var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx as jsx$1, Fragment, jsxs } from "react/jsx-runtime";
import * as React from "react";
import React__default, { createContext, Component, useState as useState$1, useCallback, memo, forwardRef, createElement, PureComponent, useContext, useMemo as useMemo$2, useEffect, useRef, useImperativeHandle, Fragment as Fragment$1, useReducer, useLayoutEffect as useLayoutEffect$2, isValidElement, version as version$3, cloneElement } from "react";
import { notification, Avatar, Typography, Form as Form$2, Input as Input$3, InputNumber, Row, Tooltip, Button, Space, Badge, Popconfirm, Popover, Progress, Modal, Pagination, Dropdown, Menu, Spin, message as message$2, Select, Table as Table$2, Checkbox, Slider as Slider$1, Skeleton, Switch, Tabs, Tag, Drawer, unstableSetRender } from "antd";
import moment from "moment";
import ReactDOM, { unstable_batchedUpdates, version as version$2, createPortal } from "react-dom";
import { CheckOutlined, CheckCircleOutlined, CloseCircleOutlined, EditOutlined, CloseOutlined, PaperClipOutlined, SendOutlined, ReloadOutlined, UploadOutlined, CloudDownloadOutlined, DeleteFilled, InfoCircleOutlined, LoadingOutlined as LoadingOutlined$3, FontColorsOutlined, SearchOutlined as SearchOutlined$3, FolderOutlined, FileOutlined, FileWordOutlined, FilePdfOutlined, FileExcelOutlined, FilePptOutlined, FileZipOutlined, HomeOutlined, RollbackOutlined, SmileOutlined, BorderOutlined, AudioOutlined, UnlockOutlined, ArrowUpOutlined, ArrowLeftOutlined, PlayCircleFilled, PauseCircleFilled, DownloadOutlined, SyncOutlined, StopOutlined, LinkOutlined, WarningOutlined, PhoneOutlined, MoreOutlined, UserOutlined, UserAddOutlined, SettingOutlined, DownOutlined, EllipsisOutlined, UserDeleteOutlined, RobotOutlined, LeftOutlined } from "@ant-design/icons";
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT$1 = {};
Object.freeze(EMPTY_OBJECT$1);
function getNextId() {
  return ++globalState$1.mobxGuid;
}
function fail(message2) {
  invariant$2(false, message2);
  throw "X";
}
function invariant$2(check, message2) {
  if (!check)
    throw new Error("[mobx] " + (message2 || OBFUSCATED_ERROR));
}
var deprecatedMessages = [];
function deprecated(msg, thing) {
  if (process.env.NODE_ENV === "production")
    return false;
  if (deprecatedMessages.indexOf(msg) !== -1)
    return false;
  deprecatedMessages.push(msg);
  console.error("[mobx] Deprecated: " + msg);
  return true;
}
function once$1(func) {
  var invoked = false;
  return function() {
    if (invoked)
      return;
    invoked = true;
    return func.apply(this, arguments);
  };
}
var noop$5 = function() {
};
function unique(list) {
  var res = [];
  list.forEach(function(item2) {
    if (res.indexOf(item2) === -1)
      res.push(item2);
  });
  return res;
}
function isObject$2(value) {
  return value !== null && typeof value === "object";
}
function isPlainObject$1(value) {
  if (value === null || typeof value !== "object")
    return false;
  var proto2 = Object.getPrototypeOf(value);
  return proto2 === Object.prototype || proto2 === null;
}
function convertToMap(dataStructure) {
  if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
    return dataStructure;
  } else if (Array.isArray(dataStructure)) {
    return new Map(dataStructure);
  } else if (isPlainObject$1(dataStructure)) {
    var map = /* @__PURE__ */ new Map();
    for (var key in dataStructure) {
      map.set(key, dataStructure[key]);
    }
    return map;
  } else {
    return fail("Cannot convert to map from '" + dataStructure + "'");
  }
}
function addHiddenProp(object4, propName, value) {
  Object.defineProperty(object4, propName, {
    enumerable: false,
    writable: true,
    configurable: true,
    value
  });
}
function addHiddenFinalProp(object4, propName, value) {
  Object.defineProperty(object4, propName, {
    enumerable: false,
    writable: false,
    configurable: true,
    value
  });
}
function isPropertyConfigurable(object4, prop) {
  var descriptor = Object.getOwnPropertyDescriptor(object4, prop);
  return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
}
function assertPropertyConfigurable(object4, prop) {
  if (process.env.NODE_ENV !== "production" && !isPropertyConfigurable(object4, prop))
    fail("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
  var propName = "isMobX" + name;
  clazz.prototype[propName] = true;
  return function(x) {
    return isObject$2(x) && x[propName] === true;
  };
}
function isES6Map(thing) {
  return thing instanceof Map;
}
function isES6Set(thing) {
  return thing instanceof Set;
}
function getPlainObjectKeys(object4) {
  var enumerables = /* @__PURE__ */ new Set();
  for (var key in object4)
    enumerables.add(key);
  Object.getOwnPropertySymbols(object4).forEach(function(k) {
    if (Object.getOwnPropertyDescriptor(object4, k).enumerable)
      enumerables.add(k);
  });
  return Array.from(enumerables);
}
function stringifyKey(key) {
  if (key && key.toString)
    return key.toString();
  else
    return new String(key).toString();
}
function toPrimitive$2(value) {
  return value === null ? null : typeof value === "object" ? "" + value : value;
}
var ownKeys$s = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols ? function(obj) {
  return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
var $mobx = Symbol("mobx administration");
var Atom = (
  /** @class */
  (function() {
    function Atom2(name) {
      if (name === void 0) {
        name = "Atom@" + getNextId();
      }
      this.name = name;
      this.isPendingUnobservation = false;
      this.isBeingObserved = false;
      this.observers = /* @__PURE__ */ new Set();
      this.diffValue = 0;
      this.lastAccessedBy = 0;
      this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom2.prototype.onBecomeObserved = function() {
      if (this.onBecomeObservedListeners) {
        this.onBecomeObservedListeners.forEach(function(listener) {
          return listener();
        });
      }
    };
    Atom2.prototype.onBecomeUnobserved = function() {
      if (this.onBecomeUnobservedListeners) {
        this.onBecomeUnobservedListeners.forEach(function(listener) {
          return listener();
        });
      }
    };
    Atom2.prototype.reportObserved = function() {
      return reportObserved(this);
    };
    Atom2.prototype.reportChanged = function() {
      startBatch();
      propagateChanged(this);
      endBatch();
    };
    Atom2.prototype.toString = function() {
      return this.name;
    };
    return Atom2;
  })()
);
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
  if (onBecomeObservedHandler === void 0) {
    onBecomeObservedHandler = noop$5;
  }
  if (onBecomeUnobservedHandler === void 0) {
    onBecomeUnobservedHandler = noop$5;
  }
  var atom = new Atom(name);
  if (onBecomeObservedHandler !== noop$5) {
    onBecomeObserved(atom, onBecomeObservedHandler);
  }
  if (onBecomeUnobservedHandler !== noop$5) {
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
  }
  return atom;
}
function structuralComparer(a, b) {
  return deepEqual(a, b);
}
function defaultComparer$2(a, b) {
  return Object.is(a, b);
}
var comparer = {
  structural: structuralComparer,
  default: defaultComparer$2
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics$1 = function(d, b) {
  extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
  };
  return extendStatics$1(d, b);
};
function __extends$1(d, b) {
  extendStatics$1(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$2 = function() {
  __assign$2 = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
  if (m) return m.call(o);
  return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
}
function __read$3(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r2, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spread$1() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read$3(arguments[i]));
  return ar;
}
var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable4) {
  var cache2 = enumerable4 ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
  return cache2[prop] || (cache2[prop] = {
    configurable: true,
    enumerable: enumerable4,
    get: function() {
      initializeInstance(this);
      return this[prop];
    },
    set: function(value) {
      initializeInstance(this);
      this[prop] = value;
    }
  });
}
function initializeInstance(target) {
  var e_1, _a2;
  if (target[mobxDidRunLazyInitializersSymbol] === true)
    return;
  var decorators = target[mobxPendingDecorators];
  if (decorators) {
    addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
    var keys2 = __spread$1(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
    try {
      for (var keys_1 = __values(keys2), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
        var key = keys_1_1.value;
        var d = decorators[key];
        d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (keys_1_1 && !keys_1_1.done && (_a2 = keys_1.return)) _a2.call(keys_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
  return function decoratorFactory() {
    var decoratorArguments;
    var decorator = function decorate(target, prop, descriptor, applyImmediately) {
      if (applyImmediately === true) {
        propertyCreator(target, prop, descriptor, target, decoratorArguments);
        return null;
      }
      if (process.env.NODE_ENV !== "production" && !quacksLikeADecorator(arguments))
        fail("This function is a decorator, but it wasn't invoked like a decorator");
      if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
        var inheritedDecorators = target[mobxPendingDecorators];
        addHiddenProp(target, mobxPendingDecorators, __assign$2({}, inheritedDecorators));
      }
      target[mobxPendingDecorators][prop] = {
        prop,
        propertyCreator,
        descriptor,
        decoratorTarget: target,
        decoratorArguments
      };
      return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
    };
    if (quacksLikeADecorator(arguments)) {
      decoratorArguments = EMPTY_ARRAY;
      return decorator.apply(null, arguments);
    } else {
      decoratorArguments = Array.prototype.slice.call(arguments);
      return decorator;
    }
  };
}
function quacksLikeADecorator(args) {
  return (args.length === 2 || args.length === 3) && (typeof args[1] === "string" || typeof args[1] === "symbol") || args.length === 4 && args[3] === true;
}
function deepEnhancer(v, _2, name) {
  if (isObservable(v))
    return v;
  if (Array.isArray(v))
    return observable.array(v, { name });
  if (isPlainObject$1(v))
    return observable.object(v, void 0, { name });
  if (isES6Map(v))
    return observable.map(v, { name });
  if (isES6Set(v))
    return observable.set(v, { name });
  return v;
}
function shallowEnhancer(v, _2, name) {
  if (v === void 0 || v === null)
    return v;
  if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
    return v;
  if (Array.isArray(v))
    return observable.array(v, { name, deep: false });
  if (isPlainObject$1(v))
    return observable.object(v, void 0, { name, deep: false });
  if (isES6Map(v))
    return observable.map(v, { name, deep: false });
  if (isES6Set(v))
    return observable.set(v, { name, deep: false });
  return fail(process.env.NODE_ENV !== "production" && "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
  return newValue;
}
function refStructEnhancer(v, oldValue, name) {
  if (process.env.NODE_ENV !== "production" && isObservable(v))
    throw "observable.struct should not be used with observable values";
  if (deepEqual(v, oldValue))
    return oldValue;
  return v;
}
function createDecoratorForEnhancer(enhancer) {
  invariant$2(enhancer);
  var decorator = createPropDecorator(true, function(target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
    if (process.env.NODE_ENV !== "production") {
      invariant$2(!descriptor || !descriptor.get, '@observable cannot be used on getter (property "' + stringifyKey(propertyName) + '"), use @computed instead.');
    }
    var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : void 0;
    asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
  });
  var res = (
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" ? function observableDecorator() {
      if (arguments.length < 2)
        return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
      return decorator.apply(null, arguments);
    } : decorator
  );
  res.enhancer = enhancer;
  return res;
}
var defaultCreateObservableOptions = {
  deep: true,
  name: void 0,
  defaultDecorator: void 0,
  proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
  if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key))
    fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
  if (thing === null || thing === void 0)
    return defaultCreateObservableOptions;
  if (typeof thing === "string")
    return { name: thing, deep: true, proxy: true };
  if (process.env.NODE_ENV !== "production") {
    if (typeof thing !== "object")
      return fail("expected options object");
    Object.keys(thing).forEach(assertValidOption);
  }
  return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
  return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
}
function createObservable(v, arg2, arg3) {
  if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
    return deepDecorator.apply(null, arguments);
  }
  if (isObservable(v))
    return v;
  var res = isPlainObject$1(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v;
  if (res !== v)
    return res;
  fail(process.env.NODE_ENV !== "production" && "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
  box: function(value, options) {
    if (arguments.length > 2)
      incorrectlyUsedAsDecorator("box");
    var o = asCreateObservableOptions(options);
    return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
  },
  array: function(initialValues, options) {
    if (arguments.length > 2)
      incorrectlyUsedAsDecorator("array");
    var o = asCreateObservableOptions(options);
    return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
  },
  map: function(initialValues, options) {
    if (arguments.length > 2)
      incorrectlyUsedAsDecorator("map");
    var o = asCreateObservableOptions(options);
    return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
  },
  set: function(initialValues, options) {
    if (arguments.length > 2)
      incorrectlyUsedAsDecorator("set");
    var o = asCreateObservableOptions(options);
    return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
  },
  object: function(props, decorators, options) {
    if (typeof arguments[1] === "string")
      incorrectlyUsedAsDecorator("object");
    var o = asCreateObservableOptions(options);
    if (o.proxy === false) {
      return extendObservable({}, props, decorators, o);
    } else {
      var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
      var base = extendObservable({}, void 0, void 0, o);
      var proxy = createDynamicObservableObject(base);
      extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
      return proxy;
    }
  },
  ref: refDecorator,
  shallow: shallowDecorator,
  deep: deepDecorator,
  struct: refStructDecorator
};
var observable = createObservable;
Object.keys(observableFactories).forEach(function(name) {
  return observable[name] = observableFactories[name];
});
function incorrectlyUsedAsDecorator(methodName) {
  fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?"
  );
}
var computedDecorator = createPropDecorator(false, function(instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
  if (process.env.NODE_ENV !== "production") {
    invariant$2(descriptor && descriptor.get, "Trying to declare a computed value for unspecified getter '" + stringifyKey(propertyName) + "'");
  }
  var get4 = descriptor.get, set2 = descriptor.set;
  var options = decoratorArgs[0] || {};
  asObservableObject(instance).addComputedProp(instance, propertyName, __assign$2({
    get: get4,
    set: set2,
    context: instance
  }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
var computed = function computed2(arg1, arg2, arg3) {
  if (typeof arg2 === "string") {
    return computedDecorator.apply(null, arguments);
  }
  if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
    return computedDecorator.apply(null, arguments);
  }
  if (process.env.NODE_ENV !== "production") {
    invariant$2(typeof arg1 === "function", "First argument to `computed` should be an expression.");
    invariant$2(arguments.length < 3, "Computed takes one or two arguments if used as function");
  }
  var opts = typeof arg2 === "object" ? arg2 : {};
  opts.get = arg1;
  opts.set = typeof arg2 === "function" ? arg2 : opts.set;
  opts.name = opts.name || arg1.name || "";
  return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;
var IDerivationState;
(function(IDerivationState2) {
  IDerivationState2[IDerivationState2["NOT_TRACKING"] = -1] = "NOT_TRACKING";
  IDerivationState2[IDerivationState2["UP_TO_DATE"] = 0] = "UP_TO_DATE";
  IDerivationState2[IDerivationState2["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
  IDerivationState2[IDerivationState2["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function(TraceMode2) {
  TraceMode2[TraceMode2["NONE"] = 0] = "NONE";
  TraceMode2[TraceMode2["LOG"] = 1] = "LOG";
  TraceMode2[TraceMode2["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = (
  /** @class */
  /* @__PURE__ */ (function() {
    function CaughtException2(cause) {
      this.cause = cause;
    }
    return CaughtException2;
  })()
);
function isCaughtException(e) {
  return e instanceof CaughtException;
}
function shouldCompute(derivation) {
  switch (derivation.dependenciesState) {
    case IDerivationState.UP_TO_DATE:
      return false;
    case IDerivationState.NOT_TRACKING:
    case IDerivationState.STALE:
      return true;
    case IDerivationState.POSSIBLY_STALE: {
      var prevAllowStateReads = allowStateReadsStart(true);
      var prevUntracked = untrackedStart();
      var obs = derivation.observing, l = obs.length;
      for (var i = 0; i < l; i++) {
        var obj = obs[i];
        if (isComputedValue(obj)) {
          if (globalState$1.disableErrorBoundaries) {
            obj.get();
          } else {
            try {
              obj.get();
            } catch (e) {
              untrackedEnd(prevUntracked);
              allowStateReadsEnd(prevAllowStateReads);
              return true;
            }
          }
          if (derivation.dependenciesState === IDerivationState.STALE) {
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return true;
          }
        }
      }
      changeDependenciesStateTo0(derivation);
      untrackedEnd(prevUntracked);
      allowStateReadsEnd(prevAllowStateReads);
      return false;
    }
  }
}
function checkIfStateModificationsAreAllowed(atom) {
  var hasObservers = atom.observers.size > 0;
  if (globalState$1.computationDepth > 0 && hasObservers)
    fail(process.env.NODE_ENV !== "production" && "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
  if (!globalState$1.allowStateChanges && (hasObservers || globalState$1.enforceActions === "strict"))
    fail(process.env.NODE_ENV !== "production" && (globalState$1.enforceActions ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") + atom.name);
}
function checkIfStateReadsAreAllowed(observable2) {
  if (process.env.NODE_ENV !== "production" && !globalState$1.allowStateReads && globalState$1.observableRequiresReaction) {
    console.warn("[mobx] Observable " + observable2.name + " being read outside a reactive context");
  }
}
function trackDerivedFunction(derivation, f, context2) {
  var prevAllowStateReads = allowStateReadsStart(true);
  changeDependenciesStateTo0(derivation);
  derivation.newObserving = new Array(derivation.observing.length + 100);
  derivation.unboundDepsCount = 0;
  derivation.runId = ++globalState$1.runId;
  var prevTracking = globalState$1.trackingDerivation;
  globalState$1.trackingDerivation = derivation;
  var result;
  if (globalState$1.disableErrorBoundaries === true) {
    result = f.call(context2);
  } else {
    try {
      result = f.call(context2);
    } catch (e) {
      result = new CaughtException(e);
    }
  }
  globalState$1.trackingDerivation = prevTracking;
  bindDependencies(derivation);
  warnAboutDerivationWithoutDependencies(derivation);
  allowStateReadsEnd(prevAllowStateReads);
  return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
  if (process.env.NODE_ENV === "production")
    return;
  if (derivation.observing.length !== 0)
    return;
  if (globalState$1.reactionRequiresObservable || derivation.requiresObservable) {
    console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
  }
}
function bindDependencies(derivation) {
  var prevObserving = derivation.observing;
  var observing = derivation.observing = derivation.newObserving;
  var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
  var i0 = 0, l = derivation.unboundDepsCount;
  for (var i = 0; i < l; i++) {
    var dep = observing[i];
    if (dep.diffValue === 0) {
      dep.diffValue = 1;
      if (i0 !== i)
        observing[i0] = dep;
      i0++;
    }
    if (dep.dependenciesState > lowestNewObservingDerivationState) {
      lowestNewObservingDerivationState = dep.dependenciesState;
    }
  }
  observing.length = i0;
  derivation.newObserving = null;
  l = prevObserving.length;
  while (l--) {
    var dep = prevObserving[l];
    if (dep.diffValue === 0) {
      removeObserver(dep, derivation);
    }
    dep.diffValue = 0;
  }
  while (i0--) {
    var dep = observing[i0];
    if (dep.diffValue === 1) {
      dep.diffValue = 0;
      addObserver(dep, derivation);
    }
  }
  if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
    derivation.dependenciesState = lowestNewObservingDerivationState;
    derivation.onBecomeStale();
  }
}
function clearObserving(derivation) {
  var obs = derivation.observing;
  derivation.observing = [];
  var i = obs.length;
  while (i--)
    removeObserver(obs[i], derivation);
  derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action3) {
  var prev4 = untrackedStart();
  try {
    return action3();
  } finally {
    untrackedEnd(prev4);
  }
}
function untrackedStart() {
  var prev4 = globalState$1.trackingDerivation;
  globalState$1.trackingDerivation = null;
  return prev4;
}
function untrackedEnd(prev4) {
  globalState$1.trackingDerivation = prev4;
}
function allowStateReadsStart(allowStateReads) {
  var prev4 = globalState$1.allowStateReads;
  globalState$1.allowStateReads = allowStateReads;
  return prev4;
}
function allowStateReadsEnd(prev4) {
  globalState$1.allowStateReads = prev4;
}
function changeDependenciesStateTo0(derivation) {
  if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
    return;
  derivation.dependenciesState = IDerivationState.UP_TO_DATE;
  var obs = derivation.observing;
  var i = obs.length;
  while (i--)
    obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function() {
}, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn, ref2) {
  if (process.env.NODE_ENV !== "production") {
    invariant$2(typeof fn === "function", "`action` can only be invoked on functions");
    if (typeof actionName !== "string" || !actionName)
      fail("actions should have valid names, got: '" + actionName + "'");
  }
  var res = function() {
    return executeAction(actionName, fn, ref2 || this, arguments);
  };
  res.isMobxAction = true;
  if (process.env.NODE_ENV !== "production") {
    if (isFunctionNameConfigurable) {
      Object.defineProperty(res, "name", { value: actionName });
    }
  }
  return res;
}
function executeAction(actionName, fn, scope, args) {
  var runInfo = _startAction(actionName, scope, args);
  try {
    return fn.apply(scope, args);
  } catch (err) {
    runInfo.error = err;
    throw err;
  } finally {
    _endAction(runInfo);
  }
}
function _startAction(actionName, scope, args) {
  var notifySpy = isSpyEnabled() && !!actionName;
  var startTime = 0;
  if (notifySpy && process.env.NODE_ENV !== "production") {
    startTime = Date.now();
    var l = args && args.length || 0;
    var flattendArgs = new Array(l);
    if (l > 0)
      for (var i = 0; i < l; i++)
        flattendArgs[i] = args[i];
    spyReportStart({
      type: "action",
      name: actionName,
      object: scope,
      arguments: flattendArgs
    });
  }
  var prevDerivation = untrackedStart();
  startBatch();
  var prevAllowStateChanges = allowStateChangesStart(true);
  var prevAllowStateReads = allowStateReadsStart(true);
  var runInfo = {
    prevDerivation,
    prevAllowStateChanges,
    prevAllowStateReads,
    notifySpy,
    startTime,
    actionId: nextActionId++,
    parentActionId: currentActionId
  };
  currentActionId = runInfo.actionId;
  return runInfo;
}
function _endAction(runInfo) {
  if (currentActionId !== runInfo.actionId) {
    fail("invalid action stack. did you forget to finish an action?");
  }
  currentActionId = runInfo.parentActionId;
  if (runInfo.error !== void 0) {
    globalState$1.suppressReactionErrors = true;
  }
  allowStateChangesEnd(runInfo.prevAllowStateChanges);
  allowStateReadsEnd(runInfo.prevAllowStateReads);
  endBatch();
  untrackedEnd(runInfo.prevDerivation);
  if (runInfo.notifySpy && process.env.NODE_ENV !== "production") {
    spyReportEnd({ time: Date.now() - runInfo.startTime });
  }
  globalState$1.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges2, func) {
  var prev4 = allowStateChangesStart(allowStateChanges2);
  var res;
  try {
    res = func();
  } finally {
    allowStateChangesEnd(prev4);
  }
  return res;
}
function allowStateChangesStart(allowStateChanges2) {
  var prev4 = globalState$1.allowStateChanges;
  globalState$1.allowStateChanges = allowStateChanges2;
  return prev4;
}
function allowStateChangesEnd(prev4) {
  globalState$1.allowStateChanges = prev4;
}
var ObservableValue = (
  /** @class */
  (function(_super) {
    __extends$1(ObservableValue2, _super);
    function ObservableValue2(value, enhancer, name, notifySpy, equals) {
      if (name === void 0) {
        name = "ObservableValue@" + getNextId();
      }
      if (notifySpy === void 0) {
        notifySpy = true;
      }
      if (equals === void 0) {
        equals = comparer.default;
      }
      var _this = _super.call(this, name) || this;
      _this.enhancer = enhancer;
      _this.name = name;
      _this.equals = equals;
      _this.hasUnreportedChange = false;
      _this.value = enhancer(value, void 0, name);
      if (notifySpy && isSpyEnabled() && process.env.NODE_ENV !== "production") {
        spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
      }
      return _this;
    }
    ObservableValue2.prototype.dehanceValue = function(value) {
      if (this.dehancer !== void 0)
        return this.dehancer(value);
      return value;
    };
    ObservableValue2.prototype.set = function(newValue) {
      var oldValue = this.value;
      newValue = this.prepareNewValue(newValue);
      if (newValue !== globalState$1.UNCHANGED) {
        var notifySpy = isSpyEnabled();
        if (notifySpy && process.env.NODE_ENV !== "production") {
          spyReportStart({
            type: "update",
            name: this.name,
            newValue,
            oldValue
          });
        }
        this.setNewValue(newValue);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
      }
    };
    ObservableValue2.prototype.prepareNewValue = function(newValue) {
      checkIfStateModificationsAreAllowed(this);
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this,
          type: "update",
          newValue
        });
        if (!change)
          return globalState$1.UNCHANGED;
        newValue = change.newValue;
      }
      newValue = this.enhancer(newValue, this.value, this.name);
      return this.equals(this.value, newValue) ? globalState$1.UNCHANGED : newValue;
    };
    ObservableValue2.prototype.setNewValue = function(newValue) {
      var oldValue = this.value;
      this.value = newValue;
      this.reportChanged();
      if (hasListeners(this)) {
        notifyListeners(this, {
          type: "update",
          object: this,
          newValue,
          oldValue
        });
      }
    };
    ObservableValue2.prototype.get = function() {
      this.reportObserved();
      return this.dehanceValue(this.value);
    };
    ObservableValue2.prototype.intercept = function(handler) {
      return registerInterceptor(this, handler);
    };
    ObservableValue2.prototype.observe = function(listener, fireImmediately) {
      if (fireImmediately)
        listener({
          object: this,
          type: "update",
          newValue: this.value,
          oldValue: void 0
        });
      return registerListener(this, listener);
    };
    ObservableValue2.prototype.toJSON = function() {
      return this.get();
    };
    ObservableValue2.prototype.toString = function() {
      return this.name + "[" + this.value + "]";
    };
    ObservableValue2.prototype.valueOf = function() {
      return toPrimitive$2(this.get());
    };
    ObservableValue2.prototype[Symbol.toPrimitive] = function() {
      return this.valueOf();
    };
    return ObservableValue2;
  })(Atom)
);
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
var ComputedValue = (
  /** @class */
  (function() {
    function ComputedValue2(options) {
      this.dependenciesState = IDerivationState.NOT_TRACKING;
      this.observing = [];
      this.newObserving = null;
      this.isBeingObserved = false;
      this.isPendingUnobservation = false;
      this.observers = /* @__PURE__ */ new Set();
      this.diffValue = 0;
      this.runId = 0;
      this.lastAccessedBy = 0;
      this.lowestObserverState = IDerivationState.UP_TO_DATE;
      this.unboundDepsCount = 0;
      this.__mapid = "#" + getNextId();
      this.value = new CaughtException(null);
      this.isComputing = false;
      this.isRunningSetter = false;
      this.isTracing = TraceMode.NONE;
      invariant$2(options.get, "missing option for computed: get");
      this.derivation = options.get;
      this.name = options.name || "ComputedValue@" + getNextId();
      if (options.set)
        this.setter = createAction(this.name + "-setter", options.set);
      this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
      this.scope = options.context;
      this.requiresReaction = !!options.requiresReaction;
      this.keepAlive = !!options.keepAlive;
    }
    ComputedValue2.prototype.onBecomeStale = function() {
      propagateMaybeChanged(this);
    };
    ComputedValue2.prototype.onBecomeObserved = function() {
      if (this.onBecomeObservedListeners) {
        this.onBecomeObservedListeners.forEach(function(listener) {
          return listener();
        });
      }
    };
    ComputedValue2.prototype.onBecomeUnobserved = function() {
      if (this.onBecomeUnobservedListeners) {
        this.onBecomeUnobservedListeners.forEach(function(listener) {
          return listener();
        });
      }
    };
    ComputedValue2.prototype.get = function() {
      if (this.isComputing)
        fail("Cycle detected in computation " + this.name + ": " + this.derivation);
      if (globalState$1.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
        if (shouldCompute(this)) {
          this.warnAboutUntrackedRead();
          startBatch();
          this.value = this.computeValue(false);
          endBatch();
        }
      } else {
        reportObserved(this);
        if (shouldCompute(this)) {
          if (this.trackAndCompute())
            propagateChangeConfirmed(this);
        }
      }
      var result = this.value;
      if (isCaughtException(result))
        throw result.cause;
      return result;
    };
    ComputedValue2.prototype.peek = function() {
      var res = this.computeValue(false);
      if (isCaughtException(res))
        throw res.cause;
      return res;
    };
    ComputedValue2.prototype.set = function(value) {
      if (this.setter) {
        invariant$2(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
        this.isRunningSetter = true;
        try {
          this.setter.call(this.scope, value);
        } finally {
          this.isRunningSetter = false;
        }
      } else
        invariant$2(false, process.env.NODE_ENV !== "production" && "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue2.prototype.trackAndCompute = function() {
      if (isSpyEnabled() && process.env.NODE_ENV !== "production") {
        spyReport({
          object: this.scope,
          type: "compute",
          name: this.name
        });
      }
      var oldValue = this.value;
      var wasSuspended = (
        /* see #1208 */
        this.dependenciesState === IDerivationState.NOT_TRACKING
      );
      var newValue = this.computeValue(true);
      var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
      if (changed) {
        this.value = newValue;
      }
      return changed;
    };
    ComputedValue2.prototype.computeValue = function(track) {
      this.isComputing = true;
      globalState$1.computationDepth++;
      var res;
      if (track) {
        res = trackDerivedFunction(this, this.derivation, this.scope);
      } else {
        if (globalState$1.disableErrorBoundaries === true) {
          res = this.derivation.call(this.scope);
        } else {
          try {
            res = this.derivation.call(this.scope);
          } catch (e) {
            res = new CaughtException(e);
          }
        }
      }
      globalState$1.computationDepth--;
      this.isComputing = false;
      return res;
    };
    ComputedValue2.prototype.suspend = function() {
      if (!this.keepAlive) {
        clearObserving(this);
        this.value = void 0;
      }
    };
    ComputedValue2.prototype.observe = function(listener, fireImmediately) {
      var _this = this;
      var firstTime = true;
      var prevValue = void 0;
      return autorun(function() {
        var newValue = _this.get();
        if (!firstTime || fireImmediately) {
          var prevU = untrackedStart();
          listener({
            type: "update",
            object: _this,
            newValue,
            oldValue: prevValue
          });
          untrackedEnd(prevU);
        }
        firstTime = false;
        prevValue = newValue;
      });
    };
    ComputedValue2.prototype.warnAboutUntrackedRead = function() {
      if (process.env.NODE_ENV === "production")
        return;
      if (this.requiresReaction === true) {
        fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
      }
      if (this.isTracing !== TraceMode.NONE) {
        console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
      }
      if (globalState$1.computedRequiresReaction) {
        console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
      }
    };
    ComputedValue2.prototype.toJSON = function() {
      return this.get();
    };
    ComputedValue2.prototype.toString = function() {
      return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue2.prototype.valueOf = function() {
      return toPrimitive$2(this.get());
    };
    ComputedValue2.prototype[Symbol.toPrimitive] = function() {
      return this.valueOf();
    };
    return ComputedValue2;
  })()
);
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
var MobXGlobals = (
  /** @class */
  /* @__PURE__ */ (function() {
    function MobXGlobals2() {
      this.version = 5;
      this.UNCHANGED = {};
      this.trackingDerivation = null;
      this.computationDepth = 0;
      this.runId = 0;
      this.mobxGuid = 0;
      this.inBatch = 0;
      this.pendingUnobservations = [];
      this.pendingReactions = [];
      this.isRunningReactions = false;
      this.allowStateChanges = true;
      this.allowStateReads = true;
      this.enforceActions = false;
      this.spyListeners = [];
      this.globalReactionErrorHandlers = [];
      this.computedRequiresReaction = false;
      this.reactionRequiresObservable = false;
      this.observableRequiresReaction = false;
      this.computedConfigurable = false;
      this.disableErrorBoundaries = false;
      this.suppressReactionErrors = false;
    }
    return MobXGlobals2;
  })()
);
var mockGlobal$1 = {};
function getGlobal$1() {
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  return mockGlobal$1;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState$1 = (function() {
  var global2 = getGlobal$1();
  if (global2.__mobxInstanceCount > 0 && !global2.__mobxGlobals)
    canMergeGlobalState = false;
  if (global2.__mobxGlobals && global2.__mobxGlobals.version !== new MobXGlobals().version)
    canMergeGlobalState = false;
  if (!canMergeGlobalState) {
    setTimeout(function() {
      if (!isolateCalled) {
        fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
      }
    }, 1);
    return new MobXGlobals();
  } else if (global2.__mobxGlobals) {
    global2.__mobxInstanceCount += 1;
    if (!global2.__mobxGlobals.UNCHANGED)
      global2.__mobxGlobals.UNCHANGED = {};
    return global2.__mobxGlobals;
  } else {
    global2.__mobxInstanceCount = 1;
    return global2.__mobxGlobals = new MobXGlobals();
  }
})();
function isolateGlobalState() {
  if (globalState$1.pendingReactions.length || globalState$1.inBatch || globalState$1.isRunningReactions)
    fail("isolateGlobalState should be called before MobX is running any reactions");
  isolateCalled = true;
  if (canMergeGlobalState) {
    if (--getGlobal$1().__mobxInstanceCount === 0)
      getGlobal$1().__mobxGlobals = void 0;
    globalState$1 = new MobXGlobals();
  }
}
function addObserver(observable2, node2) {
  observable2.observers.add(node2);
  if (observable2.lowestObserverState > node2.dependenciesState)
    observable2.lowestObserverState = node2.dependenciesState;
}
function removeObserver(observable2, node2) {
  observable2.observers.delete(node2);
  if (observable2.observers.size === 0) {
    queueForUnobservation(observable2);
  }
}
function queueForUnobservation(observable2) {
  if (observable2.isPendingUnobservation === false) {
    observable2.isPendingUnobservation = true;
    globalState$1.pendingUnobservations.push(observable2);
  }
}
function startBatch() {
  globalState$1.inBatch++;
}
function endBatch() {
  if (--globalState$1.inBatch === 0) {
    runReactions();
    var list = globalState$1.pendingUnobservations;
    for (var i = 0; i < list.length; i++) {
      var observable2 = list[i];
      observable2.isPendingUnobservation = false;
      if (observable2.observers.size === 0) {
        if (observable2.isBeingObserved) {
          observable2.isBeingObserved = false;
          observable2.onBecomeUnobserved();
        }
        if (observable2 instanceof ComputedValue) {
          observable2.suspend();
        }
      }
    }
    globalState$1.pendingUnobservations = [];
  }
}
function reportObserved(observable2) {
  checkIfStateReadsAreAllowed(observable2);
  var derivation = globalState$1.trackingDerivation;
  if (derivation !== null) {
    if (derivation.runId !== observable2.lastAccessedBy) {
      observable2.lastAccessedBy = derivation.runId;
      derivation.newObserving[derivation.unboundDepsCount++] = observable2;
      if (!observable2.isBeingObserved) {
        observable2.isBeingObserved = true;
        observable2.onBecomeObserved();
      }
    }
    return true;
  } else if (observable2.observers.size === 0 && globalState$1.inBatch > 0) {
    queueForUnobservation(observable2);
  }
  return false;
}
function propagateChanged(observable2) {
  if (observable2.lowestObserverState === IDerivationState.STALE)
    return;
  observable2.lowestObserverState = IDerivationState.STALE;
  observable2.observers.forEach(function(d) {
    if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
      if (d.isTracing !== TraceMode.NONE) {
        logTraceInfo(d, observable2);
      }
      d.onBecomeStale();
    }
    d.dependenciesState = IDerivationState.STALE;
  });
}
function propagateChangeConfirmed(observable2) {
  if (observable2.lowestObserverState === IDerivationState.STALE)
    return;
  observable2.lowestObserverState = IDerivationState.STALE;
  observable2.observers.forEach(function(d) {
    if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
      d.dependenciesState = IDerivationState.STALE;
    else if (d.dependenciesState === IDerivationState.UP_TO_DATE)
      observable2.lowestObserverState = IDerivationState.UP_TO_DATE;
  });
}
function propagateMaybeChanged(observable2) {
  if (observable2.lowestObserverState !== IDerivationState.UP_TO_DATE)
    return;
  observable2.lowestObserverState = IDerivationState.POSSIBLY_STALE;
  observable2.observers.forEach(function(d) {
    if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
      d.dependenciesState = IDerivationState.POSSIBLY_STALE;
      if (d.isTracing !== TraceMode.NONE) {
        logTraceInfo(d, observable2);
      }
      d.onBecomeStale();
    }
  });
}
function logTraceInfo(derivation, observable2) {
  console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable2.name + "'");
  if (derivation.isTracing === TraceMode.BREAK) {
    var lines = [];
    printDepTree(getDependencyTree(derivation), lines, 1);
    new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable2.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
  }
}
function printDepTree(tree, lines, depth) {
  if (lines.length >= 1e3) {
    lines.push("(and many more)");
    return;
  }
  lines.push("" + new Array(depth).join("	") + tree.name);
  if (tree.dependencies)
    tree.dependencies.forEach(function(child) {
      return printDepTree(child, lines, depth + 1);
    });
}
var Reaction$1 = (
  /** @class */
  (function() {
    function Reaction2(name, onInvalidate, errorHandler, requiresObservable) {
      if (name === void 0) {
        name = "Reaction@" + getNextId();
      }
      if (requiresObservable === void 0) {
        requiresObservable = false;
      }
      this.name = name;
      this.onInvalidate = onInvalidate;
      this.errorHandler = errorHandler;
      this.requiresObservable = requiresObservable;
      this.observing = [];
      this.newObserving = [];
      this.dependenciesState = IDerivationState.NOT_TRACKING;
      this.diffValue = 0;
      this.runId = 0;
      this.unboundDepsCount = 0;
      this.__mapid = "#" + getNextId();
      this.isDisposed = false;
      this._isScheduled = false;
      this._isTrackPending = false;
      this._isRunning = false;
      this.isTracing = TraceMode.NONE;
    }
    Reaction2.prototype.onBecomeStale = function() {
      this.schedule();
    };
    Reaction2.prototype.schedule = function() {
      if (!this._isScheduled) {
        this._isScheduled = true;
        globalState$1.pendingReactions.push(this);
        runReactions();
      }
    };
    Reaction2.prototype.isScheduled = function() {
      return this._isScheduled;
    };
    Reaction2.prototype.runReaction = function() {
      if (!this.isDisposed) {
        startBatch();
        this._isScheduled = false;
        if (shouldCompute(this)) {
          this._isTrackPending = true;
          try {
            this.onInvalidate();
            if (this._isTrackPending && isSpyEnabled() && process.env.NODE_ENV !== "production") {
              spyReport({
                name: this.name,
                type: "scheduled-reaction"
              });
            }
          } catch (e) {
            this.reportExceptionInDerivation(e);
          }
        }
        endBatch();
      }
    };
    Reaction2.prototype.track = function(fn) {
      if (this.isDisposed) {
        return;
      }
      startBatch();
      var notify = isSpyEnabled();
      var startTime;
      if (notify && process.env.NODE_ENV !== "production") {
        startTime = Date.now();
        spyReportStart({
          name: this.name,
          type: "reaction"
        });
      }
      this._isRunning = true;
      var result = trackDerivedFunction(this, fn, void 0);
      this._isRunning = false;
      this._isTrackPending = false;
      if (this.isDisposed) {
        clearObserving(this);
      }
      if (isCaughtException(result))
        this.reportExceptionInDerivation(result.cause);
      if (notify && process.env.NODE_ENV !== "production") {
        spyReportEnd({
          time: Date.now() - startTime
        });
      }
      endBatch();
    };
    Reaction2.prototype.reportExceptionInDerivation = function(error2) {
      var _this = this;
      if (this.errorHandler) {
        this.errorHandler(error2, this);
        return;
      }
      if (globalState$1.disableErrorBoundaries)
        throw error2;
      var message2 = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
      if (globalState$1.suppressReactionErrors) {
        console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)");
      } else {
        console.error(message2, error2);
      }
      if (isSpyEnabled()) {
        spyReport({
          type: "error",
          name: this.name,
          message: message2,
          error: "" + error2
        });
      }
      globalState$1.globalReactionErrorHandlers.forEach(function(f) {
        return f(error2, _this);
      });
    };
    Reaction2.prototype.dispose = function() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        if (!this._isRunning) {
          startBatch();
          clearObserving(this);
          endBatch();
        }
      }
    };
    Reaction2.prototype.getDisposer = function() {
      var r2 = this.dispose.bind(this);
      r2[$mobx] = this;
      return r2;
    };
    Reaction2.prototype.toString = function() {
      return "Reaction[" + this.name + "]";
    };
    Reaction2.prototype.trace = function(enterBreakPoint) {
      if (enterBreakPoint === void 0) {
        enterBreakPoint = false;
      }
      trace(this, enterBreakPoint);
    };
    return Reaction2;
  })()
);
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function(f) {
  return f();
};
function runReactions() {
  if (globalState$1.inBatch > 0 || globalState$1.isRunningReactions)
    return;
  reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState$1.isRunningReactions = true;
  var allReactions = globalState$1.pendingReactions;
  var iterations = 0;
  while (allReactions.length > 0) {
    if (++iterations === MAX_REACTION_ITERATIONS) {
      console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
      allReactions.splice(0);
    }
    var remainingReactions = allReactions.splice(0);
    for (var i = 0, l = remainingReactions.length; i < l; i++)
      remainingReactions[i].runReaction();
  }
  globalState$1.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction$1);
function setReactionScheduler(fn) {
  var baseScheduler = reactionScheduler;
  reactionScheduler = function(f) {
    return fn(function() {
      return baseScheduler(f);
    });
  };
}
function isSpyEnabled() {
  return process.env.NODE_ENV !== "production" && !!globalState$1.spyListeners.length;
}
function spyReport(event) {
  if (process.env.NODE_ENV === "production")
    return;
  if (!globalState$1.spyListeners.length)
    return;
  var listeners = globalState$1.spyListeners;
  for (var i = 0, l = listeners.length; i < l; i++)
    listeners[i](event);
}
function spyReportStart(event) {
  if (process.env.NODE_ENV === "production")
    return;
  var change = __assign$2(__assign$2({}, event), { spyReportStart: true });
  spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
  if (process.env.NODE_ENV === "production")
    return;
  if (change)
    spyReport(__assign$2(__assign$2({}, change), { spyReportEnd: true }));
  else
    spyReport(END_EVENT);
}
function spy(listener) {
  if (process.env.NODE_ENV === "production") {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {
    };
  } else {
    globalState$1.spyListeners.push(listener);
    return once$1(function() {
      globalState$1.spyListeners = globalState$1.spyListeners.filter(function(l) {
        return l !== listener;
      });
    });
  }
}
function dontReassignFields() {
  fail(process.env.NODE_ENV !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
  return function(target, prop, descriptor) {
    if (descriptor) {
      if (process.env.NODE_ENV !== "production" && descriptor.get !== void 0) {
        return fail("@action cannot be used with getters");
      }
      if (descriptor.value) {
        return {
          value: createAction(name, descriptor.value),
          enumerable: false,
          configurable: true,
          writable: true
          // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
        };
      }
      var initializer_1 = descriptor.initializer;
      return {
        enumerable: false,
        configurable: true,
        writable: true,
        initializer: function() {
          return createAction(name, initializer_1.call(this));
        }
      };
    }
    return actionFieldDecorator(name).apply(this, arguments);
  };
}
function actionFieldDecorator(name) {
  return function(target, prop, descriptor) {
    Object.defineProperty(target, prop, {
      configurable: true,
      enumerable: false,
      get: function() {
        return void 0;
      },
      set: function(value) {
        addHiddenProp(this, prop, action(name, value));
      }
    });
  };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
  if (applyToInstance === true) {
    defineBoundAction(target, propertyName, descriptor.value);
    return null;
  }
  if (descriptor) {
    return {
      configurable: true,
      enumerable: false,
      get: function() {
        defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
        return this[propertyName];
      },
      set: dontReassignFields
    };
  }
  return {
    enumerable: false,
    configurable: true,
    set: function(v) {
      defineBoundAction(this, propertyName, v);
    },
    get: function() {
      return void 0;
    }
  };
}
var action = function action2(arg1, arg2, arg3, arg4) {
  if (arguments.length === 1 && typeof arg1 === "function")
    return createAction(arg1.name || "<unnamed action>", arg1);
  if (arguments.length === 2 && typeof arg2 === "function")
    return createAction(arg1, arg2);
  if (arguments.length === 1 && typeof arg1 === "string")
    return namedActionDecorator(arg1);
  if (arg4 === true) {
    addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
  } else {
    return namedActionDecorator(arg2).apply(null, arguments);
  }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
  var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
  var fn = typeof arg1 === "function" ? arg1 : arg2;
  if (process.env.NODE_ENV !== "production") {
    invariant$2(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
    if (typeof actionName !== "string" || !actionName)
      fail("actions should have valid names, got: '" + actionName + "'");
  }
  return executeAction(actionName, fn, this, void 0);
}
function isAction(thing) {
  return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
  addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}
function autorun(view, opts) {
  if (opts === void 0) {
    opts = EMPTY_OBJECT$1;
  }
  if (process.env.NODE_ENV !== "production") {
    invariant$2(typeof view === "function", "Autorun expects a function as first argument");
    invariant$2(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
  }
  var name = opts && opts.name || view.name || "Autorun@" + getNextId();
  var runSync = !opts.scheduler && !opts.delay;
  var reaction2;
  if (runSync) {
    reaction2 = new Reaction$1(name, function() {
      this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
  } else {
    var scheduler_1 = createSchedulerFromOptions(opts);
    var isScheduled_1 = false;
    reaction2 = new Reaction$1(name, function() {
      if (!isScheduled_1) {
        isScheduled_1 = true;
        scheduler_1(function() {
          isScheduled_1 = false;
          if (!reaction2.isDisposed)
            reaction2.track(reactionRunner);
        });
      }
    }, opts.onError, opts.requiresObservable);
  }
  function reactionRunner() {
    view(reaction2);
  }
  reaction2.schedule();
  return reaction2.getDisposer();
}
var run = function(f) {
  return f();
};
function createSchedulerFromOptions(opts) {
  return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
    return setTimeout(f, opts.delay);
  } : run;
}
function reaction$2(expression, effect, opts) {
  if (opts === void 0) {
    opts = EMPTY_OBJECT$1;
  }
  if (process.env.NODE_ENV !== "production") {
    invariant$2(typeof expression === "function", "First argument to reaction should be a function");
    invariant$2(typeof opts === "object", "Third argument of reactions should be an object");
  }
  var name = opts.name || "Reaction@" + getNextId();
  var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
  var runSync = !opts.scheduler && !opts.delay;
  var scheduler2 = createSchedulerFromOptions(opts);
  var firstTime = true;
  var isScheduled = false;
  var value;
  var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
  var r2 = new Reaction$1(name, function() {
    if (firstTime || runSync) {
      reactionRunner();
    } else if (!isScheduled) {
      isScheduled = true;
      scheduler2(reactionRunner);
    }
  }, opts.onError, opts.requiresObservable);
  function reactionRunner() {
    isScheduled = false;
    if (r2.isDisposed)
      return;
    var changed = false;
    r2.track(function() {
      var nextValue = expression(r2);
      changed = firstTime || !equals(value, nextValue);
      value = nextValue;
    });
    if (firstTime && opts.fireImmediately)
      effectAction(value, r2);
    if (!firstTime && changed === true)
      effectAction(value, r2);
    if (firstTime)
      firstTime = false;
  }
  r2.schedule();
  return r2.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
  return function() {
    try {
      return baseFn.apply(this, arguments);
    } catch (e) {
      errorHandler.call(this, e);
    }
  };
}
function onBecomeObserved(thing, arg2, arg3) {
  return interceptHook("onBecomeObserved", thing, arg2);
}
function onBecomeUnobserved(thing, arg2, arg3) {
  return interceptHook("onBecomeUnobserved", thing, arg2);
}
function interceptHook(hook, thing, arg2, arg3) {
  var atom = getAtom(thing);
  var cb = arg2;
  var listenersKey = hook + "Listeners";
  if (atom[listenersKey]) {
    atom[listenersKey].add(cb);
  } else {
    atom[listenersKey] = /* @__PURE__ */ new Set([cb]);
  }
  var orig = atom[hook];
  if (typeof orig !== "function")
    return fail(process.env.NODE_ENV !== "production" && "Not an atom that can be (un)observed");
  return function() {
    var hookListeners = atom[listenersKey];
    if (hookListeners) {
      hookListeners.delete(cb);
      if (hookListeners.size === 0) {
        delete atom[listenersKey];
      }
    }
  };
}
function configure(options) {
  var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler2 = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
  if (options.isolateGlobalState === true) {
    isolateGlobalState();
  }
  if (enforceActions !== void 0) {
    if (typeof enforceActions === "boolean" || enforceActions === "strict")
      deprecated(`Deprecated value for 'enforceActions', use 'false' => '"never"', 'true' => '"observed"', '"strict"' => "'always'" instead`);
    var ea = void 0;
    switch (enforceActions) {
      case true:
      case "observed":
        ea = true;
        break;
      case false:
      case "never":
        ea = false;
        break;
      case "strict":
      case "always":
        ea = "strict";
        break;
      default:
        fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
    }
    globalState$1.enforceActions = ea;
    globalState$1.allowStateChanges = ea === true || ea === "strict" ? false : true;
  }
  if (computedRequiresReaction !== void 0) {
    globalState$1.computedRequiresReaction = !!computedRequiresReaction;
  }
  if (reactionRequiresObservable !== void 0) {
    globalState$1.reactionRequiresObservable = !!reactionRequiresObservable;
  }
  if (observableRequiresReaction !== void 0) {
    globalState$1.observableRequiresReaction = !!observableRequiresReaction;
    globalState$1.allowStateReads = !globalState$1.observableRequiresReaction;
  }
  if (computedConfigurable !== void 0) {
    globalState$1.computedConfigurable = !!computedConfigurable;
  }
  if (disableErrorBoundaries !== void 0) {
    if (disableErrorBoundaries === true)
      console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
    globalState$1.disableErrorBoundaries = !!disableErrorBoundaries;
  }
  if (reactionScheduler2) {
    setReactionScheduler(reactionScheduler2);
  }
}
function extendObservable(target, properties, decorators, options) {
  if (process.env.NODE_ENV !== "production") {
    invariant$2(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
    invariant$2(typeof target === "object", "'extendObservable' expects an object as first argument");
    invariant$2(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
  }
  options = asCreateObservableOptions(options);
  var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
  initializeInstance(target);
  asObservableObject(target, options.name, defaultDecorator.enhancer);
  if (properties)
    extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
  return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
  return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
  var e_1, _a2, e_2, _b;
  if (process.env.NODE_ENV !== "production") {
    invariant$2(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
    if (decorators) {
      var keys2 = getPlainObjectKeys(decorators);
      try {
        for (var keys_1 = __values(keys2), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
          var key = keys_1_1.value;
          if (!(key in properties))
            fail("Trying to declare a decorator for unspecified property '" + stringifyKey(key) + "'");
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (keys_1_1 && !keys_1_1.done && (_a2 = keys_1.return)) _a2.call(keys_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  }
  startBatch();
  try {
    var keys2 = ownKeys$s(properties);
    try {
      for (var keys_2 = __values(keys2), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
        var key = keys_2_1.value;
        var descriptor = Object.getOwnPropertyDescriptor(properties, key);
        if (process.env.NODE_ENV !== "production") {
          if (!isPlainObject$1(properties))
            fail("'extendObservable' only accepts plain objects as second argument");
          if (isComputed(descriptor.value))
            fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
        }
        var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
        if (process.env.NODE_ENV !== "production" && typeof decorator !== "function")
          fail("Not a valid decorator for '" + stringifyKey(key) + "', got: " + decorator);
        var resultDescriptor = decorator(target, key, descriptor, true);
        if (resultDescriptor)
          Object.defineProperty(target, key, resultDescriptor);
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  } finally {
    endBatch();
  }
}
function getDependencyTree(thing, property) {
  return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node2) {
  var result = {
    name: node2.name
  };
  if (node2.observing && node2.observing.length > 0)
    result.dependencies = unique(node2.observing).map(nodeToDependencyTree);
  return result;
}
function _isComputed(value, property) {
  if (value === null || value === void 0)
    return false;
  return isComputedValue(value);
}
function isComputed(value) {
  if (arguments.length > 1)
    return fail(process.env.NODE_ENV !== "production" && "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
  return _isComputed(value);
}
function _isObservable(value, property) {
  if (value === null || value === void 0)
    return false;
  return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
  if (arguments.length !== 1)
    fail(process.env.NODE_ENV !== "production" && "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
  return _isObservable(value);
}
function keys$1(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].getKeys();
  }
  if (isObservableMap(obj)) {
    return Array.from(obj.keys());
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.keys());
  }
  if (isObservableArray(obj)) {
    return obj.map(function(_2, index2) {
      return index2;
    });
  }
  return fail(process.env.NODE_ENV !== "production" && "'keys()' can only be used on observable objects, arrays, sets and maps");
}
function set$3(obj, key, value) {
  if (arguments.length === 2 && !isObservableSet(obj)) {
    startBatch();
    var values_1 = key;
    try {
      for (var key_1 in values_1)
        set$3(obj, key_1, values_1[key_1]);
    } finally {
      endBatch();
    }
    return;
  }
  if (isObservableObject(obj)) {
    var adm = obj[$mobx];
    var existingObservable = adm.values.get(key);
    if (existingObservable) {
      adm.write(key, value);
    } else {
      adm.addObservableProp(key, value, adm.defaultEnhancer);
    }
  } else if (isObservableMap(obj)) {
    obj.set(key, value);
  } else if (isObservableSet(obj)) {
    obj.add(key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number")
      key = parseInt(key, 10);
    invariant$2(key >= 0, "Not a valid index: '" + key + "'");
    startBatch();
    if (key >= obj.length)
      obj.length = key + 1;
    obj[key] = value;
    endBatch();
  } else {
    return fail(process.env.NODE_ENV !== "production" && "'set()' can only be used on observable objects, arrays and maps");
  }
}
var defaultOptions = {
  detectCycles: true,
  exportMapsAsObjects: true,
  recurseEverything: false
};
function cache(map, key, value, options) {
  if (options.detectCycles)
    map.set(key, value);
  return value;
}
function toJSHelper(source, options, __alreadySeen) {
  if (!options.recurseEverything && !isObservable(source))
    return source;
  if (typeof source !== "object")
    return source;
  if (source === null)
    return null;
  if (source instanceof Date)
    return source;
  if (isObservableValue(source))
    return toJSHelper(source.get(), options, __alreadySeen);
  if (isObservable(source))
    keys$1(source);
  var detectCycles = options.detectCycles === true;
  if (detectCycles && source !== null && __alreadySeen.has(source)) {
    return __alreadySeen.get(source);
  }
  if (isObservableArray(source) || Array.isArray(source)) {
    var res_1 = cache(__alreadySeen, source, [], options);
    var toAdd = source.map(function(value) {
      return toJSHelper(value, options, __alreadySeen);
    });
    res_1.length = toAdd.length;
    for (var i = 0, l = toAdd.length; i < l; i++)
      res_1[i] = toAdd[i];
    return res_1;
  }
  if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
    if (options.exportMapsAsObjects === false) {
      var res_2 = cache(__alreadySeen, source, /* @__PURE__ */ new Set(), options);
      source.forEach(function(value) {
        res_2.add(toJSHelper(value, options, __alreadySeen));
      });
      return res_2;
    } else {
      var res_3 = cache(__alreadySeen, source, [], options);
      source.forEach(function(value) {
        res_3.push(toJSHelper(value, options, __alreadySeen));
      });
      return res_3;
    }
  }
  if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
    if (options.exportMapsAsObjects === false) {
      var res_4 = cache(__alreadySeen, source, /* @__PURE__ */ new Map(), options);
      source.forEach(function(value, key) {
        res_4.set(key, toJSHelper(value, options, __alreadySeen));
      });
      return res_4;
    } else {
      var res_5 = cache(__alreadySeen, source, {}, options);
      source.forEach(function(value, key) {
        res_5[key] = toJSHelper(value, options, __alreadySeen);
      });
      return res_5;
    }
  }
  var res = cache(__alreadySeen, source, {}, options);
  getPlainObjectKeys(source).forEach(function(key) {
    res[key] = toJSHelper(source[key], options, __alreadySeen);
  });
  return res;
}
function toJS(source, options) {
  if (typeof options === "boolean")
    options = { detectCycles: options };
  if (!options)
    options = defaultOptions;
  options.detectCycles = options.detectCycles === void 0 ? options.recurseEverything === true : options.detectCycles === true;
  var __alreadySeen;
  if (options.detectCycles)
    __alreadySeen = /* @__PURE__ */ new Map();
  return toJSHelper(source, options, __alreadySeen);
}
function trace() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var enterBreakPoint = false;
  if (typeof args[args.length - 1] === "boolean")
    enterBreakPoint = args.pop();
  var derivation = getAtomFromArgs(args);
  if (!derivation) {
    return fail(process.env.NODE_ENV !== "production" && "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  }
  if (derivation.isTracing === TraceMode.NONE) {
    console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
  }
  derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
  switch (args.length) {
    case 0:
      return globalState$1.trackingDerivation;
    case 1:
      return getAtom(args[0]);
    case 2:
      return getAtom(args[0], args[1]);
  }
}
function transaction(action3, thisArg) {
  if (thisArg === void 0) {
    thisArg = void 0;
  }
  startBatch();
  try {
    return action3.apply(thisArg);
  } finally {
    endBatch();
  }
}
function getAdm(target) {
  return target[$mobx];
}
function isPropertyKey(val) {
  return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
var objectProxyTraps = {
  has: function(target, name) {
    if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
      return true;
    var adm = getAdm(target);
    if (isPropertyKey(name))
      return adm.has(name);
    return name in target;
  },
  get: function(target, name) {
    if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
      return target[name];
    var adm = getAdm(target);
    var observable2 = adm.values.get(name);
    if (observable2 instanceof Atom) {
      var result = observable2.get();
      if (result === void 0) {
        adm.has(name);
      }
      return result;
    }
    if (isPropertyKey(name))
      adm.has(name);
    return target[name];
  },
  set: function(target, name, value) {
    if (!isPropertyKey(name))
      return false;
    set$3(target, name, value);
    return true;
  },
  deleteProperty: function(target, name) {
    if (!isPropertyKey(name))
      return false;
    var adm = getAdm(target);
    adm.remove(name);
    return true;
  },
  ownKeys: function(target) {
    var adm = getAdm(target);
    adm.keysAtom.reportObserved();
    return Reflect.ownKeys(target);
  },
  preventExtensions: function(target) {
    fail("Dynamic observable objects cannot be frozen");
    return false;
  }
};
function createDynamicObservableObject(base) {
  var proxy = new Proxy(base, objectProxyTraps);
  base[$mobx].proxy = proxy;
  return proxy;
}
function hasInterceptors(interceptable) {
  return interceptable.interceptors !== void 0 && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
  var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
  interceptors.push(handler);
  return once$1(function() {
    var idx = interceptors.indexOf(handler);
    if (idx !== -1)
      interceptors.splice(idx, 1);
  });
}
function interceptChange(interceptable, change) {
  var prevU = untrackedStart();
  try {
    var interceptors = __spread$1(interceptable.interceptors || []);
    for (var i = 0, l = interceptors.length; i < l; i++) {
      change = interceptors[i](change);
      invariant$2(!change || change.type, "Intercept handlers should return nothing or a change object");
      if (!change)
        break;
    }
    return change;
  } finally {
    untrackedEnd(prevU);
  }
}
function hasListeners(listenable) {
  return listenable.changeListeners !== void 0 && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
  var listeners = listenable.changeListeners || (listenable.changeListeners = []);
  listeners.push(handler);
  return once$1(function() {
    var idx = listeners.indexOf(handler);
    if (idx !== -1)
      listeners.splice(idx, 1);
  });
}
function notifyListeners(listenable, change) {
  var prevU = untrackedStart();
  var listeners = listenable.changeListeners;
  if (!listeners)
    return;
  listeners = listeners.slice();
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](change);
  }
  untrackedEnd(prevU);
}
var MAX_SPLICE_SIZE = 1e4;
var arrayTraps = {
  get: function(target, name) {
    if (name === $mobx)
      return target[$mobx];
    if (name === "length")
      return target[$mobx].getArrayLength();
    if (typeof name === "number") {
      return arrayExtensions.get.call(target, name);
    }
    if (typeof name === "string" && !isNaN(name)) {
      return arrayExtensions.get.call(target, parseInt(name));
    }
    if (arrayExtensions.hasOwnProperty(name)) {
      return arrayExtensions[name];
    }
    return target[name];
  },
  set: function(target, name, value) {
    if (name === "length") {
      target[$mobx].setArrayLength(value);
    }
    if (typeof name === "number") {
      arrayExtensions.set.call(target, name, value);
    }
    if (typeof name === "symbol" || isNaN(name)) {
      target[name] = value;
    } else {
      arrayExtensions.set.call(target, parseInt(name), value);
    }
    return true;
  },
  preventExtensions: function(target) {
    fail("Observable arrays cannot be frozen");
    return false;
  }
};
function createObservableArray(initialValues, enhancer, name, owned) {
  if (name === void 0) {
    name = "ObservableArray@" + getNextId();
  }
  if (owned === void 0) {
    owned = false;
  }
  var adm = new ObservableArrayAdministration(name, enhancer, owned);
  addHiddenFinalProp(adm.values, $mobx, adm);
  var proxy = new Proxy(adm.values, arrayTraps);
  adm.proxy = proxy;
  if (initialValues && initialValues.length) {
    var prev4 = allowStateChangesStart(true);
    adm.spliceWithArray(0, 0, initialValues);
    allowStateChangesEnd(prev4);
  }
  return proxy;
}
var ObservableArrayAdministration = (
  /** @class */
  (function() {
    function ObservableArrayAdministration2(name, enhancer, owned) {
      this.owned = owned;
      this.values = [];
      this.proxy = void 0;
      this.lastKnownLength = 0;
      this.atom = new Atom(name || "ObservableArray@" + getNextId());
      this.enhancer = function(newV, oldV) {
        return enhancer(newV, oldV, name + "[..]");
      };
    }
    ObservableArrayAdministration2.prototype.dehanceValue = function(value) {
      if (this.dehancer !== void 0)
        return this.dehancer(value);
      return value;
    };
    ObservableArrayAdministration2.prototype.dehanceValues = function(values) {
      if (this.dehancer !== void 0 && values.length > 0)
        return values.map(this.dehancer);
      return values;
    };
    ObservableArrayAdministration2.prototype.intercept = function(handler) {
      return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration2.prototype.observe = function(listener, fireImmediately) {
      if (fireImmediately === void 0) {
        fireImmediately = false;
      }
      if (fireImmediately) {
        listener({
          object: this.proxy,
          type: "splice",
          index: 0,
          added: this.values.slice(),
          addedCount: this.values.length,
          removed: [],
          removedCount: 0
        });
      }
      return registerListener(this, listener);
    };
    ObservableArrayAdministration2.prototype.getArrayLength = function() {
      this.atom.reportObserved();
      return this.values.length;
    };
    ObservableArrayAdministration2.prototype.setArrayLength = function(newLength) {
      if (typeof newLength !== "number" || newLength < 0)
        throw new Error("[mobx.array] Out of range: " + newLength);
      var currentLength = this.values.length;
      if (newLength === currentLength)
        return;
      else if (newLength > currentLength) {
        var newItems = new Array(newLength - currentLength);
        for (var i = 0; i < newLength - currentLength; i++)
          newItems[i] = void 0;
        this.spliceWithArray(currentLength, 0, newItems);
      } else
        this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration2.prototype.updateArrayLength = function(oldLength, delta) {
      if (oldLength !== this.lastKnownLength)
        throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
      this.lastKnownLength += delta;
    };
    ObservableArrayAdministration2.prototype.spliceWithArray = function(index2, deleteCount, newItems) {
      var _this = this;
      checkIfStateModificationsAreAllowed(this.atom);
      var length2 = this.values.length;
      if (index2 === void 0)
        index2 = 0;
      else if (index2 > length2)
        index2 = length2;
      else if (index2 < 0)
        index2 = Math.max(0, length2 + index2);
      if (arguments.length === 1)
        deleteCount = length2 - index2;
      else if (deleteCount === void 0 || deleteCount === null)
        deleteCount = 0;
      else
        deleteCount = Math.max(0, Math.min(deleteCount, length2 - index2));
      if (newItems === void 0)
        newItems = EMPTY_ARRAY;
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy,
          type: "splice",
          index: index2,
          removedCount: deleteCount,
          added: newItems
        });
        if (!change)
          return EMPTY_ARRAY;
        deleteCount = change.removedCount;
        newItems = change.added;
      }
      newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
        return _this.enhancer(v, void 0);
      });
      if (process.env.NODE_ENV !== "production") {
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length2, lengthDelta);
      }
      var res = this.spliceItemsIntoValues(index2, deleteCount, newItems);
      if (deleteCount !== 0 || newItems.length !== 0)
        this.notifyArraySplice(index2, newItems, res);
      return this.dehanceValues(res);
    };
    ObservableArrayAdministration2.prototype.spliceItemsIntoValues = function(index2, deleteCount, newItems) {
      var _a2;
      if (newItems.length < MAX_SPLICE_SIZE) {
        return (_a2 = this.values).splice.apply(_a2, __spread$1([index2, deleteCount], newItems));
      } else {
        var res = this.values.slice(index2, index2 + deleteCount);
        this.values = this.values.slice(0, index2).concat(newItems, this.values.slice(index2 + deleteCount));
        return res;
      }
    };
    ObservableArrayAdministration2.prototype.notifyArrayChildUpdate = function(index2, newValue, oldValue) {
      var notifySpy = !this.owned && isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        object: this.proxy,
        type: "update",
        index: index2,
        newValue,
        oldValue
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportStart(__assign$2(__assign$2({}, change), { name: this.atom.name }));
      this.atom.reportChanged();
      if (notify)
        notifyListeners(this, change);
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportEnd();
    };
    ObservableArrayAdministration2.prototype.notifyArraySplice = function(index2, added, removed) {
      var notifySpy = !this.owned && isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        object: this.proxy,
        type: "splice",
        index: index2,
        removed,
        added,
        removedCount: removed.length,
        addedCount: added.length
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportStart(__assign$2(__assign$2({}, change), { name: this.atom.name }));
      this.atom.reportChanged();
      if (notify)
        notifyListeners(this, change);
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportEnd();
    };
    return ObservableArrayAdministration2;
  })()
);
var arrayExtensions = {
  intercept: function(handler) {
    return this[$mobx].intercept(handler);
  },
  observe: function(listener, fireImmediately) {
    if (fireImmediately === void 0) {
      fireImmediately = false;
    }
    var adm = this[$mobx];
    return adm.observe(listener, fireImmediately);
  },
  clear: function() {
    return this.splice(0);
  },
  replace: function(newItems) {
    var adm = this[$mobx];
    return adm.spliceWithArray(0, adm.values.length, newItems);
  },
  /**
   * Converts this array back to a (shallow) javascript structure.
   * For a deep clone use mobx.toJS
   */
  toJS: function() {
    return this.slice();
  },
  toJSON: function() {
    return this.toJS();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(index2, deleteCount) {
    var newItems = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      newItems[_i - 2] = arguments[_i];
    }
    var adm = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return adm.spliceWithArray(index2);
      case 2:
        return adm.spliceWithArray(index2, deleteCount);
    }
    return adm.spliceWithArray(index2, deleteCount, newItems);
  },
  spliceWithArray: function(index2, deleteCount, newItems) {
    var adm = this[$mobx];
    return adm.spliceWithArray(index2, deleteCount, newItems);
  },
  push: function() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var adm = this[$mobx];
    adm.spliceWithArray(adm.values.length, 0, items);
    return adm.values.length;
  },
  pop: function() {
    return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      items[_i] = arguments[_i];
    }
    var adm = this[$mobx];
    adm.spliceWithArray(0, 0, items);
    return adm.values.length;
  },
  reverse: function() {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
    }
    var clone = this.slice();
    return clone.reverse.apply(clone, arguments);
  },
  sort: function(compareFn) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
    }
    var clone = this.slice();
    return clone.sort.apply(clone, arguments);
  },
  remove: function(value) {
    var adm = this[$mobx];
    var idx = adm.dehanceValues(adm.values).indexOf(value);
    if (idx > -1) {
      this.splice(idx, 1);
      return true;
    }
    return false;
  },
  get: function(index2) {
    var adm = this[$mobx];
    if (adm) {
      if (index2 < adm.values.length) {
        adm.atom.reportObserved();
        return adm.dehanceValue(adm.values[index2]);
      }
      console.warn("[mobx.array] Attempt to read an array index (" + index2 + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    }
    return void 0;
  },
  set: function(index2, newValue) {
    var adm = this[$mobx];
    var values = adm.values;
    if (index2 < values.length) {
      checkIfStateModificationsAreAllowed(adm.atom);
      var oldValue = values[index2];
      if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
          type: "update",
          object: adm.proxy,
          index: index2,
          newValue
        });
        if (!change)
          return;
        newValue = change.newValue;
      }
      newValue = adm.enhancer(newValue, oldValue);
      var changed = newValue !== oldValue;
      if (changed) {
        values[index2] = newValue;
        adm.notifyArrayChildUpdate(index2, newValue, oldValue);
      }
    } else if (index2 === values.length) {
      adm.spliceWithArray(index2, 0, [newValue]);
    } else {
      throw new Error("[mobx.array] Index out of bounds, " + index2 + " is larger than " + values.length);
    }
  }
};
[
  "concat",
  "flat",
  "includes",
  "indexOf",
  "join",
  "lastIndexOf",
  "slice",
  "toString",
  "toLocaleString"
].forEach(function(funcName) {
  if (typeof Array.prototype[funcName] !== "function") {
    return;
  }
  arrayExtensions[funcName] = function() {
    var adm = this[$mobx];
    adm.atom.reportObserved();
    var dehancedValues = adm.dehanceValues(adm.values);
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
});
["every", "filter", "find", "findIndex", "flatMap", "forEach", "map", "some"].forEach(function(funcName) {
  if (typeof Array.prototype[funcName] !== "function") {
    return;
  }
  arrayExtensions[funcName] = function(callback, thisArg) {
    var _this = this;
    var adm = this[$mobx];
    adm.atom.reportObserved();
    var dehancedValues = adm.dehanceValues(adm.values);
    return dehancedValues[funcName](function(element, index2) {
      return callback.call(thisArg, element, index2, _this);
    }, thisArg);
  };
});
["reduce", "reduceRight"].forEach(function(funcName) {
  arrayExtensions[funcName] = function() {
    var _this = this;
    var adm = this[$mobx];
    adm.atom.reportObserved();
    var callback = arguments[0];
    arguments[0] = function(accumulator, currentValue, index2) {
      currentValue = adm.dehanceValue(currentValue);
      return callback(accumulator, currentValue, index2, _this);
    };
    return adm.values[funcName].apply(adm.values, arguments);
  };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
  return isObject$2(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _a;
var ObservableMapMarker = {};
var ObservableMap = (
  /** @class */
  (function() {
    function ObservableMap2(initialData, enhancer, name) {
      if (enhancer === void 0) {
        enhancer = deepEnhancer;
      }
      if (name === void 0) {
        name = "ObservableMap@" + getNextId();
      }
      this.enhancer = enhancer;
      this.name = name;
      this[_a] = ObservableMapMarker;
      this._keysAtom = createAtom(this.name + ".keys()");
      this[Symbol.toStringTag] = "Map";
      if (typeof Map !== "function") {
        throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
      }
      this._data = /* @__PURE__ */ new Map();
      this._hasMap = /* @__PURE__ */ new Map();
      this.merge(initialData);
    }
    ObservableMap2.prototype._has = function(key) {
      return this._data.has(key);
    };
    ObservableMap2.prototype.has = function(key) {
      var _this = this;
      if (!globalState$1.trackingDerivation)
        return this._has(key);
      var entry = this._hasMap.get(key);
      if (!entry) {
        var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
        this._hasMap.set(key, newEntry);
        onBecomeUnobserved(newEntry, function() {
          return _this._hasMap.delete(key);
        });
      }
      return entry.get();
    };
    ObservableMap2.prototype.set = function(key, value) {
      var hasKey = this._has(key);
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: hasKey ? "update" : "add",
          object: this,
          newValue: value,
          name: key
        });
        if (!change)
          return this;
        value = change.newValue;
      }
      if (hasKey) {
        this._updateValue(key, value);
      } else {
        this._addValue(key, value);
      }
      return this;
    };
    ObservableMap2.prototype.delete = function(key) {
      var _this = this;
      checkIfStateModificationsAreAllowed(this._keysAtom);
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: "delete",
          object: this,
          name: key
        });
        if (!change)
          return false;
      }
      if (this._has(key)) {
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
          type: "delete",
          object: this,
          oldValue: this._data.get(key).value,
          name: key
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
        transaction(function() {
          _this._keysAtom.reportChanged();
          _this._updateHasMapEntry(key, false);
          var observable2 = _this._data.get(key);
          observable2.setNewValue(void 0);
          _this._data.delete(key);
        });
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
        return true;
      }
      return false;
    };
    ObservableMap2.prototype._updateHasMapEntry = function(key, value) {
      var entry = this._hasMap.get(key);
      if (entry) {
        entry.setNewValue(value);
      }
    };
    ObservableMap2.prototype._updateValue = function(key, newValue) {
      var observable2 = this._data.get(key);
      newValue = observable2.prepareNewValue(newValue);
      if (newValue !== globalState$1.UNCHANGED) {
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
          type: "update",
          object: this,
          oldValue: observable2.value,
          name: key,
          newValue
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
        observable2.setNewValue(newValue);
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
      }
    };
    ObservableMap2.prototype._addValue = function(key, newValue) {
      var _this = this;
      checkIfStateModificationsAreAllowed(this._keysAtom);
      transaction(function() {
        var observable2 = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
        _this._data.set(key, observable2);
        newValue = observable2.value;
        _this._updateHasMapEntry(key, true);
        _this._keysAtom.reportChanged();
      });
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        type: "add",
        object: this,
        name: key,
        newValue
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
      if (notify)
        notifyListeners(this, change);
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportEnd();
    };
    ObservableMap2.prototype.get = function(key) {
      if (this.has(key))
        return this.dehanceValue(this._data.get(key).get());
      return this.dehanceValue(void 0);
    };
    ObservableMap2.prototype.dehanceValue = function(value) {
      if (this.dehancer !== void 0) {
        return this.dehancer(value);
      }
      return value;
    };
    ObservableMap2.prototype.keys = function() {
      this._keysAtom.reportObserved();
      return this._data.keys();
    };
    ObservableMap2.prototype.values = function() {
      var self2 = this;
      var keys2 = this.keys();
      return makeIterable({
        next: function() {
          var _b = keys2.next(), done = _b.done, value = _b.value;
          return {
            done,
            value: done ? void 0 : self2.get(value)
          };
        }
      });
    };
    ObservableMap2.prototype.entries = function() {
      var self2 = this;
      var keys2 = this.keys();
      return makeIterable({
        next: function() {
          var _b = keys2.next(), done = _b.done, value = _b.value;
          return {
            done,
            value: done ? void 0 : [value, self2.get(value)]
          };
        }
      });
    };
    ObservableMap2.prototype[_a = $mobx, Symbol.iterator] = function() {
      return this.entries();
    };
    ObservableMap2.prototype.forEach = function(callback, thisArg) {
      var e_1, _b;
      try {
        for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read$3(_d.value, 2), key = _e[0], value = _e[1];
          callback.call(thisArg, value, key, this);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    };
    ObservableMap2.prototype.merge = function(other) {
      var _this = this;
      if (isObservableMap(other)) {
        other = other.toJS();
      }
      transaction(function() {
        var prev4 = allowStateChangesStart(true);
        try {
          if (isPlainObject$1(other))
            getPlainObjectKeys(other).forEach(function(key) {
              return _this.set(key, other[key]);
            });
          else if (Array.isArray(other))
            other.forEach(function(_b) {
              var _c = __read$3(_b, 2), key = _c[0], value = _c[1];
              return _this.set(key, value);
            });
          else if (isES6Map(other)) {
            if (other.constructor !== Map)
              fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name);
            other.forEach(function(value, key) {
              return _this.set(key, value);
            });
          } else if (other !== null && other !== void 0)
            fail("Cannot initialize map from " + other);
        } finally {
          allowStateChangesEnd(prev4);
        }
      });
      return this;
    };
    ObservableMap2.prototype.clear = function() {
      var _this = this;
      transaction(function() {
        untracked(function() {
          var e_2, _b;
          try {
            for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
              var key = _d.value;
              _this.delete(key);
            }
          } catch (e_2_1) {
            e_2 = { error: e_2_1 };
          } finally {
            try {
              if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        });
      });
    };
    ObservableMap2.prototype.replace = function(values) {
      var _this = this;
      transaction(function() {
        var e_3, _b, e_4, _c;
        var replacementMap = convertToMap(values);
        var orderedData = /* @__PURE__ */ new Map();
        var keysReportChangedCalled = false;
        try {
          for (var _d = __values(_this._data.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
            var key = _e.value;
            if (!replacementMap.has(key)) {
              var deleted = _this.delete(key);
              if (deleted) {
                keysReportChangedCalled = true;
              } else {
                var value = _this._data.get(key);
                orderedData.set(key, value);
              }
            }
          }
        } catch (e_3_1) {
          e_3 = { error: e_3_1 };
        } finally {
          try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
        try {
          for (var _f = __values(replacementMap.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
            var _h = __read$3(_g.value, 2), key = _h[0], value = _h[1];
            var keyExisted = _this._data.has(key);
            _this.set(key, value);
            if (_this._data.has(key)) {
              var value_1 = _this._data.get(key);
              orderedData.set(key, value_1);
              if (!keyExisted) {
                keysReportChangedCalled = true;
              }
            }
          }
        } catch (e_4_1) {
          e_4 = { error: e_4_1 };
        } finally {
          try {
            if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
          } finally {
            if (e_4) throw e_4.error;
          }
        }
        if (!keysReportChangedCalled) {
          if (_this._data.size !== orderedData.size) {
            _this._keysAtom.reportChanged();
          } else {
            var iter1 = _this._data.keys();
            var iter2 = orderedData.keys();
            var next1 = iter1.next();
            var next22 = iter2.next();
            while (!next1.done) {
              if (next1.value !== next22.value) {
                _this._keysAtom.reportChanged();
                break;
              }
              next1 = iter1.next();
              next22 = iter2.next();
            }
          }
        }
        _this._data = orderedData;
      });
      return this;
    };
    Object.defineProperty(ObservableMap2.prototype, "size", {
      get: function() {
        this._keysAtom.reportObserved();
        return this._data.size;
      },
      enumerable: true,
      configurable: true
    });
    ObservableMap2.prototype.toPOJO = function() {
      var e_5, _b;
      var res = {};
      try {
        for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read$3(_d.value, 2), key = _e[0], value = _e[1];
          res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
        }
      } catch (e_5_1) {
        e_5 = { error: e_5_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_5) throw e_5.error;
        }
      }
      return res;
    };
    ObservableMap2.prototype.toJS = function() {
      return new Map(this);
    };
    ObservableMap2.prototype.toJSON = function() {
      return this.toPOJO();
    };
    ObservableMap2.prototype.toString = function() {
      var _this = this;
      return this.name + "[{ " + Array.from(this.keys()).map(function(key) {
        return stringifyKey(key) + ": " + ("" + _this.get(key));
      }).join(", ") + " }]";
    };
    ObservableMap2.prototype.observe = function(listener, fireImmediately) {
      process.env.NODE_ENV !== "production" && invariant$2(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
      return registerListener(this, listener);
    };
    ObservableMap2.prototype.intercept = function(handler) {
      return registerInterceptor(this, handler);
    };
    return ObservableMap2;
  })()
);
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
var _a$1;
var ObservableSetMarker = {};
var ObservableSet = (
  /** @class */
  (function() {
    function ObservableSet2(initialData, enhancer, name) {
      if (enhancer === void 0) {
        enhancer = deepEnhancer;
      }
      if (name === void 0) {
        name = "ObservableSet@" + getNextId();
      }
      this.name = name;
      this[_a$1] = ObservableSetMarker;
      this._data = /* @__PURE__ */ new Set();
      this._atom = createAtom(this.name);
      this[Symbol.toStringTag] = "Set";
      if (typeof Set !== "function") {
        throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
      }
      this.enhancer = function(newV, oldV) {
        return enhancer(newV, oldV, name);
      };
      if (initialData) {
        this.replace(initialData);
      }
    }
    ObservableSet2.prototype.dehanceValue = function(value) {
      if (this.dehancer !== void 0) {
        return this.dehancer(value);
      }
      return value;
    };
    ObservableSet2.prototype.clear = function() {
      var _this = this;
      transaction(function() {
        untracked(function() {
          var e_1, _b;
          try {
            for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
              var value = _d.value;
              _this.delete(value);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        });
      });
    };
    ObservableSet2.prototype.forEach = function(callbackFn, thisArg) {
      var e_2, _b;
      try {
        for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
          var value = _d.value;
          callbackFn.call(thisArg, value, value, this);
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    };
    Object.defineProperty(ObservableSet2.prototype, "size", {
      get: function() {
        this._atom.reportObserved();
        return this._data.size;
      },
      enumerable: true,
      configurable: true
    });
    ObservableSet2.prototype.add = function(value) {
      var _this = this;
      checkIfStateModificationsAreAllowed(this._atom);
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: "add",
          object: this,
          newValue: value
        });
        if (!change)
          return this;
      }
      if (!this.has(value)) {
        transaction(function() {
          _this._data.add(_this.enhancer(value, void 0));
          _this._atom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
          type: "add",
          object: this,
          newValue: value
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(change);
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
      }
      return this;
    };
    ObservableSet2.prototype.delete = function(value) {
      var _this = this;
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: "delete",
          object: this,
          oldValue: value
        });
        if (!change)
          return false;
      }
      if (this.has(value)) {
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
          type: "delete",
          object: this,
          oldValue: value
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(__assign$2(__assign$2({}, change), { name: this.name }));
        transaction(function() {
          _this._atom.reportChanged();
          _this._data.delete(value);
        });
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
        return true;
      }
      return false;
    };
    ObservableSet2.prototype.has = function(value) {
      this._atom.reportObserved();
      return this._data.has(this.dehanceValue(value));
    };
    ObservableSet2.prototype.entries = function() {
      var nextIndex = 0;
      var keys2 = Array.from(this.keys());
      var values = Array.from(this.values());
      return makeIterable({
        next: function() {
          var index2 = nextIndex;
          nextIndex += 1;
          return index2 < values.length ? { value: [keys2[index2], values[index2]], done: false } : { done: true };
        }
      });
    };
    ObservableSet2.prototype.keys = function() {
      return this.values();
    };
    ObservableSet2.prototype.values = function() {
      this._atom.reportObserved();
      var self2 = this;
      var nextIndex = 0;
      var observableValues = Array.from(this._data.values());
      return makeIterable({
        next: function() {
          return nextIndex < observableValues.length ? { value: self2.dehanceValue(observableValues[nextIndex++]), done: false } : { done: true };
        }
      });
    };
    ObservableSet2.prototype.replace = function(other) {
      var _this = this;
      if (isObservableSet(other)) {
        other = other.toJS();
      }
      transaction(function() {
        var prev4 = allowStateChangesStart(true);
        try {
          if (Array.isArray(other)) {
            _this.clear();
            other.forEach(function(value) {
              return _this.add(value);
            });
          } else if (isES6Set(other)) {
            _this.clear();
            other.forEach(function(value) {
              return _this.add(value);
            });
          } else if (other !== null && other !== void 0) {
            fail("Cannot initialize set from " + other);
          }
        } finally {
          allowStateChangesEnd(prev4);
        }
      });
      return this;
    };
    ObservableSet2.prototype.observe = function(listener, fireImmediately) {
      process.env.NODE_ENV !== "production" && invariant$2(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
      return registerListener(this, listener);
    };
    ObservableSet2.prototype.intercept = function(handler) {
      return registerInterceptor(this, handler);
    };
    ObservableSet2.prototype.toJS = function() {
      return new Set(this);
    };
    ObservableSet2.prototype.toString = function() {
      return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet2.prototype[_a$1 = $mobx, Symbol.iterator] = function() {
      return this.values();
    };
    return ObservableSet2;
  })()
);
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);
var ObservableObjectAdministration = (
  /** @class */
  (function() {
    function ObservableObjectAdministration2(target, values, name, defaultEnhancer) {
      if (values === void 0) {
        values = /* @__PURE__ */ new Map();
      }
      this.target = target;
      this.values = values;
      this.name = name;
      this.defaultEnhancer = defaultEnhancer;
      this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration2.prototype.read = function(key) {
      return this.values.get(key).get();
    };
    ObservableObjectAdministration2.prototype.write = function(key, newValue) {
      var instance = this.target;
      var observable2 = this.values.get(key);
      if (observable2 instanceof ComputedValue) {
        observable2.set(newValue);
        return;
      }
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: "update",
          object: this.proxy || instance,
          name: key,
          newValue
        });
        if (!change)
          return;
        newValue = change.newValue;
      }
      newValue = observable2.prepareNewValue(newValue);
      if (newValue !== globalState$1.UNCHANGED) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy ? {
          type: "update",
          object: this.proxy || instance,
          oldValue: observable2.value,
          name: key,
          newValue
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
        observable2.setNewValue(newValue);
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
      }
    };
    ObservableObjectAdministration2.prototype.has = function(key) {
      var map = this.pendingKeys || (this.pendingKeys = /* @__PURE__ */ new Map());
      var entry = map.get(key);
      if (entry)
        return entry.get();
      else {
        var exists = !!this.values.get(key);
        entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
        map.set(key, entry);
        return entry.get();
      }
    };
    ObservableObjectAdministration2.prototype.addObservableProp = function(propName, newValue, enhancer) {
      if (enhancer === void 0) {
        enhancer = this.defaultEnhancer;
      }
      var target = this.target;
      assertPropertyConfigurable(target, propName);
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy || target,
          name: propName,
          type: "add",
          newValue
        });
        if (!change)
          return;
        newValue = change.newValue;
      }
      var observable2 = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
      this.values.set(propName, observable2);
      newValue = observable2.value;
      Object.defineProperty(target, propName, generateObservablePropConfig(propName));
      this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration2.prototype.addComputedProp = function(propertyOwner, propName, options) {
      var target = this.target;
      options.name = options.name || this.name + "." + stringifyKey(propName);
      this.values.set(propName, new ComputedValue(options));
      if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName))
        Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration2.prototype.remove = function(key) {
      if (!this.values.has(key))
        return;
      var target = this.target;
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy || target,
          name: key,
          type: "remove"
        });
        if (!change)
          return;
      }
      try {
        startBatch();
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var oldObservable = this.values.get(key);
        var oldValue = oldObservable && oldObservable.get();
        oldObservable && oldObservable.set(void 0);
        this.keysAtom.reportChanged();
        this.values.delete(key);
        if (this.pendingKeys) {
          var entry = this.pendingKeys.get(key);
          if (entry)
            entry.set(false);
        }
        delete this.target[key];
        var change = notify || notifySpy ? {
          type: "remove",
          object: this.proxy || target,
          oldValue,
          name: key
        } : null;
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
        if (notify)
          notifyListeners(this, change);
        if (notifySpy && process.env.NODE_ENV !== "production")
          spyReportEnd();
      } finally {
        endBatch();
      }
    };
    ObservableObjectAdministration2.prototype.illegalAccess = function(owner, propName) {
      console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    ObservableObjectAdministration2.prototype.observe = function(callback, fireImmediately) {
      process.env.NODE_ENV !== "production" && invariant$2(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
      return registerListener(this, callback);
    };
    ObservableObjectAdministration2.prototype.intercept = function(handler) {
      return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration2.prototype.notifyPropertyAddition = function(key, newValue) {
      var notify = hasListeners(this);
      var notifySpy = isSpyEnabled();
      var change = notify || notifySpy ? {
        type: "add",
        object: this.proxy || this.target,
        name: key,
        newValue
      } : null;
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportStart(__assign$2(__assign$2({}, change), { name: this.name, key }));
      if (notify)
        notifyListeners(this, change);
      if (notifySpy && process.env.NODE_ENV !== "production")
        spyReportEnd();
      if (this.pendingKeys) {
        var entry = this.pendingKeys.get(key);
        if (entry)
          entry.set(true);
      }
      this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration2.prototype.getKeys = function() {
      var e_1, _a2;
      this.keysAtom.reportObserved();
      var res = [];
      try {
        for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read$3(_c.value, 2), key = _d[0], value = _d[1];
          if (value instanceof ObservableValue)
            res.push(key);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return)) _a2.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      return res;
    };
    return ObservableObjectAdministration2;
  })()
);
function asObservableObject(target, name, defaultEnhancer) {
  if (name === void 0) {
    name = "";
  }
  if (defaultEnhancer === void 0) {
    defaultEnhancer = deepEnhancer;
  }
  if (Object.prototype.hasOwnProperty.call(target, $mobx))
    return target[$mobx];
  process.env.NODE_ENV !== "production" && invariant$2(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
  if (!isPlainObject$1(target))
    name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
  if (!name)
    name = "ObservableObject@" + getNextId();
  var adm = new ObservableObjectAdministration(target, /* @__PURE__ */ new Map(), stringifyKey(name), defaultEnhancer);
  addHiddenProp(target, $mobx, adm);
  return adm;
}
var observablePropertyConfigs = /* @__PURE__ */ Object.create(null);
var computedPropertyConfigs = /* @__PURE__ */ Object.create(null);
function generateObservablePropConfig(propName) {
  return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
    configurable: true,
    enumerable: true,
    get: function() {
      return this[$mobx].read(propName);
    },
    set: function(v) {
      this[$mobx].write(propName, v);
    }
  });
}
function getAdministrationForComputedPropOwner(owner) {
  var adm = owner[$mobx];
  if (!adm) {
    initializeInstance(owner);
    return owner[$mobx];
  }
  return adm;
}
function generateComputedPropConfig(propName) {
  return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
    configurable: globalState$1.computedConfigurable,
    enumerable: false,
    get: function() {
      return getAdministrationForComputedPropOwner(this).read(propName);
    },
    set: function(v) {
      getAdministrationForComputedPropOwner(this).write(propName, v);
    }
  });
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
  if (isObject$2(thing)) {
    initializeInstance(thing);
    return isObservableObjectAdministration(thing[$mobx]);
  }
  return false;
}
function getAtom(thing, property) {
  if (typeof thing === "object" && thing !== null) {
    if (isObservableArray(thing)) {
      if (property !== void 0)
        fail(process.env.NODE_ENV !== "production" && "It is not possible to get index atoms from arrays");
      return thing[$mobx].atom;
    }
    if (isObservableSet(thing)) {
      return thing[$mobx];
    }
    if (isObservableMap(thing)) {
      var anyThing = thing;
      if (property === void 0)
        return anyThing._keysAtom;
      var observable2 = anyThing._data.get(property) || anyThing._hasMap.get(property);
      if (!observable2)
        fail(process.env.NODE_ENV !== "production" && "the entry '" + property + "' does not exist in the observable map '" + getDebugName$1(thing) + "'");
      return observable2;
    }
    initializeInstance(thing);
    if (property && !thing[$mobx])
      thing[property];
    if (isObservableObject(thing)) {
      if (!property)
        return fail(process.env.NODE_ENV !== "production" && "please specify a property");
      var observable2 = thing[$mobx].values.get(property);
      if (!observable2)
        fail(process.env.NODE_ENV !== "production" && "no observable property '" + property + "' found on the observable object '" + getDebugName$1(thing) + "'");
      return observable2;
    }
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
      return thing;
    }
  } else if (typeof thing === "function") {
    if (isReaction(thing[$mobx])) {
      return thing[$mobx];
    }
  }
  return fail(process.env.NODE_ENV !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
  if (!thing)
    fail("Expecting some object");
  if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
    return thing;
  if (isObservableMap(thing) || isObservableSet(thing))
    return thing;
  initializeInstance(thing);
  if (thing[$mobx])
    return thing[$mobx];
  fail(process.env.NODE_ENV !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName$1(thing, property) {
  var named;
  if (property !== void 0)
    named = getAtom(thing, property);
  else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
    named = getAdministration(thing);
  else
    named = getAtom(thing);
  return named.name;
}
var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
  if (depth === void 0) {
    depth = -1;
  }
  return eq(a, b, depth);
}
function eq(a, b, depth, aStack, bStack) {
  if (a === b)
    return a !== 0 || 1 / a === 1 / b;
  if (a == null || b == null)
    return false;
  if (a !== a)
    return b !== b;
  var type4 = typeof a;
  if (type4 !== "function" && type4 !== "object" && typeof b != "object")
    return false;
  var className = toString.call(a);
  if (className !== toString.call(b))
    return false;
  switch (className) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + a === "" + b;
    case "[object Number]":
      if (+a !== +a)
        return +b !== +b;
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case "[object Date]":
    case "[object Boolean]":
      return +a === +b;
    case "[object Symbol]":
      return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
    case "[object Map]":
    case "[object Set]":
      if (depth >= 0) {
        depth++;
      }
      break;
  }
  a = unwrap(a);
  b = unwrap(b);
  var areArrays = className === "[object Array]";
  if (!areArrays) {
    if (typeof a != "object" || typeof b != "object")
      return false;
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && ("constructor" in a && "constructor" in b)) {
      return false;
    }
  }
  if (depth === 0) {
    return false;
  } else if (depth < 0) {
    depth = -1;
  }
  aStack = aStack || [];
  bStack = bStack || [];
  var length2 = aStack.length;
  while (length2--) {
    if (aStack[length2] === a)
      return bStack[length2] === b;
  }
  aStack.push(a);
  bStack.push(b);
  if (areArrays) {
    length2 = a.length;
    if (length2 !== b.length)
      return false;
    while (length2--) {
      if (!eq(a[length2], b[length2], depth - 1, aStack, bStack))
        return false;
    }
  } else {
    var keys2 = Object.keys(a);
    var key = void 0;
    length2 = keys2.length;
    if (Object.keys(b).length !== length2)
      return false;
    while (length2--) {
      key = keys2[length2];
      if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
        return false;
    }
  }
  aStack.pop();
  bStack.pop();
  return true;
}
function unwrap(a) {
  if (isObservableArray(a))
    return a.slice();
  if (isES6Map(a) || isObservableMap(a))
    return Array.from(a.entries());
  if (isES6Set(a) || isObservableSet(a))
    return Array.from(a.entries());
  return a;
}
function has$1(a, key) {
  return Object.prototype.hasOwnProperty.call(a, key);
}
function makeIterable(iterator) {
  iterator[Symbol.iterator] = getSelf;
  return iterator;
}
function getSelf() {
  return this;
}
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
  throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
  process.env.NODE_ENV;
} catch (e) {
  var g = getGlobal$1();
  if (typeof process === "undefined")
    g.process = {};
  g.process.env = {};
}
(function() {
  function testCodeMinification() {
  }
  if (testCodeMinification.name !== "testCodeMinification" && process.env.NODE_ENV !== "production" && typeof process !== "undefined" && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
    var varName = ["process", "env", "NODE_ENV"].join(".");
    console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
  }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy,
    extras: {
      getDebugName: getDebugName$1
    },
    $mobx
  });
}
class JwtToken {
}
class JwtDecoder {
  decode(token2) {
    try {
      const payload = token2.split(".")[1];
      const payloadJson = JSON.parse(this.b64DecodeUnicode(payload));
      const decodedToken = new JwtToken();
      decodedToken.exp = new Date(payloadJson.exp * 1e3);
      decodedToken.iat = new Date(payloadJson.iat * 1e3);
      decodedToken.user = payloadJson.user;
      return decodedToken;
    } catch (e) {
      console.error("[JwtDecoder] Error while decoding token:", token2, e);
      return null;
    }
  }
  b64DecodeUnicode(str) {
    var base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    return decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      var isInstance = false;
      try {
        isInstance = this instanceof a2;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var _Reflect = {};
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var hasRequired_Reflect;
function require_Reflect() {
  if (hasRequired_Reflect) return _Reflect;
  hasRequired_Reflect = 1;
  var Reflect2;
  (function(Reflect3) {
    (function(factory) {
      var root = typeof commonjsGlobal === "object" ? commonjsGlobal : typeof self === "object" ? self : typeof this === "object" ? this : Function("return this;")();
      var exporter = makeExporter(Reflect3);
      if (typeof root.Reflect === "undefined") {
        root.Reflect = Reflect3;
      } else {
        exporter = makeExporter(root.Reflect, exporter);
      }
      factory(exporter);
      function makeExporter(target, previous) {
        return function(key, value) {
          if (typeof target[key] !== "function") {
            Object.defineProperty(target, key, { configurable: true, writable: true, value });
          }
          if (previous)
            previous(key, value);
        };
      }
    })(function(exporter) {
      var hasOwn2 = Object.prototype.hasOwnProperty;
      var supportsSymbol = typeof Symbol === "function";
      var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
      var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
      var supportsCreate = typeof Object.create === "function";
      var supportsProto = { __proto__: [] } instanceof Array;
      var downLevel = !supportsCreate && !supportsProto;
      var HashMap = {
        // create an object in dictionary mode (a.k.a. "slow" mode in v8)
        create: supportsCreate ? function() {
          return MakeDictionary(/* @__PURE__ */ Object.create(null));
        } : supportsProto ? function() {
          return MakeDictionary({ __proto__: null });
        } : function() {
          return MakeDictionary({});
        },
        has: downLevel ? function(map, key) {
          return hasOwn2.call(map, key);
        } : function(map, key) {
          return key in map;
        },
        get: downLevel ? function(map, key) {
          return hasOwn2.call(map, key) ? map[key] : void 0;
        } : function(map, key) {
          return map[key];
        }
      };
      var functionPrototype = Object.getPrototypeOf(Function);
      var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
      var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
      var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
      var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
      var Metadata = new _WeakMap();
      function decorate(decorators, target, propertyKey, attributes2) {
        if (!IsUndefined(propertyKey)) {
          if (!IsArray(decorators))
            throw new TypeError();
          if (!IsObject(target))
            throw new TypeError();
          if (!IsObject(attributes2) && !IsUndefined(attributes2) && !IsNull(attributes2))
            throw new TypeError();
          if (IsNull(attributes2))
            attributes2 = void 0;
          propertyKey = ToPropertyKey(propertyKey);
          return DecorateProperty(decorators, target, propertyKey, attributes2);
        } else {
          if (!IsArray(decorators))
            throw new TypeError();
          if (!IsConstructor(target))
            throw new TypeError();
          return DecorateConstructor(decorators, target);
        }
      }
      exporter("decorate", decorate);
      function metadata(metadataKey, metadataValue) {
        function decorator(target, propertyKey) {
          if (!IsObject(target))
            throw new TypeError();
          if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
            throw new TypeError();
          OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        return decorator;
      }
      exporter("metadata", metadata);
      function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
      }
      exporter("defineMetadata", defineMetadata);
      function hasMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasMetadata(metadataKey, target, propertyKey);
      }
      exporter("hasMetadata", hasMetadata);
      function hasOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
      }
      exporter("hasOwnMetadata", hasOwnMetadata);
      function getMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetMetadata(metadataKey, target, propertyKey);
      }
      exporter("getMetadata", getMetadata);
      function getOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
      }
      exporter("getOwnMetadata", getOwnMetadata);
      function getMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryMetadataKeys(target, propertyKey);
      }
      exporter("getMetadataKeys", getMetadataKeys);
      function getOwnMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryOwnMetadataKeys(target, propertyKey);
      }
      exporter("getOwnMetadataKeys", getOwnMetadataKeys);
      function deleteMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
          throw new TypeError();
        if (!IsUndefined(propertyKey))
          propertyKey = ToPropertyKey(propertyKey);
        var metadataMap = GetOrCreateMetadataMap(
          target,
          propertyKey,
          /*Create*/
          false
        );
        if (IsUndefined(metadataMap))
          return false;
        if (!metadataMap.delete(metadataKey))
          return false;
        if (metadataMap.size > 0)
          return true;
        var targetMetadata = Metadata.get(target);
        targetMetadata.delete(propertyKey);
        if (targetMetadata.size > 0)
          return true;
        Metadata.delete(target);
        return true;
      }
      exporter("deleteMetadata", deleteMetadata);
      function DecorateConstructor(decorators, target) {
        for (var i = decorators.length - 1; i >= 0; --i) {
          var decorator = decorators[i];
          var decorated = decorator(target);
          if (!IsUndefined(decorated) && !IsNull(decorated)) {
            if (!IsConstructor(decorated))
              throw new TypeError();
            target = decorated;
          }
        }
        return target;
      }
      function DecorateProperty(decorators, target, propertyKey, descriptor) {
        for (var i = decorators.length - 1; i >= 0; --i) {
          var decorator = decorators[i];
          var decorated = decorator(target, propertyKey, descriptor);
          if (!IsUndefined(decorated) && !IsNull(decorated)) {
            if (!IsObject(decorated))
              throw new TypeError();
            descriptor = decorated;
          }
        }
        return descriptor;
      }
      function GetOrCreateMetadataMap(O, P, Create) {
        var targetMetadata = Metadata.get(O);
        if (IsUndefined(targetMetadata)) {
          if (!Create)
            return void 0;
          targetMetadata = new _Map();
          Metadata.set(O, targetMetadata);
        }
        var metadataMap = targetMetadata.get(P);
        if (IsUndefined(metadataMap)) {
          if (!Create)
            return void 0;
          metadataMap = new _Map();
          targetMetadata.set(P, metadataMap);
        }
        return metadataMap;
      }
      function OrdinaryHasMetadata(MetadataKey, O, P) {
        var hasOwn3 = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn3)
          return true;
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
          return OrdinaryHasMetadata(MetadataKey, parent, P);
        return false;
      }
      function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(
          O,
          P,
          /*Create*/
          false
        );
        if (IsUndefined(metadataMap))
          return false;
        return ToBoolean(metadataMap.has(MetadataKey));
      }
      function OrdinaryGetMetadata(MetadataKey, O, P) {
        var hasOwn3 = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn3)
          return OrdinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
          return OrdinaryGetMetadata(MetadataKey, parent, P);
        return void 0;
      }
      function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(
          O,
          P,
          /*Create*/
          false
        );
        if (IsUndefined(metadataMap))
          return void 0;
        return metadataMap.get(MetadataKey);
      }
      function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
        var metadataMap = GetOrCreateMetadataMap(
          O,
          P,
          /*Create*/
          true
        );
        metadataMap.set(MetadataKey, MetadataValue);
      }
      function OrdinaryMetadataKeys(O, P) {
        var ownKeys2 = OrdinaryOwnMetadataKeys(O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (parent === null)
          return ownKeys2;
        var parentKeys = OrdinaryMetadataKeys(parent, P);
        if (parentKeys.length <= 0)
          return ownKeys2;
        if (ownKeys2.length <= 0)
          return parentKeys;
        var set2 = new _Set();
        var keys2 = [];
        for (var _i = 0, ownKeys_1 = ownKeys2; _i < ownKeys_1.length; _i++) {
          var key = ownKeys_1[_i];
          var hasKey = set2.has(key);
          if (!hasKey) {
            set2.add(key);
            keys2.push(key);
          }
        }
        for (var _a2 = 0, parentKeys_1 = parentKeys; _a2 < parentKeys_1.length; _a2++) {
          var key = parentKeys_1[_a2];
          var hasKey = set2.has(key);
          if (!hasKey) {
            set2.add(key);
            keys2.push(key);
          }
        }
        return keys2;
      }
      function OrdinaryOwnMetadataKeys(O, P) {
        var keys2 = [];
        var metadataMap = GetOrCreateMetadataMap(
          O,
          P,
          /*Create*/
          false
        );
        if (IsUndefined(metadataMap))
          return keys2;
        var keysObj = metadataMap.keys();
        var iterator = GetIterator(keysObj);
        var k = 0;
        while (true) {
          var next4 = IteratorStep(iterator);
          if (!next4) {
            keys2.length = k;
            return keys2;
          }
          var nextValue = IteratorValue(next4);
          try {
            keys2[k] = nextValue;
          } catch (e) {
            try {
              IteratorClose(iterator);
            } finally {
              throw e;
            }
          }
          k++;
        }
      }
      function Type(x) {
        if (x === null)
          return 1;
        switch (typeof x) {
          case "undefined":
            return 0;
          case "boolean":
            return 2;
          case "string":
            return 3;
          case "symbol":
            return 4;
          case "number":
            return 5;
          case "object":
            return x === null ? 1 : 6;
          default:
            return 6;
        }
      }
      function IsUndefined(x) {
        return x === void 0;
      }
      function IsNull(x) {
        return x === null;
      }
      function IsSymbol(x) {
        return typeof x === "symbol";
      }
      function IsObject(x) {
        return typeof x === "object" ? x !== null : typeof x === "function";
      }
      function ToPrimitive(input2, PreferredType) {
        switch (Type(input2)) {
          case 0:
            return input2;
          case 1:
            return input2;
          case 2:
            return input2;
          case 3:
            return input2;
          case 4:
            return input2;
          case 5:
            return input2;
        }
        var hint = "string";
        var exoticToPrim = GetMethod(input2, toPrimitiveSymbol);
        if (exoticToPrim !== void 0) {
          var result = exoticToPrim.call(input2, hint);
          if (IsObject(result))
            throw new TypeError();
          return result;
        }
        return OrdinaryToPrimitive(input2);
      }
      function OrdinaryToPrimitive(O, hint) {
        var valueOf, result, toString_2;
        {
          var toString_1 = O.toString;
          if (IsCallable(toString_1)) {
            var result = toString_1.call(O);
            if (!IsObject(result))
              return result;
          }
          var valueOf = O.valueOf;
          if (IsCallable(valueOf)) {
            var result = valueOf.call(O);
            if (!IsObject(result))
              return result;
          }
        }
        throw new TypeError();
      }
      function ToBoolean(argument) {
        return !!argument;
      }
      function ToString(argument) {
        return "" + argument;
      }
      function ToPropertyKey(argument) {
        var key = ToPrimitive(argument);
        if (IsSymbol(key))
          return key;
        return ToString(key);
      }
      function IsArray(argument) {
        return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
      }
      function IsCallable(argument) {
        return typeof argument === "function";
      }
      function IsConstructor(argument) {
        return typeof argument === "function";
      }
      function IsPropertyKey(argument) {
        switch (Type(argument)) {
          case 3:
            return true;
          case 4:
            return true;
          default:
            return false;
        }
      }
      function GetMethod(V, P) {
        var func = V[P];
        if (func === void 0 || func === null)
          return void 0;
        if (!IsCallable(func))
          throw new TypeError();
        return func;
      }
      function GetIterator(obj) {
        var method4 = GetMethod(obj, iteratorSymbol);
        if (!IsCallable(method4))
          throw new TypeError();
        var iterator = method4.call(obj);
        if (!IsObject(iterator))
          throw new TypeError();
        return iterator;
      }
      function IteratorValue(iterResult) {
        return iterResult.value;
      }
      function IteratorStep(iterator) {
        var result = iterator.next();
        return result.done ? false : result;
      }
      function IteratorClose(iterator) {
        var f = iterator["return"];
        if (f)
          f.call(iterator);
      }
      function OrdinaryGetPrototypeOf(O) {
        var proto2 = Object.getPrototypeOf(O);
        if (typeof O !== "function" || O === functionPrototype)
          return proto2;
        if (proto2 !== functionPrototype)
          return proto2;
        var prototype = O.prototype;
        var prototypeProto = prototype && Object.getPrototypeOf(prototype);
        if (prototypeProto == null || prototypeProto === Object.prototype)
          return proto2;
        var constructor = prototypeProto.constructor;
        if (typeof constructor !== "function")
          return proto2;
        if (constructor === O)
          return proto2;
        return constructor;
      }
      function CreateMapPolyfill() {
        var cacheSentinel = {};
        var arraySentinel = [];
        var MapIterator = (
          /** @class */
          (function() {
            function MapIterator2(keys2, values, selector) {
              this._index = 0;
              this._keys = keys2;
              this._values = values;
              this._selector = selector;
            }
            MapIterator2.prototype["@@iterator"] = function() {
              return this;
            };
            MapIterator2.prototype[iteratorSymbol] = function() {
              return this;
            };
            MapIterator2.prototype.next = function() {
              var index2 = this._index;
              if (index2 >= 0 && index2 < this._keys.length) {
                var result = this._selector(this._keys[index2], this._values[index2]);
                if (index2 + 1 >= this._keys.length) {
                  this._index = -1;
                  this._keys = arraySentinel;
                  this._values = arraySentinel;
                } else {
                  this._index++;
                }
                return { value: result, done: false };
              }
              return { value: void 0, done: true };
            };
            MapIterator2.prototype.throw = function(error2) {
              if (this._index >= 0) {
                this._index = -1;
                this._keys = arraySentinel;
                this._values = arraySentinel;
              }
              throw error2;
            };
            MapIterator2.prototype.return = function(value) {
              if (this._index >= 0) {
                this._index = -1;
                this._keys = arraySentinel;
                this._values = arraySentinel;
              }
              return { value, done: true };
            };
            return MapIterator2;
          })()
        );
        return (
          /** @class */
          (function() {
            function Map2() {
              this._keys = [];
              this._values = [];
              this._cacheKey = cacheSentinel;
              this._cacheIndex = -2;
            }
            Object.defineProperty(Map2.prototype, "size", {
              get: function() {
                return this._keys.length;
              },
              enumerable: true,
              configurable: true
            });
            Map2.prototype.has = function(key) {
              return this._find(
                key,
                /*insert*/
                false
              ) >= 0;
            };
            Map2.prototype.get = function(key) {
              var index2 = this._find(
                key,
                /*insert*/
                false
              );
              return index2 >= 0 ? this._values[index2] : void 0;
            };
            Map2.prototype.set = function(key, value) {
              var index2 = this._find(
                key,
                /*insert*/
                true
              );
              this._values[index2] = value;
              return this;
            };
            Map2.prototype.delete = function(key) {
              var index2 = this._find(
                key,
                /*insert*/
                false
              );
              if (index2 >= 0) {
                var size2 = this._keys.length;
                for (var i = index2 + 1; i < size2; i++) {
                  this._keys[i - 1] = this._keys[i];
                  this._values[i - 1] = this._values[i];
                }
                this._keys.length--;
                this._values.length--;
                if (key === this._cacheKey) {
                  this._cacheKey = cacheSentinel;
                  this._cacheIndex = -2;
                }
                return true;
              }
              return false;
            };
            Map2.prototype.clear = function() {
              this._keys.length = 0;
              this._values.length = 0;
              this._cacheKey = cacheSentinel;
              this._cacheIndex = -2;
            };
            Map2.prototype.keys = function() {
              return new MapIterator(this._keys, this._values, getKey);
            };
            Map2.prototype.values = function() {
              return new MapIterator(this._keys, this._values, getValue3);
            };
            Map2.prototype.entries = function() {
              return new MapIterator(this._keys, this._values, getEntry);
            };
            Map2.prototype["@@iterator"] = function() {
              return this.entries();
            };
            Map2.prototype[iteratorSymbol] = function() {
              return this.entries();
            };
            Map2.prototype._find = function(key, insert) {
              if (this._cacheKey !== key) {
                this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
              }
              if (this._cacheIndex < 0 && insert) {
                this._cacheIndex = this._keys.length;
                this._keys.push(key);
                this._values.push(void 0);
              }
              return this._cacheIndex;
            };
            return Map2;
          })()
        );
        function getKey(key, _2) {
          return key;
        }
        function getValue3(_2, value) {
          return value;
        }
        function getEntry(key, value) {
          return [key, value];
        }
      }
      function CreateSetPolyfill() {
        return (
          /** @class */
          (function() {
            function Set2() {
              this._map = new _Map();
            }
            Object.defineProperty(Set2.prototype, "size", {
              get: function() {
                return this._map.size;
              },
              enumerable: true,
              configurable: true
            });
            Set2.prototype.has = function(value) {
              return this._map.has(value);
            };
            Set2.prototype.add = function(value) {
              return this._map.set(value, value), this;
            };
            Set2.prototype.delete = function(value) {
              return this._map.delete(value);
            };
            Set2.prototype.clear = function() {
              this._map.clear();
            };
            Set2.prototype.keys = function() {
              return this._map.keys();
            };
            Set2.prototype.values = function() {
              return this._map.values();
            };
            Set2.prototype.entries = function() {
              return this._map.entries();
            };
            Set2.prototype["@@iterator"] = function() {
              return this.keys();
            };
            Set2.prototype[iteratorSymbol] = function() {
              return this.keys();
            };
            return Set2;
          })()
        );
      }
      function CreateWeakMapPolyfill() {
        var UUID_SIZE = 16;
        var keys2 = HashMap.create();
        var rootKey = CreateUniqueKey();
        return (
          /** @class */
          (function() {
            function WeakMap2() {
              this._key = CreateUniqueKey();
            }
            WeakMap2.prototype.has = function(target) {
              var table = GetOrCreateWeakMapTable(
                target,
                /*create*/
                false
              );
              return table !== void 0 ? HashMap.has(table, this._key) : false;
            };
            WeakMap2.prototype.get = function(target) {
              var table = GetOrCreateWeakMapTable(
                target,
                /*create*/
                false
              );
              return table !== void 0 ? HashMap.get(table, this._key) : void 0;
            };
            WeakMap2.prototype.set = function(target, value) {
              var table = GetOrCreateWeakMapTable(
                target,
                /*create*/
                true
              );
              table[this._key] = value;
              return this;
            };
            WeakMap2.prototype.delete = function(target) {
              var table = GetOrCreateWeakMapTable(
                target,
                /*create*/
                false
              );
              return table !== void 0 ? delete table[this._key] : false;
            };
            WeakMap2.prototype.clear = function() {
              this._key = CreateUniqueKey();
            };
            return WeakMap2;
          })()
        );
        function CreateUniqueKey() {
          var key;
          do
            key = "@@WeakMap@@" + CreateUUID();
          while (HashMap.has(keys2, key));
          keys2[key] = true;
          return key;
        }
        function GetOrCreateWeakMapTable(target, create) {
          if (!hasOwn2.call(target, rootKey)) {
            if (!create)
              return void 0;
            Object.defineProperty(target, rootKey, { value: HashMap.create() });
          }
          return target[rootKey];
        }
        function FillRandomBytes(buffer, size2) {
          for (var i = 0; i < size2; ++i)
            buffer[i] = Math.random() * 255 | 0;
          return buffer;
        }
        function GenRandomBytes(size2) {
          if (typeof Uint8Array === "function") {
            if (typeof crypto !== "undefined")
              return crypto.getRandomValues(new Uint8Array(size2));
            if (typeof msCrypto !== "undefined")
              return msCrypto.getRandomValues(new Uint8Array(size2));
            return FillRandomBytes(new Uint8Array(size2), size2);
          }
          return FillRandomBytes(new Array(size2), size2);
        }
        function CreateUUID() {
          var data2 = GenRandomBytes(UUID_SIZE);
          data2[6] = data2[6] & 79 | 64;
          data2[8] = data2[8] & 191 | 128;
          var result = "";
          for (var offset = 0; offset < UUID_SIZE; ++offset) {
            var byte = data2[offset];
            if (offset === 4 || offset === 6 || offset === 8)
              result += "-";
            if (byte < 16)
              result += "0";
            result += byte.toString(16).toLowerCase();
          }
          return result;
        }
      }
      function MakeDictionary(obj) {
        obj.__ = void 0;
        delete obj.__;
        return obj;
      }
    });
  })(Reflect2 || (Reflect2 = {}));
  return _Reflect;
}
require_Reflect();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r2:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$1.AsyncMode = l;
  reactIs_production_min$1.ConcurrentMode = m;
  reactIs_production_min$1.ContextConsumer = k;
  reactIs_production_min$1.ContextProvider = h;
  reactIs_production_min$1.Element = c;
  reactIs_production_min$1.ForwardRef = n;
  reactIs_production_min$1.Fragment = e;
  reactIs_production_min$1.Lazy = t;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d;
  reactIs_production_min$1.Profiler = g;
  reactIs_production_min$1.StrictMode = f;
  reactIs_production_min$1.Suspense = p;
  reactIs_production_min$1.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$1.isConcurrentMode = A;
  reactIs_production_min$1.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min$1.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min$1.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$1.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min$1.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min$1.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min$1.isMemo = function(a) {
    return z(a) === r2;
  };
  reactIs_production_min$1.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min$1.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min$1.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min$1.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min$1.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min$1.typeOf = z;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol2 = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE2 = hasSymbol2 ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type4) {
        return typeof type4 === "string" || typeof type4 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type4 === REACT_FRAGMENT_TYPE2 || type4 === REACT_CONCURRENT_MODE_TYPE || type4 === REACT_PROFILER_TYPE || type4 === REACT_STRICT_MODE_TYPE || type4 === REACT_SUSPENSE_TYPE || type4 === REACT_SUSPENSE_LIST_TYPE || typeof type4 === "object" && type4 !== null && (type4.$$typeof === REACT_LAZY_TYPE || type4.$$typeof === REACT_MEMO_TYPE || type4.$$typeof === REACT_PROVIDER_TYPE || type4.$$typeof === REACT_CONTEXT_TYPE || type4.$$typeof === REACT_FORWARD_REF_TYPE || type4.$$typeof === REACT_FUNDAMENTAL_TYPE || type4.$$typeof === REACT_RESPONDER_TYPE || type4.$$typeof === REACT_SCOPE_TYPE || type4.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object4) {
        if (typeof object4 === "object" && object4 !== null) {
          var $$typeof = object4.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type4 = object4.type;
              switch (type4) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE2:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type4;
                default:
                  var $$typeofType = type4 && type4.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE2;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object4) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object4) || typeOf(object4) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object4) {
        return typeOf(object4) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object4) {
        return typeOf(object4) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object4) {
        return typeOf(object4) === REACT_PROVIDER_TYPE;
      }
      function isElement(object4) {
        return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object4) {
        return typeOf(object4) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment2(object4) {
        return typeOf(object4) === REACT_FRAGMENT_TYPE2;
      }
      function isLazy(object4) {
        return typeOf(object4) === REACT_LAZY_TYPE;
      }
      function isMemo(object4) {
        return typeOf(object4) === REACT_MEMO_TYPE;
      }
      function isPortal(object4) {
        return typeOf(object4) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object4) {
        return typeOf(object4) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object4) {
        return typeOf(object4) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object4) {
        return typeOf(object4) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment2;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = requireReactIs_production_min$1();
  } else {
    reactIs$1.exports = requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs$1();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty2 = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf2 = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf2(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys2 = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys2.length; ++i) {
        var key = keys2[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty2(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
function isFunction(arg) {
  return typeof arg === "function";
}
function isObject$1(arg) {
  return arg && typeof arg === "object";
}
function isReactComponent(prototype) {
  return isObject$1(prototype) && isObject$1(prototype.isReactComponent);
}
function isValidMetadata(arg) {
  return isFunction(arg) && [Object, Function, Number, String, Boolean].indexOf(arg) === -1;
}
function getDebugName(value) {
  if (isFunction(value)) {
    return String(value.displayName || value.name);
  }
  if (isObject$1(value) && isFunction(value.constructor)) {
    return String(value.constructor.name);
  }
  return String(value);
}
function logError(message2) {
  try {
    throw new Error(message2);
  } catch (e) {
    console.error(e);
  }
}
function logNotFoundDependency(token2) {
  var name = getDebugName(token2);
  logError(
    "Dependency " + name + " is not found.\nPlease register " + name + " in some Provider e.g.\n@provider([" + name + ", " + name + "])\nclass App extends React.Component { /*...*/ }"
  );
}
function logNotFoundProvider(target) {
  if (isReactComponent(target)) {
    var name_1 = getDebugName(target);
    logError(
      "Provider is not found.\n  Please define Provider and set " + name_1 + ".contextType = InjectorContext e.g.\n  @provider([MyService, MyService])\n  class App extends React.Component { /*...*/ }\n  class " + name_1 + " extends React.Component {\n    static contextType = InjectorContext;\n  }"
    );
  } else {
    logError(
      "Provider is not found.\n  Please define Provider e.g.\n  @provider([MyService, MyService])\n  class App extends React.Component { /*...*/ }"
    );
  }
}
function logInvalidMetadata(target, token2) {
  var tokenName = getDebugName(token2);
  var targetName = getDebugName(target);
  logError(
    tokenName + " is not a valid dependency.\nPlease specify ES6 class as property type e.g.\nclass MyService {}\nclass " + targetName + " {\n  @inject myService: MyService;\n}"
  );
}
var InjectorContext = createContext(null);
var Injector = (
  /** @class */
  (function(_super) {
    __extends(Injector2, _super);
    function Injector2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return Injector2;
  })(Component)
);
function getInjector(target) {
  var injector = target[INJECTOR];
  if (injector) {
    return injector;
  }
  injector = currentInjector || target.context;
  if (injector instanceof Injector) {
    target[INJECTOR] = injector;
    return injector;
  }
  return null;
}
var currentInjector = null;
var INJECTOR = typeof Symbol === "function" ? Symbol() : "__injector__";
function getInstance(injector, token2) {
  if (registrationQueue.length > 0) {
    registrationQueue.forEach(function(registration) {
      registration();
    });
    registrationQueue.length = 0;
  }
  while (injector) {
    var instance = injector._instanceMap.get(token2);
    if (instance !== void 0) {
      return instance;
    }
    var binding = injector._bindingMap.get(token2);
    if (binding) {
      var prevInjector = currentInjector;
      currentInjector = injector;
      try {
        instance = binding(injector);
      } finally {
        currentInjector = prevInjector;
      }
      injector._instanceMap.set(token2, instance);
      return instance;
    }
    injector = injector._parent;
  }
  if (process.env.NODE_ENV !== "production") {
    logNotFoundDependency(token2);
  }
  return void 0;
}
var registrationQueue = [];
function inject(targetOrToken, keyOrToken) {
  if (isFunction(keyOrToken)) {
    return injectFunction(targetOrToken, keyOrToken);
  }
  var token2;
  if (!keyOrToken) {
    token2 = targetOrToken;
    return injectDecorator;
  }
  return injectDecorator(targetOrToken, keyOrToken);
  function injectDecorator(prototype, key) {
    if (process.env.NODE_ENV !== "production") {
      defineContextType(prototype);
    } else {
      prototype.constructor.contextType = InjectorContext;
    }
    if (!token2) {
      token2 = Reflect.getMetadata("design:type", prototype, key);
      if (process.env.NODE_ENV !== "production") {
        if (!isValidMetadata(token2)) {
          logInvalidMetadata(targetOrToken, token2);
        }
      }
    }
    var descriptor = {
      configurable: true,
      enumerable: true,
      get: function() {
        var instance = injectFunction(this, token2);
        Object.defineProperty(this, key, {
          enumerable: true,
          writable: true,
          value: instance
        });
        return instance;
      },
      set: function(instance) {
        Object.defineProperty(this, key, {
          enumerable: true,
          writable: true,
          value: instance
        });
      }
    };
    Object.defineProperty(prototype, key, descriptor);
    return descriptor;
  }
}
function injectFunction(target, token2) {
  var injector = getInjector(target);
  if (process.env.NODE_ENV !== "production") {
    if (!injector) {
      logNotFoundProvider(target);
    }
  }
  return getInstance(injector, token2);
}
function defineContextType(prototype) {
  if (isReactComponent(prototype)) {
    var constructor = prototype.constructor;
    var className_1 = getDebugName(constructor);
    if (constructor.contextType !== InjectorContext) {
      if (constructor.contextType) {
        logError(
          "Decorator tries to overwrite existing " + className_1 + ".contextType"
        );
      } else {
        Object.defineProperty(constructor, "contextType", {
          get: function() {
            return InjectorContext;
          },
          set: function() {
            logError(
              "You are trying to overwrite " + className_1 + ".contextType = InjectorContext"
            );
          }
        });
      }
    }
  }
}
class TypedEvent {
  constructor() {
    this.listeners = [];
    this.listenersOncer = [];
    this.on = (listener) => {
      this.listeners.push(listener);
      return {
        dispose: () => this.off(listener)
      };
    };
    this.once = (listener) => {
      this.listenersOncer.push(listener);
    };
    this.off = (listener) => {
      var callbackIndex = this.listeners.indexOf(listener);
      if (callbackIndex > -1) this.listeners.splice(callbackIndex, 1);
    };
    this.emit = (event) => {
      this.listeners.forEach((listener) => listener(event));
      if (this.listenersOncer.length > 0) {
        this.listenersOncer.forEach((listener) => listener(event));
        this.listenersOncer = [];
      }
    };
    this.pipe = (filter2, listener) => {
      return this.on((e) => filter2(e) && listener(e));
    };
  }
}
var Lang = /* @__PURE__ */ ((Lang2) => {
  Lang2["ru"] = "ru";
  Lang2["en"] = "en";
  Lang2["id"] = "id";
  Lang2["uk"] = "uk";
  Lang2["es"] = "es";
  Lang2["zhtw"] = "zhtw";
  Lang2["zhcn"] = "zhcn";
  return Lang2;
})(Lang || {});
var HttpStatusCode = /* @__PURE__ */ ((HttpStatusCode2) => {
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["Redirect"] = 302] = "Redirect";
  HttpStatusCode2[HttpStatusCode2["BadRequest"] = 400] = "BadRequest";
  HttpStatusCode2[HttpStatusCode2["Unauthorized"] = 401] = "Unauthorized";
  HttpStatusCode2[HttpStatusCode2["Forbidden"] = 403] = "Forbidden";
  HttpStatusCode2[HttpStatusCode2["NotFound"] = 404] = "NotFound";
  HttpStatusCode2[HttpStatusCode2["InternalServerError"] = 500] = "InternalServerError";
  HttpStatusCode2[HttpStatusCode2["TemporarilyDisabled"] = 540] = "TemporarilyDisabled";
  return HttpStatusCode2;
})(HttpStatusCode || {});
var SortingDirection = /* @__PURE__ */ ((SortingDirection2) => {
  SortingDirection2["asc"] = "ASC";
  SortingDirection2["desc"] = "DESC";
  return SortingDirection2;
})(SortingDirection || {});
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["InvalidModel"] = 0] = "InvalidModel";
  ErrorCode2[ErrorCode2["UserNotFound"] = 1] = "UserNotFound";
  ErrorCode2[ErrorCode2["InternalError"] = 2] = "InternalError";
  ErrorCode2[ErrorCode2["MustSpecifyFieldsToSelect"] = 3] = "MustSpecifyFieldsToSelect";
  ErrorCode2[ErrorCode2["IsRequired"] = 4] = "IsRequired";
  ErrorCode2[ErrorCode2["TokenExpired"] = 5] = "TokenExpired";
  ErrorCode2[ErrorCode2["AccessDenied"] = 6] = "AccessDenied";
  ErrorCode2[ErrorCode2["FileNotFound"] = 7] = "FileNotFound";
  ErrorCode2[ErrorCode2["NeedFillField"] = 8] = "NeedFillField";
  ErrorCode2[ErrorCode2["EditingProhibited"] = 9] = "EditingProhibited";
  ErrorCode2[ErrorCode2["LoginFailed"] = 10] = "LoginFailed";
  ErrorCode2[ErrorCode2["RequestLogLevelFailed"] = 11] = "RequestLogLevelFailed";
  ErrorCode2[ErrorCode2["UnknownTimezone"] = 12] = "UnknownTimezone";
  ErrorCode2[ErrorCode2["NumberAttemptsExceeded"] = 13] = "NumberAttemptsExceeded";
  ErrorCode2[ErrorCode2["EmailAlreadyConfirmed"] = 14] = "EmailAlreadyConfirmed";
  ErrorCode2[ErrorCode2["AlreadyExists"] = 15] = "AlreadyExists";
  ErrorCode2[ErrorCode2["EmailAlreadyExists"] = 16] = "EmailAlreadyExists";
  ErrorCode2[ErrorCode2["InvalidDatePeriod"] = 17] = "InvalidDatePeriod";
  ErrorCode2[ErrorCode2["FailedSendEmail"] = 18] = "FailedSendEmail";
  ErrorCode2[ErrorCode2["InvalidEmail"] = 19] = "InvalidEmail";
  ErrorCode2[ErrorCode2["EmailNotConfirmed"] = 20] = "EmailNotConfirmed";
  ErrorCode2[ErrorCode2["EmailNotFound"] = 21] = "EmailNotFound";
  ErrorCode2[ErrorCode2["AlreadyHasDifferentWebhook"] = 27] = "AlreadyHasDifferentWebhook";
  ErrorCode2[ErrorCode2["AlreadyHasBeenChanged"] = 31] = "AlreadyHasBeenChanged";
  ErrorCode2[ErrorCode2["InvalidParameter"] = 1e3] = "InvalidParameter";
  ErrorCode2[ErrorCode2["WrongPassword"] = 1001] = "WrongPassword";
  ErrorCode2[ErrorCode2["PasswordMustBeBetween6And30Characters"] = 1002] = "PasswordMustBeBetween6And30Characters";
  ErrorCode2[ErrorCode2["PasswordAndConfirmationPasswordDoNotMatch"] = 1003] = "PasswordAndConfirmationPasswordDoNotMatch";
  ErrorCode2[ErrorCode2["InvalidRefreshToken"] = 1005] = "InvalidRefreshToken";
  ErrorCode2[ErrorCode2["UserAlreadyExist"] = 1006] = "UserAlreadyExist";
  ErrorCode2[ErrorCode2["InvalidAccessToken"] = 1007] = "InvalidAccessToken";
  ErrorCode2[ErrorCode2["InvalidResetToken"] = 1008] = "InvalidResetToken";
  ErrorCode2[ErrorCode2["SchoolNotFound"] = 1009] = "SchoolNotFound";
  ErrorCode2[ErrorCode2["CannotDeleteOwnerFromSchool"] = 1010] = "CannotDeleteOwnerFromSchool";
  ErrorCode2[ErrorCode2["SchoolPhoneInsufficientFunds"] = 1011] = "SchoolPhoneInsufficientFunds";
  ErrorCode2[ErrorCode2["LockedSchoolAccessDenied"] = 1012] = "LockedSchoolAccessDenied";
  ErrorCode2[ErrorCode2["LockedUserAccessDenied"] = 1013] = "LockedUserAccessDenied";
  ErrorCode2[ErrorCode2["ConfirmCodeSendExceedLimit"] = 1014] = "ConfirmCodeSendExceedLimit";
  ErrorCode2[ErrorCode2["InvalidConfirmCode"] = 1015] = "InvalidConfirmCode";
  ErrorCode2[ErrorCode2["NewPasswordMustBeDifferent"] = 1016] = "NewPasswordMustBeDifferent";
  ErrorCode2[ErrorCode2["ResetPasswordRequired"] = 1017] = "ResetPasswordRequired";
  ErrorCode2[ErrorCode2["SmsRuClientError"] = 1022] = "SmsRuClientError";
  ErrorCode2[ErrorCode2["LocWordAlreadyExist"] = 2001] = "LocWordAlreadyExist";
  ErrorCode2[ErrorCode2["LocWordNotFound"] = 2002] = "LocWordNotFound";
  ErrorCode2[ErrorCode2["LocTranslationNotFound"] = 2003] = "LocTranslationNotFound";
  ErrorCode2[ErrorCode2["LocNeedFillFields"] = 2004] = "LocNeedFillFields";
  ErrorCode2[ErrorCode2["LocLanguageNotFound"] = 2005] = "LocLanguageNotFound";
  ErrorCode2[ErrorCode2["LocWordNeedText"] = 2006] = "LocWordNeedText";
  ErrorCode2[ErrorCode2["LocWordNeedTranslations"] = 2007] = "LocWordNeedTranslations";
  ErrorCode2[ErrorCode2["LocTranslationNeedText"] = 2008] = "LocTranslationNeedText";
  ErrorCode2[ErrorCode2["LocNeedFields"] = 2009] = "LocNeedFields";
  ErrorCode2[ErrorCode2["EmailTemplateNotFound"] = 3001] = "EmailTemplateNotFound";
  ErrorCode2[ErrorCode2["PhoneAlreadyExist"] = 4001] = "PhoneAlreadyExist";
  ErrorCode2[ErrorCode2["InvalidPhone"] = 4002] = "InvalidPhone";
  ErrorCode2[ErrorCode2["PhoneNotVerified"] = 4003] = "PhoneNotVerified";
  ErrorCode2[ErrorCode2["PhoneAlreadyVerified"] = 4004] = "PhoneAlreadyVerified";
  ErrorCode2[ErrorCode2["PhoneCodeSendingLatency"] = 4005] = "PhoneCodeSendingLatency";
  ErrorCode2[ErrorCode2["PhoneBlocked"] = 4006] = "PhoneBlocked";
  ErrorCode2[ErrorCode2["PhoneNotFound"] = 4007] = "PhoneNotFound";
  ErrorCode2[ErrorCode2["WrongPhoneVerificationCode"] = 4008] = "WrongPhoneVerificationCode";
  ErrorCode2[ErrorCode2["SchoolAlreadyExist"] = 5001] = "SchoolAlreadyExist";
  ErrorCode2[ErrorCode2["SchoolAdminNotFound"] = 5002] = "SchoolAdminNotFound";
  ErrorCode2[ErrorCode2["SchoolProfileSettingsNotFound"] = 5003] = "SchoolProfileSettingsNotFound";
  ErrorCode2[ErrorCode2["SchoolStatisticsNotFound"] = 5101] = "SchoolStatisticsNotFound";
  ErrorCode2[ErrorCode2["SchoolBillingNotFound"] = 5201] = "SchoolBillingNotFound";
  ErrorCode2[ErrorCode2["SchoolDomainAlreadyExist"] = 5251] = "SchoolDomainAlreadyExist";
  ErrorCode2[ErrorCode2["CourseNotFound"] = 6001] = "CourseNotFound";
  ErrorCode2[ErrorCode2["CoursePlanNotFound"] = 6002] = "CoursePlanNotFound";
  ErrorCode2[ErrorCode2["CourseCategoryNotFound"] = 6003] = "CourseCategoryNotFound";
  ErrorCode2[ErrorCode2["CourseAlreadyContainsPackage"] = 6005] = "CourseAlreadyContainsPackage";
  ErrorCode2[ErrorCode2["CourseNotFoundPackageLink"] = 6006] = "CourseNotFoundPackageLink";
  ErrorCode2[ErrorCode2["CourseCategoryRequireName"] = 6007] = "CourseCategoryRequireName";
  ErrorCode2[ErrorCode2["CourseAlreadyContainCategory"] = 6008] = "CourseAlreadyContainCategory";
  ErrorCode2[ErrorCode2["CourseNotContainCategory"] = 6009] = "CourseNotContainCategory";
  ErrorCode2[ErrorCode2["CourseItemNotFound"] = 6010] = "CourseItemNotFound";
  ErrorCode2[ErrorCode2["CourseFileBelongsToAnotherCourse"] = 6011] = "CourseFileBelongsToAnotherCourse";
  ErrorCode2[ErrorCode2["CourseItemNotValidPosition"] = 6013] = "CourseItemNotValidPosition";
  ErrorCode2[ErrorCode2["CourseItemAlreadyContainsPlan"] = 6014] = "CourseItemAlreadyContainsPlan";
  ErrorCode2[ErrorCode2["CourseItemNotFoundPlanLink"] = 6015] = "CourseItemNotFoundPlanLink";
  ErrorCode2[ErrorCode2["CourseItemCommentNotFound"] = 6016] = "CourseItemCommentNotFound";
  ErrorCode2[ErrorCode2["CourseItemTaskNotFound"] = 6016] = "CourseItemTaskNotFound";
  ErrorCode2[ErrorCode2["CourseItemTestQuestionNotFound"] = 6017] = "CourseItemTestQuestionNotFound";
  ErrorCode2[ErrorCode2["CourseItemTestAnswerNotFound"] = 6018] = "CourseItemTestAnswerNotFound";
  ErrorCode2[ErrorCode2["CourseItemTestNotFound"] = 6019] = "CourseItemTestNotFound";
  ErrorCode2[ErrorCode2["CourseStudentNotFound"] = 6020] = "CourseStudentNotFound";
  ErrorCode2[ErrorCode2["CourseItemTestQuestionMustHaveCorrectAnswer"] = 6021] = "CourseItemTestQuestionMustHaveCorrectAnswer";
  ErrorCode2[ErrorCode2["CourseItemTaskFieldNotFound"] = 6027] = "CourseItemTaskFieldNotFound";
  ErrorCode2[ErrorCode2["FileInitiateError"] = 7001] = "FileInitiateError";
  ErrorCode2[ErrorCode2["FileUploadError"] = 7002] = "FileUploadError";
  ErrorCode2[ErrorCode2["FileCompleteError"] = 7003] = "FileCompleteError";
  ErrorCode2[ErrorCode2["DirectoryWithSameNameAlreadyExist"] = 7004] = "DirectoryWithSameNameAlreadyExist";
  ErrorCode2[ErrorCode2["DirectoryCannotBeRecursive"] = 7005] = "DirectoryCannotBeRecursive";
  ErrorCode2[ErrorCode2["DirectoryNotFound"] = 7006] = "DirectoryNotFound";
  ErrorCode2[ErrorCode2["FileManagerItemNotFound"] = 7007] = "FileManagerItemNotFound";
  ErrorCode2[ErrorCode2["YouCannotDeleteDirectoryBecauseIsNotEmpty"] = 7008] = "YouCannotDeleteDirectoryBecauseIsNotEmpty";
  ErrorCode2[ErrorCode2["FileWithSameNameAlreadyExist"] = 7009] = "FileWithSameNameAlreadyExist";
  ErrorCode2[ErrorCode2["FileUpdateCannedACLError"] = 7010] = "FileUpdateCannedACLError";
  ErrorCode2[ErrorCode2["FileReplaceExtensionError"] = 7011] = "FileReplaceExtensionError";
  ErrorCode2[ErrorCode2["FileUpdateError"] = 7012] = "FileUpdateError";
  ErrorCode2[ErrorCode2["StudentNotFound"] = 8001] = "StudentNotFound";
  ErrorCode2[ErrorCode2["StudentCourseNotFound"] = 8002] = "StudentCourseNotFound";
  ErrorCode2[ErrorCode2["StudentCourseItemProgressNotFound"] = 8003] = "StudentCourseItemProgressNotFound";
  ErrorCode2[ErrorCode2["StudentCourseItemTaskAnswerNotFound"] = 8004] = "StudentCourseItemTaskAnswerNotFound";
  ErrorCode2[ErrorCode2["StudentCourseStepAccessDenied"] = 8005] = "StudentCourseStepAccessDenied";
  ErrorCode2[ErrorCode2["StudentCourseCannotBeCompleted"] = 8006] = "StudentCourseCannotBeCompleted";
  ErrorCode2[ErrorCode2["StudentCourseItemTaskAnswerCommentNotFound"] = 8007] = "StudentCourseItemTaskAnswerCommentNotFound";
  ErrorCode2[ErrorCode2["StudentCourseItemCommentTimeLimit"] = 8009] = "StudentCourseItemCommentTimeLimit";
  ErrorCode2[ErrorCode2["StudentCourseStartError"] = 8010] = "StudentCourseStartError";
  ErrorCode2[ErrorCode2["StudentNotHaveEmail"] = 8011] = "StudentNotHaveEmail";
  ErrorCode2[ErrorCode2["StudentAlreadyMerging"] = 8012] = "StudentAlreadyMerging";
  ErrorCode2[ErrorCode2["StudentLibraryItemsNotFound"] = 8013] = "StudentLibraryItemsNotFound";
  ErrorCode2[ErrorCode2["StudentCourseHasRequirements"] = 8040] = "StudentCourseHasRequirements";
  ErrorCode2[ErrorCode2["StudentCourseItemsNotFound"] = 8500] = "StudentCourseItemsNotFound";
  ErrorCode2[ErrorCode2["InvalidInviteToken"] = 9001] = "InvalidInviteToken";
  ErrorCode2[ErrorCode2["TagNotFound"] = 10001] = "TagNotFound";
  ErrorCode2[ErrorCode2["TagAlreadyExists"] = 10002] = "TagAlreadyExists";
  ErrorCode2[ErrorCode2["StudentTagLinkNotFound"] = 11001] = "StudentTagLinkNotFound";
  ErrorCode2[ErrorCode2["LeadNotFound"] = 12001] = "LeadNotFound";
  ErrorCode2[ErrorCode2["StudentLicenseNotFound"] = 12003] = "StudentLicenseNotFound";
  ErrorCode2[ErrorCode2["LeadAttributeNotFound"] = 12100] = "LeadAttributeNotFound";
  ErrorCode2[ErrorCode2["LeadAttributeNameAlreadyExists"] = 12101] = "LeadAttributeNameAlreadyExists";
  ErrorCode2[ErrorCode2["LeadAttributeKeyNameAlreadyExists"] = 12102] = "LeadAttributeKeyNameAlreadyExists";
  ErrorCode2[ErrorCode2["LeadAttributeKeyNameBusyBySystem"] = 12103] = "LeadAttributeKeyNameBusyBySystem";
  ErrorCode2[ErrorCode2["FlowNotFound"] = 13001] = "FlowNotFound";
  ErrorCode2[ErrorCode2["FlowDateNotFound"] = 13002] = "FlowDateNotFound";
  ErrorCode2[ErrorCode2["AdminNotFound"] = 14001] = "AdminNotFound";
  ErrorCode2[ErrorCode2["AdminResponsibleNotFound"] = 14002] = "AdminResponsibleNotFound";
  ErrorCode2[ErrorCode2["AdminResponsibleFromUserExists"] = 14011] = "AdminResponsibleFromUserExists";
  ErrorCode2[ErrorCode2["AdminCRMSettingsNotFound"] = 14050] = "AdminCRMSettingsNotFound";
  ErrorCode2[ErrorCode2["AdminPartnerTariffNotFound"] = 14100] = "AdminPartnerTariffNotFound";
  ErrorCode2[ErrorCode2["AdminPartnerTariffAlreadyExists"] = 14101] = "AdminPartnerTariffAlreadyExists";
  ErrorCode2[ErrorCode2["AdminPartnerTransactionNotFound"] = 14200] = "AdminPartnerTransactionNotFound";
  ErrorCode2[ErrorCode2["AdminPartnerTransactionInsufficientFunds"] = 14201] = "AdminPartnerTransactionInsufficientFunds";
  ErrorCode2[ErrorCode2["CRMImportInvalidFile"] = 15001] = "CRMImportInvalidFile";
  ErrorCode2[ErrorCode2["CRMImportInvalidText"] = 15002] = "CRMImportInvalidText";
  ErrorCode2[ErrorCode2["CRMImportNoRowsFound"] = 15003] = "CRMImportNoRowsFound";
  ErrorCode2[ErrorCode2["CRMImportError"] = 15004] = "CRMImportError";
  ErrorCode2[ErrorCode2["CRMImportInvalidRow"] = 15005] = "CRMImportInvalidRow";
  ErrorCode2[ErrorCode2["CRMImportFieldInvalidPattern"] = 15006] = "CRMImportFieldInvalidPattern";
  ErrorCode2[ErrorCode2["CRMImportEmailRequired"] = 15007] = "CRMImportEmailRequired";
  ErrorCode2[ErrorCode2["CRMImportInvalidFieldCast"] = 15008] = "CRMImportInvalidFieldCast";
  ErrorCode2[ErrorCode2["CRMImportRequiredFields"] = 15012] = "CRMImportRequiredFields";
  ErrorCode2[ErrorCode2["ForumThreadNotFound"] = 17001] = "ForumThreadNotFound";
  ErrorCode2[ErrorCode2["ForumThreadCannotDeleteWhileHasNestedThreads"] = 17002] = "ForumThreadCannotDeleteWhileHasNestedThreads";
  ErrorCode2[ErrorCode2["ForumAccessDenied"] = 17003] = "ForumAccessDenied";
  ErrorCode2[ErrorCode2["ForumThreadModeratorNotFound"] = 17100] = "ForumThreadModeratorNotFound";
  ErrorCode2[ErrorCode2["ForumTopicNotFound"] = 17200] = "ForumTopicNotFound";
  ErrorCode2[ErrorCode2["ForumTopicCommentNotFound"] = 17201] = "ForumTopicCommentNotFound";
  ErrorCode2[ErrorCode2["ForumReactionNotFound"] = 17300] = "ForumReactionNotFound";
  ErrorCode2[ErrorCode2["ForumSubscriptionNotFound"] = 17400] = "ForumSubscriptionNotFound";
  ErrorCode2[ErrorCode2["ForumUnableCreateTopic"] = 17451] = "ForumUnableCreateTopic";
  ErrorCode2[ErrorCode2["ForumUnableEditTopic"] = 17452] = "ForumUnableEditTopic";
  ErrorCode2[ErrorCode2["ForumUnableEditTopicComment"] = 17453] = "ForumUnableEditTopicComment";
  ErrorCode2[ErrorCode2["ForumUnableCreateTopicTooOften"] = 17454] = "ForumUnableCreateTopicTooOften";
  ErrorCode2[ErrorCode2["ForumBanNotFound"] = 17800] = "ForumBanNotFound";
  ErrorCode2[ErrorCode2["ForumBanAccessDenied"] = 17801] = "ForumBanAccessDenied";
  ErrorCode2[ErrorCode2["ChatConversationNotFound"] = 18001] = "ChatConversationNotFound";
  ErrorCode2[ErrorCode2["ChatCurrentContactNotFound"] = 18002] = "ChatCurrentContactNotFound";
  ErrorCode2[ErrorCode2["ChatContactNotFound"] = 18003] = "ChatContactNotFound";
  ErrorCode2[ErrorCode2["ChatDepartmentNotFound"] = 18004] = "ChatDepartmentNotFound";
  ErrorCode2[ErrorCode2["ChatConversationMemberNotFound"] = 18005] = "ChatConversationMemberNotFound";
  ErrorCode2[ErrorCode2["ChatMessageNotFound"] = 18006] = "ChatMessageNotFound";
  ErrorCode2[ErrorCode2["ChatMessageCouldntBeEmpty"] = 18007] = "ChatMessageCouldntBeEmpty";
  ErrorCode2[ErrorCode2["ChatConversationWrongType"] = 18008] = "ChatConversationWrongType";
  ErrorCode2[ErrorCode2["ChatConversationWrongContactCount"] = 18009] = "ChatConversationWrongContactCount";
  ErrorCode2[ErrorCode2["EmailProfileNotFound"] = 19001] = "EmailProfileNotFound";
  ErrorCode2[ErrorCode2["EmailProfileFailedDeletePrimary"] = 19002] = "EmailProfileFailedDeletePrimary";
  ErrorCode2[ErrorCode2["EmailProfileFailedDeleteActive"] = 19003] = "EmailProfileFailedDeleteActive";
  ErrorCode2[ErrorCode2["EmailProfileTestFailed"] = 19004] = "EmailProfileTestFailed";
  ErrorCode2[ErrorCode2["ExtendedFilterNotFound"] = 20001] = "ExtendedFilterNotFound";
  ErrorCode2[ErrorCode2["EmailDomainNotFound"] = 21001] = "EmailDomainNotFound";
  ErrorCode2[ErrorCode2["EmailDomainFailedDelete"] = 21002] = "EmailDomainFailedDelete";
  ErrorCode2[ErrorCode2["EmailDomainFailedAdd"] = 21003] = "EmailDomainFailedAdd";
  ErrorCode2[ErrorCode2["EmailDomainFailedVerify"] = 21004] = "EmailDomainFailedVerify";
  ErrorCode2[ErrorCode2["EmailDomainNeedVerify"] = 21005] = "EmailDomainNeedVerify";
  ErrorCode2[ErrorCode2["EmailDomainWaitRegistration"] = 21007] = "EmailDomainWaitRegistration";
  ErrorCode2[ErrorCode2["EmailMessageNotFound"] = 25001] = "EmailMessageNotFound";
  ErrorCode2[ErrorCode2["EmailMessageBlockedEmails"] = 25002] = "EmailMessageBlockedEmails";
  ErrorCode2[ErrorCode2["EmailMessageNotEnoughDataToSend"] = 25003] = "EmailMessageNotEnoughDataToSend";
  ErrorCode2[ErrorCode2["EmailMessageAttachmentsSizeExceeded"] = 25004] = "EmailMessageAttachmentsSizeExceeded";
  ErrorCode2[ErrorCode2["EmailMessageExceedLimit"] = 25006] = "EmailMessageExceedLimit";
  ErrorCode2[ErrorCode2["CallAccountAlreadyInUse"] = 27015] = "CallAccountAlreadyInUse";
  ErrorCode2[ErrorCode2["CallAccountCantSetWebhookUrl"] = 27016] = "CallAccountCantSetWebhookUrl";
  ErrorCode2[ErrorCode2["LibraryNotFound"] = 29001] = "LibraryNotFound";
  ErrorCode2[ErrorCode2["LibraryItemNotFound"] = 29501] = "LibraryItemNotFound";
  ErrorCode2[ErrorCode2["LibraryItemAccessDenied"] = 29502] = "LibraryItemAccessDenied";
  ErrorCode2[ErrorCode2["ProductPackageNotFound"] = 30001] = "ProductPackageNotFound";
  ErrorCode2[ErrorCode2["SiteNotFound"] = 31001] = "SiteNotFound";
  ErrorCode2[ErrorCode2["SiteAlreadyExists"] = 31002] = "SiteAlreadyExists";
  ErrorCode2[ErrorCode2["SitePageNotFound"] = 31003] = "SitePageNotFound";
  ErrorCode2[ErrorCode2["SitePageAlreadyExists"] = 31004] = "SitePageAlreadyExists";
  ErrorCode2[ErrorCode2["SiteDomainNotFound"] = 31005] = "SiteDomainNotFound";
  ErrorCode2[ErrorCode2["SiteDomainAlreadyExists"] = 31006] = "SiteDomainAlreadyExists";
  ErrorCode2[ErrorCode2["SiteMenuItemAlreadyExists"] = 31007] = "SiteMenuItemAlreadyExists";
  ErrorCode2[ErrorCode2["SiteMenuItemNotFound"] = 31008] = "SiteMenuItemNotFound";
  ErrorCode2[ErrorCode2["ProductNotFound"] = 33001] = "ProductNotFound";
  ErrorCode2[ErrorCode2["ProductImageLinkNotFound"] = 33002] = "ProductImageLinkNotFound";
  ErrorCode2[ErrorCode2["ProductContentAlreadyExists"] = 33100] = "ProductContentAlreadyExists";
  ErrorCode2[ErrorCode2["WebinarNotFound"] = 38001] = "WebinarNotFound";
  ErrorCode2[ErrorCode2["WebinarShortNameAlreadyExist"] = 38003] = "WebinarShortNameAlreadyExist";
  ErrorCode2[ErrorCode2["WebinarScheduleInvalid"] = 38004] = "WebinarScheduleInvalid";
  ErrorCode2[ErrorCode2["WebinarImportEventInvalidFileFormat"] = 38451] = "WebinarImportEventInvalidFileFormat";
  ErrorCode2[ErrorCode2["WebinarImportEventInvalidEventFormat"] = 38452] = "WebinarImportEventInvalidEventFormat";
  ErrorCode2[ErrorCode2["ChatChannelNotFound"] = 41001] = "ChatChannelNotFound";
  ErrorCode2[ErrorCode2["ChatChannelResponseTimeLimitExceeded"] = 41002] = "ChatChannelResponseTimeLimitExceeded";
  ErrorCode2[ErrorCode2["BulkActionRegisterWebinarMaxSizeExceeded"] = 44001] = "BulkActionRegisterWebinarMaxSizeExceeded";
  ErrorCode2[ErrorCode2["DocumentNotFound"] = 45001] = "DocumentNotFound";
  ErrorCode2[ErrorCode2["DocumentContentNotFound"] = 45100] = "DocumentContentNotFound";
  ErrorCode2[ErrorCode2["DocumentUrlAlreadyExists"] = 45200] = "DocumentUrlAlreadyExists";
  ErrorCode2[ErrorCode2["DocumentTitleAlreadyExists"] = 45300] = "DocumentTitleAlreadyExists";
  ErrorCode2[ErrorCode2["BillingPlanNotFound"] = 49001] = "BillingPlanNotFound";
  ErrorCode2[ErrorCode2["BillingPlanNameAlreadyExists"] = 49002] = "BillingPlanNameAlreadyExists";
  ErrorCode2[ErrorCode2["BillingPaymentMethodNotFound"] = 49100] = "BillingPaymentMethodNotFound";
  ErrorCode2[ErrorCode2["BillingPaymentNotFound"] = 49200] = "BillingPaymentNotFound";
  ErrorCode2[ErrorCode2["BillingPaymentFailed"] = 49201] = "BillingPaymentFailed";
  ErrorCode2[ErrorCode2["BillingInvoiceNotFound"] = 49301] = "BillingInvoiceNotFound";
  ErrorCode2[ErrorCode2["BillingCurrencyExchangeRateChanged"] = 49401] = "BillingCurrencyExchangeRateChanged";
  ErrorCode2[ErrorCode2["RequisiteNotFound"] = 52001] = "RequisiteNotFound";
  ErrorCode2[ErrorCode2["RequisiteAlreadyExists"] = 52002] = "RequisiteAlreadyExists";
  ErrorCode2[ErrorCode2["PipelineNotFound"] = 53001] = "PipelineNotFound";
  ErrorCode2[ErrorCode2["PipelineStageNotFound"] = 53050] = "PipelineStageNotFound";
  ErrorCode2[ErrorCode2["PipelineStageItemNotFound"] = 53100] = "PipelineStageItemNotFound";
  ErrorCode2[ErrorCode2["PipelineTagNotFound"] = 53150] = "PipelineTagNotFound";
  ErrorCode2[ErrorCode2["PipelineFieldNotFound"] = 53200] = "PipelineFieldNotFound";
  ErrorCode2[ErrorCode2["PipelineFieldValueUpdatedFailed"] = 53201] = "PipelineFieldValueUpdatedFailed";
  ErrorCode2[ErrorCode2["PipelineFieldKeyAlreadyExists"] = 53202] = "PipelineFieldKeyAlreadyExists";
  ErrorCode2[ErrorCode2["PipelineFieldRequired"] = 53203] = "PipelineFieldRequired";
  ErrorCode2[ErrorCode2["PipelineItemNotFound"] = 53301] = "PipelineItemNotFound";
  ErrorCode2[ErrorCode2["ApplicationNotFound"] = 54001] = "ApplicationNotFound";
  ErrorCode2[ErrorCode2["ApplicationCantHasMultipleInstance"] = 54002] = "ApplicationCantHasMultipleInstance";
  ErrorCode2[ErrorCode2["ApplicationSchoolLinkNotFound"] = 54101] = "ApplicationSchoolLinkNotFound";
  ErrorCode2[ErrorCode2["ApplicationSchoolLinkCantBeRestored"] = 54102] = "ApplicationSchoolLinkCantBeRestored";
  ErrorCode2[ErrorCode2["TelegramGroupNotFound"] = 54201] = "TelegramGroupNotFound";
  ErrorCode2[ErrorCode2["TelegramGroupCantRegistered"] = 54202] = "TelegramGroupCantRegistered";
  ErrorCode2[ErrorCode2["TelegramGroupUserNotFound"] = 54301] = "TelegramGroupUserNotFound";
  ErrorCode2[ErrorCode2["TelegramGroupCannotDeleteOwnerFromGroup"] = 54302] = "TelegramGroupCannotDeleteOwnerFromGroup";
  ErrorCode2[ErrorCode2["TelegramGroupCannotUpdateOwner"] = 54303] = "TelegramGroupCannotUpdateOwner";
  ErrorCode2[ErrorCode2["TelegramGroupCannotDeleteAdminFromGroup"] = 54304] = "TelegramGroupCannotDeleteAdminFromGroup";
  ErrorCode2[ErrorCode2["MetaConversionCantRegistered"] = 54350] = "MetaConversionCantRegistered";
  ErrorCode2[ErrorCode2["TelegramGroupApproveChatJoinRequest"] = 54401] = "TelegramGroupApproveChatJoinRequest";
  ErrorCode2[ErrorCode2["TelegramGroupDeclineChatJoinRequest"] = 54402] = "TelegramGroupDeclineChatJoinRequest";
  ErrorCode2[ErrorCode2["YandexMetrikaGoalNotFound"] = 54501] = "YandexMetrikaGoalNotFound";
  ErrorCode2[ErrorCode2["YandexMetrikaAuthError"] = 54502] = "YandexMetrikaAuthError";
  ErrorCode2[ErrorCode2["YandexMetrikaExportError"] = 54503] = "YandexMetrikaExportError";
  ErrorCode2[ErrorCode2["YandexMetrikaImportError"] = 54504] = "YandexMetrikaImportError";
  ErrorCode2[ErrorCode2["GlossaryNotFound"] = 55001] = "GlossaryNotFound";
  ErrorCode2[ErrorCode2["GlossaryAlreadyExists"] = 55002] = "GlossaryAlreadyExists";
  ErrorCode2[ErrorCode2["GlossaryWordsCountExceeded"] = 55003] = "GlossaryWordsCountExceeded";
  ErrorCode2[ErrorCode2["GlobalVariableNotFound"] = 56001] = "GlobalVariableNotFound";
  ErrorCode2[ErrorCode2["WebhookNumberAttemptsExceeded"] = 57001] = "WebhookNumberAttemptsExceeded";
  ErrorCode2[ErrorCode2["PartnershipNotFound"] = 58001] = "PartnershipNotFound";
  ErrorCode2[ErrorCode2["PartnershipAlreadyExists"] = 58002] = "PartnershipAlreadyExists";
  ErrorCode2[ErrorCode2["PartnershipInsufficientFunds"] = 58003] = "PartnershipInsufficientFunds";
  ErrorCode2[ErrorCode2["PartnershipTransferMinFeeAmountRestrictions"] = 58004] = "PartnershipTransferMinFeeAmountRestrictions";
  ErrorCode2[ErrorCode2["PartnershipMemberNotFound"] = 58050] = "PartnershipMemberNotFound";
  ErrorCode2[ErrorCode2["PartnershipTransactionNotFound"] = 58100] = "PartnershipTransactionNotFound";
  ErrorCode2[ErrorCode2["PartnershipOfferNotFound"] = 58200] = "PartnershipOfferNotFound";
  ErrorCode2[ErrorCode2["PartnershipOfferWithSameProductAlreadyExists"] = 58201] = "PartnershipOfferWithSameProductAlreadyExists";
  ErrorCode2[ErrorCode2["PartnershipTransactionRequestNotFound"] = 58251] = "PartnershipTransactionRequestNotFound";
  ErrorCode2[ErrorCode2["SharedSettingsExportNotFound"] = 59001] = "SharedSettingsExportNotFound";
  ErrorCode2[ErrorCode2["SharedSettingsReexportProhibited"] = 59002] = "SharedSettingsReexportProhibited";
  ErrorCode2[ErrorCode2["SharedSettingsImportNotFound"] = 59100] = "SharedSettingsImportNotFound";
  ErrorCode2[ErrorCode2["CaptchaNeedSend"] = 70001] = "CaptchaNeedSend";
  return ErrorCode2;
})(ErrorCode || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["USD"] = "usd";
  Currency2["EUR"] = "eur";
  Currency2["RUB"] = "rub";
  Currency2["IDR"] = "idr";
  Currency2["UAH"] = "uah";
  Currency2["BYN"] = "byn";
  Currency2["KZT"] = "kzt";
  Currency2["TWD"] = "twd";
  Currency2["TRY"] = "try";
  Currency2["ARS"] = "ars";
  Currency2["AUD"] = "aud";
  Currency2["BGN"] = "bgn";
  Currency2["BRL"] = "brl";
  Currency2["CLP"] = "clp";
  Currency2["COP"] = "cop";
  Currency2["MXN"] = "mxn";
  Currency2["PEN"] = "pen";
  Currency2["UYU"] = "uyu";
  Currency2["GBP"] = "gbp";
  Currency2["MYR"] = "myr";
  Currency2["CAD"] = "cad";
  return Currency2;
})(Currency || {});
var KeyCode$1 = /* @__PURE__ */ ((KeyCode2) => {
  KeyCode2[KeyCode2["Backspace"] = 8] = "Backspace";
  KeyCode2[KeyCode2["Tab"] = 9] = "Tab";
  KeyCode2[KeyCode2["Enter"] = 13] = "Enter";
  KeyCode2[KeyCode2["Shift"] = 16] = "Shift";
  KeyCode2[KeyCode2["Ctrl"] = 17] = "Ctrl";
  KeyCode2[KeyCode2["Alt"] = 18] = "Alt";
  KeyCode2[KeyCode2["PauseBreak"] = 19] = "PauseBreak";
  KeyCode2[KeyCode2["CapsLock"] = 20] = "CapsLock";
  KeyCode2[KeyCode2["Escape"] = 27] = "Escape";
  KeyCode2[KeyCode2["Space"] = 32] = "Space";
  KeyCode2[KeyCode2["PageUp"] = 33] = "PageUp";
  KeyCode2[KeyCode2["PageDown"] = 34] = "PageDown";
  KeyCode2[KeyCode2["End"] = 35] = "End";
  KeyCode2[KeyCode2["Home"] = 36] = "Home";
  KeyCode2[KeyCode2["LeftArrow"] = 37] = "LeftArrow";
  KeyCode2[KeyCode2["UpArrow"] = 38] = "UpArrow";
  KeyCode2[KeyCode2["RightArrow"] = 39] = "RightArrow";
  KeyCode2[KeyCode2["DownArrow"] = 40] = "DownArrow";
  KeyCode2[KeyCode2["Insert"] = 45] = "Insert";
  KeyCode2[KeyCode2["Delete"] = 46] = "Delete";
  KeyCode2[KeyCode2["A"] = 65] = "A";
  KeyCode2[KeyCode2["B"] = 66] = "B";
  KeyCode2[KeyCode2["C"] = 67] = "C";
  KeyCode2[KeyCode2["D"] = 68] = "D";
  KeyCode2[KeyCode2["E"] = 69] = "E";
  KeyCode2[KeyCode2["F"] = 70] = "F";
  KeyCode2[KeyCode2["G"] = 71] = "G";
  KeyCode2[KeyCode2["H"] = 72] = "H";
  KeyCode2[KeyCode2["I"] = 73] = "I";
  KeyCode2[KeyCode2["J"] = 74] = "J";
  KeyCode2[KeyCode2["K"] = 75] = "K";
  KeyCode2[KeyCode2["L"] = 76] = "L";
  KeyCode2[KeyCode2["M"] = 77] = "M";
  KeyCode2[KeyCode2["N"] = 78] = "N";
  KeyCode2[KeyCode2["O"] = 79] = "O";
  KeyCode2[KeyCode2["P"] = 80] = "P";
  KeyCode2[KeyCode2["Q"] = 81] = "Q";
  KeyCode2[KeyCode2["R"] = 82] = "R";
  KeyCode2[KeyCode2["S"] = 83] = "S";
  KeyCode2[KeyCode2["T"] = 84] = "T";
  KeyCode2[KeyCode2["U"] = 85] = "U";
  KeyCode2[KeyCode2["V"] = 86] = "V";
  KeyCode2[KeyCode2["W"] = 87] = "W";
  KeyCode2[KeyCode2["X"] = 88] = "X";
  KeyCode2[KeyCode2["Y"] = 89] = "Y";
  KeyCode2[KeyCode2["Z"] = 90] = "Z";
  KeyCode2[KeyCode2["Numpad0"] = 96] = "Numpad0";
  KeyCode2[KeyCode2["Numpad1"] = 97] = "Numpad1";
  KeyCode2[KeyCode2["Numpad2"] = 98] = "Numpad2";
  KeyCode2[KeyCode2["Numpad3"] = 99] = "Numpad3";
  KeyCode2[KeyCode2["Numpad4"] = 100] = "Numpad4";
  KeyCode2[KeyCode2["Numpad5"] = 101] = "Numpad5";
  KeyCode2[KeyCode2["Numpad6"] = 102] = "Numpad6";
  KeyCode2[KeyCode2["Numpad7"] = 103] = "Numpad7";
  KeyCode2[KeyCode2["Numpad8"] = 104] = "Numpad8";
  KeyCode2[KeyCode2["Numpad9"] = 105] = "Numpad9";
  KeyCode2[KeyCode2["Multiply"] = 106] = "Multiply";
  KeyCode2[KeyCode2["Add"] = 107] = "Add";
  KeyCode2[KeyCode2["Subtract"] = 109] = "Subtract";
  KeyCode2[KeyCode2["DecimalPoint"] = 110] = "DecimalPoint";
  KeyCode2[KeyCode2["Divide"] = 111] = "Divide";
  KeyCode2[KeyCode2["F1"] = 112] = "F1";
  KeyCode2[KeyCode2["F2"] = 113] = "F2";
  KeyCode2[KeyCode2["F3"] = 114] = "F3";
  KeyCode2[KeyCode2["F4"] = 115] = "F4";
  KeyCode2[KeyCode2["F5"] = 116] = "F5";
  KeyCode2[KeyCode2["F6"] = 117] = "F6";
  KeyCode2[KeyCode2["F7"] = 118] = "F7";
  KeyCode2[KeyCode2["F8"] = 119] = "F8";
  KeyCode2[KeyCode2["F9"] = 120] = "F9";
  KeyCode2[KeyCode2["F10"] = 121] = "F10";
  KeyCode2[KeyCode2["F11"] = 122] = "F11";
  KeyCode2[KeyCode2["F12"] = 123] = "F12";
  return KeyCode2;
})(KeyCode$1 || {});
var FileUploadStatus = /* @__PURE__ */ ((FileUploadStatus2) => {
  FileUploadStatus2["Uploading"] = "uploading";
  FileUploadStatus2["Uploaded"] = "uploaded";
  FileUploadStatus2["Error"] = "error";
  return FileUploadStatus2;
})(FileUploadStatus || {});
var Env = /* @__PURE__ */ ((Env2) => {
  Env2["dev"] = "Development";
  Env2["prod"] = "Production";
  return Env2;
})(Env || {});
const env = process.env.NODE_ENV == "development" ? "Development" : "Production";
const isDev = env == "Development";
var UserOnlineStatus = /* @__PURE__ */ ((UserOnlineStatus2) => {
  UserOnlineStatus2["Online"] = "online";
  UserOnlineStatus2["Offline"] = "offline";
  return UserOnlineStatus2;
})(UserOnlineStatus || {});
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["School"] = "school";
  UserType2["Guest"] = "guest";
  UserType2["Student"] = "student";
  UserType2["Admin"] = "admin";
  return UserType2;
})(UserType || {});
var WebinarRegistrationFieldType = /* @__PURE__ */ ((WebinarRegistrationFieldType2) => {
  WebinarRegistrationFieldType2["Email"] = "email";
  WebinarRegistrationFieldType2["FirstName"] = "firstName";
  WebinarRegistrationFieldType2["LastName"] = "lastName";
  WebinarRegistrationFieldType2["MiddleName"] = "middleName";
  WebinarRegistrationFieldType2["Phone"] = "phone";
  WebinarRegistrationFieldType2["Birthday"] = "birthday";
  WebinarRegistrationFieldType2["Gender"] = "gender";
  WebinarRegistrationFieldType2["TermOfService"] = "termsOfService";
  return WebinarRegistrationFieldType2;
})(WebinarRegistrationFieldType || {});
/*! js-cookie v3.0.1 | MIT */
function assign$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init$1(converter, defaultAttributes) {
  function set2(key, value, attributes2) {
    if (typeof document === "undefined") {
      return;
    }
    attributes2 = assign$1({}, defaultAttributes, attributes2);
    if (typeof attributes2.expires === "number") {
      attributes2.expires = new Date(Date.now() + attributes2.expires * 864e5);
    }
    if (attributes2.expires) {
      attributes2.expires = attributes2.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes2) {
      if (!attributes2[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes2[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes2[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get4(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create(
    {
      set: set2,
      get: get4,
      remove: function(key, attributes2) {
        set2(
          key,
          "",
          assign$1({}, attributes2, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes2) {
        return init$1(this.converter, assign$1({}, this.attributes, attributes2));
      },
      withConverter: function(converter2) {
        return init$1(assign$1({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init$1(defaultConverter, { path: "/" });
var __defProp$3p = Object.defineProperty;
var __getOwnPropDesc$3b = Object.getOwnPropertyDescriptor;
var __decorateClass$3r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3p(target, key, result);
  return result;
};
class LangDetector {
  constructor(opts = {
    detectLangStrategy: "auto",
    manualLang: Lang.en
  }) {
    this.opts = opts;
    if (!opts.locCookieName) opts.locCookieName = "loc";
    if (!opts.domainCookieName) opts.domainCookieName = "originDomain";
    switch (opts.detectLangStrategy) {
      case "auto":
        this.lang = this.autoLang;
        break;
      case "cookie":
        this.lang = this.cookieLang;
        break;
      case "manual":
        this.setLang(opts.manualLang);
        break;
    }
  }
  get autoLang() {
    return this.cookieLang ?? this.domainLang ?? this.browserLang;
  }
  /**
   * @deprecated use autoLang
   * just for backwards compatibility
   * remove later
   */
  get currentLang() {
    return this.autoLang;
  }
  get cookieLang() {
    let cookieLang = api.get(this.opts.locCookieName);
    if (cookieLang != null)
      return cookieLang;
    return null;
  }
  get browserLang() {
    let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    if (!lang)
      lang = window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
    if (lang == null)
      return Lang.en;
    if (lang.indexOf("-") !== -1)
      lang = lang.split("-")[0];
    if (lang.indexOf("_") !== -1)
      lang = lang.split("_")[0];
    switch (lang) {
      case "ru":
        return Lang.ru;
      case "uk":
        return Lang.uk;
      case "zh":
        return Lang.zhtw;
      case "id":
      case "id, in":
        return Lang.id;
      case "es":
        return Lang.es;
      default:
        return Lang.en;
    }
  }
  get domainLang() {
    if (!this.opts.domains) return null;
    const originDomain = this.getDomain();
    return this.opts.domains.get(originDomain) ?? null;
  }
  setLang(lang) {
    api.set(this.opts.locCookieName, lang);
    this.lang = lang;
  }
  /**
   * temporary solution for detection origin domain
   * 'from' url OR domain cookie
   */
  getDomain() {
    let domain2 = new URLSearchParams(window.location.search).get("from");
    if (domain2) {
      api.set(this.opts.domainCookieName, domain2);
    } else {
      domain2 = api.get(this.opts.domainCookieName) ?? null;
    }
    return domain2 || window.location.host;
  }
}
__decorateClass$3r([
  observable
], LangDetector.prototype, "lang", 2);
__decorateClass$3r([
  action
], LangDetector.prototype, "setLang", 1);
var lodash$1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var lodash = lodash$1.exports;
var hasRequiredLodash;
function requireLodash() {
  if (hasRequiredLodash) return lodash$1.exports;
  hasRequiredLodash = 1;
  (function(module2, exports$1) {
    (function() {
      var undefined$1;
      var VERSION2 = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = exports$1 && !exports$1.nodeType && exports$1;
      var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = (function() {
        try {
          var types2 = freeModule && freeModule.require && freeModule.require("util").types;
          if (types2) {
            return types2;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      })();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply3(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array4, setter2, iteratee, accumulator) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        while (++index2 < length2) {
          var value = array4[index2];
          setter2(accumulator, value, iteratee(value), array4);
        }
        return accumulator;
      }
      function arrayEach(array4, iteratee) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        while (++index2 < length2) {
          if (iteratee(array4[index2], index2, array4) === false) {
            break;
          }
        }
        return array4;
      }
      function arrayEachRight(array4, iteratee) {
        var length2 = array4 == null ? 0 : array4.length;
        while (length2--) {
          if (iteratee(array4[length2], length2, array4) === false) {
            break;
          }
        }
        return array4;
      }
      function arrayEvery(array4, predicate) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        while (++index2 < length2) {
          if (!predicate(array4[index2], index2, array4)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array4, predicate) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value = array4[index2];
          if (predicate(value, index2, array4)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array4, value) {
        var length2 = array4 == null ? 0 : array4.length;
        return !!length2 && baseIndexOf(array4, value, 0) > -1;
      }
      function arrayIncludesWith(array4, value, comparator) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        while (++index2 < length2) {
          if (comparator(value, array4[index2])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array4, iteratee) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length, result = Array(length2);
        while (++index2 < length2) {
          result[index2] = iteratee(array4[index2], index2, array4);
        }
        return result;
      }
      function arrayPush(array4, values) {
        var index2 = -1, length2 = values.length, offset = array4.length;
        while (++index2 < length2) {
          array4[offset + index2] = values[index2];
        }
        return array4;
      }
      function arrayReduce(array4, iteratee, accumulator, initAccum) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        if (initAccum && length2) {
          accumulator = array4[++index2];
        }
        while (++index2 < length2) {
          accumulator = iteratee(accumulator, array4[index2], index2, array4);
        }
        return accumulator;
      }
      function arrayReduceRight(array4, iteratee, accumulator, initAccum) {
        var length2 = array4 == null ? 0 : array4.length;
        if (initAccum && length2) {
          accumulator = array4[--length2];
        }
        while (length2--) {
          accumulator = iteratee(accumulator, array4[length2], length2, array4);
        }
        return accumulator;
      }
      function arraySome(array4, predicate) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length;
        while (++index2 < length2) {
          if (predicate(array4[index2], index2, array4)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string3) {
        return string3.split("");
      }
      function asciiWords(string3) {
        return string3.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array4, predicate, fromIndex, fromRight) {
        var length2 = array4.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length2) {
          if (predicate(array4[index2], index2, array4)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIndexOf(array4, value, fromIndex) {
        return value === value ? strictIndexOf(array4, value, fromIndex) : baseFindIndex(array4, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array4, value, fromIndex, comparator) {
        var index2 = fromIndex - 1, length2 = array4.length;
        while (++index2 < length2) {
          if (comparator(array4[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array4, iteratee) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? baseSum(array4, iteratee) / length2 : NAN;
      }
      function baseProperty(key) {
        return function(object4) {
          return object4 == null ? undefined$1 : object4[key];
        };
      }
      function basePropertyOf(object4) {
        return function(key) {
          return object4 == null ? undefined$1 : object4[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array4, comparer2) {
        var length2 = array4.length;
        array4.sort(comparer2);
        while (length2--) {
          array4[length2] = array4[length2].value;
        }
        return array4;
      }
      function baseSum(array4, iteratee) {
        var result, index2 = -1, length2 = array4.length;
        while (++index2 < length2) {
          var current = iteratee(array4[index2]);
          if (current !== undefined$1) {
            result = result === undefined$1 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index2 = -1, result = Array(n);
        while (++index2 < n) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      function baseToPairs(object4, props) {
        return arrayMap(props, function(key) {
          return [key, object4[key]];
        });
      }
      function baseTrim(string3) {
        return string3 ? string3.slice(0, trimmedEndIndex(string3) + 1).replace(reTrimStart, "") : string3;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object4, props) {
        return arrayMap(props, function(key) {
          return object4[key];
        });
      }
      function cacheHas(cache2, key) {
        return cache2.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index2 = -1, length2 = strSymbols.length;
        while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index2 = strSymbols.length;
        while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function countHolders(array4, placeholder) {
        var length2 = array4.length, result = 0;
        while (length2--) {
          if (array4[length2] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue3(object4, key) {
        return object4 == null ? undefined$1 : object4[key];
      }
      function hasUnicode(string3) {
        return reHasUnicode.test(string3);
      }
      function hasUnicodeWord(string3) {
        return reHasUnicodeWord.test(string3);
      }
      function iteratorToArray(iterator) {
        var data2, result = [];
        while (!(data2 = iterator.next()).done) {
          result.push(data2.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index2] = [key, value];
        });
        return result;
      }
      function overArg(func, transform3) {
        return function(arg) {
          return func(transform3(arg));
        };
      }
      function replaceHolders(array4, placeholder) {
        var index2 = -1, length2 = array4.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value = array4[index2];
          if (value === placeholder || value === PLACEHOLDER) {
            array4[index2] = PLACEHOLDER;
            result[resIndex++] = index2;
          }
        }
        return result;
      }
      function setToArray(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index2] = value;
        });
        return result;
      }
      function setToPairs(set2) {
        var index2 = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index2] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array4, value, fromIndex) {
        var index2 = fromIndex - 1, length2 = array4.length;
        while (++index2 < length2) {
          if (array4[index2] === value) {
            return index2;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array4, value, fromIndex) {
        var index2 = fromIndex + 1;
        while (index2--) {
          if (array4[index2] === value) {
            return index2;
          }
        }
        return index2;
      }
      function stringSize(string3) {
        return hasUnicode(string3) ? unicodeSize(string3) : asciiSize(string3);
      }
      function stringToArray(string3) {
        return hasUnicode(string3) ? unicodeToArray(string3) : asciiToArray(string3);
      }
      function trimmedEndIndex(string3) {
        var index2 = string3.length;
        while (index2-- && reWhitespace.test(string3.charAt(index2))) {
        }
        return index2;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string3) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string3)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string3) {
        return string3.match(reUnicode) || [];
      }
      function unicodeWords(string3) {
        return string3.match(reUnicodeWord) || [];
      }
      var runInContext = (function runInContext2(context2) {
        context2 = context2 == null ? root : _2.defaults(root.Object(), context2, _2.pick(root, contextProps));
        var Array2 = context2.Array, Date2 = context2.Date, Error2 = context2.Error, Function2 = context2.Function, Math2 = context2.Math, Object2 = context2.Object, RegExp2 = context2.RegExp, String2 = context2.String, TypeError2 = context2.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context2["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = (function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        })();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context2.Buffer : undefined$1, Symbol2 = context2.Symbol, Uint8Array2 = context2.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
        var defineProperty2 = (function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        })();
        var ctxClearTimeout = context2.clearTimeout !== root.clearTimeout && context2.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context2.setTimeout !== root.setTimeout && context2.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context2.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context2.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView2 = getNative(context2, "DataView"), Map2 = getNative(context2, "Map"), Promise2 = getNative(context2, "Promise"), Set2 = getNative(context2, "Set"), WeakMap2 = getNative(context2, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
        function lodash2(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ (function() {
          function object4() {
          }
          return function(proto2) {
            if (!isObject2(proto2)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto2);
            }
            object4.prototype = proto2;
            var result2 = new object4();
            object4.prototype = undefined$1;
            return result2;
          };
        })();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined$1;
        }
        lodash2.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash2
          }
        };
        lodash2.prototype = baseLodash.prototype;
        lodash2.prototype.constructor = lodash2;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array4 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array4), isRight = dir < 0, arrLength = isArr ? array4.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end = view.end, length2 = end - start2, index2 = isRight ? end : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length2, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
            return baseWrapperValue(array4, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length2-- && resIndex < takeCount) {
              index2 += dir;
              var iterIndex = -1, value = array4[index2];
              while (++iterIndex < iterLength) {
                var data2 = iteratees[iterIndex], iteratee2 = data2.iteratee, type4 = data2.type, computed3 = iteratee2(value);
                if (type4 == LAZY_MAP_FLAG) {
                  value = computed3;
                } else if (!computed3) {
                  if (type4 == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data2 = this.__data__;
          if (nativeCreate) {
            var result2 = data2[key];
            return result2 === HASH_UNDEFINED ? undefined$1 : result2;
          }
          return hasOwnProperty.call(data2, key) ? data2[key] : undefined$1;
        }
        function hashHas(key) {
          var data2 = this.__data__;
          return nativeCreate ? data2[key] !== undefined$1 : hasOwnProperty.call(data2, key);
        }
        function hashSet(key, value) {
          var data2 = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data2[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data2 = this.__data__, index2 = assocIndexOf(data2, key);
          if (index2 < 0) {
            return false;
          }
          var lastIndex = data2.length - 1;
          if (index2 == lastIndex) {
            data2.pop();
          } else {
            splice.call(data2, index2, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data2 = this.__data__, index2 = assocIndexOf(data2, key);
          return index2 < 0 ? undefined$1 : data2[index2][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data2 = this.__data__, index2 = assocIndexOf(data2, key);
          if (index2 < 0) {
            ++this.size;
            data2.push([key, value]);
          } else {
            data2[index2][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index2 = -1, length2 = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length2) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data2 = getMapData(this, key), size3 = data2.size;
          data2.set(key, value);
          this.size += data2.size == size3 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index2 = -1, length2 = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index2 < length2) {
            this.add(values2[index2]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data2 = this.__data__ = new ListCache(entries);
          this.size = data2.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data2 = this.__data__, result2 = data2["delete"](key);
          this.size = data2.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data2 = this.__data__;
          if (data2 instanceof ListCache) {
            var pairs = data2.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data2.size;
              return this;
            }
            data2 = this.__data__ = new MapCache(pairs);
          }
          data2.set(key, value);
          this.size = data2.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length2 = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length2)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array4) {
          var length2 = array4.length;
          return length2 ? array4[baseRandom(0, length2 - 1)] : undefined$1;
        }
        function arraySampleSize(array4, n) {
          return shuffleSelf(copyArray(array4), baseClamp(n, 0, array4.length));
        }
        function arrayShuffle(array4) {
          return shuffleSelf(copyArray(array4));
        }
        function assignMergeValue(object4, key, value) {
          if (value !== undefined$1 && !eq2(object4[key], value) || value === undefined$1 && !(key in object4)) {
            baseAssignValue(object4, key, value);
          }
        }
        function assignValue(object4, key, value) {
          var objValue = object4[key];
          if (!(hasOwnProperty.call(object4, key) && eq2(objValue, value)) || value === undefined$1 && !(key in object4)) {
            baseAssignValue(object4, key, value);
          }
        }
        function assocIndexOf(array4, key) {
          var length2 = array4.length;
          while (length2--) {
            if (eq2(array4[length2][0], key)) {
              return length2;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter2, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter2(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object4, source) {
          return object4 && copyObject(source, keys2(source), object4);
        }
        function baseAssignIn(object4, source) {
          return object4 && copyObject(source, keysIn(source), object4);
        }
        function baseAssignValue(object4, key, value) {
          if (key == "__proto__" && defineProperty2) {
            defineProperty2(object4, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object4[key] = value;
          }
        }
        function baseAt(object4, paths) {
          var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object4 == null;
          while (++index2 < length2) {
            result2[index2] = skip ? undefined$1 : get4(object4, paths[index2]);
          }
          return result2;
        }
        function baseClamp(number4, lower, upper) {
          if (number4 === number4) {
            if (upper !== undefined$1) {
              number4 = number4 <= upper ? number4 : upper;
            }
            if (lower !== undefined$1) {
              number4 = number4 >= lower ? number4 : lower;
            }
          }
          return number4;
        }
        function baseClone(value, bitmask, customizer, key, object4, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object4 ? customizer(value, key, object4, stack) : customizer(value);
          }
          if (result2 !== undefined$1) {
            return result2;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object4) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object4 ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys2;
          var props = isArr ? undefined$1 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys2(source);
          return function(object4) {
            return baseConformsTo(object4, source, props);
          };
        }
        function baseConformsTo(object4, source, props) {
          var length2 = props.length;
          if (object4 == null) {
            return !length2;
          }
          object4 = Object2(object4);
          while (length2--) {
            var key = props[length2], predicate = source[key], value = object4[key];
            if (value === undefined$1 && !(key in object4) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined$1, args);
          }, wait);
        }
        function baseDifference(array4, values2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array4.length, result2 = [], valuesLength = values2.length;
          if (!length2) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index2 < length2) {
              var value = array4[index2], computed3 = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed3 === computed3) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed3) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed3, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index2, collection2) {
            result2 = !!predicate(value, index2, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array4, iteratee2, comparator) {
          var index2 = -1, length2 = array4.length;
          while (++index2 < length2) {
            var value = array4[index2], current = iteratee2(value);
            if (current != null && (computed3 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed3))) {
              var computed3 = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array4, value, start2, end) {
          var length2 = array4.length;
          start2 = toInteger(start2);
          if (start2 < 0) {
            start2 = -start2 > length2 ? 0 : length2 + start2;
          }
          end = end === undefined$1 || end > length2 ? length2 : toInteger(end);
          if (end < 0) {
            end += length2;
          }
          end = start2 > end ? 0 : toLength(end);
          while (start2 < end) {
            array4[start2++] = value;
          }
          return array4;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index2, collection2) {
            if (predicate(value, index2, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array4, depth, predicate, isStrict, result2) {
          var index2 = -1, length2 = array4.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index2 < length2) {
            var value = array4[index2];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object4, iteratee2) {
          return object4 && baseFor(object4, iteratee2, keys2);
        }
        function baseForOwnRight(object4, iteratee2) {
          return object4 && baseForRight(object4, iteratee2, keys2);
        }
        function baseFunctions(object4, props) {
          return arrayFilter(props, function(key) {
            return isFunction2(object4[key]);
          });
        }
        function baseGet(object4, path2) {
          path2 = castPath(path2, object4);
          var index2 = 0, length2 = path2.length;
          while (object4 != null && index2 < length2) {
            object4 = object4[toKey(path2[index2++])];
          }
          return index2 && index2 == length2 ? object4 : undefined$1;
        }
        function baseGetAllKeys(object4, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object4);
          return isArray(object4) ? result2 : arrayPush(result2, symbolsFunc(object4));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined$1 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object4, key) {
          return object4 != null && hasOwnProperty.call(object4, key);
        }
        function baseHasIn(object4, key) {
          return object4 != null && key in Object2(object4);
        }
        function baseInRange(number4, start2, end) {
          return number4 >= nativeMin(start2, end) && number4 < nativeMax(start2, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array4 = arrays[othIndex];
            if (othIndex && iteratee2) {
              array4 = arrayMap(array4, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array4.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array4.length >= 120) ? new SetCache(othIndex && array4) : undefined$1;
          }
          array4 = arrays[0];
          var index2 = -1, seen = caches[0];
          outer:
            while (++index2 < length2 && result2.length < maxLength) {
              var value = array4[index2], computed3 = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed3) : includes2(result2, computed3, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache2 = caches[othIndex];
                  if (!(cache2 ? cacheHas(cache2, computed3) : includes2(arrays[othIndex], computed3, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed3);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object4, setter2, iteratee2, accumulator) {
          baseForOwn(object4, function(value, key, object5) {
            setter2(accumulator, iteratee2(value), key, object5);
          });
          return accumulator;
        }
        function baseInvoke(object4, path2, args) {
          path2 = castPath(path2, object4);
          object4 = parent(object4, path2);
          var func = object4 == null ? object4 : object4[toKey(last(path2))];
          return func == null ? undefined$1 : apply3(func, object4, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object4, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object4), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object4), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object4)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object4) ? equalArrays(object4, other, bitmask, customizer, equalFunc, stack) : equalByTag(object4, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object4, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object4.value() : object4, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object4, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object4, source, matchData, customizer) {
          var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
          if (object4 == null) {
            return !length2;
          }
          object4 = Object2(object4);
          while (index2--) {
            var data2 = matchData[index2];
            if (noCustomizer && data2[2] ? data2[1] !== object4[data2[0]] : !(data2[0] in object4)) {
              return false;
            }
          }
          while (++index2 < length2) {
            data2 = matchData[index2];
            var key = data2[0], objValue = object4[key], srcValue = data2[1];
            if (noCustomizer && data2[2]) {
              if (objValue === undefined$1 && !(key in object4)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object4, source, stack);
              }
              if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern4 = isFunction2(value) ? reIsNative : reIsHostCtor;
          return pattern4.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity2;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object4) {
          if (!isPrototype(object4)) {
            return nativeKeys(object4);
          }
          var result2 = [];
          for (var key in Object2(object4)) {
            if (hasOwnProperty.call(object4, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object4) {
          if (!isObject2(object4)) {
            return nativeKeysIn(object4);
          }
          var isProto = isPrototype(object4), result2 = [];
          for (var key in object4) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object4, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index2] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object4) {
            return object4 === source || baseIsMatch(object4, source, matchData);
          };
        }
        function baseMatchesProperty(path2, srcValue) {
          if (isKey(path2) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path2), srcValue);
          }
          return function(object4) {
            var objValue = get4(object4, path2);
            return objValue === undefined$1 && objValue === srcValue ? hasIn(object4, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object4, source, srcIndex, customizer, stack) {
          if (object4 === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object4, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object4, key), srcValue, key + "", object4, source, stack) : undefined$1;
              if (newValue === undefined$1) {
                newValue = srcValue;
              }
              assignMergeValue(object4, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object4, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object4, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object4, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object4, source, stack) : undefined$1;
          var isCommon = newValue === undefined$1;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction2(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object4, key, newValue);
        }
        function baseNth(array4, n) {
          var length2 = array4.length;
          if (!length2) {
            return;
          }
          n += n < 0 ? length2 : 0;
          return isIndex(n, length2) ? array4[n] : undefined$1;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity2];
          }
          var index2 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index2, "value": value };
          });
          return baseSortBy(result2, function(object4, other) {
            return compareMultiple(object4, other, orders);
          });
        }
        function basePick(object4, paths) {
          return basePickBy(object4, paths, function(value, path2) {
            return hasIn(object4, path2);
          });
        }
        function basePickBy(object4, paths, predicate) {
          var index2 = -1, length2 = paths.length, result2 = {};
          while (++index2 < length2) {
            var path2 = paths[index2], value = baseGet(object4, path2);
            if (predicate(value, path2)) {
              baseSet(result2, castPath(path2, object4), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path2) {
          return function(object4) {
            return baseGet(object4, path2);
          };
        }
        function basePullAll(array4, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values2.length, seen = array4;
          if (array4 === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array4, baseUnary(iteratee2));
          }
          while (++index2 < length2) {
            var fromIndex = 0, value = values2[index2], computed3 = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed3, fromIndex, comparator)) > -1) {
              if (seen !== array4) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array4, fromIndex, 1);
            }
          }
          return array4;
        }
        function basePullAt(array4, indexes) {
          var length2 = array4 ? indexes.length : 0, lastIndex = length2 - 1;
          while (length2--) {
            var index2 = indexes[length2];
            if (length2 == lastIndex || index2 !== previous) {
              var previous = index2;
              if (isIndex(index2)) {
                splice.call(array4, index2, 1);
              } else {
                baseUnset(array4, index2);
              }
            }
          }
          return array4;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start2, end, step, fromRight) {
          var index2 = -1, length2 = nativeMax(nativeCeil((end - start2) / (step || 1)), 0), result2 = Array2(length2);
          while (length2--) {
            result2[fromRight ? length2 : ++index2] = start2;
            start2 += step;
          }
          return result2;
        }
        function baseRepeat(string3, n) {
          var result2 = "";
          if (!string3 || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string3;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string3 += string3;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start2) {
          return setToString(overRest(func, start2, identity2), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array4 = values(collection);
          return shuffleSelf(array4, baseClamp(n, 0, array4.length));
        }
        function baseSet(object4, path2, value, customizer) {
          if (!isObject2(object4)) {
            return object4;
          }
          path2 = castPath(path2, object4);
          var index2 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object4;
          while (nested != null && ++index2 < length2) {
            var key = toKey(path2[index2]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object4;
            }
            if (index2 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
              if (newValue === undefined$1) {
                newValue = isObject2(objValue) ? objValue : isIndex(path2[index2 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object4;
        }
        var baseSetData = !metaMap ? identity2 : function(func, data2) {
          metaMap.set(func, data2);
          return func;
        };
        var baseSetToString = !defineProperty2 ? identity2 : function(func, string3) {
          return defineProperty2(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string3),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array4, start2, end) {
          var index2 = -1, length2 = array4.length;
          if (start2 < 0) {
            start2 = -start2 > length2 ? 0 : length2 + start2;
          }
          end = end > length2 ? length2 : end;
          if (end < 0) {
            end += length2;
          }
          length2 = start2 > end ? 0 : end - start2 >>> 0;
          start2 >>>= 0;
          var result2 = Array2(length2);
          while (++index2 < length2) {
            result2[index2] = array4[index2 + start2];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index2, collection2) {
            result2 = predicate(value, index2, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array4, value, retHighest) {
          var low = 0, high = array4 == null ? low : array4.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed3 = array4[mid];
              if (computed3 !== null && !isSymbol(computed3) && (retHighest ? computed3 <= value : computed3 < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array4, value, identity2, retHighest);
        }
        function baseSortedIndexBy(array4, value, iteratee2, retHighest) {
          var low = 0, high = array4 == null ? 0 : array4.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed3 = iteratee2(array4[mid]), othIsDefined = computed3 !== undefined$1, othIsNull = computed3 === null, othIsReflexive = computed3 === computed3, othIsSymbol = isSymbol(computed3);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed3 <= value : computed3 < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array4, iteratee2) {
          var index2 = -1, length2 = array4.length, resIndex = 0, result2 = [];
          while (++index2 < length2) {
            var value = array4[index2], computed3 = iteratee2 ? iteratee2(value) : value;
            if (!index2 || !eq2(computed3, seen)) {
              var seen = computed3;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array4, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, length2 = array4.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length2 >= LARGE_ARRAY_SIZE) {
            var set3 = iteratee2 ? null : createSet(array4);
            if (set3) {
              return setToArray(set3);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index2 < length2) {
              var value = array4[index2], computed3 = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed3 === computed3) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed3) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed3);
                }
                result2.push(value);
              } else if (!includes2(seen, computed3, comparator)) {
                if (seen !== result2) {
                  seen.push(computed3);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object4, path2) {
          path2 = castPath(path2, object4);
          object4 = parent(object4, path2);
          return object4 == null || delete object4[toKey(last(path2))];
        }
        function baseUpdate(object4, path2, updater, customizer) {
          return baseSet(object4, path2, updater(baseGet(object4, path2)), customizer);
        }
        function baseWhile(array4, predicate, isDrop, fromRight) {
          var length2 = array4.length, index2 = fromRight ? length2 : -1;
          while ((fromRight ? index2-- : ++index2 < length2) && predicate(array4[index2], index2, array4)) {
          }
          return isDrop ? baseSlice(array4, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array4, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action3) {
            return action3.func.apply(action3.thisArg, arrayPush([result3], action3.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length2 = arrays.length;
          if (length2 < 2) {
            return length2 ? baseUniq(arrays[0]) : [];
          }
          var index2 = -1, result2 = Array2(length2);
          while (++index2 < length2) {
            var array4 = arrays[index2], othIndex = -1;
            while (++othIndex < length2) {
              if (othIndex != index2) {
                result2[index2] = baseDifference(result2[index2] || array4, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index2 = -1, length2 = props.length, valsLength = values2.length, result2 = {};
          while (++index2 < length2) {
            var value = index2 < valsLength ? values2[index2] : undefined$1;
            assignFunc(result2, props[index2], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity2;
        }
        function castPath(value, object4) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object4) ? [value] : stringToPath(toString2(value));
        }
        var castRest = baseRest;
        function castSlice(array4, start2, end) {
          var length2 = array4.length;
          end = end === undefined$1 ? length2 : end;
          return !start2 && end >= length2 ? array4 : baseSlice(array4, start2, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id2) {
          return root.clearTimeout(id2);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp4) {
          var result2 = new regexp4.constructor(regexp4.source, reFlags.exec(regexp4));
          result2.lastIndex = regexp4.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object4, other, orders) {
          var index2 = -1, objCriteria = object4.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
          while (++index2 < length2) {
            var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
            if (result2) {
              if (index2 >= ordersLength) {
                return result2;
              }
              var order = orders[index2];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object4.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array4) {
          var index2 = -1, length2 = source.length;
          array4 || (array4 = Array2(length2));
          while (++index2 < length2) {
            array4[index2] = source[index2];
          }
          return array4;
        }
        function copyObject(source, props, object4, customizer) {
          var isNew = !object4;
          object4 || (object4 = {});
          var index2 = -1, length2 = props.length;
          while (++index2 < length2) {
            var key = props[index2];
            var newValue = customizer ? customizer(object4[key], source[key], key, object4, source) : undefined$1;
            if (newValue === undefined$1) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object4, key, newValue);
            } else {
              assignValue(object4, key, newValue);
            }
          }
          return object4;
        }
        function copySymbols(source, object4) {
          return copyObject(source, getSymbols(source), object4);
        }
        function copySymbolsIn(source, object4) {
          return copyObject(source, getSymbolsIn(source), object4);
        }
        function createAggregator(setter2, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter2, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object4, sources) {
            var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length2 < 3 ? undefined$1 : customizer;
              length2 = 1;
            }
            object4 = Object2(object4);
            while (++index2 < length2) {
              var source = sources[index2];
              if (source) {
                assigner(object4, source, index2, customizer);
              }
            }
            return object4;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
            while (fromRight ? index2-- : ++index2 < length2) {
              if (iteratee2(iterable[index2], index2, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object4, iteratee2, keysFunc) {
            var index2 = -1, iterable = Object2(object4), props = keysFunc(object4), length2 = props.length;
            while (length2--) {
              var key = props[fromRight ? length2 : ++index2];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object4;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper2() {
            var fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper2;
        }
        function createCaseFirst(methodName) {
          return function(string3) {
            string3 = toString2(string3);
            var strSymbols = hasUnicode(string3) ? stringToArray(string3) : undefined$1;
            var chr = strSymbols ? strSymbols[0] : string3.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string3.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string3) {
            return arrayReduce(words(deburr(string3).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper2() {
            var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper2);
            while (index2--) {
              args[index2] = arguments[index2];
            }
            var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length2 -= holders.length;
            if (length2 < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper2.placeholder,
                undefined$1,
                args,
                holders,
                undefined$1,
                undefined$1,
                arity - length2
              );
            }
            var fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
            return apply3(fn, this, args);
          }
          return wrapper2;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys2(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index2 = findIndexFunc(collection, predicate, fromIndex);
            return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index2--) {
              var func = funcs[index2];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper2 && getFuncName(func) == "wrapper") {
                var wrapper2 = new LodashWrapper([], true);
              }
            }
            index2 = wrapper2 ? index2 : length2;
            while (++index2 < length2) {
              func = funcs[index2];
              var funcName = getFuncName(func), data2 = funcName == "wrapper" ? getData2(func) : undefined$1;
              if (data2 && isLaziable(data2[0]) && data2[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data2[4].length && data2[9] == 1) {
                wrapper2 = wrapper2[getFuncName(data2[0])].apply(wrapper2, data2[3]);
              } else {
                wrapper2 = func.length == 1 && isLaziable(func) ? wrapper2[funcName]() : wrapper2.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper2 && args.length == 1 && isArray(value)) {
                return wrapper2.plant(value).value();
              }
              var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
              while (++index3 < length2) {
                result2 = funcs[index3].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
          function wrapper2() {
            var length2 = arguments.length, args = Array2(length2), index2 = length2;
            while (index2--) {
              args[index2] = arguments[index2];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper2), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length2 -= holdersCount;
            if (isCurried && length2 < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper2.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length2
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length2 = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length2 > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length2) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper2) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper2;
        }
        function createInverter(setter2, toIteratee) {
          return function(object4, iteratee2) {
            return baseInverter(object4, setter2, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined$1 && other === undefined$1) {
              return defaultValue;
            }
            if (value !== undefined$1) {
              result2 = value;
            }
            if (other !== undefined$1) {
              if (result2 === undefined$1) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply3(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length2, chars) {
          chars = chars === undefined$1 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length2) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper2() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper2 ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply3(fn, isBind ? thisArg : this, args);
          }
          return wrapper2;
        }
        function createRange(fromRight) {
          return function(start2, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start2, end, step)) {
              end = step = undefined$1;
            }
            start2 = toFinite(start2);
            if (end === undefined$1) {
              end = start2;
              start2 = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined$1 ? start2 < end ? 1 : -1 : toFinite(step);
            return baseRange(start2, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= -4;
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined$1, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number4, precision) {
            number4 = toNumber(number4);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number4)) {
              var pair = (toString2(number4) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString2(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number4);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop4 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object4) {
            var tag = getTag(object4);
            if (tag == mapTag) {
              return mapToArray(object4);
            }
            if (tag == setTag) {
              return setToPairs(object4);
            }
            return baseToPairs(object4, keysFunc(object4));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length2 = partials ? partials.length : 0;
          if (!length2) {
            bitmask &= -97;
            partials = holders = undefined$1;
          }
          ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined$1 ? arity : toInteger(arity);
          length2 -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined$1;
          }
          var data2 = isBindKey ? undefined$1 : getData2(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data2) {
            mergeData(newData, data2);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length2, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= -25;
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined$1, newData);
          }
          var setter2 = data2 ? baseSetData : setData;
          return setWrapToString(setter2(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object4) {
          if (objValue === undefined$1 || eq2(objValue, objectProto[key]) && !hasOwnProperty.call(object4, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object4, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject2(value) ? undefined$1 : value;
        }
        function equalArrays(array4, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array4.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array4);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array4;
          }
          var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
          stack.set(array4, other);
          stack.set(other, array4);
          while (++index2 < arrLength) {
            var arrValue = array4[index2], othValue = other[index2];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index2, other, array4, stack) : customizer(arrValue, othValue, index2, array4, other, stack);
            }
            if (compared !== undefined$1) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array4);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object4, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object4.byteLength != other.byteLength || object4.byteOffset != other.byteOffset) {
                return false;
              }
              object4 = object4.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object4.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object4), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq2(+object4, +other);
            case errorTag:
              return object4.name == other.name && object4.message == other.message;
            case regexpTag:
            case stringTag:
              return object4 == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object4.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object4);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object4, other);
              var result2 = equalArrays(convert(object4), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object4);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object4) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object4, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object4), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index2 = objLength;
          while (index2--) {
            var key = objProps[index2];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object4);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object4;
          }
          var result2 = true;
          stack.set(object4, other);
          stack.set(other, object4);
          var skipCtor = isPartial;
          while (++index2 < objLength) {
            key = objProps[index2];
            var objValue = object4[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object4, stack) : customizer(objValue, othValue, key, object4, other, stack);
            }
            if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object4.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object4 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object4);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined$1, flatten2), func + "");
        }
        function getAllKeys(object4) {
          return baseGetAllKeys(object4, keys2, getSymbols);
        }
        function getAllKeysIn(object4) {
          return baseGetAllKeys(object4, keysIn, getSymbolsIn);
        }
        var getData2 = !metaMap ? noop4 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array4 = realNames[result2], length2 = hasOwnProperty.call(realNames, result2) ? array4.length : 0;
          while (length2--) {
            var data2 = array4[length2], otherFunc = data2.func;
            if (otherFunc == null || otherFunc == func) {
              return data2.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object4 = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
          return object4.placeholder;
        }
        function getIteratee() {
          var result2 = lodash2.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data2 = map2.__data__;
          return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
        }
        function getMatchData(object4) {
          var result2 = keys2(object4), length2 = result2.length;
          while (length2--) {
            var key = result2[length2], value = object4[key];
            result2[length2] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object4, key) {
          var value = getValue3(object4, key);
          return baseIsNative(value) ? value : undefined$1;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined$1;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object4) {
          if (object4 == null) {
            return [];
          }
          object4 = Object2(object4);
          return arrayFilter(nativeGetSymbols(object4), function(symbol) {
            return propertyIsEnumerable.call(object4, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object4) {
          var result2 = [];
          while (object4) {
            arrayPush(result2, getSymbols(object4));
            object4 = getPrototype(object4);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start2, end, transforms) {
          var index2 = -1, length2 = transforms.length;
          while (++index2 < length2) {
            var data2 = transforms[index2], size3 = data2.size;
            switch (data2.type) {
              case "drop":
                start2 += size3;
                break;
              case "dropRight":
                end -= size3;
                break;
              case "take":
                end = nativeMin(end, start2 + size3);
                break;
              case "takeRight":
                start2 = nativeMax(start2, end - size3);
                break;
            }
          }
          return { "start": start2, "end": end };
        }
        function getWrapDetails(source) {
          var match2 = source.match(reWrapDetails);
          return match2 ? match2[1].split(reSplitDetails) : [];
        }
        function hasPath(object4, path2, hasFunc) {
          path2 = castPath(path2, object4);
          var index2 = -1, length2 = path2.length, result2 = false;
          while (++index2 < length2) {
            var key = toKey(path2[index2]);
            if (!(result2 = object4 != null && hasFunc(object4, key))) {
              break;
            }
            object4 = object4[key];
          }
          if (result2 || ++index2 != length2) {
            return result2;
          }
          length2 = object4 == null ? 0 : object4.length;
          return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray(object4) || isArguments(object4));
        }
        function initCloneArray(array4) {
          var length2 = array4.length, result2 = new array4.constructor(length2);
          if (length2 && typeof array4[0] == "string" && hasOwnProperty.call(array4, "index")) {
            result2.index = array4.index;
            result2.input = array4.input;
          }
          return result2;
        }
        function initCloneObject(object4) {
          return typeof object4.constructor == "function" && !isPrototype(object4) ? baseCreate(getPrototype(object4)) : {};
        }
        function initCloneByTag(object4, tag, isDeep) {
          var Ctor = object4.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object4);
            case boolTag:
            case dateTag:
              return new Ctor(+object4);
            case dataViewTag:
              return cloneDataView(object4, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object4, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object4);
            case regexpTag:
              return cloneRegExp(object4);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object4);
          }
        }
        function insertWrapDetails(source, details) {
          var length2 = details.length;
          if (!length2) {
            return source;
          }
          var lastIndex = length2 - 1;
          details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length2 > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length2) {
          var type4 = typeof value;
          length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
          return !!length2 && (type4 == "number" || type4 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
        }
        function isIterateeCall(value, index2, object4) {
          if (!isObject2(object4)) {
            return false;
          }
          var type4 = typeof index2;
          if (type4 == "number" ? isArrayLike(object4) && isIndex(index2, object4.length) : type4 == "string" && index2 in object4) {
            return eq2(object4[index2], value);
          }
          return false;
        }
        function isKey(value, object4) {
          if (isArray(value)) {
            return false;
          }
          var type4 = typeof value;
          if (type4 == "number" || type4 == "symbol" || type4 == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object4 != null && value in Object2(object4);
        }
        function isKeyable(value) {
          var type4 = typeof value;
          return type4 == "string" || type4 == "number" || type4 == "symbol" || type4 == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash2[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data2 = getData2(other);
          return !!data2 && func === data2[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction2 : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto2;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object4) {
            if (object4 == null) {
              return false;
            }
            return object4[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object4));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize2(func, function(key) {
            if (cache2.size === MAX_MEMOIZE_SIZE) {
              cache2.clear();
            }
            return key;
          });
          var cache2 = result2.cache;
          return result2;
        }
        function mergeData(data2, source) {
          var bitmask = data2[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data2[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data2;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data2[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data2[3];
            data2[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data2[4] = partials ? replaceHolders(data2[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data2[5];
            data2[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data2[6] = partials ? replaceHolders(data2[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data2[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data2[8] = data2[8] == null ? source[8] : nativeMin(data2[8], source[8]);
          }
          if (data2[9] == null) {
            data2[9] = source[9];
          }
          data2[0] = source[0];
          data2[1] = newBitmask;
          return data2;
        }
        function nativeKeysIn(object4) {
          var result2 = [];
          if (object4 != null) {
            for (var key in Object2(object4)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start2, transform4) {
          start2 = nativeMax(start2 === undefined$1 ? func.length - 1 : start2, 0);
          return function() {
            var args = arguments, index2 = -1, length2 = nativeMax(args.length - start2, 0), array4 = Array2(length2);
            while (++index2 < length2) {
              array4[index2] = args[start2 + index2];
            }
            index2 = -1;
            var otherArgs = Array2(start2 + 1);
            while (++index2 < start2) {
              otherArgs[index2] = args[index2];
            }
            otherArgs[start2] = transform4(array4);
            return apply3(func, this, otherArgs);
          };
        }
        function parent(object4, path2) {
          return path2.length < 2 ? object4 : baseGet(object4, baseSlice(path2, 0, -1));
        }
        function reorder(array4, indexes) {
          var arrLength = array4.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array4);
          while (length2--) {
            var index2 = indexes[length2];
            array4[length2] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
          }
          return array4;
        }
        function safeGet(object4, key) {
          if (key === "constructor" && typeof object4[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object4[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper2, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper2, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined$1, arguments);
          };
        }
        function shuffleSelf(array4, size3) {
          var index2 = -1, length2 = array4.length, lastIndex = length2 - 1;
          size3 = size3 === undefined$1 ? length2 : size3;
          while (++index2 < size3) {
            var rand = baseRandom(index2, lastIndex), value = array4[rand];
            array4[rand] = array4[index2];
            array4[index2] = value;
          }
          array4.length = size3;
          return array4;
        }
        var stringToPath = memoizeCapped(function(string3) {
          var result2 = [];
          if (string3.charCodeAt(0) === 46) {
            result2.push("");
          }
          string3.replace(rePropName, function(match2, number4, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match2);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper2) {
          if (wrapper2 instanceof LazyWrapper) {
            return wrapper2.clone();
          }
          var result2 = new LodashWrapper(wrapper2.__wrapped__, wrapper2.__chain__);
          result2.__actions__ = copyArray(wrapper2.__actions__);
          result2.__index__ = wrapper2.__index__;
          result2.__values__ = wrapper2.__values__;
          return result2;
        }
        function chunk(array4, size3, guard) {
          if (guard ? isIterateeCall(array4, size3, guard) : size3 === undefined$1) {
            size3 = 1;
          } else {
            size3 = nativeMax(toInteger(size3), 0);
          }
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2 || size3 < 1) {
            return [];
          }
          var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size3));
          while (index2 < length2) {
            result2[resIndex++] = baseSlice(array4, index2, index2 += size3);
          }
          return result2;
        }
        function compact2(array4) {
          var index2 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result2 = [];
          while (++index2 < length2) {
            var value = array4[index2];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length2 = arguments.length;
          if (!length2) {
            return [];
          }
          var args = Array2(length2 - 1), array4 = arguments[0], index2 = length2;
          while (index2--) {
            args[index2 - 1] = arguments[index2];
          }
          return arrayPush(isArray(array4) ? copyArray(array4) : [array4], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array4, values2) {
          return isArrayLikeObject(array4) ? baseDifference(array4, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array4, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return isArrayLikeObject(array4) ? baseDifference(array4, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array4, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined$1;
          }
          return isArrayLikeObject(array4) ? baseDifference(array4, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
        });
        function drop(array4, n, guard) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger(n);
          return baseSlice(array4, n < 0 ? 0 : n, length2);
        }
        function dropRight(array4, n, guard) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger(n);
          n = length2 - n;
          return baseSlice(array4, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array4, predicate) {
          return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array4, predicate) {
          return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), true) : [];
        }
        function fill(array4, value, start2, end) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          if (start2 && typeof start2 != "number" && isIterateeCall(array4, value, start2)) {
            start2 = 0;
            end = length2;
          }
          return baseFill(array4, value, start2, end);
        }
        function findIndex(array4, predicate, fromIndex) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length2 + index2, 0);
          }
          return baseFindIndex(array4, getIteratee(predicate, 3), index2);
        }
        function findLastIndex(array4, predicate, fromIndex) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return -1;
          }
          var index2 = length2 - 1;
          if (fromIndex !== undefined$1) {
            index2 = toInteger(fromIndex);
            index2 = fromIndex < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
          }
          return baseFindIndex(array4, getIteratee(predicate, 3), index2, true);
        }
        function flatten2(array4) {
          var length2 = array4 == null ? 0 : array4.length;
          return length2 ? baseFlatten(array4, 1) : [];
        }
        function flattenDeep(array4) {
          var length2 = array4 == null ? 0 : array4.length;
          return length2 ? baseFlatten(array4, INFINITY) : [];
        }
        function flattenDepth(array4, depth) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(array4, depth);
        }
        function fromPairs(pairs) {
          var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index2 < length2) {
            var pair = pairs[index2];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array4) {
          return array4 && array4.length ? array4[0] : undefined$1;
        }
        function indexOf(array4, value, fromIndex) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length2 + index2, 0);
          }
          return baseIndexOf(array4, value, index2);
        }
        function initial2(array4) {
          var length2 = array4 == null ? 0 : array4.length;
          return length2 ? baseSlice(array4, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined$1;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
        });
        function join(array4, separator) {
          return array4 == null ? "" : nativeJoin.call(array4, separator);
        }
        function last(array4) {
          var length2 = array4 == null ? 0 : array4.length;
          return length2 ? array4[length2 - 1] : undefined$1;
        }
        function lastIndexOf(array4, value, fromIndex) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return -1;
          }
          var index2 = length2;
          if (fromIndex !== undefined$1) {
            index2 = toInteger(fromIndex);
            index2 = index2 < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
          }
          return value === value ? strictLastIndexOf(array4, value, index2) : baseFindIndex(array4, baseIsNaN, index2, true);
        }
        function nth(array4, n) {
          return array4 && array4.length ? baseNth(array4, toInteger(n)) : undefined$1;
        }
        var pull = baseRest(pullAll);
        function pullAll(array4, values2) {
          return array4 && array4.length && values2 && values2.length ? basePullAll(array4, values2) : array4;
        }
        function pullAllBy(array4, values2, iteratee2) {
          return array4 && array4.length && values2 && values2.length ? basePullAll(array4, values2, getIteratee(iteratee2, 2)) : array4;
        }
        function pullAllWith(array4, values2, comparator) {
          return array4 && array4.length && values2 && values2.length ? basePullAll(array4, values2, undefined$1, comparator) : array4;
        }
        var pullAt = flatRest(function(array4, indexes) {
          var length2 = array4 == null ? 0 : array4.length, result2 = baseAt(array4, indexes);
          basePullAt(array4, arrayMap(indexes, function(index2) {
            return isIndex(index2, length2) ? +index2 : index2;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array4, predicate) {
          var result2 = [];
          if (!(array4 && array4.length)) {
            return result2;
          }
          var index2 = -1, indexes = [], length2 = array4.length;
          predicate = getIteratee(predicate, 3);
          while (++index2 < length2) {
            var value = array4[index2];
            if (predicate(value, index2, array4)) {
              result2.push(value);
              indexes.push(index2);
            }
          }
          basePullAt(array4, indexes);
          return result2;
        }
        function reverse(array4) {
          return array4 == null ? array4 : nativeReverse.call(array4);
        }
        function slice2(array4, start2, end) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array4, start2, end)) {
            start2 = 0;
            end = length2;
          } else {
            start2 = start2 == null ? 0 : toInteger(start2);
            end = end === undefined$1 ? length2 : toInteger(end);
          }
          return baseSlice(array4, start2, end);
        }
        function sortedIndex(array4, value) {
          return baseSortedIndex(array4, value);
        }
        function sortedIndexBy(array4, value, iteratee2) {
          return baseSortedIndexBy(array4, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array4, value) {
          var length2 = array4 == null ? 0 : array4.length;
          if (length2) {
            var index2 = baseSortedIndex(array4, value);
            if (index2 < length2 && eq2(array4[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedLastIndex(array4, value) {
          return baseSortedIndex(array4, value, true);
        }
        function sortedLastIndexBy(array4, value, iteratee2) {
          return baseSortedIndexBy(array4, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array4, value) {
          var length2 = array4 == null ? 0 : array4.length;
          if (length2) {
            var index2 = baseSortedIndex(array4, value, true) - 1;
            if (eq2(array4[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedUniq(array4) {
          return array4 && array4.length ? baseSortedUniq(array4) : [];
        }
        function sortedUniqBy(array4, iteratee2) {
          return array4 && array4.length ? baseSortedUniq(array4, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array4) {
          var length2 = array4 == null ? 0 : array4.length;
          return length2 ? baseSlice(array4, 1, length2) : [];
        }
        function take(array4, n, guard) {
          if (!(array4 && array4.length)) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger(n);
          return baseSlice(array4, 0, n < 0 ? 0 : n);
        }
        function takeRight(array4, n, guard) {
          var length2 = array4 == null ? 0 : array4.length;
          if (!length2) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger(n);
          n = length2 - n;
          return baseSlice(array4, n < 0 ? 0 : n, length2);
        }
        function takeRightWhile(array4, predicate) {
          return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array4, predicate) {
          return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
        });
        function uniq2(array4) {
          return array4 && array4.length ? baseUniq(array4) : [];
        }
        function uniqBy(array4, iteratee2) {
          return array4 && array4.length ? baseUniq(array4, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array4, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return array4 && array4.length ? baseUniq(array4, undefined$1, comparator) : [];
        }
        function unzip(array4) {
          if (!(array4 && array4.length)) {
            return [];
          }
          var length2 = 0;
          array4 = arrayFilter(array4, function(group2) {
            if (isArrayLikeObject(group2)) {
              length2 = nativeMax(group2.length, length2);
              return true;
            }
          });
          return baseTimes(length2, function(index2) {
            return arrayMap(array4, baseProperty(index2));
          });
        }
        function unzipWith(array4, iteratee2) {
          if (!(array4 && array4.length)) {
            return [];
          }
          var result2 = unzip(array4);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group2) {
            return apply3(iteratee2, undefined$1, group2);
          });
        }
        var without = baseRest(function(array4, values2) {
          return isArrayLikeObject(array4) ? baseDifference(array4, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash2(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length2 = paths.length, start2 = length2 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object4) {
            return baseAt(object4, paths);
          };
          if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start2)) {
            return this.thru(interceptor);
          }
          value = value.slice(start2, +start2 + (length2 ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined$1
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array4) {
            if (length2 && !array4.length) {
              array4.push(undefined$1);
            }
            return array4;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined$1) {
            this.__values__ = toArray2(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined$1;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined$1
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter2(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined$1 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length2 = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length2 + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path2, args) {
          var index2 = -1, isFunc = typeof path2 == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index2] = isFunc ? apply3(path2, value, args) : baseInvoke(value, path2, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined$1 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size2(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length2 = iteratees.length;
          if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined$1 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined$1;
            }
            return result2;
          };
        }
        var bind2 = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind2));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object4, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object4, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined$1;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined$1;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined$1;
            return result2;
          }
          function cancel2() {
            if (timerId !== undefined$1) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined$1;
          }
          function flush() {
            return timerId === undefined$1 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined$1) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined$1) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel2;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize2(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
            if (cache2.has(key)) {
              return cache2.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache2.set(key, result2) || cache2;
            return result2;
          };
          memoized.cache = new (memoize2.Cache || MapCache)();
          return memoized;
        }
        memoize2.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once2(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index2 = -1, length2 = nativeMin(args.length, funcsLength);
            while (++index2 < length2) {
              args[index2] = transforms[index2].call(this, args[index2]);
            }
            return apply3(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
        });
        function rest(func, start2) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start2 = start2 === undefined$1 ? start2 : toInteger(start2);
          return baseRest(func, start2);
        }
        function spread2(func, start2) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start2 = start2 == null ? 0 : nativeMax(toInteger(start2), 0);
          return baseRest(function(args) {
            var array4 = args[start2], otherArgs = castSlice(args, 0, start2);
            if (array4) {
              arrayPush(otherArgs, array4);
            }
            return apply3(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper2) {
          return partial(castFunction(wrapper2), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object4, source) {
          return source == null || baseConformsTo(object4, source, keys2(source));
        }
        function eq2(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction2(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
        }
        function isEmpty2(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual4(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          var result2 = customizer ? customizer(value, other) : undefined$1;
          return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
        }
        function isFinite2(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction2(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type4 = typeof value;
          return value != null && (type4 == "object" || type4 == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object4, source) {
          return object4 === source || baseIsMatch(object4, source, getMatchData(source));
        }
        function isMatchWith(object4, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseIsMatch(object4, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject2(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto2 = getPrototype(value);
          if (proto2 === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto2, "constructor") && proto2.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined$1;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray2(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign2 = value < 0 ? -1 : 1;
            return sign2 * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString2(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign2 = createAssigner(function(object4, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys2(source), object4);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object4, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object4, source) {
          copyObject(source, keysIn(source), object4);
        });
        var assignInWith = createAssigner(function(object4, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object4, customizer);
        });
        var assignWith = createAssigner(function(object4, source, srcIndex, customizer) {
          copyObject(source, keys2(source), object4, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults2 = baseRest(function(object4, sources) {
          object4 = Object2(object4);
          var index2 = -1;
          var length2 = sources.length;
          var guard = length2 > 2 ? sources[2] : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length2 = 1;
          }
          while (++index2 < length2) {
            var source = sources[index2];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object4[key];
              if (value === undefined$1 || eq2(value, objectProto[key]) && !hasOwnProperty.call(object4, key)) {
                object4[key] = source[key];
              }
            }
          }
          return object4;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined$1, customDefaultsMerge);
          return apply3(mergeWith, undefined$1, args);
        });
        function findKey(object4, predicate) {
          return baseFindKey(object4, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object4, predicate) {
          return baseFindKey(object4, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object4, iteratee2) {
          return object4 == null ? object4 : baseFor(object4, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object4, iteratee2) {
          return object4 == null ? object4 : baseForRight(object4, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object4, iteratee2) {
          return object4 && baseForOwn(object4, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object4, iteratee2) {
          return object4 && baseForOwnRight(object4, getIteratee(iteratee2, 3));
        }
        function functions(object4) {
          return object4 == null ? [] : baseFunctions(object4, keys2(object4));
        }
        function functionsIn(object4) {
          return object4 == null ? [] : baseFunctions(object4, keysIn(object4));
        }
        function get4(object4, path2, defaultValue) {
          var result2 = object4 == null ? undefined$1 : baseGet(object4, path2);
          return result2 === undefined$1 ? defaultValue : result2;
        }
        function has2(object4, path2) {
          return object4 != null && hasPath(object4, path2, baseHas);
        }
        function hasIn(object4, path2) {
          return object4 != null && hasPath(object4, path2, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity2));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys2(object4) {
          return isArrayLike(object4) ? arrayLikeKeys(object4) : baseKeys(object4);
        }
        function keysIn(object4) {
          return isArrayLike(object4) ? arrayLikeKeys(object4, true) : baseKeysIn(object4);
        }
        function mapKeys(object4, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object4, function(value, key, object5) {
            baseAssignValue(result2, iteratee2(value, key, object5), value);
          });
          return result2;
        }
        function mapValues(object4, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object4, function(value, key, object5) {
            baseAssignValue(result2, key, iteratee2(value, key, object5));
          });
          return result2;
        }
        var merge2 = createAssigner(function(object4, source, srcIndex) {
          baseMerge(object4, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object4, source, srcIndex, customizer) {
          baseMerge(object4, source, srcIndex, customizer);
        });
        var omit2 = flatRest(function(object4, paths) {
          var result2 = {};
          if (object4 == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path2) {
            path2 = castPath(path2, object4);
            isDeep || (isDeep = path2.length > 1);
            return path2;
          });
          copyObject(object4, getAllKeysIn(object4), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length2 = paths.length;
          while (length2--) {
            baseUnset(result2, paths[length2]);
          }
          return result2;
        });
        function omitBy(object4, predicate) {
          return pickBy(object4, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object4, paths) {
          return object4 == null ? {} : basePick(object4, paths);
        });
        function pickBy(object4, predicate) {
          if (object4 == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object4), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object4, props, function(value, path2) {
            return predicate(value, path2[0]);
          });
        }
        function result(object4, path2, defaultValue) {
          path2 = castPath(path2, object4);
          var index2 = -1, length2 = path2.length;
          if (!length2) {
            length2 = 1;
            object4 = undefined$1;
          }
          while (++index2 < length2) {
            var value = object4 == null ? undefined$1 : object4[toKey(path2[index2])];
            if (value === undefined$1) {
              index2 = length2;
              value = defaultValue;
            }
            object4 = isFunction2(value) ? value.call(object4) : value;
          }
          return object4;
        }
        function set2(object4, path2, value) {
          return object4 == null ? object4 : baseSet(object4, path2, value);
        }
        function setWith(object4, path2, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object4 == null ? object4 : baseSet(object4, path2, value, customizer);
        }
        var toPairs = createToPairs(keys2);
        var toPairsIn = createToPairs(keysIn);
        function transform3(object4, iteratee2, accumulator) {
          var isArr = isArray(object4), isArrLike = isArr || isBuffer(object4) || isTypedArray(object4);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object4 && object4.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object4)) {
              accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object4)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object4, function(value, index2, object5) {
            return iteratee2(accumulator, value, index2, object5);
          });
          return accumulator;
        }
        function unset(object4, path2) {
          return object4 == null ? true : baseUnset(object4, path2);
        }
        function update2(object4, path2, updater) {
          return object4 == null ? object4 : baseUpdate(object4, path2, castFunction(updater));
        }
        function updateWith(object4, path2, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object4 == null ? object4 : baseUpdate(object4, path2, castFunction(updater), customizer);
        }
        function values(object4) {
          return object4 == null ? [] : baseValues(object4, keys2(object4));
        }
        function valuesIn(object4) {
          return object4 == null ? [] : baseValues(object4, keysIn(object4));
        }
        function clamp(number4, lower, upper) {
          if (upper === undefined$1) {
            upper = lower;
            lower = undefined$1;
          }
          if (upper !== undefined$1) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined$1) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number4), lower, upper);
        }
        function inRange(number4, start2, end) {
          start2 = toFinite(start2);
          if (end === undefined$1) {
            end = start2;
            start2 = 0;
          } else {
            end = toFinite(end);
          }
          number4 = toNumber(number4);
          return baseInRange(number4, start2, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined$1;
          }
          if (floating === undefined$1) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined$1;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined$1;
            }
          }
          if (lower === undefined$1 && upper === undefined$1) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined$1) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index2) {
          word = word.toLowerCase();
          return result2 + (index2 ? capitalize(word) : word);
        });
        function capitalize(string3) {
          return upperFirst(toString2(string3).toLowerCase());
        }
        function deburr(string3) {
          string3 = toString2(string3);
          return string3 && string3.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string3, target, position2) {
          string3 = toString2(string3);
          target = baseToString(target);
          var length2 = string3.length;
          position2 = position2 === undefined$1 ? length2 : baseClamp(toInteger(position2), 0, length2);
          var end = position2;
          position2 -= target.length;
          return position2 >= 0 && string3.slice(position2, end) == target;
        }
        function escape2(string3) {
          string3 = toString2(string3);
          return string3 && reHasUnescapedHtml.test(string3) ? string3.replace(reUnescapedHtml, escapeHtmlChar) : string3;
        }
        function escapeRegExp(string3) {
          string3 = toString2(string3);
          return string3 && reHasRegExpChar.test(string3) ? string3.replace(reRegExpChar, "\\$&") : string3;
        }
        var kebabCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string3, length2, chars) {
          string3 = toString2(string3);
          length2 = toInteger(length2);
          var strLength = length2 ? stringSize(string3) : 0;
          if (!length2 || strLength >= length2) {
            return string3;
          }
          var mid = (length2 - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string3 + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string3, length2, chars) {
          string3 = toString2(string3);
          length2 = toInteger(length2);
          var strLength = length2 ? stringSize(string3) : 0;
          return length2 && strLength < length2 ? string3 + createPadding(length2 - strLength, chars) : string3;
        }
        function padStart(string3, length2, chars) {
          string3 = toString2(string3);
          length2 = toInteger(length2);
          var strLength = length2 ? stringSize(string3) : 0;
          return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string3 : string3;
        }
        function parseInt2(string3, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString2(string3).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string3, n, guard) {
          if (guard ? isIterateeCall(string3, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString2(string3), n);
        }
        function replace2() {
          var args = arguments, string3 = toString2(args[0]);
          return args.length < 3 ? string3 : string3.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "_" : "") + word.toLowerCase();
        });
        function split(string3, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string3, separator, limit)) {
            separator = limit = undefined$1;
          }
          limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string3 = toString2(string3);
          if (string3 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string3)) {
              return castSlice(stringToArray(string3), 0, limit);
            }
          }
          return string3.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + upperFirst(word);
        });
        function startsWith(string3, target, position2) {
          string3 = toString2(string3);
          position2 = position2 == null ? 0 : baseClamp(toInteger(position2), 0, string3.length);
          target = baseToString(target);
          return string3.slice(position2, position2 + target.length) == target;
        }
        function template(string3, options, guard) {
          var settings = lodash2.templateSettings;
          if (guard && isIterateeCall(string3, options, guard)) {
            options = undefined$1;
          }
          string3 = toString2(string3);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string3.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string3.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index2 = offset + match2.length;
            return match2;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString2(value).toLowerCase();
        }
        function toUpper(value) {
          return toString2(value).toUpperCase();
        }
        function trim2(string3, chars, guard) {
          string3 = toString2(string3);
          if (string3 && (guard || chars === undefined$1)) {
            return baseTrim(string3);
          }
          if (!string3 || !(chars = baseToString(chars))) {
            return string3;
          }
          var strSymbols = stringToArray(string3), chrSymbols = stringToArray(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start2, end).join("");
        }
        function trimEnd(string3, chars, guard) {
          string3 = toString2(string3);
          if (string3 && (guard || chars === undefined$1)) {
            return string3.slice(0, trimmedEndIndex(string3) + 1);
          }
          if (!string3 || !(chars = baseToString(chars))) {
            return string3;
          }
          var strSymbols = stringToArray(string3), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string3, chars, guard) {
          string3 = toString2(string3);
          if (string3 && (guard || chars === undefined$1)) {
            return string3.replace(reTrimStart, "");
          }
          if (!string3 || !(chars = baseToString(chars))) {
            return string3;
          }
          var strSymbols = stringToArray(string3), start2 = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start2).join("");
        }
        function truncate(string3, options) {
          var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length2 = "length" in options ? toInteger(options.length) : length2;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string3 = toString2(string3);
          var strLength = string3.length;
          if (hasUnicode(string3)) {
            var strSymbols = stringToArray(string3);
            strLength = strSymbols.length;
          }
          if (length2 >= strLength) {
            return string3;
          }
          var end = length2 - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string3.slice(0, end);
          if (separator === undefined$1) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string3.slice(end).search(separator)) {
              var match2, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString2(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match2 = separator.exec(substring)) {
                var newEnd = match2.index;
              }
              result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
            }
          } else if (string3.indexOf(baseToString(separator), end) != end) {
            var index2 = result2.lastIndexOf(separator);
            if (index2 > -1) {
              result2 = result2.slice(0, index2);
            }
          }
          return result2 + omission;
        }
        function unescape2(string3) {
          string3 = toString2(string3);
          return string3 && reHasEscapedHtml.test(string3) ? string3.replace(reEscapedHtml, unescapeHtmlChar) : string3;
        }
        var upperCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string3, pattern4, guard) {
          string3 = toString2(string3);
          pattern4 = guard ? undefined$1 : pattern4;
          if (pattern4 === undefined$1) {
            return hasUnicodeWord(string3) ? unicodeWords(string3) : asciiWords(string3);
          }
          return string3.match(pattern4) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply3(func, undefined$1, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll2 = flatRest(function(object4, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object4, key, bind2(object4[key], object4));
          });
          return object4;
        });
        function cond(pairs) {
          var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length2 ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index2 = -1;
            while (++index2 < length2) {
              var pair = pairs[index2];
              if (apply3(pair[0], this, args)) {
                return apply3(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity2(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path2, srcValue) {
          return baseMatchesProperty(path2, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method4 = baseRest(function(path2, args) {
          return function(object4) {
            return baseInvoke(object4, path2, args);
          };
        });
        var methodOf = baseRest(function(object4, args) {
          return function(path2) {
            return baseInvoke(object4, path2, args);
          };
        });
        function mixin(object4, source, options) {
          var props = keys2(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object4;
            object4 = this;
            methodNames = baseFunctions(source, keys2(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object4);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object4[methodName] = func;
            if (isFunc) {
              object4.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object4(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object4 });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object4, arrayPush([this.value()], arguments));
              };
            }
          });
          return object4;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop4() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path2) {
          return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
        }
        function propertyOf(object4) {
          return function(path2) {
            return object4 == null ? undefined$1 : baseGet(object4, path2);
          };
        }
        var range3 = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length2, iteratee2);
          while (++index2 < n) {
            iteratee2(index2);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString2(value)));
        }
        function uniqueId(prefix2) {
          var id2 = ++idCounter;
          return toString2(prefix2) + id2;
        }
        var add3 = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor2 = createRound("floor");
        function max2(array4) {
          return array4 && array4.length ? baseExtremum(array4, identity2, baseGt) : undefined$1;
        }
        function maxBy(array4, iteratee2) {
          return array4 && array4.length ? baseExtremum(array4, getIteratee(iteratee2, 2), baseGt) : undefined$1;
        }
        function mean(array4) {
          return baseMean(array4, identity2);
        }
        function meanBy(array4, iteratee2) {
          return baseMean(array4, getIteratee(iteratee2, 2));
        }
        function min2(array4) {
          return array4 && array4.length ? baseExtremum(array4, identity2, baseLt) : undefined$1;
        }
        function minBy(array4, iteratee2) {
          return array4 && array4.length ? baseExtremum(array4, getIteratee(iteratee2, 2), baseLt) : undefined$1;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round2 = createRound("round");
        var subtract3 = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array4) {
          return array4 && array4.length ? baseSum(array4, identity2) : 0;
        }
        function sumBy(array4, iteratee2) {
          return array4 && array4.length ? baseSum(array4, getIteratee(iteratee2, 2)) : 0;
        }
        lodash2.after = after;
        lodash2.ary = ary;
        lodash2.assign = assign2;
        lodash2.assignIn = assignIn;
        lodash2.assignInWith = assignInWith;
        lodash2.assignWith = assignWith;
        lodash2.at = at;
        lodash2.before = before;
        lodash2.bind = bind2;
        lodash2.bindAll = bindAll2;
        lodash2.bindKey = bindKey;
        lodash2.castArray = castArray;
        lodash2.chain = chain;
        lodash2.chunk = chunk;
        lodash2.compact = compact2;
        lodash2.concat = concat;
        lodash2.cond = cond;
        lodash2.conforms = conforms;
        lodash2.constant = constant;
        lodash2.countBy = countBy;
        lodash2.create = create;
        lodash2.curry = curry;
        lodash2.curryRight = curryRight;
        lodash2.debounce = debounce;
        lodash2.defaults = defaults2;
        lodash2.defaultsDeep = defaultsDeep;
        lodash2.defer = defer;
        lodash2.delay = delay;
        lodash2.difference = difference;
        lodash2.differenceBy = differenceBy;
        lodash2.differenceWith = differenceWith;
        lodash2.drop = drop;
        lodash2.dropRight = dropRight;
        lodash2.dropRightWhile = dropRightWhile;
        lodash2.dropWhile = dropWhile;
        lodash2.fill = fill;
        lodash2.filter = filter2;
        lodash2.flatMap = flatMap;
        lodash2.flatMapDeep = flatMapDeep;
        lodash2.flatMapDepth = flatMapDepth;
        lodash2.flatten = flatten2;
        lodash2.flattenDeep = flattenDeep;
        lodash2.flattenDepth = flattenDepth;
        lodash2.flip = flip;
        lodash2.flow = flow;
        lodash2.flowRight = flowRight;
        lodash2.fromPairs = fromPairs;
        lodash2.functions = functions;
        lodash2.functionsIn = functionsIn;
        lodash2.groupBy = groupBy;
        lodash2.initial = initial2;
        lodash2.intersection = intersection;
        lodash2.intersectionBy = intersectionBy;
        lodash2.intersectionWith = intersectionWith;
        lodash2.invert = invert;
        lodash2.invertBy = invertBy;
        lodash2.invokeMap = invokeMap;
        lodash2.iteratee = iteratee;
        lodash2.keyBy = keyBy;
        lodash2.keys = keys2;
        lodash2.keysIn = keysIn;
        lodash2.map = map;
        lodash2.mapKeys = mapKeys;
        lodash2.mapValues = mapValues;
        lodash2.matches = matches;
        lodash2.matchesProperty = matchesProperty;
        lodash2.memoize = memoize2;
        lodash2.merge = merge2;
        lodash2.mergeWith = mergeWith;
        lodash2.method = method4;
        lodash2.methodOf = methodOf;
        lodash2.mixin = mixin;
        lodash2.negate = negate;
        lodash2.nthArg = nthArg;
        lodash2.omit = omit2;
        lodash2.omitBy = omitBy;
        lodash2.once = once2;
        lodash2.orderBy = orderBy;
        lodash2.over = over;
        lodash2.overArgs = overArgs;
        lodash2.overEvery = overEvery;
        lodash2.overSome = overSome;
        lodash2.partial = partial;
        lodash2.partialRight = partialRight;
        lodash2.partition = partition;
        lodash2.pick = pick;
        lodash2.pickBy = pickBy;
        lodash2.property = property;
        lodash2.propertyOf = propertyOf;
        lodash2.pull = pull;
        lodash2.pullAll = pullAll;
        lodash2.pullAllBy = pullAllBy;
        lodash2.pullAllWith = pullAllWith;
        lodash2.pullAt = pullAt;
        lodash2.range = range3;
        lodash2.rangeRight = rangeRight;
        lodash2.rearg = rearg;
        lodash2.reject = reject;
        lodash2.remove = remove;
        lodash2.rest = rest;
        lodash2.reverse = reverse;
        lodash2.sampleSize = sampleSize;
        lodash2.set = set2;
        lodash2.setWith = setWith;
        lodash2.shuffle = shuffle;
        lodash2.slice = slice2;
        lodash2.sortBy = sortBy;
        lodash2.sortedUniq = sortedUniq;
        lodash2.sortedUniqBy = sortedUniqBy;
        lodash2.split = split;
        lodash2.spread = spread2;
        lodash2.tail = tail;
        lodash2.take = take;
        lodash2.takeRight = takeRight;
        lodash2.takeRightWhile = takeRightWhile;
        lodash2.takeWhile = takeWhile;
        lodash2.tap = tap;
        lodash2.throttle = throttle2;
        lodash2.thru = thru;
        lodash2.toArray = toArray2;
        lodash2.toPairs = toPairs;
        lodash2.toPairsIn = toPairsIn;
        lodash2.toPath = toPath;
        lodash2.toPlainObject = toPlainObject;
        lodash2.transform = transform3;
        lodash2.unary = unary;
        lodash2.union = union;
        lodash2.unionBy = unionBy;
        lodash2.unionWith = unionWith;
        lodash2.uniq = uniq2;
        lodash2.uniqBy = uniqBy;
        lodash2.uniqWith = uniqWith;
        lodash2.unset = unset;
        lodash2.unzip = unzip;
        lodash2.unzipWith = unzipWith;
        lodash2.update = update2;
        lodash2.updateWith = updateWith;
        lodash2.values = values;
        lodash2.valuesIn = valuesIn;
        lodash2.without = without;
        lodash2.words = words;
        lodash2.wrap = wrap;
        lodash2.xor = xor;
        lodash2.xorBy = xorBy;
        lodash2.xorWith = xorWith;
        lodash2.zip = zip;
        lodash2.zipObject = zipObject;
        lodash2.zipObjectDeep = zipObjectDeep;
        lodash2.zipWith = zipWith;
        lodash2.entries = toPairs;
        lodash2.entriesIn = toPairsIn;
        lodash2.extend = assignIn;
        lodash2.extendWith = assignInWith;
        mixin(lodash2, lodash2);
        lodash2.add = add3;
        lodash2.attempt = attempt;
        lodash2.camelCase = camelCase;
        lodash2.capitalize = capitalize;
        lodash2.ceil = ceil;
        lodash2.clamp = clamp;
        lodash2.clone = clone;
        lodash2.cloneDeep = cloneDeep;
        lodash2.cloneDeepWith = cloneDeepWith;
        lodash2.cloneWith = cloneWith;
        lodash2.conformsTo = conformsTo;
        lodash2.deburr = deburr;
        lodash2.defaultTo = defaultTo;
        lodash2.divide = divide;
        lodash2.endsWith = endsWith;
        lodash2.eq = eq2;
        lodash2.escape = escape2;
        lodash2.escapeRegExp = escapeRegExp;
        lodash2.every = every;
        lodash2.find = find;
        lodash2.findIndex = findIndex;
        lodash2.findKey = findKey;
        lodash2.findLast = findLast;
        lodash2.findLastIndex = findLastIndex;
        lodash2.findLastKey = findLastKey;
        lodash2.floor = floor2;
        lodash2.forEach = forEach;
        lodash2.forEachRight = forEachRight;
        lodash2.forIn = forIn;
        lodash2.forInRight = forInRight;
        lodash2.forOwn = forOwn;
        lodash2.forOwnRight = forOwnRight;
        lodash2.get = get4;
        lodash2.gt = gt;
        lodash2.gte = gte;
        lodash2.has = has2;
        lodash2.hasIn = hasIn;
        lodash2.head = head;
        lodash2.identity = identity2;
        lodash2.includes = includes;
        lodash2.indexOf = indexOf;
        lodash2.inRange = inRange;
        lodash2.invoke = invoke;
        lodash2.isArguments = isArguments;
        lodash2.isArray = isArray;
        lodash2.isArrayBuffer = isArrayBuffer2;
        lodash2.isArrayLike = isArrayLike;
        lodash2.isArrayLikeObject = isArrayLikeObject;
        lodash2.isBoolean = isBoolean;
        lodash2.isBuffer = isBuffer;
        lodash2.isDate = isDate;
        lodash2.isElement = isElement;
        lodash2.isEmpty = isEmpty2;
        lodash2.isEqual = isEqual4;
        lodash2.isEqualWith = isEqualWith;
        lodash2.isError = isError;
        lodash2.isFinite = isFinite2;
        lodash2.isFunction = isFunction2;
        lodash2.isInteger = isInteger;
        lodash2.isLength = isLength;
        lodash2.isMap = isMap;
        lodash2.isMatch = isMatch;
        lodash2.isMatchWith = isMatchWith;
        lodash2.isNaN = isNaN2;
        lodash2.isNative = isNative;
        lodash2.isNil = isNil;
        lodash2.isNull = isNull;
        lodash2.isNumber = isNumber;
        lodash2.isObject = isObject2;
        lodash2.isObjectLike = isObjectLike;
        lodash2.isPlainObject = isPlainObject2;
        lodash2.isRegExp = isRegExp;
        lodash2.isSafeInteger = isSafeInteger;
        lodash2.isSet = isSet;
        lodash2.isString = isString;
        lodash2.isSymbol = isSymbol;
        lodash2.isTypedArray = isTypedArray;
        lodash2.isUndefined = isUndefined;
        lodash2.isWeakMap = isWeakMap;
        lodash2.isWeakSet = isWeakSet;
        lodash2.join = join;
        lodash2.kebabCase = kebabCase;
        lodash2.last = last;
        lodash2.lastIndexOf = lastIndexOf;
        lodash2.lowerCase = lowerCase;
        lodash2.lowerFirst = lowerFirst;
        lodash2.lt = lt;
        lodash2.lte = lte;
        lodash2.max = max2;
        lodash2.maxBy = maxBy;
        lodash2.mean = mean;
        lodash2.meanBy = meanBy;
        lodash2.min = min2;
        lodash2.minBy = minBy;
        lodash2.stubArray = stubArray;
        lodash2.stubFalse = stubFalse;
        lodash2.stubObject = stubObject;
        lodash2.stubString = stubString;
        lodash2.stubTrue = stubTrue;
        lodash2.multiply = multiply;
        lodash2.nth = nth;
        lodash2.noConflict = noConflict;
        lodash2.noop = noop4;
        lodash2.now = now;
        lodash2.pad = pad;
        lodash2.padEnd = padEnd;
        lodash2.padStart = padStart;
        lodash2.parseInt = parseInt2;
        lodash2.random = random;
        lodash2.reduce = reduce;
        lodash2.reduceRight = reduceRight;
        lodash2.repeat = repeat;
        lodash2.replace = replace2;
        lodash2.result = result;
        lodash2.round = round2;
        lodash2.runInContext = runInContext2;
        lodash2.sample = sample;
        lodash2.size = size2;
        lodash2.snakeCase = snakeCase;
        lodash2.some = some;
        lodash2.sortedIndex = sortedIndex;
        lodash2.sortedIndexBy = sortedIndexBy;
        lodash2.sortedIndexOf = sortedIndexOf;
        lodash2.sortedLastIndex = sortedLastIndex;
        lodash2.sortedLastIndexBy = sortedLastIndexBy;
        lodash2.sortedLastIndexOf = sortedLastIndexOf;
        lodash2.startCase = startCase;
        lodash2.startsWith = startsWith;
        lodash2.subtract = subtract3;
        lodash2.sum = sum;
        lodash2.sumBy = sumBy;
        lodash2.template = template;
        lodash2.times = times;
        lodash2.toFinite = toFinite;
        lodash2.toInteger = toInteger;
        lodash2.toLength = toLength;
        lodash2.toLower = toLower;
        lodash2.toNumber = toNumber;
        lodash2.toSafeInteger = toSafeInteger;
        lodash2.toString = toString2;
        lodash2.toUpper = toUpper;
        lodash2.trim = trim2;
        lodash2.trimEnd = trimEnd;
        lodash2.trimStart = trimStart;
        lodash2.truncate = truncate;
        lodash2.unescape = unescape2;
        lodash2.uniqueId = uniqueId;
        lodash2.upperCase = upperCase;
        lodash2.upperFirst = upperFirst;
        lodash2.each = forEach;
        lodash2.eachRight = forEachRight;
        lodash2.first = head;
        mixin(lodash2, (function() {
          var source = {};
          baseForOwn(lodash2, function(func, methodName) {
            if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        })(), { "chain": false });
        lodash2.VERSION = VERSION2;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash2[methodName].placeholder = lodash2;
        });
        arrayEach(["drop", "take"], function(methodName, index2) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
          var type4 = index2 + 1, isFilter = type4 == LAZY_FILTER_FLAG || type4 == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type4
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index2) {
          var takeName = "take" + (index2 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index2) {
          var dropName = "drop" + (index2 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity2);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path2, args) {
          if (typeof path2 == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path2, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start2, end) {
          start2 = toInteger(start2);
          var result2 = this;
          if (result2.__filtered__ && (start2 > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start2 < 0) {
            result2 = result2.takeRight(-start2);
          } else if (start2) {
            result2 = result2.drop(start2);
          }
          if (end !== undefined$1) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start2);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash2.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash2.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash2[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined$1
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash2.prototype.at = wrapperAt;
        lodash2.prototype.chain = wrapperChain;
        lodash2.prototype.commit = wrapperCommit;
        lodash2.prototype.next = wrapperNext;
        lodash2.prototype.plant = wrapperPlant;
        lodash2.prototype.reverse = wrapperReverse;
        lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
        lodash2.prototype.first = lodash2.prototype.head;
        if (symIterator) {
          lodash2.prototype[symIterator] = wrapperToIterator;
        }
        return lodash2;
      });
      var _2 = runInContext();
      if (freeModule) {
        (freeModule.exports = _2)._ = _2;
        freeExports._ = _2;
      } else {
        root._ = _2;
      }
    }).call(lodash);
  })(lodash$1, lodash$1.exports);
  return lodash$1.exports;
}
var lodashExports = requireLodash();
const _ = /* @__PURE__ */ getDefaultExportFromCjs(lodashExports);
class CookieStorage {
  set(name, value, options) {
    api.set(name, value, options);
  }
  setJSON(name, value, options) {
    this.set(name, JSON.stringify(value), options);
  }
  get(name) {
    return api.get(name);
  }
  /**
   * Returns the parsed representation of the string
   * stored in the cookie according to JSON.parse
   */
  getJSON(name) {
    var value = this.get(name);
    if (value) return JSON.parse(value);
    return void 0;
  }
  remove(name, options) {
    api.remove(name, options);
  }
}
var HttpMethod = /* @__PURE__ */ ((HttpMethod2) => {
  HttpMethod2["GET"] = "get";
  HttpMethod2["POST"] = "post";
  HttpMethod2["PUT"] = "put";
  HttpMethod2["DELETE"] = "delete";
  return HttpMethod2;
})(HttpMethod || {});
class ApiRequest {
  constructor(options) {
    this.method = "get";
    this.autoUpdateUser = true;
    this.authorized = true;
    this.v = 1;
    this.headers = null;
    this.responseType = "json";
    Object.assign(this, options);
    this.cancellationToken = new AbortController();
  }
  get resultFields() {
    return this.fields ? this.fields.replace(new RegExp("\r?\n| ", "g"), "") : null;
  }
  cancel() {
    if (!this.cancellationToken)
      return;
    this.cancellationToken.abort("Cancelled by user");
  }
}
class ApiError {
  constructor(error2) {
    this.original = error2;
    this.message = error2.statusText;
  }
}
class ApiResponseError {
  constructor(code, message2, target) {
    this.code = code;
    this.message = message2;
    this.target = target;
  }
  static fromJson(json) {
    return new ApiResponseError(json.code, json.message, json.target);
  }
}
class ApiResponse {
  constructor(response = null) {
    this.errors = [];
    this.accessToken = null;
    this.refreshToken = null;
    this.resetToken = false;
    if (response == null || response.body == null && response.errors == null)
      return;
    this.errors = response.errors.map(ApiResponseError.fromJson);
    this.body = response.body;
    this.resetToken = response.resetToken;
    if (this.body != null) {
      this.accessToken = this.body.accessToken ?? null;
      this.refreshToken = this.body.refreshToken ?? null;
    }
  }
  get hasTokens() {
    return this.accessToken != null && this.refreshToken != null;
  }
  get hasErrors() {
    return this.errors.length > 0;
  }
  hasError(...error2) {
    return this.errors.some((x) => error2.includes(x.code));
  }
  getError(error2) {
    return this.errors.find((x) => x.code == error2);
  }
}
class ApiResult {
  constructor(result) {
    this.error = null;
    Object.assign(this, result);
  }
  get hasError() {
    return this.error != null || this.status != HttpStatusCode.OK;
  }
  get success() {
    return !this.hasError && !this.response.hasErrors;
  }
  hasResponseError(...errors) {
    return this.response.hasError(...errors);
  }
  /**
   * @deprecated use `useNotifier` | `useApiRequest` hooks or <Request> instead
   * @param opts 
   * @returns 
   */
  notify(opts = {}) {
    if (this.success) {
      opts.success && notification.success({ duration: 2, ...opts.success });
      return;
    }
    if (this.response.errors.length > 0) {
      this.response.errors.forEach((e) => {
        notification.error({ duration: 2, message: e.message });
      });
      return;
    }
    if (opts.error) {
      notification.error({ duration: 2, ...opts.error });
      return;
    }
    if (opts.loc) {
      notification.error({ duration: 2, message: opts.loc.word("Error occured") });
      return;
    }
  }
}
class BadApiResult extends ApiResult {
  constructor(status, response) {
    super({
      status: status ?? 0,
      response: response ?? new ApiResponse(null),
      error: response ? new ApiError(response) : null
    });
  }
  static withErrors(...errors) {
    return new BadApiResult(HttpStatusCode.OK, new ApiResponse({ body: null, errors: errors.map((x) => ({ code: x })) }));
  }
}
function toOptional(value) {
  if (value === void 0) return void 0;
  return { value };
}
var axios$1 = { exports: {} };
var bind$1;
var hasRequiredBind$1;
function requireBind$1() {
  if (hasRequiredBind$1) return bind$1;
  hasRequiredBind$1 = 1;
  bind$1 = function bind2(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      return fn.apply(thisArg, args);
    };
  };
  return bind$1;
}
var utils$3;
var hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3) return utils$3;
  hasRequiredUtils$3 = 1;
  var bind2 = requireBind$1();
  var toString2 = Object.prototype.toString;
  var kindOf = /* @__PURE__ */ (function(cache2) {
    return function(thing) {
      var str = toString2.call(thing);
      return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
    };
  })(/* @__PURE__ */ Object.create(null));
  function kindOfTest(type4) {
    type4 = type4.toLowerCase();
    return function isKindOf(thing) {
      return kindOf(thing) === type4;
    };
  }
  function isArray(val) {
    return Array.isArray(val);
  }
  function isUndefined(val) {
    return typeof val === "undefined";
  }
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
  }
  var isArrayBuffer2 = kindOfTest("ArrayBuffer");
  function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer2(val.buffer);
    }
    return result;
  }
  function isString(val) {
    return typeof val === "string";
  }
  function isNumber(val) {
    return typeof val === "number";
  }
  function isObject2(val) {
    return val !== null && typeof val === "object";
  }
  function isPlainObject2(val) {
    if (kindOf(val) !== "object") {
      return false;
    }
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
  }
  var isDate = kindOfTest("Date");
  var isFile = kindOfTest("File");
  var isBlob = kindOfTest("Blob");
  var isFileList = kindOfTest("FileList");
  function isFunction2(val) {
    return toString2.call(val) === "[object Function]";
  }
  function isStream(val) {
    return isObject2(val) && isFunction2(val.pipe);
  }
  function isFormData(thing) {
    var pattern4 = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || toString2.call(thing) === pattern4 || isFunction2(thing.toString) && thing.toString() === pattern4);
  }
  var isURLSearchParams = kindOfTest("URLSearchParams");
  function trim2(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
  }
  function isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
      return false;
    }
    return typeof window !== "undefined" && typeof document !== "undefined";
  }
  function forEach(obj, fn) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray(obj)) {
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }
  function merge2() {
    var result = {};
    function assignValue(val, key) {
      if (isPlainObject2(result[key]) && isPlainObject2(val)) {
        result[key] = merge2(result[key], val);
      } else if (isPlainObject2(val)) {
        result[key] = merge2({}, val);
      } else if (isArray(val)) {
        result[key] = val.slice();
      } else {
        result[key] = val;
      }
    }
    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }
  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === "function") {
        a[key] = bind2(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }
  function stripBOM(content2) {
    if (content2.charCodeAt(0) === 65279) {
      content2 = content2.slice(1);
    }
    return content2;
  }
  function inherits2(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
  }
  function toFlatObject(sourceObj, destObj, filter2) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
      props = Object.getOwnPropertyNames(sourceObj);
      i = props.length;
      while (i-- > 0) {
        prop = props[i];
        if (!merged[prop]) {
          destObj[prop] = sourceObj[prop];
          merged[prop] = true;
        }
      }
      sourceObj = Object.getPrototypeOf(sourceObj);
    } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
  }
  function endsWith(str, searchString, position2) {
    str = String(str);
    if (position2 === void 0 || position2 > str.length) {
      position2 = str.length;
    }
    position2 -= searchString.length;
    var lastIndex = str.indexOf(searchString, position2);
    return lastIndex !== -1 && lastIndex === position2;
  }
  function toArray2(thing) {
    if (!thing) return null;
    var i = thing.length;
    if (isUndefined(i)) return null;
    var arr = new Array(i);
    while (i-- > 0) {
      arr[i] = thing[i];
    }
    return arr;
  }
  var isTypedArray = /* @__PURE__ */ (function(TypedArray) {
    return function(thing) {
      return TypedArray && thing instanceof TypedArray;
    };
  })(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
  utils$3 = {
    isArray,
    isArrayBuffer: isArrayBuffer2,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isObject: isObject2,
    isPlainObject: isPlainObject2,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isFunction: isFunction2,
    isStream,
    isURLSearchParams,
    isStandardBrowserEnv,
    forEach,
    merge: merge2,
    extend,
    trim: trim2,
    stripBOM,
    inherits: inherits2,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray: toArray2,
    isTypedArray,
    isFileList
  };
  return utils$3;
}
var buildURL;
var hasRequiredBuildURL;
function requireBuildURL() {
  if (hasRequiredBuildURL) return buildURL;
  hasRequiredBuildURL = 1;
  var utils2 = requireUtils$3();
  function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  buildURL = function buildURL2(url2, params, paramsSerializer) {
    if (!params) {
      return url2;
    }
    var serializedParams;
    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils2.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];
      utils2.forEach(params, function serialize2(val, key) {
        if (val === null || typeof val === "undefined") {
          return;
        }
        if (utils2.isArray(val)) {
          key = key + "[]";
        } else {
          val = [val];
        }
        utils2.forEach(val, function parseValue(v) {
          if (utils2.isDate(v)) {
            v = v.toISOString();
          } else if (utils2.isObject(v)) {
            v = JSON.stringify(v);
          }
          parts.push(encode(key) + "=" + encode(v));
        });
      });
      serializedParams = parts.join("&");
    }
    if (serializedParams) {
      var hashmarkIndex = url2.indexOf("#");
      if (hashmarkIndex !== -1) {
        url2 = url2.slice(0, hashmarkIndex);
      }
      url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url2;
  };
  return buildURL;
}
var InterceptorManager_1;
var hasRequiredInterceptorManager;
function requireInterceptorManager() {
  if (hasRequiredInterceptorManager) return InterceptorManager_1;
  hasRequiredInterceptorManager = 1;
  var utils2 = requireUtils$3();
  function InterceptorManager() {
    this.handlers = [];
  }
  InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  };
  InterceptorManager.prototype.eject = function eject(id2) {
    if (this.handlers[id2]) {
      this.handlers[id2] = null;
    }
  };
  InterceptorManager.prototype.forEach = function forEach(fn) {
    utils2.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };
  InterceptorManager_1 = InterceptorManager;
  return InterceptorManager_1;
}
var normalizeHeaderName;
var hasRequiredNormalizeHeaderName;
function requireNormalizeHeaderName() {
  if (hasRequiredNormalizeHeaderName) return normalizeHeaderName;
  hasRequiredNormalizeHeaderName = 1;
  var utils2 = requireUtils$3();
  normalizeHeaderName = function normalizeHeaderName2(headers, normalizedName) {
    utils2.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };
  return normalizeHeaderName;
}
var AxiosError_1;
var hasRequiredAxiosError;
function requireAxiosError() {
  if (hasRequiredAxiosError) return AxiosError_1;
  hasRequiredAxiosError = 1;
  var utils2 = requireUtils$3();
  function AxiosError(message2, code, config2, request2, response) {
    Error.call(this);
    this.message = message2;
    this.name = "AxiosError";
    code && (this.code = code);
    config2 && (this.config = config2);
    request2 && (this.request = request2);
    response && (this.response = response);
  }
  utils2.inherits(AxiosError, Error, {
    toJSON: function toJSON() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  var prototype = AxiosError.prototype;
  var descriptors = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
    // eslint-disable-next-line func-names
  ].forEach(function(code) {
    descriptors[code] = { value: code };
  });
  Object.defineProperties(AxiosError, descriptors);
  Object.defineProperty(prototype, "isAxiosError", { value: true });
  AxiosError.from = function(error2, code, config2, request2, response, customProps) {
    var axiosError = Object.create(prototype);
    utils2.toFlatObject(error2, axiosError, function filter2(obj) {
      return obj !== Error.prototype;
    });
    AxiosError.call(axiosError, error2.message, code, config2, request2, response);
    axiosError.name = error2.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
  };
  AxiosError_1 = AxiosError;
  return AxiosError_1;
}
var transitional;
var hasRequiredTransitional;
function requireTransitional() {
  if (hasRequiredTransitional) return transitional;
  hasRequiredTransitional = 1;
  transitional = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  };
  return transitional;
}
var toFormData_1;
var hasRequiredToFormData;
function requireToFormData() {
  if (hasRequiredToFormData) return toFormData_1;
  hasRequiredToFormData = 1;
  var utils2 = requireUtils$3();
  function toFormData(obj, formData) {
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
      if (value === null) return "";
      if (utils2.isDate(value)) {
        return value.toISOString();
      }
      if (utils2.isArrayBuffer(value) || utils2.isTypedArray(value)) {
        return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
      }
      return value;
    }
    function build(data2, parentKey) {
      if (utils2.isPlainObject(data2) || utils2.isArray(data2)) {
        if (stack.indexOf(data2) !== -1) {
          throw Error("Circular reference detected in " + parentKey);
        }
        stack.push(data2);
        utils2.forEach(data2, function each(value, key) {
          if (utils2.isUndefined(value)) return;
          var fullKey = parentKey ? parentKey + "." + key : key;
          var arr;
          if (value && !parentKey && typeof value === "object") {
            if (utils2.endsWith(key, "{}")) {
              value = JSON.stringify(value);
            } else if (utils2.endsWith(key, "[]") && (arr = utils2.toArray(value))) {
              arr.forEach(function(el) {
                !utils2.isUndefined(el) && formData.append(fullKey, convertValue(el));
              });
              return;
            }
          }
          build(value, fullKey);
        });
        stack.pop();
      } else {
        formData.append(parentKey, convertValue(data2));
      }
    }
    build(obj);
    return formData;
  }
  toFormData_1 = toFormData;
  return toFormData_1;
}
var settle;
var hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle) return settle;
  hasRequiredSettle = 1;
  var AxiosError = requireAxiosError();
  settle = function settle2(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(new AxiosError(
        "Request failed with status code " + response.status,
        [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
        response.config,
        response.request,
        response
      ));
    }
  };
  return settle;
}
var cookies;
var hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies) return cookies;
  hasRequiredCookies = 1;
  var utils2 = requireUtils$3();
  cookies = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path2, domain2, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils2.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils2.isString(path2)) {
            cookie.push("path=" + path2);
          }
          if (utils2.isString(domain2)) {
            cookie.push("domain=" + domain2);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match2 ? decodeURIComponent(match2[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    })()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ (function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    })()
  );
  return cookies;
}
var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
  hasRequiredIsAbsoluteURL = 1;
  isAbsoluteURL = function isAbsoluteURL2(url2) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
  };
  return isAbsoluteURL;
}
var combineURLs;
var hasRequiredCombineURLs;
function requireCombineURLs() {
  if (hasRequiredCombineURLs) return combineURLs;
  hasRequiredCombineURLs = 1;
  combineURLs = function combineURLs2(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  };
  return combineURLs;
}
var buildFullPath;
var hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath) return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var isAbsoluteURL2 = requireIsAbsoluteURL();
  var combineURLs2 = requireCombineURLs();
  buildFullPath = function buildFullPath2(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL2(requestedURL)) {
      return combineURLs2(baseURL, requestedURL);
    }
    return requestedURL;
  };
  return buildFullPath;
}
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders) return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = requireUtils$3();
  var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  parseHeaders = function parseHeaders2(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) {
      return parsed;
    }
    utils2.forEach(headers.split("\n"), function parser(line2) {
      i = line2.indexOf(":");
      key = utils2.trim(line2.substr(0, i)).toLowerCase();
      val = utils2.trim(line2.substr(i + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === "set-cookie") {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      }
    });
    return parsed;
  };
  return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = requireUtils$3();
  isURLSameOrigin = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url2) {
        var href = url2;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin2(requestURL) {
        var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    })()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ (function nonStandardBrowserEnv() {
      return function isURLSameOrigin2() {
        return true;
      };
    })()
  );
  return isURLSameOrigin;
}
var CanceledError_1;
var hasRequiredCanceledError;
function requireCanceledError() {
  if (hasRequiredCanceledError) return CanceledError_1;
  hasRequiredCanceledError = 1;
  var AxiosError = requireAxiosError();
  var utils2 = requireUtils$3();
  function CanceledError(message2) {
    AxiosError.call(this, message2 == null ? "canceled" : message2, AxiosError.ERR_CANCELED);
    this.name = "CanceledError";
  }
  utils2.inherits(CanceledError, AxiosError, {
    __CANCEL__: true
  });
  CanceledError_1 = CanceledError;
  return CanceledError_1;
}
var parseProtocol;
var hasRequiredParseProtocol;
function requireParseProtocol() {
  if (hasRequiredParseProtocol) return parseProtocol;
  hasRequiredParseProtocol = 1;
  parseProtocol = function parseProtocol2(url2) {
    var match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url2);
    return match2 && match2[1] || "";
  };
  return parseProtocol;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr) return xhr;
  hasRequiredXhr = 1;
  var utils2 = requireUtils$3();
  var settle2 = requireSettle();
  var cookies2 = requireCookies();
  var buildURL2 = requireBuildURL();
  var buildFullPath2 = requireBuildFullPath();
  var parseHeaders2 = requireParseHeaders();
  var isURLSameOrigin2 = requireIsURLSameOrigin();
  var transitionalDefaults = requireTransitional();
  var AxiosError = requireAxiosError();
  var CanceledError = requireCanceledError();
  var parseProtocol2 = requireParseProtocol();
  xhr = function xhrAdapter(config2) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      var requestData = config2.data;
      var requestHeaders = config2.headers;
      var responseType = config2.responseType;
      var onCanceled;
      function done() {
        if (config2.cancelToken) {
          config2.cancelToken.unsubscribe(onCanceled);
        }
        if (config2.signal) {
          config2.signal.removeEventListener("abort", onCanceled);
        }
      }
      if (utils2.isFormData(requestData) && utils2.isStandardBrowserEnv()) {
        delete requestHeaders["Content-Type"];
      }
      var request2 = new XMLHttpRequest();
      if (config2.auth) {
        var username = config2.auth.username || "";
        var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath2(config2.baseURL, config2.url);
      request2.open(config2.method.toUpperCase(), buildURL2(fullPath, config2.params, config2.paramsSerializer), true);
      request2.timeout = config2.timeout;
      function onloadend() {
        if (!request2) {
          return;
        }
        var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
        var response = {
          data: responseData,
          status: request2.status,
          statusText: request2.statusText,
          headers: responseHeaders,
          config: config2,
          request: request2
        };
        settle2(function _resolve(value) {
          resolve(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);
        request2 = null;
      }
      if ("onloadend" in request2) {
        request2.onloadend = onloadend;
      } else {
        request2.onreadystatechange = function handleLoad() {
          if (!request2 || request2.readyState !== 4) {
            return;
          }
          if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request2.onabort = function handleAbort() {
        if (!request2) {
          return;
        }
        reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config2, request2));
        request2 = null;
      };
      request2.onerror = function handleError() {
        reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config2, request2, request2));
        request2 = null;
      };
      request2.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
        var transitional2 = config2.transitional || transitionalDefaults;
        if (config2.timeoutErrorMessage) {
          timeoutErrorMessage = config2.timeoutErrorMessage;
        }
        reject(new AxiosError(
          timeoutErrorMessage,
          transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
          config2,
          request2
        ));
        request2 = null;
      };
      if (utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config2.withCredentials || isURLSameOrigin2(fullPath)) && config2.xsrfCookieName ? cookies2.read(config2.xsrfCookieName) : void 0;
        if (xsrfValue) {
          requestHeaders[config2.xsrfHeaderName] = xsrfValue;
        }
      }
      if ("setRequestHeader" in request2) {
        utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
            delete requestHeaders[key];
          } else {
            request2.setRequestHeader(key, val);
          }
        });
      }
      if (!utils2.isUndefined(config2.withCredentials)) {
        request2.withCredentials = !!config2.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request2.responseType = config2.responseType;
      }
      if (typeof config2.onDownloadProgress === "function") {
        request2.addEventListener("progress", config2.onDownloadProgress);
      }
      if (typeof config2.onUploadProgress === "function" && request2.upload) {
        request2.upload.addEventListener("progress", config2.onUploadProgress);
      }
      if (config2.cancelToken || config2.signal) {
        onCanceled = function(cancel2) {
          if (!request2) {
            return;
          }
          reject(!cancel2 || cancel2 && cancel2.type ? new CanceledError() : cancel2);
          request2.abort();
          request2 = null;
        };
        config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
        if (config2.signal) {
          config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
        }
      }
      if (!requestData) {
        requestData = null;
      }
      var protocol2 = parseProtocol2(fullPath);
      if (protocol2 && ["http", "https", "file"].indexOf(protocol2) === -1) {
        reject(new AxiosError("Unsupported protocol " + protocol2 + ":", AxiosError.ERR_BAD_REQUEST, config2));
        return;
      }
      request2.send(requestData);
    });
  };
  return xhr;
}
var _null;
var hasRequired_null;
function require_null() {
  if (hasRequired_null) return _null;
  hasRequired_null = 1;
  _null = null;
  return _null;
}
var defaults_1;
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults) return defaults_1;
  hasRequiredDefaults = 1;
  var utils2 = requireUtils$3();
  var normalizeHeaderName2 = requireNormalizeHeaderName();
  var AxiosError = requireAxiosError();
  var transitionalDefaults = requireTransitional();
  var toFormData = requireToFormData();
  var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function setContentTypeIfUnset(headers, value) {
    if (!utils2.isUndefined(headers) && utils2.isUndefined(headers["Content-Type"])) {
      headers["Content-Type"] = value;
    }
  }
  function getDefaultAdapter() {
    var adapter2;
    if (typeof XMLHttpRequest !== "undefined") {
      adapter2 = requireXhr();
    } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
      adapter2 = requireXhr();
    }
    return adapter2;
  }
  function stringifySafely(rawValue, parser, encoder) {
    if (utils2.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils2.trim(rawValue);
      } catch (e) {
        if (e.name !== "SyntaxError") {
          throw e;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  var defaults2 = {
    transitional: transitionalDefaults,
    adapter: getDefaultAdapter(),
    transformRequest: [function transformRequest(data2, headers) {
      normalizeHeaderName2(headers, "Accept");
      normalizeHeaderName2(headers, "Content-Type");
      if (utils2.isFormData(data2) || utils2.isArrayBuffer(data2) || utils2.isBuffer(data2) || utils2.isStream(data2) || utils2.isFile(data2) || utils2.isBlob(data2)) {
        return data2;
      }
      if (utils2.isArrayBufferView(data2)) {
        return data2.buffer;
      }
      if (utils2.isURLSearchParams(data2)) {
        setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
        return data2.toString();
      }
      var isObjectPayload = utils2.isObject(data2);
      var contentType = headers && headers["Content-Type"];
      var isFileList;
      if ((isFileList = utils2.isFileList(data2)) || isObjectPayload && contentType === "multipart/form-data") {
        var _FormData = this.env && this.env.FormData;
        return toFormData(isFileList ? { "files[]": data2 } : data2, _FormData && new _FormData());
      } else if (isObjectPayload || contentType === "application/json") {
        setContentTypeIfUnset(headers, "application/json");
        return stringifySafely(data2);
      }
      return data2;
    }],
    transformResponse: [function transformResponse(data2) {
      var transitional2 = this.transitional || defaults2.transitional;
      var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
      var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
      if (strictJSONParsing || forcedJSONParsing && utils2.isString(data2) && data2.length) {
        try {
          return JSON.parse(data2);
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === "SyntaxError") {
              throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
            }
            throw e;
          }
        }
      }
      return data2;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: require_null()
    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    }
  };
  utils2.forEach(["delete", "get", "head"], function forEachMethodNoData(method4) {
    defaults2.headers[method4] = {};
  });
  utils2.forEach(["post", "put", "patch"], function forEachMethodWithData(method4) {
    defaults2.headers[method4] = utils2.merge(DEFAULT_CONTENT_TYPE);
  });
  defaults_1 = defaults2;
  return defaults_1;
}
var transformData;
var hasRequiredTransformData;
function requireTransformData() {
  if (hasRequiredTransformData) return transformData;
  hasRequiredTransformData = 1;
  var utils2 = requireUtils$3();
  var defaults2 = requireDefaults();
  transformData = function transformData2(data2, headers, fns) {
    var context2 = this || defaults2;
    utils2.forEach(fns, function transform3(fn) {
      data2 = fn.call(context2, data2, headers);
    });
    return data2;
  };
  return transformData;
}
var isCancel;
var hasRequiredIsCancel;
function requireIsCancel() {
  if (hasRequiredIsCancel) return isCancel;
  hasRequiredIsCancel = 1;
  isCancel = function isCancel2(value) {
    return !!(value && value.__CANCEL__);
  };
  return isCancel;
}
var dispatchRequest;
var hasRequiredDispatchRequest;
function requireDispatchRequest() {
  if (hasRequiredDispatchRequest) return dispatchRequest;
  hasRequiredDispatchRequest = 1;
  var utils2 = requireUtils$3();
  var transformData2 = requireTransformData();
  var isCancel2 = requireIsCancel();
  var defaults2 = requireDefaults();
  var CanceledError = requireCanceledError();
  function throwIfCancellationRequested(config2) {
    if (config2.cancelToken) {
      config2.cancelToken.throwIfRequested();
    }
    if (config2.signal && config2.signal.aborted) {
      throw new CanceledError();
    }
  }
  dispatchRequest = function dispatchRequest2(config2) {
    throwIfCancellationRequested(config2);
    config2.headers = config2.headers || {};
    config2.data = transformData2.call(
      config2,
      config2.data,
      config2.headers,
      config2.transformRequest
    );
    config2.headers = utils2.merge(
      config2.headers.common || {},
      config2.headers[config2.method] || {},
      config2.headers
    );
    utils2.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function cleanHeaderConfig(method4) {
        delete config2.headers[method4];
      }
    );
    var adapter2 = config2.adapter || defaults2.adapter;
    return adapter2(config2).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config2);
      response.data = transformData2.call(
        config2,
        response.data,
        response.headers,
        config2.transformResponse
      );
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel2(reason)) {
        throwIfCancellationRequested(config2);
        if (reason && reason.response) {
          reason.response.data = transformData2.call(
            config2,
            reason.response.data,
            reason.response.headers,
            config2.transformResponse
          );
        }
      }
      return Promise.reject(reason);
    });
  };
  return dispatchRequest;
}
var mergeConfig;
var hasRequiredMergeConfig;
function requireMergeConfig() {
  if (hasRequiredMergeConfig) return mergeConfig;
  hasRequiredMergeConfig = 1;
  var utils2 = requireUtils$3();
  mergeConfig = function mergeConfig2(config1, config2) {
    config2 = config2 || {};
    var config3 = {};
    function getMergedValue(target, source) {
      if (utils2.isPlainObject(target) && utils2.isPlainObject(source)) {
        return utils2.merge(target, source);
      } else if (utils2.isPlainObject(source)) {
        return utils2.merge({}, source);
      } else if (utils2.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (!utils2.isUndefined(config1[prop])) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    function valueFromConfig2(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(void 0, config2[prop]);
      }
    }
    function defaultToConfig2(prop) {
      if (!utils2.isUndefined(config2[prop])) {
        return getMergedValue(void 0, config2[prop]);
      } else if (!utils2.isUndefined(config1[prop])) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    function mergeDirectKeys(prop) {
      if (prop in config2) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (prop in config1) {
        return getMergedValue(void 0, config1[prop]);
      }
    }
    var mergeMap = {
      "url": valueFromConfig2,
      "method": valueFromConfig2,
      "data": valueFromConfig2,
      "baseURL": defaultToConfig2,
      "transformRequest": defaultToConfig2,
      "transformResponse": defaultToConfig2,
      "paramsSerializer": defaultToConfig2,
      "timeout": defaultToConfig2,
      "timeoutMessage": defaultToConfig2,
      "withCredentials": defaultToConfig2,
      "adapter": defaultToConfig2,
      "responseType": defaultToConfig2,
      "xsrfCookieName": defaultToConfig2,
      "xsrfHeaderName": defaultToConfig2,
      "onUploadProgress": defaultToConfig2,
      "onDownloadProgress": defaultToConfig2,
      "decompress": defaultToConfig2,
      "maxContentLength": defaultToConfig2,
      "maxBodyLength": defaultToConfig2,
      "beforeRedirect": defaultToConfig2,
      "transport": defaultToConfig2,
      "httpAgent": defaultToConfig2,
      "httpsAgent": defaultToConfig2,
      "cancelToken": defaultToConfig2,
      "socketPath": defaultToConfig2,
      "responseEncoding": defaultToConfig2,
      "validateStatus": mergeDirectKeys
    };
    utils2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
      var merge2 = mergeMap[prop] || mergeDeepProperties;
      var configValue = merge2(prop);
      utils2.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config3[prop] = configValue);
    });
    return config3;
  };
  return mergeConfig;
}
var data$1;
var hasRequiredData;
function requireData() {
  if (hasRequiredData) return data$1;
  hasRequiredData = 1;
  data$1 = {
    "version": "0.27.2"
  };
  return data$1;
}
var validator;
var hasRequiredValidator;
function requireValidator() {
  if (hasRequiredValidator) return validator;
  hasRequiredValidator = 1;
  var VERSION2 = requireData().version;
  var AxiosError = requireAxiosError();
  var validators2 = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type4, i) {
    validators2[type4] = function validator2(thing) {
      return typeof thing === type4 || "a" + (i < 1 ? "n " : " ") + type4;
    };
  });
  var deprecatedWarnings = {};
  validators2.transitional = function transitional2(validator2, version2, message2) {
    function formatMessage(opt, desc) {
      return "[Axios v" + VERSION2 + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
    }
    return function(value, opt, opts) {
      if (validator2 === false) {
        throw new AxiosError(
          formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
          AxiosError.ERR_DEPRECATED
        );
      }
      if (version2 && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        console.warn(
          formatMessage(
            opt,
            " has been deprecated since v" + version2 + " and will be removed in the near future"
          )
        );
      }
      return validator2 ? validator2(value, opt, opts) : true;
    };
  };
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") {
      throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
    }
    var keys2 = Object.keys(options);
    var i = keys2.length;
    while (i-- > 0) {
      var opt = keys2[i];
      var validator2 = schema[opt];
      if (validator2) {
        var value = options[opt];
        var result = value === void 0 || validator2(value, opt, options);
        if (result !== true) {
          throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
      }
    }
  }
  validator = {
    assertOptions,
    validators: validators2
  };
  return validator;
}
var Axios_1;
var hasRequiredAxios$2;
function requireAxios$2() {
  if (hasRequiredAxios$2) return Axios_1;
  hasRequiredAxios$2 = 1;
  var utils2 = requireUtils$3();
  var buildURL2 = requireBuildURL();
  var InterceptorManager = requireInterceptorManager();
  var dispatchRequest2 = requireDispatchRequest();
  var mergeConfig2 = requireMergeConfig();
  var buildFullPath2 = requireBuildFullPath();
  var validator2 = requireValidator();
  var validators2 = validator2.validators;
  function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  Axios.prototype.request = function request2(configOrUrl, config2) {
    if (typeof configOrUrl === "string") {
      config2 = config2 || {};
      config2.url = configOrUrl;
    } else {
      config2 = configOrUrl || {};
    }
    config2 = mergeConfig2(this.defaults, config2);
    if (config2.method) {
      config2.method = config2.method.toLowerCase();
    } else if (this.defaults.method) {
      config2.method = this.defaults.method.toLowerCase();
    } else {
      config2.method = "get";
    }
    var transitional2 = config2.transitional;
    if (transitional2 !== void 0) {
      validator2.assertOptions(transitional2, {
        silentJSONParsing: validators2.transitional(validators2.boolean),
        forcedJSONParsing: validators2.transitional(validators2.boolean),
        clarifyTimeoutError: validators2.transitional(validators2.boolean)
      }, false);
    }
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
      var chain = [dispatchRequest2, void 0];
      Array.prototype.unshift.apply(chain, requestInterceptorChain);
      chain = chain.concat(responseInterceptorChain);
      promise = Promise.resolve(config2);
      while (chain.length) {
        promise = promise.then(chain.shift(), chain.shift());
      }
      return promise;
    }
    var newConfig = config2;
    while (requestInterceptorChain.length) {
      var onFulfilled = requestInterceptorChain.shift();
      var onRejected = requestInterceptorChain.shift();
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error2) {
        onRejected(error2);
        break;
      }
    }
    try {
      promise = dispatchRequest2(newConfig);
    } catch (error2) {
      return Promise.reject(error2);
    }
    while (responseInterceptorChain.length) {
      promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    }
    return promise;
  };
  Axios.prototype.getUri = function getUri(config2) {
    config2 = mergeConfig2(this.defaults, config2);
    var fullPath = buildFullPath2(config2.baseURL, config2.url);
    return buildURL2(fullPath, config2.params, config2.paramsSerializer);
  };
  utils2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method4) {
    Axios.prototype[method4] = function(url2, config2) {
      return this.request(mergeConfig2(config2 || {}, {
        method: method4,
        url: url2,
        data: (config2 || {}).data
      }));
    };
  });
  utils2.forEach(["post", "put", "patch"], function forEachMethodWithData(method4) {
    function generateHTTPMethod(isForm) {
      return function httpMethod(url2, data2, config2) {
        return this.request(mergeConfig2(config2 || {}, {
          method: method4,
          headers: isForm ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: url2,
          data: data2
        }));
      };
    }
    Axios.prototype[method4] = generateHTTPMethod();
    Axios.prototype[method4 + "Form"] = generateHTTPMethod(true);
  });
  Axios_1 = Axios;
  return Axios_1;
}
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken) return CancelToken_1;
  hasRequiredCancelToken = 1;
  var CanceledError = requireCanceledError();
  function CancelToken(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    var token2 = this;
    this.promise.then(function(cancel2) {
      if (!token2._listeners) return;
      var i;
      var l = token2._listeners.length;
      for (i = 0; i < l; i++) {
        token2._listeners[i](cancel2);
      }
      token2._listeners = null;
    });
    this.promise.then = function(onfulfilled) {
      var _resolve;
      var promise = new Promise(function(resolve) {
        token2.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token2.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel2(message2) {
      if (token2.reason) {
        return;
      }
      token2.reason = new CanceledError(message2);
      resolvePromise(token2.reason);
    });
  }
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  };
  CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    var index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  };
  CancelToken.source = function source() {
    var cancel2;
    var token2 = new CancelToken(function executor(c) {
      cancel2 = c;
    });
    return {
      token: token2,
      cancel: cancel2
    };
  };
  CancelToken_1 = CancelToken;
  return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
  if (hasRequiredSpread) return spread;
  hasRequiredSpread = 1;
  spread = function spread2(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError) return isAxiosError;
  hasRequiredIsAxiosError = 1;
  var utils2 = requireUtils$3();
  isAxiosError = function isAxiosError2(payload) {
    return utils2.isObject(payload) && payload.isAxiosError === true;
  };
  return isAxiosError;
}
var hasRequiredAxios$1;
function requireAxios$1() {
  if (hasRequiredAxios$1) return axios$1.exports;
  hasRequiredAxios$1 = 1;
  var utils2 = requireUtils$3();
  var bind2 = requireBind$1();
  var Axios = requireAxios$2();
  var mergeConfig2 = requireMergeConfig();
  var defaults2 = requireDefaults();
  function createInstance(defaultConfig) {
    var context2 = new Axios(defaultConfig);
    var instance = bind2(Axios.prototype.request, context2);
    utils2.extend(instance, Axios.prototype, context2);
    utils2.extend(instance, context2);
    instance.create = function create(instanceConfig) {
      return createInstance(mergeConfig2(defaultConfig, instanceConfig));
    };
    return instance;
  }
  var axios2 = createInstance(defaults2);
  axios2.Axios = Axios;
  axios2.CanceledError = requireCanceledError();
  axios2.CancelToken = requireCancelToken();
  axios2.isCancel = requireIsCancel();
  axios2.VERSION = requireData().version;
  axios2.toFormData = requireToFormData();
  axios2.AxiosError = requireAxiosError();
  axios2.Cancel = axios2.CanceledError;
  axios2.all = function all(promises) {
    return Promise.all(promises);
  };
  axios2.spread = requireSpread();
  axios2.isAxiosError = requireIsAxiosError();
  axios$1.exports = axios2;
  axios$1.exports.default = axios2;
  return axios$1.exports;
}
var axios;
var hasRequiredAxios;
function requireAxios() {
  if (hasRequiredAxios) return axios;
  hasRequiredAxios = 1;
  axios = requireAxios$1();
  return axios;
}
requireAxios();
var type$2;
var hasRequiredType;
function requireType() {
  if (hasRequiredType) return type$2;
  hasRequiredType = 1;
  type$2 = TypeError;
  return type$2;
}
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var objectInspect;
var hasRequiredObjectInspect;
function requireObjectInspect() {
  if (hasRequiredObjectInspect) return objectInspect;
  hasRequiredObjectInspect = 1;
  var hasMap = typeof Map === "function" && Map.prototype;
  var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
  var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
  var mapForEach = hasMap && Map.prototype.forEach;
  var hasSet = typeof Set === "function" && Set.prototype;
  var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
  var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
  var setForEach = hasSet && Set.prototype.forEach;
  var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
  var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
  var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
  var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
  var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
  var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
  var booleanValueOf = Boolean.prototype.valueOf;
  var objectToString = Object.prototype.toString;
  var functionToString = Function.prototype.toString;
  var $match = String.prototype.match;
  var $slice = String.prototype.slice;
  var $replace = String.prototype.replace;
  var $toUpperCase = String.prototype.toUpperCase;
  var $toLowerCase = String.prototype.toLowerCase;
  var $test = RegExp.prototype.test;
  var $concat = Array.prototype.concat;
  var $join = Array.prototype.join;
  var $arrSlice = Array.prototype.slice;
  var $floor = Math.floor;
  var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
  var gOPS = Object.getOwnPropertySymbols;
  var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
  var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
  var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
    return O.__proto__;
  } : null);
  function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
      return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
      var int = num < 0 ? -$floor(-num) : $floor(num);
      if (int !== num) {
        var intStr = String(int);
        var dec = $slice.call(str, intStr.length + 1);
        return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return $replace.call(str, sepRegex, "$&_");
  }
  var utilInspect = require$$0$1;
  var inspectCustom = utilInspect.custom;
  var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
  var quotes = {
    __proto__: null,
    "double": '"',
    single: "'"
  };
  var quoteREs = {
    __proto__: null,
    "double": /(["\\])/g,
    single: /(['\\])/g
  };
  objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has2(opts, "quoteStyle") && !has2(quotes, opts.quoteStyle)) {
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (has2(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has2(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    }
    if (has2(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has2(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") {
      return "undefined";
    }
    if (obj === null) {
      return "null";
    }
    if (typeof obj === "boolean") {
      return obj ? "true" : "false";
    }
    if (typeof obj === "string") {
      return inspectString(obj, opts);
    }
    if (typeof obj === "number") {
      if (obj === 0) {
        return Infinity / obj > 0 ? "0" : "-0";
      }
      var str = String(obj);
      return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
      var bigIntStr = String(obj) + "n";
      return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") {
      depth = 0;
    }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
      return isArray(obj) ? "[Array]" : "[Object]";
    }
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") {
      seen = [];
    } else if (indexOf(seen, obj) >= 0) {
      return "[Circular]";
    }
    function inspect(value, from2, noIndent) {
      if (from2) {
        seen = $arrSlice.call(seen);
        seen.push(from2);
      }
      if (noIndent) {
        var newOpts = {
          depth: opts.depth
        };
        if (has2(opts, "quoteStyle")) {
          newOpts.quoteStyle = opts.quoteStyle;
        }
        return inspect_(value, newOpts, depth + 1, seen);
      }
      return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
      var name = nameOf(obj);
      var keys2 = arrObjKeys(obj, inspect);
      return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys2.length > 0 ? " { " + $join.call(keys2, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
      var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
      return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
      var s = "<" + $toLowerCase.call(String(obj.nodeName));
      var attrs = obj.attributes || [];
      for (var i = 0; i < attrs.length; i++) {
        s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
      }
      s += ">";
      if (obj.childNodes && obj.childNodes.length) {
        s += "...";
      }
      s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
      return s;
    }
    if (isArray(obj)) {
      if (obj.length === 0) {
        return "[]";
      }
      var xs = arrObjKeys(obj, inspect);
      if (indent && !singleLineValues(xs)) {
        return "[" + indentedJoin(xs, indent) + "]";
      }
      return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
      var parts = arrObjKeys(obj, inspect);
      if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
        return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
      }
      if (parts.length === 0) {
        return "[" + String(obj) + "]";
      }
      return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
      if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
        return utilInspect(obj, { depth: maxDepth - depth });
      } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
        return obj.inspect();
      }
    }
    if (isMap(obj)) {
      var mapParts = [];
      if (mapForEach) {
        mapForEach.call(obj, function(value, key) {
          mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
      }
      return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
      var setParts = [];
      if (setForEach) {
        setForEach.call(obj, function(value) {
          setParts.push(inspect(value, obj));
        });
      }
      return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
      return weakCollectionOf("WeakMap");
    }
    if (isWeakSet(obj)) {
      return weakCollectionOf("WeakSet");
    }
    if (isWeakRef(obj)) {
      return weakCollectionOf("WeakRef");
    }
    if (isNumber(obj)) {
      return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
      return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
      return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
      return markBoxed(inspect(String(obj)));
    }
    if (typeof window !== "undefined" && obj === window) {
      return "{ [object Window] }";
    }
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof commonjsGlobal !== "undefined" && obj === commonjsGlobal) {
      return "{ [object globalThis] }";
    }
    if (!isDate(obj) && !isRegExp(obj)) {
      var ys = arrObjKeys(obj, inspect);
      var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
      var protoTag = obj instanceof Object ? "" : "null prototype";
      var stringTag = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
      var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
      var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
      if (ys.length === 0) {
        return tag + "{}";
      }
      if (indent) {
        return tag + "{" + indentedJoin(ys, indent) + "}";
      }
      return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
  };
  function wrapQuotes(s, defaultStyle, opts) {
    var style2 = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style2];
    return quoteChar + s + quoteChar;
  }
  function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
  }
  function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === "object" && (toStringTag in obj || typeof obj[toStringTag] !== "undefined"));
  }
  function isArray(obj) {
    return toStr(obj) === "[object Array]" && canTrustToString(obj);
  }
  function isDate(obj) {
    return toStr(obj) === "[object Date]" && canTrustToString(obj);
  }
  function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && canTrustToString(obj);
  }
  function isError(obj) {
    return toStr(obj) === "[object Error]" && canTrustToString(obj);
  }
  function isString(obj) {
    return toStr(obj) === "[object String]" && canTrustToString(obj);
  }
  function isNumber(obj) {
    return toStr(obj) === "[object Number]" && canTrustToString(obj);
  }
  function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && canTrustToString(obj);
  }
  function isSymbol(obj) {
    if (hasShammedSymbols) {
      return obj && typeof obj === "object" && obj instanceof Symbol;
    }
    if (typeof obj === "symbol") {
      return true;
    }
    if (!obj || typeof obj !== "object" || !symToString) {
      return false;
    }
    try {
      symToString.call(obj);
      return true;
    } catch (e) {
    }
    return false;
  }
  function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) {
      return false;
    }
    try {
      bigIntValueOf.call(obj);
      return true;
    } catch (e) {
    }
    return false;
  }
  var hasOwn2 = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
  };
  function has2(obj, key) {
    return hasOwn2.call(obj, key);
  }
  function toStr(obj) {
    return objectToString.call(obj);
  }
  function nameOf(f) {
    if (f.name) {
      return f.name;
    }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) {
      return m[1];
    }
    return null;
  }
  function indexOf(xs, x) {
    if (xs.indexOf) {
      return xs.indexOf(x);
    }
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) {
        return i;
      }
    }
    return -1;
  }
  function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") {
      return false;
    }
    try {
      mapSize.call(x);
      try {
        setSize.call(x);
      } catch (s) {
        return true;
      }
      return x instanceof Map;
    } catch (e) {
    }
    return false;
  }
  function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakMapHas.call(x, weakMapHas);
      try {
        weakSetHas.call(x, weakSetHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakMap;
    } catch (e) {
    }
    return false;
  }
  function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakRefDeref.call(x);
      return true;
    } catch (e) {
    }
    return false;
  }
  function isSet(x) {
    if (!setSize || !x || typeof x !== "object") {
      return false;
    }
    try {
      setSize.call(x);
      try {
        mapSize.call(x);
      } catch (m) {
        return true;
      }
      return x instanceof Set;
    } catch (e) {
    }
    return false;
  }
  function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakSetHas.call(x, weakSetHas);
      try {
        weakMapHas.call(x, weakMapHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakSet;
    } catch (e) {
    }
    return false;
  }
  function isElement(x) {
    if (!x || typeof x !== "object") {
      return false;
    }
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
      return true;
    }
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
  }
  function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
      var remaining = str.length - opts.maxStringLength;
      var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
      return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || "single"];
    quoteRE.lastIndex = 0;
    var s = $replace.call($replace.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
  }
  function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[n];
    if (x) {
      return "\\" + x;
    }
    return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
  }
  function markBoxed(str) {
    return "Object(" + str + ")";
  }
  function weakCollectionOf(type4) {
    return type4 + " { ? }";
  }
  function collectionOf(type4, size2, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type4 + " (" + size2 + ") {" + joinedEntries + "}";
  }
  function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
      if (indexOf(xs[i], "\n") >= 0) {
        return false;
      }
    }
    return true;
  }
  function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") {
      baseIndent = "	";
    } else if (typeof opts.indent === "number" && opts.indent > 0) {
      baseIndent = $join.call(Array(opts.indent + 1), " ");
    } else {
      return null;
    }
    return {
      base: baseIndent,
      prev: $join.call(Array(depth + 1), baseIndent)
    };
  }
  function indentedJoin(xs, indent) {
    if (xs.length === 0) {
      return "";
    }
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
  }
  function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
      xs.length = obj.length;
      for (var i = 0; i < obj.length; i++) {
        xs[i] = has2(obj, i) ? inspect(obj[i], obj) : "";
      }
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
      symMap = {};
      for (var k = 0; k < syms.length; k++) {
        symMap["$" + syms[k]] = syms[k];
      }
    }
    for (var key in obj) {
      if (!has2(obj, key)) {
        continue;
      }
      if (isArr && String(Number(key)) === key && key < obj.length) {
        continue;
      }
      if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
        continue;
      } else if ($test.call(/[^\w$]/, key)) {
        xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
      } else {
        xs.push(key + ": " + inspect(obj[key], obj));
      }
    }
    if (typeof gOPS === "function") {
      for (var j = 0; j < syms.length; j++) {
        if (isEnumerable.call(obj, syms[j])) {
          xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
        }
      }
    }
    return xs;
  }
  return objectInspect;
}
var sideChannelList;
var hasRequiredSideChannelList;
function requireSideChannelList() {
  if (hasRequiredSideChannelList) return sideChannelList;
  hasRequiredSideChannelList = 1;
  var inspect = /* @__PURE__ */ requireObjectInspect();
  var $TypeError = /* @__PURE__ */ requireType();
  var listGetNode = function(list, key, isDelete) {
    var prev4 = list;
    var curr;
    for (; (curr = prev4.next) != null; prev4 = curr) {
      if (curr.key === key) {
        prev4.next = curr.next;
        if (!isDelete) {
          curr.next = /** @type {NonNullable<typeof list.next>} */
          list.next;
          list.next = curr;
        }
        return curr;
      }
    }
  };
  var listGet = function(objects2, key) {
    if (!objects2) {
      return void 0;
    }
    var node2 = listGetNode(objects2, key);
    return node2 && node2.value;
  };
  var listSet = function(objects2, key, value) {
    var node2 = listGetNode(objects2, key);
    if (node2) {
      node2.value = value;
    } else {
      objects2.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
      {
        // eslint-disable-line no-param-reassign, no-extra-parens
        key,
        next: objects2.next,
        value
      };
    }
  };
  var listHas = function(objects2, key) {
    if (!objects2) {
      return false;
    }
    return !!listGetNode(objects2, key);
  };
  var listDelete = function(objects2, key) {
    if (objects2) {
      return listGetNode(objects2, key, true);
    }
  };
  sideChannelList = function getSideChannelList() {
    var $o;
    var channel = {
      assert: function(key) {
        if (!channel.has(key)) {
          throw new $TypeError("Side channel does not contain " + inspect(key));
        }
      },
      "delete": function(key) {
        var root = $o && $o.next;
        var deletedNode = listDelete($o, key);
        if (deletedNode && root && root === deletedNode) {
          $o = void 0;
        }
        return !!deletedNode;
      },
      get: function(key) {
        return listGet($o, key);
      },
      has: function(key) {
        return listHas($o, key);
      },
      set: function(key, value) {
        if (!$o) {
          $o = {
            next: void 0
          };
        }
        listSet(
          /** @type {NonNullable<typeof $o>} */
          $o,
          key,
          value
        );
      }
    };
    return channel;
  };
  return sideChannelList;
}
var esObjectAtoms;
var hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  if (hasRequiredEsObjectAtoms) return esObjectAtoms;
  hasRequiredEsObjectAtoms = 1;
  esObjectAtoms = Object;
  return esObjectAtoms;
}
var esErrors;
var hasRequiredEsErrors;
function requireEsErrors() {
  if (hasRequiredEsErrors) return esErrors;
  hasRequiredEsErrors = 1;
  esErrors = Error;
  return esErrors;
}
var _eval;
var hasRequired_eval;
function require_eval() {
  if (hasRequired_eval) return _eval;
  hasRequired_eval = 1;
  _eval = EvalError;
  return _eval;
}
var range$1;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range$1;
  hasRequiredRange = 1;
  range$1 = RangeError;
  return range$1;
}
var ref$1;
var hasRequiredRef$1;
function requireRef$1() {
  if (hasRequiredRef$1) return ref$1;
  hasRequiredRef$1 = 1;
  ref$1 = ReferenceError;
  return ref$1;
}
var syntax;
var hasRequiredSyntax;
function requireSyntax() {
  if (hasRequiredSyntax) return syntax;
  hasRequiredSyntax = 1;
  syntax = SyntaxError;
  return syntax;
}
var uri;
var hasRequiredUri;
function requireUri() {
  if (hasRequiredUri) return uri;
  hasRequiredUri = 1;
  uri = URIError;
  return uri;
}
var abs$2;
var hasRequiredAbs;
function requireAbs() {
  if (hasRequiredAbs) return abs$2;
  hasRequiredAbs = 1;
  abs$2 = Math.abs;
  return abs$2;
}
var floor;
var hasRequiredFloor;
function requireFloor() {
  if (hasRequiredFloor) return floor;
  hasRequiredFloor = 1;
  floor = Math.floor;
  return floor;
}
var max;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max;
  hasRequiredMax = 1;
  max = Math.max;
  return max;
}
var min;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min;
  hasRequiredMin = 1;
  min = Math.min;
  return min;
}
var pow;
var hasRequiredPow;
function requirePow() {
  if (hasRequiredPow) return pow;
  hasRequiredPow = 1;
  pow = Math.pow;
  return pow;
}
var round$1;
var hasRequiredRound;
function requireRound() {
  if (hasRequiredRound) return round$1;
  hasRequiredRound = 1;
  round$1 = Math.round;
  return round$1;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
  if (hasRequired_isNaN) return _isNaN;
  hasRequired_isNaN = 1;
  _isNaN = Number.isNaN || function isNaN2(a) {
    return a !== a;
  };
  return _isNaN;
}
var sign;
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign;
  hasRequiredSign = 1;
  var $isNaN = /* @__PURE__ */ require_isNaN();
  sign = function sign2(number4) {
    if ($isNaN(number4) || number4 === 0) {
      return number4;
    }
    return number4 < 0 ? -1 : 1;
  };
  return sign;
}
var gOPD;
var hasRequiredGOPD;
function requireGOPD() {
  if (hasRequiredGOPD) return gOPD;
  hasRequiredGOPD = 1;
  gOPD = Object.getOwnPropertyDescriptor;
  return gOPD;
}
var gopd;
var hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var $gOPD = /* @__PURE__ */ requireGOPD();
  if ($gOPD) {
    try {
      $gOPD([], "length");
    } catch (e) {
      $gOPD = null;
    }
  }
  gopd = $gOPD;
  return gopd;
}
var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var $defineProperty = Object.defineProperty || false;
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e) {
      $defineProperty = false;
    }
  }
  esDefineProperty = $defineProperty;
  return esDefineProperty;
}
var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  shams = function hasSymbols2() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
      return false;
    }
    if (typeof Symbol.iterator === "symbol") {
      return true;
    }
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
      return false;
    }
    var symVal = 42;
    obj[sym] = symVal;
    for (var _2 in obj) {
      return false;
    }
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === "function") {
      var descriptor = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(obj, sym)
      );
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams;
}
var hasSymbols;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== "undefined" && Symbol;
  var hasSymbolSham = requireShams();
  hasSymbols = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
      return false;
    }
    if (typeof Symbol !== "function") {
      return false;
    }
    if (typeof origSymbol("foo") !== "symbol") {
      return false;
    }
    if (typeof Symbol("bar") !== "symbol") {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols;
}
var Reflect_getPrototypeOf;
var hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  if (hasRequiredReflect_getPrototypeOf) return Reflect_getPrototypeOf;
  hasRequiredReflect_getPrototypeOf = 1;
  Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
  return Reflect_getPrototypeOf;
}
var Object_getPrototypeOf;
var hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  Object_getPrototypeOf = $Object.getPrototypeOf || null;
  return Object_getPrototypeOf;
}
var implementation;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation;
  hasRequiredImplementation = 1;
  var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
  var toStr = Object.prototype.toString;
  var max2 = Math.max;
  var funcType = "[object Function]";
  var concatty = function concatty2(a, b) {
    var arr = [];
    for (var i = 0; i < a.length; i += 1) {
      arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
      arr[j + a.length] = b[j];
    }
    return arr;
  };
  var slicy = function slicy2(arrLike, offset) {
    var arr = [];
    for (var i = offset, j = 0; i < arrLike.length; i += 1, j += 1) {
      arr[j] = arrLike[i];
    }
    return arr;
  };
  var joiny = function(arr, joiner) {
    var str = "";
    for (var i = 0; i < arr.length; i += 1) {
      str += arr[i];
      if (i + 1 < arr.length) {
        str += joiner;
      }
    }
    return str;
  };
  implementation = function bind2(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
      if (this instanceof bound) {
        var result = target.apply(
          this,
          concatty(args, arguments)
        );
        if (Object(result) === result) {
          return result;
        }
        return this;
      }
      return target.apply(
        that,
        concatty(args, arguments)
      );
    };
    var boundLength = max2(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
      boundArgs[i] = "$" + i;
    }
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
      var Empty2 = function Empty3() {
      };
      Empty2.prototype = target.prototype;
      bound.prototype = new Empty2();
      Empty2.prototype = null;
    }
    return bound;
  };
  return implementation;
}
var functionBind;
var hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var implementation2 = requireImplementation();
  functionBind = Function.prototype.bind || implementation2;
  return functionBind;
}
var functionCall;
var hasRequiredFunctionCall;
function requireFunctionCall() {
  if (hasRequiredFunctionCall) return functionCall;
  hasRequiredFunctionCall = 1;
  functionCall = Function.prototype.call;
  return functionCall;
}
var functionApply;
var hasRequiredFunctionApply;
function requireFunctionApply() {
  if (hasRequiredFunctionApply) return functionApply;
  hasRequiredFunctionApply = 1;
  functionApply = Function.prototype.apply;
  return functionApply;
}
var reflectApply;
var hasRequiredReflectApply;
function requireReflectApply() {
  if (hasRequiredReflectApply) return reflectApply;
  hasRequiredReflectApply = 1;
  reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
  return reflectApply;
}
var actualApply;
var hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply) return actualApply;
  hasRequiredActualApply = 1;
  var bind2 = requireFunctionBind();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var $reflectApply = requireReflectApply();
  actualApply = $reflectApply || bind2.call($call, $apply);
  return actualApply;
}
var callBindApplyHelpers;
var hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers) return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var bind2 = requireFunctionBind();
  var $TypeError = /* @__PURE__ */ requireType();
  var $call = requireFunctionCall();
  var $actualApply = requireActualApply();
  callBindApplyHelpers = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== "function") {
      throw new $TypeError("a function is required");
    }
    return $actualApply(bind2, $call, args);
  };
  return callBindApplyHelpers;
}
var get$4;
var hasRequiredGet$1;
function requireGet$1() {
  if (hasRequiredGet$1) return get$4;
  hasRequiredGet$1 = 1;
  var callBind = requireCallBindApplyHelpers();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var hasProtoAccessor;
  try {
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e) {
    if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") {
      throw e;
    }
  }
  var desc = !!hasProtoAccessor && gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  var $Object = Object;
  var $getPrototypeOf = $Object.getPrototypeOf;
  get$4 = desc && typeof desc.get === "function" ? callBind([desc.get]) : typeof $getPrototypeOf === "function" ? (
    /** @type {import('./get')} */
    function getDunder(value) {
      return $getPrototypeOf(value == null ? value : $Object(value));
    }
  ) : false;
  return get$4;
}
var getProto;
var hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto;
  hasRequiredGetProto = 1;
  var reflectGetProto = requireReflect_getPrototypeOf();
  var originalGetProto = requireObject_getPrototypeOf();
  var getDunderProto = /* @__PURE__ */ requireGet$1();
  getProto = reflectGetProto ? function getProto2(O) {
    return reflectGetProto(O);
  } : originalGetProto ? function getProto2(O) {
    if (!O || typeof O !== "object" && typeof O !== "function") {
      throw new TypeError("getProto: not an object");
    }
    return originalGetProto(O);
  } : getDunderProto ? function getProto2(O) {
    return getDunderProto(O);
  } : null;
  return getProto;
}
var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call2 = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind2 = requireFunctionBind();
  hasown = bind2.call(call2, $hasOwn);
  return hasown;
}
var getIntrinsic;
var hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var undefined$1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var $Error = /* @__PURE__ */ requireEsErrors();
  var $EvalError = /* @__PURE__ */ require_eval();
  var $RangeError = /* @__PURE__ */ requireRange();
  var $ReferenceError = /* @__PURE__ */ requireRef$1();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var $URIError = /* @__PURE__ */ requireUri();
  var abs2 = /* @__PURE__ */ requireAbs();
  var floor2 = /* @__PURE__ */ requireFloor();
  var max2 = /* @__PURE__ */ requireMax();
  var min2 = /* @__PURE__ */ requireMin();
  var pow2 = /* @__PURE__ */ requirePow();
  var round2 = /* @__PURE__ */ requireRound();
  var sign2 = /* @__PURE__ */ requireSign();
  var $Function = Function;
  var getEvalledConstructor = function(expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {
    }
  };
  var $gOPD = /* @__PURE__ */ requireGopd();
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var throwTypeError = function() {
    throw new $TypeError();
  };
  var ThrowTypeError = $gOPD ? (function() {
    try {
      arguments.callee;
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        return $gOPD(arguments, "callee").get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  })() : throwTypeError;
  var hasSymbols2 = requireHasSymbols()();
  var getProto2 = requireGetProto();
  var $ObjectGPO = requireObject_getPrototypeOf();
  var $ReflectGPO = requireReflect_getPrototypeOf();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var needsEval = {};
  var TypedArray = typeof Uint8Array === "undefined" || !getProto2 ? undefined$1 : getProto2(Uint8Array);
  var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": $EvalError,
    "%Float16Array%": typeof Float16Array === "undefined" ? undefined$1 : Float16Array,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(getProto2([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": $Object,
    "%Object.getOwnPropertyDescriptor%": $gOPD,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
    "%Function.prototype.call%": $call,
    "%Function.prototype.apply%": $apply,
    "%Object.defineProperty%": $defineProperty,
    "%Object.getPrototypeOf%": $ObjectGPO,
    "%Math.abs%": abs2,
    "%Math.floor%": floor2,
    "%Math.max%": max2,
    "%Math.min%": min2,
    "%Math.pow%": pow2,
    "%Math.round%": round2,
    "%Math.sign%": sign2,
    "%Reflect.getPrototypeOf%": $ReflectGPO
  };
  if (getProto2) {
    try {
      null.error;
    } catch (e) {
      var errorProto = getProto2(getProto2(e));
      INTRINSICS["%Error.prototype%"] = errorProto;
    }
  }
  var doEval = function doEval2(name) {
    var value;
    if (name === "%AsyncFunction%") {
      value = getEvalledConstructor("async function () {}");
    } else if (name === "%GeneratorFunction%") {
      value = getEvalledConstructor("function* () {}");
    } else if (name === "%AsyncGeneratorFunction%") {
      value = getEvalledConstructor("async function* () {}");
    } else if (name === "%AsyncGenerator%") {
      var fn = doEval2("%AsyncGeneratorFunction%");
      if (fn) {
        value = fn.prototype;
      }
    } else if (name === "%AsyncIteratorPrototype%") {
      var gen = doEval2("%AsyncGenerator%");
      if (gen && getProto2) {
        value = getProto2(gen.prototype);
      }
    }
    INTRINSICS[name] = value;
    return value;
  };
  var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  };
  var bind2 = requireFunctionBind();
  var hasOwn2 = /* @__PURE__ */ requireHasown();
  var $concat = bind2.call($call, Array.prototype.concat);
  var $spliceApply = bind2.call($apply, Array.prototype.splice);
  var $replace = bind2.call($call, String.prototype.replace);
  var $strSlice = bind2.call($call, String.prototype.slice);
  var $exec = bind2.call($call, RegExp.prototype.exec);
  var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = function stringToPath2(string3) {
    var first = $strSlice(string3, 0, 1);
    var last = $strSlice(string3, -1);
    if (first === "%" && last !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    } else if (last === "%" && first !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    }
    var result = [];
    $replace(string3, rePropName, function(match2, number4, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number4 || match2;
    });
    return result;
  };
  var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
    var intrinsicName = name;
    var alias2;
    if (hasOwn2(LEGACY_ALIASES, intrinsicName)) {
      alias2 = LEGACY_ALIASES[intrinsicName];
      intrinsicName = "%" + alias2[0] + "%";
    }
    if (hasOwn2(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval) {
        value = doEval(intrinsicName);
      }
      if (typeof value === "undefined" && !allowMissing) {
        throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
      }
      return {
        alias: alias2,
        name: intrinsicName,
        value
      };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
  };
  getIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) {
      throw new $TypeError("intrinsic name must be a non-empty string");
    }
    if (arguments.length > 1 && typeof allowMissing !== "boolean") {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }
    if ($exec(/^%?[^%]*%?$/, name) === null) {
      throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    }
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias2 = intrinsic.alias;
    if (alias2) {
      intrinsicBaseName = alias2[0];
      $spliceApply(parts, $concat([0, 1], alias2));
    }
    for (var i = 1, isOwn = true; i < parts.length; i += 1) {
      var part = parts[i];
      var first = $strSlice(part, 0, 1);
      var last = $strSlice(part, -1);
      if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
        throw new $SyntaxError("property names with quotes must have matching quotes");
      }
      if (part === "constructor" || !isOwn) {
        skipFurtherCaching = true;
      }
      intrinsicBaseName += "." + part;
      intrinsicRealName = "%" + intrinsicBaseName + "%";
      if (hasOwn2(INTRINSICS, intrinsicRealName)) {
        value = INTRINSICS[intrinsicRealName];
      } else if (value != null) {
        if (!(part in value)) {
          if (!allowMissing) {
            throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
          }
          return void undefined$1;
        }
        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part);
          isOwn = !!desc;
          if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
            value = desc.get;
          } else {
            value = value[part];
          }
        } else {
          isOwn = hasOwn2(value, part);
          value = value[part];
        }
        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value;
        }
      }
    }
    return value;
  };
  return getIntrinsic;
}
var callBound;
var hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic();
  var callBindBasic = requireCallBindApplyHelpers();
  var $indexOf = callBindBasic([GetIntrinsic("%String.prototype.indexOf%")]);
  callBound = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      GetIntrinsic(name, !!allowMissing)
    );
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
      return callBindBasic(
        /** @type {const} */
        [intrinsic]
      );
    }
    return intrinsic;
  };
  return callBound;
}
var sideChannelMap;
var hasRequiredSideChannelMap;
function requireSideChannelMap() {
  if (hasRequiredSideChannelMap) return sideChannelMap;
  hasRequiredSideChannelMap = 1;
  var GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic();
  var callBound2 = /* @__PURE__ */ requireCallBound();
  var inspect = /* @__PURE__ */ requireObjectInspect();
  var $TypeError = /* @__PURE__ */ requireType();
  var $Map = GetIntrinsic("%Map%", true);
  var $mapGet = callBound2("Map.prototype.get", true);
  var $mapSet = callBound2("Map.prototype.set", true);
  var $mapHas = callBound2("Map.prototype.has", true);
  var $mapDelete = callBound2("Map.prototype.delete", true);
  var $mapSize = callBound2("Map.prototype.size", true);
  sideChannelMap = !!$Map && /** @type {Exclude<import('.'), false>} */
  function getSideChannelMap() {
    var $m;
    var channel = {
      assert: function(key) {
        if (!channel.has(key)) {
          throw new $TypeError("Side channel does not contain " + inspect(key));
        }
      },
      "delete": function(key) {
        if ($m) {
          var result = $mapDelete($m, key);
          if ($mapSize($m) === 0) {
            $m = void 0;
          }
          return result;
        }
        return false;
      },
      get: function(key) {
        if ($m) {
          return $mapGet($m, key);
        }
      },
      has: function(key) {
        if ($m) {
          return $mapHas($m, key);
        }
        return false;
      },
      set: function(key, value) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      }
    };
    return channel;
  };
  return sideChannelMap;
}
var sideChannelWeakmap;
var hasRequiredSideChannelWeakmap;
function requireSideChannelWeakmap() {
  if (hasRequiredSideChannelWeakmap) return sideChannelWeakmap;
  hasRequiredSideChannelWeakmap = 1;
  var GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic();
  var callBound2 = /* @__PURE__ */ requireCallBound();
  var inspect = /* @__PURE__ */ requireObjectInspect();
  var getSideChannelMap = requireSideChannelMap();
  var $TypeError = /* @__PURE__ */ requireType();
  var $WeakMap = GetIntrinsic("%WeakMap%", true);
  var $weakMapGet = callBound2("WeakMap.prototype.get", true);
  var $weakMapSet = callBound2("WeakMap.prototype.set", true);
  var $weakMapHas = callBound2("WeakMap.prototype.has", true);
  var $weakMapDelete = callBound2("WeakMap.prototype.delete", true);
  sideChannelWeakmap = $WeakMap ? (
    /** @type {Exclude<import('.'), false>} */
    function getSideChannelWeakMap() {
      var $wm;
      var $m;
      var channel = {
        assert: function(key) {
          if (!channel.has(key)) {
            throw new $TypeError("Side channel does not contain " + inspect(key));
          }
        },
        "delete": function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapDelete($wm, key);
            }
          } else if (getSideChannelMap) {
            if ($m) {
              return $m["delete"](key);
            }
          }
          return false;
        },
        get: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapGet($wm, key);
            }
          }
          return $m && $m.get(key);
        },
        has: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapHas($wm, key);
            }
          }
          return !!$m && $m.has(key);
        },
        set: function(key, value) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if (!$wm) {
              $wm = new $WeakMap();
            }
            $weakMapSet($wm, key, value);
          } else if (getSideChannelMap) {
            if (!$m) {
              $m = getSideChannelMap();
            }
            $m.set(key, value);
          }
        }
      };
      return channel;
    }
  ) : getSideChannelMap;
  return sideChannelWeakmap;
}
var sideChannel;
var hasRequiredSideChannel;
function requireSideChannel() {
  if (hasRequiredSideChannel) return sideChannel;
  hasRequiredSideChannel = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var inspect = /* @__PURE__ */ requireObjectInspect();
  var getSideChannelList = requireSideChannelList();
  var getSideChannelMap = requireSideChannelMap();
  var getSideChannelWeakMap = requireSideChannelWeakmap();
  var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
  sideChannel = function getSideChannel() {
    var $channelData;
    var channel = {
      assert: function(key) {
        if (!channel.has(key)) {
          throw new $TypeError("Side channel does not contain " + inspect(key));
        }
      },
      "delete": function(key) {
        return !!$channelData && $channelData["delete"](key);
      },
      get: function(key) {
        return $channelData && $channelData.get(key);
      },
      has: function(key) {
        return !!$channelData && $channelData.has(key);
      },
      set: function(key, value) {
        if (!$channelData) {
          $channelData = makeChannel();
        }
        $channelData.set(key, value);
      }
    };
    return channel;
  };
  return sideChannel;
}
var formats;
var hasRequiredFormats;
function requireFormats() {
  if (hasRequiredFormats) return formats;
  hasRequiredFormats = 1;
  var replace2 = String.prototype.replace;
  var percentTwenties = /%20/g;
  var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  formats = {
    "default": Format.RFC3986,
    formatters: {
      RFC1738: function(value) {
        return replace2.call(value, percentTwenties, "+");
      },
      RFC3986: function(value) {
        return String(value);
      }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
  };
  return formats;
}
var utils$2;
var hasRequiredUtils$2;
function requireUtils$2() {
  if (hasRequiredUtils$2) return utils$2;
  hasRequiredUtils$2 = 1;
  var formats2 = requireFormats();
  var has2 = Object.prototype.hasOwnProperty;
  var isArray = Array.isArray;
  var hexTable = (function() {
    var array4 = [];
    for (var i = 0; i < 256; ++i) {
      array4.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    }
    return array4;
  })();
  var compactQueue = function compactQueue2(queue) {
    while (queue.length > 1) {
      var item2 = queue.pop();
      var obj = item2.obj[item2.prop];
      if (isArray(obj)) {
        var compacted = [];
        for (var j = 0; j < obj.length; ++j) {
          if (typeof obj[j] !== "undefined") {
            compacted.push(obj[j]);
          }
        }
        item2.obj[item2.prop] = compacted;
      }
    }
  };
  var arrayToObject = function arrayToObject2(source, options) {
    var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
      if (typeof source[i] !== "undefined") {
        obj[i] = source[i];
      }
    }
    return obj;
  };
  var merge2 = function merge3(target, source, options) {
    if (!source) {
      return target;
    }
    if (typeof source !== "object") {
      if (isArray(target)) {
        target.push(source);
      } else if (target && typeof target === "object") {
        if (options && (options.plainObjects || options.allowPrototypes) || !has2.call(Object.prototype, source)) {
          target[source] = true;
        }
      } else {
        return [target, source];
      }
      return target;
    }
    if (!target || typeof target !== "object") {
      return [target].concat(source);
    }
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
      mergeTarget = arrayToObject(target, options);
    }
    if (isArray(target) && isArray(source)) {
      source.forEach(function(item2, i) {
        if (has2.call(target, i)) {
          var targetItem = target[i];
          if (targetItem && typeof targetItem === "object" && item2 && typeof item2 === "object") {
            target[i] = merge3(targetItem, item2, options);
          } else {
            target.push(item2);
          }
        } else {
          target[i] = item2;
        }
      });
      return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
      var value = source[key];
      if (has2.call(acc, key)) {
        acc[key] = merge3(acc[key], value, options);
      } else {
        acc[key] = value;
      }
      return acc;
    }, mergeTarget);
  };
  var assign2 = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
      acc[key] = source[key];
      return acc;
    }, target);
  };
  var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") {
      return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    try {
      return decodeURIComponent(strWithoutPlus);
    } catch (e) {
      return strWithoutPlus;
    }
  };
  var encode = function encode2(str, defaultEncoder, charset, kind, format2) {
    if (str.length === 0) {
      return str;
    }
    var string3 = str;
    if (typeof str === "symbol") {
      string3 = Symbol.prototype.toString.call(str);
    } else if (typeof str !== "string") {
      string3 = String(str);
    }
    if (charset === "iso-8859-1") {
      return escape(string3).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
      });
    }
    var out = "";
    for (var i = 0; i < string3.length; ++i) {
      var c = string3.charCodeAt(i);
      if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format2 === formats2.RFC1738 && (c === 40 || c === 41)) {
        out += string3.charAt(i);
        continue;
      }
      if (c < 128) {
        out = out + hexTable[c];
        continue;
      }
      if (c < 2048) {
        out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
        continue;
      }
      if (c < 55296 || c >= 57344) {
        out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
        continue;
      }
      i += 1;
      c = 65536 + ((c & 1023) << 10 | string3.charCodeAt(i) & 1023);
      out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
    }
    return out;
  };
  var compact2 = function compact3(value) {
    var queue = [{ obj: { o: value }, prop: "o" }];
    var refs = [];
    for (var i = 0; i < queue.length; ++i) {
      var item2 = queue[i];
      var obj = item2.obj[item2.prop];
      var keys2 = Object.keys(obj);
      for (var j = 0; j < keys2.length; ++j) {
        var key = keys2[j];
        var val = obj[key];
        if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
          queue.push({ obj, prop: key });
          refs.push(val);
        }
      }
    }
    compactQueue(queue);
    return value;
  };
  var isRegExp = function isRegExp2(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
  };
  var isBuffer = function isBuffer2(obj) {
    if (!obj || typeof obj !== "object") {
      return false;
    }
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
  };
  var combine2 = function combine3(a, b) {
    return [].concat(a, b);
  };
  var maybeMap = function maybeMap2(val, fn) {
    if (isArray(val)) {
      var mapped = [];
      for (var i = 0; i < val.length; i += 1) {
        mapped.push(fn(val[i]));
      }
      return mapped;
    }
    return fn(val);
  };
  utils$2 = {
    arrayToObject,
    assign: assign2,
    combine: combine2,
    compact: compact2,
    decode,
    encode,
    isBuffer,
    isRegExp,
    maybeMap,
    merge: merge2
  };
  return utils$2;
}
var stringify_1;
var hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify_1;
  hasRequiredStringify = 1;
  var getSideChannel = requireSideChannel();
  var utils2 = requireUtils$2();
  var formats2 = requireFormats();
  var has2 = Object.prototype.hasOwnProperty;
  var arrayPrefixGenerators = {
    brackets: function brackets(prefix2) {
      return prefix2 + "[]";
    },
    comma: "comma",
    indices: function indices(prefix2, key) {
      return prefix2 + "[" + key + "]";
    },
    repeat: function repeat(prefix2) {
      return prefix2;
    }
  };
  var isArray = Array.isArray;
  var split = String.prototype.split;
  var push = Array.prototype.push;
  var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
  };
  var toISO = Date.prototype.toISOString;
  var defaultFormat = formats2["default"];
  var defaults2 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: utils2.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats2.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date4) {
      return toISO.call(date4);
    },
    skipNulls: false,
    strictNullHandling: false
  };
  var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
  };
  var sentinel = {};
  var stringify2 = function stringify3(object4, prefix2, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter2, sort, allowDots, serializeDate, format2, formatter, encodeValuesOnly, charset, sideChannel2) {
    var obj = object4;
    var tmpSc = sideChannel2;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
      var pos = tmpSc.get(object4);
      step += 1;
      if (typeof pos !== "undefined") {
        if (pos === step) {
          throw new RangeError("Cyclic object value");
        } else {
          findFlag = true;
        }
      }
      if (typeof tmpSc.get(sentinel) === "undefined") {
        step = 0;
      }
    }
    if (typeof filter2 === "function") {
      obj = filter2(prefix2, obj);
    } else if (obj instanceof Date) {
      obj = serializeDate(obj);
    } else if (generateArrayPrefix === "comma" && isArray(obj)) {
      obj = utils2.maybeMap(obj, function(value2) {
        if (value2 instanceof Date) {
          return serializeDate(value2);
        }
        return value2;
      });
    }
    if (obj === null) {
      if (strictNullHandling) {
        return encoder && !encodeValuesOnly ? encoder(prefix2, defaults2.encoder, charset, "key", format2) : prefix2;
      }
      obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils2.isBuffer(obj)) {
      if (encoder) {
        var keyValue = encodeValuesOnly ? prefix2 : encoder(prefix2, defaults2.encoder, charset, "key", format2);
        if (generateArrayPrefix === "comma" && encodeValuesOnly) {
          var valuesArray = split.call(String(obj), ",");
          var valuesJoined = "";
          for (var i = 0; i < valuesArray.length; ++i) {
            valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], defaults2.encoder, charset, "value", format2));
          }
          return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? "[]" : "") + "=" + valuesJoined];
        }
        return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults2.encoder, charset, "value", format2))];
      }
      return [formatter(prefix2) + "=" + formatter(String(obj))];
    }
    var values = [];
    if (typeof obj === "undefined") {
      return values;
    }
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) {
      objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
    } else if (isArray(filter2)) {
      objKeys = filter2;
    } else {
      var keys2 = Object.keys(obj);
      objKeys = sort ? keys2.sort(sort) : keys2;
    }
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix2 + "[]" : prefix2;
    for (var j = 0; j < objKeys.length; ++j) {
      var key = objKeys[j];
      var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
      if (skipNulls && value === null) {
        continue;
      }
      var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
      sideChannel2.set(object4, step);
      var valueSideChannel = getSideChannel();
      valueSideChannel.set(sentinel, sideChannel2);
      pushToArray(values, stringify3(
        value,
        keyPrefix,
        generateArrayPrefix,
        commaRoundTrip,
        strictNullHandling,
        skipNulls,
        encoder,
        filter2,
        sort,
        allowDots,
        serializeDate,
        format2,
        formatter,
        encodeValuesOnly,
        charset,
        valueSideChannel
      ));
    }
    return values;
  };
  var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
    if (!opts) {
      return defaults2;
    }
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
      throw new TypeError("Encoder has to be a function.");
    }
    var charset = opts.charset || defaults2.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    }
    var format2 = formats2["default"];
    if (typeof opts.format !== "undefined") {
      if (!has2.call(formats2.formatters, opts.format)) {
        throw new TypeError("Unknown format option provided.");
      }
      format2 = opts.format;
    }
    var formatter = formats2.formatters[format2];
    var filter2 = defaults2.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) {
      filter2 = opts.filter;
    }
    return {
      addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults2.addQueryPrefix,
      allowDots: typeof opts.allowDots === "undefined" ? defaults2.allowDots : !!opts.allowDots,
      charset,
      charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults2.charsetSentinel,
      delimiter: typeof opts.delimiter === "undefined" ? defaults2.delimiter : opts.delimiter,
      encode: typeof opts.encode === "boolean" ? opts.encode : defaults2.encode,
      encoder: typeof opts.encoder === "function" ? opts.encoder : defaults2.encoder,
      encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults2.encodeValuesOnly,
      filter: filter2,
      format: format2,
      formatter,
      serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults2.serializeDate,
      skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults2.skipNulls,
      sort: typeof opts.sort === "function" ? opts.sort : null,
      strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults2.strictNullHandling
    };
  };
  stringify_1 = function(object4, opts) {
    var obj = object4;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter2;
    if (typeof options.filter === "function") {
      filter2 = options.filter;
      obj = filter2("", obj);
    } else if (isArray(options.filter)) {
      filter2 = options.filter;
      objKeys = filter2;
    }
    var keys2 = [];
    if (typeof obj !== "object" || obj === null) {
      return "";
    }
    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
      arrayFormat = opts.arrayFormat;
    } else if (opts && "indices" in opts) {
      arrayFormat = opts.indices ? "indices" : "repeat";
    } else {
      arrayFormat = "indices";
    }
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    }
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) {
      objKeys = Object.keys(obj);
    }
    if (options.sort) {
      objKeys.sort(options.sort);
    }
    var sideChannel2 = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i];
      if (options.skipNulls && obj[key] === null) {
        continue;
      }
      pushToArray(keys2, stringify2(
        obj[key],
        key,
        generateArrayPrefix,
        commaRoundTrip,
        options.strictNullHandling,
        options.skipNulls,
        options.encode ? options.encoder : null,
        options.filter,
        options.sort,
        options.allowDots,
        options.serializeDate,
        options.format,
        options.formatter,
        options.encodeValuesOnly,
        options.charset,
        sideChannel2
      ));
    }
    var joined = keys2.join(options.delimiter);
    var prefix2 = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
      if (options.charset === "iso-8859-1") {
        prefix2 += "utf8=%26%2310003%3B&";
      } else {
        prefix2 += "utf8=%E2%9C%93&";
      }
    }
    return joined.length > 0 ? prefix2 + joined : "";
  };
  return stringify_1;
}
var parse$2;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse$2;
  hasRequiredParse = 1;
  var utils2 = requireUtils$2();
  var has2 = Object.prototype.hasOwnProperty;
  var isArray = Array.isArray;
  var defaults2 = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: utils2.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1e3,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
  };
  var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
      return String.fromCharCode(parseInt(numberStr, 10));
    });
  };
  var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
      return val.split(",");
    }
    return val;
  };
  var isoSentinel = "utf8=%26%2310003%3B";
  var charsetSentinel = "utf8=%E2%9C%93";
  var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1;
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
      for (i = 0; i < parts.length; ++i) {
        if (parts[i].indexOf("utf8=") === 0) {
          if (parts[i] === charsetSentinel) {
            charset = "utf-8";
          } else if (parts[i] === isoSentinel) {
            charset = "iso-8859-1";
          }
          skipIndex = i;
          i = parts.length;
        }
      }
    }
    for (i = 0; i < parts.length; ++i) {
      if (i === skipIndex) {
        continue;
      }
      var part = parts[i];
      var bracketEqualsPos = part.indexOf("]=");
      var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
      var key, val;
      if (pos === -1) {
        key = options.decoder(part, defaults2.decoder, charset, "key");
        val = options.strictNullHandling ? null : "";
      } else {
        key = options.decoder(part.slice(0, pos), defaults2.decoder, charset, "key");
        val = utils2.maybeMap(
          parseArrayValue(part.slice(pos + 1), options),
          function(encodedVal) {
            return options.decoder(encodedVal, defaults2.decoder, charset, "value");
          }
        );
      }
      if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
        val = interpretNumericEntities(val);
      }
      if (part.indexOf("[]=") > -1) {
        val = isArray(val) ? [val] : val;
      }
      if (has2.call(obj, key)) {
        obj[key] = utils2.combine(obj[key], val);
      } else {
        obj[key] = val;
      }
    }
    return obj;
  };
  var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for (var i = chain.length - 1; i >= 0; --i) {
      var obj;
      var root = chain[i];
      if (root === "[]" && options.parseArrays) {
        obj = [].concat(leaf);
      } else {
        obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
        var index2 = parseInt(cleanRoot, 10);
        if (!options.parseArrays && cleanRoot === "") {
          obj = { 0: leaf };
        } else if (!isNaN(index2) && root !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
          obj = [];
          obj[index2] = leaf;
        } else if (cleanRoot !== "__proto__") {
          obj[cleanRoot] = leaf;
        }
      }
      leaf = obj;
    }
    return leaf;
  };
  var parseKeys2 = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
      return;
    }
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys2 = [];
    if (parent) {
      if (!options.plainObjects && has2.call(Object.prototype, parent)) {
        if (!options.allowPrototypes) {
          return;
        }
      }
      keys2.push(parent);
    }
    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
      i += 1;
      if (!options.plainObjects && has2.call(Object.prototype, segment[1].slice(1, -1))) {
        if (!options.allowPrototypes) {
          return;
        }
      }
      keys2.push(segment[1]);
    }
    if (segment) {
      keys2.push("[" + key.slice(segment.index) + "]");
    }
    return parseObject(keys2, val, options, valuesParsed);
  };
  var normalizeParseOptions = function normalizeParseOptions2(opts) {
    if (!opts) {
      return defaults2;
    }
    if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
      throw new TypeError("Decoder has to be a function.");
    }
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    }
    var charset = typeof opts.charset === "undefined" ? defaults2.charset : opts.charset;
    return {
      allowDots: typeof opts.allowDots === "undefined" ? defaults2.allowDots : !!opts.allowDots,
      allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults2.allowPrototypes,
      allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults2.allowSparse,
      arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults2.arrayLimit,
      charset,
      charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults2.charsetSentinel,
      comma: typeof opts.comma === "boolean" ? opts.comma : defaults2.comma,
      decoder: typeof opts.decoder === "function" ? opts.decoder : defaults2.decoder,
      delimiter: typeof opts.delimiter === "string" || utils2.isRegExp(opts.delimiter) ? opts.delimiter : defaults2.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults2.depth,
      ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
      interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults2.interpretNumericEntities,
      parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults2.parameterLimit,
      parseArrays: opts.parseArrays !== false,
      plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults2.plainObjects,
      strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults2.strictNullHandling
    };
  };
  parse$2 = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") {
      return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    }
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    var keys2 = Object.keys(tempObj);
    for (var i = 0; i < keys2.length; ++i) {
      var key = keys2[i];
      var newObj = parseKeys2(key, tempObj[key], options, typeof str === "string");
      obj = utils2.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) {
      return obj;
    }
    return utils2.compact(obj);
  };
  return parse$2;
}
var lib$1;
var hasRequiredLib$1;
function requireLib$1() {
  if (hasRequiredLib$1) return lib$1;
  hasRequiredLib$1 = 1;
  var stringify2 = requireStringify();
  var parse2 = requireParse();
  var formats2 = requireFormats();
  lib$1 = {
    formats: formats2,
    parse: parse2,
    stringify: stringify2
  };
  return lib$1;
}
requireLib$1();
class Api {
  constructor(client2) {
    this.client = client2;
  }
  async execute(request2, ResponseType) {
    return await this.client.execute(request2, ResponseType);
  }
  /**
   * new format of request execution
   * @param req 
   * @param parse 
   * @returns 
   */
  async execute2(req, parse2) {
    const result = await this.client.execute(new ApiRequest({ ...req }));
    if (result.response?.body && parse2)
      result.response.body = parse2(result.response.body);
    return result;
  }
  async put(url2, body, parse2) {
    return this.execute2({ method: HttpMethod.PUT, url: url2, body }, parse2);
  }
  async get(url2, fields = "", parse2) {
    return this.execute2({ method: HttpMethod.GET, url: url2, fields }, parse2);
  }
  async getFile(url2, body) {
    return this.execute2({ method: HttpMethod.GET, url: url2, body, responseType: "blob" });
  }
  async getList(url2, fields = "", filter2, parse2) {
    const result = await this.client.execute(new ApiRequest({ method: HttpMethod.GET, url: url2, fields, body: { ...filter2 } }));
    if (result.response?.body) {
      let response = result.response;
      if (parse2)
        response.body = parse2(result.response.body);
      response.items = result.response.body.items;
      response.filter = result.response.body.filter;
    }
    return result;
  }
  async post(url2, body, parse2) {
    return this.execute2({ method: HttpMethod.POST, url: url2, body }, parse2);
  }
  async delete(url2, parse2) {
    return this.execute2({ method: HttpMethod.DELETE, url: url2 }, parse2);
  }
}
var humanize$1 = { exports: {} };
var humanize = humanize$1.exports;
var hasRequiredHumanize;
function requireHumanize() {
  if (hasRequiredHumanize) return humanize$1.exports;
  hasRequiredHumanize = 1;
  (function(module2, exports$1) {
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
    };
    (function(root, factory) {
      if (_typeof2(exports$1) === "object") {
        module2.exports = factory();
      } else {
        root.Humanize = factory();
      }
    })(humanize, function() {
      var TIME_FORMATS = [{
        name: "second",
        value: 1e3
      }, {
        name: "minute",
        value: 6e4
      }, {
        name: "hour",
        value: 36e5
      }, {
        name: "day",
        value: 864e5
      }, {
        name: "week",
        value: 6048e5
      }];
      var LABELS_FOR_POWERS_OF_KILO = {
        P: Math.pow(2, 50),
        T: Math.pow(2, 40),
        G: Math.pow(2, 30),
        M: Math.pow(2, 20)
      };
      var exists = function exists2(maybe) {
        return typeof maybe !== "undefined" && maybe !== null;
      };
      var isNaN2 = function isNaN3(value) {
        return value !== value;
      };
      var isFiniteNumber = function isFiniteNumber2(value) {
        return isFinite(value) && !isNaN2(parseFloat(value));
      };
      var isArray = function isArray2(value) {
        var type4 = Object.prototype.toString.call(value);
        return type4 === "[object Array]";
      };
      var Humanize2 = {
        // Converts a large integer to a friendly text representation.
        intword: function intword(number4, charWidth) {
          var decimals = arguments.length <= 2 || arguments[2] === void 0 ? 2 : arguments[2];
          return Humanize2.compactInteger(number4, decimals);
        },
        // Converts an integer into its most compact representation
        compactInteger: function compactInteger(input2) {
          var decimals = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          decimals = Math.max(decimals, 0);
          var number4 = parseInt(input2, 10);
          var signString = number4 < 0 ? "-" : "";
          var unsignedNumber = Math.abs(number4);
          var unsignedNumberString = String(unsignedNumber);
          var numberLength = unsignedNumberString.length;
          var numberLengths = [13, 10, 7, 4];
          var bigNumPrefixes = ["T", "B", "M", "k"];
          if (unsignedNumber < 1e3) {
            return "" + signString + unsignedNumberString;
          }
          if (numberLength > numberLengths[0] + 3) {
            return number4.toExponential(decimals).replace("e+", "x10^");
          }
          var length2 = void 0;
          for (var i = 0; i < numberLengths.length; i++) {
            var _length = numberLengths[i];
            if (numberLength >= _length) {
              length2 = _length;
              break;
            }
          }
          var decimalIndex = numberLength - length2 + 1;
          var unsignedNumberCharacterArray = unsignedNumberString.split("");
          var wholePartArray = unsignedNumberCharacterArray.slice(0, decimalIndex);
          var decimalPartArray = unsignedNumberCharacterArray.slice(decimalIndex, decimalIndex + decimals + 1);
          var wholePart = wholePartArray.join("");
          var decimalPart = decimalPartArray.join("");
          if (decimalPart.length < decimals) {
            decimalPart += "" + Array(decimals - decimalPart.length + 1).join("0");
          }
          var output = void 0;
          if (decimals === 0) {
            output = "" + signString + wholePart + bigNumPrefixes[numberLengths.indexOf(length2)];
          } else {
            var outputNumber = Number(wholePart + "." + decimalPart).toFixed(decimals);
            output = "" + signString + outputNumber + bigNumPrefixes[numberLengths.indexOf(length2)];
          }
          return output;
        },
        // Converts an integer to a string containing commas every three digits.
        intComma: function intComma(number4) {
          var decimals = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          return Humanize2.formatNumber(number4, decimals);
        },
        intcomma: function intcomma() {
          return Humanize2.intComma.apply(Humanize2, arguments);
        },
        // Formats the value like a 'human-readable' file size (i.e. '13 KB', '4.1 MB', '102 bytes', etc).
        fileSize: function fileSize(filesize) {
          var precision = arguments.length <= 1 || arguments[1] === void 0 ? 2 : arguments[1];
          for (var label in LABELS_FOR_POWERS_OF_KILO) {
            if (LABELS_FOR_POWERS_OF_KILO.hasOwnProperty(label)) {
              var minnum = LABELS_FOR_POWERS_OF_KILO[label];
              if (filesize >= minnum) {
                return Humanize2.formatNumber(filesize / minnum, precision, "") + " " + label + "B";
              }
            }
          }
          if (filesize >= 1024) {
            return Humanize2.formatNumber(filesize / 1024, 0) + " KB";
          }
          return Humanize2.formatNumber(filesize, 0) + Humanize2.pluralize(filesize, " byte");
        },
        filesize: function filesize() {
          return Humanize2.fileSize.apply(Humanize2, arguments);
        },
        // Formats a number to a human-readable string.
        // Localize by overriding the precision, thousand and decimal arguments.
        formatNumber: function formatNumber(number4) {
          var precision = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          var thousand = arguments.length <= 2 || arguments[2] === void 0 ? "," : arguments[2];
          var decimal = arguments.length <= 3 || arguments[3] === void 0 ? "." : arguments[3];
          var firstComma = function firstComma2(_number, _thousand, _position) {
            return _position ? _number.substr(0, _position) + _thousand : "";
          };
          var commas = function commas2(_number, _thousand, _position) {
            return _number.substr(_position).replace(/(\d{3})(?=\d)/g, "$1" + _thousand);
          };
          var decimals = function decimals2(_number, _decimal, usePrecision2) {
            return usePrecision2 ? _decimal + Humanize2.toFixed(Math.abs(_number), usePrecision2).split(".")[1] : "";
          };
          var usePrecision = Humanize2.normalizePrecision(precision);
          var negative = number4 < 0 && "-" || "";
          var base = String(parseInt(Humanize2.toFixed(Math.abs(number4 || 0), usePrecision), 10));
          var mod = base.length > 3 ? base.length % 3 : 0;
          return negative + firstComma(base, thousand, mod) + commas(base, thousand, mod) + decimals(number4, decimal, usePrecision);
        },
        // Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61')
        toFixed: function toFixed2(value, precision) {
          precision = exists(precision) ? precision : Humanize2.normalizePrecision(precision, 0);
          var power = Math.pow(10, precision);
          return (Math.round(value * power) / power).toFixed(precision);
        },
        // Ensures precision value is a positive integer
        normalizePrecision: function normalizePrecision(value, base) {
          value = Math.round(Math.abs(value));
          return isNaN2(value) ? base : value;
        },
        // Converts an integer to its ordinal as a string.
        ordinal: function ordinal(value) {
          var number4 = parseInt(value, 10);
          if (number4 === 0) {
            return value;
          }
          var specialCase = number4 % 100;
          if ([11, 12, 13].indexOf(specialCase) >= 0) {
            return number4 + "th";
          }
          var leastSignificant = number4 % 10;
          var end = void 0;
          switch (leastSignificant) {
            case 1:
              end = "st";
              break;
            case 2:
              end = "nd";
              break;
            case 3:
              end = "rd";
              break;
            default:
              end = "th";
          }
          return "" + number4 + end;
        },
        // Interprets numbers as occurences. Also accepts an optional array/map of overrides.
        times: function times(value) {
          var overrides = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
          if (isFiniteNumber(value) && value >= 0) {
            var number4 = parseFloat(value);
            var smallTimes = ["never", "once", "twice"];
            if (exists(overrides[number4])) {
              return String(overrides[number4]);
            }
            var numberString = exists(smallTimes[number4]) && smallTimes[number4].toString();
            return numberString || number4.toString() + " times";
          }
          return null;
        },
        // Returns the plural version of a given word if the value is not 1. The default suffix is 's'.
        pluralize: function pluralize(number4, singular, plural) {
          if (!(exists(number4) && exists(singular))) {
            return null;
          }
          plural = exists(plural) ? plural : singular + "s";
          return parseInt(number4, 10) === 1 ? singular : plural;
        },
        // Truncates a string if it is longer than the specified number of characters (inclusive).
        // Truncated strings will end with a translatable ellipsis sequence ("…").
        truncate: function truncate(str) {
          var length2 = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1];
          var ending = arguments.length <= 2 || arguments[2] === void 0 ? "..." : arguments[2];
          if (str.length > length2) {
            return str.substring(0, length2 - ending.length) + ending;
          }
          return str;
        },
        // Truncates a string after a certain number of words.
        truncateWords: function truncateWords(string3, length2) {
          var array4 = string3.split(" ");
          var result = "";
          var i = 0;
          while (i < length2) {
            if (exists(array4[i])) {
              result += array4[i] + " ";
            }
            i++;
          }
          if (array4.length > length2) {
            return result + "...";
          }
          return null;
        },
        truncatewords: function truncatewords() {
          return Humanize2.truncateWords.apply(Humanize2, arguments);
        },
        // Truncates a number to an upper bound.
        boundedNumber: function boundedNumber(num) {
          var bound = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1];
          var ending = arguments.length <= 2 || arguments[2] === void 0 ? "+" : arguments[2];
          var result = void 0;
          if (isFiniteNumber(num) && isFiniteNumber(bound)) {
            if (num > bound) {
              result = bound + ending;
            }
          }
          return (result || num).toString();
        },
        truncatenumber: function truncatenumber() {
          return Humanize2.boundedNumber.apply(Humanize2, arguments);
        },
        // Converts a list of items to a human readable string with an optional limit.
        oxford: function oxford(items, limit, limitStr) {
          var numItems = items.length;
          var limitIndex = void 0;
          if (numItems < 2) {
            return String(items);
          } else if (numItems === 2) {
            return items.join(" and ");
          } else if (exists(limit) && numItems > limit) {
            var extra = numItems - limit;
            limitIndex = limit;
            limitStr = exists(limitStr) ? limitStr : ", and " + extra + " " + Humanize2.pluralize(extra, "other");
          } else {
            limitIndex = -1;
            limitStr = ", and " + items[numItems - 1];
          }
          return items.slice(0, limitIndex).join(", ") + limitStr;
        },
        // Converts an object to a definition-like string
        dictionary: function dictionary(object4) {
          var joiner = arguments.length <= 1 || arguments[1] === void 0 ? " is " : arguments[1];
          var separator = arguments.length <= 2 || arguments[2] === void 0 ? ", " : arguments[2];
          var result = "";
          if (exists(object4) && (typeof object4 === "undefined" ? "undefined" : _typeof2(object4)) === "object" && !isArray(object4)) {
            var defs = [];
            for (var key in object4) {
              if (object4.hasOwnProperty(key)) {
                var val = object4[key];
                defs.push("" + key + joiner + val);
              }
            }
            return defs.join(separator);
          }
          return result;
        },
        // Describes how many times an item appears in a list
        frequency: function frequency(list, verb) {
          if (!isArray(list)) {
            return null;
          }
          var len = list.length;
          var times = Humanize2.times(len);
          if (len === 0) {
            return times + " " + verb;
          }
          return verb + " " + times;
        },
        pace: function pace(value, intervalMs) {
          var unit2 = arguments.length <= 2 || arguments[2] === void 0 ? "time" : arguments[2];
          if (value === 0 || intervalMs === 0) {
            return "No " + Humanize2.pluralize(0, unit2);
          }
          var prefix2 = "Approximately";
          var timeUnit = void 0;
          var relativePace = void 0;
          var rate2 = value / intervalMs;
          for (var i = 0; i < TIME_FORMATS.length; ++i) {
            var f = TIME_FORMATS[i];
            relativePace = rate2 * f.value;
            if (relativePace > 1) {
              timeUnit = f.name;
              break;
            }
          }
          if (!timeUnit) {
            prefix2 = "Less than";
            relativePace = 1;
            timeUnit = TIME_FORMATS[TIME_FORMATS.length - 1].name;
          }
          var roundedPace = Math.round(relativePace);
          unit2 = Humanize2.pluralize(roundedPace, unit2);
          return prefix2 + " " + roundedPace + " " + unit2 + " per " + timeUnit;
        },
        // Converts newlines to <br/> tags
        nl2br: function nl2br(string3) {
          var replacement = arguments.length <= 1 || arguments[1] === void 0 ? "<br/>" : arguments[1];
          return string3.replace(/\n/g, replacement);
        },
        // Converts <br/> tags to newlines
        br2nl: function br2nl(string3) {
          var replacement = arguments.length <= 1 || arguments[1] === void 0 ? "\r\n" : arguments[1];
          return string3.replace(/\<br\s*\/?\>/g, replacement);
        },
        // Capitalizes first letter in a string
        capitalize: function capitalize(string3) {
          var downCaseTail = arguments.length <= 1 || arguments[1] === void 0 ? false : arguments[1];
          return "" + string3.charAt(0).toUpperCase() + (downCaseTail ? string3.slice(1).toLowerCase() : string3.slice(1));
        },
        // Capitalizes the first letter of each word in a string
        capitalizeAll: function capitalizeAll(string3) {
          return string3.replace(/(?:^|\s)\S/g, function(a) {
            return a.toUpperCase();
          });
        },
        // Titlecase words in a string.
        titleCase: function titleCase(string3) {
          var smallWords = /\b(a|an|and|at|but|by|de|en|for|if|in|of|on|or|the|to|via|vs?\.?)\b/i;
          var internalCaps = /\S+[A-Z]+\S*/;
          var splitOnWhiteSpaceRegex = /\s+/;
          var splitOnHyphensRegex = /-/;
          var _doTitleCase = void 0;
          _doTitleCase = function doTitleCase(_string) {
            var hyphenated = arguments.length <= 1 || arguments[1] === void 0 ? false : arguments[1];
            var firstOrLast = arguments.length <= 2 || arguments[2] === void 0 ? true : arguments[2];
            var titleCasedArray = [];
            var stringArray = _string.split(hyphenated ? splitOnHyphensRegex : splitOnWhiteSpaceRegex);
            for (var index2 = 0; index2 < stringArray.length; ++index2) {
              var word = stringArray[index2];
              if (word.indexOf("-") !== -1) {
                titleCasedArray.push(_doTitleCase(word, true, index2 === 0 || index2 === stringArray.length - 1));
                continue;
              }
              if (firstOrLast && (index2 === 0 || index2 === stringArray.length - 1)) {
                titleCasedArray.push(internalCaps.test(word) ? word : Humanize2.capitalize(word));
                continue;
              }
              if (internalCaps.test(word)) {
                titleCasedArray.push(word);
              } else if (smallWords.test(word)) {
                titleCasedArray.push(word.toLowerCase());
              } else {
                titleCasedArray.push(Humanize2.capitalize(word));
              }
            }
            return titleCasedArray.join(hyphenated ? "-" : " ");
          };
          return _doTitleCase(string3);
        },
        titlecase: function titlecase() {
          return Humanize2.titleCase.apply(Humanize2, arguments);
        }
      };
      return Humanize2;
    });
  })(humanize$1, humanize$1.exports);
  return humanize$1.exports;
}
var humanizeExports = requireHumanize();
const Humanize = /* @__PURE__ */ getDefaultExportFromCjs(humanizeExports);
var __defProp$3o = Object.defineProperty;
var __getOwnPropDesc$3a = Object.getOwnPropertyDescriptor;
var __decorateClass$3q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3o(target, key, result);
  return result;
};
class Updatable {
  update(entity, allowUndefined = false) {
    if (entity == null)
      return;
    for (const key in entity) {
      if (!entity.hasOwnProperty(key))
        continue;
      if (allowUndefined)
        this[key] = entity[key];
      else {
        if (entity[key] !== void 0)
          this[key] = entity[key];
      }
    }
  }
  /**
  * for backward compatibility
  */
  copy() {
    return this.clone();
  }
  clone() {
    throw new Error("Method not implemented.");
  }
}
__decorateClass$3q([
  action
], Updatable.prototype, "update", 1);
let Entity$1 = class Entity extends Updatable {
  constructor(entity) {
    super();
    if (entity) this.update(entity);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
};
__decorateClass$3q([
  observable
], Entity$1.prototype, "id", 2);
__decorateClass$3q([
  observable
], Entity$1.prototype, "softDeleted", 2);
__decorateClass$3q([
  observable
], Entity$1.prototype, "softDeletedDate", 2);
__decorateClass$3q([
  action
], Entity$1.prototype, "update", 1);
class Designable extends Entity$1 {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
__decorateClass$3q([
  observable
], Designable.prototype, "designSettings", 2);
__decorateClass$3q([
  observable
], Designable.prototype, "designSettingsPublished", 2);
__decorateClass$3q([
  observable
], Designable.prototype, "designHTMLPublished", 2);
__decorateClass$3q([
  observable
], Designable.prototype, "designStylePublished", 2);
__decorateClass$3q([
  observable
], Designable.prototype, "designConcurrencyStamp", 2);
__decorateClass$3q([
  action
], Designable.prototype, "update", 1);
var __defProp$3n = Object.defineProperty;
var __getOwnPropDesc$39 = Object.getOwnPropertyDescriptor;
var __decorateClass$3p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$39(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3n(target, key, result);
  return result;
};
class User extends Entity$1 {
  constructor(user2) {
    super(user2);
  }
  get isFirstNameEmpty() {
    return isEmpty(this.firstName);
  }
  get isLastNameEmpty() {
    return isEmpty(this.lastName);
  }
  get hasName() {
    return !this.isFirstNameEmpty || !this.isLastNameEmpty;
  }
  get fullName() {
    if (this.isFirstNameEmpty && this.isLastNameEmpty)
      return this.email;
    if (this.isFirstNameEmpty)
      return this.lastName;
    if (this.isLastNameEmpty)
      return this.firstName;
    return `${this.firstName} ${this.lastName}`;
  }
  get fullNameNoEmail() {
    if (this.isFirstNameEmpty && this.isLastNameEmpty)
      return "";
    if (this.isFirstNameEmpty)
      return this.lastName;
    if (this.isLastNameEmpty)
      return this.firstName;
    return `${this.firstName} ${this.lastName}`;
  }
}
__decorateClass$3p([
  observable
], User.prototype, "firstName", 2);
__decorateClass$3p([
  observable
], User.prototype, "lastName", 2);
__decorateClass$3p([
  observable
], User.prototype, "middleName", 2);
__decorateClass$3p([
  observable
], User.prototype, "phone", 2);
__decorateClass$3p([
  observable
], User.prototype, "email", 2);
__decorateClass$3p([
  observable
], User.prototype, "avatar", 2);
__decorateClass$3p([
  observable
], User.prototype, "gender", 2);
__decorateClass$3p([
  observable
], User.prototype, "birthday", 2);
__decorateClass$3p([
  observable
], User.prototype, "lang", 2);
__decorateClass$3p([
  computed
], User.prototype, "isFirstNameEmpty", 1);
__decorateClass$3p([
  computed
], User.prototype, "isLastNameEmpty", 1);
__decorateClass$3p([
  computed
], User.prototype, "hasName", 1);
__decorateClass$3p([
  computed
], User.prototype, "fullName", 1);
__decorateClass$3p([
  computed
], User.prototype, "fullNameNoEmail", 1);
var __defProp$3m = Object.defineProperty;
var __getOwnPropDesc$38 = Object.getOwnPropertyDescriptor;
var __decorateClass$3o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$38(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3m(target, key, result);
  return result;
};
const _ExtendedFilter = class _ExtendedFilter2 extends Entity$1 {
  constructor(exfilter) {
    super(exfilter);
    if (exfilter) this.update(exfilter);
  }
  get groups() {
    if (isEmpty(this.filterJson))
      return [];
    return JSON.parse(this.filterJson);
  }
  set groups(value) {
    if (value == null || value.length == 0)
      this.filterJson = null;
    this.filterJson = JSON.stringify(value);
  }
  static fromJson(json) {
    return new _ExtendedFilter2({
      ...json
    });
  }
  update(branch) {
    super.update(branch);
  }
  clone() {
    return new _ExtendedFilter2(this);
  }
};
__decorateClass$3o([
  observable
], _ExtendedFilter.prototype, "name", 2);
__decorateClass$3o([
  observable
], _ExtendedFilter.prototype, "type", 2);
__decorateClass$3o([
  observable
], _ExtendedFilter.prototype, "filterJson", 2);
__decorateClass$3o([
  computed
], _ExtendedFilter.prototype, "groups", 1);
__decorateClass$3o([
  action
], _ExtendedFilter.prototype, "update", 1);
let ExtendedFilter = _ExtendedFilter;
class BaseFilter {
  constructor(filter2) {
    this.skip = 0;
    this.take = 25;
    this.softDeleted = false;
    this.useSort = true;
    this.useBaseFilter = true;
    this.useItemsTotal = true;
    if (filter2) this.update(filter2);
  }
  get groups() {
    if (isEmpty(this.extendedFilter))
      return [];
    return JSON.parse(this.extendedFilter);
  }
  set groups(value) {
    if (isEmpty(value))
      this.extendedFilter = void 0;
    this.extendedFilter = JSON.stringify(value);
  }
  get page() {
    return this.skip / Math.max(1, this.take) + 1;
  }
  set page(value) {
    this.skip = (value - 1) * Math.max(1, this.take);
  }
  get pageTotal() {
    return Math.ceil(this.itemsTotal / Math.max(1, this.take));
  }
  get selectString() {
    return toSelectStringFilter(this);
  }
  get queryString() {
    return toQueryStringFilter(this);
  }
  /**
   * 'changes' can contain undefined fields despite other entities
   * @param changes 
   */
  update(changes) {
    for (const key in changes)
      if (changes.hasOwnProperty(key))
        this[key] = changes[key] === null ? void 0 : changes[key];
    if (changes.softDeleted === null)
      this.softDeleted = null;
  }
  toExtendedFilter() {
    if (this.extendedFilterId || this.groups && this.groups.length > 0)
      return new ExtendedFilter({ id: this.extendedFilterId, groups: this.groups });
    return null;
  }
  hasChanges(filter2) {
    return this.search != filter2.search || this.softDeleted != filter2.softDeleted || this.extendedFilterId != filter2.extendedFilterId || this.extendedFilter != filter2.extendedFilter;
  }
}
var __defProp$3l = Object.defineProperty;
var __getOwnPropDesc$37 = Object.getOwnPropertyDescriptor;
var __decorateClass$3n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$37(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3l(target, key, result);
  return result;
};
var CustomFieldType = /* @__PURE__ */ ((CustomFieldType2) => {
  CustomFieldType2["Text"] = "text";
  CustomFieldType2["TextArea"] = "textArea";
  CustomFieldType2["DateTime"] = "dateTime";
  CustomFieldType2["Number"] = "number";
  CustomFieldType2["Boolean"] = "boolean";
  CustomFieldType2["List"] = "list";
  CustomFieldType2["MultiList"] = "multiList";
  CustomFieldType2["Date"] = "date";
  return CustomFieldType2;
})(CustomFieldType || {});
const _CustomField = class _CustomField2 extends Entity$1 {
  constructor(f) {
    super();
    if (f) this.update(f);
  }
  get hasKey() {
    return !isEmpty(this.keyName);
  }
  get isListType() {
    return this.type == "list" || this.type == "multiList";
  }
  get listOptions() {
    switch (this.type) {
      case "list":
      case "multiList":
        return this.additionalData ? JSON.parse(this.additionalData) : [];
      default:
        return [];
    }
  }
  get isDateType() {
    return this.type == "date" || this.type == "dateTime";
  }
  set listOptions(options) {
    runInAction(() => this.additionalData = JSON.stringify(options));
  }
  clone(f) {
    return new _CustomField2({
      ...this,
      ...f
    });
  }
  toJson() {
    return toJS({
      name: this.name,
      keyName: this.keyName,
      additionalData: this.additionalData,
      type: this.type,
      required: this.required,
      visible: this.visible
    });
  }
  update(attr, allowUndefined = false) {
    super.update(attr, allowUndefined);
  }
  static default() {
    return new _CustomField2({
      type: "text",
      additionalData: JSON.stringify([])
    });
  }
  static fromJson(json) {
    return new _CustomField2({
      ...json
    });
  }
};
__decorateClass$3n([
  observable
], _CustomField.prototype, "name", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "keyName", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "additionalData", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "type", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "position", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "visible", 2);
__decorateClass$3n([
  observable
], _CustomField.prototype, "required", 2);
__decorateClass$3n([
  computed
], _CustomField.prototype, "hasKey", 1);
__decorateClass$3n([
  computed
], _CustomField.prototype, "isListType", 1);
__decorateClass$3n([
  computed
], _CustomField.prototype, "listOptions", 1);
__decorateClass$3n([
  computed
], _CustomField.prototype, "isDateType", 1);
__decorateClass$3n([
  action
], _CustomField.prototype, "update", 1);
let CustomField = _CustomField;
var __defProp$3k = Object.defineProperty;
var __getOwnPropDesc$36 = Object.getOwnPropertyDescriptor;
var __decorateClass$3m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$36(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3k(target, key, result);
  return result;
};
const _CustomFieldValue = class _CustomFieldValue2 extends Entity$1 {
  constructor(attr) {
    super(attr);
    if (attr) this.update(attr);
  }
  get value() {
    if (this.valueBoolean !== void 0) return this.valueBoolean;
    if (this.valueNumeric !== void 0) return this.valueNumeric;
    if (this.valueDateTime !== void 0) return this.valueDateTime;
    if (this.valueDate !== void 0) return this.valueDate;
    if (this.valueString !== void 0) return this.valueString;
    if (this.valueList !== void 0) return this.valueList;
    return this.valueMultiList;
  }
  update(attr, allowUndefined = false) {
    super.update(attr, allowUndefined);
  }
  isEquals(attrValue) {
    if (this.customField.id != attrValue.customField.id) return false;
    if (this.valueBoolean !== void 0) return this.valueBoolean === attrValue.valueBoolean;
    if (this.valueNumeric !== void 0) return this.valueNumeric === attrValue.valueNumeric;
    if (this.valueDateTime !== void 0) return this.valueDateTime === attrValue.valueDateTime;
    if (this.valueDate !== void 0) return this.valueDate === attrValue.valueDate;
    if (this.valueString !== void 0) return this.valueString === attrValue.valueString;
    if (this.valueList !== void 0) return this.valueList === attrValue.valueList;
    return isArraysEqual(this.valueMultiList, attrValue.valueMultiList);
  }
  copy() {
    return new _CustomFieldValue2({
      id: this.id,
      customField: this.customField,
      valueString: this.valueString,
      valueNumeric: this.valueNumeric,
      valueBoolean: this.valueBoolean,
      valueDateTime: this.valueDateTime,
      valueDate: this.valueDate,
      valueList: this.valueList,
      valueMultiList: this.valueMultiList?.slice()
    });
  }
  get valueJson() {
    return this.valueMultiList ? JSON.stringify(this.value) : this.value;
  }
  /**
   * @returns short json object for api
   */
  toJson() {
    return {
      id: this.customField.id,
      value: this.valueJson
    };
  }
  /**
   * json which contains all fields, it can be restored via `fromJson`
   */
  toFullJson() {
    return {
      id: this.customField.id,
      valueString: this.valueString,
      valueNumeric: this.valueNumeric,
      valueBoolean: this.valueBoolean,
      valueDateTime: this.valueDateTime,
      valueDate: this.valueDate,
      valueList: this.valueList,
      valueMultiList: this.valueMultiList,
      field: this.customField ? {
        id: this.customField.id,
        name: this.customField.name,
        type: this.customField.type
      } : void 0
    };
  }
  clone() {
    return new _CustomFieldValue2({
      ...this
    });
  }
  static fromJson(json) {
    return new _CustomFieldValue2({
      id: json.id,
      valueString: json.valueString ?? void 0,
      valueNumeric: json.valueNumeric ?? void 0,
      valueBoolean: json.valueBoolean ?? void 0,
      valueDateTime: json.valueDateTime ? moment(json.valueDateTime) : void 0,
      valueDate: json.valueDate ? moment(json.valueDate) : void 0,
      valueList: json.valueList ?? void 0,
      valueMultiList: json.valueMultiList ? Array.isArray(json.valueMultiList) ? json.valueMultiList : [json.valueMultiList] : void 0,
      customField: json.field ? CustomField.fromJson(json.field) : void 0
    });
  }
  static fromValueType(type4, value) {
    const val = new _CustomFieldValue2();
    switch (type4) {
      case CustomFieldType.Boolean:
        val.valueBoolean = value;
        break;
      case CustomFieldType.Date:
        val.valueDate = value && moment(value);
        break;
      case CustomFieldType.DateTime:
        val.valueDateTime = value && moment(value);
        break;
      case CustomFieldType.List:
        val.valueList = value;
        break;
      case CustomFieldType.MultiList:
        const multiValue = typeof value === "string" ? JSON.parse(value) : value;
        val.valueMultiList = Array.isArray(multiValue) ? multiValue : [multiValue];
        break;
      case CustomFieldType.Number:
        val.valueNumeric = value && parseFloat(value);
        break;
      case CustomFieldType.Text:
      case CustomFieldType.TextArea:
        val.valueString = value;
        break;
    }
    return val;
  }
  /**
   * TODO use it here, in purchase order, in pipeline stage item, in contact
   */
  static parseValuesFromJson(values, parse2) {
    const customAttrValues = values ? values.map((x) => parse2 ? parse2(x) : _CustomFieldValue2.fromJson(x)) : [];
    const grouped = customAttrValues.groupBy((x) => x.customField.id);
    const result = [];
    grouped.forEach((x) => {
      const first = x[0];
      if (first.customField.type == CustomFieldType.MultiList) {
        const combinedValues = x.map((x2) => x2.valueMultiList).reduce((a, b) => [...a, ...b]);
        first.update({ valueMultiList: combinedValues });
      }
      result.push(first);
    });
    return result;
  }
};
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueString", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueNumeric", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueBoolean", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueDateTime", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueDate", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueList", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "valueMultiList", 2);
__decorateClass$3m([
  observable
], _CustomFieldValue.prototype, "customField", 2);
__decorateClass$3m([
  computed
], _CustomFieldValue.prototype, "value", 1);
__decorateClass$3m([
  action
], _CustomFieldValue.prototype, "update", 1);
let CustomFieldValue = _CustomFieldValue;
var __defProp$3j = Object.defineProperty;
var __getOwnPropDesc$35 = Object.getOwnPropertyDescriptor;
var __decorateClass$3l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$35(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3j(target, key, result);
  return result;
};
const _AccelFileConversion = class _AccelFileConversion2 extends Entity$1 {
  constructor(conversion) {
    super(conversion);
    if (conversion) this.update(conversion);
  }
  static fromJson(json) {
    return new _AccelFileConversion2({
      id: json.id,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      type: json.type,
      status: json.status,
      data: json.dataJson ? JSON.parse(json.dataJson) : void 0,
      progress: json.progress,
      file: json.file ? AccelFile.fromJson(json.file) : void 0
    });
  }
  update(conversion, allowUndefined = false) {
    super.update(conversion, allowUndefined);
  }
};
__decorateClass$3l([
  observable
], _AccelFileConversion.prototype, "status", 2);
__decorateClass$3l([
  observable
], _AccelFileConversion.prototype, "data", 2);
__decorateClass$3l([
  observable
], _AccelFileConversion.prototype, "progress", 2);
__decorateClass$3l([
  action
], _AccelFileConversion.prototype, "update", 1);
let AccelFileConversion = _AccelFileConversion;
var __defProp$3i = Object.defineProperty;
var __getOwnPropDesc$34 = Object.getOwnPropertyDescriptor;
var __decorateClass$3k = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$34(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$3i(target, key, result);
  return result;
};
const _Timezone = class _Timezone2 extends Entity$1 {
  constructor(timezone) {
    super(timezone);
    if (timezone) this.update(timezone);
  }
  get offsetAsText() {
    if (!this.offset) return "";
    const negative = this.offset.asMilliseconds() < 0;
    const hours = Math.floor(Math.abs(this.offset.asHours()));
    const mins = Math.abs(this.offset.asMinutes()) - hours * 60;
    const format2 = hours.toString().padStart(2, "0") + ":" + mins.toString().padStart(2, "0");
    return negative ? `-${format2}` : `+${format2}`;
  }
  update(timezone) {
    super.update(timezone);
  }
  clone() {
    return new _Timezone2({
      id: this.id,
      offset: this.offset,
      name: this.name
    });
  }
  static fromJson(json) {
    return new _Timezone2({
      id: json.id,
      offset: moment.duration(json.offset ?? "00:00"),
      name: json.name
    });
  }
  static utc() {
    return new _Timezone2({
      id: "UTC",
      offset: moment.duration("00:00")
    });
  }
};
__decorateClass$3k([
  action
], _Timezone.prototype, "update");
let Timezone = _Timezone;
var __defProp$3h = Object.defineProperty;
var __getOwnPropDesc$33 = Object.getOwnPropertyDescriptor;
var __decorateClass$3j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$33(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3h(target, key, result);
  return result;
};
var FileManagerItemType = /* @__PURE__ */ ((FileManagerItemType2) => {
  FileManagerItemType2["Directory"] = "directory";
  FileManagerItemType2["File"] = "file";
  return FileManagerItemType2;
})(FileManagerItemType || {});
const _FileManagerItem = class _FileManagerItem2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    this._renaming = false;
    if (item2) this.update(item2);
  }
  get isDir() {
    return this.type == "directory";
  }
  get totalItemCount() {
    return (this.folderCount ?? 0) + (this.itemCount ?? 0);
  }
  static fromJson(json) {
    return new _FileManagerItem2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      file: json.file ? AccelFile.fromJson(json.file) : void 0,
      video: json.video ? Video$1.fromJson(json.video) : void 0,
      site: json.site ? Site.fromJson(json.site) : void 0,
      duration: json.duration ? TimeSpan.fromSeconds(json.duration) : void 0,
      breadcrumbs: json.path ? json.path : []
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "name", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "file", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "video", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "type", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "createdDate", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "updatedDate", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "parentId", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "site", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "sectionType", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "size", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "duration", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "folderCount", 2);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "itemCount", 2);
__decorateClass$3j([
  computed
], _FileManagerItem.prototype, "isDir", 1);
__decorateClass$3j([
  computed
], _FileManagerItem.prototype, "totalItemCount", 1);
__decorateClass$3j([
  observable
], _FileManagerItem.prototype, "_renaming", 2);
__decorateClass$3j([
  action
], _FileManagerItem.prototype, "update", 1);
let FileManagerItem = _FileManagerItem;
class FileManagerItemFilter extends BaseFilter {
  constructor(filter2, fsTarget) {
    super();
    if (filter2) this.update(filter2);
    if (fsTarget) this.update({
      ...fsTarget
    });
  }
  update(changes) {
    super.update(changes);
  }
}
var __defProp$3g = Object.defineProperty;
var __getOwnPropDesc$32 = Object.getOwnPropertyDescriptor;
var __decorateClass$3i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$32(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3g(target, key, result);
  return result;
};
const _Admin = class _Admin2 extends User {
  constructor(user2) {
    super(user2);
    if (user2) this.update(user2);
  }
  clone() {
    return new _Admin2({
      ...this,
      school: this.school?.clone(),
      schools: this.schools.map((s) => s.clone()),
      partner: this.partner?.clone(),
      avatar: this.avatar?.clone(),
      birthday: this.birthday ? new Date(this.birthday) : void 0,
      createdDate: this.createdDate ? moment(this.createdDate) : void 0,
      emailConfirmationSentDate: this.emailConfirmationSentDate ? new Date(this.emailConfirmationSentDate) : null
    });
  }
  update(user2, allowUndefined = false) {
    super.update(user2, allowUndefined);
  }
  static fromJson(json) {
    return new _Admin2({
      ...json,
      school: json.school ? School.fromJson(json.school) : null,
      schools: json.schools ? json.schools.map(School.fromJson) : [],
      partner: json.partner ? _Admin2.fromJson(json.partner) : null,
      avatar: json.avatar ? AccelFile.fromJson(json.avatar) : void 0,
      birthday: json.birthday ? new Date(json.birthday) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      emailConfirmationSentDate: json.emailConfirmationSentDate ? new Date(json.emailConfirmationSentDate) : null
    });
  }
};
__decorateClass$3i([
  observable
], _Admin.prototype, "post", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "isEmailConfirmed", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "emailConfirmationSentDate", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "isPhoneConfirmed", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "needChangePassword", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "school", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "schools", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "partner", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "type", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "partnerStatus", 2);
__decorateClass$3i([
  observable
], _Admin.prototype, "createdDate", 2);
__decorateClass$3i([
  action
], _Admin.prototype, "update", 1);
let Admin = _Admin;
var __defProp$3f = Object.defineProperty;
var __getOwnPropDesc$31 = Object.getOwnPropertyDescriptor;
var __decorateClass$3h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$31(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3f(target, key, result);
  return result;
};
const _AdminPartnerTransaction = class _AdminPartnerTransaction2 extends Entity$1 {
  constructor(transaction2) {
    super(transaction2);
    if (transaction2) this.update(transaction2);
  }
  clone() {
    return new _AdminPartnerTransaction2({
      ...this,
      admin: this.admin?.clone(),
      fromAdmin: this.fromAdmin ? this.fromAdmin.clone() : null
    });
  }
  update(user2, allowUndefined = false) {
    super.update(user2, allowUndefined);
  }
  static fromJson(json) {
    return new _AdminPartnerTransaction2({
      id: json.id,
      mainServiceAmount: json.mainServiceAmount,
      additionalServiceAmount: json.additionalServiceAmount,
      totalAmount: json.totalAmount,
      exchangeCurrency: json.exchangeCurrency,
      exchangeRate: json.exchangeRate,
      comment: json.comment,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      fromAdmin: json.fromAdmin ? Admin.fromJson(json.fromAdmin) : void 0
    });
  }
};
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "mainServiceAmount", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "additionalServiceAmount", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "totalAmount", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "exchangeCurrency", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "exchangeRate", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "createdDate", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "admin", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "fromAdmin", 2);
__decorateClass$3h([
  observable
], _AdminPartnerTransaction.prototype, "comment", 2);
__decorateClass$3h([
  action
], _AdminPartnerTransaction.prototype, "update", 1);
let AdminPartnerTransaction = _AdminPartnerTransaction;
var __defProp$3e = Object.defineProperty;
var __getOwnPropDesc$30 = Object.getOwnPropertyDescriptor;
var __decorateClass$3g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$30(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3e(target, key, result);
  return result;
};
const _AdminPartnerTariff = class _AdminPartnerTariff2 extends Entity$1 {
  constructor(tariff) {
    super(tariff);
    if (tariff) this.update(tariff);
  }
  update(user2, allowUndefined = false) {
    super.update(user2, allowUndefined);
  }
  static fromJson(json) {
    return new _AdminPartnerTariff2({
      id: json.id,
      name: json.name,
      mainServicePercent: json.mainServicePercent,
      additionalServicePercent: json.additionalServicePercent,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0
    });
  }
};
__decorateClass$3g([
  observable
], _AdminPartnerTariff.prototype, "name", 2);
__decorateClass$3g([
  observable
], _AdminPartnerTariff.prototype, "mainServicePercent", 2);
__decorateClass$3g([
  observable
], _AdminPartnerTariff.prototype, "additionalServicePercent", 2);
__decorateClass$3g([
  observable
], _AdminPartnerTariff.prototype, "admin", 2);
__decorateClass$3g([
  action
], _AdminPartnerTariff.prototype, "update", 1);
var __defProp$3d = Object.defineProperty;
var __getOwnPropDesc$2$ = Object.getOwnPropertyDescriptor;
var __decorateClass$3f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2$(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3d(target, key, result);
  return result;
};
const _CustomAttribute = class _CustomAttribute2 extends CustomField {
  constructor(attr) {
    super(attr);
    this.limitedAccess = false;
    this.hideInView = false;
    if (attr) this.update(attr);
  }
  update(attr, allowUndefined = false) {
    super.update(attr, allowUndefined);
  }
  clone() {
    return new _CustomAttribute2({
      ...this,
      type: this.type ?? CustomFieldType.Text,
      additionalData: this?.additionalData ?? JSON.stringify([])
    });
  }
  static default() {
    return new _CustomAttribute2({
      type: CustomFieldType.Text,
      additionalData: JSON.stringify([]),
      hideInView: false
    });
  }
  static fromJson(json) {
    return new _CustomAttribute2({
      ...json,
      // set visible to show the 'eye' icon on the list
      visible: !json.hideInView
    });
  }
};
__decorateClass$3f([
  observable
], _CustomAttribute.prototype, "limitedAccess", 2);
__decorateClass$3f([
  observable
], _CustomAttribute.prototype, "hideInView", 2);
__decorateClass$3f([
  action
], _CustomAttribute.prototype, "update", 1);
let CustomAttribute = _CustomAttribute;
var __defProp$3c = Object.defineProperty;
var __getOwnPropDesc$2_ = Object.getOwnPropertyDescriptor;
var __decorateClass$3e = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$2_(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$3c(target, key, result);
  return result;
};
const _CustomAttributeValue = class _CustomAttributeValue2 extends CustomFieldValue {
  constructor(attr) {
    super(attr);
    if (attr) this.update(attr);
  }
  update(attr, allowUndefined = false) {
    super.update(attr, allowUndefined);
  }
  clone() {
    return new _CustomAttributeValue2({
      id: this.id,
      customField: this.customField,
      valueString: this.valueString,
      valueNumeric: this.valueNumeric,
      valueBoolean: this.valueBoolean,
      valueDateTime: this.valueDateTime,
      valueDate: this.valueDate,
      valueList: this.valueList,
      valueMultiList: this.valueMultiList?.slice()
    });
  }
  static fromJson(json) {
    const base = CustomFieldValue.fromJson(json);
    return new _CustomAttributeValue2({
      ...base,
      customField: json.leadAttribute ? CustomAttribute.fromJson(json.leadAttribute) : void 0
    });
  }
};
__decorateClass$3e([
  action
], _CustomAttributeValue.prototype, "update");
let CustomAttributeValue = _CustomAttributeValue;
var __defProp$3b = Object.defineProperty;
var __getOwnPropDesc$2Z = Object.getOwnPropertyDescriptor;
var __decorateClass$3d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2Z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3b(target, key, result);
  return result;
};
const _Contact = class _Contact2 extends User {
  constructor(contact) {
    super(contact);
    if (contact) this.update(contact);
  }
  getAttributeValue(attrId) {
    const val = this.customAttributesValues.find((x) => x.customField.id == attrId);
    return val ?? null;
  }
  setAttributeValue(value) {
    const val = this.getAttributeValue(value.customField.id);
    if (val) {
      val.update(value, true);
    } else {
      this.customAttributesValues.push(value);
    }
  }
  update(contact, allowUndefined = false) {
    super.update(contact, allowUndefined);
  }
  clone() {
    return new _Contact2({
      ...this
    });
  }
  static fromJson(json) {
    return new _Contact2({
      ...json,
      avatar: json.avatar ? AccelFile.fromJson(json.avatar) : void 0,
      birthday: json.birthday ? new Date(json.birthday) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      emailConfirmationSentDate: json.emailConfirmationSentDate ? new Date(json.emailConfirmationSentDate) : null,
      customAttributesValues: _Contact2.parseAttrValuesFromJson(json.leadAttributeValues),
      softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : void 0
    });
  }
  static parseAttrValuesFromJson(values) {
    const customAttrValues = values ? values.map(CustomAttributeValue.fromJson) : [];
    const grouped = customAttrValues.groupBy((x) => x.customField.id);
    const result = [];
    grouped.forEach((x) => {
      const first = x[0];
      if (first.customField.type == CustomFieldType.MultiList) {
        const combinedValues = x.map((x2) => x2.valueMultiList).reduce((a, b) => [...a, ...b]);
        first.update({ valueMultiList: combinedValues });
      }
      result.push(first);
    });
    return result;
  }
};
__decorateClass$3d([
  observable
], _Contact.prototype, "banned", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "isEmailConfirmed", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "isSchoolEmailConfirmed", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "emailConfirmationSentDate", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "isPhoneConfirmed", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "needChangePassword", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "customAttributesValues", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "createdDate", 2);
__decorateClass$3d([
  observable
], _Contact.prototype, "partnerId", 2);
__decorateClass$3d([
  action
], _Contact.prototype, "setAttributeValue", 1);
__decorateClass$3d([
  action
], _Contact.prototype, "update", 1);
let Contact = _Contact;
class ContactFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
var __defProp$3a = Object.defineProperty;
var __getOwnPropDesc$2Y = Object.getOwnPropertyDescriptor;
var __decorateClass$3c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2Y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3a(target, key, result);
  return result;
};
const _ContactCourse = class _ContactCourse2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  get hasFeedback() {
    return !isEmpty(this.feedback);
  }
  static fromJson(json) {
    return new _ContactCourse2({
      id: json.id,
      softDeleted: json.softDeleted,
      state: json.state,
      progress: json.progress,
      feedback: json.feedback,
      score: json.score,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      course: json.course ? Course.fromJson(json.course) : void 0,
      currentCourseItem: json.currentCourseItem ? CourseItem.fromJson(json.currentCourseItem) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      lastActivityDate: json.lastActivityDate ? new Date(json.lastActivityDate) : void 0,
      beginDate: json.beginDate ? new Date(json.beginDate) : void 0,
      endDate: json.endDate ? new Date(json.endDate) : void 0
    });
  }
  update(course) {
    super.update(course);
  }
};
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "beginDate", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "endDate", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "state", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "progress", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "contact", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "course", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "currentCourseItem", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "feedback", 2);
__decorateClass$3c([
  observable
], _ContactCourse.prototype, "score", 2);
__decorateClass$3c([
  computed
], _ContactCourse.prototype, "hasFeedback", 1);
__decorateClass$3c([
  action
], _ContactCourse.prototype, "update", 1);
var __defProp$39 = Object.defineProperty;
var __getOwnPropDesc$2X = Object.getOwnPropertyDescriptor;
var __decorateClass$3b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2X(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$39(target, key, result);
  return result;
};
const _ContactLicense = class _ContactLicense2 extends Entity$1 {
  constructor(license) {
    super(license);
    this.renewalCountLimitEnabled = false;
    this.renewalCountLimit = null;
    if (license) this.update(license);
  }
  get isActive() {
    if (this.endDate == null)
      return this.beginDate.isSameOrBefore(moment());
    return this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  get isSuspended() {
    return this.currentSuspension != null;
  }
  get isBeginInFuture() {
    return this.beginDate.isAfter(moment());
  }
  get isSubscriptionActive() {
    return this.beginDate.isSameOrBefore() && (this.creditEndDate && this.creditEndDate.isAfter() || !this.creditEndDate && this.endDate && this.endDate.isAfter() || this.endDate == null);
  }
  get isSubscriptionEnding() {
    return this.isSubscriptionActive && this.endDate && this.creditEndDate && this.endDate.isSameOrBefore() && this.creditEndDate.isAfter();
  }
  get isSubscriptionEnded() {
    return !this.isSubscriptionActive && this.endDate && this.creditEndDate && this.creditEndDate.isSameOrBefore();
  }
  get canPauseSubscription() {
    return this.state == "active" && !this.isSubscriptionEnded;
  }
  get canContinueSubscription() {
    return this.state == "paused" && !this.isSubscriptionEnded;
  }
  get hasLibraryItems() {
    return this.libraryItemIds && this.libraryItemIds.length > 0;
  }
  get periodInDays() {
    if (this.beginDate != null && this.endDate != null)
      return this.endDate.diff(this.beginDate, "days");
    return 0;
  }
  get daysAndHoursLeft() {
    return this.calculateDaysLeft(this.endDate, false);
  }
  get creditDaysAndHoursLeft() {
    return this.calculateDaysLeft(this.creditEndDate, true);
  }
  get subjectId() {
    switch (this.type) {
      case "flowDate":
        return this.flowDate?.id;
      case "course":
        return this.course?.id;
      case "library":
        return this.library?.id;
      case "product":
        return this.product?.id;
    }
  }
  get isDeleted() {
    switch (this.type) {
      case "flowDate":
        return this.flowDate?.softDeleted || this.flowDate?.flow.softDeleted;
      case "course":
        return this.coursePlan?.softDeleted || this.course?.softDeleted;
      case "library":
        return this.library?.softDeleted;
      case "product":
        return this.product?.softDeleted;
    }
  }
  get canEditContent() {
    return this.purchaseOrder == null;
  }
  changeType(type4) {
    this.update({
      type: type4,
      course: null,
      coursePlan: null,
      flowDate: null,
      product: null,
      library: null,
      libraryItemIds: null,
      renewalCountLimitEnabled: false,
      renewalCountLimit: null
    });
  }
  isDateInLicense(date4, granularity) {
    return this.beginDate.isSameOrBefore(date4, granularity) && (!this.endDate || this.endDate.isSameOrAfter(date4, granularity));
  }
  calculateDaysLeft(date4, isCredit) {
    if (date4 == null)
      return { days: isCredit ? 0 : Infinity, hours: 0, lessThanOneDay: false, lessThanOneHour: false, daysAgo: 0 };
    let totalHoursLeft = date4.diff(moment.now(), "hours", true);
    let daysLeft = Math.trunc(totalHoursLeft / 24);
    let hoursLeft = Math.floor(totalHoursLeft % 24);
    if (totalHoursLeft < 0)
      return { days: 0, hours: 0, daysAgo: Math.abs(daysLeft), lessThanOneDay: false, lessThanOneHour: false };
    const lessThanOneDay = daysLeft < 1;
    const lessThanOneHour = daysLeft === 0 && totalHoursLeft < 1;
    return { days: daysLeft, hours: hoursLeft, lessThanOneDay, lessThanOneHour, daysAgo: 0 };
  }
  static fromJson(json) {
    const license = new _ContactLicense2({
      ...json,
      contact: json.contact ? Contact.fromJson(json.contact) : void 0,
      beginDate: json.beginDate ? moment(json.beginDate) : void 0,
      endDate: json.endDate ? moment(json.endDate) : null,
      creditEndDate: json.creditEndDate ? moment(json.creditEndDate) : null,
      course: json.course ? Course.fromJson(json.course) : void 0,
      coursePlan: json.coursePlan ? CoursePlan.fromJson(json.coursePlan) : void 0,
      product: json.product ? new Product(json.product) : void 0,
      flowDate: json.flowDate ? FlowDate.fromJson(json.flowDate) : void 0,
      library: json.libraryAccess ? Library.fromJson(json.libraryAccess.library) : void 0,
      libraryItemIds: json.libraryAccess && json.libraryAccess.itemAccesses ? json.libraryAccess.itemAccesses.map((x) => x.libraryItem.id) : null,
      purchaseOrder: json.purchaseOrder ? PurchaseOrder.fromJson(json.purchaseOrder) : void 0,
      currentSuspension: json.currentSuspension ? ContactLicenseSuspension.fromJson(json.currentSuspension) : null,
      suspendedPeriod: json.suspendedPeriodInSec ? TimeSpan.fromSeconds(json.suspendedPeriodInSec) : TimeSpan.zero
    });
    if (license.coursePlan)
      license.update({ course: license.coursePlan?.course });
    return license;
  }
  update(license) {
    super.update(license);
  }
};
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "contact", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "purchaseOrder", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "course", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "coursePlan", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "flowDate", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "library", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "libraryItemIds", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "product", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "type", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "state", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "beginDate", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "endDate", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "creditEndDate", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "currentSuspension", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "suspendedPeriod", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "renewalCountLimitEnabled", 2);
__decorateClass$3b([
  observable
], _ContactLicense.prototype, "renewalCountLimit", 2);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isActive", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isSuspended", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isBeginInFuture", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isSubscriptionActive", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isSubscriptionEnding", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "isSubscriptionEnded", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "canPauseSubscription", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "canContinueSubscription", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "hasLibraryItems", 1);
__decorateClass$3b([
  computed
], _ContactLicense.prototype, "periodInDays", 1);
__decorateClass$3b([
  action
], _ContactLicense.prototype, "update", 1);
let ContactLicense = _ContactLicense;
const _ContactLicenseSuspension = class _ContactLicenseSuspension2 extends Entity$1 {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get periodInDays() {
    if (this.beginDate != null && this.endDate != null)
      return this.endDate.diff(this.beginDate, "days");
    return 0;
  }
  get isActive() {
    return this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  toJson() {
    return {
      beginDate: this.beginDate,
      endDate: this.endDate,
      licenseId: this.license?.id
    };
  }
  update(s) {
    super.update(s);
  }
  static fromJson(json) {
    return new _ContactLicenseSuspension2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      beginDate: json.beginDate ? moment(json.beginDate) : void 0,
      endDate: json.endDate ? moment(json.endDate) : null,
      license: json.license ? ContactLicense.fromJson(json.license) : void 0
    });
  }
};
__decorateClass$3b([
  observable
], _ContactLicenseSuspension.prototype, "beginDate", 2);
__decorateClass$3b([
  observable
], _ContactLicenseSuspension.prototype, "endDate", 2);
__decorateClass$3b([
  observable
], _ContactLicenseSuspension.prototype, "license", 2);
__decorateClass$3b([
  computed
], _ContactLicenseSuspension.prototype, "periodInDays", 1);
__decorateClass$3b([
  computed
], _ContactLicenseSuspension.prototype, "isActive", 1);
__decorateClass$3b([
  action
], _ContactLicenseSuspension.prototype, "update", 1);
let ContactLicenseSuspension = _ContactLicenseSuspension;
var __defProp$38 = Object.defineProperty;
var __getOwnPropDesc$2W = Object.getOwnPropertyDescriptor;
var __decorateClass$3a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2W(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$38(target, key, result);
  return result;
};
const _ContactCommunication = class _ContactCommunication2 extends Entity$1 {
  constructor(user2) {
    super(user2);
    if (user2) this.update(user2);
  }
  update(g, allowUndefined = false) {
    super.update(g, allowUndefined);
  }
  get hasNameOrFullName() {
    return this.externalName || this.externalFullName;
  }
  get externalFullName() {
    const emptyFirstName = isEmpty(this.externalFirstName);
    const emptyLastName = isEmpty(this.externalLastName);
    if (emptyFirstName && emptyLastName)
      return null;
    if (emptyFirstName)
      return this.externalLastName;
    if (emptyLastName)
      return this.externalFirstName;
    return `${this.externalFirstName} ${this.externalLastName}`;
  }
  static fromJson(json) {
    return new _ContactCommunication2({
      ...json,
      softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      contact: json.student ? Contact.fromJson(json.student) : null
    });
  }
};
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "externalId", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "externalName", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "externalFirstName", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "externalLastName", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "type", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "createdDate", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "updatedDate", 2);
__decorateClass$3a([
  observable
], _ContactCommunication.prototype, "contact", 2);
__decorateClass$3a([
  action
], _ContactCommunication.prototype, "update", 1);
__decorateClass$3a([
  computed
], _ContactCommunication.prototype, "hasNameOrFullName", 1);
__decorateClass$3a([
  computed
], _ContactCommunication.prototype, "externalFullName", 1);
let ContactCommunication = _ContactCommunication;
var __defProp$37 = Object.defineProperty;
var __getOwnPropDesc$2V = Object.getOwnPropertyDescriptor;
var __decorateClass$39 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2V(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$37(target, key, result);
  return result;
};
const _ContactGroup = class _ContactGroup2 extends Entity$1 {
  constructor(group2) {
    super(group2);
    if (group2) this.update(group2);
  }
  update(tag) {
    super.update(tag);
  }
  clone() {
    return new _ContactGroup2(this);
  }
  static fromJson(json) {
    return new _ContactGroup2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
};
__decorateClass$39([
  observable
], _ContactGroup.prototype, "name", 2);
__decorateClass$39([
  action
], _ContactGroup.prototype, "update", 1);
let ContactGroup = _ContactGroup;
var __defProp$36 = Object.defineProperty;
var __getOwnPropDesc$2U = Object.getOwnPropertyDescriptor;
var __decorateClass$38 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2U(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$36(target, key, result);
  return result;
};
const _SchoolBilling = class _SchoolBilling2 extends Entity$1 {
  constructor(b) {
    super(b);
    if (b) this.update(b);
  }
  get totalBalance() {
    return this.balance + this.bonusBalance;
  }
  get totalBalanceWithCredit() {
    return this.totalBalance + this.credit;
  }
  get hasLowBalance() {
    return this.totalBalance < 0 && this.totalBalance - this.credit > 0;
  }
  get isLocked() {
    return this.credit == 0 ? this.totalBalanceWithCredit < 0 : this.totalBalanceWithCredit <= 0;
  }
  get trialCompletedDate() {
    return this.trialDaysCount <= 0 ? null : moment(this.createdDate).utc().startOf("day").add(this.trialDaysCount, "days");
  }
  get trialCompletedDateExpired() {
    return this.trialCompletedDate && this.trialCompletedDate > moment();
  }
  get needToAcceptAgreement() {
    return this.plan?.isAgreementRequired && !this.agreedBillingPlan;
  }
  get isProdamusGateway() {
    return this.gatewayType == PaymentGatewayType.Prodamus;
  }
  get minDepositAmount() {
    switch (this.currency) {
      case Currency.RUB:
        return this.isProdamusGateway ? 50 : 1;
      case Currency.USD:
        return 1;
      case Currency.EUR:
        return 1;
      case Currency.IDR:
        return 1e3;
      default:
        return 0;
    }
  }
  update(billing, allowUndefined = false) {
    super.update(billing, allowUndefined);
  }
  toJson() {
    return { ...this };
  }
  clone() {
    return new _SchoolBilling2({
      ...this,
      plan: this.plan?.clone(),
      paymentMethod: this.paymentMethod?.clone()
    });
  }
  static fromJson(json) {
    return new _SchoolBilling2({
      id: json.id,
      balance: json.balance,
      bonusBalance: json.bonusBalance,
      credit: json.credit,
      trialDaysCount: json.trialDaysCount,
      discountOnMainServices: json.discountOnMainServices,
      discountOnExtraServices: json.discountOnExtraServices,
      autoRecharge: json.autoRecharge,
      autoRechargeAmount: json.autoRechargeAmount,
      autoRechargeBalance: json.autoRechargeBalance,
      agreedBillingPlan: json.agreedBillingPlan,
      currency: json.currency,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      plan: json.billingPlan ? BillingPlan.fromJson(json.billingPlan) : void 0,
      paymentMethod: json.autoRechargePaymentMethod ? BillingPaymentMethod.fromJson(json.autoRechargePaymentMethod) : void 0,
      school: json.school ? School.fromJson(json.school) : void 0
    });
  }
  get gatewayType() {
    switch (this.currency) {
      case Currency.RUB:
        return PaymentGatewayType.Prodamus;
      default:
        return PaymentGatewayType.AuthorizeNet;
    }
  }
};
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "balance", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "bonusBalance", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "credit", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "discountOnMainServices", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "discountOnExtraServices", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "trialDaysCount", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "autoRecharge", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "autoRechargeAmount", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "autoRechargeBalance", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "agreedBillingPlan", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "createdDate", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "currency", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "plan", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "paymentMethod", 2);
__decorateClass$38([
  observable
], _SchoolBilling.prototype, "school", 2);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "totalBalance", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "totalBalanceWithCredit", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "hasLowBalance", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "isLocked", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "trialCompletedDate", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "trialCompletedDateExpired", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "needToAcceptAgreement", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "isProdamusGateway", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "minDepositAmount", 1);
__decorateClass$38([
  action
], _SchoolBilling.prototype, "update", 1);
__decorateClass$38([
  computed
], _SchoolBilling.prototype, "gatewayType", 1);
let SchoolBilling = _SchoolBilling;
var __defProp$35 = Object.defineProperty;
var __getOwnPropDesc$2T = Object.getOwnPropertyDescriptor;
var __decorateClass$37 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2T(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$35(target, key, result);
  return result;
};
const _SchoolMetadata = class _SchoolMetadata2 extends Entity$1 {
  constructor(b) {
    super(b);
    if (b) this.update(b);
  }
  get hasUtm() {
    return this.utmSource != null || this.utmMedium != null || this.utmCampaign != null || this.utmTerm != null || this.utmContent != null;
  }
  clone() {
    return new _SchoolMetadata2({
      ...this,
      partnerBonusTransaction: this.partnerBonusTransaction ? this.partnerBonusTransaction.clone() : null,
      billingPromoCode: this.billingPromoCode ? this.billingPromoCode.clone() : null
    });
  }
  update(metadata, allowUndefined = false) {
    super.update(metadata, allowUndefined);
  }
  static fromJson(json) {
    return new _SchoolMetadata2({
      id: json.id,
      organisationActivity: json.organisationActivity,
      organisationActivityOther: json.organisationActivityOther,
      howDidYouHearAboutUs: json.howDidYouHearAboutUs,
      howDidYouHearAboutUsOther: json.howDidYouHearAboutUsOther,
      employeesNumber: json.employeesNumber,
      leadsNumber: json.leadsNumber,
      partnerBonusAmount: json.partnerBonusAmount,
      partnerBonusTransaction: json.partnerBonusTransaction ? AdminPartnerTransaction.fromJson(json.partnerBonusTransaction) : null,
      utmSource: json.utmSource,
      utmMedium: json.utmMedium,
      utmCampaign: json.utmCampaign,
      utmTerm: json.utmTerm,
      utmContent: json.utmContent,
      billingPromoCode: json.billingPromoCode ? BillingPromoCode.fromJson(json.billingPromoCode) : null
    });
  }
};
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "organisationActivity", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "organisationActivityOther", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "howDidYouHearAboutUs", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "howDidYouHearAboutUsOther", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "employeesNumber", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "leadsNumber", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "partnerBonusAmount", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "partnerBonusTransaction", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "utmSource", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "utmMedium", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "utmCampaign", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "utmTerm", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "utmContent", 2);
__decorateClass$37([
  observable
], _SchoolMetadata.prototype, "billingPromoCode", 2);
__decorateClass$37([
  computed
], _SchoolMetadata.prototype, "hasUtm", 1);
__decorateClass$37([
  action
], _SchoolMetadata.prototype, "update", 1);
let SchoolMetadata = _SchoolMetadata;
var __defProp$34 = Object.defineProperty;
var __getOwnPropDesc$2S = Object.getOwnPropertyDescriptor;
var __decorateClass$36 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2S(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$34(target, key, result);
  return result;
};
const _SchoolSettings = class _SchoolSettings2 extends Entity$1 {
  constructor(settings) {
    super(settings);
    this.deductionEnabled = false;
    if (settings) this.update(settings);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
  copy() {
    return new _SchoolSettings2({
      id: this.id,
      registrationAgreementText: this.registrationAgreementText,
      isRegistrationAgreementEnabled: this.isRegistrationAgreementEnabled,
      footerHtml: this.footerHtml,
      isPageFooterEnabled: this.isPageFooterEnabled,
      isLearnPageFooterEnabled: this.isLearnPageFooterEnabled,
      userSessionCountLimit: this.userSessionCountLimit,
      userSessionCountLimitEnabled: this.userSessionCountLimitEnabled,
      deductionEnabled: this.deductionEnabled,
      deduction: this.deduction
    });
  }
  static fromJson(json) {
    return new _SchoolSettings2({
      ...json,
      footerHtml: json.footerText
    });
  }
};
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "registrationAgreementText", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "isRegistrationAgreementEnabled", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "footerHtml", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "isPageFooterEnabled", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "isLearnPageFooterEnabled", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "userSessionCountLimit", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "userSessionCountLimitEnabled", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "deductionEnabled", 2);
__decorateClass$36([
  observable
], _SchoolSettings.prototype, "deduction", 2);
__decorateClass$36([
  action
], _SchoolSettings.prototype, "update", 1);
let SchoolSettings = _SchoolSettings;
var __defProp$33 = Object.defineProperty;
var __getOwnPropDesc$2R = Object.getOwnPropertyDescriptor;
var __decorateClass$35 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2R(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$33(target, key, result);
  return result;
};
const _School = class _School2 extends Entity$1 {
  constructor(school) {
    super(school);
    this.migration = null;
    if (school) this.update(school);
  }
  get hasMigrationLock() {
    return this.migration?.isActive || this.migration?.isCompleted;
  }
  get canUseBillingAddress() {
    return this.billing.currency == Currency.USD;
  }
  get hasTgAppIntegration() {
    return this.appIntegrations.includes(ApplicationType.Telegram);
  }
  get hasChatChannelIntegrations() {
    return this.chatChannelIntegrations.length > 0;
  }
  update(school) {
    super.update(school);
  }
  setPromoCode(code) {
    this.metadata.billingPromoCode?.update({ code });
  }
  get canMigrate() {
    return this.migrationStatus == "default" || this.migrationStatus == "aborted" || this.migrationStatus == "error";
  }
  clone() {
    return new _School2({
      ...this,
      settings: this.settings?.copy(),
      profileSettings: this.profileSettings.copy(),
      timezone: this.timezone.clone(),
      owner: this.owner?.clone(),
      logo: this.logo?.clone(),
      favicon: this.favicon?.clone(),
      createdDate: this.createdDate ? new Date(this.createdDate) : void 0,
      mainSiteDomain: this.mainSiteDomain?.clone(),
      billing: this.billing?.clone(),
      metadata: this.metadata?.clone(),
      chatChannelIntegrations: this.chatChannelIntegrations.map((c) => c.clone()),
      partnership: this.partnership?.clone(),
      organization: this.organization?.clone()
    });
  }
  static fromJson(json) {
    return new _School2({
      ...json,
      timezone: json.timezone ? Timezone.fromJson(json.timezone) : Timezone.utc(),
      settings: json.settings ? SchoolSettings.fromJson(json.settings) : new SchoolSettings(),
      profileSettings: SchoolProfileSettings.fromJson(json.studentProfileSettings),
      logo: json.logo ? AccelFile.fromJson(json.logo) : null,
      favicon: json.favicon ? AccelFile.fromJson(json.favicon) : null,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      mainSiteDomain: json.mainSiteDomain ? SiteDomain.fromJson(json.mainSiteDomain) : null,
      billing: json.billing ? SchoolBilling.fromJson(json.billing) : void 0,
      metadata: json.metadata ? SchoolMetadata.fromJson(json.metadata) : void 0,
      country: json.country,
      owner: json.owner ? Admin.fromJson(json.owner) : void 0,
      appIntegrations: json.appIntegrations ?? [],
      chatChannelIntegrations: json.chatChannelIntegrations ? json.chatChannelIntegrations.map(ChatChannelIntegration.fromJson) : [],
      allowCustomProductGatewaySettings: json.allowCustomProductGatewaySettings ?? false,
      allowCustomProductPaymentMethodsSettings: json.allowCustomProductPaymentMethodsSettings ?? false,
      partnership: json.partnership ? Partnership.fromJson(json.partnership) : null,
      gamification: json.gamification ? Gamification.fromJson(json.gamification) : null,
      organization: json.organization ? Organization.fromJson(json.organization) : void 0,
      migration: json.migration ? SchoolMigration.fromJson(json.migration) : void 0
      // new SchoolMigration({
      //     status: SchoolMigrationStatus.Completed,
      //     progress: 0,
      //     scheduledDate: moment().add(1, 'day'),
      //     settings: {
      //         targetUrls: {
      //             admin: 'https://admin.accelonline.io',
      //             school: 'https://school.accelonline.io',
      //         }
      //     }
      // })
    });
  }
};
__decorateClass$35([
  observable
], _School.prototype, "name", 2);
__decorateClass$35([
  observable
], _School.prototype, "description", 2);
__decorateClass$35([
  observable
], _School.prototype, "number", 2);
__decorateClass$35([
  observable
], _School.prototype, "domain", 2);
__decorateClass$35([
  observable
], _School.prototype, "customDomain", 2);
__decorateClass$35([
  observable
], _School.prototype, "disableOpenRegistration", 2);
__decorateClass$35([
  observable
], _School.prototype, "isForumAvailable", 2);
__decorateClass$35([
  observable
], _School.prototype, "settings", 2);
__decorateClass$35([
  observable
], _School.prototype, "profileSettings", 2);
__decorateClass$35([
  observable
], _School.prototype, "timezone", 2);
__decorateClass$35([
  observable
], _School.prototype, "owner", 2);
__decorateClass$35([
  observable
], _School.prototype, "logo", 2);
__decorateClass$35([
  observable
], _School.prototype, "favicon", 2);
__decorateClass$35([
  observable
], _School.prototype, "showUnavailableStartedCourses", 2);
__decorateClass$35([
  observable
], _School.prototype, "isExternal", 2);
__decorateClass$35([
  observable
], _School.prototype, "ownerId", 2);
__decorateClass$35([
  observable
], _School.prototype, "jsHeadCode", 2);
__decorateClass$35([
  observable
], _School.prototype, "jsBodyCode", 2);
__decorateClass$35([
  observable
], _School.prototype, "supportChatEnabled", 2);
__decorateClass$35([
  observable
], _School.prototype, "supportConversationTitle", 2);
__decorateClass$35([
  observable
], _School.prototype, "recordInternalCalls", 2);
__decorateClass$35([
  observable
], _School.prototype, "recordCRMCalls", 2);
__decorateClass$35([
  observable
], _School.prototype, "lang", 2);
__decorateClass$35([
  observable
], _School.prototype, "createdDate", 2);
__decorateClass$35([
  observable
], _School.prototype, "mainSiteDomain", 2);
__decorateClass$35([
  observable
], _School.prototype, "phoneBalance", 2);
__decorateClass$35([
  observable
], _School.prototype, "currency", 2);
__decorateClass$35([
  observable
], _School.prototype, "billing", 2);
__decorateClass$35([
  observable
], _School.prototype, "metadata", 2);
__decorateClass$35([
  observable
], _School.prototype, "country", 2);
__decorateClass$35([
  observable
], _School.prototype, "appIntegrations", 2);
__decorateClass$35([
  observable
], _School.prototype, "chatChannelIntegrations", 2);
__decorateClass$35([
  observable
], _School.prototype, "allowCustomProductGatewaySettings", 2);
__decorateClass$35([
  observable
], _School.prototype, "allowCustomProductPaymentMethodsSettings", 2);
__decorateClass$35([
  observable
], _School.prototype, "organization", 2);
__decorateClass$35([
  observable
], _School.prototype, "partnership", 2);
__decorateClass$35([
  observable
], _School.prototype, "gamification", 2);
__decorateClass$35([
  observable
], _School.prototype, "migration", 2);
__decorateClass$35([
  observable
], _School.prototype, "migrationStatus", 2);
__decorateClass$35([
  computed
], _School.prototype, "hasMigrationLock", 1);
__decorateClass$35([
  computed
], _School.prototype, "canUseBillingAddress", 1);
__decorateClass$35([
  computed
], _School.prototype, "hasTgAppIntegration", 1);
__decorateClass$35([
  computed
], _School.prototype, "hasChatChannelIntegrations", 1);
__decorateClass$35([
  action
], _School.prototype, "update", 1);
__decorateClass$35([
  action
], _School.prototype, "setPromoCode", 1);
__decorateClass$35([
  computed
], _School.prototype, "canMigrate", 1);
let School = _School;
const _SchoolMigration = class _SchoolMigration2 extends Entity$1 {
  constructor(schoolMigration) {
    super();
    this.school = void 0;
    this.status = "default";
    this.progress = 0;
    this.durationInMinutes = 5;
    this.scheduledDate = void 0;
    this.settings = void 0;
    this.error = void 0;
    if (schoolMigration) this.update(schoolMigration);
  }
  get isScheduled() {
    return this.status == "default" || this.status == "pending";
  }
  get isActive() {
    return this.status == "inProgress";
  }
  get isCompleted() {
    return this.status == "completed" || this.status == "aborted" || this.status == "error";
  }
  update(schoolMigration) {
    super.update(schoolMigration);
  }
  toJson() {
    return {
      ...this,
      schoolId: this.school?.id,
      school: void 0,
      scheduledDate: this.scheduledDate?.toISOString(),
      settingsJson: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  static fromJson(json) {
    return new _SchoolMigration2({
      ...json,
      scheduledDate: json.scheduledDate ? moment(json.scheduledDate) : void 0,
      settings: json.settingsJson ? JSON.parse(json.settingsJson) : void 0
    });
  }
};
__decorateClass$35([
  observable
], _SchoolMigration.prototype, "school", 2);
__decorateClass$35([
  observable
], _SchoolMigration.prototype, "status", 2);
__decorateClass$35([
  observable
], _SchoolMigration.prototype, "progress", 2);
__decorateClass$35([
  observable
], _SchoolMigration.prototype, "durationInMinutes", 2);
__decorateClass$35([
  computed
], _SchoolMigration.prototype, "isScheduled", 1);
__decorateClass$35([
  computed
], _SchoolMigration.prototype, "isActive", 1);
__decorateClass$35([
  computed
], _SchoolMigration.prototype, "isCompleted", 1);
let SchoolMigration = _SchoolMigration;
var __defProp$32 = Object.defineProperty;
var __getOwnPropDesc$2Q = Object.getOwnPropertyDescriptor;
var __decorateClass$34 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2Q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$32(target, key, result);
  return result;
};
const _SchoolProfileSettings = class _SchoolProfileSettings2 extends Entity$1 {
  constructor(settings) {
    super(settings);
    if (settings) this.update(settings);
  }
  clone() {
    return new _SchoolProfileSettings2({
      ...this
    });
  }
  update(settings) {
    super.update(settings);
  }
  static fromJson(json) {
    return new _SchoolProfileSettings2({
      ...json
    });
  }
};
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "email", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "emailNeedConfirm", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "blockAccessIfEmailUnconfirmed", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "blockEmailChange", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "phone", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "phoneRequired", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "phoneNeedConfirm", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "blockAccessIfPhoneUnconfirmed", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "firstName", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "firstNameRequired", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "lastName", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "lastNameRequired", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "middleName", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "middleNameRequired", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "birthday", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "birthdayRequired", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "gender", 2);
__decorateClass$34([
  observable
], _SchoolProfileSettings.prototype, "genderRequired", 2);
__decorateClass$34([
  action
], _SchoolProfileSettings.prototype, "update", 1);
let SchoolProfileSettings = _SchoolProfileSettings;
var __defProp$31 = Object.defineProperty;
var __getOwnPropDesc$2P = Object.getOwnPropertyDescriptor;
var __decorateClass$33 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2P(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$31(target, key, result);
  return result;
};
const _CourseImage = class _CourseImage2 extends Entity$1 {
  constructor(courseImage) {
    super(courseImage);
    if (courseImage) this.update(courseImage);
  }
  static fromJson(json) {
    return new _CourseImage2({
      id: json.id,
      file: json.file ? AccelFile.fromJson(json.file) : void 0
    });
  }
  update(courseImage) {
    super.update(courseImage);
  }
};
__decorateClass$33([
  observable
], _CourseImage.prototype, "file", 2);
__decorateClass$33([
  action
], _CourseImage.prototype, "update", 1);
let CourseImage = _CourseImage;
var __defProp$30 = Object.defineProperty;
var __getOwnPropDesc$2O = Object.getOwnPropertyDescriptor;
var __decorateClass$32 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2O(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$30(target, key, result);
  return result;
};
const _Course = class _Course2 extends Entity$1 {
  constructor(course) {
    super(course);
    if (course) this.update(course);
  }
  get currentImage() {
    if (this.primaryImage) return this.primaryImage;
    if (!this.primaryImageId || this.images.length == 0)
      return void 0;
    return this.images.find((x) => x.id == this.primaryImageId);
  }
  static fromJson(json) {
    const course = new _Course2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      images: json.images ? json.images.map(CourseImage.fromJson) : void 0,
      primaryImage: json.primaryImage ? CourseImage.fromJson(json.primaryImage) : void 0,
      categories: json.categoriesLinks ? json.categoriesLinks.map((x) => Category$1.fromJson(x.category)) : void 0,
      coursesIds: json.courseRequirements ? json.courseRequirements.map((x) => _Course2.fromJson(x.requiredCourse)) : void 0,
      plans: json.plans ? json.plans.map((x) => new CoursePlan(x)) : void 0,
      scenario: json.scenarios && json.scenarios.length > 0 ? Scenario.fromJson(json.scenarios[0]) : void 0,
      cert: json.cert ? Cert.fromJson(json.cert) : void 0
    });
    if (course.scenario) course.scenario.update({ course });
    return course;
  }
  update(changes) {
    super.update(changes);
  }
};
__decorateClass$32([
  observable
], _Course.prototype, "name", 2);
__decorateClass$32([
  observable
], _Course.prototype, "shortDescription", 2);
__decorateClass$32([
  observable
], _Course.prototype, "categories", 2);
__decorateClass$32([
  observable
], _Course.prototype, "coursesIds", 2);
__decorateClass$32([
  observable
], _Course.prototype, "images", 2);
__decorateClass$32([
  observable
], _Course.prototype, "createdDate", 2);
__decorateClass$32([
  observable
], _Course.prototype, "updatedDate", 2);
__decorateClass$32([
  observable
], _Course.prototype, "isPublished", 2);
__decorateClass$32([
  observable
], _Course.prototype, "primaryImageId", 2);
__decorateClass$32([
  observable
], _Course.prototype, "showOnSite", 2);
__decorateClass$32([
  observable
], _Course.prototype, "showInSchool", 2);
__decorateClass$32([
  observable
], _Course.prototype, "showOnlyForWhoHaveAccess", 2);
__decorateClass$32([
  observable
], _Course.prototype, "freeAccess", 2);
__decorateClass$32([
  observable
], _Course.prototype, "dontAskFeedback", 2);
__decorateClass$32([
  observable
], _Course.prototype, "gamificationEnabled", 2);
__decorateClass$32([
  observable
], _Course.prototype, "isCompleteAnyCourseRequirement", 2);
__decorateClass$32([
  observable
], _Course.prototype, "primaryImage", 2);
__decorateClass$32([
  observable
], _Course.prototype, "studentCount", 2);
__decorateClass$32([
  observable
], _Course.prototype, "plans", 2);
__decorateClass$32([
  observable
], _Course.prototype, "scenario", 2);
__decorateClass$32([
  observable
], _Course.prototype, "cert", 2);
__decorateClass$32([
  computed
], _Course.prototype, "currentImage", 1);
__decorateClass$32([
  action
], _Course.prototype, "update", 1);
let Course = _Course;
var __defProp$2$ = Object.defineProperty;
var __getOwnPropDesc$2N = Object.getOwnPropertyDescriptor;
var __decorateClass$31 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2N(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2$(target, key, result);
  return result;
};
const _Category = class _Category2 extends Entity$1 {
  constructor(category) {
    super(category);
    if (category) this.update(category);
  }
  update(category) {
    super.update(category);
  }
  static fromJson(json) {
    return new _Category2({
      ...json
    });
  }
};
__decorateClass$31([
  observable
], _Category.prototype, "name", 2);
__decorateClass$31([
  observable
], _Category.prototype, "courseCount", 2);
__decorateClass$31([
  observable
], _Category.prototype, "librariesCount", 2);
__decorateClass$31([
  action
], _Category.prototype, "update", 1);
let Category$1 = _Category;
var __defProp$2_ = Object.defineProperty;
var __getOwnPropDesc$2M = Object.getOwnPropertyDescriptor;
var __decorateClass$30 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2M(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2_(target, key, result);
  return result;
};
const _CoursePlan = class _CoursePlan2 extends Entity$1 {
  constructor(plan) {
    super();
    if (plan) this.update(plan);
  }
  update(changes) {
    super.update(changes);
  }
  static fromJson(json) {
    return new _CoursePlan2({
      ...json,
      course: json.course ? Course.fromJson(json.course) : void 0
    });
  }
};
__decorateClass$30([
  observable
], _CoursePlan.prototype, "name", 2);
__decorateClass$30([
  observable
], _CoursePlan.prototype, "disableTimeLimits", 2);
__decorateClass$30([
  action
], _CoursePlan.prototype, "update", 1);
let CoursePlan = _CoursePlan;
var __defProp$2Z = Object.defineProperty;
var __getOwnPropDesc$2L = Object.getOwnPropertyDescriptor;
var __decorateClass$2$ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2L(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2Z(target, key, result);
  return result;
};
const _CourseItem = class _CourseItem2 extends Designable {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _CourseItem2({
      ...json,
      regularTimeDelay: json.regularTimeDelay ? json.regularTimeDelay : 1,
      regularTimeDelayCondition: json.regularTimeDelayCondition ? json.regularTimeDelayCondition : "previousStep",
      regularTimeDelayMeasureType: json.regularTimeDelayMeasureType ? json.regularTimeDelayMeasureType : "days",
      flowTimeDelay: json.flowTimeDelay ? json.flowTimeDelay : 1,
      flowTimeDelayCondition: json.flowTimeDelayCondition ? json.flowTimeDelayCondition : "previousStep",
      flowTimeDelayMeasureType: json.flowTimeDelayMeasureType ? json.flowTimeDelayMeasureType : "days",
      plans: json.plans ? json.plans.map((x) => new CoursePlan(x.coursePlan)) : void 0,
      parent: json.parentItem ? _CourseItem2.fromJson(json.parentItem) : void 0,
      children: json.children ? json.children.map(_CourseItem2.fromJson) : void 0,
      course: json.course ? Course.fromJson(json.course) : void 0,
      files: json.fileLinks ? json.fileLinks.map((x) => AccelFile.fromJson(x.file)) : [],
      dateDelay: json.dateDelay ? moment(json.dateDelay) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      regularWaitUntilTime: json.regularWaitUntilTime ? moment(json.regularWaitUntilTime) : void 0,
      flowWaitUntilTime: json.flowWaitUntilTime ? moment(json.flowWaitUntilTime) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2$([
  observable
], _CourseItem.prototype, "title", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "position", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "isDraft", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "isOptional", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "type", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "comment", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "allowComments", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "showComments", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "disableCommentModeration", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "ratingEnabled", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "ratingRequired", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "ratingCommentRequired", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "availableOnAllPlans", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "showRegardlessPlan", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "availability", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularTimeDelayActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularTimeDelay", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularTimeDelayCondition", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularTimeDelayMeasureType", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularWaitUntilTimeDaysOfWeekActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularWaitUntilDaysOfWeek", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularWaitUntilTimeActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "regularWaitUntilTime", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowTimeDelayActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowTimeDelay", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowTimeDelayCondition", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowTimeDelayMeasureType", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowWaitUntilTimeDaysOfWeekActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowWaitUntilDaysOfWeek", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowWaitUntilTimeActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "flowWaitUntilTime", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "dateDelayActive", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "dateDelay", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "preventCopingAndSelectingText", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "blockCourseUntilTasksApproved", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "theoryVisible", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "tasksVisible", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "testsVisible", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "score", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "plans", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "files", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "parent", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "parentItemId", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "children", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "course", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "createdDate", 2);
__decorateClass$2$([
  observable
], _CourseItem.prototype, "updatedDate", 2);
__decorateClass$2$([
  action
], _CourseItem.prototype, "update", 1);
let CourseItem = _CourseItem;
var __defProp$2Y = Object.defineProperty;
var __getOwnPropDesc$2K = Object.getOwnPropertyDescriptor;
var __decorateClass$2_ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2K(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2Y(target, key, result);
  return result;
};
const _CourseItemTask = class _CourseItemTask2 extends Entity$1 {
  constructor(task) {
    super(task);
    if (task) this.update(task);
  }
  get hasDescription() {
    return !isEmpty(this.description);
  }
  get hasQuestion() {
    return !isEmpty(this.question);
  }
  static fromJson(json) {
    return new _CourseItemTask2({
      ...json,
      files: json.files ? json.files.map(AccelFile.fromJson) : void 0,
      fields: json.fields ? json.fields.map(CourseItemTaskField.fromJson) : void 0
    });
  }
  update(task) {
    super.update(task);
  }
};
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "question", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "description", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "correctAnswer", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "position", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "files", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "disableVerification", 2);
__decorateClass$2_([
  observable
], _CourseItemTask.prototype, "fields", 2);
__decorateClass$2_([
  computed
], _CourseItemTask.prototype, "hasDescription", 1);
__decorateClass$2_([
  computed
], _CourseItemTask.prototype, "hasQuestion", 1);
__decorateClass$2_([
  action
], _CourseItemTask.prototype, "update", 1);
let CourseItemTask = _CourseItemTask;
var __defProp$2X = Object.defineProperty;
var __decorateClass$2Z = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2X(target, key, result);
  return result;
};
const _CourseItemTaskFieldListSettings = class _CourseItemTaskFieldListSettings2 extends Updatable {
  constructor(s) {
    super();
    s && this.update(s);
  }
  update(s, allowUndefined = false) {
    super.update(s, allowUndefined);
  }
  static fromJson(json) {
    return new _CourseItemTaskFieldListSettings2({
      options: [],
      ...json
    });
  }
};
__decorateClass$2Z([
  observable
], _CourseItemTaskFieldListSettings.prototype, "options");
let CourseItemTaskFieldListSettings = _CourseItemTaskFieldListSettings;
class CourseItemTaskFieldSettingsFactory {
  static build(type4, settingsJson) {
    const json = settingsJson ? JSON.parse(settingsJson) : null;
    switch (type4) {
      case CourseItemTaskFieldType.MonoSelect:
      case CourseItemTaskFieldType.MultiSelect:
        return CourseItemTaskFieldListSettings.fromJson(json);
      default:
        return json;
    }
  }
}
var __defProp$2W = Object.defineProperty;
var __getOwnPropDesc$2J = Object.getOwnPropertyDescriptor;
var __decorateClass$2Y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2J(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2W(target, key, result);
  return result;
};
var CourseItemTaskFieldType = /* @__PURE__ */ ((CourseItemTaskFieldType2) => {
  CourseItemTaskFieldType2["TextField"] = "textField";
  CourseItemTaskFieldType2["TextArea"] = "textArea";
  CourseItemTaskFieldType2["Checkbox"] = "checkbox";
  CourseItemTaskFieldType2["MultiSelect"] = "multiSelect";
  CourseItemTaskFieldType2["MonoSelect"] = "monoSelect";
  return CourseItemTaskFieldType2;
})(CourseItemTaskFieldType || {});
const _CourseItemTaskField = class _CourseItemTaskField2 extends Entity$1 {
  constructor(field) {
    super(field);
    if (field) this.update(field);
  }
  get listSettings() {
    return this.settings;
  }
  get isListType() {
    return this.type == "monoSelect" || this.type == "multiSelect";
  }
  toJson() {
    return {
      id: this.id,
      title: this.title,
      placeholder: this.placeholder,
      description: this.description,
      required: this.required,
      position: this.position,
      type: this.type,
      taskId: this.task?.id,
      additionalData: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  update(field, allowUndefined = false) {
    super.update(field, allowUndefined);
  }
  static fromJson(json) {
    return new _CourseItemTaskField2({
      id: json.id,
      title: json.title,
      placeholder: json.placeholder,
      description: json.description,
      required: json.required,
      position: json.position,
      type: json.type,
      task: json.task ? CourseItemTask.fromJson(json.task) : void 0,
      settings: CourseItemTaskFieldSettingsFactory.build(json.type, json.additionalData)
    });
  }
};
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "title", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "placeholder", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "description", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "required", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "position", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "type", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "task", 2);
__decorateClass$2Y([
  observable
], _CourseItemTaskField.prototype, "settings", 2);
__decorateClass$2Y([
  action
], _CourseItemTaskField.prototype, "update", 1);
let CourseItemTaskField = _CourseItemTaskField;
var __defProp$2V = Object.defineProperty;
var __getOwnPropDesc$2I = Object.getOwnPropertyDescriptor;
var __decorateClass$2X = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2I(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2V(target, key, result);
  return result;
};
const _CourseItemTaskAnswer = class _CourseItemTaskAnswer2 extends Entity$1 {
  constructor(answer) {
    super(answer);
    if (answer) this.update(answer);
  }
  static fromJson(json) {
    return new _CourseItemTaskAnswer2({
      ...json,
      text: !isEmpty(json.text) ? json.text : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      comments: json.comments ? json.comments.map(CourseItemTaskAnswerComment.fromJson) : void 0,
      files: json.files ? json.files.map(AccelFile.fromJson) : void 0,
      fields: json.studentAnswerFields ? json.studentAnswerFields.map(StudentCourseItemTaskAnswerField.fromJson) : void 0
    });
  }
  getFieldValue(fId) {
    const val = this.fields.find((x) => x.field.id == fId);
    return val ?? null;
  }
  setFieldValue(f) {
    const val = this.getFieldValue(f.field.id);
    if (val) {
      val.update(f, true);
    } else {
      this.fields.push(f);
    }
  }
  update(task) {
    super.update(task);
  }
};
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "createdDate", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "updatedDate", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "text", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "contact", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "status", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "comments", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "commentCount", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "files", 2);
__decorateClass$2X([
  observable
], _CourseItemTaskAnswer.prototype, "fields", 2);
__decorateClass$2X([
  action
], _CourseItemTaskAnswer.prototype, "setFieldValue", 1);
__decorateClass$2X([
  action
], _CourseItemTaskAnswer.prototype, "update", 1);
var __defProp$2U = Object.defineProperty;
var __getOwnPropDesc$2H = Object.getOwnPropertyDescriptor;
var __decorateClass$2W = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2U(target, key, result);
  return result;
};
const _StudentCourseItemTaskAnswerField = class _StudentCourseItemTaskAnswerField2 extends Entity$1 {
  constructor(answerField) {
    super(answerField);
    if (answerField) this.update(answerField);
  }
  get value() {
    if (this.booleanValue !== void 0) return this.booleanValue;
    if (this.stringValue !== void 0) return this.stringValue;
    if (this.listValue !== void 0) return this.listValue;
    if (this.multiListValue !== void 0) return this.multiListValue;
    return void 0;
  }
  update(answerField, allowUndefined = false) {
    super.update(answerField, allowUndefined);
  }
  isEquals(field) {
    if (this.field.id != field.field.id) return false;
    if (this.booleanValue !== void 0) return this.booleanValue === field.booleanValue;
    if (this.listValue !== void 0) return this.listValue === field.listValue;
    if (this.multiListValue !== void 0) return this.multiListValue === field.multiListValue;
    return this.stringValue === field.stringValue;
  }
  copy() {
    return new _StudentCourseItemTaskAnswerField2({
      id: this.id,
      field: this.field,
      stringValue: this.stringValue,
      booleanValue: this.booleanValue,
      listValue: this.listValue,
      listLabelValue: this.listLabelValue,
      multiListValue: this.multiListValue?.slice(),
      multiListLabelValue: this.multiListLabelValue?.slice()
    });
  }
  get valueJson() {
    return typeof this.value === "object" ? JSON.stringify(this.value) : this.value;
  }
  toJson() {
    return {
      id: this.field.id,
      value: this.valueJson
    };
  }
  static fromJson(json) {
    return new _StudentCourseItemTaskAnswerField2({
      id: json.id,
      stringValue: json.stringValue ?? void 0,
      booleanValue: json.booleanValue ?? void 0,
      listValue: json.listValue ?? void 0,
      listLabelValue: json.listLabelValue ?? void 0,
      multiListValue: json.multiListValue ? JSON.parse(json.multiListValue) : void 0,
      multiListLabelValue: json.multiListLabelValue ? JSON.parse(json.multiListLabelValue) : void 0,
      field: json.field ? CourseItemTaskField.fromJson(json.field) : void 0
    });
  }
};
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "stringValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "booleanValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "listValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "listLabelValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "multiListValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "multiListLabelValue", 2);
__decorateClass$2W([
  observable
], _StudentCourseItemTaskAnswerField.prototype, "field", 2);
__decorateClass$2W([
  action
], _StudentCourseItemTaskAnswerField.prototype, "update", 1);
let StudentCourseItemTaskAnswerField = _StudentCourseItemTaskAnswerField;
var __defProp$2T = Object.defineProperty;
var __getOwnPropDesc$2G = Object.getOwnPropertyDescriptor;
var __decorateClass$2V = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2T(target, key, result);
  return result;
};
const _CourseItemTaskAnswerComment = class _CourseItemTaskAnswerComment2 extends Entity$1 {
  constructor(comment2) {
    super(comment2);
    if (comment2) this.update(comment2);
  }
  get author() {
    return this.contact ?? this.admin;
  }
  static fromJson(json) {
    return new _CourseItemTaskAnswerComment2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      files: json.files ? json.files.map(AccelFile.fromJson) : []
    });
  }
  update(comment2) {
    super.update(comment2);
  }
};
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "id", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "createdDate", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "updatedDate", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "comment", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "admin", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "contact", 2);
__decorateClass$2V([
  observable
], _CourseItemTaskAnswerComment.prototype, "files", 2);
__decorateClass$2V([
  action
], _CourseItemTaskAnswerComment.prototype, "update", 1);
let CourseItemTaskAnswerComment = _CourseItemTaskAnswerComment;
var __defProp$2S = Object.defineProperty;
var __decorateClass$2U = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2S(target, key, result);
  return result;
};
class CourseItemTaskAnswerCommentFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
__decorateClass$2U([
  observable
], CourseItemTaskAnswerCommentFilter.prototype, "id");
__decorateClass$2U([
  observable
], CourseItemTaskAnswerCommentFilter.prototype, "answerId");
__decorateClass$2U([
  observable
], CourseItemTaskAnswerCommentFilter.prototype, "adminId");
__decorateClass$2U([
  observable
], CourseItemTaskAnswerCommentFilter.prototype, "studentId");
__decorateClass$2U([
  observable
], CourseItemTaskAnswerCommentFilter.prototype, "createdDateLessThan");
var __defProp$2R = Object.defineProperty;
var __getOwnPropDesc$2F = Object.getOwnPropertyDescriptor;
var __decorateClass$2T = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2R(target, key, result);
  return result;
};
const _SchoolContentItemComment = class _SchoolContentItemComment2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  get author() {
    return this.admin ?? this.contact;
  }
  get isEmpty() {
    return !this.text && this.files.length == 0;
  }
  get isRoot() {
    return this.parentId == null;
  }
  get hasMore() {
    return this.childrenCount > this.children.length;
  }
  static fromJson(json) {
    return new _SchoolContentItemComment2({
      ...json,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      children: json.children ? json.children.map(_SchoolContentItemComment2.fromJson) : void 0,
      rating: json.progress ? json.progress.rating : void 0,
      files: json.files ? json.files.map(AccelFile.fromJson) : [],
      reply: json.reply ? _SchoolContentItemComment2.fromJson(json.reply) : void 0,
      courseItem: json.courseItem ? CourseItem.fromJson(json.courseItem) : void 0,
      libraryItem: json.libraryItem ? LibraryItem.fromJson(json.libraryItem) : void 0
    });
  }
  update(comment2, allowUndefined = false) {
    super.update(comment2, allowUndefined);
  }
};
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "text", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "state", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "contact", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "admin", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "createdDate", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "updatedDate", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "parentId", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "replyId", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "children", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "childrenCount", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "rating", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "files", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "reply", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "courseItem", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "libraryItem", 2);
__decorateClass$2T([
  observable
], _SchoolContentItemComment.prototype, "sectionType", 2);
__decorateClass$2T([
  computed
], _SchoolContentItemComment.prototype, "author", 1);
__decorateClass$2T([
  computed
], _SchoolContentItemComment.prototype, "isEmpty", 1);
__decorateClass$2T([
  computed
], _SchoolContentItemComment.prototype, "isRoot", 1);
__decorateClass$2T([
  computed
], _SchoolContentItemComment.prototype, "hasMore", 1);
__decorateClass$2T([
  action
], _SchoolContentItemComment.prototype, "update", 1);
let SchoolContentItemComment = _SchoolContentItemComment;
var __defProp$2Q = Object.defineProperty;
var __getOwnPropDesc$2E = Object.getOwnPropertyDescriptor;
var __decorateClass$2S = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2Q(target, key, result);
  return result;
};
const _SchoolContentItemProgressRating = class _SchoolContentItemProgressRating2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  get hasMoreComments() {
    return this.commentsCount > this.comments.length;
  }
  get isCommentEmpty() {
    return isEmpty(this.comment) && this.files.length == 0;
  }
  update(comment2) {
    super.update(comment2);
  }
  clone() {
    return new _SchoolContentItemProgressRating2({
      ...this,
      files: this.files.slice()
    });
  }
  static fromJson(json) {
    return new _SchoolContentItemProgressRating2({
      ...json,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      comments: json.comments ? json.comments.map(SchoolContentItemComment.fromJson) : void 0,
      files: json.files ? json.files.map(AccelFile.fromJson) : [],
      courseItem: json.courseItem ? CourseItem.fromJson(json.courseItem) : void 0,
      libraryItem: json.libraryItem ? LibraryItem.fromJson(json.libraryItem) : void 0
    });
  }
};
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "comment", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "contact", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "createdDate", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "updatedDate", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "comments", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "commentsCount", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "rating", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "files", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "courseItem", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "libraryItem", 2);
__decorateClass$2S([
  observable
], _SchoolContentItemProgressRating.prototype, "sectionType", 2);
__decorateClass$2S([
  computed
], _SchoolContentItemProgressRating.prototype, "hasMoreComments", 1);
__decorateClass$2S([
  computed
], _SchoolContentItemProgressRating.prototype, "isCommentEmpty", 1);
__decorateClass$2S([
  action
], _SchoolContentItemProgressRating.prototype, "update", 1);
var __defProp$2P = Object.defineProperty;
var __getOwnPropDesc$2D = Object.getOwnPropertyDescriptor;
var __decorateClass$2R = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$2D(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2P(target, key, result);
  return result;
};
const _Package = class _Package2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _Package2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2R([
  action
], _Package.prototype, "update");
let Package = _Package;
var __defProp$2O = Object.defineProperty;
var __getOwnPropDesc$2C = Object.getOwnPropertyDescriptor;
var __decorateClass$2Q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2O(target, key, result);
  return result;
};
const _PackageCourse = class _PackageCourse2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _PackageCourse2({
      ...json,
      course: json.course ? Course.fromJson(json.course) : void 0,
      plan: json.plan ? CoursePlan.fromJson(json.plan) : void 0,
      package: json.package ? Package.fromJson(json.package) : void 0
    });
  }
  update(course) {
    super.update(course);
  }
};
__decorateClass$2Q([
  observable
], _PackageCourse.prototype, "plan", 2);
__decorateClass$2Q([
  observable
], _PackageCourse.prototype, "course", 2);
__decorateClass$2Q([
  observable
], _PackageCourse.prototype, "package", 2);
__decorateClass$2Q([
  action
], _PackageCourse.prototype, "update", 1);
var __defProp$2N = Object.defineProperty;
var __getOwnPropDesc$2B = Object.getOwnPropertyDescriptor;
var __decorateClass$2P = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2N(target, key, result);
  return result;
};
const _PackageLibrary = class _PackageLibrary2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _PackageLibrary2({
      ...json,
      library: json.library ? Library.fromJson(json.library) : void 0,
      libraryItems: json.items ? json.items.map((x) => LibraryItem.fromJson(x)) : [],
      package: json.package ? Package.fromJson(json.package) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2P([
  observable
], _PackageLibrary.prototype, "library", 2);
__decorateClass$2P([
  observable
], _PackageLibrary.prototype, "libraryItems", 2);
__decorateClass$2P([
  observable
], _PackageLibrary.prototype, "package", 2);
__decorateClass$2P([
  action
], _PackageLibrary.prototype, "update", 1);
var __defProp$2M = Object.defineProperty;
var __getOwnPropDesc$2A = Object.getOwnPropertyDescriptor;
var __decorateClass$2O = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2M(target, key, result);
  return result;
};
const _Library = class _Library2 extends Entity$1 {
  constructor(lib2) {
    super(lib2);
    if (lib2) this.update(lib2);
  }
  clone() {
    return new _Library2({
      ...this,
      primaryImage: this.primaryImage ? this.primaryImage.clone() : null,
      images: this.images.slice()
    });
  }
  static fromJson(json) {
    return new _Library2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      primaryImage: json.primaryImage ? AccelFile.fromJson(json.primaryImage.file) : null,
      images: json.images ? json.images.map((x) => AccelFile.fromJson(x.file)) : [],
      categories: json.categoriesLinks ? json.categoriesLinks.map((x) => Category$1.fromJson(x.category)) : []
    });
  }
  update(course) {
    super.update(course);
  }
};
__decorateClass$2O([
  observable
], _Library.prototype, "name", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "shortDescription", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "createdDate", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "updatedDate", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "isPublished", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "freeAccess", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "itemCount", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "gamificationEnabled", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "categories", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "primaryImage", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "images", 2);
__decorateClass$2O([
  observable
], _Library.prototype, "studentCount", 2);
__decorateClass$2O([
  action
], _Library.prototype, "update", 1);
let Library = _Library;
var __defProp$2L = Object.defineProperty;
var __getOwnPropDesc$2z = Object.getOwnPropertyDescriptor;
var __decorateClass$2N = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2L(target, key, result);
  return result;
};
const _LibraryItem = class _LibraryItem2 extends Designable {
  constructor(lib2) {
    super(lib2);
    if (lib2) this.update(lib2);
  }
  clone() {
    return new _LibraryItem2({
      ...this,
      parent: this.parent ? this.parent.clone() : void 0,
      library: this.library ? this.library.clone() : void 0
    });
  }
  static fromJson(json) {
    return new _LibraryItem2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      library: json.library ? Library.fromJson(json.library) : void 0,
      parent: json.parentItem ? _LibraryItem2.fromJson(json.parentItem) : void 0
    });
  }
  update(course) {
    super.update(course);
  }
};
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "title", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "comment", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "position", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "avgRating", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "type", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "parent", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "parentItemId", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "isDraft", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "allowComments", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "showComments", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "ratingEnabled", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "disableCommentModeration", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "ratingCommentRequired", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "preventCopingAndSelectingText", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "createdDate", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "updatedDate", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "flowTimeDelayActive", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "flowTimeDelay", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "flowTimeDelayCondition", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "flowTimeDelayMeasureType", 2);
__decorateClass$2N([
  observable
], _LibraryItem.prototype, "library", 2);
__decorateClass$2N([
  action
], _LibraryItem.prototype, "update", 1);
let LibraryItem = _LibraryItem;
var __defProp$2K = Object.defineProperty;
var __getOwnPropDesc$2y = Object.getOwnPropertyDescriptor;
var __decorateClass$2M = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$2y(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2K(target, key, result);
  return result;
};
class HistoryEventPayloadFactory {
  static parse(type4, json) {
    const payload = json ? JSON.parse(json) : void 0;
    switch (type4) {
      case "studentMergedSource":
      case "studentMergedTarget":
        return {
          contacts: payload?.contacts ? payload.contacts.map((x) => new Contact({ ...x })) : [],
          results: payload?.results
        };
      default:
        return payload;
    }
  }
}
const _HistoryEvent = class _HistoryEvent2 extends Entity$1 {
  constructor(e) {
    super(e);
    if (e) this.update(e);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  static fromJson(json) {
    return new _HistoryEvent2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      additionalData: HistoryEventPayloadFactory.parse(json.type, json.additionalData)
    });
  }
};
__decorateClass$2M([
  action
], _HistoryEvent.prototype, "update");
var __defProp$2J = Object.defineProperty;
var __getOwnPropDesc$2x = Object.getOwnPropertyDescriptor;
var __decorateClass$2L = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2J(target, key, result);
  return result;
};
const _LocalizationLanguage = class _LocalizationLanguage2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _LocalizationLanguage2({
      ...json
    });
  }
  update(language) {
    super.update(language);
  }
};
__decorateClass$2L([
  observable
], _LocalizationLanguage.prototype, "name", 2);
__decorateClass$2L([
  observable
], _LocalizationLanguage.prototype, "prefix", 2);
__decorateClass$2L([
  action
], _LocalizationLanguage.prototype, "update", 1);
let LocalizationLanguage = _LocalizationLanguage;
var __defProp$2I = Object.defineProperty;
var __getOwnPropDesc$2w = Object.getOwnPropertyDescriptor;
var __decorateClass$2K = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2I(target, key, result);
  return result;
};
const _LocalizationTranslation = class _LocalizationTranslation2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _LocalizationTranslation2({
      ...json,
      language: json.language ? LocalizationLanguage.fromJson(json.language) : void 0,
      word: json.word ? LocalizationWord.fromJson(json.word) : void 0
    });
  }
  update(translation, allowUndefined = false) {
    super.update(translation, allowUndefined);
  }
};
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "id", 2);
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "text", 2);
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "suggestedText", 2);
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "language", 2);
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "word", 2);
__decorateClass$2K([
  observable
], _LocalizationTranslation.prototype, "isVerified", 2);
__decorateClass$2K([
  action
], _LocalizationTranslation.prototype, "update", 1);
let LocalizationTranslation = _LocalizationTranslation;
var __defProp$2H = Object.defineProperty;
var __getOwnPropDesc$2v = Object.getOwnPropertyDescriptor;
var __decorateClass$2J = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2H(target, key, result);
  return result;
};
const _LocalizationWord = class _LocalizationWord2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _LocalizationWord2({
      ...json,
      translations: json.translations ? json.translations.map((i) => LocalizationTranslation.fromJson(i)) : []
    });
  }
  update(word) {
    super.update(word);
  }
  get englishTranslation() {
    if (this.translations == null || this.translations.length == 0)
      return null;
    return this.translations.find((i) => i.language.prefix = Lang.en);
  }
};
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "id", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "text", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "comment", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "useInSchool", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "useInManager", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "useInSite", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "useInAdmin", 2);
__decorateClass$2J([
  observable
], _LocalizationWord.prototype, "translations", 2);
__decorateClass$2J([
  action
], _LocalizationWord.prototype, "update", 1);
__decorateClass$2J([
  computed
], _LocalizationWord.prototype, "englishTranslation", 1);
let LocalizationWord = _LocalizationWord;
var __defProp$2G = Object.defineProperty;
var __getOwnPropDesc$2u = Object.getOwnPropertyDescriptor;
var __decorateClass$2I = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2G(target, key, result);
  return result;
};
const _LocalizationRequestTranslate = class _LocalizationRequestTranslate2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _LocalizationRequestTranslate2({
      ...json
    });
  }
  update(word) {
    super.update(word);
  }
};
__decorateClass$2I([
  observable
], _LocalizationRequestTranslate.prototype, "languageId", 2);
__decorateClass$2I([
  observable
], _LocalizationRequestTranslate.prototype, "text", 2);
__decorateClass$2I([
  action
], _LocalizationRequestTranslate.prototype, "update", 1);
var __defProp$2F = Object.defineProperty;
var __getOwnPropDesc$2t = Object.getOwnPropertyDescriptor;
var __decorateClass$2H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2F(target, key, result);
  return result;
};
const _Flow = class _Flow2 extends Entity$1 {
  constructor(flow) {
    super(flow);
    if (flow) this.update(flow);
  }
  static fromJson(json) {
    const flow = new _Flow2({
      ...json,
      flowDates: json.flowDates ? json.flowDates.map(FlowDate.fromJson) : void 0,
      scenario: json.scenarios && json.scenarios.length > 0 ? Scenario.fromJson(json.scenarios[0]) : void 0
    });
    if (flow.scenario) flow.scenario.update({ flow });
    return flow;
  }
  update(flow) {
    super.update(flow);
  }
};
__decorateClass$2H([
  observable
], _Flow.prototype, "title", 2);
__decorateClass$2H([
  observable
], _Flow.prototype, "denyAccessContentAfterEnd", 2);
__decorateClass$2H([
  observable
], _Flow.prototype, "denyAccessContentBeforeStart", 2);
__decorateClass$2H([
  observable
], _Flow.prototype, "flowDates", 2);
__decorateClass$2H([
  observable
], _Flow.prototype, "scenario", 2);
__decorateClass$2H([
  action
], _Flow.prototype, "update", 1);
let Flow = _Flow;
var __defProp$2E = Object.defineProperty;
var __getOwnPropDesc$2s = Object.getOwnPropertyDescriptor;
var __decorateClass$2G = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2E(target, key, result);
  return result;
};
const _FlowDate = class _FlowDate2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  get duration() {
    if (this.beginDate != null && this.endDate != null) {
      const days = Math.round((this.endDate.toDate().getTime() - this.beginDate.toDate().getTime()) / (1e3 * 3600 * 24));
      return days < 0 ? 0 : days;
    }
    return 0;
  }
  static fromJson(json) {
    return new _FlowDate2({
      ...json,
      beginDate: json.beginDate ? moment(json.beginDate) : void 0,
      endDate: json.endDate ? moment(json.endDate) : void 0,
      flow: json.flow ? Flow.fromJson(json.flow) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2G([
  observable
], _FlowDate.prototype, "name", 2);
__decorateClass$2G([
  observable
], _FlowDate.prototype, "beginDate", 2);
__decorateClass$2G([
  observable
], _FlowDate.prototype, "endDate", 2);
__decorateClass$2G([
  observable
], _FlowDate.prototype, "flow", 2);
__decorateClass$2G([
  action
], _FlowDate.prototype, "update", 1);
let FlowDate = _FlowDate;
var __defProp$2D = Object.defineProperty;
var __getOwnPropDesc$2r = Object.getOwnPropertyDescriptor;
var __decorateClass$2F = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2D(target, key, result);
  return result;
};
const _FlowCourse = class _FlowCourse2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _FlowCourse2({
      ...json,
      course: json.course ? Course.fromJson(json.course) : void 0,
      plan: json.plan ? CoursePlan.fromJson(json.plan) : void 0,
      flow: json.flow ? Flow.fromJson(json.flow) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2F([
  observable
], _FlowCourse.prototype, "plan", 2);
__decorateClass$2F([
  observable
], _FlowCourse.prototype, "course", 2);
__decorateClass$2F([
  observable
], _FlowCourse.prototype, "flow", 2);
__decorateClass$2F([
  action
], _FlowCourse.prototype, "update", 1);
var __defProp$2C = Object.defineProperty;
var __getOwnPropDesc$2q = Object.getOwnPropertyDescriptor;
var __decorateClass$2E = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2C(target, key, result);
  return result;
};
const _FlowForum = class _FlowForum2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _FlowForum2({
      ...json,
      forum: json.forumThread ? ForumThread.fromJson(json.forumThread) : void 0,
      flow: json.flow ? Flow.fromJson(json.flow) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2E([
  observable
], _FlowForum.prototype, "forumThread", 2);
__decorateClass$2E([
  observable
], _FlowForum.prototype, "flow", 2);
__decorateClass$2E([
  action
], _FlowForum.prototype, "update", 1);
var __defProp$2B = Object.defineProperty;
var __getOwnPropDesc$2p = Object.getOwnPropertyDescriptor;
var __decorateClass$2D = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2B(target, key, result);
  return result;
};
const _FlowLibrary = class _FlowLibrary2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _FlowLibrary2({
      ...json,
      library: json.library ? Library.fromJson(json.library) : void 0,
      libraryItems: json.items ? json.items.map((x) => LibraryItem.fromJson(x)) : [],
      flow: json.flow ? Flow.fromJson(json.flow) : void 0
    });
  }
  update(item2) {
    super.update(item2);
  }
};
__decorateClass$2D([
  observable
], _FlowLibrary.prototype, "flow", 2);
__decorateClass$2D([
  observable
], _FlowLibrary.prototype, "library", 2);
__decorateClass$2D([
  observable
], _FlowLibrary.prototype, "libraryItems", 2);
__decorateClass$2D([
  action
], _FlowLibrary.prototype, "update", 1);
var __defProp$2A = Object.defineProperty;
var __getOwnPropDesc$2o = Object.getOwnPropertyDescriptor;
var __decorateClass$2C = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2A(target, key, result);
  return result;
};
const _ForumThread = class _ForumThread2 extends Designable {
  constructor(branch) {
    super(branch);
    if (branch) this.update(branch);
  }
  update(branch) {
    super.update(branch);
  }
  static fromJson(json) {
    return new _ForumThread2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      lastActivityDate: json.lastActivityDate ? new Date(json.lastActivityDate) : void 0,
      parentThread: json.parentThread ? _ForumThread2.fromJson(json.parentThread) : null,
      moderators: json.moderators ? json.moderators.map((i) => Contact.fromJson(i.student)) : []
    });
  }
};
__decorateClass$2C([
  observable
], _ForumThread.prototype, "title", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "description", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "canStudentCreateTopics", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "isPublished", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "isLimitedAccess", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "createdDate", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "updatedDate", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "lastActivityDate", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "parentThread", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "moderators", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "topicCount", 2);
__decorateClass$2C([
  observable
], _ForumThread.prototype, "commentCount", 2);
__decorateClass$2C([
  action
], _ForumThread.prototype, "update", 1);
let ForumThread = _ForumThread;
var __defProp$2z = Object.defineProperty;
var __getOwnPropDesc$2n = Object.getOwnPropertyDescriptor;
var __decorateClass$2B = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2z(target, key, result);
  return result;
};
const _ForumTopic = class _ForumTopic2 extends Entity$1 {
  constructor(topic) {
    super(topic);
    if (topic) this.update(topic);
  }
  static fromJson(json) {
    return new _ForumTopic2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      lastActivityDate: json.lastActivityDate ? new Date(json.lastActivityDate) : void 0,
      lastComment: json.lastComment ? TopicComment.fromJson(json.lastComment) : null,
      contact: json.student ? Contact.fromJson(json.student) : null,
      files: json.files ? json.files.map(AccelFile.fromJson) : [],
      currentUserReaction: json.currentUserReaction ? ForumReaction.fromJson(json.currentUserReaction) : null
    });
  }
  update(branch) {
    super.update(branch);
  }
};
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "title", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "text", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "createdDate", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "updatedDate", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "lastActivityDate", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "lastComment", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "commentCount", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "contact", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "files", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "likeCount", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "dislikeCount", 2);
__decorateClass$2B([
  observable
], _ForumTopic.prototype, "currentUserReaction", 2);
__decorateClass$2B([
  action
], _ForumTopic.prototype, "update", 1);
var __defProp$2y = Object.defineProperty;
var __getOwnPropDesc$2m = Object.getOwnPropertyDescriptor;
var __decorateClass$2A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2y(target, key, result);
  return result;
};
const _TopicComment = class _TopicComment2 extends Entity$1 {
  constructor(comment2) {
    super(comment2);
    this.likeCount = 0;
    this.dislikeCount = 0;
    if (comment2) this.update(comment2);
  }
  static fromJson(json) {
    return new _TopicComment2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      reply: json.replyToComment ? _TopicComment2.fromJson(json.replyToComment) : null,
      files: json.files ? json.files.map(AccelFile.fromJson) : [],
      contact: json.student ? Contact.fromJson(json.student) : null,
      currentUserReaction: json.currentUserReaction ? ForumReaction.fromJson(json.currentUserReaction) : null
    });
  }
  update(comment2) {
    super.update(comment2);
  }
};
__decorateClass$2A([
  observable
], _TopicComment.prototype, "text", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "createdDate", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "updatedDate", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "reply", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "contact", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "files", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "sequenceNumber", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "likeCount", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "dislikeCount", 2);
__decorateClass$2A([
  observable
], _TopicComment.prototype, "currentUserReaction", 2);
__decorateClass$2A([
  action
], _TopicComment.prototype, "update", 1);
let TopicComment = _TopicComment;
var __defProp$2x = Object.defineProperty;
var __getOwnPropDesc$2l = Object.getOwnPropertyDescriptor;
var __decorateClass$2z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2x(target, key, result);
  return result;
};
const _ForumBan = class _ForumBan2 extends Entity$1 {
  constructor(ban) {
    super(ban);
    if (ban) this.update(ban);
  }
  static fromJson(json) {
    return new _ForumBan2({
      ...json,
      beginDate: json.beginDate ? new Date(json.beginDate) : void 0,
      endDate: json.endDate ? new Date(json.endDate) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : null
    });
  }
  update(branch) {
    super.update(branch);
  }
};
__decorateClass$2z([
  observable
], _ForumBan.prototype, "reason", 2);
__decorateClass$2z([
  observable
], _ForumBan.prototype, "beginDate", 2);
__decorateClass$2z([
  observable
], _ForumBan.prototype, "endDate", 2);
__decorateClass$2z([
  observable
], _ForumBan.prototype, "contact", 2);
__decorateClass$2z([
  action
], _ForumBan.prototype, "update", 1);
var __defProp$2w = Object.defineProperty;
var __getOwnPropDesc$2k = Object.getOwnPropertyDescriptor;
var __decorateClass$2y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2w(target, key, result);
  return result;
};
const _ForumReaction = class _ForumReaction2 extends Entity$1 {
  constructor(reaction2) {
    super(reaction2);
    if (reaction2) this.update(reaction2);
  }
  static fromJson(json) {
    return new _ForumReaction2({
      ...json
    });
  }
  update(comment2) {
    super.update(comment2);
  }
};
__decorateClass$2y([
  observable
], _ForumReaction.prototype, "type", 2);
__decorateClass$2y([
  action
], _ForumReaction.prototype, "update", 1);
let ForumReaction = _ForumReaction;
var __defProp$2v = Object.defineProperty;
var __getOwnPropDesc$2j = Object.getOwnPropertyDescriptor;
var __decorateClass$2x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2v(target, key, result);
  return result;
};
const _SiteDomain = class _SiteDomain2 extends Entity$1 {
  constructor(siteDomain) {
    super(siteDomain);
    if (siteDomain) this.update(siteDomain);
  }
  get url() {
    return `https://${this.name}`;
  }
  clone() {
    return new _SiteDomain2({
      ...this,
      site: this.site?.clone()
    });
  }
  static fromJson(json) {
    return new _SiteDomain2({
      ...json,
      site: json.site ? Site.fromJson(json.site) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      isSystem: false
    });
  }
  update(siteDomain) {
    super.update(siteDomain);
  }
};
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "name", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "redirectTo", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "movedPermanently", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "isMain", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "isSslCertIssued", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "isConfirmed", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "createdDate", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "updatedDate", 2);
__decorateClass$2x([
  observable
], _SiteDomain.prototype, "site", 2);
__decorateClass$2x([
  computed
], _SiteDomain.prototype, "url", 1);
__decorateClass$2x([
  action
], _SiteDomain.prototype, "update", 1);
let SiteDomain = _SiteDomain;
var __defProp$2u = Object.defineProperty;
var __getOwnPropDesc$2i = Object.getOwnPropertyDescriptor;
var __decorateClass$2w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2u(target, key, result);
  return result;
};
const _SiteCounters = class _SiteCounters2 extends Updatable {
  constructor(siteCounters) {
    super();
    if (siteCounters) this.update(siteCounters);
  }
  static fromJson(json) {
    return new _SiteCounters2({
      today: json?.today ? json.today : 0,
      sevenDays: json?.sevenDays ? json.sevenDays : 0,
      thirtyDays: json?.thirtyDays ? json.thirtyDays : 0
    });
  }
  update(siteCounters) {
    super.update(siteCounters);
  }
};
__decorateClass$2w([
  observable
], _SiteCounters.prototype, "today", 2);
__decorateClass$2w([
  observable
], _SiteCounters.prototype, "sevenDays", 2);
__decorateClass$2w([
  observable
], _SiteCounters.prototype, "thirtyDays", 2);
__decorateClass$2w([
  action
], _SiteCounters.prototype, "update", 1);
let SiteCounters = _SiteCounters;
var __defProp$2t = Object.defineProperty;
var __getOwnPropDesc$2h = Object.getOwnPropertyDescriptor;
var __decorateClass$2v = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2t(target, key, result);
  return result;
};
const _SiteFileConfirmation = class _SiteFileConfirmation2 extends Entity$1 {
  constructor(confirm) {
    super(confirm);
    this._key = KeyGenerator.generate(5);
    if (confirm) this.update(confirm);
  }
  hasChanges(b) {
    return this.name != b.name || this.path != b.path || this.type != b.type || this.content != b.content || this.file?.id != b.file?.id;
  }
  clone() {
    return new _SiteFileConfirmation2({
      ...this
    });
  }
  toJson() {
    return toJS({
      id: this.id,
      name: this.name,
      path: this.path,
      type: this.type,
      content: this.content,
      fileId: this.file?.id
    });
  }
  update(confirm, allowUndefined) {
    super.update(confirm, allowUndefined);
  }
  static default() {
    return new _SiteFileConfirmation2({
      type: "file"
    });
  }
  static fromJson(json) {
    return new _SiteFileConfirmation2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      file: json.file ? AccelFile.fromJson(json.file) : null
    });
  }
};
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "name", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "path", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "type", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "content", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "file", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "createdDate", 2);
__decorateClass$2v([
  observable
], _SiteFileConfirmation.prototype, "updatedDate", 2);
__decorateClass$2v([
  action
], _SiteFileConfirmation.prototype, "update", 1);
let SiteFileConfirmation = _SiteFileConfirmation;
var __defProp$2s = Object.defineProperty;
var __getOwnPropDesc$2g = Object.getOwnPropertyDescriptor;
var __decorateClass$2u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2s(target, key, result);
  return result;
};
const _Site = class _Site2 extends Entity$1 {
  constructor(site) {
    super(site);
    if (site) this.update(site);
  }
  getSiteDomain(defaultSiteDomain, protocol2) {
    if (!protocol2)
      protocol2 = isDev ? "http" : "https";
    if (this.siteDomain != null)
      return `${protocol2}://${this.siteDomain.name}`;
    return this.getSiteTechDomain(defaultSiteDomain, protocol2);
  }
  getSiteTechDomain(defaultSiteDomain, protocol2) {
    if (!protocol2)
      protocol2 = isDev ? "http" : "https";
    return `${protocol2}://${this.subdomain}${defaultSiteDomain}`;
  }
  update(site, allowUndefined = false) {
    super.update(site, allowUndefined);
  }
  clone(changes) {
    return new _Site2({
      ...this,
      confirmations: this.confirmations.map((x) => x.clone()),
      ...changes
    });
  }
  hasChanges(site) {
    return this.name != site.name || this.shortDescription != site.shortDescription || this.subdomain != site.subdomain || this.siteDomain?.id != site.siteDomain?.id || this.favicon?.id != site.favicon?.id || this.logo?.id != site.logo?.id || this.formTerms != site.formTerms || this.formTermsEnabled != site.formTermsEnabled || this.formTermsDefaultAccepted != site.formTermsDefaultAccepted || this.checkoutFormTerms != site.checkoutFormTerms || this.checkoutFormTermsEnabled != site.checkoutFormTermsEnabled || this.checkoutFormTermsDefaultAccepted != site.checkoutFormTermsDefaultAccepted || !isArraysEqual(this.confirmations, site.confirmations, (a, b) => !a.hasChanges(b)) || this.bodyIntegrationCode != site.bodyIntegrationCode || this.enabled != site.enabled || this.headerIntegrationCode != site.headerIntegrationCode || this.robotsTxt != site.robotsTxt || this.page404?.id != site.page404?.id;
  }
  toJson() {
    throw new Error("not implemented");
  }
  static fromJson(json) {
    return new _Site2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      favicon: json.favicon ? AccelFile.fromJson(json.favicon) : null,
      logo: json.logo ? AccelFile.fromJson(json.logo) : null,
      siteDomain: json.siteDomain ? SiteDomain.fromJson(json.siteDomain) : null,
      counters: json.counters !== void 0 ? SiteCounters.fromJson(json.counters) : void 0,
      confirmations: json.confirmations ? json.confirmations.map(SiteFileConfirmation.fromJson) : [],
      page404: json.page404 ? SitePage.fromJson(json.page404) : null
    });
  }
};
__decorateClass$2u([
  observable
], _Site.prototype, "name", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "shortDescription", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "subdomain", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "enabled", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "headerIntegrationCode", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "bodyIntegrationCode", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "createdDate", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "updatedDate", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "favicon", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "logo", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "siteDomain", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "counters", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "formTerms", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "formTermsEnabled", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "formTermsDefaultAccepted", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "checkoutFormTerms", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "checkoutFormTermsEnabled", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "checkoutFormTermsDefaultAccepted", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "confirmations", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "robotsTxt", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "page404", 2);
__decorateClass$2u([
  observable
], _Site.prototype, "pagesCount", 2);
__decorateClass$2u([
  action
], _Site.prototype, "update", 1);
let Site = _Site;
var __defProp$2r = Object.defineProperty;
var __getOwnPropDesc$2f = Object.getOwnPropertyDescriptor;
var __decorateClass$2t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2r(target, key, result);
  return result;
};
const _SitePage = class _SitePage2 extends Designable {
  constructor(sitePage) {
    super(sitePage);
    if (sitePage) this.update(sitePage);
  }
  get hasInternalName() {
    return !isEmpty(this.internalName);
  }
  static fromJson(json) {
    const item2 = new _SitePage2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      parent: json.parent ? _SitePage2.fromJson(json.parent) : void 0,
      site: json.site ? Site.fromJson(json.site) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : null,
      header: json.header ? SiteComponent.fromJson(json.header) : null,
      footer: json.footer ? SiteComponent.fromJson(json.footer) : null,
      lang: !isEmpty(json.customLang) ? "custom" : json.lang ?? null,
      customLang: json.customLang ?? null,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0
    });
    if (item2.scenario) item2.scenario.update({ sitePage: item2 });
    return item2;
  }
  update(changes, allowUndefined = false) {
    super.update(changes, allowUndefined);
  }
  clone(changes) {
    return new _SitePage2({
      ...this,
      ...changes
    });
  }
  hasChanges(page) {
    return this.name != page.name || this.internalName != page.internalName || this.shortDescription != page.shortDescription || this.segment != page.segment || this.redirect != page.redirect || this.redirectUrl != page.redirectUrl || this.hideFromSearchBots != page.hideFromSearchBots || this.header?.id != page.header?.id || this.footer?.id != page.footer?.id || this.layoutType != page.layoutType || this.site?.id != page.site?.id || this.image?.id != page.image?.id || this.lang != page.lang || this.customLang != page.customLang;
  }
};
__decorateClass$2t([
  observable
], _SitePage.prototype, "siteId", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "name", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "internalName", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "segment", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "url", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "shortDescription", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "isPublished", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "redirect", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "parentId", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "position", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "redirectUrl", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "image", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "lang", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "customLang", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "hideFromSearchBots", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "headHtml", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "bodyHtml", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "headerIntegrationCode", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "bodyIntegrationCode", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "layoutType", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "createdDate", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "updatedDate", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "parent", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "site", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "header", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "footer", 2);
__decorateClass$2t([
  observable
], _SitePage.prototype, "scenario", 2);
__decorateClass$2t([
  computed
], _SitePage.prototype, "hasInternalName", 1);
__decorateClass$2t([
  action
], _SitePage.prototype, "update", 1);
let SitePage = _SitePage;
var __defProp$2q = Object.defineProperty;
var __getOwnPropDesc$2e = Object.getOwnPropertyDescriptor;
var __decorateClass$2s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2q(target, key, result);
  return result;
};
const _SiteComponent = class _SiteComponent2 extends Designable {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    const item2 = new _SiteComponent2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      site: json.site ? Site.fromJson(json.site) : void 0,
      headerPages: json.headerPages ? json.headerPages.map(SitePage.fromJson) : [],
      footerPages: json.footerPages ? json.footerPages.map(SitePage.fromJson) : []
    });
    return item2;
  }
  update(changes) {
    super.update(changes);
  }
  get pages() {
    switch (this.type) {
      case SiteComponentType.Header:
        return this.headerPages ?? [];
      case SiteComponentType.Footer:
        return this.footerPages ?? [];
      default:
        return [];
    }
  }
  get pageIds() {
    return this.pages.map((i) => i.id);
  }
  updatePages(pages) {
    switch (this.type) {
      case SiteComponentType.Header:
        this.headerPages = [...pages];
        break;
      case SiteComponentType.Footer:
        this.footerPages = [...pages];
        break;
    }
  }
};
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "name", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "type", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "createdDate", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "updatedDate", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "headerPages", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "footerPages", 2);
__decorateClass$2s([
  observable
], _SiteComponent.prototype, "site", 2);
__decorateClass$2s([
  action
], _SiteComponent.prototype, "update", 1);
__decorateClass$2s([
  computed
], _SiteComponent.prototype, "pages", 1);
__decorateClass$2s([
  computed
], _SiteComponent.prototype, "pageIds", 1);
__decorateClass$2s([
  action
], _SiteComponent.prototype, "updatePages", 1);
let SiteComponent = _SiteComponent;
var SiteComponentType = /* @__PURE__ */ ((SiteComponentType2) => {
  SiteComponentType2["Header"] = "header";
  SiteComponentType2["Footer"] = "footer";
  return SiteComponentType2;
})(SiteComponentType || {});
var __defProp$2p = Object.defineProperty;
var __getOwnPropDesc$2d = Object.getOwnPropertyDescriptor;
var __decorateClass$2r = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$2d(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2p(target, key, result);
  return result;
};
const _SiteView = class _SiteView2 extends Entity$1 {
  constructor(siteView) {
    super(siteView);
    if (siteView) this.update(siteView);
  }
  static fromJson(json) {
    return new _SiteView2({
      ...json,
      date: json.date ? new Date(json.date) : void 0
    });
  }
  update(siteView) {
    super.update(siteView);
  }
};
__decorateClass$2r([
  action
], _SiteView.prototype, "update");
var __defProp$2o = Object.defineProperty;
var __getOwnPropDesc$2c = Object.getOwnPropertyDescriptor;
var __decorateClass$2q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2o(target, key, result);
  return result;
};
const _Gamification = class _Gamification2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  toJson() {
    return {
      ...this,
      pointsCustomIconId: this.pointsCustomIcon === null ? null : this.pointsCustomIcon?.id,
      // skip some fields just in case,
      pointsCustomIcon: void 0,
      scenario: void 0
    };
  }
  clone() {
    return new _Gamification2({
      ...this,
      pointsCustomIcon: this.pointsCustomIcon?.clone()
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  hasChanges(settings) {
    return this.achievementStyle !== settings.achievementStyle || this.pointsName !== settings.pointsName || this.pointsShortName !== settings.pointsShortName || this.pointsExpireDuration !== settings.pointsExpireDuration || this.pointsExpireDurationType !== settings.pointsExpireDurationType || this.pointsIconType !== settings.pointsIconType || this.pointsIconCloudKey !== settings.pointsIconCloudKey || this.pointsCustomIcon?.id !== settings.pointsCustomIcon?.id || this.leaderboardEnabled !== settings.leaderboardEnabled || this.leaderboardTakeCount !== settings.leaderboardTakeCount || this.leaderboardDuration !== settings.leaderboardDuration || this.leaderboardDurationType !== settings.leaderboardDurationType;
  }
  static fromJson(json) {
    const gamification = new _Gamification2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      pointsCustomIcon: json.pointsCustomIcon ? AccelFile.fromJson(json.pointsCustomIcon) : void 0
    });
    if (gamification.scenario)
      gamification.scenario.update({ gamification });
    return gamification;
  }
};
__decorateClass$2q([
  observable
], _Gamification.prototype, "createdDate", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "updatedDate", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "enabled", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "shopEnabled", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "leaderboardEnabled", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "leaderboardTakeCount", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "leaderboardDuration", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "leaderboardDurationType", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsName", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsShortName", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsExpireDuration", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsExpireDurationType", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsIconType", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsIconCloudKey", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "pointsCustomIcon", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "achievementStyle", 2);
__decorateClass$2q([
  observable
], _Gamification.prototype, "scenario", 2);
__decorateClass$2q([
  action
], _Gamification.prototype, "update", 1);
let Gamification = _Gamification;
const _GamificationAchievement = class _GamificationAchievement2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  get isOverrided() {
    return this.systemAchievement !== null;
  }
  get isSystem() {
    return this.type == "system";
  }
  get executionMethod() {
    switch (this.subtype) {
      case "firstStep":
      case "firstTask":
      case "firstTest":
        return "once-material";
      case "activeStudent":
        return "many";
      default:
        return "once";
    }
  }
  toJson() {
    return {
      ...this,
      customImageId: this.customImage === null ? null : this.customImage?.id,
      systemAchievementId: this.systemAchievement === null ? null : this.systemAchievement?.id,
      // skip some fields just in case,
      customImage: void 0,
      systemAchievement: void 0
    };
  }
  clone(changes) {
    return new _GamificationAchievement2({
      ...this,
      customImage: this.customImage?.clone(),
      systemAchievement: this.systemAchievement?.clone(),
      ...changes
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  hasChanges(settings) {
    return Object.keys(settings).some((key) => settings[key] !== this[key]);
  }
  static fromJson(json) {
    return new _GamificationAchievement2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      customImage: json.customImage ? AccelFile.fromJson(json.customImage) : null,
      systemAchievement: json.systemAchievement ? _GamificationAchievement2.fromJson(json.systemAchievement) : null,
      achievedDate: json.achievedDate ? moment(json.achievedDate) : void 0
    });
  }
};
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "createdDate", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "updatedDate", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "enabled", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "points", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "title", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "description", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "type", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "subtype", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "style", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "imageType", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "imageCloudKey", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "customImage", 2);
__decorateClass$2q([
  observable
], _GamificationAchievement.prototype, "systemAchievement", 2);
__decorateClass$2q([
  computed
], _GamificationAchievement.prototype, "isOverrided", 1);
__decorateClass$2q([
  computed
], _GamificationAchievement.prototype, "isSystem", 1);
__decorateClass$2q([
  action
], _GamificationAchievement.prototype, "update", 1);
let GamificationAchievement = _GamificationAchievement;
const _GamificationProduct = class _GamificationProduct2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  toJson() {
    return {
      ...this,
      imageId: this.image === null ? null : this.image?.id,
      productId: this.product === null ? null : this.product?.id,
      gamificationId: this.gamification === null ? null : this.gamification?.id,
      // skip some fields just in case,
      image: void 0,
      product: void 0,
      scenario: void 0,
      gamification: void 0
    };
  }
  clone() {
    return new _GamificationProduct2({
      ...this,
      image: this.image?.clone(),
      product: this.product?.clone(),
      scenario: this.scenario?.copy(),
      gamification: this.gamification?.clone()
    });
  }
  setContentType(type4) {
    this.contentType = type4;
  }
  update(product, allowUndefined = false) {
    super.update(product, allowUndefined);
  }
  hasChanges(settings) {
    return this.title !== settings.title || this.description !== settings.description || this.points !== settings.points || this.useAvailableCount !== settings.useAvailableCount || this.availableCount !== settings.availableCount || this.contentType !== settings.contentType || this.bonusAmount !== settings.bonusAmount || this.image?.id !== settings.image?.id || this.product?.id !== settings.product?.id || this.enabled !== settings.enabled;
  }
  static fromJson(json) {
    const product = new _GamificationProduct2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : null,
      product: json.product ? Product.fromJson(json.product) : null,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      gamification: json.gamification ? Gamification.fromJson(json.gamification) : void 0,
      purchaseDate: json.purchaseDate ? moment(json.purchaseDate) : void 0
    });
    if (product.scenario)
      product.scenario.update({ gamificationProduct: product });
    return product;
  }
};
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "title", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "description", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "createdDate", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "updatedDate", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "enabled", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "points", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "useAvailableCount", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "availableCount", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "contentType", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "bonusAmount", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "image", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "product", 2);
__decorateClass$2q([
  observable
], _GamificationProduct.prototype, "scenario", 2);
__decorateClass$2q([
  action
], _GamificationProduct.prototype, "setContentType", 1);
__decorateClass$2q([
  action
], _GamificationProduct.prototype, "update", 1);
let GamificationProduct = _GamificationProduct;
const _GamificationTransaction = class _GamificationTransaction2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  toJson() {
    return {
      ...this,
      contactId: this.contact === null ? null : this.contact?.id,
      studentAchievementId: this.achievement === null ? null : this.achievement?.id,
      productId: this.product === null ? null : this.product?.id,
      scenarioNodeId: this.scenarioNode === null ? null : this.scenarioNode?.id,
      burnedTransactionId: this.burnedTransaction === null ? null : this.burnedTransaction?.id,
      // skip some fields just in case,
      contact: void 0,
      adminCreator: void 0,
      achievement: void 0,
      product: void 0,
      scenarioNode: void 0,
      burnedTransaction: void 0
    };
  }
  clone() {
    return new _GamificationTransaction2({
      ...this,
      contact: this.contact?.clone(),
      adminCreator: this.adminCreator?.clone(),
      achievement: this.achievement?.clone(),
      product: this.product?.clone(),
      scenarioNode: this.scenarioNode?.clone(),
      burnedTransaction: this.burnedTransaction?.clone()
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  hasChanges(settings) {
    return Object.keys(settings).some((key) => settings[key] !== this[key]);
  }
  static fromJson(json) {
    return new _GamificationTransaction2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      expiredDate: json.expiredDate ? moment(json.expiredDate) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : null,
      adminCreator: json.adminCreator ? Admin.fromJson(json.adminCreator) : null,
      achievement: json.studentAchievement ? GamificationContactAchievement.fromJson(json.studentAchievement) : null,
      product: json.product ? GamificationProduct.fromJson(json.product) : null,
      course: json.course ? Course.fromJson(json.course) : null,
      courseItem: json.courseItem ? CourseItem.fromJson(json.courseItem) : null,
      scenarioNode: json.scenarioNode ? ScenarioNode.fromJson(json.scenarioNode) : null,
      burnedTransaction: json.burnedTransaction ? _GamificationTransaction2.fromJson(json.burnedTransaction) : null
    });
  }
};
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "points", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "type", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "comment", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "burnedTransaction", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "createdDate", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "updatedDate", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "expiredDate", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "contact", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "adminCreator", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "achievement", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "product", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "scenarioNode", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "duration", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "durationType", 2);
__decorateClass$2q([
  observable
], _GamificationTransaction.prototype, "validUntilDate", 2);
__decorateClass$2q([
  action
], _GamificationTransaction.prototype, "update", 1);
const _GamificationContactAchievement = class _GamificationContactAchievement2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  static fromJson(json) {
    return new _GamificationContactAchievement2({
      ...json,
      achievement: json.achievement ? GamificationAchievement.fromJson(json.achievement) : void 0,
      course: json.course ? Course.fromJson(json.course) : null,
      courseItem: json.courseItem ? CourseItem.fromJson(json.courseItem) : null,
      library: json.library ? Library.fromJson(json.library) : null,
      libraryItem: json.libraryItem ? LibraryItem.fromJson(json.libraryItem) : null
    });
  }
};
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "course", 2);
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "courseItem", 2);
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "library", 2);
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "libraryItem", 2);
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "achievement", 2);
__decorateClass$2q([
  observable
], _GamificationContactAchievement.prototype, "points", 2);
let GamificationContactAchievement = _GamificationContactAchievement;
class GamificationLeaderAchievement extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  static fromJson(json) {
    return new GamificationLeaderAchievement({
      ...json
    });
  }
}
const _GamificationLeader = class _GamificationLeader2 extends Entity$1 {
  constructor(g) {
    super();
    if (g) this.update(g);
  }
  toJson() {
    return {
      ...this
    };
  }
  clone() {
    return new _GamificationLeader2({
      ...this,
      contact: this.contact?.clone()
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  static fromJson(json) {
    return new _GamificationLeader2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : null,
      achievements: json.achievements ? json.achievements.map(GamificationLeaderAchievement.fromJson) : null
    });
  }
};
__decorateClass$2q([
  observable
], _GamificationLeader.prototype, "place", 2);
__decorateClass$2q([
  observable
], _GamificationLeader.prototype, "score", 2);
__decorateClass$2q([
  observable
], _GamificationLeader.prototype, "createdDate", 2);
__decorateClass$2q([
  observable
], _GamificationLeader.prototype, "contact", 2);
__decorateClass$2q([
  observable
], _GamificationLeader.prototype, "achievements", 2);
__decorateClass$2q([
  action
], _GamificationLeader.prototype, "update", 1);
var __defProp$2n = Object.defineProperty;
var __getOwnPropDesc$2b = Object.getOwnPropertyDescriptor;
var __decorateClass$2p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2n(target, key, result);
  return result;
};
const _Scenario = class _Scenario2 extends Entity$1 {
  constructor(scenario) {
    super(scenario);
    if (scenario) this.update(scenario);
  }
  get contentName() {
    if (this.softDeleted)
      return null;
    switch (this.type) {
      case "courseItem":
        return this.courseItem?.title;
      case "course":
        return this.course?.name;
      case "sitePage":
        return this.sitePage?.name;
      case "flow":
        return this.flow?.title;
      case "webinar":
        return this.webinar?.name;
      case "widget":
        return this.widget?.name;
      case "product":
        return this.product?.name;
      case "chatBot":
        return this.chatBot?.name;
      case "group":
        return this.telegramGroup?.name;
      case "quiz":
        return this.quiz?.title;
      case "pipeline":
        return this.pipeline?.name;
      case "partnership":
      case "gamification":
        return void 0;
      case "cert":
        return this.cert?.name;
      case "chatChannel":
        return this.chatChannel?.name;
      case "gamificationProduct":
        return this.gamificationProduct?.title;
      default:
        return this.name;
    }
  }
  get isContentDeleted() {
    if (this.softDeleted)
      return true;
    switch (this.type) {
      case "courseItem":
        return this.courseItem?.softDeleted || false;
      case "course":
        return this.course?.softDeleted || false;
      case "sitePage":
        return this.sitePage?.softDeleted || false;
      case "flow":
        return this.flow?.softDeleted || false;
      case "webinar":
        return this.webinar?.softDeleted || false;
      case "widget":
        return this.widget?.softDeleted || false;
      case "product":
        return this.product?.softDeleted || false;
      case "chatBot":
        return this.chatBot?.softDeleted || false;
      case "group":
        return this.telegramGroup?.softDeleted || false;
      case "quiz":
        return this.quiz?.softDeleted || false;
      case "pipeline":
        return this.pipeline?.softDeleted || false;
      case "cert":
        return this.cert?.softDeleted || false;
      case "chatChannel":
        return this.chatChannel?.softDeleted || false;
      default:
        return false;
    }
  }
  get canCopy() {
    return this.type == "simple";
  }
  update(entity) {
    super.update(entity);
  }
  static fromJson(json) {
    return new _Scenario2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      course: json.course ? Course.fromJson(json.course) : void 0,
      courseItem: json.courseItem ? CourseItem.fromJson(json.courseItem) : void 0,
      sitePage: json.sitePage ? SitePage.fromJson(json.sitePage) : void 0,
      flow: json.flow ? Flow.fromJson(json.flow) : void 0,
      webinar: json.webinar ? Webinar.fromJson(json.webinar) : void 0,
      widget: json.widget ? Widget.fromJson(json.widget) : void 0,
      product: json.product ? Product.fromJson(json.product) : void 0,
      chatBot: json.chatBot ? ChatBot.fromJson(json.chatBot) : void 0,
      telegramGroup: json.group ? TelegramGroup.fromJson(json.group) : void 0,
      quiz: json.quiz ? Quiz.fromJson(json.quiz) : void 0,
      pipeline: json.pipeline ? Pipeline.fromJson(json.pipeline) : void 0,
      partnership: json.partnership ? Partnership.fromJson(json.partnership) : void 0,
      cert: json.cert ? Cert.fromJson(json.cert) : void 0,
      chatChannel: json.chatChannel ? ChatChannel.fromJson(json.chatChannel) : void 0,
      gamification: json.gamification ? Gamification.fromJson(json.gamification) : void 0,
      gamificationProduct: json.gamificationProduct ? GamificationProduct.fromJson(json.gamificationProduct) : void 0,
      type: json.type,
      nodeCount: json.nodeCount,
      completedStudentScenariosCount: json.completedStudentScenariosCount,
      activeStudentScenariosCount: json.activeStudentScenariosCount
    });
  }
  copy() {
    return new _Scenario2({
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type
    });
  }
};
__decorateClass$2p([
  observable
], _Scenario.prototype, "name", 2);
__decorateClass$2p([
  observable
], _Scenario.prototype, "description", 2);
__decorateClass$2p([
  observable
], _Scenario.prototype, "isActive", 2);
__decorateClass$2p([
  computed
], _Scenario.prototype, "contentName", 1);
__decorateClass$2p([
  computed
], _Scenario.prototype, "isContentDeleted", 1);
__decorateClass$2p([
  computed
], _Scenario.prototype, "canCopy", 1);
let Scenario = _Scenario;
var __defProp$2m = Object.defineProperty;
var __getOwnPropDesc$2a = Object.getOwnPropertyDescriptor;
var __decorateClass$2o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2m(target, key, result);
  return result;
};
class ScenarioNodePortPayloadFactory {
  static fromJson(payload, type4) {
    switch (type4) {
      case "button":
        return ScenarioNodePortButtonPayload.fromJson(payload);
      case "expireButton":
        return ScenarioNodePortExpiredButtonPayload.fromJson(payload);
      default:
        return null;
    }
  }
}
const _ScenarioNodePortButtonPayload = class _ScenarioNodePortButtonPayload2 extends Updatable {
  constructor(p) {
    super();
    if (p) this.update(p);
  }
  update(entity) {
    super.update(entity);
  }
  static fromJson(json) {
    return new _ScenarioNodePortButtonPayload2({
      ...json
    });
  }
};
__decorateClass$2o([
  observable
], _ScenarioNodePortButtonPayload.prototype, "title", 2);
__decorateClass$2o([
  observable
], _ScenarioNodePortButtonPayload.prototype, "type", 2);
__decorateClass$2o([
  observable
], _ScenarioNodePortButtonPayload.prototype, "link", 2);
__decorateClass$2o([
  action
], _ScenarioNodePortButtonPayload.prototype, "update", 1);
let ScenarioNodePortButtonPayload = _ScenarioNodePortButtonPayload;
const _ScenarioNodePortExpiredButtonPayload = class _ScenarioNodePortExpiredButtonPayload2 extends Updatable {
  constructor(p) {
    super();
    if (p) this.update(p);
  }
  update(entity) {
    super.update(entity);
  }
  static fromJson(json) {
    return new _ScenarioNodePortExpiredButtonPayload2({
      ...json
    });
  }
};
__decorateClass$2o([
  observable
], _ScenarioNodePortExpiredButtonPayload.prototype, "value", 2);
__decorateClass$2o([
  observable
], _ScenarioNodePortExpiredButtonPayload.prototype, "measure", 2);
__decorateClass$2o([
  action
], _ScenarioNodePortExpiredButtonPayload.prototype, "update", 1);
let ScenarioNodePortExpiredButtonPayload = _ScenarioNodePortExpiredButtonPayload;
var __defProp$2l = Object.defineProperty;
var __getOwnPropDesc$29 = Object.getOwnPropertyDescriptor;
var __decorateClass$2n = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$29(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2l(target, key, result);
  return result;
};
const _ScenarioNodePort = class _ScenarioNodePort2 extends Entity$1 {
  constructor(port) {
    super();
    if (port) this.update(port);
  }
  get title() {
    switch (this.type) {
      case "button":
        return this.buttonPayload?.title;
      case "expireButton":
      default:
        return null;
    }
  }
  get buttonPayload() {
    if (this.type === "button")
      return this.payload;
    return null;
  }
  set buttonPayload(value) {
    this.payload = value;
  }
  get expiredButtonPayload() {
    if (this.type === "expireButton")
      return this.payload;
    return null;
  }
  set expiredButtonPayload(value) {
    this.payload = value;
  }
  update(entity) {
    super.update(entity);
  }
  clone(changes) {
    return new _ScenarioNodePort2({ ...this, ...changes });
  }
  static default(type4, position2 = 0) {
    const port = new _ScenarioNodePort2({
      // will be removed on api request
      id: KeyGenerator.generate(5),
      _isNew: true,
      type: type4,
      executionCount: 0,
      position: position2
    });
    switch (type4) {
      case "button":
        port.payload = new ScenarioNodePortButtonPayload({ type: "default" });
        break;
      case "expireButton":
        port.payload = new ScenarioNodePortExpiredButtonPayload({ value: 24, measure: "hours" });
        break;
      default:
        console.warn("unknown port type");
    }
    return port;
  }
  static fromJson(json) {
    return new _ScenarioNodePort2({
      ...json,
      payload: json.payloadJson ? ScenarioNodePortPayloadFactory.fromJson(JSON.parse(json.payloadJson), json.type) : null
    });
  }
};
__decorateClass$2n([
  computed
], _ScenarioNodePort.prototype, "title");
__decorateClass$2n([
  computed
], _ScenarioNodePort.prototype, "buttonPayload");
__decorateClass$2n([
  computed
], _ScenarioNodePort.prototype, "expiredButtonPayload");
__decorateClass$2n([
  action
], _ScenarioNodePort.prototype, "update");
let ScenarioNodePort = _ScenarioNodePort;
var __defProp$2k = Object.defineProperty;
var __getOwnPropDesc$28 = Object.getOwnPropertyDescriptor;
var __decorateClass$2m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$28(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2k(target, key, result);
  return result;
};
const _ScenarioNodeSettings = class _ScenarioNodeSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity) {
    super.update(entity);
  }
  static fromJson(json) {
    return new _ScenarioNodeSettings2({
      position: json.position
    });
  }
  static default() {
    return new _ScenarioNodeSettings2({
      position: { x: 350, y: 22 }
    });
  }
};
__decorateClass$2m([
  observable
], _ScenarioNodeSettings.prototype, "position", 2);
__decorateClass$2m([
  action
], _ScenarioNodeSettings.prototype, "update", 1);
__decorateClass$2m([
  action
], _ScenarioNodeSettings, "fromJson", 1);
let ScenarioNodeSettings = _ScenarioNodeSettings;
const _ScenarioNode = class _ScenarioNode2 extends Entity$1 {
  constructor(node2) {
    super(node2);
    if (node2) this.update(node2);
  }
  get hasName() {
    return !isEmpty(this.name);
  }
  get buttonPorts() {
    if (!this.ports) return [];
    return this.ports.filter((p) => p.type == "button");
  }
  set buttonPorts(btnPorts) {
    const p = this.ports.filter((x) => x.type != "button");
    this.ports = [...p, ...btnPorts];
  }
  update(entity) {
    super.update(entity);
  }
  clone(changes) {
    return new _ScenarioNode2({
      ...this,
      /**
       * node payload can be a class model with `clone` method in it
       */
      //@ts-ignore
      payload: typeof this.payload?.clone === "function" ? this.payload.clone() : this.payload,
      ports: this.ports ? this.ports.map((p) => p.clone()) : void 0,
      ...changes
    });
  }
  static fromJson(json) {
    return new _ScenarioNode2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      settings: json.settingsJson ? ScenarioNodeSettings.fromJson(JSON.parse(json.settingsJson)) : ScenarioNodeSettings.default(),
      // payload: ScenarioNodePayloadFactory.parse(json.actionType, json.payload),
      payload: json.payload ? JSON.parse(json.payload) : null,
      ports: json.ports ? json.ports.map(ScenarioNodePort.fromJson) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0
    });
  }
};
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "name", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "actionType", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "nodeType", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "settings", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "executionCount", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "ports", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "useButtonsOneTime", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "payload", 2);
__decorateClass$2m([
  observable
], _ScenarioNode.prototype, "scenario", 2);
__decorateClass$2m([
  computed
], _ScenarioNode.prototype, "hasName", 1);
__decorateClass$2m([
  computed
], _ScenarioNode.prototype, "buttonPorts", 1);
__decorateClass$2m([
  action
], _ScenarioNode.prototype, "update", 1);
__decorateClass$2m([
  action
], _ScenarioNode, "fromJson", 1);
let ScenarioNode = _ScenarioNode;
var __defProp$2j = Object.defineProperty;
var __getOwnPropDesc$27 = Object.getOwnPropertyDescriptor;
var __decorateClass$2l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$27(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2j(target, key, result);
  return result;
};
const _CallSIPRegistration = class _CallSIPRegistration2 extends Entity$1 {
  constructor(callSIPRegistration) {
    super(callSIPRegistration);
    this.admins = [];
    if (callSIPRegistration) this.update(callSIPRegistration);
  }
  toJson() {
    return {
      id: this.id,
      name: this.name,
      domain: this.domain,
      externalId: this.externalId,
      login: this.login,
      password: this.password,
      lastErrorMessage: this.lastErrorMessage,
      providerCost: this.providerCost,
      status: this.status,
      createdDate: this.createdDate,
      updatedDate: this.updatedDate,
      purchaseDate: this.purchaseDate,
      nextSubscriptionRenewalDate: this.nextSubscriptionRenewalDate,
      adminId: this.admins?.length > 0 ? this.admins[0].id : null
    };
  }
  static fromJson(json) {
    return new _CallSIPRegistration2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      purchaseDate: json.purchaseDate ? new Date(json.purchaseDate) : null,
      nextSubscriptionRenewalDate: json.nextSubscriptionRenewalDate ? new Date(json.nextSubscriptionRenewalDate) : null,
      admins: json.sipRegistrationLinks?.map((x) => Admin.fromJson(x.schoolAdmin.admin)) ?? []
    });
  }
  update(callSIPRegistration, allowUndefined = false) {
    super.update(callSIPRegistration, allowUndefined);
  }
  static default() {
    return new _CallSIPRegistration2({
      admins: []
    });
  }
};
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "name", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "domain", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "externalId", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "login", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "password", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "lastErrorMessage", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "providerCost", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "status", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "createdDate", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "updatedDate", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "purchaseDate", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "nextSubscriptionRenewalDate", 2);
__decorateClass$2l([
  observable
], _CallSIPRegistration.prototype, "admins", 2);
__decorateClass$2l([
  action
], _CallSIPRegistration.prototype, "update", 1);
let CallSIPRegistration = _CallSIPRegistration;
var __defProp$2i = Object.defineProperty;
var __getOwnPropDesc$26 = Object.getOwnPropertyDescriptor;
var __decorateClass$2k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$26(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2i(target, key, result);
  return result;
};
const _CallIncoming = class _CallIncoming2 extends Entity$1 {
  constructor(callIncoming) {
    super(callIncoming);
    if (callIncoming) this.update(callIncoming);
  }
  static fromJson(json) {
    return new _CallIncoming2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : null,
      sipRegistration: json.sipRegistration ? CallSIPRegistration.fromJson(json.sipRegistration) : null
    });
  }
  update(callIncoming) {
    super.update(callIncoming);
  }
};
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "admin", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "sipRegistration", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "phone", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "phoneE164", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "type", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "lineType", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "createdDate", 2);
__decorateClass$2k([
  observable
], _CallIncoming.prototype, "updatedDate", 2);
__decorateClass$2k([
  action
], _CallIncoming.prototype, "update", 1);
var __defProp$2h = Object.defineProperty;
var __getOwnPropDesc$25 = Object.getOwnPropertyDescriptor;
var __decorateClass$2j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$25(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2h(target, key, result);
  return result;
};
const _CallLine = class _CallLine2 extends Entity$1 {
  constructor(callLine) {
    super(callLine);
    if (callLine) this.update(callLine);
  }
  static fromJson(json) {
    return new _CallLine2({
      ...json,
      sipRegistration: json.sipRegistration ? CallSIPRegistration.fromJson(json.sipRegistration) : null
    });
  }
  update(callLine) {
    super.update(callLine);
  }
};
__decorateClass$2j([
  observable
], _CallLine.prototype, "sipRegistration", 2);
__decorateClass$2j([
  observable
], _CallLine.prototype, "type", 2);
__decorateClass$2j([
  action
], _CallLine.prototype, "update", 1);
var __defProp$2g = Object.defineProperty;
var __getOwnPropDesc$24 = Object.getOwnPropertyDescriptor;
var __decorateClass$2i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$24(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2g(target, key, result);
  return result;
};
const _CallSession = class _CallSession2 extends Entity$1 {
  constructor(callSession) {
    super(callSession);
    if (callSession) this.update(callSession);
  }
  get hasCost() {
    if (!this.callAccount) return false;
    return this.callAccount.type !== CallAccountType.OnlinePbx;
  }
  get isSuccessful() {
    return this.state === "completed";
  }
  static fromJson(json) {
    return new _CallSession2({
      ...json,
      callAccount: json.callAccount ? CallAccount.fromJson(json.callAccount) : void 0,
      fromUser: json.fromUser ? CallUser.fromJson(json.fromUser) : void 0,
      toUser: json.toUser ? CallUser.fromJson(json.toUser) : void 0,
      records: json.records ? json.records.map(CallRecord.fromJson) : void 0,
      school: json.school ? School.fromJson(json.school) : void 0,
      sipRegistration: json.sipRegistration ? CallSIPRegistration.fromJson(json.sipRegistration) : null,
      startDate: json.startDate ? new Date(json.startDate) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      completedDate: json.completedDate ? new Date(json.completedDate) : void 0
    });
  }
  update(callSession) {
    super.update(callSession);
  }
};
__decorateClass$2i([
  observable
], _CallSession.prototype, "callAccount", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "fromUser", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "toUser", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "records", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "school", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "sipRegistration", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "durationInSec", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "orderPaymentAmount", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "providerCallCost", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "providerRecordCost", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "providerResourseCost", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "totalProviderCost", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "currency", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "state", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "isIncoming", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "startDate", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "createdDate", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "updatedDate", 2);
__decorateClass$2i([
  observable
], _CallSession.prototype, "completedDate", 2);
__decorateClass$2i([
  computed
], _CallSession.prototype, "hasCost", 1);
__decorateClass$2i([
  computed
], _CallSession.prototype, "isSuccessful", 1);
__decorateClass$2i([
  action
], _CallSession.prototype, "update", 1);
var __defProp$2f = Object.defineProperty;
var __getOwnPropDesc$23 = Object.getOwnPropertyDescriptor;
var __decorateClass$2h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$23(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2f(target, key, result);
  return result;
};
const _CallRecord = class _CallRecord2 extends Entity$1 {
  constructor(schoolCallRecord) {
    super(schoolCallRecord);
    if (schoolCallRecord) this.update(schoolCallRecord);
  }
  static fromJson(json) {
    return new _CallRecord2({
      ...json,
      file: json.file ? AccelFile.fromJson(json.file) : void 0
    });
  }
  update(contact) {
    super.update(contact);
  }
};
__decorateClass$2h([
  observable
], _CallRecord.prototype, "durationInSec", 2);
__decorateClass$2h([
  observable
], _CallRecord.prototype, "providerCost", 2);
__decorateClass$2h([
  observable
], _CallRecord.prototype, "file", 2);
__decorateClass$2h([
  observable
], _CallRecord.prototype, "state", 2);
__decorateClass$2h([
  action
], _CallRecord.prototype, "update", 1);
let CallRecord = _CallRecord;
var __defProp$2e = Object.defineProperty;
var __getOwnPropDesc$22 = Object.getOwnPropertyDescriptor;
var __decorateClass$2g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$22(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2e(target, key, result);
  return result;
};
const _CallUser = class _CallUser2 extends Entity$1 {
  constructor(callUser) {
    super(callUser);
    if (callUser) this.update(callUser);
  }
  static fromJson(json) {
    return new _CallUser2({
      ...json,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0
    });
  }
  update(callUser) {
    super.update(callUser);
  }
};
__decorateClass$2g([
  observable
], _CallUser.prototype, "number", 2);
__decorateClass$2g([
  observable
], _CallUser.prototype, "admin", 2);
__decorateClass$2g([
  observable
], _CallUser.prototype, "contact", 2);
__decorateClass$2g([
  action
], _CallUser.prototype, "update", 1);
let CallUser = _CallUser;
class VoximplantSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class ZadarmaSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class OnlinePbxSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class NovofonSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
var __defProp$2d = Object.defineProperty;
var __getOwnPropDesc$21 = Object.getOwnPropertyDescriptor;
var __decorateClass$2f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$21(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2d(target, key, result);
  return result;
};
var CallAccountType = /* @__PURE__ */ ((CallAccountType2) => {
  CallAccountType2["Voximplant"] = "voximplant";
  CallAccountType2["Zadarma"] = "zadarma";
  CallAccountType2["OnlinePbx"] = "onlinePbx";
  CallAccountType2["Novofon"] = "novofon";
  CallAccountType2["MangoOffice"] = "mangoOffice";
  return CallAccountType2;
})(CallAccountType || {});
const _CallAccount = class _CallAccount2 extends Entity$1 {
  constructor(callAccount) {
    super(callAccount);
    if (callAccount) this.update(callAccount);
  }
  get voximplantSettings() {
    return new VoximplantSettings(this.settings);
  }
  get zadarmaSettings() {
    return new ZadarmaSettings(this.settings);
  }
  get novofonSettings() {
    return new NovofonSettings(this.settings);
  }
  get onlinePbxSettings() {
    return new OnlinePbxSettings(this.settings);
  }
  get mangoOfficeSettings() {
    return new MangoOfficeSettings(this.settings);
  }
  clone() {
    return new _CallAccount2(this);
  }
  toJson() {
    return { ...this };
  }
  update(callAccount, allowUndefined = false) {
    super.update(callAccount, allowUndefined);
  }
  static fromJson(json) {
    return new _CallAccount2({
      ...json,
      settings: json.settingsJson ? JSON.parse(json.settingsJson) : void 0
    });
  }
};
__decorateClass$2f([
  observable
], _CallAccount.prototype, "externalId", 2);
__decorateClass$2f([
  observable
], _CallAccount.prototype, "type", 2);
__decorateClass$2f([
  observable
], _CallAccount.prototype, "active", 2);
__decorateClass$2f([
  observable
], _CallAccount.prototype, "saveCallRecords", 2);
__decorateClass$2f([
  observable
], _CallAccount.prototype, "settings", 2);
__decorateClass$2f([
  action
], _CallAccount.prototype, "update", 1);
let CallAccount = _CallAccount;
class MangoOfficeSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
var __defProp$2c = Object.defineProperty;
var __getOwnPropDesc$20 = Object.getOwnPropertyDescriptor;
var __decorateClass$2e = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$20(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$2c(target, key, result);
  return result;
};
var PaymentGatewayPaymentObjectType = /* @__PURE__ */ ((PaymentGatewayPaymentObjectType2) => {
  PaymentGatewayPaymentObjectType2["Unknown"] = "unknown";
  PaymentGatewayPaymentObjectType2["Payment"] = "payment";
  PaymentGatewayPaymentObjectType2["Commodity"] = "commodity";
  PaymentGatewayPaymentObjectType2["Excise"] = "excise";
  PaymentGatewayPaymentObjectType2["Job"] = "job";
  PaymentGatewayPaymentObjectType2["Service"] = "service";
  PaymentGatewayPaymentObjectType2["GamblingBet"] = "gamblingBet";
  PaymentGatewayPaymentObjectType2["GamblingPrize"] = "gamblingPrize";
  PaymentGatewayPaymentObjectType2["Lottery"] = "lottery";
  PaymentGatewayPaymentObjectType2["LotteryPrize"] = "lotteryPrize";
  PaymentGatewayPaymentObjectType2["IntellectualActivity"] = "intellectualActivity";
  PaymentGatewayPaymentObjectType2["AgentCommission"] = "agentCommission";
  PaymentGatewayPaymentObjectType2["Composite"] = "composite";
  PaymentGatewayPaymentObjectType2["Another"] = "another";
  PaymentGatewayPaymentObjectType2["PropertyRight"] = "propertyRight";
  PaymentGatewayPaymentObjectType2["NonOperatingGain"] = "nonOperatingGain";
  PaymentGatewayPaymentObjectType2["InsurancePremium"] = "insurancePremium";
  PaymentGatewayPaymentObjectType2["SalesTax"] = "salesTax";
  PaymentGatewayPaymentObjectType2["ResortFee"] = "resortFee";
  return PaymentGatewayPaymentObjectType2;
})(PaymentGatewayPaymentObjectType || {});
var PaymentGatewayPaymentMethodType = /* @__PURE__ */ ((PaymentGatewayPaymentMethodType2) => {
  PaymentGatewayPaymentMethodType2["Unknown"] = "unknown";
  PaymentGatewayPaymentMethodType2["FullPayment"] = "fullPayment";
  PaymentGatewayPaymentMethodType2["PartialPayment"] = "partialPayment";
  PaymentGatewayPaymentMethodType2["FullPrepayment"] = "fullPrepayment";
  PaymentGatewayPaymentMethodType2["PartialPrepayment"] = "partialPrepayment";
  PaymentGatewayPaymentMethodType2["Advance"] = "advance";
  PaymentGatewayPaymentMethodType2["Credit"] = "credit";
  PaymentGatewayPaymentMethodType2["CreditPayment"] = "creditPayment";
  return PaymentGatewayPaymentMethodType2;
})(PaymentGatewayPaymentMethodType || {});
var PaymentGatewayTaxationType = /* @__PURE__ */ ((PaymentGatewayTaxationType2) => {
  PaymentGatewayTaxationType2["Osn"] = "osn";
  PaymentGatewayTaxationType2["UsnIncome"] = "usnIncome";
  PaymentGatewayTaxationType2["UsnIncomeOutcome"] = "usnIncomeOutcome";
  PaymentGatewayTaxationType2["Envd"] = "envd";
  PaymentGatewayTaxationType2["Esn"] = "esn";
  PaymentGatewayTaxationType2["Patent"] = "patent";
  return PaymentGatewayTaxationType2;
})(PaymentGatewayTaxationType || {});
var PaymentGatewayTaxType = /* @__PURE__ */ ((PaymentGatewayTaxType2) => {
  PaymentGatewayTaxType2["None"] = "none";
  PaymentGatewayTaxType2["Vat0"] = "vat0";
  PaymentGatewayTaxType2["Vat10"] = "vat10";
  PaymentGatewayTaxType2["Vat12"] = "vat12";
  PaymentGatewayTaxType2["Vat18"] = "vat18";
  PaymentGatewayTaxType2["Vat20"] = "vat20";
  PaymentGatewayTaxType2["Vat110"] = "vat110";
  PaymentGatewayTaxType2["Vat118"] = "vat118";
  PaymentGatewayTaxType2["Vat120"] = "vat120";
  return PaymentGatewayTaxType2;
})(PaymentGatewayTaxType || {});
const _PaymentGatewayInfo = class _PaymentGatewayInfo2 extends Updatable {
  constructor(info) {
    super();
    if (info) this.update(info);
  }
  get hasPaymentMethodGroups() {
    return this.paymentMethodGroups?.length > 0;
  }
  update(product) {
    super.update(product);
  }
  static fromJson(json) {
    return new _PaymentGatewayInfo2({
      ...json
    });
  }
};
__decorateClass$2e([
  computed
], _PaymentGatewayInfo.prototype, "hasPaymentMethodGroups");
class YandexCheckoutSettings extends Updatable {
  constructor() {
    super(...arguments);
    this.tax = PaymentGatewayTaxType.None;
    this.paymentObject = PaymentGatewayPaymentObjectType.Payment;
    this.paymentMethod = PaymentGatewayPaymentMethodType.FullPayment;
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class StripeSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class RoboKassaSettings extends Updatable {
  constructor() {
    super(...arguments);
    this.enableKassa = false;
    this.isTest = false;
    this.taxation = PaymentGatewayTaxationType.Osn;
    this.tax = PaymentGatewayTaxType.None;
    this.paymentObject = PaymentGatewayPaymentObjectType.Payment;
    this.paymentMethod = PaymentGatewayPaymentMethodType.FullPayment;
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class PayPalSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class CloudPaymentsSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class PaymentGatewayStats extends Updatable {
  constructor(stats) {
    super();
    if (stats)
      this.update(stats);
  }
  update(product) {
    super.update(product);
  }
  clone() {
    return new PaymentGatewayStats({
      ...this
    });
  }
  static fromJson(json) {
    return new PaymentGatewayStats({
      ...json
    });
  }
}
class MidtransSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class TinkoffSettings extends Updatable {
  constructor() {
    super(...arguments);
    this.tax = PaymentGatewayTaxType.None;
    this.taxation = PaymentGatewayTaxationType.Osn;
    this.paymentMethod = PaymentGatewayPaymentMethodType.FullPayment;
    this.paymentObject = PaymentGatewayPaymentObjectType.Payment;
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class ProdamusSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class SberbankSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class FondySettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class BePaidSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class SquareUpSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class SmartGlocalSettings extends Updatable {
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class BitPaySettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class EcPaySettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class TinkoffInstallmentSettings extends Updatable {
  constructor(settings) {
    super();
    this.widgetMode = true;
    this.promoCodes = [];
    this.flexible = true;
    if (settings) this.update(settings);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
}
class MercadopagoSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class CyberSourceSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
class WayForPaySettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  toJson() {
    return {
      ...this
    };
  }
}
class MobbexSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  toJson() {
    return {
      ...this
    };
  }
}
class ProntoPagaSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
}
var __defProp$2b = Object.defineProperty;
var __getOwnPropDesc$1$ = Object.getOwnPropertyDescriptor;
var __decorateClass$2d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1$(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2b(target, key, result);
  return result;
};
const _PaymentGateway = class _PaymentGateway2 extends Entity$1 {
  constructor(gateway) {
    super(gateway);
    if (gateway) this.update(gateway);
  }
  get hasNoPayments() {
    return this.stats.every((x) => x.value == 0);
  }
  get settingsJson() {
    return this.settings ? JSON.parse(this.settings) : null;
  }
  // TODO use inline ctor like bitPaySettings
  get yandexCheckoutSettings() {
    const settings = new YandexCheckoutSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get stripeSettings() {
    const settings = new StripeSettings({ isWidgetModeEnabled: true });
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get roboKassaSettings() {
    const settings = new RoboKassaSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get payPalSettings() {
    const settings = new PayPalSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get cloudPaymentsSettings() {
    const settings = new CloudPaymentsSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get midtransSettings() {
    const settings = new MidtransSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get tinkoffSettings() {
    const settings = new TinkoffSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get prodamusSettings() {
    const settings = new ProdamusSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get sberbankSettings() {
    const settings = new SberbankSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get fondySettings() {
    const settings = new FondySettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get bePaidSettings() {
    const settings = new BePaidSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get squareUpSettings() {
    const settings = new SquareUpSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get smartGlocalSettings() {
    const settings = new SmartGlocalSettings();
    if (this.settings) settings.update(this.settingsJson);
    return settings;
  }
  get bitPaySettings() {
    return new BitPaySettings(this.settingsJson);
  }
  get ecPaySettings() {
    return new EcPaySettings(this.settingsJson);
  }
  get tinkoffInstallmentSettings() {
    return new TinkoffInstallmentSettings(this.settingsJson);
  }
  get mercadopagoSettings() {
    return new MercadopagoSettings(this.settingsJson);
  }
  get cyberSourceSettings() {
    return new CyberSourceSettings(this.settingsJson);
  }
  get wayForPaySettings() {
    return new WayForPaySettings(this.settingsJson);
  }
  get mobbexSettings() {
    return new MobbexSettings(this.settingsJson);
  }
  get prontoPagaSettings() {
    return new ProntoPagaSettings(this.settingsJson);
  }
  update(product) {
    super.update(product);
  }
  toJson() {
    throw new Error("not implemented");
  }
  clone() {
    return new _PaymentGateway2({
      ...this,
      stats: this.stats?.map((x) => x.clone())
    });
  }
  static fromJson(json) {
    return new _PaymentGateway2({
      ...json,
      stats: json.stats ? json.stats.map(PaymentGatewayStats.fromJson) : []
    });
  }
};
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "name", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "description", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "paymentButtonText", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "type", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "settings", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "isPrimary", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "showOnSite", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "saveCardEnabled", 2);
__decorateClass$2d([
  observable
], _PaymentGateway.prototype, "currency", 2);
__decorateClass$2d([
  computed
], _PaymentGateway.prototype, "settingsJson", 1);
let PaymentGateway = _PaymentGateway;
var PaymentGatewayType = /* @__PURE__ */ ((PaymentGatewayType2) => {
  PaymentGatewayType2["Prodamus"] = "prodamus";
  PaymentGatewayType2["YandexCheckout"] = "yandexCheckout";
  PaymentGatewayType2["RoboKassa"] = "roboKassa";
  PaymentGatewayType2["Stripe"] = "stripe";
  PaymentGatewayType2["PayPal"] = "payPal";
  PaymentGatewayType2["Cash"] = "cash";
  PaymentGatewayType2["CloudPayments"] = "cloudPayments";
  PaymentGatewayType2["WireTransfer"] = "wireTransfer";
  PaymentGatewayType2["NewStripe"] = "newStripe";
  PaymentGatewayType2["Midtrans"] = "midtrans";
  PaymentGatewayType2["Tinkoff"] = "tinkoff";
  PaymentGatewayType2["Sberbank"] = "sberbank";
  PaymentGatewayType2["Fondy"] = "fondy";
  PaymentGatewayType2["SquareUp"] = "squareUp";
  PaymentGatewayType2["BePaid"] = "bePaid";
  PaymentGatewayType2["AuthorizeNet"] = "authorizeNet";
  PaymentGatewayType2["SmartGlocal"] = "smartGlocal";
  PaymentGatewayType2["BitPay"] = "bitPay";
  PaymentGatewayType2["EcPay"] = "ecPay";
  PaymentGatewayType2["TinkoffInstallment"] = "tinkoffInstallment";
  PaymentGatewayType2["Mercadopago"] = "mercadopago";
  PaymentGatewayType2["CyberSource"] = "cyberSource";
  PaymentGatewayType2["WayForPay"] = "wayForPay";
  PaymentGatewayType2["Mobbex"] = "mobbex";
  PaymentGatewayType2["ProntoPaga"] = "prontoPaga";
  return PaymentGatewayType2;
})(PaymentGatewayType || {});
var __defProp$2a = Object.defineProperty;
var __getOwnPropDesc$1_ = Object.getOwnPropertyDescriptor;
var __decorateClass$2c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1_(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2a(target, key, result);
  return result;
};
const _ProductPaymentGatewaySettings = class _ProductPaymentGatewaySettings2 extends Entity$1 {
  constructor(settings) {
    super(settings);
    this.paymentMethodGroupRequired = false;
    this.paymentMethodGroups = [];
    this.type = "onlineKassa";
    this._key = KeyGenerator.generate(5);
    if (settings) this.update(settings);
  }
  update(product, allowUndefined = false) {
    super.update(product, allowUndefined);
  }
  static fromJson(json) {
    return new _ProductPaymentGatewaySettings2({
      ...json,
      gateway: json.gateway ? PaymentGateway.fromJson(json.gateway) : null
    });
  }
  toJson() {
    return {
      gatewayId: this.gateway.id,
      tax: this.tax,
      paymentObject: this.paymentObject,
      paymentMethod: this.paymentMethod,
      paymentMethodGroups: this.paymentMethodGroups,
      type: this.type
    };
  }
  clone(changes) {
    return new _ProductPaymentGatewaySettings2({
      ...this,
      ...changes
    });
  }
  hasChanges(settings) {
    return this.gateway.id != settings.gateway.id || this.tax != settings.tax || this.type != settings.type || this.paymentObject != settings.paymentObject || this.paymentMethod != settings.paymentMethod || !isArraysEqual(this.paymentMethodGroups, settings.paymentMethodGroups, (a, b) => a == b);
  }
};
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "productId", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "gateway", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "taxRequired", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "tax", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentObjectRequired", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentObject", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentMethodRequired", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentMethod", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentMethodGroupRequired", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "paymentMethodGroups", 2);
__decorateClass$2c([
  observable
], _ProductPaymentGatewaySettings.prototype, "type", 2);
__decorateClass$2c([
  action
], _ProductPaymentGatewaySettings.prototype, "update", 1);
let ProductPaymentGatewaySettings = _ProductPaymentGatewaySettings;
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["Digital"] = "digital";
  ProductType2["Physical"] = "physical";
  ProductType2["Service"] = "service";
  ProductType2["Material"] = "material";
  ProductType2["Subscription"] = "subscription";
  ProductType2["Cohort"] = "cohort";
  return ProductType2;
})(ProductType || {});
var ProductContentType = /* @__PURE__ */ ((ProductContentType2) => {
  ProductContentType2["Course"] = "course";
  ProductContentType2["Library"] = "library";
  ProductContentType2["AllCourses"] = "allCourses";
  ProductContentType2["AllLibraries"] = "allLibraries";
  return ProductContentType2;
})(ProductContentType || {});
var __defProp$29 = Object.defineProperty;
var __getOwnPropDesc$1Z = Object.getOwnPropertyDescriptor;
var __decorateClass$2b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1Z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$29(target, key, result);
  return result;
};
const _ProductCategory = class _ProductCategory2 extends Entity$1 {
  constructor(c) {
    super();
    this.name = "";
    this.description = "";
    this.products = [];
    if (c) this.update(c);
  }
  toJson() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      productIds: this.products?.map((x) => x.id)
    };
  }
  update(c, allowUndefined) {
    super.update(c, allowUndefined);
  }
  clone(changes) {
    return new _ProductCategory2({
      ...this,
      products: this.products?.map((x) => x.clone()),
      ...changes
    });
  }
  static fromJson(json) {
    return new _ProductCategory2({
      ...json,
      products: json.products ? json.products.map(Product.fromJson) : void 0
    });
  }
};
__decorateClass$2b([
  observable
], _ProductCategory.prototype, "name", 2);
__decorateClass$2b([
  observable
], _ProductCategory.prototype, "description", 2);
__decorateClass$2b([
  observable
], _ProductCategory.prototype, "products", 2);
__decorateClass$2b([
  action
], _ProductCategory.prototype, "update", 1);
let ProductCategory = _ProductCategory;
var __defProp$28 = Object.defineProperty;
var __getOwnPropDesc$1Y = Object.getOwnPropertyDescriptor;
var __decorateClass$2a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1Y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$28(target, key, result);
  return result;
};
const _SubsRenewalSettings = class _SubsRenewalSettings2 extends Updatable {
  constructor(settings) {
    super();
    this.mode = "auto";
    this.attemptCount = 0;
    this.dayCount = 0;
    this.retryDays = [];
    this.creditEnabled = false;
    this.creditDayCount = 0;
    this.countLimitEnabled = false;
    this.countLimit = null;
    if (settings) this.update(settings);
  }
  addPause() {
    this.retryDays.push({ key: KeyGenerator.generate(5), value: 1 });
  }
  updatePause(key, days) {
    this.retryDays = this.retryDays.map((x) => x.key == key ? { key, value: days } : x);
  }
  removePause(key) {
    this.retryDays = this.retryDays.filter((x) => x.key != key);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
  toJson() {
    return {
      ...this,
      retryDays: this.retryDays.map((x) => x.value)
    };
  }
  hasChanges(settings) {
    return this.mode != settings.mode || this.attemptCount != settings.attemptCount || this.dayCount != settings.dayCount || this.creditEnabled != settings.creditEnabled || this.creditDayCount != settings.creditDayCount || !this.retryDays.isEquals(settings.retryDays, (a, b) => a.value == b.value) || this.countLimitEnabled != settings.countLimitEnabled || this.countLimit != settings.countLimit;
  }
  clone() {
    return new _SubsRenewalSettings2({
      ...this,
      retryDays: this.retryDays.map((x) => ({ key: KeyGenerator.generate(5), value: x.value }))
    });
  }
  static fromJson(json) {
    return new _SubsRenewalSettings2({
      ...json,
      retryDays: json.retryDays?.map((x) => ({ key: KeyGenerator.generate(5), value: x })) ?? []
    });
  }
};
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "mode", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "attemptCount", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "dayCount", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "retryDays", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "creditEnabled", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "creditDayCount", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "countLimitEnabled", 2);
__decorateClass$2a([
  observable
], _SubsRenewalSettings.prototype, "countLimit", 2);
__decorateClass$2a([
  action
], _SubsRenewalSettings.prototype, "addPause", 1);
__decorateClass$2a([
  action
], _SubsRenewalSettings.prototype, "updatePause", 1);
__decorateClass$2a([
  action
], _SubsRenewalSettings.prototype, "removePause", 1);
__decorateClass$2a([
  action
], _SubsRenewalSettings.prototype, "update", 1);
let SubsRenewalSettings = _SubsRenewalSettings;
const _Product = class _Product2 extends Entity$1 {
  constructor(product) {
    super(product);
    this.limitOrderLifetime = false;
    this.limitOrderLifetimeMode = "duration";
    this.limitOrderLifetimeDuration = null;
    this.limitOrderLifetimeDate = null;
    this.category = null;
    if (product) this.update(product);
  }
  get isSubscription() {
    return this.type == ProductType.Subscription;
  }
  get accessTimeType() {
    if (this.duration == null && !this.beginDate && !this.endDate)
      return "endless";
    if (this.duration != null)
      return "duration";
    return "period";
  }
  get hasInternalName() {
    return !isEmpty(this.internalName);
  }
  get subsAccessTimeType() {
    if (this.duration == null && !this.beginDate && !this.endDate)
      return "endless";
    if (this.duration != null)
      return "duration";
    return "period";
  }
  addPaymentGatewaySettings(settings) {
    this.paymentGatewaySettings.push(settings);
  }
  removePaymentGatewaySettings(settings) {
    this.paymentGatewaySettings.remove(settings);
  }
  get price() {
    if (this.isSubscription)
      return this.subsPrice ?? 0;
    return this.oneTimePrice ?? 0;
  }
  update(product, allowUndefined = false) {
    super.update(product, allowUndefined);
  }
  static fromJson(json) {
    const product = new _Product2({
      id: json.id,
      name: json.name,
      internalName: json.internalName,
      description: json.description,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      orderCount: json.orderCount,
      contactCount: json.contactCount ?? 0,
      type: json.type,
      preventSystemEmail: json.preventSystemEmail,
      files: json.fileLinks ? json.fileLinks.map((x) => AccelFile.fromJson(x.file)) : [],
      image: json.image ? AccelFile.fromJson(json.image) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      contents: json.contents ? json.contents.map(ProductContent.fromJson) : [],
      isPublished: json.isPublished,
      oneTimePrice: json.oneTimePrice ?? null,
      oneTimeDisplayPrice: json.oneTimeDisplayPrice ?? null,
      useOneTimeDisplayPrice: json.useOneTimeDisplayPrice,
      duration: json.duration ?? null,
      durationType: json.durationType ?? null,
      beginDate: json.beginDate ? moment(json.beginDate) : null,
      endDate: json.endDate ? moment(json.endDate) : null,
      freeDownload: json.freeDownload,
      installmentDisabled: json.installmentDisabled,
      subsPrice: json.subsPrice ?? null,
      subsDuration: json.subsDuration ?? null,
      subsDurationType: json.subsDurationType ?? null,
      subsRenewalSettings: json.subsRenewalSettings ? SubsRenewalSettings.fromJson(json.subsRenewalSettings) : new SubsRenewalSettings(),
      useTrialSubs: json.useTrialSubs ?? false,
      trialSubsPrice: json.trialSubsPrice ?? false,
      trialSubsDuration: json.trialSubsDuration ?? false,
      trialSubsDurationType: json.trialSubsDurationType ?? null,
      useBonusPayment: json.useBonusPayment ?? false,
      bonusPaymentAmount: json.bonusPaymentAmount ?? 0,
      bonusPaymentType: json.bonusPaymentType ?? "percent",
      useDonationPayment: json.useDonationPayment ?? false,
      minDonationPaymentAmount: json.minDonationPaymentAmount ?? 0,
      flowDate: json.flowDate ? FlowDate.fromJson(json.flowDate) : void 0,
      softDeleted: json.softDeleted,
      paymentGatewaySettings: json.paymentGatewaySettings ? json.paymentGatewaySettings.map(ProductPaymentGatewaySettings.fromJson) : [],
      paymentGateways: json.paymentGatewayLinks ? json.paymentGatewayLinks.map((x) => PaymentGateway.fromJson(x.gateway)) : [],
      relatedProducts: json.relatedProductLinks ? json.relatedProductLinks.map((x) => _Product2.fromJson(x.target)) : [],
      limitOrderLifetime: json.limitOrderLifetime,
      limitOrderLifetimeMode: json.limitOrderLifetimeMode,
      limitOrderLifetimeDuration: json.limitOrderLifetimeDuration,
      limitOrderLifetimeDate: json.limitOrderLifetimeDate ? moment(json.limitOrderLifetimeDate) : null,
      category: json.category ? ProductCategory.fromJson(json.category) : void 0
    });
    if (product.scenario)
      product.scenario.update({ product });
    return product;
  }
  clone(changes) {
    return new _Product2({
      ...this,
      files: this.files.slice(),
      contents: this.contents.map((x) => x.clone()),
      paymentGatewaySettings: this.paymentGatewaySettings.slice(),
      paymentGateways: this.paymentGateways.slice(),
      relatedProducts: this.relatedProducts.slice(),
      subsRenewalSettings: this.subsRenewalSettings.clone(),
      ...changes
    });
  }
  hasChanges(product) {
    return this.name != product.name || this.internalName != product.internalName || this.description != product.description || this.oneTimePrice != product.oneTimePrice || this.oneTimeDisplayPrice != product.oneTimeDisplayPrice || this.useOneTimeDisplayPrice != product.useOneTimeDisplayPrice || this.useDonationPayment != product.useDonationPayment || this.minDonationPaymentAmount != product.minDonationPaymentAmount || this.freeDownload != product.freeDownload || this.installmentDisabled != product.installmentDisabled || this.preventSystemEmail != product.preventSystemEmail || this.type != product.type || !this.files.isEquals(product.files, (a, b) => a.id == b.id) || this.type != product.type || !this.contents.isEquals(product.contents, (a, b) => !a.hasChanges(b)) || this.duration != product.duration || this.durationType != product.durationType || this.beginDate != product.beginDate || this.endDate != product.endDate || this.useTrialSubs != product.useTrialSubs || this.subsDurationType != product.subsDurationType || this.subsDuration != product.subsDuration || this.subsPrice != product.subsPrice || this.trialSubsDurationType != product.trialSubsDurationType || this.trialSubsDuration != product.trialSubsDuration || this.trialSubsPrice != product.trialSubsPrice || this.flowDate?.id != product.flowDate?.id || this.image?.id != product.image?.id || !this.paymentGatewaySettings.isEquals(product.paymentGatewaySettings, (a, b) => !a.hasChanges(b)) || !this.paymentGateways.isEquals(product.paymentGateways, (a, b) => a.id == b.id) || this.useBonusPayment != product.useBonusPayment || this.bonusPaymentAmount != product.bonusPaymentAmount || this.bonusPaymentType != product.bonusPaymentType || !this.relatedProducts.isEquals(product.relatedProducts, (a, b) => a.id == b.id) || this.limitOrderLifetime != product.limitOrderLifetime || this.limitOrderLifetimeMode != product.limitOrderLifetimeMode || this.limitOrderLifetimeDuration != product.limitOrderLifetimeDuration || this.limitOrderLifetimeDate != product.limitOrderLifetimeDate || this.subsRenewalSettings.hasChanges(product.subsRenewalSettings) || this.category?.id != product.category?.id;
  }
};
__decorateClass$2a([
  observable
], _Product.prototype, "name", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "internalName", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "description", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "createdDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "updatedDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "orderCount", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "contactCount", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "isPublished", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "type", 2);
__decorateClass$2a([
  computed
], _Product.prototype, "isSubscription", 1);
__decorateClass$2a([
  observable
], _Product.prototype, "preventSystemEmail", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "files", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "image", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "scenario", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "flowDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "contents", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "oneTimePrice", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "oneTimeDisplayPrice", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "useOneTimeDisplayPrice", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "useDonationPayment", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "minDonationPaymentAmount", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "duration", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "durationType", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "beginDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "endDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "useBonusPayment", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "bonusPaymentAmount", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "bonusPaymentType", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "limitOrderLifetime", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "limitOrderLifetimeMode", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "limitOrderLifetimeDuration", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "limitOrderLifetimeDate", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "category", 2);
__decorateClass$2a([
  computed
], _Product.prototype, "accessTimeType", 1);
__decorateClass$2a([
  computed
], _Product.prototype, "hasInternalName", 1);
__decorateClass$2a([
  observable
], _Product.prototype, "freeDownload", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "installmentDisabled", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "subsPrice", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "subsDuration", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "subsDurationType", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "subsRenewalSettings", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "useTrialSubs", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "trialSubsPrice", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "trialSubsDuration", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "trialSubsDurationType", 2);
__decorateClass$2a([
  computed
], _Product.prototype, "subsAccessTimeType", 1);
__decorateClass$2a([
  observable
], _Product.prototype, "paymentGateways", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "paymentGatewaySettings", 2);
__decorateClass$2a([
  observable
], _Product.prototype, "relatedProducts", 2);
__decorateClass$2a([
  action
], _Product.prototype, "addPaymentGatewaySettings", 1);
__decorateClass$2a([
  action
], _Product.prototype, "removePaymentGatewaySettings", 1);
__decorateClass$2a([
  computed
], _Product.prototype, "price", 1);
__decorateClass$2a([
  action
], _Product.prototype, "update", 1);
let Product = _Product;
var __defProp$27 = Object.defineProperty;
var __getOwnPropDesc$1X = Object.getOwnPropertyDescriptor;
var __decorateClass$29 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1X(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$27(target, key, result);
  return result;
};
const _ProductContent = class _ProductContent2 extends Entity$1 {
  constructor(content2) {
    super(content2);
    if (content2)
      this.update(content2);
  }
  get contentSoftDeleted() {
    switch (this.type) {
      case ProductContentType.Course:
        return this.course?.softDeleted;
      case ProductContentType.Library:
        return this.library?.softDeleted;
      default:
        return void 0;
    }
  }
  get name() {
    switch (this.type) {
      case ProductContentType.Course:
        return this.course?.name;
      case ProductContentType.Library:
        return this.library?.name;
      default:
        return void 0;
    }
  }
  get hasLibraryItems() {
    return this.libraryItemIds && this.libraryItemIds.length > 0;
  }
  changeType(type4) {
    this.type = type4;
    this.course = null;
    this.coursePlan = null;
    this.library = null;
    this.libraryItemIds = null;
  }
  update(product, allowUndefined = false) {
    super.update(product, allowUndefined);
  }
  static fromJson(json) {
    return new _ProductContent2({
      id: json.id,
      type: json.type,
      course: json.course ? Course.fromJson(json.course) : null,
      coursePlan: json.coursePlan ? CoursePlan.fromJson(json.coursePlan) : null,
      library: json.libraryAccess ? Library.fromJson(json.libraryAccess.library) : null,
      libraryItemIds: json.libraryAccess && json.libraryAccess.itemAccesses ? json.libraryAccess.itemAccesses.map((x) => x.libraryItem.id) : null,
      image: json.image ? AccelFile.fromJson(json.image) : void 0
    });
  }
  clone() {
    return new _ProductContent2({
      id: this.id,
      type: this.type,
      course: this.course,
      coursePlan: this.coursePlan,
      library: this.library,
      libraryItemIds: this.libraryItemIds?.slice()
    });
  }
  hasChanges(content2) {
    return this.id != content2.id || this.image?.id != content2.image?.id || this.course?.id != content2.course?.id || this.coursePlan?.id != content2.coursePlan?.id || this.library?.id != content2.library?.id || this.type != content2.type || !(this.libraryItemIds ?? []).isEquals(content2.libraryItemIds ?? [], (a, b) => a === b);
  }
};
__decorateClass$29([
  observable
], _ProductContent.prototype, "image", 2);
__decorateClass$29([
  observable
], _ProductContent.prototype, "course", 2);
__decorateClass$29([
  observable
], _ProductContent.prototype, "coursePlan", 2);
__decorateClass$29([
  observable
], _ProductContent.prototype, "library", 2);
__decorateClass$29([
  observable
], _ProductContent.prototype, "libraryItemIds", 2);
__decorateClass$29([
  observable
], _ProductContent.prototype, "type", 2);
__decorateClass$29([
  computed
], _ProductContent.prototype, "contentSoftDeleted", 1);
__decorateClass$29([
  computed
], _ProductContent.prototype, "name", 1);
__decorateClass$29([
  computed
], _ProductContent.prototype, "hasLibraryItems", 1);
__decorateClass$29([
  action
], _ProductContent.prototype, "changeType", 1);
__decorateClass$29([
  action
], _ProductContent.prototype, "update", 1);
let ProductContent = _ProductContent;
var PurchaseOrderStatus = /* @__PURE__ */ ((PurchaseOrderStatus2) => {
  PurchaseOrderStatus2["Created"] = "created";
  PurchaseOrderStatus2["CheckoutData"] = "checkoutData";
  PurchaseOrderStatus2["Payment"] = "payment";
  PurchaseOrderStatus2["PartiallyPaid"] = "partiallyPaid";
  PurchaseOrderStatus2["Paid"] = "paid";
  PurchaseOrderStatus2["PreparingShipment"] = "preparingShipment";
  PurchaseOrderStatus2["Shipped"] = "shipped";
  PurchaseOrderStatus2["Fulfilled"] = "fulfilled";
  PurchaseOrderStatus2["Canceled"] = "canceled";
  PurchaseOrderStatus2["Refund"] = "refund";
  return PurchaseOrderStatus2;
})(PurchaseOrderStatus || {});
var __defProp$26 = Object.defineProperty;
var __getOwnPropDesc$1W = Object.getOwnPropertyDescriptor;
var __decorateClass$28 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1W(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$26(target, key, result);
  return result;
};
const _PurchaseOrder = class _PurchaseOrder2 extends Entity$1 {
  constructor(purchaseOrder) {
    super(purchaseOrder);
    if (purchaseOrder) this.update(purchaseOrder, false, true);
  }
  get isRenewal() {
    return !isEmpty(this.renewalLicenseId);
  }
  get totalAmountWithShipping() {
    return this.totalAmount + (this.shippingPrice ?? 0);
  }
  get totalAmountWithoutSavings() {
    return this.totalAmount + this.savingsAmount;
  }
  get amountToBePaid() {
    return this.totalAmount - this.paidAmount + (this.shippingPrice ?? 0);
  }
  get needShipping() {
    return this.contents.some((x) => x.product.type == ProductType.Physical);
  }
  get canModifyContent() {
    return !this.completed && this.status != PurchaseOrderStatus.Payment;
  }
  calcTotals() {
    this.totalAmount = this.contents.map((x) => x.totalPriceFinal).reduce((a, b) => a + b, 0);
    this.savingsAmount = this.contents.map((x) => x.totalSavings).reduce((a, b) => a + b, 0);
  }
  get canComplete() {
    return !this.completed && this.contents.length > 0;
  }
  get hasContact() {
    return this.contact != null;
  }
  getFieldValue(attrId) {
    const val = this.fieldValues.find((x) => x.customField.id == attrId);
    return val ?? null;
  }
  setFieldValue(value) {
    const val = this.getFieldValue(value.customField.id);
    if (val) {
      val.update(value, true);
    } else {
      this.fieldValues.push(value);
    }
  }
  get isExpired() {
    return this.expirationDate != null && this.expirationDate.isBefore(moment());
  }
  get isContactEditable() {
    return !this.completed && !this.isRenewal;
  }
  get isPartiallyPaid() {
    return this.paidAmount > 0 && this.paidAmount < this.totalAmount;
  }
  toJson() {
    throw new Error("Method not implemented.");
  }
  update(changes, allowUndefined = false, disableRecalc = false) {
    const needRecalc = disableRecalc != true && (changes.contents !== void 0 || changes.shippingPrice != this.shippingPrice);
    super.update(changes, allowUndefined);
    if (needRecalc) this.calcTotals();
  }
  clone() {
    return new _PurchaseOrder2({
      ...this,
      promoCode: this.promoCode?.copy(),
      payments: this.payments?.slice(),
      contents: this.contents?.map((x) => x.copy()),
      tags: this.tags?.map((x) => x.copy()),
      pipelineItem: this.pipelineItem?.clone(),
      partner: this.partner?.clone(),
      fields: this.fields?.map((x) => x.clone()),
      fieldValues: this.fieldValues?.map((x) => x.clone())
    });
  }
  hasChanges(order, skipContents = true) {
    const result = this.status != order.status || this.shippingEmail != order.shippingEmail || this.shippingFirstName != order.shippingFirstName || this.shippingLastName != order.shippingLastName || this.shippingPhone != order.shippingPhone || this.shippingAddress != order.shippingAddress || this.shippingCity != order.shippingCity || this.shippingState != order.shippingState || this.shippingZip != order.shippingZip || this.shippingComment != order.shippingComment || this.shippingCountry != order.shippingCountry || this.shippingTrackingCode != order.shippingTrackingCode || this.shippingPrice != order.shippingPrice || this.contact?.id != order.contact?.id || this.responsible?.id != order.responsible?.id || this.promoCode?.id != order.promoCode?.id || this.partner?.id != order.partner?.id || this.pipelineItem?.id != order.pipelineItem?.id || !this.tags?.isEquals(order.tags, (a, b) => a.id === b.id) || this.expirationDate != order.expirationDate || this.partner?.id != order.partner?.id || !isArraysEqual(
      this.fieldValues,
      order.fieldValues,
      (a, b) => a.isEquals(b)
    );
    if (result || skipContents) return result;
    return this.contents && order.contents && (this.contents.length != order.contents.length || this.contents.some((x) => order.contents.find((y) => x.id == y.id) == null));
  }
  static fromJson(json) {
    return new _PurchaseOrder2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      paidDate: json.paidDate ? moment(json.paidDate) : null,
      contact: json.contact ? Contact.fromJson(json.contact) : null,
      site: json.site ? Site.fromJson(json.site) : void 0,
      paymentGateway: json.paymentGateway ? PaymentGateway.fromJson(json.paymentGateway) : void 0,
      contents: json.contents ? json.contents.map(PurchaseOrderContent.fromJson) : [],
      payments: json.payments ? json.payments.map(PurchaseOrderPayment.fromJson) : [],
      parent: json.parent ? _PurchaseOrder2.fromJson(json.parent) : null,
      admin: json.admin ? Admin.fromJson(json.admin) : null,
      responsible: json.responsible ? Admin.fromJson(json.responsible) : null,
      school: json.school ? School.fromJson(json.school) : null,
      promoCode: json.promoCode ? PromoCode.fromJson(json.promoCode) : null,
      tags: json.tagLinks ? json.tagLinks.map((i) => AccelTag.fromJson(i.tag)) : [],
      pipelineItem: json.pipelineItem ? PipelineStageItem.fromJson(json.pipelineItem) : void 0,
      utmTags: new UtmContainer({ campaign: json.utmCampaign, content: json.utmContent, medium: json.utmMedium, source: json.utmSource, term: json.utmTerm }),
      expirationDate: json.expirationDate ? moment(json.expirationDate) : null,
      partner: json.partner ? Contact.fromJson(json.partner) : null,
      fieldValues: CustomFieldValue.parseValuesFromJson(json.fieldValues),
      fields: json.fields ? json.fields.map(CustomField.fromJson) : []
    });
  }
};
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "createdDate", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "paidDate", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "currency", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "isDigitalDelivery", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "fullyPaid", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingPrice", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "totalAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "paidAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "paidBonusAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "savingsAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "status", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "completed", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingEmail", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingFirstName", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingLastName", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingPhone", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingAddress", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingCity", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingState", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingZip", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingCountry", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingComment", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "shippingTrackingCode", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "siteGuestId", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "siteSessionEnterViewId", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "number", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "pipelineItem", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "parent", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "admin", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "responsible", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "site", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "contact", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "school", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "paymentGateway", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "payments", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "contents", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "promoCode", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "tags", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "offSession", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "utmTags", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "feeAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "partnerFeeAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "partner", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "income", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "deductionAmount", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "expirationDate", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "fields", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "fieldValues", 2);
__decorateClass$28([
  observable
], _PurchaseOrder.prototype, "renewalLicenseId", 2);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "isRenewal", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "totalAmountWithShipping", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "totalAmountWithoutSavings", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "amountToBePaid", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "needShipping", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "canModifyContent", 1);
__decorateClass$28([
  action
], _PurchaseOrder.prototype, "calcTotals", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "canComplete", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "hasContact", 1);
__decorateClass$28([
  action
], _PurchaseOrder.prototype, "setFieldValue", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "isExpired", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "isContactEditable", 1);
__decorateClass$28([
  computed
], _PurchaseOrder.prototype, "isPartiallyPaid", 1);
let PurchaseOrder = _PurchaseOrder;
var __defProp$25 = Object.defineProperty;
var __getOwnPropDesc$1V = Object.getOwnPropertyDescriptor;
var __decorateClass$27 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1V(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$25(target, key, result);
  return result;
};
const _PromoCode = class _PromoCode2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  get status() {
    var utcNow = moment();
    if (this.endDate != null && utcNow >= this.endDate)
      return "expired";
    if (this.useAvailableCount && this.availableCount !== null && this.availableCount <= 0)
      return "ended";
    return utcNow >= this.beginDate && (this.endDate == null || utcNow < this.endDate) ? "active" : "inactive";
  }
  update(promoCode) {
    super.update(promoCode);
  }
  static fromJson(json) {
    return new _PromoCode2({
      ...json,
      createdDate: json.beginDate ? moment(json.beginDate) : void 0,
      updatedDate: json.endDate ? moment(json.endDate) : void 0,
      beginDate: json.beginDate ? moment(json.beginDate) : void 0,
      endDate: json.endDate ? moment(json.endDate) : null,
      products: json.productLinks ? json.productLinks.map((x) => Product.fromJson(x.product)) : null,
      partner: json.partner ? Contact.fromJson(json.partner) : void 0
    });
  }
  clone() {
    return new _PromoCode2({
      ...this,
      products: this.products?.map((i) => i.copy()),
      partner: this.partner?.clone()
    });
  }
};
__decorateClass$27([
  observable
], _PromoCode.prototype, "updatedDate", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "beginDate", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "endDate", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "name", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "code", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "discountType", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "discountAmount", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "products", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "subsRenewalDisabled", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "ignoreCase", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "partner", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "useAvailableCount", 2);
__decorateClass$27([
  observable
], _PromoCode.prototype, "availableCount", 2);
__decorateClass$27([
  computed
], _PromoCode.prototype, "status", 1);
let PromoCode = _PromoCode;
var __defProp$24 = Object.defineProperty;
var __getOwnPropDesc$1U = Object.getOwnPropertyDescriptor;
var __decorateClass$26 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1U(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$24(target, key, result);
  return result;
};
const _PurchaseOrderContent = class _PurchaseOrderContent2 extends Entity$1 {
  constructor(purchaseOrder) {
    super(purchaseOrder);
    if (purchaseOrder) this.update(purchaseOrder);
  }
  get finalPriceEach() {
    return this.priceEach - this.savingsEach;
  }
  get totalPriceNoSavings() {
    return this.quantity * this.priceEach;
  }
  get totalSavings() {
    return this.quantity * this.savingsEach;
  }
  get totalPriceFinal() {
    return this.quantity * this.finalPriceEach;
  }
  update(product) {
    super.update(product);
  }
  copy() {
    return new _PurchaseOrderContent2({
      id: this.id,
      quantity: this.quantity,
      priceEach: this.priceEach,
      savingsEach: this.savingsEach,
      product: this.product,
      purchaseOrder: this.purchaseOrder
    });
  }
  static fromJson(json) {
    return new _PurchaseOrderContent2({
      ...json,
      product: json.product ? Product.fromJson(json.product) : void 0,
      purchaseOrder: json.purchaseOrder ? PurchaseOrder.fromJson(json.purchaseOrder) : void 0
    });
  }
};
__decorateClass$26([
  observable
], _PurchaseOrderContent.prototype, "quantity", 2);
__decorateClass$26([
  observable
], _PurchaseOrderContent.prototype, "priceEach", 2);
__decorateClass$26([
  observable
], _PurchaseOrderContent.prototype, "savingsEach", 2);
__decorateClass$26([
  observable
], _PurchaseOrderContent.prototype, "product", 2);
__decorateClass$26([
  observable
], _PurchaseOrderContent.prototype, "purchaseOrder", 2);
__decorateClass$26([
  computed
], _PurchaseOrderContent.prototype, "finalPriceEach", 1);
__decorateClass$26([
  computed
], _PurchaseOrderContent.prototype, "totalPriceNoSavings", 1);
__decorateClass$26([
  computed
], _PurchaseOrderContent.prototype, "totalSavings", 1);
__decorateClass$26([
  computed
], _PurchaseOrderContent.prototype, "totalPriceFinal", 1);
let PurchaseOrderContent = _PurchaseOrderContent;
var __defProp$23 = Object.defineProperty;
var __getOwnPropDesc$1T = Object.getOwnPropertyDescriptor;
var __decorateClass$25 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1T(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$23(target, key, result);
  return result;
};
const _PurchaseOrderPayment = class _PurchaseOrderPayment2 extends Entity$1 {
  constructor(payment) {
    super(payment);
    if (payment) this.update(payment);
  }
  get canModify() {
    return this.admin != null;
  }
  update(product) {
    super.update(product);
  }
  static fromJson(json) {
    return new _PurchaseOrderPayment2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      paymentDate: json.paymentDate ? moment(json.paymentDate) : null,
      waitingForCaptureUntilDate: json.waitingForCaptureUntilDate ? moment(json.waitingForCaptureUntilDate) : null,
      purchaseOrder: json.purchaseOrder ? PurchaseOrder.fromJson(json.purchaseOrder) : void 0,
      paymentGateway: json.paymentGateway ? PaymentGateway.fromJson(json.paymentGateway) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0
    });
  }
};
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "amount", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "status", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "installmentStatus", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "currency", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "createdDate", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "paymentDate", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "waitingForCaptureUntilDate", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "errorMessage", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "additionalPaymentData", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "additionalPaymentMethodName", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "additionalPaymentMethodData", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "offSession", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "purchaseOrder", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "paymentGateway", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "admin", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "isManual", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "isTest", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "fee", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "income", 2);
__decorateClass$25([
  observable
], _PurchaseOrderPayment.prototype, "type", 2);
__decorateClass$25([
  computed
], _PurchaseOrderPayment.prototype, "canModify", 1);
let PurchaseOrderPayment = _PurchaseOrderPayment;
var HelpItemType = /* @__PURE__ */ ((HelpItemType2) => {
  HelpItemType2["Category"] = "category";
  HelpItemType2["Article"] = "article";
  return HelpItemType2;
})(HelpItemType || {});
var __defProp$22 = Object.defineProperty;
var __decorateClass$24 = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$22(target, key, result);
  return result;
};
const _HelpItemContent = class _HelpItemContent2 extends Designable {
  constructor(content2) {
    super(content2);
    if (content2) this.update(content2);
  }
  static fromJson(json) {
    return new _HelpItemContent2({
      ...json,
      item: json.item ? HelpItem.fromJson(json.item) : void 0,
      relatedArticles: json.relatedItemLinks ? json.relatedItemLinks.map((x) => _HelpItemContent2.fromJson(x.relatedHelpItemContent)) : []
    });
  }
  update(session, allowUndefined = false) {
    super.update(session, allowUndefined);
  }
};
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "title");
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "shortDescription");
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "isPublished");
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "language");
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "item");
__decorateClass$24([
  observable
], _HelpItemContent.prototype, "relatedArticles");
let HelpItemContent = _HelpItemContent;
var __defProp$21 = Object.defineProperty;
var __getOwnPropDesc$1S = Object.getOwnPropertyDescriptor;
var __decorateClass$23 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1S(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$21(target, key, result);
  return result;
};
const _HelpItem = class _HelpItem2 extends Entity$1 {
  constructor(helpItem) {
    super(helpItem);
    if (helpItem) this.update(helpItem);
  }
  getContent(lang) {
    return this.contents.find((x) => x.language == lang) ?? null;
  }
  update(session, allowUndefined = false) {
    super.update(session, allowUndefined);
  }
  get empty() {
    if (this.type == HelpItemType.Article) return false;
    return this.children.length == 0 || this.children.every((x) => x.empty);
  }
  get emptyContent() {
    return this.contents.length == 0;
  }
  static fromJson(json) {
    return new _HelpItem2({
      id: json.id,
      url: json.url,
      type: json.type,
      number: json.number,
      position: json.position,
      parentItem: json.parentItem ? _HelpItem2.fromJson(json.parentItem) : null,
      contents: json.contents ? json.contents.map(HelpItemContent.fromJson) : [],
      children: json.children ? json.children.map(_HelpItem2.fromJson) : []
    });
  }
};
__decorateClass$23([
  observable
], _HelpItem.prototype, "url", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "type", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "position", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "number", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "parentItem", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "children", 2);
__decorateClass$23([
  observable
], _HelpItem.prototype, "contents", 2);
__decorateClass$23([
  computed
], _HelpItem.prototype, "empty", 1);
__decorateClass$23([
  computed
], _HelpItem.prototype, "emptyContent", 1);
let HelpItem = _HelpItem;
var __defProp$20 = Object.defineProperty;
var __getOwnPropDesc$1R = Object.getOwnPropertyDescriptor;
var __decorateClass$22 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1R(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$20(target, key, result);
  return result;
};
const _WebinarDesignSettings = class _WebinarDesignSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
  hasChanges(settings) {
    return this.registration.hasChanges(settings.registration);
  }
  copy() {
    return new _WebinarDesignSettings2({
      registration: this.registration?.copy()
    });
  }
  static fromJson(json) {
    return new _WebinarDesignSettings2({
      ...json,
      registration: json.registration ? WebinarRegistrationDesignSettings.fromJson(json.registration) : void 0
    });
  }
};
__decorateClass$22([
  observable
], _WebinarDesignSettings.prototype, "registration", 2);
__decorateClass$22([
  action
], _WebinarDesignSettings.prototype, "update", 1);
let WebinarDesignSettings = _WebinarDesignSettings;
var __defProp$1$ = Object.defineProperty;
var __getOwnPropDesc$1Q = Object.getOwnPropertyDescriptor;
var __decorateClass$21 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1Q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1$(target, key, result);
  return result;
};
const _Webinar = class _Webinar2 extends Entity$1 {
  constructor(webinar) {
    super(webinar);
    this.closeRegistrationBeforeStart = false;
    this.closeRegistrationBeforeStartInHours = 0;
    if (webinar) this.update(webinar);
  }
  get resumeUntilDate() {
    if (!this.precompletedDate) return null;
    return this.precompletedDate.add(15, "minutes");
  }
  get status() {
    if (this.precompletedDate)
      return "completed";
    if (this.startedDate)
      return "inProgress";
    return "notStarted";
  }
  get startingIn() {
    if (this.status != "notStarted")
      return TimeSpan.zero;
    let diffMs = 0;
    if (this.scheduledDate.isAfter())
      diffMs = this.scheduledDate.diff(moment(), "milliseconds");
    else diffMs = moment().diff(this.scheduledDate, "milliseconds");
    return TimeSpan.fromMilliseconds(diffMs);
  }
  get startedAgo() {
    if (!this.startedDate)
      return TimeSpan.zero;
    const diffMs = moment().diff(this.startedDate, "milliseconds");
    return TimeSpan.fromMilliseconds(diffMs);
  }
  get scheduledDateUtc() {
    return moment(this.scheduledDate).utc();
  }
  get scheduledDateByTZ() {
    return moment(this.scheduledDateUtc).add(this.scheduledTimezone.offset.asMinutes(), "m");
  }
  get localScheduledDate() {
    return moment(this.scheduledDateUtc).add(moment().utcOffset(), "m");
  }
  get timeLeftBeforeStart() {
    return TimeSpan.fromMilliseconds(moment(this.scheduledDate).diff(moment()).valueOf());
  }
  get cuepoints() {
    return _Webinar2.generateCuepoints(this.currentDuration);
  }
  get isAuto() {
    return this.template != null;
  }
  get usesTemplateScenario() {
    return this.isAuto && !this.hasOwnScenario;
  }
  get hasActiveScenario() {
    if (this.usesTemplateScenario)
      return this.template?.scenario?.isActive ?? false;
    return this.scenario?.isActive ?? false;
  }
  get hasOwnScenario() {
    return this.scenario != null;
  }
  get hasSchedule() {
    return this.scheduleCron != null;
  }
  get hasComment() {
    return !lodashExports.isEmpty(this.comment);
  }
  get type() {
    if (this.isTemplate)
      return "template";
    if (this.template != null)
      return "auto";
    return "basic";
  }
  get canRedirectAfterCompletion() {
    return this.afterCompletionRedirect === true && !lodashExports.isEmpty(this.afterCompletionRedirectUrl);
  }
  get hasInternalName() {
    return !lodashExports.isEmpty(this.internalName);
  }
  static fromJson(json) {
    const webinar = new _Webinar2({
      id: json.id,
      name: json.name,
      internalName: json.internalName,
      softDeleted: json.softDeleted,
      shortName: json.shortName,
      description: json.description,
      comment: json.comment,
      afterword: json.afterword,
      userCount: json.userCount,
      number: json.number,
      isTemplate: json.isTemplate,
      useActiveAsNearest: json.useActiveAsNearest,
      closeRegistrationBeforeStart: json.closeRegistrationBeforeStart,
      closeRegistrationBeforeStartInHours: json.closeRegistrationBeforeStartInHours,
      afterCompletionRedirect: json.afterCompletionRedirect,
      afterCompletionRedirectUrl: json.afterCompletionRedirectUrl,
      // streamSources: json.streamSourcesJson ? JSON.parse(json.streamSourcesJson) : [],
      blockedIPs: json.blockedIPsJson ? JSON.parse(json.blockedIPsJson) : [],
      chatChannels: json.chatChannelsJson ? JSON.parse(json.chatChannelsJson) : [],
      // TODO need to convert scheduledDate to selected timezone by default
      scheduledDate: json.scheduledDate ? moment(json.scheduledDate) : void 0,
      scheduledTimezone: json.scheduledTimezone ? Timezone.fromJson(json.scheduledTimezone) : Timezone.utc(),
      scheduleCron: json.scheduleCron ? json.scheduleCron : void 0,
      scheduleCronTimezone: json.scheduleTimezone ? Timezone.fromJson(json.scheduleTimezone) : null,
      duration: json.duration ? TimeSpan.fromTicks(json.duration) : void 0,
      currentDuration: json.currentDurationMs ? TimeSpan.fromMs(json.currentDurationMs) : TimeSpan.zero,
      startedDate: json.startedDate ? moment(json.startedDate) : void 0,
      completedDate: json.completedDate ? moment(json.completedDate) : void 0,
      precompletedDate: json.precompletedDate ? moment(json.precompletedDate) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      template: json.template ? _Webinar2.fromJson(json.template) : void 0,
      source: json.source ? _Webinar2.fromJson(json.source) : void 0,
      registrationSettings: json.registrationSettingsJson ? WebinarRegistrationSettings.fromJson(JSON.parse(json.registrationSettingsJson)) : void 0,
      designSettings: json.designSettingsJson ? WebinarDesignSettings.fromJson(JSON.parse(json.designSettingsJson)) : void 0,
      roomSettings: json.roomSettingsJson ? WebinarRoomSettings.fromJson(JSON.parse(json.roomSettingsJson)) : void 0,
      integrationSettings: json.integrationSettingsJson ? WebinarIntegrationSettings.fromJson(JSON.parse(json.integrationSettingsJson)) : void 0,
      school: json.school ? School.fromJson(json.school) : void 0,
      siteDomain: json.siteDomain ? SiteDomain.fromJson(json.siteDomain) : null,
      contents: json.contents ? json.contents.map(WebinarContent.fromJson) : void 0,
      chatBot: json.chatBot ? ChatBot.fromJson(json.chatBot) : void 0,
      chatBots: json.chatBots,
      glossaries: json.glossaryLinks ? json.glossaryLinks.map((x) => Glossary.fromJson(x.glossary)) : void 0,
      useContactFilter: json.useContactFilter,
      contactFilter: new ExtendedFilter({ filterJson: json.contactFilterJson })
    });
    if (webinar.scenario) webinar.scenario.update({ webinar });
    return webinar;
  }
  static get cuepointPeriod() {
    return TimeSpan.fromSeconds(30);
  }
  static generateCuepoints(duration) {
    const cuepoints = [];
    let currentOffset = 0;
    while (currentOffset <= duration.seconds) {
      cuepoints.push(currentOffset);
      currentOffset += _Webinar2.cuepointPeriod.seconds;
    }
    return cuepoints;
  }
  clone(changes) {
    return new _Webinar2({
      id: this.id,
      name: this.name,
      internalName: this.internalName,
      number: this.number,
      shortName: this.shortName,
      description: this.description,
      comment: this.comment,
      afterword: this.afterword,
      scheduledDate: this.scheduledDate.clone(),
      scheduledTimezone: this.scheduledTimezone?.clone(),
      scheduleCron: this.scheduleCron,
      scheduleCronTimezone: this.scheduleCronTimezone?.clone(),
      duration: this.duration,
      blockedIPs: this.blockedIPs,
      siteDomain: this.siteDomain,
      isTemplate: this.isTemplate,
      afterCompletionRedirect: this.afterCompletionRedirect,
      afterCompletionRedirectUrl: this.afterCompletionRedirectUrl,
      useActiveAsNearest: this.useActiveAsNearest,
      closeRegistrationBeforeStart: this.closeRegistrationBeforeStart,
      closeRegistrationBeforeStartInHours: this.closeRegistrationBeforeStartInHours,
      contents: this.contents?.slice(),
      ...changes
    });
  }
  hasChanges(webinar) {
    return this.name != webinar.name || this.internalName != webinar.internalName || this.description != webinar.description || this.comment != webinar.comment || this.afterword != webinar.afterword || this.scheduledDate.toISOString() != webinar.scheduledDate.toISOString() || this.scheduledTimezone.id != webinar.scheduledTimezone.id || this.duration != webinar.duration || !this.blockedIPs.isEquals(webinar.blockedIPs) || this.shortName != webinar.shortName || this.siteDomain?.id != webinar.siteDomain?.id || this.afterCompletionRedirect != webinar.afterCompletionRedirect || this.afterCompletionRedirectUrl != webinar.afterCompletionRedirectUrl || this.useActiveAsNearest != webinar.useActiveAsNearest || this.closeRegistrationBeforeStart != webinar.closeRegistrationBeforeStart || this.closeRegistrationBeforeStartInHours != webinar.closeRegistrationBeforeStartInHours;
  }
  update(webinar, allowUndefined = false) {
    super.update(webinar, allowUndefined);
  }
};
__decorateClass$21([
  observable
], _Webinar.prototype, "name", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "internalName", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "shortName", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "number", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "description", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "comment", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "afterword", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "school", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "template", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "source", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "isTemplate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "useActiveAsNearest", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "closeRegistrationBeforeStart", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "closeRegistrationBeforeStartInHours", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "afterCompletionRedirect", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "afterCompletionRedirectUrl", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "scheduledDate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "scheduledTimezone", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "scheduleCron", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "scheduleCronTimezone", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "duration", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "currentDuration", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "startedDate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "precompletedDate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "completedDate", 2);
__decorateClass$21([
  computed
], _Webinar.prototype, "resumeUntilDate", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "status", 1);
__decorateClass$21([
  observable
], _Webinar.prototype, "blockedIPs", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "chatChannels", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "userCount", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "scenario", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "siteDomain", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "createdDate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "updatedDate", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "registrationSettings", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "designSettings", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "roomSettings", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "integrationSettings", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "contents", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "chatBot", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "chatBots", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "glossaries", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "useContactFilter", 2);
__decorateClass$21([
  observable
], _Webinar.prototype, "contactFilter", 2);
__decorateClass$21([
  computed
], _Webinar.prototype, "scheduledDateUtc", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "scheduledDateByTZ", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "localScheduledDate", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "timeLeftBeforeStart", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "cuepoints", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "isAuto", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "usesTemplateScenario", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "hasActiveScenario", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "hasOwnScenario", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "hasSchedule", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "hasComment", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "type", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "canRedirectAfterCompletion", 1);
__decorateClass$21([
  computed
], _Webinar.prototype, "hasInternalName", 1);
__decorateClass$21([
  action
], _Webinar.prototype, "update", 1);
let Webinar = _Webinar;
var __defProp$1_ = Object.defineProperty;
var __getOwnPropDesc$1P = Object.getOwnPropertyDescriptor;
var __decorateClass$20 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1P(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1_(target, key, result);
  return result;
};
const _WebinarRegistrationSettings = class _WebinarRegistrationSettings2 extends Updatable {
  constructor(settings) {
    super();
    this.fields = [];
    if (settings) this.update(settings);
  }
  get needEmailConfirmation() {
    const email2 = this.email;
    return email2 != null && email2.required && email2.settings?.confirmation;
  }
  get email() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.Email);
  }
  get hasEmailField() {
    return this.email != void 0;
  }
  get phone() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.Phone);
  }
  get firstName() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.FirstName);
  }
  get lastName() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.LastName);
  }
  get birthday() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.Birthday);
  }
  get gender() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.Gender);
  }
  get termsOfService() {
    return this.fields.find((i) => i.type == WebinarRegistrationFieldType.TermOfService);
  }
  update(settings) {
    super.update(settings);
  }
  hasChanges(settings) {
    if (this.fields.length != settings.fields.length)
      return true;
    let index2 = 0;
    for (const field of this.fields) {
      const compareFieldIndex = settings.fields.findIndex((i) => i.type == field.type);
      if (compareFieldIndex < 0 || index2 != compareFieldIndex)
        return true;
      if (field.hasChanged(settings.fields[compareFieldIndex]))
        return true;
      index2++;
    }
    return false;
  }
  copy() {
    return new _WebinarRegistrationSettings2({
      ...this,
      fields: this.fields.map((i) => i.copy())
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationSettings2({
      ...json,
      fields: json.fields ? json.fields.map((i) => {
        switch (i.type) {
          case WebinarRegistrationFieldType.Email:
            return WebinarRegistrationEmailField.fromJson(i);
          case WebinarRegistrationFieldType.TermOfService:
            return WebinarRegistrationTermOfServiceField.fromJson(i);
          default:
            return WebinarRegistrationField.fromJson(i);
        }
      }) : []
    });
  }
};
__decorateClass$20([
  observable
], _WebinarRegistrationSettings.prototype, "fields", 2);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "needEmailConfirmation", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "email", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "hasEmailField", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "phone", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "firstName", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "lastName", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "birthday", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "gender", 1);
__decorateClass$20([
  computed
], _WebinarRegistrationSettings.prototype, "termsOfService", 1);
__decorateClass$20([
  action
], _WebinarRegistrationSettings.prototype, "update", 1);
let WebinarRegistrationSettings = _WebinarRegistrationSettings;
var __defProp$1Z = Object.defineProperty;
var __getOwnPropDesc$1O = Object.getOwnPropertyDescriptor;
var __decorateClass$1$ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1O(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1Z(target, key, result);
  return result;
};
const _WebinarRegistrationDesignSettings = class _WebinarRegistrationDesignSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
  hasChanges(settings) {
    return this.backgroundColor != settings.backgroundColor || this.textColor != settings.textColor || this.buttonTextColor != settings.buttonTextColor || this.buttonText != settings.buttonText || this.buttonBackgroundColor != settings.buttonBackgroundColor || this.logoUrl != settings.logoUrl || this.coverUrl != settings.coverUrl;
  }
  copy() {
    return new _WebinarRegistrationDesignSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationDesignSettings2({
      ...json
    });
  }
};
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "backgroundColor", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "textColor", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "buttonBackgroundColor", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "buttonTextColor", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "buttonText", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "logoUrl", 2);
__decorateClass$1$([
  observable
], _WebinarRegistrationDesignSettings.prototype, "coverUrl", 2);
__decorateClass$1$([
  action
], _WebinarRegistrationDesignSettings.prototype, "update", 1);
let WebinarRegistrationDesignSettings = _WebinarRegistrationDesignSettings;
var __defProp$1Y = Object.defineProperty;
var __getOwnPropDesc$1N = Object.getOwnPropertyDescriptor;
var __decorateClass$1_ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1N(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1Y(target, key, result);
  return result;
};
const _WebinarRoomSettings = class _WebinarRoomSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get questionsDelay() {
    return TimeSpan.fromMilliseconds(this.questionsDelayMs);
  }
  update(settings) {
    super.update(settings);
  }
  hasChanges(settings) {
    return this.enableChat != settings.enableChat || this.hideParticipantLastName != settings.hideParticipantLastName || this.denyMultipleTabs != settings.denyMultipleTabs || this.enableQuestions != settings.enableQuestions || this.enableQuestionsDelay != settings.enableQuestionsDelay || this.questionsDelayMs != settings.questionsDelayMs || this.blockGuestLinks != settings.blockGuestLinks || this.hideParticipantsCounter != settings.hideParticipantsCounter || this.enableChatGlossariesStopWords != settings.enableChatGlossariesStopWords;
  }
  copy() {
    return new _WebinarRoomSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarRoomSettings2({
      enableChat: json.enableChat,
      hideParticipantLastName: json.hideParticipantLastName,
      denyMultipleTabs: json.denyMultipleTabs,
      enableQuestions: json.enableQuestions,
      enableQuestionsDelay: json.enableQuestionsDelay,
      questionsDelayMs: json.questionsDelayMs,
      blockGuestLinks: json.blockGuestLinks,
      hideParticipantsCounter: json.hideParticipantsCounter,
      enableChatGlossariesStopWords: json.enableChatGlossariesStopWords
    });
  }
};
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "enableChat", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "blockGuestLinks", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "hideParticipantLastName", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "hideParticipantsCounter", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "denyMultipleTabs", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "enableQuestions", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "enableQuestionsDelay", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "questionsDelayMs", 2);
__decorateClass$1_([
  observable
], _WebinarRoomSettings.prototype, "enableChatGlossariesStopWords", 2);
__decorateClass$1_([
  computed
], _WebinarRoomSettings.prototype, "questionsDelay", 1);
__decorateClass$1_([
  action
], _WebinarRoomSettings.prototype, "update", 1);
let WebinarRoomSettings = _WebinarRoomSettings;
var __defProp$1X = Object.defineProperty;
var __getOwnPropDesc$1M = Object.getOwnPropertyDescriptor;
var __decorateClass$1Z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1M(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1X(target, key, result);
  return result;
};
const _WebinarIntegrationSettings = class _WebinarIntegrationSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings) {
    super.update(settings);
  }
  hasChanges(settings) {
    return this.headerScript != settings.headerScript || this.bodyScript != settings.bodyScript;
  }
  copy() {
    return new _WebinarIntegrationSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarIntegrationSettings2({
      ...json
    });
  }
};
__decorateClass$1Z([
  observable
], _WebinarIntegrationSettings.prototype, "headerScript", 2);
__decorateClass$1Z([
  observable
], _WebinarIntegrationSettings.prototype, "bodyScript", 2);
__decorateClass$1Z([
  action
], _WebinarIntegrationSettings.prototype, "update", 1);
let WebinarIntegrationSettings = _WebinarIntegrationSettings;
var __defProp$1W = Object.defineProperty;
var __getOwnPropDesc$1L = Object.getOwnPropertyDescriptor;
var __decorateClass$1Y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1L(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1W(target, key, result);
  return result;
};
const _WebinarUser = class _WebinarUser2 extends User {
  constructor(webinar) {
    super(webinar);
    if (webinar) this.update(webinar);
  }
  update(webinar, allowUndefined = false) {
    super.update(webinar, allowUndefined);
  }
  static fromJson(json) {
    return new _WebinarUser2({
      ...json,
      cuepoints: json.cuepoints ?? [],
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      school: json.school ? School.fromJson(json.school) : null,
      webinar: json.webinar ? Webinar.fromJson(json.webinar) : null,
      viewDuration: json.viewDuration ? TimeSpan.fromTicks(json.viewDuration) : void 0,
      chatChannel: json.chatChannel ? ChatChannel.fromJson(json.chatChannel) : void 0,
      chatChannels: json.chatChannels ? json.chatChannels.map(ChatChannel.fromJson) : [],
      partner: json.partner ? Contact.fromJson(json.partner) : void 0
    });
  }
};
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "role", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "contactId", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "createdDate", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "updatedDate", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "isBlocked", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "isMuted", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "isChatBlocked", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "cuepoints", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "viewDuration", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "presencePercent", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "school", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "initialSiteGuestSessionId", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "webinar", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "chatChannel", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "chatChannels", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "isTeamMember", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "loginLink", 2);
__decorateClass$1Y([
  observable
], _WebinarUser.prototype, "partner", 2);
__decorateClass$1Y([
  action
], _WebinarUser.prototype, "update", 1);
var __defProp$1V = Object.defineProperty;
var __getOwnPropDesc$1K = Object.getOwnPropertyDescriptor;
var __decorateClass$1X = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1K(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1V(target, key, result);
  return result;
};
const _WebinarRegistrationField = class _WebinarRegistrationField2 extends Updatable {
  constructor(field) {
    super();
    if (field) this.update(field);
  }
  update(settings) {
    super.update(settings);
  }
  get hasSettings() {
    return false;
  }
  get isEditable() {
    return this.type != WebinarRegistrationFieldType.FirstName && this.type != WebinarRegistrationFieldType.TermOfService;
  }
  get isDeletable() {
    return this.type != WebinarRegistrationFieldType.FirstName;
  }
  hasChanged(field) {
    return this.required != field.required || this.type != field.type;
  }
  copy() {
    return new _WebinarRegistrationField2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationField2({
      ...json
    });
  }
};
__decorateClass$1X([
  observable
], _WebinarRegistrationField.prototype, "type", 2);
__decorateClass$1X([
  observable
], _WebinarRegistrationField.prototype, "required", 2);
__decorateClass$1X([
  action
], _WebinarRegistrationField.prototype, "update", 1);
let WebinarRegistrationField = _WebinarRegistrationField;
var __defProp$1U = Object.defineProperty;
var __getOwnPropDesc$1J = Object.getOwnPropertyDescriptor;
var __decorateClass$1W = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1J(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1U(target, key, result);
  return result;
};
const _WebinarRegistrationEmailFieldSettings = class _WebinarRegistrationEmailFieldSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings) {
    super.update(settings);
  }
  hasChanged(settings) {
    return this.confirmation != settings.confirmation;
  }
  copy() {
    return new _WebinarRegistrationEmailFieldSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationEmailFieldSettings2({
      ...json
    });
  }
};
__decorateClass$1W([
  observable
], _WebinarRegistrationEmailFieldSettings.prototype, "confirmation", 2);
__decorateClass$1W([
  action
], _WebinarRegistrationEmailFieldSettings.prototype, "update", 1);
let WebinarRegistrationEmailFieldSettings = _WebinarRegistrationEmailFieldSettings;
var __defProp$1T = Object.defineProperty;
var __getOwnPropDesc$1I = Object.getOwnPropertyDescriptor;
var __decorateClass$1V = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1I(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1T(target, key, result);
  return result;
};
const _WebinarRegistrationEmailField = class _WebinarRegistrationEmailField2 extends WebinarRegistrationField {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings) {
    super.update(settings);
  }
  get hasSettings() {
    return true;
  }
  hasChanged(field) {
    return super.hasChanged(field) || this.settings.hasChanged(field.settings);
  }
  copy() {
    return new _WebinarRegistrationEmailField2({
      ...this,
      settings: this.settings?.copy()
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationEmailField2({
      ...json,
      settings: json.settings ? WebinarRegistrationEmailFieldSettings.fromJson(json.settings) : void 0
    });
  }
};
__decorateClass$1V([
  observable
], _WebinarRegistrationEmailField.prototype, "settings", 2);
__decorateClass$1V([
  action
], _WebinarRegistrationEmailField.prototype, "update", 1);
let WebinarRegistrationEmailField = _WebinarRegistrationEmailField;
var __defProp$1S = Object.defineProperty;
var __getOwnPropDesc$1H = Object.getOwnPropertyDescriptor;
var __decorateClass$1U = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1S(target, key, result);
  return result;
};
const _WebinarRegistrationTermOfServiceFieldSettings = class _WebinarRegistrationTermOfServiceFieldSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings, allowUndefined = false) {
    super.update(settings, allowUndefined);
  }
  hasChanged(settings) {
    return this.text != settings.text || this.termsDefaultAccepted != settings.termsDefaultAccepted;
  }
  copy() {
    return new _WebinarRegistrationTermOfServiceFieldSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationTermOfServiceFieldSettings2({
      ...json
    });
  }
};
__decorateClass$1U([
  observable
], _WebinarRegistrationTermOfServiceFieldSettings.prototype, "terms", 2);
__decorateClass$1U([
  observable
], _WebinarRegistrationTermOfServiceFieldSettings.prototype, "text", 2);
__decorateClass$1U([
  observable
], _WebinarRegistrationTermOfServiceFieldSettings.prototype, "termsDefaultAccepted", 2);
__decorateClass$1U([
  action
], _WebinarRegistrationTermOfServiceFieldSettings.prototype, "update", 1);
let WebinarRegistrationTermOfServiceFieldSettings = _WebinarRegistrationTermOfServiceFieldSettings;
var __defProp$1R = Object.defineProperty;
var __getOwnPropDesc$1G = Object.getOwnPropertyDescriptor;
var __decorateClass$1T = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1R(target, key, result);
  return result;
};
const _WebinarRegistrationTermOfServiceField = class _WebinarRegistrationTermOfServiceField2 extends WebinarRegistrationField {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(settings) {
    super.update(settings);
  }
  get hasSettings() {
    return true;
  }
  hasChanged(field) {
    return super.hasChanged(field) || this.settings.hasChanged(field.settings);
  }
  copy() {
    return new _WebinarRegistrationTermOfServiceField2({
      ...this,
      settings: this.settings?.copy()
    });
  }
  static fromJson(json) {
    return new _WebinarRegistrationTermOfServiceField2({
      ...json,
      settings: json.settings ? WebinarRegistrationTermOfServiceFieldSettings.fromJson(json.settings) : void 0
    });
  }
};
__decorateClass$1T([
  observable
], _WebinarRegistrationTermOfServiceField.prototype, "settings", 2);
__decorateClass$1T([
  action
], _WebinarRegistrationTermOfServiceField.prototype, "update", 1);
let WebinarRegistrationTermOfServiceField = _WebinarRegistrationTermOfServiceField;
var __defProp$1Q = Object.defineProperty;
var __decorateClass$1S = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1Q(target, key, result);
  return result;
};
const _WebinarContent = class _WebinarContent2 extends Entity$1 {
  constructor(file) {
    super(file);
    if (file) this.update(file);
  }
  static fromJson(json) {
    return new _WebinarContent2({
      id: json.id,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      file: json.file ? AccelFile.fromJson(json.file) : void 0,
      type: json.type,
      url: json.url,
      conversion: json.conversion ? AccelFileConversion.fromJson(json.conversion) : void 0,
      widget: json.widget ? Widget.fromJson(json.widget) : void 0,
      video: json.video ? Video$1.fromJson(json.video) : void 0
    });
  }
  update(file, allowUndefined = false) {
    super.update(file, allowUndefined);
  }
};
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "createdDate");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "file");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "type");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "conversion");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "url");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "widget");
__decorateClass$1S([
  observable
], _WebinarContent.prototype, "video");
let WebinarContent = _WebinarContent;
var __defProp$1P = Object.defineProperty;
var __getOwnPropDesc$1F = Object.getOwnPropertyDescriptor;
var __decorateClass$1R = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1P(target, key, result);
  return result;
};
const _VideoSettings = class _VideoSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  updateWatermark(watermark) {
    this.watermark = { ...this.watermark, ...watermark };
  }
  update(changes, allowUndefined = false) {
    super.update(changes, allowUndefined);
  }
  toJson() {
    return toJS({
      watermark: this.watermark
    });
  }
  clone() {
    return new _VideoSettings2({
      ...this
    });
  }
  hasChanges(settings) {
    return this.watermark?.enabled != settings.watermark?.enabled || this.watermark?.frequencyDelayInSec != settings.watermark?.frequencyDelayInSec;
  }
  static default() {
    return new _VideoSettings2({
      watermark: { enabled: false, frequencyDelayInSec: 30 }
    });
  }
  static fromJson(json) {
    const def = _VideoSettings2.default();
    return new _VideoSettings2({
      watermark: json.watermark || def.watermark
    });
  }
};
__decorateClass$1R([
  observable
], _VideoSettings.prototype, "watermark", 2);
__decorateClass$1R([
  action
], _VideoSettings.prototype, "updateWatermark", 1);
__decorateClass$1R([
  action
], _VideoSettings.prototype, "update", 1);
let VideoSettings = _VideoSettings;
const _Video = class _Video2 extends Entity$1 {
  constructor(video) {
    super(video);
    if (video) this.update(video);
  }
  update(changes, allowUndefined = false) {
    super.update(changes, allowUndefined);
  }
  clone() {
    return new _Video2({
      ...this,
      currentVideoStream: this.currentVideoStream?.clone(),
      primaryImage: this.primaryImage?.clone(),
      settings: this.settings?.clone()
    });
  }
  hasChanges(video) {
    return this.name !== video.name || this.shortDescription !== video.shortDescription || this.lang !== video.lang || this.settings.hasChanges(video.settings);
  }
  static fromJson(json) {
    return new _Video2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      currentVideoStream: json.currentVideoStream ? VideoStream.fromJson(json.currentVideoStream) : void 0,
      primaryImage: json.primaryImage?.file ? AccelFile.fromJson(json.primaryImage.file) : void 0,
      primaryImageFileId: json.primaryImage?.file?.id ? json.primaryImage.file.id : void 0,
      access: json.videoAccess ? VideoAccess.fromJson(json.videoAccess) : null,
      breadcrumbs: json.path,
      settings: json.settingsJson ? VideoSettings.fromJson(JSON.parse(json.settingsJson)) : VideoSettings.default()
    });
  }
};
__decorateClass$1R([
  observable
], _Video.prototype, "name", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "shortDescription", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "lang", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "viewsCount", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "createdDate", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "updatedDate", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "isNotCompletedStreamExist", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "currentVideoStream", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "primaryImage", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "primaryImageFileId", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "accessAnywhere", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "access", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "breadcrumbs", 2);
__decorateClass$1R([
  observable
], _Video.prototype, "settings", 2);
__decorateClass$1R([
  action
], _Video.prototype, "update", 1);
let Video$1 = _Video;
var __defProp$1O = Object.defineProperty;
var __getOwnPropDesc$1E = Object.getOwnPropertyDescriptor;
var __decorateClass$1Q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1O(target, key, result);
  return result;
};
const _VideoStream = class _VideoStream2 extends Entity$1 {
  constructor(videoStream) {
    super(videoStream);
    if (videoStream) this.update(videoStream);
  }
  get isUploading() {
    return this.state == "cloudUploading";
  }
  get isInProgress() {
    return this.state == "cloudUploading" || this.state == "cloudUploaded" || this.state == "downloading" || this.state == "providerUploading" || this.state == "providerUploaded" || this.state == "converting";
  }
  get hasError() {
    return this.state == "failure" || this.state == "aborted";
  }
  get isCompleted() {
    return this.state == "completed";
  }
  update(videoStream, allowUndefined = false) {
    super.update(videoStream, allowUndefined);
  }
  clone() {
    return new _VideoStream2({
      ...this
    });
  }
  static fromJson(json) {
    return new _VideoStream2({
      ...json,
      duration: json.duration ? TimeSpan.fromSeconds(json.duration) : void 0,
      file: json.file ? AccelFile.fromJson(json.file) : void 0,
      storyboard: json.storyboard ? AccelFile.fromJson(json.storyboard) : void 0,
      video: json.video ? Video$1.fromJson(json.video) : void 0,
      createdByAdmin: json.createdByAdmin ? Admin.fromJson(json.createdByAdmin) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      images: json.images ? json.images.map((x) => AccelFile.fromJson(x.file)) : []
    });
  }
};
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "file", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "video", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "duration", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "originalSize", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "progress", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "width", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "height", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "mp4", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "dash", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "hlsfmp4", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "hls", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "providerId", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "state", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "subState", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "errorMessage", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "createdDate", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "storyboard", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "createdByAdmin", 2);
__decorateClass$1Q([
  observable
], _VideoStream.prototype, "images", 2);
__decorateClass$1Q([
  action
], _VideoStream.prototype, "update", 1);
let VideoStream = _VideoStream;
var __defProp$1N = Object.defineProperty;
var __getOwnPropDesc$1D = Object.getOwnPropertyDescriptor;
var __decorateClass$1P = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1D(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1N(target, key, result);
  return result;
};
const _VideoDomain = class _VideoDomain2 extends Entity$1 {
  constructor(videoDomain) {
    super();
    if (videoDomain) this.update(videoDomain);
  }
  update(accessDomain) {
    super.update(accessDomain);
  }
  static fromJson(json) {
    return new _VideoDomain2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
};
__decorateClass$1P([
  observable
], _VideoDomain.prototype, "text", 2);
__decorateClass$1P([
  observable
], _VideoDomain.prototype, "createdDate", 2);
__decorateClass$1P([
  observable
], _VideoDomain.prototype, "updatedDate", 2);
__decorateClass$1P([
  action
], _VideoDomain.prototype, "update", 1);
let VideoDomain = _VideoDomain;
var __defProp$1M = Object.defineProperty;
var __getOwnPropDesc$1C = Object.getOwnPropertyDescriptor;
var __decorateClass$1O = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1M(target, key, result);
  return result;
};
const _VideoAccess = class _VideoAccess2 extends Entity$1 {
  constructor(access) {
    super();
    if (access) this.update(access);
  }
  update(access) {
    super.update(access);
  }
  static fromJson(json) {
    return new _VideoAccess2({
      ...json,
      domains: json.videoAccessDomainLinks ? json.videoAccessDomainLinks.map((i) => VideoDomain.fromJson(i.videoDomain)) : [],
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
};
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "coursesAccess", 2);
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "sitesAccess", 2);
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "linkAccess", 2);
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "createdDate", 2);
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "updatedDate", 2);
__decorateClass$1O([
  observable
], _VideoAccess.prototype, "domains", 2);
__decorateClass$1O([
  action
], _VideoAccess.prototype, "update", 1);
let VideoAccess = _VideoAccess;
var __defProp$1L = Object.defineProperty;
var __getOwnPropDesc$1B = Object.getOwnPropertyDescriptor;
var __decorateClass$1N = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1L(target, key, result);
  return result;
};
const _Widget = class _Widget2 extends Designable {
  constructor(widget) {
    super(widget);
    if (widget) this.update(widget);
  }
  static fromJson(json) {
    const widget = new _Widget2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      createdByAdmin: json.createdByAdmin ? Admin.fromJson(json.createdByAdmin) : void 0,
      updatedByAdmin: json.updatedByAdmin ? Admin.fromJson(json.updatedByAdmin) : void 0
    });
    if (widget.scenario) widget.scenario.update({ widget });
    return widget;
  }
  update(widget) {
    super.update(widget);
  }
};
__decorateClass$1N([
  observable
], _Widget.prototype, "name", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "description", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "viewCount", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "createdDate", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "createdByAdmin", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "updatedDate", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "updatedByAdmin", 2);
__decorateClass$1N([
  observable
], _Widget.prototype, "scenario", 2);
__decorateClass$1N([
  action
], _Widget.prototype, "update", 1);
let Widget = _Widget;
var __defProp$1K = Object.defineProperty;
var __getOwnPropDesc$1A = Object.getOwnPropertyDescriptor;
var __decorateClass$1M = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1K(target, key, result);
  return result;
};
const _ExternalImport = class _ExternalImport2 extends Entity$1 {
  constructor(externalImport) {
    super(externalImport);
    if (externalImport) this.update(externalImport);
  }
  static fromJson(json) {
    return new _ExternalImport2({
      ...json,
      file: json.file ? AccelFile.fromJson(json.file) : void 0,
      createdByAdmin: json.createdByAdmin ? Admin.fromJson(json.createdByAdmin) : void 0,
      updatedByAdmin: json.updatedByAdmin ? Admin.fromJson(json.updatedByAdmin) : void 0,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
  update(externalImport) {
    super.update(externalImport);
  }
};
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "totalCount", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "processedCount", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "error", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "state", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "source", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "lastImportedEntity", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "createdDate", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "updatedDate", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "file", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "createdByAdmin", 2);
__decorateClass$1M([
  observable
], _ExternalImport.prototype, "updatedByAdmin", 2);
__decorateClass$1M([
  action
], _ExternalImport.prototype, "update", 1);
var __defProp$1J = Object.defineProperty;
var __decorateClass$1L = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1J(target, key, result);
  return result;
};
const _BaseChannelSettings = class _BaseChannelSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get isValid() {
    return !isEmpty(this.accessToken);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return this.accessToken !== settings.accessToken;
  }
  clone() {
    return new _BaseChannelSettings2(this);
  }
};
__decorateClass$1L([
  observable
], _BaseChannelSettings.prototype, "accessToken");
let BaseChannelSettings = _BaseChannelSettings;
var __defProp$1I = Object.defineProperty;
var __decorateClass$1K = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1I(target, key, result);
  return result;
};
const _FbChannelSettings = class _FbChannelSettings2 extends BaseChannelSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasPage;
  }
  get hasPage() {
    return !isEmpty(this.pageId) && !isEmpty(this.pageName);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.pageId !== settings.pageId;
  }
  clone() {
    return new _FbChannelSettings2(this);
  }
};
__decorateClass$1K([
  observable
], _FbChannelSettings.prototype, "pageId");
__decorateClass$1K([
  observable
], _FbChannelSettings.prototype, "pageName");
let FbChannelSettings = _FbChannelSettings;
var __defProp$1H = Object.defineProperty;
var __decorateClass$1J = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1H(target, key, result);
  return result;
};
const _VkChannelSettings = class _VkChannelSettings2 extends BaseChannelSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasGroup;
  }
  get hasGroup() {
    return !isEmpty(this.groupName) && this.groupId > 0;
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.groupId !== settings.groupId;
  }
  clone() {
    return new _VkChannelSettings2(this);
  }
};
__decorateClass$1J([
  observable
], _VkChannelSettings.prototype, "groupId");
__decorateClass$1J([
  observable
], _VkChannelSettings.prototype, "groupName");
let VkChannelSettings = _VkChannelSettings;
var __defProp$1G = Object.defineProperty;
var __getOwnPropDesc$1z = Object.getOwnPropertyDescriptor;
var __decorateClass$1I = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1G(target, key, result);
  return result;
};
const _Wazzup24Channel = class _Wazzup24Channel2 extends Entity$1 {
  constructor(channel) {
    super();
    if (channel) this.update(channel);
  }
  get chatType() {
    switch (this.transportType) {
      case "whatsapp":
      case "wapi":
        return "whatsapp";
      case "telegram":
      case "tgapi":
        return "telegram";
      case "instagram":
        return "instagram";
      case "vk":
        return "vk";
      default:
        return "telegram";
    }
  }
  static fromJson(json) {
    return new _Wazzup24Channel2({
      ...json
    });
  }
  update(channel) {
    super.update(channel);
  }
};
__decorateClass$1I([
  observable
], _Wazzup24Channel.prototype, "name", 2);
__decorateClass$1I([
  observable
], _Wazzup24Channel.prototype, "plainId", 2);
__decorateClass$1I([
  observable
], _Wazzup24Channel.prototype, "transportType", 2);
__decorateClass$1I([
  computed
], _Wazzup24Channel.prototype, "chatType", 1);
let Wazzup24Channel = _Wazzup24Channel;
const _Wazzup24ChannelSettings = class _Wazzup24ChannelSettings2 extends BaseChannelSettings {
  get chatType() {
    switch (this.transportType) {
      case "whatsapp":
      case "wapi":
        return "whatsapp";
      case "telegram":
      case "tgapi":
        return "telegram";
      case "instagram":
        return "instagram";
      case "vk":
        return "vk";
      default:
        return "telegram";
    }
  }
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get channel() {
    if (!this.hasChannel) return null;
    return new Wazzup24Channel({
      id: this.channelId,
      name: this.channelName,
      plainId: this.plainId,
      transportType: this.transportType
    });
  }
  set channel(channel) {
    if (!channel) return;
    runInAction(() => {
      this.channelName = channel.name;
      this.channelId = channel.id;
      this.plainId = channel.plainId;
      this.transportType = channel.transportType;
    });
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasChannel;
  }
  get hasChannel() {
    return !isEmpty(this.channelId) && !isEmpty(this.plainId);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.channelId != settings.channelId || this.plainId != settings.plainId || this.channelName != settings.channelName || this.transportType != settings.transportType;
  }
  clone() {
    return new _Wazzup24ChannelSettings2(this);
  }
};
__decorateClass$1I([
  observable
], _Wazzup24ChannelSettings.prototype, "channelName", 2);
__decorateClass$1I([
  observable
], _Wazzup24ChannelSettings.prototype, "channelId", 2);
__decorateClass$1I([
  observable
], _Wazzup24ChannelSettings.prototype, "plainId", 2);
__decorateClass$1I([
  observable
], _Wazzup24ChannelSettings.prototype, "transportType", 2);
__decorateClass$1I([
  computed
], _Wazzup24ChannelSettings.prototype, "chatType", 1);
let Wazzup24ChannelSettings = _Wazzup24ChannelSettings;
var __defProp$1F = Object.defineProperty;
var __getOwnPropDesc$1y = Object.getOwnPropertyDescriptor;
var __decorateClass$1H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1F(target, key, result);
  return result;
};
const _WhatsAppPhoneNumber = class _WhatsAppPhoneNumber2 extends Entity$1 {
  constructor(channel) {
    super();
    if (channel) this.update(channel);
  }
  static fromJson(json) {
    return new _WhatsAppPhoneNumber2({
      ...json
    });
  }
  update(channel) {
    super.update(channel);
  }
};
__decorateClass$1H([
  observable
], _WhatsAppPhoneNumber.prototype, "verifiedName", 2);
__decorateClass$1H([
  observable
], _WhatsAppPhoneNumber.prototype, "displayPhoneNumber", 2);
__decorateClass$1H([
  observable
], _WhatsAppPhoneNumber.prototype, "qualityRating", 2);
let WhatsAppPhoneNumber = _WhatsAppPhoneNumber;
const _WhatsAppChannelSettings = class _WhatsAppChannelSettings2 extends BaseChannelSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get phone() {
    if (!this.hasPhoneNumber) return null;
    return new WhatsAppPhoneNumber({
      id: this.phoneNumberId,
      displayPhoneNumber: this.phoneNumber
    });
  }
  set phone(phone) {
    if (!phone) return;
    runInAction(() => {
      this.phoneNumberId = phone.id;
      this.phoneNumber = phone.displayPhoneNumber;
    });
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasAccount;
  }
  get hasAccount() {
    return !isEmpty(this.accountId) && this.hasPhoneNumber;
  }
  get hasPhoneNumber() {
    return !isEmpty(this.phoneNumberId) && !isEmpty(this.phoneNumber);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.accountId != settings.accountId || this.phoneNumberId != settings.phoneNumberId;
  }
  clone() {
    return new _WhatsAppChannelSettings2(this);
  }
};
__decorateClass$1H([
  observable
], _WhatsAppChannelSettings.prototype, "accountId", 2);
__decorateClass$1H([
  observable
], _WhatsAppChannelSettings.prototype, "phoneNumberId", 2);
__decorateClass$1H([
  observable
], _WhatsAppChannelSettings.prototype, "phoneNumber", 2);
__decorateClass$1H([
  computed
], _WhatsAppChannelSettings.prototype, "isValid", 1);
__decorateClass$1H([
  computed
], _WhatsAppChannelSettings.prototype, "hasAccount", 1);
__decorateClass$1H([
  computed
], _WhatsAppChannelSettings.prototype, "hasPhoneNumber", 1);
let WhatsAppChannelSettings = _WhatsAppChannelSettings;
var __defProp$1E = Object.defineProperty;
var __decorateClass$1G = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1E(target, key, result);
  return result;
};
const _InstagramChannelSettings = class _InstagramChannelSettings2 extends BaseChannelSettings {
  constructor(settings) {
    super();
    this.ignorePrivateConversations = false;
    if (settings) this.update(settings);
  }
  hasPermissions(permissions) {
    if (!this.permissions) return false;
    return permissions.every((x) => this.permissions.includes(x));
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasPage && this.hasAccount;
  }
  get hasPage() {
    return !isEmpty(this.pageId) && !isEmpty(this.pageName);
  }
  get hasAccount() {
    return !isEmpty(this.accountId) && !isEmpty(this.accountUsername);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.pageId !== settings.pageId || this.accountId !== settings.accountId || this.ignorePrivateConversations !== settings.ignorePrivateConversations;
  }
  clone() {
    return new _InstagramChannelSettings2(this);
  }
};
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "pageId");
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "pageName");
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "accountId");
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "accountUsername");
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "ignorePrivateConversations");
__decorateClass$1G([
  observable
], _InstagramChannelSettings.prototype, "permissions");
let InstagramChannelSettings = _InstagramChannelSettings;
var __defProp$1D = Object.defineProperty;
var __decorateClass$1F = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1D(target, key, result);
  return result;
};
const _LineChannelSettings = class _LineChannelSettings2 extends BaseChannelSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && !isEmpty(this.secret) && !isEmpty(this.channelId);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  hasChanges(settings) {
    return super.hasChanges(settings) || this.channelId !== settings.channelId || this.secret !== settings.secret;
  }
  clone() {
    return new _LineChannelSettings2(this);
  }
};
__decorateClass$1F([
  observable
], _LineChannelSettings.prototype, "secret");
__decorateClass$1F([
  observable
], _LineChannelSettings.prototype, "channelId");
let LineChannelSettings = _LineChannelSettings;
class ChatChannelSettingsFactory {
  static build(type4, settingsJson) {
    const settings = settingsJson ? JSON.parse(settingsJson) : {};
    switch (type4) {
      case ChatChannelType.Vk:
        return new VkChannelSettings(settings);
      case ChatChannelType.Fb:
        return new FbChannelSettings(settings);
      case ChatChannelType.Wazzup24:
        return new Wazzup24ChannelSettings(settings);
      case ChatChannelType.Wa:
        return new WhatsAppChannelSettings(settings);
      case ChatChannelType.Ig:
        return new InstagramChannelSettings(settings);
      case ChatChannelType.Line:
        return new LineChannelSettings(settings);
      case ChatChannelType.Tg:
      case ChatChannelType.Vb:
      default:
        return new BaseChannelSettings(settings);
    }
  }
}
var __defProp$1C = Object.defineProperty;
var __decorateClass$1E = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1C(target, key, result);
  return result;
};
const _ChatChannel = class _ChatChannel2 extends Entity$1 {
  constructor(item2) {
    super();
    if (item2) this.update(item2);
  }
  get vkSettings() {
    return this.settings;
  }
  get fbSettings() {
    return this.settings;
  }
  get wazzup24Settings() {
    return this.settings;
  }
  get whatsAppSettings() {
    return this.settings;
  }
  get instagramSettings() {
    return this.settings;
  }
  get lineSettings() {
    return this.settings;
  }
  get isValidSettings() {
    return this.settings.isValid;
  }
  get isWA() {
    return this.type === ChatChannelType.Wa;
  }
  get isWazzup() {
    return this.type === ChatChannelType.Wazzup24;
  }
  update(channel) {
    super.update(channel);
  }
  hasChanges(channel) {
    return this.name != channel.name || this.color != channel.color || this.type != channel.type || this.broadcastDisabled != channel.broadcastDisabled || this.settings.hasChanges(channel.settings) || this.defaultChatBot?.id !== channel.defaultChatBot?.id;
  }
  clone() {
    return new _ChatChannel2({
      ...this,
      settings: this.settings.clone(),
      defaultChatBot: this.defaultChatBot
    });
  }
  static fromJson(json) {
    const channel = new _ChatChannel2({
      ...json,
      settings: ChatChannelSettingsFactory.build(json.type, json.settingsJson),
      defaultChatBot: json.defaultChatBot ? ChatBot.fromJson(json.defaultChatBot) : null,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : null
    });
    if (channel.scenario) {
      channel.scenario.update({ chatChannel: channel });
    }
    return channel;
  }
  static default(c) {
    return new _ChatChannel2({
      ...c,
      broadcastDisabled: c.type === ChatChannelType.Wa || c.type === ChatChannelType.Wazzup24,
      settings: ChatChannelSettingsFactory.build(c.type)
    });
  }
};
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "name");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "type");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "disabled");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "broadcastDisabled");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "disabledReason");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "number");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "color");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "userCount");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "subscribedUserCount");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "defaultChatBot");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "webhookInvalidated");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "settings");
__decorateClass$1E([
  observable
], _ChatChannel.prototype, "scenario");
let ChatChannel = _ChatChannel;
var __defProp$1B = Object.defineProperty;
var __decorateClass$1D = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1B(target, key, result);
  return result;
};
const _ChatChannelIntegration = class _ChatChannelIntegration2 extends Entity$1 {
  clone() {
    return new _ChatChannelIntegration2({
      ...this
    });
  }
  update(integration) {
    super.update(integration);
  }
  static fromJson(json) {
    return new _ChatChannelIntegration2({
      ...json
    });
  }
};
__decorateClass$1D([
  observable
], _ChatChannelIntegration.prototype, "name");
__decorateClass$1D([
  observable
], _ChatChannelIntegration.prototype, "type");
__decorateClass$1D([
  observable
], _ChatChannelIntegration.prototype, "canInitiateMessaging");
let ChatChannelIntegration = _ChatChannelIntegration;
var ChatChannelType = /* @__PURE__ */ ((ChatChannelType2) => {
  ChatChannelType2["Accel"] = "accel";
  ChatChannelType2["Vk"] = "vk";
  ChatChannelType2["Tg"] = "tg";
  ChatChannelType2["Vb"] = "vb";
  ChatChannelType2["Fb"] = "fb";
  ChatChannelType2["Wazzup24"] = "wazzup24";
  ChatChannelType2["Wa"] = "wa";
  ChatChannelType2["Ig"] = "ig";
  ChatChannelType2["Line"] = "line";
  return ChatChannelType2;
})(ChatChannelType || {});
var __defProp$1A = Object.defineProperty;
var __decorateClass$1C = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1A(target, key, result);
  return result;
};
const _ChatBotPhrase = class _ChatBotPhrase2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  update(bot) {
    super.update(bot);
  }
  static fromJson(json) {
    return new _ChatBotPhrase2({
      id: json.id,
      softDeleted: json.softDeleted,
      phrase: json.phrase,
      executionTimes: json.executionTimes,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0
    });
  }
};
__decorateClass$1C([
  observable
], _ChatBotPhrase.prototype, "phrase");
__decorateClass$1C([
  observable
], _ChatBotPhrase.prototype, "executionTimes");
__decorateClass$1C([
  observable
], _ChatBotPhrase.prototype, "createdDate");
let ChatBotPhrase = _ChatBotPhrase;
var __defProp$1z = Object.defineProperty;
var __decorateClass$1B = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1z(target, key, result);
  return result;
};
const _ChatBot = class _ChatBot2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  update(bot) {
    super.update(bot);
  }
  copy() {
    return new _ChatBot2({
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      phrases: this.phrases.slice()
    });
  }
  static fromJson(json) {
    const chatBot = new _ChatBot2({
      id: json.id,
      softDeleted: json.softDeleted,
      name: json.name,
      description: json.description,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      type: json.type,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      number: json.number,
      phrases: json.keyPhrases ? json.keyPhrases.map(ChatBotPhrase.fromJson) : void 0,
      school: json.school ? School.fromJson(json.school) : null
    });
    if (chatBot.scenario) chatBot.scenario.update({ chatBot });
    return chatBot;
  }
};
__decorateClass$1B([
  observable
], _ChatBot.prototype, "name");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "description");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "createdDate");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "type");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "scenario");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "number");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "phrases");
__decorateClass$1B([
  observable
], _ChatBot.prototype, "school");
let ChatBot = _ChatBot;
var __defProp$1y = Object.defineProperty;
var __getOwnPropDesc$1x = Object.getOwnPropertyDescriptor;
var __decorateClass$1A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1y(target, key, result);
  return result;
};
const _Document = class _Document2 extends Designable {
  constructor(doc) {
    super(doc);
    if (doc) this.update(doc);
  }
  static fromJson(json) {
    return new _Document2({
      ...json,
      file: json.file ? AccelFile.fromJson(json.file) : null,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
  update(doc) {
    super.update(doc);
  }
};
__decorateClass$1A([
  observable
], _Document.prototype, "title", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "url", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "language", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "file", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "createdDate", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "updatedDate", 2);
__decorateClass$1A([
  observable
], _Document.prototype, "isPublished", 2);
__decorateClass$1A([
  action
], _Document.prototype, "update", 1);
var __defProp$1x = Object.defineProperty;
var __getOwnPropDesc$1w = Object.getOwnPropertyDescriptor;
var __decorateClass$1z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1x(target, key, result);
  return result;
};
const _Requisite = class _Requisite2 extends Entity$1 {
  constructor(requisite) {
    super(requisite);
    if (requisite) this.update(requisite);
  }
  static fromJson(json) {
    return new _Requisite2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
  static default(lang) {
    return new _Requisite2({
      requisites: "",
      licensor: "",
      language: lang,
      currency: lang === Lang.ru ? Currency.RUB : Currency.USD
    });
  }
  update(doc) {
    super.update(doc);
  }
};
__decorateClass$1z([
  observable
], _Requisite.prototype, "requisites", 2);
__decorateClass$1z([
  observable
], _Requisite.prototype, "licensor", 2);
__decorateClass$1z([
  observable
], _Requisite.prototype, "language", 2);
__decorateClass$1z([
  observable
], _Requisite.prototype, "currency", 2);
__decorateClass$1z([
  observable
], _Requisite.prototype, "createdDate", 2);
__decorateClass$1z([
  observable
], _Requisite.prototype, "updatedDate", 2);
__decorateClass$1z([
  action
], _Requisite.prototype, "update", 1);
var __defProp$1w = Object.defineProperty;
var __getOwnPropDesc$1v = Object.getOwnPropertyDescriptor;
var __decorateClass$1y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1w(target, key, result);
  return result;
};
const _SchoolContentItem = class _SchoolContentItem2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  static fromJson(json) {
    return new _SchoolContentItem2({
      id: json.id,
      title: json.title,
      description: json.description,
      isPublished: json.isPublished,
      type: json.type,
      sectionType: json.sectionType,
      position: json.position,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0,
      cover: json.cover ? AccelFile.fromJson(json.cover) : null,
      parentId: json.parentId,
      parent: json.parent ? _SchoolContentItem2.fromJson(json.parent) : json.parent,
      course: json.course ? Course.fromJson(json.course) : json.course,
      library: json.library ? Library.fromJson(json.library) : json.library
    });
  }
  update(changes) {
    super.update(changes);
  }
};
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "title", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "description", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "isPublished", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "cover", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "createdDate", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "updatedDate", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "position", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "parentId", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "parent", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "course", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "library", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "type", 2);
__decorateClass$1y([
  observable
], _SchoolContentItem.prototype, "sectionType", 2);
__decorateClass$1y([
  action
], _SchoolContentItem.prototype, "update", 1);
var __defProp$1v = Object.defineProperty;
var __getOwnPropDesc$1u = Object.getOwnPropertyDescriptor;
var __decorateClass$1x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1v(target, key, result);
  return result;
};
const _BillingPlan = class _BillingPlan2 extends Entity$1 {
  constructor(plan) {
    super(plan);
    if (plan) this.update(plan);
  }
  static fromJson(json) {
    const prices = /* @__PURE__ */ new Map();
    if (json.billingPlanPriceJson) {
      const raw = JSON.parse(json.billingPlanPriceJson);
      Object.keys(raw).forEach((key) => prices.set(key, raw[key].map(BillingPlanPrice.fromJson)));
    }
    return new _BillingPlan2({
      id: json.id,
      name: json.name,
      description: json.description,
      currency: json.currency,
      defaultTrialDaysCount: json.defaultTrialDaysCount,
      defaultCreditAmount: json.defaultCreditAmount,
      minimumExpensesAmount: json.minimumExpensesAmount,
      prices,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      isPrimary: json.isPrimary,
      isThirdParty: json.isThirdParty,
      isAgreementRequired: json.isAgreementRequired,
      fallbackPlan: json.fallbackPlan ? _BillingPlan2.fromJson(json.fallbackPlan) : null
    });
  }
  update(plan, allowUndefined = false) {
    super.update(plan, allowUndefined);
  }
  clone() {
    return new _BillingPlan2({
      ...this,
      prices: new Map(this.prices)
    });
  }
};
__decorateClass$1x([
  observable
], _BillingPlan.prototype, "name", 2);
__decorateClass$1x([
  observable
], _BillingPlan.prototype, "description", 2);
__decorateClass$1x([
  observable
], _BillingPlan.prototype, "prices", 2);
__decorateClass$1x([
  action
], _BillingPlan.prototype, "update", 1);
let BillingPlan = _BillingPlan;
var __defProp$1u = Object.defineProperty;
var __getOwnPropDesc$1t = Object.getOwnPropertyDescriptor;
var __decorateClass$1w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1u(target, key, result);
  return result;
};
const _BillingPlanPrice = class _BillingPlanPrice2 extends Updatable {
  constructor(p) {
    super();
    if (p) this.update(p);
  }
  static fromJson(json) {
    return new _BillingPlanPrice2({
      bracket: json.bracket,
      amount: json.amount
    });
  }
  update(plan) {
    super.update(plan);
  }
};
__decorateClass$1w([
  observable
], _BillingPlanPrice.prototype, "bracket", 2);
__decorateClass$1w([
  observable
], _BillingPlanPrice.prototype, "amount", 2);
__decorateClass$1w([
  action
], _BillingPlanPrice.prototype, "update", 1);
let BillingPlanPrice = _BillingPlanPrice;
var __defProp$1t = Object.defineProperty;
var __getOwnPropDesc$1s = Object.getOwnPropertyDescriptor;
var __decorateClass$1v = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1s(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1t(target, key, result);
  return result;
};
const _BillingPaymentMethod = class _BillingPaymentMethod2 extends Entity$1 {
  constructor(t) {
    super(t);
    if (t) this.update(t);
  }
  static fromJson(json) {
    return new _BillingPaymentMethod2({
      id: json.id,
      externalId: json.externalId,
      cardNumber: json.cardNumber,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      expYear: json.expYear,
      expMonth: json.expMonth,
      gatewayType: json.gatewayType,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      address: json.address ? BillingAddress.fromJson(json.address) : void 0
    });
  }
  update(t) {
    super.update(t);
  }
  clone() {
    return new _BillingPaymentMethod2({
      ...this,
      address: this.address ? this.address.clone() : void 0
    });
  }
};
__decorateClass$1v([
  action
], _BillingPaymentMethod.prototype, "update");
let BillingPaymentMethod = _BillingPaymentMethod;
var __defProp$1s = Object.defineProperty;
var __decorateClass$1u = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1s(target, key, result);
  return result;
};
class BillingPaymentMethodFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
__decorateClass$1u([
  observable
], BillingPaymentMethodFilter.prototype, "gatewayType");
var __defProp$1r = Object.defineProperty;
var __getOwnPropDesc$1r = Object.getOwnPropertyDescriptor;
var __decorateClass$1t = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1r(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1r(target, key, result);
  return result;
};
const _ManagerUser = class _ManagerUser2 extends User {
  constructor(user2) {
    super(user2);
    if (user2) this.update(user2);
  }
  static fromJson(json) {
    return new _ManagerUser2({
      ...json
    });
  }
  update(user2, allowUndefined = false) {
    super.update(user2, allowUndefined);
  }
};
__decorateClass$1t([
  action
], _ManagerUser.prototype, "update");
let ManagerUser = _ManagerUser;
var __defProp$1q = Object.defineProperty;
var __getOwnPropDesc$1q = Object.getOwnPropertyDescriptor;
var __decorateClass$1s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1q(target, key, result);
  return result;
};
const _BillingTransaction = class _BillingTransaction2 extends Entity$1 {
  constructor(t) {
    super(t);
    if (t) this.update(t);
  }
  get isDeletable() {
    return this.gatewayType == null && this.invoice == null;
  }
  get totalAmount() {
    return this.amount + this.bonusAmount;
  }
  get amountExchange() {
    return this.amount * this.exchangeRate;
  }
  get bonusAmountExchange() {
    return this.bonusAmount * this.exchangeRate;
  }
  get totalAmountExchange() {
    return this.amountExchange + this.bonusAmountExchange;
  }
  get hasReason() {
    return !isEmpty(this.reasonMessage);
  }
  get isIncome() {
    return this.totalAmount > 0;
  }
  isCreator(id2) {
    return this.manager?.id == id2;
  }
  update(t) {
    super.update(t);
  }
  static fromJson(json) {
    return new _BillingTransaction2({
      id: json.id,
      amount: json.amount,
      bonusAmount: json.bonusAmount,
      invoice: json.invoice ? BillingInvoice.fromJson(json.invoice) : null,
      externalId: json.externalId,
      externalPayload: json.externalPayload,
      paymentMethod: json.paymentMethod ? BillingPaymentMethod.fromJson(json.paymentMethod) : null,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      reasonMessage: json.reasonMessage,
      errorMessage: json.errorMessage,
      plan: json.billingPlan ? BillingPlan.fromJson(json.billingPlan) : null,
      status: json.status,
      school: json.school ? School.fromJson(json.school) : void 0,
      exchangeCurrency: json.exchangeCurrency,
      exchangeRate: json.exchangeRate,
      gatewayType: json.gatewayType,
      manager: json.manager ? ManagerUser.fromJson(json.manager) : void 0,
      address: json.address ? BillingAddress.fromJson(json.address) : void 0,
      paymentMethodCard: json.paymentMethodCardJson ? JSON.parse(json.paymentMethodCardJson) : void 0,
      isAutopay: json.isAutopay
    });
  }
};
__decorateClass$1s([
  observable
], _BillingTransaction.prototype, "school", 2);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "totalAmount", 1);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "amountExchange", 1);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "bonusAmountExchange", 1);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "totalAmountExchange", 1);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "hasReason", 1);
__decorateClass$1s([
  computed
], _BillingTransaction.prototype, "isIncome", 1);
__decorateClass$1s([
  action
], _BillingTransaction.prototype, "update", 1);
var __defProp$1p = Object.defineProperty;
var __getOwnPropDesc$1p = Object.getOwnPropertyDescriptor;
var __decorateClass$1r = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1p(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1p(target, key, result);
  return result;
};
const _BillingInvoiceBracketAmount = class _BillingInvoiceBracketAmount2 extends Updatable {
  constructor(i) {
    super();
    if (i) this.update(i);
  }
  static fromJson(json) {
    return new _BillingInvoiceBracketAmount2({
      type: json.type,
      count: json.count,
      amount: json.amount,
      fromBracket: json.fromBracket,
      toBracket: json.toBracket,
      bracketAmount: json.bracketAmount
    });
  }
  update(t) {
    super.update(t);
  }
};
__decorateClass$1r([
  action
], _BillingInvoiceBracketAmount.prototype, "update");
let BillingInvoiceBracketAmount = _BillingInvoiceBracketAmount;
const _BillingInvoiceDetail = class _BillingInvoiceDetail2 extends Updatable {
  constructor(i) {
    super();
    if (i) this.update(i);
  }
  get period() {
    return `${this.year}-${this.month.toString().padStart(2, "0")}-${this.day.toString().padStart(2, "0")}`;
  }
  get date() {
    const d = moment.utc();
    d.set("year", this.year);
    d.set("month", this.month - 1);
    d.set("date", this.day);
    d.startOf("day");
    return d;
  }
  static fromJson(json) {
    return new _BillingInvoiceDetail2({
      month: json.month,
      year: json.year,
      day: json.day,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      type: json.type,
      count: json.count,
      amount: json.amount
    });
  }
  update(t) {
    super.update(t);
  }
};
__decorateClass$1r([
  action
], _BillingInvoiceDetail.prototype, "update");
let BillingInvoiceDetail = _BillingInvoiceDetail;
const _BillingInvoice = class _BillingInvoice2 extends Entity$1 {
  constructor(i) {
    super(i);
    if (i) this.update(i);
  }
  get period() {
    return `${this.year}-${this.month.toString().padStart(2, "0")}`;
  }
  get bracketsMap() {
    if (!this.brackets) return /* @__PURE__ */ new Map();
    const map = this.brackets.groupBy((x) => x.type);
    map.forEach((brackets, type4) => map.set(type4, brackets.orderBy((x) => x.fromBracket)));
    return map;
  }
  get detailsMap() {
    if (!this.details) return /* @__PURE__ */ new Map();
    const map = this.details.groupBy((x) => x.type);
    map.forEach((brackets, type4) => map.set(type4, brackets.orderBy((x) => x.period)));
    return map;
  }
  static fromJson(json) {
    return new _BillingInvoice2({
      id: json.id,
      month: json.month,
      year: json.year,
      number: json.number,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      details: json.details ? json.details.map(BillingInvoiceDetail.fromJson) : void 0,
      brackets: json.brackets ? json.brackets.map(BillingInvoiceBracketAmount.fromJson) : void 0,
      totals: json.totals ? json.totals.map(BillingInvoiceBracketAmount.fromJson) : void 0,
      amount: json.amount,
      correctionToMinimumExpensesAmount: json.correctionToMinimumExpensesAmount,
      trialPeriodBonusAmount: json.trialPeriodBonusAmount,
      exchangeCurrency: json.exchangeCurrency,
      exchangeRate: json.exchangeRate,
      isClosed: json.isClosed
    });
  }
  update(t) {
    super.update(t);
  }
};
__decorateClass$1r([
  computed
], _BillingInvoice.prototype, "bracketsMap");
__decorateClass$1r([
  computed
], _BillingInvoice.prototype, "detailsMap");
__decorateClass$1r([
  action
], _BillingInvoice.prototype, "update");
let BillingInvoice = _BillingInvoice;
var __defProp$1o = Object.defineProperty;
var __getOwnPropDesc$1o = Object.getOwnPropertyDescriptor;
var __decorateClass$1q = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1o(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1o(target, key, result);
  return result;
};
const _BillingPlanUsage = class _BillingPlanUsage2 extends Entity$1 {
  constructor(usage) {
    super(usage);
    if (usage) this.update(usage);
  }
  get hasRedFlag() {
    return this.fee * 0.25 >= this.fallbackAmount;
  }
  get feeInExchangeCurrency() {
    return this.fee * (this.exchangeRate ?? 1);
  }
  get fallbackAmountInExchangeCurrency() {
    return this.fallbackAmount * (this.exchangeRate ?? 1);
  }
  static fromJson(json) {
    return new _BillingPlanUsage2({
      id: json.id,
      invoiceId: json.invoiceId,
      fallbackInvoiceId: json.fallbackInvoiceId,
      fallbackAmount: json.fallbackAmount,
      fee: json.fee,
      exchangeCurrency: json.exchangeCurrency,
      exchangeRate: json.exchangeRate,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      syncDate: json.syncDate ? moment(json.syncDate) : null,
      schoolBilling: json.schoolBilling ? SchoolBilling.fromJson(json.schoolBilling) : void 0,
      plan: json.plan ? BillingPlan.fromJson(json.plan) : void 0,
      fallbackPlan: json.fallbackPlan ? BillingPlan.fromJson(json.fallbackPlan) : void 0
    });
  }
  update(usage, allowUndefined = false) {
    super.update(usage, allowUndefined);
  }
};
__decorateClass$1q([
  computed
], _BillingPlanUsage.prototype, "hasRedFlag");
__decorateClass$1q([
  computed
], _BillingPlanUsage.prototype, "feeInExchangeCurrency");
__decorateClass$1q([
  computed
], _BillingPlanUsage.prototype, "fallbackAmountInExchangeCurrency");
__decorateClass$1q([
  action
], _BillingPlanUsage.prototype, "update");
var __defProp$1n = Object.defineProperty;
var __getOwnPropDesc$1n = Object.getOwnPropertyDescriptor;
var __decorateClass$1p = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1n(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1n(target, key, result);
  return result;
};
const _BillingAddress = class _BillingAddress2 extends Entity$1 {
  constructor(address) {
    super();
    if (address) this.update(address);
  }
  get isEmpty() {
    return isEmpty(this.firstName) && isEmpty(this.lastName) && isEmpty(this.address) && isEmpty(this.state) && isEmpty(this.country) && isEmpty(this.city) && isEmpty(this.zipCode);
  }
  get fullName() {
    const hasFirstName = !isEmpty(this.firstName);
    const hasLastName = !isEmpty(this.lastName);
    if (!hasFirstName && !hasLastName) return "";
    if (hasFirstName && !hasLastName) return this.firstName;
    if (!hasFirstName && hasLastName) return this.lastName;
    return `${this.firstName} ${this.lastName}`;
  }
  toString() {
    return [this.address, this.city, this.zipCode, this.state, this.country, this.fullName, this.company, this.note].filter((x) => x).join(", ");
  }
  toJson() {
    return {
      ...this
    };
  }
  clone() {
    return new _BillingAddress2({
      ...this
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  static fromJson(json) {
    return new _BillingAddress2({
      ...json,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      partnershipVisibleToGroup: json.partnershipVisibleToGroup ? ContactGroup.fromJson(json.partnershipVisibleToGroup) : void 0
    });
  }
};
__decorateClass$1p([
  action
], _BillingAddress.prototype, "update");
let BillingAddress = _BillingAddress;
var __defProp$1m = Object.defineProperty;
var __getOwnPropDesc$1m = Object.getOwnPropertyDescriptor;
var __decorateClass$1o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1m(target, key, result);
  return result;
};
const _UserNotification = class _UserNotification2 extends Entity$1 {
  constructor(n) {
    super(n);
    if (n) this.update(n);
  }
  get isSeen() {
    return this.seenDate != null;
  }
  //#endregion
  static fromJson(json) {
    return new _UserNotification2({
      id: json.id,
      type: json.type,
      payload: json.payloadJson ? JSON.parse(json.payloadJson) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      seenDate: json.seenDate ? moment(json.seenDate) : null,
      adminId: json.adminId,
      contactId: json.studentId,
      adminTaskId: json.adminTaskId,
      courseItemId: json.courseItemId,
      libraryItemId: json.libraryItemId,
      courseItemTaskId: json.courseItemTaskId,
      schoolContentItemCommentId: json.schoolContentItemCommentId,
      orderId: json.orderId,
      orderPaymentId: json.orderPaymentId,
      scenarioId: json.scenarioId,
      chatConversationId: json.chatConversationId,
      courseId: json.courseId,
      libraryId: json.libraryId,
      taskAnswerId: json.taskAnswerId,
      schoolContentItemProgressRatingId: json.schoolContentItemProgressRatingId,
      partnershipTransactionId: json.partnershipTransactionId,
      partnershipTransactionRequestId: json.partnershipTransactionRequestId,
      studentBonusTransactionId: json.studentBonusTransactionId
    });
  }
  update(n) {
    super.update(n);
  }
};
__decorateClass$1o([
  observable
], _UserNotification.prototype, "type", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "payload", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "createdDate", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "updatedDate", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "seenDate", 2);
__decorateClass$1o([
  computed
], _UserNotification.prototype, "isSeen", 1);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "adminTaskId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "courseItemId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "libraryItemId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "taskAnswerId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "courseItemTaskId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "schoolContentItemCommentId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "orderId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "orderPaymentId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "scenarioId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "chatConversationId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "courseId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "libraryId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "contactId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "adminId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "schoolContentItemProgressRatingId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "partnershipTransactionId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "partnershipTransactionRequestId", 2);
__decorateClass$1o([
  observable
], _UserNotification.prototype, "studentBonusTransactionId", 2);
__decorateClass$1o([
  action
], _UserNotification.prototype, "update", 1);
var UserNotificationType = /* @__PURE__ */ ((UserNotificationType2) => {
  UserNotificationType2["AccountLoginSuccess"] = "accountLoginSuccess";
  UserNotificationType2["AccountLoginPrevented"] = "accountLoginPrevented";
  UserNotificationType2["EmailConfirmed"] = "adminEmailConfirmed";
  UserNotificationType2["CourseTaskAnswer"] = "courseTaskAnswer";
  UserNotificationType2["Order"] = "order";
  UserNotificationType2["OrderPayment"] = "orderPayment";
  UserNotificationType2["AdminTaskStatus"] = "adminTaskStatus";
  UserNotificationType2["AdminTaskCreated"] = "adminTaskCreated";
  UserNotificationType2["AdminTaskReminder"] = "adminTaskReminder";
  UserNotificationType2["CustomNotification"] = "customNotification";
  UserNotificationType2["CourseTaskComment"] = "courseTaskComment";
  UserNotificationType2["CourseItemComment"] = "courseItemComment";
  UserNotificationType2["LibraryItemComment"] = "libraryItemComment";
  UserNotificationType2["PipelineDealCreated"] = "pipelineDealCreated";
  UserNotificationType2["PipelineDealCompleted"] = "pipelineDealCompleted";
  UserNotificationType2["CourseTaskAnswerStatus"] = "courseTaskAnswerStatus";
  UserNotificationType2["PasswordChanged"] = "passwordChanged";
  UserNotificationType2["NewChatMessage"] = "receivedNewChatMessage";
  UserNotificationType2["NewEmailMessage"] = "receivedNewEmailMessage";
  UserNotificationType2["AdminPartnershipTransactionRequest"] = "adminPartnershipTransactionRequest";
  UserNotificationType2["StudentPartnershipTransaction"] = "studentPartnershipTransaction";
  UserNotificationType2["StudentPartnershipRegistration"] = "studentPartnershipRegistration";
  UserNotificationType2["StudentBonusTransaction"] = "studentBonusTransaction";
  return UserNotificationType2;
})(UserNotificationType || {});
var __defProp$1l = Object.defineProperty;
var __getOwnPropDesc$1l = Object.getOwnPropertyDescriptor;
var __decorateClass$1n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1l(target, key, result);
  return result;
};
const _UserNotificationSubscription = class _UserNotificationSubscription2 extends Entity$1 {
  constructor(s) {
    super(s);
    if (s) this.update(s);
  }
  static fromJson(json) {
    return new _UserNotificationSubscription2({
      id: json.id,
      type: json.type,
      notificationType: json.notificationType,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      subscriberAdmin: json.subscriberAdmin ? Admin.fromJson(json.subscriberAdmin) : void 0,
      subscriberContact: json.subscriberStudent ? Contact.fromJson(json.subscriberStudent) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0
    });
  }
  update(n) {
    super.update(n);
  }
};
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "type", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "notificationType", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "createdDate", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "updatedDate", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "subscriberAdmin", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "subscriberContact", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "admin", 2);
__decorateClass$1n([
  observable
], _UserNotificationSubscription.prototype, "contact", 2);
__decorateClass$1n([
  action
], _UserNotificationSubscription.prototype, "update", 1);
var __defProp$1k = Object.defineProperty;
var __getOwnPropDesc$1k = Object.getOwnPropertyDescriptor;
var __decorateClass$1m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1k(target, key, result);
  return result;
};
const _UserNotificationChannel = class _UserNotificationChannel2 extends Entity$1 {
  constructor(ch) {
    super(ch);
    if (ch) this.update(ch);
  }
  get hasSubscription() {
    return this.subscriptionId != null;
  }
  get canUseAsGlobalSub() {
    switch (this.notificationType) {
      case UserNotificationType.AdminTaskStatus:
      case UserNotificationType.AdminTaskCreated:
      case UserNotificationType.CourseTaskAnswer:
      case UserNotificationType.CourseTaskComment:
      case UserNotificationType.Order:
      case UserNotificationType.OrderPayment:
        return true;
      default:
        return false;
    }
  }
  /**
   * indicates whether this type of subscription can be used for a personal subscription to a contact
   */
  get canUseAsPersonalSub() {
    switch (this.notificationType) {
      case UserNotificationType.CourseTaskAnswer:
      case UserNotificationType.CourseTaskComment:
      case UserNotificationType.OrderPayment:
      case UserNotificationType.Order:
        return true;
      default:
        return false;
    }
  }
  static fromJson(json) {
    return new _UserNotificationChannel2({
      id: json.id,
      notificationType: json.notificationType,
      useSite: json.useSite,
      useEmail: json.useEmail,
      useTg: json.useTg,
      useWebPush: json.useWebPush,
      subscriptionId: json.subscriptionId,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0
    });
  }
  update(n, allowUndefined = false) {
    super.update(n, allowUndefined);
  }
};
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "notificationType", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "useSite", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "useEmail", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "useTg", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "useWebPush", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "admin", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "contact", 2);
__decorateClass$1m([
  observable
], _UserNotificationChannel.prototype, "subscriptionId", 2);
__decorateClass$1m([
  computed
], _UserNotificationChannel.prototype, "hasSubscription", 1);
__decorateClass$1m([
  action
], _UserNotificationChannel.prototype, "update", 1);
let UserNotificationChannel = _UserNotificationChannel;
var __defProp$1j = Object.defineProperty;
var __getOwnPropDesc$1j = Object.getOwnPropertyDescriptor;
var __decorateClass$1l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1j(target, key, result);
  return result;
};
const _UserNotificationSettings = class _UserNotificationSettings2 extends Entity$1 {
  constructor(s) {
    super(s);
    if (s) this.update(s);
  }
  static fromJson(json) {
    return new _UserNotificationSettings2({
      id: json.id,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      useEmail: json.useEmail,
      email: json.email,
      customEmail: json.customEmail,
      useTg: json.useTg,
      tgId: json.tgId,
      tgLink: json.tgLink,
      useWebPush: json.useWebPush,
      channels: json.channels ? json.channels.map(UserNotificationChannel.fromJson) : []
    });
  }
  update(n) {
    super.update(n);
  }
};
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "admin", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "contact", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "useEmail", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "email", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "customEmail", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "useTg", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "tgId", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "channels", 2);
__decorateClass$1l([
  observable
], _UserNotificationSettings.prototype, "useWebPush", 2);
__decorateClass$1l([
  action
], _UserNotificationSettings.prototype, "update", 1);
const BROWSER_ALIASES_MAP = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
};
const BROWSER_MAP = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
};
const PLATFORMS_MAP = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
};
const OS_MAP = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
};
const ENGINE_MAP = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Utils {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(regexp4, ua) {
    const match2 = ua.match(regexp4);
    return match2 && match2.length > 0 && match2[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(regexp4, ua) {
    const match2 = ua.match(regexp4);
    return match2 && match2.length > 1 && match2[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(regexp4, ua, _const) {
    if (regexp4.test(ua)) {
      return _const;
    }
    return void 0;
  }
  static getWindowsVersionName(version2) {
    switch (version2) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return void 0;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(version2) {
    const v = version2.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] !== 10) return void 0;
    switch (v[1]) {
      case 5:
        return "Leopard";
      case 6:
        return "Snow Leopard";
      case 7:
        return "Lion";
      case 8:
        return "Mountain Lion";
      case 9:
        return "Mavericks";
      case 10:
        return "Yosemite";
      case 11:
        return "El Capitan";
      case 12:
        return "Sierra";
      case 13:
        return "High Sierra";
      case 14:
        return "Mojave";
      case 15:
        return "Catalina";
      default:
        return void 0;
    }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(version2) {
    const v = version2.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] === 1 && v[1] < 5) return void 0;
    if (v[0] === 1 && v[1] < 6) return "Cupcake";
    if (v[0] === 1 && v[1] >= 6) return "Donut";
    if (v[0] === 2 && v[1] < 2) return "Eclair";
    if (v[0] === 2 && v[1] === 2) return "Froyo";
    if (v[0] === 2 && v[1] > 2) return "Gingerbread";
    if (v[0] === 3) return "Honeycomb";
    if (v[0] === 4 && v[1] < 1) return "Ice Cream Sandwich";
    if (v[0] === 4 && v[1] < 4) return "Jelly Bean";
    if (v[0] === 4 && v[1] >= 4) return "KitKat";
    if (v[0] === 5) return "Lollipop";
    if (v[0] === 6) return "Marshmallow";
    if (v[0] === 7) return "Nougat";
    if (v[0] === 8) return "Oreo";
    if (v[0] === 9) return "Pie";
    return void 0;
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(version2) {
    return version2.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(versionA, versionB, isLoose = false) {
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = Utils.map([versionA, versionB], (version2) => {
      const delta = precision - Utils.getVersionPrecision(version2);
      const _version = version2 + new Array(delta + 1).join(".0");
      return Utils.map(_version.split("."), (chunk) => new Array(20 - chunk.length).join("0") + chunk).reverse();
    });
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }
    precision -= 1;
    while (precision >= lastPrecision) {
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          return 0;
        }
        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }
    return void 0;
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(arr, iterator) {
    const result = [];
    let i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i += 1) {
      result.push(iterator(arr[i]));
    }
    return result;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(arr, predicate) {
    let i;
    let l;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i = 0, l = arr.length; i < l; i += 1) {
      const value = arr[i];
      if (predicate(value, i)) {
        return value;
      }
    }
    return void 0;
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(obj, ...assigners) {
    const result = obj;
    let i;
    let l;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i = 0, l = assigners.length; i < l; i += 1) {
      const assigner = assigners[i];
      if (typeof assigner === "object" && assigner !== null) {
        const keys2 = Object.keys(assigner);
        keys2.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || "";
  }
}
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser = {
        name: "Googlebot"
      };
      const version2 = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version2 = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser = {
        name: "Samsung Internet for Android"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser = {
        name: "NAVER Whale Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser = {
        name: "MZ Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser = {
        name: "Focus"
      };
      const version2 = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser = {
        name: "Swing"
      };
      const version2 = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser = {
        name: "Opera Coast"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser = {
        name: "Opera Touch"
      };
      const version2 = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser = {
        name: "Yandex Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser = {
        name: "UC Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser = {
        name: "Maxthon"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser = {
        name: "Epiphany"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser = {
        name: "Puffin"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser = {
        name: "Sleipnir"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser = {
        name: "K-Meleon"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser = {
        name: "WeChat"
      };
      const version2 = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser = {
        name: /qqbrowserlite/i.test(ua) ? "QQ Browser Lite" : "QQ Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser = {
        name: "Internet Explorer"
      };
      const version2 = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version2 = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version2 = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser = {
        name: "Vivaldi"
      };
      const version2 = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser = {
        name: "SeaMonkey"
      };
      const version2 = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser = {
        name: "Sailfish"
      };
      const version2 = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser = {
        name: "Amazon Silk"
      };
      const version2 = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser = {
        name: "PhantomJS"
      };
      const version2 = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser = {
        name: "SlimerJS"
      };
      const version2 = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser = {
        name: "BlackBerry"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser = {
        name: "WebOS Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser = {
        name: "Bada"
      };
      const version2 = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser = {
        name: "Tizen"
      };
      const version2 = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser = {
        name: "QupZilla"
      };
      const version2 = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser = {
        name: "Firefox"
      };
      const version2 = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser = {
        name: "Electron"
      };
      const version2 = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser = {
        name: "Miui"
      };
      const version2 = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser = {
        name: "Chromium"
      };
      const version2 = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser = {
        name: "Chrome"
      };
      const version2 = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser = {
        name: "Google Search"
      };
      const version2 = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* Android Browser */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser = {
        name: "Android Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser = {
        name: "PlayStation 4"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser = {
        name: "Safari"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser.version = version2;
      }
      return browser;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(ua) {
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search("\\(") !== -1;
      const regexp4 = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp4, ua),
        version: Utils.getSecondMatch(regexp4, ua)
      };
    }
  }
];
const osParsersList = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version: version2
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version: version2
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version2);
      return {
        name: OS_MAP.Windows,
        version: version2,
        versionName
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS
      };
      const version2 = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version2) {
        result.version = version2;
      }
      return result;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, ".");
      const versionName = Utils.getMacOSVersionName(version2);
      const os = {
        name: OS_MAP.MacOS,
        version: version2
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, ".");
      return {
        name: OS_MAP.iOS,
        version: version2
      };
    }
  },
  /* Android */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version2 = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version2);
      const os = {
        name: OS_MAP.Android,
        version: version2
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS
      };
      if (version2 && version2.length) {
        os.version = version2;
      }
      return os;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || Utils.getFirstMatch(/\bbb(\d+)/i, ua);
      return {
        name: OS_MAP.BlackBerry,
        version: version2
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Bada,
        version: version2
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Tizen,
        version: version2
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version: version2
      };
    }
  }
];
const platformParsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && "Nova";
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: "Huawei"
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(parser) {
      const iDevice = parser.test(/ipod|iphone/i);
      const likeIDevice = parser.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Apple",
        model
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(parser) {
      return parser.getBrowserName(true) === "blackberry";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(parser) {
      return parser.getBrowserName(true) === "bada";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(parser) {
      return parser.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(parser) {
      const osMajorVersion = Number(String(parser.getOSVersion()).split(".")[0]);
      return parser.getOSName(true) === "android" && osMajorVersion >= 3;
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(parser) {
      return parser.getOSName(true) === "android";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* desktop */
  {
    test(parser) {
      return parser.getOSName(true) === "macos";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(parser) {
      return parser.getOSName(true) === "windows";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* Linux */
  {
    test(parser) {
      return parser.getOSName(true) === "linux";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(parser) {
      return parser.getOSName(true) === "playstation 4";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  },
  /* Roku */
  {
    test(parser) {
      return parser.getOSName(true) === "roku";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  }
];
const enginesParsersList = [
  /* EdgeHTML */
  {
    test(parser) {
      return parser.getBrowserName(true) === "microsoft edge";
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink
        };
      }
      const version2 = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
      return {
        name: ENGINE_MAP.EdgeHTML,
        version: version2
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident
      };
      const version2 = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Presto */
  {
    test(parser) {
      return parser.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto
      };
      const version2 = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Gecko */
  {
    test(parser) {
      const isGecko = parser.test(/gecko/i);
      const likeGecko = parser.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko
      };
      const version2 = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit
      };
      const version2 = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  }
];
let Parser$1 = class Parser {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === "") {
      throw new Error("UserAgent parameter can't be empty");
    }
    this._ua = UA;
    this.parsedResult = {};
    if (skipParsing !== true) {
      this.parse();
    }
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(regex2) {
    return regex2.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = Utils.find(browsersList, (_browser) => {
      if (typeof _browser.test === "function") {
        return _browser.test(this);
      }
      if (_browser.test instanceof Array) {
        return _browser.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }
    return this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }
    return this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || "";
    }
    return this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }
    return this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const os = Utils.find(osParsersList, (_os) => {
      if (typeof _os.test === "function") {
        return _os.test(this);
      }
      if (_os.test instanceof Array) {
        return _os.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }
    return this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(toLowerCase) {
    const { name } = this.getOS();
    if (toLowerCase) {
      return String(name).toLowerCase() || "";
    }
    return name || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }
    return this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(toLowerCase = false) {
    const { type: type4 } = this.getPlatform();
    if (toLowerCase) {
      return String(type4).toLowerCase() || "";
    }
    return type4 || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = Utils.find(platformParsersList, (_platform) => {
      if (typeof _platform.test === "function") {
        return _platform.test(this);
      }
      if (_platform.test instanceof Array) {
        return _platform.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }
    return this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }
    return this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || "";
    }
    return this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const engine = Utils.find(enginesParsersList, (_engine) => {
      if (typeof _engine.test === "function") {
        return _engine.test(this);
      }
      if (_engine.test instanceof Array) {
        return _engine.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }
    return this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === "string") {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === "object") {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });
    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, (name) => this.isOS(name));
      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);
        if (osResult !== void 0) {
          return osResult;
        }
      }
      const platformMatchingDefinition = Utils.find(
        platformsAndOSNames,
        (name) => this.isPlatform(name)
      );
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);
        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }
    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, (name) => this.isBrowser(name, true));
      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }
    return void 0;
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias2 = Utils.getBrowserTypeByAlias(browserNameLower);
    if (includingAlias && alias2) {
      browserNameLower = alias2.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }
  compareVersion(version2) {
    let expectedResults = [0];
    let comparableVersion = version2;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();
    if (typeof currentBrowserVersion !== "string") {
      return void 0;
    }
    if (version2[0] === ">" || version2[0] === "<") {
      comparableVersion = version2.substr(1);
      if (version2[1] === "=") {
        isLoose = true;
        comparableVersion = version2.substr(2);
      } else {
        expectedResults = [];
      }
      if (version2[0] === ">") {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version2[0] === "=") {
      comparableVersion = version2.substr(1);
    } else if (version2[0] === "~") {
      isLoose = true;
      comparableVersion = version2.substr(1);
    }
    return expectedResults.indexOf(
      Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)
    ) > -1;
  }
  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }
  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }
  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything) || this.isPlatform(anything);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(anythings = []) {
    return anythings.some((anything) => this.is(anything));
  }
};
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Bowser {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== "string") {
      throw new Error("UserAgent should be a string");
    }
    return new Parser$1(UA, skipParsing);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(UA) {
    return new Parser$1(UA).getResult();
  }
  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }
  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }
  static get OS_MAP() {
    return OS_MAP;
  }
  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
}
var __defProp$1i = Object.defineProperty;
var __getOwnPropDesc$1i = Object.getOwnPropertyDescriptor;
var __decorateClass$1k = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1i(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1i(target, key, result);
  return result;
};
const _UserWebPushToken = class _UserWebPushToken2 extends Entity$1 {
  constructor(n) {
    super(n);
    if (n) this.update(n);
  }
  get parsedUserAgent() {
    if (!this.userAgent) return null;
    return Bowser.parse(this.userAgent);
  }
  update(n) {
    super.update(n);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(json) {
    return new _UserWebPushToken2({
      id: json.id,
      token: json.token,
      userAgent: json.userAgent,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0
    });
  }
};
__decorateClass$1k([
  computed
], _UserWebPushToken.prototype, "parsedUserAgent");
__decorateClass$1k([
  action
], _UserWebPushToken.prototype, "update");
var __defProp$1h = Object.defineProperty;
var __getOwnPropDesc$1h = Object.getOwnPropertyDescriptor;
var __decorateClass$1j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1h(target, key, result);
  return result;
};
const _AccelTag = class _AccelTag2 extends Entity$1 {
  constructor(tag) {
    super(tag);
    if (tag) this.update(tag);
  }
  update(tag) {
    super.update(tag);
  }
  clone() {
    return new _AccelTag2({
      ...this
    });
  }
  toJson() {
    return {
      id: this.id,
      text: this.text,
      type: this.type,
      color: this.color,
      position: this.position
    };
  }
  static fromJson(json) {
    return new _AccelTag2({
      ...json,
      createdDate: json.createdDate ? new Date(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? new Date(json.updatedDate) : void 0
    });
  }
};
__decorateClass$1j([
  observable
], _AccelTag.prototype, "text", 2);
__decorateClass$1j([
  observable
], _AccelTag.prototype, "type", 2);
__decorateClass$1j([
  observable
], _AccelTag.prototype, "color", 2);
__decorateClass$1j([
  observable
], _AccelTag.prototype, "position", 2);
__decorateClass$1j([
  observable
], _AccelTag.prototype, "createdDate", 2);
__decorateClass$1j([
  observable
], _AccelTag.prototype, "updatedDate", 2);
__decorateClass$1j([
  action
], _AccelTag.prototype, "update", 1);
let AccelTag = _AccelTag;
var __defProp$1g = Object.defineProperty;
var __getOwnPropDesc$1g = Object.getOwnPropertyDescriptor;
var __decorateClass$1i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1g(target, key, result);
  return result;
};
const _QuizSettings = class _QuizSettings2 extends Updatable {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  copy() {
    return new _QuizSettings2({
      ...this
    });
  }
  static get default() {
    return new _QuizSettings2({
      nextButtonText: void 0,
      completeButtonText: void 0,
      showBackButton: false,
      completeFormText: void 0,
      showCompleteImage: true,
      completeImageUrl: null,
      redirectEnabled: false,
      redirectUrl: void 0,
      redirectNewTab: false,
      codeExecutionEnabled: false,
      code: void 0,
      titleSize: 16,
      textSize: 14,
      textColor: "#262626",
      titleColor: "#262626",
      bgColor: "#FFFFFF",
      bgImageUrl: null,
      borderThickness: 1,
      borderColor: "#BFBFBF",
      borderRadius: 3,
      navBtnBgColor: "#1890FF",
      navBtnTextColor: "#FFFFFF",
      navBtnSize: "md",
      navBtnBorderStyle: "solid",
      navBtnBorderThickness: 1,
      navBtnBorderColor: "#0063BF",
      navBtnBorderRadius: 2,
      navBtnFontSize: 16,
      elBtnBgColor: "#1890FF",
      elBtnTextColor: "#262626",
      elBtnSize: "md",
      elBtnBorderStyle: "solid",
      elBtnBorderThickness: 1,
      elBtnBorderColor: "#0063BF",
      elBtnBorderRadius: 2,
      elBtnFontSize: 16,
      progressBarVisible: false,
      progressBarBgColor: "#8ED1FC",
      progressBarFillColor: "#0693E3",
      progressBarHeight: 6,
      progressBarPercentVisible: false,
      progressBarPercentColor: "#262626",
      progressBarPercentFontSize: 14,
      progressBarPercentPlacement: "right"
    });
  }
  toJson() {
    return JSON.stringify(this);
  }
  static fromJson(json) {
    return new _QuizSettings2({
      ...this.default,
      ...json
    });
  }
};
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "showBackButton", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "nextButtonText", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "completeButtonText", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "completeFormText", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "showCompleteImage", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "completeImageUrl", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "redirectEnabled", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "redirectUrl", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "redirectNewTab", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "codeExecutionEnabled", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "code", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "textSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "textColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "bgColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "bgImageUrl", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "titleSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "titleColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "borderThickness", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "borderColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "borderRadius", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnBgColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnTextColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnBorderStyle", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnBorderThickness", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnBorderColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnBorderRadius", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "navBtnFontSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnBgColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnTextColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnBorderStyle", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnBorderThickness", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnBorderColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnBorderRadius", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "elBtnFontSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarVisible", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarBgColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarFillColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarHeight", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarPercentVisible", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarPercentColor", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarPercentFontSize", 2);
__decorateClass$1i([
  observable
], _QuizSettings.prototype, "progressBarPercentPlacement", 2);
__decorateClass$1i([
  action
], _QuizSettings.prototype, "update", 1);
let QuizSettings = _QuizSettings;
var __defProp$1f = Object.defineProperty;
var __getOwnPropDesc$1f = Object.getOwnPropertyDescriptor;
var __decorateClass$1h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1f(target, key, result);
  return result;
};
const _Quiz = class _Quiz2 extends Entity$1 {
  constructor(product) {
    super(product);
    if (product) this.update(product);
  }
  get isPublished() {
    return this.snapshotDate != void 0;
  }
  get hasUnpublishedChanges() {
    if (!this.snapshotDate)
      return true;
    return (this.updatedDate ?? this.createdDate)?.isAfter(this.snapshotDate);
  }
  get hasAdditionalHtml() {
    return !isEmpty(this.additionalHtml);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static fromJson(json) {
    const quiz = new _Quiz2({
      id: json.id,
      softDeleted: json.softDeleted,
      title: json.title,
      description: json.description,
      // settingsJson: json.settingsJson,
      settings: json.settingsJson ? QuizSettings.fromJson(JSON.parse(json.settingsJson)) : QuizSettings.default,
      additionalHtml: json.additionalHtml,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      snapshotDate: json.snapshotDate ? moment(json.snapshotDate) : void 0,
      snapshotId: json.snapshotId,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      widget: json.widget ? Widget.fromJson(json.widget) : void 0,
      sentCount: json.sentCount
    });
    if (quiz.scenario)
      quiz.scenario.update({ quiz });
    return quiz;
  }
  copy() {
    return new _Quiz2({
      id: this.id,
      title: this.title,
      description: this.description,
      settings: this.settings?.copy(),
      additionalHtml: this.additionalHtml,
      snapshotDate: this.snapshotDate,
      createdDate: this.createdDate,
      updatedDate: this.updatedDate,
      scenario: this.scenario?.copy()
    });
  }
};
__decorateClass$1h([
  observable
], _Quiz.prototype, "title", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "description", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "settings", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "additionalHtml", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "createdDate", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "updatedDate", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "snapshotDate", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "snapshotId", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "sentCount", 2);
__decorateClass$1h([
  observable
], _Quiz.prototype, "scenario", 2);
__decorateClass$1h([
  computed
], _Quiz.prototype, "isPublished", 1);
__decorateClass$1h([
  computed
], _Quiz.prototype, "hasUnpublishedChanges", 1);
__decorateClass$1h([
  computed
], _Quiz.prototype, "hasAdditionalHtml", 1);
__decorateClass$1h([
  action
], _Quiz.prototype, "update", 1);
let Quiz = _Quiz;
var __defProp$1e = Object.defineProperty;
var __getOwnPropDesc$1e = Object.getOwnPropertyDescriptor;
var __decorateClass$1g = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$1e(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$1e(target, key, result);
  return result;
};
const _QuizPageSettings = class _QuizPageSettings2 extends Updatable {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static get default() {
    return new _QuizPageSettings2({
      rule: null,
      rules: null
    });
  }
  clone() {
    return new _QuizPageSettings2({
      ...this
    });
  }
  toJson() {
    return JSON.stringify(this);
  }
  static fromJson(json) {
    return new _QuizPageSettings2({
      rule: json.rule,
      rules: json.rules ? json.rules : json.rule ? [json.rule] : void 0
    });
  }
};
__decorateClass$1g([
  action
], _QuizPageSettings.prototype, "update");
let QuizPageSettings = _QuizPageSettings;
var __defProp$1d = Object.defineProperty;
var __getOwnPropDesc$1d = Object.getOwnPropertyDescriptor;
var __decorateClass$1f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1d(target, key, result);
  return result;
};
const _QuizPage = class _QuizPage2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static fromJson(json) {
    return new _QuizPage2({
      id: json.id,
      softDeleted: json.softDeleted,
      settings: json.settingsJson ? QuizPageSettings.fromJson(JSON.parse(json.settingsJson)) : QuizPageSettings.default,
      quizId: json.quizId,
      position: json.position,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      items: json.items ? json.items.map(QuizItem.fromJson) : void 0
    });
  }
  clone() {
    return new _QuizPage2({
      id: this.id,
      settings: this.settings.clone(),
      quizId: this.quizId,
      position: this.position,
      createdDate: this.createdDate,
      updatedDate: this.updatedDate
      // items: this.items.map(x => x.clone())
    });
  }
};
__decorateClass$1f([
  observable
], _QuizPage.prototype, "quizId", 2);
__decorateClass$1f([
  observable
], _QuizPage.prototype, "settings", 2);
__decorateClass$1f([
  observable
], _QuizPage.prototype, "position", 2);
__decorateClass$1f([
  observable
], _QuizPage.prototype, "createdDate", 2);
__decorateClass$1f([
  observable
], _QuizPage.prototype, "updatedDate", 2);
__decorateClass$1f([
  observable
], _QuizPage.prototype, "items", 2);
__decorateClass$1f([
  action
], _QuizPage.prototype, "update", 1);
let QuizPage = _QuizPage;
var QuizItemType = /* @__PURE__ */ ((QuizItemType2) => {
  QuizItemType2["TextField"] = "textField";
  QuizItemType2["TextArea"] = "textArea";
  QuizItemType2["Number"] = "number";
  QuizItemType2["Phone"] = "phone";
  QuizItemType2["Email"] = "email";
  QuizItemType2["Url"] = "url";
  QuizItemType2["Checkbox"] = "checkbox";
  QuizItemType2["DropdownList"] = "dropdownList";
  QuizItemType2["MultiSelect"] = "multiSelect";
  QuizItemType2["MonoSelect"] = "monoSelect";
  QuizItemType2["HiddenField"] = "hiddenField";
  QuizItemType2["Rating"] = "rating";
  QuizItemType2["UploadFile"] = "uploadFile";
  QuizItemType2["DateTime"] = "dateTime";
  QuizItemType2["Slider"] = "slider";
  QuizItemType2["NameField"] = "nameField";
  QuizItemType2["Header"] = "header";
  QuizItemType2["Paragraph"] = "paragraph";
  QuizItemType2["Separator"] = "separator";
  QuizItemType2["Indent"] = "indent";
  QuizItemType2["Image"] = "picture";
  QuizItemType2["Video"] = "video";
  QuizItemType2["Social"] = "socialButton";
  return QuizItemType2;
})(QuizItemType || {});
var __defProp$1c = Object.defineProperty;
var __getOwnPropDesc$1c = Object.getOwnPropertyDescriptor;
var __decorateClass$1e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1c(target, key, result);
  return result;
};
const _QuizItemSettings = class _QuizItemSettings2 extends Updatable {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get displayLabel() {
    return !isEmpty(this.fieldName) ? this.fieldName : this.question;
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  clone() {
    return new _QuizItemSettings2({
      ...this
    });
  }
  static get default() {
    return new _QuizItemSettings2({
      required: false,
      question: "",
      placeholder: "",
      desc: "",
      descHtml: "",
      fieldName: void 0,
      hideIfFilled: false,
      customAttrKey: void 0,
      attrId: null,
      hideQuestion: false
    });
  }
  toJson() {
    return JSON.stringify(this);
  }
  static fromJson(json) {
    return new _QuizItemSettings2({
      ..._QuizItemSettings2.default,
      ...json
    });
  }
};
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "question", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "placeholder", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "desc", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "descHtml", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "fieldName", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "hideIfFilled", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "attrId", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "customAttrKey", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "required", 2);
__decorateClass$1e([
  observable
], _QuizItemSettings.prototype, "hideQuestion", 2);
__decorateClass$1e([
  computed
], _QuizItemSettings.prototype, "displayLabel", 1);
__decorateClass$1e([
  action
], _QuizItemSettings.prototype, "update", 1);
let QuizItemSettings = _QuizItemSettings;
var __defProp$1b = Object.defineProperty;
var __getOwnPropDesc$1b = Object.getOwnPropertyDescriptor;
var __decorateClass$1d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1b(target, key, result);
  return result;
};
const _CheckboxItemSettings = class _CheckboxItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _CheckboxItemSettings2({
      ...QuizItemSettings.default,
      label: "",
      ...settings
    });
  }
  clone() {
    return new _CheckboxItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _CheckboxItemSettings2.build(json);
  }
};
__decorateClass$1d([
  observable
], _CheckboxItemSettings.prototype, "label", 2);
__decorateClass$1d([
  observable
], _CheckboxItemSettings.prototype, "labelHtml", 2);
__decorateClass$1d([
  action
], _CheckboxItemSettings.prototype, "update", 1);
let CheckboxItemSettings = _CheckboxItemSettings;
var __defProp$1a = Object.defineProperty;
var __getOwnPropDesc$1a = Object.getOwnPropertyDescriptor;
var __decorateClass$1c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1a(target, key, result);
  return result;
};
const _DateTimeItemSettings = class _DateTimeItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _DateTimeItemSettings2({
      ...QuizItemSettings.default,
      type: "dateTime",
      ...settings
    });
  }
  clone() {
    return new _DateTimeItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _DateTimeItemSettings2.build(json);
  }
};
__decorateClass$1c([
  observable
], _DateTimeItemSettings.prototype, "type", 2);
__decorateClass$1c([
  action
], _DateTimeItemSettings.prototype, "update", 1);
let DateTimeItemSettings = _DateTimeItemSettings;
var __defProp$19 = Object.defineProperty;
var __getOwnPropDesc$19 = Object.getOwnPropertyDescriptor;
var __decorateClass$1b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$19(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$19(target, key, result);
  return result;
};
const _DropdownListItemSettings = class _DropdownListItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _DropdownListItemSettings2({
      ...QuizItemSettings.default,
      options: [],
      ...settings
    });
  }
  clone() {
    return new _DropdownListItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _DropdownListItemSettings2.build(json);
  }
};
__decorateClass$1b([
  observable
], _DropdownListItemSettings.prototype, "options", 2);
__decorateClass$1b([
  action
], _DropdownListItemSettings.prototype, "update", 1);
let DropdownListItemSettings = _DropdownListItemSettings;
var __defProp$18 = Object.defineProperty;
var __getOwnPropDesc$18 = Object.getOwnPropertyDescriptor;
var __decorateClass$1a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$18(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$18(target, key, result);
  return result;
};
const _HeaderItemSettings = class _HeaderItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _HeaderItemSettings2({
      ...QuizItemSettings.default,
      text: "",
      fontSize: 25,
      ...settings
    });
  }
  clone() {
    return new _HeaderItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _HeaderItemSettings2.build(json);
  }
};
__decorateClass$1a([
  observable
], _HeaderItemSettings.prototype, "text", 2);
__decorateClass$1a([
  observable
], _HeaderItemSettings.prototype, "textHtml", 2);
__decorateClass$1a([
  observable
], _HeaderItemSettings.prototype, "fontSize", 2);
__decorateClass$1a([
  observable
], _HeaderItemSettings.prototype, "textColor", 2);
__decorateClass$1a([
  action
], _HeaderItemSettings.prototype, "update", 1);
let HeaderItemSettings = _HeaderItemSettings;
var __defProp$17 = Object.defineProperty;
var __getOwnPropDesc$17 = Object.getOwnPropertyDescriptor;
var __decorateClass$19 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$17(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$17(target, key, result);
  return result;
};
const _HiddenFieldItemSettings = class _HiddenFieldItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _HiddenFieldItemSettings2({
      ...QuizItemSettings.default,
      value: void 0,
      ...def
    });
  }
  clone() {
    return new _HiddenFieldItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _HiddenFieldItemSettings2.build(json);
  }
};
__decorateClass$19([
  observable
], _HiddenFieldItemSettings.prototype, "value", 2);
__decorateClass$19([
  action
], _HiddenFieldItemSettings.prototype, "update", 1);
let HiddenFieldItemSettings = _HiddenFieldItemSettings;
var __defProp$16 = Object.defineProperty;
var __getOwnPropDesc$16 = Object.getOwnPropertyDescriptor;
var __decorateClass$18 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$16(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$16(target, key, result);
  return result;
};
const _ImageItemSettings = class _ImageItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _ImageItemSettings2({
      ...QuizItemSettings.default,
      imageUrl: null,
      fit: "contain",
      widthPercent: 100,
      height: null,
      align: "center",
      ...settings
    });
  }
  clone() {
    return new _ImageItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _ImageItemSettings2.build(json);
  }
};
__decorateClass$18([
  observable
], _ImageItemSettings.prototype, "imageUrl", 2);
__decorateClass$18([
  observable
], _ImageItemSettings.prototype, "fit", 2);
__decorateClass$18([
  observable
], _ImageItemSettings.prototype, "widthPercent", 2);
__decorateClass$18([
  observable
], _ImageItemSettings.prototype, "height", 2);
__decorateClass$18([
  observable
], _ImageItemSettings.prototype, "align", 2);
__decorateClass$18([
  action
], _ImageItemSettings.prototype, "update", 1);
let ImageItemSettings = _ImageItemSettings;
var __defProp$15 = Object.defineProperty;
var __getOwnPropDesc$15 = Object.getOwnPropertyDescriptor;
var __decorateClass$17 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$15(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$15(target, key, result);
  return result;
};
const _IndentItemSettings = class _IndentItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _IndentItemSettings2({
      ...QuizItemSettings.default,
      height: 20,
      ...settings
    });
  }
  clone() {
    return new _IndentItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _IndentItemSettings2.build(json);
  }
};
__decorateClass$17([
  observable
], _IndentItemSettings.prototype, "height", 2);
__decorateClass$17([
  action
], _IndentItemSettings.prototype, "update", 1);
let IndentItemSettings = _IndentItemSettings;
var __defProp$14 = Object.defineProperty;
var __getOwnPropDesc$14 = Object.getOwnPropertyDescriptor;
var __decorateClass$16 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$14(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$14(target, key, result);
  return result;
};
const _NameFieldItemSettings = class _NameFieldItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get hasRequiredField() {
    if (this.showFirstName && this.firstNameRequired) return true;
    if (this.showMiddleName && this.middleNameRequired) return true;
    if (this.showLastName && this.lastNameRequired) return true;
    return false;
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _NameFieldItemSettings2({
      ...QuizItemSettings.default,
      showFirstName: true,
      firstNameRequired: true,
      showMiddleName: true,
      middleNameRequired: false,
      showLastName: true,
      lastNameRequired: false,
      ...settings
    });
  }
  clone() {
    return new _NameFieldItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _NameFieldItemSettings2.build(json);
  }
};
__decorateClass$16([
  computed
], _NameFieldItemSettings.prototype, "hasRequiredField", 1);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "showFirstName", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "firstNameRequired", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "firstNamePlaceholder", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "showMiddleName", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "middleNameRequired", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "middleNamePlaceholder", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "showLastName", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "lastNameRequired", 2);
__decorateClass$16([
  observable
], _NameFieldItemSettings.prototype, "lastNamePlaceholder", 2);
__decorateClass$16([
  action
], _NameFieldItemSettings.prototype, "update", 1);
let NameFieldItemSettings = _NameFieldItemSettings;
var __defProp$13 = Object.defineProperty;
var __getOwnPropDesc$13 = Object.getOwnPropertyDescriptor;
var __decorateClass$15 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$13(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$13(target, key, result);
  return result;
};
const _NumberItemSettings = class _NumberItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _NumberItemSettings2({
      ...QuizItemSettings.default,
      minValue: void 0,
      maxValue: void 0,
      ...def
    });
  }
  clone() {
    return new _NumberItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _NumberItemSettings2.build(json);
  }
};
__decorateClass$15([
  observable
], _NumberItemSettings.prototype, "minValue", 2);
__decorateClass$15([
  observable
], _NumberItemSettings.prototype, "maxValue", 2);
__decorateClass$15([
  action
], _NumberItemSettings.prototype, "update", 1);
let NumberItemSettings = _NumberItemSettings;
var __defProp$12 = Object.defineProperty;
var __getOwnPropDesc$12 = Object.getOwnPropertyDescriptor;
var __decorateClass$14 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$12(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$12(target, key, result);
  return result;
};
const _ParagraphItemSettings = class _ParagraphItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _ParagraphItemSettings2({
      ...QuizItemSettings.default,
      text: "",
      fontSize: 16,
      ...settings
    });
  }
  clone() {
    return new _ParagraphItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _ParagraphItemSettings2.build(json);
  }
};
__decorateClass$14([
  observable
], _ParagraphItemSettings.prototype, "text", 2);
__decorateClass$14([
  observable
], _ParagraphItemSettings.prototype, "textHtml", 2);
__decorateClass$14([
  observable
], _ParagraphItemSettings.prototype, "fontSize", 2);
__decorateClass$14([
  observable
], _ParagraphItemSettings.prototype, "textColor", 2);
__decorateClass$14([
  action
], _ParagraphItemSettings.prototype, "update", 1);
let ParagraphItemSettings = _ParagraphItemSettings;
var __defProp$11 = Object.defineProperty;
var __getOwnPropDesc$11 = Object.getOwnPropertyDescriptor;
var __decorateClass$13 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$11(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$11(target, key, result);
  return result;
};
const _RatingItemSettings = class _RatingItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _RatingItemSettings2({
      ...QuizItemSettings.default,
      starCount: 5,
      ...def
    });
  }
  clone() {
    return new _RatingItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _RatingItemSettings2.build(json);
  }
};
__decorateClass$13([
  observable
], _RatingItemSettings.prototype, "starCount", 2);
__decorateClass$13([
  action
], _RatingItemSettings.prototype, "update", 1);
var __defProp$10 = Object.defineProperty;
var __getOwnPropDesc$10 = Object.getOwnPropertyDescriptor;
var __decorateClass$12 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$10(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$10(target, key, result);
  return result;
};
const _SelectListItemSettings = class _SelectListItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get hasImage() {
    return this.options.some((x) => x.imageUrl != void 0);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _SelectListItemSettings2({
      ...QuizItemSettings.default,
      options: [],
      optionType: "default",
      goToNextPage: false,
      ...def
    });
  }
  clone() {
    return new _SelectListItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _SelectListItemSettings2.build(json);
  }
};
__decorateClass$12([
  observable
], _SelectListItemSettings.prototype, "optionType", 2);
__decorateClass$12([
  observable
], _SelectListItemSettings.prototype, "goToNextPage", 2);
__decorateClass$12([
  observable
], _SelectListItemSettings.prototype, "options", 2);
__decorateClass$12([
  computed
], _SelectListItemSettings.prototype, "hasImage", 1);
__decorateClass$12([
  action
], _SelectListItemSettings.prototype, "update", 1);
let SelectListItemSettings = _SelectListItemSettings;
var __defProp$$ = Object.defineProperty;
var __getOwnPropDesc$$ = Object.getOwnPropertyDescriptor;
var __decorateClass$11 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$$(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$$(target, key, result);
  return result;
};
const _SeparatorItemSettings = class _SeparatorItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get hasText() {
    return !isEmpty(this.text);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _SeparatorItemSettings2({
      ...QuizItemSettings.default,
      text: "",
      borderThickness: 1,
      borderColor: "#0000000f",
      align: "center",
      ...settings
    });
  }
  clone() {
    return new _SeparatorItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _SeparatorItemSettings2.build(json);
  }
};
__decorateClass$11([
  observable
], _SeparatorItemSettings.prototype, "text", 2);
__decorateClass$11([
  observable
], _SeparatorItemSettings.prototype, "borderThickness", 2);
__decorateClass$11([
  observable
], _SeparatorItemSettings.prototype, "borderColor", 2);
__decorateClass$11([
  observable
], _SeparatorItemSettings.prototype, "align", 2);
__decorateClass$11([
  computed
], _SeparatorItemSettings.prototype, "hasText", 1);
__decorateClass$11([
  action
], _SeparatorItemSettings.prototype, "update", 1);
let SeparatorItemSettings = _SeparatorItemSettings;
var __defProp$_ = Object.defineProperty;
var __getOwnPropDesc$_ = Object.getOwnPropertyDescriptor;
var __decorateClass$10 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$_(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$_(target, key, result);
  return result;
};
const _SliderItemSettings = class _SliderItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _SliderItemSettings2({
      ...QuizItemSettings.default,
      min: 0,
      max: 100,
      ...def
    });
  }
  clone() {
    return new _SliderItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _SliderItemSettings2.build(json);
  }
};
__decorateClass$10([
  observable
], _SliderItemSettings.prototype, "min", 2);
__decorateClass$10([
  observable
], _SliderItemSettings.prototype, "max", 2);
__decorateClass$10([
  action
], _SliderItemSettings.prototype, "update", 1);
let SliderItemSettings = _SliderItemSettings;
var __defProp$Z = Object.defineProperty;
var __getOwnPropDesc$Z = Object.getOwnPropertyDescriptor;
var __decorateClass$$ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$Z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$Z(target, key, result);
  return result;
};
const _SocialItemSettings = class _SocialItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get hasEnabled() {
    return this.facebookEnabled || this.twitterEnabled || this.vkEnabled || this.instagramEnabled || this.tgEnabled || this.whatsAppEnabled || this.linkedinEnabled;
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _SocialItemSettings2({
      ...QuizItemSettings.default,
      facebookEnabled: false,
      twitterEnabled: false,
      vkEnabled: false,
      instagramEnabled: false,
      tgEnabled: false,
      whatsAppEnabled: false,
      linkedinEnabled: false,
      shape: "default",
      size: "md",
      ...settings
    });
  }
  clone() {
    return new _SocialItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _SocialItemSettings2.build(json);
  }
};
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "facebookEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "facebookLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "twitterEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "twitterLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "vkEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "vkLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "instagramEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "instagramLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "tgEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "tgLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "whatsAppEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "whatsAppLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "linkedinEnabled", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "linkedinLink", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "shape", 2);
__decorateClass$$([
  observable
], _SocialItemSettings.prototype, "size", 2);
__decorateClass$$([
  computed
], _SocialItemSettings.prototype, "hasEnabled", 1);
__decorateClass$$([
  action
], _SocialItemSettings.prototype, "update", 1);
let SocialItemSettings = _SocialItemSettings;
var __defProp$Y = Object.defineProperty;
var __getOwnPropDesc$Y = Object.getOwnPropertyDescriptor;
var __decorateClass$_ = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$Y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$Y(target, key, result);
  return result;
};
const _UploadItemSettings = class _UploadItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get maxFileSize() {
    return FileSize.fromKilobytes(this.maxFileSizeKb);
  }
  get maxFileSizeString() {
    return Humanize.fileSize(this.maxFileSizeKb * 1024, 0);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(def) {
    return new _UploadItemSettings2({
      ...QuizItemSettings.default,
      fileType: "all",
      maxFileSizeKb: FileSize.fromMegabytes(25).kilobytes,
      ...def
    });
  }
  clone() {
    return new _UploadItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _UploadItemSettings2.build(json);
  }
};
__decorateClass$_([
  observable
], _UploadItemSettings.prototype, "fileType", 2);
__decorateClass$_([
  observable
], _UploadItemSettings.prototype, "maxFileSizeKb", 2);
__decorateClass$_([
  computed
], _UploadItemSettings.prototype, "maxFileSize", 1);
__decorateClass$_([
  action
], _UploadItemSettings.prototype, "update", 1);
let UploadItemSettings = _UploadItemSettings;
var __defProp$X = Object.defineProperty;
var __getOwnPropDesc$X = Object.getOwnPropertyDescriptor;
var __decorateClass$Z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$X(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$X(target, key, result);
  return result;
};
const _VideoItemSettings = class _VideoItemSettings2 extends QuizItemSettings {
  constructor(s) {
    super();
    if (s)
      this.update(s);
  }
  get hasVideo() {
    return !isEmpty(this.videoId) || !isEmpty(this.videoUrl);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static build(settings) {
    return new _VideoItemSettings2({
      ...QuizItemSettings.default,
      videoId: null,
      videoUrl: null,
      widthPercent: 100,
      align: "center",
      ...settings
    });
  }
  clone() {
    return new _VideoItemSettings2({
      ...this
    });
  }
  static fromJson(json) {
    return _VideoItemSettings2.build(json);
  }
};
__decorateClass$Z([
  observable
], _VideoItemSettings.prototype, "videoId", 2);
__decorateClass$Z([
  observable
], _VideoItemSettings.prototype, "videoUrl", 2);
__decorateClass$Z([
  computed
], _VideoItemSettings.prototype, "hasVideo", 1);
__decorateClass$Z([
  observable
], _VideoItemSettings.prototype, "widthPercent", 2);
__decorateClass$Z([
  observable
], _VideoItemSettings.prototype, "align", 2);
__decorateClass$Z([
  action
], _VideoItemSettings.prototype, "update", 1);
let VideoItemSettings = _VideoItemSettings;
class QuizItemSettingsParser {
  static parse(type4, settingsJson) {
    const s = settingsJson ? JSON.parse(settingsJson) : void 0;
    switch (type4) {
      case QuizItemType.Number:
        return NumberItemSettings.fromJson(s);
      case QuizItemType.DropdownList:
        return DropdownListItemSettings.fromJson(s);
      case QuizItemType.MultiSelect:
      case QuizItemType.MonoSelect:
        return SelectListItemSettings.fromJson(s);
      case QuizItemType.UploadFile:
        return UploadItemSettings.fromJson(s);
      case QuizItemType.DateTime:
        return DateTimeItemSettings.fromJson(s);
      case QuizItemType.Slider:
        return SliderItemSettings.fromJson(s);
      case QuizItemType.HiddenField:
        return HiddenFieldItemSettings.fromJson(s);
      case QuizItemType.NameField:
        return NameFieldItemSettings.fromJson(s);
      case QuizItemType.Checkbox:
        return CheckboxItemSettings.fromJson(s);
      case QuizItemType.Header:
        return HeaderItemSettings.fromJson(s);
      case QuizItemType.Paragraph:
        return ParagraphItemSettings.fromJson(s);
      case QuizItemType.Separator:
        return SeparatorItemSettings.fromJson(s);
      case QuizItemType.Indent:
        return IndentItemSettings.fromJson(s);
      case QuizItemType.Image:
        return ImageItemSettings.fromJson(s);
      case QuizItemType.Video:
        return VideoItemSettings.fromJson(s);
      case QuizItemType.Social:
        return SocialItemSettings.fromJson(s);
      default:
        return QuizItemSettings.fromJson(s);
    }
  }
}
var __defProp$W = Object.defineProperty;
var __getOwnPropDesc$W = Object.getOwnPropertyDescriptor;
var __decorateClass$Y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$W(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$W(target, key, result);
  return result;
};
const _QuizItem = class _QuizItem2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static fromJson(json) {
    return new _QuizItem2({
      id: json.id,
      title: json.title,
      description: json.description,
      settings: QuizItemSettingsParser.parse(json.type, json.settingsJson),
      position: json.position,
      type: json.type,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      softDeleted: json.softDeleted,
      pageId: json.pageId,
      page: json.page ? QuizPage.fromJson(json.page) : void 0
    });
  }
  clone(c) {
    return new _QuizItem2({
      title: this.title,
      description: this.description,
      settings: this.settings.clone(),
      position: this.position,
      type: this.type,
      createdDate: this.createdDate,
      pageId: this.pageId,
      page: this.page,
      ...c
    });
  }
  get supportsAnswerSort() {
    switch (this.type) {
      case QuizItemType.UploadFile:
        return false;
      default:
        return true;
    }
  }
  get answerSortName() {
    if (!this.supportsAnswerSort)
      return void 0;
    let fieldName = `Items.${this.id}`;
    let fieldValue = "";
    switch (this.type) {
      case QuizItemType.Checkbox:
        fieldValue = "BooleanValue";
        break;
      case QuizItemType.DateTime:
        fieldValue = "DateTimeValue";
        break;
      case QuizItemType.Rating:
      case QuizItemType.Number:
      case QuizItemType.Slider:
        fieldValue = "NumericValue";
        break;
      case QuizItemType.DropdownList:
      case QuizItemType.MonoSelect:
        fieldValue = "ListLabelValue";
        break;
      case QuizItemType.MultiSelect:
        fieldValue = "MultiListLabelValue";
        break;
      case QuizItemType.Email:
      case QuizItemType.NameField:
      case QuizItemType.Phone:
      case QuizItemType.TextArea:
      case QuizItemType.TextField:
      case QuizItemType.Url:
        fieldValue = "StringValue";
        break;
    }
    return `${fieldName}.${fieldValue}`;
  }
};
__decorateClass$Y([
  observable
], _QuizItem.prototype, "title", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "description", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "settings", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "type", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "position", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "createdDate", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "updatedDate", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "pageId", 2);
__decorateClass$Y([
  observable
], _QuizItem.prototype, "page", 2);
__decorateClass$Y([
  action
], _QuizItem.prototype, "update", 1);
__decorateClass$Y([
  computed
], _QuizItem.prototype, "supportsAnswerSort", 1);
__decorateClass$Y([
  computed
], _QuizItem.prototype, "answerSortName", 1);
let QuizItem = _QuizItem;
var __defProp$V = Object.defineProperty;
var __getOwnPropDesc$V = Object.getOwnPropertyDescriptor;
var __decorateClass$X = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$V(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$V(target, key, result);
  return result;
};
const _QuizItemAnswer = class _QuizItemAnswer2 extends Updatable {
  constructor(item2) {
    super();
    if (item2) this.update(item2);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static fromJson(json) {
    return new _QuizItemAnswer2({
      ...json,
      files: json.files ? json.files.map(AccelFile.fromJson) : [],
      dateTimeValue: json.dateTimeValue ? moment(json.dateTimeValue) : void 0
    });
  }
};
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "itemId", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "fileIds", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "rawValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "booleanValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "numericValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "dateTimeValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "stringValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "listValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "listLabelValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "multiListValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "multiListLabelValue", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "files", 2);
__decorateClass$X([
  observable
], _QuizItemAnswer.prototype, "listCustomValue", 2);
__decorateClass$X([
  action
], _QuizItemAnswer.prototype, "update", 1);
let QuizItemAnswer = _QuizItemAnswer;
var __defProp$U = Object.defineProperty;
var __getOwnPropDesc$U = Object.getOwnPropertyDescriptor;
var __decorateClass$W = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$U(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$U(target, key, result);
  return result;
};
const _QuizAnswer = class _QuizAnswer2 extends Entity$1 {
  constructor(item2) {
    super(item2);
    if (item2) this.update(item2);
  }
  update(q, allowUndefined = false) {
    super.update(q, allowUndefined);
  }
  static fromJson(json) {
    return new _QuizAnswer2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      completionDate: json.completionDate ? moment(json.completionDate) : void 0,
      answers: json.answers ? json.answers.map(QuizItemAnswer.fromJson) : [],
      contact: json.contact ? Contact.fromJson(json.contact) : void 0,
      quiz: json.quiz ? Quiz.fromJson(json.quiz) : void 0
    });
  }
};
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "quizId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "createdDate", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "completionDate", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "currentPageId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "contactId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "siteGuestId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "siteSessionViewId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "siteId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "sitePageId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "widgetId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "url", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "uTMSource", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "uTMMedium", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "uTMCampaign", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "uTMTerm", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "uTMContent", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "answers", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "contact", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "snapshotId", 2);
__decorateClass$W([
  observable
], _QuizAnswer.prototype, "quiz", 2);
__decorateClass$W([
  action
], _QuizAnswer.prototype, "update", 1);
var __defProp$T = Object.defineProperty;
var __getOwnPropDesc$T = Object.getOwnPropertyDescriptor;
var __decorateClass$V = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$T(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$T(target, key, result);
  return result;
};
const _Pipeline = class _Pipeline2 extends Entity$1 {
  constructor(p) {
    super();
    this.removeTasksAfterCompleteDeal = false;
    if (p) this.update(p);
  }
  static fromJson(json) {
    const pipeline = new _Pipeline2({
      id: json.id,
      type: json.type,
      name: json.name,
      description: json.description,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      fields: json.field,
      stages: json.stages ? json.stages.map(PipelineStage.fromJson) : void 0,
      stageCount: json.stageCount,
      itemCount: json.itemCount,
      autocompleteDealAfterCompleteOrders: json.autocompleteDealAfterCompleteOrders,
      removeTasksAfterCompleteDeal: json.removeTasksAfterCompleteDeal
    });
    if (pipeline.scenario)
      pipeline.scenario.update({ pipeline });
    return pipeline;
  }
  update(session) {
    super.update(session);
  }
};
__decorateClass$V([
  observable
], _Pipeline.prototype, "name", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "description", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "autocompleteDealAfterCompleteOrders", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "removeTasksAfterCompleteDeal", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "stages", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "fields", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "scenario", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "stageCount", 2);
__decorateClass$V([
  observable
], _Pipeline.prototype, "itemCount", 2);
__decorateClass$V([
  action
], _Pipeline.prototype, "update", 1);
let Pipeline = _Pipeline;
var __defProp$S = Object.defineProperty;
var __getOwnPropDesc$S = Object.getOwnPropertyDescriptor;
var __decorateClass$U = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$S(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$S(target, key, result);
  return result;
};
const _PipelineStage = class _PipelineStage2 extends Entity$1 {
  constructor(p) {
    super(p);
    this.requiredFieldIds = [];
    this.items = [];
    if (p) this.update(p);
  }
  static fromJson(json) {
    return new _PipelineStage2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      pipeline: json.pipeline ? Pipeline.fromJson(json.pipeline) : void 0,
      items: json.items ? json.items.map(PipelineStageItem.fromJson) : [],
      requiredFieldIds: json.fieldLinks ? json.fieldLinks.map((x) => x.fieldId) : json.requiredFieldIds ?? []
    });
  }
  clone(changes) {
    return new _PipelineStage2({
      ...this,
      items: this.items.slice(),
      ...changes
    });
  }
  update(session) {
    super.update(session);
  }
  static default() {
    return new _PipelineStage2({
      type: "custom",
      color: "#0693E3",
      inArchive: false,
      requiredFieldIds: [],
      totalAmount: 0,
      totalCount: 0,
      _newlyAdded: true
    });
  }
};
__decorateClass$U([
  observable
], _PipelineStage.prototype, "name", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "type", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "inArchive", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "lexorankPosition", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "color", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "requiredFieldIds", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "pipeline", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "totalCount", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "totalAmount", 2);
__decorateClass$U([
  observable
], _PipelineStage.prototype, "items", 2);
__decorateClass$U([
  action
], _PipelineStage.prototype, "update", 1);
let PipelineStage = _PipelineStage;
var __defProp$R = Object.defineProperty;
var __getOwnPropDesc$R = Object.getOwnPropertyDescriptor;
var __decorateClass$T = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$R(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$R(target, key, result);
  return result;
};
const _PipelineStageItem = class _PipelineStageItem2 extends Entity$1 {
  constructor(p) {
    super(p);
    if (p) this.update(p);
  }
  getFieldValue(fieldId) {
    const val = this.fieldValues.find((x) => x.customField.id == fieldId);
    return val ?? null;
  }
  setFieldValue(value) {
    const val = this.getFieldValue(value.customField.id);
    if (val) {
      val.update(value, true);
    } else {
      this.fieldValues.push(value);
    }
  }
  clone() {
    return new _PipelineStageItem2({
      ...this,
      fieldValues: this.fieldValues?.map((x) => x.copy()),
      tags: this.tags?.slice()
    });
  }
  static fromJson(json) {
    return new _PipelineStageItem2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      contact: json.contact ? Contact.fromJson(json.contact) : void 0,
      responsible: json.responsible ? Admin.fromJson(json.responsible) : json.responsible,
      tags: json.tagLinks ? json.tagLinks.map((x) => PipelineTag.fromJson(x.tag)) : void 0,
      fieldValues: json.fieldValues ? _PipelineStageItem2.parseFieldValuesFromJson(json) : void 0,
      stage: json.stage ? PipelineStage.fromJson(json.stage) : void 0,
      pipeline: json.pipeline ? Pipeline.fromJson(json.pipeline) : void 0
    });
  }
  static parseFieldValuesFromJson(json) {
    const customFieldValues = json.fieldValues.map(PipelineFieldValue.fromJson);
    const grouped = customFieldValues.groupBy((x) => x.customField.id);
    const result = [];
    grouped.forEach((x) => {
      const first = x[0];
      if (first.customField.type == CustomFieldType.MultiList) {
        const combinedValues = x.map((x2) => x2.valueMultiList).reduce((a, b) => [...a, ...b]);
        first.update({ valueMultiList: combinedValues });
      }
      result.push(first);
    });
    return result;
  }
  update(session, allowUndefined = false) {
    super.update(session, allowUndefined);
  }
};
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "number", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "stage", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "inArchive", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "lexorankPosition", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "dealAmount", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "revenue", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "responsible", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "contact", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "orderCount", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "adminTaskCount", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "outdated", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "tags", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "fieldValues", 2);
__decorateClass$T([
  observable
], _PipelineStageItem.prototype, "pipeline", 2);
__decorateClass$T([
  action
], _PipelineStageItem.prototype, "setFieldValue", 1);
__decorateClass$T([
  action
], _PipelineStageItem.prototype, "update", 1);
let PipelineStageItem = _PipelineStageItem;
var __defProp$Q = Object.defineProperty;
var __getOwnPropDesc$Q = Object.getOwnPropertyDescriptor;
var __decorateClass$S = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$Q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$Q(target, key, result);
  return result;
};
const _PipelineField = class _PipelineField2 extends CustomField {
  constructor(f) {
    super(f);
    this.stages = [];
    if (f) this.update(f);
  }
  clone(changes) {
    return new _PipelineField2({
      ...this,
      ...changes
    });
  }
  update(f, allowUndefined = false) {
    super.update(f, allowUndefined);
  }
  static default() {
    return new _PipelineField2({
      visible: true,
      required: false,
      type: CustomFieldType.Text,
      additionalData: JSON.stringify([]),
      stages: []
    });
  }
  static fromJson(json) {
    return new _PipelineField2({
      id: json.id,
      type: json.type,
      name: json.name,
      keyName: json.key,
      additionalData: json.additionalData,
      position: json.position,
      visible: json.visible,
      required: json.required,
      stages: json.stageLinks ? json.stageLinks.map((x) => PipelineStage.fromJson(x.stage)) : []
    });
  }
};
__decorateClass$S([
  observable
], _PipelineField.prototype, "stages", 2);
__decorateClass$S([
  action
], _PipelineField.prototype, "update", 1);
let PipelineField = _PipelineField;
var __defProp$P = Object.defineProperty;
var __getOwnPropDesc$P = Object.getOwnPropertyDescriptor;
var __decorateClass$R = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$P(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$P(target, key, result);
  return result;
};
const _PipelineTag = class _PipelineTag2 extends Entity$1 {
  constructor(t) {
    super(t);
    if (t) this.update(t);
  }
  static fromJson(json) {
    return new _PipelineTag2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0
    });
  }
  update(t) {
    super.update(t);
  }
  clone(t) {
    return new _PipelineTag2({
      ...this,
      ...t
    });
  }
};
__decorateClass$R([
  observable
], _PipelineTag.prototype, "name", 2);
__decorateClass$R([
  observable
], _PipelineTag.prototype, "color", 2);
__decorateClass$R([
  observable
], _PipelineTag.prototype, "position", 2);
__decorateClass$R([
  action
], _PipelineTag.prototype, "update", 1);
let PipelineTag = _PipelineTag;
var __defProp$O = Object.defineProperty;
var __getOwnPropDesc$O = Object.getOwnPropertyDescriptor;
var __decorateClass$Q = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$O(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$O(target, key, result);
  return result;
};
const _PipelineFieldValue = class _PipelineFieldValue2 extends CustomFieldValue {
  constructor(attr) {
    super(attr);
    if (attr) this.update(attr);
  }
  update(attr, allowUndefined = false) {
    super.update(attr, allowUndefined);
  }
  copy() {
    return new _PipelineFieldValue2({
      id: this.id,
      customField: this.customField,
      valueString: this.valueString,
      valueNumeric: this.valueNumeric,
      valueBoolean: this.valueBoolean,
      valueDateTime: this.valueDateTime,
      valueDate: this.valueDate,
      valueList: this.valueList,
      valueMultiList: this.valueMultiList?.slice()
    });
  }
  static fromJson(json) {
    const base = CustomFieldValue.fromJson(json);
    return new _PipelineFieldValue2({
      ...base,
      customField: json.field ? PipelineField.fromJson(json.field) : void 0
    });
  }
};
__decorateClass$Q([
  action
], _PipelineFieldValue.prototype, "update");
let PipelineFieldValue = _PipelineFieldValue;
var __defProp$N = Object.defineProperty;
var __getOwnPropDesc$N = Object.getOwnPropertyDescriptor;
var __decorateClass$P = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$N(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$N(target, key, result);
  return result;
};
const _Glossary = class _Glossary2 extends Entity$1 {
  constructor(glossary) {
    super(glossary);
    if (glossary) this.update(glossary);
  }
  addWord(defaultWord = "") {
    this.words.push({ id: KeyGenerator.generate(6), word: defaultWord });
  }
  addWords(words) {
    this.words.push(...words.map((x) => ({ id: KeyGenerator.generate(6), word: x })));
  }
  removeWord(key) {
    const indexToRemove = this.words.findIndex((item2) => item2.id === key);
    if (indexToRemove !== -1)
      this.words.splice(indexToRemove, 1);
  }
  update(glossary, allowUndefined = false) {
    super.update(glossary, allowUndefined);
  }
  static fromJson(json) {
    const glossary = new _Glossary2({
      id: json.id,
      title: json.title,
      description: json.description,
      words: json.words ? json.words.map((x) => ({ id: KeyGenerator.generate(6), word: x })) : [],
      wordsCount: json.wordsCount,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      softDeleted: json.softDeleted
    });
    return glossary;
  }
};
__decorateClass$P([
  observable
], _Glossary.prototype, "title", 2);
__decorateClass$P([
  observable
], _Glossary.prototype, "description", 2);
__decorateClass$P([
  observable
], _Glossary.prototype, "words", 2);
__decorateClass$P([
  observable
], _Glossary.prototype, "wordsCount", 2);
__decorateClass$P([
  observable
], _Glossary.prototype, "createdDate", 2);
__decorateClass$P([
  observable
], _Glossary.prototype, "updatedDate", 2);
__decorateClass$P([
  action
], _Glossary.prototype, "addWord", 1);
__decorateClass$P([
  action
], _Glossary.prototype, "addWords", 1);
__decorateClass$P([
  action
], _Glossary.prototype, "removeWord", 1);
__decorateClass$P([
  action
], _Glossary.prototype, "update", 1);
let Glossary = _Glossary;
var __defProp$M = Object.defineProperty;
var __getOwnPropDesc$M = Object.getOwnPropertyDescriptor;
var __decorateClass$O = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$M(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$M(target, key, result);
  return result;
};
var ApplicationType = /* @__PURE__ */ ((ApplicationType2) => {
  ApplicationType2["Custom"] = "custom";
  ApplicationType2["Telegram"] = "telegramGroups";
  ApplicationType2["MetaConversions"] = "metaConversions";
  ApplicationType2["YandexMetrika"] = "yandexMetrika";
  ApplicationType2["GoogleAnalytics"] = "googleAnalytics";
  return ApplicationType2;
})(ApplicationType || {});
const _Application = class _Application2 extends Entity$1 {
  constructor(application) {
    super(application);
    if (application) this.update(application);
  }
  update(application, allowUndefined = false) {
    super.update(application, allowUndefined);
  }
  static fromJson(json) {
    return new _Application2({
      id: json.id,
      title: json.title,
      description: json.description,
      shortDescription: json.shortDescription,
      type: json.type,
      pricingJson: json.pricingJson,
      softDeleted: json.softDeleted,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : null,
      school: json.school ? School.fromJson(json.school) : null,
      schoolAppsCount: json.schoolLinksCount ?? 0
    });
  }
};
__decorateClass$O([
  observable
], _Application.prototype, "title", 2);
__decorateClass$O([
  observable
], _Application.prototype, "description", 2);
__decorateClass$O([
  observable
], _Application.prototype, "shortDescription", 2);
__decorateClass$O([
  observable
], _Application.prototype, "pricingJson", 2);
__decorateClass$O([
  observable
], _Application.prototype, "createdDate", 2);
__decorateClass$O([
  observable
], _Application.prototype, "updatedDate", 2);
__decorateClass$O([
  observable
], _Application.prototype, "type", 2);
__decorateClass$O([
  observable
], _Application.prototype, "image", 2);
__decorateClass$O([
  observable
], _Application.prototype, "school", 2);
__decorateClass$O([
  observable
], _Application.prototype, "schoolAppsCount", 2);
__decorateClass$O([
  action
], _Application.prototype, "update", 1);
let Application = _Application;
class ApplicationSettings extends Updatable {
}
class TgGroupsApplicationSettings extends ApplicationSettings {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasBot;
  }
  get hasBot() {
    return !isEmpty(this.botId) && !isEmpty(this.botName);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  static fromJson(json) {
    return new TgGroupsApplicationSettings({ ...json });
  }
}
class MetaConversionsApplicationSettings extends ApplicationSettings {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && this.hasId;
  }
  get hasId() {
    return !isEmpty(this.id) && !isEmpty(this.name);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  static fromJson(json) {
    return new MetaConversionsApplicationSettings(json);
  }
}
class YandexMetrikaApplicationSettings extends ApplicationSettings {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && !isEmpty(this.counterId);
  }
  get isAccessTokenMasked() {
    return this.accessToken.slice(0, 3) === "***";
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  static fromJson(json) {
    return new YandexMetrikaApplicationSettings({ ...json });
  }
}
class GoogleAnalyticsApplicationSettings extends ApplicationSettings {
  constructor(s) {
    super();
    if (s) this.update(s);
  }
  get isValid() {
    return !isEmpty(this.accessToken) && !isEmpty(this.measurementId);
  }
  update(entity, allowUndefined = false) {
    super.update(entity, allowUndefined);
  }
  static fromJson(json) {
    return new GoogleAnalyticsApplicationSettings({ ...json });
  }
}
var __defProp$L = Object.defineProperty;
var __getOwnPropDesc$L = Object.getOwnPropertyDescriptor;
var __decorateClass$N = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$L(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$L(target, key, result);
  return result;
};
const _SchoolApplication = class _SchoolApplication2 extends Entity$1 {
  constructor(app) {
    super(app);
    if (app) this.update(app);
  }
  get settings() {
    if (isEmpty(this.settingsJson))
      return null;
    return JSON.parse(this.settingsJson);
  }
  get tgGroupsSettings() {
    return TgGroupsApplicationSettings.fromJson(this.settings ?? {});
  }
  get metaConversionsSettings() {
    return MetaConversionsApplicationSettings.fromJson(this.settings ?? {});
  }
  get yandexMetrikaSettings() {
    return YandexMetrikaApplicationSettings.fromJson(this.settings ?? {});
  }
  get googleAnalyticsSettings() {
    return GoogleAnalyticsApplicationSettings.fromJson(this.settings ?? {});
  }
  update(schoolApp, allowUndefined = false) {
    super.update(schoolApp, allowUndefined);
  }
  clone(entity) {
    return new _SchoolApplication2({
      id: this.id,
      title: this.title,
      type: this.type,
      settingsJson: this.settingsJson,
      softDeleted: this.softDeleted,
      softDeletedDate: this.softDeletedDate,
      createdDate: this.createdDate,
      updatedDate: this.updatedDate,
      application: this.application,
      webhookInvalidated: this.webhookInvalidated,
      sites: this.sites.map((x) => x.clone()),
      ...entity
    });
  }
  hasChanges(app) {
    return this.title !== app.title || this.type !== app.type || this.settingsJson !== app.settingsJson || !this.sites.isEquals(app.sites, (a, b, aIndex, bIndex) => aIndex == bIndex && !a.hasChanges(b));
  }
  static fromJson(json) {
    return new _SchoolApplication2({
      id: json.id,
      title: json.title,
      type: json.type,
      settingsJson: json.settingsJson,
      softDeleted: json.softDeleted,
      softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      webhookInvalidated: json.webhookInvalidated,
      application: json.application ? Application.fromJson(json.application) : void 0,
      sites: json.integrations ? json.integrations.map((x) => Site.fromJson(x.site)) : []
    });
  }
};
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "title", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "type", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "settingsJson", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "createdDate", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "updatedDate", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "webhookInvalidated", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "application", 2);
__decorateClass$N([
  observable
], _SchoolApplication.prototype, "sites", 2);
__decorateClass$N([
  computed
], _SchoolApplication.prototype, "settings", 1);
__decorateClass$N([
  computed
], _SchoolApplication.prototype, "tgGroupsSettings", 1);
__decorateClass$N([
  computed
], _SchoolApplication.prototype, "metaConversionsSettings", 1);
__decorateClass$N([
  computed
], _SchoolApplication.prototype, "yandexMetrikaSettings", 1);
__decorateClass$N([
  computed
], _SchoolApplication.prototype, "googleAnalyticsSettings", 1);
__decorateClass$N([
  action
], _SchoolApplication.prototype, "update", 1);
let SchoolApplication = _SchoolApplication;
var __defProp$K = Object.defineProperty;
var __getOwnPropDesc$K = Object.getOwnPropertyDescriptor;
var __decorateClass$M = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$K(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$K(target, key, result);
  return result;
};
const _TelegramGroup = class _TelegramGroup2 extends Entity$1 {
  constructor(g) {
    super(g);
    if (g) this.update(g);
  }
  update(g, allowUndefined = false) {
    super.update(g, allowUndefined);
  }
  static fromJson(json) {
    return new _TelegramGroup2({
      id: json.id,
      name: json.name,
      status: json.status,
      keyPhrase: json.keyPhrase,
      externalId: json.externalId,
      externalName: json.externalName,
      owner: json.owner ? TelegramGroupUser.fromJson(json.owner) : void 0,
      description: json.description,
      excludeNonExistingUsers: json.excludeNonExistingUsers,
      softDeleted: json.softDeleted,
      softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      schoolApp: json.schoolLink ? SchoolApplication.fromJson(json.schoolLink) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : null,
      usersCount: json.usersCount ?? 0,
      requestedUsersCount: json.requestedUsersCount ?? 0
    });
  }
};
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "name", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "keyPhrase", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "status", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "createdDate", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "updatedDate", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "description", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "schoolApp", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "image", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "excludeNonExistingUsers", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "scenario", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "usersCount", 2);
__decorateClass$M([
  observable
], _TelegramGroup.prototype, "requestedUsersCount", 2);
__decorateClass$M([
  action
], _TelegramGroup.prototype, "update", 1);
let TelegramGroup = _TelegramGroup;
var __defProp$J = Object.defineProperty;
var __getOwnPropDesc$J = Object.getOwnPropertyDescriptor;
var __decorateClass$L = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$J(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$J(target, key, result);
  return result;
};
const _TelegramGroupUser = class _TelegramGroupUser2 extends Entity$1 {
  constructor(user2) {
    super(user2);
    if (user2) this.update(user2);
  }
  update(g, allowUndefined = false) {
    super.update(g, allowUndefined);
  }
  static fromJson(json) {
    return new _TelegramGroupUser2({
      id: json.id,
      state: json.state,
      softDeleted: json.softDeleted,
      isBot: json.isBot,
      softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : void 0,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      group: json.group ? TelegramGroup.fromJson(json.group) : void 0,
      communication: json.studentCommunication ? ContactCommunication.fromJson(json.studentCommunication) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : void 0
    });
  }
};
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "state", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "createdDate", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "updatedDate", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "group", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "communication", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "image", 2);
__decorateClass$L([
  observable
], _TelegramGroupUser.prototype, "isBot", 2);
__decorateClass$L([
  action
], _TelegramGroupUser.prototype, "update", 1);
let TelegramGroupUser = _TelegramGroupUser;
var __defProp$I = Object.defineProperty;
var __getOwnPropDesc$I = Object.getOwnPropertyDescriptor;
var __decorateClass$K = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$I(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$I(target, key, result);
  return result;
};
const _BillingPromoCode = class _BillingPromoCode2 extends Entity$1 {
  constructor(code) {
    super(code);
    if (code) this.update(code);
  }
  get endless() {
    return !this.beginDate && !this.endDate;
  }
  clone() {
    return new _BillingPromoCode2({
      ...this
    });
  }
  static fromJson(json) {
    return new _BillingPromoCode2({
      ...json,
      id: json.id,
      name: json.name,
      code: json.code,
      type: json.type,
      description: json.description,
      bonusBalance: json.bonusBalance,
      trialDaysCount: json.trialDaysCount,
      beginDate: json.beginDate ? moment(json.beginDate) : null,
      endDate: json.endDate ? moment(json.endDate) : null,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      billingPlan: json.billingPlan ? BillingPlan.fromJson(json.billingPlan) : null
    });
  }
  update(t, allowUndefined = false) {
    super.update(t, allowUndefined);
  }
};
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "name", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "code", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "type", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "description", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "bonusBalance", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "trialDaysCount", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "beginDate", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "endDate", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "createdDate", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "updatedDate", 2);
__decorateClass$K([
  observable
], _BillingPromoCode.prototype, "billingPlan", 2);
__decorateClass$K([
  computed
], _BillingPromoCode.prototype, "endless", 1);
__decorateClass$K([
  action
], _BillingPromoCode.prototype, "update", 1);
let BillingPromoCode = _BillingPromoCode;
var SharedSettingsEntityType = /* @__PURE__ */ ((SharedSettingsEntityType2) => {
  SharedSettingsEntityType2["SitePage"] = "sitePage";
  return SharedSettingsEntityType2;
})(SharedSettingsEntityType || {});
var __defProp$H = Object.defineProperty;
var __getOwnPropDesc$H = Object.getOwnPropertyDescriptor;
var __decorateClass$J = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$H(target, key, result);
  return result;
};
const _SharedSettingsExport = class _SharedSettingsExport2 extends Entity$1 {
  constructor(ex) {
    super();
    if (ex) this.update(ex);
  }
  get targets() {
    const map = /* @__PURE__ */ new Map();
    this.entities.forEach((e) => {
      switch (e.type) {
        case SharedSettingsEntityType.SitePage:
          map.set("site", true);
          break;
      }
    });
    return Array.from(map.keys());
  }
  update(session) {
    super.update(session);
  }
  static fromJson(json) {
    return new _SharedSettingsExport2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      createdByAdmin: json.createdByAdmin ? Admin.fromJson(json.createdByAdmin) : void 0,
      entities: json.entities ? json.entities.map(SharedSettingsExportEntity.fromJson) : void 0,
      contactFilter: new ExtendedFilter({ filterJson: json.contactFilterJson })
    });
  }
};
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "name", 2);
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "description", 2);
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "reexportProhibited", 2);
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "contactFilter", 2);
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "accessType", 2);
__decorateClass$J([
  observable
], _SharedSettingsExport.prototype, "entities", 2);
__decorateClass$J([
  action
], _SharedSettingsExport.prototype, "update", 1);
let SharedSettingsExport = _SharedSettingsExport;
var __defProp$G = Object.defineProperty;
var __getOwnPropDesc$G = Object.getOwnPropertyDescriptor;
var __decorateClass$I = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$G(target, key, result);
  return result;
};
const _SharedSettingsExportEntity = class _SharedSettingsExportEntity2 extends Entity$1 {
  constructor(en) {
    super();
    if (en)
      this.update(en);
  }
  update(session) {
    super.update(session);
  }
  toJson() {
    return {
      sitePageId: this.sitePage?.id
    };
  }
  static fromJson(json) {
    return new _SharedSettingsExportEntity2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      export: json.export ? SharedSettingsExport.fromJson(json.export) : void 0,
      sitePage: json.sitePage ? SitePage.fromJson(json.sitePage) : void 0
    });
  }
};
__decorateClass$I([
  observable
], _SharedSettingsExportEntity.prototype, "type", 2);
__decorateClass$I([
  observable
], _SharedSettingsExportEntity.prototype, "export", 2);
__decorateClass$I([
  observable
], _SharedSettingsExportEntity.prototype, "sitePage", 2);
__decorateClass$I([
  action
], _SharedSettingsExportEntity.prototype, "update", 1);
let SharedSettingsExportEntity = _SharedSettingsExportEntity;
var __defProp$F = Object.defineProperty;
var __getOwnPropDesc$F = Object.getOwnPropertyDescriptor;
var __decorateClass$H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$F(target, key, result);
  return result;
};
const _SharedSettingsImport = class _SharedSettingsImport2 extends Entity$1 {
  constructor(i) {
    super();
    if (i) this.update(i);
  }
  update(session) {
    super.update(session);
  }
  static fromJson(json) {
    return new _SharedSettingsImport2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      export: json.export ? SharedSettingsExport.fromJson(json.export) : void 0,
      site: json.site ? Site.fromJson(json.site) : void 0,
      createdByAdmin: json.createdByAdmin ? Admin.fromJson(json.createdByAdmin) : void 0,
      entities: json.entities ? json.entities.map(SharedSettingsImportEntity.fromJson) : void 0,
      school: json.school ? School.fromJson(json.school) : void 0
    });
  }
};
__decorateClass$H([
  observable
], _SharedSettingsImport.prototype, "status", 2);
__decorateClass$H([
  observable
], _SharedSettingsImport.prototype, "errorMsg", 2);
__decorateClass$H([
  observable
], _SharedSettingsImport.prototype, "email", 2);
__decorateClass$H([
  observable
], _SharedSettingsImport.prototype, "export", 2);
__decorateClass$H([
  observable
], _SharedSettingsImport.prototype, "site", 2);
__decorateClass$H([
  action
], _SharedSettingsImport.prototype, "update", 1);
let SharedSettingsImport = _SharedSettingsImport;
var __defProp$E = Object.defineProperty;
var __getOwnPropDesc$E = Object.getOwnPropertyDescriptor;
var __decorateClass$G = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$E(target, key, result);
  return result;
};
const _SharedSettingsImportEntity = class _SharedSettingsImportEntity2 extends Entity$1 {
  constructor(en) {
    super();
    if (en)
      this.update(en);
  }
  update(session) {
    super.update(session);
  }
  static fromJson(json) {
    return new _SharedSettingsImportEntity2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      import: json.import ? SharedSettingsImport.fromJson(json.import) : void 0,
      sitePage: json.sitePage ? SitePage.fromJson(json.sitePage) : void 0
    });
  }
};
__decorateClass$G([
  observable
], _SharedSettingsImportEntity.prototype, "type", 2);
__decorateClass$G([
  observable
], _SharedSettingsImportEntity.prototype, "import", 2);
__decorateClass$G([
  observable
], _SharedSettingsImportEntity.prototype, "sitePage", 2);
__decorateClass$G([
  action
], _SharedSettingsImportEntity.prototype, "update", 1);
let SharedSettingsImportEntity = _SharedSettingsImportEntity;
var __defProp$D = Object.defineProperty;
var __getOwnPropDesc$D = Object.getOwnPropertyDescriptor;
var __decorateClass$F = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc$D(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$D(target, key, result);
  return result;
};
class EmailTemplate extends Entity$1 {
  constructor(profile) {
    super(profile);
    if (profile) this.update(profile);
  }
  update(item2) {
    super.update(item2);
  }
}
__decorateClass$F([
  action
], EmailTemplate.prototype, "update");
class UtmContainer extends Updatable {
  constructor(utm) {
    super();
    if (utm) this.update(utm);
  }
  get isEmpty() {
    return !this.campaign && !this.content && !this.medium && !this.source && !this.term;
  }
  update(utm, allowUndefined = false) {
    super.update(utm, allowUndefined);
  }
  toJson() {
    return {
      utmCampaign: this.campaign,
      utmContent: this.content,
      utmMedium: this.medium,
      utmSource: this.source,
      utmTerm: this.term
    };
  }
  static fromJson(json) {
    return new UtmContainer({
      campaign: json.utmCampaign ?? json.campaign,
      content: json.utmContent ?? json.content,
      medium: json.utmMedium ?? json.medium,
      source: json.utmSource ?? json.source,
      term: json.utmTerm ?? json.term
    });
  }
}
var __defProp$C = Object.defineProperty;
var __getOwnPropDesc$C = Object.getOwnPropertyDescriptor;
var __decorateClass$E = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$C(target, key, result);
  return result;
};
const _Partnership = class _Partnership2 extends Entity$1 {
  constructor(partnership) {
    super();
    this.deductionEnabled = false;
    if (partnership) this.update(partnership);
  }
  get isSingleLevel() {
    return this.levelCount === 1;
  }
  toJson() {
    return {
      ...this,
      partnershipVisibleToGroupId: this.partnershipVisibleToGroup === null ? null : this.partnershipVisibleToGroup?.id,
      // skip some fields just in case,
      partnershipVisibleToGroup: void 0,
      scenario: void 0
    };
  }
  clone() {
    return new _Partnership2({
      ...this
    });
  }
  update(partnership, allowUndefined = false) {
    super.update(partnership, allowUndefined);
  }
  hasChanges(settings) {
    return Object.keys(settings).some((key) => settings[key] !== this[key]);
  }
  static fromJson(json) {
    const partnership = new _Partnership2({
      ...json,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      partnershipVisibleToGroup: json.partnershipVisibleToGroup ? ContactGroup.fromJson(json.partnershipVisibleToGroup) : void 0
    });
    if (partnership.scenario)
      partnership.scenario.update({ partnership });
    return partnership;
  }
};
__decorateClass$E([
  observable
], _Partnership.prototype, "isActive", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "agreementRequired", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "agreementText", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "agreementUrl", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnerAssigningCookieDurationDays", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnerAssigningDurationType", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnerAssigningDurationDays", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferBonusPartner", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferBonusPartnerAmount", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferBonusReferral", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferBonusReferralAmount", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferFeeMethod", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferFeeAllowed", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferFeeAllowedToBonus", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferFeeMinAmount", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "transferFeeHoldingPeriodDays", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnershipVisible", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnershipVisibleToGroup", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnershipPaidOrdersVisible", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnershipAllOrdersVisible", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "partnershipOrdersContactVisible", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "paymentGatewayFeeEnabled", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "deductionEnabled", 2);
__decorateClass$E([
  observable
], _Partnership.prototype, "levelCount", 2);
__decorateClass$E([
  computed
], _Partnership.prototype, "isSingleLevel", 1);
__decorateClass$E([
  observable
], _Partnership.prototype, "scenario", 2);
__decorateClass$E([
  action
], _Partnership.prototype, "update", 1);
let Partnership = _Partnership;
var __defProp$B = Object.defineProperty;
var __getOwnPropDesc$B = Object.getOwnPropertyDescriptor;
var __decorateClass$D = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$B(target, key, result);
  return result;
};
const _PartnershipTransaction = class _PartnershipTransaction2 extends Entity$1 {
  constructor(t) {
    super();
    if (t) this.update(t);
  }
  get contact() {
    return this.order?.contact;
  }
  get canWithdraw() {
    return this.validAfterDate && this.validAfterDate.isBefore(moment());
  }
  update(partnership) {
    super.update(partnership);
  }
  toJson() {
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      fee: this.fee,
      comment: this.comment,
      partnerId: this.partner?.id,
      contactId: this.contact?.id,
      orderId: this.order?.id,
      useBonus: this.useBonus,
      level: this.level,
      levelPartnerId: this.levelPartner?.id
    };
  }
  clone() {
    return new _PartnershipTransaction2({
      ...this,
      partner: this.partner?.clone(),
      contact: this.contact?.clone(),
      adminCreator: this.adminCreator?.clone(),
      order: this.order?.clone()
    });
  }
  static fromJson(json) {
    return new _PartnershipTransaction2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      partner: json.partner ? Contact.fromJson(json.partner) : void 0,
      order: json.order ? PurchaseOrder.fromJson(json.order) : void 0,
      validAfterDate: json.validAfterDate ? moment(json.validAfterDate) : void 0,
      adminCreator: json.adminCreator ? Admin.fromJson(json.adminCreator) : void 0,
      levelPartner: json.levelPartner ? Contact.fromJson(json.levelPartner) : void 0
    });
  }
  static default() {
    return new _PartnershipTransaction2({
      fee: 0,
      type: "deposit"
    });
  }
};
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "amount", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "fee", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "useBonus", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "comment", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "createdDate", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "updatedDate", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "partner", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "adminCreator", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "type", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "order", 2);
__decorateClass$D([
  observable
], _PartnershipTransaction.prototype, "validAfterDate", 2);
__decorateClass$D([
  computed
], _PartnershipTransaction.prototype, "contact", 1);
__decorateClass$D([
  computed
], _PartnershipTransaction.prototype, "canWithdraw", 1);
__decorateClass$D([
  action
], _PartnershipTransaction.prototype, "update", 1);
let PartnershipTransaction = _PartnershipTransaction;
var __defProp$A = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$C = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$A(target, key, result);
  return result;
};
const _PartnershipMember = class _PartnershipMember2 extends Entity$1 {
  constructor(partnership) {
    super();
    if (partnership) this.update(partnership);
  }
  toJson() {
    return {
      id: this.id,
      acceptedDate: this.acceptedDate,
      studentId: this.contact?.id
    };
  }
  clone() {
    return new _PartnershipMember2({
      ...this,
      contact: this.contact?.clone()
    });
  }
  update(partnership) {
    super.update(partnership);
  }
  static fromJson(json) {
    return new _PartnershipMember2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      contact: json.student ? Contact.fromJson(json.student) : null,
      acceptedDate: json.acceptedDate ? moment(json.acceptedDate) : null
    });
  }
};
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "isActive", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "navigationCount", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "registrationCount", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "amount", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "fee", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "availableFee", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "createdDate", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "updatedDate", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "acceptedDate", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "contact", 2);
__decorateClass$C([
  observable
], _PartnershipMember.prototype, "code", 2);
__decorateClass$C([
  action
], _PartnershipMember.prototype, "update", 1);
var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$B = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$z(target, key, result);
  return result;
};
const _PartnershipOffer = class _PartnershipOffer2 extends Entity$1 {
  constructor(t) {
    super();
    if (t) this.update(t);
  }
  toJson() {
    return {
      id: this.id,
      title: this.title,
      url: this.url,
      urls: this.urls,
      description: this.description,
      isActive: this.isActive,
      feeType: this.feeType,
      productType: this.productType,
      partnerType: this.partnerType,
      purchaseType: this.purchaseType,
      productIds: this.products.map((p) => p.id),
      partnerIds: this.partners.map((p) => p.id),
      partnerGroupIds: this.partnerGroups?.map((p) => p.id),
      levels: this.levels
    };
  }
  update(partnership) {
    super.update(partnership);
  }
  static fromJson(json) {
    return new _PartnershipOffer2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      urls: json.urlsJson ? JSON.parse(json.urlsJson) : void 0,
      products: json.productLinks ? json.productLinks.map((x) => Product.fromJson(x.product)) : void 0,
      partners: json.partnerLinks ? json.partnerLinks.map((x) => Contact.fromJson(x.partner)) : void 0,
      partnerGroups: json.partnerGroupLinks ? json.partnerGroupLinks.map((x) => ContactGroup.fromJson(x.group)) : void 0
    });
  }
};
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "title", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "url", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "urls", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "description", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "isActive", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "createdDate", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "updatedDate", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "fee", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "feeType", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "productType", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "partnerType", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "purchaseType", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "products", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "partners", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "partnerGroups", 2);
__decorateClass$B([
  observable
], _PartnershipOffer.prototype, "levels", 2);
__decorateClass$B([
  action
], _PartnershipOffer.prototype, "update", 1);
var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$y(target, key, result);
  return result;
};
const _PartnershipTransactionRequest = class _PartnershipTransactionRequest2 extends Entity$1 {
  constructor(t) {
    super();
    if (t) this.update(t);
  }
  toJson() {
    return {
      id: this.id,
      amount: this.amount,
      partnerComment: this.partnerComment,
      adminComment: this.adminComment,
      status: this.status,
      partnerId: this.partner?.id
    };
  }
  update(partnership) {
    super.update(partnership);
  }
  static fromJson(json) {
    return new _PartnershipTransactionRequest2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      partner: json.partner ? Contact.fromJson(json.partner) : void 0,
      admin: json.admin ? Admin.fromJson(json.admin) : void 0
    });
  }
};
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "amount", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "partnerComment", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "adminComment", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "status", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "createdDate", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "updatedDate", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "partner", 2);
__decorateClass$A([
  observable
], _PartnershipTransactionRequest.prototype, "admin", 2);
__decorateClass$A([
  action
], _PartnershipTransactionRequest.prototype, "update", 1);
var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$x(target, key, result);
  return result;
};
const _StudentBonusTransaction = class _StudentBonusTransaction2 extends Entity$1 {
  constructor(t) {
    super();
    if (t) this.update(t);
  }
  clone() {
    return new _StudentBonusTransaction2({
      ...this
    });
  }
  toJson() {
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      comment: this.comment,
      studentId: this.contact?.id,
      orderId: this.order?.id,
      duration: this.duration,
      durationType: this.durationType,
      validUntilDate: this.validUntilDate
    };
  }
  update(partnership) {
    super.update(partnership);
  }
  static fromJson(json) {
    return new _StudentBonusTransaction2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      validUntilDate: json.validUntilDate ? moment(json.validUntilDate) : null,
      contact: json.student ? Contact.fromJson(json.student) : void 0,
      admin: json.adminCreator ? Admin.fromJson(json.adminCreator) : void 0,
      order: json.order ? PurchaseOrder.fromJson(json.order) : void 0,
      transaction: json.transaction ? PartnershipTransaction.fromJson(json.transaction) : void 0,
      burnedTransaction: json.burnedTransaction ? _StudentBonusTransaction2.fromJson(json.burnedTransaction) : void 0
    });
  }
  static default() {
    return new _StudentBonusTransaction2({
      amount: 0,
      type: "deposit"
    });
  }
};
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "amount", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "comment", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "createdDate", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "updatedDate", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "contact", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "admin", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "order", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "type", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "transaction", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "burnedTransaction", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "duration", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "durationType", 2);
__decorateClass$z([
  observable
], _StudentBonusTransaction.prototype, "validUntilDate", 2);
__decorateClass$z([
  action
], _StudentBonusTransaction.prototype, "update", 1);
var __defProp$w = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$w(target, key, result);
  return result;
};
const _Cert = class _Cert2 extends Entity$1 {
  constructor(c) {
    super();
    if (c) this.update(c);
  }
  get nextPadNumber() {
    return this.usePadLeft ? this.nextNumber.toString().padStart(this.padLeftLength ?? 0, "0") : this.nextNumber.toString();
  }
  get nextSerialNumber() {
    return `${this.serialNumber ?? ""}${this.nextPadNumber}`;
  }
  toJson() {
    return {
      id: this.id,
      name: this.name,
      imageId: this.image === null ? null : this.image?.id,
      settingsJson: JSON.stringify(this.settings?.toJson()),
      items: this.items?.map((i) => i.toJson()),
      serialNumber: this.serialNumber,
      usePadLeft: this.usePadLeft,
      padLeftLength: this.padLeftLength
    };
  }
  clone() {
    return new _Cert2({
      ...this,
      settings: this.settings?.clone(),
      items: this.items?.map((i) => i.clone())
    });
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  hasChanges(cert) {
    return this.name != cert.name || this.serialNumber != cert.serialNumber || this.usePadLeft != cert.usePadLeft || this.padLeftLength != cert.padLeftLength || this.settings.hasChanges(cert.settings) || !this.items.isEquals(cert.items, (a, b, aIndex, bIndex) => aIndex == bIndex && !a.hasChanges(b));
  }
  static default() {
    return new _Cert2({
      settings: CertSettings.default()
    });
  }
  static fromJson(json) {
    const cert = new _Cert2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      image: json.image ? AccelFile.fromJson(json.image) : null,
      settings: json.settingsJson ? CertSettings.fromJson(JSON.parse(json.settingsJson)) : void 0,
      scenario: json.scenario ? Scenario.fromJson(json.scenario) : void 0,
      items: json.items ? json.items.map(CertItem.fromJson) : []
    });
    if (cert.scenario)
      cert.scenario.update({ cert });
    return cert;
  }
};
__decorateClass$y([
  observable
], _Cert.prototype, "name", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "settingsJson", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "settings", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "releasedCount", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "serialNumber", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "nextNumber", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "usePadLeft", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "padLeftLength", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "createdDate", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "updatedDate", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "image", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "items", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "courses", 2);
__decorateClass$y([
  observable
], _Cert.prototype, "scenario", 2);
__decorateClass$y([
  computed
], _Cert.prototype, "nextPadNumber", 1);
__decorateClass$y([
  computed
], _Cert.prototype, "nextSerialNumber", 1);
__decorateClass$y([
  action
], _Cert.prototype, "update", 1);
let Cert = _Cert;
var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$v(target, key, result);
  return result;
};
const _CertSettings = class _CertSettings2 extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  get width() {
    switch (this.layout) {
      case "a4Portrait":
        return 1240;
      case "a4Landscape":
        return 1754;
      case "custom":
        return this.customWidth;
    }
  }
  get height() {
    switch (this.layout) {
      case "a4Portrait":
        return 1754;
      case "a4Landscape":
        return 1240;
      case "custom":
        return this.customHeight;
    }
  }
  get size() {
    return {
      width: this.width,
      height: this.height
    };
  }
  get aspectRatio() {
    return this.width / this.height;
  }
  toJson() {
    return {
      ...this
    };
  }
  clone(changes) {
    return new _CertSettings2({
      ...this,
      ...changes
    });
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  hasChanges(settings) {
    return this.bgColor != settings.bgColor || this.bgImageUrl != settings.bgImageUrl || this.fontFamily != settings.fontFamily || this.layout != settings.layout || this.customHeight != settings.customHeight || this.customWidth != settings.customWidth;
  }
  static fromJson(json) {
    return new _CertSettings2({
      ...json
    });
  }
  static default(changes) {
    return new _CertSettings2({
      layout: "a4Landscape",
      customHeight: 1754,
      customWidth: 1240,
      bgColor: "#FFFFFF",
      bgImageUrl: null,
      fontFamily: "Roboto",
      ...changes
    });
  }
};
__decorateClass$x([
  observable
], _CertSettings.prototype, "layout", 2);
__decorateClass$x([
  observable
], _CertSettings.prototype, "customWidth", 2);
__decorateClass$x([
  observable
], _CertSettings.prototype, "customHeight", 2);
__decorateClass$x([
  computed
], _CertSettings.prototype, "width", 1);
__decorateClass$x([
  computed
], _CertSettings.prototype, "height", 1);
__decorateClass$x([
  computed
], _CertSettings.prototype, "size", 1);
__decorateClass$x([
  computed
], _CertSettings.prototype, "aspectRatio", 1);
__decorateClass$x([
  observable
], _CertSettings.prototype, "bgImageUrl", 2);
__decorateClass$x([
  observable
], _CertSettings.prototype, "bgColor", 2);
__decorateClass$x([
  observable
], _CertSettings.prototype, "fontFamily", 2);
__decorateClass$x([
  action
], _CertSettings.prototype, "update", 1);
let CertSettings = _CertSettings;
class CertSettingsFactory {
  static parse(type4, settingsJson) {
    const settings = settingsJson ? JSON.parse(settingsJson) : {};
    switch (type4) {
      case "text":
        return new CertItemTextSettings(settings);
      case "image":
        return new CertItemImageSettings(settings);
      default:
        return new CertItemSettings(settings);
    }
  }
  static default(type4, cert) {
    switch (type4) {
      case "text":
        return CertItemTextSettings.default({ zIndex: cert.items.length + 1 });
      case "image":
        return CertItemImageSettings.default();
      default:
        return CertItemTextSettings.default();
    }
  }
}
var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$u(target, key, result);
  return result;
};
const _CertItem = class _CertItem2 extends Entity$1 {
  constructor(c) {
    super();
    if (c) this.update(c);
  }
  toJson() {
    return {
      id: this.id,
      type: this.type,
      subType: this.subType,
      settingsJson: JSON.stringify(this.settings.toJson()),
      value: this.value,
      metaJson: this.meta ? JSON.stringify(this.meta) : void 0,
      // for sorting without parsing settings on server
      zIndex: this.settings.zIndex
    };
  }
  clone() {
    return new _CertItem2({
      ...this,
      //@ts-ignore
      meta: this.meta,
      settings: this.settings.clone()
    });
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  hasChanges(item2) {
    return this.type != item2.type || this.subType != item2.subType || this.settings.hasChanges(item2.settings) || this.value != item2.value;
  }
  static fromJson(json) {
    return new _CertItem2({
      ...json,
      meta: json.metaJson ? JSON.parse(json.metaJson) : void 0,
      settings: json.settingsJson ? CertSettingsFactory.parse(json.type, json.settingsJson) : void 0
    });
  }
};
__decorateClass$w([
  observable
], _CertItem.prototype, "settings", 2);
__decorateClass$w([
  observable
], _CertItem.prototype, "meta", 2);
__decorateClass$w([
  observable
], _CertItem.prototype, "value", 2);
__decorateClass$w([
  action
], _CertItem.prototype, "update", 1);
let CertItem = _CertItem;
var __defProp$t = Object.defineProperty;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$t(target, key, result);
  return result;
};
class CertItemSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  toJson() {
    return {
      ...this
    };
  }
  hasChanges(settings) {
    return this.positionX != settings.positionX || this.positionY != settings.positionY || this.scaleX != settings.scaleX || this.scaleY != settings.scaleY || this.zIndex != settings.zIndex || this.width != settings.width || this.height != settings.height || this.angle != settings.angle;
  }
}
__decorateClass$v([
  observable
], CertItemSettings.prototype, "positionX");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "positionY");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "scaleX");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "scaleY");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "zIndex");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "width");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "height");
__decorateClass$v([
  observable
], CertItemSettings.prototype, "angle");
var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$s(target, key, result);
  return result;
};
const _CertItemTextSettings = class _CertItemTextSettings2 extends CertItemSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  clone() {
    return new _CertItemTextSettings2(this);
  }
  toJson() {
    return {
      ...this
    };
  }
  hasChanges(settings) {
    return this.fontFamily != settings.fontFamily || this.fontSize != settings.fontSize || this.fontColor != settings.fontColor || this.italic != settings.italic || this.bold != settings.bold || this.strikethrough != settings.strikethrough || this.underline != settings.underline || this.textAlign != settings.textAlign || super.hasChanges(settings);
  }
  static default(changes) {
    return new _CertItemTextSettings2({
      angle: 0,
      bold: false,
      fontSize: 60,
      fontColor: "#000000",
      fontFamily: null,
      italic: false,
      strikethrough: false,
      textAlign: "center",
      underline: false,
      positionX: 0,
      positionY: 0,
      scaleX: 1,
      scaleY: 1,
      width: 300,
      height: 50,
      ...changes
    });
  }
};
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "fontFamily", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "fontSize", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "fontColor", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "italic", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "bold", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "strikethrough", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "underline", 2);
__decorateClass$u([
  observable
], _CertItemTextSettings.prototype, "textAlign", 2);
__decorateClass$u([
  action
], _CertItemTextSettings.prototype, "update", 1);
let CertItemTextSettings = _CertItemTextSettings;
var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$r(target, key, result);
  return result;
};
const _CertItemImageSettings = class _CertItemImageSettings2 extends CertItemSettings {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  recalculateScale() {
    this.scaleX = this.imageWidth == 0 ? 1 : this.width / this.imageWidth;
    this.scaleY = this.imageHeight == 0 ? 1 : this.height / this.imageHeight;
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  clone() {
    return new _CertItemImageSettings2(this);
  }
  hasChanges(settings) {
    return this.imageUrl != settings.imageUrl || this.imageWidth != settings.imageWidth || this.imageHeight != settings.imageHeight || super.hasChanges(settings);
  }
  static default(changes) {
    return new _CertItemImageSettings2({
      angle: 0,
      imageUrl: null,
      imageWidth: 0,
      imageHeight: 0,
      positionX: 0,
      positionY: 0,
      scaleX: 1,
      scaleY: 1,
      // TODO auto detect size of placeholder
      width: 416,
      height: 234,
      ...changes
    });
  }
};
__decorateClass$t([
  observable
], _CertItemImageSettings.prototype, "imageUrl", 2);
__decorateClass$t([
  observable
], _CertItemImageSettings.prototype, "imageWidth", 2);
__decorateClass$t([
  observable
], _CertItemImageSettings.prototype, "imageHeight", 2);
__decorateClass$t([
  action
], _CertItemImageSettings.prototype, "recalculateScale", 1);
__decorateClass$t([
  action
], _CertItemImageSettings.prototype, "update", 1);
let CertItemImageSettings = _CertItemImageSettings;
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$q(target, key, result);
  return result;
};
const _ContactCert = class _ContactCert2 extends Entity$1 {
  constructor(c) {
    super();
    if (c) this.update(c);
  }
  toJson() {
    this.cert.image.id;
    return {
      id: this.id,
      number: this.number,
      certId: this.cert === null ? null : this.cert?.id,
      contactId: this.contact === null ? null : this.contact?.id,
      courseId: this.course === null ? null : this.course?.id
    };
  }
  clone() {
    return new _ContactCert2({
      ...this,
      cert: this.cert.clone(),
      contact: this.contact.clone(),
      course: this.course.clone()
    });
  }
  update(c, allowUndefined = false) {
    super.update(c, allowUndefined);
  }
  hasChanges(settings) {
    return Object.keys(settings).some((key) => settings[key] !== this[key]);
  }
  static fromJson(json) {
    const cert = new _ContactCert2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
      cert: json.cert ? Cert.fromJson(json.cert) : void 0,
      contact: json.contact ? Contact.fromJson(json.contact) : void 0,
      course: json.course ? Course.fromJson(json.course) : void 0,
      image: json.image ? AccelFile.fromJson(json.image) : void 0
    });
    return cert;
  }
};
__decorateClass$s([
  observable
], _ContactCert.prototype, "number", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "cert", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "contact", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "course", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "image", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "createdDate", 2);
__decorateClass$s([
  observable
], _ContactCert.prototype, "updatedDate", 2);
__decorateClass$s([
  action
], _ContactCert.prototype, "update", 1);
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$p(target, key, result);
  return result;
};
const _Announcement = class _Announcement2 extends Entity$1 {
  constructor(announcement) {
    super();
    if (announcement) this.update(announcement);
  }
  get isActive() {
    return moment().isBetween(this.beginDate, this.endDate);
  }
  toJson() {
    return {
      id: this.id,
      name: this.name,
      text: this.text,
      lang: this.lang,
      isAdmin: this.isAdmin,
      isSchool: this.isSchool,
      isPublished: this.isPublished,
      showOnlyForMigratedSchool: this.showOnlyForMigratedSchool,
      beginDate: this.beginDate?.toISOString() ?? null,
      endDate: this.endDate?.toISOString()
    };
  }
  clone() {
    return new _Announcement2({
      ...this
    });
  }
  update(announcement, allowUndefined = false) {
    super.update(announcement, allowUndefined);
  }
  static fromJson(json) {
    return new _Announcement2({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      beginDate: json.beginDate ? moment(json.beginDate) : null,
      endDate: json.endDate ? moment(json.endDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0
    });
  }
};
__decorateClass$r([
  observable
], _Announcement.prototype, "name", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "text", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "lang", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "isAdmin", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "isSchool", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "createdDate", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "beginDate", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "endDate", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "updatedDate", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "isPublished", 2);
__decorateClass$r([
  observable
], _Announcement.prototype, "showOnlyForMigratedSchool", 2);
__decorateClass$r([
  computed
], _Announcement.prototype, "isActive", 1);
__decorateClass$r([
  action
], _Announcement.prototype, "update", 1);
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$o(target, key, result);
  return result;
};
const _Organization = class _Organization2 extends Entity$1 {
  constructor(company) {
    super(company);
    this.name = "";
    this.domain = "";
    this.textAgreement = "";
    this.schools = [];
    if (company) this.update(company);
  }
  update(org, allowUndefined = false) {
    super.update(org, allowUndefined);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(json) {
    return new _Organization2({
      ...json,
      schools: json.schools ? json.schools?.map((x) => School.fromJson(x)) : []
    });
  }
};
__decorateClass$q([
  observable
], _Organization.prototype, "name", 2);
__decorateClass$q([
  observable
], _Organization.prototype, "domain", 2);
__decorateClass$q([
  observable
], _Organization.prototype, "textAgreement", 2);
__decorateClass$q([
  action
], _Organization.prototype, "update", 1);
let Organization = _Organization;
class KeyGenerator {
  generate(length2 = 10) {
    return [...Array(length2)].map((i) => (~~(Math.random() * 36)).toString(36)).join("");
  }
  static generate(length2 = 10) {
    return [...Array(length2)].map((i) => (~~(Math.random() * 36)).toString(36)).join("");
  }
}
var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$n(target, key, result);
  return result;
};
var FileType = /* @__PURE__ */ ((FileType2) => {
  FileType2["Other"] = "other";
  FileType2["Image"] = "image";
  FileType2["Video"] = "video";
  FileType2["Audio"] = "audio";
  FileType2["Doc"] = "doc";
  FileType2["Pdf"] = "pdf";
  FileType2["Zip"] = "zip";
  FileType2["Ppt"] = "ppt";
  FileType2["Xls"] = "xls";
  FileType2["Json"] = "json";
  FileType2["Csv"] = "csv";
  return FileType2;
})(FileType || {});
const _AccelFile = class _AccelFile2 extends Entity$1 {
  constructor(file) {
    super(file);
    if (file) this.update(file);
  }
  get audioMeta() {
    return this.additionalData;
  }
  set audioMeta(meta) {
    this.additionalData = meta;
  }
  /**
   * remove 'size' and rename
   */
  get fileSize() {
    return FileSize.fromBytes(this.size);
  }
  get fileSizeString() {
    return Humanize.fileSize(this.size);
  }
  get isUploaded() {
    return !isEmpty(this.cloudKey);
  }
  get isExternalFile() {
    return !isEmpty(this.url);
  }
  get isImage() {
    return [".bmp", ".dib", ".rle", ".jpg", ".jpeg", ".jpe", ".jfif", ".gif", ".tif", ".tiff", ".png", ".svg", ".pjpeg", ".webp", ".ico"].includes(this.extension);
  }
  get isAudio() {
    return [".mp3", ".ogg", ".webm", ".m4a"].includes(this.extension);
  }
  get filename() {
    return this.name + this.extension;
  }
  replaceFile(file) {
    this.update({
      ..._AccelFile2.fromFile(file),
      id: this.id,
      name: this.name,
      description: this.description,
      createdDate: this.createdDate,
      isPublic: this.isPublic
    }, true);
  }
  update(file, allowUndefined = false) {
    super.update(file, allowUndefined);
  }
  toJson() {
    return {
      ...this,
      additionalData: JSON.stringify(this.additionalData),
      nativeFile: void 0
    };
  }
  clone() {
    return new _AccelFile2({
      ...this
    });
  }
  static fromJson(json) {
    return new _AccelFile2({
      ...json,
      key: json.id,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      convertData: json.convertDataJson ? JSON.parse(json.convertDataJson) : void 0,
      additionalData: json.additionalData ? JSON.parse(json.additionalData) : void 0
    });
  }
  static fromFile(file, overrides) {
    const index2 = file.name.lastIndexOf(".");
    const base = new _AccelFile2({
      key: KeyGenerator.generate(10),
      source: "amazon",
      nativeFile: file,
      size: file.size,
      mimetype: file.type,
      name: file.name.substring(0, index2),
      extension: file.name.substring(index2),
      createdDate: moment(),
      ...overrides
    });
    if (base.isImage && base.nativeFile)
      base.previewImage = URL.createObjectURL(base.nativeFile);
    if (base.isAudio && base.nativeFile && base.nativeFile.type.includes("audio"))
      base.previewAudio = URL.createObjectURL(base.nativeFile);
    return base;
  }
};
__decorateClass$p([
  observable
], _AccelFile.prototype, "name", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "description", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "cloudKey", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "isPublic", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "isVoice", 2);
__decorateClass$p([
  computed
], _AccelFile.prototype, "audioMeta", 1);
__decorateClass$p([
  observable
], _AccelFile.prototype, "key", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "nativeFile", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "previewImage", 2);
__decorateClass$p([
  observable
], _AccelFile.prototype, "previewAudio", 2);
__decorateClass$p([
  computed
], _AccelFile.prototype, "isUploaded", 1);
__decorateClass$p([
  observable
], _AccelFile.prototype, "url", 2);
__decorateClass$p([
  action
], _AccelFile.prototype, "update", 1);
let AccelFile = _AccelFile;
class CreateFileManagerDirectoryRequest extends ApiRequest {
  constructor(dir, target) {
    super();
    this.method = HttpMethod.POST;
    this.url = `/file-manager/create-directory`;
    this.body = {
      name: dir.name,
      parentId: dir.parentId,
      sectionType: dir.sectionType,
      ...target
    };
  }
}
class CreateFileManagerItemRequest extends ApiRequest {
  constructor(name, section, content2, parentId, target) {
    super();
    this.name = name;
    this.section = section;
    this.content = content2;
    this.parentId = parentId;
    this.target = target;
    this.method = HttpMethod.POST;
    this.url = `/file-manager/create-file`;
    this.body = {
      name: this.name,
      sectionType: this.section,
      fileId: this.content.fileId,
      fileUrl: this.content.fileUrl,
      videoId: this.content.videoId,
      parentId: this.parentId,
      ...this.target
    };
  }
}
class FetchFileManagerItemsRequest extends ApiRequest {
  constructor(filter2, fields) {
    super();
    this.filter = filter2;
    this.method = HttpMethod.GET;
    this.fields = `{
        id,
        name,
		updatedDate,
		createdDate,
		type,
		parentId,
		softDeleted,
		duration,
		size,
		folderCount,
		itemCount,
		file {
			id,
			name,
			size,
			type,
			mimeType,
			cloudKey,
			extension,
			isPublic
		},
		video {
            id,
            name,
            shortDescription,
			createdDate,
			updatedDate,
            primaryImage {
				id,
            	file {
                    id,
					name,
					size,
					type,
					mimeType,
					cloudKey,
					extension,
					isPublic
                }
            },
            currentVideoStream {
				id,
				duration,
				progress,
				width,
				height,
				state,
				subState,
				errorMessage,
				createdDate,
				file {
					id,
					name,
					size,
					type,
					mimeType,
					cloudKey,
					extension,
					isPublic
                }
            }
        },
		site{
			id
		}
    }`;
    this.url = "/file-manager";
    this.body = {
      ...this.filter
    };
    this.fields = fields || this.fields;
  }
}
class UpdateFileManagerItemRequest extends ApiRequest {
  constructor(item2) {
    super();
    this.item = item2;
    this.method = HttpMethod.PUT;
    this.url = `/file-manager`;
    this.body = {
      name: this.item.name,
      id: this.item.id,
      parentId: this.item.parentId
    };
  }
}
class FetchLocalizationRequest extends ApiRequest {
  constructor(lang, timestamp) {
    super();
    this.lang = lang;
    this.timestamp = timestamp;
    this.method = HttpMethod.GET;
    this.url = "/localization";
    this.body = {
      lang: this.lang,
      timestamp: this.timestamp
    };
  }
}
class S3UploaderOptions {
  constructor() {
    this.chunkSize = 50 * 1024 * 1024;
    this.resume = true;
    this.maxAttempts = 3;
    this.concurrentUploads = 10;
  }
}
class S3Uploader {
  constructor(api2, options = new S3UploaderOptions()) {
    this.api = api2;
    this.onBegin = new TypedEvent();
    this.onProgress = new TypedEvent();
    this.onComplete = new TypedEvent();
    this.onPrepare = new TypedEvent();
    this.onError = new TypedEvent();
    this.onAborted = new TypedEvent();
    this.isAborted = false;
    this.isUploading = false;
    this.options = { ...new S3UploaderOptions(), ...options };
  }
  setOptions(options) {
    this.options = { ...new S3UploaderOptions(), ...options };
  }
  setFile(file, args = {}) {
    if (this.isUploading)
      return false;
    this.fileMeta = null;
    this.file = file;
    this.args = args;
    return true;
  }
  async upload() {
    if (!this.file)
      throw new Error("File is not specified");
    if (this.isUploading)
      throw new Error("Upload is in progress");
    this.isUploading = true;
    const urls = await this.beginUpload();
    if (urls.length == 0)
      return false;
    const eTags = await this.uploadParts(urls);
    if (eTags.length == 0)
      return false;
    await this.complete(eTags);
    return await this.prepare();
  }
  async beginUpload() {
    const result = await this.api.begin(
      this.file,
      this.options.chunkSize,
      this.args
    );
    if (!result.success) {
      this.onError.emit({
        errors: result.errors
      });
      return [];
    }
    this.onBegin.emit({
      id: result.body.id
    });
    this.fileMeta = {
      id: result.body.id
    };
    return result.body.urls;
  }
  async abort() {
    if (this.isAborted) return Promise.resolve(true);
    this.isAborted = true;
    if (this.fileMeta == null) return true;
    this.isUploading = false;
    const result = await this.api.abort(this.fileMeta.id);
    if (!result.success) {
      this.onError.emit({
        errors: result.errors
      });
      return false;
    }
    this.onAborted.emit({});
    return true;
  }
  async uploadParts(urls) {
    if (this.isAborted)
      return [];
    let fulfilled = 0;
    let concurentUploads = [];
    let tags = [];
    for (let i = 0; i < urls.length; i++) {
      const url2 = urls[i];
      const partNumber = i + 1;
      const start2 = i * this.options.chunkSize;
      const end = partNumber * this.options.chunkSize;
      const blob = this.file.slice(start2, end);
      const isLastChunk = i == urls.length - 1;
      if (this.isAborted)
        break;
      const promise = this.uploadPart(url2, blob, partNumber);
      concurentUploads.push(promise);
      promise.then(() => {
        fulfilled++;
        this.onProgress.emit({
          chunk: partNumber,
          id: this.fileMeta.id,
          total: urls.length,
          percent: Math.round(fulfilled / urls.length * 100)
        });
      }, (reason) => this.onError.emit({ errors: [{ message: reason, number: partNumber }] }));
      if (this.options.concurrentUploads > 0 && concurentUploads.length >= this.options.concurrentUploads || isLastChunk) {
        tags = [...tags, ...await Promise.all(concurentUploads)];
        concurentUploads = [];
        console.logDev("[s3 uploader]", this.fileMeta.id, tags);
      }
    }
    return tags;
  }
  async uploadPart(url2, blob, partNumber) {
    let attempts = 0;
    do {
      attempts++;
      try {
        const response = await fetch(url2, {
          method: "PUT",
          body: blob
        });
        if (response != null && response.ok) {
          const eTag = response.headers.get("etag");
          return Promise.resolve({ eTag, partNumber });
        }
      } catch (e) {
        let result;
        if (e.response == null || e.response.data == null) {
          result = new BadApiResult();
          console.error("Network error", e);
        } else {
          const response = new ApiResponse(e.response.data);
          result = new BadApiResult(e.response.status, response);
        }
        this.onError.emit({ errors: result.hasError ? [result.error] : result.response.errors });
      }
    } while (attempts != this.options.maxAttempts && !this.isAborted);
    await this.abort();
    return Promise.reject("Maximum retries reached");
  }
  async complete(eTags) {
    if (this.isAborted) return false;
    this.isUploading = false;
    const result = await this.api.complete(this.fileMeta.id, eTags);
    if (!result.success) {
      this.onError.emit({
        errors: result.errors
      });
      return false;
    }
    this.onComplete.emit({
      file: result.body
    });
    return true;
  }
  async prepare() {
    if (this.isAborted) return false;
    const result = await this.api.prepare(this.fileMeta.id);
    if (!result.success) {
      this.onError.emit({
        errors: result.errors
      });
      return false;
    }
    this.onPrepare.emit();
    return true;
  }
}
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$m(target, key, result);
  return result;
};
const LocalizationStorageKey = "localization";
class LocalizationStore {
  constructor(api2) {
    this.api = api2;
    this.ready = false;
    this.words = [];
    this.excludedLangs = [];
    this.api = api2 || inject(this, Api);
  }
  get langs() {
    return Object.keys(Lang).filter((x) => !this.excludedLangs.includes(x)).map((x) => x);
  }
  get cache() {
    var locCacheJson = localStorage.getItem(LocalizationStorageKey);
    if (locCacheJson != null)
      return JSON.parse(locCacheJson);
    return null;
  }
  /**
   * Temporary code to reset obsolete cache
   * @todo remove after fixing localization cache
   */
  get isCacheObsolete() {
    const cache2 = this.cache;
    return !cache2?.excludedLangs;
  }
  set cache(cache2) {
    if (cache2 == null) {
      localStorage.removeItem(LocalizationStorageKey);
      return;
    }
    localStorage.setItem(LocalizationStorageKey, JSON.stringify(cache2));
  }
  async init(lang) {
    if (this.isCacheObsolete)
      this.clear(false);
    else {
      const locCache = this.cache;
      if (locCache?.lang == lang)
        this.setData(lang, locCache.words, locCache.timestamp, false, locCache.excludedLangs);
      else this.clear(false);
    }
    await this.fetchWords(lang);
  }
  clear(cache2 = true) {
    this.words = [];
    this.timestamp = void 0;
    this.ready = false;
    this.excludedLangs = [];
    if (cache2)
      this.cache = null;
  }
  async fetchWords(lang) {
    const result = await this.api.loc.fetch(new FetchLocalizationRequest(lang, this.timestamp));
    if (!result.success)
      return;
    if (result.response.needSync)
      this.setData(lang, result.response.words, result.response.timestamp, true, result.response.excludedLangs);
    runInAction(() => this.ready = true);
  }
  async setData(lang, words, timestamp, needCache = true, excludedLangs = []) {
    this.lang = lang;
    this.words = words;
    this.timestamp = timestamp;
    this.excludedLangs = excludedLangs;
    if (needCache)
      this.cache = { timestamp, words, lang, excludedLangs };
  }
}
__decorateClass$o([
  observable
], LocalizationStore.prototype, "ready", 2);
__decorateClass$o([
  observable
], LocalizationStore.prototype, "words", 2);
__decorateClass$o([
  observable
], LocalizationStore.prototype, "excludedLangs", 2);
__decorateClass$o([
  computed
], LocalizationStore.prototype, "langs", 1);
__decorateClass$o([
  action
], LocalizationStore.prototype, "clear", 1);
__decorateClass$o([
  action
], LocalizationStore.prototype, "fetchWords", 1);
__decorateClass$o([
  action
], LocalizationStore.prototype, "setData", 1);
const reaction$1 = (expression, effect, opts) => {
  let prevValue = expression();
  return reaction$2(expression, async (v, r2) => {
    effect(v, r2, prevValue);
    prevValue = v;
  }, opts);
};
function saveAs(url2, targetBlank = false, filename = "") {
  const link = document.createElement("a");
  if (typeof link.download === "string") {
    document.body.appendChild(link);
    link.download = filename;
    link.href = url2;
    if (targetBlank)
      link.target = "_blank";
    link.click();
    document.body.removeChild(link);
  } else {
    location.replace(url2);
  }
}
function isEmpty(val, opts = { trimSpaces: true }) {
  let v = val;
  if (typeof v === "string" && opts.trimSpaces == true)
    v = v?.trim();
  else if (typeof v === "number" || typeof v === "boolean" || lodashExports.isDate(val))
    return v === void 0;
  return lodashExports.isEmpty(v);
}
function combineRefs(...refs) {
  return (target) => {
    refs.forEach((ref2) => {
      if (!ref2) return;
      if (typeof ref2 === "function") {
        ref2(target);
      } else {
        ref2.current = target;
      }
    });
  };
}
function combineClasses(...args) {
  return args.filter((item2) => {
    if (typeof item2 === "undefined") {
      return false;
    } else if (item2 === null) {
      return false;
    } else if ([true, false].includes(item2)) {
      return false;
    }
    return item2.toString().trim().length > 0;
  }).join(" ");
}
function toCleanObject(f) {
  const newObj = {};
  Object.keys(f).forEach((key) => {
    if (isEmpty(f[key]) && f[key] !== null) return;
    let valueToCopy = f[key];
    if (typeof f[key] === "object" && !Array.isArray(f[key]) && f[key] instanceof Date === false) {
      if (moment.isMoment(f[key])) {
        valueToCopy = f[key].toDate();
      } else if (f[key] === null) {
        valueToCopy = null;
      } else {
        valueToCopy = toCleanObject(f[key]);
        if (f[key] instanceof BaseFilter === true)
          removeFilterDefaults(valueToCopy);
      }
    }
    newObj[key] = valueToCopy;
  });
  return newObj;
}
function removeFilterDefaults(filter2) {
  if (!filter2 || typeof filter2 !== "object" || Array.isArray(filter2)) return;
  if (filter2.skip == 0)
    delete filter2["skip"];
  if (filter2.take == 25)
    delete filter2["take"];
  if (filter2.useBaseFilter == true)
    delete filter2["useBaseFilter"];
  if (filter2.softDeleted == false)
    delete filter2["softDeleted"];
  if (filter2.useSort == true)
    delete filter2["useSort"];
  if (filter2.useItemsTotal == true)
    delete filter2["useItemsTotal"];
  delete filter2["itemsTotal"];
  if (isEmpty(filter2.search))
    delete filter2["search"];
}
function toSelectStringFilter(f) {
  return toQueryStringFilter(f).replaceAll('"', "'");
}
function toQueryStringFilter(f) {
  const filter2 = toCleanObject(f);
  removeFilterDefaults(filter2);
  return JSON.stringify(filter2);
}
class AuthCookieClient {
  constructor(cookieStorage, settings) {
    this.cookieStorage = cookieStorage;
    this.settings = settings;
    this.cookieStorage = cookieStorage || inject(this, CookieStorage);
  }
  getAccessToken() {
    return this.cookieStorage.get(this.settings.accessTokenName);
  }
  getRefreshToken() {
    return this.cookieStorage.get(this.settings.refreshTokenName);
  }
  setAccessToken(token2, expiresDate) {
    this.cookieStorage.set(this.settings.accessTokenName, token2, {
      path: this.getCookiePath(),
      expires: expiresDate
    });
  }
  setRefreshToken(token2, expiresDate) {
    this.cookieStorage.set(this.settings.refreshTokenName, token2, {
      path: this.getCookiePath(),
      expires: expiresDate ?? 365
      // We cannot use 'secure' attr, it blocks cookie access from js
      // secure: true
    });
  }
  removeAccessToken() {
    this.cookieStorage.remove(this.settings.accessTokenName, {
      path: this.getCookiePath()
    });
  }
  removeRefreshToken() {
    this.cookieStorage.remove(this.settings.refreshTokenName, {
      path: this.getCookiePath()
    });
  }
  getCookiePath() {
    return "/";
  }
}
class DisposableStack {
  constructor() {
    this.stack = [];
  }
  get length() {
    return this.stack.length;
  }
  push(func) {
    if (func == null) throw new Error("[DisposableStack] func is null");
    if (func.dispose != void 0) {
      this.stack.push(func.dispose.bind(func));
      return;
    }
    if (typeof func != "function") throw new Error("[DisposableStack] func is not a function");
    this.stack.push(func);
  }
  dispose() {
    while (this.stack.length > 0) {
      this.stack.pop()();
    }
  }
}
class Disposable {
  constructor() {
    this.stack = new DisposableStack();
  }
  toDispose(func) {
    this.stack.push(func);
  }
  dispose() {
    this.stack.dispose();
  }
}
var HoursPer = /* @__PURE__ */ ((HoursPer2) => {
  HoursPer2[HoursPer2["Day"] = 24] = "Day";
  return HoursPer2;
})(HoursPer || {});
var MinutesPer = /* @__PURE__ */ ((MinutesPer2) => {
  MinutesPer2[MinutesPer2["Hour"] = 60] = "Hour";
  MinutesPer2[MinutesPer2["Day"] = 1440] = "Day";
  return MinutesPer2;
})(MinutesPer || {});
var SecondsPer = /* @__PURE__ */ ((SecondsPer2) => {
  SecondsPer2[SecondsPer2["Minute"] = 60] = "Minute";
  SecondsPer2[SecondsPer2["Hour"] = 3600] = "Hour";
  SecondsPer2[SecondsPer2["Day"] = 86400] = "Day";
  return SecondsPer2;
})(SecondsPer || {});
var MillisecondsPer = /* @__PURE__ */ ((MillisecondsPer2) => {
  MillisecondsPer2[MillisecondsPer2["Second"] = 1e3] = "Second";
  MillisecondsPer2[MillisecondsPer2["Minute"] = 6e4] = "Minute";
  MillisecondsPer2[MillisecondsPer2["Hour"] = 36e5] = "Hour";
  MillisecondsPer2[MillisecondsPer2["Day"] = 864e5] = "Day";
  return MillisecondsPer2;
})(MillisecondsPer || {});
var TicksPer = /* @__PURE__ */ ((TicksPer2) => {
  TicksPer2[TicksPer2["Millisecond"] = 1e4] = "Millisecond";
  TicksPer2[TicksPer2["Second"] = 1e7] = "Second";
  TicksPer2[TicksPer2["Minute"] = 6e8] = "Minute";
  TicksPer2[TicksPer2["Hour"] = 36e9] = "Hour";
  TicksPer2[TicksPer2["Day"] = 864e9] = "Day";
  return TicksPer2;
})(TicksPer || {});
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2[TimeUnit2["Ticks"] = 0] = "Ticks";
  TimeUnit2[TimeUnit2["Milliseconds"] = 1] = "Milliseconds";
  TimeUnit2[TimeUnit2["Seconds"] = 2] = "Seconds";
  TimeUnit2[TimeUnit2["Minutes"] = 3] = "Minutes";
  TimeUnit2[TimeUnit2["Hours"] = 4] = "Hours";
  TimeUnit2[TimeUnit2["Days"] = 5] = "Days";
  return TimeUnit2;
})(TimeUnit || {});
class TimeUnitUtils {
  static toMilliseconds(value, units = 1) {
    switch (units) {
      //@ts-ignore
      case 5:
        value *= HoursPer.Day;
      //@ts-ignore
      case 4:
        value *= MinutesPer.Hour;
      //@ts-ignore
      case 3:
        value *= SecondsPer.Minute;
      //@ts-ignore
      case 2:
        value *= MillisecondsPer.Second;
      case 1:
        return value;
      case 0:
        return value / TicksPer.Millisecond;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
  static fromMilliseconds(ms, units) {
    switch (units) {
      case 5:
        return ms / MillisecondsPer.Day;
      case 4:
        return ms / MillisecondsPer.Hour;
      case 3:
        return ms / MillisecondsPer.Minute;
      case 2:
        return ms / MillisecondsPer.Second;
      case 1:
        return ms;
      case 0:
        return ms * TicksPer.Millisecond;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
}
class TimeSpan {
  constructor(value, units = TimeUnit.Milliseconds) {
    const ms = TimeUnitUtils.toMilliseconds(value, units);
    this.ticks = ms * TicksPer.Millisecond;
    this.milliseconds = ms;
    this.seconds = ms / MillisecondsPer.Second;
    this.minutes = ms / MillisecondsPer.Minute;
    this.hours = ms / MillisecondsPer.Hour;
    this.days = ms / MillisecondsPer.Day;
  }
  add(span) {
    return TimeSpan.fromMilliseconds(this.milliseconds + span.milliseconds);
  }
  substract(span) {
    return TimeSpan.fromMilliseconds(this.milliseconds - span.milliseconds);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.ticks == 0;
  }
  static from(value, units) {
    return new TimeSpan(value, units);
  }
  static fromDays(value) {
    return new TimeSpan(value, TimeUnit.Days);
  }
  static fromHours(value) {
    return new TimeSpan(value, TimeUnit.Hours);
  }
  static fromMinutes(value) {
    return new TimeSpan(value, TimeUnit.Minutes);
  }
  static fromSeconds(value) {
    return new TimeSpan(value, TimeUnit.Seconds);
  }
  static fromMilliseconds(value) {
    return new TimeSpan(value, TimeUnit.Milliseconds);
  }
  static fromMs(value) {
    return new TimeSpan(value, TimeUnit.Milliseconds);
  }
  static fromTicks(value) {
    return new TimeSpan(value, TimeUnit.Ticks);
  }
  static fromTimeMeasure(value, measure) {
    switch (measure) {
      case "seconds":
        return TimeSpan.fromSeconds(value);
      case "minutes":
        return TimeSpan.fromMinutes(value);
      case "hours":
        return TimeSpan.fromHours(value);
      case "days":
        return TimeSpan.fromDays(value);
      case "weeks":
        return TimeSpan.fromDays(value * 7);
      case "months":
        return TimeSpan.fromDays(value * 30);
      default:
        throw new Error("Invalid TimeMeasure.");
    }
  }
  static get zero() {
    return new TimeSpan(0);
  }
}
TimeSpan.prototype.toString = function() {
  return this.milliseconds.toString();
};
TimeSpan.prototype.valueOf = function() {
  return this.milliseconds;
};
function defaultComparer$1(a, b) {
  return a === b;
}
function isArraysEqual(srcArr, dstArr, comparer2 = defaultComparer$1) {
  if (srcArr === dstArr) return true;
  if (!srcArr || !dstArr) return false;
  if (srcArr.length !== dstArr.length) return false;
  return srcArr.every((x) => dstArr.find((y) => comparer2(x, y)) != null);
}
var BytesPer = /* @__PURE__ */ ((BytesPer2) => {
  BytesPer2[BytesPer2["Kilobytes"] = 1024] = "Kilobytes";
  BytesPer2[BytesPer2["Megabytes"] = 1048576] = "Megabytes";
  BytesPer2[BytesPer2["Gigabytes"] = 1073741824] = "Gigabytes";
  return BytesPer2;
})(BytesPer || {});
var FileSizeUnit = /* @__PURE__ */ ((FileSizeUnit2) => {
  FileSizeUnit2[FileSizeUnit2["Bytes"] = 0] = "Bytes";
  FileSizeUnit2[FileSizeUnit2["Kilobytes"] = 1] = "Kilobytes";
  FileSizeUnit2[FileSizeUnit2["Megabytes"] = 2] = "Megabytes";
  FileSizeUnit2[FileSizeUnit2["Gigabytes"] = 3] = "Gigabytes";
  return FileSizeUnit2;
})(FileSizeUnit || {});
class FileSizeUnitUtils {
  static toBytes(value, units = 0) {
    switch (units) {
      case 3:
        return value * BytesPer.Gigabytes;
      case 2:
        return value * BytesPer.Megabytes;
      case 1:
        return value * BytesPer.Kilobytes;
      case 0:
        return value;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
  static fromBytes(bytes, units) {
    switch (units) {
      case 3:
        return bytes / BytesPer.Gigabytes;
      case 2:
        return bytes / BytesPer.Megabytes;
      case 1:
        return bytes / BytesPer.Kilobytes;
      case 0:
        return bytes;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
}
class FileSize {
  constructor(value, units = FileSizeUnit.Bytes) {
    const bytes = FileSizeUnitUtils.toBytes(value, units);
    this.bytes = bytes;
    this.kilobytes = bytes / BytesPer.Kilobytes;
    this.megabytes = bytes / BytesPer.Megabytes;
    this.gigabytes = bytes / BytesPer.Gigabytes;
  }
  add(span) {
    return FileSize.fromBytes(this.bytes + span.bytes);
  }
  substract(span) {
    return FileSize.fromBytes(this.bytes - span.bytes);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.bytes == 0;
  }
  static from(value, units) {
    return new FileSize(value, units);
  }
  static fromBytes(value) {
    return new FileSize(value, FileSizeUnit.Bytes);
  }
  static fromKilobytes(value) {
    return new FileSize(value, FileSizeUnit.Kilobytes);
  }
  static fromMegabytes(value) {
    return new FileSize(value, FileSizeUnit.Megabytes);
  }
  static fromGigabytes(value) {
    return new FileSize(value, FileSizeUnit.Gigabytes);
  }
  static get zero() {
    return new FileSize(0);
  }
}
var mimeTypes = {};
const require$$0 = {
  "application/1d-interleaved-parityfec": { "source": "iana" },
  "application/3gpdash-qoe-report+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/3gpp-ims+xml": { "source": "iana", "compressible": true },
  "application/3gpphal+json": { "source": "iana", "compressible": true },
  "application/3gpphalforms+json": { "source": "iana", "compressible": true },
  "application/a2l": { "source": "iana" },
  "application/ace+cbor": { "source": "iana" },
  "application/activemessage": { "source": "iana" },
  "application/activity+json": { "source": "iana", "compressible": true },
  "application/alto-costmap+json": { "source": "iana", "compressible": true },
  "application/alto-costmapfilter+json": { "source": "iana", "compressible": true },
  "application/alto-directory+json": { "source": "iana", "compressible": true },
  "application/alto-endpointcost+json": { "source": "iana", "compressible": true },
  "application/alto-endpointcostparams+json": { "source": "iana", "compressible": true },
  "application/alto-endpointprop+json": { "source": "iana", "compressible": true },
  "application/alto-endpointpropparams+json": { "source": "iana", "compressible": true },
  "application/alto-error+json": { "source": "iana", "compressible": true },
  "application/alto-networkmap+json": { "source": "iana", "compressible": true },
  "application/alto-networkmapfilter+json": { "source": "iana", "compressible": true },
  "application/alto-updatestreamcontrol+json": { "source": "iana", "compressible": true },
  "application/alto-updatestreamparams+json": { "source": "iana", "compressible": true },
  "application/aml": { "source": "iana" },
  "application/andrew-inset": { "source": "iana", "extensions": ["ez"] },
  "application/applefile": { "source": "iana" },
  "application/applixware": { "source": "apache", "extensions": ["aw"] },
  "application/at+jwt": { "source": "iana" },
  "application/atf": { "source": "iana" },
  "application/atfx": { "source": "iana" },
  "application/atom+xml": { "source": "iana", "compressible": true, "extensions": ["atom"] },
  "application/atomcat+xml": { "source": "iana", "compressible": true, "extensions": ["atomcat"] },
  "application/atomdeleted+xml": { "source": "iana", "compressible": true, "extensions": ["atomdeleted"] },
  "application/atomicmail": { "source": "iana" },
  "application/atomsvc+xml": { "source": "iana", "compressible": true, "extensions": ["atomsvc"] },
  "application/atsc-dwd+xml": { "source": "iana", "compressible": true, "extensions": ["dwd"] },
  "application/atsc-dynamic-event-message": { "source": "iana" },
  "application/atsc-held+xml": { "source": "iana", "compressible": true, "extensions": ["held"] },
  "application/atsc-rdt+json": { "source": "iana", "compressible": true },
  "application/atsc-rsat+xml": { "source": "iana", "compressible": true, "extensions": ["rsat"] },
  "application/atxml": { "source": "iana" },
  "application/auth-policy+xml": { "source": "iana", "compressible": true },
  "application/bacnet-xdd+zip": { "source": "iana", "compressible": false },
  "application/batch-smtp": { "source": "iana" },
  "application/bdoc": { "compressible": false, "extensions": ["bdoc"] },
  "application/beep+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/calendar+json": { "source": "iana", "compressible": true },
  "application/calendar+xml": { "source": "iana", "compressible": true, "extensions": ["xcs"] },
  "application/call-completion": { "source": "iana" },
  "application/cals-1840": { "source": "iana" },
  "application/captive+json": { "source": "iana", "compressible": true },
  "application/cbor": { "source": "iana" },
  "application/cbor-seq": { "source": "iana" },
  "application/cccex": { "source": "iana" },
  "application/ccmp+xml": { "source": "iana", "compressible": true },
  "application/ccxml+xml": { "source": "iana", "compressible": true, "extensions": ["ccxml"] },
  "application/cdfx+xml": { "source": "iana", "compressible": true, "extensions": ["cdfx"] },
  "application/cdmi-capability": { "source": "iana", "extensions": ["cdmia"] },
  "application/cdmi-container": { "source": "iana", "extensions": ["cdmic"] },
  "application/cdmi-domain": { "source": "iana", "extensions": ["cdmid"] },
  "application/cdmi-object": { "source": "iana", "extensions": ["cdmio"] },
  "application/cdmi-queue": { "source": "iana", "extensions": ["cdmiq"] },
  "application/cdni": { "source": "iana" },
  "application/cea": { "source": "iana" },
  "application/cea-2018+xml": { "source": "iana", "compressible": true },
  "application/cellml+xml": { "source": "iana", "compressible": true },
  "application/cfw": { "source": "iana" },
  "application/city+json": { "source": "iana", "compressible": true },
  "application/clr": { "source": "iana" },
  "application/clue+xml": { "source": "iana", "compressible": true },
  "application/clue_info+xml": { "source": "iana", "compressible": true },
  "application/cms": { "source": "iana" },
  "application/cnrp+xml": { "source": "iana", "compressible": true },
  "application/coap-group+json": { "source": "iana", "compressible": true },
  "application/coap-payload": { "source": "iana" },
  "application/commonground": { "source": "iana" },
  "application/conference-info+xml": { "source": "iana", "compressible": true },
  "application/cose": { "source": "iana" },
  "application/cose-key": { "source": "iana" },
  "application/cose-key-set": { "source": "iana" },
  "application/cpl+xml": { "source": "iana", "compressible": true, "extensions": ["cpl"] },
  "application/csrattrs": { "source": "iana" },
  "application/csta+xml": { "source": "iana", "compressible": true },
  "application/cstadata+xml": { "source": "iana", "compressible": true },
  "application/csvm+json": { "source": "iana", "compressible": true },
  "application/cu-seeme": { "source": "apache", "extensions": ["cu"] },
  "application/cwt": { "source": "iana" },
  "application/cybercash": { "source": "iana" },
  "application/dart": { "compressible": true },
  "application/dash+xml": { "source": "iana", "compressible": true, "extensions": ["mpd"] },
  "application/dash-patch+xml": { "source": "iana", "compressible": true, "extensions": ["mpp"] },
  "application/dashdelta": { "source": "iana" },
  "application/davmount+xml": { "source": "iana", "compressible": true, "extensions": ["davmount"] },
  "application/dca-rft": { "source": "iana" },
  "application/dcd": { "source": "iana" },
  "application/dec-dx": { "source": "iana" },
  "application/dialog-info+xml": { "source": "iana", "compressible": true },
  "application/dicom": { "source": "iana" },
  "application/dicom+json": { "source": "iana", "compressible": true },
  "application/dicom+xml": { "source": "iana", "compressible": true },
  "application/dii": { "source": "iana" },
  "application/dit": { "source": "iana" },
  "application/dns": { "source": "iana" },
  "application/dns+json": { "source": "iana", "compressible": true },
  "application/dns-message": { "source": "iana" },
  "application/docbook+xml": { "source": "apache", "compressible": true, "extensions": ["dbk"] },
  "application/dots+cbor": { "source": "iana" },
  "application/dskpp+xml": { "source": "iana", "compressible": true },
  "application/dssc+der": { "source": "iana", "extensions": ["dssc"] },
  "application/dssc+xml": { "source": "iana", "compressible": true, "extensions": ["xdssc"] },
  "application/dvcs": { "source": "iana" },
  "application/ecmascript": { "source": "iana", "compressible": true, "extensions": ["es", "ecma"] },
  "application/edi-consent": { "source": "iana" },
  "application/edi-x12": { "source": "iana", "compressible": false },
  "application/edifact": { "source": "iana", "compressible": false },
  "application/efi": { "source": "iana" },
  "application/elm+json": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/elm+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.cap+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/emergencycalldata.comment+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.control+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.deviceinfo+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.ecall.msd": { "source": "iana" },
  "application/emergencycalldata.providerinfo+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.serviceinfo+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.subscriberinfo+xml": { "source": "iana", "compressible": true },
  "application/emergencycalldata.veds+xml": { "source": "iana", "compressible": true },
  "application/emma+xml": { "source": "iana", "compressible": true, "extensions": ["emma"] },
  "application/emotionml+xml": { "source": "iana", "compressible": true, "extensions": ["emotionml"] },
  "application/encaprtp": { "source": "iana" },
  "application/epp+xml": { "source": "iana", "compressible": true },
  "application/epub+zip": { "source": "iana", "compressible": false, "extensions": ["epub"] },
  "application/eshop": { "source": "iana" },
  "application/exi": { "source": "iana", "extensions": ["exi"] },
  "application/expect-ct-report+json": { "source": "iana", "compressible": true },
  "application/express": { "source": "iana", "extensions": ["exp"] },
  "application/fastinfoset": { "source": "iana" },
  "application/fastsoap": { "source": "iana" },
  "application/fdt+xml": { "source": "iana", "compressible": true, "extensions": ["fdt"] },
  "application/fhir+json": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/fhir+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/fido.trusted-apps+json": { "compressible": true },
  "application/fits": { "source": "iana" },
  "application/flexfec": { "source": "iana" },
  "application/font-sfnt": { "source": "iana" },
  "application/font-tdpfr": { "source": "iana", "extensions": ["pfr"] },
  "application/font-woff": { "source": "iana", "compressible": false },
  "application/framework-attributes+xml": { "source": "iana", "compressible": true },
  "application/geo+json": { "source": "iana", "compressible": true, "extensions": ["geojson"] },
  "application/geo+json-seq": { "source": "iana" },
  "application/geopackage+sqlite3": { "source": "iana" },
  "application/geoxacml+xml": { "source": "iana", "compressible": true },
  "application/gltf-buffer": { "source": "iana" },
  "application/gml+xml": { "source": "iana", "compressible": true, "extensions": ["gml"] },
  "application/gpx+xml": { "source": "apache", "compressible": true, "extensions": ["gpx"] },
  "application/gxf": { "source": "apache", "extensions": ["gxf"] },
  "application/gzip": { "source": "iana", "compressible": false, "extensions": ["gz"] },
  "application/h224": { "source": "iana" },
  "application/held+xml": { "source": "iana", "compressible": true },
  "application/hjson": { "extensions": ["hjson"] },
  "application/http": { "source": "iana" },
  "application/hyperstudio": { "source": "iana", "extensions": ["stk"] },
  "application/ibe-key-request+xml": { "source": "iana", "compressible": true },
  "application/ibe-pkg-reply+xml": { "source": "iana", "compressible": true },
  "application/ibe-pp-data": { "source": "iana" },
  "application/iges": { "source": "iana" },
  "application/im-iscomposing+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/index": { "source": "iana" },
  "application/index.cmd": { "source": "iana" },
  "application/index.obj": { "source": "iana" },
  "application/index.response": { "source": "iana" },
  "application/index.vnd": { "source": "iana" },
  "application/inkml+xml": { "source": "iana", "compressible": true, "extensions": ["ink", "inkml"] },
  "application/iotp": { "source": "iana" },
  "application/ipfix": { "source": "iana", "extensions": ["ipfix"] },
  "application/ipp": { "source": "iana" },
  "application/isup": { "source": "iana" },
  "application/its+xml": { "source": "iana", "compressible": true, "extensions": ["its"] },
  "application/java-archive": { "source": "apache", "compressible": false, "extensions": ["jar", "war", "ear"] },
  "application/java-serialized-object": { "source": "apache", "compressible": false, "extensions": ["ser"] },
  "application/java-vm": { "source": "apache", "compressible": false, "extensions": ["class"] },
  "application/javascript": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["js", "mjs"] },
  "application/jf2feed+json": { "source": "iana", "compressible": true },
  "application/jose": { "source": "iana" },
  "application/jose+json": { "source": "iana", "compressible": true },
  "application/jrd+json": { "source": "iana", "compressible": true },
  "application/jscalendar+json": { "source": "iana", "compressible": true },
  "application/json": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["json", "map"] },
  "application/json-patch+json": { "source": "iana", "compressible": true },
  "application/json-seq": { "source": "iana" },
  "application/json5": { "extensions": ["json5"] },
  "application/jsonml+json": { "source": "apache", "compressible": true, "extensions": ["jsonml"] },
  "application/jwk+json": { "source": "iana", "compressible": true },
  "application/jwk-set+json": { "source": "iana", "compressible": true },
  "application/jwt": { "source": "iana" },
  "application/kpml-request+xml": { "source": "iana", "compressible": true },
  "application/kpml-response+xml": { "source": "iana", "compressible": true },
  "application/ld+json": { "source": "iana", "compressible": true, "extensions": ["jsonld"] },
  "application/lgr+xml": { "source": "iana", "compressible": true, "extensions": ["lgr"] },
  "application/link-format": { "source": "iana" },
  "application/load-control+xml": { "source": "iana", "compressible": true },
  "application/lost+xml": { "source": "iana", "compressible": true, "extensions": ["lostxml"] },
  "application/lostsync+xml": { "source": "iana", "compressible": true },
  "application/lpf+zip": { "source": "iana", "compressible": false },
  "application/lxf": { "source": "iana" },
  "application/mac-binhex40": { "source": "iana", "extensions": ["hqx"] },
  "application/mac-compactpro": { "source": "apache", "extensions": ["cpt"] },
  "application/macwriteii": { "source": "iana" },
  "application/mads+xml": { "source": "iana", "compressible": true, "extensions": ["mads"] },
  "application/manifest+json": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["webmanifest"] },
  "application/marc": { "source": "iana", "extensions": ["mrc"] },
  "application/marcxml+xml": { "source": "iana", "compressible": true, "extensions": ["mrcx"] },
  "application/mathematica": { "source": "iana", "extensions": ["ma", "nb", "mb"] },
  "application/mathml+xml": { "source": "iana", "compressible": true, "extensions": ["mathml"] },
  "application/mathml-content+xml": { "source": "iana", "compressible": true },
  "application/mathml-presentation+xml": { "source": "iana", "compressible": true },
  "application/mbms-associated-procedure-description+xml": { "source": "iana", "compressible": true },
  "application/mbms-deregister+xml": { "source": "iana", "compressible": true },
  "application/mbms-envelope+xml": { "source": "iana", "compressible": true },
  "application/mbms-msk+xml": { "source": "iana", "compressible": true },
  "application/mbms-msk-response+xml": { "source": "iana", "compressible": true },
  "application/mbms-protection-description+xml": { "source": "iana", "compressible": true },
  "application/mbms-reception-report+xml": { "source": "iana", "compressible": true },
  "application/mbms-register+xml": { "source": "iana", "compressible": true },
  "application/mbms-register-response+xml": { "source": "iana", "compressible": true },
  "application/mbms-schedule+xml": { "source": "iana", "compressible": true },
  "application/mbms-user-service-description+xml": { "source": "iana", "compressible": true },
  "application/mbox": { "source": "iana", "extensions": ["mbox"] },
  "application/media-policy-dataset+xml": { "source": "iana", "compressible": true, "extensions": ["mpf"] },
  "application/media_control+xml": { "source": "iana", "compressible": true },
  "application/mediaservercontrol+xml": { "source": "iana", "compressible": true, "extensions": ["mscml"] },
  "application/merge-patch+json": { "source": "iana", "compressible": true },
  "application/metalink+xml": { "source": "apache", "compressible": true, "extensions": ["metalink"] },
  "application/metalink4+xml": { "source": "iana", "compressible": true, "extensions": ["meta4"] },
  "application/mets+xml": { "source": "iana", "compressible": true, "extensions": ["mets"] },
  "application/mf4": { "source": "iana" },
  "application/mikey": { "source": "iana" },
  "application/mipc": { "source": "iana" },
  "application/missing-blocks+cbor-seq": { "source": "iana" },
  "application/mmt-aei+xml": { "source": "iana", "compressible": true, "extensions": ["maei"] },
  "application/mmt-usd+xml": { "source": "iana", "compressible": true, "extensions": ["musd"] },
  "application/mods+xml": { "source": "iana", "compressible": true, "extensions": ["mods"] },
  "application/moss-keys": { "source": "iana" },
  "application/moss-signature": { "source": "iana" },
  "application/mosskey-data": { "source": "iana" },
  "application/mosskey-request": { "source": "iana" },
  "application/mp21": { "source": "iana", "extensions": ["m21", "mp21"] },
  "application/mp4": { "source": "iana", "extensions": ["mp4s", "m4p"] },
  "application/mpeg4-generic": { "source": "iana" },
  "application/mpeg4-iod": { "source": "iana" },
  "application/mpeg4-iod-xmt": { "source": "iana" },
  "application/mrb-consumer+xml": { "source": "iana", "compressible": true },
  "application/mrb-publish+xml": { "source": "iana", "compressible": true },
  "application/msc-ivr+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/msc-mixer+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/msword": { "source": "iana", "compressible": false, "extensions": ["doc", "dot"] },
  "application/mud+json": { "source": "iana", "compressible": true },
  "application/multipart-core": { "source": "iana" },
  "application/mxf": { "source": "iana", "extensions": ["mxf"] },
  "application/n-quads": { "source": "iana", "extensions": ["nq"] },
  "application/n-triples": { "source": "iana", "extensions": ["nt"] },
  "application/nasdata": { "source": "iana" },
  "application/news-checkgroups": { "source": "iana", "charset": "US-ASCII" },
  "application/news-groupinfo": { "source": "iana", "charset": "US-ASCII" },
  "application/news-transmission": { "source": "iana" },
  "application/nlsml+xml": { "source": "iana", "compressible": true },
  "application/node": { "source": "iana", "extensions": ["cjs"] },
  "application/nss": { "source": "iana" },
  "application/oauth-authz-req+jwt": { "source": "iana" },
  "application/oblivious-dns-message": { "source": "iana" },
  "application/ocsp-request": { "source": "iana" },
  "application/ocsp-response": { "source": "iana" },
  "application/octet-stream": { "source": "iana", "compressible": false, "extensions": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { "source": "iana", "extensions": ["oda"] },
  "application/odm+xml": { "source": "iana", "compressible": true },
  "application/odx": { "source": "iana" },
  "application/oebps-package+xml": { "source": "iana", "compressible": true, "extensions": ["opf"] },
  "application/ogg": { "source": "iana", "compressible": false, "extensions": ["ogx"] },
  "application/omdoc+xml": { "source": "apache", "compressible": true, "extensions": ["omdoc"] },
  "application/onenote": { "source": "apache", "extensions": ["onetoc", "onetoc2", "onetmp", "onepkg"] },
  "application/opc-nodeset+xml": { "source": "iana", "compressible": true },
  "application/oscore": { "source": "iana" },
  "application/oxps": { "source": "iana", "extensions": ["oxps"] },
  "application/p21": { "source": "iana" },
  "application/p21+zip": { "source": "iana", "compressible": false },
  "application/p2p-overlay+xml": { "source": "iana", "compressible": true, "extensions": ["relo"] },
  "application/parityfec": { "source": "iana" },
  "application/passport": { "source": "iana" },
  "application/patch-ops-error+xml": { "source": "iana", "compressible": true, "extensions": ["xer"] },
  "application/pdf": { "source": "iana", "compressible": false, "extensions": ["pdf"] },
  "application/pdx": { "source": "iana" },
  "application/pem-certificate-chain": { "source": "iana" },
  "application/pgp-encrypted": { "source": "iana", "compressible": false, "extensions": ["pgp"] },
  "application/pgp-keys": { "source": "iana", "extensions": ["asc"] },
  "application/pgp-signature": { "source": "iana", "extensions": ["asc", "sig"] },
  "application/pics-rules": { "source": "apache", "extensions": ["prf"] },
  "application/pidf+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/pidf-diff+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/pkcs10": { "source": "iana", "extensions": ["p10"] },
  "application/pkcs12": { "source": "iana" },
  "application/pkcs7-mime": { "source": "iana", "extensions": ["p7m", "p7c"] },
  "application/pkcs7-signature": { "source": "iana", "extensions": ["p7s"] },
  "application/pkcs8": { "source": "iana", "extensions": ["p8"] },
  "application/pkcs8-encrypted": { "source": "iana" },
  "application/pkix-attr-cert": { "source": "iana", "extensions": ["ac"] },
  "application/pkix-cert": { "source": "iana", "extensions": ["cer"] },
  "application/pkix-crl": { "source": "iana", "extensions": ["crl"] },
  "application/pkix-pkipath": { "source": "iana", "extensions": ["pkipath"] },
  "application/pkixcmp": { "source": "iana", "extensions": ["pki"] },
  "application/pls+xml": { "source": "iana", "compressible": true, "extensions": ["pls"] },
  "application/poc-settings+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/postscript": { "source": "iana", "compressible": true, "extensions": ["ai", "eps", "ps"] },
  "application/ppsp-tracker+json": { "source": "iana", "compressible": true },
  "application/problem+json": { "source": "iana", "compressible": true },
  "application/problem+xml": { "source": "iana", "compressible": true },
  "application/provenance+xml": { "source": "iana", "compressible": true, "extensions": ["provx"] },
  "application/prs.alvestrand.titrax-sheet": { "source": "iana" },
  "application/prs.cww": { "source": "iana", "extensions": ["cww"] },
  "application/prs.cyn": { "source": "iana", "charset": "7-BIT" },
  "application/prs.hpub+zip": { "source": "iana", "compressible": false },
  "application/prs.nprend": { "source": "iana" },
  "application/prs.plucker": { "source": "iana" },
  "application/prs.rdf-xml-crypt": { "source": "iana" },
  "application/prs.xsf+xml": { "source": "iana", "compressible": true },
  "application/pskc+xml": { "source": "iana", "compressible": true, "extensions": ["pskcxml"] },
  "application/pvd+json": { "source": "iana", "compressible": true },
  "application/qsig": { "source": "iana" },
  "application/raml+yaml": { "compressible": true, "extensions": ["raml"] },
  "application/raptorfec": { "source": "iana" },
  "application/rdap+json": { "source": "iana", "compressible": true },
  "application/rdf+xml": { "source": "iana", "compressible": true, "extensions": ["rdf", "owl"] },
  "application/reginfo+xml": { "source": "iana", "compressible": true, "extensions": ["rif"] },
  "application/relax-ng-compact-syntax": { "source": "iana", "extensions": ["rnc"] },
  "application/remote-printing": { "source": "iana" },
  "application/reputon+json": { "source": "iana", "compressible": true },
  "application/resource-lists+xml": { "source": "iana", "compressible": true, "extensions": ["rl"] },
  "application/resource-lists-diff+xml": { "source": "iana", "compressible": true, "extensions": ["rld"] },
  "application/rfc+xml": { "source": "iana", "compressible": true },
  "application/riscos": { "source": "iana" },
  "application/rlmi+xml": { "source": "iana", "compressible": true },
  "application/rls-services+xml": { "source": "iana", "compressible": true, "extensions": ["rs"] },
  "application/route-apd+xml": { "source": "iana", "compressible": true, "extensions": ["rapd"] },
  "application/route-s-tsid+xml": { "source": "iana", "compressible": true, "extensions": ["sls"] },
  "application/route-usd+xml": { "source": "iana", "compressible": true, "extensions": ["rusd"] },
  "application/rpki-ghostbusters": { "source": "iana", "extensions": ["gbr"] },
  "application/rpki-manifest": { "source": "iana", "extensions": ["mft"] },
  "application/rpki-publication": { "source": "iana" },
  "application/rpki-roa": { "source": "iana", "extensions": ["roa"] },
  "application/rpki-updown": { "source": "iana" },
  "application/rsd+xml": { "source": "apache", "compressible": true, "extensions": ["rsd"] },
  "application/rss+xml": { "source": "apache", "compressible": true, "extensions": ["rss"] },
  "application/rtf": { "source": "iana", "compressible": true, "extensions": ["rtf"] },
  "application/rtploopback": { "source": "iana" },
  "application/rtx": { "source": "iana" },
  "application/samlassertion+xml": { "source": "iana", "compressible": true },
  "application/samlmetadata+xml": { "source": "iana", "compressible": true },
  "application/sarif+json": { "source": "iana", "compressible": true },
  "application/sarif-external-properties+json": { "source": "iana", "compressible": true },
  "application/sbe": { "source": "iana" },
  "application/sbml+xml": { "source": "iana", "compressible": true, "extensions": ["sbml"] },
  "application/scaip+xml": { "source": "iana", "compressible": true },
  "application/scim+json": { "source": "iana", "compressible": true },
  "application/scvp-cv-request": { "source": "iana", "extensions": ["scq"] },
  "application/scvp-cv-response": { "source": "iana", "extensions": ["scs"] },
  "application/scvp-vp-request": { "source": "iana", "extensions": ["spq"] },
  "application/scvp-vp-response": { "source": "iana", "extensions": ["spp"] },
  "application/sdp": { "source": "iana", "extensions": ["sdp"] },
  "application/secevent+jwt": { "source": "iana" },
  "application/senml+cbor": { "source": "iana" },
  "application/senml+json": { "source": "iana", "compressible": true },
  "application/senml+xml": { "source": "iana", "compressible": true, "extensions": ["senmlx"] },
  "application/senml-etch+cbor": { "source": "iana" },
  "application/senml-etch+json": { "source": "iana", "compressible": true },
  "application/senml-exi": { "source": "iana" },
  "application/sensml+cbor": { "source": "iana" },
  "application/sensml+json": { "source": "iana", "compressible": true },
  "application/sensml+xml": { "source": "iana", "compressible": true, "extensions": ["sensmlx"] },
  "application/sensml-exi": { "source": "iana" },
  "application/sep+xml": { "source": "iana", "compressible": true },
  "application/sep-exi": { "source": "iana" },
  "application/session-info": { "source": "iana" },
  "application/set-payment": { "source": "iana" },
  "application/set-payment-initiation": { "source": "iana", "extensions": ["setpay"] },
  "application/set-registration": { "source": "iana" },
  "application/set-registration-initiation": { "source": "iana", "extensions": ["setreg"] },
  "application/sgml": { "source": "iana" },
  "application/sgml-open-catalog": { "source": "iana" },
  "application/shf+xml": { "source": "iana", "compressible": true, "extensions": ["shf"] },
  "application/sieve": { "source": "iana", "extensions": ["siv", "sieve"] },
  "application/simple-filter+xml": { "source": "iana", "compressible": true },
  "application/simple-message-summary": { "source": "iana" },
  "application/simplesymbolcontainer": { "source": "iana" },
  "application/sipc": { "source": "iana" },
  "application/slate": { "source": "iana" },
  "application/smil": { "source": "iana" },
  "application/smil+xml": { "source": "iana", "compressible": true, "extensions": ["smi", "smil"] },
  "application/smpte336m": { "source": "iana" },
  "application/soap+fastinfoset": { "source": "iana" },
  "application/soap+xml": { "source": "iana", "compressible": true },
  "application/sparql-query": { "source": "iana", "extensions": ["rq"] },
  "application/sparql-results+xml": { "source": "iana", "compressible": true, "extensions": ["srx"] },
  "application/spdx+json": { "source": "iana", "compressible": true },
  "application/spirits-event+xml": { "source": "iana", "compressible": true },
  "application/sql": { "source": "iana" },
  "application/srgs": { "source": "iana", "extensions": ["gram"] },
  "application/srgs+xml": { "source": "iana", "compressible": true, "extensions": ["grxml"] },
  "application/sru+xml": { "source": "iana", "compressible": true, "extensions": ["sru"] },
  "application/ssdl+xml": { "source": "apache", "compressible": true, "extensions": ["ssdl"] },
  "application/ssml+xml": { "source": "iana", "compressible": true, "extensions": ["ssml"] },
  "application/stix+json": { "source": "iana", "compressible": true },
  "application/swid+xml": { "source": "iana", "compressible": true, "extensions": ["swidtag"] },
  "application/tamp-apex-update": { "source": "iana" },
  "application/tamp-apex-update-confirm": { "source": "iana" },
  "application/tamp-community-update": { "source": "iana" },
  "application/tamp-community-update-confirm": { "source": "iana" },
  "application/tamp-error": { "source": "iana" },
  "application/tamp-sequence-adjust": { "source": "iana" },
  "application/tamp-sequence-adjust-confirm": { "source": "iana" },
  "application/tamp-status-query": { "source": "iana" },
  "application/tamp-status-response": { "source": "iana" },
  "application/tamp-update": { "source": "iana" },
  "application/tamp-update-confirm": { "source": "iana" },
  "application/tar": { "compressible": true },
  "application/taxii+json": { "source": "iana", "compressible": true },
  "application/td+json": { "source": "iana", "compressible": true },
  "application/tei+xml": { "source": "iana", "compressible": true, "extensions": ["tei", "teicorpus"] },
  "application/tetra_isi": { "source": "iana" },
  "application/thraud+xml": { "source": "iana", "compressible": true, "extensions": ["tfi"] },
  "application/timestamp-query": { "source": "iana" },
  "application/timestamp-reply": { "source": "iana" },
  "application/timestamped-data": { "source": "iana", "extensions": ["tsd"] },
  "application/tlsrpt+gzip": { "source": "iana" },
  "application/tlsrpt+json": { "source": "iana", "compressible": true },
  "application/tnauthlist": { "source": "iana" },
  "application/token-introspection+jwt": { "source": "iana" },
  "application/toml": { "compressible": true, "extensions": ["toml"] },
  "application/trickle-ice-sdpfrag": { "source": "iana" },
  "application/trig": { "source": "iana", "extensions": ["trig"] },
  "application/ttml+xml": { "source": "iana", "compressible": true, "extensions": ["ttml"] },
  "application/tve-trigger": { "source": "iana" },
  "application/tzif": { "source": "iana" },
  "application/tzif-leap": { "source": "iana" },
  "application/ubjson": { "compressible": false, "extensions": ["ubj"] },
  "application/ulpfec": { "source": "iana" },
  "application/urc-grpsheet+xml": { "source": "iana", "compressible": true },
  "application/urc-ressheet+xml": { "source": "iana", "compressible": true, "extensions": ["rsheet"] },
  "application/urc-targetdesc+xml": { "source": "iana", "compressible": true, "extensions": ["td"] },
  "application/urc-uisocketdesc+xml": { "source": "iana", "compressible": true },
  "application/vcard+json": { "source": "iana", "compressible": true },
  "application/vcard+xml": { "source": "iana", "compressible": true },
  "application/vemmi": { "source": "iana" },
  "application/vividence.scriptfile": { "source": "apache" },
  "application/vnd.1000minds.decision-model+xml": { "source": "iana", "compressible": true, "extensions": ["1km"] },
  "application/vnd.3gpp-prose+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp-prose-pc3ch+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp-v2x-local-service-information": { "source": "iana" },
  "application/vnd.3gpp.5gnas": { "source": "iana" },
  "application/vnd.3gpp.access-transfer-events+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.bsf+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.gmop+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.gtpc": { "source": "iana" },
  "application/vnd.3gpp.interworking-data": { "source": "iana" },
  "application/vnd.3gpp.lpp": { "source": "iana" },
  "application/vnd.3gpp.mc-signalling-ear": { "source": "iana" },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcdata-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcdata-payload": { "source": "iana" },
  "application/vnd.3gpp.mcdata-service-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcdata-signalling": { "source": "iana" },
  "application/vnd.3gpp.mcdata-ue-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcdata-user-profile+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-floor-request+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-location-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-service-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-signed+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-ue-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcptt-user-profile+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-location-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-service-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-ue-config+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mcvideo-user-profile+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.mid-call+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.ngap": { "source": "iana" },
  "application/vnd.3gpp.pfcp": { "source": "iana" },
  "application/vnd.3gpp.pic-bw-large": { "source": "iana", "extensions": ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { "source": "iana", "extensions": ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { "source": "iana", "extensions": ["pvb"] },
  "application/vnd.3gpp.s1ap": { "source": "iana" },
  "application/vnd.3gpp.sms": { "source": "iana" },
  "application/vnd.3gpp.sms+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.srvcc-ext+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.srvcc-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.state-and-event-info+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp.ussd+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp2.bcmcsinfo+xml": { "source": "iana", "compressible": true },
  "application/vnd.3gpp2.sms": { "source": "iana" },
  "application/vnd.3gpp2.tcap": { "source": "iana", "extensions": ["tcap"] },
  "application/vnd.3lightssoftware.imagescal": { "source": "iana" },
  "application/vnd.3m.post-it-notes": { "source": "iana", "extensions": ["pwn"] },
  "application/vnd.accpac.simply.aso": { "source": "iana", "extensions": ["aso"] },
  "application/vnd.accpac.simply.imp": { "source": "iana", "extensions": ["imp"] },
  "application/vnd.acucobol": { "source": "iana", "extensions": ["acu"] },
  "application/vnd.acucorp": { "source": "iana", "extensions": ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { "source": "apache", "compressible": false, "extensions": ["air"] },
  "application/vnd.adobe.flash.movie": { "source": "iana" },
  "application/vnd.adobe.formscentral.fcdt": { "source": "iana", "extensions": ["fcdt"] },
  "application/vnd.adobe.fxp": { "source": "iana", "extensions": ["fxp", "fxpl"] },
  "application/vnd.adobe.partial-upload": { "source": "iana" },
  "application/vnd.adobe.xdp+xml": { "source": "iana", "compressible": true, "extensions": ["xdp"] },
  "application/vnd.adobe.xfdf": { "source": "iana", "extensions": ["xfdf"] },
  "application/vnd.aether.imp": { "source": "iana" },
  "application/vnd.afpc.afplinedata": { "source": "iana" },
  "application/vnd.afpc.afplinedata-pagedef": { "source": "iana" },
  "application/vnd.afpc.cmoca-cmresource": { "source": "iana" },
  "application/vnd.afpc.foca-charset": { "source": "iana" },
  "application/vnd.afpc.foca-codedfont": { "source": "iana" },
  "application/vnd.afpc.foca-codepage": { "source": "iana" },
  "application/vnd.afpc.modca": { "source": "iana" },
  "application/vnd.afpc.modca-cmtable": { "source": "iana" },
  "application/vnd.afpc.modca-formdef": { "source": "iana" },
  "application/vnd.afpc.modca-mediummap": { "source": "iana" },
  "application/vnd.afpc.modca-objectcontainer": { "source": "iana" },
  "application/vnd.afpc.modca-overlay": { "source": "iana" },
  "application/vnd.afpc.modca-pagesegment": { "source": "iana" },
  "application/vnd.age": { "source": "iana", "extensions": ["age"] },
  "application/vnd.ah-barcode": { "source": "iana" },
  "application/vnd.ahead.space": { "source": "iana", "extensions": ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { "source": "iana", "extensions": ["azf"] },
  "application/vnd.airzip.filesecure.azs": { "source": "iana", "extensions": ["azs"] },
  "application/vnd.amadeus+json": { "source": "iana", "compressible": true },
  "application/vnd.amazon.ebook": { "source": "apache", "extensions": ["azw"] },
  "application/vnd.amazon.mobi8-ebook": { "source": "iana" },
  "application/vnd.americandynamics.acc": { "source": "iana", "extensions": ["acc"] },
  "application/vnd.amiga.ami": { "source": "iana", "extensions": ["ami"] },
  "application/vnd.amundsen.maze+xml": { "source": "iana", "compressible": true },
  "application/vnd.android.ota": { "source": "iana" },
  "application/vnd.android.package-archive": { "source": "apache", "compressible": false, "extensions": ["apk"] },
  "application/vnd.anki": { "source": "iana" },
  "application/vnd.anser-web-certificate-issue-initiation": { "source": "iana", "extensions": ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { "source": "apache", "extensions": ["fti"] },
  "application/vnd.antix.game-component": { "source": "iana", "extensions": ["atx"] },
  "application/vnd.apache.arrow.file": { "source": "iana" },
  "application/vnd.apache.arrow.stream": { "source": "iana" },
  "application/vnd.apache.thrift.binary": { "source": "iana" },
  "application/vnd.apache.thrift.compact": { "source": "iana" },
  "application/vnd.apache.thrift.json": { "source": "iana" },
  "application/vnd.api+json": { "source": "iana", "compressible": true },
  "application/vnd.aplextor.warrp+json": { "source": "iana", "compressible": true },
  "application/vnd.apothekende.reservation+json": { "source": "iana", "compressible": true },
  "application/vnd.apple.installer+xml": { "source": "iana", "compressible": true, "extensions": ["mpkg"] },
  "application/vnd.apple.keynote": { "source": "iana", "extensions": ["key"] },
  "application/vnd.apple.mpegurl": { "source": "iana", "extensions": ["m3u8"] },
  "application/vnd.apple.numbers": { "source": "iana", "extensions": ["numbers"] },
  "application/vnd.apple.pages": { "source": "iana", "extensions": ["pages"] },
  "application/vnd.apple.pkpass": { "compressible": false, "extensions": ["pkpass"] },
  "application/vnd.arastra.swi": { "source": "iana" },
  "application/vnd.aristanetworks.swi": { "source": "iana", "extensions": ["swi"] },
  "application/vnd.artisan+json": { "source": "iana", "compressible": true },
  "application/vnd.artsquare": { "source": "iana" },
  "application/vnd.astraea-software.iota": { "source": "iana", "extensions": ["iota"] },
  "application/vnd.audiograph": { "source": "iana", "extensions": ["aep"] },
  "application/vnd.autopackage": { "source": "iana" },
  "application/vnd.avalon+json": { "source": "iana", "compressible": true },
  "application/vnd.avistar+xml": { "source": "iana", "compressible": true },
  "application/vnd.balsamiq.bmml+xml": { "source": "iana", "compressible": true, "extensions": ["bmml"] },
  "application/vnd.balsamiq.bmpr": { "source": "iana" },
  "application/vnd.banana-accounting": { "source": "iana" },
  "application/vnd.bbf.usp.error": { "source": "iana" },
  "application/vnd.bbf.usp.msg": { "source": "iana" },
  "application/vnd.bbf.usp.msg+json": { "source": "iana", "compressible": true },
  "application/vnd.bekitzur-stech+json": { "source": "iana", "compressible": true },
  "application/vnd.bint.med-content": { "source": "iana" },
  "application/vnd.biopax.rdf+xml": { "source": "iana", "compressible": true },
  "application/vnd.blink-idb-value-wrapper": { "source": "iana" },
  "application/vnd.blueice.multipass": { "source": "iana", "extensions": ["mpm"] },
  "application/vnd.bluetooth.ep.oob": { "source": "iana" },
  "application/vnd.bluetooth.le.oob": { "source": "iana" },
  "application/vnd.bmi": { "source": "iana", "extensions": ["bmi"] },
  "application/vnd.bpf": { "source": "iana" },
  "application/vnd.bpf3": { "source": "iana" },
  "application/vnd.businessobjects": { "source": "iana", "extensions": ["rep"] },
  "application/vnd.byu.uapi+json": { "source": "iana", "compressible": true },
  "application/vnd.cab-jscript": { "source": "iana" },
  "application/vnd.canon-cpdl": { "source": "iana" },
  "application/vnd.canon-lips": { "source": "iana" },
  "application/vnd.capasystems-pg+json": { "source": "iana", "compressible": true },
  "application/vnd.cendio.thinlinc.clientconf": { "source": "iana" },
  "application/vnd.century-systems.tcp_stream": { "source": "iana" },
  "application/vnd.chemdraw+xml": { "source": "iana", "compressible": true, "extensions": ["cdxml"] },
  "application/vnd.chess-pgn": { "source": "iana" },
  "application/vnd.chipnuts.karaoke-mmd": { "source": "iana", "extensions": ["mmd"] },
  "application/vnd.ciedi": { "source": "iana" },
  "application/vnd.cinderella": { "source": "iana", "extensions": ["cdy"] },
  "application/vnd.cirpack.isdn-ext": { "source": "iana" },
  "application/vnd.citationstyles.style+xml": { "source": "iana", "compressible": true, "extensions": ["csl"] },
  "application/vnd.claymore": { "source": "iana", "extensions": ["cla"] },
  "application/vnd.cloanto.rp9": { "source": "iana", "extensions": ["rp9"] },
  "application/vnd.clonk.c4group": { "source": "iana", "extensions": ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { "source": "iana", "extensions": ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { "source": "iana", "extensions": ["c11amz"] },
  "application/vnd.coffeescript": { "source": "iana" },
  "application/vnd.collabio.xodocuments.document": { "source": "iana" },
  "application/vnd.collabio.xodocuments.document-template": { "source": "iana" },
  "application/vnd.collabio.xodocuments.presentation": { "source": "iana" },
  "application/vnd.collabio.xodocuments.presentation-template": { "source": "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet": { "source": "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet-template": { "source": "iana" },
  "application/vnd.collection+json": { "source": "iana", "compressible": true },
  "application/vnd.collection.doc+json": { "source": "iana", "compressible": true },
  "application/vnd.collection.next+json": { "source": "iana", "compressible": true },
  "application/vnd.comicbook+zip": { "source": "iana", "compressible": false },
  "application/vnd.comicbook-rar": { "source": "iana" },
  "application/vnd.commerce-battelle": { "source": "iana" },
  "application/vnd.commonspace": { "source": "iana", "extensions": ["csp"] },
  "application/vnd.contact.cmsg": { "source": "iana", "extensions": ["cdbcmsg"] },
  "application/vnd.coreos.ignition+json": { "source": "iana", "compressible": true },
  "application/vnd.cosmocaller": { "source": "iana", "extensions": ["cmc"] },
  "application/vnd.crick.clicker": { "source": "iana", "extensions": ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { "source": "iana", "extensions": ["clkk"] },
  "application/vnd.crick.clicker.palette": { "source": "iana", "extensions": ["clkp"] },
  "application/vnd.crick.clicker.template": { "source": "iana", "extensions": ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { "source": "iana", "extensions": ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { "source": "iana", "compressible": true, "extensions": ["wbs"] },
  "application/vnd.cryptii.pipe+json": { "source": "iana", "compressible": true },
  "application/vnd.crypto-shade-file": { "source": "iana" },
  "application/vnd.cryptomator.encrypted": { "source": "iana" },
  "application/vnd.cryptomator.vault": { "source": "iana" },
  "application/vnd.ctc-posml": { "source": "iana", "extensions": ["pml"] },
  "application/vnd.ctct.ws+xml": { "source": "iana", "compressible": true },
  "application/vnd.cups-pdf": { "source": "iana" },
  "application/vnd.cups-postscript": { "source": "iana" },
  "application/vnd.cups-ppd": { "source": "iana", "extensions": ["ppd"] },
  "application/vnd.cups-raster": { "source": "iana" },
  "application/vnd.cups-raw": { "source": "iana" },
  "application/vnd.curl": { "source": "iana" },
  "application/vnd.curl.car": { "source": "apache", "extensions": ["car"] },
  "application/vnd.curl.pcurl": { "source": "apache", "extensions": ["pcurl"] },
  "application/vnd.cyan.dean.root+xml": { "source": "iana", "compressible": true },
  "application/vnd.cybank": { "source": "iana" },
  "application/vnd.cyclonedx+json": { "source": "iana", "compressible": true },
  "application/vnd.cyclonedx+xml": { "source": "iana", "compressible": true },
  "application/vnd.d2l.coursepackage1p0+zip": { "source": "iana", "compressible": false },
  "application/vnd.d3m-dataset": { "source": "iana" },
  "application/vnd.d3m-problem": { "source": "iana" },
  "application/vnd.dart": { "source": "iana", "compressible": true, "extensions": ["dart"] },
  "application/vnd.data-vision.rdz": { "source": "iana", "extensions": ["rdz"] },
  "application/vnd.datapackage+json": { "source": "iana", "compressible": true },
  "application/vnd.dataresource+json": { "source": "iana", "compressible": true },
  "application/vnd.dbf": { "source": "iana", "extensions": ["dbf"] },
  "application/vnd.debian.binary-package": { "source": "iana" },
  "application/vnd.dece.data": { "source": "iana", "extensions": ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { "source": "iana", "compressible": true, "extensions": ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { "source": "iana", "extensions": ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { "source": "iana", "extensions": ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { "source": "iana", "extensions": ["fe_launch"] },
  "application/vnd.desmume.movie": { "source": "iana" },
  "application/vnd.dir-bi.plate-dl-nosuffix": { "source": "iana" },
  "application/vnd.dm.delegation+xml": { "source": "iana", "compressible": true },
  "application/vnd.dna": { "source": "iana", "extensions": ["dna"] },
  "application/vnd.document+json": { "source": "iana", "compressible": true },
  "application/vnd.dolby.mlp": { "source": "apache", "extensions": ["mlp"] },
  "application/vnd.dolby.mobile.1": { "source": "iana" },
  "application/vnd.dolby.mobile.2": { "source": "iana" },
  "application/vnd.doremir.scorecloud-binary-document": { "source": "iana" },
  "application/vnd.dpgraph": { "source": "iana", "extensions": ["dpg"] },
  "application/vnd.dreamfactory": { "source": "iana", "extensions": ["dfac"] },
  "application/vnd.drive+json": { "source": "iana", "compressible": true },
  "application/vnd.ds-keypoint": { "source": "apache", "extensions": ["kpxx"] },
  "application/vnd.dtg.local": { "source": "iana" },
  "application/vnd.dtg.local.flash": { "source": "iana" },
  "application/vnd.dtg.local.html": { "source": "iana" },
  "application/vnd.dvb.ait": { "source": "iana", "extensions": ["ait"] },
  "application/vnd.dvb.dvbisl+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.dvbj": { "source": "iana" },
  "application/vnd.dvb.esgcontainer": { "source": "iana" },
  "application/vnd.dvb.ipdcdftnotifaccess": { "source": "iana" },
  "application/vnd.dvb.ipdcesgaccess": { "source": "iana" },
  "application/vnd.dvb.ipdcesgaccess2": { "source": "iana" },
  "application/vnd.dvb.ipdcesgpdd": { "source": "iana" },
  "application/vnd.dvb.ipdcroaming": { "source": "iana" },
  "application/vnd.dvb.iptv.alfec-base": { "source": "iana" },
  "application/vnd.dvb.iptv.alfec-enhancement": { "source": "iana" },
  "application/vnd.dvb.notif-aggregate-root+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-container+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-generic+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-ia-msglist+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-ia-registration-request+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-ia-registration-response+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.notif-init+xml": { "source": "iana", "compressible": true },
  "application/vnd.dvb.pfr": { "source": "iana" },
  "application/vnd.dvb.service": { "source": "iana", "extensions": ["svc"] },
  "application/vnd.dxr": { "source": "iana" },
  "application/vnd.dynageo": { "source": "iana", "extensions": ["geo"] },
  "application/vnd.dzr": { "source": "iana" },
  "application/vnd.easykaraoke.cdgdownload": { "source": "iana" },
  "application/vnd.ecdis-update": { "source": "iana" },
  "application/vnd.ecip.rlp": { "source": "iana" },
  "application/vnd.eclipse.ditto+json": { "source": "iana", "compressible": true },
  "application/vnd.ecowin.chart": { "source": "iana", "extensions": ["mag"] },
  "application/vnd.ecowin.filerequest": { "source": "iana" },
  "application/vnd.ecowin.fileupdate": { "source": "iana" },
  "application/vnd.ecowin.series": { "source": "iana" },
  "application/vnd.ecowin.seriesrequest": { "source": "iana" },
  "application/vnd.ecowin.seriesupdate": { "source": "iana" },
  "application/vnd.efi.img": { "source": "iana" },
  "application/vnd.efi.iso": { "source": "iana" },
  "application/vnd.emclient.accessrequest+xml": { "source": "iana", "compressible": true },
  "application/vnd.enliven": { "source": "iana", "extensions": ["nml"] },
  "application/vnd.enphase.envoy": { "source": "iana" },
  "application/vnd.eprints.data+xml": { "source": "iana", "compressible": true },
  "application/vnd.epson.esf": { "source": "iana", "extensions": ["esf"] },
  "application/vnd.epson.msf": { "source": "iana", "extensions": ["msf"] },
  "application/vnd.epson.quickanime": { "source": "iana", "extensions": ["qam"] },
  "application/vnd.epson.salt": { "source": "iana", "extensions": ["slt"] },
  "application/vnd.epson.ssf": { "source": "iana", "extensions": ["ssf"] },
  "application/vnd.ericsson.quickcall": { "source": "iana" },
  "application/vnd.espass-espass+zip": { "source": "iana", "compressible": false },
  "application/vnd.eszigno3+xml": { "source": "iana", "compressible": true, "extensions": ["es3", "et3"] },
  "application/vnd.etsi.aoc+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.asic-e+zip": { "source": "iana", "compressible": false },
  "application/vnd.etsi.asic-s+zip": { "source": "iana", "compressible": false },
  "application/vnd.etsi.cug+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvcommand+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvdiscovery+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvprofile+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvsad-bc+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvsad-cod+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvsad-npvr+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvservice+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvsync+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.iptvueprofile+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.mcid+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.mheg5": { "source": "iana" },
  "application/vnd.etsi.overload-control-policy-dataset+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.pstn+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.sci+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.simservs+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.timestamp-token": { "source": "iana" },
  "application/vnd.etsi.tsl+xml": { "source": "iana", "compressible": true },
  "application/vnd.etsi.tsl.der": { "source": "iana" },
  "application/vnd.eu.kasparian.car+json": { "source": "iana", "compressible": true },
  "application/vnd.eudora.data": { "source": "iana" },
  "application/vnd.evolv.ecig.profile": { "source": "iana" },
  "application/vnd.evolv.ecig.settings": { "source": "iana" },
  "application/vnd.evolv.ecig.theme": { "source": "iana" },
  "application/vnd.exstream-empower+zip": { "source": "iana", "compressible": false },
  "application/vnd.exstream-package": { "source": "iana" },
  "application/vnd.ezpix-album": { "source": "iana", "extensions": ["ez2"] },
  "application/vnd.ezpix-package": { "source": "iana", "extensions": ["ez3"] },
  "application/vnd.f-secure.mobile": { "source": "iana" },
  "application/vnd.familysearch.gedcom+zip": { "source": "iana", "compressible": false },
  "application/vnd.fastcopy-disk-image": { "source": "iana" },
  "application/vnd.fdf": { "source": "iana", "extensions": ["fdf"] },
  "application/vnd.fdsn.mseed": { "source": "iana", "extensions": ["mseed"] },
  "application/vnd.fdsn.seed": { "source": "iana", "extensions": ["seed", "dataless"] },
  "application/vnd.ffsns": { "source": "iana" },
  "application/vnd.ficlab.flb+zip": { "source": "iana", "compressible": false },
  "application/vnd.filmit.zfc": { "source": "iana" },
  "application/vnd.fints": { "source": "iana" },
  "application/vnd.firemonkeys.cloudcell": { "source": "iana" },
  "application/vnd.flographit": { "source": "iana", "extensions": ["gph"] },
  "application/vnd.fluxtime.clip": { "source": "iana", "extensions": ["ftc"] },
  "application/vnd.font-fontforge-sfd": { "source": "iana" },
  "application/vnd.framemaker": { "source": "iana", "extensions": ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { "source": "iana", "extensions": ["fnc"] },
  "application/vnd.frogans.ltf": { "source": "iana", "extensions": ["ltf"] },
  "application/vnd.fsc.weblaunch": { "source": "iana", "extensions": ["fsc"] },
  "application/vnd.fujifilm.fb.docuworks": { "source": "iana" },
  "application/vnd.fujifilm.fb.docuworks.binder": { "source": "iana" },
  "application/vnd.fujifilm.fb.docuworks.container": { "source": "iana" },
  "application/vnd.fujifilm.fb.jfi+xml": { "source": "iana", "compressible": true },
  "application/vnd.fujitsu.oasys": { "source": "iana", "extensions": ["oas"] },
  "application/vnd.fujitsu.oasys2": { "source": "iana", "extensions": ["oa2"] },
  "application/vnd.fujitsu.oasys3": { "source": "iana", "extensions": ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { "source": "iana", "extensions": ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { "source": "iana", "extensions": ["bh2"] },
  "application/vnd.fujixerox.art-ex": { "source": "iana" },
  "application/vnd.fujixerox.art4": { "source": "iana" },
  "application/vnd.fujixerox.ddd": { "source": "iana", "extensions": ["ddd"] },
  "application/vnd.fujixerox.docuworks": { "source": "iana", "extensions": ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { "source": "iana", "extensions": ["xbd"] },
  "application/vnd.fujixerox.docuworks.container": { "source": "iana" },
  "application/vnd.fujixerox.hbpl": { "source": "iana" },
  "application/vnd.fut-misnet": { "source": "iana" },
  "application/vnd.futoin+cbor": { "source": "iana" },
  "application/vnd.futoin+json": { "source": "iana", "compressible": true },
  "application/vnd.fuzzysheet": { "source": "iana", "extensions": ["fzs"] },
  "application/vnd.genomatix.tuxedo": { "source": "iana", "extensions": ["txd"] },
  "application/vnd.gentics.grd+json": { "source": "iana", "compressible": true },
  "application/vnd.geo+json": { "source": "iana", "compressible": true },
  "application/vnd.geocube+xml": { "source": "iana", "compressible": true },
  "application/vnd.geogebra.file": { "source": "iana", "extensions": ["ggb"] },
  "application/vnd.geogebra.slides": { "source": "iana" },
  "application/vnd.geogebra.tool": { "source": "iana", "extensions": ["ggt"] },
  "application/vnd.geometry-explorer": { "source": "iana", "extensions": ["gex", "gre"] },
  "application/vnd.geonext": { "source": "iana", "extensions": ["gxt"] },
  "application/vnd.geoplan": { "source": "iana", "extensions": ["g2w"] },
  "application/vnd.geospace": { "source": "iana", "extensions": ["g3w"] },
  "application/vnd.gerber": { "source": "iana" },
  "application/vnd.globalplatform.card-content-mgt": { "source": "iana" },
  "application/vnd.globalplatform.card-content-mgt-response": { "source": "iana" },
  "application/vnd.gmx": { "source": "iana", "extensions": ["gmx"] },
  "application/vnd.google-apps.document": { "compressible": false, "extensions": ["gdoc"] },
  "application/vnd.google-apps.presentation": { "compressible": false, "extensions": ["gslides"] },
  "application/vnd.google-apps.spreadsheet": { "compressible": false, "extensions": ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { "source": "iana", "compressible": true, "extensions": ["kml"] },
  "application/vnd.google-earth.kmz": { "source": "iana", "compressible": false, "extensions": ["kmz"] },
  "application/vnd.gov.sk.e-form+xml": { "source": "iana", "compressible": true },
  "application/vnd.gov.sk.e-form+zip": { "source": "iana", "compressible": false },
  "application/vnd.gov.sk.xmldatacontainer+xml": { "source": "iana", "compressible": true },
  "application/vnd.grafeq": { "source": "iana", "extensions": ["gqf", "gqs"] },
  "application/vnd.gridmp": { "source": "iana" },
  "application/vnd.groove-account": { "source": "iana", "extensions": ["gac"] },
  "application/vnd.groove-help": { "source": "iana", "extensions": ["ghf"] },
  "application/vnd.groove-identity-message": { "source": "iana", "extensions": ["gim"] },
  "application/vnd.groove-injector": { "source": "iana", "extensions": ["grv"] },
  "application/vnd.groove-tool-message": { "source": "iana", "extensions": ["gtm"] },
  "application/vnd.groove-tool-template": { "source": "iana", "extensions": ["tpl"] },
  "application/vnd.groove-vcard": { "source": "iana", "extensions": ["vcg"] },
  "application/vnd.hal+json": { "source": "iana", "compressible": true },
  "application/vnd.hal+xml": { "source": "iana", "compressible": true, "extensions": ["hal"] },
  "application/vnd.handheld-entertainment+xml": { "source": "iana", "compressible": true, "extensions": ["zmm"] },
  "application/vnd.hbci": { "source": "iana", "extensions": ["hbci"] },
  "application/vnd.hc+json": { "source": "iana", "compressible": true },
  "application/vnd.hcl-bireports": { "source": "iana" },
  "application/vnd.hdt": { "source": "iana" },
  "application/vnd.heroku+json": { "source": "iana", "compressible": true },
  "application/vnd.hhe.lesson-player": { "source": "iana", "extensions": ["les"] },
  "application/vnd.hl7cda+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.hl7v2+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.hp-hpgl": { "source": "iana", "extensions": ["hpgl"] },
  "application/vnd.hp-hpid": { "source": "iana", "extensions": ["hpid"] },
  "application/vnd.hp-hps": { "source": "iana", "extensions": ["hps"] },
  "application/vnd.hp-jlyt": { "source": "iana", "extensions": ["jlt"] },
  "application/vnd.hp-pcl": { "source": "iana", "extensions": ["pcl"] },
  "application/vnd.hp-pclxl": { "source": "iana", "extensions": ["pclxl"] },
  "application/vnd.httphone": { "source": "iana" },
  "application/vnd.hydrostatix.sof-data": { "source": "iana", "extensions": ["sfd-hdstx"] },
  "application/vnd.hyper+json": { "source": "iana", "compressible": true },
  "application/vnd.hyper-item+json": { "source": "iana", "compressible": true },
  "application/vnd.hyperdrive+json": { "source": "iana", "compressible": true },
  "application/vnd.hzn-3d-crossword": { "source": "iana" },
  "application/vnd.ibm.afplinedata": { "source": "iana" },
  "application/vnd.ibm.electronic-media": { "source": "iana" },
  "application/vnd.ibm.minipay": { "source": "iana", "extensions": ["mpy"] },
  "application/vnd.ibm.modcap": { "source": "iana", "extensions": ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { "source": "iana", "extensions": ["irm"] },
  "application/vnd.ibm.secure-container": { "source": "iana", "extensions": ["sc"] },
  "application/vnd.iccprofile": { "source": "iana", "extensions": ["icc", "icm"] },
  "application/vnd.ieee.1905": { "source": "iana" },
  "application/vnd.igloader": { "source": "iana", "extensions": ["igl"] },
  "application/vnd.imagemeter.folder+zip": { "source": "iana", "compressible": false },
  "application/vnd.imagemeter.image+zip": { "source": "iana", "compressible": false },
  "application/vnd.immervision-ivp": { "source": "iana", "extensions": ["ivp"] },
  "application/vnd.immervision-ivu": { "source": "iana", "extensions": ["ivu"] },
  "application/vnd.ims.imsccv1p1": { "source": "iana" },
  "application/vnd.ims.imsccv1p2": { "source": "iana" },
  "application/vnd.ims.imsccv1p3": { "source": "iana" },
  "application/vnd.ims.lis.v2.result+json": { "source": "iana", "compressible": true },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": { "source": "iana", "compressible": true },
  "application/vnd.ims.lti.v2.toolproxy+json": { "source": "iana", "compressible": true },
  "application/vnd.ims.lti.v2.toolproxy.id+json": { "source": "iana", "compressible": true },
  "application/vnd.ims.lti.v2.toolsettings+json": { "source": "iana", "compressible": true },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": { "source": "iana", "compressible": true },
  "application/vnd.informedcontrol.rms+xml": { "source": "iana", "compressible": true },
  "application/vnd.informix-visionary": { "source": "iana" },
  "application/vnd.infotech.project": { "source": "iana" },
  "application/vnd.infotech.project+xml": { "source": "iana", "compressible": true },
  "application/vnd.innopath.wamp.notification": { "source": "iana" },
  "application/vnd.insors.igm": { "source": "iana", "extensions": ["igm"] },
  "application/vnd.intercon.formnet": { "source": "iana", "extensions": ["xpw", "xpx"] },
  "application/vnd.intergeo": { "source": "iana", "extensions": ["i2g"] },
  "application/vnd.intertrust.digibox": { "source": "iana" },
  "application/vnd.intertrust.nncp": { "source": "iana" },
  "application/vnd.intu.qbo": { "source": "iana", "extensions": ["qbo"] },
  "application/vnd.intu.qfx": { "source": "iana", "extensions": ["qfx"] },
  "application/vnd.iptc.g2.catalogitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.conceptitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.knowledgeitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.newsitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.newsmessage+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.packageitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.iptc.g2.planningitem+xml": { "source": "iana", "compressible": true },
  "application/vnd.ipunplugged.rcprofile": { "source": "iana", "extensions": ["rcprofile"] },
  "application/vnd.irepository.package+xml": { "source": "iana", "compressible": true, "extensions": ["irp"] },
  "application/vnd.is-xpr": { "source": "iana", "extensions": ["xpr"] },
  "application/vnd.isac.fcs": { "source": "iana", "extensions": ["fcs"] },
  "application/vnd.iso11783-10+zip": { "source": "iana", "compressible": false },
  "application/vnd.jam": { "source": "iana", "extensions": ["jam"] },
  "application/vnd.japannet-directory-service": { "source": "iana" },
  "application/vnd.japannet-jpnstore-wakeup": { "source": "iana" },
  "application/vnd.japannet-payment-wakeup": { "source": "iana" },
  "application/vnd.japannet-registration": { "source": "iana" },
  "application/vnd.japannet-registration-wakeup": { "source": "iana" },
  "application/vnd.japannet-setstore-wakeup": { "source": "iana" },
  "application/vnd.japannet-verification": { "source": "iana" },
  "application/vnd.japannet-verification-wakeup": { "source": "iana" },
  "application/vnd.jcp.javame.midlet-rms": { "source": "iana", "extensions": ["rms"] },
  "application/vnd.jisp": { "source": "iana", "extensions": ["jisp"] },
  "application/vnd.joost.joda-archive": { "source": "iana", "extensions": ["joda"] },
  "application/vnd.jsk.isdn-ngn": { "source": "iana" },
  "application/vnd.kahootz": { "source": "iana", "extensions": ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { "source": "iana", "extensions": ["karbon"] },
  "application/vnd.kde.kchart": { "source": "iana", "extensions": ["chrt"] },
  "application/vnd.kde.kformula": { "source": "iana", "extensions": ["kfo"] },
  "application/vnd.kde.kivio": { "source": "iana", "extensions": ["flw"] },
  "application/vnd.kde.kontour": { "source": "iana", "extensions": ["kon"] },
  "application/vnd.kde.kpresenter": { "source": "iana", "extensions": ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { "source": "iana", "extensions": ["ksp"] },
  "application/vnd.kde.kword": { "source": "iana", "extensions": ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { "source": "iana", "extensions": ["htke"] },
  "application/vnd.kidspiration": { "source": "iana", "extensions": ["kia"] },
  "application/vnd.kinar": { "source": "iana", "extensions": ["kne", "knp"] },
  "application/vnd.koan": { "source": "iana", "extensions": ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { "source": "iana", "extensions": ["sse"] },
  "application/vnd.las": { "source": "iana" },
  "application/vnd.las.las+json": { "source": "iana", "compressible": true },
  "application/vnd.las.las+xml": { "source": "iana", "compressible": true, "extensions": ["lasxml"] },
  "application/vnd.laszip": { "source": "iana" },
  "application/vnd.leap+json": { "source": "iana", "compressible": true },
  "application/vnd.liberty-request+xml": { "source": "iana", "compressible": true },
  "application/vnd.llamagraphics.life-balance.desktop": { "source": "iana", "extensions": ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { "source": "iana", "compressible": true, "extensions": ["lbe"] },
  "application/vnd.logipipe.circuit+zip": { "source": "iana", "compressible": false },
  "application/vnd.loom": { "source": "iana" },
  "application/vnd.lotus-1-2-3": { "source": "iana", "extensions": ["123"] },
  "application/vnd.lotus-approach": { "source": "iana", "extensions": ["apr"] },
  "application/vnd.lotus-freelance": { "source": "iana", "extensions": ["pre"] },
  "application/vnd.lotus-notes": { "source": "iana", "extensions": ["nsf"] },
  "application/vnd.lotus-organizer": { "source": "iana", "extensions": ["org"] },
  "application/vnd.lotus-screencam": { "source": "iana", "extensions": ["scm"] },
  "application/vnd.lotus-wordpro": { "source": "iana", "extensions": ["lwp"] },
  "application/vnd.macports.portpkg": { "source": "iana", "extensions": ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { "source": "iana", "extensions": ["mvt"] },
  "application/vnd.marlin.drm.actiontoken+xml": { "source": "iana", "compressible": true },
  "application/vnd.marlin.drm.conftoken+xml": { "source": "iana", "compressible": true },
  "application/vnd.marlin.drm.license+xml": { "source": "iana", "compressible": true },
  "application/vnd.marlin.drm.mdcf": { "source": "iana" },
  "application/vnd.mason+json": { "source": "iana", "compressible": true },
  "application/vnd.maxar.archive.3tz+zip": { "source": "iana", "compressible": false },
  "application/vnd.maxmind.maxmind-db": { "source": "iana" },
  "application/vnd.mcd": { "source": "iana", "extensions": ["mcd"] },
  "application/vnd.medcalcdata": { "source": "iana", "extensions": ["mc1"] },
  "application/vnd.mediastation.cdkey": { "source": "iana", "extensions": ["cdkey"] },
  "application/vnd.meridian-slingshot": { "source": "iana" },
  "application/vnd.mfer": { "source": "iana", "extensions": ["mwf"] },
  "application/vnd.mfmp": { "source": "iana", "extensions": ["mfm"] },
  "application/vnd.micro+json": { "source": "iana", "compressible": true },
  "application/vnd.micrografx.flo": { "source": "iana", "extensions": ["flo"] },
  "application/vnd.micrografx.igx": { "source": "iana", "extensions": ["igx"] },
  "application/vnd.microsoft.portable-executable": { "source": "iana" },
  "application/vnd.microsoft.windows.thumbnail-cache": { "source": "iana" },
  "application/vnd.miele+json": { "source": "iana", "compressible": true },
  "application/vnd.mif": { "source": "iana", "extensions": ["mif"] },
  "application/vnd.minisoft-hp3000-save": { "source": "iana" },
  "application/vnd.mitsubishi.misty-guard.trustweb": { "source": "iana" },
  "application/vnd.mobius.daf": { "source": "iana", "extensions": ["daf"] },
  "application/vnd.mobius.dis": { "source": "iana", "extensions": ["dis"] },
  "application/vnd.mobius.mbk": { "source": "iana", "extensions": ["mbk"] },
  "application/vnd.mobius.mqy": { "source": "iana", "extensions": ["mqy"] },
  "application/vnd.mobius.msl": { "source": "iana", "extensions": ["msl"] },
  "application/vnd.mobius.plc": { "source": "iana", "extensions": ["plc"] },
  "application/vnd.mobius.txf": { "source": "iana", "extensions": ["txf"] },
  "application/vnd.mophun.application": { "source": "iana", "extensions": ["mpn"] },
  "application/vnd.mophun.certificate": { "source": "iana", "extensions": ["mpc"] },
  "application/vnd.motorola.flexsuite": { "source": "iana" },
  "application/vnd.motorola.flexsuite.adsi": { "source": "iana" },
  "application/vnd.motorola.flexsuite.fis": { "source": "iana" },
  "application/vnd.motorola.flexsuite.gotap": { "source": "iana" },
  "application/vnd.motorola.flexsuite.kmr": { "source": "iana" },
  "application/vnd.motorola.flexsuite.ttc": { "source": "iana" },
  "application/vnd.motorola.flexsuite.wem": { "source": "iana" },
  "application/vnd.motorola.iprm": { "source": "iana" },
  "application/vnd.mozilla.xul+xml": { "source": "iana", "compressible": true, "extensions": ["xul"] },
  "application/vnd.ms-3mfdocument": { "source": "iana" },
  "application/vnd.ms-artgalry": { "source": "iana", "extensions": ["cil"] },
  "application/vnd.ms-asf": { "source": "iana" },
  "application/vnd.ms-cab-compressed": { "source": "iana", "extensions": ["cab"] },
  "application/vnd.ms-color.iccprofile": { "source": "apache" },
  "application/vnd.ms-excel": { "source": "iana", "compressible": false, "extensions": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { "source": "iana", "extensions": ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { "source": "iana", "extensions": ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { "source": "iana", "extensions": ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { "source": "iana", "extensions": ["xltm"] },
  "application/vnd.ms-fontobject": { "source": "iana", "compressible": true, "extensions": ["eot"] },
  "application/vnd.ms-htmlhelp": { "source": "iana", "extensions": ["chm"] },
  "application/vnd.ms-ims": { "source": "iana", "extensions": ["ims"] },
  "application/vnd.ms-lrm": { "source": "iana", "extensions": ["lrm"] },
  "application/vnd.ms-office.activex+xml": { "source": "iana", "compressible": true },
  "application/vnd.ms-officetheme": { "source": "iana", "extensions": ["thmx"] },
  "application/vnd.ms-opentype": { "source": "apache", "compressible": true },
  "application/vnd.ms-outlook": { "compressible": false, "extensions": ["msg"] },
  "application/vnd.ms-package.obfuscated-opentype": { "source": "apache" },
  "application/vnd.ms-pki.seccat": { "source": "apache", "extensions": ["cat"] },
  "application/vnd.ms-pki.stl": { "source": "apache", "extensions": ["stl"] },
  "application/vnd.ms-playready.initiator+xml": { "source": "iana", "compressible": true },
  "application/vnd.ms-powerpoint": { "source": "iana", "compressible": false, "extensions": ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { "source": "iana", "extensions": ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { "source": "iana", "extensions": ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { "source": "iana", "extensions": ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { "source": "iana", "extensions": ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { "source": "iana", "extensions": ["potm"] },
  "application/vnd.ms-printdevicecapabilities+xml": { "source": "iana", "compressible": true },
  "application/vnd.ms-printing.printticket+xml": { "source": "apache", "compressible": true },
  "application/vnd.ms-printschematicket+xml": { "source": "iana", "compressible": true },
  "application/vnd.ms-project": { "source": "iana", "extensions": ["mpp", "mpt"] },
  "application/vnd.ms-tnef": { "source": "iana" },
  "application/vnd.ms-windows.devicepairing": { "source": "iana" },
  "application/vnd.ms-windows.nwprinting.oob": { "source": "iana" },
  "application/vnd.ms-windows.printerpairing": { "source": "iana" },
  "application/vnd.ms-windows.wsd.oob": { "source": "iana" },
  "application/vnd.ms-wmdrm.lic-chlg-req": { "source": "iana" },
  "application/vnd.ms-wmdrm.lic-resp": { "source": "iana" },
  "application/vnd.ms-wmdrm.meter-chlg-req": { "source": "iana" },
  "application/vnd.ms-wmdrm.meter-resp": { "source": "iana" },
  "application/vnd.ms-word.document.macroenabled.12": { "source": "iana", "extensions": ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { "source": "iana", "extensions": ["dotm"] },
  "application/vnd.ms-works": { "source": "iana", "extensions": ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { "source": "iana", "extensions": ["wpl"] },
  "application/vnd.ms-xpsdocument": { "source": "iana", "compressible": false, "extensions": ["xps"] },
  "application/vnd.msa-disk-image": { "source": "iana" },
  "application/vnd.mseq": { "source": "iana", "extensions": ["mseq"] },
  "application/vnd.msign": { "source": "iana" },
  "application/vnd.multiad.creator": { "source": "iana" },
  "application/vnd.multiad.creator.cif": { "source": "iana" },
  "application/vnd.music-niff": { "source": "iana" },
  "application/vnd.musician": { "source": "iana", "extensions": ["mus"] },
  "application/vnd.muvee.style": { "source": "iana", "extensions": ["msty"] },
  "application/vnd.mynfc": { "source": "iana", "extensions": ["taglet"] },
  "application/vnd.nacamar.ybrid+json": { "source": "iana", "compressible": true },
  "application/vnd.ncd.control": { "source": "iana" },
  "application/vnd.ncd.reference": { "source": "iana" },
  "application/vnd.nearst.inv+json": { "source": "iana", "compressible": true },
  "application/vnd.nebumind.line": { "source": "iana" },
  "application/vnd.nervana": { "source": "iana" },
  "application/vnd.netfpx": { "source": "iana" },
  "application/vnd.neurolanguage.nlu": { "source": "iana", "extensions": ["nlu"] },
  "application/vnd.nimn": { "source": "iana" },
  "application/vnd.nintendo.nitro.rom": { "source": "iana" },
  "application/vnd.nintendo.snes.rom": { "source": "iana" },
  "application/vnd.nitf": { "source": "iana", "extensions": ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { "source": "iana", "extensions": ["nnd"] },
  "application/vnd.noblenet-sealer": { "source": "iana", "extensions": ["nns"] },
  "application/vnd.noblenet-web": { "source": "iana", "extensions": ["nnw"] },
  "application/vnd.nokia.catalogs": { "source": "iana" },
  "application/vnd.nokia.conml+wbxml": { "source": "iana" },
  "application/vnd.nokia.conml+xml": { "source": "iana", "compressible": true },
  "application/vnd.nokia.iptv.config+xml": { "source": "iana", "compressible": true },
  "application/vnd.nokia.isds-radio-presets": { "source": "iana" },
  "application/vnd.nokia.landmark+wbxml": { "source": "iana" },
  "application/vnd.nokia.landmark+xml": { "source": "iana", "compressible": true },
  "application/vnd.nokia.landmarkcollection+xml": { "source": "iana", "compressible": true },
  "application/vnd.nokia.n-gage.ac+xml": { "source": "iana", "compressible": true, "extensions": ["ac"] },
  "application/vnd.nokia.n-gage.data": { "source": "iana", "extensions": ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { "source": "iana", "extensions": ["n-gage"] },
  "application/vnd.nokia.ncd": { "source": "iana" },
  "application/vnd.nokia.pcd+wbxml": { "source": "iana" },
  "application/vnd.nokia.pcd+xml": { "source": "iana", "compressible": true },
  "application/vnd.nokia.radio-preset": { "source": "iana", "extensions": ["rpst"] },
  "application/vnd.nokia.radio-presets": { "source": "iana", "extensions": ["rpss"] },
  "application/vnd.novadigm.edm": { "source": "iana", "extensions": ["edm"] },
  "application/vnd.novadigm.edx": { "source": "iana", "extensions": ["edx"] },
  "application/vnd.novadigm.ext": { "source": "iana", "extensions": ["ext"] },
  "application/vnd.ntt-local.content-share": { "source": "iana" },
  "application/vnd.ntt-local.file-transfer": { "source": "iana" },
  "application/vnd.ntt-local.ogw_remote-access": { "source": "iana" },
  "application/vnd.ntt-local.sip-ta_remote": { "source": "iana" },
  "application/vnd.ntt-local.sip-ta_tcp_stream": { "source": "iana" },
  "application/vnd.oasis.opendocument.chart": { "source": "iana", "extensions": ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { "source": "iana", "extensions": ["otc"] },
  "application/vnd.oasis.opendocument.database": { "source": "iana", "extensions": ["odb"] },
  "application/vnd.oasis.opendocument.formula": { "source": "iana", "extensions": ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { "source": "iana", "extensions": ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { "source": "iana", "compressible": false, "extensions": ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { "source": "iana", "extensions": ["otg"] },
  "application/vnd.oasis.opendocument.image": { "source": "iana", "extensions": ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { "source": "iana", "extensions": ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { "source": "iana", "compressible": false, "extensions": ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { "source": "iana", "extensions": ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { "source": "iana", "compressible": false, "extensions": ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { "source": "iana", "extensions": ["ots"] },
  "application/vnd.oasis.opendocument.text": { "source": "iana", "compressible": false, "extensions": ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { "source": "iana", "extensions": ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { "source": "iana", "extensions": ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { "source": "iana", "extensions": ["oth"] },
  "application/vnd.obn": { "source": "iana" },
  "application/vnd.ocf+cbor": { "source": "iana" },
  "application/vnd.oci.image.manifest.v1+json": { "source": "iana", "compressible": true },
  "application/vnd.oftn.l10n+json": { "source": "iana", "compressible": true },
  "application/vnd.oipf.contentaccessdownload+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.contentaccessstreaming+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.cspg-hexbinary": { "source": "iana" },
  "application/vnd.oipf.dae.svg+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.dae.xhtml+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.mippvcontrolmessage+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.pae.gem": { "source": "iana" },
  "application/vnd.oipf.spdiscovery+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.spdlist+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.ueprofile+xml": { "source": "iana", "compressible": true },
  "application/vnd.oipf.userprofile+xml": { "source": "iana", "compressible": true },
  "application/vnd.olpc-sugar": { "source": "iana", "extensions": ["xo"] },
  "application/vnd.oma-scws-config": { "source": "iana" },
  "application/vnd.oma-scws-http-request": { "source": "iana" },
  "application/vnd.oma-scws-http-response": { "source": "iana" },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.drm-trigger+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.imd+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.ltkm": { "source": "iana" },
  "application/vnd.oma.bcast.notification+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.provisioningtrigger": { "source": "iana" },
  "application/vnd.oma.bcast.sgboot": { "source": "iana" },
  "application/vnd.oma.bcast.sgdd+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.sgdu": { "source": "iana" },
  "application/vnd.oma.bcast.simple-symbol-container": { "source": "iana" },
  "application/vnd.oma.bcast.smartcard-trigger+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.sprov+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.bcast.stkm": { "source": "iana" },
  "application/vnd.oma.cab-address-book+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.cab-feature-handler+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.cab-pcc+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.cab-subs-invite+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.cab-user-prefs+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.dcd": { "source": "iana" },
  "application/vnd.oma.dcdc": { "source": "iana" },
  "application/vnd.oma.dd2+xml": { "source": "iana", "compressible": true, "extensions": ["dd2"] },
  "application/vnd.oma.drm.risd+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.group-usage-list+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.lwm2m+cbor": { "source": "iana" },
  "application/vnd.oma.lwm2m+json": { "source": "iana", "compressible": true },
  "application/vnd.oma.lwm2m+tlv": { "source": "iana" },
  "application/vnd.oma.pal+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.poc.detailed-progress-report+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.poc.final-report+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.poc.groups+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.poc.invocation-descriptor+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.poc.optimized-progress-report+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.push": { "source": "iana" },
  "application/vnd.oma.scidm.messages+xml": { "source": "iana", "compressible": true },
  "application/vnd.oma.xcap-directory+xml": { "source": "iana", "compressible": true },
  "application/vnd.omads-email+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.omads-file+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.omads-folder+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.omaloc-supl-init": { "source": "iana" },
  "application/vnd.onepager": { "source": "iana" },
  "application/vnd.onepagertamp": { "source": "iana" },
  "application/vnd.onepagertamx": { "source": "iana" },
  "application/vnd.onepagertat": { "source": "iana" },
  "application/vnd.onepagertatp": { "source": "iana" },
  "application/vnd.onepagertatx": { "source": "iana" },
  "application/vnd.openblox.game+xml": { "source": "iana", "compressible": true, "extensions": ["obgx"] },
  "application/vnd.openblox.game-binary": { "source": "iana" },
  "application/vnd.openeye.oeb": { "source": "iana" },
  "application/vnd.openofficeorg.extension": { "source": "apache", "extensions": ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { "source": "iana", "compressible": true, "extensions": ["osm"] },
  "application/vnd.opentimestamps.ots": { "source": "iana" },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawing+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { "source": "iana", "compressible": false, "extensions": ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { "source": "iana", "extensions": ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { "source": "iana", "extensions": ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { "source": "iana", "extensions": ["potx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { "source": "iana", "compressible": false, "extensions": ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { "source": "iana", "extensions": ["xltx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.theme+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.vmldrawing": { "source": "iana" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { "source": "iana", "compressible": false, "extensions": ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { "source": "iana", "extensions": ["dotx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-package.core-properties+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": { "source": "iana", "compressible": true },
  "application/vnd.openxmlformats-package.relationships+xml": { "source": "iana", "compressible": true },
  "application/vnd.oracle.resource+json": { "source": "iana", "compressible": true },
  "application/vnd.orange.indata": { "source": "iana" },
  "application/vnd.osa.netdeploy": { "source": "iana" },
  "application/vnd.osgeo.mapguide.package": { "source": "iana", "extensions": ["mgp"] },
  "application/vnd.osgi.bundle": { "source": "iana" },
  "application/vnd.osgi.dp": { "source": "iana", "extensions": ["dp"] },
  "application/vnd.osgi.subsystem": { "source": "iana", "extensions": ["esa"] },
  "application/vnd.otps.ct-kip+xml": { "source": "iana", "compressible": true },
  "application/vnd.oxli.countgraph": { "source": "iana" },
  "application/vnd.pagerduty+json": { "source": "iana", "compressible": true },
  "application/vnd.palm": { "source": "iana", "extensions": ["pdb", "pqa", "oprc"] },
  "application/vnd.panoply": { "source": "iana" },
  "application/vnd.paos.xml": { "source": "iana" },
  "application/vnd.patentdive": { "source": "iana" },
  "application/vnd.patientecommsdoc": { "source": "iana" },
  "application/vnd.pawaafile": { "source": "iana", "extensions": ["paw"] },
  "application/vnd.pcos": { "source": "iana" },
  "application/vnd.pg.format": { "source": "iana", "extensions": ["str"] },
  "application/vnd.pg.osasli": { "source": "iana", "extensions": ["ei6"] },
  "application/vnd.piaccess.application-licence": { "source": "iana" },
  "application/vnd.picsel": { "source": "iana", "extensions": ["efif"] },
  "application/vnd.pmi.widget": { "source": "iana", "extensions": ["wg"] },
  "application/vnd.poc.group-advertisement+xml": { "source": "iana", "compressible": true },
  "application/vnd.pocketlearn": { "source": "iana", "extensions": ["plf"] },
  "application/vnd.powerbuilder6": { "source": "iana", "extensions": ["pbd"] },
  "application/vnd.powerbuilder6-s": { "source": "iana" },
  "application/vnd.powerbuilder7": { "source": "iana" },
  "application/vnd.powerbuilder7-s": { "source": "iana" },
  "application/vnd.powerbuilder75": { "source": "iana" },
  "application/vnd.powerbuilder75-s": { "source": "iana" },
  "application/vnd.preminet": { "source": "iana" },
  "application/vnd.previewsystems.box": { "source": "iana", "extensions": ["box"] },
  "application/vnd.proteus.magazine": { "source": "iana", "extensions": ["mgz"] },
  "application/vnd.psfs": { "source": "iana" },
  "application/vnd.publishare-delta-tree": { "source": "iana", "extensions": ["qps"] },
  "application/vnd.pvi.ptid1": { "source": "iana", "extensions": ["ptid"] },
  "application/vnd.pwg-multiplexed": { "source": "iana" },
  "application/vnd.pwg-xhtml-print+xml": { "source": "iana", "compressible": true },
  "application/vnd.qualcomm.brew-app-res": { "source": "iana" },
  "application/vnd.quarantainenet": { "source": "iana" },
  "application/vnd.quark.quarkxpress": { "source": "iana", "extensions": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.quobject-quoxdocument": { "source": "iana" },
  "application/vnd.radisys.moml+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-audit+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-audit-conf+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-audit-conn+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-audit-dialog+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-audit-stream+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-conf+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-base+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-group+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-speech+xml": { "source": "iana", "compressible": true },
  "application/vnd.radisys.msml-dialog-transform+xml": { "source": "iana", "compressible": true },
  "application/vnd.rainstor.data": { "source": "iana" },
  "application/vnd.rapid": { "source": "iana" },
  "application/vnd.rar": { "source": "iana", "extensions": ["rar"] },
  "application/vnd.realvnc.bed": { "source": "iana", "extensions": ["bed"] },
  "application/vnd.recordare.musicxml": { "source": "iana", "extensions": ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { "source": "iana", "compressible": true, "extensions": ["musicxml"] },
  "application/vnd.renlearn.rlprint": { "source": "iana" },
  "application/vnd.resilient.logic": { "source": "iana" },
  "application/vnd.restful+json": { "source": "iana", "compressible": true },
  "application/vnd.rig.cryptonote": { "source": "iana", "extensions": ["cryptonote"] },
  "application/vnd.rim.cod": { "source": "apache", "extensions": ["cod"] },
  "application/vnd.rn-realmedia": { "source": "apache", "extensions": ["rm"] },
  "application/vnd.rn-realmedia-vbr": { "source": "apache", "extensions": ["rmvb"] },
  "application/vnd.route66.link66+xml": { "source": "iana", "compressible": true, "extensions": ["link66"] },
  "application/vnd.rs-274x": { "source": "iana" },
  "application/vnd.ruckus.download": { "source": "iana" },
  "application/vnd.s3sms": { "source": "iana" },
  "application/vnd.sailingtracker.track": { "source": "iana", "extensions": ["st"] },
  "application/vnd.sar": { "source": "iana" },
  "application/vnd.sbm.cid": { "source": "iana" },
  "application/vnd.sbm.mid2": { "source": "iana" },
  "application/vnd.scribus": { "source": "iana" },
  "application/vnd.sealed.3df": { "source": "iana" },
  "application/vnd.sealed.csf": { "source": "iana" },
  "application/vnd.sealed.doc": { "source": "iana" },
  "application/vnd.sealed.eml": { "source": "iana" },
  "application/vnd.sealed.mht": { "source": "iana" },
  "application/vnd.sealed.net": { "source": "iana" },
  "application/vnd.sealed.ppt": { "source": "iana" },
  "application/vnd.sealed.tiff": { "source": "iana" },
  "application/vnd.sealed.xls": { "source": "iana" },
  "application/vnd.sealedmedia.softseal.html": { "source": "iana" },
  "application/vnd.sealedmedia.softseal.pdf": { "source": "iana" },
  "application/vnd.seemail": { "source": "iana", "extensions": ["see"] },
  "application/vnd.seis+json": { "source": "iana", "compressible": true },
  "application/vnd.sema": { "source": "iana", "extensions": ["sema"] },
  "application/vnd.semd": { "source": "iana", "extensions": ["semd"] },
  "application/vnd.semf": { "source": "iana", "extensions": ["semf"] },
  "application/vnd.shade-save-file": { "source": "iana" },
  "application/vnd.shana.informed.formdata": { "source": "iana", "extensions": ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { "source": "iana", "extensions": ["itp"] },
  "application/vnd.shana.informed.interchange": { "source": "iana", "extensions": ["iif"] },
  "application/vnd.shana.informed.package": { "source": "iana", "extensions": ["ipk"] },
  "application/vnd.shootproof+json": { "source": "iana", "compressible": true },
  "application/vnd.shopkick+json": { "source": "iana", "compressible": true },
  "application/vnd.shp": { "source": "iana" },
  "application/vnd.shx": { "source": "iana" },
  "application/vnd.sigrok.session": { "source": "iana" },
  "application/vnd.simtech-mindmapper": { "source": "iana", "extensions": ["twd", "twds"] },
  "application/vnd.siren+json": { "source": "iana", "compressible": true },
  "application/vnd.smaf": { "source": "iana", "extensions": ["mmf"] },
  "application/vnd.smart.notebook": { "source": "iana" },
  "application/vnd.smart.teacher": { "source": "iana", "extensions": ["teacher"] },
  "application/vnd.snesdev-page-table": { "source": "iana" },
  "application/vnd.software602.filler.form+xml": { "source": "iana", "compressible": true, "extensions": ["fo"] },
  "application/vnd.software602.filler.form-xml-zip": { "source": "iana" },
  "application/vnd.solent.sdkm+xml": { "source": "iana", "compressible": true, "extensions": ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { "source": "iana", "extensions": ["dxp"] },
  "application/vnd.spotfire.sfs": { "source": "iana", "extensions": ["sfs"] },
  "application/vnd.sqlite3": { "source": "iana" },
  "application/vnd.sss-cod": { "source": "iana" },
  "application/vnd.sss-dtf": { "source": "iana" },
  "application/vnd.sss-ntf": { "source": "iana" },
  "application/vnd.stardivision.calc": { "source": "apache", "extensions": ["sdc"] },
  "application/vnd.stardivision.draw": { "source": "apache", "extensions": ["sda"] },
  "application/vnd.stardivision.impress": { "source": "apache", "extensions": ["sdd"] },
  "application/vnd.stardivision.math": { "source": "apache", "extensions": ["smf"] },
  "application/vnd.stardivision.writer": { "source": "apache", "extensions": ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { "source": "apache", "extensions": ["sgl"] },
  "application/vnd.stepmania.package": { "source": "iana", "extensions": ["smzip"] },
  "application/vnd.stepmania.stepchart": { "source": "iana", "extensions": ["sm"] },
  "application/vnd.street-stream": { "source": "iana" },
  "application/vnd.sun.wadl+xml": { "source": "iana", "compressible": true, "extensions": ["wadl"] },
  "application/vnd.sun.xml.calc": { "source": "apache", "extensions": ["sxc"] },
  "application/vnd.sun.xml.calc.template": { "source": "apache", "extensions": ["stc"] },
  "application/vnd.sun.xml.draw": { "source": "apache", "extensions": ["sxd"] },
  "application/vnd.sun.xml.draw.template": { "source": "apache", "extensions": ["std"] },
  "application/vnd.sun.xml.impress": { "source": "apache", "extensions": ["sxi"] },
  "application/vnd.sun.xml.impress.template": { "source": "apache", "extensions": ["sti"] },
  "application/vnd.sun.xml.math": { "source": "apache", "extensions": ["sxm"] },
  "application/vnd.sun.xml.writer": { "source": "apache", "extensions": ["sxw"] },
  "application/vnd.sun.xml.writer.global": { "source": "apache", "extensions": ["sxg"] },
  "application/vnd.sun.xml.writer.template": { "source": "apache", "extensions": ["stw"] },
  "application/vnd.sus-calendar": { "source": "iana", "extensions": ["sus", "susp"] },
  "application/vnd.svd": { "source": "iana", "extensions": ["svd"] },
  "application/vnd.swiftview-ics": { "source": "iana" },
  "application/vnd.sycle+xml": { "source": "iana", "compressible": true },
  "application/vnd.syft+json": { "source": "iana", "compressible": true },
  "application/vnd.symbian.install": { "source": "apache", "extensions": ["sis", "sisx"] },
  "application/vnd.syncml+xml": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { "source": "iana", "charset": "UTF-8", "extensions": ["bdm"] },
  "application/vnd.syncml.dm+xml": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["xdm"] },
  "application/vnd.syncml.dm.notification": { "source": "iana" },
  "application/vnd.syncml.dmddf+wbxml": { "source": "iana" },
  "application/vnd.syncml.dmddf+xml": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["ddf"] },
  "application/vnd.syncml.dmtnds+wbxml": { "source": "iana" },
  "application/vnd.syncml.dmtnds+xml": { "source": "iana", "charset": "UTF-8", "compressible": true },
  "application/vnd.syncml.ds.notification": { "source": "iana" },
  "application/vnd.tableschema+json": { "source": "iana", "compressible": true },
  "application/vnd.tao.intent-module-archive": { "source": "iana", "extensions": ["tao"] },
  "application/vnd.tcpdump.pcap": { "source": "iana", "extensions": ["pcap", "cap", "dmp"] },
  "application/vnd.think-cell.ppttc+json": { "source": "iana", "compressible": true },
  "application/vnd.tmd.mediaflex.api+xml": { "source": "iana", "compressible": true },
  "application/vnd.tml": { "source": "iana" },
  "application/vnd.tmobile-livetv": { "source": "iana", "extensions": ["tmo"] },
  "application/vnd.tri.onesource": { "source": "iana" },
  "application/vnd.trid.tpt": { "source": "iana", "extensions": ["tpt"] },
  "application/vnd.triscape.mxs": { "source": "iana", "extensions": ["mxs"] },
  "application/vnd.trueapp": { "source": "iana", "extensions": ["tra"] },
  "application/vnd.truedoc": { "source": "iana" },
  "application/vnd.ubisoft.webplayer": { "source": "iana" },
  "application/vnd.ufdl": { "source": "iana", "extensions": ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { "source": "iana", "extensions": ["utz"] },
  "application/vnd.umajin": { "source": "iana", "extensions": ["umj"] },
  "application/vnd.unity": { "source": "iana", "extensions": ["unityweb"] },
  "application/vnd.uoml+xml": { "source": "iana", "compressible": true, "extensions": ["uoml"] },
  "application/vnd.uplanet.alert": { "source": "iana" },
  "application/vnd.uplanet.alert-wbxml": { "source": "iana" },
  "application/vnd.uplanet.bearer-choice": { "source": "iana" },
  "application/vnd.uplanet.bearer-choice-wbxml": { "source": "iana" },
  "application/vnd.uplanet.cacheop": { "source": "iana" },
  "application/vnd.uplanet.cacheop-wbxml": { "source": "iana" },
  "application/vnd.uplanet.channel": { "source": "iana" },
  "application/vnd.uplanet.channel-wbxml": { "source": "iana" },
  "application/vnd.uplanet.list": { "source": "iana" },
  "application/vnd.uplanet.list-wbxml": { "source": "iana" },
  "application/vnd.uplanet.listcmd": { "source": "iana" },
  "application/vnd.uplanet.listcmd-wbxml": { "source": "iana" },
  "application/vnd.uplanet.signal": { "source": "iana" },
  "application/vnd.uri-map": { "source": "iana" },
  "application/vnd.valve.source.material": { "source": "iana" },
  "application/vnd.vcx": { "source": "iana", "extensions": ["vcx"] },
  "application/vnd.vd-study": { "source": "iana" },
  "application/vnd.vectorworks": { "source": "iana" },
  "application/vnd.vel+json": { "source": "iana", "compressible": true },
  "application/vnd.verimatrix.vcas": { "source": "iana" },
  "application/vnd.veritone.aion+json": { "source": "iana", "compressible": true },
  "application/vnd.veryant.thin": { "source": "iana" },
  "application/vnd.ves.encrypted": { "source": "iana" },
  "application/vnd.vidsoft.vidconference": { "source": "iana" },
  "application/vnd.visio": { "source": "iana", "extensions": ["vsd", "vst", "vss", "vsw"] },
  "application/vnd.visionary": { "source": "iana", "extensions": ["vis"] },
  "application/vnd.vividence.scriptfile": { "source": "iana" },
  "application/vnd.vsf": { "source": "iana", "extensions": ["vsf"] },
  "application/vnd.wap.sic": { "source": "iana" },
  "application/vnd.wap.slc": { "source": "iana" },
  "application/vnd.wap.wbxml": { "source": "iana", "charset": "UTF-8", "extensions": ["wbxml"] },
  "application/vnd.wap.wmlc": { "source": "iana", "extensions": ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { "source": "iana", "extensions": ["wmlsc"] },
  "application/vnd.webturbo": { "source": "iana", "extensions": ["wtb"] },
  "application/vnd.wfa.dpp": { "source": "iana" },
  "application/vnd.wfa.p2p": { "source": "iana" },
  "application/vnd.wfa.wsc": { "source": "iana" },
  "application/vnd.windows.devicepairing": { "source": "iana" },
  "application/vnd.wmc": { "source": "iana" },
  "application/vnd.wmf.bootstrap": { "source": "iana" },
  "application/vnd.wolfram.mathematica": { "source": "iana" },
  "application/vnd.wolfram.mathematica.package": { "source": "iana" },
  "application/vnd.wolfram.player": { "source": "iana", "extensions": ["nbp"] },
  "application/vnd.wordperfect": { "source": "iana", "extensions": ["wpd"] },
  "application/vnd.wqd": { "source": "iana", "extensions": ["wqd"] },
  "application/vnd.wrq-hp3000-labelled": { "source": "iana" },
  "application/vnd.wt.stf": { "source": "iana", "extensions": ["stf"] },
  "application/vnd.wv.csp+wbxml": { "source": "iana" },
  "application/vnd.wv.csp+xml": { "source": "iana", "compressible": true },
  "application/vnd.wv.ssp+xml": { "source": "iana", "compressible": true },
  "application/vnd.xacml+json": { "source": "iana", "compressible": true },
  "application/vnd.xara": { "source": "iana", "extensions": ["xar"] },
  "application/vnd.xfdl": { "source": "iana", "extensions": ["xfdl"] },
  "application/vnd.xfdl.webform": { "source": "iana" },
  "application/vnd.xmi+xml": { "source": "iana", "compressible": true },
  "application/vnd.xmpie.cpkg": { "source": "iana" },
  "application/vnd.xmpie.dpkg": { "source": "iana" },
  "application/vnd.xmpie.plan": { "source": "iana" },
  "application/vnd.xmpie.ppkg": { "source": "iana" },
  "application/vnd.xmpie.xlim": { "source": "iana" },
  "application/vnd.yamaha.hv-dic": { "source": "iana", "extensions": ["hvd"] },
  "application/vnd.yamaha.hv-script": { "source": "iana", "extensions": ["hvs"] },
  "application/vnd.yamaha.hv-voice": { "source": "iana", "extensions": ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { "source": "iana", "extensions": ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { "source": "iana", "compressible": true, "extensions": ["osfpvg"] },
  "application/vnd.yamaha.remote-setup": { "source": "iana" },
  "application/vnd.yamaha.smaf-audio": { "source": "iana", "extensions": ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { "source": "iana", "extensions": ["spf"] },
  "application/vnd.yamaha.through-ngn": { "source": "iana" },
  "application/vnd.yamaha.tunnel-udpencap": { "source": "iana" },
  "application/vnd.yaoweme": { "source": "iana" },
  "application/vnd.yellowriver-custom-menu": { "source": "iana", "extensions": ["cmp"] },
  "application/vnd.youtube.yt": { "source": "iana" },
  "application/vnd.zul": { "source": "iana", "extensions": ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { "source": "iana", "compressible": true, "extensions": ["zaz"] },
  "application/voicexml+xml": { "source": "iana", "compressible": true, "extensions": ["vxml"] },
  "application/voucher-cms+json": { "source": "iana", "compressible": true },
  "application/vq-rtcpxr": { "source": "iana" },
  "application/wasm": { "source": "iana", "compressible": true, "extensions": ["wasm"] },
  "application/watcherinfo+xml": { "source": "iana", "compressible": true, "extensions": ["wif"] },
  "application/webpush-options+json": { "source": "iana", "compressible": true },
  "application/whoispp-query": { "source": "iana" },
  "application/whoispp-response": { "source": "iana" },
  "application/widget": { "source": "iana", "extensions": ["wgt"] },
  "application/winhlp": { "source": "apache", "extensions": ["hlp"] },
  "application/wita": { "source": "iana" },
  "application/wordperfect5.1": { "source": "iana" },
  "application/wsdl+xml": { "source": "iana", "compressible": true, "extensions": ["wsdl"] },
  "application/wspolicy+xml": { "source": "iana", "compressible": true, "extensions": ["wspolicy"] },
  "application/x-7z-compressed": { "source": "apache", "compressible": false, "extensions": ["7z"] },
  "application/x-abiword": { "source": "apache", "extensions": ["abw"] },
  "application/x-ace-compressed": { "source": "apache", "extensions": ["ace"] },
  "application/x-amf": { "source": "apache" },
  "application/x-apple-diskimage": { "source": "apache", "extensions": ["dmg"] },
  "application/x-arj": { "compressible": false, "extensions": ["arj"] },
  "application/x-authorware-bin": { "source": "apache", "extensions": ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { "source": "apache", "extensions": ["aam"] },
  "application/x-authorware-seg": { "source": "apache", "extensions": ["aas"] },
  "application/x-bcpio": { "source": "apache", "extensions": ["bcpio"] },
  "application/x-bdoc": { "compressible": false, "extensions": ["bdoc"] },
  "application/x-bittorrent": { "source": "apache", "extensions": ["torrent"] },
  "application/x-blorb": { "source": "apache", "extensions": ["blb", "blorb"] },
  "application/x-bzip": { "source": "apache", "compressible": false, "extensions": ["bz"] },
  "application/x-bzip2": { "source": "apache", "compressible": false, "extensions": ["bz2", "boz"] },
  "application/x-cbr": { "source": "apache", "extensions": ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { "source": "apache", "extensions": ["vcd"] },
  "application/x-cfs-compressed": { "source": "apache", "extensions": ["cfs"] },
  "application/x-chat": { "source": "apache", "extensions": ["chat"] },
  "application/x-chess-pgn": { "source": "apache", "extensions": ["pgn"] },
  "application/x-chrome-extension": { "extensions": ["crx"] },
  "application/x-cocoa": { "source": "nginx", "extensions": ["cco"] },
  "application/x-compress": { "source": "apache" },
  "application/x-conference": { "source": "apache", "extensions": ["nsc"] },
  "application/x-cpio": { "source": "apache", "extensions": ["cpio"] },
  "application/x-csh": { "source": "apache", "extensions": ["csh"] },
  "application/x-deb": { "compressible": false },
  "application/x-debian-package": { "source": "apache", "extensions": ["deb", "udeb"] },
  "application/x-dgc-compressed": { "source": "apache", "extensions": ["dgc"] },
  "application/x-director": { "source": "apache", "extensions": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { "source": "apache", "extensions": ["wad"] },
  "application/x-dtbncx+xml": { "source": "apache", "compressible": true, "extensions": ["ncx"] },
  "application/x-dtbook+xml": { "source": "apache", "compressible": true, "extensions": ["dtb"] },
  "application/x-dtbresource+xml": { "source": "apache", "compressible": true, "extensions": ["res"] },
  "application/x-dvi": { "source": "apache", "compressible": false, "extensions": ["dvi"] },
  "application/x-envoy": { "source": "apache", "extensions": ["evy"] },
  "application/x-eva": { "source": "apache", "extensions": ["eva"] },
  "application/x-font-bdf": { "source": "apache", "extensions": ["bdf"] },
  "application/x-font-dos": { "source": "apache" },
  "application/x-font-framemaker": { "source": "apache" },
  "application/x-font-ghostscript": { "source": "apache", "extensions": ["gsf"] },
  "application/x-font-libgrx": { "source": "apache" },
  "application/x-font-linux-psf": { "source": "apache", "extensions": ["psf"] },
  "application/x-font-pcf": { "source": "apache", "extensions": ["pcf"] },
  "application/x-font-snf": { "source": "apache", "extensions": ["snf"] },
  "application/x-font-speedo": { "source": "apache" },
  "application/x-font-sunos-news": { "source": "apache" },
  "application/x-font-type1": { "source": "apache", "extensions": ["pfa", "pfb", "pfm", "afm"] },
  "application/x-font-vfont": { "source": "apache" },
  "application/x-freearc": { "source": "apache", "extensions": ["arc"] },
  "application/x-futuresplash": { "source": "apache", "extensions": ["spl"] },
  "application/x-gca-compressed": { "source": "apache", "extensions": ["gca"] },
  "application/x-glulx": { "source": "apache", "extensions": ["ulx"] },
  "application/x-gnumeric": { "source": "apache", "extensions": ["gnumeric"] },
  "application/x-gramps-xml": { "source": "apache", "extensions": ["gramps"] },
  "application/x-gtar": { "source": "apache", "extensions": ["gtar"] },
  "application/x-gzip": { "source": "apache" },
  "application/x-hdf": { "source": "apache", "extensions": ["hdf"] },
  "application/x-httpd-php": { "compressible": true, "extensions": ["php"] },
  "application/x-install-instructions": { "source": "apache", "extensions": ["install"] },
  "application/x-iso9660-image": { "source": "apache", "extensions": ["iso"] },
  "application/x-iwork-keynote-sffkey": { "extensions": ["key"] },
  "application/x-iwork-numbers-sffnumbers": { "extensions": ["numbers"] },
  "application/x-iwork-pages-sffpages": { "extensions": ["pages"] },
  "application/x-java-archive-diff": { "source": "nginx", "extensions": ["jardiff"] },
  "application/x-java-jnlp-file": { "source": "apache", "compressible": false, "extensions": ["jnlp"] },
  "application/x-javascript": { "compressible": true },
  "application/x-keepass2": { "extensions": ["kdbx"] },
  "application/x-latex": { "source": "apache", "compressible": false, "extensions": ["latex"] },
  "application/x-lua-bytecode": { "extensions": ["luac"] },
  "application/x-lzh-compressed": { "source": "apache", "extensions": ["lzh", "lha"] },
  "application/x-makeself": { "source": "nginx", "extensions": ["run"] },
  "application/x-mie": { "source": "apache", "extensions": ["mie"] },
  "application/x-mobipocket-ebook": { "source": "apache", "extensions": ["prc", "mobi"] },
  "application/x-mpegurl": { "compressible": false },
  "application/x-ms-application": { "source": "apache", "extensions": ["application"] },
  "application/x-ms-shortcut": { "source": "apache", "extensions": ["lnk"] },
  "application/x-ms-wmd": { "source": "apache", "extensions": ["wmd"] },
  "application/x-ms-wmz": { "source": "apache", "extensions": ["wmz"] },
  "application/x-ms-xbap": { "source": "apache", "extensions": ["xbap"] },
  "application/x-msaccess": { "source": "apache", "extensions": ["mdb"] },
  "application/x-msbinder": { "source": "apache", "extensions": ["obd"] },
  "application/x-mscardfile": { "source": "apache", "extensions": ["crd"] },
  "application/x-msclip": { "source": "apache", "extensions": ["clp"] },
  "application/x-msdos-program": { "extensions": ["exe"] },
  "application/x-msdownload": { "source": "apache", "extensions": ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { "source": "apache", "extensions": ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { "source": "apache", "extensions": ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { "source": "apache", "extensions": ["mny"] },
  "application/x-mspublisher": { "source": "apache", "extensions": ["pub"] },
  "application/x-msschedule": { "source": "apache", "extensions": ["scd"] },
  "application/x-msterminal": { "source": "apache", "extensions": ["trm"] },
  "application/x-mswrite": { "source": "apache", "extensions": ["wri"] },
  "application/x-netcdf": { "source": "apache", "extensions": ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { "compressible": true, "extensions": ["pac"] },
  "application/x-nzb": { "source": "apache", "extensions": ["nzb"] },
  "application/x-perl": { "source": "nginx", "extensions": ["pl", "pm"] },
  "application/x-pilot": { "source": "nginx", "extensions": ["prc", "pdb"] },
  "application/x-pkcs12": { "source": "apache", "compressible": false, "extensions": ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { "source": "apache", "extensions": ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { "source": "apache", "extensions": ["p7r"] },
  "application/x-pki-message": { "source": "iana" },
  "application/x-rar-compressed": { "source": "apache", "compressible": false, "extensions": ["rar"] },
  "application/x-redhat-package-manager": { "source": "nginx", "extensions": ["rpm"] },
  "application/x-research-info-systems": { "source": "apache", "extensions": ["ris"] },
  "application/x-sea": { "source": "nginx", "extensions": ["sea"] },
  "application/x-sh": { "source": "apache", "compressible": true, "extensions": ["sh"] },
  "application/x-shar": { "source": "apache", "extensions": ["shar"] },
  "application/x-shockwave-flash": { "source": "apache", "compressible": false, "extensions": ["swf"] },
  "application/x-silverlight-app": { "source": "apache", "extensions": ["xap"] },
  "application/x-sql": { "source": "apache", "extensions": ["sql"] },
  "application/x-stuffit": { "source": "apache", "compressible": false, "extensions": ["sit"] },
  "application/x-stuffitx": { "source": "apache", "extensions": ["sitx"] },
  "application/x-subrip": { "source": "apache", "extensions": ["srt"] },
  "application/x-sv4cpio": { "source": "apache", "extensions": ["sv4cpio"] },
  "application/x-sv4crc": { "source": "apache", "extensions": ["sv4crc"] },
  "application/x-t3vm-image": { "source": "apache", "extensions": ["t3"] },
  "application/x-tads": { "source": "apache", "extensions": ["gam"] },
  "application/x-tar": { "source": "apache", "compressible": true, "extensions": ["tar"] },
  "application/x-tcl": { "source": "apache", "extensions": ["tcl", "tk"] },
  "application/x-tex": { "source": "apache", "extensions": ["tex"] },
  "application/x-tex-tfm": { "source": "apache", "extensions": ["tfm"] },
  "application/x-texinfo": { "source": "apache", "extensions": ["texinfo", "texi"] },
  "application/x-tgif": { "source": "apache", "extensions": ["obj"] },
  "application/x-ustar": { "source": "apache", "extensions": ["ustar"] },
  "application/x-virtualbox-hdd": { "compressible": true, "extensions": ["hdd"] },
  "application/x-virtualbox-ova": { "compressible": true, "extensions": ["ova"] },
  "application/x-virtualbox-ovf": { "compressible": true, "extensions": ["ovf"] },
  "application/x-virtualbox-vbox": { "compressible": true, "extensions": ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { "compressible": false, "extensions": ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { "compressible": true, "extensions": ["vdi"] },
  "application/x-virtualbox-vhd": { "compressible": true, "extensions": ["vhd"] },
  "application/x-virtualbox-vmdk": { "compressible": true, "extensions": ["vmdk"] },
  "application/x-wais-source": { "source": "apache", "extensions": ["src"] },
  "application/x-web-app-manifest+json": { "compressible": true, "extensions": ["webapp"] },
  "application/x-www-form-urlencoded": { "source": "iana", "compressible": true },
  "application/x-x509-ca-cert": { "source": "iana", "extensions": ["der", "crt", "pem"] },
  "application/x-x509-ca-ra-cert": { "source": "iana" },
  "application/x-x509-next-ca-cert": { "source": "iana" },
  "application/x-xfig": { "source": "apache", "extensions": ["fig"] },
  "application/x-xliff+xml": { "source": "apache", "compressible": true, "extensions": ["xlf"] },
  "application/x-xpinstall": { "source": "apache", "compressible": false, "extensions": ["xpi"] },
  "application/x-xz": { "source": "apache", "extensions": ["xz"] },
  "application/x-zmachine": { "source": "apache", "extensions": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/x400-bp": { "source": "iana" },
  "application/xacml+xml": { "source": "iana", "compressible": true },
  "application/xaml+xml": { "source": "apache", "compressible": true, "extensions": ["xaml"] },
  "application/xcap-att+xml": { "source": "iana", "compressible": true, "extensions": ["xav"] },
  "application/xcap-caps+xml": { "source": "iana", "compressible": true, "extensions": ["xca"] },
  "application/xcap-diff+xml": { "source": "iana", "compressible": true, "extensions": ["xdf"] },
  "application/xcap-el+xml": { "source": "iana", "compressible": true, "extensions": ["xel"] },
  "application/xcap-error+xml": { "source": "iana", "compressible": true },
  "application/xcap-ns+xml": { "source": "iana", "compressible": true, "extensions": ["xns"] },
  "application/xcon-conference-info+xml": { "source": "iana", "compressible": true },
  "application/xcon-conference-info-diff+xml": { "source": "iana", "compressible": true },
  "application/xenc+xml": { "source": "iana", "compressible": true, "extensions": ["xenc"] },
  "application/xhtml+xml": { "source": "iana", "compressible": true, "extensions": ["xhtml", "xht"] },
  "application/xhtml-voice+xml": { "source": "apache", "compressible": true },
  "application/xliff+xml": { "source": "iana", "compressible": true, "extensions": ["xlf"] },
  "application/xml": { "source": "iana", "compressible": true, "extensions": ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { "source": "iana", "compressible": true, "extensions": ["dtd"] },
  "application/xml-external-parsed-entity": { "source": "iana" },
  "application/xml-patch+xml": { "source": "iana", "compressible": true },
  "application/xmpp+xml": { "source": "iana", "compressible": true },
  "application/xop+xml": { "source": "iana", "compressible": true, "extensions": ["xop"] },
  "application/xproc+xml": { "source": "apache", "compressible": true, "extensions": ["xpl"] },
  "application/xslt+xml": { "source": "iana", "compressible": true, "extensions": ["xsl", "xslt"] },
  "application/xspf+xml": { "source": "apache", "compressible": true, "extensions": ["xspf"] },
  "application/xv+xml": { "source": "iana", "compressible": true, "extensions": ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { "source": "iana", "extensions": ["yang"] },
  "application/yang-data+json": { "source": "iana", "compressible": true },
  "application/yang-data+xml": { "source": "iana", "compressible": true },
  "application/yang-patch+json": { "source": "iana", "compressible": true },
  "application/yang-patch+xml": { "source": "iana", "compressible": true },
  "application/yin+xml": { "source": "iana", "compressible": true, "extensions": ["yin"] },
  "application/zip": { "source": "iana", "compressible": false, "extensions": ["zip"] },
  "application/zlib": { "source": "iana" },
  "application/zstd": { "source": "iana" },
  "audio/1d-interleaved-parityfec": { "source": "iana" },
  "audio/32kadpcm": { "source": "iana" },
  "audio/3gpp": { "source": "iana", "compressible": false, "extensions": ["3gpp"] },
  "audio/3gpp2": { "source": "iana" },
  "audio/aac": { "source": "iana" },
  "audio/ac3": { "source": "iana" },
  "audio/adpcm": { "source": "apache", "extensions": ["adp"] },
  "audio/amr": { "source": "iana", "extensions": ["amr"] },
  "audio/amr-wb": { "source": "iana" },
  "audio/amr-wb+": { "source": "iana" },
  "audio/aptx": { "source": "iana" },
  "audio/asc": { "source": "iana" },
  "audio/atrac-advanced-lossless": { "source": "iana" },
  "audio/atrac-x": { "source": "iana" },
  "audio/atrac3": { "source": "iana" },
  "audio/basic": { "source": "iana", "compressible": false, "extensions": ["au", "snd"] },
  "audio/bv16": { "source": "iana" },
  "audio/bv32": { "source": "iana" },
  "audio/clearmode": { "source": "iana" },
  "audio/cn": { "source": "iana" },
  "audio/dat12": { "source": "iana" },
  "audio/dls": { "source": "iana" },
  "audio/dsr-es201108": { "source": "iana" },
  "audio/dsr-es202050": { "source": "iana" },
  "audio/dsr-es202211": { "source": "iana" },
  "audio/dsr-es202212": { "source": "iana" },
  "audio/dv": { "source": "iana" },
  "audio/dvi4": { "source": "iana" },
  "audio/eac3": { "source": "iana" },
  "audio/encaprtp": { "source": "iana" },
  "audio/evrc": { "source": "iana" },
  "audio/evrc-qcp": { "source": "iana" },
  "audio/evrc0": { "source": "iana" },
  "audio/evrc1": { "source": "iana" },
  "audio/evrcb": { "source": "iana" },
  "audio/evrcb0": { "source": "iana" },
  "audio/evrcb1": { "source": "iana" },
  "audio/evrcnw": { "source": "iana" },
  "audio/evrcnw0": { "source": "iana" },
  "audio/evrcnw1": { "source": "iana" },
  "audio/evrcwb": { "source": "iana" },
  "audio/evrcwb0": { "source": "iana" },
  "audio/evrcwb1": { "source": "iana" },
  "audio/evs": { "source": "iana" },
  "audio/flexfec": { "source": "iana" },
  "audio/fwdred": { "source": "iana" },
  "audio/g711-0": { "source": "iana" },
  "audio/g719": { "source": "iana" },
  "audio/g722": { "source": "iana" },
  "audio/g7221": { "source": "iana" },
  "audio/g723": { "source": "iana" },
  "audio/g726-16": { "source": "iana" },
  "audio/g726-24": { "source": "iana" },
  "audio/g726-32": { "source": "iana" },
  "audio/g726-40": { "source": "iana" },
  "audio/g728": { "source": "iana" },
  "audio/g729": { "source": "iana" },
  "audio/g7291": { "source": "iana" },
  "audio/g729d": { "source": "iana" },
  "audio/g729e": { "source": "iana" },
  "audio/gsm": { "source": "iana" },
  "audio/gsm-efr": { "source": "iana" },
  "audio/gsm-hr-08": { "source": "iana" },
  "audio/ilbc": { "source": "iana" },
  "audio/ip-mr_v2.5": { "source": "iana" },
  "audio/isac": { "source": "apache" },
  "audio/l16": { "source": "iana" },
  "audio/l20": { "source": "iana" },
  "audio/l24": { "source": "iana", "compressible": false },
  "audio/l8": { "source": "iana" },
  "audio/lpc": { "source": "iana" },
  "audio/melp": { "source": "iana" },
  "audio/melp1200": { "source": "iana" },
  "audio/melp2400": { "source": "iana" },
  "audio/melp600": { "source": "iana" },
  "audio/mhas": { "source": "iana" },
  "audio/midi": { "source": "apache", "extensions": ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { "source": "iana", "extensions": ["mxmf"] },
  "audio/mp3": { "compressible": false, "extensions": ["mp3"] },
  "audio/mp4": { "source": "iana", "compressible": false, "extensions": ["m4a", "mp4a"] },
  "audio/mp4a-latm": { "source": "iana" },
  "audio/mpa": { "source": "iana" },
  "audio/mpa-robust": { "source": "iana" },
  "audio/mpeg": { "source": "iana", "compressible": false, "extensions": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/mpeg4-generic": { "source": "iana" },
  "audio/musepack": { "source": "apache" },
  "audio/ogg": { "source": "iana", "compressible": false, "extensions": ["oga", "ogg", "spx", "opus"] },
  "audio/opus": { "source": "iana" },
  "audio/parityfec": { "source": "iana" },
  "audio/pcma": { "source": "iana" },
  "audio/pcma-wb": { "source": "iana" },
  "audio/pcmu": { "source": "iana" },
  "audio/pcmu-wb": { "source": "iana" },
  "audio/prs.sid": { "source": "iana" },
  "audio/qcelp": { "source": "iana" },
  "audio/raptorfec": { "source": "iana" },
  "audio/red": { "source": "iana" },
  "audio/rtp-enc-aescm128": { "source": "iana" },
  "audio/rtp-midi": { "source": "iana" },
  "audio/rtploopback": { "source": "iana" },
  "audio/rtx": { "source": "iana" },
  "audio/s3m": { "source": "apache", "extensions": ["s3m"] },
  "audio/scip": { "source": "iana" },
  "audio/silk": { "source": "apache", "extensions": ["sil"] },
  "audio/smv": { "source": "iana" },
  "audio/smv-qcp": { "source": "iana" },
  "audio/smv0": { "source": "iana" },
  "audio/sofa": { "source": "iana" },
  "audio/sp-midi": { "source": "iana" },
  "audio/speex": { "source": "iana" },
  "audio/t140c": { "source": "iana" },
  "audio/t38": { "source": "iana" },
  "audio/telephone-event": { "source": "iana" },
  "audio/tetra_acelp": { "source": "iana" },
  "audio/tetra_acelp_bb": { "source": "iana" },
  "audio/tone": { "source": "iana" },
  "audio/tsvcis": { "source": "iana" },
  "audio/uemclip": { "source": "iana" },
  "audio/ulpfec": { "source": "iana" },
  "audio/usac": { "source": "iana" },
  "audio/vdvi": { "source": "iana" },
  "audio/vmr-wb": { "source": "iana" },
  "audio/vnd.3gpp.iufp": { "source": "iana" },
  "audio/vnd.4sb": { "source": "iana" },
  "audio/vnd.audiokoz": { "source": "iana" },
  "audio/vnd.celp": { "source": "iana" },
  "audio/vnd.cisco.nse": { "source": "iana" },
  "audio/vnd.cmles.radio-events": { "source": "iana" },
  "audio/vnd.cns.anp1": { "source": "iana" },
  "audio/vnd.cns.inf1": { "source": "iana" },
  "audio/vnd.dece.audio": { "source": "iana", "extensions": ["uva", "uvva"] },
  "audio/vnd.digital-winds": { "source": "iana", "extensions": ["eol"] },
  "audio/vnd.dlna.adts": { "source": "iana" },
  "audio/vnd.dolby.heaac.1": { "source": "iana" },
  "audio/vnd.dolby.heaac.2": { "source": "iana" },
  "audio/vnd.dolby.mlp": { "source": "iana" },
  "audio/vnd.dolby.mps": { "source": "iana" },
  "audio/vnd.dolby.pl2": { "source": "iana" },
  "audio/vnd.dolby.pl2x": { "source": "iana" },
  "audio/vnd.dolby.pl2z": { "source": "iana" },
  "audio/vnd.dolby.pulse.1": { "source": "iana" },
  "audio/vnd.dra": { "source": "iana", "extensions": ["dra"] },
  "audio/vnd.dts": { "source": "iana", "extensions": ["dts"] },
  "audio/vnd.dts.hd": { "source": "iana", "extensions": ["dtshd"] },
  "audio/vnd.dts.uhd": { "source": "iana" },
  "audio/vnd.dvb.file": { "source": "iana" },
  "audio/vnd.everad.plj": { "source": "iana" },
  "audio/vnd.hns.audio": { "source": "iana" },
  "audio/vnd.lucent.voice": { "source": "iana", "extensions": ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { "source": "iana", "extensions": ["pya"] },
  "audio/vnd.nokia.mobile-xmf": { "source": "iana" },
  "audio/vnd.nortel.vbk": { "source": "iana" },
  "audio/vnd.nuera.ecelp4800": { "source": "iana", "extensions": ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { "source": "iana", "extensions": ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { "source": "iana", "extensions": ["ecelp9600"] },
  "audio/vnd.octel.sbc": { "source": "iana" },
  "audio/vnd.presonus.multitrack": { "source": "iana" },
  "audio/vnd.qcelp": { "source": "iana" },
  "audio/vnd.rhetorex.32kadpcm": { "source": "iana" },
  "audio/vnd.rip": { "source": "iana", "extensions": ["rip"] },
  "audio/vnd.rn-realaudio": { "compressible": false },
  "audio/vnd.sealedmedia.softseal.mpeg": { "source": "iana" },
  "audio/vnd.vmx.cvsd": { "source": "iana" },
  "audio/vnd.wave": { "compressible": false },
  "audio/vorbis": { "source": "iana", "compressible": false },
  "audio/vorbis-config": { "source": "iana" },
  "audio/wav": { "compressible": false, "extensions": ["wav"] },
  "audio/wave": { "compressible": false, "extensions": ["wav"] },
  "audio/webm": { "source": "apache", "compressible": false, "extensions": ["weba"] },
  "audio/x-aac": { "source": "apache", "compressible": false, "extensions": ["aac"] },
  "audio/x-aiff": { "source": "apache", "extensions": ["aif", "aiff", "aifc"] },
  "audio/x-caf": { "source": "apache", "compressible": false, "extensions": ["caf"] },
  "audio/x-flac": { "source": "apache", "extensions": ["flac"] },
  "audio/x-m4a": { "source": "nginx", "extensions": ["m4a"] },
  "audio/x-matroska": { "source": "apache", "extensions": ["mka"] },
  "audio/x-mpegurl": { "source": "apache", "extensions": ["m3u"] },
  "audio/x-ms-wax": { "source": "apache", "extensions": ["wax"] },
  "audio/x-ms-wma": { "source": "apache", "extensions": ["wma"] },
  "audio/x-pn-realaudio": { "source": "apache", "extensions": ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { "source": "apache", "extensions": ["rmp"] },
  "audio/x-realaudio": { "source": "nginx", "extensions": ["ra"] },
  "audio/x-tta": { "source": "apache" },
  "audio/x-wav": { "source": "apache", "extensions": ["wav"] },
  "audio/xm": { "source": "apache", "extensions": ["xm"] },
  "chemical/x-cdx": { "source": "apache", "extensions": ["cdx"] },
  "chemical/x-cif": { "source": "apache", "extensions": ["cif"] },
  "chemical/x-cmdf": { "source": "apache", "extensions": ["cmdf"] },
  "chemical/x-cml": { "source": "apache", "extensions": ["cml"] },
  "chemical/x-csml": { "source": "apache", "extensions": ["csml"] },
  "chemical/x-pdb": { "source": "apache" },
  "chemical/x-xyz": { "source": "apache", "extensions": ["xyz"] },
  "font/collection": { "source": "iana", "extensions": ["ttc"] },
  "font/otf": { "source": "iana", "compressible": true, "extensions": ["otf"] },
  "font/sfnt": { "source": "iana" },
  "font/ttf": { "source": "iana", "compressible": true, "extensions": ["ttf"] },
  "font/woff": { "source": "iana", "extensions": ["woff"] },
  "font/woff2": { "source": "iana", "extensions": ["woff2"] },
  "image/aces": { "source": "iana", "extensions": ["exr"] },
  "image/apng": { "compressible": false, "extensions": ["apng"] },
  "image/avci": { "source": "iana", "extensions": ["avci"] },
  "image/avcs": { "source": "iana", "extensions": ["avcs"] },
  "image/avif": { "source": "iana", "compressible": false, "extensions": ["avif"] },
  "image/bmp": { "source": "iana", "compressible": true, "extensions": ["bmp"] },
  "image/cgm": { "source": "iana", "extensions": ["cgm"] },
  "image/dicom-rle": { "source": "iana", "extensions": ["drle"] },
  "image/emf": { "source": "iana", "extensions": ["emf"] },
  "image/fits": { "source": "iana", "extensions": ["fits"] },
  "image/g3fax": { "source": "iana", "extensions": ["g3"] },
  "image/gif": { "source": "iana", "compressible": false, "extensions": ["gif"] },
  "image/heic": { "source": "iana", "extensions": ["heic"] },
  "image/heic-sequence": { "source": "iana", "extensions": ["heics"] },
  "image/heif": { "source": "iana", "extensions": ["heif"] },
  "image/heif-sequence": { "source": "iana", "extensions": ["heifs"] },
  "image/hej2k": { "source": "iana", "extensions": ["hej2"] },
  "image/hsj2": { "source": "iana", "extensions": ["hsj2"] },
  "image/ief": { "source": "iana", "extensions": ["ief"] },
  "image/jls": { "source": "iana", "extensions": ["jls"] },
  "image/jp2": { "source": "iana", "compressible": false, "extensions": ["jp2", "jpg2"] },
  "image/jpeg": { "source": "iana", "compressible": false, "extensions": ["jpeg", "jpg", "jpe"] },
  "image/jph": { "source": "iana", "extensions": ["jph"] },
  "image/jphc": { "source": "iana", "extensions": ["jhc"] },
  "image/jpm": { "source": "iana", "compressible": false, "extensions": ["jpm"] },
  "image/jpx": { "source": "iana", "compressible": false, "extensions": ["jpx", "jpf"] },
  "image/jxr": { "source": "iana", "extensions": ["jxr"] },
  "image/jxra": { "source": "iana", "extensions": ["jxra"] },
  "image/jxrs": { "source": "iana", "extensions": ["jxrs"] },
  "image/jxs": { "source": "iana", "extensions": ["jxs"] },
  "image/jxsc": { "source": "iana", "extensions": ["jxsc"] },
  "image/jxsi": { "source": "iana", "extensions": ["jxsi"] },
  "image/jxss": { "source": "iana", "extensions": ["jxss"] },
  "image/ktx": { "source": "iana", "extensions": ["ktx"] },
  "image/ktx2": { "source": "iana", "extensions": ["ktx2"] },
  "image/naplps": { "source": "iana" },
  "image/pjpeg": { "compressible": false },
  "image/png": { "source": "iana", "compressible": false, "extensions": ["png"] },
  "image/prs.btif": { "source": "iana", "extensions": ["btif"] },
  "image/prs.pti": { "source": "iana", "extensions": ["pti"] },
  "image/pwg-raster": { "source": "iana" },
  "image/sgi": { "source": "apache", "extensions": ["sgi"] },
  "image/svg+xml": { "source": "iana", "compressible": true, "extensions": ["svg", "svgz"] },
  "image/t38": { "source": "iana", "extensions": ["t38"] },
  "image/tiff": { "source": "iana", "compressible": false, "extensions": ["tif", "tiff"] },
  "image/tiff-fx": { "source": "iana", "extensions": ["tfx"] },
  "image/vnd.adobe.photoshop": { "source": "iana", "compressible": true, "extensions": ["psd"] },
  "image/vnd.airzip.accelerator.azv": { "source": "iana", "extensions": ["azv"] },
  "image/vnd.cns.inf2": { "source": "iana" },
  "image/vnd.dece.graphic": { "source": "iana", "extensions": ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { "source": "iana", "extensions": ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { "source": "iana", "extensions": ["sub"] },
  "image/vnd.dwg": { "source": "iana", "extensions": ["dwg"] },
  "image/vnd.dxf": { "source": "iana", "extensions": ["dxf"] },
  "image/vnd.fastbidsheet": { "source": "iana", "extensions": ["fbs"] },
  "image/vnd.fpx": { "source": "iana", "extensions": ["fpx"] },
  "image/vnd.fst": { "source": "iana", "extensions": ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { "source": "iana", "extensions": ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { "source": "iana", "extensions": ["rlc"] },
  "image/vnd.globalgraphics.pgb": { "source": "iana" },
  "image/vnd.microsoft.icon": { "source": "iana", "compressible": true, "extensions": ["ico"] },
  "image/vnd.mix": { "source": "iana" },
  "image/vnd.mozilla.apng": { "source": "iana" },
  "image/vnd.ms-dds": { "compressible": true, "extensions": ["dds"] },
  "image/vnd.ms-modi": { "source": "iana", "extensions": ["mdi"] },
  "image/vnd.ms-photo": { "source": "apache", "extensions": ["wdp"] },
  "image/vnd.net-fpx": { "source": "iana", "extensions": ["npx"] },
  "image/vnd.pco.b16": { "source": "iana", "extensions": ["b16"] },
  "image/vnd.radiance": { "source": "iana" },
  "image/vnd.sealed.png": { "source": "iana" },
  "image/vnd.sealedmedia.softseal.gif": { "source": "iana" },
  "image/vnd.sealedmedia.softseal.jpg": { "source": "iana" },
  "image/vnd.svf": { "source": "iana" },
  "image/vnd.tencent.tap": { "source": "iana", "extensions": ["tap"] },
  "image/vnd.valve.source.texture": { "source": "iana", "extensions": ["vtf"] },
  "image/vnd.wap.wbmp": { "source": "iana", "extensions": ["wbmp"] },
  "image/vnd.xiff": { "source": "iana", "extensions": ["xif"] },
  "image/vnd.zbrush.pcx": { "source": "iana", "extensions": ["pcx"] },
  "image/webp": { "source": "apache", "extensions": ["webp"] },
  "image/wmf": { "source": "iana", "extensions": ["wmf"] },
  "image/x-3ds": { "source": "apache", "extensions": ["3ds"] },
  "image/x-cmu-raster": { "source": "apache", "extensions": ["ras"] },
  "image/x-cmx": { "source": "apache", "extensions": ["cmx"] },
  "image/x-freehand": { "source": "apache", "extensions": ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { "source": "apache", "compressible": true, "extensions": ["ico"] },
  "image/x-jng": { "source": "nginx", "extensions": ["jng"] },
  "image/x-mrsid-image": { "source": "apache", "extensions": ["sid"] },
  "image/x-ms-bmp": { "source": "nginx", "compressible": true, "extensions": ["bmp"] },
  "image/x-pcx": { "source": "apache", "extensions": ["pcx"] },
  "image/x-pict": { "source": "apache", "extensions": ["pic", "pct"] },
  "image/x-portable-anymap": { "source": "apache", "extensions": ["pnm"] },
  "image/x-portable-bitmap": { "source": "apache", "extensions": ["pbm"] },
  "image/x-portable-graymap": { "source": "apache", "extensions": ["pgm"] },
  "image/x-portable-pixmap": { "source": "apache", "extensions": ["ppm"] },
  "image/x-rgb": { "source": "apache", "extensions": ["rgb"] },
  "image/x-tga": { "source": "apache", "extensions": ["tga"] },
  "image/x-xbitmap": { "source": "apache", "extensions": ["xbm"] },
  "image/x-xcf": { "compressible": false },
  "image/x-xpixmap": { "source": "apache", "extensions": ["xpm"] },
  "image/x-xwindowdump": { "source": "apache", "extensions": ["xwd"] },
  "message/cpim": { "source": "iana" },
  "message/delivery-status": { "source": "iana" },
  "message/disposition-notification": { "source": "iana", "extensions": ["disposition-notification"] },
  "message/external-body": { "source": "iana" },
  "message/feedback-report": { "source": "iana" },
  "message/global": { "source": "iana", "extensions": ["u8msg"] },
  "message/global-delivery-status": { "source": "iana", "extensions": ["u8dsn"] },
  "message/global-disposition-notification": { "source": "iana", "extensions": ["u8mdn"] },
  "message/global-headers": { "source": "iana", "extensions": ["u8hdr"] },
  "message/http": { "source": "iana", "compressible": false },
  "message/imdn+xml": { "source": "iana", "compressible": true },
  "message/news": { "source": "iana" },
  "message/partial": { "source": "iana", "compressible": false },
  "message/rfc822": { "source": "iana", "compressible": true, "extensions": ["eml", "mime"] },
  "message/s-http": { "source": "iana" },
  "message/sip": { "source": "iana" },
  "message/sipfrag": { "source": "iana" },
  "message/tracking-status": { "source": "iana" },
  "message/vnd.si.simp": { "source": "iana" },
  "message/vnd.wfa.wsc": { "source": "iana", "extensions": ["wsc"] },
  "model/3mf": { "source": "iana", "extensions": ["3mf"] },
  "model/e57": { "source": "iana" },
  "model/gltf+json": { "source": "iana", "compressible": true, "extensions": ["gltf"] },
  "model/gltf-binary": { "source": "iana", "compressible": true, "extensions": ["glb"] },
  "model/iges": { "source": "iana", "compressible": false, "extensions": ["igs", "iges"] },
  "model/mesh": { "source": "iana", "compressible": false, "extensions": ["msh", "mesh", "silo"] },
  "model/mtl": { "source": "iana", "extensions": ["mtl"] },
  "model/obj": { "source": "iana", "extensions": ["obj"] },
  "model/step": { "source": "iana" },
  "model/step+xml": { "source": "iana", "compressible": true, "extensions": ["stpx"] },
  "model/step+zip": { "source": "iana", "compressible": false, "extensions": ["stpz"] },
  "model/step-xml+zip": { "source": "iana", "compressible": false, "extensions": ["stpxz"] },
  "model/stl": { "source": "iana", "extensions": ["stl"] },
  "model/vnd.collada+xml": { "source": "iana", "compressible": true, "extensions": ["dae"] },
  "model/vnd.dwf": { "source": "iana", "extensions": ["dwf"] },
  "model/vnd.flatland.3dml": { "source": "iana" },
  "model/vnd.gdl": { "source": "iana", "extensions": ["gdl"] },
  "model/vnd.gs-gdl": { "source": "apache" },
  "model/vnd.gs.gdl": { "source": "iana" },
  "model/vnd.gtw": { "source": "iana", "extensions": ["gtw"] },
  "model/vnd.moml+xml": { "source": "iana", "compressible": true },
  "model/vnd.mts": { "source": "iana", "extensions": ["mts"] },
  "model/vnd.opengex": { "source": "iana", "extensions": ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { "source": "iana", "extensions": ["x_b"] },
  "model/vnd.parasolid.transmit.text": { "source": "iana", "extensions": ["x_t"] },
  "model/vnd.pytha.pyox": { "source": "iana" },
  "model/vnd.rosette.annotated-data-model": { "source": "iana" },
  "model/vnd.sap.vds": { "source": "iana", "extensions": ["vds"] },
  "model/vnd.usdz+zip": { "source": "iana", "compressible": false, "extensions": ["usdz"] },
  "model/vnd.valve.source.compiled-map": { "source": "iana", "extensions": ["bsp"] },
  "model/vnd.vtu": { "source": "iana", "extensions": ["vtu"] },
  "model/vrml": { "source": "iana", "compressible": false, "extensions": ["wrl", "vrml"] },
  "model/x3d+binary": { "source": "apache", "compressible": false, "extensions": ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { "source": "iana", "extensions": ["x3db"] },
  "model/x3d+vrml": { "source": "apache", "compressible": false, "extensions": ["x3dv", "x3dvz"] },
  "model/x3d+xml": { "source": "iana", "compressible": true, "extensions": ["x3d", "x3dz"] },
  "model/x3d-vrml": { "source": "iana", "extensions": ["x3dv"] },
  "multipart/alternative": { "source": "iana", "compressible": false },
  "multipart/appledouble": { "source": "iana" },
  "multipart/byteranges": { "source": "iana" },
  "multipart/digest": { "source": "iana" },
  "multipart/encrypted": { "source": "iana", "compressible": false },
  "multipart/form-data": { "source": "iana", "compressible": false },
  "multipart/header-set": { "source": "iana" },
  "multipart/mixed": { "source": "iana" },
  "multipart/multilingual": { "source": "iana" },
  "multipart/parallel": { "source": "iana" },
  "multipart/related": { "source": "iana", "compressible": false },
  "multipart/report": { "source": "iana" },
  "multipart/signed": { "source": "iana", "compressible": false },
  "multipart/vnd.bint.med-plus": { "source": "iana" },
  "multipart/voice-message": { "source": "iana" },
  "multipart/x-mixed-replace": { "source": "iana" },
  "text/1d-interleaved-parityfec": { "source": "iana" },
  "text/cache-manifest": { "source": "iana", "compressible": true, "extensions": ["appcache", "manifest"] },
  "text/calendar": { "source": "iana", "extensions": ["ics", "ifb"] },
  "text/calender": { "compressible": true },
  "text/cmd": { "compressible": true },
  "text/coffeescript": { "extensions": ["coffee", "litcoffee"] },
  "text/cql": { "source": "iana" },
  "text/cql-expression": { "source": "iana" },
  "text/cql-identifier": { "source": "iana" },
  "text/css": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["css"] },
  "text/csv": { "source": "iana", "compressible": true, "extensions": ["csv"] },
  "text/csv-schema": { "source": "iana" },
  "text/directory": { "source": "iana" },
  "text/dns": { "source": "iana" },
  "text/ecmascript": { "source": "iana" },
  "text/encaprtp": { "source": "iana" },
  "text/enriched": { "source": "iana" },
  "text/fhirpath": { "source": "iana" },
  "text/flexfec": { "source": "iana" },
  "text/fwdred": { "source": "iana" },
  "text/gff3": { "source": "iana" },
  "text/grammar-ref-list": { "source": "iana" },
  "text/html": { "source": "iana", "compressible": true, "extensions": ["html", "htm", "shtml"] },
  "text/jade": { "extensions": ["jade"] },
  "text/javascript": { "source": "iana", "compressible": true },
  "text/jcr-cnd": { "source": "iana" },
  "text/jsx": { "compressible": true, "extensions": ["jsx"] },
  "text/less": { "compressible": true, "extensions": ["less"] },
  "text/markdown": { "source": "iana", "compressible": true, "extensions": ["markdown", "md"] },
  "text/mathml": { "source": "nginx", "extensions": ["mml"] },
  "text/mdx": { "compressible": true, "extensions": ["mdx"] },
  "text/mizar": { "source": "iana" },
  "text/n3": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["n3"] },
  "text/parameters": { "source": "iana", "charset": "UTF-8" },
  "text/parityfec": { "source": "iana" },
  "text/plain": { "source": "iana", "compressible": true, "extensions": ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/provenance-notation": { "source": "iana", "charset": "UTF-8" },
  "text/prs.fallenstein.rst": { "source": "iana" },
  "text/prs.lines.tag": { "source": "iana", "extensions": ["dsc"] },
  "text/prs.prop.logic": { "source": "iana" },
  "text/raptorfec": { "source": "iana" },
  "text/red": { "source": "iana" },
  "text/rfc822-headers": { "source": "iana" },
  "text/richtext": { "source": "iana", "compressible": true, "extensions": ["rtx"] },
  "text/rtf": { "source": "iana", "compressible": true, "extensions": ["rtf"] },
  "text/rtp-enc-aescm128": { "source": "iana" },
  "text/rtploopback": { "source": "iana" },
  "text/rtx": { "source": "iana" },
  "text/sgml": { "source": "iana", "extensions": ["sgml", "sgm"] },
  "text/shaclc": { "source": "iana" },
  "text/shex": { "source": "iana", "extensions": ["shex"] },
  "text/slim": { "extensions": ["slim", "slm"] },
  "text/spdx": { "source": "iana", "extensions": ["spdx"] },
  "text/strings": { "source": "iana" },
  "text/stylus": { "extensions": ["stylus", "styl"] },
  "text/t140": { "source": "iana" },
  "text/tab-separated-values": { "source": "iana", "compressible": true, "extensions": ["tsv"] },
  "text/troff": { "source": "iana", "extensions": ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { "source": "iana", "charset": "UTF-8", "extensions": ["ttl"] },
  "text/ulpfec": { "source": "iana" },
  "text/uri-list": { "source": "iana", "compressible": true, "extensions": ["uri", "uris", "urls"] },
  "text/vcard": { "source": "iana", "compressible": true, "extensions": ["vcard"] },
  "text/vnd.a": { "source": "iana" },
  "text/vnd.abc": { "source": "iana" },
  "text/vnd.ascii-art": { "source": "iana" },
  "text/vnd.curl": { "source": "iana", "extensions": ["curl"] },
  "text/vnd.curl.dcurl": { "source": "apache", "extensions": ["dcurl"] },
  "text/vnd.curl.mcurl": { "source": "apache", "extensions": ["mcurl"] },
  "text/vnd.curl.scurl": { "source": "apache", "extensions": ["scurl"] },
  "text/vnd.debian.copyright": { "source": "iana", "charset": "UTF-8" },
  "text/vnd.dmclientscript": { "source": "iana" },
  "text/vnd.dvb.subtitle": { "source": "iana", "extensions": ["sub"] },
  "text/vnd.esmertec.theme-descriptor": { "source": "iana", "charset": "UTF-8" },
  "text/vnd.familysearch.gedcom": { "source": "iana", "extensions": ["ged"] },
  "text/vnd.ficlab.flt": { "source": "iana" },
  "text/vnd.fly": { "source": "iana", "extensions": ["fly"] },
  "text/vnd.fmi.flexstor": { "source": "iana", "extensions": ["flx"] },
  "text/vnd.gml": { "source": "iana" },
  "text/vnd.graphviz": { "source": "iana", "extensions": ["gv"] },
  "text/vnd.hans": { "source": "iana" },
  "text/vnd.hgl": { "source": "iana" },
  "text/vnd.in3d.3dml": { "source": "iana", "extensions": ["3dml"] },
  "text/vnd.in3d.spot": { "source": "iana", "extensions": ["spot"] },
  "text/vnd.iptc.newsml": { "source": "iana" },
  "text/vnd.iptc.nitf": { "source": "iana" },
  "text/vnd.latex-z": { "source": "iana" },
  "text/vnd.motorola.reflex": { "source": "iana" },
  "text/vnd.ms-mediapackage": { "source": "iana" },
  "text/vnd.net2phone.commcenter.command": { "source": "iana" },
  "text/vnd.radisys.msml-basic-layout": { "source": "iana" },
  "text/vnd.senx.warpscript": { "source": "iana" },
  "text/vnd.si.uricatalogue": { "source": "iana" },
  "text/vnd.sosi": { "source": "iana" },
  "text/vnd.sun.j2me.app-descriptor": { "source": "iana", "charset": "UTF-8", "extensions": ["jad"] },
  "text/vnd.trolltech.linguist": { "source": "iana", "charset": "UTF-8" },
  "text/vnd.wap.si": { "source": "iana" },
  "text/vnd.wap.sl": { "source": "iana" },
  "text/vnd.wap.wml": { "source": "iana", "extensions": ["wml"] },
  "text/vnd.wap.wmlscript": { "source": "iana", "extensions": ["wmls"] },
  "text/vtt": { "source": "iana", "charset": "UTF-8", "compressible": true, "extensions": ["vtt"] },
  "text/x-asm": { "source": "apache", "extensions": ["s", "asm"] },
  "text/x-c": { "source": "apache", "extensions": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { "source": "nginx", "extensions": ["htc"] },
  "text/x-fortran": { "source": "apache", "extensions": ["f", "for", "f77", "f90"] },
  "text/x-gwt-rpc": { "compressible": true },
  "text/x-handlebars-template": { "extensions": ["hbs"] },
  "text/x-java-source": { "source": "apache", "extensions": ["java"] },
  "text/x-jquery-tmpl": { "compressible": true },
  "text/x-lua": { "extensions": ["lua"] },
  "text/x-markdown": { "compressible": true, "extensions": ["mkd"] },
  "text/x-nfo": { "source": "apache", "extensions": ["nfo"] },
  "text/x-opml": { "source": "apache", "extensions": ["opml"] },
  "text/x-org": { "compressible": true, "extensions": ["org"] },
  "text/x-pascal": { "source": "apache", "extensions": ["p", "pas"] },
  "text/x-processing": { "compressible": true, "extensions": ["pde"] },
  "text/x-sass": { "extensions": ["sass"] },
  "text/x-scss": { "extensions": ["scss"] },
  "text/x-setext": { "source": "apache", "extensions": ["etx"] },
  "text/x-sfv": { "source": "apache", "extensions": ["sfv"] },
  "text/x-suse-ymp": { "compressible": true, "extensions": ["ymp"] },
  "text/x-uuencode": { "source": "apache", "extensions": ["uu"] },
  "text/x-vcalendar": { "source": "apache", "extensions": ["vcs"] },
  "text/x-vcard": { "source": "apache", "extensions": ["vcf"] },
  "text/xml": { "source": "iana", "compressible": true, "extensions": ["xml"] },
  "text/xml-external-parsed-entity": { "source": "iana" },
  "text/yaml": { "compressible": true, "extensions": ["yaml", "yml"] },
  "video/1d-interleaved-parityfec": { "source": "iana" },
  "video/3gpp": { "source": "iana", "extensions": ["3gp", "3gpp"] },
  "video/3gpp-tt": { "source": "iana" },
  "video/3gpp2": { "source": "iana", "extensions": ["3g2"] },
  "video/av1": { "source": "iana" },
  "video/bmpeg": { "source": "iana" },
  "video/bt656": { "source": "iana" },
  "video/celb": { "source": "iana" },
  "video/dv": { "source": "iana" },
  "video/encaprtp": { "source": "iana" },
  "video/ffv1": { "source": "iana" },
  "video/flexfec": { "source": "iana" },
  "video/h261": { "source": "iana", "extensions": ["h261"] },
  "video/h263": { "source": "iana", "extensions": ["h263"] },
  "video/h263-1998": { "source": "iana" },
  "video/h263-2000": { "source": "iana" },
  "video/h264": { "source": "iana", "extensions": ["h264"] },
  "video/h264-rcdo": { "source": "iana" },
  "video/h264-svc": { "source": "iana" },
  "video/h265": { "source": "iana" },
  "video/iso.segment": { "source": "iana", "extensions": ["m4s"] },
  "video/jpeg": { "source": "iana", "extensions": ["jpgv"] },
  "video/jpeg2000": { "source": "iana" },
  "video/jpm": { "source": "apache", "extensions": ["jpm", "jpgm"] },
  "video/jxsv": { "source": "iana" },
  "video/mj2": { "source": "iana", "extensions": ["mj2", "mjp2"] },
  "video/mp1s": { "source": "iana" },
  "video/mp2p": { "source": "iana" },
  "video/mp2t": { "source": "iana", "extensions": ["ts"] },
  "video/mp4": { "source": "iana", "compressible": false, "extensions": ["mp4", "mp4v", "mpg4"] },
  "video/mp4v-es": { "source": "iana" },
  "video/mpeg": { "source": "iana", "compressible": false, "extensions": ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/mpeg4-generic": { "source": "iana" },
  "video/mpv": { "source": "iana" },
  "video/nv": { "source": "iana" },
  "video/ogg": { "source": "iana", "compressible": false, "extensions": ["ogv"] },
  "video/parityfec": { "source": "iana" },
  "video/pointer": { "source": "iana" },
  "video/quicktime": { "source": "iana", "compressible": false, "extensions": ["qt", "mov"] },
  "video/raptorfec": { "source": "iana" },
  "video/raw": { "source": "iana" },
  "video/rtp-enc-aescm128": { "source": "iana" },
  "video/rtploopback": { "source": "iana" },
  "video/rtx": { "source": "iana" },
  "video/scip": { "source": "iana" },
  "video/smpte291": { "source": "iana" },
  "video/smpte292m": { "source": "iana" },
  "video/ulpfec": { "source": "iana" },
  "video/vc1": { "source": "iana" },
  "video/vc2": { "source": "iana" },
  "video/vnd.cctv": { "source": "iana" },
  "video/vnd.dece.hd": { "source": "iana", "extensions": ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { "source": "iana", "extensions": ["uvm", "uvvm"] },
  "video/vnd.dece.mp4": { "source": "iana" },
  "video/vnd.dece.pd": { "source": "iana", "extensions": ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { "source": "iana", "extensions": ["uvs", "uvvs"] },
  "video/vnd.dece.video": { "source": "iana", "extensions": ["uvv", "uvvv"] },
  "video/vnd.directv.mpeg": { "source": "iana" },
  "video/vnd.directv.mpeg-tts": { "source": "iana" },
  "video/vnd.dlna.mpeg-tts": { "source": "iana" },
  "video/vnd.dvb.file": { "source": "iana", "extensions": ["dvb"] },
  "video/vnd.fvt": { "source": "iana", "extensions": ["fvt"] },
  "video/vnd.hns.video": { "source": "iana" },
  "video/vnd.iptvforum.1dparityfec-1010": { "source": "iana" },
  "video/vnd.iptvforum.1dparityfec-2005": { "source": "iana" },
  "video/vnd.iptvforum.2dparityfec-1010": { "source": "iana" },
  "video/vnd.iptvforum.2dparityfec-2005": { "source": "iana" },
  "video/vnd.iptvforum.ttsavc": { "source": "iana" },
  "video/vnd.iptvforum.ttsmpeg2": { "source": "iana" },
  "video/vnd.motorola.video": { "source": "iana" },
  "video/vnd.motorola.videop": { "source": "iana" },
  "video/vnd.mpegurl": { "source": "iana", "extensions": ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { "source": "iana", "extensions": ["pyv"] },
  "video/vnd.nokia.interleaved-multimedia": { "source": "iana" },
  "video/vnd.nokia.mp4vr": { "source": "iana" },
  "video/vnd.nokia.videovoip": { "source": "iana" },
  "video/vnd.objectvideo": { "source": "iana" },
  "video/vnd.radgamettools.bink": { "source": "iana" },
  "video/vnd.radgamettools.smacker": { "source": "iana" },
  "video/vnd.sealed.mpeg1": { "source": "iana" },
  "video/vnd.sealed.mpeg4": { "source": "iana" },
  "video/vnd.sealed.swf": { "source": "iana" },
  "video/vnd.sealedmedia.softseal.mov": { "source": "iana" },
  "video/vnd.uvvu.mp4": { "source": "iana", "extensions": ["uvu", "uvvu"] },
  "video/vnd.vivo": { "source": "iana", "extensions": ["viv"] },
  "video/vnd.youtube.yt": { "source": "iana" },
  "video/vp8": { "source": "iana" },
  "video/vp9": { "source": "iana" },
  "video/webm": { "source": "apache", "compressible": false, "extensions": ["webm"] },
  "video/x-f4v": { "source": "apache", "extensions": ["f4v"] },
  "video/x-fli": { "source": "apache", "extensions": ["fli"] },
  "video/x-flv": { "source": "apache", "compressible": false, "extensions": ["flv"] },
  "video/x-m4v": { "source": "apache", "extensions": ["m4v"] },
  "video/x-matroska": { "source": "apache", "compressible": false, "extensions": ["mkv", "mk3d", "mks"] },
  "video/x-mng": { "source": "apache", "extensions": ["mng"] },
  "video/x-ms-asf": { "source": "apache", "extensions": ["asf", "asx"] },
  "video/x-ms-vob": { "source": "apache", "extensions": ["vob"] },
  "video/x-ms-wm": { "source": "apache", "extensions": ["wm"] },
  "video/x-ms-wmv": { "source": "apache", "compressible": false, "extensions": ["wmv"] },
  "video/x-ms-wmx": { "source": "apache", "extensions": ["wmx"] },
  "video/x-ms-wvx": { "source": "apache", "extensions": ["wvx"] },
  "video/x-msvideo": { "source": "apache", "extensions": ["avi"] },
  "video/x-sgi-movie": { "source": "apache", "extensions": ["movie"] },
  "video/x-smv": { "source": "apache", "extensions": ["smv"] },
  "x-conference/x-cooltalk": { "source": "apache", "extensions": ["ice"] },
  "x-shader/x-fragment": { "compressible": true },
  "x-shader/x-vertex": { "compressible": true }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var mimeDb;
var hasRequiredMimeDb;
function requireMimeDb() {
  if (hasRequiredMimeDb) return mimeDb;
  hasRequiredMimeDb = 1;
  mimeDb = require$$0;
  return mimeDb;
}
var path = { exports: {} };
var util$2 = {};
var isBufferBrowser;
var hasRequiredIsBufferBrowser;
function requireIsBufferBrowser() {
  if (hasRequiredIsBufferBrowser) return isBufferBrowser;
  hasRequiredIsBufferBrowser = 1;
  isBufferBrowser = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
  };
  return isBufferBrowser;
}
var inherits_browser = { exports: {} };
var hasRequiredInherits_browser;
function requireInherits_browser() {
  if (hasRequiredInherits_browser) return inherits_browser.exports;
  hasRequiredInherits_browser = 1;
  if (typeof Object.create === "function") {
    inherits_browser.exports = function inherits2(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits_browser.exports = function inherits2(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  return inherits_browser.exports;
}
var hasRequiredUtil$2;
function requireUtil$2() {
  if (hasRequiredUtil$2) return util$2;
  hasRequiredUtil$2 = 1;
  (function(exports$1) {
    var formatRegExp2 = /%[sdj%]/g;
    exports$1.format = function(f) {
      if (!isString(f)) {
        var objects2 = [];
        for (var i = 0; i < arguments.length; i++) {
          objects2.push(inspect(arguments[i]));
        }
        return objects2.join(" ");
      }
      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp2, function(x2) {
        if (x2 === "%%") return "%";
        if (i >= len) return x2;
        switch (x2) {
          case "%s":
            return String(args[i++]);
          case "%d":
            return Number(args[i++]);
          case "%j":
            try {
              return JSON.stringify(args[i++]);
            } catch (_2) {
              return "[Circular]";
            }
          default:
            return x2;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject2(x)) {
          str += " " + x;
        } else {
          str += " " + inspect(x);
        }
      }
      return str;
    };
    exports$1.deprecate = function(fn, msg) {
      if (isUndefined(commonjsGlobal.process)) {
        return function() {
          return exports$1.deprecate(fn, msg).apply(this, arguments);
        };
      }
      if (process.noDeprecation === true) {
        return fn;
      }
      var warned2 = false;
      function deprecated2() {
        if (!warned2) {
          if (process.throwDeprecation) {
            throw new Error(msg);
          } else if (process.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned2 = true;
        }
        return fn.apply(this, arguments);
      }
      return deprecated2;
    };
    var debugs = {};
    var debugEnviron;
    exports$1.debuglog = function(set2) {
      if (isUndefined(debugEnviron))
        debugEnviron = process.env.NODE_DEBUG || "";
      set2 = set2.toUpperCase();
      if (!debugs[set2]) {
        if (new RegExp("\\b" + set2 + "\\b", "i").test(debugEnviron)) {
          var pid = process.pid;
          debugs[set2] = function() {
            var msg = exports$1.format.apply(exports$1, arguments);
            console.error("%s %d: %s", set2, pid, msg);
          };
        } else {
          debugs[set2] = function() {
          };
        }
      }
      return debugs[set2];
    };
    function inspect(obj, opts) {
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      if (arguments.length >= 3) ctx.depth = arguments[2];
      if (arguments.length >= 4) ctx.colors = arguments[3];
      if (isBoolean(opts)) {
        ctx.showHidden = opts;
      } else if (opts) {
        exports$1._extend(ctx, opts);
      }
      if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
      if (isUndefined(ctx.depth)) ctx.depth = 2;
      if (isUndefined(ctx.colors)) ctx.colors = false;
      if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
      if (ctx.colors) ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }
    exports$1.inspect = inspect;
    inspect.colors = {
      "bold": [1, 22],
      "italic": [3, 23],
      "underline": [4, 24],
      "inverse": [7, 27],
      "white": [37, 39],
      "grey": [90, 39],
      "black": [30, 39],
      "blue": [34, 39],
      "cyan": [36, 39],
      "green": [32, 39],
      "magenta": [35, 39],
      "red": [31, 39],
      "yellow": [33, 39]
    };
    inspect.styles = {
      "special": "cyan",
      "number": "yellow",
      "boolean": "yellow",
      "undefined": "grey",
      "null": "bold",
      "string": "green",
      "date": "magenta",
      // "name": intentionally not styling
      "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
      var style2 = inspect.styles[styleType];
      if (style2) {
        return "\x1B[" + inspect.colors[style2][0] + "m" + str + "\x1B[" + inspect.colors[style2][1] + "m";
      } else {
        return str;
      }
    }
    function stylizeNoColor(str, styleType) {
      return str;
    }
    function arrayToHash(array4) {
      var hash2 = {};
      array4.forEach(function(val, idx) {
        hash2[val] = true;
      });
      return hash2;
    }
    function formatValue(ctx, value, recurseTimes) {
      if (ctx.customInspect && value && isFunction2(value.inspect) && // Filter out the util module, it's inspect function is special
      value.inspect !== exports$1.inspect && // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }
      var keys2 = Object.keys(value);
      var visibleKeys = arrayToHash(keys2);
      if (ctx.showHidden) {
        keys2 = Object.getOwnPropertyNames(value);
      }
      if (isError(value) && (keys2.indexOf("message") >= 0 || keys2.indexOf("description") >= 0)) {
        return formatError(value);
      }
      if (keys2.length === 0) {
        if (isFunction2(value)) {
          var name = value.name ? ": " + value.name : "";
          return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        }
        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), "date");
        }
        if (isError(value)) {
          return formatError(value);
        }
      }
      var base = "", array4 = false, braces = ["{", "}"];
      if (isArray(value)) {
        array4 = true;
        braces = ["[", "]"];
      }
      if (isFunction2(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
      }
      if (isRegExp(value)) {
        base = " " + RegExp.prototype.toString.call(value);
      }
      if (isDate(value)) {
        base = " " + Date.prototype.toUTCString.call(value);
      }
      if (isError(value)) {
        base = " " + formatError(value);
      }
      if (keys2.length === 0 && (!array4 || value.length == 0)) {
        return braces[0] + base + braces[1];
      }
      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        } else {
          return ctx.stylize("[Object]", "special");
        }
      }
      ctx.seen.push(value);
      var output;
      if (array4) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys2);
      } else {
        output = keys2.map(function(key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array4);
        });
      }
      ctx.seen.pop();
      return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
      if (isUndefined(value))
        return ctx.stylize("undefined", "undefined");
      if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
      }
      if (isNumber(value))
        return ctx.stylize("" + value, "number");
      if (isBoolean(value))
        return ctx.stylize("" + value, "boolean");
      if (isNull(value))
        return ctx.stylize("null", "null");
    }
    function formatError(value) {
      return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys2) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(
            ctx,
            value,
            recurseTimes,
            visibleKeys,
            String(i),
            true
          ));
        } else {
          output.push("");
        }
      }
      keys2.forEach(function(key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(
            ctx,
            value,
            recurseTimes,
            visibleKeys,
            key,
            true
          ));
        }
      });
      return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array4) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize("[Getter/Setter]", "special");
        } else {
          str = ctx.stylize("[Getter]", "special");
        }
      } else {
        if (desc.set) {
          str = ctx.stylize("[Setter]", "special");
        }
      }
      if (!hasOwnProperty(visibleKeys, key)) {
        name = "[" + key + "]";
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf("\n") > -1) {
            if (array4) {
              str = str.split("\n").map(function(line2) {
                return "  " + line2;
              }).join("\n").substr(2);
            } else {
              str = "\n" + str.split("\n").map(function(line2) {
                return "   " + line2;
              }).join("\n");
            }
          }
        } else {
          str = ctx.stylize("[Circular]", "special");
        }
      }
      if (isUndefined(name)) {
        if (array4 && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, "name");
        } else {
          name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, "string");
        }
      }
      return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
      var length2 = output.reduce(function(prev4, cur) {
        if (cur.indexOf("\n") >= 0) ;
        return prev4 + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      if (length2 > 60) {
        return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
      }
      return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    }
    function isArray(ar) {
      return Array.isArray(ar);
    }
    exports$1.isArray = isArray;
    function isBoolean(arg) {
      return typeof arg === "boolean";
    }
    exports$1.isBoolean = isBoolean;
    function isNull(arg) {
      return arg === null;
    }
    exports$1.isNull = isNull;
    function isNullOrUndefined(arg) {
      return arg == null;
    }
    exports$1.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
      return typeof arg === "number";
    }
    exports$1.isNumber = isNumber;
    function isString(arg) {
      return typeof arg === "string";
    }
    exports$1.isString = isString;
    function isSymbol(arg) {
      return typeof arg === "symbol";
    }
    exports$1.isSymbol = isSymbol;
    function isUndefined(arg) {
      return arg === void 0;
    }
    exports$1.isUndefined = isUndefined;
    function isRegExp(re2) {
      return isObject2(re2) && objectToString(re2) === "[object RegExp]";
    }
    exports$1.isRegExp = isRegExp;
    function isObject2(arg) {
      return typeof arg === "object" && arg !== null;
    }
    exports$1.isObject = isObject2;
    function isDate(d) {
      return isObject2(d) && objectToString(d) === "[object Date]";
    }
    exports$1.isDate = isDate;
    function isError(e) {
      return isObject2(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
    }
    exports$1.isError = isError;
    function isFunction2(arg) {
      return typeof arg === "function";
    }
    exports$1.isFunction = isFunction2;
    function isPrimitive(arg) {
      return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
      typeof arg === "undefined";
    }
    exports$1.isPrimitive = isPrimitive;
    exports$1.isBuffer = requireIsBufferBrowser();
    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }
    function pad(n) {
      return n < 10 ? "0" + n.toString(10) : n.toString(10);
    }
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function timestamp() {
      var d = /* @__PURE__ */ new Date();
      var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
      ].join(":");
      return [d.getDate(), months[d.getMonth()], time].join(" ");
    }
    exports$1.log = function() {
      console.log("%s - %s", timestamp(), exports$1.format.apply(exports$1, arguments));
    };
    exports$1.inherits = requireInherits_browser();
    exports$1._extend = function(origin2, add3) {
      if (!add3 || !isObject2(add3)) return origin2;
      var keys2 = Object.keys(add3);
      var i = keys2.length;
      while (i--) {
        origin2[keys2[i]] = add3[keys2[i]];
      }
      return origin2;
    };
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
  })(util$2);
  return util$2;
}
var hasRequiredPath;
function requirePath() {
  if (hasRequiredPath) return path.exports;
  hasRequiredPath = 1;
  var isWindows = process.platform === "win32";
  var util2 = requireUtil$2();
  function normalizeArray(parts, allowAboveRoot) {
    var res = [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p || p === ".")
        continue;
      if (p === "..") {
        if (res.length && res[res.length - 1] !== "..") {
          res.pop();
        } else if (allowAboveRoot) {
          res.push("..");
        }
      } else {
        res.push(p);
      }
    }
    return res;
  }
  function trimArray(arr) {
    var lastIndex = arr.length - 1;
    var start2 = 0;
    for (; start2 <= lastIndex; start2++) {
      if (arr[start2])
        break;
    }
    var end = lastIndex;
    for (; end >= 0; end--) {
      if (arr[end])
        break;
    }
    if (start2 === 0 && end === lastIndex)
      return arr;
    if (start2 > end)
      return [];
    return arr.slice(start2, end + 1);
  }
  var splitDeviceRe = /^([a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?([\\\/])?([\s\S]*?)$/;
  var splitTailRe = /^([\s\S]*?)((?:\.{1,2}|[^\\\/]+?|)(\.[^.\/\\]*|))(?:[\\\/]*)$/;
  var win32 = {};
  function win32SplitPath(filename) {
    var result = splitDeviceRe.exec(filename), device = (result[1] || "") + (result[2] || ""), tail = result[3] || "";
    var result2 = splitTailRe.exec(tail), dir = result2[1], basename = result2[2], ext = result2[3];
    return [device, dir, basename, ext];
  }
  function win32StatPath(path2) {
    var result = splitDeviceRe.exec(path2), device = result[1] || "", isUnc = !!device && device[1] !== ":";
    return {
      device,
      isUnc,
      isAbsolute: isUnc || !!result[2],
      // UNC paths are always absolute
      tail: result[3]
    };
  }
  function normalizeUNCRoot(device) {
    return "\\\\" + device.replace(/^[\\\/]+/, "").replace(/[\\\/]+/g, "\\");
  }
  win32.resolve = function() {
    var resolvedDevice = "", resolvedTail = "", resolvedAbsolute = false;
    for (var i = arguments.length - 1; i >= -1; i--) {
      var path2;
      if (i >= 0) {
        path2 = arguments[i];
      } else if (!resolvedDevice) {
        path2 = process.cwd();
      } else {
        path2 = process.env["=" + resolvedDevice];
        if (!path2 || path2.substr(0, 3).toLowerCase() !== resolvedDevice.toLowerCase() + "\\") {
          path2 = resolvedDevice + "\\";
        }
      }
      if (!util2.isString(path2)) {
        throw new TypeError("Arguments to path.resolve must be strings");
      } else if (!path2) {
        continue;
      }
      var result = win32StatPath(path2), device = result.device, isUnc = result.isUnc, isAbsolute = result.isAbsolute, tail = result.tail;
      if (device && resolvedDevice && device.toLowerCase() !== resolvedDevice.toLowerCase()) {
        continue;
      }
      if (!resolvedDevice) {
        resolvedDevice = device;
      }
      if (!resolvedAbsolute) {
        resolvedTail = tail + "\\" + resolvedTail;
        resolvedAbsolute = isAbsolute;
      }
      if (resolvedDevice && resolvedAbsolute) {
        break;
      }
    }
    if (isUnc) {
      resolvedDevice = normalizeUNCRoot(resolvedDevice);
    }
    resolvedTail = normalizeArray(
      resolvedTail.split(/[\\\/]+/),
      !resolvedAbsolute
    ).join("\\");
    return resolvedDevice + (resolvedAbsolute ? "\\" : "") + resolvedTail || ".";
  };
  win32.normalize = function(path2) {
    var result = win32StatPath(path2), device = result.device, isUnc = result.isUnc, isAbsolute = result.isAbsolute, tail = result.tail, trailingSlash = /[\\\/]$/.test(tail);
    tail = normalizeArray(tail.split(/[\\\/]+/), !isAbsolute).join("\\");
    if (!tail && !isAbsolute) {
      tail = ".";
    }
    if (tail && trailingSlash) {
      tail += "\\";
    }
    if (isUnc) {
      device = normalizeUNCRoot(device);
    }
    return device + (isAbsolute ? "\\" : "") + tail;
  };
  win32.isAbsolute = function(path2) {
    return win32StatPath(path2).isAbsolute;
  };
  win32.join = function() {
    var paths = [];
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!util2.isString(arg)) {
        throw new TypeError("Arguments to path.join must be strings");
      }
      if (arg) {
        paths.push(arg);
      }
    }
    var joined = paths.join("\\");
    if (!/^[\\\/]{2}[^\\\/]/.test(paths[0])) {
      joined = joined.replace(/^[\\\/]{2,}/, "\\");
    }
    return win32.normalize(joined);
  };
  win32.relative = function(from2, to) {
    from2 = win32.resolve(from2);
    to = win32.resolve(to);
    var lowerFrom = from2.toLowerCase();
    var lowerTo = to.toLowerCase();
    var toParts = trimArray(to.split("\\"));
    var lowerFromParts = trimArray(lowerFrom.split("\\"));
    var lowerToParts = trimArray(lowerTo.split("\\"));
    var length2 = Math.min(lowerFromParts.length, lowerToParts.length);
    var samePartsLength = length2;
    for (var i = 0; i < length2; i++) {
      if (lowerFromParts[i] !== lowerToParts[i]) {
        samePartsLength = i;
        break;
      }
    }
    if (samePartsLength == 0) {
      return to;
    }
    var outputParts = [];
    for (var i = samePartsLength; i < lowerFromParts.length; i++) {
      outputParts.push("..");
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("\\");
  };
  win32._makeLong = function(path2) {
    if (!util2.isString(path2))
      return path2;
    if (!path2) {
      return "";
    }
    var resolvedPath = win32.resolve(path2);
    if (/^[a-zA-Z]\:\\/.test(resolvedPath)) {
      return "\\\\?\\" + resolvedPath;
    } else if (/^\\\\[^?.]/.test(resolvedPath)) {
      return "\\\\?\\UNC\\" + resolvedPath.substring(2);
    }
    return path2;
  };
  win32.dirname = function(path2) {
    var result = win32SplitPath(path2), root = result[0], dir = result[1];
    if (!root && !dir) {
      return ".";
    }
    if (dir) {
      dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
  };
  win32.basename = function(path2, ext) {
    var f = win32SplitPath(path2)[2];
    if (ext && f.substr(-1 * ext.length) === ext) {
      f = f.substr(0, f.length - ext.length);
    }
    return f;
  };
  win32.extname = function(path2) {
    return win32SplitPath(path2)[3];
  };
  win32.format = function(pathObject) {
    if (!util2.isObject(pathObject)) {
      throw new TypeError(
        "Parameter 'pathObject' must be an object, not " + typeof pathObject
      );
    }
    var root = pathObject.root || "";
    if (!util2.isString(root)) {
      throw new TypeError(
        "'pathObject.root' must be a string or undefined, not " + typeof pathObject.root
      );
    }
    var dir = pathObject.dir;
    var base = pathObject.base || "";
    if (!dir) {
      return base;
    }
    if (dir[dir.length - 1] === win32.sep) {
      return dir + base;
    }
    return dir + win32.sep + base;
  };
  win32.parse = function(pathString) {
    if (!util2.isString(pathString)) {
      throw new TypeError(
        "Parameter 'pathString' must be a string, not " + typeof pathString
      );
    }
    var allParts = win32SplitPath(pathString);
    if (!allParts || allParts.length !== 4) {
      throw new TypeError("Invalid path '" + pathString + "'");
    }
    return {
      root: allParts[0],
      dir: allParts[0] + allParts[1].slice(0, -1),
      base: allParts[2],
      ext: allParts[3],
      name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
    };
  };
  win32.sep = "\\";
  win32.delimiter = ";";
  var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
  var posix = {};
  function posixSplitPath(filename) {
    return splitPathRe.exec(filename).slice(1);
  }
  posix.resolve = function() {
    var resolvedPath = "", resolvedAbsolute = false;
    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path2 = i >= 0 ? arguments[i] : process.cwd();
      if (!util2.isString(path2)) {
        throw new TypeError("Arguments to path.resolve must be strings");
      } else if (!path2) {
        continue;
      }
      resolvedPath = path2 + "/" + resolvedPath;
      resolvedAbsolute = path2[0] === "/";
    }
    resolvedPath = normalizeArray(
      resolvedPath.split("/"),
      !resolvedAbsolute
    ).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
  };
  posix.normalize = function(path2) {
    var isAbsolute = posix.isAbsolute(path2), trailingSlash = path2 && path2[path2.length - 1] === "/";
    path2 = normalizeArray(path2.split("/"), !isAbsolute).join("/");
    if (!path2 && !isAbsolute) {
      path2 = ".";
    }
    if (path2 && trailingSlash) {
      path2 += "/";
    }
    return (isAbsolute ? "/" : "") + path2;
  };
  posix.isAbsolute = function(path2) {
    return path2.charAt(0) === "/";
  };
  posix.join = function() {
    var path2 = "";
    for (var i = 0; i < arguments.length; i++) {
      var segment = arguments[i];
      if (!util2.isString(segment)) {
        throw new TypeError("Arguments to path.join must be strings");
      }
      if (segment) {
        if (!path2) {
          path2 += segment;
        } else {
          path2 += "/" + segment;
        }
      }
    }
    return posix.normalize(path2);
  };
  posix.relative = function(from2, to) {
    from2 = posix.resolve(from2).substr(1);
    to = posix.resolve(to).substr(1);
    var fromParts = trimArray(from2.split("/"));
    var toParts = trimArray(to.split("/"));
    var length2 = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length2;
    for (var i = 0; i < length2; i++) {
      if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
      }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
      outputParts.push("..");
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
  };
  posix._makeLong = function(path2) {
    return path2;
  };
  posix.dirname = function(path2) {
    var result = posixSplitPath(path2), root = result[0], dir = result[1];
    if (!root && !dir) {
      return ".";
    }
    if (dir) {
      dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
  };
  posix.basename = function(path2, ext) {
    var f = posixSplitPath(path2)[2];
    if (ext && f.substr(-1 * ext.length) === ext) {
      f = f.substr(0, f.length - ext.length);
    }
    return f;
  };
  posix.extname = function(path2) {
    return posixSplitPath(path2)[3];
  };
  posix.format = function(pathObject) {
    if (!util2.isObject(pathObject)) {
      throw new TypeError(
        "Parameter 'pathObject' must be an object, not " + typeof pathObject
      );
    }
    var root = pathObject.root || "";
    if (!util2.isString(root)) {
      throw new TypeError(
        "'pathObject.root' must be a string or undefined, not " + typeof pathObject.root
      );
    }
    var dir = pathObject.dir ? pathObject.dir + posix.sep : "";
    var base = pathObject.base || "";
    return dir + base;
  };
  posix.parse = function(pathString) {
    if (!util2.isString(pathString)) {
      throw new TypeError(
        "Parameter 'pathString' must be a string, not " + typeof pathString
      );
    }
    var allParts = posixSplitPath(pathString);
    if (!allParts || allParts.length !== 4) {
      throw new TypeError("Invalid path '" + pathString + "'");
    }
    allParts[1] = allParts[1] || "";
    allParts[2] = allParts[2] || "";
    allParts[3] = allParts[3] || "";
    return {
      root: allParts[0],
      dir: allParts[0] + allParts[1].slice(0, -1),
      base: allParts[2],
      ext: allParts[3],
      name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
    };
  };
  posix.sep = "/";
  posix.delimiter = ":";
  if (isWindows)
    path.exports = win32;
  else
    path.exports = posix;
  path.exports.posix = posix;
  path.exports.win32 = win32;
  return path.exports;
}
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var hasRequiredMimeTypes;
function requireMimeTypes() {
  if (hasRequiredMimeTypes) return mimeTypes;
  hasRequiredMimeTypes = 1;
  (function(exports$1) {
    var db = requireMimeDb();
    var extname = requirePath().extname;
    var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
    var TEXT_TYPE_REGEXP = /^text\//i;
    exports$1.charset = charset;
    exports$1.charsets = { lookup: charset };
    exports$1.contentType = contentType;
    exports$1.extension = extension;
    exports$1.extensions = /* @__PURE__ */ Object.create(null);
    exports$1.lookup = lookup;
    exports$1.types = /* @__PURE__ */ Object.create(null);
    populateMaps(exports$1.extensions, exports$1.types);
    function charset(type4) {
      if (!type4 || typeof type4 !== "string") {
        return false;
      }
      var match2 = EXTRACT_TYPE_REGEXP.exec(type4);
      var mime = match2 && db[match2[1].toLowerCase()];
      if (mime && mime.charset) {
        return mime.charset;
      }
      if (match2 && TEXT_TYPE_REGEXP.test(match2[1])) {
        return "UTF-8";
      }
      return false;
    }
    function contentType(str) {
      if (!str || typeof str !== "string") {
        return false;
      }
      var mime = str.indexOf("/") === -1 ? exports$1.lookup(str) : str;
      if (!mime) {
        return false;
      }
      if (mime.indexOf("charset") === -1) {
        var charset2 = exports$1.charset(mime);
        if (charset2) mime += "; charset=" + charset2.toLowerCase();
      }
      return mime;
    }
    function extension(type4) {
      if (!type4 || typeof type4 !== "string") {
        return false;
      }
      var match2 = EXTRACT_TYPE_REGEXP.exec(type4);
      var exts = match2 && exports$1.extensions[match2[1].toLowerCase()];
      if (!exts || !exts.length) {
        return false;
      }
      return exts[0];
    }
    function lookup(path2) {
      if (!path2 || typeof path2 !== "string") {
        return false;
      }
      var extension2 = extname("x." + path2).toLowerCase().substr(1);
      if (!extension2) {
        return false;
      }
      return exports$1.types[extension2] || false;
    }
    function populateMaps(extensions, types2) {
      var preference = ["nginx", "apache", void 0, "iana"];
      Object.keys(db).forEach(function forEachMimeType(type4) {
        var mime = db[type4];
        var exts = mime.extensions;
        if (!exts || !exts.length) {
          return;
        }
        extensions[type4] = exts;
        for (var i = 0; i < exts.length; i++) {
          var extension2 = exts[i];
          if (types2[extension2]) {
            var from2 = preference.indexOf(db[types2[extension2]].source);
            var to = preference.indexOf(mime.source);
            if (types2[extension2] !== "application/octet-stream" && (from2 > to || from2 === to && types2[extension2].substr(0, 12) === "application/")) {
              continue;
            }
          }
          types2[extension2] = type4;
        }
      });
    }
  })(mimeTypes);
  return mimeTypes;
}
requireMimeTypes();
class Timer {
  constructor() {
    this.isActive = false;
    this.isInterval = false;
  }
  set(fn, span, fireImmediately = false) {
    if (fireImmediately) fn();
    this.timerObj = setTimeout(() => {
      fn();
      this.clear();
    }, span.milliseconds);
    this.isActive = true;
    this.isInterval = false;
  }
  setInterval(fn, span, fireImmediately = false) {
    if (fireImmediately) fn();
    this.timerObj = setInterval(() => {
      fn();
    }, span.milliseconds);
    this.isActive = true;
    this.isInterval = true;
  }
  clear() {
    if (this.isInterval) {
      clearInterval(this.timerObj);
    } else {
      clearTimeout(this.timerObj);
    }
    this.timerObj = null;
  }
}
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$l(target, key, result);
  return result;
};
class TokenStore {
  constructor(jwtDecoder, cookieClient) {
    this.jwtDecoder = jwtDecoder;
    this.cookieClient = cookieClient;
    this.jwtDecoder = jwtDecoder || inject(this, JwtDecoder);
    this.cookieClient = cookieClient || inject(this, AuthCookieClient);
    this.updateTokens(this.cookieClient.getAccessToken() ?? null, this.cookieClient.getRefreshToken() ?? null);
  }
  get decodedAccessToken() {
    if (this.accessToken == null)
      return null;
    return this.jwtDecoder.decode(this.accessToken);
  }
  updateTokens(accessToken, refreshToken) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    if (this.accessToken != null && this.decodedAccessToken != null) {
      this.cookieClient.setAccessToken(this.accessToken, this.decodedAccessToken.exp);
    } else {
      this.cookieClient.removeAccessToken();
    }
    if (this.refreshToken != null) {
      this.cookieClient.setRefreshToken(this.refreshToken);
    } else {
      this.cookieClient.removeRefreshToken();
    }
  }
  clearTokens() {
    this.updateTokens(null, null);
  }
}
__decorateClass$n([
  observable
], TokenStore.prototype, "refreshToken", 2);
__decorateClass$n([
  observable
], TokenStore.prototype, "accessToken", 2);
__decorateClass$n([
  computed
], TokenStore.prototype, "decodedAccessToken", 1);
__decorateClass$n([
  action
], TokenStore.prototype, "updateTokens", 1);
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$k(target, key, result);
  return result;
};
class ListStore extends Disposable {
  constructor(mode = "paging", replaceFilter = true) {
    super();
    this.inited = false;
    this.hasError = false;
    this.fetching = false;
    this.items = [];
    this.mode = "paging";
    this.replaceFilter = true;
    this.filter = this.createFilter({});
    this.mode = mode ?? "paging";
    this.replaceFilter = replaceFilter ?? true;
  }
  get empty() {
    return this.inited && this.items.length == 0;
  }
  get emptyByFilter() {
    return this.inited && this.filter.itemsTotal == 0;
  }
  get hasMore() {
    if (this.filter.itemsTotal === void 0) return true;
    switch (this.mode) {
      case "paging":
        return this.filter.page * this.filter.take < this.filter.itemsTotal;
      case "infinity":
        return this.filter.itemsTotal > this.items.length;
    }
  }
  get moreCount() {
    switch (this.mode) {
      case "paging":
        return Math.max(this.filter.itemsTotal - this.filter.page * this.filter.take, 0);
      case "infinity":
        return this.filter.itemsTotal - this.items.length;
    }
  }
  setItems(items) {
    this.items = items;
  }
  async fetch(fields) {
    const allowFetch = this.beforeFetch(this.filter, fields);
    if (!allowFetch) return new BadApiResult();
    runInAction(() => {
      this.fetching = true;
    });
    const result = await this.fetchItems(fields);
    if (result.success) {
      const items = result.response.items ?? result.response.body?.items ?? [];
      const filter2 = result.response.filter ?? result.response.body?.filter;
      this.processResponse(items, filter2);
    }
    runInAction(() => {
      this.inited = true;
      this.hasError = !result.success;
      this.fetching = false;
    });
    this.afterFetch(result);
    return result;
  }
  /**
   * fetch with no pagination
   * @param fields 
   * @returns 
   */
  async fetchAll(fields, includeDeleted = false) {
    this.updateFilter({ useBaseFilter: false, softDeleted: includeDeleted ? null : this.filter.softDeleted });
    return await this.fetch(fields);
  }
  processResponse(items, filter2) {
    switch (this.mode) {
      case "paging": {
        this.items = items;
        break;
      }
      case "infinity": {
        console.logDev("Infinity fetching", filter2.skip, filter2.skip + filter2.take, items.length);
        const arr = this.items.slice();
        let index2 = filter2.skip;
        for (const item2 of items) {
          if (!arr[index2])
            arr[index2] = item2;
          index2++;
        }
        this.items = arr;
        break;
      }
    }
    if (!filter2) {
      console.warn("[ListStore] no filter in response");
      return;
    }
    if (this.replaceFilter && filter2 instanceof BaseFilter)
      this.filter = filter2;
    else this.filter = this.createFilter({ ...this.filter, itemsTotal: filter2.itemsTotal });
  }
  updateFilter(changes, resetPaging = true) {
    if (resetPaging) this.filter.page = 1;
    this.filter = this.createFilter(changes);
  }
  setFilter(filter2) {
    this.filter = filter2;
  }
  createFilter(changes) {
    return new BaseFilter({ ...this.filter, ...changes });
  }
  beforeFetch(filter2, fields) {
    return true;
  }
  afterFetch(result) {
    return;
  }
  reset() {
    this.items = [];
    this.hasError = false;
    this.filter = this.createFilter({});
    this.inited = false;
  }
}
__decorateClass$m([
  observable
], ListStore.prototype, "inited", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "hasError", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "fetching", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "items", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "filter", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "mode", 2);
__decorateClass$m([
  observable
], ListStore.prototype, "replaceFilter", 2);
__decorateClass$m([
  computed
], ListStore.prototype, "empty", 1);
__decorateClass$m([
  computed
], ListStore.prototype, "emptyByFilter", 1);
__decorateClass$m([
  computed
], ListStore.prototype, "hasMore", 1);
__decorateClass$m([
  computed
], ListStore.prototype, "moreCount", 1);
__decorateClass$m([
  action
], ListStore.prototype, "setItems", 1);
__decorateClass$m([
  action
], ListStore.prototype, "processResponse", 1);
__decorateClass$m([
  action
], ListStore.prototype, "updateFilter", 1);
__decorateClass$m([
  action
], ListStore.prototype, "setFilter", 1);
__decorateClass$m([
  action
], ListStore.prototype, "reset", 1);
class SelectableListStore extends ListStore {
  constructor() {
    super(...arguments);
    this.selectedAll = false;
    this.selectedIdsSet = /* @__PURE__ */ new Set();
    this.filterSkipFields = ["asNoTracking", "itemsTotal", "skip", "take", "sortName", "sortType", "useBaseFilter", "useSort"];
  }
  get selectedIds() {
    return Array.from(this.selectedIdsSet);
  }
  get hasSelection() {
    return this.selectedAll || this.selectedIdsSet.size > 0;
  }
  get selectedCount() {
    return this.selectedAll ? this.filter.itemsTotal : this.selectedIdsSet.size;
  }
  get selectionFilter() {
    return this.selectedAll ? this.createFilter({ ...this.filter, ids: void 0 }) : this.createFilter({ ids: this.selectedIds });
  }
  get selectedItems() {
    return this.items.filter((x) => this.selectedIdsSet.has(x.id));
  }
  updateFilter(changes, resetPaging = true) {
    super.updateFilter(changes, resetPaging);
    if (this.selectedAll && this.shouldResetSelection(changes)) {
      this.selectedAll = false;
    }
  }
  shouldResetSelection(changes) {
    const keys2 = Object.keys(changes).filter((x) => changes[x] !== void 0).filter((x) => !this.filterSkipFields.includes(x));
    return keys2.length > 0;
  }
  toggleItem(id2) {
    const isSelected = this.isSelected(id2);
    if (isSelected) {
      this.deselectItems([id2]);
      return;
    }
    this.selectItems([id2]);
  }
  setSelectedItems(ids) {
    this.deselectAll();
    ids.forEach((id2) => this.selectedIdsSet.add(id2));
  }
  selectItems(ids, deselectPrev = false) {
    this.selectedAll = false;
    if (deselectPrev)
      this.deselectAll();
    ids.forEach((id2) => this.selectedIdsSet.add(id2));
  }
  deselectItems(ids) {
    this.selectedAll = false;
    ids.forEach((id2) => this.selectedIdsSet.delete(id2));
  }
  isSelected(id2) {
    return this.selectedIdsSet.has(id2);
  }
  selectAll() {
    this.deselectAll();
    this.selectedAll = true;
  }
  deselectAll() {
    this.selectedAll = false;
    this.selectedIdsSet.clear();
  }
}
__decorateClass$m([
  observable
], SelectableListStore.prototype, "selectedAll", 2);
__decorateClass$m([
  observable
], SelectableListStore.prototype, "selectedIdsSet", 2);
__decorateClass$m([
  computed
], SelectableListStore.prototype, "selectedIds", 1);
__decorateClass$m([
  computed
], SelectableListStore.prototype, "hasSelection", 1);
__decorateClass$m([
  computed
], SelectableListStore.prototype, "selectedCount", 1);
__decorateClass$m([
  computed
], SelectableListStore.prototype, "selectionFilter", 1);
__decorateClass$m([
  computed
], SelectableListStore.prototype, "selectedItems", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "updateFilter", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "toggleItem", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "setSelectedItems", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "selectItems", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "deselectItems", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "selectAll", 1);
__decorateClass$m([
  action
], SelectableListStore.prototype, "deselectAll", 1);
class CRUDListStore extends ListStore {
  constructor() {
    super(...arguments);
    this.creating = false;
    this.saving = false;
    this.deleting = false;
  }
  createFilter(changes) {
    return new BaseFilter({ ...this.filter, ...changes });
  }
  async create(e) {
    this.creating = true;
    const result = await this.crudApi.create(e);
    if (result.success) {
      if (typeof result.response.body === "string")
        e.update({ id: result.response.body });
      else e.update(result.response.body);
    }
    runInAction(() => {
      this.creating = false;
    });
    return result;
  }
  async save(target) {
    this.saving = true;
    const result = await this.crudApi.save(target.toJson());
    runInAction(() => {
      this.saving = false;
    });
    return result;
  }
  async savePartial(changes, target) {
    this.saving = true;
    const result = await this.crudApi.save({ id: target.id, ...changes });
    if (result.success)
      target.update(changes);
    runInAction(() => {
      this.saving = false;
    });
    return result;
  }
  async saveCustom(changes) {
    this.saving = true;
    const result = await this.crudApi.save(changes);
    runInAction(() => {
      this.saving = false;
    });
    return result;
  }
  async delete(id2, fetchAfter = true) {
    this.deleting = true;
    const result = await this.crudApi.delete(id2);
    if (result.success && fetchAfter)
      this.fetch();
    runInAction(() => {
      this.deleting = false;
    });
    return result;
  }
  async fetchItem(id2, fields) {
    this.fetching = true;
    const result = await this.crudApi.fetchItem(id2, fields);
    runInAction(() => {
      this.fetching = false;
    });
    return result;
  }
  fetchItems(fields, filter2) {
    return this.crudApi.fetch(fields, filter2 ?? this.filter);
  }
}
__decorateClass$m([
  observable
], CRUDListStore.prototype, "creating", 2);
__decorateClass$m([
  action
], CRUDListStore.prototype, "create", 1);
__decorateClass$m([
  observable
], CRUDListStore.prototype, "saving", 2);
__decorateClass$m([
  action
], CRUDListStore.prototype, "save", 1);
__decorateClass$m([
  action
], CRUDListStore.prototype, "savePartial", 1);
__decorateClass$m([
  action
], CRUDListStore.prototype, "saveCustom", 1);
__decorateClass$m([
  observable
], CRUDListStore.prototype, "deleting", 2);
__decorateClass$m([
  action
], CRUDListStore.prototype, "delete", 1);
__decorateClass$m([
  action
], CRUDListStore.prototype, "fetchItem", 1);
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$j(target, key, result);
  return result;
};
class FileItemStore {
  constructor(api2, fileUploader) {
    this.api = api2;
    this.percent = 10;
    this.hasUploadError = false;
    this.uploading = false;
    this.began = new TypedEvent();
    this.uploaded = new TypedEvent();
    this.aborted = new TypedEvent();
    this.error = new TypedEvent();
    this.s3Uploader = fileUploader || new S3Uploader(api2);
  }
  get status() {
    if (this.hasUploadError) return FileUploadStatus.Error;
    if (this.uploading) return FileUploadStatus.Uploading;
    return FileUploadStatus.Uploaded;
  }
  setFile(file) {
    if (this.file != null && this.file.id == file.id) return;
    this.file = file;
  }
  abort() {
    this.s3Uploader.abort();
    this.aborted.emit();
  }
  get ready() {
    return this.file != null;
  }
  get canUpload() {
    return this.ready && this.file.nativeFile != null;
  }
  async upload(links = {}) {
    if (this.file.nativeFile == null) return;
    this.percent = 10;
    this.hasUploadError = false;
    this.uploading = true;
    links.fileId = this.file.id;
    if (links.isPublic == null) {
      links.isPublic = this.file.isImage;
    }
    this.s3Uploader.setFile(this.file.nativeFile, links);
    this.s3Uploader.onBegin.on((x) => {
      runInAction(() => {
        this.file.id = x.id;
        this.began.emit(x);
      });
    });
    this.s3Uploader.onProgress.on((x) => {
      runInAction(() => {
        this.percent = Math.max(10, x.percent);
      });
    });
    this.s3Uploader.onComplete.on((x) => {
      runInAction(() => {
        this.uploading = false;
        this.percent = 100;
        this.file.update({
          nativeFile: null,
          cloudKey: x.file.cloudKey,
          type: x.file.type,
          isPublic: links.isPublic ?? this.file.isPublic
        });
        this.uploaded.emit(x.file);
      });
    });
    if (!await this.s3Uploader.upload()) {
      runInAction(() => {
        this.hasUploadError = true;
        this.error.emit();
      });
    }
  }
  async download() {
    if (this.file.isExternalFile) {
      saveAs(this.file.url, true, this.file.filename);
      return true;
    }
    const result = await this.api.download(this.file.id);
    if (result.success) {
      saveAs(result.body, false, this.file.filename);
    }
    return result.success;
  }
  async preview() {
    const result = await this.api.download(this.file.id, true);
    if (result.success) {
      saveAs(result.body, true, this.file.filename);
    }
    return result.success;
  }
}
__decorateClass$l([
  observable
], FileItemStore.prototype, "file", 2);
__decorateClass$l([
  observable
], FileItemStore.prototype, "percent", 2);
__decorateClass$l([
  observable
], FileItemStore.prototype, "hasUploadError", 2);
__decorateClass$l([
  observable
], FileItemStore.prototype, "uploading", 2);
__decorateClass$l([
  computed
], FileItemStore.prototype, "status", 1);
__decorateClass$l([
  action
], FileItemStore.prototype, "setFile", 1);
__decorateClass$l([
  action
], FileItemStore.prototype, "abort", 1);
__decorateClass$l([
  computed
], FileItemStore.prototype, "ready", 1);
__decorateClass$l([
  computed
], FileItemStore.prototype, "canUpload", 1);
__decorateClass$l([
  action
], FileItemStore.prototype, "upload", 1);
__decorateClass$l([
  action
], FileItemStore.prototype, "download", 1);
__decorateClass$l([
  action
], FileItemStore.prototype, "preview", 1);
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$i(target, key, result);
  return result;
};
class DeviceStore extends Disposable {
  constructor() {
    super();
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.browser = Bowser.parse(window.navigator.userAgent);
    const func = action(() => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    });
    window.addEventListener("resize", func);
    this.toDispose(() => window.removeEventListener("resize", func));
  }
  get orientation() {
    return this.height > this.width ? "portrait" : "landscape";
  }
  get platform() {
    return this.browser.platform.type;
  }
  get OS() {
    return this.browser.os.name;
  }
  get engine() {
    return this.browser.engine.name;
  }
  get info() {
    return this.browser.engine.name;
  }
  get isTouch() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || //@ts-ignore
    navigator.msMaxTouchPoints > 0;
  }
  get isTelegram() {
    return window["TelegramWebview"] !== void 0;
  }
  get isInAppBrowser() {
    return this.isTelegram;
  }
  get size() {
    if (this.width <= 750) return "mobile";
    else if (this.width <= 1024) return "tablet";
    return "desktop";
  }
  get isMobile() {
    return this.size == "mobile";
  }
  get isNotDesktop() {
    return this.size != "desktop";
  }
}
__decorateClass$k([
  observable
], DeviceStore.prototype, "width", 2);
__decorateClass$k([
  observable
], DeviceStore.prototype, "height", 2);
__decorateClass$k([
  computed
], DeviceStore.prototype, "orientation", 1);
__decorateClass$k([
  computed
], DeviceStore.prototype, "size", 1);
__decorateClass$k([
  computed
], DeviceStore.prototype, "isMobile", 1);
__decorateClass$k([
  computed
], DeviceStore.prototype, "isNotDesktop", 1);
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$h(target, key, result);
  return result;
};
class RecyclableListStore {
  constructor(buffer, defaultItems) {
    this.buffer = buffer;
    this.items = [];
    if (defaultItems)
      this.push(defaultItems);
  }
  get empty() {
    return this.length == 0;
  }
  get length() {
    return this.items.length;
  }
  get available() {
    return this.buffer - this.items.length;
  }
  push(items) {
    const copy2 = this.items.slice();
    if (this.available < items.length) {
      copy2.splice(0, items.length - this.available);
    }
    copy2.push(...items);
    this.items = copy2;
  }
  remove(id2) {
    const index2 = this.items.findIndex((x) => x.id == id2);
    if (index2 == -1) return;
    const copy2 = this.items.slice();
    copy2.splice(index2, 1);
    this.items = copy2;
  }
  removeRange(ids) {
    const copy2 = this.items.slice();
    for (const id2 of ids) {
      const index2 = copy2.findIndex((x) => x.id == id2);
      if (index2 == -1) continue;
      copy2.splice(index2, 1);
    }
    this.items = copy2;
  }
  removeRangeByFilter(predicate) {
    const itemsToRemove = this.items.filter(predicate);
    this.removeRange(itemsToRemove.map((x) => x.id));
  }
  clear() {
    this.items = [];
  }
}
__decorateClass$j([
  computed
], RecyclableListStore.prototype, "empty", 1);
__decorateClass$j([
  computed
], RecyclableListStore.prototype, "length", 1);
__decorateClass$j([
  observable
], RecyclableListStore.prototype, "items", 2);
__decorateClass$j([
  computed
], RecyclableListStore.prototype, "available", 1);
__decorateClass$j([
  action
], RecyclableListStore.prototype, "push", 1);
__decorateClass$j([
  action
], RecyclableListStore.prototype, "remove", 1);
__decorateClass$j([
  action
], RecyclableListStore.prototype, "removeRange", 1);
__decorateClass$j([
  action
], RecyclableListStore.prototype, "removeRangeByFilter", 1);
__decorateClass$j([
  action
], RecyclableListStore.prototype, "clear", 1);
class HttpError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(errorMessage, statusCode) {
    const trueProto = new.target.prototype;
    super(`${errorMessage}: Status code '${statusCode}'`);
    this.statusCode = statusCode;
    this.__proto__ = trueProto;
  }
}
class TimeoutError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(errorMessage = "A timeout occurred.") {
    const trueProto = new.target.prototype;
    super(errorMessage);
    this.__proto__ = trueProto;
  }
}
class AbortError extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(errorMessage = "An abort occurred.") {
    const trueProto = new.target.prototype;
    super(errorMessage);
    this.__proto__ = trueProto;
  }
}
class UnsupportedTransportError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  constructor(message2, transport) {
    const trueProto = new.target.prototype;
    super(message2);
    this.transport = transport;
    this.errorType = "UnsupportedTransportError";
    this.__proto__ = trueProto;
  }
}
class DisabledTransportError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  constructor(message2, transport) {
    const trueProto = new.target.prototype;
    super(message2);
    this.transport = transport;
    this.errorType = "DisabledTransportError";
    this.__proto__ = trueProto;
  }
}
class FailedToStartTransportError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occured on.
   */
  constructor(message2, transport) {
    const trueProto = new.target.prototype;
    super(message2);
    this.transport = transport;
    this.errorType = "FailedToStartTransportError";
    this.__proto__ = trueProto;
  }
}
class FailedToNegotiateWithServerError extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(message2) {
    const trueProto = new.target.prototype;
    super(message2);
    this.errorType = "FailedToNegotiateWithServerError";
    this.__proto__ = trueProto;
  }
}
class AggregateErrors extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(message2, innerErrors) {
    const trueProto = new.target.prototype;
    super(message2);
    this.innerErrors = innerErrors;
    this.__proto__ = trueProto;
  }
}
class HttpResponse {
  constructor(statusCode, statusText, content2) {
    this.statusCode = statusCode;
    this.statusText = statusText;
    this.content = content2;
  }
}
class HttpClient {
  get(url2, options) {
    return this.send({
      ...options,
      method: "GET",
      url: url2
    });
  }
  post(url2, options) {
    return this.send({
      ...options,
      method: "POST",
      url: url2
    });
  }
  delete(url2, options) {
    return this.send({
      ...options,
      method: "DELETE",
      url: url2
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(url2) {
    return "";
  }
}
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["Trace"] = 0] = "Trace";
  LogLevel2[LogLevel2["Debug"] = 1] = "Debug";
  LogLevel2[LogLevel2["Information"] = 2] = "Information";
  LogLevel2[LogLevel2["Warning"] = 3] = "Warning";
  LogLevel2[LogLevel2["Error"] = 4] = "Error";
  LogLevel2[LogLevel2["Critical"] = 5] = "Critical";
  LogLevel2[LogLevel2["None"] = 6] = "None";
})(LogLevel || (LogLevel = {}));
class NullLogger {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(_logLevel, _message) {
  }
}
NullLogger.instance = new NullLogger();
const VERSION = "6.0.9";
class Arg {
  static isRequired(val, name) {
    if (val === null || val === void 0) {
      throw new Error(`The '${name}' argument is required.`);
    }
  }
  static isNotEmpty(val, name) {
    if (!val || val.match(/^\s*$/)) {
      throw new Error(`The '${name}' argument should not be empty.`);
    }
  }
  static isIn(val, values, name) {
    if (!(val in values)) {
      throw new Error(`Unknown ${name} value: ${val}.`);
    }
  }
}
class Platform {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return typeof window === "object" && typeof window.document === "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return typeof self === "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return typeof window === "object" && typeof window.document === "undefined";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return !this.isBrowser && !this.isWebWorker && !this.isReactNative;
  }
}
function getDataDetail(data2, includeContent) {
  let detail = "";
  if (isArrayBuffer(data2)) {
    detail = `Binary data of length ${data2.byteLength}`;
    if (includeContent) {
      detail += `. Content: '${formatArrayBuffer(data2)}'`;
    }
  } else if (typeof data2 === "string") {
    detail = `String data of length ${data2.length}`;
    if (includeContent) {
      detail += `. Content: '${data2}'`;
    }
  }
  return detail;
}
function formatArrayBuffer(data2) {
  const view = new Uint8Array(data2);
  let str = "";
  view.forEach((num) => {
    const pad = num < 16 ? "0" : "";
    str += `0x${pad}${num.toString(16)} `;
  });
  return str.substr(0, str.length - 1);
}
function isArrayBuffer(val) {
  return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  val.constructor && val.constructor.name === "ArrayBuffer");
}
async function sendMessage(logger, transportName, httpClient, url2, accessTokenFactory, content2, options) {
  let headers = {};
  if (accessTokenFactory) {
    const token2 = await accessTokenFactory();
    if (token2) {
      headers = {
        ["Authorization"]: `Bearer ${token2}`
      };
    }
  }
  const [name, value] = getUserAgentHeader();
  headers[name] = value;
  logger.log(LogLevel.Trace, `(${transportName} transport) sending data. ${getDataDetail(content2, options.logMessageContent)}.`);
  const responseType = isArrayBuffer(content2) ? "arraybuffer" : "text";
  const response = await httpClient.post(url2, {
    content: content2,
    headers: { ...headers, ...options.headers },
    responseType,
    timeout: options.timeout,
    withCredentials: options.withCredentials
  });
  logger.log(LogLevel.Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function createLogger(logger) {
  if (logger === void 0) {
    return new ConsoleLogger(LogLevel.Information);
  }
  if (logger === null) {
    return NullLogger.instance;
  }
  if (logger.log !== void 0) {
    return logger;
  }
  return new ConsoleLogger(logger);
}
class SubjectSubscription {
  constructor(subject, observer2) {
    this._subject = subject;
    this._observer = observer2;
  }
  dispose() {
    const index2 = this._subject.observers.indexOf(this._observer);
    if (index2 > -1) {
      this._subject.observers.splice(index2, 1);
    }
    if (this._subject.observers.length === 0 && this._subject.cancelCallback) {
      this._subject.cancelCallback().catch((_2) => {
      });
    }
  }
}
class ConsoleLogger {
  constructor(minimumLogLevel) {
    this._minLevel = minimumLogLevel;
    this.out = console;
  }
  log(logLevel, message2) {
    if (logLevel >= this._minLevel) {
      const msg = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${LogLevel[logLevel]}: ${message2}`;
      switch (logLevel) {
        case LogLevel.Critical:
        case LogLevel.Error:
          this.out.error(msg);
          break;
        case LogLevel.Warning:
          this.out.warn(msg);
          break;
        case LogLevel.Information:
          this.out.info(msg);
          break;
        default:
          this.out.log(msg);
          break;
      }
    }
  }
}
function getUserAgentHeader() {
  let userAgentHeaderName = "X-SignalR-User-Agent";
  if (Platform.isNode) {
    userAgentHeaderName = "User-Agent";
  }
  return [userAgentHeaderName, constructUserAgent(VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
function constructUserAgent(version2, os, runtime, runtimeVersion) {
  let userAgent = "Microsoft SignalR/";
  const majorAndMinor = version2.split(".");
  userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
  userAgent += ` (${version2}; `;
  if (os && os !== "") {
    userAgent += `${os}; `;
  } else {
    userAgent += "Unknown OS; ";
  }
  userAgent += `${runtime}`;
  if (runtimeVersion) {
    userAgent += `; ${runtimeVersion}`;
  } else {
    userAgent += "; Unknown Runtime Version";
  }
  userAgent += ")";
  return userAgent;
}
function getOsName() {
  if (Platform.isNode) {
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  } else {
    return "";
  }
}
function getRuntimeVersion() {
  if (Platform.isNode) {
    return process.versions.node;
  }
  return void 0;
}
function getRuntime() {
  if (Platform.isNode) {
    return "NodeJS";
  } else {
    return "Browser";
  }
}
function getErrorString(e) {
  if (e.stack) {
    return e.stack;
  } else if (e.message) {
    return e.message;
  }
  return `${e}`;
}
function getGlobalThis() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw new Error("could not find global");
}
class FetchHttpClient extends HttpClient {
  constructor(logger) {
    super();
    this._logger = logger;
    if (typeof fetch === "undefined") {
      const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      this._jar = new (requireFunc("tough-cookie")).CookieJar();
      this._fetchType = requireFunc("node-fetch");
      this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
    } else {
      this._fetchType = fetch.bind(getGlobalThis());
    }
    if (typeof AbortController === "undefined") {
      const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      this._abortControllerType = requireFunc("abort-controller");
    } else {
      this._abortControllerType = AbortController;
    }
  }
  /** @inheritDoc */
  async send(request2) {
    if (request2.abortSignal && request2.abortSignal.aborted) {
      throw new AbortError();
    }
    if (!request2.method) {
      throw new Error("No method defined.");
    }
    if (!request2.url) {
      throw new Error("No url defined.");
    }
    const abortController = new this._abortControllerType();
    let error2;
    if (request2.abortSignal) {
      request2.abortSignal.onabort = () => {
        abortController.abort();
        error2 = new AbortError();
      };
    }
    let timeoutId = null;
    if (request2.timeout) {
      const msTimeout = request2.timeout;
      timeoutId = setTimeout(() => {
        abortController.abort();
        this._logger.log(LogLevel.Warning, `Timeout from HTTP request.`);
        error2 = new TimeoutError();
      }, msTimeout);
    }
    let response;
    try {
      response = await this._fetchType(request2.url, {
        body: request2.content,
        cache: "no-cache",
        credentials: request2.withCredentials === true ? "include" : "same-origin",
        headers: {
          "Content-Type": "text/plain;charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest",
          ...request2.headers
        },
        method: request2.method,
        mode: "cors",
        redirect: "follow",
        signal: abortController.signal
      });
    } catch (e) {
      if (error2) {
        throw error2;
      }
      this._logger.log(LogLevel.Warning, `Error from HTTP request. ${e}.`);
      throw e;
    } finally {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (request2.abortSignal) {
        request2.abortSignal.onabort = null;
      }
    }
    if (!response.ok) {
      const errorMessage = await deserializeContent(response, "text");
      throw new HttpError(errorMessage || response.statusText, response.status);
    }
    const content2 = deserializeContent(response, request2.responseType);
    const payload = await content2;
    return new HttpResponse(response.status, response.statusText, payload);
  }
  getCookieString(url2) {
    let cookies2 = "";
    if (Platform.isNode && this._jar) {
      this._jar.getCookies(url2, (e, c) => cookies2 = c.join("; "));
    }
    return cookies2;
  }
}
function deserializeContent(response, responseType) {
  let content2;
  switch (responseType) {
    case "arraybuffer":
      content2 = response.arrayBuffer();
      break;
    case "text":
      content2 = response.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${responseType} is not supported.`);
    default:
      content2 = response.text();
      break;
  }
  return content2;
}
class XhrHttpClient extends HttpClient {
  constructor(logger) {
    super();
    this._logger = logger;
  }
  /** @inheritDoc */
  send(request2) {
    if (request2.abortSignal && request2.abortSignal.aborted) {
      return Promise.reject(new AbortError());
    }
    if (!request2.method) {
      return Promise.reject(new Error("No method defined."));
    }
    if (!request2.url) {
      return Promise.reject(new Error("No url defined."));
    }
    return new Promise((resolve, reject) => {
      const xhr2 = new XMLHttpRequest();
      xhr2.open(request2.method, request2.url, true);
      xhr2.withCredentials = request2.withCredentials === void 0 ? true : request2.withCredentials;
      xhr2.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr2.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
      const headers = request2.headers;
      if (headers) {
        Object.keys(headers).forEach((header) => {
          xhr2.setRequestHeader(header, headers[header]);
        });
      }
      if (request2.responseType) {
        xhr2.responseType = request2.responseType;
      }
      if (request2.abortSignal) {
        request2.abortSignal.onabort = () => {
          xhr2.abort();
          reject(new AbortError());
        };
      }
      if (request2.timeout) {
        xhr2.timeout = request2.timeout;
      }
      xhr2.onload = () => {
        if (request2.abortSignal) {
          request2.abortSignal.onabort = null;
        }
        if (xhr2.status >= 200 && xhr2.status < 300) {
          resolve(new HttpResponse(xhr2.status, xhr2.statusText, xhr2.response || xhr2.responseText));
        } else {
          reject(new HttpError(xhr2.response || xhr2.responseText || xhr2.statusText, xhr2.status));
        }
      };
      xhr2.onerror = () => {
        this._logger.log(LogLevel.Warning, `Error from HTTP request. ${xhr2.status}: ${xhr2.statusText}.`);
        reject(new HttpError(xhr2.statusText, xhr2.status));
      };
      xhr2.ontimeout = () => {
        this._logger.log(LogLevel.Warning, `Timeout from HTTP request.`);
        reject(new TimeoutError());
      };
      xhr2.send(request2.content || "");
    });
  }
}
class DefaultHttpClient extends HttpClient {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(logger) {
    super();
    if (typeof fetch !== "undefined" || Platform.isNode) {
      this._httpClient = new FetchHttpClient(logger);
    } else if (typeof XMLHttpRequest !== "undefined") {
      this._httpClient = new XhrHttpClient(logger);
    } else {
      throw new Error("No usable HttpClient found.");
    }
  }
  /** @inheritDoc */
  send(request2) {
    if (request2.abortSignal && request2.abortSignal.aborted) {
      return Promise.reject(new AbortError());
    }
    if (!request2.method) {
      return Promise.reject(new Error("No method defined."));
    }
    if (!request2.url) {
      return Promise.reject(new Error("No url defined."));
    }
    return this._httpClient.send(request2);
  }
  getCookieString(url2) {
    return this._httpClient.getCookieString(url2);
  }
}
class TextMessageFormat {
  static write(output) {
    return `${output}${TextMessageFormat.RecordSeparator}`;
  }
  static parse(input2) {
    if (input2[input2.length - 1] !== TextMessageFormat.RecordSeparator) {
      throw new Error("Message is incomplete.");
    }
    const messages2 = input2.split(TextMessageFormat.RecordSeparator);
    messages2.pop();
    return messages2;
  }
}
TextMessageFormat.RecordSeparatorCode = 30;
TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
class HandshakeProtocol {
  // Handshake request is always JSON
  writeHandshakeRequest(handshakeRequest) {
    return TextMessageFormat.write(JSON.stringify(handshakeRequest));
  }
  parseHandshakeResponse(data2) {
    let messageData;
    let remainingData;
    if (isArrayBuffer(data2)) {
      const binaryData = new Uint8Array(data2);
      const separatorIndex = binaryData.indexOf(TextMessageFormat.RecordSeparatorCode);
      if (separatorIndex === -1) {
        throw new Error("Message is incomplete.");
      }
      const responseLength = separatorIndex + 1;
      messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
      remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
    } else {
      const textData = data2;
      const separatorIndex = textData.indexOf(TextMessageFormat.RecordSeparator);
      if (separatorIndex === -1) {
        throw new Error("Message is incomplete.");
      }
      const responseLength = separatorIndex + 1;
      messageData = textData.substring(0, responseLength);
      remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
    }
    const messages2 = TextMessageFormat.parse(messageData);
    const response = JSON.parse(messages2[0]);
    if (response.type) {
      throw new Error("Expected a handshake response from the server.");
    }
    const responseMessage = response;
    return [remainingData, responseMessage];
  }
}
var MessageType;
(function(MessageType2) {
  MessageType2[MessageType2["Invocation"] = 1] = "Invocation";
  MessageType2[MessageType2["StreamItem"] = 2] = "StreamItem";
  MessageType2[MessageType2["Completion"] = 3] = "Completion";
  MessageType2[MessageType2["StreamInvocation"] = 4] = "StreamInvocation";
  MessageType2[MessageType2["CancelInvocation"] = 5] = "CancelInvocation";
  MessageType2[MessageType2["Ping"] = 6] = "Ping";
  MessageType2[MessageType2["Close"] = 7] = "Close";
})(MessageType || (MessageType = {}));
class Subject {
  constructor() {
    this.observers = [];
  }
  next(item2) {
    for (const observer2 of this.observers) {
      observer2.next(item2);
    }
  }
  error(err) {
    for (const observer2 of this.observers) {
      if (observer2.error) {
        observer2.error(err);
      }
    }
  }
  complete() {
    for (const observer2 of this.observers) {
      if (observer2.complete) {
        observer2.complete();
      }
    }
  }
  subscribe(observer2) {
    this.observers.push(observer2);
    return new SubjectSubscription(this, observer2);
  }
}
const DEFAULT_TIMEOUT_IN_MS = 30 * 1e3;
const DEFAULT_PING_INTERVAL_IN_MS = 15 * 1e3;
var HubConnectionState;
(function(HubConnectionState2) {
  HubConnectionState2["Disconnected"] = "Disconnected";
  HubConnectionState2["Connecting"] = "Connecting";
  HubConnectionState2["Connected"] = "Connected";
  HubConnectionState2["Disconnecting"] = "Disconnecting";
  HubConnectionState2["Reconnecting"] = "Reconnecting";
})(HubConnectionState || (HubConnectionState = {}));
class HubConnection {
  constructor(connection, logger, protocol2, reconnectPolicy) {
    this._nextKeepAlive = 0;
    this._freezeEventListener = () => {
      this._logger.log(LogLevel.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://docs.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    };
    Arg.isRequired(connection, "connection");
    Arg.isRequired(logger, "logger");
    Arg.isRequired(protocol2, "protocol");
    this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
    this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
    this._logger = logger;
    this._protocol = protocol2;
    this.connection = connection;
    this._reconnectPolicy = reconnectPolicy;
    this._handshakeProtocol = new HandshakeProtocol();
    this.connection.onreceive = (data2) => this._processIncomingData(data2);
    this.connection.onclose = (error2) => this._connectionClosed(error2);
    this._callbacks = {};
    this._methods = {};
    this._closedCallbacks = [];
    this._reconnectingCallbacks = [];
    this._reconnectedCallbacks = [];
    this._invocationId = 0;
    this._receivedHandshakeResponse = false;
    this._connectionState = HubConnectionState.Disconnected;
    this._connectionStarted = false;
    this._cachedPingMessage = this._protocol.writeMessage({ type: MessageType.Ping });
  }
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(connection, logger, protocol2, reconnectPolicy) {
    return new HubConnection(connection, logger, protocol2, reconnectPolicy);
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection ? this.connection.connectionId || null : null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(url2) {
    if (this._connectionState !== HubConnectionState.Disconnected && this._connectionState !== HubConnectionState.Reconnecting) {
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    }
    if (!url2) {
      throw new Error("The HubConnection url must be a valid url.");
    }
    this.connection.baseUrl = url2;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    this._startPromise = this._startWithStateTransitions();
    return this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== HubConnectionState.Disconnected) {
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    }
    this._connectionState = HubConnectionState.Connecting;
    this._logger.log(LogLevel.Debug, "Starting HubConnection.");
    try {
      await this._startInternal();
      if (Platform.isBrowser) {
        window.document.addEventListener("freeze", this._freezeEventListener);
      }
      this._connectionState = HubConnectionState.Connected;
      this._connectionStarted = true;
      this._logger.log(LogLevel.Debug, "HubConnection connected successfully.");
    } catch (e) {
      this._connectionState = HubConnectionState.Disconnected;
      this._logger.log(LogLevel.Debug, `HubConnection failed to start successfully because of error '${e}'.`);
      return Promise.reject(e);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0;
    this._receivedHandshakeResponse = false;
    const handshakePromise = new Promise((resolve, reject) => {
      this._handshakeResolver = resolve;
      this._handshakeRejecter = reject;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      const handshakeRequest = {
        protocol: this._protocol.name,
        version: this._protocol.version
      };
      this._logger.log(LogLevel.Debug, "Sending handshake request.");
      await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
      this._logger.log(LogLevel.Information, `Using HubProtocol '${this._protocol.name}'.`);
      this._cleanupTimeout();
      this._resetTimeoutPeriod();
      this._resetKeepAliveInterval();
      await handshakePromise;
      if (this._stopDuringStartError) {
        throw this._stopDuringStartError;
      }
    } catch (e) {
      this._logger.log(LogLevel.Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
      this._cleanupTimeout();
      this._cleanupPingTimer();
      await this.connection.stop(e);
      throw e;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const startPromise = this._startPromise;
    this._stopPromise = this._stopInternal();
    await this._stopPromise;
    try {
      await startPromise;
    } catch (e) {
    }
  }
  _stopInternal(error2) {
    if (this._connectionState === HubConnectionState.Disconnected) {
      this._logger.log(LogLevel.Debug, `Call to HubConnection.stop(${error2}) ignored because it is already in the disconnected state.`);
      return Promise.resolve();
    }
    if (this._connectionState === HubConnectionState.Disconnecting) {
      this._logger.log(LogLevel.Debug, `Call to HttpConnection.stop(${error2}) ignored because the connection is already in the disconnecting state.`);
      return this._stopPromise;
    }
    this._connectionState = HubConnectionState.Disconnecting;
    this._logger.log(LogLevel.Debug, "Stopping HubConnection.");
    if (this._reconnectDelayHandle) {
      this._logger.log(LogLevel.Debug, "Connection stopped during reconnect delay. Done reconnecting.");
      clearTimeout(this._reconnectDelayHandle);
      this._reconnectDelayHandle = void 0;
      this._completeClose();
      return Promise.resolve();
    }
    this._cleanupTimeout();
    this._cleanupPingTimer();
    this._stopDuringStartError = error2 || new Error("The connection was stopped before the hub handshake could complete.");
    return this.connection.stop(error2);
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(methodName, ...args) {
    const [streams, streamIds] = this._replaceStreamingParams(args);
    const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
    let promiseQueue;
    const subject = new Subject();
    subject.cancelCallback = () => {
      const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
      delete this._callbacks[invocationDescriptor.invocationId];
      return promiseQueue.then(() => {
        return this._sendWithProtocol(cancelInvocation);
      });
    };
    this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error2) => {
      if (error2) {
        subject.error(error2);
        return;
      } else if (invocationEvent) {
        if (invocationEvent.type === MessageType.Completion) {
          if (invocationEvent.error) {
            subject.error(new Error(invocationEvent.error));
          } else {
            subject.complete();
          }
        } else {
          subject.next(invocationEvent.item);
        }
      }
    };
    promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e) => {
      subject.error(e);
      delete this._callbacks[invocationDescriptor.invocationId];
    });
    this._launchStreams(streams, promiseQueue);
    return subject;
  }
  _sendMessage(message2) {
    this._resetKeepAliveInterval();
    return this.connection.send(message2);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(message2) {
    return this._sendMessage(this._protocol.writeMessage(message2));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(methodName, ...args) {
    const [streams, streamIds] = this._replaceStreamingParams(args);
    const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
    this._launchStreams(streams, sendPromise);
    return sendPromise;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(methodName, ...args) {
    const [streams, streamIds] = this._replaceStreamingParams(args);
    const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
    const p = new Promise((resolve, reject) => {
      this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error2) => {
        if (error2) {
          reject(error2);
          return;
        } else if (invocationEvent) {
          if (invocationEvent.type === MessageType.Completion) {
            if (invocationEvent.error) {
              reject(new Error(invocationEvent.error));
            } else {
              resolve(invocationEvent.result);
            }
          } else {
            reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
          }
        }
      };
      const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e) => {
        reject(e);
        delete this._callbacks[invocationDescriptor.invocationId];
      });
      this._launchStreams(streams, promiseQueue);
    });
    return p;
  }
  /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
   *
   * @param {string} methodName The name of the hub method to define.
   * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
   */
  on(methodName, newMethod) {
    if (!methodName || !newMethod) {
      return;
    }
    methodName = methodName.toLowerCase();
    if (!this._methods[methodName]) {
      this._methods[methodName] = [];
    }
    if (this._methods[methodName].indexOf(newMethod) !== -1) {
      return;
    }
    this._methods[methodName].push(newMethod);
  }
  off(methodName, method4) {
    if (!methodName) {
      return;
    }
    methodName = methodName.toLowerCase();
    const handlers = this._methods[methodName];
    if (!handlers) {
      return;
    }
    if (method4) {
      const removeIdx = handlers.indexOf(method4);
      if (removeIdx !== -1) {
        handlers.splice(removeIdx, 1);
        if (handlers.length === 0) {
          delete this._methods[methodName];
        }
      }
    } else {
      delete this._methods[methodName];
    }
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(callback) {
    if (callback) {
      this._closedCallbacks.push(callback);
    }
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(callback) {
    if (callback) {
      this._reconnectingCallbacks.push(callback);
    }
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(callback) {
    if (callback) {
      this._reconnectedCallbacks.push(callback);
    }
  }
  _processIncomingData(data2) {
    this._cleanupTimeout();
    if (!this._receivedHandshakeResponse) {
      data2 = this._processHandshakeResponse(data2);
      this._receivedHandshakeResponse = true;
    }
    if (data2) {
      const messages2 = this._protocol.parseMessages(data2, this._logger);
      for (const message2 of messages2) {
        switch (message2.type) {
          case MessageType.Invocation:
            this._invokeClientMethod(message2);
            break;
          case MessageType.StreamItem:
          case MessageType.Completion: {
            const callback = this._callbacks[message2.invocationId];
            if (callback) {
              if (message2.type === MessageType.Completion) {
                delete this._callbacks[message2.invocationId];
              }
              try {
                callback(message2);
              } catch (e) {
                this._logger.log(LogLevel.Error, `Stream callback threw error: ${getErrorString(e)}`);
              }
            }
            break;
          }
          case MessageType.Ping:
            break;
          case MessageType.Close: {
            this._logger.log(LogLevel.Information, "Close message received from server.");
            const error2 = message2.error ? new Error("Server returned an error on close: " + message2.error) : void 0;
            if (message2.allowReconnect === true) {
              this.connection.stop(error2);
            } else {
              this._stopPromise = this._stopInternal(error2);
            }
            break;
          }
          default:
            this._logger.log(LogLevel.Warning, `Invalid message type: ${message2.type}.`);
            break;
        }
      }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(data2) {
    let responseMessage;
    let remainingData;
    try {
      [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data2);
    } catch (e) {
      const message2 = "Error parsing handshake response: " + e;
      this._logger.log(LogLevel.Error, message2);
      const error2 = new Error(message2);
      this._handshakeRejecter(error2);
      throw error2;
    }
    if (responseMessage.error) {
      const message2 = "Server returned handshake error: " + responseMessage.error;
      this._logger.log(LogLevel.Error, message2);
      const error2 = new Error(message2);
      this._handshakeRejecter(error2);
      throw error2;
    } else {
      this._logger.log(LogLevel.Debug, "Server handshake complete.");
    }
    this._handshakeResolver();
    return remainingData;
  }
  _resetKeepAliveInterval() {
    if (this.connection.features.inherentKeepAlive) {
      return;
    }
    this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds;
    this._cleanupPingTimer();
  }
  _resetTimeoutPeriod() {
    if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
      this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds);
      if (this._pingServerHandle === void 0) {
        let nextPing = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
        if (nextPing < 0) {
          nextPing = 0;
        }
        this._pingServerHandle = setTimeout(async () => {
          if (this._connectionState === HubConnectionState.Connected) {
            try {
              await this._sendMessage(this._cachedPingMessage);
            } catch {
              this._cleanupPingTimer();
            }
          }
        }, nextPing);
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  _invokeClientMethod(invocationMessage) {
    const methods = this._methods[invocationMessage.target.toLowerCase()];
    if (methods) {
      try {
        methods.forEach((m) => m.apply(this, invocationMessage.arguments));
      } catch (e) {
        this._logger.log(LogLevel.Error, `A callback for the method ${invocationMessage.target.toLowerCase()} threw error '${e}'.`);
      }
      if (invocationMessage.invocationId) {
        const message2 = "Server requested a response, which is not supported in this version of the client.";
        this._logger.log(LogLevel.Error, message2);
        this._stopPromise = this._stopInternal(new Error(message2));
      }
    } else {
      this._logger.log(LogLevel.Warning, `No client method with the name '${invocationMessage.target}' found.`);
    }
  }
  _connectionClosed(error2) {
    this._logger.log(LogLevel.Debug, `HubConnection.connectionClosed(${error2}) called while in state ${this._connectionState}.`);
    this._stopDuringStartError = this._stopDuringStartError || error2 || new Error("The underlying connection was closed before the hub handshake could complete.");
    if (this._handshakeResolver) {
      this._handshakeResolver();
    }
    this._cancelCallbacksWithError(error2 || new Error("Invocation canceled due to the underlying connection being closed."));
    this._cleanupTimeout();
    this._cleanupPingTimer();
    if (this._connectionState === HubConnectionState.Disconnecting) {
      this._completeClose(error2);
    } else if (this._connectionState === HubConnectionState.Connected && this._reconnectPolicy) {
      this._reconnect(error2);
    } else if (this._connectionState === HubConnectionState.Connected) {
      this._completeClose(error2);
    }
  }
  _completeClose(error2) {
    if (this._connectionStarted) {
      this._connectionState = HubConnectionState.Disconnected;
      this._connectionStarted = false;
      if (Platform.isBrowser) {
        window.document.removeEventListener("freeze", this._freezeEventListener);
      }
      try {
        this._closedCallbacks.forEach((c) => c.apply(this, [error2]));
      } catch (e) {
        this._logger.log(LogLevel.Error, `An onclose callback called with error '${error2}' threw error '${e}'.`);
      }
    }
  }
  async _reconnect(error2) {
    const reconnectStartTime = Date.now();
    let previousReconnectAttempts = 0;
    let retryError = error2 !== void 0 ? error2 : new Error("Attempting to reconnect due to a unknown error.");
    let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
    if (nextRetryDelay === null) {
      this._logger.log(LogLevel.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
      this._completeClose(error2);
      return;
    }
    this._connectionState = HubConnectionState.Reconnecting;
    if (error2) {
      this._logger.log(LogLevel.Information, `Connection reconnecting because of error '${error2}'.`);
    } else {
      this._logger.log(LogLevel.Information, "Connection reconnecting.");
    }
    if (this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((c) => c.apply(this, [error2]));
      } catch (e) {
        this._logger.log(LogLevel.Error, `An onreconnecting callback called with error '${error2}' threw error '${e}'.`);
      }
      if (this._connectionState !== HubConnectionState.Reconnecting) {
        this._logger.log(LogLevel.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    while (nextRetryDelay !== null) {
      this._logger.log(LogLevel.Information, `Reconnect attempt number ${previousReconnectAttempts} will start in ${nextRetryDelay} ms.`);
      await new Promise((resolve) => {
        this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
      });
      this._reconnectDelayHandle = void 0;
      if (this._connectionState !== HubConnectionState.Reconnecting) {
        this._logger.log(LogLevel.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        await this._startInternal();
        this._connectionState = HubConnectionState.Connected;
        this._logger.log(LogLevel.Information, "HubConnection reconnected successfully.");
        if (this._reconnectedCallbacks.length !== 0) {
          try {
            this._reconnectedCallbacks.forEach((c) => c.apply(this, [this.connection.connectionId]));
          } catch (e) {
            this._logger.log(LogLevel.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
          }
        }
        return;
      } catch (e) {
        this._logger.log(LogLevel.Information, `Reconnect attempt failed because of error '${e}'.`);
        if (this._connectionState !== HubConnectionState.Reconnecting) {
          this._logger.log(LogLevel.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
          if (this._connectionState === HubConnectionState.Disconnecting) {
            this._completeClose();
          }
          return;
        }
        retryError = e instanceof Error ? e : new Error(e.toString());
        nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
      }
    }
    this._logger.log(LogLevel.Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
    this._completeClose();
  }
  _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds,
        previousRetryCount,
        retryReason
      });
    } catch (e) {
      this._logger.log(LogLevel.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
      return null;
    }
  }
  _cancelCallbacksWithError(error2) {
    const callbacks = this._callbacks;
    this._callbacks = {};
    Object.keys(callbacks).forEach((key) => {
      const callback = callbacks[key];
      try {
        callback(null, error2);
      } catch (e) {
        this._logger.log(LogLevel.Error, `Stream 'error' callback called with '${error2}' threw error: ${getErrorString(e)}`);
      }
    });
  }
  _cleanupPingTimer() {
    if (this._pingServerHandle) {
      clearTimeout(this._pingServerHandle);
      this._pingServerHandle = void 0;
    }
  }
  _cleanupTimeout() {
    if (this._timeoutHandle) {
      clearTimeout(this._timeoutHandle);
    }
  }
  _createInvocation(methodName, args, nonblocking, streamIds) {
    if (nonblocking) {
      if (streamIds.length !== 0) {
        return {
          arguments: args,
          streamIds,
          target: methodName,
          type: MessageType.Invocation
        };
      } else {
        return {
          arguments: args,
          target: methodName,
          type: MessageType.Invocation
        };
      }
    } else {
      const invocationId = this._invocationId;
      this._invocationId++;
      if (streamIds.length !== 0) {
        return {
          arguments: args,
          invocationId: invocationId.toString(),
          streamIds,
          target: methodName,
          type: MessageType.Invocation
        };
      } else {
        return {
          arguments: args,
          invocationId: invocationId.toString(),
          target: methodName,
          type: MessageType.Invocation
        };
      }
    }
  }
  _launchStreams(streams, promiseQueue) {
    if (streams.length === 0) {
      return;
    }
    if (!promiseQueue) {
      promiseQueue = Promise.resolve();
    }
    for (const streamId in streams) {
      streams[streamId].subscribe({
        complete: () => {
          promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createCompletionMessage(streamId)));
        },
        error: (err) => {
          let message2;
          if (err instanceof Error) {
            message2 = err.message;
          } else if (err && err.toString) {
            message2 = err.toString();
          } else {
            message2 = "Unknown error";
          }
          promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createCompletionMessage(streamId, message2)));
        },
        next: (item2) => {
          promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createStreamItemMessage(streamId, item2)));
        }
      });
    }
  }
  _replaceStreamingParams(args) {
    const streams = [];
    const streamIds = [];
    for (let i = 0; i < args.length; i++) {
      const argument = args[i];
      if (this._isObservable(argument)) {
        const streamId = this._invocationId;
        this._invocationId++;
        streams[streamId] = argument;
        streamIds.push(streamId.toString());
        args.splice(i, 1);
      }
    }
    return [streams, streamIds];
  }
  _isObservable(arg) {
    return arg && arg.subscribe && typeof arg.subscribe === "function";
  }
  _createStreamInvocation(methodName, args, streamIds) {
    const invocationId = this._invocationId;
    this._invocationId++;
    if (streamIds.length !== 0) {
      return {
        arguments: args,
        invocationId: invocationId.toString(),
        streamIds,
        target: methodName,
        type: MessageType.StreamInvocation
      };
    } else {
      return {
        arguments: args,
        invocationId: invocationId.toString(),
        target: methodName,
        type: MessageType.StreamInvocation
      };
    }
  }
  _createCancelInvocation(id2) {
    return {
      invocationId: id2,
      type: MessageType.CancelInvocation
    };
  }
  _createStreamItemMessage(id2, item2) {
    return {
      invocationId: id2,
      item: item2,
      type: MessageType.StreamItem
    };
  }
  _createCompletionMessage(id2, error2, result) {
    if (error2) {
      return {
        error: error2,
        invocationId: id2,
        type: MessageType.Completion
      };
    }
    return {
      invocationId: id2,
      result,
      type: MessageType.Completion
    };
  }
}
const DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2e3, 1e4, 3e4, null];
class DefaultReconnectPolicy {
  constructor(retryDelays) {
    this._retryDelays = retryDelays !== void 0 ? [...retryDelays, null] : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
  }
  nextRetryDelayInMilliseconds(retryContext) {
    return this._retryDelays[retryContext.previousRetryCount];
  }
}
class HeaderNames {
}
HeaderNames.Authorization = "Authorization";
HeaderNames.Cookie = "Cookie";
var HttpTransportType;
(function(HttpTransportType2) {
  HttpTransportType2[HttpTransportType2["None"] = 0] = "None";
  HttpTransportType2[HttpTransportType2["WebSockets"] = 1] = "WebSockets";
  HttpTransportType2[HttpTransportType2["ServerSentEvents"] = 2] = "ServerSentEvents";
  HttpTransportType2[HttpTransportType2["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType || (HttpTransportType = {}));
var TransferFormat;
(function(TransferFormat2) {
  TransferFormat2[TransferFormat2["Text"] = 1] = "Text";
  TransferFormat2[TransferFormat2["Binary"] = 2] = "Binary";
})(TransferFormat || (TransferFormat = {}));
let AbortController$1 = class AbortController2 {
  constructor() {
    this._isAborted = false;
    this.onabort = null;
  }
  abort() {
    if (!this._isAborted) {
      this._isAborted = true;
      if (this.onabort) {
        this.onabort();
      }
    }
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
};
class LongPollingTransport {
  constructor(httpClient, accessTokenFactory, logger, options) {
    this._httpClient = httpClient;
    this._accessTokenFactory = accessTokenFactory;
    this._logger = logger;
    this._pollAbort = new AbortController$1();
    this._options = options;
    this._running = false;
    this.onreceive = null;
    this.onclose = null;
  }
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  async connect(url2, transferFormat) {
    Arg.isRequired(url2, "url");
    Arg.isRequired(transferFormat, "transferFormat");
    Arg.isIn(transferFormat, TransferFormat, "transferFormat");
    this._url = url2;
    this._logger.log(LogLevel.Trace, "(LongPolling transport) Connecting.");
    if (transferFormat === TransferFormat.Binary && (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    }
    const [name, value] = getUserAgentHeader();
    const headers = { [name]: value, ...this._options.headers };
    const pollOptions = {
      abortSignal: this._pollAbort.signal,
      headers,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    if (transferFormat === TransferFormat.Binary) {
      pollOptions.responseType = "arraybuffer";
    }
    const token2 = await this._getAccessToken();
    this._updateHeaderToken(pollOptions, token2);
    const pollUrl = `${url2}&_=${Date.now()}`;
    this._logger.log(LogLevel.Trace, `(LongPolling transport) polling: ${pollUrl}.`);
    const response = await this._httpClient.get(pollUrl, pollOptions);
    if (response.statusCode !== 200) {
      this._logger.log(LogLevel.Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
      this._closeError = new HttpError(response.statusText || "", response.statusCode);
      this._running = false;
    } else {
      this._running = true;
    }
    this._receiving = this._poll(this._url, pollOptions);
  }
  async _getAccessToken() {
    if (this._accessTokenFactory) {
      return await this._accessTokenFactory();
    }
    return null;
  }
  _updateHeaderToken(request2, token2) {
    if (!request2.headers) {
      request2.headers = {};
    }
    if (token2) {
      request2.headers[HeaderNames.Authorization] = `Bearer ${token2}`;
      return;
    }
    if (request2.headers[HeaderNames.Authorization]) {
      delete request2.headers[HeaderNames.Authorization];
    }
  }
  async _poll(url2, pollOptions) {
    try {
      while (this._running) {
        const token2 = await this._getAccessToken();
        this._updateHeaderToken(pollOptions, token2);
        try {
          const pollUrl = `${url2}&_=${Date.now()}`;
          this._logger.log(LogLevel.Trace, `(LongPolling transport) polling: ${pollUrl}.`);
          const response = await this._httpClient.get(pollUrl, pollOptions);
          if (response.statusCode === 204) {
            this._logger.log(LogLevel.Information, "(LongPolling transport) Poll terminated by server.");
            this._running = false;
          } else if (response.statusCode !== 200) {
            this._logger.log(LogLevel.Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            this._closeError = new HttpError(response.statusText || "", response.statusCode);
            this._running = false;
          } else {
            if (response.content) {
              this._logger.log(LogLevel.Trace, `(LongPolling transport) data received. ${getDataDetail(response.content, this._options.logMessageContent)}.`);
              if (this.onreceive) {
                this.onreceive(response.content);
              }
            } else {
              this._logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
            }
          }
        } catch (e) {
          if (!this._running) {
            this._logger.log(LogLevel.Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
          } else {
            if (e instanceof TimeoutError) {
              this._logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
            } else {
              this._closeError = e;
              this._running = false;
            }
          }
        }
      }
    } finally {
      this._logger.log(LogLevel.Trace, "(LongPolling transport) Polling complete.");
      if (!this.pollAborted) {
        this._raiseOnClose();
      }
    }
  }
  async send(data2) {
    if (!this._running) {
      return Promise.reject(new Error("Cannot send until the transport is connected"));
    }
    return sendMessage(this._logger, "LongPolling", this._httpClient, this._url, this._accessTokenFactory, data2, this._options);
  }
  async stop() {
    this._logger.log(LogLevel.Trace, "(LongPolling transport) Stopping polling.");
    this._running = false;
    this._pollAbort.abort();
    try {
      await this._receiving;
      this._logger.log(LogLevel.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const headers = {};
      const [name, value] = getUserAgentHeader();
      headers[name] = value;
      const deleteOptions = {
        headers: { ...headers, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      const token2 = await this._getAccessToken();
      this._updateHeaderToken(deleteOptions, token2);
      await this._httpClient.delete(this._url, deleteOptions);
      this._logger.log(LogLevel.Trace, "(LongPolling transport) DELETE request sent.");
    } finally {
      this._logger.log(LogLevel.Trace, "(LongPolling transport) Stop finished.");
      this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let logMessage = "(LongPolling transport) Firing onclose event.";
      if (this._closeError) {
        logMessage += " Error: " + this._closeError;
      }
      this._logger.log(LogLevel.Trace, logMessage);
      this.onclose(this._closeError);
    }
  }
}
class ServerSentEventsTransport {
  constructor(httpClient, accessTokenFactory, logger, options) {
    this._httpClient = httpClient;
    this._accessTokenFactory = accessTokenFactory;
    this._logger = logger;
    this._options = options;
    this.onreceive = null;
    this.onclose = null;
  }
  async connect(url2, transferFormat) {
    Arg.isRequired(url2, "url");
    Arg.isRequired(transferFormat, "transferFormat");
    Arg.isIn(transferFormat, TransferFormat, "transferFormat");
    this._logger.log(LogLevel.Trace, "(SSE transport) Connecting.");
    this._url = url2;
    if (this._accessTokenFactory) {
      const token2 = await this._accessTokenFactory();
      if (token2) {
        url2 += (url2.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token2)}`;
      }
    }
    return new Promise((resolve, reject) => {
      let opened = false;
      if (transferFormat !== TransferFormat.Text) {
        reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let eventSource;
      if (Platform.isBrowser || Platform.isWebWorker) {
        eventSource = new this._options.EventSource(url2, { withCredentials: this._options.withCredentials });
      } else {
        const cookies2 = this._httpClient.getCookieString(url2);
        const headers = {};
        headers.Cookie = cookies2;
        const [name, value] = getUserAgentHeader();
        headers[name] = value;
        eventSource = new this._options.EventSource(url2, { withCredentials: this._options.withCredentials, headers: { ...headers, ...this._options.headers } });
      }
      try {
        eventSource.onmessage = (e) => {
          if (this.onreceive) {
            try {
              this._logger.log(LogLevel.Trace, `(SSE transport) data received. ${getDataDetail(e.data, this._options.logMessageContent)}.`);
              this.onreceive(e.data);
            } catch (error2) {
              this._close(error2);
              return;
            }
          }
        };
        eventSource.onerror = (e) => {
          if (opened) {
            this._close();
          } else {
            reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
          }
        };
        eventSource.onopen = () => {
          this._logger.log(LogLevel.Information, `SSE connected to ${this._url}`);
          this._eventSource = eventSource;
          opened = true;
          resolve();
        };
      } catch (e) {
        reject(e);
        return;
      }
    });
  }
  async send(data2) {
    if (!this._eventSource) {
      return Promise.reject(new Error("Cannot send until the transport is connected"));
    }
    return sendMessage(this._logger, "SSE", this._httpClient, this._url, this._accessTokenFactory, data2, this._options);
  }
  stop() {
    this._close();
    return Promise.resolve();
  }
  _close(e) {
    if (this._eventSource) {
      this._eventSource.close();
      this._eventSource = void 0;
      if (this.onclose) {
        this.onclose(e);
      }
    }
  }
}
class WebSocketTransport {
  constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers) {
    this._logger = logger;
    this._accessTokenFactory = accessTokenFactory;
    this._logMessageContent = logMessageContent;
    this._webSocketConstructor = webSocketConstructor;
    this._httpClient = httpClient;
    this.onreceive = null;
    this.onclose = null;
    this._headers = headers;
  }
  async connect(url2, transferFormat) {
    Arg.isRequired(url2, "url");
    Arg.isRequired(transferFormat, "transferFormat");
    Arg.isIn(transferFormat, TransferFormat, "transferFormat");
    this._logger.log(LogLevel.Trace, "(WebSockets transport) Connecting.");
    if (this._accessTokenFactory) {
      const token2 = await this._accessTokenFactory();
      if (token2) {
        url2 += (url2.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token2)}`;
      }
    }
    return new Promise((resolve, reject) => {
      url2 = url2.replace(/^http/, "ws");
      let webSocket;
      const cookies2 = this._httpClient.getCookieString(url2);
      let opened = false;
      if (Platform.isNode) {
        const headers = {};
        const [name, value] = getUserAgentHeader();
        headers[name] = value;
        if (cookies2) {
          headers[HeaderNames.Cookie] = `${cookies2}`;
        }
        webSocket = new this._webSocketConstructor(url2, void 0, {
          headers: { ...headers, ...this._headers }
        });
      }
      if (!webSocket) {
        webSocket = new this._webSocketConstructor(url2);
      }
      if (transferFormat === TransferFormat.Binary) {
        webSocket.binaryType = "arraybuffer";
      }
      webSocket.onopen = (_event) => {
        this._logger.log(LogLevel.Information, `WebSocket connected to ${url2}.`);
        this._webSocket = webSocket;
        opened = true;
        resolve();
      };
      webSocket.onerror = (event) => {
        let error2 = null;
        if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
          error2 = event.error;
        } else {
          error2 = "There was an error with the transport";
        }
        this._logger.log(LogLevel.Information, `(WebSockets transport) ${error2}.`);
      };
      webSocket.onmessage = (message2) => {
        this._logger.log(LogLevel.Trace, `(WebSockets transport) data received. ${getDataDetail(message2.data, this._logMessageContent)}.`);
        if (this.onreceive) {
          try {
            this.onreceive(message2.data);
          } catch (error2) {
            this._close(error2);
            return;
          }
        }
      };
      webSocket.onclose = (event) => {
        if (opened) {
          this._close(event);
        } else {
          let error2 = null;
          if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
            error2 = event.error;
          } else {
            error2 = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
          }
          reject(new Error(error2));
        }
      };
    });
  }
  send(data2) {
    if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
      this._logger.log(LogLevel.Trace, `(WebSockets transport) sending data. ${getDataDetail(data2, this._logMessageContent)}.`);
      this._webSocket.send(data2);
      return Promise.resolve();
    }
    return Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    if (this._webSocket) {
      this._close(void 0);
    }
    return Promise.resolve();
  }
  _close(event) {
    if (this._webSocket) {
      this._webSocket.onclose = () => {
      };
      this._webSocket.onmessage = () => {
      };
      this._webSocket.onerror = () => {
      };
      this._webSocket.close();
      this._webSocket = void 0;
    }
    this._logger.log(LogLevel.Trace, "(WebSockets transport) socket closed.");
    if (this.onclose) {
      if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1e3)) {
        this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
      } else if (event instanceof Error) {
        this.onclose(event);
      } else {
        this.onclose();
      }
    }
  }
  _isCloseEvent(event) {
    return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
  }
}
const MAX_REDIRECTS = 100;
class HttpConnection {
  constructor(url2, options = {}) {
    this._stopPromiseResolver = () => {
    };
    this.features = {};
    this._negotiateVersion = 1;
    Arg.isRequired(url2, "url");
    this._logger = createLogger(options.logger);
    this.baseUrl = this._resolveUrl(url2);
    options = options || {};
    options.logMessageContent = options.logMessageContent === void 0 ? false : options.logMessageContent;
    if (typeof options.withCredentials === "boolean" || options.withCredentials === void 0) {
      options.withCredentials = options.withCredentials === void 0 ? true : options.withCredentials;
    } else {
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    }
    options.timeout = options.timeout === void 0 ? 100 * 1e3 : options.timeout;
    let webSocketModule = null;
    let eventSourceModule = null;
    if (Platform.isNode && typeof require !== "undefined") {
      const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
      webSocketModule = requireFunc("ws");
      eventSourceModule = requireFunc("eventsource");
    }
    if (!Platform.isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
      options.WebSocket = WebSocket;
    } else if (Platform.isNode && !options.WebSocket) {
      if (webSocketModule) {
        options.WebSocket = webSocketModule;
      }
    }
    if (!Platform.isNode && typeof EventSource !== "undefined" && !options.EventSource) {
      options.EventSource = EventSource;
    } else if (Platform.isNode && !options.EventSource) {
      if (typeof eventSourceModule !== "undefined") {
        options.EventSource = eventSourceModule;
      }
    }
    this._httpClient = options.httpClient || new DefaultHttpClient(this._logger);
    this._connectionState = "Disconnected";
    this._connectionStarted = false;
    this._options = options;
    this.onreceive = null;
    this.onclose = null;
  }
  async start(transferFormat) {
    transferFormat = transferFormat || TransferFormat.Binary;
    Arg.isIn(transferFormat, TransferFormat, "transferFormat");
    this._logger.log(LogLevel.Debug, `Starting connection with transfer format '${TransferFormat[transferFormat]}'.`);
    if (this._connectionState !== "Disconnected") {
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    }
    this._connectionState = "Connecting";
    this._startInternalPromise = this._startInternal(transferFormat);
    await this._startInternalPromise;
    if (this._connectionState === "Disconnecting") {
      const message2 = "Failed to start the HttpConnection before stop() was called.";
      this._logger.log(LogLevel.Error, message2);
      await this._stopPromise;
      return Promise.reject(new Error(message2));
    } else if (this._connectionState !== "Connected") {
      const message2 = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      this._logger.log(LogLevel.Error, message2);
      return Promise.reject(new Error(message2));
    }
    this._connectionStarted = true;
  }
  send(data2) {
    if (this._connectionState !== "Connected") {
      return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
    }
    if (!this._sendQueue) {
      this._sendQueue = new TransportSendQueue(this.transport);
    }
    return this._sendQueue.send(data2);
  }
  async stop(error2) {
    if (this._connectionState === "Disconnected") {
      this._logger.log(LogLevel.Debug, `Call to HttpConnection.stop(${error2}) ignored because the connection is already in the disconnected state.`);
      return Promise.resolve();
    }
    if (this._connectionState === "Disconnecting") {
      this._logger.log(LogLevel.Debug, `Call to HttpConnection.stop(${error2}) ignored because the connection is already in the disconnecting state.`);
      return this._stopPromise;
    }
    this._connectionState = "Disconnecting";
    this._stopPromise = new Promise((resolve) => {
      this._stopPromiseResolver = resolve;
    });
    await this._stopInternal(error2);
    await this._stopPromise;
  }
  async _stopInternal(error2) {
    this._stopError = error2;
    try {
      await this._startInternalPromise;
    } catch (e) {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (e) {
        this._logger.log(LogLevel.Error, `HttpConnection.transport.stop() threw error '${e}'.`);
        this._stopConnection();
      }
      this.transport = void 0;
    } else {
      this._logger.log(LogLevel.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
  }
  async _startInternal(transferFormat) {
    let url2 = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory;
    try {
      if (this._options.skipNegotiation) {
        if (this._options.transport === HttpTransportType.WebSockets) {
          this.transport = this._constructTransport(HttpTransportType.WebSockets);
          await this._startTransport(url2, transferFormat);
        } else {
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
        }
      } else {
        let negotiateResponse = null;
        let redirects = 0;
        do {
          negotiateResponse = await this._getNegotiationResponse(url2);
          if (this._connectionState === "Disconnecting" || this._connectionState === "Disconnected") {
            throw new Error("The connection was stopped during negotiation.");
          }
          if (negotiateResponse.error) {
            throw new Error(negotiateResponse.error);
          }
          if (negotiateResponse.ProtocolVersion) {
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          }
          if (negotiateResponse.url) {
            url2 = negotiateResponse.url;
          }
          if (negotiateResponse.accessToken) {
            const accessToken = negotiateResponse.accessToken;
            this._accessTokenFactory = () => accessToken;
          }
          redirects++;
        } while (negotiateResponse.url && redirects < MAX_REDIRECTS);
        if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
          throw new Error("Negotiate redirection limit exceeded.");
        }
        await this._createTransport(url2, this._options.transport, negotiateResponse, transferFormat);
      }
      if (this.transport instanceof LongPollingTransport) {
        this.features.inherentKeepAlive = true;
      }
      if (this._connectionState === "Connecting") {
        this._logger.log(LogLevel.Debug, "The HttpConnection connected successfully.");
        this._connectionState = "Connected";
      }
    } catch (e) {
      this._logger.log(LogLevel.Error, "Failed to start the connection: " + e);
      this._connectionState = "Disconnected";
      this.transport = void 0;
      this._stopPromiseResolver();
      return Promise.reject(e);
    }
  }
  async _getNegotiationResponse(url2) {
    const headers = {};
    if (this._accessTokenFactory) {
      const token2 = await this._accessTokenFactory();
      if (token2) {
        headers[HeaderNames.Authorization] = `Bearer ${token2}`;
      }
    }
    const [name, value] = getUserAgentHeader();
    headers[name] = value;
    const negotiateUrl = this._resolveNegotiateUrl(url2);
    this._logger.log(LogLevel.Debug, `Sending negotiation request: ${negotiateUrl}.`);
    try {
      const response = await this._httpClient.post(negotiateUrl, {
        content: "",
        headers: { ...headers, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (response.statusCode !== 200) {
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
      }
      const negotiateResponse = JSON.parse(response.content);
      if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
        negotiateResponse.connectionToken = negotiateResponse.connectionId;
      }
      return negotiateResponse;
    } catch (e) {
      let errorMessage = "Failed to complete negotiation with the server: " + e;
      if (e instanceof HttpError) {
        if (e.statusCode === 404) {
          errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
        }
      }
      this._logger.log(LogLevel.Error, errorMessage);
      return Promise.reject(new FailedToNegotiateWithServerError(errorMessage));
    }
  }
  _createConnectUrl(url2, connectionToken) {
    if (!connectionToken) {
      return url2;
    }
    return url2 + (url2.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
  }
  async _createTransport(url2, requestedTransport, negotiateResponse, requestedTransferFormat) {
    let connectUrl = this._createConnectUrl(url2, negotiateResponse.connectionToken);
    if (this._isITransport(requestedTransport)) {
      this._logger.log(LogLevel.Debug, "Connection was provided an instance of ITransport, using that directly.");
      this.transport = requestedTransport;
      await this._startTransport(connectUrl, requestedTransferFormat);
      this.connectionId = negotiateResponse.connectionId;
      return;
    }
    const transportExceptions = [];
    const transports = negotiateResponse.availableTransports || [];
    let negotiate = negotiateResponse;
    for (const endpoint of transports) {
      const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
      if (transportOrError instanceof Error) {
        transportExceptions.push(`${endpoint.transport} failed:`);
        transportExceptions.push(transportOrError);
      } else if (this._isITransport(transportOrError)) {
        this.transport = transportOrError;
        if (!negotiate) {
          try {
            negotiate = await this._getNegotiationResponse(url2);
          } catch (ex) {
            return Promise.reject(ex);
          }
          connectUrl = this._createConnectUrl(url2, negotiate.connectionToken);
        }
        try {
          await this._startTransport(connectUrl, requestedTransferFormat);
          this.connectionId = negotiate.connectionId;
          return;
        } catch (ex) {
          this._logger.log(LogLevel.Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
          negotiate = void 0;
          transportExceptions.push(new FailedToStartTransportError(`${endpoint.transport} failed: ${ex}`, HttpTransportType[endpoint.transport]));
          if (this._connectionState !== "Connecting") {
            const message2 = "Failed to select transport before stop() was called.";
            this._logger.log(LogLevel.Debug, message2);
            return Promise.reject(new Error(message2));
          }
        }
      }
    }
    if (transportExceptions.length > 0) {
      return Promise.reject(new AggregateErrors(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
    }
    return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(transport) {
    switch (transport) {
      case HttpTransportType.WebSockets:
        if (!this._options.WebSocket) {
          throw new Error("'WebSocket' is not supported in your environment.");
        }
        return new WebSocketTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case HttpTransportType.ServerSentEvents:
        if (!this._options.EventSource) {
          throw new Error("'EventSource' is not supported in your environment.");
        }
        return new ServerSentEventsTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options);
      case HttpTransportType.LongPolling:
        return new LongPollingTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${transport}.`);
    }
  }
  _startTransport(url2, transferFormat) {
    this.transport.onreceive = this.onreceive;
    this.transport.onclose = (e) => this._stopConnection(e);
    return this.transport.connect(url2, transferFormat);
  }
  _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat) {
    const transport = HttpTransportType[endpoint.transport];
    if (transport === null || transport === void 0) {
      this._logger.log(LogLevel.Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
      return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
    } else {
      if (transportMatches(requestedTransport, transport)) {
        const transferFormats = endpoint.transferFormats.map((s) => TransferFormat[s]);
        if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
          if (transport === HttpTransportType.WebSockets && !this._options.WebSocket || transport === HttpTransportType.ServerSentEvents && !this._options.EventSource) {
            this._logger.log(LogLevel.Debug, `Skipping transport '${HttpTransportType[transport]}' because it is not supported in your environment.'`);
            return new UnsupportedTransportError(`'${HttpTransportType[transport]}' is not supported in your environment.`, transport);
          } else {
            this._logger.log(LogLevel.Debug, `Selecting transport '${HttpTransportType[transport]}'.`);
            try {
              return this._constructTransport(transport);
            } catch (ex) {
              return ex;
            }
          }
        } else {
          this._logger.log(LogLevel.Debug, `Skipping transport '${HttpTransportType[transport]}' because it does not support the requested transfer format '${TransferFormat[requestedTransferFormat]}'.`);
          return new Error(`'${HttpTransportType[transport]}' does not support ${TransferFormat[requestedTransferFormat]}.`);
        }
      } else {
        this._logger.log(LogLevel.Debug, `Skipping transport '${HttpTransportType[transport]}' because it was disabled by the client.`);
        return new DisabledTransportError(`'${HttpTransportType[transport]}' is disabled by the client.`, transport);
      }
    }
  }
  _isITransport(transport) {
    return transport && typeof transport === "object" && "connect" in transport;
  }
  _stopConnection(error2) {
    this._logger.log(LogLevel.Debug, `HttpConnection.stopConnection(${error2}) called while in state ${this._connectionState}.`);
    this.transport = void 0;
    error2 = this._stopError || error2;
    this._stopError = void 0;
    if (this._connectionState === "Disconnected") {
      this._logger.log(LogLevel.Debug, `Call to HttpConnection.stopConnection(${error2}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting") {
      this._logger.log(LogLevel.Warning, `Call to HttpConnection.stopConnection(${error2}) was ignored because the connection is still in the connecting state.`);
      throw new Error(`HttpConnection.stopConnection(${error2}) was called while the connection is still in the connecting state.`);
    }
    if (this._connectionState === "Disconnecting") {
      this._stopPromiseResolver();
    }
    if (error2) {
      this._logger.log(LogLevel.Error, `Connection disconnected with error '${error2}'.`);
    } else {
      this._logger.log(LogLevel.Information, "Connection disconnected.");
    }
    if (this._sendQueue) {
      this._sendQueue.stop().catch((e) => {
        this._logger.log(LogLevel.Error, `TransportSendQueue.stop() threw error '${e}'.`);
      });
      this._sendQueue = void 0;
    }
    this.connectionId = void 0;
    this._connectionState = "Disconnected";
    if (this._connectionStarted) {
      this._connectionStarted = false;
      try {
        if (this.onclose) {
          this.onclose(error2);
        }
      } catch (e) {
        this._logger.log(LogLevel.Error, `HttpConnection.onclose(${error2}) threw error '${e}'.`);
      }
    }
  }
  _resolveUrl(url2) {
    if (url2.lastIndexOf("https://", 0) === 0 || url2.lastIndexOf("http://", 0) === 0) {
      return url2;
    }
    if (!Platform.isBrowser) {
      throw new Error(`Cannot resolve '${url2}'.`);
    }
    const aTag = window.document.createElement("a");
    aTag.href = url2;
    this._logger.log(LogLevel.Information, `Normalizing '${url2}' to '${aTag.href}'.`);
    return aTag.href;
  }
  _resolveNegotiateUrl(url2) {
    const index2 = url2.indexOf("?");
    let negotiateUrl = url2.substring(0, index2 === -1 ? url2.length : index2);
    if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
      negotiateUrl += "/";
    }
    negotiateUrl += "negotiate";
    negotiateUrl += index2 === -1 ? "" : url2.substring(index2);
    if (negotiateUrl.indexOf("negotiateVersion") === -1) {
      negotiateUrl += index2 === -1 ? "?" : "&";
      negotiateUrl += "negotiateVersion=" + this._negotiateVersion;
    }
    return negotiateUrl;
  }
}
function transportMatches(requestedTransport, actualTransport) {
  return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class TransportSendQueue {
  constructor(_transport) {
    this._transport = _transport;
    this._buffer = [];
    this._executing = true;
    this._sendBufferedData = new PromiseSource();
    this._transportResult = new PromiseSource();
    this._sendLoopPromise = this._sendLoop();
  }
  send(data2) {
    this._bufferData(data2);
    if (!this._transportResult) {
      this._transportResult = new PromiseSource();
    }
    return this._transportResult.promise;
  }
  stop() {
    this._executing = false;
    this._sendBufferedData.resolve();
    return this._sendLoopPromise;
  }
  _bufferData(data2) {
    if (this._buffer.length && typeof this._buffer[0] !== typeof data2) {
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data2}`);
    }
    this._buffer.push(data2);
    this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    while (true) {
      await this._sendBufferedData.promise;
      if (!this._executing) {
        if (this._transportResult) {
          this._transportResult.reject("Connection stopped.");
        }
        break;
      }
      this._sendBufferedData = new PromiseSource();
      const transportResult = this._transportResult;
      this._transportResult = void 0;
      const data2 = typeof this._buffer[0] === "string" ? this._buffer.join("") : TransportSendQueue._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(data2);
        transportResult.resolve();
      } catch (error2) {
        transportResult.reject(error2);
      }
    }
  }
  static _concatBuffers(arrayBuffers) {
    const totalLength = arrayBuffers.map((b) => b.byteLength).reduce((a, b) => a + b);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const item2 of arrayBuffers) {
      result.set(new Uint8Array(item2), offset);
      offset += item2.byteLength;
    }
    return result.buffer;
  }
}
class PromiseSource {
  constructor() {
    this.promise = new Promise((resolve, reject) => [this._resolver, this._rejecter] = [resolve, reject]);
  }
  resolve() {
    this._resolver();
  }
  reject(reason) {
    this._rejecter(reason);
  }
}
const JSON_HUB_PROTOCOL_NAME = "json";
class JsonHubProtocol {
  constructor() {
    this.name = JSON_HUB_PROTOCOL_NAME;
    this.version = 1;
    this.transferFormat = TransferFormat.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(input2, logger) {
    if (typeof input2 !== "string") {
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    }
    if (!input2) {
      return [];
    }
    if (logger === null) {
      logger = NullLogger.instance;
    }
    const messages2 = TextMessageFormat.parse(input2);
    const hubMessages = [];
    for (const message2 of messages2) {
      const parsedMessage = JSON.parse(message2);
      if (typeof parsedMessage.type !== "number") {
        throw new Error("Invalid payload.");
      }
      switch (parsedMessage.type) {
        case MessageType.Invocation:
          this._isInvocationMessage(parsedMessage);
          break;
        case MessageType.StreamItem:
          this._isStreamItemMessage(parsedMessage);
          break;
        case MessageType.Completion:
          this._isCompletionMessage(parsedMessage);
          break;
        case MessageType.Ping:
          break;
        case MessageType.Close:
          break;
        default:
          logger.log(LogLevel.Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
          continue;
      }
      hubMessages.push(parsedMessage);
    }
    return hubMessages;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(message2) {
    return TextMessageFormat.write(JSON.stringify(message2));
  }
  _isInvocationMessage(message2) {
    this._assertNotEmptyString(message2.target, "Invalid payload for Invocation message.");
    if (message2.invocationId !== void 0) {
      this._assertNotEmptyString(message2.invocationId, "Invalid payload for Invocation message.");
    }
  }
  _isStreamItemMessage(message2) {
    this._assertNotEmptyString(message2.invocationId, "Invalid payload for StreamItem message.");
    if (message2.item === void 0) {
      throw new Error("Invalid payload for StreamItem message.");
    }
  }
  _isCompletionMessage(message2) {
    if (message2.result && message2.error) {
      throw new Error("Invalid payload for Completion message.");
    }
    if (!message2.result && message2.error) {
      this._assertNotEmptyString(message2.error, "Invalid payload for Completion message.");
    }
    this._assertNotEmptyString(message2.invocationId, "Invalid payload for Completion message.");
  }
  _assertNotEmptyString(value, errorMessage) {
    if (typeof value !== "string" || value === "") {
      throw new Error(errorMessage);
    }
  }
}
const LogLevelNameMapping = {
  trace: LogLevel.Trace,
  debug: LogLevel.Debug,
  info: LogLevel.Information,
  information: LogLevel.Information,
  warn: LogLevel.Warning,
  warning: LogLevel.Warning,
  error: LogLevel.Error,
  critical: LogLevel.Critical,
  none: LogLevel.None
};
function parseLogLevel(name) {
  const mapping2 = LogLevelNameMapping[name.toLowerCase()];
  if (typeof mapping2 !== "undefined") {
    return mapping2;
  } else {
    throw new Error(`Unknown log level: ${name}`);
  }
}
class HubConnectionBuilder {
  configureLogging(logging) {
    Arg.isRequired(logging, "logging");
    if (isLogger(logging)) {
      this.logger = logging;
    } else if (typeof logging === "string") {
      const logLevel = parseLogLevel(logging);
      this.logger = new ConsoleLogger(logLevel);
    } else {
      this.logger = new ConsoleLogger(logging);
    }
    return this;
  }
  withUrl(url2, transportTypeOrOptions) {
    Arg.isRequired(url2, "url");
    Arg.isNotEmpty(url2, "url");
    this.url = url2;
    if (typeof transportTypeOrOptions === "object") {
      this.httpConnectionOptions = { ...this.httpConnectionOptions, ...transportTypeOrOptions };
    } else {
      this.httpConnectionOptions = {
        ...this.httpConnectionOptions,
        transport: transportTypeOrOptions
      };
    }
    return this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(protocol2) {
    Arg.isRequired(protocol2, "protocol");
    this.protocol = protocol2;
    return this;
  }
  withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
    if (this.reconnectPolicy) {
      throw new Error("A reconnectPolicy has already been set.");
    }
    if (!retryDelaysOrReconnectPolicy) {
      this.reconnectPolicy = new DefaultReconnectPolicy();
    } else if (Array.isArray(retryDelaysOrReconnectPolicy)) {
      this.reconnectPolicy = new DefaultReconnectPolicy(retryDelaysOrReconnectPolicy);
    } else {
      this.reconnectPolicy = retryDelaysOrReconnectPolicy;
    }
    return this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const httpConnectionOptions = this.httpConnectionOptions || {};
    if (httpConnectionOptions.logger === void 0) {
      httpConnectionOptions.logger = this.logger;
    }
    if (!this.url) {
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    }
    const connection = new HttpConnection(this.url, httpConnectionOptions);
    return HubConnection.create(connection, this.logger || NullLogger.instance, this.protocol || new JsonHubProtocol(), this.reconnectPolicy);
  }
}
function isLogger(logger) {
  return logger.log !== void 0;
}
class HubResponse {
  constructor(response = null, processPayload = (x) => x) {
    this.errors = [];
    this.body = null;
    this.resetToken = false;
    if (response == null || response.body == null && response.errors == null)
      return;
    this.errors = response.errors.map(ApiResponseError.fromJson);
    this.body = response.body;
    this.resetToken = response.resetToken;
    if (this.success && this.body)
      this.payload = processPayload(this.body);
  }
  get success() {
    return this.errors.length == 0 && this.body != null;
  }
  hasError(error2) {
    return this.errors.some((x) => x.code == error2);
  }
  getError(error2) {
    return this.errors.find((x) => x.code == error2);
  }
}
class BadHubResponse extends HubResponse {
  get success() {
    return false;
  }
  constructor() {
    super(null, () => null);
  }
}
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$g(target, key, result);
  return result;
};
class BaseHubClient extends Disposable {
  constructor(tokenStore, settings) {
    super();
    this.tokenStore = tokenStore;
    this.settings = settings;
    this.inited = false;
    this.connectionError = null;
    this.state = HubConnectionState.Disconnected;
    this.connectionId = null;
    this.connected = new TypedEvent();
    this.disconnected = new TypedEvent();
    this.reconnecting = new TypedEvent();
    this.connecting = new TypedEvent();
    this.unauthorized = new TypedEvent();
    this.tokenStore = tokenStore || inject(this, TokenStore);
    this.toDispose(reaction$1(() => this.state, (state) => {
      switch (state) {
        case HubConnectionState.Connected:
          this.connected.emit();
          break;
        case HubConnectionState.Disconnected:
          this.disconnected.emit();
          break;
        case HubConnectionState.Reconnecting:
          this.reconnecting.emit();
          if (this.connectionError?.message?.includes("401"))
            this.unauthorized.emit();
          break;
        case HubConnectionState.Connecting:
          this.connecting.emit();
          break;
      }
      this.connectionId = this.connection.connectionId;
    }));
    this.connection = new HubConnectionBuilder().withUrl(this.settings.host, {
      accessTokenFactory: () => this.tokenStore.accessToken,
      transport: HttpTransportType.WebSockets
    }).withAutomaticReconnect([2e3, 3e3, 5e3, 1e4, 6e4]).build();
    this.toDispose(() => this.connection.stop());
    this.init();
  }
  init() {
    if (this.inited)
      throw new Error("[HubClient] Already inited");
    this.connection.onclose((e) => {
      this.setState(HubConnectionState.Disconnected);
    });
    this.connection.onreconnecting((e) => {
      this.setState(HubConnectionState.Reconnecting);
    });
    this.connection.onreconnected((e) => {
      this.setState(HubConnectionState.Connected);
    });
    this.toDispose(reaction$1(() => this.tokenStore.accessToken, async (newValue, r2, oldValue) => {
      if (newValue != null) {
        if (newValue != oldValue) {
          await this.disconnect();
        }
        await this.connect();
      } else {
        await this.disconnect();
      }
    }, {
      fireImmediately: this.settings.autoConnect !== false
    }));
    this.inited = true;
  }
  async connect() {
    if (this.state == HubConnectionState.Connected)
      return;
    try {
      this.setState(HubConnectionState.Connecting);
      await this.connection.start();
      this.setState(HubConnectionState.Connected);
    } catch (e) {
      this.setState(HubConnectionState.Reconnecting, e);
      setTimeout(() => this.connect(), 5e3);
    }
  }
  async disconnect() {
    if (this.state == HubConnectionState.Disconnected)
      return;
    try {
      this.setState(HubConnectionState.Disconnecting);
      await this.connection.stop();
      this.setState(HubConnectionState.Disconnected);
    } catch (e) {
      this.setState(HubConnectionState.Disconnected);
    }
  }
  on(subscription, callback) {
    subscription.subscribe(this.connection, callback);
    console.logDev(`[HubClient] Subscribed '${subscription.method}'`, subscription);
    return subscription.unsubscription;
  }
  async invoke(request2) {
    let result = await this.safeInvoke(request2);
    if (!result.success && this.connection.state != HubConnectionState.Connected) {
      const waitResult = await this.waitForConnection();
      if (!waitResult)
        return result;
      return await this.safeInvoke(request2);
    }
    return result;
  }
  async safeInvoke(request2) {
    try {
      const res = await request2.invoke(this.connection);
      console.logDev(`[HubClient] HubResponse`, request2.url, request2.body, res);
      return res;
    } catch (e) {
      console.logDev(`[HubClient] BadHubResponse`, request2, e);
      return new BadHubResponse();
    }
  }
  async invokeWithResult(request2) {
    return await this.invoke(request2);
  }
  setState(value, error2 = null) {
    this.connectionError = error2;
    this.state = value;
  }
  /**
   * wait for reconnection or timeout
   * @param durationMs
   */
  waitForConnection() {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        disposer();
        resolve(false);
      }, this.settings.invokeTimeoutMs);
      const disposer = reaction$1(() => this.state, (state) => {
        if (state == HubConnectionState.Connected) {
          clearTimeout(timeout);
          disposer();
          resolve(true);
        }
      });
    });
  }
}
__decorateClass$i([
  observable
], BaseHubClient.prototype, "state", 2);
__decorateClass$i([
  observable
], BaseHubClient.prototype, "connectionId", 2);
__decorateClass$i([
  action
], BaseHubClient.prototype, "setState", 1);
class HubRequest {
  constructor() {
    this.body = [];
  }
  async invoke(connection) {
    this.connection = connection;
    return await this.connection.invoke(this.url, ...this.body);
  }
}
class HubRequestWithResponse extends HubRequest {
  async invoke(connection) {
    const response = await super.invoke(connection);
    return new HubResponse(response, this.processPayload);
  }
}
class HubCaller extends User {
  constructor(caller) {
    super();
    if (caller)
      this.update(caller);
  }
  static fromJson(json) {
    return new HubCaller({
      id: json.id,
      firstName: json.firstName,
      lastName: json.lastName,
      phone: json.phone,
      email: json.email,
      gender: json.gender,
      avatar: json.avatar ? AccelFile.fromJson(json.avatar) : void 0,
      birthday: json.birthday ? new Date(json.birthday) : void 0
    });
  }
}
class HubUnsubscription {
  constructor(subscription) {
    this.subscription = subscription;
    this.unsubscribed = false;
  }
  dispose() {
    if (this.unsubscribed)
      throw new Error("Already unsubscribed");
    this.subscription.connection.off(this.subscription.method, this.subscription.callback);
    this.unsubscribed = true;
    console.logDev(`[HubClient] Unsubscribed '${this.subscription.method}'`, this.subscription);
  }
}
class HubSubscription {
  constructor() {
    this.subscribed = false;
    this.processPayload = (json, caller) => json;
  }
  subscribe(connection, callback) {
    if (this.subscribed)
      throw new Error("Already subscribed");
    this.connection = connection;
    this.callback = (json) => {
      const caller = json.caller ? HubCaller.fromJson(json.caller) : null;
      try {
        const payload = this.processPayload(json.payload, caller);
        callback(payload, caller);
      } catch (e) {
        console.error(e);
      }
    };
    this.connection.on(this.method, this.callback);
    this.unsubscription = new HubUnsubscription(this);
    this.subscribed = true;
  }
  unsubscribe() {
    if (this.unsubscription == null)
      throw new Error("You must subscribe first");
    this.unsubscription.dispose();
  }
  _call(json) {
    if (!this.subscribed)
      throw new Error("You must subscribe first");
    this.callback(json);
  }
}
class HubClient extends BaseHubClient {
}
var ChatEventType = /* @__PURE__ */ ((ChatEventType2) => {
  ChatEventType2["ConversationCreated"] = "conversationCreated";
  ChatEventType2["ConversationUpdated"] = "conversationUpdated";
  ChatEventType2["ConversationDeleted"] = "conversationDeleted";
  ChatEventType2["ConversationSynced"] = "conversationSynced";
  ChatEventType2["MessageSent"] = "messageCreated";
  ChatEventType2["MessageUpdated"] = "messageUpdated";
  ChatEventType2["MessageDeleted"] = "messageDeleted";
  ChatEventType2["MemberAdded"] = "memberCreated";
  ChatEventType2["MemberDeleted"] = "memberDeleted";
  ChatEventType2["MemberUpdated"] = "memberUpdated";
  ChatEventType2["MemberTyping"] = "memberTyping";
  ChatEventType2["CounterIncreased"] = "counterIncreased";
  ChatEventType2["CounterDecreased"] = "counterDecreased";
  return ChatEventType2;
})(ChatEventType || {});
var ChannelType = /* @__PURE__ */ ((ChannelType2) => {
  ChannelType2["Accel"] = "accel";
  ChannelType2["VK"] = "vk";
  ChannelType2["Telegram"] = "tg";
  ChannelType2["Viber"] = "vb";
  ChannelType2["Facebook"] = "fb";
  ChannelType2["Instagram"] = "ig";
  ChannelType2["Wazzup24"] = "wazzup24";
  ChannelType2["WA"] = "wa";
  ChannelType2["Line"] = "line";
  return ChannelType2;
})(ChannelType || {});
var ChatMessageType = /* @__PURE__ */ ((ChatMessageType2) => {
  ChatMessageType2["Normal"] = "normal";
  ChatMessageType2["System"] = "system";
  ChatMessageType2["CallStarted"] = "callStarted";
  ChatMessageType2["CallCompleted"] = "callCompleted";
  ChatMessageType2["ButtonClicked"] = "buttonClicked";
  ChatMessageType2["Comment"] = "comment";
  ChatMessageType2["Voice"] = "voice";
  ChatMessageType2["Template"] = "template";
  return ChatMessageType2;
})(ChatMessageType || {});
class ChatMessageAttachment extends AccelFile {
  constructor(attach) {
    super();
    if (attach)
      this.update(attach);
  }
  get isReplyAttachment() {
    return this.channelType == ChatChannelType.Ig && (this.type == "pictureStoryReply" || this.type == "videoStoryReply" || this.type == "pictureStoryMention" || this.type == "videoStoryMention" || this.type == "pictureComment" || this.type == "videoComment" || this.type == "carouselAlbumComment");
  }
  update(attach) {
    super.update(attach);
  }
  static fromJson(json) {
    const base = AccelFile.fromJson(json);
    return new ChatMessageAttachment({
      ...base,
      channelType: json.channelType
    });
  }
}
class ChatMessageReaction extends Updatable {
  constructor(r2) {
    super();
    if (r2) this.update(r2);
  }
  update(msg) {
    super.update(msg);
  }
  static fromJson(json) {
    return new ChatMessageReaction({
      ...json,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0
    });
  }
}
class ChatMessageButton extends Updatable {
  constructor(btn2) {
    super();
    if (btn2) this.update(btn2);
  }
  update(msg) {
    super.update(msg);
  }
  static fromJson(json) {
    return new ChatMessageButton({
      ...json
    });
  }
}
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$f(target, key, result);
  return result;
};
const _ChatMessage = class _ChatMessage2 extends Entity$1 {
  constructor(msg) {
    super();
    if (msg)
      this.update(msg);
  }
  get hasButtons() {
    return this.buttons && this.buttons.length > 0;
  }
  get hasError() {
    return this.sentError || this.deletedError;
  }
  init(conversation2) {
    if (!this.author)
      this.author = conversation2.memberMap.get(this.authorId);
    if (this.reply && !this.reply.author)
      this.reply.author = conversation2.memberMap.get(this.reply.authorId);
    this.reactions.forEach((r2) => {
      if (!r2.member) r2.member = conversation2.memberMap.get(r2.chatMemberId);
    });
  }
  get voice() {
    return this.type === ChatMessageType.Voice && this.attachments[0];
  }
  get replyAttachment() {
    return this.attachments.find((x) => x.isReplyAttachment);
  }
  get downloadableAttachments() {
    const attachments = this.type == ChatMessageType.Voice ? this.attachments.slice(1) : this.attachments;
    return attachments.filter((x) => !x.isReplyAttachment);
  }
  get hasText() {
    return !isEmpty(this.text);
  }
  get isMessageFromSystemMember() {
    return this.author?.isSystem ?? false;
  }
  update(msg) {
    super.update(msg);
  }
  static fromJson(json) {
    return new _ChatMessage2({
      id: json.id,
      index: json.index,
      text: json.text,
      plainText: json.plainText,
      authorId: json.authorId,
      author: json.author ? ChatMember.fromJson(json.author) : void 0,
      reply: json.reply ? _ChatMessage2.fromJson(json.reply) : null,
      createdDate: moment(json.createdDate),
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      type: json.type,
      attachments: json.attachments ? json.attachments.map(ChatMessageAttachment.fromJson) : [],
      isDraft: json.isDraft,
      softDeleted: json.softDeleted,
      location: json.location,
      hasAttachments: json.hasAttachments,
      hasLocation: json.hasLocation,
      callDuration: json.callDurationInSec ? TimeSpan.fromSeconds(json.callDurationInSec) : void 0,
      sent: json.sent,
      sentError: json.sentError,
      sentErrorMessage: json.sentErrorMessage,
      deleting: json.deleting,
      deleted: json.deleted,
      deletedError: json.deletedError,
      deletedErrorMessage: json.deletedErrorMessage,
      hasReactions: json.hasReactions,
      renderMethod: json.renderMethod,
      reactions: json.reactions ? json.reactions.map(ChatMessageReaction.fromJson) : [],
      buttons: json.buttons ? json.buttons.map(ChatMessageButton.fromJson) : [],
      template: json.template
    });
  }
};
__decorateClass$h([
  observable
], _ChatMessage.prototype, "hasReactions", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "reactions", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "buttons", 2);
__decorateClass$h([
  computed
], _ChatMessage.prototype, "hasButtons", 1);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "sent", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "sentError", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "sentErrorMessage", 2);
__decorateClass$h([
  computed
], _ChatMessage.prototype, "hasError", 1);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "deleting", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "deleted", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "deletedError", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "deletedErrorMessage", 2);
__decorateClass$h([
  observable
], _ChatMessage.prototype, "renderMethod", 2);
__decorateClass$h([
  computed
], _ChatMessage.prototype, "voice", 1);
__decorateClass$h([
  computed
], _ChatMessage.prototype, "replyAttachment", 1);
__decorateClass$h([
  computed
], _ChatMessage.prototype, "downloadableAttachments", 1);
let ChatMessage = _ChatMessage;
class ChatMessageFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$e(target, key, result);
  return result;
};
const _ChatMember = class _ChatMember2 extends User {
  constructor(member) {
    super();
    if (member)
      this.update(member);
  }
  get canCall() {
    return !isEmpty(this.internalNumber);
  }
  update(member) {
    super.update(member);
  }
  static fromJson(json) {
    return new _ChatMember2({
      id: json.id,
      userId: json.userId,
      studentId: json.studentId,
      adminId: json.adminId,
      firstName: json.firstName,
      lastName: json.lastName,
      middleName: json.middleName,
      email: json.email,
      phone: json.phone,
      userName: json.userName,
      gender: json.gender,
      birthday: json.birthday ? new Date(json.birthday) : void 0,
      avatar: json.avatar ? AccelFile.fromJson(json.avatar) : null,
      lastActivityDate: json.lastActivityDate ? moment(json.lastActivityDate) : void 0,
      onlineStatus: json.onlineStatus,
      isActive: json.isActive,
      createdDate: json.createdDate ? moment(json.createdDate) : void 0,
      updatedDate: json.updatedDate ? moment(json.updatedDate) : void 0,
      syncedDate: json.syncedDate ? moment(json.syncedDate) : void 0,
      lastSeenMessageIndex: json.lastSeenMessageIndex,
      internalNumber: json.internalNumber,
      type: json.type,
      post: json.post,
      isSystem: json.isSystem
    });
  }
};
__decorateClass$g([
  observable
], _ChatMember.prototype, "lastActivityDate", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "onlineStatus", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "syncedDate", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "lastSeenMessageIndex", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "internalNumber", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "type", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "post", 2);
__decorateClass$g([
  observable
], _ChatMember.prototype, "userName", 2);
__decorateClass$g([
  computed
], _ChatMember.prototype, "canCall", 1);
let ChatMember = _ChatMember;
var ConversationType = /* @__PURE__ */ ((ConversationType2) => {
  ConversationType2["Support"] = "support";
  ConversationType2["Normal"] = "normal";
  ConversationType2["Group"] = "group";
  return ConversationType2;
})(ConversationType || {});
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$d(target, key, result);
  return result;
};
var ChatConversationState = /* @__PURE__ */ ((ChatConversationState2) => {
  ChatConversationState2["New"] = "new";
  ChatConversationState2["Opened"] = "opened";
  ChatConversationState2["Closed"] = "closed";
  return ChatConversationState2;
})(ChatConversationState || {});
class ChatConversationFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
class ChatConversationMessageSettings extends Updatable {
  constructor(settings) {
    super();
    if (settings) this.update(settings);
  }
  update(conv) {
    super.update(conv);
  }
  static fromJson(json) {
    return new ChatConversationMessageSettings({
      maxLength: json.maxLength,
      maxFileSize: json.maxFileSize ? FileSize.fromBytes(json.maxFileSize) : void 0,
      forbiddenFileExtensions: json.forbiddenFileExtensions,
      canEdit: json.canEdit,
      canDelete: json.canDelete,
      modifyTimeout: json.modifyTimeout ? TimeSpan.fromMilliseconds(json.modifyTimeout) : void 0,
      responseTimeLimit: json.responseTimeLimit ? TimeSpan.fromMilliseconds(json.responseTimeLimit) : null
    });
  }
}
const _ChatConversation = class _ChatConversation2 extends Entity$1 {
  constructor(conv) {
    super();
    if (conv)
      this.update(conv);
    this.membersTypingMap = /* @__PURE__ */ new Map();
  }
  get scrollToIndex() {
    return this.lastSeenMessageIndex ?? this.lastMessage?.index ?? 0;
  }
  get hasUserNameOrId() {
    return !isEmpty(this.target?.userName) || !isEmpty(this.creatorUserExternalId);
  }
  get userName() {
    switch (this.channelType) {
      case ChannelType.Telegram:
        return this.target?.userName && `@${this.target?.userName}`;
      default:
        return this.target?.userName;
    }
  }
  get userChannelId() {
    switch (this.channelType) {
      case ChannelType.WA:
        return this.creatorUserExternalId && `+${this.creatorUserExternalId}`;
      default:
        return this.creatorUserExternalId;
    }
  }
  get memberMapByUserId() {
    return this.members.toMap((x) => x.userId);
  }
  get memberMap() {
    return this.members.toMap((x) => x.id);
  }
  get memberTyping() {
    return Array.from(this.membersTypingMap.keys()).map((x) => this.memberMap.get(x));
  }
  get isResponseTimeLimitExceeded() {
    const settings = this.messageSettings;
    if (!settings.responseTimeLimit) return false;
    if (this.creatorLastActivityDate) {
      const diff = moment().diff(this.creatorLastActivityDate, "milliseconds");
      return diff > settings.responseTimeLimit.milliseconds;
    } else {
      return true;
    }
  }
  get isGroup() {
    return this.target == null;
  }
  get isWA() {
    return this.channelType == ChannelType.WA;
  }
  get isWZ() {
    return this.channelType == ChannelType.Wazzup24;
  }
  get isAccel() {
    return this.channelType == ChannelType.Accel;
  }
  get isSupport() {
    return this.type == ConversationType.Support;
  }
  get name() {
    switch (this.type) {
      case ConversationType.Support:
      case ConversationType.Normal:
        return this.target?.fullName ?? this.target?.phone ?? this.target?.userName;
      case ConversationType.Group:
        return this.title;
    }
  }
  get unreadMessageCount() {
    if (!this.lastMessage) return 0;
    if (this.lastSeenMessageIndex == null) return this.lastMessage.index + 1;
    return this.lastMessage.index - this.lastSeenMessageIndex;
  }
  addMember(member) {
    if (this.memberMap.has(member.id)) return false;
    this.members.push(member);
    return true;
  }
  removeMember(memberId) {
    if (!this.memberMap.has(memberId)) return false;
    this.members = this.members.filter((x) => x.id != memberId);
    return true;
  }
  addTypingMember(memberId) {
    if (!this.memberMap.has(memberId)) return;
    if (this.membersTypingMap.has(memberId))
      clearTimeout(this.membersTypingMap.get(memberId));
    this.membersTypingMap.set(memberId, setTimeout(() => this.removeTypingMember(memberId), 2e3));
    return true;
  }
  removeTypingMember(memberId) {
    this.membersTypingMap.delete(memberId);
  }
  update(conv) {
    super.update(conv);
  }
  static fromJson(json) {
    return new _ChatConversation2({
      id: json.id,
      title: json.title,
      lastMessage: json.lastMessage ? ChatMessage.fromJson(json.lastMessage) : null,
      lastActivityDate: json.lastActivityDate ? moment(json.lastActivityDate) : null,
      creatorLastActivityDate: json.creatorLastActivityDate ? moment(json.creatorLastActivityDate) : null,
      channelType: json.channelType,
      channelColor: json.channelColor ?? "#ffffff",
      lastSeenMessageIndex: json.lastSeenMessageIndex,
      targetLastSeenMessageIndex: json.targetLastSeenMessageIndex,
      members: json.members ? json.members.map(ChatMember.fromJson) : [],
      type: json.type,
      target: json.target ? ChatMember.fromJson(json.target) : void 0,
      isDraft: json.isDraft,
      readonly: json.readonly,
      creatorUnsubscribed: json.creatorUnsubscribed ?? false,
      creatorUnsubscribedReason: json.creatorUnsubscribedReason,
      state: json.state,
      messageSettings: json.messageSettings ? ChatConversationMessageSettings.fromJson(json.messageSettings) : void 0,
      creatorUserId: json.creatorUserId,
      creatorUserExternalId: json.creatorUserExternalId
    });
  }
};
__decorateClass$f([
  observable
], _ChatConversation.prototype, "title", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "lastMessage", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "lastActivityDate", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "creatorLastActivityDate", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "lastSeenMessageIndex", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "targetLastSeenMessageIndex", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "membersTypingMap", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "members", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "target", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "isDraft", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "readonly", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "creatorUnsubscribed", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "creatorUnsubscribedReason", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "messageSettings", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "state", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "creatorUserId", 2);
__decorateClass$f([
  observable
], _ChatConversation.prototype, "creatorUserExternalId", 2);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "hasUserNameOrId", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "userName", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "userChannelId", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "memberMapByUserId", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "memberMap", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "memberTyping", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "isResponseTimeLimitExceeded", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "name", 1);
__decorateClass$f([
  computed
], _ChatConversation.prototype, "unreadMessageCount", 1);
__decorateClass$f([
  action
], _ChatConversation.prototype, "addMember", 1);
__decorateClass$f([
  action
], _ChatConversation.prototype, "removeMember", 1);
__decorateClass$f([
  action
], _ChatConversation.prototype, "addTypingMember", 1);
__decorateClass$f([
  action
], _ChatConversation.prototype, "removeTypingMember", 1);
let ChatConversation = _ChatConversation;
var __defProp$c = Object.defineProperty;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$c(target, key, result);
  return result;
};
var ChatUserRole = /* @__PURE__ */ ((ChatUserRole2) => {
  ChatUserRole2[ChatUserRole2["Admin"] = 0] = "Admin";
  ChatUserRole2[ChatUserRole2["TechSupport"] = 1] = "TechSupport";
  ChatUserRole2[ChatUserRole2["Student"] = 2] = "Student";
  return ChatUserRole2;
})(ChatUserRole || {});
const _ChatUser = class _ChatUser2 extends User {
  constructor(msg) {
    super();
    if (msg)
      this.update(msg);
  }
  get isAdmin() {
    return this.adminId != void 0;
  }
  hasRoles(...requiredRoles) {
    if (requiredRoles.length == 0)
      return true;
    if (this.roles == null || this.roles.length == 0)
      return false;
    return requiredRoles.some((x) => this.roles.includes(x));
  }
  update(msg) {
    super.update(msg);
  }
  static fromJson(json) {
    return new _ChatUser2({
      id: json.id,
      firstName: json.firstName,
      lastName: json.lastName,
      middleName: json.middleName,
      email: json.email,
      phone: json.phone,
      gender: json.gender,
      birthday: json.birthday ? new Date(json.birthday) : void 0,
      avatar: json.avatar ? AccelFile.fromJson(json.avatar) : null,
      adminId: json.adminId,
      studentId: json.studentId,
      metadata: json.metadata ? JSON.parse(json.metadata) : void 0,
      lastSeenDate: json.lastSeenDate ? moment(json.lastSeenDate) : void 0,
      roles: json.roles ? json.roles : [
        0
        /* Admin */
      ],
      post: json.post,
      userName: json.userName
    });
  }
};
__decorateClass$e([
  observable
], _ChatUser.prototype, "roles");
let ChatUser = _ChatUser;
class ChatUserFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    super.update(changes);
  }
}
class ChatUserContact extends User {
  constructor(msg) {
    super();
    if (msg)
      this.update(msg);
  }
  update(msg) {
    super.update(msg);
  }
  static fromJson(json) {
    return new ChatUserContact({
      id: json.id,
      firstName: json.firstName,
      lastName: json.lastName,
      middleName: json.middleName,
      email: json.email,
      phone: json.phone,
      tags: json.tags ? json.tags : [],
      groups: json.groups ? json.groups : []
    });
  }
}
var ConversationState = /* @__PURE__ */ ((ConversationState2) => {
  ConversationState2["New"] = "new";
  ConversationState2["Opened"] = "opened";
  ConversationState2["Closed"] = "closed";
  return ConversationState2;
})(ConversationState || {});
var ConversationTab$1 = /* @__PURE__ */ ((ConversationTab2) => {
  ConversationTab2["Opened"] = "opened";
  ConversationTab2["Closed"] = "closed";
  ConversationTab2["My"] = "my";
  ConversationTab2["New"] = "new";
  return ConversationTab2;
})(ConversationTab$1 || {});
class FetchConversationsRequest extends HubRequestWithResponse {
  constructor(filter2) {
    super();
    this.filter = filter2;
    this.url = "GetConversations";
    this.body = [this.filter];
    this.processPayload = (json) => {
      return {
        items: json.items.map(ChatConversation.fromJson),
        filter: new ChatConversationFilter(json.filter)
      };
    };
  }
}
class FetchMessagesRequest extends HubRequestWithResponse {
  constructor(filter2) {
    super();
    this.filter = filter2;
    this.url = "GetMessages";
    this.body = [this.filter];
    this.processPayload = (json) => {
      return {
        items: json.items.map(ChatMessage.fromJson),
        filter: new ChatMessageFilter(json.filter)
      };
    };
  }
}
class ChatEvent extends Updatable {
  constructor(event) {
    super();
    if (event) this.update(event);
  }
  update(event) {
    super.update(event);
  }
}
class ConversationSyncedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new ConversationSyncedPayload(json);
  }
  update(event) {
    super.update(event);
  }
}
class ChatEventFactory {
  static create(type4, payload) {
    switch (type4) {
      // conversations
      case ChatEventType.ConversationCreated:
        payload = ConversationCreatedPayload.fromJson(payload);
        break;
      case ChatEventType.ConversationUpdated:
        payload = ConversationUpdatedPayload.fromJson(payload);
        break;
      case ChatEventType.ConversationDeleted:
        payload = ConversationDeletedPayload.fromJson(payload);
        break;
      case ChatEventType.ConversationSynced:
        payload = ConversationSyncedPayload.fromJson(payload);
        break;
      // conversation
      case ChatEventType.MessageSent:
        payload = MessageSentPayload.fromJson(payload);
        break;
      case ChatEventType.MessageUpdated:
        payload = MessageUpdatedPayload.fromJson(payload);
        break;
      case ChatEventType.MessageDeleted:
        payload = MessageDeletedPayload.fromJson(payload);
        break;
      case ChatEventType.MemberTyping:
        payload = MemberTypingPayload.fromJson(payload);
        break;
      case ChatEventType.MemberAdded:
        payload = MemberAddedPayload.fromJson(payload);
        break;
      case ChatEventType.MemberDeleted:
        payload = MemberDeletedPayload.fromJson(payload);
        break;
      case ChatEventType.MemberUpdated:
        payload = MemberUpdatedPayload.fromJson(payload);
        break;
      // counters
      case ChatEventType.CounterIncreased:
        payload = CounterIncreasedPayload.fromJson(payload);
        break;
      case ChatEventType.CounterDecreased:
        payload = CounterDecreasedPayload.fromJson(payload);
        break;
      default:
        throw new Error(`[ChatActionFactory] '${type4}' not found`);
    }
    return new ChatEvent({ type: type4, payload });
  }
}
class ChatConversationsSubscription extends HubSubscription {
  constructor(tab) {
    super();
    this.tab = tab;
    this.method = `Conversations ${this.tab}`;
    this.processPayload = (e) => {
      console.logDev(this.method, e.type, e.payload);
      return ChatEventFactory.create(e.type, e.payload);
    };
  }
}
class FetchConversationRequest extends HubRequestWithResponse {
  constructor(conversationId) {
    super();
    this.conversationId = conversationId;
    this.url = "GetConversation";
    this.body = [this.conversationId];
    this.processPayload = (json) => {
      return ChatConversation.fromJson(json);
    };
  }
}
class InitChatRequest extends HubRequestWithResponse {
  constructor() {
    super(...arguments);
    this.url = "Init";
    this.processPayload = (json) => {
      return {
        user: ChatUser.fromJson(json.user),
        counters: json.counters,
        conversationId: json.conversationId
      };
    };
  }
}
class ChatUserSubscription extends HubSubscription {
  constructor(chatUserId) {
    super();
    this.chatUserId = chatUserId;
    this.method = `UserUpdated ${this.chatUserId}`;
    this.processPayload = (json) => {
      return {
        id: json.id,
        onlineStatus: json.onlineStatus?.value,
        firstName: json.firstName?.value,
        lastName: json.lastName?.value,
        email: json.email?.value,
        phone: json.phone?.value,
        gender: json.gender?.value,
        avatar: json.avatar ? json.avatar.value ? AccelFile.fromJson(json.avatar.value) : null : void 0
      };
    };
  }
}
class FetchUsersRequest extends HubRequestWithResponse {
  constructor(filter2) {
    super();
    this.filter = filter2;
    this.url = "GetUsers";
    this.body = [this.filter];
    this.processPayload = (json) => {
      return {
        items: json.items.map(ChatUser.fromJson),
        filter: new ChatUserFilter(json.filter)
      };
    };
  }
}
class CreateConversationRequest extends HubRequestWithResponse {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "CreateConversation";
    this.body = [this.payload];
    this.processPayload = (json) => {
      return {
        conversationId: json.conversationId
      };
    };
  }
}
class SendMessageRequest extends HubRequestWithResponse {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "SendMessage";
    this.body = [this.payload];
    this.processPayload = (json) => {
      return {
        member: ChatMember.fromJson(json.member),
        messages: json.messages.map(ChatMessage.fromJson)
      };
    };
  }
}
class ConversationCreatedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new ConversationCreatedPayload({
      conversation: ChatConversation.fromJson(json)
    });
  }
  update(event) {
    super.update(event);
  }
}
class ConversationDeletedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new ConversationDeletedPayload({ id: json.id });
  }
  update(event) {
    super.update(event);
  }
}
class ConversationUpdatedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new ConversationUpdatedPayload({
      conversation: ChatConversation.fromJson(json)
    });
  }
  update(event) {
    super.update(event);
  }
}
class MemberAddedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MemberAddedPayload({
      member: ChatMember.fromJson(json)
    });
  }
  update(event) {
    super.update(event);
  }
}
class MemberDeletedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MemberDeletedPayload({
      id: json.id
    });
  }
  update(event) {
    super.update(event);
  }
}
class MemberTypingPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MemberTypingPayload({
      memberId: json.memberId
    });
  }
  update(event) {
    super.update(event);
  }
}
class MessageDeletedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MessageDeletedPayload({
      index: json.index
    });
  }
  update(event) {
    super.update(event);
  }
}
class MessageSentPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MessageSentPayload({
      member: ChatMember.fromJson(json.member),
      messages: json.messages.map(ChatMessage.fromJson)
    });
  }
  update(event) {
    super.update(event);
  }
}
class MessageUpdatedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MessageUpdatedPayload({
      message: ChatMessage.fromJson(json)
    });
  }
  update(event) {
    super.update(event);
  }
}
class SyncConversationRequest extends HubRequest {
  constructor(conversationId, index2) {
    super();
    this.conversationId = conversationId;
    this.index = index2;
    this.url = "SyncConversation";
    this.body = [{
      id: this.conversationId,
      index: this.index
    }];
  }
}
class UpdateMessageRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "UpdateMessage";
    this.body = [this.payload];
  }
}
class DeleteMessageRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "DeleteMessage";
    this.body = [this.payload];
  }
}
class MemberTypingRequest extends HubRequest {
  constructor(conversationId, memberId) {
    super();
    this.conversationId = conversationId;
    this.memberId = memberId;
    this.url = "MemberTyping";
    this.body = [{
      conversationId: this.conversationId,
      memberId: this.memberId
    }];
  }
}
class UpdateConversationRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "UpdateConversation";
    this.body = [{
      id: this.payload.id,
      title: toOptional(this.payload.title),
      state: toOptional(this.payload.state)
    }];
  }
}
class FetchUserInfoRequest extends HubRequestWithResponse {
  constructor(userId) {
    super();
    this.userId = userId;
    this.url = "GetUserInfo";
    this.body = [this.userId];
    this.processPayload = (json) => {
      return {
        user: new ChatUser({
          id: json.id,
          email: json.email,
          phone: json.phone,
          firstName: json.firstName,
          lastName: json.lastName,
          post: json.post,
          userName: json.userName
        }),
        onlineStatus: json.onlineStatus,
        contact: json.contact ? ChatUserContact.fromJson(json.contact) : null,
        chats: json.chats.map(ChatConversation.fromJson)
      };
    };
  }
}
class FetchContactsRequest extends HubRequestWithResponse {
  constructor(filter2) {
    super();
    this.filter = filter2;
    this.url = "GetContacts";
    this.body = [this.filter];
    this.processPayload = (json) => {
      return {
        items: json.items.map((x) => ({
          contact: ChatUserContact.fromJson(x),
          matchFields: x.matchFields
        })),
        filter: new ContactFilter(json.filter)
      };
    };
  }
}
class UpdateUserRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "UpdateUser";
    this.body = [this.payload];
  }
}
class CounterIncreasedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new CounterIncreasedPayload({
      id: json.id,
      tab: json.tab
    });
  }
  update(event) {
    super.update(event);
  }
}
class CounterDecreasedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new CounterDecreasedPayload({
      id: json.id,
      tab: json.tab
    });
  }
  update(event) {
    super.update(event);
  }
}
class ChatCountersSubscription extends HubSubscription {
  constructor() {
    super();
    this.method = `Counters`;
    this.processPayload = (e) => {
      if (env == Env.dev)
        console.log(this.method, e.type, e.payload);
      return ChatEventFactory.create(e.type, e.payload);
    };
  }
}
class JoinConversationRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "JoinConversation";
    this.body = [this.payload];
  }
}
class LeaveConversationRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "LeaveConversation";
    this.body = [this.payload];
  }
}
class MemberUpdatedPayload extends Updatable {
  constructor(payload) {
    super();
    if (payload) this.update(payload);
  }
  static fromJson(json) {
    return new MemberUpdatedPayload({
      id: json.id,
      isActive: json.isActive,
      lastSeenMessageIndex: json.lastSeenMessageIndex
    });
  }
  update(event) {
    super.update(event);
  }
}
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$b(target, key, result);
  return result;
};
let InfinityListStore$1 = class InfinityListStore extends Disposable {
  /**
   * @param defaultValue 
   * @param defaultTotalCount need to preview items placeholder while first fetching
   * @param defaultFilter
   */
  constructor(defaultValue = [], defaultTotalCount = 25, defaultFilter = {}) {
    super();
    this.defaultTotalCount = defaultTotalCount;
    this.hasError = false;
    this.isFetching = false;
    this.items = [];
    this.itemsMap = /* @__PURE__ */ new Map();
    this.isInited = false;
    this.resetItems(defaultValue, defaultTotalCount);
    this.filter = this.createFilter(defaultFilter);
  }
  get empty() {
    return this.totalCount == 0;
  }
  setViewport(v) {
    this.viewport = v;
  }
  setTotalCount(count) {
    this.totalCount = count;
  }
  isRowLoaded(index2) {
    return !!this.items[index2];
  }
  /**
   * -1 means no rows loaded
   */
  get lastLoadedIndex() {
    return this.items.length - 1;
  }
  get isAllRowsLoaded() {
    return this.items.length >= this.totalCount;
  }
  /**
   * null if item hasn't been loaded yet
   */
  getItem(index2) {
    if (!this.isRowLoaded(index2)) return null;
    return this.items[index2];
  }
  getItemById(id2) {
    return this.itemsMap.get(id2) ?? null;
  }
  async fetch(req) {
    const allowFetch = this.beforeFetch(this.filter, req);
    if (!allowFetch) return;
    runInAction(() => {
      this.isFetching = true;
    });
    const filter2 = this.createFilter({
      ...this.filter,
      skip: req.startIndex,
      take: req.stopIndex - req.startIndex + 1
    });
    const result = await this.fetchItems(filter2, req);
    if (result.success) {
      let index2 = req.startIndex;
      for (const item2 of result.items) {
        if (!this.items[index2])
          this.items[index2] = item2;
        index2++;
        this.itemsMap.set(item2.id, item2);
      }
      this.setFilter(result.filter);
    }
    runInAction(() => {
      this.hasError = !result.success;
      this.isFetching = false;
    });
    if (result.success && !this.isInited)
      runInAction(() => {
        this.isInited = true;
      });
    this.afterFetch(result);
  }
  updateFilter(changes = {}, resetPaging = true) {
    if (resetPaging)
      this.filter.page = 1;
    this.filter = this.createFilter(changes);
  }
  setFilter(filter2, reset = false) {
    this.filter = filter2;
    this.totalCount = this.filter.itemsTotal;
    if (reset) this.forceReset();
  }
  forceReset(items = [], totalCount = this.defaultTotalCount, isInited = false) {
    this.resetItems(items, totalCount);
    this.isInited = isInited;
    this.hasError = false;
  }
  resetItems(items, totalCount = this.totalCount) {
    this.itemsMap.clear();
    this.items = items;
    if (this.items.length > 0)
      this.items.forEach((x) => this.itemsMap.set(x.id, x));
    this.totalCount = totalCount;
  }
  insertItem(item2, index2) {
    const preventInsert = index2 < 0 || index2 > this.lastLoadedIndex && !this.isAllRowsLoaded;
    this.totalCount += 1;
    if (preventInsert)
      return false;
    this.items.splice(index2, 0, item2);
    this.itemsMap.set(item2.id, item2);
    return true;
  }
  updateItem(item2, index2) {
    if (!this.isRowLoaded(index2)) return;
    this.items[index2] = item2;
    this.itemsMap.set(item2.id, item2);
  }
  swapItems(index2, newIndex) {
    if (!this.isRowLoaded(index2)) return;
    const item2 = this.items[index2];
    this.items[index2] = this.items[newIndex];
    this.items[newIndex] = item2;
  }
  deleteItem(index2) {
    const preventDelete = !this.isRowLoaded(index2);
    this.totalCount -= 1;
    if (preventDelete) return false;
    const item2 = this.items[index2];
    this.items.splice(index2, 1);
    this.itemsMap.delete(item2.id);
    return true;
  }
  beforeFetch(filter2, req) {
    return true;
  }
  afterFetch(result) {
    return;
  }
};
__decorateClass$d([
  observable
], InfinityListStore$1.prototype, "hasError", 2);
__decorateClass$d([
  observable
], InfinityListStore$1.prototype, "isFetching", 2);
__decorateClass$d([
  observable
], InfinityListStore$1.prototype, "isInited", 2);
__decorateClass$d([
  observable
], InfinityListStore$1.prototype, "filter", 2);
__decorateClass$d([
  observable
], InfinityListStore$1.prototype, "totalCount", 2);
__decorateClass$d([
  computed
], InfinityListStore$1.prototype, "empty", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "setTotalCount", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "updateFilter", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "setFilter", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "forceReset", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "resetItems", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "insertItem", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "updateItem", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "swapItems", 1);
__decorateClass$d([
  action
], InfinityListStore$1.prototype, "deleteItem", 1);
class ConversationListStore extends InfinityListStore$1 {
  constructor(hub, defaultFilter) {
    super([], 50, defaultFilter);
    this.hub = hub;
    this.fetched = new TypedEvent();
    this.hub = hub || inject(this, HubClient);
  }
  createFilter(p) {
    return new ChatConversationFilter({ ...this.filter, ...p });
  }
  async fetchItems(filter2, req) {
    const result = await this.hub.invokeWithResult(new FetchConversationsRequest(filter2));
    if (result.success)
      this.fetched.emit(result.payload?.items);
    return {
      success: result.success,
      items: result.payload?.items,
      filter: result.payload?.filter
    };
  }
}
class ConversationCacheStore extends Disposable {
  constructor(hub) {
    super();
    this.hub = hub;
    this.hub = hub || inject(this, HubClient);
    this.myConversations = new ConversationListStore(this.hub, { tab: ConversationTab$1.My });
    this.newConversations = new ConversationListStore(this.hub, { tab: ConversationTab$1.New });
    this.openedConversations = new ConversationListStore(this.hub, { tab: ConversationTab$1.Opened });
    this.closedConversations = new ConversationListStore(this.hub, { tab: ConversationTab$1.Closed });
  }
  get(tab) {
    switch (tab) {
      case ConversationTab$1.Opened:
        return this.openedConversations;
      case ConversationTab$1.Closed:
        return this.closedConversations;
      case ConversationTab$1.My:
        return this.myConversations;
      case ConversationTab$1.New:
        return this.newConversations;
    }
  }
  clear() {
    this.myConversations.forceReset();
    this.newConversations.forceReset();
    this.openedConversations.forceReset();
    this.closedConversations.forceReset();
  }
  dispose() {
    this.clear();
  }
  findConversation(tab, id2) {
    const tabList = this.get(tab);
    if (!tabList) return null;
    return tabList.items.find((i) => i.id == id2) ?? null;
  }
}
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$a(target, key, result);
  return result;
};
class ChatController extends Disposable {
  constructor(hub, conversationCache) {
    super();
    this.hub = hub;
    this.conversationCache = conversationCache;
    this.inited = false;
    this.syncing = true;
    this.counters = { my: [], new: [] };
    this.visible = false;
    this.conversationTab = ConversationTab$1.My;
    this.phone = null;
    this.search = "";
    this.size = { width: 500, height: 500 };
    this.settingsVisible = false;
    this.newConversationVisible = false;
    this.infoVisibleTouched = false;
    this.infoVisible = false;
    this.onInited = new TypedEvent();
    this.onUnreadCountChanged = new TypedEvent();
    this.selectedConversationId = null;
    this.selectedConversation = null;
    this.replyMessage = null;
    this.editMessage = null;
    this.isVoiceRecording = false;
    this.fetchingConversation = false;
    this.recordingCancelled = new TypedEvent();
    this.hub = hub || inject(this, HubClient);
    this.conversationCache = conversationCache || inject(this, ConversationCacheStore);
  }
  setPhoneController(phone) {
    this.phone = phone;
  }
  get phoneEnabled() {
    return this.phone != null;
  }
  get hasActiveCall() {
    return this.phoneEnabled && this.phone?.call.isActive;
  }
  setSearch(val = "") {
    this.search = val;
  }
  setSize(size2) {
    this.size = size2;
  }
  get mode() {
    if (this.size.width < 600) return "compact";
    if (this.size.width < 1e3) return "default";
    return "full";
  }
  setSettings(value) {
    this.settings = value;
  }
  setSettingsVisible(value) {
    this.settingsVisible = value;
  }
  setNewConversationVisible(value) {
    this.newConversationVisible = value;
  }
  setInfoVisible(value) {
    this.infoVisible = value;
    this.infoVisibleTouched = true;
    this.setSize({ ...this.size });
  }
  async connect() {
    this.toDispose(this.hub.connected.on(() => {
      this.init();
    }));
    this.toDispose(this.hub.disconnected.on(() => {
      this.syncing = true;
    }));
    await this.hub.connect();
  }
  open() {
    this.visible = true;
  }
  close() {
    this.visible = false;
  }
  get hasSelectedConversation() {
    return this.selectedConversationId != null;
  }
  setConversation(conversationId, openChat = false) {
    this.selectedConversationId = conversationId;
    this.selectedConversation = null;
    this.replyMessage = null;
    this.editMessage = null;
    if (this.selectedConversationId)
      this.fetchConversation();
    if (openChat)
      this.open();
  }
  setReplyMessage(reply) {
    this.replyMessage = reply;
  }
  setEditMessage(edit2) {
    this.editMessage = edit2;
  }
  setIsVoiceRecording(value) {
    this.isVoiceRecording = value;
  }
  get hasBlockingActions() {
    return this.isVoiceRecording;
  }
  async init() {
    const result = await this.hub.invokeWithResult(new InitChatRequest());
    if (result.success) {
      runInAction(() => {
        this.user = result.payload.user;
        this.counters = result.payload.counters;
        if (result.payload.conversationId) {
          this.setConversation(result.payload.conversationId);
        }
      });
    }
    runInAction(() => {
      this.syncing = false;
      this.inited = true;
    });
    this.onInited.emit(this);
    this.toDispose(reaction$2(
      () => this.mode,
      (m) => {
        if (!this.infoVisibleTouched && m == "full")
          this.setInfoVisible(true);
      },
      { fireImmediately: true }
    ));
  }
  async fetchConversation() {
    this.fetchingConversation = true;
    const result = await this.hub.invokeWithResult(new FetchConversationRequest(this.selectedConversationId));
    if (result.success) {
      runInAction(() => this.selectedConversation = result.payload);
      if (result.payload.lastMessage)
        this.updateSelectedConversationLastMessage(result.payload.lastMessage);
    } else this.setConversation(null);
    runInAction(() => this.fetchingConversation = false);
  }
  updateSelectedConversationLastMessage(lastMessage) {
    const conversation2 = this.conversationCache.findConversation(this.conversationTab, this.selectedConversationId);
    const needUpdateLastMessage = conversation2 && conversation2.lastMessage?.id != lastMessage.id;
    if (needUpdateLastMessage)
      conversation2.update({ lastMessage });
  }
  async openConversation(params, openChat = true) {
    const result = await this.hub.invokeWithResult(new CreateConversationRequest({ ...params, type: ConversationType.Support }));
    if (result.success) {
      this.setConversation(result.payload.conversationId, openChat);
    } else {
      this.setConversation(null);
    }
  }
  increaseCounter(tab, id2) {
    switch (tab) {
      case ConversationTab$1.My: {
        this.counters.my.pushIfNotExists(id2);
        break;
      }
      case ConversationTab$1.New: {
        this.counters.new.pushIfNotExists(id2);
        break;
      }
    }
    this.counters = {
      ...this.counters
    };
  }
  decreaseCounter(tab, id2) {
    switch (tab) {
      case ConversationTab$1.My: {
        this.counters.my = this.counters.my.filter((x) => x !== id2);
        break;
      }
      case ConversationTab$1.New: {
        this.counters.new = this.counters.new.filter((x) => x !== id2);
        break;
      }
    }
    this.counters = {
      ...this.counters
    };
  }
  cancelRecording() {
    this.recordingCancelled.emit();
    console.logDev("User cancelled voice recording");
  }
}
__decorateClass$c([
  observable
], ChatController.prototype, "inited", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "syncing", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "user", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "counters", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "visible", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "conversationTab", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "phone", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setPhoneController", 1);
__decorateClass$c([
  computed
], ChatController.prototype, "phoneEnabled", 1);
__decorateClass$c([
  computed
], ChatController.prototype, "hasActiveCall", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "search", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setSearch", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "size", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setSize", 1);
__decorateClass$c([
  computed
], ChatController.prototype, "mode", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "settings", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setSettings", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "settingsVisible", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setSettingsVisible", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "newConversationVisible", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setNewConversationVisible", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "infoVisibleTouched", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "infoVisible", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setInfoVisible", 1);
__decorateClass$c([
  action
], ChatController.prototype, "open", 1);
__decorateClass$c([
  action
], ChatController.prototype, "close", 1);
__decorateClass$c([
  computed
], ChatController.prototype, "hasSelectedConversation", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "selectedConversationId", 2);
__decorateClass$c([
  observable
], ChatController.prototype, "selectedConversation", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setConversation", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "replyMessage", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setReplyMessage", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "editMessage", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setEditMessage", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "isVoiceRecording", 2);
__decorateClass$c([
  action
], ChatController.prototype, "setIsVoiceRecording", 1);
__decorateClass$c([
  computed
], ChatController.prototype, "hasBlockingActions", 1);
__decorateClass$c([
  observable
], ChatController.prototype, "fetchingConversation", 2);
__decorateClass$c([
  action
], ChatController.prototype, "increaseCounter", 1);
__decorateClass$c([
  action
], ChatController.prototype, "decreaseCounter", 1);
class UserListStore extends InfinityListStore$1 {
  constructor(hub, defaultFilter) {
    super([], 25, defaultFilter);
    this.hub = hub;
    this.hub = hub || inject(this, HubClient);
  }
  createFilter(p) {
    return new ChatUserFilter({ ...this.filter, ...p });
  }
  async fetchItems(filter2) {
    const result = await this.hub.invokeWithResult(new FetchUsersRequest(filter2));
    return {
      success: result.success,
      items: result.payload?.items,
      filter: result.payload?.filter
    };
  }
}
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$9(target, key, result);
  return result;
};
const _ChatSettings = class _ChatSettings2 extends Updatable {
  constructor(settings) {
    super();
    this.hideBotMessages = false;
    if (settings)
      this.update(settings);
  }
  get scaleFactorPercent() {
    return this.scaleFactor * 100;
  }
  set scaleFactorPercent(percent) {
    runInAction(() => this.scaleFactor = percent / 100);
  }
  update(s, allowUndefined = false) {
    super.update(s, allowUndefined);
  }
  toJson() {
    return {
      scaleFactor: this.scaleFactor,
      micDeviceId: this.micDeviceId,
      hideBotMessages: this.hideBotMessages
    };
  }
  clone() {
    return new _ChatSettings2({
      ...this
    });
  }
  static default(p) {
    return new _ChatSettings2({
      scaleFactor: 1,
      ...p
    });
  }
  static fromJson(json) {
    return new _ChatSettings2({
      ...json,
      scaleFactor: json.scaleFactor
    });
  }
};
__decorateClass$b([
  observable
], _ChatSettings.prototype, "scaleFactor", 2);
__decorateClass$b([
  observable
], _ChatSettings.prototype, "micDeviceId", 2);
__decorateClass$b([
  observable
], _ChatSettings.prototype, "hideBotMessages", 2);
__decorateClass$b([
  computed
], _ChatSettings.prototype, "scaleFactorPercent", 1);
let ChatSettings = _ChatSettings;
const Context$3 = React.createContext();
class AccelProvider extends React.Component {
  render() {
    const config2 = {
      loc: this.props.loc,
      keygen: this.props.keygen,
      api: this.props.api,
      fileProvider: this.props.fileProvider,
      lang: this.props.lang,
      user: this.props.user,
      deviceStore: this.props.deviceStore,
      geoLocator: this.props.geoLocator,
      domainDocPrefix: this.props.domainDocPrefix
    };
    return /* @__PURE__ */ jsx$1(Context$3.Provider, { value: config2, children: this.props.children });
  }
}
if (!useState$1) {
  throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!spy) {
  throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
}
var __read$2 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r2, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
function useForceUpdate() {
  var _a2 = __read$2(useState$1(0), 2), setTick = _a2[1];
  var update2 = useCallback(function() {
    setTick(function(tick) {
      return tick + 1;
    });
  }, []);
  return update2;
}
function isPlainObject(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  var proto2 = Object.getPrototypeOf(value);
  return !proto2 || proto2 === Object.prototype;
}
function getSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol.for(name);
  }
  return "__$mobx-react " + name + "__";
}
var mockGlobal = {};
function getGlobal() {
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  return mockGlobal;
}
var observerBatchingConfiguredSymbol = getSymbol("observerBatching");
function defaultNoopBatch(callback) {
  callback();
}
function observerBatching(reactionScheduler2) {
  if (!reactionScheduler2) {
    reactionScheduler2 = defaultNoopBatch;
    if ("production" !== process.env.NODE_ENV) {
      console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
    }
  }
  configure({ reactionScheduler: reactionScheduler2 });
  getGlobal()[observerBatchingConfiguredSymbol] = true;
}
function printDebugValue(v) {
  return getDependencyTree(v);
}
function createTrackingData(reaction2) {
  var trackingData = {
    cleanAt: Date.now() + CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS,
    reaction: reaction2
  };
  return trackingData;
}
var CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 1e4;
var CLEANUP_TIMER_LOOP_MILLIS = 1e4;
var uncommittedReactionRefs = /* @__PURE__ */ new Set();
var reactionCleanupHandle;
function ensureCleanupTimerRunning() {
  if (reactionCleanupHandle === void 0) {
    reactionCleanupHandle = setTimeout(cleanUncommittedReactions, CLEANUP_TIMER_LOOP_MILLIS);
  }
}
function scheduleCleanupOfReactionIfLeaked(ref2) {
  uncommittedReactionRefs.add(ref2);
  ensureCleanupTimerRunning();
}
function recordReactionAsCommitted(reactionRef) {
  uncommittedReactionRefs.delete(reactionRef);
}
function cleanUncommittedReactions() {
  reactionCleanupHandle = void 0;
  var now = Date.now();
  uncommittedReactionRefs.forEach(function(ref2) {
    var tracking = ref2.current;
    if (tracking) {
      if (now >= tracking.cleanAt) {
        tracking.reaction.dispose();
        ref2.current = null;
        uncommittedReactionRefs.delete(ref2);
      }
    }
  });
  if (uncommittedReactionRefs.size > 0) {
    ensureCleanupTimerRunning();
  }
}
var insideRender = false;
var forceUpdateQueue = [];
function useQueuedForceUpdate(forceUpdate) {
  return function() {
    if (insideRender) {
      forceUpdateQueue.push(forceUpdate);
    } else {
      forceUpdate();
    }
  };
}
function useQueuedForceUpdateBlock(callback) {
  insideRender = true;
  forceUpdateQueue = [];
  try {
    var result = callback();
    insideRender = false;
    var queue_1 = forceUpdateQueue.length > 0 ? forceUpdateQueue : void 0;
    React__default.useLayoutEffect(function() {
      if (queue_1) {
        queue_1.forEach(function(x) {
          return x();
        });
      }
    }, [queue_1]);
    return result;
  } finally {
    insideRender = false;
  }
}
var EMPTY_OBJECT = {};
function observerComponentNameFor(baseComponentName) {
  return "observer" + baseComponentName;
}
function useObserver(fn, baseComponentName, options) {
  if (baseComponentName === void 0) {
    baseComponentName = "observed";
  }
  if (options === void 0) {
    options = EMPTY_OBJECT;
  }
  var wantedForceUpdateHook = options.useForceUpdate || useForceUpdate;
  var forceUpdate = wantedForceUpdateHook();
  var queuedForceUpdate = useQueuedForceUpdate(forceUpdate);
  var reactionTrackingRef = React__default.useRef(null);
  if (!reactionTrackingRef.current) {
    var newReaction_1 = new Reaction$1(observerComponentNameFor(baseComponentName), function() {
      if (trackingData_1.mounted) {
        queuedForceUpdate();
      } else {
        newReaction_1.dispose();
        reactionTrackingRef.current = null;
      }
    });
    var trackingData_1 = createTrackingData(newReaction_1);
    reactionTrackingRef.current = trackingData_1;
    scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
  }
  var reaction2 = reactionTrackingRef.current.reaction;
  React__default.useDebugValue(reaction2, printDebugValue);
  React__default.useEffect(function() {
    recordReactionAsCommitted(reactionTrackingRef);
    if (reactionTrackingRef.current) {
      reactionTrackingRef.current.mounted = true;
    } else {
      reactionTrackingRef.current = {
        reaction: new Reaction$1(observerComponentNameFor(baseComponentName), function() {
          queuedForceUpdate();
        }),
        cleanAt: Infinity
      };
      queuedForceUpdate();
    }
    return function() {
      reactionTrackingRef.current.reaction.dispose();
      reactionTrackingRef.current = null;
    };
  }, []);
  return useQueuedForceUpdateBlock(function() {
    var rendering;
    var exception;
    reaction2.track(function() {
      try {
        rendering = fn();
      } catch (e) {
        exception = e;
      }
    });
    if (exception) {
      throw exception;
    }
    return rendering;
  });
}
var __assign$1 = function() {
  __assign$1 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
        t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function observer$1(baseComponent, options) {
  var realOptions = __assign$1({ forwardRef: false }, options);
  var baseComponentName = baseComponent.displayName || baseComponent.name;
  var wrappedComponent = function(props, ref2) {
    return useObserver(function() {
      return baseComponent(props, ref2);
    }, baseComponentName);
  };
  wrappedComponent.displayName = baseComponentName;
  var memoComponent;
  if (realOptions.forwardRef) {
    memoComponent = memo(forwardRef(wrappedComponent));
  } else {
    memoComponent = memo(wrappedComponent);
  }
  copyStaticProperties(baseComponent, memoComponent);
  memoComponent.displayName = baseComponentName;
  return memoComponent;
}
var hoistBlackList = {
  $$typeof: true,
  render: true,
  compare: true,
  type: true
};
function copyStaticProperties(base, target) {
  Object.keys(base).forEach(function(key) {
    if (!hoistBlackList[key]) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    }
  });
}
function ObserverComponent(_a2) {
  var children2 = _a2.children, render2 = _a2.render;
  var component = children2 || render2;
  if (typeof component !== "function") {
    return null;
  }
  return useObserver(component);
}
ObserverComponent.propTypes = {
  children: ObserverPropsCheck,
  render: ObserverPropsCheck
};
ObserverComponent.displayName = "Observer";
function ObserverPropsCheck(props, key, componentName, location2, propFullName) {
  var extraKey = key === "children" ? "render" : "children";
  var hasProp = typeof props[key] === "function";
  var hasExtraProp = typeof props[extraKey] === "function";
  if (hasProp && hasExtraProp) {
    return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
  }
  if (hasProp || hasExtraProp) {
    return null;
  }
  return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to `" + componentName + "`, expected `function`.");
}
var __read$1 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r2, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
function useAsObservableSourceInternal(current, usedByLocalStore) {
  var culprit = "useLocalStore";
  if ("production" !== process.env.NODE_ENV && usedByLocalStore) {
    var _a2 = __read$1(React__default.useState(current), 1), initialSource = _a2[0];
    if (initialSource !== void 0 && current === void 0 || initialSource === void 0 && current !== void 0) {
      throw new Error("make sure you never pass `undefined` to " + culprit);
    }
  }
  {
    return void 0;
  }
}
function useLocalStore(initializer, current) {
  var source = useAsObservableSourceInternal(current, true);
  return React__default.useState(function() {
    var local = observable(initializer(source));
    if (isPlainObject(local)) {
      runInAction(function() {
        Object.keys(local).forEach(function(key) {
          var value = local[key];
          if (typeof value === "function") {
            local[key] = wrapInTransaction(value, local);
          }
        });
      });
    }
    return local;
  })[0];
}
function wrapInTransaction(fn, context2) {
  return function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return transaction(function() {
      return fn.apply(context2, args);
    });
  };
}
observerBatching(unstable_batchedUpdates);
var symbolId = 0;
function createSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol(name);
  }
  var symbol = "__$mobx-react " + name + " (" + symbolId + ")";
  symbolId++;
  return symbol;
}
var createdSymbols = {};
function newSymbol(name) {
  if (!createdSymbols[name]) {
    createdSymbols[name] = createSymbol(name);
  }
  return createdSymbols[name];
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (!Object.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function setHiddenProp(target, prop, value) {
  if (!Object.hasOwnProperty.call(target, prop)) {
    Object.defineProperty(target, prop, {
      enumerable: false,
      configurable: true,
      writable: true,
      value
    });
  } else {
    target[prop] = value;
  }
}
var mobxMixins = /* @__PURE__ */ newSymbol("patchMixins");
var mobxPatchedDefinition = /* @__PURE__ */ newSymbol("patchedDefinition");
function getMixins(target, methodName) {
  var mixins = target[mobxMixins] = target[mobxMixins] || {};
  var methodMixins = mixins[methodName] = mixins[methodName] || {};
  methodMixins.locks = methodMixins.locks || 0;
  methodMixins.methods = methodMixins.methods || [];
  return methodMixins;
}
function wrapper(realMethod, mixins) {
  var _this = this;
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  mixins.locks++;
  try {
    var retVal;
    if (realMethod !== void 0 && realMethod !== null) {
      retVal = realMethod.apply(this, args);
    }
    return retVal;
  } finally {
    mixins.locks--;
    if (mixins.locks === 0) {
      mixins.methods.forEach(function(mx) {
        mx.apply(_this, args);
      });
    }
  }
}
function wrapFunction(realMethod, mixins) {
  var fn = function fn2() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
  };
  return fn;
}
function patch(target, methodName, mixinMethod) {
  var mixins = getMixins(target, methodName);
  if (mixins.methods.indexOf(mixinMethod) < 0) {
    mixins.methods.push(mixinMethod);
  }
  var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
  if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
    return;
  }
  var originalMethod = target[methodName];
  var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : void 0, mixins, originalMethod);
  Object.defineProperty(target, methodName, newDefinition);
}
function createDefinition(target, methodName, enumerable4, mixins, originalMethod) {
  var _ref;
  var wrappedFunc = wrapFunction(originalMethod, mixins);
  return _ref = {}, _ref[mobxPatchedDefinition] = true, _ref.get = function get4() {
    return wrappedFunc;
  }, _ref.set = function set2(value) {
    if (this === target) {
      wrappedFunc = wrapFunction(value, mixins);
    } else {
      var newDefinition = createDefinition(this, methodName, enumerable4, mixins, value);
      Object.defineProperty(this, methodName, newDefinition);
    }
  }, _ref.configurable = true, _ref.enumerable = enumerable4, _ref;
}
var mobxAdminProperty = $mobx || "$mobx";
var mobxObserverProperty = /* @__PURE__ */ newSymbol("isMobXReactObserver");
var mobxIsUnmounted = /* @__PURE__ */ newSymbol("isUnmounted");
var skipRenderKey = /* @__PURE__ */ newSymbol("skipRender");
var isForcingUpdateKey = /* @__PURE__ */ newSymbol("isForcingUpdate");
function makeClassComponentObserver(componentClass) {
  var target = componentClass.prototype;
  if (componentClass[mobxObserverProperty]) {
    var displayName = getDisplayName(target);
    console.warn("The provided component class (" + displayName + ") \n                has already been declared as an observer component.");
  } else {
    componentClass[mobxObserverProperty] = true;
  }
  if (target.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (componentClass["__proto__"] !== PureComponent) {
    if (!target.shouldComponentUpdate) target.shouldComponentUpdate = observerSCU;
    else if (target.shouldComponentUpdate !== observerSCU)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  makeObservableProp(target, "props");
  makeObservableProp(target, "state");
  var baseRender = target.render;
  target.render = function() {
    return makeComponentReactive.call(this, baseRender);
  };
  patch(target, "componentWillUnmount", function() {
    var _this$render$mobxAdmi;
    (_this$render$mobxAdmi = this.render[mobxAdminProperty]) === null || _this$render$mobxAdmi === void 0 ? void 0 : _this$render$mobxAdmi.dispose();
    this[mobxIsUnmounted] = true;
    if (!this.render[mobxAdminProperty]) {
      var _displayName = getDisplayName(this);
      console.warn("The reactive render of an observer class component (" + _displayName + ") \n                was overriden after MobX attached. This may result in a memory leak if the \n                overriden reactive render was not properly disposed.");
    }
  });
  return componentClass;
}
function getDisplayName(comp) {
  return comp.displayName || comp.name || comp.constructor && (comp.constructor.displayName || comp.constructor.name) || "<component>";
}
function makeComponentReactive(render2) {
  var _this = this;
  setHiddenProp(this, skipRenderKey, false);
  setHiddenProp(this, isForcingUpdateKey, false);
  var initialName = getDisplayName(this);
  var baseRender = render2.bind(this);
  var isRenderingPending = false;
  var reaction2 = new Reaction$1(initialName + ".render()", function() {
    if (!isRenderingPending) {
      isRenderingPending = true;
      if (_this[mobxIsUnmounted] !== true) {
        var hasError = true;
        try {
          setHiddenProp(_this, isForcingUpdateKey, true);
          if (!_this[skipRenderKey]) Component.prototype.forceUpdate.call(_this);
          hasError = false;
        } finally {
          setHiddenProp(_this, isForcingUpdateKey, false);
          if (hasError) reaction2.dispose();
        }
      }
    }
  });
  reaction2["reactComponent"] = this;
  reactiveRender[mobxAdminProperty] = reaction2;
  this.render = reactiveRender;
  function reactiveRender() {
    isRenderingPending = false;
    var exception = void 0;
    var rendering = void 0;
    reaction2.track(function() {
      try {
        rendering = allowStateChanges(false, baseRender);
      } catch (e) {
        exception = e;
      }
    });
    if (exception) {
      throw exception;
    }
    return rendering;
  }
  return reactiveRender.call(this);
}
function observerSCU(nextProps, nextState) {
  if (this.state !== nextState) {
    return true;
  }
  return !shallowEqual(this.props, nextProps);
}
function makeObservableProp(target, propName) {
  var valueHolderKey = newSymbol("reactProp_" + propName + "_valueHolder");
  var atomHolderKey = newSymbol("reactProp_" + propName + "_atomHolder");
  function getAtom2() {
    if (!this[atomHolderKey]) {
      setHiddenProp(this, atomHolderKey, createAtom("reactive " + propName));
    }
    return this[atomHolderKey];
  }
  Object.defineProperty(target, propName, {
    configurable: true,
    enumerable: true,
    get: function get4() {
      var prevReadState = false;
      if (allowStateReadsStart && allowStateReadsEnd) {
        prevReadState = allowStateReadsStart(true);
      }
      getAtom2.call(this).reportObserved();
      if (allowStateReadsStart && allowStateReadsEnd) {
        allowStateReadsEnd(prevReadState);
      }
      return this[valueHolderKey];
    },
    set: function set2(v) {
      if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
        setHiddenProp(this, valueHolderKey, v);
        setHiddenProp(this, skipRenderKey, true);
        getAtom2.call(this).reportChanged();
        setHiddenProp(this, skipRenderKey, false);
      } else {
        setHiddenProp(this, valueHolderKey, v);
      }
    }
  });
}
var hasSymbol = typeof Symbol === "function" && Symbol.for;
var ReactForwardRefSymbol = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : typeof forwardRef === "function" && forwardRef(function(props) {
  return null;
})["$$typeof"];
var ReactMemoSymbol = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : typeof memo === "function" && memo(function(props) {
  return null;
})["$$typeof"];
function observer(component) {
  if (component["isMobxInjector"] === true) {
    console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
  }
  if (ReactMemoSymbol && component["$$typeof"] === ReactMemoSymbol) {
    throw new Error("Mobx observer: You are trying to use 'observer' on a function component wrapped in either another observer or 'React.memo'. The observer already applies 'React.memo' for you.");
  }
  if (ReactForwardRefSymbol && component["$$typeof"] === ReactForwardRefSymbol) {
    var baseRender = component["render"];
    if (typeof baseRender !== "function") throw new Error("render property of ForwardRef was not a function");
    return forwardRef(function ObserverForwardRef() {
      var args = arguments;
      return createElement(ObserverComponent, null, function() {
        return baseRender.apply(void 0, args);
      });
    });
  }
  if (typeof component === "function" && (!component.prototype || !component.prototype.render) && !component["isReactClass"] && !Object.prototype.isPrototypeOf.call(Component, component)) {
    return observer$1(component);
  }
  return makeClassComponentObserver(component);
}
if (!Component) throw new Error("mobx-react requires React to be available");
if (!observable) throw new Error("mobx-react requires mobx to be available");
const defaultColors = [
  "#2ecc71",
  // emerald
  "#3498db",
  // peter river
  "#8e44ad",
  // wisteria
  "#e67e22",
  // carrot
  "#e74c3c",
  // alizarin
  "#1abc9c",
  // turquoise
  "#2c3e50"
  // midnight blue
];
const UserAvatar = ({ user: user2, shape = "circle", size: size2 = "default", useShortName = true, resize = { w: 85, h: 85 }, ...props }) => {
  const { fileProvider } = useContext(Context$3);
  const shortName = useMemo$2(() => {
    let str = "";
    if (!isEmpty(user2.firstName))
      str += user2.firstName[0].toUpperCase();
    if (!isEmpty(user2.lastName))
      str += user2.lastName[0].toUpperCase();
    if (isEmpty(str) && !isEmpty(user2.email))
      return user2.email[0].toUpperCase();
    return str;
  }, [user2]);
  const getState = () => {
    return {
      avatarUrl: user2.avatar != null ? fileProvider.getUrl(user2.avatar) ?? null : null,
      shortName: useShortName == false ? user2.fullName : shortName
    };
  };
  const [state, setState] = useState$1(getState());
  useEffect(() => {
    setState(getState());
  }, [user2]);
  const getRandomColor = useCallback(() => {
    const str = !isEmpty(user2.email) ? user2.email : user2.fullName;
    if (isEmpty(str)) return defaultColors[0];
    let sum = 0;
    for (let i2 = 0; i2 < str.length; i2++) {
      sum += str.charCodeAt(i2);
    }
    const i = sum % defaultColors.length;
    return defaultColors[i];
  }, [user2]);
  const getFontSize = useCallback(() => {
    if (typeof size2 == "number")
      return size2 / 2.5;
    return void 0;
  }, [size2]);
  const style2 = useMemo$2(() => {
    if (state.avatarUrl) return void 0;
    return {
      backgroundColor: props.color ?? getRandomColor(),
      fontSize: getFontSize()
    };
  }, [getRandomColor, getFontSize]);
  const url2 = useMemo$2(() => {
    let url22 = state.avatarUrl;
    if (url22?.startsWith("http") && resize) {
      try {
        const parsedUrl = new URL(url22);
        if (resize.h) parsedUrl.searchParams.append("d", `h${resize.h}`);
        else if (resize.w) parsedUrl.searchParams.append("d", `w${resize.w}`);
        url22 = parsedUrl.toString();
      } catch {
      }
    }
    return url22;
  }, [resize, state.avatarUrl]);
  return /* @__PURE__ */ jsx$1(
    Avatar,
    {
      className: combineClasses(props.className, "flex flex-center"),
      shape,
      size: size2,
      style: style2,
      src: url2 ?? void 0,
      onError: () => {
        setState({
          ...state,
          avatarUrl: null
        });
        return false;
      },
      children: state.shortName
    }
  );
};
const UserAvatar$1 = observer(UserAvatar);
const Image$2 = ({
  fit,
  alt,
  file,
  height,
  width,
  src,
  cloudKey,
  placeholder,
  className,
  loading,
  resize,
  usePreview,
  onError,
  onMouseEnter,
  onMouseLeave,
  onClick: onClick2,
  onLoad
}) => {
  const { fileProvider } = useContext(Context$3);
  const [success, setSuccess] = useState$1(true);
  const [url2, setUrl] = useState$1(src ?? fileProvider.getUrl(file));
  useEffect(() => {
    let url22 = src ?? (cloudKey ? fileProvider.getUrlByKey(cloudKey) : fileProvider.getUrl(file, usePreview ?? false));
    if (url22?.startsWith("http") && resize) {
      try {
        const parsedUrl = new URL(url22);
        if (resize.h) parsedUrl.searchParams.append("d", `h${resize.h}`);
        else if (resize.w) parsedUrl.searchParams.append("d", `w${resize.w}`);
        url22 = parsedUrl.toString();
      } catch {
      }
    }
    setUrl(url22);
  }, [file, src, resize, usePreview, cloudKey]);
  const handleError = useCallback(() => {
    setSuccess(false);
    onError?.();
  }, []);
  const getImageStyle = useCallback(() => {
    return {
      width,
      height,
      objectFit: fit
    };
  }, [width, height, fit]);
  if ((!success || !url2) && placeholder)
    return /* @__PURE__ */ jsx$1(Fragment, { children: placeholder });
  return /* @__PURE__ */ jsx$1(
    "img",
    {
      loading,
      src: url2,
      style: getImageStyle(),
      alt,
      onLoad: () => onLoad?.(),
      onError: () => handleError(),
      onMouseEnter: () => onMouseEnter?.(),
      onMouseLeave: () => onMouseLeave?.(),
      className,
      onClick: () => onClick2?.()
    }
  );
};
class DateTimeConverter {
  static format(date4, lang, format2 = "LLL") {
    const d = moment(date4);
    return d.format(format2);
  }
  static fromNow(date4, lang) {
    const d = moment(date4);
    return d.fromNow();
  }
  static calendar(date4, lang) {
    const d = moment(date4);
    return d.calendar();
  }
}
const DateTime = (props) => {
  const { lang } = useContext(Context$3);
  const getDate = useCallback(() => {
    if (props.fromNow === true) return DateTimeConverter.fromNow(props.date, lang);
    if (props.calendar === true) return DateTimeConverter.calendar(props.date, lang);
    return DateTimeConverter.format(props.date, lang, props.format ?? props.customFormat);
  }, [props]);
  const [date4, setDate] = useState$1(getDate());
  useEffect(() => {
    setDate(getDate());
  }, [props]);
  return /* @__PURE__ */ jsx$1("span", { className: props.className, title: DateTimeConverter.format(props.date, lang), children: date4 });
};
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$8(target, key, result);
  return result;
};
class CustomEditableFieldStore {
  constructor(obj) {
    Object.assign(this, obj);
  }
  setValue(value) {
    this.value = value;
  }
  setEditing(value) {
    this.editing = value;
  }
  setSaving(value) {
    this.saving = value;
  }
  setSavedIconVisible(value) {
    this.savedIconVisible = value;
  }
}
__decorateClass$a([
  observable
], CustomEditableFieldStore.prototype, "value", 2);
__decorateClass$a([
  observable
], CustomEditableFieldStore.prototype, "editing", 2);
__decorateClass$a([
  observable
], CustomEditableFieldStore.prototype, "saving", 2);
__decorateClass$a([
  observable
], CustomEditableFieldStore.prototype, "savedIconVisible", 2);
__decorateClass$a([
  action
], CustomEditableFieldStore.prototype, "setValue", 1);
__decorateClass$a([
  action
], CustomEditableFieldStore.prototype, "setEditing", 1);
__decorateClass$a([
  action
], CustomEditableFieldStore.prototype, "setSaving", 1);
__decorateClass$a([
  action
], CustomEditableFieldStore.prototype, "setSavedIconVisible", 1);
const ef_field_holder = "_ef_field_holder_1o470_1";
const ef_title = "_ef_title_1o470_2";
const ef_normal = "_ef_normal_1o470_3";
const ef_editable = "_ef_editable_1o470_4";
const ef_saved_icon = "_ef_saved_icon_1o470_21";
const styles$V = {
  ef_field_holder,
  ef_title,
  ef_normal,
  ef_editable,
  ef_saved_icon
};
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let EditableField = class extends React__default.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.disposableStack = new DisposableStack();
    this.formRef = React__default.createRef();
    this.wrapperRef = React__default.createRef();
    this.store = new CustomEditableFieldStore({
      editing: this.props.editing || this.props.defaultEditing || false,
      value: this.props.defaultValue,
      saving: false,
      savedIconVisible: false
    });
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleTrigger = this.handleTrigger.bind(this);
  }
  get loc() {
    return this.context.loc;
  }
  get value() {
    return this.store.value;
  }
  set value(val) {
    this.store.setValue(val);
    if (this.formRef.current != null) {
      this.formRef.current.setFieldsValue(this.formValues);
    }
  }
  get formValues() {
    const values = {};
    values["value"] = this.store.value;
    return values;
  }
  get editing() {
    return this.store.editing;
  }
  set editing(val) {
    this.store.setEditing(this.props.editing || val);
  }
  get saving() {
    return this.store.saving;
  }
  set saving(val) {
    this.store.setSaving(val);
  }
  get savedIconVisible() {
    return this.store.savedIconVisible;
  }
  set savedIconVisible(val) {
    this.store.setSavedIconVisible(val);
  }
  handleClickOutside(event) {
    if (!this.editing)
      return;
    if (this.wrapperRef.current != null && !this.wrapperRef.current.contains(event.target)) {
      this.onCancel(event, "outside");
    }
  }
  handleTrigger(event) {
    if (this.editing) return;
    this.editing = true;
  }
  handleKeydown(event) {
    if (!this.editing)
      return;
    switch (event.keyCode) {
      case 27: {
        if (!this.props.escape)
          return;
        this.onCancel(event, "escape");
        break;
      }
      case 13: {
        if (!this.props.enter)
          return;
        this.onChange(event, "enter");
        this.onSave(event, "enter");
        break;
      }
      default:
        return;
    }
  }
  async onChange(e, source = "button") {
    if (this.saving)
      return;
    if (this.props.onChange) {
      this.props.onChange(this.value, this, e, source);
    }
  }
  async validate() {
    try {
      await this.formRef.current.validateFields();
      return true;
    } catch {
      return false;
    }
  }
  async onSave(e, source = "button") {
    if (this.saving)
      return;
    let preventSave = this.props.preventSaveIfEquals == true && this.value == this.props.defaultValue;
    if (this.props.beforeSave) {
      preventSave = this.props.beforeSave(this.value, this, e, source) == false;
    }
    if (preventSave) {
      this.value = this.props.defaultValue;
      this.editing = false;
      return;
    }
    if (this.formRef.current != null) {
      if (!await this.validate())
        return;
    }
    if (this.props.saveable == true) {
      if (!this.props.onSave)
        throw new Error("You must specify onSave function");
      this.hideSavedIcon();
      this.saving = true;
      const res = await this.props.onSave(this.value, this, e, source);
      this.saving = false;
      if (res == true) {
        this.showSavedIcon();
      }
    }
    if (this.props.autoclose) {
      this.editing = false;
    }
  }
  showSavedIcon() {
    this.savedIconVisible = true;
    this.savedIconTimeout = setTimeout(() => {
      this.savedIconVisible = false;
    }, this.props.savedIconVisibleDurationMs || 1e3);
  }
  hideSavedIcon() {
    clearTimeout(this.savedIconTimeout);
    this.savedIconVisible = false;
  }
  onCancel(e, source = "button") {
    this.value = this.props.defaultValue;
    this.editing = false;
    if (this.props.onCancel != null)
      this.props.onCancel(this, e, source);
  }
  componentDidMount() {
    if (this.props.clickOutside == true) {
      document.addEventListener("mousedown", this.handleClickOutside);
      this.disposableStack.push(() => document.removeEventListener("mousedown", this.handleClickOutside));
    }
    const wrapper2 = this.wrapperRef.current;
    if (this.props.enter == true || this.props.escape == true) {
      wrapper2.addEventListener("keydown", this.handleKeydown);
      this.disposableStack.push(() => wrapper2.removeEventListener("keydown", this.handleKeydown));
    }
    if (this.props.editTrigger) {
      switch (this.props.editTrigger) {
        case "click":
          wrapper2.addEventListener("click", this.handleTrigger);
          this.disposableStack.push(() => wrapper2.removeEventListener("click", this.handleTrigger));
          break;
        case "dblclick":
          wrapper2.addEventListener("dblclick", this.handleTrigger);
          this.disposableStack.push(() => wrapper2.removeEventListener("dblclick", this.handleTrigger));
          break;
      }
    }
  }
  componentWillUnmount() {
    this.disposableStack.dispose();
  }
  renderSavedIcon() {
    if (this.props.showSavedIcon == false)
      return null;
    return /* @__PURE__ */ jsxs("div", { className: styles$V.ef_saved_icon, children: [
      /* @__PURE__ */ jsx$1(CheckOutlined, {}),
      this.props.savedText === void 0 ? null : /* @__PURE__ */ jsx$1(Typography.Text, { children: this.props.savedText })
    ] });
  }
  renderEditableField() {
    return /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$V.ef_wrapper, this.props.className), style: this.props.style, children: [
      this.props.title != null ? /* @__PURE__ */ jsxs("div", { className: styles$V.ef_title, children: [
        typeof this.props.title == "string" ? /* @__PURE__ */ jsx$1("label", { children: this.props.title }) : this.props.title,
        this.savedIconVisible ? this.renderSavedIcon() : null
      ] }) : null,
      /* @__PURE__ */ jsxs("div", { id: this.props.id, ref: this.wrapperRef, className: styles$V.ef_field_holder, "data-editing": this.editing, children: [
        !this.editing ? /* @__PURE__ */ jsx$1("div", { className: styles$V.ef_normal, style: { width: this.props.width }, children: this.props.render(this) }) : /* @__PURE__ */ jsx$1("div", { className: styles$V.ef_editable, style: { width: this.props.width }, children: this.props.rules ? /* @__PURE__ */ jsx$1(Form$2, { ref: this.formRef, initialValues: { value: this.props.defaultValue }, style: { width: "100%" }, children: /* @__PURE__ */ jsx$1(Form$2.Item, { name: this.props.name ?? "value", help: this.props.help, rules: this.props.rules, style: { marginBottom: 0 }, children: this.props.renderEdit(this) }) }) : this.props.renderEdit(this) }),
        this.props.title == null && this.savedIconVisible ? this.renderSavedIcon() : null
      ] })
    ] });
  }
  render() {
    return this.renderEditableField();
  }
};
EditableField.contextType = Context$3;
EditableField.defaultProps = {
  id: "",
  clickOutside: true,
  enter: true,
  escape: true,
  defaultEditing: false,
  autoclose: true,
  saveable: true,
  preventSaveIfEquals: true,
  showSavedIcon: true,
  style: {
    width: "100%"
  },
  savedIconVisibleDurationMs: 1e3,
  width: "100%"
};
EditableField = __decorateClass$9([
  observer
], EditableField);
const input_ef__inp = "_input_ef__inp_edbla_1";
const input_ef__save_btn = "_input_ef__save_btn_edbla_25";
const input_ef__cancel_btn = "_input_ef__cancel_btn_edbla_26";
const styles$U = {
  input_ef__inp,
  input_ef__save_btn,
  input_ef__cancel_btn
};
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$7(target, key, result);
  return result;
};
let TextEditableField = class extends React__default.Component {
  constructor() {
    super(...arguments);
    this.actionsWidth = 25;
  }
  get loc() {
    return this.context.loc;
  }
  get keygen() {
    return this.context.keygen;
  }
  setActionWidth(val) {
    this.actionsWidth = val || 0;
  }
  handleChange(self2, e) {
    self2.value = e.target.value;
    self2.onChange(e.nativeEvent);
  }
  handleBlur(self2, e) {
    if (this.props.onBlur)
      this.props.onBlur(self2, e);
    if (this.props.blur != true)
      return;
    self2.value = e.target.value;
    self2.onSave(e.nativeEvent, "custom");
  }
  handleSaveClick(self2, e) {
    if (this.props.allowEmpty == false && isEmpty(self2.value)) {
      self2.onCancel(e.nativeEvent);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    self2.onSave(e.nativeEvent, "button");
  }
  handleCancelClick(self2, e) {
    e.preventDefault();
    e.stopPropagation();
    self2.onCancel(e.nativeEvent);
    return false;
  }
  setEditInputRef(input2) {
    if (input2 == null) return;
    const ifFirstTime = this.editInputRef == null;
    this.editInputRef = input2;
    if (ifFirstTime) {
      if (this.props.autofocus == true) {
        setTimeout(() => {
          input2.focus();
        }, 1);
      }
    }
  }
  setEditTextAreaRef(input2) {
    if (input2 == null) return;
    const ifFirstTime = this.editInputRef == null;
    this.editInputRef = input2;
    if (ifFirstTime) {
      if (this.props.autofocus == true) {
        setTimeout(() => {
          input2.focus();
          input2.resizableTextArea?.textArea?.setSelectionRange(1e4, 1e4);
        }, 1);
      }
    }
  }
  handleClick(self2, e) {
    if (this.props.editTrigger != "click")
      return;
    e.preventDefault();
    e.stopPropagation();
    self2.editing = true;
  }
  handleDoubleClick(self2, e) {
    if (this.props.editTrigger != "dblclick")
      return;
    e.preventDefault();
    e.stopPropagation();
    self2.editing = true;
  }
  // @action
  handleCancel(self2, e, source) {
    if (this.props.onCancel)
      this.props.onCancel(self2, e, source);
  }
  getInputTitle() {
    switch (this.props.editTrigger) {
      case "click":
        return this.loc.word("Click to edit");
      case "dblclick":
        return this.loc.word("Double click to edit");
      default:
        return "";
    }
  }
  renderInput() {
    const id2 = this.keygen.generate();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      this.props.value,
      /* @__PURE__ */ jsx$1(
        EditableField,
        {
          ...this.props,
          id: id2,
          editTrigger: "custom",
          onCancel: this.handleCancel.bind(this),
          render: (self2) => {
            return /* @__PURE__ */ jsx$1(
              Input$3,
              {
                size: this.props.inputSize,
                title: this.getInputTitle(),
                readOnly: true,
                value: self2.value,
                defaultValue: this.props.defaultValue,
                className: styles$U.input_ef__inp,
                "data-dashed": this.props.dashed,
                disabled: this.props.disabled,
                placeholder: this.props.placeholder,
                onClick: (e) => this.handleClick(self2, e),
                onDoubleClick: (e) => this.handleDoubleClick(self2, e),
                suffix: this.props.suffix ? this.props.suffix(self2) : null
              }
            );
          },
          renderEdit: (self2) => {
            const props = this.props.rules ? {} : { value: self2.value };
            return /* @__PURE__ */ jsx$1(
              Input$3,
              {
                ...props,
                ref: this.setEditInputRef.bind(this),
                onChange: (e) => this.handleChange(self2, e),
                onBlur: (e) => this.handleBlur(self2, e),
                size: this.props.inputSize,
                disabled: self2.saving || this.props.disabled,
                placeholder: this.props.placeholder,
                suffix: this.props.showButtons ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx$1("div", { onMouseDown: (e) => {
                    this.handleSaveClick(self2, e);
                  }, className: styles$U.input_ef__save_btn, title: this.loc.word("Save"), children: /* @__PURE__ */ jsx$1(CheckCircleOutlined, {}) }),
                  /* @__PURE__ */ jsx$1("div", { onMouseDown: (e) => {
                    this.handleCancelClick(self2, e);
                  }, className: styles$U.input_ef__cancel_btn, title: this.loc.word("Cancel"), children: /* @__PURE__ */ jsx$1(CloseCircleOutlined, {}) })
                ] }) : null
              }
            );
          },
          className: this.props.className
        }
      )
    ] });
  }
  renderTextarea() {
    return /* @__PURE__ */ jsx$1(
      EditableField,
      {
        ...this.props,
        editTrigger: "custom",
        onCancel: this.handleCancel.bind(this),
        render: (self2) => /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(
          Input$3.TextArea,
          {
            title: this.loc.word("Click to edit"),
            readOnly: true,
            value: self2.value,
            defaultValue: this.props.defaultValue,
            className: styles$U.input_ef__inp,
            "data-dashed": this.props.dashed,
            disabled: this.props.disabled,
            onClick: (e) => this.handleClick(self2, e),
            onDoubleClick: (e) => this.handleDoubleClick(self2, e),
            autoSize: this.props.autosize,
            placeholder: this.props.placeholder
          }
        ) }),
        renderEdit: (self2) => {
          const props = this.props.rules ? {} : { value: self2.value };
          return /* @__PURE__ */ jsx$1(
            Input$3.TextArea,
            {
              ...props,
              ref: this.setEditTextAreaRef.bind(this),
              disabled: self2.saving || this.props.disabled,
              onChange: (e) => this.handleChange(self2, e),
              onBlur: (e) => this.handleBlur(self2, e),
              autoSize: this.props.autosize,
              placeholder: this.props.placeholder
            }
          );
        },
        className: this.props.className
      }
    );
  }
  render() {
    return this.props.textarea ? this.renderTextarea() : this.renderInput();
  }
};
TextEditableField.contextType = Context$3;
TextEditableField.defaultProps = {
  suffix: (self2) => /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(EditOutlined, { onClick: () => {
    self2.editing = true;
  }, style: { marginRight: "5px" } }) }),
  actionsWidth: 25,
  dashed: false,
  blur: true,
  showButtons: true,
  clickOutside: false,
  autofocus: true,
  inputSize: "middle",
  textarea: false,
  autosize: true,
  allowEmpty: true
};
__decorateClass$8([
  observable
], TextEditableField.prototype, "actionsWidth", 2);
__decorateClass$8([
  action
], TextEditableField.prototype, "setActionWidth", 1);
TextEditableField = __decorateClass$8([
  observer
], TextEditableField);
const usePropsWithDefault = (props, defaultProps2) => {
  return useMemo$2(() => {
    return { ...defaultProps2, ...props };
  }, [defaultProps2, props]);
};
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let NumberEditableField = class extends React__default.Component {
  get loc() {
    return this.context.loc;
  }
  get keygen() {
    return this.context.keygen;
  }
  handleChange(self2, e) {
    self2.value = parseInt(e);
    self2.onChange({});
  }
  handleBlur(self2, e) {
    if (this.props.onBlur)
      this.props.onBlur(self2, e);
    if (this.props.blur != true)
      return;
    self2.value = parseInt(e.target.value);
    self2.onSave(e.nativeEvent, "custom");
  }
  handleSaveClick(self2, e) {
    e.preventDefault();
    e.stopPropagation();
    self2.onSave(e.nativeEvent, "button");
  }
  handleCancelClick(self2, e) {
    e.preventDefault();
    e.stopPropagation();
    self2.onCancel(e.nativeEvent);
    return false;
  }
  setEditInputRef(input2) {
    this.editInputRef = input2;
    if (input2 != null && this.props.autofocus == true)
      input2.focus();
  }
  handleClick(self2, e) {
    if (this.props.editTrigger != "click")
      return;
    e.preventDefault();
    e.stopPropagation();
    self2.editing = true;
  }
  handleDoubleClick(self2, e) {
    if (this.props.editTrigger != "dblclick")
      return;
    e.preventDefault();
    e.stopPropagation();
    self2.editing = true;
  }
  handleCancel(self2, e, source) {
    if (this.props.onCancel)
      this.props.onCancel(self2, e, source);
  }
  getInputTitle() {
    switch (this.props.editTrigger) {
      case "click":
        return this.loc.word("Click to edit");
      case "dblclick":
        return this.loc.word("Double click to edit");
      default:
        return "";
    }
  }
  render() {
    const id2 = this.keygen.generate();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      this.props.value,
      /* @__PURE__ */ jsx$1(
        EditableField,
        {
          ...this.props,
          id: id2,
          editTrigger: "custom",
          onCancel: this.handleCancel.bind(this),
          render: (self2) => {
            return /* @__PURE__ */ jsx$1(
              InputNumber,
              {
                size: this.props.inputSize,
                title: this.getInputTitle(),
                readOnly: true,
                value: self2.value,
                defaultValue: this.props.defaultValue,
                "data-dashed": this.props.dashed,
                disabled: this.props.disabled,
                placeholder: this.props.placeholder,
                onClick: (e) => this.handleClick(self2, e),
                onDoubleClick: (e) => this.handleDoubleClick(self2, e),
                style: { width: this.props.width }
              }
            );
          },
          renderEdit: (self2) => {
            const props = this.props.rules ? {} : { value: self2.value };
            return /* @__PURE__ */ jsx$1(
              InputNumber,
              {
                ...props,
                ref: this.setEditInputRef.bind(this),
                onChange: (e) => this.handleChange(self2, e),
                onBlur: (e) => this.handleBlur(self2, e),
                size: this.props.inputSize,
                disabled: self2.saving || this.props.disabled,
                placeholder: this.props.placeholder,
                style: { width: this.props.width },
                min: this.props.min,
                max: this.props.max
              }
            );
          },
          className: this.props.className
        }
      )
    ] });
  }
};
NumberEditableField.contextType = Context$3;
NumberEditableField.defaultProps = {
  dashed: false,
  blur: true,
  clickOutside: false,
  autofocus: true,
  inputSize: "middle"
};
NumberEditableField = __decorateClass$7([
  observer
], NumberEditableField);
const fl = "_fl_fgb0l_1";
const fl_preview_modal = "_fl_preview_modal_fgb0l_19";
const styles$T = {
  fl,
  fl_preview_modal
};
const fl_grid_item = "_fl_grid_item_hu4wm_1";
const fl_grid_item_menu = "_fl_grid_item_menu_hu4wm_21";
const fl_grid_item__preview = "_fl_grid_item__preview_hu4wm_37";
const styles$S = {
  fl_grid_item,
  fl_grid_item_menu,
  fl_grid_item__preview
};
function useClickOutside(ref2, enable, onClick2) {
  useEffect(() => {
    if (!enable || !ref2.current) return;
    function handleClickOutside(event) {
      if (ref2.current && !ref2.current.contains(event.target)) {
        onClick2(event);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref2, enable]);
}
const fl_filename_input = "_fl_filename_input_1gawe_1";
const styles$R = {
  fl_filename_input
};
const FileName = ({ file, editable, useExtension, loc, className, onRename }) => {
  const [editing, setEditing] = useState$1(false);
  const [saving, setSaving] = useState$1(false);
  const inputRef = useRef(null);
  useClickOutside(inputRef, editing, () => {
    save();
  });
  const save = useCallback(async () => {
    const val = inputRef.current?.value ?? "";
    if (val !== file.name) {
      setSaving(true);
      await onRename(val);
      setSaving(false);
    }
    setEditing(false);
  }, [file]);
  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);
  return /* @__PURE__ */ jsx$1(Fragment, { children: !editing ? /* @__PURE__ */ jsx$1(
    "div",
    {
      className: combineClasses("ellipsis", editable ? "c-pointer hoverable" : void 0, className),
      onClick: () => editable && setEditing(true),
      title: editable ? loc.word("File.clickToRename", { default: "Click to rename" }) : file.filename,
      children: useExtension == true ? file.filename : file.name
    }
  ) : /* @__PURE__ */ jsx$1("input", { ref: inputRef, defaultValue: file.name, type: "text", disabled: saving, className: combineClasses(styles$R.fl_filename_input, "w-100 p-0 m-0 no-border"), onKeyUp: (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.key == "Enter")
      save();
  } }) });
};
const comment$2 = "_comment_1flia_1";
const comment_form$1 = "_comment_form_1flia_1";
const comment_bottom = "_comment_bottom_1flia_9";
const comment_bottom_btn = "_comment_bottom_btn_1flia_12";
const comment_send_btn = "_comment_send_btn_1flia_20";
const comment_files = "_comment_files_1flia_16";
const comment_text = "_comment_text_1flia_31";
const styles$Q = {
  comment: comment$2,
  comment_form: comment_form$1,
  comment_bottom,
  comment_bottom_btn,
  comment_send_btn,
  comment_files,
  comment_text
};
var propTypes = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to = toObject(target);
    var symbols3;
    for (var s = 1; s < arguments.length; s++) {
      from2 = Object(arguments[s]);
      for (var key in from2) {
        if (hasOwnProperty.call(from2, key)) {
          to[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols3 = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols3.length; i++) {
          if (propIsEnumerable.call(from2, symbols3[i])) {
            to[symbols3[i]] = from2[symbols3[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text2) {
      var message2 = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location2 + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs$1();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message2 = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message2, data2) {
      this.message = message2;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location2, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location2, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error2 = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is2(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type4 = getPreciseType(value);
          if (type4 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location2, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location2, propFullName, key, type4) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type4 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type4 = getPreciseType(value);
      switch (type4) {
        case "array":
        case "object":
          return "an " + type4;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type4;
        default:
          return type4;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs$1();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_2 = 0)), _2) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _2.label++;
          return { value: op[1], done: false };
        case 5:
          _2.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _2.ops.pop();
          _2.trys.pop();
          continue;
        default:
          if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _2 = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _2.label = op[1];
            break;
          }
          if (op[0] === 6 && _2.label < t[1]) {
            _2.label = t[1];
            t = op;
            break;
          }
          if (t && _2.label < t[2]) {
            _2.label = t[2];
            _2.ops.push(op);
            break;
          }
          if (t[2]) _2.ops.pop();
          _2.trys.pop();
          continue;
      }
      op = body.call(thisArg, _2);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r2, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error2) {
    e = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read(arguments[i]));
  return ar;
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e = new Error(message2);
  return e.name = "SuppressedError", e.error = error2, e.suppressed = suppressed, e;
};
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  ["avi", "video/avi"],
  ["gif", "image/gif"],
  ["ico", "image/x-icon"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["mp4", "video/mp4"],
  ["pdf", "application/pdf"],
  ["png", "image/png"],
  ["zip", "application/zip"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
]);
function toFileWithPath(file, path2) {
  var f = withMimeType(file);
  if (typeof f.path !== "string") {
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, "path", {
      value: typeof path2 === "string" ? path2 : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  return f;
}
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split(".").pop().toLowerCase();
    var type4 = COMMON_MIME_TYPES.get(ext);
    if (type4) {
      Object.defineProperty(file, "type", {
        value: type4,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
var FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, isDragEvt(evt) && evt.dataTransfer ? getDataTransferFiles(evt.dataTransfer, evt.type) : getInputFiles(evt)];
    });
  });
}
function isDragEvt(value) {
  return !!value.dataTransfer;
}
function getInputFiles(evt) {
  var files = isInput(evt.target) ? evt.target.files ? fromList(evt.target.files) : [] : [];
  return files.map(function(file) {
    return toFileWithPath(file);
  });
}
function isInput(value) {
  return value !== null;
}
function getDataTransferFiles(dt, type4) {
  return __awaiter(this, void 0, void 0, function() {
    var items, files;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!dt.items) return [3, 2];
          items = fromList(dt.items).filter(function(item2) {
            return item2.kind === "file";
          });
          if (type4 !== "drop") {
            return [2, items];
          }
          return [4, Promise.all(items.map(toFilePromises))];
        case 1:
          files = _a2.sent();
          return [2, noIgnoredFiles(flatten(files))];
        case 2:
          return [2, noIgnoredFiles(fromList(dt.files).map(function(file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}
function noIgnoredFiles(files) {
  return files.filter(function(file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
function fromList(items) {
  var files = [];
  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }
  return files;
}
function toFilePromises(item2) {
  if (typeof item2.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item2);
  }
  var entry = item2.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item2);
}
function flatten(items) {
  return items.reduce(function(acc, files) {
    return __spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}
function fromDataTransferItem(item2) {
  var file = item2.getAsFile();
  if (!file) {
    return Promise.reject(item2 + " is not a File");
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function(resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      reader.readEntries(function(batch) {
        return __awaiter(_this, void 0, void 0, function() {
          var files, err_1, items;
          return __generator(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                if (!!batch.length) return [3, 5];
                _a2.label = 1;
              case 1:
                _a2.trys.push([1, 3, , 4]);
                return [4, Promise.all(entries)];
              case 2:
                files = _a2.sent();
                resolve(files);
                return [3, 4];
              case 3:
                err_1 = _a2.sent();
                reject(err_1);
                return [3, 4];
              case 4:
                return [3, 6];
              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items);
                readEntries();
                _a2.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(err) {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, new Promise(function(resolve, reject) {
        entry.file(function(file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function(err) {
          reject(err);
        });
      })];
    });
  });
}
var es$a = {};
var hasRequiredEs;
function requireEs() {
  if (hasRequiredEs) return es$a;
  hasRequiredEs = 1;
  es$a.__esModule = true;
  es$a.default = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
      var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
      if (acceptedFilesArray.length === 0) {
        return true;
      }
      var fileName = file.name || "";
      var mimeType = (file.type || "").toLowerCase();
      var baseMimeType = mimeType.replace(/\/.*$/, "");
      return acceptedFilesArray.some(function(type4) {
        var validType = type4.trim().toLowerCase();
        if (validType.charAt(0) === ".") {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith("/*")) {
          return baseMimeType === validType.replace(/\/.*$/, "");
        }
        return mimeType === validType;
      });
    }
    return true;
  };
  return es$a;
}
var esExports = requireEs();
const accepts = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
function _slicedToArray$4(arr, i) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$3(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr2(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr2(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr2(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function allFilesAccepted(_ref) {
  var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple;
  if (!multiple && files.length > 1) {
    return false;
  }
  return files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$4(_fileAccepted, 1), accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$4(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
    return accepted && sizeMatch;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function(type4) {
    return type4 === "Files" || type4 === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function(fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function _toConsumableArray$3(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray$2(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _slicedToArray$3(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$2(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$r(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$p(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$r(source, true).forEach(function(key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$r(source).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Dropzone = forwardRef(function(_ref, ref2) {
  var children2 = _ref.children, params = _objectWithoutProperties$3(_ref, ["children"]);
  var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties$3(_useDropzone, ["open"]);
  useImperativeHandle(ref2, function() {
    return {
      open
    };
  }, [open]);
  return React__default.createElement(Fragment$1, null, children2(_objectSpread$p({}, props, {
    open
  })));
});
Dropzone.displayName = "Dropzone";
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func
};
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, accept = _ref2.accept, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$getFilesFromEve = _ref2.getFilesFromEvent, getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve, _ref2$maxSize = _ref2.maxSize, maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize, _ref2$minSize = _ref2.minSize, minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize, _ref2$multiple = _ref2.multiple, multiple = _ref2$multiple === void 0 ? true : _ref2$multiple, onDragEnter = _ref2.onDragEnter, onDragLeave = _ref2.onDragLeave, onDragOver = _ref2.onDragOver, onDrop = _ref2.onDrop, onDropAccepted = _ref2.onDropAccepted, onDropRejected = _ref2.onDropRejected, onFileDialogCancel = _ref2.onFileDialogCancel, _ref2$preventDropOnDo = _ref2.preventDropOnDocument, preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo, _ref2$noClick = _ref2.noClick, noClick = _ref2$noClick === void 0 ? false : _ref2$noClick, _ref2$noKeyboard = _ref2.noKeyboard, noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard, _ref2$noDrag = _ref2.noDrag, noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag, _ref2$noDragEventsBub = _ref2.noDragEventsBubbling, noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer$2, initialState), _useReducer2 = _slicedToArray$3(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles;
  var openFileDialog = useCallback(function() {
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]);
  var onWindowFocus = function onWindowFocus2() {
    if (isFileDialogActive) {
      setTimeout(function() {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            if (typeof onFileDialogCancel === "function") {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };
  useEffect(function() {
    window.addEventListener("focus", onWindowFocus, false);
    return function() {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]);
  var onKeyDownCb = useCallback(function(event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]);
  var onFocusCb = useCallback(function() {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function() {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function() {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop2(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function() {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function() {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray$3(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles2) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        dispatch({
          draggedFiles: draggedFiles2,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {
      }
    }
    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      isDragActive: false,
      type: "setDraggedFiles",
      draggedFiles: []
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
          var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$3(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
          var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$3(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
          if (accepted && sizeMatch) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError].filter(function(e) {
              return e;
            });
            fileRejections.push({
              file,
              errors
            });
          }
        });
        if (!multiple && acceptedFiles.length > 1) {
          acceptedFiles.forEach(function(file) {
            fileRejections.push({
              file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }
        dispatch({
          acceptedFiles,
          fileRejections,
          type: "setFiles"
        });
        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }
        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }
        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }
    dispatch({
      type: "reset"
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);
  var composeHandler = function composeHandler2(fn) {
    return disabled ? null : fn;
  };
  var composeKeyboardHandler = function composeKeyboardHandler2(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };
  var composeDragHandler = function composeDragHandler2(fn) {
    return noDrag ? null : composeHandler(fn);
  };
  var stopPropagation = function stopPropagation2(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo$2(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onKeyDown = _ref3.onKeyDown, onFocus = _ref3.onFocus, onBlur = _ref3.onBlur, onClick2 = _ref3.onClick, onDragEnter2 = _ref3.onDragEnter, onDragOver2 = _ref3.onDragOver, onDragLeave2 = _ref3.onDragLeave, onDrop2 = _ref3.onDrop, rest = _objectWithoutProperties$3(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);
      return _objectSpread$p(_defineProperty$3({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop2, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function(event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo$2(function() {
    return function() {
      var _ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, onChange5 = _ref4.onChange, onClick2 = _ref4.onClick, rest = _objectWithoutProperties$3(_ref4, ["refKey", "onChange", "onClick"]);
      var inputProps = _defineProperty$3({
        accept,
        multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange5, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onInputElementClick)),
        autoComplete: "off",
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread$p({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept,
    minSize,
    maxSize,
    multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread$p({}, state, {
    isDragAccept,
    isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer$2(state, action3) {
  switch (action3.type) {
    case "focus":
      return _objectSpread$p({}, state, {
        isFocused: true
      });
    case "blur":
      return _objectSpread$p({}, state, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread$p({}, state, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread$p({}, state, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      var isDragActive = action3.isDragActive, draggedFiles = action3.draggedFiles;
      return _objectSpread$p({}, state, {
        draggedFiles,
        isDragActive
      });
    case "setFiles":
      return _objectSpread$p({}, state, {
        acceptedFiles: action3.acceptedFiles,
        fileRejections: action3.fileRejections
      });
    case "reset":
      return _objectSpread$p({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        fileRejections: []
      });
    default:
      return state;
  }
}
const Comment = React__default.forwardRef((props, ref2) => {
  if (props.enterToSubmit === void 0) {
    props.enterToSubmit = true;
  }
  const ctx = useContext(Context$3);
  const { loc, user: user2, deviceStore } = ctx;
  const dropzoneRef = useRef(null);
  const [text2, _setText] = useState$1(props.defaultText ?? props.text ?? "");
  const setText = (val) => {
    if (!props.text) _setText(val);
  };
  const [files, _setFiles] = useState$1(props.defaultFiles?.slice() ?? props.files?.slice() ?? []);
  const setFiles = (val) => {
    if (!props.files) _setFiles(val);
  };
  const [editing, _setEditing] = useState$1(props.defaultEditing ?? props.editing ?? false);
  const setEditing = (val) => {
    if (!props.editing) _setEditing(val);
  };
  const [sending, setSending] = useState$1(false);
  const [, setRemoving] = useState$1(false);
  const [editingText, setEditingText] = useState$1("");
  const [editingFiles, setEditingFiles] = useState$1([]);
  const [editingReplyRemoved, setEditingReplyRemoved] = useState$1(false);
  const hasFocusRef = useRef(false);
  useEffect(() => {
    if (props.editing == void 0) return;
    _setEditing(props.editing);
  }, [props.editing]);
  useEffect(() => {
    if (editing) {
      setEditingText(text2);
      setEditingFiles(files.slice());
    }
  }, [editing]);
  useEffect(() => {
    if (props.text == void 0) return;
    _setText(props.text);
    if (editing) {
      setEditingText(props.text);
    }
  }, [props.text]);
  useEffect(() => {
    if (props.files == void 0) return;
    _setFiles(props.files.slice());
    if (editing) {
      setEditingFiles(props.files.slice());
    }
  }, [props.files]);
  useEffect(() => {
    if (replyTo == null)
      setEditingReplyRemoved(false);
  }, [props.replyTo]);
  const trimText = (val) => {
    if (props.keepEmptyLines == true) {
      return val;
    } else {
      return val.split("\n").filter((x) => x.length > 0).join("\n");
    }
  };
  const availableFileCount = props.maxFiles != null ? Math.max(0, props.maxFiles - editingFiles.length) : null;
  const canAttachFiles = availableFileCount == null || availableFileCount > 0;
  const sendComment = async () => {
    if (props.onSend == null) return;
    setSending(true);
    const trimmedText = trimText(editingText);
    const success = await props.onSend(trimmedText, editingFiles, editingReplyRemoved);
    if (success) {
      if (props.clearAfterSending == true) {
        setFiles([]);
        setText("");
        props.onReplyRemoved?.();
      } else {
        setFiles(editingFiles.slice());
        setText(trimmedText);
      }
      setEditing(false);
      setEditingFiles([]);
      setEditingText("");
      setEditingReplyRemoved(false);
    }
    setSending(false);
  };
  const attachFiles = (files2) => {
    if (files2.length == 0)
      return;
    if (availableFileCount != null) {
      if (availableFileCount == 0) return;
      if (files2.length > availableFileCount)
        files2 = files2.slice(0, availableFileCount);
    }
    const newEditingFiles = [...editingFiles];
    for (const file of files2.map((x) => AccelFile.fromFile(x))) {
      newEditingFiles.push(file);
      props.onFileAdded?.(file);
    }
    setEditingFiles(newEditingFiles);
    props.onFilesChange?.(newEditingFiles);
  };
  const deleteFile = (file) => {
    const newEditingFiles = editingFiles.filter((x) => x.id != file.id || x != file);
    setEditingFiles(newEditingFiles);
    props.onFileRemoved?.(file);
    props.onFilesChange?.(newEditingFiles);
  };
  useClipboardFiles((file) => {
    if (!hasFocusRef.current) return;
    attachFiles([file]);
  }, props.disableFiles !== true, [props.disableFiles, attachFiles]);
  const edit2 = () => {
    props.onEdit?.();
    setEditing(true);
  };
  const cancelEdit = () => {
    props.onCancelEdit?.();
    setEditing(false);
    setEditingFiles([]);
    setEditingReplyRemoved(false);
  };
  const updateText = (val) => {
    setEditingText(val);
    props.onTextChange?.(val);
  };
  const remove = async () => {
    setRemoving(true);
    if (props.onRemove != null)
      await props.onRemove();
    setRemoving(false);
  };
  const reply = () => {
    props.onReply?.();
  };
  const removeReply = () => {
    props.onReplyRemoved?.();
    setEditingReplyRemoved(true);
  };
  const getAttachFilesTooltip = () => {
    let tooltip = loc.word("Attach files");
    if (props.maxFiles)
      tooltip += ` (${loc.word("Max", { case: "lower" })}: ${props.maxFiles})`;
    return tooltip;
  };
  const openFileDialog = () => {
    if (!canAttachFiles) return;
    dropzoneRef.current?.open();
  };
  const disabled = props.disabled == true;
  const renderDropzone = (children2) => {
    return /* @__PURE__ */ jsx$1(Dropzone, { ref: dropzoneRef, noClick: true, noDrag: true, noKeyboard: true, onDrop: (x) => attachFiles(x), children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ jsx$1("section", { children: /* @__PURE__ */ jsxs("div", { ...getRootProps(), children: [
      /* @__PURE__ */ jsx$1("input", { ...getInputProps() }),
      children2
    ] }) }) });
  };
  const renderButtons = () => {
    const canSend = editingText.length > 0 || editingFiles.length > 0;
    const sendButtonVisible = props.onSend != null;
    const attachButtonVisible = props.disableFiles != true;
    if (props.viewMode != "buttonsBelow") {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        sendButtonVisible && /* @__PURE__ */ jsx$1(
          Button,
          {
            type: "link",
            onClick: () => sendComment(),
            disabled: disabled || !canSend || sending,
            size: "small",
            className: styles$Q.comment_send_btn,
            children: props.sendBtnText ?? loc.word("Send")
          }
        ),
        attachButtonVisible && /* @__PURE__ */ jsx$1(Fragment, { children: !disabled ? renderDropzone(/* @__PURE__ */ jsx$1(Tooltip, { placement: "topRight", title: getAttachFilesTooltip(), children: /* @__PURE__ */ jsx$1(
          Button,
          {
            type: "link",
            size: "large",
            onClick: () => openFileDialog(),
            disabled: sending || !canAttachFiles,
            icon: /* @__PURE__ */ jsx$1(PaperClipOutlined, {})
          }
        ) })) : /* @__PURE__ */ jsx$1(
          Button,
          {
            type: "link",
            size: "large",
            disabled: true,
            icon: /* @__PURE__ */ jsx$1(PaperClipOutlined, {})
          }
        ) })
      ] });
    } else {
      return /* @__PURE__ */ jsxs(Space, { className: "mt-10", children: [
        attachButtonVisible && /* @__PURE__ */ jsx$1(Fragment, { children: !disabled ? renderDropzone(/* @__PURE__ */ jsx$1(
          Button,
          {
            type: "dashed",
            onClick: () => openFileDialog(),
            disabled: sending || !canAttachFiles,
            icon: /* @__PURE__ */ jsx$1(PaperClipOutlined, {}),
            children: deviceStore.deviceSize != "mobile" && loc.word("Attach files")
          }
        )) : /* @__PURE__ */ jsx$1(
          Button,
          {
            type: "dashed",
            disabled: true,
            icon: /* @__PURE__ */ jsx$1(PaperClipOutlined, {}),
            children: deviceStore.deviceSize != "mobile" && loc.word("Attach files")
          }
        ) }),
        sendButtonVisible && /* @__PURE__ */ jsx$1(
          Button,
          {
            type: "primary",
            onClick: () => sendComment(),
            disabled: disabled || !canSend || sending,
            className: styles$Q.comment_send_btn,
            icon: /* @__PURE__ */ jsx$1(SendOutlined, {}),
            children: deviceStore.deviceSize != "mobile" && (props.sendBtnText ?? loc.word("Send"))
          }
        )
      ] });
    }
  };
  const renderInput = () => {
    return /* @__PURE__ */ jsxs("div", { className: styles$Q.comment_form, children: [
      /* @__PURE__ */ jsx$1(
        Input$3.TextArea,
        {
          ref: ref2,
          value: editingText,
          disabled: disabled || sending,
          onChange: (e) => updateText(e.target.value),
          placeholder: props.placeholder ?? loc.word("Enter comment"),
          autoSize: {
            minRows: props.minRows ?? 2,
            maxRows: props.maxRows ?? 5
          },
          onFocus: () => hasFocusRef.current = true,
          onBlur: () => hasFocusRef.current = false,
          onKeyDown: (e) => {
            if (props.enterToSubmit === true && (e.key == "Enter" && !e.shiftKey)) {
              e.preventDefault();
              sendComment();
            }
          }
        }
      ),
      props.viewMode != "buttonsBelow" && renderButtons()
    ] });
  };
  const renderFiles = (files2) => {
    if (files2.length == 0)
      return null;
    return /* @__PURE__ */ jsx$1("div", { className: styles$Q.comment_files, children: files2.length > 0 && /* @__PURE__ */ jsx$1(
      Files$1,
      {
        editable: !disabled && editing,
        deletable: !disabled && editing,
        files: files2,
        beforeRemove: async (x) => {
          deleteFile(x);
          return false;
        },
        view: props.fileView || "grid",
        size: props.fileListSize || "md"
      }
    ) });
  };
  const { author, createdDate, updatedDate, replyTo } = props;
  const canEdit = props.canEdit != false;
  const canRemove = props.canRemove != false;
  const canCancel = props.canCancel != false;
  const canReply = props.canReply == true;
  const useAvatar = props.useAvatar != false;
  return /* @__PURE__ */ jsx$1("div", { className: `${props.className ?? ""} ${styles$Q.comment}`, "data-view": props.viewMode ?? "default", "data-files-disabled": props.disableFiles ?? false, children: /* @__PURE__ */ jsxs(Row, { children: [
    author != null && useAvatar && /* @__PURE__ */ jsx$1(UserAvatar$1, { user: author, size: 40, className: "mr-10" }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
      author != null && user2 != null && !editing && /* @__PURE__ */ jsx$1(Typography.Text, { children: user2.id != author.id ? props.authorExtra?.(author) ?? author.fullName : loc.word("You") }),
      replyTo != null && !editingReplyRemoved && /* @__PURE__ */ jsxs(Row, { align: "middle", children: [
        replyTo,
        editing && /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Remove"), children: /* @__PURE__ */ jsx$1(Button, { onClick: () => removeReply(), type: "link", size: "small", icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}) }) })
      ] }),
      /* @__PURE__ */ jsx$1("div", { className: styles$Q.comment_text, children: !editing ? /* @__PURE__ */ jsx$1(Fragment, { children: text2 ? /* @__PURE__ */ jsx$1(LinkifyText, { text: text2 }) : props.emptyText }) : renderInput() }),
      /* @__PURE__ */ jsxs(Row, { align: "top", justify: "space-between", children: [
        /* @__PURE__ */ jsx$1("div", {}),
        renderFiles(!editing ? files : editingFiles),
        editing && props.viewMode == "buttonsBelow" && /* @__PURE__ */ jsx$1("div", { className: "text-right", children: renderButtons() })
      ] }),
      /* @__PURE__ */ jsxs(Row, { align: "middle", className: styles$Q.comment_bottom, children: [
        createdDate != null && /* @__PURE__ */ jsx$1(Typography.Text, { type: "secondary", children: /* @__PURE__ */ jsxs(Space, { size: 2, children: [
          loc.word("Sent"),
          /* @__PURE__ */ jsx$1(DateTime, { date: createdDate })
        ] }) }),
        updatedDate != null && /* @__PURE__ */ jsxs(Fragment, { children: [
          createdDate && /* @__PURE__ */ jsx$1(Badge, { status: "default", className: "separator" }),
          /* @__PURE__ */ jsx$1(Typography.Text, { type: "secondary", children: /* @__PURE__ */ jsxs(Space, { size: 2, children: [
            loc.word("Updated"),
            /* @__PURE__ */ jsx$1(DateTime, { date: updatedDate })
          ] }) })
        ] }),
        editing ? /* @__PURE__ */ jsx$1(Fragment, { children: canCancel && /* @__PURE__ */ jsxs(Fragment, { children: [
          (createdDate || updatedDate) && /* @__PURE__ */ jsx$1(Badge, { status: "default", className: "separator" }),
          /* @__PURE__ */ jsx$1(
            Button,
            {
              className: styles$Q.comment_bottom_btn,
              disabled,
              type: "link",
              size: "small",
              onClick: () => cancelEdit(),
              children: loc.word("Cancel", { case: "lower" })
            }
          )
        ] }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          canReply && /* @__PURE__ */ jsxs(Fragment, { children: [
            (createdDate || updatedDate) && /* @__PURE__ */ jsx$1(Badge, { status: "default", className: "separator" }),
            /* @__PURE__ */ jsx$1(
              Button,
              {
                className: styles$Q.comment_bottom_btn,
                disabled,
                type: "link",
                size: "small",
                onClick: () => reply(),
                children: loc.word("Reply", { case: "lower" })
              }
            )
          ] }),
          canEdit && /* @__PURE__ */ jsxs(Fragment, { children: [
            (createdDate || updatedDate || canReply) && /* @__PURE__ */ jsx$1(Badge, { status: "default", className: "separator" }),
            /* @__PURE__ */ jsx$1(
              Button,
              {
                className: styles$Q.comment_bottom_btn,
                disabled,
                type: "link",
                size: "small",
                onClick: () => edit2(),
                children: loc.word("Edit", { case: "lower" })
              }
            )
          ] }),
          canRemove && /* @__PURE__ */ jsxs(Fragment, { children: [
            (createdDate || updatedDate || canReply || canEdit) && /* @__PURE__ */ jsx$1(Badge, { status: "default", className: "separator" }),
            disabled ? /* @__PURE__ */ jsx$1(
              Button,
              {
                className: styles$Q.comment_bottom_btn,
                disabled: true,
                type: "link",
                size: "small",
                children: loc.word("Delete", { case: "lower" })
              }
            ) : /* @__PURE__ */ jsx$1(
              Popconfirm,
              {
                title: loc.word("Comment.delete.confirm"),
                onConfirm: () => remove(),
                children: /* @__PURE__ */ jsx$1(
                  Button,
                  {
                    className: styles$Q.comment_bottom_btn,
                    type: "link",
                    size: "small",
                    children: loc.word("Delete", { case: "lower" })
                  }
                )
              }
            )
          ] })
        ] }),
        props.extra?.(editing)
      ] })
    ] })
  ] }) });
});
const FileDescriptionPopover = ({ loc, file, canEdit, onSave, children: children2 }) => {
  return /* @__PURE__ */ jsx$1(
    Popover,
    {
      content: /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(
        Comment,
        {
          text: file.description,
          emptyText: /* @__PURE__ */ jsx$1(Typography.Text, { type: "secondary", children: loc.word("FileList.emptyDescriptionMsg", { default: "No description" }) }),
          disableFiles: true,
          placeholder: loc.word("FileList.descriptionPlaceholder", { default: "Enter description" }),
          onSend: async (text2) => onSave?.(text2),
          canRemove: false,
          canEdit
        }
      ) }),
      title: loc.word("Description"),
      trigger: "hover",
      children: children2
    }
  );
};
const fl_item__preview = "_fl_item__preview_kp8ey_1";
const fl_item__preview_background = "_fl_item__preview_background_kp8ey_1";
const styles$P = {
  fl_item__preview,
  fl_item__preview_background
};
const file_progress = "_file_progress_1bq2y_1";
const styles$O = {
  file_progress
};
const FileProgress = ({ view, file, size: size2, progress }) => {
  const width = useMemo$2(() => {
    if (view == "grid")
      switch (size2) {
        case "xs":
          return 30;
        case "sm":
          return 40;
        case "md":
          return 50;
        case "lg":
          return 60;
        case "xl":
          return 70;
      }
    switch (size2) {
      case "xs":
      case "sm":
        return 30;
      case "md":
        return 35;
      case "lg":
        return 40;
      case "xl":
        return 50;
    }
  }, [view, size2]);
  return /* @__PURE__ */ jsx$1(Progress, { width, type: "circle", percent: progress, className: styles$O.file_progress });
};
const FilePreview = ({ view, file, size: size2, progress, uploadStatus, loc, fileProvider, className, fileIconColor, onPreview, onRetryUpload }) => {
  const fileIconSize = useMemo$2(() => {
    if (view == "grid") return size2;
    switch (size2) {
      case "xs":
        return "xs";
      case "sm":
        return "sm";
      case "md":
        return "sm";
      case "lg":
        return "md";
      case "xl":
        return "lg";
      default:
        return size2;
    }
  }, [view, size2]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: combineClasses(styles$P.fl_item__preview, "flex flex-center relative w-100 c-pointer", className),
      "data-upload-status": uploadStatus,
      "data-size": size2,
      onClick: () => uploadStatus == FileUploadStatus.Uploaded && onPreview(),
      title: loc.word("File.clickToPreview", { default: "Click to preview" }),
      children: [
        file.isImage ? /* @__PURE__ */ jsx$1(Image$2, { fit: "cover", width: "100%", height: "100%", file, usePreview: true, resize: { w: 100 } }) : /* @__PURE__ */ jsx$1(FileIcon, { filename: file.extension, size: fileIconSize, bgColor: fileIconColor }),
        /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$P.fl_item__preview_background, "absolute t-0 l-0 r-0 b-0 flex flex-center fs-20"), children: [
          uploadStatus == FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(FileProgress, { view, file, progress, size: size2 }),
          uploadStatus == FileUploadStatus.Error && /* @__PURE__ */ jsx$1("div", { title: loc.word("File.retryUploadMsg", { default: "Retry upload" }), onClick: () => onRetryUpload(), children: /* @__PURE__ */ jsx$1(ReloadOutlined, {}) })
        ] })
      ]
    }
  );
};
const FileActions = ({ file, downloadable, replaceable, deletable, uploadStatus, loc, theme: theme2, size: size2, onReplace, onDownload, onUpload, onRemove, onAbort }) => {
  return /* @__PURE__ */ jsxs(Space, { size: size2 == "small" ? 2 : 5, children: [
    uploadStatus == FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(
      Button,
      {
        size: size2,
        type: "text",
        icon: /* @__PURE__ */ jsx$1(CloseCircleOutlined, {}),
        title: loc.word("Cancel"),
        onClick: () => onAbort(),
        className: "p-0"
      }
    ),
    replaceable && uploadStatus == FileUploadStatus.Uploaded && /* @__PURE__ */ jsx$1(
      Button,
      {
        size: size2,
        type: "text",
        icon: /* @__PURE__ */ jsx$1(UploadOutlined, { className: theme2 == "light" ? "color-white" : void 0 }),
        title: loc.word("File.replaceMsg", { default: "Replace file" }),
        onClick: () => onReplace(),
        className: "p-0"
      }
    ),
    downloadable && uploadStatus == FileUploadStatus.Uploaded && /* @__PURE__ */ jsx$1(
      Button,
      {
        size: size2,
        type: "text",
        icon: /* @__PURE__ */ jsx$1(CloudDownloadOutlined, { className: theme2 == "light" ? "color-white" : void 0 }),
        title: loc.word("Download"),
        onClick: () => onDownload(),
        className: "p-0"
      }
    ),
    uploadStatus == FileUploadStatus.Error && /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("File.uploadErrorMsg", { default: "Click to retry upload" }), children: /* @__PURE__ */ jsx$1(
      Button,
      {
        size: size2,
        type: "text",
        danger: true,
        icon: /* @__PURE__ */ jsx$1(ReloadOutlined, { className: theme2 == "light" ? "color-white" : void 0 }),
        onClick: () => onUpload(),
        className: "p-0"
      }
    ) }) }),
    deletable == true && uploadStatus != FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(
      Popconfirm,
      {
        title: loc.word("File.deleteConfirmation", { default: "Are you sure you want to delete this file?" }),
        onConfirm: () => onRemove(),
        children: /* @__PURE__ */ jsx$1(
          Button,
          {
            size: size2,
            type: "text",
            danger: true,
            icon: /* @__PURE__ */ jsx$1(DeleteFilled, {}),
            className: "p-0"
          }
        )
      }
    )
  ] });
};
const FileGridItem = ({ file, ...props }) => {
  const uploaderHandler = useRef(void 0);
  const [progress, setProgress] = useState$1(0);
  const [uploadStatus, setUploadStatus] = useState$1(file?.nativeFile != null ? FileUploadStatus.Uploading : FileUploadStatus.Uploaded);
  const retryUpload = useCallback(() => {
    setProgress(0);
    setUploadStatus(FileUploadStatus.Uploading);
  }, []);
  const handleFileReadyToUpload = useCallback(async () => {
    const res = await props.beforeUpload?.(file);
    if (res !== void 0 && res === false) return;
    await uploaderHandler.current?.upload();
  }, []);
  const fileContent = useMemo$2(() => /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$S.fl_grid_item, "flex align-center p-5 relative"), "data-size": props.size, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col flex-center flex-1 w-100", children: [
    /* @__PURE__ */ jsxs("div", { className: "relative w-100 h-100", children: [
      /* @__PURE__ */ jsx$1(
        FilePreview,
        {
          view: "grid",
          file,
          fileProvider: props.fileProvider,
          loc: props.loc,
          size: props.size,
          progress,
          uploadStatus,
          onPreview: () => props.onPreview(file),
          onRetryUpload: () => retryUpload(),
          fileIconColor: props.fileIconColor,
          className: styles$S.fl_grid_item__preview
        }
      ),
      /* @__PURE__ */ jsx$1("div", { className: styles$S.fl_grid_item_menu, children: /* @__PURE__ */ jsx$1(
        FileActions,
        {
          file,
          theme: "light",
          size: props.size != "xs" ? "middle" : "small",
          deletable: props.deletable,
          downloadable: props.downloadable,
          replaceable: props.replaceable,
          uploadStatus,
          loc: props.loc,
          onDownload: () => props.onDownload?.(file),
          onRemove: () => props.onRemove?.(file),
          onReplace: () => props.onReplace?.(file),
          onUpload: () => retryUpload(),
          onAbort: () => uploaderHandler.current?.abort()
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx$1("div", { className: "w-100 ellipsis", children: /* @__PURE__ */ jsx$1(
      FileName,
      {
        file,
        editable: props.editable,
        useExtension: true,
        onRename: async (name) => await props.onChange?.(file, { name }) ?? true,
        loc: props.loc,
        className: "text-center"
      }
    ) }),
    /* @__PURE__ */ jsx$1("div", { className: "w-100 fs-12", children: /* @__PURE__ */ jsx$1("div", { className: "flex flex-center ellipsis", children: uploadStatus == FileUploadStatus.Error ? /* @__PURE__ */ jsx$1("span", { className: "fs-12 color-danger", children: props.loc.word("File.uploadFailedLabel", { default: "Upload failed" }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      (props.dateCreatedVisible == true || props.descriptionVisible == true) && /* @__PURE__ */ jsxs("span", { className: "flex-1 mr-5", children: [
        props.dateCreatedVisible == true && /* @__PURE__ */ jsx$1(
          DateTime,
          {
            date: file.createdDate,
            format: file.createdDate?.isSame(moment(), "day") ? "LT" : "L",
            className: "color-secondary"
          }
        ),
        props.descriptionVisible == true && uploadStatus == FileUploadStatus.Uploaded && /* @__PURE__ */ jsx$1(
          FileDescriptionPopover,
          {
            loc: props.loc,
            file,
            onSave: async (description) => await props.onChange?.(file, { description }) ?? true,
            children: /* @__PURE__ */ jsx$1(InfoCircleOutlined, { className: combineClasses("ml-5", !isEmpty(file.description) ? "color-success" : void 0) })
          }
        )
      ] }),
      /* @__PURE__ */ jsx$1("span", { className: "color-secondary", children: Humanize.fileSize(file.size) })
    ] }) }) })
  ] }) }), [file, props]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    fileContent,
    uploadStatus == FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(
      FileUploader$1,
      {
        handler: (x) => uploaderHandler.current = x,
        autostart: false,
        file,
        onReady: handleFileReadyToUpload,
        onProgress: (x) => setProgress(Math.min(x.percent, 90)),
        onComplete: async ({ file: file2 }) => {
          file2.update(file2);
          setUploadStatus(FileUploadStatus.Uploaded);
          props.onUploaded?.(file2);
        },
        uploadArgs: props.uploadArgs,
        onAbort: () => {
          if (file.nativeFile) {
            setUploadStatus(FileUploadStatus.Error);
            props.onAborted?.(file);
          }
        },
        onError: (a) => {
          setUploadStatus(FileUploadStatus.Error);
          notification.error({ message: props.loc.word("Error occured"), duration: 2 });
        }
      }
    )
  ] });
};
const FileGridItem$1 = observer(FileGridItem);
const fl_drag_handle = "_fl_drag_handle_9wkje_1";
const fl_list_item = "_fl_list_item_9wkje_6";
const fl_list_item__preview = "_fl_list_item__preview_9wkje_10";
const fl_list_item__name = "_fl_list_item__name_9wkje_19";
const styles$N = {
  fl_drag_handle,
  fl_list_item,
  fl_list_item__preview,
  fl_list_item__name
};
var arrayWithHoles$1;
var hasRequiredArrayWithHoles$1;
function requireArrayWithHoles$1() {
  if (hasRequiredArrayWithHoles$1) return arrayWithHoles$1;
  hasRequiredArrayWithHoles$1 = 1;
  function _arrayWithHoles2(arr) {
    if (Array.isArray(arr)) return arr;
  }
  arrayWithHoles$1 = _arrayWithHoles2;
  return arrayWithHoles$1;
}
var iterableToArrayLimit$1;
var hasRequiredIterableToArrayLimit$1;
function requireIterableToArrayLimit$1() {
  if (hasRequiredIterableToArrayLimit$1) return iterableToArrayLimit$1;
  hasRequiredIterableToArrayLimit$1 = 1;
  function _iterableToArrayLimit2(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  iterableToArrayLimit$1 = _iterableToArrayLimit2;
  return iterableToArrayLimit$1;
}
var arrayLikeToArray$1;
var hasRequiredArrayLikeToArray$1;
function requireArrayLikeToArray$1() {
  if (hasRequiredArrayLikeToArray$1) return arrayLikeToArray$1;
  hasRequiredArrayLikeToArray$1 = 1;
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  arrayLikeToArray$1 = _arrayLikeToArray2;
  return arrayLikeToArray$1;
}
var unsupportedIterableToArray$1;
var hasRequiredUnsupportedIterableToArray$1;
function requireUnsupportedIterableToArray$1() {
  if (hasRequiredUnsupportedIterableToArray$1) return unsupportedIterableToArray$1;
  hasRequiredUnsupportedIterableToArray$1 = 1;
  var arrayLikeToArray2 = requireArrayLikeToArray$1();
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray2(o, minLen);
  }
  unsupportedIterableToArray$1 = _unsupportedIterableToArray2;
  return unsupportedIterableToArray$1;
}
var nonIterableRest$1;
var hasRequiredNonIterableRest$1;
function requireNonIterableRest$1() {
  if (hasRequiredNonIterableRest$1) return nonIterableRest$1;
  hasRequiredNonIterableRest$1 = 1;
  function _nonIterableRest2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  nonIterableRest$1 = _nonIterableRest2;
  return nonIterableRest$1;
}
var slicedToArray$1;
var hasRequiredSlicedToArray$1;
function requireSlicedToArray$1() {
  if (hasRequiredSlicedToArray$1) return slicedToArray$1;
  hasRequiredSlicedToArray$1 = 1;
  var arrayWithHoles2 = requireArrayWithHoles$1();
  var iterableToArrayLimit2 = requireIterableToArrayLimit$1();
  var unsupportedIterableToArray2 = requireUnsupportedIterableToArray$1();
  var nonIterableRest2 = requireNonIterableRest$1();
  function _slicedToArray2(arr, i) {
    return arrayWithHoles2(arr) || iterableToArrayLimit2(arr, i) || unsupportedIterableToArray2(arr, i) || nonIterableRest2();
  }
  slicedToArray$1 = _slicedToArray2;
  return slicedToArray$1;
}
var slicedToArrayExports = requireSlicedToArray$1();
const _slicedToArray$2 = /* @__PURE__ */ getDefaultExportFromCjs(slicedToArrayExports);
var classCallCheck$1;
var hasRequiredClassCallCheck$1;
function requireClassCallCheck$1() {
  if (hasRequiredClassCallCheck$1) return classCallCheck$1;
  hasRequiredClassCallCheck$1 = 1;
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  classCallCheck$1 = _classCallCheck2;
  return classCallCheck$1;
}
var classCallCheckExports = requireClassCallCheck$1();
const _classCallCheck$2 = /* @__PURE__ */ getDefaultExportFromCjs(classCallCheckExports);
var createClass$1;
var hasRequiredCreateClass$1;
function requireCreateClass$1() {
  if (hasRequiredCreateClass$1) return createClass$1;
  hasRequiredCreateClass$1 = 1;
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties2(Constructor, staticProps);
    return Constructor;
  }
  createClass$1 = _createClass2;
  return createClass$1;
}
var createClassExports = requireCreateClass$1();
const _createClass$2 = /* @__PURE__ */ getDefaultExportFromCjs(createClassExports);
var _typeof_1;
var hasRequired_typeof$1;
function require_typeof$1() {
  if (hasRequired_typeof$1) return _typeof_1;
  hasRequired_typeof$1 = 1;
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof_1 = _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof_1 = _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  _typeof_1 = _typeof2;
  return _typeof_1;
}
var assertThisInitialized;
var hasRequiredAssertThisInitialized;
function requireAssertThisInitialized() {
  if (hasRequiredAssertThisInitialized) return assertThisInitialized;
  hasRequiredAssertThisInitialized = 1;
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  assertThisInitialized = _assertThisInitialized2;
  return assertThisInitialized;
}
var possibleConstructorReturn;
var hasRequiredPossibleConstructorReturn;
function requirePossibleConstructorReturn() {
  if (hasRequiredPossibleConstructorReturn) return possibleConstructorReturn;
  hasRequiredPossibleConstructorReturn = 1;
  var _typeof2 = require_typeof$1();
  var assertThisInitialized2 = requireAssertThisInitialized();
  function _possibleConstructorReturn2(self2, call2) {
    if (call2 && (_typeof2(call2) === "object" || typeof call2 === "function")) {
      return call2;
    }
    return assertThisInitialized2(self2);
  }
  possibleConstructorReturn = _possibleConstructorReturn2;
  return possibleConstructorReturn;
}
var possibleConstructorReturnExports = requirePossibleConstructorReturn();
const _possibleConstructorReturn$2 = /* @__PURE__ */ getDefaultExportFromCjs(possibleConstructorReturnExports);
var getPrototypeOf;
var hasRequiredGetPrototypeOf;
function requireGetPrototypeOf() {
  if (hasRequiredGetPrototypeOf) return getPrototypeOf;
  hasRequiredGetPrototypeOf = 1;
  function _getPrototypeOf2(o) {
    getPrototypeOf = _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  getPrototypeOf = _getPrototypeOf2;
  return getPrototypeOf;
}
var getPrototypeOfExports = requireGetPrototypeOf();
const _getPrototypeOf$2 = /* @__PURE__ */ getDefaultExportFromCjs(getPrototypeOfExports);
var setPrototypeOf;
var hasRequiredSetPrototypeOf;
function requireSetPrototypeOf() {
  if (hasRequiredSetPrototypeOf) return setPrototypeOf;
  hasRequiredSetPrototypeOf = 1;
  function _setPrototypeOf2(o, p) {
    setPrototypeOf = _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  setPrototypeOf = _setPrototypeOf2;
  return setPrototypeOf;
}
var inherits;
var hasRequiredInherits;
function requireInherits() {
  if (hasRequiredInherits) return inherits;
  hasRequiredInherits = 1;
  var setPrototypeOf2 = requireSetPrototypeOf();
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) setPrototypeOf2(subClass, superClass);
  }
  inherits = _inherits2;
  return inherits;
}
var inheritsExports = requireInherits();
const _inherits$2 = /* @__PURE__ */ getDefaultExportFromCjs(inheritsExports);
var isNativeFunction;
var hasRequiredIsNativeFunction;
function requireIsNativeFunction() {
  if (hasRequiredIsNativeFunction) return isNativeFunction;
  hasRequiredIsNativeFunction = 1;
  function _isNativeFunction2(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  isNativeFunction = _isNativeFunction2;
  return isNativeFunction;
}
var isNativeReflectConstruct;
var hasRequiredIsNativeReflectConstruct;
function requireIsNativeReflectConstruct() {
  if (hasRequiredIsNativeReflectConstruct) return isNativeReflectConstruct;
  hasRequiredIsNativeReflectConstruct = 1;
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  isNativeReflectConstruct = _isNativeReflectConstruct2;
  return isNativeReflectConstruct;
}
var construct;
var hasRequiredConstruct;
function requireConstruct() {
  if (hasRequiredConstruct) return construct;
  hasRequiredConstruct = 1;
  var setPrototypeOf2 = requireSetPrototypeOf();
  var isNativeReflectConstruct2 = requireIsNativeReflectConstruct();
  function _construct2(Parent, args, Class) {
    if (isNativeReflectConstruct2()) {
      construct = _construct2 = Reflect.construct;
    } else {
      construct = _construct2 = function _construct3(Parent2, args2, Class2) {
        var a = [null];
        a.push.apply(a, args2);
        var Constructor = Function.bind.apply(Parent2, a);
        var instance = new Constructor();
        if (Class2) setPrototypeOf2(instance, Class2.prototype);
        return instance;
      };
    }
    return _construct2.apply(null, arguments);
  }
  construct = _construct2;
  return construct;
}
var wrapNativeSuper;
var hasRequiredWrapNativeSuper;
function requireWrapNativeSuper() {
  if (hasRequiredWrapNativeSuper) return wrapNativeSuper;
  hasRequiredWrapNativeSuper = 1;
  var getPrototypeOf2 = requireGetPrototypeOf();
  var setPrototypeOf2 = requireSetPrototypeOf();
  var isNativeFunction2 = requireIsNativeFunction();
  var construct2 = requireConstruct();
  function _wrapNativeSuper2(Class) {
    var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
    wrapNativeSuper = _wrapNativeSuper2 = function _wrapNativeSuper3(Class2) {
      if (Class2 === null || !isNativeFunction2(Class2)) return Class2;
      if (typeof Class2 !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class2)) return _cache.get(Class2);
        _cache.set(Class2, Wrapper);
      }
      function Wrapper() {
        return construct2(Class2, arguments, getPrototypeOf2(this).constructor);
      }
      Wrapper.prototype = Object.create(Class2.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return setPrototypeOf2(Wrapper, Class2);
    };
    return _wrapNativeSuper2(Class);
  }
  wrapNativeSuper = _wrapNativeSuper2;
  return wrapNativeSuper;
}
var wrapNativeSuperExports = requireWrapNativeSuper();
const _wrapNativeSuper$1 = /* @__PURE__ */ getDefaultExportFromCjs(wrapNativeSuperExports);
function _callSuper$g(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$i() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var isProduction$1 = process.env.NODE_ENV === "production";
var prefix$2 = "Invariant failed";
var RbdInvariant = /* @__PURE__ */ (function(_Error) {
  function RbdInvariant2(message2) {
    var _this;
    _classCallCheck$2(this, RbdInvariant2);
    _this = _callSuper$g(this, RbdInvariant2);
    _this.message = message2;
    return _this;
  }
  _inherits$2(RbdInvariant2, _Error);
  return _createClass$2(RbdInvariant2, [{
    key: "toString",
    value: function toString2() {
      return this.message;
    }
  }]);
})(/* @__PURE__ */ _wrapNativeSuper$1(Error));
function rbdInvariant(condition, message2) {
  if (condition) {
    return;
  }
  if (isProduction$1) {
    throw new RbdInvariant(prefix$2);
  } else {
    throw new RbdInvariant("".concat(prefix$2, ": ").concat(message2 || ""));
  }
}
var DragDropContext$2 = /* @__PURE__ */ createContext(null);
function useDragDropContext() {
  var value = useContext(DragDropContext$2);
  rbdInvariant(value !== null, "Unable to find DragDropContext context");
  return value;
}
function DragDropContextProvider(_ref) {
  var children2 = _ref.children, contextId = _ref.contextId, getDragState = _ref.getDragState, startKeyboardDrag = _ref.startKeyboardDrag, droppableRegistry = _ref.droppableRegistry;
  var value = useMemo$2(function() {
    return {
      contextId,
      getDragState,
      startKeyboardDrag,
      droppableRegistry
    };
  }, [contextId, getDragState, startKeyboardDrag, droppableRegistry]);
  return /* @__PURE__ */ React__default.createElement(DragDropContext$2.Provider, {
    value
  }, children2);
}
function getDraggableDimensions(element) {
  var _window$getComputedSt = window.getComputedStyle(element), margin = _window$getComputedSt.margin;
  var rect = element.getBoundingClientRect();
  return {
    margin,
    rect
  };
}
function useDraggableDimensions() {
  var _useDragDropContext = useDragDropContext(), getDragState = _useDragDropContext.getDragState;
  var dragState = getDragState();
  if (!dragState.isDragging) {
    return null;
  }
  return dragState.draggableDimensions;
}
var noop$4 = function noop() {
};
function createCleanupManager() {
  var cleanupFn = noop$4;
  var setCleanupFn = function setCleanupFn2(newCleanupFn) {
    cleanupFn = newCleanupFn;
  };
  var runCleanupFn = function runCleanupFn2() {
    cleanupFn();
    cleanupFn = noop$4;
  };
  return {
    setCleanupFn,
    runCleanupFn
  };
}
function useCleanupFn() {
  var _useState = useState$1(createCleanupManager), _useState2 = _slicedToArray$2(_useState, 1), cleanupManager = _useState2[0];
  useEffect(function() {
    return cleanupManager.runCleanupFn;
  }, [cleanupManager.runCleanupFn]);
  return cleanupManager;
}
var attributes$1 = {
  draggable: {
    contextId: "data-rbd-draggable-context-id",
    id: "data-rbd-draggable-id"
  },
  dragHandle: {
    contextId: "data-rbd-drag-handle-context-id",
    draggableId: "data-rbd-drag-handle-draggable-id"
  },
  droppable: {
    contextId: "data-rbd-droppable-context-id",
    id: "data-rbd-droppable-id"
  },
  placeholder: {
    contextId: "data-rbd-placeholder-context-id"
  }
};
var customAttributes = {
  draggable: {
    droppableId: "data-rbd-draggable-droppable-id",
    index: "data-rbd-draggable-index"
  },
  dropIndicator: "data-rbd-drop-indicator",
  droppable: {
    direction: "data-rbd-droppable-direction",
    type: "data-rbd-droppable-type"
  }
};
function getAttribute(element, attribute) {
  var value = element.getAttribute(attribute);
  rbdInvariant(value !== null, "Expected '".concat(attribute, "' to be present"));
  return value;
}
function setAttributes(element, attributes2) {
  for (var _i = 0, _Object$entries = Object.entries(attributes2); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
    element.setAttribute(key, value);
  }
  return function() {
    for (var _i2 = 0, _Object$keys = Object.keys(attributes2); _i2 < _Object$keys.length; _i2++) {
      var _key = _Object$keys[_i2];
      element.removeAttribute(_key);
    }
  };
}
function getSelector() {
  for (var _len = arguments.length, fragments = new Array(_len), _key = 0; _key < _len; _key++) {
    fragments[_key] = arguments[_key];
  }
  var parts = fragments.map(function(_ref) {
    var attribute = _ref.attribute, value = _ref.value;
    if (value) {
      return "[".concat(attribute, '="').concat(CSS.escape(value), '"]');
    }
    return "[".concat(attribute, "]");
  });
  return parts.join("");
}
function findElement() {
  var selector = getSelector.apply(void 0, arguments);
  return document.querySelector(selector);
}
function findElementAll() {
  var selector = getSelector.apply(void 0, arguments);
  return Array.from(document.querySelectorAll(selector));
}
function getElement() {
  var result = findElement.apply(void 0, arguments);
  rbdInvariant(result, "There is a matching HTMLElement for selector " + getSelector.apply(void 0, arguments));
  return result;
}
function findDragHandle(_ref) {
  var contextId = _ref.contextId, draggableId = _ref.draggableId;
  return findElement({
    attribute: attributes$1.dragHandle.contextId,
    value: contextId
  }, {
    attribute: attributes$1.dragHandle.draggableId,
    value: draggableId
  });
}
function getClosestAbsolutePositionedElement(element) {
  var _getComputedStyle = getComputedStyle(element), position2 = _getComputedStyle.position;
  if (position2 === "absolute") {
    return element;
  }
  var parentElement = element.parentElement;
  if (parentElement instanceof HTMLElement) {
    return getClosestAbsolutePositionedElement(parentElement);
  }
  return null;
}
function getClosestPositionedElement(_ref) {
  var _getClosestAbsolutePo;
  var element = _ref.element, mode = _ref.mode;
  if (mode === "standard") {
    return element;
  }
  return (_getClosestAbsolutePo = getClosestAbsolutePositionedElement(element)) !== null && _getClosestAbsolutePo !== void 0 ? _getClosestAbsolutePo : element;
}
function cancelPointerDrag() {
  window.dispatchEvent(new DragEvent("dragend"));
}
var objectWithoutPropertiesLoose$1;
var hasRequiredObjectWithoutPropertiesLoose$1;
function requireObjectWithoutPropertiesLoose$1() {
  if (hasRequiredObjectWithoutPropertiesLoose$1) return objectWithoutPropertiesLoose$1;
  hasRequiredObjectWithoutPropertiesLoose$1 = 1;
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  objectWithoutPropertiesLoose$1 = _objectWithoutPropertiesLoose2;
  return objectWithoutPropertiesLoose$1;
}
var objectWithoutProperties$1;
var hasRequiredObjectWithoutProperties$1;
function requireObjectWithoutProperties$1() {
  if (hasRequiredObjectWithoutProperties$1) return objectWithoutProperties$1;
  hasRequiredObjectWithoutProperties$1 = 1;
  var objectWithoutPropertiesLoose2 = requireObjectWithoutPropertiesLoose$1();
  function _objectWithoutProperties2(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  objectWithoutProperties$1 = _objectWithoutProperties2;
  return objectWithoutProperties$1;
}
var objectWithoutPropertiesExports = requireObjectWithoutProperties$1();
const _objectWithoutProperties$2 = /* @__PURE__ */ getDefaultExportFromCjs(objectWithoutPropertiesExports);
var defineProperty$1;
var hasRequiredDefineProperty$1;
function requireDefineProperty$1() {
  if (hasRequiredDefineProperty$1) return defineProperty$1;
  hasRequiredDefineProperty$1 = 1;
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  defineProperty$1 = _defineProperty2;
  return defineProperty$1;
}
var definePropertyExports = requireDefineProperty$1();
const _defineProperty$2 = /* @__PURE__ */ getDefaultExportFromCjs(definePropertyExports);
function ownKeys$q(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$o(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$q(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var getDistanceToEdge = {
  top: function top(rect, client2) {
    return Math.abs(client2.y - rect.top);
  },
  right: function right(rect, client2) {
    return Math.abs(rect.right - client2.x);
  },
  bottom: function bottom(rect, client2) {
    return Math.abs(rect.bottom - client2.y);
  },
  left: function left(rect, client2) {
    return Math.abs(client2.x - rect.left);
  }
};
var uniqueKey = Symbol("closestEdge");
function attachClosestEdge(userData, _ref) {
  var _entries$sort$0$edge, _entries$sort$;
  var element = _ref.element, input2 = _ref.input, allowedEdges = _ref.allowedEdges;
  var client2 = {
    x: input2.clientX,
    y: input2.clientY
  };
  var rect = element.getBoundingClientRect();
  var entries = allowedEdges.map(function(edge) {
    return {
      edge,
      value: getDistanceToEdge[edge](rect, client2)
    };
  });
  var addClosestEdge = (_entries$sort$0$edge = (_entries$sort$ = entries.sort(function(a, b) {
    return a.value - b.value;
  })[0]) === null || _entries$sort$ === void 0 ? void 0 : _entries$sort$.edge) !== null && _entries$sort$0$edge !== void 0 ? _entries$sort$0$edge : null;
  return _objectSpread$o(_objectSpread$o({}, userData), {}, _defineProperty$2({}, uniqueKey, addClosestEdge));
}
function extractClosestEdge(userData) {
  var _ref2;
  return (_ref2 = userData[uniqueKey]) !== null && _ref2 !== void 0 ? _ref2 : null;
}
var privateKey$1 = Symbol("DraggableData");
function isDraggableData(data2) {
  return data2[privateKey$1] === true;
}
function useDraggableData(_ref) {
  var draggableId = _ref.draggableId, droppableId = _ref.droppableId, getIndex2 = _ref.getIndex, contextId = _ref.contextId, type4 = _ref.type;
  return useMemo$2(function() {
    return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, privateKey$1, true), "draggableId", draggableId), "droppableId", droppableId), "getIndex", getIndex2), "contextId", contextId), "type", type4);
  }, [draggableId, droppableId, getIndex2, contextId, type4]);
}
var privateKey = Symbol("DroppableData");
function isDroppableData(data2) {
  return data2[privateKey] === true;
}
function useDroppableData(_ref) {
  var contextId = _ref.contextId, droppableId = _ref.droppableId, getIsDropDisabled = _ref.getIsDropDisabled;
  return useMemo$2(function() {
    return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, privateKey, true), "contextId", contextId), "droppableId", droppableId), "getIsDropDisabled", getIsDropDisabled);
  }, [contextId, droppableId, getIsDropDisabled]);
}
function findAllDraggables(_ref) {
  var droppableId = _ref.droppableId, contextId = _ref.contextId;
  return findElementAll({
    attribute: attributes$1.draggable.contextId,
    value: contextId
  }, {
    attribute: customAttributes.draggable.droppableId,
    value: droppableId
  });
}
var _excluded$g = ["droppableId", "getIndex"], _excluded2$4 = ["contextId", "droppableId"];
function getDraggableLocationFromDraggableData(_ref) {
  var droppableId = _ref.droppableId, getIndex2 = _ref.getIndex, data2 = _objectWithoutProperties$2(_ref, _excluded$g);
  var index2 = getIndex2();
  var closestEdge = extractClosestEdge(
    /**
     * TypeScript doesn't like this without casting.
     *
     * The IDE doesn't have an issue, but if you try to build it then
     * there will be an error.
     */
    data2
  );
  var isForwardEdge = closestEdge === "bottom" || closestEdge === "right";
  if (isForwardEdge) {
    index2 += 1;
  }
  return {
    droppableId,
    index: index2
  };
}
function getDraggableLocationFromDroppableData(_ref2) {
  var contextId = _ref2.contextId, droppableId = _ref2.droppableId, data2 = _objectWithoutProperties$2(_ref2, _excluded2$4);
  var draggables = findAllDraggables({
    contextId,
    droppableId
  });
  if (draggables.length === 0) {
    return {
      droppableId,
      index: 0
    };
  }
  var closestEdge = extractClosestEdge(data2);
  var isCloserToStart = closestEdge === "top" || closestEdge === "left";
  if (isCloserToStart) {
    return {
      droppableId,
      index: 0
    };
  }
  var biggestIndex = draggables.reduce(function(max2, draggable2) {
    var draggableIndex = parseInt(getAttribute(draggable2, customAttributes.draggable.index), 10);
    return Math.max(max2, draggableIndex);
  }, 0);
  return {
    droppableId,
    index: biggestIndex + 1
  };
}
function getDraggableLocation(location2) {
  var dropTargets = location2.dropTargets;
  if (dropTargets.length === 0) {
    return null;
  }
  var target = dropTargets[0];
  if (isDraggableData(target.data)) {
    return getDraggableLocationFromDraggableData(target.data);
  }
  if (isDroppableData(target.data)) {
    return getDraggableLocationFromDroppableData(target.data);
  }
  return null;
}
function isSameLocation(a, b) {
  if ((a === null || a === void 0 ? void 0 : a.droppableId) !== (b === null || b === void 0 ? void 0 : b.droppableId)) {
    return false;
  }
  if ((a === null || a === void 0 ? void 0 : a.index) !== (b === null || b === void 0 ? void 0 : b.index)) {
    return false;
  }
  return true;
}
function createDroppableRegistry() {
  var droppableMap = /* @__PURE__ */ new Map();
  var getEntry = function getEntry2(_ref) {
    var _droppableMap$get;
    var droppableId = _ref.droppableId;
    return (_droppableMap$get = droppableMap.get(droppableId)) !== null && _droppableMap$get !== void 0 ? _droppableMap$get : null;
  };
  var updateListener = null;
  var setUpdateListener = function setUpdateListener2(listener) {
    updateListener = listener;
  };
  var register3 = function register4(entry) {
    var _updateListener;
    droppableMap.set(entry.droppableId, entry);
    (_updateListener = updateListener) === null || _updateListener === void 0 || _updateListener(entry);
    return function() {
      droppableMap.delete(entry.droppableId);
    };
  };
  return {
    getEntry,
    register: register3,
    setUpdateListener
  };
}
function useDroppableRegistry() {
  var _useState = useState$1(createDroppableRegistry), _useState2 = _slicedToArray$2(_useState, 1), droppableRegistry = _useState2[0];
  return droppableRegistry;
}
var dist$1 = {};
var bind = {};
var hasRequiredBind;
function requireBind() {
  if (hasRequiredBind) return bind;
  hasRequiredBind = 1;
  Object.defineProperty(bind, "__esModule", { value: true });
  bind.bind = void 0;
  function bind$12(target, _a2) {
    var type4 = _a2.type, listener = _a2.listener, options = _a2.options;
    target.addEventListener(type4, listener, options);
    return function unbind() {
      target.removeEventListener(type4, listener, options);
    };
  }
  bind.bind = bind$12;
  return bind;
}
var bindAll = {};
var hasRequiredBindAll;
function requireBindAll() {
  if (hasRequiredBindAll) return bindAll;
  hasRequiredBindAll = 1;
  var __assign2 = bindAll && bindAll.__assign || function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  Object.defineProperty(bindAll, "__esModule", { value: true });
  bindAll.bindAll = void 0;
  var bind_1 = /* @__PURE__ */ requireBind();
  function toOptions(value) {
    if (typeof value === "undefined") {
      return void 0;
    }
    if (typeof value === "boolean") {
      return {
        capture: value
      };
    }
    return value;
  }
  function getBinding(original, sharedOptions) {
    if (sharedOptions == null) {
      return original;
    }
    var binding = __assign2(__assign2({}, original), { options: __assign2(__assign2({}, toOptions(sharedOptions)), toOptions(original.options)) });
    return binding;
  }
  function bindAll$1(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
      var binding = getBinding(original, sharedOptions);
      return (0, bind_1.bind)(target, binding);
    });
    return function unbindAll() {
      unbinds.forEach(function(unbind) {
        return unbind();
      });
    };
  }
  bindAll.bindAll = bindAll$1;
  return bindAll;
}
var hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist$1;
  hasRequiredDist$1 = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.bindAll = exports$1.bind = void 0;
    var bind_1 = /* @__PURE__ */ requireBind();
    Object.defineProperty(exports$1, "bind", { enumerable: true, get: function() {
      return bind_1.bind;
    } });
    var bind_all_1 = /* @__PURE__ */ requireBindAll();
    Object.defineProperty(exports$1, "bindAll", { enumerable: true, get: function() {
      return bind_all_1.bindAll;
    } });
  })(dist$1);
  return dist$1;
}
var distExports$1 = /* @__PURE__ */ requireDist$1();
function combine$1() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function cleanup2() {
    fns.forEach(function(fn) {
      return fn();
    });
  };
}
var honeyPotDataAttribute = "data-pdnd-honey-pot";
function isHoneyPotElement(target) {
  return target instanceof Element && target.hasAttribute(honeyPotDataAttribute);
}
function getElementFromPointWithoutHoneypot(client2) {
  var _document$elementsFro = document.elementsFromPoint(client2.x, client2.y), _document$elementsFro2 = _slicedToArray$2(_document$elementsFro, 2), top2 = _document$elementsFro2[0], second = _document$elementsFro2[1];
  if (!top2) {
    return null;
  }
  if (isHoneyPotElement(top2)) {
    return second !== null && second !== void 0 ? second : null;
  }
  return top2;
}
var maxZIndex = 2147483647;
function ownKeys$p(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$n(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$p(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var honeyPotSize = 2;
var halfHoneyPotSize = honeyPotSize / 2;
function floorToClosestPixel(point) {
  return {
    x: Math.floor(point.x),
    y: Math.floor(point.y)
  };
}
function pullBackByHalfHoneyPotSize(point) {
  return {
    x: point.x - halfHoneyPotSize,
    y: point.y - halfHoneyPotSize
  };
}
function preventGoingBackwardsOffScreen(point) {
  return {
    x: Math.max(point.x, 0),
    y: Math.max(point.y, 0)
  };
}
function preventGoingForwardsOffScreen(point) {
  return {
    x: Math.min(point.x, window.innerWidth - honeyPotSize),
    y: Math.min(point.y, window.innerHeight - honeyPotSize)
  };
}
function getHoneyPotRectFor(_ref) {
  var client2 = _ref.client;
  var point = preventGoingForwardsOffScreen(preventGoingBackwardsOffScreen(pullBackByHalfHoneyPotSize(floorToClosestPixel(client2))));
  return DOMRect.fromRect({
    x: point.x,
    y: point.y,
    width: honeyPotSize,
    height: honeyPotSize
  });
}
function getRectStyles(_ref2) {
  var clientRect = _ref2.clientRect;
  return {
    left: "".concat(clientRect.left, "px"),
    top: "".concat(clientRect.top, "px"),
    width: "".concat(clientRect.width, "px"),
    height: "".concat(clientRect.height, "px")
  };
}
function isWithin(_ref3) {
  var client2 = _ref3.client, clientRect = _ref3.clientRect;
  return (
    // is within horizontal bounds
    client2.x >= clientRect.x && client2.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client2.y >= clientRect.y && client2.y <= clientRect.y + clientRect.height
  );
}
function mountHoneyPot(_ref4) {
  var initial2 = _ref4.initial;
  var element = document.createElement("div");
  element.setAttribute(honeyPotDataAttribute, "true");
  var clientRect = getHoneyPotRectFor({
    client: initial2
  });
  Object.assign(element.style, _objectSpread$n(_objectSpread$n({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: "transparent",
    position: "fixed",
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: "border-box"
  }, getRectStyles({
    clientRect
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: "auto",
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: maxZIndex
  }));
  document.body.appendChild(element);
  var unbindPointerMove = distExports$1.bind(window, {
    type: "pointermove",
    listener: function listener(event) {
      var client2 = {
        x: event.clientX,
        y: event.clientY
      };
      clientRect = getHoneyPotRectFor({
        client: client2
      });
      Object.assign(element.style, getRectStyles({
        clientRect
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: true
    }
  });
  return function finish(_ref5) {
    var current = _ref5.current;
    unbindPointerMove();
    if (isWithin({
      client: current,
      clientRect
    })) {
      element.remove();
      return;
    }
    function cleanup2() {
      unbindPostDragEvents();
      element.remove();
    }
    var unbindPostDragEvents = distExports$1.bindAll(window, [
      {
        type: "pointerdown",
        listener: cleanup2
      },
      {
        type: "pointermove",
        listener: cleanup2
      },
      {
        type: "focusin",
        listener: cleanup2
      },
      {
        type: "focusout",
        listener: cleanup2
      },
      // a 'pointerdown' should happen before 'dragstart', but just being super safe
      {
        type: "dragstart",
        listener: cleanup2
      },
      // if the user has dragged something out of the window
      // and then is dragging something back into the window
      // the first events we will see are "dragenter" (and then "dragover").
      // So if we see any of these we need to clear the post drag fix.
      {
        type: "dragenter",
        listener: cleanup2
      },
      {
        type: "dragover",
        listener: cleanup2
      }
      // Not adding a "wheel" event listener, as "wheel" by itself does not
      // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: true
    });
  };
}
function makeHoneyPotFix() {
  var latestPointerMove = null;
  function bindEvents() {
    latestPointerMove = null;
    return distExports$1.bind(window, {
      type: "pointermove",
      listener: function listener(event) {
        latestPointerMove = {
          x: event.clientX,
          y: event.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: true
      }
    });
  }
  function getOnPostDispatch() {
    var finish = null;
    return function onPostEvent(_ref6) {
      var eventName = _ref6.eventName, payload = _ref6.payload;
      if (eventName === "onDragStart") {
        var input2 = payload.location.initial.input;
        var initial2 = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
          x: input2.clientX,
          y: input2.clientY
        };
        finish = mountHoneyPot({
          initial: initial2
        });
      }
      if (eventName === "onDrop") {
        var _finish;
        var _input = payload.location.current.input;
        (_finish = finish) === null || _finish === void 0 || _finish({
          current: {
            x: _input.clientX,
            y: _input.clientY
          }
        });
        finish = null;
        latestPointerMove = null;
      }
    };
  }
  return {
    bindEvents,
    getOnPostDispatch
  };
}
var arrayWithoutHoles$1;
var hasRequiredArrayWithoutHoles$1;
function requireArrayWithoutHoles$1() {
  if (hasRequiredArrayWithoutHoles$1) return arrayWithoutHoles$1;
  hasRequiredArrayWithoutHoles$1 = 1;
  var arrayLikeToArray2 = requireArrayLikeToArray$1();
  function _arrayWithoutHoles2(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray2(arr);
  }
  arrayWithoutHoles$1 = _arrayWithoutHoles2;
  return arrayWithoutHoles$1;
}
var iterableToArray$1;
var hasRequiredIterableToArray$1;
function requireIterableToArray$1() {
  if (hasRequiredIterableToArray$1) return iterableToArray$1;
  hasRequiredIterableToArray$1 = 1;
  function _iterableToArray2(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }
  iterableToArray$1 = _iterableToArray2;
  return iterableToArray$1;
}
var nonIterableSpread$1;
var hasRequiredNonIterableSpread$1;
function requireNonIterableSpread$1() {
  if (hasRequiredNonIterableSpread$1) return nonIterableSpread$1;
  hasRequiredNonIterableSpread$1 = 1;
  function _nonIterableSpread2() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  nonIterableSpread$1 = _nonIterableSpread2;
  return nonIterableSpread$1;
}
var toConsumableArray$1;
var hasRequiredToConsumableArray$1;
function requireToConsumableArray$1() {
  if (hasRequiredToConsumableArray$1) return toConsumableArray$1;
  hasRequiredToConsumableArray$1 = 1;
  var arrayWithoutHoles2 = requireArrayWithoutHoles$1();
  var iterableToArray2 = requireIterableToArray$1();
  var unsupportedIterableToArray2 = requireUnsupportedIterableToArray$1();
  var nonIterableSpread2 = requireNonIterableSpread$1();
  function _toConsumableArray2(arr) {
    return arrayWithoutHoles2(arr) || iterableToArray2(arr) || unsupportedIterableToArray2(arr) || nonIterableSpread2();
  }
  toConsumableArray$1 = _toConsumableArray2;
  return toConsumableArray$1;
}
var toConsumableArrayExports = requireToConsumableArray$1();
const _toConsumableArray$2 = /* @__PURE__ */ getDefaultExportFromCjs(toConsumableArrayExports);
function once(fn) {
  var cache2 = null;
  return function wrapped() {
    if (!cache2) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = fn.apply(this, args);
      cache2 = {
        result
      };
    }
    return cache2.result;
  };
}
var isFirefox = once(function isFirefox2() {
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  return navigator.userAgent.includes("Firefox");
});
var isSafari = once(function isSafari2() {
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  var _navigator = navigator, userAgent = _navigator.userAgent;
  return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});
var symbols = {
  isLeavingWindow: Symbol("leaving"),
  isEnteringWindow: Symbol("entering")
};
function isLeavingWindowInSafari(_ref2) {
  var dragLeave = _ref2.dragLeave;
  if (!isSafari()) {
    return false;
  }
  return dragLeave.hasOwnProperty(symbols.isLeavingWindow);
}
(function fixSafari() {
  if (typeof window === "undefined") {
    return;
  }
  if (process.env.NODE_ENV === "test") {
    return;
  }
  if (!isSafari()) {
    return;
  }
  function getInitialState() {
    return {
      enterCount: 0,
      isOverWindow: false
    };
  }
  var state = getInitialState();
  function resetState() {
    state = getInitialState();
  }
  distExports$1.bindAll(
    window,
    [{
      type: "dragstart",
      listener: function listener() {
        state.enterCount = 0;
        state.isOverWindow = true;
      }
    }, {
      type: "drop",
      listener: resetState
    }, {
      type: "dragend",
      listener: resetState
    }, {
      type: "dragenter",
      listener: function listener(event) {
        if (!state.isOverWindow && state.enterCount === 0) {
          event[symbols.isEnteringWindow] = true;
        }
        state.isOverWindow = true;
        state.enterCount++;
      }
    }, {
      type: "dragleave",
      listener: function listener(event) {
        state.enterCount--;
        if (state.isOverWindow && state.enterCount === 0) {
          event[symbols.isLeavingWindow] = true;
          state.isOverWindow = false;
        }
      }
    }],
    // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
      capture: true
    }
  );
})();
function isNodeLike(target) {
  return "nodeName" in target;
}
function isFromAnotherWindow(eventTarget) {
  return isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}
function isLeavingWindow(_ref) {
  var dragLeave = _ref.dragLeave;
  var type4 = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
  if (type4 !== "dragleave") {
    return false;
  }
  if (isSafari()) {
    return isLeavingWindowInSafari({
      dragLeave
    });
  }
  if (relatedTarget == null) {
    return true;
  }
  if (isFirefox()) {
    return isFromAnotherWindow(relatedTarget);
  }
  return relatedTarget instanceof HTMLIFrameElement;
}
function getBindingsForBrokenDrags(_ref) {
  var onDragEnd2 = _ref.onDragEnd;
  return [
    // ## Detecting drag ending for removed draggables
    //
    // If a draggable element is removed during a drag and the user drops:
    // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
    // 2. if not over a valid drop target (or cancelled): we get nothing
    // The "dragend" event will not fire on the source draggable if it has been
    // removed from the DOM.
    // So we need to figure out if a drag operation has finished by looking at other events
    // We can do this by looking at other events
    // ### First detection: "pointermove" events
    // 1. "pointermove" events cannot fire during a drag and drop operation
    // according to the spec. So if we get a "pointermove" it means that
    // the drag and drop operations has finished. So if we get a "pointermove"
    // we know that the drag is over
    // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
    // other pointer events. However, firefox will allow a few
    // pointer event to get through after a drag starts.
    // The most I've seen is 3
    {
      type: "pointermove",
      listener: /* @__PURE__ */ (function() {
        var callCount = 0;
        return function listener() {
          if (callCount < 20) {
            callCount++;
            return;
          }
          onDragEnd2();
        };
      })()
    },
    // ### Second detection: "pointerdown" events
    // If we receive this event then we know that a drag operation has finished
    // and potentially another one is about to start.
    // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
    {
      type: "pointerdown",
      listener: onDragEnd2
    }
  ];
}
function getInput(event) {
  return {
    altKey: event.altKey,
    button: event.button,
    buttons: event.buttons,
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    clientX: event.clientX,
    clientY: event.clientY,
    pageX: event.pageX,
    pageY: event.pageY
  };
}
var rafSchd = function rafSchd2(fn) {
  var lastArgs = [];
  var frameId = null;
  var wrapperFn = function wrapperFn2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    if (frameId) {
      return;
    }
    frameId = requestAnimationFrame(function() {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };
  wrapperFn.cancel = function() {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
  };
  return wrapperFn;
};
var scheduleOnDrag = rafSchd(function(fn) {
  return fn();
});
var dragStart = /* @__PURE__ */ (function() {
  var scheduled = null;
  function schedule2(fn) {
    var frameId = requestAnimationFrame(function() {
      scheduled = null;
      fn();
    });
    scheduled = {
      frameId,
      fn
    };
  }
  function flush() {
    if (scheduled) {
      cancelAnimationFrame(scheduled.frameId);
      scheduled.fn();
      scheduled = null;
    }
  }
  return {
    schedule: schedule2,
    flush
  };
})();
function makeDispatch(_ref) {
  var source = _ref.source, initial2 = _ref.initial, dispatchEvent = _ref.dispatchEvent;
  var previous = {
    dropTargets: []
  };
  function safeDispatch(args) {
    dispatchEvent(args);
    previous = {
      dropTargets: args.payload.location.current.dropTargets
    };
  }
  var dispatch = {
    start: function start2(_ref2) {
      var nativeSetDragImage = _ref2.nativeSetDragImage;
      var location2 = {
        current: initial2,
        previous,
        initial: initial2
      };
      safeDispatch({
        eventName: "onGenerateDragPreview",
        payload: {
          source,
          location: location2,
          nativeSetDragImage
        }
      });
      dragStart.schedule(function() {
        safeDispatch({
          eventName: "onDragStart",
          payload: {
            source,
            location: location2
          }
        });
      });
    },
    dragUpdate: function dragUpdate(_ref3) {
      var current = _ref3.current;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: "onDropTargetChange",
        payload: {
          source,
          location: {
            initial: initial2,
            previous,
            current
          }
        }
      });
    },
    drag: function drag(_ref4) {
      var current = _ref4.current;
      scheduleOnDrag(function() {
        dragStart.flush();
        var location2 = {
          initial: initial2,
          previous,
          current
        };
        safeDispatch({
          eventName: "onDrag",
          payload: {
            source,
            location: location2
          }
        });
      });
    },
    drop: function drop(_ref5) {
      var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: "onDrop",
        payload: {
          source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
          location: {
            current,
            previous,
            initial: initial2
          }
        }
      });
    }
  };
  return dispatch;
}
var globalState = {
  isActive: false
};
function canStart() {
  return !globalState.isActive;
}
function getNativeSetDragImage(event) {
  if (event.dataTransfer) {
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
  }
  return null;
}
function hasHierarchyChanged(_ref) {
  var current = _ref.current, next4 = _ref.next;
  if (current.length !== next4.length) {
    return true;
  }
  for (var i = 0; i < current.length; i++) {
    if (current[i].element !== next4[i].element) {
      return true;
    }
  }
  return false;
}
function start$1(_ref2) {
  var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
  if (!canStart()) {
    return;
  }
  var initial2 = getStartLocation({
    event,
    dragType,
    getDropTargetsOver
  });
  globalState.isActive = true;
  var state = {
    current: initial2
  };
  setDropEffectOnEvent({
    event,
    current: initial2.dropTargets
  });
  var dispatch = makeDispatch({
    source: dragType.payload,
    dispatchEvent,
    initial: initial2
  });
  function updateState(next4) {
    var hasChanged = hasHierarchyChanged({
      current: state.current.dropTargets,
      next: next4.dropTargets
    });
    state.current = next4;
    if (hasChanged) {
      dispatch.dragUpdate({
        current: state.current
      });
    }
  }
  function onUpdateEvent(event2) {
    var input2 = getInput(event2);
    var target = isHoneyPotElement(event2.target) ? getElementFromPointWithoutHoneypot({
      x: input2.clientX,
      y: input2.clientY
    }) : event2.target;
    var nextDropTargets = getDropTargetsOver({
      target,
      input: input2,
      source: dragType.payload,
      current: state.current.dropTargets
    });
    if (nextDropTargets.length) {
      event2.preventDefault();
      setDropEffectOnEvent({
        event: event2,
        current: nextDropTargets
      });
    }
    updateState({
      dropTargets: nextDropTargets,
      input: input2
    });
  }
  function cancel2() {
    if (state.current.dropTargets.length) {
      updateState({
        dropTargets: [],
        input: state.current.input
      });
    }
    dispatch.drop({
      current: state.current,
      updatedSourcePayload: null
    });
    finish();
  }
  function finish() {
    globalState.isActive = false;
    unbindEvents2();
  }
  var unbindEvents2 = distExports$1.bindAll(
    window,
    [{
      // 👋 Note: we are repurposing the `dragover` event as our `drag` event
      // this is because firefox does not publish pointer coordinates during
      // a `drag` event, but does for every other type of drag event
      // `dragover` fires on all elements that are being dragged over
      // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
      // 🦊😤
      type: "dragover",
      listener: function listener(event2) {
        onUpdateEvent(event2);
        dispatch.drag({
          current: state.current
        });
      }
    }, {
      type: "dragenter",
      listener: onUpdateEvent
    }, {
      type: "dragleave",
      listener: function listener(event2) {
        if (!isLeavingWindow({
          dragLeave: event2
        })) {
          return;
        }
        updateState({
          input: state.current.input,
          dropTargets: []
        });
        if (dragType.startedFrom === "external") {
          cancel2();
        }
      }
    }, {
      // A "drop" can only happen if the browser allowed the drop
      type: "drop",
      listener: function listener(event2) {
        state.current = {
          dropTargets: state.current.dropTargets,
          input: getInput(event2)
        };
        if (!state.current.dropTargets.length) {
          cancel2();
          return;
        }
        event2.preventDefault();
        setDropEffectOnEvent({
          event: event2,
          current: state.current.dropTargets
        });
        dispatch.drop({
          current: state.current,
          // When dropping something native, we need to extract the latest
          // `.items` from the "drop" event as it is now accessible
          updatedSourcePayload: dragType.type === "external" ? dragType.getDropPayload(event2) : null
        });
        finish();
      }
    }, {
      // "dragend" fires when on the drag source (eg a draggable element)
      // when the drag is finished.
      // "dragend" will fire after "drop" (if there was a successful drop)
      // "dragend" does not fire if the draggable source has been removed during the drag
      // or for external drag sources (eg files)
      // This "dragend" listener will not fire if there was a successful drop
      // as we will have already removed the event listener
      type: "dragend",
      listener: function listener(event2) {
        state.current = {
          dropTargets: state.current.dropTargets,
          input: getInput(event2)
        };
        cancel2();
      }
    }].concat(_toConsumableArray$2(getBindingsForBrokenDrags({
      onDragEnd: cancel2
    }))),
    // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
      capture: true
    }
  );
  dispatch.start({
    nativeSetDragImage: getNativeSetDragImage(event)
  });
}
function setDropEffectOnEvent(_ref3) {
  var _current$;
  var event = _ref3.event, current = _ref3.current;
  var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
  if (innerMost != null && event.dataTransfer) {
    event.dataTransfer.dropEffect = innerMost;
  }
}
function getStartLocation(_ref4) {
  var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
  var input2 = getInput(event);
  if (dragType.startedFrom === "external") {
    return {
      input: input2,
      dropTargets: []
    };
  }
  var dropTargets = getDropTargetsOver({
    input: input2,
    source: dragType.payload,
    target: event.target,
    current: []
  });
  return {
    input: input2,
    dropTargets
  };
}
var lifecycle = {
  canStart,
  start: start$1
};
var ledger = /* @__PURE__ */ new Map();
function registerUsage(_ref) {
  var typeKey = _ref.typeKey, mount2 = _ref.mount;
  var entry = ledger.get(typeKey);
  if (entry) {
    entry.usageCount++;
    return entry;
  }
  var initial2 = {
    typeKey,
    unmount: mount2(),
    usageCount: 1
  };
  ledger.set(typeKey, initial2);
  return initial2;
}
function register(args) {
  var entry = registerUsage(args);
  return function unregister() {
    entry.usageCount--;
    if (entry.usageCount > 0) {
      return;
    }
    entry.unmount();
    ledger.delete(args.typeKey);
  };
}
function addAttribute(element, _ref) {
  var attribute = _ref.attribute, value = _ref.value;
  element.setAttribute(attribute, value);
  return function() {
    return element.removeAttribute(attribute);
  };
}
function ownKeys$o(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$m(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$o(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _createForOfIteratorHelper$2(r2, e) {
  var t = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t) {
    if (Array.isArray(r2) || (t = _unsupportedIterableToArray$4(r2)) || e) {
      t && (r2 = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r2.length ? { done: true } : { done: false, value: r2[_n++] };
      }, e: function e2(r3) {
        throw r3;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r2);
  }, n: function n() {
    var r3 = t.next();
    return a = r3.done, r3;
  }, e: function e2(r3) {
    u = true, o = r3;
  }, f: function f() {
    try {
      a || null == t.return || t.return();
    } finally {
      if (u) throw o;
    }
  } };
}
function _unsupportedIterableToArray$4(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray$4(r2, a);
    var t = {}.toString.call(r2).slice(8, -1);
    return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r2, a) : void 0;
  }
}
function _arrayLikeToArray$4(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r2[e];
  return n;
}
function copyReverse(array4) {
  return array4.slice(0).reverse();
}
function makeDropTarget(_ref) {
  var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
  var registry = /* @__PURE__ */ new WeakMap();
  var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
  var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
  function addToRegistry2(args) {
    registry.set(args.element, args);
    return function() {
      return registry.delete(args.element);
    };
  }
  function dropTargetForConsumers(args) {
    if (process.env.NODE_ENV !== "production") {
      var existing = registry.get(args.element);
      if (existing) {
        console.warn("You have already registered a [".concat(typeKey, "] dropTarget on the same element"), {
          existing,
          proposed: args
        });
      }
      if (args.element instanceof HTMLIFrameElement) {
        console.warn("\n            We recommend not registering <iframe> elements as drop targets\n            as it can result in some strange browser event ordering.\n          ".replace(/\s{2,}/g, " ").trim());
      }
    }
    var cleanup2 = combine$1(addAttribute(args.element, {
      attribute: dropTargetDataAtt,
      value: "true"
    }), addToRegistry2(args));
    return once(cleanup2);
  }
  function getActualDropTargets(_ref2) {
    var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
    var source = _ref2.source, target = _ref2.target, input2 = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
    if (target == null) {
      return result;
    }
    if (!(target instanceof Element)) {
      if (target instanceof Node) {
        return getActualDropTargets({
          source,
          target: target.parentElement,
          input: input2,
          result
        });
      }
      return result;
    }
    var closest = target.closest(dropTargetSelector);
    if (closest == null) {
      return result;
    }
    var args = registry.get(closest);
    if (args == null) {
      return result;
    }
    var feedback = {
      input: input2,
      source,
      element: args.element
    };
    if (args.canDrop && !args.canDrop(feedback)) {
      return getActualDropTargets({
        source,
        target: args.element.parentElement,
        input: input2,
        result
      });
    }
    var data2 = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
    var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
    var record = {
      data: data2,
      element: args.element,
      dropEffect,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: false
    };
    return getActualDropTargets({
      source,
      target: args.element.parentElement,
      input: input2,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(_toConsumableArray$2(result), [record])
    });
  }
  function notifyCurrent(_ref3) {
    var eventName = _ref3.eventName, payload = _ref3.payload;
    var _iterator = _createForOfIteratorHelper$2(payload.location.current.dropTargets), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _entry$eventName;
        var record = _step.value;
        var entry = registry.get(record.element);
        var args = _objectSpread$m(_objectSpread$m({}, payload), {}, {
          self: record
        });
        entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(
          entry,
          // I cannot seem to get the types right here.
          // TS doesn't seem to like that one event can need `nativeSetDragImage`
          // @ts-expect-error
          args
        );
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var actions = {
    onGenerateDragPreview: notifyCurrent,
    onDrag: notifyCurrent,
    onDragStart: notifyCurrent,
    onDrop: notifyCurrent,
    onDropTargetChange: function onDropTargetChange(_ref4) {
      var payload = _ref4.payload;
      var isCurrent = new Set(payload.location.current.dropTargets.map(function(record2) {
        return record2.element;
      }));
      var visited = /* @__PURE__ */ new Set();
      var _iterator2 = _createForOfIteratorHelper$2(payload.location.previous.dropTargets), _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
          var _entry$onDropTargetCh;
          var record = _step2.value;
          visited.add(record.element);
          var entry = registry.get(record.element);
          var isOver = isCurrent.has(record.element);
          var args = _objectSpread$m(_objectSpread$m({}, payload), {}, {
            self: record
          });
          entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
          if (!isOver) {
            var _entry$onDragLeave;
            entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper$2(payload.location.current.dropTargets), _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
          var _entry$onDropTargetCh2, _entry$onDragEnter;
          var _record = _step3.value;
          if (visited.has(_record.element)) {
            continue;
          }
          var _args = _objectSpread$m(_objectSpread$m({}, payload), {}, {
            self: _record
          });
          var _entry = registry.get(_record.element);
          _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
          _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  };
  function dispatchEvent(args) {
    actions[args.eventName](args);
  }
  function getIsOver(_ref5) {
    var source = _ref5.source, target = _ref5.target, input2 = _ref5.input, current = _ref5.current;
    var actual = getActualDropTargets({
      source,
      target,
      input: input2
    });
    if (actual.length >= current.length) {
      return actual;
    }
    var lastCaptureOrdered = copyReverse(current);
    var actualCaptureOrdered = copyReverse(actual);
    var resultCaptureOrdered = [];
    for (var index2 = 0; index2 < lastCaptureOrdered.length; index2++) {
      var _argsForLast$getIsSti;
      var last = lastCaptureOrdered[index2];
      var fresh = actualCaptureOrdered[index2];
      if (fresh != null) {
        resultCaptureOrdered.push(fresh);
        continue;
      }
      var parent = resultCaptureOrdered[index2 - 1];
      var lastParent = lastCaptureOrdered[index2 - 1];
      if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) {
        break;
      }
      var argsForLast = registry.get(last.element);
      if (!argsForLast) {
        break;
      }
      var feedback = {
        input: input2,
        source,
        element: argsForLast.element
      };
      if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) {
        break;
      }
      if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) {
        break;
      }
      resultCaptureOrdered.push(_objectSpread$m(_objectSpread$m({}, last), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: true
      }));
    }
    return copyReverse(resultCaptureOrdered);
  }
  return {
    dropTargetForConsumers,
    getIsOver,
    dispatchEvent
  };
}
function _createForOfIteratorHelper$1(r2, e) {
  var t = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t) {
    if (Array.isArray(r2) || (t = _unsupportedIterableToArray$3(r2)) || e) {
      t && (r2 = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r2.length ? { done: true } : { done: false, value: r2[_n++] };
      }, e: function e2(r3) {
        throw r3;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r2);
  }, n: function n() {
    var r3 = t.next();
    return a = r3.done, r3;
  }, e: function e2(r3) {
    u = true, o = r3;
  }, f: function f() {
    try {
      a || null == t.return || t.return();
    } finally {
      if (u) throw o;
    }
  } };
}
function _unsupportedIterableToArray$3(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray$3(r2, a);
    var t = {}.toString.call(r2).slice(8, -1);
    return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r2, a) : void 0;
  }
}
function _arrayLikeToArray$3(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r2[e];
  return n;
}
function ownKeys$n(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$l(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$n(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function makeMonitor() {
  var registry = /* @__PURE__ */ new Set();
  var dragging = null;
  function tryAddToActive(monitor) {
    if (!dragging) {
      return;
    }
    if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) {
      dragging.active.add(monitor);
    }
  }
  function monitorForConsumers(args) {
    var entry = _objectSpread$l({}, args);
    registry.add(entry);
    tryAddToActive(entry);
    function cleanup2() {
      registry.delete(entry);
      if (dragging) {
        dragging.active.delete(entry);
      }
    }
    return once(cleanup2);
  }
  function dispatchEvent(_ref) {
    var eventName = _ref.eventName, payload = _ref.payload;
    if (eventName === "onGenerateDragPreview") {
      dragging = {
        canMonitorArgs: {
          initial: payload.location.initial,
          source: payload.source
        },
        active: /* @__PURE__ */ new Set()
      };
      var _iterator = _createForOfIteratorHelper$1(registry), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var monitor = _step.value;
          tryAddToActive(monitor);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (!dragging) {
      return;
    }
    var active = Array.from(dragging.active);
    for (var _i = 0, _active = active; _i < _active.length; _i++) {
      var _monitor = _active[_i];
      if (dragging.active.has(_monitor)) {
        var _monitor$eventName;
        (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
      }
    }
    if (eventName === "onDrop") {
      dragging.active.clear();
      dragging = null;
    }
  }
  return {
    dispatchEvent,
    monitorForConsumers
  };
}
function makeAdapter(_ref) {
  var typeKey = _ref.typeKey, mount2 = _ref.mount, dispatchEventToSource2 = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
  var monitorAPI = makeMonitor();
  var dropTargetAPI = makeDropTarget({
    typeKey,
    defaultDropEffect
  });
  function dispatchEvent(args) {
    dispatchEventToSource2 === null || dispatchEventToSource2 === void 0 || dispatchEventToSource2(args);
    dropTargetAPI.dispatchEvent(args);
    monitorAPI.dispatchEvent(args);
    onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
  }
  function start2(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType;
    lifecycle.start({
      event,
      dragType,
      getDropTargetsOver: dropTargetAPI.getIsOver,
      dispatchEvent
    });
  }
  function registerUsage2() {
    function mountAdapter() {
      var api2 = {
        canStart: lifecycle.canStart,
        start: start2
      };
      return mount2(api2);
    }
    return register({
      typeKey,
      mount: mountAdapter
    });
  }
  return {
    registerUsage: registerUsage2,
    dropTarget: dropTargetAPI.dropTargetForConsumers,
    monitor: monitorAPI.monitorForConsumers
  };
}
var isAndroid = once(function isAndroid2() {
  return navigator.userAgent.toLocaleLowerCase().includes("android");
});
var androidFallbackText = "pdnd:android-fallback";
var textMediaType = "text/plain";
var URLMediaType = "text/uri-list";
var elementAdapterNativeDataKey = "application/vnd.pdnd";
var draggableRegistry = /* @__PURE__ */ new WeakMap();
function addToRegistry(args) {
  draggableRegistry.set(args.element, args);
  return function cleanup2() {
    draggableRegistry.delete(args.element);
  };
}
var honeyPotFix = makeHoneyPotFix();
var adapter = makeAdapter({
  typeKey: "element",
  defaultDropEffect: "move",
  mount: function mount(api2) {
    return combine$1(honeyPotFix.bindEvents(), distExports$1.bind(document, {
      type: "dragstart",
      listener: function listener(event) {
        var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
        if (!api2.canStart(event)) {
          return;
        }
        if (event.defaultPrevented) {
          return;
        }
        if (!event.dataTransfer) {
          if (process.env.NODE_ENV !== "production") {
            console.warn("\n              It appears as though you have are not testing DragEvents correctly.\n\n              - If you are unit testing, ensure you have polyfilled DragEvent.\n              - If you are browser testing, ensure you are dispatching drag events correctly.\n\n              Please see our testing guides for more information:\n              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing\n            ".replace(/ {2}/g, ""));
          }
          return;
        }
        var target = event.target;
        if (!(target instanceof HTMLElement)) {
          return;
        }
        var entry = draggableRegistry.get(target);
        if (!entry) {
          return;
        }
        var input2 = getInput(event);
        var feedback = {
          element: entry.element,
          dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
          input: input2
        };
        if (entry.canDrag && !entry.canDrag(feedback)) {
          event.preventDefault();
          return;
        }
        if (entry.dragHandle) {
          var over = getElementFromPointWithoutHoneypot({
            x: input2.clientX,
            y: input2.clientY
          });
          if (!entry.dragHandle.contains(over)) {
            event.preventDefault();
            return;
          }
        }
        var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
        if (nativeData) {
          for (var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray$2(_Object$entries[_i], 2), key = _Object$entries$_i[0], data2 = _Object$entries$_i[1];
            event.dataTransfer.setData(key, data2 !== null && data2 !== void 0 ? data2 : "");
          }
        }
        if (isAndroid() && !event.dataTransfer.types.includes(textMediaType) && !event.dataTransfer.types.includes(URLMediaType)) {
          event.dataTransfer.setData(textMediaType, androidFallbackText);
        }
        event.dataTransfer.setData(elementAdapterNativeDataKey, "");
        var payload = {
          element: entry.element,
          dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
          data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
        };
        var dragType = {
          type: "element",
          payload,
          startedFrom: "internal"
        };
        api2.start({
          event,
          dragType
        });
      }
    }));
  },
  dispatchEventToSource: function dispatchEventToSource(_ref) {
    var _draggableRegistry$ge, _draggableRegistry$ge2;
    var eventName = _ref.eventName, payload = _ref.payload;
    (_draggableRegistry$ge = draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(
      _draggableRegistry$ge,
      // I cannot seem to get the types right here.
      // TS doesn't seem to like that one event can need `nativeSetDragImage`
      // @ts-expect-error
      payload
    );
  },
  onPostDispatch: honeyPotFix.getOnPostDispatch()
});
var dropTargetForElements = adapter.dropTarget;
var monitorForElements = adapter.monitor;
function draggable(args) {
  if (process.env.NODE_ENV !== "production") {
    if (args.dragHandle && !args.element.contains(args.dragHandle)) {
      console.warn("Drag handle element must be contained in draggable element", {
        element: args.element,
        dragHandle: args.dragHandle
      });
    }
  }
  if (process.env.NODE_ENV !== "production") {
    var existing = draggableRegistry.get(args.element);
    if (existing) {
      console.warn("You have already registered a `draggable` on the same element", {
        existing,
        proposed: args
      });
    }
  }
  var cleanup2 = combine$1(
    // making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    adapter.registerUsage(),
    addToRegistry(args),
    addAttribute(args.element, {
      attribute: "draggable",
      value: "true"
    })
  );
  return once(cleanup2);
}
function noop$3() {
}
var log = (
  // no warnings in production
  process.env.NODE_ENV === "production" ? noop$3 : (
    /**
    * An Immediately Invoked Function Expression (IIFE) is used to enable
    * dead code elimination while also only having to evaluate these
    * declarations once.
    */
    /* @__PURE__ */ (function() {
      var isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
      var spacesAndTabs = /[ \t]{2,}/g;
      var lineStartWithSpaces = /^[ \t]*/gm;
      var clean2 = function clean3(value) {
        return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
      };
      var getDevMessage = function getDevMessage2(message2) {
        return clean2("\n          %creact-beautiful-dnd\n\n          %c".concat(clean2(message2), "\n\n          %c👷‍ This is a development only message. It will be removed in production builds.\n        "));
      };
      var getFormattedMessage = function getFormattedMessage2(message2) {
        return [
          getDevMessage(message2),
          // title (green400)
          "color: #00C584; font-size: 1.2em; font-weight: bold;",
          // message
          "line-height: 1.5",
          // footer (purple300)
          "color: #723874;"
        ];
      };
      return function log2(type4, message2) {
        var _console;
        if (typeof window !== "undefined" && window[isDisabledFlag]) {
          return;
        }
        (_console = console)[type4].apply(_console, _toConsumableArray$2(getFormattedMessage(message2)));
      };
    })()
  )
);
var warning$5 = log.bind(null, "warn");
var error = log.bind(null, "error");
function _callSuper$f(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$h() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function ErrorBoundaryInner(_ref) {
  var children2 = _ref.children, dragController = _ref.dragController;
  var isDraggingRef = useRef(false);
  var handleWindowError = useCallback(function(event) {
    var dragState = dragController.getDragState();
    if (!dragState.isDragging) {
      return;
    }
    if (dragState.mode === "FLUID") {
      cancelPointerDrag();
    }
    if (dragState.mode === "SNAP") {
      dragController.stopDrag({
        reason: "CANCEL"
      });
    }
    if (process.env.NODE_ENV !== "production") {
      warning$5("\n          An error was caught by our window 'error' event listener while a drag was occurring.\n          The active drag has been aborted.\n        ");
    }
    var err = event.error;
    if (err instanceof RbdInvariant) {
      event.preventDefault();
      if (process.env.NODE_ENV !== "production") {
        error(err.message);
      }
    }
  }, [dragController]);
  useEffect(function() {
    return combine$1(monitorForElements({
      onDragStart: function onDragStart2() {
        isDraggingRef.current = true;
      },
      onDrop: function onDrop() {
        isDraggingRef.current = false;
      }
    }), distExports$1.bind(window, {
      type: "error",
      listener: handleWindowError
    }));
  }, [handleWindowError]);
  return children2;
}
var ErrorBoundary$1 = /* @__PURE__ */ (function(_React$Component) {
  function ErrorBoundary2() {
    _classCallCheck$2(this, ErrorBoundary2);
    return _callSuper$f(this, ErrorBoundary2, arguments);
  }
  _inherits$2(ErrorBoundary2, _React$Component);
  return _createClass$2(ErrorBoundary2, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err) {
      if (err instanceof RbdInvariant) {
        if (process.env.NODE_ENV !== "production") {
          error(err.message);
        }
        return;
      }
      throw err;
    }
  }, {
    key: "render",
    value: function render2() {
      return /* @__PURE__ */ React__default.createElement(ErrorBoundaryInner, {
        contextId: this.props.contextId,
        dragController: this.props.dragController
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
    }
  }]);
})(React__default.Component);
function ownKeys$m(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$k(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$m(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function getActualDestination(_ref) {
  var start2 = _ref.start, target = _ref.target;
  if (target === null) {
    return null;
  }
  var isSameList = start2.droppableId === target.droppableId;
  var isMovingForward = target.index > start2.index;
  var shouldAdjust = isSameList && isMovingForward;
  if (!shouldAdjust) {
    return _objectSpread$k({}, target);
  }
  return _objectSpread$k(_objectSpread$k({}, target), {}, {
    index: target.index - 1
  });
}
function getHiddenTextElementId(contextId) {
  return "rbd-lift-instruction-".concat(contextId);
}
function useHiddenTextElement(_ref) {
  var contextId = _ref.contextId, text2 = _ref.text;
  useEffect(function() {
    var id2 = getHiddenTextElementId(contextId);
    var el = document.createElement("div");
    el.id = id2;
    el.textContent = text2;
    Object.assign(el.style, {
      display: "none"
    });
    document.body.appendChild(el);
    return function unmount() {
      el.remove();
    };
  }, [contextId, text2]);
}
function findClosestScrollContainer(element) {
  var _getComputedStyle = getComputedStyle(element), overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  if (overflowX === "scroll" || overflowX === "auto" || overflowY === "scroll" || overflowY === "auto") {
    return element;
  }
  var parentElement = element.parentElement;
  if (parentElement === null) {
    return null;
  }
  return findClosestScrollContainer(parentElement);
}
function getDroppablesOfType(_ref) {
  var contextId = _ref.contextId, type4 = _ref.type;
  return findElementAll({
    attribute: attributes$1.droppable.contextId,
    value: contextId
  }, {
    attribute: customAttributes.droppable.type,
    value: type4
  });
}
function getBestCrossAxisDroppable(_ref2) {
  var droppableId = _ref2.droppableId, type4 = _ref2.type, isMovingForward = _ref2.isMovingForward, contextId = _ref2.contextId, droppableRegistry = _ref2.droppableRegistry;
  var droppables = getDroppablesOfType({
    contextId,
    type: type4
  });
  var currentIndex = droppables.findIndex(function(element) {
    return getAttribute(element, attributes$1.droppable.id) === droppableId;
  });
  var candidates = droppables.filter(function(_2, index2) {
    if (isMovingForward) {
      return index2 > currentIndex;
    }
    return index2 < currentIndex;
  }).filter(function(element) {
    var droppableId2 = getAttribute(element, attributes$1.droppable.id);
    var entry = droppableRegistry.getEntry({
      droppableId: droppableId2
    });
    var isValidCandidate = entry && !entry.isDropDisabled;
    return isValidCandidate;
  });
  var bestCandidate = isMovingForward ? candidates.at(0) : candidates.at(-1);
  return bestCandidate !== null && bestCandidate !== void 0 ? bestCandidate : null;
}
function getElementByDraggableLocation(contextId, location2) {
  if (!location2) {
    return null;
  }
  return findElement({
    attribute: attributes$1.draggable.contextId,
    value: contextId
  }, {
    attribute: customAttributes.draggable.droppableId,
    value: location2.droppableId
  }, {
    attribute: customAttributes.draggable.index,
    value: String(location2.index)
  });
}
function ownKeys$l(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$j(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$l(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function scrollToTop(element) {
  var scrollContainer = findClosestScrollContainer(element);
  if (!scrollContainer) {
    return;
  }
  scrollContainer.scrollTo(0, 0);
}
var moveHandlers = {
  mainAxis: {
    prev: function prev(event, _ref) {
      var dragController = _ref.dragController;
      event.preventDefault();
      var dragState = dragController.getDragState();
      rbdInvariant(dragState.isDragging);
      var sourceLocation = dragState.sourceLocation, targetLocation = dragState.targetLocation;
      if (!targetLocation) {
        return;
      }
      if (targetLocation.index === 0) {
        return;
      }
      var nextLocation = _objectSpread$j(_objectSpread$j({}, targetLocation), {}, {
        index: targetLocation.index - 1
      });
      var nextDestination = getActualDestination({
        start: sourceLocation,
        target: nextLocation
      });
      if (isSameLocation(sourceLocation, nextDestination)) {
        nextLocation.index = targetLocation.index - 2;
      }
      dragController.updateDrag({
        targetLocation: nextLocation
      });
    },
    next: function next(event, _ref2) {
      var dragController = _ref2.dragController, contextId = _ref2.contextId;
      event.preventDefault();
      var dragState = dragController.getDragState();
      rbdInvariant(dragState.isDragging);
      var sourceLocation = dragState.sourceLocation, targetLocation = dragState.targetLocation;
      if (!targetLocation) {
        return;
      }
      var element = getElementByDraggableLocation(contextId, targetLocation);
      var isSame = isSameLocation(sourceLocation, targetLocation);
      if (!isSame && !element) {
        return;
      }
      var nextLocation = _objectSpread$j(_objectSpread$j({}, targetLocation), {}, {
        index: targetLocation.index + 1
      });
      var nextDestination = getActualDestination({
        start: sourceLocation,
        target: nextLocation
      });
      if (isSameLocation(sourceLocation, nextDestination)) {
        nextLocation.index = targetLocation.index + 2;
      }
      dragController.updateDrag({
        targetLocation: nextLocation
      });
    }
  },
  crossAxis: {
    prev: function prev2(event, _ref3) {
      var dragController = _ref3.dragController, droppableRegistry = _ref3.droppableRegistry, contextId = _ref3.contextId;
      event.preventDefault();
      var dragState = dragController.getDragState();
      rbdInvariant(dragState.isDragging);
      var targetLocation = dragState.targetLocation, type4 = dragState.type;
      if (!targetLocation) {
        return;
      }
      var before = getBestCrossAxisDroppable({
        droppableId: targetLocation.droppableId,
        type: type4,
        isMovingForward: false,
        contextId,
        droppableRegistry
      });
      if (!before) {
        return;
      }
      scrollToTop(before);
      var nextLocation = {
        droppableId: getAttribute(before, attributes$1.droppable.id),
        index: 0
      };
      dragController.updateDrag({
        targetLocation: nextLocation
      });
    },
    next: function next2(event, _ref4) {
      var dragController = _ref4.dragController, droppableRegistry = _ref4.droppableRegistry, contextId = _ref4.contextId;
      event.preventDefault();
      var dragState = dragController.getDragState();
      rbdInvariant(dragState.isDragging);
      var targetLocation = dragState.targetLocation, type4 = dragState.type;
      if (!targetLocation) {
        return;
      }
      var after = getBestCrossAxisDroppable({
        droppableId: targetLocation.droppableId,
        type: type4,
        isMovingForward: true,
        contextId,
        droppableRegistry
      });
      if (!after) {
        return;
      }
      scrollToTop(after);
      var nextLocation = {
        droppableId: getAttribute(after, attributes$1.droppable.id),
        index: 0
      };
      dragController.updateDrag({
        targetLocation: nextLocation
      });
    }
  }
};
function preventDefault(event) {
  event.preventDefault();
}
var commonKeyHandlers = {
  PageUp: preventDefault,
  PageDown: preventDefault,
  Home: preventDefault,
  End: preventDefault,
  Enter: preventDefault,
  Tab: preventDefault
};
var keyHandlers = {
  vertical: _objectSpread$j(_objectSpread$j({}, commonKeyHandlers), {}, {
    ArrowUp: moveHandlers.mainAxis.prev,
    ArrowDown: moveHandlers.mainAxis.next,
    ArrowLeft: moveHandlers.crossAxis.prev,
    ArrowRight: moveHandlers.crossAxis.next
  }),
  horizontal: _objectSpread$j(_objectSpread$j({}, commonKeyHandlers), {}, {
    ArrowUp: moveHandlers.crossAxis.prev,
    ArrowDown: moveHandlers.crossAxis.next,
    ArrowLeft: moveHandlers.mainAxis.prev,
    ArrowRight: moveHandlers.mainAxis.next
  })
};
function useKeyboardControls(_ref5) {
  var dragController = _ref5.dragController, droppableRegistry = _ref5.droppableRegistry, contextId = _ref5.contextId, setKeyboardCleanupFn = _ref5.setKeyboardCleanupFn;
  var startKeyboardDrag = useCallback(function(_ref6) {
    var startEvent = _ref6.event, draggableId = _ref6.draggableId, type4 = _ref6.type, getSourceLocation = _ref6.getSourceLocation, sourceElement = _ref6.sourceElement;
    dragController.startDrag({
      draggableId,
      type: type4,
      getSourceLocation,
      sourceElement,
      mode: "SNAP"
    });
    var sourceLocation = getSourceLocation();
    var droppable = getElement({
      attribute: attributes$1.droppable.id,
      value: sourceLocation.droppableId
    });
    var direction = getAttribute(droppable, customAttributes.droppable.direction);
    rbdInvariant(direction === "vertical" || direction === "horizontal");
    function cancelDrag() {
      dragController.stopDrag({
        reason: "CANCEL"
      });
    }
    var cancelBindings = ["mousedown", "mouseup", "click", "touchstart", "resize", "wheel", "visibilitychange"].map(function(type5) {
      return {
        type: type5,
        listener: cancelDrag
      };
    });
    var cleanupFn = distExports$1.bindAll(window, [{
      type: "keydown",
      listener: function listener(event) {
        var _keyHandlers$directio, _keyHandlers$directio2;
        if (event === startEvent) {
          return;
        }
        var _dragController$getDr = dragController.getDragState(), isDragging = _dragController$getDr.isDragging;
        if (!isDragging) {
          return;
        }
        if (event.key === " ") {
          event.preventDefault();
          dragController.stopDrag({
            reason: "DROP"
          });
          return;
        }
        if (event.key === "Escape") {
          event.preventDefault();
          dragController.stopDrag({
            reason: "CANCEL"
          });
          return;
        }
        (_keyHandlers$directio = (_keyHandlers$directio2 = keyHandlers[direction])[event.key]) === null || _keyHandlers$directio === void 0 || _keyHandlers$directio.call(_keyHandlers$directio2, event, {
          dragController,
          droppableRegistry,
          contextId
        });
      }
    }].concat(_toConsumableArray$2(cancelBindings)));
    setKeyboardCleanupFn(cleanupFn);
  }, [contextId, dragController, droppableRegistry, setKeyboardCleanupFn]);
  return {
    startKeyboardDrag
  };
}
var isEqual$3 = function isEqual(base) {
  return function(value) {
    return base === value;
  };
};
var isScroll = isEqual$3("scroll");
var isAuto = isEqual$3("auto");
var isEither = function isEither2(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var isElementScrollable = function isElementScrollable2(el) {
  var style2 = window.getComputedStyle(el);
  var overflow = {
    overflowX: style2.overflowX,
    overflowY: style2.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};
var _getClosestScrollableElement = function getClosestScrollableElement(el) {
  if (!el) {
    return null;
  }
  if (el === document.body || el === document.documentElement) {
    return null;
  }
  if (!isElementScrollable(el)) {
    return _getClosestScrollableElement(el.parentElement);
  }
  return el;
};
var isProduction = process.env.NODE_ENV === "production";
var prefix$1 = "Invariant failed";
function invariant$1(condition, message2) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix$1);
  }
  var provided = typeof message2 === "function" ? message2() : message2;
  var value = provided ? "".concat(prefix$1, ": ").concat(provided) : prefix$1;
  throw new Error(value);
}
var getRect = function getRect2(_ref) {
  var top2 = _ref.top, right2 = _ref.right, bottom2 = _ref.bottom, left2 = _ref.left;
  var width = right2 - left2;
  var height = bottom2 - top2;
  var rect = {
    top: top2,
    right: right2,
    bottom: bottom2,
    left: left2,
    width,
    height,
    x: left2,
    y: top2,
    center: {
      x: (right2 + left2) / 2,
      y: (bottom2 + top2) / 2
    }
  };
  return rect;
};
var getScrollable = function getScrollable2(_ref) {
  var closestScrollable = _ref.closestScrollable;
  var rect = closestScrollable.getBoundingClientRect();
  var scrollPosition = {
    x: closestScrollable.scrollLeft,
    y: closestScrollable.scrollTop
  };
  return {
    container: getRect(rect),
    scroll: {
      current: scrollPosition,
      max: {
        x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
        y: closestScrollable.scrollHeight - closestScrollable.clientHeight
      }
    }
  };
};
var origin = {
  x: 0,
  y: 0
};
var apply = function apply2(fn) {
  return function(point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};
var isEqual$2 = function isEqual2(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var add$1 = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract2(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var smallestSigned = apply(function(value) {
  if (value === 0) {
    return 0;
  }
  return value > 0 ? 1 : -1;
});
var getOverlap = /* @__PURE__ */ (function() {
  var getRemainder = function getRemainder2(target, max2) {
    if (target < 0) {
      return target;
    }
    if (target > max2) {
      return target - max2;
    }
    return 0;
  };
  return function(_ref) {
    var current = _ref.current, max2 = _ref.max, change = _ref.change;
    var targetScroll = add$1(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max2.x),
      y: getRemainder(targetScroll.y, max2.y)
    };
    if (isEqual$2(overlap, origin)) {
      return null;
    }
    return overlap;
  };
})();
var canPartiallyScroll = function canPartiallyScroll2(_ref2) {
  var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
  var max2 = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max2,
    current,
    change: smallestChange
  });
  if (!overlap) {
    return true;
  }
  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }
  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }
  return false;
};
var canScrollWindow = function canScrollWindow2(viewport2, change) {
  return canPartiallyScroll({
    current: viewport2.scroll.current,
    max: viewport2.scroll.max,
    change
  });
};
var canScrollScrollable = function canScrollScrollable2(scrollable, change) {
  return canPartiallyScroll({
    current: scrollable.scroll.current,
    max: scrollable.scroll.max,
    change
  });
};
var minScroll = 1;
var vertical = {
  direction: "vertical",
  start: "top",
  end: "bottom",
  size: "height",
  scrollAxis: "scrollTop"
};
var horizontal = {
  direction: "horizontal",
  start: "left",
  end: "right",
  size: "width",
  scrollAxis: "scrollLeft"
};
[horizontal.direction, vertical.direction];
var config = {
  // percentage distance from edge of container:
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  // pixels per frame
  maxPixelScroll: 28,
  // A function used to ease a percentage value
  // A simple linear function would be: (percentage) => percentage;
  // percentage is between 0 and 1
  // result must be between 0 and 1
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    // ms: how long to dampen the speed of an auto scroll from the start of a drag
    stopDampeningAt: 1200,
    // ms: when to start accelerating the reduction of duration dampening
    accelerateAt: 360
  }
};
var getDistanceThresholds = function getDistanceThresholds2(container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom,
    maxScrollValueAt
  };
  return thresholds;
};
var getPercentage = function getPercentage2(_ref) {
  var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
  var range3 = endOfRange - startOfRange;
  if (range3 === 0) {
    return 0;
  }
  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range3;
  return percentage;
};
var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = function dampenValueByTime2(proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;
  if (runTime >= stopAt) {
    return proposedScroll;
  }
  if (runTime < accelerateAt) {
    return minScroll;
  }
  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange,
    current: runTime
  });
  var scroll3 = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll3);
};
var getValueFromDistance = function getValueFromDistance2(distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }
  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }
  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }
  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll3 = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll3);
};
var getValue$2 = function getValue(_ref) {
  var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll3 = getValueFromDistance(distanceToEdge, thresholds);
  if (scroll3 === 0) {
    return 0;
  }
  if (!shouldUseTimeDampening) {
    return scroll3;
  }
  return Math.max(dampenValueByTime(scroll3, dragStartTime), minScroll);
};
const getScrollOnAxis = (function(_ref) {
  var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
  if (isCloserToEnd) {
    return getValue$2({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds,
      dragStartTime,
      shouldUseTimeDampening
    });
  }
  return -1 * getValue$2({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds,
    dragStartTime,
    shouldUseTimeDampening
  });
});
var clean = apply(function(value) {
  return value === 0 ? 0 : value;
});
const getScroll = (function(_ref) {
  var dragStartTime = _ref.dragStartTime, container = _ref.container, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container,
    distanceToEdges,
    dragStartTime,
    axis: vertical,
    shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container,
    distanceToEdges,
    dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening
  });
  var required4 = clean({
    x,
    y
  });
  if (isEqual$2(required4, origin)) {
    return null;
  }
  return required4;
});
const getScrollableScrollChange = (function(_ref) {
  var scrollable = _ref.scrollable, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll3 = getScroll({
    dragStartTime,
    container: scrollable.container,
    center,
    shouldUseTimeDampening
  });
  return scroll3 && canScrollScrollable(scrollable, scroll3) ? scroll3 : null;
});
const getWindowScrollChange = (function(_ref) {
  var viewport2 = _ref.viewport, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll3 = getScroll({
    dragStartTime,
    container: viewport2.container,
    center,
    shouldUseTimeDampening
  });
  return scroll3 && canScrollWindow(viewport2, scroll3) ? scroll3 : null;
});
const getMaxScroll = (function(_ref) {
  var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
  var maxScroll = subtract(
    // full size
    {
      x: scrollWidth,
      y: scrollHeight
    },
    // viewport size
    {
      x: width,
      y: height
    }
  );
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});
const getMaxWindowScroll = (function() {
  var doc = document.documentElement;
  var maxScroll = getMaxScroll({
    // unclipped padding box, with scrollbar
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    // clipped padding box, without scrollbar
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});
const getWindowScroll = (function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});
const getViewport = (function() {
  var scroll3 = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top2 = scroll3.y;
  var left2 = scroll3.x;
  var doc = document.documentElement;
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right2 = left2 + width;
  var bottom2 = top2 + height;
  var container = getRect({
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  });
  var viewport2 = {
    container,
    scroll: {
      current: scroll3,
      max: maxScroll
    }
  };
  return viewport2;
});
var scroll = function scroll2(_ref) {
  var input2 = _ref.input, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollElement3 = _ref.scrollElement, scrollWindow3 = _ref.scrollWindow, behavior = _ref.behavior;
  var tryScrollWindow = function tryScrollWindow2() {
    var viewport2 = getViewport();
    var windowScrollChange = getWindowScrollChange({
      dragStartTime,
      viewport: viewport2,
      center: {
        x: input2.clientX + viewport2.scroll.current.x,
        y: input2.clientY + viewport2.scroll.current.y
      },
      shouldUseTimeDampening
    });
    if (windowScrollChange) {
      scrollWindow3(windowScrollChange);
      return true;
    }
    return false;
  };
  var tryScrollContainer = function tryScrollContainer2() {
    var over = getElementFromPointWithoutHoneypot({
      x: input2.clientX,
      y: input2.clientY
    });
    var closestScrollable = _getClosestScrollableElement(over);
    if (!closestScrollable) {
      return false;
    }
    var scrollable = getScrollable({
      closestScrollable
    });
    var scrollableScrollChange = getScrollableScrollChange({
      dragStartTime,
      scrollable,
      center: {
        x: input2.clientX,
        y: input2.clientY
      },
      shouldUseTimeDampening
    });
    if (scrollableScrollChange) {
      scrollElement3(closestScrollable, scrollableScrollChange);
      return true;
    }
    return false;
  };
  if (behavior === "container-only") {
    tryScrollContainer();
  }
  if (behavior === "window-only") {
    tryScrollWindow();
  }
  if (behavior === "container-then-window") {
    tryScrollContainer() || tryScrollWindow();
  }
  if (behavior === "window-then-container") {
    tryScrollWindow() || tryScrollContainer();
  }
};
var scrollElement = function scrollElement2(element, change) {
  element.scrollBy(change.x, change.y);
};
var scrollWindow = function scrollWindow2(change) {
  window.scrollBy(change.x, change.y);
};
var createAutoScroller = function createAutoScroller2() {
  var dragging = null;
  function tryScroll(fakeScrollCallback) {
    if (dragging == null) {
      return;
    }
    scroll({
      input: dragging.latestInput,
      dragStartTime: dragging.dragStartTime,
      shouldUseTimeDampening: dragging.shouldUseTimeDampening,
      behavior: dragging.behavior,
      scrollElement: fakeScrollCallback !== null && fakeScrollCallback !== void 0 ? fakeScrollCallback : scrollElement,
      scrollWindow: fakeScrollCallback !== null && fakeScrollCallback !== void 0 ? fakeScrollCallback : scrollWindow
    });
  }
  function loop() {
    if (!dragging) {
      return;
    }
    dragging.loopFrameId = requestAnimationFrame(function() {
      tryScroll();
      loop();
    });
  }
  var start2 = function start3(_ref) {
    var input2 = _ref.input, _ref$behavior = _ref.behavior, behavior = _ref$behavior === void 0 ? "window-then-container" : _ref$behavior;
    var dragStartTime = Date.now();
    dragging = {
      dragStartTime,
      latestInput: input2,
      loopFrameId: null,
      shouldUseTimeDampening: false,
      behavior
    };
    var fakeScrollCallback = function fakeScrollCallback2() {
      if (dragging) {
        dragging.shouldUseTimeDampening = true;
      }
    };
    tryScroll(fakeScrollCallback);
    loop();
  };
  function updateInput(_ref2) {
    var input2 = _ref2.input;
    if (!dragging) {
      return;
    }
    dragging.latestInput = input2;
  }
  var stop2 = function stop3() {
    if (!dragging) {
      return;
    }
    if (dragging.loopFrameId) {
      cancelAnimationFrame(dragging.loopFrameId);
    }
    dragging = null;
  };
  return {
    start: start2,
    updateInput,
    stop: stop2
  };
};
var autoScroller = createAutoScroller();
function acceptDrop(event) {
  if (event.defaultPrevented) {
    return;
  }
  if (event.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }
  event.preventDefault();
}
var unbindEvents = null;
function start() {
  cleanup$1();
  unbindEvents = distExports$1.bindAll(
    window,
    [{
      type: "dragover",
      listener: acceptDrop
    }, {
      type: "dragenter",
      listener: acceptDrop
    }, {
      type: "drop",
      listener: function listener(event) {
        event.preventDefault();
        cleanup$1();
      }
    }, {
      type: "dragend",
      listener: cleanup$1
    }].concat(_toConsumableArray$2(getBindingsForBrokenDrags({
      onDragEnd: cleanup$1
    }))),
    // being clear that these are added in the bubble phase
    {
      capture: false
    }
  );
}
function cleanup$1() {
  var _unbindEvents;
  (_unbindEvents = unbindEvents) === null || _unbindEvents === void 0 || _unbindEvents();
  unbindEvents = null;
}
function stop() {
  var _window$event;
  if (((_window$event = window.event) === null || _window$event === void 0 ? void 0 : _window$event.type) === "drop") {
    var _window$event2;
    (_window$event2 = window.event) === null || _window$event2 === void 0 || _window$event2.preventDefault();
  }
  cleanup$1();
}
var preventUnhandled = {
  start,
  stop
};
function usePointerControls(_ref) {
  var dragController = _ref.dragController, contextId = _ref.contextId;
  var updatePointerDrag = useCallback(function(location2) {
    dragController.updateDrag({
      targetLocation: getDraggableLocation(location2.current)
    });
  }, [dragController]);
  useEffect(function() {
    return monitorForElements({
      canMonitor: function canMonitor(_ref2) {
        var initial2 = _ref2.initial, source = _ref2.source;
        if (!isDraggableData(source.data)) {
          return false;
        }
        var isValidDraggable = source.data.contextId === contextId;
        if (!isValidDraggable) {
          return false;
        }
        var droppable = initial2.dropTargets.find(function(target) {
          return isDroppableData(target.data);
        });
        if (!droppable) {
          return true;
        }
        var isValidDroppable = droppable.data.contextId === contextId;
        return isValidDroppable;
      },
      onDragStart: function onDragStart2(_ref3) {
        var location2 = _ref3.location, source = _ref3.source;
        autoScroller.start({
          input: location2.current.input
        });
        preventUnhandled.start();
        var data2 = source.data;
        rbdInvariant(isDraggableData(data2));
        var draggableId = data2.draggableId, droppableId = data2.droppableId, getIndex2 = data2.getIndex, type4 = data2.type;
        dragController.startDrag({
          draggableId,
          type: type4,
          getSourceLocation: function getSourceLocation() {
            return {
              droppableId,
              index: getIndex2()
            };
          },
          sourceElement: source.element,
          mode: "FLUID"
        });
      },
      onDrag: function onDrag(_ref4) {
        var location2 = _ref4.location;
        autoScroller.updateInput({
          input: location2.current.input
        });
        updatePointerDrag(location2);
      },
      onDropTargetChange: function onDropTargetChange(_ref5) {
        var location2 = _ref5.location;
        updatePointerDrag(location2);
      },
      onDrop: function onDrop() {
        autoScroller.stop();
        preventUnhandled.stop();
        dragController.stopDrag({
          reason: "DROP"
        });
      }
    });
  }, [dragController, contextId, updatePointerDrag]);
}
var useIsomorphicLayoutEffect$2 = typeof window !== "undefined" ? useLayoutEffect$2 : useEffect;
var styleContextIdAttribute = "data-rbd-style-context-id";
function getRuleString(_ref) {
  var selector = _ref.selector, styles2 = _ref.styles;
  var concatString = Object.entries(styles2).map(function(_ref2) {
    var _ref3 = _slicedToArray$2(_ref2, 2), property = _ref3[0], value = _ref3[1];
    return "".concat(property, ": ").concat(value, ";");
  }).join(" ");
  return "".concat(selector, " { ").concat(concatString, " }");
}
function getDragHandleRuleString(contextId) {
  var selector = "[".concat(attributes$1.dragHandle.contextId, '="').concat(contextId, '"]');
  var styles2 = {
    /**
     * Indicates the element is draggable.
     *
     * Although this is always applied, it will not be visible during drags
     * because the browser will override the cursor.
     */
    cursor: "grab",
    /**
     * Improves the UX when dragging links on iOS.
     *
     * Without this a preview of the link will open. Although it is still
     * draggable, it is inconsistent with `react-beautiful-dnd`.
     */
    "-webkit-touch-callout": "none"
  };
  return getRuleString({
    selector,
    styles: styles2
  });
}
function createStyleEl(_ref4) {
  var contextId = _ref4.contextId, nonce = _ref4.nonce;
  var el = document.createElement("style");
  if (nonce) {
    el.setAttribute("nonce", nonce);
  }
  el.setAttribute(styleContextIdAttribute, contextId);
  document.head.appendChild(el);
  return el;
}
function createStyleManager(_ref5) {
  var contextId = _ref5.contextId, nonce = _ref5.nonce;
  var el = createStyleEl({
    contextId,
    nonce
  });
  el.textContent = getDragHandleRuleString(contextId);
  return function cleanup2() {
    el.remove();
  };
}
function useStyleMarshal(_ref6) {
  var contextId = _ref6.contextId, nonce = _ref6.nonce;
  useIsomorphicLayoutEffect$2(function() {
    return createStyleManager({
      contextId,
      nonce
    });
  }, [contextId, nonce]);
}
var schedule = (function() {
  if (
    // `unstable_batchedUpdates` is defined in all currently supported versions
    // but could be removed in the future.
    // This check is defensive and not currently necessary.
    typeof unstable_batchedUpdates === "function" && // The version export was only introduced in `react-dom@16.13.0`
    // but we need to support `react-dom@^16.8.0`
    // so we need to handle when the version is `undefined`
    (typeof version$2 === "undefined" || version$2.startsWith("16"))
  ) {
    return unstable_batchedUpdates;
  }
  return function(callback) {
    return callback();
  };
})();
function batchUpdatesForReact16(callback) {
  schedule(callback);
}
function _createForOfIteratorHelper(r2, e) {
  var t = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t) {
    if (Array.isArray(r2) || (t = _unsupportedIterableToArray$2(r2)) || e) {
      t && (r2 = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r2.length ? { done: true } : { done: false, value: r2[_n++] };
      }, e: function e2(r3) {
        throw r3;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r2);
  }, n: function n() {
    var r3 = t.next();
    return a = r3.done, r3;
  }, e: function e2(r3) {
    u = true, o = r3;
  }, f: function f() {
    try {
      a || null == t.return || t.return();
    } finally {
      if (u) throw o;
    }
  } };
}
function _unsupportedIterableToArray$2(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray$2(r2, a);
    var t = {}.toString.call(r2).slice(8, -1);
    return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r2, a) : void 0;
  }
}
function _arrayLikeToArray$2(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r2[e];
  return n;
}
function createRegistry() {
  return {
    onPendingDragStart: [],
    onPrePendingDragUpdate: [],
    onPendingDragUpdate: [],
    onBeforeDragEnd: []
  };
}
function createLifecycleManager() {
  var registry = createRegistry();
  var addResponder = function addResponder2(event, responder) {
    registry[event].push(responder);
    return function() {
      registry[event] = registry[event].filter(function(value) {
        return value !== responder;
      });
    };
  };
  var dispatch = function dispatch2(event, data2) {
    batchUpdatesForReact16(function() {
      var _iterator = _createForOfIteratorHelper(registry[event]), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var _responder = _step.value;
          _responder(data2);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  };
  return {
    addResponder,
    dispatch
  };
}
function useLifecycle() {
  var _useState = useState$1(createLifecycleManager), _useState2 = _slicedToArray$2(_useState, 1), lifecycleManager = _useState2[0];
  return lifecycleManager;
}
var LifecycleContext = /* @__PURE__ */ createContext(null);
function LifecycleContextProvider(_ref) {
  var children2 = _ref.children, lifecycle2 = _ref.lifecycle;
  var monitorForLifecycle = useCallback(function(responders) {
    var cleanupFns = [];
    for (var _i = 0, _Object$entries = Object.entries(responders); _i < _Object$entries.length; _i++) {
      var entry = _Object$entries[_i];
      var _ref2 = entry, _ref3 = _slicedToArray$2(_ref2, 2), _event = _ref3[0], _responder2 = _ref3[1];
      cleanupFns.push(lifecycle2.addResponder(_event, _responder2));
    }
    return combine$1.apply(void 0, cleanupFns);
  }, [lifecycle2]);
  return /* @__PURE__ */ React__default.createElement(LifecycleContext.Provider, {
    value: monitorForLifecycle
  }, children2);
}
function useMonitorForLifecycle() {
  var monitorForLifecycle = useContext(LifecycleContext);
  rbdInvariant(monitorForLifecycle !== null, "useLifecycle() should only be called inside of a <DragDropContext />");
  return monitorForLifecycle;
}
var node$2 = null;
var size$1 = "1px";
var visuallyHiddenStyles$1 = {
  // Standard visually hidden styles.
  // Copied from our VisuallyHidden (react) package.
  width: size$1,
  height: size$1,
  padding: "0",
  position: "absolute",
  border: "0",
  clip: "rect(".concat(size$1, ", ").concat(size$1, ", ").concat(size$1, ", ").concat(size$1, ")"),
  overflow: "hidden",
  whiteSpace: "nowrap",
  // Pulling upwards slightly to prevent the page
  // from growing when appended to a body that contains
  // an element with height:100%
  marginTop: "-".concat(size$1),
  // Just being safe and letting this element not interfere with hitboxes
  pointerEvents: "none"
};
function createNode() {
  var node2 = document.createElement("div");
  node2.setAttribute("role", "alert");
  Object.assign(node2.style, visuallyHiddenStyles$1);
  document.body.append(node2);
  return node2;
}
function getNode() {
  if (node$2 === null) {
    node$2 = createNode();
  }
  return node$2;
}
function announce(message2) {
  var node2 = getNode();
  node2.textContent = message2;
}
function getPosition$1(location2) {
  return location2.index + 1;
}
var defaultMessage = {
  onDragStart: function onDragStart(_ref) {
    var source = _ref.source;
    var startPosition = getPosition$1(source);
    return "You have lifted an item in position ".concat(startPosition, ".");
  },
  onDragUpdate: function onDragUpdate(_ref2) {
    var source = _ref2.source, destination = _ref2.destination;
    if (!destination) {
      return "You are currently not dragging over a droppable area.";
    }
    var startPosition = getPosition$1(source);
    var endPosition = getPosition$1(destination);
    var isSameList = source.droppableId === destination.droppableId;
    if (isSameList) {
      return "You have moved the item from position ".concat(startPosition, " to position ").concat(endPosition, ".");
    }
    return "You have moved the item from position ".concat(startPosition, " in list ").concat(source.droppableId, " to list ").concat(destination.droppableId, " in position ").concat(endPosition, ".");
  },
  onDragEnd: function onDragEnd(_ref3) {
    var source = _ref3.source, destination = _ref3.destination, reason = _ref3.reason;
    var startPosition = getPosition$1(source);
    if (reason === "CANCEL") {
      return "Movement cancelled. The item has returned to its starting position of ".concat(startPosition, ".");
    }
    if (!destination) {
      return "The item has been dropped while not over a droppable location. The item has returned to its starting position of ".concat(startPosition, ".");
    }
    var endPosition = getPosition$1(destination);
    var isSameList = source.droppableId === destination.droppableId;
    if (isSameList) {
      return "You have dropped the item. It has moved from position ".concat(startPosition, " to ").concat(endPosition, ".");
    }
    return "You have dropped the item. It has moved from position ".concat(startPosition, " in list ").concat(source.droppableId, " to position ").concat(endPosition, " in list ").concat(destination.droppableId, ".");
  }
};
function getDefaultMessage(event, data2) {
  return defaultMessage[event](data2);
}
function getProvided(event, data2) {
  var userMessage = null;
  var hasExpired = false;
  var provided = {
    /**
     * Used to capture custom messages for screen readers.
     *
     * Does not announce directly, but exposes the message that should be
     * announced. This may or may not be the default message.
     */
    announce: function announce2(message2) {
      if (process.env.NODE_ENV !== "production") {
        if (userMessage) {
          warning$5("Announcement already made. Not making a second announcement");
        }
        if (hasExpired) {
          warning$5("\n            Announcements cannot be made asynchronously.\n            Default message has already been announced.\n          ");
        }
      }
      userMessage = message2;
    }
  };
  function getMessage() {
    hasExpired = true;
    return userMessage !== null && userMessage !== void 0 ? userMessage : getDefaultMessage(event, data2);
  }
  return {
    provided,
    getMessage
  };
}
var defaultDragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var idleQueue = {
  status: "idle"
};
function createScheduler() {
  var queue = idleQueue;
  var schedule2 = function schedule3(callback) {
    if (queue.status === "idle") {
      queue = {
        status: "pending",
        timeoutId: setTimeout(flush, 0),
        items: []
      };
    }
    queue.items.push(callback);
  };
  var flush = function flush2() {
    if (queue.status === "idle") {
      return;
    }
    clearTimeout(queue.timeoutId);
    var items = Array.from(queue.items);
    queue = idleQueue;
    batchUpdatesForReact16(function() {
      items.forEach(function(callback) {
        return callback();
      });
    });
  };
  return {
    schedule: schedule2,
    flush
  };
}
function useScheduler() {
  var _useState = useState$1(createScheduler), _useState2 = _slicedToArray$2(_useState, 1), scheduler2 = _useState2[0];
  return scheduler2;
}
var instanceCount = 0;
function getContextId() {
  return "".concat(instanceCount++);
}
function getOffset(args) {
  var offsetElement = getClosestPositionedElement(args);
  return {
    top: offsetElement.offsetTop,
    left: offsetElement.offsetLeft
  };
}
function DragDropContext$1(_ref) {
  var children2 = _ref.children, _ref$dragHandleUsageI = _ref.dragHandleUsageInstructions, dragHandleUsageInstructions = _ref$dragHandleUsageI === void 0 ? defaultDragHandleUsageInstructions : _ref$dragHandleUsageI, nonce = _ref.nonce, onBeforeCapture = _ref.onBeforeCapture, onBeforeDragStart = _ref.onBeforeDragStart, onDragStart2 = _ref.onDragStart, onDragUpdate2 = _ref.onDragUpdate, onDragEnd2 = _ref.onDragEnd;
  var _useState = useState$1(getContextId), _useState2 = _slicedToArray$2(_useState, 1), contextId = _useState2[0];
  useHiddenTextElement({
    contextId,
    text: dragHandleUsageInstructions
  });
  var lifecycle2 = useLifecycle();
  var _useScheduler = useScheduler(), schedule2 = _useScheduler.schedule, flush = _useScheduler.flush;
  var dragStateRef = useRef({
    isDragging: false
  });
  var getDragState = useCallback(function() {
    return dragStateRef.current;
  }, []);
  var droppableRegistry = useDroppableRegistry();
  var getClosestEnabledDraggableLocation = useCallback(function(_ref2) {
    var droppableId = _ref2.droppableId;
    var droppable = droppableRegistry.getEntry({
      droppableId
    });
    while (droppable !== null && droppable.isDropDisabled) {
      var _droppable = droppable, parentDroppableId = _droppable.parentDroppableId;
      droppable = parentDroppableId ? droppableRegistry.getEntry({
        droppableId: parentDroppableId
      }) : null;
    }
    if (droppable === null) {
      return null;
    }
    return {
      droppableId: droppable.droppableId,
      index: 0
    };
  }, [droppableRegistry]);
  useEffect(function() {
    return function() {
      var _getDragState = getDragState(), isDragging = _getDragState.isDragging;
      if (isDragging) {
        cancelPointerDrag();
      }
    };
  }, [getDragState]);
  var updateDrag = useCallback(function(_ref3) {
    var targetLocation = _ref3.targetLocation, _ref3$isImmediate = _ref3.isImmediate, isImmediate = _ref3$isImmediate === void 0 ? false : _ref3$isImmediate;
    if (!dragStateRef.current.isDragging) {
      return;
    }
    var _dragStateRef$current = dragStateRef.current, prevDestination = _dragStateRef$current.prevDestination, draggableId = _dragStateRef$current.draggableId, type4 = _dragStateRef$current.type, sourceLocation = _dragStateRef$current.sourceLocation;
    var nextDestination = getActualDestination({
      start: sourceLocation,
      target: targetLocation
    });
    if (isSameLocation(prevDestination, nextDestination)) {
      return;
    }
    Object.assign(dragStateRef.current, {
      prevDestination: nextDestination,
      sourceLocation,
      targetLocation
    });
    var update2 = {
      mode: dragStateRef.current.mode,
      draggableId,
      type: type4,
      source: sourceLocation,
      destination: nextDestination,
      combine: null
      // not supported by migration layer
    };
    var droppable = targetLocation ? droppableRegistry.getEntry({
      droppableId: targetLocation.droppableId
    }) : null;
    lifecycle2.dispatch("onPrePendingDragUpdate", {
      update: update2,
      targetLocation
    });
    lifecycle2.dispatch("onPendingDragUpdate", {
      update: update2,
      targetLocation,
      droppable
    });
    function dispatchConsumerLifecycleEvent() {
      var _getProvided = getProvided("onDragUpdate", update2), provided = _getProvided.provided, getMessage = _getProvided.getMessage;
      onDragUpdate2 === null || onDragUpdate2 === void 0 || onDragUpdate2(update2, provided);
      announce(getMessage());
    }
    if (isImmediate) {
      dispatchConsumerLifecycleEvent();
    } else {
      schedule2(dispatchConsumerLifecycleEvent);
    }
  }, [droppableRegistry, lifecycle2, onDragUpdate2, schedule2]);
  var startDrag2 = useCallback(function(_ref4) {
    var draggableId = _ref4.draggableId, type4 = _ref4.type, getSourceLocation = _ref4.getSourceLocation, sourceElement = _ref4.sourceElement, mode = _ref4.mode;
    if (dragStateRef.current.isDragging) {
      return;
    }
    var before = {
      draggableId,
      mode
    };
    onBeforeCapture === null || onBeforeCapture === void 0 || onBeforeCapture(before);
    var start2 = {
      mode,
      draggableId,
      type: type4,
      source: getSourceLocation()
    };
    var _document = document, activeElement = _document.activeElement;
    var dragHandleDraggableId = activeElement instanceof HTMLElement && activeElement.hasAttribute(attributes$1.dragHandle.draggableId) ? getAttribute(activeElement, attributes$1.dragHandle.draggableId) : null;
    var droppableId = start2.source.droppableId;
    var droppable = droppableRegistry.getEntry({
      droppableId
    });
    rbdInvariant(droppable, "should have entry for droppable '".concat(droppableId, "'"));
    dragStateRef.current = {
      isDragging: true,
      mode,
      draggableDimensions: getDraggableDimensions(sourceElement),
      restoreFocusTo: dragHandleDraggableId,
      draggableId,
      type: type4,
      prevDestination: start2.source,
      sourceLocation: start2.source,
      targetLocation: start2.source,
      draggableInitialOffsetInSourceDroppable: getOffset({
        element: sourceElement,
        mode: droppable.mode
      })
    };
    onBeforeDragStart === null || onBeforeDragStart === void 0 || onBeforeDragStart(start2);
    lifecycle2.dispatch("onPendingDragStart", {
      start: start2,
      droppable
    });
    schedule2(function() {
      var start3 = {
        mode,
        draggableId,
        type: type4,
        source: getSourceLocation()
      };
      var _getProvided2 = getProvided("onDragStart", start3), provided = _getProvided2.provided, getMessage = _getProvided2.getMessage;
      onDragStart2 === null || onDragStart2 === void 0 || onDragStart2(start3, provided);
      announce(getMessage());
      schedule2(function() {
        var droppableId2 = start3.source.droppableId;
        var droppable2 = droppableRegistry.getEntry({
          droppableId: droppableId2
        });
        if (droppable2 !== null && droppable2 !== void 0 && droppable2.isDropDisabled) {
          var targetLocation = getClosestEnabledDraggableLocation({
            droppableId: droppableId2
          });
          updateDrag({
            targetLocation,
            isImmediate: true
          });
        }
      });
    });
  }, [droppableRegistry, getClosestEnabledDraggableLocation, lifecycle2, onBeforeCapture, onBeforeDragStart, onDragStart2, schedule2, updateDrag]);
  var keyboardCleanupManager = useCleanupFn();
  var stopDrag = useCallback(function(_ref5) {
    var reason = _ref5.reason;
    if (!dragStateRef.current.isDragging) {
      return;
    }
    keyboardCleanupManager.runCleanupFn();
    if (reason === "CANCEL") {
      updateDrag({
        targetLocation: null
      });
    }
    var _dragStateRef$current2 = dragStateRef.current, mode = _dragStateRef$current2.mode, restoreFocusTo = _dragStateRef$current2.restoreFocusTo, sourceLocation = _dragStateRef$current2.sourceLocation, targetLocation = _dragStateRef$current2.targetLocation, type4 = _dragStateRef$current2.type, draggableId = _dragStateRef$current2.draggableId;
    dragStateRef.current = {
      isDragging: false
    };
    flush();
    var destination = getActualDestination({
      start: sourceLocation,
      target: targetLocation
    });
    var result = {
      // We are saying all null destination drops count as a CANCEL
      reason: destination === null ? "CANCEL" : "DROP",
      type: type4,
      source: sourceLocation,
      destination,
      mode,
      draggableId,
      combine: null
      // not supported by migration layer
    };
    lifecycle2.dispatch("onBeforeDragEnd", {
      draggableId
    });
    var _getProvided3 = getProvided("onDragEnd", result), provided = _getProvided3.provided, getMessage = _getProvided3.getMessage;
    onDragEnd2(result, provided);
    announce(getMessage());
    if (restoreFocusTo) {
      requestAnimationFrame(function() {
        var dragHandle = findDragHandle({
          contextId,
          draggableId
        });
        if (!dragHandle) {
          return;
        }
        dragHandle.focus();
      });
    }
  }, [contextId, flush, keyboardCleanupManager, lifecycle2, onDragEnd2, updateDrag]);
  var dragController = useMemo$2(function() {
    return {
      getDragState,
      startDrag: startDrag2,
      updateDrag,
      stopDrag
    };
  }, [getDragState, startDrag2, stopDrag, updateDrag]);
  usePointerControls({
    dragController,
    contextId
  });
  var _useKeyboardControls = useKeyboardControls({
    dragController,
    droppableRegistry,
    contextId,
    setKeyboardCleanupFn: keyboardCleanupManager.setCleanupFn
  }), startKeyboardDrag = _useKeyboardControls.startKeyboardDrag;
  var onDroppableUpdate = useCallback(function(entry) {
    var _dragState$targetLoca;
    var dragState = dragStateRef.current;
    if (!dragState.isDragging) {
      return;
    }
    if (!entry.isDropDisabled) {
      return;
    }
    if (entry.droppableId !== ((_dragState$targetLoca = dragState.targetLocation) === null || _dragState$targetLoca === void 0 ? void 0 : _dragState$targetLoca.droppableId)) {
      return;
    }
    var targetLocation = getClosestEnabledDraggableLocation({
      droppableId: entry.droppableId
    });
    updateDrag({
      targetLocation
    });
  }, [getClosestEnabledDraggableLocation, updateDrag]);
  droppableRegistry.setUpdateListener(onDroppableUpdate);
  useStyleMarshal({
    contextId,
    nonce
  });
  return /* @__PURE__ */ React__default.createElement(ErrorBoundary$1, {
    contextId,
    dragController
  }, /* @__PURE__ */ React__default.createElement(LifecycleContextProvider, {
    lifecycle: lifecycle2
  }, /* @__PURE__ */ React__default.createElement(DragDropContextProvider, {
    contextId,
    getDragState,
    startKeyboardDrag,
    droppableRegistry
  }, children2)));
}
var tinyTransparentImage = (function() {
  if (typeof window === "undefined") {
    return null;
  }
  var img = new Image();
  img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
  return img;
})();
function disableNativeDragPreview(_ref) {
  var nativeSetDragImage = _ref.nativeSetDragImage;
  if (nativeSetDragImage && tinyTransparentImage) {
    nativeSetDragImage(tinyTransparentImage, 0, 0);
  }
}
var DroppableContext = /* @__PURE__ */ createContext(null);
var DroppableContextProvider = DroppableContext.Provider;
function useDroppableContext() {
  var value = useContext(DroppableContext);
  rbdInvariant(value, "Missing <Droppable /> parent");
  return value;
}
function useParentDroppableId() {
  var parentDroppable = useContext(DroppableContext);
  if (!parentDroppable) {
    return null;
  }
  return parentDroppable.droppableId;
}
function useDropTargetForDraggable(_ref) {
  var elementRef = _ref.elementRef, data2 = _ref.data, direction = _ref.direction, contextId = _ref.contextId, isDropDisabled = _ref.isDropDisabled, type4 = _ref.type;
  useEffect(function() {
    var element = elementRef.current;
    rbdInvariant(element instanceof HTMLElement);
    return dropTargetForElements({
      element,
      getIsSticky: function getIsSticky() {
        return true;
      },
      canDrop: function canDrop(_ref2) {
        var source = _ref2.source;
        if (!isDraggableData(source.data)) {
          return false;
        }
        if (isDropDisabled) {
          return false;
        }
        return source.data.type === type4 && source.data.contextId === contextId;
      },
      getData: function getData2(_ref3) {
        var input2 = _ref3.input;
        return attachClosestEdge(data2, {
          element,
          input: input2,
          allowedEdges: direction === "vertical" ? ["top", "bottom"] : ["left", "right"]
        });
      }
    });
  }, [data2, direction, contextId, isDropDisabled, type4, elementRef]);
}
function useKeyboardContext() {
  var _useDragDropContext = useDragDropContext(), startKeyboardDrag = _useDragDropContext.startKeyboardDrag;
  return {
    startKeyboardDrag
  };
}
function findDropIndicator() {
  return findElement({
    attribute: customAttributes.dropIndicator
  });
}
function findPlaceholder(contextId) {
  return findElement({
    attribute: attributes$1.placeholder.contextId,
    value: contextId
  });
}
function useStable(value) {
  var ref2 = useRef(value);
  useEffect(function() {
    ref2.current = value;
  }, [value]);
  var getValue3 = useCallback(function() {
    return ref2.current;
  }, []);
  return getValue3;
}
var zIndex = {
  dragging: 5e3
};
var keyboardPreviewCrossAxisOffset = 24;
function ownKeys$k(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$i(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$k(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var notDraggingStyle = {
  transform: void 0,
  transition: void 0
};
var baseDraggingStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  boxSizing: "border-box",
  transition: "none",
  zIndex: zIndex.dragging,
  /**
   * This transparency is intended to allow for better visibility of
   * drop indicators.
   */
  opacity: 0.75,
  pointerEvents: "none"
};
function getDraggingStyle(_ref) {
  var draggableDimensions = _ref.draggableDimensions, previewOffset = _ref.previewOffset;
  var rect = draggableDimensions.rect;
  var translateX = rect.left + previewOffset.x;
  var translateY = rect.top + previewOffset.y;
  var isAtOrigin = translateX === 0 && translateY === 0;
  return _objectSpread$i(_objectSpread$i({}, baseDraggingStyle), {}, {
    transform: isAtOrigin ? void 0 : "translate(".concat(translateX, "px, ").concat(translateY, "px)"),
    width: rect.width,
    height: rect.height
  });
}
function getDraggableProvidedStyle(_ref2) {
  var draggableDimensions = _ref2.draggableDimensions, draggableState = _ref2.draggableState;
  if (draggableState.type !== "dragging" || !draggableState.previewOffset || !draggableDimensions) {
    return notDraggingStyle;
  }
  return getDraggingStyle({
    draggableDimensions,
    previewOffset: draggableState.previewOffset
  });
}
var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};
function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }
  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);
  if (hasAnInteractiveTag) {
    return true;
  }
  var attribute = current.getAttribute("contenteditable");
  if (attribute === "true" || attribute === "") {
    return true;
  }
  if (current === parent) {
    return false;
  }
  return isAnInteractiveElement(parent, current.parentElement);
}
function isEventInInteractiveElement(draggable2, event) {
  var target = event.target;
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  return isAnInteractiveElement(draggable2, target);
}
var _extends_1;
var hasRequired_extends$1;
function require_extends$1() {
  if (hasRequired_extends$1) return _extends_1;
  hasRequired_extends$1 = 1;
  function _extends2() {
    _extends_1 = _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  _extends_1 = _extends2;
  return _extends_1;
}
var _extendsExports = require_extends$1();
const _extends$7 = /* @__PURE__ */ getDefaultExportFromCjs(_extendsExports);
function ownKeys$j(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$h(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$j(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var Placeholder = /* @__PURE__ */ memo(/* @__PURE__ */ forwardRef(function Placeholder2(_ref, ref2) {
  var styleProp = _ref.style;
  var dimensions = useDraggableDimensions();
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId;
  var dataAttributes = _defineProperty$2({}, attributes$1.placeholder.contextId, contextId);
  var style2 = useMemo$2(function() {
    if (!dimensions) {
      return;
    }
    var margin = dimensions.margin, rect = dimensions.rect;
    return _objectSpread$h({
      boxSizing: "border-box",
      width: rect.width,
      height: rect.height,
      margin
    }, styleProp);
  }, [dimensions, styleProp]);
  return /* @__PURE__ */ React__default.createElement("div", _extends$7({
    ref: ref2,
    style: style2
  }, dataAttributes));
}));
var directionMapping$1 = {
  vertical: {
    mainAxis: {
      name: "y",
      offset: "offsetTop",
      length: "offsetHeight",
      scrollOffset: "scrollTop",
      forwardEdge: "bottom",
      overflow: "overflowY",
      style: {
        length: "height",
        transform: "translateY"
      }
    },
    crossAxis: {
      name: "x",
      offset: "offsetLeft",
      length: "offsetWidth",
      style: {
        length: "width",
        offset: "left"
      }
    }
  },
  horizontal: {
    mainAxis: {
      name: "x",
      offset: "offsetLeft",
      length: "offsetWidth",
      scrollOffset: "scrollLeft",
      forwardEdge: "right",
      overflow: "overflowX",
      style: {
        length: "width",
        transform: "translateX"
      }
    },
    crossAxis: {
      name: "y",
      offset: "offsetTop",
      length: "offsetHeight",
      style: {
        length: "height",
        offset: "top"
      }
    }
  }
};
var lineThickness = 2;
var lineOffset = lineThickness / 2;
function ownKeys$i(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$g(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$i(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var idleState$1 = {
  type: "idle",
  draggingOver: null
};
function getHidingState(mode) {
  return {
    type: "hiding",
    draggingOver: null,
    mode
  };
}
var getKeyboardPreviewOffset = {
  initial: function initial(_ref) {
    var direction = _ref.direction;
    var _directionMapping$dir = directionMapping$1[direction], mainAxis = _directionMapping$dir.mainAxis, crossAxis = _directionMapping$dir.crossAxis;
    return _defineProperty$2(_defineProperty$2({}, mainAxis.name, 0), crossAxis.name, keyboardPreviewCrossAxisOffset);
  },
  home: function home(_ref3) {
    var direction = _ref3.droppable.direction, placeholderRect = _ref3.placeholderRect, draggableDimensions = _ref3.draggableDimensions;
    rbdInvariant(placeholderRect, "the placeholder should exist if in home position");
    var baseOffset = {
      x: placeholderRect.x - draggableDimensions.rect.x,
      y: placeholderRect.y - draggableDimensions.rect.y
    };
    var _directionMapping$dir2 = directionMapping$1[direction], mainAxis = _directionMapping$dir2.mainAxis, crossAxis = _directionMapping$dir2.crossAxis;
    return _defineProperty$2(_defineProperty$2({}, mainAxis.name, baseOffset[mainAxis.name]), crossAxis.name, baseOffset[crossAxis.name] + keyboardPreviewCrossAxisOffset);
  },
  away: function away(_ref5) {
    var direction = _ref5.droppable.direction, dropIndicatorRect = _ref5.dropIndicatorRect, draggableDimensions = _ref5.draggableDimensions;
    rbdInvariant(dropIndicatorRect, "the drop indicator should exist if in away position");
    var baseOffset = {
      x: dropIndicatorRect.x - draggableDimensions.rect.x,
      y: dropIndicatorRect.y - draggableDimensions.rect.y
    };
    var _directionMapping$dir3 = directionMapping$1[direction], mainAxis = _directionMapping$dir3.mainAxis, crossAxis = _directionMapping$dir3.crossAxis;
    return _defineProperty$2(_defineProperty$2({}, mainAxis.name, baseOffset[mainAxis.name] - 0.5 * draggableDimensions.rect[mainAxis.style.length]), crossAxis.name, baseOffset[crossAxis.name] + keyboardPreviewCrossAxisOffset);
  }
};
function updateKeyboardPreview(state, _ref7) {
  var _update$destination;
  var update2 = _ref7.update, droppable = _ref7.droppable, draggableDimensions = _ref7.draggableDimensions, placeholderRect = _ref7.placeholderRect, dropIndicatorRect = _ref7.dropIndicatorRect;
  if (!droppable || !draggableDimensions) {
    return state;
  }
  var data2 = {
    droppable,
    draggableDimensions,
    placeholderRect,
    dropIndicatorRect
  };
  var isHome = isSameLocation(update2.source, (_update$destination = update2.destination) !== null && _update$destination !== void 0 ? _update$destination : null);
  var previewOffset = isHome ? getKeyboardPreviewOffset.home(data2) : getKeyboardPreviewOffset.away(data2);
  if (!previewOffset) {
    return state;
  }
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    previewOffset
  });
}
function startDrag(state, _ref8) {
  var start2 = _ref8.start, previewOffset = _ref8.previewOffset;
  rbdInvariant(state.type === "idle", "The draggable is idle.");
  var draggingOver = start2.source.droppableId;
  var nextState = {
    type: "dragging",
    draggingOver,
    location: null,
    start: start2.source,
    draggableId: start2.draggableId,
    mode: start2.mode,
    previewOffset
  };
  return nextState;
}
function reducer$1(state, action3) {
  if (action3.type === "START_POINTER_DRAG") {
    return startDrag(state, _objectSpread$g(_objectSpread$g({}, action3.payload), {}, {
      previewOffset: {
        x: 0,
        y: 0
      }
    }));
  }
  if (action3.type === "START_KEYBOARD_DRAG") {
    var _action$payload = action3.payload, draggableDimensions = _action$payload.draggableDimensions, droppable = _action$payload.droppable;
    return startDrag(state, _objectSpread$g(_objectSpread$g({}, action3.payload), {}, {
      previewOffset: getKeyboardPreviewOffset.initial({
        draggableDimensions,
        direction: droppable.direction
      })
    }));
  }
  if (action3.type === "UPDATE_DRAG") {
    rbdInvariant(state.type === "dragging", "The draggable is dragging.");
    var update2 = action3.payload.update;
    var draggingOver = update2.destination ? update2.destination.droppableId : null;
    if (draggingOver === state.draggingOver) {
      return state;
    }
    var nextState = _objectSpread$g(_objectSpread$g({}, state), {}, {
      draggingOver
    });
    return nextState;
  }
  if (action3.type === "UPDATE_POINTER_PREVIEW") {
    rbdInvariant(state.type === "dragging", "The draggable is dragging.");
    var pointerLocation = action3.payload.pointerLocation;
    var _nextState = _objectSpread$g(_objectSpread$g({}, state), {}, {
      previewOffset: {
        x: pointerLocation.current.input.clientX - pointerLocation.initial.input.clientX,
        y: pointerLocation.current.input.clientY - pointerLocation.initial.input.clientY
      }
    });
    return _nextState;
  }
  if (action3.type === "UPDATE_KEYBOARD_PREVIEW") {
    rbdInvariant(state.type === "dragging", "The draggable is dragging.");
    if (state.type !== "dragging") {
      return state;
    }
    var _nextState2 = updateKeyboardPreview(state, action3.payload);
    return _nextState2;
  }
  if (action3.type === "DROP") {
    rbdInvariant(state.type === "dragging", "The draggable is dragging.");
    return idleState$1;
  }
  if (action3.type === "START_HIDING") {
    rbdInvariant(state.type === "idle" || state.type === "hiding");
    return getHidingState(action3.payload.mode);
  }
  if (action3.type === "STOP_HIDING") {
    rbdInvariant(state.type === "hiding");
    return idleState$1;
  }
  return state;
}
function useDraggableStateSnapshot(_ref) {
  var draggingOver = _ref.draggingOver, isClone = _ref.isClone, isDragging = _ref.isDragging, mode = _ref.mode;
  return useMemo$2(function() {
    return {
      isClone,
      isDragging,
      draggingOver,
      mode,
      /**
       * The properties below are fixed in the migration layer,
       * because they are not supported.
       *
       * Animation and combination were intentionally removed.
       */
      isDropAnimating: false,
      dropAnimation: null,
      combineWith: null,
      combineTargetFor: null
    };
  }, [draggingOver, isClone, isDragging, mode]);
}
var noop$2 = function noop2() {
};
function Draggable$1(_ref) {
  var children2 = _ref.children, draggableId = _ref.draggableId, index2 = _ref.index, _ref$isDragDisabled = _ref.isDragDisabled, isDragDisabled = _ref$isDragDisabled === void 0 ? false : _ref$isDragDisabled, _ref$disableInteracti = _ref.disableInteractiveElementBlocking, disableInteractiveElementBlocking = _ref$disableInteracti === void 0 ? false : _ref$disableInteracti;
  var _useDroppableContext = useDroppableContext(), direction = _useDroppableContext.direction, droppableId = _useDroppableContext.droppableId, type4 = _useDroppableContext.type, mode = _useDroppableContext.mode;
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId, getDragState = _useDragDropContext.getDragState;
  var elementRef = useRef(null);
  var dragHandleRef = useRef(null);
  var _useCleanupFn = useCleanupFn(), setCleanupFn = _useCleanupFn.setCleanupFn, runCleanupFn = _useCleanupFn.runCleanupFn;
  var setElement = useCallback(function(element) {
    if (elementRef.current) {
      runCleanupFn();
    }
    if (element) {
      var cleanupFn = setAttributes(element, _defineProperty$2(_defineProperty$2({}, customAttributes.draggable.droppableId, droppableId), customAttributes.draggable.index, String(index2)));
      setCleanupFn(cleanupFn);
    }
    elementRef.current = element;
    dragHandleRef.current = findDragHandle({
      contextId,
      draggableId
    });
  }, [contextId, draggableId, droppableId, index2, runCleanupFn, setCleanupFn]);
  var getIndex2 = useStable(index2);
  var _useReducer = useReducer(reducer$1, idleState$1), _useReducer2 = _slicedToArray$2(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var data2 = useDraggableData({
    draggableId,
    droppableId,
    getIndex: getIndex2,
    contextId,
    type: type4
  });
  var isDragging = state.type === "dragging";
  var isHiding = state.type === "hiding";
  var _useDroppableContext2 = useDroppableContext(), shouldRenderCloneWhileDragging = _useDroppableContext2.shouldRenderCloneWhileDragging, isDropDisabled = _useDroppableContext2.isDropDisabled;
  var monitorForLifecycle = useMonitorForLifecycle();
  var _useKeyboardContext = useKeyboardContext(), startKeyboardDrag = _useKeyboardContext.startKeyboardDrag;
  useEffect(function() {
    if (state.type !== "idle") {
      return;
    }
    if (isDragDisabled) {
      return;
    }
    var element = elementRef.current;
    invariant$1(element instanceof HTMLElement);
    var dragHandle = dragHandleRef.current;
    invariant$1(dragHandle instanceof HTMLElement);
    return distExports$1.bindAll(dragHandle, [{
      type: "keydown",
      listener: function listener(event) {
        if (event.key === " ") {
          if (event.defaultPrevented) {
            return;
          }
          if (!disableInteractiveElementBlocking && isEventInInteractiveElement(element, event)) {
            return;
          }
          event.preventDefault();
          startKeyboardDrag({
            event,
            draggableId,
            type: type4,
            getSourceLocation: function getSourceLocation() {
              return {
                droppableId,
                index: getIndex2()
              };
            },
            sourceElement: element
          });
        }
      }
    }]);
  }, [disableInteractiveElementBlocking, draggableId, droppableId, getIndex2, isDragDisabled, startKeyboardDrag, state.type, type4]);
  useEffect(function() {
    if (isHiding) {
      return;
    }
    if (isDragDisabled) {
      return;
    }
    var element = elementRef.current;
    rbdInvariant(element instanceof HTMLElement);
    var dragHandle = dragHandleRef.current;
    rbdInvariant(dragHandle instanceof HTMLElement);
    return draggable({
      canDrag: function canDrag(_ref2) {
        var input2 = _ref2.input;
        if (input2.ctrlKey || input2.metaKey || input2.shiftKey || input2.altKey) {
          return false;
        }
        if (!disableInteractiveElementBlocking) {
          var elementUnderPointer = getElementFromPointWithoutHoneypot({
            x: input2.clientX,
            y: input2.clientY
          });
          return !isAnInteractiveElement(dragHandle, elementUnderPointer);
        }
        return !isDragging;
      },
      element,
      dragHandle,
      getInitialData: function getInitialData() {
        return data2;
      },
      onGenerateDragPreview: disableNativeDragPreview
    });
  }, [data2, disableInteractiveElementBlocking, isDragDisabled, isDragging, isHiding]);
  var hasPlaceholder = state.type !== "idle" && mode === "standard";
  var placeholderRef = useRef(null);
  useDropTargetForDraggable({
    /**
     * Swapping the drop target to the placeholder is important
     * to ensure that hovering over where the item was won't result in a
     * drop at the end of the list.
     */
    elementRef: hasPlaceholder ? placeholderRef : elementRef,
    data: data2,
    direction,
    contextId,
    isDropDisabled,
    type: type4
  });
  var isMountedRef = useRef(true);
  useEffect(function() {
    isMountedRef.current = true;
    return function() {
      isMountedRef.current = false;
    };
  }, []);
  useEffect(function() {
    var dragState = getDragState();
    if (!shouldRenderCloneWhileDragging) {
      return;
    }
    if (!dragState.isDragging) {
      return;
    }
    if (dragState.draggableId !== data2.draggableId) {
      return;
    }
    dispatch({
      type: "START_HIDING",
      payload: {
        mode: dragState.mode
      }
    });
  }, [data2.draggableId, getDragState, shouldRenderCloneWhileDragging]);
  var draggableDimensions = useDraggableDimensions();
  useEffect(function() {
    if (shouldRenderCloneWhileDragging) {
      return monitorForLifecycle({
        onPendingDragStart: function onPendingDragStart(_ref3) {
          var start2 = _ref3.start;
          if (data2.draggableId !== start2.draggableId) {
            return;
          }
          dispatch({
            type: "START_HIDING",
            payload: {
              mode: start2.mode
            }
          });
        },
        onBeforeDragEnd: function onBeforeDragEnd(_ref4) {
          var draggableId2 = _ref4.draggableId;
          if (draggableId2 !== data2.draggableId) {
            return;
          }
          dispatch({
            type: "STOP_HIDING"
          });
        }
      });
    }
    return combine$1(monitorForLifecycle({
      onPendingDragStart: function onPendingDragStart(_ref5) {
        var start2 = _ref5.start, droppable = _ref5.droppable;
        if (data2.draggableId !== start2.draggableId) {
          return;
        }
        if (start2.mode === "FLUID") {
          return dispatch({
            type: "START_POINTER_DRAG",
            payload: {
              start: start2
            }
          });
        }
        if (start2.mode === "SNAP") {
          var dragState = getDragState();
          rbdInvariant(dragState.isDragging && dragState.draggableDimensions);
          return dispatch({
            type: "START_KEYBOARD_DRAG",
            payload: {
              start: start2,
              draggableDimensions: dragState.draggableDimensions,
              droppable
            }
          });
        }
      },
      onPendingDragUpdate: function onPendingDragUpdate(_ref6) {
        var update2 = _ref6.update, droppable = _ref6.droppable;
        if (data2.draggableId !== update2.draggableId) {
          return;
        }
        dispatch({
          type: "UPDATE_DRAG",
          payload: {
            update: update2
          }
        });
        if (update2.mode === "SNAP") {
          queueMicrotask(function() {
            var dragState = getDragState();
            if (!dragState.isDragging) {
              return;
            }
            var placeholder = findPlaceholder(contextId);
            var placeholderRect = placeholder ? placeholder.getBoundingClientRect() : null;
            var dropIndicator = findDropIndicator();
            var dropIndicatorRect = dropIndicator ? dropIndicator.getBoundingClientRect() : null;
            dispatch({
              type: "UPDATE_KEYBOARD_PREVIEW",
              payload: {
                update: update2,
                draggableDimensions,
                droppable,
                placeholderRect,
                dropIndicatorRect
              }
            });
          });
        }
      },
      onBeforeDragEnd: function onBeforeDragEnd(_ref7) {
        var draggableId2 = _ref7.draggableId;
        if (draggableId2 !== data2.draggableId) {
          return;
        }
        rbdInvariant(isMountedRef.current, "isMounted onBeforeDragEnd");
        dispatch({
          type: "DROP"
        });
      }
    }), monitorForElements({
      canMonitor: function canMonitor(_ref8) {
        var source = _ref8.source;
        if (!isDraggableData(source.data)) {
          return false;
        }
        return source.data.contextId === data2.contextId && source.data.draggableId === data2.draggableId;
      },
      onDrag: function onDrag(_ref9) {
        var location2 = _ref9.location;
        dispatch({
          type: "UPDATE_POINTER_PREVIEW",
          payload: {
            pointerLocation: location2
          }
        });
      }
    }));
  }, [data2.draggableId, data2.contextId, monitorForLifecycle, shouldRenderCloneWhileDragging, direction, contextId, draggableDimensions, getDragState]);
  var provided = useMemo$2(function() {
    return {
      draggableProps: _defineProperty$2(_defineProperty$2(_defineProperty$2({}, attributes$1.draggable.contextId, contextId), attributes$1.draggable.id, draggableId), "style", getDraggableProvidedStyle({
        draggableDimensions,
        draggableState: state
      })),
      dragHandleProps: _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({
        role: "button",
        "aria-describedby": getHiddenTextElementId(contextId)
      }, attributes$1.dragHandle.contextId, contextId), attributes$1.dragHandle.draggableId, draggableId), "tabIndex", 0), "draggable", false), "onDragStart", noop$2),
      innerRef: setElement
    };
  }, [contextId, draggableId, draggableDimensions, state, setElement]);
  var snapshot = useDraggableStateSnapshot({
    draggingOver: state.draggingOver,
    isClone: false,
    isDragging,
    mode: isDragging ? state.mode : null
  });
  var rubric = useMemo$2(function() {
    return {
      draggableId,
      type: type4,
      source: {
        droppableId,
        index: index2
      }
    };
  }, [draggableId, droppableId, index2, type4]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isHiding ? null : children2(provided, snapshot, rubric), hasPlaceholder && /* @__PURE__ */ React__default.createElement(Placeholder, {
    ref: placeholderRef
  }));
}
function getBody() {
  return document.body;
}
function DraggableCloneInner(_ref) {
  var children2 = _ref.children, droppableId = _ref.droppableId, type4 = _ref.type, draggableId = _ref.draggableId, index2 = _ref.index, draggingOver = _ref.draggingOver, style2 = _ref.style, _ref$getContainerForC = _ref.getContainerForClone, getContainerForClone = _ref$getContainerForC === void 0 ? getBody : _ref$getContainerForC, mode = _ref.mode;
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId;
  var focusDragHandle = useCallback(function(element) {
    if (!element) {
      return;
    }
    var dragHandle = findDragHandle({
      contextId,
      draggableId
    });
    dragHandle === null || dragHandle === void 0 || dragHandle.focus();
  }, [contextId, draggableId]);
  var provided = useMemo$2(function() {
    return {
      innerRef: focusDragHandle,
      draggableProps: _defineProperty$2(_defineProperty$2(_defineProperty$2({}, attributes$1.draggable.contextId, contextId), attributes$1.draggable.id, draggableId), "style", style2),
      dragHandleProps: _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({
        role: "button",
        "aria-describedby": getHiddenTextElementId(contextId)
      }, attributes$1.dragHandle.contextId, contextId), attributes$1.dragHandle.draggableId, draggableId), "tabIndex", 0), "draggable", false), "onDragStart", function onDragStart2() {
      })
    };
  }, [contextId, draggableId, focusDragHandle, style2]);
  var snapshot = useDraggableStateSnapshot({
    draggingOver,
    isClone: true,
    isDragging: true,
    mode
  });
  var rubric = useMemo$2(function() {
    return {
      draggableId,
      type: type4,
      source: {
        droppableId,
        index: index2
      }
    };
  }, [draggableId, droppableId, index2, type4]);
  return /* @__PURE__ */ createPortal(children2(provided, snapshot, rubric), getContainerForClone());
}
function DraggableClone(_ref2) {
  var children2 = _ref2.children, droppableId = _ref2.droppableId, type4 = _ref2.type, getContainerForClone = _ref2.getContainerForClone;
  var _useDragDropContext2 = useDragDropContext(), contextId = _useDragDropContext2.contextId, getDragState = _useDragDropContext2.getDragState;
  var draggableDimensions = useDraggableDimensions();
  var _useReducer = useReducer(reducer$1, idleState$1), _useReducer2 = _slicedToArray$2(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var monitorForLifecycle = useMonitorForLifecycle();
  useEffect(function() {
    return combine$1(monitorForLifecycle({
      onPendingDragStart: function onPendingDragStart(_ref3) {
        var start2 = _ref3.start, droppable = _ref3.droppable;
        if (droppableId !== start2.source.droppableId) {
          return;
        }
        if (start2.mode === "FLUID") {
          return dispatch({
            type: "START_POINTER_DRAG",
            payload: {
              start: start2
            }
          });
        }
        if (start2.mode === "SNAP") {
          var dragState = getDragState();
          rbdInvariant(dragState.isDragging && dragState.draggableDimensions);
          return dispatch({
            type: "START_KEYBOARD_DRAG",
            payload: {
              start: start2,
              draggableDimensions: dragState.draggableDimensions,
              droppable
            }
          });
        }
      },
      onPendingDragUpdate: function onPendingDragUpdate(_ref4) {
        var update2 = _ref4.update, droppable = _ref4.droppable;
        if (state.type !== "dragging") {
          return;
        }
        if (state.draggableId !== update2.draggableId) {
          return;
        }
        dispatch({
          type: "UPDATE_DRAG",
          payload: {
            update: update2
          }
        });
        if (update2.mode === "SNAP") {
          queueMicrotask(function() {
            var dragState = getDragState();
            if (!dragState.isDragging) {
              return;
            }
            var placeholder = findPlaceholder(contextId);
            var placeholderRect = placeholder ? placeholder.getBoundingClientRect() : null;
            var dropIndicator = findDropIndicator();
            var dropIndicatorRect = dropIndicator ? dropIndicator.getBoundingClientRect() : null;
            dispatch({
              type: "UPDATE_KEYBOARD_PREVIEW",
              payload: {
                update: update2,
                draggableDimensions,
                droppable,
                placeholderRect,
                dropIndicatorRect
              }
            });
          });
        }
      },
      onBeforeDragEnd: function onBeforeDragEnd(_ref5) {
        var draggableId = _ref5.draggableId;
        if (state.type !== "dragging") {
          return;
        }
        if (draggableId !== state.draggableId) {
          return;
        }
        dispatch({
          type: "DROP"
        });
      }
    }), monitorForElements({
      canMonitor: function canMonitor(_ref6) {
        var source = _ref6.source;
        if (!isDraggableData(source.data)) {
          return false;
        }
        return source.data.contextId === contextId && source.data.droppableId === droppableId;
      },
      onDrag: function onDrag(_ref7) {
        var location2 = _ref7.location;
        dispatch({
          type: "UPDATE_POINTER_PREVIEW",
          payload: {
            pointerLocation: location2
          }
        });
      }
    }));
  }, [droppableId, contextId, monitorForLifecycle, state, draggableDimensions, getDragState]);
  if (state.type !== "dragging") {
    return null;
  }
  var style2 = getDraggableProvidedStyle({
    draggableDimensions,
    draggableState: state
  });
  return /* @__PURE__ */ React__default.createElement(DraggableCloneInner, {
    droppableId,
    type: type4,
    draggableId: state.draggableId,
    index: state.start.index,
    draggingOver: state.draggingOver,
    mode: state.mode,
    style: style2,
    getContainerForClone
  }, children2);
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
})();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT$1 = "comm";
var RULESET$1 = "rule";
var DECLARATION$1 = "decl";
var IMPORT$1 = "@import";
var KEYFRAMES$1 = "@keyframes";
var LAYER$1 = "@layer";
var abs$1 = Math.abs;
var from$1 = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat$1(value, 0) ^ 45 ? (((length2 << 2 ^ charat$1(value, 0)) << 2 ^ charat$1(value, 1)) << 2 ^ charat$1(value, 2)) << 2 ^ charat$1(value, 3) : 0;
}
function trim$1(value) {
  return value.trim();
}
function match$1(value, pattern4) {
  return (value = pattern4.exec(value)) ? value[0] : value;
}
function replace$1(value, pattern4, replacement) {
  return value.replace(pattern4, replacement);
}
function indexof$1(value, search3) {
  return value.indexOf(search3);
}
function charat$1(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr$1(value, begin, end) {
  return value.slice(begin, end);
}
function strlen$1(value) {
  return value.length;
}
function sizeof$1(value) {
  return value.length;
}
function append$1(value, array4) {
  return array4.push(value), value;
}
function combine(array4, callback) {
  return array4.map(callback).join("");
}
var line$1 = 1;
var column$1 = 1;
var length$1 = 0;
var position$1 = 0;
var character$1 = 0;
var characters$1 = "";
function node$1(value, root, parent, type4, props, children2, length2) {
  return { value, root, parent, type: type4, props, children: children2, line: line$1, column: column$1, length: length2, return: "" };
}
function copy$1(root, props) {
  return assign(node$1("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char$1() {
  return character$1;
}
function prev$1() {
  character$1 = position$1 > 0 ? charat$1(characters$1, --position$1) : 0;
  if (column$1--, character$1 === 10)
    column$1 = 1, line$1--;
  return character$1;
}
function next$1() {
  character$1 = position$1 < length$1 ? charat$1(characters$1, position$1++) : 0;
  if (column$1++, character$1 === 10)
    column$1 = 1, line$1++;
  return character$1;
}
function peek$1() {
  return charat$1(characters$1, position$1);
}
function caret$2() {
  return position$1;
}
function slice$1(begin, end) {
  return substr$1(characters$1, begin, end);
}
function token$3(type4) {
  switch (type4) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$1(value) {
  return line$1 = column$1 = 1, length$1 = strlen$1(characters$1 = value), position$1 = 0, [];
}
function dealloc$1(value) {
  return characters$1 = "", value;
}
function delimit$1(type4) {
  return trim$1(slice$1(position$1 - 1, delimiter$1(type4 === 91 ? type4 + 2 : type4 === 40 ? type4 + 1 : type4)));
}
function whitespace$2(type4) {
  while (character$1 = peek$1())
    if (character$1 < 33)
      next$1();
    else
      break;
  return token$3(type4) > 2 || token$3(character$1) > 3 ? "" : " ";
}
function escaping$1(index2, count) {
  while (--count && next$1())
    if (character$1 < 48 || character$1 > 102 || character$1 > 57 && character$1 < 65 || character$1 > 70 && character$1 < 97)
      break;
  return slice$1(index2, caret$2() + (count < 6 && peek$1() == 32 && next$1() == 32));
}
function delimiter$1(type4) {
  while (next$1())
    switch (character$1) {
      // ] ) " '
      case type4:
        return position$1;
      // " '
      case 34:
      case 39:
        if (type4 !== 34 && type4 !== 39)
          delimiter$1(character$1);
        break;
      // (
      case 40:
        if (type4 === 41)
          delimiter$1(type4);
        break;
      // \
      case 92:
        next$1();
        break;
    }
  return position$1;
}
function commenter$1(type4, index2) {
  while (next$1())
    if (type4 + character$1 === 47 + 10)
      break;
    else if (type4 + character$1 === 42 + 42 && peek$1() === 47)
      break;
  return "/*" + slice$1(index2, position$1 - 1) + "*" + from$1(type4 === 47 ? type4 : next$1());
}
function identifier$1(index2) {
  while (!token$3(peek$1()))
    next$1();
  return slice$1(index2, position$1);
}
function compile$1(value) {
  return dealloc$1(parse$1("", null, null, null, [""], value = alloc$1(value), 0, [0], value));
}
function parse$1(value, root, parent, rule, rules2, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type4 = "";
  var props = rules2;
  var children2 = rulesets;
  var reference = rule;
  var characters2 = type4;
  while (scanning)
    switch (previous = character2, character2 = next$1()) {
      // (
      case 40:
        if (previous != 108 && charat$1(characters2, length2 - 1) == 58) {
          if (indexof$1(characters2 += replace$1(delimit$1(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit$1(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace$2(previous);
        break;
      // \
      case 92:
        characters2 += escaping$1(caret$2() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$1()) {
          case 42:
          case 47:
            append$1(comment$1(commenter$1(next$1(), caret$2()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index2++] = strlen$1(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset:
            if (ampersand == -1) characters2 = replace$1(characters2, /\f/g, "");
            if (property > 0 && strlen$1(characters2) - length2)
              append$1(property > 32 ? declaration$1(characters2 + ";", rule, parent, length2 - 1) : declaration$1(replace$1(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append$1(reference = ruleset$1(characters2, root, parent, index2, offset, rules2, points, type4, props = [], children2 = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse$1(characters2, root, reference, reference, props, rulesets, length2, points, children2);
              else
                switch (atrule === 99 && charat$1(characters2, 3) === 110 ? 100 : atrule) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(value, reference, reference, rule && append$1(ruleset$1(value, reference, reference, 0, 0, rules2, points, type4, rules2, props = [], length2), children2), rules2, children2, length2, points, rule ? props : children2);
                    break;
                  default:
                    parse$1(characters2, reference, reference, reference, [""], children2, 0, points, children2);
                }
        }
        index2 = offset = property = 0, variable = ampersand = 1, type4 = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen$1(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev$1() == 125)
            continue;
        }
        switch (characters2 += from$1(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index2++] = (strlen$1(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek$1() === 45)
              characters2 += delimit$1(next$1());
            atrule = peek$1(), offset = length2 = strlen$1(type4 = characters2 += identifier$1(caret$2())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen$1(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset$1(value, root, parent, index2, offset, rules2, points, type4, props, children2, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules2 : [""];
  var size2 = sizeof$1(rule);
  for (var i = 0, j = 0, k = 0; i < index2; ++i)
    for (var x = 0, y = substr$1(value, post + 1, post = abs$1(j = points[i])), z = value; x < size2; ++x)
      if (z = trim$1(j > 0 ? rule[x] + " " + y : replace$1(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node$1(value, root, parent, offset === 0 ? RULESET$1 : type4, props, children2, length2);
}
function comment$1(value, root, parent) {
  return node$1(value, root, parent, COMMENT$1, from$1(char$1()), substr$1(value, 2, -2), 0);
}
function declaration$1(value, root, parent, length2) {
  return node$1(value, root, parent, DECLARATION$1, substr$1(value, 0, length2), substr$1(value, length2 + 1, -1), length2);
}
function serialize$2(children2, callback) {
  var output = "";
  var length2 = sizeof$1(children2);
  for (var i = 0; i < length2; i++)
    output += callback(children2[i], i, children2, callback) || "";
  return output;
}
function stringify$2(element, index2, children2, callback) {
  switch (element.type) {
    case LAYER$1:
      if (element.children.length) break;
    case IMPORT$1:
    case DECLARATION$1:
      return element.return = element.return || element.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES$1:
      return element.return = element.value + "{" + serialize$2(element.children, callback) + "}";
    case RULESET$1:
      element.value = element.props.join(",");
  }
  return strlen$1(children2 = serialize$2(element.children, callback)) ? element.return = element.value + "{" + children2 + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof$1(collection);
  return function(element, index2, children2, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children2, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize(fn) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0) cache2[arg] = fn(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek$1();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token$3(character2)) {
      break;
    }
    next$1();
  }
  return slice$1(begin, position$1);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token$3(character2)) {
      case 0:
        if (character2 === 38 && peek$1() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position$1 - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit$1(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek$1() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      // fallthrough
      default:
        parsed[index2] += from$1(character2);
    }
  } while (character2 = next$1());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc$1(toRules(alloc$1(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules2 = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules2.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules2[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules2[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    // align-items
    case 5187:
      return WEBKIT + value + replace$1(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    // align-self
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace$1(value, /flex-|-self/, "") + value;
    // align-content
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace$1(value, /align-content|flex-|-self/, "") + value;
    // flex-shrink
    case 5548:
      return WEBKIT + value + MS + replace$1(value, "shrink", "negative") + value;
    // flex-basis
    case 5292:
      return WEBKIT + value + MS + replace$1(value, "basis", "preferred-size") + value;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$1(value, "-grow", "") + WEBKIT + value + MS + replace$1(value, "grow", "positive") + value;
    // transition
    case 4554:
      return WEBKIT + replace$1(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    // cursor
    case 6187:
      return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    // background, background-image
    case 5495:
    case 3959:
      return replace$1(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$1(replace$1(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen$1(value) - 1 - length2 > 6) switch (charat$1(value, length2 + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat$1(value, length2 + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$1(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat$1(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        // (s)tretch
        case 115:
          return ~indexof$1(value, "stretch") ? prefix(replace$1(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    // position: sticky
    case 4949:
      if (charat$1(value, length2 + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat$1(value, strlen$1(value) - 3 - (~indexof$1(value, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$1(value, ":", ":" + WEBKIT) + value;
        // (inline-)?fl(e)x
        case 101:
          return replace$1(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat$1(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat$1(value, length2 + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        // vertical-r(l)
        case 108:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children2, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION$1:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES$1:
        return serialize$2([copy$1(element, {
          value: replace$1(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET$1:
        if (element.length) return combine(element.props, function(value) {
          switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ":read-only":
            case ":read-write":
              return serialize$2([copy$1(element, {
                props: [replace$1(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            // :placeholder
            case "::placeholder":
              return serialize$2([copy$1(element, {
                props: [replace$1(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy$1(element, {
                props: [replace$1(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy$1(element, {
                props: [replace$1(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache$1 = function createCache(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify$2, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize$2(compile$1(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
var isBrowser$3 = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$3 === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag) {
  registerStyles(cache2, serialized, isStringTag);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2$1(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys$1[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes = interpolation;
      if (keyframes.anim === 1) {
        cursor = {
          name: keyframes.name,
          styles: keyframes.styles,
          next: cursor
        };
        return keyframes.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next4 = serializedStyles.next;
        if (next4 !== void 0) {
          while (next4 !== void 0) {
            cursor = {
              name: next4.name,
              styles: next4.styles,
              next: cursor
            };
            next4 = next4.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  {
    return asString;
  }
}
function createStringFromObject(mergedProps, registered, obj) {
  var string3 = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string3 += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== "object") {
        var asString = value;
        if (isProcessableValue(asString)) {
          string3 += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value) && typeof value[0] === "string" && registered == null) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string3 += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case "animation":
            case "animationName": {
              string3 += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string3 += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string3;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2$1(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect$2 = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect$2 || syncFallback;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache$1({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref2) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref2);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type4, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type4;
  return newProps;
};
var Insertion = function Insertion2(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref2) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && true) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref2) {
    newProps.ref = ref2;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var jsx = function jsx2(type4, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type4, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  /* @__PURE__ */ (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var directionMapping = {
  horizontal: {
    rect: {
      start: "left",
      end: "right"
    }
  },
  vertical: {
    rect: {
      start: "top",
      end: "bottom"
    }
  }
};
function getDistance(_ref) {
  var a = _ref.a, b = _ref.b, direction = _ref.direction;
  var rect = directionMapping[direction].rect;
  return Math.max(a[rect.start], b[rect.start]) - Math.min(a[rect.end], b[rect.end]);
}
function getDroppableId(element) {
  return getAttribute(element, customAttributes.draggable.droppableId);
}
function getIndex(element) {
  var value = getAttribute(element, customAttributes.draggable.index);
  var index2 = parseInt(value);
  rbdInvariant(Number.isInteger(index2), "invalid index: '".concat(index2, "' is not an integer"));
  return index2;
}
function calculateGap(_ref) {
  var element = _ref.element, where = _ref.where, direction = _ref.direction, contextId = _ref.contextId;
  var droppableId = getDroppableId(element);
  var index2 = getIndex(element);
  var indexBefore = index2 - 1;
  var indexAfter = index2 + 1;
  var isBefore = where === "before";
  var adjacentElement = getElementByDraggableLocation(contextId, {
    droppableId,
    index: isBefore ? indexBefore : indexAfter
  });
  if (adjacentElement === null) {
    var _getComputedStyle = getComputedStyle(element), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft;
    if (direction === "horizontal") {
      return parseFloat(marginLeft) + parseFloat(marginRight);
    }
    return parseFloat(marginTop) + parseFloat(marginBottom);
  }
  var distance = getDistance({
    direction,
    a: element.getBoundingClientRect(),
    b: adjacentElement.getBoundingClientRect()
  });
  return distance;
}
function getGapOffset(_ref2) {
  var element = _ref2.element, where = _ref2.where, direction = _ref2.direction, contextId = _ref2.contextId;
  var gap = calculateGap({
    element,
    where,
    direction,
    contextId
  });
  if (where === "before") {
    return -gap / 2;
  }
  return gap / 2;
}
function measureDraggable(_ref) {
  var element = _ref.element, isForwardEdge = _ref.isForwardEdge, mode = _ref.mode, direction = _ref.direction, contextId = _ref.contextId;
  var _directionMapping$dir = directionMapping$1[direction], mainAxis = _directionMapping$dir.mainAxis, crossAxis = _directionMapping$dir.crossAxis;
  var offsetElement = getClosestPositionedElement({
    element,
    mode
  });
  var gapOffset = getGapOffset({
    element,
    where: isForwardEdge ? "after" : "before",
    direction,
    contextId
  });
  var baseOffset = offsetElement[mainAxis.offset] - lineOffset;
  var mainAxisOffset = isForwardEdge ? baseOffset + element[mainAxis.length] : baseOffset;
  return {
    mainAxis: {
      offset: mainAxisOffset + gapOffset
    },
    crossAxis: {
      offset: offsetElement[crossAxis.offset],
      length: offsetElement[crossAxis.length]
    }
  };
}
function measurePlaceholder(_ref2) {
  var element = _ref2.element, direction = _ref2.direction;
  var _directionMapping$dir2 = directionMapping$1[direction], mainAxis = _directionMapping$dir2.mainAxis, crossAxis = _directionMapping$dir2.crossAxis;
  var baseOffset = element[mainAxis.offset] - lineOffset;
  var mainAxisOffset = baseOffset + element[mainAxis.length] / 2;
  return {
    mainAxis: {
      offset: mainAxisOffset
    },
    crossAxis: {
      offset: element[crossAxis.offset],
      length: element[crossAxis.length]
    }
  };
}
function getDroppableOffset(_ref3) {
  var element = _ref3.element, direction = _ref3.direction;
  var mainAxis = directionMapping$1[direction].mainAxis;
  var scrollContainer = findClosestScrollContainer(element);
  if (!scrollContainer) {
    return 0;
  }
  var _getComputedStyle = getComputedStyle(scrollContainer), position2 = _getComputedStyle.position;
  if (position2 !== "static") {
    return 0;
  }
  return scrollContainer[mainAxis.offset];
}
function measureDroppable(_ref4) {
  var droppableId = _ref4.droppableId, direction = _ref4.direction;
  var element = getElement({
    attribute: attributes$1.droppable.id,
    value: droppableId
  });
  var mainAxisOffset = getDroppableOffset({
    element,
    direction
  });
  return {
    mainAxis: {
      offset: mainAxisOffset
    },
    crossAxis: {
      offset: 0,
      length: "100%"
    }
  };
}
function getIndicatorSizeAndOffset(_ref5) {
  var targetLocation = _ref5.targetLocation, isInHomeLocation = _ref5.isInHomeLocation, direction = _ref5.direction, mode = _ref5.mode, contextId = _ref5.contextId;
  if (isInHomeLocation) {
    var _element = findPlaceholder(contextId);
    if (!_element) {
      return null;
    }
    return measurePlaceholder({
      element: _element,
      direction
    });
  }
  if (targetLocation.index === 0) {
    var _element2 = getElementByDraggableLocation(contextId, targetLocation);
    if (!_element2) {
      return measureDroppable({
        droppableId: targetLocation.droppableId,
        direction
      });
    }
    return measureDraggable({
      element: _element2,
      // `false` because the line is before the item
      isForwardEdge: false,
      mode,
      direction,
      contextId
    });
  }
  var element = getElementByDraggableLocation(contextId, {
    droppableId: targetLocation.droppableId,
    // subtracting one because it is the draggable above
    index: targetLocation.index - 1
  });
  if (!element) {
    return null;
  }
  return measureDraggable({
    element,
    // `true` because the line is after the item
    isForwardEdge: true,
    mode,
    direction,
    contextId
  });
}
var scrollMarginTop = lineThickness + 2 * lineOffset;
var baseStyles = css({
  background: "var(--ds-border-brand, #0C66E4)",
  /**
   * Ensures that when the indicator is scrolled into view there is visual
   * space around it.
   *
   * Otherwise it will hug the edge of the container and be hard to see.
   */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  scrollMarginTop,
  /**
   * The bottom margin needs to be slightly bigger for the gap to look
   * the same visually.
   *
   * It's unclear why, this was found through testing.
   */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  scrollMarginBottom: scrollMarginTop + lineOffset
});
var virtualStyles = css({
  position: "absolute",
  top: 0,
  left: 0
});
var visuallyHiddenStyles = css({
  opacity: 0
});
var directionStyles = {
  horizontal: css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: lineThickness,
    height: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    marginLeft: -lineThickness
  }),
  vertical: css({
    width: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: lineThickness,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    marginTop: -lineThickness
  })
};
function getDynamicStyles(_ref) {
  var direction = _ref.direction, dimensions = _ref.dimensions, indicatorOffset = _ref.indicatorOffset;
  if (dimensions === null) {
    return {
      opacity: 0
    };
  }
  var _directionMapping$dir = directionMapping$1[direction], mainAxis = _directionMapping$dir.mainAxis, crossAxis = _directionMapping$dir.crossAxis;
  return _defineProperty$2(_defineProperty$2({
    transform: "".concat(mainAxis.style.transform, "(").concat(dimensions.mainAxis.offset - indicatorOffset, "px)")
  }, crossAxis.style.length, dimensions.crossAxis.length), crossAxis.style.offset, dimensions.crossAxis.offset);
}
var dropIndicatorData = _defineProperty$2({}, customAttributes.dropIndicator, "");
var DropIndicator = function DropIndicator2(_ref3) {
  var direction = _ref3.direction, mode = _ref3.mode;
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId, getDragState = _useDragDropContext.getDragState;
  var ref2 = useRef(null);
  var _useState = useState$1(null), _useState2 = _slicedToArray$2(_useState, 2), dimensions = _useState2[0], setDimensions = _useState2[1];
  var _useState3 = useState$1(false), _useState4 = _slicedToArray$2(_useState3, 2), isHidden = _useState4[0], setIsHidden = _useState4[1];
  var monitorForLifecycle = useMonitorForLifecycle();
  var updateIndicator = useCallback(function(_ref4) {
    var targetLocation = _ref4.targetLocation, source = _ref4.source, destination = _ref4.destination;
    if (!targetLocation) {
      return setDimensions(null);
    }
    var isInHomeLocation = isSameLocation(source, destination);
    setIsHidden(isInHomeLocation);
    return setDimensions(getIndicatorSizeAndOffset({
      targetLocation,
      isInHomeLocation,
      direction,
      mode,
      contextId
    }));
  }, [contextId, direction, mode]);
  useLayoutEffect$2(function() {
    var dragState = getDragState();
    if (!dragState.isDragging) {
      return;
    }
    var targetLocation = dragState.targetLocation, sourceLocation = dragState.sourceLocation;
    var destination = getActualDestination({
      start: sourceLocation,
      target: targetLocation
    });
    updateIndicator({
      targetLocation,
      destination,
      source: sourceLocation
    });
    return monitorForLifecycle({
      onPrePendingDragUpdate: function onPrePendingDragUpdate(_ref5) {
        var update2 = _ref5.update, targetLocation2 = _ref5.targetLocation;
        var _update$destination = update2.destination, destination2 = _update$destination === void 0 ? null : _update$destination, source = update2.source;
        updateIndicator({
          targetLocation: targetLocation2,
          source,
          destination: destination2
        });
      }
    });
  }, [contextId, direction, getDragState, mode, monitorForLifecycle, updateIndicator]);
  useLayoutEffect$2(function() {
    if (dimensions === null) {
      return;
    }
    var dragState = getDragState();
    if (!dragState.isDragging || dragState.mode !== "SNAP") {
      return;
    }
    var element = ref2.current;
    rbdInvariant(element instanceof HTMLElement);
    element.scrollIntoView({
      block: "nearest"
    });
  }, [dimensions, getDragState]);
  var mainAxis = directionMapping$1[direction].mainAxis;
  var indicatorOffset = ref2.current ? ref2.current[mainAxis.offset] : 0;
  var dynamicStyles = getDynamicStyles({
    direction,
    dimensions,
    indicatorOffset
  });
  var isVirtual = mode === "virtual";
  return jsx("div", _extends$7({
    ref: ref2,
    css: [baseStyles, directionStyles[direction], isVirtual && virtualStyles, isHidden && visuallyHiddenStyles],
    style: dynamicStyles
  }, dropIndicatorData));
};
function ownKeys$h(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$f(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$h(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var idleState = {
  draggingFromThisWith: null,
  draggingOverWith: null,
  isDraggingOver: false
};
function reducer(state, action3) {
  if (action3.type === "DRAG_START") {
    var _action$payload = action3.payload, droppableId = _action$payload.droppableId, start2 = _action$payload.start;
    var draggableId = start2.draggableId, source = start2.source;
    var isDraggingOver = source.droppableId === droppableId;
    var draggingOverWith = isDraggingOver ? draggableId : null;
    var isDraggingFrom = source.droppableId === droppableId;
    var draggingFromThisWith = isDraggingFrom ? draggableId : null;
    return _objectSpread$f(_objectSpread$f({}, state), {}, {
      isDraggingOver,
      draggingFromThisWith,
      draggingOverWith
    });
  }
  if (action3.type === "DRAG_UPDATE") {
    var _action$payload2 = action3.payload, _droppableId = _action$payload2.droppableId, update2 = _action$payload2.update;
    var _update$destination = update2.destination, destination = _update$destination === void 0 ? null : _update$destination, _draggableId = update2.draggableId, _source = update2.source;
    var _isDraggingOver = (destination === null || destination === void 0 ? void 0 : destination.droppableId) === _droppableId;
    var _draggingOverWith = _isDraggingOver ? _draggableId : null;
    var _isDraggingFrom = _source.droppableId === _droppableId;
    var _draggingFromThisWith = _isDraggingFrom ? _draggableId : null;
    return _objectSpread$f(_objectSpread$f({}, state), {}, {
      isDraggingOver: _isDraggingOver,
      draggingFromThisWith: _draggingFromThisWith,
      draggingOverWith: _draggingOverWith
    });
  }
  if (action3.type === "DRAG_CLEAR") {
    return idleState;
  }
  return state;
}
function VirtualPlaceholder(_ref) {
  var draggableId = _ref.draggableId, droppableId = _ref.droppableId, type4 = _ref.type, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled;
  var ref2 = useRef(null);
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId, getDragState = _useDragDropContext.getDragState;
  var dragState = getDragState();
  rbdInvariant(dragState.isDragging, "The virtual placeholder should only be rendered during a drag");
  var getIndex2 = useCallback(function() {
    return dragState.sourceLocation.index;
  }, [dragState.sourceLocation.index]);
  var data2 = useDraggableData({
    draggableId,
    droppableId,
    getIndex: getIndex2,
    contextId,
    type: type4
  });
  useDropTargetForDraggable({
    elementRef: ref2,
    data: data2,
    direction,
    contextId,
    isDropDisabled,
    type: type4
  });
  var style2 = useMemo$2(function() {
    return {
      position: "absolute",
      top: dragState.draggableInitialOffsetInSourceDroppable.top,
      left: dragState.draggableInitialOffsetInSourceDroppable.left,
      margin: 0
    };
  }, [dragState.draggableInitialOffsetInSourceDroppable.left, dragState.draggableInitialOffsetInSourceDroppable.top]);
  return /* @__PURE__ */ React__default.createElement(Placeholder, {
    ref: ref2,
    style: style2
  });
}
function Droppable(_ref) {
  var children2 = _ref.children, droppableId = _ref.droppableId, _ref$type = _ref.type, type4 = _ref$type === void 0 ? "DEFAULT" : _ref$type, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "vertical" : _ref$direction, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "standard" : _ref$mode, renderClone = _ref.renderClone, getContainerForClone = _ref.getContainerForClone, _ref$isDropDisabled = _ref.isDropDisabled, isDropDisabled = _ref$isDropDisabled === void 0 ? false : _ref$isDropDisabled;
  var getIsDropDisabled = useStable(isDropDisabled);
  var _useDragDropContext = useDragDropContext(), contextId = _useDragDropContext.contextId, droppableRegistry = _useDragDropContext.droppableRegistry;
  var data2 = useDroppableData({
    contextId,
    droppableId,
    getIsDropDisabled
  });
  var elementRef = useRef(null);
  var setElement = useCallback(function(element2) {
    if (element2) {
      setAttributes(element2, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, customAttributes.droppable.type, type4), customAttributes.droppable.direction, direction), attributes$1.droppable.id, droppableId), attributes$1.droppable.contextId, contextId));
    }
    elementRef.current = element2;
  }, [contextId, direction, droppableId, type4]);
  var _useReducer = useReducer(reducer, idleState), _useReducer2 = _slicedToArray$2(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var draggingFromThisWith = state.draggingFromThisWith, draggingOverWith = state.draggingOverWith, isDraggingOver = state.isDraggingOver;
  var parentDroppableId = useParentDroppableId();
  useEffect(function() {
    var element2 = elementRef.current;
    invariant$1(element2 instanceof HTMLElement, "innerRef must provide an `HTMLElement`");
    return combine$1(droppableRegistry.register({
      droppableId,
      type: type4,
      isDropDisabled,
      parentDroppableId,
      element: element2,
      direction,
      mode
    }), dropTargetForElements({
      element: element2,
      getData: function getData2(_ref2) {
        var input2 = _ref2.input;
        return attachClosestEdge(data2, {
          element: element2,
          input: input2,
          allowedEdges: direction === "vertical" ? ["top", "bottom"] : ["left", "right"]
        });
      },
      canDrop: function canDrop(_ref3) {
        var source = _ref3.source;
        if (!isDraggableData(source.data)) {
          return false;
        }
        if (isDropDisabled) {
          return false;
        }
        return source.data.contextId === contextId && source.data.type === type4;
      },
      onDragLeave: function onDragLeave() {
        dispatch({
          type: "DRAG_CLEAR"
        });
      }
    }));
  }, [data2, droppableId, contextId, isDropDisabled, type4, droppableRegistry, parentDroppableId, direction, mode]);
  var monitorForLifecycle = useMonitorForLifecycle();
  useEffect(function() {
    function isEventRelevant(data3) {
      var _data$destination;
      var isSameType = data3.type === type4;
      var isOverAfterUpdate = ((_data$destination = data3.destination) === null || _data$destination === void 0 ? void 0 : _data$destination.droppableId) === droppableId;
      var isDragEnter = !isDraggingOver && isOverAfterUpdate;
      var isDragLeave = isDraggingOver && !isOverAfterUpdate;
      var isDragEnterOrLeave = isDragEnter || isDragLeave;
      return isSameType && isDragEnterOrLeave;
    }
    return monitorForLifecycle({
      onPendingDragStart: function onPendingDragStart(_ref4) {
        var start2 = _ref4.start;
        if (!isEventRelevant({
          destination: start2.source,
          type: start2.type
        })) {
          return;
        }
        dispatch({
          type: "DRAG_START",
          payload: {
            droppableId,
            start: start2
          }
        });
      },
      onPendingDragUpdate: function onPendingDragUpdate(_ref5) {
        var update2 = _ref5.update;
        if (!isEventRelevant(update2)) {
          return;
        }
        dispatch({
          type: "DRAG_UPDATE",
          payload: {
            droppableId,
            update: update2
          }
        });
      },
      onBeforeDragEnd: function onBeforeDragEnd() {
        dispatch({
          type: "DRAG_CLEAR"
        });
      }
    });
  }, [droppableId, isDraggingOver, monitorForLifecycle, type4]);
  var dropIndicator = useMemo$2(function() {
    if (!isDraggingOver) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement(DropIndicator, {
      direction,
      mode
    });
  }, [direction, isDraggingOver, mode]);
  var provided = useMemo$2(function() {
    return {
      innerRef: setElement,
      droppableProps: _defineProperty$2(_defineProperty$2({}, attributes$1.droppable.contextId, contextId), attributes$1.droppable.id, droppableId),
      /**
       * We only provide a drop indicator as the placeholder for
       * non-virtual lists. Otherwise it is portalled in.
       */
      placeholder: mode === "standard" ? dropIndicator : null
    };
  }, [contextId, dropIndicator, droppableId, mode, setElement]);
  var snapshot = useMemo$2(function() {
    return {
      draggingFromThisWith,
      draggingOverWith,
      isDraggingOver,
      isUsingPlaceholder: isDraggingOver
    };
  }, [draggingFromThisWith, draggingOverWith, isDraggingOver]);
  var element = elementRef.current;
  var shouldPortalDropIndicator = isDraggingOver && mode === "virtual" && element;
  useIsomorphicLayoutEffect$2(function() {
    if (!shouldPortalDropIndicator) {
      return;
    }
    var _window$getComputedSt = window.getComputedStyle(element), position2 = _window$getComputedSt.position;
    if (position2 !== "static") {
      return;
    }
    var prevStyle = element.style.position;
    element.style.position = "relative";
    return function() {
      element.style.position = prevStyle;
    };
  }, [element, shouldPortalDropIndicator]);
  var shouldRenderCloneWhileDragging = Boolean(renderClone);
  var contextValue = useMemo$2(function() {
    return {
      direction,
      droppableId,
      shouldRenderCloneWhileDragging,
      isDropDisabled,
      type: type4,
      mode
    };
  }, [direction, droppableId, shouldRenderCloneWhileDragging, isDropDisabled, type4, mode]);
  var shouldPortalPlaceholder = draggingFromThisWith && mode === "virtual" && element;
  return /* @__PURE__ */ React__default.createElement(DroppableContextProvider, {
    value: contextValue
  }, children2(provided, snapshot), shouldPortalDropIndicator && /* @__PURE__ */ createPortal(dropIndicator, element), shouldPortalPlaceholder && /* @__PURE__ */ createPortal(/* @__PURE__ */ React__default.createElement(VirtualPlaceholder, {
    droppableId,
    draggableId: draggingFromThisWith,
    type: type4,
    direction,
    isDropDisabled
  }), element), renderClone && /* @__PURE__ */ React__default.createElement(DraggableClone, {
    droppableId,
    type: type4,
    getContainerForClone
  }, renderClone));
}
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node2, i) {
    return React__default.createElement(node2.tag, __assign({
      key: i
    }, node2.attr), Tree2Element(node2.child));
  });
}
function GenIcon(data2) {
  return function(props) {
    return React__default.createElement(IconBase$1, __assign({
      attr: __assign({}, data2.attr)
    }, props), Tree2Element(data2.child));
  };
}
function IconBase$1(props) {
  var elem = function(conf) {
    var attr = props.attr, size2 = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React__default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
function VscGripper(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 16 16", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M5 3h2v2H5zm0 4h2v2H5zm0 4h2v2H5zm4-8h2v2H9zm0 4h2v2H9zm0 4h2v2H9z" } }] })(props);
}
const space_separator = "_space_separator_13s2v_2";
const item = "_item_13s2v_9";
const styles$M = {
  space_separator,
  item
};
const defaultProps$2 = {
  separator: "dot",
  inline: true,
  wrap: true,
  ellipsis: true
};
const SpaceSeparator = (propsRaw) => {
  const props = usePropsWithDefault(propsRaw, defaultProps$2);
  const children2 = useMemo$2(() => {
    return React__default.Children.toArray(props.children).filter((x) => !!x);
  }, [props.children]);
  if (children2.length == 0) return /* @__PURE__ */ jsx$1(Fragment, { children: props.placeholder ?? null });
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$M.space_separator, props.className), "data-wrap": props.wrap, "data-inline": props.inline, "data-separator": props.separator, "data-ellipsis": props.ellipsis, children: children2.map((x, i) => /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$M.item, props.itemClassName), children: x }, i)) });
};
const FileListItem = ({ file, ...props }) => {
  const uploaderHandler = useRef(void 0);
  const [progress, setProgress] = useState$1(0);
  const [uploadStatus, setUploadStatus] = useState$1(file?.nativeFile != null ? FileUploadStatus.Uploading : FileUploadStatus.Uploaded);
  const retryUpload = useCallback(() => {
    setProgress(0);
    setUploadStatus(FileUploadStatus.Uploading);
  }, []);
  const handleFileReadyToUpload = useCallback(async () => {
    const res = await props.beforeUpload?.(file);
    if (res !== void 0 && res === false) return;
    await uploaderHandler.current?.upload();
  }, []);
  const fileSize = useMemo$2(() => props.size == "lg" || props.size == "xl" ? "large" : props.size == "md" ? "middle" : "small", [props.size]);
  const fileContent = useMemo$2(() => /* @__PURE__ */ jsx$1(
    "div",
    {
      className: combineClasses(styles$N.fl_list_item, "flex align-center flex-1 mb-5 mt-5"),
      "data-draggable": props.draggable,
      "data-size": props.size,
      children: /* @__PURE__ */ jsxs("div", { className: "flex flex-center flex-1 w-100", children: [
        /* @__PURE__ */ jsx$1(
          FilePreview,
          {
            view: "list",
            file,
            fileProvider: props.fileProvider,
            loc: props.loc,
            size: props.size,
            progress,
            uploadStatus,
            onPreview: () => props.onPreview(file),
            onRetryUpload: () => retryUpload(),
            fileIconColor: props.fileIconColor,
            className: styles$N.fl_list_item__preview
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 flex align-center ellipsis", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex-1 flex flex-col justify-center ml-10 ellipsis", children: [
            /* @__PURE__ */ jsx$1(FileName, { file, editable: props.editable, useExtension: true, onRename: async (name) => await props.onChange?.(file, { name }) ?? true, loc: props.loc, className: styles$N.fl_list_item__name }),
            /* @__PURE__ */ jsx$1("div", { className: "fs-12", children: uploadStatus == FileUploadStatus.Error ? /* @__PURE__ */ jsx$1("span", { className: "fs-12 color-danger", children: props.loc.word("File.uploadFailedLabel", { default: "Upload failed" }) }) : /* @__PURE__ */ jsxs(SpaceSeparator, { separator: "dot", wrap: false, children: [
              props.dateCreatedVisible == true && /* @__PURE__ */ jsx$1(DateTime, { date: file.createdDate, format: "LLL", className: "color-secondary" }),
              /* @__PURE__ */ jsx$1("span", { className: "color-secondary", children: Humanize.fileSize(file.size) }),
              props.descriptionVisible == true && uploadStatus == FileUploadStatus.Uploaded && /* @__PURE__ */ jsx$1(
                FileDescriptionPopover,
                {
                  loc: props.loc,
                  file,
                  onSave: async (description) => await props.onChange?.(file, { description }) ?? true,
                  children: /* @__PURE__ */ jsx$1(InfoCircleOutlined, { className: combineClasses("ml-5", !isEmpty(file.description) ? "color-success" : void 0) })
                }
              )
            ] }) })
          ] }),
          /* @__PURE__ */ jsx$1("div", { className: "ml-10", children: /* @__PURE__ */ jsx$1(
            FileActions,
            {
              file,
              theme: "dark",
              size: fileSize,
              deletable: props.deletable,
              downloadable: props.downloadable,
              replaceable: props.replaceable,
              uploadStatus,
              loc: props.loc,
              onDownload: () => props.onDownload?.(file),
              onRemove: () => props.onRemove?.(file),
              onReplace: () => props.onReplace?.(file),
              onUpload: () => retryUpload(),
              onAbort: () => uploaderHandler.current?.abort()
            }
          ) })
        ] })
      ] })
    }
  ), [file, props]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    props.draggable ? /* @__PURE__ */ jsx$1(Draggable$1, { draggableId: file.key, index: props.index, children: (provided, snap) => /* @__PURE__ */ jsxs(
      "div",
      {
        ref: provided.innerRef,
        ...provided.draggableProps,
        style: provided.draggableProps.style,
        className: combineClasses("flex align-center", snap.isDragging ? "shadow-sm" : void 0),
        children: [
          props.draggable == true && /* @__PURE__ */ jsx$1("div", { ...provided.dragHandleProps, className: combineClasses(styles$N.fl_drag_handle, "flex fs-18"), children: /* @__PURE__ */ jsx$1(VscGripper, {}) }),
          fileContent
        ]
      }
    ) }) : fileContent,
    uploadStatus == FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(
      FileUploader$1,
      {
        handler: (x) => uploaderHandler.current = x,
        autostart: false,
        file,
        onReady: handleFileReadyToUpload,
        onProgress: (x) => setProgress(x.percent),
        onComplete: async ({ file: file2 }) => {
          file2.update(file2);
          setUploadStatus(FileUploadStatus.Uploaded);
          props.onUploaded?.(file2);
        },
        uploadArgs: props.uploadArgs,
        onAbort: () => {
          if (file.nativeFile) {
            setUploadStatus(FileUploadStatus.Error);
            props.onAborted?.(file);
          }
        },
        onError: (a) => {
          setUploadStatus(FileUploadStatus.Error);
          notification.error({ message: props.loc.word("Error occured"), duration: 2 });
        }
      }
    )
  ] });
};
const FileListItem$1 = observer(FileListItem);
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$6(target, key, result);
  return result;
};
class FileStore {
  constructor(api2) {
    this.api = api2;
    this.removing = false;
    this.api = api2 || inject(this, Api);
  }
  async save(file) {
    return await this.api.save(file);
  }
  async remove(fileId) {
    this.removing = true;
    const result = await this.api.remove(fileId);
    runInAction(() => {
      this.removing = false;
    });
    return result;
  }
  async download(file) {
    if (file.isExternalFile) {
      saveAs(file.url, true, file.filename);
      return true;
    }
    const result = await this.api.download(file.id);
    if (result.success) {
      saveAs(result.body, false, file.filename);
    }
    return result.success;
  }
  async preview(file) {
    const result = await this.api.download(file.id, true);
    if (result.success) {
      saveAs(result.body, true, file.filename);
    }
    return result.success;
  }
}
__decorateClass$6([
  action
], FileStore.prototype, "save", 1);
__decorateClass$6([
  observable
], FileStore.prototype, "removing", 2);
__decorateClass$6([
  action
], FileStore.prototype, "remove", 1);
__decorateClass$6([
  action
], FileStore.prototype, "download", 1);
__decorateClass$6([
  action
], FileStore.prototype, "preview", 1);
const defaultProps$1 = {
  uploadArgs: {},
  files: [],
  downloadable: true,
  editable: true,
  draggable: false,
  view: "list",
  size: "md",
  removeFromServer: true,
  replacable: false,
  deletable: true,
  descriptionVisible: false,
  dateCreatedVisible: false
};
const Files = (propsRaw) => {
  const props = usePropsWithDefault(propsRaw, defaultProps$1);
  const ctx = useContext(Context$3);
  const [store2] = useState$1(new FileStore(ctx.api.file));
  const fileReplaceInput = useRef(null);
  const [fileToReplace, setFileToReplace] = useState$1(null);
  const previewModal = useDrawer$1();
  const remove = useCallback(async (file) => {
    if (props.beforeRemove != null) {
      if (await props.beforeRemove(file) == false)
        return;
    }
    if (props.removeFromServer == true) {
      const res = await store2.remove(file.id);
      if (res.success) props.onRemoved?.(file);
    } else {
      props.onRemoved?.(file);
    }
  }, []);
  const save = useCallback(async (file, changes) => {
    const res = await store2.save({ ...changes, id: file.id });
    file.update(changes);
    return res.success;
  }, []);
  const replaceFile = useCallback((nativeFile) => {
    if (!fileToReplace) return;
    const file = AccelFile.fromFile(nativeFile);
    if (file.extension != fileToReplace.extension) {
      setFileToReplace(null);
      notification.error({
        message: ctx.loc.word("ErrorFileReplaceExtensionError", { default: "The file extensions to replace must match the extension of the original file" }),
        duration: 3
      });
      return;
    }
    fileToReplace.replaceFile(nativeFile);
    setFileToReplace(null);
  }, [fileToReplace]);
  const previewFile = useCallback((file) => {
    if (file.isImage) {
      previewModal.open(file);
      return;
    }
    store2.preview(file);
  }, []);
  const downloadFile = useCallback(async (file) => {
    await store2.download(file);
    props.onDownload?.(file);
  }, []);
  const fileProps = useMemo$2(() => ({
    fileProvider: ctx.fileProvider,
    loc: ctx.loc,
    editable: props.editable ?? true,
    downloadable: props.downloadable ?? true,
    uploadArgs: props.uploadArgs ?? {},
    size: props.size,
    deletable: props.deletable ?? true,
    replaceable: props.replacable ?? false,
    dateCreatedVisible: props.dateCreatedVisible ?? false,
    descriptionVisible: props.descriptionVisible ?? false,
    draggable: props.draggable ?? false,
    fileIconColor: props.fileIconColor ?? "#ffffff",
    onRemove: (file) => remove(file),
    onAborted: props.onAborted,
    onUploaded: props.onUploaded,
    onChange: (file, changes) => save(file, changes),
    beforeUpload: props.beforeUpload,
    onDownload: (file) => downloadFile(file),
    onReplace: (file) => {
      setFileToReplace(file);
      setTimeout(() => {
        fileReplaceInput.current?.click();
      }, 50);
    },
    onPreview: (file) => previewFile(file)
  }), [props]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1("div", { className: styles$T.fl, "data-view": props.view, children: props.view == "grid" ? props.files.map((x, i) => /* @__PURE__ */ jsx$1(
      FileGridItem$1,
      {
        file: x,
        index: i,
        ...fileProps
      },
      x.key
    )) : /* @__PURE__ */ jsx$1(Fragment, { children: props.draggable ? /* @__PURE__ */ jsx$1(
      DragDropContext$1,
      {
        onDragEnd: (result) => {
          if (!result.destination) return;
          props.onDrop?.(result.source.index, result.destination.index);
        },
        children: /* @__PURE__ */ jsx$1(Droppable, { droppableId: "fl_droppable", isDropDisabled: !props.draggable, children: (provided) => /* @__PURE__ */ jsxs("div", { ref: provided.innerRef, ...provided.droppableProps, children: [
          props.files.map((x, i) => /* @__PURE__ */ jsx$1(
            FileListItem$1,
            {
              file: x,
              index: i,
              ...fileProps
            },
            x.key
          )),
          provided.placeholder
        ] }) })
      }
    ) : props.files.map((x, i) => /* @__PURE__ */ jsx$1(
      FileListItem$1,
      {
        file: x,
        index: i,
        ...fileProps
      },
      x.key
    )) }) }),
    props.replacable && /* @__PURE__ */ jsx$1(
      "input",
      {
        ref: fileReplaceInput,
        type: "file",
        accept: fileToReplace?.extension ?? props.acceptFiles,
        className: "d-none",
        onChange: (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!e.target.files || e.target.files.length == 0) return;
          replaceFile(e.target.files[0]);
        }
      }
    ),
    previewModal.visible && /* @__PURE__ */ jsx$1(
      Modal,
      {
        className: styles$T.fl_preview_modal,
        open: previewModal.visible,
        width: 800,
        onOk: () => previewModal.close(),
        onCancel: () => previewModal.close(),
        footer: null,
        children: /* @__PURE__ */ jsx$1("img", { className: "w-100", src: ctx.fileProvider.getUrl(previewModal.data) ?? void 0 })
      }
    )
  ] });
};
const Files$1 = observer(Files);
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module2) {
    (function() {
      var hasOwn2 = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn2.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module2.exports) {
        classNames2.default = classNames2;
        module2.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var lib;
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  lib = (function(e) {
    var t = {};
    function r2(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = { i: n, l: false, exports: {} };
      return e[n].call(a.exports, a, a.exports, r2), a.l = true, a.exports;
    }
    return r2.m = e, r2.c = t, r2.d = function(e2, t2, n) {
      r2.o(e2, t2) || Object.defineProperty(e2, t2, { enumerable: true, get: n });
    }, r2.r = function(e2) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
    }, r2.t = function(e2, t2) {
      if (1 & t2 && (e2 = r2(e2)), 8 & t2) return e2;
      if (4 & t2 && "object" == typeof e2 && e2 && e2.__esModule) return e2;
      var n = /* @__PURE__ */ Object.create(null);
      if (r2.r(n), Object.defineProperty(n, "default", { enumerable: true, value: e2 }), 2 & t2 && "string" != typeof e2) for (var a in e2) r2.d(n, a, function(t3) {
        return e2[t3];
      }.bind(null, a));
      return n;
    }, r2.n = function(e2) {
      var t2 = e2 && e2.__esModule ? function() {
        return e2.default;
      } : function() {
        return e2;
      };
      return r2.d(t2, "a", t2), t2;
    }, r2.o = function(e2, t2) {
      return Object.prototype.hasOwnProperty.call(e2, t2);
    }, r2.p = "", r2(r2.s = 9);
  })([function(e, t) {
    e.exports = React__default;
  }, function(e, t, r2) {
    var n;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */
    !(function() {
      var r3 = {}.hasOwnProperty;
      function a() {
        for (var e2 = [], t2 = 0; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          if (n2) {
            var o = typeof n2;
            if ("string" === o || "number" === o) e2.push(n2);
            else if (Array.isArray(n2) && n2.length) {
              var i = a.apply(null, n2);
              i && e2.push(i);
            } else if ("object" === o) for (var u in n2) r3.call(n2, u) && n2[u] && e2.push(u);
          }
        }
        return e2.join(" ");
      }
      e.exports ? (a.default = a, e.exports = a) : void 0 === (n = function() {
        return a;
      }.apply(t, [])) || (e.exports = n);
    })();
  }, function(e, t, r2) {
    (function(t2) {
      var r3 = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t2 && t2 && t2.Object === Object && t2, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = s.Symbol, d = f ? f.prototype : void 0, p = d ? d.toString : void 0;
      function h(e2) {
        if ("string" == typeof e2) return e2;
        if (y(e2)) return p ? p.call(e2) : "";
        var t3 = e2 + "";
        return "0" == t3 && 1 / e2 == -1 / 0 ? "-0" : t3;
      }
      function m(e2) {
        var t3 = typeof e2;
        return !!e2 && ("object" == t3 || "function" == t3);
      }
      function y(e2) {
        return "symbol" == typeof e2 || /* @__PURE__ */ (function(e3) {
          return !!e3 && "object" == typeof e3;
        })(e2) && "[object Symbol]" == l.call(e2);
      }
      function b(e2) {
        return e2 ? (e2 = (function(e3) {
          if ("number" == typeof e3) return e3;
          if (y(e3)) return NaN;
          if (m(e3)) {
            var t3 = "function" == typeof e3.valueOf ? e3.valueOf() : e3;
            e3 = m(t3) ? t3 + "" : t3;
          }
          if ("string" != typeof e3) return 0 === e3 ? e3 : +e3;
          e3 = e3.replace(r3, "");
          var u2 = a.test(e3);
          return u2 || o.test(e3) ? i(e3.slice(2), u2 ? 2 : 8) : n.test(e3) ? NaN : +e3;
        })(e2)) === 1 / 0 || e2 === -1 / 0 ? 17976931348623157e292 * (e2 < 0 ? -1 : 1) : e2 == e2 ? e2 : 0 : 0 === e2 ? e2 : 0;
      }
      e.exports = function(e2, t3, r4) {
        var n2, a2, o2, i2;
        return e2 = null == (n2 = e2) ? "" : h(n2), a2 = (function(e3) {
          var t4 = b(e3), r5 = t4 % 1;
          return t4 == t4 ? r5 ? t4 - r5 : t4 : 0;
        })(r4), o2 = 0, i2 = e2.length, a2 == a2 && (void 0 !== i2 && (a2 = a2 <= i2 ? a2 : i2), void 0 !== o2 && (a2 = a2 >= o2 ? a2 : o2)), r4 = a2, t3 = h(t3), e2.slice(r4, r4 + t3.length) == t3;
      };
    }).call(this, r2(3));
  }, function(e, t) {
    var r2;
    r2 = /* @__PURE__ */ (function() {
      return this;
    })();
    try {
      r2 = r2 || new Function("return this")();
    } catch (e2) {
      "object" == typeof window && (r2 = window);
    }
    e.exports = r2;
  }, function(e, t, r2) {
    (function(t2) {
      var r3 = /^\[object .+?Constructor\]$/, n = "object" == typeof t2 && t2 && t2.Object === Object && t2, a = "object" == typeof self && self && self.Object === Object && self, o = n || a || Function("return this")();
      var i, u = Array.prototype, c = Function.prototype, s = Object.prototype, l = o["__core-js_shared__"], f = (i = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "", d = c.toString, p = s.hasOwnProperty, h = s.toString, m = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), y = u.splice, b = x(o, "Map"), g = x(Object, "create");
      function v(e2) {
        var t3 = -1, r4 = e2 ? e2.length : 0;
        for (this.clear(); ++t3 < r4; ) {
          var n2 = e2[t3];
          this.set(n2[0], n2[1]);
        }
      }
      function C(e2) {
        var t3 = -1, r4 = e2 ? e2.length : 0;
        for (this.clear(); ++t3 < r4; ) {
          var n2 = e2[t3];
          this.set(n2[0], n2[1]);
        }
      }
      function _2(e2) {
        var t3 = -1, r4 = e2 ? e2.length : 0;
        for (this.clear(); ++t3 < r4; ) {
          var n2 = e2[t3];
          this.set(n2[0], n2[1]);
        }
      }
      function w(e2, t3) {
        for (var r4, n2, a2 = e2.length; a2--; ) if ((r4 = e2[a2][0]) === (n2 = t3) || r4 != r4 && n2 != n2) return a2;
        return -1;
      }
      function S(e2) {
        return !(!O(e2) || (t3 = e2, f && f in t3)) && ((function(e3) {
          var t4 = O(e3) ? h.call(e3) : "";
          return "[object Function]" == t4 || "[object GeneratorFunction]" == t4;
        })(e2) || (function(e3) {
          var t4 = false;
          if (null != e3 && "function" != typeof e3.toString) try {
            t4 = !!(e3 + "");
          } catch (e4) {
          }
          return t4;
        })(e2) ? m : r3).test((function(e3) {
          if (null != e3) {
            try {
              return d.call(e3);
            } catch (e4) {
            }
            try {
              return e3 + "";
            } catch (e4) {
            }
          }
          return "";
        })(e2));
        var t3;
      }
      function j(e2, t3) {
        var r4, n2, a2 = e2.__data__;
        return ("string" == (n2 = typeof (r4 = t3)) || "number" == n2 || "symbol" == n2 || "boolean" == n2 ? "__proto__" !== r4 : null === r4) ? a2["string" == typeof t3 ? "string" : "hash"] : a2.map;
      }
      function x(e2, t3) {
        var r4 = (function(e3, t4) {
          return null == e3 ? void 0 : e3[t4];
        })(e2, t3);
        return S(r4) ? r4 : void 0;
      }
      function N(e2, t3) {
        if ("function" != typeof e2 || t3 && "function" != typeof t3) throw new TypeError("Expected a function");
        var r4 = function() {
          var n2 = arguments, a2 = t3 ? t3.apply(this, n2) : n2[0], o2 = r4.cache;
          if (o2.has(a2)) return o2.get(a2);
          var i2 = e2.apply(this, n2);
          return r4.cache = o2.set(a2, i2), i2;
        };
        return r4.cache = new (N.Cache || _2)(), r4;
      }
      function O(e2) {
        var t3 = typeof e2;
        return !!e2 && ("object" == t3 || "function" == t3);
      }
      v.prototype.clear = function() {
        this.__data__ = g ? g(null) : {};
      }, v.prototype.delete = function(e2) {
        return this.has(e2) && delete this.__data__[e2];
      }, v.prototype.get = function(e2) {
        var t3 = this.__data__;
        if (g) {
          var r4 = t3[e2];
          return "__lodash_hash_undefined__" === r4 ? void 0 : r4;
        }
        return p.call(t3, e2) ? t3[e2] : void 0;
      }, v.prototype.has = function(e2) {
        var t3 = this.__data__;
        return g ? void 0 !== t3[e2] : p.call(t3, e2);
      }, v.prototype.set = function(e2, t3) {
        return this.__data__[e2] = g && void 0 === t3 ? "__lodash_hash_undefined__" : t3, this;
      }, C.prototype.clear = function() {
        this.__data__ = [];
      }, C.prototype.delete = function(e2) {
        var t3 = this.__data__, r4 = w(t3, e2);
        return !(r4 < 0) && (r4 == t3.length - 1 ? t3.pop() : y.call(t3, r4, 1), true);
      }, C.prototype.get = function(e2) {
        var t3 = this.__data__, r4 = w(t3, e2);
        return r4 < 0 ? void 0 : t3[r4][1];
      }, C.prototype.has = function(e2) {
        return w(this.__data__, e2) > -1;
      }, C.prototype.set = function(e2, t3) {
        var r4 = this.__data__, n2 = w(r4, e2);
        return n2 < 0 ? r4.push([e2, t3]) : r4[n2][1] = t3, this;
      }, _2.prototype.clear = function() {
        this.__data__ = { hash: new v(), map: new (b || C)(), string: new v() };
      }, _2.prototype.delete = function(e2) {
        return j(this, e2).delete(e2);
      }, _2.prototype.get = function(e2) {
        return j(this, e2).get(e2);
      }, _2.prototype.has = function(e2) {
        return j(this, e2).has(e2);
      }, _2.prototype.set = function(e2, t3) {
        return j(this, e2).set(e2, t3), this;
      }, N.Cache = _2, e.exports = N;
    }).call(this, r2(3));
  }, function(e, t, r2) {
    (function(t2) {
      var r3 = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t2 && t2 && t2.Object === Object && t2, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = Math.max, d = Math.min, p = function() {
        return s.Date.now();
      };
      function h(e2) {
        var t3 = typeof e2;
        return !!e2 && ("object" == t3 || "function" == t3);
      }
      function m(e2) {
        if ("number" == typeof e2) return e2;
        if ((function(e3) {
          return "symbol" == typeof e3 || /* @__PURE__ */ (function(e4) {
            return !!e4 && "object" == typeof e4;
          })(e3) && "[object Symbol]" == l.call(e3);
        })(e2)) return NaN;
        if (h(e2)) {
          var t3 = "function" == typeof e2.valueOf ? e2.valueOf() : e2;
          e2 = h(t3) ? t3 + "" : t3;
        }
        if ("string" != typeof e2) return 0 === e2 ? e2 : +e2;
        e2 = e2.replace(r3, "");
        var u2 = a.test(e2);
        return u2 || o.test(e2) ? i(e2.slice(2), u2 ? 2 : 8) : n.test(e2) ? NaN : +e2;
      }
      e.exports = function(e2, t3, r4) {
        var n2, a2, o2, i2, u2, c2, s2 = 0, l2 = false, y = false, b = true;
        if ("function" != typeof e2) throw new TypeError("Expected a function");
        function g(t4) {
          var r5 = n2, o3 = a2;
          return n2 = a2 = void 0, s2 = t4, i2 = e2.apply(o3, r5);
        }
        function v(e3) {
          return s2 = e3, u2 = setTimeout(_2, t3), l2 ? g(e3) : i2;
        }
        function C(e3) {
          var r5 = e3 - c2;
          return void 0 === c2 || r5 >= t3 || r5 < 0 || y && e3 - s2 >= o2;
        }
        function _2() {
          var e3 = p();
          if (C(e3)) return w(e3);
          u2 = setTimeout(_2, (function(e4) {
            var r5 = t3 - (e4 - c2);
            return y ? d(r5, o2 - (e4 - s2)) : r5;
          })(e3));
        }
        function w(e3) {
          return u2 = void 0, b && n2 ? g(e3) : (n2 = a2 = void 0, i2);
        }
        function S() {
          var e3 = p(), r5 = C(e3);
          if (n2 = arguments, a2 = this, c2 = e3, r5) {
            if (void 0 === u2) return v(c2);
            if (y) return u2 = setTimeout(_2, t3), g(c2);
          }
          return void 0 === u2 && (u2 = setTimeout(_2, t3)), i2;
        }
        return t3 = m(t3) || 0, h(r4) && (l2 = !!r4.leading, o2 = (y = "maxWait" in r4) ? f(m(r4.maxWait) || 0, t3) : o2, b = "trailing" in r4 ? !!r4.trailing : b), S.cancel = function() {
          void 0 !== u2 && clearTimeout(u2), s2 = 0, n2 = c2 = a2 = u2 = void 0;
        }, S.flush = function() {
          return void 0 === u2 ? i2 : w(p());
        }, S;
      };
    }).call(this, r2(3));
  }, function(e, t, r2) {
    (function(e2, r3) {
      var n = "[object Arguments]", a = "[object Map]", o = "[object Object]", i = "[object Set]", u = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/, s = /^\./, l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, f = /\\(\\)?/g, d = /^\[object .+?Constructor\]$/, p = /^(?:0|[1-9]\d*)$/, h = {};
      h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = true, h[n] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h[a] = h["[object Number]"] = h[o] = h["[object RegExp]"] = h[i] = h["[object String]"] = h["[object WeakMap]"] = false;
      var m = "object" == typeof e2 && e2 && e2.Object === Object && e2, y = "object" == typeof self && self && self.Object === Object && self, b = m || y || Function("return this")(), g = t && !t.nodeType && t, v = g && "object" == typeof r3 && r3 && !r3.nodeType && r3, C = v && v.exports === g && m.process, _2 = (function() {
        try {
          return C && C.binding("util");
        } catch (e3) {
        }
      })(), w = _2 && _2.isTypedArray;
      function S(e3, t2, r4, n2) {
        var a2 = -1, o2 = e3 ? e3.length : 0;
        for (n2 && o2 && (r4 = e3[++a2]); ++a2 < o2; ) r4 = t2(r4, e3[a2], a2, e3);
        return r4;
      }
      function j(e3, t2) {
        for (var r4 = -1, n2 = e3 ? e3.length : 0; ++r4 < n2; ) if (t2(e3[r4], r4, e3)) return true;
        return false;
      }
      function x(e3, t2, r4, n2, a2) {
        return a2(e3, (function(e4, a3, o2) {
          r4 = n2 ? (n2 = false, e4) : t2(r4, e4, a3, o2);
        })), r4;
      }
      function N(e3) {
        var t2 = false;
        if (null != e3 && "function" != typeof e3.toString) try {
          t2 = !!(e3 + "");
        } catch (e4) {
        }
        return t2;
      }
      function O(e3) {
        var t2 = -1, r4 = Array(e3.size);
        return e3.forEach((function(e4, n2) {
          r4[++t2] = [n2, e4];
        })), r4;
      }
      function k(e3) {
        var t2 = -1, r4 = Array(e3.size);
        return e3.forEach((function(e4) {
          r4[++t2] = e4;
        })), r4;
      }
      var E, T, I, A = Array.prototype, D = Function.prototype, P = Object.prototype, F = b["__core-js_shared__"], M = (E = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", R = D.toString, L = P.hasOwnProperty, z = P.toString, B = RegExp("^" + R.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), G = b.Symbol, $ = b.Uint8Array, V = P.propertyIsEnumerable, K = A.splice, U = (T = Object.keys, I = Object, function(e3) {
        return T(I(e3));
      }), q = Ne(b, "DataView"), H = Ne(b, "Map"), W = Ne(b, "Promise"), J = Ne(b, "Set"), Z = Ne(b, "WeakMap"), Q = Ne(Object, "create"), Y = Pe(q), X = Pe(H), ee = Pe(W), te = Pe(J), re2 = Pe(Z), ne = G ? G.prototype : void 0, ae = ne ? ne.valueOf : void 0, oe = ne ? ne.toString : void 0;
      function ie(e3) {
        var t2 = -1, r4 = e3 ? e3.length : 0;
        for (this.clear(); ++t2 < r4; ) {
          var n2 = e3[t2];
          this.set(n2[0], n2[1]);
        }
      }
      function ue(e3) {
        var t2 = -1, r4 = e3 ? e3.length : 0;
        for (this.clear(); ++t2 < r4; ) {
          var n2 = e3[t2];
          this.set(n2[0], n2[1]);
        }
      }
      function ce(e3) {
        var t2 = -1, r4 = e3 ? e3.length : 0;
        for (this.clear(); ++t2 < r4; ) {
          var n2 = e3[t2];
          this.set(n2[0], n2[1]);
        }
      }
      function se(e3) {
        var t2 = -1, r4 = e3 ? e3.length : 0;
        for (this.__data__ = new ce(); ++t2 < r4; ) this.add(e3[t2]);
      }
      function le(e3) {
        this.__data__ = new ue(e3);
      }
      function fe(e3, t2) {
        var r4 = Le(e3) || Re(e3) ? (function(e4, t3) {
          for (var r5 = -1, n3 = Array(e4); ++r5 < e4; ) n3[r5] = t3(r5);
          return n3;
        })(e3.length, String) : [], n2 = r4.length, a2 = !!n2;
        for (var o2 in e3) !L.call(e3, o2) || a2 && ("length" == o2 || ke(o2, n2)) || r4.push(o2);
        return r4;
      }
      function de(e3, t2) {
        for (var r4 = e3.length; r4--; ) if (Me(e3[r4][0], t2)) return r4;
        return -1;
      }
      ie.prototype.clear = function() {
        this.__data__ = Q ? Q(null) : {};
      }, ie.prototype.delete = function(e3) {
        return this.has(e3) && delete this.__data__[e3];
      }, ie.prototype.get = function(e3) {
        var t2 = this.__data__;
        if (Q) {
          var r4 = t2[e3];
          return "__lodash_hash_undefined__" === r4 ? void 0 : r4;
        }
        return L.call(t2, e3) ? t2[e3] : void 0;
      }, ie.prototype.has = function(e3) {
        var t2 = this.__data__;
        return Q ? void 0 !== t2[e3] : L.call(t2, e3);
      }, ie.prototype.set = function(e3, t2) {
        return this.__data__[e3] = Q && void 0 === t2 ? "__lodash_hash_undefined__" : t2, this;
      }, ue.prototype.clear = function() {
        this.__data__ = [];
      }, ue.prototype.delete = function(e3) {
        var t2 = this.__data__, r4 = de(t2, e3);
        return !(r4 < 0) && (r4 == t2.length - 1 ? t2.pop() : K.call(t2, r4, 1), true);
      }, ue.prototype.get = function(e3) {
        var t2 = this.__data__, r4 = de(t2, e3);
        return r4 < 0 ? void 0 : t2[r4][1];
      }, ue.prototype.has = function(e3) {
        return de(this.__data__, e3) > -1;
      }, ue.prototype.set = function(e3, t2) {
        var r4 = this.__data__, n2 = de(r4, e3);
        return n2 < 0 ? r4.push([e3, t2]) : r4[n2][1] = t2, this;
      }, ce.prototype.clear = function() {
        this.__data__ = { hash: new ie(), map: new (H || ue)(), string: new ie() };
      }, ce.prototype.delete = function(e3) {
        return xe(this, e3).delete(e3);
      }, ce.prototype.get = function(e3) {
        return xe(this, e3).get(e3);
      }, ce.prototype.has = function(e3) {
        return xe(this, e3).has(e3);
      }, ce.prototype.set = function(e3, t2) {
        return xe(this, e3).set(e3, t2), this;
      }, se.prototype.add = se.prototype.push = function(e3) {
        return this.__data__.set(e3, "__lodash_hash_undefined__"), this;
      }, se.prototype.has = function(e3) {
        return this.__data__.has(e3);
      }, le.prototype.clear = function() {
        this.__data__ = new ue();
      }, le.prototype.delete = function(e3) {
        return this.__data__.delete(e3);
      }, le.prototype.get = function(e3) {
        return this.__data__.get(e3);
      }, le.prototype.has = function(e3) {
        return this.__data__.has(e3);
      }, le.prototype.set = function(e3, t2) {
        var r4 = this.__data__;
        if (r4 instanceof ue) {
          var n2 = r4.__data__;
          if (!H || n2.length < 199) return n2.push([e3, t2]), this;
          r4 = this.__data__ = new ce(n2);
        }
        return r4.set(e3, t2), this;
      };
      var pe, me = (pe = function(e3, t2) {
        return e3 && ye(e3, t2, qe);
      }, function(e3, t2) {
        if (null == e3) return e3;
        if (!ze(e3)) return pe(e3, t2);
        for (var r4 = e3.length, n2 = -1, a2 = Object(e3); ++n2 < r4 && false !== t2(a2[n2], n2, a2); ) ;
        return e3;
      }), ye = /* @__PURE__ */ (function(e3) {
        return function(t2, r4, n2) {
          for (var a2 = -1, o2 = Object(t2), i2 = n2(t2), u2 = i2.length; u2--; ) {
            var c2 = i2[++a2];
            if (false === r4(o2[c2], c2, o2)) break;
          }
          return t2;
        };
      })();
      function be(e3, t2) {
        for (var r4 = 0, n2 = (t2 = Ee(t2, e3) ? [t2] : Se(t2)).length; null != e3 && r4 < n2; ) e3 = e3[De(t2[r4++])];
        return r4 && r4 == n2 ? e3 : void 0;
      }
      function ge(e3, t2) {
        return null != e3 && t2 in Object(e3);
      }
      function ve(e3, t2, r4, u2, c2) {
        return e3 === t2 || (null == e3 || null == t2 || !$e(e3) && !Ve(t2) ? e3 != e3 && t2 != t2 : (function(e4, t3, r5, u3, c3, s2) {
          var l2 = Le(e4), f2 = Le(t3), d2 = "[object Array]", p2 = "[object Array]";
          l2 || (d2 = (d2 = Oe(e4)) == n ? o : d2);
          f2 || (p2 = (p2 = Oe(t3)) == n ? o : p2);
          var h2 = d2 == o && !N(e4), m2 = p2 == o && !N(t3), y2 = d2 == p2;
          if (y2 && !h2) return s2 || (s2 = new le()), l2 || Ue(e4) ? je(e4, t3, r5, u3, c3, s2) : (function(e5, t4, r6, n2, o2, u4, c4) {
            switch (r6) {
              case "[object DataView]":
                if (e5.byteLength != t4.byteLength || e5.byteOffset != t4.byteOffset) return false;
                e5 = e5.buffer, t4 = t4.buffer;
              case "[object ArrayBuffer]":
                return !(e5.byteLength != t4.byteLength || !n2(new $(e5), new $(t4)));
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return Me(+e5, +t4);
              case "[object Error]":
                return e5.name == t4.name && e5.message == t4.message;
              case "[object RegExp]":
              case "[object String]":
                return e5 == t4 + "";
              case a:
                var s3 = O;
              case i:
                var l3 = 2 & u4;
                if (s3 || (s3 = k), e5.size != t4.size && !l3) return false;
                var f3 = c4.get(e5);
                if (f3) return f3 == t4;
                u4 |= 1, c4.set(e5, t4);
                var d3 = je(s3(e5), s3(t4), n2, o2, u4, c4);
                return c4.delete(e5), d3;
              case "[object Symbol]":
                if (ae) return ae.call(e5) == ae.call(t4);
            }
            return false;
          })(e4, t3, d2, r5, u3, c3, s2);
          if (!(2 & c3)) {
            var b2 = h2 && L.call(e4, "__wrapped__"), g2 = m2 && L.call(t3, "__wrapped__");
            if (b2 || g2) {
              var v2 = b2 ? e4.value() : e4, C2 = g2 ? t3.value() : t3;
              return s2 || (s2 = new le()), r5(v2, C2, u3, c3, s2);
            }
          }
          if (!y2) return false;
          return s2 || (s2 = new le()), (function(e5, t4, r6, n2, a2, o2) {
            var i2 = 2 & a2, u4 = qe(e5), c4 = u4.length, s3 = qe(t4).length;
            if (c4 != s3 && !i2) return false;
            var l3 = c4;
            for (; l3--; ) {
              var f3 = u4[l3];
              if (!(i2 ? f3 in t4 : L.call(t4, f3))) return false;
            }
            var d3 = o2.get(e5);
            if (d3 && o2.get(t4)) return d3 == t4;
            var p3 = true;
            o2.set(e5, t4), o2.set(t4, e5);
            var h3 = i2;
            for (; ++l3 < c4; ) {
              f3 = u4[l3];
              var m3 = e5[f3], y3 = t4[f3];
              if (n2) var b3 = i2 ? n2(y3, m3, f3, t4, e5, o2) : n2(m3, y3, f3, e5, t4, o2);
              if (!(void 0 === b3 ? m3 === y3 || r6(m3, y3, n2, a2, o2) : b3)) {
                p3 = false;
                break;
              }
              h3 || (h3 = "constructor" == f3);
            }
            if (p3 && !h3) {
              var g3 = e5.constructor, v3 = t4.constructor;
              g3 == v3 || !("constructor" in e5) || !("constructor" in t4) || "function" == typeof g3 && g3 instanceof g3 && "function" == typeof v3 && v3 instanceof v3 || (p3 = false);
            }
            return o2.delete(e5), o2.delete(t4), p3;
          })(e4, t3, r5, u3, c3, s2);
        })(e3, t2, ve, r4, u2, c2));
      }
      function Ce(e3) {
        return !(!$e(e3) || (function(e4) {
          return !!M && M in e4;
        })(e3)) && (Be(e3) || N(e3) ? B : d).test(Pe(e3));
      }
      function _e(e3) {
        return "function" == typeof e3 ? e3 : null == e3 ? He : "object" == typeof e3 ? Le(e3) ? (function(e4, t3) {
          if (Ee(e4) && Te(t3)) return Ie(De(e4), t3);
          return function(r5) {
            var n2 = (function(e5, t4, r6) {
              var n3 = null == e5 ? void 0 : be(e5, t4);
              return void 0 === n3 ? r6 : n3;
            })(r5, e4);
            return void 0 === n2 && n2 === t3 ? (function(e5, t4) {
              return null != e5 && (function(e6, t5, r6) {
                t5 = Ee(t5, e6) ? [t5] : Se(t5);
                var n3, a2 = -1, o2 = t5.length;
                for (; ++a2 < o2; ) {
                  var i2 = De(t5[a2]);
                  if (!(n3 = null != e6 && r6(e6, i2))) break;
                  e6 = e6[i2];
                }
                if (n3) return n3;
                return !!(o2 = e6 ? e6.length : 0) && Ge(o2) && ke(i2, o2) && (Le(e6) || Re(e6));
              })(e5, t4, ge);
            })(r5, e4) : ve(t3, n2, void 0, 3);
          };
        })(e3[0], e3[1]) : (function(e4) {
          var t3 = (function(e5) {
            var t4 = qe(e5), r5 = t4.length;
            for (; r5--; ) {
              var n2 = t4[r5], a2 = e5[n2];
              t4[r5] = [n2, a2, Te(a2)];
            }
            return t4;
          })(e4);
          if (1 == t3.length && t3[0][2]) return Ie(t3[0][0], t3[0][1]);
          return function(r5) {
            return r5 === e4 || (function(e5, t4, r6, n2) {
              var a2 = r6.length, o2 = a2;
              if (null == e5) return !o2;
              for (e5 = Object(e5); a2--; ) {
                var u2 = r6[a2];
                if (u2[2] ? u2[1] !== e5[u2[0]] : !(u2[0] in e5)) return false;
              }
              for (; ++a2 < o2; ) {
                var c2 = (u2 = r6[a2])[0], s2 = e5[c2], l2 = u2[1];
                if (u2[2]) {
                  if (void 0 === s2 && !(c2 in e5)) return false;
                } else {
                  var f2 = new le();
                  var d2;
                  if (!(void 0 === d2 ? ve(l2, s2, n2, 3, f2) : d2)) return false;
                }
              }
              return true;
            })(r5, e4, t3);
          };
        })(e3) : Ee(t2 = e3) ? (r4 = De(t2), function(e4) {
          return null == e4 ? void 0 : e4[r4];
        }) : /* @__PURE__ */ (function(e4) {
          return function(t3) {
            return be(t3, e4);
          };
        })(t2);
        var t2, r4;
      }
      function we(e3) {
        if (r4 = (t2 = e3) && t2.constructor, n2 = "function" == typeof r4 && r4.prototype || P, t2 !== n2) return U(e3);
        var t2, r4, n2, a2 = [];
        for (var o2 in Object(e3)) L.call(e3, o2) && "constructor" != o2 && a2.push(o2);
        return a2;
      }
      function Se(e3) {
        return Le(e3) ? e3 : Ae(e3);
      }
      function je(e3, t2, r4, n2, a2, o2) {
        var i2 = 2 & a2, u2 = e3.length, c2 = t2.length;
        if (u2 != c2 && !(i2 && c2 > u2)) return false;
        var s2 = o2.get(e3);
        if (s2 && o2.get(t2)) return s2 == t2;
        var l2 = -1, f2 = true, d2 = 1 & a2 ? new se() : void 0;
        for (o2.set(e3, t2), o2.set(t2, e3); ++l2 < u2; ) {
          var p2 = e3[l2], h2 = t2[l2];
          if (n2) var m2 = i2 ? n2(h2, p2, l2, t2, e3, o2) : n2(p2, h2, l2, e3, t2, o2);
          if (void 0 !== m2) {
            if (m2) continue;
            f2 = false;
            break;
          }
          if (d2) {
            if (!j(t2, (function(e4, t3) {
              if (!d2.has(t3) && (p2 === e4 || r4(p2, e4, n2, a2, o2))) return d2.add(t3);
            }))) {
              f2 = false;
              break;
            }
          } else if (p2 !== h2 && !r4(p2, h2, n2, a2, o2)) {
            f2 = false;
            break;
          }
        }
        return o2.delete(e3), o2.delete(t2), f2;
      }
      function xe(e3, t2) {
        var r4, n2, a2 = e3.__data__;
        return ("string" == (n2 = typeof (r4 = t2)) || "number" == n2 || "symbol" == n2 || "boolean" == n2 ? "__proto__" !== r4 : null === r4) ? a2["string" == typeof t2 ? "string" : "hash"] : a2.map;
      }
      function Ne(e3, t2) {
        var r4 = (function(e4, t3) {
          return null == e4 ? void 0 : e4[t3];
        })(e3, t2);
        return Ce(r4) ? r4 : void 0;
      }
      var Oe = function(e3) {
        return z.call(e3);
      };
      function ke(e3, t2) {
        return !!(t2 = null == t2 ? 9007199254740991 : t2) && ("number" == typeof e3 || p.test(e3)) && e3 > -1 && e3 % 1 == 0 && e3 < t2;
      }
      function Ee(e3, t2) {
        if (Le(e3)) return false;
        var r4 = typeof e3;
        return !("number" != r4 && "symbol" != r4 && "boolean" != r4 && null != e3 && !Ke(e3)) || (c.test(e3) || !u.test(e3) || null != t2 && e3 in Object(t2));
      }
      function Te(e3) {
        return e3 == e3 && !$e(e3);
      }
      function Ie(e3, t2) {
        return function(r4) {
          return null != r4 && (r4[e3] === t2 && (void 0 !== t2 || e3 in Object(r4)));
        };
      }
      (q && "[object DataView]" != Oe(new q(new ArrayBuffer(1))) || H && Oe(new H()) != a || W && "[object Promise]" != Oe(W.resolve()) || J && Oe(new J()) != i || Z && "[object WeakMap]" != Oe(new Z())) && (Oe = function(e3) {
        var t2 = z.call(e3), r4 = t2 == o ? e3.constructor : void 0, n2 = r4 ? Pe(r4) : void 0;
        if (n2) switch (n2) {
          case Y:
            return "[object DataView]";
          case X:
            return a;
          case ee:
            return "[object Promise]";
          case te:
            return i;
          case re2:
            return "[object WeakMap]";
        }
        return t2;
      });
      var Ae = Fe((function(e3) {
        var t2;
        e3 = null == (t2 = e3) ? "" : (function(e4) {
          if ("string" == typeof e4) return e4;
          if (Ke(e4)) return oe ? oe.call(e4) : "";
          var t3 = e4 + "";
          return "0" == t3 && 1 / e4 == -1 / 0 ? "-0" : t3;
        })(t2);
        var r4 = [];
        return s.test(e3) && r4.push(""), e3.replace(l, (function(e4, t3, n2, a2) {
          r4.push(n2 ? a2.replace(f, "$1") : t3 || e4);
        })), r4;
      }));
      function De(e3) {
        if ("string" == typeof e3 || Ke(e3)) return e3;
        var t2 = e3 + "";
        return "0" == t2 && 1 / e3 == -1 / 0 ? "-0" : t2;
      }
      function Pe(e3) {
        if (null != e3) {
          try {
            return R.call(e3);
          } catch (e4) {
          }
          try {
            return e3 + "";
          } catch (e4) {
          }
        }
        return "";
      }
      function Fe(e3, t2) {
        if ("function" != typeof e3 || t2 && "function" != typeof t2) throw new TypeError("Expected a function");
        var r4 = function() {
          var n2 = arguments, a2 = t2 ? t2.apply(this, n2) : n2[0], o2 = r4.cache;
          if (o2.has(a2)) return o2.get(a2);
          var i2 = e3.apply(this, n2);
          return r4.cache = o2.set(a2, i2), i2;
        };
        return r4.cache = new (Fe.Cache || ce)(), r4;
      }
      function Me(e3, t2) {
        return e3 === t2 || e3 != e3 && t2 != t2;
      }
      function Re(e3) {
        return (function(e4) {
          return Ve(e4) && ze(e4);
        })(e3) && L.call(e3, "callee") && (!V.call(e3, "callee") || z.call(e3) == n);
      }
      Fe.Cache = ce;
      var Le = Array.isArray;
      function ze(e3) {
        return null != e3 && Ge(e3.length) && !Be(e3);
      }
      function Be(e3) {
        var t2 = $e(e3) ? z.call(e3) : "";
        return "[object Function]" == t2 || "[object GeneratorFunction]" == t2;
      }
      function Ge(e3) {
        return "number" == typeof e3 && e3 > -1 && e3 % 1 == 0 && e3 <= 9007199254740991;
      }
      function $e(e3) {
        var t2 = typeof e3;
        return !!e3 && ("object" == t2 || "function" == t2);
      }
      function Ve(e3) {
        return !!e3 && "object" == typeof e3;
      }
      function Ke(e3) {
        return "symbol" == typeof e3 || Ve(e3) && "[object Symbol]" == z.call(e3);
      }
      var Ue = w ? /* @__PURE__ */ (function(e3) {
        return function(t2) {
          return e3(t2);
        };
      })(w) : function(e3) {
        return Ve(e3) && Ge(e3.length) && !!h[z.call(e3)];
      };
      function qe(e3) {
        return ze(e3) ? fe(e3) : we(e3);
      }
      function He(e3) {
        return e3;
      }
      r3.exports = function(e3, t2, r4) {
        var n2 = Le(e3) ? S : x, a2 = arguments.length < 3;
        return n2(e3, _e(t2), r4, a2, me);
      };
    }).call(this, r2(3), r2(7)(e));
  }, function(e, t) {
    e.exports = function(e2) {
      return e2.webpackPolyfill || (e2.deprecate = function() {
      }, e2.paths = [], e2.children || (e2.children = []), Object.defineProperty(e2, "loaded", { enumerable: true, get: function() {
        return e2.l;
      } }), Object.defineProperty(e2, "id", { enumerable: true, get: function() {
        return e2.i;
      } }), e2.webpackPolyfill = 1), e2;
    };
  }, function(e, t) {
    String.prototype.padEnd || (String.prototype.padEnd = function(e2, t2) {
      return e2 >>= 0, t2 = String(void 0 !== t2 ? t2 : " "), this.length > e2 ? String(this) : ((e2 -= this.length) > t2.length && (t2 += t2.repeat(e2 / t2.length)), String(this) + t2.slice(0, e2));
    });
  }, function(e, t, r2) {
    function n(e2, t2, r3) {
      return t2 in e2 ? Object.defineProperty(e2, t2, { value: r3, enumerable: true, configurable: true, writable: true }) : e2[t2] = r3, e2;
    }
    function a(e2) {
      if (Symbol.iterator in Object(e2) || "[object Arguments]" === Object.prototype.toString.call(e2)) return Array.from(e2);
    }
    function o(e2) {
      return (function(e3) {
        if (Array.isArray(e3)) {
          for (var t2 = 0, r3 = new Array(e3.length); t2 < e3.length; t2++) r3[t2] = e3[t2];
          return r3;
        }
      })(e2) || a(e2) || (function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      })();
    }
    function i(e2) {
      if (Array.isArray(e2)) return e2;
    }
    function u() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    function c(e2, t2) {
      if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
    }
    function s(e2, t2) {
      for (var r3 = 0; r3 < t2.length; r3++) {
        var n2 = t2[r3];
        n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
      }
    }
    function l(e2) {
      return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
        return typeof e3;
      } : function(e3) {
        return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
      })(e2);
    }
    function f(e2) {
      return (f = "function" == typeof Symbol && "symbol" === l(Symbol.iterator) ? function(e3) {
        return l(e3);
      } : function(e3) {
        return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : l(e3);
      })(e2);
    }
    function d(e2) {
      if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e2;
    }
    function p(e2) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
        return e3.__proto__ || Object.getPrototypeOf(e3);
      })(e2);
    }
    function h(e2, t2) {
      return (h = Object.setPrototypeOf || function(e3, t3) {
        return e3.__proto__ = t3, e3;
      })(e2, t2);
    }
    r2.r(t);
    var m = r2(0), y = r2.n(m), b = r2(5), g = r2.n(b), v = r2(4), C = r2.n(v), _2 = r2(6), w = r2.n(_2), S = r2(2), j = r2.n(S), x = r2(1), N = r2.n(x);
    r2(8);
    function O(e2, t2) {
      return i(e2) || (function(e3, t3) {
        var r3 = [], n2 = true, a2 = false, o2 = void 0;
        try {
          for (var i2, u2 = e3[Symbol.iterator](); !(n2 = (i2 = u2.next()).done) && (r3.push(i2.value), !t3 || r3.length !== t3); n2 = true) ;
        } catch (e4) {
          a2 = true, o2 = e4;
        } finally {
          try {
            n2 || null == u2.return || u2.return();
          } finally {
            if (a2) throw o2;
          }
        }
        return r3;
      })(e2, t2) || u();
    }
    var k = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]], E = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];
    function T(e2, t2, r3, n2, a2) {
      return !r3 || a2 ? e2 + "".padEnd(t2.length, ".") + " " + n2 : e2 + "".padEnd(t2.length, ".") + " " + r3;
    }
    function I(e2, t2, r3, a2, i2) {
      var u2, c2, s2 = [];
      return c2 = true === t2, [(u2 = []).concat.apply(u2, o(e2.map((function(e3) {
        var o2 = { name: e3[0], regions: e3[1], iso2: e3[2], countryCode: e3[3], dialCode: e3[3], format: T(r3, e3[3], e3[4], a2, i2), priority: e3[5] || 0 }, u3 = [];
        return e3[6] && e3[6].map((function(t3) {
          var r4 = (function(e4) {
            for (var t4 = 1; t4 < arguments.length; t4++) {
              var r5 = null != arguments[t4] ? arguments[t4] : {}, a3 = Object.keys(r5);
              "function" == typeof Object.getOwnPropertySymbols && (a3 = a3.concat(Object.getOwnPropertySymbols(r5).filter((function(e5) {
                return Object.getOwnPropertyDescriptor(r5, e5).enumerable;
              })))), a3.forEach((function(t5) {
                n(e4, t5, r5[t5]);
              }));
            }
            return e4;
          })({}, o2);
          r4.dialCode = e3[3] + t3, r4.isAreaCode = true, r4.areaCodeLength = t3.length, u3.push(r4);
        })), u3.length > 0 ? (o2.mainCode = true, c2 || "Array" === t2.constructor.name && t2.includes(e3[2]) ? (o2.hasAreaCodes = true, [o2].concat(u3)) : (s2 = s2.concat(u3), [o2])) : [o2];
      })))), s2];
    }
    function A(e2, t2, r3, n2) {
      if (null !== r3) {
        var a2 = Object.keys(r3), o2 = Object.values(r3);
        a2.forEach((function(r4, a3) {
          if (n2) return e2.push([r4, o2[a3]]);
          var i2 = e2.findIndex((function(e3) {
            return e3[0] === r4;
          }));
          if (-1 === i2) {
            var u2 = [r4];
            u2[t2] = o2[a3], e2.push(u2);
          } else e2[i2][t2] = o2[a3];
        }));
      }
    }
    function D(e2, t2) {
      return 0 === t2.length ? e2 : e2.map((function(e3) {
        var r3 = t2.findIndex((function(t3) {
          return t3[0] === e3[2];
        }));
        if (-1 === r3) return e3;
        var n2 = t2[r3];
        return n2[1] && (e3[4] = n2[1]), n2[3] && (e3[5] = n2[3]), n2[2] && (e3[6] = n2[2]), e3;
      }));
    }
    var P = function e2(t2, r3, n2, a2, i2, u2, s2, l2, f2, d2, p2, h2, m2, y2) {
      c(this, e2), this.filterRegions = function(e3, t3) {
        if ("string" == typeof e3) {
          var r4 = e3;
          return t3.filter((function(e4) {
            return e4.regions.some((function(e5) {
              return e5 === r4;
            }));
          }));
        }
        return t3.filter((function(t4) {
          return e3.map((function(e4) {
            return t4.regions.some((function(t5) {
              return t5 === e4;
            }));
          })).some((function(e4) {
            return e4;
          }));
        }));
      }, this.sortTerritories = function(e3, t3) {
        var r4 = [].concat(o(e3), o(t3));
        return r4.sort((function(e4, t4) {
          return e4.name < t4.name ? -1 : e4.name > t4.name ? 1 : 0;
        })), r4;
      }, this.getFilteredCountryList = function(e3, t3, r4) {
        return 0 === e3.length ? t3 : r4 ? e3.map((function(e4) {
          var r5 = t3.find((function(t4) {
            return t4.iso2 === e4;
          }));
          if (r5) return r5;
        })).filter((function(e4) {
          return e4;
        })) : t3.filter((function(t4) {
          return e3.some((function(e4) {
            return e4 === t4.iso2;
          }));
        }));
      }, this.localizeCountries = function(e3, t3, r4) {
        for (var n3 = 0; n3 < e3.length; n3++) void 0 !== t3[e3[n3].iso2] ? e3[n3].localName = t3[e3[n3].iso2] : void 0 !== t3[e3[n3].name] && (e3[n3].localName = t3[e3[n3].name]);
        return r4 || e3.sort((function(e4, t4) {
          return e4.localName < t4.localName ? -1 : e4.localName > t4.localName ? 1 : 0;
        })), e3;
      }, this.getCustomAreas = function(e3, t3) {
        for (var r4 = [], n3 = 0; n3 < t3.length; n3++) {
          var a3 = JSON.parse(JSON.stringify(e3));
          a3.dialCode += t3[n3], r4.push(a3);
        }
        return r4;
      }, this.excludeCountries = function(e3, t3) {
        return 0 === t3.length ? e3 : e3.filter((function(e4) {
          return !t3.includes(e4.iso2);
        }));
      };
      var b2 = (function(e3, t3, r4) {
        var n3 = [];
        return A(n3, 1, e3, true), A(n3, 3, t3), A(n3, 2, r4), n3;
      })(l2, f2, d2), g2 = D(JSON.parse(JSON.stringify(k)), b2), v2 = D(JSON.parse(JSON.stringify(E)), b2), C2 = O(I(g2, t2, h2, m2, y2), 2), _3 = C2[0], w2 = C2[1];
      if (r3) {
        var S2 = O(I(v2, t2, h2, m2, y2), 2), j2 = S2[0];
        S2[1];
        _3 = this.sortTerritories(j2, _3);
      }
      n2 && (_3 = this.filterRegions(n2, _3)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a2, _3, s2.includes("onlyCountries")), u2), p2, s2.includes("onlyCountries")), this.preferredCountries = 0 === i2.length ? [] : this.localizeCountries(this.getFilteredCountryList(i2, _3, s2.includes("preferredCountries")), p2, s2.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(a2, w2), u2);
    }, F = (function(e2) {
      function t2(e3) {
        var r4;
        c(this, t2), (r4 = (function(e4, t3) {
          return !t3 || "object" !== f(t3) && "function" != typeof t3 ? d(e4) : t3;
        })(this, p(t2).call(this, e3))).getProbableCandidate = C()((function(e4) {
          return e4 && 0 !== e4.length ? r4.state.onlyCountries.filter((function(t3) {
            return j()(t3.name.toLowerCase(), e4.toLowerCase());
          }), d(d(r4)))[0] : null;
        })), r4.guessSelectedCountry = C()((function(e4, t3, n2, a2) {
          var o2;
          if (false === r4.props.enableAreaCodes && (a2.some((function(t4) {
            if (j()(e4, t4.dialCode)) return n2.some((function(e5) {
              if (t4.iso2 === e5.iso2 && e5.mainCode) return o2 = e5, true;
            })), true;
          })), o2)) return o2;
          var i2 = n2.find((function(e5) {
            return e5.iso2 == t3;
          }));
          if ("" === e4.trim()) return i2;
          var u2 = n2.reduce((function(t4, r5) {
            if (j()(e4, r5.dialCode)) {
              if (r5.dialCode.length > t4.dialCode.length) return r5;
              if (r5.dialCode.length === t4.dialCode.length && r5.priority < t4.priority) return r5;
            }
            return t4;
          }), { dialCode: "", priority: 10001 }, d(d(r4)));
          return u2.name ? u2 : i2;
        })), r4.updateCountry = function(e4) {
          var t3, n2 = r4.state.onlyCountries;
          (t3 = e4.indexOf(0) >= "0" && e4.indexOf(0) <= "9" ? n2.find((function(t4) {
            return t4.dialCode == +e4;
          })) : n2.find((function(t4) {
            return t4.iso2 == e4;
          }))) && t3.dialCode && r4.setState({ selectedCountry: t3, formattedNumber: r4.props.disableCountryCode ? "" : r4.formatNumber(t3.dialCode, t3) });
        }, r4.scrollTo = function(e4, t3) {
          if (e4) {
            var n2 = r4.dropdownRef;
            if (n2 && document.body) {
              var a2 = n2.offsetHeight, o2 = n2.getBoundingClientRect().top + document.body.scrollTop, i2 = o2 + a2, u2 = e4, c2 = u2.getBoundingClientRect(), s3 = u2.offsetHeight, l4 = c2.top + document.body.scrollTop, f2 = l4 + s3, d2 = l4 - o2 + n2.scrollTop, p2 = a2 / 2 - s3 / 2;
              if (r4.props.enableSearch ? l4 < o2 + 32 : l4 < o2) t3 && (d2 -= p2), n2.scrollTop = d2;
              else if (f2 > i2) {
                t3 && (d2 += p2);
                var h3 = a2 - s3;
                n2.scrollTop = d2 - h3;
              }
            }
          }
        }, r4.scrollToTop = function() {
          var e4 = r4.dropdownRef;
          e4 && document.body && (e4.scrollTop = 0);
        }, r4.formatNumber = function(e4, t3) {
          if (!t3) return e4;
          var n2, o2 = t3.format, c2 = r4.props, s3 = c2.disableCountryCode, l4 = c2.enableAreaCodeStretch, f2 = c2.enableLongNumbers, d2 = c2.autoFormat;
          if (s3 ? ((n2 = o2.split(" ")).shift(), n2 = n2.join(" ")) : l4 && t3.isAreaCode ? ((n2 = o2.split(" "))[1] = n2[1].replace(/\.+/, "".padEnd(t3.areaCodeLength, ".")), n2 = n2.join(" ")) : n2 = o2, !e4 || 0 === e4.length) return s3 ? "" : r4.props.prefix;
          if (e4 && e4.length < 2 || !n2 || !d2) return s3 ? e4 : r4.props.prefix + e4;
          var p2, h3 = w()(n2, (function(e5, t4) {
            if (0 === e5.remainingText.length) return e5;
            if ("." !== t4) return { formattedText: e5.formattedText + t4, remainingText: e5.remainingText };
            var r5, n3 = i(r5 = e5.remainingText) || a(r5) || u(), o3 = n3[0], c3 = n3.slice(1);
            return { formattedText: e5.formattedText + o3, remainingText: c3 };
          }), { formattedText: "", remainingText: e4.split("") });
          return (p2 = f2 ? h3.formattedText + h3.remainingText.join("") : h3.formattedText).includes("(") && !p2.includes(")") && (p2 += ")"), p2;
        }, r4.cursorToEnd = function() {
          var e4 = r4.numberInputRef;
          if (document.activeElement === e4) {
            e4.focus();
            var t3 = e4.value.length;
            ")" === e4.value.charAt(t3 - 1) && (t3 -= 1), e4.setSelectionRange(t3, t3);
          }
        }, r4.getElement = function(e4) {
          return r4["flag_no_".concat(e4)];
        }, r4.getCountryData = function() {
          return r4.state.selectedCountry ? { name: r4.state.selectedCountry.name || "", dialCode: r4.state.selectedCountry.dialCode || "", countryCode: r4.state.selectedCountry.iso2 || "", format: r4.state.selectedCountry.format || "" } : {};
        }, r4.handleFlagDropdownClick = function(e4) {
          if (e4.preventDefault(), r4.state.showDropdown || !r4.props.disabled) {
            var t3 = r4.state, n2 = t3.preferredCountries, a2 = t3.onlyCountries, o2 = t3.selectedCountry, i2 = r4.concatPreferredCountries(n2, a2).findIndex((function(e5) {
              return e5.dialCode === o2.dialCode && e5.iso2 === o2.iso2;
            }));
            r4.setState({ showDropdown: !r4.state.showDropdown, highlightCountryIndex: i2 }, (function() {
              r4.state.showDropdown && r4.scrollTo(r4.getElement(r4.state.highlightCountryIndex));
            }));
          }
        }, r4.handleInput = function(e4) {
          var t3 = e4.target.value, n2 = r4.props, a2 = n2.prefix, o2 = n2.onChange, i2 = r4.props.disableCountryCode ? "" : a2, u2 = r4.state.selectedCountry, c2 = r4.state.freezeSelection;
          if (!r4.props.countryCodeEditable) {
            var s3 = a2 + (u2.hasAreaCodes ? r4.state.onlyCountries.find((function(e5) {
              return e5.iso2 === u2.iso2 && e5.mainCode;
            })).dialCode : u2.dialCode);
            if (t3.slice(0, s3.length) !== s3) return;
          }
          if (t3 === a2) return o2 && o2("", r4.getCountryData(), e4, ""), r4.setState({ formattedNumber: "" });
          if (t3.replace(/\D/g, "").length > 15) {
            if (false === r4.props.enableLongNumbers) return;
            if ("number" == typeof r4.props.enableLongNumbers && t3.replace(/\D/g, "").length > r4.props.enableLongNumbers) return;
          }
          if (t3 !== r4.state.formattedNumber) {
            e4.preventDefault ? e4.preventDefault() : e4.returnValue = false;
            var l4 = r4.props.country, f2 = r4.state, d2 = f2.onlyCountries, p2 = f2.selectedCountry, h3 = f2.hiddenAreaCodes;
            if (o2 && e4.persist(), t3.length > 0) {
              var m3 = t3.replace(/\D/g, "");
              (!r4.state.freezeSelection || p2 && p2.dialCode.length > m3.length) && (u2 = r4.props.disableCountryGuess ? p2 : r4.guessSelectedCountry(m3.substring(0, 6), l4, d2, h3) || p2, c2 = false), i2 = r4.formatNumber(m3, u2), u2 = u2.dialCode ? u2 : p2;
            }
            var y2 = e4.target.selectionStart, b3 = e4.target.selectionStart, g2 = r4.state.formattedNumber, v3 = i2.length - g2.length;
            r4.setState({ formattedNumber: i2, freezeSelection: c2, selectedCountry: u2 }, (function() {
              v3 > 0 && (b3 -= v3), ")" == i2.charAt(i2.length - 1) ? r4.numberInputRef.setSelectionRange(i2.length - 1, i2.length - 1) : b3 > 0 && g2.length >= i2.length ? r4.numberInputRef.setSelectionRange(b3, b3) : y2 < g2.length && r4.numberInputRef.setSelectionRange(y2, y2), o2 && o2(i2.replace(/[^0-9]+/g, ""), r4.getCountryData(), e4, i2);
            }));
          }
        }, r4.handleInputClick = function(e4) {
          r4.setState({ showDropdown: false }), r4.props.onClick && r4.props.onClick(e4, r4.getCountryData());
        }, r4.handleDoubleClick = function(e4) {
          var t3 = e4.target.value.length;
          e4.target.setSelectionRange(0, t3);
        }, r4.handleFlagItemClick = function(e4, t3) {
          var n2 = r4.state.selectedCountry, a2 = r4.state.onlyCountries.find((function(t4) {
            return t4 == e4;
          }));
          if (a2) {
            var o2 = r4.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), i2 = o2.length > 1 ? o2.replace(n2.dialCode, a2.dialCode) : a2.dialCode, u2 = r4.formatNumber(i2.replace(/\D/g, ""), a2);
            r4.setState({ showDropdown: false, selectedCountry: a2, freezeSelection: true, formattedNumber: u2, searchValue: "" }, (function() {
              r4.cursorToEnd(), r4.props.onChange && r4.props.onChange(u2.replace(/[^0-9]+/g, ""), r4.getCountryData(), t3, u2);
            }));
          }
        }, r4.handleInputFocus = function(e4) {
          r4.numberInputRef && r4.numberInputRef.value === r4.props.prefix && r4.state.selectedCountry && !r4.props.disableCountryCode && r4.setState({ formattedNumber: r4.props.prefix + r4.state.selectedCountry.dialCode }, (function() {
            r4.props.jumpCursorToEnd && setTimeout(r4.cursorToEnd, 0);
          })), r4.setState({ placeholder: "" }), r4.props.onFocus && r4.props.onFocus(e4, r4.getCountryData()), r4.props.jumpCursorToEnd && setTimeout(r4.cursorToEnd, 0);
        }, r4.handleInputBlur = function(e4) {
          e4.target.value || r4.setState({ placeholder: r4.props.placeholder }), r4.props.onBlur && r4.props.onBlur(e4, r4.getCountryData());
        }, r4.handleInputCopy = function(e4) {
          if (r4.props.copyNumbersOnly) {
            var t3 = window.getSelection().toString().replace(/[^0-9]+/g, "");
            e4.clipboardData.setData("text/plain", t3), e4.preventDefault();
          }
        }, r4.getHighlightCountryIndex = function(e4) {
          var t3 = r4.state.highlightCountryIndex + e4;
          return t3 < 0 || t3 >= r4.state.onlyCountries.length + r4.state.preferredCountries.length ? t3 - e4 : r4.props.enableSearch && t3 > r4.getSearchFilteredCountries().length ? 0 : t3;
        }, r4.searchCountry = function() {
          var e4 = r4.getProbableCandidate(r4.state.queryString) || r4.state.onlyCountries[0], t3 = r4.state.onlyCountries.findIndex((function(t4) {
            return t4 == e4;
          })) + r4.state.preferredCountries.length;
          r4.scrollTo(r4.getElement(t3), true), r4.setState({ queryString: "", highlightCountryIndex: t3 });
        }, r4.handleKeydown = function(e4) {
          var t3 = r4.props.keys, n2 = e4.target.className;
          if (n2.includes("selected-flag") && e4.which === t3.ENTER && !r4.state.showDropdown) return r4.handleFlagDropdownClick(e4);
          if (n2.includes("form-control") && (e4.which === t3.ENTER || e4.which === t3.ESC)) return e4.target.blur();
          if (r4.state.showDropdown && !r4.props.disabled && (!n2.includes("search-box") || e4.which === t3.UP || e4.which === t3.DOWN || e4.which === t3.ENTER || e4.which === t3.ESC && "" === e4.target.value)) {
            e4.preventDefault ? e4.preventDefault() : e4.returnValue = false;
            var a2 = function(e5) {
              r4.setState({ highlightCountryIndex: r4.getHighlightCountryIndex(e5) }, (function() {
                r4.scrollTo(r4.getElement(r4.state.highlightCountryIndex), true);
              }));
            };
            switch (e4.which) {
              case t3.DOWN:
                a2(1);
                break;
              case t3.UP:
                a2(-1);
                break;
              case t3.ENTER:
                r4.props.enableSearch ? r4.handleFlagItemClick(r4.getSearchFilteredCountries()[r4.state.highlightCountryIndex] || r4.getSearchFilteredCountries()[0], e4) : r4.handleFlagItemClick([].concat(o(r4.state.preferredCountries), o(r4.state.onlyCountries))[r4.state.highlightCountryIndex], e4);
                break;
              case t3.ESC:
              case t3.TAB:
                r4.setState({ showDropdown: false }, r4.cursorToEnd);
                break;
              default:
                (e4.which >= t3.A && e4.which <= t3.Z || e4.which === t3.SPACE) && r4.setState({ queryString: r4.state.queryString + String.fromCharCode(e4.which) }, r4.state.debouncedQueryStingSearcher);
            }
          }
        }, r4.handleInputKeyDown = function(e4) {
          var t3 = r4.props, n2 = t3.keys, a2 = t3.onEnterKeyPress, o2 = t3.onKeyDown;
          e4.which === n2.ENTER && a2 && a2(e4), o2 && o2(e4);
        }, r4.handleClickOutside = function(e4) {
          r4.dropdownRef && !r4.dropdownContainerRef.contains(e4.target) && r4.state.showDropdown && r4.setState({ showDropdown: false });
        }, r4.handleSearchChange = function(e4) {
          var t3 = e4.currentTarget.value, n2 = r4.state, a2 = n2.preferredCountries, o2 = n2.selectedCountry, i2 = 0;
          if ("" === t3 && o2) {
            var u2 = r4.state.onlyCountries;
            i2 = r4.concatPreferredCountries(a2, u2).findIndex((function(e5) {
              return e5 == o2;
            })), setTimeout((function() {
              return r4.scrollTo(r4.getElement(i2));
            }), 100);
          }
          r4.setState({ searchValue: t3, highlightCountryIndex: i2 });
        }, r4.concatPreferredCountries = function(e4, t3) {
          return e4.length > 0 ? o(new Set(e4.concat(t3))) : t3;
        }, r4.getDropdownCountryName = function(e4) {
          return e4.localName || e4.name;
        }, r4.getSearchFilteredCountries = function() {
          var e4 = r4.state, t3 = e4.preferredCountries, n2 = e4.onlyCountries, a2 = e4.searchValue, i2 = r4.props.enableSearch, u2 = r4.concatPreferredCountries(t3, n2), c2 = a2.trim().toLowerCase().replace("+", "");
          if (i2 && c2) {
            if (/^\d+$/.test(c2)) return u2.filter((function(e5) {
              var t4 = e5.dialCode;
              return ["".concat(t4)].some((function(e6) {
                return e6.toLowerCase().includes(c2);
              }));
            }));
            var s3 = u2.filter((function(e5) {
              var t4 = e5.iso2;
              return ["".concat(t4)].some((function(e6) {
                return e6.toLowerCase().includes(c2);
              }));
            })), l4 = u2.filter((function(e5) {
              var t4 = e5.name, r5 = e5.localName;
              e5.iso2;
              return ["".concat(t4), "".concat(r5 || "")].some((function(e6) {
                return e6.toLowerCase().includes(c2);
              }));
            }));
            return r4.scrollToTop(), o(new Set([].concat(s3, l4)));
          }
          return u2;
        }, r4.getCountryDropdownList = function() {
          var e4 = r4.state, t3 = e4.preferredCountries, a2 = e4.highlightCountryIndex, o2 = e4.showDropdown, i2 = e4.searchValue, u2 = r4.props, c2 = u2.disableDropdown, s3 = u2.prefix, l4 = r4.props, f2 = l4.enableSearch, d2 = l4.searchNotFound, p2 = l4.disableSearchIcon, h3 = l4.searchClass, m3 = l4.searchStyle, b3 = l4.searchPlaceholder, g2 = l4.autocompleteSearch, v3 = r4.getSearchFilteredCountries().map((function(e5, t4) {
            var n2 = a2 === t4, o3 = N()({ country: true, preferred: "us" === e5.iso2 || "gb" === e5.iso2, active: "us" === e5.iso2, highlight: n2 }), i3 = "flag ".concat(e5.iso2);
            return y.a.createElement("li", Object.assign({ ref: function(e6) {
              return r4["flag_no_".concat(t4)] = e6;
            }, key: "flag_no_".concat(t4), "data-flag-key": "flag_no_".concat(t4), className: o3, "data-dial-code": "1", tabIndex: c2 ? "-1" : "0", "data-country-code": e5.iso2, onClick: function(t5) {
              return r4.handleFlagItemClick(e5, t5);
            }, role: "option" }, n2 ? { "aria-selected": true } : {}), y.a.createElement("div", { className: i3 }), y.a.createElement("span", { className: "country-name" }, r4.getDropdownCountryName(e5)), y.a.createElement("span", { className: "dial-code" }, e5.format ? r4.formatNumber(e5.dialCode, e5) : s3 + e5.dialCode));
          })), C2 = y.a.createElement("li", { key: "dashes", className: "divider" });
          t3.length > 0 && (!f2 || f2 && !i2.trim()) && v3.splice(t3.length, 0, C2);
          var _4 = N()(n({ "country-list": true, hide: !o2 }, r4.props.dropdownClass, true));
          return y.a.createElement("ul", { ref: function(e5) {
            return !f2 && e5 && e5.focus(), r4.dropdownRef = e5;
          }, className: _4, style: r4.props.dropdownStyle, role: "listbox", tabIndex: "0" }, f2 && y.a.createElement("li", { className: N()(n({ search: true }, h3, h3)) }, !p2 && y.a.createElement("span", { className: N()(n({ "search-emoji": true }, "".concat(h3, "-emoji"), h3)), role: "img", "aria-label": "Magnifying glass" }, "🔎"), y.a.createElement("input", { className: N()(n({ "search-box": true }, "".concat(h3, "-box"), h3)), style: m3, type: "search", placeholder: b3, autoFocus: true, autoComplete: g2 ? "on" : "off", value: i2, onChange: r4.handleSearchChange })), v3.length > 0 ? v3 : y.a.createElement("li", { className: "no-entries-message" }, y.a.createElement("span", null, d2)));
        };
        var s2, l3 = new P(e3.enableAreaCodes, e3.enableTerritories, e3.regions, e3.onlyCountries, e3.preferredCountries, e3.excludeCountries, e3.preserveOrder, e3.masks, e3.priority, e3.areaCodes, e3.localization, e3.prefix, e3.defaultMask, e3.alwaysDefaultMask), h2 = l3.onlyCountries, m2 = l3.preferredCountries, b2 = l3.hiddenAreaCodes, v2 = e3.value ? e3.value.replace(/\D/g, "") : "";
        s2 = e3.disableInitialCountryGuess ? 0 : v2.length > 1 ? r4.guessSelectedCountry(v2.substring(0, 6), e3.country, h2, b2) || 0 : e3.country && h2.find((function(t3) {
          return t3.iso2 == e3.country;
        })) || 0;
        var _3, S2 = v2.length < 2 && s2 && !j()(v2, s2.dialCode) ? s2.dialCode : "";
        _3 = "" === v2 && 0 === s2 ? "" : r4.formatNumber((e3.disableCountryCode ? "" : S2) + v2, s2.name ? s2 : void 0);
        var x2 = h2.findIndex((function(e4) {
          return e4 == s2;
        }));
        return r4.state = { showDropdown: e3.showDropdown, formattedNumber: _3, onlyCountries: h2, preferredCountries: m2, hiddenAreaCodes: b2, selectedCountry: s2, highlightCountryIndex: x2, queryString: "", freezeSelection: false, debouncedQueryStingSearcher: g()(r4.searchCountry, 250), searchValue: "" }, r4;
      }
      var r3, l2;
      return (function(e3, t3) {
        if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
        e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), t3 && h(e3, t3);
      })(t2, e2), r3 = t2, (l2 = [{ key: "componentDidMount", value: function() {
        document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
      } }, { key: "componentWillUnmount", value: function() {
        document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
      } }, { key: "componentDidUpdate", value: function(e3, t3, r4) {
        e3.country !== this.props.country ? this.updateCountry(this.props.country) : e3.value !== this.props.value && this.updateFormattedNumber(this.props.value);
      } }, { key: "updateFormattedNumber", value: function(e3) {
        if (null === e3) return this.setState({ selectedCountry: 0, formattedNumber: "" });
        var t3 = this.state, r4 = t3.onlyCountries, n2 = t3.selectedCountry, a2 = t3.hiddenAreaCodes, o2 = this.props, i2 = o2.country, u2 = o2.prefix;
        if ("" === e3) return this.setState({ selectedCountry: n2, formattedNumber: "" });
        var c2, s2, l3 = e3.replace(/\D/g, "");
        if (n2 && j()(e3, u2 + n2.dialCode)) s2 = this.formatNumber(l3, n2), this.setState({ formattedNumber: s2 });
        else {
          var f2 = (c2 = this.props.disableCountryGuess ? n2 : this.guessSelectedCountry(l3.substring(0, 6), i2, r4, a2) || n2) && j()(l3, u2 + c2.dialCode) ? c2.dialCode : "";
          s2 = this.formatNumber((this.props.disableCountryCode ? "" : f2) + l3, c2 || void 0), this.setState({ selectedCountry: c2, formattedNumber: s2 });
        }
      } }, { key: "render", value: function() {
        var e3, t3, r4, a2 = this, o2 = this.state, i2 = o2.onlyCountries, u2 = o2.selectedCountry, c2 = o2.showDropdown, s2 = o2.formattedNumber, l3 = o2.hiddenAreaCodes, f2 = this.props, d2 = f2.disableDropdown, p2 = f2.renderStringAsFlag, h2 = f2.isValid, m2 = f2.defaultErrorMessage, b2 = f2.specialLabel;
        if ("boolean" == typeof h2) t3 = h2;
        else {
          var g2 = h2(s2.replace(/\D/g, ""), u2, i2, l3);
          "boolean" == typeof g2 ? false === (t3 = g2) && (r4 = m2) : (t3 = false, r4 = g2);
        }
        var v2 = N()((n(e3 = {}, this.props.containerClass, true), n(e3, "react-tel-input", true), e3)), C2 = N()({ arrow: true, up: c2 }), _3 = N()(n({ "form-control": true, "invalid-number": !t3, open: c2 }, this.props.inputClass, true)), w2 = N()({ "selected-flag": true, open: c2 }), S2 = N()(n({ "flag-dropdown": true, "invalid-number": !t3, open: c2 }, this.props.buttonClass, true)), j2 = "flag ".concat(u2 && u2.iso2);
        return y.a.createElement("div", { className: "".concat(v2, " ").concat(this.props.className), style: this.props.style || this.props.containerStyle, onKeyDown: this.handleKeydown }, b2 && y.a.createElement("div", { className: "special-label" }, b2), r4 && y.a.createElement("div", { className: "invalid-number-message" }, r4), y.a.createElement("input", Object.assign({ className: _3, style: this.props.inputStyle, onChange: this.handleInput, onClick: this.handleInputClick, onDoubleClick: this.handleDoubleClick, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onCopy: this.handleInputCopy, value: s2, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, disabled: this.props.disabled, type: "tel" }, this.props.inputProps, { ref: function(e4) {
          a2.numberInputRef = e4, "function" == typeof a2.props.inputProps.ref ? a2.props.inputProps.ref(e4) : "object" == typeof a2.props.inputProps.ref && (a2.props.inputProps.ref.current = e4);
        } })), y.a.createElement("div", { className: S2, style: this.props.buttonStyle, ref: function(e4) {
          return a2.dropdownContainerRef = e4;
        } }, p2 ? y.a.createElement("div", { className: w2 }, p2) : y.a.createElement("div", { onClick: d2 ? void 0 : this.handleFlagDropdownClick, className: w2, title: u2 ? "".concat(u2.localName || u2.name, ": + ").concat(u2.dialCode) : "", tabIndex: d2 ? "-1" : "0", role: "button", "aria-haspopup": "listbox", "aria-expanded": !!c2 || void 0 }, y.a.createElement("div", { className: j2 }, !d2 && y.a.createElement("div", { className: C2 }))), c2 && this.getCountryDropdownList()));
      } }]) && s(r3.prototype, l2), t2;
    })(y.a.Component);
    F.defaultProps = { country: "", value: "", onlyCountries: [], preferredCountries: [], excludeCountries: [], placeholder: "1 (702) 123-4567", searchPlaceholder: "search", searchNotFound: "No entries to show", flagsImagePath: "./flags.png", disabled: false, containerStyle: {}, inputStyle: {}, buttonStyle: {}, dropdownStyle: {}, searchStyle: {}, containerClass: "", inputClass: "", buttonClass: "", dropdownClass: "", searchClass: "", className: "", autoFormat: true, enableAreaCodes: false, enableTerritories: false, disableCountryCode: false, disableDropdown: false, enableLongNumbers: false, countryCodeEditable: true, enableSearch: false, disableSearchIcon: false, disableInitialCountryGuess: false, disableCountryGuess: false, regions: "", inputProps: {}, localization: {}, masks: null, priority: null, areaCodes: null, preserveOrder: [], defaultMask: "... ... ... ... ..", alwaysDefaultMask: false, prefix: "+", copyNumbersOnly: true, renderStringAsFlag: "", autocompleteSearch: false, jumpCursorToEnd: true, enableAreaCodeStretch: false, enableClickOutside: true, showDropdown: false, isValid: true, defaultErrorMessage: "", specialLabel: "Phone", onEnterKeyPress: null, keys: { UP: 38, DOWN: 40, RIGHT: 39, LEFT: 37, ENTER: 13, ESC: 27, PLUS: 43, A: 65, Z: 90, SPACE: 32, TAB: 9 } };
    t.default = F;
  }]);
  return lib;
}
requireLib();
const HubStatusNotificationKey = "hub_status_notification_key";
const HubConnectionStatus = ({ hub, delay, useDescription }) => {
  const ctx = useContext(Context$3);
  const loc = ctx.loc;
  const [visible, setVisible] = useState$1(false);
  const stop2 = useRef(false);
  const timer = useRef(void 0);
  useEffect(() => {
    switch (hub.state) {
      case HubConnectionState.Connected:
        clearTimeout(timer.current);
        stop2.current = false;
        setVisible(false);
        break;
      case HubConnectionState.Reconnecting:
        if (stop2.current) return;
        if (delay) {
          timer.current = setTimeout(() => {
            setVisible(true);
          }, delay.milliseconds);
        } else {
          setVisible(true);
        }
        break;
    }
  }, [hub.state]);
  useEffect(() => {
    if (visible) {
      notification.warning({
        key: HubStatusNotificationKey,
        placement: "bottomLeft",
        icon: /* @__PURE__ */ jsx$1(LoadingOutlined$3, {}),
        message: loc.word("HubConnection.reconnectingLabel", { default: "Connecting to the server" }),
        description: useDescription === true ? `${loc.word("Trying to reconnect")}...` : null,
        duration: 0,
        onClose: () => {
          setVisible(false);
          stop2.current = true;
        }
      });
    } else {
      notification.destroy(HubStatusNotificationKey);
    }
  }, [visible]);
  return null;
};
observer(HubConnectionStatus);
const loadingOverlay = "_loadingOverlay_wdndd_1";
const icon = "_icon_wdndd_34";
const styles$L = {
  loadingOverlay,
  icon
};
const LoadingOverlay = ({ loading = true, icon: icon2, label, position: position2, delay, size: size2, theme: theme2, animation, className, children: children2 }) => {
  const [delayed, setDelayed] = useState$1(delay ? true : false);
  const timer = useTimer();
  useEffect(() => {
    if (!delay) return;
    timer.set(() => setDelayed(false), delay);
    return () => timer.clear();
  });
  if (delayed) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    loading == true && /* @__PURE__ */ jsx$1(
      "div",
      {
        className: combineClasses(styles$L.loadingOverlay, className),
        "data-position": position2 ?? "relative",
        "data-size": size2 ?? "middle",
        "data-theme": theme2 ?? "light",
        "data-animation": animation ?? false,
        children: /* @__PURE__ */ jsxs(Space, { size: size2, align: "center", children: [
          icon2 ?? /* @__PURE__ */ jsx$1(LoadingOutlined$3, { className: styles$L.icon }),
          label
        ] })
      }
    ),
    children2
  ] });
};
const Loc = (props) => {
  if (props.word == void 0 && props.wordPlural == void 0) {
    console.warn(`Loc 'word' or 'wordPlural' must be specified`);
    return null;
  }
  if (props.wordPlural != void 0 && props.number == void 0) {
    console.warn(`Loc 'number' must be specified when use 'wordPlural'`);
    return null;
  }
  const ctx = useContext(Context$3);
  const loc = ctx.loc;
  const word = useMemo$2(() => props.word ? loc.word(props.word, { default: props.default, case: props.case }) : loc.wordPlural(props.number, props.wordPlural, { default: props.defaultPlural, case: props.case }), [props.word, props.number]);
  const args = useMemo$2(() => props.args ?? React__default.Children.toArray(props.children), [props.args, props.children]);
  if (args.length == 0) return /* @__PURE__ */ jsx$1("span", { className: props.className, children: word });
  return /* @__PURE__ */ jsx$1(StringTemplate, { template: word, args, className: props.className });
};
const LocPlural = (props) => {
  const loc = /* @__PURE__ */ jsx$1(
    Loc,
    {
      ...props,
      word: void 0,
      wordPlural: { one: `${props.word}.plural.one`, two: `${props.word}.plural.two`, other: `${props.word}.plural.other` },
      defaultPlural: { one: "item", two: "items", other: "items" },
      case: props.case ?? "lower"
    }
  );
  if (props.renderNumber === true)
    return /* @__PURE__ */ jsxs("span", { className: props.className, children: [
      props.number,
      " ",
      loc
    ] });
  return loc;
};
Loc.Plural = LocPlural;
const LocMd = (props) => {
  const ctx = useContext(Context$3);
  const loc = ctx.loc;
  const word = useMemo$2(() => props.word ? loc.word(props.word, { default: props.default, case: props.case }) : loc.wordPlural(props.number, props.wordPlural, { default: props.defaultPlural, case: props.case }), [props.word, props.number]);
  return /* @__PURE__ */ jsx$1(MarkdownText, { text: word, ...props });
};
Loc.Md = LocMd;
Loc.Time = (props) => /* @__PURE__ */ jsx$1(TimeLoc, { ...props });
const FileIcon = ({ extension, size: size2 = "md", filename, bgColor = "#ffffff", className }) => {
  const dataType = useMemo$2(() => {
    if (filename != null)
      return filename.split(".").pop();
    if (extension != null) {
      if (extension.startsWith("."))
        return extension.substring(1);
    }
    return extension;
  }, [filename, extension]);
  const sizeClassName = useMemo$2(() => {
    return size2 == null ? "" : `file-icon-${size2}`;
  }, [size2]);
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses("file-icon shadow-xs", sizeClassName, className), "data-type": dataType, "data-bg-color": bgColor, children: dataType && /* @__PURE__ */ jsx$1("div", { className: "file-icon-ext", children: dataType.toUpperCase() }) });
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$3(o);
}
function toPrimitive$1(t, r2) {
  if ("object" != _typeof$3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != _typeof$3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function toPropertyKey$1(t) {
  var i = toPrimitive$1(t, "string");
  return "symbol" == _typeof$3(i) ? i : i + "";
}
function _defineProperty$1(e, r2, t) {
  return (r2 = toPropertyKey$1(r2)) in e ? Object.defineProperty(e, r2, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r2] = t, e;
}
function ownKeys$g(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$g(Object(t), true).forEach(function(r3) {
      _defineProperty$1(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
var dist = {};
var Linkify$1 = {};
var defaultComponentDecorator = {};
var hasRequiredDefaultComponentDecorator;
function requireDefaultComponentDecorator() {
  if (hasRequiredDefaultComponentDecorator) return defaultComponentDecorator;
  hasRequiredDefaultComponentDecorator = 1;
  Object.defineProperty(defaultComponentDecorator, "__esModule", {
    value: true
  });
  var _react = React__default;
  var React2 = _interopRequireWildcard(_react);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  defaultComponentDecorator.default = function(decoratedHref, decoratedText, key) {
    return React2.createElement(
      "a",
      { href: decoratedHref, key },
      decoratedText
    );
  };
  return defaultComponentDecorator;
}
var defaultHrefDecorator = {};
var hasRequiredDefaultHrefDecorator;
function requireDefaultHrefDecorator() {
  if (hasRequiredDefaultHrefDecorator) return defaultHrefDecorator;
  hasRequiredDefaultHrefDecorator = 1;
  Object.defineProperty(defaultHrefDecorator, "__esModule", {
    value: true
  });
  defaultHrefDecorator.default = function(href) {
    return href;
  };
  return defaultHrefDecorator;
}
var defaultMatchDecorator = {};
var regex$3;
var hasRequiredRegex$3;
function requireRegex$3() {
  if (hasRequiredRegex$3) return regex$3;
  hasRequiredRegex$3 = 1;
  regex$3 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
  return regex$3;
}
var regex$2;
var hasRequiredRegex$2;
function requireRegex$2() {
  if (hasRequiredRegex$2) return regex$2;
  hasRequiredRegex$2 = 1;
  regex$2 = /[\0-\x1F\x7F-\x9F]/;
  return regex$2;
}
var regex$1;
var hasRequiredRegex$1;
function requireRegex$1() {
  if (hasRequiredRegex$1) return regex$1;
  hasRequiredRegex$1 = 1;
  regex$1 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
  return regex$1;
}
var regex;
var hasRequiredRegex;
function requireRegex() {
  if (hasRequiredRegex) return regex;
  hasRequiredRegex = 1;
  regex = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
  return regex;
}
var re;
var hasRequiredRe;
function requireRe() {
  if (hasRequiredRe) return re;
  hasRequiredRe = 1;
  re = function(opts) {
    var re2 = {};
    re2.src_Any = requireRegex$3().source;
    re2.src_Cc = requireRegex$2().source;
    re2.src_Z = requireRegex$1().source;
    re2.src_P = requireRegex().source;
    re2.src_ZPCc = [re2.src_Z, re2.src_P, re2.src_Cc].join("|");
    re2.src_ZCc = [re2.src_Z, re2.src_Cc].join("|");
    var text_separators = "[><｜]";
    re2.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re2.src_ZPCc + ")" + re2.src_Any + ")";
    re2.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    re2.src_auth = "(?:(?:(?!" + re2.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re2.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re2.src_host_terminator = "(?=$|" + text_separators + "|" + re2.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re2.src_ZPCc + "))";
    re2.src_path = "(?:[/?#](?:(?!" + re2.src_ZCc + "|" + text_separators + `|[()[\\]{}.,"'?!\\-]).|\\[(?:(?!` + re2.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + re2.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + re2.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + re2.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + re2.src_ZCc + "|[']).)+\\'|\\'(?=" + re2.src_pseudo_letter + "|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!" + re2.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + "\\,(?!" + re2.src_ZCc + ").|\\!(?!" + re2.src_ZCc + "|[!]).|\\?(?!" + re2.src_ZCc + "|[?]).)+|\\/)?";
    re2.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re2.src_xn = "xn--[a-z0-9\\-]{1,59}";
    re2.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re2.src_xn + "|" + re2.src_pseudo_letter + "{1,63})";
    re2.src_domain = "(?:" + re2.src_xn + "|(?:" + re2.src_pseudo_letter + ")|(?:" + re2.src_pseudo_letter + "(?:-|" + re2.src_pseudo_letter + "){0,61}" + re2.src_pseudo_letter + "))";
    re2.src_host = "(?:(?:(?:(?:" + re2.src_domain + ")\\.)*" + re2.src_domain + "))";
    re2.tpl_host_fuzzy = "(?:" + re2.src_ip4 + "|(?:(?:(?:" + re2.src_domain + ")\\.)+(?:%TLDS%)))";
    re2.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re2.src_domain + ")\\.)+(?:%TLDS%))";
    re2.src_host_strict = re2.src_host + re2.src_host_terminator;
    re2.tpl_host_fuzzy_strict = re2.tpl_host_fuzzy + re2.src_host_terminator;
    re2.src_host_port_strict = re2.src_host + re2.src_port + re2.src_host_terminator;
    re2.tpl_host_port_fuzzy_strict = re2.tpl_host_fuzzy + re2.src_port + re2.src_host_terminator;
    re2.tpl_host_port_no_ip_fuzzy_strict = re2.tpl_host_no_ip_fuzzy + re2.src_port + re2.src_host_terminator;
    re2.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re2.src_ZPCc + "|>|$))";
    re2.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re2.src_ZCc + ")(" + re2.src_email_name + "@" + re2.tpl_host_fuzzy_strict + ")";
    re2.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re2.src_ZPCc + "))((?![$+<=>^`|｜])" + re2.tpl_host_port_fuzzy_strict + re2.src_path + ")";
    re2.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + re2.src_ZPCc + "))((?![$+<=>^`|｜])" + re2.tpl_host_port_no_ip_fuzzy_strict + re2.src_path + ")";
    return re2;
  };
  return re;
}
var linkifyIt;
var hasRequiredLinkifyIt;
function requireLinkifyIt() {
  if (hasRequiredLinkifyIt) return linkifyIt;
  hasRequiredLinkifyIt = 1;
  function assign2(obj) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
      if (!source) {
        return;
      }
      Object.keys(source).forEach(function(key) {
        obj[key] = source[key];
      });
    });
    return obj;
  }
  function _class(obj) {
    return Object.prototype.toString.call(obj);
  }
  function isString(obj) {
    return _class(obj) === "[object String]";
  }
  function isObject2(obj) {
    return _class(obj) === "[object Object]";
  }
  function isRegExp(obj) {
    return _class(obj) === "[object RegExp]";
  }
  function isFunction2(obj) {
    return _class(obj) === "[object Function]";
  }
  function escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }
  var defaultOptions2 = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
  };
  function isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
      return acc || defaultOptions2.hasOwnProperty(k);
    }, false);
  }
  var defaultSchemas = {
    "http:": {
      validate: function(text2, pos, self2) {
        var tail = text2.slice(pos);
        if (!self2.re.http) {
          self2.re.http = new RegExp(
            "^\\/\\/" + self2.re.src_auth + self2.re.src_host_port_strict + self2.re.src_path,
            "i"
          );
        }
        if (self2.re.http.test(tail)) {
          return tail.match(self2.re.http)[0].length;
        }
        return 0;
      }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
      validate: function(text2, pos, self2) {
        var tail = text2.slice(pos);
        if (!self2.re.no_http) {
          self2.re.no_http = new RegExp(
            "^" + self2.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self2.re.src_domain + ")\\.)+" + self2.re.src_domain_root + ")" + self2.re.src_port + self2.re.src_host_terminator + self2.re.src_path,
            "i"
          );
        }
        if (self2.re.no_http.test(tail)) {
          if (pos >= 3 && text2[pos - 3] === ":") {
            return 0;
          }
          if (pos >= 3 && text2[pos - 3] === "/") {
            return 0;
          }
          return tail.match(self2.re.no_http)[0].length;
        }
        return 0;
      }
    },
    "mailto:": {
      validate: function(text2, pos, self2) {
        var tail = text2.slice(pos);
        if (!self2.re.mailto) {
          self2.re.mailto = new RegExp(
            "^" + self2.re.src_email_name + "@" + self2.re.src_host_strict,
            "i"
          );
        }
        if (self2.re.mailto.test(tail)) {
          return tail.match(self2.re.mailto)[0].length;
        }
        return 0;
      }
    }
  };
  var tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
  var tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
  function resetScanCache(self2) {
    self2.__index__ = -1;
    self2.__text_cache__ = "";
  }
  function createValidator(re2) {
    return function(text2, pos) {
      var tail = text2.slice(pos);
      if (re2.test(tail)) {
        return tail.match(re2)[0].length;
      }
      return 0;
    };
  }
  function createNormalizer() {
    return function(match2, self2) {
      self2.normalize(match2);
    };
  }
  function compile2(self2) {
    var re2 = self2.re = requireRe()(self2.__opts__);
    var tlds = self2.__tlds__.slice();
    self2.onCompile();
    if (!self2.__tlds_replaced__) {
      tlds.push(tlds_2ch_src_re);
    }
    tlds.push(re2.src_xn);
    re2.src_tlds = tlds.join("|");
    function untpl(tpl) {
      return tpl.replace("%TLDS%", re2.src_tlds);
    }
    re2.email_fuzzy = RegExp(untpl(re2.tpl_email_fuzzy), "i");
    re2.link_fuzzy = RegExp(untpl(re2.tpl_link_fuzzy), "i");
    re2.link_no_ip_fuzzy = RegExp(untpl(re2.tpl_link_no_ip_fuzzy), "i");
    re2.host_fuzzy_test = RegExp(untpl(re2.tpl_host_fuzzy_test), "i");
    var aliases2 = [];
    self2.__compiled__ = {};
    function schemaError(name, val) {
      throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self2.__schemas__).forEach(function(name) {
      var val = self2.__schemas__[name];
      if (val === null) {
        return;
      }
      var compiled = { validate: null, link: null };
      self2.__compiled__[name] = compiled;
      if (isObject2(val)) {
        if (isRegExp(val.validate)) {
          compiled.validate = createValidator(val.validate);
        } else if (isFunction2(val.validate)) {
          compiled.validate = val.validate;
        } else {
          schemaError(name, val);
        }
        if (isFunction2(val.normalize)) {
          compiled.normalize = val.normalize;
        } else if (!val.normalize) {
          compiled.normalize = createNormalizer();
        } else {
          schemaError(name, val);
        }
        return;
      }
      if (isString(val)) {
        aliases2.push(name);
        return;
      }
      schemaError(name, val);
    });
    aliases2.forEach(function(alias2) {
      if (!self2.__compiled__[self2.__schemas__[alias2]]) {
        return;
      }
      self2.__compiled__[alias2].validate = self2.__compiled__[self2.__schemas__[alias2]].validate;
      self2.__compiled__[alias2].normalize = self2.__compiled__[self2.__schemas__[alias2]].normalize;
    });
    self2.__compiled__[""] = { validate: null, normalize: createNormalizer() };
    var slist = Object.keys(self2.__compiled__).filter(function(name) {
      return name.length > 0 && self2.__compiled__[name];
    }).map(escapeRE).join("|");
    self2.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + re2.src_ZPCc + "))(" + slist + ")", "i");
    self2.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + re2.src_ZPCc + "))(" + slist + ")", "ig");
    self2.re.pretest = RegExp(
      "(" + self2.re.schema_test.source + ")|(" + self2.re.host_fuzzy_test.source + ")|@",
      "i"
    );
    resetScanCache(self2);
  }
  function Match(self2, shift) {
    var start2 = self2.__index__, end = self2.__last_index__, text2 = self2.__text_cache__.slice(start2, end);
    this.schema = self2.__schema__.toLowerCase();
    this.index = start2 + shift;
    this.lastIndex = end + shift;
    this.raw = text2;
    this.text = text2;
    this.url = text2;
  }
  function createMatch(self2, shift) {
    var match2 = new Match(self2, shift);
    self2.__compiled__[match2.schema].normalize(match2, self2);
    return match2;
  }
  function LinkifyIt2(schemas, options) {
    if (!(this instanceof LinkifyIt2)) {
      return new LinkifyIt2(schemas, options);
    }
    if (!options) {
      if (isOptionsObj(schemas)) {
        options = schemas;
        schemas = {};
      }
    }
    this.__opts__ = assign2({}, defaultOptions2, options);
    this.__index__ = -1;
    this.__last_index__ = -1;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = assign2({}, defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    compile2(this);
  }
  LinkifyIt2.prototype.add = function add3(schema, definition) {
    this.__schemas__[schema] = definition;
    compile2(this);
    return this;
  };
  LinkifyIt2.prototype.set = function set2(options) {
    this.__opts__ = assign2(this.__opts__, options);
    return this;
  };
  LinkifyIt2.prototype.test = function test(text2) {
    this.__text_cache__ = text2;
    this.__index__ = -1;
    if (!text2.length) {
      return false;
    }
    var m, ml, me, len, shift, next4, re2, tld_pos, at_pos;
    if (this.re.schema_test.test(text2)) {
      re2 = this.re.schema_search;
      re2.lastIndex = 0;
      while ((m = re2.exec(text2)) !== null) {
        len = this.testSchemaAt(text2, m[2], re2.lastIndex);
        if (len) {
          this.__schema__ = m[2];
          this.__index__ = m.index + m[1].length;
          this.__last_index__ = m.index + m[0].length + len;
          break;
        }
      }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
      tld_pos = text2.search(this.re.host_fuzzy_test);
      if (tld_pos >= 0) {
        if (this.__index__ < 0 || tld_pos < this.__index__) {
          if ((ml = text2.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
            shift = ml.index + ml[1].length;
            if (this.__index__ < 0 || shift < this.__index__) {
              this.__schema__ = "";
              this.__index__ = shift;
              this.__last_index__ = ml.index + ml[0].length;
            }
          }
        }
      }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
      at_pos = text2.indexOf("@");
      if (at_pos >= 0) {
        if ((me = text2.match(this.re.email_fuzzy)) !== null) {
          shift = me.index + me[1].length;
          next4 = me.index + me[0].length;
          if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next4 > this.__last_index__) {
            this.__schema__ = "mailto:";
            this.__index__ = shift;
            this.__last_index__ = next4;
          }
        }
      }
    }
    return this.__index__ >= 0;
  };
  LinkifyIt2.prototype.pretest = function pretest(text2) {
    return this.re.pretest.test(text2);
  };
  LinkifyIt2.prototype.testSchemaAt = function testSchemaAt(text2, schema, pos) {
    if (!this.__compiled__[schema.toLowerCase()]) {
      return 0;
    }
    return this.__compiled__[schema.toLowerCase()].validate(text2, pos, this);
  };
  LinkifyIt2.prototype.match = function match2(text2) {
    var shift = 0, result = [];
    if (this.__index__ >= 0 && this.__text_cache__ === text2) {
      result.push(createMatch(this, shift));
      shift = this.__last_index__;
    }
    var tail = shift ? text2.slice(shift) : text2;
    while (this.test(tail)) {
      result.push(createMatch(this, shift));
      tail = tail.slice(this.__last_index__);
      shift += this.__last_index__;
    }
    if (result.length) {
      return result;
    }
    return null;
  };
  LinkifyIt2.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [list];
    if (!keepOld) {
      this.__tlds__ = list.slice();
      this.__tlds_replaced__ = true;
      compile2(this);
      return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
      return el !== arr[idx - 1];
    }).reverse();
    compile2(this);
    return this;
  };
  LinkifyIt2.prototype.normalize = function normalize2(match2) {
    if (!match2.schema) {
      match2.url = "http://" + match2.url;
    }
    if (match2.schema === "mailto:" && !/^mailto:/i.test(match2.url)) {
      match2.url = "mailto:" + match2.url;
    }
  };
  LinkifyIt2.prototype.onCompile = function onCompile() {
  };
  linkifyIt = LinkifyIt2;
  return linkifyIt;
}
const require$$1 = /* @__PURE__ */ JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","vermögensberater","vermögensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","ελ","ευ","бг","бел","дети","ею","католик","ком","мкд","мон","москва","онлайн","орг","рус","рф","сайт","срб","укр","қаз","հայ","ישראל","קום","ابوظبي","ارامكو","الاردن","البحرين","الجزائر","السعودية","العليان","المغرب","امارات","ایران","بارت","بازار","بيتك","بھارت","تونس","سودان","سورية","شبكة","عراق","عرب","عمان","فلسطين","قطر","كاثوليك","كوم","مصر","مليسيا","موريتانيا","موقع","همراه","پاکستان","ڀارت","कॉम","नेट","भारत","भारतम्","भारोत","संगठन","বাংলা","ভারত","ভাৰত","ਭਾਰਤ","ભારત","ଭାରତ","இந்தியா","இலங்கை","சிங்கப்பூர்","భారత్","ಭಾರತ","ഭാരതം","ලංකා","คอม","ไทย","ລາວ","გე","みんな","アマゾン","クラウド","グーグル","コム","ストア","セール","ファッション","ポイント","世界","中信","中国","中國","中文网","亚马逊","企业","佛山","信息","健康","八卦","公司","公益","台湾","台灣","商城","商店","商标","嘉里","嘉里大酒店","在线","大拿","天主教","娱乐","家電","广东","微博","慈善","我爱你","手机","招聘","政务","政府","新加坡","新闻","时尚","書籍","机构","淡马锡","游戏","澳門","点看","移动","组织机构","网址","网店","网站","网络","联通","谷歌","购物","通販","集团","電訊盈科","飞利浦","食品","餐厅","香格里拉","香港","닷넷","닷컴","삼성","한국"]');
var hasRequiredDefaultMatchDecorator;
function requireDefaultMatchDecorator() {
  if (hasRequiredDefaultMatchDecorator) return defaultMatchDecorator;
  hasRequiredDefaultMatchDecorator = 1;
  Object.defineProperty(defaultMatchDecorator, "__esModule", {
    value: true
  });
  var _linkifyIt = requireLinkifyIt();
  var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
  var _tlds = require$$1;
  var _tlds2 = _interopRequireDefault(_tlds);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var linkify = new _linkifyIt2.default();
  linkify.tlds(_tlds2.default);
  defaultMatchDecorator.default = function(text2) {
    return linkify.match(text2);
  };
  return defaultMatchDecorator;
}
var defaultTextDecorator = {};
var hasRequiredDefaultTextDecorator;
function requireDefaultTextDecorator() {
  if (hasRequiredDefaultTextDecorator) return defaultTextDecorator;
  hasRequiredDefaultTextDecorator = 1;
  Object.defineProperty(defaultTextDecorator, "__esModule", {
    value: true
  });
  defaultTextDecorator.default = function(text2) {
    return text2;
  };
  return defaultTextDecorator;
}
var hasRequiredLinkify;
function requireLinkify() {
  if (hasRequiredLinkify) return Linkify$1;
  hasRequiredLinkify = 1;
  Object.defineProperty(Linkify$1, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _react = React__default;
  var React2 = _interopRequireWildcard(_react);
  var _defaultComponentDecorator = requireDefaultComponentDecorator();
  var _defaultComponentDecorator2 = _interopRequireDefault(_defaultComponentDecorator);
  var _defaultHrefDecorator = requireDefaultHrefDecorator();
  var _defaultHrefDecorator2 = _interopRequireDefault(_defaultHrefDecorator);
  var _defaultMatchDecorator = requireDefaultMatchDecorator();
  var _defaultMatchDecorator2 = _interopRequireDefault(_defaultMatchDecorator);
  var _defaultTextDecorator = requireDefaultTextDecorator();
  var _defaultTextDecorator2 = _interopRequireDefault(_defaultTextDecorator);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var Linkify2 = (function(_React$Component) {
    _inherits2(Linkify3, _React$Component);
    function Linkify3() {
      _classCallCheck2(this, Linkify3);
      return _possibleConstructorReturn2(this, (Linkify3.__proto__ || Object.getPrototypeOf(Linkify3)).apply(this, arguments));
    }
    _createClass2(Linkify3, [{
      key: "parseString",
      value: function parseString(string3) {
        var _this2 = this;
        if (string3 === "") {
          return string3;
        }
        var matches = this.props.matchDecorator(string3);
        if (!matches) {
          return string3;
        }
        var elements = [];
        var lastIndex = 0;
        matches.forEach(function(match2, i) {
          if (match2.index > lastIndex) {
            elements.push(string3.substring(lastIndex, match2.index));
          }
          var decoratedHref = _this2.props.hrefDecorator(match2.url);
          var decoratedText = _this2.props.textDecorator(match2.text);
          var decoratedComponent = _this2.props.componentDecorator(decoratedHref, decoratedText, i);
          elements.push(decoratedComponent);
          lastIndex = match2.lastIndex;
        });
        if (string3.length > lastIndex) {
          elements.push(string3.substring(lastIndex));
        }
        return elements.length === 1 ? elements[0] : elements;
      }
    }, {
      key: "parse",
      value: function parse2(children2) {
        var _this3 = this;
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (typeof children2 === "string") {
          return this.parseString(children2);
        } else if (React2.isValidElement(children2) && children2.type !== "a" && children2.type !== "button") {
          return React2.cloneElement(children2, { key }, this.parse(children2.props.children));
        } else if (Array.isArray(children2)) {
          return children2.map(function(child, i) {
            return _this3.parse(child, i);
          });
        }
        return children2;
      }
    }, {
      key: "render",
      value: function render2() {
        return React2.createElement(
          React2.Fragment,
          null,
          this.parse(this.props.children)
        );
      }
    }]);
    return Linkify3;
  })(React2.Component);
  Linkify2.defaultProps = {
    componentDecorator: _defaultComponentDecorator2.default,
    hrefDecorator: _defaultHrefDecorator2.default,
    matchDecorator: _defaultMatchDecorator2.default,
    textDecorator: _defaultTextDecorator2.default
  };
  Linkify$1.default = Linkify2;
  return Linkify$1;
}
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  Object.defineProperty(dist, "__esModule", {
    value: true
  });
  var _Linkify = requireLinkify();
  var _Linkify2 = _interopRequireDefault(_Linkify);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  dist.default = _Linkify2.default;
  return dist;
}
var distExports = requireDist();
const Linkify = /* @__PURE__ */ getDefaultExportFromCjs(distExports);
var linkifyItExports = requireLinkifyIt();
const LinkifyIt = /* @__PURE__ */ getDefaultExportFromCjs(linkifyItExports);
const LinkifyText = ({ text: text2, placeholder, wrap = true, className, linkClassName }) => {
  const [linkify] = useState$1(new LinkifyIt());
  const content2 = useMemo$2(() => {
    return !text2 ? /* @__PURE__ */ jsx$1("span", { className: "color-secondary", children: placeholder }) : /* @__PURE__ */ jsx$1(
      Linkify,
      {
        matchDecorator: (text22) => linkify.match(text22),
        componentDecorator: (href, text22, key) => /* @__PURE__ */ jsx$1("a", { href, target: "_blank", className: linkClassName, children: text22 }, key),
        children: text2
      }
    );
  }, [text2, placeholder]);
  if (wrap === true)
    return /* @__PURE__ */ jsx$1("div", { className: combineClasses("pre-wrap", className), children: content2 });
  return /* @__PURE__ */ jsx$1(Fragment, { children: content2 });
};
class InfiniteScroll extends Component {
  constructor(props) {
    super(props);
    this.scrollListener = this.scrollListener.bind(this);
    this.eventListenerOptions = this.eventListenerOptions.bind(this);
    this.mousewheelListener = this.mousewheelListener.bind(this);
  }
  componentDidMount() {
    this.pageLoaded = this.props.pageStart;
    this.options = this.eventListenerOptions();
    this.attachScrollListener();
  }
  componentDidUpdate() {
    if (this.props.isReverse && this.loadMore) {
      const parentElement = this.getParentElement(this.scrollComponent);
      parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
      this.loadMore = false;
    }
    this.attachScrollListener();
  }
  componentWillUnmount() {
    this.detachScrollListener();
    this.detachMousewheelListener();
  }
  isPassiveSupported() {
    let passive = false;
    const testOptions = {
      get passive() {
        passive = true;
      }
    };
    try {
      document.addEventListener("test", null, testOptions);
      document.removeEventListener("test", null, testOptions);
    } catch (e) {
    }
    return passive;
  }
  eventListenerOptions() {
    let options = this.props.useCapture;
    if (this.isPassiveSupported()) {
      options = {
        useCapture: this.props.useCapture,
        passive: true
      };
    } else {
      options = {
        passive: false
      };
    }
    return options;
  }
  // Set a defaut loader for all your `InfiniteScroll` components
  setDefaultLoader(loader) {
    this.defaultLoader = loader;
  }
  detachMousewheelListener() {
    let scrollEl = window;
    if (this.props.useWindow === false) {
      scrollEl = this.scrollComponent.parentNode;
    }
    scrollEl.removeEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  detachScrollListener() {
    let scrollEl = window;
    if (this.props.useWindow === false) {
      scrollEl = this.getParentElement(this.scrollComponent);
    }
    scrollEl.removeEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
    scrollEl.removeEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  getParentElement(el) {
    const scrollParent = this.props.getScrollParent && this.props.getScrollParent();
    if (scrollParent != null) {
      return scrollParent;
    }
    return el && el.parentNode;
  }
  filterProps(props) {
    return props;
  }
  attachScrollListener() {
    const parentElement = this.getParentElement(this.scrollComponent);
    if (!this.props.hasMore || !parentElement) {
      return;
    }
    let scrollEl = window;
    if (this.props.useWindow === false) {
      scrollEl = parentElement;
    }
    scrollEl.addEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    );
    scrollEl.addEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
    scrollEl.addEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
    if (this.props.initialLoad) {
      this.scrollListener();
    }
  }
  mousewheelListener(e) {
    if (e.deltaY === 1 && !this.isPassiveSupported()) {
      e.preventDefault();
    }
  }
  scrollListener() {
    const el = this.scrollComponent;
    const scrollEl = window;
    const parentNode = this.getParentElement(el);
    let offset;
    if (this.props.useWindow) {
      const doc = document.documentElement || document.body.parentNode || document.body;
      const scrollTop = scrollEl.pageYOffset !== void 0 ? scrollEl.pageYOffset : doc.scrollTop;
      if (this.props.isReverse) {
        offset = scrollTop;
      } else {
        offset = this.calculateOffset(el, scrollTop);
      }
    } else if (this.props.isReverse) {
      offset = parentNode.scrollTop;
    } else {
      offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
    }
    if (offset < Number(this.props.threshold) && (el && el.offsetParent !== null)) {
      this.detachScrollListener();
      this.beforeScrollHeight = parentNode.scrollHeight;
      this.beforeScrollTop = parentNode.scrollTop;
      if (typeof this.props.loadMore === "function") {
        this.props.loadMore(this.pageLoaded += 1);
        this.loadMore = true;
      }
    }
  }
  calculateOffset(el, scrollTop) {
    if (!el) {
      return 0;
    }
    return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
  }
  calculateTopPosition(el) {
    if (!el) {
      return 0;
    }
    return el.offsetTop + this.calculateTopPosition(el.offsetParent);
  }
  render() {
    const renderProps = this.filterProps(this.props);
    const {
      children: children2,
      element,
      hasMore,
      initialLoad,
      isReverse,
      loader,
      loadMore,
      pageStart,
      ref: ref2,
      threshold,
      useCapture,
      useWindow,
      getScrollParent,
      ...props
    } = renderProps;
    props.ref = (node2) => {
      this.scrollComponent = node2;
      if (ref2) {
        ref2(node2);
      }
    };
    const childrenArray = [children2];
    if (hasMore) {
      if (loader) {
        isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
      } else if (this.defaultLoader) {
        isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
      }
    }
    return React__default.createElement(element, props, childrenArray);
  }
}
__publicField(InfiniteScroll, "propTypes", {
  children: PropTypes.node.isRequired,
  element: PropTypes.node,
  hasMore: PropTypes.bool,
  initialLoad: PropTypes.bool,
  isReverse: PropTypes.bool,
  loader: PropTypes.node,
  loadMore: PropTypes.func.isRequired,
  pageStart: PropTypes.number,
  ref: PropTypes.func,
  getScrollParent: PropTypes.func,
  threshold: PropTypes.number,
  useCapture: PropTypes.bool,
  useWindow: PropTypes.bool
});
__publicField(InfiniteScroll, "defaultProps", {
  element: "div",
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
});
const il = "_il_1o92x_1";
const il_scroller = "_il_scroller_1o92x_6";
const il_pagination = "_il_pagination_1o92x_13";
const il_item_highlight = "_il_item_highlight_1o92x_53";
const styles$K = {
  il,
  il_scroller,
  il_pagination,
  il_item_highlight
};
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$5(target, key, result);
  return result;
};
class InfinityListStoreFilter extends BaseFilter {
  constructor(filter2) {
    super();
    if (filter2) this.update(filter2);
  }
  update(changes) {
    for (const key in changes)
      if (changes.hasOwnProperty(key) && changes[key] !== void 0)
        this[key] = changes[key];
  }
}
class InfinityListStore2 {
  constructor(fetchItems) {
    this.fetchItems = fetchItems;
    this.fetching = false;
    this.items = [];
    this.filter = new InfinityListStoreFilter();
  }
  async fetch(reset = false) {
    this.fetching = true;
    try {
      const { items, filter: filter2 } = await this.fetchItems(this.filter.page, this.filter.take);
      runInAction(() => {
        this.filter = filter2;
        if (reset)
          this.items = items.slice();
        else
          this.items.push(...items);
        this.fetching = false;
      });
    } catch {
    }
  }
}
__decorateClass$5([
  observable
], InfinityListStore2.prototype, "fetching", 2);
__decorateClass$5([
  observable
], InfinityListStore2.prototype, "items", 2);
__decorateClass$5([
  observable
], InfinityListStore2.prototype, "filter", 2);
__decorateClass$5([
  action
], InfinityListStore2.prototype, "fetch", 1);
function _extends$5() {
  _extends$5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var ObserverMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new Map();
var rootId = 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(function(key) {
    return options[key] !== void 0;
  }).map(function(key) {
    return key + "_" + (key === "root" ? getRootId(options.root) : options[key]);
  }).toString();
}
function createObserver(options) {
  var id2 = optionsToId(options);
  var instance = ObserverMap.get(id2);
  if (!instance) {
    var elements = /* @__PURE__ */ new Map();
    var thresholds;
    var observer2 = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var _elements$get;
        var inView = entry.isIntersecting && thresholds.some(function(threshold) {
          return entry.intersectionRatio >= threshold;
        });
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function(callback) {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer2.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id2,
      observer: observer2,
      elements
    };
    ObserverMap.set(id2, instance);
  }
  return instance;
}
function observe$1(element, callback, options) {
  if (options === void 0) {
    options = {};
  }
  if (!element) return function() {
  };
  var _createObserver = createObserver(options), id2 = _createObserver.id, observer2 = _createObserver.observer, elements = _createObserver.elements;
  var callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer2.observe(element);
  return function unobserve2() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements["delete"](element);
      observer2.unobserve(element);
    }
    if (elements.size === 0) {
      observer2.disconnect();
      ObserverMap["delete"](id2);
    }
  };
}
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = /* @__PURE__ */ (function(_React$Component) {
  _inheritsLoose(InView2, _React$Component);
  function InView2(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;
    _this.handleNode = function(node2) {
      if (_this.node) {
        _this.unobserve();
        if (!node2 && !_this.props.triggerOnce && !_this.props.skip) {
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: void 0
          });
        }
      }
      _this.node = node2 ? node2 : null;
      _this.observeNode();
    };
    _this.handleChange = function(inView, entry) {
      if (inView && _this.props.triggerOnce) {
        _this.unobserve();
      }
      if (!isPlainChildren(_this.props)) {
        _this.setState({
          inView,
          entry
        });
      }
      if (_this.props.onChange) {
        _this.props.onChange(inView, entry);
      }
    };
    _this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
    return _this;
  }
  var _proto = InView2.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };
  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay;
    this._unobserveCb = observe$1(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    });
  };
  _proto.unobserve = function unobserve2() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  };
  _proto.render = function render2() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }
    var _this$props2 = this.props, children2 = _this$props2.children, as = _this$props2.as, tag = _this$props2.tag, props = _objectWithoutPropertiesLoose$3(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);
    return /* @__PURE__ */ createElement(as || tag || "div", _extends$5({
      ref: this.handleNode
    }, props), children2);
  };
  return InView2;
})(Component);
InView.displayName = "InView";
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$4(target, key, result);
  return result;
};
let InfinityList = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.itemsCache = /* @__PURE__ */ new Map();
    this.pageStart = this.props.pageStart || 1;
    this.lastFetchedPage = 0;
    this.store = new InfinityListStore2(this.props.fetch);
    this.currentPage = this.pageStart;
    this.lastVisibleIndex = 0;
    this.visibleIndecies = /* @__PURE__ */ new Set();
    if (props.pageSize)
      this.store.filter.update({ take: props.pageSize });
  }
  get loc() {
    return this.context.loc;
  }
  componentDidMount() {
    this.fetchPage(this.pageStart);
  }
  get trackItemVisibility() {
    return this.props.trackItemVisibility !== false;
  }
  get isScrolledToBottom() {
    return Math.abs(this.container.scrollHeight - this.container.scrollTop - this.container.clientHeight) <= 3;
  }
  get pageTotal() {
    return this.store.filter.pageTotal;
  }
  get items() {
    return this.store.items;
  }
  async goToPage(page, scrollToBottom = false) {
    if (page < 0 || page > this.store.filter.pageTotal)
      throw new Error("page is out of range");
    if (this.currentPage == page)
      return;
    await this.setPage(page);
    if (scrollToBottom)
      this.scrollToBottom();
  }
  async goToPosition(position2) {
    const page = this.calcPageByPosition(position2);
    await this.setPage(page);
    setTimeout(() => {
      const el = this.container.querySelector(`[data-position="${position2}"]`);
      if (el == null) return;
      this.container.scrollTo({ top: el.offsetTop, behavior: "smooth" });
      this._highlightItem(el);
    }, 50);
  }
  updateFilter(filter2) {
    this.store.filter.update(filter2);
  }
  scrollToBottom() {
    setTimeout(() => {
      this.container.scrollTo({ top: this.container.scrollHeight, behavior: "auto" });
    }, 50);
  }
  highlightItem(id2) {
    const el = this.container.querySelector(`[data-id="${id2}"]`);
    if (el == null) return;
    this._highlightItem(el);
  }
  pushItem(item2, forceScroll = false) {
    const needScrollToBottom = forceScroll == true || this.isScrolledToBottom;
    this.store.items.push(item2);
    const oldPageTotal = this.pageTotal;
    this.store.filter.update({ itemsTotal: this.store.filter.itemsTotal + 1 });
    if (this.pageTotal - oldPageTotal == 1)
      this.lastFetchedPage = this.pageTotal;
    if (needScrollToBottom)
      this.scrollToBottom();
  }
  tryRemoveItem(id2) {
    const i = this.store.items.findIndex((x) => x.id == id2);
    if (i > -1) {
      this.store.items.splice(i, 1);
      this.store.filter.update({ itemsTotal: this.store.filter.itemsTotal - 1 });
      return true;
    }
    return false;
  }
  tryFindItem(id2) {
    return this.store.items.find((x) => x.id == id2);
  }
  get offset() {
    return Math.max(0, this.pageStart - 1) * this.store.filter.take;
  }
  get hasMore() {
    return this.lastFetchedPage == 0 || this.pageTotal > this.lastFetchedPage;
  }
  calcCurrentPage() {
    const page = this.calcPageByPosition(this.lastVisibleIndex + 1);
    this.currentPage = Math.max(this.pageStart, page);
  }
  setChildVisibility(isVisible2, index2) {
    index2 = this.offset + index2;
    if (isVisible2) {
      this.visibleIndecies.add(index2);
    } else {
      this.visibleIndecies.delete(index2);
    }
    if (this.visibleIndecies.size == 0) return;
    const max2 = Math.max(...Array.from(this.visibleIndecies));
    if (max2 != this.lastVisibleIndex) {
      this.lastVisibleIndex = max2;
      this.calcCurrentPage();
    }
  }
  async fetchPage(page, reset = false) {
    if (!this.hasMore) return;
    if (page > this.lastFetchedPage)
      this.lastFetchedPage = page;
    this.store.filter.update({
      page
    });
    await this.store.fetch(reset);
    this.props.onPageFetched?.(page);
  }
  onPageChange(page, pageSize) {
    this.setPage(page);
  }
  async setPage(page) {
    this.visibleIndecies.clear();
    this.lastFetchedPage = 0;
    this.pageStart = page;
    await this.fetchPage(page, true);
    this.container.scrollTo({ top: 0, behavior: "auto" });
  }
  calcPageByPosition(position2) {
    return Math.ceil(position2 / this.store.filter.take);
  }
  getOrCreateItemCache(item2, isVisible2) {
    let itemCache = this.itemsCache.get(item2.id);
    if (itemCache == void 0 || this.trackItemVisibility && itemCache[0] != isVisible2) {
      itemCache = [isVisible2 ?? false, this.props.renderItem(item2, isVisible2 ?? false)];
      this.itemsCache.set(item2.id, itemCache);
      return itemCache[1];
    }
    return itemCache[1];
  }
  _highlightItem(el) {
    el.classList.add(styles$K.il_item_highlight);
    setTimeout(() => {
      el.classList.remove(styles$K.il_item_highlight);
    }, 2e3);
  }
  render() {
    const placeholder = this.props.placeholder?.();
    return /* @__PURE__ */ jsxs("div", { className: styles$K.il, children: [
      this.props.pagination != false && this.store.filter.pageTotal > 1 ? /* @__PURE__ */ jsx$1("div", { className: styles$K.il_pagination, children: /* @__PURE__ */ jsx$1(
        Pagination,
        {
          size: "small",
          total: this.store.filter.itemsTotal,
          current: this.currentPage,
          pageSize: this.store.filter.take,
          showSizeChanger: false,
          onChange: (page, pageSize) => this.onPageChange(page, pageSize)
        }
      ) }) : null,
      /* @__PURE__ */ jsx$1(
        "div",
        {
          style: { height: this.props.height || "100%" },
          className: styles$K.il_scroller,
          ref: (ref2) => this.container = ref2,
          children: /* @__PURE__ */ jsxs(
            InfiniteScroll,
            {
              pageStart: this.pageStart,
              initialLoad: false,
              loadMore: () => this.fetchPage(this.lastFetchedPage + 1),
              hasMore: this.hasMore,
              loader: void 0,
              useWindow: this.props.useWindow || false,
              children: [
                this.store.items.length == 0 && !this.store.fetching ? /* @__PURE__ */ jsx$1(Fragment, { children: placeholder }) : null,
                this.store.items.map((x, index2) => (
                  // @ts-expect-error
                  /* @__PURE__ */ jsx$1(
                    InView,
                    {
                      root: this.container,
                      threshold: 0.1,
                      onChange: (visible) => this.setChildVisibility(visible, index2),
                      children: ({ inView }) => {
                        const item2 = this.getOrCreateItemCache(x, inView);
                        return /* @__PURE__ */ jsx$1("div", { "data-id": x.id, "data-position": index2 + this.offset + 1, children: item2 });
                      }
                    },
                    x.id
                  )
                ))
              ]
            }
          )
        }
      )
    ] });
  }
};
InfinityList.contextType = Context$3;
__decorateClass$4([
  observable
], InfinityList.prototype, "pageStart", 2);
__decorateClass$4([
  observable
], InfinityList.prototype, "lastFetchedPage", 2);
__decorateClass$4([
  observable
], InfinityList.prototype, "store", 2);
__decorateClass$4([
  action
], InfinityList.prototype, "pushItem", 1);
__decorateClass$4([
  action
], InfinityList.prototype, "tryRemoveItem", 1);
__decorateClass$4([
  action
], InfinityList.prototype, "tryFindItem", 1);
__decorateClass$4([
  computed
], InfinityList.prototype, "offset", 1);
__decorateClass$4([
  computed
], InfinityList.prototype, "hasMore", 1);
__decorateClass$4([
  observable
], InfinityList.prototype, "currentPage", 2);
__decorateClass$4([
  action
], InfinityList.prototype, "calcCurrentPage", 1);
__decorateClass$4([
  observable
], InfinityList.prototype, "lastVisibleIndex", 2);
__decorateClass$4([
  observable
], InfinityList.prototype, "visibleIndecies", 2);
__decorateClass$4([
  action
], InfinityList.prototype, "setChildVisibility", 1);
__decorateClass$4([
  action
], InfinityList.prototype, "fetchPage", 1);
__decorateClass$4([
  action
], InfinityList.prototype, "onPageChange", 1);
__decorateClass$4([
  action
], InfinityList.prototype, "setPage", 1);
InfinityList = __decorateClass$4([
  observer
], InfinityList);
const StringTemplate = ({ template, ...props }) => {
  const matchAll = useCallback((template2, regex2) => {
    let match2;
    const matches2 = [];
    do {
      match2 = regex2.exec(template2);
      if (match2) {
        matches2.push(match2);
      }
    } while (match2);
    return matches2;
  }, []);
  const matches = useMemo$2(() => Array.from(matchAll(template, /{(\d+)}/g)), [template]);
  if (matches.length > 0) {
    const args = props.args ?? React__default.Children.toArray(props.children);
    if (args == null || args.length == 0) {
      console.error(`StringTemplate '${template}' invalid args: required ${matches.length}, actual ${args?.length ?? 0}`);
      return /* @__PURE__ */ jsx$1("span", { children: template });
    }
    const nodes = [];
    let lastIndex = 0;
    for (let i = 0; i < matches.length; i++) {
      const match2 = matches[i];
      const argIndex = parseInt(match2[1]);
      nodes.push(template.substring(lastIndex, match2.index));
      nodes.push(args[argIndex]);
      lastIndex = match2.index + 3;
    }
    nodes.push(template.substr(lastIndex));
    return /* @__PURE__ */ jsx$1("span", { className: props.className, children: nodes.map((x, i) => /* @__PURE__ */ jsx$1("span", { children: x }, i)) });
  }
  return /* @__PURE__ */ jsx$1("span", { className: props.className, children: template });
};
const rate = "_rate_541b3_1";
const rate_step = "_rate_step_541b3_5";
const styles$J = {
  rate,
  rate_step,
  "break": "_break_541b3_75"
};
const RateStep = ({ text: text2, value, selected: selected2, breakLine, onClick: onClick2 }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      "div",
      {
        className: styles$J.rate_step,
        "data-rating": value,
        "data-selected": selected2,
        onClick: () => onClick2(value),
        children: text2
      }
    ),
    breakLine && /* @__PURE__ */ jsx$1("div", { className: styles$J.break })
  ] });
};
const Rate = ({ defaultRating, rating, disabled = false, size: size2 = "default", onClick: onClick2, onChange: onChange5, className }) => {
  const ctx = useContext(Context$3);
  const deviceSize = ctx.deviceStore;
  const getSteps = () => {
    let i = 1;
    return Array.from(Array(10), () => i++);
  };
  const [steps] = useState$1(getSteps());
  const [_rating, setRating] = useState$1(defaultRating ?? rating);
  useEffect(() => {
    setRating(rating);
  }, [rating]);
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$J.rate, className), "data-disabled": disabled, "data-size": size2, children: steps.map((x) => /* @__PURE__ */ jsx$1(
    RateStep,
    {
      value: x,
      text: x,
      selected: _rating == x,
      breakLine: x == 5 && deviceSize.deviceSize == "mobile",
      onClick: () => {
        onClick2?.(x);
        onChange5?.(x);
      }
    },
    x
  )) });
};
observer(Rate);
var input = {};
var interopRequireDefault = { exports: {} };
var hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  if (hasRequiredInteropRequireDefault) return interopRequireDefault.exports;
  hasRequiredInteropRequireDefault = 1;
  (function(module2) {
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    module2.exports = _interopRequireDefault, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(interopRequireDefault);
  return interopRequireDefault.exports;
}
var Group = {};
var interopRequireWildcard = { exports: {} };
var _typeof$2 = { exports: {} };
var hasRequired_typeof;
function require_typeof() {
  if (hasRequired_typeof) return _typeof$2.exports;
  hasRequired_typeof = 1;
  (function(module2) {
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(o);
    }
    module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(_typeof$2);
  return _typeof$2.exports;
}
var hasRequiredInteropRequireWildcard;
function requireInteropRequireWildcard() {
  if (hasRequiredInteropRequireWildcard) return interopRequireWildcard.exports;
  hasRequiredInteropRequireWildcard = 1;
  (function(module2) {
    var _typeof2 = require_typeof()["default"];
    function _interopRequireWildcard(e, t) {
      if ("function" == typeof WeakMap) var r2 = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
      return (module2.exports = _interopRequireWildcard = function _interopRequireWildcard2(e2, t2) {
        if (!t2 && e2 && e2.__esModule) return e2;
        var o, i, f = {
          __proto__: null,
          "default": e2
        };
        if (null === e2 || "object" != _typeof2(e2) && "function" != typeof e2) return f;
        if (o = t2 ? n : r2) {
          if (o.has(e2)) return o.get(e2);
          o.set(e2, f);
        }
        for (var _t in e2) "default" !== _t && {}.hasOwnProperty.call(e2, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e2, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e2[_t]);
        return f;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports)(e, t);
    }
    module2.exports = _interopRequireWildcard, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(interopRequireWildcard);
  return interopRequireWildcard.exports;
}
var warning$4 = {};
var warning$3 = {};
var hasRequiredWarning$1;
function requireWarning$1() {
  if (hasRequiredWarning$1) return warning$3;
  hasRequiredWarning$1 = 1;
  Object.defineProperty(warning$3, "__esModule", {
    value: true
  });
  warning$3.call = call2;
  warning$3.default = void 0;
  warning$3.note = note2;
  warning$3.noteOnce = noteOnce2;
  warning$3.preMessage = void 0;
  warning$3.resetWarned = resetWarned2;
  warning$3.warning = warning3;
  warning$3.warningOnce = warningOnce2;
  var warned2 = {};
  var preWarningFns2 = [];
  var preMessage3 = warning$3.preMessage = function preMessage4(fn) {
    preWarningFns2.push(fn);
  };
  function warning3(valid, message2) {
    if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
      var finalMessage = preWarningFns2.reduce(function(msg, preMessageFn) {
        return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
      }, message2);
      if (finalMessage) {
        console.error("Warning: ".concat(finalMessage));
      }
    }
  }
  function note2(valid, message2) {
    if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
      var finalMessage = preWarningFns2.reduce(function(msg, preMessageFn) {
        return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
      }, message2);
      if (finalMessage) {
        console.warn("Note: ".concat(finalMessage));
      }
    }
  }
  function resetWarned2() {
    warned2 = {};
  }
  function call2(method4, valid, message2) {
    if (!valid && !warned2[message2]) {
      method4(false, message2);
      warned2[message2] = true;
    }
  }
  function warningOnce2(valid, message2) {
    call2(warning3, valid, message2);
  }
  function noteOnce2(valid, message2) {
    call2(note2, valid, message2);
  }
  warningOnce2.preMessage = preMessage3;
  warningOnce2.resetWarned = resetWarned2;
  warningOnce2.noteOnce = noteOnce2;
  warning$3.default = warningOnce2;
  return warning$3;
}
var hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning$4;
  hasRequiredWarning = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(warning$4, "__esModule", {
    value: true
  });
  warning$4.devUseWarning = warning$4.default = warning$4.WarningContext = void 0;
  warning$4.noop = noop4;
  warning$4.resetWarned = resetWarned2;
  var React2 = _interopRequireWildcard(React__default);
  var _warning = _interopRequireWildcard(requireWarning$1());
  function noop4() {
  }
  let deprecatedWarnList = null;
  function resetWarned2() {
    deprecatedWarnList = null;
    (0, _warning.resetWarned)();
  }
  let warning3 = noop4;
  if (process.env.NODE_ENV !== "production") {
    warning3 = (valid, component, message2) => {
      (0, _warning.default)(valid, `[antd: ${component}] ${message2}`);
      if (process.env.NODE_ENV === "test") {
        resetWarned2();
      }
    };
  }
  const WarningContext = warning$4.WarningContext = /* @__PURE__ */ React2.createContext({});
  warning$4.devUseWarning = process.env.NODE_ENV !== "production" ? (component) => {
    const {
      strict
    } = React2.useContext(WarningContext);
    const typeWarning = (valid, type4, message2) => {
      if (!valid) {
        if (strict === false && type4 === "deprecated") {
          const existWarning = deprecatedWarnList;
          if (!deprecatedWarnList) {
            deprecatedWarnList = {};
          }
          deprecatedWarnList[component] = deprecatedWarnList[component] || [];
          if (!deprecatedWarnList[component].includes(message2 || "")) {
            deprecatedWarnList[component].push(message2 || "");
          }
          if (!existWarning) {
            console.warn("[antd] There exists deprecated usage in your code:", deprecatedWarnList);
          }
        } else {
          process.env.NODE_ENV !== "production" ? warning3(valid, component, message2) : void 0;
        }
      }
    };
    typeWarning.deprecated = (valid, oldProp, newProp, message2) => {
      typeWarning(valid, "deprecated", `\`${oldProp}\` is deprecated. Please use \`${newProp}\` instead.${message2 ? ` ${message2}` : ""}`);
    };
    return typeWarning;
  } : () => {
    const noopWarning = () => {
    };
    noopWarning.deprecated = noop4;
    return noopWarning;
  };
  warning$4.default = warning3;
  return warning$4;
}
var configProvider = {};
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function ownKeys$f(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$f(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$f(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
function canUseDom$1() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function contains$1(root, n) {
  if (!root) {
    return false;
  }
  if (root.contains) {
    return root.contains(n);
  }
  var node2 = n;
  while (node2) {
    if (node2 === root) {
      return true;
    }
    node2 = node2.parentNode;
  }
  return false;
}
var APPEND_ORDER = "data-rc-order";
var APPEND_PRIORITY = "data-rc-priority";
var MARK_KEY = "rc-util-key";
var containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === "queue") {
    return "prependQueue";
  }
  return prepend ? "prepend" : "append";
}
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function(node2) {
    return node2.tagName === "STYLE";
  });
}
function injectCSS(css2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom$1()) {
    return null;
  }
  var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === "prependQueue";
  var styleNode = document.createElement("style");
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    if (isPrependQueue) {
      var existStyle = (option.styles || findStyles(container)).filter(function(node2) {
        if (!["prepend", "prependQueue"].includes(node2.getAttribute(APPEND_ORDER))) {
          return false;
        }
        var nodePriority = Number(node2.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer(option);
  return (option.styles || findStyles(container)).find(function(node2) {
    return node2.getAttribute(getMark(option)) === key;
  });
}
function removeCSS(key) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var existNode = findExistNode(key, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);
  if (!cachedRealContainer || !contains$1(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS("", option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css2, key) {
  var originOption = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var container = getContainer(originOption);
  var styles2 = findStyles(container);
  var option = _objectSpread2$1(_objectSpread2$1({}, originOption), {}, {
    styles: styles2
  });
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function useMemo$1(getValue3, condition, shouldUpdate) {
  var cacheRef = React.useRef({});
  if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue3();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage2(fn) {
  preWarningFns.push(fn);
};
function warning$2(valid, message2) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
    }, message2);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}
function note(valid, message2) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
    }, message2);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method4, valid, message2) {
  if (!valid && !warned[message2]) {
    method4(false, message2);
    warned[message2] = true;
  }
}
function warningOnce(valid, message2) {
  call(warning$2, valid, message2);
}
function noteOnce(valid, message2) {
  call(note, valid, message2);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
function isEqual$1(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var refSet = /* @__PURE__ */ new Set();
  function deepEqual2(a, b) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var circular = refSet.has(a);
    warningOnce(!circular, "Warning: There may be circular references");
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual2(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && _typeof$3(a) === "object" && _typeof$3(b) === "object") {
      var keys2 = Object.keys(a);
      if (keys2.length !== Object.keys(b).length) {
        return false;
      }
      return keys2.every(function(key) {
        return deepEqual2(a[key], b[key], newLevel);
      });
    }
    return false;
  }
  return deepEqual2(obj1, obj2);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
var SPLIT$1 = "%";
function pathKey(keys2) {
  return keys2.join(SPLIT$1);
}
var Entity2 = /* @__PURE__ */ (function() {
  function Entity3(instanceId) {
    _classCallCheck$1(this, Entity3);
    _defineProperty(this, "instanceId", void 0);
    _defineProperty(this, "cache", /* @__PURE__ */ new Map());
    _defineProperty(this, "extracted", /* @__PURE__ */ new Set());
    this.instanceId = instanceId;
  }
  _createClass$1(Entity3, [{
    key: "get",
    value: function get4(keys2) {
      return this.opGet(pathKey(keys2));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function opGet(keyPathStr) {
      return this.cache.get(keyPathStr) || null;
    }
  }, {
    key: "update",
    value: function update2(keys2, valueFn) {
      return this.opUpdate(pathKey(keys2), valueFn);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function opUpdate(keyPathStr, valueFn) {
      var prevValue = this.cache.get(keyPathStr);
      var nextValue = valueFn(prevValue);
      if (nextValue === null) {
        this.cache.delete(keyPathStr);
      } else {
        this.cache.set(keyPathStr, nextValue);
      }
    }
  }]);
  return Entity3;
})();
var _excluded$f = ["children"];
var ATTR_TOKEN = "data-token-hash";
var ATTR_MARK = "data-css-hash";
var ATTR_CACHE_PATH = "data-cache-path";
var CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache2() {
  var cssinjsInstanceId = Math.random().toString(12).slice(2);
  if (typeof document !== "undefined" && document.head && document.body) {
    var styles2 = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [];
    var firstChild = document.head.firstChild;
    Array.from(styles2).forEach(function(style2) {
      style2[CSS_IN_JS_INSTANCE] = style2[CSS_IN_JS_INSTANCE] || cssinjsInstanceId;
      if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
        document.head.insertBefore(style2, firstChild);
      }
    });
    var styleHash = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(style2) {
      var hash2 = style2.getAttribute(ATTR_MARK);
      if (styleHash[hash2]) {
        if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
          var _style$parentNode;
          (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
        }
      } else {
        styleHash[hash2] = true;
      }
    });
  }
  return new Entity2(cssinjsInstanceId);
}
var StyleContext = /* @__PURE__ */ React.createContext({
  hashPriority: "low",
  cache: createCache2(),
  defaultCache: true
});
var StyleProvider = function StyleProvider2(props) {
  var children2 = props.children, restProps = _objectWithoutProperties$1(props, _excluded$f);
  var parentContext = React.useContext(StyleContext);
  var context2 = useMemo$1(function() {
    var mergedContext = _objectSpread2({}, parentContext);
    Object.keys(restProps).forEach(function(key) {
      var value = restProps[key];
      if (restProps[key] !== void 0) {
        mergedContext[key] = value;
      }
    });
    var cache2 = restProps.cache;
    mergedContext.cache = mergedContext.cache || createCache2();
    mergedContext.defaultCache = !cache2 && parentContext.defaultCache;
    return mergedContext;
  }, [parentContext, restProps], function(prev4, next4) {
    return !isEqual$1(prev4[0], next4[0], true) || !isEqual$1(prev4[1], next4[1], true);
  });
  return /* @__PURE__ */ React.createElement(StyleContext.Provider, {
    value: context2
  }, children2);
};
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _possibleConstructorReturn$1(self2, call2) {
  if (call2 && (_typeof$1(call2) === "object" || typeof call2 === "function")) {
    return call2;
  }
  return _assertThisInitialized$2(self2);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$g();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
var AbstractCalculator$1 = /* @__PURE__ */ _createClass$1(function AbstractCalculator() {
  _classCallCheck$1(this, AbstractCalculator);
});
var CALC_UNIT$1 = "CALC_UNIT";
var regexp$2 = new RegExp(CALC_UNIT$1, "g");
function unit$2(value) {
  if (typeof value === "number") {
    return "".concat(value).concat(CALC_UNIT$1);
  }
  return value;
}
var CSSCalculator$1 = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits$1(CSSCalculator2, _AbstractCalculator);
  var _super = _createSuper$1(CSSCalculator2);
  function CSSCalculator2(num, unitlessCssVar) {
    var _this;
    _classCallCheck$1(this, CSSCalculator2);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized$2(_this), "result", "");
    _defineProperty(_assertThisInitialized$2(_this), "unitlessCssVar", void 0);
    _defineProperty(_assertThisInitialized$2(_this), "lowPriority", void 0);
    var numType = _typeof$1(num);
    _this.unitlessCssVar = unitlessCssVar;
    if (num instanceof CSSCalculator2) {
      _this.result = "(".concat(num.result, ")");
    } else if (numType === "number") {
      _this.result = unit$2(num);
    } else if (numType === "string") {
      _this.result = num;
    }
    return _this;
  }
  _createClass$1(CSSCalculator2, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " + ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " + ").concat(unit$2(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " - ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " - ").concat(unit$2(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " * ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " * ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " / ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " / ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      var _this2 = this;
      var _ref = options || {}, cssUnit = _ref.unit;
      var mergedUnit = true;
      if (typeof cssUnit === "boolean") {
        mergedUnit = cssUnit;
      } else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
        return _this2.result.includes(cssVar);
      })) {
        mergedUnit = false;
      }
      this.result = this.result.replace(regexp$2, mergedUnit ? "px" : "");
      if (typeof this.lowPriority !== "undefined") {
        return "calc(".concat(this.result, ")");
      }
      return this.result;
    }
  }]);
  return CSSCalculator2;
})(AbstractCalculator$1);
var NumCalculator$1 = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits$1(NumCalculator2, _AbstractCalculator);
  var _super = _createSuper$1(NumCalculator2);
  function NumCalculator2(num) {
    var _this;
    _classCallCheck$1(this, NumCalculator2);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized$2(_this), "result", 0);
    if (num instanceof NumCalculator2) {
      _this.result = num.result;
    } else if (typeof num === "number") {
      _this.result = num;
    }
    return _this;
  }
  _createClass$1(NumCalculator2, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof NumCalculator2) {
        this.result += num.result;
      } else if (typeof num === "number") {
        this.result += num;
      }
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof NumCalculator2) {
        this.result -= num.result;
      } else if (typeof num === "number") {
        this.result -= num;
      }
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (num instanceof NumCalculator2) {
        this.result *= num.result;
      } else if (typeof num === "number") {
        this.result *= num;
      }
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (num instanceof NumCalculator2) {
        this.result /= num.result;
      } else if (typeof num === "number") {
        this.result /= num;
      }
      return this;
    }
  }, {
    key: "equal",
    value: function equal() {
      return this.result;
    }
  }]);
  return NumCalculator2;
})(AbstractCalculator$1);
var genCalc$1 = function genCalc(type4, unitlessCssVar) {
  var Calculator = type4 === "css" ? CSSCalculator$1 : NumCalculator$1;
  return function(num) {
    return new Calculator(num, unitlessCssVar);
  };
};
function sameDerivativeOption(left2, right2) {
  if (left2.length !== right2.length) {
    return false;
  }
  for (var i = 0; i < left2.length; i++) {
    if (left2[i] !== right2[i]) {
      return false;
    }
  }
  return true;
}
var ThemeCache = /* @__PURE__ */ (function() {
  function ThemeCache2() {
    _classCallCheck$1(this, ThemeCache2);
    _defineProperty(this, "cache", void 0);
    _defineProperty(this, "keys", void 0);
    _defineProperty(this, "cacheCallTimes", void 0);
    this.cache = /* @__PURE__ */ new Map();
    this.keys = [];
    this.cacheCallTimes = 0;
  }
  _createClass$1(ThemeCache2, [{
    key: "size",
    value: function size2() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function internalGet(derivativeOption) {
      var _cache2, _cache3;
      var updateCallTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var cache2 = {
        map: this.cache
      };
      derivativeOption.forEach(function(derivative) {
        if (!cache2) {
          cache2 = void 0;
        } else {
          var _cache;
          cache2 = (_cache = cache2) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
        }
      });
      if ((_cache2 = cache2) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) {
        cache2.value[1] = this.cacheCallTimes++;
      }
      return (_cache3 = cache2) === null || _cache3 === void 0 ? void 0 : _cache3.value;
    }
  }, {
    key: "get",
    value: function get4(derivativeOption) {
      var _this$internalGet;
      return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
    }
  }, {
    key: "has",
    value: function has2(derivativeOption) {
      return !!this.internalGet(derivativeOption);
    }
  }, {
    key: "set",
    value: function set2(derivativeOption, value) {
      var _this = this;
      if (!this.has(derivativeOption)) {
        if (this.size() + 1 > ThemeCache2.MAX_CACHE_SIZE + ThemeCache2.MAX_CACHE_OFFSET) {
          var _this$keys$reduce = this.keys.reduce(function(result, key) {
            var _result = _slicedToArray$1(result, 2), callTimes = _result[1];
            if (_this.internalGet(key)[1] < callTimes) {
              return [key, _this.internalGet(key)[1]];
            }
            return result;
          }, [this.keys[0], this.cacheCallTimes]), _this$keys$reduce2 = _slicedToArray$1(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
          this.delete(targetKey);
        }
        this.keys.push(derivativeOption);
      }
      var cache2 = this.cache;
      derivativeOption.forEach(function(derivative, index2) {
        if (index2 === derivativeOption.length - 1) {
          cache2.set(derivative, {
            value: [value, _this.cacheCallTimes++]
          });
        } else {
          var cacheValue = cache2.get(derivative);
          if (!cacheValue) {
            cache2.set(derivative, {
              map: /* @__PURE__ */ new Map()
            });
          } else if (!cacheValue.map) {
            cacheValue.map = /* @__PURE__ */ new Map();
          }
          cache2 = cache2.get(derivative).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function deleteByPath(currentCache, derivatives) {
      var cache2 = currentCache.get(derivatives[0]);
      if (derivatives.length === 1) {
        var _cache$value;
        if (!cache2.map) {
          currentCache.delete(derivatives[0]);
        } else {
          currentCache.set(derivatives[0], {
            map: cache2.map
          });
        }
        return (_cache$value = cache2.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
      }
      var result = this.deleteByPath(cache2.map, derivatives.slice(1));
      if ((!cache2.map || cache2.map.size === 0) && !cache2.value) {
        currentCache.delete(derivatives[0]);
      }
      return result;
    }
  }, {
    key: "delete",
    value: function _delete2(derivativeOption) {
      if (this.has(derivativeOption)) {
        this.keys = this.keys.filter(function(item2) {
          return !sameDerivativeOption(item2, derivativeOption);
        });
        return this.deleteByPath(this.cache, derivativeOption);
      }
      return void 0;
    }
  }]);
  return ThemeCache2;
})();
_defineProperty(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty(ThemeCache, "MAX_CACHE_OFFSET", 5);
var uuid = 0;
var Theme = /* @__PURE__ */ (function() {
  function Theme2(derivatives) {
    _classCallCheck$1(this, Theme2);
    _defineProperty(this, "derivatives", void 0);
    _defineProperty(this, "id", void 0);
    this.derivatives = Array.isArray(derivatives) ? derivatives : [derivatives];
    this.id = uuid;
    if (derivatives.length === 0) {
      warning$2(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
    }
    uuid += 1;
  }
  _createClass$1(Theme2, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token2) {
      return this.derivatives.reduce(function(result, derivative) {
        return derivative(token2, result);
      }, void 0);
    }
  }]);
  return Theme2;
})();
var cacheThemes = new ThemeCache();
function createTheme(derivatives) {
  var derivativeArr = Array.isArray(derivatives) ? derivatives : [derivatives];
  if (!cacheThemes.has(derivativeArr)) {
    cacheThemes.set(derivativeArr, new Theme(derivativeArr));
  }
  return cacheThemes.get(derivativeArr);
}
var resultCache = /* @__PURE__ */ new WeakMap();
var RESULT_VALUE = {};
function memoResult(callback, deps) {
  var current = resultCache;
  for (var i = 0; i < deps.length; i += 1) {
    var dep = deps[i];
    if (!current.has(dep)) {
      current.set(dep, /* @__PURE__ */ new WeakMap());
    }
    current = current.get(dep);
  }
  if (!current.has(RESULT_VALUE)) {
    current.set(RESULT_VALUE, callback());
  }
  return current.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(token2) {
  var str = flattenTokenCache.get(token2) || "";
  if (!str) {
    Object.keys(token2).forEach(function(key) {
      var value = token2[key];
      str += key;
      if (value instanceof Theme) {
        str += value.id;
      } else if (value && _typeof$1(value) === "object") {
        str += flattenToken(value);
      } else {
        str += value;
      }
    });
    str = murmur2(str);
    flattenTokenCache.set(token2, str);
  }
  return str;
}
function token2key(token2, salt) {
  return murmur2("".concat(salt, "_").concat(flattenToken(token2)));
}
var randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
var checkContent = "_bAmBoO_";
function supportSelector(styleStr, handleElement, supportCheck) {
  if (canUseDom$1()) {
    var _getComputedStyle$con, _ele$parentNode;
    updateCSS(styleStr, randomSelectorKey);
    var _ele = document.createElement("div");
    _ele.style.position = "fixed";
    _ele.style.left = "0";
    _ele.style.top = "0";
    handleElement === null || handleElement === void 0 || handleElement(_ele);
    document.body.appendChild(_ele);
    if (process.env.NODE_ENV !== "production") {
      _ele.innerHTML = "Test";
      _ele.style.zIndex = "9999999";
    }
    var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes(checkContent);
    (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
    removeCSS(randomSelectorKey);
    return support;
  }
  return false;
}
var canWhere = void 0;
function supportWhere() {
  if (canWhere === void 0) {
    canWhere = supportSelector(":where(.".concat(randomSelectorKey, ') { content: "').concat(checkContent, '"!important; }'), function(ele) {
      ele.className = randomSelectorKey;
    });
  }
  return canWhere;
}
var canLogic = void 0;
function supportLogicProps() {
  if (canLogic === void 0) {
    canLogic = supportSelector(".".concat(randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
      ele.className = randomSelectorKey;
    }, function(ele) {
      return getComputedStyle(ele).bottom === "93px";
    });
  }
  return canLogic;
}
var isClientSide = canUseDom$1();
function unit$1(num) {
  if (typeof num === "number") {
    return "".concat(num, "px");
  }
  return num;
}
function toStyleStr(style2, tokenKey, styleId) {
  var customizeAttrs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var plain = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  if (plain) {
    return style2;
  }
  var attrs = _objectSpread2(_objectSpread2({}, customizeAttrs), {}, _defineProperty(_defineProperty({}, ATTR_TOKEN, tokenKey), ATTR_MARK, styleId));
  var attrStr = Object.keys(attrs).map(function(attr) {
    var val = attrs[attr];
    return val ? "".concat(attr, '="').concat(val, '"') : null;
  }).filter(function(v) {
    return v;
  }).join(" ");
  return "<style ".concat(attrStr, ">").concat(style2, "</style>");
}
var token2CSSVar = function token2CSSVar2(token2) {
  var prefix2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(prefix2 ? "".concat(prefix2, "-") : "").concat(token2).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var serializeCSSVar = function serializeCSSVar2(cssVars, hashId, options) {
  if (!Object.keys(cssVars).length) {
    return "";
  }
  return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2), key = _ref2[0], value = _ref2[1];
    return "".concat(key, ":").concat(value, ";");
  }).join(""), "}");
};
var transformToken = function transformToken2(token2, themeKey, config2) {
  var cssVars = {};
  var result = {};
  Object.entries(token2).forEach(function(_ref3) {
    var _config$preserve, _config$ignore;
    var _ref4 = _slicedToArray$1(_ref3, 2), key = _ref4[0], value = _ref4[1];
    if (config2 !== null && config2 !== void 0 && (_config$preserve = config2.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) {
      result[key] = value;
    } else if ((typeof value === "string" || typeof value === "number") && !(config2 !== null && config2 !== void 0 && (_config$ignore = config2.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
      var _config$unitless;
      var cssVar = token2CSSVar(key, config2 === null || config2 === void 0 ? void 0 : config2.prefix);
      cssVars[cssVar] = typeof value === "number" && !(config2 !== null && config2 !== void 0 && (_config$unitless = config2.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
      result[key] = "var(".concat(cssVar, ")");
    }
  });
  return [result, serializeCSSVar(cssVars, themeKey, {
    scope: config2 === null || config2 === void 0 ? void 0 : config2.scope
  })];
};
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom$1() ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect$1 = function useLayoutEffect(callback, deps) {
  var firstMountRef = React.useRef(true);
  useInternalLayoutEffect(function() {
    return callback(firstMountRef.current);
  }, deps);
  useInternalLayoutEffect(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect2(callback, deps) {
  useLayoutEffect$1(function(firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
var fullClone$1 = _objectSpread2({}, React);
var useInsertionEffect$1 = fullClone$1.useInsertionEffect;
var useInsertionEffectPolyfill = function useInsertionEffectPolyfill2(renderEffect, effect, deps) {
  React.useMemo(renderEffect, deps);
  useLayoutEffect$1(function() {
    return effect(true);
  }, deps);
};
var useCompatibleInsertionEffect = useInsertionEffect$1 ? function(renderEffect, effect, deps) {
  return useInsertionEffect$1(function() {
    renderEffect();
    return effect();
  }, deps);
} : useInsertionEffectPolyfill;
var fullClone = _objectSpread2({}, React);
var useInsertionEffect = fullClone.useInsertionEffect;
var useCleanupRegister = function useCleanupRegister2(deps) {
  var effectCleanups = [];
  var cleanupFlag = false;
  function register3(fn) {
    if (cleanupFlag) {
      if (process.env.NODE_ENV !== "production") {
        warning$2(false, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      }
      return;
    }
    effectCleanups.push(fn);
  }
  React.useEffect(function() {
    cleanupFlag = false;
    return function() {
      cleanupFlag = true;
      if (effectCleanups.length) {
        effectCleanups.forEach(function(fn) {
          return fn();
        });
      }
    };
  }, deps);
  return register3;
};
var useRun = function useRun2() {
  return function(fn) {
    fn();
  };
};
var useEffectCleanupRegister = typeof useInsertionEffect !== "undefined" ? useCleanupRegister : useRun;
function useProdHMR() {
  return false;
}
var webpackHMR = false;
function useDevHMR() {
  return webpackHMR;
}
const useHMR = process.env.NODE_ENV === "production" ? useProdHMR : useDevHMR;
if (process.env.NODE_ENV !== "production" && typeof module !== "undefined" && module && module.hot && typeof window !== "undefined") {
  var win$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : null;
  if (win$1 && typeof win$1.webpackHotUpdate === "function") {
    var originWebpackHotUpdate = win$1.webpackHotUpdate;
    win$1.webpackHotUpdate = function() {
      webpackHMR = true;
      setTimeout(function() {
        webpackHMR = false;
      }, 0);
      return originWebpackHotUpdate.apply(void 0, arguments);
    };
  }
}
function useGlobalCache(prefix2, keyPath, cacheFn, onCacheRemove, onCacheEffect) {
  var _React$useContext = React.useContext(StyleContext), globalCache = _React$useContext.cache;
  var fullPath = [prefix2].concat(_toConsumableArray$1(keyPath));
  var fullPathStr = pathKey(fullPath);
  var register3 = useEffectCleanupRegister([fullPathStr]);
  var HMRUpdate = useHMR();
  var buildCache = function buildCache2(updater) {
    globalCache.opUpdate(fullPathStr, function(prevCache) {
      var _ref = prevCache || [void 0, void 0], _ref2 = _slicedToArray$1(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache2 = _ref2[1];
      var tmpCache = cache2;
      if (process.env.NODE_ENV !== "production" && cache2 && HMRUpdate) {
        onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(tmpCache, HMRUpdate);
        tmpCache = null;
      }
      var mergedCache = tmpCache || cacheFn();
      var data2 = [times, mergedCache];
      return updater ? updater(data2) : data2;
    });
  };
  React.useMemo(
    function() {
      buildCache();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [fullPathStr]
    /* eslint-enable */
  );
  var cacheEntity = globalCache.opGet(fullPathStr);
  if (process.env.NODE_ENV !== "production" && !cacheEntity) {
    buildCache();
    cacheEntity = globalCache.opGet(fullPathStr);
  }
  var cacheContent = cacheEntity[1];
  useCompatibleInsertionEffect(function() {
    onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
  }, function(polyfill2) {
    buildCache(function(_ref3) {
      var _ref4 = _slicedToArray$1(_ref3, 2), times = _ref4[0], cache2 = _ref4[1];
      if (polyfill2 && times === 0) {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
      }
      return [times + 1, cache2];
    });
    return function() {
      globalCache.opUpdate(fullPathStr, function(prevCache) {
        var _ref5 = prevCache || [], _ref6 = _slicedToArray$1(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache2 = _ref6[1];
        var nextCount = times - 1;
        if (nextCount === 0) {
          register3(function() {
            if (polyfill2 || !globalCache.opGet(fullPathStr)) {
              onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache2, false);
            }
          });
          return null;
        }
        return [times - 1, cache2];
      });
    };
  }, [fullPathStr]);
  return cacheContent;
}
var EMPTY_OVERRIDE = {};
var hashPrefix = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css";
var tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(tokenKey) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) + 1);
}
function removeStyleTags(key, instanceId) {
  if (typeof document !== "undefined") {
    var styles2 = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(key, '"]'));
    styles2.forEach(function(style2) {
      if (style2[CSS_IN_JS_INSTANCE] === instanceId) {
        var _style$parentNode;
        (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(tokenKey, instanceId) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) - 1);
  var cleanableKeyList = /* @__PURE__ */ new Set();
  tokenKeys.forEach(function(value, key) {
    if (value <= 0) cleanableKeyList.add(key);
  });
  if (tokenKeys.size - cleanableKeyList.size > TOKEN_THRESHOLD) {
    cleanableKeyList.forEach(function(key) {
      removeStyleTags(key, instanceId);
      tokenKeys.delete(key);
    });
  }
}
var getComputedToken = function getComputedToken2(originToken, overrideToken, theme2, format2) {
  var derivativeToken = theme2.getDerivativeToken(originToken);
  var mergedDerivativeToken = _objectSpread2(_objectSpread2({}, derivativeToken), overrideToken);
  if (format2) {
    mergedDerivativeToken = format2(mergedDerivativeToken);
  }
  return mergedDerivativeToken;
};
var TOKEN_PREFIX = "token";
function useCacheToken(theme2, tokens) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _useContext = useContext(StyleContext), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
  var mergedToken = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray$1(tokens)));
  }, tokens);
  var tokenStr = flattenToken(mergedToken);
  var overrideTokenStr = flattenToken(override);
  var cssVarStr = cssVar ? flattenToken(cssVar) : "";
  var cachedToken = useGlobalCache(TOKEN_PREFIX, [salt, theme2.id, tokenStr, overrideTokenStr, cssVarStr], function() {
    var _cssVar$key;
    var mergedDerivativeToken = compute ? compute(mergedToken, override, theme2) : getComputedToken(mergedToken, override, theme2, formatToken);
    var actualToken = _objectSpread2({}, mergedDerivativeToken);
    var cssVarsStr = "";
    if (!!cssVar) {
      var _transformToken = transformToken(mergedDerivativeToken, cssVar.key, {
        prefix: cssVar.prefix,
        ignore: cssVar.ignore,
        unitless: cssVar.unitless,
        preserve: cssVar.preserve
      });
      var _transformToken2 = _slicedToArray$1(_transformToken, 2);
      mergedDerivativeToken = _transformToken2[0];
      cssVarsStr = _transformToken2[1];
    }
    var tokenKey = token2key(mergedDerivativeToken, salt);
    mergedDerivativeToken._tokenKey = tokenKey;
    actualToken._tokenKey = token2key(actualToken, salt);
    var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
    mergedDerivativeToken._themeKey = themeKey;
    recordCleanToken(themeKey);
    var hashId = "".concat(hashPrefix, "-").concat(murmur2(tokenKey));
    mergedDerivativeToken._hashId = hashId;
    return [mergedDerivativeToken, hashId, actualToken, cssVarsStr, (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""];
  }, function(cache2) {
    cleanTokenStyle(cache2[0]._themeKey, instanceId);
  }, function(_ref) {
    var _ref2 = _slicedToArray$1(_ref, 4), token2 = _ref2[0], cssVarsStr = _ref2[3];
    if (cssVar && cssVarsStr) {
      var style2 = updateCSS(cssVarsStr, murmur2("css-variables-".concat(token2._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: container,
        priority: -999
      });
      style2[CSS_IN_JS_INSTANCE] = instanceId;
      style2.setAttribute(ATTR_TOKEN, token2._themeKey);
    }
  });
  return cachedToken;
}
var extract$2 = function extract(cache2, effectStyles, options) {
  var _cache = _slicedToArray$1(cache2, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
  var _ref3 = options || {}, plain = _ref3.plain;
  if (!styleStr) {
    return null;
  }
  var styleId = realToken._tokenKey;
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
function _extends$4() {
  _extends$4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var NAMESPACE$1 = "@namespace";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
function trim(value) {
  return value.trim();
}
function replace(value, pattern4, replacement) {
  return value.replace(pattern4, replacement);
}
function indexof(value, search3, position2) {
  return value.indexOf(search3, position2);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array4) {
  return array4.push(value), value;
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type4, props, children2, length2, siblings) {
  return { value, root, parent, type: type4, props, children: children2, line, column, length: length2, return: "", siblings };
}
function char() {
  return character;
}
function prev3() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next3() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret$1() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token$2(type4) {
  switch (type4) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type4) {
  return trim(slice(position - 1, delimiter(type4 === 91 ? type4 + 2 : type4 === 40 ? type4 + 1 : type4)));
}
function whitespace$1(type4) {
  while (character = peek())
    if (character < 33)
      next3();
    else
      break;
  return token$2(type4) > 2 || token$2(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next3())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret$1() + (count < 6 && peek() == 32 && next3() == 32));
}
function delimiter(type4) {
  while (next3())
    switch (character) {
      // ] ) " '
      case type4:
        return position;
      // " '
      case 34:
      case 39:
        if (type4 !== 34 && type4 !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type4 === 41)
          delimiter(type4);
        break;
      // \
      case 92:
        next3();
        break;
    }
  return position;
}
function commenter(type4, index2) {
  while (next3())
    if (type4 + character === 47 + 10)
      break;
    else if (type4 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type4 === 47 ? type4 : next3());
}
function identifier(index2) {
  while (!token$2(peek()))
    next3();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules2, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type4 = "";
  var props = rules2;
  var children2 = rulesets;
  var reference = rule;
  var characters2 = type4;
  while (scanning)
    switch (previous = character2, character2 = next3()) {
      // (
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f", abs(index2 ? points[index2 - 1] : 0)) != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace$1(previous);
        break;
      // \
      case 92:
        characters2 += escaping(caret$1() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next3(), caret$1()), root, parent, declarations), declarations);
            if ((token$2(previous || 1) == 5 || token$2(peek() || 1) == 5) && strlen(characters2) && substr(characters2, -1, void 0) !== " ") characters2 += " ";
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && (strlen(characters2) - length2 || variable === 0 && previous === 47))
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1, declarations) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2, declarations), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference = ruleset(characters2, root, parent, index2, offset, rules2, points, type4, props = [], children2 = [], length2, rulesets), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children2);
              else {
                switch (atrule) {
                  // c(ontainer)
                  case 99:
                    if (charat(characters2, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (charat(characters2, 2) === 97) break;
                  default:
                    offset = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                if (offset) parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules2, points, type4, rules2, props = [], length2, children2), children2), rules2, children2, length2, points, rule ? props : children2);
                else parse(characters2, reference, reference, reference, [""], children2, 0, points, children2);
              }
        }
        index2 = offset = property = 0, variable = ampersand = 1, type4 = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev3() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next3());
            atrule = peek(), offset = length2 = strlen(type4 = characters2 += identifier(caret$1())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset, rules2, points, type4, props, children2, length2, siblings) {
  var post = offset - 1;
  var rule = offset === 0 ? rules2 : [""];
  var size2 = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index2; ++i)
    for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size2; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type4, props, children2, length2, siblings);
}
function comment(value, root, parent, siblings) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings);
}
function declaration(value, root, parent, length2, siblings) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2, siblings);
}
function serialize$1(children2, callback) {
  var output = "";
  for (var i = 0; i < children2.length; i++)
    output += callback(children2[i], i, children2, callback) || "";
  return output;
}
function stringify$1(element, index2, children2, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case NAMESPACE$1:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize$1(element.children, callback) + "}";
    case RULESET:
      if (!strlen(element.value = element.props.join(","))) return "";
  }
  return strlen(children2 = serialize$1(element.children, callback)) ? element.return = element.value + "{" + children2 + "}" : "";
}
function lintWarning(message2, info) {
  var path2 = info.path, parentSelectors = info.parentSelectors;
  warningOnce(false, "[Ant Design CSS-in-JS] ".concat(path2 ? "Error in ".concat(path2, ": ") : "").concat(message2).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}
var linter$5 = function linter(key, value, info) {
  if (key === "content") {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ["normal", "none", "initial", "inherit", "unset"];
    if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
      lintWarning("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
  }
};
var linter$4 = function linter2(key, value, info) {
  if (key === "animation") {
    if (info.hashId && value !== "none") {
      lintWarning("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
  }
};
function isConcatSelector(selector) {
  var _selector$match;
  var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || "";
  var splitCells2 = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
    return str;
  });
  return splitCells2.length > 1;
}
function parsePath$1(info) {
  return info.parentSelectors.reduce(function(prev4, cur) {
    if (!prev4) {
      return cur;
    }
    return cur.includes("&") ? cur.replace(/&/g, prev4) : "".concat(prev4, " ").concat(cur);
  }, "");
}
var linter$3 = function linter3(key, value, info) {
  var parentSelectorPath = parsePath$1(info);
  var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
  if (notList.length > 0 && notList.some(isConcatSelector)) {
    lintWarning("Concat ':not' selector not support in legacy browsers.", info);
  }
};
var linter$2 = function linter4(key, value, info) {
  switch (key) {
    case "marginLeft":
    case "marginRight":
    case "paddingLeft":
    case "paddingRight":
    case "left":
    case "right":
    case "borderLeft":
    case "borderLeftWidth":
    case "borderLeftStyle":
    case "borderLeftColor":
    case "borderRight":
    case "borderRightWidth":
    case "borderRightStyle":
    case "borderRightColor":
    case "borderTopLeftRadius":
    case "borderTopRightRadius":
    case "borderBottomLeftRadius":
    case "borderBottomRightRadius":
      lintWarning("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
      return;
    case "margin":
    case "padding":
    case "borderWidth":
    case "borderStyle":
      if (typeof value === "string") {
        var valueArr = value.split(" ").map(function(item2) {
          return item2.trim();
        });
        if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) {
          lintWarning("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
        }
      }
      return;
    case "clear":
    case "textAlign":
      if (value === "left" || value === "right") {
        lintWarning("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
      }
      return;
    case "borderRadius":
      if (typeof value === "string") {
        var radiusGroups = value.split("/").map(function(item2) {
          return item2.trim();
        });
        var invalid = radiusGroups.reduce(function(result, group2) {
          if (result) {
            return result;
          }
          var radiusArr = group2.split(" ").map(function(item2) {
            return item2.trim();
          });
          if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) {
            return true;
          }
          if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) {
            return true;
          }
          if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) {
            return true;
          }
          return result;
        }, false);
        if (invalid) {
          lintWarning("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
        }
      }
      return;
  }
};
var linter$1 = function linter5(key, value, info) {
  if (typeof value === "string" && /NaN/g.test(value) || Number.isNaN(value)) {
    lintWarning("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
  }
};
var linter6 = function linter7(key, value, info) {
  if (info.parentSelectors.some(function(selector) {
    var selectors = selector.split(",");
    return selectors.some(function(item2) {
      return item2.split("&").length > 2;
    });
  })) {
    lintWarning("Should not use more than one `&` in a selector.", info);
  }
};
var ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path";
var CSS_FILE_STYLE = "_FILE_STYLE__";
function serialize(cachePathMap2) {
  return Object.keys(cachePathMap2).map(function(path2) {
    var hash2 = cachePathMap2[path2];
    return "".concat(path2, ":").concat(hash2);
  }).join(";");
}
var cachePathMap;
var fromCSSFile = true;
function prepare() {
  if (!cachePathMap) {
    cachePathMap = {};
    if (canUseDom$1()) {
      var div = document.createElement("div");
      div.className = ATTR_CACHE_MAP;
      div.style.position = "fixed";
      div.style.visibility = "hidden";
      div.style.top = "-9999px";
      document.body.appendChild(div);
      var content2 = getComputedStyle(div).content || "";
      content2 = content2.replace(/^"/, "").replace(/"$/, "");
      content2.split(";").forEach(function(item2) {
        var _item$split = item2.split(":"), _item$split2 = _slicedToArray$1(_item$split, 2), path2 = _item$split2[0], hash2 = _item$split2[1];
        cachePathMap[path2] = hash2;
      });
      var inlineMapStyle = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
      if (inlineMapStyle) {
        var _inlineMapStyle$paren;
        fromCSSFile = false;
        (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
      }
      document.body.removeChild(div);
    }
  }
}
function existPath(path2) {
  prepare();
  return !!cachePathMap[path2];
}
function getStyleAndHash(path2) {
  var hash2 = cachePathMap[path2];
  var styleStr = null;
  if (hash2 && canUseDom$1()) {
    if (fromCSSFile) {
      styleStr = CSS_FILE_STYLE;
    } else {
      var _style = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[path2], '"]'));
      if (_style) {
        styleStr = _style.innerHTML;
      } else {
        delete cachePathMap[path2];
      }
    }
  }
  return [styleStr, hash2];
}
var SKIP_CHECK = "_skip_check_";
var MULTI_VALUE = "_multi_value_";
function normalizeStyle(styleStr) {
  var serialized = serialize$1(compile(styleStr), stringify$1);
  return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(value) {
  return _typeof$1(value) === "object" && value && (SKIP_CHECK in value || MULTI_VALUE in value);
}
function injectSelectorHash(key, hashId, hashPriority) {
  if (!hashId) {
    return key;
  }
  var hashClassName = ".".concat(hashId);
  var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
  var keys2 = key.split(",").map(function(k) {
    var _firstPath$match;
    var fullPath = k.trim().split(/\s+/);
    var firstPath = fullPath[0] || "";
    var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
    firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
    return [firstPath].concat(_toConsumableArray$1(fullPath.slice(1))).join(" ");
  });
  return keys2.join(",");
}
var parseStyle = function parseStyle2(interpolation) {
  var config2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: true,
    parentSelectors: []
  }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
  var hashId = config2.hashId, layer = config2.layer, path2 = config2.path, hashPriority = config2.hashPriority, _config$transformers = config2.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config2.linters, linters = _config$linters === void 0 ? [] : _config$linters;
  var styleStr = "";
  var effectStyle = {};
  function parseKeyframes(keyframes) {
    var animationName = keyframes.getName(hashId);
    if (!effectStyle[animationName]) {
      var _parseStyle = parseStyle2(keyframes.style, config2, {
        root: false,
        parentSelectors
      }), _parseStyle2 = _slicedToArray$1(_parseStyle, 1), _parsedStr = _parseStyle2[0];
      effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
    }
  }
  function flattenList(list) {
    var fullList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    list.forEach(function(item2) {
      if (Array.isArray(item2)) {
        flattenList(item2, fullList);
      } else if (item2) {
        fullList.push(item2);
      }
    });
    return fullList;
  }
  var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [interpolation]);
  flattenStyleList.forEach(function(originStyle) {
    var style2 = typeof originStyle === "string" && !root ? {} : originStyle;
    if (typeof style2 === "string") {
      styleStr += "".concat(style2, "\n");
    } else if (style2._keyframe) {
      parseKeyframes(style2);
    } else {
      var mergedStyle = transformers.reduce(function(prev4, trans) {
        var _trans$visit;
        return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev4)) || prev4;
      }, style2);
      Object.keys(mergedStyle).forEach(function(key) {
        var value = mergedStyle[key];
        if (_typeof$1(value) === "object" && value && (key !== "animationName" || !value._keyframe) && !isCompoundCSSProperty(value)) {
          var subInjectHash = false;
          var mergedKey = key.trim();
          var nextRoot = false;
          if ((root || injectHash) && hashId) {
            if (mergedKey.startsWith("@")) {
              subInjectHash = true;
            } else if (mergedKey === "&") {
              mergedKey = injectSelectorHash("", hashId, hashPriority);
            } else {
              mergedKey = injectSelectorHash(key, hashId, hashPriority);
            }
          } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
            mergedKey = "";
            nextRoot = true;
          }
          var _parseStyle3 = parseStyle2(value, config2, {
            root: nextRoot,
            injectHash: subInjectHash,
            parentSelectors: [].concat(_toConsumableArray$1(parentSelectors), [mergedKey])
          }), _parseStyle4 = _slicedToArray$1(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
          effectStyle = _objectSpread2(_objectSpread2({}, effectStyle), childEffectStyle);
          styleStr += "".concat(mergedKey).concat(_parsedStr2);
        } else {
          let appendStyle = function(cssKey, cssValue) {
            if (process.env.NODE_ENV !== "production" && (_typeof$1(value) !== "object" || !(value !== null && value !== void 0 && value[SKIP_CHECK]))) {
              [linter$5, linter$4].concat(_toConsumableArray$1(linters)).forEach(function(linter8) {
                return linter8(cssKey, cssValue, {
                  path: path2,
                  hashId,
                  parentSelectors
                });
              });
            }
            var styleName = cssKey.replace(/[A-Z]/g, function(match2) {
              return "-".concat(match2.toLowerCase());
            });
            var formatValue = cssValue;
            if (!unitlessKeys[cssKey] && typeof formatValue === "number" && formatValue !== 0) {
              formatValue = "".concat(formatValue, "px");
            }
            if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
              parseKeyframes(cssValue);
              formatValue = cssValue.getName(hashId);
            }
            styleStr += "".concat(styleName, ":").concat(formatValue, ";");
          };
          var _value;
          var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
          if (_typeof$1(value) === "object" && value !== null && value !== void 0 && value[MULTI_VALUE] && Array.isArray(actualValue)) {
            actualValue.forEach(function(item2) {
              appendStyle(key, item2);
            });
          } else {
            appendStyle(key, actualValue);
          }
        }
      });
    }
  });
  if (!root) {
    styleStr = "{".concat(styleStr, "}");
  } else if (layer) {
    if (styleStr) {
      styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
    }
    if (layer.dependencies) {
      effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
        return "@layer ".concat(deps, ", ").concat(layer.name, ";");
      }).join("\n");
    }
  }
  return [styleStr, effectStyle];
};
function uniqueHash(path2, styleStr) {
  return murmur2("".concat(path2.join("%")).concat(styleStr));
}
function Empty() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(info, styleFn) {
  var token2 = info.token, path2 = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
  var _React$useContext = React.useContext(StyleContext), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache2 = _React$useContext.cache, enableLayer = _React$useContext.layer;
  var tokenKey = token2._tokenKey;
  var fullPath = [tokenKey];
  if (enableLayer) {
    fullPath.push("layer");
  }
  fullPath.push.apply(fullPath, _toConsumableArray$1(path2));
  var isMergedClientSide = isClientSide;
  if (process.env.NODE_ENV !== "production" && mock !== void 0) {
    isMergedClientSide = mock === "client";
  }
  var _useGlobalCache = useGlobalCache(
    STYLE_PREFIX,
    fullPath,
    // Create cache if needed
    function() {
      var cachePath = fullPath.join("|");
      if (existPath(cachePath)) {
        var _getStyleAndHash = getStyleAndHash(cachePath), _getStyleAndHash2 = _slicedToArray$1(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
        if (inlineCacheStyleStr) {
          return [inlineCacheStyleStr, tokenKey, styleHash, {}, clientOnly, order];
        }
      }
      var styleObj = styleFn();
      var _parseStyle5 = parseStyle(styleObj, {
        hashId,
        hashPriority,
        layer: enableLayer ? layer : void 0,
        path: path2.join("-"),
        transformers,
        linters
      }), _parseStyle6 = _slicedToArray$1(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
      var styleStr = normalizeStyle(parsedStyle);
      var styleId = uniqueHash(fullPath, styleStr);
      return [styleStr, tokenKey, styleId, effectStyle, clientOnly, order];
    },
    // Remove cache if no need
    function(_ref2, fromHMR) {
      var _ref3 = _slicedToArray$1(_ref2, 3), styleId = _ref3[2];
      if ((fromHMR || autoClear) && isClientSide) {
        removeCSS(styleId, {
          mark: ATTR_MARK,
          attachTo: container
        });
      }
    },
    // Effect: Inject style here
    function(_ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 4), styleStr = _ref5[0];
      _ref5[1];
      var styleId = _ref5[2], effectStyle = _ref5[3];
      if (isMergedClientSide && styleStr !== CSS_FILE_STYLE) {
        var mergedCSSConfig = {
          mark: ATTR_MARK,
          prepend: enableLayer ? false : "queue",
          attachTo: container,
          priority: order
        };
        var nonceStr = typeof nonce === "function" ? nonce() : nonce;
        if (nonceStr) {
          mergedCSSConfig.csp = {
            nonce: nonceStr
          };
        }
        var effectLayerKeys = [];
        var effectRestKeys = [];
        Object.keys(effectStyle).forEach(function(key) {
          if (key.startsWith("@layer")) {
            effectLayerKeys.push(key);
          } else {
            effectRestKeys.push(key);
          }
        });
        effectLayerKeys.forEach(function(effectKey) {
          updateCSS(normalizeStyle(effectStyle[effectKey]), "_layer-".concat(effectKey), _objectSpread2(_objectSpread2({}, mergedCSSConfig), {}, {
            prepend: true
          }));
        });
        var style2 = updateCSS(styleStr, styleId, mergedCSSConfig);
        style2[CSS_IN_JS_INSTANCE] = cache2.instanceId;
        style2.setAttribute(ATTR_TOKEN, tokenKey);
        if (process.env.NODE_ENV !== "production") {
          style2.setAttribute(ATTR_CACHE_PATH, fullPath.join("|"));
        }
        effectRestKeys.forEach(function(effectKey) {
          updateCSS(normalizeStyle(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
        });
      }
    }
  ), _useGlobalCache2 = _slicedToArray$1(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
  return function(node2) {
    var styleNode;
    if (!ssrInline || isMergedClientSide || !defaultCache) {
      styleNode = /* @__PURE__ */ React.createElement(Empty, null);
    } else {
      styleNode = /* @__PURE__ */ React.createElement("style", _extends$4({}, _defineProperty(_defineProperty({}, ATTR_TOKEN, cachedTokenKey), ATTR_MARK, cachedStyleId), {
        dangerouslySetInnerHTML: {
          __html: cachedStyleStr
        }
      }));
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, styleNode, node2);
  };
}
var extract$1 = function extract2(cache2, effectStyles, options) {
  var _cache = _slicedToArray$1(cache2, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
  var _ref7 = options || {}, plain = _ref7.plain;
  if (clientOnly) {
    return null;
  }
  var keyStyleText = styleStr;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  keyStyleText = toStyleStr(styleStr, tokenKey, styleId, sharedAttrs, plain);
  if (effectStyle) {
    Object.keys(effectStyle).forEach(function(effectKey) {
      if (!effectStyles[effectKey]) {
        effectStyles[effectKey] = true;
        var effectStyleStr = normalizeStyle(effectStyle[effectKey]);
        var effectStyleHTML = toStyleStr(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
        if (effectKey.startsWith("@layer")) {
          keyStyleText = effectStyleHTML + keyStyleText;
        } else {
          keyStyleText += effectStyleHTML;
        }
      }
    });
  }
  return [order, styleId, keyStyleText];
};
var CSS_VAR_PREFIX = "cssVar";
var useCSSVarRegister = function useCSSVarRegister2(config2, fn) {
  var key = config2.key, prefix2 = config2.prefix, unitless = config2.unitless, ignore = config2.ignore, token2 = config2.token, _config$scope = config2.scope, scope = _config$scope === void 0 ? "" : _config$scope;
  var _useContext = useContext(StyleContext), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var tokenKey = token2._tokenKey;
  var stylePath = [].concat(_toConsumableArray$1(config2.path), [key, scope, tokenKey]);
  var cache2 = useGlobalCache(CSS_VAR_PREFIX, stylePath, function() {
    var originToken = fn();
    var _transformToken = transformToken(originToken, key, {
      prefix: prefix2,
      unitless,
      ignore,
      scope
    }), _transformToken2 = _slicedToArray$1(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
    var styleId = uniqueHash(stylePath, cssVarsStr);
    return [mergedToken, cssVarsStr, styleId, key];
  }, function(_ref) {
    var _ref2 = _slicedToArray$1(_ref, 3), styleId = _ref2[2];
    if (isClientSide) {
      removeCSS(styleId, {
        mark: ATTR_MARK,
        attachTo: container
      });
    }
  }, function(_ref3) {
    var _ref4 = _slicedToArray$1(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
    if (!cssVarsStr) {
      return;
    }
    var style2 = updateCSS(cssVarsStr, styleId, {
      mark: ATTR_MARK,
      prepend: "queue",
      attachTo: container,
      priority: -999
    });
    style2[CSS_IN_JS_INSTANCE] = instanceId;
    style2.setAttribute(ATTR_TOKEN, key);
  });
  return cache2;
};
var extract3 = function extract4(cache2, effectStyles, options) {
  var _cache = _slicedToArray$1(cache2, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
  var _ref5 = options || {}, plain = _ref5.plain;
  if (!styleStr) {
    return null;
  }
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
var ExtractStyleFns = _defineProperty(_defineProperty(_defineProperty({}, STYLE_PREFIX, extract$1), TOKEN_PREFIX, extract$2), CSS_VAR_PREFIX, extract3);
function isNotNull(value) {
  return value !== null;
}
function extractStyle(cache2, options) {
  var _ref = typeof options === "boolean" ? {
    plain: options
  } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types2 = _ref$types === void 0 ? ["style", "token", "cssVar"] : _ref$types, _ref$once = _ref.once, once2 = _ref$once === void 0 ? false : _ref$once;
  var matchPrefixRegexp = new RegExp("^(".concat((typeof types2 === "string" ? [types2] : types2).join("|"), ")%"));
  var styleKeys = Array.from(cache2.cache.keys()).filter(function(key) {
    return matchPrefixRegexp.test(key);
  });
  var effectStyles = {};
  var cachePathMap2 = {};
  var styleText = "";
  styleKeys.map(function(key) {
    if (once2 && cache2.extracted.has(key)) {
      return null;
    }
    var cachePath = key.replace(matchPrefixRegexp, "").replace(/%/g, "|");
    var _key$split = key.split("%"), _key$split2 = _slicedToArray$1(_key$split, 1), prefix2 = _key$split2[0];
    var extractFn = ExtractStyleFns[prefix2];
    var extractedStyle = extractFn(cache2.cache.get(key)[1], effectStyles, {
      plain
    });
    if (!extractedStyle) {
      return null;
    }
    var _extractedStyle = _slicedToArray$1(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
    if (key.startsWith("style")) {
      cachePathMap2[cachePath] = styleId;
    }
    cache2.extracted.add(key);
    return [order, styleStr];
  }).filter(isNotNull).sort(function(_ref2, _ref3) {
    var _ref4 = _slicedToArray$1(_ref2, 1), o1 = _ref4[0];
    var _ref5 = _slicedToArray$1(_ref3, 1), o2 = _ref5[0];
    return o1 - o2;
  }).forEach(function(_ref6) {
    var _ref7 = _slicedToArray$1(_ref6, 2), style2 = _ref7[1];
    styleText += style2;
  });
  styleText += toStyleStr(".".concat(ATTR_CACHE_MAP, '{content:"').concat(serialize(cachePathMap2), '";}'), void 0, void 0, _defineProperty({}, ATTR_CACHE_MAP, ATTR_CACHE_MAP), plain);
  return styleText;
}
var Keyframe = /* @__PURE__ */ (function() {
  function Keyframe2(name, style2) {
    _classCallCheck$1(this, Keyframe2);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "style", void 0);
    _defineProperty(this, "_keyframe", true);
    this.name = name;
    this.style = style2;
  }
  _createClass$1(Keyframe2, [{
    key: "getName",
    value: function getName() {
      var hashId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
    }
  }]);
  return Keyframe2;
})();
function splitValues(value) {
  if (typeof value === "number") {
    return [[value], false];
  }
  var rawStyle = String(value).trim();
  var importantCells = rawStyle.match(/(.*)(!important)/);
  var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
  var temp = [];
  var brackets = 0;
  return [splitStyle.reduce(function(list, item2) {
    if (item2.includes("(") || item2.includes(")")) {
      var left2 = item2.split("(").length - 1;
      var right2 = item2.split(")").length - 1;
      brackets += left2 - right2;
    }
    if (brackets >= 0) temp.push(item2);
    if (brackets === 0) {
      list.push(temp.join(" "));
      temp = [];
    }
    return list;
  }, []), !!importantCells];
}
function noSplit(list) {
  list.notSplit = true;
  return list;
}
var keyMap = {
  // Inset
  inset: ["top", "right", "bottom", "left"],
  insetBlock: ["top", "bottom"],
  insetBlockStart: ["top"],
  insetBlockEnd: ["bottom"],
  insetInline: ["left", "right"],
  insetInlineStart: ["left"],
  insetInlineEnd: ["right"],
  // Margin
  marginBlock: ["marginTop", "marginBottom"],
  marginBlockStart: ["marginTop"],
  marginBlockEnd: ["marginBottom"],
  marginInline: ["marginLeft", "marginRight"],
  marginInlineStart: ["marginLeft"],
  marginInlineEnd: ["marginRight"],
  // Padding
  paddingBlock: ["paddingTop", "paddingBottom"],
  paddingBlockStart: ["paddingTop"],
  paddingBlockEnd: ["paddingBottom"],
  paddingInline: ["paddingLeft", "paddingRight"],
  paddingInlineStart: ["paddingLeft"],
  paddingInlineEnd: ["paddingRight"],
  // Border
  borderBlock: noSplit(["borderTop", "borderBottom"]),
  borderBlockStart: noSplit(["borderTop"]),
  borderBlockEnd: noSplit(["borderBottom"]),
  borderInline: noSplit(["borderLeft", "borderRight"]),
  borderInlineStart: noSplit(["borderLeft"]),
  borderInlineEnd: noSplit(["borderRight"]),
  // Border width
  borderBlockWidth: ["borderTopWidth", "borderBottomWidth"],
  borderBlockStartWidth: ["borderTopWidth"],
  borderBlockEndWidth: ["borderBottomWidth"],
  borderInlineWidth: ["borderLeftWidth", "borderRightWidth"],
  borderInlineStartWidth: ["borderLeftWidth"],
  borderInlineEndWidth: ["borderRightWidth"],
  // Border style
  borderBlockStyle: ["borderTopStyle", "borderBottomStyle"],
  borderBlockStartStyle: ["borderTopStyle"],
  borderBlockEndStyle: ["borderBottomStyle"],
  borderInlineStyle: ["borderLeftStyle", "borderRightStyle"],
  borderInlineStartStyle: ["borderLeftStyle"],
  borderInlineEndStyle: ["borderRightStyle"],
  // Border color
  borderBlockColor: ["borderTopColor", "borderBottomColor"],
  borderBlockStartColor: ["borderTopColor"],
  borderBlockEndColor: ["borderBottomColor"],
  borderInlineColor: ["borderLeftColor", "borderRightColor"],
  borderInlineStartColor: ["borderLeftColor"],
  borderInlineEndColor: ["borderRightColor"],
  // Border radius
  borderStartStartRadius: ["borderTopLeftRadius"],
  borderStartEndRadius: ["borderTopRightRadius"],
  borderEndStartRadius: ["borderBottomLeftRadius"],
  borderEndEndRadius: ["borderBottomRightRadius"]
};
function wrapImportantAndSkipCheck(value, important) {
  var parsedValue = value;
  if (important) {
    parsedValue = "".concat(parsedValue, " !important");
  }
  return {
    _skip_check_: true,
    value: parsedValue
  };
}
var transform$1 = {
  visit: function visit(cssObj) {
    var clone = {};
    Object.keys(cssObj).forEach(function(key) {
      var value = cssObj[key];
      var matchValue = keyMap[key];
      if (matchValue && (typeof value === "number" || typeof value === "string")) {
        var _splitValues = splitValues(value), _splitValues2 = _slicedToArray$1(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
        if (matchValue.length && matchValue.notSplit) {
          matchValue.forEach(function(matchKey) {
            clone[matchKey] = wrapImportantAndSkipCheck(value, _important);
          });
        } else if (matchValue.length === 1) {
          clone[matchValue[0]] = wrapImportantAndSkipCheck(_values[0], _important);
        } else if (matchValue.length === 2) {
          matchValue.forEach(function(matchKey, index2) {
            var _values$index;
            clone[matchKey] = wrapImportantAndSkipCheck((_values$index = _values[index2]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
          });
        } else if (matchValue.length === 4) {
          matchValue.forEach(function(matchKey, index2) {
            var _ref, _values$index2;
            clone[matchKey] = wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index2]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index2 - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
          });
        } else {
          clone[key] = value;
        }
      } else {
        clone[key] = value;
      }
    });
    return clone;
  }
};
var pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function toFixed(number4, precision) {
  var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number4 * multiplier);
  return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var transform = function transform2() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
  var pxReplace = function pxReplace2(m, $1) {
    if (!$1) return m;
    var pixels = parseFloat($1);
    if (pixels <= 1) return m;
    var fixedVal = toFixed(pixels / rootValue, precision);
    return "".concat(fixedVal, "rem");
  };
  var visit2 = function visit3(cssObj) {
    var clone = _objectSpread2({}, cssObj);
    Object.entries(cssObj).forEach(function(_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2), key = _ref2[0], value = _ref2[1];
      if (typeof value === "string" && value.includes("px")) {
        var newValue = value.replace(pxRegex, pxReplace);
        clone[key] = newValue;
      }
      if (!unitlessKeys[key] && typeof value === "number" && value !== 0) {
        clone[key] = "".concat(value, "px").replace(pxRegex, pxReplace);
      }
      var mergedKey = key.trim();
      if (mergedKey.startsWith("@") && mergedKey.includes("px") && mediaQuery) {
        var newKey = key.replace(pxRegex, pxReplace);
        clone[newKey] = clone[key];
        delete clone[key];
      }
    });
    return clone;
  };
  return {
    visit: visit2
  };
};
var _experimental = {
  supportModernCSS: function supportModernCSS() {
    return supportWhere() && supportLogicProps();
  }
};
const es$9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Keyframes: Keyframe,
  NaNLinter: linter$1,
  StyleContext,
  StyleProvider,
  Theme,
  _experimental,
  createCache: createCache2,
  createTheme,
  extractStyle,
  genCalc: genCalc$1,
  getComputedToken,
  legacyLogicalPropertiesTransformer: transform$1,
  legacyNotSelectorLinter: linter$3,
  logicalPropertiesLinter: linter$2,
  parentSelectorLinter: linter6,
  px2remTransformer: transform,
  token2CSSVar,
  unit: unit$1,
  useCSSVarRegister,
  useCacheToken,
  useStyleRegister
}, Symbol.toStringTag, { value: "Module" }));
const require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(es$9);
var Context$2 = {};
var hasRequiredContext$4;
function requireContext$4() {
  if (hasRequiredContext$4) return Context$2;
  hasRequiredContext$4 = 1;
  Object.defineProperty(Context$2, "__esModule", {
    value: true
  });
  Context$2.default = void 0;
  var _react = React__default;
  var IconContext2 = /* @__PURE__ */ (0, _react.createContext)({});
  Context$2.default = IconContext2;
  return Context$2;
}
var useMemo = {};
var hasRequiredUseMemo;
function requireUseMemo() {
  if (hasRequiredUseMemo) return useMemo;
  hasRequiredUseMemo = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useMemo, "__esModule", {
    value: true
  });
  useMemo.default = useMemo$12;
  var React2 = _interopRequireWildcard(React__default);
  function useMemo$12(getValue3, condition, shouldUpdate) {
    var cacheRef = React2.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
      cacheRef.current.value = getValue3();
      cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
  }
  return useMemo;
}
var set$2 = {};
var objectSpread2 = { exports: {} };
var defineProperty = { exports: {} };
var toPropertyKey = { exports: {} };
var toPrimitive = { exports: {} };
var hasRequiredToPrimitive;
function requireToPrimitive() {
  if (hasRequiredToPrimitive) return toPrimitive.exports;
  hasRequiredToPrimitive = 1;
  (function(module2) {
    var _typeof2 = require_typeof()["default"];
    function toPrimitive2(t, r2) {
      if ("object" != _typeof2(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r2 || "default");
        if ("object" != _typeof2(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r2 ? String : Number)(t);
    }
    module2.exports = toPrimitive2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(toPrimitive);
  return toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  if (hasRequiredToPropertyKey) return toPropertyKey.exports;
  hasRequiredToPropertyKey = 1;
  (function(module2) {
    var _typeof2 = require_typeof()["default"];
    var toPrimitive2 = requireToPrimitive();
    function toPropertyKey2(t) {
      var i = toPrimitive2(t, "string");
      return "symbol" == _typeof2(i) ? i : i + "";
    }
    module2.exports = toPropertyKey2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(toPropertyKey);
  return toPropertyKey.exports;
}
var hasRequiredDefineProperty;
function requireDefineProperty() {
  if (hasRequiredDefineProperty) return defineProperty.exports;
  hasRequiredDefineProperty = 1;
  (function(module2) {
    var toPropertyKey2 = requireToPropertyKey();
    function _defineProperty2(e, r2, t) {
      return (r2 = toPropertyKey2(r2)) in e ? Object.defineProperty(e, r2, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
      }) : e[r2] = t, e;
    }
    module2.exports = _defineProperty2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(defineProperty);
  return defineProperty.exports;
}
var hasRequiredObjectSpread2;
function requireObjectSpread2() {
  if (hasRequiredObjectSpread2) return objectSpread2.exports;
  hasRequiredObjectSpread2 = 1;
  (function(module2) {
    var defineProperty2 = requireDefineProperty();
    function ownKeys2(e, r2) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r2 && (o = o.filter(function(r3) {
          return Object.getOwnPropertyDescriptor(e, r3).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread22(e) {
      for (var r2 = 1; r2 < arguments.length; r2++) {
        var t = null != arguments[r2] ? arguments[r2] : {};
        r2 % 2 ? ownKeys2(Object(t), true).forEach(function(r3) {
          defineProperty2(e, r3, t[r3]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r3) {
          Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
        });
      }
      return e;
    }
    module2.exports = _objectSpread22, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(objectSpread2);
  return objectSpread2.exports;
}
var toConsumableArray = { exports: {} };
var arrayWithoutHoles = { exports: {} };
var arrayLikeToArray = { exports: {} };
var hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  if (hasRequiredArrayLikeToArray) return arrayLikeToArray.exports;
  hasRequiredArrayLikeToArray = 1;
  (function(module2) {
    function _arrayLikeToArray2(r2, a) {
      (null == a || a > r2.length) && (a = r2.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r2[e];
      return n;
    }
    module2.exports = _arrayLikeToArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(arrayLikeToArray);
  return arrayLikeToArray.exports;
}
var hasRequiredArrayWithoutHoles;
function requireArrayWithoutHoles() {
  if (hasRequiredArrayWithoutHoles) return arrayWithoutHoles.exports;
  hasRequiredArrayWithoutHoles = 1;
  (function(module2) {
    var arrayLikeToArray2 = requireArrayLikeToArray();
    function _arrayWithoutHoles2(r2) {
      if (Array.isArray(r2)) return arrayLikeToArray2(r2);
    }
    module2.exports = _arrayWithoutHoles2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(arrayWithoutHoles);
  return arrayWithoutHoles.exports;
}
var iterableToArray = { exports: {} };
var hasRequiredIterableToArray;
function requireIterableToArray() {
  if (hasRequiredIterableToArray) return iterableToArray.exports;
  hasRequiredIterableToArray = 1;
  (function(module2) {
    function _iterableToArray2(r2) {
      if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
    }
    module2.exports = _iterableToArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(iterableToArray);
  return iterableToArray.exports;
}
var unsupportedIterableToArray = { exports: {} };
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  if (hasRequiredUnsupportedIterableToArray) return unsupportedIterableToArray.exports;
  hasRequiredUnsupportedIterableToArray = 1;
  (function(module2) {
    var arrayLikeToArray2 = requireArrayLikeToArray();
    function _unsupportedIterableToArray2(r2, a) {
      if (r2) {
        if ("string" == typeof r2) return arrayLikeToArray2(r2, a);
        var t = {}.toString.call(r2).slice(8, -1);
        return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray2(r2, a) : void 0;
      }
    }
    module2.exports = _unsupportedIterableToArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(unsupportedIterableToArray);
  return unsupportedIterableToArray.exports;
}
var nonIterableSpread = { exports: {} };
var hasRequiredNonIterableSpread;
function requireNonIterableSpread() {
  if (hasRequiredNonIterableSpread) return nonIterableSpread.exports;
  hasRequiredNonIterableSpread = 1;
  (function(module2) {
    function _nonIterableSpread2() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    module2.exports = _nonIterableSpread2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(nonIterableSpread);
  return nonIterableSpread.exports;
}
var hasRequiredToConsumableArray;
function requireToConsumableArray() {
  if (hasRequiredToConsumableArray) return toConsumableArray.exports;
  hasRequiredToConsumableArray = 1;
  (function(module2) {
    var arrayWithoutHoles2 = requireArrayWithoutHoles();
    var iterableToArray2 = requireIterableToArray();
    var unsupportedIterableToArray2 = requireUnsupportedIterableToArray();
    var nonIterableSpread2 = requireNonIterableSpread();
    function _toConsumableArray2(r2) {
      return arrayWithoutHoles2(r2) || iterableToArray2(r2) || unsupportedIterableToArray2(r2) || nonIterableSpread2();
    }
    module2.exports = _toConsumableArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(toConsumableArray);
  return toConsumableArray.exports;
}
var toArray$3 = { exports: {} };
var arrayWithHoles = { exports: {} };
var hasRequiredArrayWithHoles;
function requireArrayWithHoles() {
  if (hasRequiredArrayWithHoles) return arrayWithHoles.exports;
  hasRequiredArrayWithHoles = 1;
  (function(module2) {
    function _arrayWithHoles2(r2) {
      if (Array.isArray(r2)) return r2;
    }
    module2.exports = _arrayWithHoles2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(arrayWithHoles);
  return arrayWithHoles.exports;
}
var nonIterableRest = { exports: {} };
var hasRequiredNonIterableRest;
function requireNonIterableRest() {
  if (hasRequiredNonIterableRest) return nonIterableRest.exports;
  hasRequiredNonIterableRest = 1;
  (function(module2) {
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    module2.exports = _nonIterableRest2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(nonIterableRest);
  return nonIterableRest.exports;
}
var hasRequiredToArray$1;
function requireToArray$1() {
  if (hasRequiredToArray$1) return toArray$3.exports;
  hasRequiredToArray$1 = 1;
  (function(module2) {
    var arrayWithHoles2 = requireArrayWithHoles();
    var iterableToArray2 = requireIterableToArray();
    var unsupportedIterableToArray2 = requireUnsupportedIterableToArray();
    var nonIterableRest2 = requireNonIterableRest();
    function _toArray2(r2) {
      return arrayWithHoles2(r2) || iterableToArray2(r2) || unsupportedIterableToArray2(r2) || nonIterableRest2();
    }
    module2.exports = _toArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(toArray$3);
  return toArray$3.exports;
}
var get$3 = {};
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get$3;
  hasRequiredGet = 1;
  Object.defineProperty(get$3, "__esModule", {
    value: true
  });
  get$3.default = get4;
  function get4(entity, path2) {
    var current = entity;
    for (var i = 0; i < path2.length; i += 1) {
      if (current === null || current === void 0) {
        return void 0;
      }
      current = current[path2[i]];
    }
    return current;
  }
  return get$3;
}
var hasRequiredSet;
function requireSet() {
  if (hasRequiredSet) return set$2;
  hasRequiredSet = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(set$2, "__esModule", {
    value: true
  });
  set$2.default = set2;
  set$2.merge = merge2;
  var _typeof2 = _interopRequireDefault(require_typeof());
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var _toConsumableArray2 = _interopRequireDefault(requireToConsumableArray());
  var _toArray2 = _interopRequireDefault(requireToArray$1());
  var _get = _interopRequireDefault(requireGet());
  function internalSet2(entity, paths, value, removeIfUndefined) {
    if (!paths.length) {
      return value;
    }
    var _paths = (0, _toArray2.default)(paths), path2 = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path2 === "number") {
      clone = [];
    } else if (Array.isArray(entity)) {
      clone = (0, _toConsumableArray2.default)(entity);
    } else {
      clone = (0, _objectSpread22.default)({}, entity);
    }
    if (removeIfUndefined && value === void 0 && restPath.length === 1) {
      delete clone[path2][restPath[0]];
    } else {
      clone[path2] = internalSet2(clone[path2], restPath, value, removeIfUndefined);
    }
    return clone;
  }
  function set2(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (paths.length && removeIfUndefined && value === void 0 && !(0, _get.default)(entity, paths.slice(0, -1))) {
      return entity;
    }
    return internalSet2(entity, paths, value, removeIfUndefined);
  }
  function isObject2(obj) {
    return (0, _typeof2.default)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
  }
  function createEmpty2(source) {
    return Array.isArray(source) ? [] : {};
  }
  var keys2 = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
  function merge2() {
    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }
    var clone = createEmpty2(sources[0]);
    sources.forEach(function(src) {
      function internalMerge(path2, parentLoopSet) {
        var loopSet = new Set(parentLoopSet);
        var value = (0, _get.default)(src, path2);
        var isArr = Array.isArray(value);
        if (isArr || isObject2(value)) {
          if (!loopSet.has(value)) {
            loopSet.add(value);
            var originValue = (0, _get.default)(clone, path2);
            if (isArr) {
              clone = set2(clone, path2, []);
            } else if (!originValue || (0, _typeof2.default)(originValue) !== "object") {
              clone = set2(clone, path2, createEmpty2(value));
            }
            keys2(value).forEach(function(key) {
              internalMerge([].concat((0, _toConsumableArray2.default)(path2), [key]), loopSet);
            });
          }
        } else {
          clone = set2(clone, path2, value);
        }
      }
      internalMerge([]);
    });
    return clone;
  }
  return set$2;
}
var validateMessagesContext = {};
var hasRequiredValidateMessagesContext;
function requireValidateMessagesContext() {
  if (hasRequiredValidateMessagesContext) return validateMessagesContext;
  hasRequiredValidateMessagesContext = 1;
  Object.defineProperty(validateMessagesContext, "__esModule", {
    value: true
  });
  validateMessagesContext.default = void 0;
  var _react = React__default;
  validateMessagesContext.default = /* @__PURE__ */ (0, _react.createContext)(void 0);
  return validateMessagesContext;
}
var locale$1 = {};
var locale = {};
var en_US$5 = {};
var en_US$4 = {};
var hasRequiredEn_US$5;
function requireEn_US$5() {
  if (hasRequiredEn_US$5) return en_US$4;
  hasRequiredEn_US$5 = 1;
  Object.defineProperty(en_US$4, "__esModule", {
    value: true
  });
  en_US$4.default = void 0;
  var locale2 = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
  };
  en_US$4.default = locale2;
  return en_US$4;
}
var en_US$3 = {};
var en_US$2 = {};
var en_US$1 = {};
var common = {};
var hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common;
  hasRequiredCommon = 1;
  Object.defineProperty(common, "__esModule", {
    value: true
  });
  common.commonLocale = void 0;
  common.commonLocale = {
    yearFormat: "YYYY",
    dayFormat: "D",
    cellMeridiemFormat: "A",
    monthBeforeYear: true
  };
  return common;
}
var hasRequiredEn_US$4;
function requireEn_US$4() {
  if (hasRequiredEn_US$4) return en_US$1;
  hasRequiredEn_US$4 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$1, "__esModule", {
    value: true
  });
  en_US$1.default = void 0;
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var _common = requireCommon();
  var locale2 = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, _common.commonLocale), {}, {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    week: "Week",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    dateFormat: "M/D/YYYY",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
  });
  en_US$1.default = locale2;
  return en_US$1;
}
var en_US = {};
var hasRequiredEn_US$3;
function requireEn_US$3() {
  if (hasRequiredEn_US$3) return en_US;
  hasRequiredEn_US$3 = 1;
  Object.defineProperty(en_US, "__esModule", {
    value: true
  });
  en_US.default = void 0;
  const locale2 = {
    placeholder: "Select time",
    rangePlaceholder: ["Start time", "End time"]
  };
  en_US.default = locale2;
  return en_US;
}
var hasRequiredEn_US$2;
function requireEn_US$2() {
  if (hasRequiredEn_US$2) return en_US$2;
  hasRequiredEn_US$2 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$2, "__esModule", {
    value: true
  });
  en_US$2.default = void 0;
  var _en_US = _interopRequireDefault(requireEn_US$4());
  var _en_US2 = _interopRequireDefault(/* @__PURE__ */ requireEn_US$3());
  const locale2 = {
    lang: Object.assign({
      placeholder: "Select date",
      yearPlaceholder: "Select year",
      quarterPlaceholder: "Select quarter",
      monthPlaceholder: "Select month",
      weekPlaceholder: "Select week",
      rangePlaceholder: ["Start date", "End date"],
      rangeYearPlaceholder: ["Start year", "End year"],
      rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
      rangeMonthPlaceholder: ["Start month", "End month"],
      rangeWeekPlaceholder: ["Start week", "End week"]
    }, _en_US.default),
    timePickerLocale: Object.assign({}, _en_US2.default)
  };
  en_US$2.default = locale2;
  return en_US$2;
}
var hasRequiredEn_US$1;
function requireEn_US$1() {
  if (hasRequiredEn_US$1) return en_US$3;
  hasRequiredEn_US$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$3, "__esModule", {
    value: true
  });
  en_US$3.default = void 0;
  var _en_US = _interopRequireDefault(/* @__PURE__ */ requireEn_US$2());
  en_US$3.default = _en_US.default;
  return en_US$3;
}
var hasRequiredEn_US;
function requireEn_US() {
  if (hasRequiredEn_US) return en_US$5;
  hasRequiredEn_US = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(en_US$5, "__esModule", {
    value: true
  });
  en_US$5.default = void 0;
  var _en_US = _interopRequireDefault(requireEn_US$5());
  var _en_US2 = _interopRequireDefault(/* @__PURE__ */ requireEn_US$1());
  var _en_US3 = _interopRequireDefault(/* @__PURE__ */ requireEn_US$2());
  var _en_US4 = _interopRequireDefault(/* @__PURE__ */ requireEn_US$3());
  const typeTemplate2 = "${label} is not a valid ${type}";
  const localeValues = {
    locale: "en",
    Pagination: _en_US.default,
    DatePicker: _en_US3.default,
    TimePicker: _en_US4.default,
    Calendar: _en_US2.default,
    global: {
      placeholder: "Please select"
    },
    Table: {
      filterTitle: "Filter menu",
      filterConfirm: "OK",
      filterReset: "Reset",
      filterEmptyText: "No filters",
      filterCheckAll: "Select all items",
      filterSearchPlaceholder: "Search in filters",
      emptyText: "No data",
      selectAll: "Select current page",
      selectInvert: "Invert current page",
      selectNone: "Clear all data",
      selectionAll: "Select all data",
      sortTitle: "Sort",
      expand: "Expand row",
      collapse: "Collapse row",
      triggerDesc: "Click to sort descending",
      triggerAsc: "Click to sort ascending",
      cancelSort: "Click to cancel sorting"
    },
    Tour: {
      Next: "Next",
      Previous: "Previous",
      Finish: "Finish"
    },
    Modal: {
      okText: "OK",
      cancelText: "Cancel",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Cancel"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Search here",
      itemUnit: "item",
      itemsUnit: "items",
      remove: "Remove",
      selectCurrent: "Select current page",
      removeCurrent: "Remove current page",
      selectAll: "Select all data",
      deselectAll: "Deselect all data",
      removeAll: "Remove all data",
      selectInvert: "Invert current page"
    },
    Upload: {
      uploading: "Uploading...",
      removeFile: "Remove file",
      uploadError: "Upload error",
      previewFile: "Preview file",
      downloadFile: "Download file"
    },
    Empty: {
      description: "No data"
    },
    Icon: {
      icon: "icon"
    },
    Text: {
      edit: "Edit",
      copy: "Copy",
      copied: "Copied",
      expand: "Expand",
      collapse: "Collapse"
    },
    Form: {
      optional: "(optional)",
      defaultValidateMessages: {
        default: "Field validation error for ${label}",
        required: "Please enter ${label}",
        enum: "${label} must be one of [${enum}]",
        whitespace: "${label} cannot be a blank character",
        date: {
          format: "${label} date format is invalid",
          parse: "${label} cannot be converted to a date",
          invalid: "${label} is an invalid date"
        },
        types: {
          string: typeTemplate2,
          method: typeTemplate2,
          array: typeTemplate2,
          object: typeTemplate2,
          number: typeTemplate2,
          date: typeTemplate2,
          boolean: typeTemplate2,
          integer: typeTemplate2,
          float: typeTemplate2,
          regexp: typeTemplate2,
          email: typeTemplate2,
          url: typeTemplate2,
          hex: typeTemplate2
        },
        string: {
          len: "${label} must be ${len} characters",
          min: "${label} must be at least ${min} characters",
          max: "${label} must be up to ${max} characters",
          range: "${label} must be between ${min}-${max} characters"
        },
        number: {
          len: "${label} must be equal to ${len}",
          min: "${label} must be minimum ${min}",
          max: "${label} must be maximum ${max}",
          range: "${label} must be between ${min}-${max}"
        },
        array: {
          len: "Must be ${len} ${label}",
          min: "At least ${min} ${label}",
          max: "At most ${max} ${label}",
          range: "The amount of ${label} must be between ${min}-${max}"
        },
        pattern: {
          mismatch: "${label} does not match the pattern ${pattern}"
        }
      }
    },
    Image: {
      preview: "Preview"
    },
    QRCode: {
      expired: "QR code expired",
      refresh: "Refresh",
      scanned: "Scanned"
    },
    ColorPicker: {
      presetEmpty: "Empty",
      transparent: "Transparent",
      singleColor: "Single",
      gradientColor: "Gradient"
    }
  };
  en_US$5.default = localeValues;
  return en_US$5;
}
var hasRequiredLocale$1;
function requireLocale$1() {
  if (hasRequiredLocale$1) return locale;
  hasRequiredLocale$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(locale, "__esModule", {
    value: true
  });
  locale.changeConfirmLocale = changeConfirmLocale;
  locale.getConfirmLocale = getConfirmLocale;
  var _en_US = _interopRequireDefault(/* @__PURE__ */ requireEn_US());
  let runtimeLocale = Object.assign({}, _en_US.default.Modal);
  let localeList = [];
  const generateLocale = () => localeList.reduce((merged, locale2) => Object.assign(Object.assign({}, merged), locale2), _en_US.default.Modal);
  function changeConfirmLocale(newLocale) {
    if (newLocale) {
      const cloneLocale = Object.assign({}, newLocale);
      localeList.push(cloneLocale);
      runtimeLocale = generateLocale();
      return () => {
        localeList = localeList.filter((locale2) => locale2 !== cloneLocale);
        runtimeLocale = generateLocale();
      };
    }
    runtimeLocale = Object.assign({}, _en_US.default.Modal);
  }
  function getConfirmLocale() {
    return runtimeLocale;
  }
  return locale;
}
var context$3 = {};
var hasRequiredContext$3;
function requireContext$3() {
  if (hasRequiredContext$3) return context$3;
  hasRequiredContext$3 = 1;
  Object.defineProperty(context$3, "__esModule", {
    value: true
  });
  context$3.default = void 0;
  var _react = React__default;
  const LocaleContext = /* @__PURE__ */ (0, _react.createContext)(void 0);
  context$3.default = LocaleContext;
  return context$3;
}
var useLocale = {};
var hasRequiredUseLocale;
function requireUseLocale() {
  if (hasRequiredUseLocale) return useLocale;
  hasRequiredUseLocale = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useLocale, "__esModule", {
    value: true
  });
  useLocale.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _context = _interopRequireDefault(/* @__PURE__ */ requireContext$3());
  var _en_US = _interopRequireDefault(/* @__PURE__ */ requireEn_US());
  const useLocale$1 = (componentName, defaultLocale) => {
    const fullLocale = React2.useContext(_context.default);
    const getLocale = React2.useMemo(() => {
      var _a2;
      const locale2 = defaultLocale || _en_US.default[componentName];
      const localeFromContext = (_a2 = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a2 !== void 0 ? _a2 : {};
      return Object.assign(Object.assign({}, typeof locale2 === "function" ? locale2() : locale2), localeFromContext || {});
    }, [componentName, defaultLocale, fullLocale]);
    const getLocaleCode = React2.useMemo(() => {
      const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
      if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
        return _en_US.default.locale;
      }
      return localeCode;
    }, [fullLocale]);
    return [getLocale, getLocaleCode];
  };
  useLocale.default = useLocale$1;
  return useLocale;
}
var hasRequiredLocale;
function requireLocale() {
  if (hasRequiredLocale) return locale$1;
  hasRequiredLocale = 1;
  (function(exports$1) {
    "use client";
    var _interopRequireDefault = requireInteropRequireDefault().default;
    var _interopRequireWildcard = requireInteropRequireWildcard().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = exports$1.ANT_MARK = void 0;
    Object.defineProperty(exports$1, "useLocale", {
      enumerable: true,
      get: function() {
        return _useLocale.default;
      }
    });
    var React2 = _interopRequireWildcard(React__default);
    var _warning = /* @__PURE__ */ requireWarning();
    var _locale = /* @__PURE__ */ requireLocale$1();
    var _context = _interopRequireDefault(/* @__PURE__ */ requireContext$3());
    var _useLocale = _interopRequireDefault(/* @__PURE__ */ requireUseLocale());
    const ANT_MARK = exports$1.ANT_MARK = "internalMark";
    const LocaleProvider = (props) => {
      const {
        locale: locale2 = {},
        children: children2,
        _ANT_MARK__
      } = props;
      if (process.env.NODE_ENV !== "production") {
        const warning3 = (0, _warning.devUseWarning)("LocaleProvider");
        process.env.NODE_ENV !== "production" ? warning3(_ANT_MARK__ === ANT_MARK, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale") : void 0;
      }
      React2.useEffect(() => {
        const clearLocale = (0, _locale.changeConfirmLocale)(locale2 === null || locale2 === void 0 ? void 0 : locale2.Modal);
        return clearLocale;
      }, [locale2]);
      const getMemoizedContextValue = React2.useMemo(() => Object.assign(Object.assign({}, locale2), {
        exist: true
      }), [locale2]);
      return /* @__PURE__ */ React2.createElement(_context.default.Provider, {
        value: getMemoizedContextValue
      }, children2);
    };
    if (process.env.NODE_ENV !== "production") {
      LocaleProvider.displayName = "LocaleProvider";
    }
    exports$1.default = LocaleProvider;
  })(locale$1);
  return locale$1;
}
var context$2 = {};
var seed = {};
var hasRequiredSeed;
function requireSeed() {
  if (hasRequiredSeed) return seed;
  hasRequiredSeed = 1;
  Object.defineProperty(seed, "__esModule", {
    value: true
  });
  seed.defaultPresetColors = seed.default = void 0;
  const defaultPresetColors = seed.defaultPresetColors = {
    blue: "#1677FF",
    purple: "#722ED1",
    cyan: "#13C2C2",
    green: "#52C41A",
    magenta: "#EB2F96",
    /**
     * @deprecated Use magenta instead
     */
    pink: "#EB2F96",
    red: "#F5222D",
    orange: "#FA8C16",
    yellow: "#FADB14",
    volcano: "#FA541C",
    geekblue: "#2F54EB",
    gold: "#FAAD14",
    lime: "#A0D911"
  };
  const seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
    // Color
    colorPrimary: "#1677ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",
    colorLink: "",
    colorTextBase: "",
    colorBgBase: "",
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: "solid",
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
    motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
    motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
    motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1e3,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
  });
  seed.default = seedToken;
  return seed;
}
var theme = {};
var _default = {};
const round = Math.round;
function splitColorStr(str, parseNum) {
  const match2 = str.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [];
  const numList = match2.map((item2) => parseFloat(item2));
  for (let i = 0; i < 3; i += 1) {
    numList[i] = parseNum(numList[i] || 0, match2[i] || "", i);
  }
  if (match2[3]) {
    numList[3] = match2[3].includes("%") ? numList[3] / 100 : numList[3];
  } else {
    numList[3] = 1;
  }
  return numList;
}
const parseHSVorHSL = (num, _2, index2) => index2 === 0 ? num : num / 100;
function limitRange(value, max2) {
  const mergedMax = max2 || 255;
  if (value > mergedMax) {
    return mergedMax;
  }
  if (value < 0) {
    return 0;
  }
  return value;
}
class FastColor {
  constructor(input2) {
    _defineProperty$1(this, "isValid", true);
    _defineProperty$1(this, "r", 0);
    _defineProperty$1(this, "g", 0);
    _defineProperty$1(this, "b", 0);
    _defineProperty$1(this, "a", 1);
    _defineProperty$1(this, "_h", void 0);
    _defineProperty$1(this, "_s", void 0);
    _defineProperty$1(this, "_l", void 0);
    _defineProperty$1(this, "_v", void 0);
    _defineProperty$1(this, "_max", void 0);
    _defineProperty$1(this, "_min", void 0);
    _defineProperty$1(this, "_brightness", void 0);
    function matchFormat(str) {
      return str[0] in input2 && str[1] in input2 && str[2] in input2;
    }
    if (!input2) ;
    else if (typeof input2 === "string") {
      let matchPrefix = function(prefix2) {
        return trimStr.startsWith(prefix2);
      };
      const trimStr = input2.trim();
      if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) {
        this.fromHexString(trimStr);
      } else if (matchPrefix("rgb")) {
        this.fromRgbString(trimStr);
      } else if (matchPrefix("hsl")) {
        this.fromHslString(trimStr);
      } else if (matchPrefix("hsv") || matchPrefix("hsb")) {
        this.fromHsvString(trimStr);
      }
    } else if (input2 instanceof FastColor) {
      this.r = input2.r;
      this.g = input2.g;
      this.b = input2.b;
      this.a = input2.a;
      this._h = input2._h;
      this._s = input2._s;
      this._l = input2._l;
      this._v = input2._v;
    } else if (matchFormat("rgb")) {
      this.r = limitRange(input2.r);
      this.g = limitRange(input2.g);
      this.b = limitRange(input2.b);
      this.a = typeof input2.a === "number" ? limitRange(input2.a, 1) : 1;
    } else if (matchFormat("hsl")) {
      this.fromHsl(input2);
    } else if (matchFormat("hsv")) {
      this.fromHsv(input2);
    } else {
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(input2));
    }
  }
  // ======================= Setter =======================
  setR(value) {
    return this._sc("r", value);
  }
  setG(value) {
    return this._sc("g", value);
  }
  setB(value) {
    return this._sc("b", value);
  }
  setA(value) {
    return this._sc("a", value, 1);
  }
  setHue(value) {
    const hsv = this.toHsv();
    hsv.h = value;
    return this._c(hsv);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function adjustGamma(raw) {
      const val = raw / 255;
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }
    const R = adjustGamma(this.r);
    const G = adjustGamma(this.g);
    const B = adjustGamma(this.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }
  getHue() {
    if (typeof this._h === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._h = 0;
      } else {
        this._h = round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
      }
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s === "undefined") {
      const delta = this.getMax() - this.getMin();
      if (delta === 0) {
        this._s = 0;
      } else {
        this._s = delta / this.getMax();
      }
    }
    return this._s;
  }
  getLightness() {
    if (typeof this._l === "undefined") {
      this._l = (this.getMax() + this.getMin()) / 510;
    }
    return this._l;
  }
  getValue() {
    if (typeof this._v === "undefined") {
      this._v = this.getMax() / 255;
    }
    return this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    if (typeof this._brightness === "undefined") {
      this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3;
    }
    return this._brightness;
  }
  // ======================== Func ========================
  darken(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() - amount / 100;
    if (l < 0) {
      l = 0;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }
  lighten(amount = 10) {
    const h = this.getHue();
    const s = this.getSaturation();
    let l = this.getLightness() + amount / 100;
    if (l > 1) {
      l = 1;
    }
    return this._c({
      h,
      s,
      l,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(input2, amount = 50) {
    const color2 = this._c(input2);
    const p = amount / 100;
    const calc = (key) => (color2[key] - this[key]) * p + this[key];
    const rgba = {
      r: round(calc("r")),
      g: round(calc("g")),
      b: round(calc("b")),
      a: round(calc("a") * 100) / 100
    };
    return this._c(rgba);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(amount = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, amount);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(amount = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, amount);
  }
  onBackground(background) {
    const bg = this._c(background);
    const alpha = this.a + bg.a * (1 - this.a);
    const calc = (key) => {
      return round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
    };
    return this._c({
      r: calc("r"),
      g: calc("g"),
      b: calc("b"),
      a: alpha
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(other) {
    return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let hex2 = "#";
    const rHex = (this.r || 0).toString(16);
    hex2 += rHex.length === 2 ? rHex : "0" + rHex;
    const gHex = (this.g || 0).toString(16);
    hex2 += gHex.length === 2 ? gHex : "0" + gHex;
    const bHex = (this.b || 0).toString(16);
    hex2 += bHex.length === 2 ? bHex : "0" + bHex;
    if (typeof this.a === "number" && this.a >= 0 && this.a < 1) {
      const aHex = round(this.a * 255).toString(16);
      hex2 += aHex.length === 2 ? aHex : "0" + aHex;
    }
    return hex2;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const h = this.getHue();
    const s = round(this.getSaturation() * 100);
    const l = round(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(rgb, value, max2) {
    const clone = this.clone();
    clone[rgb] = limitRange(value, max2);
    return clone;
  }
  _c(input2) {
    return new this.constructor(input2);
  }
  getMax() {
    if (typeof this._max === "undefined") {
      this._max = Math.max(this.r, this.g, this.b);
    }
    return this._max;
  }
  getMin() {
    if (typeof this._min === "undefined") {
      this._min = Math.min(this.r, this.g, this.b);
    }
    return this._min;
  }
  fromHexString(trimStr) {
    const withoutPrefix = trimStr.replace("#", "");
    function connectNum(index1, index2) {
      return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
    }
    if (withoutPrefix.length < 6) {
      this.r = connectNum(0);
      this.g = connectNum(1);
      this.b = connectNum(2);
      this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
    } else {
      this.r = connectNum(0, 1);
      this.g = connectNum(2, 3);
      this.b = connectNum(4, 5);
      this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
    }
  }
  fromHsl({
    h,
    s,
    l,
    a
  }) {
    this._h = h % 360;
    this._s = s;
    this._l = l;
    this.a = typeof a === "number" ? a : 1;
    if (s <= 0) {
      const rgb = round(l * 255);
      this.r = rgb;
      this.g = rgb;
      this.b = rgb;
    }
    let r2 = 0, g = 0, b = 0;
    const huePrime = h / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    if (huePrime >= 0 && huePrime < 1) {
      r2 = chroma;
      g = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      r2 = secondComponent;
      g = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      g = chroma;
      b = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      g = secondComponent;
      b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      r2 = secondComponent;
      b = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      r2 = chroma;
      b = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    this.r = round((r2 + lightnessModification) * 255);
    this.g = round((g + lightnessModification) * 255);
    this.b = round((b + lightnessModification) * 255);
  }
  fromHsv({
    h,
    s,
    v,
    a
  }) {
    this._h = h % 360;
    this._s = s;
    this._v = v;
    this.a = typeof a === "number" ? a : 1;
    const vv = round(v * 255);
    this.r = vv;
    this.g = vv;
    this.b = vv;
    if (s <= 0) {
      return;
    }
    const hh = h / 60;
    const i = Math.floor(hh);
    const ff = hh - i;
    const p = round(v * (1 - s) * 255);
    const q = round(v * (1 - s * ff) * 255);
    const t = round(v * (1 - s * (1 - ff)) * 255);
    switch (i) {
      case 0:
        this.g = t;
        this.b = p;
        break;
      case 1:
        this.r = q;
        this.b = p;
        break;
      case 2:
        this.r = p;
        this.b = t;
        break;
      case 3:
        this.r = p;
        this.g = q;
        break;
      case 4:
        this.r = t;
        this.g = p;
        break;
      case 5:
      default:
        this.g = p;
        this.b = q;
        break;
    }
  }
  fromHsvString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsv({
      h: cells[0],
      s: cells[1],
      v: cells[2],
      a: cells[3]
    });
  }
  fromHslString(trimStr) {
    const cells = splitColorStr(trimStr, parseHSVorHSL);
    this.fromHsl({
      h: cells[0],
      s: cells[1],
      l: cells[2],
      a: cells[3]
    });
  }
  fromRgbString(trimStr) {
    const cells = splitColorStr(trimStr, (num, txt) => (
      // Convert percentage to number. e.g. 50% -> 128
      txt.includes("%") ? round(num / 100 * 255) : num
    ));
    this.r = cells[0];
    this.g = cells[1];
    this.b = cells[2];
    this.a = cells[3];
  }
}
const es$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FastColor
}, Symbol.toStringTag, { value: "Module" }));
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function getHue(hsv, i, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Math.round(saturation * 100) / 100;
}
function getValue$1(hsv, i, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  value = Math.max(0, Math.min(1, value));
  return Math.round(value * 100) / 100;
}
function generate(color2) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = new FastColor(color2);
  var hsv = pColor.toHsv();
  for (var i = lightColorCount; i > 0; i -= 1) {
    var c = new FastColor({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue$1(hsv, i, true)
    });
    patterns.push(c);
  }
  patterns.push(pColor);
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _c = new FastColor({
      h: getHue(hsv, _i),
      s: getSaturation(hsv, _i),
      v: getValue$1(hsv, _i)
    });
    patterns.push(_c);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref) {
      var index2 = _ref.index, amount = _ref.amount;
      return new FastColor(opts.backgroundColor || "#141414").mix(patterns[index2], amount).toHexString();
    });
  }
  return patterns.map(function(c2) {
    return c2.toHexString();
  });
}
var presetPrimaryColors = {
  "red": "#F5222D",
  "volcano": "#FA541C",
  "orange": "#FA8C16",
  "gold": "#FAAD14",
  "yellow": "#FADB14",
  "lime": "#A0D911",
  "green": "#52C41A",
  "cyan": "#13C2C2",
  "blue": "#1677FF",
  "geekblue": "#2F54EB",
  "purple": "#722ED1",
  "magenta": "#EB2F96",
  "grey": "#666666"
};
var red = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
red.primary = red[5];
var volcano = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
volcano.primary = volcano[5];
var orange = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
orange.primary = orange[5];
var gold = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
gold.primary = gold[5];
var yellow = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
yellow.primary = yellow[5];
var lime = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
lime.primary = lime[5];
var green = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
green.primary = green[5];
var cyan = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
cyan.primary = cyan[5];
var blue = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
blue.primary = blue[5];
var geekblue = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
geekblue.primary = geekblue[5];
var purple = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
purple.primary = purple[5];
var magenta = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
magenta.primary = magenta[5];
var grey = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
grey.primary = grey[5];
var gray = grey;
var presetPalettes = {
  red,
  volcano,
  orange,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey
};
var redDark = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
redDark.primary = redDark[5];
var volcanoDark = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
volcanoDark.primary = volcanoDark[5];
var orangeDark = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
orangeDark.primary = orangeDark[5];
var goldDark = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
goldDark.primary = goldDark[5];
var yellowDark = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
yellowDark.primary = yellowDark[5];
var limeDark = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
limeDark.primary = limeDark[5];
var greenDark = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
greenDark.primary = greenDark[5];
var cyanDark = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
cyanDark.primary = cyanDark[5];
var blueDark = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
blueDark.primary = blueDark[5];
var geekblueDark = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
geekblueDark.primary = geekblueDark[5];
var purpleDark = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
purpleDark.primary = purpleDark[5];
var magentaDark = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
magentaDark.primary = magentaDark[5];
var greyDark = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
greyDark.primary = greyDark[5];
var presetDarkPalettes = {
  red: redDark,
  volcano: volcanoDark,
  orange: orangeDark,
  gold: goldDark,
  yellow: yellowDark,
  lime: limeDark,
  green: greenDark,
  cyan: cyanDark,
  blue: blueDark,
  geekblue: geekblueDark,
  purple: purpleDark,
  magenta: magentaDark,
  grey: greyDark
};
const es$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue,
  blueDark,
  cyan,
  cyanDark,
  geekblue,
  geekblueDark,
  generate,
  gold,
  goldDark,
  gray,
  green,
  greenDark,
  grey,
  greyDark,
  lime,
  limeDark,
  magenta,
  magentaDark,
  orange,
  orangeDark,
  presetDarkPalettes,
  presetPalettes,
  presetPrimaryColors,
  purple,
  purpleDark,
  red,
  redDark,
  volcano,
  volcanoDark,
  yellow,
  yellowDark
}, Symbol.toStringTag, { value: "Module" }));
const require$$8 = /* @__PURE__ */ getAugmentedNamespace(es$7);
var genColorMapToken = {};
const require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(es$8);
var hasRequiredGenColorMapToken;
function requireGenColorMapToken() {
  if (hasRequiredGenColorMapToken) return genColorMapToken;
  hasRequiredGenColorMapToken = 1;
  Object.defineProperty(genColorMapToken, "__esModule", {
    value: true
  });
  genColorMapToken.default = genColorMapToken$1;
  var _fastColor = require$$2$1;
  function genColorMapToken$1(seed2, _ref) {
    let {
      generateColorPalettes,
      generateNeutralColorPalettes
    } = _ref;
    const {
      colorSuccess: colorSuccessBase,
      colorWarning: colorWarningBase,
      colorError: colorErrorBase,
      colorInfo: colorInfoBase,
      colorPrimary: colorPrimaryBase,
      colorBgBase,
      colorTextBase
    } = seed2;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    const colorLink = seed2.colorLink || seed2.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new _fastColor.FastColor(errorColors[1]).mix(new _fastColor.FastColor(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
      colorPrimaryBg: primaryColors[1],
      colorPrimaryBgHover: primaryColors[2],
      colorPrimaryBorder: primaryColors[3],
      colorPrimaryBorderHover: primaryColors[4],
      colorPrimaryHover: primaryColors[5],
      colorPrimary: primaryColors[6],
      colorPrimaryActive: primaryColors[7],
      colorPrimaryTextHover: primaryColors[8],
      colorPrimaryText: primaryColors[9],
      colorPrimaryTextActive: primaryColors[10],
      colorSuccessBg: successColors[1],
      colorSuccessBgHover: successColors[2],
      colorSuccessBorder: successColors[3],
      colorSuccessBorderHover: successColors[4],
      colorSuccessHover: successColors[4],
      colorSuccess: successColors[6],
      colorSuccessActive: successColors[7],
      colorSuccessTextHover: successColors[8],
      colorSuccessText: successColors[9],
      colorSuccessTextActive: successColors[10],
      colorErrorBg: errorColors[1],
      colorErrorBgHover: errorColors[2],
      colorErrorBgFilledHover,
      colorErrorBgActive: errorColors[3],
      colorErrorBorder: errorColors[3],
      colorErrorBorderHover: errorColors[4],
      colorErrorHover: errorColors[5],
      colorError: errorColors[6],
      colorErrorActive: errorColors[7],
      colorErrorTextHover: errorColors[8],
      colorErrorText: errorColors[9],
      colorErrorTextActive: errorColors[10],
      colorWarningBg: warningColors[1],
      colorWarningBgHover: warningColors[2],
      colorWarningBorder: warningColors[3],
      colorWarningBorderHover: warningColors[4],
      colorWarningHover: warningColors[4],
      colorWarning: warningColors[6],
      colorWarningActive: warningColors[7],
      colorWarningTextHover: warningColors[8],
      colorWarningText: warningColors[9],
      colorWarningTextActive: warningColors[10],
      colorInfoBg: infoColors[1],
      colorInfoBgHover: infoColors[2],
      colorInfoBorder: infoColors[3],
      colorInfoBorderHover: infoColors[4],
      colorInfoHover: infoColors[4],
      colorInfo: infoColors[6],
      colorInfoActive: infoColors[7],
      colorInfoTextHover: infoColors[8],
      colorInfoText: infoColors[9],
      colorInfoTextActive: infoColors[10],
      colorLinkHover: linkColors[4],
      colorLink: linkColors[6],
      colorLinkActive: linkColors[7],
      colorBgMask: new _fastColor.FastColor("#000").setA(0.45).toRgbString(),
      colorWhite: "#fff"
    });
  }
  return genColorMapToken;
}
var genCommonMapToken = {};
var genRadius = {};
var hasRequiredGenRadius;
function requireGenRadius() {
  if (hasRequiredGenRadius) return genRadius;
  hasRequiredGenRadius = 1;
  Object.defineProperty(genRadius, "__esModule", {
    value: true
  });
  genRadius.default = void 0;
  const genRadius$1 = (radiusBase) => {
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    if (radiusBase < 6 && radiusBase >= 5) {
      radiusLG = radiusBase + 1;
    } else if (radiusBase < 16 && radiusBase >= 6) {
      radiusLG = radiusBase + 2;
    } else if (radiusBase >= 16) {
      radiusLG = 16;
    }
    if (radiusBase < 7 && radiusBase >= 5) {
      radiusSM = 4;
    } else if (radiusBase < 8 && radiusBase >= 7) {
      radiusSM = 5;
    } else if (radiusBase < 14 && radiusBase >= 8) {
      radiusSM = 6;
    } else if (radiusBase < 16 && radiusBase >= 14) {
      radiusSM = 7;
    } else if (radiusBase >= 16) {
      radiusSM = 8;
    }
    if (radiusBase < 6 && radiusBase >= 2) {
      radiusXS = 1;
    } else if (radiusBase >= 6) {
      radiusXS = 2;
    }
    if (radiusBase > 4 && radiusBase < 8) {
      radiusOuter = 4;
    } else if (radiusBase >= 8) {
      radiusOuter = 6;
    }
    return {
      borderRadius: radiusBase,
      borderRadiusXS: radiusXS,
      borderRadiusSM: radiusSM,
      borderRadiusLG: radiusLG,
      borderRadiusOuter: radiusOuter
    };
  };
  genRadius.default = genRadius$1;
  return genRadius;
}
var hasRequiredGenCommonMapToken;
function requireGenCommonMapToken() {
  if (hasRequiredGenCommonMapToken) return genCommonMapToken;
  hasRequiredGenCommonMapToken = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(genCommonMapToken, "__esModule", {
    value: true
  });
  genCommonMapToken.default = genCommonMapToken$1;
  var _genRadius = _interopRequireDefault(/* @__PURE__ */ requireGenRadius());
  function genCommonMapToken$1(token2) {
    const {
      motionUnit,
      motionBase,
      borderRadius,
      lineWidth
    } = token2;
    return Object.assign({
      // motion
      motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
      motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
      motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
      // line
      lineWidthBold: lineWidth + 1
    }, (0, _genRadius.default)(borderRadius));
  }
  return genCommonMapToken;
}
var genControlHeight = {};
var hasRequiredGenControlHeight;
function requireGenControlHeight() {
  if (hasRequiredGenControlHeight) return genControlHeight;
  hasRequiredGenControlHeight = 1;
  Object.defineProperty(genControlHeight, "__esModule", {
    value: true
  });
  genControlHeight.default = void 0;
  const genControlHeight$1 = (token2) => {
    const {
      controlHeight
    } = token2;
    return {
      controlHeightSM: controlHeight * 0.75,
      controlHeightXS: controlHeight * 0.5,
      controlHeightLG: controlHeight * 1.25
    };
  };
  genControlHeight.default = genControlHeight$1;
  return genControlHeight;
}
var genFontMapToken = {};
var genFontSizes = {};
var hasRequiredGenFontSizes;
function requireGenFontSizes() {
  if (hasRequiredGenFontSizes) return genFontSizes;
  hasRequiredGenFontSizes = 1;
  Object.defineProperty(genFontSizes, "__esModule", {
    value: true
  });
  genFontSizes.default = getFontSizes;
  genFontSizes.getLineHeight = getLineHeight;
  function getLineHeight(fontSize) {
    return (fontSize + 8) / fontSize;
  }
  function getFontSizes(base) {
    const fontSizes = Array.from({
      length: 10
    }).map((_2, index2) => {
      const i = index2 - 1;
      const baseSize = base * Math.pow(Math.E, i / 5);
      const intSize = index2 > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
      return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size2) => ({
      size: size2,
      lineHeight: getLineHeight(size2)
    }));
  }
  return genFontSizes;
}
var hasRequiredGenFontMapToken;
function requireGenFontMapToken() {
  if (hasRequiredGenFontMapToken) return genFontMapToken;
  hasRequiredGenFontMapToken = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(genFontMapToken, "__esModule", {
    value: true
  });
  genFontMapToken.default = void 0;
  var _genFontSizes = _interopRequireDefault(/* @__PURE__ */ requireGenFontSizes());
  const genFontMapToken$1 = (fontSize) => {
    const fontSizePairs = (0, _genFontSizes.default)(fontSize);
    const fontSizes = fontSizePairs.map((pair) => pair.size);
    const lineHeights = fontSizePairs.map((pair) => pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
      fontSizeSM,
      fontSize: fontSizeMD,
      fontSizeLG,
      fontSizeXL: fontSizes[3],
      fontSizeHeading1: fontSizes[6],
      fontSizeHeading2: fontSizes[5],
      fontSizeHeading3: fontSizes[4],
      fontSizeHeading4: fontSizes[3],
      fontSizeHeading5: fontSizes[2],
      lineHeight,
      lineHeightLG,
      lineHeightSM,
      fontHeight: Math.round(lineHeight * fontSizeMD),
      fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
      fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
      lineHeightHeading1: lineHeights[6],
      lineHeightHeading2: lineHeights[5],
      lineHeightHeading3: lineHeights[4],
      lineHeightHeading4: lineHeights[3],
      lineHeightHeading5: lineHeights[2]
    };
  };
  genFontMapToken.default = genFontMapToken$1;
  return genFontMapToken;
}
var genSizeMapToken = {};
var hasRequiredGenSizeMapToken;
function requireGenSizeMapToken() {
  if (hasRequiredGenSizeMapToken) return genSizeMapToken;
  hasRequiredGenSizeMapToken = 1;
  Object.defineProperty(genSizeMapToken, "__esModule", {
    value: true
  });
  genSizeMapToken.default = genSizeMapToken$1;
  function genSizeMapToken$1(token2) {
    const {
      sizeUnit,
      sizeStep
    } = token2;
    return {
      sizeXXL: sizeUnit * (sizeStep + 8),
      // 48
      sizeXL: sizeUnit * (sizeStep + 4),
      // 32
      sizeLG: sizeUnit * (sizeStep + 2),
      // 24
      sizeMD: sizeUnit * (sizeStep + 1),
      // 20
      sizeMS: sizeUnit * sizeStep,
      // 16
      size: sizeUnit * sizeStep,
      // 16
      sizeSM: sizeUnit * (sizeStep - 1),
      // 12
      sizeXS: sizeUnit * (sizeStep - 2),
      // 8
      sizeXXS: sizeUnit * (sizeStep - 3)
      // 4
    };
  }
  return genSizeMapToken;
}
var colors = {};
var colorAlgorithm = {};
var hasRequiredColorAlgorithm;
function requireColorAlgorithm() {
  if (hasRequiredColorAlgorithm) return colorAlgorithm;
  hasRequiredColorAlgorithm = 1;
  Object.defineProperty(colorAlgorithm, "__esModule", {
    value: true
  });
  colorAlgorithm.getSolidColor = colorAlgorithm.getAlphaColor = void 0;
  var _fastColor = require$$2$1;
  const getAlphaColor2 = (baseColor, alpha) => new _fastColor.FastColor(baseColor).setA(alpha).toRgbString();
  colorAlgorithm.getAlphaColor = getAlphaColor2;
  const getSolidColor = (baseColor, brightness) => {
    const instance = new _fastColor.FastColor(baseColor);
    return instance.darken(brightness).toHexString();
  };
  colorAlgorithm.getSolidColor = getSolidColor;
  return colorAlgorithm;
}
var hasRequiredColors;
function requireColors() {
  if (hasRequiredColors) return colors;
  hasRequiredColors = 1;
  Object.defineProperty(colors, "__esModule", {
    value: true
  });
  colors.generateNeutralColorPalettes = colors.generateColorPalettes = void 0;
  var _colors = require$$8;
  var _colorAlgorithm = /* @__PURE__ */ requireColorAlgorithm();
  const generateColorPalettes = (baseColor) => {
    const colors2 = (0, _colors.generate)(baseColor);
    return {
      1: colors2[0],
      2: colors2[1],
      3: colors2[2],
      4: colors2[3],
      5: colors2[4],
      6: colors2[5],
      7: colors2[6],
      8: colors2[4],
      9: colors2[5],
      10: colors2[6]
      // 8: colors[7],
      // 9: colors[8],
      // 10: colors[9],
    };
  };
  colors.generateColorPalettes = generateColorPalettes;
  const generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
    const colorBgBase = bgBaseColor || "#fff";
    const colorTextBase = textBaseColor || "#000";
    return {
      colorBgBase,
      colorTextBase,
      colorText: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.88),
      colorTextSecondary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.65),
      colorTextTertiary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.45),
      colorTextQuaternary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.25),
      colorFill: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.15),
      colorFillSecondary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.06),
      colorFillTertiary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.04),
      colorFillQuaternary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.02),
      colorBgSolid: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 1),
      colorBgSolidHover: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.75),
      colorBgSolidActive: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.95),
      colorBgLayout: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 4),
      colorBgContainer: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 0),
      colorBgElevated: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 0),
      colorBgSpotlight: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.85),
      colorBgBlur: "transparent",
      colorBorder: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 15),
      colorBorderSecondary: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 6)
    };
  };
  colors.generateNeutralColorPalettes = generateNeutralColorPalettes;
  return colors;
}
var hasRequired_default;
function require_default() {
  if (hasRequired_default) return _default;
  hasRequired_default = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(_default, "__esModule", {
    value: true
  });
  _default.default = derivative;
  var _colors = require$$8;
  var _seed = /* @__PURE__ */ requireSeed();
  var _genColorMapToken = _interopRequireDefault(/* @__PURE__ */ requireGenColorMapToken());
  var _genCommonMapToken = _interopRequireDefault(/* @__PURE__ */ requireGenCommonMapToken());
  var _genControlHeight = _interopRequireDefault(/* @__PURE__ */ requireGenControlHeight());
  var _genFontMapToken = _interopRequireDefault(/* @__PURE__ */ requireGenFontMapToken());
  var _genSizeMapToken = _interopRequireDefault(/* @__PURE__ */ requireGenSizeMapToken());
  var _colors2 = /* @__PURE__ */ requireColors();
  function derivative(token2) {
    _colors.presetPrimaryColors.pink = _colors.presetPrimaryColors.magenta;
    _colors.presetPalettes.pink = _colors.presetPalettes.magenta;
    const colorPalettes = Object.keys(_seed.defaultPresetColors).map((colorKey) => {
      const colors2 = token2[colorKey] === _colors.presetPrimaryColors[colorKey] ? _colors.presetPalettes[colorKey] : (0, _colors.generate)(token2[colorKey]);
      return Array.from({
        length: 10
      }, () => 1).reduce((prev4, _2, i) => {
        prev4[`${colorKey}-${i + 1}`] = colors2[i];
        prev4[`${colorKey}${i + 1}`] = colors2[i];
        return prev4;
      }, {});
    }).reduce((prev4, cur) => {
      prev4 = Object.assign(Object.assign({}, prev4), cur);
      return prev4;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token2), colorPalettes), (0, _genColorMapToken.default)(token2, {
      generateColorPalettes: _colors2.generateColorPalettes,
      generateNeutralColorPalettes: _colors2.generateNeutralColorPalettes
    })), (0, _genFontMapToken.default)(token2.fontSize)), (0, _genSizeMapToken.default)(token2)), (0, _genControlHeight.default)(token2)), (0, _genCommonMapToken.default)(token2));
  }
  return _default;
}
var hasRequiredTheme;
function requireTheme() {
  if (hasRequiredTheme) return theme;
  hasRequiredTheme = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(theme, "__esModule", {
    value: true
  });
  theme.default = void 0;
  var _cssinjs = require$$2$2;
  var _index = _interopRequireDefault(/* @__PURE__ */ require_default());
  const defaultTheme = (0, _cssinjs.createTheme)(_index.default);
  theme.default = defaultTheme;
  return theme;
}
var hasRequiredContext$2;
function requireContext$2() {
  if (hasRequiredContext$2) return context$2;
  hasRequiredContext$2 = 1;
  (function(exports$1) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.defaultConfig = exports$1.DesignTokenContext = void 0;
    Object.defineProperty(exports$1, "defaultTheme", {
      enumerable: true,
      get: function() {
        return _theme.default;
      }
    });
    var _react = _interopRequireDefault(React__default);
    var _seed = _interopRequireDefault(/* @__PURE__ */ requireSeed());
    var _theme = _interopRequireDefault(/* @__PURE__ */ requireTheme());
    const defaultConfig = exports$1.defaultConfig = {
      token: _seed.default,
      override: {
        override: _seed.default
      },
      hashed: true
    };
    exports$1.DesignTokenContext = /* @__PURE__ */ _react.default.createContext(defaultConfig);
  })(context$2);
  return context$2;
}
var context$1 = {};
var hasRequiredContext$1;
function requireContext$1() {
  if (hasRequiredContext$1) return context$1;
  hasRequiredContext$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(context$1, "__esModule", {
    value: true
  });
  context$1.defaultPrefixCls = context$1.defaultIconPrefixCls = context$1.Variants = context$1.ConfigContext = context$1.ConfigConsumer = void 0;
  context$1.useComponentConfig = useComponentConfig;
  var React2 = _interopRequireWildcard(React__default);
  const defaultPrefixCls = context$1.defaultPrefixCls = "ant";
  const defaultIconPrefixCls = context$1.defaultIconPrefixCls = "anticon";
  context$1.Variants = ["outlined", "borderless", "filled", "underlined"];
  const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
  };
  const ConfigContext = context$1.ConfigContext = /* @__PURE__ */ React2.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: defaultGetPrefixCls,
    iconPrefixCls: defaultIconPrefixCls
  });
  const {
    Consumer: ConfigConsumer
  } = ConfigContext;
  context$1.ConfigConsumer = ConfigConsumer;
  const EMPTY_OBJECT2 = {};
  function useComponentConfig(propName) {
    const context2 = React2.useContext(ConfigContext);
    const {
      getPrefixCls,
      direction,
      getPopupContainer
    } = context2;
    const propValue = context2[propName];
    return Object.assign(Object.assign({
      classNames: EMPTY_OBJECT2,
      styles: EMPTY_OBJECT2
    }, propValue), {
      getPrefixCls,
      direction,
      getPopupContainer
    });
  }
  return context$1;
}
var cssVariables = {};
var canUseDom = {};
var hasRequiredCanUseDom;
function requireCanUseDom() {
  if (hasRequiredCanUseDom) return canUseDom;
  hasRequiredCanUseDom = 1;
  Object.defineProperty(canUseDom, "__esModule", {
    value: true
  });
  canUseDom.default = canUseDom$12;
  function canUseDom$12() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
  }
  return canUseDom;
}
var dynamicCSS = {};
var contains = {};
var hasRequiredContains;
function requireContains() {
  if (hasRequiredContains) return contains;
  hasRequiredContains = 1;
  Object.defineProperty(contains, "__esModule", {
    value: true
  });
  contains.default = contains$12;
  function contains$12(root, n) {
    if (!root) {
      return false;
    }
    if (root.contains) {
      return root.contains(n);
    }
    var node2 = n;
    while (node2) {
      if (node2 === root) {
        return true;
      }
      node2 = node2.parentNode;
    }
    return false;
  }
  return contains;
}
var hasRequiredDynamicCSS;
function requireDynamicCSS() {
  if (hasRequiredDynamicCSS) return dynamicCSS;
  hasRequiredDynamicCSS = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(dynamicCSS, "__esModule", {
    value: true
  });
  dynamicCSS.clearContainerCache = clearContainerCache;
  dynamicCSS.injectCSS = injectCSS2;
  dynamicCSS.removeCSS = removeCSS2;
  dynamicCSS.updateCSS = updateCSS2;
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var _canUseDom = _interopRequireDefault(requireCanUseDom());
  var _contains = _interopRequireDefault(requireContains());
  var APPEND_ORDER2 = "data-rc-order";
  var APPEND_PRIORITY2 = "data-rc-priority";
  var MARK_KEY2 = "rc-util-key";
  var containerCache2 = /* @__PURE__ */ new Map();
  function getMark2() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
    if (mark) {
      return mark.startsWith("data-") ? mark : "data-".concat(mark);
    }
    return MARK_KEY2;
  }
  function getContainer2(option) {
    if (option.attachTo) {
      return option.attachTo;
    }
    var head = document.querySelector("head");
    return head || document.body;
  }
  function getOrder2(prepend) {
    if (prepend === "queue") {
      return "prependQueue";
    }
    return prepend ? "prepend" : "append";
  }
  function findStyles2(container) {
    return Array.from((containerCache2.get(container) || container).children).filter(function(node2) {
      return node2.tagName === "STYLE";
    });
  }
  function injectCSS2(css2) {
    var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(0, _canUseDom.default)()) {
      return null;
    }
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = getOrder2(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute(APPEND_ORDER2, mergedOrder);
    if (isPrependQueue && priority) {
      styleNode.setAttribute(APPEND_PRIORITY2, "".concat(priority));
    }
    if (csp !== null && csp !== void 0 && csp.nonce) {
      styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    }
    styleNode.innerHTML = css2;
    var container = getContainer2(option);
    var firstChild = container.firstChild;
    if (prepend) {
      if (isPrependQueue) {
        var existStyle = (option.styles || findStyles2(container)).filter(function(node2) {
          if (!["prepend", "prependQueue"].includes(node2.getAttribute(APPEND_ORDER2))) {
            return false;
          }
          var nodePriority = Number(node2.getAttribute(APPEND_PRIORITY2) || 0);
          return priority >= nodePriority;
        });
        if (existStyle.length) {
          container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
          return styleNode;
        }
      }
      container.insertBefore(styleNode, firstChild);
    } else {
      container.appendChild(styleNode);
    }
    return styleNode;
  }
  function findExistNode2(key) {
    var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var container = getContainer2(option);
    return (option.styles || findStyles2(container)).find(function(node2) {
      return node2.getAttribute(getMark2(option)) === key;
    });
  }
  function removeCSS2(key) {
    var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var existNode = findExistNode2(key, option);
    if (existNode) {
      var container = getContainer2(option);
      container.removeChild(existNode);
    }
  }
  function syncRealContainer2(container, option) {
    var cachedRealContainer = containerCache2.get(container);
    if (!cachedRealContainer || !(0, _contains.default)(document, cachedRealContainer)) {
      var placeholderStyle = injectCSS2("", option);
      var parentNode = placeholderStyle.parentNode;
      containerCache2.set(container, parentNode);
      container.removeChild(placeholderStyle);
    }
  }
  function clearContainerCache() {
    containerCache2.clear();
  }
  function updateCSS2(css2, key) {
    var originOption = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var container = getContainer2(originOption);
    var styles2 = findStyles2(container);
    var option = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, originOption), {}, {
      styles: styles2
    });
    syncRealContainer2(container, option);
    var existNode = findExistNode2(key, option);
    if (existNode) {
      var _option$csp, _option$csp2;
      if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
        var _option$csp3;
        existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
      }
      if (existNode.innerHTML !== css2) {
        existNode.innerHTML = css2;
      }
      return existNode;
    }
    var newNode = injectCSS2(css2, option);
    newNode.setAttribute(getMark2(option), key);
    return newNode;
  }
  return dynamicCSS;
}
var hasRequiredCssVariables;
function requireCssVariables() {
  if (hasRequiredCssVariables) return cssVariables;
  hasRequiredCssVariables = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(cssVariables, "__esModule", {
    value: true
  });
  cssVariables.getStyle = getStyle;
  cssVariables.registerTheme = registerTheme;
  var _colors = require$$8;
  var _fastColor = require$$2$1;
  var _canUseDom = _interopRequireDefault(requireCanUseDom());
  var _dynamicCSS = requireDynamicCSS();
  var _warning = _interopRequireDefault(/* @__PURE__ */ requireWarning());
  const dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
  function getStyle(globalPrefixCls, theme2) {
    const variables = {};
    const formatColor = (color2, updater) => {
      let clone = color2.clone();
      clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
      return clone.toRgbString();
    };
    const fillColor = (colorVal, type4) => {
      const baseColor = new _fastColor.FastColor(colorVal);
      const colorPalettes = (0, _colors.generate)(baseColor.toRgbString());
      variables[`${type4}-color`] = formatColor(baseColor);
      variables[`${type4}-color-disabled`] = colorPalettes[1];
      variables[`${type4}-color-hover`] = colorPalettes[4];
      variables[`${type4}-color-active`] = colorPalettes[6];
      variables[`${type4}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
      variables[`${type4}-color-deprecated-bg`] = colorPalettes[0];
      variables[`${type4}-color-deprecated-border`] = colorPalettes[2];
    };
    if (theme2.primaryColor) {
      fillColor(theme2.primaryColor, "primary");
      const primaryColor = new _fastColor.FastColor(theme2.primaryColor);
      const primaryColors = (0, _colors.generate)(primaryColor.toRgbString());
      primaryColors.forEach((color2, index2) => {
        variables[`primary-${index2 + 1}`] = color2;
      });
      variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, (c) => c.lighten(35));
      variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, (c) => c.lighten(20));
      variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, (c) => c.tint(20));
      variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, (c) => c.tint(50));
      variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, (c) => c.setA(c.a * 0.12));
      const primaryActiveColor = new _fastColor.FastColor(primaryColors[0]);
      variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, (c) => c.setA(c.a * 0.3));
      variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, (c) => c.darken(2));
    }
    if (theme2.successColor) {
      fillColor(theme2.successColor, "success");
    }
    if (theme2.warningColor) {
      fillColor(theme2.warningColor, "warning");
    }
    if (theme2.errorColor) {
      fillColor(theme2.errorColor, "error");
    }
    if (theme2.infoColor) {
      fillColor(theme2.infoColor, "info");
    }
    const cssList = Object.keys(variables).map((key) => `--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join("\n")}
  }
  `.trim();
  }
  function registerTheme(globalPrefixCls, theme2) {
    const style2 = getStyle(globalPrefixCls, theme2);
    if ((0, _canUseDom.default)()) {
      (0, _dynamicCSS.updateCSS)(style2, `${dynamicStyleMark}-dynamic-theme`);
    } else {
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.") : void 0;
    }
  }
  return cssVariables;
}
var DisabledContext = {};
var hasRequiredDisabledContext;
function requireDisabledContext() {
  if (hasRequiredDisabledContext) return DisabledContext;
  hasRequiredDisabledContext = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(DisabledContext, "__esModule", {
    value: true
  });
  DisabledContext.default = DisabledContext.DisabledContextProvider = void 0;
  var React2 = _interopRequireWildcard(React__default);
  const DisabledContext$1 = /* @__PURE__ */ React2.createContext(false);
  const DisabledContextProvider = (_ref) => {
    let {
      children: children2,
      disabled
    } = _ref;
    const originDisabled = React2.useContext(DisabledContext$1);
    return /* @__PURE__ */ React2.createElement(DisabledContext$1.Provider, {
      value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children2);
  };
  DisabledContext.DisabledContextProvider = DisabledContextProvider;
  DisabledContext.default = DisabledContext$1;
  return DisabledContext;
}
var useConfig = {};
var SizeContext = {};
var hasRequiredSizeContext;
function requireSizeContext() {
  if (hasRequiredSizeContext) return SizeContext;
  hasRequiredSizeContext = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(SizeContext, "__esModule", {
    value: true
  });
  SizeContext.default = SizeContext.SizeContextProvider = void 0;
  var React2 = _interopRequireWildcard(React__default);
  const SizeContext$1 = /* @__PURE__ */ React2.createContext(void 0);
  const SizeContextProvider = (_ref) => {
    let {
      children: children2,
      size: size2
    } = _ref;
    const originSize = React2.useContext(SizeContext$1);
    return /* @__PURE__ */ React2.createElement(SizeContext$1.Provider, {
      value: size2 || originSize
    }, children2);
  };
  SizeContext.SizeContextProvider = SizeContextProvider;
  SizeContext.default = SizeContext$1;
  return SizeContext;
}
var hasRequiredUseConfig;
function requireUseConfig() {
  if (hasRequiredUseConfig) return useConfig;
  hasRequiredUseConfig = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useConfig, "__esModule", {
    value: true
  });
  useConfig.default = void 0;
  var _react = React__default;
  var _DisabledContext = _interopRequireDefault(/* @__PURE__ */ requireDisabledContext());
  var _SizeContext = _interopRequireDefault(/* @__PURE__ */ requireSizeContext());
  function useConfig$1() {
    const componentDisabled = (0, _react.useContext)(_DisabledContext.default);
    const componentSize = (0, _react.useContext)(_SizeContext.default);
    return {
      componentDisabled,
      componentSize
    };
  }
  useConfig.default = useConfig$1;
  return useConfig;
}
var useTheme = {};
var isEqual3 = {};
var hasRequiredIsEqual;
function requireIsEqual() {
  if (hasRequiredIsEqual) return isEqual3;
  hasRequiredIsEqual = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(isEqual3, "__esModule", {
    value: true
  });
  isEqual3.default = void 0;
  var _typeof2 = _interopRequireDefault(require_typeof());
  var _warning = _interopRequireDefault(requireWarning$1());
  function isEqual$12(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var refSet = /* @__PURE__ */ new Set();
    function deepEqual2(a, b) {
      var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      var circular = refSet.has(a);
      (0, _warning.default)(!circular, "Warning: There may be circular references");
      if (circular) {
        return false;
      }
      if (a === b) {
        return true;
      }
      if (shallow && level > 1) {
        return false;
      }
      refSet.add(a);
      var newLevel = level + 1;
      if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) {
          return false;
        }
        for (var i = 0; i < a.length; i++) {
          if (!deepEqual2(a[i], b[i], newLevel)) {
            return false;
          }
        }
        return true;
      }
      if (a && b && (0, _typeof2.default)(a) === "object" && (0, _typeof2.default)(b) === "object") {
        var keys2 = Object.keys(a);
        if (keys2.length !== Object.keys(b).length) {
          return false;
        }
        return keys2.every(function(key) {
          return deepEqual2(a[key], b[key], newLevel);
        });
      }
      return false;
    }
    return deepEqual2(obj1, obj2);
  }
  isEqual3.default = isEqual$12;
  return isEqual3;
}
var internal = {};
function _arrayWithHoles(r2) {
  if (Array.isArray(r2)) return r2;
}
function _iterableToArrayLimit(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r2, a) {
  (null == a || a > r2.length) && (a = r2.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r2[e];
  return n;
}
function _unsupportedIterableToArray(r2, a) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a);
    var t = {}.toString.call(r2).slice(8, -1);
    return "Object" === t && r2.constructor && (t = r2.constructor.name), "Map" === t || "Set" === t ? Array.from(r2) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r2, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r2, e) {
  return _arrayWithHoles(r2) || _iterableToArrayLimit(r2, e) || _unsupportedIterableToArray(r2, e) || _nonIterableRest();
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey$1(o.key), o);
  }
}
function _createClass(e, r2, t) {
  return r2 && _defineProperties(e.prototype, r2), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
function _isNativeReflectConstruct$f() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$3(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _createSuper(t) {
  var r2 = _isNativeReflectConstruct$f();
  return function() {
    var e, o = _getPrototypeOf(t);
    if (r2) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
var AbstractCalculator2 = /* @__PURE__ */ _createClass(function AbstractCalculator3() {
  _classCallCheck(this, AbstractCalculator3);
});
var CALC_UNIT = "CALC_UNIT";
var regexp$1 = new RegExp(CALC_UNIT, "g");
function unit(value) {
  if (typeof value === "number") {
    return "".concat(value).concat(CALC_UNIT);
  }
  return value;
}
var CSSCalculator = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits(CSSCalculator2, _AbstractCalculator);
  var _super = _createSuper(CSSCalculator2);
  function CSSCalculator2(num, unitlessCssVar) {
    var _this;
    _classCallCheck(this, CSSCalculator2);
    _this = _super.call(this);
    _defineProperty$1(_assertThisInitialized$1(_this), "result", "");
    _defineProperty$1(_assertThisInitialized$1(_this), "unitlessCssVar", void 0);
    _defineProperty$1(_assertThisInitialized$1(_this), "lowPriority", void 0);
    var numType = _typeof$3(num);
    _this.unitlessCssVar = unitlessCssVar;
    if (num instanceof CSSCalculator2) {
      _this.result = "(".concat(num.result, ")");
    } else if (numType === "number") {
      _this.result = unit(num);
    } else if (numType === "string") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(CSSCalculator2, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " + ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " + ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " - ").concat(num.getResult());
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " - ").concat(unit(num));
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " * ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " * ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = "(".concat(this.result, ")");
      }
      if (num instanceof CSSCalculator2) {
        this.result = "".concat(this.result, " / ").concat(num.getResult(true));
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = "".concat(this.result, " / ").concat(num);
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      var _this2 = this;
      var _ref = options || {}, cssUnit = _ref.unit;
      var mergedUnit = true;
      if (typeof cssUnit === "boolean") {
        mergedUnit = cssUnit;
      } else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
        return _this2.result.includes(cssVar);
      })) {
        mergedUnit = false;
      }
      this.result = this.result.replace(regexp$1, mergedUnit ? "px" : "");
      if (typeof this.lowPriority !== "undefined") {
        return "calc(".concat(this.result, ")");
      }
      return this.result;
    }
  }]);
  return CSSCalculator2;
})(AbstractCalculator2);
var NumCalculator = /* @__PURE__ */ (function(_AbstractCalculator) {
  _inherits(NumCalculator2, _AbstractCalculator);
  var _super = _createSuper(NumCalculator2);
  function NumCalculator2(num) {
    var _this;
    _classCallCheck(this, NumCalculator2);
    _this = _super.call(this);
    _defineProperty$1(_assertThisInitialized$1(_this), "result", 0);
    if (num instanceof NumCalculator2) {
      _this.result = num.result;
    } else if (typeof num === "number") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(NumCalculator2, [{
    key: "add",
    value: function add3(num) {
      if (num instanceof NumCalculator2) {
        this.result += num.result;
      } else if (typeof num === "number") {
        this.result += num;
      }
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof NumCalculator2) {
        this.result -= num.result;
      } else if (typeof num === "number") {
        this.result -= num;
      }
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (num instanceof NumCalculator2) {
        this.result *= num.result;
      } else if (typeof num === "number") {
        this.result *= num;
      }
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (num instanceof NumCalculator2) {
        this.result /= num.result;
      } else if (typeof num === "number") {
        this.result /= num;
      }
      return this;
    }
  }, {
    key: "equal",
    value: function equal() {
      return this.result;
    }
  }]);
  return NumCalculator2;
})(AbstractCalculator2);
var genCalc2 = function genCalc3(type4, unitlessCssVar) {
  var Calculator = type4 === "css" ? CSSCalculator : NumCalculator;
  return function(num) {
    return new Calculator(num, unitlessCssVar);
  };
};
var getCompVarPrefix = function getCompVarPrefix2(component, prefix2) {
  return "".concat([prefix2, component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function useEvent$1(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue), _React$useState2 = _slicedToArray(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
  React.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}
function hasValue(value) {
  return value !== void 0;
}
function useMergedState$1(defaultStateValue, option) {
  var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange5 = _ref.onChange, postState = _ref.postState;
  var _useState = useSafeState(function() {
    if (hasValue(value)) {
      return value;
    } else if (hasValue(defaultValue)) {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    } else {
      return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }
  }), _useState2 = _slicedToArray(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
  var mergedValue = value !== void 0 ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;
  var onChangeFn = useEvent$1(onChange5);
  var _useState3 = useSafeState([mergedValue]), _useState4 = _slicedToArray(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function() {
    var prev4 = prevValue[0];
    if (innerValue !== prev4) {
      onChangeFn(innerValue, prev4);
    }
  }, [prevValue]);
  useLayoutUpdateEffect(function() {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);
  var triggerChange = useEvent$1(function(updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
  u = Symbol.for("react.module.reference");
  function v(a) {
    if ("object" === typeof a && null !== a) {
      var r2 = a.$$typeof;
      switch (r2) {
        case b:
          switch (a = a.type, a) {
            case d:
            case f:
            case e:
            case m:
            case n:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case h:
                case l:
                case q:
                case p:
                case g:
                  return a;
                default:
                  return r2;
              }
          }
        case c:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h;
  reactIs_production_min.ContextProvider = g;
  reactIs_production_min.Element = b;
  reactIs_production_min.ForwardRef = l;
  reactIs_production_min.Fragment = d;
  reactIs_production_min.Lazy = q;
  reactIs_production_min.Memo = p;
  reactIs_production_min.Portal = c;
  reactIs_production_min.Profiler = f;
  reactIs_production_min.StrictMode = e;
  reactIs_production_min.Suspense = m;
  reactIs_production_min.SuspenseList = n;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a) {
    return v(a) === h;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return v(a) === g;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return v(a) === l;
  };
  reactIs_production_min.isFragment = function(a) {
    return v(a) === d;
  };
  reactIs_production_min.isLazy = function(a) {
    return v(a) === q;
  };
  reactIs_production_min.isMemo = function(a) {
    return v(a) === p;
  };
  reactIs_production_min.isPortal = function(a) {
    return v(a) === c;
  };
  reactIs_production_min.isProfiler = function(a) {
    return v(a) === f;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return v(a) === e;
  };
  reactIs_production_min.isSuspense = function(a) {
    return v(a) === m;
  };
  reactIs_production_min.isSuspenseList = function(a) {
    return v(a) === n;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v;
  return reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE2 = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type4) {
        if (typeof type4 === "string" || typeof type4 === "function") {
          return true;
        }
        if (type4 === REACT_FRAGMENT_TYPE2 || type4 === REACT_PROFILER_TYPE || enableDebugTracing || type4 === REACT_STRICT_MODE_TYPE || type4 === REACT_SUSPENSE_TYPE || type4 === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type4 === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type4 === "object" && type4 !== null) {
          if (type4.$$typeof === REACT_LAZY_TYPE || type4.$$typeof === REACT_MEMO_TYPE || type4.$$typeof === REACT_PROVIDER_TYPE || type4.$$typeof === REACT_CONTEXT_TYPE || type4.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type4.$$typeof === REACT_MODULE_REFERENCE || type4.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object4) {
        if (typeof object4 === "object" && object4 !== null) {
          var $$typeof = object4.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type4 = object4.type;
              switch (type4) {
                case REACT_FRAGMENT_TYPE2:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type4;
                default:
                  var $$typeofType = type4 && type4.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE2;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object4) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object4) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object4) {
        return typeOf(object4) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object4) {
        return typeOf(object4) === REACT_PROVIDER_TYPE;
      }
      function isElement(object4) {
        return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object4) {
        return typeOf(object4) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment2(object4) {
        return typeOf(object4) === REACT_FRAGMENT_TYPE2;
      }
      function isLazy(object4) {
        return typeOf(object4) === REACT_LAZY_TYPE;
      }
      function isMemo(object4) {
        return typeOf(object4) === REACT_MEMO_TYPE;
      }
      function isPortal(object4) {
        return typeOf(object4) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object4) {
        return typeOf(object4) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object4) {
        return typeOf(object4) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object4) {
        return typeOf(object4) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object4) {
        return typeOf(object4) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment2;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var reactIsExports = requireReactIs();
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element");
var REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element");
var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment$1(object4) {
  return (
    // Base object type
    object4 && _typeof$3(object4) === "object" && // React Element type
    (object4.$$typeof === REACT_ELEMENT_TYPE_18 || object4.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object4.type === REACT_FRAGMENT_TYPE
  );
}
var ReactMajorVersion = Number(version$3.split(".")[0]);
var fillRef = function fillRef2(ref2, node2) {
  if (typeof ref2 === "function") {
    ref2(node2);
  } else if (_typeof$3(ref2) === "object" && ref2 && "current" in ref2) {
    ref2.current = node2;
  }
};
var composeRef = function composeRef2() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(Boolean);
  if (refList.length <= 1) {
    return refList[0];
  }
  return function(node2) {
    refs.forEach(function(ref2) {
      fillRef(ref2, node2);
    });
  };
};
var useComposeRef = function useComposeRef2() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo$1(function() {
    return composeRef.apply(void 0, refs);
  }, refs, function(prev4, next4) {
    return prev4.length !== next4.length || prev4.every(function(ref2, i) {
      return ref2 !== next4[i];
    });
  });
};
var supportRef = function supportRef2(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  if (!nodeOrComponent) {
    return false;
  }
  if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) {
    return true;
  }
  var type4 = reactIsExports.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type4 === "function" && !((_type$prototype = type4.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type4.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== reactIsExports.ForwardRef) {
    return false;
  }
  return true;
};
function isReactElement(node2) {
  return /* @__PURE__ */ isValidElement(node2) && !isFragment$1(node2);
}
var getNodeRef = function getNodeRef2(node2) {
  if (node2 && isReactElement(node2)) {
    var ele = node2;
    return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
  }
  return null;
};
function get$2(entity, path2) {
  var current = entity;
  for (var i = 0; i < path2.length; i += 1) {
    if (current === null || current === void 0) {
      return void 0;
    }
    current = current[path2[i]];
  }
  return current;
}
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray(r2);
}
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableSpread();
}
function _toArray(r2) {
  return _arrayWithHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableRest();
}
function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = _toArray(paths), path2 = _paths[0], restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path2 === "number") {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = _toConsumableArray(entity);
  } else {
    clone = _objectSpread2$1({}, entity);
  }
  if (removeIfUndefined && value === void 0 && restPath.length === 1) {
    delete clone[path2][restPath[0]];
  } else {
    clone[path2] = internalSet(clone[path2], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set$1(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (paths.length && removeIfUndefined && value === void 0 && !get$2(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return _typeof$3(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function merge$2() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function(src) {
    function internalMerge(path2, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = get$2(src, path2);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = get$2(clone, path2);
          if (isArr) {
            clone = set$1(clone, path2, []);
          } else if (!originValue || _typeof$3(originValue) !== "object") {
            clone = set$1(clone, path2, createEmpty(value));
          }
          keys(value).forEach(function(key) {
            internalMerge([].concat(_toConsumableArray(path2), [key]), loopSet);
          });
        }
      } else {
        clone = set$1(clone, path2, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}
function getComponentToken(component, token2, defaultToken, options) {
  var customToken = _objectSpread2$1({}, token2[component]);
  if (options !== null && options !== void 0 && options.deprecatedTokens) {
    var deprecatedTokens = options.deprecatedTokens;
    deprecatedTokens.forEach(function(_ref) {
      var _ref2 = _slicedToArray(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
      if (process.env.NODE_ENV !== "production") {
        warningOnce(!(customToken !== null && customToken !== void 0 && customToken[oldTokenKey]), "Component Token `".concat(String(oldTokenKey), "` of ").concat(String(component), " is deprecated. Please use `").concat(String(newTokenKey), "` instead."));
      }
      if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
        var _customToken$newToken;
        (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
      }
    });
  }
  var mergedToken = _objectSpread2$1(_objectSpread2$1({}, defaultToken), customToken);
  Object.keys(mergedToken).forEach(function(key) {
    if (mergedToken[key] === token2[key]) {
      delete mergedToken[key];
    }
  });
  return mergedToken;
}
var enableStatistic = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC !== "undefined";
var recording = true;
function merge$1() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  if (!enableStatistic) {
    return Object.assign.apply(Object, [{}].concat(objs));
  }
  recording = false;
  var ret = {};
  objs.forEach(function(obj) {
    if (_typeof$3(obj) !== "object") {
      return;
    }
    var keys2 = Object.keys(obj);
    keys2.forEach(function(key) {
      Object.defineProperty(ret, key, {
        configurable: true,
        enumerable: true,
        get: function get4() {
          return obj[key];
        }
      });
    });
  });
  recording = true;
  return ret;
}
var statistic = {};
function noop$1() {
}
var statisticToken = function statisticToken2(token2) {
  var tokenKeys2;
  var proxy = token2;
  var flush = noop$1;
  if (enableStatistic && typeof Proxy !== "undefined") {
    tokenKeys2 = /* @__PURE__ */ new Set();
    proxy = new Proxy(token2, {
      get: function get4(obj, prop) {
        if (recording) {
          var _tokenKeys;
          (_tokenKeys = tokenKeys2) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
        }
        return obj[prop];
      }
    });
    flush = function flush2(componentName, componentToken) {
      var _statistic$componentN;
      statistic[componentName] = {
        global: Array.from(tokenKeys2),
        component: _objectSpread2$1(_objectSpread2$1({}, (_statistic$componentN = statistic[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
      };
    };
  }
  return {
    token: proxy,
    keys: tokenKeys2,
    flush
  };
};
function getDefaultComponentToken(component, token2, getDefaultToken) {
  if (typeof getDefaultToken === "function") {
    var _token$component;
    return getDefaultToken(merge$1(token2, (_token$component = token2[component]) !== null && _token$component !== void 0 ? _token$component : {}));
  }
  return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
function genMaxMin(type4) {
  if (type4 === "js") {
    return {
      max: Math.max,
      min: Math.min
    };
  }
  return {
    max: function max2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return "max(".concat(args.map(function(value) {
        return unit$1(value);
      }).join(","), ")");
    },
    min: function min2() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return "min(".concat(args.map(function(value) {
        return unit$1(value);
      }).join(","), ")");
    }
  };
}
var BEAT_LIMIT = 1e3 * 60 * 10;
var ArrayKeyMap = /* @__PURE__ */ (function() {
  function ArrayKeyMap2() {
    _classCallCheck(this, ArrayKeyMap2);
    _defineProperty$1(this, "map", /* @__PURE__ */ new Map());
    _defineProperty$1(this, "objectIDMap", /* @__PURE__ */ new WeakMap());
    _defineProperty$1(this, "nextID", 0);
    _defineProperty$1(this, "lastAccessBeat", /* @__PURE__ */ new Map());
    _defineProperty$1(this, "accessBeat", 0);
  }
  _createClass(ArrayKeyMap2, [{
    key: "set",
    value: function set2(keys2, value) {
      this.clear();
      var compositeKey = this.getCompositeKey(keys2);
      this.map.set(compositeKey, value);
      this.lastAccessBeat.set(compositeKey, Date.now());
    }
  }, {
    key: "get",
    value: function get4(keys2) {
      var compositeKey = this.getCompositeKey(keys2);
      var cache2 = this.map.get(compositeKey);
      this.lastAccessBeat.set(compositeKey, Date.now());
      this.accessBeat += 1;
      return cache2;
    }
  }, {
    key: "getCompositeKey",
    value: function getCompositeKey(keys2) {
      var _this = this;
      var ids = keys2.map(function(key) {
        if (key && _typeof$3(key) === "object") {
          return "obj_".concat(_this.getObjectID(key));
        }
        return "".concat(_typeof$3(key), "_").concat(key);
      });
      return ids.join("|");
    }
  }, {
    key: "getObjectID",
    value: function getObjectID(obj) {
      if (this.objectIDMap.has(obj)) {
        return this.objectIDMap.get(obj);
      }
      var id2 = this.nextID;
      this.objectIDMap.set(obj, id2);
      this.nextID += 1;
      return id2;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      if (this.accessBeat > 1e4) {
        var now = Date.now();
        this.lastAccessBeat.forEach(function(beat, key) {
          if (now - beat > BEAT_LIMIT) {
            _this2.map.delete(key);
            _this2.lastAccessBeat.delete(key);
          }
        });
        this.accessBeat = 0;
      }
    }
  }]);
  return ArrayKeyMap2;
})();
var uniqueMap = new ArrayKeyMap();
function useUniqueMemo(memoFn, deps) {
  return React__default.useMemo(function() {
    var cachedValue = uniqueMap.get(deps);
    if (cachedValue) {
      return cachedValue;
    }
    var newValue = memoFn();
    uniqueMap.set(deps, newValue);
    return newValue;
  }, deps);
}
var useDefaultCSP = function useDefaultCSP2() {
  return {};
};
function genStyleUtils$1(config2) {
  var _config$useCSP = config2.useCSP, useCSP = _config$useCSP === void 0 ? useDefaultCSP : _config$useCSP, useToken2 = config2.useToken, usePrefix = config2.usePrefix, getResetStyles = config2.getResetStyles, getCommonStyle = config2.getCommonStyle, getCompUnitless = config2.getCompUnitless;
  function genStyleHooks(component, styleFn, getDefaultToken, options) {
    var componentName = Array.isArray(component) ? component[0] : component;
    function prefixToken(key) {
      return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
    }
    var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
    var originCompUnitless = typeof getCompUnitless === "function" ? getCompUnitless(component) : {};
    var compUnitless = _objectSpread2$1(_objectSpread2$1({}, originCompUnitless), {}, _defineProperty$1({}, prefixToken("zIndexPopup"), true));
    Object.keys(originUnitless).forEach(function(key) {
      compUnitless[prefixToken(key)] = originUnitless[key];
    });
    var mergedOptions = _objectSpread2$1(_objectSpread2$1({}, options), {}, {
      unitless: compUnitless,
      prefixToken
    });
    var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
    var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
    return function(prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : prefixCls;
      var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = _slicedToArray(_useStyle, 2), hashId = _useStyle2[1];
      var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = _slicedToArray(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
      return [wrapCSSVar, hashId, cssVarCls];
    };
  }
  function genCSSVarRegister(component, getDefaultToken, options) {
    var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore = options.ignore;
    var CSSVarRegister = function CSSVarRegister2(_ref) {
      var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
      var _useToken = useToken2(), realToken = _useToken.realToken;
      useCSSVarRegister({
        path: [component],
        prefix: cssVar.prefix,
        key: cssVar.key,
        unitless: compUnitless,
        ignore,
        token: realToken,
        scope: rootCls
      }, function() {
        var defaultToken = getDefaultComponentToken(component, realToken, getDefaultToken);
        var componentToken = getComponentToken(component, realToken, defaultToken, {
          deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
        });
        Object.keys(defaultToken).forEach(function(key) {
          componentToken[prefixToken(key)] = componentToken[key];
          delete componentToken[key];
        });
        return componentToken;
      });
      return null;
    };
    var useCSSVar = function useCSSVar2(rootCls) {
      var _useToken2 = useToken2(), cssVar = _useToken2.cssVar;
      return [function(node2) {
        return injectStyle && cssVar ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(CSSVarRegister, {
          rootCls,
          cssVar,
          component
        }), node2) : node2;
      }, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key];
    };
    return useCSSVar;
  }
  function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var cells = Array.isArray(componentName) ? componentName : [componentName, componentName];
    var _cells = _slicedToArray(cells, 1), component = _cells[0];
    var concatComponent = cells.join("-");
    var mergedLayer = config2.layer || {
      name: "antd"
    };
    return function(prefixCls) {
      var rootCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : prefixCls;
      var _useToken3 = useToken2(), theme2 = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token2 = _useToken3.token, cssVar = _useToken3.cssVar;
      var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
      var csp = useCSP();
      var type4 = cssVar ? "css" : "js";
      var calc = useUniqueMemo(function() {
        var unitlessCssVar = /* @__PURE__ */ new Set();
        if (cssVar) {
          Object.keys(options.unitless || {}).forEach(function(key) {
            unitlessCssVar.add(token2CSSVar(key, cssVar.prefix));
            unitlessCssVar.add(token2CSSVar(key, getCompVarPrefix(component, cssVar.prefix)));
          });
        }
        return genCalc2(type4, unitlessCssVar);
      }, [type4, component, cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix]);
      var _genMaxMin = genMaxMin(type4), max2 = _genMaxMin.max, min2 = _genMaxMin.min;
      var sharedConfig = {
        theme: theme2,
        token: token2,
        hashId,
        nonce: function nonce() {
          return csp.nonce;
        },
        clientOnly: options.clientOnly,
        layer: mergedLayer,
        // antd is always at top of styles
        order: options.order || -999
      };
      if (typeof getResetStyles === "function") {
        useStyleRegister(_objectSpread2$1(_objectSpread2$1({}, sharedConfig), {}, {
          clientOnly: false,
          path: ["Shared", rootPrefixCls]
        }), function() {
          return getResetStyles(token2, {
            prefix: {
              rootPrefixCls,
              iconPrefixCls
            },
            csp
          });
        });
      }
      var wrapSSR = useStyleRegister(_objectSpread2$1(_objectSpread2$1({}, sharedConfig), {}, {
        path: [concatComponent, prefixCls, iconPrefixCls]
      }), function() {
        if (options.injectStyle === false) {
          return [];
        }
        var _statisticToken = statisticToken(token2), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
        var defaultComponentToken = getDefaultComponentToken(component, realToken, getDefaultToken);
        var componentCls = ".".concat(prefixCls);
        var componentToken = getComponentToken(component, realToken, defaultComponentToken, {
          deprecatedTokens: options.deprecatedTokens
        });
        if (cssVar && defaultComponentToken && _typeof$3(defaultComponentToken) === "object") {
          Object.keys(defaultComponentToken).forEach(function(key) {
            defaultComponentToken[key] = "var(".concat(token2CSSVar(key, getCompVarPrefix(component, cssVar.prefix)), ")");
          });
        }
        var mergedToken = merge$1(proxyToken, {
          componentCls,
          prefixCls,
          iconCls: ".".concat(iconPrefixCls),
          antCls: ".".concat(rootPrefixCls),
          calc,
          // @ts-ignore
          max: max2,
          // @ts-ignore
          min: min2
        }, cssVar ? defaultComponentToken : componentToken);
        var styleInterpolation = styleFn(mergedToken, {
          hashId,
          prefixCls,
          rootPrefixCls,
          iconPrefixCls
        });
        flush(component, componentToken);
        var commonStyle = typeof getCommonStyle === "function" ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
        return [options.resetStyle === false ? null : commonStyle, styleInterpolation];
      });
      return [wrapSSR, hashId];
    };
  }
  function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, _objectSpread2$1({
      resetStyle: false,
      // Sub Style should default after root one
      order: -998
    }, options));
    var StyledComponent = function StyledComponent2(_ref2) {
      var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
      useStyle(prefixCls, rootCls);
      return null;
    };
    if (process.env.NODE_ENV !== "production") {
      StyledComponent.displayName = "SubStyle_".concat(String(Array.isArray(componentName) ? componentName.join(".") : componentName));
    }
    return StyledComponent;
  }
  return {
    genStyleHooks,
    genSubStyleComponent,
    genComponentStyleHook
  };
}
const es$6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  genCalc: genCalc2,
  genStyleUtils: genStyleUtils$1,
  mergeToken: merge$1,
  statistic,
  statisticToken
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(es$6);
var _interface$1 = {};
var presetColors = {};
var hasRequiredPresetColors;
function requirePresetColors() {
  if (hasRequiredPresetColors) return presetColors;
  hasRequiredPresetColors = 1;
  Object.defineProperty(presetColors, "__esModule", {
    value: true
  });
  presetColors.PresetColors = void 0;
  presetColors.PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];
  return presetColors;
}
var hasRequired_interface$1;
function require_interface$1() {
  if (hasRequired_interface$1) return _interface$1;
  hasRequired_interface$1 = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    Object.defineProperty(exports$1, "PresetColors", {
      enumerable: true,
      get: function() {
        return _presetColors.PresetColors;
      }
    });
    var _presetColors = /* @__PURE__ */ requirePresetColors();
  })(_interface$1);
  return _interface$1;
}
var useToken = {};
var version$1 = {};
var version = {};
var hasRequiredVersion$1;
function requireVersion$1() {
  if (hasRequiredVersion$1) return version;
  hasRequiredVersion$1 = 1;
  Object.defineProperty(version, "__esModule", {
    value: true
  });
  version.default = void 0;
  version.default = "5.24.2";
  return version;
}
var hasRequiredVersion;
function requireVersion() {
  if (hasRequiredVersion) return version$1;
  hasRequiredVersion = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(version$1, "__esModule", {
    value: true
  });
  version$1.default = void 0;
  var _version = _interopRequireDefault(/* @__PURE__ */ requireVersion$1());
  version$1.default = _version.default;
  return version$1;
}
var alias = {};
var getAlphaColor = {};
var hasRequiredGetAlphaColor;
function requireGetAlphaColor() {
  if (hasRequiredGetAlphaColor) return getAlphaColor;
  hasRequiredGetAlphaColor = 1;
  Object.defineProperty(getAlphaColor, "__esModule", {
    value: true
  });
  getAlphaColor.default = void 0;
  var _fastColor = require$$2$1;
  function isStableColor(color2) {
    return color2 >= 0 && color2 <= 255;
  }
  function getAlphaColor$1(frontColor, backgroundColor) {
    const {
      r: fR,
      g: fG,
      b: fB,
      a: originAlpha
    } = new _fastColor.FastColor(frontColor).toRgb();
    if (originAlpha < 1) {
      return frontColor;
    }
    const {
      r: bR,
      g: bG,
      b: bB
    } = new _fastColor.FastColor(backgroundColor).toRgb();
    for (let fA = 0.01; fA <= 1; fA += 0.01) {
      const r2 = Math.round((fR - bR * (1 - fA)) / fA);
      const g = Math.round((fG - bG * (1 - fA)) / fA);
      const b = Math.round((fB - bB * (1 - fA)) / fA);
      if (isStableColor(r2) && isStableColor(g) && isStableColor(b)) {
        return new _fastColor.FastColor({
          r: r2,
          g,
          b,
          a: Math.round(fA * 100) / 100
        }).toRgbString();
      }
    }
    return new _fastColor.FastColor({
      r: fR,
      g: fG,
      b: fB,
      a: 1
    }).toRgbString();
  }
  getAlphaColor.default = getAlphaColor$1;
  return getAlphaColor;
}
var hasRequiredAlias;
function requireAlias() {
  if (hasRequiredAlias) return alias;
  hasRequiredAlias = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(alias, "__esModule", {
    value: true
  });
  alias.default = formatToken;
  var _fastColor = require$$2$1;
  var _seed = _interopRequireDefault(/* @__PURE__ */ requireSeed());
  var _getAlphaColor = _interopRequireDefault(/* @__PURE__ */ requireGetAlphaColor());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  function formatToken(derivativeToken) {
    const {
      override
    } = derivativeToken, restToken = __rest2(derivativeToken, ["override"]);
    const overrideTokens = Object.assign({}, override);
    Object.keys(_seed.default).forEach((token2) => {
      delete overrideTokens[token2];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    if (mergedToken.motion === false) {
      const fastDuration = "0s";
      mergedToken.motionDurationFast = fastDuration;
      mergedToken.motionDurationMid = fastDuration;
      mergedToken.motionDurationSlow = fastDuration;
    }
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
      // ============== Background ============== //
      colorFillContent: mergedToken.colorFillSecondary,
      colorFillContentHover: mergedToken.colorFill,
      colorFillAlter: mergedToken.colorFillQuaternary,
      colorBgContainerDisabled: mergedToken.colorFillTertiary,
      // ============== Split ============== //
      colorBorderBg: mergedToken.colorBgContainer,
      colorSplit: (0, _getAlphaColor.default)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
      // ============== Text ============== //
      colorTextPlaceholder: mergedToken.colorTextQuaternary,
      colorTextDisabled: mergedToken.colorTextQuaternary,
      colorTextHeading: mergedToken.colorText,
      colorTextLabel: mergedToken.colorTextSecondary,
      colorTextDescription: mergedToken.colorTextTertiary,
      colorTextLightSolid: mergedToken.colorWhite,
      colorHighlight: mergedToken.colorError,
      colorBgTextHover: mergedToken.colorFillSecondary,
      colorBgTextActive: mergedToken.colorFill,
      colorIcon: mergedToken.colorTextTertiary,
      colorIconHover: mergedToken.colorText,
      colorErrorOutline: (0, _getAlphaColor.default)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
      colorWarningOutline: (0, _getAlphaColor.default)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
      // Font
      fontSizeIcon: mergedToken.fontSizeSM,
      // Line
      lineWidthFocus: mergedToken.lineWidth * 3,
      // Control
      lineWidth: mergedToken.lineWidth,
      controlOutlineWidth: mergedToken.lineWidth * 2,
      // Checkbox size and expand icon size
      controlInteractiveSize: mergedToken.controlHeight / 2,
      controlItemBgHover: mergedToken.colorFillTertiary,
      controlItemBgActive: mergedToken.colorPrimaryBg,
      controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
      controlItemBgActiveDisabled: mergedToken.colorFill,
      controlTmpOutline: mergedToken.colorFillQuaternary,
      controlOutline: (0, _getAlphaColor.default)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
      lineType: mergedToken.lineType,
      borderRadius: mergedToken.borderRadius,
      borderRadiusXS: mergedToken.borderRadiusXS,
      borderRadiusSM: mergedToken.borderRadiusSM,
      borderRadiusLG: mergedToken.borderRadiusLG,
      fontWeightStrong: 600,
      opacityLoading: 0.65,
      linkDecoration: "none",
      linkHoverDecoration: "none",
      linkFocusDecoration: "none",
      controlPaddingHorizontal: 12,
      controlPaddingHorizontalSM: 8,
      paddingXXS: mergedToken.sizeXXS,
      paddingXS: mergedToken.sizeXS,
      paddingSM: mergedToken.sizeSM,
      padding: mergedToken.size,
      paddingMD: mergedToken.sizeMD,
      paddingLG: mergedToken.sizeLG,
      paddingXL: mergedToken.sizeXL,
      paddingContentHorizontalLG: mergedToken.sizeLG,
      paddingContentVerticalLG: mergedToken.sizeMS,
      paddingContentHorizontal: mergedToken.sizeMS,
      paddingContentVertical: mergedToken.sizeSM,
      paddingContentHorizontalSM: mergedToken.size,
      paddingContentVerticalSM: mergedToken.sizeXS,
      marginXXS: mergedToken.sizeXXS,
      marginXS: mergedToken.sizeXS,
      marginSM: mergedToken.sizeSM,
      margin: mergedToken.size,
      marginMD: mergedToken.sizeMD,
      marginLG: mergedToken.sizeLG,
      marginXL: mergedToken.sizeXL,
      marginXXL: mergedToken.sizeXXL,
      boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
      screenXS,
      screenXSMin: screenXS,
      screenXSMax: screenSM - 1,
      screenSM,
      screenSMMin: screenSM,
      screenSMMax: screenMD - 1,
      screenMD,
      screenMDMin: screenMD,
      screenMDMax: screenLG - 1,
      screenLG,
      screenLGMin: screenLG,
      screenLGMax: screenXL - 1,
      screenXL,
      screenXLMin: screenXL,
      screenXLMax: screenXXL - 1,
      screenXXL,
      screenXXLMin: screenXXL,
      boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
      boxShadowCard: `
      0 1px 2px -2px ${new _fastColor.FastColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new _fastColor.FastColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new _fastColor.FastColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
      boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
      boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
      boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
      boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
      boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
    }), overrideTokens);
    return aliasToken;
  }
  return alias;
}
var hasRequiredUseToken;
function requireUseToken() {
  if (hasRequiredUseToken) return useToken;
  hasRequiredUseToken = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useToken, "__esModule", {
    value: true
  });
  useToken.default = useToken$1;
  useToken.unitless = useToken.ignore = useToken.getComputedToken = void 0;
  var _react = _interopRequireDefault(React__default);
  var _cssinjs = require$$2$2;
  var _version = _interopRequireDefault(/* @__PURE__ */ requireVersion());
  var _context = /* @__PURE__ */ requireContext$2();
  var _seed = _interopRequireDefault(/* @__PURE__ */ requireSeed());
  var _alias = _interopRequireDefault(/* @__PURE__ */ requireAlias());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const unitless = useToken.unitless = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
  };
  const ignore = useToken.ignore = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
  };
  const preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
  };
  const getComputedToken3 = (originToken, overrideToken, theme2) => {
    const derivativeToken = theme2.getDerivativeToken(originToken);
    const {
      override
    } = overrideToken, components = __rest2(overrideToken, ["override"]);
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
      override
    });
    mergedDerivativeToken = (0, _alias.default)(mergedDerivativeToken);
    if (components) {
      Object.entries(components).forEach((_ref) => {
        let [key, value] = _ref;
        const {
          theme: componentTheme
        } = value, componentTokens = __rest2(value, ["theme"]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) {
          mergedComponentToken = getComputedToken3(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
          }, componentTheme);
        }
        mergedDerivativeToken[key] = mergedComponentToken;
      });
    }
    return mergedDerivativeToken;
  };
  useToken.getComputedToken = getComputedToken3;
  function useToken$1() {
    const {
      token: rootDesignToken,
      hashed,
      theme: theme2,
      override,
      cssVar
    } = _react.default.useContext(_context.DesignTokenContext);
    const salt = `${_version.default}-${hashed || ""}`;
    const mergedTheme = theme2 || _context.defaultTheme;
    const [token2, hashId, realToken] = (0, _cssinjs.useCacheToken)(mergedTheme, [_seed.default, rootDesignToken], {
      salt,
      override,
      getComputedToken: getComputedToken3,
      // formatToken will not be consumed after 1.15.0 with getComputedToken.
      // But token will break if @ant-design/cssinjs is under 1.15.0 without it
      formatToken: _alias.default,
      cssVar: cssVar && {
        prefix: cssVar.prefix,
        key: cssVar.key,
        unitless,
        ignore,
        preserve
      }
    });
    return [mergedTheme, realToken, hashed ? hashId : "", token2, cssVar];
  }
  return useToken;
}
var genStyleUtils = {};
var style$8 = {};
var hasRequiredStyle$6;
function requireStyle$6() {
  if (hasRequiredStyle$6) return style$8;
  hasRequiredStyle$6 = 1;
  Object.defineProperty(style$8, "__esModule", {
    value: true
  });
  style$8.textEllipsis = style$8.resetIcon = style$8.resetComponent = style$8.operationUnit = style$8.genLinkStyle = style$8.genIconStyle = style$8.genFocusStyle = style$8.genFocusOutline = style$8.genCommonStyle = style$8.clearFix = void 0;
  var _cssinjs = require$$2$2;
  style$8.textEllipsis = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  };
  const resetComponent = function(token2) {
    let needInheritFontFamily = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
      color: token2.colorText,
      fontSize: token2.fontSize,
      // font-variant: @font-variant-base;
      lineHeight: token2.lineHeight,
      listStyle: "none",
      // font-feature-settings: @font-feature-settings-base;
      fontFamily: needInheritFontFamily ? "inherit" : token2.fontFamily
    };
  };
  style$8.resetComponent = resetComponent;
  const resetIcon = () => ({
    display: "inline-flex",
    alignItems: "center",
    color: "inherit",
    fontStyle: "normal",
    lineHeight: 0,
    textAlign: "center",
    textTransform: "none",
    // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
    verticalAlign: "-0.125em",
    textRendering: "optimizeLegibility",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale",
    "> *": {
      lineHeight: 1
    },
    svg: {
      display: "inline-block"
    }
  });
  style$8.resetIcon = resetIcon;
  const clearFix = () => ({
    // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
    "&::before": {
      display: "table",
      content: '""'
    },
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/21864
      display: "table",
      clear: "both",
      content: '""'
    }
  });
  style$8.clearFix = clearFix;
  const genLinkStyle = (token2) => ({
    a: {
      color: token2.colorLink,
      textDecoration: token2.linkDecoration,
      backgroundColor: "transparent",
      // remove the gray background on active links in IE 10.
      outline: "none",
      cursor: "pointer",
      transition: `color ${token2.motionDurationSlow}`,
      "-webkit-text-decoration-skip": "objects",
      // remove gaps in links underline in iOS 8+ and Safari 8+.
      "&:hover": {
        color: token2.colorLinkHover
      },
      "&:active": {
        color: token2.colorLinkActive
      },
      "&:active, &:hover": {
        textDecoration: token2.linkHoverDecoration,
        outline: 0
      },
      // https://github.com/ant-design/ant-design/issues/22503
      "&:focus": {
        textDecoration: token2.linkFocusDecoration,
        outline: 0
      },
      "&[disabled]": {
        color: token2.colorTextDisabled,
        cursor: "not-allowed"
      }
    }
  });
  style$8.genLinkStyle = genLinkStyle;
  const genCommonStyle = (token2, componentPrefixCls, rootCls, resetFont) => {
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      }
    };
    let resetFontStyle = {};
    if (resetFont !== false) {
      resetFontStyle = {
        fontFamily: token2.fontFamily,
        fontSize: token2.fontSize
      };
    }
    return {
      [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
        [prefixSelector]: resetStyle
      })
    };
  };
  style$8.genCommonStyle = genCommonStyle;
  const genFocusOutline = (token2, offset) => ({
    outline: `${(0, _cssinjs.unit)(token2.lineWidthFocus)} solid ${token2.colorPrimaryBorder}`,
    outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
    transition: "outline-offset 0s, outline 0s"
  });
  style$8.genFocusOutline = genFocusOutline;
  const genFocusStyle = (token2, offset) => ({
    "&:focus-visible": Object.assign({}, genFocusOutline(token2, offset))
  });
  style$8.genFocusStyle = genFocusStyle;
  const genIconStyle = (iconPrefixCls) => ({
    [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
      [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
        display: "block"
      }
    })
  });
  style$8.genIconStyle = genIconStyle;
  const operationUnit = (token2) => Object.assign(Object.assign({
    // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
    // And Typography use this to generate link style which should not do this.
    color: token2.colorLink,
    textDecoration: token2.linkDecoration,
    outline: "none",
    cursor: "pointer",
    transition: `all ${token2.motionDurationSlow}`,
    border: 0,
    padding: 0,
    background: "none",
    userSelect: "none"
  }, genFocusStyle(token2)), {
    "&:focus, &:hover": {
      color: token2.colorLinkHover
    },
    "&:active": {
      color: token2.colorLinkActive
    }
  });
  style$8.operationUnit = operationUnit;
  return style$8;
}
var hasRequiredGenStyleUtils;
function requireGenStyleUtils() {
  if (hasRequiredGenStyleUtils) return genStyleUtils;
  hasRequiredGenStyleUtils = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(genStyleUtils, "__esModule", {
    value: true
  });
  genStyleUtils.genSubStyleComponent = genStyleUtils.genStyleHooks = genStyleUtils.genComponentStyleHook = void 0;
  var _react = React__default;
  var _cssinjsUtils = require$$2;
  var _context = /* @__PURE__ */ requireContext$1();
  var _style = /* @__PURE__ */ requireStyle$6();
  var _useToken = _interopRequireWildcard(/* @__PURE__ */ requireUseToken());
  const {
    genStyleHooks,
    genComponentStyleHook,
    genSubStyleComponent
  } = (0, _cssinjsUtils.genStyleUtils)({
    usePrefix: () => {
      const {
        getPrefixCls,
        iconPrefixCls
      } = (0, _react.useContext)(_context.ConfigContext);
      const rootPrefixCls = getPrefixCls();
      return {
        rootPrefixCls,
        iconPrefixCls
      };
    },
    useToken: () => {
      const [theme2, realToken, hashId, token2, cssVar] = (0, _useToken.default)();
      return {
        theme: theme2,
        realToken,
        hashId,
        token: token2,
        cssVar
      };
    },
    useCSP: () => {
      const {
        csp
      } = (0, _react.useContext)(_context.ConfigContext);
      return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token2, config2) => {
      var _a2;
      const linkStyle = (0, _style.genLinkStyle)(token2);
      return [linkStyle, {
        "&": linkStyle
      }, (0, _style.genIconStyle)((_a2 = config2 === null || config2 === void 0 ? void 0 : config2.prefix.iconPrefixCls) !== null && _a2 !== void 0 ? _a2 : _context.defaultIconPrefixCls)];
    },
    getCommonStyle: _style.genCommonStyle,
    getCompUnitless: () => _useToken.unitless
  });
  genStyleUtils.genSubStyleComponent = genSubStyleComponent;
  genStyleUtils.genComponentStyleHook = genComponentStyleHook;
  genStyleUtils.genStyleHooks = genStyleHooks;
  return genStyleUtils;
}
var genPresetColor = {};
var hasRequiredGenPresetColor;
function requireGenPresetColor() {
  if (hasRequiredGenPresetColor) return genPresetColor;
  hasRequiredGenPresetColor = 1;
  Object.defineProperty(genPresetColor, "__esModule", {
    value: true
  });
  genPresetColor.default = genPresetColor$1;
  var _interface2 = /* @__PURE__ */ require_interface$1();
  function genPresetColor$1(token2, genCss) {
    return _interface2.PresetColors.reduce((prev4, colorKey) => {
      const lightColor = token2[`${colorKey}1`];
      const lightBorderColor = token2[`${colorKey}3`];
      const darkColor = token2[`${colorKey}6`];
      const textColor = token2[`${colorKey}7`];
      return Object.assign(Object.assign({}, prev4), genCss(colorKey, {
        lightColor,
        lightBorderColor,
        darkColor,
        textColor
      }));
    }, {});
  }
  return genPresetColor;
}
var useResetIconStyle = {};
var hasRequiredUseResetIconStyle;
function requireUseResetIconStyle() {
  if (hasRequiredUseResetIconStyle) return useResetIconStyle;
  hasRequiredUseResetIconStyle = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useResetIconStyle, "__esModule", {
    value: true
  });
  useResetIconStyle.default = void 0;
  var _cssinjs = require$$2$2;
  var _style = /* @__PURE__ */ requireStyle$6();
  var _useToken = _interopRequireDefault(/* @__PURE__ */ requireUseToken());
  const useResetIconStyle$1 = (iconPrefixCls, csp) => {
    const [theme2, token2] = (0, _useToken.default)();
    return (0, _cssinjs.useStyleRegister)({
      theme: theme2,
      token: token2,
      hashId: "",
      path: ["ant-design-icons", iconPrefixCls],
      nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
      layer: {
        name: "antd"
      }
    }, () => [(0, _style.genIconStyle)(iconPrefixCls)]);
  };
  useResetIconStyle.default = useResetIconStyle$1;
  return useResetIconStyle;
}
var hasRequiredInternal;
function requireInternal() {
  if (hasRequiredInternal) return internal;
  hasRequiredInternal = 1;
  (function(exports$1) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    Object.defineProperty(exports$1, "DesignTokenContext", {
      enumerable: true,
      get: function() {
        return _context.DesignTokenContext;
      }
    });
    Object.defineProperty(exports$1, "PresetColors", {
      enumerable: true,
      get: function() {
        return _interface2.PresetColors;
      }
    });
    Object.defineProperty(exports$1, "calc", {
      enumerable: true,
      get: function() {
        return _cssinjsUtils.genCalc;
      }
    });
    Object.defineProperty(exports$1, "defaultConfig", {
      enumerable: true,
      get: function() {
        return _context.defaultConfig;
      }
    });
    Object.defineProperty(exports$1, "genComponentStyleHook", {
      enumerable: true,
      get: function() {
        return _genStyleUtils.genComponentStyleHook;
      }
    });
    Object.defineProperty(exports$1, "genPresetColor", {
      enumerable: true,
      get: function() {
        return _genPresetColor.default;
      }
    });
    Object.defineProperty(exports$1, "genStyleHooks", {
      enumerable: true,
      get: function() {
        return _genStyleUtils.genStyleHooks;
      }
    });
    Object.defineProperty(exports$1, "genSubStyleComponent", {
      enumerable: true,
      get: function() {
        return _genStyleUtils.genSubStyleComponent;
      }
    });
    Object.defineProperty(exports$1, "getLineHeight", {
      enumerable: true,
      get: function() {
        return _genFontSizes.getLineHeight;
      }
    });
    Object.defineProperty(exports$1, "mergeToken", {
      enumerable: true,
      get: function() {
        return _cssinjsUtils.mergeToken;
      }
    });
    Object.defineProperty(exports$1, "statistic", {
      enumerable: true,
      get: function() {
        return _cssinjsUtils.statistic;
      }
    });
    Object.defineProperty(exports$1, "statisticToken", {
      enumerable: true,
      get: function() {
        return _cssinjsUtils.statisticToken;
      }
    });
    Object.defineProperty(exports$1, "useResetIconStyle", {
      enumerable: true,
      get: function() {
        return _useResetIconStyle.default;
      }
    });
    Object.defineProperty(exports$1, "useStyleRegister", {
      enumerable: true,
      get: function() {
        return _cssinjs.useStyleRegister;
      }
    });
    Object.defineProperty(exports$1, "useToken", {
      enumerable: true,
      get: function() {
        return _useToken.default;
      }
    });
    var _cssinjs = require$$2$2;
    var _cssinjsUtils = require$$2;
    var _interface2 = /* @__PURE__ */ require_interface$1();
    var _genFontSizes = /* @__PURE__ */ requireGenFontSizes();
    var _useToken = _interopRequireDefault(/* @__PURE__ */ requireUseToken());
    var _genStyleUtils = /* @__PURE__ */ requireGenStyleUtils();
    var _genPresetColor = _interopRequireDefault(/* @__PURE__ */ requireGenPresetColor());
    var _useResetIconStyle = _interopRequireDefault(/* @__PURE__ */ requireUseResetIconStyle());
    var _context = /* @__PURE__ */ requireContext$2();
  })(internal);
  return internal;
}
var useThemeKey = {};
var hasRequiredUseThemeKey;
function requireUseThemeKey() {
  if (hasRequiredUseThemeKey) return useThemeKey;
  hasRequiredUseThemeKey = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useThemeKey, "__esModule", {
    value: true
  });
  useThemeKey.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  const fullClone2 = Object.assign({}, React2);
  const {
    useId
  } = fullClone2;
  const useEmptyId = () => "";
  const useThemeKey$1 = typeof useId === "undefined" ? useEmptyId : useId;
  useThemeKey.default = useThemeKey$1;
  return useThemeKey;
}
var hasRequiredUseTheme;
function requireUseTheme() {
  if (hasRequiredUseTheme) return useTheme;
  hasRequiredUseTheme = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useTheme, "__esModule", {
    value: true
  });
  useTheme.default = useTheme$1;
  var _useMemo = _interopRequireDefault(requireUseMemo());
  var _isEqual = _interopRequireDefault(requireIsEqual());
  var _warning = /* @__PURE__ */ requireWarning();
  var _internal = /* @__PURE__ */ requireInternal();
  var _useThemeKey = _interopRequireDefault(/* @__PURE__ */ requireUseThemeKey());
  function useTheme$1(theme2, parentTheme, config2) {
    var _a2, _b;
    const warning3 = (0, _warning.devUseWarning)("ConfigProvider");
    const themeConfig = theme2 || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, _internal.defaultConfig), {
      hashed: (_a2 = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a2 !== void 0 ? _a2 : _internal.defaultConfig.hashed,
      cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, _useThemeKey.default)();
    if (process.env.NODE_ENV !== "production") {
      const cssVarEnabled = themeConfig.cssVar || parentThemeConfig.cssVar;
      const validKey = !!(typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || themeKey);
      process.env.NODE_ENV !== "production" ? warning3(!cssVarEnabled || validKey, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.") : void 0;
    }
    return (0, _useMemo.default)(() => {
      var _a3, _b2;
      if (!theme2) {
        return parentTheme;
      }
      const mergedComponents = Object.assign({}, parentThemeConfig.components);
      Object.keys(theme2.components || {}).forEach((componentName) => {
        mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme2.components[componentName]);
      });
      const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
      const mergedCssVar = ((_a3 = themeConfig.cssVar) !== null && _a3 !== void 0 ? _a3 : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
        prefix: config2 === null || config2 === void 0 ? void 0 : config2.prefixCls
      }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
        key: typeof themeConfig.cssVar === "object" && ((_b2 = themeConfig.cssVar) === null || _b2 === void 0 ? void 0 : _b2.key) || cssVarKey
      });
      return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
        token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
        components: mergedComponents,
        cssVar: mergedCssVar
      });
    }, [themeConfig, parentThemeConfig], (prev4, next4) => prev4.some((prevTheme, index2) => {
      const nextTheme = next4[index2];
      return !(0, _isEqual.default)(prevTheme, nextTheme, true);
    }));
  }
  return useTheme;
}
var MotionWrapper = {};
function isDOM(node2) {
  return node2 instanceof HTMLElement || node2 instanceof SVGElement;
}
function getDOM(node2) {
  if (node2 && _typeof$3(node2) === "object" && isDOM(node2.nativeElement)) {
    return node2.nativeElement;
  }
  if (isDOM(node2)) {
    return node2;
  }
  return null;
}
function findDOMNode(node2) {
  var domNode = getDOM(node2);
  if (domNode) {
    return domNode;
  }
  if (node2 instanceof React__default.Component) {
    var _ReactDOM$findDOMNode;
    return (_ReactDOM$findDOMNode = ReactDOM.findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call(ReactDOM, node2);
  }
  return null;
}
var _excluded$e = ["children"];
var Context$1 = /* @__PURE__ */ React.createContext({});
function MotionProvider(_ref) {
  var children2 = _ref.children, props = _objectWithoutProperties$1(_ref, _excluded$e);
  return /* @__PURE__ */ React.createElement(Context$1.Provider, {
    value: props
  }, children2);
}
var DomWrapper$1 = /* @__PURE__ */ (function(_React$Component) {
  _inherits$1(DomWrapper2, _React$Component);
  var _super = _createSuper$1(DomWrapper2);
  function DomWrapper2() {
    _classCallCheck$1(this, DomWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass$1(DomWrapper2, [{
    key: "render",
    value: function render2() {
      return this.props.children;
    }
  }]);
  return DomWrapper2;
})(React.Component);
function useSyncState(defaultValue) {
  var _React$useReducer = React.useReducer(function(x) {
    return x + 1;
  }, 0), _React$useReducer2 = _slicedToArray(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
  var currentValueRef = React.useRef(defaultValue);
  var getValue3 = useEvent$1(function() {
    return currentValueRef.current;
  });
  var setValue = useEvent$1(function(updater) {
    currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
    forceUpdate();
  });
  return [getValue3, setValue];
}
var STATUS_NONE = "none";
var STATUS_APPEAR = "appear";
var STATUS_ENTER = "enter";
var STATUS_LEAVE = "leave";
var STEP_NONE = "none";
var STEP_PREPARE = "prepare";
var STEP_START = "start";
var STEP_ACTIVE = "active";
var STEP_ACTIVATED = "end";
var STEP_PREPARED = "prepared";
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win2) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win2)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win2)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom$1(), typeof window !== "undefined" ? window : {});
var style$7 = {};
if (canUseDom$1()) {
  var _document$createEleme = document.createElement("div");
  style$7 = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style$7) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend");
var internalTransitionEndName = getVendorPrefixedEventName("transitionend");
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || "animationend";
var transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;
  if (_typeof$1(transitionName) === "object") {
    var type4 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName[type4];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
const useDomMotionEvents = (function(onInternalMotionEnd) {
  var cacheElementRef = useRef();
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);
      cacheElementRef.current = element;
    }
  }
  React.useEffect(function() {
    return function() {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
var useIsomorphicLayoutEffect$1 = canUseDom$1() ? useLayoutEffect$2 : useEffect;
var raf$2 = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf$1 = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf$2 = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf$1 = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id2) {
  rafIds.delete(id2);
}
var wrapperRaf = function wrapperRaf2(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id2 = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id2);
      callback();
    } else {
      var realId = raf$2(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id2, realId);
    }
  }
  callRef(times);
  return id2;
};
wrapperRaf.cancel = function(id2) {
  var realId = rafIds.get(id2);
  cleanup(id2);
  return caf$1(realId);
};
if (process.env.NODE_ENV !== "production") {
  wrapperRaf.ids = function() {
    return rafIds;
  };
}
const useNextFrame = (function() {
  var nextFrameRef = React.useRef(null);
  function cancelNextFrame() {
    wrapperRaf.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = wrapperRaf(function() {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];
var SkipStep = false;
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
const useStepQueue = (function(status, prepareOnly, callback) {
  var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray$1(_useState, 2), step = _useState2[0], setStep = _useState2[1];
  var _useNextFrame = useNextFrame(), _useNextFrame2 = _slicedToArray$1(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  useIsomorphicLayoutEffect$1(function() {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index2 = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index2 + 1];
      var result = callback(step);
      if (result === SkipStep) {
        setStep(nextStep, true);
      } else if (nextStep) {
        nextFrame(function(info) {
          function doNext() {
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
function useStatus(supportMotion, visible, getElement2, _ref) {
  var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray$1(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useSyncState = useSyncState(STATUS_NONE), _useSyncState2 = _slicedToArray$1(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
  var _useState3 = useSafeState(null), _useState4 = _slicedToArray$1(_useState3, 2), style2 = _useState4[0], setStyle = _useState4[1];
  var currentStatus = getStatus();
  var mountedRef = useRef(false);
  var deadlineRef = useRef(null);
  function getDomElement() {
    return getElement2();
  }
  var activeRef = useRef(false);
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE);
    setStyle(null, true);
  }
  var onInternalMotionEnd = useEvent$1(function(event) {
    var status = getStatus();
    if (status === STATUS_NONE) {
      return;
    }
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  });
  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray$1(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var getEventHandlers = function getEventHandlers2(targetStatus) {
    switch (targetStatus) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onAppearPrepare), STEP_START, onAppearStart), STEP_ACTIVE, onAppearActive);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onEnterPrepare), STEP_START, onEnterStart), STEP_ACTIVE, onEnterActive);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, onLeavePrepare), STEP_START, onLeaveStart), STEP_ACTIVE, onLeaveActive);
      default:
        return {};
    }
  };
  var eventHandlers = React.useMemo(function() {
    return getEventHandlers(currentStatus);
  }, [currentStatus]);
  var _useStepQueue = useStepQueue(currentStatus, !supportMotion, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }
    if (step === STEP_ACTIVE && currentStatus !== STATUS_NONE) {
      patchMotionEvents(getDomElement());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    if (step === STEP_PREPARED) {
      updateMotionEndStatus();
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray$1(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;
  var visibleRef = useRef(null);
  useIsomorphicLayoutEffect$1(function() {
    if (mountedRef.current && visibleRef.current === visible) {
      return;
    }
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      setStatus(STATUS_NONE);
    }
    visibleRef.current = visible;
  }, [visible]);
  useEffect(function() {
    if (
      // Cancel appear
      currentStatus === STATUS_APPEAR && !motionAppear || // Cancel enter
      currentStatus === STATUS_ENTER && !motionEnter || // Cancel leave
      currentStatus === STATUS_LEAVE && !motionLeave
    ) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  useEffect(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React.useRef(false);
  useEffect(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && currentStatus === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, currentStatus]);
  var mergedStyle = style2;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2({
      transition: "none"
    }, mergedStyle);
  }
  return [currentStatus, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
function genCSSMotion(config2) {
  var transitionSupport = config2;
  if (_typeof$1(config2) === "object") {
    transitionSupport = config2.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion2 = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
    var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children2 = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
    var _React$useContext = React.useContext(Context$1), contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);
    var nodeRef = useRef();
    var wrapperNodeRef = useRef();
    function getDomElement() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props), _useStatus2 = _slicedToArray$1(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React.useCallback(function(node2) {
      nodeRef.current = node2;
      fillRef(ref2, node2);
    }, [ref2]);
    var motionChildren;
    var mergedProps = _objectSpread2(_objectSpread2({}, eventProps), {}, {
      visible
    });
    if (!children2) {
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      if (mergedVisible) {
        motionChildren = children2(_objectSpread2({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children2(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children2(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children2(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
        className: classNames(getTransitionName(motionName, status), _defineProperty(_defineProperty({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === "string")),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var originNodeRef = getNodeRef(motionChildren);
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React.createElement(DomWrapper$1, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion2.displayName = "CSSMotion";
  return CSSMotion2;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add";
var STATUS_KEEP = "keep";
var STATUS_REMOVE = "remove";
var STATUS_REMOVED = "removed";
function wrapKeyToObject(key) {
  var keyObj;
  if (key && _typeof$1(key) === "object" && "key" in key) {
    keyObj = key;
  } else {
    keyObj = {
      key
    };
  }
  return _objectSpread2(_objectSpread2({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys2.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
            return _objectSpread2(_objectSpread2({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push(_objectSpread2(_objectSpread2({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list.push(_objectSpread2(_objectSpread2({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys2 = {};
  list.forEach(function(_ref) {
    var key = _ref.key;
    keys2[key] = (keys2[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys2).filter(function(key) {
    return keys2[key] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list = list.filter(function(_ref2) {
      var key = _ref2.key, status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });
    list.forEach(function(node2) {
      if (node2.key === matchKey) {
        node2.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
var _excluded$d = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$3 = ["status"];
var MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(transitionSupport) {
  var CSSMotion$1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion;
  var CSSMotionList2 = /* @__PURE__ */ (function(_React$Component) {
    _inherits$1(CSSMotionList3, _React$Component);
    var _super = _createSuper$1(CSSMotionList3);
    function CSSMotionList3() {
      var _this;
      _classCallCheck$1(this, CSSMotionList3);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$2(_this), "state", {
        keyEntities: []
      });
      _defineProperty(_assertThisInitialized$2(_this), "removeKey", function(removeKey) {
        _this.setState(function(prevState) {
          var nextKeyEntities = prevState.keyEntities.map(function(entity) {
            if (entity.key !== removeKey) return entity;
            return _objectSpread2(_objectSpread2({}, entity), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: nextKeyEntities
          };
        }, function() {
          var keyEntities = _this.state.keyEntities;
          var restKeysCount = keyEntities.filter(function(_ref) {
            var status = _ref.status;
            return status !== STATUS_REMOVED;
          }).length;
          if (restKeysCount === 0 && _this.props.onAllRemoved) {
            _this.props.onAllRemoved();
          }
        });
      });
      return _this;
    }
    _createClass$1(CSSMotionList3, [{
      key: "render",
      value: function render2() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children2 = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged;
        _this$props.onAllRemoved;
        var restProps = _objectWithoutProperties$1(_this$props, _excluded$d);
        var Component2 = component || React.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React.createElement(Component2, restProps, keyEntities.map(function(_ref2, index2) {
          var status = _ref2.status, eventProps = _objectWithoutProperties$1(_ref2, _excluded2$3);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(CSSMotion$1, _extends$4({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                _this2.removeKey(eventProps.key);
              }
            }
          }), function(props, ref2) {
            return children2(_objectSpread2(_objectSpread2({}, props), {}, {
              index: index2
            }), ref2);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys2 = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys2);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList3;
  })(React.Component);
  _defineProperty(CSSMotionList2, "defaultProps", {
    component: "div"
  });
  return CSSMotionList2;
}
const CSSMotionList = genCSSMotionList(supportTransition);
const es$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CSSMotionList,
  Provider: MotionProvider,
  default: CSSMotion
}, Symbol.toStringTag, { value: "Module" }));
const require$$5$1 = /* @__PURE__ */ getAugmentedNamespace(es$5);
var hasRequiredMotionWrapper;
function requireMotionWrapper() {
  if (hasRequiredMotionWrapper) return MotionWrapper;
  hasRequiredMotionWrapper = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(MotionWrapper, "__esModule", {
    value: true
  });
  MotionWrapper.default = MotionWrapper$1;
  var React2 = _interopRequireWildcard(React__default);
  var _rcMotion = require$$5$1;
  var _internal = /* @__PURE__ */ requireInternal();
  function MotionWrapper$1(props) {
    const {
      children: children2
    } = props;
    const [, token2] = (0, _internal.useToken)();
    const {
      motion: motion2
    } = token2;
    const needWrapMotionProviderRef = React2.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion2 === false;
    if (needWrapMotionProviderRef.current) {
      return /* @__PURE__ */ React2.createElement(_rcMotion.Provider, {
        motion: motion2
      }, children2);
    }
    return children2;
  }
  return MotionWrapper;
}
var PropWarning = {};
var hasRequiredPropWarning;
function requirePropWarning() {
  if (hasRequiredPropWarning) return PropWarning;
  hasRequiredPropWarning = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(PropWarning, "__esModule", {
    value: true
  });
  PropWarning.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _warning = /* @__PURE__ */ requireWarning();
  const PropWarning$1 = /* @__PURE__ */ React2.memo((_ref) => {
    let {
      dropdownMatchSelectWidth
    } = _ref;
    const warning3 = (0, _warning.devUseWarning)("ConfigProvider");
    warning3.deprecated(dropdownMatchSelectWidth === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    return null;
  });
  if (process.env.NODE_ENV !== "production") {
    PropWarning$1.displayName = "PropWarning";
  }
  PropWarning.default = process.env.NODE_ENV !== "production" ? PropWarning$1 : () => null;
  return PropWarning;
}
var style$6 = {};
var hasRequiredStyle$5;
function requireStyle$5() {
  if (hasRequiredStyle$5) return style$6;
  hasRequiredStyle$5 = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    Object.defineProperty(exports$1, "default", {
      enumerable: true,
      get: function() {
        return _internal.useResetIconStyle;
      }
    });
    var _internal = /* @__PURE__ */ requireInternal();
  })(style$6);
  return style$6;
}
var hasRequiredConfigProvider;
function requireConfigProvider() {
  if (hasRequiredConfigProvider) return configProvider;
  hasRequiredConfigProvider = 1;
  (function(exports$1) {
    "use client";
    var _interopRequireDefault = requireInteropRequireDefault().default;
    var _interopRequireWildcard = requireInteropRequireWildcard().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    Object.defineProperty(exports$1, "ConfigConsumer", {
      enumerable: true,
      get: function() {
        return _context3.ConfigConsumer;
      }
    });
    Object.defineProperty(exports$1, "ConfigContext", {
      enumerable: true,
      get: function() {
        return _context3.ConfigContext;
      }
    });
    Object.defineProperty(exports$1, "Variants", {
      enumerable: true,
      get: function() {
        return _context3.Variants;
      }
    });
    exports$1.default = exports$1.configConsumerProps = void 0;
    Object.defineProperty(exports$1, "defaultIconPrefixCls", {
      enumerable: true,
      get: function() {
        return _context3.defaultIconPrefixCls;
      }
    });
    Object.defineProperty(exports$1, "defaultPrefixCls", {
      enumerable: true,
      get: function() {
        return _context3.defaultPrefixCls;
      }
    });
    exports$1.warnContext = exports$1.globalConfig = void 0;
    var React2 = _interopRequireWildcard(React__default);
    var _cssinjs = require$$2$2;
    var _Context = _interopRequireDefault(/* @__PURE__ */ requireContext$4());
    var _useMemo = _interopRequireDefault(requireUseMemo());
    var _set = requireSet();
    var _warning = _interopRequireWildcard(/* @__PURE__ */ requireWarning());
    var _validateMessagesContext = _interopRequireDefault(/* @__PURE__ */ requireValidateMessagesContext());
    var _locale = _interopRequireWildcard(/* @__PURE__ */ requireLocale());
    var _context = _interopRequireDefault(/* @__PURE__ */ requireContext$3());
    var _en_US = _interopRequireDefault(/* @__PURE__ */ requireEn_US());
    var _context2 = /* @__PURE__ */ requireContext$2();
    var _seed = _interopRequireDefault(/* @__PURE__ */ requireSeed());
    var _context3 = /* @__PURE__ */ requireContext$1();
    var _cssVariables = /* @__PURE__ */ requireCssVariables();
    var _DisabledContext = /* @__PURE__ */ requireDisabledContext();
    var _useConfig = _interopRequireDefault(/* @__PURE__ */ requireUseConfig());
    var _useTheme = _interopRequireDefault(/* @__PURE__ */ requireUseTheme());
    var _MotionWrapper = _interopRequireDefault(/* @__PURE__ */ requireMotionWrapper());
    var _PropWarning = _interopRequireDefault(/* @__PURE__ */ requirePropWarning());
    var _SizeContext = _interopRequireWildcard(/* @__PURE__ */ requireSizeContext());
    var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle$5());
    var __rest2 = function(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
      return t;
    };
    let existThemeConfig = false;
    exports$1.warnContext = process.env.NODE_ENV !== "production" ? (componentName) => {
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(!existThemeConfig, componentName, `Static function can not consume context like dynamic theme. Please use 'App' component instead.`) : void 0;
    } : (
      /* istanbul ignore next */
      null
    );
    exports$1.configConsumerProps = ["getTargetContainer", "getPopupContainer", "rootPrefixCls", "getPrefixCls", "renderEmpty", "csp", "autoInsertSpaceInButton", "locale"];
    const PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
    let globalPrefixCls;
    let globalIconPrefixCls;
    let globalTheme;
    let globalHolderRender;
    function getGlobalPrefixCls() {
      return globalPrefixCls || _context3.defaultPrefixCls;
    }
    function getGlobalIconPrefixCls() {
      return globalIconPrefixCls || _context3.defaultIconPrefixCls;
    }
    function isLegacyTheme(theme2) {
      return Object.keys(theme2).some((key) => key.endsWith("Color"));
    }
    const setGlobalConfig = (props) => {
      const {
        prefixCls,
        iconPrefixCls,
        theme: theme2,
        holderRender
      } = props;
      if (prefixCls !== void 0) {
        globalPrefixCls = prefixCls;
      }
      if (iconPrefixCls !== void 0) {
        globalIconPrefixCls = iconPrefixCls;
      }
      if ("holderRender" in props) {
        globalHolderRender = holderRender;
      }
      if (theme2) {
        if (isLegacyTheme(theme2)) {
          process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead.") : void 0;
          (0, _cssVariables.registerTheme)(getGlobalPrefixCls(), theme2);
        } else {
          globalTheme = theme2;
        }
      }
    };
    const globalConfig = () => ({
      getPrefixCls: (suffixCls, customizePrefixCls) => {
        if (customizePrefixCls) {
          return customizePrefixCls;
        }
        return suffixCls ? `${getGlobalPrefixCls()}-${suffixCls}` : getGlobalPrefixCls();
      },
      getIconPrefixCls: getGlobalIconPrefixCls,
      getRootPrefixCls: () => {
        if (globalPrefixCls) {
          return globalPrefixCls;
        }
        return getGlobalPrefixCls();
      },
      getTheme: () => globalTheme,
      holderRender: globalHolderRender
    });
    exports$1.globalConfig = globalConfig;
    const ProviderChildren = (props) => {
      const {
        children: children2,
        csp: customCsp,
        autoInsertSpaceInButton,
        alert,
        anchor,
        form,
        locale: locale2,
        componentSize,
        direction,
        space,
        splitter,
        virtual,
        dropdownMatchSelectWidth,
        popupMatchSelectWidth,
        popupOverflow,
        legacyLocale,
        parentContext,
        iconPrefixCls: customIconPrefixCls,
        theme: theme2,
        componentDisabled,
        segmented,
        statistic: statistic2,
        spin,
        calendar,
        carousel,
        cascader,
        collapse: collapse2,
        typography,
        checkbox,
        descriptions,
        divider,
        drawer,
        skeleton,
        steps,
        image,
        layout,
        list,
        mentions,
        modal,
        progress,
        result,
        slider,
        breadcrumb,
        menu: menu2,
        pagination,
        input: input2,
        textArea,
        empty,
        badge,
        radio,
        rate: rate2,
        switch: SWITCH,
        transfer,
        avatar,
        message: message2,
        tag,
        table,
        card,
        tabs: tabs2,
        timeline,
        timePicker,
        upload,
        notification: notification2,
        tree,
        colorPicker,
        datePicker,
        rangePicker,
        flex,
        wave: wave2,
        dropdown,
        warning: warningConfig,
        tour,
        tooltip,
        popover,
        popconfirm,
        floatButtonGroup,
        variant,
        inputNumber,
        treeSelect
      } = props;
      const getPrefixCls = React2.useCallback((suffixCls, customizePrefixCls) => {
        const {
          prefixCls
        } = props;
        if (customizePrefixCls) {
          return customizePrefixCls;
        }
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
      }, [parentContext.getPrefixCls, props.prefixCls]);
      const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || _context3.defaultIconPrefixCls;
      const csp = customCsp || parentContext.csp;
      (0, _style.default)(iconPrefixCls, csp);
      const mergedTheme = (0, _useTheme.default)(theme2, parentContext.theme, {
        prefixCls: getPrefixCls("")
      });
      if (process.env.NODE_ENV !== "production") {
        existThemeConfig = existThemeConfig || !!mergedTheme;
      }
      const baseConfig = {
        csp,
        autoInsertSpaceInButton,
        alert,
        anchor,
        locale: locale2 || legacyLocale,
        direction,
        space,
        splitter,
        virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow,
        getPrefixCls,
        iconPrefixCls,
        theme: mergedTheme,
        segmented,
        statistic: statistic2,
        spin,
        calendar,
        carousel,
        cascader,
        collapse: collapse2,
        typography,
        checkbox,
        descriptions,
        divider,
        drawer,
        skeleton,
        steps,
        image,
        input: input2,
        textArea,
        layout,
        list,
        mentions,
        modal,
        progress,
        result,
        slider,
        breadcrumb,
        menu: menu2,
        pagination,
        empty,
        badge,
        radio,
        rate: rate2,
        switch: SWITCH,
        transfer,
        avatar,
        message: message2,
        tag,
        table,
        card,
        tabs: tabs2,
        timeline,
        timePicker,
        upload,
        notification: notification2,
        tree,
        colorPicker,
        datePicker,
        rangePicker,
        flex,
        wave: wave2,
        dropdown,
        warning: warningConfig,
        tour,
        tooltip,
        popover,
        popconfirm,
        floatButtonGroup,
        variant,
        inputNumber,
        treeSelect
      };
      if (process.env.NODE_ENV !== "production") {
        const warningFn = (0, _warning.devUseWarning)("ConfigProvider");
        warningFn(!("autoInsertSpaceInButton" in props), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
      }
      const config2 = Object.assign({}, parentContext);
      Object.keys(baseConfig).forEach((key) => {
        if (baseConfig[key] !== void 0) {
          config2[key] = baseConfig[key];
        }
      });
      PASSED_PROPS.forEach((propName) => {
        const propValue = props[propName];
        if (propValue) {
          config2[propName] = propValue;
        }
      });
      if (typeof autoInsertSpaceInButton !== "undefined") {
        config2.button = Object.assign({
          autoInsertSpace: autoInsertSpaceInButton
        }, config2.button);
      }
      const memoedConfig = (0, _useMemo.default)(() => config2, config2, (prevConfig, currentConfig) => {
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key) => prevConfig[key] !== currentConfig[key]);
      });
      const {
        layer
      } = React2.useContext(_cssinjs.StyleContext);
      const memoIconContextValue = React2.useMemo(() => ({
        prefixCls: iconPrefixCls,
        csp,
        layer: layer ? "antd" : void 0
      }), [iconPrefixCls, csp, layer]);
      let childNode = /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(_PropWarning.default, {
        dropdownMatchSelectWidth
      }), children2);
      const validateMessages = React2.useMemo(() => {
        var _a2, _b, _c, _d;
        return (0, _set.merge)(((_a2 = _en_US.default.Form) === null || _a2 === void 0 ? void 0 : _a2.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
      }, [memoedConfig, form === null || form === void 0 ? void 0 : form.validateMessages]);
      if (Object.keys(validateMessages).length > 0) {
        childNode = /* @__PURE__ */ React2.createElement(_validateMessagesContext.default.Provider, {
          value: validateMessages
        }, childNode);
      }
      if (locale2) {
        childNode = /* @__PURE__ */ React2.createElement(_locale.default, {
          locale: locale2,
          _ANT_MARK__: _locale.ANT_MARK
        }, childNode);
      }
      if (iconPrefixCls || csp) {
        childNode = /* @__PURE__ */ React2.createElement(_Context.default.Provider, {
          value: memoIconContextValue
        }, childNode);
      }
      if (componentSize) {
        childNode = /* @__PURE__ */ React2.createElement(_SizeContext.SizeContextProvider, {
          size: componentSize
        }, childNode);
      }
      childNode = /* @__PURE__ */ React2.createElement(_MotionWrapper.default, null, childNode);
      const memoTheme = React2.useMemo(() => {
        const _a2 = mergedTheme || {}, {
          algorithm,
          token: token2,
          components,
          cssVar
        } = _a2, rest = __rest2(_a2, ["algorithm", "token", "components", "cssVar"]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, _cssinjs.createTheme)(algorithm) : _context2.defaultTheme;
        const parsedComponents = {};
        Object.entries(components || {}).forEach((_ref) => {
          let [componentName, componentToken] = _ref;
          const parsedToken = Object.assign({}, componentToken);
          if ("algorithm" in parsedToken) {
            if (parsedToken.algorithm === true) {
              parsedToken.theme = themeObj;
            } else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") {
              parsedToken.theme = (0, _cssinjs.createTheme)(parsedToken.algorithm);
            }
            delete parsedToken.algorithm;
          }
          parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, _seed.default), token2);
        return Object.assign(Object.assign({}, rest), {
          theme: themeObj,
          token: mergedToken,
          components: parsedComponents,
          override: Object.assign({
            override: mergedToken
          }, parsedComponents),
          cssVar
        });
      }, [mergedTheme]);
      if (theme2) {
        childNode = /* @__PURE__ */ React2.createElement(_context2.DesignTokenContext.Provider, {
          value: memoTheme
        }, childNode);
      }
      if (memoedConfig.warning) {
        childNode = /* @__PURE__ */ React2.createElement(_warning.WarningContext.Provider, {
          value: memoedConfig.warning
        }, childNode);
      }
      if (componentDisabled !== void 0) {
        childNode = /* @__PURE__ */ React2.createElement(_DisabledContext.DisabledContextProvider, {
          disabled: componentDisabled
        }, childNode);
      }
      return /* @__PURE__ */ React2.createElement(_context3.ConfigContext.Provider, {
        value: memoedConfig
      }, childNode);
    };
    const ConfigProvider = (props) => {
      const context2 = React2.useContext(_context3.ConfigContext);
      const antLocale = React2.useContext(_context.default);
      return /* @__PURE__ */ React2.createElement(ProviderChildren, Object.assign({
        parentContext: context2,
        legacyLocale: antLocale
      }, props));
    };
    ConfigProvider.ConfigContext = _context3.ConfigContext;
    ConfigProvider.SizeContext = _SizeContext.default;
    ConfigProvider.config = setGlobalConfig;
    ConfigProvider.useConfig = _useConfig.default;
    Object.defineProperty(ConfigProvider, "SizeContext", {
      get: () => {
        process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead.") : void 0;
        return _SizeContext.default;
      }
    });
    if (process.env.NODE_ENV !== "production") {
      ConfigProvider.displayName = "ConfigProvider";
    }
    exports$1.default = ConfigProvider;
  })(configProvider);
  return configProvider;
}
var context = {};
function _objectWithoutPropertiesLoose$1(r2, e) {
  if (null == r2) return {};
  var t = {};
  for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r2[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r2, i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r2 = 0; r2 < n.length; r2++) o = n[r2], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _regeneratorDefine(e, r2, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e2) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine2(e2, r3, n2, t2) {
    function o(r4, n3) {
      _regeneratorDefine(e2, r4, function(e3) {
        return this._invoke(r4, n3, e3);
      });
    }
    r3 ? i ? i(e2, r3, {
      value: n2,
      enumerable: !t2,
      configurable: !t2,
      writable: !t2
    }) : e2[r3] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r2, n, t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e, t, r2 = "function" == typeof Symbol ? Symbol : {}, n = r2.iterator || "@@iterator", o = r2.toStringTag || "@@toStringTag";
  function i(r3, n2, o2, i2) {
    var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
    return _regeneratorDefine(u2, "_invoke", (function(r4, n3, o3) {
      var i3, c3, u3, f2 = 0, p = o3 || [], y = false, G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d2(t2, r5) {
          return i3 = t2, c3 = 0, u3 = e, G.n = r5, a;
        }
      };
      function d(r5, n4) {
        for (c3 = r5, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
          var o4, i4 = p[t], d2 = G.p, l = i4[2];
          r5 > 3 ? (o4 = l === n4) && (u3 = i4[(c3 = i4[4]) ? 5 : (c3 = 3, 3)], i4[4] = i4[5] = e) : i4[0] <= d2 && ((o4 = r5 < 2 && d2 < i4[1]) ? (c3 = 0, G.v = n4, G.n = i4[1]) : d2 < l && (o4 = r5 < 3 || i4[0] > n4 || n4 > l) && (i4[4] = r5, i4[5] = n4, G.n = l, c3 = 0));
        }
        if (o4 || r5 > 1) return a;
        throw y = true, n4;
      }
      return function(o4, p2, l) {
        if (f2 > 1) throw TypeError("Generator is already running");
        for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
          i3 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
          try {
            if (f2 = 2, i3) {
              if (c3 || (o4 = "next"), t = i3[o4]) {
                if (!(t = t.call(i3, u3))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u3 = t.value, c3 < 2 && (c3 = 0);
              } else 1 === c3 && (t = i3["return"]) && t.call(i3), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
              i3 = e;
            } else if ((t = (y = G.n < 0) ? u3 : r4.call(n3, G)) !== a) break;
          } catch (t2) {
            i3 = e, c3 = 1, u3 = t2;
          } finally {
            f2 = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    })(r3, o2, i2), true), u2;
  }
  var a = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function() {
    return this;
  }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e2) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function() {
    return this;
  }), _regeneratorDefine(u, "toString", function() {
    return "[object Generator]";
  }), (_regenerator = function _regenerator2() {
    return {
      w: i,
      m: f
    };
  })();
}
function AsyncIterator(t, e) {
  function n(r3, o, i, f) {
    try {
      var c = t[r3](o), u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function(t2) {
        n("next", t2, i, f);
      }, function(t2) {
        n("throw", t2, i, f);
      }) : e.resolve(u).then(function(t2) {
        c.value = t2, i(c);
      }, function(t2) {
        return n("throw", t2, i, f);
      });
    } catch (t2) {
      f(t2);
    }
  }
  var r2;
  this.next || (_regeneratorDefine(AsyncIterator.prototype), _regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
    return this;
  })), _regeneratorDefine(this, "_invoke", function(t2, o, i) {
    function f() {
      return new e(function(e2, r3) {
        n(t2, i, e2, r3);
      });
    }
    return r2 = r2 ? r2.then(f, f) : f();
  }, true);
}
function _regeneratorAsyncGen(r2, e, t, o, n) {
  return new AsyncIterator(_regenerator().w(r2, e, t, o), n || Promise);
}
function _regeneratorAsync(n, e, r2, t, o) {
  var a = _regeneratorAsyncGen(n, e, r2, t, o);
  return a.next().then(function(n2) {
    return n2.done ? n2.value : a.next();
  });
}
function _regeneratorKeys(e) {
  var n = Object(e), r2 = [];
  for (var t in n) r2.unshift(t);
  return function e2() {
    for (; r2.length; ) if ((t = r2.pop()) in n) return e2.value = t, e2.done = false, e2;
    return e2.done = true, e2;
  };
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r2 = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next4() {
        return e && r2 >= e.length && (e = void 0), {
          value: e && e[r2++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof$3(e) + " is not iterable");
}
function _regeneratorRuntime() {
  var r2 = _regenerator(), e = r2.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r3) {
    var e2 = "function" == typeof r3 && r3.constructor;
    return !!e2 && (e2 === t || "GeneratorFunction" === (e2.displayName || e2.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r3) {
    var e2, t2;
    return function(n2) {
      e2 || (e2 = {
        stop: function stop2() {
          return t2(n2.a, 2);
        },
        "catch": function _catch() {
          return n2.v;
        },
        abrupt: function abrupt(r4, e3) {
          return t2(n2.a, o[r4], e3);
        },
        delegateYield: function delegateYield(r4, o2, a2) {
          return e2.resultName = o2, t2(n2.d, _regeneratorValues(r4), a2);
        },
        finish: function finish(r4) {
          return t2(n2.f, r4);
        }
      }, t2 = function t3(r4, _t, o2) {
        n2.p = e2.prev, n2.n = e2.next;
        try {
          return r4(_t, o2);
        } finally {
          e2.next = n2.n;
        }
      }), e2.resultName && (e2[e2.resultName] = n2.v, e2.resultName = void 0), e2.sent = n2.v, e2.next = n2.n;
      try {
        return r3.call(this, e2);
      } finally {
        n2.p = e2.prev, n2.n = e2.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime2() {
    return {
      wrap: function wrap(e2, t2, n2, o2) {
        return r2.w(a(e2), t2, n2, o2 && o2.reverse());
      },
      isGeneratorFunction: n,
      mark: r2.m,
      awrap: function awrap(r3, e2) {
        return new _OverloadYield(r3, e2);
      },
      AsyncIterator,
      async: function async(r3, e2, t2, o2, u) {
        return (n(e2) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r3), e2, t2, o2, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function asyncGeneratorStep(n, t, e, r2, o, a, c) {
  try {
    var i = n[a](c), u = i.value;
  } catch (n2) {
    return void e(n2);
  }
  i.done ? t(u) : Promise.resolve(u).then(r2, o);
}
function _asyncToGenerator(n) {
  return function() {
    var t = this, e = arguments;
    return new Promise(function(r2, o) {
      var a = n.apply(t, e);
      function _next(n2) {
        asyncGeneratorStep(a, r2, o, _next, _throw, "next", n2);
      }
      function _throw(n2) {
        asyncGeneratorStep(a, r2, o, _next, _throw, "throw", n2);
      }
      _next(void 0);
    });
  };
}
function toArray$2(children2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var ret = [];
  React__default.Children.forEach(children2, function(child) {
    if ((child === void 0 || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray$2(child));
    } else if (isFragment$1(child) && child.props) {
      ret = ret.concat(toArray$2(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS";
var warningFunc = function warningFunc2() {
  warningOnce(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var Context = /* @__PURE__ */ React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
var ListContext = /* @__PURE__ */ React.createContext(null);
function toArray$1(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function isFormInstance(form) {
  return form && !!form._init;
}
function newMessages() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _construct(t, e, r2) {
  if (_isNativeReflectConstruct$f()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r2 && _setPrototypeOf(p, r2.prototype), p;
}
function _wrapNativeSuper(t) {
  var r2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t2) {
    if (null === t2 || !_isNativeFunction(t2)) return t2;
    if ("function" != typeof t2) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r2) {
      if (r2.has(t2)) return r2.get(t2);
      r2.set(t2, Wrapper);
    }
    function Wrapper() {
      return _construct(t2, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper, t2);
  }, _wrapNativeSuper(t);
}
var formatRegExp = /%[sdj%]/g;
var warning$1 = function warning() {
};
if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && typeof window !== "undefined" && typeof document !== "undefined") {
  warning$1 = function warning3(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e) {
        return typeof e === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function(error2) {
    var field = error2.field;
    fields[field] = fields[field] || [];
    fields[field].push(error2);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x) {
      if (x === "%%") {
        return "%";
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case "%s":
          return String(args[i++]);
        case "%d":
          return Number(args[i++]);
        case "%j":
          try {
            return JSON.stringify(args[i++]);
          } catch (_2) {
            return "[Circular]";
          }
          break;
        default:
          return x;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value, type4) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, _toConsumableArray(errors || []));
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a) {
    func(a, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next4(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next4);
    } else {
      callback([]);
    }
  }
  next4([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k) {
    ret.push.apply(ret, _toConsumableArray(objArr[k] || []));
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ (function(_Error) {
  _inherits(AsyncValidationError2, _Error);
  var _super = _createSuper(AsyncValidationError2);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _classCallCheck(this, AsyncValidationError2);
    _this = _super.call(this, "Async Validation Error");
    _defineProperty$1(_assertThisInitialized$1(_this), "errors", void 0);
    _defineProperty$1(_assertThisInitialized$1(_this), "fields", void 0);
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return _createClass(AsyncValidationError2);
})(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next4 = function next5(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next4);
    });
    _pending.catch(function(e) {
      return e;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next4 = function next5(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next4);
      } else {
        asyncParallelArray(arr, func, next4);
      }
    });
  });
  pending.catch(function(e) {
    return e;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue2(value, path2) {
  var v = value;
  for (var i = 0; i < path2.length; i++) {
    if (v == void 0) {
      return v;
    }
    v = v[path2[i]];
  }
  return v;
}
function complementError(rule, source) {
  return function(oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue2(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === "function" ? oe() : oe,
      fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge$1(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if (_typeof$3(value) === "object" && _typeof$3(target[s]) === "object") {
          target[s] = _objectSpread2$1(_objectSpread2$1({}, target[s]), value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$2 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min2 = typeof rule.min === "number";
  var max2 = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key = "number";
  } else if (str) {
    key = "string";
  } else if (arr) {
    key = "array";
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min2 && !max2 && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max2 && !min2 && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min2 && max2 && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
var required$1 = function required(rule, value, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type4 || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
var urlReg;
const getUrlRegex = (function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b = function b2(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6List = [
    "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ];
  var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?";
  var v6 = "(?:".concat(v6List.join("|"), ")").concat(v6Eth0);
  var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
  var v4exact = new RegExp("^".concat(v4, "$"));
  var v6exact = new RegExp("^".concat(v6, "$"));
  var ip = function ip2(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), "g");
  };
  ip.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), "g");
  };
  ip.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), "g");
  };
  var protocol2 = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain2 = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path2 = '(?:[/?#][^\\s"]*)?';
  var regex2 = "(?:".concat(protocol2, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain2).concat(tld, ")").concat(port).concat(path2);
  urlReg = new RegExp("(?:^".concat(regex2, "$)"), "i");
  return urlReg;
});
var pattern$1 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return _typeof$3(value) === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern$1.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern$1.hex);
  }
};
var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required$1(rule, value, source, errors, options);
    return;
  }
  var custom2 = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom2.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && _typeof$3(value) !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var whitespace = function whitespace2(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
const rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  enum: enumerable$1,
  pattern: pattern$2
};
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var boolean = function boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value) ? "array" : _typeof$3(value);
  rules.required(rule, value, source, errors, options, type4);
  callback(errors);
};
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var type2 = function type3(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
const validators = {
  string,
  method: method2,
  number: number2,
  boolean,
  regexp: regexp2,
  integer: integer2,
  float: floatFn,
  array: array2,
  object: object2,
  enum: enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
var Schema = /* @__PURE__ */ (function() {
  function Schema2(descriptor) {
    _classCallCheck(this, Schema2);
    _defineProperty$1(this, "rules", null);
    _defineProperty$1(this, "_messages", messages);
    this.define(descriptor);
  }
  _createClass(Schema2, [{
    key: "define",
    value: function define(rules2) {
      var _this = this;
      if (!rules2) {
        throw new Error("Cannot configure a schema with no rules");
      }
      if (_typeof$3(rules2) !== "object" || Array.isArray(rules2)) {
        throw new Error("Rules must be an object");
      }
      this.rules = {};
      Object.keys(rules2).forEach(function(name) {
        var item2 = rules2[name];
        _this.rules[name] = Array.isArray(item2) ? item2 : [item2];
      });
    }
  }, {
    key: "messages",
    value: function messages2(_messages) {
      if (_messages) {
        this._messages = deepMerge$1(newMessages(), _messages);
      }
      return this._messages;
    }
  }, {
    key: "validate",
    value: function validate(source_) {
      var _this2 = this;
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var oc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      };
      var source = source_;
      var options = o;
      var callback = oc;
      if (typeof options === "function") {
        callback = options;
        options = {};
      }
      if (!this.rules || Object.keys(this.rules).length === 0) {
        if (callback) {
          callback(null, source);
        }
        return Promise.resolve(source);
      }
      function complete(results) {
        var errors = [];
        var fields = {};
        function add3(e) {
          if (Array.isArray(e)) {
            var _errors;
            errors = (_errors = errors).concat.apply(_errors, _toConsumableArray(e));
          } else {
            errors.push(e);
          }
        }
        for (var i = 0; i < results.length; i++) {
          add3(results[i]);
        }
        if (!errors.length) {
          callback(null, source);
        } else {
          fields = convertFieldsError(errors);
          callback(errors, fields);
        }
      }
      if (options.messages) {
        var messages$1 = this.messages();
        if (messages$1 === messages) {
          messages$1 = newMessages();
        }
        deepMerge$1(messages$1, options.messages);
        options.messages = messages$1;
      } else {
        options.messages = this.messages();
      }
      var series = {};
      var keys2 = options.keys || Object.keys(this.rules);
      keys2.forEach(function(z) {
        var arr = _this2.rules[z];
        var value = source[z];
        arr.forEach(function(r2) {
          var rule = r2;
          if (typeof rule.transform === "function") {
            if (source === source_) {
              source = _objectSpread2$1({}, source);
            }
            value = source[z] = rule.transform(value);
            if (value !== void 0 && value !== null) {
              rule.type = rule.type || (Array.isArray(value) ? "array" : _typeof$3(value));
            }
          }
          if (typeof rule === "function") {
            rule = {
              validator: rule
            };
          } else {
            rule = _objectSpread2$1({}, rule);
          }
          rule.validator = _this2.getValidationMethod(rule);
          if (!rule.validator) {
            return;
          }
          rule.field = z;
          rule.fullField = rule.fullField || z;
          rule.type = _this2.getType(rule);
          series[z] = series[z] || [];
          series[z].push({
            rule,
            value,
            source,
            field: z
          });
        });
      });
      var errorFields = {};
      return asyncMap(series, options, function(data2, doIt) {
        var rule = data2.rule;
        var deep = (rule.type === "object" || rule.type === "array") && (_typeof$3(rule.fields) === "object" || _typeof$3(rule.defaultField) === "object");
        deep = deep && (rule.required || !rule.required && data2.value);
        rule.field = data2.field;
        function addFullField(key, schema) {
          return _objectSpread2$1(_objectSpread2$1({}, schema), {}, {
            fullField: "".concat(rule.fullField, ".").concat(key),
            fullFields: rule.fullFields ? [].concat(_toConsumableArray(rule.fullFields), [key]) : [key]
          });
        }
        function cb() {
          var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
          var errorList = Array.isArray(e) ? e : [e];
          if (!options.suppressWarning && errorList.length) {
            Schema2.warning("async-validator:", errorList);
          }
          if (errorList.length && rule.message !== void 0) {
            errorList = [].concat(rule.message);
          }
          var filledErrors = errorList.map(complementError(rule, source));
          if (options.first && filledErrors.length) {
            errorFields[rule.field] = 1;
            return doIt(filledErrors);
          }
          if (!deep) {
            doIt(filledErrors);
          } else {
            if (rule.required && !data2.value) {
              if (rule.message !== void 0) {
                filledErrors = [].concat(rule.message).map(complementError(rule, source));
              } else if (options.error) {
                filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
              }
              return doIt(filledErrors);
            }
            var fieldsSchema = {};
            if (rule.defaultField) {
              Object.keys(data2.value).map(function(key) {
                fieldsSchema[key] = rule.defaultField;
              });
            }
            fieldsSchema = _objectSpread2$1(_objectSpread2$1({}, fieldsSchema), data2.rule.fields);
            var paredFieldsSchema = {};
            Object.keys(fieldsSchema).forEach(function(field) {
              var fieldSchema = fieldsSchema[field];
              var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
              paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
            });
            var schema = new Schema2(paredFieldsSchema);
            schema.messages(options.messages);
            if (data2.rule.options) {
              data2.rule.options.messages = options.messages;
              data2.rule.options.error = options.error;
            }
            schema.validate(data2.value, data2.rule.options || options, function(errs) {
              var finalErrors = [];
              if (filledErrors && filledErrors.length) {
                finalErrors.push.apply(finalErrors, _toConsumableArray(filledErrors));
              }
              if (errs && errs.length) {
                finalErrors.push.apply(finalErrors, _toConsumableArray(errs));
              }
              doIt(finalErrors.length ? finalErrors : null);
            });
          }
        }
        var res;
        if (rule.asyncValidator) {
          res = rule.asyncValidator(rule, data2.value, cb, data2.source, options);
        } else if (rule.validator) {
          try {
            res = rule.validator(rule, data2.value, cb, data2.source, options);
          } catch (error2) {
            var _console$error, _console;
            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error2);
            if (!options.suppressValidatorError) {
              setTimeout(function() {
                throw error2;
              }, 0);
            }
            cb(error2.message);
          }
          if (res === true) {
            cb();
          } else if (res === false) {
            cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
          } else if (res instanceof Array) {
            cb(res);
          } else if (res instanceof Error) {
            cb(res.message);
          }
        }
        if (res && res.then) {
          res.then(function() {
            return cb();
          }, function(e) {
            return cb(e);
          });
        }
      }, function(results) {
        complete(results);
      }, source);
    }
  }, {
    key: "getType",
    value: function getType(rule) {
      if (rule.type === void 0 && rule.pattern instanceof RegExp) {
        rule.type = "pattern";
      }
      if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
        throw new Error(format("Unknown rule type %s", rule.type));
      }
      return rule.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function getValidationMethod(rule) {
      if (typeof rule.validator === "function") {
        return rule.validator;
      }
      var keys2 = Object.keys(rule);
      var messageIndex = keys2.indexOf("message");
      if (messageIndex !== -1) {
        keys2.splice(messageIndex, 1);
      }
      if (keys2.length === 1 && keys2[0] === "required") {
        return validators.required;
      }
      return validators[this.getType(rule)] || void 0;
    }
  }]);
  return Schema2;
})();
_defineProperty$1(Schema, "register", function register2(type4, validator2) {
  if (typeof validator2 !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator2;
});
_defineProperty$1(Schema, "warning", warning$1);
_defineProperty$1(Schema, "messages", messages);
_defineProperty$1(Schema, "validators", validators);
var typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
var AsyncValidator = Schema;
function replaceMessage(template, kv) {
  return template.replace(/\\?\$\{\w+\}/g, function(str) {
    if (str.startsWith("\\")) {
      return str.slice(1);
    }
    var key = str.slice(2, -1);
    return kv[key];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, originValidator, subRuleField, validator2, messages2, result, subResults, kv, fillVariableResult;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cloneRule = _objectSpread2$1({}, rule);
          delete cloneRule.ruleIndex;
          AsyncValidator.warning = function() {
            return void 0;
          };
          if (cloneRule.validator) {
            originValidator = cloneRule.validator;
            cloneRule.validator = function() {
              try {
                return originValidator.apply(void 0, arguments);
              } catch (error2) {
                console.error(error2);
                return Promise.reject(CODE_LOGIC_ERROR);
              }
            };
          }
          subRuleField = null;
          if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
            subRuleField = cloneRule.defaultField;
            delete cloneRule.defaultField;
          }
          validator2 = new AsyncValidator(_defineProperty$1({}, name, [cloneRule]));
          messages2 = merge$2(defaultValidateMessages, options.validateMessages);
          validator2.messages(messages2);
          result = [];
          _context2.prev = 10;
          _context2.next = 13;
          return Promise.resolve(validator2.validate(_defineProperty$1({}, name, value), _objectSpread2$1({}, options)));
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](10);
          if (_context2.t0.errors) {
            result = _context2.t0.errors.map(function(_ref4, index2) {
              var message2 = _ref4.message;
              var mergedMessage = message2 === CODE_LOGIC_ERROR ? messages2.default : message2;
              return /* @__PURE__ */ React.isValidElement(mergedMessage) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ React.cloneElement(mergedMessage, {
                  key: "error_".concat(index2)
                })
              ) : mergedMessage;
            });
          }
        case 18:
          if (!(!result.length && subRuleField && Array.isArray(value) && value.length > 0)) {
            _context2.next = 23;
            break;
          }
          _context2.next = 21;
          return Promise.all(value.map(function(subValue, i) {
            return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
          }));
        case 21:
          subResults = _context2.sent;
          return _context2.abrupt("return", subResults.reduce(function(prev4, errors) {
            return [].concat(_toConsumableArray(prev4), _toConsumableArray(errors));
          }, []));
        case 23:
          kv = _objectSpread2$1(_objectSpread2$1({}, rule), {}, {
            name,
            enum: (rule.enum || []).join(", ")
          }, messageVariables);
          fillVariableResult = result.map(function(error2) {
            if (typeof error2 === "string") {
              return replaceMessage(error2, kv);
            }
            return error2;
          });
          return _context2.abrupt("return", fillVariableResult);
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 15]]);
  }));
  return _validateRule.apply(this, arguments);
}
function validateRules(namePath, value, rules2, options, validateFirst, messageVariables) {
  var name = namePath.join(".");
  var filledRules = rules2.map(function(currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;
    var cloneRule = _objectSpread2$1(_objectSpread2$1({}, currentRule), {}, {
      ruleIndex
    });
    if (originValidatorFunc) {
      cloneRule.validator = function(rule, val, callback) {
        var hasPromise = false;
        var wrappedCallback = function wrappedCallback2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          Promise.resolve().then(function() {
            warningOnce(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
        warningOnce(hasPromise, "`callback` is deprecated. Please return a promise instead.");
        if (hasPromise) {
          promise.then(function() {
            callback();
          }).catch(function(err) {
            callback(err || " ");
          });
        }
      };
    }
    return cloneRule;
  }).sort(function(_ref, _ref2) {
    var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
    if (!!w1 === !!w2) {
      return i1 - i2;
    }
    if (w1) {
      return 1;
    }
    return -1;
  });
  var summaryPromise;
  if (validateFirst === true) {
    summaryPromise = new Promise(/* @__PURE__ */ (function() {
      var _ref3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < filledRules.length)) {
                _context.next = 12;
                break;
              }
              rule = filledRules[i];
              _context.next = 5;
              return validateRule(name, value, rule, options, messageVariables);
            case 5:
              errors = _context.sent;
              if (!errors.length) {
                _context.next = 9;
                break;
              }
              reject([{
                errors,
                rule
              }]);
              return _context.abrupt("return");
            case 9:
              i += 1;
              _context.next = 1;
              break;
            case 12:
              resolve([]);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function(_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    })());
  } else {
    var rulePromises = filledRules.map(function(rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function(errors) {
        return {
          errors,
          rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function(errors) {
      return Promise.reject(errors);
    });
  }
  summaryPromise.catch(function(e) {
    return e;
  });
  return summaryPromise;
}
function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(rulePromises) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
            var _ref5;
            var errors = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(errorsList));
            return errors;
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(rulePromises) {
    var count;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          count = 0;
          return _context4.abrupt("return", new Promise(function(resolve) {
            rulePromises.forEach(function(promise) {
              promise.then(function(ruleError) {
                if (ruleError.errors.length) {
                  resolve([ruleError]);
                }
                count += 1;
                if (count === rulePromises.length) {
                  resolve([]);
                }
              });
            });
          }));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}
function getNamePath(path2) {
  return toArray$1(path2);
}
function cloneByNamePathList(store2, namePathList) {
  var newStore = {};
  namePathList.forEach(function(namePath) {
    var value = get$2(store2, namePath);
    newStore = set$1(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  return namePathList && namePathList.some(function(path2) {
    return matchNamePath(namePath, path2, partialMatch);
  });
}
function matchNamePath(namePath, subNamePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (!namePath || !subNamePath) {
    return false;
  }
  if (!partialMatch && namePath.length !== subNamePath.length) {
    return false;
  }
  return subNamePath.every(function(nameUnit, i) {
    return namePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }
  if (!source && target || source && !target) {
    return false;
  }
  if (!source || !target || _typeof$3(source) !== "object" || _typeof$3(target) !== "object") {
    return false;
  }
  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys2 = new Set([].concat(sourceKeys, targetKeys));
  return _toConsumableArray(keys2).every(function(key) {
    var sourceValue = source[key];
    var targetValue = target[key];
    if (typeof sourceValue === "function" && typeof targetValue === "function") {
      return true;
    }
    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? void 0 : arguments[1];
  if (event && event.target && _typeof$3(event.target) === "object" && valuePropName in event.target) {
    return event.target[valuePropName];
  }
  return event;
}
function move$1(array4, moveIndex, toIndex) {
  var length2 = array4.length;
  if (moveIndex < 0 || moveIndex >= length2 || toIndex < 0 || toIndex >= length2) {
    return array4;
  }
  var item2 = array4[moveIndex];
  var diff = moveIndex - toIndex;
  if (diff > 0) {
    return [].concat(_toConsumableArray(array4.slice(0, toIndex)), [item2], _toConsumableArray(array4.slice(toIndex, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, length2)));
  }
  if (diff < 0) {
    return [].concat(_toConsumableArray(array4.slice(0, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, toIndex + 1)), [item2], _toConsumableArray(array4.slice(toIndex + 1, length2)));
  }
  return array4;
}
var _excluded$c = ["name"];
var EMPTY_ERRORS = [];
function requireUpdate(shouldUpdate, prev4, next4, prevValue, nextValue, info) {
  if (typeof shouldUpdate === "function") {
    return shouldUpdate(prev4, next4, "source" in info ? {
      source: info.source
    } : {});
  }
  return prevValue !== nextValue;
}
var Field = /* @__PURE__ */ (function(_React$Component) {
  _inherits(Field2, _React$Component);
  var _super = _createSuper(Field2);
  function Field2(props) {
    var _this;
    _classCallCheck(this, Field2);
    _this = _super.call(this, props);
    _defineProperty$1(_assertThisInitialized$1(_this), "state", {
      resetCount: 0
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "cancelRegisterFunc", null);
    _defineProperty$1(_assertThisInitialized$1(_this), "mounted", false);
    _defineProperty$1(_assertThisInitialized$1(_this), "touched", false);
    _defineProperty$1(_assertThisInitialized$1(_this), "dirty", false);
    _defineProperty$1(_assertThisInitialized$1(_this), "validatePromise", void 0);
    _defineProperty$1(_assertThisInitialized$1(_this), "prevValidating", void 0);
    _defineProperty$1(_assertThisInitialized$1(_this), "errors", EMPTY_ERRORS);
    _defineProperty$1(_assertThisInitialized$1(_this), "warnings", EMPTY_ERRORS);
    _defineProperty$1(_assertThisInitialized$1(_this), "cancelRegister", function() {
      var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve, getNamePath(name));
      }
      _this.cancelRegisterFunc = null;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getNamePath", function() {
      var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== void 0 ? [].concat(_toConsumableArray(prefixName), _toConsumableArray(name)) : [];
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getRules", function() {
      var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules2 = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
      return rules2.map(function(rule) {
        if (typeof rule === "function") {
          return rule(fieldContext);
        }
        return rule;
      });
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "refresh", function() {
      if (!_this.mounted) return;
      _this.setState(function(_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "metaCache", null);
    _defineProperty$1(_assertThisInitialized$1(_this), "triggerMetaEvent", function(destroy) {
      var onMetaChange = _this.props.onMetaChange;
      if (onMetaChange) {
        var _meta = _objectSpread2$1(_objectSpread2$1({}, _this.getMeta()), {}, {
          destroy
        });
        if (!isEqual$1(_this.metaCache, _meta)) {
          onMetaChange(_meta);
        }
        _this.metaCache = _meta;
      } else {
        _this.metaCache = null;
      }
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "onStoreChange", function(prevStore, namePathList, info) {
      var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
      var store2 = info.store;
      var namePath = _this.getNamePath();
      var prevValue = _this.getValue(prevStore);
      var curValue = _this.getValue(store2);
      var namePathMatch = namePathList && containsNamePath(namePathList, namePath);
      if (info.type === "valueUpdate" && info.source === "external" && !isEqual$1(prevValue, curValue)) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;
        _this.triggerMetaEvent();
      }
      switch (info.type) {
        case "reset":
          if (!namePathList || namePathMatch) {
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = void 0;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;
            _this.triggerMetaEvent();
            onReset === null || onReset === void 0 || onReset();
            _this.refresh();
            return;
          }
          break;
        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case "remove": {
          if (shouldUpdate && requireUpdate(shouldUpdate, prevStore, store2, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var data2 = info.data;
          if (namePathMatch) {
            if ("touched" in data2) {
              _this.touched = data2.touched;
            }
            if ("validating" in data2 && !("originRCField" in data2)) {
              _this.validatePromise = data2.validating ? Promise.resolve([]) : null;
            }
            if ("errors" in data2) {
              _this.errors = data2.errors || EMPTY_ERRORS;
            }
            if ("warnings" in data2) {
              _this.warnings = data2.warnings || EMPTY_ERRORS;
            }
            _this.dirty = true;
            _this.triggerMetaEvent();
            _this.reRender();
            return;
          } else if ("value" in data2 && containsNamePath(namePathList, namePath, true)) {
            _this.reRender();
            return;
          }
          if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store2, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var dependencyList = dependencies.map(getNamePath);
          if (dependencyList.some(function(dependency) {
            return containsNamePath(info.relatedFields, dependency);
          })) {
            _this.reRender();
            return;
          }
          break;
        }
        default:
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store2, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
      }
      if (shouldUpdate === true) {
        _this.reRender();
      }
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "validateRules", function(options) {
      var namePath = _this.getNamePath();
      var currentValue = _this.getValue();
      var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
      var rootPromise = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
        var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.mounted) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", []);
            case 2:
              _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce;
              filteredRules = _this.getRules();
              if (triggerName) {
                filteredRules = filteredRules.filter(function(rule) {
                  return rule;
                }).filter(function(rule) {
                  var validateTrigger = rule.validateTrigger;
                  if (!validateTrigger) {
                    return true;
                  }
                  var triggerList = toArray$1(validateTrigger);
                  return triggerList.includes(triggerName);
                });
              }
              if (!(validateDebounce && triggerName)) {
                _context.next = 10;
                break;
              }
              _context.next = 8;
              return new Promise(function(resolve) {
                setTimeout(resolve, validateDebounce);
              });
            case 8:
              if (!(_this.validatePromise !== rootPromise)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", []);
            case 10:
              promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
              promise.catch(function(e) {
                return e;
              }).then(function() {
                var ruleErrors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                if (_this.validatePromise === rootPromise) {
                  var _ruleErrors$forEach;
                  _this.validatePromise = null;
                  var nextErrors = [];
                  var nextWarnings = [];
                  (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                    var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? EMPTY_ERRORS : _ref4$errors;
                    if (warningOnly) {
                      nextWarnings.push.apply(nextWarnings, _toConsumableArray(errors));
                    } else {
                      nextErrors.push.apply(nextErrors, _toConsumableArray(errors));
                    }
                  });
                  _this.errors = nextErrors;
                  _this.warnings = nextWarnings;
                  _this.triggerMetaEvent();
                  _this.reRender();
                }
              });
              return _context.abrupt("return", promise);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      if (validateOnly) {
        return rootPromise;
      }
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;
      _this.triggerMetaEvent();
      _this.reRender();
      return rootPromise;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isFieldValidating", function() {
      return !!_this.validatePromise;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isFieldTouched", function() {
      return _this.touched;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isFieldDirty", function() {
      if (_this.dirty || _this.props.initialValue !== void 0) {
        return true;
      }
      var fieldContext = _this.props.fieldContext;
      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK), getInitialValue = _fieldContext$getInte.getInitialValue;
      if (getInitialValue(_this.getNamePath()) !== void 0) {
        return true;
      }
      return false;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getErrors", function() {
      return _this.errors;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getWarnings", function() {
      return _this.warnings;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isListField", function() {
      return _this.props.isListField;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isList", function() {
      return _this.props.isList;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "isPreserve", function() {
      return _this.props.preserve;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getMeta", function() {
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath(),
        validated: _this.validatePromise === null
      };
      return meta;
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getOnlyChild", function(children2) {
      if (typeof children2 === "function") {
        var _meta2 = _this.getMeta();
        return _objectSpread2$1(_objectSpread2$1({}, _this.getOnlyChild(children2(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      }
      var childList = toArray$2(children2);
      if (childList.length !== 1 || !/* @__PURE__ */ React.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }
      return {
        child: childList[0],
        isFunction: false
      };
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getValue", function(store2) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;
      var namePath = _this.getNamePath();
      return get$2(store2 || getFieldsValue(true), namePath);
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getControlled", function() {
      var childProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize2 = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : fieldContext.validateTrigger;
      var namePath = _this.getNamePath();
      var getInternalHooks3 = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
      var _getInternalHooks = getInternalHooks3(HOOK_MARK), dispatch = _getInternalHooks.dispatch;
      var value = _this.getValue();
      var mergedGetValueProps = getValueProps || function(val) {
        return _defineProperty$1({}, valuePropName, val);
      };
      var originTriggerFunc = childProps[trigger];
      var valueProps = name !== void 0 ? mergedGetValueProps(value) : {};
      if (process.env.NODE_ENV !== "production" && valueProps) {
        Object.keys(valueProps).forEach(function(key) {
          warningOnce(typeof valueProps[key] !== "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(key, ")"));
        });
      }
      var control = _objectSpread2$1(_objectSpread2$1({}, childProps), valueProps);
      control[trigger] = function() {
        _this.touched = true;
        _this.dirty = true;
        _this.triggerMetaEvent();
        var newValue;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }
        if (normalize2) {
          newValue = normalize2(newValue, value, getFieldsValue(true));
        }
        if (newValue !== value) {
          dispatch({
            type: "updateValue",
            namePath,
            value: newValue
          });
        }
        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      };
      var validateTriggerList = toArray$1(mergedValidateTrigger || []);
      validateTriggerList.forEach(function(triggerName) {
        var originTrigger = control[triggerName];
        control[triggerName] = function() {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          }
          var rules2 = _this.props.rules;
          if (rules2 && rules2.length) {
            dispatch({
              type: "validateField",
              namePath,
              triggerName
            });
          }
        };
      });
      return control;
    });
    if (props.fieldContext) {
      var getInternalHooks2 = props.fieldContext.getInternalHooks;
      var _getInternalHooks2 = getInternalHooks2(HOOK_MARK), initEntityValue = _getInternalHooks2.initEntityValue;
      initEntityValue(_assertThisInitialized$1(_this));
    }
    return _this;
  }
  _createClass(Field2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
      this.mounted = true;
      if (fieldContext) {
        var getInternalHooks2 = fieldContext.getInternalHooks;
        var _getInternalHooks3 = getInternalHooks2(HOOK_MARK), registerField = _getInternalHooks3.registerField;
        this.cancelRegisterFunc = registerField(this);
      }
      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render2() {
      var resetCount = this.state.resetCount;
      var children2 = this.props.children;
      var _this$getOnlyChild = this.getOnlyChild(children2), child = _this$getOnlyChild.child, isFunction2 = _this$getOnlyChild.isFunction;
      var returnChildNode;
      if (isFunction2) {
        returnChildNode = child;
      } else if (/* @__PURE__ */ React.isValidElement(child)) {
        returnChildNode = /* @__PURE__ */ React.cloneElement(child, this.getControlled(child.props));
      } else {
        warningOnce(!child, "`children` of Field is not validate ReactElement.");
        returnChildNode = child;
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);
  return Field2;
})(React.Component);
_defineProperty$1(Field, "contextType", Context);
_defineProperty$1(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(_ref6) {
  var _restProps$isListFiel;
  var name = _ref6.name, restProps = _objectWithoutProperties(_ref6, _excluded$c);
  var fieldContext = React.useContext(Context);
  var listContext = React.useContext(ListContext);
  var namePath = name !== void 0 ? getNamePath(name) : void 0;
  var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
  var key = "keep";
  if (!isMergedListField) {
    key = "_".concat((namePath || []).join("_"));
  }
  if (process.env.NODE_ENV !== "production" && restProps.preserve === false && isMergedListField && namePath.length <= 1) {
    warningOnce(false, "`preserve` should not apply on Form.List fields.");
  }
  return /* @__PURE__ */ React.createElement(Field, _extends$6({
    key,
    name: namePath,
    isListField: isMergedListField
  }, restProps, {
    fieldContext
  }));
}
function List$1(_ref) {
  var name = _ref.name, initialValue = _ref.initialValue, children2 = _ref.children, rules2 = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
  var context2 = React.useContext(Context);
  var wrapperListContext = React.useContext(ListContext);
  var keyRef = React.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = React.useMemo(function() {
    var parentPrefixName = getNamePath(context2.prefixName) || [];
    return [].concat(_toConsumableArray(parentPrefixName), _toConsumableArray(getNamePath(name)));
  }, [context2.prefixName, name]);
  var fieldContext = React.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, context2), {}, {
      prefixName
    });
  }, [context2, prefixName]);
  var listContext = React.useMemo(function() {
    return {
      getKey: function getKey(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]);
  if (typeof children2 !== "function") {
    warningOnce(false, "Form.List only accepts function as children.");
    return null;
  }
  var shouldUpdate = function shouldUpdate2(prevValue, nextValue, _ref2) {
    var source = _ref2.source;
    if (source === "internal") {
      return false;
    }
    return prevValue !== nextValue;
  };
  return /* @__PURE__ */ React.createElement(ListContext.Provider, {
    value: listContext
  }, /* @__PURE__ */ React.createElement(Context.Provider, {
    value: fieldContext
  }, /* @__PURE__ */ React.createElement(WrapperField, {
    name: [],
    shouldUpdate,
    rules: rules2,
    validateTrigger,
    initialValue,
    isList: true,
    isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
  }, function(_ref3, meta) {
    var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange5 = _ref3.onChange;
    var getFieldValue = context2.getFieldValue;
    var getNewValue = function getNewValue2() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    var operations = {
      add: function add3(defaultValue, index2) {
        var newValue = getNewValue();
        if (index2 >= 0 && index2 <= newValue.length) {
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys.slice(0, index2)), [keyManager.id], _toConsumableArray(keyManager.keys.slice(index2)));
          onChange5([].concat(_toConsumableArray(newValue.slice(0, index2)), [defaultValue], _toConsumableArray(newValue.slice(index2))));
        } else {
          if (process.env.NODE_ENV !== "production" && (index2 < 0 || index2 > newValue.length)) {
            warningOnce(false, "The second parameter of the add function should be a valid positive number.");
          }
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange5([].concat(_toConsumableArray(newValue), [defaultValue]));
        }
        keyManager.id += 1;
      },
      remove: function remove(index2) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index2) ? index2 : [index2]);
        if (indexSet.size <= 0) {
          return;
        }
        keyManager.keys = keyManager.keys.filter(function(_2, keysIndex) {
          return !indexSet.has(keysIndex);
        });
        onChange5(newValue.filter(function(_2, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move2(from2, to) {
        if (from2 === to) {
          return;
        }
        var newValue = getNewValue();
        if (from2 < 0 || from2 >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }
        keyManager.keys = move$1(keyManager.keys, from2, to);
        onChange5(move$1(newValue, from2, to));
      }
    };
    var listValue = value || [];
    if (!Array.isArray(listValue)) {
      listValue = [];
      if (process.env.NODE_ENV !== "production") {
        warningOnce(false, "Current value of '".concat(prefixName.join(" > "), "' is not an array type."));
      }
    }
    return children2(listValue.map(function(__, index2) {
      var key = keyManager.keys[index2];
      if (key === void 0) {
        keyManager.keys[index2] = keyManager.id;
        key = keyManager.keys[index2];
        keyManager.id += 1;
      }
      return {
        name: index2,
        key,
        isListField: true
      };
    }), operations, meta);
  })));
}
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function(resolve, reject) {
    promiseList.forEach(function(promise, index2) {
      promise.catch(function(e) {
        hasError = true;
        return e;
      }).then(function(result) {
        count -= 1;
        results[index2] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}
var SPLIT = "__@field_split__";
function normalize(namePath) {
  return namePath.map(function(cell) {
    return "".concat(_typeof$3(cell), ":").concat(cell);
  }).join(SPLIT);
}
var NameMap = /* @__PURE__ */ (function() {
  function NameMap2() {
    _classCallCheck(this, NameMap2);
    _defineProperty$1(this, "kvs", /* @__PURE__ */ new Map());
  }
  _createClass(NameMap2, [{
    key: "set",
    value: function set2(key, value) {
      this.kvs.set(normalize(key), value);
    }
  }, {
    key: "get",
    value: function get4(key) {
      return this.kvs.get(normalize(key));
    }
  }, {
    key: "update",
    value: function update2(key, updater) {
      var origin2 = this.get(key);
      var next4 = updater(origin2);
      if (!next4) {
        this.delete(key);
      } else {
        this.set(key, next4);
      }
    }
  }, {
    key: "delete",
    value: function _delete2(key) {
      this.kvs.delete(normalize(key));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function map(callback) {
      return _toConsumableArray(this.kvs.entries()).map(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cells = key.split(SPLIT);
        return callback({
          key: cells.map(function(cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = _slicedToArray(_cell$match, 3), type4 = _cell$match2[1], unit2 = _cell$match2[2];
            return type4 === "number" ? Number(unit2) : unit2;
          }),
          value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function(_ref3) {
        var key = _ref3.key, value = _ref3.value;
        json[key.join(".")] = value;
        return null;
      });
      return json;
    }
  }]);
  return NameMap2;
})();
var _excluded$b = ["name"];
var FormStore = /* @__PURE__ */ _createClass(function FormStore2(forceRootUpdate) {
  var _this = this;
  _classCallCheck(this, FormStore2);
  _defineProperty$1(this, "formHooked", false);
  _defineProperty$1(this, "forceRootUpdate", void 0);
  _defineProperty$1(this, "subscribable", true);
  _defineProperty$1(this, "store", {});
  _defineProperty$1(this, "fieldEntities", []);
  _defineProperty$1(this, "initialValues", {});
  _defineProperty$1(this, "callbacks", {});
  _defineProperty$1(this, "validateMessages", null);
  _defineProperty$1(this, "preserve", null);
  _defineProperty$1(this, "lastValidatePromise", null);
  _defineProperty$1(this, "getForm", function() {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      _init: true,
      getInternalHooks: _this.getInternalHooks
    };
  });
  _defineProperty$1(this, "getInternalHooks", function(key) {
    if (key === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        destroyForm: _this.destroyForm,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue,
        registerWatch: _this.registerWatch
      };
    }
    warningOnce(false, "`getInternalHooks` is internal usage. Should not call directly.");
    return null;
  });
  _defineProperty$1(this, "useSubscribe", function(subscribable) {
    _this.subscribable = subscribable;
  });
  _defineProperty$1(this, "prevWithoutPreserves", null);
  _defineProperty$1(this, "setInitialValues", function(initialValues, init2) {
    _this.initialValues = initialValues || {};
    if (init2) {
      var _this$prevWithoutPres;
      var nextStore = merge$2(initialValues, _this.store);
      (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
        var namePath = _ref.key;
        nextStore = set$1(nextStore, namePath, get$2(initialValues, namePath));
      });
      _this.prevWithoutPreserves = null;
      _this.updateStore(nextStore);
    }
  });
  _defineProperty$1(this, "destroyForm", function(clearOnDestroy) {
    if (clearOnDestroy) {
      _this.updateStore({});
    } else {
      var prevWithoutPreserves = new NameMap();
      _this.getFieldEntities(true).forEach(function(entity) {
        if (!_this.isMergedPreserve(entity.isPreserve())) {
          prevWithoutPreserves.set(entity.getNamePath(), true);
        }
      });
      _this.prevWithoutPreserves = prevWithoutPreserves;
    }
  });
  _defineProperty$1(this, "getInitialValue", function(namePath) {
    var initValue = get$2(_this.initialValues, namePath);
    return namePath.length ? merge$2(initValue) : initValue;
  });
  _defineProperty$1(this, "setCallbacks", function(callbacks) {
    _this.callbacks = callbacks;
  });
  _defineProperty$1(this, "setValidateMessages", function(validateMessages) {
    _this.validateMessages = validateMessages;
  });
  _defineProperty$1(this, "setPreserve", function(preserve) {
    _this.preserve = preserve;
  });
  _defineProperty$1(this, "watchList", []);
  _defineProperty$1(this, "registerWatch", function(callback) {
    _this.watchList.push(callback);
    return function() {
      _this.watchList = _this.watchList.filter(function(fn) {
        return fn !== callback;
      });
    };
  });
  _defineProperty$1(this, "notifyWatch", function() {
    var namePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (_this.watchList.length) {
      var values = _this.getFieldsValue();
      var allValues = _this.getFieldsValue(true);
      _this.watchList.forEach(function(callback) {
        callback(values, allValues, namePath);
      });
    }
  });
  _defineProperty$1(this, "timeoutId", null);
  _defineProperty$1(this, "warningUnhooked", function() {
    if (process.env.NODE_ENV !== "production" && !_this.timeoutId && typeof window !== "undefined") {
      _this.timeoutId = setTimeout(function() {
        _this.timeoutId = null;
        if (!_this.formHooked) {
          warningOnce(false, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
        }
      });
    }
  });
  _defineProperty$1(this, "updateStore", function(nextStore) {
    _this.store = nextStore;
  });
  _defineProperty$1(this, "getFieldEntities", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!pure) {
      return _this.fieldEntities;
    }
    return _this.fieldEntities.filter(function(field) {
      return field.getNamePath().length;
    });
  });
  _defineProperty$1(this, "getFieldsMap", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var cache2 = new NameMap();
    _this.getFieldEntities(pure).forEach(function(field) {
      var namePath = field.getNamePath();
      cache2.set(namePath, field);
    });
    return cache2;
  });
  _defineProperty$1(this, "getFieldEntitiesForNamePathList", function(nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }
    var cache2 = _this.getFieldsMap(true);
    return nameList.map(function(name) {
      var namePath = getNamePath(name);
      return cache2.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  });
  _defineProperty$1(this, "getFieldsValue", function(nameList, filterFunc) {
    _this.warningUnhooked();
    var mergedNameList;
    var mergedFilterFunc;
    var mergedStrict;
    if (nameList === true || Array.isArray(nameList)) {
      mergedNameList = nameList;
      mergedFilterFunc = filterFunc;
    } else if (nameList && _typeof$3(nameList) === "object") {
      mergedStrict = nameList.strict;
      mergedFilterFunc = nameList.filter;
    }
    if (mergedNameList === true && !mergedFilterFunc) {
      return _this.store;
    }
    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
    var filteredNameList = [];
    fieldEntities.forEach(function(entity) {
      var _isListField, _ref3;
      var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
      if (mergedStrict) {
        var _isList, _ref2;
        if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) {
          return;
        }
      } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) {
        return;
      }
      if (!mergedFilterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = "getMeta" in entity ? entity.getMeta() : null;
        if (mergedFilterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  });
  _defineProperty$1(this, "getFieldValue", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    return get$2(_this.store, namePath);
  });
  _defineProperty$1(this, "getFieldsError", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
    return fieldEntities.map(function(entity, index2) {
      if (entity && !("INVALIDATE_NAME_PATH" in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }
      return {
        name: getNamePath(nameList[index2]),
        errors: [],
        warnings: []
      };
    });
  });
  _defineProperty$1(this, "getFieldError", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.errors;
  });
  _defineProperty$1(this, "getFieldWarning", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.warnings;
  });
  _defineProperty$1(this, "isFieldsTouched", function() {
    _this.warningUnhooked();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg0 = args[0], arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;
    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }
    var fieldEntities = _this.getFieldEntities(true);
    var isFieldTouched = function isFieldTouched2(field) {
      return field.isFieldTouched();
    };
    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(function(entity) {
        return isFieldTouched(entity) || entity.isList();
      }) : fieldEntities.some(isFieldTouched);
    }
    var map = new NameMap();
    namePathList.forEach(function(shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function(field) {
      var fieldNamePath = field.getNamePath();
      namePathList.forEach(function(shortNamePath) {
        if (shortNamePath.every(function(nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function(list) {
            return [].concat(_toConsumableArray(list), [field]);
          });
        }
      });
    });
    var isNamePathListTouched = function isNamePathListTouched2(entities) {
      return entities.some(isFieldTouched);
    };
    var namePathListEntities = map.map(function(_ref4) {
      var value = _ref4.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  });
  _defineProperty$1(this, "isFieldTouched", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsTouched([name]);
  });
  _defineProperty$1(this, "isFieldsValidating", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntities();
    if (!nameList) {
      return fieldEntities.some(function(testField) {
        return testField.isFieldValidating();
      });
    }
    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function(testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  });
  _defineProperty$1(this, "isFieldValidating", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsValidating([name]);
  });
  _defineProperty$1(this, "resetWithFieldInitialValue", function() {
    var info = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cache2 = new NameMap();
    var fieldEntities = _this.getFieldEntities(true);
    fieldEntities.forEach(function(field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath();
      if (initialValue !== void 0) {
        var records = cache2.get(namePath) || /* @__PURE__ */ new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache2.set(namePath, records);
      }
    });
    var resetWithFields = function resetWithFields2(entities) {
      entities.forEach(function(field) {
        var initialValue = field.props.initialValue;
        if (initialValue !== void 0) {
          var namePath = field.getNamePath();
          var formInitialValue = _this.getInitialValue(namePath);
          if (formInitialValue !== void 0) {
            warningOnce(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
          } else {
            var records = cache2.get(namePath);
            if (records && records.size > 1) {
              warningOnce(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath);
              var isListField = field.isListField();
              if (!isListField && (!info.skipExist || originValue === void 0)) {
                _this.updateStore(set$1(_this.store, namePath, _toConsumableArray(records)[0].value));
              }
            }
          }
        }
      });
    };
    var requiredFieldEntities;
    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function(namePath) {
        var records = cache2.get(namePath);
        if (records) {
          var _requiredFieldEntitie;
          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, _toConsumableArray(_toConsumableArray(records).map(function(r2) {
            return r2.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }
    resetWithFields(requiredFieldEntities);
  });
  _defineProperty$1(this, "resetFields", function(nameList) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (!nameList) {
      _this.updateStore(merge$2(_this.initialValues));
      _this.resetWithFieldInitialValue();
      _this.notifyObservers(prevStore, null, {
        type: "reset"
      });
      _this.notifyWatch();
      return;
    }
    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function(namePath) {
      var initialValue = _this.getInitialValue(namePath);
      _this.updateStore(set$1(_this.store, namePath, initialValue));
    });
    _this.resetWithFieldInitialValue({
      namePathList
    });
    _this.notifyObservers(prevStore, namePathList, {
      type: "reset"
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty$1(this, "setFields", function(fields) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    var namePathList = [];
    fields.forEach(function(fieldData) {
      var name = fieldData.name, data2 = _objectWithoutProperties(fieldData, _excluded$b);
      var namePath = getNamePath(name);
      namePathList.push(namePath);
      if ("value" in data2) {
        _this.updateStore(set$1(_this.store, namePath, data2.value));
      }
      _this.notifyObservers(prevStore, [namePath], {
        type: "setField",
        data: fieldData
      });
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty$1(this, "getFields", function() {
    var entities = _this.getFieldEntities(true);
    var fields = entities.map(function(field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();
      var fieldData = _objectSpread2$1(_objectSpread2$1({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });
      Object.defineProperty(fieldData, "originRCField", {
        value: true
      });
      return fieldData;
    });
    return fields;
  });
  _defineProperty$1(this, "initEntityValue", function(entity) {
    var initialValue = entity.props.initialValue;
    if (initialValue !== void 0) {
      var namePath = entity.getNamePath();
      var prevValue = get$2(_this.store, namePath);
      if (prevValue === void 0) {
        _this.updateStore(set$1(_this.store, namePath, initialValue));
      }
    }
  });
  _defineProperty$1(this, "isMergedPreserve", function(fieldPreserve) {
    var mergedPreserve = fieldPreserve !== void 0 ? fieldPreserve : _this.preserve;
    return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
  });
  _defineProperty$1(this, "registerField", function(entity) {
    _this.fieldEntities.push(entity);
    var namePath = entity.getNamePath();
    _this.notifyWatch([namePath]);
    if (entity.props.initialValue !== void 0) {
      var prevStore = _this.store;
      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });
      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(isListField, preserve) {
      var subNamePath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function(item2) {
        return item2 !== entity;
      });
      if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
        var defaultValue = isListField ? void 0 : _this.getInitialValue(namePath);
        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;
          _this.updateStore(set$1(_prevStore, namePath, defaultValue, true));
          _this.notifyObservers(_prevStore, [namePath], {
            type: "remove"
          });
          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }
      _this.notifyWatch([namePath]);
    };
  });
  _defineProperty$1(this, "dispatch", function(action3) {
    switch (action3.type) {
      case "updateValue": {
        var namePath = action3.namePath, value = action3.value;
        _this.updateValue(namePath, value);
        break;
      }
      case "validateField": {
        var _namePath = action3.namePath, triggerName = action3.triggerName;
        _this.validateFields([_namePath], {
          triggerName
        });
        break;
      }
    }
  });
  _defineProperty$1(this, "notifyObservers", function(prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = _objectSpread2$1(_objectSpread2$1({}, info), {}, {
        store: _this.getFieldsValue(true)
      });
      _this.getFieldEntities().forEach(function(_ref5) {
        var onStoreChange = _ref5.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  });
  _defineProperty$1(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);
    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }
    _this.notifyObservers(prevStore, childrenFields, {
      type: "dependenciesUpdate",
      relatedFields: [namePath].concat(_toConsumableArray(childrenFields))
    });
    return childrenFields;
  });
  _defineProperty$1(this, "updateValue", function(name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;
    _this.updateStore(set$1(_this.store, namePath, value));
    _this.notifyObservers(prevStore, [namePath], {
      type: "valueUpdate",
      source: "internal"
    });
    _this.notifyWatch([namePath]);
    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
    var onValuesChange = _this.callbacks.onValuesChange;
    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }
    _this.triggerOnFieldsChange([namePath].concat(_toConsumableArray(childrenFields)));
  });
  _defineProperty$1(this, "setFieldsValue", function(store2) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (store2) {
      var nextStore = merge$2(_this.store, store2);
      _this.updateStore(nextStore);
    }
    _this.notifyObservers(prevStore, null, {
      type: "valueUpdate",
      source: "external"
    });
    _this.notifyWatch();
  });
  _defineProperty$1(this, "setFieldValue", function(name, value) {
    _this.setFields([{
      name,
      value,
      errors: [],
      warnings: []
    }]);
  });
  _defineProperty$1(this, "getDependencyChildrenFields", function(rootNamePath) {
    var children2 = /* @__PURE__ */ new Set();
    var childrenFields = [];
    var dependencies2fields = new NameMap();
    _this.getFieldEntities().forEach(function(field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function(dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function() {
          var fields = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          fields.add(field);
          return fields;
        });
      });
    });
    var fillChildren = function fillChildren2(namePath) {
      var fields = dependencies2fields.get(namePath) || /* @__PURE__ */ new Set();
      fields.forEach(function(field) {
        if (!children2.has(field)) {
          children2.add(field);
          var fieldNamePath = field.getNamePath();
          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren2(fieldNamePath);
          }
        }
      });
    };
    fillChildren(rootNamePath);
    return childrenFields;
  });
  _defineProperty$1(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;
    if (onFieldsChange) {
      var fields = _this.getFields();
      if (filedErrors) {
        var cache2 = new NameMap();
        filedErrors.forEach(function(_ref6) {
          var name = _ref6.name, errors = _ref6.errors;
          cache2.set(name, errors);
        });
        fields.forEach(function(field) {
          field.errors = cache2.get(field.name) || field.errors;
        });
      }
      var changedFields = fields.filter(function(_ref7) {
        var fieldName = _ref7.name;
        return containsNamePath(namePathList, fieldName);
      });
      if (changedFields.length) {
        onFieldsChange(changedFields, fields);
      }
    }
  });
  _defineProperty$1(this, "validateFields", function(arg1, arg2) {
    _this.warningUnhooked();
    var nameList;
    var options;
    if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
      nameList = arg1;
      options = arg2;
    } else {
      options = arg1;
    }
    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : [];
    var promiseList = [];
    var TMP_SPLIT = String(Date.now());
    var validateNamePathList = /* @__PURE__ */ new Set();
    var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
    _this.getFieldEntities(true).forEach(function(field) {
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      if (!field.props.rules || !field.props.rules.length) {
        return;
      }
      if (dirty && !field.isFieldDirty()) {
        return;
      }
      var fieldNamePath = field.getNamePath();
      validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
      if (!provideNameList || containsNamePath(namePathList, fieldNamePath, recursive)) {
        var promise = field.validateRules(_objectSpread2$1({
          validateMessages: _objectSpread2$1(_objectSpread2$1({}, defaultValidateMessages), _this.validateMessages)
        }, options));
        promiseList.push(promise.then(function() {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function(ruleErrors) {
          var _ruleErrors$forEach;
          var mergedErrors = [];
          var mergedWarnings = [];
          (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
            var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
            }
          });
          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }
          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });
    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise;
    summaryPromise.catch(function(results) {
      return results;
    }).then(function(results) {
      var resultNamePathList = results.map(function(_ref10) {
        var name = _ref10.name;
        return name;
      });
      _this.notifyObservers(_this.store, resultNamePathList, {
        type: "validateFinish"
      });
      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function() {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }
      return Promise.reject([]);
    }).catch(function(results) {
      var errorList = results.filter(function(result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    });
    returnPromise.catch(function(e) {
      return e;
    });
    var triggerNamePathList = namePathList.filter(function(namePath) {
      return validateNamePathList.has(namePath.join(TMP_SPLIT));
    });
    _this.triggerOnFieldsChange(triggerNamePathList);
    return returnPromise;
  });
  _defineProperty$1(this, "submit", function() {
    _this.warningUnhooked();
    _this.validateFields().then(function(values) {
      var onFinish = _this.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function(e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  });
  this.forceRootUpdate = forceRootUpdate;
});
function useForm(form) {
  var formRef = React.useRef();
  var _React$useState = React.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      var forceReRender = function forceReRender2() {
        forceUpdate({});
      };
      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
var FormContext = /* @__PURE__ */ React.createContext({
  triggerFormChange: function triggerFormChange() {
  },
  triggerFormFinish: function triggerFormFinish() {
  },
  registerForm: function registerForm() {
  },
  unregisterForm: function unregisterForm() {
  }
});
var FormProvider = function FormProvider2(_ref) {
  var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children2 = _ref.children;
  var formContext = React.useContext(FormContext);
  var formsRef = React.useRef({});
  return /* @__PURE__ */ React.createElement(FormContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, formContext), {}, {
      validateMessages: _objectSpread2$1(_objectSpread2$1({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange2(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields,
            forms: formsRef.current
          });
        }
        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish2(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values,
            forms: formsRef.current
          });
        }
        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm2(name, form) {
        if (name) {
          formsRef.current = _objectSpread2$1(_objectSpread2$1({}, formsRef.current), {}, _defineProperty$1({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm2(name) {
        var newForms = _objectSpread2$1({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children2);
};
var _excluded$a = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"];
var Form$1 = function Form(_ref, ref2) {
  var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children2 = _ref.children, _ref$component = _ref.component, Component2 = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = _objectWithoutProperties(_ref, _excluded$a);
  var nativeElementRef = React.useRef(null);
  var formContext = React.useContext(FormContext);
  var _useForm = useForm(form), _useForm2 = _slicedToArray(_useForm, 1), formInstance = _useForm2[0];
  var _getInternalHooks = formInstance.getInternalHooks(HOOK_MARK), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
  React.useImperativeHandle(ref2, function() {
    return _objectSpread2$1(_objectSpread2$1({}, formInstance), {}, {
      nativeElement: nativeElementRef.current
    });
  });
  React.useEffect(function() {
    formContext.registerForm(name, formInstance);
    return function() {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]);
  setValidateMessages(_objectSpread2$1(_objectSpread2$1({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);
      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }
        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);
      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed
  });
  setPreserve(preserve);
  var mountRef = React.useRef(null);
  setInitialValues(initialValues, !mountRef.current);
  if (!mountRef.current) {
    mountRef.current = true;
  }
  React.useEffect(
    function() {
      return function() {
        return destroyForm(clearOnDestroy);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var childrenNode;
  var childrenRenderProps = typeof children2 === "function";
  if (childrenRenderProps) {
    var _values = formInstance.getFieldsValue(true);
    childrenNode = children2(_values, formInstance);
  } else {
    childrenNode = children2;
  }
  useSubscribe(!childrenRenderProps);
  var prevFieldsRef = React.useRef();
  React.useEffect(function() {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }
    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = React.useMemo(function() {
    return _objectSpread2$1(_objectSpread2$1({}, formInstance), {}, {
      validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /* @__PURE__ */ React.createElement(ListContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Context.Provider, {
    value: formContextValue
  }, childrenNode));
  if (Component2 === false) {
    return wrapperNode;
  }
  return /* @__PURE__ */ React.createElement(Component2, _extends$6({}, restProps, {
    ref: nativeElementRef,
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;
      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};
function stringify(value) {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return Math.random();
  }
}
var useWatchWarning = process.env.NODE_ENV !== "production" ? function(namePath) {
  var fullyStr = namePath.join("__RC_FIELD_FORM_SPLIT__");
  var nameStrRef = useRef(fullyStr);
  warningOnce(nameStrRef.current === fullyStr, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function useWatch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
  var options = isFormInstance(_form) ? {
    form: _form
  } : _form;
  var form = options.form;
  var _useState = useState$1(), _useState2 = _slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
  var valueStr = useMemo$2(function() {
    return stringify(value);
  }, [value]);
  var valueStrRef = useRef(valueStr);
  valueStrRef.current = valueStr;
  var fieldContext = useContext(Context);
  var formInstance = form || fieldContext;
  var isValidForm = formInstance && formInstance._init;
  if (process.env.NODE_ENV !== "production") {
    warningOnce(args.length === 2 ? form ? isValidForm : true : isValidForm, "useWatch requires a form instance since it can not auto detect from context.");
  }
  var namePath = getNamePath(dependencies);
  var namePathRef = useRef(namePath);
  namePathRef.current = namePath;
  useWatchWarning(namePath);
  useEffect(
    function() {
      if (!isValidForm) {
        return;
      }
      var getFieldsValue = formInstance.getFieldsValue, getInternalHooks2 = formInstance.getInternalHooks;
      var _getInternalHooks = getInternalHooks2(HOOK_MARK), registerWatch = _getInternalHooks.registerWatch;
      var getWatchValue = function getWatchValue2(values, allValues) {
        var watchValue = options.preserve ? allValues : values;
        return typeof dependencies === "function" ? dependencies(watchValue) : get$2(watchValue, namePathRef.current);
      };
      var cancelRegister = registerWatch(function(values, allValues) {
        var newValue = getWatchValue(values, allValues);
        var nextValueStr = stringify(newValue);
        if (valueStrRef.current !== nextValueStr) {
          valueStrRef.current = nextValueStr;
          setValue(newValue);
        }
      });
      var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
      if (value !== initialValue) {
        setValue(initialValue);
      }
      return cancelRegister;
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isValidForm]
  );
  return value;
}
var InternalForm = /* @__PURE__ */ React.forwardRef(Form$1);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = WrapperField;
RefForm.List = List$1;
RefForm.useForm = useForm;
RefForm.useWatch = useWatch;
const es$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Field: WrapperField,
  FieldContext: Context,
  FormProvider,
  List: List$1,
  ListContext,
  default: RefForm,
  useForm,
  useWatch
}, Symbol.toStringTag, { value: "Module" }));
const require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(es$4);
var omit$1 = {};
var hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit$1;
  hasRequiredOmit = 1;
  Object.defineProperty(omit$1, "__esModule", {
    value: true
  });
  omit$1.default = omit2;
  function omit2(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) {
      fields.forEach(function(key) {
        delete clone[key];
      });
    }
    return clone;
  }
  return omit$1;
}
var hasRequiredContext;
function requireContext() {
  if (hasRequiredContext) return context;
  hasRequiredContext = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(context, "__esModule", {
    value: true
  });
  context.VariantContext = context.NoStyleItemContext = context.NoFormStyle = context.FormProvider = context.FormItemPrefixContext = context.FormItemInputContext = context.FormContext = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _rcFieldForm = require$$3$1;
  var _omit = _interopRequireDefault(requireOmit());
  context.FormContext = /* @__PURE__ */ React2.createContext({
    labelAlign: "right",
    vertical: false,
    itemRef: () => {
    }
  });
  context.NoStyleItemContext = /* @__PURE__ */ React2.createContext(null);
  const FormProvider3 = (props) => {
    const providerProps = (0, _omit.default)(props, ["prefixCls"]);
    return /* @__PURE__ */ React2.createElement(_rcFieldForm.FormProvider, Object.assign({}, providerProps));
  };
  context.FormProvider = FormProvider3;
  context.FormItemPrefixContext = /* @__PURE__ */ React2.createContext({
    prefixCls: ""
  });
  const FormItemInputContext = context.FormItemInputContext = /* @__PURE__ */ React2.createContext({});
  if (process.env.NODE_ENV !== "production") {
    FormItemInputContext.displayName = "FormItemInputContext";
  }
  const NoFormStyle = (_ref) => {
    let {
      children: children2,
      status,
      override
    } = _ref;
    const formItemInputContext = React2.useContext(FormItemInputContext);
    const newFormItemInputContext = React2.useMemo(() => {
      const newContext = Object.assign({}, formItemInputContext);
      if (override) {
        delete newContext.isFormItemInput;
      }
      if (status) {
        delete newContext.status;
        delete newContext.hasFeedback;
        delete newContext.feedbackIcon;
      }
      return newContext;
    }, [status, override, formItemInputContext]);
    return /* @__PURE__ */ React2.createElement(FormItemInputContext.Provider, {
      value: newFormItemInputContext
    }, children2);
  };
  context.NoFormStyle = NoFormStyle;
  context.VariantContext = /* @__PURE__ */ React2.createContext(void 0);
  return context;
}
var style$5 = {};
var compactItem = {};
var hasRequiredCompactItem;
function requireCompactItem() {
  if (hasRequiredCompactItem) return compactItem;
  hasRequiredCompactItem = 1;
  Object.defineProperty(compactItem, "__esModule", {
    value: true
  });
  compactItem.genCompactItemStyle = genCompactItemStyle;
  function compactItemBorder(token2, parentCls, options) {
    const {
      focusElCls,
      focus,
      borderElCls
    } = options;
    const childCombinator = borderElCls ? "> *" : "";
    const hoverEffects = ["hover", focus ? "focus" : null, "active"].filter(Boolean).map((n) => `&:${n} ${childCombinator}`).join(",");
    return {
      [`&-item:not(${parentCls}-last-item)`]: {
        marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal()
      },
      "&-item": Object.assign(Object.assign({
        [hoverEffects]: {
          zIndex: 2
        }
      }, focusElCls ? {
        [`&${focusElCls}`]: {
          zIndex: 2
        }
      } : {}), {
        [`&[disabled] ${childCombinator}`]: {
          zIndex: 0
        }
      })
    };
  }
  function compactItemBorderRadius(prefixCls, parentCls, options) {
    const {
      borderElCls
    } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : "";
    return {
      [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
        borderRadius: 0
      },
      [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
        [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        }
      },
      [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
        [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        }
      }
    };
  }
  function genCompactItemStyle(token2) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      focus: true
    };
    const {
      componentCls
    } = token2;
    const compactCls = `${componentCls}-compact`;
    return {
      [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token2, compactCls, options)), compactItemBorderRadius(componentCls, compactCls, options))
    };
  }
  return compactItem;
}
var token$1 = {};
var hasRequiredToken$1;
function requireToken$1() {
  if (hasRequiredToken$1) return token$1;
  hasRequiredToken$1 = 1;
  Object.defineProperty(token$1, "__esModule", {
    value: true
  });
  token$1.initComponentToken = void 0;
  token$1.initInputToken = initInputToken;
  var _internal = /* @__PURE__ */ requireInternal();
  function initInputToken(token2) {
    return (0, _internal.mergeToken)(token2, {
      inputAffixPadding: token2.paddingXXS
    });
  }
  const initComponentToken = (token2) => {
    const {
      controlHeight,
      fontSize,
      lineHeight,
      lineWidth,
      controlHeightSM,
      controlHeightLG,
      fontSizeLG,
      lineHeightLG,
      paddingSM,
      controlPaddingHorizontalSM,
      controlPaddingHorizontal,
      colorFillAlter,
      colorPrimaryHover,
      colorPrimary,
      controlOutlineWidth,
      controlOutline,
      colorErrorOutline,
      colorWarningOutline,
      colorBgContainer,
      inputFontSize,
      inputFontSizeLG,
      inputFontSizeSM
    } = token2;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
      paddingBlock: Math.max(paddingBlock, 0),
      paddingBlockSM: Math.max(paddingBlockSM, 0),
      paddingBlockLG: Math.max(paddingBlockLG, 0),
      paddingInline: paddingSM - lineWidth,
      paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
      paddingInlineLG: controlPaddingHorizontal - lineWidth,
      addonBg: colorFillAlter,
      activeBorderColor: colorPrimary,
      hoverBorderColor: colorPrimaryHover,
      activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
      errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
      warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
      hoverBg: colorBgContainer,
      activeBg: colorBgContainer,
      inputFontSize: mergedFontSize,
      inputFontSizeLG: mergedFontSizeLG,
      inputFontSizeSM: mergedFontSizeSM
    };
  };
  token$1.initComponentToken = initComponentToken;
  return token$1;
}
var variants = {};
var hasRequiredVariants;
function requireVariants() {
  if (hasRequiredVariants) return variants;
  hasRequiredVariants = 1;
  Object.defineProperty(variants, "__esModule", {
    value: true
  });
  variants.genUnderlinedStyle = variants.genOutlinedStyle = variants.genOutlinedGroupStyle = variants.genHoverStyle = variants.genFilledStyle = variants.genFilledGroupStyle = variants.genDisabledStyle = variants.genBorderlessStyle = variants.genBaseUnderlinedStyle = variants.genBaseOutlinedStyle = void 0;
  var _cssinjs = require$$2$2;
  var _internal = /* @__PURE__ */ requireInternal();
  const genHoverStyle = (token2) => ({
    borderColor: token2.hoverBorderColor,
    backgroundColor: token2.hoverBg
  });
  variants.genHoverStyle = genHoverStyle;
  const genDisabledStyle = (token2) => ({
    color: token2.colorTextDisabled,
    backgroundColor: token2.colorBgContainerDisabled,
    borderColor: token2.colorBorder,
    boxShadow: "none",
    cursor: "not-allowed",
    opacity: 1,
    "input[disabled], textarea[disabled]": {
      cursor: "not-allowed"
    },
    "&:hover:not([disabled])": Object.assign({}, genHoverStyle((0, _internal.mergeToken)(token2, {
      hoverBorderColor: token2.colorBorder,
      hoverBg: token2.colorBgContainerDisabled
    })))
  });
  variants.genDisabledStyle = genDisabledStyle;
  const genBaseOutlinedStyle = (token2, options) => ({
    background: token2.colorBgContainer,
    borderWidth: token2.lineWidth,
    borderStyle: token2.lineType,
    borderColor: options.borderColor,
    "&:hover": {
      borderColor: options.hoverBorderColor,
      backgroundColor: token2.hoverBg
    },
    "&:focus, &:focus-within": {
      borderColor: options.activeBorderColor,
      boxShadow: options.activeShadow,
      outline: 0,
      backgroundColor: token2.activeBg
    }
  });
  variants.genBaseOutlinedStyle = genBaseOutlinedStyle;
  const genOutlinedStatusStyle = (token2, options) => ({
    [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseOutlinedStyle(token2, options)), {
      [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
        color: options.affixColor
      }
    }),
    [`&${token2.componentCls}-status-${options.status}${token2.componentCls}-disabled`]: {
      borderColor: options.borderColor
    }
  });
  const genOutlinedStyle = (token2, extraStyles) => ({
    "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(token2, {
      borderColor: token2.colorBorder,
      hoverBorderColor: token2.hoverBorderColor,
      activeBorderColor: token2.activeBorderColor,
      activeShadow: token2.activeShadow
    })), {
      [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle(token2))
    }), genOutlinedStatusStyle(token2, {
      status: "error",
      borderColor: token2.colorError,
      hoverBorderColor: token2.colorErrorBorderHover,
      activeBorderColor: token2.colorError,
      activeShadow: token2.errorActiveShadow,
      affixColor: token2.colorError
    })), genOutlinedStatusStyle(token2, {
      status: "warning",
      borderColor: token2.colorWarning,
      hoverBorderColor: token2.colorWarningBorderHover,
      activeBorderColor: token2.colorWarning,
      activeShadow: token2.warningActiveShadow,
      affixColor: token2.colorWarning
    })), extraStyles)
  });
  variants.genOutlinedStyle = genOutlinedStyle;
  const genOutlinedGroupStatusStyle = (token2, options) => ({
    [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
      [`${token2.componentCls}-group-addon`]: {
        borderColor: options.addonBorderColor,
        color: options.addonColor
      }
    }
  });
  const genOutlinedGroupStyle = (token2) => ({
    "&-outlined": Object.assign(Object.assign(Object.assign({
      [`${token2.componentCls}-group`]: {
        "&-addon": {
          background: token2.addonBg,
          border: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        },
        "&-addon:first-child": {
          borderInlineEnd: 0
        },
        "&-addon:last-child": {
          borderInlineStart: 0
        }
      }
    }, genOutlinedGroupStatusStyle(token2, {
      status: "error",
      addonBorderColor: token2.colorError,
      addonColor: token2.colorErrorText
    })), genOutlinedGroupStatusStyle(token2, {
      status: "warning",
      addonBorderColor: token2.colorWarning,
      addonColor: token2.colorWarningText
    })), {
      [`&${token2.componentCls}-group-wrapper-disabled`]: {
        [`${token2.componentCls}-group-addon`]: Object.assign({}, genDisabledStyle(token2))
      }
    })
  });
  variants.genOutlinedGroupStyle = genOutlinedGroupStyle;
  const genBorderlessStyle = (token2, extraStyles) => {
    const {
      componentCls
    } = token2;
    return {
      "&-borderless": Object.assign({
        background: "transparent",
        border: "none",
        "&:focus, &:focus-within": {
          outline: "none"
        },
        // >>>>> Disabled
        [`&${componentCls}-disabled, &[disabled]`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed"
        },
        // >>>>> Status
        [`&${componentCls}-status-error`]: {
          "&, & input, & textarea": {
            color: token2.colorError
          }
        },
        [`&${componentCls}-status-warning`]: {
          "&, & input, & textarea": {
            color: token2.colorWarning
          }
        }
      }, extraStyles)
    };
  };
  variants.genBorderlessStyle = genBorderlessStyle;
  const genBaseFilledStyle = (token2, options) => ({
    background: options.bg,
    borderWidth: token2.lineWidth,
    borderStyle: token2.lineType,
    borderColor: "transparent",
    "input&, & input, textarea&, & textarea": {
      color: options === null || options === void 0 ? void 0 : options.inputColor
    },
    "&:hover": {
      background: options.hoverBg
    },
    "&:focus, &:focus-within": {
      outline: 0,
      borderColor: options.activeBorderColor,
      backgroundColor: token2.activeBg
    }
  });
  const genFilledStatusStyle = (token2, options) => ({
    [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseFilledStyle(token2, options)), {
      [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
        color: options.affixColor
      }
    })
  });
  const genFilledStyle = (token2, extraStyles) => ({
    "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(token2, {
      bg: token2.colorFillTertiary,
      hoverBg: token2.colorFillSecondary,
      activeBorderColor: token2.activeBorderColor
    })), {
      [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle(token2))
    }), genFilledStatusStyle(token2, {
      status: "error",
      bg: token2.colorErrorBg,
      hoverBg: token2.colorErrorBgHover,
      activeBorderColor: token2.colorError,
      inputColor: token2.colorErrorText,
      affixColor: token2.colorError
    })), genFilledStatusStyle(token2, {
      status: "warning",
      bg: token2.colorWarningBg,
      hoverBg: token2.colorWarningBgHover,
      activeBorderColor: token2.colorWarning,
      inputColor: token2.colorWarningText,
      affixColor: token2.colorWarning
    })), extraStyles)
  });
  variants.genFilledStyle = genFilledStyle;
  const genFilledGroupStatusStyle = (token2, options) => ({
    [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
      [`${token2.componentCls}-group-addon`]: {
        background: options.addonBg,
        color: options.addonColor
      }
    }
  });
  const genFilledGroupStyle = (token2) => ({
    "&-filled": Object.assign(Object.assign(Object.assign({
      [`${token2.componentCls}-group`]: {
        "&-addon": {
          background: token2.colorFillTertiary
        },
        [`${token2.componentCls}-filled:not(:focus):not(:focus-within)`]: {
          "&:not(:first-child)": {
            borderInlineStart: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
          },
          "&:not(:last-child)": {
            borderInlineEnd: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
          }
        }
      }
    }, genFilledGroupStatusStyle(token2, {
      status: "error",
      addonBg: token2.colorErrorBg,
      addonColor: token2.colorErrorText
    })), genFilledGroupStatusStyle(token2, {
      status: "warning",
      addonBg: token2.colorWarningBg,
      addonColor: token2.colorWarningText
    })), {
      [`&${token2.componentCls}-group-wrapper-disabled`]: {
        [`${token2.componentCls}-group`]: {
          "&-addon": {
            background: token2.colorFillTertiary,
            color: token2.colorTextDisabled
          },
          "&-addon:first-child": {
            borderInlineStart: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
            borderTop: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
            borderBottom: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
          },
          "&-addon:last-child": {
            borderInlineEnd: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
            borderTop: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
            borderBottom: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
          }
        }
      }
    })
  });
  variants.genFilledGroupStyle = genFilledGroupStyle;
  const genBaseUnderlinedStyle = (token2, options) => ({
    background: token2.colorBgContainer,
    borderWidth: `${(0, _cssinjs.unit)(token2.lineWidth)} 0`,
    borderStyle: `${token2.lineType} none`,
    borderColor: `transparent transparent ${options.borderColor} transparent`,
    borderRadius: 0,
    "&:hover": {
      borderColor: `transparent transparent ${options.borderColor} transparent`,
      backgroundColor: token2.hoverBg
    },
    "&:focus, &:focus-within": {
      borderColor: `transparent transparent ${options.borderColor} transparent`,
      outline: 0,
      backgroundColor: token2.activeBg
    }
  });
  variants.genBaseUnderlinedStyle = genBaseUnderlinedStyle;
  const genUnderlinedStatusStyle = (token2, options) => ({
    [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseUnderlinedStyle(token2, options)), {
      [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
        color: options.affixColor
      }
    }),
    [`&${token2.componentCls}-status-${options.status}${token2.componentCls}-disabled`]: {
      borderColor: options.borderColor
    }
  });
  const genUnderlinedStyle = (token2, extraStyles) => ({
    "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseUnderlinedStyle(token2, {
      borderColor: token2.colorBorder,
      hoverBorderColor: token2.hoverBorderColor,
      activeBorderColor: token2.activeBorderColor,
      activeShadow: token2.activeShadow
    })), {
      // >>>>> Disabled
      [`&${token2.componentCls}-disabled, &[disabled]`]: {
        color: token2.colorTextDisabled,
        boxShadow: "none",
        cursor: "not-allowed",
        "&:hover": {
          borderColor: token2.colorBorder
        }
      },
      "input[disabled], textarea[disabled]": {
        cursor: "not-allowed"
      }
    }), genUnderlinedStatusStyle(token2, {
      status: "error",
      borderColor: token2.colorError,
      hoverBorderColor: token2.colorErrorBorderHover,
      activeBorderColor: token2.colorError,
      activeShadow: token2.errorActiveShadow,
      affixColor: token2.colorError
    })), genUnderlinedStatusStyle(token2, {
      status: "warning",
      borderColor: token2.colorWarning,
      hoverBorderColor: token2.colorWarningBorderHover,
      activeBorderColor: token2.colorWarning,
      activeShadow: token2.warningActiveShadow,
      affixColor: token2.colorWarning
    })), extraStyles)
  });
  variants.genUnderlinedStyle = genUnderlinedStyle;
  return variants;
}
var hasRequiredStyle$4;
function requireStyle$4() {
  if (hasRequiredStyle$4) return style$5;
  hasRequiredStyle$4 = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.genPlaceholderStyle = exports$1.genInputStyle = exports$1.genInputSmallStyle = exports$1.genInputGroupStyle = exports$1.genBasicInputStyle = exports$1.genAffixStyle = exports$1.genActiveStyle = exports$1.default = void 0;
    Object.defineProperty(exports$1, "initComponentToken", {
      enumerable: true,
      get: function() {
        return _token.initComponentToken;
      }
    });
    Object.defineProperty(exports$1, "initInputToken", {
      enumerable: true,
      get: function() {
        return _token.initInputToken;
      }
    });
    exports$1.useSharedStyle = void 0;
    var _cssinjs = require$$2$2;
    var _style = /* @__PURE__ */ requireStyle$6();
    var _compactItem = /* @__PURE__ */ requireCompactItem();
    var _internal = /* @__PURE__ */ requireInternal();
    var _token = /* @__PURE__ */ requireToken$1();
    var _variants = /* @__PURE__ */ requireVariants();
    const genPlaceholderStyle = (color2) => ({
      // Firefox
      "&::-moz-placeholder": {
        opacity: 1
      },
      "&::placeholder": {
        color: color2,
        userSelect: "none"
        // https://github.com/ant-design/ant-design/pull/32639
      },
      "&:placeholder-shown": {
        textOverflow: "ellipsis"
      }
    });
    exports$1.genPlaceholderStyle = genPlaceholderStyle;
    const genActiveStyle = (token2) => ({
      borderColor: token2.activeBorderColor,
      boxShadow: token2.activeShadow,
      outline: 0,
      backgroundColor: token2.activeBg
    });
    exports$1.genActiveStyle = genActiveStyle;
    const genInputLargeStyle = (token2) => {
      const {
        paddingBlockLG,
        lineHeightLG,
        borderRadiusLG,
        paddingInlineLG
      } = token2;
      return {
        padding: `${(0, _cssinjs.unit)(paddingBlockLG)} ${(0, _cssinjs.unit)(paddingInlineLG)}`,
        fontSize: token2.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
      };
    };
    const genInputSmallStyle = (token2) => ({
      padding: `${(0, _cssinjs.unit)(token2.paddingBlockSM)} ${(0, _cssinjs.unit)(token2.paddingInlineSM)}`,
      fontSize: token2.inputFontSizeSM,
      borderRadius: token2.borderRadiusSM
    });
    exports$1.genInputSmallStyle = genInputSmallStyle;
    const genBasicInputStyle = (token2) => Object.assign(Object.assign({
      position: "relative",
      display: "inline-block",
      width: "100%",
      minWidth: 0,
      padding: `${(0, _cssinjs.unit)(token2.paddingBlock)} ${(0, _cssinjs.unit)(token2.paddingInline)}`,
      color: token2.colorText,
      fontSize: token2.inputFontSize,
      lineHeight: token2.lineHeight,
      borderRadius: token2.borderRadius,
      transition: `all ${token2.motionDurationMid}`
    }, genPlaceholderStyle(token2.colorTextPlaceholder)), {
      // Reset height for `textarea`s
      "textarea&": {
        maxWidth: "100%",
        // prevent textarea resize from coming out of its container
        height: "auto",
        minHeight: token2.controlHeight,
        lineHeight: token2.lineHeight,
        verticalAlign: "bottom",
        transition: `all ${token2.motionDurationSlow}, height 0s`,
        resize: "vertical"
      },
      // Size
      "&-lg": Object.assign({}, genInputLargeStyle(token2)),
      "&-sm": Object.assign({}, genInputSmallStyle(token2)),
      // RTL
      "&-rtl, &-textarea-rtl": {
        direction: "rtl"
      }
    });
    exports$1.genBasicInputStyle = genBasicInputStyle;
    const genInputGroupStyle = (token2) => {
      const {
        componentCls,
        antCls
      } = token2;
      return {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
          paddingInlineEnd: token2.paddingXS,
          "&:last-child": {
            paddingInlineEnd: 0
          }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, genInputLargeStyle(token2)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, genInputSmallStyle(token2)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
          height: token2.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
          height: token2.controlHeightSM
        },
        [`> ${componentCls}`]: {
          display: "table-cell",
          "&:not(:first-child):not(:last-child)": {
            borderRadius: 0
          }
        },
        [`${componentCls}-group`]: {
          "&-addon, &-wrap": {
            display: "table-cell",
            width: 1,
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            "&:not(:first-child):not(:last-child)": {
              borderRadius: 0
            }
          },
          "&-wrap > *": {
            display: "block !important"
          },
          "&-addon": {
            position: "relative",
            padding: `0 ${(0, _cssinjs.unit)(token2.paddingInline)}`,
            color: token2.colorText,
            fontWeight: "normal",
            fontSize: token2.inputFontSize,
            textAlign: "center",
            borderRadius: token2.borderRadius,
            transition: `all ${token2.motionDurationSlow}`,
            lineHeight: 1,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
              margin: `${(0, _cssinjs.unit)(token2.calc(token2.paddingBlock).add(1).mul(-1).equal())} ${(0, _cssinjs.unit)(token2.calc(token2.paddingInline).mul(-1).equal())}`,
              [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                [`${antCls}-select-selector`]: {
                  backgroundColor: "inherit",
                  border: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} transparent`,
                  boxShadow: "none"
                }
              }
            },
            // https://github.com/ant-design/ant-design/issues/31333
            [`${antCls}-cascader-picker`]: {
              margin: `-9px ${(0, _cssinjs.unit)(token2.calc(token2.paddingInline).mul(-1).equal())}`,
              backgroundColor: "transparent",
              [`${antCls}-cascader-input`]: {
                textAlign: "start",
                border: 0,
                boxShadow: "none"
              }
            }
          }
        },
        [componentCls]: {
          width: "100%",
          marginBottom: 0,
          textAlign: "inherit",
          "&:focus": {
            zIndex: 1,
            // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
            borderInlineEndWidth: 1
          },
          "&:hover": {
            zIndex: 1,
            borderInlineEndWidth: 1,
            [`${componentCls}-search-with-button &`]: {
              zIndex: 0
            }
          }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          // Reset Select's style in addon
          [`${antCls}-select ${antCls}-select-selector`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`> ${componentCls}-affix-wrapper`]: {
          [`&:not(:first-child) ${componentCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          },
          [`&:not(:last-child) ${componentCls}`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0,
          // Reset Select's style in addon
          [`${antCls}-select ${antCls}-select-selector`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        [`${componentCls}-affix-wrapper`]: {
          "&:not(:last-child)": {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            [`${componentCls}-search &`]: {
              borderStartStartRadius: token2.borderRadius,
              borderEndStartRadius: token2.borderRadius
            }
          },
          [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
          display: "block"
        }, (0, _style.clearFix)()), {
          [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
            "&:not(:first-child):not(:last-child)": {
              borderInlineEndWidth: token2.lineWidth,
              "&:hover, &:focus": {
                zIndex: 1
              }
            }
          },
          "& > *": {
            display: "inline-flex",
            float: "none",
            verticalAlign: "top",
            // https://github.com/ant-design/ant-design-pro/issues/139
            borderRadius: 0
          },
          [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
            display: "inline-flex"
          },
          "& > *:not(:last-child)": {
            marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
            borderInlineEndWidth: token2.lineWidth
          },
          // Undo float for .ant-input-group .ant-input
          [componentCls]: {
            float: "none"
          },
          // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
          [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
            borderInlineEndWidth: token2.lineWidth,
            borderRadius: 0,
            "&:hover, &:focus": {
              zIndex: 1
            }
          },
          [`& > ${antCls}-select-focused`]: {
            zIndex: 1
          },
          // update z-index for arrow icon
          [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
            zIndex: 1
            // https://github.com/ant-design/ant-design/issues/20371
          },
          [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
            borderStartStartRadius: token2.borderRadius,
            borderEndStartRadius: token2.borderRadius
          },
          [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
            borderInlineEndWidth: token2.lineWidth,
            borderStartEndRadius: token2.borderRadius,
            borderEndEndRadius: token2.borderRadius
          },
          // https://github.com/ant-design/ant-design/issues/12493
          [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
            verticalAlign: "top"
          },
          [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
            marginInlineStart: token2.calc(token2.lineWidth).mul(-1).equal(),
            [`${componentCls}-affix-wrapper`]: {
              borderRadius: 0
            }
          },
          [`${componentCls}-group-wrapper:not(:last-child)`]: {
            [`&${componentCls}-search > ${componentCls}-group`]: {
              [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                borderRadius: 0
              },
              [`& > ${componentCls}`]: {
                borderStartStartRadius: token2.borderRadius,
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                borderEndStartRadius: token2.borderRadius
              }
            }
          }
        })
      };
    };
    exports$1.genInputGroupStyle = genInputGroupStyle;
    const genInputStyle = (token2) => {
      const {
        componentCls,
        controlHeightSM,
        lineWidth,
        calc
      } = token2;
      const FIXED_CHROME_COLOR_HEIGHT = 16;
      const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
      return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, _style.resetComponent)(token2)), genBasicInputStyle(token2)), (0, _variants.genOutlinedStyle)(token2)), (0, _variants.genFilledStyle)(token2)), (0, _variants.genBorderlessStyle)(token2)), (0, _variants.genUnderlinedStyle)(token2)), {
          '&[type="color"]': {
            height: token2.controlHeight,
            [`&${componentCls}-lg`]: {
              height: token2.controlHeightLG
            },
            [`&${componentCls}-sm`]: {
              height: controlHeightSM,
              paddingTop: colorSmallPadding,
              paddingBottom: colorSmallPadding
            }
          },
          '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
            "-webkit-appearance": "none"
          }
        })
      };
    };
    exports$1.genInputStyle = genInputStyle;
    const genAllowClearStyle = (token2) => {
      const {
        componentCls
      } = token2;
      return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
          margin: 0,
          padding: 0,
          lineHeight: 0,
          color: token2.colorTextQuaternary,
          fontSize: token2.fontSizeIcon,
          verticalAlign: -1,
          // https://github.com/ant-design/ant-design/pull/18151
          // https://codesandbox.io/s/wizardly-sun-u10br
          cursor: "pointer",
          transition: `color ${token2.motionDurationSlow}`,
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          "&:hover": {
            color: token2.colorTextTertiary
          },
          "&:active": {
            color: token2.colorText
          },
          "&-hidden": {
            visibility: "hidden"
          },
          "&-has-suffix": {
            margin: `0 ${(0, _cssinjs.unit)(token2.inputAffixPadding)}`
          }
        }
      };
    };
    const genAffixStyle = (token2) => {
      const {
        componentCls,
        inputAffixPadding,
        colorTextDescription,
        motionDurationSlow,
        colorIcon,
        colorIconHover,
        iconCls
      } = token2;
      const affixCls = `${componentCls}-affix-wrapper`;
      const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
      return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token2)), {
          display: "inline-flex",
          [`&:not(${componentCls}-disabled):hover`]: {
            zIndex: 1,
            [`${componentCls}-search-with-button &`]: {
              zIndex: 0
            }
          },
          "&-focused, &:focus": {
            zIndex: 1
          },
          [`> input${componentCls}`]: {
            padding: 0
          },
          [`> input${componentCls}, > textarea${componentCls}`]: {
            fontSize: "inherit",
            border: "none",
            borderRadius: 0,
            outline: "none",
            background: "transparent",
            color: "inherit",
            "&::-ms-reveal": {
              display: "none"
            },
            "&:focus": {
              boxShadow: "none !important"
            }
          },
          "&::before": {
            display: "inline-block",
            width: 0,
            visibility: "hidden",
            content: '"\\a0"'
          },
          [componentCls]: {
            "&-prefix, &-suffix": {
              display: "flex",
              flex: "none",
              alignItems: "center",
              "> *:not(:last-child)": {
                marginInlineEnd: token2.paddingXS
              }
            },
            "&-show-count-suffix": {
              color: colorTextDescription
            },
            "&-show-count-has-suffix": {
              marginInlineEnd: token2.paddingXXS
            },
            "&-prefix": {
              marginInlineEnd: inputAffixPadding
            },
            "&-suffix": {
              marginInlineStart: inputAffixPadding
            }
          }
        }), genAllowClearStyle(token2)), {
          // password
          [`${iconCls}${componentCls}-password-icon`]: {
            color: colorIcon,
            cursor: "pointer",
            transition: `all ${motionDurationSlow}`,
            "&:hover": {
              color: colorIconHover
            }
          }
        }),
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
          borderRadius: 0
        },
        [affixClsDisabled]: {
          // password disabled
          [`${iconCls}${componentCls}-password-icon`]: {
            color: colorIcon,
            cursor: "not-allowed",
            "&:hover": {
              color: colorIcon
            }
          }
        }
      };
    };
    exports$1.genAffixStyle = genAffixStyle;
    const genGroupStyle = (token2) => {
      const {
        componentCls,
        borderRadiusLG,
        borderRadiusSM
      } = token2;
      return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, _style.resetComponent)(token2)), genInputGroupStyle(token2)), {
          "&-rtl": {
            direction: "rtl"
          },
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            width: "100%",
            textAlign: "start",
            verticalAlign: "top",
            "&-rtl": {
              direction: "rtl"
            },
            // Size
            "&-lg": {
              [`${componentCls}-group-addon`]: {
                borderRadius: borderRadiusLG,
                fontSize: token2.inputFontSizeLG
              }
            },
            "&-sm": {
              [`${componentCls}-group-addon`]: {
                borderRadius: borderRadiusSM
              }
            }
          }, (0, _variants.genOutlinedGroupStyle)(token2)), (0, _variants.genFilledGroupStyle)(token2)), {
            // '&-disabled': {
            //   [`${componentCls}-group-addon`]: {
            //     ...genDisabledStyle(token),
            //   },
            // },
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/42122
            [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
              [`${componentCls}, ${componentCls}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            },
            // Fix the issue of input use show-count param in space compact mode
            // https://github.com/ant-design/ant-design/issues/46872
            [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
              [`${componentCls}-affix-wrapper`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            // Fix the issue of input use `addonAfter` param in space compact mode
            // https://github.com/ant-design/ant-design/issues/52483
            [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
              [`${componentCls}-affix-wrapper`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        })
      };
    };
    const genSearchInputStyle = (token2) => {
      const {
        componentCls,
        antCls
      } = token2;
      const searchPrefixCls = `${componentCls}-search`;
      return {
        [searchPrefixCls]: {
          [componentCls]: {
            "&:hover, &:focus": {
              [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                borderInlineStartColor: token2.colorPrimaryHover
              }
            }
          },
          [`${componentCls}-affix-wrapper`]: {
            height: token2.controlHeight,
            borderRadius: 0
          },
          // fix slight height diff in Firefox:
          // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
          [`${componentCls}-lg`]: {
            lineHeight: token2.calc(token2.lineHeightLG).sub(2e-4).equal()
          },
          [`> ${componentCls}-group`]: {
            [`> ${componentCls}-group-addon:last-child`]: {
              insetInlineStart: -1,
              padding: 0,
              border: 0,
              [`${searchPrefixCls}-button`]: {
                // Fix https://github.com/ant-design/ant-design/issues/47150
                marginInlineEnd: -1,
                borderStartStartRadius: 0,
                borderEndStartRadius: 0,
                boxShadow: "none"
              },
              [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                color: token2.colorTextDescription,
                "&:hover": {
                  color: token2.colorPrimaryHover
                },
                "&:active": {
                  color: token2.colorPrimaryActive
                },
                [`&${antCls}-btn-loading::before`]: {
                  insetInlineStart: 0,
                  insetInlineEnd: 0,
                  insetBlockStart: 0,
                  insetBlockEnd: 0
                }
              }
            }
          },
          [`${searchPrefixCls}-button`]: {
            height: token2.controlHeight,
            "&:hover, &:focus": {
              zIndex: 1
            }
          },
          "&-large": {
            [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
              height: token2.controlHeightLG
            }
          },
          "&-small": {
            [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
              height: token2.controlHeightSM
            }
          },
          "&-rtl": {
            direction: "rtl"
          },
          // ===================== Compact Item Customized Styles =====================
          [`&${componentCls}-compact-item`]: {
            [`&:not(${componentCls}-compact-last-item)`]: {
              [`${componentCls}-group-addon`]: {
                [`${componentCls}-search-button`]: {
                  marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
                  borderRadius: 0
                }
              }
            },
            [`&:not(${componentCls}-compact-first-item)`]: {
              [`${componentCls},${componentCls}-affix-wrapper`]: {
                borderRadius: 0
              }
            },
            [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
              "&:hover, &:focus, &:active": {
                zIndex: 2
              }
            },
            [`> ${componentCls}-affix-wrapper-focused`]: {
              zIndex: 2
            }
          }
        }
      };
    };
    const genRangeStyle = (token2) => {
      const {
        componentCls
      } = token2;
      return {
        [`${componentCls}-out-of-range`]: {
          [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
            color: token2.colorError
          }
        }
      };
    };
    exports$1.useSharedStyle = (0, _internal.genStyleHooks)(["Input", "Shared"], (token2) => {
      const inputToken = (0, _internal.mergeToken)(token2, (0, _token.initInputToken)(token2));
      return [genInputStyle(inputToken), genAffixStyle(inputToken)];
    }, _token.initComponentToken, {
      resetFont: false
    });
    exports$1.default = (0, _internal.genStyleHooks)(["Input", "Component"], (token2) => {
      const inputToken = (0, _internal.mergeToken)(token2, (0, _token.initInputToken)(token2));
      return [
        genGroupStyle(inputToken),
        genSearchInputStyle(inputToken),
        genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, _compactItem.genCompactItemStyle)(inputToken)
      ];
    }, _token.initComponentToken, {
      resetFont: false
    });
  })(style$5);
  return style$5;
}
var hasRequiredGroup$1;
function requireGroup$1() {
  if (hasRequiredGroup$1) return Group;
  hasRequiredGroup$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(Group, "__esModule", {
    value: true
  });
  Group.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var React2 = _react;
  var _classnames = _interopRequireDefault(requireClassnames());
  var _warning = /* @__PURE__ */ requireWarning();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _context = /* @__PURE__ */ requireContext();
  var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle$4());
  const Group$1 = (props) => {
    const {
      getPrefixCls,
      direction
    } = (0, _react.useContext)(_configProvider.ConfigContext);
    const {
      prefixCls: customizePrefixCls,
      className
    } = props;
    const prefixCls = getPrefixCls("input-group", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input");
    const [wrapCSSVar, hashId, cssVarCls] = (0, _style.default)(inputPrefixCls);
    const cls = (0, _classnames.default)(prefixCls, cssVarCls, {
      [`${prefixCls}-lg`]: props.size === "large",
      [`${prefixCls}-sm`]: props.size === "small",
      [`${prefixCls}-compact`]: props.compact,
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, hashId, className);
    const formItemContext = (0, _react.useContext)(_context.FormItemInputContext);
    const groupFormItemContext = (0, _react.useMemo)(() => Object.assign(Object.assign({}, formItemContext), {
      isFormItemInput: false
    }), [formItemContext]);
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Input.Group");
      warning3.deprecated(false, "Input.Group", "Space.Compact");
    }
    return wrapCSSVar(/* @__PURE__ */ React2.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, /* @__PURE__ */ React2.createElement(_context.FormItemInputContext.Provider, {
      value: groupFormItemContext
    }, props.children)));
  };
  Group.default = Group$1;
  return Group;
}
var Input$2 = {};
function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}
function cloneEvent(event, target, value) {
  var currentTarget = target.cloneNode(true);
  var newEvent = Object.create(event, {
    target: {
      value: currentTarget
    },
    currentTarget: {
      value: currentTarget
    }
  });
  currentTarget.value = value;
  if (typeof target.selectionStart === "number" && typeof target.selectionEnd === "number") {
    currentTarget.selectionStart = target.selectionStart;
    currentTarget.selectionEnd = target.selectionEnd;
  }
  currentTarget.setSelectionRange = function() {
    target.setSelectionRange.apply(target, arguments);
  };
  return newEvent;
}
function resolveOnChange(target, e, onChange5, targetValue) {
  if (!onChange5) {
    return;
  }
  var event = e;
  if (e.type === "click") {
    event = cloneEvent(e, target, "");
    onChange5(event);
    return;
  }
  if (target.type !== "file" && targetValue !== void 0) {
    event = cloneEvent(e, target, targetValue);
    onChange5(event);
    return;
  }
  onChange5(event);
}
function triggerFocus(element, option) {
  if (!element) return;
  element.focus(option);
  var _ref = option || {}, cursor2 = _ref.cursor;
  if (cursor2) {
    var len = element.value.length;
    switch (cursor2) {
      case "start":
        element.setSelectionRange(0, 0);
        break;
      case "end":
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
    }
  }
}
var BaseInput = /* @__PURE__ */ React__default.forwardRef(function(props, ref2) {
  var _props, _props2, _props3;
  var inputEl = props.inputElement, children2 = props.children, prefixCls = props.prefixCls, prefix2 = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style2 = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus2 = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden2 = props.hidden, classes = props.classes, classNames$1 = props.classNames, dataAttrs = props.dataAttrs, styles2 = props.styles, components = props.components, onClear = props.onClear;
  var inputElement = children2 !== null && children2 !== void 0 ? children2 : inputEl;
  var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
  var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
  var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
  var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
  var containerRef = useRef(null);
  var onInputClick = function onInputClick2(e) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) {
      triggerFocus2 === null || triggerFocus2 === void 0 || triggerFocus2();
    }
  };
  var hasAffix = hasPrefixSuffix(props);
  var element = /* @__PURE__ */ cloneElement(inputElement, {
    value,
    className: classNames((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.variant)) || null
  });
  var groupRef = useRef(null);
  React__default.useImperativeHandle(ref2, function() {
    return {
      nativeElement: groupRef.current || containerRef.current
    };
  });
  if (hasAffix) {
    var clearIcon = null;
    if (allowClear) {
      var needClear = !disabled && !readOnly && value;
      var clearIconCls = "".concat(prefixCls, "-clear-icon");
      var iconNode = _typeof$1(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "✖";
      clearIcon = /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function onClick2(event) {
          handleReset === null || handleReset === void 0 || handleReset(event);
          onClear === null || onClear === void 0 || onClear();
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: classNames(clearIconCls, _defineProperty(_defineProperty({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
      }, iconNode);
    }
    var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
    var affixWrapperCls = classNames(affixWrapperPrefixCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.affixWrapper, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.variant);
    var suffixNode = (suffix || allowClear) && /* @__PURE__ */ React__default.createElement("span", {
      className: classNames("".concat(prefixCls, "-suffix"), classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.suffix),
      style: styles2 === null || styles2 === void 0 ? void 0 : styles2.suffix
    }, clearIcon, suffix);
    element = /* @__PURE__ */ React__default.createElement(AffixWrapperComponent, _extends$4({
      className: affixWrapperCls,
      style: styles2 === null || styles2 === void 0 ? void 0 : styles2.affixWrapper,
      onClick: onInputClick
    }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
      ref: containerRef
    }), prefix2 && /* @__PURE__ */ React__default.createElement("span", {
      className: classNames("".concat(prefixCls, "-prefix"), classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.prefix),
      style: styles2 === null || styles2 === void 0 ? void 0 : styles2.prefix
    }, prefix2), element, suffixNode);
  }
  if (hasAddon(props)) {
    var wrapperCls = "".concat(prefixCls, "-group");
    var addonCls = "".concat(wrapperCls, "-addon");
    var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
    var mergedWrapperClassName = classNames("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.wrapper);
    var mergedGroupClassName = classNames(groupWrapperCls, _defineProperty({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.groupWrapper);
    element = /* @__PURE__ */ React__default.createElement(GroupWrapperComponent, {
      className: mergedGroupClassName,
      ref: groupRef
    }, /* @__PURE__ */ React__default.createElement(WrapperComponent, {
      className: mergedWrapperClassName
    }, addonBefore && /* @__PURE__ */ React__default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonBefore), element, addonAfter && /* @__PURE__ */ React__default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonAfter)));
  }
  return /* @__PURE__ */ React__default.cloneElement(element, {
    className: classNames((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className) || null,
    style: _objectSpread2(_objectSpread2({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style2),
    hidden: hidden2
  });
});
function omit(obj, fields) {
  var clone = Object.assign({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function(key) {
      delete clone[key];
    });
  }
  return clone;
}
var _excluded$9 = ["show"];
function useCount(count, showCount) {
  return React.useMemo(function() {
    var mergedConfig = {};
    if (showCount) {
      mergedConfig.show = _typeof$1(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
    }
    mergedConfig = _objectSpread2(_objectSpread2({}, mergedConfig), count);
    var _ref = mergedConfig, show = _ref.show, rest = _objectWithoutProperties$1(_ref, _excluded$9);
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      show: !!show,
      showFormatter: typeof show === "function" ? show : void 0,
      strategy: rest.strategy || function(value) {
        return value.length;
      }
    });
  }, [count, showCount]);
}
var _excluded$8 = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"];
var Input$1 = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var autoComplete = props.autoComplete, onChange5 = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type4 = _props$type === void 0 ? "text" : _props$type, classes = props.classes, classNames$1 = props.classNames, styles2 = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = _objectWithoutProperties$1(props, _excluded$8);
  var _useState = useState$1(false), _useState2 = _slicedToArray$1(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
  var compositionRef = useRef(false);
  var keyLockRef = useRef(false);
  var inputRef = useRef(null);
  var holderRef = useRef(null);
  var focus = function focus2(option) {
    if (inputRef.current) {
      triggerFocus(inputRef.current, option);
    }
  };
  var _useMergedState = useMergedState$1(props.defaultValue, {
    value: props.value
  }), _useMergedState2 = _slicedToArray$1(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var formatValue = value === void 0 || value === null ? "" : String(value);
  var _useState3 = useState$1(null), _useState4 = _slicedToArray$1(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
  var countConfig = useCount(count, showCount);
  var mergedMax = countConfig.max || maxLength;
  var valueLength = countConfig.strategy(formatValue);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;
  useImperativeHandle(ref2, function() {
    var _holderRef$current;
    return {
      focus,
      blur: function blur() {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
      },
      setSelectionRange: function setSelectionRange(start2, end, direction) {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start2, end, direction);
      },
      select: function select() {
        var _inputRef$current3;
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
      },
      input: inputRef.current,
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
    };
  });
  useEffect(function() {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(function(prev4) {
      return prev4 && disabled ? false : prev4;
    });
  }, [disabled]);
  var triggerChange = function triggerChange2(e, currentValue, info) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        var _inputRef$current4, _inputRef$current5;
        setSelection([((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0, ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0]);
      }
    } else if (info.source === "compositionEnd") {
      return;
    }
    setValue(cutValue);
    if (inputRef.current) {
      resolveOnChange(inputRef.current, e, onChange5, cutValue);
    }
  };
  useEffect(function() {
    if (selection) {
      var _inputRef$current6;
      (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, _toConsumableArray$1(selection));
    }
  }, [selection]);
  var onInternalChange = function onInternalChange2(e) {
    triggerChange(e, e.target.value, {
      source: "change"
    });
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e) {
    compositionRef.current = false;
    triggerChange(e, e.currentTarget.value, {
      source: "compositionEnd"
    });
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    if (onPressEnter && e.key === "Enter" && !keyLockRef.current) {
      keyLockRef.current = true;
      onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleKeyUp = function handleKeyUp2(e) {
    if (e.key === "Enter") {
      keyLockRef.current = false;
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
  };
  var handleFocus = function handleFocus2(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleBlur = function handleBlur2(e) {
    if (keyLockRef.current) {
      keyLockRef.current = false;
    }
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  var handleReset = function handleReset2(e) {
    setValue("");
    focus();
    if (inputRef.current) {
      resolveOnChange(inputRef.current, e, onChange5);
    }
  };
  var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
  var getInputElement = function getInputElement2() {
    var otherProps = omit(props, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ React__default.createElement("input", _extends$4({
      autoComplete
    }, otherProps, {
      onChange: onInternalChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      className: classNames(prefixCls, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled), classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.input),
      style: styles2 === null || styles2 === void 0 ? void 0 : styles2.input,
      ref: inputRef,
      size: htmlSize,
      type: type4,
      onCompositionStart: function onCompositionStart(e) {
        compositionRef.current = true;
        _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
      },
      onCompositionEnd: onInternalCompositionEnd
    }));
  };
  var getSuffix = function getSuffix2() {
    var hasMaxLength = Number(mergedMax) > 0;
    if (suffix || countConfig.show) {
      var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
        value: formatValue,
        count: valueLength,
        maxLength: mergedMax
      }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, countConfig.show && /* @__PURE__ */ React__default.createElement("span", {
        className: classNames("".concat(prefixCls, "-show-count-suffix"), _defineProperty({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.count),
        style: _objectSpread2({}, styles2 === null || styles2 === void 0 ? void 0 : styles2.count)
      }, dataCount), suffix);
    }
    return null;
  };
  return /* @__PURE__ */ React__default.createElement(BaseInput, _extends$4({}, rest, {
    prefixCls,
    className: classNames(className, outOfRangeCls),
    handleReset,
    value: formatValue,
    focused,
    triggerFocus: focus,
    suffix: getSuffix(),
    disabled,
    classes,
    classNames: classNames$1,
    styles: styles2
  }), getInputElement());
});
const es$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInput,
  default: Input$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$4$1 = /* @__PURE__ */ getAugmentedNamespace(es$3);
var commonUtils = {};
var hasRequiredCommonUtils;
function requireCommonUtils() {
  if (hasRequiredCommonUtils) return commonUtils;
  hasRequiredCommonUtils = 1;
  Object.defineProperty(commonUtils, "__esModule", {
    value: true
  });
  commonUtils.hasAddon = hasAddon2;
  commonUtils.hasPrefixSuffix = hasPrefixSuffix2;
  commonUtils.resolveOnChange = resolveOnChange2;
  commonUtils.triggerFocus = triggerFocus2;
  function hasAddon2(props) {
    return !!(props.addonBefore || props.addonAfter);
  }
  function hasPrefixSuffix2(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
  }
  function cloneEvent2(event, target, value) {
    var currentTarget = target.cloneNode(true);
    var newEvent = Object.create(event, {
      target: {
        value: currentTarget
      },
      currentTarget: {
        value: currentTarget
      }
    });
    currentTarget.value = value;
    if (typeof target.selectionStart === "number" && typeof target.selectionEnd === "number") {
      currentTarget.selectionStart = target.selectionStart;
      currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
      target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
  }
  function resolveOnChange2(target, e, onChange5, targetValue) {
    if (!onChange5) {
      return;
    }
    var event = e;
    if (e.type === "click") {
      event = cloneEvent2(e, target, "");
      onChange5(event);
      return;
    }
    if (target.type !== "file" && targetValue !== void 0) {
      event = cloneEvent2(e, target, targetValue);
      onChange5(event);
      return;
    }
    onChange5(event);
  }
  function triggerFocus2(element, option) {
    if (!element) return;
    element.focus(option);
    var _ref = option || {}, cursor2 = _ref.cursor;
    if (cursor2) {
      var len = element.value.length;
      switch (cursor2) {
        case "start":
          element.setSelectionRange(0, 0);
          break;
        case "end":
          element.setSelectionRange(len, len);
          break;
        default:
          element.setSelectionRange(0, len);
      }
    }
  }
  return commonUtils;
}
var ref = {};
var isFragment = {};
var hasRequiredIsFragment;
function requireIsFragment() {
  if (hasRequiredIsFragment) return isFragment;
  hasRequiredIsFragment = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(isFragment, "__esModule", {
    value: true
  });
  isFragment.default = isFragment$12;
  var _typeof2 = _interopRequireDefault(require_typeof());
  var REACT_ELEMENT_TYPE_182 = Symbol.for("react.element");
  var REACT_ELEMENT_TYPE_192 = Symbol.for("react.transitional.element");
  var REACT_FRAGMENT_TYPE2 = Symbol.for("react.fragment");
  function isFragment$12(object4) {
    return (
      // Base object type
      object4 && (0, _typeof2.default)(object4) === "object" && // React Element type
      (object4.$$typeof === REACT_ELEMENT_TYPE_182 || object4.$$typeof === REACT_ELEMENT_TYPE_192) && // React Fragment type
      object4.type === REACT_FRAGMENT_TYPE2
    );
  }
  return isFragment;
}
var hasRequiredRef;
function requireRef() {
  if (hasRequiredRef) return ref;
  hasRequiredRef = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(ref, "__esModule", {
    value: true
  });
  ref.useComposeRef = ref.supportRef = ref.supportNodeRef = ref.getNodeRef = ref.fillRef = ref.composeRef = void 0;
  var _typeof2 = _interopRequireDefault(require_typeof());
  var _react = React__default;
  var _reactIs = requireReactIs();
  var _useMemo = _interopRequireDefault(requireUseMemo());
  var _isFragment = _interopRequireDefault(requireIsFragment());
  var ReactMajorVersion2 = Number(_react.version.split(".")[0]);
  var fillRef3 = ref.fillRef = function fillRef4(ref2, node2) {
    if (typeof ref2 === "function") {
      ref2(node2);
    } else if ((0, _typeof2.default)(ref2) === "object" && ref2 && "current" in ref2) {
      ref2.current = node2;
    }
  };
  var composeRef3 = ref.composeRef = function composeRef4() {
    for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
      refs[_key] = arguments[_key];
    }
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) {
      return refList[0];
    }
    return function(node2) {
      refs.forEach(function(ref2) {
        fillRef3(ref2, node2);
      });
    };
  };
  ref.useComposeRef = function useComposeRef3() {
    for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      refs[_key2] = arguments[_key2];
    }
    return (0, _useMemo.default)(function() {
      return composeRef3.apply(void 0, refs);
    }, refs, function(prev4, next4) {
      return prev4.length !== next4.length || prev4.every(function(ref2, i) {
        return ref2 !== next4[i];
      });
    });
  };
  var supportRef3 = ref.supportRef = function supportRef4(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) {
      return false;
    }
    if (isReactElement2(nodeOrComponent) && ReactMajorVersion2 >= 19) {
      return true;
    }
    var type4 = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    if (typeof type4 === "function" && !((_type$prototype = type4.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type4.$$typeof !== _reactIs.ForwardRef) {
      return false;
    }
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== _reactIs.ForwardRef) {
      return false;
    }
    return true;
  };
  function isReactElement2(node2) {
    return /* @__PURE__ */ (0, _react.isValidElement)(node2) && !(0, _isFragment.default)(node2);
  }
  ref.supportNodeRef = function supportNodeRef(node2) {
    return isReactElement2(node2) && supportRef3(node2);
  };
  ref.getNodeRef = function getNodeRef3(node2) {
    if (node2 && isReactElement2(node2)) {
      var ele = node2;
      return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
    }
    return null;
  };
  return ref;
}
var ContextIsolator = {};
var Compact = {};
var toArray = {};
var hasRequiredToArray;
function requireToArray() {
  if (hasRequiredToArray) return toArray;
  hasRequiredToArray = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(toArray, "__esModule", {
    value: true
  });
  toArray.default = toArray$12;
  var _isFragment = _interopRequireDefault(requireIsFragment());
  var _react = _interopRequireDefault(React__default);
  function toArray$12(children2) {
    var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ret = [];
    _react.default.Children.forEach(children2, function(child) {
      if ((child === void 0 || child === null) && !option.keepEmpty) {
        return;
      }
      if (Array.isArray(child)) {
        ret = ret.concat(toArray$12(child));
      } else if ((0, _isFragment.default)(child) && child.props) {
        ret = ret.concat(toArray$12(child.props.children, option));
      } else {
        ret.push(child);
      }
    });
    return ret;
  }
  return toArray;
}
var useSize = {};
var hasRequiredUseSize;
function requireUseSize() {
  if (hasRequiredUseSize) return useSize;
  hasRequiredUseSize = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useSize, "__esModule", {
    value: true
  });
  useSize.default = void 0;
  var _react = _interopRequireDefault(React__default);
  var _SizeContext = _interopRequireDefault(/* @__PURE__ */ requireSizeContext());
  const useSize$1 = (customSize) => {
    const size2 = _react.default.useContext(_SizeContext.default);
    const mergedSize = _react.default.useMemo(() => {
      if (!customSize) {
        return size2;
      }
      if (typeof customSize === "string") {
        return customSize !== null && customSize !== void 0 ? customSize : size2;
      }
      if (customSize instanceof Function) {
        return customSize(size2);
      }
      return size2;
    }, [customSize, size2]);
    return mergedSize;
  };
  useSize.default = useSize$1;
  return useSize;
}
var style$4 = {};
var compact$1 = {};
var hasRequiredCompact$2;
function requireCompact$2() {
  if (hasRequiredCompact$2) return compact$1;
  hasRequiredCompact$2 = 1;
  Object.defineProperty(compact$1, "__esModule", {
    value: true
  });
  compact$1.default = void 0;
  const genSpaceCompactStyle = (token2) => {
    const {
      componentCls
    } = token2;
    return {
      [componentCls]: {
        "&-block": {
          display: "flex",
          width: "100%"
        },
        "&-vertical": {
          flexDirection: "column"
        }
      }
    };
  };
  compact$1.default = genSpaceCompactStyle;
  return compact$1;
}
var hasRequiredStyle$3;
function requireStyle$3() {
  if (hasRequiredStyle$3) return style$4;
  hasRequiredStyle$3 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(style$4, "__esModule", {
    value: true
  });
  style$4.prepareComponentToken = style$4.default = void 0;
  var _internal = /* @__PURE__ */ requireInternal();
  var _compact = _interopRequireDefault(/* @__PURE__ */ requireCompact$2());
  const genSpaceStyle = (token2) => {
    const {
      componentCls,
      antCls
    } = token2;
    return {
      [componentCls]: {
        display: "inline-flex",
        "&-rtl": {
          direction: "rtl"
        },
        "&-vertical": {
          flexDirection: "column"
        },
        "&-align": {
          flexDirection: "column",
          "&-center": {
            alignItems: "center"
          },
          "&-start": {
            alignItems: "flex-start"
          },
          "&-end": {
            alignItems: "flex-end"
          },
          "&-baseline": {
            alignItems: "baseline"
          }
        },
        [`${componentCls}-item:empty`]: {
          display: "none"
        },
        // https://github.com/ant-design/ant-design/issues/47875
        [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
          display: "block"
        }
      }
    };
  };
  const genSpaceGapStyle = (token2) => {
    const {
      componentCls
    } = token2;
    return {
      [componentCls]: {
        "&-gap-row-small": {
          rowGap: token2.spaceGapSmallSize
        },
        "&-gap-row-middle": {
          rowGap: token2.spaceGapMiddleSize
        },
        "&-gap-row-large": {
          rowGap: token2.spaceGapLargeSize
        },
        "&-gap-col-small": {
          columnGap: token2.spaceGapSmallSize
        },
        "&-gap-col-middle": {
          columnGap: token2.spaceGapMiddleSize
        },
        "&-gap-col-large": {
          columnGap: token2.spaceGapLargeSize
        }
      }
    };
  };
  const prepareComponentToken = () => ({});
  style$4.prepareComponentToken = prepareComponentToken;
  style$4.default = (0, _internal.genStyleHooks)("Space", (token2) => {
    const spaceToken = (0, _internal.mergeToken)(token2, {
      spaceGapSmallSize: token2.paddingXS,
      spaceGapMiddleSize: token2.padding,
      spaceGapLargeSize: token2.paddingLG
    });
    return [genSpaceStyle(spaceToken), genSpaceGapStyle(spaceToken), (0, _compact.default)(spaceToken)];
  }, () => ({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
  });
  return style$4;
}
var hasRequiredCompact$1;
function requireCompact$1() {
  if (hasRequiredCompact$1) return Compact;
  hasRequiredCompact$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(Compact, "__esModule", {
    value: true
  });
  Compact.useCompactItemContext = Compact.default = Compact.SpaceCompactItemContext = Compact.NoCompactStyle = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _toArray2 = _interopRequireDefault(requireToArray());
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle$3());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const SpaceCompactItemContext = Compact.SpaceCompactItemContext = /* @__PURE__ */ React2.createContext(null);
  const useCompactItemContext = (prefixCls, direction) => {
    const compactItemContext = React2.useContext(SpaceCompactItemContext);
    const compactItemClassnames = React2.useMemo(() => {
      if (!compactItemContext) {
        return "";
      }
      const {
        compactDirection,
        isFirstItem,
        isLastItem
      } = compactItemContext;
      const separator = compactDirection === "vertical" ? "-vertical-" : "-";
      return (0, _classnames.default)(`${prefixCls}-compact${separator}item`, {
        [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
        [`${prefixCls}-compact${separator}last-item`]: isLastItem,
        [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
      });
    }, [prefixCls, direction, compactItemContext]);
    return {
      compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
      compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
      compactItemClassnames
    };
  };
  Compact.useCompactItemContext = useCompactItemContext;
  const NoCompactStyle = (props) => {
    const {
      children: children2
    } = props;
    return /* @__PURE__ */ React2.createElement(SpaceCompactItemContext.Provider, {
      value: null
    }, children2);
  };
  Compact.NoCompactStyle = NoCompactStyle;
  const CompactItem = (props) => {
    const {
      children: children2
    } = props, others = __rest2(props, ["children"]);
    return /* @__PURE__ */ React2.createElement(SpaceCompactItemContext.Provider, {
      value: React2.useMemo(() => others, [others])
    }, children2);
  };
  const Compact$1 = (props) => {
    const {
      getPrefixCls,
      direction: directionConfig
    } = React2.useContext(_configProvider.ConfigContext);
    const {
      size: size2,
      direction,
      block: block2,
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      children: children2
    } = props, restProps = __rest2(props, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]);
    const mergedSize = (0, _useSize.default)((ctx) => size2 !== null && size2 !== void 0 ? size2 : ctx);
    const prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, _style.default)(prefixCls);
    const clx = (0, _classnames.default)(prefixCls, hashId, {
      [`${prefixCls}-rtl`]: directionConfig === "rtl",
      [`${prefixCls}-block`]: block2,
      [`${prefixCls}-vertical`]: direction === "vertical"
    }, className, rootClassName);
    const compactItemContext = React2.useContext(SpaceCompactItemContext);
    const childNodes = (0, _toArray2.default)(children2);
    const nodes = React2.useMemo(() => childNodes.map((child, i) => {
      const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
      return /* @__PURE__ */ React2.createElement(CompactItem, {
        key,
        compactSize: mergedSize,
        compactDirection: direction,
        isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
        isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
      }, child);
    }), [size2, childNodes, compactItemContext]);
    if (childNodes.length === 0) {
      return null;
    }
    return wrapCSSVar(/* @__PURE__ */ React2.createElement("div", Object.assign({
      className: clx
    }, restProps), nodes));
  };
  Compact.default = Compact$1;
  return Compact;
}
var hasRequiredContextIsolator;
function requireContextIsolator() {
  if (hasRequiredContextIsolator) return ContextIsolator;
  hasRequiredContextIsolator = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(ContextIsolator, "__esModule", {
    value: true
  });
  ContextIsolator.default = void 0;
  var _react = _interopRequireDefault(React__default);
  var _context = /* @__PURE__ */ requireContext();
  var _Compact = /* @__PURE__ */ requireCompact$1();
  const ContextIsolator$1 = (props) => {
    const {
      space,
      form,
      children: children2
    } = props;
    if (children2 === void 0 || children2 === null) {
      return null;
    }
    let result = children2;
    if (form) {
      result = /* @__PURE__ */ _react.default.createElement(_context.NoFormStyle, {
        override: true,
        status: true
      }, result);
    }
    if (space) {
      result = /* @__PURE__ */ _react.default.createElement(_Compact.NoCompactStyle, null, result);
    }
    return result;
  };
  ContextIsolator.default = ContextIsolator$1;
  return ContextIsolator;
}
var getAllowClear = {};
var CloseCircleFilled$2 = { exports: {} };
var CloseCircleFilled$1 = {};
var _extends$3 = { exports: {} };
var hasRequired_extends;
function require_extends() {
  if (hasRequired_extends) return _extends$3.exports;
  hasRequired_extends = 1;
  (function(module2) {
    function _extends2() {
      return module2.exports = _extends2 = Object.assign ? Object.assign.bind() : function(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
        }
        return n;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _extends2.apply(null, arguments);
    }
    module2.exports = _extends2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(_extends$3);
  return _extends$3.exports;
}
var CloseCircleFilled = {};
var hasRequiredCloseCircleFilled$2;
function requireCloseCircleFilled$2() {
  if (hasRequiredCloseCircleFilled$2) return CloseCircleFilled;
  hasRequiredCloseCircleFilled$2 = 1;
  Object.defineProperty(CloseCircleFilled, "__esModule", { value: true });
  var CloseCircleFilled$12 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, "name": "close-circle", "theme": "filled" };
  CloseCircleFilled.default = CloseCircleFilled$12;
  return CloseCircleFilled;
}
var AntdIcon = {};
var slicedToArray = { exports: {} };
var iterableToArrayLimit = { exports: {} };
var hasRequiredIterableToArrayLimit;
function requireIterableToArrayLimit() {
  if (hasRequiredIterableToArrayLimit) return iterableToArrayLimit.exports;
  hasRequiredIterableToArrayLimit = 1;
  (function(module2) {
    function _iterableToArrayLimit2(r2, l) {
      var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
      if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
          if (i = (t = t.call(r2)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r3) {
          o = true, n = r3;
        } finally {
          try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    module2.exports = _iterableToArrayLimit2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(iterableToArrayLimit);
  return iterableToArrayLimit.exports;
}
var hasRequiredSlicedToArray;
function requireSlicedToArray() {
  if (hasRequiredSlicedToArray) return slicedToArray.exports;
  hasRequiredSlicedToArray = 1;
  (function(module2) {
    var arrayWithHoles2 = requireArrayWithHoles();
    var iterableToArrayLimit2 = requireIterableToArrayLimit();
    var unsupportedIterableToArray2 = requireUnsupportedIterableToArray();
    var nonIterableRest2 = requireNonIterableRest();
    function _slicedToArray2(r2, e) {
      return arrayWithHoles2(r2) || iterableToArrayLimit2(r2, e) || unsupportedIterableToArray2(r2, e) || nonIterableRest2();
    }
    module2.exports = _slicedToArray2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(slicedToArray);
  return slicedToArray.exports;
}
var objectWithoutProperties = { exports: {} };
var objectWithoutPropertiesLoose = { exports: {} };
var hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
  hasRequiredObjectWithoutPropertiesLoose = 1;
  (function(module2) {
    function _objectWithoutPropertiesLoose2(r2, e) {
      if (null == r2) return {};
      var t = {};
      for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r2[n];
      }
      return t;
    }
    module2.exports = _objectWithoutPropertiesLoose2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(objectWithoutPropertiesLoose);
  return objectWithoutPropertiesLoose.exports;
}
var hasRequiredObjectWithoutProperties;
function requireObjectWithoutProperties() {
  if (hasRequiredObjectWithoutProperties) return objectWithoutProperties.exports;
  hasRequiredObjectWithoutProperties = 1;
  (function(module2) {
    var objectWithoutPropertiesLoose2 = requireObjectWithoutPropertiesLoose();
    function _objectWithoutProperties2(e, t) {
      if (null == e) return {};
      var o, r2, i = objectWithoutPropertiesLoose2(e, t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for (r2 = 0; r2 < n.length; r2++) o = n[r2], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
      }
      return i;
    }
    module2.exports = _objectWithoutProperties2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(objectWithoutProperties);
  return objectWithoutProperties.exports;
}
var IconBase = {};
var utils$1 = {};
var shadow = {};
var hasRequiredShadow;
function requireShadow() {
  if (hasRequiredShadow) return shadow;
  hasRequiredShadow = 1;
  Object.defineProperty(shadow, "__esModule", {
    value: true
  });
  shadow.getShadowRoot = getShadowRoot;
  shadow.inShadow = inShadow;
  function getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
  }
  function inShadow(ele) {
    return getRoot(ele) instanceof ShadowRoot;
  }
  function getShadowRoot(ele) {
    return inShadow(ele) ? getRoot(ele) : null;
  }
  return shadow;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$1;
  hasRequiredUtils$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(utils$1, "__esModule", {
    value: true
  });
  utils$1.generate = generate2;
  utils$1.getSecondaryColor = getSecondaryColor;
  utils$1.iconStyles = void 0;
  utils$1.isIconDefinition = isIconDefinition;
  utils$1.normalizeAttrs = normalizeAttrs;
  utils$1.normalizeTwoToneColors = normalizeTwoToneColors;
  utils$1.useInsertStyles = utils$1.svgBaseProps = void 0;
  utils$1.warning = warning3;
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var _typeof2 = _interopRequireDefault(require_typeof());
  var _colors = require$$8;
  var _dynamicCSS = requireDynamicCSS();
  var _shadow = requireShadow();
  var _warning = _interopRequireDefault(requireWarning$1());
  var _react = _interopRequireWildcard(React__default);
  var _Context = _interopRequireDefault(/* @__PURE__ */ requireContext$4());
  function camelCase(input2) {
    return input2.replace(/-(.)/g, function(match2, g) {
      return g.toUpperCase();
    });
  }
  function warning3(valid, message2) {
    (0, _warning.default)(valid, "[@ant-design/icons] ".concat(message2));
  }
  function isIconDefinition(target) {
    return (0, _typeof2.default)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, _typeof2.default)(target.icon) === "object" || typeof target.icon === "function");
  }
  function normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
      var val = attrs[key];
      switch (key) {
        case "class":
          acc.className = val;
          delete acc.class;
          break;
        default:
          delete acc[key];
          acc[camelCase(key)] = val;
      }
      return acc;
    }, {});
  }
  function generate2(node2, key, rootProps) {
    if (!rootProps) {
      return /* @__PURE__ */ _react.default.createElement(node2.tag, (0, _objectSpread22.default)({
        key
      }, normalizeAttrs(node2.attrs)), (node2.children || []).map(function(child, index2) {
        return generate2(child, "".concat(key, "-").concat(node2.tag, "-").concat(index2));
      }));
    }
    return /* @__PURE__ */ _react.default.createElement(node2.tag, (0, _objectSpread22.default)((0, _objectSpread22.default)({
      key
    }, normalizeAttrs(node2.attrs)), rootProps), (node2.children || []).map(function(child, index2) {
      return generate2(child, "".concat(key, "-").concat(node2.tag, "-").concat(index2));
    }));
  }
  function getSecondaryColor(primaryColor) {
    return (0, _colors.generate)(primaryColor)[0];
  }
  function normalizeTwoToneColors(twoToneColor) {
    if (!twoToneColor) {
      return [];
    }
    return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
  }
  utils$1.svgBaseProps = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  };
  var iconStyles = utils$1.iconStyles = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
  utils$1.useInsertStyles = function useInsertStyles(eleRef) {
    var _useContext = (0, _react.useContext)(_Context.default), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = iconStyles;
    if (prefixCls) {
      mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    }
    if (layer) {
      mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    }
    (0, _react.useEffect)(function() {
      var ele = eleRef.current;
      var shadowRoot = (0, _shadow.getShadowRoot)(ele);
      (0, _dynamicCSS.updateCSS)(mergedStyleStr, "@ant-design-icons", {
        prepend: !layer,
        csp,
        attachTo: shadowRoot
      });
    }, []);
  };
  return utils$1;
}
var hasRequiredIconBase;
function requireIconBase() {
  if (hasRequiredIconBase) return IconBase;
  hasRequiredIconBase = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(IconBase, "__esModule", {
    value: true
  });
  IconBase.default = void 0;
  var _objectWithoutProperties2 = _interopRequireDefault(requireObjectWithoutProperties());
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var React2 = _interopRequireWildcard(React__default);
  var _utils = /* @__PURE__ */ requireUtils$1();
  var _excluded5 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
  var twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
  };
  function setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    twoToneColorPalette.primaryColor = primaryColor;
    twoToneColorPalette.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
    twoToneColorPalette.calculated = !!secondaryColor;
  }
  function getTwoToneColors() {
    return (0, _objectSpread22.default)({}, twoToneColorPalette);
  }
  var IconBase$12 = function IconBase2(props) {
    var icon2 = props.icon, className = props.className, onClick2 = props.onClick, style2 = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, _objectWithoutProperties2.default)(props, _excluded5);
    var svgRef = React2.useRef();
    var colors2 = twoToneColorPalette;
    if (primaryColor) {
      colors2 = {
        primaryColor,
        secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
      };
    }
    (0, _utils.useInsertStyles)(svgRef);
    (0, _utils.warning)((0, _utils.isIconDefinition)(icon2), "icon should be icon definiton, but got ".concat(icon2));
    if (!(0, _utils.isIconDefinition)(icon2)) {
      return null;
    }
    var target = icon2;
    if (target && typeof target.icon === "function") {
      target = (0, _objectSpread22.default)((0, _objectSpread22.default)({}, target), {}, {
        icon: target.icon(colors2.primaryColor, colors2.secondaryColor)
      });
    }
    return (0, _utils.generate)(target.icon, "svg-".concat(target.name), (0, _objectSpread22.default)((0, _objectSpread22.default)({
      className,
      onClick: onClick2,
      style: style2,
      "data-icon": target.name,
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, restProps), {}, {
      ref: svgRef
    }));
  };
  IconBase$12.displayName = "IconReact";
  IconBase$12.getTwoToneColors = getTwoToneColors;
  IconBase$12.setTwoToneColors = setTwoToneColors;
  IconBase.default = IconBase$12;
  return IconBase;
}
var twoTonePrimaryColor = {};
var hasRequiredTwoTonePrimaryColor;
function requireTwoTonePrimaryColor() {
  if (hasRequiredTwoTonePrimaryColor) return twoTonePrimaryColor;
  hasRequiredTwoTonePrimaryColor = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(twoTonePrimaryColor, "__esModule", {
    value: true
  });
  twoTonePrimaryColor.getTwoToneColor = getTwoToneColor;
  twoTonePrimaryColor.setTwoToneColor = setTwoToneColor;
  var _slicedToArray2 = _interopRequireDefault(requireSlicedToArray());
  var _IconBase = _interopRequireDefault(/* @__PURE__ */ requireIconBase());
  var _utils = /* @__PURE__ */ requireUtils$1();
  function setTwoToneColor(twoToneColor) {
    var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, _slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return _IconBase.default.setTwoToneColors({
      primaryColor,
      secondaryColor
    });
  }
  function getTwoToneColor() {
    var colors2 = _IconBase.default.getTwoToneColors();
    if (!colors2.calculated) {
      return colors2.primaryColor;
    }
    return [colors2.primaryColor, colors2.secondaryColor];
  }
  return twoTonePrimaryColor;
}
var hasRequiredAntdIcon;
function requireAntdIcon() {
  if (hasRequiredAntdIcon) return AntdIcon;
  hasRequiredAntdIcon = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(AntdIcon, "__esModule", {
    value: true
  });
  AntdIcon.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var _slicedToArray2 = _interopRequireDefault(requireSlicedToArray());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var _objectWithoutProperties2 = _interopRequireDefault(requireObjectWithoutProperties());
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _colors = require$$8;
  var _Context = _interopRequireDefault(/* @__PURE__ */ requireContext$4());
  var _IconBase = _interopRequireDefault(/* @__PURE__ */ requireIconBase());
  var _twoTonePrimaryColor = /* @__PURE__ */ requireTwoTonePrimaryColor();
  var _utils = /* @__PURE__ */ requireUtils$1();
  var _excluded5 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
  (0, _twoTonePrimaryColor.setTwoToneColor)(_colors.blue.primary);
  var Icon = /* @__PURE__ */ React2.forwardRef(function(props, ref2) {
    var className = props.className, icon2 = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick2 = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, _objectWithoutProperties2.default)(props, _excluded5);
    var _React$useContext = React2.useContext(_Context.default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, _classnames.default)(rootClassName, prefixCls, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(icon2.name), !!icon2.name), "".concat(prefixCls, "-spin"), !!spin || icon2.name === "loading"), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === void 0 && onClick2) {
      iconTabIndex = -1;
    }
    var svgStyle = rotate ? {
      msTransform: "rotate(".concat(rotate, "deg)"),
      transform: "rotate(".concat(rotate, "deg)")
    } : void 0;
    var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, _slicedToArray2.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /* @__PURE__ */ React2.createElement("span", (0, _extends2.default)({
      role: "img",
      "aria-label": icon2.name
    }, restProps, {
      ref: ref2,
      tabIndex: iconTabIndex,
      onClick: onClick2,
      className: classString
    }), /* @__PURE__ */ React2.createElement(_IconBase.default, {
      icon: icon2,
      primaryColor,
      secondaryColor,
      style: svgStyle
    }));
  });
  Icon.displayName = "AntdIcon";
  Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
  Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
  AntdIcon.default = Icon;
  return AntdIcon;
}
var hasRequiredCloseCircleFilled$1;
function requireCloseCircleFilled$1() {
  if (hasRequiredCloseCircleFilled$1) return CloseCircleFilled$1;
  hasRequiredCloseCircleFilled$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(CloseCircleFilled$1, "__esModule", {
    value: true
  });
  CloseCircleFilled$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _CloseCircleFilled = _interopRequireDefault(/* @__PURE__ */ requireCloseCircleFilled$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var CloseCircleFilled2 = function CloseCircleFilled3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _CloseCircleFilled.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(CloseCircleFilled2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "CloseCircleFilled";
  }
  CloseCircleFilled$1.default = RefIcon;
  return CloseCircleFilled$1;
}
var hasRequiredCloseCircleFilled;
function requireCloseCircleFilled() {
  if (hasRequiredCloseCircleFilled) return CloseCircleFilled$2.exports;
  hasRequiredCloseCircleFilled = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _CloseCircleFilled = _interopRequireDefault(/* @__PURE__ */ requireCloseCircleFilled$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _CloseCircleFilled;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(CloseCircleFilled$2, CloseCircleFilled$2.exports);
  return CloseCircleFilled$2.exports;
}
var hasRequiredGetAllowClear;
function requireGetAllowClear() {
  if (hasRequiredGetAllowClear) return getAllowClear;
  hasRequiredGetAllowClear = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(getAllowClear, "__esModule", {
    value: true
  });
  getAllowClear.default = void 0;
  var _react = _interopRequireDefault(React__default);
  var _CloseCircleFilled = _interopRequireDefault(/* @__PURE__ */ requireCloseCircleFilled());
  const getAllowClear$1 = (allowClear) => {
    let mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) {
      mergedAllowClear = allowClear;
    } else if (allowClear) {
      mergedAllowClear = {
        clearIcon: /* @__PURE__ */ _react.default.createElement(_CloseCircleFilled.default, null)
      };
    }
    return mergedAllowClear;
  };
  getAllowClear.default = getAllowClear$1;
  return getAllowClear;
}
var statusUtils = {};
var hasRequiredStatusUtils;
function requireStatusUtils() {
  if (hasRequiredStatusUtils) return statusUtils;
  hasRequiredStatusUtils = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(statusUtils, "__esModule", {
    value: true
  });
  statusUtils.getMergedStatus = void 0;
  statusUtils.getStatusClassNames = getStatusClassNames;
  var _classnames = _interopRequireDefault(requireClassnames());
  function getStatusClassNames(prefixCls, status, hasFeedback) {
    return (0, _classnames.default)({
      [`${prefixCls}-status-success`]: status === "success",
      [`${prefixCls}-status-warning`]: status === "warning",
      [`${prefixCls}-status-error`]: status === "error",
      [`${prefixCls}-status-validating`]: status === "validating",
      [`${prefixCls}-has-feedback`]: hasFeedback
    });
  }
  const getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;
  statusUtils.getMergedStatus = getMergedStatus;
  return statusUtils;
}
var useCSSVarCls = {};
var hasRequiredUseCSSVarCls;
function requireUseCSSVarCls() {
  if (hasRequiredUseCSSVarCls) return useCSSVarCls;
  hasRequiredUseCSSVarCls = 1;
  Object.defineProperty(useCSSVarCls, "__esModule", {
    value: true
  });
  useCSSVarCls.default = void 0;
  var _internal = /* @__PURE__ */ requireInternal();
  const useCSSVarCls$1 = (prefixCls) => {
    const [, , , , cssVar] = (0, _internal.useToken)();
    return cssVar ? `${prefixCls}-css-var` : "";
  };
  useCSSVarCls.default = useCSSVarCls$1;
  return useCSSVarCls;
}
var useVariants = {};
var hasRequiredUseVariants;
function requireUseVariants() {
  if (hasRequiredUseVariants) return useVariants;
  hasRequiredUseVariants = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useVariants, "__esModule", {
    value: true
  });
  useVariants.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _context = /* @__PURE__ */ requireContext();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  const useVariant = function(component, variant) {
    let legacyBordered = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    var _a2, _b;
    const {
      variant: configVariant,
      [component]: componentConfig
    } = React2.useContext(_configProvider.ConfigContext);
    const ctxVariant = React2.useContext(_context.VariantContext);
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== "undefined") {
      mergedVariant = variant;
    } else if (legacyBordered === false) {
      mergedVariant = "borderless";
    } else {
      mergedVariant = (_b = (_a2 = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a2 !== void 0 ? _a2 : configVariant) !== null && _b !== void 0 ? _b : "outlined";
    }
    const enableVariantCls = _configProvider.Variants.includes(mergedVariant);
    return [mergedVariant, enableVariantCls];
  };
  useVariants.default = useVariant;
  return useVariants;
}
var useRemovePasswordTimeout = {};
var hasRequiredUseRemovePasswordTimeout;
function requireUseRemovePasswordTimeout() {
  if (hasRequiredUseRemovePasswordTimeout) return useRemovePasswordTimeout;
  hasRequiredUseRemovePasswordTimeout = 1;
  Object.defineProperty(useRemovePasswordTimeout, "__esModule", {
    value: true
  });
  useRemovePasswordTimeout.default = useRemovePasswordTimeout$1;
  var _react = React__default;
  function useRemovePasswordTimeout$1(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, _react.useRef)([]);
    const removePasswordTimeout = () => {
      removePasswordTimeoutRef.current.push(setTimeout(() => {
        var _a2, _b, _c, _d;
        if (((_a2 = inputRef.current) === null || _a2 === void 0 ? void 0 : _a2.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) {
          (_d = inputRef.current) === null || _d === void 0 ? void 0 : _d.input.removeAttribute("value");
        }
      }));
    };
    (0, _react.useEffect)(() => {
      if (triggerOnMount) {
        removePasswordTimeout();
      }
      return () => removePasswordTimeoutRef.current.forEach((timer) => {
        if (timer) {
          clearTimeout(timer);
        }
      });
    }, []);
    return removePasswordTimeout;
  }
  return useRemovePasswordTimeout;
}
var utils = {};
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils;
  hasRequiredUtils = 1;
  Object.defineProperty(utils, "__esModule", {
    value: true
  });
  utils.hasPrefixSuffix = hasPrefixSuffix2;
  function hasPrefixSuffix2(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
  }
  return utils;
}
var hasRequiredInput$1;
function requireInput$1() {
  if (hasRequiredInput$1) return Input$2;
  hasRequiredInput$1 = 1;
  (function(exports$1) {
    "use client";
    var _interopRequireDefault = requireInteropRequireDefault().default;
    var _interopRequireWildcard = requireInteropRequireWildcard().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    Object.defineProperty(exports$1, "triggerFocus", {
      enumerable: true,
      get: function() {
        return _commonUtils.triggerFocus;
      }
    });
    var _react = _interopRequireWildcard(React__default);
    var _classnames = _interopRequireDefault(requireClassnames());
    var _rcInput = _interopRequireDefault(require$$4$1);
    var _commonUtils = requireCommonUtils();
    var _ref = requireRef();
    var _ContextIsolator = _interopRequireDefault(/* @__PURE__ */ requireContextIsolator());
    var _getAllowClear = _interopRequireDefault(/* @__PURE__ */ requireGetAllowClear());
    var _statusUtils = /* @__PURE__ */ requireStatusUtils();
    var _warning = /* @__PURE__ */ requireWarning();
    var _context = /* @__PURE__ */ requireContext$1();
    var _DisabledContext = _interopRequireDefault(/* @__PURE__ */ requireDisabledContext());
    var _useCSSVarCls = _interopRequireDefault(/* @__PURE__ */ requireUseCSSVarCls());
    var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
    var _context2 = /* @__PURE__ */ requireContext();
    var _useVariants = _interopRequireDefault(/* @__PURE__ */ requireUseVariants());
    var _Compact = /* @__PURE__ */ requireCompact$1();
    var _useRemovePasswordTimeout = _interopRequireDefault(/* @__PURE__ */ requireUseRemovePasswordTimeout());
    var _style = _interopRequireWildcard(/* @__PURE__ */ requireStyle$4());
    var _utils = /* @__PURE__ */ requireUtils();
    var __rest2 = function(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
      return t;
    };
    const Input2 = /* @__PURE__ */ (0, _react.forwardRef)((props, ref2) => {
      const {
        prefixCls: customizePrefixCls,
        bordered = true,
        status: customStatus,
        size: customSize,
        disabled: customDisabled,
        onBlur,
        onFocus,
        suffix,
        allowClear,
        addonAfter,
        addonBefore,
        className,
        style: style2,
        styles: styles2,
        rootClassName,
        onChange: onChange5,
        classNames: classes,
        variant: customVariant
      } = props, rest = __rest2(props, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
      if (process.env.NODE_ENV !== "production") {
        const {
          deprecated: deprecated2
        } = (0, _warning.devUseWarning)("Input");
        deprecated2(!("bordered" in props), "bordered", "variant");
      }
      const {
        getPrefixCls,
        direction,
        allowClear: contextAllowClear,
        autoComplete: contextAutoComplete,
        className: contextClassName,
        style: contextStyle,
        classNames: contextClassNames,
        styles: contextStyles
      } = (0, _context.useComponentConfig)("input");
      const prefixCls = getPrefixCls("input", customizePrefixCls);
      const inputRef = (0, _react.useRef)(null);
      const rootCls = (0, _useCSSVarCls.default)(prefixCls);
      const [wrapSharedCSSVar, hashId, cssVarCls] = (0, _style.useSharedStyle)(prefixCls, rootClassName);
      const [wrapCSSVar] = (0, _style.default)(prefixCls, rootCls);
      const {
        compactSize,
        compactItemClassnames
      } = (0, _Compact.useCompactItemContext)(prefixCls, direction);
      const mergedSize = (0, _useSize.default)((ctx) => {
        var _a2;
        return (_a2 = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
      });
      const disabled = _react.default.useContext(_DisabledContext.default);
      const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
      const {
        status: contextStatus,
        hasFeedback,
        feedbackIcon
      } = (0, _react.useContext)(_context2.FormItemInputContext);
      const mergedStatus = (0, _statusUtils.getMergedStatus)(contextStatus, customStatus);
      const inputHasPrefixSuffix = (0, _utils.hasPrefixSuffix)(props) || !!hasFeedback;
      const prevHasPrefixSuffix = (0, _react.useRef)(inputHasPrefixSuffix);
      if (process.env.NODE_ENV !== "production") {
        const warning3 = (0, _warning.devUseWarning)("Input");
        (0, _react.useEffect)(() => {
          var _a2;
          if (inputHasPrefixSuffix && !prevHasPrefixSuffix.current) {
            process.env.NODE_ENV !== "production" ? warning3(document.activeElement === ((_a2 = inputRef.current) === null || _a2 === void 0 ? void 0 : _a2.input), "usage", `When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ`) : void 0;
          }
          prevHasPrefixSuffix.current = inputHasPrefixSuffix;
        }, [inputHasPrefixSuffix]);
      }
      const removePasswordTimeout = (0, _useRemovePasswordTimeout.default)(inputRef, true);
      const handleBlur = (e) => {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      };
      const handleFocus = (e) => {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
      };
      const handleChange = (e) => {
        removePasswordTimeout();
        onChange5 === null || onChange5 === void 0 ? void 0 : onChange5(e);
      };
      const suffixNode = (hasFeedback || suffix) && /* @__PURE__ */ _react.default.createElement(_react.default.Fragment, null, suffix, hasFeedback && feedbackIcon);
      const mergedAllowClear = (0, _getAllowClear.default)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
      const [variant, enableVariantCls] = (0, _useVariants.default)("input", customVariant, bordered);
      return wrapSharedCSSVar(wrapCSSVar(/* @__PURE__ */ _react.default.createElement(_rcInput.default, Object.assign({
        ref: (0, _ref.composeRef)(ref2, inputRef),
        prefixCls,
        autoComplete: contextAutoComplete
      }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, contextStyle), style2),
        styles: Object.assign(Object.assign({}, contextStyles), styles2),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, _classnames.default)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName),
        onChange: handleChange,
        addonBefore: addonBefore && /* @__PURE__ */ _react.default.createElement(_ContextIsolator.default, {
          form: true,
          space: true
        }, addonBefore),
        addonAfter: addonAfter && /* @__PURE__ */ _react.default.createElement(_ContextIsolator.default, {
          form: true,
          space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
          input: (0, _classnames.default)({
            [`${prefixCls}-sm`]: mergedSize === "small",
            [`${prefixCls}-lg`]: mergedSize === "large",
            [`${prefixCls}-rtl`]: direction === "rtl"
          }, classes === null || classes === void 0 ? void 0 : classes.input, contextClassNames.input, hashId),
          variant: (0, _classnames.default)({
            [`${prefixCls}-${variant}`]: enableVariantCls
          }, (0, _statusUtils.getStatusClassNames)(prefixCls, mergedStatus)),
          affixWrapper: (0, _classnames.default)({
            [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
            [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
            [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl"
          }, hashId),
          wrapper: (0, _classnames.default)({
            [`${prefixCls}-group-rtl`]: direction === "rtl"
          }, hashId),
          groupWrapper: (0, _classnames.default)({
            [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
            [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
            [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
            [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
          }, (0, _statusUtils.getStatusClassNames)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
      }))));
    });
    if (process.env.NODE_ENV !== "production") {
      Input2.displayName = "Input";
    }
    exports$1.default = Input2;
  })(Input$2);
  return Input$2;
}
var OTP = {};
var useEvent = {};
var hasRequiredUseEvent;
function requireUseEvent() {
  if (hasRequiredUseEvent) return useEvent;
  hasRequiredUseEvent = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useEvent, "__esModule", {
    value: true
  });
  useEvent.default = useEvent$12;
  var React2 = _interopRequireWildcard(React__default);
  function useEvent$12(callback) {
    var fnRef = React2.useRef();
    fnRef.current = callback;
    var memoFn = React2.useCallback(function() {
      var _fnRef$current;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
    }, []);
    return memoFn;
  }
  return useEvent;
}
var pickAttrs$1 = {};
var hasRequiredPickAttrs;
function requirePickAttrs() {
  if (hasRequiredPickAttrs) return pickAttrs$1;
  hasRequiredPickAttrs = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(pickAttrs$1, "__esModule", {
    value: true
  });
  pickAttrs$1.default = pickAttrs2;
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var attributes2 = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
  var eventsName2 = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
  var propList2 = "".concat(attributes2, " ").concat(eventsName2).split(/[\s\n]+/);
  var ariaPrefix2 = "aria-";
  var dataPrefix2 = "data-";
  function match2(key, prefix2) {
    return key.indexOf(prefix2) === 0;
  }
  function pickAttrs2(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) {
      mergedConfig = {
        aria: true,
        data: true,
        attr: true
      };
    } else if (ariaOnly === true) {
      mergedConfig = {
        aria: true
      };
    } else {
      mergedConfig = (0, _objectSpread22.default)({}, ariaOnly);
    }
    var attrs = {};
    Object.keys(props).forEach(function(key) {
      if (
        // Aria
        mergedConfig.aria && (key === "role" || match2(key, ariaPrefix2)) || // Data
        mergedConfig.data && match2(key, dataPrefix2) || // Attr
        mergedConfig.attr && propList2.includes(key)
      ) {
        attrs[key] = props[key];
      }
    });
    return attrs;
  }
  return pickAttrs$1;
}
var otp = {};
var hasRequiredOtp;
function requireOtp() {
  if (hasRequiredOtp) return otp;
  hasRequiredOtp = 1;
  Object.defineProperty(otp, "__esModule", {
    value: true
  });
  otp.default = void 0;
  var _internal = /* @__PURE__ */ requireInternal();
  var _token = /* @__PURE__ */ requireToken$1();
  const genOTPStyle = (token2) => {
    const {
      componentCls,
      paddingXS
    } = token2;
    return {
      [componentCls]: {
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "nowrap",
        columnGap: paddingXS,
        "&-rtl": {
          direction: "rtl"
        },
        [`${componentCls}-input`]: {
          textAlign: "center",
          paddingInline: token2.paddingXXS
        },
        // ================= Size =================
        [`&${componentCls}-sm ${componentCls}-input`]: {
          paddingInline: token2.calc(token2.paddingXXS).div(2).equal()
        },
        [`&${componentCls}-lg ${componentCls}-input`]: {
          paddingInline: token2.paddingXS
        }
      }
    };
  };
  otp.default = (0, _internal.genStyleHooks)(["Input", "OTP"], (token2) => {
    const inputToken = (0, _internal.mergeToken)(token2, (0, _token.initInputToken)(token2));
    return [genOTPStyle(inputToken)];
  }, _token.initComponentToken);
  return otp;
}
var OTPInput = {};
var raf$1 = {};
var hasRequiredRaf;
function requireRaf() {
  if (hasRequiredRaf) return raf$1;
  hasRequiredRaf = 1;
  Object.defineProperty(raf$1, "__esModule", {
    value: true
  });
  raf$1.default = void 0;
  var raf3 = function raf4(callback) {
    return +setTimeout(callback, 16);
  };
  var caf3 = function caf4(num) {
    return clearTimeout(num);
  };
  if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    raf3 = function raf4(callback) {
      return window.requestAnimationFrame(callback);
    };
    caf3 = function caf4(handle) {
      return window.cancelAnimationFrame(handle);
    };
  }
  var rafUUID2 = 0;
  var rafIds2 = /* @__PURE__ */ new Map();
  function cleanup2(id2) {
    rafIds2.delete(id2);
  }
  var wrapperRaf3 = function wrapperRaf4(callback) {
    var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    rafUUID2 += 1;
    var id2 = rafUUID2;
    function callRef(leftTimes) {
      if (leftTimes === 0) {
        cleanup2(id2);
        callback();
      } else {
        var realId = raf3(function() {
          callRef(leftTimes - 1);
        });
        rafIds2.set(id2, realId);
      }
    }
    callRef(times);
    return id2;
  };
  wrapperRaf3.cancel = function(id2) {
    var realId = rafIds2.get(id2);
    cleanup2(id2);
    return caf3(realId);
  };
  if (process.env.NODE_ENV !== "production") {
    wrapperRaf3.ids = function() {
      return rafIds2;
    };
  }
  raf$1.default = wrapperRaf3;
  return raf$1;
}
var hasRequiredOTPInput;
function requireOTPInput() {
  if (hasRequiredOTPInput) return OTPInput;
  hasRequiredOTPInput = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(OTPInput, "__esModule", {
    value: true
  });
  OTPInput.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _raf = _interopRequireDefault(requireRaf());
  var _Input = _interopRequireDefault(/* @__PURE__ */ requireInput$1());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const OTPInput$1 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    const {
      value,
      onChange: onChange5,
      onActiveChange,
      index: index2,
      mask
    } = props, restProps = __rest2(props, ["value", "onChange", "onActiveChange", "index", "mask"]);
    const internalValue = value && typeof mask === "string" ? mask : value;
    const onInternalChange = (e) => {
      onChange5(index2, e.target.value);
    };
    const inputRef = React2.useRef(null);
    React2.useImperativeHandle(ref2, () => inputRef.current);
    const syncSelection = () => {
      (0, _raf.default)(() => {
        var _a2;
        const inputEle = (_a2 = inputRef.current) === null || _a2 === void 0 ? void 0 : _a2.input;
        if (document.activeElement === inputEle && inputEle) {
          inputEle.select();
        }
      });
    };
    const onInternalKeyDown = (event) => {
      const {
        key,
        ctrlKey,
        metaKey
      } = event;
      if (key === "ArrowLeft") {
        onActiveChange(index2 - 1);
      } else if (key === "ArrowRight") {
        onActiveChange(index2 + 1);
      } else if (key === "z" && (ctrlKey || metaKey)) {
        event.preventDefault();
      }
      syncSelection();
    };
    const onInternalKeyUp = (e) => {
      if (e.key === "Backspace" && !value) {
        onActiveChange(index2 - 1);
      }
      syncSelection();
    };
    return /* @__PURE__ */ React2.createElement(_Input.default, Object.assign({
      type: mask === true ? "password" : "text"
    }, restProps, {
      ref: inputRef,
      value: internalValue,
      onInput: onInternalChange,
      onFocus: syncSelection,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onMouseDown: syncSelection,
      onMouseUp: syncSelection
    }));
  });
  OTPInput.default = OTPInput$1;
  return OTPInput;
}
var hasRequiredOTP;
function requireOTP() {
  if (hasRequiredOTP) return OTP;
  hasRequiredOTP = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(OTP, "__esModule", {
    value: true
  });
  OTP.default = void 0;
  var _toConsumableArray2 = _interopRequireDefault(requireToConsumableArray());
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _useEvent = _interopRequireDefault(requireUseEvent());
  var _pickAttrs = _interopRequireDefault(requirePickAttrs());
  var _statusUtils = /* @__PURE__ */ requireStatusUtils();
  var _warning = /* @__PURE__ */ requireWarning();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _context = /* @__PURE__ */ requireContext();
  var _otp = _interopRequireDefault(/* @__PURE__ */ requireOtp());
  var _OTPInput = _interopRequireDefault(/* @__PURE__ */ requireOTPInput());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  function strToArr(str) {
    return (str || "").split("");
  }
  const Separator = (props) => {
    const {
      index: index2,
      prefixCls,
      separator
    } = props;
    const separatorNode = typeof separator === "function" ? separator(index2) : separator;
    if (!separatorNode) {
      return null;
    }
    return /* @__PURE__ */ React2.createElement("span", {
      className: `${prefixCls}-separator`
    }, separatorNode);
  };
  const OTP$1 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    const {
      prefixCls: customizePrefixCls,
      length: length2 = 6,
      size: customSize,
      defaultValue,
      value,
      onChange: onChange5,
      formatter,
      separator,
      variant,
      disabled,
      status: customStatus,
      autoFocus,
      mask,
      type: type4,
      onInput,
      inputMode
    } = props, restProps = __rest2(props, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "separator", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]);
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Input.OTP");
      process.env.NODE_ENV !== "production" ? warning3(!(typeof mask === "string" && mask.length > 1), "usage", "`mask` prop should be a single character.") : void 0;
    }
    const {
      getPrefixCls,
      direction
    } = React2.useContext(_configProvider.ConfigContext);
    const prefixCls = getPrefixCls("otp", customizePrefixCls);
    const domAttrs = (0, _pickAttrs.default)(restProps, {
      aria: true,
      data: true,
      attr: true
    });
    const [wrapCSSVar, hashId, cssVarCls] = (0, _otp.default)(prefixCls);
    const mergedSize = (0, _useSize.default)((ctx) => customSize !== null && customSize !== void 0 ? customSize : ctx);
    const formContext = React2.useContext(_context.FormItemInputContext);
    const mergedStatus = (0, _statusUtils.getMergedStatus)(formContext.status, customStatus);
    const proxyFormContext = React2.useMemo(() => Object.assign(Object.assign({}, formContext), {
      status: mergedStatus,
      hasFeedback: false,
      feedbackIcon: null
    }), [formContext, mergedStatus]);
    const containerRef = React2.useRef(null);
    const refs = React2.useRef({});
    React2.useImperativeHandle(ref2, () => ({
      focus: () => {
        var _a2;
        (_a2 = refs.current[0]) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: () => {
        var _a2;
        for (let i = 0; i < length2; i += 1) {
          (_a2 = refs.current[i]) === null || _a2 === void 0 ? void 0 : _a2.blur();
        }
      },
      nativeElement: containerRef.current
    }));
    const internalFormatter = (txt) => formatter ? formatter(txt) : txt;
    const [valueCells, setValueCells] = React2.useState(() => strToArr(internalFormatter(defaultValue || "")));
    React2.useEffect(() => {
      if (value !== void 0) {
        setValueCells(strToArr(value));
      }
    }, [value]);
    const triggerValueCellsChange = (0, _useEvent.default)((nextValueCells) => {
      setValueCells(nextValueCells);
      if (onInput) {
        onInput(nextValueCells);
      }
      if (onChange5 && nextValueCells.length === length2 && nextValueCells.every((c) => c) && nextValueCells.some((c, index2) => valueCells[index2] !== c)) {
        onChange5(nextValueCells.join(""));
      }
    });
    const patchValue = (0, _useEvent.default)((index2, txt) => {
      let nextCells = (0, _toConsumableArray2.default)(valueCells);
      for (let i = 0; i < index2; i += 1) {
        if (!nextCells[i]) {
          nextCells[i] = "";
        }
      }
      if (txt.length <= 1) {
        nextCells[index2] = txt;
      } else {
        nextCells = nextCells.slice(0, index2).concat(strToArr(txt));
      }
      nextCells = nextCells.slice(0, length2);
      for (let i = nextCells.length - 1; i >= 0; i -= 1) {
        if (nextCells[i]) {
          break;
        }
        nextCells.pop();
      }
      const formattedValue = internalFormatter(nextCells.map((c) => c || " ").join(""));
      nextCells = strToArr(formattedValue).map((c, i) => {
        if (c === " " && !nextCells[i]) {
          return nextCells[i];
        }
        return c;
      });
      return nextCells;
    });
    const onInputChange = (index2, txt) => {
      var _a2;
      const nextCells = patchValue(index2, txt);
      const nextIndex = Math.min(index2 + txt.length, length2 - 1);
      if (nextIndex !== index2 && nextCells[index2] !== void 0) {
        (_a2 = refs.current[nextIndex]) === null || _a2 === void 0 ? void 0 : _a2.focus();
      }
      triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex) => {
      var _a2;
      (_a2 = refs.current[nextIndex]) === null || _a2 === void 0 ? void 0 : _a2.focus();
    };
    const inputSharedProps = {
      variant,
      disabled,
      status: mergedStatus,
      mask,
      type: type4,
      inputMode
    };
    return wrapCSSVar(/* @__PURE__ */ React2.createElement("div", Object.assign({}, domAttrs, {
      ref: containerRef,
      className: (0, _classnames.default)(prefixCls, {
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-rtl`]: direction === "rtl"
      }, cssVarCls, hashId)
    }), /* @__PURE__ */ React2.createElement(_context.FormItemInputContext.Provider, {
      value: proxyFormContext
    }, Array.from({
      length: length2
    }).map((_2, index2) => {
      const key = `otp-${index2}`;
      const singleValue = valueCells[index2] || "";
      return /* @__PURE__ */ React2.createElement(React2.Fragment, {
        key
      }, /* @__PURE__ */ React2.createElement(_OTPInput.default, Object.assign({
        ref: (inputEle) => {
          refs.current[index2] = inputEle;
        },
        index: index2,
        size: mergedSize,
        htmlSize: 1,
        className: `${prefixCls}-input`,
        onChange: onInputChange,
        value: singleValue,
        onActiveChange: onInputActiveChange,
        autoFocus: index2 === 0 && autoFocus
      }, inputSharedProps)), index2 < length2 - 1 && /* @__PURE__ */ React2.createElement(Separator, {
        separator,
        index: index2,
        prefixCls
      }));
    }))));
  });
  OTP.default = OTP$1;
  return OTP;
}
var Password = {};
var EyeInvisibleOutlined$2 = { exports: {} };
var EyeInvisibleOutlined$1 = {};
var EyeInvisibleOutlined = {};
var hasRequiredEyeInvisibleOutlined$2;
function requireEyeInvisibleOutlined$2() {
  if (hasRequiredEyeInvisibleOutlined$2) return EyeInvisibleOutlined;
  hasRequiredEyeInvisibleOutlined$2 = 1;
  Object.defineProperty(EyeInvisibleOutlined, "__esModule", { value: true });
  var EyeInvisibleOutlined$12 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
  EyeInvisibleOutlined.default = EyeInvisibleOutlined$12;
  return EyeInvisibleOutlined;
}
var hasRequiredEyeInvisibleOutlined$1;
function requireEyeInvisibleOutlined$1() {
  if (hasRequiredEyeInvisibleOutlined$1) return EyeInvisibleOutlined$1;
  hasRequiredEyeInvisibleOutlined$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(EyeInvisibleOutlined$1, "__esModule", {
    value: true
  });
  EyeInvisibleOutlined$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _EyeInvisibleOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeInvisibleOutlined$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var EyeInvisibleOutlined2 = function EyeInvisibleOutlined3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _EyeInvisibleOutlined.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(EyeInvisibleOutlined2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "EyeInvisibleOutlined";
  }
  EyeInvisibleOutlined$1.default = RefIcon;
  return EyeInvisibleOutlined$1;
}
var hasRequiredEyeInvisibleOutlined;
function requireEyeInvisibleOutlined() {
  if (hasRequiredEyeInvisibleOutlined) return EyeInvisibleOutlined$2.exports;
  hasRequiredEyeInvisibleOutlined = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _EyeInvisibleOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeInvisibleOutlined$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _EyeInvisibleOutlined;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(EyeInvisibleOutlined$2, EyeInvisibleOutlined$2.exports);
  return EyeInvisibleOutlined$2.exports;
}
var EyeOutlined$2 = { exports: {} };
var EyeOutlined$1 = {};
var EyeOutlined = {};
var hasRequiredEyeOutlined$2;
function requireEyeOutlined$2() {
  if (hasRequiredEyeOutlined$2) return EyeOutlined;
  hasRequiredEyeOutlined$2 = 1;
  Object.defineProperty(EyeOutlined, "__esModule", { value: true });
  var EyeOutlined$12 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
  EyeOutlined.default = EyeOutlined$12;
  return EyeOutlined;
}
var hasRequiredEyeOutlined$1;
function requireEyeOutlined$1() {
  if (hasRequiredEyeOutlined$1) return EyeOutlined$1;
  hasRequiredEyeOutlined$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(EyeOutlined$1, "__esModule", {
    value: true
  });
  EyeOutlined$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _EyeOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeOutlined$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var EyeOutlined2 = function EyeOutlined3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _EyeOutlined.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(EyeOutlined2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "EyeOutlined";
  }
  EyeOutlined$1.default = RefIcon;
  return EyeOutlined$1;
}
var hasRequiredEyeOutlined;
function requireEyeOutlined() {
  if (hasRequiredEyeOutlined) return EyeOutlined$2.exports;
  hasRequiredEyeOutlined = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _EyeOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeOutlined$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _EyeOutlined;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(EyeOutlined$2, EyeOutlined$2.exports);
  return EyeOutlined$2.exports;
}
var hasRequiredPassword;
function requirePassword() {
  if (hasRequiredPassword) return Password;
  hasRequiredPassword = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(Password, "__esModule", {
    value: true
  });
  Password.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var React2 = _react;
  var _EyeInvisibleOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeInvisibleOutlined());
  var _EyeOutlined = _interopRequireDefault(/* @__PURE__ */ requireEyeOutlined());
  var _classnames = _interopRequireDefault(requireClassnames());
  var _omit = _interopRequireDefault(requireOmit());
  var _ref = requireRef();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _DisabledContext = _interopRequireDefault(/* @__PURE__ */ requireDisabledContext());
  var _useRemovePasswordTimeout = _interopRequireDefault(/* @__PURE__ */ requireUseRemovePasswordTimeout());
  var _Input = _interopRequireDefault(/* @__PURE__ */ requireInput$1());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const defaultIconRender = (visible) => visible ? /* @__PURE__ */ React2.createElement(_EyeOutlined.default, null) : /* @__PURE__ */ React2.createElement(_EyeInvisibleOutlined.default, null);
  const actionMap = {
    click: "onClick",
    hover: "onMouseOver"
  };
  const Password$1 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    const {
      disabled: customDisabled,
      action: action3 = "click",
      visibilityToggle = true,
      iconRender = defaultIconRender
    } = props;
    const disabled = React2.useContext(_DisabledContext.default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const visibilityControlled = typeof visibilityToggle === "object" && visibilityToggle.visible !== void 0;
    const [visible, setVisible] = (0, _react.useState)(() => visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, _react.useRef)(null);
    React2.useEffect(() => {
      if (visibilityControlled) {
        setVisible(visibilityToggle.visible);
      }
    }, [visibilityControlled, visibilityToggle]);
    const removePasswordTimeout = (0, _useRemovePasswordTimeout.default)(inputRef);
    const onVisibleChange = () => {
      var _a2;
      if (mergedDisabled) {
        return;
      }
      if (visible) {
        removePasswordTimeout();
      }
      const nextVisible = !visible;
      setVisible(nextVisible);
      if (typeof visibilityToggle === "object") {
        (_a2 = visibilityToggle.onVisibleChange) === null || _a2 === void 0 ? void 0 : _a2.call(visibilityToggle, nextVisible);
      }
    };
    const getIcon = (prefixCls2) => {
      const iconTrigger = actionMap[action3] || "";
      const icon2 = iconRender(visible);
      const iconProps = {
        [iconTrigger]: onVisibleChange,
        className: `${prefixCls2}-icon`,
        key: "passwordIcon",
        onMouseDown: (e) => {
          e.preventDefault();
        },
        onMouseUp: (e) => {
          e.preventDefault();
        }
      };
      return /* @__PURE__ */ React2.cloneElement(/* @__PURE__ */ React2.isValidElement(icon2) ? icon2 : /* @__PURE__ */ React2.createElement("span", null, icon2), iconProps);
    };
    const {
      className,
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      size: size2
    } = props, restProps = __rest2(props, ["className", "prefixCls", "inputPrefixCls", "size"]);
    const {
      getPrefixCls
    } = React2.useContext(_configProvider.ConfigContext);
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const prefixCls = getPrefixCls("input-password", customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, _classnames.default)(prefixCls, className, {
      [`${prefixCls}-${size2}`]: !!size2
    });
    const omittedProps = Object.assign(Object.assign({}, (0, _omit.default)(restProps, ["suffix", "iconRender", "visibilityToggle"])), {
      type: visible ? "text" : "password",
      className: inputClassName,
      prefixCls: inputPrefixCls,
      suffix: suffixIcon
    });
    if (size2) {
      omittedProps.size = size2;
    }
    return /* @__PURE__ */ React2.createElement(_Input.default, Object.assign({
      ref: (0, _ref.composeRef)(ref2, inputRef)
    }, omittedProps));
  });
  if (process.env.NODE_ENV !== "production") {
    Password$1.displayName = "Input.Password";
  }
  Password.default = Password$1;
  return Password;
}
var Search$1 = {};
var SearchOutlined$2 = { exports: {} };
var SearchOutlined$1 = {};
var SearchOutlined = {};
var hasRequiredSearchOutlined$2;
function requireSearchOutlined$2() {
  if (hasRequiredSearchOutlined$2) return SearchOutlined;
  hasRequiredSearchOutlined$2 = 1;
  Object.defineProperty(SearchOutlined, "__esModule", { value: true });
  var SearchOutlined$12 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
  SearchOutlined.default = SearchOutlined$12;
  return SearchOutlined;
}
var hasRequiredSearchOutlined$1;
function requireSearchOutlined$1() {
  if (hasRequiredSearchOutlined$1) return SearchOutlined$1;
  hasRequiredSearchOutlined$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(SearchOutlined$1, "__esModule", {
    value: true
  });
  SearchOutlined$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _SearchOutlined = _interopRequireDefault(/* @__PURE__ */ requireSearchOutlined$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var SearchOutlined2 = function SearchOutlined3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _SearchOutlined.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(SearchOutlined2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "SearchOutlined";
  }
  SearchOutlined$1.default = RefIcon;
  return SearchOutlined$1;
}
var hasRequiredSearchOutlined;
function requireSearchOutlined() {
  if (hasRequiredSearchOutlined) return SearchOutlined$2.exports;
  hasRequiredSearchOutlined = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _SearchOutlined = _interopRequireDefault(/* @__PURE__ */ requireSearchOutlined$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _SearchOutlined;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(SearchOutlined$2, SearchOutlined$2.exports);
  return SearchOutlined$2.exports;
}
var reactNode = {};
var hasRequiredReactNode;
function requireReactNode() {
  if (hasRequiredReactNode) return reactNode;
  hasRequiredReactNode = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(reactNode, "__esModule", {
    value: true
  });
  reactNode.cloneElement = cloneElement2;
  reactNode.isFragment = isFragment2;
  reactNode.replaceElement = void 0;
  var _react = _interopRequireDefault(React__default);
  function isFragment2(child) {
    return child && /* @__PURE__ */ _react.default.isValidElement(child) && child.type === _react.default.Fragment;
  }
  const replaceElement = (element, replacement, props) => {
    if (!/* @__PURE__ */ _react.default.isValidElement(element)) {
      return replacement;
    }
    return /* @__PURE__ */ _react.default.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
  };
  reactNode.replaceElement = replaceElement;
  function cloneElement2(element, props) {
    return replaceElement(element, element, props);
  }
  return reactNode;
}
var button$1 = {};
var button = {};
var wave = {};
var isVisible = {};
var hasRequiredIsVisible;
function requireIsVisible() {
  if (hasRequiredIsVisible) return isVisible;
  hasRequiredIsVisible = 1;
  Object.defineProperty(isVisible, "__esModule", {
    value: true
  });
  isVisible.default = void 0;
  isVisible.default = function _default2(element) {
    if (!element) {
      return false;
    }
    if (element instanceof Element) {
      if (element.offsetParent) {
        return true;
      }
      if (element.getBBox) {
        var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
        if (width || height) {
          return true;
        }
      }
      if (element.getBoundingClientRect) {
        var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
        if (_width || _height) {
          return true;
        }
      }
    }
    return false;
  };
  return isVisible;
}
var style$3 = {};
var hasRequiredStyle$2;
function requireStyle$2() {
  if (hasRequiredStyle$2) return style$3;
  hasRequiredStyle$2 = 1;
  Object.defineProperty(style$3, "__esModule", {
    value: true
  });
  style$3.default = void 0;
  var _internal = /* @__PURE__ */ requireInternal();
  const genWaveStyle = (token2) => {
    const {
      componentCls,
      colorPrimary
    } = token2;
    return {
      [componentCls]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none",
        boxSizing: "border-box",
        color: `var(--wave-color, ${colorPrimary})`,
        boxShadow: `0 0 0 0 currentcolor`,
        opacity: 0.2,
        // =================== Motion ===================
        "&.wave-motion-appear": {
          transition: [`box-shadow 0.4s ${token2.motionEaseOutCirc}`, `opacity 2s ${token2.motionEaseOutCirc}`].join(","),
          "&-active": {
            boxShadow: `0 0 0 6px currentcolor`,
            opacity: 0
          },
          "&.wave-quick": {
            transition: [`box-shadow ${token2.motionDurationSlow} ${token2.motionEaseInOut}`, `opacity ${token2.motionDurationSlow} ${token2.motionEaseInOut}`].join(",")
          }
        }
      }
    };
  };
  style$3.default = (0, _internal.genComponentStyleHook)("Wave", (token2) => [genWaveStyle(token2)]);
  return style$3;
}
var useWave = {};
var _interface = {};
var hasRequired_interface;
function require_interface() {
  if (hasRequired_interface) return _interface;
  hasRequired_interface = 1;
  Object.defineProperty(_interface, "__esModule", {
    value: true
  });
  _interface.TARGET_CLS = void 0;
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  _interface.TARGET_CLS = `${_configProvider.defaultPrefixCls}-wave-target`;
  return _interface;
}
var WaveEffect = {};
var UnstableContext = {};
var render = {};
var regeneratorRuntime = { exports: {} };
var OverloadYield = { exports: {} };
var hasRequiredOverloadYield;
function requireOverloadYield() {
  if (hasRequiredOverloadYield) return OverloadYield.exports;
  hasRequiredOverloadYield = 1;
  (function(module2) {
    function _OverloadYield2(e, d) {
      this.v = e, this.k = d;
    }
    module2.exports = _OverloadYield2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(OverloadYield);
  return OverloadYield.exports;
}
var regenerator = { exports: {} };
var regeneratorDefine = { exports: {} };
var hasRequiredRegeneratorDefine;
function requireRegeneratorDefine() {
  if (hasRequiredRegeneratorDefine) return regeneratorDefine.exports;
  hasRequiredRegeneratorDefine = 1;
  (function(module2) {
    function _regeneratorDefine2(e, r2, n, t) {
      var i = Object.defineProperty;
      try {
        i({}, "", {});
      } catch (e2) {
        i = 0;
      }
      module2.exports = _regeneratorDefine2 = function regeneratorDefine2(e2, r3, n2, t2) {
        function o(r4, n3) {
          _regeneratorDefine2(e2, r4, function(e3) {
            return this._invoke(r4, n3, e3);
          });
        }
        r3 ? i ? i(e2, r3, {
          value: n2,
          enumerable: !t2,
          configurable: !t2,
          writable: !t2
        }) : e2[r3] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _regeneratorDefine2(e, r2, n, t);
    }
    module2.exports = _regeneratorDefine2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorDefine);
  return regeneratorDefine.exports;
}
var hasRequiredRegenerator;
function requireRegenerator() {
  if (hasRequiredRegenerator) return regenerator.exports;
  hasRequiredRegenerator = 1;
  (function(module2) {
    var regeneratorDefine2 = requireRegeneratorDefine();
    function _regenerator2() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
      var e, t, r2 = "function" == typeof Symbol ? Symbol : {}, n = r2.iterator || "@@iterator", o = r2.toStringTag || "@@toStringTag";
      function i(r3, n2, o2, i2) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return regeneratorDefine2(u2, "_invoke", (function(r4, n3, o3) {
          var i3, c3, u3, f2 = 0, p = o3 || [], y = false, G = {
            p: 0,
            n: 0,
            v: e,
            a: d,
            f: d.bind(e, 4),
            d: function d2(t2, r5) {
              return i3 = t2, c3 = 0, u3 = e, G.n = r5, a;
            }
          };
          function d(r5, n4) {
            for (c3 = r5, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
              var o4, i4 = p[t], d2 = G.p, l = i4[2];
              r5 > 3 ? (o4 = l === n4) && (u3 = i4[(c3 = i4[4]) ? 5 : (c3 = 3, 3)], i4[4] = i4[5] = e) : i4[0] <= d2 && ((o4 = r5 < 2 && d2 < i4[1]) ? (c3 = 0, G.v = n4, G.n = i4[1]) : d2 < l && (o4 = r5 < 3 || i4[0] > n4 || n4 > l) && (i4[4] = r5, i4[5] = n4, G.n = l, c3 = 0));
            }
            if (o4 || r5 > 1) return a;
            throw y = true, n4;
          }
          return function(o4, p2, l) {
            if (f2 > 1) throw TypeError("Generator is already running");
            for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
              i3 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
              try {
                if (f2 = 2, i3) {
                  if (c3 || (o4 = "next"), t = i3[o4]) {
                    if (!(t = t.call(i3, u3))) throw TypeError("iterator result is not an object");
                    if (!t.done) return t;
                    u3 = t.value, c3 < 2 && (c3 = 0);
                  } else 1 === c3 && (t = i3["return"]) && t.call(i3), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                  i3 = e;
                } else if ((t = (y = G.n < 0) ? u3 : r4.call(n3, G)) !== a) break;
              } catch (t2) {
                i3 = e, c3 = 1, u3 = t2;
              } finally {
                f2 = 1;
              }
            }
            return {
              value: t,
              done: y
            };
          };
        })(r3, o2, i2), true), u2;
      }
      var a = {};
      function Generator() {
      }
      function GeneratorFunction() {
      }
      function GeneratorFunctionPrototype() {
      }
      t = Object.getPrototypeOf;
      var c = [][n] ? t(t([][n]())) : (regeneratorDefine2(t = {}, n, function() {
        return this;
      }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
      function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, regeneratorDefine2(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine2(u), regeneratorDefine2(u, o, "Generator"), regeneratorDefine2(u, n, function() {
        return this;
      }), regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
      }), (module2.exports = _regenerator2 = function _regenerator3() {
        return {
          w: i,
          m: f
        };
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports)();
    }
    module2.exports = _regenerator2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regenerator);
  return regenerator.exports;
}
var regeneratorAsync = { exports: {} };
var regeneratorAsyncGen = { exports: {} };
var regeneratorAsyncIterator = { exports: {} };
var hasRequiredRegeneratorAsyncIterator;
function requireRegeneratorAsyncIterator() {
  if (hasRequiredRegeneratorAsyncIterator) return regeneratorAsyncIterator.exports;
  hasRequiredRegeneratorAsyncIterator = 1;
  (function(module2) {
    var OverloadYield2 = requireOverloadYield();
    var regeneratorDefine2 = requireRegeneratorDefine();
    function AsyncIterator2(t, e) {
      function n(r3, o, i, f) {
        try {
          var c = t[r3](o), u = c.value;
          return u instanceof OverloadYield2 ? e.resolve(u.v).then(function(t2) {
            n("next", t2, i, f);
          }, function(t2) {
            n("throw", t2, i, f);
          }) : e.resolve(u).then(function(t2) {
            c.value = t2, i(c);
          }, function(t2) {
            return n("throw", t2, i, f);
          });
        } catch (t2) {
          f(t2);
        }
      }
      var r2;
      this.next || (regeneratorDefine2(AsyncIterator2.prototype), regeneratorDefine2(AsyncIterator2.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
      })), regeneratorDefine2(this, "_invoke", function(t2, o, i) {
        function f() {
          return new e(function(e2, r3) {
            n(t2, i, e2, r3);
          });
        }
        return r2 = r2 ? r2.then(f, f) : f();
      }, true);
    }
    module2.exports = AsyncIterator2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorAsyncIterator);
  return regeneratorAsyncIterator.exports;
}
var hasRequiredRegeneratorAsyncGen;
function requireRegeneratorAsyncGen() {
  if (hasRequiredRegeneratorAsyncGen) return regeneratorAsyncGen.exports;
  hasRequiredRegeneratorAsyncGen = 1;
  (function(module2) {
    var regenerator2 = requireRegenerator();
    var regeneratorAsyncIterator2 = requireRegeneratorAsyncIterator();
    function _regeneratorAsyncGen2(r2, e, t, o, n) {
      return new regeneratorAsyncIterator2(regenerator2().w(r2, e, t, o), n || Promise);
    }
    module2.exports = _regeneratorAsyncGen2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorAsyncGen);
  return regeneratorAsyncGen.exports;
}
var hasRequiredRegeneratorAsync;
function requireRegeneratorAsync() {
  if (hasRequiredRegeneratorAsync) return regeneratorAsync.exports;
  hasRequiredRegeneratorAsync = 1;
  (function(module2) {
    var regeneratorAsyncGen2 = requireRegeneratorAsyncGen();
    function _regeneratorAsync2(n, e, r2, t, o) {
      var a = regeneratorAsyncGen2(n, e, r2, t, o);
      return a.next().then(function(n2) {
        return n2.done ? n2.value : a.next();
      });
    }
    module2.exports = _regeneratorAsync2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorAsync);
  return regeneratorAsync.exports;
}
var regeneratorKeys = { exports: {} };
var hasRequiredRegeneratorKeys;
function requireRegeneratorKeys() {
  if (hasRequiredRegeneratorKeys) return regeneratorKeys.exports;
  hasRequiredRegeneratorKeys = 1;
  (function(module2) {
    function _regeneratorKeys2(e) {
      var n = Object(e), r2 = [];
      for (var t in n) r2.unshift(t);
      return function e2() {
        for (; r2.length; ) if ((t = r2.pop()) in n) return e2.value = t, e2.done = false, e2;
        return e2.done = true, e2;
      };
    }
    module2.exports = _regeneratorKeys2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorKeys);
  return regeneratorKeys.exports;
}
var regeneratorValues = { exports: {} };
var hasRequiredRegeneratorValues;
function requireRegeneratorValues() {
  if (hasRequiredRegeneratorValues) return regeneratorValues.exports;
  hasRequiredRegeneratorValues = 1;
  (function(module2) {
    var _typeof2 = require_typeof()["default"];
    function _regeneratorValues2(e) {
      if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r2 = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
          next: function next4() {
            return e && r2 >= e.length && (e = void 0), {
              value: e && e[r2++],
              done: !e
            };
          }
        };
      }
      throw new TypeError(_typeof2(e) + " is not iterable");
    }
    module2.exports = _regeneratorValues2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorValues);
  return regeneratorValues.exports;
}
var hasRequiredRegeneratorRuntime;
function requireRegeneratorRuntime() {
  if (hasRequiredRegeneratorRuntime) return regeneratorRuntime.exports;
  hasRequiredRegeneratorRuntime = 1;
  (function(module2) {
    var OverloadYield2 = requireOverloadYield();
    var regenerator2 = requireRegenerator();
    var regeneratorAsync2 = requireRegeneratorAsync();
    var regeneratorAsyncGen2 = requireRegeneratorAsyncGen();
    var regeneratorAsyncIterator2 = requireRegeneratorAsyncIterator();
    var regeneratorKeys2 = requireRegeneratorKeys();
    var regeneratorValues2 = requireRegeneratorValues();
    function _regeneratorRuntime2() {
      var r2 = regenerator2(), e = r2.m(_regeneratorRuntime2), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
      function n(r3) {
        var e2 = "function" == typeof r3 && r3.constructor;
        return !!e2 && (e2 === t || "GeneratorFunction" === (e2.displayName || e2.name));
      }
      var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
      };
      function a(r3) {
        var e2, t2;
        return function(n2) {
          e2 || (e2 = {
            stop: function stop2() {
              return t2(n2.a, 2);
            },
            "catch": function _catch() {
              return n2.v;
            },
            abrupt: function abrupt(r4, e3) {
              return t2(n2.a, o[r4], e3);
            },
            delegateYield: function delegateYield(r4, o2, a2) {
              return e2.resultName = o2, t2(n2.d, regeneratorValues2(r4), a2);
            },
            finish: function finish(r4) {
              return t2(n2.f, r4);
            }
          }, t2 = function t3(r4, _t, o2) {
            n2.p = e2.prev, n2.n = e2.next;
            try {
              return r4(_t, o2);
            } finally {
              e2.next = n2.n;
            }
          }), e2.resultName && (e2[e2.resultName] = n2.v, e2.resultName = void 0), e2.sent = n2.v, e2.next = n2.n;
          try {
            return r3.call(this, e2);
          } finally {
            n2.p = e2.prev, n2.n = e2.next;
          }
        };
      }
      return (module2.exports = _regeneratorRuntime2 = function _regeneratorRuntime3() {
        return {
          wrap: function wrap(e2, t2, n2, o2) {
            return r2.w(a(e2), t2, n2, o2 && o2.reverse());
          },
          isGeneratorFunction: n,
          mark: r2.m,
          awrap: function awrap(r3, e2) {
            return new OverloadYield2(r3, e2);
          },
          AsyncIterator: regeneratorAsyncIterator2,
          async: function async(r3, e2, t2, o2, u) {
            return (n(e2) ? regeneratorAsyncGen2 : regeneratorAsync2)(a(r3), e2, t2, o2, u);
          },
          keys: regeneratorKeys2,
          values: regeneratorValues2
        };
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports)();
    }
    module2.exports = _regeneratorRuntime2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(regeneratorRuntime);
  return regeneratorRuntime.exports;
}
var asyncToGenerator = { exports: {} };
var hasRequiredAsyncToGenerator;
function requireAsyncToGenerator() {
  if (hasRequiredAsyncToGenerator) return asyncToGenerator.exports;
  hasRequiredAsyncToGenerator = 1;
  (function(module2) {
    function asyncGeneratorStep2(n, t, e, r2, o, a, c) {
      try {
        var i = n[a](c), u = i.value;
      } catch (n2) {
        return void e(n2);
      }
      i.done ? t(u) : Promise.resolve(u).then(r2, o);
    }
    function _asyncToGenerator2(n) {
      return function() {
        var t = this, e = arguments;
        return new Promise(function(r2, o) {
          var a = n.apply(t, e);
          function _next(n2) {
            asyncGeneratorStep2(a, r2, o, _next, _throw, "next", n2);
          }
          function _throw(n2) {
            asyncGeneratorStep2(a, r2, o, _next, _throw, "throw", n2);
          }
          _next(void 0);
        });
      };
    }
    module2.exports = _asyncToGenerator2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(asyncToGenerator);
  return asyncToGenerator.exports;
}
var hasRequiredRender;
function requireRender() {
  if (hasRequiredRender) return render;
  hasRequiredRender = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(render, "__esModule", {
    value: true
  });
  render._r = _r;
  render._u = _u;
  render.render = render$1;
  render.unmount = unmount;
  var _regeneratorRuntime2 = _interopRequireDefault(requireRegeneratorRuntime());
  var _asyncToGenerator2 = _interopRequireDefault(requireAsyncToGenerator());
  var _typeof2 = _interopRequireDefault(require_typeof());
  var _objectSpread22 = _interopRequireDefault(requireObjectSpread2());
  var ReactDOM$1 = _interopRequireWildcard(ReactDOM);
  var fullClone2 = (0, _objectSpread22.default)({}, ReactDOM$1);
  var version2 = fullClone2.version, reactRender = fullClone2.render, unmountComponentAtNode = fullClone2.unmountComponentAtNode;
  var createRoot;
  try {
    var mainVersion = Number((version2 || "").split(".")[0]);
    if (mainVersion >= 18) {
      createRoot = fullClone2.createRoot;
    }
  } catch (e) {
  }
  function toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, _typeof2.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") {
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
    }
  }
  var MARK = "__rc_react_root__";
  function modernRender(node2, container) {
    toggleWarning(true);
    var root = container[MARK] || createRoot(container);
    toggleWarning(false);
    root.render(node2);
    container[MARK] = root;
  }
  function legacyRender(node2, container) {
    reactRender === null || reactRender === void 0 || reactRender(node2, container);
  }
  function _r(node2, container) {
    if (process.env.NODE_ENV !== "production") {
      return legacyRender(node2, container);
    }
  }
  function render$1(node2, container) {
    if (createRoot) {
      modernRender(node2, container);
      return;
    }
    legacyRender(node2, container);
  }
  function modernUnmount(_x) {
    return _modernUnmount.apply(this, arguments);
  }
  function _modernUnmount() {
    _modernUnmount = (0, _asyncToGenerator2.default)(/* @__PURE__ */ (0, _regeneratorRuntime2.default)().mark(function _callee(container) {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve().then(function() {
              var _container$MARK;
              (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
              delete container[MARK];
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _modernUnmount.apply(this, arguments);
  }
  function legacyUnmount(container) {
    unmountComponentAtNode(container);
  }
  function _u(container) {
    if (process.env.NODE_ENV !== "production") {
      return legacyUnmount(container);
    }
  }
  function unmount(_x2) {
    return _unmount.apply(this, arguments);
  }
  function _unmount() {
    _unmount = (0, _asyncToGenerator2.default)(/* @__PURE__ */ (0, _regeneratorRuntime2.default)().mark(function _callee2(container) {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(createRoot !== void 0)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", modernUnmount(container));
          case 2:
            legacyUnmount(container);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _unmount.apply(this, arguments);
  }
  return render;
}
var hasRequiredUnstableContext;
function requireUnstableContext() {
  if (hasRequiredUnstableContext) return UnstableContext;
  hasRequiredUnstableContext = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(UnstableContext, "__esModule", {
    value: true
  });
  UnstableContext.getReactRender = getReactRender;
  UnstableContext.unstableSetRender = unstableSetRender2;
  var React2 = _interopRequireWildcard(React__default);
  var ReactDOM$1 = _interopRequireWildcard(ReactDOM);
  var _render = requireRender();
  var _warning = _interopRequireDefault(/* @__PURE__ */ requireWarning());
  const defaultReactRender = (node2, container) => {
    if (process.env.NODE_ENV !== "production") {
      const majorVersion = parseInt(React2.version.split(".")[0], 10);
      const fullKeys = Object.keys(ReactDOM$1);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(majorVersion < 19 || fullKeys.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.") : void 0;
    }
    (0, _render.render)(node2, container);
    return () => {
      return (0, _render.unmount)(container);
    };
  };
  let unstableRender = defaultReactRender;
  function unstableSetRender2(render2) {
    unstableRender = render2;
  }
  function getReactRender() {
    return unstableRender;
  }
  return UnstableContext;
}
var util$1 = {};
var hasRequiredUtil$1;
function requireUtil$1() {
  if (hasRequiredUtil$1) return util$1;
  hasRequiredUtil$1 = 1;
  Object.defineProperty(util$1, "__esModule", {
    value: true
  });
  util$1.getTargetWaveColor = getTargetWaveColor;
  util$1.isValidWaveColor = isValidWaveColor;
  function isValidWaveColor(color2) {
    return color2 && color2 !== "#fff" && color2 !== "#ffffff" && color2 !== "rgb(255, 255, 255)" && color2 !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(color2) && // any transparent rgba color
    color2 !== "transparent";
  }
  function getTargetWaveColor(node2) {
    const {
      borderTopColor,
      borderColor,
      backgroundColor
    } = getComputedStyle(node2);
    if (isValidWaveColor(borderTopColor)) {
      return borderTopColor;
    }
    if (isValidWaveColor(borderColor)) {
      return borderColor;
    }
    if (isValidWaveColor(backgroundColor)) {
      return backgroundColor;
    }
    return null;
  }
  return util$1;
}
var hasRequiredWaveEffect;
function requireWaveEffect() {
  if (hasRequiredWaveEffect) return WaveEffect;
  hasRequiredWaveEffect = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(WaveEffect, "__esModule", {
    value: true
  });
  WaveEffect.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _rcMotion = _interopRequireDefault(require$$5$1);
  var _raf = _interopRequireDefault(requireRaf());
  var _ref2 = requireRef();
  var _UnstableContext = /* @__PURE__ */ requireUnstableContext();
  var _interface2 = /* @__PURE__ */ require_interface();
  var _util = /* @__PURE__ */ requireUtil$1();
  function validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
  }
  const WaveEffect$1 = (props) => {
    const {
      className,
      target,
      component,
      registerUnmount
    } = props;
    const divRef = React2.useRef(null);
    const unmountRef = React2.useRef(null);
    React2.useEffect(() => {
      unmountRef.current = registerUnmount();
    }, []);
    const [color2, setWaveColor] = React2.useState(null);
    const [borderRadius, setBorderRadius] = React2.useState([]);
    const [left2, setLeft] = React2.useState(0);
    const [top2, setTop] = React2.useState(0);
    const [width, setWidth] = React2.useState(0);
    const [height, setHeight] = React2.useState(0);
    const [enabled, setEnabled] = React2.useState(false);
    const waveStyle = {
      left: left2,
      top: top2,
      width,
      height,
      borderRadius: borderRadius.map((radius) => `${radius}px`).join(" ")
    };
    if (color2) {
      waveStyle["--wave-color"] = color2;
    }
    function syncPos() {
      const nodeStyle = getComputedStyle(target);
      setWaveColor((0, _util.getTargetWaveColor)(target));
      const isStatic = nodeStyle.position === "static";
      const {
        borderLeftWidth,
        borderTopWidth
      } = nodeStyle;
      setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
      setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
      setWidth(target.offsetWidth);
      setHeight(target.offsetHeight);
      const {
        borderTopLeftRadius,
        borderTopRightRadius,
        borderBottomLeftRadius,
        borderBottomRightRadius
      } = nodeStyle;
      setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map((radius) => validateNum(parseFloat(radius))));
    }
    React2.useEffect(() => {
      if (target) {
        const id2 = (0, _raf.default)(() => {
          syncPos();
          setEnabled(true);
        });
        let resizeObserver2;
        if (typeof ResizeObserver !== "undefined") {
          resizeObserver2 = new ResizeObserver(syncPos);
          resizeObserver2.observe(target);
        }
        return () => {
          _raf.default.cancel(id2);
          resizeObserver2 === null || resizeObserver2 === void 0 ? void 0 : resizeObserver2.disconnect();
        };
      }
    }, []);
    if (!enabled) {
      return null;
    }
    const isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains(_interface2.TARGET_CLS));
    return /* @__PURE__ */ React2.createElement(_rcMotion.default, {
      visible: true,
      motionAppear: true,
      motionName: "wave-motion",
      motionDeadline: 5e3,
      onAppearEnd: (_2, event) => {
        var _a2, _b;
        if (event.deadline || event.propertyName === "opacity") {
          const holder = (_a2 = divRef.current) === null || _a2 === void 0 ? void 0 : _a2.parentElement;
          (_b = unmountRef.current) === null || _b === void 0 ? void 0 : _b.call(unmountRef).then(() => {
            holder === null || holder === void 0 ? void 0 : holder.remove();
          });
        }
        return false;
      }
    }, (_ref, ref2) => {
      let {
        className: motionClassName
      } = _ref;
      return /* @__PURE__ */ React2.createElement("div", {
        ref: (0, _ref2.composeRef)(divRef, ref2),
        className: (0, _classnames.default)(className, motionClassName, {
          "wave-quick": isSmallComponent
        }),
        style: waveStyle
      });
    });
  };
  const showWaveEffect = (target, info) => {
    var _a2;
    const {
      component
    } = info;
    if (component === "Checkbox" && !((_a2 = target.querySelector("input")) === null || _a2 === void 0 ? void 0 : _a2.checked)) {
      return;
    }
    const holder = document.createElement("div");
    holder.style.position = "absolute";
    holder.style.left = "0px";
    holder.style.top = "0px";
    target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    const reactRender = (0, _UnstableContext.getReactRender)();
    let unmountCallback = null;
    function registerUnmount() {
      return unmountCallback;
    }
    unmountCallback = reactRender(/* @__PURE__ */ React2.createElement(WaveEffect$1, Object.assign({}, info, {
      target,
      registerUnmount
    })), holder);
  };
  WaveEffect.default = showWaveEffect;
  return WaveEffect;
}
var hasRequiredUseWave;
function requireUseWave() {
  if (hasRequiredUseWave) return useWave;
  hasRequiredUseWave = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useWave, "__esModule", {
    value: true
  });
  useWave.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _useEvent = _interopRequireDefault(requireUseEvent());
  var _raf = _interopRequireDefault(requireRaf());
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _useToken = _interopRequireDefault(/* @__PURE__ */ requireUseToken());
  var _interface2 = /* @__PURE__ */ require_interface();
  var _WaveEffect = _interopRequireDefault(/* @__PURE__ */ requireWaveEffect());
  const useWave$1 = (nodeRef, className, component) => {
    const {
      wave: wave2
    } = React2.useContext(_configProvider.ConfigContext);
    const [, token2, hashId] = (0, _useToken.default)();
    const showWave = (0, _useEvent.default)((event) => {
      const node2 = nodeRef.current;
      if ((wave2 === null || wave2 === void 0 ? void 0 : wave2.disabled) || !node2) {
        return;
      }
      const targetNode = node2.querySelector(`.${_interface2.TARGET_CLS}`) || node2;
      const {
        showEffect
      } = wave2 || {};
      (showEffect || _WaveEffect.default)(targetNode, {
        className,
        token: token2,
        component,
        event,
        hashId
      });
    });
    const rafId = React2.useRef(null);
    const showDebounceWave = (event) => {
      _raf.default.cancel(rafId.current);
      rafId.current = (0, _raf.default)(() => {
        showWave(event);
      });
    };
    return showDebounceWave;
  };
  useWave.default = useWave$1;
  return useWave;
}
var hasRequiredWave;
function requireWave() {
  if (hasRequiredWave) return wave;
  hasRequiredWave = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(wave, "__esModule", {
    value: true
  });
  wave.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _isVisible = _interopRequireDefault(requireIsVisible());
  var _ref = requireRef();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _reactNode = /* @__PURE__ */ requireReactNode();
  var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle$2());
  var _useWave = _interopRequireDefault(/* @__PURE__ */ requireUseWave());
  const Wave = (props) => {
    const {
      children: children2,
      disabled,
      component
    } = props;
    const {
      getPrefixCls
    } = (0, _react.useContext)(_configProvider.ConfigContext);
    const containerRef = (0, _react.useRef)(null);
    const prefixCls = getPrefixCls("wave");
    const [, hashId] = (0, _style.default)(prefixCls);
    const showWave = (0, _useWave.default)(containerRef, (0, _classnames.default)(prefixCls, hashId), component);
    _react.default.useEffect(() => {
      const node2 = containerRef.current;
      if (!node2 || node2.nodeType !== 1 || disabled) {
        return;
      }
      const onClick2 = (e) => {
        if (!(0, _isVisible.default)(e.target) || // No need wave
        !node2.getAttribute || node2.getAttribute("disabled") || node2.disabled || node2.className.includes("disabled") || node2.className.includes("-leave")) {
          return;
        }
        showWave(e);
      };
      node2.addEventListener("click", onClick2, true);
      return () => {
        node2.removeEventListener("click", onClick2, true);
      };
    }, [disabled]);
    if (!/* @__PURE__ */ _react.default.isValidElement(children2)) {
      return children2 !== null && children2 !== void 0 ? children2 : null;
    }
    const ref2 = (0, _ref.supportRef)(children2) ? (0, _ref.composeRef)((0, _ref.getNodeRef)(children2), containerRef) : containerRef;
    return (0, _reactNode.cloneElement)(children2, {
      ref: ref2
    });
  };
  if (process.env.NODE_ENV !== "production") {
    Wave.displayName = "Wave";
  }
  wave.default = Wave;
  return wave;
}
var buttonGroup = {};
var hasRequiredButtonGroup;
function requireButtonGroup() {
  if (hasRequiredButtonGroup) return buttonGroup;
  hasRequiredButtonGroup = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(buttonGroup, "__esModule", {
    value: true
  });
  buttonGroup.default = buttonGroup.GroupSizeContext = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _warning = /* @__PURE__ */ requireWarning();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _internal = /* @__PURE__ */ requireInternal();
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const GroupSizeContext = buttonGroup.GroupSizeContext = /* @__PURE__ */ React2.createContext(void 0);
  const ButtonGroup = (props) => {
    const {
      getPrefixCls,
      direction
    } = React2.useContext(_configProvider.ConfigContext);
    const {
      prefixCls: customizePrefixCls,
      size: size2,
      className
    } = props, others = __rest2(props, ["prefixCls", "size", "className"]);
    const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    const [, , hashId] = (0, _internal.useToken)();
    const sizeCls = React2.useMemo(() => {
      switch (size2) {
        case "large":
          return "lg";
        case "small":
          return "sm";
        default:
          return "";
      }
    }, [size2]);
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Button.Group");
      warning3.deprecated(false, "Button.Group", "Space.Compact");
      process.env.NODE_ENV !== "production" ? warning3(!size2 || ["large", "small", "middle"].includes(size2), "usage", "Invalid prop `size`.") : void 0;
    }
    const classes = (0, _classnames.default)(prefixCls, {
      [`${prefixCls}-${sizeCls}`]: sizeCls,
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId);
    return /* @__PURE__ */ React2.createElement(GroupSizeContext.Provider, {
      value: size2
    }, /* @__PURE__ */ React2.createElement("div", Object.assign({}, others, {
      className: classes
    })));
  };
  buttonGroup.default = ButtonGroup;
  return buttonGroup;
}
var buttonHelpers = {};
var hasRequiredButtonHelpers;
function requireButtonHelpers() {
  if (hasRequiredButtonHelpers) return buttonHelpers;
  hasRequiredButtonHelpers = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(buttonHelpers, "__esModule", {
    value: true
  });
  buttonHelpers._ButtonVariantTypes = buttonHelpers._ButtonColorTypes = void 0;
  buttonHelpers.convertLegacyProps = convertLegacyProps;
  buttonHelpers.isString = isString;
  buttonHelpers.isTwoCNChar = void 0;
  buttonHelpers.isUnBorderedButtonVariant = isUnBorderedButtonVariant;
  buttonHelpers.spaceChildren = spaceChildren;
  var _toConsumableArray2 = _interopRequireDefault(requireToConsumableArray());
  var _react = _interopRequireDefault(React__default);
  var _reactNode = /* @__PURE__ */ requireReactNode();
  var _interface2 = /* @__PURE__ */ require_interface$1();
  const rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
  const isTwoCNChar = buttonHelpers.isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
  function convertLegacyProps(type4) {
    if (type4 === "danger") {
      return {
        danger: true
      };
    }
    return {
      type: type4
    };
  }
  function isString(str) {
    return typeof str === "string";
  }
  function isUnBorderedButtonVariant(type4) {
    return type4 === "text" || type4 === "link";
  }
  function splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === void 0) {
      return;
    }
    const SPACE = needInserted ? " " : "";
    if (typeof child !== "string" && typeof child !== "number" && isString(child.type) && isTwoCNChar(child.props.children)) {
      return (0, _reactNode.cloneElement)(child, {
        children: child.props.children.split("").join(SPACE)
      });
    }
    if (isString(child)) {
      return isTwoCNChar(child) ? /* @__PURE__ */ _react.default.createElement("span", null, child.split("").join(SPACE)) : /* @__PURE__ */ _react.default.createElement("span", null, child);
    }
    if ((0, _reactNode.isFragment)(child)) {
      return /* @__PURE__ */ _react.default.createElement("span", null, child);
    }
    return child;
  }
  function spaceChildren(children2, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    _react.default.Children.forEach(children2, (child) => {
      const type4 = typeof child;
      const isCurrentChildPure = type4 === "string" || type4 === "number";
      if (isPrevChildPure && isCurrentChildPure) {
        const lastIndex = childList.length - 1;
        const lastChild = childList[lastIndex];
        childList[lastIndex] = `${lastChild}${child}`;
      } else {
        childList.push(child);
      }
      isPrevChildPure = isCurrentChildPure;
    });
    return _react.default.Children.map(childList, (child) => splitCNCharsBySpace(child, needInserted));
  }
  buttonHelpers._ButtonVariantTypes = ["outlined", "dashed", "solid", "filled", "text", "link"];
  buttonHelpers._ButtonColorTypes = ["default", "primary", "danger"].concat((0, _toConsumableArray2.default)(_interface2.PresetColors));
  return buttonHelpers;
}
var DefaultLoadingIcon = {};
var LoadingOutlined$2 = { exports: {} };
var LoadingOutlined$1 = {};
var LoadingOutlined = {};
var hasRequiredLoadingOutlined$2;
function requireLoadingOutlined$2() {
  if (hasRequiredLoadingOutlined$2) return LoadingOutlined;
  hasRequiredLoadingOutlined$2 = 1;
  Object.defineProperty(LoadingOutlined, "__esModule", { value: true });
  var LoadingOutlined$12 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
  LoadingOutlined.default = LoadingOutlined$12;
  return LoadingOutlined;
}
var hasRequiredLoadingOutlined$1;
function requireLoadingOutlined$1() {
  if (hasRequiredLoadingOutlined$1) return LoadingOutlined$1;
  hasRequiredLoadingOutlined$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(LoadingOutlined$1, "__esModule", {
    value: true
  });
  LoadingOutlined$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _LoadingOutlined = _interopRequireDefault(/* @__PURE__ */ requireLoadingOutlined$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var LoadingOutlined2 = function LoadingOutlined3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _LoadingOutlined.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(LoadingOutlined2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "LoadingOutlined";
  }
  LoadingOutlined$1.default = RefIcon;
  return LoadingOutlined$1;
}
var hasRequiredLoadingOutlined;
function requireLoadingOutlined() {
  if (hasRequiredLoadingOutlined) return LoadingOutlined$2.exports;
  hasRequiredLoadingOutlined = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _LoadingOutlined = _interopRequireDefault(/* @__PURE__ */ requireLoadingOutlined$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _LoadingOutlined;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(LoadingOutlined$2, LoadingOutlined$2.exports);
  return LoadingOutlined$2.exports;
}
var IconWrapper = {};
var hasRequiredIconWrapper;
function requireIconWrapper() {
  if (hasRequiredIconWrapper) return IconWrapper;
  hasRequiredIconWrapper = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(IconWrapper, "__esModule", {
    value: true
  });
  IconWrapper.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  const IconWrapper$1 = /* @__PURE__ */ (0, _react.forwardRef)((props, ref2) => {
    const {
      className,
      style: style2,
      children: children2,
      prefixCls
    } = props;
    const iconWrapperCls = (0, _classnames.default)(`${prefixCls}-icon`, className);
    return /* @__PURE__ */ _react.default.createElement("span", {
      ref: ref2,
      className: iconWrapperCls,
      style: style2
    }, children2);
  });
  IconWrapper.default = IconWrapper$1;
  return IconWrapper;
}
var hasRequiredDefaultLoadingIcon;
function requireDefaultLoadingIcon() {
  if (hasRequiredDefaultLoadingIcon) return DefaultLoadingIcon;
  hasRequiredDefaultLoadingIcon = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(DefaultLoadingIcon, "__esModule", {
    value: true
  });
  DefaultLoadingIcon.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var _LoadingOutlined = _interopRequireDefault(/* @__PURE__ */ requireLoadingOutlined());
  var _classnames = _interopRequireDefault(requireClassnames());
  var _rcMotion = _interopRequireDefault(require$$5$1);
  var _IconWrapper = _interopRequireDefault(/* @__PURE__ */ requireIconWrapper());
  const InnerLoadingIcon = /* @__PURE__ */ (0, _react.forwardRef)((props, ref2) => {
    const {
      prefixCls,
      className,
      style: style2,
      iconClassName
    } = props;
    const mergedIconCls = (0, _classnames.default)(`${prefixCls}-loading-icon`, className);
    return /* @__PURE__ */ _react.default.createElement(_IconWrapper.default, {
      prefixCls,
      className: mergedIconCls,
      style: style2,
      ref: ref2
    }, /* @__PURE__ */ _react.default.createElement(_LoadingOutlined.default, {
      className: iconClassName
    }));
  });
  const getCollapsedWidth = () => ({
    width: 0,
    opacity: 0,
    transform: "scale(0)"
  });
  const getRealWidth = (node2) => ({
    width: node2.scrollWidth,
    opacity: 1,
    transform: "scale(1)"
  });
  const DefaultLoadingIcon$1 = (props) => {
    const {
      prefixCls,
      loading,
      existIcon,
      className,
      style: style2,
      mount: mount2
    } = props;
    const visible = !!loading;
    if (existIcon) {
      return /* @__PURE__ */ _react.default.createElement(InnerLoadingIcon, {
        prefixCls,
        className,
        style: style2
      });
    }
    return /* @__PURE__ */ _react.default.createElement(_rcMotion.default, {
      visible,
      // Used for minus flex gap style only
      motionName: `${prefixCls}-loading-icon-motion`,
      motionAppear: !mount2,
      motionEnter: !mount2,
      motionLeave: !mount2,
      removeOnLeave: true,
      onAppearStart: getCollapsedWidth,
      onAppearActive: getRealWidth,
      onEnterStart: getCollapsedWidth,
      onEnterActive: getRealWidth,
      onLeaveStart: getRealWidth,
      onLeaveActive: getCollapsedWidth
    }, (_ref, ref2) => {
      let {
        className: motionCls,
        style: motionStyle
      } = _ref;
      const mergedStyle = Object.assign(Object.assign({}, style2), motionStyle);
      return /* @__PURE__ */ _react.default.createElement(InnerLoadingIcon, {
        prefixCls,
        className: (0, _classnames.default)(className, motionCls),
        style: mergedStyle,
        ref: ref2
      });
    });
  };
  DefaultLoadingIcon.default = DefaultLoadingIcon$1;
  return DefaultLoadingIcon;
}
var style$2 = {};
var group = {};
var hasRequiredGroup;
function requireGroup() {
  if (hasRequiredGroup) return group;
  hasRequiredGroup = 1;
  Object.defineProperty(group, "__esModule", {
    value: true
  });
  group.default = void 0;
  const genButtonBorderStyle = (buttonTypeCls, borderColor) => ({
    // Border
    [`> span, > ${buttonTypeCls}`]: {
      "&:not(:last-child)": {
        [`&, & > ${buttonTypeCls}`]: {
          "&:not(:disabled)": {
            borderInlineEndColor: borderColor
          }
        }
      },
      "&:not(:first-child)": {
        [`&, & > ${buttonTypeCls}`]: {
          "&:not(:disabled)": {
            borderInlineStartColor: borderColor
          }
        }
      }
    }
  });
  const genGroupStyle = (token2) => {
    const {
      componentCls,
      fontSize,
      lineWidth,
      groupBorderColor,
      colorErrorHover
    } = token2;
    return {
      [`${componentCls}-group`]: [
        {
          position: "relative",
          display: "inline-flex",
          // Border
          [`> span, > ${componentCls}`]: {
            "&:not(:last-child)": {
              [`&, & > ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            "&:not(:first-child)": {
              marginInlineStart: token2.calc(lineWidth).mul(-1).equal(),
              [`&, & > ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          },
          [componentCls]: {
            position: "relative",
            zIndex: 1,
            "&:hover, &:focus, &:active": {
              zIndex: 2
            },
            "&[disabled]": {
              zIndex: 0
            }
          },
          [`${componentCls}-icon-only`]: {
            fontSize
          }
        },
        // Border Color
        genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
        genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
      ]
    };
  };
  group.default = genGroupStyle;
  return group;
}
var token = {};
var color = {};
var classCallCheck = { exports: {} };
var hasRequiredClassCallCheck;
function requireClassCallCheck() {
  if (hasRequiredClassCallCheck) return classCallCheck.exports;
  hasRequiredClassCallCheck = 1;
  (function(module2) {
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    module2.exports = _classCallCheck2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(classCallCheck);
  return classCallCheck.exports;
}
var createClass = { exports: {} };
var hasRequiredCreateClass;
function requireCreateClass() {
  if (hasRequiredCreateClass) return createClass.exports;
  hasRequiredCreateClass = 1;
  (function(module2) {
    var toPropertyKey2 = requireToPropertyKey();
    function _defineProperties2(e, r2) {
      for (var t = 0; t < r2.length; t++) {
        var o = r2[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r2, t) {
      return r2 && _defineProperties2(e.prototype, r2), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", {
        writable: false
      }), e;
    }
    module2.exports = _createClass2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  })(createClass);
  return createClass.exports;
}
var _excluded$7 = ["b"], _excluded2$2 = ["v"];
var getRoundNumber = function getRoundNumber2(value) {
  return Math.round(Number(value || 0));
};
var convertHsb2Hsv = function convertHsb2Hsv2(color2) {
  if (color2 instanceof FastColor) {
    return color2;
  }
  if (color2 && _typeof$3(color2) === "object" && "h" in color2 && "b" in color2) {
    var _ref = color2, b = _ref.b, resets = _objectWithoutProperties(_ref, _excluded$7);
    return _objectSpread2$1(_objectSpread2$1({}, resets), {}, {
      v: b
    });
  }
  if (typeof color2 === "string" && /hsb/.test(color2)) {
    return color2.replace(/hsb/, "hsv");
  }
  return color2;
};
var Color = /* @__PURE__ */ (function(_FastColor) {
  _inherits(Color2, _FastColor);
  var _super = _createSuper(Color2);
  function Color2(color2) {
    _classCallCheck(this, Color2);
    return _super.call(this, convertHsb2Hsv(color2));
  }
  _createClass(Color2, [{
    key: "toHsbString",
    value: function toHsbString() {
      var hsb = this.toHsb();
      var saturation = getRoundNumber(hsb.s * 100);
      var lightness = getRoundNumber(hsb.b * 100);
      var hue = getRoundNumber(hsb.h);
      var alpha = hsb.a;
      var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
      var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
      return alpha === 1 ? hsbString : hsbaString;
    }
  }, {
    key: "toHsb",
    value: function toHsb() {
      var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = _objectWithoutProperties(_this$toHsv, _excluded2$2);
      return _objectSpread2$1(_objectSpread2$1({}, resets), {}, {
        b: v,
        a: this.a
      });
    }
  }]);
  return Color2;
})(FastColor);
var ColorPickerPrefixCls = "rc-color-picker";
var generateColor = function generateColor2(color2) {
  if (color2 instanceof Color) {
    return color2;
  }
  return new Color(color2);
};
var defaultColor = generateColor("#1677ff");
var calculateColor = function calculateColor2(props) {
  var offset = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color2 = props.color, type4 = props.type;
  var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
  var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
  var centerOffsetX = targetWidth / 2;
  var centerOffsetY = targetHeight / 2;
  var saturation = (offset.x + centerOffsetX) / width;
  var bright = 1 - (offset.y + centerOffsetY) / height;
  var hsb = color2.toHsb();
  var alphaOffset = saturation;
  var hueOffset = (offset.x + centerOffsetX) / width * 360;
  if (type4) {
    switch (type4) {
      case "hue":
        return generateColor(_objectSpread2$1(_objectSpread2$1({}, hsb), {}, {
          h: hueOffset <= 0 ? 0 : hueOffset
        }));
      case "alpha":
        return generateColor(_objectSpread2$1(_objectSpread2$1({}, hsb), {}, {
          a: alphaOffset <= 0 ? 0 : alphaOffset
        }));
    }
  }
  return generateColor({
    h: hsb.h,
    s: saturation <= 0 ? 0 : saturation,
    b: bright >= 1 ? 1 : bright,
    a: hsb.a
  });
};
var calcOffset = function calcOffset2(color2, type4) {
  var hsb = color2.toHsb();
  switch (type4) {
    case "hue":
      return {
        x: hsb.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: color2.a * 100,
        y: 50
      };
    // Picker panel
    default:
      return {
        x: hsb.s * 100,
        y: (1 - hsb.b) * 100
      };
  }
};
var ColorBlock = function ColorBlock2(_ref) {
  var color2 = _ref.color, prefixCls = _ref.prefixCls, className = _ref.className, style2 = _ref.style, onClick2 = _ref.onClick;
  var colorBlockCls = "".concat(prefixCls, "-color-block");
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames(colorBlockCls, className),
    style: style2,
    onClick: onClick2
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(colorBlockCls, "-inner"),
    style: {
      background: color2
    }
  }));
};
function getPosition(e) {
  var obj = "touches" in e ? e.touches[0] : e;
  var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
  var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: obj.pageX - scrollXOffset,
    pageY: obj.pageY - scrollYOffset
  };
}
function useColorDrag(props) {
  var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate = props.calculate, color2 = props.color, disabledDrag = props.disabledDrag;
  var _useState = useState$1({
    x: 0,
    y: 0
  }), _useState2 = _slicedToArray(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
  var mouseMoveRef = useRef(null);
  var mouseUpRef = useRef(null);
  useEffect(function() {
    setOffsetValue(calculate());
  }, [color2]);
  useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", mouseMoveRef.current);
      document.removeEventListener("mouseup", mouseUpRef.current);
      document.removeEventListener("touchmove", mouseMoveRef.current);
      document.removeEventListener("touchend", mouseUpRef.current);
      mouseMoveRef.current = null;
      mouseUpRef.current = null;
    };
  }, []);
  var updateOffset = function updateOffset2(e) {
    var _getPosition3 = getPosition(e), pageX = _getPosition3.pageX, pageY = _getPosition3.pageY;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
    var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
    var calcOffset3 = {
      x: offsetX,
      y: direction === "x" ? offsetValue.y : offsetY
    };
    if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) {
      return false;
    }
    onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset3);
  };
  var onDragMove = function onDragMove2(e) {
    e.preventDefault();
    updateOffset(e);
  };
  var onDragStop = function onDragStop2(e) {
    e.preventDefault();
    document.removeEventListener("mousemove", mouseMoveRef.current);
    document.removeEventListener("mouseup", mouseUpRef.current);
    document.removeEventListener("touchmove", mouseMoveRef.current);
    document.removeEventListener("touchend", mouseUpRef.current);
    mouseMoveRef.current = null;
    mouseUpRef.current = null;
    onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
  };
  var onDragStart2 = function onDragStart3(e) {
    document.removeEventListener("mousemove", mouseMoveRef.current);
    document.removeEventListener("mouseup", mouseUpRef.current);
    if (disabledDrag) {
      return;
    }
    updateOffset(e);
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragStop);
    document.addEventListener("touchmove", onDragMove);
    document.addEventListener("touchend", onDragStop);
    mouseMoveRef.current = onDragMove;
    mouseUpRef.current = onDragStop;
  };
  return [offsetValue, onDragStart2];
}
var Handler = function Handler2(_ref) {
  var _ref$size = _ref.size, size2 = _ref$size === void 0 ? "default" : _ref$size, color2 = _ref.color, prefixCls = _ref.prefixCls;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(prefixCls, "-handler"), _defineProperty$1({}, "".concat(prefixCls, "-handler-sm"), size2 === "small")),
    style: {
      backgroundColor: color2
    }
  });
};
var Palette = function Palette2(_ref) {
  var children2 = _ref.children, style2 = _ref.style, prefixCls = _ref.prefixCls;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-palette"),
    style: _objectSpread2$1({
      position: "relative"
    }, style2)
  }, children2);
};
var Transform = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var children2 = props.children, x = props.x, y = props.y;
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: ref2,
    style: {
      position: "absolute",
      left: "".concat(x, "%"),
      top: "".concat(y, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, children2);
});
var Picker$1 = function Picker(_ref) {
  var color2 = _ref.color, onChange5 = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
  var pickerRef = useRef();
  var transformRef = useRef();
  var colorRef = useRef(color2);
  var onDragChange = useEvent$1(function(offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: pickerRef,
      color: color2
    });
    colorRef.current = calcColor;
    onChange5(calcColor);
  });
  var _useColorDrag = useColorDrag({
    color: color2,
    containerRef: pickerRef,
    targetRef: transformRef,
    calculate: function calculate() {
      return calcOffset(color2);
    },
    onDragChange,
    onDragChangeComplete: function onDragChangeComplete() {
      return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
    },
    disabledDrag: disabled
  }), _useColorDrag2 = _slicedToArray(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: pickerRef,
    className: "".concat(prefixCls, "-select"),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /* @__PURE__ */ React__default.createElement(Palette, {
    prefixCls
  }, /* @__PURE__ */ React__default.createElement(Transform, {
    x: offset.x,
    y: offset.y,
    ref: transformRef
  }, /* @__PURE__ */ React__default.createElement(Handler, {
    color: color2.toRgbString(),
    prefixCls
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(color2.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
};
var useColorState = function useColorState2(defaultValue, value) {
  var _useMergedState = useMergedState$1(defaultValue, {
    value
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
  var color2 = useMemo$2(function() {
    return generateColor(mergedValue);
  }, [mergedValue]);
  return [color2, setValue];
};
var Gradient = function Gradient2(_ref) {
  var colors2 = _ref.colors, children2 = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "to right" : _ref$direction, type4 = _ref.type, prefixCls = _ref.prefixCls;
  var gradientColors = useMemo$2(function() {
    return colors2.map(function(color2, idx) {
      var result = generateColor(color2);
      if (type4 === "alpha" && idx === colors2.length - 1) {
        result = new Color(result.setA(1));
      }
      return result.toRgbString();
    }).join(",");
  }, [colors2, type4]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
    }
  }, children2);
};
var Slider = function Slider2(props) {
  var prefixCls = props.prefixCls, colors2 = props.colors, disabled = props.disabled, onChange5 = props.onChange, onChangeComplete = props.onChangeComplete, color2 = props.color, type4 = props.type;
  var sliderRef = useRef();
  var transformRef = useRef();
  var colorRef = useRef(color2);
  var getValue3 = function getValue4(c) {
    return type4 === "hue" ? c.getHue() : c.a * 100;
  };
  var onDragChange = useEvent$1(function(offsetValue) {
    var calcColor = calculateColor({
      offset: offsetValue,
      targetRef: transformRef,
      containerRef: sliderRef,
      color: color2,
      type: type4
    });
    colorRef.current = calcColor;
    onChange5(getValue3(calcColor));
  });
  var _useColorDrag = useColorDrag({
    color: color2,
    targetRef: transformRef,
    containerRef: sliderRef,
    calculate: function calculate() {
      return calcOffset(color2, type4);
    },
    onDragChange,
    onDragChangeComplete: function onDragChangeComplete() {
      onChangeComplete(getValue3(colorRef.current));
    },
    direction: "x",
    disabledDrag: disabled
  }), _useColorDrag2 = _slicedToArray(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
  var handleColor = React__default.useMemo(function() {
    if (type4 === "hue") {
      var hsb = color2.toHsb();
      hsb.s = 1;
      hsb.b = 1;
      hsb.a = 1;
      var lightColor = new Color(hsb);
      return lightColor;
    }
    return color2;
  }, [color2, type4]);
  var gradientList = React__default.useMemo(function() {
    return colors2.map(function(info) {
      return "".concat(info.color, " ").concat(info.percent, "%");
    });
  }, [colors2]);
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: sliderRef,
    className: classNames("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type4)),
    onMouseDown: dragStartHandle,
    onTouchStart: dragStartHandle
  }, /* @__PURE__ */ React__default.createElement(Palette, {
    prefixCls
  }, /* @__PURE__ */ React__default.createElement(Transform, {
    x: offset.x,
    y: offset.y,
    ref: transformRef
  }, /* @__PURE__ */ React__default.createElement(Handler, {
    size: "small",
    color: handleColor.toHexString(),
    prefixCls
  })), /* @__PURE__ */ React__default.createElement(Gradient, {
    colors: gradientList,
    type: type4,
    prefixCls
  })));
};
function useComponent(components) {
  return React.useMemo(function() {
    var _ref = components || {}, slider = _ref.slider;
    return [slider || Slider];
  }, [components]);
}
var HUE_COLORS = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}];
var ColorPicker = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var value = props.value, defaultValue = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? ColorPickerPrefixCls : _props$prefixCls, onChange5 = props.onChange, onChangeComplete = props.onChangeComplete, className = props.className, style2 = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
  var _useComponent = useComponent(components), _useComponent2 = _slicedToArray(_useComponent, 1), Slider3 = _useComponent2[0];
  var _useColorState = useColorState(defaultValue || defaultColor, value), _useColorState2 = _slicedToArray(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
  var alphaColor = useMemo$2(function() {
    return colorValue.setA(1).toRgbString();
  }, [colorValue]);
  var handleChange = function handleChange2(data2, type4) {
    if (!value) {
      setColorValue(data2);
    }
    onChange5 === null || onChange5 === void 0 || onChange5(data2, type4);
  };
  var getHueColor = function getHueColor2(hue) {
    return new Color(colorValue.setHue(hue));
  };
  var getAlphaColor2 = function getAlphaColor3(alpha) {
    return new Color(colorValue.setA(alpha / 100));
  };
  var onHueChange = function onHueChange2(hue) {
    handleChange(getHueColor(hue), {
      type: "hue",
      value: hue
    });
  };
  var onAlphaChange = function onAlphaChange2(alpha) {
    handleChange(getAlphaColor2(alpha), {
      type: "alpha",
      value: alpha
    });
  };
  var onHueChangeComplete = function onHueChangeComplete2(hue) {
    if (onChangeComplete) {
      onChangeComplete(getHueColor(hue));
    }
  };
  var onAlphaChangeComplete = function onAlphaChangeComplete2(alpha) {
    if (onChangeComplete) {
      onChangeComplete(getAlphaColor2(alpha));
    }
  };
  var mergeCls = classNames("".concat(prefixCls, "-panel"), className, _defineProperty$1({}, "".concat(prefixCls, "-panel-disabled"), disabled));
  var sharedSliderProps = {
    prefixCls,
    disabled,
    color: colorValue
  };
  var defaultPanel = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Picker$1, _extends$6({
    onChange: handleChange
  }, sharedSliderProps, {
    onChangeComplete
  })), /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-slider-container")
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(prefixCls, "-slider-group"), _defineProperty$1({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
  }, /* @__PURE__ */ React__default.createElement(Slider3, _extends$6({}, sharedSliderProps, {
    type: "hue",
    colors: HUE_COLORS,
    min: 0,
    max: 359,
    value: colorValue.getHue(),
    onChange: onHueChange,
    onChangeComplete: onHueChangeComplete
  })), !disabledAlpha && /* @__PURE__ */ React__default.createElement(Slider3, _extends$6({}, sharedSliderProps, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: alphaColor
    }],
    min: 0,
    max: 100,
    value: colorValue.a * 100,
    onChange: onAlphaChange,
    onChangeComplete: onAlphaChangeComplete
  }))), /* @__PURE__ */ React__default.createElement(ColorBlock, {
    color: colorValue.toRgbString(),
    prefixCls
  })));
  return /* @__PURE__ */ React__default.createElement("div", {
    className: mergeCls,
    style: style2,
    ref: ref2
  }, typeof panelRender === "function" ? panelRender(defaultPanel) : defaultPanel);
});
if (process.env.NODE_ENV !== "production") {
  ColorPicker.displayName = "ColorPicker";
}
const es$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Color,
  ColorBlock,
  default: ColorPicker
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(es$2);
var hasRequiredColor;
function requireColor() {
  if (hasRequiredColor) return color;
  hasRequiredColor = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(color, "__esModule", {
    value: true
  });
  color.toHexFormat = color.getHex = color.AggregationColor = void 0;
  var _classCallCheck2 = _interopRequireDefault(requireClassCallCheck());
  var _createClass2 = _interopRequireDefault(requireCreateClass());
  var _colorPicker = require$$3;
  const toHexFormat = (value, alpha) => (value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, "").slice(0, alpha ? 8 : 6)) || "";
  color.toHexFormat = toHexFormat;
  const getHex = (value, alpha) => value ? toHexFormat(value, alpha) : "";
  color.getHex = getHex;
  color.AggregationColor = /* @__PURE__ */ (function() {
    function AggregationColor(color2) {
      (0, _classCallCheck2.default)(this, AggregationColor);
      var _a2;
      this.cleared = false;
      if (color2 instanceof AggregationColor) {
        this.metaColor = color2.metaColor.clone();
        this.colors = (_a2 = color2.colors) === null || _a2 === void 0 ? void 0 : _a2.map((info) => ({
          color: new AggregationColor(info.color),
          percent: info.percent
        }));
        this.cleared = color2.cleared;
        return;
      }
      const isArray = Array.isArray(color2);
      if (isArray && color2.length) {
        this.colors = color2.map((_ref) => {
          let {
            color: c,
            percent
          } = _ref;
          return {
            color: new AggregationColor(c),
            percent
          };
        });
        this.metaColor = new _colorPicker.Color(this.colors[0].color.metaColor);
      } else {
        this.metaColor = new _colorPicker.Color(isArray ? "" : color2);
      }
      if (!color2 || isArray && !this.colors) {
        this.metaColor = this.metaColor.setA(0);
        this.cleared = true;
      }
    }
    return (0, _createClass2.default)(AggregationColor, [{
      key: "toHsb",
      value: function toHsb() {
        return this.metaColor.toHsb();
      }
    }, {
      key: "toHsbString",
      value: function toHsbString() {
        return this.metaColor.toHsbString();
      }
    }, {
      key: "toHex",
      value: function toHex() {
        return getHex(this.toHexString(), this.metaColor.a < 1);
      }
    }, {
      key: "toHexString",
      value: function toHexString() {
        return this.metaColor.toHexString();
      }
    }, {
      key: "toRgb",
      value: function toRgb() {
        return this.metaColor.toRgb();
      }
    }, {
      key: "toRgbString",
      value: function toRgbString() {
        return this.metaColor.toRgbString();
      }
    }, {
      key: "isGradient",
      value: function isGradient() {
        return !!this.colors && !this.cleared;
      }
    }, {
      key: "getColors",
      value: function getColors() {
        return this.colors || [{
          color: this,
          percent: 0
        }];
      }
    }, {
      key: "toCssString",
      value: function toCssString() {
        const {
          colors: colors2
        } = this;
        if (colors2) {
          const colorsStr = colors2.map((c) => `${c.color.toRgbString()} ${c.percent}%`).join(", ");
          return `linear-gradient(90deg, ${colorsStr})`;
        }
        return this.metaColor.toRgbString();
      }
    }, {
      key: "equals",
      value: function equals(color2) {
        if (!color2 || this.isGradient() !== color2.isGradient()) {
          return false;
        }
        if (!this.isGradient()) {
          return this.toHexString() === color2.toHexString();
        }
        return this.colors.length === color2.colors.length && this.colors.every((c, i) => {
          const target = color2.colors[i];
          return c.percent === target.percent && c.color.equals(target.color);
        });
      }
    }]);
  })();
  return color;
}
var ColorPresets = {};
var useMergedState = {};
var useLayoutEffect2 = {};
var hasRequiredUseLayoutEffect;
function requireUseLayoutEffect() {
  if (hasRequiredUseLayoutEffect) return useLayoutEffect2;
  hasRequiredUseLayoutEffect = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(useLayoutEffect2, "__esModule", {
    value: true
  });
  useLayoutEffect2.useLayoutUpdateEffect = useLayoutEffect2.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _canUseDom = _interopRequireDefault(requireCanUseDom());
  var useInternalLayoutEffect2 = process.env.NODE_ENV !== "test" && (0, _canUseDom.default)() ? React2.useLayoutEffect : React2.useEffect;
  var useLayoutEffect$12 = function useLayoutEffect3(callback, deps) {
    var firstMountRef = React2.useRef(true);
    useInternalLayoutEffect2(function() {
      return callback(firstMountRef.current);
    }, deps);
    useInternalLayoutEffect2(function() {
      firstMountRef.current = false;
      return function() {
        firstMountRef.current = true;
      };
    }, []);
  };
  useLayoutEffect2.useLayoutUpdateEffect = function useLayoutUpdateEffect3(callback, deps) {
    useLayoutEffect$12(function(firstMount) {
      if (!firstMount) {
        return callback();
      }
    }, deps);
  };
  useLayoutEffect2.default = useLayoutEffect$12;
  return useLayoutEffect2;
}
var useState = {};
var hasRequiredUseState;
function requireUseState() {
  if (hasRequiredUseState) return useState;
  hasRequiredUseState = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useState, "__esModule", {
    value: true
  });
  useState.default = useSafeState2;
  var _slicedToArray2 = _interopRequireDefault(requireSlicedToArray());
  var React2 = _interopRequireWildcard(React__default);
  function useSafeState2(defaultValue) {
    var destroyRef = React2.useRef(false);
    var _React$useState = React2.useState(defaultValue), _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    React2.useEffect(function() {
      destroyRef.current = false;
      return function() {
        destroyRef.current = true;
      };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
      if (ignoreDestroy && destroyRef.current) {
        return;
      }
      setValue(updater);
    }
    return [value, safeSetState];
  }
  return useState;
}
var hasRequiredUseMergedState;
function requireUseMergedState() {
  if (hasRequiredUseMergedState) return useMergedState;
  hasRequiredUseMergedState = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(useMergedState, "__esModule", {
    value: true
  });
  useMergedState.default = useMergedState$12;
  var _slicedToArray2 = _interopRequireDefault(requireSlicedToArray());
  var _useEvent = _interopRequireDefault(requireUseEvent());
  var _useLayoutEffect = requireUseLayoutEffect();
  var _useState5 = _interopRequireDefault(requireUseState());
  function hasValue2(value) {
    return value !== void 0;
  }
  function useMergedState$12(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange5 = _ref.onChange, postState = _ref.postState;
    var _useState = (0, _useState5.default)(function() {
      if (hasValue2(value)) {
        return value;
      } else if (hasValue2(defaultValue)) {
        return typeof defaultValue === "function" ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
      }
    }), _useState2 = (0, _slicedToArray2.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== void 0 ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    var onChangeFn = (0, _useEvent.default)(onChange5);
    var _useState3 = (0, _useState5.default)([mergedValue]), _useState4 = (0, _slicedToArray2.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
      var prev4 = prevValue[0];
      if (innerValue !== prev4) {
        onChangeFn(innerValue, prev4);
      }
    }, [prevValue]);
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
      if (!hasValue2(value)) {
        setInnerValue(value);
      }
    }, [value]);
    var triggerChange = (0, _useEvent.default)(function(updater, ignoreDestroy) {
      setInnerValue(updater, ignoreDestroy);
      setPrevValue([mergedValue], ignoreDestroy);
    });
    return [postMergedValue, triggerChange];
  }
  return useMergedState;
}
var collapse$1 = {};
var Collapse$2 = {};
var RightOutlined$2 = { exports: {} };
var RightOutlined$1 = {};
var RightOutlined = {};
var hasRequiredRightOutlined$2;
function requireRightOutlined$2() {
  if (hasRequiredRightOutlined$2) return RightOutlined;
  hasRequiredRightOutlined$2 = 1;
  Object.defineProperty(RightOutlined, "__esModule", { value: true });
  var RightOutlined$12 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
  RightOutlined.default = RightOutlined$12;
  return RightOutlined;
}
var hasRequiredRightOutlined$1;
function requireRightOutlined$1() {
  if (hasRequiredRightOutlined$1) return RightOutlined$1;
  hasRequiredRightOutlined$1 = 1;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(RightOutlined$1, "__esModule", {
    value: true
  });
  RightOutlined$1.default = void 0;
  var _extends2 = _interopRequireDefault(require_extends());
  var React2 = _interopRequireWildcard(React__default);
  var _RightOutlined = _interopRequireDefault(/* @__PURE__ */ requireRightOutlined$2());
  var _AntdIcon = _interopRequireDefault(/* @__PURE__ */ requireAntdIcon());
  var RightOutlined2 = function RightOutlined3(props, ref2) {
    return /* @__PURE__ */ React2.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
      ref: ref2,
      icon: _RightOutlined.default
    }));
  };
  var RefIcon = /* @__PURE__ */ React2.forwardRef(RightOutlined2);
  if (process.env.NODE_ENV !== "production") {
    RefIcon.displayName = "RightOutlined";
  }
  RightOutlined$1.default = RefIcon;
  return RightOutlined$1;
}
var hasRequiredRightOutlined;
function requireRightOutlined() {
  if (hasRequiredRightOutlined) return RightOutlined$2.exports;
  hasRequiredRightOutlined = 1;
  (function(module2, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    const _RightOutlined = _interopRequireDefault(/* @__PURE__ */ requireRightOutlined$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    const _default2 = _RightOutlined;
    exports$1.default = _default2;
    module2.exports = _default2;
  })(RightOutlined$2, RightOutlined$2.exports);
  return RightOutlined$2.exports;
}
var KeyCode = {
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13
};
var PanelContent = /* @__PURE__ */ React__default.forwardRef(function(props, ref2) {
  var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style2 = props.style, children2 = props.children, isActive2 = props.isActive, role = props.role, customizeClassNames = props.classNames, styles2 = props.styles;
  var _React$useState = React__default.useState(isActive2 || forceRender), _React$useState2 = _slicedToArray$1(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
  React__default.useEffect(function() {
    if (forceRender || isActive2) {
      setRendered(true);
    }
  }, [forceRender, isActive2]);
  if (!rendered) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: ref2,
    className: classNames("".concat(prefixCls, "-content"), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-content-active"), isActive2), "".concat(prefixCls, "-content-inactive"), !isActive2), className),
    style: style2,
    role
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classNames("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
    style: styles2 === null || styles2 === void 0 ? void 0 : styles2.body
  }, children2));
});
PanelContent.displayName = "PanelContent";
var _excluded$6 = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "classNames", "styles", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"];
var CollapsePanel$1 = /* @__PURE__ */ React__default.forwardRef(function(props, ref2) {
  var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive2 = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles2 = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children2 = props.children, resetProps = _objectWithoutProperties$1(props, _excluded$6);
  var disabled = collapsible === "disabled";
  var ifExtraExist = extra !== null && extra !== void 0 && typeof extra !== "boolean";
  var collapsibleProps = _defineProperty(_defineProperty(_defineProperty({
    onClick: function onClick2() {
      onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.keyCode === KeyCode.ENTER || e.which === KeyCode.ENTER) {
        onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
      }
    },
    role: accordion ? "tab" : "button"
  }, "aria-expanded", isActive2), "aria-disabled", disabled), "tabIndex", disabled ? -1 : 0);
  var iconNodeInner = typeof expandIcon === "function" ? expandIcon(props) : /* @__PURE__ */ React__default.createElement("i", {
    className: "arrow"
  });
  var iconNode = iconNodeInner && /* @__PURE__ */ React__default.createElement("div", _extends$4({
    className: "".concat(prefixCls, "-expand-icon")
  }, ["header", "icon"].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
  var collapsePanelClassNames = classNames("".concat(prefixCls, "-item"), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-item-active"), isActive2), "".concat(prefixCls, "-item-disabled"), disabled), className);
  var headerClassName = classNames(headerClass, "".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
  var headerProps = _objectSpread2({
    className: headerClassName,
    style: styles2.header
  }, ["header", "icon"].includes(collapsible) ? {} : collapsibleProps);
  return /* @__PURE__ */ React__default.createElement("div", _extends$4({}, resetProps, {
    ref: ref2,
    className: collapsePanelClassNames
  }), /* @__PURE__ */ React__default.createElement("div", headerProps, showArrow && iconNode, /* @__PURE__ */ React__default.createElement("span", _extends$4({
    className: "".concat(prefixCls, "-header-text")
  }, collapsible === "header" ? collapsibleProps : {}), header), ifExtraExist && /* @__PURE__ */ React__default.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra)), /* @__PURE__ */ React__default.createElement(CSSMotion, _extends$4({
    visible: isActive2,
    leavedClassName: "".concat(prefixCls, "-content-hidden")
  }, openMotion, {
    forceRender,
    removeOnLeave: destroyInactivePanel
  }), function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React__default.createElement(PanelContent, {
      ref: motionRef,
      prefixCls,
      className: motionClassName,
      classNames: customizeClassNames,
      style: motionStyle,
      styles: styles2,
      isActive: isActive2,
      forceRender,
      role: accordion ? "tabpanel" : void 0
    }, children2);
  }));
});
var _excluded$5 = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"];
var convertItemsToNodes = function convertItemsToNodes2(items, props) {
  var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
  return items.map(function(item2, index2) {
    var children2 = item2.children, label = item2.label, rawKey = item2.key, rawCollapsible = item2.collapsible, rawOnItemClick = item2.onItemClick, rawDestroyInactivePanel = item2.destroyInactivePanel, restProps = _objectWithoutProperties$1(item2, _excluded$5);
    var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index2);
    var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
    var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
    var handleItemClick = function handleItemClick2(value) {
      if (mergeCollapsible === "disabled") return;
      onItemClick(value);
      rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
    };
    var isActive2 = false;
    if (accordion) {
      isActive2 = activeKey[0] === key;
    } else {
      isActive2 = activeKey.indexOf(key) > -1;
    }
    return /* @__PURE__ */ React__default.createElement(CollapsePanel$1, _extends$4({}, restProps, {
      prefixCls,
      key,
      panelKey: key,
      isActive: isActive2,
      accordion,
      openMotion,
      expandIcon,
      header: label,
      collapsible: mergeCollapsible,
      onItemClick: handleItemClick,
      destroyInactivePanel: mergeDestroyInactivePanel
    }), children2);
  });
};
var getNewChild = function getNewChild2(child, index2, props) {
  if (!child) return null;
  var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
  var key = child.key || String(index2);
  var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
  var isActive2 = false;
  if (accordion) {
    isActive2 = activeKey[0] === key;
  } else {
    isActive2 = activeKey.indexOf(key) > -1;
  }
  var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
  var handleItemClick = function handleItemClick2(value) {
    if (mergeCollapsible === "disabled") return;
    onItemClick(value);
    childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
  };
  var childProps = {
    key,
    panelKey: key,
    header,
    headerClass,
    isActive: isActive2,
    prefixCls,
    destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
    openMotion,
    accordion,
    children: child.props.children,
    onItemClick: handleItemClick,
    expandIcon,
    collapsible: mergeCollapsible
  };
  if (typeof child.type === "string") {
    return child;
  }
  Object.keys(childProps).forEach(function(propName) {
    if (typeof childProps[propName] === "undefined") {
      delete childProps[propName];
    }
  });
  return /* @__PURE__ */ React__default.cloneElement(child, childProps);
};
function useItems(items, rawChildren, props) {
  if (Array.isArray(items)) {
    return convertItemsToNodes(items, props);
  }
  return toArray$2(rawChildren).map(function(child, index2) {
    return getNewChild(child, index2, props);
  });
}
var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match(key, prefix2) {
  return key.indexOf(prefix2) === 0;
}
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread2$1({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function(key) {
    if (
      // Aria
      mergedConfig.aria && (key === "role" || match(key, ariaPrefix)) || // Data
      mergedConfig.data && match(key, dataPrefix) || // Attr
      mergedConfig.attr && propList.includes(key)
    ) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}
function getActiveKeysArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    var activeKeyType = _typeof$1(currentActiveKey);
    currentActiveKey = activeKeyType === "number" || activeKeyType === "string" ? [currentActiveKey] : [];
  }
  return currentActiveKey.map(function(key) {
    return String(key);
  });
}
var Collapse = /* @__PURE__ */ React__default.forwardRef(function(props, ref2) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-collapse" : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style2 = props.style, accordion = props.accordion, className = props.className, children2 = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
  var collapseClassName = classNames(prefixCls, className);
  var _useMergedState = useMergedState$1([], {
    value: rawActiveKey,
    onChange: function onChange5(v) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
    },
    defaultValue: defaultActiveKey,
    postState: getActiveKeysArray
  }), _useMergedState2 = _slicedToArray$1(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
  var onItemClick = function onItemClick2(key) {
    return setActiveKey(function() {
      if (accordion) {
        return activeKey[0] === key ? [] : [key];
      }
      var index2 = activeKey.indexOf(key);
      var isActive2 = index2 > -1;
      if (isActive2) {
        return activeKey.filter(function(item2) {
          return item2 !== key;
        });
      }
      return [].concat(_toConsumableArray$1(activeKey), [key]);
    });
  };
  warningOnce(!children2, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var mergedChildren = useItems(items, children2, {
    prefixCls,
    accordion,
    openMotion,
    expandIcon,
    collapsible,
    destroyInactivePanel,
    onItemClick,
    activeKey
  });
  return /* @__PURE__ */ React__default.createElement("div", _extends$4({
    ref: ref2,
    className: collapseClassName,
    style: style2,
    role: accordion ? "tablist" : void 0
  }, pickAttrs(props, {
    aria: true,
    data: true
  })), mergedChildren);
});
const Collapse$1 = Object.assign(Collapse, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: CollapsePanel$1
});
var Panel = Collapse$1.Panel;
const es$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Panel,
  default: Collapse$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$5 = /* @__PURE__ */ getAugmentedNamespace(es$1);
var motion$2 = {};
var hasRequiredMotion$2;
function requireMotion$2() {
  if (hasRequiredMotion$2) return motion$2;
  hasRequiredMotion$2 = 1;
  Object.defineProperty(motion$2, "__esModule", {
    value: true
  });
  motion$2.getTransitionName = motion$2.default = void 0;
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  const getCollapsedHeight = () => ({
    height: 0,
    opacity: 0
  });
  const getRealHeight = (node2) => {
    const {
      scrollHeight
    } = node2;
    return {
      height: scrollHeight,
      opacity: 1
    };
  };
  const getCurrentHeight = (node2) => ({
    height: node2 ? node2.offsetHeight : 0
  });
  const skipOpacityTransition = (_2, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
  const initCollapseMotion = function() {
    let rootCls = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _configProvider.defaultPrefixCls;
    return {
      motionName: `${rootCls}-motion-collapse`,
      onAppearStart: getCollapsedHeight,
      onEnterStart: getCollapsedHeight,
      onAppearActive: getRealHeight,
      onEnterActive: getRealHeight,
      onLeaveStart: getCurrentHeight,
      onLeaveActive: getCollapsedHeight,
      onAppearEnd: skipOpacityTransition,
      onEnterEnd: skipOpacityTransition,
      onLeaveEnd: skipOpacityTransition,
      motionDeadline: 500
    };
  };
  const getTransitionName2 = (rootPrefixCls, motion2, transitionName) => {
    if (transitionName !== void 0) {
      return transitionName;
    }
    return `${rootPrefixCls}-${motion2}`;
  };
  motion$2.getTransitionName = getTransitionName2;
  motion$2.default = initCollapseMotion;
  return motion$2;
}
var CollapsePanel = {};
var hasRequiredCollapsePanel;
function requireCollapsePanel() {
  if (hasRequiredCollapsePanel) return CollapsePanel;
  hasRequiredCollapsePanel = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(CollapsePanel, "__esModule", {
    value: true
  });
  CollapsePanel.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _rcCollapse = _interopRequireDefault(require$$5);
  var _warning = /* @__PURE__ */ requireWarning();
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  const CollapsePanel$12 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Collapse.Panel");
      warning3.deprecated(!("disabled" in props), "disabled", 'collapsible="disabled"');
    }
    const {
      getPrefixCls
    } = React2.useContext(_configProvider.ConfigContext);
    const {
      prefixCls: customizePrefixCls,
      className,
      showArrow = true
    } = props;
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const collapsePanelClassName = (0, _classnames.default)({
      [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /* @__PURE__ */ React2.createElement(_rcCollapse.default.Panel, Object.assign({
      ref: ref2
    }, props, {
      prefixCls,
      className: collapsePanelClassName
    }));
  });
  CollapsePanel.default = CollapsePanel$12;
  return CollapsePanel;
}
var style$1 = {};
var motion$1 = {};
var collapse = {};
var hasRequiredCollapse$2;
function requireCollapse$2() {
  if (hasRequiredCollapse$2) return collapse;
  hasRequiredCollapse$2 = 1;
  Object.defineProperty(collapse, "__esModule", {
    value: true
  });
  collapse.default = void 0;
  const genCollapseMotion = (token2) => ({
    [token2.componentCls]: {
      // For common/openAnimation
      [`${token2.antCls}-motion-collapse-legacy`]: {
        overflow: "hidden",
        "&-active": {
          transition: `height ${token2.motionDurationMid} ${token2.motionEaseInOut},
        opacity ${token2.motionDurationMid} ${token2.motionEaseInOut} !important`
        }
      },
      [`${token2.antCls}-motion-collapse`]: {
        overflow: "hidden",
        transition: `height ${token2.motionDurationMid} ${token2.motionEaseInOut},
        opacity ${token2.motionDurationMid} ${token2.motionEaseInOut} !important`
      }
    }
  });
  collapse.default = genCollapseMotion;
  return collapse;
}
var fade = {};
var motion = {};
var hasRequiredMotion$1;
function requireMotion$1() {
  if (hasRequiredMotion$1) return motion;
  hasRequiredMotion$1 = 1;
  Object.defineProperty(motion, "__esModule", {
    value: true
  });
  motion.initMotion = void 0;
  const initMotionCommon = (duration) => ({
    animationDuration: duration,
    animationFillMode: "both"
  });
  const initMotionCommonLeave = (duration) => ({
    animationDuration: duration,
    animationFillMode: "both"
  });
  const initMotion = function(motionCls, inKeyframes, outKeyframes, duration) {
    let sameLevel = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return {
      [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
        animationPlayState: "paused"
      }),
      [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
        animationPlayState: "paused"
      }),
      [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
        animationName: inKeyframes,
        animationPlayState: "running"
      },
      [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
        animationName: outKeyframes,
        animationPlayState: "running",
        pointerEvents: "none"
      }
    };
  };
  motion.initMotion = initMotion;
  return motion;
}
var hasRequiredFade;
function requireFade() {
  if (hasRequiredFade) return fade;
  hasRequiredFade = 1;
  Object.defineProperty(fade, "__esModule", {
    value: true
  });
  fade.initFadeMotion = fade.fadeOut = fade.fadeIn = void 0;
  var _cssinjs = require$$2$2;
  var _motion = /* @__PURE__ */ requireMotion$1();
  const fadeIn = fade.fadeIn = new _cssinjs.Keyframes("antFadeIn", {
    "0%": {
      opacity: 0
    },
    "100%": {
      opacity: 1
    }
  });
  const fadeOut = fade.fadeOut = new _cssinjs.Keyframes("antFadeOut", {
    "0%": {
      opacity: 1
    },
    "100%": {
      opacity: 0
    }
  });
  const initFadeMotion = function(token2) {
    let sameLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const {
      antCls
    } = token2;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return [(0, _motion.initMotion)(motionCls, fadeIn, fadeOut, token2.motionDurationMid, sameLevel), {
      [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
        opacity: 0,
        animationTimingFunction: "linear"
      },
      [`${sameLevelPrefix}${motionCls}-leave`]: {
        animationTimingFunction: "linear"
      }
    }];
  };
  fade.initFadeMotion = initFadeMotion;
  return fade;
}
var move = {};
var hasRequiredMove;
function requireMove() {
  if (hasRequiredMove) return move;
  hasRequiredMove = 1;
  Object.defineProperty(move, "__esModule", {
    value: true
  });
  move.moveUpOut = move.moveUpIn = move.moveRightOut = move.moveRightIn = move.moveLeftOut = move.moveLeftIn = move.moveDownOut = move.moveDownIn = move.initMoveMotion = void 0;
  var _cssinjs = require$$2$2;
  var _motion = /* @__PURE__ */ requireMotion$1();
  const moveDownIn = move.moveDownIn = new _cssinjs.Keyframes("antMoveDownIn", {
    "0%": {
      transform: "translate3d(0, 100%, 0)",
      transformOrigin: "0 0",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    }
  });
  const moveDownOut = move.moveDownOut = new _cssinjs.Keyframes("antMoveDownOut", {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    },
    "100%": {
      transform: "translate3d(0, 100%, 0)",
      transformOrigin: "0 0",
      opacity: 0
    }
  });
  const moveLeftIn = move.moveLeftIn = new _cssinjs.Keyframes("antMoveLeftIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      transformOrigin: "0 0",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    }
  });
  const moveLeftOut = move.moveLeftOut = new _cssinjs.Keyframes("antMoveLeftOut", {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    },
    "100%": {
      transform: "translate3d(-100%, 0, 0)",
      transformOrigin: "0 0",
      opacity: 0
    }
  });
  const moveRightIn = move.moveRightIn = new _cssinjs.Keyframes("antMoveRightIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      transformOrigin: "0 0",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    }
  });
  const moveRightOut = move.moveRightOut = new _cssinjs.Keyframes("antMoveRightOut", {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    },
    "100%": {
      transform: "translate3d(100%, 0, 0)",
      transformOrigin: "0 0",
      opacity: 0
    }
  });
  const moveUpIn = move.moveUpIn = new _cssinjs.Keyframes("antMoveUpIn", {
    "0%": {
      transform: "translate3d(0, -100%, 0)",
      transformOrigin: "0 0",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    }
  });
  const moveUpOut = move.moveUpOut = new _cssinjs.Keyframes("antMoveUpOut", {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      transformOrigin: "0 0",
      opacity: 1
    },
    "100%": {
      transform: "translate3d(0, -100%, 0)",
      transformOrigin: "0 0",
      opacity: 0
    }
  });
  const moveMotion = {
    "move-up": {
      inKeyframes: moveUpIn,
      outKeyframes: moveUpOut
    },
    "move-down": {
      inKeyframes: moveDownIn,
      outKeyframes: moveDownOut
    },
    "move-left": {
      inKeyframes: moveLeftIn,
      outKeyframes: moveLeftOut
    },
    "move-right": {
      inKeyframes: moveRightIn,
      outKeyframes: moveRightOut
    }
  };
  const initMoveMotion = (token2, motionName) => {
    const {
      antCls
    } = token2;
    const motionCls = `${antCls}-${motionName}`;
    const {
      inKeyframes,
      outKeyframes
    } = moveMotion[motionName];
    return [(0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
      [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
        opacity: 0,
        animationTimingFunction: token2.motionEaseOutCirc
      },
      [`${motionCls}-leave`]: {
        animationTimingFunction: token2.motionEaseInOutCirc
      }
    }];
  };
  move.initMoveMotion = initMoveMotion;
  return move;
}
var slide = {};
var hasRequiredSlide;
function requireSlide() {
  if (hasRequiredSlide) return slide;
  hasRequiredSlide = 1;
  Object.defineProperty(slide, "__esModule", {
    value: true
  });
  slide.slideUpOut = slide.slideUpIn = slide.slideRightOut = slide.slideRightIn = slide.slideLeftOut = slide.slideLeftIn = slide.slideDownOut = slide.slideDownIn = slide.initSlideMotion = void 0;
  var _cssinjs = require$$2$2;
  var _motion = /* @__PURE__ */ requireMotion$1();
  const slideUpIn = slide.slideUpIn = new _cssinjs.Keyframes("antSlideUpIn", {
    "0%": {
      transform: "scaleY(0.8)",
      transformOrigin: "0% 0%",
      opacity: 0
    },
    "100%": {
      transform: "scaleY(1)",
      transformOrigin: "0% 0%",
      opacity: 1
    }
  });
  const slideUpOut = slide.slideUpOut = new _cssinjs.Keyframes("antSlideUpOut", {
    "0%": {
      transform: "scaleY(1)",
      transformOrigin: "0% 0%",
      opacity: 1
    },
    "100%": {
      transform: "scaleY(0.8)",
      transformOrigin: "0% 0%",
      opacity: 0
    }
  });
  const slideDownIn = slide.slideDownIn = new _cssinjs.Keyframes("antSlideDownIn", {
    "0%": {
      transform: "scaleY(0.8)",
      transformOrigin: "100% 100%",
      opacity: 0
    },
    "100%": {
      transform: "scaleY(1)",
      transformOrigin: "100% 100%",
      opacity: 1
    }
  });
  const slideDownOut = slide.slideDownOut = new _cssinjs.Keyframes("antSlideDownOut", {
    "0%": {
      transform: "scaleY(1)",
      transformOrigin: "100% 100%",
      opacity: 1
    },
    "100%": {
      transform: "scaleY(0.8)",
      transformOrigin: "100% 100%",
      opacity: 0
    }
  });
  const slideLeftIn = slide.slideLeftIn = new _cssinjs.Keyframes("antSlideLeftIn", {
    "0%": {
      transform: "scaleX(0.8)",
      transformOrigin: "0% 0%",
      opacity: 0
    },
    "100%": {
      transform: "scaleX(1)",
      transformOrigin: "0% 0%",
      opacity: 1
    }
  });
  const slideLeftOut = slide.slideLeftOut = new _cssinjs.Keyframes("antSlideLeftOut", {
    "0%": {
      transform: "scaleX(1)",
      transformOrigin: "0% 0%",
      opacity: 1
    },
    "100%": {
      transform: "scaleX(0.8)",
      transformOrigin: "0% 0%",
      opacity: 0
    }
  });
  const slideRightIn = slide.slideRightIn = new _cssinjs.Keyframes("antSlideRightIn", {
    "0%": {
      transform: "scaleX(0.8)",
      transformOrigin: "100% 0%",
      opacity: 0
    },
    "100%": {
      transform: "scaleX(1)",
      transformOrigin: "100% 0%",
      opacity: 1
    }
  });
  const slideRightOut = slide.slideRightOut = new _cssinjs.Keyframes("antSlideRightOut", {
    "0%": {
      transform: "scaleX(1)",
      transformOrigin: "100% 0%",
      opacity: 1
    },
    "100%": {
      transform: "scaleX(0.8)",
      transformOrigin: "100% 0%",
      opacity: 0
    }
  });
  const slideMotion = {
    "slide-up": {
      inKeyframes: slideUpIn,
      outKeyframes: slideUpOut
    },
    "slide-down": {
      inKeyframes: slideDownIn,
      outKeyframes: slideDownOut
    },
    "slide-left": {
      inKeyframes: slideLeftIn,
      outKeyframes: slideLeftOut
    },
    "slide-right": {
      inKeyframes: slideRightIn,
      outKeyframes: slideRightOut
    }
  };
  const initSlideMotion = (token2, motionName) => {
    const {
      antCls
    } = token2;
    const motionCls = `${antCls}-${motionName}`;
    const {
      inKeyframes,
      outKeyframes
    } = slideMotion[motionName];
    return [(0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
      [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
        transform: "scale(0)",
        transformOrigin: "0% 0%",
        opacity: 0,
        animationTimingFunction: token2.motionEaseOutQuint,
        "&-prepare": {
          transform: "scale(1)"
        }
      },
      [`${motionCls}-leave`]: {
        animationTimingFunction: token2.motionEaseInQuint
      }
    }];
  };
  slide.initSlideMotion = initSlideMotion;
  return slide;
}
var zoom = {};
var hasRequiredZoom;
function requireZoom() {
  if (hasRequiredZoom) return zoom;
  hasRequiredZoom = 1;
  Object.defineProperty(zoom, "__esModule", {
    value: true
  });
  zoom.zoomUpOut = zoom.zoomUpIn = zoom.zoomRightOut = zoom.zoomRightIn = zoom.zoomOut = zoom.zoomLeftOut = zoom.zoomLeftIn = zoom.zoomIn = zoom.zoomDownOut = zoom.zoomDownIn = zoom.zoomBigOut = zoom.zoomBigIn = zoom.initZoomMotion = void 0;
  var _cssinjs = require$$2$2;
  var _motion = /* @__PURE__ */ requireMotion$1();
  const zoomIn = zoom.zoomIn = new _cssinjs.Keyframes("antZoomIn", {
    "0%": {
      transform: "scale(0.2)",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1
    }
  });
  const zoomOut = zoom.zoomOut = new _cssinjs.Keyframes("antZoomOut", {
    "0%": {
      transform: "scale(1)"
    },
    "100%": {
      transform: "scale(0.2)",
      opacity: 0
    }
  });
  const zoomBigIn = zoom.zoomBigIn = new _cssinjs.Keyframes("antZoomBigIn", {
    "0%": {
      transform: "scale(0.8)",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1
    }
  });
  const zoomBigOut = zoom.zoomBigOut = new _cssinjs.Keyframes("antZoomBigOut", {
    "0%": {
      transform: "scale(1)"
    },
    "100%": {
      transform: "scale(0.8)",
      opacity: 0
    }
  });
  const zoomUpIn = zoom.zoomUpIn = new _cssinjs.Keyframes("antZoomUpIn", {
    "0%": {
      transform: "scale(0.8)",
      transformOrigin: "50% 0%",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      transformOrigin: "50% 0%"
    }
  });
  const zoomUpOut = zoom.zoomUpOut = new _cssinjs.Keyframes("antZoomUpOut", {
    "0%": {
      transform: "scale(1)",
      transformOrigin: "50% 0%"
    },
    "100%": {
      transform: "scale(0.8)",
      transformOrigin: "50% 0%",
      opacity: 0
    }
  });
  const zoomLeftIn = zoom.zoomLeftIn = new _cssinjs.Keyframes("antZoomLeftIn", {
    "0%": {
      transform: "scale(0.8)",
      transformOrigin: "0% 50%",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      transformOrigin: "0% 50%"
    }
  });
  const zoomLeftOut = zoom.zoomLeftOut = new _cssinjs.Keyframes("antZoomLeftOut", {
    "0%": {
      transform: "scale(1)",
      transformOrigin: "0% 50%"
    },
    "100%": {
      transform: "scale(0.8)",
      transformOrigin: "0% 50%",
      opacity: 0
    }
  });
  const zoomRightIn = zoom.zoomRightIn = new _cssinjs.Keyframes("antZoomRightIn", {
    "0%": {
      transform: "scale(0.8)",
      transformOrigin: "100% 50%",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      transformOrigin: "100% 50%"
    }
  });
  const zoomRightOut = zoom.zoomRightOut = new _cssinjs.Keyframes("antZoomRightOut", {
    "0%": {
      transform: "scale(1)",
      transformOrigin: "100% 50%"
    },
    "100%": {
      transform: "scale(0.8)",
      transformOrigin: "100% 50%",
      opacity: 0
    }
  });
  const zoomDownIn = zoom.zoomDownIn = new _cssinjs.Keyframes("antZoomDownIn", {
    "0%": {
      transform: "scale(0.8)",
      transformOrigin: "50% 100%",
      opacity: 0
    },
    "100%": {
      transform: "scale(1)",
      transformOrigin: "50% 100%"
    }
  });
  const zoomDownOut = zoom.zoomDownOut = new _cssinjs.Keyframes("antZoomDownOut", {
    "0%": {
      transform: "scale(1)",
      transformOrigin: "50% 100%"
    },
    "100%": {
      transform: "scale(0.8)",
      transformOrigin: "50% 100%",
      opacity: 0
    }
  });
  const zoomMotion = {
    zoom: {
      inKeyframes: zoomIn,
      outKeyframes: zoomOut
    },
    "zoom-big": {
      inKeyframes: zoomBigIn,
      outKeyframes: zoomBigOut
    },
    "zoom-big-fast": {
      inKeyframes: zoomBigIn,
      outKeyframes: zoomBigOut
    },
    "zoom-left": {
      inKeyframes: zoomLeftIn,
      outKeyframes: zoomLeftOut
    },
    "zoom-right": {
      inKeyframes: zoomRightIn,
      outKeyframes: zoomRightOut
    },
    "zoom-up": {
      inKeyframes: zoomUpIn,
      outKeyframes: zoomUpOut
    },
    "zoom-down": {
      inKeyframes: zoomDownIn,
      outKeyframes: zoomDownOut
    }
  };
  const initZoomMotion = (token2, motionName) => {
    const {
      antCls
    } = token2;
    const motionCls = `${antCls}-${motionName}`;
    const {
      inKeyframes,
      outKeyframes
    } = zoomMotion[motionName];
    return [(0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token2.motionDurationFast : token2.motionDurationMid), {
      [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
        transform: "scale(0)",
        opacity: 0,
        animationTimingFunction: token2.motionEaseOutCirc,
        "&-prepare": {
          transform: "none"
        }
      },
      [`${motionCls}-leave`]: {
        animationTimingFunction: token2.motionEaseInOutCirc
      }
    }];
  };
  zoom.initZoomMotion = initZoomMotion;
  return zoom;
}
var hasRequiredMotion;
function requireMotion() {
  if (hasRequiredMotion) return motion$1;
  hasRequiredMotion = 1;
  (function(exports$1) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    Object.defineProperty(exports$1, "fadeIn", {
      enumerable: true,
      get: function() {
        return _fade.fadeIn;
      }
    });
    Object.defineProperty(exports$1, "fadeOut", {
      enumerable: true,
      get: function() {
        return _fade.fadeOut;
      }
    });
    Object.defineProperty(exports$1, "genCollapseMotion", {
      enumerable: true,
      get: function() {
        return _collapse.default;
      }
    });
    Object.defineProperty(exports$1, "initFadeMotion", {
      enumerable: true,
      get: function() {
        return _fade.initFadeMotion;
      }
    });
    Object.defineProperty(exports$1, "initMoveMotion", {
      enumerable: true,
      get: function() {
        return _move.initMoveMotion;
      }
    });
    Object.defineProperty(exports$1, "initSlideMotion", {
      enumerable: true,
      get: function() {
        return _slide.initSlideMotion;
      }
    });
    Object.defineProperty(exports$1, "initZoomMotion", {
      enumerable: true,
      get: function() {
        return _zoom.initZoomMotion;
      }
    });
    Object.defineProperty(exports$1, "moveDownIn", {
      enumerable: true,
      get: function() {
        return _move.moveDownIn;
      }
    });
    Object.defineProperty(exports$1, "moveDownOut", {
      enumerable: true,
      get: function() {
        return _move.moveDownOut;
      }
    });
    Object.defineProperty(exports$1, "moveLeftIn", {
      enumerable: true,
      get: function() {
        return _move.moveLeftIn;
      }
    });
    Object.defineProperty(exports$1, "moveLeftOut", {
      enumerable: true,
      get: function() {
        return _move.moveLeftOut;
      }
    });
    Object.defineProperty(exports$1, "moveRightIn", {
      enumerable: true,
      get: function() {
        return _move.moveRightIn;
      }
    });
    Object.defineProperty(exports$1, "moveRightOut", {
      enumerable: true,
      get: function() {
        return _move.moveRightOut;
      }
    });
    Object.defineProperty(exports$1, "moveUpIn", {
      enumerable: true,
      get: function() {
        return _move.moveUpIn;
      }
    });
    Object.defineProperty(exports$1, "moveUpOut", {
      enumerable: true,
      get: function() {
        return _move.moveUpOut;
      }
    });
    Object.defineProperty(exports$1, "slideDownIn", {
      enumerable: true,
      get: function() {
        return _slide.slideDownIn;
      }
    });
    Object.defineProperty(exports$1, "slideDownOut", {
      enumerable: true,
      get: function() {
        return _slide.slideDownOut;
      }
    });
    Object.defineProperty(exports$1, "slideLeftIn", {
      enumerable: true,
      get: function() {
        return _slide.slideLeftIn;
      }
    });
    Object.defineProperty(exports$1, "slideLeftOut", {
      enumerable: true,
      get: function() {
        return _slide.slideLeftOut;
      }
    });
    Object.defineProperty(exports$1, "slideRightIn", {
      enumerable: true,
      get: function() {
        return _slide.slideRightIn;
      }
    });
    Object.defineProperty(exports$1, "slideRightOut", {
      enumerable: true,
      get: function() {
        return _slide.slideRightOut;
      }
    });
    Object.defineProperty(exports$1, "slideUpIn", {
      enumerable: true,
      get: function() {
        return _slide.slideUpIn;
      }
    });
    Object.defineProperty(exports$1, "slideUpOut", {
      enumerable: true,
      get: function() {
        return _slide.slideUpOut;
      }
    });
    Object.defineProperty(exports$1, "zoomBigIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomBigIn;
      }
    });
    Object.defineProperty(exports$1, "zoomBigOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomBigOut;
      }
    });
    Object.defineProperty(exports$1, "zoomDownIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomDownIn;
      }
    });
    Object.defineProperty(exports$1, "zoomDownOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomDownOut;
      }
    });
    Object.defineProperty(exports$1, "zoomIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomIn;
      }
    });
    Object.defineProperty(exports$1, "zoomLeftIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomLeftIn;
      }
    });
    Object.defineProperty(exports$1, "zoomLeftOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomLeftOut;
      }
    });
    Object.defineProperty(exports$1, "zoomOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomOut;
      }
    });
    Object.defineProperty(exports$1, "zoomRightIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomRightIn;
      }
    });
    Object.defineProperty(exports$1, "zoomRightOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomRightOut;
      }
    });
    Object.defineProperty(exports$1, "zoomUpIn", {
      enumerable: true,
      get: function() {
        return _zoom.zoomUpIn;
      }
    });
    Object.defineProperty(exports$1, "zoomUpOut", {
      enumerable: true,
      get: function() {
        return _zoom.zoomUpOut;
      }
    });
    var _collapse = _interopRequireDefault(/* @__PURE__ */ requireCollapse$2());
    var _fade = /* @__PURE__ */ requireFade();
    var _move = /* @__PURE__ */ requireMove();
    var _slide = /* @__PURE__ */ requireSlide();
    var _zoom = /* @__PURE__ */ requireZoom();
  })(motion$1);
  return motion$1;
}
var hasRequiredStyle$1;
function requireStyle$1() {
  if (hasRequiredStyle$1) return style$1;
  hasRequiredStyle$1 = 1;
  Object.defineProperty(style$1, "__esModule", {
    value: true
  });
  style$1.prepareComponentToken = style$1.genBaseStyle = style$1.default = void 0;
  var _cssinjs = require$$2$2;
  var _style = /* @__PURE__ */ requireStyle$6();
  var _motion = /* @__PURE__ */ requireMotion();
  var _internal = /* @__PURE__ */ requireInternal();
  const genBaseStyle = (token2) => {
    const {
      componentCls,
      contentBg,
      padding,
      headerBg,
      headerPadding,
      collapseHeaderPaddingSM,
      collapseHeaderPaddingLG,
      collapsePanelBorderRadius,
      lineWidth,
      lineType,
      colorBorder,
      colorText,
      colorTextHeading,
      colorTextDisabled,
      fontSizeLG,
      lineHeight,
      lineHeightLG,
      marginSM,
      paddingSM,
      paddingLG,
      paddingXS,
      motionDurationSlow,
      fontSizeIcon,
      contentPadding,
      fontHeight,
      fontHeightLG
    } = token2;
    const borderBase = `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
      [componentCls]: Object.assign(Object.assign({}, (0, _style.resetComponent)(token2)), {
        backgroundColor: headerBg,
        border: borderBase,
        borderRadius: collapsePanelBorderRadius,
        "&-rtl": {
          direction: "rtl"
        },
        [`& > ${componentCls}-item`]: {
          borderBottom: borderBase,
          "&:first-child": {
            [`
            &,
            & > ${componentCls}-header`]: {
              borderRadius: `${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} 0 0`
            }
          },
          "&:last-child": {
            [`
            &,
            & > ${componentCls}-header`]: {
              borderRadius: `0 0 ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)}`
            }
          },
          [`> ${componentCls}-header`]: Object.assign(Object.assign({
            position: "relative",
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "flex-start",
            padding: headerPadding,
            color: colorTextHeading,
            lineHeight,
            cursor: "pointer",
            transition: `all ${motionDurationSlow}, visibility 0s`
          }, (0, _style.genFocusStyle)(token2)), {
            [`> ${componentCls}-header-text`]: {
              flex: "auto"
            },
            // >>>>> Arrow
            [`${componentCls}-expand-icon`]: {
              height: fontHeight,
              display: "flex",
              alignItems: "center",
              paddingInlineEnd: marginSM
            },
            [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, _style.resetIcon)()), {
              fontSize: fontSizeIcon,
              // when `transform: rotate()` is applied to icon's root element
              transition: `transform ${motionDurationSlow}`,
              // when `transform: rotate()` is applied to icon's child element
              svg: {
                transition: `transform ${motionDurationSlow}`
              }
            }),
            // >>>>> Text
            [`${componentCls}-header-text`]: {
              marginInlineEnd: "auto"
            }
          }),
          [`${componentCls}-collapsible-header`]: {
            cursor: "default",
            [`${componentCls}-header-text`]: {
              flex: "none",
              cursor: "pointer"
            }
          },
          [`${componentCls}-collapsible-icon`]: {
            cursor: "unset",
            [`${componentCls}-expand-icon`]: {
              cursor: "pointer"
            }
          }
        },
        [`${componentCls}-content`]: {
          color: colorText,
          backgroundColor: contentBg,
          borderTop: borderBase,
          [`& > ${componentCls}-content-box`]: {
            padding: contentPadding
          },
          "&-hidden": {
            display: "none"
          }
        },
        "&-small": {
          [`> ${componentCls}-item`]: {
            [`> ${componentCls}-header`]: {
              padding: collapseHeaderPaddingSM,
              paddingInlineStart: paddingXS,
              [`> ${componentCls}-expand-icon`]: {
                // Arrow offset
                marginInlineStart: token2.calc(paddingSM).sub(paddingXS).equal()
              }
            },
            [`> ${componentCls}-content > ${componentCls}-content-box`]: {
              padding: paddingSM
            }
          }
        },
        "&-large": {
          [`> ${componentCls}-item`]: {
            fontSize: fontSizeLG,
            lineHeight: lineHeightLG,
            [`> ${componentCls}-header`]: {
              padding: collapseHeaderPaddingLG,
              paddingInlineStart: padding,
              [`> ${componentCls}-expand-icon`]: {
                height: fontHeightLG,
                // Arrow offset
                marginInlineStart: token2.calc(paddingLG).sub(padding).equal()
              }
            },
            [`> ${componentCls}-content > ${componentCls}-content-box`]: {
              padding: paddingLG
            }
          }
        },
        [`${componentCls}-item:last-child`]: {
          borderBottom: 0,
          [`> ${componentCls}-content`]: {
            borderRadius: `0 0 ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)}`
          }
        },
        [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
          [`
          &,
          & > .arrow
        `]: {
            color: colorTextDisabled,
            cursor: "not-allowed"
          }
        },
        // ========================== Icon Position ==========================
        [`&${componentCls}-icon-position-end`]: {
          [`& > ${componentCls}-item`]: {
            [`> ${componentCls}-header`]: {
              [`${componentCls}-expand-icon`]: {
                order: 1,
                paddingInlineEnd: 0,
                paddingInlineStart: marginSM
              }
            }
          }
        }
      })
    };
  };
  style$1.genBaseStyle = genBaseStyle;
  const genArrowStyle = (token2) => {
    const {
      componentCls
    } = token2;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
      [`${componentCls}-rtl`]: {
        [fixedSelector]: {
          transform: `rotate(180deg)`
        }
      }
    };
  };
  const genBorderlessStyle = (token2) => {
    const {
      componentCls,
      headerBg,
      paddingXXS,
      colorBorder
    } = token2;
    return {
      [`${componentCls}-borderless`]: {
        backgroundColor: headerBg,
        border: 0,
        [`> ${componentCls}-item`]: {
          borderBottom: `1px solid ${colorBorder}`
        },
        [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
          borderRadius: 0
        },
        [`> ${componentCls}-item:last-child`]: {
          borderBottom: 0
        },
        [`> ${componentCls}-item > ${componentCls}-content`]: {
          backgroundColor: "transparent",
          borderTop: 0
        },
        [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
          paddingTop: paddingXXS
        }
      }
    };
  };
  const genGhostStyle = (token2) => {
    const {
      componentCls,
      paddingSM
    } = token2;
    return {
      [`${componentCls}-ghost`]: {
        backgroundColor: "transparent",
        border: 0,
        [`> ${componentCls}-item`]: {
          borderBottom: 0,
          [`> ${componentCls}-content`]: {
            backgroundColor: "transparent",
            border: 0,
            [`> ${componentCls}-content-box`]: {
              paddingBlock: paddingSM
            }
          }
        }
      }
    };
  };
  const prepareComponentToken = (token2) => ({
    headerPadding: `${token2.paddingSM}px ${token2.padding}px`,
    headerBg: token2.colorFillAlter,
    contentPadding: `${token2.padding}px 16px`,
    // Fixed Value
    contentBg: token2.colorBgContainer
  });
  style$1.prepareComponentToken = prepareComponentToken;
  style$1.default = (0, _internal.genStyleHooks)("Collapse", (token2) => {
    const collapseToken = (0, _internal.mergeToken)(token2, {
      collapseHeaderPaddingSM: `${(0, _cssinjs.unit)(token2.paddingXS)} ${(0, _cssinjs.unit)(token2.paddingSM)}`,
      collapseHeaderPaddingLG: `${(0, _cssinjs.unit)(token2.padding)} ${(0, _cssinjs.unit)(token2.paddingLG)}`,
      collapsePanelBorderRadius: token2.borderRadiusLG
    });
    return [genBaseStyle(collapseToken), genBorderlessStyle(collapseToken), genGhostStyle(collapseToken), genArrowStyle(collapseToken), (0, _motion.genCollapseMotion)(collapseToken)];
  }, prepareComponentToken);
  return style$1;
}
var hasRequiredCollapse$1;
function requireCollapse$1() {
  if (hasRequiredCollapse$1) return Collapse$2;
  hasRequiredCollapse$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(Collapse$2, "__esModule", {
    value: true
  });
  Collapse$2.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _RightOutlined = _interopRequireDefault(/* @__PURE__ */ requireRightOutlined());
  var _classnames = _interopRequireDefault(requireClassnames());
  var _rcCollapse = _interopRequireDefault(require$$5);
  var _toArray2 = _interopRequireDefault(requireToArray());
  var _omit = _interopRequireDefault(requireOmit());
  var _motion = _interopRequireDefault(/* @__PURE__ */ requireMotion$2());
  var _reactNode = /* @__PURE__ */ requireReactNode();
  var _warning = /* @__PURE__ */ requireWarning();
  var _context = /* @__PURE__ */ requireContext$1();
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _CollapsePanel = _interopRequireDefault(/* @__PURE__ */ requireCollapsePanel());
  var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle$1());
  const Collapse2 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    const {
      getPrefixCls,
      direction,
      expandIcon: contextExpandIcon,
      className: contextClassName,
      style: contextStyle
    } = (0, _context.useComponentConfig)("collapse");
    const {
      prefixCls: customizePrefixCls,
      className,
      rootClassName,
      style: style2,
      bordered = true,
      ghost,
      size: customizeSize,
      expandIconPosition = "start",
      children: children2,
      expandIcon
    } = props;
    const mergedSize = (0, _useSize.default)((ctx) => {
      var _a2;
      return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a2 !== void 0 ? _a2 : "middle";
    });
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId, cssVarCls] = (0, _style.default)(prefixCls);
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Collapse");
      process.env.NODE_ENV !== "production" ? warning3(expandIconPosition !== "left" && expandIconPosition !== "right", "deprecated", "`expandIconPosition` with `left` or `right` is deprecated. Please use `start` or `end` instead.") : void 0;
    }
    const mergedExpandIconPosition = React2.useMemo(() => {
      if (expandIconPosition === "left") {
        return "start";
      }
      return expandIconPosition === "right" ? "end" : expandIconPosition;
    }, [expandIconPosition]);
    const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    const renderExpandIcon = React2.useCallback(function() {
      let panelProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const icon2 = typeof mergedExpandIcon === "function" ? mergedExpandIcon(panelProps) : /* @__PURE__ */ React2.createElement(_RightOutlined.default, {
        rotate: panelProps.isActive ? direction === "rtl" ? -90 : 90 : void 0,
        "aria-label": panelProps.isActive ? "expanded" : "collapsed"
      });
      return (0, _reactNode.cloneElement)(icon2, () => {
        var _a2;
        return {
          className: (0, _classnames.default)((_a2 = icon2 === null || icon2 === void 0 ? void 0 : icon2.props) === null || _a2 === void 0 ? void 0 : _a2.className, `${prefixCls}-arrow`)
        };
      });
    }, [mergedExpandIcon, prefixCls]);
    const collapseClassName = (0, _classnames.default)(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
      [`${prefixCls}-borderless`]: !bordered,
      [`${prefixCls}-rtl`]: direction === "rtl",
      [`${prefixCls}-ghost`]: !!ghost,
      [`${prefixCls}-${mergedSize}`]: mergedSize !== "middle"
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const openMotion = Object.assign(Object.assign({}, (0, _motion.default)(rootPrefixCls)), {
      motionAppear: false,
      leavedClassName: `${prefixCls}-content-hidden`
    });
    const items = React2.useMemo(() => {
      if (children2) {
        return (0, _toArray2.default)(children2).map((child, index2) => {
          var _a2, _b;
          const childProps = child.props;
          if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
            const key = (_a2 = child.key) !== null && _a2 !== void 0 ? _a2 : String(index2);
            const mergedChildProps = Object.assign(Object.assign({}, (0, _omit.default)(child.props, ["disabled"])), {
              key,
              collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : "disabled"
            });
            return (0, _reactNode.cloneElement)(child, mergedChildProps);
          }
          return child;
        });
      }
      return null;
    }, [children2]);
    return wrapCSSVar(
      // @ts-ignore
      /* @__PURE__ */ React2.createElement(_rcCollapse.default, Object.assign({
        ref: ref2,
        openMotion
      }, (0, _omit.default)(props, ["rootClassName"]), {
        expandIcon: renderExpandIcon,
        prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, contextStyle), style2)
      }), items)
    );
  });
  if (process.env.NODE_ENV !== "production") {
    Collapse2.displayName = "Collapse";
  }
  Collapse$2.default = Object.assign(Collapse2, {
    Panel: _CollapsePanel.default
  });
  return Collapse$2;
}
var hasRequiredCollapse;
function requireCollapse() {
  if (hasRequiredCollapse) return collapse$1;
  hasRequiredCollapse = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(collapse$1, "__esModule", {
    value: true
  });
  collapse$1.default = void 0;
  var _Collapse = _interopRequireDefault(/* @__PURE__ */ requireCollapse$1());
  collapse$1.default = _Collapse.default;
  return collapse$1;
}
var util = {};
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(util, "__esModule", {
    value: true
  });
  util.getRoundNumber = util.getGradientPercentColor = util.getColorAlpha = util.generateColor = util.genAlphaColor = void 0;
  var _toConsumableArray2 = _interopRequireDefault(requireToConsumableArray());
  var _colorPicker = require$$3;
  var _color = /* @__PURE__ */ requireColor();
  const generateColor3 = (color2) => {
    if (color2 instanceof _color.AggregationColor) {
      return color2;
    }
    return new _color.AggregationColor(color2);
  };
  util.generateColor = generateColor3;
  const getRoundNumber3 = (value) => Math.round(Number(value || 0));
  util.getRoundNumber = getRoundNumber3;
  const getColorAlpha = (color2) => getRoundNumber3(color2.toHsb().a * 100);
  util.getColorAlpha = getColorAlpha;
  const genAlphaColor = (color2, alpha) => {
    const rgba = color2.toRgb();
    if (!rgba.r && !rgba.g && !rgba.b) {
      const hsba = color2.toHsb();
      hsba.a = alpha || 1;
      return generateColor3(hsba);
    }
    rgba.a = alpha || 1;
    return generateColor3(rgba);
  };
  util.genAlphaColor = genAlphaColor;
  const getGradientPercentColor = (colors2, percent) => {
    const filledColors = [{
      percent: 0,
      color: colors2[0].color
    }].concat((0, _toConsumableArray2.default)(colors2), [{
      percent: 100,
      color: colors2[colors2.length - 1].color
    }]);
    for (let i = 0; i < filledColors.length - 1; i += 1) {
      const startPtg = filledColors[i].percent;
      const endPtg = filledColors[i + 1].percent;
      const startColor = filledColors[i].color;
      const endColor = filledColors[i + 1].color;
      if (startPtg <= percent && percent <= endPtg) {
        const dist2 = endPtg - startPtg;
        if (dist2 === 0) {
          return startColor;
        }
        const ratio = (percent - startPtg) / dist2 * 100;
        const startRcColor = new _colorPicker.Color(startColor);
        const endRcColor = new _colorPicker.Color(endColor);
        return startRcColor.mix(endRcColor, ratio).toRgbString();
      }
    }
    return "";
  };
  util.getGradientPercentColor = getGradientPercentColor;
  return util;
}
var hasRequiredColorPresets;
function requireColorPresets() {
  if (hasRequiredColorPresets) return ColorPresets;
  hasRequiredColorPresets = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(ColorPresets, "__esModule", {
    value: true
  });
  ColorPresets.isBright = ColorPresets.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var _colorPicker = require$$3;
  var _classnames = _interopRequireDefault(requireClassnames());
  var _useMergedState = _interopRequireDefault(requireUseMergedState());
  var _collapse = _interopRequireDefault(/* @__PURE__ */ requireCollapse());
  var _locale = /* @__PURE__ */ requireLocale();
  var _internal = /* @__PURE__ */ requireInternal();
  var _util = /* @__PURE__ */ requireUtil();
  const genPresetColor2 = (list) => list.map((value) => {
    value.colors = value.colors.map(_util.generateColor);
    return value;
  });
  const isBright = (value, bgColorToken) => {
    const {
      r: r2,
      g,
      b,
      a
    } = value.toRgb();
    const hsv = new _colorPicker.Color(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) {
      return hsv.v > 0.5;
    }
    return r2 * 0.299 + g * 0.587 + b * 0.114 > 192;
  };
  ColorPresets.isBright = isBright;
  const genCollapsePanelKey = (preset, index2) => {
    var _a2;
    const mergedKey = (_a2 = preset.key) !== null && _a2 !== void 0 ? _a2 : index2;
    return `panel-${mergedKey}`;
  };
  const ColorPresets$1 = (_ref) => {
    let {
      prefixCls,
      presets,
      value: color2,
      onChange: onChange5
    } = _ref;
    const [locale2] = (0, _locale.useLocale)("ColorPicker");
    const [, token2] = (0, _internal.useToken)();
    const [presetsValue] = (0, _useMergedState.default)(genPresetColor2(presets), {
      value: genPresetColor2(presets),
      postState: genPresetColor2
    });
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, _react.useMemo)(() => presetsValue.reduce((acc, preset, index2) => {
      const {
        defaultOpen = true
      } = preset;
      if (defaultOpen) {
        acc.push(genCollapsePanelKey(preset, index2));
      }
      return acc;
    }, []), [presetsValue]);
    const handleClick = (colorValue) => {
      onChange5 === null || onChange5 === void 0 ? void 0 : onChange5(colorValue);
    };
    const items = presetsValue.map((preset, index2) => {
      var _a2;
      return {
        key: genCollapsePanelKey(preset, index2),
        label: /* @__PURE__ */ _react.default.createElement("div", {
          className: `${colorPresetsPrefixCls}-label`
        }, preset === null || preset === void 0 ? void 0 : preset.label),
        children: /* @__PURE__ */ _react.default.createElement("div", {
          className: `${colorPresetsPrefixCls}-items`
        }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a2 = preset.colors) === null || _a2 === void 0 ? void 0 : _a2.length) > 0 ? preset.colors.map((presetColor, index3) => /* @__PURE__ */ _react.default.createElement(
          _colorPicker.ColorBlock,
          {
            // eslint-disable-next-line react/no-array-index-key
            key: `preset-${index3}-${presetColor.toHexString()}`,
            color: (0, _util.generateColor)(presetColor).toRgbString(),
            prefixCls,
            className: (0, _classnames.default)(`${colorPresetsPrefixCls}-color`, {
              [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color2 === null || color2 === void 0 ? void 0 : color2.toHexString()),
              [`${colorPresetsPrefixCls}-color-bright`]: isBright(presetColor, token2.colorBgElevated)
            }),
            onClick: () => handleClick(presetColor)
          }
        )) : /* @__PURE__ */ _react.default.createElement("span", {
          className: `${colorPresetsPrefixCls}-empty`
        }, locale2.presetEmpty))
      };
    });
    return /* @__PURE__ */ _react.default.createElement("div", {
      className: colorPresetsPrefixCls
    }, /* @__PURE__ */ _react.default.createElement(_collapse.default, {
      defaultActiveKey: activeKeys,
      ghost: true,
      items
    }));
  };
  ColorPresets.default = ColorPresets$1;
  return ColorPresets;
}
var hasRequiredToken;
function requireToken() {
  if (hasRequiredToken) return token;
  hasRequiredToken = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(token, "__esModule", {
    value: true
  });
  token.prepareToken = token.prepareComponentToken = void 0;
  var _cssinjs = require$$2$2;
  var _color = /* @__PURE__ */ requireColor();
  var _ColorPresets = /* @__PURE__ */ requireColorPresets();
  var _internal = /* @__PURE__ */ requireInternal();
  var _interface2 = /* @__PURE__ */ require_interface$1();
  var _getAlphaColor = _interopRequireDefault(/* @__PURE__ */ requireGetAlphaColor());
  const prepareToken = (token2) => {
    const {
      paddingInline,
      onlyIconSize
    } = token2;
    const buttonToken = (0, _internal.mergeToken)(token2, {
      buttonPaddingHorizontal: paddingInline,
      buttonPaddingVertical: 0,
      buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
  };
  token.prepareToken = prepareToken;
  const prepareComponentToken = (token2) => {
    var _a2, _b, _c, _d, _e, _f;
    const contentFontSize = (_a2 = token2.contentFontSize) !== null && _a2 !== void 0 ? _a2 : token2.fontSize;
    const contentFontSizeSM = (_b = token2.contentFontSizeSM) !== null && _b !== void 0 ? _b : token2.fontSize;
    const contentFontSizeLG = (_c = token2.contentFontSizeLG) !== null && _c !== void 0 ? _c : token2.fontSizeLG;
    const contentLineHeight = (_d = token2.contentLineHeight) !== null && _d !== void 0 ? _d : (0, _internal.getLineHeight)(contentFontSize);
    const contentLineHeightSM = (_e = token2.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, _internal.getLineHeight)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token2.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, _internal.getLineHeight)(contentFontSizeLG);
    const solidTextColor = (0, _ColorPresets.isBright)(new _color.AggregationColor(token2.colorBgSolid), "#fff") ? "#000" : "#fff";
    const shadowColorTokens = _interface2.PresetColors.reduce((prev4, colorKey) => Object.assign(Object.assign({}, prev4), {
      [`${colorKey}ShadowColor`]: `0 ${(0, _cssinjs.unit)(token2.controlOutlineWidth)} 0 ${(0, _getAlphaColor.default)(token2[`${colorKey}1`], token2.colorBgContainer)}`
    }), {});
    return Object.assign(Object.assign({}, shadowColorTokens), {
      fontWeight: 400,
      defaultShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlTmpOutline}`,
      primaryShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlOutline}`,
      dangerShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.colorErrorOutline}`,
      primaryColor: token2.colorTextLightSolid,
      dangerColor: token2.colorTextLightSolid,
      borderColorDisabled: token2.colorBorder,
      defaultGhostColor: token2.colorBgContainer,
      ghostBg: "transparent",
      defaultGhostBorderColor: token2.colorBgContainer,
      paddingInline: token2.paddingContentHorizontal - token2.lineWidth,
      paddingInlineLG: token2.paddingContentHorizontal - token2.lineWidth,
      paddingInlineSM: 8 - token2.lineWidth,
      onlyIconSize: "inherit",
      onlyIconSizeSM: "inherit",
      onlyIconSizeLG: "inherit",
      groupBorderColor: token2.colorPrimaryHover,
      linkHoverBg: "transparent",
      textTextColor: token2.colorText,
      textTextHoverColor: token2.colorText,
      textTextActiveColor: token2.colorText,
      textHoverBg: token2.colorFillTertiary,
      defaultColor: token2.colorText,
      defaultBg: token2.colorBgContainer,
      defaultBorderColor: token2.colorBorder,
      defaultBorderColorDisabled: token2.colorBorder,
      defaultHoverBg: token2.colorBgContainer,
      defaultHoverColor: token2.colorPrimaryHover,
      defaultHoverBorderColor: token2.colorPrimaryHover,
      defaultActiveBg: token2.colorBgContainer,
      defaultActiveColor: token2.colorPrimaryActive,
      defaultActiveBorderColor: token2.colorPrimaryActive,
      solidTextColor,
      contentFontSize,
      contentFontSizeSM,
      contentFontSizeLG,
      contentLineHeight,
      contentLineHeightSM,
      contentLineHeightLG,
      paddingBlock: Math.max((token2.controlHeight - contentFontSize * contentLineHeight) / 2 - token2.lineWidth, 0),
      paddingBlockSM: Math.max((token2.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token2.lineWidth, 0),
      paddingBlockLG: Math.max((token2.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token2.lineWidth, 0)
    });
  };
  token.prepareComponentToken = prepareComponentToken;
  return token;
}
var hasRequiredStyle;
function requireStyle() {
  if (hasRequiredStyle) return style$2;
  hasRequiredStyle = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(style$2, "__esModule", {
    value: true
  });
  style$2.default = void 0;
  var _cssinjs = require$$2$2;
  var _style = /* @__PURE__ */ requireStyle$6();
  var _interface2 = /* @__PURE__ */ require_interface$1();
  var _internal = /* @__PURE__ */ requireInternal();
  var _group = _interopRequireDefault(/* @__PURE__ */ requireGroup());
  var _token = /* @__PURE__ */ requireToken();
  const genSharedButtonStyle = (token2) => {
    const {
      componentCls,
      iconCls,
      fontWeight,
      opacityLoading,
      motionDurationSlow,
      motionEaseInOut,
      marginXS,
      calc
    } = token2;
    return {
      [componentCls]: {
        outline: "none",
        position: "relative",
        display: "inline-flex",
        gap: token2.marginXS,
        alignItems: "center",
        justifyContent: "center",
        fontWeight,
        whiteSpace: "nowrap",
        textAlign: "center",
        backgroundImage: "none",
        background: "transparent",
        border: `${(0, _cssinjs.unit)(token2.lineWidth)} ${token2.lineType} transparent`,
        cursor: "pointer",
        transition: `all ${token2.motionDurationMid} ${token2.motionEaseInOut}`,
        userSelect: "none",
        touchAction: "manipulation",
        color: token2.colorText,
        "&:disabled > *": {
          pointerEvents: "none"
        },
        // https://github.com/ant-design/ant-design/issues/51380
        [`${componentCls}-icon > svg`]: (0, _style.resetIcon)(),
        "> a": {
          color: "currentColor"
        },
        "&:not(:disabled)": (0, _style.genFocusStyle)(token2),
        [`&${componentCls}-two-chinese-chars::first-letter`]: {
          letterSpacing: "0.34em"
        },
        [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
          marginInlineEnd: "-0.34em",
          letterSpacing: "0.34em"
        },
        [`&${componentCls}-icon-only`]: {
          paddingInline: 0,
          // make `btn-icon-only` not too narrow
          [`&${componentCls}-compact-item`]: {
            flex: "none"
          },
          [`&${componentCls}-round`]: {
            width: "auto"
          }
        },
        // Loading
        [`&${componentCls}-loading`]: {
          opacity: opacityLoading,
          cursor: "default"
        },
        [`${componentCls}-loading-icon`]: {
          transition: ["width", "opacity", "margin"].map((transition) => `${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
        },
        // iconPosition
        [`&:not(${componentCls}-icon-end)`]: {
          [`${componentCls}-loading-icon-motion`]: {
            "&-appear-start, &-enter-start": {
              marginInlineEnd: calc(marginXS).mul(-1).equal()
            },
            "&-appear-active, &-enter-active": {
              marginInlineEnd: 0
            },
            "&-leave-start": {
              marginInlineEnd: 0
            },
            "&-leave-active": {
              marginInlineEnd: calc(marginXS).mul(-1).equal()
            }
          }
        },
        "&-icon-end": {
          flexDirection: "row-reverse",
          [`${componentCls}-loading-icon-motion`]: {
            "&-appear-start, &-enter-start": {
              marginInlineStart: calc(marginXS).mul(-1).equal()
            },
            "&-appear-active, &-enter-active": {
              marginInlineStart: 0
            },
            "&-leave-start": {
              marginInlineStart: 0
            },
            "&-leave-active": {
              marginInlineStart: calc(marginXS).mul(-1).equal()
            }
          }
        }
      }
    };
  };
  const genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle) => ({
    [`&:not(:disabled):not(${btnCls}-disabled)`]: {
      "&:hover": hoverStyle,
      "&:active": activeStyle
    }
  });
  const genCircleButtonStyle = (token2) => ({
    minWidth: token2.controlHeight,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    borderRadius: "50%"
  });
  const genRoundButtonStyle = (token2) => ({
    borderRadius: token2.controlHeight,
    paddingInlineStart: token2.calc(token2.controlHeight).div(2).equal(),
    paddingInlineEnd: token2.calc(token2.controlHeight).div(2).equal()
  });
  const genDisabledStyle = (token2) => ({
    cursor: "not-allowed",
    borderColor: token2.borderColorDisabled,
    color: token2.colorTextDisabled,
    background: token2.colorBgContainerDisabled,
    boxShadow: "none"
  });
  const genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) => ({
    [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
      color: textColor || void 0,
      background,
      borderColor: borderColor || void 0,
      boxShadow: "none"
    }, genHoverActiveButtonStyle(btnCls, Object.assign({
      background
    }, hoverStyle), Object.assign({
      background
    }, activeStyle))), {
      "&:disabled": {
        cursor: "not-allowed",
        color: textColorDisabled || void 0,
        borderColor: borderColorDisabled || void 0
      }
    })
  });
  const genSolidDisabledButtonStyle = (token2) => ({
    [`&:disabled, &${token2.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(token2))
  });
  const genPureDisabledButtonStyle = (token2) => ({
    [`&:disabled, &${token2.componentCls}-disabled`]: {
      cursor: "not-allowed",
      color: token2.colorTextDisabled
    }
  });
  const genVariantButtonStyle = (token2, hoverStyle, activeStyle, variant) => {
    const isPureDisabled = variant && ["link", "text"].includes(variant);
    const genDisabledButtonStyle = isPureDisabled ? genPureDisabledButtonStyle : genSolidDisabledButtonStyle;
    return Object.assign(Object.assign({}, genDisabledButtonStyle(token2)), genHoverActiveButtonStyle(token2.componentCls, hoverStyle, activeStyle));
  };
  const genSolidButtonStyle = (token2, textColor, background, hoverStyle, activeStyle) => ({
    [`&${token2.componentCls}-variant-solid`]: Object.assign({
      color: textColor,
      background
    }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
  });
  const genOutlinedDashedButtonStyle = (token2, borderColor, background, hoverStyle, activeStyle) => ({
    [`&${token2.componentCls}-variant-outlined, &${token2.componentCls}-variant-dashed`]: Object.assign({
      borderColor,
      background
    }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
  });
  const genDashedButtonStyle = (token2) => ({
    [`&${token2.componentCls}-variant-dashed`]: {
      borderStyle: "dashed"
    }
  });
  const genFilledButtonStyle = (token2, background, hoverStyle, activeStyle) => ({
    [`&${token2.componentCls}-variant-filled`]: Object.assign({
      boxShadow: "none",
      background
    }, genVariantButtonStyle(token2, hoverStyle, activeStyle))
  });
  const genTextLinkButtonStyle = (token2, textColor, variant, hoverStyle, activeStyle) => ({
    [`&${token2.componentCls}-variant-${variant}`]: Object.assign({
      color: textColor,
      boxShadow: "none"
    }, genVariantButtonStyle(token2, hoverStyle, activeStyle, variant))
  });
  const genPresetColorStyle = (token2) => {
    const {
      componentCls
    } = token2;
    return _interface2.PresetColors.reduce((prev4, colorKey) => {
      const darkColor = token2[`${colorKey}6`];
      const lightColor = token2[`${colorKey}1`];
      const hoverColor = token2[`${colorKey}5`];
      const lightHoverColor = token2[`${colorKey}2`];
      const lightBorderColor = token2[`${colorKey}3`];
      const activeColor = token2[`${colorKey}7`];
      return Object.assign(Object.assign({}, prev4), {
        [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          color: darkColor,
          boxShadow: token2[`${colorKey}ShadowColor`]
        }, genSolidButtonStyle(token2, token2.colorTextLightSolid, darkColor, {
          background: hoverColor
        }, {
          background: activeColor
        })), genOutlinedDashedButtonStyle(token2, darkColor, token2.colorBgContainer, {
          color: hoverColor,
          borderColor: hoverColor,
          background: token2.colorBgContainer
        }, {
          color: activeColor,
          borderColor: activeColor,
          background: token2.colorBgContainer
        })), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, lightColor, {
          background: lightHoverColor
        }, {
          background: lightBorderColor
        })), genTextLinkButtonStyle(token2, darkColor, "link", {
          color: hoverColor
        }, {
          color: activeColor
        })), genTextLinkButtonStyle(token2, darkColor, "text", {
          color: hoverColor,
          background: lightColor
        }, {
          color: activeColor,
          background: lightBorderColor
        }))
      });
    }, {});
  };
  const genDefaultButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    color: token2.defaultColor,
    boxShadow: token2.defaultShadow
  }, genSolidButtonStyle(token2, token2.solidTextColor, token2.colorBgSolid, {
    color: token2.solidTextColor,
    background: token2.colorBgSolidHover
  }, {
    color: token2.solidTextColor,
    background: token2.colorBgSolidActive
  })), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorFillTertiary, {
    background: token2.colorFillSecondary
  }, {
    background: token2.colorFill
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.defaultGhostColor, token2.defaultGhostBorderColor, token2.colorTextDisabled, token2.colorBorder)), genTextLinkButtonStyle(token2, token2.textTextColor, "link", {
    color: token2.colorLinkHover,
    background: token2.linkHoverBg
  }, {
    color: token2.colorLinkActive
  }));
  const genPrimaryButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    color: token2.colorPrimary,
    boxShadow: token2.primaryShadow
  }, genOutlinedDashedButtonStyle(token2, token2.colorPrimary, token2.colorBgContainer, {
    color: token2.colorPrimaryTextHover,
    borderColor: token2.colorPrimaryHover,
    background: token2.colorBgContainer
  }, {
    color: token2.colorPrimaryTextActive,
    borderColor: token2.colorPrimaryActive,
    background: token2.colorBgContainer
  })), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorPrimaryBg, {
    background: token2.colorPrimaryBgHover
  }, {
    background: token2.colorPrimaryBorder
  })), genTextLinkButtonStyle(token2, token2.colorPrimaryText, "text", {
    color: token2.colorPrimaryTextHover,
    background: token2.colorPrimaryBg
  }, {
    color: token2.colorPrimaryTextActive,
    background: token2.colorPrimaryBorder
  })), genTextLinkButtonStyle(token2, token2.colorPrimaryText, "link", {
    color: token2.colorPrimaryTextHover,
    background: token2.linkHoverBg
  }, {
    color: token2.colorPrimaryTextActive
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorPrimary, token2.colorPrimary, token2.colorTextDisabled, token2.colorBorder, {
    color: token2.colorPrimaryHover,
    borderColor: token2.colorPrimaryHover
  }, {
    color: token2.colorPrimaryActive,
    borderColor: token2.colorPrimaryActive
  }));
  const genDangerousStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    color: token2.colorError,
    boxShadow: token2.dangerShadow
  }, genSolidButtonStyle(token2, token2.dangerColor, token2.colorError, {
    background: token2.colorErrorHover
  }, {
    background: token2.colorErrorActive
  })), genOutlinedDashedButtonStyle(token2, token2.colorError, token2.colorBgContainer, {
    color: token2.colorErrorHover,
    borderColor: token2.colorErrorBorderHover
  }, {
    color: token2.colorErrorActive,
    borderColor: token2.colorErrorActive
  })), genDashedButtonStyle(token2)), genFilledButtonStyle(token2, token2.colorErrorBg, {
    background: token2.colorErrorBgFilledHover
  }, {
    background: token2.colorErrorBgActive
  })), genTextLinkButtonStyle(token2, token2.colorError, "text", {
    color: token2.colorErrorHover,
    background: token2.colorErrorBg
  }, {
    color: token2.colorErrorHover,
    background: token2.colorErrorBgActive
  })), genTextLinkButtonStyle(token2, token2.colorError, "link", {
    color: token2.colorErrorHover
  }, {
    color: token2.colorErrorActive
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorError, token2.colorError, token2.colorTextDisabled, token2.colorBorder, {
    color: token2.colorErrorHover,
    borderColor: token2.colorErrorHover
  }, {
    color: token2.colorErrorActive,
    borderColor: token2.colorErrorActive
  }));
  const genLinkStyle = (token2) => Object.assign(Object.assign({}, genTextLinkButtonStyle(token2, token2.colorLink, "link", {
    color: token2.colorLinkHover
  }, {
    color: token2.colorLinkActive
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorInfo, token2.colorInfo, token2.colorTextDisabled, token2.colorBorder, {
    color: token2.colorInfoHover,
    borderColor: token2.colorInfoHover
  }, {
    color: token2.colorInfoActive,
    borderColor: token2.colorInfoActive
  }));
  const genColorButtonStyle = (token2) => {
    const {
      componentCls
    } = token2;
    return Object.assign({
      [`${componentCls}-color-default`]: genDefaultButtonStyle(token2),
      [`${componentCls}-color-primary`]: genPrimaryButtonStyle(token2),
      [`${componentCls}-color-dangerous`]: genDangerousStyle(token2),
      [`${componentCls}-color-link`]: genLinkStyle(token2)
    }, genPresetColorStyle(token2));
  };
  const genCompatibleButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign({}, genOutlinedDashedButtonStyle(token2, token2.defaultBorderColor, token2.defaultBg, {
    color: token2.defaultHoverColor,
    borderColor: token2.defaultHoverBorderColor,
    background: token2.defaultHoverBg
  }, {
    color: token2.defaultActiveColor,
    borderColor: token2.defaultActiveBorderColor,
    background: token2.defaultActiveBg
  })), genTextLinkButtonStyle(token2, token2.textTextColor, "text", {
    color: token2.textTextHoverColor,
    background: token2.textHoverBg
  }, {
    color: token2.textTextActiveColor,
    background: token2.colorBgTextActive
  })), genSolidButtonStyle(token2, token2.primaryColor, token2.colorPrimary, {
    background: token2.colorPrimaryHover,
    color: token2.primaryColor
  }, {
    background: token2.colorPrimaryActive,
    color: token2.primaryColor
  })), genTextLinkButtonStyle(token2, token2.colorLink, "link", {
    color: token2.colorLinkHover,
    background: token2.linkHoverBg
  }, {
    color: token2.colorLinkActive
  }));
  const genButtonStyle = function(token2) {
    let prefixCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const {
      componentCls,
      controlHeight,
      fontSize,
      borderRadius,
      buttonPaddingHorizontal,
      iconCls,
      buttonPaddingVertical,
      buttonIconOnlyFontSize
    } = token2;
    return [
      {
        [prefixCls]: {
          fontSize,
          height: controlHeight,
          padding: `${(0, _cssinjs.unit)(buttonPaddingVertical)} ${(0, _cssinjs.unit)(buttonPaddingHorizontal)}`,
          borderRadius,
          [`&${componentCls}-icon-only`]: {
            width: controlHeight,
            [iconCls]: {
              fontSize: buttonIconOnlyFontSize
            }
          }
        }
      },
      // Shape - patch prefixCls again to override solid border radius style
      {
        [`${componentCls}${componentCls}-circle${prefixCls}`]: genCircleButtonStyle(token2)
      },
      {
        [`${componentCls}${componentCls}-round${prefixCls}`]: genRoundButtonStyle(token2)
      }
    ];
  };
  const genSizeBaseButtonStyle = (token2) => {
    const baseToken = (0, _internal.mergeToken)(token2, {
      fontSize: token2.contentFontSize
    });
    return genButtonStyle(baseToken, token2.componentCls);
  };
  const genSizeSmallButtonStyle = (token2) => {
    const smallToken = (0, _internal.mergeToken)(token2, {
      controlHeight: token2.controlHeightSM,
      fontSize: token2.contentFontSizeSM,
      padding: token2.paddingXS,
      buttonPaddingHorizontal: token2.paddingInlineSM,
      buttonPaddingVertical: 0,
      borderRadius: token2.borderRadiusSM,
      buttonIconOnlyFontSize: token2.onlyIconSizeSM
    });
    return genButtonStyle(smallToken, `${token2.componentCls}-sm`);
  };
  const genSizeLargeButtonStyle = (token2) => {
    const largeToken = (0, _internal.mergeToken)(token2, {
      controlHeight: token2.controlHeightLG,
      fontSize: token2.contentFontSizeLG,
      buttonPaddingHorizontal: token2.paddingInlineLG,
      buttonPaddingVertical: 0,
      borderRadius: token2.borderRadiusLG,
      buttonIconOnlyFontSize: token2.onlyIconSizeLG
    });
    return genButtonStyle(largeToken, `${token2.componentCls}-lg`);
  };
  const genBlockButtonStyle = (token2) => {
    const {
      componentCls
    } = token2;
    return {
      [componentCls]: {
        [`&${componentCls}-block`]: {
          width: "100%"
        }
      }
    };
  };
  style$2.default = (0, _internal.genStyleHooks)("Button", (token2) => {
    const buttonToken = (0, _token.prepareToken)(token2);
    return [
      // Shared
      genSharedButtonStyle(buttonToken),
      // Size
      genSizeBaseButtonStyle(buttonToken),
      genSizeSmallButtonStyle(buttonToken),
      genSizeLargeButtonStyle(buttonToken),
      // Block
      genBlockButtonStyle(buttonToken),
      // Color
      genColorButtonStyle(buttonToken),
      // https://github.com/ant-design/ant-design/issues/50969
      genCompatibleButtonStyle(buttonToken),
      // Button Group
      (0, _group.default)(buttonToken)
    ];
  }, _token.prepareComponentToken, {
    unitless: {
      fontWeight: true,
      contentLineHeight: true,
      contentLineHeightSM: true,
      contentLineHeightLG: true
    }
  });
  return style$2;
}
var compact = {};
var compactItemVertical = {};
var hasRequiredCompactItemVertical;
function requireCompactItemVertical() {
  if (hasRequiredCompactItemVertical) return compactItemVertical;
  hasRequiredCompactItemVertical = 1;
  Object.defineProperty(compactItemVertical, "__esModule", {
    value: true
  });
  compactItemVertical.genCompactItemVerticalStyle = genCompactItemVerticalStyle;
  function compactItemVerticalBorder(token2, parentCls) {
    return {
      // border collapse
      [`&-item:not(${parentCls}-last-item)`]: {
        marginBottom: token2.calc(token2.lineWidth).mul(-1).equal()
      },
      "&-item": {
        "&:hover,&:focus,&:active": {
          zIndex: 2
        },
        "&[disabled]": {
          zIndex: 0
        }
      }
    };
  }
  function compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
      [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
        borderRadius: 0
      },
      [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
        [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
          borderEndEndRadius: 0,
          borderEndStartRadius: 0
        }
      },
      [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
        [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0
        }
      }
    };
  }
  function genCompactItemVerticalStyle(token2) {
    const compactCls = `${token2.componentCls}-compact-vertical`;
    return {
      [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token2, compactCls)), compactItemBorderVerticalRadius(token2.componentCls, compactCls))
    };
  }
  return compactItemVertical;
}
var hasRequiredCompact;
function requireCompact() {
  if (hasRequiredCompact) return compact;
  hasRequiredCompact = 1;
  Object.defineProperty(compact, "__esModule", {
    value: true
  });
  compact.default = void 0;
  var _compactItem = /* @__PURE__ */ requireCompactItem();
  var _compactItemVertical = /* @__PURE__ */ requireCompactItemVertical();
  var _internal = /* @__PURE__ */ requireInternal();
  var _token = /* @__PURE__ */ requireToken();
  const genButtonCompactStyle = (token2) => {
    const {
      componentCls,
      colorPrimaryHover,
      lineWidth,
      calc
    } = token2;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical2) => {
      const selector = `${componentCls}-compact${vertical2 ? "-vertical" : ""}-item${componentCls}-primary:not([disabled])`;
      return {
        [`${selector} + ${selector}::before`]: {
          position: "absolute",
          top: vertical2 ? insetOffset : 0,
          insetInlineStart: vertical2 ? 0 : insetOffset,
          backgroundColor: colorPrimaryHover,
          content: '""',
          width: vertical2 ? "100%" : lineWidth,
          height: vertical2 ? lineWidth : "100%"
        }
      };
    };
    return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
  };
  compact.default = (0, _internal.genSubStyleComponent)(["Button", "compact"], (token2) => {
    const buttonToken = (0, _token.prepareToken)(token2);
    return [
      // Space Compact
      (0, _compactItem.genCompactItemStyle)(buttonToken),
      (0, _compactItemVertical.genCompactItemVerticalStyle)(buttonToken),
      genButtonCompactStyle(buttonToken)
    ];
  }, _token.prepareComponentToken);
  return compact;
}
var hasRequiredButton$1;
function requireButton$1() {
  if (hasRequiredButton$1) return button;
  hasRequiredButton$1 = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(button, "__esModule", {
    value: true
  });
  button.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _omit = _interopRequireDefault(requireOmit());
  var _ref = requireRef();
  var _warning = /* @__PURE__ */ requireWarning();
  var _wave = _interopRequireDefault(/* @__PURE__ */ requireWave());
  var _context = /* @__PURE__ */ requireContext$1();
  var _DisabledContext = _interopRequireDefault(/* @__PURE__ */ requireDisabledContext());
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _Compact = /* @__PURE__ */ requireCompact$1();
  var _buttonGroup = _interopRequireWildcard(/* @__PURE__ */ requireButtonGroup());
  var _buttonHelpers = /* @__PURE__ */ requireButtonHelpers();
  var _DefaultLoadingIcon = _interopRequireDefault(/* @__PURE__ */ requireDefaultLoadingIcon());
  var _IconWrapper = _interopRequireDefault(/* @__PURE__ */ requireIconWrapper());
  var _style = _interopRequireDefault(/* @__PURE__ */ requireStyle());
  var _compact = _interopRequireDefault(/* @__PURE__ */ requireCompact());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  function getLoadingConfig(loading) {
    if (typeof loading === "object" && loading) {
      let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
      delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
      return {
        loading: delay <= 0,
        delay
      };
    }
    return {
      loading: !!loading,
      delay: 0
    };
  }
  const ButtonTypeMap = {
    default: ["default", "outlined"],
    primary: ["primary", "solid"],
    dashed: ["default", "dashed"],
    // `link` is not a real color but we should compatible with it
    link: ["link", "link"],
    text: ["default", "text"]
  };
  const InternalCompoundedButton = /* @__PURE__ */ _react.default.forwardRef((props, ref2) => {
    var _a2, _b;
    const {
      loading = false,
      prefixCls: customizePrefixCls,
      color: color2,
      variant,
      type: type4,
      danger = false,
      shape = "default",
      size: customizeSize,
      styles: styles2,
      disabled: customDisabled,
      className,
      rootClassName,
      children: children2,
      icon: icon2,
      iconPosition = "start",
      ghost = false,
      block: block2 = false,
      // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
      htmlType = "button",
      classNames: customClassNames,
      style: customStyle = {},
      autoInsertSpace,
      autoFocus
    } = props, rest = __rest2(props, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]);
    const mergedType = type4 || "default";
    const [mergedColor, mergedVariant] = (0, _react.useMemo)(() => {
      if (color2 && variant) {
        return [color2, variant];
      }
      const colorVariantPair = ButtonTypeMap[mergedType] || [];
      if (danger) {
        return ["danger", colorVariantPair[1]];
      }
      return colorVariantPair;
    }, [type4, color2, variant, danger]);
    const isDanger = mergedColor === "danger";
    const mergedColorText = isDanger ? "dangerous" : mergedColor;
    const {
      getPrefixCls,
      direction,
      autoInsertSpace: contextAutoInsertSpace,
      className: contextClassName,
      style: contextStyle,
      classNames: contextClassNames,
      styles: contextStyles
    } = (0, _context.useComponentConfig)("button");
    const mergedInsertSpace = (_a2 = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a2 !== void 0 ? _a2 : true;
    const prefixCls = getPrefixCls("btn", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, _style.default)(prefixCls);
    const disabled = (0, _react.useContext)(_DisabledContext.default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, _react.useContext)(_buttonGroup.GroupSizeContext);
    const loadingOrDelay = (0, _react.useMemo)(() => getLoadingConfig(loading), [loading]);
    const [innerLoading, setLoading] = (0, _react.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, _react.useState)(false);
    const buttonRef = (0, _react.useRef)(null);
    const mergedRef = (0, _ref.useComposeRef)(ref2, buttonRef);
    const needInserted = _react.Children.count(children2) === 1 && !icon2 && !(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant);
    const isMountRef = (0, _react.useRef)(true);
    _react.default.useEffect(() => {
      isMountRef.current = false;
      return () => {
        isMountRef.current = true;
      };
    }, []);
    (0, _react.useEffect)(() => {
      let delayTimer = null;
      if (loadingOrDelay.delay > 0) {
        delayTimer = setTimeout(() => {
          delayTimer = null;
          setLoading(true);
        }, loadingOrDelay.delay);
      } else {
        setLoading(loadingOrDelay.loading);
      }
      function cleanupTimer() {
        if (delayTimer) {
          clearTimeout(delayTimer);
          delayTimer = null;
        }
      }
      return cleanupTimer;
    }, [loadingOrDelay]);
    (0, _react.useEffect)(() => {
      if (!buttonRef.current || !mergedInsertSpace) {
        return;
      }
      const buttonText = buttonRef.current.textContent || "";
      if (needInserted && (0, _buttonHelpers.isTwoCNChar)(buttonText)) {
        if (!hasTwoCNChar) {
          setHasTwoCNChar(true);
        }
      } else if (hasTwoCNChar) {
        setHasTwoCNChar(false);
      }
    });
    (0, _react.useEffect)(() => {
      if (autoFocus && buttonRef.current) {
        buttonRef.current.focus();
      }
    }, []);
    const handleClick = _react.default.useCallback((e) => {
      var _a3;
      if (innerLoading || mergedDisabled) {
        e.preventDefault();
        return;
      }
      (_a3 = props.onClick) === null || _a3 === void 0 ? void 0 : _a3.call(props, "href" in props ? e : e);
    }, [props.onClick, innerLoading, mergedDisabled]);
    if (process.env.NODE_ENV !== "production") {
      const warning3 = (0, _warning.devUseWarning)("Button");
      process.env.NODE_ENV !== "production" ? warning3(!(typeof icon2 === "string" && icon2.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon2}\` at https://ant.design/components/icon`) : void 0;
      process.env.NODE_ENV !== "production" ? warning3(!(ghost && (0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant)), "usage", "`link` or `text` button can't be a `ghost` button.") : void 0;
    }
    const {
      compactSize,
      compactItemClassnames
    } = (0, _Compact.useCompactItemContext)(prefixCls, direction);
    const sizeClassNameMap = {
      large: "lg",
      small: "sm",
      middle: void 0
    };
    const sizeFullName = (0, _useSize.default)((ctxSize) => {
      var _a3, _b2;
      return (_b2 = (_a3 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a3 !== void 0 ? _a3 : groupSize) !== null && _b2 !== void 0 ? _b2 : ctxSize;
    });
    const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : "" : "";
    const iconType = innerLoading ? "loading" : icon2;
    const linkButtonRestProps = (0, _omit.default)(rest, ["navigate"]);
    const classes = (0, _classnames.default)(prefixCls, hashId, cssVarCls, {
      [`${prefixCls}-${shape}`]: shape !== "default" && shape,
      // line(253 - 254): Compatible with versions earlier than 5.21.0
      [`${prefixCls}-${mergedType}`]: mergedType,
      [`${prefixCls}-dangerous`]: danger,
      [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
      [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
      [`${prefixCls}-${sizeCls}`]: sizeCls,
      [`${prefixCls}-icon-only`]: !children2 && children2 !== 0 && !!iconType,
      [`${prefixCls}-background-ghost`]: ghost && !(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant),
      [`${prefixCls}-loading`]: innerLoading,
      [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
      [`${prefixCls}-block`]: block2,
      [`${prefixCls}-rtl`]: direction === "rtl",
      [`${prefixCls}-icon-end`]: iconPosition === "end"
    }, compactItemClassnames, className, rootClassName, contextClassName);
    const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
    const iconClasses = (0, _classnames.default)(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles2 === null || styles2 === void 0 ? void 0 : styles2.icon) || {}), contextStyles.icon || {});
    const iconNode = icon2 && !innerLoading ? /* @__PURE__ */ _react.default.createElement(_IconWrapper.default, {
      prefixCls,
      className: iconClasses,
      style: iconStyle
    }, icon2) : loading && typeof loading === "object" && loading.icon ? /* @__PURE__ */ _react.default.createElement(_IconWrapper.default, {
      prefixCls,
      className: iconClasses,
      style: iconStyle
    }, loading.icon) : /* @__PURE__ */ _react.default.createElement(_DefaultLoadingIcon.default, {
      existIcon: !!icon2,
      prefixCls,
      loading: innerLoading,
      mount: isMountRef.current
    });
    const kids = children2 || children2 === 0 ? (0, _buttonHelpers.spaceChildren)(children2, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== void 0) {
      return wrapCSSVar(/* @__PURE__ */ _react.default.createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, _classnames.default)(classes, {
          [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? void 0 : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0
      }), iconNode, kids));
    }
    let buttonNode = /* @__PURE__ */ _react.default.createElement("button", Object.assign({}, rest, {
      type: htmlType,
      className: classes,
      style: fullStyle,
      onClick: handleClick,
      disabled: mergedDisabled,
      ref: mergedRef
    }), iconNode, kids, compactItemClassnames && /* @__PURE__ */ _react.default.createElement(_compact.default, {
      prefixCls
    }));
    if (!(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant)) {
      buttonNode = /* @__PURE__ */ _react.default.createElement(_wave.default, {
        component: "Button",
        disabled: innerLoading
      }, buttonNode);
    }
    return wrapCSSVar(buttonNode);
  });
  const Button2 = InternalCompoundedButton;
  Button2.Group = _buttonGroup.default;
  Button2.__ANT_BUTTON = true;
  if (process.env.NODE_ENV !== "production") {
    Button2.displayName = "Button";
  }
  button.default = Button2;
  return button;
}
var hasRequiredButton;
function requireButton() {
  if (hasRequiredButton) return button$1;
  hasRequiredButton = 1;
  (function(exports$1) {
    "use client";
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    var _exportNames = {};
    exports$1.default = void 0;
    var _button = _interopRequireDefault(/* @__PURE__ */ requireButton$1());
    var _buttonHelpers = /* @__PURE__ */ requireButtonHelpers();
    Object.keys(_buttonHelpers).forEach(function(key) {
      if (key === "default" || key === "__esModule") return;
      if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
      if (key in exports$1 && exports$1[key] === _buttonHelpers[key]) return;
      Object.defineProperty(exports$1, key, {
        enumerable: true,
        get: function() {
          return _buttonHelpers[key];
        }
      });
    });
    exports$1.default = _button.default;
  })(button$1);
  return button$1;
}
var hasRequiredSearch;
function requireSearch() {
  if (hasRequiredSearch) return Search$1;
  hasRequiredSearch = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(Search$1, "__esModule", {
    value: true
  });
  Search$1.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _SearchOutlined = _interopRequireDefault(/* @__PURE__ */ requireSearchOutlined());
  var _classnames = _interopRequireDefault(requireClassnames());
  var _ref = requireRef();
  var _reactNode = /* @__PURE__ */ requireReactNode();
  var _button = _interopRequireDefault(/* @__PURE__ */ requireButton());
  var _configProvider = /* @__PURE__ */ requireConfigProvider();
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _Compact = /* @__PURE__ */ requireCompact$1();
  var _Input = _interopRequireDefault(/* @__PURE__ */ requireInput$1());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const Search2 = /* @__PURE__ */ React2.forwardRef((props, ref2) => {
    const {
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      className,
      size: customizeSize,
      suffix,
      enterButton = false,
      addonAfter,
      loading,
      disabled,
      onSearch: customOnSearch,
      onChange: customOnChange,
      onCompositionStart,
      onCompositionEnd
    } = props, restProps = __rest2(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]);
    const {
      getPrefixCls,
      direction
    } = React2.useContext(_configProvider.ConfigContext);
    const composedRef = React2.useRef(false);
    const prefixCls = getPrefixCls("input-search", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const {
      compactSize
    } = (0, _Compact.useCompactItemContext)(prefixCls, direction);
    const size2 = (0, _useSize.default)((ctx) => {
      var _a2;
      return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
    });
    const inputRef = React2.useRef(null);
    const onChange5 = (e) => {
      if ((e === null || e === void 0 ? void 0 : e.target) && e.type === "click" && customOnSearch) {
        customOnSearch(e.target.value, e, {
          source: "clear"
        });
      }
      customOnChange === null || customOnChange === void 0 ? void 0 : customOnChange(e);
    };
    const onMouseDown = (e) => {
      var _a2;
      if (document.activeElement === ((_a2 = inputRef.current) === null || _a2 === void 0 ? void 0 : _a2.input)) {
        e.preventDefault();
      }
    };
    const onSearch2 = (e) => {
      var _a2, _b;
      if (customOnSearch) {
        customOnSearch((_b = (_a2 = inputRef.current) === null || _a2 === void 0 ? void 0 : _a2.input) === null || _b === void 0 ? void 0 : _b.value, e, {
          source: "input"
        });
      }
    };
    const onPressEnter = (e) => {
      if (composedRef.current || loading) {
        return;
      }
      onSearch2(e);
    };
    const searchIcon = typeof enterButton === "boolean" ? /* @__PURE__ */ React2.createElement(_SearchOutlined.default, null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button2;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") {
      button2 = (0, _reactNode.cloneElement)(enterButtonAsElement, Object.assign({
        onMouseDown,
        onClick: (e) => {
          var _a2, _b;
          (_b = (_a2 = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a2 === void 0 ? void 0 : _a2.onClick) === null || _b === void 0 ? void 0 : _b.call(_a2, e);
          onSearch2(e);
        },
        key: "enterButton"
      }, isAntdButton ? {
        className: btnClassName,
        size: size2
      } : {}));
    } else {
      button2 = /* @__PURE__ */ React2.createElement(_button.default, {
        className: btnClassName,
        type: enterButton ? "primary" : void 0,
        size: size2,
        disabled,
        key: "enterButton",
        onMouseDown,
        onClick: onSearch2,
        loading,
        icon: searchIcon
      }, enterButton);
    }
    if (addonAfter) {
      button2 = [button2, (0, _reactNode.cloneElement)(addonAfter, {
        key: "addonAfter"
      })];
    }
    const cls = (0, _classnames.default)(prefixCls, {
      [`${prefixCls}-rtl`]: direction === "rtl",
      [`${prefixCls}-${size2}`]: !!size2,
      [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const newProps = Object.assign(Object.assign({}, restProps), {
      className: cls,
      prefixCls: inputPrefixCls,
      type: "search"
    });
    const handleOnCompositionStart = (e) => {
      composedRef.current = true;
      onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e) => {
      composedRef.current = false;
      onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
    };
    return /* @__PURE__ */ React2.createElement(_Input.default, Object.assign({
      ref: (0, _ref.composeRef)(inputRef, ref2),
      onPressEnter
    }, newProps, {
      size: size2,
      onCompositionStart: handleOnCompositionStart,
      onCompositionEnd: handleOnCompositionEnd,
      addonAfter: button2,
      suffix,
      onChange: onChange5,
      disabled
    }));
  });
  if (process.env.NODE_ENV !== "production") {
    Search2.displayName = "Search";
  }
  Search$1.default = Search2;
  return Search$1;
}
var TextArea$1 = {};
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection$1(_ref) {
  var children2 = _ref.children, onBatchResize = _ref.onBatchResize;
  var resizeIdRef = React.useRef(0);
  var resizeInfosRef = React.useRef([]);
  var onCollectionResize = React.useContext(CollectionContext);
  var onResize4 = React.useCallback(function(size2, element, data2) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size: size2,
      element,
      data: data2
    });
    Promise.resolve().then(function() {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });
    onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size2, element, data2);
  }, [onBatchResize, onCollectionResize]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: onResize4
  }, children2);
}
var MapShim = (function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex2(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    (function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex2(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex2(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex2(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex2(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a2 = this.__entries__; _i < _a2.length; _i++) {
          var entry = _a2[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    })()
  );
})();
var isBrowser$2 = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = (function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
})();
var requestAnimationFrame$1 = (function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
})();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  (function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer2) {
      if (!~this.observers_.indexOf(observer2)) {
        this.observers_.push(observer2);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer2) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer2);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer2) {
        return observer2.gatherActive(), observer2.hasActive();
      });
      activeObservers.forEach(function(observer2) {
        return observer2.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser$2 || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser$2 || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a2) {
      var _b = _a2.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  })()
);
var defineConfigurable = (function(target, props) {
  for (var _i = 0, _a2 = Object.keys(props); _i < _a2.length; _i++) {
    var key = _a2[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
});
var getWindowOf = (function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
});
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles2) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size2, position2) {
    var value = styles2["border-" + position2 + "-width"];
    return size2 + toFloat(value);
  }, 0);
}
function getPaddings(styles2) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value = styles2["padding-" + position2];
    paddings[position2] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles2 = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles2);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles2.width), height = toFloat(styles2.height);
  if (styles2.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles2, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles2, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = (function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
})();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser$2) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a2) {
  var x = _a2.x, y = _a2.y, width = _a2.width, height = _a2.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x,
    y,
    width,
    height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
function createRectInit(x, y, width, height) {
  return { x, y, width, height };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  })()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  })()
);
var ResizeObserverSPI = (
  /** @class */
  (function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  })()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ResizeObserver2(callback) {
      if (!(this instanceof ResizeObserver2)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer2 = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer2);
    }
    return ResizeObserver2;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method4) {
  ResizeObserver$2.prototype[method4] = function() {
    var _a2;
    return (_a2 = observers.get(this))[method4].apply(_a2, arguments);
  };
});
var index = (function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$2;
})();
var elementListeners = /* @__PURE__ */ new Map();
function onResize(entities) {
  entities.forEach(function(entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
      return listener(target);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV !== "production" ? elementListeners : null;
process.env.NODE_ENV !== "production" ? onResize : null;
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, /* @__PURE__ */ new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}
var DomWrapper = /* @__PURE__ */ (function(_React$Component) {
  _inherits(DomWrapper2, _React$Component);
  var _super = _createSuper(DomWrapper2);
  function DomWrapper2() {
    _classCallCheck(this, DomWrapper2);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper2, [{
    key: "render",
    value: function render2() {
      return this.props.children;
    }
  }]);
  return DomWrapper2;
})(React.Component);
function SingleObserver(props, ref2) {
  var children2 = props.children, disabled = props.disabled;
  var elementRef = React.useRef(null);
  var wrapperRef = React.useRef(null);
  var onCollectionResize = React.useContext(CollectionContext);
  var isRenderProps = typeof children2 === "function";
  var mergedChildren = isRenderProps ? children2(elementRef) : children2;
  var sizeRef = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });
  var canRef = !isRenderProps && /* @__PURE__ */ React.isValidElement(mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? getNodeRef(mergedChildren) : null;
  var mergedRef = useComposeRef(originRef, elementRef);
  var getDom = function getDom2() {
    var _elementRef$current;
    return findDOMNode(elementRef.current) || // Support `nativeElement` format
    (elementRef.current && _typeof$3(elementRef.current) === "object" ? findDOMNode((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || findDOMNode(wrapperRef.current);
  };
  React.useImperativeHandle(ref2, function() {
    return getDom();
  });
  var propsRef = React.useRef(props);
  propsRef.current = props;
  var onInternalResize = React.useCallback(function(target) {
    var _propsRef$current = propsRef.current, onResize4 = _propsRef$current.onResize, data2 = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size2 = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth,
        offsetHeight
      };
      sizeRef.current = size2;
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = _objectSpread2$1(_objectSpread2$1({}, size2), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });
      onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data2);
      if (onResize4) {
        Promise.resolve().then(function() {
          onResize4(sizeInfo, target);
        });
      }
    }
  }, []);
  React.useEffect(function() {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function() {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);
  return /* @__PURE__ */ React.createElement(DomWrapper, {
    ref: wrapperRef
  }, canRef ? /* @__PURE__ */ React.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
if (process.env.NODE_ENV !== "production") {
  RefSingleObserver.displayName = "SingleObserver";
}
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(props, ref2) {
  var children2 = props.children;
  var childNodes = typeof children2 === "function" ? [children2] : toArray$2(children2);
  if (process.env.NODE_ENV !== "production") {
    if (childNodes.length > 1) {
      warning$2(false, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.");
    } else if (childNodes.length === 0) {
      warning$2(false, "`children` of ResizeObserver is empty. Nothing is in observe.");
    }
  }
  return childNodes.map(function(child, index2) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index2);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$6({}, props, {
      key,
      ref: index2 === 0 ? ref2 : void 0
    }), child);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
if (process.env.NODE_ENV !== "production") {
  RefResizeObserver.displayName = "ResizeObserver";
}
RefResizeObserver.Collection = Collection$1;
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node2) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var nodeRef = node2.getAttribute("id") || node2.getAttribute("data-reactid") || node2.getAttribute("name");
  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style2 = window.getComputedStyle(node2);
  var boxSizing = style2.getPropertyValue("box-sizing") || style2.getPropertyValue("-moz-box-sizing") || style2.getPropertyValue("-webkit-box-sizing");
  var paddingSize = parseFloat(style2.getPropertyValue("padding-bottom")) + parseFloat(style2.getPropertyValue("padding-top"));
  var borderSize = parseFloat(style2.getPropertyValue("border-bottom-width")) + parseFloat(style2.getPropertyValue("border-top-width"));
  var sizingStyle = SIZING_STYLE.map(function(name) {
    return "".concat(name, ":").concat(style2.getPropertyValue(name));
  }).join(";");
  var nodeInfo = {
    sizingStyle,
    paddingSize,
    borderSize,
    boxSizing
  };
  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateAutoSizeStyle(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement("textarea");
    hiddenTextarea.setAttribute("tab-index", "-1");
    hiddenTextarea.setAttribute("aria-hidden", "true");
    hiddenTextarea.setAttribute("name", "hiddenTextarea");
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute("wrap")) {
    hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
  } else {
    hiddenTextarea.removeAttribute("wrap");
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
  var minHeight = void 0;
  var maxHeight = void 0;
  var overflowY;
  var height = hiddenTextarea.scrollHeight;
  if (boxSizing === "border-box") {
    height += borderSize;
  } else if (boxSizing === "content-box") {
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = " ";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? "" : "hidden";
      height = Math.min(maxHeight, height);
    }
  }
  var style2 = {
    height,
    overflowY,
    resize: "none"
  };
  if (minHeight) {
    style2.minHeight = minHeight;
  }
  if (maxHeight) {
    style2.maxHeight = maxHeight;
  }
  return style2;
}
var _excluded$4 = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"];
var RESIZE_START = 0;
var RESIZE_MEASURING = 1;
var RESIZE_STABLE = 2;
var ResizableTextArea = /* @__PURE__ */ React.forwardRef(function(props, ref2) {
  var _ref = props, prefixCls = _ref.prefixCls, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize4 = _ref.onResize, className = _ref.className, style2 = _ref.style, disabled = _ref.disabled, onChange5 = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = _objectWithoutProperties$1(_ref, _excluded$4);
  var _useMergedState = useMergedState$1(defaultValue, {
    value,
    postState: function postState(val) {
      return val !== null && val !== void 0 ? val : "";
    }
  }), _useMergedState2 = _slicedToArray$1(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
  var onInternalChange = function onInternalChange2(event) {
    setMergedValue(event.target.value);
    onChange5 === null || onChange5 === void 0 || onChange5(event);
  };
  var textareaRef = React.useRef();
  React.useImperativeHandle(ref2, function() {
    return {
      textArea: textareaRef.current
    };
  });
  var _React$useMemo = React.useMemo(function() {
    if (autoSize && _typeof$1(autoSize) === "object") {
      return [autoSize.minRows, autoSize.maxRows];
    }
    return [];
  }, [autoSize]), _React$useMemo2 = _slicedToArray$1(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
  var needAutoSize = !!autoSize;
  var fixFirefoxAutoScroll = function fixFirefoxAutoScroll2() {
    try {
      if (document.activeElement === textareaRef.current) {
        var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
        textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
        textareaRef.current.scrollTop = scrollTop;
      }
    } catch (e) {
    }
  };
  var _React$useState = React.useState(RESIZE_STABLE), _React$useState2 = _slicedToArray$1(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
  var _React$useState3 = React.useState(), _React$useState4 = _slicedToArray$1(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
  var startResize = function startResize2() {
    setResizeState(RESIZE_START);
    if (process.env.NODE_ENV === "test") {
      onInternalAutoSize === null || onInternalAutoSize === void 0 || onInternalAutoSize();
    }
  };
  useLayoutEffect$1(function() {
    if (needAutoSize) {
      startResize();
    }
  }, [value, minRows, maxRows, needAutoSize]);
  useLayoutEffect$1(function() {
    if (resizeState === RESIZE_START) {
      setResizeState(RESIZE_MEASURING);
    } else if (resizeState === RESIZE_MEASURING) {
      var textareaStyles = calculateAutoSizeStyle(textareaRef.current, false, minRows, maxRows);
      setResizeState(RESIZE_STABLE);
      setAutoSizeStyle(textareaStyles);
    } else {
      fixFirefoxAutoScroll();
    }
  }, [resizeState]);
  var resizeRafRef = React.useRef();
  var cleanRaf = function cleanRaf2() {
    wrapperRaf.cancel(resizeRafRef.current);
  };
  var onInternalResize = function onInternalResize2(size2) {
    if (resizeState === RESIZE_STABLE) {
      onResize4 === null || onResize4 === void 0 || onResize4(size2);
      if (autoSize) {
        cleanRaf();
        resizeRafRef.current = wrapperRaf(function() {
          startResize();
        });
      }
    }
  };
  React.useEffect(function() {
    return cleanRaf;
  }, []);
  var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
  var mergedStyle = _objectSpread2(_objectSpread2({}, style2), mergedAutoSizeStyle);
  if (resizeState === RESIZE_START || resizeState === RESIZE_MEASURING) {
    mergedStyle.overflowY = "hidden";
    mergedStyle.overflowX = "hidden";
  }
  return /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: onInternalResize,
    disabled: !(autoSize || onResize4)
  }, /* @__PURE__ */ React.createElement("textarea", _extends$4({}, restProps, {
    ref: textareaRef,
    style: mergedStyle,
    className: classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)),
    disabled,
    value: mergedValue,
    onChange: onInternalChange
  })));
});
var _excluded$3 = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"];
var TextArea = /* @__PURE__ */ React__default.forwardRef(function(_ref, ref2) {
  var _countConfig$max;
  var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange5 = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style2 = _ref.style, disabled = _ref.disabled, hidden2 = _ref.hidden, classNames$1 = _ref.classNames, styles2 = _ref.styles, onResize4 = _ref.onResize, onClear = _ref.onClear, onPressEnter = _ref.onPressEnter, readOnly = _ref.readOnly, autoSize = _ref.autoSize, onKeyDown = _ref.onKeyDown, rest = _objectWithoutProperties$1(_ref, _excluded$3);
  var _useMergedState = useMergedState$1(defaultValue, {
    value: customValue,
    defaultValue
  }), _useMergedState2 = _slicedToArray$1(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var formatValue = value === void 0 || value === null ? "" : String(value);
  var _React$useState = React__default.useState(false), _React$useState2 = _slicedToArray$1(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var compositionRef = React__default.useRef(false);
  var _React$useState3 = React__default.useState(null), _React$useState4 = _slicedToArray$1(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
  var holderRef = useRef(null);
  var resizableTextAreaRef = useRef(null);
  var getTextArea = function getTextArea2() {
    var _resizableTextAreaRef;
    return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
  };
  var focus = function focus2() {
    getTextArea().focus();
  };
  useImperativeHandle(ref2, function() {
    var _holderRef$current;
    return {
      resizableTextArea: resizableTextAreaRef.current,
      focus,
      blur: function blur() {
        getTextArea().blur();
      },
      nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
    };
  });
  useEffect(function() {
    setFocused(function(prev4) {
      return !disabled && prev4;
    });
  }, [disabled]);
  var _React$useState5 = React__default.useState(null), _React$useState6 = _slicedToArray$1(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
  React__default.useEffect(function() {
    if (selection) {
      var _getTextArea;
      (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, _toConsumableArray$1(selection));
    }
  }, [selection]);
  var countConfig = useCount(count, showCount);
  var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
  var hasMaxLength = Number(mergedMax) > 0;
  var valueLength = countConfig.strategy(formatValue);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;
  var triggerChange = function triggerChange2(e, currentValue) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        setSelection([getTextArea().selectionStart || 0, getTextArea().selectionEnd || 0]);
      }
    }
    setValue(cutValue);
    resolveOnChange(e.currentTarget, e, onChange5, cutValue);
  };
  var onInternalCompositionStart = function onInternalCompositionStart2(e) {
    compositionRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e) {
    compositionRef.current = false;
    triggerChange(e, e.currentTarget.value);
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
  };
  var onInternalChange = function onInternalChange2(e) {
    triggerChange(e, e.target.value);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    if (e.key === "Enter" && onPressEnter) {
      onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleFocus = function handleFocus2(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleBlur = function handleBlur2(e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  var handleReset = function handleReset2(e) {
    setValue("");
    focus();
    resolveOnChange(getTextArea(), e, onChange5);
  };
  var suffixNode = suffix;
  var dataCount;
  if (countConfig.show) {
    if (countConfig.showFormatter) {
      dataCount = countConfig.showFormatter({
        value: formatValue,
        count: valueLength,
        maxLength: mergedMax
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
    }
    suffixNode = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, suffixNode, /* @__PURE__ */ React__default.createElement("span", {
      className: classNames("".concat(prefixCls, "-data-count"), classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.count),
      style: styles2 === null || styles2 === void 0 ? void 0 : styles2.count
    }, dataCount));
  }
  var handleResize = function handleResize2(size2) {
    var _getTextArea2;
    onResize4 === null || onResize4 === void 0 || onResize4(size2);
    if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) {
      setTextareaResized(true);
    }
  };
  var isPureTextArea = !autoSize && !showCount && !allowClear;
  return /* @__PURE__ */ React__default.createElement(BaseInput, {
    ref: holderRef,
    value: formatValue,
    allowClear,
    handleReset,
    suffix: suffixNode,
    prefixCls,
    classNames: _objectSpread2(_objectSpread2({}, classNames$1), {}, {
      affixWrapper: classNames(classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.affixWrapper, _defineProperty(_defineProperty({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
    }),
    disabled,
    focused,
    className: classNames(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
    style: _objectSpread2(_objectSpread2({}, style2), textareaResized && !isPureTextArea ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof dataCount === "string" ? dataCount : void 0
      }
    },
    hidden: hidden2,
    readOnly,
    onClear
  }, /* @__PURE__ */ React__default.createElement(ResizableTextArea, _extends$4({}, rest, {
    autoSize,
    maxLength,
    onKeyDown: handleKeyDown,
    onChange: onInternalChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onCompositionStart: onInternalCompositionStart,
    onCompositionEnd: onInternalCompositionEnd,
    className: classNames(classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.textarea),
    style: _objectSpread2(_objectSpread2({}, styles2 === null || styles2 === void 0 ? void 0 : styles2.textarea), {}, {
      resize: style2 === null || style2 === void 0 ? void 0 : style2.resize
    }),
    disabled,
    prefixCls,
    onResize: handleResize,
    ref: resizableTextAreaRef,
    readOnly
  })));
});
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ResizableTextArea,
  default: TextArea
}, Symbol.toStringTag, { value: "Module" }));
const require$$4 = /* @__PURE__ */ getAugmentedNamespace(es);
var textarea = {};
var hasRequiredTextarea;
function requireTextarea() {
  if (hasRequiredTextarea) return textarea;
  hasRequiredTextarea = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    Object.defineProperty(exports$1, "initComponentToken", {
      enumerable: true,
      get: function() {
        return _token.initComponentToken;
      }
    });
    Object.defineProperty(exports$1, "initInputToken", {
      enumerable: true,
      get: function() {
        return _token.initInputToken;
      }
    });
    var _internal = /* @__PURE__ */ requireInternal();
    var _token = /* @__PURE__ */ requireToken$1();
    const genTextAreaStyle = (token2) => {
      const {
        componentCls,
        paddingLG
      } = token2;
      const textareaPrefixCls = `${componentCls}-textarea`;
      return {
        [textareaPrefixCls]: {
          position: "relative",
          "&-show-count": {
            // https://github.com/ant-design/ant-design/issues/33049
            [`> ${componentCls}`]: {
              height: "100%"
            },
            [`${componentCls}-data-count`]: {
              position: "absolute",
              bottom: token2.calc(token2.fontSize).mul(token2.lineHeight).mul(-1).equal(),
              insetInlineEnd: 0,
              color: token2.colorTextDescription,
              whiteSpace: "nowrap",
              pointerEvents: "none"
            }
          },
          [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
            paddingInlineEnd: paddingLG
          },
          [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
            padding: 0,
            [`> textarea${componentCls}`]: {
              fontSize: "inherit",
              border: "none",
              outline: "none",
              background: "transparent",
              minHeight: token2.calc(token2.controlHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal(),
              "&:focus": {
                boxShadow: "none !important"
              }
            },
            [`${componentCls}-suffix`]: {
              margin: 0,
              "> *:not(:last-child)": {
                marginInline: 0
              },
              // Clear Icon
              [`${componentCls}-clear-icon`]: {
                position: "absolute",
                insetInlineEnd: token2.paddingInline,
                insetBlockStart: token2.paddingXS
              },
              // Feedback Icon
              [`${textareaPrefixCls}-suffix`]: {
                position: "absolute",
                top: 0,
                insetInlineEnd: token2.paddingInline,
                bottom: 0,
                zIndex: 1,
                display: "inline-flex",
                alignItems: "center",
                margin: "auto",
                pointerEvents: "none"
              }
            }
          },
          [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
            [`${componentCls}-suffix`]: {
              [`${componentCls}-clear-icon`]: {
                insetInlineEnd: token2.paddingInlineSM
              }
            }
          }
        }
      };
    };
    exports$1.default = (0, _internal.genStyleHooks)(["Input", "TextArea"], (token2) => {
      const inputToken = (0, _internal.mergeToken)(token2, (0, _token.initInputToken)(token2));
      return [genTextAreaStyle(inputToken)];
    }, _token.initComponentToken, {
      resetFont: false
    });
  })(textarea);
  return textarea;
}
var hasRequiredTextArea;
function requireTextArea() {
  if (hasRequiredTextArea) return TextArea$1;
  hasRequiredTextArea = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  var _interopRequireWildcard = requireInteropRequireWildcard().default;
  Object.defineProperty(TextArea$1, "__esModule", {
    value: true
  });
  TextArea$1.default = void 0;
  var _react = _interopRequireWildcard(React__default);
  var React2 = _react;
  var _classnames = _interopRequireDefault(requireClassnames());
  var _rcTextarea = _interopRequireDefault(require$$4);
  var _getAllowClear = _interopRequireDefault(/* @__PURE__ */ requireGetAllowClear());
  var _statusUtils = /* @__PURE__ */ requireStatusUtils();
  var _warning = /* @__PURE__ */ requireWarning();
  var _context = /* @__PURE__ */ requireContext$1();
  var _DisabledContext = _interopRequireDefault(/* @__PURE__ */ requireDisabledContext());
  var _useCSSVarCls = _interopRequireDefault(/* @__PURE__ */ requireUseCSSVarCls());
  var _useSize = _interopRequireDefault(/* @__PURE__ */ requireUseSize());
  var _context2 = /* @__PURE__ */ requireContext();
  var _useVariants = _interopRequireDefault(/* @__PURE__ */ requireUseVariants());
  var _Compact = /* @__PURE__ */ requireCompact$1();
  var _Input = /* @__PURE__ */ requireInput$1();
  var _style = /* @__PURE__ */ requireStyle$4();
  var _textarea = _interopRequireDefault(/* @__PURE__ */ requireTextarea());
  var __rest2 = function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  const TextArea2 = /* @__PURE__ */ (0, _react.forwardRef)((props, ref2) => {
    var _a2;
    const {
      prefixCls: customizePrefixCls,
      bordered = true,
      size: customizeSize,
      disabled: customDisabled,
      status: customStatus,
      allowClear,
      classNames: classes,
      rootClassName,
      className,
      style: style2,
      styles: styles2,
      variant: customVariant
    } = props, rest = __rest2(props, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
    if (process.env.NODE_ENV !== "production") {
      const {
        deprecated: deprecated2
      } = (0, _warning.devUseWarning)("TextArea");
      deprecated2(!("bordered" in props), "bordered", "variant");
    }
    const {
      getPrefixCls,
      direction,
      allowClear: contextAllowClear,
      autoComplete: contextAutoComplete,
      className: contextClassName,
      style: contextStyle,
      classNames: contextClassNames,
      styles: contextStyles
    } = (0, _context.useComponentConfig)("textArea");
    const disabled = React2.useContext(_DisabledContext.default);
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const {
      status: contextStatus,
      hasFeedback,
      feedbackIcon
    } = React2.useContext(_context2.FormItemInputContext);
    const mergedStatus = (0, _statusUtils.getMergedStatus)(contextStatus, customStatus);
    const innerRef = React2.useRef(null);
    React2.useImperativeHandle(ref2, () => {
      var _a3;
      return {
        resizableTextArea: (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.resizableTextArea,
        focus: (option) => {
          var _a4, _b;
          (0, _Input.triggerFocus)((_b = (_a4 = innerRef.current) === null || _a4 === void 0 ? void 0 : _a4.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
        },
        blur: () => {
          var _a4;
          return (_a4 = innerRef.current) === null || _a4 === void 0 ? void 0 : _a4.blur();
        }
      };
    });
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    const rootCls = (0, _useCSSVarCls.default)(prefixCls);
    const [wrapSharedCSSVar, hashId, cssVarCls] = (0, _style.useSharedStyle)(prefixCls, rootClassName);
    const [wrapCSSVar] = (0, _textarea.default)(prefixCls, rootCls);
    const {
      compactSize,
      compactItemClassnames
    } = (0, _Compact.useCompactItemContext)(prefixCls, direction);
    const mergedSize = (0, _useSize.default)((ctx) => {
      var _a3;
      return (_a3 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a3 !== void 0 ? _a3 : ctx;
    });
    const [variant, enableVariantCls] = (0, _useVariants.default)("textArea", customVariant, bordered);
    const mergedAllowClear = (0, _getAllowClear.default)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
    return wrapSharedCSSVar(wrapCSSVar(/* @__PURE__ */ React2.createElement(_rcTextarea.default, Object.assign({
      autoComplete: contextAutoComplete
    }, rest, {
      style: Object.assign(Object.assign({}, contextStyle), style2),
      styles: Object.assign(Object.assign({}, contextStyles), styles2),
      disabled: mergedDisabled,
      allowClear: mergedAllowClear,
      className: (0, _classnames.default)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName),
      classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
        textarea: (0, _classnames.default)({
          [`${prefixCls}-sm`]: mergedSize === "small",
          [`${prefixCls}-lg`]: mergedSize === "large"
        }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, contextClassNames.textarea),
        variant: (0, _classnames.default)({
          [`${prefixCls}-${variant}`]: enableVariantCls
        }, (0, _statusUtils.getStatusClassNames)(prefixCls, mergedStatus)),
        affixWrapper: (0, _classnames.default)(`${prefixCls}-textarea-affix-wrapper`, {
          [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
          [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
          [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
          [`${prefixCls}-textarea-show-count`]: props.showCount || ((_a2 = props.count) === null || _a2 === void 0 ? void 0 : _a2.show)
        }, hashId)
      }),
      prefixCls,
      suffix: hasFeedback && /* @__PURE__ */ React2.createElement("span", {
        className: `${prefixCls}-textarea-suffix`
      }, feedbackIcon),
      ref: innerRef
    }))));
  });
  TextArea$1.default = TextArea2;
  return TextArea$1;
}
var hasRequiredInput;
function requireInput() {
  if (hasRequiredInput) return input;
  hasRequiredInput = 1;
  var _interopRequireDefault = requireInteropRequireDefault().default;
  Object.defineProperty(input, "__esModule", {
    value: true
  });
  input.default = void 0;
  var _Group = _interopRequireDefault(/* @__PURE__ */ requireGroup$1());
  var _Input = _interopRequireDefault(/* @__PURE__ */ requireInput$1());
  var _OTP = _interopRequireDefault(/* @__PURE__ */ requireOTP());
  var _Password = _interopRequireDefault(/* @__PURE__ */ requirePassword());
  var _Search = _interopRequireDefault(/* @__PURE__ */ requireSearch());
  var _TextArea = _interopRequireDefault(/* @__PURE__ */ requireTextArea());
  const Input2 = _Input.default;
  Input2.Group = _Group.default;
  Input2.Search = _Search.default;
  Input2.TextArea = _TextArea.default;
  Input2.Password = _Password.default;
  Input2.OTP = _OTP.default;
  input.default = Input2;
  return input;
}
var inputExports = /* @__PURE__ */ requireInput();
const Input = /* @__PURE__ */ getDefaultExportFromCjs(inputExports);
const useDebouncedCallback = (callback, dependencies, delay, options) => {
  return React__default.useCallback(lodashExports.debounce((...args) => {
    callback(...args);
  }, delay.milliseconds, options), [...dependencies]);
};
const InputSearch = ({ debounce = 300, onSearch: onSearch2, width = 250, searchIcon = /* @__PURE__ */ jsx$1(SearchOutlined$3, {}), iconInSuffux = false, settings, debounceSettings, ...rest }) => {
  if (typeof rest.allowClear === void 0) {
    rest.allowClear = true;
  }
  const ctx = useContext(Context$3);
  const loc = ctx.loc;
  const search3 = useDebouncedCallback((search22) => {
    onSearch2?.(search22);
  }, [], TimeSpan.fromMilliseconds(debounce ?? 300), { ...debounceSettings });
  const suffix = useMemo$2(() => {
    const suffix2 = [];
    if (settings?.match.enabled === true)
      suffix2.push(
        /* @__PURE__ */ jsx$1(
          FontColorsOutlined,
          {
            title: loc.word("InputSearch.matchWholeWordHelp", { default: "Match whole word" }),
            onClick: () => settings.match.onChange(!settings.match.value),
            className: settings.match.value === true ? "color-primary" : "color-secondary"
          }
        )
      );
    if (iconInSuffux === true)
      suffix2.push(searchIcon);
    return suffix2;
  }, [settings?.match, iconInSuffux, searchIcon]);
  return /* @__PURE__ */ jsx$1(
    Input,
    {
      ...rest,
      onChange: (e) => {
        rest.onChange?.(e);
        search3(e.target.value);
      },
      placeholder: rest.placeholder ?? loc.word("Search"),
      prefix: !iconInSuffux ? searchIcon : void 0,
      suffix,
      style: rest.style ?? { width }
    }
  );
};
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3(target, key, result);
  return result;
};
class ViewFileManagerItem extends FileManagerItem {
  constructor() {
    super(...arguments);
    this.isSelected = false;
    this.isUploading = false;
    this.isRenaming = false;
  }
}
__decorateClass$3([
  observable
], ViewFileManagerItem.prototype, "isSelected", 2);
__decorateClass$3([
  observable
], ViewFileManagerItem.prototype, "isUploading", 2);
__decorateClass$3([
  observable
], ViewFileManagerItem.prototype, "isRenaming", 2);
const LocalStorageParentIdKey = "fileManagerParentId";
class FileManagerStore {
  constructor(api2, loc, keygen) {
    this.api = api2;
    this.items = [];
    this.path = [];
    this.isLoaded = false;
    this.isVisible = false;
    this.currentParentId = localStorage.getItem(LocalStorageParentIdKey);
    this.api = api2;
    this.loc = loc;
    this.keygen = keygen;
  }
  get selectedItems() {
    return this.items.filter((x) => x.isSelected);
  }
  async addFile(item2) {
    this.items.push(item2);
    this.sortItems();
  }
  async abortUploading(item2) {
    if (item2.isUploading) {
      this.removeItemFromList(item2);
    } else {
      this.removeItemFromServer(item2);
      this.removeItemFromList(item2);
    }
  }
  async fileNameExists(name) {
    return this.items.some((x) => x.name == name);
  }
  changeParent(id2 = null) {
    this.currentParentId = id2;
    if (this.currentParentId) {
      localStorage.setItem(LocalStorageParentIdKey, this.currentParentId);
    } else {
      localStorage.removeItem(LocalStorageParentIdKey);
    }
    this.deselectAll();
    this.fetchFiles();
  }
  deselectAll() {
    this.selectedItems.forEach((x) => x.isSelected = false);
  }
  get parentFolder() {
    if (this.currentParentId || this.path.length == 1) {
      return _.last(this.path)?.parentId || null;
    }
    return null;
  }
  goOneLevelUp() {
    this.changeParent(this.parentFolder);
  }
  async createFileManagerItem(item2, file) {
    const result = await this.api.fileManager.createItem(new CreateFileManagerItemRequest(item2.name, "fileSystem", { fileId: file.id }, item2.parentId));
    if (result.success) {
      runInAction(() => item2.id = result.response?.id);
    }
    return result;
  }
  async uploadFiles(files) {
    if (files.length == 0) return;
    for (const file of files) {
      var newFileItem = new ViewFileManagerItem(
        new FileManagerItem({
          id: "_" + this.keygen.generate(),
          name: file.name,
          file: AccelFile.fromFile(file),
          parentId: this.currentParentId,
          type: FileManagerItemType.File
        })
      );
      newFileItem.isUploading = true;
      this.addFile(newFileItem);
    }
  }
  async createFileManagerDirectory() {
    var newDirName = this.loc.word("New Folder");
    var i = 1;
    while (await this.fileNameExists(newDirName) == true) {
      newDirName = `${this.loc.word("New Folder")} ${i}`;
      i++;
    }
    var newDir = new ViewFileManagerItem(
      new FileManagerItem({
        id: "_" + this.keygen.generate(),
        type: FileManagerItemType.Directory,
        name: newDirName,
        parentId: this.currentParentId,
        sectionType: "fileSystem"
      })
    );
    const result = await this.api.fileManager.createDirectory(new CreateFileManagerDirectoryRequest(newDir));
    if (result.success) {
      runInAction(() => newDir.id = result.response.id);
      this.addFile(newDir);
    }
    return result;
  }
  async removeItemFromServer(item2) {
    const result = await this.api.fileManager.remove(new FileManagerItemFilter({ ids: [item2.id] }));
    return result;
  }
  removeItemFromList(item2) {
    this.items = this.items.filter((x) => x.id != item2.id);
  }
  async fetchFiles() {
    this.isLoaded = false;
    this.updateFilter({ take: 1e3, parentId: this.currentParentId });
    const result = await this.api.fileManager.fetchItems(new FetchFileManagerItemsRequest(
      this.filter,
      `{ id, name, updatedDate, createdDate, type, parentId, softDeleted, file{ id, name, size, type, mimeType, cloudKey, extension }}`
    ));
    if (result.success) {
      runInAction(() => {
        var itemList = result.response.items.map((x) => new ViewFileManagerItem(x));
        this.items = _.orderBy(itemList, ["type", "createdDate"], ["asc", "desc"]);
        this.path = result.response.path.map((x) => new ViewFileManagerItem(x));
        this.filter = result.response.filter;
      });
    } else {
      if (result.response.hasError(ErrorCode.DirectoryNotFound)) {
        this.changeParent();
        return;
      }
    }
    runInAction(() => {
      this.isLoaded = true;
    });
  }
  updateFilter(changes) {
    if (this.filter == null)
      this.filter = new FileManagerItemFilter({ sectionType: "fileSystem" });
    this.filter.update({ ...changes, sectionType: "fileSystem" });
  }
  async sortItems() {
    this.items = _.orderBy(this.items, ["type", "createdDate"], ["asc", "desc"]);
  }
  async renameSaveToServer(item2) {
    runInAction(() => {
      item2.name = item2.newTemporaryName || "";
    });
    const result = await this.api.fileManager.updateItem(new UpdateFileManagerItemRequest(item2));
    return result;
  }
  async changeParentFolderSaveToServer(item2, newFolderId) {
    runInAction(() => {
      item2.parentId = newFolderId;
    });
    const result = await this.api.fileManager.updateItem(new UpdateFileManagerItemRequest(item2));
    return result;
  }
}
__decorateClass$3([
  observable
], FileManagerStore.prototype, "items", 2);
__decorateClass$3([
  observable
], FileManagerStore.prototype, "path", 2);
__decorateClass$3([
  observable
], FileManagerStore.prototype, "filter", 2);
__decorateClass$3([
  observable
], FileManagerStore.prototype, "isLoaded", 2);
__decorateClass$3([
  observable
], FileManagerStore.prototype, "isVisible", 2);
__decorateClass$3([
  observable
], FileManagerStore.prototype, "currentParentId", 2);
__decorateClass$3([
  computed
], FileManagerStore.prototype, "selectedItems", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "addFile", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "abortUploading", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "fileNameExists", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "changeParent", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "deselectAll", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "removeItemFromServer", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "removeItemFromList", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "fetchFiles", 1);
__decorateClass$3([
  action
], FileManagerStore.prototype, "updateFilter", 1);
const fileManagerHolder = "_fileManagerHolder_oe1yk_2";
const fileManagerTreeHolder = "_fileManagerTreeHolder_oe1yk_9";
const fileManagerTreeHolderLoading = "_fileManagerTreeHolderLoading_oe1yk_17";
const fileManagerFooter = "_fileManagerFooter_oe1yk_23";
const fileManagerNoFileAlert = "_fileManagerNoFileAlert_oe1yk_27";
const fileManagerTreeItem = "_fileManagerTreeItem_oe1yk_35";
const fileManagerTreeItemDropActive = "_fileManagerTreeItemDropActive_oe1yk_51";
const fileManagerTreeItemMoved = "_fileManagerTreeItemMoved_oe1yk_55";
const fileManagerTreeItemGoUp = "_fileManagerTreeItemGoUp_oe1yk_74";
const fileManagerTreeItemSelected = "_fileManagerTreeItemSelected_oe1yk_84";
const fileManagerTreeItemOverlay = "_fileManagerTreeItemOverlay_oe1yk_89";
const fileManagerPath = "_fileManagerPath_oe1yk_101";
const fileManagerPathItem = "_fileManagerPathItem_oe1yk_108";
const itemMeta = "_itemMeta_oe1yk_128";
const itemMetaContent = "_itemMetaContent_oe1yk_135";
const menu = "_menu_oe1yk_158";
const itemPreview = "_itemPreview_oe1yk_183";
const imageCover = "_imageCover_oe1yk_193";
const dropzone_holder = "_dropzone_holder_oe1yk_201";
const styles$I = {
  fileManagerHolder,
  fileManagerTreeHolder,
  fileManagerTreeHolderLoading,
  fileManagerFooter,
  fileManagerNoFileAlert,
  fileManagerTreeItem,
  fileManagerTreeItemDropActive,
  fileManagerTreeItemMoved,
  fileManagerTreeItemGoUp,
  fileManagerTreeItemSelected,
  fileManagerTreeItemOverlay,
  fileManagerPath,
  fileManagerPathItem,
  itemMeta,
  itemMetaContent,
  menu,
  itemPreview,
  imageCover,
  dropzone_holder
};
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2(target, key, result);
  return result;
};
class DragDropManager {
  constructor() {
    this.sources = [];
    this.targets = [];
    this.currentSource = null;
    this.currentTarget = null;
    this.setCurrentTarget = lodashExports.debounce(this.setCurrentTarget.bind(this), 10, { leading: true });
  }
  addSource(source) {
    this.sources.push(source);
    return source;
  }
  addTarget(target) {
    this.targets.push(target);
    return target;
  }
  deleteSource(source) {
    this.sources = this.sources.filter((x) => x != source);
  }
  deleteTarget(target) {
    this.targets = this.targets.filter((x) => x != target);
  }
  setCurrentSource(source) {
    this.currentSource = source;
  }
  setCurrentTarget(target, callback) {
    this.currentTarget = target;
    callback?.();
  }
  isCurrentSource(source) {
    return this.currentSource == source;
  }
  isCurrentTarget(target) {
    return this.currentTarget == target;
  }
}
__decorateClass$2([
  observable
], DragDropManager.prototype, "sources", 2);
__decorateClass$2([
  observable
], DragDropManager.prototype, "targets", 2);
__decorateClass$2([
  observable
], DragDropManager.prototype, "currentSource", 2);
__decorateClass$2([
  observable
], DragDropManager.prototype, "currentTarget", 2);
__decorateClass$2([
  action
], DragDropManager.prototype, "addSource", 1);
__decorateClass$2([
  action
], DragDropManager.prototype, "addTarget", 1);
__decorateClass$2([
  action
], DragDropManager.prototype, "deleteSource", 1);
__decorateClass$2([
  action
], DragDropManager.prototype, "deleteTarget", 1);
__decorateClass$2([
  action
], DragDropManager.prototype, "setCurrentSource", 1);
__decorateClass$2([
  action
], DragDropManager.prototype, "setCurrentTarget", 1);
const DragDropContext = React__default.createContext();
const DragDropProvider = ({ children: children2 }) => {
  const [manager] = useState$1(new DragDropManager());
  const ctx = {
    manager
  };
  return /* @__PURE__ */ jsx$1(DragDropContext.Provider, { value: ctx, children: children2 });
};
function useDrag(props) {
  const sourceRef = useRef(null);
  const handlerRef = useRef(null);
  const { manager } = useContext(DragDropContext);
  const state = useLocalStore(() => ({
    manager,
    source: null,
    get isDragging() {
      return state.source != null && manager.isCurrentSource(state.source);
    },
    get draggable() {
      return props.draggable?.() ?? true;
    },
    get target() {
      if (!state.isDragging) return null;
      return manager.currentTarget;
    }
  }));
  const getSourceElement = () => sourceRef.current;
  const getHandlerElement = () => handlerRef.current ?? sourceRef.current;
  const onMouseDown = useCallback((e) => {
    log2();
    if (!state.draggable) return false;
    state.source.e = e;
    const srcElement = getSourceElement();
    srcElement.setAttribute("draggable", "true");
    props.onMouseDown?.(e);
  }, []);
  const onMouseUp = useCallback((e) => {
    log2();
    if (!state.source || !state.source.e) return;
    state.source.e = void 0;
    const srcElement = getSourceElement();
    srcElement.removeAttribute("draggable");
    props.onMouseUp?.(e);
  }, []);
  const onDragStart2 = useCallback((e) => {
    log2();
    manager.setCurrentSource(state.source);
    props.onStart?.(e);
  }, []);
  const onDrag = useCallback(lodashExports.throttle((e) => {
    log2();
    props.onDrag?.(e);
  }, 100, { leading: true, trailing: false }), []);
  const onDragEnd2 = useCallback((e) => {
    log2();
    manager.setCurrentSource(null);
    const srcElement = getSourceElement();
    srcElement.removeAttribute("draggable");
    props.onStop?.(e);
  }, []);
  const log2 = (msg) => {
  };
  useEffect(() => {
    const handlerElement = getHandlerElement();
    if (handlerElement == null) return;
    const srcElement = getSourceElement();
    const source = manager.addSource({
      el: srcElement,
      handlerEl: handlerElement,
      data: props.data,
      type: props.type
    });
    runInAction(() => state.source = source);
    handlerElement.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    srcElement.addEventListener("dragstart", onDragStart2);
    srcElement.addEventListener("drag", onDrag);
    srcElement.addEventListener("dragend", onDragEnd2);
    return () => {
      manager.deleteSource(state.source);
      handlerElement.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      srcElement.removeEventListener("dragstart", onDragStart2);
      srcElement.removeEventListener("drag", onDrag);
      srcElement.removeEventListener("dragend", onDragEnd2);
    };
  }, [sourceRef, handlerRef]);
  return [state, {
    sourceRef,
    handlerRef
  }];
}
function useDrop(props) {
  const targetRef = useRef(null);
  const { manager } = useContext(DragDropContext);
  const state = useLocalStore(() => ({
    manager,
    target: null,
    get targetBoundingClientRect() {
      if (state.target == null) return null;
      return state.target.el.getBoundingClientRect();
    },
    get source() {
      if (!state.target || !manager.isCurrentTarget(state.target))
        return null;
      return manager.currentSource;
    },
    get dragState() {
      if (!state.source) return null;
      return {
        canDrop: state.canDrop,
        source: state.source,
        position: state.position
      };
    },
    get canDrop() {
      if (state.source == null) return false;
      if (props.droppable && !props.droppable()) return false;
      if (props.accept && state.source.type && !props.accept.includes(state.source.type))
        return false;
      if (props.canDrop && !props.canDrop(state.source, { ...state.position }, state.overEv)) return false;
      return true;
    },
    get position() {
      if (!state.overEv || state.target == null) return null;
      const e = state.overEv;
      let rect = state.target.el.getBoundingClientRect();
      return {
        vertical: e.y - rect.y <= rect.bottom - e.y ? "top" : "bottom",
        horizontal: e.x - rect.x <= rect.right - e.x ? "left" : "right"
      };
    },
    get direction() {
      if (!state.prevOverEv || !state.overEv) return null;
      return {
        horizontal: state.prevOverEv.clientX < state.overEv.clientX ? "right" : "left",
        vertical: state.prevOverEv.clientY > state.overEv.clientY ? "upwards" : "downwards"
      };
    }
  }));
  const onDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (manager.isCurrentTarget(state.target)) return;
    manager.setCurrentTarget(state.target, () => {
      log2("onDragEnter");
      props.onEnter?.(state.source, state.position, e);
    });
    runInAction(() => {
      state.overEv = e;
    });
    return false;
  }, []);
  const onDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!manager.isCurrentTarget(state.target)) {
      props.onLeave?.(state.source, e);
      log2("onDragLeave");
      return;
    }
    let rect = state.targetBoundingClientRect;
    if (e.x >= rect.left + rect.width || e.x <= rect.left || e.y >= rect.top + rect.height || e.y <= rect.top) {
      manager.setCurrentTarget(null, () => {
        log2("onDragLeave");
        props.onLeave?.(state.source, e);
      });
      return false;
    }
  }, []);
  const onDragOver = useCallback((e) => {
    e.preventDefault();
    if (state.overEv && Math.abs(e.x - state.overEv.x) < (props.dragThreshold?.x ?? 5) && Math.abs(e.y - state.overEv.y) < (props.dragThreshold?.y ?? 5))
      return;
    return onOver(e);
  }, []);
  const onOver = lodashExports.debounce((e) => {
    if (manager.currentTarget == null) return true;
    log2("onDragOver");
    runInAction(() => {
      state.prevOverEv = state.overEv;
      state.overEv = e;
    });
    if (!state.canDrop) return true;
    props.onOver?.(state.source, state.position, state.direction, e);
    return false;
  }, 10, { leading: true });
  const onDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    log2("onDrop");
    if (state.canDrop) {
      props.onDrop?.(state.source, { ...state.position }, e);
    }
    manager.setCurrentSource(null);
    manager.setCurrentTarget(null);
    runInAction(() => {
      state.overEv = void 0;
      state.prevOverEv = void 0;
    });
    return false;
  }, []);
  const log2 = (msg) => {
    console.logDev(msg);
  };
  useEffect(() => {
    const dropElement = targetRef.current;
    if (dropElement == null)
      return;
    const target = manager.addTarget({
      el: dropElement,
      accept: props.accept
    });
    runInAction(() => state.target = target);
    dropElement.setAttribute("droppable", "true");
    dropElement.addEventListener("dragenter", onDragEnter);
    dropElement.addEventListener("dragleave", onDragLeave);
    dropElement.addEventListener("dragover", onDragOver);
    dropElement.addEventListener("drop", onDrop);
    return () => {
      manager.deleteTarget(state.target);
      dropElement.removeAttribute("droppable");
      dropElement.removeEventListener("dragenter", onDragEnter);
      dropElement.removeEventListener("dragleave", onDragLeave);
      dropElement.removeEventListener("dragover", onDragOver);
      dropElement.removeEventListener("drop", onDrop);
    };
  }, [targetRef]);
  return [state, targetRef];
}
const FileManagerOneItem = ({ item: item2, fileManager, managerStore }) => {
  const ctx = useContext(Context$3);
  const { loc, api: api2 } = ctx;
  const [fileItemStore] = useState$1(new FileItemStore(api2.file));
  const [isDropActive, setIsDropActive] = useState$1(false);
  const [isMoved, setIsMoved] = useState$1(false);
  const renameInputRef = useRef(null);
  const getProperRef = () => item2.type == FileManagerItemType.File ? sourceRef : dropRef;
  const [, { sourceRef }] = useDrag({
    data: item2
  });
  const [, dropRef] = useDrop({
    onDrop: async (src, _2, e) => {
      changeParent(src.data, item2.id);
    },
    onEnter: () => setIsDropActive(true),
    onLeave: () => setIsDropActive(false)
  });
  useEffect(() => {
    item2.itemHandler = {
      delete: deleteItem,
      rename,
      changeParent,
      setMoved: setIsMoved
    };
  }, []);
  useEffect(() => {
    if (!item2.isUploading || item2.type != FileManagerItemType.File) return;
    fileItemStore.aborted.on((x) => managerStore.abortUploading(item2));
    fileItemStore.uploaded.on((uploadedFile) => {
      item2.isUploading = false;
      item2.file.update(uploadedFile);
      managerStore.createFileManagerItem(item2, uploadedFile);
    });
    fileItemStore.setFile(item2.file);
    if (item2.file.nativeFile) fileItemStore.upload();
  }, [item2.isUploading]);
  useEffect(() => {
    if (!item2.isRenaming) return;
    renameInputRef?.current?.focus();
    renameInputRef?.current?.select();
  }, [item2.isRenaming]);
  const changeParent = async (droppedItem, newFolderId) => {
    var result = await managerStore.changeParentFolderSaveToServer(droppedItem, newFolderId);
    if (result.success)
      droppedItem?.itemHandler?.setMoved(true);
    result.notify({
      success: {
        message: loc.word("FM.updateFile.successfulMsg", { default: "File/folder updated successfully" }),
        duration: 2
      },
      loc
    });
  };
  const selectToggle = () => {
    if (fileManager.mode == FileManagerMode.SelectOneURL) {
      managerStore.deselectAll();
    }
    runInAction(() => item2.isSelected = !item2.isSelected);
    if (item2.isSelected && item2.type == FileManagerItemType.File) {
      fileManager.onSelected();
    }
  };
  const onDoubleClick = () => {
    if (item2.isRenaming) return;
    if (item2.type == FileManagerItemType.Directory)
      managerStore.changeParent(item2.id);
  };
  const abortUploading = () => {
    fileItemStore.abort();
    managerStore.abortUploading(item2);
  };
  const rename = () => {
    renameCancel();
    runInAction(() => {
      item2.newTemporaryName = item2.name;
      item2.isRenaming = true;
    });
    setTimeout(() => {
      window.addEventListener("keyup", renameKeyUpListener);
      window.addEventListener("click", renameOnOutsideClick);
    }, 33);
  };
  const renameKeyUpListener = async (e) => {
    switch (e.keyCode) {
      case KeyCode$1.Escape:
        renameCancel();
        break;
      case KeyCode$1.Enter:
        renameApply();
        break;
    }
  };
  const renameApply = async () => {
    var result = await managerStore.renameSaveToServer(item2);
    if (result.success)
      renameCancel();
    result.notify({
      success: {
        message: loc.word("FM.updateFile.successfulMsg", { default: "File/folder updated successfully" }),
        duration: 2
      },
      error: { message: loc.word("Error occured"), duration: 2 }
    });
  };
  const renameOnOutsideClick = (e) => {
    if (item2.isRenaming == false) return;
    const ref2 = getProperRef();
    if (ref2.current && ref2.current != e.target && !ref2.current.contains(e.target)) {
      renameApply();
    }
  };
  const renameCancel = () => {
    runInAction(() => {
      item2.isRenaming = false;
    });
    window.removeEventListener("keyup", renameKeyUpListener);
    window.removeEventListener("click", renameOnOutsideClick);
  };
  const deleteItem = () => {
    fileManager.deleteSelected(item2);
  };
  const renderPreview = () => {
    if (item2.type == FileManagerItemType.Directory) return /* @__PURE__ */ jsx$1(FolderOutlined, {});
    if (!item2.file) return /* @__PURE__ */ jsx$1(FileOutlined, {});
    if (item2.file.type == FileType.Image || item2.file.previewImage) {
      return /* @__PURE__ */ jsx$1("div", { className: styles$I.imageCover, style: { backgroundImage: `url('${fileManager.fileProvider.getUrl(item2.file)}')` } });
    }
    if (item2.file.type == FileType.Video)
      return /* @__PURE__ */ jsx$1("div", { className: styles$I.imageCover, style: { backgroundImage: `url('${fileManager.fileProvider.getUrlByKey(item2.file.videoThumbnailUrl)}')` } });
    if (item2.file.mimetype) {
      if (item2.file.mimetype.includes("doc")) return /* @__PURE__ */ jsx$1(FileWordOutlined, {});
      if (item2.file.mimetype.includes("pdf")) return /* @__PURE__ */ jsx$1(FilePdfOutlined, {});
      if (item2.file.mimetype.includes("xls")) return /* @__PURE__ */ jsx$1(FileExcelOutlined, {});
      if (item2.file.mimetype.includes("ppt")) return /* @__PURE__ */ jsx$1(FilePptOutlined, {});
      if (item2.file.mimetype.includes("zip") || item2.file.mimetype.includes("rar")) return /* @__PURE__ */ jsx$1(FileZipOutlined, {});
    }
    return /* @__PURE__ */ jsx$1(FileOutlined, {});
  };
  const menu2 = () => {
    return /* @__PURE__ */ jsxs(Menu, { children: [
      item2.type == FileManagerItemType.Directory && /* @__PURE__ */ jsx$1(Menu.Item, { onClick: () => onDoubleClick(), children: loc.word("Do Open") }, "0"),
      /* @__PURE__ */ jsx$1(Menu.Item, { onClick: () => rename(), children: loc.word("Rename") }, "1"),
      /* @__PURE__ */ jsx$1(Menu.Item, { onClick: () => deleteItem(), children: loc.word("Delete") }, "2")
    ] });
  };
  if (item2.type == FileManagerItemType.File && !item2?.id) return null;
  if (fileItemStore.status == FileUploadStatus.Error) {
    return /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerTreeItem, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$I.itemPreview, children: [
        /* @__PURE__ */ jsx$1(Tooltip, { title: /* @__PURE__ */ jsxs(Fragment, { children: [
          loc.word("Error occured"),
          loc.word("Click to remove image")
        ] }), children: /* @__PURE__ */ jsx$1("div", { onClick: () => managerStore.removeItemFromList(item2), style: { cursor: "pointer" }, className: styles$I.fileManagerTreeItemOverlay, children: /* @__PURE__ */ jsx$1(Progress, { type: "circle", percent: 100, status: "exception", width: 40 }) }) }),
        renderPreview()
      ] }),
      /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMeta, children: /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMetaContent, children: item2.name }) })
    ] });
  } else if (fileItemStore.status == FileUploadStatus.Uploading) {
    return /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerTreeItem, children: [
      /* @__PURE__ */ jsxs("div", { className: styles$I.itemPreview, children: [
        /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Click to cancel uploading"), children: /* @__PURE__ */ jsx$1("div", { onClick: () => abortUploading(), style: { cursor: "pointer" }, className: styles$I.fileManagerTreeItemOverlay, children: /* @__PURE__ */ jsx$1(Progress, { type: "circle", percent: fileItemStore.percent, width: 40 }) }) }),
        renderPreview()
      ] }),
      /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMeta, children: /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMetaContent, children: item2.name }) })
    ] });
  }
  const itemClasses = [styles$I.fileManagerTreeItem];
  if (item2.isSelected) itemClasses.push(styles$I.fileManagerTreeItemSelected);
  if (isDropActive) itemClasses.push(styles$I.fileManagerTreeItemDropActive);
  if (isMoved) itemClasses.push(styles$I.fileManagerTreeItemMoved);
  return /* @__PURE__ */ jsx$1(Dropdown, { overlay: menu2(), trigger: ["contextMenu"], children: /* @__PURE__ */ jsxs(
    "div",
    {
      ref: getProperRef(),
      className: itemClasses.join(" "),
      onDoubleClick: () => onDoubleClick(),
      onClick: () => selectToggle(),
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$I.itemPreview, children: renderPreview() }),
        /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMeta, children: item2.isRenaming ? /* @__PURE__ */ jsx$1("div", { className: styles$I.itemMetaContent, children: /* @__PURE__ */ jsx$1("input", { ref: renameInputRef, type: "text", defaultValue: item2.name, onKeyUp: (e) => item2.newTemporaryName = e.target.value }) }) : /* @__PURE__ */ jsxs("div", { className: styles$I.itemMetaContent, children: [
          item2.name,
          item2.type == FileManagerItemType.File ? item2.file.extension : void 0
        ] }) })
      ]
    }
  ) });
};
const FileManagerOneItem$1 = observer(FileManagerOneItem);
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1(target, key, result);
  return result;
};
var FileManagerMode = /* @__PURE__ */ ((FileManagerMode2) => {
  FileManagerMode2["Free"] = "Free";
  FileManagerMode2["SelectOneURL"] = "SelectOneUrl";
  FileManagerMode2["SelectFileId"] = "SelectFileId";
  FileManagerMode2["SelectFile"] = "SelectFile";
  return FileManagerMode2;
})(FileManagerMode || {});
let FileManager = class extends React__default.Component {
  constructor(props, context2) {
    super(props, context2);
    this.mode = this.props.mode || "Free";
    this.backButtonRef = React__default.createRef();
    this.loc = context2.loc;
    this.fileProvider = context2.fileProvider;
    this.fileManagerStore = new FileManagerStore(context2.api, context2.loc, context2.keygen);
  }
  showModal() {
    this.fileManagerStore.isVisible = true;
    this.fileManagerStore.updateFilter({ fileType: this.props.accept ?? void 0 });
    this.fileManagerStore.fetchFiles();
  }
  closeModal() {
    this.fileManagerStore.isVisible = false;
    if (typeof this.props.onClose == "function") this.props.onClose();
  }
  async uploadFiles(files) {
    await this.fileManagerStore.uploadFiles(files);
  }
  async createDirectory() {
    var createResult = await this.fileManagerStore.createFileManagerDirectory();
    if (createResult.success == false || createResult.response.errors.length > 0) {
      notification.error({
        message: this.loc.word("Folder creation error"),
        description: createResult.response.errors[0].message
      });
    }
  }
  renameSelected() {
    var item2 = this.fileManagerStore.selectedItems[0];
    if (!item2) return;
    if (item2.itemHandler?.rename) item2.itemHandler?.rename();
  }
  onSelected() {
    if (!this.props.onSelected || this.fileManagerStore.selectedItems.length == 0)
      return;
    switch (this.mode) {
      case "SelectOneUrl":
        var item2 = this.fileManagerStore.selectedItems[0];
        var itemUrl = this.fileProvider.getUrlByKey(item2.file.cloudKey);
        this.props.onSelected(itemUrl ?? null);
        this.closeModal();
        break;
      case "SelectFileId":
        var item2 = this.fileManagerStore.selectedItems[0];
        this.props.onSelected(item2.file.id);
        this.closeModal();
        break;
      case "SelectFile":
        var item2 = this.fileManagerStore.selectedItems[0];
        this.props.onSelected(item2.file);
        this.closeModal();
        break;
    }
  }
  deleteSelected(item2) {
    Modal.confirm({
      okText: this.loc.word("Delete"),
      title: this.loc.word("Are you sure you want to delete this files?"),
      cancelText: this.loc.word("Cancel"),
      onOk: () => {
        var items = item2 ? [item2] : this.fileManagerStore.selectedItems;
        items.forEach(async (x) => {
          var deleteResult = await this.fileManagerStore.removeItemFromServer(x);
          if (deleteResult.success) {
            this.fileManagerStore.removeItemFromList(x);
          } else if (deleteResult.success == false) {
            if (deleteResult.response.errors.length > 0) {
              notification.error({
                message: this.loc.word("Deletion error"),
                description: deleteResult.response.errors[0].message
              });
            }
          }
        });
      }
    });
  }
  holder() {
    return /* @__PURE__ */ jsx$1(DragDropProvider, { children: /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerHolder, children: [
      this.path(),
      !this.fileManagerStore.isLoaded ? /* @__PURE__ */ jsx$1("div", { className: styles$I.fileManagerTreeHolder + " " + styles$I.fileManagerTreeHolderLoading, children: /* @__PURE__ */ jsx$1(Spin, {}) }) : /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerTreeHolder, ref: this.backButtonRef, children: [
        this.fileManagerStore.currentParentId && /* @__PURE__ */ jsx$1(BackButton, { store: this.fileManagerStore }),
        this.fileManagerStore.items.length > 0 ? this.fileManagerStore.items.map((x) => /* @__PURE__ */ jsx$1(FileManagerOneItem$1, { item: x, fileManager: this, managerStore: this.fileManagerStore }, x.id)) : /* @__PURE__ */ jsx$1("div", { className: styles$I.fileManagerNoFileAlert, children: this.loc.word("You have no uploaded files") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerFooter, children: [
        this.menu(),
        this.dropzone()
      ] })
    ] }) });
  }
  path() {
    return /* @__PURE__ */ jsxs("div", { className: styles$I.fileManagerPath, children: [
      /* @__PURE__ */ jsxs("a", { className: styles$I.fileManagerPathItem, onClick: () => this.fileManagerStore.changeParent(), children: [
        "	",
        /* @__PURE__ */ jsx$1(HomeOutlined, {})
      ] }),
      this.fileManagerStore.path.map((x, index2) => {
        if (index2 == this.fileManagerStore.path.length - 1) return /* @__PURE__ */ jsx$1("a", { disabled: true, className: styles$I.fileManagerPathItem, children: x.name }, x.id);
        return /* @__PURE__ */ jsx$1("a", { className: styles$I.fileManagerPathItem, onClick: () => this.fileManagerStore.changeParent(x.id), children: x.name }, x.id);
      })
    ] });
  }
  menu() {
    return /* @__PURE__ */ jsx$1("div", { className: styles$I.menu, children: this.fileManagerStore.selectedItems.length == 0 ? /* @__PURE__ */ jsx$1("a", { onClick: () => this.createDirectory(), children: this.loc.word("Create Folder") }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("span", { children: [
        this.loc.word("Files selected"),
        ": ",
        this.fileManagerStore.selectedItems.length
      ] }),
      this.fileManagerStore.selectedItems.length == 1 && /* @__PURE__ */ jsx$1("a", { onClick: () => this.renameSelected(), children: this.loc.word("Rename") }),
      /* @__PURE__ */ jsx$1("a", { onClick: () => this.deleteSelected(), children: this.loc.word("Delete") })
    ] }) });
  }
  get dropzoneAccept() {
    switch (this.props.accept) {
      case FileType.Image:
        return "image/jpeg, image/pjpeg, image/png, image/gif, image/icon, image/jpg, image/svg+xml, image/svg, image/webp";
      case FileType.Video:
        return "video/x-flv, video/mp4, video/quicktime";
      case FileType.Pdf:
        return "application/pdf";
      case FileType.Audio:
      case FileType.Other:
      default:
        return void 0;
    }
  }
  dropzone() {
    return /* @__PURE__ */ jsx$1(Dropzone, { onDrop: (files) => this.uploadFiles(files), accept: this.dropzoneAccept, children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ jsxs("div", { ...getRootProps(), children: [
      /* @__PURE__ */ jsx$1("input", { ...getInputProps() }),
      /* @__PURE__ */ jsxs("div", { className: styles$I.dropzone_holder, children: [
        /* @__PURE__ */ jsx$1(UploadOutlined, { className: "mr-20" }),
        /* @__PURE__ */ jsx$1("span", { children: this.loc.word("FileUploader.uploadMsg", { default: "Click or drag files to upload" }) })
      ] })
    ] }) });
  }
  componentDidMount() {
    this.fileManagerStore;
    reaction$2(
      () => this.props.visible,
      () => {
        runInAction(() => {
          this.fileManagerStore.isVisible = this.props.visible == true;
        });
        if (this.props.visible) this.showModal();
        else this.closeModal();
      }
    );
  }
  render() {
    return /* @__PURE__ */ jsx$1(
      Modal,
      {
        width: "80vw",
        keyboard: false,
        bodyStyle: { height: "600px" },
        title: this.loc.word("File Manager"),
        open: this.fileManagerStore.isVisible,
        destroyOnClose: true,
        onCancel: () => this.closeModal(),
        footer: null,
        children: this.holder()
      }
    );
  }
};
FileManager.contextType = Context$3;
__decorateClass$1([
  action
], FileManager.prototype, "showModal", 1);
__decorateClass$1([
  action
], FileManager.prototype, "closeModal", 1);
FileManager = __decorateClass$1([
  observer
], FileManager);
const BackButton = ({ store: store2 }) => {
  const [isDropActive, setIsDropActive] = useState$1(false);
  const [, dropRef] = useDrop({
    onDrop: async (src, _2, e) => {
      src.data.itemHandler?.changeParent(src.data, store2.parentFolder);
    },
    onEnter: () => setIsDropActive(true),
    onLeave: () => setIsDropActive(false)
  });
  const classes = [styles$I.fileManagerTreeItem];
  if (isDropActive) classes.push(styles$I.fileManagerTreeItemDropActive);
  return /* @__PURE__ */ jsx$1("div", { ref: dropRef, className: classes.join(" "), onClick: () => store2.goOneLevelUp(), children: /* @__PURE__ */ jsx$1("div", { className: styles$I.fileManagerTreeItemGoUp, children: /* @__PURE__ */ jsx$1(RollbackOutlined, {}) }) });
};
function getDurationParts(duration, convertDaysToHours) {
  let leftDuration = duration;
  let days = 0;
  if (convertDaysToHours !== true) {
    days = Math.floor(leftDuration.days);
    leftDuration = leftDuration.substract(TimeSpan.fromDays(days));
  }
  const hours = Math.floor(leftDuration.hours);
  leftDuration = leftDuration.substract(TimeSpan.fromHours(hours));
  const minutes = Math.floor(leftDuration.minutes);
  leftDuration = leftDuration.substract(TimeSpan.fromMinutes(minutes));
  const seconds = Math.floor(leftDuration.seconds);
  return { days, hours, minutes, seconds };
}
const Duration = ({ duration, convertDaysToHours = false, includeSeconds = true, format: format2 = "default", placeholder, hideUnitIfZero, className, suffix }) => {
  const isNegative = useMemo$2(() => duration.seconds < 0, [duration]);
  const { days, hours, minutes, seconds } = useMemo$2(() => getDurationParts(duration, convertDaysToHours), [duration, convertDaysToHours]);
  if (format2 == "default")
    return /* @__PURE__ */ jsxs("span", { className, children: [
      isNegative && "-",
      (hideUnitIfZero === false || days > 0) && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(TimeLoc, { value: days, measure: "days", short: true }),
        " "
      ] }),
      (hideUnitIfZero === false || hours > 0 || days > 0) && /* @__PURE__ */ jsxs(Fragment, { children: [
        hours.toString().padStart(2, "0"),
        ":"
      ] }),
      /* @__PURE__ */ jsxs(Fragment, { children: [
        minutes.toString().padStart(2, "0"),
        ":"
      ] }),
      /* @__PURE__ */ jsx$1(Fragment, { children: seconds.toString().padStart(2, "0") }),
      suffix
    ] });
  if (minutes == 0 && hours == 0 && days == 0 && (includeSeconds == false || seconds == 0))
    return /* @__PURE__ */ jsx$1("span", { className, children: placeholder ?? /* @__PURE__ */ jsxs(Space, { size: 5, children: [
      isNegative && "-",
      convertDaysToHours && /* @__PURE__ */ jsx$1(TimeLoc, { value: 0, measure: "days", short: format2 == "textShort" }),
      /* @__PURE__ */ jsx$1(TimeLoc, { value: 0, measure: "hours", short: format2 == "textShort" }),
      /* @__PURE__ */ jsx$1(TimeLoc, { value: 0, measure: "minutes", short: format2 == "textShort" }),
      includeSeconds && /* @__PURE__ */ jsx$1(TimeLoc, { value: 0, measure: "seconds", short: format2 == "textShort" }),
      suffix
    ] }) });
  const secondsVisible = seconds > 0 && (includeSeconds == true || minutes == 0 && hours == 0 && days == 0);
  return /* @__PURE__ */ jsxs(Space, { size: 5, className, children: [
    isNegative && "-",
    days > 0 && /* @__PURE__ */ jsx$1(
      TimeLoc,
      {
        value: days,
        measure: "days",
        short: format2 == "textShort",
        renderValue: (x) => /* @__PURE__ */ jsx$1(NumberFormat, { number: x, precision: 0, truncateIfFractionalZero: true, delimeter: "space" })
      }
    ),
    hours > 0 && /* @__PURE__ */ jsx$1(
      TimeLoc,
      {
        value: hours,
        measure: "hours",
        short: format2 == "textShort",
        renderValue: (x) => /* @__PURE__ */ jsx$1(NumberFormat, { number: x, precision: 0, truncateIfFractionalZero: true, delimeter: "space" })
      }
    ),
    minutes > 0 && /* @__PURE__ */ jsx$1(TimeLoc, { value: minutes, measure: "minutes", short: format2 == "textShort" }),
    secondsVisible && /* @__PURE__ */ jsx$1(TimeLoc, { value: seconds, measure: "seconds", short: format2 == "textShort" }),
    suffix
  ] });
};
const viewport = "_viewport_1wvu7_1";
const content = "_content_1wvu7_5";
const styles$H = {
  viewport,
  content
};
const VirtualScroll = ({ itemHeight, buffer = 1, children: children2 }) => {
  const viewportRef = useRef(null);
  const state = useLocalStore(() => ({
    get scrollHeight() {
      return state.items.length * itemHeight;
    },
    get offsetTop() {
      return state.firstVisibleIndex * itemHeight;
    },
    parentEl: void 0,
    setParentEl: action((el) => {
      state.parentEl = el;
      state.setParentHeight(el.clientHeight);
    }),
    parentHeight: 0,
    setParentHeight: action((height) => {
      state.parentHeight = height;
    }),
    scrollY: 0,
    setScrollY: action((scrollY) => {
      state.scrollY = scrollY;
    }),
    items: [],
    setItems: action((items) => {
      state.items = items;
    }),
    get currentVisibleIndex() {
      return Math.ceil(state.scrollY / itemHeight);
    },
    get firstVisibleIndex() {
      return Math.max(0, state.currentVisibleIndex - buffer);
    },
    get lastVisibleIndex() {
      return Math.min(Math.ceil(state.parentHeight / itemHeight) + state.currentVisibleIndex + buffer, state.items.length);
    },
    get visibleItems() {
      return state.items.slice(state.firstVisibleIndex, state.lastVisibleIndex);
    }
  }));
  const handleScroll = useCallback(lodashExports.debounce(() => {
    state.setScrollY(state.parentEl.scrollTop);
  }, 10, { maxWait: 10 }), []);
  const handleResize = useCallback(lodashExports.debounce(() => {
    state.setParentHeight(state.parentEl.clientHeight);
  }, 50, { maxWait: 50 }), []);
  useEffect(() => {
    state.setParentEl(viewportRef.current.parentElement);
    state.parentEl.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      state.parentEl.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    state.setItems(React__default.Children.toArray(children2));
  }, [children2]);
  return /* @__PURE__ */ jsx$1("div", { ref: viewportRef, className: styles$H.viewport, style: { height: state.scrollHeight }, children: state.parentEl && /* @__PURE__ */ jsx$1("div", { className: styles$H.content, style: { top: state.offsetTop }, children: state.visibleItems }) });
};
observer(VirtualScroll);
const TimeLoc = ({ measure, value, renderValue, short, case: _case = "lower", className }) => {
  const { loc } = useContext(Context$3);
  const timeLoc = useMemo$2(() => {
    let pluralKeyPrefix = `TimeMeasure.${measure}`;
    if (short == true) {
      pluralKeyPrefix += ".short";
      return loc.word(pluralKeyPrefix, { case: _case, default: measure });
    }
    pluralKeyPrefix += `.plural`;
    return loc.wordPlural(
      value,
      { one: `${pluralKeyPrefix}.one`, two: `${pluralKeyPrefix}.two`, other: `${pluralKeyPrefix}.other` },
      { case: _case, default: { one: measure, two: measure, other: measure } }
    );
  }, [measure, value]);
  return /* @__PURE__ */ jsxs("span", { className, children: [
    renderValue ? renderValue(value) : value,
    !short && /* @__PURE__ */ jsx$1(Fragment, { children: " " }),
    timeLoc
  ] });
};
function useReaction(expression, effect, options) {
  React__default.useEffect(() => {
    const disposer = reaction$1(expression, effect, options);
    return () => disposer();
  }, []);
}
function useDevice() {
  const ctx = useContext(Context$3);
  return ctx.deviceStore;
}
const comment_editor = "_comment_editor_f0hw1_1";
const comment_editor_wrapper = "_comment_editor_wrapper_f0hw1_13";
const styles$G = {
  comment_editor,
  comment_editor_wrapper
};
const compressed = true;
const categories$1 = /* @__PURE__ */ JSON.parse('[{"id":"people","name":"Smileys & People","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","shushing_face","thinking_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","smirk","unamused","face_with_rolling_eyes","grimacing","lying_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","exploding_head","face_with_cowboy_hat","partying_face","sunglasses","nerd_face","face_with_monocle","confused","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","robot_face","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","ok_hand","pinching_hand","v","crossed_fingers","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","tooth","bone","eyes","eye","tongue","lips","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","construction_worker","male-construction-worker","female-construction-worker","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","man_in_tuxedo","bride_with_veil","pregnant_woman","breast-feeding","angel","santa","mrs_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","man-with-bunny-ears-partying","woman-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","couple","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","footprints","kiss","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart","orange_heart","yellow_heart","green_heart","blue_heart","purple_heart","brown_heart","black_heart","white_heart","100","anger","boom","dizzy","sweat_drops","dash","hole","bomb","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","name":"Animals & Nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","hedgehog","bat","bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","flamingo","peacock","parrot","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","fish","tropical_fish","blowfish","shark","octopus","shell","snail","butterfly","bug","ant","bee","beetle","cricket","spider","spider_web","scorpion","mosquito","microbe","bouquet","cherry_blossom","white_flower","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves"]},{"id":"foods","name":"Food & Drink","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","leafy_green","broccoli","garlic","onion","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora"]},{"id":"activity","name":"Activities","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","8ball","crystal_ball","nazar_amulet","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","yarn"]},{"id":"places","name":"Travel & Places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","busstop","motorway","railway_track","oil_drum","fuelpump","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","name":"Objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","crown","womans_hat","tophat","mortar_board","billed_cap","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","iphone","calling","phone","telephone_receiver","pager","fax","battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","currency_exchange","heavy_dollar_sign","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","gun","bow_and_arrow","shield","wrench","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","toolbox","magnet","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","stethoscope","door","bed","couch_and_lamp","chair","toilet","shower","bathtub","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","soap","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","funeral_urn","moyai"]},{"id":"symbols","name":"Symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","medical_symbol","infinity","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","heavy_multiplication_x","x","negative_squared_cross_mark","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","name":"Flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}]');
const emojis = /* @__PURE__ */ JSON.parse(`{"100":{"a":"Hundred Points Symbol","b":"1F4AF","d":true,"e":true,"f":true,"h":true,"j":["score","perfect","numbers","century","exam","quiz","test","pass","hundred"],"k":[26,5],"o":2},"1234":{"a":"Input Symbol for Numbers","b":"1F522","d":true,"e":true,"f":true,"h":true,"j":["numbers","blue-square"],"k":[28,5],"o":2},"grinning":{"a":"Grinning Face","b":"1F600","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","joy",":D","grin"],"k":[30,35],"m":":D","o":2},"monkey_face":{"a":"Monkey Face","b":"1F435","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[12,25],"l":[":o)"],"o":2},"grapes":{"a":"Grapes","b":"1F347","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","wine"],"k":[6,31],"o":2},"eyeglasses":{"a":"Eyeglasses","b":"1F453","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","eyesight","nerdy","dork","geek"],"k":[14,7],"o":2},"checkered_flag":{"a":"Chequered Flag","b":"1F3C1","d":true,"e":true,"f":true,"h":true,"j":["contest","finishline","race","gokart"],"k":[8,39],"o":2},"jack_o_lantern":{"a":"Jack-O-Lantern","b":"1F383","d":true,"e":true,"f":true,"h":true,"j":["halloween","light","pumpkin","creepy","fall"],"k":[7,34],"o":2},"wave":{"skin_variations":{"1F3FB":{"unified":"1F44B-1F3FB","non_qualified":null,"image":"1f44b-1f3fb.png","sheet_x":13,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44B-1F3FC","non_qualified":null,"image":"1f44b-1f3fc.png","sheet_x":13,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44B-1F3FD","non_qualified":null,"image":"1f44b-1f3fd.png","sheet_x":13,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44B-1F3FE","non_qualified":null,"image":"1f44b-1f3fe.png","sheet_x":13,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44B-1F3FF","non_qualified":null,"image":"1f44b-1f3ff.png","sheet_x":13,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Waving Hand Sign","b":"1F44B","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"k":[13,26],"o":2},"earth_africa":{"a":"Earth Globe Europe-Africa","b":"1F30D","d":true,"e":true,"f":true,"h":true,"j":["globe","world","international"],"k":[5,32],"o":2},"atm":{"a":"Automated Teller Machine","b":"1F3E7","d":true,"e":true,"f":true,"h":true,"j":["money","sales","cash","blue-square","payment","bank"],"k":[11,1],"o":2},"melon":{"a":"Melon","b":"1F348","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,32],"o":2},"triangular_flag_on_post":{"a":"Triangular Flag on Post","b":"1F6A9","d":true,"e":true,"f":true,"h":true,"j":["mark","milestone","place"],"k":[35,0],"o":2},"put_litter_in_its_place":{"a":"Put Litter in Its Place Symbol","b":"1F6AE","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sign","human","info"],"k":[35,5],"o":2},"christmas_tree":{"a":"Christmas Tree","b":"1F384","d":true,"e":true,"f":true,"h":true,"j":["festival","vacation","december","xmas","celebration"],"k":[7,35],"o":2},"monkey":{"a":"Monkey","b":"1F412","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","banana","circus"],"k":[11,46],"o":2},"earth_americas":{"a":"Earth Globe Americas","b":"1F30E","d":true,"e":true,"f":true,"h":true,"j":["globe","world","USA","international"],"k":[5,33],"o":2},"dark_sunglasses":{"a":"Dark Sunglasses","b":"1F576-FE0F","c":"1F576","d":true,"e":true,"f":true,"h":true,"j":["face","cool","accessories"],"k":[29,33],"o":2},"raised_back_of_hand":{"skin_variations":{"1F3FB":{"unified":"1F91A-1F3FB","non_qualified":null,"image":"1f91a-1f3fb.png","sheet_x":37,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91A-1F3FC","non_qualified":null,"image":"1f91a-1f3fc.png","sheet_x":37,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91A-1F3FD","non_qualified":null,"image":"1f91a-1f3fd.png","sheet_x":37,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91A-1F3FE","non_qualified":null,"image":"1f91a-1f3fe.png","sheet_x":37,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91A-1F3FF","non_qualified":null,"image":"1f91a-1f3ff.png","sheet_x":37,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Back of Hand","b":"1F91A","d":true,"e":true,"f":true,"h":true,"j":["fingers","raised","backhand"],"k":[37,43],"o":4},"smiley":{"a":"Smiling Face with Open Mouth","b":"1F603","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","haha",":D",":)","smile","funny"],"k":[30,38],"l":["=)","=-)"],"m":":)","o":2},"earth_asia":{"a":"Earth Globe Asia-Australia","b":"1F30F","d":true,"e":true,"f":true,"h":true,"j":["globe","world","east","international"],"k":[5,34],"o":2},"crossed_flags":{"a":"Crossed Flags","b":"1F38C","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","country","border"],"k":[7,48],"o":2},"watermelon":{"a":"Watermelon","b":"1F349","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","picnic","summer"],"k":[6,33],"o":2},"goggles":{"a":"Goggles","b":"1F97D","d":true,"e":true,"f":true,"h":true,"k":[42,15],"o":11},"raised_hand_with_fingers_splayed":{"skin_variations":{"1F3FB":{"unified":"1F590-1F3FB","non_qualified":null,"image":"1f590-1f3fb.png","sheet_x":29,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F590-1F3FC","non_qualified":null,"image":"1f590-1f3fc.png","sheet_x":29,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F590-1F3FD","non_qualified":null,"image":"1f590-1f3fd.png","sheet_x":29,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F590-1F3FE","non_qualified":null,"image":"1f590-1f3fe.png","sheet_x":29,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F590-1F3FF","non_qualified":null,"image":"1f590-1f3ff.png","sheet_x":29,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Fingers Splayed","b":"1F590-FE0F","c":"1F590","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","palm"],"k":[29,48],"o":2},"smile":{"a":"Smiling Face with Open Mouth and Smiling Eyes","b":"1F604","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","funny","haha","laugh","like",":D",":)"],"k":[30,39],"l":["C:","c:",":D",":-D"],"m":":)","o":2},"potable_water":{"a":"Potable Water Symbol","b":"1F6B0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","liquid","restroom","cleaning","faucet"],"k":[35,7],"o":2},"fireworks":{"a":"Fireworks","b":"1F386","d":true,"e":true,"f":true,"h":true,"j":["photo","festival","carnival","congratulations"],"k":[7,42],"o":2},"gorilla":{"a":"Gorilla","b":"1F98D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[42,31],"o":4},"lab_coat":{"a":"Lab Coat","b":"1F97C","d":true,"e":true,"f":true,"h":true,"k":[42,14],"o":11},"tangerine":{"a":"Tangerine","b":"1F34A","d":true,"e":true,"f":true,"h":true,"j":["food","fruit","nature","orange"],"k":[6,34],"o":2},"wheelchair":{"a":"Wheelchair Symbol","b":"267F","d":true,"e":true,"f":true,"h":true,"j":["blue-square","disabled","a11y","accessibility"],"k":[53,40],"o":2},"waving_black_flag":{"a":"Waving Black Flag","b":"1F3F4","d":true,"e":true,"f":true,"h":true,"k":[11,17],"o":2},"orangutan":{"a":"Orangutan","b":"1F9A7","d":true,"e":true,"f":true,"h":true,"k":[42,55],"o":12},"sparkler":{"a":"Firework Sparkler","b":"1F387","d":true,"e":true,"f":true,"h":true,"j":["stars","night","shine"],"k":[7,43],"o":2},"globe_with_meridians":{"a":"Globe with Meridians","b":"1F310","d":true,"e":true,"f":true,"h":true,"j":["earth","international","world","internet","interweb","i18n"],"k":[5,35],"o":2},"grin":{"a":"Grinning Face with Smiling Eyes","b":"1F601","d":true,"e":true,"f":true,"h":true,"j":["face","happy","smile","joy","kawaii"],"k":[30,36],"o":2},"hand":{"skin_variations":{"1F3FB":{"unified":"270B-1F3FB","non_qualified":null,"image":"270b-1f3fb.png","sheet_x":54,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270B-1F3FC","non_qualified":null,"image":"270b-1f3fc.png","sheet_x":54,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270B-1F3FD","non_qualified":null,"image":"270b-1f3fd.png","sheet_x":54,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270B-1F3FE","non_qualified":null,"image":"270b-1f3fe.png","sheet_x":54,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270B-1F3FF","non_qualified":null,"image":"270b-1f3ff.png","sheet_x":54,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand","b":"270B","d":true,"e":true,"f":true,"h":true,"k":[54,49],"n":["raised_hand"],"o":2},"firecracker":{"a":"Firecracker","b":"1F9E8","d":true,"e":true,"f":true,"h":true,"k":[51,27],"o":11},"lemon":{"a":"Lemon","b":"1F34B","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,35],"o":2},"dog":{"a":"Dog Face","b":"1F436","d":true,"e":true,"f":true,"h":true,"j":["animal","friend","nature","woof","puppy","pet","faithful"],"k":[12,26],"o":2},"mens":{"a":"Mens Symbol","b":"1F6B9","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","wc","blue-square","gender","male"],"k":[36,10],"o":2},"spock-hand":{"skin_variations":{"1F3FB":{"unified":"1F596-1F3FB","non_qualified":null,"image":"1f596-1f3fb.png","sheet_x":30,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F596-1F3FC","non_qualified":null,"image":"1f596-1f3fc.png","sheet_x":30,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F596-1F3FD","non_qualified":null,"image":"1f596-1f3fd.png","sheet_x":30,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F596-1F3FE","non_qualified":null,"image":"1f596-1f3fe.png","sheet_x":30,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F596-1F3FF","non_qualified":null,"image":"1f596-1f3ff.png","sheet_x":30,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Part Between Middle and Ring Fingers","b":"1F596","d":true,"e":true,"f":true,"h":true,"k":[30,3],"o":2},"world_map":{"a":"World Map","b":"1F5FA-FE0F","c":"1F5FA","d":true,"e":true,"f":true,"h":true,"j":["location","direction"],"k":[30,29],"o":2},"laughing":{"a":"Smiling Face with Open Mouth and Tightly-Closed Eyes","b":"1F606","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","lol","satisfied","haha","face","glad","XD","laugh"],"k":[30,41],"l":[":>",":->"],"n":["satisfied"],"o":2},"waving_white_flag":{"a":"Waving White Flag","b":"1F3F3-FE0F","c":"1F3F3","d":true,"e":true,"f":true,"h":true,"k":[11,12],"o":2},"safety_vest":{"a":"Safety Vest","b":"1F9BA","d":true,"e":true,"f":true,"h":true,"k":[43,54],"o":12},"sweat_smile":{"a":"Smiling Face with Open Mouth and Cold Sweat","b":"1F605","d":true,"e":true,"f":true,"h":true,"j":["face","hot","happy","laugh","sweat","smile","relief"],"k":[30,40],"o":2},"sparkles":{"a":"Sparkles","b":"2728","d":true,"e":true,"f":true,"h":true,"j":["stars","shine","shiny","cool","awesome","good","magic"],"k":[55,16],"o":2},"banana":{"a":"Banana","b":"1F34C","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","monkey"],"k":[6,36],"o":2},"rainbow-flag":{"a":"Rainbow Flag","b":"1F3F3-FE0F-200D-1F308","c":"1F3F3-200D-1F308","d":true,"e":true,"f":true,"h":true,"k":[11,11],"o":4},"ok_hand":{"skin_variations":{"1F3FB":{"unified":"1F44C-1F3FB","non_qualified":null,"image":"1f44c-1f3fb.png","sheet_x":13,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44C-1F3FC","non_qualified":null,"image":"1f44c-1f3fc.png","sheet_x":13,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44C-1F3FD","non_qualified":null,"image":"1f44c-1f3fd.png","sheet_x":13,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44C-1F3FE","non_qualified":null,"image":"1f44c-1f3fe.png","sheet_x":13,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44C-1F3FF","non_qualified":null,"image":"1f44c-1f3ff.png","sheet_x":13,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ok Hand Sign","b":"1F44C","d":true,"e":true,"f":true,"h":true,"j":["fingers","limbs","perfect","ok","okay"],"k":[13,32],"o":2},"japan":{"a":"Silhouette of Japan","b":"1F5FE","d":true,"e":true,"f":true,"h":true,"j":["nation","country","japanese","asia"],"k":[30,33],"o":2},"dog2":{"a":"Dog","b":"1F415","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","friend","doge","pet","faithful"],"k":[11,50],"o":2},"womens":{"a":"Womens Symbol","b":"1F6BA","d":true,"e":true,"f":true,"h":true,"j":["purple-square","woman","female","toilet","loo","restroom","gender"],"k":[36,11],"o":2},"necktie":{"a":"Necktie","b":"1F454","d":true,"e":true,"f":true,"h":true,"j":["shirt","suitup","formal","fashion","cloth","business"],"k":[14,8],"o":2},"pirate_flag":{"a":"Pirate Flag","b":"1F3F4-200D-2620-FE0F","c":"1F3F4-200D-2620","d":true,"e":true,"f":true,"h":true,"k":[11,13],"o":11},"guide_dog":{"a":"Guide Dog","b":"1F9AE","d":true,"e":true,"f":true,"h":true,"k":[43,2],"o":12},"restroom":{"a":"Restroom","b":"1F6BB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","toilet","refresh","wc","gender"],"k":[36,12],"o":2},"compass":{"a":"Compass","b":"1F9ED","d":true,"e":true,"f":true,"h":true,"k":[51,32],"o":11},"rolling_on_the_floor_laughing":{"a":"Rolling on the Floor Laughing","b":"1F923","d":true,"e":true,"f":true,"h":true,"k":[38,20],"o":4},"balloon":{"a":"Balloon","b":"1F388","d":true,"e":true,"f":true,"h":true,"j":["party","celebration","birthday","circus"],"k":[7,44],"o":2},"pinching_hand":{"skin_variations":{"1F3FB":{"unified":"1F90F-1F3FB","non_qualified":null,"image":"1f90f-1f3fb.png","sheet_x":37,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F90F-1F3FC","non_qualified":null,"image":"1f90f-1f3fc.png","sheet_x":37,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F90F-1F3FD","non_qualified":null,"image":"1f90f-1f3fd.png","sheet_x":37,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F90F-1F3FE","non_qualified":null,"image":"1f90f-1f3fe.png","sheet_x":37,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F90F-1F3FF","non_qualified":null,"image":"1f90f-1f3ff.png","sheet_x":37,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pinching Hand","b":"1F90F","d":true,"e":true,"f":true,"h":true,"k":[37,17],"o":12},"pineapple":{"a":"Pineapple","b":"1F34D","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,37],"o":2},"shirt":{"a":"T-Shirt","b":"1F455","d":true,"e":true,"f":true,"h":true,"k":[14,9],"n":["tshirt"],"o":2},"service_dog":{"a":"Service Dog","b":"1F415-200D-1F9BA","d":true,"e":true,"f":true,"h":true,"k":[11,49],"o":12},"baby_symbol":{"a":"Baby Symbol","b":"1F6BC","d":true,"e":true,"f":true,"h":true,"j":["orange-square","child"],"k":[36,13],"o":2},"joy":{"a":"Face with Tears of Joy","b":"1F602","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","weep","happy","happytears","haha"],"k":[30,37],"o":2},"tada":{"a":"Party Popper","b":"1F389","d":true,"e":true,"f":true,"h":true,"j":["party","congratulations","birthday","magic","circus","celebration"],"k":[7,45],"o":2},"mango":{"a":"Mango","b":"1F96D","d":true,"e":true,"f":true,"h":true,"k":[42,3],"o":11},"v":{"skin_variations":{"1F3FB":{"unified":"270C-1F3FB","non_qualified":null,"image":"270c-1f3fb.png","sheet_x":54,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270C-1F3FC","non_qualified":null,"image":"270c-1f3fc.png","sheet_x":55,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270C-1F3FD","non_qualified":null,"image":"270c-1f3fd.png","sheet_x":55,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270C-1F3FE","non_qualified":null,"image":"270c-1f3fe.png","sheet_x":55,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270C-1F3FF","non_qualified":null,"image":"270c-1f3ff.png","sheet_x":55,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Victory Hand","b":"270C-FE0F","c":"270C","d":true,"e":true,"f":true,"h":true,"j":["fingers","ohyeah","hand","peace","victory","two"],"k":[54,55],"o":2},"snow_capped_mountain":{"a":"Snow Capped Mountain","b":"1F3D4-FE0F","c":"1F3D4","d":true,"e":true,"f":true,"h":true,"k":[10,39],"o":2},"flag-ac":{"a":"Ascension Island Flag","b":"1F1E6-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[0,31],"o":2},"jeans":{"a":"Jeans","b":"1F456","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping"],"k":[14,10],"o":2},"poodle":{"a":"Poodle","b":"1F429","d":true,"e":true,"f":true,"h":true,"j":["dog","animal","101","nature","pet"],"k":[12,13],"o":2},"crossed_fingers":{"skin_variations":{"1F3FB":{"unified":"1F91E-1F3FB","non_qualified":null,"image":"1f91e-1f3fb.png","sheet_x":38,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91E-1F3FC","non_qualified":null,"image":"1f91e-1f3fc.png","sheet_x":38,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91E-1F3FD","non_qualified":null,"image":"1f91e-1f3fd.png","sheet_x":38,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91E-1F3FE","non_qualified":null,"image":"1f91e-1f3fe.png","sheet_x":38,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91E-1F3FF","non_qualified":null,"image":"1f91e-1f3ff.png","sheet_x":38,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Hand with Index and Middle Fingers Crossed","b":"1F91E","d":true,"e":true,"f":true,"h":true,"j":["good","lucky"],"k":[38,5],"n":["hand_with_index_and_middle_fingers_crossed"],"o":4},"flag-ad":{"a":"Andorra Flag","b":"1F1E6-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,32],"o":2},"slightly_smiling_face":{"a":"Slightly Smiling Face","b":"1F642","d":true,"e":true,"f":true,"h":true,"j":["face","smile"],"k":[31,44],"l":[":)","(:",":-)"],"o":2},"apple":{"a":"Red Apple","b":"1F34E","d":true,"e":true,"f":true,"h":true,"j":["fruit","mac","school"],"k":[6,38],"o":2},"wc":{"a":"Water Closet","b":"1F6BE","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","blue-square"],"k":[36,15],"o":2},"scarf":{"a":"Scarf","b":"1F9E3","d":true,"e":true,"f":true,"h":true,"k":[51,22],"o":5},"mountain":{"a":"Mountain","b":"26F0-FE0F","c":"26F0","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","environment"],"k":[54,11],"o":2},"confetti_ball":{"a":"Confetti Ball","b":"1F38A","d":true,"e":true,"f":true,"h":true,"j":["festival","party","birthday","circus"],"k":[7,46],"o":2},"i_love_you_hand_sign":{"skin_variations":{"1F3FB":{"unified":"1F91F-1F3FB","non_qualified":null,"image":"1f91f-1f3fb.png","sheet_x":38,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91F-1F3FC","non_qualified":null,"image":"1f91f-1f3fc.png","sheet_x":38,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91F-1F3FD","non_qualified":null,"image":"1f91f-1f3fd.png","sheet_x":38,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91F-1F3FE","non_qualified":null,"image":"1f91f-1f3fe.png","sheet_x":38,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91F-1F3FF","non_qualified":null,"image":"1f91f-1f3ff.png","sheet_x":38,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"I Love You Hand Sign","b":"1F91F","d":true,"e":true,"f":true,"h":true,"k":[38,11],"o":5},"wolf":{"a":"Wolf Face","b":"1F43A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,30],"o":2},"gloves":{"a":"Gloves","b":"1F9E4","d":true,"e":true,"f":true,"h":true,"k":[51,23],"o":5},"flag-ae":{"a":"United Arab Emirates Flag","b":"1F1E6-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,33],"o":2},"upside_down_face":{"a":"Upside-Down Face","b":"1F643","d":true,"e":true,"f":true,"h":true,"j":["face","flipped","silly","smile"],"k":[31,45],"o":2},"green_apple":{"a":"Green Apple","b":"1F34F","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,39],"o":2},"passport_control":{"a":"Passport Control","b":"1F6C2","d":true,"e":true,"f":true,"h":true,"j":["custom","blue-square"],"k":[36,24],"o":2},"volcano":{"a":"Volcano","b":"1F30B","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","disaster"],"k":[5,30],"o":2},"tanabata_tree":{"a":"Tanabata Tree","b":"1F38B","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","branch","summer"],"k":[7,47],"o":2},"customs":{"a":"Customs","b":"1F6C3","d":true,"e":true,"f":true,"h":true,"j":["passport","border","blue-square"],"k":[36,25],"o":2},"coat":{"a":"Coat","b":"1F9E5","d":true,"e":true,"f":true,"h":true,"k":[51,24],"o":5},"wink":{"a":"Winking Face","b":"1F609","d":true,"e":true,"f":true,"h":true,"j":["face","happy","mischievous","secret",";)","smile","eye"],"k":[30,44],"l":[";)",";-)"],"m":";)","o":2},"bamboo":{"a":"Pine Decoration","b":"1F38D","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","vegetable","panda","pine_decoration"],"k":[7,49],"o":2},"flag-af":{"a":"Afghanistan Flag","b":"1F1E6-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,34],"o":2},"fox_face":{"a":"Fox Face","b":"1F98A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","face"],"k":[42,28],"o":4},"pear":{"a":"Pear","b":"1F350","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,40],"o":2},"mount_fuji":{"a":"Mount Fuji","b":"1F5FB","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain","nature","japanese"],"k":[30,30],"o":2},"the_horns":{"skin_variations":{"1F3FB":{"unified":"1F918-1F3FB","non_qualified":null,"image":"1f918-1f3fb.png","sheet_x":37,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F918-1F3FC","non_qualified":null,"image":"1f918-1f3fc.png","sheet_x":37,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F918-1F3FD","non_qualified":null,"image":"1f918-1f3fd.png","sheet_x":37,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F918-1F3FE","non_qualified":null,"image":"1f918-1f3fe.png","sheet_x":37,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F918-1F3FF","non_qualified":null,"image":"1f918-1f3ff.png","sheet_x":37,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sign of the Horns","b":"1F918","d":true,"e":true,"f":true,"h":true,"k":[37,31],"n":["sign_of_the_horns"],"o":2},"call_me_hand":{"skin_variations":{"1F3FB":{"unified":"1F919-1F3FB","non_qualified":null,"image":"1f919-1f3fb.png","sheet_x":37,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F919-1F3FC","non_qualified":null,"image":"1f919-1f3fc.png","sheet_x":37,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F919-1F3FD","non_qualified":null,"image":"1f919-1f3fd.png","sheet_x":37,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F919-1F3FE","non_qualified":null,"image":"1f919-1f3fe.png","sheet_x":37,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F919-1F3FF","non_qualified":null,"image":"1f919-1f3ff.png","sheet_x":37,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Call Me Hand","b":"1F919","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture"],"k":[37,37],"o":4},"flag-ag":{"a":"Antigua & Barbuda Flag","b":"1F1E6-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,35],"o":2},"raccoon":{"a":"Raccoon","b":"1F99D","d":true,"e":true,"f":true,"h":true,"k":[42,47],"o":11},"dolls":{"a":"Japanese Dolls","b":"1F38E","d":true,"e":true,"f":true,"h":true,"j":["japanese","toy","kimono"],"k":[7,50],"o":2},"blush":{"a":"Smiling Face with Smiling Eyes","b":"1F60A","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","flushed","crush","embarrassed","shy","joy"],"k":[30,45],"m":":)","o":2},"peach":{"a":"Peach","b":"1F351","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,41],"o":2},"baggage_claim":{"a":"Baggage Claim","b":"1F6C4","d":true,"e":true,"f":true,"h":true,"j":["blue-square","airport","transport"],"k":[36,26],"o":2},"socks":{"a":"Socks","b":"1F9E6","d":true,"e":true,"f":true,"h":true,"k":[51,25],"o":5},"camping":{"a":"Camping","b":"1F3D5-FE0F","c":"1F3D5","d":true,"e":true,"f":true,"h":true,"j":["photo","outdoors","tent"],"k":[10,40],"o":2},"dress":{"a":"Dress","b":"1F457","d":true,"e":true,"f":true,"h":true,"j":["clothes","fashion","shopping"],"k":[14,11],"o":2},"beach_with_umbrella":{"a":"Beach with Umbrella","b":"1F3D6-FE0F","c":"1F3D6","d":true,"e":true,"f":true,"h":true,"k":[10,41],"o":2},"cherries":{"a":"Cherries","b":"1F352","d":true,"e":true,"f":true,"h":true,"j":["food","fruit"],"k":[6,42],"o":2},"cat":{"a":"Cat Face","b":"1F431","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","nature","pet","kitten"],"k":[12,21],"o":2},"point_left":{"skin_variations":{"1F3FB":{"unified":"1F448-1F3FB","non_qualified":null,"image":"1f448-1f3fb.png","sheet_x":13,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F448-1F3FC","non_qualified":null,"image":"1f448-1f3fc.png","sheet_x":13,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F448-1F3FD","non_qualified":null,"image":"1f448-1f3fd.png","sheet_x":13,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F448-1F3FE","non_qualified":null,"image":"1f448-1f3fe.png","sheet_x":13,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F448-1F3FF","non_qualified":null,"image":"1f448-1f3ff.png","sheet_x":13,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Left Pointing Backhand Index","b":"1F448","d":true,"e":true,"f":true,"h":true,"j":["direction","fingers","hand","left"],"k":[13,8],"o":2},"left_luggage":{"a":"Left Luggage","b":"1F6C5","d":true,"e":true,"f":true,"h":true,"j":["blue-square","travel"],"k":[36,27],"o":2},"flag-ai":{"a":"Anguilla Flag","b":"1F1E6-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,36],"o":2},"innocent":{"a":"Smiling Face with Halo","b":"1F607","d":true,"e":true,"f":true,"h":true,"j":["face","angel","heaven","halo"],"k":[30,42],"o":2},"flags":{"a":"Carp Streamer","b":"1F38F","d":true,"e":true,"f":true,"h":true,"j":["fish","japanese","koinobori","carp","banner"],"k":[7,51],"o":2},"warning":{"a":"Warning Sign","b":"26A0-FE0F","c":"26A0","d":true,"e":true,"f":true,"h":true,"j":["exclamation","wip","alert","error","problem","issue"],"k":[53,50],"o":2},"strawberry":{"a":"Strawberry","b":"1F353","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","nature"],"k":[6,43],"o":2},"point_right":{"skin_variations":{"1F3FB":{"unified":"1F449-1F3FB","non_qualified":null,"image":"1f449-1f3fb.png","sheet_x":13,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F449-1F3FC","non_qualified":null,"image":"1f449-1f3fc.png","sheet_x":13,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F449-1F3FD","non_qualified":null,"image":"1f449-1f3fd.png","sheet_x":13,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F449-1F3FE","non_qualified":null,"image":"1f449-1f3fe.png","sheet_x":13,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F449-1F3FF","non_qualified":null,"image":"1f449-1f3ff.png","sheet_x":13,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Right Pointing Backhand Index","b":"1F449","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","right"],"k":[13,14],"o":2},"desert":{"a":"Desert","b":"1F3DC-FE0F","c":"1F3DC","d":true,"e":true,"f":true,"h":true,"j":["photo","warm","saharah"],"k":[10,47],"o":2},"kimono":{"a":"Kimono","b":"1F458","d":true,"e":true,"f":true,"h":true,"j":["dress","fashion","women","female","japanese"],"k":[14,12],"o":2},"flag-al":{"a":"Albania Flag","b":"1F1E6-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[0,37],"o":2},"wind_chime":{"a":"Wind Chime","b":"1F390","d":true,"e":true,"f":true,"h":true,"j":["nature","ding","spring","bell"],"k":[7,52],"o":2},"smiling_face_with_3_hearts":{"a":"Smiling Face with Smiling Eyes and Three Hearts","b":"1F970","d":true,"e":true,"f":true,"h":true,"k":[42,6],"o":11},"cat2":{"a":"Cat","b":"1F408","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","pet","cats"],"k":[11,36],"o":2},"rice_scene":{"a":"Moon Viewing Ceremony","b":"1F391","d":true,"e":true,"f":true,"h":true,"j":["photo","japan","asia","tsukimi"],"k":[7,53],"o":2},"heart_eyes":{"a":"Smiling Face with Heart-Shaped Eyes","b":"1F60D","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","crush","heart"],"k":[30,48],"o":2},"sari":{"a":"Sari","b":"1F97B","d":true,"e":true,"f":true,"h":true,"k":[42,13],"o":12},"flag-am":{"a":"Armenia Flag","b":"1F1E6-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[0,38],"o":2},"lion_face":{"a":"Lion Face","b":"1F981","d":true,"e":true,"f":true,"h":true,"k":[42,19],"o":2},"desert_island":{"a":"Desert Island","b":"1F3DD-FE0F","c":"1F3DD","d":true,"e":true,"f":true,"h":true,"j":["photo","tropical","mojito"],"k":[10,48],"o":2},"point_up_2":{"skin_variations":{"1F3FB":{"unified":"1F446-1F3FB","non_qualified":null,"image":"1f446-1f3fb.png","sheet_x":12,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F446-1F3FC","non_qualified":null,"image":"1f446-1f3fc.png","sheet_x":12,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F446-1F3FD","non_qualified":null,"image":"1f446-1f3fd.png","sheet_x":12,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F446-1F3FE","non_qualified":null,"image":"1f446-1f3fe.png","sheet_x":13,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F446-1F3FF","non_qualified":null,"image":"1f446-1f3ff.png","sheet_x":13,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Backhand Index","b":"1F446","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","up"],"k":[12,53],"o":2},"kiwifruit":{"a":"Kiwifruit","b":"1F95D","d":true,"e":true,"f":true,"h":true,"k":[41,44],"o":4},"children_crossing":{"a":"Children Crossing","b":"1F6B8","d":true,"e":true,"f":true,"h":true,"j":["school","warning","danger","sign","driving","yellow-diamond"],"k":[36,9],"o":2},"national_park":{"a":"National Park","b":"1F3DE-FE0F","c":"1F3DE","d":true,"e":true,"f":true,"h":true,"j":["photo","environment","nature"],"k":[10,49],"o":2},"no_entry":{"a":"No Entry","b":"26D4","d":true,"e":true,"f":true,"h":true,"j":["limit","security","privacy","bad","denied","stop","circle"],"k":[54,8],"o":2},"one-piece_swimsuit":{"a":"One-Piece Swimsuit","b":"1FA71","d":true,"e":true,"f":true,"h":true,"k":[51,52],"o":12},"tiger":{"a":"Tiger Face","b":"1F42F","d":true,"e":true,"f":true,"h":true,"j":["animal","cat","danger","wild","nature","roar"],"k":[12,19],"o":2},"red_envelope":{"a":"Red Gift Envelope","b":"1F9E7","d":true,"e":true,"f":true,"h":true,"k":[51,26],"o":11},"star-struck":{"a":"Grinning Face with Star Eyes","b":"1F929","d":true,"e":true,"f":true,"h":true,"k":[38,43],"n":["grinning_face_with_star_eyes"],"o":5},"middle_finger":{"skin_variations":{"1F3FB":{"unified":"1F595-1F3FB","non_qualified":null,"image":"1f595-1f3fb.png","sheet_x":29,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F595-1F3FC","non_qualified":null,"image":"1f595-1f3fc.png","sheet_x":29,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F595-1F3FD","non_qualified":null,"image":"1f595-1f3fd.png","sheet_x":30,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F595-1F3FE","non_qualified":null,"image":"1f595-1f3fe.png","sheet_x":30,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F595-1F3FF","non_qualified":null,"image":"1f595-1f3ff.png","sheet_x":30,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Reversed Hand with Middle Finger Extended","b":"1F595","d":true,"e":true,"f":true,"h":true,"k":[29,54],"n":["reversed_hand_with_middle_finger_extended"],"o":2},"flag-ao":{"a":"Angola Flag","b":"1F1E6-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[0,39],"o":2},"tomato":{"a":"Tomato","b":"1F345","d":true,"e":true,"f":true,"h":true,"j":["fruit","vegetable","nature","food"],"k":[6,29],"o":2},"coconut":{"a":"Coconut","b":"1F965","d":true,"e":true,"f":true,"h":true,"k":[41,52],"o":5},"ribbon":{"a":"Ribbon","b":"1F380","d":true,"e":true,"f":true,"h":true,"j":["decoration","pink","girl","bowtie"],"k":[7,31],"o":2},"no_entry_sign":{"a":"No Entry Sign","b":"1F6AB","d":true,"e":true,"f":true,"h":true,"j":["forbid","stop","limit","denied","disallow","circle"],"k":[35,2],"o":2},"point_down":{"skin_variations":{"1F3FB":{"unified":"1F447-1F3FB","non_qualified":null,"image":"1f447-1f3fb.png","sheet_x":13,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F447-1F3FC","non_qualified":null,"image":"1f447-1f3fc.png","sheet_x":13,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F447-1F3FD","non_qualified":null,"image":"1f447-1f3fd.png","sheet_x":13,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F447-1F3FE","non_qualified":null,"image":"1f447-1f3fe.png","sheet_x":13,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F447-1F3FF","non_qualified":null,"image":"1f447-1f3ff.png","sheet_x":13,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Down Pointing Backhand Index","b":"1F447","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","down"],"k":[13,2],"o":2},"flag-aq":{"a":"Antarctica Flag","b":"1F1E6-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[0,40],"o":2},"briefs":{"a":"Briefs","b":"1FA72","d":true,"e":true,"f":true,"h":true,"k":[51,53],"o":12},"kissing_heart":{"a":"Face Throwing a Kiss","b":"1F618","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,2],"l":[":*",":-*"],"o":2},"tiger2":{"a":"Tiger","b":"1F405","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","roar"],"k":[11,33],"o":2},"stadium":{"a":"Stadium","b":"1F3DF-FE0F","c":"1F3DF","d":true,"e":true,"f":true,"h":true,"j":["photo","place","sports","concert","venue"],"k":[10,50],"o":2},"leopard":{"a":"Leopard","b":"1F406","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,34],"o":2},"no_bicycles":{"a":"No Bicycles","b":"1F6B3","d":true,"e":true,"f":true,"h":true,"j":["cyclist","prohibited","circle"],"k":[35,10],"o":2},"kissing":{"a":"Kissing Face","b":"1F617","d":true,"e":true,"f":true,"h":true,"j":["love","like","face","3","valentines","infatuation","kiss"],"k":[31,1],"o":2},"flag-ar":{"a":"Argentina Flag","b":"1F1E6-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[0,41],"o":2},"avocado":{"a":"Avocado","b":"1F951","d":true,"e":true,"f":true,"h":true,"j":["fruit","food"],"k":[41,32],"o":4},"point_up":{"skin_variations":{"1F3FB":{"unified":"261D-1F3FB","non_qualified":null,"image":"261d-1f3fb.png","sheet_x":53,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"261D-1F3FC","non_qualified":null,"image":"261d-1f3fc.png","sheet_x":53,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"261D-1F3FD","non_qualified":null,"image":"261d-1f3fd.png","sheet_x":53,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"261D-1F3FE","non_qualified":null,"image":"261d-1f3fe.png","sheet_x":53,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"261D-1F3FF","non_qualified":null,"image":"261d-1f3ff.png","sheet_x":53,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Index","b":"261D-FE0F","c":"261D","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","direction","up"],"k":[53,2],"o":2},"gift":{"a":"Wrapped Present","b":"1F381","d":true,"e":true,"f":true,"h":true,"j":["present","birthday","christmas","xmas"],"k":[7,32],"o":2},"classical_building":{"a":"Classical Building","b":"1F3DB-FE0F","c":"1F3DB","d":true,"e":true,"f":true,"h":true,"j":["art","culture","history"],"k":[10,46],"o":2},"shorts":{"a":"Shorts","b":"1FA73","d":true,"e":true,"f":true,"h":true,"k":[51,54],"o":12},"+1":{"skin_variations":{"1F3FB":{"unified":"1F44D-1F3FB","non_qualified":null,"image":"1f44d-1f3fb.png","sheet_x":13,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44D-1F3FC","non_qualified":null,"image":"1f44d-1f3fc.png","sheet_x":13,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44D-1F3FD","non_qualified":null,"image":"1f44d-1f3fd.png","sheet_x":13,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44D-1F3FE","non_qualified":null,"image":"1f44d-1f3fe.png","sheet_x":13,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44D-1F3FF","non_qualified":null,"image":"1f44d-1f3ff.png","sheet_x":13,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Up Sign","b":"1F44D","d":true,"e":true,"f":true,"h":true,"j":["thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"k":[13,38],"n":["thumbsup"],"o":2},"horse":{"a":"Horse Face","b":"1F434","d":true,"e":true,"f":true,"h":true,"j":["animal","brown","nature"],"k":[12,24],"o":2},"bikini":{"a":"Bikini","b":"1F459","d":true,"e":true,"f":true,"h":true,"j":["swimming","female","woman","girl","fashion","beach","summer"],"k":[14,13],"o":2},"no_smoking":{"a":"No Smoking Symbol","b":"1F6AD","d":true,"e":true,"f":true,"h":true,"j":["cigarette","blue-square","smell","smoke"],"k":[35,4],"o":2},"eggplant":{"a":"Aubergine","b":"1F346","d":true,"e":true,"f":true,"h":true,"j":["vegetable","nature","food","aubergine"],"k":[6,30],"o":2},"flag-as":{"a":"American Samoa Flag","b":"1F1E6-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[0,42],"o":2},"reminder_ribbon":{"a":"Reminder Ribbon","b":"1F397-FE0F","c":"1F397","d":true,"e":true,"f":true,"h":true,"j":["sports","cause","support","awareness"],"k":[8,0],"o":2},"building_construction":{"a":"Building Construction","b":"1F3D7-FE0F","c":"1F3D7","d":true,"e":true,"f":true,"h":true,"j":["wip","working","progress"],"k":[10,42],"o":2},"relaxed":{"a":"White Smiling Face","b":"263A-FE0F","c":"263A","d":true,"e":true,"f":true,"h":true,"j":["face","blush","massage","happiness"],"k":[53,17],"o":2},"kissing_closed_eyes":{"a":"Kissing Face with Closed Eyes","b":"1F61A","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,4],"o":2},"-1":{"skin_variations":{"1F3FB":{"unified":"1F44E-1F3FB","non_qualified":null,"image":"1f44e-1f3fb.png","sheet_x":13,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44E-1F3FC","non_qualified":null,"image":"1f44e-1f3fc.png","sheet_x":13,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44E-1F3FD","non_qualified":null,"image":"1f44e-1f3fd.png","sheet_x":13,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44E-1F3FE","non_qualified":null,"image":"1f44e-1f3fe.png","sheet_x":13,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44E-1F3FF","non_qualified":null,"image":"1f44e-1f3ff.png","sheet_x":13,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Down Sign","b":"1F44E","d":true,"e":true,"f":true,"h":true,"j":["thumbsdown","no","dislike","hand"],"k":[13,44],"n":["thumbsdown"],"o":2},"admission_tickets":{"a":"Admission Tickets","b":"1F39F-FE0F","c":"1F39F","d":true,"e":true,"f":true,"h":true,"k":[8,5],"o":2},"flag-at":{"a":"Austria Flag","b":"1F1E6-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[0,43],"o":2},"womans_clothes":{"a":"Womans Clothes","b":"1F45A","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping_bags","female"],"k":[14,14],"o":2},"do_not_litter":{"a":"Do Not Litter Symbol","b":"1F6AF","d":true,"e":true,"f":true,"h":true,"j":["trash","bin","garbage","circle"],"k":[35,6],"o":2},"potato":{"a":"Potato","b":"1F954","d":true,"e":true,"f":true,"h":true,"j":["food","tuber","vegatable","starch"],"k":[41,35],"o":4},"racehorse":{"a":"Horse","b":"1F40E","d":true,"e":true,"f":true,"h":true,"j":["animal","gamble","luck"],"k":[11,42],"o":2},"bricks":{"a":"Brick","b":"1F9F1","d":true,"e":true,"f":true,"h":true,"k":[51,36],"o":11},"fist":{"skin_variations":{"1F3FB":{"unified":"270A-1F3FB","non_qualified":null,"image":"270a-1f3fb.png","sheet_x":54,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270A-1F3FC","non_qualified":null,"image":"270a-1f3fc.png","sheet_x":54,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270A-1F3FD","non_qualified":null,"image":"270a-1f3fd.png","sheet_x":54,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270A-1F3FE","non_qualified":null,"image":"270a-1f3fe.png","sheet_x":54,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270A-1F3FF","non_qualified":null,"image":"270a-1f3ff.png","sheet_x":54,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Fist","b":"270A","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","grasp"],"k":[54,43],"o":2},"house_buildings":{"a":"House Buildings","b":"1F3D8-FE0F","c":"1F3D8","d":true,"e":true,"f":true,"h":true,"k":[10,43],"o":2},"carrot":{"a":"Carrot","b":"1F955","d":true,"e":true,"f":true,"h":true,"j":["vegetable","food","orange"],"k":[41,36],"o":4},"ticket":{"a":"Ticket","b":"1F3AB","d":true,"e":true,"f":true,"h":true,"j":["event","concert","pass"],"k":[8,17],"o":2},"flag-au":{"a":"Australia Flag","b":"1F1E6-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[0,44],"o":2},"non-potable_water":{"a":"Non-Potable Water Symbol","b":"1F6B1","d":true,"e":true,"f":true,"h":true,"j":["drink","faucet","tap","circle"],"k":[35,8],"o":2},"purse":{"a":"Purse","b":"1F45B","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","money","sales","shopping"],"k":[14,15],"o":2},"unicorn_face":{"a":"Unicorn Face","b":"1F984","d":true,"e":true,"f":true,"h":true,"k":[42,22],"o":2},"kissing_smiling_eyes":{"a":"Kissing Face with Smiling Eyes","b":"1F619","d":true,"e":true,"f":true,"h":true,"j":["face","affection","valentines","infatuation","kiss"],"k":[31,3],"o":2},"facepunch":{"skin_variations":{"1F3FB":{"unified":"1F44A-1F3FB","non_qualified":null,"image":"1f44a-1f3fb.png","sheet_x":13,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44A-1F3FC","non_qualified":null,"image":"1f44a-1f3fc.png","sheet_x":13,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44A-1F3FD","non_qualified":null,"image":"1f44a-1f3fd.png","sheet_x":13,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44A-1F3FE","non_qualified":null,"image":"1f44a-1f3fe.png","sheet_x":13,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44A-1F3FF","non_qualified":null,"image":"1f44a-1f3ff.png","sheet_x":13,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Fisted Hand Sign","b":"1F44A","d":true,"e":true,"f":true,"h":true,"j":["angry","violence","fist","hit","attack","hand"],"k":[13,20],"n":["punch"],"o":2},"medal":{"a":"Medal","b":"1F396-FE0F","c":"1F396","d":true,"e":true,"f":true,"h":true,"k":[7,56],"o":2},"zebra_face":{"a":"Zebra Face","b":"1F993","d":true,"e":true,"f":true,"h":true,"k":[42,37],"o":5},"handbag":{"a":"Handbag","b":"1F45C","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessory","accessories","shopping"],"k":[14,16],"o":2},"derelict_house_building":{"a":"Derelict House Building","b":"1F3DA-FE0F","c":"1F3DA","d":true,"e":true,"f":true,"h":true,"k":[10,45],"o":2},"yum":{"a":"Face Savouring Delicious Food","b":"1F60B","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","tongue","smile","face","silly","yummy","nom","delicious","savouring"],"k":[30,46],"o":2},"corn":{"a":"Ear of Maize","b":"1F33D","d":true,"e":true,"f":true,"h":true,"j":["food","vegetable","plant"],"k":[6,21],"o":2},"flag-aw":{"a":"Aruba Flag","b":"1F1E6-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[0,45],"o":2},"no_pedestrians":{"a":"No Pedestrians","b":"1F6B7","d":true,"e":true,"f":true,"h":true,"j":["rules","crossing","walking","circle"],"k":[36,8],"o":2},"house":{"a":"House Building","b":"1F3E0","d":true,"e":true,"f":true,"h":true,"j":["building","home"],"k":[10,51],"o":2},"hot_pepper":{"a":"Hot Pepper","b":"1F336-FE0F","c":"1F336","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","chilli","chili"],"k":[6,14],"o":2},"flag-ax":{"a":"Åland Islands Flag","b":"1F1E6-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[0,46],"o":2},"trophy":{"a":"Trophy","b":"1F3C6","d":true,"e":true,"f":true,"h":true,"j":["win","award","contest","place","ftw","ceremony"],"k":[9,26],"o":2},"deer":{"a":"Deer","b":"1F98C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horns","venison"],"k":[42,30],"o":4},"left-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91B-1F3FB","non_qualified":null,"image":"1f91b-1f3fb.png","sheet_x":37,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91B-1F3FC","non_qualified":null,"image":"1f91b-1f3fc.png","sheet_x":37,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91B-1F3FD","non_qualified":null,"image":"1f91b-1f3fd.png","sheet_x":37,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91B-1F3FE","non_qualified":null,"image":"1f91b-1f3fe.png","sheet_x":37,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91B-1F3FF","non_qualified":null,"image":"1f91b-1f3ff.png","sheet_x":37,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Left-Facing Fist","b":"1F91B","d":true,"e":true,"f":true,"h":true,"k":[37,49],"o":4},"stuck_out_tongue":{"a":"Face with Stuck-out Tongue","b":"1F61B","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","tongue"],"k":[31,5],"l":[":p",":-p",":P",":-P",":b",":-b"],"m":":p","o":2},"pouch":{"a":"Pouch","b":"1F45D","d":true,"e":true,"f":true,"h":true,"j":["bag","accessories","shopping"],"k":[14,17],"o":2},"no_mobile_phones":{"a":"No Mobile Phones","b":"1F4F5","d":true,"e":true,"f":true,"h":true,"j":["iphone","mute","circle"],"k":[27,18],"o":2},"stuck_out_tongue_winking_eye":{"a":"Face with Stuck-out Tongue and Winking Eye","b":"1F61C","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","wink","tongue"],"k":[31,6],"l":[";p",";-p",";b",";-b",";P",";-P"],"m":";p","o":2},"sports_medal":{"a":"Sports Medal","b":"1F3C5","d":true,"e":true,"f":true,"h":true,"k":[9,25],"o":2},"cucumber":{"a":"Cucumber","b":"1F952","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","pickle"],"k":[41,33],"o":4},"cow":{"a":"Cow Face","b":"1F42E","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[12,18],"o":2},"underage":{"a":"No One Under Eighteen Symbol","b":"1F51E","d":true,"e":true,"f":true,"h":true,"j":["18","drink","pub","night","minor","circle"],"k":[28,1],"o":2},"flag-az":{"a":"Azerbaijan Flag","b":"1F1E6-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[0,47],"o":2},"shopping_bags":{"a":"Shopping Bags","b":"1F6CD-FE0F","c":"1F6CD","d":true,"e":true,"f":true,"h":true,"k":[36,35],"o":2},"right-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91C-1F3FB","non_qualified":null,"image":"1f91c-1f3fb.png","sheet_x":37,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91C-1F3FC","non_qualified":null,"image":"1f91c-1f3fc.png","sheet_x":38,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91C-1F3FD","non_qualified":null,"image":"1f91c-1f3fd.png","sheet_x":38,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91C-1F3FE","non_qualified":null,"image":"1f91c-1f3fe.png","sheet_x":38,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91C-1F3FF","non_qualified":null,"image":"1f91c-1f3ff.png","sheet_x":38,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Right-Facing Fist","b":"1F91C","d":true,"e":true,"f":true,"h":true,"k":[37,55],"o":4},"house_with_garden":{"a":"House with Garden","b":"1F3E1","d":true,"e":true,"f":true,"h":true,"j":["home","plant","nature"],"k":[10,52],"o":2},"clap":{"skin_variations":{"1F3FB":{"unified":"1F44F-1F3FB","non_qualified":null,"image":"1f44f-1f3fb.png","sheet_x":13,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44F-1F3FC","non_qualified":null,"image":"1f44f-1f3fc.png","sheet_x":13,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44F-1F3FD","non_qualified":null,"image":"1f44f-1f3fd.png","sheet_x":13,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44F-1F3FE","non_qualified":null,"image":"1f44f-1f3fe.png","sheet_x":13,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44F-1F3FF","non_qualified":null,"image":"1f44f-1f3ff.png","sheet_x":13,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Clapping Hands Sign","b":"1F44F","d":true,"e":true,"f":true,"h":true,"j":["hands","praise","applause","congrats","yay"],"k":[13,50],"o":2},"leafy_green":{"a":"Leafy Green","b":"1F96C","d":true,"e":true,"f":true,"h":true,"k":[42,2],"o":11},"office":{"a":"Office Building","b":"1F3E2","d":true,"e":true,"f":true,"h":true,"j":["building","bureau","work"],"k":[10,53],"o":2},"flag-ba":{"a":"Bosnia & Herzegovina Flag","b":"1F1E7-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[0,48],"o":2},"zany_face":{"a":"Grinning Face with One Large and One Small Eye","b":"1F92A","d":true,"e":true,"f":true,"h":true,"k":[38,44],"n":["grinning_face_with_one_large_and_one_small_eye"],"o":5},"first_place_medal":{"a":"First Place Medal","b":"1F947","d":true,"e":true,"f":true,"h":true,"k":[41,22],"o":4},"ox":{"a":"Ox","b":"1F402","d":true,"e":true,"f":true,"h":true,"j":["animal","cow","beef"],"k":[11,30],"o":2},"school_satchel":{"a":"School Satchel","b":"1F392","d":true,"e":true,"f":true,"h":true,"j":["student","education","bag","backpack"],"k":[7,54],"o":2},"radioactive_sign":{"a":"Radioactive Sign","b":"2622-FE0F","c":"2622","d":true,"e":true,"f":true,"h":true,"k":[53,9],"o":2},"second_place_medal":{"a":"Second Place Medal","b":"1F948","d":true,"e":true,"f":true,"h":true,"k":[41,23],"o":4},"stuck_out_tongue_closed_eyes":{"a":"Face with Stuck-out Tongue and Tightly-Closed Eyes","b":"1F61D","d":true,"e":true,"f":true,"h":true,"j":["face","prank","playful","mischievous","smile","tongue"],"k":[31,7],"o":2},"broccoli":{"a":"Broccoli","b":"1F966","d":true,"e":true,"f":true,"h":true,"k":[41,53],"o":5},"biohazard_sign":{"a":"Biohazard Sign","b":"2623-FE0F","c":"2623","d":true,"e":true,"f":true,"h":true,"k":[53,10],"o":2},"mans_shoe":{"a":"Mans Shoe","b":"1F45E","d":true,"e":true,"f":true,"h":true,"j":["fashion","male"],"k":[14,18],"n":["shoe"],"o":2},"raised_hands":{"skin_variations":{"1F3FB":{"unified":"1F64C-1F3FB","non_qualified":null,"image":"1f64c-1f3fb.png","sheet_x":33,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64C-1F3FC","non_qualified":null,"image":"1f64c-1f3fc.png","sheet_x":33,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64C-1F3FD","non_qualified":null,"image":"1f64c-1f3fd.png","sheet_x":33,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64C-1F3FE","non_qualified":null,"image":"1f64c-1f3fe.png","sheet_x":33,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64C-1F3FF","non_qualified":null,"image":"1f64c-1f3ff.png","sheet_x":33,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person Raising Both Hands in Celebration","b":"1F64C","d":true,"e":true,"f":true,"h":true,"j":["gesture","hooray","yea","celebration","hands"],"k":[33,8],"o":2},"post_office":{"a":"Japanese Post Office","b":"1F3E3","d":true,"e":true,"f":true,"h":true,"j":["building","envelope","communication"],"k":[10,54],"o":2},"flag-bb":{"a":"Barbados Flag","b":"1F1E7-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[0,49],"o":2},"water_buffalo":{"a":"Water Buffalo","b":"1F403","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ox","cow"],"k":[11,31],"o":2},"third_place_medal":{"a":"Third Place Medal","b":"1F949","d":true,"e":true,"f":true,"h":true,"k":[41,24],"o":4},"european_post_office":{"a":"European Post Office","b":"1F3E4","d":true,"e":true,"f":true,"h":true,"j":["building","email"],"k":[10,55],"o":2},"athletic_shoe":{"a":"Athletic Shoe","b":"1F45F","d":true,"e":true,"f":true,"h":true,"j":["shoes","sports","sneakers"],"k":[14,19],"o":2},"arrow_up":{"a":"Upwards Black Arrow","b":"2B06-FE0F","c":"2B06","d":true,"e":true,"f":true,"h":true,"j":["blue-square","continue","top","direction"],"k":[55,38],"o":2},"cow2":{"a":"Cow","b":"1F404","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[11,32],"o":2},"open_hands":{"skin_variations":{"1F3FB":{"unified":"1F450-1F3FB","non_qualified":null,"image":"1f450-1f3fb.png","sheet_x":14,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F450-1F3FC","non_qualified":null,"image":"1f450-1f3fc.png","sheet_x":14,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F450-1F3FD","non_qualified":null,"image":"1f450-1f3fd.png","sheet_x":14,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F450-1F3FE","non_qualified":null,"image":"1f450-1f3fe.png","sheet_x":14,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F450-1F3FF","non_qualified":null,"image":"1f450-1f3ff.png","sheet_x":14,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Open Hands Sign","b":"1F450","d":true,"e":true,"f":true,"h":true,"j":["fingers","butterfly","hands","open"],"k":[13,56],"o":2},"garlic":{"a":"Garlic","b":"1F9C4","d":true,"e":true,"f":true,"h":true,"k":[44,12],"o":12},"money_mouth_face":{"a":"Money-Mouth Face","b":"1F911","d":true,"e":true,"f":true,"h":true,"j":["face","rich","dollar","money"],"k":[37,24],"o":2},"flag-bd":{"a":"Bangladesh Flag","b":"1F1E7-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,50],"o":2},"soccer":{"a":"Soccer Ball","b":"26BD","d":true,"e":true,"f":true,"h":true,"j":["sports","football"],"k":[53,56],"o":2},"hugging_face":{"a":"Hugging Face","b":"1F917","d":true,"e":true,"f":true,"h":true,"k":[37,30],"o":2},"onion":{"a":"Onion","b":"1F9C5","d":true,"e":true,"f":true,"h":true,"k":[44,13],"o":12},"arrow_upper_right":{"a":"North East Arrow","b":"2197-FE0F","c":"2197","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northeast"],"k":[52,17],"o":2},"palms_up_together":{"skin_variations":{"1F3FB":{"unified":"1F932-1F3FB","non_qualified":null,"image":"1f932-1f3fb.png","sheet_x":39,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F932-1F3FC","non_qualified":null,"image":"1f932-1f3fc.png","sheet_x":39,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F932-1F3FD","non_qualified":null,"image":"1f932-1f3fd.png","sheet_x":39,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F932-1F3FE","non_qualified":null,"image":"1f932-1f3fe.png","sheet_x":39,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F932-1F3FF","non_qualified":null,"image":"1f932-1f3ff.png","sheet_x":39,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Palms Up Together","b":"1F932","d":true,"e":true,"f":true,"h":true,"k":[39,5],"o":5},"pig":{"a":"Pig Face","b":"1F437","d":true,"e":true,"f":true,"h":true,"j":["animal","oink","nature"],"k":[12,27],"o":2},"hospital":{"a":"Hospital","b":"1F3E5","d":true,"e":true,"f":true,"h":true,"j":["building","health","surgery","doctor"],"k":[10,56],"o":2},"hiking_boot":{"a":"Hiking Boot","b":"1F97E","d":true,"e":true,"f":true,"h":true,"k":[42,16],"o":11},"flag-be":{"a":"Belgium Flag","b":"1F1E7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,51],"o":2},"flag-bf":{"a":"Burkina Faso Flag","b":"1F1E7-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,52],"o":2},"mushroom":{"a":"Mushroom","b":"1F344","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable"],"k":[6,28],"o":2},"pig2":{"a":"Pig","b":"1F416","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,51],"o":2},"baseball":{"a":"Baseball","b":"26BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[54,0],"o":2},"face_with_hand_over_mouth":{"a":"Smiling Face with Smiling Eyes and Hand Covering Mouth","b":"1F92D","d":true,"e":true,"f":true,"h":true,"k":[38,47],"n":["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],"o":5},"handshake":{"a":"Handshake","b":"1F91D","d":true,"e":true,"f":true,"h":true,"j":["agreement","shake"],"k":[38,4],"o":4},"womans_flat_shoe":{"a":"Flat Shoe","b":"1F97F","d":true,"e":true,"f":true,"h":true,"k":[42,17],"o":11},"bank":{"a":"Bank","b":"1F3E6","d":true,"e":true,"f":true,"h":true,"j":["building","money","sales","cash","business","enterprise"],"k":[11,0],"o":2},"arrow_right":{"a":"Black Rightwards Arrow","b":"27A1-FE0F","c":"27A1","d":true,"e":true,"f":true,"h":true,"j":["blue-square","next"],"k":[55,32],"o":2},"peanuts":{"a":"Peanuts","b":"1F95C","d":true,"e":true,"f":true,"h":true,"j":["food","nut"],"k":[41,43],"o":4},"shushing_face":{"a":"Face with Finger Covering Closed Lips","b":"1F92B","d":true,"e":true,"f":true,"h":true,"k":[38,45],"n":["face_with_finger_covering_closed_lips"],"o":5},"pray":{"skin_variations":{"1F3FB":{"unified":"1F64F-1F3FB","non_qualified":null,"image":"1f64f-1f3fb.png","sheet_x":33,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64F-1F3FC","non_qualified":null,"image":"1f64f-1f3fc.png","sheet_x":33,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64F-1F3FD","non_qualified":null,"image":"1f64f-1f3fd.png","sheet_x":33,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64F-1F3FE","non_qualified":null,"image":"1f64f-1f3fe.png","sheet_x":33,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64F-1F3FF","non_qualified":null,"image":"1f64f-1f3ff.png","sheet_x":33,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Folded Hands","b":"1F64F","d":true,"e":true,"f":true,"h":true,"j":["please","hope","wish","namaste","highfive"],"k":[33,50],"o":2},"softball":{"a":"Softball","b":"1F94E","d":true,"e":true,"f":true,"h":true,"k":[41,29],"o":11},"high_heel":{"a":"High-Heeled Shoe","b":"1F460","d":true,"e":true,"f":true,"h":true,"j":["fashion","shoes","female","pumps","stiletto"],"k":[14,20],"o":2},"flag-bg":{"a":"Bulgaria Flag","b":"1F1E7-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,53],"o":2},"arrow_lower_right":{"a":"South East Arrow","b":"2198-FE0F","c":"2198","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southeast"],"k":[52,18],"o":2},"hotel":{"a":"Hotel","b":"1F3E8","d":true,"e":true,"f":true,"h":true,"j":["building","accomodation","checkin"],"k":[11,2],"o":2},"boar":{"a":"Boar","b":"1F417","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,52],"o":2},"sandal":{"a":"Womans Sandal","b":"1F461","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion","flip flops"],"k":[14,21],"o":2},"flag-bh":{"a":"Bahrain Flag","b":"1F1E7-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[0,54],"o":2},"arrow_down":{"a":"Downwards Black Arrow","b":"2B07-FE0F","c":"2B07","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,39],"o":2},"thinking_face":{"a":"Thinking Face","b":"1F914","d":true,"e":true,"f":true,"h":true,"k":[37,27],"o":2},"writing_hand":{"skin_variations":{"1F3FB":{"unified":"270D-1F3FB","non_qualified":null,"image":"270d-1f3fb.png","sheet_x":55,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270D-1F3FC","non_qualified":null,"image":"270d-1f3fc.png","sheet_x":55,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270D-1F3FD","non_qualified":null,"image":"270d-1f3fd.png","sheet_x":55,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270D-1F3FE","non_qualified":null,"image":"270d-1f3fe.png","sheet_x":55,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270D-1F3FF","non_qualified":null,"image":"270d-1f3ff.png","sheet_x":55,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Writing Hand","b":"270D-FE0F","c":"270D","d":true,"e":true,"f":true,"h":true,"j":["lower_left_ballpoint_pen","stationery","write","compose"],"k":[55,4],"o":2},"chestnut":{"a":"Chestnut","b":"1F330","d":true,"e":true,"f":true,"h":true,"j":["food","squirrel"],"k":[6,8],"o":2},"basketball":{"a":"Basketball and Hoop","b":"1F3C0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NBA"],"k":[8,38],"o":2},"pig_nose":{"a":"Pig Nose","b":"1F43D","d":true,"e":true,"f":true,"h":true,"j":["animal","oink"],"k":[12,33],"o":2},"love_hotel":{"a":"Love Hotel","b":"1F3E9","d":true,"e":true,"f":true,"h":true,"j":["like","affection","dating"],"k":[11,3],"o":2},"nail_care":{"skin_variations":{"1F3FB":{"unified":"1F485-1F3FB","non_qualified":null,"image":"1f485-1f3fb.png","sheet_x":24,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F485-1F3FC","non_qualified":null,"image":"1f485-1f3fc.png","sheet_x":24,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F485-1F3FD","non_qualified":null,"image":"1f485-1f3fd.png","sheet_x":24,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F485-1F3FE","non_qualified":null,"image":"1f485-1f3fe.png","sheet_x":24,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F485-1F3FF","non_qualified":null,"image":"1f485-1f3ff.png","sheet_x":24,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nail Polish","b":"1F485","d":true,"e":true,"f":true,"h":true,"j":["beauty","manicure","finger","fashion","nail"],"k":[24,33],"o":2},"volleyball":{"a":"Volleyball","b":"1F3D0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[10,35],"o":2},"flag-bi":{"a":"Burundi Flag","b":"1F1E7-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,55],"o":2},"arrow_lower_left":{"a":"South West Arrow","b":"2199-FE0F","c":"2199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southwest"],"k":[52,19],"o":2},"ram":{"a":"Ram","b":"1F40F","d":true,"e":true,"f":true,"h":true,"j":["animal","sheep","nature"],"k":[11,43],"o":2},"ballet_shoes":{"a":"Ballet Shoes","b":"1FA70","d":true,"e":true,"f":true,"h":true,"k":[51,51],"o":12},"zipper_mouth_face":{"a":"Zipper-Mouth Face","b":"1F910","d":true,"e":true,"f":true,"h":true,"j":["face","sealed","zipper","secret"],"k":[37,23],"o":2},"bread":{"a":"Bread","b":"1F35E","d":true,"e":true,"f":true,"h":true,"j":["food","wheat","breakfast","toast"],"k":[6,54],"o":2},"convenience_store":{"a":"Convenience Store","b":"1F3EA","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","groceries"],"k":[11,4],"o":2},"boot":{"a":"Womans Boots","b":"1F462","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion"],"k":[14,22],"o":2},"sheep":{"a":"Sheep","b":"1F411","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wool","shipit"],"k":[11,45],"o":2},"face_with_raised_eyebrow":{"a":"Face with One Eyebrow Raised","b":"1F928","d":true,"e":true,"f":true,"h":true,"k":[38,42],"n":["face_with_one_eyebrow_raised"],"o":5},"flag-bj":{"a":"Benin Flag","b":"1F1E7-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[0,56],"o":2},"arrow_left":{"a":"Leftwards Black Arrow","b":"2B05-FE0F","c":"2B05","d":true,"e":true,"f":true,"h":true,"j":["blue-square","previous","back"],"k":[55,37],"o":2},"selfie":{"skin_variations":{"1F3FB":{"unified":"1F933-1F3FB","non_qualified":null,"image":"1f933-1f3fb.png","sheet_x":39,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F933-1F3FC","non_qualified":null,"image":"1f933-1f3fc.png","sheet_x":39,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F933-1F3FD","non_qualified":null,"image":"1f933-1f3fd.png","sheet_x":39,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F933-1F3FE","non_qualified":null,"image":"1f933-1f3fe.png","sheet_x":39,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F933-1F3FF","non_qualified":null,"image":"1f933-1f3ff.png","sheet_x":39,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Selfie","b":"1F933","d":true,"e":true,"f":true,"h":true,"j":["camera","phone"],"k":[39,11],"o":4},"croissant":{"a":"Croissant","b":"1F950","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,31],"o":4},"school":{"a":"School","b":"1F3EB","d":true,"e":true,"f":true,"h":true,"j":["building","student","education","learn","teach"],"k":[11,5],"o":2},"football":{"a":"American Football","b":"1F3C8","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NFL"],"k":[9,33],"o":2},"goat":{"a":"Goat","b":"1F410","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,44],"o":2},"department_store":{"a":"Department Store","b":"1F3EC","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","mall"],"k":[11,6],"o":2},"flag-bl":{"a":"St. Barthélemy Flag","b":"1F1E7-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,0],"o":2},"crown":{"a":"Crown","b":"1F451","d":true,"e":true,"f":true,"h":true,"j":["king","kod","leader","royalty","lord"],"k":[14,5],"o":2},"arrow_upper_left":{"a":"North West Arrow","b":"2196-FE0F","c":"2196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northwest"],"k":[52,16],"o":2},"neutral_face":{"a":"Neutral Face","b":"1F610","d":true,"e":true,"f":true,"h":true,"j":["indifference","meh",":|","neutral"],"k":[30,51],"l":[":|",":-|"],"o":2},"rugby_football":{"a":"Rugby Football","b":"1F3C9","d":true,"e":true,"f":true,"h":true,"j":["sports","team"],"k":[9,34],"o":2},"muscle":{"skin_variations":{"1F3FB":{"unified":"1F4AA-1F3FB","non_qualified":null,"image":"1f4aa-1f3fb.png","sheet_x":25,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F4AA-1F3FC","non_qualified":null,"image":"1f4aa-1f3fc.png","sheet_x":25,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F4AA-1F3FD","non_qualified":null,"image":"1f4aa-1f3fd.png","sheet_x":25,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F4AA-1F3FE","non_qualified":null,"image":"1f4aa-1f3fe.png","sheet_x":25,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F4AA-1F3FF","non_qualified":null,"image":"1f4aa-1f3ff.png","sheet_x":26,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Flexed Biceps","b":"1F4AA","d":true,"e":true,"f":true,"h":true,"j":["arm","flex","hand","summer","strong","biceps"],"k":[25,52],"o":2},"baguette_bread":{"a":"Baguette Bread","b":"1F956","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,37],"o":4},"expressionless":{"a":"Expressionless Face","b":"1F611","d":true,"e":true,"f":true,"h":true,"j":["face","indifferent","-_-","meh","deadpan"],"k":[30,52],"o":2},"womans_hat":{"a":"Womans Hat","b":"1F452","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","female","lady","spring"],"k":[14,6],"o":2},"pretzel":{"a":"Pretzel","b":"1F968","d":true,"e":true,"f":true,"h":true,"k":[41,55],"o":5},"mechanical_arm":{"a":"Mechanical Arm","b":"1F9BE","d":true,"e":true,"f":true,"h":true,"k":[44,6],"o":12},"arrow_up_down":{"a":"Up Down Arrow","b":"2195-FE0F","c":"2195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","way","vertical"],"k":[52,15],"o":2},"dromedary_camel":{"a":"Dromedary Camel","b":"1F42A","d":true,"e":true,"f":true,"h":true,"j":["animal","hot","desert","hump"],"k":[12,14],"o":2},"tennis":{"a":"Tennis Racquet and Ball","b":"1F3BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","green"],"k":[8,36],"o":2},"flag-bm":{"a":"Bermuda Flag","b":"1F1E7-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,1],"o":2},"factory":{"a":"Factory","b":"1F3ED","d":true,"e":true,"f":true,"h":true,"j":["building","industry","pollution","smoke"],"k":[11,7],"o":2},"japanese_castle":{"a":"Japanese Castle","b":"1F3EF","d":true,"e":true,"f":true,"h":true,"j":["photo","building"],"k":[11,9],"o":2},"no_mouth":{"a":"Face Without Mouth","b":"1F636","d":true,"e":true,"f":true,"h":true,"j":["face","hellokitty"],"k":[31,32],"o":2},"mechanical_leg":{"a":"Mechanical Leg","b":"1F9BF","d":true,"e":true,"f":true,"h":true,"k":[44,7],"o":12},"bagel":{"a":"Bagel","b":"1F96F","d":true,"e":true,"f":true,"h":true,"k":[42,5],"o":11},"camel":{"a":"Bactrian Camel","b":"1F42B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","hot","desert","hump"],"k":[12,15],"o":2},"tophat":{"a":"Top Hat","b":"1F3A9","d":true,"e":true,"f":true,"h":true,"j":["magic","gentleman","classy","circus"],"k":[8,15],"o":2},"left_right_arrow":{"a":"Left Right Arrow","b":"2194-FE0F","c":"2194","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","horizontal","sideways"],"k":[52,14],"o":2},"flag-bn":{"a":"Brunei Flag","b":"1F1E7-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[1,2],"o":2},"flying_disc":{"a":"Flying Disc","b":"1F94F","d":true,"e":true,"f":true,"h":true,"k":[41,30],"o":11},"smirk":{"a":"Smirking Face","b":"1F60F","d":true,"e":true,"f":true,"h":true,"j":["face","smile","mean","prank","smug","sarcasm"],"k":[30,50],"o":2},"mortar_board":{"a":"Graduation Cap","b":"1F393","d":true,"e":true,"f":true,"h":true,"j":["school","college","degree","university","graduation","cap","hat","legal","learn","education"],"k":[7,55],"o":2},"european_castle":{"a":"European Castle","b":"1F3F0","d":true,"e":true,"f":true,"h":true,"j":["building","royalty","history"],"k":[11,10],"o":2},"leg":{"skin_variations":{"1F3FB":{"unified":"1F9B5-1F3FB","non_qualified":null,"image":"1f9b5-1f3fb.png","sheet_x":43,"sheet_y":6,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B5-1F3FC","non_qualified":null,"image":"1f9b5-1f3fc.png","sheet_x":43,"sheet_y":7,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B5-1F3FD","non_qualified":null,"image":"1f9b5-1f3fd.png","sheet_x":43,"sheet_y":8,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B5-1F3FE","non_qualified":null,"image":"1f9b5-1f3fe.png","sheet_x":43,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B5-1F3FF","non_qualified":null,"image":"1f9b5-1f3ff.png","sheet_x":43,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Leg","b":"1F9B5","d":true,"e":true,"f":true,"h":true,"k":[43,5],"o":11},"pancakes":{"a":"Pancakes","b":"1F95E","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","flapjacks","hotcakes"],"k":[41,45],"o":4},"leftwards_arrow_with_hook":{"a":"Leftwards Arrow with Hook","b":"21A9-FE0F","c":"21A9","d":true,"e":true,"f":true,"h":true,"j":["back","return","blue-square","undo","enter"],"k":[52,20],"o":2},"flag-bo":{"a":"Bolivia Flag","b":"1F1E7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,3],"o":2},"bowling":{"a":"Bowling","b":"1F3B3","d":true,"e":true,"f":true,"h":true,"j":["sports","fun","play"],"k":[8,25],"o":2},"llama":{"a":"Llama","b":"1F999","d":true,"e":true,"f":true,"h":true,"k":[42,43],"o":11},"arrow_right_hook":{"a":"Rightwards Arrow with Hook","b":"21AA-FE0F","c":"21AA","d":true,"e":true,"f":true,"h":true,"j":["blue-square","return","rotate","direction"],"k":[52,21],"o":2},"wedding":{"a":"Wedding","b":"1F492","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","couple","marriage","bride","groom"],"k":[25,28],"o":2},"flag-bq":{"a":"Caribbean Netherlands Flag","b":"1F1E7-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[1,4],"o":2},"foot":{"skin_variations":{"1F3FB":{"unified":"1F9B6-1F3FB","non_qualified":null,"image":"1f9b6-1f3fb.png","sheet_x":43,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B6-1F3FC","non_qualified":null,"image":"1f9b6-1f3fc.png","sheet_x":43,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B6-1F3FD","non_qualified":null,"image":"1f9b6-1f3fd.png","sheet_x":43,"sheet_y":14,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B6-1F3FE","non_qualified":null,"image":"1f9b6-1f3fe.png","sheet_x":43,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B6-1F3FF","non_qualified":null,"image":"1f9b6-1f3ff.png","sheet_x":43,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Foot","b":"1F9B6","d":true,"e":true,"f":true,"h":true,"k":[43,11],"o":11},"giraffe_face":{"a":"Giraffe Face","b":"1F992","d":true,"e":true,"f":true,"h":true,"k":[42,36],"o":5},"unamused":{"a":"Unamused Face","b":"1F612","d":true,"e":true,"f":true,"h":true,"j":["indifference","bored","straight face","serious","sarcasm"],"k":[30,53],"m":":(","o":2},"billed_cap":{"a":"Billed Cap","b":"1F9E2","d":true,"e":true,"f":true,"h":true,"k":[51,21],"o":5},"waffle":{"a":"Waffle","b":"1F9C7","d":true,"e":true,"f":true,"h":true,"k":[44,15],"o":12},"cricket_bat_and_ball":{"a":"Cricket Bat and Ball","b":"1F3CF","d":true,"e":true,"f":true,"h":true,"k":[10,34],"o":2},"helmet_with_white_cross":{"a":"Helmet with White Cross","b":"26D1-FE0F","c":"26D1","d":true,"e":true,"f":true,"h":true,"k":[54,6],"o":2},"ear":{"skin_variations":{"1F3FB":{"unified":"1F442-1F3FB","non_qualified":null,"image":"1f442-1f3fb.png","sheet_x":12,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F442-1F3FC","non_qualified":null,"image":"1f442-1f3fc.png","sheet_x":12,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F442-1F3FD","non_qualified":null,"image":"1f442-1f3fd.png","sheet_x":12,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F442-1F3FE","non_qualified":null,"image":"1f442-1f3fe.png","sheet_x":12,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F442-1F3FF","non_qualified":null,"image":"1f442-1f3ff.png","sheet_x":12,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear","b":"1F442","d":true,"e":true,"f":true,"h":true,"j":["face","hear","sound","listen"],"k":[12,39],"o":2},"elephant":{"a":"Elephant","b":"1F418","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","nose","th","circus"],"k":[11,53],"o":2},"cheese_wedge":{"a":"Cheese Wedge","b":"1F9C0","d":true,"e":true,"f":true,"h":true,"k":[44,8],"o":2},"tokyo_tower":{"a":"Tokyo Tower","b":"1F5FC","d":true,"e":true,"f":true,"h":true,"j":["photo","japanese"],"k":[30,31],"o":2},"arrow_heading_up":{"a":"Arrow Pointing Rightwards Then Curving Upwards","b":"2934-FE0F","c":"2934","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[55,35],"o":2},"field_hockey_stick_and_ball":{"a":"Field Hockey Stick and Ball","b":"1F3D1","d":true,"e":true,"f":true,"h":true,"k":[10,36],"o":2},"flag-br":{"a":"Brazil Flag","b":"1F1E7-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,5],"o":2},"face_with_rolling_eyes":{"a":"Face with Rolling Eyes","b":"1F644","d":true,"e":true,"f":true,"h":true,"k":[31,46],"o":2},"ear_with_hearing_aid":{"skin_variations":{"1F3FB":{"unified":"1F9BB-1F3FB","non_qualified":null,"image":"1f9bb-1f3fb.png","sheet_x":43,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9BB-1F3FC","non_qualified":null,"image":"1f9bb-1f3fc.png","sheet_x":44,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9BB-1F3FD","non_qualified":null,"image":"1f9bb-1f3fd.png","sheet_x":44,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9BB-1F3FE","non_qualified":null,"image":"1f9bb-1f3fe.png","sheet_x":44,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9BB-1F3FF","non_qualified":null,"image":"1f9bb-1f3ff.png","sheet_x":44,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear with Hearing Aid","b":"1F9BB","d":true,"e":true,"f":true,"h":true,"k":[43,55],"o":12},"arrow_heading_down":{"a":"Arrow Pointing Rightwards Then Curving Downwards","b":"2935-FE0F","c":"2935","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,36],"o":2},"ice_hockey_stick_and_puck":{"a":"Ice Hockey Stick and Puck","b":"1F3D2","d":true,"e":true,"f":true,"h":true,"k":[10,37],"o":2},"meat_on_bone":{"a":"Meat on Bone","b":"1F356","d":true,"e":true,"f":true,"h":true,"j":["good","food","drumstick"],"k":[6,46],"o":2},"prayer_beads":{"a":"Prayer Beads","b":"1F4FF","d":true,"e":true,"f":true,"h":true,"j":["dhikr","religious"],"k":[27,27],"o":2},"statue_of_liberty":{"a":"Statue of Liberty","b":"1F5FD","d":true,"e":true,"f":true,"h":true,"j":["american","newyork"],"k":[30,32],"o":2},"grimacing":{"a":"Grimacing Face","b":"1F62C","d":true,"e":true,"f":true,"h":true,"j":["face","grimace","teeth"],"k":[31,22],"o":2},"flag-bs":{"a":"Bahamas Flag","b":"1F1E7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[1,6],"o":2},"rhinoceros":{"a":"Rhinoceros","b":"1F98F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horn"],"k":[42,33],"o":4},"lacrosse":{"a":"Lacrosse Stick and Ball","b":"1F94D","d":true,"e":true,"f":true,"h":true,"k":[41,28],"o":11},"poultry_leg":{"a":"Poultry Leg","b":"1F357","d":true,"e":true,"f":true,"h":true,"j":["food","meat","drumstick","bird","chicken","turkey"],"k":[6,47],"o":2},"hippopotamus":{"a":"Hippopotamus","b":"1F99B","d":true,"e":true,"f":true,"h":true,"k":[42,45],"o":11},"nose":{"skin_variations":{"1F3FB":{"unified":"1F443-1F3FB","non_qualified":null,"image":"1f443-1f3fb.png","sheet_x":12,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F443-1F3FC","non_qualified":null,"image":"1f443-1f3fc.png","sheet_x":12,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F443-1F3FD","non_qualified":null,"image":"1f443-1f3fd.png","sheet_x":12,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F443-1F3FE","non_qualified":null,"image":"1f443-1f3fe.png","sheet_x":12,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F443-1F3FF","non_qualified":null,"image":"1f443-1f3ff.png","sheet_x":12,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nose","b":"1F443","d":true,"e":true,"f":true,"h":true,"j":["smell","sniff"],"k":[12,45],"o":2},"arrows_clockwise":{"a":"Clockwise Downwards and Upwards Open Circle Arrows","b":"1F503","d":true,"e":true,"f":true,"h":true,"j":["sync","cycle","round","repeat"],"k":[27,31],"o":2},"flag-bt":{"a":"Bhutan Flag","b":"1F1E7-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,7],"o":2},"church":{"a":"Church","b":"26EA","d":true,"e":true,"f":true,"h":true,"j":["building","religion","christ"],"k":[54,10],"o":2},"lipstick":{"a":"Lipstick","b":"1F484","d":true,"e":true,"f":true,"h":true,"j":["female","girl","fashion","woman"],"k":[24,32],"o":2},"lying_face":{"a":"Lying Face","b":"1F925","d":true,"e":true,"f":true,"h":true,"j":["face","lie","pinocchio"],"k":[38,22],"o":4},"arrows_counterclockwise":{"a":"Anticlockwise Downwards and Upwards Open Circle Arrows","b":"1F504","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sync","cycle"],"k":[27,32],"o":2},"flag-bv":{"a":"Bouvet Island Flag","b":"1F1E7-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,8],"o":2},"cut_of_meat":{"a":"Cut of Meat","b":"1F969","d":true,"e":true,"f":true,"h":true,"k":[41,56],"o":5},"mosque":{"a":"Mosque","b":"1F54C","d":true,"e":true,"f":true,"h":true,"j":["islam","worship","minaret"],"k":[28,36],"o":2},"ring":{"a":"Ring","b":"1F48D","d":true,"e":true,"f":true,"h":true,"j":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"k":[25,23],"o":2},"brain":{"a":"Brain","b":"1F9E0","d":true,"e":true,"f":true,"h":true,"k":[51,19],"o":5},"table_tennis_paddle_and_ball":{"a":"Table Tennis Paddle and Ball","b":"1F3D3","d":true,"e":true,"f":true,"h":true,"k":[10,38],"o":2},"relieved":{"a":"Relieved Face","b":"1F60C","d":true,"e":true,"f":true,"h":true,"j":["face","relaxed","phew","massage","happiness"],"k":[30,47],"o":2},"mouse":{"a":"Mouse Face","b":"1F42D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","cheese_wedge","rodent"],"k":[12,17],"o":2},"hindu_temple":{"a":"Hindu Temple","b":"1F6D5","d":true,"e":true,"f":true,"h":true,"k":[36,41],"o":12},"back":{"a":"Back with Leftwards Arrow Above","b":"1F519","d":true,"e":true,"f":true,"h":true,"j":["arrow","words","return"],"k":[27,53],"o":2},"gem":{"a":"Gem Stone","b":"1F48E","d":true,"e":true,"f":true,"h":true,"j":["blue","ruby","diamond","jewelry"],"k":[25,24],"o":2},"pensive":{"a":"Pensive Face","b":"1F614","d":true,"e":true,"f":true,"h":true,"j":["face","sad","depressed","upset"],"k":[30,55],"o":2},"flag-bw":{"a":"Botswana Flag","b":"1F1E7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,9],"o":2},"mouse2":{"a":"Mouse","b":"1F401","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent"],"k":[11,29],"o":2},"bacon":{"a":"Bacon","b":"1F953","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","pork","pig","meat"],"k":[41,34],"o":4},"tooth":{"a":"Tooth","b":"1F9B7","d":true,"e":true,"f":true,"h":true,"k":[43,17],"o":11},"badminton_racquet_and_shuttlecock":{"a":"Badminton Racquet and Shuttlecock","b":"1F3F8","d":true,"e":true,"f":true,"h":true,"k":[11,20],"o":2},"rat":{"a":"Rat","b":"1F400","d":true,"e":true,"f":true,"h":true,"j":["animal","mouse","rodent"],"k":[11,28],"o":2},"synagogue":{"a":"Synagogue","b":"1F54D","d":true,"e":true,"f":true,"h":true,"j":["judaism","worship","temple","jewish"],"k":[28,37],"o":2},"end":{"a":"End with Leftwards Arrow Above","b":"1F51A","d":true,"e":true,"f":true,"h":true,"j":["words","arrow"],"k":[27,54],"o":2},"bone":{"a":"Bone","b":"1F9B4","d":true,"e":true,"f":true,"h":true,"k":[43,4],"o":11},"boxing_glove":{"a":"Boxing Glove","b":"1F94A","d":true,"e":true,"f":true,"h":true,"j":["sports","fighting"],"k":[41,25],"o":4},"mute":{"a":"Speaker with Cancellation Stroke","b":"1F507","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","quiet"],"k":[27,35],"o":2},"hamburger":{"a":"Hamburger","b":"1F354","d":true,"e":true,"f":true,"h":true,"j":["meat","fast food","beef","cheeseburger","mcdonalds","burger king"],"k":[6,44],"o":2},"flag-by":{"a":"Belarus Flag","b":"1F1E7-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,10],"o":2},"sleepy":{"a":"Sleepy Face","b":"1F62A","d":true,"e":true,"f":true,"h":true,"j":["face","tired","rest","nap"],"k":[31,20],"o":2},"on":{"a":"On with Exclamation Mark with Left Right Arrow Above","b":"1F51B","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,55],"o":2},"martial_arts_uniform":{"a":"Martial Arts Uniform","b":"1F94B","d":true,"e":true,"f":true,"h":true,"j":["judo","karate","taekwondo"],"k":[41,26],"o":4},"speaker":{"a":"Speaker","b":"1F508","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","broadcast"],"k":[27,36],"o":2},"drooling_face":{"a":"Drooling Face","b":"1F924","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,21],"o":4},"eyes":{"a":"Eyes","b":"1F440","d":true,"e":true,"f":true,"h":true,"j":["look","watch","stalk","peek","see"],"k":[12,36],"o":2},"flag-bz":{"a":"Belize Flag","b":"1F1E7-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,11],"o":2},"hamster":{"a":"Hamster Face","b":"1F439","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,29],"o":2},"shinto_shrine":{"a":"Shinto Shrine","b":"26E9-FE0F","c":"26E9","d":true,"e":true,"f":true,"h":true,"j":["temple","japan","kyoto"],"k":[54,9],"o":2},"fries":{"a":"French Fries","b":"1F35F","d":true,"e":true,"f":true,"h":true,"j":["chips","snack","fast food"],"k":[6,55],"o":2},"goal_net":{"a":"Goal Net","b":"1F945","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[41,21],"o":4},"kaaba":{"a":"Kaaba","b":"1F54B","d":true,"e":true,"f":true,"h":true,"j":["mecca","mosque","islam"],"k":[28,35],"o":2},"soon":{"a":"Soon with Rightwards Arrow Above","b":"1F51C","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,56],"o":2},"flag-ca":{"a":"Canada Flag","b":"1F1E8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,12],"o":2},"rabbit":{"a":"Rabbit Face","b":"1F430","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","spring","magic","bunny"],"k":[12,20],"o":2},"eye":{"a":"Eye","b":"1F441-FE0F","c":"1F441","d":true,"e":true,"f":true,"h":true,"j":["face","look","see","watch","stare"],"k":[12,38],"o":2},"sleeping":{"a":"Sleeping Face","b":"1F634","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","night","zzz"],"k":[31,30],"o":2},"pizza":{"a":"Slice of Pizza","b":"1F355","d":true,"e":true,"f":true,"h":true,"j":["food","party"],"k":[6,45],"o":2},"sound":{"a":"Speaker with One Sound Wave","b":"1F509","d":true,"e":true,"f":true,"h":true,"j":["volume","speaker","broadcast"],"k":[27,37],"o":2},"rabbit2":{"a":"Rabbit","b":"1F407","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","magic","spring"],"k":[11,35],"o":2},"fountain":{"a":"Fountain","b":"26F2","d":true,"e":true,"f":true,"h":true,"j":["photo","summer","water","fresh"],"k":[54,13],"o":2},"golf":{"a":"Flag in Hole","b":"26F3","d":true,"e":true,"f":true,"h":true,"j":["sports","business","flag","hole","summer"],"k":[54,14],"o":2},"top":{"a":"Top with Upwards Arrow Above","b":"1F51D","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[28,0],"o":2},"mask":{"a":"Face with Medical Mask","b":"1F637","d":true,"e":true,"f":true,"h":true,"j":["face","sick","ill","disease"],"k":[31,33],"o":2},"flag-cc":{"a":"Cocos (keeling) Islands Flag","b":"1F1E8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,13],"o":2},"hotdog":{"a":"Hot Dog","b":"1F32D","d":true,"e":true,"f":true,"h":true,"j":["food","frankfurter"],"k":[6,5],"o":2},"loud_sound":{"a":"Speaker with Three Sound Waves","b":"1F50A","d":true,"e":true,"f":true,"h":true,"j":["volume","noise","noisy","speaker","broadcast"],"k":[27,38],"o":2},"tongue":{"a":"Tongue","b":"1F445","d":true,"e":true,"f":true,"h":true,"j":["mouth","playful"],"k":[12,52],"o":2},"place_of_worship":{"a":"Place of Worship","b":"1F6D0","d":true,"e":true,"f":true,"h":true,"j":["religion","church","temple","prayer"],"k":[36,38],"o":2},"ice_skate":{"a":"Ice Skate","b":"26F8-FE0F","c":"26F8","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[54,18],"o":2},"sandwich":{"a":"Sandwich","b":"1F96A","d":true,"e":true,"f":true,"h":true,"k":[42,0],"o":5},"chipmunk":{"a":"Chipmunk","b":"1F43F-FE0F","c":"1F43F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent","squirrel"],"k":[12,35],"o":2},"loudspeaker":{"a":"Public Address Loudspeaker","b":"1F4E2","d":true,"e":true,"f":true,"h":true,"j":["volume","sound"],"k":[26,56],"o":2},"lips":{"a":"Mouth","b":"1F444","d":true,"e":true,"f":true,"h":true,"j":["mouth","kiss"],"k":[12,51],"o":2},"flag-cd":{"a":"Congo - Kinshasa Flag","b":"1F1E8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,14],"o":2},"tent":{"a":"Tent","b":"26FA","d":true,"e":true,"f":true,"h":true,"j":["photo","camping","outdoors"],"k":[54,37],"o":2},"face_with_thermometer":{"a":"Face with Thermometer","b":"1F912","d":true,"e":true,"f":true,"h":true,"j":["sick","temperature","thermometer","cold","fever"],"k":[37,25],"o":2},"taco":{"a":"Taco","b":"1F32E","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,6],"o":2},"foggy":{"a":"Foggy","b":"1F301","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain"],"k":[5,20],"o":2},"flag-cf":{"a":"Central African Republic Flag","b":"1F1E8-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[1,15],"o":2},"baby":{"skin_variations":{"1F3FB":{"unified":"1F476-1F3FB","non_qualified":null,"image":"1f476-1f3fb.png","sheet_x":23,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F476-1F3FC","non_qualified":null,"image":"1f476-1f3fc.png","sheet_x":23,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F476-1F3FD","non_qualified":null,"image":"1f476-1f3fd.png","sheet_x":23,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F476-1F3FE","non_qualified":null,"image":"1f476-1f3fe.png","sheet_x":23,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F476-1F3FF","non_qualified":null,"image":"1f476-1f3ff.png","sheet_x":23,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby","b":"1F476","d":true,"e":true,"f":true,"h":true,"j":["child","boy","girl","toddler"],"k":[23,4],"o":2},"atom_symbol":{"a":"Atom Symbol","b":"269B-FE0F","c":"269B","d":true,"e":true,"f":true,"h":true,"j":["science","physics","chemistry"],"k":[53,48],"o":2},"fishing_pole_and_fish":{"a":"Fishing Pole and Fish","b":"1F3A3","d":true,"e":true,"f":true,"h":true,"j":["food","hobby","summer"],"k":[8,9],"o":2},"hedgehog":{"a":"Hedgehog","b":"1F994","d":true,"e":true,"f":true,"h":true,"k":[42,38],"o":5},"face_with_head_bandage":{"a":"Face with Head-Bandage","b":"1F915","d":true,"e":true,"f":true,"h":true,"j":["injured","clumsy","bandage","hurt"],"k":[37,28],"o":2},"mega":{"a":"Cheering Megaphone","b":"1F4E3","d":true,"e":true,"f":true,"h":true,"j":["sound","speaker","volume"],"k":[27,0],"o":2},"nauseated_face":{"a":"Nauseated Face","b":"1F922","d":true,"e":true,"f":true,"h":true,"j":["face","vomit","gross","green","sick","throw up","ill"],"k":[38,19],"o":4},"child":{"skin_variations":{"1F3FB":{"unified":"1F9D2-1F3FB","non_qualified":null,"image":"1f9d2-1f3fb.png","sheet_x":48,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D2-1F3FC","non_qualified":null,"image":"1f9d2-1f3fc.png","sheet_x":48,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D2-1F3FD","non_qualified":null,"image":"1f9d2-1f3fd.png","sheet_x":48,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D2-1F3FE","non_qualified":null,"image":"1f9d2-1f3fe.png","sheet_x":48,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D2-1F3FF","non_qualified":null,"image":"1f9d2-1f3ff.png","sheet_x":48,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Child","b":"1F9D2","d":true,"e":true,"f":true,"h":true,"k":[48,16],"o":5},"flag-cg":{"a":"Congo - Brazzaville Flag","b":"1F1E8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,16],"o":2},"bat":{"a":"Bat","b":"1F987","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","blind","vampire"],"k":[42,25],"o":4},"diving_mask":{"a":"Diving Mask","b":"1F93F","d":true,"e":true,"f":true,"h":true,"k":[41,15],"o":12},"burrito":{"a":"Burrito","b":"1F32F","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,7],"o":2},"postal_horn":{"a":"Postal Horn","b":"1F4EF","d":true,"e":true,"f":true,"h":true,"j":["instrument","music"],"k":[27,12],"o":2},"night_with_stars":{"a":"Night with Stars","b":"1F303","d":true,"e":true,"f":true,"h":true,"j":["evening","city","downtown"],"k":[5,22],"o":2},"om_symbol":{"a":"Om Symbol","b":"1F549-FE0F","c":"1F549","d":true,"e":true,"f":true,"h":true,"k":[28,33],"o":2},"star_of_david":{"a":"Star of David","b":"2721-FE0F","c":"2721","d":true,"e":true,"f":true,"h":true,"j":["judaism"],"k":[55,15],"o":2},"boy":{"skin_variations":{"1F3FB":{"unified":"1F466-1F3FB","non_qualified":null,"image":"1f466-1f3fb.png","sheet_x":14,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F466-1F3FC","non_qualified":null,"image":"1f466-1f3fc.png","sheet_x":14,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F466-1F3FD","non_qualified":null,"image":"1f466-1f3fd.png","sheet_x":14,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F466-1F3FE","non_qualified":null,"image":"1f466-1f3fe.png","sheet_x":14,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F466-1F3FF","non_qualified":null,"image":"1f466-1f3ff.png","sheet_x":14,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Boy","b":"1F466","d":true,"e":true,"f":true,"h":true,"j":["man","male","guy","teenager"],"k":[14,26],"o":2},"bell":{"a":"Bell","b":"1F514","d":true,"e":true,"f":true,"h":true,"j":["sound","notification","christmas","xmas","chime"],"k":[27,48],"o":2},"flag-ch":{"a":"Switzerland Flag","b":"1F1E8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,17],"o":2},"running_shirt_with_sash":{"a":"Running Shirt with Sash","b":"1F3BD","d":true,"e":true,"f":true,"h":true,"j":["play","pageant"],"k":[8,35],"o":2},"stuffed_flatbread":{"a":"Stuffed Flatbread","b":"1F959","d":true,"e":true,"f":true,"h":true,"j":["food","flatbread","stuffed","gyro"],"k":[41,40],"o":4},"bear":{"a":"Bear Face","b":"1F43B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,31],"o":2},"cityscape":{"a":"Cityscape","b":"1F3D9-FE0F","c":"1F3D9","d":true,"e":true,"f":true,"h":true,"j":["photo","night life","urban"],"k":[10,44],"o":2},"face_vomiting":{"a":"Face with Open Mouth Vomiting","b":"1F92E","d":true,"e":true,"f":true,"h":true,"k":[38,48],"n":["face_with_open_mouth_vomiting"],"o":5},"wheel_of_dharma":{"a":"Wheel of Dharma","b":"2638-FE0F","c":"2638","d":true,"e":true,"f":true,"h":true,"j":["hinduism","buddhism","sikhism","jainism"],"k":[53,15],"o":2},"ski":{"a":"Ski and Ski Boot","b":"1F3BF","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","cold","snow"],"k":[8,37],"o":2},"girl":{"skin_variations":{"1F3FB":{"unified":"1F467-1F3FB","non_qualified":null,"image":"1f467-1f3fb.png","sheet_x":14,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F467-1F3FC","non_qualified":null,"image":"1f467-1f3fc.png","sheet_x":14,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F467-1F3FD","non_qualified":null,"image":"1f467-1f3fd.png","sheet_x":14,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F467-1F3FE","non_qualified":null,"image":"1f467-1f3fe.png","sheet_x":14,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F467-1F3FF","non_qualified":null,"image":"1f467-1f3ff.png","sheet_x":14,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Girl","b":"1F467","d":true,"e":true,"f":true,"h":true,"j":["female","woman","teenager"],"k":[14,32],"o":2},"falafel":{"a":"Falafel","b":"1F9C6","d":true,"e":true,"f":true,"h":true,"k":[44,14],"o":12},"sneezing_face":{"a":"Sneezing Face","b":"1F927","d":true,"e":true,"f":true,"h":true,"j":["face","gesundheit","sneeze","sick","allergy"],"k":[38,41],"o":4},"no_bell":{"a":"Bell with Cancellation Stroke","b":"1F515","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","mute","quiet","silent"],"k":[27,49],"o":2},"koala":{"a":"Koala","b":"1F428","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,12],"o":2},"sunrise_over_mountains":{"a":"Sunrise over Mountains","b":"1F304","d":true,"e":true,"f":true,"h":true,"j":["view","vacation","photo"],"k":[5,23],"o":2},"flag-ci":{"a":"Côte D’ivoire Flag","b":"1F1E8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,18],"o":2},"sunrise":{"a":"Sunrise","b":"1F305","d":true,"e":true,"f":true,"h":true,"j":["morning","view","vacation","photo"],"k":[5,24],"o":2},"yin_yang":{"a":"Yin Yang","b":"262F-FE0F","c":"262F","d":true,"e":true,"f":true,"h":true,"j":["balance"],"k":[53,14],"o":2},"adult":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb.png","sheet_x":48,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc.png","sheet_x":48,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd.png","sheet_x":48,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe.png","sheet_x":48,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff.png","sheet_x":48,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Adult","b":"1F9D1","d":true,"e":true,"f":true,"h":true,"k":[48,10],"o":5},"hot_face":{"a":"Overheated Face","b":"1F975","d":true,"e":true,"f":true,"h":true,"k":[42,10],"o":11},"musical_score":{"a":"Musical Score","b":"1F3BC","d":true,"e":true,"f":true,"h":true,"j":["treble","clef","compose"],"k":[8,34],"o":2},"sled":{"a":"Sled","b":"1F6F7","d":true,"e":true,"f":true,"h":true,"k":[36,56],"o":5},"egg":{"a":"Egg","b":"1F95A","d":true,"e":true,"f":true,"h":true,"j":["food","chicken","breakfast"],"k":[41,41],"o":4},"panda_face":{"a":"Panda Face","b":"1F43C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","panda"],"k":[12,32],"o":2},"flag-ck":{"a":"Cook Islands Flag","b":"1F1E8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,19],"o":2},"flag-cl":{"a":"Chile Flag","b":"1F1E8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,20],"o":2},"person_with_blond_hair":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB","non_qualified":null,"image":"1f471-1f3fb.png","sheet_x":22,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F471-1F3FC","non_qualified":null,"image":"1f471-1f3fc.png","sheet_x":22,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F471-1F3FD","non_qualified":null,"image":"1f471-1f3fd.png","sheet_x":22,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F471-1F3FE","non_qualified":null,"image":"1f471-1f3fe.png","sheet_x":22,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F471-1F3FF","non_qualified":null,"image":"1f471-1f3ff.png","sheet_x":22,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F471-200D-2642-FE0F","a":"Person with Blond Hair","b":"1F471","d":true,"e":true,"f":true,"h":false,"k":[22,19],"o":2},"sloth":{"a":"Sloth","b":"1F9A5","d":true,"e":true,"f":true,"h":true,"k":[42,53],"o":12},"latin_cross":{"a":"Latin Cross","b":"271D-FE0F","c":"271D","d":true,"e":true,"f":true,"h":true,"j":["christianity"],"k":[55,14],"o":2},"curling_stone":{"a":"Curling Stone","b":"1F94C","d":true,"e":true,"f":true,"h":true,"k":[41,27],"o":5},"cold_face":{"a":"Freezing Face","b":"1F976","d":true,"e":true,"f":true,"h":true,"k":[42,11],"o":11},"fried_egg":{"a":"Cooking","b":"1F373","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","kitchen","egg"],"k":[7,18],"n":["cooking"],"o":2},"city_sunset":{"a":"Cityscape at Dusk","b":"1F306","d":true,"e":true,"f":true,"h":true,"j":["photo","evening","sky","buildings"],"k":[5,25],"o":2},"musical_note":{"a":"Musical Note","b":"1F3B5","d":true,"e":true,"f":true,"h":true,"j":["score","tone","sound"],"k":[8,27],"o":2},"flag-cm":{"a":"Cameroon Flag","b":"1F1E8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,21],"o":2},"notes":{"a":"Multiple Musical Notes","b":"1F3B6","d":true,"e":true,"f":true,"h":true,"j":["music","score"],"k":[8,28],"o":2},"woozy_face":{"a":"Face with Uneven Eyes and Wavy Mouth","b":"1F974","d":true,"e":true,"f":true,"h":true,"k":[42,9],"o":11},"dart":{"a":"Direct Hit","b":"1F3AF","d":true,"e":true,"f":true,"h":true,"j":["game","play","bar"],"k":[8,21],"o":2},"orthodox_cross":{"a":"Orthodox Cross","b":"2626-FE0F","c":"2626","d":true,"e":true,"f":true,"h":true,"j":["suppedaneum","religion"],"k":[53,11],"o":2},"shallow_pan_of_food":{"a":"Shallow Pan of Food","b":"1F958","d":true,"e":true,"f":true,"h":true,"j":["food","cooking","casserole","paella"],"k":[41,39],"o":4},"otter":{"a":"Otter","b":"1F9A6","d":true,"e":true,"f":true,"h":true,"k":[42,54],"o":12},"man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fb.png","sheet_x":17,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fc.png","sheet_x":17,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fd.png","sheet_x":17,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fe.png","sheet_x":17,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF","non_qualified":null,"image":"1f468-1f3ff.png","sheet_x":17,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man","b":"1F468","d":true,"e":true,"f":true,"h":true,"j":["mustache","father","dad","guy","classy","sir","moustache"],"k":[17,22],"o":2},"city_sunrise":{"a":"Sunset over Buildings","b":"1F307","d":true,"e":true,"f":true,"h":true,"j":["photo","good morning","dawn"],"k":[5,26],"o":2},"bearded_person":{"skin_variations":{"1F3FB":{"unified":"1F9D4-1F3FB","non_qualified":null,"image":"1f9d4-1f3fb.png","sheet_x":48,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D4-1F3FC","non_qualified":null,"image":"1f9d4-1f3fc.png","sheet_x":48,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D4-1F3FD","non_qualified":null,"image":"1f9d4-1f3fd.png","sheet_x":48,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D4-1F3FE","non_qualified":null,"image":"1f9d4-1f3fe.png","sheet_x":48,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D4-1F3FF","non_qualified":null,"image":"1f9d4-1f3ff.png","sheet_x":48,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bearded Person","b":"1F9D4","d":true,"e":true,"f":true,"h":true,"k":[48,28],"o":5},"skunk":{"a":"Skunk","b":"1F9A8","d":true,"e":true,"f":true,"h":true,"k":[42,56],"o":12},"stew":{"a":"Pot of Food","b":"1F372","d":true,"e":true,"f":true,"h":true,"j":["food","meat","soup"],"k":[7,17],"o":2},"cn":{"a":"China Flag","b":"1F1E8-1F1F3","d":true,"e":true,"f":true,"h":true,"j":["china","chinese","prc","flag","country","nation","banner"],"k":[1,22],"n":["flag-cn"],"o":2},"studio_microphone":{"a":"Studio Microphone","b":"1F399-FE0F","c":"1F399","d":true,"e":true,"f":true,"h":true,"j":["sing","recording","artist","talkshow"],"k":[8,1],"o":2},"star_and_crescent":{"a":"Star and Crescent","b":"262A-FE0F","c":"262A","d":true,"e":true,"f":true,"h":true,"j":["islam"],"k":[53,12],"o":2},"yo-yo":{"a":"Yo-Yo","b":"1FA80","d":true,"e":true,"f":true,"h":true,"k":[52,1],"o":12},"bridge_at_night":{"a":"Bridge at Night","b":"1F309","d":true,"e":true,"f":true,"h":true,"j":["photo","sanfrancisco"],"k":[5,28],"o":2},"dizzy_face":{"a":"Dizzy Face","b":"1F635","d":true,"e":true,"f":true,"h":true,"j":["spent","unconscious","xox","dizzy"],"k":[31,31],"o":2},"red_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b0.png","sheet_x":16,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b0.png","sheet_x":16,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b0.png","sheet_x":16,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b0.png","sheet_x":16,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b0.png","sheet_x":16,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Man","b":"1F468-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[16,23],"o":11},"kite":{"a":"Kite","b":"1FA81","d":true,"e":true,"f":true,"h":true,"k":[52,2],"o":12},"bowl_with_spoon":{"a":"Bowl with Spoon","b":"1F963","d":true,"e":true,"f":true,"h":true,"k":[41,50],"o":5},"flag-co":{"a":"Colombia Flag","b":"1F1E8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,23],"o":2},"peace_symbol":{"a":"Peace Symbol","b":"262E-FE0F","c":"262E","d":true,"e":true,"f":true,"h":true,"j":["hippie"],"k":[53,13],"o":2},"kangaroo":{"a":"Kangaroo","b":"1F998","d":true,"e":true,"f":true,"h":true,"k":[42,42],"o":11},"hotsprings":{"a":"Hot Springs","b":"2668-FE0F","c":"2668","d":true,"e":true,"f":true,"h":true,"j":["bath","warm","relax"],"k":[53,37],"o":2},"exploding_head":{"a":"Shocked Face with Exploding Head","b":"1F92F","d":true,"e":true,"f":true,"h":true,"k":[38,49],"n":["shocked_face_with_exploding_head"],"o":5},"level_slider":{"a":"Level Slider","b":"1F39A-FE0F","c":"1F39A","d":true,"e":true,"f":true,"h":true,"j":["scale"],"k":[8,2],"o":2},"badger":{"a":"Badger","b":"1F9A1","d":true,"e":true,"f":true,"h":true,"k":[42,51],"o":11},"8ball":{"a":"Billiards","b":"1F3B1","d":true,"e":true,"f":true,"h":true,"j":["pool","hobby","game","luck","magic"],"k":[8,23],"o":2},"curly_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b1.png","sheet_x":16,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b1.png","sheet_x":16,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b1.png","sheet_x":16,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b1.png","sheet_x":16,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b1.png","sheet_x":16,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Man","b":"1F468-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[16,29],"o":11},"flag-cp":{"a":"Clipperton Island Flag","b":"1F1E8-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[1,24],"o":2},"carousel_horse":{"a":"Carousel Horse","b":"1F3A0","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival"],"k":[8,6],"o":2},"face_with_cowboy_hat":{"a":"Face with Cowboy Hat","b":"1F920","d":true,"e":true,"f":true,"h":true,"k":[38,17],"o":4},"menorah_with_nine_branches":{"a":"Menorah with Nine Branches","b":"1F54E","d":true,"e":true,"f":true,"h":true,"k":[28,38],"o":2},"green_salad":{"a":"Green Salad","b":"1F957","d":true,"e":true,"f":true,"h":true,"j":["food","healthy","lettuce"],"k":[41,38],"o":4},"control_knobs":{"a":"Control Knobs","b":"1F39B-FE0F","c":"1F39B","d":true,"e":true,"f":true,"h":true,"j":["dial"],"k":[8,3],"o":2},"popcorn":{"a":"Popcorn","b":"1F37F","d":true,"e":true,"f":true,"h":true,"j":["food","movie theater","films","snack"],"k":[7,30],"o":2},"six_pointed_star":{"a":"Six Pointed Star with Middle Dot","b":"1F52F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","religion","jewish","hexagram"],"k":[28,18],"o":2},"feet":{"a":"Paw Prints","b":"1F43E","d":true,"e":true,"f":true,"h":true,"k":[12,34],"n":["paw_prints"],"o":2},"ferris_wheel":{"a":"Ferris Wheel","b":"1F3A1","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival","londoneye"],"k":[8,7],"o":2},"microphone":{"a":"Microphone","b":"1F3A4","d":true,"e":true,"f":true,"h":true,"j":["sound","music","PA","sing","talkshow"],"k":[8,10],"o":2},"crystal_ball":{"a":"Crystal Ball","b":"1F52E","d":true,"e":true,"f":true,"h":true,"j":["disco","party","magic","circus","fortune_teller"],"k":[28,17],"o":2},"partying_face":{"a":"Face with Party Horn and Party Hat","b":"1F973","d":true,"e":true,"f":true,"h":true,"k":[42,8],"o":11},"flag-cr":{"a":"Costa Rica Flag","b":"1F1E8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,25],"o":2},"white_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b3.png","sheet_x":16,"sheet_y":42,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b3.png","sheet_x":16,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b3.png","sheet_x":16,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b3.png","sheet_x":16,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b3.png","sheet_x":16,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Man","b":"1F468-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[16,41],"o":11},"headphones":{"a":"Headphone","b":"1F3A7","d":true,"e":true,"f":true,"h":true,"j":["music","score","gadgets"],"k":[8,13],"o":2},"bald_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b2.png","sheet_x":16,"sheet_y":36,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b2.png","sheet_x":16,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b2.png","sheet_x":16,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b2.png","sheet_x":16,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b2.png","sheet_x":16,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Man","b":"1F468-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[16,35],"o":11},"sunglasses":{"a":"Smiling Face with Sunglasses","b":"1F60E","d":true,"e":true,"f":true,"h":true,"j":["face","cool","smile","summer","beach","sunglass"],"k":[30,49],"l":["8)"],"o":2},"butter":{"a":"Butter","b":"1F9C8","d":true,"e":true,"f":true,"h":true,"k":[44,16],"o":12},"roller_coaster":{"a":"Roller Coaster","b":"1F3A2","d":true,"e":true,"f":true,"h":true,"j":["carnival","playground","photo","fun"],"k":[8,8],"o":2},"turkey":{"a":"Turkey","b":"1F983","d":true,"e":true,"f":true,"h":true,"j":["animal","bird"],"k":[42,21],"o":2},"nazar_amulet":{"a":"Nazar Amulet","b":"1F9FF","d":true,"e":true,"f":true,"h":true,"k":[51,50],"o":11},"flag-cu":{"a":"Cuba Flag","b":"1F1E8-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,26],"o":2},"aries":{"a":"Aries","b":"2648","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,20],"o":2},"flag-cv":{"a":"Cape Verde Flag","b":"1F1E8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,27],"o":2},"barber":{"a":"Barber Pole","b":"1F488","d":true,"e":true,"f":true,"h":true,"j":["hair","salon","style"],"k":[25,18],"o":2},"taurus":{"a":"Taurus","b":"2649","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,21],"o":2},"salt":{"a":"Salt Shaker","b":"1F9C2","d":true,"e":true,"f":true,"h":true,"k":[44,10],"o":11},"woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fb.png","sheet_x":20,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fc.png","sheet_x":20,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fd.png","sheet_x":20,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fe.png","sheet_x":20,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF","non_qualified":null,"image":"1f469-1f3ff.png","sheet_x":20,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman","b":"1F469","d":true,"e":true,"f":true,"h":true,"j":["female","girls","lady"],"k":[20,9],"o":2},"video_game":{"a":"Video Game","b":"1F3AE","d":true,"e":true,"f":true,"h":true,"j":["play","console","PS4","controller"],"k":[8,20],"o":2},"chicken":{"a":"Chicken","b":"1F414","d":true,"e":true,"f":true,"h":true,"j":["animal","cluck","nature","bird"],"k":[11,48],"o":2},"radio":{"a":"Radio","b":"1F4FB","d":true,"e":true,"f":true,"h":true,"j":["communication","music","podcast","program"],"k":[27,24],"o":2},"nerd_face":{"a":"Nerd Face","b":"1F913","d":true,"e":true,"f":true,"h":true,"j":["face","nerdy","geek","dork"],"k":[37,26],"o":2},"red_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b0.png","sheet_x":19,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b0.png","sheet_x":19,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b0.png","sheet_x":19,"sheet_y":11,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b0.png","sheet_x":19,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b0.png","sheet_x":19,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Woman","b":"1F469-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[19,8],"o":11},"circus_tent":{"a":"Circus Tent","b":"1F3AA","d":true,"e":true,"f":true,"h":true,"j":["festival","carnival","party"],"k":[8,16],"o":2},"face_with_monocle":{"a":"Face with Monocle","b":"1F9D0","d":true,"e":true,"f":true,"h":true,"k":[45,16],"o":5},"canned_food":{"a":"Canned Food","b":"1F96B","d":true,"e":true,"f":true,"h":true,"k":[42,1],"o":5},"flag-cw":{"a":"Curaçao Flag","b":"1F1E8-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,28],"o":2},"gemini":{"a":"Gemini","b":"264A","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,22],"o":2},"saxophone":{"a":"Saxophone","b":"1F3B7","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","jazz","blues"],"k":[8,29],"o":2},"rooster":{"a":"Rooster","b":"1F413","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","chicken"],"k":[11,47],"o":2},"joystick":{"a":"Joystick","b":"1F579-FE0F","c":"1F579","d":true,"e":true,"f":true,"h":true,"j":["game","play"],"k":[29,36],"o":2},"guitar":{"a":"Guitar","b":"1F3B8","d":true,"e":true,"f":true,"h":true,"j":["music","instrument"],"k":[8,30],"o":2},"slot_machine":{"a":"Slot Machine","b":"1F3B0","d":true,"e":true,"f":true,"h":true,"j":["bet","gamble","vegas","fruit machine","luck","casino"],"k":[8,22],"o":2},"bento":{"a":"Bento Box","b":"1F371","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","box"],"k":[7,16],"o":2},"steam_locomotive":{"a":"Steam Locomotive","b":"1F682","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","train"],"k":[34,1],"o":2},"confused":{"a":"Confused Face","b":"1F615","d":true,"e":true,"f":true,"h":true,"j":["face","indifference","huh","weird","hmmm",":/"],"k":[30,56],"l":[":\\\\",":-\\\\",":/",":-/"],"o":2},"flag-cx":{"a":"Christmas Island Flag","b":"1F1E8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[1,29],"o":2},"hatching_chick":{"a":"Hatching Chick","b":"1F423","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","egg","born","baby","bird"],"k":[12,7],"o":2},"cancer":{"a":"Cancer","b":"264B","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,23],"o":2},"red_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b0.png","sheet_x":47,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b0.png","sheet_x":47,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b0.png","sheet_x":47,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b0.png","sheet_x":47,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b0.png","sheet_x":47,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Red Haired Person","b":"1F9D1-200D-1F9B0","d":true,"e":false,"f":false,"h":false,"k":[47,13],"o":12},"flag-cy":{"a":"Cyprus Flag","b":"1F1E8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,30],"o":2},"worried":{"a":"Worried Face","b":"1F61F","d":true,"e":true,"f":true,"h":true,"j":["face","concern","nervous",":("],"k":[31,9],"o":2},"railway_car":{"a":"Railway Car","b":"1F683","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,2],"o":2},"leo":{"a":"Leo","b":"264C","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,24],"o":2},"curly_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b1.png","sheet_x":19,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b1.png","sheet_x":19,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b1.png","sheet_x":19,"sheet_y":17,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b1.png","sheet_x":19,"sheet_y":18,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b1.png","sheet_x":19,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Woman","b":"1F469-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[19,14],"o":11},"baby_chick":{"a":"Baby Chick","b":"1F424","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","bird"],"k":[12,8],"o":2},"musical_keyboard":{"a":"Musical Keyboard","b":"1F3B9","d":true,"e":true,"f":true,"h":true,"j":["piano","instrument","compose"],"k":[8,31],"o":2},"game_die":{"a":"Game Die","b":"1F3B2","d":true,"e":true,"f":true,"h":true,"j":["dice","random","tabletop","play","luck"],"k":[8,24],"o":2},"rice_cracker":{"a":"Rice Cracker","b":"1F358","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,48],"o":2},"virgo":{"a":"Virgo","b":"264D","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,25],"o":2},"flag-cz":{"a":"Czechia Flag","b":"1F1E8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,31],"o":2},"curly_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b1.png","sheet_x":47,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b1.png","sheet_x":47,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b1.png","sheet_x":47,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b1.png","sheet_x":47,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b1.png","sheet_x":47,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Curly Haired Person","b":"1F9D1-200D-1F9B1","d":true,"e":false,"f":false,"h":false,"k":[47,19],"o":12},"rice_ball":{"a":"Rice Ball","b":"1F359","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,49],"o":2},"hatched_chick":{"a":"Front-Facing Baby Chick","b":"1F425","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","baby","bird"],"k":[12,9],"o":2},"jigsaw":{"a":"Jigsaw Puzzle Piece","b":"1F9E9","d":true,"e":true,"f":true,"h":true,"k":[51,28],"o":11},"trumpet":{"a":"Trumpet","b":"1F3BA","d":true,"e":true,"f":true,"h":true,"j":["music","brass"],"k":[8,32],"o":2},"slightly_frowning_face":{"a":"Slightly Frowning Face","b":"1F641","d":true,"e":true,"f":true,"h":true,"j":["face","frowning","disappointed","sad","upset"],"k":[31,43],"o":2},"bullettrain_side":{"a":"High-Speed Train","b":"1F684","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,3],"o":2},"libra":{"a":"Libra","b":"264E","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,26],"o":2},"de":{"a":"Germany Flag","b":"1F1E9-1F1EA","d":true,"e":true,"f":true,"h":true,"j":["german","nation","flag","country","banner"],"k":[1,32],"n":["flag-de"],"o":2},"rice":{"a":"Cooked Rice","b":"1F35A","d":true,"e":true,"f":true,"h":true,"j":["food","china","asian"],"k":[6,50],"o":2},"violin":{"a":"Violin","b":"1F3BB","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","orchestra","symphony"],"k":[8,33],"o":2},"white_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b3.png","sheet_x":19,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b3.png","sheet_x":19,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b3.png","sheet_x":19,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b3.png","sheet_x":19,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b3.png","sheet_x":19,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Woman","b":"1F469-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[19,26],"o":11},"bird":{"a":"Bird","b":"1F426","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fly","tweet","spring"],"k":[12,10],"o":2},"white_frowning_face":{"a":"White Frowning Face","b":"2639-FE0F","c":"2639","d":true,"e":true,"f":true,"h":true,"k":[53,16],"o":2},"bullettrain_front":{"a":"High-Speed Train with Bullet Nose","b":"1F685","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","speed","fast","public","travel"],"k":[34,4],"o":2},"teddy_bear":{"a":"Teddy Bear","b":"1F9F8","d":true,"e":true,"f":true,"h":true,"k":[51,43],"o":11},"white_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b3.png","sheet_x":47,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b3.png","sheet_x":47,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b3.png","sheet_x":47,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b3.png","sheet_x":47,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b3.png","sheet_x":47,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"White Haired Person","b":"1F9D1-200D-1F9B3","d":true,"e":false,"f":false,"h":false,"k":[47,31],"o":12},"spades":{"a":"Black Spade Suit","b":"2660-FE0F","c":"2660","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","suits","magic"],"k":[53,33],"o":2},"banjo":{"a":"Banjo","b":"1FA95","d":true,"e":true,"f":true,"h":true,"k":[52,9],"o":12},"train2":{"a":"Train","b":"1F686","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,5],"o":2},"scorpius":{"a":"Scorpius","b":"264F","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology","scorpio"],"k":[53,27],"o":2},"curry":{"a":"Curry and Rice","b":"1F35B","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","hot","indian"],"k":[6,51],"o":2},"open_mouth":{"a":"Face with Open Mouth","b":"1F62E","d":true,"e":true,"f":true,"h":true,"j":["face","surprise","impressed","wow","whoa",":O"],"k":[31,24],"l":[":o",":-o",":O",":-O"],"o":2},"flag-dg":{"a":"Diego Garcia Flag","b":"1F1E9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,33],"o":2},"penguin":{"a":"Penguin","b":"1F427","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,11],"o":2},"hearts":{"a":"Black Heart Suit","b":"2665-FE0F","c":"2665","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,35],"o":2},"ramen":{"a":"Steaming Bowl","b":"1F35C","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","noodle","chopsticks"],"k":[6,52],"o":2},"sagittarius":{"a":"Sagittarius","b":"2650","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,28],"o":2},"bald_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b2.png","sheet_x":19,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b2.png","sheet_x":19,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b2.png","sheet_x":19,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b2.png","sheet_x":19,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b2.png","sheet_x":19,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Woman","b":"1F469-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[19,20],"o":11},"dove_of_peace":{"a":"Dove of Peace","b":"1F54A-FE0F","c":"1F54A","d":true,"e":true,"f":true,"h":true,"k":[28,34],"o":2},"hushed":{"a":"Hushed Face","b":"1F62F","d":true,"e":true,"f":true,"h":true,"j":["face","woo","shh"],"k":[31,25],"o":2},"metro":{"a":"Metro","b":"1F687","d":true,"e":true,"f":true,"h":true,"j":["transportation","blue-square","mrt","underground","tube"],"k":[34,6],"o":2},"flag-dj":{"a":"Djibouti Flag","b":"1F1E9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,34],"o":2},"drum_with_drumsticks":{"a":"Drum with Drumsticks","b":"1F941","d":true,"e":true,"f":true,"h":true,"k":[41,17],"o":4},"spaghetti":{"a":"Spaghetti","b":"1F35D","d":true,"e":true,"f":true,"h":true,"j":["food","italian","noodle"],"k":[6,53],"o":2},"eagle":{"a":"Eagle","b":"1F985","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird"],"k":[42,23],"o":4},"astonished":{"a":"Astonished Face","b":"1F632","d":true,"e":true,"f":true,"h":true,"j":["face","xox","surprised","poisoned"],"k":[31,28],"o":2},"capricorn":{"a":"Capricorn","b":"2651","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,29],"o":2},"light_rail":{"a":"Light Rail","b":"1F688","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,7],"o":2},"flag-dk":{"a":"Denmark Flag","b":"1F1E9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,35],"o":2},"iphone":{"a":"Mobile Phone","b":"1F4F1","d":true,"e":true,"f":true,"h":true,"j":["technology","apple","gadgets","dial"],"k":[27,14],"o":2},"bald_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b2.png","sheet_x":47,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b2.png","sheet_x":47,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b2.png","sheet_x":47,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b2.png","sheet_x":47,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b2.png","sheet_x":47,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Bald Person","b":"1F9D1-200D-1F9B2","d":true,"e":false,"f":false,"h":false,"k":[47,25],"o":12},"diamonds":{"a":"Black Diamond Suit","b":"2666-FE0F","c":"2666","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,36],"o":2},"clubs":{"a":"Black Club Suit","b":"2663-FE0F","c":"2663","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,34],"o":2},"aquarius":{"a":"Aquarius","b":"2652","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,30],"o":2},"sweet_potato":{"a":"Roasted Sweet Potato","b":"1F360","d":true,"e":true,"f":true,"h":true,"j":["food","nature"],"k":[6,56],"o":2},"flag-dm":{"a":"Dominica Flag","b":"1F1E9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,36],"o":2},"duck":{"a":"Duck","b":"1F986","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","mallard"],"k":[42,24],"o":4},"calling":{"a":"Mobile Phone with Rightwards Arrow at Left","b":"1F4F2","d":true,"e":true,"f":true,"h":true,"j":["iphone","incoming"],"k":[27,15],"o":2},"station":{"a":"Station","b":"1F689","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","public"],"k":[34,8],"o":2},"blond-haired-woman":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2640-FE0F","non_qualified":"1F471-1F3FB-200D-2640","image":"1f471-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2640-FE0F","non_qualified":"1F471-1F3FC-200D-2640","image":"1f471-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2640-FE0F","non_qualified":"1F471-1F3FD-200D-2640","image":"1f471-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2640-FE0F","non_qualified":"1F471-1F3FE-200D-2640","image":"1f471-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2640-FE0F","non_qualified":"1F471-1F3FF-200D-2640","image":"1f471-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Blond Haired Woman","b":"1F471-200D-2640-FE0F","c":"1F471-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,7],"o":4},"flushed":{"a":"Flushed Face","b":"1F633","d":true,"e":true,"f":true,"h":true,"j":["face","blush","shy","flattered"],"k":[31,29],"o":2},"pisces":{"a":"Pisces","b":"2653","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,31],"o":2},"chess_pawn":{"a":"Chess Pawn","b":"265F-FE0F","c":"265F","d":true,"e":true,"f":true,"h":true,"k":[53,32],"o":11},"blond-haired-man":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2642-FE0F","non_qualified":"1F471-1F3FB-200D-2642","image":"1f471-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2642-FE0F","non_qualified":"1F471-1F3FC-200D-2642","image":"1f471-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2642-FE0F","non_qualified":"1F471-1F3FD-200D-2642","image":"1f471-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2642-FE0F","non_qualified":"1F471-1F3FE-200D-2642","image":"1f471-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2642-FE0F","non_qualified":"1F471-1F3FF-200D-2642","image":"1f471-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F471","a":"Blond Haired Man","b":"1F471-200D-2642-FE0F","c":"1F471-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,13],"o":4},"phone":{"a":"Black Telephone","b":"260E-FE0F","c":"260E","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial","telephone"],"k":[52,54],"n":["telephone"],"o":2},"oden":{"a":"Oden","b":"1F362","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[7,1],"o":2},"flag-do":{"a":"Dominican Republic Flag","b":"1F1E9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,37],"o":2},"tram":{"a":"Tram","b":"1F68A","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,9],"o":2},"swan":{"a":"Swan","b":"1F9A2","d":true,"e":true,"f":true,"h":true,"k":[42,52],"o":11},"pleading_face":{"a":"Face with Pleading Eyes","b":"1F97A","d":true,"e":true,"f":true,"h":true,"k":[42,12],"o":11},"flag-dz":{"a":"Algeria Flag","b":"1F1E9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,38],"o":2},"monorail":{"a":"Monorail","b":"1F69D","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,28],"o":2},"owl":{"a":"Owl","b":"1F989","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","hoot"],"k":[42,27],"o":4},"sushi":{"a":"Sushi","b":"1F363","d":true,"e":true,"f":true,"h":true,"j":["food","fish","japanese","rice"],"k":[7,2],"o":2},"telephone_receiver":{"a":"Telephone Receiver","b":"1F4DE","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial"],"k":[26,52],"o":2},"black_joker":{"a":"Playing Card Black Joker","b":"1F0CF","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","game","play","magic"],"k":[0,15],"o":2},"ophiuchus":{"a":"Ophiuchus","b":"26CE","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","constellation","astrology"],"k":[54,4],"o":2},"frowning":{"a":"Frowning Face with Open Mouth","b":"1F626","d":true,"e":true,"f":true,"h":true,"j":["face","aw","what"],"k":[31,16],"o":2},"older_adult":{"skin_variations":{"1F3FB":{"unified":"1F9D3-1F3FB","non_qualified":null,"image":"1f9d3-1f3fb.png","sheet_x":48,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D3-1F3FC","non_qualified":null,"image":"1f9d3-1f3fc.png","sheet_x":48,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D3-1F3FD","non_qualified":null,"image":"1f9d3-1f3fd.png","sheet_x":48,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D3-1F3FE","non_qualified":null,"image":"1f9d3-1f3fe.png","sheet_x":48,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D3-1F3FF","non_qualified":null,"image":"1f9d3-1f3ff.png","sheet_x":48,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Adult","b":"1F9D3","d":true,"e":true,"f":true,"h":true,"k":[48,22],"o":5},"flag-ea":{"a":"Ceuta & Melilla Flag","b":"1F1EA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,39],"o":2},"flamingo":{"a":"Flamingo","b":"1F9A9","d":true,"e":true,"f":true,"h":true,"k":[43,0],"o":12},"pager":{"a":"Pager","b":"1F4DF","d":true,"e":true,"f":true,"h":true,"j":["bbcall","oldschool","90s"],"k":[26,53],"o":2},"mountain_railway":{"a":"Mountain Railway","b":"1F69E","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,29],"o":2},"mahjong":{"a":"Mahjong Tile Red Dragon","b":"1F004","d":true,"e":true,"f":true,"h":true,"j":["game","play","chinese","kanji"],"k":[0,14],"o":2},"older_man":{"skin_variations":{"1F3FB":{"unified":"1F474-1F3FB","non_qualified":null,"image":"1f474-1f3fb.png","sheet_x":22,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F474-1F3FC","non_qualified":null,"image":"1f474-1f3fc.png","sheet_x":22,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F474-1F3FD","non_qualified":null,"image":"1f474-1f3fd.png","sheet_x":22,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F474-1F3FE","non_qualified":null,"image":"1f474-1f3fe.png","sheet_x":22,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F474-1F3FF","non_qualified":null,"image":"1f474-1f3ff.png","sheet_x":22,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Man","b":"1F474","d":true,"e":true,"f":true,"h":true,"j":["human","male","men","old","elder","senior"],"k":[22,49],"o":2},"twisted_rightwards_arrows":{"a":"Twisted Rightwards Arrows","b":"1F500","d":true,"e":true,"f":true,"h":true,"j":["blue-square","shuffle","music","random"],"k":[27,28],"o":2},"fried_shrimp":{"a":"Fried Shrimp","b":"1F364","d":true,"e":true,"f":true,"h":true,"j":["food","animal","appetizer","summer"],"k":[7,3],"o":2},"anguished":{"a":"Anguished Face","b":"1F627","d":true,"e":true,"f":true,"h":true,"j":["face","stunned","nervous"],"k":[31,17],"l":["D:"],"o":2},"repeat":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows","b":"1F501","d":true,"e":true,"f":true,"h":true,"j":["loop","record"],"k":[27,29],"o":2},"fish_cake":{"a":"Fish Cake with Swirl Design","b":"1F365","d":true,"e":true,"f":true,"h":true,"j":["food","japan","sea","beach","narutomaki","pink","swirl","kamaboko","surimi","ramen"],"k":[7,4],"o":2},"fax":{"a":"Fax Machine","b":"1F4E0","d":true,"e":true,"f":true,"h":true,"j":["communication","technology"],"k":[26,54],"o":2},"older_woman":{"skin_variations":{"1F3FB":{"unified":"1F475-1F3FB","non_qualified":null,"image":"1f475-1f3fb.png","sheet_x":22,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F475-1F3FC","non_qualified":null,"image":"1f475-1f3fc.png","sheet_x":23,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F475-1F3FD","non_qualified":null,"image":"1f475-1f3fd.png","sheet_x":23,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F475-1F3FE","non_qualified":null,"image":"1f475-1f3fe.png","sheet_x":23,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F475-1F3FF","non_qualified":null,"image":"1f475-1f3ff.png","sheet_x":23,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Woman","b":"1F475","d":true,"e":true,"f":true,"h":true,"j":["human","female","women","lady","old","elder","senior"],"k":[22,55],"o":2},"flag-ec":{"a":"Ecuador Flag","b":"1F1EA-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,40],"o":2},"peacock":{"a":"Peacock","b":"1F99A","d":true,"e":true,"f":true,"h":true,"k":[42,44],"o":11},"fearful":{"a":"Fearful Face","b":"1F628","d":true,"e":true,"f":true,"h":true,"j":["face","scared","terrified","nervous","oops","huh"],"k":[31,18],"o":2},"train":{"a":"Tram Car","b":"1F68B","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","carriage","public","travel"],"k":[34,10],"o":2},"flower_playing_cards":{"a":"Flower Playing Cards","b":"1F3B4","d":true,"e":true,"f":true,"h":true,"j":["game","sunset","red"],"k":[8,26],"o":2},"repeat_one":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay","b":"1F502","d":true,"e":true,"f":true,"h":true,"j":["blue-square","loop"],"k":[27,30],"o":2},"moon_cake":{"a":"Moon Cake","b":"1F96E","d":true,"e":true,"f":true,"h":true,"k":[42,4],"o":11},"performing_arts":{"a":"Performing Arts","b":"1F3AD","d":true,"e":true,"f":true,"h":true,"j":["acting","theater","drama"],"k":[8,19],"o":2},"cold_sweat":{"a":"Face with Open Mouth and Cold Sweat","b":"1F630","d":true,"e":true,"f":true,"h":true,"j":["face","nervous","sweat"],"k":[31,26],"o":2},"person_frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB","non_qualified":null,"image":"1f64d-1f3fb.png","sheet_x":33,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64D-1F3FC","non_qualified":null,"image":"1f64d-1f3fc.png","sheet_x":33,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64D-1F3FD","non_qualified":null,"image":"1f64d-1f3fd.png","sheet_x":33,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64D-1F3FE","non_qualified":null,"image":"1f64d-1f3fe.png","sheet_x":33,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64D-1F3FF","non_qualified":null,"image":"1f64d-1f3ff.png","sheet_x":33,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64D-200D-2640-FE0F","a":"Person Frowning","b":"1F64D","d":true,"e":true,"f":true,"h":false,"k":[33,26],"o":2},"flag-ee":{"a":"Estonia Flag","b":"1F1EA-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[1,41],"o":2},"battery":{"a":"Battery","b":"1F50B","d":true,"e":true,"f":true,"h":true,"j":["power","energy","sustain"],"k":[27,39],"o":2},"parrot":{"a":"Parrot","b":"1F99C","d":true,"e":true,"f":true,"h":true,"k":[42,46],"o":11},"bus":{"a":"Bus","b":"1F68C","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,11],"o":2},"flag-eg":{"a":"Egypt Flag","b":"1F1EA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,42],"o":2},"arrow_forward":{"a":"Black Right-Pointing Triangle","b":"25B6-FE0F","c":"25B6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","right","direction","play"],"k":[52,43],"o":2},"man-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2642-FE0F","non_qualified":"1F64D-1F3FB-200D-2642","image":"1f64d-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2642-FE0F","non_qualified":"1F64D-1F3FC-200D-2642","image":"1f64d-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2642-FE0F","non_qualified":"1F64D-1F3FD-200D-2642","image":"1f64d-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2642-FE0F","non_qualified":"1F64D-1F3FE-200D-2642","image":"1f64d-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2642-FE0F","non_qualified":"1F64D-1F3FF-200D-2642","image":"1f64d-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Frowning","b":"1F64D-200D-2642-FE0F","c":"1F64D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,20],"o":4},"disappointed_relieved":{"a":"Disappointed but Relieved Face","b":"1F625","d":true,"e":true,"f":true,"h":true,"j":["face","phew","sweat","nervous"],"k":[31,15],"o":2},"electric_plug":{"a":"Electric Plug","b":"1F50C","d":true,"e":true,"f":true,"h":true,"j":["charger","power"],"k":[27,40],"o":2},"frame_with_picture":{"a":"Frame with Picture","b":"1F5BC-FE0F","c":"1F5BC","d":true,"e":true,"f":true,"h":true,"k":[30,14],"o":2},"oncoming_bus":{"a":"Oncoming Bus","b":"1F68D","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,12],"o":2},"dango":{"a":"Dango","b":"1F361","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","sweet","japanese","barbecue","meat"],"k":[7,0],"o":2},"frog":{"a":"Frog Face","b":"1F438","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","croak","toad"],"k":[12,28],"o":2},"computer":{"a":"Personal Computer","b":"1F4BB","d":true,"e":true,"f":true,"h":true,"j":["technology","laptop","screen","display","monitor"],"k":[26,17],"o":2},"art":{"a":"Artist Palette","b":"1F3A8","d":true,"e":true,"f":true,"h":true,"j":["design","paint","draw","colors"],"k":[8,14],"o":2},"flag-eh":{"a":"Western Sahara Flag","b":"1F1EA-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,43],"o":2},"fast_forward":{"a":"Black Right-Pointing Double Triangle","b":"23E9","d":true,"e":true,"f":true,"h":true,"j":["blue-square","play","speed","continue"],"k":[52,26],"o":2},"cry":{"a":"Crying Face","b":"1F622","d":true,"e":true,"f":true,"h":true,"j":["face","tears","sad","depressed","upset",":'("],"k":[31,12],"l":[":'("],"m":":'(","o":2},"woman-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2640-FE0F","non_qualified":"1F64D-1F3FB-200D-2640","image":"1f64d-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2640-FE0F","non_qualified":"1F64D-1F3FC-200D-2640","image":"1f64d-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2640-FE0F","non_qualified":"1F64D-1F3FD-200D-2640","image":"1f64d-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2640-FE0F","non_qualified":"1F64D-1F3FE-200D-2640","image":"1f64d-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2640-FE0F","non_qualified":"1F64D-1F3FF-200D-2640","image":"1f64d-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64D","a":"Woman Frowning","b":"1F64D-200D-2640-FE0F","c":"1F64D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,14],"o":4},"trolleybus":{"a":"Trolleybus","b":"1F68E","d":true,"e":true,"f":true,"h":true,"j":["bart","transportation","vehicle"],"k":[34,13],"o":2},"crocodile":{"a":"Crocodile","b":"1F40A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile","lizard","alligator"],"k":[11,38],"o":2},"dumpling":{"a":"Dumpling","b":"1F95F","d":true,"e":true,"f":true,"h":true,"k":[41,46],"o":5},"black_right_pointing_double_triangle_with_vertical_bar":{"a":"Black Right Pointing Double Triangle with Vertical Bar","b":"23ED-FE0F","c":"23ED","d":true,"e":true,"f":true,"h":true,"k":[52,30],"o":2},"desktop_computer":{"a":"Desktop Computer","b":"1F5A5-FE0F","c":"1F5A5","d":true,"e":true,"f":true,"h":true,"j":["technology","computing","screen"],"k":[30,10],"o":2},"person_with_pouting_face":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB","non_qualified":null,"image":"1f64e-1f3fb.png","sheet_x":33,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64E-1F3FC","non_qualified":null,"image":"1f64e-1f3fc.png","sheet_x":33,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64E-1F3FD","non_qualified":null,"image":"1f64e-1f3fd.png","sheet_x":33,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64E-1F3FE","non_qualified":null,"image":"1f64e-1f3fe.png","sheet_x":33,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64E-1F3FF","non_qualified":null,"image":"1f64e-1f3ff.png","sheet_x":33,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64E-200D-2640-FE0F","a":"Person with Pouting Face","b":"1F64E","d":true,"e":true,"f":true,"h":false,"k":[33,44],"o":2},"turtle":{"a":"Turtle","b":"1F422","d":true,"e":true,"f":true,"h":true,"j":["animal","slow","nature","tortoise"],"k":[12,6],"o":2},"sob":{"a":"Loudly Crying Face","b":"1F62D","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","sad","upset","depressed"],"k":[31,23],"m":":'(","o":2},"flag-er":{"a":"Eritrea Flag","b":"1F1EA-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,44],"o":2},"thread":{"a":"Spool of Thread","b":"1F9F5","d":true,"e":true,"f":true,"h":true,"k":[51,40],"o":11},"minibus":{"a":"Minibus","b":"1F690","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","transportation"],"k":[34,15],"o":2},"fortune_cookie":{"a":"Fortune Cookie","b":"1F960","d":true,"e":true,"f":true,"h":true,"k":[41,47],"o":5},"yarn":{"a":"Ball of Yarn","b":"1F9F6","d":true,"e":true,"f":true,"h":true,"k":[51,41],"o":11},"takeout_box":{"a":"Takeout Box","b":"1F961","d":true,"e":true,"f":true,"h":true,"k":[41,48],"o":5},"man-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2642-FE0F","non_qualified":"1F64E-1F3FB-200D-2642","image":"1f64e-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2642-FE0F","non_qualified":"1F64E-1F3FC-200D-2642","image":"1f64e-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2642-FE0F","non_qualified":"1F64E-1F3FD-200D-2642","image":"1f64e-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2642-FE0F","non_qualified":"1F64E-1F3FE-200D-2642","image":"1f64e-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2642-FE0F","non_qualified":"1F64E-1F3FF-200D-2642","image":"1f64e-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Pouting","b":"1F64E-200D-2642-FE0F","c":"1F64E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,38],"o":4},"printer":{"a":"Printer","b":"1F5A8-FE0F","c":"1F5A8","d":true,"e":true,"f":true,"h":true,"j":["paper","ink"],"k":[30,11],"o":2},"scream":{"a":"Face Screaming in Fear","b":"1F631","d":true,"e":true,"f":true,"h":true,"j":["face","munch","scared","omg"],"k":[31,27],"o":2},"es":{"a":"Spain Flag","b":"1F1EA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["spain","flag","nation","country","banner"],"k":[1,45],"n":["flag-es"],"o":2},"ambulance":{"a":"Ambulance","b":"1F691","d":true,"e":true,"f":true,"h":true,"j":["health","911","hospital"],"k":[34,16],"o":2},"black_right_pointing_triangle_with_double_vertical_bar":{"a":"Black Right Pointing Triangle with Double Vertical Bar","b":"23EF-FE0F","c":"23EF","d":true,"e":true,"f":true,"h":true,"k":[52,32],"o":2},"lizard":{"a":"Lizard","b":"1F98E","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile"],"k":[42,32],"o":4},"flag-et":{"a":"Ethiopia Flag","b":"1F1EA-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,46],"o":2},"keyboard":{"a":"Keyboard","b":"2328-FE0F","c":"2328","d":true,"e":true,"f":true,"h":true,"j":["technology","computer","type","input","text"],"k":[52,24],"o":2},"crab":{"a":"Crab","b":"1F980","d":true,"e":true,"f":true,"h":true,"j":["animal","crustacean"],"k":[42,18],"o":2},"confounded":{"a":"Confounded Face","b":"1F616","d":true,"e":true,"f":true,"h":true,"j":["face","confused","sick","unwell","oops",":S"],"k":[31,0],"o":2},"snake":{"a":"Snake","b":"1F40D","d":true,"e":true,"f":true,"h":true,"j":["animal","evil","nature","hiss","python"],"k":[11,41],"o":2},"woman-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2640-FE0F","non_qualified":"1F64E-1F3FB-200D-2640","image":"1f64e-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2640-FE0F","non_qualified":"1F64E-1F3FC-200D-2640","image":"1f64e-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2640-FE0F","non_qualified":"1F64E-1F3FD-200D-2640","image":"1f64e-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2640-FE0F","non_qualified":"1F64E-1F3FE-200D-2640","image":"1f64e-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2640-FE0F","non_qualified":"1F64E-1F3FF-200D-2640","image":"1f64e-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64E","a":"Woman Pouting","b":"1F64E-200D-2640-FE0F","c":"1F64E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,32],"o":4},"arrow_backward":{"a":"Black Left-Pointing Triangle","b":"25C0-FE0F","c":"25C0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","left","direction"],"k":[52,44],"o":2},"fire_engine":{"a":"Fire Engine","b":"1F692","d":true,"e":true,"f":true,"h":true,"j":["transportation","cars","vehicle"],"k":[34,17],"o":2},"rewind":{"a":"Black Left-Pointing Double Triangle","b":"23EA","d":true,"e":true,"f":true,"h":true,"j":["play","blue-square"],"k":[52,27],"o":2},"three_button_mouse":{"a":"Three Button Mouse","b":"1F5B1-FE0F","c":"1F5B1","d":true,"e":true,"f":true,"h":true,"k":[30,12],"o":2},"no_good":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB","non_qualified":null,"image":"1f645-1f3fb.png","sheet_x":32,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F645-1F3FC","non_qualified":null,"image":"1f645-1f3fc.png","sheet_x":32,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F645-1F3FD","non_qualified":null,"image":"1f645-1f3fd.png","sheet_x":32,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F645-1F3FE","non_qualified":null,"image":"1f645-1f3fe.png","sheet_x":32,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F645-1F3FF","non_qualified":null,"image":"1f645-1f3ff.png","sheet_x":32,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F645-200D-2640-FE0F","a":"Face with No Good Gesture","b":"1F645","d":true,"e":true,"f":true,"h":false,"k":[32,2],"o":2},"police_car":{"a":"Police Car","b":"1F693","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","law","legal","enforcement"],"k":[34,18],"o":2},"dragon_face":{"a":"Dragon Face","b":"1F432","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[12,22],"o":2},"persevere":{"a":"Persevering Face","b":"1F623","d":true,"e":true,"f":true,"h":true,"j":["face","sick","no","upset","oops"],"k":[31,13],"o":2},"lobster":{"a":"Lobster","b":"1F99E","d":true,"e":true,"f":true,"h":true,"k":[42,48],"o":11},"flag-eu":{"a":"European Union Flag","b":"1F1EA-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,47],"o":2},"disappointed":{"a":"Disappointed Face","b":"1F61E","d":true,"e":true,"f":true,"h":true,"j":["face","sad","upset","depressed",":("],"k":[31,8],"l":["):",":(",":-("],"m":":(","o":2},"shrimp":{"a":"Shrimp","b":"1F990","d":true,"e":true,"f":true,"h":true,"j":["animal","ocean","nature","seafood"],"k":[42,34],"o":4},"dragon":{"a":"Dragon","b":"1F409","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[11,37],"o":2},"man-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2642-FE0F","non_qualified":"1F645-1F3FB-200D-2642","image":"1f645-1f3fb-200d-2642-fe0f.png","sheet_x":31,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2642-FE0F","non_qualified":"1F645-1F3FC-200D-2642","image":"1f645-1f3fc-200d-2642-fe0f.png","sheet_x":31,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2642-FE0F","non_qualified":"1F645-1F3FD-200D-2642","image":"1f645-1f3fd-200d-2642-fe0f.png","sheet_x":31,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2642-FE0F","non_qualified":"1F645-1F3FE-200D-2642","image":"1f645-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2642-FE0F","non_qualified":"1F645-1F3FF-200D-2642","image":"1f645-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing No","b":"1F645-200D-2642-FE0F","c":"1F645-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[31,53],"o":4},"flag-fi":{"a":"Finland Flag","b":"1F1EB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,48],"o":2},"trackball":{"a":"Trackball","b":"1F5B2-FE0F","c":"1F5B2","d":true,"e":true,"f":true,"h":true,"j":["technology","trackpad"],"k":[30,13],"o":2},"black_left_pointing_double_triangle_with_vertical_bar":{"a":"Black Left Pointing Double Triangle with Vertical Bar","b":"23EE-FE0F","c":"23EE","d":true,"e":true,"f":true,"h":true,"k":[52,31],"o":2},"oncoming_police_car":{"a":"Oncoming Police Car","b":"1F694","d":true,"e":true,"f":true,"h":true,"j":["vehicle","law","legal","enforcement","911"],"k":[34,19],"o":2},"minidisc":{"a":"Minidisc","b":"1F4BD","d":true,"e":true,"f":true,"h":true,"j":["technology","record","data","disk","90s"],"k":[26,19],"o":2},"sweat":{"a":"Face with Cold Sweat","b":"1F613","d":true,"e":true,"f":true,"h":true,"j":["face","hot","sad","tired","exercise"],"k":[30,54],"o":2},"squid":{"a":"Squid","b":"1F991","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ocean","sea"],"k":[42,35],"o":4},"sauropod":{"a":"Sauropod","b":"1F995","d":true,"e":true,"f":true,"h":true,"k":[42,39],"o":5},"arrow_up_small":{"a":"Up-Pointing Small Red Triangle","b":"1F53C","d":true,"e":true,"f":true,"h":true,"j":["blue-square","triangle","direction","point","forward","top"],"k":[28,31],"o":2},"flag-fj":{"a":"Fiji Flag","b":"1F1EB-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,49],"o":2},"woman-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2640-FE0F","non_qualified":"1F645-1F3FB-200D-2640","image":"1f645-1f3fb-200d-2640-fe0f.png","sheet_x":31,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2640-FE0F","non_qualified":"1F645-1F3FC-200D-2640","image":"1f645-1f3fc-200d-2640-fe0f.png","sheet_x":31,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2640-FE0F","non_qualified":"1F645-1F3FD-200D-2640","image":"1f645-1f3fd-200d-2640-fe0f.png","sheet_x":31,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2640-FE0F","non_qualified":"1F645-1F3FE-200D-2640","image":"1f645-1f3fe-200d-2640-fe0f.png","sheet_x":31,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2640-FE0F","non_qualified":"1F645-1F3FF-200D-2640","image":"1f645-1f3ff-200d-2640-fe0f.png","sheet_x":31,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F645","a":"Woman Gesturing No","b":"1F645-200D-2640-FE0F","c":"1F645-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[31,47],"o":4},"taxi":{"a":"Taxi","b":"1F695","d":true,"e":true,"f":true,"h":true,"j":["uber","vehicle","cars","transportation"],"k":[34,20],"o":2},"flag-fk":{"a":"Falkland Islands Flag","b":"1F1EB-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,50],"o":2},"floppy_disk":{"a":"Floppy Disk","b":"1F4BE","d":true,"e":true,"f":true,"h":true,"j":["oldschool","technology","save","90s","80s"],"k":[26,20],"o":2},"t-rex":{"a":"T-Rex","b":"1F996","d":true,"e":true,"f":true,"h":true,"k":[42,40],"o":5},"oyster":{"a":"Oyster","b":"1F9AA","d":true,"e":true,"f":true,"h":true,"k":[43,1],"o":12},"arrow_double_up":{"a":"Black Up-Pointing Double Triangle","b":"23EB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[52,28],"o":2},"oncoming_taxi":{"a":"Oncoming Taxi","b":"1F696","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","uber"],"k":[34,21],"o":2},"ok_woman":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB","non_qualified":null,"image":"1f646-1f3fb.png","sheet_x":32,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F646-1F3FC","non_qualified":null,"image":"1f646-1f3fc.png","sheet_x":32,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F646-1F3FD","non_qualified":null,"image":"1f646-1f3fd.png","sheet_x":32,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F646-1F3FE","non_qualified":null,"image":"1f646-1f3fe.png","sheet_x":32,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F646-1F3FF","non_qualified":null,"image":"1f646-1f3ff.png","sheet_x":32,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F646-200D-2640-FE0F","a":"Face with Ok Gesture","b":"1F646","d":true,"e":true,"f":true,"h":false,"j":["women","girl","female","pink","human","woman"],"k":[32,20],"o":2},"weary":{"a":"Weary Face","b":"1F629","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","sad","frustrated","upset"],"k":[31,19],"o":2},"man-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2642-FE0F","non_qualified":"1F646-1F3FB-200D-2642","image":"1f646-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2642-FE0F","non_qualified":"1F646-1F3FC-200D-2642","image":"1f646-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2642-FE0F","non_qualified":"1F646-1F3FD-200D-2642","image":"1f646-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2642-FE0F","non_qualified":"1F646-1F3FE-200D-2642","image":"1f646-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2642-FE0F","non_qualified":"1F646-1F3FF-200D-2642","image":"1f646-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing Ok","b":"1F646-200D-2642-FE0F","c":"1F646-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,14],"o":4},"arrow_down_small":{"a":"Down-Pointing Small Red Triangle","b":"1F53D","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[28,32],"o":2},"tired_face":{"a":"Tired Face","b":"1F62B","d":true,"e":true,"f":true,"h":true,"j":["sick","whine","upset","frustrated"],"k":[31,21],"o":2},"car":{"a":"Automobile","b":"1F697","d":true,"e":true,"f":true,"h":true,"k":[34,22],"n":["red_car"],"o":2},"icecream":{"a":"Soft Ice Cream","b":"1F366","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert","summer"],"k":[7,5],"o":2},"cd":{"a":"Optical Disc","b":"1F4BF","d":true,"e":true,"f":true,"h":true,"j":["technology","dvd","disk","disc","90s"],"k":[26,21],"o":2},"whale":{"a":"Spouting Whale","b":"1F433","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[12,23],"o":2},"flag-fm":{"a":"Micronesia Flag","b":"1F1EB-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,51],"o":2},"oncoming_automobile":{"a":"Oncoming Automobile","b":"1F698","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,23],"o":2},"arrow_double_down":{"a":"Black Down-Pointing Double Triangle","b":"23EC","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[52,29],"o":2},"woman-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2640-FE0F","non_qualified":"1F646-1F3FB-200D-2640","image":"1f646-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2640-FE0F","non_qualified":"1F646-1F3FC-200D-2640","image":"1f646-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2640-FE0F","non_qualified":"1F646-1F3FD-200D-2640","image":"1f646-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2640-FE0F","non_qualified":"1F646-1F3FE-200D-2640","image":"1f646-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2640-FE0F","non_qualified":"1F646-1F3FF-200D-2640","image":"1f646-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F646","a":"Woman Gesturing Ok","b":"1F646-200D-2640-FE0F","c":"1F646-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,8],"o":4},"yawning_face":{"a":"Yawning Face","b":"1F971","d":true,"e":true,"f":true,"h":true,"k":[42,7],"o":12},"dvd":{"a":"Dvd","b":"1F4C0","d":true,"e":true,"f":true,"h":true,"j":["cd","disk","disc"],"k":[26,22],"o":2},"whale2":{"a":"Whale","b":"1F40B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[11,39],"o":2},"flag-fo":{"a":"Faroe Islands Flag","b":"1F1EB-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,52],"o":2},"shaved_ice":{"a":"Shaved Ice","b":"1F367","d":true,"e":true,"f":true,"h":true,"j":["hot","dessert","summer"],"k":[7,6],"o":2},"double_vertical_bar":{"a":"Double Vertical Bar","b":"23F8-FE0F","c":"23F8","d":true,"e":true,"f":true,"h":true,"k":[52,37],"o":2},"information_desk_person":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB","non_qualified":null,"image":"1f481-1f3fb.png","sheet_x":24,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F481-1F3FC","non_qualified":null,"image":"1f481-1f3fc.png","sheet_x":24,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F481-1F3FD","non_qualified":null,"image":"1f481-1f3fd.png","sheet_x":24,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F481-1F3FE","non_qualified":null,"image":"1f481-1f3fe.png","sheet_x":24,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F481-1F3FF","non_qualified":null,"image":"1f481-1f3ff.png","sheet_x":24,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F481-200D-2640-FE0F","a":"Information Desk Person","b":"1F481","d":true,"e":true,"f":true,"h":false,"k":[24,2],"o":2},"dolphin":{"a":"Dolphin","b":"1F42C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","flipper","fins","beach"],"k":[12,16],"n":["flipper"],"o":2},"blue_car":{"a":"Recreational Vehicle","b":"1F699","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,24],"o":2},"ice_cream":{"a":"Ice Cream","b":"1F368","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert"],"k":[7,7],"o":2},"fr":{"a":"France Flag","b":"1F1EB-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["banner","flag","nation","france","french","country"],"k":[1,53],"n":["flag-fr"],"o":2},"triumph":{"a":"Face with Look of Triumph","b":"1F624","d":true,"e":true,"f":true,"h":true,"j":["face","gas","phew","proud","pride"],"k":[31,14],"o":2},"abacus":{"a":"Abacus","b":"1F9EE","d":true,"e":true,"f":true,"h":true,"k":[51,33],"o":11},"man-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2642-FE0F","non_qualified":"1F481-1F3FB-200D-2642","image":"1f481-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2642-FE0F","non_qualified":"1F481-1F3FC-200D-2642","image":"1f481-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2642-FE0F","non_qualified":"1F481-1F3FD-200D-2642","image":"1f481-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2642-FE0F","non_qualified":"1F481-1F3FE-200D-2642","image":"1f481-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2642-FE0F","non_qualified":"1F481-1F3FF-200D-2642","image":"1f481-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Tipping Hand","b":"1F481-200D-2642-FE0F","c":"1F481-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,53],"o":4},"doughnut":{"a":"Doughnut","b":"1F369","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","snack","sweet","donut"],"k":[7,8],"o":2},"fish":{"a":"Fish","b":"1F41F","d":true,"e":true,"f":true,"h":true,"j":["animal","food","nature"],"k":[12,3],"o":2},"truck":{"a":"Delivery Truck","b":"1F69A","d":true,"e":true,"f":true,"h":true,"j":["cars","transportation"],"k":[34,25],"o":2},"movie_camera":{"a":"Movie Camera","b":"1F3A5","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[8,11],"o":2},"flag-ga":{"a":"Gabon Flag","b":"1F1EC-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,54],"o":2},"rage":{"a":"Pouting Face","b":"1F621","d":true,"e":true,"f":true,"h":true,"j":["angry","mad","hate","despise"],"k":[31,11],"o":2},"black_square_for_stop":{"a":"Black Square for Stop","b":"23F9-FE0F","c":"23F9","d":true,"e":true,"f":true,"h":true,"k":[52,38],"o":2},"articulated_lorry":{"a":"Articulated Lorry","b":"1F69B","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","express"],"k":[34,26],"o":2},"angry":{"a":"Angry Face","b":"1F620","d":true,"e":true,"f":true,"h":true,"j":["mad","face","annoyed","frustrated"],"k":[31,10],"l":[">:(",">:-("],"o":2},"cookie":{"a":"Cookie","b":"1F36A","d":true,"e":true,"f":true,"h":true,"j":["food","snack","oreo","chocolate","sweet","dessert"],"k":[7,9],"o":2},"gb":{"a":"United Kingdom Flag","b":"1F1EC-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[1,55],"n":["uk","flag-gb"],"o":2},"tropical_fish":{"a":"Tropical Fish","b":"1F420","d":true,"e":true,"f":true,"h":true,"j":["animal","swim","ocean","beach","nemo"],"k":[12,4],"o":2},"woman-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2640-FE0F","non_qualified":"1F481-1F3FB-200D-2640","image":"1f481-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2640-FE0F","non_qualified":"1F481-1F3FC-200D-2640","image":"1f481-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2640-FE0F","non_qualified":"1F481-1F3FD-200D-2640","image":"1f481-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2640-FE0F","non_qualified":"1F481-1F3FE-200D-2640","image":"1f481-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2640-FE0F","non_qualified":"1F481-1F3FF-200D-2640","image":"1f481-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F481","a":"Woman Tipping Hand","b":"1F481-200D-2640-FE0F","c":"1F481-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,47],"o":4},"black_circle_for_record":{"a":"Black Circle for Record","b":"23FA-FE0F","c":"23FA","d":true,"e":true,"f":true,"h":true,"k":[52,39],"o":2},"film_frames":{"a":"Film Frames","b":"1F39E-FE0F","c":"1F39E","d":true,"e":true,"f":true,"h":true,"k":[8,4],"o":2},"film_projector":{"a":"Film Projector","b":"1F4FD-FE0F","c":"1F4FD","d":true,"e":true,"f":true,"h":true,"j":["video","tape","record","movie"],"k":[27,26],"o":2},"flag-gd":{"a":"Grenada Flag","b":"1F1EC-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,56],"o":2},"blowfish":{"a":"Blowfish","b":"1F421","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","food","sea","ocean"],"k":[12,5],"o":2},"face_with_symbols_on_mouth":{"a":"Serious Face with Symbols Covering Mouth","b":"1F92C","d":true,"e":true,"f":true,"h":true,"k":[38,46],"n":["serious_face_with_symbols_covering_mouth"],"o":5},"birthday":{"a":"Birthday Cake","b":"1F382","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","cake"],"k":[7,33],"o":2},"eject":{"a":"Eject","b":"23CF-FE0F","c":"23CF","d":true,"e":true,"f":true,"h":true,"k":[52,25],"o":2},"raising_hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB","non_qualified":null,"image":"1f64b-1f3fb.png","sheet_x":33,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64B-1F3FC","non_qualified":null,"image":"1f64b-1f3fc.png","sheet_x":33,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64B-1F3FD","non_qualified":null,"image":"1f64b-1f3fd.png","sheet_x":33,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64B-1F3FE","non_qualified":null,"image":"1f64b-1f3fe.png","sheet_x":33,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64B-1F3FF","non_qualified":null,"image":"1f64b-1f3ff.png","sheet_x":33,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64B-200D-2640-FE0F","a":"Happy Person Raising One Hand","b":"1F64B","d":true,"e":true,"f":true,"h":false,"k":[33,2],"o":2},"tractor":{"a":"Tractor","b":"1F69C","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","farming","agriculture"],"k":[34,27],"o":2},"flag-ge":{"a":"Georgia Flag","b":"1F1EC-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,0],"o":2},"smiling_imp":{"a":"Smiling Face with Horns","b":"1F608","d":true,"e":true,"f":true,"h":true,"j":["devil","horns"],"k":[30,43],"o":2},"racing_car":{"a":"Racing Car","b":"1F3CE-FE0F","c":"1F3CE","d":true,"e":true,"f":true,"h":true,"j":["sports","race","fast","formula","f1"],"k":[10,33],"o":2},"cinema":{"a":"Cinema","b":"1F3A6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","record","film","movie","curtain","stage","theater"],"k":[8,12],"o":2},"clapper":{"a":"Clapper Board","b":"1F3AC","d":true,"e":true,"f":true,"h":true,"j":["movie","film","record"],"k":[8,18],"o":2},"shark":{"a":"Shark","b":"1F988","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"k":[42,26],"o":4},"cake":{"a":"Shortcake","b":"1F370","d":true,"e":true,"f":true,"h":true,"j":["food","dessert"],"k":[7,15],"o":2},"man-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2642-FE0F","non_qualified":"1F64B-1F3FB-200D-2642","image":"1f64b-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2642-FE0F","non_qualified":"1F64B-1F3FC-200D-2642","image":"1f64b-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2642-FE0F","non_qualified":"1F64B-1F3FD-200D-2642","image":"1f64b-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2642-FE0F","non_qualified":"1F64B-1F3FE-200D-2642","image":"1f64b-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2642-FE0F","non_qualified":"1F64B-1F3FF-200D-2642","image":"1f64b-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Raising Hand","b":"1F64B-200D-2642-FE0F","c":"1F64B-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,53],"o":4},"octopus":{"a":"Octopus","b":"1F419","d":true,"e":true,"f":true,"h":true,"j":["animal","creature","ocean","sea","nature","beach"],"k":[11,54],"o":2},"woman-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2640-FE0F","non_qualified":"1F64B-1F3FB-200D-2640","image":"1f64b-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2640-FE0F","non_qualified":"1F64B-1F3FC-200D-2640","image":"1f64b-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2640-FE0F","non_qualified":"1F64B-1F3FD-200D-2640","image":"1f64b-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2640-FE0F","non_qualified":"1F64B-1F3FE-200D-2640","image":"1f64b-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2640-FE0F","non_qualified":"1F64B-1F3FF-200D-2640","image":"1f64b-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64B","a":"Woman Raising Hand","b":"1F64B-200D-2640-FE0F","c":"1F64B-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,47],"o":4},"flag-gf":{"a":"French Guiana Flag","b":"1F1EC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[2,1],"o":2},"tv":{"a":"Television","b":"1F4FA","d":true,"e":true,"f":true,"h":true,"j":["technology","program","oldschool","show","television"],"k":[27,23],"o":2},"imp":{"a":"Imp","b":"1F47F","d":true,"e":true,"f":true,"h":true,"j":["devil","angry","horns"],"k":[23,45],"o":2},"cupcake":{"a":"Cupcake","b":"1F9C1","d":true,"e":true,"f":true,"h":true,"k":[44,9],"o":11},"racing_motorcycle":{"a":"Racing Motorcycle","b":"1F3CD-FE0F","c":"1F3CD","d":true,"e":true,"f":true,"h":true,"k":[10,32],"o":2},"low_brightness":{"a":"Low Brightness Symbol","b":"1F505","d":true,"e":true,"f":true,"h":true,"j":["sun","afternoon","warm","summer"],"k":[27,33],"o":2},"shell":{"a":"Spiral Shell","b":"1F41A","d":true,"e":true,"f":true,"h":true,"j":["nature","sea","beach"],"k":[11,55],"o":2},"flag-gg":{"a":"Guernsey Flag","b":"1F1EC-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,2],"o":2},"high_brightness":{"a":"High Brightness Symbol","b":"1F506","d":true,"e":true,"f":true,"h":true,"j":["sun","light"],"k":[27,34],"o":2},"deaf_person":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB","non_qualified":null,"image":"1f9cf-1f3fb.png","sheet_x":45,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC","non_qualified":null,"image":"1f9cf-1f3fc.png","sheet_x":45,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD","non_qualified":null,"image":"1f9cf-1f3fd.png","sheet_x":45,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE","non_qualified":null,"image":"1f9cf-1f3fe.png","sheet_x":45,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF","non_qualified":null,"image":"1f9cf-1f3ff.png","sheet_x":45,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Person","b":"1F9CF","d":true,"e":true,"f":true,"h":true,"k":[45,10],"o":12},"skull":{"a":"Skull","b":"1F480","d":true,"e":true,"f":true,"h":true,"j":["dead","skeleton","creepy","death"],"k":[23,46],"o":2},"motor_scooter":{"a":"Motor Scooter","b":"1F6F5","d":true,"e":true,"f":true,"h":true,"j":["vehicle","vespa","sasha"],"k":[36,54],"o":4},"camera":{"a":"Camera","b":"1F4F7","d":true,"e":true,"f":true,"h":true,"j":["gadgets","photography"],"k":[27,20],"o":2},"pie":{"a":"Pie","b":"1F967","d":true,"e":true,"f":true,"h":true,"k":[41,54],"o":5},"flag-gh":{"a":"Ghana Flag","b":"1F1EC-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,3],"o":2},"deaf_man":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2642-FE0F","non_qualified":"1F9CF-1F3FB-200D-2642","image":"1f9cf-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2642-FE0F","non_qualified":"1F9CF-1F3FC-200D-2642","image":"1f9cf-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2642-FE0F","non_qualified":"1F9CF-1F3FD-200D-2642","image":"1f9cf-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2642-FE0F","non_qualified":"1F9CF-1F3FE-200D-2642","image":"1f9cf-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2642-FE0F","non_qualified":"1F9CF-1F3FF-200D-2642","image":"1f9cf-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Man","b":"1F9CF-200D-2642-FE0F","c":"1F9CF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[45,4],"o":12},"skull_and_crossbones":{"a":"Skull and Crossbones","b":"2620-FE0F","c":"2620","d":true,"e":true,"f":true,"h":true,"j":["poison","danger","deadly","scary","death","pirate","evil"],"k":[53,8],"o":2},"camera_with_flash":{"a":"Camera with Flash","b":"1F4F8","d":true,"e":true,"f":true,"h":true,"k":[27,21],"o":2},"signal_strength":{"a":"Antenna with Bars","b":"1F4F6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","reception","phone","internet","connection","wifi","bluetooth","bars"],"k":[27,19],"o":2},"chocolate_bar":{"a":"Chocolate Bar","b":"1F36B","d":true,"e":true,"f":true,"h":true,"j":["food","snack","dessert","sweet"],"k":[7,10],"o":2},"manual_wheelchair":{"a":"Manual Wheelchair","b":"1F9BD","d":true,"e":true,"f":true,"h":true,"k":[44,5],"o":12},"snail":{"a":"Snail","b":"1F40C","d":true,"e":true,"f":true,"h":true,"j":["slow","animal","shell"],"k":[11,40],"o":2},"motorized_wheelchair":{"a":"Motorized Wheelchair","b":"1F9BC","d":true,"e":true,"f":true,"h":true,"k":[44,4],"o":12},"flag-gi":{"a":"Gibraltar Flag","b":"1F1EC-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,4],"o":2},"hankey":{"a":"Pile of Poo","b":"1F4A9","d":true,"e":true,"f":true,"h":true,"k":[25,51],"n":["poop","shit"],"o":2},"vibration_mode":{"a":"Vibration Mode","b":"1F4F3","d":true,"e":true,"f":true,"h":true,"j":["orange-square","phone"],"k":[27,16],"o":2},"deaf_woman":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2640-FE0F","non_qualified":"1F9CF-1F3FB-200D-2640","image":"1f9cf-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2640-FE0F","non_qualified":"1F9CF-1F3FC-200D-2640","image":"1f9cf-1f3fc-200d-2640-fe0f.png","sheet_x":45,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2640-FE0F","non_qualified":"1F9CF-1F3FD-200D-2640","image":"1f9cf-1f3fd-200d-2640-fe0f.png","sheet_x":45,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2640-FE0F","non_qualified":"1F9CF-1F3FE-200D-2640","image":"1f9cf-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2640-FE0F","non_qualified":"1F9CF-1F3FF-200D-2640","image":"1f9cf-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Woman","b":"1F9CF-200D-2640-FE0F","c":"1F9CF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,55],"o":12},"butterfly":{"a":"Butterfly","b":"1F98B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","caterpillar"],"k":[42,29],"o":4},"video_camera":{"a":"Video Camera","b":"1F4F9","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[27,22],"o":2},"candy":{"a":"Candy","b":"1F36C","d":true,"e":true,"f":true,"h":true,"j":["snack","dessert","sweet","lolly"],"k":[7,11],"o":2},"auto_rickshaw":{"a":"Auto Rickshaw","b":"1F6FA","d":true,"e":true,"f":true,"h":true,"k":[37,2],"o":12},"bow":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB","non_qualified":null,"image":"1f647-1f3fb.png","sheet_x":32,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F647-1F3FC","non_qualified":null,"image":"1f647-1f3fc.png","sheet_x":32,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F647-1F3FD","non_qualified":null,"image":"1f647-1f3fd.png","sheet_x":32,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F647-1F3FE","non_qualified":null,"image":"1f647-1f3fe.png","sheet_x":32,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F647-1F3FF","non_qualified":null,"image":"1f647-1f3ff.png","sheet_x":32,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F647-200D-2642-FE0F","a":"Person Bowing Deeply","b":"1F647","d":true,"e":true,"f":true,"h":false,"k":[32,38],"o":2},"mobile_phone_off":{"a":"Mobile Phone off","b":"1F4F4","d":true,"e":true,"f":true,"h":true,"j":["mute","orange-square","silence","quiet"],"k":[27,17],"o":2},"clown_face":{"a":"Clown Face","b":"1F921","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,18],"o":4},"lollipop":{"a":"Lollipop","b":"1F36D","d":true,"e":true,"f":true,"h":true,"j":["food","snack","candy","sweet"],"k":[7,12],"o":2},"flag-gl":{"a":"Greenland Flag","b":"1F1EC-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,5],"o":2},"vhs":{"a":"Videocassette","b":"1F4FC","d":true,"e":true,"f":true,"h":true,"j":["record","video","oldschool","90s","80s"],"k":[27,25],"o":2},"bug":{"a":"Bug","b":"1F41B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","worm"],"k":[11,56],"o":2},"bike":{"a":"Bicycle","b":"1F6B2","d":true,"e":true,"f":true,"h":true,"j":["sports","bicycle","exercise","hipster"],"k":[35,9],"o":2},"man-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2642-FE0F","non_qualified":"1F647-1F3FB-200D-2642","image":"1f647-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2642-FE0F","non_qualified":"1F647-1F3FC-200D-2642","image":"1f647-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2642-FE0F","non_qualified":"1F647-1F3FD-200D-2642","image":"1f647-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2642-FE0F","non_qualified":"1F647-1F3FE-200D-2642","image":"1f647-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2642-FE0F","non_qualified":"1F647-1F3FF-200D-2642","image":"1f647-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F647","a":"Man Bowing","b":"1F647-200D-2642-FE0F","c":"1F647-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,32],"o":4},"female_sign":{"a":"Female Sign","b":"2640-FE0F","c":"2640","d":false,"e":true,"f":true,"h":true,"k":[53,18],"o":4},"japanese_ogre":{"a":"Japanese Ogre","b":"1F479","d":true,"e":true,"f":true,"h":true,"j":["monster","red","mask","halloween","scary","creepy","devil","demon","japanese","ogre"],"k":[23,34],"o":2},"custard":{"a":"Custard","b":"1F36E","d":true,"e":true,"f":true,"h":true,"j":["dessert","food"],"k":[7,13],"o":2},"ant":{"a":"Ant","b":"1F41C","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","bug"],"k":[12,0],"o":2},"mag":{"a":"Left-Pointing Magnifying Glass","b":"1F50D","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,41],"o":2},"flag-gm":{"a":"Gambia Flag","b":"1F1EC-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,6],"o":2},"honey_pot":{"a":"Honey Pot","b":"1F36F","d":true,"e":true,"f":true,"h":true,"j":["bees","sweet","kitchen"],"k":[7,14],"o":2},"woman-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2640-FE0F","non_qualified":"1F647-1F3FB-200D-2640","image":"1f647-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2640-FE0F","non_qualified":"1F647-1F3FC-200D-2640","image":"1f647-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2640-FE0F","non_qualified":"1F647-1F3FD-200D-2640","image":"1f647-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2640-FE0F","non_qualified":"1F647-1F3FE-200D-2640","image":"1f647-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2640-FE0F","non_qualified":"1F647-1F3FF-200D-2640","image":"1f647-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bowing","b":"1F647-200D-2640-FE0F","c":"1F647-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,26],"o":4},"male_sign":{"a":"Male Sign","b":"2642-FE0F","c":"2642","d":false,"e":true,"f":true,"h":true,"k":[53,19],"o":4},"mag_right":{"a":"Right-Pointing Magnifying Glass","b":"1F50E","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,42],"o":2},"japanese_goblin":{"a":"Japanese Goblin","b":"1F47A","d":true,"e":true,"f":true,"h":true,"j":["red","evil","mask","monster","scary","creepy","japanese","goblin"],"k":[23,35],"o":2},"scooter":{"a":"Scooter","b":"1F6F4","d":true,"e":true,"f":true,"h":true,"k":[36,53],"o":4},"bee":{"a":"Honeybee","b":"1F41D","d":true,"e":true,"f":true,"h":true,"k":[12,1],"n":["honeybee"],"o":2},"flag-gn":{"a":"Guinea Flag","b":"1F1EC-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,7],"o":2},"candle":{"a":"Candle","b":"1F56F-FE0F","c":"1F56F","d":true,"e":true,"f":true,"h":true,"j":["fire","wax"],"k":[29,6],"o":2},"skateboard":{"a":"Skateboard","b":"1F6F9","d":true,"e":true,"f":true,"h":true,"k":[37,1],"o":11},"medical_symbol":{"a":"Medical Symbol","b":"2695-FE0F","c":"2695","d":false,"e":true,"f":true,"h":true,"k":[53,44],"n":["staff_of_aesculapius"],"o":4},"ghost":{"a":"Ghost","b":"1F47B","d":true,"e":true,"f":true,"h":true,"j":["halloween","spooky","scary"],"k":[23,36],"o":2},"beetle":{"a":"Lady Beetle","b":"1F41E","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","ladybug"],"k":[12,2],"o":2},"face_palm":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB","non_qualified":null,"image":"1f926-1f3fb.png","sheet_x":38,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F926-1F3FC","non_qualified":null,"image":"1f926-1f3fc.png","sheet_x":38,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F926-1F3FD","non_qualified":null,"image":"1f926-1f3fd.png","sheet_x":38,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F926-1F3FE","non_qualified":null,"image":"1f926-1f3fe.png","sheet_x":38,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F926-1F3FF","non_qualified":null,"image":"1f926-1f3ff.png","sheet_x":38,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Face Palm","b":"1F926","d":true,"e":true,"f":true,"h":false,"k":[38,35],"o":4},"flag-gp":{"a":"Guadeloupe Flag","b":"1F1EC-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,8],"o":2},"baby_bottle":{"a":"Baby Bottle","b":"1F37C","d":true,"e":true,"f":true,"h":true,"j":["food","container","milk"],"k":[7,27],"o":2},"infinity":{"a":"Infinity","b":"267E-FE0F","c":"267E","d":true,"e":true,"f":true,"h":true,"k":[53,39],"o":11},"glass_of_milk":{"a":"Glass of Milk","b":"1F95B","d":true,"e":true,"f":true,"h":true,"k":[41,42],"o":4},"man-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2642-FE0F","non_qualified":"1F926-1F3FB-200D-2642","image":"1f926-1f3fb-200d-2642-fe0f.png","sheet_x":38,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2642-FE0F","non_qualified":"1F926-1F3FC-200D-2642","image":"1f926-1f3fc-200d-2642-fe0f.png","sheet_x":38,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2642-FE0F","non_qualified":"1F926-1F3FD-200D-2642","image":"1f926-1f3fd-200d-2642-fe0f.png","sheet_x":38,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2642-FE0F","non_qualified":"1F926-1F3FE-200D-2642","image":"1f926-1f3fe-200d-2642-fe0f.png","sheet_x":38,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2642-FE0F","non_qualified":"1F926-1F3FF-200D-2642","image":"1f926-1f3ff-200d-2642-fe0f.png","sheet_x":38,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Facepalming","b":"1F926-200D-2642-FE0F","c":"1F926-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[38,29],"o":4},"cricket":{"a":"Cricket","b":"1F997","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[42,41],"o":5},"busstop":{"a":"Bus Stop","b":"1F68F","d":true,"e":true,"f":true,"h":true,"j":["transportation","wait"],"k":[34,14],"o":2},"flag-gq":{"a":"Equatorial Guinea Flag","b":"1F1EC-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,9],"o":2},"alien":{"a":"Extraterrestrial Alien","b":"1F47D","d":true,"e":true,"f":true,"h":true,"j":["UFO","paul","weird","outer_space"],"k":[23,43],"o":2},"bulb":{"a":"Electric Light Bulb","b":"1F4A1","d":true,"e":true,"f":true,"h":true,"j":["light","electricity","idea"],"k":[25,43],"o":2},"woman-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2640-FE0F","non_qualified":"1F926-1F3FB-200D-2640","image":"1f926-1f3fb-200d-2640-fe0f.png","sheet_x":38,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2640-FE0F","non_qualified":"1F926-1F3FC-200D-2640","image":"1f926-1f3fc-200d-2640-fe0f.png","sheet_x":38,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2640-FE0F","non_qualified":"1F926-1F3FD-200D-2640","image":"1f926-1f3fd-200d-2640-fe0f.png","sheet_x":38,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2640-FE0F","non_qualified":"1F926-1F3FE-200D-2640","image":"1f926-1f3fe-200d-2640-fe0f.png","sheet_x":38,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2640-FE0F","non_qualified":"1F926-1F3FF-200D-2640","image":"1f926-1f3ff-200d-2640-fe0f.png","sheet_x":38,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Facepalming","b":"1F926-200D-2640-FE0F","c":"1F926-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[38,23],"o":4},"spider":{"a":"Spider","b":"1F577-FE0F","c":"1F577","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[29,34],"o":2},"space_invader":{"a":"Alien Monster","b":"1F47E","d":true,"e":true,"f":true,"h":true,"j":["game","arcade","play"],"k":[23,44],"o":2},"motorway":{"a":"Motorway","b":"1F6E3-FE0F","c":"1F6E3","d":true,"e":true,"f":true,"h":true,"j":["road","cupertino","interstate","highway"],"k":[36,45],"o":2},"flag-gr":{"a":"Greece Flag","b":"1F1EC-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,10],"o":2},"recycle":{"a":"Black Universal Recycling Symbol","b":"267B-FE0F","c":"267B","d":true,"e":true,"f":true,"h":true,"j":["arrow","environment","garbage","trash"],"k":[53,38],"o":2},"coffee":{"a":"Hot Beverage","b":"2615","d":true,"e":true,"f":true,"h":true,"j":["beverage","caffeine","latte","espresso"],"k":[53,0],"o":2},"flashlight":{"a":"Electric Torch","b":"1F526","d":true,"e":true,"f":true,"h":true,"j":["dark","camping","sight","night"],"k":[28,9],"o":2},"spider_web":{"a":"Spider Web","b":"1F578-FE0F","c":"1F578","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","arachnid","silk"],"k":[29,35],"o":2},"izakaya_lantern":{"a":"Izakaya Lantern","b":"1F3EE","d":true,"e":true,"f":true,"h":true,"j":["light","paper","halloween","spooky"],"k":[11,8],"n":["lantern"],"o":2},"flag-gs":{"a":"South Georgia & South Sandwich Islands Flag","b":"1F1EC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,11],"o":2},"shrug":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB","non_qualified":null,"image":"1f937-1f3fb.png","sheet_x":39,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F937-1F3FC","non_qualified":null,"image":"1f937-1f3fc.png","sheet_x":39,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F937-1F3FD","non_qualified":null,"image":"1f937-1f3fd.png","sheet_x":39,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F937-1F3FE","non_qualified":null,"image":"1f937-1f3fe.png","sheet_x":39,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F937-1F3FF","non_qualified":null,"image":"1f937-1f3ff.png","sheet_x":39,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Shrug","b":"1F937","d":true,"e":true,"f":true,"h":false,"k":[39,47],"o":4},"fleur_de_lis":{"a":"Fleur De Lis","b":"269C-FE0F","c":"269C","d":true,"e":true,"f":true,"h":true,"j":["decorative","scout"],"k":[53,49],"o":2},"robot_face":{"a":"Robot Face","b":"1F916","d":true,"e":true,"f":true,"h":true,"k":[37,29],"o":2},"railway_track":{"a":"Railway Track","b":"1F6E4-FE0F","c":"1F6E4","d":true,"e":true,"f":true,"h":true,"j":["train","transportation"],"k":[36,46],"o":2},"tea":{"a":"Teacup Without Handle","b":"1F375","d":true,"e":true,"f":true,"h":true,"j":["drink","bowl","breakfast","green","british"],"k":[7,20],"o":2},"flag-gt":{"a":"Guatemala Flag","b":"1F1EC-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,12],"o":2},"oil_drum":{"a":"Oil Drum","b":"1F6E2-FE0F","c":"1F6E2","d":true,"e":true,"f":true,"h":true,"j":["barrell"],"k":[36,44],"o":2},"diya_lamp":{"a":"Diya Lamp","b":"1FA94","d":true,"e":true,"f":true,"h":true,"k":[52,8],"o":12},"sake":{"a":"Sake Bottle and Cup","b":"1F376","d":true,"e":true,"f":true,"h":true,"j":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"k":[7,21],"o":2},"trident":{"a":"Trident Emblem","b":"1F531","d":true,"e":true,"f":true,"h":true,"j":["weapon","spear"],"k":[28,20],"o":2},"man-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2642-FE0F","non_qualified":"1F937-1F3FB-200D-2642","image":"1f937-1f3fb-200d-2642-fe0f.png","sheet_x":39,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2642-FE0F","non_qualified":"1F937-1F3FC-200D-2642","image":"1f937-1f3fc-200d-2642-fe0f.png","sheet_x":39,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2642-FE0F","non_qualified":"1F937-1F3FD-200D-2642","image":"1f937-1f3fd-200d-2642-fe0f.png","sheet_x":39,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2642-FE0F","non_qualified":"1F937-1F3FE-200D-2642","image":"1f937-1f3fe-200d-2642-fe0f.png","sheet_x":39,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2642-FE0F","non_qualified":"1F937-1F3FF-200D-2642","image":"1f937-1f3ff-200d-2642-fe0f.png","sheet_x":39,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Shrugging","b":"1F937-200D-2642-FE0F","c":"1F937-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[39,41],"o":4},"smiley_cat":{"a":"Smiling Cat Face with Open Mouth","b":"1F63A","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","happy","smile"],"k":[31,36],"o":2},"scorpion":{"a":"Scorpion","b":"1F982","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[42,20],"o":2},"woman-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2640-FE0F","non_qualified":"1F937-1F3FB-200D-2640","image":"1f937-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2640-FE0F","non_qualified":"1F937-1F3FC-200D-2640","image":"1f937-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2640-FE0F","non_qualified":"1F937-1F3FD-200D-2640","image":"1f937-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2640-FE0F","non_qualified":"1F937-1F3FE-200D-2640","image":"1f937-1f3fe-200d-2640-fe0f.png","sheet_x":39,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2640-FE0F","non_qualified":"1F937-1F3FF-200D-2640","image":"1f937-1f3ff-200d-2640-fe0f.png","sheet_x":39,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Shrugging","b":"1F937-200D-2640-FE0F","c":"1F937-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,35],"o":4},"notebook_with_decorative_cover":{"a":"Notebook with Decorative Cover","b":"1F4D4","d":true,"e":true,"f":true,"h":true,"j":["classroom","notes","record","paper","study"],"k":[26,42],"o":2},"fuelpump":{"a":"Fuel Pump","b":"26FD","d":true,"e":true,"f":true,"h":true,"j":["gas station","petroleum"],"k":[54,38],"o":2},"name_badge":{"a":"Name Badge","b":"1F4DB","d":true,"e":true,"f":true,"h":true,"j":["fire","forbid"],"k":[26,49],"o":2},"mosquito":{"a":"Mosquito","b":"1F99F","d":true,"e":true,"f":true,"h":true,"k":[42,49],"o":11},"flag-gu":{"a":"Guam Flag","b":"1F1EC-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,13],"o":2},"smile_cat":{"a":"Grinning Cat Face with Smiling Eyes","b":"1F638","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smile"],"k":[31,34],"o":2},"champagne":{"a":"Bottle with Popping Cork","b":"1F37E","d":true,"e":true,"f":true,"h":true,"j":["drink","wine","bottle","celebration"],"k":[7,29],"o":2},"joy_cat":{"a":"Cat Face with Tears of Joy","b":"1F639","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","haha","happy","tears"],"k":[31,35],"o":2},"closed_book":{"a":"Closed Book","b":"1F4D5","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","learn"],"k":[26,43],"o":2},"health_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2695-FE0F","non_qualified":"1F9D1-1F3FB-200D-2695","image":"1f9d1-1f3fb-200d-2695-fe0f.png","sheet_x":47,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2695-FE0F","non_qualified":"1F9D1-1F3FC-200D-2695","image":"1f9d1-1f3fc-200d-2695-fe0f.png","sheet_x":47,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2695-FE0F","non_qualified":"1F9D1-1F3FD-200D-2695","image":"1f9d1-1f3fd-200d-2695-fe0f.png","sheet_x":47,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2695-FE0F","non_qualified":"1F9D1-1F3FE-200D-2695","image":"1f9d1-1f3fe-200d-2695-fe0f.png","sheet_x":47,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2695-FE0F","non_qualified":"1F9D1-1F3FF-200D-2695","image":"1f9d1-1f3ff-200d-2695-fe0f.png","sheet_x":47,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Health Worker","b":"1F9D1-200D-2695-FE0F","c":"1F9D1-200D-2695","d":true,"e":false,"f":false,"h":false,"k":[47,49],"o":12},"rotating_light":{"a":"Police Cars Revolving Light","b":"1F6A8","d":true,"e":true,"f":true,"h":true,"j":["police","ambulance","911","emergency","alert","error","pinged","law","legal"],"k":[34,56],"o":2},"microbe":{"a":"Microbe","b":"1F9A0","d":true,"e":true,"f":true,"h":true,"k":[42,50],"o":11},"flag-gw":{"a":"Guinea-Bissau Flag","b":"1F1EC-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,14],"o":2},"wine_glass":{"a":"Wine Glass","b":"1F377","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","booze"],"k":[7,22],"o":2},"beginner":{"a":"Japanese Symbol for Beginner","b":"1F530","d":true,"e":true,"f":true,"h":true,"j":["badge","shield"],"k":[28,19],"o":2},"bouquet":{"a":"Bouquet","b":"1F490","d":true,"e":true,"f":true,"h":true,"j":["flowers","nature","spring"],"k":[25,26],"o":2},"heart_eyes_cat":{"a":"Smiling Cat Face with Heart-Shaped Eyes","b":"1F63B","d":true,"e":true,"f":true,"h":true,"j":["animal","love","like","affection","cats","valentines","heart"],"k":[31,37],"o":2},"male-doctor":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2695-FE0F","non_qualified":"1F468-1F3FB-200D-2695","image":"1f468-1f3fb-200d-2695-fe0f.png","sheet_x":17,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2695-FE0F","non_qualified":"1F468-1F3FC-200D-2695","image":"1f468-1f3fc-200d-2695-fe0f.png","sheet_x":17,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2695-FE0F","non_qualified":"1F468-1F3FD-200D-2695","image":"1f468-1f3fd-200d-2695-fe0f.png","sheet_x":17,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2695-FE0F","non_qualified":"1F468-1F3FE-200D-2695","image":"1f468-1f3fe-200d-2695-fe0f.png","sheet_x":17,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2695-FE0F","non_qualified":"1F468-1F3FF-200D-2695","image":"1f468-1f3ff-200d-2695-fe0f.png","sheet_x":17,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Doctor","b":"1F468-200D-2695-FE0F","c":"1F468-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[17,2],"o":4},"book":{"a":"Open Book","b":"1F4D6","d":true,"e":true,"f":true,"h":true,"k":[26,44],"n":["open_book"],"o":2},"traffic_light":{"a":"Horizontal Traffic Light","b":"1F6A5","d":true,"e":true,"f":true,"h":true,"j":["transportation","signal"],"k":[34,53],"o":2},"cocktail":{"a":"Cocktail Glass","b":"1F378","d":true,"e":true,"f":true,"h":true,"j":["drink","drunk","alcohol","beverage","booze","mojito"],"k":[7,23],"o":2},"o":{"a":"Heavy Large Circle","b":"2B55","d":true,"e":true,"f":true,"h":true,"j":["circle","round"],"k":[55,43],"o":2},"flag-gy":{"a":"Guyana Flag","b":"1F1EC-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,15],"o":2},"female-doctor":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2695-FE0F","non_qualified":"1F469-1F3FB-200D-2695","image":"1f469-1f3fb-200d-2695-fe0f.png","sheet_x":19,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2695-FE0F","non_qualified":"1F469-1F3FC-200D-2695","image":"1f469-1f3fc-200d-2695-fe0f.png","sheet_x":19,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2695-FE0F","non_qualified":"1F469-1F3FD-200D-2695","image":"1f469-1f3fd-200d-2695-fe0f.png","sheet_x":19,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2695-FE0F","non_qualified":"1F469-1F3FE-200D-2695","image":"1f469-1f3fe-200d-2695-fe0f.png","sheet_x":19,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2695-FE0F","non_qualified":"1F469-1F3FF-200D-2695","image":"1f469-1f3ff-200d-2695-fe0f.png","sheet_x":19,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Doctor","b":"1F469-200D-2695-FE0F","c":"1F469-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[19,44],"o":4},"smirk_cat":{"a":"Cat Face with Wry Smile","b":"1F63C","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smirk"],"k":[31,38],"o":2},"green_book":{"a":"Green Book","b":"1F4D7","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","study"],"k":[26,45],"o":2},"cherry_blossom":{"a":"Cherry Blossom","b":"1F338","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","spring","flower"],"k":[6,16],"o":2},"flag-hk":{"a":"Hong Kong Sar China Flag","b":"1F1ED-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,16],"o":2},"vertical_traffic_light":{"a":"Vertical Traffic Light","b":"1F6A6","d":true,"e":true,"f":true,"h":true,"j":["transportation","driving"],"k":[34,54],"o":2},"white_check_mark":{"a":"White Heavy Check Mark","b":"2705","d":true,"e":true,"f":true,"h":true,"j":["green-square","ok","agree","vote","election","answer","tick"],"k":[54,40],"o":2},"tropical_drink":{"a":"Tropical Drink","b":"1F379","d":true,"e":true,"f":true,"h":true,"j":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"k":[7,24],"o":2},"kissing_cat":{"a":"Kissing Cat Face with Closed Eyes","b":"1F63D","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","kiss"],"k":[31,39],"o":2},"flag-hm":{"a":"Heard & Mcdonald Islands Flag","b":"1F1ED-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,17],"o":2},"octagonal_sign":{"a":"Octagonal Sign","b":"1F6D1","d":true,"e":true,"f":true,"h":true,"k":[36,39],"o":4},"white_flower":{"a":"White Flower","b":"1F4AE","d":true,"e":true,"f":true,"h":true,"j":["japanese","spring"],"k":[26,4],"o":2},"ballot_box_with_check":{"a":"Ballot Box with Check","b":"2611-FE0F","c":"2611","d":true,"e":true,"f":true,"h":true,"j":["ok","agree","confirm","black-square","vote","election","yes","tick"],"k":[52,55],"o":2},"student":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f393.png","sheet_x":45,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f393.png","sheet_x":45,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f393.png","sheet_x":45,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f393.png","sheet_x":45,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F393","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f393.png","sheet_x":45,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Student","b":"1F9D1-200D-1F393","d":true,"e":false,"f":false,"h":false,"k":[45,29],"o":12},"blue_book":{"a":"Blue Book","b":"1F4D8","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","learn","study"],"k":[26,46],"o":2},"beer":{"a":"Beer Mug","b":"1F37A","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,25],"o":2},"construction":{"a":"Construction Sign","b":"1F6A7","d":true,"e":true,"f":true,"h":true,"j":["wip","progress","caution","warning"],"k":[34,55],"o":2},"rosette":{"a":"Rosette","b":"1F3F5-FE0F","c":"1F3F5","d":true,"e":true,"f":true,"h":true,"j":["flower","decoration","military"],"k":[11,18],"o":2},"heavy_check_mark":{"a":"Heavy Check Mark","b":"2714-FE0F","c":"2714","d":true,"e":true,"f":true,"h":true,"j":["ok","nike","answer","yes","tick"],"k":[55,12],"o":2},"scream_cat":{"a":"Weary Cat Face","b":"1F640","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","munch","scared","scream"],"k":[31,42],"o":2},"orange_book":{"a":"Orange Book","b":"1F4D9","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","study"],"k":[26,47],"o":2},"beers":{"a":"Clinking Beer Mugs","b":"1F37B","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,26],"o":2},"male-student":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F393","non_qualified":null,"image":"1f468-1f3fb-200d-1f393.png","sheet_x":14,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F393","non_qualified":null,"image":"1f468-1f3fc-200d-1f393.png","sheet_x":14,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F393","non_qualified":null,"image":"1f468-1f3fd-200d-1f393.png","sheet_x":14,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F393","non_qualified":null,"image":"1f468-1f3fe-200d-1f393.png","sheet_x":14,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F393","non_qualified":null,"image":"1f468-1f3ff-200d-1f393.png","sheet_x":14,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Student","b":"1F468-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[14,50],"o":4},"flag-hn":{"a":"Honduras Flag","b":"1F1ED-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,18],"o":2},"crying_cat_face":{"a":"Crying Cat Face","b":"1F63F","d":true,"e":true,"f":true,"h":true,"j":["animal","tears","weep","sad","cats","upset","cry"],"k":[31,41],"o":2},"anchor":{"a":"Anchor","b":"2693","d":true,"e":true,"f":true,"h":true,"j":["ship","ferry","sea","boat"],"k":[53,42],"o":2},"flag-hr":{"a":"Croatia Flag","b":"1F1ED-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,19],"o":2},"heavy_multiplication_x":{"a":"Heavy Multiplication X","b":"2716-FE0F","c":"2716","d":true,"e":true,"f":true,"h":true,"j":["math","calculation"],"k":[55,13],"o":2},"female-student":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F393","non_qualified":null,"image":"1f469-1f3fb-200d-1f393.png","sheet_x":17,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F393","non_qualified":null,"image":"1f469-1f3fc-200d-1f393.png","sheet_x":17,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F393","non_qualified":null,"image":"1f469-1f3fd-200d-1f393.png","sheet_x":17,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F393","non_qualified":null,"image":"1f469-1f3fe-200d-1f393.png","sheet_x":17,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F393","non_qualified":null,"image":"1f469-1f3ff-200d-1f393.png","sheet_x":17,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Student","b":"1F469-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[17,40],"o":4},"rose":{"a":"Rose","b":"1F339","d":true,"e":true,"f":true,"h":true,"j":["flowers","valentines","love","spring"],"k":[6,17],"o":2},"books":{"a":"Books","b":"1F4DA","d":true,"e":true,"f":true,"h":true,"j":["literature","library","study"],"k":[26,48],"o":2},"clinking_glasses":{"a":"Clinking Glasses","b":"1F942","d":true,"e":true,"f":true,"h":true,"j":["beverage","drink","party","alcohol","celebrate","cheers"],"k":[41,18],"o":4},"teacher":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3eb.png","sheet_x":45,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3eb.png","sheet_x":45,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3eb.png","sheet_x":45,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3eb.png","sheet_x":45,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3eb.png","sheet_x":45,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Teacher","b":"1F9D1-200D-1F3EB","d":true,"e":false,"f":false,"h":false,"k":[45,47],"o":12},"x":{"a":"Cross Mark","b":"274C","d":true,"e":true,"f":true,"h":true,"j":["no","delete","remove","cancel"],"k":[55,21],"o":2},"pouting_cat":{"a":"Pouting Cat Face","b":"1F63E","d":true,"e":true,"f":true,"h":true,"j":["animal","cats"],"k":[31,40],"o":2},"wilted_flower":{"a":"Wilted Flower","b":"1F940","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","flower"],"k":[41,16],"o":4},"boat":{"a":"Sailboat","b":"26F5","d":true,"e":true,"f":true,"h":true,"k":[54,16],"n":["sailboat"],"o":2},"flag-ht":{"a":"Haiti Flag","b":"1F1ED-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,20],"o":2},"tumbler_glass":{"a":"Tumbler Glass","b":"1F943","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","glass","shot"],"k":[41,19],"o":4},"notebook":{"a":"Notebook","b":"1F4D3","d":true,"e":true,"f":true,"h":true,"j":["stationery","record","notes","paper","study"],"k":[26,41],"o":2},"male-teacher":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fb-200d-1f3eb.png","sheet_x":15,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fc-200d-1f3eb.png","sheet_x":15,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fd-200d-1f3eb.png","sheet_x":15,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fe-200d-1f3eb.png","sheet_x":15,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f468-1f3ff-200d-1f3eb.png","sheet_x":15,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Teacher","b":"1F468-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[15,11],"o":4},"ledger":{"a":"Ledger","b":"1F4D2","d":true,"e":true,"f":true,"h":true,"j":["notes","paper"],"k":[26,40],"o":2},"flag-hu":{"a":"Hungary Flag","b":"1F1ED-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,21],"o":2},"cup_with_straw":{"a":"Cup with Straw","b":"1F964","d":true,"e":true,"f":true,"h":true,"k":[41,51],"o":5},"hibiscus":{"a":"Hibiscus","b":"1F33A","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","flowers","beach"],"k":[6,18],"o":2},"see_no_evil":{"a":"See-No-Evil Monkey","b":"1F648","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","haha"],"k":[32,44],"o":2},"canoe":{"a":"Canoe","b":"1F6F6","d":true,"e":true,"f":true,"h":true,"j":["boat","paddle","water","ship"],"k":[36,55],"o":4},"negative_squared_cross_mark":{"a":"Negative Squared Cross Mark","b":"274E","d":true,"e":true,"f":true,"h":true,"j":["x","green-square","no","deny"],"k":[55,22],"o":2},"flag-ic":{"a":"Canary Islands Flag","b":"1F1EE-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,22],"o":2},"beverage_box":{"a":"Beverage Box","b":"1F9C3","d":true,"e":true,"f":true,"h":true,"k":[44,11],"o":12},"speedboat":{"a":"Speedboat","b":"1F6A4","d":true,"e":true,"f":true,"h":true,"j":["ship","transportation","vehicle","summer"],"k":[34,52],"o":2},"heavy_plus_sign":{"a":"Heavy Plus Sign","b":"2795","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","addition","more","increase"],"k":[55,29],"o":2},"sunflower":{"a":"Sunflower","b":"1F33B","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","fall"],"k":[6,19],"o":2},"page_with_curl":{"a":"Page with Curl","b":"1F4C3","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper"],"k":[26,25],"o":2},"female-teacher":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fb-200d-1f3eb.png","sheet_x":18,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fc-200d-1f3eb.png","sheet_x":18,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fd-200d-1f3eb.png","sheet_x":18,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fe-200d-1f3eb.png","sheet_x":18,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f469-1f3ff-200d-1f3eb.png","sheet_x":18,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Teacher","b":"1F469-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[18,1],"o":4},"hear_no_evil":{"a":"Hear-No-Evil Monkey","b":"1F649","d":true,"e":true,"f":true,"h":true,"j":["animal","monkey","nature"],"k":[32,45],"o":2},"mate_drink":{"a":"Mate Drink","b":"1F9C9","d":true,"e":true,"f":true,"h":true,"k":[44,17],"o":12},"passenger_ship":{"a":"Passenger Ship","b":"1F6F3-FE0F","c":"1F6F3","d":true,"e":true,"f":true,"h":true,"j":["yacht","cruise","ferry"],"k":[36,52],"o":2},"judge":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2696-FE0F","non_qualified":"1F9D1-1F3FB-200D-2696","image":"1f9d1-1f3fb-200d-2696-fe0f.png","sheet_x":47,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2696-FE0F","non_qualified":"1F9D1-1F3FC-200D-2696","image":"1f9d1-1f3fc-200d-2696-fe0f.png","sheet_x":48,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2696-FE0F","non_qualified":"1F9D1-1F3FD-200D-2696","image":"1f9d1-1f3fd-200d-2696-fe0f.png","sheet_x":48,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2696-FE0F","non_qualified":"1F9D1-1F3FE-200D-2696","image":"1f9d1-1f3fe-200d-2696-fe0f.png","sheet_x":48,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2696-FE0F","non_qualified":"1F9D1-1F3FF-200D-2696","image":"1f9d1-1f3ff-200d-2696-fe0f.png","sheet_x":48,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Judge","b":"1F9D1-200D-2696-FE0F","c":"1F9D1-200D-2696","d":true,"e":false,"f":false,"h":false,"k":[47,55],"o":12},"scroll":{"a":"Scroll","b":"1F4DC","d":true,"e":true,"f":true,"h":true,"j":["documents","ancient","history","paper"],"k":[26,50],"o":2},"blossom":{"a":"Blossom","b":"1F33C","d":true,"e":true,"f":true,"h":true,"j":["nature","flowers","yellow"],"k":[6,20],"o":2},"flag-id":{"a":"Indonesia Flag","b":"1F1EE-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[2,23],"o":2},"speak_no_evil":{"a":"Speak-No-Evil Monkey","b":"1F64A","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","omg"],"k":[32,46],"o":2},"heavy_minus_sign":{"a":"Heavy Minus Sign","b":"2796","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","subtract","less"],"k":[55,30],"o":2},"flag-ie":{"a":"Ireland Flag","b":"1F1EE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,24],"o":2},"ice_cube":{"a":"Ice Cube","b":"1F9CA","d":true,"e":true,"f":true,"h":true,"k":[44,18],"o":12},"page_facing_up":{"a":"Page Facing Up","b":"1F4C4","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper","information"],"k":[26,26],"o":2},"male-judge":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2696-FE0F","non_qualified":"1F468-1F3FB-200D-2696","image":"1f468-1f3fb-200d-2696-fe0f.png","sheet_x":17,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2696-FE0F","non_qualified":"1F468-1F3FC-200D-2696","image":"1f468-1f3fc-200d-2696-fe0f.png","sheet_x":17,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2696-FE0F","non_qualified":"1F468-1F3FD-200D-2696","image":"1f468-1f3fd-200d-2696-fe0f.png","sheet_x":17,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2696-FE0F","non_qualified":"1F468-1F3FE-200D-2696","image":"1f468-1f3fe-200d-2696-fe0f.png","sheet_x":17,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2696-FE0F","non_qualified":"1F468-1F3FF-200D-2696","image":"1f468-1f3ff-200d-2696-fe0f.png","sheet_x":17,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Judge","b":"1F468-200D-2696-FE0F","c":"1F468-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[17,8],"o":4},"tulip":{"a":"Tulip","b":"1F337","d":true,"e":true,"f":true,"h":true,"j":["flowers","plant","nature","summer","spring"],"k":[6,15],"o":2},"ferry":{"a":"Ferry","b":"26F4-FE0F","c":"26F4","d":true,"e":true,"f":true,"h":true,"j":["boat","ship","yacht"],"k":[54,15],"o":2},"kiss":{"a":"Kiss Mark","b":"1F48B","d":true,"e":true,"f":true,"h":true,"j":["face","lips","love","like","affection","valentines"],"k":[25,21],"o":2},"heavy_division_sign":{"a":"Heavy Division Sign","b":"2797","d":true,"e":true,"f":true,"h":true,"j":["divide","math","calculation"],"k":[55,31],"o":2},"newspaper":{"a":"Newspaper","b":"1F4F0","d":true,"e":true,"f":true,"h":true,"j":["press","headline"],"k":[27,13],"o":2},"female-judge":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2696-FE0F","non_qualified":"1F469-1F3FB-200D-2696","image":"1f469-1f3fb-200d-2696-fe0f.png","sheet_x":19,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2696-FE0F","non_qualified":"1F469-1F3FC-200D-2696","image":"1f469-1f3fc-200d-2696-fe0f.png","sheet_x":19,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2696-FE0F","non_qualified":"1F469-1F3FD-200D-2696","image":"1f469-1f3fd-200d-2696-fe0f.png","sheet_x":19,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2696-FE0F","non_qualified":"1F469-1F3FE-200D-2696","image":"1f469-1f3fe-200d-2696-fe0f.png","sheet_x":19,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2696-FE0F","non_qualified":"1F469-1F3FF-200D-2696","image":"1f469-1f3ff-200d-2696-fe0f.png","sheet_x":19,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Judge","b":"1F469-200D-2696-FE0F","c":"1F469-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[19,50],"o":4},"seedling":{"a":"Seedling","b":"1F331","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","grass","lawn","spring"],"k":[6,9],"o":2},"love_letter":{"a":"Love Letter","b":"1F48C","d":true,"e":true,"f":true,"h":true,"j":["email","like","affection","envelope","valentines"],"k":[25,22],"o":2},"chopsticks":{"a":"Chopsticks","b":"1F962","d":true,"e":true,"f":true,"h":true,"k":[41,49],"o":5},"motor_boat":{"a":"Motor Boat","b":"1F6E5-FE0F","c":"1F6E5","d":true,"e":true,"f":true,"h":true,"j":["ship"],"k":[36,47],"o":2},"flag-il":{"a":"Israel Flag","b":"1F1EE-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,25],"o":2},"curly_loop":{"a":"Curly Loop","b":"27B0","d":true,"e":true,"f":true,"h":true,"j":["scribble","draw","shape","squiggle"],"k":[55,33],"o":2},"flag-im":{"a":"Isle of Man Flag","b":"1F1EE-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,26],"o":2},"evergreen_tree":{"a":"Evergreen Tree","b":"1F332","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,10],"o":2},"cupid":{"a":"Heart with Arrow","b":"1F498","d":true,"e":true,"f":true,"h":true,"j":["love","like","heart","affection","valentines"],"k":[25,34],"o":2},"loop":{"a":"Double Curly Loop","b":"27BF","d":true,"e":true,"f":true,"h":true,"j":["tape","cassette"],"k":[55,34],"o":2},"ship":{"a":"Ship","b":"1F6A2","d":true,"e":true,"f":true,"h":true,"j":["transportation","titanic","deploy"],"k":[34,33],"o":2},"farmer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f33e.png","sheet_x":45,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f33e.png","sheet_x":45,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f33e.png","sheet_x":45,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f33e.png","sheet_x":45,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f33e.png","sheet_x":45,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Farmer","b":"1F9D1-200D-1F33E","d":true,"e":false,"f":false,"h":false,"k":[45,17],"o":12},"rolled_up_newspaper":{"a":"Rolled Up Newspaper","b":"1F5DE-FE0F","c":"1F5DE","d":true,"e":true,"f":true,"h":true,"k":[30,23],"o":2},"knife_fork_plate":{"a":"Knife Fork Plate","b":"1F37D-FE0F","c":"1F37D","d":true,"e":true,"f":true,"h":true,"k":[7,28],"o":2},"fork_and_knife":{"a":"Fork and Knife","b":"1F374","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen"],"k":[7,19],"o":2},"male-farmer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F33E","non_qualified":null,"image":"1f468-1f3fb-200d-1f33e.png","sheet_x":14,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F33E","non_qualified":null,"image":"1f468-1f3fc-200d-1f33e.png","sheet_x":14,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F33E","non_qualified":null,"image":"1f468-1f3fd-200d-1f33e.png","sheet_x":14,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F33E","non_qualified":null,"image":"1f468-1f3fe-200d-1f33e.png","sheet_x":14,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F33E","non_qualified":null,"image":"1f468-1f3ff-200d-1f33e.png","sheet_x":14,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Farmer","b":"1F468-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[14,38],"o":4},"bookmark_tabs":{"a":"Bookmark Tabs","b":"1F4D1","d":true,"e":true,"f":true,"h":true,"j":["favorite","save","order","tidy"],"k":[26,39],"o":2},"part_alternation_mark":{"a":"Part Alternation Mark","b":"303D-FE0F","c":"303D","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","business","economics","bad"],"k":[55,45],"o":2},"flag-in":{"a":"India Flag","b":"1F1EE-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,27],"o":2},"gift_heart":{"a":"Heart with Ribbon","b":"1F49D","d":true,"e":true,"f":true,"h":true,"j":["love","valentines"],"k":[25,39],"o":2},"airplane":{"a":"Airplane","b":"2708-FE0F","c":"2708","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation","flight","fly"],"k":[54,41],"o":2},"deciduous_tree":{"a":"Deciduous Tree","b":"1F333","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,11],"o":2},"spoon":{"a":"Spoon","b":"1F944","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen","tableware"],"k":[41,20],"o":4},"flag-io":{"a":"British Indian Ocean Territory Flag","b":"1F1EE-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,28],"o":2},"palm_tree":{"a":"Palm Tree","b":"1F334","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","nature","summer","beach","mojito","tropical"],"k":[6,12],"o":2},"sparkling_heart":{"a":"Sparkling Heart","b":"1F496","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,32],"o":2},"female-farmer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F33E","non_qualified":null,"image":"1f469-1f3fb-200d-1f33e.png","sheet_x":17,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F33E","non_qualified":null,"image":"1f469-1f3fc-200d-1f33e.png","sheet_x":17,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F33E","non_qualified":null,"image":"1f469-1f3fd-200d-1f33e.png","sheet_x":17,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F33E","non_qualified":null,"image":"1f469-1f3fe-200d-1f33e.png","sheet_x":17,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F33E","non_qualified":null,"image":"1f469-1f3ff-200d-1f33e.png","sheet_x":17,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Farmer","b":"1F469-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[17,28],"o":4},"eight_spoked_asterisk":{"a":"Eight Spoked Asterisk","b":"2733-FE0F","c":"2733","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","green-square"],"k":[55,17],"o":2},"small_airplane":{"a":"Small Airplane","b":"1F6E9-FE0F","c":"1F6E9","d":true,"e":true,"f":true,"h":true,"j":["flight","transportation","fly","vehicle"],"k":[36,48],"o":2},"bookmark":{"a":"Bookmark","b":"1F516","d":true,"e":true,"f":true,"h":true,"j":["favorite","label","save"],"k":[27,50],"o":2},"cook":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f373.png","sheet_x":45,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f373.png","sheet_x":45,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f373.png","sheet_x":45,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f373.png","sheet_x":45,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F373","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f373.png","sheet_x":45,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Cook","b":"1F9D1-200D-1F373","d":true,"e":false,"f":false,"h":false,"k":[45,23],"o":12},"eight_pointed_black_star":{"a":"Eight Pointed Black Star","b":"2734-FE0F","c":"2734","d":true,"e":true,"f":true,"h":true,"j":["orange-square","shape","polygon"],"k":[55,18],"o":2},"heartpulse":{"a":"Growing Heart","b":"1F497","d":true,"e":true,"f":true,"h":true,"j":["like","love","affection","valentines","pink"],"k":[25,33],"o":2},"label":{"a":"Label","b":"1F3F7-FE0F","c":"1F3F7","d":true,"e":true,"f":true,"h":true,"j":["sale","tag"],"k":[11,19],"o":2},"flag-iq":{"a":"Iraq Flag","b":"1F1EE-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,29],"o":2},"hocho":{"a":"Hocho","b":"1F52A","d":true,"e":true,"f":true,"h":true,"j":["knife","blade","cutlery","kitchen","weapon"],"k":[28,13],"n":["knife"],"o":2},"cactus":{"a":"Cactus","b":"1F335","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature"],"k":[6,13],"o":2},"airplane_departure":{"a":"Airplane Departure","b":"1F6EB","d":true,"e":true,"f":true,"h":true,"k":[36,49],"o":2},"airplane_arriving":{"a":"Airplane Arriving","b":"1F6EC","d":true,"e":true,"f":true,"h":true,"k":[36,50],"o":2},"ear_of_rice":{"a":"Ear of Rice","b":"1F33E","d":true,"e":true,"f":true,"h":true,"j":["nature","plant"],"k":[6,22],"o":2},"flag-ir":{"a":"Iran Flag","b":"1F1EE-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,30],"o":2},"moneybag":{"a":"Money Bag","b":"1F4B0","d":true,"e":true,"f":true,"h":true,"j":["dollar","payment","coins","sale"],"k":[26,6],"o":2},"male-cook":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F373","non_qualified":null,"image":"1f468-1f3fb-200d-1f373.png","sheet_x":14,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F373","non_qualified":null,"image":"1f468-1f3fc-200d-1f373.png","sheet_x":14,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F373","non_qualified":null,"image":"1f468-1f3fd-200d-1f373.png","sheet_x":14,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F373","non_qualified":null,"image":"1f468-1f3fe-200d-1f373.png","sheet_x":14,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F373","non_qualified":null,"image":"1f468-1f3ff-200d-1f373.png","sheet_x":14,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Cook","b":"1F468-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[14,44],"o":4},"heartbeat":{"a":"Beating Heart","b":"1F493","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","pink","heart"],"k":[25,29],"o":2},"sparkle":{"a":"Sparkle","b":"2747-FE0F","c":"2747","d":true,"e":true,"f":true,"h":true,"j":["stars","green-square","awesome","good","fireworks"],"k":[55,20],"o":2},"amphora":{"a":"Amphora","b":"1F3FA","d":true,"e":true,"f":true,"h":true,"j":["vase","jar"],"k":[11,22],"o":2},"yen":{"a":"Banknote with Yen Sign","b":"1F4B4","d":true,"e":true,"f":true,"h":true,"j":["money","sales","japanese","dollar","currency"],"k":[26,10],"o":2},"revolving_hearts":{"a":"Revolving Hearts","b":"1F49E","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,40],"o":2},"bangbang":{"a":"Double Exclamation Mark","b":"203C-FE0F","c":"203C","d":true,"e":true,"f":true,"h":true,"j":["exclamation","surprise"],"k":[52,10],"o":2},"parachute":{"a":"Parachute","b":"1FA82","d":true,"e":true,"f":true,"h":true,"k":[52,3],"o":12},"herb":{"a":"Herb","b":"1F33F","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","medicine","weed","grass","lawn"],"k":[6,23],"o":2},"flag-is":{"a":"Iceland Flag","b":"1F1EE-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,31],"o":2},"female-cook":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F373","non_qualified":null,"image":"1f469-1f3fb-200d-1f373.png","sheet_x":17,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F373","non_qualified":null,"image":"1f469-1f3fc-200d-1f373.png","sheet_x":17,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F373","non_qualified":null,"image":"1f469-1f3fd-200d-1f373.png","sheet_x":17,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F373","non_qualified":null,"image":"1f469-1f3fe-200d-1f373.png","sheet_x":17,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F373","non_qualified":null,"image":"1f469-1f3ff-200d-1f373.png","sheet_x":17,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Cook","b":"1F469-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[17,34],"o":4},"mechanic":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f527.png","sheet_x":46,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f527.png","sheet_x":46,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f527.png","sheet_x":46,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f527.png","sheet_x":46,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F527","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f527.png","sheet_x":46,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Mechanic","b":"1F9D1-200D-1F527","d":true,"e":false,"f":false,"h":false,"k":[46,14],"o":12},"interrobang":{"a":"Exclamation Question Mark","b":"2049-FE0F","c":"2049","d":true,"e":true,"f":true,"h":true,"j":["wat","punctuation","surprise"],"k":[52,11],"o":2},"seat":{"a":"Seat","b":"1F4BA","d":true,"e":true,"f":true,"h":true,"j":["sit","airplane","transport","bus","flight","fly"],"k":[26,16],"o":2},"dollar":{"a":"Banknote with Dollar Sign","b":"1F4B5","d":true,"e":true,"f":true,"h":true,"j":["money","sales","bill","currency"],"k":[26,11],"o":2},"two_hearts":{"a":"Two Hearts","b":"1F495","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","heart"],"k":[25,31],"o":2},"it":{"a":"Italy Flag","b":"1F1EE-1F1F9","d":true,"e":true,"f":true,"h":true,"j":["italy","flag","nation","country","banner"],"k":[2,32],"n":["flag-it"],"o":2},"shamrock":{"a":"Shamrock","b":"2618-FE0F","c":"2618","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","irish","clover"],"k":[53,1],"o":2},"four_leaf_clover":{"a":"Four Leaf Clover","b":"1F340","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","lucky","irish"],"k":[6,24],"o":2},"euro":{"a":"Banknote with Euro Sign","b":"1F4B6","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","currency"],"k":[26,12],"o":2},"question":{"a":"Black Question Mark Ornament","b":"2753","d":true,"e":true,"f":true,"h":true,"j":["doubt","confused"],"k":[55,23],"o":2},"helicopter":{"a":"Helicopter","b":"1F681","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","fly"],"k":[34,0],"o":2},"heart_decoration":{"a":"Heart Decoration","b":"1F49F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","love","like"],"k":[25,41],"o":2},"flag-je":{"a":"Jersey Flag","b":"1F1EF-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,33],"o":2},"male-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F527","non_qualified":null,"image":"1f468-1f3fb-200d-1f527.png","sheet_x":15,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F527","non_qualified":null,"image":"1f468-1f3fc-200d-1f527.png","sheet_x":15,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F527","non_qualified":null,"image":"1f468-1f3fd-200d-1f527.png","sheet_x":15,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F527","non_qualified":null,"image":"1f468-1f3fe-200d-1f527.png","sheet_x":15,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F527","non_qualified":null,"image":"1f468-1f3ff-200d-1f527.png","sheet_x":15,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mechanic","b":"1F468-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[15,50],"o":4},"suspension_railway":{"a":"Suspension Railway","b":"1F69F","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,30],"o":2},"heavy_heart_exclamation_mark_ornament":{"a":"Heavy Heart Exclamation Mark Ornament","b":"2763-FE0F","c":"2763","d":true,"e":true,"f":true,"h":true,"k":[55,27],"o":2},"female-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F527","non_qualified":null,"image":"1f469-1f3fb-200d-1f527.png","sheet_x":18,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F527","non_qualified":null,"image":"1f469-1f3fc-200d-1f527.png","sheet_x":18,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F527","non_qualified":null,"image":"1f469-1f3fd-200d-1f527.png","sheet_x":18,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F527","non_qualified":null,"image":"1f469-1f3fe-200d-1f527.png","sheet_x":18,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F527","non_qualified":null,"image":"1f469-1f3ff-200d-1f527.png","sheet_x":18,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Mechanic","b":"1F469-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[18,35],"o":4},"flag-jm":{"a":"Jamaica Flag","b":"1F1EF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,34],"o":2},"grey_question":{"a":"White Question Mark Ornament","b":"2754","d":true,"e":true,"f":true,"h":true,"j":["doubts","gray","huh","confused"],"k":[55,24],"o":2},"maple_leaf":{"a":"Maple Leaf","b":"1F341","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","ca","fall"],"k":[6,25],"o":2},"pound":{"a":"Banknote with Pound Sign","b":"1F4B7","d":true,"e":true,"f":true,"h":true,"j":["british","sterling","money","sales","bills","uk","england","currency"],"k":[26,13],"o":2},"money_with_wings":{"a":"Money with Wings","b":"1F4B8","d":true,"e":true,"f":true,"h":true,"j":["dollar","bills","payment","sale"],"k":[26,14],"o":2},"flag-jo":{"a":"Jordan Flag","b":"1F1EF-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,35],"o":2},"fallen_leaf":{"a":"Fallen Leaf","b":"1F342","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","leaves"],"k":[6,26],"o":2},"factory_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3ed.png","sheet_x":45,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3ed.png","sheet_x":45,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3ed.png","sheet_x":45,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3ed.png","sheet_x":46,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3ed.png","sheet_x":46,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Factory Worker","b":"1F9D1-200D-1F3ED","d":true,"e":false,"f":false,"h":false,"k":[45,53],"o":12},"broken_heart":{"a":"Broken Heart","b":"1F494","d":true,"e":true,"f":true,"h":true,"j":["sad","sorry","break","heart","heartbreak"],"k":[25,30],"l":["</3"],"m":"</3","o":2},"grey_exclamation":{"a":"White Exclamation Mark Ornament","b":"2755","d":true,"e":true,"f":true,"h":true,"j":["surprise","punctuation","gray","wow","warning"],"k":[55,25],"o":2},"mountain_cableway":{"a":"Mountain Cableway","b":"1F6A0","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,31],"o":2},"exclamation":{"a":"Heavy Exclamation Mark Symbol","b":"2757","d":true,"e":true,"f":true,"h":true,"j":["heavy_exclamation_mark","danger","surprise","punctuation","wow","warning"],"k":[55,26],"n":["heavy_exclamation_mark"],"o":2},"leaves":{"a":"Leaf Fluttering in Wind","b":"1F343","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","tree","vegetable","grass","lawn","spring"],"k":[6,27],"o":2},"heart":{"a":"Heavy Black Heart","b":"2764-FE0F","c":"2764","d":true,"e":true,"f":true,"h":true,"j":["love","like","valentines"],"k":[55,28],"l":["<3"],"m":"<3","o":2},"jp":{"a":"Japan Flag","b":"1F1EF-1F1F5","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","flag","country","banner"],"k":[2,36],"n":["flag-jp"],"o":2},"male-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fb-200d-1f3ed.png","sheet_x":15,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fc-200d-1f3ed.png","sheet_x":15,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fd-200d-1f3ed.png","sheet_x":15,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fe-200d-1f3ed.png","sheet_x":15,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f468-1f3ff-200d-1f3ed.png","sheet_x":15,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Factory Worker","b":"1F468-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[15,17],"o":4},"credit_card":{"a":"Credit Card","b":"1F4B3","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","bill","payment","shopping"],"k":[26,9],"o":2},"aerial_tramway":{"a":"Aerial Tramway","b":"1F6A1","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,32],"o":2},"female-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fb-200d-1f3ed.png","sheet_x":18,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fc-200d-1f3ed.png","sheet_x":18,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fd-200d-1f3ed.png","sheet_x":18,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fe-200d-1f3ed.png","sheet_x":18,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f469-1f3ff-200d-1f3ed.png","sheet_x":18,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Factory Worker","b":"1F469-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[18,7],"o":4},"receipt":{"a":"Receipt","b":"1F9FE","d":true,"e":true,"f":true,"h":true,"k":[51,49],"o":11},"wavy_dash":{"a":"Wavy Dash","b":"3030-FE0F","c":"3030","d":true,"e":true,"f":true,"h":true,"j":["draw","line","moustache","mustache","squiggle","scribble"],"k":[55,44],"o":2},"flag-ke":{"a":"Kenya Flag","b":"1F1F0-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,37],"o":2},"satellite":{"a":"Satellite","b":"1F6F0-FE0F","c":"1F6F0","d":true,"e":true,"f":true,"h":true,"j":["communication","future","radio","space"],"k":[36,51],"o":2},"orange_heart":{"a":"Orange Heart","b":"1F9E1","d":true,"e":true,"f":true,"h":true,"k":[51,20],"o":5},"yellow_heart":{"a":"Yellow Heart","b":"1F49B","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,37],"m":"<3","o":2},"copyright":{"a":"Copyright Sign","b":"00A9-FE0F","c":"00A9","d":true,"e":true,"f":true,"h":false,"j":["ip","license","circle","law","legal"],"k":[0,12],"o":2},"rocket":{"a":"Rocket","b":"1F680","d":true,"e":true,"f":true,"h":true,"j":["launch","ship","staffmode","NASA","outer space","outer_space","fly"],"k":[33,56],"o":2},"chart":{"a":"Chart with Upwards Trend and Yen Sign","b":"1F4B9","d":true,"e":true,"f":true,"h":true,"j":["green-square","graph","presentation","stats"],"k":[26,15],"o":2},"flag-kg":{"a":"Kyrgyzstan Flag","b":"1F1F0-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,38],"o":2},"office_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bc.png","sheet_x":46,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bc.png","sheet_x":46,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bc.png","sheet_x":46,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bc.png","sheet_x":46,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bc.png","sheet_x":46,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Office Worker","b":"1F9D1-200D-1F4BC","d":true,"e":false,"f":false,"h":false,"k":[46,8],"o":12},"currency_exchange":{"a":"Currency Exchange","b":"1F4B1","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","travel"],"k":[26,7],"o":2},"registered":{"a":"Registered Sign","b":"00AE-FE0F","c":"00AE","d":true,"e":true,"f":true,"h":false,"j":["alphabet","circle"],"k":[0,13],"o":2},"green_heart":{"a":"Green Heart","b":"1F49A","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,36],"m":"<3","o":2},"flying_saucer":{"a":"Flying Saucer","b":"1F6F8","d":true,"e":true,"f":true,"h":true,"k":[37,0],"o":5},"flag-kh":{"a":"Cambodia Flag","b":"1F1F0-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,39],"o":2},"male-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bc.png","sheet_x":15,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bc.png","sheet_x":15,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bc.png","sheet_x":15,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bc.png","sheet_x":15,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bc.png","sheet_x":15,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Office Worker","b":"1F468-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[15,44],"o":4},"tm":{"a":"Trade Mark Sign","b":"2122-FE0F","c":"2122","d":true,"e":true,"f":true,"h":true,"j":["trademark","brand","law","legal"],"k":[52,12],"o":2},"bellhop_bell":{"a":"Bellhop Bell","b":"1F6CE-FE0F","c":"1F6CE","d":true,"e":true,"f":true,"h":true,"j":["service"],"k":[36,36],"o":2},"blue_heart":{"a":"Blue Heart","b":"1F499","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,35],"m":"<3","o":2},"flag-ki":{"a":"Kiribati Flag","b":"1F1F0-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,40],"o":2},"heavy_dollar_sign":{"a":"Heavy Dollar Sign","b":"1F4B2","d":true,"e":true,"f":true,"h":true,"j":["money","sales","payment","currency","buck"],"k":[26,8],"o":2},"female-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bc.png","sheet_x":18,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bc.png","sheet_x":18,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bc.png","sheet_x":18,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bc.png","sheet_x":18,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bc.png","sheet_x":18,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Office Worker","b":"1F469-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[18,29],"o":4},"purple_heart":{"a":"Purple Heart","b":"1F49C","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,38],"m":"<3","o":2},"scientist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f52c.png","sheet_x":46,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f52c.png","sheet_x":46,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f52c.png","sheet_x":46,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f52c.png","sheet_x":46,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f52c.png","sheet_x":46,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Scientist","b":"1F9D1-200D-1F52C","d":true,"e":false,"f":false,"h":false,"k":[46,20],"o":12},"luggage":{"a":"Luggage","b":"1F9F3","d":true,"e":true,"f":true,"h":true,"k":[51,38],"o":11},"hash":{"a":"Hash Key","b":"0023-FE0F-20E3","c":"0023-20E3","d":true,"e":true,"f":true,"h":false,"j":["symbol","blue-square","twitter"],"k":[0,0],"o":0},"flag-km":{"a":"Comoros Flag","b":"1F1F0-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,41],"o":2},"email":{"a":"Envelope","b":"2709-FE0F","c":"2709","d":true,"e":true,"f":true,"h":true,"j":["letter","postal","inbox","communication"],"k":[54,42],"n":["envelope"],"o":2},"e-mail":{"a":"E-Mail Symbol","b":"1F4E7","d":true,"e":true,"f":true,"h":true,"j":["communication","inbox"],"k":[27,4],"o":2},"keycap_star":{"a":"Keycap Star","b":"002A-FE0F-20E3","c":"002A-20E3","d":true,"e":true,"f":true,"h":false,"k":[0,1],"o":0},"flag-kn":{"a":"St. Kitts & Nevis Flag","b":"1F1F0-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,42],"o":2},"hourglass":{"a":"Hourglass","b":"231B","d":true,"e":true,"f":true,"h":true,"j":["time","clock","oldschool","limit","exam","quiz","test"],"k":[52,23],"o":2},"brown_heart":{"a":"Brown Heart","b":"1F90E","d":true,"e":true,"f":true,"h":true,"k":[37,16],"o":12},"male-scientist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F52C","non_qualified":null,"image":"1f468-1f3fb-200d-1f52c.png","sheet_x":16,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F52C","non_qualified":null,"image":"1f468-1f3fc-200d-1f52c.png","sheet_x":16,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F52C","non_qualified":null,"image":"1f468-1f3fd-200d-1f52c.png","sheet_x":16,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F52C","non_qualified":null,"image":"1f468-1f3fe-200d-1f52c.png","sheet_x":16,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F52C","non_qualified":null,"image":"1f468-1f3ff-200d-1f52c.png","sheet_x":16,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Scientist","b":"1F468-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[15,56],"o":4},"hourglass_flowing_sand":{"a":"Hourglass with Flowing Sand","b":"23F3","d":true,"e":true,"f":true,"h":true,"j":["oldschool","time","countdown"],"k":[52,36],"o":2},"black_heart":{"a":"Black Heart","b":"1F5A4","d":true,"e":true,"f":true,"h":true,"j":["evil"],"k":[30,9],"o":4},"zero":{"a":"Keycap 0","b":"0030-FE0F-20E3","c":"0030-20E3","d":true,"e":true,"f":true,"h":false,"j":["0","numbers","blue-square","null"],"k":[0,2],"o":0},"incoming_envelope":{"a":"Incoming Envelope","b":"1F4E8","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,5],"o":2},"flag-kp":{"a":"North Korea Flag","b":"1F1F0-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,43],"o":2},"female-scientist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F52C","non_qualified":null,"image":"1f469-1f3fb-200d-1f52c.png","sheet_x":18,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F52C","non_qualified":null,"image":"1f469-1f3fc-200d-1f52c.png","sheet_x":18,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F52C","non_qualified":null,"image":"1f469-1f3fd-200d-1f52c.png","sheet_x":18,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F52C","non_qualified":null,"image":"1f469-1f3fe-200d-1f52c.png","sheet_x":18,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F52C","non_qualified":null,"image":"1f469-1f3ff-200d-1f52c.png","sheet_x":18,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Scientist","b":"1F469-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[18,41],"o":4},"watch":{"a":"Watch","b":"231A","d":true,"e":true,"f":true,"h":true,"j":["time","accessories"],"k":[52,22],"o":2},"white_heart":{"a":"White Heart","b":"1F90D","d":true,"e":true,"f":true,"h":true,"k":[37,15],"o":12},"one":{"a":"Keycap 1","b":"0031-FE0F-20E3","c":"0031-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","1"],"k":[0,3],"o":0},"kr":{"a":"South Korea Flag","b":"1F1F0-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["south","korea","nation","flag","country","banner"],"k":[2,44],"n":["flag-kr"],"o":2},"envelope_with_arrow":{"a":"Envelope with Downwards Arrow Above","b":"1F4E9","d":true,"e":true,"f":true,"h":true,"j":["email","communication"],"k":[27,6],"o":2},"technologist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bb.png","sheet_x":46,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bb.png","sheet_x":46,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bb.png","sheet_x":46,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bb.png","sheet_x":46,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bb.png","sheet_x":46,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Technologist","b":"1F9D1-200D-1F4BB","d":true,"e":false,"f":false,"h":false,"k":[46,2],"o":12},"outbox_tray":{"a":"Outbox Tray","b":"1F4E4","d":true,"e":true,"f":true,"h":true,"j":["inbox","email"],"k":[27,1],"o":2},"male-technologist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bb.png","sheet_x":15,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bb.png","sheet_x":15,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bb.png","sheet_x":15,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bb.png","sheet_x":15,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bb.png","sheet_x":15,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Technologist","b":"1F468-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[15,38],"o":4},"alarm_clock":{"a":"Alarm Clock","b":"23F0","d":true,"e":true,"f":true,"h":true,"j":["time","wake"],"k":[52,33],"o":2},"flag-kw":{"a":"Kuwait Flag","b":"1F1F0-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,45],"o":2},"two":{"a":"Keycap 2","b":"0032-FE0F-20E3","c":"0032-20E3","d":true,"e":true,"f":true,"h":false,"j":["numbers","2","prime","blue-square"],"k":[0,4],"o":0},"anger":{"a":"Anger Symbol","b":"1F4A2","d":true,"e":true,"f":true,"h":true,"j":["angry","mad"],"k":[25,44],"o":2},"inbox_tray":{"a":"Inbox Tray","b":"1F4E5","d":true,"e":true,"f":true,"h":true,"j":["email","documents"],"k":[27,2],"o":2},"three":{"a":"Keycap 3","b":"0033-FE0F-20E3","c":"0033-20E3","d":true,"e":true,"f":true,"h":false,"j":["3","numbers","prime","blue-square"],"k":[0,5],"o":0},"flag-ky":{"a":"Cayman Islands Flag","b":"1F1F0-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,46],"o":2},"stopwatch":{"a":"Stopwatch","b":"23F1-FE0F","c":"23F1","d":true,"e":true,"f":true,"h":true,"j":["time","deadline"],"k":[52,34],"o":2},"female-technologist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bb.png","sheet_x":18,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bb.png","sheet_x":18,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bb.png","sheet_x":18,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bb.png","sheet_x":18,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bb.png","sheet_x":18,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Technologist","b":"1F469-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[18,23],"o":4},"boom":{"a":"Collision Symbol","b":"1F4A5","d":true,"e":true,"f":true,"h":true,"j":["bomb","explode","explosion","collision","blown"],"k":[25,47],"n":["collision"],"o":2},"flag-kz":{"a":"Kazakhstan Flag","b":"1F1F0-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[2,47],"o":2},"four":{"a":"Keycap 4","b":"0034-FE0F-20E3","c":"0034-20E3","d":true,"e":true,"f":true,"h":false,"j":["4","numbers","blue-square"],"k":[0,6],"o":0},"timer_clock":{"a":"Timer Clock","b":"23F2-FE0F","c":"23F2","d":true,"e":true,"f":true,"h":true,"j":["alarm"],"k":[52,35],"o":2},"singer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a4.png","sheet_x":45,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a4.png","sheet_x":45,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a4.png","sheet_x":45,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a4.png","sheet_x":45,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a4.png","sheet_x":45,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Singer","b":"1F9D1-200D-1F3A4","d":true,"e":false,"f":false,"h":false,"k":[45,35],"o":12},"package":{"a":"Package","b":"1F4E6","d":true,"e":true,"f":true,"h":true,"j":["mail","gift","cardboard","box","moving"],"k":[27,3],"o":2},"mailbox":{"a":"Closed Mailbox with Raised Flag","b":"1F4EB","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,8],"o":2},"flag-la":{"a":"Laos Flag","b":"1F1F1-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[2,48],"o":2},"dizzy":{"a":"Dizzy Symbol","b":"1F4AB","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","shoot","magic"],"k":[26,1],"o":2},"five":{"a":"Keycap 5","b":"0035-FE0F-20E3","c":"0035-20E3","d":true,"e":true,"f":true,"h":false,"j":["5","numbers","blue-square","prime"],"k":[0,7],"o":0},"male-singer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a4.png","sheet_x":15,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a4.png","sheet_x":15,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a4.png","sheet_x":15,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a4.png","sheet_x":15,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a4.png","sheet_x":15,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Singer","b":"1F468-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[14,56],"o":4},"mantelpiece_clock":{"a":"Mantelpiece Clock","b":"1F570-FE0F","c":"1F570","d":true,"e":true,"f":true,"h":true,"j":["time"],"k":[29,7],"o":2},"female-singer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a4.png","sheet_x":17,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a4.png","sheet_x":17,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a4.png","sheet_x":17,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a4.png","sheet_x":17,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a4.png","sheet_x":17,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Singer","b":"1F469-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[17,46],"o":4},"flag-lb":{"a":"Lebanon Flag","b":"1F1F1-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[2,49],"o":2},"six":{"a":"Keycap 6","b":"0036-FE0F-20E3","c":"0036-20E3","d":true,"e":true,"f":true,"h":false,"j":["6","numbers","blue-square"],"k":[0,8],"o":0},"mailbox_closed":{"a":"Closed Mailbox with Lowered Flag","b":"1F4EA","d":true,"e":true,"f":true,"h":true,"j":["email","communication","inbox"],"k":[27,7],"o":2},"sweat_drops":{"a":"Splashing Sweat Symbol","b":"1F4A6","d":true,"e":true,"f":true,"h":true,"j":["water","drip","oops"],"k":[25,48],"o":2},"clock12":{"a":"Clock Face Twelve Oclock","b":"1F55B","d":true,"e":true,"f":true,"h":true,"j":["time","noon","midnight","midday","late","early","schedule"],"k":[28,50],"o":2},"seven":{"a":"Keycap 7","b":"0037-FE0F-20E3","c":"0037-20E3","d":true,"e":true,"f":true,"h":false,"j":["7","numbers","blue-square","prime"],"k":[0,9],"o":0},"mailbox_with_mail":{"a":"Open Mailbox with Raised Flag","b":"1F4EC","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,9],"o":2},"clock1230":{"a":"Clock Face Twelve-Thirty","b":"1F567","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,5],"o":2},"dash":{"a":"Dash Symbol","b":"1F4A8","d":true,"e":true,"f":true,"h":true,"j":["wind","air","fast","shoo","fart","smoke","puff"],"k":[25,50],"o":2},"artist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a8.png","sheet_x":45,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a8.png","sheet_x":45,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a8.png","sheet_x":45,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a8.png","sheet_x":45,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a8.png","sheet_x":45,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Artist","b":"1F9D1-200D-1F3A8","d":true,"e":false,"f":false,"h":false,"k":[45,41],"o":12},"flag-lc":{"a":"St. Lucia Flag","b":"1F1F1-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,50],"o":2},"hole":{"a":"Hole","b":"1F573-FE0F","c":"1F573","d":true,"e":true,"f":true,"h":true,"j":["embarrassing"],"k":[29,8],"o":2},"male-artist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a8.png","sheet_x":15,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a8.png","sheet_x":15,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a8.png","sheet_x":15,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a8.png","sheet_x":15,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a8.png","sheet_x":15,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Artist","b":"1F468-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[15,5],"o":4},"clock1":{"a":"Clock Face One Oclock","b":"1F550","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,39],"o":2},"eight":{"a":"Keycap 8","b":"0038-FE0F-20E3","c":"0038-20E3","d":true,"e":true,"f":true,"h":false,"j":["8","blue-square","numbers"],"k":[0,10],"o":0},"mailbox_with_no_mail":{"a":"Open Mailbox with Lowered Flag","b":"1F4ED","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,10],"o":2},"flag-li":{"a":"Liechtenstein Flag","b":"1F1F1-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,51],"o":2},"bomb":{"a":"Bomb","b":"1F4A3","d":true,"e":true,"f":true,"h":true,"j":["boom","explode","explosion","terrorism"],"k":[25,45],"o":2},"nine":{"a":"Keycap 9","b":"0039-FE0F-20E3","c":"0039-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","9"],"k":[0,11],"o":0},"postbox":{"a":"Postbox","b":"1F4EE","d":true,"e":true,"f":true,"h":true,"j":["email","letter","envelope"],"k":[27,11],"o":2},"female-artist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a8.png","sheet_x":17,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a8.png","sheet_x":17,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a8.png","sheet_x":17,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a8.png","sheet_x":17,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a8.png","sheet_x":18,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Artist","b":"1F469-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[17,52],"o":4},"clock130":{"a":"Clock Face One-Thirty","b":"1F55C","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,51],"o":2},"flag-lk":{"a":"Sri Lanka Flag","b":"1F1F1-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,52],"o":2},"ballot_box_with_ballot":{"a":"Ballot Box with Ballot","b":"1F5F3-FE0F","c":"1F5F3","d":true,"e":true,"f":true,"h":true,"k":[30,28],"o":2},"pilot":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2708-FE0F","non_qualified":"1F9D1-1F3FB-200D-2708","image":"1f9d1-1f3fb-200d-2708-fe0f.png","sheet_x":48,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2708-FE0F","non_qualified":"1F9D1-1F3FC-200D-2708","image":"1f9d1-1f3fc-200d-2708-fe0f.png","sheet_x":48,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2708-FE0F","non_qualified":"1F9D1-1F3FD-200D-2708","image":"1f9d1-1f3fd-200d-2708-fe0f.png","sheet_x":48,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2708-FE0F","non_qualified":"1F9D1-1F3FE-200D-2708","image":"1f9d1-1f3fe-200d-2708-fe0f.png","sheet_x":48,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2708-FE0F","non_qualified":"1F9D1-1F3FF-200D-2708","image":"1f9d1-1f3ff-200d-2708-fe0f.png","sheet_x":48,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Pilot","b":"1F9D1-200D-2708-FE0F","c":"1F9D1-200D-2708","d":true,"e":false,"f":false,"h":false,"k":[48,4],"o":12},"keycap_ten":{"a":"Keycap Ten","b":"1F51F","d":true,"e":true,"f":true,"h":true,"j":["numbers","10","blue-square"],"k":[28,2],"o":2},"clock2":{"a":"Clock Face Two Oclock","b":"1F551","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,40],"o":2},"flag-lr":{"a":"Liberia Flag","b":"1F1F1-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,53],"o":2},"speech_balloon":{"a":"Speech Balloon","b":"1F4AC","d":true,"e":true,"f":true,"h":true,"j":["bubble","words","message","talk","chatting"],"k":[26,2],"o":2},"eye-in-speech-bubble":{"a":"Eye in Speech Bubble","b":"1F441-FE0F-200D-1F5E8-FE0F","d":true,"e":true,"f":false,"h":false,"k":[12,37],"o":2},"flag-ls":{"a":"Lesotho Flag","b":"1F1F1-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,54],"o":2},"clock230":{"a":"Clock Face Two-Thirty","b":"1F55D","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,52],"o":2},"male-pilot":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2708-FE0F","non_qualified":"1F468-1F3FB-200D-2708","image":"1f468-1f3fb-200d-2708-fe0f.png","sheet_x":17,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2708-FE0F","non_qualified":"1F468-1F3FC-200D-2708","image":"1f468-1f3fc-200d-2708-fe0f.png","sheet_x":17,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2708-FE0F","non_qualified":"1F468-1F3FD-200D-2708","image":"1f468-1f3fd-200d-2708-fe0f.png","sheet_x":17,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2708-FE0F","non_qualified":"1F468-1F3FE-200D-2708","image":"1f468-1f3fe-200d-2708-fe0f.png","sheet_x":17,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2708-FE0F","non_qualified":"1F468-1F3FF-200D-2708","image":"1f468-1f3ff-200d-2708-fe0f.png","sheet_x":17,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Pilot","b":"1F468-200D-2708-FE0F","c":"1F468-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[17,14],"o":4},"capital_abcd":{"a":"Input Symbol for Latin Capital Letters","b":"1F520","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","blue-square"],"k":[28,3],"o":2},"pencil2":{"a":"Pencil","b":"270F-FE0F","c":"270F","d":true,"e":true,"f":true,"h":true,"j":["stationery","write","paper","writing","school","study"],"k":[55,10],"o":2},"female-pilot":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2708-FE0F","non_qualified":"1F469-1F3FB-200D-2708","image":"1f469-1f3fb-200d-2708-fe0f.png","sheet_x":20,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2708-FE0F","non_qualified":"1F469-1F3FC-200D-2708","image":"1f469-1f3fc-200d-2708-fe0f.png","sheet_x":20,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2708-FE0F","non_qualified":"1F469-1F3FD-200D-2708","image":"1f469-1f3fd-200d-2708-fe0f.png","sheet_x":20,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2708-FE0F","non_qualified":"1F469-1F3FE-200D-2708","image":"1f469-1f3fe-200d-2708-fe0f.png","sheet_x":20,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2708-FE0F","non_qualified":"1F469-1F3FF-200D-2708","image":"1f469-1f3ff-200d-2708-fe0f.png","sheet_x":20,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Pilot","b":"1F469-200D-2708-FE0F","c":"1F469-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[19,56],"o":4},"black_nib":{"a":"Black Nib","b":"2712-FE0F","c":"2712","d":true,"e":true,"f":true,"h":true,"j":["pen","stationery","writing","write"],"k":[55,11],"o":2},"left_speech_bubble":{"a":"Left Speech Bubble","b":"1F5E8-FE0F","c":"1F5E8","d":true,"e":true,"f":true,"h":true,"j":["words","message","talk","chatting"],"k":[30,26],"o":2},"clock3":{"a":"Clock Face Three Oclock","b":"1F552","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,41],"o":2},"abcd":{"a":"Input Symbol for Latin Small Letters","b":"1F521","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,4],"o":2},"flag-lt":{"a":"Lithuania Flag","b":"1F1F1-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,55],"o":2},"clock330":{"a":"Clock Face Three-Thirty","b":"1F55E","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,53],"o":2},"astronaut":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f680.png","sheet_x":46,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f680.png","sheet_x":46,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f680.png","sheet_x":46,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f680.png","sheet_x":46,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F680","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f680.png","sheet_x":46,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Astronaut","b":"1F9D1-200D-1F680","d":true,"e":false,"f":false,"h":false,"k":[46,26],"o":12},"flag-lu":{"a":"Luxembourg Flag","b":"1F1F1-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,56],"o":2},"right_anger_bubble":{"a":"Right Anger Bubble","b":"1F5EF-FE0F","c":"1F5EF","d":true,"e":true,"f":true,"h":true,"j":["caption","speech","thinking","mad"],"k":[30,27],"o":2},"lower_left_fountain_pen":{"a":"Lower Left Fountain Pen","b":"1F58B-FE0F","c":"1F58B","d":true,"e":true,"f":true,"h":true,"k":[29,45],"o":2},"male-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F680","non_qualified":null,"image":"1f468-1f3fb-200d-1f680.png","sheet_x":16,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F680","non_qualified":null,"image":"1f468-1f3fc-200d-1f680.png","sheet_x":16,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F680","non_qualified":null,"image":"1f468-1f3fd-200d-1f680.png","sheet_x":16,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F680","non_qualified":null,"image":"1f468-1f3fe-200d-1f680.png","sheet_x":16,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F680","non_qualified":null,"image":"1f468-1f3ff-200d-1f680.png","sheet_x":16,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Astronaut","b":"1F468-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[16,5],"o":4},"thought_balloon":{"a":"Thought Balloon","b":"1F4AD","d":true,"e":true,"f":true,"h":true,"j":["bubble","cloud","speech","thinking","dream"],"k":[26,3],"o":2},"symbols":{"a":"Input Symbol for Symbols","b":"1F523","d":true,"e":true,"f":true,"h":true,"j":["blue-square","music","note","ampersand","percent","glyphs","characters"],"k":[28,6],"o":2},"clock4":{"a":"Clock Face Four Oclock","b":"1F553","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,42],"o":2},"flag-lv":{"a":"Latvia Flag","b":"1F1F1-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,0],"o":2},"lower_left_ballpoint_pen":{"a":"Lower Left Ballpoint Pen","b":"1F58A-FE0F","c":"1F58A","d":true,"e":true,"f":true,"h":true,"k":[29,44],"o":2},"abc":{"a":"Input Symbol for Latin Letters","b":"1F524","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,7],"o":2},"zzz":{"a":"Sleeping Symbol","b":"1F4A4","d":true,"e":true,"f":true,"h":true,"j":["sleepy","tired","dream"],"k":[25,46],"o":2},"lower_left_paintbrush":{"a":"Lower Left Paintbrush","b":"1F58C-FE0F","c":"1F58C","d":true,"e":true,"f":true,"h":true,"k":[29,46],"o":2},"female-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F680","non_qualified":null,"image":"1f469-1f3fb-200d-1f680.png","sheet_x":18,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F680","non_qualified":null,"image":"1f469-1f3fc-200d-1f680.png","sheet_x":18,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F680","non_qualified":null,"image":"1f469-1f3fd-200d-1f680.png","sheet_x":18,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F680","non_qualified":null,"image":"1f469-1f3fe-200d-1f680.png","sheet_x":18,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F680","non_qualified":null,"image":"1f469-1f3ff-200d-1f680.png","sheet_x":18,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Astronaut","b":"1F469-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[18,47],"o":4},"flag-ly":{"a":"Libya Flag","b":"1F1F1-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,1],"o":2},"clock430":{"a":"Clock Face Four-Thirty","b":"1F55F","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,54],"o":2},"flag-ma":{"a":"Morocco Flag","b":"1F1F2-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,2],"o":2},"a":{"a":"Negative Squared Latin Capital Letter a","b":"1F170-FE0F","c":"1F170","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,16],"o":2},"clock5":{"a":"Clock Face Five Oclock","b":"1F554","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,43],"o":2},"lower_left_crayon":{"a":"Lower Left Crayon","b":"1F58D-FE0F","c":"1F58D","d":true,"e":true,"f":true,"h":true,"k":[29,47],"o":2},"firefighter":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f692.png","sheet_x":46,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f692.png","sheet_x":46,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f692.png","sheet_x":46,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f692.png","sheet_x":46,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F692","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f692.png","sheet_x":46,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Firefighter","b":"1F9D1-200D-1F692","d":true,"e":false,"f":false,"h":false,"k":[46,32],"o":12},"male-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F692","non_qualified":null,"image":"1f468-1f3fb-200d-1f692.png","sheet_x":16,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F692","non_qualified":null,"image":"1f468-1f3fc-200d-1f692.png","sheet_x":16,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F692","non_qualified":null,"image":"1f468-1f3fd-200d-1f692.png","sheet_x":16,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F692","non_qualified":null,"image":"1f468-1f3fe-200d-1f692.png","sheet_x":16,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F692","non_qualified":null,"image":"1f468-1f3ff-200d-1f692.png","sheet_x":16,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Firefighter","b":"1F468-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[16,11],"o":4},"memo":{"a":"Memo","b":"1F4DD","d":true,"e":true,"f":true,"h":true,"j":["write","documents","stationery","pencil","paper","writing","legal","exam","quiz","test","study","compose"],"k":[26,51],"n":["pencil"],"o":2},"ab":{"a":"Negative Squared Ab","b":"1F18E","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet"],"k":[0,20],"o":2},"flag-mc":{"a":"Monaco Flag","b":"1F1F2-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,3],"o":2},"clock530":{"a":"Clock Face Five-Thirty","b":"1F560","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,55],"o":2},"briefcase":{"a":"Briefcase","b":"1F4BC","d":true,"e":true,"f":true,"h":true,"j":["business","documents","work","law","legal","job","career"],"k":[26,18],"o":2},"female-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F692","non_qualified":null,"image":"1f469-1f3fb-200d-1f692.png","sheet_x":18,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F692","non_qualified":null,"image":"1f469-1f3fc-200d-1f692.png","sheet_x":18,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F692","non_qualified":null,"image":"1f469-1f3fd-200d-1f692.png","sheet_x":18,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F692","non_qualified":null,"image":"1f469-1f3fe-200d-1f692.png","sheet_x":19,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F692","non_qualified":null,"image":"1f469-1f3ff-200d-1f692.png","sheet_x":19,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Firefighter","b":"1F469-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[18,53],"o":4},"clock6":{"a":"Clock Face Six Oclock","b":"1F555","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule","dawn","dusk"],"k":[28,44],"o":2},"b":{"a":"Negative Squared Latin Capital Letter B","b":"1F171-FE0F","c":"1F171","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,17],"o":2},"flag-md":{"a":"Moldova Flag","b":"1F1F2-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[3,4],"o":2},"clock630":{"a":"Clock Face Six-Thirty","b":"1F561","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,56],"o":2},"cl":{"a":"Squared Cl","b":"1F191","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","red-square"],"k":[0,21],"o":2},"flag-me":{"a":"Montenegro Flag","b":"1F1F2-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,5],"o":2},"file_folder":{"a":"File Folder","b":"1F4C1","d":true,"e":true,"f":true,"h":true,"j":["documents","business","office"],"k":[26,23],"o":2},"cop":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB","non_qualified":null,"image":"1f46e-1f3fb.png","sheet_x":21,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F46E-1F3FC","non_qualified":null,"image":"1f46e-1f3fc.png","sheet_x":21,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F46E-1F3FD","non_qualified":null,"image":"1f46e-1f3fd.png","sheet_x":21,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F46E-1F3FE","non_qualified":null,"image":"1f46e-1f3fe.png","sheet_x":21,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F46E-1F3FF","non_qualified":null,"image":"1f46e-1f3ff.png","sheet_x":21,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F46E-200D-2642-FE0F","a":"Police Officer","b":"1F46E","d":true,"e":true,"f":true,"h":false,"k":[21,49],"o":2},"male-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2642-FE0F","non_qualified":"1F46E-1F3FB-200D-2642","image":"1f46e-1f3fb-200d-2642-fe0f.png","sheet_x":21,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2642-FE0F","non_qualified":"1F46E-1F3FC-200D-2642","image":"1f46e-1f3fc-200d-2642-fe0f.png","sheet_x":21,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2642-FE0F","non_qualified":"1F46E-1F3FD-200D-2642","image":"1f46e-1f3fd-200d-2642-fe0f.png","sheet_x":21,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2642-FE0F","non_qualified":"1F46E-1F3FE-200D-2642","image":"1f46e-1f3fe-200d-2642-fe0f.png","sheet_x":21,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2642-FE0F","non_qualified":"1F46E-1F3FF-200D-2642","image":"1f46e-1f3ff-200d-2642-fe0f.png","sheet_x":21,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F46E","a":"Male Police Officer","b":"1F46E-200D-2642-FE0F","c":"1F46E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,43],"o":4},"cool":{"a":"Squared Cool","b":"1F192","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[0,22],"o":2},"clock7":{"a":"Clock Face Seven Oclock","b":"1F556","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,45],"o":2},"flag-mf":{"a":"St. Martin Flag","b":"1F1F2-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,6],"o":2},"open_file_folder":{"a":"Open File Folder","b":"1F4C2","d":true,"e":true,"f":true,"h":true,"j":["documents","load"],"k":[26,24],"o":2},"card_index_dividers":{"a":"Card Index Dividers","b":"1F5C2-FE0F","c":"1F5C2","d":true,"e":true,"f":true,"h":true,"j":["organizing","business","stationery"],"k":[30,15],"o":2},"flag-mg":{"a":"Madagascar Flag","b":"1F1F2-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,7],"o":2},"free":{"a":"Squared Free","b":"1F193","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words"],"k":[0,23],"o":2},"female-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2640-FE0F","non_qualified":"1F46E-1F3FB-200D-2640","image":"1f46e-1f3fb-200d-2640-fe0f.png","sheet_x":21,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2640-FE0F","non_qualified":"1F46E-1F3FC-200D-2640","image":"1f46e-1f3fc-200d-2640-fe0f.png","sheet_x":21,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2640-FE0F","non_qualified":"1F46E-1F3FD-200D-2640","image":"1f46e-1f3fd-200d-2640-fe0f.png","sheet_x":21,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2640-FE0F","non_qualified":"1F46E-1F3FE-200D-2640","image":"1f46e-1f3fe-200d-2640-fe0f.png","sheet_x":21,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2640-FE0F","non_qualified":"1F46E-1F3FF-200D-2640","image":"1f46e-1f3ff-200d-2640-fe0f.png","sheet_x":21,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Police Officer","b":"1F46E-200D-2640-FE0F","c":"1F46E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,37],"o":4},"clock730":{"a":"Clock Face Seven-Thirty","b":"1F562","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,0],"o":2},"date":{"a":"Calendar","b":"1F4C5","d":true,"e":true,"f":true,"h":true,"j":["calendar","schedule"],"k":[26,27],"o":2},"clock8":{"a":"Clock Face Eight Oclock","b":"1F557","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,46],"o":2},"information_source":{"a":"Information Source","b":"2139-FE0F","c":"2139","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet","letter"],"k":[52,13],"o":2},"sleuth_or_spy":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB","non_qualified":null,"image":"1f575-1f3fb.png","sheet_x":29,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F575-1F3FC","non_qualified":null,"image":"1f575-1f3fc.png","sheet_x":29,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F575-1F3FD","non_qualified":null,"image":"1f575-1f3fd.png","sheet_x":29,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F575-1F3FE","non_qualified":null,"image":"1f575-1f3fe.png","sheet_x":29,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F575-1F3FF","non_qualified":null,"image":"1f575-1f3ff.png","sheet_x":29,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F575-FE0F-200D-2642-FE0F","a":"Sleuth or Spy","b":"1F575-FE0F","c":"1F575","d":true,"e":true,"f":true,"h":false,"k":[29,27],"o":2},"flag-mh":{"a":"Marshall Islands Flag","b":"1F1F2-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,8],"o":2},"clock830":{"a":"Clock Face Eight-Thirty","b":"1F563","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,1],"o":2},"calendar":{"a":"Tear-off Calendar","b":"1F4C6","d":true,"e":true,"f":true,"h":true,"j":["schedule","date","planning"],"k":[26,28],"o":2},"male-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2642-FE0F","non_qualified":"1F575-1F3FB-200D-2642","image":"1f575-1f3fb-200d-2642-fe0f.png","sheet_x":29,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2642-FE0F","non_qualified":"1F575-1F3FC-200D-2642","image":"1f575-1f3fc-200d-2642-fe0f.png","sheet_x":29,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2642-FE0F","non_qualified":"1F575-1F3FD-200D-2642","image":"1f575-1f3fd-200d-2642-fe0f.png","sheet_x":29,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2642-FE0F","non_qualified":"1F575-1F3FE-200D-2642","image":"1f575-1f3fe-200d-2642-fe0f.png","sheet_x":29,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2642-FE0F","non_qualified":"1F575-1F3FF-200D-2642","image":"1f575-1f3ff-200d-2642-fe0f.png","sheet_x":29,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F575-FE0F","a":"Male Detective","b":"1F575-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,21],"o":4},"flag-mk":{"a":"North Macedonia Flag","b":"1F1F2-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,9],"o":2},"id":{"a":"Squared Id","b":"1F194","d":true,"e":true,"f":true,"h":true,"j":["purple-square","words"],"k":[0,24],"o":2},"spiral_note_pad":{"a":"Spiral Note Pad","b":"1F5D2-FE0F","c":"1F5D2","d":true,"e":true,"f":true,"h":true,"k":[30,19],"o":2},"female-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2640-FE0F","non_qualified":"1F575-1F3FB-200D-2640","image":"1f575-1f3fb-200d-2640-fe0f.png","sheet_x":29,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2640-FE0F","non_qualified":"1F575-1F3FC-200D-2640","image":"1f575-1f3fc-200d-2640-fe0f.png","sheet_x":29,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2640-FE0F","non_qualified":"1F575-1F3FD-200D-2640","image":"1f575-1f3fd-200d-2640-fe0f.png","sheet_x":29,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2640-FE0F","non_qualified":"1F575-1F3FE-200D-2640","image":"1f575-1f3fe-200d-2640-fe0f.png","sheet_x":29,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2640-FE0F","non_qualified":"1F575-1F3FF-200D-2640","image":"1f575-1f3ff-200d-2640-fe0f.png","sheet_x":29,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Detective","b":"1F575-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,15],"o":4},"clock9":{"a":"Clock Face Nine Oclock","b":"1F558","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,47],"o":2},"flag-ml":{"a":"Mali Flag","b":"1F1F2-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,10],"o":2},"m":{"a":"Circled Latin Capital Letter M","b":"24C2-FE0F","c":"24C2","d":true,"e":true,"f":true,"h":true,"j":["alphabet","blue-circle","letter"],"k":[52,40],"o":2},"flag-mm":{"a":"Myanmar (burma) Flag","b":"1F1F2-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,11],"o":2},"clock930":{"a":"Clock Face Nine-Thirty","b":"1F564","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,2],"o":2},"guardsman":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB","non_qualified":null,"image":"1f482-1f3fb.png","sheet_x":24,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F482-1F3FC","non_qualified":null,"image":"1f482-1f3fc.png","sheet_x":24,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F482-1F3FD","non_qualified":null,"image":"1f482-1f3fd.png","sheet_x":24,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F482-1F3FE","non_qualified":null,"image":"1f482-1f3fe.png","sheet_x":24,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F482-1F3FF","non_qualified":null,"image":"1f482-1f3ff.png","sheet_x":24,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F482-200D-2642-FE0F","a":"Guardsman","b":"1F482","d":true,"e":true,"f":true,"h":false,"j":["uk","gb","british","male","guy","royal"],"k":[24,20],"o":2},"new":{"a":"Squared New","b":"1F195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","start"],"k":[0,25],"o":2},"spiral_calendar_pad":{"a":"Spiral Calendar Pad","b":"1F5D3-FE0F","c":"1F5D3","d":true,"e":true,"f":true,"h":true,"k":[30,20],"o":2},"ng":{"a":"Squared Ng","b":"1F196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","shape","icon"],"k":[0,26],"o":2},"card_index":{"a":"Card Index","b":"1F4C7","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[26,29],"o":2},"clock10":{"a":"Clock Face Ten Oclock","b":"1F559","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,48],"o":2},"flag-mn":{"a":"Mongolia Flag","b":"1F1F2-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,12],"o":2},"male-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2642-FE0F","non_qualified":"1F482-1F3FB-200D-2642","image":"1f482-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2642-FE0F","non_qualified":"1F482-1F3FC-200D-2642","image":"1f482-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2642-FE0F","non_qualified":"1F482-1F3FD-200D-2642","image":"1f482-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2642-FE0F","non_qualified":"1F482-1F3FE-200D-2642","image":"1f482-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2642-FE0F","non_qualified":"1F482-1F3FF-200D-2642","image":"1f482-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F482","a":"Male Guard","b":"1F482-200D-2642-FE0F","c":"1F482-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,14],"o":4},"flag-mo":{"a":"Macao Sar China Flag","b":"1F1F2-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,13],"o":2},"clock1030":{"a":"Clock Face Ten-Thirty","b":"1F565","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,3],"o":2},"chart_with_upwards_trend":{"a":"Chart with Upwards Trend","b":"1F4C8","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"k":[26,30],"o":2},"o2":{"a":"Negative Squared Latin Capital Letter O","b":"1F17E-FE0F","c":"1F17E","d":true,"e":true,"f":true,"h":true,"j":["alphabet","red-square","letter"],"k":[0,18],"o":2},"female-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2640-FE0F","non_qualified":"1F482-1F3FB-200D-2640","image":"1f482-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2640-FE0F","non_qualified":"1F482-1F3FC-200D-2640","image":"1f482-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2640-FE0F","non_qualified":"1F482-1F3FD-200D-2640","image":"1f482-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2640-FE0F","non_qualified":"1F482-1F3FE-200D-2640","image":"1f482-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2640-FE0F","non_qualified":"1F482-1F3FF-200D-2640","image":"1f482-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Guard","b":"1F482-200D-2640-FE0F","c":"1F482-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,8],"o":4},"chart_with_downwards_trend":{"a":"Chart with Downwards Trend","b":"1F4C9","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"k":[26,31],"o":2},"flag-mp":{"a":"Northern Mariana Islands Flag","b":"1F1F2-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,14],"o":2},"ok":{"a":"Squared Ok","b":"1F197","d":true,"e":true,"f":true,"h":true,"j":["good","agree","yes","blue-square"],"k":[0,27],"o":2},"clock11":{"a":"Clock Face Eleven Oclock","b":"1F55A","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,49],"o":2},"construction_worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB","non_qualified":null,"image":"1f477-1f3fb.png","sheet_x":23,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F477-1F3FC","non_qualified":null,"image":"1f477-1f3fc.png","sheet_x":23,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F477-1F3FD","non_qualified":null,"image":"1f477-1f3fd.png","sheet_x":23,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F477-1F3FE","non_qualified":null,"image":"1f477-1f3fe.png","sheet_x":23,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F477-1F3FF","non_qualified":null,"image":"1f477-1f3ff.png","sheet_x":23,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F477-200D-2642-FE0F","a":"Construction Worker","b":"1F477","d":true,"e":true,"f":true,"h":false,"k":[23,22],"o":2},"male-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2642-FE0F","non_qualified":"1F477-1F3FB-200D-2642","image":"1f477-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2642-FE0F","non_qualified":"1F477-1F3FC-200D-2642","image":"1f477-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2642-FE0F","non_qualified":"1F477-1F3FD-200D-2642","image":"1f477-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2642-FE0F","non_qualified":"1F477-1F3FE-200D-2642","image":"1f477-1f3fe-200d-2642-fe0f.png","sheet_x":23,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2642-FE0F","non_qualified":"1F477-1F3FF-200D-2642","image":"1f477-1f3ff-200d-2642-fe0f.png","sheet_x":23,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F477","a":"Male Construction Worker","b":"1F477-200D-2642-FE0F","c":"1F477-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,16],"o":4},"clock1130":{"a":"Clock Face Eleven-Thirty","b":"1F566","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,4],"o":2},"flag-mq":{"a":"Martinique Flag","b":"1F1F2-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[3,15],"o":2},"bar_chart":{"a":"Bar Chart","b":"1F4CA","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats"],"k":[26,32],"o":2},"parking":{"a":"Negative Squared Latin Capital Letter P","b":"1F17F-FE0F","c":"1F17F","d":true,"e":true,"f":true,"h":true,"j":["cars","blue-square","alphabet","letter"],"k":[0,19],"o":2},"new_moon":{"a":"New Moon Symbol","b":"1F311","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,36],"o":2},"female-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2640-FE0F","non_qualified":"1F477-1F3FB-200D-2640","image":"1f477-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2640-FE0F","non_qualified":"1F477-1F3FC-200D-2640","image":"1f477-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2640-FE0F","non_qualified":"1F477-1F3FD-200D-2640","image":"1f477-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2640-FE0F","non_qualified":"1F477-1F3FE-200D-2640","image":"1f477-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2640-FE0F","non_qualified":"1F477-1F3FF-200D-2640","image":"1f477-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Construction Worker","b":"1F477-200D-2640-FE0F","c":"1F477-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,10],"o":4},"sos":{"a":"Squared Sos","b":"1F198","d":true,"e":true,"f":true,"h":true,"j":["help","red-square","words","emergency","911"],"k":[0,28],"o":2},"clipboard":{"a":"Clipboard","b":"1F4CB","d":true,"e":true,"f":true,"h":true,"j":["stationery","documents"],"k":[26,33],"o":2},"flag-mr":{"a":"Mauritania Flag","b":"1F1F2-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,16],"o":2},"prince":{"skin_variations":{"1F3FB":{"unified":"1F934-1F3FB","non_qualified":null,"image":"1f934-1f3fb.png","sheet_x":39,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F934-1F3FC","non_qualified":null,"image":"1f934-1f3fc.png","sheet_x":39,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F934-1F3FD","non_qualified":null,"image":"1f934-1f3fd.png","sheet_x":39,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F934-1F3FE","non_qualified":null,"image":"1f934-1f3fe.png","sheet_x":39,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F934-1F3FF","non_qualified":null,"image":"1f934-1f3ff.png","sheet_x":39,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Prince","b":"1F934","d":true,"e":true,"f":true,"h":true,"j":["boy","man","male","crown","royal","king"],"k":[39,17],"o":4},"waxing_crescent_moon":{"a":"Waxing Crescent Moon Symbol","b":"1F312","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,37],"o":2},"flag-ms":{"a":"Montserrat Flag","b":"1F1F2-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,17],"o":2},"pushpin":{"a":"Pushpin","b":"1F4CC","d":true,"e":true,"f":true,"h":true,"j":["stationery","mark","here"],"k":[26,34],"o":2},"up":{"a":"Squared Up with Exclamation Mark","b":"1F199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","above","high"],"k":[0,29],"o":2},"flag-mt":{"a":"Malta Flag","b":"1F1F2-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,18],"o":2},"princess":{"skin_variations":{"1F3FB":{"unified":"1F478-1F3FB","non_qualified":null,"image":"1f478-1f3fb.png","sheet_x":23,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F478-1F3FC","non_qualified":null,"image":"1f478-1f3fc.png","sheet_x":23,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F478-1F3FD","non_qualified":null,"image":"1f478-1f3fd.png","sheet_x":23,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F478-1F3FE","non_qualified":null,"image":"1f478-1f3fe.png","sheet_x":23,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F478-1F3FF","non_qualified":null,"image":"1f478-1f3ff.png","sheet_x":23,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Princess","b":"1F478","d":true,"e":true,"f":true,"h":true,"j":["girl","woman","female","blond","crown","royal","queen"],"k":[23,28],"o":2},"round_pushpin":{"a":"Round Pushpin","b":"1F4CD","d":true,"e":true,"f":true,"h":true,"j":["stationery","location","map","here"],"k":[26,35],"o":2},"first_quarter_moon":{"a":"First Quarter Moon Symbol","b":"1F313","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,38],"o":2},"vs":{"a":"Squared Vs","b":"1F19A","d":true,"e":true,"f":true,"h":true,"j":["words","orange-square"],"k":[0,30],"o":2},"flag-mu":{"a":"Mauritius Flag","b":"1F1F2-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,19],"o":2},"koko":{"a":"Squared Katakana Koko","b":"1F201","d":true,"e":true,"f":true,"h":true,"j":["blue-square","here","katakana","japanese","destination"],"k":[5,4],"o":2},"man_with_turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB","non_qualified":null,"image":"1f473-1f3fb.png","sheet_x":22,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F473-1F3FC","non_qualified":null,"image":"1f473-1f3fc.png","sheet_x":22,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F473-1F3FD","non_qualified":null,"image":"1f473-1f3fd.png","sheet_x":22,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F473-1F3FE","non_qualified":null,"image":"1f473-1f3fe.png","sheet_x":22,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F473-1F3FF","non_qualified":null,"image":"1f473-1f3ff.png","sheet_x":22,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F473-200D-2642-FE0F","a":"Man with Turban","b":"1F473","d":true,"e":true,"f":true,"h":false,"j":["male","indian","hinduism","arabs"],"k":[22,43],"o":2},"moon":{"a":"Waxing Gibbous Moon Symbol","b":"1F314","d":true,"e":true,"f":true,"h":true,"k":[5,39],"n":["waxing_gibbous_moon"],"o":2},"paperclip":{"a":"Paperclip","b":"1F4CE","d":true,"e":true,"f":true,"h":true,"j":["documents","stationery"],"k":[26,36],"o":2},"linked_paperclips":{"a":"Linked Paperclips","b":"1F587-FE0F","c":"1F587","d":true,"e":true,"f":true,"h":true,"k":[29,43],"o":2},"man-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2642-FE0F","non_qualified":"1F473-1F3FB-200D-2642","image":"1f473-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2642-FE0F","non_qualified":"1F473-1F3FC-200D-2642","image":"1f473-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2642-FE0F","non_qualified":"1F473-1F3FD-200D-2642","image":"1f473-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2642-FE0F","non_qualified":"1F473-1F3FE-200D-2642","image":"1f473-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2642-FE0F","non_qualified":"1F473-1F3FF-200D-2642","image":"1f473-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F473","a":"Man Wearing Turban","b":"1F473-200D-2642-FE0F","c":"1F473-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,37],"o":4},"sa":{"a":"Squared Katakana Sa","b":"1F202-FE0F","c":"1F202","d":true,"e":true,"f":true,"h":true,"j":["japanese","blue-square","katakana"],"k":[5,5],"o":2},"full_moon":{"a":"Full Moon Symbol","b":"1F315","d":true,"e":true,"f":true,"h":true,"j":["nature","yellow","twilight","planet","space","night","evening","sleep"],"k":[5,40],"o":2},"flag-mv":{"a":"Maldives Flag","b":"1F1F2-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,20],"o":2},"flag-mw":{"a":"Malawi Flag","b":"1F1F2-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,21],"o":2},"waning_gibbous_moon":{"a":"Waning Gibbous Moon Symbol","b":"1F316","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep","waxing_gibbous_moon"],"k":[5,41],"o":2},"woman-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2640-FE0F","non_qualified":"1F473-1F3FB-200D-2640","image":"1f473-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2640-FE0F","non_qualified":"1F473-1F3FC-200D-2640","image":"1f473-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2640-FE0F","non_qualified":"1F473-1F3FD-200D-2640","image":"1f473-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2640-FE0F","non_qualified":"1F473-1F3FE-200D-2640","image":"1f473-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2640-FE0F","non_qualified":"1F473-1F3FF-200D-2640","image":"1f473-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Wearing Turban","b":"1F473-200D-2640-FE0F","c":"1F473-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,31],"o":4},"u6708":{"a":"Squared Cjk Unified Ideograph-6708","b":"1F237-FE0F","c":"1F237","d":true,"e":true,"f":true,"h":true,"j":["chinese","month","moon","japanese","orange-square","kanji"],"k":[5,13],"o":2},"straight_ruler":{"a":"Straight Ruler","b":"1F4CF","d":true,"e":true,"f":true,"h":true,"j":["stationery","calculate","length","math","school","drawing","architect","sketch"],"k":[26,37],"o":2},"u6709":{"a":"Squared Cjk Unified Ideograph-6709","b":"1F236","d":true,"e":true,"f":true,"h":true,"j":["orange-square","chinese","have","kanji"],"k":[5,12],"o":2},"triangular_ruler":{"a":"Triangular Ruler","b":"1F4D0","d":true,"e":true,"f":true,"h":true,"j":["stationery","math","architect","sketch"],"k":[26,38],"o":2},"man_with_gua_pi_mao":{"skin_variations":{"1F3FB":{"unified":"1F472-1F3FB","non_qualified":null,"image":"1f472-1f3fb.png","sheet_x":22,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F472-1F3FC","non_qualified":null,"image":"1f472-1f3fc.png","sheet_x":22,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F472-1F3FD","non_qualified":null,"image":"1f472-1f3fd.png","sheet_x":22,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F472-1F3FE","non_qualified":null,"image":"1f472-1f3fe.png","sheet_x":22,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F472-1F3FF","non_qualified":null,"image":"1f472-1f3ff.png","sheet_x":22,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Gua Pi Mao","b":"1F472","d":true,"e":true,"f":true,"h":true,"j":["male","boy","chinese"],"k":[22,25],"o":2},"flag-mx":{"a":"Mexico Flag","b":"1F1F2-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[3,22],"o":2},"last_quarter_moon":{"a":"Last Quarter Moon Symbol","b":"1F317","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,42],"o":2},"person_with_headscarf":{"skin_variations":{"1F3FB":{"unified":"1F9D5-1F3FB","non_qualified":null,"image":"1f9d5-1f3fb.png","sheet_x":48,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D5-1F3FC","non_qualified":null,"image":"1f9d5-1f3fc.png","sheet_x":48,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D5-1F3FD","non_qualified":null,"image":"1f9d5-1f3fd.png","sheet_x":48,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D5-1F3FE","non_qualified":null,"image":"1f9d5-1f3fe.png","sheet_x":48,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D5-1F3FF","non_qualified":null,"image":"1f9d5-1f3ff.png","sheet_x":48,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Headscarf","b":"1F9D5","d":true,"e":true,"f":true,"h":true,"k":[48,34],"o":5},"waning_crescent_moon":{"a":"Waning Crescent Moon Symbol","b":"1F318","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,43],"o":2},"u6307":{"a":"Squared Cjk Unified Ideograph-6307","b":"1F22F","d":true,"e":true,"f":true,"h":true,"j":["chinese","point","green-square","kanji"],"k":[5,7],"o":2},"scissors":{"a":"Black Scissors","b":"2702-FE0F","c":"2702","d":true,"e":true,"f":true,"h":true,"j":["stationery","cut"],"k":[54,39],"o":2},"flag-my":{"a":"Malaysia Flag","b":"1F1F2-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,23],"o":2},"ideograph_advantage":{"a":"Circled Ideograph Advantage","b":"1F250","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","obtain","get","circle"],"k":[5,17],"o":2},"man_in_tuxedo":{"skin_variations":{"1F3FB":{"unified":"1F935-1F3FB","non_qualified":null,"image":"1f935-1f3fb.png","sheet_x":39,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F935-1F3FC","non_qualified":null,"image":"1f935-1f3fc.png","sheet_x":39,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F935-1F3FD","non_qualified":null,"image":"1f935-1f3fd.png","sheet_x":39,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F935-1F3FE","non_qualified":null,"image":"1f935-1f3fe.png","sheet_x":39,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F935-1F3FF","non_qualified":null,"image":"1f935-1f3ff.png","sheet_x":39,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Tuxedo","b":"1F935","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","groom"],"k":[39,23],"o":4},"flag-mz":{"a":"Mozambique Flag","b":"1F1F2-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,24],"o":2},"card_file_box":{"a":"Card File Box","b":"1F5C3-FE0F","c":"1F5C3","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[30,16],"o":2},"crescent_moon":{"a":"Crescent Moon","b":"1F319","d":true,"e":true,"f":true,"h":true,"j":["night","sleep","sky","evening","magic"],"k":[5,44],"o":2},"flag-na":{"a":"Namibia Flag","b":"1F1F3-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,25],"o":2},"bride_with_veil":{"skin_variations":{"1F3FB":{"unified":"1F470-1F3FB","non_qualified":null,"image":"1f470-1f3fb.png","sheet_x":22,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F470-1F3FC","non_qualified":null,"image":"1f470-1f3fc.png","sheet_x":22,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F470-1F3FD","non_qualified":null,"image":"1f470-1f3fd.png","sheet_x":22,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F470-1F3FE","non_qualified":null,"image":"1f470-1f3fe.png","sheet_x":22,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F470-1F3FF","non_qualified":null,"image":"1f470-1f3ff.png","sheet_x":22,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bride with Veil","b":"1F470","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","woman","bride"],"k":[22,1],"o":2},"new_moon_with_face":{"a":"New Moon with Face","b":"1F31A","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,45],"o":2},"file_cabinet":{"a":"File Cabinet","b":"1F5C4-FE0F","c":"1F5C4","d":true,"e":true,"f":true,"h":true,"j":["filing","organizing"],"k":[30,17],"o":2},"u5272":{"a":"Squared Cjk Unified Ideograph-5272","b":"1F239","d":true,"e":true,"f":true,"h":true,"j":["cut","divide","chinese","kanji","pink-square"],"k":[5,15],"o":2},"wastebasket":{"a":"Wastebasket","b":"1F5D1-FE0F","c":"1F5D1","d":true,"e":true,"f":true,"h":true,"j":["bin","trash","rubbish","garbage","toss"],"k":[30,18],"o":2},"pregnant_woman":{"skin_variations":{"1F3FB":{"unified":"1F930-1F3FB","non_qualified":null,"image":"1f930-1f3fb.png","sheet_x":38,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F930-1F3FC","non_qualified":null,"image":"1f930-1f3fc.png","sheet_x":38,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F930-1F3FD","non_qualified":null,"image":"1f930-1f3fd.png","sheet_x":38,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F930-1F3FE","non_qualified":null,"image":"1f930-1f3fe.png","sheet_x":38,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F930-1F3FF","non_qualified":null,"image":"1f930-1f3ff.png","sheet_x":38,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pregnant Woman","b":"1F930","d":true,"e":true,"f":true,"h":true,"j":["baby"],"k":[38,50],"o":4},"first_quarter_moon_with_face":{"a":"First Quarter Moon with Face","b":"1F31B","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,46],"o":2},"flag-nc":{"a":"New Caledonia Flag","b":"1F1F3-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,26],"o":2},"u7121":{"a":"Squared Cjk Unified Ideograph-7121","b":"1F21A","d":true,"e":true,"f":true,"h":true,"j":["nothing","chinese","kanji","japanese","orange-square"],"k":[5,6],"o":2},"lock":{"a":"Lock","b":"1F512","d":true,"e":true,"f":true,"h":true,"j":["security","password","padlock"],"k":[27,46],"o":2},"flag-ne":{"a":"Niger Flag","b":"1F1F3-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,27],"o":2},"last_quarter_moon_with_face":{"a":"Last Quarter Moon with Face","b":"1F31C","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,47],"o":2},"breast-feeding":{"skin_variations":{"1F3FB":{"unified":"1F931-1F3FB","non_qualified":null,"image":"1f931-1f3fb.png","sheet_x":39,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F931-1F3FC","non_qualified":null,"image":"1f931-1f3fc.png","sheet_x":39,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F931-1F3FD","non_qualified":null,"image":"1f931-1f3fd.png","sheet_x":39,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F931-1F3FE","non_qualified":null,"image":"1f931-1f3fe.png","sheet_x":39,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F931-1F3FF","non_qualified":null,"image":"1f931-1f3ff.png","sheet_x":39,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Breast-Feeding","b":"1F931","d":true,"e":true,"f":true,"h":true,"k":[38,56],"o":5},"u7981":{"a":"Squared Cjk Unified Ideograph-7981","b":"1F232","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","forbidden","limit","restricted","red-square"],"k":[5,8],"o":2},"accept":{"a":"Circled Ideograph Accept","b":"1F251","d":true,"e":true,"f":true,"h":true,"j":["ok","good","chinese","kanji","agree","yes","orange-circle"],"k":[5,18],"o":2},"angel":{"skin_variations":{"1F3FB":{"unified":"1F47C-1F3FB","non_qualified":null,"image":"1f47c-1f3fb.png","sheet_x":23,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F47C-1F3FC","non_qualified":null,"image":"1f47c-1f3fc.png","sheet_x":23,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F47C-1F3FD","non_qualified":null,"image":"1f47c-1f3fd.png","sheet_x":23,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F47C-1F3FE","non_qualified":null,"image":"1f47c-1f3fe.png","sheet_x":23,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F47C-1F3FF","non_qualified":null,"image":"1f47c-1f3ff.png","sheet_x":23,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby Angel","b":"1F47C","d":true,"e":true,"f":true,"h":true,"j":["heaven","wings","halo"],"k":[23,37],"o":2},"unlock":{"a":"Open Lock","b":"1F513","d":true,"e":true,"f":true,"h":true,"j":["privacy","security"],"k":[27,47],"o":2},"flag-nf":{"a":"Norfolk Island Flag","b":"1F1F3-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,28],"o":2},"thermometer":{"a":"Thermometer","b":"1F321-FE0F","c":"1F321","d":true,"e":true,"f":true,"h":true,"j":["weather","temperature","hot","cold"],"k":[5,52],"o":2},"flag-ng":{"a":"Nigeria Flag","b":"1F1F3-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,29],"o":2},"u7533":{"a":"Squared Cjk Unified Ideograph-7533","b":"1F238","d":true,"e":true,"f":true,"h":true,"j":["chinese","japanese","kanji","orange-square"],"k":[5,14],"o":2},"sunny":{"a":"Black Sun with Rays","b":"2600-FE0F","c":"2600","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","brightness","summer","beach","spring"],"k":[52,49],"o":2},"lock_with_ink_pen":{"a":"Lock with Ink Pen","b":"1F50F","d":true,"e":true,"f":true,"h":true,"j":["security","secret"],"k":[27,43],"o":2},"santa":{"skin_variations":{"1F3FB":{"unified":"1F385-1F3FB","non_qualified":null,"image":"1f385-1f3fb.png","sheet_x":7,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F385-1F3FC","non_qualified":null,"image":"1f385-1f3fc.png","sheet_x":7,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F385-1F3FD","non_qualified":null,"image":"1f385-1f3fd.png","sheet_x":7,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F385-1F3FE","non_qualified":null,"image":"1f385-1f3fe.png","sheet_x":7,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F385-1F3FF","non_qualified":null,"image":"1f385-1f3ff.png","sheet_x":7,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Father Christmas","b":"1F385","d":true,"e":true,"f":true,"h":true,"j":["festival","man","male","xmas","father christmas"],"k":[7,36],"o":2},"closed_lock_with_key":{"a":"Closed Lock with Key","b":"1F510","d":true,"e":true,"f":true,"h":true,"j":["security","privacy"],"k":[27,44],"o":2},"u5408":{"a":"Squared Cjk Unified Ideograph-5408","b":"1F234","d":true,"e":true,"f":true,"h":true,"j":["japanese","chinese","join","kanji","red-square"],"k":[5,10],"o":2},"flag-ni":{"a":"Nicaragua Flag","b":"1F1F3-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[3,30],"o":2},"mrs_claus":{"skin_variations":{"1F3FB":{"unified":"1F936-1F3FB","non_qualified":null,"image":"1f936-1f3fb.png","sheet_x":39,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F936-1F3FC","non_qualified":null,"image":"1f936-1f3fc.png","sheet_x":39,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F936-1F3FD","non_qualified":null,"image":"1f936-1f3fd.png","sheet_x":39,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F936-1F3FE","non_qualified":null,"image":"1f936-1f3fe.png","sheet_x":39,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F936-1F3FF","non_qualified":null,"image":"1f936-1f3ff.png","sheet_x":39,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mother Christmas","b":"1F936","d":true,"e":true,"f":true,"h":true,"j":["woman","female","xmas","mother christmas"],"k":[39,29],"n":["mother_christmas"],"o":4},"full_moon_with_face":{"a":"Full Moon with Face","b":"1F31D","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,48],"o":2},"key":{"a":"Key","b":"1F511","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[27,45],"o":2},"superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB","non_qualified":null,"image":"1f9b8-1f3fb.png","sheet_x":43,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC","non_qualified":null,"image":"1f9b8-1f3fc.png","sheet_x":43,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD","non_qualified":null,"image":"1f9b8-1f3fd.png","sheet_x":43,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE","non_qualified":null,"image":"1f9b8-1f3fe.png","sheet_x":43,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF","non_qualified":null,"image":"1f9b8-1f3ff.png","sheet_x":43,"sheet_y":35,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Superhero","b":"1F9B8","d":true,"e":true,"f":true,"h":true,"k":[43,30],"o":11},"flag-nl":{"a":"Netherlands Flag","b":"1F1F3-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,31],"o":2},"u7a7a":{"a":"Squared Cjk Unified Ideograph-7a7a","b":"1F233","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","empty","sky","blue-square"],"k":[5,9],"o":2},"sun_with_face":{"a":"Sun with Face","b":"1F31E","d":true,"e":true,"f":true,"h":true,"j":["nature","morning","sky"],"k":[5,49],"o":2},"male_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2642-FE0F","non_qualified":"1F9B8-1F3FB-200D-2642","image":"1f9b8-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2642-FE0F","non_qualified":"1F9B8-1F3FC-200D-2642","image":"1f9b8-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2642-FE0F","non_qualified":"1F9B8-1F3FD-200D-2642","image":"1f9b8-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2642-FE0F","non_qualified":"1F9B8-1F3FE-200D-2642","image":"1f9b8-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2642-FE0F","non_qualified":"1F9B8-1F3FF-200D-2642","image":"1f9b8-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Superhero","b":"1F9B8-200D-2642-FE0F","c":"1F9B8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,24],"o":11},"ringed_planet":{"a":"Ringed Planet","b":"1FA90","d":true,"e":true,"f":true,"h":true,"k":[52,4],"o":12},"old_key":{"a":"Old Key","b":"1F5DD-FE0F","c":"1F5DD","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[30,22],"o":2},"congratulations":{"a":"Circled Ideograph Congratulation","b":"3297-FE0F","c":"3297","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","japanese","red-circle"],"k":[55,46],"o":2},"flag-no":{"a":"Norway Flag","b":"1F1F3-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,32],"o":2},"star":{"a":"White Medium Star","b":"2B50","d":true,"e":true,"f":true,"h":true,"j":["night","yellow"],"k":[55,42],"o":2},"secret":{"a":"Circled Ideograph Secret","b":"3299-FE0F","c":"3299","d":true,"e":true,"f":true,"h":true,"j":["privacy","chinese","sshh","kanji","red-circle"],"k":[55,47],"o":2},"flag-np":{"a":"Nepal Flag","b":"1F1F3-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,33],"o":2},"female_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2640-FE0F","non_qualified":"1F9B8-1F3FB-200D-2640","image":"1f9b8-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2640-FE0F","non_qualified":"1F9B8-1F3FC-200D-2640","image":"1f9b8-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":20,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2640-FE0F","non_qualified":"1F9B8-1F3FD-200D-2640","image":"1f9b8-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2640-FE0F","non_qualified":"1F9B8-1F3FE-200D-2640","image":"1f9b8-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2640-FE0F","non_qualified":"1F9B8-1F3FF-200D-2640","image":"1f9b8-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Superhero","b":"1F9B8-200D-2640-FE0F","c":"1F9B8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,18],"o":11},"hammer":{"a":"Hammer","b":"1F528","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[28,11],"o":2},"star2":{"a":"Glowing Star","b":"1F31F","d":true,"e":true,"f":true,"h":true,"j":["night","sparkle","awesome","good","magic"],"k":[5,50],"o":2},"flag-nr":{"a":"Nauru Flag","b":"1F1F3-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,34],"o":2},"axe":{"a":"Axe","b":"1FA93","d":true,"e":true,"f":true,"h":true,"k":[52,7],"o":12},"u55b6":{"a":"Squared Cjk Unified Ideograph-55b6","b":"1F23A","d":true,"e":true,"f":true,"h":true,"j":["japanese","opening hours","orange-square"],"k":[5,16],"o":2},"supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB","non_qualified":null,"image":"1f9b9-1f3fb.png","sheet_x":43,"sheet_y":49,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC","non_qualified":null,"image":"1f9b9-1f3fc.png","sheet_x":43,"sheet_y":50,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD","non_qualified":null,"image":"1f9b9-1f3fd.png","sheet_x":43,"sheet_y":51,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE","non_qualified":null,"image":"1f9b9-1f3fe.png","sheet_x":43,"sheet_y":52,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF","non_qualified":null,"image":"1f9b9-1f3ff.png","sheet_x":43,"sheet_y":53,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Supervillain","b":"1F9B9","d":true,"e":true,"f":true,"h":true,"k":[43,48],"o":11},"stars":{"a":"Shooting Star","b":"1F320","d":true,"e":true,"f":true,"h":true,"j":["night","photo"],"k":[5,51],"o":2},"u6e80":{"a":"Squared Cjk Unified Ideograph-6e80","b":"1F235","d":true,"e":true,"f":true,"h":true,"j":["full","chinese","japanese","red-square","kanji"],"k":[5,11],"o":2},"flag-nu":{"a":"Niue Flag","b":"1F1F3-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,35],"o":2},"pick":{"a":"Pick","b":"26CF-FE0F","c":"26CF","d":true,"e":true,"f":true,"h":true,"j":["tools","dig"],"k":[54,5],"o":2},"male_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2642-FE0F","non_qualified":"1F9B9-1F3FB-200D-2642","image":"1f9b9-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2642-FE0F","non_qualified":"1F9B9-1F3FC-200D-2642","image":"1f9b9-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2642-FE0F","non_qualified":"1F9B9-1F3FD-200D-2642","image":"1f9b9-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2642-FE0F","non_qualified":"1F9B9-1F3FE-200D-2642","image":"1f9b9-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2642-FE0F","non_qualified":"1F9B9-1F3FF-200D-2642","image":"1f9b9-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":47,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Supervillain","b":"1F9B9-200D-2642-FE0F","c":"1F9B9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,42],"o":11},"female_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2640-FE0F","non_qualified":"1F9B9-1F3FB-200D-2640","image":"1f9b9-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2640-FE0F","non_qualified":"1F9B9-1F3FC-200D-2640","image":"1f9b9-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2640-FE0F","non_qualified":"1F9B9-1F3FD-200D-2640","image":"1f9b9-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2640-FE0F","non_qualified":"1F9B9-1F3FE-200D-2640","image":"1f9b9-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2640-FE0F","non_qualified":"1F9B9-1F3FF-200D-2640","image":"1f9b9-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":41,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Supervillain","b":"1F9B9-200D-2640-FE0F","c":"1F9B9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,36],"o":11},"hammer_and_pick":{"a":"Hammer and Pick","b":"2692-FE0F","c":"2692","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[53,41],"o":2},"milky_way":{"a":"Milky Way","b":"1F30C","d":true,"e":true,"f":true,"h":true,"j":["photo","space","stars"],"k":[5,31],"o":2},"red_circle":{"a":"Large Red Circle","b":"1F534","d":true,"e":true,"f":true,"h":true,"j":["shape","error","danger"],"k":[28,23],"o":2},"flag-nz":{"a":"New Zealand Flag","b":"1F1F3-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,36],"o":2},"large_orange_circle":{"a":"Large Orange Circle","b":"1F7E0","d":true,"e":true,"f":true,"h":true,"k":[37,3],"o":12},"hammer_and_wrench":{"a":"Hammer and Wrench","b":"1F6E0-FE0F","c":"1F6E0","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[36,42],"o":2},"flag-om":{"a":"Oman Flag","b":"1F1F4-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,37],"o":2},"cloud":{"a":"Cloud","b":"2601-FE0F","c":"2601","d":true,"e":true,"f":true,"h":true,"j":["weather","sky"],"k":[52,50],"o":2},"mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB","non_qualified":null,"image":"1f9d9-1f3fb.png","sheet_x":49,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D9-1F3FC","non_qualified":null,"image":"1f9d9-1f3fc.png","sheet_x":49,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D9-1F3FD","non_qualified":null,"image":"1f9d9-1f3fd.png","sheet_x":49,"sheet_y":52,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D9-1F3FE","non_qualified":null,"image":"1f9d9-1f3fe.png","sheet_x":49,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D9-1F3FF","non_qualified":null,"image":"1f9d9-1f3ff.png","sheet_x":49,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D9-200D-2640-FE0F","a":"Mage","b":"1F9D9","d":true,"e":true,"f":true,"h":true,"k":[49,49],"o":5},"dagger_knife":{"a":"Dagger Knife","b":"1F5E1-FE0F","c":"1F5E1","d":true,"e":true,"f":true,"h":true,"k":[30,24],"o":2},"partly_sunny":{"a":"Sun Behind Cloud","b":"26C5","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","cloudy","morning","fall","spring"],"k":[54,2],"o":2},"large_yellow_circle":{"a":"Large Yellow Circle","b":"1F7E1","d":true,"e":true,"f":true,"h":true,"k":[37,4],"o":12},"male_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2642-FE0F","non_qualified":"1F9D9-1F3FB-200D-2642","image":"1f9d9-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2642-FE0F","non_qualified":"1F9D9-1F3FC-200D-2642","image":"1f9d9-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2642-FE0F","non_qualified":"1F9D9-1F3FD-200D-2642","image":"1f9d9-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":46,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2642-FE0F","non_qualified":"1F9D9-1F3FE-200D-2642","image":"1f9d9-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2642-FE0F","non_qualified":"1F9D9-1F3FF-200D-2642","image":"1f9d9-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mage","b":"1F9D9-200D-2642-FE0F","c":"1F9D9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,43],"o":5},"flag-pa":{"a":"Panama Flag","b":"1F1F5-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,38],"o":2},"thunder_cloud_and_rain":{"a":"Thunder Cloud and Rain","b":"26C8-FE0F","c":"26C8","d":true,"e":true,"f":true,"h":true,"k":[54,3],"o":2},"large_green_circle":{"a":"Large Green Circle","b":"1F7E2","d":true,"e":true,"f":true,"h":true,"k":[37,5],"o":12},"female_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2640-FE0F","non_qualified":"1F9D9-1F3FB-200D-2640","image":"1f9d9-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FB"},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2640-FE0F","non_qualified":"1F9D9-1F3FC-200D-2640","image":"1f9d9-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FC"},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2640-FE0F","non_qualified":"1F9D9-1F3FD-200D-2640","image":"1f9d9-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":40,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FD"},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2640-FE0F","non_qualified":"1F9D9-1F3FE-200D-2640","image":"1f9d9-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FE"},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2640-FE0F","non_qualified":"1F9D9-1F3FF-200D-2640","image":"1f9d9-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FF"}},"obsoletes":"1F9D9","a":"Female Mage","b":"1F9D9-200D-2640-FE0F","c":"1F9D9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,37],"o":5},"crossed_swords":{"a":"Crossed Swords","b":"2694-FE0F","c":"2694","d":true,"e":true,"f":true,"h":true,"j":["weapon"],"k":[53,43],"o":2},"flag-pe":{"a":"Peru Flag","b":"1F1F5-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,39],"o":2},"gun":{"a":"Pistol","b":"1F52B","d":true,"e":true,"f":true,"h":true,"j":["violence","weapon","pistol","revolver"],"k":[28,14],"o":2},"mostly_sunny":{"a":"Mostly Sunny","b":"1F324-FE0F","c":"1F324","d":true,"e":true,"f":true,"h":true,"k":[5,53],"n":["sun_small_cloud"],"o":2},"fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB","non_qualified":null,"image":"1f9da-1f3fb.png","sheet_x":50,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DA-1F3FC","non_qualified":null,"image":"1f9da-1f3fc.png","sheet_x":50,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DA-1F3FD","non_qualified":null,"image":"1f9da-1f3fd.png","sheet_x":50,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DA-1F3FE","non_qualified":null,"image":"1f9da-1f3fe.png","sheet_x":50,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DA-1F3FF","non_qualified":null,"image":"1f9da-1f3ff.png","sheet_x":50,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DA-200D-2640-FE0F","a":"Fairy","b":"1F9DA","d":true,"e":true,"f":true,"h":true,"k":[50,10],"o":5},"flag-pf":{"a":"French Polynesia Flag","b":"1F1F5-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,40],"o":2},"large_blue_circle":{"a":"Large Blue Circle","b":"1F535","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[28,24],"o":2},"large_purple_circle":{"a":"Large Purple Circle","b":"1F7E3","d":true,"e":true,"f":true,"h":true,"k":[37,6],"o":12},"bow_and_arrow":{"a":"Bow and Arrow","b":"1F3F9","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[11,21],"o":2},"male_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2642-FE0F","non_qualified":"1F9DA-1F3FB-200D-2642","image":"1f9da-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2642-FE0F","non_qualified":"1F9DA-1F3FC-200D-2642","image":"1f9da-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2642-FE0F","non_qualified":"1F9DA-1F3FD-200D-2642","image":"1f9da-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2642-FE0F","non_qualified":"1F9DA-1F3FE-200D-2642","image":"1f9da-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2642-FE0F","non_qualified":"1F9DA-1F3FF-200D-2642","image":"1f9da-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Male Fairy","b":"1F9DA-200D-2642-FE0F","c":"1F9DA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,4],"o":5},"barely_sunny":{"a":"Barely Sunny","b":"1F325-FE0F","c":"1F325","d":true,"e":true,"f":true,"h":true,"k":[5,54],"n":["sun_behind_cloud"],"o":2},"flag-pg":{"a":"Papua New Guinea Flag","b":"1F1F5-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,41],"o":2},"shield":{"a":"Shield","b":"1F6E1-FE0F","c":"1F6E1","d":true,"e":true,"f":true,"h":true,"j":["protection","security"],"k":[36,43],"o":2},"partly_sunny_rain":{"a":"Partly Sunny Rain","b":"1F326-FE0F","c":"1F326","d":true,"e":true,"f":true,"h":true,"k":[5,55],"n":["sun_behind_rain_cloud"],"o":2},"large_brown_circle":{"a":"Large Brown Circle","b":"1F7E4","d":true,"e":true,"f":true,"h":true,"k":[37,7],"o":12},"female_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2640-FE0F","non_qualified":"1F9DA-1F3FB-200D-2640","image":"1f9da-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FB"},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2640-FE0F","non_qualified":"1F9DA-1F3FC-200D-2640","image":"1f9da-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FC"},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2640-FE0F","non_qualified":"1F9DA-1F3FD-200D-2640","image":"1f9da-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FD"},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2640-FE0F","non_qualified":"1F9DA-1F3FE-200D-2640","image":"1f9da-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FE"},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2640-FE0F","non_qualified":"1F9DA-1F3FF-200D-2640","image":"1f9da-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FF"}},"obsoletes":"1F9DA","a":"Female Fairy","b":"1F9DA-200D-2640-FE0F","c":"1F9DA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,55],"o":5},"flag-ph":{"a":"Philippines Flag","b":"1F1F5-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,42],"o":2},"flag-pk":{"a":"Pakistan Flag","b":"1F1F5-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,43],"o":2},"black_circle":{"a":"Medium Black Circle","b":"26AB","d":true,"e":true,"f":true,"h":true,"j":["shape","button","round"],"k":[53,53],"o":2},"wrench":{"a":"Wrench","b":"1F527","d":true,"e":true,"f":true,"h":true,"j":["tools","diy","ikea","fix","maintainer"],"k":[28,10],"o":2},"vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB","non_qualified":null,"image":"1f9db-1f3fb.png","sheet_x":50,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DB-1F3FC","non_qualified":null,"image":"1f9db-1f3fc.png","sheet_x":50,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DB-1F3FD","non_qualified":null,"image":"1f9db-1f3fd.png","sheet_x":50,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DB-1F3FE","non_qualified":null,"image":"1f9db-1f3fe.png","sheet_x":50,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DB-1F3FF","non_qualified":null,"image":"1f9db-1f3ff.png","sheet_x":50,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DB-200D-2640-FE0F","a":"Vampire","b":"1F9DB","d":true,"e":true,"f":true,"h":true,"k":[50,28],"o":5},"rain_cloud":{"a":"Rain Cloud","b":"1F327-FE0F","c":"1F327","d":true,"e":true,"f":true,"h":true,"k":[5,56],"o":2},"snow_cloud":{"a":"Snow Cloud","b":"1F328-FE0F","c":"1F328","d":true,"e":true,"f":true,"h":true,"k":[6,0],"o":2},"flag-pl":{"a":"Poland Flag","b":"1F1F5-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,44],"o":2},"male_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2642-FE0F","non_qualified":"1F9DB-1F3FB-200D-2642","image":"1f9db-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2642-FE0F","non_qualified":"1F9DB-1F3FC-200D-2642","image":"1f9db-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2642-FE0F","non_qualified":"1F9DB-1F3FD-200D-2642","image":"1f9db-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2642-FE0F","non_qualified":"1F9DB-1F3FE-200D-2642","image":"1f9db-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2642-FE0F","non_qualified":"1F9DB-1F3FF-200D-2642","image":"1f9db-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Vampire","b":"1F9DB-200D-2642-FE0F","c":"1F9DB-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,22],"o":5},"nut_and_bolt":{"a":"Nut and Bolt","b":"1F529","d":true,"e":true,"f":true,"h":true,"j":["handy","tools","fix"],"k":[28,12],"o":2},"white_circle":{"a":"Medium White Circle","b":"26AA","d":true,"e":true,"f":true,"h":true,"j":["shape","round"],"k":[53,52],"o":2},"female_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2640-FE0F","non_qualified":"1F9DB-1F3FB-200D-2640","image":"1f9db-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FB"},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2640-FE0F","non_qualified":"1F9DB-1F3FC-200D-2640","image":"1f9db-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FC"},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2640-FE0F","non_qualified":"1F9DB-1F3FD-200D-2640","image":"1f9db-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FD"},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2640-FE0F","non_qualified":"1F9DB-1F3FE-200D-2640","image":"1f9db-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FE"},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2640-FE0F","non_qualified":"1F9DB-1F3FF-200D-2640","image":"1f9db-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FF"}},"obsoletes":"1F9DB","a":"Female Vampire","b":"1F9DB-200D-2640-FE0F","c":"1F9DB-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,16],"o":5},"flag-pm":{"a":"St. Pierre & Miquelon Flag","b":"1F1F5-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,45],"o":2},"large_red_square":{"a":"Large Red Square","b":"1F7E5","d":true,"e":true,"f":true,"h":true,"k":[37,8],"o":12},"lightning":{"a":"Lightning","b":"1F329-FE0F","c":"1F329","d":true,"e":true,"f":true,"h":true,"k":[6,1],"n":["lightning_cloud"],"o":2},"gear":{"a":"Gear","b":"2699-FE0F","c":"2699","d":true,"e":true,"f":true,"h":true,"j":["cog"],"k":[53,47],"o":2},"merperson":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB","non_qualified":null,"image":"1f9dc-1f3fb.png","sheet_x":50,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DC-1F3FC","non_qualified":null,"image":"1f9dc-1f3fc.png","sheet_x":50,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DC-1F3FD","non_qualified":null,"image":"1f9dc-1f3fd.png","sheet_x":50,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DC-1F3FE","non_qualified":null,"image":"1f9dc-1f3fe.png","sheet_x":50,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DC-1F3FF","non_qualified":null,"image":"1f9dc-1f3ff.png","sheet_x":50,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DC-200D-2642-FE0F","a":"Merperson","b":"1F9DC","d":true,"e":true,"f":true,"h":true,"k":[50,46],"o":5},"tornado":{"a":"Tornado","b":"1F32A-FE0F","c":"1F32A","d":true,"e":true,"f":true,"h":true,"j":["weather","cyclone","twister"],"k":[6,2],"n":["tornado_cloud"],"o":2},"large_orange_square":{"a":"Large Orange Square","b":"1F7E7","d":true,"e":true,"f":true,"h":true,"k":[37,10],"o":12},"flag-pn":{"a":"Pitcairn Islands Flag","b":"1F1F5-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,46],"o":2},"compression":{"a":"Compression","b":"1F5DC-FE0F","c":"1F5DC","d":true,"e":true,"f":true,"h":true,"k":[30,21],"o":2},"merman":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2642-FE0F","non_qualified":"1F9DC-1F3FB-200D-2642","image":"1f9dc-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FB"},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2642-FE0F","non_qualified":"1F9DC-1F3FC-200D-2642","image":"1f9dc-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FC"},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2642-FE0F","non_qualified":"1F9DC-1F3FD-200D-2642","image":"1f9dc-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FD"},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2642-FE0F","non_qualified":"1F9DC-1F3FE-200D-2642","image":"1f9dc-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FE"},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2642-FE0F","non_qualified":"1F9DC-1F3FF-200D-2642","image":"1f9dc-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FF"}},"obsoletes":"1F9DC","a":"Merman","b":"1F9DC-200D-2642-FE0F","c":"1F9DC-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,40],"o":5},"large_yellow_square":{"a":"Large Yellow Square","b":"1F7E8","d":true,"e":true,"f":true,"h":true,"k":[37,11],"o":12},"fog":{"a":"Fog","b":"1F32B-FE0F","c":"1F32B","d":true,"e":true,"f":true,"h":true,"j":["weather"],"k":[6,3],"o":2},"scales":{"a":"Scales","b":"2696-FE0F","c":"2696","d":true,"e":true,"f":true,"h":true,"k":[53,45],"o":2},"flag-pr":{"a":"Puerto Rico Flag","b":"1F1F5-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,47],"o":2},"wind_blowing_face":{"a":"Wind Blowing Face","b":"1F32C-FE0F","c":"1F32C","d":true,"e":true,"f":true,"h":true,"k":[6,4],"o":2},"flag-ps":{"a":"Palestinian Territories Flag","b":"1F1F5-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,48],"o":2},"mermaid":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2640-FE0F","non_qualified":"1F9DC-1F3FB-200D-2640","image":"1f9dc-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2640-FE0F","non_qualified":"1F9DC-1F3FC-200D-2640","image":"1f9dc-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2640-FE0F","non_qualified":"1F9DC-1F3FD-200D-2640","image":"1f9dc-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2640-FE0F","non_qualified":"1F9DC-1F3FE-200D-2640","image":"1f9dc-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2640-FE0F","non_qualified":"1F9DC-1F3FF-200D-2640","image":"1f9dc-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mermaid","b":"1F9DC-200D-2640-FE0F","c":"1F9DC-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,34],"o":5},"probing_cane":{"a":"Probing Cane","b":"1F9AF","d":true,"e":true,"f":true,"h":true,"k":[43,3],"o":12},"large_green_square":{"a":"Large Green Square","b":"1F7E9","d":true,"e":true,"f":true,"h":true,"k":[37,12],"o":12},"flag-pt":{"a":"Portugal Flag","b":"1F1F5-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,49],"o":2},"link":{"a":"Link Symbol","b":"1F517","d":true,"e":true,"f":true,"h":true,"j":["rings","url"],"k":[27,51],"o":2},"large_blue_square":{"a":"Large Blue Square","b":"1F7E6","d":true,"e":true,"f":true,"h":true,"k":[37,9],"o":12},"elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB","non_qualified":null,"image":"1f9dd-1f3fb.png","sheet_x":51,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DD-1F3FC","non_qualified":null,"image":"1f9dd-1f3fc.png","sheet_x":51,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DD-1F3FD","non_qualified":null,"image":"1f9dd-1f3fd.png","sheet_x":51,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DD-1F3FE","non_qualified":null,"image":"1f9dd-1f3fe.png","sheet_x":51,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DD-1F3FF","non_qualified":null,"image":"1f9dd-1f3ff.png","sheet_x":51,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DD-200D-2642-FE0F","a":"Elf","b":"1F9DD","d":true,"e":true,"f":true,"h":true,"k":[51,7],"o":5},"cyclone":{"a":"Cyclone","b":"1F300","d":true,"e":true,"f":true,"h":true,"j":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"k":[5,19],"o":2},"rainbow":{"a":"Rainbow","b":"1F308","d":true,"e":true,"f":true,"h":true,"j":["nature","happy","unicorn_face","photo","sky","spring"],"k":[5,27],"o":2},"male_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2642-FE0F","non_qualified":"1F9DD-1F3FB-200D-2642","image":"1f9dd-1f3fb-200d-2642-fe0f.png","sheet_x":51,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FB"},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2642-FE0F","non_qualified":"1F9DD-1F3FC-200D-2642","image":"1f9dd-1f3fc-200d-2642-fe0f.png","sheet_x":51,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FC"},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2642-FE0F","non_qualified":"1F9DD-1F3FD-200D-2642","image":"1f9dd-1f3fd-200d-2642-fe0f.png","sheet_x":51,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FD"},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2642-FE0F","non_qualified":"1F9DD-1F3FE-200D-2642","image":"1f9dd-1f3fe-200d-2642-fe0f.png","sheet_x":51,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FE"},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2642-FE0F","non_qualified":"1F9DD-1F3FF-200D-2642","image":"1f9dd-1f3ff-200d-2642-fe0f.png","sheet_x":51,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FF"}},"obsoletes":"1F9DD","a":"Male Elf","b":"1F9DD-200D-2642-FE0F","c":"1F9DD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,1],"o":5},"flag-pw":{"a":"Palau Flag","b":"1F1F5-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,50],"o":2},"chains":{"a":"Chains","b":"26D3-FE0F","c":"26D3","d":true,"e":true,"f":true,"h":true,"j":["lock","arrest"],"k":[54,7],"o":2},"large_purple_square":{"a":"Large Purple Square","b":"1F7EA","d":true,"e":true,"f":true,"h":true,"k":[37,13],"o":12},"female_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2640-FE0F","non_qualified":"1F9DD-1F3FB-200D-2640","image":"1f9dd-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2640-FE0F","non_qualified":"1F9DD-1F3FC-200D-2640","image":"1f9dd-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2640-FE0F","non_qualified":"1F9DD-1F3FD-200D-2640","image":"1f9dd-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2640-FE0F","non_qualified":"1F9DD-1F3FE-200D-2640","image":"1f9dd-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2640-FE0F","non_qualified":"1F9DD-1F3FF-200D-2640","image":"1f9dd-1f3ff-200d-2640-fe0f.png","sheet_x":51,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Elf","b":"1F9DD-200D-2640-FE0F","c":"1F9DD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,52],"o":5},"flag-py":{"a":"Paraguay Flag","b":"1F1F5-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,51],"o":2},"closed_umbrella":{"a":"Closed Umbrella","b":"1F302","d":true,"e":true,"f":true,"h":true,"j":["weather","rain","drizzle"],"k":[5,21],"o":2},"toolbox":{"a":"Toolbox","b":"1F9F0","d":true,"e":true,"f":true,"h":true,"k":[51,35],"o":11},"large_brown_square":{"a":"Large Brown Square","b":"1F7EB","d":true,"e":true,"f":true,"h":true,"k":[37,14],"o":12},"magnet":{"a":"Magnet","b":"1F9F2","d":true,"e":true,"f":true,"h":true,"k":[51,37],"o":11},"genie":{"obsoleted_by":"1F9DE-200D-2642-FE0F","a":"Genie","b":"1F9DE","d":true,"e":true,"f":true,"h":true,"k":[51,15],"o":5},"flag-qa":{"a":"Qatar Flag","b":"1F1F6-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,52],"o":2},"umbrella":{"a":"Umbrella","b":"2602-FE0F","c":"2602","d":true,"e":true,"f":true,"h":true,"j":["rainy","weather","spring"],"k":[52,51],"o":2},"black_large_square":{"a":"Black Large Square","b":"2B1B","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[55,40],"o":2},"male_genie":{"obsoletes":"1F9DE","a":"Male Genie","b":"1F9DE-200D-2642-FE0F","c":"1F9DE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,14],"o":5},"umbrella_with_rain_drops":{"a":"Umbrella with Rain Drops","b":"2614","d":true,"e":true,"f":true,"h":true,"k":[52,56],"o":2},"flag-re":{"a":"Réunion Flag","b":"1F1F7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,53],"o":2},"white_large_square":{"a":"White Large Square","b":"2B1C","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","stone","button"],"k":[55,41],"o":2},"alembic":{"a":"Alembic","b":"2697-FE0F","c":"2697","d":true,"e":true,"f":true,"h":true,"j":["distilling","science","experiment","chemistry"],"k":[53,46],"o":2},"black_medium_square":{"a":"Black Medium Square","b":"25FC-FE0F","c":"25FC","d":true,"e":true,"f":true,"h":true,"j":["shape","button","icon"],"k":[52,46],"o":2},"test_tube":{"a":"Test Tube","b":"1F9EA","d":true,"e":true,"f":true,"h":true,"k":[51,29],"o":11},"flag-ro":{"a":"Romania Flag","b":"1F1F7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,54],"o":2},"female_genie":{"a":"Female Genie","b":"1F9DE-200D-2640-FE0F","c":"1F9DE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,13],"o":5},"umbrella_on_ground":{"a":"Umbrella on Ground","b":"26F1-FE0F","c":"26F1","d":true,"e":true,"f":true,"h":true,"k":[54,12],"o":2},"zombie":{"obsoleted_by":"1F9DF-200D-2642-FE0F","a":"Zombie","b":"1F9DF","d":true,"e":true,"f":true,"h":true,"k":[51,18],"o":5},"zap":{"a":"High Voltage Sign","b":"26A1","d":true,"e":true,"f":true,"h":true,"j":["thunder","weather","lightning bolt","fast"],"k":[53,51],"o":2},"white_medium_square":{"a":"White Medium Square","b":"25FB-FE0F","c":"25FB","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon"],"k":[52,45],"o":2},"flag-rs":{"a":"Serbia Flag","b":"1F1F7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,55],"o":2},"petri_dish":{"a":"Petri Dish","b":"1F9EB","d":true,"e":true,"f":true,"h":true,"k":[51,30],"o":11},"snowflake":{"a":"Snowflake","b":"2744-FE0F","c":"2744","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas"],"k":[55,19],"o":2},"dna":{"a":"Dna Double Helix","b":"1F9EC","d":true,"e":true,"f":true,"h":true,"k":[51,31],"o":11},"male_zombie":{"obsoletes":"1F9DF","a":"Male Zombie","b":"1F9DF-200D-2642-FE0F","c":"1F9DF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,17],"o":5},"black_medium_small_square":{"a":"Black Medium Small Square","b":"25FE","d":true,"e":true,"f":true,"h":true,"j":["icon","shape","button"],"k":[52,48],"o":2},"ru":{"a":"Russia Flag","b":"1F1F7-1F1FA","d":true,"e":true,"f":true,"h":true,"j":["russian","federation","flag","nation","country","banner"],"k":[3,56],"n":["flag-ru"],"o":2},"female_zombie":{"a":"Female Zombie","b":"1F9DF-200D-2640-FE0F","c":"1F9DF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,16],"o":5},"flag-rw":{"a":"Rwanda Flag","b":"1F1F7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,0],"o":2},"snowman":{"a":"Snowman","b":"2603-FE0F","c":"2603","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas","frozen","without_snow"],"k":[52,52],"o":2},"white_medium_small_square":{"a":"White Medium Small Square","b":"25FD","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon","button"],"k":[52,47],"o":2},"microscope":{"a":"Microscope","b":"1F52C","d":true,"e":true,"f":true,"h":true,"j":["laboratory","experiment","zoomin","science","study"],"k":[28,15],"o":2},"snowman_without_snow":{"a":"Snowman Without Snow","b":"26C4","d":true,"e":true,"f":true,"h":true,"k":[54,1],"o":2},"telescope":{"a":"Telescope","b":"1F52D","d":true,"e":true,"f":true,"h":true,"j":["stars","space","zoom","science","astronomy"],"k":[28,16],"o":2},"massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB","non_qualified":null,"image":"1f486-1f3fb.png","sheet_x":24,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F486-1F3FC","non_qualified":null,"image":"1f486-1f3fc.png","sheet_x":24,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F486-1F3FD","non_qualified":null,"image":"1f486-1f3fd.png","sheet_x":24,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F486-1F3FE","non_qualified":null,"image":"1f486-1f3fe.png","sheet_x":24,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F486-1F3FF","non_qualified":null,"image":"1f486-1f3ff.png","sheet_x":24,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F486-200D-2640-FE0F","a":"Face Massage","b":"1F486","d":true,"e":true,"f":true,"h":false,"k":[24,51],"o":2},"black_small_square":{"a":"Black Small Square","b":"25AA-FE0F","c":"25AA","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,41],"o":2},"flag-sa":{"a":"Saudi Arabia Flag","b":"1F1F8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,1],"o":2},"man-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2642-FE0F","non_qualified":"1F486-1F3FB-200D-2642","image":"1f486-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2642-FE0F","non_qualified":"1F486-1F3FC-200D-2642","image":"1f486-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2642-FE0F","non_qualified":"1F486-1F3FD-200D-2642","image":"1f486-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2642-FE0F","non_qualified":"1F486-1F3FE-200D-2642","image":"1f486-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2642-FE0F","non_qualified":"1F486-1F3FF-200D-2642","image":"1f486-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Massage","b":"1F486-200D-2642-FE0F","c":"1F486-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,45],"o":4},"comet":{"a":"Comet","b":"2604-FE0F","c":"2604","d":true,"e":true,"f":true,"h":true,"j":["space"],"k":[52,53],"o":2},"white_small_square":{"a":"White Small Square","b":"25AB-FE0F","c":"25AB","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,42],"o":2},"flag-sb":{"a":"Solomon Islands Flag","b":"1F1F8-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[4,2],"o":2},"satellite_antenna":{"a":"Satellite Antenna","b":"1F4E1","d":true,"e":true,"f":true,"h":true,"k":[26,55],"o":2},"large_orange_diamond":{"a":"Large Orange Diamond","b":"1F536","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,25],"o":2},"woman-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2640-FE0F","non_qualified":"1F486-1F3FB-200D-2640","image":"1f486-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2640-FE0F","non_qualified":"1F486-1F3FC-200D-2640","image":"1f486-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2640-FE0F","non_qualified":"1F486-1F3FD-200D-2640","image":"1f486-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2640-FE0F","non_qualified":"1F486-1F3FE-200D-2640","image":"1f486-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2640-FE0F","non_qualified":"1F486-1F3FF-200D-2640","image":"1f486-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F486","a":"Woman Getting Massage","b":"1F486-200D-2640-FE0F","c":"1F486-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,39],"o":4},"fire":{"a":"Fire","b":"1F525","d":true,"e":true,"f":true,"h":true,"j":["hot","cook","flame"],"k":[28,8],"o":2},"syringe":{"a":"Syringe","b":"1F489","d":true,"e":true,"f":true,"h":true,"j":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"k":[25,19],"o":2},"flag-sc":{"a":"Seychelles Flag","b":"1F1F8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,3],"o":2},"large_blue_diamond":{"a":"Large Blue Diamond","b":"1F537","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,26],"o":2},"flag-sd":{"a":"Sudan Flag","b":"1F1F8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,4],"o":2},"droplet":{"a":"Droplet","b":"1F4A7","d":true,"e":true,"f":true,"h":true,"j":["water","drip","faucet","spring"],"k":[25,49],"o":2},"drop_of_blood":{"a":"Drop of Blood","b":"1FA78","d":true,"e":true,"f":true,"h":true,"k":[51,55],"o":12},"haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB","non_qualified":null,"image":"1f487-1f3fb.png","sheet_x":25,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F487-1F3FC","non_qualified":null,"image":"1f487-1f3fc.png","sheet_x":25,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F487-1F3FD","non_qualified":null,"image":"1f487-1f3fd.png","sheet_x":25,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F487-1F3FE","non_qualified":null,"image":"1f487-1f3fe.png","sheet_x":25,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F487-1F3FF","non_qualified":null,"image":"1f487-1f3ff.png","sheet_x":25,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F487-200D-2640-FE0F","a":"Haircut","b":"1F487","d":true,"e":true,"f":true,"h":false,"k":[25,12],"o":2},"ocean":{"a":"Water Wave","b":"1F30A","d":true,"e":true,"f":true,"h":true,"j":["sea","water","wave","nature","tsunami","disaster"],"k":[5,29],"o":2},"flag-se":{"a":"Sweden Flag","b":"1F1F8-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,5],"o":2},"man-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2642-FE0F","non_qualified":"1F487-1F3FB-200D-2642","image":"1f487-1f3fb-200d-2642-fe0f.png","sheet_x":25,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2642-FE0F","non_qualified":"1F487-1F3FC-200D-2642","image":"1f487-1f3fc-200d-2642-fe0f.png","sheet_x":25,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2642-FE0F","non_qualified":"1F487-1F3FD-200D-2642","image":"1f487-1f3fd-200d-2642-fe0f.png","sheet_x":25,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2642-FE0F","non_qualified":"1F487-1F3FE-200D-2642","image":"1f487-1f3fe-200d-2642-fe0f.png","sheet_x":25,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2642-FE0F","non_qualified":"1F487-1F3FF-200D-2642","image":"1f487-1f3ff-200d-2642-fe0f.png","sheet_x":25,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Haircut","b":"1F487-200D-2642-FE0F","c":"1F487-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[25,6],"o":4},"small_orange_diamond":{"a":"Small Orange Diamond","b":"1F538","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,27],"o":2},"pill":{"a":"Pill","b":"1F48A","d":true,"e":true,"f":true,"h":true,"j":["health","medicine","doctor","pharmacy","drug"],"k":[25,20],"o":2},"woman-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2640-FE0F","non_qualified":"1F487-1F3FB-200D-2640","image":"1f487-1f3fb-200d-2640-fe0f.png","sheet_x":25,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2640-FE0F","non_qualified":"1F487-1F3FC-200D-2640","image":"1f487-1f3fc-200d-2640-fe0f.png","sheet_x":25,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2640-FE0F","non_qualified":"1F487-1F3FD-200D-2640","image":"1f487-1f3fd-200d-2640-fe0f.png","sheet_x":25,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2640-FE0F","non_qualified":"1F487-1F3FE-200D-2640","image":"1f487-1f3fe-200d-2640-fe0f.png","sheet_x":25,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2640-FE0F","non_qualified":"1F487-1F3FF-200D-2640","image":"1f487-1f3ff-200d-2640-fe0f.png","sheet_x":25,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F487","a":"Woman Getting Haircut","b":"1F487-200D-2640-FE0F","c":"1F487-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[25,0],"o":4},"small_blue_diamond":{"a":"Small Blue Diamond","b":"1F539","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,28],"o":2},"flag-sg":{"a":"Singapore Flag","b":"1F1F8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,6],"o":2},"adhesive_bandage":{"a":"Adhesive Bandage","b":"1FA79","d":true,"e":true,"f":true,"h":true,"k":[51,56],"o":12},"walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB","non_qualified":null,"image":"1f6b6-1f3fb.png","sheet_x":36,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B6-1F3FC","non_qualified":null,"image":"1f6b6-1f3fc.png","sheet_x":36,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B6-1F3FD","non_qualified":null,"image":"1f6b6-1f3fd.png","sheet_x":36,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B6-1F3FE","non_qualified":null,"image":"1f6b6-1f3fe.png","sheet_x":36,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B6-1F3FF","non_qualified":null,"image":"1f6b6-1f3ff.png","sheet_x":36,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B6-200D-2642-FE0F","a":"Pedestrian","b":"1F6B6","d":true,"e":true,"f":true,"h":false,"k":[36,2],"o":2},"small_red_triangle":{"a":"Up-Pointing Red Triangle","b":"1F53A","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","up","top"],"k":[28,29],"o":2},"flag-sh":{"a":"St. Helena Flag","b":"1F1F8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,7],"o":2},"stethoscope":{"a":"Stethoscope","b":"1FA7A","d":true,"e":true,"f":true,"h":true,"k":[52,0],"o":12},"man-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2642-FE0F","non_qualified":"1F6B6-1F3FB-200D-2642","image":"1f6b6-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2642-FE0F","non_qualified":"1F6B6-1F3FC-200D-2642","image":"1f6b6-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2642-FE0F","non_qualified":"1F6B6-1F3FD-200D-2642","image":"1f6b6-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2642-FE0F","non_qualified":"1F6B6-1F3FE-200D-2642","image":"1f6b6-1f3fe-200d-2642-fe0f.png","sheet_x":36,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2642-FE0F","non_qualified":"1F6B6-1F3FF-200D-2642","image":"1f6b6-1f3ff-200d-2642-fe0f.png","sheet_x":36,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B6","a":"Man Walking","b":"1F6B6-200D-2642-FE0F","c":"1F6B6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,53],"o":4},"flag-si":{"a":"Slovenia Flag","b":"1F1F8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,8],"o":2},"door":{"a":"Door","b":"1F6AA","d":true,"e":true,"f":true,"h":true,"j":["house","entry","exit"],"k":[35,1],"o":2},"small_red_triangle_down":{"a":"Down-Pointing Red Triangle","b":"1F53B","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","bottom"],"k":[28,30],"o":2},"flag-sj":{"a":"Svalbard & Jan Mayen Flag","b":"1F1F8-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,9],"o":2},"diamond_shape_with_a_dot_inside":{"a":"Diamond Shape with a Dot Inside","b":"1F4A0","d":true,"e":true,"f":true,"h":true,"j":["jewel","blue","gem","crystal","fancy"],"k":[25,42],"o":2},"woman-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2640-FE0F","non_qualified":"1F6B6-1F3FB-200D-2640","image":"1f6b6-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2640-FE0F","non_qualified":"1F6B6-1F3FC-200D-2640","image":"1f6b6-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2640-FE0F","non_qualified":"1F6B6-1F3FD-200D-2640","image":"1f6b6-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2640-FE0F","non_qualified":"1F6B6-1F3FE-200D-2640","image":"1f6b6-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2640-FE0F","non_qualified":"1F6B6-1F3FF-200D-2640","image":"1f6b6-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Walking","b":"1F6B6-200D-2640-FE0F","c":"1F6B6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,47],"o":4},"bed":{"a":"Bed","b":"1F6CF-FE0F","c":"1F6CF","d":true,"e":true,"f":true,"h":true,"j":["sleep","rest"],"k":[36,37],"o":2},"radio_button":{"a":"Radio Button","b":"1F518","d":true,"e":true,"f":true,"h":true,"j":["input","old","music","circle"],"k":[27,52],"o":2},"flag-sk":{"a":"Slovakia Flag","b":"1F1F8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,10],"o":2},"standing_person":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB","non_qualified":null,"image":"1f9cd-1f3fb.png","sheet_x":44,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC","non_qualified":null,"image":"1f9cd-1f3fc.png","sheet_x":44,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD","non_qualified":null,"image":"1f9cd-1f3fd.png","sheet_x":44,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE","non_qualified":null,"image":"1f9cd-1f3fe.png","sheet_x":44,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF","non_qualified":null,"image":"1f9cd-1f3ff.png","sheet_x":44,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Standing Person","b":"1F9CD","d":true,"e":true,"f":true,"h":true,"k":[44,31],"o":12},"couch_and_lamp":{"a":"Couch and Lamp","b":"1F6CB-FE0F","c":"1F6CB","d":true,"e":true,"f":true,"h":true,"j":["read","chill"],"k":[36,28],"o":2},"man_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2642-FE0F","non_qualified":"1F9CD-1F3FB-200D-2642","image":"1f9cd-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2642-FE0F","non_qualified":"1F9CD-1F3FC-200D-2642","image":"1f9cd-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2642-FE0F","non_qualified":"1F9CD-1F3FD-200D-2642","image":"1f9cd-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2642-FE0F","non_qualified":"1F9CD-1F3FE-200D-2642","image":"1f9cd-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2642-FE0F","non_qualified":"1F9CD-1F3FF-200D-2642","image":"1f9cd-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Standing","b":"1F9CD-200D-2642-FE0F","c":"1F9CD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,25],"o":12},"white_square_button":{"a":"White Square Button","b":"1F533","d":true,"e":true,"f":true,"h":true,"j":["shape","input"],"k":[28,22],"o":2},"flag-sl":{"a":"Sierra Leone Flag","b":"1F1F8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,11],"o":2},"chair":{"a":"Chair","b":"1FA91","d":true,"e":true,"f":true,"h":true,"k":[52,5],"o":12},"toilet":{"a":"Toilet","b":"1F6BD","d":true,"e":true,"f":true,"h":true,"j":["restroom","wc","washroom","bathroom","potty"],"k":[36,14],"o":2},"black_square_button":{"a":"Black Square Button","b":"1F532","d":true,"e":true,"f":true,"h":true,"j":["shape","input","frame"],"k":[28,21],"o":2},"flag-sm":{"a":"San Marino Flag","b":"1F1F8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,12],"o":2},"woman_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2640-FE0F","non_qualified":"1F9CD-1F3FB-200D-2640","image":"1f9cd-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2640-FE0F","non_qualified":"1F9CD-1F3FC-200D-2640","image":"1f9cd-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2640-FE0F","non_qualified":"1F9CD-1F3FD-200D-2640","image":"1f9cd-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2640-FE0F","non_qualified":"1F9CD-1F3FE-200D-2640","image":"1f9cd-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2640-FE0F","non_qualified":"1F9CD-1F3FF-200D-2640","image":"1f9cd-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Standing","b":"1F9CD-200D-2640-FE0F","c":"1F9CD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,19],"o":12},"kneeling_person":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB","non_qualified":null,"image":"1f9ce-1f3fb.png","sheet_x":44,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC","non_qualified":null,"image":"1f9ce-1f3fc.png","sheet_x":44,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD","non_qualified":null,"image":"1f9ce-1f3fd.png","sheet_x":44,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE","non_qualified":null,"image":"1f9ce-1f3fe.png","sheet_x":44,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF","non_qualified":null,"image":"1f9ce-1f3ff.png","sheet_x":44,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Kneeling Person","b":"1F9CE","d":true,"e":true,"f":true,"h":true,"k":[44,49],"o":12},"shower":{"a":"Shower","b":"1F6BF","d":true,"e":true,"f":true,"h":true,"j":["clean","water","bathroom"],"k":[36,16],"o":2},"flag-sn":{"a":"Senegal Flag","b":"1F1F8-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,13],"o":2},"bathtub":{"a":"Bathtub","b":"1F6C1","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,23],"o":2},"flag-so":{"a":"Somalia Flag","b":"1F1F8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,14],"o":2},"man_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2642-FE0F","non_qualified":"1F9CE-1F3FB-200D-2642","image":"1f9ce-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2642-FE0F","non_qualified":"1F9CE-1F3FC-200D-2642","image":"1f9ce-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2642-FE0F","non_qualified":"1F9CE-1F3FD-200D-2642","image":"1f9ce-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2642-FE0F","non_qualified":"1F9CE-1F3FE-200D-2642","image":"1f9ce-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2642-FE0F","non_qualified":"1F9CE-1F3FF-200D-2642","image":"1f9ce-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Kneeling","b":"1F9CE-200D-2642-FE0F","c":"1F9CE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,43],"o":12},"flag-sr":{"a":"Suriname Flag","b":"1F1F8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,15],"o":2},"woman_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2640-FE0F","non_qualified":"1F9CE-1F3FB-200D-2640","image":"1f9ce-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2640-FE0F","non_qualified":"1F9CE-1F3FC-200D-2640","image":"1f9ce-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2640-FE0F","non_qualified":"1F9CE-1F3FD-200D-2640","image":"1f9ce-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2640-FE0F","non_qualified":"1F9CE-1F3FE-200D-2640","image":"1f9ce-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2640-FE0F","non_qualified":"1F9CE-1F3FF-200D-2640","image":"1f9ce-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Kneeling","b":"1F9CE-200D-2640-FE0F","c":"1F9CE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,37],"o":12},"razor":{"a":"Razor","b":"1FA92","d":true,"e":true,"f":true,"h":true,"k":[52,6],"o":12},"person_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9af.png","sheet_x":47,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9af.png","sheet_x":47,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9af.png","sheet_x":47,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9af.png","sheet_x":47,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9af.png","sheet_x":47,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person with Probing Cane","b":"1F9D1-200D-1F9AF","d":true,"e":false,"f":false,"h":false,"k":[47,7],"o":12},"flag-ss":{"a":"South Sudan Flag","b":"1F1F8-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,16],"o":2},"lotion_bottle":{"a":"Lotion Bottle","b":"1F9F4","d":true,"e":true,"f":true,"h":true,"k":[51,39],"o":11},"flag-st":{"a":"São Tomé & Príncipe Flag","b":"1F1F8-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,17],"o":2},"safety_pin":{"a":"Safety Pin","b":"1F9F7","d":true,"e":true,"f":true,"h":true,"k":[51,42],"o":11},"man_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fb-200d-1f9af.png","sheet_x":16,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fc-200d-1f9af.png","sheet_x":16,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fd-200d-1f9af.png","sheet_x":16,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fe-200d-1f9af.png","sheet_x":16,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f468-1f3ff-200d-1f9af.png","sheet_x":16,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Probing Cane","b":"1F468-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[16,17],"o":12},"broom":{"a":"Broom","b":"1F9F9","d":true,"e":true,"f":true,"h":true,"k":[51,44],"o":11},"woman_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fb-200d-1f9af.png","sheet_x":19,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fc-200d-1f9af.png","sheet_x":19,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fd-200d-1f9af.png","sheet_x":19,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fe-200d-1f9af.png","sheet_x":19,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f469-1f3ff-200d-1f9af.png","sheet_x":19,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman with Probing Cane","b":"1F469-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[19,2],"o":12},"flag-sv":{"a":"El Salvador Flag","b":"1F1F8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,18],"o":2},"flag-sx":{"a":"Sint Maarten Flag","b":"1F1F8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[4,19],"o":2},"basket":{"a":"Basket","b":"1F9FA","d":true,"e":true,"f":true,"h":true,"k":[51,45],"o":11},"person_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bc.png","sheet_x":47,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bc.png","sheet_x":47,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bc.png","sheet_x":47,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bc.png","sheet_x":47,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bc.png","sheet_x":47,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Motorized Wheelchair","b":"1F9D1-200D-1F9BC","d":true,"e":false,"f":false,"h":false,"k":[47,37],"o":12},"man_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bc.png","sheet_x":16,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bc.png","sheet_x":16,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bc.png","sheet_x":16,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bc.png","sheet_x":16,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bc.png","sheet_x":16,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Motorized Wheelchair","b":"1F468-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[16,47],"o":12},"flag-sy":{"a":"Syria Flag","b":"1F1F8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,20],"o":2},"roll_of_paper":{"a":"Roll of Paper","b":"1F9FB","d":true,"e":true,"f":true,"h":true,"k":[51,46],"o":11},"woman_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bc.png","sheet_x":19,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bc.png","sheet_x":19,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bc.png","sheet_x":19,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bc.png","sheet_x":19,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bc.png","sheet_x":19,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Motorized Wheelchair","b":"1F469-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[19,32],"o":12},"flag-sz":{"a":"Eswatini Flag","b":"1F1F8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,21],"o":2},"soap":{"a":"Bar of Soap","b":"1F9FC","d":true,"e":true,"f":true,"h":true,"k":[51,47],"o":11},"flag-ta":{"a":"Tristan Da Cunha Flag","b":"1F1F9-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,22],"o":2},"sponge":{"a":"Sponge","b":"1F9FD","d":true,"e":true,"f":true,"h":true,"k":[51,48],"o":11},"person_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bd.png","sheet_x":47,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bd.png","sheet_x":47,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bd.png","sheet_x":47,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bd.png","sheet_x":47,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bd.png","sheet_x":47,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Manual Wheelchair","b":"1F9D1-200D-1F9BD","d":true,"e":false,"f":false,"h":false,"k":[47,43],"o":12},"fire_extinguisher":{"a":"Fire Extinguisher","b":"1F9EF","d":true,"e":true,"f":true,"h":true,"k":[51,34],"o":11},"man_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bd.png","sheet_x":16,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bd.png","sheet_x":16,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bd.png","sheet_x":16,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bd.png","sheet_x":17,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bd.png","sheet_x":17,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Manual Wheelchair","b":"1F468-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[16,53],"o":12},"flag-tc":{"a":"Turks & Caicos Islands Flag","b":"1F1F9-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,23],"o":2},"woman_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bd.png","sheet_x":19,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bd.png","sheet_x":19,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bd.png","sheet_x":19,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bd.png","sheet_x":19,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bd.png","sheet_x":19,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Manual Wheelchair","b":"1F469-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[19,38],"o":12},"flag-td":{"a":"Chad Flag","b":"1F1F9-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,24],"o":2},"shopping_trolley":{"a":"Shopping Trolley","b":"1F6D2","d":true,"e":true,"f":true,"h":true,"k":[36,40],"o":4},"runner":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB","non_qualified":null,"image":"1f3c3-1f3fb.png","sheet_x":9,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C3-1F3FC","non_qualified":null,"image":"1f3c3-1f3fc.png","sheet_x":9,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C3-1F3FD","non_qualified":null,"image":"1f3c3-1f3fd.png","sheet_x":9,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C3-1F3FE","non_qualified":null,"image":"1f3c3-1f3fe.png","sheet_x":9,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C3-1F3FF","non_qualified":null,"image":"1f3c3-1f3ff.png","sheet_x":9,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C3-200D-2642-FE0F","a":"Runner","b":"1F3C3","d":true,"e":true,"f":true,"h":false,"k":[9,1],"n":["running"],"o":2},"flag-tf":{"a":"French Southern Territories Flag","b":"1F1F9-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,25],"o":2},"smoking":{"a":"Smoking Symbol","b":"1F6AC","d":true,"e":true,"f":true,"h":true,"j":["kills","tobacco","cigarette","joint","smoke"],"k":[35,3],"o":2},"coffin":{"a":"Coffin","b":"26B0-FE0F","c":"26B0","d":true,"e":true,"f":true,"h":true,"j":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"k":[53,54],"o":2},"man-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2642-FE0F","non_qualified":"1F3C3-1F3FB-200D-2642","image":"1f3c3-1f3fb-200d-2642-fe0f.png","sheet_x":8,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2642-FE0F","non_qualified":"1F3C3-1F3FC-200D-2642","image":"1f3c3-1f3fc-200d-2642-fe0f.png","sheet_x":8,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2642-FE0F","non_qualified":"1F3C3-1F3FD-200D-2642","image":"1f3c3-1f3fd-200d-2642-fe0f.png","sheet_x":8,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2642-FE0F","non_qualified":"1F3C3-1F3FE-200D-2642","image":"1f3c3-1f3fe-200d-2642-fe0f.png","sheet_x":8,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2642-FE0F","non_qualified":"1F3C3-1F3FF-200D-2642","image":"1f3c3-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C3","a":"Man Running","b":"1F3C3-200D-2642-FE0F","c":"1F3C3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[8,52],"o":4},"flag-tg":{"a":"Togo Flag","b":"1F1F9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,26],"o":2},"woman-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2640-FE0F","non_qualified":"1F3C3-1F3FB-200D-2640","image":"1f3c3-1f3fb-200d-2640-fe0f.png","sheet_x":8,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2640-FE0F","non_qualified":"1F3C3-1F3FC-200D-2640","image":"1f3c3-1f3fc-200d-2640-fe0f.png","sheet_x":8,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2640-FE0F","non_qualified":"1F3C3-1F3FD-200D-2640","image":"1f3c3-1f3fd-200d-2640-fe0f.png","sheet_x":8,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2640-FE0F","non_qualified":"1F3C3-1F3FE-200D-2640","image":"1f3c3-1f3fe-200d-2640-fe0f.png","sheet_x":8,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2640-FE0F","non_qualified":"1F3C3-1F3FF-200D-2640","image":"1f3c3-1f3ff-200d-2640-fe0f.png","sheet_x":8,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Running","b":"1F3C3-200D-2640-FE0F","c":"1F3C3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[8,46],"o":4},"funeral_urn":{"a":"Funeral Urn","b":"26B1-FE0F","c":"26B1","d":true,"e":true,"f":true,"h":true,"j":["dead","die","death","rip","ashes"],"k":[53,55],"o":2},"flag-th":{"a":"Thailand Flag","b":"1F1F9-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,27],"o":2},"moyai":{"a":"Moyai","b":"1F5FF","d":true,"e":true,"f":true,"h":true,"j":["rock","easter island","moai"],"k":[30,34],"o":2},"flag-tj":{"a":"Tajikistan Flag","b":"1F1F9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,28],"o":2},"dancer":{"skin_variations":{"1F3FB":{"unified":"1F483-1F3FB","non_qualified":null,"image":"1f483-1f3fb.png","sheet_x":24,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F483-1F3FC","non_qualified":null,"image":"1f483-1f3fc.png","sheet_x":24,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F483-1F3FD","non_qualified":null,"image":"1f483-1f3fd.png","sheet_x":24,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F483-1F3FE","non_qualified":null,"image":"1f483-1f3fe.png","sheet_x":24,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F483-1F3FF","non_qualified":null,"image":"1f483-1f3ff.png","sheet_x":24,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Dancer","b":"1F483","d":true,"e":true,"f":true,"h":true,"j":["female","girl","woman","fun"],"k":[24,26],"o":2},"flag-tk":{"a":"Tokelau Flag","b":"1F1F9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,29],"o":2},"man_dancing":{"skin_variations":{"1F3FB":{"unified":"1F57A-1F3FB","non_qualified":null,"image":"1f57a-1f3fb.png","sheet_x":29,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F57A-1F3FC","non_qualified":null,"image":"1f57a-1f3fc.png","sheet_x":29,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F57A-1F3FD","non_qualified":null,"image":"1f57a-1f3fd.png","sheet_x":29,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F57A-1F3FE","non_qualified":null,"image":"1f57a-1f3fe.png","sheet_x":29,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F57A-1F3FF","non_qualified":null,"image":"1f57a-1f3ff.png","sheet_x":29,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Dancing","b":"1F57A","d":true,"e":true,"f":true,"h":true,"j":["male","boy","fun","dancer"],"k":[29,37],"o":4},"flag-tl":{"a":"Timor-Leste Flag","b":"1F1F9-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,30],"o":2},"man_in_business_suit_levitating":{"skin_variations":{"1F3FB":{"unified":"1F574-1F3FB","non_qualified":null,"image":"1f574-1f3fb.png","sheet_x":29,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F574-1F3FC","non_qualified":null,"image":"1f574-1f3fc.png","sheet_x":29,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F574-1F3FD","non_qualified":null,"image":"1f574-1f3fd.png","sheet_x":29,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F574-1F3FE","non_qualified":null,"image":"1f574-1f3fe.png","sheet_x":29,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F574-1F3FF","non_qualified":null,"image":"1f574-1f3ff.png","sheet_x":29,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Business Suit Levitating","b":"1F574-FE0F","c":"1F574","d":true,"e":true,"f":true,"h":true,"k":[29,9],"o":2},"flag-tm":{"a":"Turkmenistan Flag","b":"1F1F9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,31],"o":2},"dancers":{"obsoleted_by":"1F46F-200D-2640-FE0F","a":"Woman with Bunny Ears","b":"1F46F","d":true,"e":true,"f":true,"h":true,"k":[22,0],"o":2},"man-with-bunny-ears-partying":{"a":"Man with Bunny Ears Partying","b":"1F46F-200D-2642-FE0F","c":"1F46F-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,56],"o":4},"flag-tn":{"a":"Tunisia Flag","b":"1F1F9-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,32],"o":2},"flag-to":{"a":"Tonga Flag","b":"1F1F9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,33],"o":2},"woman-with-bunny-ears-partying":{"obsoletes":"1F46F","a":"Woman with Bunny Ears Partying","b":"1F46F-200D-2640-FE0F","c":"1F46F-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,55],"o":4},"flag-tr":{"a":"Turkey Flag","b":"1F1F9-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,34],"o":2},"person_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB","non_qualified":null,"image":"1f9d6-1f3fb.png","sheet_x":48,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9D6-1F3FC","non_qualified":null,"image":"1f9d6-1f3fc.png","sheet_x":48,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9D6-1F3FD","non_qualified":null,"image":"1f9d6-1f3fd.png","sheet_x":48,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9D6-1F3FE","non_qualified":null,"image":"1f9d6-1f3fe.png","sheet_x":48,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9D6-1F3FF","non_qualified":null,"image":"1f9d6-1f3ff.png","sheet_x":49,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9D6-200D-2642-FE0F","a":"Person in Steamy Room","b":"1F9D6","d":true,"e":true,"f":true,"h":true,"k":[48,52],"o":5},"man_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2642-FE0F","non_qualified":"1F9D6-1F3FB-200D-2642","image":"1f9d6-1f3fb-200d-2642-fe0f.png","sheet_x":48,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FB"},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2642-FE0F","non_qualified":"1F9D6-1F3FC-200D-2642","image":"1f9d6-1f3fc-200d-2642-fe0f.png","sheet_x":48,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FC"},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2642-FE0F","non_qualified":"1F9D6-1F3FD-200D-2642","image":"1f9d6-1f3fd-200d-2642-fe0f.png","sheet_x":48,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FD"},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2642-FE0F","non_qualified":"1F9D6-1F3FE-200D-2642","image":"1f9d6-1f3fe-200d-2642-fe0f.png","sheet_x":48,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FE"},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2642-FE0F","non_qualified":"1F9D6-1F3FF-200D-2642","image":"1f9d6-1f3ff-200d-2642-fe0f.png","sheet_x":48,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FF"}},"obsoletes":"1F9D6","a":"Man in Steamy Room","b":"1F9D6-200D-2642-FE0F","c":"1F9D6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[48,46],"o":5},"flag-tt":{"a":"Trinidad & Tobago Flag","b":"1F1F9-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,35],"o":2},"woman_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2640-FE0F","non_qualified":"1F9D6-1F3FB-200D-2640","image":"1f9d6-1f3fb-200d-2640-fe0f.png","sheet_x":48,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2640-FE0F","non_qualified":"1F9D6-1F3FC-200D-2640","image":"1f9d6-1f3fc-200d-2640-fe0f.png","sheet_x":48,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2640-FE0F","non_qualified":"1F9D6-1F3FD-200D-2640","image":"1f9d6-1f3fd-200d-2640-fe0f.png","sheet_x":48,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2640-FE0F","non_qualified":"1F9D6-1F3FE-200D-2640","image":"1f9d6-1f3fe-200d-2640-fe0f.png","sheet_x":48,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2640-FE0F","non_qualified":"1F9D6-1F3FF-200D-2640","image":"1f9d6-1f3ff-200d-2640-fe0f.png","sheet_x":48,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Steamy Room","b":"1F9D6-200D-2640-FE0F","c":"1F9D6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[48,40],"o":5},"flag-tv":{"a":"Tuvalu Flag","b":"1F1F9-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,36],"o":2},"flag-tw":{"a":"Taiwan Flag","b":"1F1F9-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,37],"o":2},"person_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB","non_qualified":null,"image":"1f9d7-1f3fb.png","sheet_x":49,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D7-1F3FC","non_qualified":null,"image":"1f9d7-1f3fc.png","sheet_x":49,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D7-1F3FD","non_qualified":null,"image":"1f9d7-1f3fd.png","sheet_x":49,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D7-1F3FE","non_qualified":null,"image":"1f9d7-1f3fe.png","sheet_x":49,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D7-1F3FF","non_qualified":null,"image":"1f9d7-1f3ff.png","sheet_x":49,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D7-200D-2640-FE0F","a":"Person Climbing","b":"1F9D7","d":true,"e":true,"f":true,"h":true,"k":[49,13],"o":5},"man_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2642-FE0F","non_qualified":"1F9D7-1F3FB-200D-2642","image":"1f9d7-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2642-FE0F","non_qualified":"1F9D7-1F3FC-200D-2642","image":"1f9d7-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2642-FE0F","non_qualified":"1F9D7-1F3FD-200D-2642","image":"1f9d7-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2642-FE0F","non_qualified":"1F9D7-1F3FE-200D-2642","image":"1f9d7-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2642-FE0F","non_qualified":"1F9D7-1F3FF-200D-2642","image":"1f9d7-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Climbing","b":"1F9D7-200D-2642-FE0F","c":"1F9D7-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,7],"o":5},"flag-tz":{"a":"Tanzania Flag","b":"1F1F9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,38],"o":2},"flag-ua":{"a":"Ukraine Flag","b":"1F1FA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,39],"o":2},"woman_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2640-FE0F","non_qualified":"1F9D7-1F3FB-200D-2640","image":"1f9d7-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FB"},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2640-FE0F","non_qualified":"1F9D7-1F3FC-200D-2640","image":"1f9d7-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FC"},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2640-FE0F","non_qualified":"1F9D7-1F3FD-200D-2640","image":"1f9d7-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FD"},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2640-FE0F","non_qualified":"1F9D7-1F3FE-200D-2640","image":"1f9d7-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FE"},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2640-FE0F","non_qualified":"1F9D7-1F3FF-200D-2640","image":"1f9d7-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FF"}},"obsoletes":"1F9D7","a":"Woman Climbing","b":"1F9D7-200D-2640-FE0F","c":"1F9D7-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,1],"o":5},"flag-ug":{"a":"Uganda Flag","b":"1F1FA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,40],"o":2},"fencer":{"a":"Fencer","b":"1F93A","d":true,"e":true,"f":true,"h":true,"k":[40,32],"o":4},"flag-um":{"a":"U.s. Outlying Islands Flag","b":"1F1FA-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,41],"o":2},"horse_racing":{"skin_variations":{"1F3FB":{"unified":"1F3C7-1F3FB","non_qualified":null,"image":"1f3c7-1f3fb.png","sheet_x":9,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C7-1F3FC","non_qualified":null,"image":"1f3c7-1f3fc.png","sheet_x":9,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C7-1F3FD","non_qualified":null,"image":"1f3c7-1f3fd.png","sheet_x":9,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C7-1F3FE","non_qualified":null,"image":"1f3c7-1f3fe.png","sheet_x":9,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C7-1F3FF","non_qualified":null,"image":"1f3c7-1f3ff.png","sheet_x":9,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Horse Racing","b":"1F3C7","d":true,"e":true,"f":true,"h":true,"j":["animal","betting","competition","gambling","luck"],"k":[9,27],"o":2},"skier":{"a":"Skier","b":"26F7-FE0F","c":"26F7","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","snow"],"k":[54,17],"o":2},"flag-un":{"a":"United Nations Flag","b":"1F1FA-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,42],"o":4},"us":{"a":"United States Flag","b":"1F1FA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["united","states","america","flag","nation","country","banner"],"k":[4,43],"n":["flag-us"],"o":2},"snowboarder":{"skin_variations":{"1F3FB":{"unified":"1F3C2-1F3FB","non_qualified":null,"image":"1f3c2-1f3fb.png","sheet_x":8,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C2-1F3FC","non_qualified":null,"image":"1f3c2-1f3fc.png","sheet_x":8,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C2-1F3FD","non_qualified":null,"image":"1f3c2-1f3fd.png","sheet_x":8,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C2-1F3FE","non_qualified":null,"image":"1f3c2-1f3fe.png","sheet_x":8,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C2-1F3FF","non_qualified":null,"image":"1f3c2-1f3ff.png","sheet_x":8,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Snowboarder","b":"1F3C2","d":true,"e":true,"f":true,"h":true,"j":["sports","winter"],"k":[8,40],"o":2},"golfer":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB","non_qualified":null,"image":"1f3cc-1f3fb.png","sheet_x":10,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CC-1F3FC","non_qualified":null,"image":"1f3cc-1f3fc.png","sheet_x":10,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CC-1F3FD","non_qualified":null,"image":"1f3cc-1f3fd.png","sheet_x":10,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CC-1F3FE","non_qualified":null,"image":"1f3cc-1f3fe.png","sheet_x":10,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CC-1F3FF","non_qualified":null,"image":"1f3cc-1f3ff.png","sheet_x":10,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CC-FE0F-200D-2642-FE0F","a":"Golfer","b":"1F3CC-FE0F","c":"1F3CC","d":true,"e":true,"f":true,"h":false,"k":[10,26],"o":2},"flag-uy":{"a":"Uruguay Flag","b":"1F1FA-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,44],"o":2},"flag-uz":{"a":"Uzbekistan Flag","b":"1F1FA-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,45],"o":2},"man-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2642-FE0F","non_qualified":"1F3CC-1F3FB-200D-2642","image":"1f3cc-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2642-FE0F","non_qualified":"1F3CC-1F3FC-200D-2642","image":"1f3cc-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2642-FE0F","non_qualified":"1F3CC-1F3FD-200D-2642","image":"1f3cc-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2642-FE0F","non_qualified":"1F3CC-1F3FE-200D-2642","image":"1f3cc-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2642-FE0F","non_qualified":"1F3CC-1F3FF-200D-2642","image":"1f3cc-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CC-FE0F","a":"Man Golfing","b":"1F3CC-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,20],"o":4},"flag-va":{"a":"Vatican City Flag","b":"1F1FB-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,46],"o":2},"woman-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2640-FE0F","non_qualified":"1F3CC-1F3FB-200D-2640","image":"1f3cc-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2640-FE0F","non_qualified":"1F3CC-1F3FC-200D-2640","image":"1f3cc-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2640-FE0F","non_qualified":"1F3CC-1F3FD-200D-2640","image":"1f3cc-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2640-FE0F","non_qualified":"1F3CC-1F3FE-200D-2640","image":"1f3cc-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2640-FE0F","non_qualified":"1F3CC-1F3FF-200D-2640","image":"1f3cc-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Golfing","b":"1F3CC-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,14],"o":4},"flag-vc":{"a":"St. Vincent & Grenadines Flag","b":"1F1FB-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,47],"o":2},"surfer":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB","non_qualified":null,"image":"1f3c4-1f3fb.png","sheet_x":9,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C4-1F3FC","non_qualified":null,"image":"1f3c4-1f3fc.png","sheet_x":9,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C4-1F3FD","non_qualified":null,"image":"1f3c4-1f3fd.png","sheet_x":9,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C4-1F3FE","non_qualified":null,"image":"1f3c4-1f3fe.png","sheet_x":9,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C4-1F3FF","non_qualified":null,"image":"1f3c4-1f3ff.png","sheet_x":9,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C4-200D-2642-FE0F","a":"Surfer","b":"1F3C4","d":true,"e":true,"f":true,"h":false,"k":[9,19],"o":2},"man-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2642-FE0F","non_qualified":"1F3C4-1F3FB-200D-2642","image":"1f3c4-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2642-FE0F","non_qualified":"1F3C4-1F3FC-200D-2642","image":"1f3c4-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2642-FE0F","non_qualified":"1F3C4-1F3FD-200D-2642","image":"1f3c4-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2642-FE0F","non_qualified":"1F3C4-1F3FE-200D-2642","image":"1f3c4-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2642-FE0F","non_qualified":"1F3C4-1F3FF-200D-2642","image":"1f3c4-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C4","a":"Man Surfing","b":"1F3C4-200D-2642-FE0F","c":"1F3C4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,13],"o":4},"flag-ve":{"a":"Venezuela Flag","b":"1F1FB-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,48],"o":2},"flag-vg":{"a":"British Virgin Islands Flag","b":"1F1FB-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,49],"o":2},"woman-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2640-FE0F","non_qualified":"1F3C4-1F3FB-200D-2640","image":"1f3c4-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2640-FE0F","non_qualified":"1F3C4-1F3FC-200D-2640","image":"1f3c4-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2640-FE0F","non_qualified":"1F3C4-1F3FD-200D-2640","image":"1f3c4-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2640-FE0F","non_qualified":"1F3C4-1F3FE-200D-2640","image":"1f3c4-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2640-FE0F","non_qualified":"1F3C4-1F3FF-200D-2640","image":"1f3c4-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Surfing","b":"1F3C4-200D-2640-FE0F","c":"1F3C4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,7],"o":4},"rowboat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB","non_qualified":null,"image":"1f6a3-1f3fb.png","sheet_x":34,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6A3-1F3FC","non_qualified":null,"image":"1f6a3-1f3fc.png","sheet_x":34,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6A3-1F3FD","non_qualified":null,"image":"1f6a3-1f3fd.png","sheet_x":34,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6A3-1F3FE","non_qualified":null,"image":"1f6a3-1f3fe.png","sheet_x":34,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6A3-1F3FF","non_qualified":null,"image":"1f6a3-1f3ff.png","sheet_x":34,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6A3-200D-2642-FE0F","a":"Rowboat","b":"1F6A3","d":true,"e":true,"f":true,"h":false,"k":[34,46],"o":2},"flag-vi":{"a":"U.s. Virgin Islands Flag","b":"1F1FB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,50],"o":2},"man-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2642-FE0F","non_qualified":"1F6A3-1F3FB-200D-2642","image":"1f6a3-1f3fb-200d-2642-fe0f.png","sheet_x":34,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2642-FE0F","non_qualified":"1F6A3-1F3FC-200D-2642","image":"1f6a3-1f3fc-200d-2642-fe0f.png","sheet_x":34,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2642-FE0F","non_qualified":"1F6A3-1F3FD-200D-2642","image":"1f6a3-1f3fd-200d-2642-fe0f.png","sheet_x":34,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2642-FE0F","non_qualified":"1F6A3-1F3FE-200D-2642","image":"1f6a3-1f3fe-200d-2642-fe0f.png","sheet_x":34,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2642-FE0F","non_qualified":"1F6A3-1F3FF-200D-2642","image":"1f6a3-1f3ff-200d-2642-fe0f.png","sheet_x":34,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6A3","a":"Man Rowing Boat","b":"1F6A3-200D-2642-FE0F","c":"1F6A3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[34,40],"o":4},"flag-vn":{"a":"Vietnam Flag","b":"1F1FB-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,51],"o":2},"flag-vu":{"a":"Vanuatu Flag","b":"1F1FB-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[4,52],"o":2},"woman-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2640-FE0F","non_qualified":"1F6A3-1F3FB-200D-2640","image":"1f6a3-1f3fb-200d-2640-fe0f.png","sheet_x":34,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2640-FE0F","non_qualified":"1F6A3-1F3FC-200D-2640","image":"1f6a3-1f3fc-200d-2640-fe0f.png","sheet_x":34,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2640-FE0F","non_qualified":"1F6A3-1F3FD-200D-2640","image":"1f6a3-1f3fd-200d-2640-fe0f.png","sheet_x":34,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2640-FE0F","non_qualified":"1F6A3-1F3FE-200D-2640","image":"1f6a3-1f3fe-200d-2640-fe0f.png","sheet_x":34,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2640-FE0F","non_qualified":"1F6A3-1F3FF-200D-2640","image":"1f6a3-1f3ff-200d-2640-fe0f.png","sheet_x":34,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Rowing Boat","b":"1F6A3-200D-2640-FE0F","c":"1F6A3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[34,34],"o":4},"swimmer":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB","non_qualified":null,"image":"1f3ca-1f3fb.png","sheet_x":9,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CA-1F3FC","non_qualified":null,"image":"1f3ca-1f3fc.png","sheet_x":9,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CA-1F3FD","non_qualified":null,"image":"1f3ca-1f3fd.png","sheet_x":9,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CA-1F3FE","non_qualified":null,"image":"1f3ca-1f3fe.png","sheet_x":9,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CA-1F3FF","non_qualified":null,"image":"1f3ca-1f3ff.png","sheet_x":9,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CA-200D-2642-FE0F","a":"Swimmer","b":"1F3CA","d":true,"e":true,"f":true,"h":false,"k":[9,47],"o":2},"flag-wf":{"a":"Wallis & Futuna Flag","b":"1F1FC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,53],"o":2},"man-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2642-FE0F","non_qualified":"1F3CA-1F3FB-200D-2642","image":"1f3ca-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2642-FE0F","non_qualified":"1F3CA-1F3FC-200D-2642","image":"1f3ca-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2642-FE0F","non_qualified":"1F3CA-1F3FD-200D-2642","image":"1f3ca-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2642-FE0F","non_qualified":"1F3CA-1F3FE-200D-2642","image":"1f3ca-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2642-FE0F","non_qualified":"1F3CA-1F3FF-200D-2642","image":"1f3ca-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CA","a":"Man Swimming","b":"1F3CA-200D-2642-FE0F","c":"1F3CA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,41],"o":4},"flag-ws":{"a":"Samoa Flag","b":"1F1FC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,54],"o":2},"woman-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2640-FE0F","non_qualified":"1F3CA-1F3FB-200D-2640","image":"1f3ca-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2640-FE0F","non_qualified":"1F3CA-1F3FC-200D-2640","image":"1f3ca-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2640-FE0F","non_qualified":"1F3CA-1F3FD-200D-2640","image":"1f3ca-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2640-FE0F","non_qualified":"1F3CA-1F3FE-200D-2640","image":"1f3ca-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2640-FE0F","non_qualified":"1F3CA-1F3FF-200D-2640","image":"1f3ca-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Swimming","b":"1F3CA-200D-2640-FE0F","c":"1F3CA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,35],"o":4},"flag-xk":{"a":"Kosovo Flag","b":"1F1FD-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,55],"o":2},"person_with_ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB","non_qualified":null,"image":"26f9-1f3fb.png","sheet_x":54,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"26F9-1F3FC","non_qualified":null,"image":"26f9-1f3fc.png","sheet_x":54,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"26F9-1F3FD","non_qualified":null,"image":"26f9-1f3fd.png","sheet_x":54,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"26F9-1F3FE","non_qualified":null,"image":"26f9-1f3fe.png","sheet_x":54,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"26F9-1F3FF","non_qualified":null,"image":"26f9-1f3ff.png","sheet_x":54,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"26F9-FE0F-200D-2642-FE0F","a":"Person with Ball","b":"26F9-FE0F","c":"26F9","d":true,"e":true,"f":true,"h":false,"k":[54,31],"o":2},"flag-ye":{"a":"Yemen Flag","b":"1F1FE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,56],"o":2},"man-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2642-FE0F","non_qualified":"26F9-1F3FB-200D-2642","image":"26f9-1f3fb-200d-2642-fe0f.png","sheet_x":54,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2642-FE0F","non_qualified":"26F9-1F3FC-200D-2642","image":"26f9-1f3fc-200d-2642-fe0f.png","sheet_x":54,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2642-FE0F","non_qualified":"26F9-1F3FD-200D-2642","image":"26f9-1f3fd-200d-2642-fe0f.png","sheet_x":54,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2642-FE0F","non_qualified":"26F9-1F3FE-200D-2642","image":"26f9-1f3fe-200d-2642-fe0f.png","sheet_x":54,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2642-FE0F","non_qualified":"26F9-1F3FF-200D-2642","image":"26f9-1f3ff-200d-2642-fe0f.png","sheet_x":54,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"26F9-FE0F","a":"Man Bouncing Ball","b":"26F9-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,25],"o":4},"flag-yt":{"a":"Mayotte Flag","b":"1F1FE-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[5,0],"o":2},"woman-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2640-FE0F","non_qualified":"26F9-1F3FB-200D-2640","image":"26f9-1f3fb-200d-2640-fe0f.png","sheet_x":54,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2640-FE0F","non_qualified":"26F9-1F3FC-200D-2640","image":"26f9-1f3fc-200d-2640-fe0f.png","sheet_x":54,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2640-FE0F","non_qualified":"26F9-1F3FD-200D-2640","image":"26f9-1f3fd-200d-2640-fe0f.png","sheet_x":54,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2640-FE0F","non_qualified":"26F9-1F3FE-200D-2640","image":"26f9-1f3fe-200d-2640-fe0f.png","sheet_x":54,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2640-FE0F","non_qualified":"26F9-1F3FF-200D-2640","image":"26f9-1f3ff-200d-2640-fe0f.png","sheet_x":54,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bouncing Ball","b":"26F9-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,19],"o":4},"flag-za":{"a":"South Africa Flag","b":"1F1FF-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[5,1],"o":2},"flag-zm":{"a":"Zambia Flag","b":"1F1FF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[5,2],"o":2},"weight_lifter":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB","non_qualified":null,"image":"1f3cb-1f3fb.png","sheet_x":10,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CB-1F3FC","non_qualified":null,"image":"1f3cb-1f3fc.png","sheet_x":10,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CB-1F3FD","non_qualified":null,"image":"1f3cb-1f3fd.png","sheet_x":10,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CB-1F3FE","non_qualified":null,"image":"1f3cb-1f3fe.png","sheet_x":10,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CB-1F3FF","non_qualified":null,"image":"1f3cb-1f3ff.png","sheet_x":10,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CB-FE0F-200D-2642-FE0F","a":"Weight Lifter","b":"1F3CB-FE0F","c":"1F3CB","d":true,"e":true,"f":true,"h":false,"k":[10,8],"o":2},"man-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2642-FE0F","non_qualified":"1F3CB-1F3FB-200D-2642","image":"1f3cb-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2642-FE0F","non_qualified":"1F3CB-1F3FC-200D-2642","image":"1f3cb-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2642-FE0F","non_qualified":"1F3CB-1F3FD-200D-2642","image":"1f3cb-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2642-FE0F","non_qualified":"1F3CB-1F3FE-200D-2642","image":"1f3cb-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2642-FE0F","non_qualified":"1F3CB-1F3FF-200D-2642","image":"1f3cb-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CB-FE0F","a":"Man Lifting Weights","b":"1F3CB-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,2],"o":4},"flag-zw":{"a":"Zimbabwe Flag","b":"1F1FF-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[5,3],"o":2},"woman-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2640-FE0F","non_qualified":"1F3CB-1F3FB-200D-2640","image":"1f3cb-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2640-FE0F","non_qualified":"1F3CB-1F3FC-200D-2640","image":"1f3cb-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2640-FE0F","non_qualified":"1F3CB-1F3FD-200D-2640","image":"1f3cb-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2640-FE0F","non_qualified":"1F3CB-1F3FE-200D-2640","image":"1f3cb-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2640-FE0F","non_qualified":"1F3CB-1F3FF-200D-2640","image":"1f3cb-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Lifting Weights","b":"1F3CB-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[9,53],"o":4},"flag-england":{"a":"England Flag","b":"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,14],"o":5},"bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB","non_qualified":null,"image":"1f6b4-1f3fb.png","sheet_x":35,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B4-1F3FC","non_qualified":null,"image":"1f6b4-1f3fc.png","sheet_x":35,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B4-1F3FD","non_qualified":null,"image":"1f6b4-1f3fd.png","sheet_x":35,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B4-1F3FE","non_qualified":null,"image":"1f6b4-1f3fe.png","sheet_x":35,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B4-1F3FF","non_qualified":null,"image":"1f6b4-1f3ff.png","sheet_x":35,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B4-200D-2642-FE0F","a":"Bicyclist","b":"1F6B4","d":true,"e":true,"f":true,"h":false,"k":[35,23],"o":2},"flag-scotland":{"a":"Scotland Flag","b":"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,15],"o":5},"flag-wales":{"a":"Wales Flag","b":"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,16],"o":5},"man-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2642-FE0F","non_qualified":"1F6B4-1F3FB-200D-2642","image":"1f6b4-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2642-FE0F","non_qualified":"1F6B4-1F3FC-200D-2642","image":"1f6b4-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2642-FE0F","non_qualified":"1F6B4-1F3FD-200D-2642","image":"1f6b4-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2642-FE0F","non_qualified":"1F6B4-1F3FE-200D-2642","image":"1f6b4-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2642-FE0F","non_qualified":"1F6B4-1F3FF-200D-2642","image":"1f6b4-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B4","a":"Man Biking","b":"1F6B4-200D-2642-FE0F","c":"1F6B4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,17],"o":4},"woman-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2640-FE0F","non_qualified":"1F6B4-1F3FB-200D-2640","image":"1f6b4-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2640-FE0F","non_qualified":"1F6B4-1F3FC-200D-2640","image":"1f6b4-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2640-FE0F","non_qualified":"1F6B4-1F3FD-200D-2640","image":"1f6b4-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2640-FE0F","non_qualified":"1F6B4-1F3FE-200D-2640","image":"1f6b4-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2640-FE0F","non_qualified":"1F6B4-1F3FF-200D-2640","image":"1f6b4-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Biking","b":"1F6B4-200D-2640-FE0F","c":"1F6B4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,11],"o":4},"mountain_bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB","non_qualified":null,"image":"1f6b5-1f3fb.png","sheet_x":35,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B5-1F3FC","non_qualified":null,"image":"1f6b5-1f3fc.png","sheet_x":35,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B5-1F3FD","non_qualified":null,"image":"1f6b5-1f3fd.png","sheet_x":35,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B5-1F3FE","non_qualified":null,"image":"1f6b5-1f3fe.png","sheet_x":35,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B5-1F3FF","non_qualified":null,"image":"1f6b5-1f3ff.png","sheet_x":35,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B5-200D-2642-FE0F","a":"Mountain Bicyclist","b":"1F6B5","d":true,"e":true,"f":true,"h":false,"k":[35,41],"o":2},"man-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2642-FE0F","non_qualified":"1F6B5-1F3FB-200D-2642","image":"1f6b5-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2642-FE0F","non_qualified":"1F6B5-1F3FC-200D-2642","image":"1f6b5-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2642-FE0F","non_qualified":"1F6B5-1F3FD-200D-2642","image":"1f6b5-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2642-FE0F","non_qualified":"1F6B5-1F3FE-200D-2642","image":"1f6b5-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2642-FE0F","non_qualified":"1F6B5-1F3FF-200D-2642","image":"1f6b5-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B5","a":"Man Mountain Biking","b":"1F6B5-200D-2642-FE0F","c":"1F6B5-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,35],"o":4},"woman-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2640-FE0F","non_qualified":"1F6B5-1F3FB-200D-2640","image":"1f6b5-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2640-FE0F","non_qualified":"1F6B5-1F3FC-200D-2640","image":"1f6b5-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2640-FE0F","non_qualified":"1F6B5-1F3FD-200D-2640","image":"1f6b5-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2640-FE0F","non_qualified":"1F6B5-1F3FE-200D-2640","image":"1f6b5-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2640-FE0F","non_qualified":"1F6B5-1F3FF-200D-2640","image":"1f6b5-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Mountain Biking","b":"1F6B5-200D-2640-FE0F","c":"1F6B5-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,29],"o":4},"person_doing_cartwheel":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB","non_qualified":null,"image":"1f938-1f3fb.png","sheet_x":40,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F938-1F3FC","non_qualified":null,"image":"1f938-1f3fc.png","sheet_x":40,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F938-1F3FD","non_qualified":null,"image":"1f938-1f3fd.png","sheet_x":40,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F938-1F3FE","non_qualified":null,"image":"1f938-1f3fe.png","sheet_x":40,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F938-1F3FF","non_qualified":null,"image":"1f938-1f3ff.png","sheet_x":40,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Person Doing Cartwheel","b":"1F938","d":true,"e":true,"f":true,"h":false,"k":[40,8],"o":4},"man-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2642-FE0F","non_qualified":"1F938-1F3FB-200D-2642","image":"1f938-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2642-FE0F","non_qualified":"1F938-1F3FC-200D-2642","image":"1f938-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2642-FE0F","non_qualified":"1F938-1F3FD-200D-2642","image":"1f938-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2642-FE0F","non_qualified":"1F938-1F3FE-200D-2642","image":"1f938-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2642-FE0F","non_qualified":"1F938-1F3FF-200D-2642","image":"1f938-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Cartwheeling","b":"1F938-200D-2642-FE0F","c":"1F938-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,2],"o":4},"woman-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2640-FE0F","non_qualified":"1F938-1F3FB-200D-2640","image":"1f938-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2640-FE0F","non_qualified":"1F938-1F3FC-200D-2640","image":"1f938-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2640-FE0F","non_qualified":"1F938-1F3FD-200D-2640","image":"1f938-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2640-FE0F","non_qualified":"1F938-1F3FE-200D-2640","image":"1f938-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2640-FE0F","non_qualified":"1F938-1F3FF-200D-2640","image":"1f938-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Cartwheeling","b":"1F938-200D-2640-FE0F","c":"1F938-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,53],"o":4},"wrestlers":{"a":"Wrestlers","b":"1F93C","d":true,"e":true,"f":true,"h":true,"k":[40,35],"o":4},"man-wrestling":{"a":"Man Wrestling","b":"1F93C-200D-2642-FE0F","c":"1F93C-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,34],"o":4},"woman-wrestling":{"a":"Woman Wrestling","b":"1F93C-200D-2640-FE0F","c":"1F93C-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,33],"o":4},"water_polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB","non_qualified":null,"image":"1f93d-1f3fb.png","sheet_x":40,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93D-1F3FC","non_qualified":null,"image":"1f93d-1f3fc.png","sheet_x":40,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93D-1F3FD","non_qualified":null,"image":"1f93d-1f3fd.png","sheet_x":40,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93D-1F3FE","non_qualified":null,"image":"1f93d-1f3fe.png","sheet_x":40,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93D-1F3FF","non_qualified":null,"image":"1f93d-1f3ff.png","sheet_x":40,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Water Polo","b":"1F93D","d":true,"e":true,"f":true,"h":false,"k":[40,48],"o":4},"man-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2642-FE0F","non_qualified":"1F93D-1F3FB-200D-2642","image":"1f93d-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2642-FE0F","non_qualified":"1F93D-1F3FC-200D-2642","image":"1f93d-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2642-FE0F","non_qualified":"1F93D-1F3FD-200D-2642","image":"1f93d-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2642-FE0F","non_qualified":"1F93D-1F3FE-200D-2642","image":"1f93d-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2642-FE0F","non_qualified":"1F93D-1F3FF-200D-2642","image":"1f93d-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Water Polo","b":"1F93D-200D-2642-FE0F","c":"1F93D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,42],"o":4},"woman-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2640-FE0F","non_qualified":"1F93D-1F3FB-200D-2640","image":"1f93d-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2640-FE0F","non_qualified":"1F93D-1F3FC-200D-2640","image":"1f93d-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2640-FE0F","non_qualified":"1F93D-1F3FD-200D-2640","image":"1f93d-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2640-FE0F","non_qualified":"1F93D-1F3FE-200D-2640","image":"1f93d-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2640-FE0F","non_qualified":"1F93D-1F3FF-200D-2640","image":"1f93d-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Water Polo","b":"1F93D-200D-2640-FE0F","c":"1F93D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,36],"o":4},"handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB","non_qualified":null,"image":"1f93e-1f3fb.png","sheet_x":41,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93E-1F3FC","non_qualified":null,"image":"1f93e-1f3fc.png","sheet_x":41,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93E-1F3FD","non_qualified":null,"image":"1f93e-1f3fd.png","sheet_x":41,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93E-1F3FE","non_qualified":null,"image":"1f93e-1f3fe.png","sheet_x":41,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93E-1F3FF","non_qualified":null,"image":"1f93e-1f3ff.png","sheet_x":41,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Handball","b":"1F93E","d":true,"e":true,"f":true,"h":false,"k":[41,9],"o":4},"man-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2642-FE0F","non_qualified":"1F93E-1F3FB-200D-2642","image":"1f93e-1f3fb-200d-2642-fe0f.png","sheet_x":41,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2642-FE0F","non_qualified":"1F93E-1F3FC-200D-2642","image":"1f93e-1f3fc-200d-2642-fe0f.png","sheet_x":41,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2642-FE0F","non_qualified":"1F93E-1F3FD-200D-2642","image":"1f93e-1f3fd-200d-2642-fe0f.png","sheet_x":41,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2642-FE0F","non_qualified":"1F93E-1F3FE-200D-2642","image":"1f93e-1f3fe-200d-2642-fe0f.png","sheet_x":41,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2642-FE0F","non_qualified":"1F93E-1F3FF-200D-2642","image":"1f93e-1f3ff-200d-2642-fe0f.png","sheet_x":41,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Handball","b":"1F93E-200D-2642-FE0F","c":"1F93E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[41,3],"o":4},"woman-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2640-FE0F","non_qualified":"1F93E-1F3FB-200D-2640","image":"1f93e-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2640-FE0F","non_qualified":"1F93E-1F3FC-200D-2640","image":"1f93e-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2640-FE0F","non_qualified":"1F93E-1F3FD-200D-2640","image":"1f93e-1f3fd-200d-2640-fe0f.png","sheet_x":41,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2640-FE0F","non_qualified":"1F93E-1F3FE-200D-2640","image":"1f93e-1f3fe-200d-2640-fe0f.png","sheet_x":41,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2640-FE0F","non_qualified":"1F93E-1F3FF-200D-2640","image":"1f93e-1f3ff-200d-2640-fe0f.png","sheet_x":41,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Handball","b":"1F93E-200D-2640-FE0F","c":"1F93E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,54],"o":4},"juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB","non_qualified":null,"image":"1f939-1f3fb.png","sheet_x":40,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC","non_qualified":null,"image":"1f939-1f3fc.png","sheet_x":40,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD","non_qualified":null,"image":"1f939-1f3fd.png","sheet_x":40,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE","non_qualified":null,"image":"1f939-1f3fe.png","sheet_x":40,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF","non_qualified":null,"image":"1f939-1f3ff.png","sheet_x":40,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Juggling","b":"1F939","d":true,"e":true,"f":true,"h":true,"k":[40,26],"o":4},"man-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2642-FE0F","non_qualified":"1F939-1F3FB-200D-2642","image":"1f939-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2642-FE0F","non_qualified":"1F939-1F3FC-200D-2642","image":"1f939-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2642-FE0F","non_qualified":"1F939-1F3FD-200D-2642","image":"1f939-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2642-FE0F","non_qualified":"1F939-1F3FE-200D-2642","image":"1f939-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2642-FE0F","non_qualified":"1F939-1F3FF-200D-2642","image":"1f939-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Juggling","b":"1F939-200D-2642-FE0F","c":"1F939-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,20],"o":4},"woman-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2640-FE0F","non_qualified":"1F939-1F3FB-200D-2640","image":"1f939-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2640-FE0F","non_qualified":"1F939-1F3FC-200D-2640","image":"1f939-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2640-FE0F","non_qualified":"1F939-1F3FD-200D-2640","image":"1f939-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2640-FE0F","non_qualified":"1F939-1F3FE-200D-2640","image":"1f939-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2640-FE0F","non_qualified":"1F939-1F3FF-200D-2640","image":"1f939-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Juggling","b":"1F939-200D-2640-FE0F","c":"1F939-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,14],"o":4},"person_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB","non_qualified":null,"image":"1f9d8-1f3fb.png","sheet_x":49,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D8-1F3FC","non_qualified":null,"image":"1f9d8-1f3fc.png","sheet_x":49,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D8-1F3FD","non_qualified":null,"image":"1f9d8-1f3fd.png","sheet_x":49,"sheet_y":34,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D8-1F3FE","non_qualified":null,"image":"1f9d8-1f3fe.png","sheet_x":49,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D8-1F3FF","non_qualified":null,"image":"1f9d8-1f3ff.png","sheet_x":49,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D8-200D-2640-FE0F","a":"Person in Lotus Position","b":"1F9D8","d":true,"e":true,"f":true,"h":true,"k":[49,31],"o":5},"man_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2642-FE0F","non_qualified":"1F9D8-1F3FB-200D-2642","image":"1f9d8-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2642-FE0F","non_qualified":"1F9D8-1F3FC-200D-2642","image":"1f9d8-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2642-FE0F","non_qualified":"1F9D8-1F3FD-200D-2642","image":"1f9d8-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":28,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2642-FE0F","non_qualified":"1F9D8-1F3FE-200D-2642","image":"1f9d8-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2642-FE0F","non_qualified":"1F9D8-1F3FF-200D-2642","image":"1f9d8-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Lotus Position","b":"1F9D8-200D-2642-FE0F","c":"1F9D8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,25],"o":5},"woman_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2640-FE0F","non_qualified":"1F9D8-1F3FB-200D-2640","image":"1f9d8-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FB"},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2640-FE0F","non_qualified":"1F9D8-1F3FC-200D-2640","image":"1f9d8-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FC"},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2640-FE0F","non_qualified":"1F9D8-1F3FD-200D-2640","image":"1f9d8-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":22,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FD"},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2640-FE0F","non_qualified":"1F9D8-1F3FE-200D-2640","image":"1f9d8-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FE"},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2640-FE0F","non_qualified":"1F9D8-1F3FF-200D-2640","image":"1f9d8-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FF"}},"obsoletes":"1F9D8","a":"Woman in Lotus Position","b":"1F9D8-200D-2640-FE0F","c":"1F9D8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,19],"o":5},"bath":{"skin_variations":{"1F3FB":{"unified":"1F6C0-1F3FB","non_qualified":null,"image":"1f6c0-1f3fb.png","sheet_x":36,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6C0-1F3FC","non_qualified":null,"image":"1f6c0-1f3fc.png","sheet_x":36,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6C0-1F3FD","non_qualified":null,"image":"1f6c0-1f3fd.png","sheet_x":36,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6C0-1F3FE","non_qualified":null,"image":"1f6c0-1f3fe.png","sheet_x":36,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6C0-1F3FF","non_qualified":null,"image":"1f6c0-1f3ff.png","sheet_x":36,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bath","b":"1F6C0","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,17],"o":2},"sleeping_accommodation":{"skin_variations":{"1F3FB":{"unified":"1F6CC-1F3FB","non_qualified":null,"image":"1f6cc-1f3fb.png","sheet_x":36,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6CC-1F3FC","non_qualified":null,"image":"1f6cc-1f3fc.png","sheet_x":36,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6CC-1F3FD","non_qualified":null,"image":"1f6cc-1f3fd.png","sheet_x":36,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6CC-1F3FE","non_qualified":null,"image":"1f6cc-1f3fe.png","sheet_x":36,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6CC-1F3FF","non_qualified":null,"image":"1f6cc-1f3ff.png","sheet_x":36,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sleeping Accommodation","b":"1F6CC","d":true,"e":true,"f":true,"h":true,"k":[36,29],"o":2},"people_holding_hands":{"skin_variations":{"1F3FB-1F3FB":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FC":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FD":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FE":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":47,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":47,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":47,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FF":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"People Holding Hands","b":"1F9D1-200D-1F91D-200D-1F9D1","d":true,"e":true,"f":true,"h":true,"k":[46,38],"o":12},"two_women_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46D-1F3FB","non_qualified":null,"image":"1f46d-1f3fb.png","sheet_x":21,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46D-1F3FC","non_qualified":null,"image":"1f46d-1f3fc.png","sheet_x":21,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46D-1F3FD","non_qualified":null,"image":"1f46d-1f3fd.png","sheet_x":21,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46D-1F3FE","non_qualified":null,"image":"1f46d-1f3fe.png","sheet_x":21,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46D-1F3FF","non_qualified":null,"image":"1f46d-1f3ff.png","sheet_x":21,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Women Holding Hands","b":"1F46D","d":true,"e":true,"f":true,"h":true,"j":["pair","friendship","couple","love","like","female","people","human"],"k":[21,11],"n":["women_holding_hands"],"o":2},"couple":{"skin_variations":{"1F3FB":{"unified":"1F46B-1F3FB","non_qualified":null,"image":"1f46b-1f3fb.png","sheet_x":20,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46B-1F3FC","non_qualified":null,"image":"1f46b-1f3fc.png","sheet_x":20,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46B-1F3FD","non_qualified":null,"image":"1f46b-1f3fd.png","sheet_x":20,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46B-1F3FE","non_qualified":null,"image":"1f46b-1f3fe.png","sheet_x":20,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46B-1F3FF","non_qualified":null,"image":"1f46b-1f3ff.png","sheet_x":20,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man and Woman Holding Hands","b":"1F46B","d":true,"e":true,"f":true,"h":true,"j":["pair","people","human","love","date","dating","like","affection","valentines","marriage"],"k":[20,16],"n":["man_and_woman_holding_hands","woman_and_man_holding_hands"],"o":2},"two_men_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46C-1F3FB","non_qualified":null,"image":"1f46c-1f3fb.png","sheet_x":20,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46C-1F3FC","non_qualified":null,"image":"1f46c-1f3fc.png","sheet_x":20,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46C-1F3FD","non_qualified":null,"image":"1f46c-1f3fd.png","sheet_x":20,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46C-1F3FE","non_qualified":null,"image":"1f46c-1f3fe.png","sheet_x":20,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46C-1F3FF","non_qualified":null,"image":"1f46c-1f3ff.png","sheet_x":20,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Men Holding Hands","b":"1F46C","d":true,"e":true,"f":true,"h":true,"j":["pair","couple","love","like","bromance","friendship","people","human"],"k":[20,42],"n":["men_holding_hands"],"o":2},"couplekiss":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","a":"Kiss","b":"1F48F","d":true,"e":true,"f":true,"h":true,"k":[25,25],"o":2},"woman-kiss-man":{"obsoletes":"1F48F","a":"Woman Kiss Man","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F469-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,7],"o":2},"man-kiss-man":{"a":"Man Kiss Man","b":"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F468-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,21],"o":2},"woman-kiss-woman":{"a":"Woman Kiss Woman","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469","c":"1F469-200D-2764-200D-1F48B-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,8],"o":2},"couple_with_heart":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F468","a":"Couple with Heart","b":"1F491","d":true,"e":true,"f":true,"h":true,"k":[25,27],"o":2},"woman-heart-man":{"obsoletes":"1F491","a":"Woman Heart Man","b":"1F469-200D-2764-FE0F-200D-1F468","c":"1F469-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,5],"o":2},"man-heart-man":{"a":"Man Heart Man","b":"1F468-200D-2764-FE0F-200D-1F468","c":"1F468-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,20],"o":2},"woman-heart-woman":{"a":"Woman Heart Woman","b":"1F469-200D-2764-FE0F-200D-1F469","c":"1F469-200D-2764-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,6],"o":2},"family":{"obsoleted_by":"1F468-200D-1F469-200D-1F466","a":"Family","b":"1F46A","d":true,"e":true,"f":true,"h":true,"k":[20,15],"n":["man-woman-boy"],"o":2},"man-woman-boy":{"obsoletes":"1F46A","a":"Man Woman Boy","b":"1F468-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,33],"n":["family"],"o":2},"man-woman-girl":{"a":"Man Woman Girl","b":"1F468-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,35],"o":2},"man-woman-girl-boy":{"a":"Man Woman Girl Boy","b":"1F468-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,36],"o":2},"man-woman-boy-boy":{"a":"Man Woman Boy Boy","b":"1F468-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,34],"o":2},"man-woman-girl-girl":{"a":"Man Woman Girl Girl","b":"1F468-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,37],"o":2},"man-man-boy":{"a":"Man Man Boy","b":"1F468-200D-1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,28],"o":2},"man-man-girl":{"a":"Man Man Girl","b":"1F468-200D-1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,30],"o":2},"man-man-girl-boy":{"a":"Man Man Girl Boy","b":"1F468-200D-1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,31],"o":2},"man-man-boy-boy":{"a":"Man Man Boy Boy","b":"1F468-200D-1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,29],"o":2},"man-man-girl-girl":{"a":"Man Man Girl Girl","b":"1F468-200D-1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,32],"o":2},"woman-woman-boy":{"a":"Woman Woman Boy","b":"1F469-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,18],"o":2},"woman-woman-girl":{"a":"Woman Woman Girl","b":"1F469-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,20],"o":2},"woman-woman-girl-boy":{"a":"Woman Woman Girl Boy","b":"1F469-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,21],"o":2},"woman-woman-boy-boy":{"a":"Woman Woman Boy Boy","b":"1F469-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,19],"o":2},"woman-woman-girl-girl":{"a":"Woman Woman Girl Girl","b":"1F469-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,22],"o":2},"man-boy":{"a":"Man Boy","b":"1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,24],"o":4},"man-boy-boy":{"a":"Man Boy Boy","b":"1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,23],"o":4},"man-girl":{"a":"Man Girl","b":"1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,27],"o":4},"man-girl-boy":{"a":"Man Girl Boy","b":"1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,25],"o":4},"man-girl-girl":{"a":"Man Girl Girl","b":"1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,26],"o":4},"woman-boy":{"a":"Woman Boy","b":"1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,14],"o":4},"woman-boy-boy":{"a":"Woman Boy Boy","b":"1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,13],"o":4},"woman-girl":{"a":"Woman Girl","b":"1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,17],"o":4},"woman-girl-boy":{"a":"Woman Girl Boy","b":"1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,15],"o":4},"woman-girl-girl":{"a":"Woman Girl Girl","b":"1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,16],"o":4},"speaking_head_in_silhouette":{"a":"Speaking Head in Silhouette","b":"1F5E3-FE0F","c":"1F5E3","d":true,"e":true,"f":true,"h":true,"k":[30,25],"o":2},"bust_in_silhouette":{"a":"Bust in Silhouette","b":"1F464","d":true,"e":true,"f":true,"h":true,"j":["user","person","human"],"k":[14,24],"o":2},"busts_in_silhouette":{"a":"Busts in Silhouette","b":"1F465","d":true,"e":true,"f":true,"h":true,"j":["user","person","human","group","team"],"k":[14,25],"o":2},"footprints":{"a":"Footprints","b":"1F463","d":true,"e":true,"f":true,"h":true,"j":["feet","tracking","walking","beach"],"k":[14,23],"o":2}}`);
const aliases = { "raised_hand": "hand", "satisfied": "laughing", "tshirt": "shirt", "hand_with_index_and_middle_fingers_crossed": "crossed_fingers", "sign_of_the_horns": "the_horns", "grinning_face_with_star_eyes": "star-struck", "reversed_hand_with_middle_finger_extended": "middle_finger", "thumbsup": "+1", "thumbsdown": "-1", "punch": "facepunch", "grinning_face_with_one_large_and_one_small_eye": "zany_face", "shoe": "mans_shoe", "smiling_face_with_smiling_eyes_and_hand_covering_mouth": "face_with_hand_over_mouth", "face_with_finger_covering_closed_lips": "shushing_face", "face_with_one_eyebrow_raised": "face_with_raised_eyebrow", "face_with_open_mouth_vomiting": "face_vomiting", "cooking": "fried_egg", "flag-cn": "cn", "shocked_face_with_exploding_head": "exploding_head", "paw_prints": "feet", "flag-de": "de", "telephone": "phone", "flag-es": "es", "red_car": "car", "flipper": "dolphin", "flag-fr": "fr", "uk": "gb", "flag-gb": "gb", "serious_face_with_symbols_covering_mouth": "face_with_symbols_on_mouth", "poop": "hankey", "shit": "hankey", "honeybee": "bee", "staff_of_aesculapius": "medical_symbol", "lantern": "izakaya_lantern", "open_book": "book", "sailboat": "boat", "knife": "hocho", "flag-it": "it", "heavy_exclamation_mark": "exclamation", "flag-jp": "jp", "envelope": "email", "flag-kr": "kr", "collision": "boom", "pencil": "memo", "waxing_gibbous_moon": "moon", "mother_christmas": "mrs_claus", "sun_small_cloud": "mostly_sunny", "sun_behind_cloud": "barely_sunny", "sun_behind_rain_cloud": "partly_sunny_rain", "lightning_cloud": "lightning", "tornado_cloud": "tornado", "flag-ru": "ru", "running": "runner", "flag-us": "us", "women_holding_hands": "two_women_holding_hands", "man_and_woman_holding_hands": "couple", "woman_and_man_holding_hands": "couple", "men_holding_hands": "two_men_holding_hands", "man-woman-boy": "family", "family": "man-woman-boy" };
const data = {
  compressed,
  categories: categories$1,
  emojis,
  aliases
};
var _typeofExports = require_typeof$1();
const _typeof = /* @__PURE__ */ getDefaultExportFromCjs(_typeofExports);
var mapping = {
  name: "a",
  unified: "b",
  non_qualified: "c",
  has_img_apple: "d",
  has_img_google: "e",
  has_img_twitter: "f",
  has_img_facebook: "h",
  keywords: "j",
  sheet: "k",
  emoticons: "l",
  text: "m",
  short_names: "n",
  added_in: "o"
};
var buildSearch = function buildSearch2(emoji) {
  var search3 = [];
  var addToSearch = function addToSearch2(strings, split) {
    if (!strings) {
      return;
    }
    (Array.isArray(strings) ? strings : [strings]).forEach(function(string3) {
      (split ? string3.split(/[-|_|\s]+/) : [string3]).forEach(function(s) {
        s = s.toLowerCase();
        if (search3.indexOf(s) == -1) {
          search3.push(s);
        }
      });
    });
  };
  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false);
  addToSearch(emoji.emoticons, false);
  return search3.join(",");
};
var uncompress = function uncompress2(data2) {
  data2.compressed = false;
  for (var id2 in data2.emojis) {
    var emoji = data2.emojis[id2];
    for (var key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }
    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id2);
    emoji.sheet_x = emoji.sheet[0];
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;
    if (!emoji.text) emoji.text = "";
    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);
    emoji.search = buildSearch(emoji);
  }
};
var _String = String;
const stringFromCodePoint = _String.fromCodePoint || function stringFromCodePoint2() {
  var MAX_SIZE = 16384;
  var codeUnits = [];
  var highSurrogate;
  var lowSurrogate;
  var index2 = -1;
  var length2 = arguments.length;
  if (!length2) {
    return "";
  }
  var result = "";
  while (++index2 < length2) {
    var codePoint = Number(arguments[index2]);
    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 1114111 || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint) {
      throw RangeError("Invalid code point: " + codePoint);
    }
    if (codePoint <= 65535) {
      codeUnits.push(codePoint);
    } else {
      codePoint -= 65536;
      highSurrogate = (codePoint >> 10) + 55296;
      lowSurrogate = codePoint % 1024 + 56320;
      codeUnits.push(highSurrogate, lowSurrogate);
    }
    if (index2 + 1 === length2 || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};
var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ["1F3FA", "1F3FB", "1F3FC", "1F3FD", "1F3FE", "1F3FF"];
function unifiedToNative(unified) {
  var unicodes = unified.split("-"), codePoints = unicodes.map(function(u) {
    return "0x".concat(u);
  });
  return stringFromCodePoint.apply(null, codePoints);
}
function sanitize(emoji) {
  var name = emoji.name, short_names = emoji.short_names, skin_tone = emoji.skin_tone, skin_variations = emoji.skin_variations, emoticons = emoji.emoticons, unified = emoji.unified, custom2 = emoji.custom, customCategory = emoji.customCategory, imageUrl = emoji.imageUrl, id2 = emoji.id || short_names[0], colons = ":".concat(id2, ":");
  if (custom2) {
    return {
      id: id2,
      name,
      short_names,
      colons,
      emoticons,
      custom: custom2,
      customCategory,
      imageUrl
    };
  }
  if (skin_tone) {
    colons += ":skin-tone-".concat(skin_tone, ":");
  }
  return {
    id: id2,
    name,
    short_names,
    colons,
    emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    "native": unifiedToNative(unified)
  };
}
function getSanitizedData() {
  return sanitize(getData.apply(void 0, arguments));
}
function getData(emoji, skin, set2, data2) {
  var emojiData = {};
  if (typeof emoji == "string") {
    var matches = emoji.match(COLONS_REGEX);
    if (matches) {
      emoji = matches[1];
      if (matches[2]) {
        skin = parseInt(matches[2], 10);
      }
    }
    if (data2.aliases.hasOwnProperty(emoji)) {
      emoji = data2.aliases[emoji];
    }
    if (data2.emojis.hasOwnProperty(emoji)) {
      emojiData = data2.emojis[emoji];
    } else {
      return null;
    }
  } else if (emoji.id) {
    if (data2.aliases.hasOwnProperty(emoji.id)) {
      emoji.id = data2.aliases[emoji.id];
    }
    if (data2.emojis.hasOwnProperty(emoji.id)) {
      emojiData = data2.emojis[emoji.id];
      skin || (skin = emoji.skin);
    }
  }
  if (!Object.keys(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;
    if (!emojiData.search) {
      emojiData.search = buildSearch(emoji);
    }
  }
  emojiData.emoticons || (emojiData.emoticons = []);
  emojiData.variations || (emojiData.variations = []);
  if (emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    var skinKey = SKINS[skin - 1], variationData = emojiData.skin_variations[skinKey];
    if (variationData) {
      if (!variationData.variations && emojiData.variations) {
        delete emojiData.variations;
      }
      if (set2 && (variationData["has_img_".concat(set2)] == void 0 || variationData["has_img_".concat(set2)]) || !set2) {
        emojiData.skin_tone = skin;
        for (var k in variationData) {
          var v = variationData[k];
          emojiData[k] = v;
        }
      }
    }
  }
  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }
  return emojiData;
}
function uniq(arr) {
  return arr.reduce(function(acc, item2) {
    if (acc.indexOf(item2) === -1) {
      acc.push(item2);
    }
    return acc;
  }, []);
}
function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);
  return uniqA.filter(function(item2) {
    return uniqB.indexOf(item2) >= 0;
  });
}
function deepMerge(a, b) {
  var o = {};
  for (var key in a) {
    var originalValue = a[key], value = originalValue;
    if (b.hasOwnProperty(key)) {
      value = b[key];
    }
    if (_typeof(value) === "object") {
      value = deepMerge(originalValue, value);
    }
    o[key] = value;
  }
  return o;
}
function measureScrollbar() {
  if (typeof document == "undefined") return 0;
  var div = document.createElement("div");
  div.style.width = "100px";
  div.style.height = "100px";
  div.style.overflow = "scroll";
  div.style.position = "absolute";
  div.style.top = "-9999px";
  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return scrollbarWidth;
}
function throttleIdleTask(func) {
  var doIdleTask = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;
  var running = false;
  return function throttled() {
    if (running) {
      return;
    }
    running = true;
    doIdleTask(function() {
      running = false;
      func();
    });
  };
}
var NAMESPACE = "emoji-mart";
var isLocalStorageSupported = typeof window !== "undefined" && "localStorage" in window;
var getter;
var setter;
function setHandlers(handlers) {
  handlers || (handlers = {});
  getter = handlers.getter;
  setter = handlers.setter;
}
function setNamespace(namespace) {
  NAMESPACE = namespace;
}
function update(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}
function set(key, value) {
  if (setter) {
    setter(key, value);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      window.localStorage["".concat(NAMESPACE, ".").concat(key)] = JSON.stringify(value);
    } catch (e) {
    }
  }
}
function get$1(key) {
  if (getter) {
    return getter(key);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      var value = window.localStorage["".concat(NAMESPACE, ".").concat(key)];
      if (value) {
        return JSON.parse(value);
      }
    } catch (e) {
      return;
    }
  }
}
const store = {
  update,
  set,
  get: get$1,
  setNamespace,
  setHandlers
};
var NimbleEmojiIndex = /* @__PURE__ */ (function() {
  function NimbleEmojiIndex2(data2, set2) {
    _classCallCheck$2(this, NimbleEmojiIndex2);
    if (data2.compressed) {
      uncompress(data2);
    }
    this.data = data2 || {};
    this.set = set2 || null;
    this.originalPool = {};
    this.index = {};
    this.emojis = {};
    this.emoticons = {};
    this.customEmojisList = [];
    this.buildIndex();
  }
  _createClass$2(NimbleEmojiIndex2, [{
    key: "buildIndex",
    value: function buildIndex() {
      var _this = this;
      var _loop = function _loop2(emoji2) {
        var emojiData = _this.data.emojis[emoji2], short_names = emojiData.short_names, emoticons = emojiData.emoticons, skin_variations = emojiData.skin_variations, id2 = short_names[0];
        if (emoticons) {
          emoticons.forEach(function(emoticon) {
            if (_this.emoticons[emoticon]) {
              return;
            }
            _this.emoticons[emoticon] = id2;
          });
        }
        if (skin_variations) {
          _this.emojis[id2] = {};
          for (var skinTone = 1; skinTone <= 6; skinTone++) {
            _this.emojis[id2][skinTone] = getSanitizedData({
              id: id2,
              skin: skinTone
            }, skinTone, _this.set, _this.data);
          }
        } else {
          _this.emojis[id2] = getSanitizedData(id2, null, _this.set, _this.data);
        }
        _this.originalPool[id2] = emojiData;
      };
      for (var emoji in this.data.emojis) {
        _loop(emoji);
      }
    }
  }, {
    key: "clearCustomEmojis",
    value: function clearCustomEmojis(pool) {
      var _this2 = this;
      this.customEmojisList.forEach(function(emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        delete pool[emojiId];
        delete _this2.emojis[emojiId];
      });
    }
  }, {
    key: "addCustomToPool",
    value: function addCustomToPool(custom2, pool) {
      var _this3 = this;
      if (this.customEmojisList.length) this.clearCustomEmojis(pool);
      custom2.forEach(function(emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = getData(emoji, null, null, _this3.data);
          _this3.emojis[emojiId] = getSanitizedData(emoji, null, null, _this3.data);
        }
      });
      this.customEmojisList = custom2;
      this.index = {};
    }
  }, {
    key: "search",
    value: function search3(value) {
      var _this4 = this;
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, emojisToShowFilter = _ref.emojisToShowFilter, maxResults = _ref.maxResults, include = _ref.include, exclude = _ref.exclude, _ref$custom = _ref.custom, custom2 = _ref$custom === void 0 ? [] : _ref$custom;
      if (this.customEmojisList != custom2) this.addCustomToPool(custom2, this.originalPool);
      var skinTone = store.get("skin") || 1;
      maxResults || (maxResults = 75);
      include || (include = []);
      exclude || (exclude = []);
      var results = null, pool = this.originalPool;
      if (value.length) {
        if (value == "-" || value == "-1") {
          return [this.emojis["-1"][skinTone]];
        }
        var values = value.toLowerCase().split(/[\s|,|\-|_]+/), allResults = [];
        if (values.length > 2) {
          values = [values[0], values[1]];
        }
        if (include.length || exclude.length) {
          pool = {};
          this.data.categories.forEach(function(category) {
            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) {
              return;
            }
            category.emojis.forEach(function(emojiId) {
              return pool[emojiId] = _this4.data.emojis[emojiId];
            });
          });
          if (custom2.length) {
            var customIsIncluded = include && include.length ? include.indexOf("custom") > -1 : true;
            var customIsExcluded = exclude && exclude.length ? exclude.indexOf("custom") > -1 : false;
            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom2, pool);
            }
          }
        }
        allResults = values.map(function(value2) {
          var aPool = pool, aIndex = _this4.index, length2 = 0;
          for (var charIndex = 0; charIndex < value2.length; charIndex++) {
            var _char = value2[charIndex];
            length2++;
            aIndex[_char] || (aIndex[_char] = {});
            aIndex = aIndex[_char];
            if (!aIndex.results) {
              (function() {
                var scores = {};
                aIndex.results = [];
                aIndex.pool = {};
                for (var id2 in aPool) {
                  var emoji = aPool[id2], search4 = emoji.search, sub = value2.substr(0, length2), subIndex = search4.indexOf(sub);
                  if (subIndex != -1) {
                    var score = subIndex + 1;
                    if (sub == id2) score = 0;
                    if (_this4.emojis[id2] && _this4.emojis[id2][skinTone]) {
                      aIndex.results.push(_this4.emojis[id2][skinTone]);
                    } else {
                      aIndex.results.push(_this4.emojis[id2]);
                    }
                    aIndex.pool[id2] = emoji;
                    scores[id2] = score;
                  }
                }
                aIndex.results.sort(function(a, b) {
                  var aScore = scores[a.id], bScore = scores[b.id];
                  if (aScore == bScore) {
                    return a.id.localeCompare(b.id);
                  } else {
                    return aScore - bScore;
                  }
                });
              })();
            }
            aPool = aIndex.pool;
          }
          return aIndex.results;
        }).filter(function(a) {
          return a;
        });
        if (allResults.length > 1) {
          results = intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }
      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(function(result) {
            return emojisToShowFilter(pool[result.id]);
          });
        }
        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }
      return results;
    }
  }]);
  return NimbleEmojiIndex2;
})();
var emojiIndex = new NimbleEmojiIndex(data);
emojiIndex.emojis;
emojiIndex.emoticons;
var DEFAULTS = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart", "poop"];
var frequently, initialized;
var defaults$1 = {};
function init() {
  initialized = true;
  frequently = store.get("frequently");
}
function add2(emoji) {
  if (!initialized) init();
  var id2 = emoji.id;
  frequently || (frequently = defaults$1);
  frequently[id2] || (frequently[id2] = 0);
  frequently[id2] += 1;
  store.set("last", id2);
  store.set("frequently", frequently);
}
function get(perLine) {
  if (!initialized) init();
  if (!frequently) {
    defaults$1 = {};
    var result = [];
    for (var i = 0; i < perLine; i++) {
      defaults$1[DEFAULTS[i]] = perLine - i;
      result.push(DEFAULTS[i]);
    }
    return result;
  }
  var quantity = perLine * 4;
  var frequentlyKeys = [];
  for (var key in frequently) {
    if (frequently.hasOwnProperty(key)) {
      frequentlyKeys.push(key);
    }
  }
  var sorted = frequentlyKeys.sort(function(a, b) {
    return frequently[a] - frequently[b];
  }).reverse();
  var sliced = sorted.slice(0, quantity);
  var last = store.get("last");
  if (last && sliced.indexOf(last) == -1) {
    sliced.pop();
    sliced.push(last);
  }
  return sliced;
}
const frequently$1 = {
  add: add2,
  get
};
var assertThisInitializedExports = requireAssertThisInitialized();
const _assertThisInitialized = /* @__PURE__ */ getDefaultExportFromCjs(assertThisInitializedExports);
var categories = {
  activity: function activity() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
    }));
  },
  custom: function custom() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("g", {
      transform: "translate(2.000000, 1.000000)"
    }, React__default.createElement("rect", {
      id: "Rectangle",
      x: "8",
      y: "0",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React__default.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React__default.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    })));
  },
  flags: function flags() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
    }));
  },
  foods: function foods() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
    }));
  },
  nature: function nature() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
    }), React__default.createElement("path", {
      d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
    }));
  },
  objects: function objects() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
    }), React__default.createElement("path", {
      d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
    }));
  },
  people: function people() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }), React__default.createElement("path", {
      d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
    }));
  },
  places: function places() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
    }), React__default.createElement("path", {
      d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
    }));
  },
  recent: function recent() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
    }), React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }));
  },
  symbols: function symbols2() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
    }));
  }
};
var search$1 = {
  search: function search() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React__default.createElement("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    }));
  },
  "delete": function _delete() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React__default.createElement("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    }));
  }
};
const icons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  categories,
  search: search$1
}, Symbol.toStringTag, { value: "Module" }));
var EmojiPropTypes = {
  data: PropTypes.object.isRequired,
  onOver: PropTypes.func,
  onLeave: PropTypes.func,
  onClick: PropTypes.func,
  fallback: PropTypes.func,
  backgroundImageFn: PropTypes.func,
  "native": PropTypes.bool,
  forceSize: PropTypes.bool,
  tooltip: PropTypes.bool,
  useButton: PropTypes.bool,
  skin: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: PropTypes.oneOf([16, 20, 32, 64]),
  sheetColumns: PropTypes.number,
  sheetRows: PropTypes.number,
  set: PropTypes.oneOf(["apple", "google", "twitter", "facebook"]),
  size: PropTypes.number.isRequired,
  emoji: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
var PickerPropTypes = {
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  onSkinChange: PropTypes.func,
  perLine: PropTypes.number,
  emojiSize: PropTypes.number,
  i18n: PropTypes.object,
  style: PropTypes.object,
  title: PropTypes.string,
  emoji: PropTypes.string,
  color: PropTypes.string,
  set: EmojiPropTypes.set,
  skin: EmojiPropTypes.skin,
  "native": PropTypes.bool,
  backgroundImageFn: EmojiPropTypes.backgroundImageFn,
  sheetSize: EmojiPropTypes.sheetSize,
  emojisToShowFilter: PropTypes.func,
  showPreview: PropTypes.bool,
  showSkinTones: PropTypes.bool,
  emojiTooltip: EmojiPropTypes.tooltip,
  useButton: EmojiPropTypes.useButton,
  theme: PropTypes.oneOf(["auto", "light", "dark"]),
  include: PropTypes.arrayOf(PropTypes.string),
  exclude: PropTypes.arrayOf(PropTypes.string),
  recent: PropTypes.arrayOf(PropTypes.string),
  autoFocus: PropTypes.bool,
  enableFrequentEmojiSort: PropTypes.bool,
  custom: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    short_names: PropTypes.arrayOf(PropTypes.string).isRequired,
    emoticons: PropTypes.arrayOf(PropTypes.string),
    keywords: PropTypes.arrayOf(PropTypes.string),
    imageUrl: PropTypes.string,
    spriteUrl: PropTypes.string,
    sheet_x: PropTypes.number,
    sheet_y: PropTypes.number,
    size: PropTypes.number,
    sheetColumns: PropTypes.number,
    sheetRows: PropTypes.number
  })),
  skinEmoji: PropTypes.string,
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string,
  icons: PropTypes.object
};
var Anchors = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(Anchors2, _React$PureComponent);
  function Anchors2(props) {
    var _this;
    _classCallCheck$2(this, Anchors2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Anchors2).call(this, props));
    var defaultCategory = props.categories.filter(function(category) {
      return category.first;
    })[0];
    _this.state = {
      selected: defaultCategory.name
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$2(Anchors2, [{
    key: "handleClick",
    value: function handleClick(e) {
      var index2 = e.currentTarget.getAttribute("data-index");
      var _this$props = this.props, categories2 = _this$props.categories, onAnchorClick2 = _this$props.onAnchorClick;
      onAnchorClick2(categories2[index2], index2);
    }
  }, {
    key: "render",
    value: function render2() {
      var _this2 = this;
      var _this$props2 = this.props, categories2 = _this$props2.categories, color2 = _this$props2.color, i18n = _this$props2.i18n, icons2 = _this$props2.icons, selected2 = this.state.selected;
      return React__default.createElement("nav", {
        className: "emoji-mart-anchors",
        "aria-label": i18n.categorieslabel
      }, categories2.map(function(category, i) {
        var id2 = category.id, name = category.name, anchor = category.anchor, isSelected = name == selected2;
        if (anchor === false) {
          return null;
        }
        var iconId = id2.startsWith("custom-") ? "custom" : id2;
        return React__default.createElement("button", {
          key: id2,
          "aria-label": i18n.categories[iconId],
          title: i18n.categories[iconId],
          "data-index": i,
          type: "button",
          onClick: _this2.handleClick,
          className: "emoji-mart-anchor ".concat(isSelected ? "emoji-mart-anchor-selected" : ""),
          style: {
            color: isSelected ? color2 : null
          }
        }, React__default.createElement("div", {
          className: "emoji-mart-anchor-icon"
        }, icons2.categories[iconId]()), React__default.createElement("span", {
          className: "emoji-mart-anchor-bar",
          style: {
            backgroundColor: color2
          }
        }));
      }));
    }
  }]);
  return Anchors2;
})(React__default.PureComponent);
Anchors.propTypes = {
  categories: PropTypes.array,
  onAnchorClick: PropTypes.func,
  icons: PropTypes.object
};
Anchors.defaultProps = {
  categories: [],
  onAnchorClick: function onAnchorClick() {
  },
  icons: {}
};
var EmojiDefaultProps = {
  skin: 1,
  set: "apple",
  sheetSize: 64,
  sheetColumns: 57,
  sheetRows: 57,
  "native": false,
  forceSize: false,
  tooltip: false,
  useButton: true,
  backgroundImageFn: function backgroundImageFn(set2, sheetSize) {
    return "https://unpkg.com/emoji-datasource-".concat(set2, "@").concat("5.0.1", "/img/").concat(set2, "/sheets-256/").concat(sheetSize, ".png");
  }
};
var PickerDefaultProps = {
  onClick: function onClick() {
  },
  onSelect: function onSelect() {
  },
  onSkinChange: function onSkinChange() {
  },
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: "Emoji Mart™",
  emoji: "department_store",
  color: "#ae65c5",
  set: EmojiDefaultProps.set,
  theme: "light",
  skin: null,
  defaultSkin: EmojiDefaultProps.skin,
  "native": EmojiDefaultProps["native"],
  sheetSize: EmojiDefaultProps.sheetSize,
  backgroundImageFn: EmojiDefaultProps.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: true,
  showSkinTones: true,
  emojiTooltip: EmojiDefaultProps.tooltip,
  useButton: EmojiDefaultProps.useButton,
  autoFocus: false,
  enableFrequentEmojiSort: false,
  custom: [],
  skinEmoji: "",
  notFound: function notFound() {
  },
  notFoundEmoji: "sleuth_or_spy",
  icons: {}
};
function ownKeys$e(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$e(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$e(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var _getData = function _getData2(props) {
  var emoji = props.emoji, skin = props.skin, set2 = props.set, data2 = props.data;
  return getData(emoji, skin, set2, data2);
};
var _getPosition = function _getPosition2(props) {
  var _getData22 = _getData(props), sheet_x = _getData22.sheet_x, sheet_y = _getData22.sheet_y, multiplyX = 100 / (props.sheetColumns - 1), multiplyY = 100 / (props.sheetRows - 1);
  return "".concat(multiplyX * sheet_x, "% ").concat(multiplyY * sheet_y, "%");
};
var _getSanitizedData = function _getSanitizedData2(props) {
  var emoji = props.emoji, skin = props.skin, set2 = props.set, data2 = props.data;
  return getSanitizedData(emoji, skin, set2, data2);
};
var _handleClick = function _handleClick2(e, props) {
  if (!props.onClick) {
    return;
  }
  var onClick2 = props.onClick, emoji = _getSanitizedData(props);
  onClick2(emoji, e);
};
var _handleOver = function _handleOver2(e, props) {
  if (!props.onOver) {
    return;
  }
  var onOver = props.onOver, emoji = _getSanitizedData(props);
  onOver(emoji, e);
};
var _handleLeave = function _handleLeave2(e, props) {
  if (!props.onLeave) {
    return;
  }
  var onLeave = props.onLeave, emoji = _getSanitizedData(props);
  onLeave(emoji, e);
};
var _isNumeric = function _isNumeric2(value) {
  return !isNaN(value - parseFloat(value));
};
var _convertStyleToCSS = function _convertStyleToCSS2(style2) {
  var div = document.createElement("div");
  for (var key in style2) {
    var value = style2[key];
    if (_isNumeric(value)) {
      value += "px";
    }
    div.style[key] = value;
  }
  return div.getAttribute("style");
};
var NimbleEmoji = function NimbleEmoji2(props) {
  if (props.data.compressed) {
    uncompress(props.data);
  }
  for (var k in NimbleEmoji2.defaultProps) {
    if (props[k] == void 0 && NimbleEmoji2.defaultProps[k] != void 0) {
      props[k] = NimbleEmoji2.defaultProps[k];
    }
  }
  var data2 = _getData(props);
  if (!data2) {
    if (props.fallback) {
      return props.fallback(null, props);
    } else {
      return null;
    }
  }
  var unified = data2.unified, custom2 = data2.custom, short_names = data2.short_names, imageUrl = data2.imageUrl, style2 = {}, children2 = props.children, className = "emoji-mart-emoji", nativeEmoji = unified && unifiedToNative(unified), label = [nativeEmoji].concat(short_names).filter(Boolean).join(", "), title = null;
  if (!unified && !custom2) {
    if (props.fallback) {
      return props.fallback(data2, props);
    } else {
      return null;
    }
  }
  if (props.tooltip) {
    title = short_names[0];
  }
  if (props["native"] && unified) {
    className += " emoji-mart-emoji-native";
    style2 = {
      fontSize: props.size
    };
    children2 = nativeEmoji;
    if (props.forceSize) {
      style2.display = "inline-block";
      style2.width = props.size;
      style2.height = props.size;
      style2.wordBreak = "keep-all";
    }
  } else if (custom2) {
    className += " emoji-mart-emoji-custom";
    style2 = {
      width: props.size,
      height: props.size,
      display: "inline-block"
    };
    if (data2.spriteUrl) {
      style2 = _objectSpread$e({}, style2, {
        backgroundImage: "url(".concat(data2.spriteUrl, ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      });
    } else {
      style2 = _objectSpread$e({}, style2, {
        backgroundImage: "url(".concat(imageUrl, ")"),
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      });
    }
  } else {
    var setHasEmoji = data2["has_img_".concat(props.set)] == void 0 || data2["has_img_".concat(props.set)];
    if (!setHasEmoji) {
      if (props.fallback) {
        return props.fallback(data2, props);
      } else {
        return null;
      }
    } else {
      style2 = {
        width: props.size,
        height: props.size,
        display: "inline-block",
        backgroundImage: "url(".concat(props.backgroundImageFn(props.set, props.sheetSize), ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      };
    }
  }
  var Tag2 = {
    name: "span",
    props: {}
  };
  if (props.onClick && props.useButton) {
    Tag2.name = "button";
    Tag2.props = {
      type: "button"
    };
  }
  if (props.html) {
    style2 = _convertStyleToCSS(style2);
    return "<".concat(Tag2.name, " style='").concat(style2, "' aria-label='").concat(label, "' ").concat(title ? "title='".concat(title, "'") : "", " class='").concat(className, "'>").concat(children2 || "", "</").concat(Tag2.name, ">");
  } else {
    return React__default.createElement(Tag2.name, _extends$7({
      onClick: function onClick2(e) {
        return _handleClick(e, props);
      },
      onMouseEnter: function onMouseEnter(e) {
        return _handleOver(e, props);
      },
      onMouseLeave: function onMouseLeave(e) {
        return _handleLeave(e, props);
      },
      "aria-label": label,
      title,
      className
    }, Tag2.props), React__default.createElement("span", {
      style: style2
    }, children2));
  }
};
NimbleEmoji.propTypes = _objectSpread$e({}, EmojiPropTypes, {
  data: PropTypes.object.isRequired
});
NimbleEmoji.defaultProps = EmojiDefaultProps;
function ownKeys$d(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$d(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$d(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var NotFound = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(NotFound2, _React$PureComponent);
  function NotFound2() {
    _classCallCheck$2(this, NotFound2);
    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(NotFound2).apply(this, arguments));
  }
  _createClass$2(NotFound2, [{
    key: "render",
    value: function render2() {
      var _this$props = this.props, data2 = _this$props.data, emojiProps = _this$props.emojiProps, i18n = _this$props.i18n, notFound2 = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji;
      var component = notFound2 && notFound2() || React__default.createElement("div", {
        className: "emoji-mart-no-results"
      }, NimbleEmoji(_objectSpread$d({
        data: data2
      }, emojiProps, {
        size: 38,
        emoji: notFoundEmoji,
        onOver: null,
        onLeave: null,
        onClick: null
      })), React__default.createElement("div", {
        className: "emoji-mart-no-results-label"
      }, i18n.notfound));
      return component;
    }
  }]);
  return NotFound2;
})(React__default.PureComponent);
NotFound.propTypes = {
  notFound: PropTypes.func.isRequired,
  emojiProps: PropTypes.object.isRequired
};
function ownKeys$c(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$c(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$c(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Category = /* @__PURE__ */ (function(_React$Component) {
  _inherits$2(Category2, _React$Component);
  function Category2(props) {
    var _this;
    _classCallCheck$2(this, Category2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Category2).call(this, props));
    _this.data = props.data;
    _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_this));
    _this.setLabelRef = _this.setLabelRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$2(Category2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.margin = 0;
      this.minMargin = 0;
      this.memoizeSize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$props = this.props, name = _this$props.name, perLine = _this$props.perLine, _native = _this$props["native"], hasStickyPosition = _this$props.hasStickyPosition, emojis2 = _this$props.emojis, emojiProps = _this$props.emojiProps, skin = emojiProps.skin, size2 = emojiProps.size, set2 = emojiProps.set, nextPerLine = nextProps.perLine, nextNative = nextProps["native"], nextHasStickyPosition = nextProps.hasStickyPosition, nextEmojis = nextProps.emojis, nextEmojiProps = nextProps.emojiProps, nextSkin = nextEmojiProps.skin, nextSize = nextEmojiProps.size, nextSet = nextEmojiProps.set, shouldUpdate = false;
      if (name == "Recent" && perLine != nextPerLine) {
        shouldUpdate = true;
      }
      if (name == "Search") {
        shouldUpdate = !(emojis2 == nextEmojis);
      }
      if (skin != nextSkin || size2 != nextSize || _native != nextNative || set2 != nextSet || hasStickyPosition != nextHasStickyPosition) {
        shouldUpdate = true;
      }
      return shouldUpdate;
    }
  }, {
    key: "memoizeSize",
    value: function memoizeSize() {
      if (!this.container) {
        this.top = 0;
        this.maxMargin = 0;
        return;
      }
      var parent = this.container.parentElement;
      var _this$container$getBo = this.container.getBoundingClientRect(), top2 = _this$container$getBo.top, height = _this$container$getBo.height;
      var _parent$getBoundingCl = parent.getBoundingClientRect(), parentTop = _parent$getBoundingCl.top;
      var _this$label$getBoundi = this.label.getBoundingClientRect(), labelHeight = _this$label$getBoundi.height;
      this.top = top2 - parentTop + parent.scrollTop;
      if (height == 0) {
        this.maxMargin = 0;
      } else {
        this.maxMargin = height - labelHeight;
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(scrollTop) {
      var margin = scrollTop - this.top;
      margin = margin < this.minMargin ? this.minMargin : margin;
      margin = margin > this.maxMargin ? this.maxMargin : margin;
      if (margin == this.margin) return;
      if (!this.props.hasStickyPosition) {
        this.label.style.top = "".concat(margin, "px");
      }
      this.margin = margin;
      return true;
    }
  }, {
    key: "getEmojis",
    value: function getEmojis() {
      var _this2 = this;
      var _this$props2 = this.props, name = _this$props2.name, emojis2 = _this$props2.emojis, recent2 = _this$props2.recent, perLine = _this$props2.perLine;
      if (name == "Recent") {
        var custom2 = this.props.custom;
        var frequentlyUsed = recent2 || frequently$1.get(perLine);
        if (frequentlyUsed.length) {
          emojis2 = frequentlyUsed.map(function(id2) {
            var emoji = custom2.filter(function(e) {
              return e.id === id2;
            })[0];
            if (emoji) {
              return emoji;
            }
            return id2;
          }).filter(function(id2) {
            return !!getData(id2, null, null, _this2.data);
          });
        }
        if (emojis2.length === 0 && frequentlyUsed.length > 0) {
          return null;
        }
      }
      if (emojis2) {
        emojis2 = emojis2.slice(0);
      }
      return emojis2;
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay(display) {
      var emojis2 = this.getEmojis();
      if (!emojis2 || !this.container) {
        return;
      }
      this.container.style.display = display;
    }
  }, {
    key: "setContainerRef",
    value: function setContainerRef(c) {
      this.container = c;
    }
  }, {
    key: "setLabelRef",
    value: function setLabelRef(c) {
      this.label = c;
    }
  }, {
    key: "render",
    value: function render2() {
      var _this3 = this;
      var _this$props3 = this.props, id2 = _this$props3.id, name = _this$props3.name, hasStickyPosition = _this$props3.hasStickyPosition, emojiProps = _this$props3.emojiProps, i18n = _this$props3.i18n, notFound2 = _this$props3.notFound, notFoundEmoji = _this$props3.notFoundEmoji, emojis2 = this.getEmojis(), labelStyles = {}, labelSpanStyles = {}, containerStyles = {};
      if (!emojis2) {
        containerStyles = {
          display: "none"
        };
      }
      if (!hasStickyPosition) {
        labelStyles = {
          height: 28
        };
        labelSpanStyles = {
          position: "absolute"
        };
      }
      var label = i18n.categories[id2] || name;
      return React__default.createElement("section", {
        ref: this.setContainerRef,
        className: "emoji-mart-category",
        "aria-label": label,
        style: containerStyles
      }, React__default.createElement("div", {
        style: labelStyles,
        "data-name": name,
        className: "emoji-mart-category-label"
      }, React__default.createElement("span", {
        style: labelSpanStyles,
        ref: this.setLabelRef,
        "aria-hidden": true
        /* already labeled by the section aria-label */
      }, label)), React__default.createElement("ul", {
        className: "emoji-mart-category-list"
      }, emojis2 && emojis2.map(function(emoji) {
        return React__default.createElement("li", {
          key: emoji.short_names && emoji.short_names.join("_") || emoji
        }, NimbleEmoji(_objectSpread$c({
          emoji,
          data: _this3.data
        }, emojiProps)));
      })), emojis2 && !emojis2.length && React__default.createElement(NotFound, {
        i18n,
        notFound: notFound2,
        notFoundEmoji,
        data: this.data,
        emojiProps
      }));
    }
  }]);
  return Category2;
})(React__default.Component);
Category.propTypes = {
  emojis: PropTypes.array,
  hasStickyPosition: PropTypes.bool,
  name: PropTypes.string.isRequired,
  "native": PropTypes.bool.isRequired,
  perLine: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  recent: PropTypes.arrayOf(PropTypes.string),
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string.isRequired
};
Category.defaultProps = {
  emojis: [],
  hasStickyPosition: true
};
var Skins = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(Skins2, _React$PureComponent);
  function Skins2(props) {
    var _this;
    _classCallCheck$2(this, Skins2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Skins2).call(this, props));
    _this.state = {
      opened: false
    };
    return _this;
  }
  _createClass$2(Skins2, [{
    key: "handleClick",
    value: function handleClick(e) {
      var skin = parseInt(e.currentTarget.getAttribute("data-skin"));
      var onChange5 = this.props.onChange;
      if (!this.state.opened) {
        this.setState({
          opened: true
        });
      } else {
        this.setState({
          opened: false
        });
        if (skin != this.props.skin) {
          onChange5(skin);
        }
      }
    }
  }, {
    key: "render",
    value: function render2() {
      return null;
    }
  }]);
  return Skins2;
})(React__default.PureComponent);
Skins.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired
};
Skins.defaultProps = {
  onChange: function onChange() {
  }
};
var SkinsEmoji = /* @__PURE__ */ (function(_Skins) {
  _inherits$2(SkinsEmoji2, _Skins);
  function SkinsEmoji2(props) {
    var _this;
    _classCallCheck$2(this, SkinsEmoji2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(SkinsEmoji2).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$2(SkinsEmoji2, [{
    key: "render",
    value: function render2() {
      var _this$props = this.props, skin = _this$props.skin, emojiProps = _this$props.emojiProps, data2 = _this$props.data, skinEmoji = _this$props.skinEmoji, i18n = _this$props.i18n;
      var opened = this.state.opened;
      var skinToneNodes = [];
      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected2 = skinTone === skin;
        skinToneNodes.push(React__default.createElement("span", {
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch custom".concat(selected2 ? " selected" : "")
        }, React__default.createElement("span", {
          onClick: this.handleClick,
          "data-skin": skinTone,
          className: "emoji-mart-skin-tone-".concat(skinTone)
        }, NimbleEmoji({
          emoji: skinEmoji,
          data: data2,
          skin: skinTone,
          backgroundImageFn: emojiProps.backgroundImageFn,
          "native": emojiProps["native"],
          set: emojiProps.set,
          sheetSize: emojiProps.sheetSize,
          size: 23
        }))));
      }
      return React__default.createElement("div", {
        className: "emoji-mart-skin-swatches custom".concat(opened ? " opened" : "")
      }, React__default.createElement("div", {
        className: "emoji-mart-skin-text".concat(opened ? " opened" : "")
      }, i18n.skintext), skinToneNodes);
    }
  }]);
  return SkinsEmoji2;
})(Skins);
SkinsEmoji.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinTone: PropTypes.number,
  skinEmoji: PropTypes.string.isRequired,
  i18n: PropTypes.object
};
SkinsEmoji.defaultProps = {
  onChange: function onChange2() {
  },
  skinTone: null
};
var SkinsDot = /* @__PURE__ */ (function(_Skins) {
  _inherits$2(SkinsDot2, _Skins);
  function SkinsDot2(props) {
    var _this;
    _classCallCheck$2(this, SkinsDot2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(SkinsDot2).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$2(SkinsDot2, [{
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props = this.props, skin = _this$props.skin, i18n = _this$props.i18n;
      var opened = this.state.opened;
      var skinToneNodes = [];
      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected2 = skinTone === skin;
        var visible = opened || selected2;
        skinToneNodes.push(React__default.createElement("span", _extends$7({
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch".concat(selected2 ? " selected" : ""),
          "aria-label": i18n.skintones[skinTone],
          "aria-hidden": !visible
        }, opened ? {
          role: "menuitem"
        } : {}), React__default.createElement("span", _extends$7({
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          role: "button"
        }, selected2 ? {
          "aria-haspopup": true,
          "aria-expanded": !!opened
        } : {}, opened ? {
          "aria-pressed": !!selected2
        } : {}, {
          tabIndex: visible ? "0" : "",
          "aria-label": i18n.skintones[skinTone],
          title: i18n.skintones[skinTone],
          "data-skin": skinTone,
          className: "emoji-mart-skin emoji-mart-skin-tone-".concat(skinTone)
        }))));
      }
      return React__default.createElement("section", {
        className: "emoji-mart-skin-swatches".concat(opened ? " opened" : ""),
        "aria-label": i18n.skintext
      }, React__default.createElement("div", opened ? {
        role: "menubar"
      } : {}, skinToneNodes));
    }
  }]);
  return SkinsDot2;
})(Skins);
SkinsDot.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  i18n: PropTypes.object
};
SkinsDot.defaultProps = {
  onChange: function onChange3() {
  }
};
function ownKeys$b(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$b(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$b(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Preview = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(Preview2, _React$PureComponent);
  function Preview2(props) {
    var _this;
    _classCallCheck$2(this, Preview2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Preview2).call(this, props));
    _this.data = props.data;
    _this.state = {
      emoji: null
    };
    return _this;
  }
  _createClass$2(Preview2, [{
    key: "render",
    value: function render2() {
      var emoji = this.state.emoji, _this$props = this.props, emojiProps = _this$props.emojiProps, skinsProps = _this$props.skinsProps, showSkinTones = _this$props.showSkinTones, title = _this$props.title, idleEmoji = _this$props.emoji, i18n = _this$props.i18n, showPreview = _this$props.showPreview;
      if (emoji && showPreview) {
        var emojiData = getData(emoji, null, null, this.data), _emojiData$emoticons = emojiData.emoticons, emoticons = _emojiData$emoticons === void 0 ? [] : _emojiData$emoticons, knownEmoticons = [], listedEmoticons = [];
        emoticons.forEach(function(emoticon) {
          if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) {
            return;
          }
          knownEmoticons.push(emoticon.toLowerCase());
          listedEmoticons.push(emoticon);
        });
        return React__default.createElement("div", {
          className: "emoji-mart-preview"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, NimbleEmoji(_objectSpread$b({
          key: emoji.id,
          emoji,
          data: this.data
        }, emojiProps))), React__default.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-name"
        }, emoji.name), React__default.createElement("div", {
          className: "emoji-mart-preview-shortnames"
        }, emojiData.short_names.map(function(short_name) {
          return React__default.createElement("span", {
            key: short_name,
            className: "emoji-mart-preview-shortname"
          }, ":", short_name, ":");
        })), React__default.createElement("div", {
          className: "emoji-mart-preview-emoticons"
        }, listedEmoticons.map(function(emoticon) {
          return React__default.createElement("span", {
            key: emoticon,
            className: "emoji-mart-preview-emoticon"
          }, emoticon);
        }))));
      } else {
        return React__default.createElement("div", {
          className: "emoji-mart-preview"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, idleEmoji && idleEmoji.length && NimbleEmoji(_objectSpread$b({
          emoji: idleEmoji,
          data: this.data
        }, emojiProps))), React__default.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React__default.createElement("span", {
          className: "emoji-mart-title-label"
        }, title)), showSkinTones && React__default.createElement("div", {
          className: "emoji-mart-preview-skins".concat(skinsProps.skinEmoji ? " custom" : "")
        }, skinsProps.skinEmoji ? React__default.createElement(SkinsEmoji, {
          skin: skinsProps.skin,
          emojiProps,
          data: this.data,
          skinEmoji: skinsProps.skinEmoji,
          i18n,
          onChange: skinsProps.onChange
        }) : React__default.createElement(SkinsDot, {
          skin: skinsProps.skin,
          i18n,
          onChange: skinsProps.onChange
        })));
      }
    }
  }]);
  return Preview2;
})(React__default.PureComponent);
Preview.propTypes = {
  showSkinTones: PropTypes.bool,
  title: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinsProps: PropTypes.object.isRequired
};
Preview.defaultProps = {
  showSkinTones: true,
  onChange: function onChange4() {
  }
};
var id = 0;
var Search = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(Search2, _React$PureComponent);
  function Search2(props) {
    var _this;
    _classCallCheck$2(this, Search2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Search2).call(this, props));
    _this.state = {
      icon: search$1.search,
      isSearching: false,
      id: ++id
    };
    _this.data = props.data;
    _this.emojiIndex = new NimbleEmojiIndex(_this.data);
    _this.setRef = _this.setRef.bind(_assertThisInitialized(_this));
    _this.clear = _this.clear.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.handleChange = throttleIdleTask(_this.handleChange.bind(_assertThisInitialized(_this)));
    return _this;
  }
  _createClass$2(Search2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.input && this.input.value) {
        this.search(this.input.value);
      }
    }
  }, {
    key: "search",
    value: function search3(value) {
      if (value == "") this.setState({
        icon: search$1.search,
        isSearching: false
      });
      else this.setState({
        icon: search$1["delete"],
        isSearching: true
      });
      this.props.onSearch(this.emojiIndex.search(value, {
        emojisToShowFilter: this.props.emojisToShowFilter,
        maxResults: this.props.maxResults,
        include: this.props.include,
        exclude: this.props.exclude,
        custom: this.props.custom
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.input.value == "") return;
      this.input.value = "";
      this.input.focus();
      this.search("");
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      if (this.input) {
        this.search(this.input.value);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      if (e.keyCode === 13) {
        this.clear();
      }
    }
  }, {
    key: "setRef",
    value: function setRef(c) {
      this.input = c;
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props = this.props, i18n = _this$props.i18n, autoFocus = _this$props.autoFocus;
      var _this$state = this.state, icon2 = _this$state.icon, isSearching = _this$state.isSearching, id2 = _this$state.id;
      var inputId = "emoji-mart-search-".concat(id2);
      return React__default.createElement("section", {
        className: "emoji-mart-search",
        "aria-label": i18n.search
      }, React__default.createElement("input", {
        id: inputId,
        ref: this.setRef,
        type: "search",
        onChange: this.handleChange,
        placeholder: i18n.search,
        autoFocus
      }), React__default.createElement("label", {
        className: "emoji-mart-sr-only",
        htmlFor: inputId
      }, i18n.search), React__default.createElement("button", {
        className: "emoji-mart-search-icon",
        onClick: this.clear,
        onKeyUp: this.handleKeyUp,
        "aria-label": i18n.clear,
        disabled: !isSearching
      }, icon2()));
    }
  }]);
  return Search2;
})(React__default.PureComponent);
Search.propTypes = {
  onSearch: PropTypes.func,
  maxResults: PropTypes.number,
  emojisToShowFilter: PropTypes.func,
  autoFocus: PropTypes.bool
};
Search.defaultProps = {
  onSearch: function onSearch() {
  },
  maxResults: 75,
  emojisToShowFilter: null,
  autoFocus: false
};
function ownKeys$a(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var I18N = {
  search: "Search",
  clear: "Clear",
  // Accessible label on "clear" button
  notfound: "No Emoji Found",
  skintext: "Choose your default skin tone",
  categories: {
    search: "Search Results",
    recent: "Frequently Used",
    people: "Smileys & People",
    nature: "Animals & Nature",
    foods: "Food & Drink",
    activity: "Activity",
    places: "Travel & Places",
    objects: "Objects",
    symbols: "Symbols",
    flags: "Flags",
    custom: "Custom"
  },
  categorieslabel: "Emoji categories",
  // Accessible title for the list of categories
  skintones: {
    1: "Default Skin Tone",
    2: "Light Skin Tone",
    3: "Medium-Light Skin Tone",
    4: "Medium Skin Tone",
    5: "Medium-Dark Skin Tone",
    6: "Dark Skin Tone"
  }
};
var NimblePicker = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(NimblePicker2, _React$PureComponent);
  function NimblePicker2(props) {
    var _this;
    _classCallCheck$2(this, NimblePicker2);
    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(NimblePicker2).call(this, props));
    _this.CUSTOM = [];
    _this.RECENT_CATEGORY = {
      id: "recent",
      name: "Recent",
      emojis: null
    };
    _this.SEARCH_CATEGORY = {
      id: "search",
      name: "Search",
      emojis: null,
      anchor: false
    };
    if (props.data.compressed) {
      uncompress(props.data);
    }
    _this.data = props.data;
    _this.i18n = deepMerge(I18N, props.i18n);
    _this.icons = deepMerge(icons, props.icons);
    _this.state = {
      firstRender: true
    };
    _this.categories = [];
    var allCategories = [].concat(_this.data.categories);
    if (props.custom.length > 0) {
      var customCategories = {};
      var customCategoriesCreated = 0;
      props.custom.forEach(function(emoji2) {
        if (!customCategories[emoji2.customCategory]) {
          customCategories[emoji2.customCategory] = {
            id: emoji2.customCategory ? "custom-".concat(emoji2.customCategory) : "custom",
            name: emoji2.customCategory || "Custom",
            emojis: [],
            anchor: customCategoriesCreated === 0
          };
          customCategoriesCreated++;
        }
        var category2 = customCategories[emoji2.customCategory];
        var customEmoji = _objectSpread$a({}, emoji2, {
          // `<Category />` expects emoji to have an `id`.
          id: emoji2.short_names[0],
          custom: true
        });
        category2.emojis.push(customEmoji);
        _this.CUSTOM.push(customEmoji);
      });
      allCategories = allCategories.concat(Object.keys(customCategories).map(function(key) {
        return customCategories[key];
      }));
    }
    _this.hideRecent = true;
    if (props.include != void 0) {
      allCategories.sort(function(a, b) {
        if (props.include.indexOf(a.id) > props.include.indexOf(b.id)) {
          return 1;
        }
        return -1;
      });
    }
    for (var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      var category = allCategories[categoryIndex];
      var isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : true;
      var isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : false;
      if (!isIncluded || isExcluded) {
        continue;
      }
      if (props.emojisToShowFilter) {
        var newEmojis = [];
        var emojis2 = category.emojis;
        for (var emojiIndex2 = 0; emojiIndex2 < emojis2.length; emojiIndex2++) {
          var emoji = emojis2[emojiIndex2];
          if (props.emojisToShowFilter(_this.data.emojis[emoji] || emoji)) {
            newEmojis.push(emoji);
          }
        }
        if (newEmojis.length) {
          var newCategory = {
            emojis: newEmojis,
            name: category.name,
            id: category.id
          };
          _this.categories.push(newCategory);
        }
      } else {
        _this.categories.push(category);
      }
    }
    var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : true;
    var excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : false;
    if (includeRecent && !excludeRecent) {
      _this.hideRecent = false;
      _this.categories.unshift(_this.RECENT_CATEGORY);
    }
    if (_this.categories[0]) {
      _this.categories[0].first = true;
    }
    _this.categories.unshift(_this.SEARCH_CATEGORY);
    _this.setAnchorsRef = _this.setAnchorsRef.bind(_assertThisInitialized(_this));
    _this.handleAnchorClick = _this.handleAnchorClick.bind(_assertThisInitialized(_this));
    _this.setSearchRef = _this.setSearchRef.bind(_assertThisInitialized(_this));
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_this));
    _this.setScrollRef = _this.setScrollRef.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollPaint = _this.handleScrollPaint.bind(_assertThisInitialized(_this));
    _this.handleEmojiOver = _this.handleEmojiOver.bind(_assertThisInitialized(_this));
    _this.handleEmojiLeave = _this.handleEmojiLeave.bind(_assertThisInitialized(_this));
    _this.handleEmojiClick = _this.handleEmojiClick.bind(_assertThisInitialized(_this));
    _this.handleEmojiSelect = _this.handleEmojiSelect.bind(_assertThisInitialized(_this));
    _this.setPreviewRef = _this.setPreviewRef.bind(_assertThisInitialized(_this));
    _this.handleSkinChange = _this.handleSkinChange.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleDarkMatchMediaChange = _this.handleDarkMatchMediaChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass$2(NimblePicker2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.state.firstRender) {
        this.testStickyPosition();
        this.firstRenderTimeout = setTimeout(function() {
          _this2.setState({
            firstRender: false
          });
        }, 60);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateCategoriesSize();
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.SEARCH_CATEGORY.emojis = null;
      clearTimeout(this.leaveTimeout);
      clearTimeout(this.firstRenderTimeout);
      if (this.darkMatchMedia) {
        this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
      }
    }
  }, {
    key: "testStickyPosition",
    value: function testStickyPosition() {
      var stickyTestElement = document.createElement("div");
      var prefixes = ["", "-webkit-", "-ms-", "-moz-", "-o-"];
      prefixes.forEach(function(prefix2) {
        return stickyTestElement.style.position = "".concat(prefix2, "sticky");
      });
      this.hasStickyPosition = !!stickyTestElement.style.position.length;
    }
  }, {
    key: "getPreferredTheme",
    value: function getPreferredTheme() {
      if (this.props.theme != "auto") return this.props.theme;
      if (this.state.theme) return this.state.theme;
      if (typeof matchMedia !== "function") return PickerDefaultProps.theme;
      if (!this.darkMatchMedia) {
        this.darkMatchMedia = matchMedia("(prefers-color-scheme: dark)");
        this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange);
      }
      if (this.darkMatchMedia.media.match(/^not/)) return PickerDefaultProps.theme;
      return this.darkMatchMedia.matches ? "dark" : "light";
    }
  }, {
    key: "handleDarkMatchMediaChange",
    value: function handleDarkMatchMediaChange() {
      this.setState({
        theme: this.darkMatchMedia.matches ? "dark" : "light"
      });
    }
  }, {
    key: "handleEmojiOver",
    value: function handleEmojiOver(emoji) {
      var preview = this.preview;
      if (!preview) {
        return;
      }
      var emojiData = this.CUSTOM.filter(function(customEmoji) {
        return customEmoji.id === emoji.id;
      })[0];
      for (var key in emojiData) {
        if (emojiData.hasOwnProperty(key)) {
          emoji[key] = emojiData[key];
        }
      }
      preview.setState({
        emoji
      });
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: "handleEmojiLeave",
    value: function handleEmojiLeave(emoji) {
      var preview = this.preview;
      if (!preview) {
        return;
      }
      this.leaveTimeout = setTimeout(function() {
        preview.setState({
          emoji: null
        });
      }, 16);
    }
  }, {
    key: "handleEmojiClick",
    value: function handleEmojiClick(emoji, e) {
      this.props.onClick(emoji, e);
      this.handleEmojiSelect(emoji);
    }
  }, {
    key: "handleEmojiSelect",
    value: function handleEmojiSelect(emoji) {
      var _this3 = this;
      this.props.onSelect(emoji);
      if (!this.hideRecent && !this.props.recent) frequently$1.add(emoji);
      var component = this.categoryRefs["category-1"];
      if (component) {
        var maxMargin = component.maxMargin;
        if (this.props.enableFrequentEmojiSort) {
          component.forceUpdate();
        }
        requestAnimationFrame(function() {
          if (!_this3.scroll) return;
          component.memoizeSize();
          if (maxMargin == component.maxMargin) return;
          _this3.updateCategoriesSize();
          _this3.handleScrollPaint();
          if (_this3.SEARCH_CATEGORY.emojis) {
            component.updateDisplay("none");
          }
        });
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (!this.waitingForPaint) {
        this.waitingForPaint = true;
        requestAnimationFrame(this.handleScrollPaint);
      }
    }
  }, {
    key: "handleScrollPaint",
    value: function handleScrollPaint() {
      this.waitingForPaint = false;
      if (!this.scroll) {
        return;
      }
      var activeCategory = null;
      if (this.SEARCH_CATEGORY.emojis) {
        activeCategory = this.SEARCH_CATEGORY;
      } else {
        var target = this.scroll, scrollTop = target.scrollTop, scrollingDown = scrollTop > (this.scrollTop || 0), minTop = 0;
        for (var i = 0, l = this.categories.length; i < l; i++) {
          var ii = scrollingDown ? this.categories.length - 1 - i : i, category = this.categories[ii], component = this.categoryRefs["category-".concat(ii)];
          if (component) {
            var active = component.handleScroll(scrollTop);
            if (!minTop || component.top < minTop) {
              if (component.top > 0) {
                minTop = component.top;
              }
            }
            if (active && !activeCategory) {
              activeCategory = category;
            }
          }
        }
        if (scrollTop < minTop) {
          activeCategory = this.categories.filter(function(category2) {
            return !(category2.anchor === false);
          })[0];
        } else if (scrollTop + this.clientHeight >= this.scrollHeight) {
          activeCategory = this.categories[this.categories.length - 1];
        }
      }
      if (activeCategory) {
        var anchors = this.anchors, _activeCategory = activeCategory, categoryName = _activeCategory.name;
        if (anchors.state.selected != categoryName) {
          anchors.setState({
            selected: categoryName
          });
        }
      }
      this.scrollTop = scrollTop;
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(emojis2) {
      this.SEARCH_CATEGORY.emojis = emojis2;
      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs["category-".concat(i)];
        if (component && component.props.name != "Search") {
          var display = emojis2 ? "none" : "inherit";
          component.updateDisplay(display);
        }
      }
      this.forceUpdate();
      if (this.scroll) {
        this.scroll.scrollTop = 0;
      }
      this.handleScroll();
    }
  }, {
    key: "handleAnchorClick",
    value: function handleAnchorClick(category, i) {
      var component = this.categoryRefs["category-".concat(i)], scroll3 = this.scroll;
      this.anchors;
      var scrollToComponent = null;
      scrollToComponent = function scrollToComponent2() {
        if (component) {
          var top2 = component.top;
          if (category.first) {
            top2 = 0;
          } else {
            top2 += 1;
          }
          scroll3.scrollTop = top2;
        }
      };
      if (this.SEARCH_CATEGORY.emojis) {
        this.handleSearch(null);
        this.search.clear();
        requestAnimationFrame(scrollToComponent);
      } else {
        scrollToComponent();
      }
    }
  }, {
    key: "handleSkinChange",
    value: function handleSkinChange(skin) {
      var newState = {
        skin
      }, onSkinChange2 = this.props.onSkinChange;
      this.setState(newState);
      store.update(newState);
      onSkinChange2(skin);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var handled = false;
      switch (e.keyCode) {
        case 13:
          var emoji;
          if (this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data))) {
            this.handleEmojiSelect(emoji);
            handled = true;
          }
          break;
      }
      if (handled) {
        e.preventDefault();
      }
    }
  }, {
    key: "updateCategoriesSize",
    value: function updateCategoriesSize() {
      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs["category-".concat(i)];
        if (component) component.memoizeSize();
      }
      if (this.scroll) {
        var target = this.scroll;
        this.scrollHeight = target.scrollHeight;
        this.clientHeight = target.clientHeight;
      }
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
    }
  }, {
    key: "setAnchorsRef",
    value: function setAnchorsRef(c) {
      this.anchors = c;
    }
  }, {
    key: "setSearchRef",
    value: function setSearchRef(c) {
      this.search = c;
    }
  }, {
    key: "setPreviewRef",
    value: function setPreviewRef(c) {
      this.preview = c;
    }
  }, {
    key: "setScrollRef",
    value: function setScrollRef(c) {
      this.scroll = c;
    }
  }, {
    key: "setCategoryRef",
    value: function setCategoryRef(name, c) {
      if (!this.categoryRefs) {
        this.categoryRefs = {};
      }
      this.categoryRefs[name] = c;
    }
  }, {
    key: "render",
    value: function render2() {
      var _this4 = this;
      var _this$props = this.props, perLine = _this$props.perLine, emojiSize = _this$props.emojiSize, set2 = _this$props.set, sheetSize = _this$props.sheetSize, sheetColumns = _this$props.sheetColumns, sheetRows = _this$props.sheetRows, style2 = _this$props.style, title = _this$props.title, emoji = _this$props.emoji, color2 = _this$props.color, _native = _this$props["native"], backgroundImageFn2 = _this$props.backgroundImageFn, emojisToShowFilter = _this$props.emojisToShowFilter, showPreview = _this$props.showPreview, showSkinTones = _this$props.showSkinTones, emojiTooltip = _this$props.emojiTooltip, useButton = _this$props.useButton, include = _this$props.include, exclude = _this$props.exclude, recent2 = _this$props.recent, autoFocus = _this$props.autoFocus, skinEmoji = _this$props.skinEmoji, notFound2 = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji;
      var width = perLine * (emojiSize + 12) + 12 + 2 + measureScrollbar();
      var theme2 = this.getPreferredTheme();
      var skin = this.props.skin || this.state.skin || store.get("skin") || this.props.defaultSkin;
      return React__default.createElement("section", {
        style: _objectSpread$a({
          width
        }, style2),
        className: "emoji-mart emoji-mart-".concat(theme2),
        "aria-label": title,
        onKeyDown: this.handleKeyDown
      }, React__default.createElement("div", {
        className: "emoji-mart-bar"
      }, React__default.createElement(Anchors, {
        ref: this.setAnchorsRef,
        data: this.data,
        i18n: this.i18n,
        color: color2,
        categories: this.categories,
        onAnchorClick: this.handleAnchorClick,
        icons: this.icons
      })), React__default.createElement(Search, {
        ref: this.setSearchRef,
        onSearch: this.handleSearch,
        data: this.data,
        i18n: this.i18n,
        emojisToShowFilter,
        include,
        exclude,
        custom: this.CUSTOM,
        autoFocus
      }), React__default.createElement("div", {
        ref: this.setScrollRef,
        className: "emoji-mart-scroll",
        onScroll: this.handleScroll
      }, this.getCategories().map(function(category, i) {
        return React__default.createElement(Category, {
          ref: _this4.setCategoryRef.bind(_this4, "category-".concat(i)),
          key: category.name,
          id: category.id,
          name: category.name,
          emojis: category.emojis,
          perLine,
          "native": _native,
          hasStickyPosition: _this4.hasStickyPosition,
          data: _this4.data,
          i18n: _this4.i18n,
          recent: category.id == _this4.RECENT_CATEGORY.id ? recent2 : void 0,
          custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : void 0,
          emojiProps: {
            "native": _native,
            skin,
            size: emojiSize,
            set: set2,
            sheetSize,
            sheetColumns,
            sheetRows,
            forceSize: _native,
            tooltip: emojiTooltip,
            backgroundImageFn: backgroundImageFn2,
            useButton,
            onOver: _this4.handleEmojiOver,
            onLeave: _this4.handleEmojiLeave,
            onClick: _this4.handleEmojiClick
          },
          notFound: notFound2,
          notFoundEmoji
        });
      })), (showPreview || showSkinTones) && React__default.createElement("div", {
        className: "emoji-mart-bar"
      }, React__default.createElement(Preview, {
        ref: this.setPreviewRef,
        data: this.data,
        title,
        emoji,
        showSkinTones,
        showPreview,
        emojiProps: {
          "native": _native,
          size: 38,
          skin,
          set: set2,
          sheetSize,
          sheetColumns,
          sheetRows,
          backgroundImageFn: backgroundImageFn2
        },
        skinsProps: {
          skin,
          onChange: this.handleSkinChange,
          skinEmoji
        },
        i18n: this.i18n
      })));
    }
  }]);
  return NimblePicker2;
})(React__default.PureComponent);
NimblePicker.propTypes = _objectSpread$a({}, PickerPropTypes, {
  data: PropTypes.object.isRequired
});
NimblePicker.defaultProps = _objectSpread$a({}, PickerDefaultProps);
function ownKeys$9(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Picker2 = /* @__PURE__ */ (function(_React$PureComponent) {
  _inherits$2(Picker3, _React$PureComponent);
  function Picker3() {
    _classCallCheck$2(this, Picker3);
    return _possibleConstructorReturn$2(this, _getPrototypeOf$2(Picker3).apply(this, arguments));
  }
  _createClass$2(Picker3, [{
    key: "render",
    value: function render2() {
      return React__default.createElement(NimblePicker, _extends$7({}, this.props, this.state));
    }
  }]);
  return Picker3;
})(React__default.PureComponent);
Picker2.propTypes = PickerPropTypes;
Picker2.defaultProps = _objectSpread$9({}, PickerDefaultProps, {
  data
});
function ownKeys$8(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols3 = Object.getOwnPropertySymbols(object4);
    if (enumerableOnly) symbols3 = symbols3.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    });
    keys2.push.apply(keys2, symbols3);
  }
  return keys2;
}
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
_objectSpread$8({}, EmojiDefaultProps, {
  data
});
const EmojiInput = ({ disabled, iconClassname, onSelect: onSelect2 }) => {
  const addEmoji = useCallback((emoji) => {
    onSelect2(emoji);
  }, [onSelect2]);
  return /* @__PURE__ */ jsx$1(
    Popover,
    {
      content: /* @__PURE__ */ jsx$1(
        Picker2,
        {
          native: true,
          onSelect: (data2) => addEmoji(data2["native"]),
          sheetSize: 16,
          emojiSize: 16,
          showSkinTones: false,
          showPreview: false
        }
      ),
      overlayClassName: "p-0",
      trigger: "click",
      children: /* @__PURE__ */ jsx$1(
        Button,
        {
          type: "link",
          size: "large",
          className: "emoji-picker-btn",
          disabled,
          icon: /* @__PURE__ */ jsx$1(SmileOutlined, { className: iconClassname })
        }
      )
    }
  );
};
const FileInput = ({ loc, label, maxFiles, disabled, forbiddenFileExtensions, maxFileSize, iconClassname, btnClassName, onAttach }) => {
  const dropzone = useDropzone({
    onDrop: (x) => {
      let files = x.map((_x) => AccelFile.fromFile(_x));
      if (forbiddenFileExtensions) {
        files = files.filter((x2) => !forbiddenFileExtensions.includes(x2.extension));
      }
      if (maxFileSize) {
        const hasIgnoredItems = files.some((x2) => x2.fileSize.bytes > maxFileSize.bytes);
        files = files.filter((x2) => x2.fileSize.bytes <= maxFileSize.bytes);
        if (hasIgnoredItems)
          message$2.warning({ content: loc.word("File.maxFileSizeTemplate", { default: `Max file size: {0}`, args: [Humanize.fileSize(maxFileSize.bytes, 0)] }) });
      }
      onAttach(files);
    },
    disabled
  });
  const tooltipTitle = useMemo$2(() => {
    let tooltip = loc.word("Attach files");
    if (maxFiles)
      tooltip += ` (${loc.word("Max", { case: "lower" })}: ${maxFiles})`;
    return tooltip;
  }, [maxFiles]);
  return /* @__PURE__ */ jsxs("div", { ...dropzone.getRootProps(), children: [
    /* @__PURE__ */ jsx$1("input", { ...dropzone.getInputProps() }),
    /* @__PURE__ */ jsx$1(Tooltip, { placement: "topRight", title: tooltipTitle, children: /* @__PURE__ */ jsx$1(
      Button,
      {
        type: "link",
        className: btnClassName ?? "file-input-btn",
        size: "large",
        disabled,
        icon: /* @__PURE__ */ jsx$1(PaperClipOutlined, { className: iconClassname }),
        children: label
      }
    ) })
  ] });
};
const Editor = ({ loc, placeholder, text: text2, enterToSubmit, autoSize, autoFocus, disabled, handlerRef, className, onChange: onChange5, onSend, onFocus, onBlur }) => {
  const inputRef = useRef(null);
  const [handler] = useState$1({
    focus: () => {
      inputRef.current?.focus();
      inputRef.current?.resizableTextArea?.textArea.setSelectionRange(1e3, 1e3);
    },
    blur: () => inputRef.current?.blur(),
    insert: (text22) => {
      if (!inputRef.current) return;
      inputRef.current.focus();
      const el = inputRef.current.resizableTextArea.textArea;
      const [start2, end] = [el.selectionStart, el.selectionEnd];
      el.setRangeText(text22, start2, end, "end");
      onChange5(el.value);
    }
  });
  useEffect(() => {
    if (handlerRef) handlerRef.current = handler;
    if (autoFocus === true)
      handler.focus();
  }, []);
  const handleInputKeyDown = useCallback(async (e) => {
    if (!enterToSubmit) return;
    if (e.keyCode != KeyCode$1.Enter || e.shiftKey)
      return;
    e.preventDefault();
    await onSend();
    inputRef.current?.focus();
  }, []);
  return /* @__PURE__ */ jsx$1(
    Input$3.TextArea,
    {
      ref: inputRef,
      value: text2,
      className: combineClasses("msg-edit-input", className),
      disabled,
      onChange: (e) => onChange5(e.target.value),
      placeholder: placeholder ?? loc.word("Enter comment"),
      autoSize,
      onKeyDown: handleInputKeyDown,
      onFocus,
      onBlur
    }
  );
};
const voice_input = "_voice_input_13ud4_1";
const voice_input_overlay = "_voice_input_overlay_13ud4_5";
const voice_input_record_btn = "_voice_input_record_btn_13ud4_14";
const styles$F = {
  voice_input,
  voice_input_overlay,
  voice_input_record_btn
};
const record_dot = "_record_dot_tqqbi_1";
const styles$E = {
  record_dot
};
const VoiceRecordDuration = ({ duration }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex align-center gap-5", children: [
    /* @__PURE__ */ jsx$1("div", { className: styles$E.record_dot }),
    /* @__PURE__ */ jsx$1(Duration, { duration })
  ] });
};
const voice_record_btn = "_voice_record_btn_17511_1";
const voice_record_container = "_voice_record_container_17511_16";
const styles$D = {
  voice_record_btn,
  voice_record_container
};
const VoiceRecordButton = ({ outside, locked, onStopRecording }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$D.voice_record_container,
      style: { width: 50, height: 50 },
      "data-outside": outside,
      "data-locked": locked,
      onClick: (e) => {
        if (!locked) return;
        e.preventDefault();
        e.stopPropagation();
        onStopRecording();
      },
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$D.voice_record_btn, children: locked ? /* @__PURE__ */ jsx$1(BorderOutlined, { className: "chat-message-icon bg-white" }) : /* @__PURE__ */ jsx$1(AudioOutlined, { className: "chat-message-icon" }) }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx$1("div", { className: "voice_record_btn_wave voice_record_btn_wave_one" }),
          /* @__PURE__ */ jsx$1("div", { className: "voice_record_btn_wave voice_record_btn_wave_two" })
        ] })
      ]
    }
  );
};
const voice_record_lock = "_voice_record_lock_1f51h_1";
const styles$C = {
  voice_record_lock
};
const VoiceRecordLock = ({ percentToLock, locked, recording: recording2 }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$C.voice_record_lock,
      "data-locked": locked,
      "data-recording": recording2,
      "data-percent": percentToLock,
      style: { height: percentToLock == 100 ? 70 : 70 * ((100 - percentToLock) / 100) },
      children: [
        /* @__PURE__ */ jsx$1(UnlockOutlined, {}),
        /* @__PURE__ */ jsx$1(ArrowUpOutlined, { className: "absolute", style: { bottom: 5, opacity: percentToLock == 100 ? 1 : 0.5 * ((100 - percentToLock) / 100) } })
      ]
    }
  );
};
const useAudioRecorder = (audioTrackConstraints, onNotAllowedOrFound, mediaRecorderOptions, onRecorded) => {
  const [isRecording, setIsRecording] = useState$1(false);
  const [isPaused, setIsPaused] = useState$1(false);
  const [recordingTime, setRecordingTime] = useState$1(0);
  const [mediaRecorder, setMediaRecorder] = useState$1();
  const [timerInterval, setTimerInterval] = useState$1();
  const [recordingBlob, setRecordingBlob] = useState$1();
  const _startTimer = useCallback(() => {
    const interval = window.setInterval(() => {
      setRecordingTime((time) => time + 1);
    }, 1e3);
    setTimerInterval(interval);
  }, [setRecordingTime, setTimerInterval]);
  const _stopTimer = useCallback(() => {
    timerInterval != null && clearInterval(timerInterval);
    setTimerInterval(void 0);
  }, [timerInterval, setTimerInterval]);
  const startRecording = useCallback(async () => {
    if (timerInterval != null) return false;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: audioTrackConstraints ?? true });
      setIsRecording(true);
      const recorder = new MediaRecorder(
        stream,
        mediaRecorderOptions
      );
      setMediaRecorder(recorder);
      recorder.start();
      _startTimer();
      recorder.addEventListener("dataavailable", (event) => {
        setRecordingBlob(event.data);
        recorder.stream.getTracks().forEach((t) => t.stop());
        setMediaRecorder(void 0);
        onRecorded?.(event.data);
      });
      return true;
    } catch (err) {
      console.log(err.name, err.message, err.cause);
      onNotAllowedOrFound?.(err);
      return false;
    }
  }, [
    timerInterval,
    setIsRecording,
    setMediaRecorder,
    _startTimer,
    setRecordingBlob,
    onNotAllowedOrFound,
    mediaRecorderOptions,
    audioTrackConstraints
  ]);
  const stopRecording = useCallback(() => {
    mediaRecorder?.stop();
    _stopTimer();
    setRecordingTime(0);
    setIsRecording(false);
    setIsPaused(false);
  }, [
    mediaRecorder,
    setRecordingTime,
    setIsRecording,
    setIsPaused,
    _stopTimer
  ]);
  const togglePauseResume = useCallback(() => {
    if (isPaused) {
      setIsPaused(false);
      mediaRecorder?.resume();
      _startTimer();
    } else {
      setIsPaused(true);
      _stopTimer();
      mediaRecorder?.pause();
    }
  }, [mediaRecorder, setIsPaused, _startTimer, _stopTimer]);
  return {
    startRecording,
    stopRecording,
    togglePauseResume,
    recordingBlob,
    isRecording,
    isPaused,
    recordingTime,
    mediaRecorder
  };
};
const useAudioContext = () => {
  const getMeta = useCallback(async (file) => {
    if (file.size >= FileSize.fromMegabytes(10).bytes) {
      const frequencyLevels2 = Array.from({ length: 128 }, () => parseFloat(Math.random().toPrecision(3)));
      return {
        frequencyLevels: frequencyLevels2,
        durationInSec: 0,
        bitrate: 0,
        channels: 0,
        codecName: file.type === "audio/webm" ? "opus" : void 0,
        formatName: file.type ?? "audio/webm"
      };
    }
    var audioCtx = new window.AudioContext();
    var volume = audioCtx.createGain();
    volume.connect(audioCtx.destination);
    var analyser = audioCtx.createAnalyser();
    analyser.connect(volume);
    var source = audioCtx.createBufferSource();
    var arrBuffer = await file.arrayBuffer();
    const buffer = await audioCtx.decodeAudioData(arrBuffer);
    source.buffer = buffer;
    source.connect(analyser);
    const rawData = buffer.getChannelData(0);
    const samples = 128;
    const blockSize = Math.floor(rawData.length / samples);
    const frequencyLevels = [];
    for (let i = 0; i < samples; i++) {
      let sum = 0;
      for (let j = 0; j < blockSize; j++) {
        sum += Math.abs(rawData[i * blockSize + j]);
      }
      let mean = sum / blockSize;
      frequencyLevels.push(mean);
    }
    const max2 = Math.max(...frequencyLevels);
    frequencyLevels.forEach((v, i) => frequencyLevels[i] = parseFloat((v / max2).toPrecision(3)));
    await audioCtx.close();
    return {
      frequencyLevels,
      durationInSec: buffer.duration,
      bitrate: buffer.sampleRate,
      channels: buffer.numberOfChannels,
      codecName: file.type == "audio/webm" ? "opus" : void 0,
      formatName: file.type ?? "audio/webm"
    };
  }, []);
  return [getMeta];
};
function withHandler(c) {
  const Component2 = c;
  Component2.useHandler = () => {
    const ref2 = useRef(void 0);
    return ref2;
  };
  return Component2;
}
function useHandler(handler, handle, deps) {
  useMemo$2(() => {
    if (handler)
      handler.current = handle;
  }, deps);
}
const voice_record_cancel = "_voice_record_cancel_1jfua_1";
const styles$B = {
  voice_record_cancel
};
const VoiceRecordTouchSlideToCancel = ({ cancelProgress, locked, recording: recording2 }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles$B.voice_record_cancel,
      "data-locked": locked,
      "data-recording": recording2,
      "data-percent": cancelProgress,
      style: {
        opacity: cancelProgress == 0 ? 1 : 0.9 * ((100 - cancelProgress) / 100),
        marginRight: cancelProgress == 0 ? 0 : 80 * (cancelProgress / 100)
      },
      children: [
        /* @__PURE__ */ jsx$1(ArrowLeftOutlined, {}),
        /* @__PURE__ */ jsx$1(Loc, { word: "Comment.voice.cancel.touch.help", default: "Slide to cancel", className: "text-placeholder" })
      ]
    }
  );
};
const VoiceInput = withHandler(({ deviceId, handler, iconClassname, disabled, onRecordingStarted, onRecordingEnded, onRecordingCanceled }) => {
  const { loc } = useContext(Context$3);
  const ref2 = useRef(null);
  const [outside, setOutside] = React__default.useState(false);
  const [recording2, setRecording] = React__default.useState(false);
  const [locked, setLocked] = React__default.useState(false);
  const [dragUpDistance, setDragUpDistance] = React__default.useState(0);
  const [dragLeftDistance, setDragLeftDistance] = React__default.useState(0);
  const [getAudioMeta] = useAudioContext();
  const audioConstraints = useMemo$2(() => ({ noiseSuppression: true, echoCancellation: true, deviceId }), [deviceId]);
  const {
    startRecording,
    stopRecording,
    recordingBlob,
    recordingTime
  } = useAudioRecorder(
    audioConstraints,
    () => {
      notification.error({ message: loc.word("Comment.voice.micAccessError", { default: "Microphone not found or not allowed" }), duration: 2 });
      console.error("Microphone not found or not allowed");
    },
    void 0
  );
  useHandler(handler, {
    cancelRecording: () => {
      cancelledRef.current = true;
      stopRecording();
    }
  }, [stopRecording]);
  useEffect(() => {
    if (!recordingBlob) return;
    if (!cancelledRef.current && (lockedRef.current || !outsideRef.current)) {
      (async () => {
        const meta = await getAudioMeta(recordingBlob);
        const ext = meta.formatName?.includes("webm") ? "webm" : "mp4";
        const nativeFile = new File([recordingBlob], `voice.${ext}`, { type: meta.formatName });
        onRecordingEnded(AccelFile.fromFile(nativeFile, { additionalData: meta, isVoice: true }));
      })();
    } else {
      onRecordingCanceled?.();
    }
    recordingRef.current = false;
    lockedRef.current = false;
    outsideRef.current = false;
    cancelledRef.current = false;
    setRecording(false);
    setLocked(false);
    setOutside(false);
    setDragUpDistance(0);
    setDragLeftDistance(0);
  }, [recordingBlob, onRecordingCanceled, onRecordingEnded]);
  const lockedRef = useRef(false);
  const outsideRef = useRef(false);
  const buttonPressedRef = useRef(false);
  const recordClickedDownRef = useRef(false);
  const recordTimerRef = useRef(null);
  const cancelledRef = useRef(false);
  const recordingRef = useRef(false);
  const elPositionRef = useRef(void 0);
  const initialMousePositionRef = useRef({ x: 0, y: 0 });
  useEffect(() => {
    if (disabled) return;
    const mouseDownHandler = (e) => {
      recordClickedDownRef.current = true;
      initialMousePositionRef.current = { x: e.clientX, y: e.clientY };
      elPositionRef.current = ref2.current.getBoundingClientRect();
      recordTimerRef.current = setTimeout(async () => {
        if (await startRecording()) {
          onRecordingStarted?.();
          buttonPressedRef.current = true;
          cancelledRef.current = false;
          setDragLeftDistance(0);
          setDragUpDistance(0);
          setRecording(true);
          recordingRef.current = true;
          return;
        }
        console.error("Start recording error. Microphone not found or not allowed.");
      }, 150);
    };
    ref2.current?.addEventListener("pointerdown", mouseDownHandler);
    return () => {
      ref2.current?.removeEventListener("pointerdown", mouseDownHandler);
    };
  }, [startRecording, onRecordingStarted, disabled]);
  useEffect(() => {
    const mouseMoveHandler = lodashExports.debounce((e) => {
      if (!buttonPressedRef.current || lockedRef.current) return;
      const mouseDragDistance = initialMousePositionRef.current.y - e.clientY - (initialMousePositionRef.current.y - (elPositionRef.current?.top ?? 0));
      setDragUpDistance(Math.max(0, Math.min(mouseDragDistance, 100)));
      if (mouseDragDistance >= 50) {
        setLocked(true);
        setOutside(true);
        lockedRef.current = true;
        outsideRef.current = true;
      }
    }, 30, { leading: true, trailing: true, maxWait: 30 });
    document.addEventListener("mousemove", mouseMoveHandler);
    const mouseLeaveHandler = () => {
      if (!buttonPressedRef.current || lockedRef.current) return;
      setOutside(true);
      outsideRef.current = true;
    };
    ref2.current?.addEventListener("mouseleave", mouseLeaveHandler);
    const mouseEnterHandler = () => {
      if (!buttonPressedRef.current || locked) return;
      setOutside(false);
      outsideRef.current = false;
    };
    ref2.current?.addEventListener("mouseenter", mouseEnterHandler);
    return () => {
      document.removeEventListener("mousemove", mouseMoveHandler);
      ref2.current?.removeEventListener("mouseleave", mouseLeaveHandler);
      ref2.current?.removeEventListener("mouseenter", mouseEnterHandler);
    };
  }, []);
  useEffect(() => {
    const touchMoveHandler = lodashExports.debounce((e) => {
      console.logDev("touch move", e.touches[0]);
      if (!buttonPressedRef.current || lockedRef.current) return;
      const touchDragUpDistance = initialMousePositionRef.current.y - e.touches[0].clientY - (initialMousePositionRef.current.y - (elPositionRef.current?.top ?? 0));
      const touchDragLeftDistance = initialMousePositionRef.current.x - e.touches[0].clientX - (initialMousePositionRef.current.x - (elPositionRef.current?.left ?? 0));
      setDragUpDistance(Math.max(0, touchDragUpDistance));
      setDragLeftDistance(Math.max(0, touchDragLeftDistance));
      if (touchDragUpDistance >= 50) {
        setLocked(true);
        setOutside(true);
        lockedRef.current = true;
        outsideRef.current = true;
      }
      if (touchDragLeftDistance >= 100) {
        cancelledRef.current = true;
        stopRecording();
      }
    }, 30, { leading: true, trailing: true, maxWait: 30 });
    document.addEventListener("touchmove", touchMoveHandler);
    return () => {
      document.removeEventListener("touchmove", touchMoveHandler);
    };
  }, [stopRecording]);
  useEffect(() => {
    const mouseUpHandler = () => {
      if (!recordClickedDownRef.current) return;
      recordClickedDownRef.current = false;
      clearTimeout(recordTimerRef.current);
      if (!recordingRef.current && !buttonPressedRef.current && !lockedRef.current) {
        console.log("Please hold the mouse button pressed to record voice message");
        return;
      }
      buttonPressedRef.current = false;
      if (!lockedRef.current) {
        lockedRef.current = false;
        stopRecording();
      }
    };
    document.addEventListener("mouseup", mouseUpHandler);
    document.addEventListener("touchend", mouseUpHandler);
    return () => {
      document.removeEventListener("mouseup", mouseUpHandler);
      document.removeEventListener("touchend", mouseUpHandler);
    };
  }, [stopRecording]);
  const device = useDevice();
  return /* @__PURE__ */ jsxs("div", { ref: ref2, className: styles$F.voice_input, "data-recording": recording2, children: [
    /* @__PURE__ */ jsxs("div", { className: styles$F.voice_input_overlay, children: [
      /* @__PURE__ */ jsx$1(VoiceRecordLock, { locked, recording: recording2, percentToLock: dragUpDistance == 0 ? 100 : dragUpDistance / 75 * 100 }),
      /* @__PURE__ */ jsx$1(VoiceRecordDuration, { duration: TimeSpan.fromSeconds(recordingTime) }),
      locked ? /* @__PURE__ */ jsx$1(
        Button,
        {
          className: "p-0",
          type: "link",
          onClick: () => {
            cancelledRef.current = true;
            stopRecording();
          },
          children: /* @__PURE__ */ jsx$1(Loc, { word: "Comment.voice.cancel", default: "Cancel" })
        }
      ) : device.isTouch ? /* @__PURE__ */ jsx$1(VoiceRecordTouchSlideToCancel, { recording: recording2, locked, cancelProgress: dragLeftDistance }) : /* @__PURE__ */ jsx$1(Loc, { word: "Comment.voice.cancel.help", default: "Release outside this field to cancel", className: "text-placeholder" }),
      /* @__PURE__ */ jsx$1(VoiceRecordButton, { outside, locked, onStopRecording: stopRecording })
    ] }),
    /* @__PURE__ */ jsx$1(Button, { type: "link", icon: /* @__PURE__ */ jsx$1(AudioOutlined, { className: iconClassname }), disabled, size: "large", className: styles$F.voice_input_record_btn })
  ] });
});
const AudioWaveform = ({ levels, playedPercent, onSeek }) => {
  const canvasRef = useRef(null);
  const drawWave = useCallback((playedPercent2 = 0) => {
    const canvas = canvasRef.current;
    const width = canvas.parentElement?.clientWidth ?? 300;
    const height = 22;
    canvas.width = width;
    canvas.height = height;
    let context2 = canvas.getContext("2d");
    const barWidth = width / (levels.length - 1) / 2;
    for (let i = 0; i < levels.length; i++) {
      let h = Math.max(levels[i] * height, 0.1 * height);
      const isFilled = Math.floor(playedPercent2 / 100 * levels.length) >= i;
      context2.fillStyle = isFilled ? "#3098ff" : "#ccc";
      const x = i * barWidth * 2;
      context2.fillRect(x, height - h, barWidth, h);
    }
  }, [levels]);
  const handleSeek = useCallback((e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const relativeX = e.clientX - rect.x;
    onSeek(relativeX / rect.width * 100);
  }, [onSeek]);
  useEffect(() => {
    drawWave(playedPercent);
  }, [levels, playedPercent]);
  return /* @__PURE__ */ jsx$1("canvas", { ref: canvasRef, onClick: handleSeek, width: 100, height: 22, className: "max-w-100" });
};
const AudioPlayerDuration = ({ currentSec, durationInSec, className }) => {
  return /* @__PURE__ */ jsxs(SpaceSeparator, { separator: "slash", className, children: [
    currentSec > 0 && /* @__PURE__ */ jsx$1(Duration, { duration: TimeSpan.fromSeconds(currentSec), includeSeconds: true }),
    /* @__PURE__ */ jsx$1(Duration, { duration: TimeSpan.fromSeconds(durationInSec), includeSeconds: true })
  ] });
};
const PlaybackRateSelect = ({ playbackRate = 1, className, onPlaybackRateChange }) => {
  return /* @__PURE__ */ jsx$1(
    Dropdown,
    {
      trigger: ["click"],
      overlay: /* @__PURE__ */ jsx$1(Menu, { selectedKeys: [playbackRate?.toString() ?? "1"], children: [0.5, 1, 1.5, 2].map((rate2, i) => /* @__PURE__ */ jsxs(Menu.Item, { onClick: (e) => onPlaybackRateChange?.(rate2), children: [
        rate2.toPrecision(2),
        "x"
      ] }, rate2)) }),
      children: /* @__PURE__ */ jsxs("span", { className, children: [
        playbackRate.toPrecision(2),
        "x"
      ] })
    }
  );
};
function useLocalStorage(key, initialValue, removeIfUndefined, parse2) {
  const [storedValue, setStoredValue] = useState$1(() => {
    try {
      const item2 = window.localStorage.getItem(key);
      return item2 ? parse2 ? parse2(JSON.parse(item2)) : JSON.parse(item2) : initialValue;
    } catch (error2) {
      console.log(error2);
      return initialValue;
    }
  });
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (removeIfUndefined === true && valueToStore == void 0) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(
          key,
          // check if it has toJson method
          JSON.stringify(valueToStore.toJson ? valueToStore.toJson() : valueToStore)
        );
      }
    } catch (error2) {
      console.log(error2);
    }
  };
  return [storedValue, setValue];
}
const audio_player = "_audio_player_sqsaf_1";
const audio_player_button = "_audio_player_button_sqsaf_1";
const styles$A = {
  audio_player,
  audio_player_button
};
const AudioPlayer = ({ file, defaultPlaybackRate, size: size2, downloadable, style: style2, onPlaybackRateChange, className }) => {
  const { api: api2, fileProvider } = useContext(Context$3);
  const [playbackRate, setPlaybackRate] = useLocalStorage("global.audioPlaybackRate", defaultPlaybackRate ?? 1, true, (x) => parseFloat(x));
  const audioRef = useRef(null);
  const [loading, setLoading] = useState$1(false);
  const [percent, setPercent] = useState$1(0);
  const [currentSec, setCurrentSec] = useState$1(0);
  const [playing, setPlaying] = useState$1(false);
  const [inited, setInited] = useState$1(false);
  const [getAudioMeta] = useAudioContext();
  const downloadAudio = useCallback(async () => {
    const url2 = file.isExternalFile || file.previewAudio ? fileProvider.getUrl(file, true) : await fetchUrl();
    saveAs(url2, false, file.name);
  }, [file]);
  const fetchUrl = useCallback(async () => {
    const result = await api2.file.download(file.id);
    return result?.body;
  }, [file]);
  const handleCreateWaveform = useCallback(async () => {
    audioRef.current.removeEventListener("canplaythrough", handleCreateWaveform);
    if (file.audioMeta?.frequencyLevels) return;
    try {
      const res = await fetch(audioRef.current.src);
      const blob = await res.blob();
      const meta = await getAudioMeta(blob);
      file.audioMeta = meta;
      await api2.file.save(file);
    } catch (e) {
      console.error(e);
    }
  }, [file]);
  const handleTimeUpdate = useCallback(async () => {
    setCurrentSec(audioRef.current.currentTime);
    setPercent(audioRef.current.currentTime / audioRef.current.duration * 100);
  }, []);
  const handleEnded = useCallback(async () => {
    setPercent(0);
    setCurrentSec(0);
    setPlaying(false);
  }, []);
  const initPlayer = useCallback(async () => {
    setLoading(true);
    const url2 = file.isExternalFile || file.previewAudio ? fileProvider.getUrl(file, true) : await fetchUrl();
    if (!url2) {
      console.error("Couldn't fetch audio url");
      return;
    }
    audioRef.current = document.createElement("audio");
    audioRef.current.src = url2;
    audioRef.current.addEventListener("timeupdate", handleTimeUpdate);
    audioRef.current.addEventListener("canplaythrough", handleCreateWaveform);
    audioRef.current.addEventListener("ended", handleEnded);
    setLoading(false);
    setInited(true);
  }, [file]);
  const playHandle = useCallback(async () => {
    if (!inited) await initPlayer();
    setPlaying(true);
  }, [file, inited]);
  const seekHandle = useDebouncedCallback((percent2) => {
    try {
      audioRef.current.currentTime = percent2 / 100 * audioRef.current.duration;
    } catch (e) {
    }
  }, [], TimeSpan.fromMs(100));
  useEffect(() => {
    if (!audioRef.current) return;
    playing ? audioRef.current.play() : audioRef.current.pause();
  }, [playing]);
  useEffect(() => {
    if (audioRef.current)
      audioRef.current.playbackRate = playbackRate;
  }, [playbackRate]);
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener("timeupdate", handleTimeUpdate);
        audioRef.current.removeEventListener("ended", handleEnded);
        audioRef.current.pause();
        audioRef.current.remove();
      }
    };
  }, []);
  const freqLevels = useMemo$2(() => file.audioMeta?.frequencyLevels ?? Array.from({ length: 128 }, () => 0), [file.audioMeta]);
  return /* @__PURE__ */ jsxs("div", { className: combineClasses("flex align-center gap-10 w-100", styles$A.audio_player, className), "data-size": size2 ?? "middle", style: style2, children: [
    !playing ? /* @__PURE__ */ jsx$1(Button, { type: "link", icon: loading ? /* @__PURE__ */ jsx$1(LoadingOutlined$3, {}) : /* @__PURE__ */ jsx$1(PlayCircleFilled, {}), className: styles$A.audio_player_button, onClick: playHandle }) : /* @__PURE__ */ jsx$1(Button, { type: "link", icon: /* @__PURE__ */ jsx$1(PauseCircleFilled, {}), className: styles$A.audio_player_button, onClick: () => setPlaying(false) }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1 lh-18", children: [
      /* @__PURE__ */ jsx$1(AudioWaveform, { levels: freqLevels, playedPercent: percent, onSeek: seekHandle }),
      /* @__PURE__ */ jsxs("div", { className: "flex-1 flex justify-between align-center", children: [
        /* @__PURE__ */ jsx$1(AudioPlayerDuration, { currentSec, durationInSec: file.audioMeta?.durationInSec ?? 0, className: "text-placeholder" }),
        /* @__PURE__ */ jsx$1(
          PlaybackRateSelect,
          {
            playbackRate,
            onPlaybackRateChange: (rate2) => {
              setPlaybackRate(rate2);
              onPlaybackRateChange?.(rate2);
            },
            className: "text-placeholder c-pointer"
          }
        )
      ] })
    ] }),
    downloadable === true && /* @__PURE__ */ jsx$1(Button, { onClick: downloadAudio, type: "link", size: size2, icon: /* @__PURE__ */ jsx$1(DownloadOutlined, {}), className: "p-0" })
  ] });
};
function FileUploader({ file, autostart, uploadArgs, handler, handlerRef, onReady, onPrepare, onAbort, onBegin, onComplete, onError, onProgress, children: children2 }) {
  const { api: api2 } = useContext(Context$3);
  const store2 = useLocalStore(() => ({
    uploader: new S3Uploader(api2.file),
    disposableStack: new DisposableStack(),
    state: {
      file,
      percent: 0,
      status: file.id != null && file.nativeFile == null ? "completed" : "idle"
    },
    setState: (state) => {
      runInAction(() => {
        store2.state = { ...store2.state, ...state };
      });
    }
  }));
  const [getAudioMeta] = useAudioContext();
  useEffect(() => {
    const h = {
      upload: () => {
        return store2.uploader.upload();
      },
      abort: () => {
        return store2.uploader.abort();
      }
    };
    handler?.(h);
    if (handlerRef)
      handlerRef.current = h;
  }, []);
  useEffect(() => {
    if (!file.nativeFile) {
      onError?.({ errors: [] });
      return;
    }
    const args = uploadArgs ?? {};
    store2.disposableStack.push(store2.uploader.onBegin.on((x) => {
      file.update({ id: x.id });
      store2.setState({
        percent: 0,
        status: "uploading"
      });
      onBegin?.(x);
    }));
    store2.disposableStack.push(store2.uploader.onProgress.on((x) => {
      store2.setState({
        percent: x.percent
      });
      onProgress?.(x);
    }));
    store2.disposableStack.push(store2.uploader.onComplete.on((x) => {
      file.update({
        nativeFile: null,
        cloudKey: x.file.cloudKey,
        type: x.file.type,
        isPublic: args.isPublic ?? x.file.isPublic
      }, true);
      store2.setState({
        percent: 100,
        status: "completed"
      });
      onComplete?.(x);
    }));
    store2.disposableStack.push(store2.uploader.onPrepare.on((x) => {
      onPrepare?.();
    }));
    store2.disposableStack.push(store2.uploader.onAborted.on((x) => {
      store2.setState({
        status: "aborted"
      });
      onAbort?.(x);
    }));
    store2.disposableStack.push(store2.uploader.onError.on((x) => {
      store2.setState({
        status: "error"
      });
      onError?.(x);
    }));
    (async () => {
      if (file.nativeFile) {
        args.fileId = file.id;
        if (args.isPublic == null)
          args.isPublic = file.isImage;
        if (file.isAudio) {
          try {
            const audioMeta = await getAudioMeta(file.nativeFile);
            args.meta = audioMeta;
            file.update({ additionalData: audioMeta });
          } catch (e) {
            console.warn(`Couldn't decode audio meta`, e);
          }
        }
        store2.uploader.setFile(file.nativeFile, args);
        if (autostart !== false)
          store2.uploader.upload();
        onReady?.();
      }
    })();
    return () => store2.disposableStack.dispose();
  }, []);
  if (!children2) return null;
  return /* @__PURE__ */ jsx$1(Fragment, { children: children2(store2.state) });
}
FileUploader.useHandler = () => {
  const ref2 = useRef(null);
  return ref2;
};
const FileUploader$1 = observer(FileUploader);
const VoiceItem = ({ voice, suffix, audioSize, loc, deletable, downloadable, deleteButtonPlacement = "left", playerStyle, onDelete }) => {
  const fileUploaderHandler = FileUploader$1.useHandler();
  const [uploadStatus, setUploadStatus] = useState$1(voice.nativeFile != null ? FileUploadStatus.Uploading : FileUploadStatus.Uploaded);
  const delBtn = useMemo$2(() => deletable ? /* @__PURE__ */ jsx$1(Button, { danger: true, type: "link", icon: /* @__PURE__ */ jsx$1(DeleteFilled, {}), onClick: onDelete }) : null, [deletable, onDelete]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex gap-10 align-center flex-1", children: [
      deleteButtonPlacement === "left" && delBtn,
      /* @__PURE__ */ jsx$1(AudioPlayer, { size: audioSize, file: voice, downloadable: downloadable ?? true, className: "p-8 pt-5 pb-5 bg-gray-4 br-xs flex-1", style: playerStyle }),
      uploadStatus == FileUploadStatus.Uploaded ? suffix : /* @__PURE__ */ jsx$1(Tooltip, { title: uploadStatus == FileUploadStatus.Error && loc.word("CommentForm.voice.uploadError", { default: "Upload error, click to try again" }), children: /* @__PURE__ */ jsx$1(
        Button,
        {
          size: "large",
          icon: uploadStatus == FileUploadStatus.Error ? /* @__PURE__ */ jsx$1(SyncOutlined, {}) : /* @__PURE__ */ jsx$1(LoadingOutlined$3, {}),
          type: "text",
          danger: uploadStatus == FileUploadStatus.Error,
          onClick: () => uploadStatus == FileUploadStatus.Error && setUploadStatus(FileUploadStatus.Uploading)
        }
      ) }),
      deleteButtonPlacement === "right" && delBtn
    ] }),
    uploadStatus == FileUploadStatus.Uploading && /* @__PURE__ */ jsx$1(
      FileUploader$1,
      {
        handlerRef: fileUploaderHandler,
        autostart: true,
        file: voice,
        onPrepare: () => setUploadStatus(FileUploadStatus.Uploaded),
        uploadArgs: {
          voice: true,
          meta: voice.audioMeta
        },
        onAbort: () => {
          if (voice.nativeFile) {
            setUploadStatus(FileUploadStatus.Error);
          }
        },
        onError: (a) => {
          setUploadStatus(FileUploadStatus.Error);
        }
      }
    )
  ] });
};
const VoiceList = ({ voices, audioSize, loc, deletable, playerStyle, onDelete }) => {
  return /* @__PURE__ */ jsx$1("div", { className: "flex flex-col gap-10", children: voices.map((voice) => /* @__PURE__ */ jsx$1(VoiceItem, { voice, audioSize, loc, deletable, suffix: null, deleteButtonPlacement: "right", playerStyle, onDelete: () => onDelete?.(voice) }, voice.id)) });
};
const defaultProps = {
  enterToSubmit: true,
  useFiles: true,
  fileProps: {
    view: "list",
    draggable: false
  },
  useEmoji: true,
  useVoice: false,
  autoSize: { minRows: 2, maxRows: 5 },
  voiceMode: "split",
  editing: true
};
const CommentFormEditor = observer((propsRaw) => {
  const props = usePropsWithDefault(propsRaw, defaultProps);
  const ctx = useContext(Context$3);
  const { loc } = ctx;
  const editorRef = useRef(void 0);
  const voiceInputHandler = VoiceInput.useHandler();
  const [handler] = useState$1({
    focus: () => editorRef.current?.focus(),
    blur: () => editorRef.current?.blur(),
    setText: (text2) => {
      store2.setText(text2, true);
    },
    insertText: (text2) => {
      editorRef.current?.insert(text2);
    },
    setFiles: (files) => {
      store2.setFiles(files, true);
    },
    setVoices: (files) => {
      store2.setVoices(files);
    },
    hasUploadingFiles: () => {
      return store2.files.some((x) => !x.isUploaded);
    },
    cancelVoiceRecording: () => {
      voiceInputHandler.current?.cancelRecording();
    }
  });
  useEffect(() => {
    if (props.handlerRef)
      props.handlerRef.current = handler;
  }, []);
  useEffect(() => {
    store2.setSendHandler(props.onSend);
  }, [props.onSend]);
  const store2 = useLocalStore(() => ({
    text: props.text ?? props.defaultText ?? "",
    setText: action((text2, force = false) => {
      if (!props.text || force) {
        store2.text = text2;
        props.onTextChange?.(store2.text);
      }
    }),
    files: (props.files ?? props.defaultFiles ?? []).slice(),
    setFiles: action((files, force = false) => {
      if (!props.files || force) {
        store2.files = files.slice();
      }
    }),
    voices: (props.voices ?? props.defaultVoices ?? []).slice(),
    setVoices: action((files) => {
      store2.voices = files;
    }),
    addVoice: action((file) => {
      store2.setVoices([...store2.voices, file]);
      props.onVoicesChange?.(store2.voices, {
        added: [file]
      });
    }),
    removeVoice(file) {
      store2.setVoices(store2.voices.filter((x) => x.id != file.id || x != file));
      props.onVoicesChange?.(store2.voices, {
        deleted: [file]
      });
    },
    clearVoices: action(() => {
      const prev4 = store2.voices.slice();
      store2.voices = [];
      props.onVoicesChange?.(store2.voices, {
        deleted: prev4
      });
    }),
    get trimmedText() {
      return store2.text?.trim();
    },
    sending: false,
    setSending: action((sending) => {
      store2.sending = sending;
    }),
    _disabled: props.disabled ?? false,
    setDisabled: action((_disabled) => {
      store2._disabled = _disabled;
    }),
    get isMaxLengthReached() {
      if (!props.maxLength || !store2.text) return false;
      return store2.trimmedText.length > props.maxLength;
    },
    get canSend() {
      if (store2.isMaxLengthReached) return false;
      return store2.hasText || store2.hasAttachments || store2.voices != null;
    },
    get availableFileCount() {
      return props.fileProps?.maxFiles ? Math.max(0, props.fileProps.maxFiles - store2.files.length) : null;
    },
    get canAttachFiles() {
      return store2.availableFileCount == null || store2.availableFileCount > 0;
    },
    get disabled() {
      return store2._disabled || store2.sending;
    },
    get hasText() {
      return !isEmpty(store2.trimmedText);
    },
    get hasAttachments() {
      return store2.files.length > 0;
    },
    get hasTextOrAttachments() {
      return store2.hasText || store2.hasAttachments;
    },
    hasFocus: false,
    setFocus: (focus) => {
      store2.hasFocus = focus;
    },
    sendHandler: props.onSend,
    setSendHandler: (handler2) => {
      store2.sendHandler = handler2;
    },
    async send() {
      if (!store2.canSend || !store2.sendHandler) return false;
      store2.setSending(true);
      let filesToSend = store2.files.slice();
      if (store2.voices.length > 0)
        filesToSend = [...store2.voices, ...filesToSend];
      const success = await store2.sendHandler(store2.trimmedText, filesToSend);
      if (success) {
        if (props.clearAfterSending == true) {
          store2.setFiles([]);
          store2.clearVoices();
          store2.setText("");
        }
      }
      store2.setSending(false);
      return success;
    },
    attachFiles(files) {
      if (files.length == 0)
        return;
      if (store2.availableFileCount != null) {
        if (store2.availableFileCount == 0) return;
        if (files.length > store2.availableFileCount)
          files = files.slice(0, store2.availableFileCount);
      }
      store2.setFiles([...store2.files, ...files]);
      props.onFilesChange?.(store2.files, {
        added: files
      });
    },
    deleteFile(file) {
      store2.setFiles(store2.files.filter((x) => x.id != file.id || x != file));
      props.onFilesChange?.(store2.files, {
        deleted: [file]
      });
    },
    reorderFiles(src, dst) {
      store2.setFiles(store2.files.reorder(src, dst).items);
      props.onFilesChange?.(store2.files, {});
    }
  }));
  useClipboardFiles((file) => {
    if (!store2.hasFocus) return;
    store2.attachFiles([AccelFile.fromFile(file)]);
  }, props.useFiles === true, [props.useFiles]);
  useEffect(() => {
    if (props.text === void 0) return;
    store2.setText(props.text, true);
  }, [props.text]);
  useEffect(() => {
    if (props.defaultText === void 0) return;
    store2.setText(props.defaultText);
  }, [props.defaultText]);
  useEffect(() => {
    if (props.defaultFiles === void 0) return;
    store2.setFiles(props.defaultFiles);
  }, [props.defaultFiles]);
  useEffect(() => {
    if (props.defaultVoices === void 0) return;
    store2.setVoices(props.defaultVoices);
  }, [props.defaultVoices]);
  useEffect(() => {
    if (props.files === void 0) return;
    store2.setFiles(props.files);
  }, [props.files]);
  useEffect(() => {
    if (props.disabled !== void 0)
      store2.setDisabled(props.disabled);
  }, [props.disabled]);
  useEffect(() => {
    if (props.voices === void 0) return;
    store2.setVoices(props.voices);
  }, [props.voices]);
  const handleRecordingEnded = useCallback((file) => {
    store2.addVoice(file);
    props.onVoiceRecordingEnded?.(file);
  }, [props.onVoiceRecordingEnded]);
  const handleRecordingCanceled = useCallback(() => {
    store2.setVoices([]);
    props.onVoiceRecordingCanceled?.();
  }, [props.onVoiceRecordingCanceled]);
  const sendButton = props.sendDisabled === true ? null : /* @__PURE__ */ jsx$1(
    Tooltip,
    {
      title: loc.word("Max text length reached", { default: "Max text length reached" }),
      open: store2.isMaxLengthReached,
      children: /* @__PURE__ */ jsx$1(
        Button,
        {
          type: "link",
          onClick: () => store2.send(),
          disabled: store2.disabled || !store2.canSend,
          size: "large",
          icon: /* @__PURE__ */ jsx$1(SendOutlined, { className: props.iconClassname }),
          className: "comment-msg-btn-send"
        }
      )
    }
  );
  const voiceInput = /* @__PURE__ */ jsx$1(
    VoiceInput,
    {
      handler: voiceInputHandler,
      deviceId: props.micDeviceId,
      disabled: store2.disabled,
      iconClassname: props.iconClassname,
      onRecordingStarted: props.onVoiceRecordingStarted,
      onRecordingEnded: handleRecordingEnded,
      onRecordingCanceled: handleRecordingCanceled
    }
  );
  return /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$G.comment_editor_wrapper, "flex flex-col"), style: props.style, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-1 w-100", children: [
      props.author && /* @__PURE__ */ jsx$1(UserAvatar$1, { user: props.author, size: 40, className: "mr-10" }),
      /* @__PURE__ */ jsx$1("div", { className: "flex flex-1 align-center p-2", "data-borderless": props.borderless ?? false, children: store2.voices.length > 0 && props.voiceMode !== "combined" ? /* @__PURE__ */ jsx$1(
        VoiceItem,
        {
          voice: store2.voices[0],
          audioSize: props.audioPlayerSize,
          deletable: props.editing === true,
          downloadable: false,
          loc,
          onDelete: () => store2.removeVoice(store2.voices[0]),
          suffix: props.editing === true ? sendButton : null,
          playerStyle: props.audioPlayerStyle
        }
      ) : props.editing === true ? /* @__PURE__ */ jsxs("div", { className: combineClasses(props.editorClassName, styles$G.comment_editor, "flex flex-1 align-center relative"), style: props.editorStyle, children: [
        props.useFiles && /* @__PURE__ */ jsx$1(
          FileInput,
          {
            loc,
            disabled: store2.disabled || !store2.canAttachFiles,
            maxFiles: props.fileProps?.maxFiles,
            forbiddenFileExtensions: props.fileProps?.forbiddenExtensions,
            maxFileSize: props.fileProps?.maxFileSize,
            onAttach: (x) => store2.attachFiles(x),
            iconClassname: props.iconClassname
          }
        ),
        /* @__PURE__ */ jsx$1(
          Editor,
          {
            handlerRef: editorRef,
            loc,
            enterToSubmit: props.enterToSubmit,
            text: store2.text,
            autoSize: props.autoSize,
            disabled: store2.disabled,
            placeholder: props.placeholder,
            autoFocus: props.autoFocus,
            onSend: async () => await store2.send(),
            onChange: (x) => store2.setText(x),
            className: props.inputClassName,
            onFocus: () => store2.setFocus(true),
            onBlur: () => store2.setFocus(false)
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex align-center", children: [
          props.actionAddons?.(handler),
          props.useEmoji && /* @__PURE__ */ jsx$1(
            EmojiInput,
            {
              onSelect: (emoji) => editorRef.current?.insert(emoji),
              disabled: store2.disabled,
              iconClassname: props.iconClassname
            }
          ),
          props.useVoice === true ? /* @__PURE__ */ jsx$1(Fragment, { children: props.voiceMode == "split" ? store2.hasTextOrAttachments ? sendButton : voiceInput : /* @__PURE__ */ jsxs(Fragment, { children: [
            voiceInput,
            sendButton
          ] }) }) : sendButton
        ] })
      ] }) : /* @__PURE__ */ jsx$1("div", { children: props.textRenderer?.(store2.text) ?? /* @__PURE__ */ jsx$1(LinkifyText, { text: store2.text }) }) })
    ] }),
    store2.voices && props.voiceMode === "combined" && /* @__PURE__ */ jsx$1("div", { className: "mt-10 pl-11 pr-11 overflow-auto w-100", children: /* @__PURE__ */ jsx$1(VoiceList, { voices: store2.voices, audioSize: props.audioPlayerSize, deletable: !store2.disabled && props.editing === true, loc, onDelete: (x) => store2.removeVoice(x), playerStyle: props.audioPlayerStyle }) }),
    store2.files.length > 0 && /* @__PURE__ */ jsx$1("div", { className: "mt-10 pl-11 pr-11 overflow-auto w-100", style: { maxHeight: 250 }, children: /* @__PURE__ */ jsx$1(
      Files$1,
      {
        editable: !store2.disabled && props.editing === true,
        deletable: !store2.disabled && props.editing === true,
        files: store2.files,
        onDrop: (src, dst) => store2.reorderFiles(src, dst),
        beforeRemove: async (x) => {
          store2.deleteFile(x);
          return false;
        },
        draggable: props.fileProps?.draggable,
        view: props.fileProps?.view || "grid",
        size: props.fileProps?.size || "md"
      }
    ) })
  ] });
});
const CommentForm = ({ author, authorClassName, createdDate, updatedDate, canEdit, canRemove, canCancelEditing = true, onRemove, onCancel, replyTo, onReply, onReplyRemoved, canReply, extra, ...props }) => {
  const ctx = useContext(Context$3);
  const { loc, user: user2 } = ctx;
  const formRef = useRef(void 0);
  useEffect(() => {
    if (props.handlerRef && formRef.current)
      combineRefs(props.handlerRef, formRef)(formRef.current);
  }, []);
  const [editing, setEditing] = useState$1(props.editing ?? false);
  const [editingText, setEditingText] = useState$1(props.text ?? props.defaultText ?? "");
  const [editingFiles, setEditingFiles] = useState$1((props.files ?? props.defaultFiles ?? []).slice());
  const [editingVoices, setEditingVoices] = useState$1((props.voices ?? props.defaultVoices ?? []).slice());
  const [editingReplyRemoved, setEditingReplyRemoved] = useState$1(false);
  useEffect(() => {
    setEditingText(props.defaultText);
  }, [props.defaultText]);
  useEffect(() => {
    setEditingFiles(props.defaultFiles);
  }, [props.defaultFiles]);
  useEffect(() => {
    setEditingVoices(props.defaultVoices);
  }, [props.defaultVoices]);
  const edit2 = useCallback(() => {
    setEditing(true);
  }, []);
  const send = useCallback(async (a, b) => {
    if (!props.onSend) {
      console.error("CommentForm.onSend is not defined");
      return false;
    }
    const res = await props.onSend(a, b, editingReplyRemoved);
    if (res) {
      setEditing(props.editing === true ? true : false);
      if (props.clearAfterSending == true) {
        onReplyRemoved?.();
      }
    }
    return res;
  }, [props.onSend, props.clearAfterSending, onReplyRemoved, props.editing]);
  const cancelEdit = useCallback(() => {
    formRef.current?.setText(props.text ?? props.defaultText ?? "");
    formRef.current?.setFiles((props.files ?? props.defaultFiles ?? []).slice());
    formRef.current?.setVoices((props.voices ?? props.defaultVoices ?? []).slice());
    setEditing(false);
    setEditingReplyRemoved(false);
    onCancel?.();
  }, [props, onCancel]);
  return /* @__PURE__ */ jsxs("div", { className: combineClasses("flex", props.className), children: [
    author && /* @__PURE__ */ jsx$1(UserAvatar$1, { user: author, size: 40, className: "mr-10" }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex gap-10", children: [
        author != null && user2 != null && !editing ? props.authorRender != void 0 ? props.authorRender(author) : /* @__PURE__ */ jsx$1(Typography.Text, { className: authorClassName, children: author.id === user2?.id ? loc.word("You") : author.fullName }) : null,
        replyTo != null && !editingReplyRemoved && /* @__PURE__ */ jsx$1(Row, { align: "middle", children: replyTo })
      ] }),
      /* @__PURE__ */ jsx$1(
        CommentFormEditor,
        {
          ...props,
          handlerRef: formRef,
          defaultText: editingText,
          defaultFiles: editingFiles,
          defaultVoices: editingVoices,
          onSend: send,
          clearAfterSending: props.clearAfterSending ?? false,
          borderless: editing ? props.borderless : true,
          editing
        }
      ),
      /* @__PURE__ */ jsx$1("div", { className: "fs-11 text-placeholder", children: /* @__PURE__ */ jsxs(SpaceSeparator, { separator: "dot", align: "center", children: [
        createdDate && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx$1(Loc, { word: "Sent" }),
          " ",
          /* @__PURE__ */ jsx$1(DateTime, { date: createdDate })
        ] }),
        updatedDate && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx$1(Loc, { word: "Updated" }),
          " ",
          /* @__PURE__ */ jsx$1(DateTime, { date: updatedDate })
        ] }),
        props.extraFirstInOrderControl && /* @__PURE__ */ jsx$1(Fragment, { children: props.extraFirstInOrderControl?.(editing) }),
        editing && canCancelEditing !== false && /* @__PURE__ */ jsx$1(Button, { type: "link", size: "small", className: "fs-11", onClick: cancelEdit, children: loc.word("Global.cancel", { case: "lower" }) }),
        !editing && canReply && /* @__PURE__ */ jsx$1(Button, { disabled: editing, type: "link", size: "small", className: "fs-11", onClick: () => onReply?.(), children: loc.word("Reply", { case: "lower" }) }),
        !editing && canEdit && /* @__PURE__ */ jsx$1(Button, { disabled: editing, type: "link", size: "small", className: "fs-11", onClick: edit2, children: loc.word("Edit", { case: "lower" }) }),
        !editing && canRemove && /* @__PURE__ */ jsx$1(
          Popconfirm,
          {
            title: /* @__PURE__ */ jsx$1(
              Loc,
              {
                word: "Comment.delete.confirm",
                default: "Are you sure you want to delete this comment?"
              }
            ),
            onConfirm: onRemove,
            children: /* @__PURE__ */ jsx$1(Button, { disabled: editing, type: "link", size: "small", className: "fs-11", children: loc.word("Remove", { case: "lower" }) })
          }
        )
      ] }) })
    ] }),
    extra?.(editing)
  ] });
};
observer(CommentForm);
function useTimer() {
  const timer = useRef(new Timer());
  const [controller] = useState$1({
    set: (fn, span, fireImmediately = false) => {
      controller.isActive = true;
      timer.current.set(fn, span, fireImmediately = false);
    },
    setInterval: (fn, span, fireImmediately = false) => {
      controller.isActive = true;
      timer.current.setInterval(fn, span, fireImmediately);
    },
    clear: () => {
      timer.current.clear();
      controller.isActive = false;
    },
    isActive: false
  });
  useEffect(() => {
    return () => controller.clear();
  }, []);
  return controller;
}
const _Draggable = class _Draggable extends React__default.Component {
  constructor(props) {
    super(props);
    this.onDragStart = (e) => {
      this.setState({
        ...this.state,
        dragging: true
      });
      this.props.onMouseDown?.(e);
      this.props.onStart?.(e, this.createEventData(e, this.state.position));
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.onDragStop);
      if (this.props.classNameDraggingBounds && this.state.bounds)
        this.state.bounds.classList.add(this.props.classNameDraggingBounds);
    };
    this.onDrag = (e) => {
      let position2 = this.calcPosition(this.state.position, e);
      const bounds2 = this.state.bounds.getBoundingClientRect();
      position2 = this.calcBoundsPosition(position2, bounds2);
      this.props.onDrag?.(e, this.createEventData(e, position2));
      this.setState({
        ...this.state,
        position: position2,
        lastX: position2.left,
        lastY: position2.top
      });
    };
    this.onDragStop = (e) => {
      this.setState({
        ...this.state,
        dragging: false
      });
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.onDragStop);
      this.props.onStop?.(e, this.createEventData(e, this.state.position));
      if (this.props.classNameDraggingBounds && this.state.bounds)
        this.state.bounds.classList.remove(this.props.classNameDraggingBounds);
    };
    this.state = {
      dragging: false,
      position: this.props.defaultPosition ?? { top: 0, left: 0 }
    };
    this.nodeRef = React__default.createRef();
  }
  getBoundsNode() {
    if (!this.props.bounds || this.props.bounds == "body") return document.body;
    if (this.props.bounds == "parent") return this.nodeRef.current.parentElement;
    if (typeof this.props.bounds === "string") return document.querySelector(this.props.bounds);
    return this.props.bounds.current;
  }
  componentDidMount() {
    this.setState({
      ...this.state,
      position: !this.props.defaultPosition ? this.getPosition(this.nodeRef.current) : this.state.position,
      bounds: this.getBoundsNode()
    });
    const handler = this.props.handler?.current ?? this.nodeRef.current;
    handler.addEventListener("mousedown", this.onDragStart);
  }
  componentWillUnmount() {
    const handler = this.props.handler?.current ?? this.nodeRef.current;
    handler.removeEventListener("mousedown", this.onDragStart);
  }
  getPosition(node2) {
    const currentStyle = node2.style;
    return {
      top: currentStyle.top ? parseInt(currentStyle.top) : 0,
      left: currentStyle.left ? parseInt(currentStyle.left) : void 0,
      right: currentStyle.right ? parseInt(currentStyle.right) : void 0
    };
  }
  createEventData(e, position2) {
    return {
      node: this.nodeRef.current,
      position: position2,
      deltaX: e.movementX,
      deltaY: e.movementY
    };
  }
  canDragAxis(axis) {
    return this.state.dragging && this.props.axis == "both" || this.props.axis == axis;
  }
  calcPosition(position2, e) {
    const canDragY = this.canDragAxis("y");
    const canDragX = this.canDragAxis("x");
    return {
      top: canDragY ? position2.top + e.movementY : position2.top,
      left: canDragX && position2.left !== void 0 ? position2.left + e.movementX : void 0,
      right: canDragX && position2.right !== void 0 ? position2.right - e.movementX : void 0
    };
  }
  calcBoundsPosition(position2, bounds2) {
    const node2 = this.nodeRef.current;
    const newPosition = { ...position2 };
    if (newPosition.top < bounds2.top) newPosition.top = bounds2.top;
    const maxTop = bounds2.height - node2.clientHeight;
    if (newPosition.top > maxTop) newPosition.top = maxTop;
    if (newPosition.top < 0) newPosition.top = 0;
    if (newPosition.right) {
      if (newPosition.right < 0) newPosition.right = 0;
      const maxRight = bounds2.width - node2.clientWidth;
      if (newPosition.right > maxRight) newPosition.right = maxRight;
    }
    if (newPosition.left) {
      if (newPosition.left < bounds2.left) newPosition.left = bounds2.left;
      const maxLeft = bounds2.width - node2.clientWidth + bounds2.left;
      if (newPosition.left > maxLeft) newPosition.left = maxLeft;
    }
    return newPosition;
  }
  render() {
    const style2 = this.state.position && {
      top: this.state.position.top,
      left: this.state.position.left,
      right: this.state.position.right
    };
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        ref: combineRefs(this.nodeRef, this.props.nodeRef),
        className: combineClasses("fixed", this.props.className, this.state.dragging ? this.props.classNameDragging : void 0),
        style: style2,
        children: this.props.children
      }
    );
  }
};
_Draggable.defaultProps = {
  axis: "both",
  defaultPosition: { top: 0, left: 0 }
};
let Draggable = _Draggable;
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype = Component2.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
function ownKeys$7(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$7(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$e(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$e() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var ArrowKeyStepper = /* @__PURE__ */ (function(_React$PureComponent) {
  function ArrowKeyStepper2() {
    var _this;
    _classCallCheck$2(this, ArrowKeyStepper2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$e(this, ArrowKeyStepper2, [].concat(args));
    _defineProperty$2(_this, "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });
    _defineProperty$2(_this, "_columnStartIndex", 0);
    _defineProperty$2(_this, "_columnStopIndex", 0);
    _defineProperty$2(_this, "_rowStartIndex", 0);
    _defineProperty$2(_this, "_rowStopIndex", 0);
    _defineProperty$2(_this, "_onKeyDown", function(event) {
      var _this$props = _this.props, columnCount = _this$props.columnCount, disabled = _this$props.disabled, mode = _this$props.mode, rowCount = _this$props.rowCount;
      if (disabled) {
        return;
      }
      var _this$_getScrollState = _this._getScrollState(), scrollToColumnPrevious = _this$_getScrollState.scrollToColumn, scrollToRowPrevious = _this$_getScrollState.scrollToRow;
      var _this$_getScrollState2 = _this._getScrollState(), scrollToColumn = _this$_getScrollState2.scrollToColumn, scrollToRow = _this$_getScrollState2.scrollToRow;
      switch (event.key) {
        case "ArrowDown":
          scrollToRow = mode === "cells" ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case "ArrowLeft":
          scrollToColumn = mode === "cells" ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case "ArrowRight":
          scrollToColumn = mode === "cells" ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case "ArrowUp":
          scrollToRow = mode === "cells" ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }
      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();
        _this._updateScrollState({
          scrollToColumn,
          scrollToRow
        });
      }
    });
    _defineProperty$2(_this, "_onSectionRendered", function(_ref) {
      var columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });
    return _this;
  }
  _inherits$2(ArrowKeyStepper2, _React$PureComponent);
  return _createClass$2(ArrowKeyStepper2, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn, scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow,
        scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props2 = this.props, className = _this$props2.className, children2 = _this$props2.children;
      var _this$_getScrollState3 = this._getScrollState(), scrollToColumn = _this$_getScrollState3.scrollToColumn, scrollToRow = _this$_getScrollState3.scrollToRow;
      return /* @__PURE__ */ React.createElement("div", {
        className,
        onKeyDown: this._onKeyDown
      }, children2({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn,
        scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn, scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props, isControlled = _this$props3.isControlled, onScrollToChange = _this$props3.onScrollToChange;
      if (typeof onScrollToChange === "function") {
        onScrollToChange({
          scrollToColumn,
          scrollToRow
        });
      }
      if (!isControlled) {
        this.setState({
          scrollToColumn,
          scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }
      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return _objectSpread$7(_objectSpread$7({}, prevState), {}, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }
      return {};
    }
  }]);
})(React.PureComponent);
_defineProperty$2(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: "edges",
  scrollToColumn: 0,
  scrollToRow: 0
});
polyfill(ArrowKeyStepper);
function createDetectElementResize(nonce, hostWindow) {
  var _window;
  if (typeof hostWindow !== "undefined") {
    _window = hostWindow;
  } else if (typeof window !== "undefined") {
    _window = window;
  } else if (typeof self !== "undefined") {
    _window = self;
  } else {
    _window = global;
  }
  var attachEvent = typeof _window.document !== "undefined" && _window.document.attachEvent;
  if (!attachEvent) {
    var requestFrame = (function() {
      var raf3 = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
        return _window.setTimeout(fn, 20);
      };
      return function(fn) {
        return raf3(fn);
      };
    })();
    var cancelFrame = (function() {
      var cancel2 = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function(id2) {
        return cancel2(id2);
      };
    })();
    var resetTriggers = function resetTriggers2(element) {
      var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + "px";
      expandChild.style.height = expand.offsetHeight + 1 + "px";
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };
    var checkTriggers = function checkTriggers2(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };
    var scrollListener = function scrollListener2(e) {
      if (e.target.className && typeof e.target.className.indexOf === "function" && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) {
        return;
      }
      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function() {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function(fn) {
            fn.call(element, e);
          });
        }
      });
    };
    var animation = false, keyframeprefix = "", animationstartevent = "animationstart", domPrefixes = "Webkit Moz O ms".split(" "), startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), pfx = "";
    {
      var elm = _window.document.createElement("fakeelement");
      if (elm.style.animationName !== void 0) {
        animation = true;
      }
      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + "AnimationName"] !== void 0) {
            pfx = domPrefixes[i];
            keyframeprefix = "-" + pfx.toLowerCase() + "-";
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = "resizeanim";
    var animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
    var animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
  }
  var createStyles = function createStyles2(doc) {
    if (!doc.getElementById("detectElementResize")) {
      var css2 = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style2 = doc.createElement("style");
      style2.id = "detectElementResize";
      style2.type = "text/css";
      if (nonce != null) {
        style2.setAttribute("nonce", nonce);
      }
      if (style2.styleSheet) {
        style2.styleSheet.cssText = css2;
      } else {
        style2.appendChild(doc.createTextNode(css2));
      }
      head.appendChild(style2);
    }
  };
  var addResizeListener = function addResizeListener2(element, fn) {
    if (attachEvent) {
      element.attachEvent("onresize", fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == "static") {
          element.style.position = "relative";
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
        var expandTrigger = doc.createElement("div");
        expandTrigger.className = "expand-trigger";
        expandTrigger.appendChild(doc.createElement("div"));
        var contractTrigger = doc.createElement("div");
        contractTrigger.className = "contract-trigger";
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener("scroll", scrollListener, true);
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };
  var removeResizeListener = function removeResizeListener2(element, fn) {
    if (attachEvent) {
      element.detachEvent("onresize", fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener("scroll", scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
        }
      }
    }
  };
  return {
    addResizeListener,
    removeResizeListener
  };
}
function ownKeys$6(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$6(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$d(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$d() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var AutoSizer = /* @__PURE__ */ (function(_React$Component) {
  function AutoSizer2() {
    var _this;
    _classCallCheck$2(this, AutoSizer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$d(this, AutoSizer2, [].concat(args));
    _defineProperty$2(_this, "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    _defineProperty$2(_this, "_parentNode", void 0);
    _defineProperty$2(_this, "_autoSizer", void 0);
    _defineProperty$2(_this, "_window", void 0);
    _defineProperty$2(_this, "_detectElementResize", void 0);
    _defineProperty$2(_this, "_onResize", function() {
      var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize4 = _this$props.onResize;
      if (_this._parentNode) {
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win2 = _this._window || window;
        var style2 = win2.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style2.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style2.paddingRight, 10) || 0;
        var paddingTop = parseInt(style2.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style2.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;
        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });
          onResize4({
            height,
            width
          });
        }
      }
    });
    _defineProperty$2(_this, "_setRef", function(autoSizer) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }
  _inherits$2(AutoSizer2, _React$Component);
  return _createClass$2(AutoSizer2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;
      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
        this._detectElementResize = createDetectElementResize(nonce, this._window);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props2 = this.props, children2 = _this$props2.children, className = _this$props2.className, disableHeight = _this$props2.disableHeight, disableWidth = _this$props2.disableWidth, style2 = _this$props2.style;
      var _this$state = this.state, height = _this$state.height, width = _this$state.width;
      var outerStyle = {
        overflow: "visible"
      };
      var childParams = {};
      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }
      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      return /* @__PURE__ */ React.createElement("div", {
        className,
        ref: this._setRef,
        style: _objectSpread$6(_objectSpread$6({}, outerStyle), style2)
      }, children2(childParams));
    }
  }]);
})(React.Component);
_defineProperty$2(AutoSizer, "defaultProps", {
  onResize: function onResize2() {
  },
  disableHeight: false,
  disableWidth: false,
  style: {}
});
function _callSuper$c(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$c() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var CellMeasurer = /* @__PURE__ */ (function(_React$PureComponent) {
  function CellMeasurer2() {
    var _this;
    _classCallCheck$2(this, CellMeasurer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$c(this, CellMeasurer2, [].concat(args));
    _defineProperty$2(_this, "_child", /* @__PURE__ */ React.createRef());
    _defineProperty$2(_this, "_measure", function() {
      var _this$props = _this.props, cache2 = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
      var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
      if (height !== cache2.getHeight(rowIndex, columnIndex) || width !== cache2.getWidth(rowIndex, columnIndex)) {
        cache2.set(rowIndex, columnIndex, width, height);
        if (parent && typeof parent.recomputeGridSize === "function") {
          parent.recomputeGridSize({
            columnIndex,
            rowIndex
          });
        }
      }
    });
    _defineProperty$2(_this, "_registerChild", function(element) {
      if (element && !(element instanceof Element)) {
        console.warn("CellMeasurer registerChild expects to be passed Element or null");
      }
      _this._child.current = element;
      if (element) {
        _this._maybeMeasureCell();
      }
    });
    return _this;
  }
  _inherits$2(CellMeasurer2, _React$PureComponent);
  return _createClass$2(CellMeasurer2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render2() {
      var _this2 = this;
      var children2 = this.props.children;
      var resolvedChildren = typeof children2 === "function" ? children2({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children2;
      if (resolvedChildren === null) {
        return resolvedChildren;
      }
      return /* @__PURE__ */ cloneElement(resolvedChildren, {
        ref: function ref2(node2) {
          if (typeof resolvedChildren.ref === "function") {
            resolvedChildren.ref(node2);
          } else if (resolvedChildren.ref) {
            resolvedChildren.ref.current = node2;
          }
          _this2._child.current = node2;
        }
      });
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache2 = this.props.cache;
      var node2 = this._child.current;
      if (node2 && node2.ownerDocument && node2.ownerDocument.defaultView && node2 instanceof node2.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node2.style.width;
        var styleHeight = node2.style.height;
        if (!cache2.hasFixedWidth()) {
          node2.style.width = "auto";
        }
        if (!cache2.hasFixedHeight()) {
          node2.style.height = "auto";
        }
        var height = Math.ceil(node2.offsetHeight);
        var width = Math.ceil(node2.offsetWidth);
        if (styleWidth) {
          node2.style.width = styleWidth;
        }
        if (styleHeight) {
          node2.style.height = styleHeight;
        }
        return {
          height,
          width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props, cache2 = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
      if (!cache2.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
        cache2.set(rowIndex, columnIndex, width, height);
        if (parent && typeof parent.invalidateCellSizeAfterRender === "function") {
          parent.invalidateCellSizeAfterRender({
            columnIndex,
            rowIndex
          });
        }
      }
    }
  }]);
})(React.PureComponent);
_defineProperty$2(CellMeasurer, "__internalCellMeasurerFlag", false);
if (process.env.NODE_ENV !== "production") {
  CellMeasurer.__internalCellMeasurerFlag = true;
}
var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100;
var CellMeasurerCache = /* @__PURE__ */ (function() {
  function CellMeasurerCache2() {
    var _this = this;
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$2(this, CellMeasurerCache2);
    _defineProperty$2(this, "_cellHeightCache", {});
    _defineProperty$2(this, "_cellWidthCache", {});
    _defineProperty$2(this, "_columnWidthCache", {});
    _defineProperty$2(this, "_rowHeightCache", {});
    _defineProperty$2(this, "_defaultHeight", void 0);
    _defineProperty$2(this, "_defaultWidth", void 0);
    _defineProperty$2(this, "_minHeight", void 0);
    _defineProperty$2(this, "_minWidth", void 0);
    _defineProperty$2(this, "_keyMapper", void 0);
    _defineProperty$2(this, "_hasFixedHeight", void 0);
    _defineProperty$2(this, "_hasFixedWidth", void 0);
    _defineProperty$2(this, "_columnCount", 0);
    _defineProperty$2(this, "_rowCount", 0);
    _defineProperty$2(this, "columnWidth", function(_ref) {
      var index2 = _ref.index;
      var key = _this._keyMapper(0, index2);
      return _this._columnWidthCache[key] !== void 0 ? _this._columnWidthCache[key] : _this._defaultWidth;
    });
    _defineProperty$2(this, "rowHeight", function(_ref2) {
      var index2 = _ref2.index;
      var key = _this._keyMapper(index2, 0);
      return _this._rowHeightCache[key] !== void 0 ? _this._rowHeightCache[key] : _this._defaultHeight;
    });
    var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === "number" ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === "number" ? defaultWidth : DEFAULT_WIDTH);
    if (process.env.NODE_ENV !== "production") {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. You have configured CellMeasurerCache to measure both. This will result in poor performance.");
      }
      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn("Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. Failing to do so will lead to unnecessary layout and poor performance.");
      }
      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn("Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. Failing to do so will lead to unnecessary layout and poor performance.");
      }
    }
  }
  return _createClass$2(CellMeasurerCache2, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      var key = this._keyMapper(rowIndex, columnIndex);
      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];
      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "defaultHeight",
    get: function get4() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get4() {
      return this._defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);
        return this._cellHeightCache[_key] !== void 0 ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);
        return this._cellWidthCache[_key2] !== void 0 ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has2(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      var key = this._keyMapper(rowIndex, columnIndex);
      return this._cellHeightCache[key] !== void 0;
    }
  }, {
    key: "set",
    value: function set2(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);
      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;
      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }]);
})();
function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}
var objectDestructuringEmpty;
var hasRequiredObjectDestructuringEmpty;
function requireObjectDestructuringEmpty() {
  if (hasRequiredObjectDestructuringEmpty) return objectDestructuringEmpty;
  hasRequiredObjectDestructuringEmpty = 1;
  function _objectDestructuringEmpty2(obj) {
    if (obj == null) throw new TypeError("Cannot destructure undefined");
  }
  objectDestructuringEmpty = _objectDestructuringEmpty2;
  return objectDestructuringEmpty;
}
var objectDestructuringEmptyExports = requireObjectDestructuringEmpty();
const _objectDestructuringEmpty = /* @__PURE__ */ getDefaultExportFromCjs(objectDestructuringEmptyExports);
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; ) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
  var cachedIndices = {};
  return function(_ref) {
    var callback = _ref.callback, indices = _ref.indices;
    var keys2 = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys2.every(function(key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys2.length !== Object.keys(cachedIndices).length || keys2.some(function(key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(",") !== value.join(",") : cachedValue !== value;
    });
    cachedIndices = indices;
    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement("div");
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";
      scrollDiv.style.width = "50px";
      scrollDiv.style.height = "50px";
      scrollDiv.style.overflow = "scroll";
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }
  return size;
}
function ownKeys$5(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$5(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$b(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$b() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var IS_SCROLLING_TIMEOUT$1 = 150;
var SCROLL_POSITION_CHANGE_REASONS$1 = {
  OBSERVED: "observed",
  REQUESTED: "requested"
};
var CollectionView = /* @__PURE__ */ (function(_React$PureComponent) {
  function CollectionView2() {
    var _this;
    _classCallCheck$2(this, CollectionView2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$b(this, CollectionView2, [].concat(args));
    _defineProperty$2(_this, "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });
    _defineProperty$2(_this, "_calculateSizeAndPositionDataOnNextUpdate", false);
    _defineProperty$2(_this, "_onSectionRenderedMemoizer", createCallbackMemoizer());
    _defineProperty$2(_this, "_onScrollMemoizer", createCallbackMemoizer(false));
    _defineProperty$2(_this, "_invokeOnSectionRenderedHelper", function() {
      var _this$props = _this.props, cellLayoutManager = _this$props.cellLayoutManager, onSectionRendered3 = _this$props.onSectionRendered;
      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered3,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });
    _defineProperty$2(_this, "_setScrollingContainerRef", function(ref2) {
      _this._scrollingContainer = ref2;
    });
    _defineProperty$2(_this, "_updateScrollPositionForScrollToCell", function() {
      var _this$props2 = _this.props, cellLayoutManager = _this$props2.cellLayoutManager, height = _this$props2.height, scrollToAlignment = _this$props2.scrollToAlignment, scrollToCell = _this$props2.scrollToCell, width = _this$props2.width;
      var _this$state = _this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height,
          scrollLeft,
          scrollTop,
          width
        });
        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });
    _defineProperty$2(_this, "_onScroll", function(event) {
      if (event.target !== _this._scrollingContainer) {
        return;
      }
      _this._enablePointerEventsAfterDelay();
      var _this$props3 = _this.props, cellLayoutManager = _this$props3.cellLayoutManager, height = _this$props3.height, isScrollingChange = _this$props3.isScrollingChange, width = _this$props3.width;
      var scrollbarSize2 = _this._scrollbarSize;
      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge.height, totalWidth = _cellLayoutManager$ge.width;
      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize2, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize2, event.target.scrollTop));
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS$1.OBSERVED : SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED;
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }
        _this.setState({
          isScrolling: true,
          scrollLeft,
          scrollPositionChangeReason,
          scrollTop
        });
      }
      _this._invokeOnScrollMemoizer({
        scrollLeft,
        scrollTop,
        totalWidth,
        totalHeight
      });
    });
    _this._scrollbarSize = scrollbarSize();
    if (_this._scrollbarSize === void 0) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }
  _inherits$2(CollectionView2, _React$PureComponent);
  return _createClass$2(CollectionView2, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props, cellLayoutManager = _this$props4.cellLayoutManager, scrollLeft = _this$props4.scrollLeft, scrollToCell = _this$props4.scrollToCell, scrollTop = _this$props4.scrollTop;
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }
      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft,
          scrollTop
        });
      }
      this._invokeOnSectionRenderedHelper();
      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge2.height, totalWidth = _cellLayoutManager$ge2.width;
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight,
        totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props, height = _this$props5.height, scrollToAlignment = _this$props5.scrollToAlignment, scrollToCell = _this$props5.scrollToCell, width = _this$props5.width;
      var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollPositionChangeReason = _this$state2.scrollPositionChangeReason, scrollTop = _this$state2.scrollTop;
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props6 = this.props, autoHeight = _this$props6.autoHeight, cellCount = _this$props6.cellCount, cellLayoutManager = _this$props6.cellLayoutManager, className = _this$props6.className, height = _this$props6.height, horizontalOverscanSize = _this$props6.horizontalOverscanSize, id2 = _this$props6.id, noContentRenderer2 = _this$props6.noContentRenderer, style2 = _this$props6.style, verticalOverscanSize = _this$props6.verticalOverscanSize, width = _this$props6.width;
      var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollLeft = _this$state3.scrollLeft, scrollTop = _this$state3.scrollTop;
      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }
      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(), totalHeight = _cellLayoutManager$ge3.height, totalWidth = _cellLayoutManager$ge3.width;
      var left2 = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top2 = Math.max(0, scrollTop - verticalOverscanSize);
      var right2 = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom2 = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom2 - top2,
        isScrolling,
        width: right2 - left2,
        x: left2,
        y: top2
      }) : [];
      var collectionStyle = {
        boxSizing: "border-box",
        direction: "ltr",
        height: autoHeight ? "auto" : height,
        position: "relative",
        WebkitOverflowScrolling: "touch",
        width,
        willChange: "transform"
      };
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? "hidden" : "auto";
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? "hidden" : "auto";
      return /* @__PURE__ */ React.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: clsx("ReactVirtualized__Collection", className),
        id: id2,
        onScroll: this._onScroll,
        role: "grid",
        style: _objectSpread$5(_objectSpread$5({}, collectionStyle), style2),
        tabIndex: 0
      }, cellCount > 0 && /* @__PURE__ */ React.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: "hidden",
          pointerEvents: isScrolling ? "none" : "",
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer2());
    }
    /* ---------------------------- Helper methods ---------------------------- */
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
      this._disablePointerEventsTimeoutId = setTimeout(function() {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT$1);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;
      var scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, totalHeight = _ref.totalHeight, totalWidth = _ref.totalWidth;
      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft2 = _ref2.scrollLeft, scrollTop2 = _ref2.scrollTop;
          var _this3$props = _this3.props, height = _this3$props.height, onScroll6 = _this3$props.onScroll, width = _this3$props.width;
          onScroll6({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft2,
            scrollTop: scrollTop2,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft,
          scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
      };
      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }
      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }
      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
        };
      }
      return null;
    }
  }]);
})(React.PureComponent);
_defineProperty$2(CollectionView, "defaultProps", {
  "aria-label": "grid",
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: "auto",
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});
CollectionView.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": PropTypes.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,
  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,
  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,
  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,
  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,
  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,
  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,
  isScrollingChange: PropTypes.func,
  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,
  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,
  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,
  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(["auto", "end", "start", "center"]).isRequired,
  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,
  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,
  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,
  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,
  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};
polyfill(CollectionView);
var Section = /* @__PURE__ */ (function() {
  function Section2(_ref) {
    var height = _ref.height, width = _ref.width, x = _ref.x, y = _ref.y;
    _classCallCheck$2(this, Section2);
    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  return _createClass$2(Section2, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index2 = _ref2.index;
      if (!this._indexMap[index2]) {
        this._indexMap[index2] = true;
        this._indices.push(index2);
      }
    }
    /** Get all cell indices that have been added to this section. */
  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function toString2() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);
})();
var SECTION_SIZE = 100;
var SectionManager = /* @__PURE__ */ (function() {
  function SectionManager2() {
    var sectionSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SECTION_SIZE;
    _classCallCheck$2(this, SectionManager2);
    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  return _createClass$2(SectionManager2, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height, width = _ref.width, x = _ref.x, y = _ref.y;
      var indices = {};
      this.getSections({
        height,
        width,
        x,
        y
      }).forEach(function(section) {
        return section.getCellIndices().forEach(function(index2) {
          indices[index2] = index2;
        });
      });
      return Object.keys(indices).map(function(index2) {
        return indices[index2];
      });
    }
    /** Get size and position information for the cell specified. */
  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index2 = _ref2.index;
      return this._cellMetadata[index2];
    }
    /** Get all Sections overlapping the specified region. */
  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height, width = _ref3.width, x = _ref3.x, y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];
      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);
          if (!this._sections[key]) {
            this._sections[key] = new Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }
          sections.push(this._sections[key]);
        }
      }
      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */
  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function toString2() {
      var _this = this;
      return Object.keys(this._sections).map(function(index2) {
        return _this._sections[index2].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum, index2 = _ref4.index;
      this._cellMetadata[index2] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function(section) {
        return section.addCellIndex({
          index: index2
        });
      });
    }
  }]);
})();
function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount, cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter, sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager(sectionSize);
  var height = 0;
  var width = 0;
  for (var index2 = 0; index2 < cellCount; index2++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index2
    });
    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index2, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }
    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index2] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum,
      index: index2
    });
  }
  return {
    cellMetadata,
    height,
    sectionManager,
    width
  };
}
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align, align = _ref$align === void 0 ? "auto" : _ref$align, cellOffset = _ref.cellOffset, cellSize = _ref.cellSize, containerSize = _ref.containerSize, currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;
  switch (align) {
    case "start":
      return maxOffset;
    case "end":
      return minOffset;
    case "center":
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
function _callSuper$a(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$a() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var Collection = /* @__PURE__ */ (function(_React$PureComponent) {
  function Collection2(props, context2) {
    var _this;
    _classCallCheck$2(this, Collection2);
    _this = _callSuper$a(this, Collection2, [props, context2]);
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];
    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }
  _inherits$2(Collection2, _React$PureComponent);
  return _createClass$2(Collection2, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== void 0) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */
  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */
  }, {
    key: "render",
    value: function render2() {
      var props = _extends$7({}, (_objectDestructuringEmpty(this.props), this.props));
      return /* @__PURE__ */ React.createElement(CollectionView, _extends$7({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */
  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData$1() {
      var _this$props = this.props, cellCount = _this$props.cellCount, cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter, sectionSize = _this$props.sectionSize;
      var data2 = calculateSizeAndPositionData({
        cellCount,
        cellSizeAndPositionGetter,
        sectionSize
      });
      this._cellMetadata = data2.cellMetadata;
      this._sectionManager = data2.sectionManager;
      this._height = data2.height;
      this._width = data2.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */
  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */
  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align, cellIndex = _ref.cellIndex, height = _ref.height, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, width = _ref.width;
      var cellCount = this.props.cellCount;
      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft
        });
        scrollTop = getUpdatedOffsetForIndex({
          align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop
        });
      }
      return {
        scrollLeft,
        scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;
      var height = _ref2.height, isScrolling = _ref2.isScrolling, width = _ref2.width, x = _ref2.x, y = _ref2.y;
      var _this$props2 = this.props, cellGroupRenderer = _this$props2.cellGroupRenderer, cellRenderer = _this$props2.cellRenderer;
      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height,
        width,
        x,
        y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index2 = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index2
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref2) {
      this._collectionView = ref2;
    }
  }]);
})(React.PureComponent);
_defineProperty$2(Collection, "defaultProps", {
  "aria-label": "grid",
  cellGroupRenderer: defaultCellGroupRenderer
});
Collection.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": PropTypes.string,
  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,
  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,
  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,
  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};
function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache, cellRenderer = _ref4.cellRenderer, cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter, indices = _ref4.indices, isScrolling = _ref4.isScrolling;
  return indices.map(function(index2) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index2
    });
    var cellRendererProps = {
      index: index2,
      isScrolling,
      key: index2,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: "absolute",
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };
    if (isScrolling) {
      if (!(index2 in cellCache)) {
        cellCache[index2] = cellRenderer(cellRendererProps);
      }
      return cellCache[index2];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function(renderedCell) {
    return !!renderedCell;
  });
}
function _callSuper$9(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$9() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var ColumnSizer = /* @__PURE__ */ (function(_React$PureComponent) {
  function ColumnSizer2(props, context2) {
    var _this;
    _classCallCheck$2(this, ColumnSizer2);
    _this = _callSuper$9(this, ColumnSizer2, [props, context2]);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }
  _inherits$2(ColumnSizer2, _React$PureComponent);
  return _createClass$2(ColumnSizer2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props, columnMaxWidth = _this$props.columnMaxWidth, columnMinWidth = _this$props.columnMinWidth, columnCount = _this$props.columnCount, width = _this$props.width;
      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props2 = this.props, children2 = _this$props2.children, columnMaxWidth = _this$props2.columnMaxWidth, columnMinWidth = _this$props2.columnMinWidth, columnCount = _this$props2.columnCount, width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children2({
        adjustedWidth,
        columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== "function") {
        throw Error("Unexpected child type registered; only Grid/MultiGrid children are supported.");
      }
      this._registeredChild = child;
      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);
})(React.PureComponent);
ColumnSizer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,
  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,
  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,
  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,
  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
  if (cellCount !== nextCellsCount || (typeof cellSize === "number" || typeof nextCellSize === "number") && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
var CellSizeAndPositionManager = /* @__PURE__ */ (function() {
  function CellSizeAndPositionManager2(_ref) {
    var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
    _classCallCheck$2(this, CellSizeAndPositionManager2);
    _defineProperty$2(this, "_cellSizeAndPositionData", {});
    _defineProperty$2(this, "_lastMeasuredIndex", -1);
    _defineProperty$2(this, "_lastBatchedIndex", -1);
    _defineProperty$2(this, "_cellCount", void 0);
    _defineProperty$2(this, "_cellSizeGetter", void 0);
    _defineProperty$2(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }
  return _createClass$2(CellSizeAndPositionManager2, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure2(_ref2) {
      var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index2) {
      if (index2 < 0 || index2 >= this._cellCount) {
        throw Error("Requested index ".concat(index2, " is outside of range 0..").concat(this._cellCount));
      }
      if (index2 > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
        for (var i = this._lastMeasuredIndex + 1; i <= index2; i++) {
          var size2 = this._cellSizeGetter({
            index: i
          });
          if (size2 === void 0 || isNaN(size2)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size2));
          } else if (size2 === null) {
            this._cellSizeAndPositionData[i] = {
              offset,
              size: 0
            };
            this._lastBatchedIndex = index2;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset,
              size: size2
            };
            offset += size2;
            this._lastMeasuredIndex = index2;
          }
        }
      }
      return this._cellSizeAndPositionData[index2];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex2(_ref3) {
      var _ref3$align = _ref3.align, align = _ref3$align === void 0 ? "auto" : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
      if (containerSize <= 0) {
        return 0;
      }
      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;
      switch (align) {
        case "start":
          idealOffset = maxOffset;
          break;
        case "end":
          idealOffset = minOffset;
          break;
        case "center":
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }
      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize, offset = params.offset;
      var totalSize = this.getTotalSize();
      if (totalSize === 0) {
        return {};
      }
      var maxOffset = offset + containerSize;
      var start2 = this._findNearestCell(offset);
      var datum = this.getSizeAndPositionOfCell(start2);
      offset = datum.offset + datum.size;
      var stop2 = start2;
      while (offset < maxOffset && stop2 < this._cellCount - 1) {
        stop2++;
        offset += this.getSizeAndPositionOfCell(stop2).size;
      }
      return {
        start: start2,
        stop: stop2
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */
  }, {
    key: "resetCell",
    value: function resetCell(index2) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index2 - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }
      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index2, offset) {
      var interval = 1;
      while (index2 < this._cellCount && this.getSizeAndPositionOfCell(index2).offset < offset) {
        index2 += interval;
        interval *= 2;
      }
      return this._binarySearch(Math.min(index2, this._cellCount - 1), Math.floor(index2 / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */
  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      }
      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
})();
var DEFAULT_MAX_ELEMENT_SIZE = 15e5;
var CHROME_MAX_ELEMENT_SIZE = 16777100;
var isBrowser$1 = function isBrowser() {
  return typeof window !== "undefined";
};
var isChrome = function isChrome2() {
  return !!window.chrome;
};
var getMaxElementSize = function getMaxElementSize2() {
  if (isBrowser$1()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};
var _excluded$2 = ["maxScrollSize"];
var ScalingCellSizeAndPositionManager = /* @__PURE__ */ (function() {
  function ScalingCellSizeAndPositionManager2(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize, params = _objectWithoutProperties$2(_ref, _excluded$2);
    _classCallCheck$2(this, ScalingCellSizeAndPositionManager2);
    _defineProperty$2(this, "_cellSizeAndPositionManager", void 0);
    _defineProperty$2(this, "_maxScrollSize", void 0);
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }
  return _createClass$2(ScalingCellSizeAndPositionManager2, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure2(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize, offset = _ref2.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize,
        offset,
        totalSize: safeTotalSize
      });
      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index2) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index2);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex2(_ref3) {
      var _ref3$align = _ref3.align, align = _ref3$align === void 0 ? "auto" : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize,
        offset: currentOffset
      });
      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align,
        containerSize,
        currentOffset,
        targetIndex
      });
      return this._offsetToSafeOffset({
        containerSize,
        offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize, offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize,
        offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize,
        offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index2) {
      this._cellSizeAndPositionManager.resetCell(index2);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize, offset = _ref6.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize,
          offset,
          totalSize
        });
        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize, offset = _ref7.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize,
          offset,
          totalSize: safeTotalSize
        });
        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
})();
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD$1 = 1;
function defaultOverscanIndicesGetter$1(_ref) {
  var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
  if (scrollDirection === SCROLL_DIRECTION_FORWARD$1) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}
function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size2 = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size2 !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === "number" && cellSize !== previousCellSize;
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);
  } else if (!hasScrollToIndex && cellCount > 0 && (size2 < previousSize || cellCount < previousCellsCount)) {
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size2) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = [];
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible2 = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style2 = void 0;
      if (canCacheStyle && styleCache[key]) {
        style2 = styleCache[key];
      } else {
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          style2 = {
            height: "auto",
            left: 0,
            position: "absolute",
            top: 0,
            width: "auto"
          };
        } else {
          style2 = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: "absolute",
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style2;
        }
      }
      var cellRendererParams = {
        columnIndex,
        isScrolling,
        isVisible: isVisible2,
        key,
        parent,
        rowIndex,
        style: style2
      };
      var renderedCell = void 0;
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }
        renderedCell = cellCache[key];
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }
      if (renderedCell == null || renderedCell === false) {
        continue;
      }
      if (process.env.NODE_ENV !== "production") {
        warnAboutMissingStyle(parent, renderedCell);
      }
      if (!renderedCell.props.role) {
        renderedCell = /* @__PURE__ */ React__default.cloneElement(renderedCell, {
          role: "gridcell"
        });
      }
      renderedCells.push(renderedCell);
    }
  }
  return renderedCells;
}
function warnAboutMissingStyle(parent, renderedCell) {
  if (process.env.NODE_ENV !== "production") {
    if (renderedCell) {
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }
      if (renderedCell && renderedCell.props && renderedCell.props.style === void 0 && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn("Rendered cell should include style property for positioning.");
      }
    }
  }
}
var win;
if (typeof window !== "undefined") {
  win = window;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function(callback) {
  return win.setTimeout(callback, 1e3 / 60);
};
var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function(id2) {
  win.clearTimeout(id2);
};
var raf2 = request;
var caf2 = cancel;
var cancelAnimationTimeout = function cancelAnimationTimeout2(frame) {
  return caf2(frame.id);
};
var requestAnimationTimeout = function requestAnimationTimeout2(callback, delay) {
  var start2;
  Promise.resolve().then(function() {
    start2 = Date.now();
  });
  var _timeout = function timeout() {
    if (Date.now() - start2 >= delay) {
      callback.call();
    } else {
      frame.id = raf2(_timeout);
    }
  };
  var frame = {
    id: raf2(_timeout)
  };
  return frame;
};
function ownKeys$4(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$4(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$8(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$8() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL$1 = 150;
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: "observed",
  REQUESTED: "requested"
};
var renderNull = function renderNull2() {
  return null;
};
var Grid = /* @__PURE__ */ (function(_React$PureComponent) {
  function Grid2(props) {
    var _this;
    _classCallCheck$2(this, Grid2);
    _this = _callSuper$8(this, Grid2, [props]);
    _defineProperty$2(_this, "_onGridRenderedMemoizer", createCallbackMemoizer());
    _defineProperty$2(_this, "_onScrollMemoizer", createCallbackMemoizer(false));
    _defineProperty$2(_this, "_deferredInvalidateColumnIndex", null);
    _defineProperty$2(_this, "_deferredInvalidateRowIndex", null);
    _defineProperty$2(_this, "_recomputeScrollLeftFlag", false);
    _defineProperty$2(_this, "_recomputeScrollTopFlag", false);
    _defineProperty$2(_this, "_horizontalScrollBarSize", 0);
    _defineProperty$2(_this, "_verticalScrollBarSize", 0);
    _defineProperty$2(_this, "_scrollbarPresenceChanged", false);
    _defineProperty$2(_this, "_scrollingContainer", void 0);
    _defineProperty$2(_this, "_childrenToDisplay", void 0);
    _defineProperty$2(_this, "_columnStartIndex", void 0);
    _defineProperty$2(_this, "_columnStopIndex", void 0);
    _defineProperty$2(_this, "_rowStartIndex", void 0);
    _defineProperty$2(_this, "_rowStopIndex", void 0);
    _defineProperty$2(_this, "_renderedColumnStartIndex", 0);
    _defineProperty$2(_this, "_renderedColumnStopIndex", 0);
    _defineProperty$2(_this, "_renderedRowStartIndex", 0);
    _defineProperty$2(_this, "_renderedRowStopIndex", 0);
    _defineProperty$2(_this, "_initialScrollTop", void 0);
    _defineProperty$2(_this, "_initialScrollLeft", void 0);
    _defineProperty$2(_this, "_disablePointerEventsTimeoutId", void 0);
    _defineProperty$2(_this, "_styleCache", {});
    _defineProperty$2(_this, "_cellCache", {});
    _defineProperty$2(_this, "_debounceScrollEndedCallback", function() {
      _this._disablePointerEventsTimeoutId = null;
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    _defineProperty$2(_this, "_invokeOnGridRenderedHelper", function() {
      var onSectionRendered3 = _this.props.onSectionRendered;
      _this._onGridRenderedMemoizer({
        callback: onSectionRendered3,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    _defineProperty$2(_this, "_setScrollingContainerRef", function(ref2) {
      _this._scrollingContainer = ref2;
      if (typeof _this.props.elementRef === "function") {
        _this.props.elementRef(ref2);
      } else if (_typeof(_this.props.elementRef) === "object") {
        _this.props.elementRef.current = ref2;
      }
    });
    _defineProperty$2(_this, "_onScroll", function(event) {
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });
    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid2._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid2._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid2._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid2._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager,
        rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD$1,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD$1,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };
    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }
  _inherits$2(Grid2, _React$PureComponent);
  return _createClass$2(Grid2, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
      var offsetProps = _objectSpread$4(_objectSpread$4({}, this.props), {}, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });
      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */
  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */
  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */
  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
      if (scrollTopParam < 0) {
        return;
      }
      this._debounceScrollEnded();
      var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
      var instanceProps = this.state.instanceProps;
      var scrollbarSize2 = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize2), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize2), scrollTopParam);
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal,
          scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };
        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }
        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }
        newState.needToResetStyleCache = false;
        this.setState(newState);
      }
      this._invokeOnScrollMemoizer({
        scrollLeft,
        scrollTop,
        totalColumnsWidth,
        totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === "number" ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === "number" ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */
  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
      var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD$1 ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD$1 ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */
  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props;
      if (columnCount > 1 && columnIndex !== void 0) {
        this._updateScrollLeftForScrollToColumn(_objectSpread$4(_objectSpread$4({}, props), {}, {
          scrollToColumn: columnIndex
        }));
      }
      if (rowIndex !== void 0) {
        this._updateScrollTopForScrollToRow(_objectSpread$4(_objectSpread$4({}, props), {}, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
      var instanceProps = this.state.instanceProps;
      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;
      this._handleInvalidatedGridSize();
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function(prevState) {
          var stateUpdate2 = _objectSpread$4(_objectSpread$4({}, prevState), {}, {
            needToResetStyleCache: false
          });
          stateUpdate2.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate2.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate2;
        });
      }
      if (typeof scrollLeft === "number" && scrollLeft >= 0 || typeof scrollTop === "number" && scrollTop >= 0) {
        var stateUpdate = Grid2._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft,
          scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }
      if (this._scrollingContainer) {
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }
      this._invokeOnGridRenderedHelper();
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });
      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
      var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
      this._handleInvalidatedGridSize();
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }
      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }
      this._invokeOnGridRenderedHelper();
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        this._invokeOnScrollMemoizer({
          scrollLeft,
          scrollTop,
          totalColumnsWidth,
          totalRowsHeight
        });
      }
      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "render",
    value: function render2() {
      var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id2 = _this$props6.id, noContentRenderer2 = _this$props6.noContentRenderer, role = _this$props6.role, style2 = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
      var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
      var isScrolling = this._isScrolling();
      var gridStyle = {
        boxSizing: "border-box",
        direction: "ltr",
        height: autoHeight ? "auto" : height,
        position: "relative",
        width: autoWidth ? "auto" : width,
        WebkitOverflowScrolling: "touch",
        willChange: "transform"
      };
      if (needToResetStyleCache) {
        this._styleCache = {};
      }
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }
      this._calculateChildrenToRender(this.props, this.state);
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? "hidden" : "auto";
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? "hidden" : "auto";
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return /* @__PURE__ */ React.createElement("div", _extends$7({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props["aria-label"],
        "aria-readonly": this.props["aria-readonly"],
        className: clsx("ReactVirtualized__Grid", className),
        id: id2,
        onScroll: this._onScroll,
        role,
        style: _objectSpread$4(_objectSpread$4({}, gridStyle), style2),
        tabIndex
      }), childrenToDisplay.length > 0 && /* @__PURE__ */ React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread$4({
          width: autoContainerWidth ? "auto" : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: "hidden",
          pointerEvents: isScrolling ? "none" : "",
          position: "relative"
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer2());
    }
    /* ---------------------------- Helper methods ---------------------------- */
  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
      var isScrolling = this._isScrolling(props, state);
      this._childrenToDisplay = [];
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: "horizontal",
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === "number" ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === "number" ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: "vertical",
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === "number" ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === "number" ? visibleRowIndices.stop : -1
        });
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;
        if (deferredMeasurementCache) {
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }
        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex,
          columnStopIndex,
          deferredMeasurementCache,
          horizontalOffsetAdjustment,
          isScrolling,
          isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex,
          rowStopIndex,
          scrollLeft,
          scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment,
          visibleColumnIndices,
          visibleRowIndices
        });
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
      this._disablePointerEventsTimeoutId = requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: (
      /**
       * Check for batched CellMeasurer size invalidations.
       * This will occur the first time one or more previously unmeasured cells are rendered.
       */
      function _handleInvalidatedGridSize() {
        if (typeof this._deferredInvalidateColumnIndex === "number" && typeof this._deferredInvalidateRowIndex === "number") {
          var columnIndex = this._deferredInvalidateColumnIndex;
          var rowIndex = this._deferredInvalidateRowIndex;
          this._deferredInvalidateColumnIndex = null;
          this._deferredInvalidateRowIndex = null;
          this.recomputeGridSize({
            columnIndex,
            rowIndex
          });
        }
      }
    )
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;
      var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft2 = _ref7.scrollLeft, scrollTop2 = _ref7.scrollTop;
          var _this3$props = _this3.props, height = _this3$props.height, onScroll6 = _this3$props.onScroll, width = _this3$props.width;
          onScroll6({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft2,
            scrollTop: scrollTop2,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft,
          scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return Object.hasOwnProperty.call(props, "isScrolling") ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange2 = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange2({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",
    value: (
      /**
       * Scroll to the specified offset(s).
       * Useful for animating position changes.
       */
      function scrollToPosition(_ref8) {
        var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
        var stateUpdate = Grid2._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft,
          scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }
    )
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return Grid2._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      var stateUpdate = Grid2._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return Grid2._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;
      this._cellCache = {};
      this._styleCache = {};
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];
          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      var stateUpdate = Grid2._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};
      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid2._getScrollToPositionStateUpdate({
          prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }
      var instanceProps = prevState.instanceProps;
      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        newState.needToResetStyleCache = true;
      }
      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid2._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid2._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid2._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid2._wrapSizeGetter(nextProps.rowHeight)
      });
      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }
      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === "number" ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === "number" ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid2._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === "number" ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === "number" ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid2._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === void 0) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }
      newState.instanceProps = instanceProps;
      return _objectSpread$4(_objectSpread$4(_objectSpread$4({}, newState), maybeStateA), maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === "number" ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === "number" ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",
    value: (
      /**
       * Get the updated state after scrolling to
       * scrollLeft and scrollTop
       */
      function _getScrollToPositionStateUpdate(_ref9) {
        var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
        var newState = {
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
        if (typeof scrollLeft === "number" && scrollLeft >= 0) {
          newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD;
          newState.scrollLeft = scrollLeft;
        }
        if (typeof scrollTop === "number" && scrollTop >= 0) {
          newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD;
          newState.scrollTop = scrollTop;
        }
        if (typeof scrollLeft === "number" && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === "number" && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
          return newState;
        }
        return {};
      }
    )
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === "function" ? value : function() {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
      var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;
      var calculatedScrollLeft = Grid2._getCalculatedScrollLeft(nextProps, prevState);
      if (typeof calculatedScrollLeft === "number" && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid2._getScrollToPositionStateUpdate({
          prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
      var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;
      var calculatedScrollTop = Grid2._getCalculatedScrollTop(nextProps, prevState);
      if (typeof calculatedScrollTop === "number" && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid2._getScrollToPositionStateUpdate({
          prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return {};
    }
  }]);
})(React.PureComponent);
_defineProperty$2(Grid, "defaultProps", {
  "aria-label": "grid",
  "aria-readonly": true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: "row",
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll2() {
  },
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {
  },
  onSectionRendered: function onSectionRendered2() {
  },
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter$1,
  overscanRowCount: 10,
  role: "grid",
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL$1,
  scrollToAlignment: "auto",
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
polyfill(Grid);
var SCROLL_DIRECTION_FORWARD = 1;
function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
  overscanCellsCount = Math.max(1, overscanCellsCount);
  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}
function _callSuper$7(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$7() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var InfiniteLoader = /* @__PURE__ */ (function(_React$PureComponent) {
  function InfiniteLoader2(props, context2) {
    var _this;
    _classCallCheck$2(this, InfiniteLoader2);
    _this = _callSuper$7(this, InfiniteLoader2, [props, context2]);
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }
  _inherits$2(InfiniteLoader2, _React$PureComponent);
  return _createClass$2(InfiniteLoader2, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();
      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var children2 = this.props.children;
      return children2({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;
      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function(unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function() {
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;
      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2, _this3 = this;
      var _this$props = this.props, isRowLoaded = _this$props.isRowLoaded, minimumBatchSize = _this$props.minimumBatchSize, rowCount = _this$props.rowCount, threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded,
        minimumBatchSize,
        rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });
      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, _toConsumableArray$2(unloadedRanges.map(function(_ref3) {
        var startIndex2 = _ref3.startIndex, stopIndex2 = _ref3.stopIndex;
        return [startIndex2, stopIndex2];
      })));
      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);
})(React.PureComponent);
_defineProperty$2(InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});
InfiniteLoader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,
  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,
  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,
  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,
  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,
  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex, lastRenderedStopIndex = _ref4.lastRenderedStopIndex, startIndex = _ref4.startIndex, stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded, minimumBatchSize = _ref5.minimumBatchSize, rowCount = _ref5.rowCount, startIndex = _ref5.startIndex, stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;
  for (var index2 = startIndex; index2 <= stopIndex; index2++) {
    var loaded = isRowLoaded({
      index: index2
    });
    if (!loaded) {
      rangeStopIndex = index2;
      if (rangeStartIndex === null) {
        rangeStartIndex = index2;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  }
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }
    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];
    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;
      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }
  return unloadedRanges;
}
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === "function" ? component.recomputeGridSize : component.recomputeRowHeights;
  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
function _callSuper$6(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$6() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var List = /* @__PURE__ */ (function(_React$PureComponent) {
  function List2() {
    var _this;
    _classCallCheck$2(this, List2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$6(this, List2, [].concat(args));
    _defineProperty$2(_this, "Grid", void 0);
    _defineProperty$2(_this, "_cellRenderer", function(_ref) {
      var parent = _ref.parent, rowIndex = _ref.rowIndex, style2 = _ref.style, isScrolling = _ref.isScrolling, isVisible2 = _ref.isVisible, key = _ref.key;
      var rowRenderer = _this.props.rowRenderer;
      var widthDescriptor = Object.getOwnPropertyDescriptor(style2, "width");
      if (widthDescriptor && widthDescriptor.writable) {
        style2.width = "100%";
      }
      return rowRenderer({
        index: rowIndex,
        style: style2,
        isScrolling,
        isVisible: isVisible2,
        key,
        parent
      });
    });
    _defineProperty$2(_this, "_setRef", function(ref2) {
      _this.Grid = ref2;
    });
    _defineProperty$2(_this, "_onScroll", function(_ref2) {
      var clientHeight = _ref2.clientHeight, scrollHeight = _ref2.scrollHeight, scrollTop = _ref2.scrollTop;
      var onScroll6 = _this.props.onScroll;
      onScroll6({
        clientHeight,
        scrollHeight,
        scrollTop
      });
    });
    _defineProperty$2(_this, "_onSectionRendered", function(_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex, rowOverscanStopIndex = _ref3.rowOverscanStopIndex, rowStartIndex = _ref3.rowStartIndex, rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered3 = _this.props.onRowsRendered;
      onRowsRendered3({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }
  _inherits$2(List2, _React$PureComponent);
  return _createClass$2(List2, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment, index2 = _ref4.index;
      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment,
          rowIndex: index2,
          columnIndex: 0
        }), scrollTop = _this$Grid$getOffsetF.scrollTop;
        return scrollTop;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex,
          columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex,
          columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index2,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index2
        });
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props = this.props, className = _this$props.className, noRowsRenderer3 = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
      var classNames2 = clsx("ReactVirtualized__List", className);
      return /* @__PURE__ */ React.createElement(Grid, _extends$7({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames2,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer3,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
})(React.PureComponent);
_defineProperty$2(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll3() {
  },
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
  },
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === "function") {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === "function") {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === "function") {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === "function") {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _EQA(a, l, h, y) {
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  while (l <= h) {
    var m = l + h >>> 1, x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === "function") {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
const bounds = {
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
};
var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;
function IntervalTreeNode(mid, left2, right2, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left2;
  this.right = right2;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left2 ? left2.count : 0) + (right2 ? right2.count : 0) + leftPoints.length;
}
var proto = IntervalTreeNode.prototype;
function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}
function rebuild(node2, intervals) {
  var ntree = createIntervalTree(intervals);
  node2.mid = ntree.mid;
  node2.left = ntree.left;
  node2.right = ntree.right;
  node2.leftPoints = ntree.leftPoints;
  node2.rightPoints = ntree.rightPoints;
  node2.count = ntree.count;
}
function rebuildWithInterval(node2, interval) {
  var intervals = node2.intervals([]);
  intervals.push(interval);
  rebuild(node2, intervals);
}
function rebuildWithoutInterval(node2, interval) {
  var intervals = node2.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node2, intervals);
  return SUCCESS;
}
proto.intervals = function(result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};
proto.insert = function(interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = bounds.ge(this.leftPoints, interval, compareBegin);
    var r2 = bounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r2, 0, interval);
  }
};
proto.remove = function(interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r2 = this.left.remove(interval);
    if (r2 === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r2 === SUCCESS) {
      this.count -= 1;
    }
    return r2;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r2 = this.right.remove(interval);
    if (r2 === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r2 === SUCCESS) {
      this.count -= 1;
    }
    return r2;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r2 = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r2;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = bounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r2 = bounds.ge(this.rightPoints, interval, compareEnd); r2 < this.rightPoints.length; ++r2) {
          if (this.rightPoints[r2][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r2] === interval) {
            this.rightPoints.splice(r2, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};
function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r2 = cb(arr[i]);
    if (r2) {
      return r2;
    }
  }
}
function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r2 = cb(arr[i]);
    if (r2) {
      return r2;
    }
  }
}
function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r2 = cb(arr[i]);
    if (r2) {
      return r2;
    }
  }
}
proto.queryPoint = function(x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r2 = this.left.queryPoint(x, cb);
      if (r2) {
        return r2;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r2 = this.right.queryPoint(x, cb);
      if (r2) {
        return r2;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};
proto.queryInterval = function(lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r2 = this.left.queryInterval(lo, hi, cb);
    if (r2) {
      return r2;
    }
  }
  if (hi > this.mid && this.right) {
    var r2 = this.right.queryInterval(lo, hi, cb);
    if (r2) {
      return r2;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};
function compareNumbers(a, b) {
  return a - b;
}
function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}
function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}
function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}
function IntervalTree(root) {
  this.root = root;
}
var tproto = IntervalTree.prototype;
tproto.insert = function(interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};
tproto.remove = function(interval) {
  if (this.root) {
    var r2 = this.root.remove(interval);
    if (r2 === EMPTY) {
      this.root = null;
    }
    return r2 !== NOT_FOUND;
  }
  return false;
};
tproto.queryPoint = function(p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};
tproto.queryInterval = function(lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};
Object.defineProperty(tproto, "count", {
  get: function get2() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});
Object.defineProperty(tproto, "intervals", {
  get: function get3() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});
function createWrapper(intervals) {
  {
    return new IntervalTree(null);
  }
}
var PositionCache = /* @__PURE__ */ (function() {
  function PositionCache2() {
    _classCallCheck$2(this, PositionCache2);
    _defineProperty$2(this, "_columnSizeMap", {});
    _defineProperty$2(this, "_intervalTree", createWrapper());
    _defineProperty$2(this, "_leftMap", {});
  }
  return _createClass$2(PositionCache2, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }
    // Render all cells visible within the viewport range defined.
  }, {
    key: "range",
    value: function range3(scrollTop, clientHeight, renderCallback) {
      var _this = this;
      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function(_ref) {
        var _ref2 = _slicedToArray$2(_ref, 3), top2 = _ref2[0];
        _ref2[1];
        var index2 = _ref2[2];
        return renderCallback(index2, _this._leftMap[index2], top2);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index2, left2, top2, height) {
      this._intervalTree.insert([top2, top2 + height, index2]);
      this._leftMap[index2] = left2;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left2];
      if (columnHeight === void 0) {
        columnSizeMap[left2] = top2 + height;
      } else {
        columnSizeMap[left2] = Math.max(columnHeight, top2 + height);
      }
    }
  }, {
    key: "count",
    get: function get4() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get4() {
      var columnSizeMap = this._columnSizeMap;
      var size2 = 0;
      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size2 = size2 === 0 ? height : Math.min(size2, height);
      }
      return size2;
    }
  }, {
    key: "tallestColumnSize",
    get: function get4() {
      var columnSizeMap = this._columnSizeMap;
      var size2 = 0;
      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size2 = Math.max(size2, height);
      }
      return size2;
    }
  }]);
})();
function ownKeys$3(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$5(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var emptyObject = {};
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
var Masonry = /* @__PURE__ */ (function(_React$PureComponent) {
  function Masonry2() {
    var _this;
    _classCallCheck$2(this, Masonry2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$5(this, Masonry2, [].concat(args));
    _defineProperty$2(_this, "state", {
      isScrolling: false,
      scrollTop: 0
    });
    _defineProperty$2(_this, "_debounceResetIsScrollingId", void 0);
    _defineProperty$2(_this, "_invalidateOnUpdateStartIndex", null);
    _defineProperty$2(_this, "_invalidateOnUpdateStopIndex", null);
    _defineProperty$2(_this, "_positionCache", new PositionCache());
    _defineProperty$2(_this, "_startIndex", null);
    _defineProperty$2(_this, "_startIndexMemoized", null);
    _defineProperty$2(_this, "_stopIndex", null);
    _defineProperty$2(_this, "_stopIndexMemoized", null);
    _defineProperty$2(_this, "_debounceResetIsScrollingCallback", function() {
      _this.setState({
        isScrolling: false
      });
    });
    _defineProperty$2(_this, "_setScrollingContainerRef", function(ref2) {
      _this._scrollingContainer = ref2;
    });
    _defineProperty$2(_this, "_onScroll", function(event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop;
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);
      if (eventScrollTop !== scrollTop) {
        return;
      }
      _this._debounceResetIsScrolling();
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop
        });
      }
    });
    return _this;
  }
  _inherits$2(Masonry2, _React$PureComponent);
  return _createClass$2(Masonry2, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache();
      this.forceUpdate();
    }
    // HACK This method signature was intended for Grid
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index2 = _ref.rowIndex;
      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index2;
        this._invalidateOnUpdateStopIndex = index2;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index2);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index2);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache();
      this._populatePositionCache(0, stopIndex);
      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render2() {
      var _this2 = this;
      var _this$props = this.props, autoHeight = _this$props.autoHeight, cellCount = _this$props.cellCount, cellMeasurerCache = _this$props.cellMeasurerCache, cellRenderer = _this$props.cellRenderer, className = _this$props.className, height = _this$props.height, id2 = _this$props.id, keyMapper = _this$props.keyMapper, overscanByPixels = _this$props.overscanByPixels, role = _this$props.role, style2 = _this$props.style, tabIndex = _this$props.tabIndex, width = _this$props.width, rowDirection = _this$props.rowDirection;
      var _this$state = this.state, isScrolling = _this$state.isScrolling, scrollTop = _this$state.scrollTop;
      var children2 = [];
      var estimateTotalHeight = this._getEstimatedTotalHeight();
      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;
      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function(index2, left2, top2) {
        if (typeof stopIndex === "undefined") {
          startIndex = index2;
          stopIndex = index2;
        } else {
          startIndex = Math.min(startIndex, index2);
          stopIndex = Math.max(stopIndex, index2);
        }
        children2.push(cellRenderer({
          index: index2,
          isScrolling,
          key: keyMapper(index2),
          parent: _this2,
          style: _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({
            height: cellMeasurerCache.getHeight(index2)
          }, rowDirection === "ltr" ? "left" : "right", left2), "position", "absolute"), "top", top2), "width", cellMeasurerCache.getWidth(index2))
        }));
      });
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children2.push(cellRenderer({
            index: _index,
            isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }
      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return /* @__PURE__ */ React.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: clsx("ReactVirtualized__Masonry", className),
        id: id2,
        onScroll: this._onScroll,
        role,
        style: _objectSpread$3({
          boxSizing: "border-box",
          direction: "ltr",
          height: autoHeight ? "auto" : height,
          overflowX: "hidden",
          overflowY: estimateTotalHeight < height ? "hidden" : "auto",
          position: "relative",
          width,
          WebkitOverflowScrolling: "touch",
          willChange: "transform"
        }, style2),
        tabIndex
      }, /* @__PURE__ */ React.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: "100%",
          height: estimateTotalHeight,
          maxWidth: "100%",
          maxHeight: estimateTotalHeight,
          overflow: "hidden",
          pointerEvents: isScrolling ? "none" : "",
          position: "relative"
        }
      }, children2));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === "number") {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;
        this._populatePositionCache(startIndex, stopIndex);
        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
      this._debounceResetIsScrollingId = requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props, cellCount = _this$props2.cellCount, cellMeasurerCache = _this$props2.cellMeasurerCache, width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props, height = _this$props3.height, onScroll6 = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;
      if (this._onScrollMemoized !== scrollTop) {
        onScroll6({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props, cellMeasurerCache = _this$props4.cellMeasurerCache, cellPositioner = _this$props4.cellPositioner;
      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2), left2 = _cellPositioner.left, top2 = _cellPositioner.top;
        this._positionCache.setPosition(_index2, left2, top2, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== void 0 && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }
      return null;
    }
  }]);
})(React.PureComponent);
_defineProperty$2(Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop3,
  onScroll: noop3,
  overscanByPixels: 20,
  role: "grid",
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: "ltr"
});
function identity(value) {
  return value;
}
function noop3() {
}
polyfill(Masonry);
var CellMeasurerCacheDecorator = /* @__PURE__ */ (function() {
  function CellMeasurerCacheDecorator2() {
    var _this = this;
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$2(this, CellMeasurerCacheDecorator2);
    _defineProperty$2(this, "_cellMeasurerCache", void 0);
    _defineProperty$2(this, "_columnIndexOffset", void 0);
    _defineProperty$2(this, "_rowIndexOffset", void 0);
    _defineProperty$2(this, "columnWidth", function(_ref) {
      var index2 = _ref.index;
      _this._cellMeasurerCache.columnWidth({
        index: index2 + _this._columnIndexOffset
      });
    });
    _defineProperty$2(this, "rowHeight", function(_ref2) {
      var index2 = _ref2.index;
      _this._cellMeasurerCache.rowHeight({
        index: index2 + _this._rowIndexOffset
      });
    });
    var cellMeasurerCache = params.cellMeasurerCache, _params$columnIndexOf = params.columnIndexOffset, columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf, _params$rowIndexOffse = params.rowIndexOffset, rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }
  return _createClass$2(CellMeasurerCacheDecorator2, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "defaultHeight",
    get: function get4() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get4() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has2(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set2(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }]);
})();
var _excluded$1 = ["rowIndex"], _excluded2$1 = ["columnIndex", "rowIndex"], _excluded3$1 = ["columnIndex"], _excluded4 = ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"];
function ownKeys$2(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$4(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var SCROLLBAR_SIZE_BUFFER = 20;
var MultiGrid = /* @__PURE__ */ (function(_React$PureComponent) {
  function MultiGrid2(props, context2) {
    var _this;
    _classCallCheck$2(this, MultiGrid2);
    _this = _callSuper$4(this, MultiGrid2, [props, context2]);
    _defineProperty$2(_this, "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });
    _defineProperty$2(_this, "_deferredInvalidateColumnIndex", null);
    _defineProperty$2(_this, "_deferredInvalidateRowIndex", null);
    _defineProperty$2(_this, "_bottomLeftGridRef", function(ref2) {
      _this._bottomLeftGrid = ref2;
    });
    _defineProperty$2(_this, "_bottomRightGridRef", function(ref2) {
      _this._bottomRightGrid = ref2;
    });
    _defineProperty$2(_this, "_cellRendererBottomLeftGrid", function(_ref) {
      var rowIndex = _ref.rowIndex, rest = _objectWithoutProperties$2(_ref, _excluded$1);
      var _this$props = _this.props, cellRenderer = _this$props.cellRenderer, fixedRowCount = _this$props.fixedRowCount, rowCount = _this$props.rowCount;
      if (rowIndex === rowCount - fixedRowCount) {
        return /* @__PURE__ */ React.createElement("div", {
          key: rest.key,
          style: _objectSpread$2(_objectSpread$2({}, rest.style), {}, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread$2(_objectSpread$2({}, rest), {}, {
          parent: _this,
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });
    _defineProperty$2(_this, "_cellRendererBottomRightGrid", function(_ref2) {
      var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex, rest = _objectWithoutProperties$2(_ref2, _excluded2$1);
      var _this$props2 = _this.props, cellRenderer = _this$props2.cellRenderer, fixedColumnCount = _this$props2.fixedColumnCount, fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(_objectSpread$2(_objectSpread$2({}, rest), {}, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this,
        rowIndex: rowIndex + fixedRowCount
      }));
    });
    _defineProperty$2(_this, "_cellRendererTopRightGrid", function(_ref3) {
      var columnIndex = _ref3.columnIndex, rest = _objectWithoutProperties$2(_ref3, _excluded3$1);
      var _this$props3 = _this.props, cellRenderer = _this$props3.cellRenderer, columnCount = _this$props3.columnCount, fixedColumnCount = _this$props3.fixedColumnCount;
      if (columnIndex === columnCount - fixedColumnCount) {
        return /* @__PURE__ */ React.createElement("div", {
          key: rest.key,
          style: _objectSpread$2(_objectSpread$2({}, rest.style), {}, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread$2(_objectSpread$2({}, rest), {}, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: _this
        }));
      }
    });
    _defineProperty$2(_this, "_columnWidthRightGrid", function(_ref4) {
      var index2 = _ref4.index;
      var _this$props4 = _this.props, columnCount = _this$props4.columnCount, fixedColumnCount = _this$props4.fixedColumnCount, columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state, scrollbarSize2 = _this$state.scrollbarSize, showHorizontalScrollbar = _this$state.showHorizontalScrollbar;
      if (showHorizontalScrollbar && index2 === columnCount - fixedColumnCount) {
        return scrollbarSize2;
      }
      return typeof columnWidth === "function" ? columnWidth({
        index: index2 + fixedColumnCount
      }) : columnWidth;
    });
    _defineProperty$2(_this, "_onScroll", function(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft, scrollTop = scrollInfo.scrollTop;
      _this.setState({
        scrollLeft,
        scrollTop
      });
      var onScroll6 = _this.props.onScroll;
      if (onScroll6) {
        onScroll6(scrollInfo);
      }
    });
    _defineProperty$2(_this, "_onScrollbarPresenceChange", function(_ref5) {
      var horizontal2 = _ref5.horizontal, size2 = _ref5.size, vertical2 = _ref5.vertical;
      var _this$state2 = _this.state, showHorizontalScrollbar = _this$state2.showHorizontalScrollbar, showVerticalScrollbar = _this$state2.showVerticalScrollbar;
      if (horizontal2 !== showHorizontalScrollbar || vertical2 !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size2,
          showHorizontalScrollbar: horizontal2,
          showVerticalScrollbar: vertical2
        });
        var onScrollbarPresenceChange2 = _this.props.onScrollbarPresenceChange;
        if (typeof onScrollbarPresenceChange2 === "function") {
          onScrollbarPresenceChange2({
            horizontal: horizontal2,
            size: size2,
            vertical: vertical2
          });
        }
      }
    });
    _defineProperty$2(_this, "_onScrollLeft", function(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;
      _this._onScroll({
        scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });
    _defineProperty$2(_this, "_onScrollTop", function(scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;
      _this._onScroll({
        scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });
    _defineProperty$2(_this, "_rowHeightBottomGrid", function(_ref6) {
      var index2 = _ref6.index;
      var _this$props5 = _this.props, fixedRowCount = _this$props5.fixedRowCount, rowCount = _this$props5.rowCount, rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state, scrollbarSize2 = _this$state3.scrollbarSize, showVerticalScrollbar = _this$state3.showVerticalScrollbar;
      if (showVerticalScrollbar && index2 === rowCount - fixedRowCount) {
        return scrollbarSize2;
      }
      return typeof rowHeight === "function" ? rowHeight({
        index: index2 + fixedRowCount
      }) : rowHeight;
    });
    _defineProperty$2(_this, "_topLeftGridRef", function(ref2) {
      _this._topLeftGrid = ref2;
    });
    _defineProperty$2(_this, "_topRightGridRef", function(ref2) {
      _this._topRightGrid = ref2;
    });
    var deferredMeasurementCache = props.deferredMeasurementCache, _fixedColumnCount = props.fixedColumnCount, _fixedRowCount = props.fixedRowCount;
    _this._maybeCalculateCachedStyles(true);
    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }
  _inherits$2(MultiGrid2, _React$PureComponent);
  return _createClass$2(MultiGrid2, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === "number" ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === "number" ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref8$columnIndex = _ref8.columnIndex, columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex, _ref8$rowIndex = _ref8.rowIndex, rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;
      var _this$props6 = this.props, fixedColumnCount = _this$props6.fixedColumnCount, fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex,
        rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props, scrollLeft = _this$props7.scrollLeft, scrollTop = _this$props7.scrollTop;
      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};
        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }
        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }
        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render2() {
      var _this$props8 = this.props, onScroll6 = _this$props8.onScroll, onSectionRendered3 = _this$props8.onSectionRendered;
      _this$props8.onScrollbarPresenceChange;
      _this$props8.scrollLeft;
      var scrollToColumn = _this$props8.scrollToColumn;
      _this$props8.scrollTop;
      var scrollToRow = _this$props8.scrollToRow, rest = _objectWithoutProperties$2(_this$props8, _excluded4);
      this._prepareForRender();
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }
      var _this$state4 = this.state, scrollLeft = _this$state4.scrollLeft, scrollTop = _this$state4.scrollTop;
      return /* @__PURE__ */ React.createElement("div", {
        style: this._containerOuterStyle
      }, /* @__PURE__ */ React.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(_objectSpread$2(_objectSpread$2({}, rest), {}, {
        onScroll: onScroll6,
        scrollLeft
      }))), /* @__PURE__ */ React.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(_objectSpread$2(_objectSpread$2({}, rest), {}, {
        onScroll: onScroll6,
        scrollTop
      })), this._renderBottomRightGrid(_objectSpread$2(_objectSpread$2({}, rest), {}, {
        onScroll: onScroll6,
        onSectionRendered: onSectionRendered3,
        scrollLeft,
        scrollToColumn,
        scrollToRow,
        scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;
      var topGridHeight = this._getTopGridHeight(props);
      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount, columnWidth = props.columnWidth;
      if (this._leftGridWidth == null) {
        if (typeof columnWidth === "function") {
          var leftGridWidth = 0;
          for (var index2 = 0; index2 < fixedColumnCount; index2++) {
            leftGridWidth += columnWidth({
              index: index2
            });
          }
          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }
      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;
      var leftGridWidth = this._getLeftGridWidth(props);
      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount, rowHeight = props.rowHeight;
      if (this._topGridHeight == null) {
        if (typeof rowHeight === "function") {
          var topGridHeight = 0;
          for (var index2 = 0; index2 < fixedRowCount; index2++) {
            topGridHeight += rowHeight({
              index: index2
            });
          }
          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }
      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === "number") {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex,
          rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */
  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props, columnWidth = _this$props9.columnWidth, enableFixedColumnScroll = _this$props9.enableFixedColumnScroll, enableFixedRowScroll = _this$props9.enableFixedRowScroll, height = _this$props9.height, fixedColumnCount = _this$props9.fixedColumnCount, fixedRowCount = _this$props9.fixedRowCount, rowHeight = _this$props9.rowHeight, style2 = _this$props9.style, styleBottomLeftGrid = _this$props9.styleBottomLeftGrid, styleBottomRightGrid = _this$props9.styleBottomRightGrid, styleTopLeftGrid = _this$props9.styleTopLeftGrid, styleTopRightGrid = _this$props9.styleTopRightGrid, width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;
      if (resetAll || sizeChange || style2 !== this._lastRenderedStyle) {
        this._containerOuterStyle = _objectSpread$2({
          height,
          overflow: "visible",
          // Let :focus outline show through
          width
        }, style2);
      }
      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: "relative",
          width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: "visible",
          // Let :focus outline show through
          position: "relative",
          width
        };
      }
      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = _objectSpread$2({
          left: 0,
          overflowX: "hidden",
          overflowY: enableFixedColumnScroll ? "auto" : "hidden",
          position: "absolute"
        }, styleBottomLeftGrid);
      }
      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = _objectSpread$2({
          left: this._getLeftGridWidth(this.props),
          position: "absolute"
        }, styleBottomRightGrid);
      }
      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = _objectSpread$2({
          left: 0,
          overflowX: "hidden",
          overflowY: "hidden",
          position: "absolute",
          top: 0
        }, styleTopLeftGrid);
      }
      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = _objectSpread$2({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? "auto" : "hidden",
          overflowY: "hidden",
          position: "absolute",
          top: 0
        }, styleTopRightGrid);
      }
      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style2;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }
      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }
      this._maybeCalculateCachedStyles();
      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;
      if (!fixedColumnCount) {
        return null;
      }
      var additionalRowCount = showVerticalScrollbar ? 1 : 0, height = this._getBottomGridHeight(props), width = this._getLeftGridWidth(props), scrollbarSize2 = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize2 : width;
      var bottomLeftGrid = /* @__PURE__ */ React.createElement(Grid, _extends$7({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : void 0,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));
      if (hideBottomLeftGridScrollbar) {
        return /* @__PURE__ */ React.createElement("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: _objectSpread$2(_objectSpread$2({}, this._bottomLeftGridStyle), {}, {
            height,
            width,
            overflowY: "hidden"
          })
        }, bottomLeftGrid);
      }
      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, rowCount = props.rowCount, scrollToColumn = props.scrollToColumn, scrollToRow = props.scrollToRow;
      return /* @__PURE__ */ React.createElement(Grid, _extends$7({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount;
      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }
      return /* @__PURE__ */ React.createElement(Grid, _extends$7({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount, enableFixedRowScroll = props.enableFixedRowScroll, fixedColumnCount = props.fixedColumnCount, fixedRowCount = props.fixedRowCount, scrollLeft = props.scrollLeft, hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state, showHorizontalScrollbar = _this$state5.showHorizontalScrollbar, scrollbarSize2 = _this$state5.scrollbarSize;
      if (!fixedRowCount) {
        return null;
      }
      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0, height = this._getTopGridHeight(props), width = this._getRightGridWidth(props), additionalHeight = showHorizontalScrollbar ? scrollbarSize2 : 0;
      var gridHeight = height, style2 = this._topRightGridStyle;
      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style2 = _objectSpread$2(_objectSpread$2({}, this._topRightGridStyle), {}, {
          left: 0
        });
      }
      var topRightGrid = /* @__PURE__ */ React.createElement(Grid, _extends$7({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : void 0,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft,
        style: style2,
        tabIndex: null,
        width
      }));
      if (hideTopRightGridScrollbar) {
        return /* @__PURE__ */ React.createElement("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: _objectSpread$2(_objectSpread$2({}, this._topRightGridStyle), {}, {
            height,
            width,
            overflowX: "hidden"
          })
        }, topRightGrid);
      }
      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }
      return null;
    }
  }]);
})(React.PureComponent);
_defineProperty$2(MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: "",
  classNameBottomRightGrid: "",
  classNameTopLeftGrid: "",
  classNameTopRightGrid: "",
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});
MultiGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};
polyfill(MultiGrid);
function _callSuper$3(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$3() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var ScrollSync = /* @__PURE__ */ (function(_React$PureComponent) {
  function ScrollSync2(props, context2) {
    var _this;
    _classCallCheck$2(this, ScrollSync2);
    _this = _callSuper$3(this, ScrollSync2, [props, context2]);
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }
  _inherits$2(ScrollSync2, _React$PureComponent);
  return _createClass$2(ScrollSync2, [{
    key: "render",
    value: function render2() {
      var children2 = this.props.children;
      var _this$state = this.state, clientHeight = _this$state.clientHeight, clientWidth = _this$state.clientWidth, scrollHeight = _this$state.scrollHeight, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop, scrollWidth = _this$state.scrollWidth;
      return children2({
        clientHeight,
        clientWidth,
        onScroll: this._onScroll,
        scrollHeight,
        scrollLeft,
        scrollTop,
        scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight, clientWidth = _ref.clientWidth, scrollHeight = _ref.scrollHeight, scrollLeft = _ref.scrollLeft, scrollTop = _ref.scrollTop, scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight,
        clientWidth,
        scrollHeight,
        scrollLeft,
        scrollTop,
        scrollWidth
      });
    }
  }]);
})(React.PureComponent);
ScrollSync.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey, rowData = _ref.rowData;
  if (typeof rowData.get === "function") {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;
  if (cellData == null) {
    return "";
  } else {
    return String(cellData);
  }
}
function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className, columns = _ref.columns, style2 = _ref.style;
  return /* @__PURE__ */ React.createElement("div", {
    className,
    role: "row",
    style: style2
  }, columns);
}
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: "ASC",
  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: "DESC"
};
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames2 = clsx("ReactVirtualized__Table__sortableHeaderIcon", {
    "ReactVirtualized__Table__sortableHeaderIcon--ASC": sortDirection === SortDirection.ASC,
    "ReactVirtualized__Table__sortableHeaderIcon--DESC": sortDirection === SortDirection.DESC
  });
  return /* @__PURE__ */ React.createElement("svg", {
    className: classNames2,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === SortDirection.ASC ? /* @__PURE__ */ React.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : /* @__PURE__ */ React.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey, label = _ref.label, sortBy = _ref.sortBy, sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children2 = [/* @__PURE__ */ React.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === "string" ? label : null
  }, label)];
  if (showSortIndicator) {
    children2.push(/* @__PURE__ */ React.createElement(SortIndicator, {
      key: "SortIndicator",
      sortDirection
    }));
  }
  return children2;
}
function defaultRowRenderer(_ref) {
  var className = _ref.className, columns = _ref.columns, index2 = _ref.index, key = _ref.key, onRowClick = _ref.onRowClick, onRowDoubleClick = _ref.onRowDoubleClick, onRowMouseOut = _ref.onRowMouseOut, onRowMouseOver = _ref.onRowMouseOver, onRowRightClick = _ref.onRowRightClick, rowData = _ref.rowData, style2 = _ref.style;
  var a11yProps = {
    "aria-rowindex": index2 + 1
  };
  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps["aria-label"] = "row";
    a11yProps.tabIndex = 0;
    if (onRowClick) {
      a11yProps.onClick = function(event) {
        return onRowClick({
          event,
          index: index2,
          rowData
        });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function(event) {
        return onRowDoubleClick({
          event,
          index: index2,
          rowData
        });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function(event) {
        return onRowMouseOut({
          event,
          index: index2,
          rowData
        });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function(event) {
        return onRowMouseOver({
          event,
          index: index2,
          rowData
        });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function(event) {
        return onRowRightClick({
          event,
          index: index2,
          rowData
        });
      };
    }
  }
  return /* @__PURE__ */ React.createElement("div", _extends$7({}, a11yProps, {
    className,
    key,
    role: "row",
    style: style2
  }), columns);
}
function _callSuper$2(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var Column = /* @__PURE__ */ (function(_React$Component) {
  function Column2() {
    _classCallCheck$2(this, Column2);
    return _callSuper$2(this, Column2, arguments);
  }
  _inherits$2(Column2, _React$Component);
  return _createClass$2(Column2);
})(React.Component);
_defineProperty$2(Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});
Column.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Optional aria-label value to set on the column header */
  "aria-label": PropTypes.string,
  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,
  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,
  /** Optional CSS class to apply to cell */
  className: PropTypes.string,
  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,
  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,
  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,
  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,
  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,
  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,
  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,
  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,
  /** Optional id to set on the column header */
  id: PropTypes.string,
  /** Header label for this column */
  label: PropTypes.node,
  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,
  /** Minimum width of column. */
  minWidth: PropTypes.number,
  /** Optional inline style to apply to cell */
  style: PropTypes.object,
  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};
function ownKeys$1(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper$1(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var Table$1 = /* @__PURE__ */ (function(_React$PureComponent) {
  function Table2(props) {
    var _this;
    _classCallCheck$2(this, Table2);
    _this = _callSuper$1(this, Table2, [props]);
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    _this._setGridElementRef = _this._setGridElementRef.bind(_this);
    return _this;
  }
  _inherits$2(Table2, _React$PureComponent);
  return _createClass$2(Table2, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment, index2 = _ref.index;
      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment,
          rowIndex: index2
        }), scrollTop = _this$Grid$getOffsetF.scrollTop;
        return scrollTop;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex;
      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex,
          columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$columnIndex = _ref3.columnIndex, columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex, _ref3$rowIndex = _ref3.rowIndex, rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex,
          columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index2
        });
      }
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index2
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.GridElement) {
        var _Grid = this.GridElement;
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }
      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render2() {
      var _this2 = this;
      var _this$props = this.props, children2 = _this$props.children, className = _this$props.className, disableHeader = _this$props.disableHeader, gridClassName = _this$props.gridClassName, gridStyle = _this$props.gridStyle, headerHeight = _this$props.headerHeight, headerRowRenderer = _this$props.headerRowRenderer, height = _this$props.height, id2 = _this$props.id, noRowsRenderer3 = _this$props.noRowsRenderer, rowClassName = _this$props.rowClassName, rowStyle = _this$props.rowStyle, scrollToIndex = _this$props.scrollToIndex, style2 = _this$props.style, width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === "function" ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === "function" ? rowStyle({
        index: -1
      }) : rowStyle;
      this._cachedColumnStyles = [];
      React.Children.toArray(children2).forEach(function(column2, index2) {
        var flexStyles = _this2._getFlexStyleForColumn(column2, column2.props.style || Column.defaultProps.style);
        _this2._cachedColumnStyles[index2] = _objectSpread$1({
          overflow: "hidden"
        }, flexStyles);
      });
      return /* @__PURE__ */ React.createElement("div", {
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-colcount": React.Children.toArray(children2).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx("ReactVirtualized__Table", className),
        id: id2,
        role: "grid",
        style: style2
      }, !disableHeader && headerRowRenderer({
        className: clsx("ReactVirtualized__Table__headerRow", rowClass),
        columns: this._getHeaderColumns(),
        style: _objectSpread$1({
          height: headerHeight,
          overflow: "hidden",
          paddingRight: scrollbarWidth,
          width
        }, rowStyleObject)
      }), /* @__PURE__ */ React.createElement(Grid, _extends$7({}, this.props, {
        elementRef: this._setGridElementRef,
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx("ReactVirtualized__Table__Grid", gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: void 0,
        noContentRenderer: noRowsRenderer3,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: _objectSpread$1(_objectSpread$1({}, gridStyle), {}, {
          overflowX: "hidden"
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column2 = _ref4.column, columnIndex = _ref4.columnIndex, isScrolling = _ref4.isScrolling, parent = _ref4.parent, rowData = _ref4.rowData, rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column2.props, cellDataGetter = _column$props.cellDataGetter, cellRenderer = _column$props.cellRenderer, className = _column$props.className, columnData = _column$props.columnData, dataKey = _column$props.dataKey, id2 = _column$props.id;
      var cellData = cellDataGetter({
        columnData,
        dataKey,
        rowData
      });
      var renderedCell = cellRenderer({
        cellData,
        columnData,
        columnIndex,
        dataKey,
        isScrolling,
        parent,
        rowData,
        rowIndex
      });
      var onClick2 = function onClick3(event) {
        onColumnClick && onColumnClick({
          columnData,
          dataKey,
          event
        });
      };
      var style2 = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === "string" ? renderedCell : null;
      return /* @__PURE__ */ React.createElement("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id2,
        className: clsx("ReactVirtualized__Table__rowColumn", className),
        key: "Row" + rowIndex + "-Col" + columnIndex,
        onClick: onClick2,
        role: "gridcell",
        style: style2,
        title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column2 = _ref5.column, index2 = _ref5.index;
      var _this$props2 = this.props, headerClassName = _this$props2.headerClassName, headerStyle = _this$props2.headerStyle, onHeaderClick = _this$props2.onHeaderClick, sort = _this$props2.sort, sortBy = _this$props2.sortBy, sortDirection = _this$props2.sortDirection;
      var _column$props2 = column2.props, columnData = _column$props2.columnData, dataKey = _column$props2.dataKey, defaultSortDirection = _column$props2.defaultSortDirection, disableSort = _column$props2.disableSort, headerRenderer = _column$props2.headerRenderer, id2 = _column$props2.id, label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames2 = clsx("ReactVirtualized__Table__headerColumn", headerClassName, column2.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style2 = this._getFlexStyleForColumn(column2, _objectSpread$1(_objectSpread$1({}, headerStyle), column2.props.headerStyle));
      var renderedHeader = headerRenderer({
        columnData,
        dataKey,
        disableSort,
        label,
        sortBy,
        sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;
      if (sortEnabled || onHeaderClick) {
        var isFirstTimeSort = sortBy !== dataKey;
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC;
        var onClick2 = function onClick3(event) {
          sortEnabled && sort({
            defaultSortDirection,
            event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData,
            dataKey,
            event
          });
        };
        var onKeyDown = function onKeyDown2(event) {
          if (event.key === "Enter" || event.key === " ") {
            onClick2(event);
          }
        };
        headerAriaLabel = column2.props["aria-label"] || label || dataKey;
        headerAriaSort = "none";
        headerTabIndex = 0;
        headerOnClick = onClick2;
        headerOnKeyDown = onKeyDown;
      }
      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === SortDirection.ASC ? "ascending" : "descending";
      }
      return /* @__PURE__ */ React.createElement("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames2,
        id: id2,
        key: "Header-Col" + index2,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style2,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;
      var index2 = _ref6.rowIndex, isScrolling = _ref6.isScrolling, key = _ref6.key, parent = _ref6.parent, style2 = _ref6.style;
      var _this$props3 = this.props, children2 = _this$props3.children, onRowClick = _this$props3.onRowClick, onRowDoubleClick = _this$props3.onRowDoubleClick, onRowRightClick = _this$props3.onRowRightClick, onRowMouseOver = _this$props3.onRowMouseOver, onRowMouseOut = _this$props3.onRowMouseOut, rowClassName = _this$props3.rowClassName, rowGetter = _this$props3.rowGetter, rowRenderer = _this$props3.rowRenderer, rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === "function" ? rowClassName({
        index: index2
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === "function" ? rowStyle({
        index: index2
      }) : rowStyle;
      var rowData = rowGetter({
        index: index2
      });
      var columns = React.Children.toArray(children2).map(function(column2, columnIndex) {
        return _this3._createColumn({
          column: column2,
          columnIndex,
          isScrolling,
          parent,
          rowData,
          rowIndex: index2,
          scrollbarWidth
        });
      });
      var className = clsx("ReactVirtualized__Table__row", rowClass);
      var flattenedStyle = _objectSpread$1(_objectSpread$1({}, style2), {}, {
        height: this._getRowHeight(index2),
        overflow: "hidden",
        paddingRight: scrollbarWidth
      }, rowStyleObject);
      return rowRenderer({
        className,
        columns,
        index: index2,
        isScrolling,
        key,
        onRowClick,
        onRowDoubleClick,
        onRowRightClick,
        onRowMouseOver,
        onRowMouseOut,
        rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */
  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column2) {
      var customStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var flexValue = "".concat(column2.props.flexGrow, " ").concat(column2.props.flexShrink, " ").concat(column2.props.width, "px");
      var style2 = _objectSpread$1(_objectSpread$1({}, customStyle), {}, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });
      if (column2.props.maxWidth) {
        style2.maxWidth = column2.props.maxWidth;
      }
      if (column2.props.minWidth) {
        style2.minWidth = column2.props.minWidth;
      }
      return style2;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;
      var _this$props4 = this.props, children2 = _this$props4.children, disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : React.Children.toArray(children2);
      return items.map(function(column2, index2) {
        return _this4._createHeader({
          column: column2,
          index: index2
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === "function" ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight, scrollHeight = _ref7.scrollHeight, scrollTop = _ref7.scrollTop;
      var onScroll6 = this.props.onScroll;
      onScroll6({
        clientHeight,
        scrollHeight,
        scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex, rowOverscanStopIndex = _ref8.rowOverscanStopIndex, rowStartIndex = _ref8.rowStartIndex, rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered3 = this.props.onRowsRendered;
      onRowsRendered3({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref2) {
      this.Grid = ref2;
    }
  }, {
    key: "_setGridElementRef",
    value: function _setGridElementRef(ref2) {
      this.GridElement = ref2;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth
      });
    }
  }]);
})(React.PureComponent);
_defineProperty$2(Table$1, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer2() {
    return null;
  },
  onRowsRendered: function onRowsRendered2() {
    return null;
  },
  onScroll: function onScroll4() {
    return null;
  },
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
Table$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is just set on the grid top element. */
  "aria-label": PropTypes.string,
  /** This is just set on the grid top element. */
  "aria-labelledby": PropTypes.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,
  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children2 = React.Children.toArray(props.children);
    for (var i = 0; i < children2.length; i++) {
      var childType = children2[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error("Table only accepts children of type Column");
      }
    }
  },
  /** Optional CSS class name */
  className: PropTypes.string,
  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,
  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,
  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,
  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,
  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,
  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,
  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,
  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,
  /** Optional id */
  id: PropTypes.string,
  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,
  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,
  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,
  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,
  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,
  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,
  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,
  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,
  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,
  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,
  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,
  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,
  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,
  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(["auto", "end", "start", "center"]).isRequired,
  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,
  /** Vertical offset. */
  scrollTop: PropTypes.number,
  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,
  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,
  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
  /** Optional inline style */
  style: PropTypes.object,
  /** Tab index for focus */
  tabIndex: PropTypes.number,
  /** Width of list */
  width: PropTypes.number.isRequired
} : {};
var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;
function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;
    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }
    originalBodyPointerEvents = null;
  }
}
function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function(instance) {
    return instance.__resetIsScrolling();
  });
}
function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }
  var maximumTimeout = 0;
  mountedInstances.forEach(function(instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}
function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = "none";
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function(instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}
function registerScrollListener(component, element) {
  if (!mountedInstances.some(function(instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener("scroll", onScrollWindow);
  }
  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function(instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener("scroll", onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}
var isWindow = function isWindow2(element) {
  return element === window;
};
var getBoundingBox = function getBoundingBox2(element) {
  return element.getBoundingClientRect();
};
function getDimensions$1(scrollElement3, props) {
  if (!scrollElement3) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement3)) {
    var _window = window, innerHeight = _window.innerHeight, innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === "number" ? innerHeight : 0,
      width: typeof innerWidth === "number" ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement3);
  }
}
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: "scrollY" in window ? window.scrollY : document.documentElement.scrollTop,
      left: "scrollX" in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
function ownKeys(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
var IS_SCROLLING_TIMEOUT = 150;
var getWindow = function getWindow2() {
  return typeof window !== "undefined" ? window : void 0;
};
var WindowScroller = /* @__PURE__ */ (function(_React$PureComponent) {
  function WindowScroller2() {
    var _this;
    _classCallCheck$2(this, WindowScroller2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WindowScroller2, [].concat(args));
    _defineProperty$2(_this, "_window", getWindow());
    _defineProperty$2(_this, "_isMounted", false);
    _defineProperty$2(_this, "_positionFromTop", 0);
    _defineProperty$2(_this, "_positionFromLeft", 0);
    _defineProperty$2(_this, "_detectElementResize", void 0);
    _defineProperty$2(_this, "_child", void 0);
    _defineProperty$2(_this, "_windowScrollerRef", /* @__PURE__ */ React.createRef());
    _defineProperty$2(_this, "state", _objectSpread(_objectSpread({}, getDimensions$1(_this.props.scrollElement, _this.props)), {}, {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));
    _defineProperty$2(_this, "_registerChild", function(element) {
      if (element && !(element instanceof Element)) {
        console.warn("WindowScroller registerChild expects to be passed Element or null");
      }
      _this._child = element;
      _this.updatePosition();
    });
    _defineProperty$2(_this, "_onChildScroll", function(_ref) {
      var scrollTop = _ref.scrollTop;
      if (_this.state.scrollTop === scrollTop) {
        return;
      }
      var scrollElement3 = _this.props.scrollElement;
      if (scrollElement3) {
        if (typeof scrollElement3.scrollTo === "function") {
          scrollElement3.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement3.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });
    _defineProperty$2(_this, "_registerResizeListener", function(element) {
      if (element === window) {
        window.addEventListener("resize", _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });
    _defineProperty$2(_this, "_unregisterResizeListener", function(element) {
      if (element === window) {
        window.removeEventListener("resize", _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });
    _defineProperty$2(_this, "_onResize", function() {
      _this.updatePosition();
    });
    _defineProperty$2(_this, "__handleWindowScrollEvent", function() {
      if (!_this._isMounted) {
        return;
      }
      var onScroll6 = _this.props.onScroll;
      var scrollElement3 = _this.props.scrollElement;
      if (scrollElement3) {
        var scrollOffset = getScrollOffset(scrollElement3);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
        _this.setState({
          isScrolling: true,
          scrollLeft,
          scrollTop
        });
        onScroll6({
          scrollLeft,
          scrollTop
        });
      }
    });
    _defineProperty$2(_this, "__resetIsScrolling", function() {
      _this.setState({
        isScrolling: false
      });
    });
    return _this;
  }
  _inherits$2(WindowScroller2, _React$PureComponent);
  return _createClass$2(WindowScroller2, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.scrollElement;
      var onResize4 = this.props.onResize;
      var _this$state = this.state, height = _this$state.height, width = _this$state.width;
      var thisNode = this._child || this._windowScrollerRef.current;
      if (thisNode instanceof Element && scrollElement3) {
        var offset = getPositionOffset(thisNode, scrollElement3);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }
      var dimensions = getDimensions$1(scrollElement3, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize4({
          height: dimensions.height,
          width: dimensions.width
        });
      }
      if (this.props.updateScrollTopOnUpdatePosition === true) {
        this.__handleWindowScrollEvent();
        this.__resetIsScrolling();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement3 = this.props.scrollElement;
      this._detectElementResize = createDetectElementResize();
      this.updatePosition(scrollElement3);
      if (scrollElement3) {
        registerScrollListener(this, scrollElement3);
        this._registerResizeListener(scrollElement3);
      }
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement3 = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;
      if (prevScrollElement !== scrollElement3 && prevScrollElement != null && scrollElement3 != null) {
        this.updatePosition(scrollElement3);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement3);
        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement3);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement3 = this.props.scrollElement;
      if (scrollElement3) {
        unregisterScrollListener(this, scrollElement3);
        this._unregisterResizeListener(scrollElement3);
      }
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render2() {
      var children2 = this.props.children;
      var _this$state2 = this.state, isScrolling = _this$state2.isScrolling, scrollTop = _this$state2.scrollTop, scrollLeft = _this$state2.scrollLeft, height = _this$state2.height, width = _this$state2.width;
      return /* @__PURE__ */ React.createElement("div", {
        ref: this._windowScrollerRef
      }, children2({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height,
        isScrolling,
        scrollLeft,
        scrollTop,
        width
      }));
    }
  }]);
})(React.PureComponent);
_defineProperty$2(WindowScroller, "defaultProps", {
  onResize: function onResize3() {
  },
  onScroll: function onScroll5() {
  },
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});
function InfinityVirtualList({
  store: store2,
  rowHeight,
  defaultRowHeight,
  rowRenderer,
  fetchDebounce,
  minimumBatchSize,
  threshold,
  overscanRowCount,
  initialLoader,
  autoFetch,
  defaultScrollToIndex,
  scrollToAlignment,
  handlerRef,
  noRowsRenderer: noRowsRenderer3,
  errorRenderer,
  onRowsRendered: onRowsRenderedCallback,
  onScroll: onScroll6,
  autosizeClassname
}) {
  const isDynamicHeight = useMemo$2(() => rowHeight === void 0, [rowHeight]);
  const cellMeasurerCache = useRef(new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: defaultRowHeight,
    minHeight: defaultRowHeight
  }));
  const batchSize = useMemo$2(() => minimumBatchSize ?? 25, [minimumBatchSize]);
  const infinityLoaderRef = useRef(null);
  const listRef = useRef(null);
  const prescrollToIndexRef = useRef(defaultScrollToIndex);
  const scrollToIndexRef = useRef(void 0);
  useEffect(() => {
    if (!store2.isInited && autoFetch === true && !store2.hasError)
      store2.fetch({ startIndex: 0, stopIndex: batchSize - 1 });
  }, [store2.isInited, autoFetch, store2.hasError]);
  useEffect(() => {
    if (handlerRef)
      handlerRef.current = {
        insertItem: (item2, index2) => {
          store2.insertItem(item2, index2);
        },
        swapItems: (index2, newIndex) => {
          store2.swapItems(index2, newIndex);
        },
        moveItem: (index2, newIndex) => {
          const item2 = store2.getItem(index2);
          store2.deleteItem(index2);
          store2.insertItem(item2, newIndex);
        },
        updateItem: (item2, index2) => {
          store2.updateItem(item2, index2);
        },
        recalcItem: (index2) => {
          cellMeasurerCache?.current?.clear(index2, 0);
        },
        deleteItem: (index2) => {
          store2.deleteItem(index2);
        },
        scrollTo: (index2) => {
          prescrollToIndexRef.current = void 0;
          infinityLoaderRef.current?.forceUpdate();
          setTimeout(() => {
            prescrollToIndexRef.current = index2;
            infinityLoaderRef.current?.forceUpdate();
            if (store2.isRowLoaded(index2)) {
              setTimeout(() => {
                prescrollToIndexRef.current = void 0;
                infinityLoaderRef.current?.forceUpdate();
              }, 300);
            }
          }, 0);
        },
        update: (resetMeasurerCache = false) => {
          if (resetMeasurerCache)
            cellMeasurerCache?.current?.clearAll();
          infinityLoaderRef.current?.forceUpdate();
        },
        reset: () => {
          store2.forceReset();
        }
      };
  }, [handlerRef, cellMeasurerCache, store2]);
  const loadMoreRows = useCallback(lodashExports.debounce(async (startIndex, stopIndex) => {
    await store2.fetch({ startIndex, stopIndex });
    if (prescrollToIndexRef.current) {
      scrollToIndexRef.current = prescrollToIndexRef.current;
      prescrollToIndexRef.current = void 0;
    }
    infinityLoaderRef.current?.forceUpdate();
  }, fetchDebounce?.milliseconds ?? 300), []);
  const scrollToIndex = useCallback((index2) => {
    setTimeout(() => {
      listRef.current?.scrollToRow(index2);
      scrollToIndexRef.current = void 0;
    }, 0);
  }, []);
  if (store2.hasError && errorRenderer)
    return /* @__PURE__ */ jsx$1(Fragment, { children: errorRenderer() });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      InfiniteLoader,
      {
        ref: infinityLoaderRef,
        isRowLoaded: (x) => store2.isRowLoaded(x.index),
        loadMoreRows: (x) => loadMoreRows(x.startIndex, x.stopIndex),
        threshold,
        rowCount: store2.totalCount,
        minimumBatchSize: batchSize,
        children: ({ onRowsRendered: onRowsRendered3, registerChild }) => /* @__PURE__ */ jsx$1(AutoSizer, { className: autosizeClassname, children: ({ width, height }) => /* @__PURE__ */ jsx$1(
          List,
          {
            rowCount: store2.totalCount,
            width,
            estimatedRowSize: defaultRowHeight,
            height,
            onScroll: (x) => {
              onScroll6?.({
                ...x,
                offsetHeight: x?.clientHeight ? x?.scrollHeight - x?.clientHeight - x?.scrollTop : 0
              });
            },
            scrollToAlignment,
            scrollToIndex: prescrollToIndexRef.current,
            rowHeight: isDynamicHeight ? cellMeasurerCache.current.rowHeight : rowHeight,
            rowRenderer: (x) => {
              const item2 = store2.isRowLoaded(x.index) ? store2.items[x.index] : void 0;
              return /* @__PURE__ */ jsx$1(
                CellMeasurer,
                {
                  cache: cellMeasurerCache.current,
                  parent: x.parent,
                  columnIndex: 0,
                  rowIndex: x.index,
                  children: ({ measure }) => /* @__PURE__ */ jsx$1("div", { style: x.style, children: rowRenderer({ ...x, item: item2, onRendered: measure }) }, x.key)
                },
                x.key
              );
            },
            deferredMeasurementCache: cellMeasurerCache.current,
            overscanRowCount,
            noRowsRenderer: noRowsRenderer3,
            onRowsRendered: (x) => {
              store2.setViewport({ startIndex: x.overscanStartIndex, stopIndex: x.overscanStopIndex });
              onRowsRendered3(x);
              onRowsRenderedCallback?.(x);
            },
            style: { outline: "none" },
            ref: (el) => {
              listRef.current = el;
              if (scrollToIndexRef.current)
                scrollToIndex(scrollToIndexRef.current);
              return registerChild(el);
            }
          }
        ) })
      }
    ),
    initialLoader && !store2.isInited && /* @__PURE__ */ jsx$1(Fragment, { children: initialLoader })
  ] });
}
const InfinityVirtualList$1 = observer(InfinityVirtualList);
function useUniqueKey(defaultKey) {
  const [key, setKey] = useState$1(KeyGenerator.generate(5));
  const update2 = useCallback(() => {
    setKey(KeyGenerator.generate(5));
  }, []);
  return {
    key,
    update: update2
  };
}
function useRefCallback(node2) {
  const [mounted, setMounted] = useState$1(node2 ? true : false);
  const ref2 = useRef(node2 ?? null);
  const setRef = useCallback((node22) => {
    if (ref2.current) ;
    ref2.current = node22;
    setMounted(true);
  }, []);
  return [setRef, ref2, mounted];
}
function getDimensions(el) {
  if (el) {
    return {
      width: el.clientWidth,
      height: el.clientHeight
    };
  } else {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
}
function useDimensions(props = {}, deps = []) {
  const [setSourceRef, sourceRef, mounted] = useRefCallback(props.srcEl);
  const [dimensions, _setDimensions] = useState$1(getDimensions(sourceRef.current));
  const setDimensions = useCallback((dim) => {
    _setDimensions(dim);
    props.onChange?.(dim);
  }, [props]);
  useEffect(() => {
    const setDimensionsFn = () => {
      setDimensions(getDimensions(sourceRef.current));
    };
    const handleResize = props.throttleDelay ? lodashExports.throttle(setDimensionsFn, props.throttleDelay.milliseconds) : setDimensionsFn;
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (mounted) {
      setDimensions(getDimensions(sourceRef.current));
    }
  }, [mounted, ...deps]);
  return [dimensions, setSourceRef, {
    recalc: () => setDimensions(getDimensions(sourceRef.current))
  }];
}
function useDrawer$1(defaultState) {
  const [state, setState] = useState$1({ visible: false });
  return {
    get visible() {
      return state.visible;
    },
    get data() {
      return state.data;
    },
    close: () => {
      setState({ visible: false });
    },
    open: (data2) => {
      setState({ visible: true, data: data2 ?? state.data });
    },
    set: (changes) => {
      const newState = { ...state, ...changes };
      setState(newState);
    }
  };
}
class NumberConverter {
  static format(value, delimeter, precision = 2, truncateIfZero = true) {
    const delimeterSymbol = NumberConverter.getDelimeterSymbol(delimeter);
    const fixed = value.toFixedValue(precision, truncateIfZero);
    const parts = fixed.split(".");
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delimeterSymbol);
    if (parts.length == 1) return intPart;
    return `${intPart}.${parts[1]}`;
  }
  static locFormat(value, lang, precision = 2, truncateIfZero = true) {
    const delimeter = NumberConverter.getDelimeterByLang(lang);
    return NumberConverter.format(value, delimeter, precision, truncateIfZero);
  }
  static getDelimeterSymbol(delimeter) {
    switch (delimeter) {
      case "comma":
        return ",";
      case "dot":
        return ".";
      case "space":
        return " ";
      default:
        return "";
    }
  }
  static getDelimeterByLang(lang) {
    switch (lang) {
      case Lang.en:
      case Lang.id:
        return "comma";
      default:
        return "space";
    }
  }
}
const NumberFormat = (props) => {
  if (props.truncateIfFractionalZero === void 0) {
    props.truncateIfFractionalZero = false;
  }
  const { lang } = useContext(Context$3);
  const number4 = useMemo$2(
    () => props.delimeter ? NumberConverter.format(props.number ?? 0, props.delimeter, props.precision, false) : NumberConverter.locFormat(props.number ?? 0, lang, props.precision, false),
    [props.delimeter, props.number, props.precision]
  );
  const parts = useMemo$2(() => number4.split("."), [number4]);
  const intPart = useMemo$2(() => {
    if (props.compact === true) {
      return Humanize.compactInteger(props.number, props.precision);
    }
    return parts[0];
  }, [parts, props.compact, props.precision]);
  const fractPart = useMemo$2(() => {
    const fract = parts.length == 1 ? "0" : parts[1];
    if (props.truncateIfFractionalZero == true && parseInt(fract) == 0)
      return null;
    return fract;
  }, [parts, props.truncateIfFractionalZero]);
  return /* @__PURE__ */ jsxs("span", { className: props.className, children: [
    intPart,
    fractPart != null && /* @__PURE__ */ jsxs("span", { className: props.fractionalClassname, children: [
      ".",
      fractPart
    ] }),
    props.suffix
  ] });
};
class ErrorBoundary extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false,
      error: void 0,
      errorInfo: void 0,
      callStackVisible: false
    };
  }
  static getDerivedStateFromError(error2, errorInfo) {
    return { hasError: true, error: error2, errorInfo, callStackVisible: false };
  }
  componentDidCatch(error2, errorInfo) {
    console.error("Uncaught error:", error2, errorInfo);
    this.props.onError?.(error2, errorInfo);
    if (isDev)
      notification.error({
        message: error2.toString(),
        duration: 0,
        description: /* @__PURE__ */ jsxs(Fragment, { children: [
          error2.stack?.split("\n")?.[1],
          /* @__PURE__ */ jsx$1("div", { children: /* @__PURE__ */ jsx$1(Button, { type: "link", className: "p-0", onClick: () => this.setState({ ...this.state, callStackVisible: true }), children: "Show call stack" }) })
        ] }),
        placement: "bottomLeft"
      });
  }
  render() {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      this.state.hasError ? this.props.fallback !== void 0 ? this.props.fallback : /* @__PURE__ */ jsx$1("div", { children: "Something went wrong" }) : this.props.children,
      this.state.callStackVisible && /* @__PURE__ */ jsxs(
        Modal,
        {
          open: true,
          onCancel: () => this.setState({ ...this.state, callStackVisible: false }),
          width: 1e3,
          title: this.state.error?.toString(),
          footer: null,
          children: [
            /* @__PURE__ */ jsx$1("pre", { children: this.state.error?.stack?.toString() }),
            /* @__PURE__ */ jsx$1("footer", { children: /* @__PURE__ */ jsx$1(Button, { onClick: () => this.setState({ ...this.state, callStackVisible: false }), children: "Close" }) })
          ]
        }
      )
    ] });
  }
}
function useDetectFirstRender(delay) {
  const [firstRender, setFirstRender] = useState$1(true);
  useEffect(() => {
    let timer;
    setFirstRender(false);
    return () => clearTimeout(timer);
  }, []);
  return firstRender;
}
function useUpdateEffect(effect, deps) {
  const isFirst = useDetectFirstRender();
  useEffect(() => {
    if (!isFirst)
      return effect();
  }, deps);
}
const HelpText = ({ className = "fs-12", icon: icon2 = /* @__PURE__ */ jsx$1(InfoCircleOutlined, {}), label, iconClassName = "color-primary", tooltip, tooltipProps }) => {
  if (tooltip === true)
    return /* @__PURE__ */ jsx$1(Tooltip, { title: label, ...tooltipProps, children: /* @__PURE__ */ jsx$1("span", { className, children: /* @__PURE__ */ jsx$1("span", { className: iconClassName, children: icon2 }) }) });
  return /* @__PURE__ */ jsxs("span", { className, children: [
    icon2 && /* @__PURE__ */ jsxs("span", { className: iconClassName, children: [
      icon2,
      " "
    ] }),
    label
  ] });
};
function getDefaults() {
  return {
    async: false,
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartLists: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}
let defaults = getDefaults();
function changeDefaults(newDefaults) {
  defaults = newDefaults;
}
const escapeTest = /[&<>"']/;
const escapeReplace = /[&<>"']/g;
const escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
const escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
const escapeReplacements = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape$1(html, encode) {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }
  return html;
}
const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function unescape$1(html) {
  return html.replace(unescapeTest, (_2, n) => {
    n = n.toLowerCase();
    if (n === "colon") return ":";
    if (n.charAt(0) === "#") {
      return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
    }
    return "";
  });
}
const caret = /(^|[^\[])\^/g;
function edit(regex2, opt) {
  regex2 = typeof regex2 === "string" ? regex2 : regex2.source;
  opt = opt || "";
  const obj = {
    replace: (name, val) => {
      val = val.source || val;
      val = val.replace(caret, "$1");
      regex2 = regex2.replace(name, val);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex2, opt);
    }
  };
  return obj;
}
const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function cleanUrl(sanitize2, base, href) {
  if (sanitize2) {
    let prot;
    try {
      prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, "").toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, "%");
  } catch (e) {
    return null;
  }
  return href;
}
const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function resolveUrl(base, href) {
  if (!baseUrls[" " + base]) {
    if (justDomain.test(base)) {
      baseUrls[" " + base] = base + "/";
    } else {
      baseUrls[" " + base] = rtrim(base, "/", true);
    }
  }
  base = baseUrls[" " + base];
  const relativeBase = base.indexOf(":") === -1;
  if (href.substring(0, 2) === "//") {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, "$1") + href;
  } else if (href.charAt(0) === "/") {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, "$1") + href;
  } else {
    return base + href;
  }
}
const noopTest = { exec: function noopTest2() {
} };
function merge(obj) {
  let i = 1, target, key;
  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }
  return obj;
}
function splitCells(tableRow, count) {
  const row = tableRow.replace(/\|/g, (match2, offset, str) => {
    let escaped = false, curr = offset;
    while (--curr >= 0 && str[curr] === "\\") escaped = !escaped;
    if (escaped) {
      return "|";
    } else {
      return " |";
    }
  }), cells = row.split(/ \|/);
  let i = 0;
  if (!cells[0].trim()) {
    cells.shift();
  }
  if (cells.length > 0 && !cells[cells.length - 1].trim()) {
    cells.pop();
  }
  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push("");
  }
  for (; i < cells.length; i++) {
    cells[i] = cells[i].trim().replace(/\\\|/g, "|");
  }
  return cells;
}
function rtrim(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return "";
  }
  let suffLen = 0;
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }
  return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  const l = str.length;
  let level = 0, i = 0;
  for (; i < l; i++) {
    if (str[i] === "\\") {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}
function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
  }
}
function repeatString(pattern4, count) {
  if (count < 1) {
    return "";
  }
  let result = "";
  while (count > 1) {
    if (count & 1) {
      result += pattern4;
    }
    count >>= 1;
    pattern4 += pattern4;
  }
  return result + pattern4;
}
function outputLink(cap, link, raw, lexer) {
  const href = link.href;
  const title = link.title ? escape$1(link.title) : null;
  const text2 = cap[1].replace(/\\([\[\]])/g, "$1");
  if (cap[0].charAt(0) !== "!") {
    lexer.state.inLink = true;
    const token2 = {
      type: "link",
      raw,
      href,
      title,
      text: text2,
      tokens: lexer.inlineTokens(text2)
    };
    lexer.state.inLink = false;
    return token2;
  }
  return {
    type: "image",
    raw,
    href,
    title,
    text: escape$1(text2)
  };
}
function indentCodeCompensation(raw, text2) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
  if (matchIndentToCode === null) {
    return text2;
  }
  const indentToCode = matchIndentToCode[1];
  return text2.split("\n").map((node2) => {
    const matchIndentInNode = node2.match(/^\s+/);
    if (matchIndentInNode === null) {
      return node2;
    }
    const [indentInNode] = matchIndentInNode;
    if (indentInNode.length >= indentToCode.length) {
      return node2.slice(indentToCode.length);
    }
    return node2;
  }).join("\n");
}
class Tokenizer {
  constructor(options) {
    this.options = options || defaults;
  }
  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap && cap[0].length > 0) {
      return {
        type: "space",
        raw: cap[0]
      };
    }
  }
  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text2 = cap[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: cap[0],
        codeBlockStyle: "indented",
        text: !this.options.pedantic ? rtrim(text2, "\n") : text2
      };
    }
  }
  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text2 = indentCodeCompensation(raw, cap[3] || "");
      return {
        type: "code",
        raw,
        lang: cap[2] ? cap[2].trim() : cap[2],
        text: text2
      };
    }
  }
  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text2 = cap[2].trim();
      if (/#$/.test(text2)) {
        const trimmed = rtrim(text2, "#");
        if (this.options.pedantic) {
          text2 = trimmed.trim();
        } else if (!trimmed || / $/.test(trimmed)) {
          text2 = trimmed.trim();
        }
      }
      return {
        type: "heading",
        raw: cap[0],
        depth: cap[1].length,
        text: text2,
        tokens: this.lexer.inline(text2)
      };
    }
  }
  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: "hr",
        raw: cap[0]
      };
    }
  }
  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      const text2 = cap[0].replace(/^ *>[ \t]?/gm, "");
      return {
        type: "blockquote",
        raw: cap[0],
        tokens: this.lexer.blockTokens(text2, []),
        text: text2
      };
    }
  }
  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line2, nextLine, rawLine, itemContents, endEarly;
      let bull = cap[1].trim();
      const isordered = bull.length > 1;
      const list = {
        type: "list",
        raw: "",
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : "",
        loose: false,
        items: []
      };
      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
      if (this.options.pedantic) {
        bull = isordered ? bull : "[*+-]";
      }
      const itemRegex = new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      while (src) {
        endEarly = false;
        if (!(cap = itemRegex.exec(src))) {
          break;
        }
        if (this.rules.block.hr.test(src)) {
          break;
        }
        raw = cap[0];
        src = src.substring(raw.length);
        line2 = cap[2].split("\n", 1)[0];
        nextLine = src.split("\n", 1)[0];
        if (this.options.pedantic) {
          indent = 2;
          itemContents = line2.trimLeft();
        } else {
          indent = cap[2].search(/[^ ]/);
          indent = indent > 4 ? 1 : indent;
          itemContents = line2.slice(indent);
          indent += cap[1].length;
        }
        blankLine = false;
        if (!line2 && /^ *$/.test(nextLine)) {
          raw += nextLine + "\n";
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }
        if (!endEarly) {
          const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))`);
          const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
          const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
          const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
          while (src) {
            rawLine = src.split("\n", 1)[0];
            line2 = rawLine;
            if (this.options.pedantic) {
              line2 = line2.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
            }
            if (fencesBeginRegex.test(line2)) {
              break;
            }
            if (headingBeginRegex.test(line2)) {
              break;
            }
            if (nextBulletRegex.test(line2)) {
              break;
            }
            if (hrRegex.test(src)) {
              break;
            }
            if (line2.search(/[^ ]/) >= indent || !line2.trim()) {
              itemContents += "\n" + line2.slice(indent);
            } else if (!blankLine) {
              itemContents += "\n" + line2;
            } else {
              break;
            }
            if (!blankLine && !line2.trim()) {
              blankLine = true;
            }
            raw += rawLine + "\n";
            src = src.substring(rawLine.length + 1);
          }
        }
        if (!list.loose) {
          if (endsWithBlankLine) {
            list.loose = true;
          } else if (/\n *\n *$/.test(raw)) {
            endsWithBlankLine = true;
          }
        }
        if (this.options.gfm) {
          istask = /^\[[ xX]\] /.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== "[ ] ";
            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
          }
        }
        list.items.push({
          type: "list_item",
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents
        });
        list.raw += raw;
      }
      list.items[list.items.length - 1].raw = raw.trimRight();
      list.items[list.items.length - 1].text = itemContents.trimRight();
      list.raw = list.raw.trimRight();
      const l = list.items.length;
      for (i = 0; i < l; i++) {
        this.lexer.state.top = false;
        list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
        const spacers = list.items[i].tokens.filter((t) => t.type === "space");
        const hasMultipleLineBreaks = spacers.every((t) => {
          const chars = t.raw.split("");
          let lineBreaks = 0;
          for (const char2 of chars) {
            if (char2 === "\n") {
              lineBreaks += 1;
            }
            if (lineBreaks > 1) {
              return true;
            }
          }
          return false;
        });
        if (!list.loose && spacers.length && hasMultipleLineBreaks) {
          list.loose = true;
          list.items[i].loose = true;
        }
      }
      return list;
    }
  }
  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token2 = {
        type: "html",
        raw: cap[0],
        pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
        text: cap[0]
      };
      if (this.options.sanitize) {
        const text2 = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]);
        token2.type = "paragraph";
        token2.text = text2;
        token2.tokens = this.lexer.inline(text2);
      }
      return token2;
    }
  }
  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
      const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
      return {
        type: "def",
        tag,
        raw: cap[0],
        href: cap[2],
        title: cap[3]
      };
    }
  }
  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (cap) {
      const item2 = {
        type: "table",
        header: splitCells(cap[1]).map((c) => {
          return { text: c };
        }),
        align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
      };
      if (item2.header.length === item2.align.length) {
        item2.raw = cap[0];
        let l = item2.align.length;
        let i, j, k, row;
        for (i = 0; i < l; i++) {
          if (/^ *-+: *$/.test(item2.align[i])) {
            item2.align[i] = "right";
          } else if (/^ *:-+: *$/.test(item2.align[i])) {
            item2.align[i] = "center";
          } else if (/^ *:-+ *$/.test(item2.align[i])) {
            item2.align[i] = "left";
          } else {
            item2.align[i] = null;
          }
        }
        l = item2.rows.length;
        for (i = 0; i < l; i++) {
          item2.rows[i] = splitCells(item2.rows[i], item2.header.length).map((c) => {
            return { text: c };
          });
        }
        l = item2.header.length;
        for (j = 0; j < l; j++) {
          item2.header[j].tokens = this.lexer.inline(item2.header[j].text);
        }
        l = item2.rows.length;
        for (j = 0; j < l; j++) {
          row = item2.rows[j];
          for (k = 0; k < row.length; k++) {
            row[k].tokens = this.lexer.inline(row[k].text);
          }
        }
        return item2;
      }
    }
  }
  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      return {
        type: "heading",
        raw: cap[0],
        depth: cap[2].charAt(0) === "=" ? 1 : 2,
        text: cap[1],
        tokens: this.lexer.inline(cap[1])
      };
    }
  }
  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const text2 = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
      return {
        type: "paragraph",
        raw: cap[0],
        text: text2,
        tokens: this.lexer.inline(text2)
      };
    }
  }
  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      return {
        type: "text",
        raw: cap[0],
        text: cap[0],
        tokens: this.lexer.inline(cap[0])
      };
    }
  }
  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: "escape",
        raw: cap[0],
        text: escape$1(cap[1])
      };
    }
  }
  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }
      return {
        type: this.options.sanitize ? "text" : "html",
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]) : cap[0]
      };
    }
  }
  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && /^</.test(trimmedUrl)) {
        if (!/>$/.test(trimmedUrl)) {
          return;
        }
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        const lastParenIndex = findClosingBracket(cap[2], "()");
        if (lastParenIndex > -1) {
          const start2 = cap[0].indexOf("!") === 0 ? 5 : 4;
          const linkLen = start2 + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = "";
        }
      }
      let href = cap[2];
      let title = "";
      if (this.options.pedantic) {
        const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
        if (link) {
          href = link[1];
          title = link[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : "";
      }
      href = href.trim();
      if (/^</.test(href)) {
        if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
        title: title ? title.replace(this.rules.inline._escapes, "$1") : title
      }, cap[0], this.lexer);
    }
  }
  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
      let link = (cap[2] || cap[1]).replace(/\s+/g, " ");
      link = links[link.toLowerCase()];
      if (!link || !link.href) {
        const text2 = cap[0].charAt(0);
        return {
          type: "text",
          raw: text2,
          text: text2
        };
      }
      return outputLink(cap, link, cap[0], this.lexer);
    }
  }
  emStrong(src, maskedSrc, prevChar = "") {
    let match2 = this.rules.inline.emStrong.lDelim.exec(src);
    if (!match2) return;
    if (match2[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
    const nextChar = match2[1] || match2[2] || "";
    if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
      const lLength = match2[0].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
      const endReg = match2[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      endReg.lastIndex = 0;
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
      while ((match2 = endReg.exec(maskedSrc)) != null) {
        rDelim = match2[1] || match2[2] || match2[3] || match2[4] || match2[5] || match2[6];
        if (!rDelim) continue;
        rLength = rDelim.length;
        if (match2[3] || match2[4]) {
          delimTotal += rLength;
          continue;
        } else if (match2[5] || match2[6]) {
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue;
          }
        }
        delimTotal -= rLength;
        if (delimTotal > 0) continue;
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
        if (Math.min(lLength, rLength) % 2) {
          const text3 = src.slice(1, lLength + match2.index + rLength);
          return {
            type: "em",
            raw: src.slice(0, lLength + match2.index + rLength + 1),
            text: text3,
            tokens: this.lexer.inlineTokens(text3)
          };
        }
        const text2 = src.slice(2, lLength + match2.index + rLength - 1);
        return {
          type: "strong",
          raw: src.slice(0, lLength + match2.index + rLength + 1),
          text: text2,
          tokens: this.lexer.inlineTokens(text2)
        };
      }
    }
  }
  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text2 = cap[2].replace(/\n/g, " ");
      const hasNonSpaceChars = /[^ ]/.test(text2);
      const hasSpaceCharsOnBothEnds = /^ /.test(text2) && / $/.test(text2);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text2 = text2.substring(1, text2.length - 1);
      }
      text2 = escape$1(text2, true);
      return {
        type: "codespan",
        raw: cap[0],
        text: text2
      };
    }
  }
  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: "br",
        raw: cap[0]
      };
    }
  }
  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: "del",
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2])
      };
    }
  }
  autolink(src, mangle2) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text2, href;
      if (cap[2] === "@") {
        text2 = escape$1(this.options.mangle ? mangle2(cap[1]) : cap[1]);
        href = "mailto:" + text2;
      } else {
        text2 = escape$1(cap[1]);
        href = text2;
      }
      return {
        type: "link",
        raw: cap[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  url(src, mangle2) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text2, href;
      if (cap[2] === "@") {
        text2 = escape$1(this.options.mangle ? mangle2(cap[0]) : cap[0]);
        href = "mailto:" + text2;
      } else {
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text2 = escape$1(cap[0]);
        if (cap[1] === "www.") {
          href = "http://" + text2;
        } else {
          href = text2;
        }
      }
      return {
        type: "link",
        raw: cap[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  inlineText(src, smartypants2) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      let text2;
      if (this.lexer.state.inRawBlock) {
        text2 = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$1(cap[0]) : cap[0];
      } else {
        text2 = escape$1(this.options.smartypants ? smartypants2(cap[0]) : cap[0]);
      }
      return {
        type: "text",
        raw: cap[0],
        text: text2
      };
    }
  }
}
const block = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: noopTest,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
block.normal = merge({}, block);
block.gfm = merge({}, block.normal, {
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
});
block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", block.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag).getRegex();
block.pedantic = merge({}, block.normal, {
  html: edit(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest,
  // fences not supported
  paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
});
const inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noopTest,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noopTest,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};
inline._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
inline.escapedEmSt = /\\\*|\\_/g;
inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "g").replace(/punct/g, inline._punctuation).getRegex();
inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "g").replace(/punct/g, inline._punctuation).getRegex();
inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
inline.normal = merge({}, inline);
inline.pedantic = merge({}, inline.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
});
inline.gfm = merge({}, inline.normal, {
  escape: edit(inline.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
inline.breaks = merge({}, inline.gfm, {
  br: edit(inline.br).replace("{2,}", "*").getRegex(),
  text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
function smartypants(text2) {
  return text2.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function mangle(text2) {
  let out = "", i, ch;
  const l = text2.length;
  for (i = 0; i < l; i++) {
    ch = text2.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = "x" + ch.toString(16);
    }
    out += "&#" + ch + ";";
  }
  return out;
}
class Lexer {
  constructor(options) {
    this.tokens = [];
    this.tokens.links = /* @__PURE__ */ Object.create(null);
    this.options = options || defaults;
    this.options.tokenizer = this.options.tokenizer || new Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };
    const rules2 = {
      block: block.normal,
      inline: inline.normal
    };
    if (this.options.pedantic) {
      rules2.block = block.pedantic;
      rules2.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules2.block = block.gfm;
      if (this.options.breaks) {
        rules2.inline = inline.breaks;
      } else {
        rules2.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules2;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }
  /**
   * Static Lex Method
   */
  static lex(src, options) {
    const lexer = new Lexer(options);
    return lexer.lex(src);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options) {
    const lexer = new Lexer(options);
    return lexer.inlineTokens(src);
  }
  /**
   * Preprocessing
   */
  lex(src) {
    src = src.replace(/\r\n|\r/g, "\n");
    this.blockTokens(src, this.tokens);
    let next4;
    while (next4 = this.inlineQueue.shift()) {
      this.inlineTokens(next4.src, next4.tokens);
    }
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(src, tokens = []) {
    if (this.options.pedantic) {
      src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
    } else {
      src = src.replace(/^( *)(\t+)/gm, (_2, leading, tabs2) => {
        return leading + "    ".repeat(tabs2.length);
      });
    }
    let token2, lastToken, cutSrc, lastParagraphClipped;
    while (src) {
      if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer) => {
        if (token2 = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token2.raw.length);
          tokens.push(token2);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token2 = this.tokenizer.space(src)) {
        src = src.substring(token2.raw.length);
        if (token2.raw.length === 1 && tokens.length > 0) {
          tokens[tokens.length - 1].raw += "\n";
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.code(src)) {
        src = src.substring(token2.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.fences(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.heading(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.hr(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.blockquote(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.list(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.html(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.def(src)) {
        src = src.substring(token2.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.raw;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else if (!this.tokens.links[token2.tag]) {
          this.tokens.links[token2.tag] = {
            href: token2.href,
            title: token2.title
          };
        }
        continue;
      }
      if (token2 = this.tokenizer.table(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.lheading(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token2 = this.tokenizer.paragraph(cutSrc))) {
        lastToken = tokens[tokens.length - 1];
        if (lastParagraphClipped && lastToken.type === "paragraph") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token2);
        }
        lastParagraphClipped = cutSrc.length !== src.length;
        src = src.substring(token2.raw.length);
        continue;
      }
      if (token2 = this.tokenizer.text(src)) {
        src = src.substring(token2.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === "text") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    this.state.top = true;
    return tokens;
  }
  inline(src, tokens = []) {
    this.inlineQueue.push({ src, tokens });
    return tokens;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let token2, lastToken, cutSrc;
    let maskedSrc = src;
    let match2;
    let keepPrevChar, prevChar;
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match2 = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match2[0].slice(match2[0].lastIndexOf("[") + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match2.index) + "[" + repeatString("a", match2[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    while ((match2 = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match2.index) + "[" + repeatString("a", match2[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }
    while ((match2 = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match2.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
    }
    while (src) {
      if (!keepPrevChar) {
        prevChar = "";
      }
      keepPrevChar = false;
      if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer) => {
        if (token2 = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token2.raw.length);
          tokens.push(token2);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token2 = this.tokenizer.escape(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.tag(src)) {
        src = src.substring(token2.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token2.type === "text" && lastToken.type === "text") {
          lastToken.raw += token2.raw;
          lastToken.text += token2.text;
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.link(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token2.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token2.type === "text" && lastToken.type === "text") {
          lastToken.raw += token2.raw;
          lastToken.text += token2.text;
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.codespan(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.br(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.del(src)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.autolink(src, mangle)) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      if (!this.state.inLink && (token2 = this.tokenizer.url(src, mangle))) {
        src = src.substring(token2.raw.length);
        tokens.push(token2);
        continue;
      }
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token2 = this.tokenizer.inlineText(cutSrc, smartypants)) {
        src = src.substring(token2.raw.length);
        if (token2.raw.slice(-1) !== "_") {
          prevChar = token2.raw.slice(-1);
        }
        keepPrevChar = true;
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === "text") {
          lastToken.raw += token2.raw;
          lastToken.text += token2.text;
        } else {
          tokens.push(token2);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    return tokens;
  }
}
class Renderer {
  constructor(options) {
    this.options = options || defaults;
  }
  code(code, infostring, escaped) {
    const lang = (infostring || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }
    code = code.replace(/\n$/, "") + "\n";
    if (!lang) {
      return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
    }
    return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
  }
  /**
   * @param {string} quote
   */
  blockquote(quote) {
    return `<blockquote>
${quote}</blockquote>
`;
  }
  html(html) {
    return html;
  }
  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(text2, level, raw, slugger) {
    if (this.options.headerIds) {
      const id2 = this.options.headerPrefix + slugger.slug(raw);
      return `<h${level} id="${id2}">${text2}</h${level}>
`;
    }
    return `<h${level}>${text2}</h${level}>
`;
  }
  hr() {
    return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
  }
  list(body, ordered, start2) {
    const type4 = ordered ? "ol" : "ul", startatt = ordered && start2 !== 1 ? ' start="' + start2 + '"' : "";
    return "<" + type4 + startatt + ">\n" + body + "</" + type4 + ">\n";
  }
  /**
   * @param {string} text
   */
  listitem(text2) {
    return `<li>${text2}</li>
`;
  }
  checkbox(checked) {
    return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  /**
   * @param {string} text
   */
  paragraph(text2) {
    return `<p>${text2}</p>
`;
  }
  /**
   * @param {string} header
   * @param {string} body
   */
  table(header, body) {
    if (body) body = `<tbody>${body}</tbody>`;
    return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
  }
  /**
   * @param {string} content
   */
  tablerow(content2) {
    return `<tr>
${content2}</tr>
`;
  }
  tablecell(content2, flags2) {
    const type4 = flags2.header ? "th" : "td";
    const tag = flags2.align ? `<${type4} align="${flags2.align}">` : `<${type4}>`;
    return tag + content2 + `</${type4}>
`;
  }
  /**
   * span level renderer
   * @param {string} text
   */
  strong(text2) {
    return `<strong>${text2}</strong>`;
  }
  /**
   * @param {string} text
   */
  em(text2) {
    return `<em>${text2}</em>`;
  }
  /**
   * @param {string} text
   */
  codespan(text2) {
    return `<code>${text2}</code>`;
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  /**
   * @param {string} text
   */
  del(text2) {
    return `<del>${text2}</del>`;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(href, title, text2) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text2;
    }
    let out = '<a href="' + escape$1(href) + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += ">" + text2 + "</a>";
    return out;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(href, title, text2) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text2;
    }
    let out = `<img src="${href}" alt="${text2}"`;
    if (title) {
      out += ` title="${title}"`;
    }
    out += this.options.xhtml ? "/>" : ">";
    return out;
  }
  text(text2) {
    return text2;
  }
}
class TextRenderer {
  // no need for block level renderers
  strong(text2) {
    return text2;
  }
  em(text2) {
    return text2;
  }
  codespan(text2) {
    return text2;
  }
  del(text2) {
    return text2;
  }
  html(text2) {
    return text2;
  }
  text(text2) {
    return text2;
  }
  link(href, title, text2) {
    return "" + text2;
  }
  image(href, title, text2) {
    return "" + text2;
  }
  br() {
    return "";
  }
}
class Slugger {
  constructor() {
    this.seen = {};
  }
  /**
   * @param {string} value
   */
  serialize(value) {
    return value.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(originalSlug, isDryRun) {
    let slug = originalSlug;
    let occurenceAccumulator = 0;
    if (this.seen.hasOwnProperty(slug)) {
      occurenceAccumulator = this.seen[originalSlug];
      do {
        occurenceAccumulator++;
        slug = originalSlug + "-" + occurenceAccumulator;
      } while (this.seen.hasOwnProperty(slug));
    }
    if (!isDryRun) {
      this.seen[originalSlug] = occurenceAccumulator;
      this.seen[slug] = 0;
    }
    return slug;
  }
  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(value, options = {}) {
    const slug = this.serialize(value);
    return this.getNextSafeSlug(slug, options.dryrun);
  }
}
class Parser2 {
  constructor(options) {
    this.options = options || defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.textRenderer = new TextRenderer();
    this.slugger = new Slugger();
  }
  /**
   * Static Parse Method
   */
  static parse(tokens, options) {
    const parser = new Parser2(options);
    return parser.parse(tokens);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options) {
    const parser = new Parser2(options);
    return parser.parseInline(tokens);
  }
  /**
   * Parse Loop
   */
  parse(tokens, top2 = true) {
    let out = "", i, j, k, l2, l3, row, cell, header, body, token2, ordered, start2, loose, itemBody, item2, checked, task, checkbox, ret;
    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token2 = tokens[i];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token2.type]) {
        ret = this.options.extensions.renderers[token2.type].call({ parser: this }, token2);
        if (ret !== false || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(token2.type)) {
          out += ret || "";
          continue;
        }
      }
      switch (token2.type) {
        case "space": {
          continue;
        }
        case "hr": {
          out += this.renderer.hr();
          continue;
        }
        case "heading": {
          out += this.renderer.heading(
            this.parseInline(token2.tokens),
            token2.depth,
            unescape$1(this.parseInline(token2.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          out += this.renderer.code(
            token2.text,
            token2.lang,
            token2.escaped
          );
          continue;
        }
        case "table": {
          header = "";
          cell = "";
          l2 = token2.header.length;
          for (j = 0; j < l2; j++) {
            cell += this.renderer.tablecell(
              this.parseInline(token2.header[j].tokens),
              { header: true, align: token2.align[j] }
            );
          }
          header += this.renderer.tablerow(cell);
          body = "";
          l2 = token2.rows.length;
          for (j = 0; j < l2; j++) {
            row = token2.rows[j];
            cell = "";
            l3 = row.length;
            for (k = 0; k < l3; k++) {
              cell += this.renderer.tablecell(
                this.parseInline(row[k].tokens),
                { header: false, align: token2.align[k] }
              );
            }
            body += this.renderer.tablerow(cell);
          }
          out += this.renderer.table(header, body);
          continue;
        }
        case "blockquote": {
          body = this.parse(token2.tokens);
          out += this.renderer.blockquote(body);
          continue;
        }
        case "list": {
          ordered = token2.ordered;
          start2 = token2.start;
          loose = token2.loose;
          l2 = token2.items.length;
          body = "";
          for (j = 0; j < l2; j++) {
            item2 = token2.items[j];
            checked = item2.checked;
            task = item2.task;
            itemBody = "";
            if (item2.task) {
              checkbox = this.renderer.checkbox(checked);
              if (loose) {
                if (item2.tokens.length > 0 && item2.tokens[0].type === "paragraph") {
                  item2.tokens[0].text = checkbox + " " + item2.tokens[0].text;
                  if (item2.tokens[0].tokens && item2.tokens[0].tokens.length > 0 && item2.tokens[0].tokens[0].type === "text") {
                    item2.tokens[0].tokens[0].text = checkbox + " " + item2.tokens[0].tokens[0].text;
                  }
                } else {
                  item2.tokens.unshift({
                    type: "text",
                    text: checkbox
                  });
                }
              } else {
                itemBody += checkbox;
              }
            }
            itemBody += this.parse(item2.tokens, loose);
            body += this.renderer.listitem(itemBody, task, checked);
          }
          out += this.renderer.list(body, ordered, start2);
          continue;
        }
        case "html": {
          out += this.renderer.html(token2.text);
          continue;
        }
        case "paragraph": {
          out += this.renderer.paragraph(this.parseInline(token2.tokens));
          continue;
        }
        case "text": {
          body = token2.tokens ? this.parseInline(token2.tokens) : token2.text;
          while (i + 1 < l && tokens[i + 1].type === "text") {
            token2 = tokens[++i];
            body += "\n" + (token2.tokens ? this.parseInline(token2.tokens) : token2.text);
          }
          out += top2 ? this.renderer.paragraph(body) : body;
          continue;
        }
        default: {
          const errMsg = 'Token with "' + token2.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer) {
    renderer = renderer || this.renderer;
    let out = "", i, token2, ret;
    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token2 = tokens[i];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token2.type]) {
        ret = this.options.extensions.renderers[token2.type].call({ parser: this }, token2);
        if (ret !== false || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(token2.type)) {
          out += ret || "";
          continue;
        }
      }
      switch (token2.type) {
        case "escape": {
          out += renderer.text(token2.text);
          break;
        }
        case "html": {
          out += renderer.html(token2.text);
          break;
        }
        case "link": {
          out += renderer.link(token2.href, token2.title, this.parseInline(token2.tokens, renderer));
          break;
        }
        case "image": {
          out += renderer.image(token2.href, token2.title, token2.text);
          break;
        }
        case "strong": {
          out += renderer.strong(this.parseInline(token2.tokens, renderer));
          break;
        }
        case "em": {
          out += renderer.em(this.parseInline(token2.tokens, renderer));
          break;
        }
        case "codespan": {
          out += renderer.codespan(token2.text);
          break;
        }
        case "br": {
          out += renderer.br();
          break;
        }
        case "del": {
          out += renderer.del(this.parseInline(token2.tokens, renderer));
          break;
        }
        case "text": {
          out += renderer.text(token2.text);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token2.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
}
function marked(src, opt, callback) {
  if (typeof src === "undefined" || src === null) {
    throw new Error("marked(): input parameter is undefined or null");
  }
  if (typeof src !== "string") {
    throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
  }
  if (typeof opt === "function") {
    callback = opt;
    opt = null;
  }
  opt = merge({}, marked.defaults, opt || {});
  checkSanitizeDeprecation(opt);
  if (callback) {
    const highlight = opt.highlight;
    let tokens;
    try {
      tokens = Lexer.lex(src, opt);
    } catch (e) {
      return callback(e);
    }
    const done = function(err) {
      let out;
      if (!err) {
        try {
          if (opt.walkTokens) {
            marked.walkTokens(tokens, opt.walkTokens);
          }
          out = Parser2.parse(tokens, opt);
        } catch (e) {
          err = e;
        }
      }
      opt.highlight = highlight;
      return err ? callback(err) : callback(null, out);
    };
    if (!highlight || highlight.length < 3) {
      return done();
    }
    delete opt.highlight;
    if (!tokens.length) return done();
    let pending = 0;
    marked.walkTokens(tokens, function(token2) {
      if (token2.type === "code") {
        pending++;
        setTimeout(() => {
          highlight(token2.text, token2.lang, function(err, code) {
            if (err) {
              return done(err);
            }
            if (code != null && code !== token2.text) {
              token2.text = code;
              token2.escaped = true;
            }
            pending--;
            if (pending === 0) {
              done();
            }
          });
        }, 0);
      }
    });
    if (pending === 0) {
      done();
    }
    return;
  }
  function onError(e) {
    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
    if (opt.silent) {
      return "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
    }
    throw e;
  }
  try {
    const tokens = Lexer.lex(src, opt);
    if (opt.walkTokens) {
      if (opt.async) {
        return Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(() => {
          return Parser2.parse(tokens, opt);
        }).catch(onError);
      }
      marked.walkTokens(tokens, opt.walkTokens);
    }
    return Parser2.parse(tokens, opt);
  } catch (e) {
    onError(e);
  }
}
marked.options = marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  changeDefaults(marked.defaults);
  return marked;
};
marked.getDefaults = getDefaults;
marked.defaults = defaults;
marked.use = function(...args) {
  const opts = merge({}, ...args);
  const extensions = marked.defaults.extensions || { renderers: {}, childTokens: {} };
  let hasExtensions;
  args.forEach((pack) => {
    if (pack.extensions) {
      hasExtensions = true;
      pack.extensions.forEach((ext) => {
        if (!ext.name) {
          throw new Error("extension name required");
        }
        if (ext.renderer) {
          const prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
          if (prevRenderer) {
            extensions.renderers[ext.name] = function(...args2) {
              let ret = ext.renderer.apply(this, args2);
              if (ret === false) {
                ret = prevRenderer.apply(this, args2);
              }
              return ret;
            };
          } else {
            extensions.renderers[ext.name] = ext.renderer;
          }
        }
        if (ext.tokenizer) {
          if (!ext.level || ext.level !== "block" && ext.level !== "inline") {
            throw new Error("extension level must be 'block' or 'inline'");
          }
          if (extensions[ext.level]) {
            extensions[ext.level].unshift(ext.tokenizer);
          } else {
            extensions[ext.level] = [ext.tokenizer];
          }
          if (ext.start) {
            if (ext.level === "block") {
              if (extensions.startBlock) {
                extensions.startBlock.push(ext.start);
              } else {
                extensions.startBlock = [ext.start];
              }
            } else if (ext.level === "inline") {
              if (extensions.startInline) {
                extensions.startInline.push(ext.start);
              } else {
                extensions.startInline = [ext.start];
              }
            }
          }
        }
        if (ext.childTokens) {
          extensions.childTokens[ext.name] = ext.childTokens;
        }
      });
    }
    if (pack.renderer) {
      const renderer = marked.defaults.renderer || new Renderer();
      for (const prop in pack.renderer) {
        const prevRenderer = renderer[prop];
        renderer[prop] = (...args2) => {
          let ret = pack.renderer[prop].apply(renderer, args2);
          if (ret === false) {
            ret = prevRenderer.apply(renderer, args2);
          }
          return ret;
        };
      }
      opts.renderer = renderer;
    }
    if (pack.tokenizer) {
      const tokenizer = marked.defaults.tokenizer || new Tokenizer();
      for (const prop in pack.tokenizer) {
        const prevTokenizer = tokenizer[prop];
        tokenizer[prop] = (...args2) => {
          let ret = pack.tokenizer[prop].apply(tokenizer, args2);
          if (ret === false) {
            ret = prevTokenizer.apply(tokenizer, args2);
          }
          return ret;
        };
      }
      opts.tokenizer = tokenizer;
    }
    if (pack.walkTokens) {
      const walkTokens = marked.defaults.walkTokens;
      opts.walkTokens = function(token2) {
        let values = [];
        values.push(pack.walkTokens.call(this, token2));
        if (walkTokens) {
          values = values.concat(walkTokens.call(this, token2));
        }
        return values;
      };
    }
    if (hasExtensions) {
      opts.extensions = extensions;
    }
    marked.setOptions(opts);
  });
};
marked.walkTokens = function(tokens, callback) {
  let values = [];
  for (const token2 of tokens) {
    values = values.concat(callback.call(marked, token2));
    switch (token2.type) {
      case "table": {
        for (const cell of token2.header) {
          values = values.concat(marked.walkTokens(cell.tokens, callback));
        }
        for (const row of token2.rows) {
          for (const cell of row) {
            values = values.concat(marked.walkTokens(cell.tokens, callback));
          }
        }
        break;
      }
      case "list": {
        values = values.concat(marked.walkTokens(token2.items, callback));
        break;
      }
      default: {
        if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token2.type]) {
          marked.defaults.extensions.childTokens[token2.type].forEach(function(childTokens) {
            values = values.concat(marked.walkTokens(token2[childTokens], callback));
          });
        } else if (token2.tokens) {
          values = values.concat(marked.walkTokens(token2.tokens, callback));
        }
      }
    }
  }
  return values;
};
marked.parseInline = function(src, opt) {
  if (typeof src === "undefined" || src === null) {
    throw new Error("marked.parseInline(): input parameter is undefined or null");
  }
  if (typeof src !== "string") {
    throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
  }
  opt = merge({}, marked.defaults, opt || {});
  checkSanitizeDeprecation(opt);
  try {
    const tokens = Lexer.lexInline(src, opt);
    if (opt.walkTokens) {
      marked.walkTokens(tokens, opt.walkTokens);
    }
    return Parser2.parseInline(tokens, opt);
  } catch (e) {
    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
    if (opt.silent) {
      return "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
    }
    throw e;
  }
};
marked.Parser = Parser2;
marked.parser = Parser2.parse;
marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;
marked.Lexer = Lexer;
marked.lexer = Lexer.lex;
marked.Tokenizer = Tokenizer;
marked.Slugger = Slugger;
marked.parse = marked;
marked.options;
marked.setOptions;
marked.use;
marked.walkTokens;
marked.parseInline;
Parser2.parse;
Lexer.lex;
const markdown_inner = "_markdown_inner_q2ssl_1";
const styles$z = {
  markdown_inner
};
const MarkdownText = ({ text: text2, settings, className, linkClassName = "break-all", ellipsis, placeholder, onParsed }) => {
  const modifiedText = useMemo$2(() => {
    if (isEmpty(text2)) return "";
    const lines = text2.split("\n");
    return lines.map((line2) => {
      if (line2.trim().length === 0)
        return line2 + "&nbsp;\n";
      return line2;
    }).join("\n");
  }, [text2]);
  useMemo$2(() => {
    marked.use(settings ?? {
      breaks: true,
      gfm: true,
      renderer: {
        paragraph(text22) {
          return `<p class="mb-0">${text22}</p>`;
        },
        link(href, title, text22) {
          return `<a href="${href}" target="_blank" class="${linkClassName}">${text22}</a>`;
        }
      }
    });
  }, [settings]);
  const textHtml = useMemo$2(() => marked.parse(modifiedText), [modifiedText]);
  useEffect(() => {
    onParsed?.(textHtml);
  }, [textHtml, onParsed]);
  if (isEmpty(textHtml))
    return /* @__PURE__ */ jsx$1(Fragment, { children: placeholder });
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      dangerouslySetInnerHTML: { __html: textHtml },
      className: combineClasses(className, styles$z.markdown_inner),
      "data-ellipsis": ellipsis
    }
  );
};
TimeSpan.fromDays(1).milliseconds;
TimeSpan.fromHours(1).milliseconds;
TimeSpan.fromMinutes(1).milliseconds;
TimeSpan.fromSeconds(1).milliseconds;
const DateSplitPicker = ({ value, defaultValue, className, onChange: onChange5, ...props }) => {
  const { loc } = useContext(Context$3);
  const state = useLocalStore(() => ({
    day: value?.date() ?? defaultValue?.date(),
    month: value ? value?.month() + 1 : defaultValue ? defaultValue.month() + 1 : void 0,
    year: value?.year() ?? defaultValue?.year(),
    get days() {
      return Array.from({ length: state.daysInMonth }, (_2, i) => i + 1);
    },
    get months() {
      return Array.from({ length: 12 }, (_2, i) => i + 1);
    },
    get years() {
      const currentYear = moment().year();
      return Array.from({ length: 100 }, (_2, i) => currentYear - i);
    },
    get daysInMonth() {
      if (state.month === void 0 || state.year === void 0)
        return 31;
      return moment({ day: 1, month: state.month - 1, year: state.year }).daysInMonth();
    },
    get date() {
      if (state.day === void 0 || state.month === void 0 || state.year === void 0)
        return void 0;
      return moment({ day: state.day, month: state.month - 1, year: state.year });
    },
    onChange: onChange5,
    update(dateObj) {
      let day2 = dateObj.day ?? state.day ?? 1;
      const month = dateObj.month ?? state.month ?? 1;
      const year = dateObj.year ?? state.year ?? moment().year();
      if (dateObj.month !== void 0 || dateObj.year !== void 0) {
        const daysInMonth = moment({ day: 1, month: month - 1, year }).daysInMonth();
        day2 = Math.min(daysInMonth, day2);
      }
      runInAction(() => {
        state.day = day2;
        state.month = month;
        state.year = year;
      });
      if (state.date !== void 0)
        state.onChange?.(state.date);
    },
    reset() {
      runInAction(() => {
        state.day = void 0;
        state.month = void 0;
        state.year = void 0;
      });
    }
  }));
  useEffect(() => {
    state.onChange = onChange5;
  }, [onChange5]);
  useUpdateEffect(() => {
    if (!value) {
      state.reset();
      return;
    }
    if (!value.isSame(state.date, "day") || !value.isSame(state.date, "month") || !value.isSame(state.date, "year")) {
      state.update({ day: value?.date(), month: value?.month() + 1, year: value?.year() });
    }
  }, [value]);
  return /* @__PURE__ */ jsxs("div", { className: combineClasses(className, "flex flex-1 gap-5"), children: [
    /* @__PURE__ */ jsx$1(
      Select,
      {
        ...props,
        placeholder: loc.word("DateSplitPicker.dayPlaceholder"),
        value: state.day,
        options: state.days.map((day2) => ({ value: day2, label: day2 })),
        onChange: (day2) => state.update({ day: day2 }),
        style: { flex: 1 }
      }
    ),
    /* @__PURE__ */ jsx$1(
      Select,
      {
        ...props,
        placeholder: loc.word("DateSplitPicker.monthPlaceholder"),
        value: state.month,
        options: state.months.map((month) => ({ value: month, label: loc.word(`Month.${month}`) })),
        onChange: (month) => state.update({ month }),
        style: { flex: 2 }
      }
    ),
    /* @__PURE__ */ jsx$1(
      Select,
      {
        ...props,
        placeholder: loc.word("DateSplitPicker.yearPlaceholder"),
        value: state.year,
        options: state.years.map((year) => ({ value: year, label: year })),
        onChange: (year) => state.update({ year }),
        style: { flex: 1 }
      }
    )
  ] });
};
observer(DateSplitPicker);
const SelectFooter = ({ footer, children: children2 }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    children2,
    /* @__PURE__ */ jsx$1("div", { className: "border-t pt-4", children: footer })
  ] });
};
const AntSelectLabel = ({ children: children2 }) => {
  return /* @__PURE__ */ jsx$1(Fragment, { children: children2 });
};
const useSelect = function(props, dataSource, itemKey) {
  const { itemLabel, itemLabelValue, isOptionDisabled, mode: _mode, value: _value, defaultValue, onChange: _onChange, onChangeSingle, createItem } = props;
  const transformItems = useCallback((items, selected2 = false) => {
    return items.map((x) => ({
      label: /* @__PURE__ */ jsx$1(AntSelectLabel, { item: x, children: selected2 && itemLabelValue ? itemLabelValue(x) : itemLabel(x) }),
      value: itemKey(x),
      disabled: isOptionDisabled?.(x)
    }));
  }, [itemLabel, itemLabelValue, itemKey, isOptionDisabled]);
  const value = useMemo$2(() => {
    const data2 = _value ?? defaultValue;
    if (data2 == null)
      return [];
    if (Array.isArray(data2))
      return transformItems(data2, true);
    return transformItems([data2], true);
  }, [_value, defaultValue]);
  const options = useMemo$2(() => transformItems(dataSource), [dataSource]);
  const handleChange = useCallback((value2) => {
    if (value2 == null) {
      _onChange?.([]);
      onChangeSingle?.(null);
      return;
    }
    const shouldCreateItem = _mode === "tags" && createItem != null;
    if (Array.isArray(value2)) {
      const items = value2.map((x) => x.label?.props?.item ?? (shouldCreateItem ? createItem(x.value) : null)).filter((x) => x != null);
      _onChange?.(items);
      if (value2.length > 0)
        onChangeSingle?.(items[0]);
    } else {
      const item2 = value2.label?.props?.item ?? (shouldCreateItem ? createItem(value2.value) : null);
      _onChange?.(item2 == null ? [] : [item2]);
      onChangeSingle?.(item2);
    }
  }, [_onChange, onChangeSingle, _mode, createItem]);
  return { value, options, mode: _mode === "mono" ? void 0 : _mode, handleChange };
};
const accel_ant_select_size_small = "_accel_ant_select_size_small_tdph3_1";
const styles$y = {
  accel_ant_select_size_small
};
const useNotifier = function() {
  const { loc } = useContext(Context$3);
  const notify = useCallback(function(result, success, successOpts, errorOpts) {
    if (result.success) {
      success && notification.open({ duration: 2, message: success, type: successOpts?.type ?? "success", ...successOpts });
      return;
    }
    if (result.response.errors.length > 0) {
      result.response.errors.forEach((e) => notification.error({ duration: 2, message: e.message ?? loc.word(`Error${ErrorCode[e.code]}`), ...errorOpts }));
      return;
    }
    notification.error({ duration: 2, message: loc.word("Error occured"), ...errorOpts });
  }, []);
  return [notify];
};
const useInitializer = function({ store: store2, initialIds, fields, onInited, onInitedSingle }) {
  const [notify] = useNotifier();
  const [idsToInit] = useState$1(() => {
    if (!initialIds) return [];
    return Array.isArray(initialIds) ? initialIds : [initialIds];
  });
  const [inited, setInited] = useState$1(idsToInit.length == 0);
  const init2 = useCallback(async () => {
    const initialFilter = new BaseFilter({
      ids: idsToInit,
      softDeleted: null,
      useBaseFilter: false
    });
    const result = await store2.fetchItems(fields, initialFilter);
    if (!result.success) {
      notify(result);
      console.error("[SelectAsync] Fetching items failed", result);
      setInited(true);
      return;
    }
    const items = result.response.items;
    onInited?.(items);
    if (items.length > 0)
      onInitedSingle?.(items[0]);
    setInited(true);
  }, []);
  useEffect(() => {
    if (!inited)
      init2();
  }, []);
  return inited;
};
function SelectAsync(props) {
  const {
    selectRef,
    store: store2,
    inline: inline2,
    itemLabel,
    itemLabelValue,
    value: _value,
    defaultValue,
    initialIds,
    fields,
    customOptions = [],
    customOptionsPlacement = "bottom",
    menuFooter,
    searchMode = "default",
    onChange: onChange5,
    onChangeSingle,
    onInited,
    onInitedSingle,
    showArrow = true,
    showSearch = true,
    ...selectProps
  } = props;
  const alreadyFetched = useRef(false);
  const [notify] = useNotifier();
  const inited = useInitializer(props);
  const { mode, value, options, handleChange } = useSelect(
    props,
    customOptions.length > 0 ? customOptionsPlacement == "top" ? [...customOptions, ...store2.items] : [...store2.items, ...customOptions] : store2.items,
    (x) => props.itemKey?.(x) ?? x.id
  );
  const handleSearch = useDebouncedCallback(async (search3) => {
    store2.updateFilter({ search: search3 });
    const result = await store2.fetch(fields);
    !result.success && notify(result);
  }, [], TimeSpan.fromMilliseconds(300));
  const handleCustomSearch = useCallback((search3, option) => {
    return props.customSearch?.(search3, option.label.props.item) ?? true;
  }, [props.customSearch]);
  const handleDropdownVisibleChange = useCallback(async (visible) => {
    if (alreadyFetched.current || !visible)
      return;
    alreadyFetched.current = true;
    const result = await store2.fetch(fields);
    !result.success && notify(result);
  }, []);
  const handleRef = useCallback((ref2) => {
    if (!selectRef || !ref2) return;
    const r2 = {
      ...ref2,
      clearCache: () => {
        alreadyFetched.current = false;
        store2.reset();
      },
      update: async () => {
        await store2.fetch(fields);
      }
    };
    if (typeof selectRef === "function") {
      selectRef(r2);
    } else {
      selectRef.current = r2;
    }
  }, []);
  useEffect(() => {
    if (selectProps.open === true)
      handleDropdownVisibleChange(true);
  }, []);
  return /* @__PURE__ */ jsx$1(
    Select,
    {
      ...selectProps,
      showArrow,
      showSearch,
      ref: handleRef,
      mode,
      value,
      options,
      onChange: handleChange,
      disabled: !inited || props.disabled,
      onSearch: searchMode == "default" ? (x) => {
        handleSearch(x);
        selectProps.onSearch?.(x);
      } : void 0,
      onDropdownVisibleChange: (open) => {
        handleDropdownVisibleChange(open);
        selectProps.onDropdownVisibleChange?.(open);
      },
      dropdownRender: menuFooter ? (menu2) => /* @__PURE__ */ jsx$1(SelectFooter, { footer: menuFooter, children: menu2 }) : void 0,
      loading: props.store.fetching,
      labelInValue: true,
      filterOption: searchMode == "custom" ? handleCustomSearch : false,
      bordered: !inline2,
      showAction: ["focus", "click"],
      className: combineClasses(styles$y.accel_ant_select, styles$y[`accel_ant_select_size_${props.size}`], props.className)
    }
  );
}
SelectAsync.useRef = () => {
  const ref2 = useRef(null);
  return ref2;
};
observer(SelectAsync);
function AntSelect(props) {
  const { dataSource, itemLabel, itemLabelValue, showArrow = true, itemKey, mode: _mode, selectRef, value: _value, defaultValue, menuFooter, inline: inline2, onChange: onChange5, onChangeSingle, ...selectProps } = props;
  const internalSelectRef = useRef(null);
  const { mode, value, options, handleChange } = useSelect(props, props.dataSource, (x) => itemKey?.(x) ?? x);
  return /* @__PURE__ */ jsx$1(
    Select,
    {
      ...selectProps,
      showArrow,
      mode,
      ref: combineRefs(internalSelectRef, selectRef),
      value,
      options,
      onChange: handleChange,
      labelInValue: true,
      dropdownRender: menuFooter ? (menu2) => /* @__PURE__ */ jsx$1(SelectFooter, { footer: menuFooter, children: menu2 }) : void 0,
      bordered: !inline2,
      className: combineClasses(styles$y.accel_ant_select, selectProps.className),
      "data-size": props.size,
      showAction: ["focus", "click"]
    }
  );
}
AntSelect.useRef = () => {
  const ref2 = useRef(null);
  return ref2;
};
observer(AntSelect);
const filter = "_filter_1ftkt_1";
const noRowBorder = "_noRowBorder_1ftkt_24";
const styles$x = {
  filter,
  noRowBorder
};
function Table(props) {
  const { loc } = useContext(Context$3);
  useEffect(() => {
    if (props.selectable === true && !(props.store instanceof SelectableListStore))
      console.error("[Table] Store must be an instance of SelectableListStore");
  }, [props.selectable, props.store]);
  const disablePagination = useMemo$2(() => {
    const filter2 = props.store.filter;
    return props.disablePagination === true || props.hidePaginationOnePage !== false && filter2.pageTotal == 1;
  }, [props.disablePagination, props.hidePaginationOnePage, props.store.filter]);
  const pagination = useMemo$2(() => {
    if (disablePagination) return false;
    const filter2 = props.store.filter;
    return {
      showSizeChanger: props.showSizeChanger ?? true,
      showTotal: (total, range3) => {
        return `${range3[0]}-${range3[1]} ${loc.word("Global.of")} ${total}`;
      },
      total: filter2.itemsTotal,
      pageSize: filter2.take,
      current: filter2.page
    };
  }, [disablePagination, props.store.filter]);
  const handleTableChange = useCallback((pagination2, filters, sorter, extra) => {
    switch (extra.action) {
      case "paginate":
        const take = pagination2.pageSize ?? props.store.filter.take;
        const page = pagination2.current ?? props.store.filter.page;
        props.store.filter.update({ take, page });
        break;
      case "sort":
        props.store.filter.update({
          // dirty hack
          sortName: sorter.field,
          sortType: sorter.order == "ascend" ? SortingDirection.asc : SortingDirection.desc
        });
        break;
    }
    props.store.filter.update({ filters });
    props.onChange?.(pagination2, filters, sorter, extra);
    if (props.autoFetch !== false)
      props.store.fetch();
  }, [props.autoFetch, props.store, props.onChange]);
  const columns = useMemo$2(() => {
    return props.useObservableCell == false ? props.columns : props.columns.map((x) => !x.render ? x : {
      ...x,
      render: (a, b, c) => {
        return /* @__PURE__ */ jsx$1(ObserverComponent, { children: () => /* @__PURE__ */ jsx$1(Fragment, { children: x.render(a, b, c) }) });
      }
    });
  }, [props.useObservableCell, props.columns]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    props.filter && /* @__PURE__ */ jsx$1(
      "div",
      {
        className: combineClasses(styles$x.filter, "p-7 bg-white"),
        "data-sticky": props.filterSticky ?? true,
        children: props.filter
      }
    ),
    /* @__PURE__ */ jsx$1(
      Table$2,
      {
        ...props,
        className: combineClasses(
          props.className,
          props.size == "xs" ? styles$x.xsmall : void 0,
          props.rowBordered === false ? styles$x.noRowBorder : void 0
        ),
        size: props.size,
        rowKey: props.rowKey ? props.rowKey : (x) => x.id,
        columns,
        scroll: { scrollToFirstRowOnChange: true, ...props.scroll },
        dataSource: props.dataSource ?? props.store.items,
        loading: props.loading ?? props.store.fetching,
        pagination,
        onChange: (p, f, s, e) => handleTableChange(p, f, s, e),
        rowSelection: props.selectable === true ? props.rowSelection ?? {
          columnTitle: () => null,
          renderCell: (checked, item2) => {
            const store2 = props.store;
            return /* @__PURE__ */ jsx$1(ObserverComponent, { children: () => /* @__PURE__ */ jsx$1(
              Checkbox,
              {
                checked: store2.selectedAll || store2.isSelected(item2.id),
                disabled: store2.selectedAll,
                onChange: (e) => {
                  store2.toggleItem(item2.id);
                }
              }
            ) });
          }
        } : void 0
      }
    )
  ] });
}
observer(Table);
const highlighted = "_highlighted_imzy4_1";
const unhighlighted = "_unhighlighted_imzy4_7";
const styles$w = {
  highlighted,
  unhighlighted
};
const TextHighlighter = ({
  textToHighlight,
  searchWords,
  highlightClassName = styles$w.highlighted,
  highlightStyle,
  unhighlightClassName = styles$w.unhighlighted,
  unhighlightStyle
}) => {
  const getHighlightedText = useCallback((text2, words) => {
    const regex2 = new RegExp(`(${words.join("|")})`, "gi");
    const parts = text2?.split(regex2) ?? [];
    return parts.filter(Boolean).map((part, index2) => {
      if (words.some((word) => new RegExp(word, "gi").test(part)))
        return /* @__PURE__ */ jsx$1("span", { className: highlightClassName, style: highlightStyle, children: part }, index2);
      else
        return /* @__PURE__ */ jsx$1("span", { className: unhighlightClassName, style: unhighlightStyle, children: part }, index2);
    });
  }, [highlightClassName, highlightStyle, unhighlightClassName, unhighlightStyle]);
  if (searchWords.length === 0) {
    return /* @__PURE__ */ jsx$1(Fragment, { children: textToHighlight });
  }
  return /* @__PURE__ */ jsx$1(Fragment, { children: getHighlightedText(textToHighlight, searchWords) });
};
observer(TextHighlighter);
function useClipboardFiles(cb, enabled = true, deps) {
  useEffect(() => {
    if (enabled === false) return;
    const onPaste = (e) => {
      const fileData = Array.from(e.clipboardData.items).find((x) => x.kind == "file");
      const file = fileData?.getAsFile();
      if (!file) return;
      cb(file);
    };
    document.addEventListener("paste", onPaste);
    return () => {
      document.removeEventListener("paste", onPaste);
    };
  }, deps);
}
const customSlider = "_customSlider_3hn0g_1";
const styles$v = {
  customSlider
};
React__default.memo(({ captcha, setOffsetX }) => {
  const [localOffsetX, setLocalOffsetX] = useState$1(0);
  const [imageWidth, setImageWidth] = useState$1(0);
  const [puzzleWidth, setPuzzleWidth] = useState$1(0);
  const handleBackgroundLoad = useCallback((e) => {
    setImageWidth(e.target.clientWidth);
  }, []);
  const handlePuzzleLoad = useCallback((e) => {
    setPuzzleWidth(e.target.clientWidth);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "text-center relative no-select", children: [
    /* @__PURE__ */ jsxs("div", { className: "d-inline-block relative overflow-hidden br-xxs", children: [
      /* @__PURE__ */ jsx$1(
        "img",
        {
          src: `data:image/png;base64,${captcha.backgroundImageBytes}`,
          alt: "background",
          className: "max-w-100 d-block",
          draggable: false,
          onLoad: handleBackgroundLoad
        }
      ),
      /* @__PURE__ */ jsx$1(
        "img",
        {
          src: `data:image/png;base64,${captcha.puzzleImageBytes}`,
          alt: "puzzle",
          className: "absolute no-pointer-events z-1",
          style: {
            top: captcha.positionY,
            left: localOffsetX
          },
          draggable: false,
          onLoad: handlePuzzleLoad
        }
      )
    ] }),
    /* @__PURE__ */ jsx$1("div", { style: { width: `${imageWidth}px`, margin: "0 auto" }, children: /* @__PURE__ */ jsx$1("div", { className: styles$v.customSlider, children: /* @__PURE__ */ jsx$1(
      Slider$1,
      {
        value: localOffsetX,
        min: 0,
        max: imageWidth > 0 ? imageWidth - (puzzleWidth || 60) : 300,
        onChange: setLocalOffsetX,
        onAfterChange: setOffsetX,
        className: "w-100",
        tooltip: { formatter: null }
      }
    ) }) })
  ] });
});
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp2(target, key, result);
  return result;
};
class ChatHardwareController extends Disposable {
  constructor() {
    super();
    this.micInited = false;
    this.micAccess = null;
    this.micError = null;
    this.micCurrentStream = null;
    this.micCurrentDeviceId = null;
    this.deviceList = null;
    const handleDeviceChange = (e) => {
      console.logDev("devicechange", e);
      this.updateDeviceList();
    };
    if (navigator.mediaDevices.addEventListener) {
      navigator.mediaDevices.addEventListener("devicechange", handleDeviceChange);
      this.toDispose(() => navigator.mediaDevices.removeEventListener("devicechange", handleDeviceChange));
    } else if (navigator.mediaDevices.ondevicechange) {
      navigator.mediaDevices.ondevicechange = handleDeviceChange;
      this.toDispose(() => navigator.mediaDevices.ondevicechange = null);
    }
  }
  async init(defaultMicDeviceId) {
    if (!this.micInited)
      await this.tryGetMicAccess(defaultMicDeviceId);
  }
  async tryGetMicAccess(deviceId) {
    try {
      const mic = await navigator.mediaDevices.getUserMedia({ audio: deviceId ? { deviceId: { exact: deviceId } } : true });
      runInAction(() => {
        this.micError = null;
        this.micCurrentStream = mic;
        this.micCurrentDeviceId = mic.getAudioTracks()[0].getSettings().deviceId ?? null;
        this.micAccess = true;
      });
      this.updateDeviceList();
      return true;
    } catch (e) {
      if (e.name === "NotFoundError") {
        runInAction(() => this.micError = "Microphone is not found");
      } else {
        runInAction(() => this.micError = e.name);
      }
      runInAction(() => {
        this.micCurrentStream = null;
        this.micCurrentDeviceId = null;
        this.micAccess = false;
      });
      return false;
    } finally {
      runInAction(() => this.micInited = true);
    }
  }
  async changeMicDevice(deviceId) {
    this.stopMicStream();
    if (deviceId) await this.tryGetMicAccess(deviceId);
    else runInAction(() => {
      this.micCurrentDeviceId = deviceId;
      this.micCurrentStream = null;
    });
  }
  stopMicStream() {
    if (this.micCurrentStream) this.micCurrentStream.getTracks().forEach((x) => x.stop());
    runInAction(() => this.micInited = false);
  }
  async updateDeviceList() {
    const list = await navigator.mediaDevices.enumerateDevices();
    runInAction(() => {
      this.deviceList = {
        mics: list.filter((x) => x.kind === "audioinput"),
        headphones: list.filter((x) => x.kind === "audiooutput"),
        cameras: list.filter((x) => x.kind === "videoinput")
      };
    });
  }
  dispose() {
    super.dispose();
    this.stopMicStream();
  }
}
__decorateClass([
  observable
], ChatHardwareController.prototype, "micInited", 2);
__decorateClass([
  observable
], ChatHardwareController.prototype, "micAccess", 2);
__decorateClass([
  observable
], ChatHardwareController.prototype, "micError", 2);
__decorateClass([
  observable
], ChatHardwareController.prototype, "micCurrentStream", 2);
__decorateClass([
  observable
], ChatHardwareController.prototype, "micCurrentDeviceId", 2);
__decorateClass([
  observable
], ChatHardwareController.prototype, "deviceList", 2);
__decorateClass([
  action
], ChatHardwareController.prototype, "tryGetMicAccess", 1);
__decorateClass([
  action
], ChatHardwareController.prototype, "updateDeviceList", 1);
const ChatContext = React.createContext();
const ChatProvider = ({ deviceStore, fileProvider, fileApi, lang, loc, settings: externalSettings, tokenStore, messageFormProps, openFullChat, children: children2 }) => {
  const [settings, saveSettings] = useLocalStorage("chat.settings", ChatSettings.default(externalSettings), true, (x) => ChatSettings.fromJson({ ...x, ...externalSettings }));
  const hub = useMemo$2(() => new HubClient(tokenStore, { host: settings.hubUrl, invokeTimeoutMs: 5e3, autoConnect: false }), []);
  const chat = useMemo$2(() => new ChatController(hub, new ConversationCacheStore(hub)), []);
  const hardware = useMemo$2(() => new ChatHardwareController(), []);
  const [ctx] = useState$1({
    loc,
    fileProvider,
    lang,
    deviceStore,
    fileApi,
    tokenStore,
    settings,
    hub,
    chat,
    openFullChat,
    hardware,
    messageFormProps
  });
  useEffect(() => {
    chat.setSettings(settings);
    return () => {
      hardware.dispose();
      chat.dispose();
      hub.dispose();
    };
  }, []);
  useEffect(() => {
    console.logDev("save chat settings", settings);
    saveSettings(settings);
    chat.setSettings(settings);
  }, [settings.scaleFactor, settings.micDeviceId, settings.hideBotMessages]);
  const api2 = useMemo$2(() => ({ file: fileApi }), [fileApi]);
  return /* @__PURE__ */ jsx$1(ChatContext.Provider, { value: ctx, children: /* @__PURE__ */ jsx$1(AccelProvider, { loc, lang, api: api2, deviceStore, fileProvider, children: children2 }) });
};
const ChatProvider_default = observer(ChatProvider);
const chat_wrapper = "_chat_wrapper_8thll_1";
const chat_drawer = "_chat_drawer_8thll_17";
const styles$u = {
  chat_wrapper,
  chat_drawer
};
function useDrawer(defaultState) {
  const [state, setState] = useState$1({ visible: false });
  return {
    get visible() {
      return state.visible;
    },
    get data() {
      return state.data;
    },
    close: () => {
      setState({ visible: false });
    },
    open: (data2) => {
      setState({ visible: true, data: data2 ?? state.data });
    },
    set: (changes) => {
      const newState = { ...state, ...changes };
      setState(newState);
    }
  };
}
function useLoc() {
  const ctx = useContext(ChatContext);
  return ctx.loc;
}
const user_status_badge = "_user_status_badge_uvn4g_1";
const styles$t = {
  user_status_badge
};
const ChatUserOnlineStatusBadge = ({ onlineStatus, userId, className, watch, children: children2 }) => {
  const hub = useChatHub();
  const [status, setStatus] = useState$1(onlineStatus ?? UserOnlineStatus.Offline);
  useEffect(() => {
    setStatus(onlineStatus);
  }, [onlineStatus]);
  useEffect(() => {
    if (watch !== true) return;
    const unsubscribe = hub.on(new ChatUserSubscription(userId), (x) => {
      setStatus(x.onlineStatus);
    });
    return () => {
      unsubscribe.dispose();
    };
  }, [userId]);
  return /* @__PURE__ */ jsx$1(
    Badge,
    {
      className: combineClasses(styles$t.user_status_badge, className),
      status: status == UserOnlineStatus.Online ? "success" : "default",
      children: children2
    }
  );
};
function useUser() {
  const controller = useChat();
  return controller.user;
}
const Access = ({ roles, allow, deny, onAllow, onDeny, children: children2 }) => {
  const user2 = useUser();
  const isAllow = useMemo$2(() => user2.hasRoles(...roles), [roles]);
  useEffect(() => {
    if (isAllow) {
      onAllow?.();
    } else {
      onDeny?.();
    }
  }, [isAllow]);
  const content2 = useMemo$2(() => {
    if (typeof children2 === "function")
      return children2(isAllow);
    if (isAllow) {
      if (!allow)
        return children2 ?? null;
      return typeof allow === "function" ? allow() : allow;
    } else {
      if (!deny)
        return null;
      return typeof deny === "function" ? deny() : deny;
    }
  }, [isAllow, allow, deny, children2]);
  return content2;
};
function useChat() {
  const ctx = useContext(ChatContext);
  return ctx.chat;
}
function useChatSettings() {
  const ctx = useContext(ChatContext);
  return ctx.settings;
}
function useChatHardware() {
  const ctx = useContext(ChatContext);
  return ctx.hardware;
}
function useChatHub() {
  const ctx = useContext(ChatContext);
  return ctx.hub;
}
const MessageDeletedPlaceholder = ({ useIcon, className }) => {
  const loc = useLoc();
  return /* @__PURE__ */ jsxs("span", { className: combineClasses("color-secondary", className), children: [
    useIcon !== false && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx$1(StopOutlined, { className: "chat-message-icon" }),
      " "
    ] }),
    loc.word("Chat.messageDeletedPlaceholder", { default: "This message was deleted" })
  ] });
};
function GoLocation(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 12 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M6 0C2.69 0 0 2.5 0 5.5 0 10.02 6 16 6 16s6-5.98 6-10.5C12 2.5 9.31 0 6 0zm0 14.55C4.14 12.52 1 8.44 1 5.5 1 3.02 3.25 1 6 1c1.34 0 2.61.48 3.56 1.36.92.86 1.44 1.97 1.44 3.14 0 2.94-3.14 7.02-5 9.05zM8 5.5c0 1.11-.89 2-2 2-1.11 0-2-.89-2-2 0-1.11.89-2 2-2 1.11 0 2 .89 2 2z" } }] })(props);
}
function MdCallMade(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" } }] })(props);
}
function MdCallReceived(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z" } }] })(props);
}
function BsReverseLayoutSidebarInsetReverse(props) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12z" } }, { "tag": "path", "attr": { "d": "M13 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4z" } }] })(props);
}
function BsCheckAll(props) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" } }] })(props);
}
function BsCheck(props) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" } }] })(props);
}
const delivery_mark = "_delivery_mark_5y7jy_1";
const styles$s = {
  delivery_mark
};
const ChatMessageDeliveryMark = ({ position: position2 = "relative", message: message2, targetLastSeenMessageIndex }) => {
  if (message2.type != ChatMessageType.Normal && message2.type != ChatMessageType.Template) return null;
  return /* @__PURE__ */ jsx$1("span", { className: styles$s.delivery_mark, "data-pos": position2, children: targetLastSeenMessageIndex && message2.index <= targetLastSeenMessageIndex ? /* @__PURE__ */ jsx$1(BsCheckAll, { className: "fs-18 color-success" }) : message2.sent ? /* @__PURE__ */ jsx$1(BsCheckAll, { className: "fs-18 color-secondary" }) : /* @__PURE__ */ jsx$1(BsCheck, { className: "fs-18 color-secondary" }) });
};
const ChatMessageDeliveryMark$1 = observer(ChatMessageDeliveryMark);
const ChatMessageContentPreview = ({ message: message2, deliveryMark, targetLastSeenMessageIndex }) => {
  const loc = useLoc();
  const user2 = useUser();
  const [hasText] = useState$1(!isEmpty(message2.text));
  const [shortText] = useState$1(message2.plainText?.slice(0, 100));
  const [direction] = useState$1(message2.author?.userId == user2.id ? "out" : "in");
  const messageContent = useMemo$2(() => {
    if (message2.softDeleted)
      return /* @__PURE__ */ jsx$1(MessageDeletedPlaceholder, { useIcon: false });
    switch (message2.type) {
      case ChatMessageType.System:
      case ChatMessageType.ButtonClicked:
      case ChatMessageType.Normal:
      case ChatMessageType.Comment:
        return /* @__PURE__ */ jsxs("div", { className: "flex align-center gap-3", children: [
          hasText && /* @__PURE__ */ jsx$1("span", { className: "ellipsis", style: { maxWidth: 250 }, children: shortText }),
          message2.hasAttachments && /* @__PURE__ */ jsx$1("span", { className: "color-primary", children: /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Chat.attachmentsTooltip", { default: "Attachments" }), children: /* @__PURE__ */ jsx$1(PaperClipOutlined, {}) }) }),
          message2.hasLocation && /* @__PURE__ */ jsx$1("span", { className: "color-primary", children: /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Chat.locationLabel", { default: "Location" }), children: /* @__PURE__ */ jsx$1(GoLocation, {}) }) }),
          deliveryMark && direction == "out" && /* @__PURE__ */ jsx$1(ChatMessageDeliveryMark$1, { message: message2, targetLastSeenMessageIndex })
        ] });
      case ChatMessageType.Template:
        return /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx$1(Loc, { word: "Global.template", default: "Template" }),
          " ",
          message2.template?.title ?? message2.template?.name
        ] });
      case ChatMessageType.CallStarted:
      case ChatMessageType.CallCompleted:
        return /* @__PURE__ */ jsxs("span", { className: "flex align-center", children: [
          direction == "in" ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx$1(MdCallReceived, {}),
            loc.word("Chat.inCallLabel", { default: "Incoming call" })
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx$1(MdCallMade, {}),
            loc.word("Chat.outCallLabel", { default: "Outgoing call" })
          ] }),
          message2.callDuration && /* @__PURE__ */ jsx$1(Duration, { duration: message2.callDuration, convertDaysToHours: true, className: "color-secondary ml-5" })
        ] });
      case ChatMessageType.Voice:
        return /* @__PURE__ */ jsx$1(Loc, { word: "Chat.voiceMessage", default: "Voice message" });
    }
  }, [message2]);
  return /* @__PURE__ */ jsx$1(Fragment, { children: messageContent });
};
const reply_msg_wrapper = "_reply_msg_wrapper_1t3yx_1";
const reply_msg = "_reply_msg_1t3yx_1";
const styles$r = {
  reply_msg_wrapper,
  reply_msg
};
const ReplyMessage = ({ message: message2, title, content: content2, canRemove, className, onClick: onClick2, onRemove }) => {
  return /* @__PURE__ */ jsxs("div", { className: combineClasses("flex align-center", className), onClick: () => onClick2?.(), children: [
    canRemove !== false && /* @__PURE__ */ jsx$1("div", { className: "fs-15 mr-10", children: /* @__PURE__ */ jsx$1(CloseOutlined, { onClick: () => onRemove?.() }) }),
    /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$r.reply_msg_wrapper, "w-100 flex align-center overflow-hidden relative c-pointer"), children: /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$r.reply_msg, "flex flex-col ml-8"), children: [
      /* @__PURE__ */ jsx$1("div", { className: "color-primary ellipsis chat-message-reply", children: title ?? message2.author.fullName }),
      /* @__PURE__ */ jsx$1("div", { className: "ellipsis chat-message-reply", children: content2 ?? /* @__PURE__ */ jsx$1(ChatMessageContentPreview, { message: message2, targetLastSeenMessageIndex: null }) })
    ] }) })
  ] });
};
const ReplyMessage$1 = observer(ReplyMessage);
const MessageContextMenu = ({ conversation: conversation2, message: message2, user: user2, children: children2, onDeleted }) => {
  const loc = useLoc();
  const controller = useChat();
  const menu2 = useDrawer();
  const hub = useChatHub();
  const getState = useCallback(() => {
    const isMine = message2.author.userId == user2.id;
    const settings = conversation2.messageSettings;
    const readonly = conversation2.readonly;
    let canModify = !message2.deleted;
    if (canModify && settings.modifyTimeout) {
      const diff = moment().diff(message2.createdDate, "milliseconds");
      canModify = diff < settings.modifyTimeout.milliseconds;
    }
    if (canModify && settings.responseTimeLimit)
      canModify = conversation2.isResponseTimeLimitExceeded;
    return {
      canReply: !readonly,
      canEdit: !readonly && isMine && canModify && settings.canEdit && message2.type != ChatMessageType.Voice,
      canDelete: !readonly && (isMine || message2.author.type == UserType.School) && canModify && settings.canDelete
    };
  }, [conversation2.messageSettings, conversation2.readonly]);
  const deleteMessage = useCallback(async () => {
    const result = await hub.invoke(new DeleteMessageRequest({
      id: message2.id
    }));
    if (result.success) {
      if (conversation2.channelType == ChannelType.Accel) {
        message2.update({
          softDeleted: true,
          deleting: false,
          deleted: true
        });
      } else {
        message2.update({ deleting: true });
      }
      onDeleted();
      menu2.close();
      return true;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
    return false;
  }, []);
  return /* @__PURE__ */ jsx$1(
    Dropdown,
    {
      open: menu2.visible,
      onOpenChange: (visible) => {
        if (visible) {
          const menuState = getState();
          if (menuState.canReply || menuState.canEdit || menuState.canDelete)
            menu2.open(menuState);
        } else
          menu2.close();
      },
      overlay: /* @__PURE__ */ jsx$1(
        Menu,
        {
          style: { width: 150 },
          onClick: (x) => {
            switch (x.key) {
              case "reply":
                controller.setReplyMessage(message2);
                menu2.close();
                break;
              case "edit":
                controller.setEditMessage(message2);
                menu2.close();
                break;
            }
          },
          children: menu2.visible && /* @__PURE__ */ jsxs(Fragment, { children: [
            menu2.data.canReply && /* @__PURE__ */ jsx$1(Menu.Item, { children: loc.word("Chat.replyMessageMsg", { default: "Reply" }) }, "reply"),
            menu2.data.canEdit && /* @__PURE__ */ jsx$1(Menu.Item, { children: loc.word("Chat.editMessageMsg", { default: "Edit" }) }, "edit"),
            menu2.data.canDelete && /* @__PURE__ */ jsx$1(Menu.Item, { children: /* @__PURE__ */ jsx$1(
              Popconfirm,
              {
                title: loc.word("Chat.deleteMessageConfirmMsg", { default: "Are you sure you want to delete this message?" }),
                trigger: "click",
                onConfirm: () => deleteMessage(),
                children: /* @__PURE__ */ jsx$1("div", { className: "w-100", children: loc.word("Chat.deleteMessage", { default: "Delete" }) })
              }
            ) }, "delete")
          ] })
        }
      ),
      trigger: ["contextMenu"],
      children: children2
    }
  );
};
const Location = ({ location: location2 }) => {
  const loc = useLoc();
  const [url2] = useState$1(`https://maps.google.com?q=@${location2.lat},${location2.lon}`);
  return /* @__PURE__ */ jsx$1("a", { target: "_blank", href: url2, children: loc.word("Chat.locationLabel", { default: "Location" }) });
};
const message$1 = "_message_1xtsh_1";
const message_text = "_message_text_1xtsh_1";
const message_content = "_message_content_1xtsh_6";
const message_avatar = "_message_avatar_1xtsh_16";
const message_add = "_message_add_1xtsh_36";
const message_status = "_message_status_1xtsh_61";
const styles$q = {
  message: message$1,
  message_text,
  message_content,
  message_avatar,
  message_add,
  message_status
};
const reaction = "_reaction_8ossl_1";
const styles$p = {
  reaction
};
const Reaction = ({ reaction: reaction2 }) => {
  return /* @__PURE__ */ jsx$1(Tooltip, { title: () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1("span", { children: reaction2.member?.fullName }),
    /* @__PURE__ */ jsx$1(DateTime, { date: reaction2.createdDate, className: "d-block fs-10" })
  ] }), children: /* @__PURE__ */ jsxs("div", { className: combineClasses("flex align-center gap-3", styles$p.reaction), children: [
    reaction2.emoji,
    reaction2.member && /* @__PURE__ */ jsx$1(UserAvatar$1, { size: 18, user: reaction2.member })
  ] }) });
};
const ReactionPanel = ({ reactions, className }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses("flex align-center gap-5 overflow-auto", className), children: reactions.map((x, i) => /* @__PURE__ */ jsx$1(Reaction, { reaction: x }, i)) });
};
const Audio = ({ src }) => {
  return /* @__PURE__ */ jsx$1("audio", { controls: true, src });
};
const preview_modal = "_preview_modal_1whbz_1";
const styles$o = {
  preview_modal
};
const Image$1 = ({ src, height, width, className, resize, onError, onLoaded }) => {
  const preview = useDrawer$1();
  const hasError = useRef(false);
  const hasLoaded = useRef(false);
  const [resizedSrc] = useState$1(() => {
    if (!resize) return src;
    try {
      const resizedUrl = new URL(src);
      if (resize.h) resizedUrl.searchParams.set("d", `h${resize.h}`);
      else if (resize.w) resizedUrl.searchParams.set("d", `w${resize.w}`);
      return resizedUrl.toString();
      ;
    } catch {
      return src;
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      "img",
      {
        src: resizedSrc,
        height,
        width,
        loading: "lazy",
        onLoad: () => {
          hasLoaded.current = true;
          onLoaded?.();
        },
        onError: () => {
          hasError.current = true;
          onError?.();
        },
        className: combineClasses("c-pointer br-xs", className),
        style: { objectFit: "cover" },
        onClick: () => !hasError.current && hasLoaded.current && preview.open()
      }
    ),
    preview.visible && /* @__PURE__ */ jsx$1(
      Modal,
      {
        className: "p-0",
        open: preview.visible,
        width: 800,
        onOk: () => preview.close(),
        onCancel: () => preview.close(),
        footer: null,
        wrapClassName: styles$o.preview_modal,
        children: /* @__PURE__ */ jsx$1("img", { className: "w-100", src })
      }
    )
  ] });
};
const DefaultFile = ({ attachment, ctx }) => {
  const [downloadble] = useState$1(attachment.channelType == ChatChannelType.Accel || !lodashExports.isEmpty(attachment.url));
  const [src] = useState$1(() => {
    switch (attachment.channelType) {
      case ChatChannelType.Accel:
        return ctx.fileProvider.getUrlByKey(attachment.cloudKey);
      default:
        return attachment.url;
    }
  });
  const download = useCallback(async () => {
    if (attachment.isExternalFile) {
      saveAs(attachment.url, true, attachment.filename);
      return;
    }
    const result = await ctx.fileApi.download(attachment.id);
    if (result.success)
      saveAs(result.body, false, attachment.filename);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-center flex-1 w-100", children: [
    /* @__PURE__ */ jsx$1("div", { style: { width: 130, height: 73 }, className: "text-center", children: attachment.isImage ? /* @__PURE__ */ jsx$1(Image$1, { src, width: "100%", height: "100%", resize: !attachment.isExternalFile ? { w: 200 } : void 0 }) : /* @__PURE__ */ jsx$1(FileIcon, { filename: attachment.extension ?? "-", size: "md" }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1 flex align-center ellipsis gap-10", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex-1 flex flex-col justify-center ml-10 ellipsis", children: [
        /* @__PURE__ */ jsx$1("div", { className: "ellipsis chat-message-file-name", title: attachment.name, children: attachment.name ?? ctx.loc.word("Unnamed") }),
        /* @__PURE__ */ jsx$1("span", { className: "color-secondary chat-message-file-size", children: attachment.size ? Humanize.fileSize(attachment.size) : ctx.loc.word("Chat.noFileSizeLabel", { default: "No size" }) })
      ] }),
      downloadble && /* @__PURE__ */ jsx$1("div", { children: /* @__PURE__ */ jsx$1(Button, { type: "link", icon: /* @__PURE__ */ jsx$1(CloudDownloadOutlined, { className: "chat-message-icon" }), onClick: () => download() }) })
    ] })
  ] });
};
const Video = ({ src, controls, height, width, className, onError, onLoaded }) => {
  return /* @__PURE__ */ jsx$1(
    "video",
    {
      src,
      controls,
      height,
      width,
      onLoad: onLoaded,
      onError,
      className: combineClasses("c-pointer br-xs", className)
    }
  );
};
const Attachment = ({ attachment, className, ctx, onRendered }) => {
  const loc = ctx.loc;
  const renderIgAttachment = useCallback(() => {
    switch (attachment.type) {
      case "audio":
        return /* @__PURE__ */ jsx$1(Audio, { src: attachment.url });
      case "picture":
        return /* @__PURE__ */ jsx$1(Image$1, { src: attachment.url, width: 130, height: 73 });
      case "pictureStoryReply":
      case "pictureStoryMention":
      case "carouselAlbumComment":
      case "pictureComment":
      case "videoComment":
        return /* @__PURE__ */ jsx$1(Image$1, { src: attachment.url, height: 150, width: 84 });
      case "video":
      case "videoStoryReply":
      case "videoStoryMention":
        return /* @__PURE__ */ jsx$1(Video, { controls: true, src: attachment.url, height: 150, width: 84 });
      default:
        return /* @__PURE__ */ jsx$1(DefaultFile, { attachment, ctx });
    }
  }, [attachment]);
  const body = useMemo$2(() => {
    switch (attachment.channelType) {
      case ChatChannelType.Ig:
        return renderIgAttachment();
      default:
        return /* @__PURE__ */ jsx$1(DefaultFile, { attachment, ctx });
    }
  }, [attachment.channelType]);
  return /* @__PURE__ */ jsxs("div", { className: combineClasses("relative flex align-end gap-5", className), children: [
    body,
    attachment.permalink && /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Chat.sourceLink", { default: "Source link" }), children: /* @__PURE__ */ jsx$1("a", { target: "_blank", href: attachment.permalink, rel: "noreferrer", children: /* @__PURE__ */ jsx$1(LinkOutlined, {}) }) })
  ] });
};
const AttachmentList = ({ attachments, className, ctx }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses("flex flex-col gap-5", className), children: attachments.map((x, i) => /* @__PURE__ */ jsx$1(Attachment, { attachment: x, ctx }, i)) });
};
const ReplyAttachment = ({ attachment, ctx }) => {
  const loc = ctx.loc;
  return /* @__PURE__ */ jsx$1(
    ReplyMessage$1,
    {
      canRemove: false,
      title: loc.word(`Chat.replyAttachment.${attachment.channelType}.${attachment.type}`, { default: attachment.type }),
      content: /* @__PURE__ */ jsx$1(AttachmentList, { attachments: [attachment], ctx })
    }
  );
};
const ReplyAttachment$1 = observer(ReplyAttachment);
const ChatButton = ({ button: button2, clickable, onClick: onClick2 }) => {
  const isLink = useMemo$2(() => button2.type == "link" && button2.link, [button2.type, button2.link]);
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: combineClasses("br-xxs bg-white color-black flex align-center justify-between p-10 w-100 no-select chat-message-button c-default", clickable ? "c-pointer hoverable" : void 0),
      target: clickable && isLink ? "_blank" : void 0,
      href: clickable && isLink ? button2.link : void 0,
      style: { minWidth: 300 },
      onClick: () => clickable && onClick2?.(),
      children: [
        /* @__PURE__ */ jsx$1("div", { className: !isLink || clickable ? "hidden" : void 0, children: /* @__PURE__ */ jsx$1(Tooltip, { title: button2.link && /* @__PURE__ */ jsx$1("a", { href: button2.link, target: "_blank", children: button2.link }), children: /* @__PURE__ */ jsx$1(LinkOutlined, {}) }) }),
        /* @__PURE__ */ jsx$1("div", { className: combineClasses("ellipsis", !clickable ? "color-black" : void 0), style: { maxWidth: 200 }, title: button2.title, children: button2.title }),
        /* @__PURE__ */ jsx$1("div", {})
      ]
    }
  );
};
const ButtonsPanel = ({ buttons, className, clickable = false, onButtonClick }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses("flex flex-col align-center gap-8 overflow-auto", className), children: buttons.map((x, i) => /* @__PURE__ */ jsx$1(ChatButton, { button: x, clickable, onClick: () => onButtonClick?.(x) }, i)) });
};
const MessageTextRenderer = ({ method: method4, text: text2, className }) => {
  const body = useMemo$2(() => {
    switch (method4) {
      case "markdown":
        return /* @__PURE__ */ jsx$1(MarkdownText, { text: text2, className });
      case "plain":
      default:
        return /* @__PURE__ */ jsx$1(LinkifyText, { text: text2, className });
    }
  }, [method4, text2, className]);
  return /* @__PURE__ */ jsx$1(Fragment, { children: body });
};
class ButtonClickRequest extends HubRequest {
  constructor(payload) {
    super();
    this.payload = payload;
    this.url = "ButtonClick";
    this.body = [this.payload];
  }
}
const DefaultMessage = ({ message: message2, store: store2, user: user2, ctx, onDeleted, onReplyClick }) => {
  const hub = useChatHub();
  const loc = ctx.loc;
  const [direction] = useState$1(message2.author.userId == user2.id ? "out" : "in");
  const nextMessage = useMemo$2(() => store2.getItem(message2.index + 1), [store2.totalCount]);
  const diffInMins = useMemo$2(() => nextMessage?.createdDate.diff(message2.createdDate, "minutes") ?? 0, [nextMessage]);
  const audioSize = useMemo$2(() => ctx.settings.scaleFactor < 1 ? "small" : ctx.settings.scaleFactor > 1.5 ? "large" : "middle", [ctx.settings.scaleFactor]);
  const buttonClickAllowed = useMemo$2(() => store2.conversation.isAccel && store2.conversation.isSupport && store2.conversation.creatorUserId == ctx.chat.user.id, [store2.conversation.id, ctx.chat.user.id]);
  const handleButtonClick = useDebouncedCallback(async (button2) => {
    if (!buttonClickAllowed)
      return;
    await hub.invoke(new ButtonClickRequest({
      conversationId: store2.conversation.id,
      messageId: message2.id,
      buttonId: button2.scenarioNodePortId
    }));
  }, [message2, store2.conversation, buttonClickAllowed], TimeSpan.fromSeconds(1), { leading: true });
  const isLastInGroup = useMemo$2(() => {
    if (!nextMessage) return message2.index == store2.totalCount - 1;
    if (nextMessage.type == ChatMessageType.System || nextMessage.type == ChatMessageType.ButtonClicked) return true;
    if (nextMessage.authorId != message2.authorId) return true;
    return diffInMins > 5;
  }, [nextMessage]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: combineClasses(styles$q.message, "relative w-100 chat-message", direction == "in" ? "direction-in" : "direction-out"),
      "data-index": message2.index,
      "data-last-in-group": isLastInGroup,
      "data-direction": direction,
      "data-author": message2.authorId,
      "data-status": message2.deleting || message2.sentError || message2.deletedError,
      "data-only-attachment": !message2.hasText && message2.hasAttachments,
      "data-error": message2.hasError,
      "data-audio": message2.type == ChatMessageType.Voice && !message2.deleted,
      children: [
        /* @__PURE__ */ jsx$1(
          MessageContextMenu,
          {
            conversation: store2.conversation,
            message: message2,
            user: user2,
            onDeleted: () => onDeleted(),
            children: /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$q.message_content, "br-xs fs-13 max-w-100 chat-msg-content"), children: [
              /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
                message2.reply && /* @__PURE__ */ jsx$1(
                  ReplyMessage$1,
                  {
                    message: message2.reply,
                    canRemove: false,
                    onClick: () => onReplyClick(message2.reply)
                  }
                ),
                message2.replyAttachment && /* @__PURE__ */ jsx$1(ReplyAttachment$1, { attachment: message2.replyAttachment, ctx }),
                /* @__PURE__ */ jsxs("span", { className: combineClasses(styles$q.message_text, "relative flex align-center chat-msg-text"), children: [
                  message2.deleted ? /* @__PURE__ */ jsx$1(MessageDeletedPlaceholder, { className: "chat-message-text" }) : /* @__PURE__ */ jsx$1(MessageText, { audioSize, user: user2, message: message2, direction, loc }),
                  !message2.deleted && direction == "out" && /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(ChatMessageDeliveryMark$1, { message: message2, targetLastSeenMessageIndex: store2.conversation.targetLastSeenMessageIndex, position: "absolute" }) })
                ] })
              ] }),
              !message2.deleted && /* @__PURE__ */ jsxs(Fragment, { children: [
                message2.hasAttachments && /* @__PURE__ */ jsx$1("div", { className: message2.hasText ? "mt-5" : void 0, children: /* @__PURE__ */ jsx$1(AttachmentList, { attachments: message2.downloadableAttachments, ctx }) }),
                message2.location && /* @__PURE__ */ jsx$1(Location, { location: message2.location })
              ] }),
              message2.hasButtons && /* @__PURE__ */ jsx$1(ButtonsPanel, { buttons: message2.buttons, className: "mt-15 mb-5 chat-msg-buttons", clickable: buttonClickAllowed, onButtonClick: handleButtonClick }),
              message2.hasReactions && /* @__PURE__ */ jsx$1(ReactionPanel, { reactions: message2.reactions, className: "mt-3 chat-msg-reactions" })
            ] })
          }
        ),
        isLastInGroup && /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$q.message_add, "color-secondary relative flex chat-msg-info"), children: [
          direction == "in" && /* @__PURE__ */ jsx$1(UserAvatar$1, { user: message2.author, className: combineClasses("absolute chat-message-avatar", styles$q.message_avatar) }),
          /* @__PURE__ */ jsx$1(DateTime, { date: message2.createdDate, format: "LT", className: "chat-message-date" }),
          direction == "in" && /* @__PURE__ */ jsxs("div", { className: "ellipsis ml-5 fw-700 chat-message-author", children: [
            message2.author.fullName,
            " ",
            message2.author.post && /* @__PURE__ */ jsxs(Fragment, { children: [
              "(",
              message2.author.post,
              ")"
            ] })
          ] })
        ] }),
        (message2.deleting || message2.hasError) && /* @__PURE__ */ jsxs("div", { className: combineClasses("absolute fs-14", styles$q.message_status), children: [
          message2.deleting && /* @__PURE__ */ jsx$1(Tooltip, { title: loc.word("Chat.deletingLabel", { default: "Deleting" }), children: /* @__PURE__ */ jsx$1(LoadingOutlined$3, {}) }),
          message2.hasError && /* @__PURE__ */ jsx$1(Tooltip, { title: message2.sentErrorMessage || message2.deletedErrorMessage, children: /* @__PURE__ */ jsx$1(WarningOutlined, { className: "color-danger" }) })
        ] })
      ]
    }
  );
};
const DefaultMessage$1 = observer(DefaultMessage);
const MessageText = ({ message: message2, direction, loc, audioSize, user: user2, onCallClick }) => {
  switch (message2.type) {
    case ChatMessageType.Normal:
    case ChatMessageType.Comment:
      return message2.hasText ? /* @__PURE__ */ jsx$1(MessageTextRenderer, { method: message2.renderMethod, text: message2.text, className: "pr-15 chat-message-text" }) : null;
    case ChatMessageType.Template:
      return message2.hasText ? user2.isAdmin ? /* @__PURE__ */ jsx$1(
        ReplyMessage$1,
        {
          title: /* @__PURE__ */ jsxs("span", { children: [
            /* @__PURE__ */ jsx$1(Loc, { word: "Global.template", default: "Template" }),
            " ",
            message2.template?.title ?? message2.template?.name
          ] }),
          content: /* @__PURE__ */ jsx$1(MessageTextRenderer, { method: message2.renderMethod, text: message2.text, className: "pr-15 chat-message-text" }),
          canRemove: false
        }
      ) : /* @__PURE__ */ jsx$1(MessageTextRenderer, { method: message2.renderMethod, text: message2.text, className: "pr-15 chat-message-text" }) : null;
    case ChatMessageType.Voice:
      return message2.voice ? /* @__PURE__ */ jsx$1(AudioPlayer, { file: message2.voice, size: audioSize, downloadable: true, className: combineClasses(styles$q.audio_player, "p-8 pt-5 pb-5 bg-gray-4 br-xs flex-1") }) : null;
    case ChatMessageType.CallStarted:
    case ChatMessageType.CallCompleted:
      return /* @__PURE__ */ jsxs("div", { className: "flex align-center c-pointer", onClick: () => onCallClick?.(), children: [
        direction == "in" ? /* @__PURE__ */ jsx$1(MdCallReceived, {}) : /* @__PURE__ */ jsx$1(MdCallMade, {}),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col ml-5", children: [
          direction == "in" ? loc.word("Chat.inCallLabel", { default: "Incoming call" }) : loc.word("Chat.outCallLabel", { default: "Outgoing call" }),
          message2.callDuration && /* @__PURE__ */ jsx$1(Duration, { duration: message2.callDuration, convertDaysToHours: true, className: "color-secondary fs-11" })
        ] }),
        /* @__PURE__ */ jsx$1(PhoneOutlined, { className: "fs-20 ml-10" })
      ] });
    default:
      return null;
  }
};
const DefaultMessagePreview = ({ message: message2, user: user2, ctx }) => {
  const [direction] = useState$1(message2.author.userId == user2.id ? "out" : "in");
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: combineClasses(styles$q.message, "relative w-100 chat-message", direction == "in" ? "direction-in" : "direction-out"),
      "data-index": message2.index,
      "data-last-in-group": true,
      "data-direction": direction,
      "data-author": message2.authorId,
      "data-status": message2.deleting || message2.sentError || message2.deletedError,
      "data-only-attachment": !message2.hasText && message2.hasAttachments,
      "data-error": message2.hasError,
      "data-audio": message2.type == ChatMessageType.Voice,
      children: [
        /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$q.message_content, "br-xs fs-13 max-w-100 chat-msg-content"), children: [
          /* @__PURE__ */ jsx$1("div", { className: "flex flex-col", children: /* @__PURE__ */ jsxs("span", { className: combineClasses(styles$q.message_text, "relative flex align-center chat-msg-text"), children: [
            message2.deleted ? /* @__PURE__ */ jsx$1(MessageDeletedPlaceholder, { className: "chat-message-text" }) : /* @__PURE__ */ jsx$1(MessageText, { audioSize: "middle", user: user2, message: message2, direction, loc: ctx.loc }),
            !message2.deleted && direction == "out" && /* @__PURE__ */ jsx$1(Fragment, { children: /* @__PURE__ */ jsx$1(ChatMessageDeliveryMark$1, { message: message2, targetLastSeenMessageIndex: message2.index, position: "absolute" }) })
          ] }) }),
          !message2.deleted && /* @__PURE__ */ jsxs(Fragment, { children: [
            message2.hasAttachments && /* @__PURE__ */ jsx$1("div", { className: message2.hasText ? "mt-5" : void 0, children: /* @__PURE__ */ jsx$1(AttachmentList, { attachments: message2.downloadableAttachments, ctx }) }),
            message2.location && /* @__PURE__ */ jsx$1(Location, { location: message2.location })
          ] }),
          message2.hasButtons && /* @__PURE__ */ jsx$1(ButtonsPanel, { buttons: message2.buttons, className: "mt-15 mb-5 chat-msg-buttons" }),
          message2.hasReactions && /* @__PURE__ */ jsx$1(ReactionPanel, { reactions: message2.reactions, className: "mt-3 chat-msg-reactions" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$q.message_add, "color-secondary relative flex chat-msg-info"), children: [
          direction == "in" && /* @__PURE__ */ jsx$1(UserAvatar$1, { user: message2.author, className: combineClasses("absolute chat-message-avatar", styles$q.message_avatar) }),
          /* @__PURE__ */ jsx$1(DateTime, { date: message2.createdDate, format: "LT", className: "chat-message-date" }),
          direction == "in" && /* @__PURE__ */ jsxs("div", { className: "ellipsis ml-5 fw-700 chat-message-author", children: [
            message2.author.fullName,
            " ",
            message2.author.post && /* @__PURE__ */ jsxs(Fragment, { children: [
              "(",
              message2.author.post,
              ")"
            ] })
          ] })
        ] })
      ]
    }
  );
};
const chat_scale_slider_tooltip = "_chat_scale_slider_tooltip_1gpfb_1";
const style = {
  chat_scale_slider_tooltip
};
const chat_style = "_chat_style_14uyj_1";
const styles$n = {
  chat_style
};
const ChatStyleProvider = ({ settings, children: children2 }) => {
  const ref2 = useRef(null);
  useLayoutEffect$2(() => {
    const root = ref2.current;
    root?.style.setProperty("--chat-scale", settings.scaleFactor.toString());
  }, [settings.scaleFactor]);
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      ref: ref2,
      className: styles$n.chat_style,
      "data-size-sm": settings.scaleFactor <= 1,
      "data-size-md": settings.scaleFactor >= 1 && settings.scaleFactor < 1.5,
      "data-size-lg": settings.scaleFactor >= 1.5 && settings.scaleFactor < 2,
      "data-size-xl": settings.scaleFactor >= 2,
      children: children2
    }
  );
};
const ChatStyleProvider$1 = observer(ChatStyleProvider);
const ChatScaleSlider = ({ settings, onChange: onChange5 }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex align-center gap-15 w-100", children: [
    /* @__PURE__ */ jsx$1(FontColorsOutlined, { className: "fs-13" }),
    /* @__PURE__ */ jsx$1(
      Slider$1,
      {
        defaultValue: settings.scaleFactorPercent,
        onChange: onChange5,
        min: 75,
        max: 200,
        marks: { 75: "75%", 100: "100%", 150: "150%", 200: "200%" },
        step: 1,
        tooltip: { prefixCls: `${style.chat_scale_slider_tooltip} ant-tooltip`, formatter: (x) => /* @__PURE__ */ jsx$1(ChatScaleSliderPreview, { settings }) },
        className: "flex-1"
      }
    ),
    /* @__PURE__ */ jsx$1(FontColorsOutlined, { className: "fs-30" })
  ] });
};
const ChatScaleSliderPreview = ({ settings }) => {
  const ctx = useContext(ChatContext);
  const [user2] = useState$1(new ChatUser({ id: "test", firstName: "John", lastName: "Doe" }));
  const [message2] = useState$1(new ChatMessage({ id: "test_msg", type: ChatMessageType.Normal, index: 1, author: new ChatMember({ id: "test", firstName: "John", lastName: "Doe", userId: "test1" }), attachments: [], buttons: [], text: "Lorem ipsum dolor sit amet " }));
  return /* @__PURE__ */ jsx$1(ChatStyleProvider$1, { settings, children: /* @__PURE__ */ jsx$1(DefaultMessagePreview, { message: message2, user: user2, ctx }) });
};
const mic_activity = "_mic_activity_l5vor_1";
const indicator = "_indicator_l5vor_9";
const styles$m = {
  mic_activity,
  indicator
};
class MicActivityIndicator extends React__default.Component {
  constructor(props) {
    super(props);
    this.indicatorRef = React__default.createRef();
    this.wrapperClientWidth = 0;
    this.wrapperClientHeight = 0;
    this.max = 50;
    this.rounder = (what, number4) => Math.ceil(what / number4) * number4;
    this.currentSize = 0;
    this.analizeAudio = () => {
      if (!this.analyser)
        return;
      const array4 = new Uint8Array(this.analyser.frequencyBinCount);
      this.analyser.getByteFrequencyData(array4);
      let values = 0;
      const length2 = array4.length;
      for (let i = 0; i < length2; i++) {
        values += array4[i];
      }
      const average = values / length2;
      const levelPercent = average / this.max * 100;
      this.currentSize = this.rounder(levelPercent, 5);
      if (this.currentSize !== this.state.indicatorSize) {
        this.setState({ indicatorSize: this.currentSize });
      }
    };
    this.analyser = null;
    this.javascriptNode = null;
    this.state = {
      indicatorSize: 0
    };
  }
  componentDidMount() {
    this.wrapperClientWidth = this.indicatorRef.current.clientWidth;
    this.wrapperClientHeight = this.indicatorRef.current.clientHeight;
    this.initAnalyzer();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.stream !== prevProps.stream) {
      this.initAnalyzer();
    }
  }
  componentWillUnmount() {
    this.stopAnalizer();
  }
  initAnalyzer() {
    if (!this.props.stream)
      return;
    const audioContext = new AudioContext();
    this.analyser = audioContext.createAnalyser();
    this.analyser.smoothingTimeConstant = 0.3;
    this.analyser.fftSize = 1024;
    const microphone = audioContext.createMediaStreamSource(this.props.stream);
    this.javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);
    microphone.connect(this.analyser);
    this.analyser.connect(this.javascriptNode);
    this.javascriptNode.connect(audioContext.destination);
    this.javascriptNode.onaudioprocess = this.analizeAudio;
  }
  stopAnalizer() {
    if (!this.javascriptNode)
      return;
    this.javascriptNode.onaudioprocess = null;
  }
  render() {
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        ref: this.indicatorRef,
        className: combineClasses(styles$m.mic_activity),
        "data-type": this.props.type,
        style: { width: this.props.width, height: this.props.height },
        children: this.props.type === "horizontal" ? /* @__PURE__ */ jsx$1("div", { className: styles$m.indicator, style: { width: 100 - this.state.indicatorSize + "%", height: "100%" } }) : /* @__PURE__ */ jsx$1("div", { className: styles$m.indicator, style: { width: "100%", height: 100 - this.state.indicatorSize + "%" } })
      }
    );
  }
}
const ChatSettingsForm = () => {
  const loc = useLoc();
  const chat = useChat();
  const srcSettings = useChatSettings();
  const [settings] = useState$1(srcSettings.clone());
  const save = useCallback(() => {
    srcSettings.update(settings);
    notification.success({
      message: loc.word("Chat.settings.save.success", { default: "Settings saved" }),
      duration: 2
    });
    chat.setSettingsVisible(false);
  }, [srcSettings, settings]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "pt-10 pb-10 pl-15 pr-15 flex flex-col gap-20", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-10", children: [
        /* @__PURE__ */ jsx$1("p", { className: "fs-18 mb-5", children: loc.word("Chat.settings.ui", { default: "Interface" }) }),
        /* @__PURE__ */ jsxs("label", { className: "settings-label fw-500", children: [
          /* @__PURE__ */ jsx$1("span", { children: loc.word("Chat.settings.ui.scale", { default: "Scale" }) }),
          /* @__PURE__ */ jsx$1(ChatScaleSlider, { settings, onChange: (x) => settings.scaleFactorPercent = x })
        ] }),
        chat.user.isAdmin && /* @__PURE__ */ jsxs("label", { className: "settings-label fw-500", children: [
          /* @__PURE__ */ jsx$1("span", { children: loc.word("Chat.settings.hideBotMessages", { default: "Hide bot messages" }) }),
          " ",
          /* @__PURE__ */ jsx$1(Switch, { defaultChecked: settings.hideBotMessages, onChange: () => settings.update({ hideBotMessages: !settings.hideBotMessages }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx$1("p", { className: "fs-18 mb-5", children: loc.word("Chat.settings.hardware", { default: "Hardware" }) }),
        /* @__PURE__ */ jsxs("label", { className: "settings-label fw-500", children: [
          /* @__PURE__ */ jsx$1("span", { children: loc.word("Chat.settings.hardware.mic", { default: "Mic" }) }),
          /* @__PURE__ */ jsx$1(MicSettings, { defaultDeviceId: settings.micDeviceId, onDeviceChange: (x) => settings.update({ micDeviceId: x }) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx$1("div", { className: "border-t text-right pt-10 pb-10 pl-15 pr-15", children: /* @__PURE__ */ jsx$1(Button, { type: "primary", onClick: save, children: /* @__PURE__ */ jsx$1(Loc, { word: "Global.save" }) }) })
  ] });
};
const MicSettings = observer(({ defaultDeviceId, onDeviceChange }) => {
  const hardware = useChatHardware();
  useEffect(() => {
    (async () => {
      await hardware.init(defaultDeviceId ?? void 0);
      onDeviceChange?.(hardware.micCurrentDeviceId);
    })();
    return () => {
      hardware.stopMicStream();
    };
  }, []);
  if (!hardware.micInited) return /* @__PURE__ */ jsx$1(Skeleton, { active: true });
  return /* @__PURE__ */ jsx$1("div", { children: hardware.micAccess ? /* @__PURE__ */ jsxs(Fragment, { children: [
    !hardware.deviceList || hardware.deviceList.mics.length == 0 ? /* @__PURE__ */ jsx$1(Loc, { word: "Chat.settings.hardware.mic.notFound", default: "No microphone is found", className: "text-placeholder" }) : /* @__PURE__ */ jsxs(
      Select,
      {
        onChange: (id2) => {
          hardware.changeMicDevice(id2);
          onDeviceChange?.(id2);
        },
        value: hardware.micCurrentDeviceId ?? "",
        className: "w-100",
        children: [
          /* @__PURE__ */ jsx$1(Select.Option, { value: "", children: /* @__PURE__ */ jsx$1(Loc, { word: "Chat.settings.hardware.mic.notChosen", default: "Not chosen" }) }),
          hardware.deviceList.mics.map((x) => /* @__PURE__ */ jsx$1(Select.Option, { value: x.deviceId, children: x.label }, x.deviceId))
        ]
      }
    ),
    hardware.micCurrentStream && /* @__PURE__ */ jsx$1("div", { className: "mt-10", children: /* @__PURE__ */ jsx$1(MicActivityIndicator, { type: "horizontal", width: "100%", height: "30px", stream: hardware.micCurrentStream }) })
  ] }) : /* @__PURE__ */ jsx$1(Loc, { word: "Chat.settings.hardware.mic.noAccess", default: "No microphone access", className: "text-placeholder" }) });
});
const ChatSettingsForm$1 = observer(ChatSettingsForm);
const chat_floating = "_chat_floating_1ovvy_1";
const hidden = "_hidden_1ovvy_13";
const stick_to_top = "_stick_to_top_1ovvy_20";
const settings_visible = "_settings_visible_1ovvy_23";
const styles$l = {
  chat_floating,
  hidden,
  stick_to_top,
  settings_visible
};
const ChatPositionKey = "chat.position";
const ChatFloating = ({ draggable: draggable2, children: children2, handlerRef, defaultPosition, onChangePosition, isMobile, stickToTop }) => {
  const controller = useChat();
  const [position2] = useState$1(localStorage.getJsonOrDefault(ChatPositionKey, defaultPosition));
  const chatFloatingRef = useRef(null);
  const changePosition = useCallback((pos) => {
    localStorage.setJson(ChatPositionKey, pos);
    onChangePosition?.(pos);
  }, [onChangePosition]);
  useEffect(() => {
    if (isMobile && chatFloatingRef.current)
      chatFloatingRef.current.style.height = window.innerHeight + "px";
  }, []);
  return /* @__PURE__ */ jsxs(
    Draggable,
    {
      defaultPosition: position2,
      bounds: "body",
      handler: handlerRef,
      nodeRef: chatFloatingRef,
      onStop: (e, data2) => changePosition(data2.position),
      className: combineClasses(
        "shadow-lg overflow-hidden border f-chat-wrapper",
        styles$l.chat_floating,
        !controller.visible ? styles$l.hidden : void 0,
        stickToTop === true ? styles$l.stick_to_top : void 0,
        controller.settingsVisible ? styles$l.settings_visible : void 0
      ),
      classNameDraggingBounds: "no-select",
      children: [
        /* @__PURE__ */ jsx$1("div", { ref: handlerRef, className: combineClasses("flex align-center justify-center bg-white c-move", !draggable2 ? "d-none" : void 0), children: /* @__PURE__ */ jsx$1(MoreOutlined, { rotate: 90, className: "fs-20 color-secondary" }) }),
        children2
      ]
    }
  );
};
function FaFacebook(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" } }] })(props);
}
function FaInstagram(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 448 512" }, "child": [{ "tag": "path", "attr": { "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" } }] })(props);
}
function FaLine(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 448 512" }, "child": [{ "tag": "path", "attr": { "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z" } }] })(props);
}
function FaTelegram(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 496 512" }, "child": [{ "tag": "path", "attr": { "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z" } }] })(props);
}
function FaViber(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z" } }] })(props);
}
function FaVk(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 576 512" }, "child": [{ "tag": "path", "attr": { "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z" } }] })(props);
}
function FaWhatsapp(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 448 512" }, "child": [{ "tag": "path", "attr": { "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" } }] })(props);
}
const wazzup24 = "_wazzup24_bqut0_1";
const styles$k = {
  wazzup24
};
const ChannelTypeIcon = ({ type: type4, name }) => {
  const title = useMemo$2(() => {
    let title2;
    switch (type4) {
      case ChannelType.VK:
        title2 = "VK";
        break;
      case ChannelType.Facebook:
        title2 = "Facebook";
        break;
      case ChannelType.Instagram:
        title2 = "Instagram";
        break;
      case ChannelType.Telegram:
        title2 = "Telegram";
        break;
      case ChannelType.Viber:
        title2 = "Viber";
        break;
      case ChannelType.WA:
        title2 = "WhatsApp";
        break;
      case ChannelType.Wazzup24:
        title2 = "Wazzup24";
        break;
      case ChannelType.Line:
        title2 = "Line";
        break;
      default:
        return void 0;
    }
    if (name)
      return `${title2} - ${name}`;
    return title2;
  }, [type4, name]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    type4 == ChannelType.VK && /* @__PURE__ */ jsx$1(FaVk, { style: { color: "#4986cc" }, title }),
    type4 == ChannelType.Facebook && /* @__PURE__ */ jsx$1(FaFacebook, { style: { color: "#285296" }, title }),
    type4 == ChannelType.Instagram && /* @__PURE__ */ jsx$1(FaInstagram, { style: { color: "#f0466f" }, title }),
    type4 == ChannelType.Telegram && /* @__PURE__ */ jsx$1(FaTelegram, { style: { color: "#35ace0" }, title }),
    type4 == ChannelType.Viber && /* @__PURE__ */ jsx$1(FaViber, { style: { color: "#9069ae" }, title }),
    type4 == ChannelType.WA && /* @__PURE__ */ jsx$1(FaWhatsapp, { style: { color: "#33bf71" }, title }),
    type4 == ChannelType.Wazzup24 && /* @__PURE__ */ jsx$1("span", { className: styles$k.wazzup24, title, children: "WZ" }),
    type4 == ChannelType.Line && /* @__PURE__ */ jsx$1(FaLine, { style: { color: "#33bf71" }, title })
  ] });
};
const LastMessagePreview = ({ message: message2, targetLastSeenMessageIndex }) => {
  const user2 = useUser();
  const loc = useLoc();
  const author = useMemo$2(() => {
    if (user2.id == message2.author?.userId)
      return loc.word("Chat.youLabel", { default: "You" });
    return null;
  }, []);
  return /* @__PURE__ */ jsxs("span", { className: "fs-16 color-secondary ellipsis flex align-center", children: [
    author && /* @__PURE__ */ jsxs("b", { children: [
      author,
      ": "
    ] }),
    /* @__PURE__ */ jsx$1(ChatMessageContentPreview, { message: message2, targetLastSeenMessageIndex, deliveryMark: true })
  ] });
};
const conversation = "_conversation_w1ovw_1";
const selected = "_selected_w1ovw_8";
const conversation_avatar = "_conversation_avatar_w1ovw_12";
const conversation_body = "_conversation_body_w1ovw_16";
const conversation_date = "_conversation_date_w1ovw_20";
const conversation_type = "_conversation_type_w1ovw_24";
const styles$j = {
  conversation,
  selected,
  conversation_avatar,
  conversation_body,
  conversation_date,
  conversation_type
};
const ConversationItem = ({ conversation: conversation2, isSelected, unreadMessagesVisible, onSelect: onSelect2 }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: combineClasses(
        styles$j.conversation,
        isSelected ? styles$j.selected : void 0,
        "flex align-center justify-start pt-8 pb-8 pl-5 pr-5 bg-white no-select"
      ),
      onClick: () => onSelect2(),
      children: [
        /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$j.conversation_avatar, "relative"), children: [
          conversation2.target ? /* @__PURE__ */ jsx$1(ChatUserOnlineStatusBadge, { onlineStatus: conversation2.target.onlineStatus, children: /* @__PURE__ */ jsx$1(UserAvatar$1, { size: 50, user: conversation2.target }) }) : /* @__PURE__ */ jsx$1(Avatar, { size: 50, icon: /* @__PURE__ */ jsx$1(UserOutlined, {}) }),
          conversation2.channelType != ChannelType.Accel && /* @__PURE__ */ jsx$1(
            "div",
            {
              className: combineClasses(styles$j.conversation_type, "absolute t-0 r-0 bg-white shadow-sm flex align-center justify-center br-full fs-16"),
              style: { border: `3px solid ${conversation2.channelColor}` },
              children: /* @__PURE__ */ jsx$1(ChannelTypeIcon, { type: conversation2.channelType, name: conversation2.title })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$j.conversation_body, "ml-10 flex flex-col justify-center"), children: [
          /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-between", children: [
            /* @__PURE__ */ jsx$1("div", { className: "fs-16 fw-700 ellipsis", children: conversation2.name }),
            conversation2.lastActivityDate && /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$j.conversation_date, "fs-13 color-secondary text-right"), children: /* @__PURE__ */ jsx$1(DateTime, { date: conversation2.lastActivityDate, format: conversation2.lastActivityDate.isSame(moment(), "day") ? "LT" : "ll" }) })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-between", children: [
            conversation2.lastMessage && /* @__PURE__ */ jsx$1(LastMessagePreview, { message: conversation2.lastMessage, targetLastSeenMessageIndex: conversation2.targetLastSeenMessageIndex }),
            unreadMessagesVisible && /* @__PURE__ */ jsx$1(Badge, { count: conversation2.unreadMessageCount })
          ] })
        ] })
      ]
    }
  );
};
const ConversationItem$1 = observer(ConversationItem);
const conversation_placeholder = "_conversation_placeholder_9nvvk_1";
const styles$i = {
  conversation_placeholder
};
const ConversationPlaceholder = () => {
  return /* @__PURE__ */ jsx$1(
    Skeleton,
    {
      avatar: true,
      active: true,
      paragraph: { rows: 1 },
      className: combineClasses(styles$i.conversation_placeholder, "pt-8 pb-8 pl-5 pr-5 flex align-center")
    }
  );
};
const NoContentPlaceholder$1 = () => {
  const loc = useLoc();
  return /* @__PURE__ */ jsx$1("div", { className: "flex align-center justify-center h-100 w-100 color-secondary", children: loc.word("Chat.noConversationsPlaceholder", { default: "No conversations yet" }) });
};
const ConversationList$1 = ({ tab, store: store2, handlerRef, onSelect: onSelect2 }) => {
  const controller = useChat();
  return /* @__PURE__ */ jsx$1(
    InfinityVirtualList$1,
    {
      handlerRef,
      store: store2,
      rowHeight: 70,
      minimumBatchSize: 50,
      noRowsRenderer: () => store2.isInited && store2.totalCount == 0 ? /* @__PURE__ */ jsx$1(NoContentPlaceholder$1, {}) : void 0,
      rowRenderer: ({ item: item2 }) => {
        if (!item2)
          return /* @__PURE__ */ jsx$1(ConversationPlaceholder, {});
        const unreadMessagesVisible = tab == ConversationTab$1.My || tab == ConversationTab$1.New || item2.lastSeenMessageIndex != null;
        return /* @__PURE__ */ jsx$1(ErrorBoundary, { fallback: /* @__PURE__ */ jsx$1(ConversationPlaceholder, {}), children: /* @__PURE__ */ jsx$1(
          ConversationItem$1,
          {
            conversation: item2,
            isSelected: controller.selectedConversationId == item2.id,
            onSelect: () => onSelect2(item2),
            unreadMessagesVisible
          },
          item2.id
        ) });
      }
    }
  );
};
const ConversationList$2 = observer(ConversationList$1);
const search2 = "_search_k7lro_1";
const styles$h = {
  search: search2
};
const ConversationSearchResult = () => {
  const loc = useLoc();
  const controller = useChat();
  const hub = useChatHub();
  const [store2] = useState$1(new ConversationListStore(hub));
  const key = useUniqueKey();
  useMemo$2(() => {
    store2.updateFilter({ search: controller.search });
    store2.forceReset();
    key.update();
  }, [controller.search]);
  return /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$h.search, "absolute bg-white flex flex-col"), children: [
    /* @__PURE__ */ jsx$1("span", { className: "pl-10 pr-10 pb-5 pt-5 fs-13 color-secondary", children: !store2.isInited || store2.isFetching ? /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: "w-100" }) : /* @__PURE__ */ jsxs("span", { children: [
      loc.word("Chat.searchFoundLabel", { default: "Found" }),
      " ",
      /* @__PURE__ */ jsx$1("span", { className: "fw-700", children: store2.filter.itemsTotal }),
      " ",
      loc.wordPlural(
        store2.filter.itemsTotal,
        { one: "Chat.conversation.plural.one", two: "Chat.conversation.plural.two", other: "Chat.conversation.plural.other" },
        { default: { one: "Conversation", two: "Conversations", other: "Conversations" }, case: "lower" }
      )
    ] }) }),
    /* @__PURE__ */ jsx$1("div", { className: "flex-1", children: /* @__PURE__ */ jsx$1(
      ConversationList$2,
      {
        store: store2,
        onSelect: (conversation2) => {
          controller.setConversation(conversation2.id);
        }
      },
      key.key
    ) })
  ] });
};
const ConversationSearchResult$1 = observer(ConversationSearchResult);
const useChatBlocker = (cb, confirm) => {
  const controller = useChat();
  const handler = useCallback((...args) => {
    if (controller.hasBlockingActions) {
      confirm((res) => res === true && cb(...args));
      return;
    }
    cb(...args);
  }, [cb, confirm]);
  return handler;
};
const useChatModalBlocker = (cb) => {
  const loc = useLoc();
  const controller = useChat();
  const recordingCancelRequest = useCallback((resolve) => {
    Modal.confirm({
      content: /* @__PURE__ */ jsx$1("span", { className: "pre-wrap", children: loc.word("Chat.leave.confirmation", { default: "Are you sure you want to leave this page?\nDo you want to stop recording and discard your voice message?" }) }),
      onOk: async () => {
        controller.cancelRecording();
        setTimeout(() => resolve(true), 300);
      },
      onCancel: () => {
        resolve(false);
      }
    });
  }, []);
  return useChatBlocker(cb, recordingCancelRequest);
};
const ConversationTab = ({ tab }) => {
  const hub = useChatHub();
  const controller = useChat();
  const [conversationStore] = useState$1(controller.conversationCache.get(tab));
  const listHandler = useRef(null);
  useEffect(() => {
    const sub = hub.on(new ChatConversationsSubscription(tab), (event) => processEvent(event));
    return () => sub.dispose();
  }, []);
  useEffect(() => {
    const subscriptions = [];
    conversationStore.fetched.on((conversations) => {
      const targetConversations = conversations.filter((x) => x.target != null);
      subscriptions.push(...targetConversations.map((x) => {
        return hub.on(new ChatUserSubscription(x.target.userId), (payload) => {
          x.target.update(payload);
        });
      }));
    });
    return () => subscriptions.forEach((x) => x.dispose());
  }, []);
  const processEvent = useCallback((event) => {
    switch (event.type) {
      case ChatEventType.ConversationCreated:
        const { conversation: conversation2 } = event.payload;
        listHandler.current.insertItem(conversation2, 0);
        break;
      case ChatEventType.ConversationDeleted: {
        const { id: id2 } = event.payload;
        const index2 = conversationStore.items.findIndex((x) => x.id == id2);
        if (index2 == -1) break;
        listHandler.current.deleteItem(index2);
        break;
      }
      case ChatEventType.ConversationUpdated: {
        const p = event.payload;
        const index2 = conversationStore.items.findIndex((x) => x.id == p.conversation.id);
        if (index2 == -1) {
          listHandler.current.insertItem(p.conversation, 0);
        } else {
          const oldItem = conversationStore.getItem(index2);
          const needSwap = oldItem?.lastActivityDate != p.conversation.lastActivityDate;
          oldItem?.update(p.conversation);
          if (needSwap)
            listHandler.current.moveItem(index2, 0);
        }
        break;
      }
      case ChatEventType.ConversationSynced: {
        const p = event.payload;
        const index2 = conversationStore.items.findIndex((x) => x.id == p.id);
        if (index2 == -1) break;
        const oldItem = conversationStore.getItem(index2);
        oldItem?.update({
          lastSeenMessageIndex: p.lastSeenMessageIndex,
          targetLastSeenMessageIndex: p.targetLastSeenMessageIndex
        });
        break;
      }
    }
  }, []);
  const handleSelectConversation = useChatModalBlocker(useCallback((conversation2) => {
    controller.setConversation(conversation2.id);
    listHandler.current?.update();
  }, []));
  return /* @__PURE__ */ jsx$1("div", { className: "flex flex-col h-100", children: /* @__PURE__ */ jsx$1(
    ConversationList$2,
    {
      handlerRef: listHandler,
      store: conversationStore,
      tab,
      onSelect: handleSelectConversation
    }
  ) });
};
const tabs = "_tabs_ehq0w_1";
const styles$g = {
  tabs
};
const ConversationsBody = () => {
  const loc = useLoc();
  const controller = useChat();
  const hasSearch = useMemo$2(() => !isEmpty(controller.search), [controller.search]);
  const hub = useChatHub();
  useEffect(() => {
    const sub = hub.on(new ChatCountersSubscription(), (event) => processEvent(event));
    return () => sub.dispose();
  }, []);
  const processEvent = useCallback((event) => {
    switch (event.type) {
      case ChatEventType.CounterIncreased: {
        const p = event.payload;
        controller.increaseCounter(p.tab, p.id);
        break;
      }
      case ChatEventType.CounterDecreased: {
        const p = event.payload;
        controller.decreaseCounter(p.tab, p.id);
        break;
      }
    }
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "relative h-100", children: [
    hasSearch && /* @__PURE__ */ jsx$1(ConversationSearchResult$1, {}),
    /* @__PURE__ */ jsx$1(
      Access,
      {
        roles: [ChatUserRole.TechSupport],
        allow: /* @__PURE__ */ jsxs(
          Tabs,
          {
            size: "small",
            activeKey: controller.conversationTab,
            onChange: (x) => runInAction(() => controller.conversationTab = x),
            animated: false,
            className: combineClasses(styles$g.tabs, "w-100 h-100"),
            tabBarStyle: { margin: 0 },
            children: [
              /* @__PURE__ */ jsx$1(Tabs.TabPane, { tab: /* @__PURE__ */ jsxs("span", { children: [
                loc.word("Chat.myTabLabel", { default: "My" }),
                " ",
                /* @__PURE__ */ jsx$1(Badge, { count: controller.counters.my.length })
              ] }), children: /* @__PURE__ */ jsx$1(ConversationTab, { tab: ConversationTab$1.My }) }, "my"),
              /* @__PURE__ */ jsx$1(
                Tabs.TabPane,
                {
                  tab: /* @__PURE__ */ jsxs("span", { children: [
                    loc.word("Chat.newTabLabel", { default: "New" }),
                    " ",
                    /* @__PURE__ */ jsx$1(Badge, { count: controller.counters.new.length, style: { backgroundColor: "#faad14" } })
                  ] }),
                  children: /* @__PURE__ */ jsx$1(ConversationTab, { tab: ConversationTab$1.New })
                },
                "new"
              ),
              /* @__PURE__ */ jsx$1(Tabs.TabPane, { tab: loc.word("Chat.openedTabLabel", { default: "Opened" }), children: /* @__PURE__ */ jsx$1(ConversationTab, { tab: ConversationTab$1.Opened }) }, "opened"),
              /* @__PURE__ */ jsx$1(Tabs.TabPane, { tab: loc.word("Chat.closedTabLabel", { default: "Closed" }), children: /* @__PURE__ */ jsx$1(ConversationTab, { tab: ConversationTab$1.Closed }) }, "closed")
            ]
          }
        ),
        deny: /* @__PURE__ */ jsx$1(ConversationTab, { tab: ConversationTab$1.My })
      }
    )
  ] });
};
const ConversationsBody$1 = observer(ConversationsBody);
const chat_header = "_chat_header_15xtm_1";
const styles$f = {
  chat_header
};
const chat_header_btn = "_chat_header_btn_1xzhy_1";
const styles$e = {
  chat_header_btn
};
const ChatHeaderButton = ({ icon: icon2, children: children2, className, tooltip, onClick: onClick2 }) => {
  const btn2 = /* @__PURE__ */ jsx$1(
    Button,
    {
      className: combineClasses(styles$e.chat_header_btn, "flex align-center justify-center fs-16 mr-5 ml-5", className),
      type: "link",
      onClick: (e) => onClick2?.(e),
      icon: icon2,
      children: children2
    }
  );
  if (tooltip)
    return /* @__PURE__ */ jsx$1(Tooltip, { title: tooltip, children: btn2 });
  return btn2;
};
const ChatHeader = ({ handlerRef, children: children2 }) => {
  return /* @__PURE__ */ jsx$1("div", { ref: handlerRef, className: combineClasses("flex justify-between align-center p-10 border-b f-chat-wrapper", styles$f.chat_header), children: children2 });
};
function FiExternalLink(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" } }, { "tag": "polyline", "attr": { "points": "15 3 21 3 21 9" } }, { "tag": "line", "attr": { "x1": "10", "y1": "14", "x2": "21", "y2": "3" } }] })(props);
}
const ConversationsHeader = ({ handlerRef, headerActionsButton }) => {
  const loc = useLoc();
  const controller = useChat();
  const { openFullChat } = useContext(ChatContext);
  const handleAddConversation = useChatModalBlocker(useCallback(() => {
    controller.setNewConversationVisible(true);
  }, []));
  return /* @__PURE__ */ jsxs(ChatHeader, { handlerRef, children: [
    /* @__PURE__ */ jsx$1("div", { className: "flex-1", children: /* @__PURE__ */ jsx$1(
      InputSearch,
      {
        onSearch: (search3) => controller.setSearch(search3),
        size: "small",
        width: "100%"
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "flex", children: [
      /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          className: "chat-header-btn-add",
          icon: /* @__PURE__ */ jsx$1(UserAddOutlined, {}),
          tooltip: loc.word("Chat.addConversationMsg", { default: "Add Conversation" }),
          onClick: handleAddConversation
        }
      ),
      /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          icon: /* @__PURE__ */ jsx$1(SettingOutlined, {}),
          onClick: () => controller.setSettingsVisible(true),
          tooltip: loc.word("Chat.openSettingsMsg", { default: "Open Settings" })
        }
      ),
      controller.mode == "compact" && openFullChat && /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          className: "chat-header-btn-full",
          icon: /* @__PURE__ */ jsx$1(FiExternalLink, {}),
          onClick: () => openFullChat(),
          tooltip: loc.word("Chat.openFullChatMsg", { default: "Open full-size chat" })
        }
      ),
      headerActionsButton,
      controller.mode == "compact" && /* @__PURE__ */ jsx$1(ChatHeaderButton, { className: "chat-header-btn-close", icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}), onClick: () => controller.close() })
    ] })
  ] });
};
const ConversationsHeader$1 = observer(ConversationsHeader);
const conversations_column = "_conversations_column_3sa5u_1";
const styles$d = {
  conversations_column
};
const ConversationsColumn = ({ handlerRef, headerActionsButton }) => {
  return /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$d.conversations_column, "flex flex-col w-100 overflow-hidden"), children: [
    /* @__PURE__ */ jsx$1(ConversationsHeader$1, { handlerRef, headerActionsButton }),
    /* @__PURE__ */ jsx$1(ConversationsBody$1, {})
  ] });
};
class ChatConversationSubscription extends HubSubscription {
  constructor(id2) {
    super();
    this.id = id2;
    this.method = `Conversation ${this.id}`;
    this.processPayload = (e) => {
      console.logDev(this.method, e.type, e.payload);
      return ChatEventFactory.create(e.type, e.payload);
    };
  }
}
class MessageListStore extends InfinityListStore$1 {
  constructor(hub) {
    super();
    this.hub = hub;
    this.hub = hub || inject(this, HubClient);
  }
  get conversation() {
    return this._conversation;
  }
  set conversation(value) {
    this._conversation = value;
    if (value.lastMessage)
      this.setTotalCount(value.lastMessage.index + 1);
    this.updateFilter();
  }
  createFilter(p) {
    return new ChatMessageFilter({ ...this.filter, ...p, conversationId: this.conversation?.id, softDeleted: null });
  }
  async fetchItems(filter2) {
    const result = await this.hub.invokeWithResult(new FetchMessagesRequest(filter2));
    const items = result.payload?.items ?? [];
    items.forEach((x) => x.init(this.conversation));
    return {
      success: result.success,
      items,
      filter: result.payload?.filter ?? filter2
    };
  }
}
const day_splitter = "_day_splitter_1odvm_1";
const day = "_day_1odvm_1";
const styles$c = {
  day_splitter,
  day
};
const DaySplitter = ({ date: date4 }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$c.day_splitter, "flex align-center w-100 pt-10 pb-10 no-select"), children: /* @__PURE__ */ jsx$1(DateTime, { date: date4, calendar: true, className: combineClasses(styles$c.day, "br-md text-center pl-20 pr-20 pt-5 pb-5 chat-message-text") }) });
};
const system_message = "_system_message_bufon_1";
const text = "_text_bufon_14";
const styles$b = {
  system_message,
  text
};
const SystemMessage = ({ message: message2 }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$b.system_message, "flex align-center w-100 pt-10 pb-10 no-select"), children: /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$b.text, "br-xs text-center pl-20 pr-20 pt-5 pb-5 chat-message-system-text"), children: [
    /* @__PURE__ */ jsx$1(DateTime, { date: message2.createdDate, format: "LT", className: "secondary-text" }),
    /* @__PURE__ */ jsx$1("div", { className: "pre-wrap", children: message2.text })
  ] }) });
};
const button_message = "_button_message_ghs13_1";
const button_message__container = "_button_message__container_ghs13_14";
const styles$a = {
  button_message,
  button_message__container
};
const ButtonClickedMessage = ({ message: message2, loc, onReplyClick }) => {
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$a.button_message, "flex align-center w-100 pt-10 pb-10 no-select"), children: /* @__PURE__ */ jsxs("div", { className: combineClasses(styles$a.button_message__container, "p-10 br-xs"), children: [
    message2.reply && /* @__PURE__ */ jsx$1(
      ReplyMessage$1,
      {
        message: message2.reply,
        canRemove: false,
        className: "mb-5",
        onClick: () => onReplyClick(message2.reply)
      }
    ),
    message2.hasButtons && /* @__PURE__ */ jsx$1(ButtonsPanel, { buttons: message2.buttons, clickable: false, className: "mb-5" }),
    /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-between secondary-text fs-11", children: [
      /* @__PURE__ */ jsx$1(DateTime, { date: message2.createdDate, format: "LT" }),
      /* @__PURE__ */ jsx$1("span", { children: loc.word("Chat.message.type.buttonClicked", { default: "Button click" }) })
    ] })
  ] }) });
};
const message = "_message_a2zgb_1";
const styles$9 = {
  message
};
const Message = (props) => {
  const { message: message2, store: store2, ctx, onReplyClick } = props;
  const prevMessage = useMemo$2(() => store2.getItem(message2.index - 1), [store2.totalCount]);
  const prevMessageSameDay = useMemo$2(() => prevMessage?.createdDate.isSame(message2.createdDate, "d"), [prevMessage]);
  const [isFirstMessage] = useState$1(message2.index == 0);
  const renderMsgBody = () => {
    switch (message2.type) {
      case ChatMessageType.System:
        return /* @__PURE__ */ jsx$1(SystemMessage, { message: message2 });
      case ChatMessageType.ButtonClicked:
        return /* @__PURE__ */ jsx$1(ButtonClickedMessage, { message: message2, loc: ctx.loc, onReplyClick });
      default:
        return /* @__PURE__ */ jsx$1(DefaultMessage$1, { ...props });
    }
  };
  useEffect(() => {
    props.onRendered?.();
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    (prevMessage || isFirstMessage) && !prevMessageSameDay && /* @__PURE__ */ jsx$1(DaySplitter, { date: message2.createdDate }),
    /* @__PURE__ */ jsx$1("div", { className: combineClasses(styles$9.message, "relative"), "data-type": message2.type, "data-highlighted": props.isHighlighted, children: renderMsgBody() })
  ] });
};
const Message$1 = observer(Message);
const NoContentPlaceholder = () => {
  const loc = useLoc();
  return /* @__PURE__ */ jsx$1("div", { className: "flex align-center justify-center h-100 w-100 color-secondary chat-message-text", children: loc.word("Chat.noMessagesPlaceholder", { default: "No messages yet" }) });
};
const btn = "_btn_14qnk_1";
const styles$8 = {
  btn
};
const ScrollToBottomButton = ({ conversation: conversation2, handlerRef }) => {
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: combineClasses(styles$8.btn, "absolute br-sm bg-white shadow color-primary flex align-center justify-center fs-16 c-pointer border"),
      onClick: () => handlerRef.current.scrollTo(conversation2.lastMessage.index),
      children: /* @__PURE__ */ jsx$1(DownOutlined, {})
    }
  );
};
const ScrollToBottomButton$1 = observer(ScrollToBottomButton);
const MessageList = ({ store: store2, handlerRef, onSync, onScroll: onScroll6 }) => {
  const ctx = useContext(ChatContext);
  const { chat, settings } = ctx;
  const user2 = chat.user;
  const hideBotMessagesRef = useRef(settings.hideBotMessages);
  const onRowsRendered3 = useCallback(lodashExports.debounce((index2) => {
    const member = store2.conversation.memberMapByUserId.get(user2.id);
    if (!member) return;
    if (store2.conversation.lastSeenMessageIndex == null || index2 > store2.conversation.lastSeenMessageIndex)
      onSync(index2);
  }, 500), [onSync]);
  const [highlightedMessageIndex, setHighlightedMessageIndex] = useState$1(null);
  const highlightTimer = useTimer();
  const highlightMessage = useCallback((index2) => {
    highlightTimer.clear();
    setHighlightedMessageIndex(index2);
    highlightTimer.set(() => {
      setHighlightedMessageIndex(null);
    }, TimeSpan.fromSeconds(2));
  }, []);
  const [scrollOffset, setScrollOffset] = useState$1(0);
  const callUser = useCallback(async () => {
    if (!user2.hasRoles(ChatUserRole.Admin) || !user2.hasRoles(ChatUserRole.TechSupport))
      return;
    const target = store2.conversation.target;
    await chat.phone?.callUser(
      target.internalNumber,
      target.fullName || "",
      false,
      store2.conversation.id
    );
  }, []);
  useEffect(() => {
    if (chat.visible) {
      handlerRef.current?.scrollTo(store2.conversation.scrollToIndex);
    }
  }, [chat.visible]);
  useEffect(() => {
    setTimeout(() => handlerRef.current?.update(true), 0);
  }, []);
  useEffect(() => {
    if (hideBotMessagesRef.current === settings.hideBotMessages) return;
    hideBotMessagesRef.current = settings.hideBotMessages;
    setTimeout(() => handlerRef.current?.update(true), 0);
  }, [settings.hideBotMessages]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      InfinityVirtualList$1,
      {
        handlerRef,
        store: store2,
        defaultScrollToIndex: store2.conversation.scrollToIndex,
        scrollToAlignment: "auto",
        autoFetch: true,
        defaultRowHeight: 1,
        minimumBatchSize: 50,
        overscanRowCount: 30,
        threshold: 100,
        noRowsRenderer: () => store2.isInited && store2.totalCount == 0 ? /* @__PURE__ */ jsx$1(NoContentPlaceholder, {}) : /* @__PURE__ */ jsx$1(Skeleton, { active: true, paragraph: { rows: 0 }, avatar: true, className: "pt-5" }),
        rowRenderer: ({ item: item2, onRendered }) => {
          if (!item2 || hideBotMessagesRef.current && item2.isMessageFromSystemMember) return null;
          return /* @__PURE__ */ jsx$1(
            Message$1,
            {
              message: item2,
              store: store2,
              user: user2,
              ctx,
              isHighlighted: highlightedMessageIndex == item2.index,
              onDeleted: () => {
                handlerRef.current?.update(true);
              },
              onReplyClick: (msg) => {
                highlightMessage(msg.index);
                handlerRef.current?.scrollTo(msg.index);
              },
              onCallClick: callUser,
              onRendered
            },
            item2.id
          );
        },
        onRowsRendered: (x) => {
          onRowsRendered3(x.stopIndex);
        },
        onScroll: (x) => {
          setScrollOffset(x.offsetHeight);
          onScroll6(x);
        },
        initialLoader: /* @__PURE__ */ jsx$1(LoadingOverlay, {})
      }
    ),
    scrollOffset > 100 && /* @__PURE__ */ jsx$1(
      ScrollToBottomButton$1,
      {
        handlerRef,
        conversation: store2.conversation
      }
    )
  ] });
};
const MessageList$1 = observer(MessageList);
const EditMessageForm = ({ message: _message, messageSettings, onSend, onRemove }) => {
  const loc = useLoc();
  const device = useDevice();
  const formRef = useRef(void 0);
  const settings = useChatSettings();
  const sendMessage2 = useCallback(async (text2, files) => {
    if (formRef.current?.hasUploadingFiles()) {
      message$2.warning({ content: loc.word("Chat.filesUploadingError", { default: "Wait for the files to finish uploading or delete failed uploads" }) });
      return false;
    }
    return await onSend(text2, files);
  }, [onSend]);
  const fileSize = useMemo$2(() => {
    return settings.scaleFactor < 1 ? "sm" : settings.scaleFactor <= 1.5 ? "md" : settings.scaleFactor < 2 ? "lg" : "xl";
  }, [settings.scaleFactor]);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx$1(
      ReplyMessage$1,
      {
        message: _message,
        title: loc.word("Chat.editingMessageTitle", { default: "Editing" }),
        onRemove: () => onRemove(),
        className: "pl-11 pr-11 pt-4 pb-4"
      }
    ),
    /* @__PURE__ */ jsx$1(
      CommentFormEditor,
      {
        handlerRef: formRef,
        defaultFiles: _message.attachments,
        defaultText: _message.text,
        onSend: async (text2, files) => sendMessage2(text2, files),
        placeholder: loc.word("Chat.enterMessageMsg", { default: "Enter your message" }),
        useEmoji: device.deviceSize == "desktop",
        useFiles: true,
        fileProps: {
          draggable: true,
          view: "list",
          size: fileSize,
          maxFileSize: messageSettings.maxFileSize,
          forbiddenExtensions: messageSettings.forbiddenFileExtensions
        },
        autoSize: { maxRows: 3, minRows: 2 },
        className: "w-100",
        borderless: true,
        autoFocus: true,
        maxLength: messageSettings.maxLength
      }
    )
  ] });
};
const comment_form = "_comment_form_1v5yt_1";
const styles$7 = {
  comment_form
};
const MessageForm = ({ conversation: conversation2, placeholder, onSent, onUpdated }) => {
  const loc = useLoc();
  const device = useDevice();
  const settings = useChatSettings();
  const hub = useChatHub();
  const controller = useChat();
  const user2 = useUser();
  const { messageFormProps } = useContext(ChatContext);
  const formRef = useRef(void 0);
  const audioSize = useMemo$2(() => settings.scaleFactor < 1 ? "small" : settings.scaleFactor > 1.5 ? "large" : "middle", [settings.scaleFactor]);
  useEffect(() => {
    const sub = controller.recordingCancelled.on(() => {
      formRef.current?.cancelVoiceRecording();
    });
    return () => sub.dispose();
  }, []);
  const sendMessage2 = useCallback(async (text2, files) => {
    if (formRef.current?.hasUploadingFiles()) {
      message$2.warning({ content: loc.word("Chat.filesUploadingError", { default: "Wait for the files to finish uploading or delete failed uploads" }) });
      return false;
    }
    const isVoice = files.some((x) => x.isAudio);
    const result = await hub.invokeWithResult(new SendMessageRequest({
      conversationId: conversation2.id,
      date: moment(),
      isDraft: false,
      // hotfix to prevent sending empty messages
      text: !isEmpty(text2) ? text2 : void 0,
      replyId: controller.replyMessage?.id,
      fileIds: files.map((x) => x.id),
      type: isVoice ? ChatMessageType.Voice : ChatMessageType.Normal
    }));
    if (result.success) {
      controller.setReplyMessage(null);
      result.payload.messages.forEach((x) => x.init(conversation2));
      onSent(result.payload.member, result.payload.messages);
      return true;
    }
    if (result.errors.length > 0) {
      result.errors.forEach((e) => notification.error({ duration: 2, message: e.message ?? loc.word(`Error${ErrorCode[e.code]}`) }));
      return false;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
    return false;
  }, []);
  const updateMessage = useCallback(async (msg, text2, files) => {
    const updatedDate = moment();
    const result = await hub.invoke(new UpdateMessageRequest({
      id: msg.id,
      date: updatedDate,
      isDraft: msg.isDraft,
      text: text2,
      fileIds: files.map((x) => x.id)
    }));
    if (result.success) {
      msg.update({
        updatedDate,
        text: text2,
        attachments: files.map((x) => new ChatMessageAttachment({ ...x, channelType: ChatChannelType.Accel })),
        hasAttachments: files.length > 0
      });
      controller.setEditMessage(null);
      onUpdated(msg);
      return true;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
    return false;
  }, []);
  const sendTyping = useCallback(lodashExports.debounce(async () => {
    const member = conversation2.memberMapByUserId.get(user2.id);
    if (!member) return;
    await hub.invoke(new MemberTypingRequest(conversation2.id, member.id));
  }, 1e3, { leading: true, maxWait: 2e3 }), []);
  useReaction(
    () => controller.replyMessage,
    () => {
      formRef.current?.focus();
    }
  );
  useReaction(
    () => controller.visible,
    (visible) => {
      visible && formRef.current?.focus();
    }
  );
  const fileSize = useMemo$2(() => {
    return settings.scaleFactor < 1 ? "sm" : settings.scaleFactor <= 1.5 ? "md" : settings.scaleFactor < 2 ? "lg" : "xl";
  }, [settings.scaleFactor]);
  const handleRecordingStarted = useCallback(() => {
    controller.setIsVoiceRecording(true);
  }, []);
  const handleRecordingEnded = useCallback(() => {
    controller.setIsVoiceRecording(false);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "w-100 relative flex flex-col border-t", children: [
    controller.editMessage && /* @__PURE__ */ jsx$1(
      EditMessageForm,
      {
        message: controller.editMessage,
        messageSettings: conversation2.messageSettings,
        onRemove: () => {
          controller.setEditMessage(null);
          formRef.current?.focus();
        },
        onSend: async (text2, files) => updateMessage(controller.editMessage, text2, files)
      },
      controller.editMessage.id
    ),
    /* @__PURE__ */ jsxs("div", { className: combineClasses("w-100", controller.editMessage ? "d-none" : void 0), children: [
      controller.replyMessage && /* @__PURE__ */ jsx$1(
        ReplyMessage$1,
        {
          message: controller.replyMessage,
          onRemove: () => controller.setReplyMessage(null),
          className: "pl-11 pr-11 pt-4 pb-4"
        },
        controller.replyMessage.id
      ),
      /* @__PURE__ */ jsx$1(
        CommentFormEditor,
        {
          handlerRef: formRef,
          onSend: sendMessage2,
          placeholder: placeholder ?? loc.word("Chat.enterMessageMsg", { default: "Enter your message" }),
          clearAfterSending: true,
          useEmoji: device.deviceSize == "desktop",
          useFiles: true,
          useVoice: true,
          audioPlayerSize: audioSize,
          fileProps: {
            draggable: true,
            view: "list",
            size: fileSize,
            maxFileSize: conversation2.messageSettings.maxFileSize,
            forbiddenExtensions: conversation2.messageSettings.forbiddenFileExtensions
          },
          autoSize: { maxRows: 5, minRows: 1 },
          className: combineClasses("w-100 pl-18 pr-18", styles$7.comment_form),
          inputClassName: "chat-message-text",
          iconClassname: "chat-message-icon",
          borderless: true,
          autoFocus: controller.visible,
          onTextChange: () => sendTyping(),
          maxLength: conversation2.messageSettings.maxLength,
          micDeviceId: settings.micDeviceId ?? void 0,
          onVoiceRecordingStarted: handleRecordingStarted,
          onVoiceRecordingEnded: handleRecordingEnded,
          onVoiceRecordingCanceled: handleRecordingEnded,
          ...messageFormProps
        }
      )
    ] })
  ] });
};
const MessageForm$1 = observer(MessageForm);
const ConversationBody = ({ conversation: conversation2 }) => {
  const loc = useLoc();
  const hub = useChatHub();
  const [store2] = useState$1(new MessageListStore(hub));
  const listHandler = useRef(null);
  const user2 = useUser();
  const controller = useChat();
  const isScrolledToBottom = useRef(true);
  const settings = useChatSettings();
  useMemo$2(() => {
    if (conversation2) {
      store2.conversation = conversation2;
      isScrolledToBottom.current = conversation2.lastMessage?.index == conversation2.lastSeenMessageIndex;
    }
  }, [conversation2]);
  useEffect(() => {
    if (!conversation2) return;
    const sub = hub.on(new ChatConversationSubscription(conversation2.id), (event) => processEvent(event));
    return () => sub.dispose();
  }, [conversation2]);
  useEffect(() => {
    if (!conversation2 || !conversation2.target) return;
    const sub = hub.on(new ChatUserSubscription(conversation2.target.userId), (payload) => {
      conversation2.target.update(payload);
    });
    return () => sub.dispose();
  }, [conversation2]);
  useEffect(() => {
    if (!controller.visible) return;
    setTimeout(() => {
      listHandler.current?.update(true);
    }, 50);
  }, [controller.size, controller.visible, settings.scaleFactor]);
  const processEvent = useCallback((event) => {
    switch (event.type) {
      case ChatEventType.MessageSent: {
        const { member, messages: messages2 } = event.payload;
        pushMessages(member, messages2);
        break;
      }
      case ChatEventType.MessageUpdated: {
        const { message: message2 } = event.payload;
        if (!store2.isRowLoaded(message2.index)) break;
        const oldMsg = store2.getItem(message2.index);
        oldMsg.update({
          updatedDate: message2.updatedDate,
          text: message2.text,
          plainText: message2.plainText,
          attachments: message2.attachments,
          location: message2.location,
          hasAttachments: message2.attachments.length > 0,
          hasReactions: message2.reactions.length > 0,
          reactions: message2.reactions,
          hasLocation: message2.hasLocation,
          sent: message2.sent,
          sentError: message2.sentError,
          sentErrorMessage: message2.sentErrorMessage,
          deleted: message2.deleted,
          deleting: message2.deleting,
          deletedError: message2.deletedError,
          deletedErrorMessage: message2.deletedErrorMessage
        });
        if (conversation2) oldMsg.init(conversation2);
        listHandler.current?.update(true);
        break;
      }
      case ChatEventType.MessageDeleted: {
        const { index: index2 } = event.payload;
        const oldMsg = store2.getItem(index2);
        oldMsg.update({
          softDeleted: true,
          deleting: false,
          deleted: true
        });
        listHandler.current?.update(true);
        break;
      }
      case ChatEventType.MemberAdded: {
        const { member } = event.payload;
        conversation2.addMember(member);
        break;
      }
      case ChatEventType.MemberDeleted: {
        const { id: id2 } = event.payload;
        conversation2.removeMember(id2);
        break;
      }
      case ChatEventType.MemberUpdated: {
        const { id: id2, ...rest } = event.payload;
        const m = conversation2.memberMap.get(id2);
        if (!m) break;
        m.update(rest);
        break;
      }
      case ChatEventType.MemberTyping: {
        const { memberId: id2 } = event.payload;
        conversation2.addTypingMember(id2);
        break;
      }
      case ChatEventType.ConversationUpdated: {
        const payloadConversation = event.payload?.conversation;
        if (payloadConversation)
          conversation2.update({
            creatorUnsubscribed: payloadConversation.creatorUnsubscribed,
            creatorUnsubscribedReason: payloadConversation.creatorUnsubscribedReason,
            creatorLastActivityDate: payloadConversation.creatorLastActivityDate,
            readonly: payloadConversation.readonly
          });
        break;
      }
      case ChatEventType.ConversationSynced: {
        const { lastSeenMessageIndex, targetLastSeenMessageIndex } = event.payload;
        conversation2.update({
          lastSeenMessageIndex,
          targetLastSeenMessageIndex
        });
        break;
      }
    }
  }, [conversation2]);
  const syncConversation = useCallback(async (index2) => {
    if (!controller.visible) return;
    const result = await hub.invoke(new SyncConversationRequest(store2.conversation.id, index2));
    if (result.success) {
      store2.conversation.update({ lastSeenMessageIndex: index2 });
      return;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
  }, []);
  const pushMessages = useCallback((member, messages2) => {
    store2.conversation.addMember(member);
    for (const msg of messages2) {
      msg.init(store2.conversation);
      listHandler.current?.insertItem(msg, msg.index);
      listHandler.current?.recalcItem(msg.index - 1);
    }
    const isYou = member.userId == user2.id;
    const lastMessage = messages2[messages2.length - 1];
    store2.conversation.update({
      lastMessage,
      lastSeenMessageIndex: isYou ? lastMessage.index : void 0
    });
    if (isYou || isScrolledToBottom.current == true && controller.visible)
      listHandler.current?.scrollTo(lastMessage.index);
    else
      listHandler.current?.update();
  }, []);
  const isWaWz = useMemo$2(() => store2.conversation && (store2.conversation.isWZ || store2.conversation.isWA), [store2.conversation]);
  const canSendMessage = useMemo$2(() => {
    return store2.conversation && !store2.conversation.readonly && (isWaWz || !store2.conversation.isResponseTimeLimitExceeded);
  }, [store2.conversation, store2.conversation?.readonly, store2.conversation?.isResponseTimeLimitExceeded, isWaWz]);
  if (!conversation2) return null;
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col flex-1 h-100 overflow-hidden relative ", children: [
    /* @__PURE__ */ jsx$1("div", { className: "h-100 pl-5 pr-5 relative chat-conversation-wrapper", children: conversation2 && controller.visible && /* @__PURE__ */ jsx$1(
      MessageList$1,
      {
        store: store2,
        handlerRef: listHandler,
        onSync: syncConversation,
        onScroll: (x) => isScrolledToBottom.current = x.offsetHeight.inBetween(-1, 1)
      }
    ) }),
    canSendMessage ? /* @__PURE__ */ jsx$1(
      MessageForm$1,
      {
        conversation: store2.conversation,
        placeholder: isWaWz && store2.conversation.isResponseTimeLimitExceeded ? loc.word("Chat.wa.responseTimeLimitExceeded", { default: "You can only send messages using a WhatsApp templates" }) : void 0,
        onSent: (member, messages2) => pushMessages(member, messages2),
        onUpdated: (message2) => listHandler.current?.update(true)
      }
    ) : /* @__PURE__ */ jsx$1("div", { className: "w-100 relative flex flex-col border-t text-center p-5 secondary-text fw-500 chat-msg-form-wrapper chat-message-text", children: store2.conversation.creatorUnsubscribed ? /* @__PURE__ */ jsxs("span", { children: [
      /* @__PURE__ */ jsx$1(Loc, { word: "Chat.creatorUnsubscribedMsg", default: "User unsubscribed from chat" }),
      " ",
      store2.conversation.creatorUnsubscribedReason && /* @__PURE__ */ jsx$1(HelpText, { tooltip: true, label: store2.conversation.creatorUnsubscribedReason })
    ] }) : store2.conversation.isResponseTimeLimitExceeded ? /* @__PURE__ */ jsx$1(Loc, { word: "ErrorChatChannelResponseTimeLimitExceeded", default: "Response time limit exceeded" }) : /* @__PURE__ */ jsx$1(Loc, { word: "Chat.unavailableMsg", default: "Chat unavailable" }) })
  ] });
};
const ConversationBody$1 = observer(ConversationBody);
const MemberTyping = ({ members }) => {
  const loc = useLoc();
  if (members.length == 0) return null;
  return /* @__PURE__ */ jsxs("span", { className: "flex align-center color-secondary fs-12", children: [
    members.length > 3 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      members.length,
      " ",
      loc.wordPlural(
        members.length,
        { one: "Chat.plural.one", two: "Chat.plural.two", other: "Contact.plural.other" },
        { case: "lower", default: { one: "contact", two: "contacts", other: "contacts" } }
      )
    ] }) : /* @__PURE__ */ jsx$1(SpaceSeparator, { separator: "comma", children: members.map((x) => /* @__PURE__ */ jsx$1("span", { children: x.fullName }, x.id)) }),
    " ",
    members.length < 2 ? loc.word("Chat.typing", { default: "Is typing", case: "lower" }) : loc.word("Chat.typing2", { default: "Are typing", case: "lower" })
  ] });
};
const ConversationMenu = ({ conversation: conversation2 }) => {
  const loc = useLoc();
  const user2 = useUser();
  const controller = useChat();
  const hub = useChatHub();
  const settings = useChatSettings();
  const getState = useCallback(() => {
    const member = conversation2.memberMapByUserId.get(user2.id);
    return {
      canClose: conversation2.state != ChatConversationState.Closed && conversation2.type == ConversationType.Support && user2.hasRoles(ChatUserRole.TechSupport),
      canJoin: !member || !member.isActive,
      canLeave: member && member.isActive
    };
  }, []);
  const closeConversation = useCallback(async () => {
    const result = await hub.invoke(new UpdateConversationRequest({
      id: conversation2.id,
      state: ConversationState.Closed
    }));
    if (!result.success) {
      notification.error({ message: loc.word("Error occured"), duration: 2 });
    }
  }, []);
  const leaveConversation = useCallback(async () => {
    const result = await hub.invoke(new LeaveConversationRequest({
      id: conversation2.id
    }));
    if (!result.success) {
      notification.error({ message: loc.word("Error occured"), duration: 2 });
    }
  }, []);
  const joinConversation = useCallback(async () => {
    const result = await hub.invoke(new JoinConversationRequest({
      id: conversation2.id
    }));
    if (!result.success) {
      notification.error({ message: loc.word("Error occured"), duration: 2 });
    }
  }, []);
  const hideBotMessages = useCallback(async () => {
    settings.update({ hideBotMessages: !settings.hideBotMessages });
  }, []);
  return /* @__PURE__ */ jsx$1(
    Dropdown,
    {
      trigger: ["click"],
      overlay: () => {
        const state = getState();
        return /* @__PURE__ */ jsxs(Menu, { children: [
          !controller.infoVisible && /* @__PURE__ */ jsx$1(
            Menu.Item,
            {
              icon: /* @__PURE__ */ jsx$1(InfoCircleOutlined, {}),
              onClick: () => controller.setInfoVisible(true),
              children: loc.word("Chat.viewProfileInfoMsg", { default: "View Profile Info" })
            },
            "info"
          ),
          state.canClose && /* @__PURE__ */ jsx$1(
            Menu.Item,
            {
              icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}),
              onClick: () => closeConversation(),
              children: loc.word("Chat.closeConversationMsg", { default: "Close conversation" })
            },
            "close"
          ),
          state.canJoin && /* @__PURE__ */ jsx$1(
            Menu.Item,
            {
              icon: /* @__PURE__ */ jsx$1(UserAddOutlined, {}),
              onClick: () => joinConversation(),
              children: loc.word("Chat.joinConversationMsg", { default: "Join" })
            },
            "join"
          ),
          state.canLeave && /* @__PURE__ */ jsx$1(
            Menu.Item,
            {
              icon: /* @__PURE__ */ jsx$1(UserDeleteOutlined, {}),
              onClick: () => leaveConversation(),
              children: loc.word("Chat.leaveConversationMsg", { default: "Leave" })
            },
            "leave"
          ),
          /* @__PURE__ */ jsx$1(
            Menu.Item,
            {
              icon: /* @__PURE__ */ jsx$1(RobotOutlined, {}),
              onClick: hideBotMessages,
              children: /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-between", children: [
                loc.word("Chat.settings.hideBotMessages", { default: "Hide bot messages" }),
                " ",
                /* @__PURE__ */ jsx$1(Switch, { size: "small", checked: settings.hideBotMessages })
              ] })
            },
            "hideBotMessages"
          )
        ] });
      },
      children: /* @__PURE__ */ jsx$1(EllipsisOutlined, { rotate: 90, className: "color-secondary" })
    }
  );
};
const title_placeholder$1 = "_title_placeholder_tclk3_1";
const subtitle_placeholder$1 = "_subtitle_placeholder_tclk3_2";
const styles$6 = {
  title_placeholder: title_placeholder$1,
  subtitle_placeholder: subtitle_placeholder$1
};
const ConversationHeaderPlaceholder$1 = () => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: styles$6.title_placeholder }),
    /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: styles$6.subtitle_placeholder })
  ] });
};
const ConversationHeader = ({ conversation: conversation2, onClose }) => {
  const loc = useLoc();
  const user2 = useUser();
  const controller = useChat();
  const renderConversationName = useCallback((conversation22) => {
    const target = conversation22.target;
    if (!user2.hasRoles(ChatUserRole.Admin) || !target || target.type != UserType.Admin && target.type != UserType.Student) {
      return /* @__PURE__ */ jsx$1("span", { title: conversation22.name, children: conversation22.name });
    }
    if (target.type == UserType.Admin) {
      return /* @__PURE__ */ jsx$1(
        "a",
        {
          target: "_blank",
          href: `/settings/team/${target.adminId}`,
          title: conversation22.name,
          children: conversation22.name
        }
      );
    }
    return /* @__PURE__ */ jsx$1(
      "a",
      {
        target: "_blank",
        href: `/crm/contacts/${target.studentId}/info`,
        title: conversation22.name,
        children: conversation22.name
      }
    );
  }, []);
  const closeConversation = useChatModalBlocker(useCallback(() => {
    controller.close();
  }, []));
  return /* @__PURE__ */ jsxs(ChatHeader, { children: [
    controller.mode == "compact" && /* @__PURE__ */ jsx$1(Button, { type: "text", icon: /* @__PURE__ */ jsx$1(LeftOutlined, {}), onClick: onClose }),
    /* @__PURE__ */ jsx$1("div", { className: "flex flex-col flex-1 w-100", children: conversation2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "fs-16 fw-400 lh-20 flex align-center gap-5 flex-ellipsis", children: [
        /* @__PURE__ */ jsx$1(ChannelTypeIcon, { type: conversation2.channelType, name: conversation2.title }),
        /* @__PURE__ */ jsxs("div", { className: "flex align-center", children: [
          /* @__PURE__ */ jsx$1("div", { className: `ellipsis ${controller.mode == "compact" ? "max-w-250px" : ""}`, children: renderConversationName(conversation2) }),
          conversation2.hasUserNameOrId && /* @__PURE__ */ jsx$1("div", { className: "ml-5 fs-14 lh-18 color-secondary ellipsis max-w-150px", children: /* @__PURE__ */ jsx$1(HelpText, { tooltipProps: { trigger: "click" }, tooltip: true, label: /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
            conversation2.userName && /* @__PURE__ */ jsx$1("span", { children: conversation2.userName }),
            conversation2.userChannelId && /* @__PURE__ */ jsx$1("span", { children: conversation2.userChannelId })
          ] }) }) })
        ] })
      ] }),
      conversation2.memberTyping.length > 0 ? /* @__PURE__ */ jsx$1(MemberTyping, { members: conversation2.memberTyping }) : /* @__PURE__ */ jsx$1(Fragment, { children: conversation2.target && /* @__PURE__ */ jsx$1(
        Badge,
        {
          color: conversation2.target.onlineStatus == UserOnlineStatus.Online ? "green" : "red",
          text: /* @__PURE__ */ jsx$1("span", { className: "color-secondary fs-12", children: loc.word(`Chat.onlineStatus.${conversation2.target.onlineStatus}`, { default: conversation2.target.onlineStatus, case: "lower" }) })
        }
      ) })
    ] }) : /* @__PURE__ */ jsx$1(ConversationHeaderPlaceholder$1, {}) }),
    /* @__PURE__ */ jsx$1("div", { children: conversation2 && /* @__PURE__ */ jsxs(Space, { className: "fs-18", align: "center", children: [
      /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          icon: /* @__PURE__ */ jsx$1(BotMessagesHiddenTooltip, { children: /* @__PURE__ */ jsx$1(SettingOutlined, {}) }),
          onClick: () => controller.setSettingsVisible(true),
          tooltip: loc.word("Chat.openSettingsMsg", { default: "Open Settings" })
        }
      ),
      controller.mode != "compact" && /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          className: "chat-header-btn-info",
          icon: /* @__PURE__ */ jsx$1(BsReverseLayoutSidebarInsetReverse, {}),
          onClick: () => controller.setInfoVisible(!controller.infoVisible)
        }
      ),
      /* @__PURE__ */ jsx$1(Access, { roles: [ChatUserRole.Admin], children: /* @__PURE__ */ jsx$1(ConversationMenu, { conversation: conversation2 }) }),
      controller.mode == "compact" && /* @__PURE__ */ jsx$1(ChatHeaderButton, { className: "chat-header-btn-close", icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}), onClick: closeConversation })
    ] }) })
  ] });
};
const ConversationHeader$1 = observer(ConversationHeader);
const BotMessagesHiddenTooltip = observer(({ children: children2 }) => {
  const loc = useLoc();
  const user2 = useUser();
  const settings = useChatSettings();
  const botMsgHiddenTimer = useTimer();
  const [botMsgHiddenTooltipOpen, setBotMsgHiddenTooltipOpen] = useState$1(user2.isAdmin && settings.hideBotMessages);
  useEffect(() => {
    if (!settings.hideBotMessages) {
      botMsgHiddenTimer.clear();
      setBotMsgHiddenTooltipOpen(false);
    } else
      !botMsgHiddenTimer.isActive && botMsgHiddenTimer.set(() => {
        setBotMsgHiddenTooltipOpen(false);
      }, TimeSpan.fromSeconds(5));
  }, [settings.hideBotMessages]);
  return /* @__PURE__ */ jsx$1(
    Tooltip,
    {
      open: botMsgHiddenTooltipOpen,
      align: { offset: [15, 0] },
      overlayClassName: "opacity-75",
      title: /* @__PURE__ */ jsxs("span", { className: "fs-12", children: [
        /* @__PURE__ */ jsx$1(RobotOutlined, {}),
        " ",
        loc.word("Chat.settings.hideBotMessages.warning", { default: "Bot messages are hidden in the settings" })
      ] }),
      placement: "bottomRight",
      children: children2
    }
  );
});
const title_placeholder = "_title_placeholder_1uzau_1";
const subtitle_placeholder = "_subtitle_placeholder_1uzau_10";
const styles$5 = {
  title_placeholder,
  subtitle_placeholder
};
const ConversationHeaderPlaceholder = () => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: styles$5.title_placeholder }),
    /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: styles$5.subtitle_placeholder })
  ] });
};
const ConversationStudentHeader = ({ conversation: conversation2, onClose }) => {
  const loc = useLoc();
  const controller = useChat();
  return /* @__PURE__ */ jsxs(ChatHeader, { children: [
    /* @__PURE__ */ jsx$1("div", { className: "flex flex-col flex-1 c-pointer", onClick: () => controller.setInfoVisible(true), children: conversation2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "fs-18 fw-400 ellipsis flex align-center", style: { lineHeight: "24px" }, children: [
        /* @__PURE__ */ jsx$1("span", { className: "mr-5", children: conversation2.title ?? loc.word("Chat.techSupportLabel", { default: "Tech Support" }) }),
        /* @__PURE__ */ jsx$1(ChannelTypeIcon, { type: conversation2.channelType })
      ] }),
      conversation2.memberTyping.length > 0 ? /* @__PURE__ */ jsx$1(MemberTyping, { members: conversation2.memberTyping }) : /* @__PURE__ */ jsx$1(Fragment, { children: conversation2.target && /* @__PURE__ */ jsx$1("span", { className: "color-secondary fs-12", children: loc.word(`Chat.onlineStatus.${conversation2.target.onlineStatus}`, { default: conversation2.target.onlineStatus }) }) })
    ] }) : /* @__PURE__ */ jsx$1(ConversationHeaderPlaceholder, {}) }),
    /* @__PURE__ */ jsx$1("div", { children: conversation2 && /* @__PURE__ */ jsxs(Space, { className: "fs-18", align: "center", children: [
      /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          icon: /* @__PURE__ */ jsx$1(SettingOutlined, {}),
          onClick: () => controller.setSettingsVisible(true)
        }
      ),
      /* @__PURE__ */ jsx$1(
        ChatHeaderButton,
        {
          className: "chat-header-btn-close",
          icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}),
          onClick: () => controller.close()
        }
      )
    ] }) })
  ] });
};
const ConversationStudentHeader$1 = observer(ConversationStudentHeader);
const conversation_column = "_conversation_column_1k688_1";
const styles$4 = {
  conversation_column
};
const ConversationColumn = () => {
  const loc = useLoc();
  const controller = useChat();
  const handleCloseConversation = useChatModalBlocker(useCallback(() => {
    controller.setConversation(null);
  }, []));
  return /* @__PURE__ */ jsx$1("div", { className: combineClasses(
    styles$4.conversation_column,
    "flex flex-col w-100 overflow-hidden bg-white",
    controller.mode != "compact" ? "border-l" : void 0
  ), children: controller.hasSelectedConversation ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1(
      Access,
      {
        roles: [ChatUserRole.Admin],
        allow: /* @__PURE__ */ jsx$1(
          ConversationHeader$1,
          {
            conversation: controller.selectedConversation,
            onClose: handleCloseConversation
          }
        ),
        deny: /* @__PURE__ */ jsx$1(
          ConversationStudentHeader$1,
          {
            conversation: controller.selectedConversation,
            onClose: handleCloseConversation
          }
        )
      }
    ),
    /* @__PURE__ */ jsx$1(ConversationBody$1, { conversation: controller.selectedConversation })
  ] }) : /* @__PURE__ */ jsx$1("div", { className: "flex align-center justify-center h-100", children: /* @__PURE__ */ jsx$1("span", { className: "flex flex-1 flex-center color-secondary fs-25", children: loc.word("Chat.conversationPlaceholder", { default: "Select a conversation to start messaging" }) }) }) });
};
const ConversationColumn$1 = observer(ConversationColumn);
const counter_placeholder = "_counter_placeholder_1hlbh_1";
const styles$3 = {
  counter_placeholder
};
const user_placeholder = "_user_placeholder_1iwiy_1";
const styles$2 = {
  user_placeholder
};
const UserPlaceholder = () => {
  return /* @__PURE__ */ jsx$1(
    Skeleton,
    {
      avatar: true,
      active: true,
      paragraph: { rows: 1 },
      className: combineClasses(styles$2.user_placeholder, "pt-8 pb-8 pl-5 pr-5")
    }
  );
};
const user = "_user_16yvf_1";
const user_avatar = "_user_avatar_16yvf_9";
const styles$1 = {
  user,
  user_avatar
};
const UserListItem = ({ user: user2, onSelect: onSelect2 }) => {
  const loc = useLoc();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: combineClasses(
        styles$1.user,
        "flex align-center justify-start pt-8 pb-8 pl-5 pr-5 bg-white no-select"
      ),
      onClick: () => onSelect2(),
      children: [
        /* @__PURE__ */ jsx$1("div", { className: styles$1.user_avatar, children: /* @__PURE__ */ jsx$1(UserAvatar$1, { size: 40, user: user2 }) }),
        /* @__PURE__ */ jsxs("div", { className: "ml-10 flex flex-col flex-1 ellipsis", children: [
          /* @__PURE__ */ jsx$1("div", { className: "flex align-center justify-between", children: /* @__PURE__ */ jsx$1("div", { className: "fs-16 fw-700 ellipsis", children: user2.fullName }) }),
          /* @__PURE__ */ jsx$1("div", { className: "fs-13 color-secondary", children: user2.adminId ? loc.word("Chat.adminLabel", { default: "Admin" }) : loc.word("Chat.contactLabel", { default: "Contact" }) })
        ] })
      ]
    }
  );
};
const ConversationList = ({ store: store2, onSelect: onSelect2 }) => {
  return /* @__PURE__ */ jsx$1(
    InfinityVirtualList$1,
    {
      store: store2,
      rowHeight: 50,
      rowRenderer: ({ item: item2 }) => item2 ? /* @__PURE__ */ jsx$1(UserListItem, { user: item2, onSelect: () => onSelect2(item2) }) : /* @__PURE__ */ jsx$1(UserPlaceholder, {})
    }
  );
};
const UserList = observer(ConversationList);
const AddConversationForm = ({ visible, onSuccess }) => {
  const loc = useLoc();
  const controller = useChat();
  const hub = useChatHub();
  const [store2] = useState$1(new UserListStore(hub));
  const key = useUniqueKey();
  const [search3, setSearch] = useState$1("");
  const [touched, setTouched] = useState$1(false);
  useEffect(() => {
    if (visible)
      setTouched(true);
  }, [visible]);
  useEffect(() => {
    store2.updateFilter({ search: search3 });
    store2.forceReset();
    key.update();
  }, [search3]);
  const createConversation = useCallback(async (user2) => {
    const result = await hub.invokeWithResult(new CreateConversationRequest({
      type: user2.hasRoles(ChatUserRole.Admin) ? ConversationType.Normal : ConversationType.Support,
      userIds: [user2.id]
    }));
    if (result.success) {
      onSuccess();
      controller.setConversation(result.payload.conversationId);
      return;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
  }, []);
  if (!touched) return null;
  return /* @__PURE__ */ jsxs("div", { className: "bg-white flex flex-col h-100 overflow-hidden", children: [
    /* @__PURE__ */ jsx$1("div", { className: "pl-5 pr-5", children: /* @__PURE__ */ jsx$1(
      InputSearch,
      {
        autoFocus: true,
        onSearch: (search22) => setSearch(search22),
        size: "small",
        width: "100%"
      }
    ) }),
    /* @__PURE__ */ jsx$1("span", { className: "pl-10 pr-10 pb-5 pt-5 fs-13 color-secondary", children: !store2.isInited ? /* @__PURE__ */ jsx$1(Skeleton.Input, { size: "small", active: true, className: combineClasses(styles$3.counter_placeholder, "w-100") }) : /* @__PURE__ */ jsxs("span", { children: [
      loc.word("Chat.searchFoundLabel", { default: "Found" }),
      " ",
      /* @__PURE__ */ jsx$1("span", { className: "fw-700", children: store2.filter.itemsTotal }),
      " ",
      loc.wordPlural(
        store2.filter.itemsTotal,
        { one: "Chat.user.plural.one", two: "Chat.user.plural.two", other: "Chat.user.plural.other" },
        { default: { one: "User", two: "Users", other: "Users" }, case: "lower" }
      )
    ] }) }),
    /* @__PURE__ */ jsx$1("div", { className: "flex-1", children: /* @__PURE__ */ jsx$1(
      UserList,
      {
        store: store2,
        onSelect: (user2) => {
          createConversation(user2);
        }
      },
      key.key
    ) })
  ] });
};
const AddConversationForm$1 = observer(AddConversationForm);
const UserCard = ({ user: user2, link, className, onlineStatus, size: size2 = "default", copyable = true, post, tags, groups, showUserName = false, userName }) => {
  const loc = useLoc();
  const sizes = useMemo$2(() => {
    switch (size2) {
      case "large":
        return {
          avatarSize: 65,
          nameFs: "fs-16",
          infoFs: "fs-13",
          ml: "75px"
        };
      case "small":
        return {
          avatarSize: 35,
          nameFs: "fs-13",
          infoFs: "fs-11",
          ml: "50px"
        };
      default:
      case "default":
        return {
          avatarSize: 50,
          nameFs: "fs-15",
          infoFs: "fs-12",
          ml: "60px"
        };
    }
  }, [size2]);
  const avatar = useMemo$2(() => /* @__PURE__ */ jsx$1("div", { style: { width: sizes.avatarSize, height: sizes.avatarSize }, children: /* @__PURE__ */ jsx$1(UserAvatar$1, { user: user2, size: sizes.avatarSize }) }), [user2, sizes]);
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-center", children: [
      onlineStatus ? /* @__PURE__ */ jsx$1(ChatUserOnlineStatusBadge, { onlineStatus, userId: user2.id, watch: true, children: avatar }) : avatar,
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col flex-1 ml-10 ellipsis", children: [
        /* @__PURE__ */ jsx$1("div", { className: "ellipsis", children: link != false ? /* @__PURE__ */ jsx$1("a", { href: `/crm/contacts/${user2.id}`, target: "_blank", className: combineClasses("fw-500", sizes.nameFs), children: user2.fullName }) : /* @__PURE__ */ jsx$1("span", { className: combineClasses("fw-500", sizes.nameFs), children: user2.fullName }) }),
        user2.phone && /* @__PURE__ */ jsx$1(Typography.Text, { copyable, className: combineClasses("color-secondary", sizes.infoFs), children: user2.phone }),
        user2.email && /* @__PURE__ */ jsx$1(Typography.Text, { copyable, className: combineClasses("color-secondary", sizes.infoFs), children: user2.email }),
        post && /* @__PURE__ */ jsx$1(Typography.Text, { className: combineClasses(sizes.infoFs), children: post }),
        showUserName === true ? /* @__PURE__ */ jsx$1(Typography.Text, { copyable: copyable && !isEmpty(userName), className: combineClasses("color-secondary ellipsis", sizes.infoFs), children: userName ? `@${userName}` : loc.word("Chat.noUserNameLabel", { default: "No data" }) }) : null
      ] })
    ] }),
    (tags && tags.length > 0 || groups && groups.length > 0) && /* @__PURE__ */ jsxs("div", { style: { marginLeft: sizes.ml }, className: "mt-10", children: [
      tags && tags.length > 0 && /* @__PURE__ */ jsx$1(
        Popover,
        {
          placement: "bottom",
          trigger: "click",
          content: /* @__PURE__ */ jsx$1("div", { style: { gap: 5 }, className: "flex flex-col", children: tags.map((x, i) => /* @__PURE__ */ jsx$1(Tag, { children: x }, i)) }),
          children: /* @__PURE__ */ jsx$1(Button, { size: "small", children: loc.word("Chat.tagsLabel", { default: "Tags" }) })
        }
      ),
      groups && groups.length > 0 && /* @__PURE__ */ jsx$1(
        Popover,
        {
          placement: "bottom",
          trigger: "click",
          content: /* @__PURE__ */ jsx$1("div", { style: { gap: 5 }, className: "flex flex-col", children: groups.map((x, i) => /* @__PURE__ */ jsx$1(Tag, { children: x }, i)) }),
          children: /* @__PURE__ */ jsx$1(Button, { size: "small", className: "ml-5", children: loc.word("Chat.groupsLabel", { default: "Groups" }) })
        }
      )
    ] })
  ] });
};
const ContactSelect = ({ size: size2, contact, onChange: onChange5 }) => {
  const loc = useLoc();
  const [fetching, setFetching] = React__default.useState(false);
  const [options, setOptions] = React__default.useState([]);
  const [value, setValue] = React__default.useState(() => {
    if (contact) return toSelectOption(contact);
    return void 0;
  });
  const fetchRef = React__default.useRef(0);
  const hub = useChatHub();
  const fetchOptions = useCallback(async (search3) => {
    const filter2 = new ContactFilter({ search: search3 });
    const result = await hub.invokeWithResult(new FetchContactsRequest(filter2));
    if (result.success) return result.payload.items;
    return [];
  }, []);
  const toSelectOption = useCallback((contact2) => {
    return {
      key: contact2.contact.id,
      label: contact2.contact.fullName,
      value: contact2.contact.id
    };
  }, []);
  const debounceFetcher = React__default.useMemo(() => {
    const loadOptions = async (value2) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      const items = await fetchOptions(value2);
      if (fetchId !== fetchRef.current) {
        return;
      }
      setOptions(items);
      setFetching(false);
    };
    return lodashExports.debounce(loadOptions, 800);
  }, []);
  return /* @__PURE__ */ jsx$1(
    Select,
    {
      optionLabelProp: "label",
      autoFocus: true,
      allowClear: true,
      filterOption: false,
      onSearch: debounceFetcher,
      notFoundContent: fetching ? /* @__PURE__ */ jsx$1(Spin, { size: "small" }) : null,
      showSearch: true,
      className: "w-100",
      size: size2,
      value,
      placeholder: loc.word("Chat.selectContactPlaceholder", { default: "Search contact" }),
      onChange: (id2) => {
        const contact2 = options.find((x) => x.contact.id == id2);
        if (contact2) {
          onChange5?.(contact2);
        }
      },
      children: options.map(({ contact: contact2 }) => /* @__PURE__ */ jsx$1(Select.Option, { value: contact2.id, label: contact2.fullName, children: /* @__PURE__ */ jsx$1(UserCard, { user: contact2, size: "small", copyable: false }) }, contact2.id))
    }
  );
};
const SimilarContactItem = ({ contact, matchFields, onLink }) => {
  const loc = useLoc();
  const matches = useMemo$2(() => {
    return matchFields.length == 0 ? loc.word("Chat.noMatchesLabel", { default: "No matches" }) : matchFields.map((x) => loc.word(`Chat.matchField.${x}`)).join(", ");
  }, [matchFields]);
  return /* @__PURE__ */ jsxs("div", { className: "flex align-center justify-between", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex align-center ellipsis", title: matches, children: [
      /* @__PURE__ */ jsx$1("a", { className: "fs-12", href: `/crm/contacts/${contact.id}`, target: "_blank", children: contact.fullName }),
      contact.email && /* @__PURE__ */ jsxs("span", { className: "fs-11 color-secondary", children: [
        " (",
        contact.email,
        ")"
      ] }),
      " ",
      /* @__PURE__ */ jsxs("span", { className: "fs-11 color-secondary", children: [
        "(",
        matches,
        ")"
      ] })
    ] }),
    /* @__PURE__ */ jsx$1(Button, { type: "link", size: "small", onClick: () => onLink(), children: loc.word("Chat.linkCRMContactMsg", { default: "Link" }) })
  ] });
};
const SimilarContactList = ({ chatUserId, onLink }) => {
  const hub = useChatHub();
  const [items, setItems] = useState$1([]);
  const fetchItems = useCallback(async () => {
    const filter2 = new ContactFilter({ similarChatUserId: chatUserId, take: 5 });
    const result = await hub.invokeWithResult(new FetchContactsRequest(filter2));
    if (result.success) setItems(result.payload.items);
    return [];
  }, []);
  useEffect(() => {
    fetchItems();
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("span", { className: "fs-12 color-secondary mb-5", children: [
      items.length == 1 && /* @__PURE__ */ jsx$1(Loc, { word: "Chat.foundSimilarContacts.plural.one", default: "Found {0} similar", children: 1 }),
      items.length >= 2 && /* @__PURE__ */ jsx$1(Loc, { word: "Chat.foundSimilarContacts.plural.other", default: "Found {0} similar", children: items.length })
    ] }),
    items.map((x) => /* @__PURE__ */ jsx$1(
      SimilarContactItem,
      {
        contact: x.contact,
        matchFields: x.matchFields,
        onLink: () => onLink(x)
      },
      x.contact.id
    ))
  ] });
};
const ContactForm = ({ contact: _contact, chatUser }) => {
  const loc = useLoc();
  const hub = useChatHub();
  const [editing, setEditing] = useState$1(false);
  const [tempContact, setTempContact] = useState$1(null);
  const [contact, setContact] = useState$1(_contact);
  const linkUser = useCallback(async (contact2) => {
    const result = await hub.invoke(new UpdateUserRequest({
      id: chatUser.id,
      contactId: toOptional(contact2.id)
    }));
    if (result.success) {
      setContact(contact2);
      setEditing(false);
      return;
    }
    notification.error({ message: loc.word("Error occured"), duration: 2 });
  }, []);
  return /* @__PURE__ */ jsx$1(Fragment, { children: editing ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx$1("span", { className: "fs-12 color-secondary", children: loc.word("Chat.searchContactLabel", { default: "Search contact manually" }) }),
    /* @__PURE__ */ jsx$1(ContactSelect, { size: "middle", onChange: (x) => setTempContact(x.contact) }),
    /* @__PURE__ */ jsx$1("div", { className: "mt-10", children: tempContact ? /* @__PURE__ */ jsx$1(SimilarContactItem, { contact: tempContact, matchFields: [], onLink: () => linkUser(tempContact) }) : /* @__PURE__ */ jsx$1(SimilarContactList, { chatUserId: chatUser.id, onLink: (x) => linkUser(x.contact) }) }),
    /* @__PURE__ */ jsx$1(
      Button,
      {
        type: "link",
        className: "mt-5 p-0",
        size: "small",
        onClick: () => setEditing(false),
        children: loc.word("Cancel")
      }
    )
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    contact ? /* @__PURE__ */ jsx$1(UserCard, { user: contact, size: "default", tags: contact.tags, groups: contact.groups }) : /* @__PURE__ */ jsx$1("span", { className: "color-secondary fs-12", children: loc.word("Chat.noLinkedCRMContactLabel", { default: "No contact selected" }) }),
    /* @__PURE__ */ jsx$1(
      Button,
      {
        type: "link",
        className: "mt-5",
        size: "small",
        icon: /* @__PURE__ */ jsx$1(EditOutlined, {}),
        onClick: () => setEditing(true),
        children: loc.word("Chat.editLinkCRMContactMsg", { default: "Edit link" })
      }
    )
  ] }) });
};
const ChatUserInfo = ({ userId, conversation: conversation2, onConversationSelect }) => {
  const hub = useChatHub();
  const loc = useLoc();
  const [fetched, setFetched] = useState$1(false);
  const [chatUser, setChatUser] = useState$1(null);
  const [contact, setContact] = useState$1(null);
  const [chats, setChats] = useState$1([]);
  useEffect(() => {
    if (!userId) return;
    const fetch2 = async () => {
      const result = await hub.invokeWithResult(new FetchUserInfoRequest(userId));
      if (result.success) {
        setChatUser(result.payload.user);
        setContact(result.payload.contact);
        setChats(result.payload.chats.filter((x) => x.id != conversation2?.id));
        setFetched(true);
      }
    };
    fetch2();
  }, [userId]);
  return /* @__PURE__ */ jsx$1("div", { className: "flex flex-col", children: !fetched ? /* @__PURE__ */ jsxs("div", { className: "p-15", children: [
    /* @__PURE__ */ jsx$1(Skeleton, { avatar: { size: 65 }, active: true }),
    /* @__PURE__ */ jsx$1(Skeleton, { paragraph: { rows: 3 }, active: true }),
    /* @__PURE__ */ jsx$1(Skeleton, { paragraph: { rows: 10 }, active: true })
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    conversation2?.channelType == ChannelType.Accel ? /* @__PURE__ */ jsx$1(UserCard, { user: chatUser, link: false, className: "p-15 mb-20", size: "large", post: chatUser.post, tags: contact?.tags, groups: contact?.groups }) : /* @__PURE__ */ jsx$1(UserCard, { user: chatUser, link: false, className: "p-15 mb-20", size: "large", showUserName: true, userName: chatUser.userName }),
    conversation2?.channelType != ChannelType.Accel && /* @__PURE__ */ jsxs("div", { className: "mb-20 pl-15 pr-15", children: [
      /* @__PURE__ */ jsx$1("div", { className: "mb-5 flex align-center", children: /* @__PURE__ */ jsx$1("p", { className: "fs-15 fw-500", children: loc.word("Chat.linkedCRMContactLabel", { default: "Linked CRM contact" }) }) }),
      /* @__PURE__ */ jsx$1(ContactForm, { contact, chatUser })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-20 pl-15 pr-15", children: [
      /* @__PURE__ */ jsx$1("div", { className: "mb-5 flex align-center", children: /* @__PURE__ */ jsx$1("p", { className: "fs-15 fw-500", children: loc.word("Chat.otherChatsLabel", { default: "Other chats" }) }) }),
      /* @__PURE__ */ jsx$1("div", { children: chats.map((x) => /* @__PURE__ */ jsx$1(
        ConversationItem$1,
        {
          conversation: x,
          isSelected: false,
          unreadMessagesVisible: x.lastSeenMessageIndex != null,
          onSelect: () => onConversationSelect(x)
        },
        x.id
      )) }),
      chats.length == 0 && /* @__PURE__ */ jsx$1("div", { className: "text-center color-secondary", children: loc.word("Chat.noConversationsLabel", { default: "No conversations" }) })
    ] })
  ] }) });
};
const info_column = "_info_column_1qwpk_1";
const styles = {
  info_column
};
const InfoColumn = () => {
  const loc = useLoc();
  const controller = useChat();
  if (!controller.selectedConversation) return null;
  return /* @__PURE__ */ jsxs("div", { className: combineClasses(
    styles.info_column,
    "flex flex-col h-100 bg-white",
    controller.mode != "compact" ? "border-l" : void 0,
    !controller.infoVisible ? "d-none" : void 0
  ), children: [
    /* @__PURE__ */ jsx$1(ChatHeader, { children: /* @__PURE__ */ jsxs("div", { className: "flex align-center w-100", children: [
      /* @__PURE__ */ jsx$1("div", { className: "fs-15 fw-400 flex-1", children: loc.word("Chat.userInfoLabel", { default: `User Info` }) }),
      /* @__PURE__ */ jsx$1(ChatHeaderButton, { className: "chat-header-btn-info", icon: /* @__PURE__ */ jsx$1(CloseOutlined, {}), onClick: () => controller.setInfoVisible(false) })
    ] }) }),
    /* @__PURE__ */ jsx$1("div", { className: "relative overflow-auto", children: /* @__PURE__ */ jsx$1(
      ChatUserInfo,
      {
        conversation: controller.selectedConversation,
        userId: controller.selectedConversation.target.userId,
        onConversationSelect: (x) => {
          controller.setConversation(x.id);
        }
      }
    ) })
  ] });
};
const InfoColumn$1 = observer(InfoColumn);
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var Action;
(function(Action2) {
  Action2["Pop"] = "POP";
  Action2["Push"] = "PUSH";
  Action2["Replace"] = "REPLACE";
})(Action || (Action = {}));
function invariant(value, message2) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message2);
  }
}
function warning2(cond, message2) {
  if (!cond) {
    if (typeof console !== "undefined") console.warn(message2);
    try {
      throw new Error(message2);
    } catch (e) {
    }
  }
}
function createPath(_ref) {
  let {
    pathname = "/",
    search: search3 = "",
    hash: hash2 = ""
  } = _ref;
  if (search3 && search3 !== "?") pathname += search3.charAt(0) === "?" ? search3 : "?" + search3;
  if (hash2 && hash2 !== "#") pathname += hash2.charAt(0) === "#" ? hash2 : "#" + hash2;
  return pathname;
}
function parsePath(path2) {
  let parsedPath = {};
  if (path2) {
    let hashIndex = path2.indexOf("#");
    if (hashIndex >= 0) {
      parsedPath.hash = path2.substr(hashIndex);
      path2 = path2.substr(0, hashIndex);
    }
    let searchIndex = path2.indexOf("?");
    if (searchIndex >= 0) {
      parsedPath.search = path2.substr(searchIndex);
      path2 = path2.substr(0, searchIndex);
    }
    if (path2) {
      parsedPath.pathname = path2;
    }
  }
  return parsedPath;
}
var ResultType;
(function(ResultType2) {
  ResultType2["data"] = "data";
  ResultType2["deferred"] = "deferred";
  ResultType2["redirect"] = "redirect";
  ResultType2["error"] = "error";
})(ResultType || (ResultType = {}));
function matchPath(pattern4, pathname) {
  if (typeof pattern4 === "string") {
    pattern4 = {
      path: pattern4,
      caseSensitive: false,
      end: true
    };
  }
  let [matcher, compiledParams] = compilePath(pattern4.path, pattern4.caseSensitive, pattern4.end);
  let match2 = pathname.match(matcher);
  if (!match2) return null;
  let matchedPathname = match2[0];
  let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  let captureGroups = match2.slice(1);
  let params = compiledParams.reduce((memo2, _ref, index2) => {
    let {
      paramName,
      isOptional
    } = _ref;
    if (paramName === "*") {
      let splatValue = captureGroups[index2] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }
    const value = captureGroups[index2];
    if (isOptional && !value) {
      memo2[paramName] = void 0;
    } else {
      memo2[paramName] = safelyDecodeURIComponent(value || "", paramName);
    }
    return memo2;
  }, {});
  return {
    params,
    pathname: matchedPathname,
    pathnameBase,
    pattern: pattern4
  };
}
function compilePath(path2, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  if (end === void 0) {
    end = true;
  }
  warning2(path2 === "*" || !path2.endsWith("*") || path2.endsWith("/*"), 'Route path "' + path2 + '" will be treated as if it were ' + ('"' + path2.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path2.replace(/\*$/, "/*") + '".'));
  let params = [];
  let regexpSource = "^" + path2.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_2, paramName, isOptional) => {
    params.push({
      paramName,
      isOptional: isOptional != null
    });
    return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
  });
  if (path2.endsWith("*")) {
    params.push({
      paramName: "*"
    });
    regexpSource += path2 === "*" || path2 === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
  } else if (end) {
    regexpSource += "\\/*$";
  } else if (path2 !== "" && path2 !== "/") {
    regexpSource += "(?:(?=\\/|$))";
  } else ;
  let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
  return [matcher, params];
}
function safelyDecodeURIComponent(value, paramName) {
  try {
    return decodeURIComponent(value);
  } catch (error2) {
    warning2(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error2 + ")."));
    return value;
  }
}
function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }
  let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
  let nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== "/") {
    return null;
  }
  return pathname.slice(startIndex) || "/";
}
function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }
  let {
    pathname: toPathname,
    search: search3 = "",
    hash: hash2 = ""
  } = typeof to === "string" ? parsePath(to) : to;
  let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname,
    search: normalizeSearch(search3),
    hash: normalizeHash(hash2)
  };
}
function resolvePathname(relativePath, fromPathname) {
  let segments = fromPathname.replace(/\/+$/, "").split("/");
  let relativeSegments = relativePath.split("/");
  relativeSegments.forEach((segment) => {
    if (segment === "..") {
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char2, field, dest, path2) {
  return "Cannot include a '" + char2 + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path2) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function getPathContributingMatches(matches) {
  return matches.filter((match2, index2) => index2 === 0 || match2.route.path && match2.route.path.length > 0);
}
function getResolveToMatches(matches, v7_relativeSplatPath) {
  let pathMatches = getPathContributingMatches(matches);
  if (v7_relativeSplatPath) {
    return pathMatches.map((match2, idx) => idx === matches.length - 1 ? match2.pathname : match2.pathnameBase);
  }
  return pathMatches.map((match2) => match2.pathnameBase);
}
function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
  if (isPathRelative === void 0) {
    isPathRelative = false;
  }
  let to;
  if (typeof toArg === "string") {
    to = parsePath(toArg);
  } else {
    to = _extends$2({}, toArg);
    invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
    invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
    invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
  }
  let isEmptyPath = toArg === "" || to.pathname === "";
  let toPathname = isEmptyPath ? "/" : to.pathname;
  let from2;
  if (toPathname == null) {
    from2 = locationPathname;
  } else {
    let routePathnameIndex = routePathnames.length - 1;
    if (!isPathRelative && toPathname.startsWith("..")) {
      let toSegments = toPathname.split("/");
      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }
      to.pathname = toSegments.join("/");
    }
    from2 = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }
  let path2 = resolvePath(to, from2);
  let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
  let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
  if (!path2.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) {
    path2.pathname += "/";
  }
  return path2;
}
const joinPaths = (paths) => paths.join("/").replace(/\/\/+/g, "/");
const normalizeSearch = (search3) => !search3 || search3 === "?" ? "" : search3.startsWith("?") ? search3 : "?" + search3;
const normalizeHash = (hash2) => !hash2 || hash2 === "#" ? "" : hash2.startsWith("#") ? hash2 : "#" + hash2;
const validMutationMethodsArr = ["post", "put", "patch", "delete"];
new Set(validMutationMethodsArr);
const validRequestMethodsArr = ["get", ...validMutationMethodsArr];
new Set(validRequestMethodsArr);
/**
 * React Router v6.21.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
const DataRouterContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterContext.displayName = "DataRouter";
}
const DataRouterStateContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterStateContext.displayName = "DataRouterState";
}
const AwaitContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  AwaitContext.displayName = "Await";
}
const NavigationContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  NavigationContext.displayName = "Navigation";
}
const LocationContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  LocationContext.displayName = "Location";
}
const RouteContext = /* @__PURE__ */ React.createContext({
  outlet: null,
  matches: [],
  isDataRoute: false
});
if (process.env.NODE_ENV !== "production") {
  RouteContext.displayName = "Route";
}
const RouteErrorContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  RouteErrorContext.displayName = "RouteError";
}
function useHref(to, _temp) {
  let {
    relative
  } = _temp === void 0 ? {} : _temp;
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(
    false,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : invariant(false) : void 0;
  let {
    basename,
    navigator: navigator2
  } = React.useContext(NavigationContext);
  let {
    hash: hash2,
    pathname,
    search: search3
  } = useResolvedPath(to, {
    relative
  });
  let joinedPathname = pathname;
  if (basename !== "/") {
    joinedPathname = pathname === "/" ? basename : joinPaths([basename, pathname]);
  }
  return navigator2.createHref({
    pathname: joinedPathname,
    search: search3,
    hash: hash2
  });
}
function useInRouterContext() {
  return React.useContext(LocationContext) != null;
}
function useLocation() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(
    false,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : invariant(false) : void 0;
  return React.useContext(LocationContext).location;
}
const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
  let isStatic = React.useContext(NavigationContext).static;
  if (!isStatic) {
    React.useLayoutEffect(cb);
  }
}
function useNavigate() {
  let {
    isDataRoute
  } = React.useContext(RouteContext);
  return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
  !useInRouterContext() ? process.env.NODE_ENV !== "production" ? invariant(
    false,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : invariant(false) : void 0;
  let dataRouterContext = React.useContext(DataRouterContext);
  let {
    basename,
    future,
    navigator: navigator2
  } = React.useContext(NavigationContext);
  let {
    matches
  } = React.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  let activeRef = React.useRef(false);
  useIsomorphicLayoutEffect(() => {
    activeRef.current = true;
  });
  let navigate = React.useCallback(function(to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning2(activeRef.current, navigateEffectWarning) : void 0;
    if (!activeRef.current) return;
    if (typeof to === "number") {
      navigator2.go(to);
      return;
    }
    let path2 = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
    if (dataRouterContext == null && basename !== "/") {
      path2.pathname = path2.pathname === "/" ? basename : joinPaths([basename, path2.pathname]);
    }
    (!!options.replace ? navigator2.replace : navigator2.push)(path2, options.state, options);
  }, [basename, navigator2, routePathnamesJson, locationPathname, dataRouterContext]);
  return navigate;
}
function useResolvedPath(to, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let {
    future
  } = React.useContext(NavigationContext);
  let {
    matches
  } = React.useContext(RouteContext);
  let {
    pathname: locationPathname
  } = useLocation();
  let routePathnamesJson = JSON.stringify(getResolveToMatches(matches, future.v7_relativeSplatPath));
  return React.useMemo(() => resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [to, routePathnamesJson, locationPathname, relative]);
}
var DataRouterHook$1 = /* @__PURE__ */ (function(DataRouterHook2) {
  DataRouterHook2["UseBlocker"] = "useBlocker";
  DataRouterHook2["UseRevalidator"] = "useRevalidator";
  DataRouterHook2["UseNavigateStable"] = "useNavigate";
  return DataRouterHook2;
})(DataRouterHook$1 || {});
var DataRouterStateHook$1 = /* @__PURE__ */ (function(DataRouterStateHook2) {
  DataRouterStateHook2["UseBlocker"] = "useBlocker";
  DataRouterStateHook2["UseLoaderData"] = "useLoaderData";
  DataRouterStateHook2["UseActionData"] = "useActionData";
  DataRouterStateHook2["UseRouteError"] = "useRouteError";
  DataRouterStateHook2["UseNavigation"] = "useNavigation";
  DataRouterStateHook2["UseRouteLoaderData"] = "useRouteLoaderData";
  DataRouterStateHook2["UseMatches"] = "useMatches";
  DataRouterStateHook2["UseRevalidator"] = "useRevalidator";
  DataRouterStateHook2["UseNavigateStable"] = "useNavigate";
  DataRouterStateHook2["UseRouteId"] = "useRouteId";
  return DataRouterStateHook2;
})(DataRouterStateHook$1 || {});
function getDataRouterConsoleError$1(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext$1(hookName) {
  let ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError$1(hookName)) : invariant(false) : void 0;
  return ctx;
}
function useRouteContext(hookName) {
  let route = React.useContext(RouteContext);
  !route ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError$1(hookName)) : invariant(false) : void 0;
  return route;
}
function useCurrentRouteId(hookName) {
  let route = useRouteContext(hookName);
  let thisRoute = route.matches[route.matches.length - 1];
  !thisRoute.route.id ? process.env.NODE_ENV !== "production" ? invariant(false, hookName + ' can only be used on routes that contain a unique "id"') : invariant(false) : void 0;
  return thisRoute.route.id;
}
function useRouteId() {
  return useCurrentRouteId(DataRouterStateHook$1.UseRouteId);
}
function useNavigateStable() {
  let {
    router
  } = useDataRouterContext$1(DataRouterHook$1.UseNavigateStable);
  let id2 = useCurrentRouteId(DataRouterStateHook$1.UseNavigateStable);
  let activeRef = React.useRef(false);
  useIsomorphicLayoutEffect(() => {
    activeRef.current = true;
  });
  let navigate = React.useCallback(function(to, options) {
    if (options === void 0) {
      options = {};
    }
    process.env.NODE_ENV !== "production" ? warning2(activeRef.current, navigateEffectWarning) : void 0;
    if (!activeRef.current) return;
    if (typeof to === "number") {
      router.navigate(to);
    } else {
      router.navigate(to, _extends$1({
        fromRouteId: id2
      }, options));
    }
  }, [router, id2]);
  return navigate;
}
new Promise(() => {
});
/**
 * React Router DOM v6.21.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object4) {
  return object4 != null && typeof object4.tagName === "string";
}
function isButtonElement(object4) {
  return isHtmlElement(object4) && object4.tagName.toLowerCase() === "button";
}
function isFormElement(object4) {
  return isHtmlElement(object4) && object4.tagName.toLowerCase() === "form";
}
function isInputElement(object4) {
  return isHtmlElement(object4) && object4.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
  return event.button === 0 && // Ignore everything but left clicks
  (!target || target === "_self") && // Let browser handle "target=_blank" etc.
  !isModifiedEvent(event);
}
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
  if (_formDataSupportsSubmitter === null) {
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      );
      _formDataSupportsSubmitter = false;
    } catch (e) {
      _formDataSupportsSubmitter = true;
    }
  }
  return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function getFormEncType(encType) {
  if (encType != null && !supportedFormEncTypes.has(encType)) {
    process.env.NODE_ENV !== "production" ? warning2(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + defaultEncType + '"')) : void 0;
    return null;
  }
  return encType;
}
function getFormSubmissionInfo(target, basename) {
  let method4;
  let action3;
  let encType;
  let formData;
  let body;
  if (isFormElement(target)) {
    let attr = target.getAttribute("action");
    action3 = attr ? stripBasename(attr, basename) : null;
    method4 = target.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
    formData = new FormData(target);
  } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
    let form = target.form;
    if (form == null) {
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    }
    let attr = target.getAttribute("formaction") || form.getAttribute("action");
    action3 = attr ? stripBasename(attr, basename) : null;
    method4 = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
    encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
    formData = new FormData(form, target);
    if (!isFormDataSubmitterSupported()) {
      let {
        name,
        type: type4,
        value
      } = target;
      if (type4 === "image") {
        let prefix2 = name ? name + "." : "";
        formData.append(prefix2 + "x", "0");
        formData.append(prefix2 + "y", "0");
      } else if (name) {
        formData.append(name, value);
      }
    }
  } else if (isHtmlElement(target)) {
    throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
  } else {
    method4 = defaultMethod;
    action3 = null;
    encType = defaultEncType;
    body = target;
  }
  if (formData && encType === "text/plain") {
    body = formData;
    formData = void 0;
  }
  return {
    action: action3,
    method: method4.toLowerCase(),
    encType,
    formData,
    body
  };
}
const _excluded = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], _excluded2 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], _excluded3 = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"];
const ViewTransitionContext = /* @__PURE__ */ React.createContext({
  isTransitioning: false
});
if (process.env.NODE_ENV !== "production") {
  ViewTransitionContext.displayName = "ViewTransition";
}
const FetchersContext = /* @__PURE__ */ React.createContext(/* @__PURE__ */ new Map());
if (process.env.NODE_ENV !== "production") {
  FetchersContext.displayName = "Fetchers";
}
if (process.env.NODE_ENV !== "production") ;
const isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const Link = /* @__PURE__ */ React.forwardRef(function LinkWithRef(_ref7, ref2) {
  let {
    onClick: onClick2,
    relative,
    reloadDocument,
    replace: replace2,
    state,
    target,
    to,
    preventScrollReset,
    unstable_viewTransition
  } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
  let {
    basename
  } = React.useContext(NavigationContext);
  let absoluteHref;
  let isExternal = false;
  if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
    absoluteHref = to;
    if (isBrowser2) {
      try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path2 = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path2 != null) {
          to = path2 + targetUrl.search + targetUrl.hash;
        } else {
          isExternal = true;
        }
      } catch (e) {
        process.env.NODE_ENV !== "production" ? warning2(false, '<Link to="' + to + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.') : void 0;
      }
    }
  }
  let href = useHref(to, {
    relative
  });
  let internalOnClick = useLinkClickHandler(to, {
    replace: replace2,
    state,
    target,
    preventScrollReset,
    relative,
    unstable_viewTransition
  });
  function handleClick(event) {
    if (onClick2) onClick2(event);
    if (!event.defaultPrevented) {
      internalOnClick(event);
    }
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ React.createElement("a", _extends({}, rest, {
      href: absoluteHref || href,
      onClick: isExternal || reloadDocument ? onClick2 : handleClick,
      ref: ref2,
      target
    }))
  );
});
if (process.env.NODE_ENV !== "production") {
  Link.displayName = "Link";
}
const NavLink = /* @__PURE__ */ React.forwardRef(function NavLinkWithRef(_ref8, ref2) {
  let {
    "aria-current": ariaCurrentProp = "page",
    caseSensitive = false,
    className: classNameProp = "",
    end = false,
    style: styleProp,
    to,
    unstable_viewTransition,
    children: children2
  } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
  let path2 = useResolvedPath(to, {
    relative: rest.relative
  });
  let location2 = useLocation();
  let routerState = React.useContext(DataRouterStateContext);
  let {
    navigator: navigator2
  } = React.useContext(NavigationContext);
  let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useViewTransitionState(path2) && unstable_viewTransition === true;
  let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path2).pathname : path2.pathname;
  let locationPathname = location2.pathname;
  let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
  if (!caseSensitive) {
    locationPathname = locationPathname.toLowerCase();
    nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
    toPathname = toPathname.toLowerCase();
  }
  const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
  let isActive2 = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
  let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
  let renderProps = {
    isActive: isActive2,
    isPending,
    isTransitioning
  };
  let ariaCurrent = isActive2 ? ariaCurrentProp : void 0;
  let className;
  if (typeof classNameProp === "function") {
    className = classNameProp(renderProps);
  } else {
    className = [classNameProp, isActive2 ? "active" : null, isPending ? "pending" : null, isTransitioning ? "transitioning" : null].filter(Boolean).join(" ");
  }
  let style2 = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
  return /* @__PURE__ */ React.createElement(Link, _extends({}, rest, {
    "aria-current": ariaCurrent,
    className,
    ref: ref2,
    style: style2,
    to,
    unstable_viewTransition
  }), typeof children2 === "function" ? children2(renderProps) : children2);
});
if (process.env.NODE_ENV !== "production") {
  NavLink.displayName = "NavLink";
}
const Form2 = /* @__PURE__ */ React.forwardRef((_ref9, forwardedRef) => {
  let {
    fetcherKey,
    navigate,
    reloadDocument,
    replace: replace2,
    state,
    method: method4 = defaultMethod,
    action: action3,
    onSubmit,
    relative,
    preventScrollReset,
    unstable_viewTransition
  } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
  let submit = useSubmit();
  let formAction = useFormAction(action3, {
    relative
  });
  let formMethod = method4.toLowerCase() === "get" ? "get" : "post";
  let submitHandler = (event) => {
    onSubmit && onSubmit(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    let submitter = event.nativeEvent.submitter;
    let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method4;
    submit(submitter || event.currentTarget, {
      fetcherKey,
      method: submitMethod,
      navigate,
      replace: replace2,
      state,
      relative,
      preventScrollReset,
      unstable_viewTransition
    });
  };
  return /* @__PURE__ */ React.createElement("form", _extends({
    ref: forwardedRef,
    method: formMethod,
    action: formAction,
    onSubmit: reloadDocument ? onSubmit : submitHandler
  }, props));
});
if (process.env.NODE_ENV !== "production") {
  Form2.displayName = "Form";
}
if (process.env.NODE_ENV !== "production") ;
var DataRouterHook;
(function(DataRouterHook2) {
  DataRouterHook2["UseScrollRestoration"] = "useScrollRestoration";
  DataRouterHook2["UseSubmit"] = "useSubmit";
  DataRouterHook2["UseSubmitFetcher"] = "useSubmitFetcher";
  DataRouterHook2["UseFetcher"] = "useFetcher";
  DataRouterHook2["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook2) {
  DataRouterStateHook2["UseFetcher"] = "useFetcher";
  DataRouterStateHook2["UseFetchers"] = "useFetchers";
  DataRouterStateHook2["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
  let ctx = React.useContext(DataRouterContext);
  !ctx ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError(hookName)) : invariant(false) : void 0;
  return ctx;
}
function useLinkClickHandler(to, _temp) {
  let {
    target,
    replace: replaceProp,
    state,
    preventScrollReset,
    relative,
    unstable_viewTransition
  } = _temp === void 0 ? {} : _temp;
  let navigate = useNavigate();
  let location2 = useLocation();
  let path2 = useResolvedPath(to, {
    relative
  });
  return React.useCallback((event) => {
    if (shouldProcessLinkClick(event, target)) {
      event.preventDefault();
      let replace2 = replaceProp !== void 0 ? replaceProp : createPath(location2) === createPath(path2);
      navigate(to, {
        replace: replace2,
        state,
        preventScrollReset,
        relative,
        unstable_viewTransition
      });
    }
  }, [location2, navigate, path2, replaceProp, state, target, to, preventScrollReset, relative, unstable_viewTransition]);
}
function validateClientSideSubmission() {
  if (typeof document === "undefined") {
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
  }
}
let fetcherId = 0;
let getUniqueFetcherId = () => "__" + String(++fetcherId) + "__";
function useSubmit() {
  let {
    router
  } = useDataRouterContext(DataRouterHook.UseSubmit);
  let {
    basename
  } = React.useContext(NavigationContext);
  let currentRouteId = useRouteId();
  return React.useCallback(function(target, options) {
    if (options === void 0) {
      options = {};
    }
    validateClientSideSubmission();
    let {
      action: action3,
      method: method4,
      encType,
      formData,
      body
    } = getFormSubmissionInfo(target, basename);
    if (options.navigate === false) {
      let key = options.fetcherKey || getUniqueFetcherId();
      router.fetch(key, currentRouteId, options.action || action3, {
        preventScrollReset: options.preventScrollReset,
        formData,
        body,
        formMethod: options.method || method4,
        formEncType: options.encType || encType,
        unstable_flushSync: options.unstable_flushSync
      });
    } else {
      router.navigate(options.action || action3, {
        preventScrollReset: options.preventScrollReset,
        formData,
        body,
        formMethod: options.method || method4,
        formEncType: options.encType || encType,
        replace: options.replace,
        state: options.state,
        fromRouteId: currentRouteId,
        unstable_flushSync: options.unstable_flushSync,
        unstable_viewTransition: options.unstable_viewTransition
      });
    }
  }, [router, basename, currentRouteId]);
}
function useFormAction(action3, _temp2) {
  let {
    relative
  } = _temp2 === void 0 ? {} : _temp2;
  let {
    basename
  } = React.useContext(NavigationContext);
  let routeContext = React.useContext(RouteContext);
  !routeContext ? process.env.NODE_ENV !== "production" ? invariant(false, "useFormAction must be used inside a RouteContext") : invariant(false) : void 0;
  let [match2] = routeContext.matches.slice(-1);
  let path2 = _extends({}, useResolvedPath(action3 ? action3 : ".", {
    relative
  }));
  let location2 = useLocation();
  if (action3 == null) {
    path2.search = location2.search;
    let params = new URLSearchParams(path2.search);
    if (params.has("index") && params.get("index") === "") {
      params.delete("index");
      path2.search = params.toString() ? "?" + params.toString() : "";
    }
  }
  if ((!action3 || action3 === ".") && match2.route.index) {
    path2.search = path2.search ? path2.search.replace(/^\?/, "?index&") : "?index";
  }
  if (basename !== "/") {
    path2.pathname = path2.pathname === "/" ? basename : joinPaths([basename, path2.pathname]);
  }
  return createPath(path2);
}
function useBeforeUnload(callback, options) {
  let {
    capture
  } = {};
  React.useEffect(() => {
    let opts = capture != null ? {
      capture
    } : void 0;
    window.addEventListener("beforeunload", callback, opts);
    return () => {
      window.removeEventListener("beforeunload", callback, opts);
    };
  }, [callback, capture]);
}
function useViewTransitionState(to, opts) {
  if (opts === void 0) {
    opts = {};
  }
  let vtContext = React.useContext(ViewTransitionContext);
  !(vtContext != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : invariant(false) : void 0;
  let {
    basename
  } = useDataRouterContext(DataRouterHook.useViewTransitionState);
  let path2 = useResolvedPath(to, {
    relative: opts.relative
  });
  if (!vtContext.isTransitioning) {
    return false;
  }
  let currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
  let nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
  return matchPath(path2.pathname, nextPath) != null || matchPath(path2.pathname, currentPath) != null;
}
if (!Array.prototype.pushIfNotExists) {
  Array.prototype.pushIfNotExists = function(elem, comparer2 = defaultComparer) {
    if (this.some((x) => comparer2(x, elem))) return;
    this.push(elem);
  };
}
if (!Array.prototype.remove) {
  Array.prototype.remove = function(elem) {
    return this.filter((e) => e !== elem);
  };
}
if (!Array.prototype.removeAt) {
  Array.prototype.removeAt = function(i) {
    const items = this.slice();
    items.splice(i, 1);
    return items;
  };
}
if (!Array.prototype.removeIf) {
  Array.prototype.removeIf = function(predicate) {
    return this.filter((e) => !predicate(e));
  };
}
if (!Array.prototype.reorder) {
  Array.prototype.reorder = function(srcIndex, dstIndex) {
    const items = this.slice();
    const srcItem = items[srcIndex];
    const dstItem = items[dstIndex];
    items.splice(srcIndex, 1);
    items.splice(dstIndex, 0, srcItem);
    return {
      oldItems: this,
      items,
      srcItem,
      dstItem
    };
  };
}
if (!Array.prototype.toggle) {
  Array.prototype.toggle = function(item2, predicate) {
    const items = this.slice();
    const p = predicate ? predicate : (x) => x === item2;
    const i = items.findIndex(p);
    if (i < 0) items.push(item2);
    else items.splice(i, 1);
    return items;
  };
}
if (!Array.prototype.toMap) {
  Array.prototype.toMap = function(getKey) {
    return new Map(this.map((x) => [getKey(x), x]));
  };
}
if (!Array.prototype.groupBy) {
  Array.prototype.groupBy = function(getKey) {
    const map = /* @__PURE__ */ new Map();
    this.forEach((item2) => {
      const key = getKey(item2);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item2]);
      } else {
        collection.push(item2);
      }
    });
    return map;
  };
}
if (!Array.prototype.isEmpty) {
  Array.prototype.isEmpty = function() {
    return this.length == 0;
  };
}
function defaultComparer(a, b) {
  return a === b;
}
if (!Array.prototype.isEquals) {
  Array.prototype.isEquals = function(dstArr, comparer2 = defaultComparer) {
    if (this === dstArr) return true;
    if (!this || !dstArr) return false;
    if (this.length !== dstArr.length) return false;
    return this.every((x, srcIndex) => dstArr.find((y, dstIndex) => comparer2(x, y, srcIndex, dstIndex)) != null);
  };
}
if (!Array.prototype.orderBy) {
  Array.prototype.orderBy = function(getter2 = (x) => x) {
    if (!this) return [];
    return this.slice().sort((a, b) => getter2(a) < getter2(b) ? -1 : 1);
  };
}
if (!Array.prototype.orderByDesc) {
  Array.prototype.orderByDesc = function(getter2 = (x) => x) {
    if (!this) return [];
    return this.slice().sort((a, b) => getter2(b) < getter2(a) ? -1 : 1);
  };
}
if (!Array.prototype.count) {
  Array.prototype.count = function(predicate = (x) => true) {
    return this.filter(predicate).length;
  };
}
if (!Array.prototype.insert) {
  Array.prototype.insert = function(item2, index2) {
    const items = this.slice();
    items.splice(index2, 0, item2);
    return items;
  };
}
if (!Array.prototype.binarySearch) {
  Array.prototype.binarySearch = function(target, comparator) {
    var l = 0, h = this.length - 1, m, comparison;
    comparator = comparator || function(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    };
    while (l <= h) {
      m = l + h >>> 1;
      comparison = comparator(this[m], target);
      if (comparison < 0) {
        l = m + 1;
      } else if (comparison > 0) {
        h = m - 1;
      } else {
        return m;
      }
    }
    return ~l;
  };
}
if (!Array.prototype.binaryInsert) {
  Array.prototype.binaryInsert = function(target, duplicate, comparator) {
    const items = this.slice();
    var i = items.binarySearch(target, comparator);
    if (i >= 0) {
      if (!duplicate) {
        return { index: i, items };
      }
    } else {
      i = ~i;
    }
    items.splice(i, 0, target);
    return { index: i, items };
  };
}
if (!Array.prototype.distinct) {
  Array.prototype.distinct = function() {
    return this.filter((value, index2, array4) => array4.indexOf(value) === index2);
  };
}
if (!Array.prototype.distinctBy) {
  Array.prototype.distinctBy = function(field) {
    return this.filter((a, i) => this.findIndex((s) => field(a) === field(s)) === i);
  };
}
if (!Array.prototype.flat) {
  Array.prototype.flat = function(depth = Infinity) {
    return this.reduce(function(flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
    }, []);
  };
}
if (!Array.prototype.shuffle) {
  Array.prototype.shuffle = function() {
    let q = this.slice();
    for (let i = q.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [q[i], q[j]] = [q[j], q[i]];
    }
    return q;
  };
}
if (!Number.prototype.inBetween) {
  Number.prototype.inBetween = function(from2, to, includeBounds = true) {
    if (includeBounds) {
      return this >= from2 && this <= to;
    } else {
      return this > from2 && this < to;
    }
  };
}
if (!Number.prototype.toFixedValue) {
  Number.prototype.toFixedValue = function(fixed, truncateIfZero) {
    const intPart = Math.trunc(this);
    const fractPart = this - intPart;
    if (truncateIfZero === true && fractPart == 0)
      return intPart.toString();
    return this.toFixed(fixed);
  };
}
if (!Storage.prototype.getItemOrDefault) {
  Storage.prototype.getItemOrDefault = function(key, defaultItem, parse2) {
    const val = localStorage.getItem(key);
    if (val == null) return defaultItem;
    if (!parse2) return val;
    return parse2(val);
  };
}
if (!Storage.prototype.getJsonOrDefault) {
  Storage.prototype.getJsonOrDefault = function(key, defaultItem) {
    return localStorage.getItemOrDefault(key, defaultItem, (x) => JSON.parse(x));
  };
}
if (!Storage.prototype.setJson) {
  Storage.prototype.setJson = function(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
  };
}
if (!console.logDev) {
  console.logDev = function(message2, ...optionalParams) {
    if (isDev)
      console.log(message2, optionalParams);
  };
}
if (!location.getReferral) {
  location.getReferral = function() {
    return location.pathname + location.search + location.hash;
  };
}
if (!String.prototype.trimSpaces) {
  String.prototype.trimSpaces = function(removeInnerSpaces = true) {
    if (!removeInnerSpaces) return this.trim();
    return this.trim().replace(" ", "");
  };
}
if (!String.prototype.isValidEmail) {
  String.prototype.isValidEmail = function() {
    const match2 = this.match(/^[_a-zA-Z0-9][a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-.]{0,61}[a-zA-Z0-9])?)$/);
    return match2 != null;
  };
}
if (!String.prototype.isValidUrl) {
  String.prototype.isValidUrl = function() {
    try {
      new URL(this?.toString());
      return true;
    } catch (e) {
      return false;
    }
  };
}
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(padString || " ");
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}
if (!String.prototype.capitalize) {
  String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
}
if (!HTMLElement.prototype.isVisible) {
  HTMLElement.prototype.isVisible = function() {
    return !!(this.offsetWidth || this.offsetHeight || this.getClientRects().length);
  };
}
if (!URL.prototype.toDecodedString) {
  URL.prototype.toDecodedString = function() {
    return decodeURI(this.toString());
  };
}
const Chat = ({ defaultPosition = { top: 0, left: 0 }, floating, phoneController, className, classNameWrapper, components, handler, onChangePosition }) => {
  const loc = useLoc();
  const controller = useChat();
  const handlerRef = useRef(null);
  const { deviceStore, settings } = useContext(ChatContext);
  const isMobile = useMemo$2(() => {
    return deviceStore.deviceSize == "mobile";
  }, [deviceStore.deviceSize]);
  const minHeight = useMemo$2(() => {
    return deviceStore.height <= 500 ? deviceStore.height - 20 : "500px";
  }, [deviceStore.height]);
  const [_2, srcRef] = useDimensions({
    throttleDelay: TimeSpan.fromMilliseconds(100),
    onChange: (size2) => controller.setSize(size2)
  });
  useEffect(() => {
    handler?.(controller);
    controller.connect();
  }, []);
  useEffect(() => {
    if (!floating)
      controller.open();
  }, [floating]);
  useEffect(() => {
    if (phoneController) {
      controller.setPhoneController(phoneController);
    }
  }, [phoneController]);
  useBeforeUnload(useCallback((e) => {
    if (!controller.hasBlockingActions) return false;
    e.preventDefault();
    e.returnValue = true;
    return true;
  }, [controller.hasBlockingActions]));
  if (!controller.inited) return null;
  const chatContent = /* @__PURE__ */ jsx$1(ChatStyleProvider$1, { settings, children: /* @__PURE__ */ jsxs(
    "div",
    {
      ref: srcRef,
      className: combineClasses(styles$u.chat_wrapper, "bg-white relative", classNameWrapper),
      style: { minHeight },
      "data-conversation": controller.hasSelectedConversation,
      "data-mode": controller.mode,
      children: [
        /* @__PURE__ */ jsx$1(Access, { roles: [ChatUserRole.Admin], children: /* @__PURE__ */ jsx$1(ConversationsColumn, { headerActionsButton: components?.headerActionsButton }) }),
        /* @__PURE__ */ jsx$1(ConversationColumn$1, {}, controller.selectedConversationId),
        /* @__PURE__ */ jsx$1(Access, { roles: [ChatUserRole.Admin], children: /* @__PURE__ */ jsx$1(InfoColumn$1, {}) }),
        /* @__PURE__ */ jsx$1(
          Modal,
          {
            open: controller.settingsVisible,
            title: loc.word("Chat.settingsLabel", { default: "Settings" }),
            onCancel: () => controller.setSettingsVisible(false),
            destroyOnClose: true,
            footer: null,
            width: 400,
            className: "p-0",
            children: /* @__PURE__ */ jsx$1(ChatSettingsForm$1, {})
          }
        ),
        /* @__PURE__ */ jsx$1(Access, { roles: [ChatUserRole.Admin], children: /* @__PURE__ */ jsx$1(
          Drawer,
          {
            open: controller.newConversationVisible,
            title: loc.word("Chat.newConversationLabel", { default: "New conversation" }),
            getContainer: false,
            onClose: () => controller.setNewConversationVisible(false),
            destroyOnClose: true,
            footer: null,
            className: combineClasses(styles$u.chat_drawer, "absolute"),
            placement: "left",
            children: /* @__PURE__ */ jsx$1(
              AddConversationForm$1,
              {
                visible: controller.newConversationVisible,
                onSuccess: () => controller.setNewConversationVisible(false)
              }
            )
          }
        ) })
      ]
    }
  ) });
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: combineClasses(styles$u.chat, className),
      "data-visible": controller.visible,
      "data-mobile": isMobile,
      children: floating === true ? /* @__PURE__ */ jsx$1(
        ChatFloating,
        {
          defaultPosition,
          draggable: !isMobile,
          isMobile,
          stickToTop: deviceStore.height <= 500,
          onChangePosition: (x) => onChangePosition?.(x),
          handlerRef,
          children: chatContent
        }
      ) : chatContent
    }
  );
};
const Chat_default = observer(Chat);
var client = { exports: {} };
var reactDomClient_production = {};
var scheduler = { exports: {} };
var scheduler_production = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production;
function requireScheduler_production() {
  if (hasRequiredScheduler_production) return scheduler_production;
  hasRequiredScheduler_production = 1;
  (function(exports$1) {
    function push(heap, node2) {
      var index2 = heap.length;
      heap.push(node2);
      a: for (; 0 < index2; ) {
        var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node2))
          heap[parentIndex] = node2, heap[index2] = parent, index2 = parentIndex;
        else break a;
      }
    }
    function peek2(heap) {
      return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
      if (0 === heap.length) return null;
      var first = heap[0], last = heap.pop();
      if (last !== first) {
        heap[0] = last;
        a: for (var index2 = 0, length2 = heap.length, halfLength = length2 >>> 1; index2 < halfLength; ) {
          var leftIndex = 2 * (index2 + 1) - 1, left2 = heap[leftIndex], rightIndex = leftIndex + 1, right2 = heap[rightIndex];
          if (0 > compare(left2, last))
            rightIndex < length2 && 0 > compare(right2, left2) ? (heap[index2] = right2, heap[rightIndex] = last, index2 = rightIndex) : (heap[index2] = left2, heap[leftIndex] = last, index2 = leftIndex);
          else if (rightIndex < length2 && 0 > compare(right2, last))
            heap[index2] = right2, heap[rightIndex] = last, index2 = rightIndex;
          else break a;
        }
      }
      return first;
    }
    function compare(a, b) {
      var diff = a.sortIndex - b.sortIndex;
      return 0 !== diff ? diff : a.id - b.id;
    }
    exports$1.unstable_now = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      exports$1.unstable_now = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date, initialTime = localDate.now();
      exports$1.unstable_now = function() {
        return localDate.now() - initialTime;
      };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
    function advanceTimers(currentTime) {
      for (var timer = peek2(timerQueue); null !== timer; ) {
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime)
          pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek2(timerQueue);
      }
    }
    function handleTimeout(currentTime) {
      isHostTimeoutScheduled = false;
      advanceTimers(currentTime);
      if (!isHostCallbackScheduled)
        if (null !== peek2(taskQueue))
          isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
        else {
          var firstTimer = peek2(timerQueue);
          null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
    var isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    function shouldYieldToHost() {
      return needsPaint ? true : exports$1.unstable_now() - startTime < frameInterval ? false : true;
    }
    function performWorkUntilDeadline() {
      needsPaint = false;
      if (isMessageLoopRunning) {
        var currentTime = exports$1.unstable_now();
        startTime = currentTime;
        var hasMoreWork = true;
        try {
          a: {
            isHostCallbackScheduled = false;
            isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
            isPerformingWork = true;
            var previousPriorityLevel = currentPriorityLevel;
            try {
              b: {
                advanceTimers(currentTime);
                for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                  var callback = currentTask.callback;
                  if ("function" === typeof callback) {
                    currentTask.callback = null;
                    currentPriorityLevel = currentTask.priorityLevel;
                    var continuationCallback = callback(
                      currentTask.expirationTime <= currentTime
                    );
                    currentTime = exports$1.unstable_now();
                    if ("function" === typeof continuationCallback) {
                      currentTask.callback = continuationCallback;
                      advanceTimers(currentTime);
                      hasMoreWork = true;
                      break b;
                    }
                    currentTask === peek2(taskQueue) && pop(taskQueue);
                    advanceTimers(currentTime);
                  } else pop(taskQueue);
                  currentTask = peek2(taskQueue);
                }
                if (null !== currentTask) hasMoreWork = true;
                else {
                  var firstTimer = peek2(timerQueue);
                  null !== firstTimer && requestHostTimeout(
                    handleTimeout,
                    firstTimer.startTime - currentTime
                  );
                  hasMoreWork = false;
                }
              }
              break a;
            } finally {
              currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
            }
            hasMoreWork = void 0;
          }
        } finally {
          hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
        }
      }
    }
    var schedulePerformWorkUntilDeadline;
    if ("function" === typeof localSetImmediate)
      schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
      };
    else if ("undefined" !== typeof MessageChannel) {
      var channel = new MessageChannel(), port = channel.port2;
      channel.port1.onmessage = performWorkUntilDeadline;
      schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
      };
    } else
      schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
      };
    function requestHostTimeout(callback, ms) {
      taskTimeoutID = localSetTimeout(function() {
        callback(exports$1.unstable_now());
      }, ms);
    }
    exports$1.unstable_IdlePriority = 5;
    exports$1.unstable_ImmediatePriority = 1;
    exports$1.unstable_LowPriority = 4;
    exports$1.unstable_NormalPriority = 3;
    exports$1.unstable_Profiling = null;
    exports$1.unstable_UserBlockingPriority = 2;
    exports$1.unstable_cancelCallback = function(task) {
      task.callback = null;
    };
    exports$1.unstable_forceFrameRate = function(fps) {
      0 > fps || 125 < fps ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    exports$1.unstable_getCurrentPriorityLevel = function() {
      return currentPriorityLevel;
    };
    exports$1.unstable_next = function(eventHandler) {
      switch (currentPriorityLevel) {
        case 1:
        case 2:
        case 3:
          var priorityLevel = 3;
          break;
        default:
          priorityLevel = currentPriorityLevel;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports$1.unstable_requestPaint = function() {
      needsPaint = true;
    };
    exports$1.unstable_runWithPriority = function(priorityLevel, eventHandler) {
      switch (priorityLevel) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          priorityLevel = 3;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports$1.unstable_scheduleCallback = function(priorityLevel, callback, options) {
      var currentTime = exports$1.unstable_now();
      "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
      switch (priorityLevel) {
        case 1:
          var timeout = -1;
          break;
        case 2:
          timeout = 250;
          break;
        case 5:
          timeout = 1073741823;
          break;
        case 4:
          timeout = 1e4;
          break;
        default:
          timeout = 5e3;
      }
      timeout = options + timeout;
      priorityLevel = {
        id: taskIdCounter++,
        callback,
        priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
      };
      options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
      return priorityLevel;
    };
    exports$1.unstable_shouldYield = shouldYieldToHost;
    exports$1.unstable_wrapCallback = function(callback) {
      var parentPriorityLevel = currentPriorityLevel;
      return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
          return callback.apply(this, arguments);
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
    };
  })(scheduler_production);
  return scheduler_production;
}
var scheduler_development = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_development;
function requireScheduler_development() {
  if (hasRequiredScheduler_development) return scheduler_development;
  hasRequiredScheduler_development = 1;
  (function(exports$1) {
    "production" !== process.env.NODE_ENV && (function() {
      function performWorkUntilDeadline() {
        needsPaint = false;
        if (isMessageLoopRunning) {
          var currentTime = exports$1.unstable_now();
          startTime = currentTime;
          var hasMoreWork = true;
          try {
            a: {
              isHostCallbackScheduled = false;
              isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
              isPerformingWork = true;
              var previousPriorityLevel = currentPriorityLevel;
              try {
                b: {
                  advanceTimers(currentTime);
                  for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                    var callback = currentTask.callback;
                    if ("function" === typeof callback) {
                      currentTask.callback = null;
                      currentPriorityLevel = currentTask.priorityLevel;
                      var continuationCallback = callback(
                        currentTask.expirationTime <= currentTime
                      );
                      currentTime = exports$1.unstable_now();
                      if ("function" === typeof continuationCallback) {
                        currentTask.callback = continuationCallback;
                        advanceTimers(currentTime);
                        hasMoreWork = true;
                        break b;
                      }
                      currentTask === peek2(taskQueue) && pop(taskQueue);
                      advanceTimers(currentTime);
                    } else pop(taskQueue);
                    currentTask = peek2(taskQueue);
                  }
                  if (null !== currentTask) hasMoreWork = true;
                  else {
                    var firstTimer = peek2(timerQueue);
                    null !== firstTimer && requestHostTimeout(
                      handleTimeout,
                      firstTimer.startTime - currentTime
                    );
                    hasMoreWork = false;
                  }
                }
                break a;
              } finally {
                currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
              }
              hasMoreWork = void 0;
            }
          } finally {
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
          }
        }
      }
      function push(heap, node2) {
        var index2 = heap.length;
        heap.push(node2);
        a: for (; 0 < index2; ) {
          var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
          if (0 < compare(parent, node2))
            heap[parentIndex] = node2, heap[index2] = parent, index2 = parentIndex;
          else break a;
        }
      }
      function peek2(heap) {
        return 0 === heap.length ? null : heap[0];
      }
      function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
          heap[0] = last;
          a: for (var index2 = 0, length2 = heap.length, halfLength = length2 >>> 1; index2 < halfLength; ) {
            var leftIndex = 2 * (index2 + 1) - 1, left2 = heap[leftIndex], rightIndex = leftIndex + 1, right2 = heap[rightIndex];
            if (0 > compare(left2, last))
              rightIndex < length2 && 0 > compare(right2, left2) ? (heap[index2] = right2, heap[rightIndex] = last, index2 = rightIndex) : (heap[index2] = left2, heap[leftIndex] = last, index2 = leftIndex);
            else if (rightIndex < length2 && 0 > compare(right2, last))
              heap[index2] = right2, heap[rightIndex] = last, index2 = rightIndex;
            else break a;
          }
        }
        return first;
      }
      function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
      }
      function advanceTimers(currentTime) {
        for (var timer = peek2(timerQueue); null !== timer; ) {
          if (null === timer.callback) pop(timerQueue);
          else if (timer.startTime <= currentTime)
            pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
          else break;
          timer = peek2(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled)
          if (null !== peek2(taskQueue))
            isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
          else {
            var firstTimer = peek2(timerQueue);
            null !== firstTimer && requestHostTimeout(
              handleTimeout,
              firstTimer.startTime - currentTime
            );
          }
      }
      function shouldYieldToHost() {
        return needsPaint ? true : exports$1.unstable_now() - startTime < frameInterval ? false : true;
      }
      function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
          callback(exports$1.unstable_now());
        }, ms);
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      exports$1.unstable_now = void 0;
      if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        exports$1.unstable_now = function() {
          return localPerformance.now();
        };
      } else {
        var localDate = Date, initialTime = localDate.now();
        exports$1.unstable_now = function() {
          return localDate.now() - initialTime;
        };
      }
      var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
      if ("function" === typeof localSetImmediate)
        var schedulePerformWorkUntilDeadline = function() {
          localSetImmediate(performWorkUntilDeadline);
        };
      else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
          port.postMessage(null);
        };
      } else
        schedulePerformWorkUntilDeadline = function() {
          localSetTimeout(performWorkUntilDeadline, 0);
        };
      exports$1.unstable_IdlePriority = 5;
      exports$1.unstable_ImmediatePriority = 1;
      exports$1.unstable_LowPriority = 4;
      exports$1.unstable_NormalPriority = 3;
      exports$1.unstable_Profiling = null;
      exports$1.unstable_UserBlockingPriority = 2;
      exports$1.unstable_cancelCallback = function(task) {
        task.callback = null;
      };
      exports$1.unstable_forceFrameRate = function(fps) {
        0 > fps || 125 < fps ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
      };
      exports$1.unstable_getCurrentPriorityLevel = function() {
        return currentPriorityLevel;
      };
      exports$1.unstable_next = function(eventHandler) {
        switch (currentPriorityLevel) {
          case 1:
          case 2:
          case 3:
            var priorityLevel = 3;
            break;
          default:
            priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports$1.unstable_requestPaint = function() {
        needsPaint = true;
      };
      exports$1.unstable_runWithPriority = function(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports$1.unstable_scheduleCallback = function(priorityLevel, callback, options) {
        var currentTime = exports$1.unstable_now();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch (priorityLevel) {
          case 1:
            var timeout = -1;
            break;
          case 2:
            timeout = 250;
            break;
          case 5:
            timeout = 1073741823;
            break;
          case 4:
            timeout = 1e4;
            break;
          default:
            timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
          id: taskIdCounter++,
          callback,
          priorityLevel,
          startTime: options,
          expirationTime: timeout,
          sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
      };
      exports$1.unstable_shouldYield = shouldYieldToHost;
      exports$1.unstable_wrapCallback = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      };
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(scheduler_development);
  return scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler) return scheduler.exports;
  hasRequiredScheduler = 1;
  if (process.env.NODE_ENV === "production") {
    scheduler.exports = requireScheduler_production();
  } else {
    scheduler.exports = requireScheduler_development();
  }
  return scheduler.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomClient_production;
function requireReactDomClient_production() {
  if (hasRequiredReactDomClient_production) return reactDomClient_production;
  hasRequiredReactDomClient_production = 1;
  var Scheduler = requireScheduler(), React2 = React__default, ReactDOM$1 = ReactDOM;
  function formatProdErrorMessage(code) {
    var url2 = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url2 += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url2 += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function isValidContainer(node2) {
    return !(!node2 || 1 !== node2.nodeType && 9 !== node2.nodeType && 11 !== node2.nodeType);
  }
  function getNearestMountedFiber(fiber) {
    var node2 = fiber, nearestMounted = fiber;
    if (fiber.alternate) for (; node2.return; ) node2 = node2.return;
    else {
      fiber = node2;
      do
        node2 = fiber, 0 !== (node2.flags & 4098) && (nearestMounted = node2.return), fiber = node2.return;
      while (fiber);
    }
    return 3 === node2.tag ? nearestMounted : null;
  }
  function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
      var suspenseState = fiber.memoizedState;
      null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
      if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
  }
  function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber)
      throw Error(formatProdErrorMessage(188));
  }
  function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
      alternate = getNearestMountedFiber(fiber);
      if (null === alternate) throw Error(formatProdErrorMessage(188));
      return alternate !== fiber ? null : fiber;
    }
    for (var a = fiber, b = alternate; ; ) {
      var parentA = a.return;
      if (null === parentA) break;
      var parentB = parentA.alternate;
      if (null === parentB) {
        b = parentA.return;
        if (null !== b) {
          a = b;
          continue;
        }
        break;
      }
      if (parentA.child === parentB.child) {
        for (parentB = parentA.child; parentB; ) {
          if (parentB === a) return assertIsMounted(parentA), fiber;
          if (parentB === b) return assertIsMounted(parentA), alternate;
          parentB = parentB.sibling;
        }
        throw Error(formatProdErrorMessage(188));
      }
      if (a.return !== b.return) a = parentA, b = parentB;
      else {
        for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
          if (child$0 === a) {
            didFindChild = true;
            a = parentA;
            b = parentB;
            break;
          }
          if (child$0 === b) {
            didFindChild = true;
            b = parentA;
            a = parentB;
            break;
          }
          child$0 = child$0.sibling;
        }
        if (!didFindChild) {
          for (child$0 = parentB.child; child$0; ) {
            if (child$0 === a) {
              didFindChild = true;
              a = parentB;
              b = parentA;
              break;
            }
            if (child$0 === b) {
              didFindChild = true;
              b = parentB;
              a = parentA;
              break;
            }
            child$0 = child$0.sibling;
          }
          if (!didFindChild) throw Error(formatProdErrorMessage(189));
        }
      }
      if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
  }
  function findCurrentHostFiberImpl(node2) {
    var tag = node2.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node2;
    for (node2 = node2.child; null !== node2; ) {
      tag = findCurrentHostFiberImpl(node2);
      if (null !== tag) return tag;
      node2 = node2.sibling;
    }
    return null;
  }
  var assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE2 = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
  var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
  var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
  var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function getComponentNameFromType(type4) {
    if (null == type4) return null;
    if ("function" === typeof type4)
      return type4.$$typeof === REACT_CLIENT_REFERENCE ? null : type4.displayName || type4.name || null;
    if ("string" === typeof type4) return type4;
    switch (type4) {
      case REACT_FRAGMENT_TYPE2:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type4)
      switch (type4.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return (type4.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
          return (type4._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type4.render;
          type4 = type4.displayName;
          type4 || (type4 = innerType.displayName || innerType.name || "", type4 = "" !== type4 ? "ForwardRef(" + type4 + ")" : "ForwardRef");
          return type4;
        case REACT_MEMO_TYPE:
          return innerType = type4.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type4.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type4._payload;
          type4 = type4._init;
          try {
            return getComponentNameFromType(type4(innerType));
          } catch (x) {
          }
      }
    return null;
  }
  var isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM$1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, valueStack = [], index2 = -1;
  function createCursor(defaultValue) {
    return { current: defaultValue };
  }
  function pop(cursor2) {
    0 > index2 || (cursor2.current = valueStack[index2], valueStack[index2] = null, index2--);
  }
  function push(cursor2, value) {
    index2++;
    valueStack[index2] = cursor2.current;
    cursor2.current = value;
  }
  var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
  function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch (nextRootInstance.nodeType) {
      case 9:
      case 11:
        fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
        break;
      default:
        if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
          nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
        else
          switch (fiber) {
            case "svg":
              fiber = 1;
              break;
            case "math":
              fiber = 2;
              break;
            default:
              fiber = 0;
          }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
  }
  function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
  }
  function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context2 = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context2, fiber.type);
    context2 !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
  }
  function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
  function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode)
      try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
      } catch (err) {
      }
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log2 = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log2(x) / LN2 | 0) | 0;
  }
  var nextTransitionLane = 256, nextRetryLane = 4194304;
  function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch (lanes & -lanes) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return lanes & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return lanes & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return lanes;
    }
  }
  function getNextLanes(root2, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root2.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes;
    root2 = root2.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
  }
  function checkIfRootIsPrerendering(root2, renderLanes2) {
    return 0 === (root2.pendingLanes & ~(root2.suspendedLanes & ~root2.pingedLanes) & renderLanes2);
  }
  function computeExpirationTime(lane, currentTime) {
    switch (lane) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return currentTime + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return currentTime + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
  }
  function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
  }
  function createLaneMap(initial2) {
    for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial2);
    return laneMap;
  }
  function markRootUpdated$1(root2, updateLane) {
    root2.pendingLanes |= updateLane;
    268435456 !== updateLane && (root2.suspendedLanes = 0, root2.pingedLanes = 0, root2.warmLanes = 0);
  }
  function markRootFinished(root2, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root2.pendingLanes;
    root2.pendingLanes = remainingLanes;
    root2.suspendedLanes = 0;
    root2.pingedLanes = 0;
    root2.warmLanes = 0;
    root2.expiredLanes &= remainingLanes;
    root2.entangledLanes &= remainingLanes;
    root2.errorRecoveryDisabledLanes &= remainingLanes;
    root2.shellSuspendCounter = 0;
    var entanglements = root2.entanglements, expirationTimes = root2.expirationTimes, hiddenUpdates = root2.hiddenUpdates;
    for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
      var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
      entanglements[index$5] = 0;
      expirationTimes[index$5] = -1;
      var hiddenUpdatesForLane = hiddenUpdates[index$5];
      if (null !== hiddenUpdatesForLane)
        for (hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++) {
          var update2 = hiddenUpdatesForLane[index$5];
          null !== update2 && (update2.lane &= -536870913);
        }
      remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root2.tag && (root2.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
  }
  function markSpawnedDeferredLane(root2, spawnedLane, entangledLanes) {
    root2.pendingLanes |= spawnedLane;
    root2.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root2.entangledLanes |= spawnedLane;
    root2.entanglements[spawnedLaneIndex] = root2.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
  }
  function markRootEntangled(root2, entangledLanes) {
    var rootEntangledLanes = root2.entangledLanes |= entangledLanes;
    for (root2 = root2.entanglements; rootEntangledLanes; ) {
      var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
      lane & entangledLanes | root2[index$6] & entangledLanes && (root2[index$6] |= entangledLanes);
      rootEntangledLanes &= ~lane;
    }
  }
  function getBumpedLaneForHydrationByLane(lane) {
    switch (lane) {
      case 2:
        lane = 1;
        break;
      case 8:
        lane = 4;
        break;
      case 32:
        lane = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        lane = 128;
        break;
      case 268435456:
        lane = 134217728;
        break;
      default:
        lane = 0;
    }
    return lane;
  }
  function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
  }
  function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
  }
  function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      return ReactDOMSharedInternals.p = priority, fn();
    } finally {
      ReactDOMSharedInternals.p = previousPriority;
    }
  }
  var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
  function detachDeletedInstance(node2) {
    delete node2[internalInstanceKey];
    delete node2[internalPropsKey];
    delete node2[internalEventHandlersKey];
    delete node2[internalEventHandlerListenersKey];
    delete node2[internalEventHandlesSetKey];
  }
  function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for (var parentNode = targetNode.parentNode; parentNode; ) {
      if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
        parentNode = targetInst.alternate;
        if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
          for (targetNode = getParentSuspenseInstance(targetNode); null !== targetNode; ) {
            if (parentNode = targetNode[internalInstanceKey]) return parentNode;
            targetNode = getParentSuspenseInstance(targetNode);
          }
        return targetInst;
      }
      targetNode = parentNode;
      parentNode = targetNode.parentNode;
    }
    return null;
  }
  function getInstanceFromNode(node2) {
    if (node2 = node2[internalInstanceKey] || node2[internalContainerInstanceKey]) {
      var tag = node2.tag;
      if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag)
        return node2;
    }
    return null;
  }
  function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
  }
  function getResourcesFromRoot(root2) {
    var resources = root2[internalRootNodeResourcesKey];
    resources || (resources = root2[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
    return resources;
  }
  function markNodeAsHoistable(node2) {
    node2[internalHoistableMarker] = true;
  }
  var allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {};
  function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
  }
  function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for (registrationName = 0; registrationName < dependencies.length; registrationName++)
      allNativeEvents.add(dependencies[registrationName]);
  }
  var VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  function setValueForAttribute(node2, name, value) {
    if (isAttributeNameSafe(name))
      if (null === value) node2.removeAttribute(name);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            node2.removeAttribute(name);
            return;
          case "boolean":
            var prefix$8 = name.toLowerCase().slice(0, 5);
            if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
              node2.removeAttribute(name);
              return;
            }
        }
        node2.setAttribute(name, "" + value);
      }
  }
  function setValueForKnownAttribute(node2, name, value) {
    if (null === value) node2.removeAttribute(name);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node2.removeAttribute(name);
          return;
      }
      node2.setAttribute(name, "" + value);
    }
  }
  function setValueForNamespacedAttribute(node2, namespace, name, value) {
    if (null === value) node2.removeAttribute(name);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node2.removeAttribute(name);
          return;
      }
      node2.setAttributeNS(namespace, name, "" + value);
    }
  }
  var prefix2, suffix;
  function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix2)
      try {
        throw Error();
      } catch (x) {
        var match2 = x.stack.trim().match(/\n( *(at )?)/);
        prefix2 = match2 && match2[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix2 + name + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn, construct2) {
    if (!fn || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct2) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  var control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$9) {
                  control = x$9;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$10) {
                control = x$10;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample) {
            if (sample && control && "string" === typeof sample.stack)
              return [sample.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeFiber(fiber) {
    switch (fiber.tag) {
      case 26:
      case 27:
      case 5:
        return describeBuiltInComponentFrame(fiber.type);
      case 16:
        return describeBuiltInComponentFrame("Lazy");
      case 13:
        return describeBuiltInComponentFrame("Suspense");
      case 19:
        return describeBuiltInComponentFrame("SuspenseList");
      case 0:
      case 15:
        return describeNativeComponentFrame(fiber.type, false);
      case 11:
        return describeNativeComponentFrame(fiber.type.render, false);
      case 1:
        return describeNativeComponentFrame(fiber.type, true);
      case 31:
        return describeBuiltInComponentFrame("Activity");
      default:
        return "";
    }
  }
  function getStackByFiberInDevAndProd(workInProgress2) {
    try {
      var info = "";
      do
        info += describeFiber(workInProgress2), workInProgress2 = workInProgress2.return;
      while (workInProgress2);
      return info;
    } catch (x) {
      return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
  }
  function getToStringValue(value) {
    switch (typeof value) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return value;
      case "object":
        return value;
      default:
        return "";
    }
  }
  function isCheckable(elem) {
    var type4 = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type4 || "radio" === type4);
  }
  function trackValueOnNode(node2) {
    var valueField = isCheckable(node2) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(
      node2.constructor.prototype,
      valueField
    ), currentValue = "" + node2[valueField];
    if (!node2.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
      var get4 = descriptor.get, set2 = descriptor.set;
      Object.defineProperty(node2, valueField, {
        configurable: true,
        get: function() {
          return get4.call(this);
        },
        set: function(value) {
          currentValue = "" + value;
          set2.call(this, value);
        }
      });
      Object.defineProperty(node2, valueField, {
        enumerable: descriptor.enumerable
      });
      return {
        getValue: function() {
          return currentValue;
        },
        setValue: function(value) {
          currentValue = "" + value;
        },
        stopTracking: function() {
          node2._valueTracker = null;
          delete node2[valueField];
        }
      };
    }
  }
  function track(node2) {
    node2._valueTracker || (node2._valueTracker = trackValueOnNode(node2));
  }
  function updateValueIfChanged(node2) {
    if (!node2) return false;
    var tracker = node2._valueTracker;
    if (!tracker) return true;
    var lastValue = tracker.getValue();
    var value = "";
    node2 && (value = isCheckable(node2) ? node2.checked ? "true" : "false" : node2.value);
    node2 = value;
    return node2 !== lastValue ? (tracker.setValue(node2), true) : false;
  }
  function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
      return doc.activeElement || doc.body;
    } catch (e) {
      return doc.body;
    }
  }
  var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
  function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(
      escapeSelectorAttributeValueInsideDoubleQuotesRegex,
      function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type4, name) {
    element.name = "";
    null != type4 && "function" !== typeof type4 && "symbol" !== typeof type4 && "boolean" !== typeof type4 ? element.type = type4 : element.removeAttribute("type");
    if (null != value)
      if ("number" === type4) {
        if (0 === value && "" === element.value || element.value != value)
          element.value = "" + getToStringValue(value);
      } else
        element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    else
      "submit" !== type4 && "reset" !== type4 || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type4, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type4, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
  }
  function initInput(element, value, defaultValue, checked, defaultChecked, type4, name, isHydrating2) {
    null != type4 && "function" !== typeof type4 && "symbol" !== typeof type4 && "boolean" !== typeof type4 && (element.type = type4);
    if (null != value || null != defaultValue) {
      if (!("submit" !== type4 && "reset" !== type4 || void 0 !== value && null !== value))
        return;
      defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
      value = null != value ? "" + getToStringValue(value) : defaultValue;
      isHydrating2 || value === element.value || (element.value = value);
      element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating2 ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
  }
  function setDefaultValue(node2, type4, value) {
    "number" === type4 && getActiveElement(node2.ownerDocument) === node2 || node2.defaultValue === "" + value || (node2.defaultValue = "" + value);
  }
  function updateOptions(node2, multiple, propValue, setDefaultSelected) {
    node2 = node2.options;
    if (multiple) {
      multiple = {};
      for (var i = 0; i < propValue.length; i++)
        multiple["$" + propValue[i]] = true;
      for (propValue = 0; propValue < node2.length; propValue++)
        i = multiple.hasOwnProperty("$" + node2[propValue].value), node2[propValue].selected !== i && (node2[propValue].selected = i), i && setDefaultSelected && (node2[propValue].defaultSelected = true);
    } else {
      propValue = "" + getToStringValue(propValue);
      multiple = null;
      for (i = 0; i < node2.length; i++) {
        if (node2[i].value === propValue) {
          node2[i].selected = true;
          setDefaultSelected && (node2[i].defaultSelected = true);
          return;
        }
        null !== multiple || node2[i].disabled || (multiple = node2[i]);
      }
      null !== multiple && (multiple.selected = true);
    }
  }
  function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
      element.defaultValue !== value && (element.defaultValue = value);
      return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
  }
  function initTextarea(element, value, defaultValue, children2) {
    if (null == value) {
      if (null != children2) {
        if (null != defaultValue) throw Error(formatProdErrorMessage(92));
        if (isArrayImpl(children2)) {
          if (1 < children2.length) throw Error(formatProdErrorMessage(93));
          children2 = children2[0];
        }
        defaultValue = children2;
      }
      null == defaultValue && (defaultValue = "");
      value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children2 = element.textContent;
    children2 === defaultValue && "" !== children2 && null !== children2 && (element.value = children2);
  }
  function setTextContent(node2, text2) {
    if (text2) {
      var firstChild = node2.firstChild;
      if (firstChild && firstChild === node2.lastChild && 3 === firstChild.nodeType) {
        firstChild.nodeValue = text2;
        return;
      }
    }
    node2.textContent = text2;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function setValueForStyle(style3, styleName, value) {
    var isCustomProperty3 = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty3 ? style3.setProperty(styleName, "") : "float" === styleName ? style3.cssFloat = "" : style3[styleName] = "" : isCustomProperty3 ? style3.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style3.cssFloat = value : style3[styleName] = ("" + value).trim() : style3[styleName] = value + "px";
  }
  function setValueForStyles(node2, styles2, prevStyles) {
    if (null != styles2 && "object" !== typeof styles2)
      throw Error(formatProdErrorMessage(62));
    node2 = node2.style;
    if (null != prevStyles) {
      for (var styleName in prevStyles)
        !prevStyles.hasOwnProperty(styleName) || null != styles2 && styles2.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node2.setProperty(styleName, "") : "float" === styleName ? node2.cssFloat = "" : node2[styleName] = "");
      for (var styleName$16 in styles2)
        styleName = styles2[styleName$16], styles2.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node2, styleName$16, styleName);
    } else
      for (var styleName$17 in styles2)
        styles2.hasOwnProperty(styleName$17) && setValueForStyle(node2, styleName$17, styles2[styleName$17]);
  }
  function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return false;
    switch (tagName) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var aliases2 = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url2) {
    return isJavaScriptProtocol.test("" + url2) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url2;
  }
  var currentReplayingEvent = null;
  function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
  }
  var restoreTarget = null, restoreQueue = null;
  function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
      var props = target[internalPropsKey] || null;
      a: switch (target = internalInstance.stateNode, internalInstance.type) {
        case "input":
          updateInput(
            target,
            props.value,
            props.defaultValue,
            props.defaultValue,
            props.checked,
            props.defaultChecked,
            props.type,
            props.name
          );
          internalInstance = props.name;
          if ("radio" === props.type && null != internalInstance) {
            for (props = target; props.parentNode; ) props = props.parentNode;
            props = props.querySelectorAll(
              'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                "" + internalInstance
              ) + '"][type="radio"]'
            );
            for (internalInstance = 0; internalInstance < props.length; internalInstance++) {
              var otherNode = props[internalInstance];
              if (otherNode !== target && otherNode.form === target.form) {
                var otherProps = otherNode[internalPropsKey] || null;
                if (!otherProps) throw Error(formatProdErrorMessage(90));
                updateInput(
                  otherNode,
                  otherProps.value,
                  otherProps.defaultValue,
                  otherProps.defaultValue,
                  otherProps.checked,
                  otherProps.defaultChecked,
                  otherProps.type,
                  otherProps.name
                );
              }
            }
            for (internalInstance = 0; internalInstance < props.length; internalInstance++)
              otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
          }
          break a;
        case "textarea":
          updateTextarea(target, props.value, props.defaultValue);
          break a;
        case "select":
          internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, false);
      }
    }
  }
  var isInsideEventHandler = false;
  function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = true;
    try {
      var JSCompiler_inline_result = fn(a);
      return JSCompiler_inline_result;
    } finally {
      if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
        if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn))
          for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
      }
    }
  }
  function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch (registrationName) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
        inst = !props;
        break a;
      default:
        inst = false;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode)
      throw Error(
        formatProdErrorMessage(231, registrationName, typeof stateNode)
      );
    return stateNode;
  }
  var canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
  if (canUseDOM2)
    try {
      var options = {};
      Object.defineProperty(options, "passive", {
        get: function() {
          passiveBrowserEventsSupported = true;
        }
      });
      window.addEventListener("test", options, options);
      window.removeEventListener("test", options, options);
    } catch (e) {
      passiveBrowserEventsSupported = false;
    }
  var root = null, startText = null, fallbackText = null;
  function getData2() {
    if (fallbackText) return fallbackText;
    var start2, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for (start2 = 0; start2 < startLength && startValue[start2] === endValue[start2]; start2++) ;
    var minEnd = startLength - start2;
    for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
    return fallbackText = endValue.slice(start2, 1 < end ? 1 - end : void 0);
  }
  function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
  }
  function functionThatReturnsTrue() {
    return true;
  }
  function functionThatReturnsFalse() {
    return false;
  }
  function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
      this._reactName = reactName;
      this._targetInst = targetInst;
      this.type = reactEventType;
      this.nativeEvent = nativeEvent;
      this.target = nativeEventTarget;
      this.currentTarget = null;
      for (var propName in Interface)
        Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
      this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
      this.isPropagationStopped = functionThatReturnsFalse;
      return this;
    }
    assign2(SyntheticBaseEvent.prototype, {
      preventDefault: function() {
        this.defaultPrevented = true;
        var event = this.nativeEvent;
        event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
      },
      stopPropagation: function() {
        var event = this.nativeEvent;
        event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
      },
      persist: function() {
      },
      isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
  }
  var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
      return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
      return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
      if ("movementX" in event) return event.movementX;
      event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
      return lastMovementX;
    },
    movementY: function(event) {
      return "movementY" in event ? event.movementY : lastMovementY;
    }
  }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
    clipboardData: function(event) {
      return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
  }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
  }
  function getEventModifierState() {
    return modifierStateGetter;
  }
  var KeyboardEventInterface = assign2({}, UIEventInterface, {
    key: function(nativeEvent) {
      if (nativeEvent.key) {
        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
        if ("Unidentified" !== key) return key;
      }
      return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
      return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
  }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
  }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
    deltaX: function(event) {
      return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
      return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
    newState: 0,
    oldState: 0
  }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
  canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
  var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = false;
  function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch (domEventName) {
      case "keyup":
        return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
      case "keydown":
        return 229 !== nativeEvent.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
  }
  var isComposing = false;
  function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch (domEventName) {
      case "compositionend":
        return getDataFromCustomEvent(nativeEvent);
      case "keypress":
        if (32 !== nativeEvent.which) return null;
        hasSpaceKeypress = true;
        return SPACEBAR_CHAR;
      case "textInput":
        return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
      default:
        return null;
    }
  }
  function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing)
      return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData2(), fallbackText = startText = root = null, isComposing = false, domEventName) : null;
    switch (domEventName) {
      case "paste":
        return null;
      case "keypress":
        if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
          if (nativeEvent.char && 1 < nativeEvent.char.length)
            return nativeEvent.char;
          if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
        }
        return null;
      case "compositionend":
        return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
      default:
        return null;
    }
  }
  var supportedInputTypes = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
  };
  function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
  }
  function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent(
      "onChange",
      "change",
      null,
      nativeEvent,
      target
    ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
  }
  var activeElement$1 = null, activeElementInst$1 = null;
  function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
  }
  function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
  }
  function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
  }
  var isInputEventSupported = false;
  if (canUseDOM2) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM2) {
      var isSupported$jscomp$inline_417 = "oninput" in document;
      if (!isSupported$jscomp$inline_417) {
        var element$jscomp$inline_418 = document.createElement("div");
        element$jscomp$inline_418.setAttribute("oninput", "return;");
        isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
      }
      JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = false;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
  }
  function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
  }
  function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
      var dispatchQueue = [];
      createAndAccumulateChangeEvent(
        dispatchQueue,
        activeElementInst$1,
        nativeEvent,
        getEventTarget(nativeEvent)
      );
      batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
  }
  function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
  }
  function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
      return getInstIfValueChanged(activeElementInst$1);
  }
  function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
  }
  function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName)
      return getInstIfValueChanged(targetInst);
  }
  function is2(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2;
  function shallowEqual2(objA, objB) {
    if (objectIs(objA, objB)) return true;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
      return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (keysB = 0; keysB < keysA.length; keysB++) {
      var currentKey = keysA[keysB];
      if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
        return false;
    }
    return true;
  }
  function getLeafNode(node2) {
    for (; node2 && node2.firstChild; ) node2 = node2.firstChild;
    return node2;
  }
  function getNodeForCharacterOffset(root2, offset) {
    var node2 = getLeafNode(root2);
    root2 = 0;
    for (var nodeEnd; node2; ) {
      if (3 === node2.nodeType) {
        nodeEnd = root2 + node2.textContent.length;
        if (root2 <= offset && nodeEnd >= offset)
          return { node: node2, offset: offset - root2 };
        root2 = nodeEnd;
      }
      a: {
        for (; node2; ) {
          if (node2.nextSibling) {
            node2 = node2.nextSibling;
            break a;
          }
          node2 = node2.parentNode;
        }
        node2 = void 0;
      }
      node2 = getLeafNode(node2);
    }
  }
  function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
  }
  function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for (var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement; ) {
      try {
        var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
      } catch (err) {
        JSCompiler_inline_result = false;
      }
      if (JSCompiler_inline_result) containerInfo = element.contentWindow;
      else break;
      element = getActiveElement(containerInfo.document);
    }
    return element;
  }
  function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
  }
  var skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false;
  function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = { start: doc.selectionStart, end: doc.selectionEnd } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
      anchorNode: doc.anchorNode,
      anchorOffset: doc.anchorOffset,
      focusNode: doc.focusNode,
      focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual2(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent(
      "onSelect",
      "select",
      null,
      nativeEvent,
      nativeEventTarget
    ), dispatchQueue.push({ event: nativeEvent, listeners: doc }), nativeEvent.target = activeElement)));
  }
  function makePrefixMap2(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
  }
  var vendorPrefixes2 = {
    animationend: makePrefixMap2("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap2("Animation", "AnimationIteration"),
    animationstart: makePrefixMap2("Animation", "AnimationStart"),
    transitionrun: makePrefixMap2("Transition", "TransitionRun"),
    transitionstart: makePrefixMap2("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap2("Transition", "TransitionCancel"),
    transitionend: makePrefixMap2("Transition", "TransitionEnd")
  }, prefixedEventNames2 = {}, style2 = {};
  canUseDOM2 && (style2 = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes2.animationend.animation, delete vendorPrefixes2.animationiteration.animation, delete vendorPrefixes2.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes2.transitionend.transition);
  function getVendorPrefixedEventName2(eventName) {
    if (prefixedEventNames2[eventName]) return prefixedEventNames2[eventName];
    if (!vendorPrefixes2[eventName]) return eventName;
    var prefixMap = vendorPrefixes2[eventName], styleProp;
    for (styleProp in prefixMap)
      if (prefixMap.hasOwnProperty(styleProp) && styleProp in style2)
        return prefixedEventNames2[eventName] = prefixMap[styleProp];
    return eventName;
  }
  var ANIMATION_END = getVendorPrefixedEventName2("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName2("animationiteration"), ANIMATION_START = getVendorPrefixedEventName2("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName2("transitionrun"), TRANSITION_START = getVendorPrefixedEventName2("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName2("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName2("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  simpleEventPluginEvents.push("scrollEnd");
  function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [domEventName]);
  }
  var CapturedStacks = /* @__PURE__ */ new WeakMap();
  function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
      var existing = CapturedStacks.get(value);
      if (void 0 !== existing) return existing;
      source = {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
      CapturedStacks.set(value, source);
      return source;
    }
    return {
      value,
      source,
      stack: getStackByFiberInDevAndProd(source)
    };
  }
  var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
  function finishQueueingConcurrentUpdates() {
    for (var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex; ) {
      var fiber = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var queue = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var update2 = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var lane = concurrentQueues[i];
      concurrentQueues[i++] = null;
      if (null !== queue && null !== update2) {
        var pending = queue.pending;
        null === pending ? update2.next = update2 : (update2.next = pending.next, pending.next = update2);
        queue.pending = update2;
      }
      0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update2, lane);
    }
  }
  function enqueueUpdate$1(fiber, queue, update2, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update2;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
  }
  function enqueueConcurrentHookUpdate(fiber, queue, update2, lane) {
    enqueueUpdate$1(fiber, queue, update2, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function markUpdateLaneFromFiberToRoot(sourceFiber, update2, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
      parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = true)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update2 && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [update2] : alternate.push(update2), update2.lane = lane | 536870912), parent) : null;
  }
  function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount)
      throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for (var parent = sourceFiber.return; null !== parent; )
      sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
  }
  var emptyContextObject = {};
  function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
  }
  function shouldConstruct(Component2) {
    Component2 = Component2.prototype;
    return !(!Component2 || !Component2.isReactComponent);
  }
  function createWorkInProgress(current, pendingProps) {
    var workInProgress2 = current.alternate;
    null === workInProgress2 ? (workInProgress2 = createFiberImplClass(
      current.tag,
      pendingProps,
      current.key,
      current.mode
    ), workInProgress2.elementType = current.elementType, workInProgress2.type = current.type, workInProgress2.stateNode = current.stateNode, workInProgress2.alternate = current, current.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null);
    workInProgress2.flags = current.flags & 65011712;
    workInProgress2.childLanes = current.childLanes;
    workInProgress2.lanes = current.lanes;
    workInProgress2.child = current.child;
    workInProgress2.memoizedProps = current.memoizedProps;
    workInProgress2.memoizedState = current.memoizedState;
    workInProgress2.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress2.dependencies = null === pendingProps ? null : { lanes: pendingProps.lanes, firstContext: pendingProps.firstContext };
    workInProgress2.sibling = current.sibling;
    workInProgress2.index = current.index;
    workInProgress2.ref = current.ref;
    workInProgress2.refCleanup = current.refCleanup;
    return workInProgress2;
  }
  function resetWorkInProgress(workInProgress2, renderLanes2) {
    workInProgress2.flags &= 65011714;
    var current = workInProgress2.alternate;
    null === current ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null) : (workInProgress2.childLanes = current.childLanes, workInProgress2.lanes = current.lanes, workInProgress2.child = current.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current.memoizedProps, workInProgress2.memoizedState = current.memoizedState, workInProgress2.updateQueue = current.updateQueue, workInProgress2.type = current.type, renderLanes2 = current.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
      lanes: renderLanes2.lanes,
      firstContext: renderLanes2.firstContext
    });
    return workInProgress2;
  }
  function createFiberFromTypeAndProps(type4, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type4;
    if ("function" === typeof type4) shouldConstruct(type4) && (fiberTag = 1);
    else if ("string" === typeof type4)
      fiberTag = isHostHoistableType(
        type4,
        pendingProps,
        contextStackCursor.current
      ) ? 26 : "html" === type4 || "head" === type4 || "body" === type4 ? 27 : 5;
    else
      a: switch (type4) {
        case REACT_ACTIVITY_TYPE:
          return type4 = createFiberImplClass(31, pendingProps, key, mode), type4.elementType = REACT_ACTIVITY_TYPE, type4.lanes = lanes, type4;
        case REACT_FRAGMENT_TYPE2:
          return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
          fiberTag = 8;
          mode |= 24;
          break;
        case REACT_PROFILER_TYPE:
          return type4 = createFiberImplClass(12, pendingProps, key, mode | 2), type4.elementType = REACT_PROFILER_TYPE, type4.lanes = lanes, type4;
        case REACT_SUSPENSE_TYPE:
          return type4 = createFiberImplClass(13, pendingProps, key, mode), type4.elementType = REACT_SUSPENSE_TYPE, type4.lanes = lanes, type4;
        case REACT_SUSPENSE_LIST_TYPE:
          return type4 = createFiberImplClass(19, pendingProps, key, mode), type4.elementType = REACT_SUSPENSE_LIST_TYPE, type4.lanes = lanes, type4;
        default:
          if ("object" === typeof type4 && null !== type4)
            switch (type4.$$typeof) {
              case REACT_PROVIDER_TYPE:
              case REACT_CONTEXT_TYPE:
                fiberTag = 10;
                break a;
              case REACT_CONSUMER_TYPE:
                fiberTag = 9;
                break a;
              case REACT_FORWARD_REF_TYPE:
                fiberTag = 11;
                break a;
              case REACT_MEMO_TYPE:
                fiberTag = 14;
                break a;
              case REACT_LAZY_TYPE:
                fiberTag = 16;
                owner = null;
                break a;
            }
          fiberTag = 29;
          pendingProps = Error(
            formatProdErrorMessage(130, null === type4 ? "null" : typeof type4, "")
          );
          owner = null;
      }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type4;
    key.type = owner;
    key.lanes = lanes;
    return key;
  }
  function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
  }
  function createFiberFromText(content2, mode, lanes) {
    content2 = createFiberImplClass(6, content2, null, mode);
    content2.lanes = lanes;
    return content2;
  }
  function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(
      4,
      null !== portal.children ? portal.children : [],
      portal.key,
      mode
    );
    mode.lanes = lanes;
    mode.stateNode = {
      containerInfo: portal.containerInfo,
      pendingChildren: null,
      implementation: portal.implementation
    };
    return mode;
  }
  var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
  function pushTreeFork(workInProgress2, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress2;
    treeForkCount = totalChildren;
  }
  function pushTreeId(workInProgress2, totalChildren, index3) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress2;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress2 = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index3 += 1;
    var length2 = 32 - clz32(totalChildren) + baseLength;
    if (30 < length2) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length2 = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index3 << baseLength | baseIdWithLeadingBit;
      treeContextOverflow = length2 + workInProgress2;
    } else
      treeContextId = 1 << length2 | index3 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
  }
  function pushMaterializedTreeId(workInProgress2) {
    null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
  }
  function popTreeContext(workInProgress2) {
    for (; workInProgress2 === treeForkProvider; )
      treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for (; workInProgress2 === treeContextProvider; )
      treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
  }
  var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(formatProdErrorMessage(519));
  function throwOnHydrationMismatch(fiber) {
    var error2 = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error2, fiber));
    throw HydrationMismatchException;
  }
  function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type4 = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch (type4) {
      case "dialog":
        listenToNonDelegatedEvent("cancel", instance);
        listenToNonDelegatedEvent("close", instance);
        break;
      case "iframe":
      case "object":
      case "embed":
        listenToNonDelegatedEvent("load", instance);
        break;
      case "video":
      case "audio":
        for (type4 = 0; type4 < mediaEventTypes.length; type4++)
          listenToNonDelegatedEvent(mediaEventTypes[type4], instance);
        break;
      case "source":
        listenToNonDelegatedEvent("error", instance);
        break;
      case "img":
      case "image":
      case "link":
        listenToNonDelegatedEvent("error", instance);
        listenToNonDelegatedEvent("load", instance);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", instance);
        break;
      case "input":
        listenToNonDelegatedEvent("invalid", instance);
        initInput(
          instance,
          props.value,
          props.defaultValue,
          props.checked,
          props.defaultChecked,
          props.type,
          props.name,
          true
        );
        track(instance);
        break;
      case "select":
        listenToNonDelegatedEvent("invalid", instance);
        break;
      case "textarea":
        listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type4 = props.children;
    "string" !== typeof type4 && "number" !== typeof type4 && "bigint" !== typeof type4 || instance.textContent === "" + type4 || true === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type4) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$12), instance = true) : instance = false;
    instance || throwOnHydrationMismatch(fiber);
  }
  function popToNextHostParent(fiber) {
    for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
      switch (hydrationParentFiber.tag) {
        case 5:
        case 13:
          rootOrSingletonContext = false;
          return;
        case 27:
        case 3:
          rootOrSingletonContext = true;
          return;
        default:
          hydrationParentFiber = hydrationParentFiber.return;
      }
  }
  function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return false;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = true, false;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
      if (JSCompiler_temp = 5 === tag)
        JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
      JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage(317));
      a: {
        fiber = fiber.nextSibling;
        for (tag = 0; fiber; ) {
          if (8 === fiber.nodeType)
            if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
              if (0 === tag) {
                nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                break a;
              }
              tag--;
            } else
              "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
          fiber = fiber.nextSibling;
        }
        nextHydratableInstance = null;
      }
    } else
      27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return true;
  }
  function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = false;
  }
  function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
      workInProgressRootRecoverableErrors,
      queuedErrors
    ), hydrationErrors = null);
    return queuedErrors;
  }
  function queueHydrationError(error2) {
    null === hydrationErrors ? hydrationErrors = [error2] : hydrationErrors.push(error2);
  }
  var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
  function pushProvider(providerFiber, context2, nextValue) {
    push(valueCursor, context2._currentValue);
    context2._currentValue = nextValue;
  }
  function popProvider(context2) {
    context2._currentValue = valueCursor.current;
    pop(valueCursor);
  }
  function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
    for (; null !== parent; ) {
      var alternate = parent.alternate;
      (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
      if (parent === propagationRoot) break;
      parent = parent.return;
    }
  }
  function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
    var fiber = workInProgress2.child;
    null !== fiber && (fiber.return = workInProgress2);
    for (; null !== fiber; ) {
      var list = fiber.dependencies;
      if (null !== list) {
        var nextFiber = fiber.child;
        list = list.firstContext;
        a: for (; null !== list; ) {
          var dependency = list;
          list = fiber;
          for (var i = 0; i < contexts.length; i++)
            if (dependency.context === contexts[i]) {
              list.lanes |= renderLanes2;
              dependency = list.alternate;
              null !== dependency && (dependency.lanes |= renderLanes2);
              scheduleContextWorkOnParentPath(
                list.return,
                renderLanes2,
                workInProgress2
              );
              forcePropagateEntireTree || (nextFiber = null);
              break a;
            }
          list = dependency.next;
        }
      } else if (18 === fiber.tag) {
        nextFiber = fiber.return;
        if (null === nextFiber) throw Error(formatProdErrorMessage(341));
        nextFiber.lanes |= renderLanes2;
        list = nextFiber.alternate;
        null !== list && (list.lanes |= renderLanes2);
        scheduleContextWorkOnParentPath(nextFiber, renderLanes2, workInProgress2);
        nextFiber = null;
      } else nextFiber = fiber.child;
      if (null !== nextFiber) nextFiber.return = fiber;
      else
        for (nextFiber = fiber; null !== nextFiber; ) {
          if (nextFiber === workInProgress2) {
            nextFiber = null;
            break;
          }
          fiber = nextFiber.sibling;
          if (null !== fiber) {
            fiber.return = nextFiber.return;
            nextFiber = fiber;
            break;
          }
          nextFiber = nextFiber.return;
        }
      fiber = nextFiber;
    }
  }
  function propagateParentContextChanges(current, workInProgress2, renderLanes2, forcePropagateEntireTree) {
    current = null;
    for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
      if (!isInsidePropagationBailout) {
        if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
        else if (0 !== (parent.flags & 262144)) break;
      }
      if (10 === parent.tag) {
        var currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage(387));
        currentParent = currentParent.memoizedProps;
        if (null !== currentParent) {
          var context2 = parent.type;
          objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context2) : current = [context2]);
        }
      } else if (parent === hostTransitionProviderCursor.current) {
        currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage(387));
        currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [HostTransitionContext]);
      }
      parent = parent.return;
    }
    null !== current && propagateContextChanges(
      workInProgress2,
      current,
      renderLanes2,
      forcePropagateEntireTree
    );
    workInProgress2.flags |= 262144;
  }
  function checkIfContextChanged(currentDependencies) {
    for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
      if (!objectIs(
        currentDependencies.context._currentValue,
        currentDependencies.memoizedValue
      ))
        return true;
      currentDependencies = currentDependencies.next;
    }
    return false;
  }
  function prepareToReadContext(workInProgress2) {
    currentlyRenderingFiber$1 = workInProgress2;
    lastContextDependency = null;
    workInProgress2 = workInProgress2.dependencies;
    null !== workInProgress2 && (workInProgress2.firstContext = null);
  }
  function readContext(context2) {
    return readContextForConsumer(currentlyRenderingFiber$1, context2);
  }
  function readContextDuringReconciliation(consumer, context2) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context2);
  }
  function readContextForConsumer(consumer, context2) {
    var value = context2._currentValue;
    context2 = { context: context2, memoizedValue: value, next: null };
    if (null === lastContextDependency) {
      if (null === consumer) throw Error(formatProdErrorMessage(308));
      lastContextDependency = context2;
      consumer.dependencies = { lanes: 0, firstContext: context2 };
      consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context2;
    return value;
  }
  var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
      aborted: false,
      addEventListener: function(type4, listener) {
        listeners.push(listener);
      }
    };
    this.abort = function() {
      signal.aborted = true;
      listeners.forEach(function(listener) {
        return listener();
      });
    };
  }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function createCache3() {
    return {
      controller: new AbortControllerLocal(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function releaseCache(cache2) {
    cache2.refCount--;
    0 === cache2.refCount && scheduleCallback$2(NormalPriority, function() {
      cache2.controller.abort();
    });
  }
  var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
  function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
      var entangledListeners = currentEntangledListeners = [];
      currentEntangledPendingCount = 0;
      currentEntangledLane = requestTransitionLane();
      currentEntangledActionThenable = {
        status: "pending",
        value: void 0,
        then: function(resolve) {
          entangledListeners.push(resolve);
        }
      };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
  }
  function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
      null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
      var listeners = currentEntangledListeners;
      currentEntangledListeners = null;
      currentEntangledLane = 0;
      currentEntangledActionThenable = null;
      for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
    }
  }
  function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
      status: "pending",
      value: null,
      reason: null,
      then: function(resolve) {
        listeners.push(resolve);
      }
    };
    thenable.then(
      function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
      },
      function(error2) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error2;
        for (error2 = 0; error2 < listeners.length; error2++)
          (0, listeners[error2])(void 0);
      }
    );
    return thenableWithOverride;
  }
  var prevOnStartTransitionFinish = ReactSharedInternals.S;
  ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
  };
  var resumedCache = createCursor(null);
  function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
  }
  function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
  }
  function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
  }
  var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = { then: function() {
  } };
  function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
  }
  function noop$32() {
  }
  function trackUsedThenable(thenableState2, thenable, index3) {
    index3 = thenableState2[index3];
    void 0 === index3 ? thenableState2.push(thenable) : index3 !== thenable && (thenable.then(noop$32, noop$32), thenable = index3);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
      default:
        if ("string" === typeof thenable.status) thenable.then(noop$32, noop$32);
        else {
          thenableState2 = workInProgressRoot;
          if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
            throw Error(formatProdErrorMessage(482));
          thenableState2 = thenable;
          thenableState2.status = "pending";
          thenableState2.then(
            function(fulfilledValue) {
              if ("pending" === thenable.status) {
                var fulfilledThenable = thenable;
                fulfilledThenable.status = "fulfilled";
                fulfilledThenable.value = fulfilledValue;
              }
            },
            function(error2) {
              if ("pending" === thenable.status) {
                var rejectedThenable = thenable;
                rejectedThenable.status = "rejected";
                rejectedThenable.reason = error2;
              }
            }
          );
        }
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
      throw Error(formatProdErrorMessage(483));
  }
  var hasForceUpdate = false;
  function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
      baseState: fiber.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function cloneUpdateQueue(current, workInProgress2) {
    current = current.updateQueue;
    workInProgress2.updateQueue === current && (workInProgress2.updateQueue = {
      baseState: current.baseState,
      firstBaseUpdate: current.firstBaseUpdate,
      lastBaseUpdate: current.lastBaseUpdate,
      shared: current.shared,
      callbacks: null
    });
  }
  function createUpdate(lane) {
    return { lane, tag: 0, payload: null, callback: null, next: null };
  }
  function enqueueUpdate(fiber, update2, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
      var pending = updateQueue.pending;
      null === pending ? update2.next = update2 : (update2.next = pending.next, pending.next = update2);
      updateQueue.pending = update2;
      update2 = getRootForUpdatedFiber(fiber);
      markUpdateLaneFromFiberToRoot(fiber, null, lane);
      return update2;
    }
    enqueueUpdate$1(fiber, updateQueue, update2, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function entangleTransitions(root2, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
      var queueLanes = fiber.lanes;
      queueLanes &= root2.pendingLanes;
      lane |= queueLanes;
      fiber.lanes = lane;
      markRootEntangled(root2, lane);
    }
  }
  function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
    var queue = workInProgress2.updateQueue, current = workInProgress2.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
      var newFirst = null, newLast = null;
      queue = queue.firstBaseUpdate;
      if (null !== queue) {
        do {
          var clone = {
            lane: queue.lane,
            tag: queue.tag,
            payload: queue.payload,
            callback: null,
            next: null
          };
          null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
          queue = queue.next;
        } while (null !== queue);
        null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
      } else newFirst = newLast = capturedUpdate;
      queue = {
        baseState: current.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: current.shared,
        callbacks: current.callbacks
      };
      workInProgress2.updateQueue = queue;
      return;
    }
    workInProgress2 = queue.lastBaseUpdate;
    null === workInProgress2 ? queue.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
  }
  var didReadFromEntangledAsyncAction = false;
  function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
      var entangledActionThenable = currentEntangledActionThenable;
      if (null !== entangledActionThenable) throw entangledActionThenable;
    }
  }
  function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes2) {
    didReadFromEntangledAsyncAction = false;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = false;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
      queue.shared.pending = null;
      var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
      lastPendingUpdate.next = null;
      null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
      lastBaseUpdate = lastPendingUpdate;
      var current = workInProgress$jscomp$0.alternate;
      null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
      var newState = queue.baseState;
      lastBaseUpdate = 0;
      current = firstPendingUpdate = lastPendingUpdate = null;
      pendingQueue = firstBaseUpdate;
      do {
        var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
        if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
          0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
          null !== current && (current = current.next = {
            lane: 0,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: null,
            next: null
          });
          a: {
            var workInProgress2 = workInProgress$jscomp$0, update2 = pendingQueue;
            updateLane = props;
            var instance = instance$jscomp$0;
            switch (update2.tag) {
              case 1:
                workInProgress2 = update2.payload;
                if ("function" === typeof workInProgress2) {
                  newState = workInProgress2.call(instance, newState, updateLane);
                  break a;
                }
                newState = workInProgress2;
                break a;
              case 3:
                workInProgress2.flags = workInProgress2.flags & -65537 | 128;
              case 0:
                workInProgress2 = update2.payload;
                updateLane = "function" === typeof workInProgress2 ? workInProgress2.call(instance, newState, updateLane) : workInProgress2;
                if (null === updateLane || void 0 === updateLane) break a;
                newState = assign2({}, newState, updateLane);
                break a;
              case 2:
                hasForceUpdate = true;
            }
          }
          updateLane = pendingQueue.callback;
          null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
        } else
          isHiddenUpdate = {
            lane: updateLane,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: pendingQueue.callback,
            next: null
          }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
        pendingQueue = pendingQueue.next;
        if (null === pendingQueue)
          if (pendingQueue = queue.shared.pending, null === pendingQueue)
            break;
          else
            isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
      } while (1);
      null === current && (lastPendingUpdate = newState);
      queue.baseState = lastPendingUpdate;
      queue.firstBaseUpdate = firstPendingUpdate;
      queue.lastBaseUpdate = current;
      null === firstBaseUpdate && (queue.shared.lanes = 0);
      workInProgressRootSkippedLanes |= lastBaseUpdate;
      workInProgress$jscomp$0.lanes = lastBaseUpdate;
      workInProgress$jscomp$0.memoizedState = newState;
    }
  }
  function callCallback(callback, context2) {
    if ("function" !== typeof callback)
      throw Error(formatProdErrorMessage(191, callback));
    callback.call(context2);
  }
  function commitCallbacks(updateQueue, context2) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks)
      for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
        callCallback(callbacks[updateQueue], context2);
  }
  var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
  function pushHiddenContext(fiber, context2) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context2);
    entangledRenderLanes = fiber | context2.baseLanes;
  }
  function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
  }
  function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
  }
  var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
  function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
  }
  function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return false;
    for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
      if (!objectIs(nextDeps[i], prevDeps[i])) return false;
    return true;
  }
  function renderWithHooks(current, workInProgress2, Component2, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress2;
    workInProgress2.memoizedState = null;
    workInProgress2.updateQueue = null;
    workInProgress2.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    nextRenderLanes = Component2(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(
      workInProgress2,
      Component2,
      props,
      secondArg
    ));
    finishRenderingHooks(current);
    return nextRenderLanes;
  }
  function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = false;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = true));
  }
  function renderWithHooksAgain(workInProgress2, Component2, props, secondArg) {
    currentlyRenderingFiber = workInProgress2;
    var numberOfReRenders = 0;
    do {
      didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
      thenableIndexCounter$1 = 0;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
      numberOfReRenders += 1;
      workInProgressHook = currentHook = null;
      if (null != workInProgress2.updateQueue) {
        var children2 = workInProgress2.updateQueue;
        children2.lastEffect = null;
        children2.events = null;
        children2.stores = null;
        null != children2.memoCache && (children2.memoCache.index = 0);
      }
      ReactSharedInternals.H = HooksDispatcherOnRerender;
      children2 = Component2(props, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children2;
  }
  function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
  }
  function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
  }
  function bailoutHooks(current, workInProgress2, lanes) {
    workInProgress2.updateQueue = current.updateQueue;
    workInProgress2.flags &= -2053;
    current.lanes &= ~lanes;
  }
  function resetHooksOnUnwind(workInProgress2) {
    if (didScheduleRenderPhaseUpdate) {
      for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
        var queue = workInProgress2.queue;
        null !== queue && (queue.pending = null);
        workInProgress2 = workInProgress2.next;
      }
      didScheduleRenderPhaseUpdate = false;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = false;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
  }
  function mountWorkInProgressHook() {
    var hook = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
  }
  function updateWorkInProgressHook() {
    if (null === currentHook) {
      var nextCurrentHook = currentlyRenderingFiber.alternate;
      nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook)
      workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
      if (null === nextCurrentHook) {
        if (null === currentlyRenderingFiber.alternate)
          throw Error(formatProdErrorMessage(467));
        throw Error(formatProdErrorMessage(310));
      }
      currentHook = nextCurrentHook;
      nextCurrentHook = {
        memoizedState: currentHook.memoizedState,
        baseState: currentHook.baseState,
        baseQueue: currentHook.baseQueue,
        queue: currentHook.queue,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
  }
  function createFunctionComponentUpdateQueue() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function useThenable(thenable) {
    var index3 = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index3);
    index3 = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index3.memoizedState : workInProgressHook.next) && (index3 = index3.alternate, ReactSharedInternals.H = null === index3 || null === index3.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
  }
  function use(usable) {
    if (null !== usable && "object" === typeof usable) {
      if ("function" === typeof usable.then) return useThenable(usable);
      if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
  }
  function useMemoCache(size2) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
      var current = currentlyRenderingFiber.alternate;
      null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
        data: current.data.map(function(array4) {
          return array4.slice();
        }),
        index: 0
      })));
    }
    null == memoCache && (memoCache = { data: [], index: 0 });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue)
      for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current = 0; current < size2; current++)
        updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
  }
  function basicStateReducer(state, action3) {
    return "function" === typeof action3 ? action3(state) : action3;
  }
  function updateReducer(reducer2) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer2);
  }
  function updateReducerImpl(hook, current, reducer2) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer2;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
      if (null !== baseQueue) {
        var baseFirst = baseQueue.next;
        baseQueue.next = pendingQueue.next;
        pendingQueue.next = baseFirst;
      }
      current.baseQueue = baseQueue = pendingQueue;
      queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
      current = baseQueue.next;
      var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update2 = current, didReadFromEntangledAsyncAction$32 = false;
      do {
        var updateLane = update2.lane & -536870913;
        if (updateLane !== update2.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
          var revertLane = update2.revertLane;
          if (0 === revertLane)
            null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
              lane: 0,
              revertLane: 0,
              action: update2.action,
              hasEagerState: update2.hasEagerState,
              eagerState: update2.eagerState,
              next: null
            }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = true);
          else if ((renderLanes & revertLane) === revertLane) {
            update2 = update2.next;
            revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = true);
            continue;
          } else
            updateLane = {
              lane: 0,
              revertLane: update2.revertLane,
              action: update2.action,
              hasEagerState: update2.hasEagerState,
              eagerState: update2.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
          updateLane = update2.action;
          shouldDoubleInvokeUserFnsInHooksDEV && reducer2(pendingQueue, updateLane);
          pendingQueue = update2.hasEagerState ? update2.eagerState : reducer2(pendingQueue, updateLane);
        } else
          revertLane = {
            lane: updateLane,
            revertLane: update2.revertLane,
            action: update2.action,
            hasEagerState: update2.hasEagerState,
            eagerState: update2.eagerState,
            next: null
          }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
        update2 = update2.next;
      } while (null !== update2 && update2 !== current);
      null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
      if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction$32 && (reducer2 = currentEntangledActionThenable, null !== reducer2)))
        throw reducer2;
      hook.memoizedState = pendingQueue;
      hook.baseState = baseFirst;
      hook.baseQueue = newBaseQueueLast;
      queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [hook.memoizedState, queue.dispatch];
  }
  function rerenderReducer(reducer2) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer2;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
      queue.pending = null;
      var update2 = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      do
        newState = reducer2(newState, update2.action), update2 = update2.next;
      while (update2 !== lastRenderPhaseUpdate);
      objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
      hook.memoizedState = newState;
      null === hook.baseQueue && (hook.baseState = newState);
      queue.lastRenderedState = newState;
    }
    return [newState, dispatch];
  }
  function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
      if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
      getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs(
      (currentHook || hook).memoizedState,
      getServerSnapshot
    );
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = true);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [subscribe]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          hook,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
      isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
  }
  function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = { getSnapshot, value: renderedSnapshot };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
  }
  function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
  }
  function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error2) {
      return true;
    }
  }
  function forceStoreRerender(fiber) {
    var root2 = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2);
  }
  function mountStateImpl(initialState2) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState2) {
      var initialStateInitializer = initialState2;
      initialState2 = initialStateInitializer();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          initialStateInitializer();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
    }
    hook.memoizedState = hook.baseState = initialState2;
    hook.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: initialState2
    };
    return hook;
  }
  function updateOptimisticImpl(hook, current, passthrough, reducer2) {
    hook.baseState = passthrough;
    return updateReducerImpl(
      hook,
      currentHook,
      "function" === typeof reducer2 ? reducer2 : basicStateReducer
    );
  }
  function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
      var actionNode = {
        payload,
        action: fiber,
        next: null,
        isTransition: true,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(listener) {
          actionNode.listeners.push(listener);
        }
      };
      null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
      setState(actionNode);
      setPendingState = actionQueue.pending;
      null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
  }
  function runActionStateAction(actionQueue, node2) {
    var action3 = node2.action, payload = node2.payload, prevState = actionQueue.state;
    if (node2.isTransition) {
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      try {
        var returnValue = action3(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        handleActionReturnValue(actionQueue, node2, returnValue);
      } catch (error2) {
        onActionError(actionQueue, node2, error2);
      } finally {
        ReactSharedInternals.T = prevTransition;
      }
    } else
      try {
        prevTransition = action3(prevState, payload), handleActionReturnValue(actionQueue, node2, prevTransition);
      } catch (error$38) {
        onActionError(actionQueue, node2, error$38);
      }
  }
  function handleActionReturnValue(actionQueue, node2, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(
      function(nextState) {
        onActionSuccess(actionQueue, node2, nextState);
      },
      function(error2) {
        return onActionError(actionQueue, node2, error2);
      }
    ) : onActionSuccess(actionQueue, node2, returnValue);
  }
  function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
  }
  function onActionError(actionQueue, actionNode, error2) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
      last = last.next;
      do
        actionNode.status = "rejected", actionNode.reason = error2, notifyActionListeners(actionNode), actionNode = actionNode.next;
      while (actionNode !== last);
    }
    actionQueue.action = null;
  }
  function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
  }
  function actionStateReducer(oldState, newState) {
    return newState;
  }
  function mountActionState(action3, initialStateProp) {
    if (isHydrating) {
      var ssrFormState = workInProgressRoot.formState;
      if (null !== ssrFormState) {
        a: {
          var JSCompiler_inline_result = currentlyRenderingFiber;
          if (isHydrating) {
            if (nextHydratableInstance) {
              b: {
                var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                for (var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType; ) {
                  if (!inRootOrSingleton) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                  JSCompiler_inline_result$jscomp$0 = getNextHydratable(
                    JSCompiler_inline_result$jscomp$0.nextSibling
                  );
                  if (null === JSCompiler_inline_result$jscomp$0) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                }
                inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
              }
              if (JSCompiler_inline_result$jscomp$0) {
                nextHydratableInstance = getNextHydratable(
                  JSCompiler_inline_result$jscomp$0.nextSibling
                );
                JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                break a;
              }
            }
            throwOnHydrationMismatch(JSCompiler_inline_result);
          }
          JSCompiler_inline_result = false;
        }
        JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
      }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: actionStateReducer,
      lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result
    );
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(false);
    inRootOrSingleton = dispatchOptimisticSetState.bind(
      null,
      currentlyRenderingFiber,
      false,
      JSCompiler_inline_result.queue
    );
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
      state: initialStateProp,
      dispatch: null,
      action: action3,
      pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result$jscomp$0,
      inRootOrSingleton,
      ssrFormState
    );
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action3;
    return [initialStateProp, ssrFormState, false];
  }
  function updateActionState(action3) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action3);
  }
  function updateActionStateImpl(stateHook, currentStateHook, action3) {
    currentStateHook = updateReducerImpl(
      stateHook,
      currentStateHook,
      actionStateReducer
    )[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
      try {
        var state = useThenable(currentStateHook);
      } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
      }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action3 !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
      9,
      createEffectInstance(),
      actionStateActionEffect.bind(null, actionQueue, action3),
      null
    ));
    return [state, dispatch, stateHook];
  }
  function actionStateActionEffect(actionQueue, action3) {
    actionQueue.action = action3;
  }
  function rerenderActionState(action3) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook)
      return updateActionStateImpl(stateHook, currentStateHook, action3);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action3;
    return [stateHook, dispatch, false];
  }
  function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = { tag, create, deps: createDeps, inst, next: null };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
  }
  function createEffectInstance() {
    return { destroy: void 0, resource: void 0 };
  }
  function updateRef() {
    return updateWorkInProgressHook().memoizedState;
  }
  function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      createEffectInstance(),
      create,
      createDeps
    );
  }
  function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      inst,
      create,
      deps
    ));
  }
  function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
  }
  function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
  }
  function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
  }
  function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
  }
  function imperativeHandleEffect(create, ref2) {
    if ("function" === typeof ref2) {
      create = create();
      var refCleanup = ref2(create);
      return function() {
        "function" === typeof refCleanup ? refCleanup() : ref2(null);
      };
    }
    if (null !== ref2 && void 0 !== ref2)
      return create = create(), ref2.current = create, function() {
        ref2.current = null;
      };
  }
  function updateImperativeHandle(ref2, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([ref2]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref2), deps);
  }
  function mountDebugValue() {
  }
  function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    hook.memoizedState = [callback, deps];
    return callback;
  }
  function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
      setIsStrictModeForDevtools(true);
      try {
        nextCreate();
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    hook.memoizedState = [prevState, deps];
    return prevState;
  }
  function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824))
      return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
  }
  function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current)
      return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
    if (0 === (renderLanes & 42))
      return didReceiveUpdate = true, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
  }
  function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, false, queue, pendingState);
    try {
      var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
        var thenableForFinishedState = chainThenableValue(
          returnValue,
          finishedState
        );
        dispatchSetStateInternal(
          fiber,
          queue,
          thenableForFinishedState,
          requestUpdateLane(fiber)
        );
      } else
        dispatchSetStateInternal(
          fiber,
          queue,
          finishedState,
          requestUpdateLane(fiber)
        );
    } catch (error2) {
      dispatchSetStateInternal(
        fiber,
        queue,
        { then: function() {
        }, status: "rejected", reason: error2 },
        requestUpdateLane()
      );
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function noop$22() {
  }
  function startHostTransition(formFiber, pendingState, action3, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(
      formFiber,
      queue,
      pendingState,
      sharedNotPendingObject,
      null === action3 ? noop$22 : function() {
        requestFormReset$1(formFiber);
        return action3(formData);
      }
    );
  }
  function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
      memoizedState: sharedNotPendingObject,
      baseState: sharedNotPendingObject,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: sharedNotPendingObject
      },
      next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
      memoizedState: initialResetState,
      baseState: initialResetState,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialResetState
      },
      next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
  }
  function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
  }
  function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
  }
  function updateId() {
    return updateWorkInProgressHook().memoizedState;
  }
  function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
  }
  function refreshCache(fiber) {
    for (var provider = fiber.return; null !== provider; ) {
      switch (provider.tag) {
        case 24:
        case 3:
          var lane = requestUpdateLane();
          fiber = createUpdate(lane);
          var root$41 = enqueueUpdate(provider, fiber, lane);
          null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
          provider = { cache: createCache3() };
          fiber.payload = provider;
          return;
      }
      provider = provider.return;
    }
  }
  function dispatchReducerAction(fiber, queue, action3) {
    var lane = requestUpdateLane();
    action3 = {
      lane,
      revertLane: 0,
      action: action3,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action3) : (action3 = enqueueConcurrentHookUpdate(fiber, queue, action3, lane), null !== action3 && (scheduleUpdateOnFiber(action3, fiber, lane), entangleTransitionUpdate(action3, queue, lane)));
  }
  function dispatchSetState(fiber, queue, action3) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action3, lane);
  }
  function dispatchSetStateInternal(fiber, queue, action3, lane) {
    var update2 = {
      lane,
      revertLane: 0,
      action: action3,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update2);
    else {
      var alternate = fiber.alternate;
      if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate))
        try {
          var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action3);
          update2.hasEagerState = true;
          update2.eagerState = eagerState;
          if (objectIs(eagerState, currentState))
            return enqueueUpdate$1(fiber, queue, update2, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
        } catch (error2) {
        } finally {
        }
      action3 = enqueueConcurrentHookUpdate(fiber, queue, update2, lane);
      if (null !== action3)
        return scheduleUpdateOnFiber(action3, fiber, lane), entangleTransitionUpdate(action3, queue, lane), true;
    }
    return false;
  }
  function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action3) {
    action3 = {
      lane: 2,
      revertLane: requestTransitionLane(),
      action: action3,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
      if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else
      throwIfDuringRender = enqueueConcurrentHookUpdate(
        fiber,
        queue,
        action3,
        2
      ), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
  }
  function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
  }
  function enqueueRenderPhaseUpdate(queue, update2) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
    var pending = queue.pending;
    null === pending ? update2.next = update2 : (update2.next = pending.next, pending.next = update2);
    queue.pending = update2;
  }
  function entangleTransitionUpdate(root2, queue, lane) {
    if (0 !== (lane & 4194048)) {
      var queueLanes = queue.lanes;
      queueLanes &= root2.pendingLanes;
      lane |= queueLanes;
      queue.lanes = lane;
      markRootEntangled(root2, lane);
    }
  }
  var ContextOnlyDispatcher = {
    readContext,
    use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
  }, HooksDispatcherOnMount = {
    readContext,
    use,
    useCallback: function(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref2, create, deps) {
      deps = null !== deps && void 0 !== deps ? deps.concat([ref2]) : null;
      mountEffectImpl(
        4194308,
        4,
        imperativeHandleEffect.bind(null, create, ref2),
        deps
      );
    },
    useLayoutEffect: function(create, deps) {
      return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
      mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    },
    useReducer: function(reducer2, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer2 = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer2,
        lastRenderedState: initialState2
      };
      hook.queue = reducer2;
      reducer2 = reducer2.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer2
      );
      return [hook.memoizedState, reducer2];
    },
    useRef: function(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    },
    useState: function(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
      } else {
        getServerSnapshot = getSnapshot();
        if (null === workInProgressRoot)
          throw Error(formatProdErrorMessage(349));
        0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      hook.memoizedState = getServerSnapshot;
      var inst = { value: getServerSnapshot, getSnapshot };
      hook.queue = inst;
      mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
        subscribe
      ]);
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          inst,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      return getServerSnapshot;
    },
    useId: function() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var JSCompiler_inline_result = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
        identifierPrefix = "«" + identifierPrefix + "R" + JSCompiler_inline_result;
        JSCompiler_inline_result = localIdCounter++;
        0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
        identifierPrefix += "»";
      } else
        JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "«" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "»";
      return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    },
    useMemoCache,
    useCacheRefresh: function() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    }
  }, HooksDispatcherOnUpdate = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
      return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start2 = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start2
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer2) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer2);
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  }, HooksDispatcherOnRerender = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
      return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start2 = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start2
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer2) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer2);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  }, thenableState = null, thenableIndexCounter = 0;
  function unwrapThenable(thenable) {
    var index3 = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index3);
  }
  function coerceRef(workInProgress2, element) {
    element = element.props.ref;
    workInProgress2.ref = void 0 !== element ? element : null;
  }
  function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
      throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(
      formatProdErrorMessage(
        31,
        "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber
      )
    );
  }
  function resolveLazy(lazyType) {
    var init2 = lazyType._init;
    return init2(lazyType._payload);
  }
  function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
      if (shouldTrackSideEffects) {
        var deletions = returnFiber.deletions;
        null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
      }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
      if (!shouldTrackSideEffects) return null;
      for (; null !== currentFirstChild; )
        deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return null;
    }
    function mapRemainingChildren(currentFirstChild) {
      for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
        null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
      fiber = createWorkInProgress(fiber, pendingProps);
      fiber.index = 0;
      fiber.sibling = null;
      return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
      newFiber.index = newIndex;
      if (!shouldTrackSideEffects)
        return newFiber.flags |= 1048576, lastPlacedIndex;
      newIndex = newFiber.alternate;
      if (null !== newIndex)
        return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
      newFiber.flags |= 67108866;
      return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
      shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
      return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
      if (null === current || 6 !== current.tag)
        return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
      current = useFiber(current, textContent);
      current.return = returnFiber;
      return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
      var elementType = element.type;
      if (elementType === REACT_FRAGMENT_TYPE2)
        return updateFragment(
          returnFiber,
          current,
          element.props.children,
          lanes,
          element.key
        );
      if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type))
        return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
      current = createFiberFromTypeAndProps(
        element.type,
        element.key,
        element.props,
        null,
        returnFiber.mode,
        lanes
      );
      coerceRef(current, element);
      current.return = returnFiber;
      return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
      if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation)
        return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
      current = useFiber(current, portal.children || []);
      current.return = returnFiber;
      return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
      if (null === current || 7 !== current.tag)
        return current = createFiberFromFragment(
          fragment,
          returnFiber.mode,
          lanes,
          key
        ), current.return = returnFiber, current;
      current = useFiber(current, fragment);
      current.return = returnFiber;
      return current;
    }
    function createChild(returnFiber, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return newChild = createFiberFromText(
          "" + newChild,
          returnFiber.mode,
          lanes
        ), newChild.return = returnFiber, newChild;
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return lanes = createFiberFromTypeAndProps(
              newChild.type,
              newChild.key,
              newChild.props,
              null,
              returnFiber.mode,
              lanes
            ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
          case REACT_PORTAL_TYPE:
            return newChild = createFiberFromPortal(
              newChild,
              returnFiber.mode,
              lanes
            ), newChild.return = returnFiber, newChild;
          case REACT_LAZY_TYPE:
            var init2 = newChild._init;
            newChild = init2(newChild._payload);
            return createChild(returnFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return newChild = createFiberFromFragment(
            newChild,
            returnFiber.mode,
            lanes,
            null
          ), newChild.return = returnFiber, newChild;
        if ("function" === typeof newChild.then)
          return createChild(returnFiber, unwrapThenable(newChild), lanes);
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return createChild(
            returnFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
      var key = null !== oldFiber ? oldFiber.key : null;
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_PORTAL_TYPE:
            return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_LAZY_TYPE:
            return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateSlot(
            returnFiber,
            oldFiber,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateSlot(
            returnFiber,
            oldFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
          case REACT_PORTAL_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
          case REACT_LAZY_TYPE:
            var init2 = newChild._init;
            newChild = init2(newChild._payload);
            return updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(
          returnFiber,
          oldFiber,
          newChildren[newIdx],
          lanes
        );
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (newIdx === newChildren.length)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; newIdx < newChildren.length; newIdx++)
          oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(
            oldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
        nextOldFiber = updateFromMap(
          oldFiber,
          returnFiber,
          newIdx,
          newChildren[newIdx],
          lanes
        ), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
          null === nextOldFiber.key ? newIdx : nextOldFiber.key
        ), currentFirstChild = placeChild(
          nextOldFiber,
          currentFirstChild,
          newIdx
        ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
      if (null == newChildren) throw Error(formatProdErrorMessage(151));
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (step.done)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; !step.done; newIdx++, step = newChildren.next())
          step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
        step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
      "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE2 && null === newChild.key && (newChild = newChild.props.children);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            a: {
              for (var key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key) {
                  key = newChild.type;
                  if (key === REACT_FRAGMENT_TYPE2) {
                    if (7 === currentFirstChild.tag) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        newChild.props.children
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    }
                  } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.props);
                    coerceRef(lanes, newChild);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  }
                  deleteRemainingChildren(returnFiber, currentFirstChild);
                  break;
                } else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              newChild.type === REACT_FRAGMENT_TYPE2 ? (lanes = createFiberFromFragment(
                newChild.props.children,
                returnFiber.mode,
                lanes,
                newChild.key
              ), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(
                newChild.type,
                newChild.key,
                newChild.props,
                null,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
            }
            return placeSingleChild(returnFiber);
          case REACT_PORTAL_TYPE:
            a: {
              for (key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key)
                  if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.children || []);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  } else {
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  }
                else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
              lanes.return = returnFiber;
              returnFiber = lanes;
            }
            return placeSingleChild(returnFiber);
          case REACT_LAZY_TYPE:
            return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild))
          return reconcileChildrenArray(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        if (getIteratorFn(newChild)) {
          key = getIteratorFn(newChild);
          if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
          newChild = key.call(newChild);
          return reconcileChildrenIterator(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        }
        if ("function" === typeof newChild.then)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
      try {
        thenableIndexCounter = 0;
        var firstChildFiber = reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
        thenableState = null;
        return firstChildFiber;
      } catch (x) {
        if (x === SuspenseException || x === SuspenseActionException) throw x;
        var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
        fiber.lanes = lanes;
        fiber.return = returnFiber;
        return fiber;
      } finally {
      }
    };
  }
  var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
  function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
  }
  function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
      if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
        var current = fiber.alternate;
        null !== current && null !== current.memoizedState && (shellBoundary = fiber);
      }
    } else reuseSuspenseHandlerOnStack();
  }
  function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
  }
  function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
  }
  var suspenseStackCursor = createCursor(0);
  function findFirstSuspended(row) {
    for (var node2 = row; null !== node2; ) {
      if (13 === node2.tag) {
        var state = node2.memoizedState;
        if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state)))
          return node2;
      } else if (19 === node2.tag && void 0 !== node2.memoizedProps.revealOrder) {
        if (0 !== (node2.flags & 128)) return node2;
      } else if (null !== node2.child) {
        node2.child.return = node2;
        node2 = node2.child;
        continue;
      }
      if (node2 === row) break;
      for (; null === node2.sibling; ) {
        if (null === node2.return || node2.return === row) return null;
        node2 = node2.return;
      }
      node2.sibling.return = node2.return;
      node2 = node2.sibling;
    }
    return null;
  }
  function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress2.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign2({}, ctor, getDerivedStateFromProps);
    workInProgress2.memoizedState = getDerivedStateFromProps;
    0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = getDerivedStateFromProps);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update2 = createUpdate(lane);
      update2.payload = payload;
      void 0 !== callback && null !== callback && (update2.callback = callback);
      payload = enqueueUpdate(inst, update2, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update2 = createUpdate(lane);
      update2.tag = 1;
      update2.payload = payload;
      void 0 !== callback && null !== callback && (update2.callback = callback);
      payload = enqueueUpdate(inst, update2, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update2 = createUpdate(lane);
      update2.tag = 2;
      void 0 !== callback && null !== callback && (update2.callback = callback);
      callback = enqueueUpdate(inst, update2, lane);
      null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
  };
  function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress2 = workInProgress2.stateNode;
    return "function" === typeof workInProgress2.shouldComponentUpdate ? workInProgress2.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual2(oldProps, newProps) || !shallowEqual2(oldState, newState) : true;
  }
  function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
    workInProgress2 = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress2 && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
  function resolveClassComponentProps(Component2, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
      newProps = {};
      for (var propName in baseProps)
        "ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component2 = Component2.defaultProps) {
      newProps === baseProps && (newProps = assign2({}, newProps));
      for (var propName$73 in Component2)
        void 0 === newProps[propName$73] && (newProps[propName$73] = Component2[propName$73]);
    }
    return newProps;
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error2) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error2 && null !== error2 && "string" === typeof error2.message ? String(error2.message) : String(error2),
        error: error2
      });
      if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error2);
      return;
    }
    console.error(error2);
  };
  function defaultOnUncaughtError(error2) {
    reportGlobalError(error2);
  }
  function defaultOnCaughtError(error2) {
    console.error(error2);
  }
  function defaultOnRecoverableError(error2) {
    reportGlobalError(error2);
  }
  function logUncaughtError(root2, errorInfo) {
    try {
      var onUncaughtError = root2.onUncaughtError;
      onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
    } catch (e$74) {
      setTimeout(function() {
        throw e$74;
      });
    }
  }
  function logCaughtError(root2, boundary, errorInfo) {
    try {
      var onCaughtError = root2.onCaughtError;
      onCaughtError(errorInfo.value, {
        componentStack: errorInfo.stack,
        errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
      });
    } catch (e$75) {
      setTimeout(function() {
        throw e$75;
      });
    }
  }
  function createRootErrorUpdate(root2, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = { element: null };
    lane.callback = function() {
      logUncaughtError(root2, errorInfo);
    };
    return lane;
  }
  function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
  }
  function initializeClassErrorUpdate(update2, root2, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
      var error2 = errorInfo.value;
      update2.payload = function() {
        return getDerivedStateFromError(error2);
      };
      update2.callback = function() {
        logCaughtError(root2, fiber, errorInfo);
      };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update2.callback = function() {
      logCaughtError(root2, fiber, errorInfo);
      "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
      var stack = errorInfo.stack;
      this.componentDidCatch(errorInfo.value, {
        componentStack: null !== stack ? stack : ""
      });
    });
  }
  function throwException(root2, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
      returnFiber = sourceFiber.alternate;
      null !== returnFiber && propagateParentContextChanges(
        returnFiber,
        sourceFiber,
        rootRenderLanes,
        true
      );
      sourceFiber = suspenseHandlerStackCursor.current;
      if (null !== sourceFiber) {
        switch (sourceFiber.tag) {
          case 13:
            return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root2, value, rootRenderLanes)), false;
          case 22:
            return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([value])
            }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root2, value, rootRenderLanes)), false;
        }
        throw Error(formatProdErrorMessage(435, sourceFiber.tag));
      }
      attachPingListener(root2, value, rootRenderLanes);
      renderDidSuspendDelayIfPossible();
      return false;
    }
    if (isHydrating)
      return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root2 = Error(formatProdErrorMessage(422), { cause: value }), queueHydrationError(createCapturedValueAtFiber(root2, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
      }), queueHydrationError(
        createCapturedValueAtFiber(returnFiber, sourceFiber)
      )), root2 = root2.current.alternate, root2.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root2.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
        root2.stateNode,
        value,
        rootRenderLanes
      ), enqueueCapturedUpdate(root2, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), false;
    var wrapperError = Error(formatProdErrorMessage(520), { cause: value });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [wrapperError] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return true;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
      switch (sourceFiber.tag) {
        case 3:
          return sourceFiber.flags |= 65536, root2 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root2, root2 = createRootErrorUpdate(sourceFiber.stateNode, value, root2), enqueueCapturedUpdate(sourceFiber, root2), false;
        case 1:
          if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError))))
            return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
              rootRenderLanes,
              root2,
              sourceFiber,
              value
            ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
      }
      sourceFiber = sourceFiber.return;
    } while (null !== sourceFiber);
    return false;
  }
  var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = false;
  function reconcileChildren(current, workInProgress2, nextChildren, renderLanes2) {
    workInProgress2.child = null === current ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
      workInProgress2,
      current.child,
      nextChildren,
      renderLanes2
    );
  }
  function updateForwardRef(current, workInProgress2, Component2, nextProps, renderLanes2) {
    Component2 = Component2.render;
    var ref2 = workInProgress2.ref;
    if ("ref" in nextProps) {
      var propsWithoutRef = {};
      for (var key in nextProps)
        "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress2);
    nextProps = renderWithHooks(
      current,
      workInProgress2,
      Component2,
      propsWithoutRef,
      ref2,
      renderLanes2
    );
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && key && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateMemoComponent(current, workInProgress2, Component2, nextProps, renderLanes2) {
    if (null === current) {
      var type4 = Component2.type;
      if ("function" === typeof type4 && !shouldConstruct(type4) && void 0 === type4.defaultProps && null === Component2.compare)
        return workInProgress2.tag = 15, workInProgress2.type = type4, updateSimpleMemoComponent(
          current,
          workInProgress2,
          type4,
          nextProps,
          renderLanes2
        );
      current = createFiberFromTypeAndProps(
        Component2.type,
        null,
        nextProps,
        workInProgress2,
        workInProgress2.mode,
        renderLanes2
      );
      current.ref = workInProgress2.ref;
      current.return = workInProgress2;
      return workInProgress2.child = current;
    }
    type4 = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes2)) {
      var prevProps = type4.memoizedProps;
      Component2 = Component2.compare;
      Component2 = null !== Component2 ? Component2 : shallowEqual2;
      if (Component2(prevProps, nextProps) && current.ref === workInProgress2.ref)
        return bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    }
    workInProgress2.flags |= 1;
    current = createWorkInProgress(type4, nextProps);
    current.ref = workInProgress2.ref;
    current.return = workInProgress2;
    return workInProgress2.child = current;
  }
  function updateSimpleMemoComponent(current, workInProgress2, Component2, nextProps, renderLanes2) {
    if (null !== current) {
      var prevProps = current.memoizedProps;
      if (shallowEqual2(prevProps, nextProps) && current.ref === workInProgress2.ref)
        if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes2))
          0 !== (current.flags & 131072) && (didReceiveUpdate = true);
        else
          return workInProgress2.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    }
    return updateFunctionComponent(
      current,
      workInProgress2,
      Component2,
      nextProps,
      renderLanes2
    );
  }
  function updateOffscreenComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
      if (0 !== (workInProgress2.flags & 128)) {
        nextProps = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
        if (null !== current) {
          nextChildren = workInProgress2.child = current.child;
          for (prevState = 0; null !== nextChildren; )
            prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
          workInProgress2.childLanes = prevState & ~nextProps;
        } else workInProgress2.childLanes = 0, workInProgress2.child = null;
        return deferHiddenOffscreenComponent(
          current,
          workInProgress2,
          nextProps,
          renderLanes2
        );
      }
      if (0 !== (renderLanes2 & 536870912))
        workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current && pushTransition(
          workInProgress2,
          null !== prevState ? prevState.cachePool : null
        ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress2);
      else
        return workInProgress2.lanes = workInProgress2.childLanes = 536870912, deferHiddenOffscreenComponent(
          current,
          workInProgress2,
          null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
          renderLanes2
        );
    } else
      null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(), workInProgress2.memoizedState = null) : (null !== current && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack());
    reconcileChildren(current, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  function deferHiddenOffscreenComponent(current, workInProgress2, nextBaseLanes, renderLanes2) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : { parent: CacheContext._currentValue, pool: JSCompiler_inline_result };
    workInProgress2.memoizedState = {
      baseLanes: nextBaseLanes,
      cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress2, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress2);
    null !== current && propagateParentContextChanges(current, workInProgress2, renderLanes2, true);
    return null;
  }
  function markRef(current, workInProgress2) {
    var ref2 = workInProgress2.ref;
    if (null === ref2)
      null !== current && null !== current.ref && (workInProgress2.flags |= 4194816);
    else {
      if ("function" !== typeof ref2 && "object" !== typeof ref2)
        throw Error(formatProdErrorMessage(284));
      if (null === current || current.ref !== ref2)
        workInProgress2.flags |= 4194816;
    }
  }
  function updateFunctionComponent(current, workInProgress2, Component2, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    Component2 = renderWithHooks(
      current,
      workInProgress2,
      Component2,
      nextProps,
      void 0,
      renderLanes2
    );
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, Component2, renderLanes2);
    return workInProgress2.child;
  }
  function replayFunctionComponent(current, workInProgress2, nextProps, Component2, secondArg, renderLanes2) {
    prepareToReadContext(workInProgress2);
    workInProgress2.updateQueue = null;
    nextProps = renderWithHooksAgain(
      workInProgress2,
      Component2,
      nextProps,
      secondArg
    );
    finishRenderingHooks(current);
    Component2 = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && Component2 && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateClassComponent(current, workInProgress2, Component2, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    if (null === workInProgress2.stateNode) {
      var context2 = emptyContextObject, contextType = Component2.contextType;
      "object" === typeof contextType && null !== contextType && (context2 = readContext(contextType));
      context2 = new Component2(nextProps, context2);
      workInProgress2.memoizedState = null !== context2.state && void 0 !== context2.state ? context2.state : null;
      context2.updater = classComponentUpdater;
      workInProgress2.stateNode = context2;
      context2._reactInternals = workInProgress2;
      context2 = workInProgress2.stateNode;
      context2.props = nextProps;
      context2.state = workInProgress2.memoizedState;
      context2.refs = {};
      initializeUpdateQueue(workInProgress2);
      contextType = Component2.contextType;
      context2.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
      context2.state = workInProgress2.memoizedState;
      contextType = Component2.getDerivedStateFromProps;
      "function" === typeof contextType && (applyDerivedStateFromProps(
        workInProgress2,
        Component2,
        contextType,
        nextProps
      ), context2.state = workInProgress2.memoizedState);
      "function" === typeof Component2.getDerivedStateFromProps || "function" === typeof context2.getSnapshotBeforeUpdate || "function" !== typeof context2.UNSAFE_componentWillMount && "function" !== typeof context2.componentWillMount || (contextType = context2.state, "function" === typeof context2.componentWillMount && context2.componentWillMount(), "function" === typeof context2.UNSAFE_componentWillMount && context2.UNSAFE_componentWillMount(), contextType !== context2.state && classComponentUpdater.enqueueReplaceState(context2, context2.state, null), processUpdateQueue(workInProgress2, nextProps, context2, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), context2.state = workInProgress2.memoizedState);
      "function" === typeof context2.componentDidMount && (workInProgress2.flags |= 4194308);
      nextProps = true;
    } else if (null === current) {
      context2 = workInProgress2.stateNode;
      var unresolvedOldProps = workInProgress2.memoizedProps, oldProps = resolveClassComponentProps(Component2, unresolvedOldProps);
      context2.props = oldProps;
      var oldContext = context2.context, contextType$jscomp$0 = Component2.contextType;
      contextType = emptyContextObject;
      "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
      var getDerivedStateFromProps = Component2.getDerivedStateFromProps;
      contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context2.getSnapshotBeforeUpdate;
      unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
      contextType$jscomp$0 || "function" !== typeof context2.UNSAFE_componentWillReceiveProps && "function" !== typeof context2.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(
        workInProgress2,
        context2,
        nextProps,
        contextType
      );
      hasForceUpdate = false;
      var oldState = workInProgress2.memoizedState;
      context2.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context2, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      oldContext = workInProgress2.memoizedState;
      unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component2,
        getDerivedStateFromProps,
        nextProps
      ), oldContext = workInProgress2.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component2,
        oldProps,
        nextProps,
        oldState,
        oldContext,
        contextType
      )) ? (contextType$jscomp$0 || "function" !== typeof context2.UNSAFE_componentWillMount && "function" !== typeof context2.componentWillMount || ("function" === typeof context2.componentWillMount && context2.componentWillMount(), "function" === typeof context2.UNSAFE_componentWillMount && context2.UNSAFE_componentWillMount()), "function" === typeof context2.componentDidMount && (workInProgress2.flags |= 4194308)) : ("function" === typeof context2.componentDidMount && (workInProgress2.flags |= 4194308), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), context2.props = nextProps, context2.state = oldContext, context2.context = contextType, nextProps = oldProps) : ("function" === typeof context2.componentDidMount && (workInProgress2.flags |= 4194308), nextProps = false);
    } else {
      context2 = workInProgress2.stateNode;
      cloneUpdateQueue(current, workInProgress2);
      contextType = workInProgress2.memoizedProps;
      contextType$jscomp$0 = resolveClassComponentProps(Component2, contextType);
      context2.props = contextType$jscomp$0;
      getDerivedStateFromProps = workInProgress2.pendingProps;
      oldState = context2.context;
      oldContext = Component2.contextType;
      oldProps = emptyContextObject;
      "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
      unresolvedOldProps = Component2.getDerivedStateFromProps;
      (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context2.getSnapshotBeforeUpdate) || "function" !== typeof context2.UNSAFE_componentWillReceiveProps && "function" !== typeof context2.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(
        workInProgress2,
        context2,
        nextProps,
        oldProps
      );
      hasForceUpdate = false;
      oldState = workInProgress2.memoizedState;
      context2.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context2, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      var newState = workInProgress2.memoizedState;
      contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component2,
        unresolvedOldProps,
        nextProps
      ), newState = workInProgress2.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component2,
        contextType$jscomp$0,
        nextProps,
        oldState,
        newState,
        oldProps
      ) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context2.UNSAFE_componentWillUpdate && "function" !== typeof context2.componentWillUpdate || ("function" === typeof context2.componentWillUpdate && context2.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context2.UNSAFE_componentWillUpdate && context2.UNSAFE_componentWillUpdate(
        nextProps,
        newState,
        oldProps
      )), "function" === typeof context2.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof context2.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof context2.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context2.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), context2.props = nextProps, context2.state = newState, context2.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context2.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context2.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 1024), nextProps = false);
    }
    context2 = nextProps;
    markRef(current, workInProgress2);
    nextProps = 0 !== (workInProgress2.flags & 128);
    context2 || nextProps ? (context2 = workInProgress2.stateNode, Component2 = nextProps && "function" !== typeof Component2.getDerivedStateFromError ? null : context2.render(), workInProgress2.flags |= 1, null !== current && nextProps ? (workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      current.child,
      null,
      renderLanes2
    ), workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      null,
      Component2,
      renderLanes2
    )) : reconcileChildren(current, workInProgress2, Component2, renderLanes2), workInProgress2.memoizedState = context2.state, current = workInProgress2.child) : current = bailoutOnAlreadyFinishedWork(
      current,
      workInProgress2,
      renderLanes2
    );
    return current;
  }
  function mountHostRootWithoutHydrating(current, workInProgress2, nextChildren, renderLanes2) {
    resetHydrationState();
    workInProgress2.flags |= 256;
    reconcileChildren(current, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function mountSuspenseOffscreenState(renderLanes2) {
    return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
  }
  function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes2) {
    current = null !== current ? current.childLanes & ~renderLanes2 : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
  }
  function updateSuspenseComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, showFallback = false, didSuspend = 0 !== (workInProgress2.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? false : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = true, workInProgress2.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress2.flags & 32);
    workInProgress2.flags &= -33;
    if (null === current) {
      if (isHydrating) {
        showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack();
        if (isHydrating) {
          var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
          if (JSCompiler_temp$jscomp$0 = nextInstance) {
            c: {
              JSCompiler_temp$jscomp$0 = nextInstance;
              for (nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType; ) {
                if (!nextInstance) {
                  nextInstance = null;
                  break c;
                }
                JSCompiler_temp$jscomp$0 = getNextHydratable(
                  JSCompiler_temp$jscomp$0.nextSibling
                );
                if (null === JSCompiler_temp$jscomp$0) {
                  nextInstance = null;
                  break c;
                }
              }
              nextInstance = JSCompiler_temp$jscomp$0;
            }
            null !== nextInstance ? (workInProgress2.memoizedState = {
              dehydrated: nextInstance,
              treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, JSCompiler_temp$jscomp$0 = createFiberImplClass(
              18,
              null,
              null,
              0
            ), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress2, workInProgress2.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = true) : JSCompiler_temp$jscomp$0 = false;
          }
          JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress2);
        }
        nextInstance = workInProgress2.memoizedState;
        if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance))
          return isSuspenseInstanceFallback(nextInstance) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912, null;
        popSuspenseHandler(workInProgress2);
      }
      nextInstance = nextProps.children;
      nextProps = nextProps.fallback;
      if (showFallback)
        return reuseSuspenseHandlerOnStack(), showFallback = workInProgress2.mode, nextInstance = mountWorkInProgressOffscreenFiber(
          { mode: "hidden", children: nextInstance },
          showFallback
        ), nextProps = createFiberFromFragment(
          nextProps,
          showFallback,
          renderLanes2,
          null
        ), nextInstance.return = workInProgress2, nextProps.return = workInProgress2, nextInstance.sibling = nextProps, workInProgress2.child = nextInstance, showFallback = workInProgress2.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes2), showFallback.childLanes = getRemainingWorkInPrimaryTree(
          current,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, nextProps;
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      return mountSuspensePrimaryChildren(workInProgress2, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
      if (didSuspend)
        workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(), workInProgress2.child = current.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, nextInstance = workInProgress2.mode, nextProps = mountWorkInProgressOffscreenFiber(
          { mode: "visible", children: nextProps.children },
          nextInstance
        ), showFallback = createFiberFromFragment(
          showFallback,
          nextInstance,
          renderLanes2,
          null
        ), showFallback.flags |= 2, nextProps.return = workInProgress2, showFallback.return = workInProgress2, nextProps.sibling = showFallback, workInProgress2.child = nextProps, reconcileChildFibers(
          workInProgress2,
          current.child,
          null,
          renderLanes2
        ), nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = showFallback);
      else if (pushPrimaryTreeSuspenseHandler(workInProgress2), isSuspenseInstanceFallback(nextInstance)) {
        JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
        if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
        JSCompiler_temp = digest;
        nextProps = Error(formatProdErrorMessage(419));
        nextProps.stack = "";
        nextProps.digest = JSCompiler_temp;
        queueHydrationError({ value: nextProps, source: null, stack: null });
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        );
      } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress2, renderLanes2, false), JSCompiler_temp = 0 !== (renderLanes2 & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
        JSCompiler_temp = workInProgressRoot;
        if (null !== JSCompiler_temp && (nextProps = renderLanes2 & -renderLanes2, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes2)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane))
          throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
        "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        );
      } else
        "$?" === nextInstance.data ? (workInProgress2.flags |= 192, workInProgress2.child = current.child, workInProgress2 = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(
          nextInstance.nextSibling
        ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress2), workInProgress2 = mountSuspensePrimaryChildren(
          workInProgress2,
          nextProps.children
        ), workInProgress2.flags |= 4096);
      return workInProgress2;
    }
    if (showFallback)
      return reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, nextInstance = workInProgress2.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
      }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(
        showFallback,
        nextInstance,
        renderLanes2,
        null
      ), showFallback.flags |= 2), showFallback.return = workInProgress2, nextProps.return = workInProgress2, nextProps.sibling = showFallback, workInProgress2.child = nextProps, nextProps = showFallback, showFallback = workInProgress2.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes2) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? { parent: digest, pool: digest } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes2,
        cachePool: JSCompiler_temp$jscomp$0
      }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(
        current,
        JSCompiler_temp,
        renderLanes2
      ), workInProgress2.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress2);
    renderLanes2 = current.child;
    current = renderLanes2.sibling;
    renderLanes2 = createWorkInProgress(renderLanes2, {
      mode: "visible",
      children: nextProps.children
    });
    renderLanes2.return = workInProgress2;
    renderLanes2.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress2.deletions, null === JSCompiler_temp ? (workInProgress2.deletions = [current], workInProgress2.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress2.child = renderLanes2;
    workInProgress2.memoizedState = null;
    return renderLanes2;
  }
  function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber(
      { mode: "visible", children: primaryChildren },
      workInProgress2.mode
    );
    primaryChildren.return = workInProgress2;
    return workInProgress2.child = primaryChildren;
  }
  function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    };
    return offscreenProps;
  }
  function retrySuspenseComponentWithoutHydrating(current, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current.child, null, renderLanes2);
    current = mountSuspensePrimaryChildren(
      workInProgress2,
      workInProgress2.pendingProps.children
    );
    current.flags |= 2;
    workInProgress2.memoizedState = null;
    return current;
  }
  function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
    fiber.lanes |= renderLanes2;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes2);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes2, propagationRoot);
  }
  function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress2.memoizedState;
    null === renderState ? workInProgress2.memoizedState = {
      isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail,
      tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
  }
  function updateSuspenseListComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress2, nextProps.children, renderLanes2);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2))
      nextProps = nextProps & 1 | 2, workInProgress2.flags |= 128;
    else {
      if (null !== current && 0 !== (current.flags & 128))
        a: for (current = workInProgress2.child; null !== current; ) {
          if (13 === current.tag)
            null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes2, workInProgress2);
          else if (19 === current.tag)
            scheduleSuspenseWorkOnFiber(current, renderLanes2, workInProgress2);
          else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
          }
          if (current === workInProgress2) break a;
          for (; null === current.sibling; ) {
            if (null === current.return || current.return === workInProgress2)
              break a;
            current = current.return;
          }
          current.sibling.return = current.return;
          current = current.sibling;
        }
      nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch (revealOrder) {
      case "forwards":
        renderLanes2 = workInProgress2.child;
        for (revealOrder = null; null !== renderLanes2; )
          current = renderLanes2.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
        renderLanes2 = revealOrder;
        null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
        initSuspenseListRenderState(
          workInProgress2,
          false,
          revealOrder,
          renderLanes2,
          tailMode
        );
        break;
      case "backwards":
        renderLanes2 = null;
        revealOrder = workInProgress2.child;
        for (workInProgress2.child = null; null !== revealOrder; ) {
          current = revealOrder.alternate;
          if (null !== current && null === findFirstSuspended(current)) {
            workInProgress2.child = revealOrder;
            break;
          }
          current = revealOrder.sibling;
          revealOrder.sibling = renderLanes2;
          renderLanes2 = revealOrder;
          revealOrder = current;
        }
        initSuspenseListRenderState(
          workInProgress2,
          true,
          renderLanes2,
          null,
          tailMode
        );
        break;
      case "together":
        initSuspenseListRenderState(workInProgress2, false, null, null, void 0);
        break;
      default:
        workInProgress2.memoizedState = null;
    }
    return workInProgress2.child;
  }
  function bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2) {
    null !== current && (workInProgress2.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress2.lanes;
    if (0 === (renderLanes2 & workInProgress2.childLanes))
      if (null !== current) {
        if (propagateParentContextChanges(
          current,
          workInProgress2,
          renderLanes2,
          false
        ), 0 === (renderLanes2 & workInProgress2.childLanes))
          return null;
      } else return null;
    if (null !== current && workInProgress2.child !== current.child)
      throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress2.child) {
      current = workInProgress2.child;
      renderLanes2 = createWorkInProgress(current, current.pendingProps);
      workInProgress2.child = renderLanes2;
      for (renderLanes2.return = workInProgress2; null !== current.sibling; )
        current = current.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current, current.pendingProps), renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
    }
    return workInProgress2.child;
  }
  function checkScheduledUpdateOrContext(current, renderLanes2) {
    if (0 !== (current.lanes & renderLanes2)) return true;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? true : false;
  }
  function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress2, renderLanes2) {
    switch (workInProgress2.tag) {
      case 3:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        pushProvider(workInProgress2, CacheContext, current.memoizedState.cache);
        resetHydrationState();
        break;
      case 27:
      case 5:
        pushHostContext(workInProgress2);
        break;
      case 4:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        break;
      case 10:
        pushProvider(
          workInProgress2,
          workInProgress2.type,
          workInProgress2.memoizedProps.value
        );
        break;
      case 13:
        var state = workInProgress2.memoizedState;
        if (null !== state) {
          if (null !== state.dehydrated)
            return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
          if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
            return updateSuspenseComponent(current, workInProgress2, renderLanes2);
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          current = bailoutOnAlreadyFinishedWork(
            current,
            workInProgress2,
            renderLanes2
          );
          return null !== current ? current.sibling : null;
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        break;
      case 19:
        var didSuspendBefore = 0 !== (current.flags & 128);
        state = 0 !== (renderLanes2 & workInProgress2.childLanes);
        state || (propagateParentContextChanges(
          current,
          workInProgress2,
          renderLanes2,
          false
        ), state = 0 !== (renderLanes2 & workInProgress2.childLanes));
        if (didSuspendBefore) {
          if (state)
            return updateSuspenseListComponent(
              current,
              workInProgress2,
              renderLanes2
            );
          workInProgress2.flags |= 128;
        }
        didSuspendBefore = workInProgress2.memoizedState;
        null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
        push(suspenseStackCursor, suspenseStackCursor.current);
        if (state) break;
        else return null;
      case 22:
      case 23:
        return workInProgress2.lanes = 0, updateOffscreenComponent(current, workInProgress2, renderLanes2);
      case 24:
        pushProvider(workInProgress2, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
  }
  function beginWork(current, workInProgress2, renderLanes2) {
    if (null !== current)
      if (current.memoizedProps !== workInProgress2.pendingProps)
        didReceiveUpdate = true;
      else {
        if (!checkScheduledUpdateOrContext(current, renderLanes2) && 0 === (workInProgress2.flags & 128))
          return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
            current,
            workInProgress2,
            renderLanes2
          );
        didReceiveUpdate = 0 !== (current.flags & 131072) ? true : false;
      }
    else
      didReceiveUpdate = false, isHydrating && 0 !== (workInProgress2.flags & 1048576) && pushTreeId(workInProgress2, treeForkCount, workInProgress2.index);
    workInProgress2.lanes = 0;
    switch (workInProgress2.tag) {
      case 16:
        a: {
          current = workInProgress2.pendingProps;
          var lazyComponent = workInProgress2.elementType, init2 = lazyComponent._init;
          lazyComponent = init2(lazyComponent._payload);
          workInProgress2.type = lazyComponent;
          if ("function" === typeof lazyComponent)
            shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress2.tag = 1, workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              lazyComponent,
              current,
              renderLanes2
            )) : (workInProgress2.tag = 0, workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              lazyComponent,
              current,
              renderLanes2
            ));
          else {
            if (void 0 !== lazyComponent && null !== lazyComponent) {
              if (init2 = lazyComponent.$$typeof, init2 === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  lazyComponent,
                  current,
                  renderLanes2
                );
                break a;
              } else if (init2 === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  lazyComponent,
                  current,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = getComponentNameFromType(lazyComponent) || lazyComponent;
            throw Error(formatProdErrorMessage(306, workInProgress2, ""));
          }
        }
        return workInProgress2;
      case 0:
        return updateFunctionComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 1:
        return lazyComponent = workInProgress2.type, init2 = resolveClassComponentProps(
          lazyComponent,
          workInProgress2.pendingProps
        ), updateClassComponent(
          current,
          workInProgress2,
          lazyComponent,
          init2,
          renderLanes2
        );
      case 3:
        a: {
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          if (null === current) throw Error(formatProdErrorMessage(387));
          lazyComponent = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          init2 = prevState.element;
          cloneUpdateQueue(current, workInProgress2);
          processUpdateQueue(workInProgress2, lazyComponent, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          lazyComponent = nextState.cache;
          pushProvider(workInProgress2, CacheContext, lazyComponent);
          lazyComponent !== prevState.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          );
          suspendIfUpdateReadFromEntangledAsyncAction();
          lazyComponent = nextState.element;
          if (prevState.isDehydrated)
            if (prevState = {
              element: lazyComponent,
              isDehydrated: false,
              cache: nextState.cache
            }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
              workInProgress2 = mountHostRootWithoutHydrating(
                current,
                workInProgress2,
                lazyComponent,
                renderLanes2
              );
              break a;
            } else if (lazyComponent !== init2) {
              init2 = createCapturedValueAtFiber(
                Error(formatProdErrorMessage(424)),
                workInProgress2
              );
              queueHydrationError(init2);
              workInProgress2 = mountHostRootWithoutHydrating(
                current,
                workInProgress2,
                lazyComponent,
                renderLanes2
              );
              break a;
            } else {
              current = workInProgress2.stateNode.containerInfo;
              switch (current.nodeType) {
                case 9:
                  current = current.body;
                  break;
                default:
                  current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
              }
              nextHydratableInstance = getNextHydratable(current.firstChild);
              hydrationParentFiber = workInProgress2;
              isHydrating = true;
              hydrationErrors = null;
              rootOrSingletonContext = true;
              renderLanes2 = mountChildFibers(
                workInProgress2,
                null,
                lazyComponent,
                renderLanes2
              );
              for (workInProgress2.child = renderLanes2; renderLanes2; )
                renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
            }
          else {
            resetHydrationState();
            if (lazyComponent === init2) {
              workInProgress2 = bailoutOnAlreadyFinishedWork(
                current,
                workInProgress2,
                renderLanes2
              );
              break a;
            }
            reconcileChildren(
              current,
              workInProgress2,
              lazyComponent,
              renderLanes2
            );
          }
          workInProgress2 = workInProgress2.child;
        }
        return workInProgress2;
      case 26:
        return markRef(current, workInProgress2), null === current ? (renderLanes2 = getResource(
          workInProgress2.type,
          null,
          workInProgress2.pendingProps,
          null
        )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current = workInProgress2.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(
          rootInstanceStackCursor.current
        ).createElement(renderLanes2), lazyComponent[internalInstanceKey] = workInProgress2, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes2, current), markNodeAsHoistable(lazyComponent), workInProgress2.stateNode = lazyComponent) : workInProgress2.memoizedState = getResource(
          workInProgress2.type,
          current.memoizedProps,
          workInProgress2.pendingProps,
          current.memoizedState
        ), null;
      case 27:
        return pushHostContext(workInProgress2), null === current && isHydrating && (lazyComponent = workInProgress2.stateNode = resolveSingletonInstance(
          workInProgress2.type,
          workInProgress2.pendingProps,
          rootInstanceStackCursor.current
        ), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, init2 = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = init2, nextHydratableInstance = getNextHydratable(
          lazyComponent.firstChild
        )) : nextHydratableInstance = init2), reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), markRef(current, workInProgress2), null === current && (workInProgress2.flags |= 4194304), workInProgress2.child;
      case 5:
        if (null === current && isHydrating) {
          if (init2 = lazyComponent = nextHydratableInstance)
            lazyComponent = canHydrateInstance(
              lazyComponent,
              workInProgress2.type,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== lazyComponent ? (workInProgress2.stateNode = lazyComponent, hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(
              lazyComponent.firstChild
            ), rootOrSingletonContext = false, init2 = true) : init2 = false;
          init2 || throwOnHydrationMismatch(workInProgress2);
        }
        pushHostContext(workInProgress2);
        init2 = workInProgress2.type;
        prevState = workInProgress2.pendingProps;
        nextState = null !== current ? current.memoizedProps : null;
        lazyComponent = prevState.children;
        shouldSetTextContent(init2, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init2, nextState) && (workInProgress2.flags |= 32);
        null !== workInProgress2.memoizedState && (init2 = renderWithHooks(
          current,
          workInProgress2,
          TransitionAwareHostComponent,
          null,
          null,
          renderLanes2
        ), HostTransitionContext._currentValue = init2);
        markRef(current, workInProgress2);
        reconcileChildren(current, workInProgress2, lazyComponent, renderLanes2);
        return workInProgress2.child;
      case 6:
        if (null === current && isHydrating) {
          if (current = renderLanes2 = nextHydratableInstance)
            renderLanes2 = canHydrateTextInstance(
              renderLanes2,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== renderLanes2 ? (workInProgress2.stateNode = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, current = true) : current = false;
          current || throwOnHydrationMismatch(workInProgress2);
        }
        return null;
      case 13:
        return updateSuspenseComponent(current, workInProgress2, renderLanes2);
      case 4:
        return pushHostContainer(
          workInProgress2,
          workInProgress2.stateNode.containerInfo
        ), lazyComponent = workInProgress2.pendingProps, null === current ? workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          lazyComponent,
          renderLanes2
        ) : reconcileChildren(
          current,
          workInProgress2,
          lazyComponent,
          renderLanes2
        ), workInProgress2.child;
      case 11:
        return updateForwardRef(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 7:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps,
          renderLanes2
        ), workInProgress2.child;
      case 8:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 12:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 10:
        return lazyComponent = workInProgress2.pendingProps, pushProvider(workInProgress2, workInProgress2.type, lazyComponent.value), reconcileChildren(
          current,
          workInProgress2,
          lazyComponent.children,
          renderLanes2
        ), workInProgress2.child;
      case 9:
        return init2 = workInProgress2.type._context, lazyComponent = workInProgress2.pendingProps.children, prepareToReadContext(workInProgress2), init2 = readContext(init2), lazyComponent = lazyComponent(init2), workInProgress2.flags |= 1, reconcileChildren(current, workInProgress2, lazyComponent, renderLanes2), workInProgress2.child;
      case 14:
        return updateMemoComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 15:
        return updateSimpleMemoComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 19:
        return updateSuspenseListComponent(current, workInProgress2, renderLanes2);
      case 31:
        return lazyComponent = workInProgress2.pendingProps, renderLanes2 = workInProgress2.mode, lazyComponent = {
          mode: lazyComponent.mode,
          children: lazyComponent.children
        }, null === current ? (renderLanes2 = mountWorkInProgressOffscreenFiber(
          lazyComponent,
          renderLanes2
        ), renderLanes2.ref = workInProgress2.ref, workInProgress2.child = renderLanes2, renderLanes2.return = workInProgress2, workInProgress2 = renderLanes2) : (renderLanes2 = createWorkInProgress(current.child, lazyComponent), renderLanes2.ref = workInProgress2.ref, workInProgress2.child = renderLanes2, renderLanes2.return = workInProgress2, workInProgress2 = renderLanes2), workInProgress2;
      case 22:
        return updateOffscreenComponent(current, workInProgress2, renderLanes2);
      case 24:
        return prepareToReadContext(workInProgress2), lazyComponent = readContext(CacheContext), null === current ? (init2 = peekCacheFromPool(), null === init2 && (init2 = workInProgressRoot, prevState = createCache3(), init2.pooledCache = prevState, prevState.refCount++, null !== prevState && (init2.pooledCacheLanes |= renderLanes2), init2 = prevState), workInProgress2.memoizedState = {
          parent: lazyComponent,
          cache: init2
        }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, init2)) : (0 !== (current.lanes & renderLanes2) && (cloneUpdateQueue(current, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), init2 = current.memoizedState, prevState = workInProgress2.memoizedState, init2.parent !== lazyComponent ? (init2 = { parent: lazyComponent, cache: lazyComponent }, workInProgress2.memoizedState = init2, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = init2), pushProvider(workInProgress2, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress2, CacheContext, lazyComponent), lazyComponent !== init2.cache && propagateContextChanges(
          workInProgress2,
          [CacheContext],
          renderLanes2,
          true
        ))), reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 29:
        throw workInProgress2.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress2.tag));
  }
  function markUpdate(workInProgress2) {
    workInProgress2.flags |= 4;
  }
  function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4))
      workInProgress2.flags &= -16777217;
    else if (workInProgress2.flags |= 16777216, !preloadResource(resource)) {
      resource = suspenseHandlerStackCursor.current;
      if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary))
        throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
      workInProgress2.flags |= 8192;
    }
  }
  function scheduleRetryEffect(workInProgress2, retryQueue) {
    null !== retryQueue && (workInProgress2.flags |= 4);
    workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
  }
  function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating)
      switch (renderState.tailMode) {
        case "hidden":
          hasRenderedATailFallback = renderState.tail;
          for (var lastTailNode = null; null !== hasRenderedATailFallback; )
            null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
          null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
          break;
        case "collapsed":
          lastTailNode = renderState.tail;
          for (var lastTailNode$113 = null; null !== lastTailNode; )
            null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
          null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
      }
  }
  function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout)
      for (var child$114 = completedWork.child; null !== child$114; )
        newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else
      for (child$114 = completedWork.child; null !== child$114; )
        newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
  }
  function completeWork(current, workInProgress2, renderLanes2) {
    var newProps = workInProgress2.pendingProps;
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return bubbleProperties(workInProgress2), null;
      case 1:
        return bubbleProperties(workInProgress2), null;
      case 3:
        renderLanes2 = workInProgress2.stateNode;
        newProps = null;
        null !== current && (newProps = current.memoizedState.cache);
        workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
        popProvider(CacheContext);
        popHostContainer();
        renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
        if (null === current || null === current.child)
          popHydrationState(workInProgress2) ? markUpdate(workInProgress2) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
        bubbleProperties(workInProgress2);
        return null;
      case 26:
        return renderLanes2 = workInProgress2.memoizedState, null === current ? (markUpdate(workInProgress2), null !== renderLanes2 ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, renderLanes2)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217)) : renderLanes2 ? renderLanes2 !== current.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, renderLanes2)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217), null;
      case 27:
        popHostContext(workInProgress2);
        renderLanes2 = rootInstanceStackCursor.current;
        var type4 = workInProgress2.type;
        if (null !== current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current = contextStackCursor.current;
          popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current = resolveSingletonInstance(type4, newProps, renderLanes2), workInProgress2.stateNode = current, markUpdate(workInProgress2));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 5:
        popHostContext(workInProgress2);
        renderLanes2 = workInProgress2.type;
        if (null !== current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current = contextStackCursor.current;
          if (popHydrationState(workInProgress2))
            prepareToHydrateHostInstance(workInProgress2);
          else {
            type4 = getOwnerDocumentFromRootContainer(
              rootInstanceStackCursor.current
            );
            switch (current) {
              case 1:
                current = type4.createElementNS(
                  "http://www.w3.org/2000/svg",
                  renderLanes2
                );
                break;
              case 2:
                current = type4.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  renderLanes2
                );
                break;
              default:
                switch (renderLanes2) {
                  case "svg":
                    current = type4.createElementNS(
                      "http://www.w3.org/2000/svg",
                      renderLanes2
                    );
                    break;
                  case "math":
                    current = type4.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      renderLanes2
                    );
                    break;
                  case "script":
                    current = type4.createElement("div");
                    current.innerHTML = "<script><\/script>";
                    current = current.removeChild(current.firstChild);
                    break;
                  case "select":
                    current = "string" === typeof newProps.is ? type4.createElement("select", { is: newProps.is }) : type4.createElement("select");
                    newProps.multiple ? current.multiple = true : newProps.size && (current.size = newProps.size);
                    break;
                  default:
                    current = "string" === typeof newProps.is ? type4.createElement(renderLanes2, { is: newProps.is }) : type4.createElement(renderLanes2);
                }
            }
            current[internalInstanceKey] = workInProgress2;
            current[internalPropsKey] = newProps;
            a: for (type4 = workInProgress2.child; null !== type4; ) {
              if (5 === type4.tag || 6 === type4.tag)
                current.appendChild(type4.stateNode);
              else if (4 !== type4.tag && 27 !== type4.tag && null !== type4.child) {
                type4.child.return = type4;
                type4 = type4.child;
                continue;
              }
              if (type4 === workInProgress2) break a;
              for (; null === type4.sibling; ) {
                if (null === type4.return || type4.return === workInProgress2)
                  break a;
                type4 = type4.return;
              }
              type4.sibling.return = type4.return;
              type4 = type4.sibling;
            }
            workInProgress2.stateNode = current;
            a: switch (setInitialProperties(current, renderLanes2, newProps), renderLanes2) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                current = !!newProps.autoFocus;
                break a;
              case "img":
                current = true;
                break a;
              default:
                current = false;
            }
            current && markUpdate(workInProgress2);
          }
        }
        bubbleProperties(workInProgress2);
        workInProgress2.flags &= -16777217;
        return null;
      case 6:
        if (current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if ("string" !== typeof newProps && null === workInProgress2.stateNode)
            throw Error(formatProdErrorMessage(166));
          current = rootInstanceStackCursor.current;
          if (popHydrationState(workInProgress2)) {
            current = workInProgress2.stateNode;
            renderLanes2 = workInProgress2.memoizedProps;
            newProps = null;
            type4 = hydrationParentFiber;
            if (null !== type4)
              switch (type4.tag) {
                case 27:
                case 5:
                  newProps = type4.memoizedProps;
              }
            current[internalInstanceKey] = workInProgress2;
            current = current.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes2) ? true : false;
            current || throwOnHydrationMismatch(workInProgress2);
          } else
            current = getOwnerDocumentFromRootContainer(current).createTextNode(
              newProps
            ), current[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current;
        }
        bubbleProperties(workInProgress2);
        return null;
      case 13:
        newProps = workInProgress2.memoizedState;
        if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
          type4 = popHydrationState(workInProgress2);
          if (null !== newProps && null !== newProps.dehydrated) {
            if (null === current) {
              if (!type4) throw Error(formatProdErrorMessage(318));
              type4 = workInProgress2.memoizedState;
              type4 = null !== type4 ? type4.dehydrated : null;
              if (!type4) throw Error(formatProdErrorMessage(317));
              type4[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            type4 = false;
          } else
            type4 = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type4), type4 = true;
          if (!type4) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
        }
        popSuspenseHandler(workInProgress2);
        if (0 !== (workInProgress2.flags & 128))
          return workInProgress2.lanes = renderLanes2, workInProgress2;
        renderLanes2 = null !== newProps;
        current = null !== current && null !== current.memoizedState;
        if (renderLanes2) {
          newProps = workInProgress2.child;
          type4 = null;
          null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type4 = newProps.alternate.memoizedState.cachePool.pool);
          var cache$127 = null;
          null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
          cache$127 !== type4 && (newProps.flags |= 2048);
        }
        renderLanes2 !== current && renderLanes2 && (workInProgress2.child.flags |= 8192);
        scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
        bubbleProperties(workInProgress2);
        return null;
      case 4:
        return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress2.stateNode.containerInfo), bubbleProperties(workInProgress2), null;
      case 10:
        return popProvider(workInProgress2.type), bubbleProperties(workInProgress2), null;
      case 19:
        pop(suspenseStackCursor);
        type4 = workInProgress2.memoizedState;
        if (null === type4) return bubbleProperties(workInProgress2), null;
        newProps = 0 !== (workInProgress2.flags & 128);
        cache$127 = type4.rendering;
        if (null === cache$127)
          if (newProps) cutOffTailIfNeeded(type4, false);
          else {
            if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128))
              for (current = workInProgress2.child; null !== current; ) {
                cache$127 = findFirstSuspended(current);
                if (null !== cache$127) {
                  workInProgress2.flags |= 128;
                  cutOffTailIfNeeded(type4, false);
                  current = cache$127.updateQueue;
                  workInProgress2.updateQueue = current;
                  scheduleRetryEffect(workInProgress2, current);
                  workInProgress2.subtreeFlags = 0;
                  current = renderLanes2;
                  for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                    resetWorkInProgress(renderLanes2, current), renderLanes2 = renderLanes2.sibling;
                  push(
                    suspenseStackCursor,
                    suspenseStackCursor.current & 1 | 2
                  );
                  return workInProgress2.child;
                }
                current = current.sibling;
              }
            null !== type4.tail && now() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(type4, false), workInProgress2.lanes = 4194304);
          }
        else {
          if (!newProps)
            if (current = findFirstSuspended(cache$127), null !== current) {
              if (workInProgress2.flags |= 128, newProps = true, current = current.updateQueue, workInProgress2.updateQueue = current, scheduleRetryEffect(workInProgress2, current), cutOffTailIfNeeded(type4, true), null === type4.tail && "hidden" === type4.tailMode && !cache$127.alternate && !isHydrating)
                return bubbleProperties(workInProgress2), null;
            } else
              2 * now() - type4.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(type4, false), workInProgress2.lanes = 4194304);
          type4.isBackwards ? (cache$127.sibling = workInProgress2.child, workInProgress2.child = cache$127) : (current = type4.last, null !== current ? current.sibling = cache$127 : workInProgress2.child = cache$127, type4.last = cache$127);
        }
        if (null !== type4.tail)
          return workInProgress2 = type4.tail, type4.rendering = workInProgress2, type4.tail = workInProgress2.sibling, type4.renderingStartTime = now(), workInProgress2.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress2;
        bubbleProperties(workInProgress2);
        return null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), newProps = null !== workInProgress2.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes2 = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current && pop(resumedCache), null;
      case 24:
        return renderLanes2 = null, null !== current && (renderLanes2 = current.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress2), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress2.tag));
  }
  function unwindWork(current, workInProgress2) {
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 1:
        return current = workInProgress2.flags, current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 3:
        return popProvider(CacheContext), popHostContainer(), current = workInProgress2.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 26:
      case 27:
      case 5:
        return popHostContext(workInProgress2), null;
      case 13:
        popSuspenseHandler(workInProgress2);
        current = workInProgress2.memoizedState;
        if (null !== current && null !== current.dehydrated) {
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage(340));
          resetHydrationState();
        }
        current = workInProgress2.flags;
        return current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 19:
        return pop(suspenseStackCursor), null;
      case 4:
        return popHostContainer(), null;
      case 10:
        return popProvider(workInProgress2.type), null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress2.flags, current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 24:
        return popProvider(CacheContext), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch (interruptedWork.tag) {
      case 3:
        popProvider(CacheContext);
        popHostContainer();
        break;
      case 26:
      case 27:
      case 5:
        popHostContext(interruptedWork);
        break;
      case 4:
        popHostContainer();
        break;
      case 13:
        popSuspenseHandler(interruptedWork);
        break;
      case 19:
        pop(suspenseStackCursor);
        break;
      case 10:
        popProvider(interruptedWork.type);
        break;
      case 22:
      case 23:
        popSuspenseHandler(interruptedWork);
        popHiddenContext();
        null !== current && pop(resumedCache);
        break;
      case 24:
        popProvider(CacheContext);
    }
  }
  function commitHookEffectListMount(flags2, finishedWork) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags2) === flags2) {
            lastEffect = void 0;
            var create = updateQueue.create, inst = updateQueue.inst;
            lastEffect = create();
            inst.destroy = lastEffect;
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error2) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error2);
    }
  }
  function commitHookEffectListUnmount(flags2, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags2) === flags2) {
            var inst = updateQueue.inst, destroy = inst.destroy;
            if (void 0 !== destroy) {
              inst.destroy = void 0;
              lastEffect = finishedWork;
              var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
              try {
                destroy_();
              } catch (error2) {
                captureCommitPhaseError(
                  lastEffect,
                  nearestMountedAncestor,
                  error2
                );
              }
            }
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error2) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error2);
    }
  }
  function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
      var instance = finishedWork.stateNode;
      try {
        commitCallbacks(updateQueue, instance);
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
  }
  function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(
      current.type,
      current.memoizedProps
    );
    instance.state = current.memoizedState;
    try {
      instance.componentWillUnmount();
    } catch (error2) {
      captureCommitPhaseError(current, nearestMountedAncestor, error2);
    }
  }
  function safelyAttachRef(current, nearestMountedAncestor) {
    try {
      var ref2 = current.ref;
      if (null !== ref2) {
        switch (current.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = current.stateNode;
            break;
          case 30:
            instanceToUse = current.stateNode;
            break;
          default:
            instanceToUse = current.stateNode;
        }
        "function" === typeof ref2 ? current.refCleanup = ref2(instanceToUse) : ref2.current = instanceToUse;
      }
    } catch (error2) {
      captureCommitPhaseError(current, nearestMountedAncestor, error2);
    }
  }
  function safelyDetachRef(current, nearestMountedAncestor) {
    var ref2 = current.ref, refCleanup = current.refCleanup;
    if (null !== ref2)
      if ("function" === typeof refCleanup)
        try {
          refCleanup();
        } catch (error2) {
          captureCommitPhaseError(current, nearestMountedAncestor, error2);
        } finally {
          current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
      else if ("function" === typeof ref2)
        try {
          ref2(null);
        } catch (error$143) {
          captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
      else ref2.current = null;
  }
  function commitHostMount(finishedWork) {
    var type4 = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
      a: switch (type4) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          props.autoFocus && instance.focus();
          break a;
        case "img":
          props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
      }
    } catch (error2) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error2);
    }
  }
  function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
      var domElement = finishedWork.stateNode;
      updateProperties(domElement, finishedWork.type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    } catch (error2) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error2);
    }
  }
  function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
  }
  function getHostSibling(fiber) {
    a: for (; ; ) {
      for (; null === fiber.sibling; ) {
        if (null === fiber.return || isHostParent(fiber.return)) return null;
        fiber = fiber.return;
      }
      fiber.sibling.return = fiber.return;
      for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
        if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
        if (fiber.flags & 2) continue a;
        if (null === fiber.child || 4 === fiber.tag) continue a;
        else fiber.child.return = fiber, fiber = fiber.child;
      }
      if (!(fiber.flags & 2)) return fiber.stateNode;
    }
  }
  function insertOrAppendPlacementNodeIntoContainer(node2, before, parent) {
    var tag = node2.tag;
    if (5 === tag || 6 === tag)
      node2 = node2.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node2, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node2), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$12));
    else if (4 !== tag && (27 === tag && isSingletonScope(node2.type) && (parent = node2.stateNode, before = null), node2 = node2.child, null !== node2))
      for (insertOrAppendPlacementNodeIntoContainer(node2, before, parent), node2 = node2.sibling; null !== node2; )
        insertOrAppendPlacementNodeIntoContainer(node2, before, parent), node2 = node2.sibling;
  }
  function insertOrAppendPlacementNode(node2, before, parent) {
    var tag = node2.tag;
    if (5 === tag || 6 === tag)
      node2 = node2.stateNode, before ? parent.insertBefore(node2, before) : parent.appendChild(node2);
    else if (4 !== tag && (27 === tag && isSingletonScope(node2.type) && (parent = node2.stateNode), node2 = node2.child, null !== node2))
      for (insertOrAppendPlacementNode(node2, before, parent), node2 = node2.sibling; null !== node2; )
        insertOrAppendPlacementNode(node2, before, parent), node2 = node2.sibling;
  }
  function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
      for (var type4 = finishedWork.type, attributes2 = singleton.attributes; attributes2.length; )
        singleton.removeAttributeNode(attributes2[0]);
      setInitialProperties(singleton, type4, props);
      singleton[internalInstanceKey] = finishedWork;
      singleton[internalPropsKey] = props;
    } catch (error2) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error2);
    }
  }
  var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
  function commitBeforeMutationEffects(root2, firstChild) {
    root2 = root2.containerInfo;
    eventsEnabled = _enabled;
    root2 = getActiveElementDeep(root2);
    if (hasSelectionCapabilities(root2)) {
      if ("selectionStart" in root2)
        var JSCompiler_temp = {
          start: root2.selectionStart,
          end: root2.selectionEnd
        };
      else
        a: {
          JSCompiler_temp = (JSCompiler_temp = root2.ownerDocument) && JSCompiler_temp.defaultView || window;
          var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
          if (selection && 0 !== selection.rangeCount) {
            JSCompiler_temp = selection.anchorNode;
            var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
            selection = selection.focusOffset;
            try {
              JSCompiler_temp.nodeType, focusNode.nodeType;
            } catch (e$20) {
              JSCompiler_temp = null;
              break a;
            }
            var length2 = 0, start2 = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node2 = root2, parentNode = null;
            b: for (; ; ) {
              for (var next4; ; ) {
                node2 !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node2.nodeType || (start2 = length2 + anchorOffset);
                node2 !== focusNode || 0 !== selection && 3 !== node2.nodeType || (end = length2 + selection);
                3 === node2.nodeType && (length2 += node2.nodeValue.length);
                if (null === (next4 = node2.firstChild)) break;
                parentNode = node2;
                node2 = next4;
              }
              for (; ; ) {
                if (node2 === root2) break b;
                parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start2 = length2);
                parentNode === focusNode && ++indexWithinFocus === selection && (end = length2);
                if (null !== (next4 = node2.nextSibling)) break;
                node2 = parentNode;
                parentNode = node2.parentNode;
              }
              node2 = next4;
            }
            JSCompiler_temp = -1 === start2 || -1 === end ? null : { start: start2, end };
          } else JSCompiler_temp = null;
        }
      JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
    } else JSCompiler_temp = null;
    selectionInformation = { focusedElem: root2, selectionRange: JSCompiler_temp };
    _enabled = false;
    for (nextEffect = firstChild; null !== nextEffect; )
      if (firstChild = nextEffect, root2 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root2)
        root2.return = firstChild, nextEffect = root2;
      else
        for (; null !== nextEffect; ) {
          firstChild = nextEffect;
          focusNode = firstChild.alternate;
          root2 = firstChild.flags;
          switch (firstChild.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (0 !== (root2 & 1024) && null !== focusNode) {
                root2 = void 0;
                JSCompiler_temp = firstChild;
                anchorOffset = focusNode.memoizedProps;
                focusNode = focusNode.memoizedState;
                selection = JSCompiler_temp.stateNode;
                try {
                  var resolvedPrevProps = resolveClassComponentProps(
                    JSCompiler_temp.type,
                    anchorOffset,
                    JSCompiler_temp.elementType === JSCompiler_temp.type
                  );
                  root2 = selection.getSnapshotBeforeUpdate(
                    resolvedPrevProps,
                    focusNode
                  );
                  selection.__reactInternalSnapshotBeforeUpdate = root2;
                } catch (error2) {
                  captureCommitPhaseError(
                    JSCompiler_temp,
                    JSCompiler_temp.return,
                    error2
                  );
                }
              }
              break;
            case 3:
              if (0 !== (root2 & 1024)) {
                if (root2 = firstChild.stateNode.containerInfo, JSCompiler_temp = root2.nodeType, 9 === JSCompiler_temp)
                  clearContainerSparingly(root2);
                else if (1 === JSCompiler_temp)
                  switch (root2.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      clearContainerSparingly(root2);
                      break;
                    default:
                      root2.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (0 !== (root2 & 1024)) throw Error(formatProdErrorMessage(163));
          }
          root2 = firstChild.sibling;
          if (null !== root2) {
            root2.return = firstChild.return;
            nextEffect = root2;
            break;
          }
          nextEffect = firstChild.return;
        }
  }
  function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags2 = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags2 & 4 && commitHookEffectListMount(5, finishedWork);
        break;
      case 1:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags2 & 4)
          if (finishedRoot = finishedWork.stateNode, null === current)
            try {
              finishedRoot.componentDidMount();
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          else {
            var prevProps = resolveClassComponentProps(
              finishedWork.type,
              current.memoizedProps
            );
            current = current.memoizedState;
            try {
              finishedRoot.componentDidUpdate(
                prevProps,
                current,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            } catch (error$142) {
              captureCommitPhaseError(
                finishedWork,
                finishedWork.return,
                error$142
              );
            }
          }
        flags2 & 64 && commitClassCallbacks(finishedWork);
        flags2 & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags2 & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
          current = null;
          if (null !== finishedWork.child)
            switch (finishedWork.child.tag) {
              case 27:
              case 5:
                current = finishedWork.child.stateNode;
                break;
              case 1:
                current = finishedWork.child.stateNode;
            }
          try {
            commitCallbacks(finishedRoot, current);
          } catch (error2) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error2);
          }
        }
        break;
      case 27:
        null === current && flags2 & 4 && commitHostSingletonAcquisition(finishedWork);
      case 26:
      case 5:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        null === current && flags2 & 4 && commitHostMount(finishedWork);
        flags2 & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 12:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        break;
      case 13:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags2 & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        flags2 & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(
          null,
          finishedWork
        ), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
        break;
      case 22:
        flags2 = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
        if (!flags2) {
          current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
          prevProps = offscreenSubtreeIsHidden;
          var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = flags2;
          (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            0 !== (finishedWork.subtreeFlags & 8772)
          ) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          offscreenSubtreeIsHidden = prevProps;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        }
        break;
      case 30:
        break;
      default:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
  }
  function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
  }
  var hostParent = null, hostParentIsContainer = false;
  function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for (parent = parent.child; null !== parent; )
      commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
  }
  function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
      try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
      } catch (err) {
      }
    switch (deletedFiber.tag) {
      case 26:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
        break;
      case 27:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
        isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        releaseSingletonInstance(deletedFiber.stateNode);
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 5:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
      case 6:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = null;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        if (null !== hostParent)
          if (hostParentIsContainer)
            try {
              (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
            } catch (error2) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error2
              );
            }
          else
            try {
              hostParent.removeChild(deletedFiber.stateNode);
            } catch (error2) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error2
              );
            }
        break;
      case 18:
        null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(
          9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
          deletedFiber.stateNode
        ), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
        break;
      case 4:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = deletedFiber.stateNode.containerInfo;
        hostParentIsContainer = true;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 1:
        offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
          deletedFiber,
          nearestMountedAncestor,
          prevHostParent
        ));
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 21:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 22:
        offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        offscreenSubtreeWasHidden = prevHostParent;
        break;
      default:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
    }
  }
  function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
  }
  function getRetryCache(finishedWork) {
    switch (finishedWork.tag) {
      case 13:
      case 19:
        var retryCache = finishedWork.stateNode;
        null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
        return retryCache;
      case 22:
        return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
      default:
        throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
  }
  function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
      var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
      retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
  }
  function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions)
      for (var i = 0; i < deletions.length; i++) {
        var childToDelete = deletions[i], root2 = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for (; null !== parent; ) {
          switch (parent.tag) {
            case 27:
              if (isSingletonScope(parent.type)) {
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              }
              break;
            case 5:
              hostParent = parent.stateNode;
              hostParentIsContainer = false;
              break a;
            case 3:
            case 4:
              hostParent = parent.stateNode.containerInfo;
              hostParentIsContainer = true;
              break a;
          }
          parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root2, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = false;
        root2 = childToDelete.alternate;
        null !== root2 && (root2.return = null);
        childToDelete.return = null;
      }
    if (parentFiber.subtreeFlags & 13878)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
  }
  var currentHoistableRoot = null;
  function commitMutationEffectsOnFiber(finishedWork, root2) {
    var current = finishedWork.alternate, flags2 = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
        break;
      case 1:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        flags2 & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags2 = finishedWork.callbacks, null !== flags2 && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags2 : current.concat(flags2))));
        break;
      case 26:
        var hoistableRoot = currentHoistableRoot;
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        if (flags2 & 4) {
          var currentResource = null !== current ? current.memoizedState : null;
          flags2 = finishedWork.memoizedState;
          if (null === current)
            if (null === flags2)
              if (null === finishedWork.stateNode) {
                a: {
                  flags2 = finishedWork.type;
                  current = finishedWork.memoizedProps;
                  hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                  b: switch (flags2) {
                    case "title":
                      currentResource = hoistableRoot.getElementsByTagName("title")[0];
                      if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop"))
                        currentResource = hoistableRoot.createElement(flags2), hoistableRoot.head.insertBefore(
                          currentResource,
                          hoistableRoot.querySelector("head > title")
                        );
                      setInitialProperties(currentResource, flags2, current);
                      currentResource[internalInstanceKey] = finishedWork;
                      markNodeAsHoistable(currentResource);
                      flags2 = currentResource;
                      break a;
                    case "link":
                      var maybeNodes = getHydratableHoistableCache(
                        "link",
                        "href",
                        hoistableRoot
                      ).get(flags2 + (current.href || ""));
                      if (maybeNodes) {
                        for (var i = 0; i < maybeNodes.length; i++)
                          if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                            maybeNodes.splice(i, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags2);
                      setInitialProperties(currentResource, flags2, current);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    case "meta":
                      if (maybeNodes = getHydratableHoistableCache(
                        "meta",
                        "content",
                        hoistableRoot
                      ).get(flags2 + (current.content || ""))) {
                        for (i = 0; i < maybeNodes.length; i++)
                          if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                            maybeNodes.splice(i, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags2);
                      setInitialProperties(currentResource, flags2, current);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    default:
                      throw Error(formatProdErrorMessage(468, flags2));
                  }
                  currentResource[internalInstanceKey] = finishedWork;
                  markNodeAsHoistable(currentResource);
                  flags2 = currentResource;
                }
                finishedWork.stateNode = flags2;
              } else
                mountHoistable(
                  hoistableRoot,
                  finishedWork.type,
                  finishedWork.stateNode
                );
            else
              finishedWork.stateNode = acquireResource(
                hoistableRoot,
                flags2,
                finishedWork.memoizedProps
              );
          else
            currentResource !== flags2 ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags2 ? mountHoistable(
              hoistableRoot,
              finishedWork.type,
              finishedWork.stateNode
            ) : acquireResource(
              hoistableRoot,
              flags2,
              finishedWork.memoizedProps
            )) : null === flags2 && null !== finishedWork.stateNode && commitHostUpdate(
              finishedWork,
              finishedWork.memoizedProps,
              current.memoizedProps
            );
        }
        break;
      case 27:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        null !== current && flags2 & 4 && commitHostUpdate(
          finishedWork,
          finishedWork.memoizedProps,
          current.memoizedProps
        );
        break;
      case 5:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        if (finishedWork.flags & 32) {
          hoistableRoot = finishedWork.stateNode;
          try {
            setTextContent(hoistableRoot, "");
          } catch (error2) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error2);
          }
        }
        flags2 & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(
          finishedWork,
          hoistableRoot,
          null !== current ? current.memoizedProps : hoistableRoot
        ));
        flags2 & 1024 && (needsFormReset = true);
        break;
      case 6:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        if (flags2 & 4) {
          if (null === finishedWork.stateNode)
            throw Error(formatProdErrorMessage(162));
          flags2 = finishedWork.memoizedProps;
          current = finishedWork.stateNode;
          try {
            current.nodeValue = flags2;
          } catch (error2) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error2);
          }
        }
        break;
      case 3:
        tagCaches = null;
        hoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(root2.containerInfo);
        recursivelyTraverseMutationEffects(root2, finishedWork);
        currentHoistableRoot = hoistableRoot;
        commitReconciliationEffects(finishedWork);
        if (flags2 & 4 && null !== current && current.memoizedState.isDehydrated)
          try {
            retryIfBlockedOn(root2.containerInfo);
          } catch (error2) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error2);
          }
        needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
        break;
      case 4:
        flags2 = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(
          finishedWork.stateNode.containerInfo
        );
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        currentHoistableRoot = flags2;
        break;
      case 12:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        break;
      case 13:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
        flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags2)));
        break;
      case 22:
        hoistableRoot = null !== finishedWork.memoizedState;
        var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
        recursivelyTraverseMutationEffects(root2, finishedWork);
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
        commitReconciliationEffects(finishedWork);
        if (flags2 & 8192)
          a: for (root2 = finishedWork.stateNode, root2._visibility = hoistableRoot ? root2._visibility & -2 : root2._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root2 = finishedWork; ; ) {
            if (5 === root2.tag || 26 === root2.tag) {
              if (null === current) {
                wasHidden = current = root2;
                try {
                  if (currentResource = wasHidden.stateNode, hoistableRoot)
                    maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                  else {
                    i = wasHidden.stateNode;
                    var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                  }
                } catch (error2) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error2);
                }
              }
            } else if (6 === root2.tag) {
              if (null === current) {
                wasHidden = root2;
                try {
                  wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                } catch (error2) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error2);
                }
              }
            } else if ((22 !== root2.tag && 23 !== root2.tag || null === root2.memoizedState || root2 === finishedWork) && null !== root2.child) {
              root2.child.return = root2;
              root2 = root2.child;
              continue;
            }
            if (root2 === finishedWork) break a;
            for (; null === root2.sibling; ) {
              if (null === root2.return || root2.return === finishedWork) break a;
              current === root2 && (current = null);
              root2 = root2.return;
            }
            current === root2 && (current = null);
            root2.sibling.return = root2.return;
            root2 = root2.sibling;
          }
        flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (current = flags2.retryQueue, null !== current && (flags2.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
        break;
      case 19:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags2)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        recursivelyTraverseMutationEffects(root2, finishedWork), commitReconciliationEffects(finishedWork);
    }
  }
  function commitReconciliationEffects(finishedWork) {
    var flags2 = finishedWork.flags;
    if (flags2 & 2) {
      try {
        for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
          if (isHostParent(parentFiber)) {
            hostParentFiber = parentFiber;
            break;
          }
          parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
        switch (hostParentFiber.tag) {
          case 27:
            var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before, parent);
            break;
          case 5:
            var parent$144 = hostParentFiber.stateNode;
            hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
            var before$145 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
            break;
          case 3:
          case 4:
            var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
            insertOrAppendPlacementNodeIntoContainer(
              finishedWork,
              before$147,
              parent$146
            );
            break;
          default:
            throw Error(formatProdErrorMessage(161));
        }
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
      finishedWork.flags &= -3;
    }
    flags2 & 4096 && (finishedWork.flags &= -4097);
  }
  function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
      }
  }
  function recursivelyTraverseLayoutEffects(root2, parentFiber) {
    if (parentFiber.subtreeFlags & 8772)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitLayoutEffectOnFiber(root2, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
  }
  function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedWork = parentFiber;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          releaseSingletonInstance(finishedWork.stateNode);
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(4, finishedWork);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current = finishedWork;
          finishedRoot = current.stateNode;
          if ("function" === typeof finishedRoot.componentDidMount)
            try {
              finishedRoot.componentDidMount();
            } catch (error2) {
              captureCommitPhaseError(current, current.return, error2);
            }
          current = finishedWork;
          finishedRoot = current.updateQueue;
          if (null !== finishedRoot) {
            var instance = current.stateNode;
            try {
              var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
              if (null !== hiddenCallbacks)
                for (finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)
                  callCallback(hiddenCallbacks[finishedRoot], instance);
            } catch (error2) {
              captureCommitPhaseError(current, current.return, error2);
            }
          }
          includeWorkInProgressEffects && flags2 & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current && flags2 & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags2 & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
  }
  function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
  }
  function recursivelyTraversePassiveMountEffects(root2, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveMountOnFiber(
          root2,
          parentFiber,
          committedLanes,
          committedTransitions
        ), parentFiber = parentFiber.sibling;
  }
  function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags2 = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags2 & 2048 && commitHookEffectListMount(9, finishedWork);
        break;
      case 1:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 3:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags2 & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
        break;
      case 12:
        if (flags2 & 2048) {
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          finishedRoot = finishedWork.stateNode;
          try {
            var _finishedWork$memoize2 = finishedWork.memoizedProps, id2 = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
            "function" === typeof onPostCommit && onPostCommit(
              id2,
              null === finishedWork.alternate ? "mount" : "update",
              finishedRoot.passiveEffectDuration,
              -0
            );
          } catch (error2) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error2);
          }
        } else
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
        break;
      case 13:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 23:
        break;
      case 22:
        _finishedWork$memoize2 = finishedWork.stateNode;
        id2 = finishedWork.alternate;
        null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          0 !== (finishedWork.subtreeFlags & 10256)
        ));
        flags2 & 2048 && commitOffscreenPassiveMountEffects(id2, finishedWork);
        break;
      case 24:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags2 & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
        break;
      default:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
    }
  }
  function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(8, finishedWork);
          break;
        case 23:
          break;
        case 22:
          var instance = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ));
          includeWorkInProgressEffects && flags2 & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags2 & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags2 = finishedWork.flags;
        switch (finishedWork.tag) {
          case 22:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags2 & 2048 && commitOffscreenPassiveMountEffects(
              finishedWork.alternate,
              finishedWork
            );
            break;
          case 24:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags2 & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
          default:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
      }
  }
  var suspenseyCommitFlag = 8192;
  function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function accumulateSuspenseyCommitOnFiber(fiber) {
    switch (fiber.tag) {
      case 26:
        recursivelyAccumulateSuspenseyCommit(fiber);
        fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
          currentHoistableRoot,
          fiber.memoizedState,
          fiber.memoizedProps
        );
        break;
      case 5:
        recursivelyAccumulateSuspenseyCommit(fiber);
        break;
      case 3:
      case 4:
        var previousHoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
        recursivelyAccumulateSuspenseyCommit(fiber);
        currentHoistableRoot = previousHoistableRoot;
        break;
      case 22:
        null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
        break;
      default:
        recursivelyAccumulateSuspenseyCommit(fiber);
    }
  }
  function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
      previousFiber.child = null;
      do
        previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
      while (null !== parentFiber);
    }
  }
  function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i = 0; i < deletions.length; i++) {
          var childToDelete = deletions[i];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function commitPassiveUnmountOnFiber(finishedWork) {
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 12:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 22:
        var instance = finishedWork.stateNode;
        null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      default:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
  }
  function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i = 0; i < deletions.length; i++) {
          var childToDelete = deletions[i];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      deletions = parentFiber;
      switch (deletions.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, deletions, deletions.return);
          recursivelyTraverseDisconnectPassiveEffects(deletions);
          break;
        case 22:
          i = deletions.stateNode;
          i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(deletions);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for (; null !== nextEffect; ) {
      var fiber = nextEffect;
      switch (fiber.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
          break;
        case 23:
        case 22:
          if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
            var cache2 = fiber.memoizedState.cachePool.pool;
            null != cache2 && cache2.refCount++;
          }
          break;
        case 24:
          releaseCache(fiber.memoizedState.cache);
      }
      cache2 = fiber.child;
      if (null !== cache2) cache2.return = fiber, nextEffect = cache2;
      else
        a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
          cache2 = nextEffect;
          var sibling = cache2.sibling, returnFiber = cache2.return;
          detachFiberAfterEffects(cache2);
          if (cache2 === fiber) {
            nextEffect = null;
            break a;
          }
          if (null !== sibling) {
            sibling.return = returnFiber;
            nextEffect = sibling;
            break a;
          }
          nextEffect = returnFiber;
        }
    }
  }
  var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
      var cache2 = readContext(CacheContext), cacheForType = cache2.data.get(resourceType);
      void 0 === cacheForType && (cacheForType = resourceType(), cache2.data.set(resourceType, cacheForType));
      return cacheForType;
    }
  }, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
  function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes)
      return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
      var actionScopeLane = currentEntangledLane;
      return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
  }
  function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
  }
  function scheduleUpdateOnFiber(root2, fiber, lane) {
    if (root2 === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root2.cancelPendingCommit)
      prepareFreshStack(root2, 0), markRootSuspended(
        root2,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    markRootUpdated$1(root2, lane);
    if (0 === (executionContext & 2) || root2 !== workInProgressRoot)
      root2 === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(
        root2,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      )), ensureRootIsScheduled(root2);
  }
  function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, true), renderWasConcurrent = shouldTimeSlice;
    do {
      if (0 === exitStatus) {
        workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, false);
        break;
      } else {
        forceSync = root$jscomp$0.current.alternate;
        if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
          exitStatus = renderRootSync(root$jscomp$0, lanes, false);
          renderWasConcurrent = false;
          continue;
        }
        if (2 === exitStatus) {
          renderWasConcurrent = lanes;
          if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
            var JSCompiler_inline_result = 0;
          else
            JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
          if (0 !== JSCompiler_inline_result) {
            lanes = JSCompiler_inline_result;
            a: {
              var root2 = root$jscomp$0;
              exitStatus = workInProgressRootConcurrentErrors;
              var wasRootDehydrated = root2.current.memoizedState.isDehydrated;
              wasRootDehydrated && (prepareFreshStack(root2, JSCompiler_inline_result).flags |= 256);
              JSCompiler_inline_result = renderRootSync(
                root2,
                JSCompiler_inline_result,
                false
              );
              if (2 !== JSCompiler_inline_result) {
                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                  root2.errorRecoveryDisabledLanes |= renderWasConcurrent;
                  workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                  exitStatus = 4;
                  break a;
                }
                renderWasConcurrent = workInProgressRootRecoverableErrors;
                workInProgressRootRecoverableErrors = exitStatus;
                null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(
                  workInProgressRootRecoverableErrors,
                  renderWasConcurrent
                ));
              }
              exitStatus = JSCompiler_inline_result;
            }
            renderWasConcurrent = false;
            if (2 !== exitStatus) continue;
          }
        }
        if (1 === exitStatus) {
          prepareFreshStack(root$jscomp$0, 0);
          markRootSuspended(root$jscomp$0, lanes, 0, true);
          break;
        }
        a: {
          shouldTimeSlice = root$jscomp$0;
          renderWasConcurrent = exitStatus;
          switch (renderWasConcurrent) {
            case 0:
            case 1:
              throw Error(formatProdErrorMessage(345));
            case 4:
              if ((lanes & 4194048) !== lanes) break;
            case 6:
              markRootSuspended(
                shouldTimeSlice,
                lanes,
                workInProgressDeferredLane,
                !workInProgressRootDidSkipSuspendedSiblings
              );
              break a;
            case 2:
              workInProgressRootRecoverableErrors = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(formatProdErrorMessage(329));
          }
          if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
            markRootSuspended(
              shouldTimeSlice,
              lanes,
              workInProgressDeferredLane,
              !workInProgressRootDidSkipSuspendedSiblings
            );
            if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
            shouldTimeSlice.timeoutHandle = scheduleTimeout(
              commitRootWhenReady.bind(
                null,
                shouldTimeSlice,
                forceSync,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                renderWasConcurrent,
                2,
                -0,
                0
              ),
              exitStatus
            );
            break a;
          }
          commitRootWhenReady(
            shouldTimeSlice,
            forceSync,
            workInProgressRootRecoverableErrors,
            workInProgressTransitions,
            workInProgressRootDidIncludeRecursiveRenderUpdate,
            lanes,
            workInProgressDeferredLane,
            workInProgressRootInterleavedUpdatedLanes,
            workInProgressSuspendedRetryLanes,
            workInProgressRootDidSkipSuspendedSiblings,
            renderWasConcurrent,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (1);
    ensureRootIsScheduled(root$jscomp$0);
  }
  function commitRootWhenReady(root2, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root2.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
      if (suspendedState = { stylesheets: null, count: 0, unsuspend: noop4 }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
        root2.cancelPendingCommit = suspendedCommitReason(
          commitRoot.bind(
            null,
            root2,
            finishedWork,
            lanes,
            recoverableErrors,
            transitions,
            didIncludeRenderPhaseUpdate,
            spawnedLane,
            updatedLanes,
            suspendedRetryLanes,
            exitStatus,
            1,
            completedRenderStartTime,
            completedRenderEndTime
          )
        );
        markRootSuspended(root2, lanes, spawnedLane, !didSkipSuspendedSiblings);
        return;
      }
    }
    commitRoot(
      root2,
      finishedWork,
      lanes,
      recoverableErrors,
      transitions,
      didIncludeRenderPhaseUpdate,
      spawnedLane,
      updatedLanes,
      suspendedRetryLanes
    );
  }
  function isRenderConsistentWithExternalStores(finishedWork) {
    for (var node2 = finishedWork; ; ) {
      var tag = node2.tag;
      if ((0 === tag || 11 === tag || 15 === tag) && node2.flags & 16384 && (tag = node2.updateQueue, null !== tag && (tag = tag.stores, null !== tag)))
        for (var i = 0; i < tag.length; i++) {
          var check = tag[i], getSnapshot = check.getSnapshot;
          check = check.value;
          try {
            if (!objectIs(getSnapshot(), check)) return false;
          } catch (error2) {
            return false;
          }
        }
      tag = node2.child;
      if (node2.subtreeFlags & 16384 && null !== tag)
        tag.return = node2, node2 = tag;
      else {
        if (node2 === finishedWork) break;
        for (; null === node2.sibling; ) {
          if (null === node2.return || node2.return === finishedWork) return true;
          node2 = node2.return;
        }
        node2.sibling.return = node2.return;
        node2 = node2.sibling;
      }
    }
    return true;
  }
  function markRootSuspended(root2, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root2.suspendedLanes |= suspendedLanes;
    root2.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root2.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root2.expirationTimes;
    for (var lanes = suspendedLanes; 0 < lanes; ) {
      var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
      didAttemptEntireTree[index$4] = -1;
      lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, suspendedLanes);
  }
  function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
  }
  function resetWorkInProgressStack() {
    if (null !== workInProgress) {
      if (0 === workInProgressSuspendedReason)
        var interruptedWork = workInProgress.return;
      else
        interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
      for (; null !== interruptedWork; )
        unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
      workInProgress = null;
    }
  }
  function prepareFreshStack(root2, lanes) {
    var timeoutHandle = root2.timeoutHandle;
    -1 !== timeoutHandle && (root2.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root2.cancelPendingCommit;
    null !== timeoutHandle && (root2.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root2;
    workInProgress = timeoutHandle = createWorkInProgress(root2.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = false;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root2, lanes);
    workInProgressRootDidAttachPingListener = false;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = false;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root2.entangledLanes;
    if (0 !== allEntangledLanes)
      for (root2 = root2.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes; ) {
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root2[index$2];
        allEntangledLanes &= ~lane;
      }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
  }
  function handleThrow(root2, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(
      root2,
      createCapturedValueAtFiber(thrownValue, root2.current)
    ));
  }
  function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
  }
  function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
  }
  function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
      workInProgressRoot,
      workInProgressRootRenderLanes,
      workInProgressDeferredLane,
      false
    );
  }
  function renderRootSync(root2, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes)
      workInProgressTransitions = null, prepareFreshStack(root2, lanes);
    lanes = false;
    var exitStatus = workInProgressRootExitStatus;
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
          switch (workInProgressSuspendedReason) {
            case 8:
              resetWorkInProgressStack();
              exitStatus = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              null === suspenseHandlerStackCursor.current && (lanes = true);
              var reason = workInProgressSuspendedReason;
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
              if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                exitStatus = 0;
                break a;
              }
              break;
            default:
              reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
          }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
      } catch (thrownValue$167) {
        handleThrow(root2, thrownValue$167);
      }
    while (1);
    lanes && root2.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
  }
  function workLoopSync() {
    for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
  }
  function renderRootConcurrent(root2, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root2, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
      root2,
      lanes
    );
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          lanes = workInProgress;
          var thrownValue = workInProgressThrownValue;
          b: switch (workInProgressSuspendedReason) {
            case 1:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 1);
              break;
            case 2:
            case 9:
              if (isThenableResolved(thrownValue)) {
                workInProgressSuspendedReason = 0;
                workInProgressThrownValue = null;
                replaySuspendedUnitOfWork(lanes);
                break;
              }
              lanes = function() {
                2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root2 || (workInProgressSuspendedReason = 7);
                ensureRootIsScheduled(root2);
              };
              thrownValue.then(lanes, lanes);
              break a;
            case 3:
              workInProgressSuspendedReason = 7;
              break a;
            case 4:
              workInProgressSuspendedReason = 5;
              break a;
            case 7:
              isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root2, lanes, thrownValue, 7));
              break;
            case 5:
              var resource = null;
              switch (workInProgress.tag) {
                case 26:
                  resource = workInProgress.memoizedState;
                case 5:
                case 27:
                  var hostFiber = workInProgress;
                  if (resource ? preloadResource(resource) : 1) {
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    var sibling = hostFiber.sibling;
                    if (null !== sibling) workInProgress = sibling;
                    else {
                      var returnFiber = hostFiber.return;
                      null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                    }
                    break b;
                  }
              }
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 5);
              break;
            case 6:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 6);
              break;
            case 8:
              resetWorkInProgressStack();
              workInProgressRootExitStatus = 6;
              break a;
            default:
              throw Error(formatProdErrorMessage(462));
          }
        }
        workLoopConcurrentByScheduler();
        break;
      } catch (thrownValue$169) {
        handleThrow(root2, thrownValue$169);
      }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
  }
  function workLoopConcurrentByScheduler() {
    for (; null !== workInProgress && !shouldYield(); )
      performUnitOfWork(workInProgress);
  }
  function performUnitOfWork(unitOfWork) {
    var next4 = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next4 ? completeUnitOfWork(unitOfWork) : workInProgress = next4;
  }
  function replaySuspendedUnitOfWork(unitOfWork) {
    var next4 = unitOfWork;
    var current = next4.alternate;
    switch (next4.tag) {
      case 15:
      case 0:
        next4 = replayFunctionComponent(
          current,
          next4,
          next4.pendingProps,
          next4.type,
          void 0,
          workInProgressRootRenderLanes
        );
        break;
      case 11:
        next4 = replayFunctionComponent(
          current,
          next4,
          next4.pendingProps,
          next4.type.render,
          next4.ref,
          workInProgressRootRenderLanes
        );
        break;
      case 5:
        resetHooksOnUnwind(next4);
      default:
        unwindInterruptedWork(current, next4), next4 = workInProgress = resetWorkInProgress(next4, entangledRenderLanes), next4 = beginWork(current, next4, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next4 ? completeUnitOfWork(unitOfWork) : workInProgress = next4;
  }
  function throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
      if (throwException(
        root2,
        returnFiber,
        unitOfWork,
        thrownValue,
        workInProgressRootRenderLanes
      )) {
        workInProgressRootExitStatus = 1;
        logUncaughtError(
          root2,
          createCapturedValueAtFiber(thrownValue, root2.current)
        );
        workInProgress = null;
        return;
      }
    } catch (error2) {
      if (null !== returnFiber) throw workInProgress = returnFiber, error2;
      workInProgressRootExitStatus = 1;
      logUncaughtError(
        root2,
        createCapturedValueAtFiber(thrownValue, root2.current)
      );
      workInProgress = null;
      return;
    }
    if (unitOfWork.flags & 32768) {
      if (isHydrating || 1 === suspendedReason) root2 = true;
      else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
        root2 = false;
      else if (workInProgressRootDidSkipSuspendedSiblings = root2 = true, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason)
        suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
      unwindUnitOfWork(unitOfWork, root2);
    } else completeUnitOfWork(unitOfWork);
  }
  function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
      if (0 !== (completedWork.flags & 32768)) {
        unwindUnitOfWork(
          completedWork,
          workInProgressRootDidSkipSuspendedSiblings
        );
        return;
      }
      unitOfWork = completedWork.return;
      var next4 = completeWork(
        completedWork.alternate,
        completedWork,
        entangledRenderLanes
      );
      if (null !== next4) {
        workInProgress = next4;
        return;
      }
      completedWork = completedWork.sibling;
      if (null !== completedWork) {
        workInProgress = completedWork;
        return;
      }
      workInProgress = completedWork = unitOfWork;
    } while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
  }
  function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
      var next4 = unwindWork(unitOfWork.alternate, unitOfWork);
      if (null !== next4) {
        next4.flags &= 32767;
        workInProgress = next4;
        return;
      }
      next4 = unitOfWork.return;
      null !== next4 && (next4.flags |= 32768, next4.subtreeFlags = 0, next4.deletions = null);
      if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
        workInProgress = unitOfWork;
        return;
      }
      workInProgress = unitOfWork = next4;
    } while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
  }
  function commitRoot(root2, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root2.cancelPendingCommit = null;
    do
      flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
      if (finishedWork === root2.current) throw Error(formatProdErrorMessage(177));
      didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
      didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
      markRootFinished(
        root2,
        lanes,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes
      );
      root2 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
      pendingFinishedWork = finishedWork;
      pendingEffectsRoot = root2;
      pendingEffectsLanes = lanes;
      pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
      pendingPassiveTransitions = transitions;
      pendingRecoverableErrors = recoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root2.callbackNode = null, root2.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects();
        return null;
      })) : (root2.callbackNode = null, root2.callbackPriority = 0);
      recoverableErrors = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
        recoverableErrors = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        transitions = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        spawnedLane = executionContext;
        executionContext |= 4;
        try {
          commitBeforeMutationEffects(root2, finishedWork, lanes);
        } finally {
          executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
        }
      }
      pendingEffectsStatus = 1;
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
    }
  }
  function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
        rootMutationHasEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitMutationEffectsOnFiber(finishedWork, root2);
          var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root2.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
            priorFocusedElem.ownerDocument.documentElement,
            priorFocusedElem
          )) {
            if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
              var start2 = priorSelectionRange.start, end = priorSelectionRange.end;
              void 0 === end && (end = start2);
              if ("selectionStart" in priorFocusedElem)
                priorFocusedElem.selectionStart = start2, priorFocusedElem.selectionEnd = Math.min(
                  end,
                  priorFocusedElem.value.length
                );
              else {
                var doc = priorFocusedElem.ownerDocument || document, win2 = doc && doc.defaultView || window;
                if (win2.getSelection) {
                  var selection = win2.getSelection(), length2 = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length2), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length2);
                  !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                  var startMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    start$jscomp$0
                  ), endMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    end$jscomp$0
                  );
                  if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                    var range3 = doc.createRange();
                    range3.setStart(startMarker.node, startMarker.offset);
                    selection.removeAllRanges();
                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range3), selection.extend(endMarker.node, endMarker.offset)) : (range3.setEnd(endMarker.node, endMarker.offset), selection.addRange(range3));
                  }
                }
              }
            }
            doc = [];
            for (selection = priorFocusedElem; selection = selection.parentNode; )
              1 === selection.nodeType && doc.push({
                element: selection,
                left: selection.scrollLeft,
                top: selection.scrollTop
              });
            "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
            for (priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++) {
              var info = doc[priorFocusedElem];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
          _enabled = !!eventsEnabled;
          selectionInformation = eventsEnabled = null;
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
        }
      }
      root2.current = finishedWork;
      pendingEffectsStatus = 2;
    }
  }
  function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
      if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
        rootHasLayoutEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitLayoutEffectOnFiber(root2, finishedWork.alternate, finishedWork);
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
        }
      }
      pendingEffectsStatus = 3;
    }
  }
  function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      requestPaint();
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root2, root2.pendingLanes));
      var remainingLanes = root2.pendingLanes;
      0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
      lanesToEventPriority(lanes);
      finishedWork = finishedWork.stateNode;
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
        try {
          injectedHook.onCommitFiberRoot(
            rendererID,
            finishedWork,
            void 0,
            128 === (finishedWork.current.flags & 128)
          );
        } catch (err) {
        }
      if (null !== recoverableErrors) {
        finishedWork = ReactSharedInternals.T;
        remainingLanes = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        ReactSharedInternals.T = null;
        try {
          for (var onRecoverableError = root2.onRecoverableError, i = 0; i < recoverableErrors.length; i++) {
            var recoverableError = recoverableErrors[i];
            onRecoverableError(recoverableError.value, {
              componentStack: recoverableError.stack
            });
          }
        } finally {
          ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
        }
      }
      0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
      ensureRootIsScheduled(root2);
      remainingLanes = root2.pendingLanes;
      0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root2 === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root2) : nestedUpdateCount = 0;
      flushSyncWorkAcrossRoots_impl(0);
    }
  }
  function releaseRootPooledCache(root2, remainingLanes) {
    0 === (root2.pooledCacheLanes &= remainingLanes) && (remainingLanes = root2.pooledCache, null != remainingLanes && (root2.pooledCache = null, releaseCache(remainingLanes)));
  }
  function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
  }
  function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return false;
    var root2 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
      ReactSharedInternals.T = null;
      renderPriority = pendingPassiveTransitions;
      pendingPassiveTransitions = null;
      var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
      pendingEffectsStatus = 0;
      pendingFinishedWork = pendingEffectsRoot = null;
      pendingEffectsLanes = 0;
      if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      commitPassiveUnmountOnFiber(root$jscomp$0.current);
      commitPassiveMountOnFiber(
        root$jscomp$0,
        root$jscomp$0.current,
        lanes,
        renderPriority
      );
      executionContext = prevExecutionContext;
      flushSyncWorkAcrossRoots_impl(0, false);
      if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
        try {
          injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {
        }
      return true;
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root2, remainingLanes);
    }
  }
  function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error2) {
    sourceFiber = createCapturedValueAtFiber(error2, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
  }
  function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error2) {
    if (3 === sourceFiber.tag)
      captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error2);
    else
      for (; null !== nearestMountedAncestor; ) {
        if (3 === nearestMountedAncestor.tag) {
          captureCommitPhaseErrorOnRoot(
            nearestMountedAncestor,
            sourceFiber,
            error2
          );
          break;
        } else if (1 === nearestMountedAncestor.tag) {
          var instance = nearestMountedAncestor.stateNode;
          if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
            sourceFiber = createCapturedValueAtFiber(error2, sourceFiber);
            error2 = createClassErrorUpdate(2);
            instance = enqueueUpdate(nearestMountedAncestor, error2, 2);
            null !== instance && (initializeClassErrorUpdate(
              error2,
              instance,
              nearestMountedAncestor,
              sourceFiber
            ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
            break;
          }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
      }
  }
  function attachPingListener(root2, wakeable, lanes) {
    var pingCache = root2.pingCache;
    if (null === pingCache) {
      pingCache = root2.pingCache = new PossiblyWeakMap();
      var threadIDs = /* @__PURE__ */ new Set();
      pingCache.set(wakeable, threadIDs);
    } else
      threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), root2 = pingSuspendedRoot.bind(null, root2, wakeable, lanes), wakeable.then(root2, root2));
  }
  function pingSuspendedRoot(root2, wakeable, pingedLanes) {
    var pingCache = root2.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root2.pingedLanes |= root2.suspendedLanes & pingedLanes;
    root2.warmLanes &= ~pingedLanes;
    workInProgressRoot === root2 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root2, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root2);
  }
  function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
  }
  function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch (boundaryFiber.tag) {
      case 13:
        var retryCache = boundaryFiber.stateNode;
        var suspenseState = boundaryFiber.memoizedState;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        break;
      case 19:
        retryCache = boundaryFiber.stateNode;
        break;
      case 22:
        retryCache = boundaryFiber.stateNode._retryCache;
        break;
      default:
        throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
  }
  var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0;
  function ensureRootIsScheduled(root2) {
    root2 !== lastScheduledRoot && null === root2.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root2 : lastScheduledRoot = lastScheduledRoot.next = root2);
    mightHavePendingSyncWork = true;
    didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
  }
  function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
      isFlushingWork = true;
      do {
        var didPerformSomeWork = false;
        for (var root$174 = firstScheduledRoot; null !== root$174; ) {
          if (0 !== syncTransitionLanes) {
            var pendingLanes = root$174.pendingLanes;
            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
            else {
              var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
              JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
              JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
              JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
            }
            0 !== JSCompiler_inline_result && (didPerformSomeWork = true, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
          } else
            JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(
              root$174,
              root$174 === workInProgressRoot ? JSCompiler_inline_result : 0,
              null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle
            ), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = true, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
          root$174 = root$174.next;
        }
      } while (didPerformSomeWork);
      isFlushingWork = false;
    }
  }
  function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
  }
  function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = false;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for (var currentTime = now(), prev4 = null, root2 = firstScheduledRoot; null !== root2; ) {
      var next4 = root2.next, nextLanes = scheduleTaskForRootDuringMicrotask(root2, currentTime);
      if (0 === nextLanes)
        root2.next = null, null === prev4 ? firstScheduledRoot = next4 : prev4.next = next4, null === next4 && (lastScheduledRoot = prev4);
      else if (prev4 = root2, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
        mightHavePendingSyncWork = true;
      root2 = next4;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
  }
  function scheduleTaskForRootDuringMicrotask(root2, currentTime) {
    for (var suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes, expirationTimes = root2.expirationTimes, lanes = root2.pendingLanes & -62914561; 0 < lanes; ) {
      var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
      if (-1 === expirationTime) {
        if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
          expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
      } else expirationTime <= currentTime && (root2.expiredLanes |= lane);
      lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(
      root2,
      root2 === currentTime ? suspendedLanes : 0,
      null !== root2.cancelPendingCommit || -1 !== root2.timeoutHandle
    );
    pingedLanes = root2.callbackNode;
    if (0 === suspendedLanes || root2 === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root2.cancelPendingCommit)
      return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root2.callbackNode = null, root2.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root2, suspendedLanes)) {
      currentTime = suspendedLanes & -suspendedLanes;
      if (currentTime === root2.callbackPriority) return currentTime;
      null !== pingedLanes && cancelCallback$1(pingedLanes);
      switch (lanesToEventPriority(suspendedLanes)) {
        case 2:
        case 8:
          suspendedLanes = UserBlockingPriority;
          break;
        case 32:
          suspendedLanes = NormalPriority$1;
          break;
        case 268435456:
          suspendedLanes = IdlePriority;
          break;
        default:
          suspendedLanes = NormalPriority$1;
      }
      pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root2);
      suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
      root2.callbackPriority = currentTime;
      root2.callbackNode = suspendedLanes;
      return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root2.callbackPriority = 2;
    root2.callbackNode = null;
    return 2;
  }
  function performWorkOnRootViaSchedulerTask(root2, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
      return root2.callbackNode = null, root2.callbackPriority = 0, null;
    var originalCallbackNode = root2.callbackNode;
    if (flushPendingEffects() && root2.callbackNode !== originalCallbackNode)
      return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
      root2,
      root2 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
      null !== root2.cancelPendingCommit || -1 !== root2.timeoutHandle
    );
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root2, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root2, now());
    return null != root2.callbackNode && root2.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root2) : null;
  }
  function performSyncWorkOnRoot(root2, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root2, lanes, true);
  }
  function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
      0 !== (executionContext & 6) ? scheduleCallback$3(
        ImmediatePriority,
        processRootScheduleInImmediateTask
      ) : processRootScheduleInMicrotask();
    });
  }
  function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
  }
  function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
  }
  function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
  }
  function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
      var action3 = coerceFormActionProp(
        (nativeEventTarget[internalPropsKey] || null).action
      ), submitter = nativeEvent.submitter;
      submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action3 = domEventName, submitter = null));
      var event = new SyntheticEvent(
        "action",
        "action",
        null,
        nativeEvent,
        nativeEventTarget
      );
      dispatchQueue.push({
        event,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (nativeEvent.defaultPrevented) {
                if (0 !== currentEventTransitionLane) {
                  var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                  startHostTransition(
                    maybeTargetInst,
                    {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action: action3
                    },
                    null,
                    formData
                  );
                }
              } else
                "function" === typeof action3 && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action: action3
                  },
                  action3,
                  formData
                ));
            },
            currentTarget: nativeEventTarget
          }
        ]
      });
    }
  }
  for (var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++) {
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(
      domEventName$jscomp$inline_1530,
      "on" + capitalizedEvent$jscomp$inline_1531
    );
  }
  registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
  registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
  registerSimpleEvent(ANIMATION_START, "onAnimationStart");
  registerSimpleEvent("dblclick", "onDoubleClick");
  registerSimpleEvent("focusin", "onFocus");
  registerSimpleEvent("focusout", "onBlur");
  registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
  registerSimpleEvent(TRANSITION_START, "onTransitionStart");
  registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
  registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
  registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
  registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
  registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
  registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
  registerTwoPhaseEvent(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  );
  registerTwoPhaseEvent(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  );
  registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]);
  registerTwoPhaseEvent(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), nonDelegatedEvents = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
  );
  function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for (var i = 0; i < dispatchQueue.length; i++) {
      var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
      _dispatchQueue$i = _dispatchQueue$i.listeners;
      a: {
        var previousInstance = void 0;
        if (eventSystemFlags)
          for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
            var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error2) {
              reportGlobalError(error2);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
        else
          for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
            _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
            instance = _dispatchListeners$i.instance;
            currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error2) {
              reportGlobalError(error2);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
      }
    }
  }
  function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), JSCompiler_inline_result.add(listenerSetKey));
  }
  function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(
      target,
      domEventName,
      eventSystemFlags,
      isCapturePhaseListener
    );
  }
  var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
  function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
      rootContainerElement[listeningMarker] = true;
      allNativeEvents.forEach(function(domEventName) {
        "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
      });
      var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
      null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
    }
  }
  function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch (getEventPriority(domEventName)) {
      case 2:
        var listenerWrapper = dispatchDiscreteEvent;
        break;
      case 8:
        listenerWrapper = dispatchContinuousEvent;
        break;
      default:
        listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(
      null,
      domEventName,
      eventSystemFlags,
      targetContainer
    );
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      capture: true,
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, false);
  }
  function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
      a: for (; ; ) {
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
          var container = targetInst$jscomp$0.stateNode.containerInfo;
          if (container === targetContainer) break;
          if (4 === nodeTag)
            for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
              var grandTag = nodeTag.tag;
              if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                return;
              nodeTag = nodeTag.return;
            }
          for (; null !== container; ) {
            nodeTag = getClosestInstanceFromNode(container);
            if (null === nodeTag) return;
            grandTag = nodeTag.tag;
            if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
              targetInst$jscomp$0 = ancestorInst = nodeTag;
              continue a;
            }
            container = container.parentNode;
          }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
      }
    batchedUpdates$1(function() {
      var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
      a: {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (void 0 !== reactName) {
          var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
          switch (domEventName) {
            case "keypress":
              if (0 === getEventCharCode(nativeEvent)) break a;
            case "keydown":
            case "keyup":
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;
            case "focusin":
              reactEventType = "focus";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "focusout":
              reactEventType = "blur";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "beforeblur":
            case "afterblur":
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "click":
              if (2 === nativeEvent.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              SyntheticEventCtor = SyntheticMouseEvent;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              SyntheticEventCtor = SyntheticDragEvent;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              SyntheticEventCtor = SyntheticTouchEvent;
              break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;
            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;
            case "scroll":
            case "scrollend":
              SyntheticEventCtor = SyntheticUIEvent;
              break;
            case "wheel":
              SyntheticEventCtor = SyntheticWheelEvent;
              break;
            case "copy":
            case "cut":
            case "paste":
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
            case "toggle":
            case "beforetoggle":
              SyntheticEventCtor = SyntheticToggleEvent;
          }
          var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
          inCapturePhase = [];
          for (var instance = targetInst, lastHostComponent; null !== instance; ) {
            var _instance = instance;
            lastHostComponent = _instance.stateNode;
            _instance = _instance.tag;
            5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(
              createDispatchListener(instance, _instance, lastHostComponent)
            ));
            if (accumulateTargetOnly) break;
            instance = instance.return;
          }
          0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
            reactName,
            reactEventType,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({ event: reactName, listeners: inCapturePhase }));
        }
      }
      if (0 === (eventSystemFlags & 7)) {
        a: {
          reactName = "mouseover" === domEventName || "pointerover" === domEventName;
          SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
          if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
            break a;
          if (SyntheticEventCtor || reactName) {
            reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
            if (SyntheticEventCtor) {
              if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                reactEventType = null;
            } else SyntheticEventCtor = null, reactEventType = targetInst;
            if (SyntheticEventCtor !== reactEventType) {
              inCapturePhase = SyntheticMouseEvent;
              _instance = "onMouseLeave";
              reactEventName = "onMouseEnter";
              instance = "mouse";
              if ("pointerout" === domEventName || "pointerover" === domEventName)
                inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
              accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
              lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
              reactName = new inCapturePhase(
                _instance,
                instance + "leave",
                SyntheticEventCtor,
                nativeEvent,
                nativeEventTarget
              );
              reactName.target = accumulateTargetOnly;
              reactName.relatedTarget = lastHostComponent;
              _instance = null;
              getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                reactEventName,
                instance + "enter",
                reactEventType,
                nativeEvent,
                nativeEventTarget
              ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
              accumulateTargetOnly = _instance;
              if (SyntheticEventCtor && reactEventType)
                b: {
                  inCapturePhase = SyntheticEventCtor;
                  reactEventName = reactEventType;
                  instance = 0;
                  for (lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))
                    instance++;
                  lastHostComponent = 0;
                  for (_instance = reactEventName; _instance; _instance = getParent(_instance))
                    lastHostComponent++;
                  for (; 0 < instance - lastHostComponent; )
                    inCapturePhase = getParent(inCapturePhase), instance--;
                  for (; 0 < lastHostComponent - instance; )
                    reactEventName = getParent(reactEventName), lastHostComponent--;
                  for (; instance--; ) {
                    if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate)
                      break b;
                    inCapturePhase = getParent(inCapturePhase);
                    reactEventName = getParent(reactEventName);
                  }
                  inCapturePhase = null;
                }
              else inCapturePhase = null;
              null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                reactName,
                SyntheticEventCtor,
                inCapturePhase,
                false
              );
              null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                accumulateTargetOnly,
                reactEventType,
                inCapturePhase,
                true
              );
            }
          }
        }
        a: {
          reactName = targetInst ? getNodeFromInstance(targetInst) : window;
          SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
          if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
            var getTargetInstFunc = getTargetInstForChangeEvent;
          else if (isTextInputElement(reactName))
            if (isInputEventSupported)
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              var handleEventFunc = handleEventsForInputEventPolyfill;
            }
          else
            SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
          if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
            createAndAccumulateChangeEvent(
              dispatchQueue,
              getTargetInstFunc,
              nativeEvent,
              nativeEventTarget
            );
            break a;
          }
          handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
          "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
        }
        handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
        switch (domEventName) {
          case "focusin":
            if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
              activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
            break;
          case "focusout":
            lastSelection = activeElementInst = activeElement = null;
            break;
          case "mousedown":
            mouseDown = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;
          case "selectionchange":
            if (skipSelectionChangeEvent) break;
          case "keydown":
          case "keyup":
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
        var fallbackData;
        if (canUseCompositionEvent)
          b: {
            switch (domEventName) {
              case "compositionstart":
                var eventType = "onCompositionStart";
                break b;
              case "compositionend":
                eventType = "onCompositionEnd";
                break b;
              case "compositionupdate":
                eventType = "onCompositionUpdate";
                break b;
            }
            eventType = void 0;
          }
        else
          isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
        eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData2()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
          eventType,
          domEventName,
          null,
          nativeEvent,
          nativeEventTarget
        ), dispatchQueue.push({ event: eventType, listeners: handleEventFunc }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
        if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
          eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent(
            "onBeforeInput",
            "beforeinput",
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: handleEventFunc,
            listeners: eventType
          }), handleEventFunc.data = fallbackData);
        extractEvents$1(
          dispatchQueue,
          domEventName,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
  }
  function createDispatchListener(instance, listener, currentTarget) {
    return {
      instance,
      listener,
      currentTarget
    };
  }
  function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
      var _instance2 = targetFiber, stateNode = _instance2.stateNode;
      _instance2 = _instance2.tag;
      5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ));
      if (3 === targetFiber.tag) return listeners;
      targetFiber = targetFiber.return;
    }
    return [];
  }
  function getParent(inst) {
    if (null === inst) return null;
    do
      inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
  }
  function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common2, inCapturePhase) {
    for (var registrationName = event._reactName, listeners = []; null !== target && target !== common2; ) {
      var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
      _instance3 = _instance3.tag;
      if (null !== alternate && alternate === common2) break;
      5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
        createDispatchListener(target, stateNode, alternate)
      )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
        createDispatchListener(target, stateNode, alternate)
      )));
      target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({ event, listeners });
  }
  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
  function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
  }
  function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
  }
  function noop$12() {
  }
  function setProp(domElement, tag, key, value, props, prevValue) {
    switch (key) {
      case "children":
        "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
        break;
      case "className":
        setValueForKnownAttribute(domElement, "class", value);
        break;
      case "tabIndex":
        setValueForKnownAttribute(domElement, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        setValueForKnownAttribute(domElement, key, value);
        break;
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "data":
        if ("object" !== tag) {
          setValueForKnownAttribute(domElement, "data", value);
          break;
        }
      case "src":
      case "href":
        if ("" === value && ("a" !== tag || "href" !== key)) {
          domElement.removeAttribute(key);
          break;
        }
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "action":
      case "formAction":
        if ("function" === typeof value) {
          domElement.setAttribute(
            key,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(
            domElement,
            tag,
            "formEncType",
            props.formEncType,
            props,
            null
          ), setProp(
            domElement,
            tag,
            "formMethod",
            props.formMethod,
            props,
            null
          ), setProp(
            domElement,
            tag,
            "formTarget",
            props.formTarget,
            props,
            null
          )) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
        if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage(61));
          key = value.__html;
          if (null != key) {
            if (null != props.children) throw Error(formatProdErrorMessage(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "multiple":
        domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "muted":
        domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
          domElement.removeAttribute("xlink:href");
          break;
        }
        key = sanitizeURL("" + value);
        domElement.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          key
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
        break;
      case "capture":
      case "download":
        true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "rowSpan":
      case "start":
        null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
        break;
      case "popover":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        setValueForAttribute(domElement, "popover", value);
        break;
      case "xlinkActuate":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          value
        );
        break;
      case "xlinkArcrole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          value
        );
        break;
      case "xlinkRole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          value
        );
        break;
      case "xlinkShow":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          value
        );
        break;
      case "xlinkTitle":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          value
        );
        break;
      case "xlinkType":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          value
        );
        break;
      case "xmlBase":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          value
        );
        break;
      case "xmlLang":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          value
        );
        break;
      case "xmlSpace":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          value
        );
        break;
      case "is":
        setValueForAttribute(domElement, "is", value);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1])
          key = aliases2.get(key) || key, setValueForAttribute(domElement, key, value);
    }
  }
  function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch (key) {
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage(61));
          key = value.__html;
          if (null != key) {
            if (null != props.children) throw Error(formatProdErrorMessage(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "children":
        "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!registrationNameDependencies.hasOwnProperty(key))
          a: {
            if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
              "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
              domElement.addEventListener(tag, value, props);
              break a;
            }
            key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
          }
    }
  }
  function setInitialProperties(domElement, tag, props) {
    switch (tag) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        var hasSrc = false, hasSrcSet = false, propKey;
        for (propKey in props)
          if (props.hasOwnProperty(propKey)) {
            var propValue = props[propKey];
            if (null != propValue)
              switch (propKey) {
                case "src":
                  hasSrc = true;
                  break;
                case "srcSet":
                  hasSrcSet = true;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(137, tag));
                default:
                  setProp(domElement, tag, propKey, propValue, props, null);
              }
          }
        hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
        hasSrc && setProp(domElement, tag, "src", props.src, props, null);
        return;
      case "input":
        listenToNonDelegatedEvent("invalid", domElement);
        var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
        for (hasSrc in props)
          if (props.hasOwnProperty(hasSrc)) {
            var propValue$188 = props[hasSrc];
            if (null != propValue$188)
              switch (hasSrc) {
                case "name":
                  hasSrcSet = propValue$188;
                  break;
                case "type":
                  propValue = propValue$188;
                  break;
                case "checked":
                  checked = propValue$188;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$188;
                  break;
                case "value":
                  propKey = propValue$188;
                  break;
                case "defaultValue":
                  defaultValue = propValue$188;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propValue$188)
                    throw Error(formatProdErrorMessage(137, tag));
                  break;
                default:
                  setProp(domElement, tag, hasSrc, propValue$188, props, null);
              }
          }
        initInput(
          domElement,
          propKey,
          defaultValue,
          checked,
          defaultChecked,
          propValue,
          hasSrcSet,
          false
        );
        track(domElement);
        return;
      case "select":
        listenToNonDelegatedEvent("invalid", domElement);
        hasSrc = propValue = propKey = null;
        for (hasSrcSet in props)
          if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue))
            switch (hasSrcSet) {
              case "value":
                propKey = defaultValue;
                break;
              case "defaultValue":
                propValue = defaultValue;
                break;
              case "multiple":
                hasSrc = defaultValue;
              default:
                setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
        tag = propKey;
        props = propValue;
        domElement.multiple = !!hasSrc;
        null != tag ? updateOptions(domElement, !!hasSrc, tag, false) : null != props && updateOptions(domElement, !!hasSrc, props, true);
        return;
      case "textarea":
        listenToNonDelegatedEvent("invalid", domElement);
        propKey = hasSrcSet = hasSrc = null;
        for (propValue in props)
          if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue))
            switch (propValue) {
              case "value":
                hasSrc = defaultValue;
                break;
              case "defaultValue":
                hasSrcSet = defaultValue;
                break;
              case "children":
                propKey = defaultValue;
                break;
              case "dangerouslySetInnerHTML":
                if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                break;
              default:
                setProp(domElement, tag, propValue, defaultValue, props, null);
            }
        initTextarea(domElement, hasSrc, hasSrcSet, propKey);
        track(domElement);
        return;
      case "option":
        for (checked in props)
          if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc))
            switch (checked) {
              case "selected":
                domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                break;
              default:
                setProp(domElement, tag, checked, hasSrc, props, null);
            }
        return;
      case "dialog":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        listenToNonDelegatedEvent("cancel", domElement);
        listenToNonDelegatedEvent("close", domElement);
        break;
      case "iframe":
      case "object":
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "video":
      case "audio":
        for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
          listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
        break;
      case "image":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", domElement);
        break;
      case "embed":
      case "source":
      case "link":
        listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (defaultChecked in props)
          if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc))
            switch (defaultChecked) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(formatProdErrorMessage(137, tag));
              default:
                setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
        return;
      default:
        if (isCustomElement(tag)) {
          for (propValue$188 in props)
            props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(
              domElement,
              tag,
              propValue$188,
              hasSrc,
              props,
              void 0
            ));
          return;
        }
    }
    for (defaultValue in props)
      props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
  }
  function updateProperties(domElement, tag, lastProps, nextProps) {
    switch (tag) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var name = null, type4 = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
        for (propKey in lastProps) {
          var lastProp = lastProps[propKey];
          if (lastProps.hasOwnProperty(propKey) && null != lastProp)
            switch (propKey) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                lastDefaultValue = lastProp;
              default:
                nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
            }
        }
        for (var propKey$205 in nextProps) {
          var propKey = nextProps[propKey$205];
          lastProp = lastProps[propKey$205];
          if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp))
            switch (propKey$205) {
              case "type":
                type4 = propKey;
                break;
              case "name":
                name = propKey;
                break;
              case "checked":
                checked = propKey;
                break;
              case "defaultChecked":
                defaultChecked = propKey;
                break;
              case "value":
                value = propKey;
                break;
              case "defaultValue":
                defaultValue = propKey;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey)
                  throw Error(formatProdErrorMessage(137, tag));
                break;
              default:
                propKey !== lastProp && setProp(
                  domElement,
                  tag,
                  propKey$205,
                  propKey,
                  nextProps,
                  lastProp
                );
            }
        }
        updateInput(
          domElement,
          value,
          defaultValue,
          lastDefaultValue,
          checked,
          defaultChecked,
          type4,
          name
        );
        return;
      case "select":
        propKey = value = defaultValue = propKey$205 = null;
        for (type4 in lastProps)
          if (lastDefaultValue = lastProps[type4], lastProps.hasOwnProperty(type4) && null != lastDefaultValue)
            switch (type4) {
              case "value":
                break;
              case "multiple":
                propKey = lastDefaultValue;
              default:
                nextProps.hasOwnProperty(type4) || setProp(
                  domElement,
                  tag,
                  type4,
                  null,
                  nextProps,
                  lastDefaultValue
                );
            }
        for (name in nextProps)
          if (type4 = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type4 || null != lastDefaultValue))
            switch (name) {
              case "value":
                propKey$205 = type4;
                break;
              case "defaultValue":
                defaultValue = type4;
                break;
              case "multiple":
                value = type4;
              default:
                type4 !== lastDefaultValue && setProp(
                  domElement,
                  tag,
                  name,
                  type4,
                  nextProps,
                  lastDefaultValue
                );
            }
        tag = defaultValue;
        lastProps = value;
        nextProps = propKey;
        null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, false) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, true) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", false));
        return;
      case "textarea":
        propKey = propKey$205 = null;
        for (defaultValue in lastProps)
          if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue))
            switch (defaultValue) {
              case "value":
                break;
              case "children":
                break;
              default:
                setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
        for (value in nextProps)
          if (name = nextProps[value], type4 = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type4))
            switch (value) {
              case "value":
                propKey$205 = name;
                break;
              case "defaultValue":
                propKey = name;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (null != name) throw Error(formatProdErrorMessage(91));
                break;
              default:
                name !== type4 && setProp(domElement, tag, value, name, nextProps, type4);
            }
        updateTextarea(domElement, propKey$205, propKey);
        return;
      case "option":
        for (var propKey$221 in lastProps)
          if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221))
            switch (propKey$221) {
              case "selected":
                domElement.selected = false;
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  propKey$221,
                  null,
                  nextProps,
                  propKey$205
                );
            }
        for (lastDefaultValue in nextProps)
          if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey))
            switch (lastDefaultValue) {
              case "selected":
                domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  lastDefaultValue,
                  propKey$205,
                  nextProps,
                  propKey
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var propKey$226 in lastProps)
          propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
        for (checked in nextProps)
          if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey))
            switch (checked) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey$205)
                  throw Error(formatProdErrorMessage(137, tag));
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  checked,
                  propKey$205,
                  nextProps,
                  propKey
                );
            }
        return;
      default:
        if (isCustomElement(tag)) {
          for (var propKey$231 in lastProps)
            propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(
              domElement,
              tag,
              propKey$231,
              void 0,
              nextProps,
              propKey$205
            );
          for (defaultChecked in nextProps)
            propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(
              domElement,
              tag,
              defaultChecked,
              propKey$205,
              nextProps,
              propKey
            );
          return;
        }
    }
    for (var propKey$236 in lastProps)
      propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for (lastProp in nextProps)
      propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
  }
  var eventsEnabled = null, selectionInformation = null;
  function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
  }
  function getOwnHostContext(namespaceURI) {
    switch (namespaceURI) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function getChildHostContextProd(parentNamespace, type4) {
    if (0 === parentNamespace)
      switch (type4) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return 1 === parentNamespace && "foreignObject" === type4 ? 0 : parentNamespace;
  }
  function shouldSetTextContent(type4, props) {
    return "textarea" === type4 || "noscript" === type4 || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
  }
  var currentPopstateTransitionEvent = null;
  function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
      if (event === currentPopstateTransitionEvent) return false;
      currentPopstateTransitionEvent = event;
      return true;
    }
    currentPopstateTransitionEvent = null;
    return false;
  }
  var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
  } : scheduleTimeout;
  function handleErrorInNextTick(error2) {
    setTimeout(function() {
      throw error2;
    });
  }
  function isSingletonScope(type4) {
    return "head" === type4;
  }
  function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node2 = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
      var nextNode = node2.nextSibling;
      parentInstance.removeChild(node2);
      if (nextNode && 8 === nextNode.nodeType)
        if (node2 = nextNode.data, "/$" === node2) {
          if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
            node2 = possiblePreambleContribution;
            var ownerDocument = parentInstance.ownerDocument;
            node2 & 1 && releaseSingletonInstance(ownerDocument.documentElement);
            node2 & 2 && releaseSingletonInstance(ownerDocument.body);
            if (node2 & 4)
              for (node2 = ownerDocument.head, releaseSingletonInstance(node2), ownerDocument = node2.firstChild; ownerDocument; ) {
                var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node2.removeChild(ownerDocument);
                ownerDocument = nextNode$jscomp$0;
              }
          }
          if (0 === depth) {
            parentInstance.removeChild(nextNode);
            retryIfBlockedOn(suspenseInstance);
            return;
          }
          depth--;
        } else
          "$" === node2 || "$?" === node2 || "$!" === node2 ? depth++ : possiblePreambleContribution = node2.charCodeAt(0) - 48;
      else possiblePreambleContribution = 0;
      node2 = nextNode;
    } while (node2);
    retryIfBlockedOn(suspenseInstance);
  }
  function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for (; nextNode; ) {
      var node2 = nextNode;
      nextNode = nextNode.nextSibling;
      switch (node2.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          clearContainerSparingly(node2);
          detachDeletedInstance(node2);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if ("stylesheet" === node2.rel.toLowerCase()) continue;
      }
      container.removeChild(node2);
    }
  }
  function canHydrateInstance(instance, type4, props, inRootOrSingleton) {
    for (; 1 === instance.nodeType; ) {
      var anyProps = props;
      if (instance.nodeName.toLowerCase() !== type4.toLowerCase()) {
        if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
          break;
      } else if (!inRootOrSingleton)
        if ("input" === type4 && "hidden" === instance.type) {
          var name = null == anyProps.name ? null : "" + anyProps.name;
          if ("hidden" === anyProps.type && instance.getAttribute("name") === name)
            return instance;
        } else return instance;
      else if (!instance[internalHoistableMarker])
        switch (type4) {
          case "meta":
            if (!instance.hasAttribute("itemprop")) break;
            return instance;
          case "link":
            name = instance.getAttribute("rel");
            if ("stylesheet" === name && instance.hasAttribute("data-precedence"))
              break;
            else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
              break;
            return instance;
          case "style":
            if (instance.hasAttribute("data-precedence")) break;
            return instance;
          case "script":
            name = instance.getAttribute("src");
            if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
              break;
            return instance;
          default:
            return instance;
        }
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) break;
    }
    return null;
  }
  function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
    if ("" === text2) return null;
    for (; 3 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
  }
  function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState)
      callback();
    else {
      var listener = function() {
        callback();
        ownerDocument.removeEventListener("DOMContentLoaded", listener);
      };
      ownerDocument.addEventListener("DOMContentLoaded", listener);
      instance._reactRetry = listener;
    }
  }
  function getNextHydratable(node2) {
    for (; null != node2; node2 = node2.nextSibling) {
      var nodeType = node2.nodeType;
      if (1 === nodeType || 3 === nodeType) break;
      if (8 === nodeType) {
        nodeType = node2.data;
        if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType)
          break;
        if ("/$" === nodeType) return null;
      }
    }
    return node2;
  }
  var previousHydratableOnEnteringScopedSingleton = null;
  function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for (var depth = 0; targetInstance; ) {
      if (8 === targetInstance.nodeType) {
        var data2 = targetInstance.data;
        if ("$" === data2 || "$!" === data2 || "$?" === data2) {
          if (0 === depth) return targetInstance;
          depth--;
        } else "/$" === data2 && depth++;
      }
      targetInstance = targetInstance.previousSibling;
    }
    return null;
  }
  function resolveSingletonInstance(type4, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch (type4) {
      case "html":
        type4 = props.documentElement;
        if (!type4) throw Error(formatProdErrorMessage(452));
        return type4;
      case "head":
        type4 = props.head;
        if (!type4) throw Error(formatProdErrorMessage(453));
        return type4;
      case "body":
        type4 = props.body;
        if (!type4) throw Error(formatProdErrorMessage(454));
        return type4;
      default:
        throw Error(formatProdErrorMessage(451));
    }
  }
  function releaseSingletonInstance(instance) {
    for (var attributes2 = instance.attributes; attributes2.length; )
      instance.removeAttributeNode(attributes2[0]);
    detachDeletedInstance(instance);
  }
  var preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set();
  function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
  }
  var previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
  }
  function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
  }
  var globalDocument = "undefined" === typeof document ? null : document;
  function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
      var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
      limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
      "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
      preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
  }
  function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
  }
  function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
  }
  function preload(href, as, options2) {
    previousDispatcher.L(href, as, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
      var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
      "image" === as ? options2 && options2.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options2.imageSrcSet
      ) + '"]', "string" === typeof options2.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options2.imageSizes
      ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
      var key = preloadSelector;
      switch (as) {
        case "style":
          key = getStyleKey(href);
          break;
        case "script":
          key = getScriptKey(href);
      }
      preloadPropsMap.has(key) || (href = assign2(
        {
          rel: "preload",
          href: "image" === as && options2 && options2.imageSrcSet ? void 0 : href,
          as
        },
        options2
      ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
  }
  function preloadModule(href, options2) {
    previousDispatcher.m(href, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var as = options2 && "string" === typeof options2.as ? options2.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
      switch (as) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          key = getScriptKey(href);
      }
      if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options2), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
        switch (as) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
              return;
        }
        as = ownerDocument.createElement("link");
        setInitialProperties(as, "link", href);
        markNodeAsHoistable(as);
        ownerDocument.head.appendChild(as);
      }
    }
  }
  function preinitStyle(href, precedence, options2) {
    previousDispatcher.S(href, precedence, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var styles2 = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
      precedence = precedence || "default";
      var resource = styles2.get(key);
      if (!resource) {
        var state = { loading: 0, preload: null };
        if (resource = ownerDocument.querySelector(
          getStylesheetSelectorFromKey(key)
        ))
          state.loading = 5;
        else {
          href = assign2(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options2
          );
          (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options2);
          var link = resource = ownerDocument.createElement("link");
          markNodeAsHoistable(link);
          setInitialProperties(link, "link", href);
          link._p = new Promise(function(resolve, reject) {
            link.onload = resolve;
            link.onerror = reject;
          });
          link.addEventListener("load", function() {
            state.loading |= 1;
          });
          link.addEventListener("error", function() {
            state.loading |= 2;
          });
          state.loading |= 4;
          insertStylesheet(resource, precedence, ownerDocument);
        }
        resource = {
          type: "stylesheet",
          instance: resource,
          count: 1,
          state
        };
        styles2.set(key, resource);
      }
    }
  }
  function preinitScript(src, options2) {
    previousDispatcher.X(src, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function preinitModuleScript(src, options2) {
    previousDispatcher.M(src, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true, type: "module" }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function getResource(type4, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch (type4) {
      case "meta":
      case "title":
        return null;
      case "style":
        return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
          type4 = getStyleKey(pendingProps.href);
          var styles$244 = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles, resource$245 = styles$244.get(type4);
          resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, styles$244.set(type4, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(
            getStylesheetSelectorFromKey(type4)
          )) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type4) || (pendingProps = {
            rel: "preload",
            as: "style",
            href: pendingProps.href,
            crossOrigin: pendingProps.crossOrigin,
            integrity: pendingProps.integrity,
            media: pendingProps.media,
            hrefLang: pendingProps.hrefLang,
            referrerPolicy: pendingProps.referrerPolicy
          }, preloadPropsMap.set(type4, pendingProps), styles$244 || preloadStylesheet(
            JSCompiler_inline_result,
            type4,
            pendingProps,
            resource$245.state
          )));
          if (currentProps && null === currentResource)
            throw Error(formatProdErrorMessage(528, ""));
          return resource$245;
        }
        if (currentProps && null !== currentResource)
          throw Error(formatProdErrorMessage(529, ""));
        return null;
      case "script":
        return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(formatProdErrorMessage(444, type4));
    }
  }
  function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
  }
  function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
  }
  function stylesheetPropsFromRawProps(rawProps) {
    return assign2({}, rawProps, {
      "data-precedence": rawProps.precedence,
      precedence: null
    });
  }
  function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
      return state.loading |= 1;
    }), key.addEventListener("error", function() {
      return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
  }
  function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
  }
  function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
  }
  function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance)
      switch (resource.type) {
        case "style":
          var instance = hoistableRoot.querySelector(
            'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]'
          );
          if (instance)
            return resource.instance = instance, markNodeAsHoistable(instance), instance;
          var styleProps = assign2({}, props, {
            "data-href": props.href,
            "data-precedence": props.precedence,
            href: null,
            precedence: null
          });
          instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement(
            "style"
          );
          markNodeAsHoistable(instance);
          setInitialProperties(instance, "style", styleProps);
          insertStylesheet(instance, props.precedence, hoistableRoot);
          return resource.instance = instance;
        case "stylesheet":
          styleProps = getStyleKey(props.href);
          var instance$250 = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(styleProps)
          );
          if (instance$250)
            return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
          instance = stylesheetPropsFromRawProps(props);
          (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
          instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
          markNodeAsHoistable(instance$250);
          var linkInstance = instance$250;
          linkInstance._p = new Promise(function(resolve, reject) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject;
          });
          setInitialProperties(instance$250, "link", instance);
          resource.state.loading |= 4;
          insertStylesheet(instance$250, props.precedence, hoistableRoot);
          return resource.instance = instance$250;
        case "script":
          instance$250 = getScriptKey(props.src);
          if (styleProps = hoistableRoot.querySelector(
            getScriptSelectorFromKey(instance$250)
          ))
            return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
          instance = props;
          if (styleProps = preloadPropsMap.get(instance$250))
            instance = assign2({}, props), adoptPreloadPropsForScript(instance, styleProps);
          hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
          styleProps = hoistableRoot.createElement("script");
          markNodeAsHoistable(styleProps);
          setInitialProperties(styleProps, "link", instance);
          hoistableRoot.head.appendChild(styleProps);
          return resource.instance = styleProps;
        case "void":
          return null;
        default:
          throw Error(formatProdErrorMessage(443, resource.type));
      }
    else
      "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
  }
  function insertStylesheet(instance, precedence, root2) {
    for (var nodes = root2.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++) {
      var node2 = nodes[i];
      if (node2.dataset.precedence === precedence) prior = node2;
      else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root2.nodeType ? root2.head : root2, precedence.insertBefore(instance, precedence.firstChild));
  }
  function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
  }
  function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
  }
  var tagCaches = null;
  function getHydratableHoistableCache(type4, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
      var cache2 = /* @__PURE__ */ new Map();
      var caches = tagCaches = /* @__PURE__ */ new Map();
      caches.set(ownerDocument, cache2);
    } else
      caches = tagCaches, cache2 = caches.get(ownerDocument), cache2 || (cache2 = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache2));
    if (cache2.has(type4)) return cache2;
    cache2.set(type4, null);
    ownerDocument = ownerDocument.getElementsByTagName(type4);
    for (caches = 0; caches < ownerDocument.length; caches++) {
      var node2 = ownerDocument[caches];
      if (!(node2[internalHoistableMarker] || node2[internalInstanceKey] || "link" === type4 && "stylesheet" === node2.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node2.namespaceURI) {
        var nodeKey = node2.getAttribute(keyAttribute) || "";
        nodeKey = type4 + nodeKey;
        var existing = cache2.get(nodeKey);
        existing ? existing.push(node2) : cache2.set(nodeKey, [node2]);
      }
    }
    return cache2;
  }
  function mountHoistable(hoistableRoot, type4, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(
      instance,
      "title" === type4 ? hoistableRoot.querySelector("head > title") : null
    );
  }
  function isHostHoistableType(type4, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return false;
    switch (type4) {
      case "meta":
      case "title":
        return true;
      case "style":
        if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href)
          break;
        return true;
      case "link":
        if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError)
          break;
        switch (props.rel) {
          case "stylesheet":
            return type4 = props.disabled, "string" === typeof props.precedence && null == type4;
          default:
            return true;
        }
      case "script":
        if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src)
          return true;
    }
    return false;
  }
  function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? false : true;
  }
  var suspendedState = null;
  function noop4() {
  }
  function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || false !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
      if (null === resource.instance) {
        var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(key)
        );
        if (instance) {
          hoistableRoot = instance._p;
          null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
          resource.state.loading |= 4;
          resource.instance = instance;
          markNodeAsHoistable(instance);
          return;
        }
        instance = hoistableRoot.ownerDocument || hoistableRoot;
        props = stylesheetPropsFromRawProps(props);
        (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
        instance = instance.createElement("link");
        markNodeAsHoistable(instance);
        var linkInstance = instance;
        linkInstance._p = new Promise(function(resolve, reject) {
          linkInstance.onload = resolve;
          linkInstance.onerror = reject;
        });
        setInitialProperties(instance, "link", props);
        resource.instance = instance;
      }
      null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
      state.stylesheets.set(resource, hoistableRoot);
      (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
  }
  function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
      var stylesheetTimer = setTimeout(function() {
        state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
        if (state.unsuspend) {
          var unsuspend = state.unsuspend;
          state.unsuspend = null;
          unsuspend();
        }
      }, 6e4);
      state.unsuspend = commit;
      return function() {
        state.unsuspend = null;
        clearTimeout(stylesheetTimer);
      };
    } : null;
  }
  function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
      if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
      else if (this.unsuspend) {
        var unsuspend = this.unsuspend;
        this.unsuspend = null;
        unsuspend();
      }
    }
  }
  var precedencesByRoot = null;
  function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
  }
  function insertStylesheetIntoRoot(root2, resource) {
    if (!(resource.state.loading & 4)) {
      var precedences = precedencesByRoot.get(root2);
      if (precedences) var last = precedences.get(null);
      else {
        precedences = /* @__PURE__ */ new Map();
        precedencesByRoot.set(root2, precedences);
        for (var nodes = root2.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), i = 0; i < nodes.length; i++) {
          var node2 = nodes[i];
          if ("LINK" === node2.nodeName || "not all" !== node2.getAttribute("media"))
            precedences.set(node2.dataset.precedence, node2), last = node2;
        }
        last && precedences.set(null, last);
      }
      nodes = resource.instance;
      node2 = nodes.getAttribute("data-precedence");
      i = precedences.get(node2) || last;
      i === last && precedences.set(null, nodes);
      precedences.set(node2, nodes);
      this.count++;
      last = onUnsuspend.bind(this);
      nodes.addEventListener("load", last);
      nodes.addEventListener("error", last);
      i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root2 = 9 === root2.nodeType ? root2.head : root2, root2.insertBefore(nodes, root2.firstChild));
      resource.state.loading |= 4;
    }
  }
  var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
  };
  function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(
      containerInfo,
      tag,
      hydrate,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      formState
    );
    tag = 1;
    true === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache3();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
      element: initialChildren,
      isDehydrated: hydrate,
      cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
  }
  function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
  }
  function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = { element };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
  }
  function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
      var a = fiber.retryLane;
      fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
  }
  function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
  }
  function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
      var root2 = enqueueConcurrentRenderForLane(fiber, 67108864);
      null !== root2 && scheduleUpdateOnFiber(root2, fiber, 67108864);
      markRetryLaneIfNotHydrated(fiber, 67108864);
    }
  }
  var _enabled = true;
  function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
      var blockedOn = findInstanceBlockingEvent(nativeEvent);
      if (null === blockedOn)
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          return_targetInst,
          targetContainer
        ), clearIfContinuousEvent(domEventName, nativeEvent);
      else if (queueIfContinuousEvent(
        blockedOn,
        domEventName,
        eventSystemFlags,
        targetContainer,
        nativeEvent
      ))
        nativeEvent.stopPropagation();
      else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
        for (; null !== blockedOn; ) {
          var fiber = getInstanceFromNode(blockedOn);
          if (null !== fiber)
            switch (fiber.tag) {
              case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                  var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                  if (0 !== lanes) {
                    var root2 = fiber;
                    root2.pendingLanes |= 2;
                    for (root2.entangledLanes |= 2; lanes; ) {
                      var lane = 1 << 31 - clz32(lanes);
                      root2.entanglements[1] |= lane;
                      lanes &= ~lane;
                    }
                    ensureRootIsScheduled(fiber);
                    0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0));
                  }
                }
                break;
              case 13:
                root2 = enqueueConcurrentRenderForLane(fiber, 2), null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
            }
          fiber = findInstanceBlockingEvent(nativeEvent);
          null === fiber && dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          );
          if (fiber === blockedOn) break;
          blockedOn = fiber;
        }
        null !== blockedOn && nativeEvent.stopPropagation();
      } else
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          null,
          targetContainer
        );
    }
  }
  function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
  }
  var return_targetInst = null;
  function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
      var nearestMounted = getNearestMountedFiber(targetNode);
      if (null === nearestMounted) targetNode = null;
      else {
        var tag = nearestMounted.tag;
        if (13 === tag) {
          targetNode = getSuspenseInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (3 === tag) {
          if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
            return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          targetNode = null;
        } else nearestMounted !== targetNode && (targetNode = null);
      }
    }
    return_targetInst = targetNode;
    return null;
  }
  function getEventPriority(domEventName) {
    switch (domEventName) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (getCurrentPriorityLevel()) {
          case ImmediatePriority:
            return 2;
          case UserBlockingPriority:
            return 8;
          case NormalPriority$1:
          case LowPriority:
            return 32;
          case IdlePriority:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch (domEventName) {
      case "focusin":
      case "focusout":
        queuedFocus = null;
        break;
      case "dragenter":
      case "dragleave":
        queuedDrag = null;
        break;
      case "mouseover":
      case "mouseout":
        queuedMouse = null;
        break;
      case "pointerover":
      case "pointerout":
        queuedPointers.delete(nativeEvent.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
  }
  function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
      return existingQueuedEvent = {
        blockedOn,
        domEventName,
        eventSystemFlags,
        nativeEvent,
        targetContainers: [targetContainer]
      }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
  }
  function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch (domEventName) {
      case "focusin":
        return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedFocus,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "dragenter":
        return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedDrag,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "mouseover":
        return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedMouse,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "pointerover":
        var pointerId = nativeEvent.pointerId;
        queuedPointers.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointers.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        );
        return true;
      case "gotpointercapture":
        return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointerCaptures.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        ), true;
    }
    return false;
  }
  function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
      var nearestMounted = getNearestMountedFiber(targetInst);
      if (null !== nearestMounted) {
        if (targetInst = nearestMounted.tag, 13 === targetInst) {
          if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              if (13 === nearestMounted.tag) {
                var lane = requestUpdateLane();
                lane = getBumpedLaneForHydrationByLane(lane);
                var root2 = enqueueConcurrentRenderForLane(nearestMounted, lane);
                null !== root2 && scheduleUpdateOnFiber(root2, nearestMounted, lane);
                markRetryLaneIfNotHydrated(nearestMounted, lane);
              }
            });
            return;
          }
        } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
          queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          return;
        }
      }
    }
    queuedTarget.blockedOn = null;
  }
  function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return false;
    for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
      var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
      if (null === nextBlockedOn) {
        nextBlockedOn = queuedEvent.nativeEvent;
        var nativeEventClone = new nextBlockedOn.constructor(
          nextBlockedOn.type,
          nextBlockedOn
        );
        currentReplayingEvent = nativeEventClone;
        nextBlockedOn.target.dispatchEvent(nativeEventClone);
        currentReplayingEvent = null;
      } else
        return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
      targetContainers.shift();
    }
    return true;
  }
  function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
  }
  function replayUnblockedEvents() {
    hasScheduledReplayAttempt = false;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
  }
  function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler.unstable_scheduleCallback(
      Scheduler.unstable_NormalPriority,
      replayUnblockedEvents
    )));
  }
  var lastScheduledReplayQueue = null;
  function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(
      Scheduler.unstable_NormalPriority,
      function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for (var i = 0; i < formReplayingQueue.length; i += 3) {
          var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
          if ("function" !== typeof submitterOrAction)
            if (null === findInstanceBlockingTarget(submitterOrAction || form))
              continue;
            else break;
          var formInst = getInstanceFromNode(form);
          null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(
            formInst,
            {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            },
            submitterOrAction,
            formData
          ));
        }
      }
    ));
  }
  function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
      return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for (var i = 0; i < queuedExplicitHydrationTargets.length; i++) {
      var queuedTarget = queuedExplicitHydrationTargets[i];
      queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for (; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn); )
      attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i)
      for (queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3) {
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction)
          formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
          var action3 = null;
          if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
            if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
              action3 = formProps.formAction;
            else {
              if (null !== findInstanceBlockingTarget(form)) continue;
            }
          else action3 = formProps.action;
          "function" === typeof action3 ? i[queuedTarget + 1] = action3 : (i.splice(queuedTarget, 3), queuedTarget -= 3);
          scheduleReplayQueueIfNeeded(i);
        }
      }
  }
  function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children2) {
    var root2 = this._internalRoot;
    if (null === root2) throw Error(formatProdErrorMessage(409));
    var current = root2.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children2, root2, null, null);
  };
  ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root2 = this._internalRoot;
    if (null !== root2) {
      this._internalRoot = null;
      var container = root2.containerInfo;
      updateContainerImpl(root2.current, 2, null, root2, null, null);
      flushSyncWork$1();
      container[internalContainerInstanceKey] = null;
    }
  };
  function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
      var updatePriority = resolveUpdatePriority();
      target = { blockedOn: null, target, priority: updatePriority };
      for (var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++) ;
      queuedExplicitHydrationTargets.splice(i, 0, target);
      0 === i && attemptExplicitHydrationTarget(target);
    }
  };
  var isomorphicReactPackageVersion$jscomp$inline_1785 = React2.version;
  if ("19.1.0" !== isomorphicReactPackageVersion$jscomp$inline_1785)
    throw Error(
      formatProdErrorMessage(
        527,
        isomorphicReactPackageVersion$jscomp$inline_1785,
        "19.1.0"
      )
    );
  ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
      if ("function" === typeof componentOrElement.render)
        throw Error(formatProdErrorMessage(188));
      componentOrElement = Object.keys(componentOrElement).join(",");
      throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
  };
  var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.0"
  };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber)
      try {
        rendererID = hook$jscomp$inline_2257.inject(
          internals$jscomp$inline_2256
        ), injectedHook = hook$jscomp$inline_2257;
      } catch (err) {
      }
  }
  reactDomClient_production.createRoot = function(container, options2) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.unstable_transitionCallbacks && (transitionCallbacks = options2.unstable_transitionCallbacks));
    options2 = createFiberRoot(
      container,
      1,
      false,
      null,
      null,
      isStrictMode,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      transitionCallbacks,
      null
    );
    container[internalContainerInstanceKey] = options2.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options2);
  };
  reactDomClient_production.hydrateRoot = function(container, initialChildren, options2) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.unstable_transitionCallbacks && (transitionCallbacks = options2.unstable_transitionCallbacks), void 0 !== options2.formState && (formState = options2.formState));
    initialChildren = createFiberRoot(
      container,
      1,
      true,
      initialChildren,
      null != options2 ? options2 : null,
      isStrictMode,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      transitionCallbacks,
      formState
    );
    initialChildren.context = getContextForSubtree(null);
    options2 = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options2, identifierPrefix, isStrictMode);
    options2 = isStrictMode;
    initialChildren.current.lanes = options2;
    markRootUpdated$1(initialChildren, options2);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
  };
  reactDomClient_production.version = "19.1.0";
  return reactDomClient_production;
}
var reactDomClient_development = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomClient_development;
function requireReactDomClient_development() {
  if (hasRequiredReactDomClient_development) return reactDomClient_development;
  hasRequiredReactDomClient_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function findHook(fiber, id2) {
      for (fiber = fiber.memoizedState; null !== fiber && 0 < id2; )
        fiber = fiber.next, id2--;
      return fiber;
    }
    function copyWithSetImpl(obj, path2, index2, value) {
      if (index2 >= path2.length) return value;
      var key = path2[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      updated[key] = copyWithSetImpl(obj[key], path2, index2 + 1, value);
      return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
      if (oldPath.length !== newPath.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var i = 0; i < newPath.length - 1; i++)
          if (oldPath[i] !== newPath[i]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
      }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index2) {
      var oldKey = oldPath[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      index2 + 1 === oldPath.length ? (updated[newPath[index2]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(
        obj[oldKey],
        oldPath,
        newPath,
        index2 + 1
      );
      return updated;
    }
    function copyWithDeleteImpl(obj, path2, index2) {
      var key = path2[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      if (index2 + 1 === path2.length)
        return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
      updated[key] = copyWithDeleteImpl(obj[key], path2, index2 + 1);
      return updated;
    }
    function shouldSuspendImpl() {
      return false;
    }
    function shouldErrorImpl() {
      return null;
    }
    function warnForMissingKey() {
    }
    function warnInvalidHookAccess() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function warnInvalidContextAccess() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function noop$22() {
    }
    function setToSortedString(set2) {
      var array4 = [];
      set2.forEach(function(value) {
        array4.push(value);
      });
      return array4.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
      return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root2, element) {
      root2.context === emptyContextObject && (updateContainerImpl(root2.current, 2, element, root2, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root2, update2) {
      if (null !== resolveFamily) {
        var staleFamilies = update2.staleFamilies;
        update2 = update2.updatedFamilies;
        flushPendingEffects();
        scheduleFibersWithFamiliesRecursively(
          root2.current,
          update2,
          staleFamilies
        );
        flushSyncWork$1();
      }
    }
    function setRefreshHandler(handler) {
      resolveFamily = handler;
    }
    function isValidContainer(node2) {
      return !(!node2 || 1 !== node2.nodeType && 9 !== node2.nodeType && 11 !== node2.nodeType);
    }
    function getNearestMountedFiber(fiber) {
      var node2 = fiber, nearestMounted = fiber;
      if (fiber.alternate) for (; node2.return; ) node2 = node2.return;
      else {
        fiber = node2;
        do
          node2 = fiber, 0 !== (node2.flags & 4098) && (nearestMounted = node2.return), fiber = node2.return;
        while (fiber);
      }
      return 3 === node2.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
      if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
      }
      return null;
    }
    function assertIsMounted(fiber) {
      if (getNearestMountedFiber(fiber) !== fiber)
        throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
      var alternate = fiber.alternate;
      if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate)
          throw Error("Unable to find node on an unmounted component.");
        return alternate !== fiber ? null : fiber;
      }
      for (var a = fiber, b = alternate; ; ) {
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
          b = parentA.return;
          if (null !== b) {
            a = b;
            continue;
          }
          break;
        }
        if (parentA.child === parentB.child) {
          for (parentB = parentA.child; parentB; ) {
            if (parentB === a) return assertIsMounted(parentA), fiber;
            if (parentB === b) return assertIsMounted(parentA), alternate;
            parentB = parentB.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
          for (var didFindChild = false, _child = parentA.child; _child; ) {
            if (_child === a) {
              didFindChild = true;
              a = parentA;
              b = parentB;
              break;
            }
            if (_child === b) {
              didFindChild = true;
              b = parentA;
              a = parentB;
              break;
            }
            _child = _child.sibling;
          }
          if (!didFindChild) {
            for (_child = parentB.child; _child; ) {
              if (_child === a) {
                didFindChild = true;
                a = parentB;
                b = parentA;
                break;
              }
              if (_child === b) {
                didFindChild = true;
                b = parentB;
                a = parentA;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (a.alternate !== b)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (3 !== a.tag)
        throw Error("Unable to find node on an unmounted component.");
      return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node2) {
      var tag = node2.tag;
      if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node2;
      for (node2 = node2.child; null !== node2; ) {
        tag = findCurrentHostFiberImpl(node2);
        if (null !== tag) return tag;
        node2 = node2.sibling;
      }
      return null;
    }
    function getIteratorFn(maybeIterable) {
      if (null === maybeIterable || "object" !== typeof maybeIterable)
        return null;
      maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
      return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type4) {
      if (null == type4) return null;
      if ("function" === typeof type4)
        return type4.$$typeof === REACT_CLIENT_REFERENCE ? null : type4.displayName || type4.name || null;
      if ("string" === typeof type4) return type4;
      switch (type4) {
        case REACT_FRAGMENT_TYPE2:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type4)
        switch ("number" === typeof type4.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type4.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return (type4.displayName || "Context") + ".Provider";
          case REACT_CONSUMER_TYPE:
            return (type4._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type4.render;
            type4 = type4.displayName;
            type4 || (type4 = innerType.displayName || innerType.name || "", type4 = "" !== type4 ? "ForwardRef(" + type4 + ")" : "ForwardRef");
            return type4;
          case REACT_MEMO_TYPE:
            return innerType = type4.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type4.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type4._payload;
            type4 = type4._init;
            try {
              return getComponentNameFromType(type4(innerType));
            } catch (x) {
            }
        }
      return null;
    }
    function getComponentNameFromOwner(owner) {
      return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
      var type4 = fiber.type;
      switch (fiber.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (type4._context.displayName || "Context") + ".Consumer";
        case 10:
          return (type4.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return fiber = type4.render, fiber = fiber.displayName || fiber.name || "", type4.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return type4;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return getComponentNameFromType(type4);
        case 8:
          return type4 === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if ("function" === typeof type4)
            return type4.displayName || type4.name || null;
          if ("string" === typeof type4) return type4;
          break;
        case 29:
          type4 = fiber._debugInfo;
          if (null != type4) {
            for (var i = type4.length - 1; 0 <= i; i--)
              if ("string" === typeof type4[i].name) return type4[i].name;
          }
          if (null !== fiber.return)
            return getComponentNameFromFiber(fiber.return);
      }
      return null;
    }
    function createCursor(defaultValue) {
      return { current: defaultValue };
    }
    function pop(cursor2, fiber) {
      0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor2.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor2, value, fiber) {
      index$jscomp$0++;
      valueStack[index$jscomp$0] = cursor2.current;
      fiberStack[index$jscomp$0] = fiber;
      cursor2.current = value;
    }
    function requiredContext(c) {
      null === c && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      );
      return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
      push(rootInstanceStackCursor, nextRootInstance, fiber);
      push(contextFiberStackCursor, fiber, fiber);
      push(contextStackCursor, null, fiber);
      var nextRootContext = nextRootInstance.nodeType;
      switch (nextRootContext) {
        case 9:
        case 11:
          nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
          nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
          break;
        default:
          if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
            nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(
              nextRootInstance,
              nextRootContext
            );
          else
            switch (nextRootContext) {
              case "svg":
                nextRootInstance = HostContextNamespaceSvg;
                break;
              case "math":
                nextRootInstance = HostContextNamespaceMath;
                break;
              default:
                nextRootInstance = HostContextNamespaceNone;
            }
      }
      nextRootContext = nextRootContext.toLowerCase();
      nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
      nextRootContext = {
        context: nextRootInstance,
        ancestorInfo: nextRootContext
      };
      pop(contextStackCursor, fiber);
      push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
      pop(contextStackCursor, fiber);
      pop(contextFiberStackCursor, fiber);
      pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
      return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
      null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber, fiber);
      var context2 = requiredContext(contextStackCursor.current);
      var type4 = fiber.type;
      var nextContext = getChildHostContextProd(context2.context, type4);
      type4 = updatedAncestorInfoDev(context2.ancestorInfo, type4);
      nextContext = { context: nextContext, ancestorInfo: type4 };
      context2 !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
      contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
      hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function typeName(value) {
      return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
      try {
        return testStringCoercion(value), false;
      } catch (e) {
        return true;
      }
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          attributeName,
          typeName(value)
        ), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          propName,
          typeName(value)
        ), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
      if (willCoercionThrow(value))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          typeName(value)
        ), testStringCoercion(value);
    }
    function injectInternals(internals) {
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return false;
      var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (hook.isDisabled) return true;
      if (!hook.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), true;
      try {
        rendererID = hook.inject(internals), injectedHook = hook;
      } catch (err) {
        console.error("React instrumentation encountered an error: %s.", err);
      }
      return hook.checkDCE ? true : false;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
      "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
      if (injectedHook && "function" === typeof injectedHook.setStrictMode)
        try {
          injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %s",
            err
          ));
        }
    }
    function injectProfilingHooks(profilingHooks) {
      injectedProfilingHooks = profilingHooks;
    }
    function markCommitStopped() {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markCommitStopped && injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentRenderStarted && injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentRenderStopped && injectedProfilingHooks.markComponentRenderStopped();
    }
    function markRenderStarted(lanes) {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markRenderStarted && injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderStopped() {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markRenderStopped && injectedProfilingHooks.markRenderStopped();
    }
    function markStateUpdateScheduled(fiber, lane) {
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markStateUpdateScheduled && injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    function clz32Fallback(x) {
      x >>>= 0;
      return 0 === x ? 32 : 31 - (log2(x) / LN2 | 0) | 0;
    }
    function getLabelForLane(lane) {
      if (lane & 1) return "SyncHydrationLane";
      if (lane & 2) return "Sync";
      if (lane & 4) return "InputContinuousHydration";
      if (lane & 8) return "InputContinuous";
      if (lane & 16) return "DefaultHydration";
      if (lane & 32) return "Default";
      if (lane & 128) return "TransitionHydration";
      if (lane & 4194048) return "Transition";
      if (lane & 62914560) return "Retry";
      if (lane & 67108864) return "SelectiveHydration";
      if (lane & 134217728) return "IdleHydration";
      if (lane & 268435456) return "Idle";
      if (lane & 536870912) return "Offscreen";
      if (lane & 1073741824) return "Deferred";
    }
    function getHighestPriorityLanes(lanes) {
      var pendingSyncLanes = lanes & 42;
      if (0 !== pendingSyncLanes) return pendingSyncLanes;
      switch (lanes & -lanes) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return lanes & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), lanes;
      }
    }
    function getNextLanes(root2, wipLanes, rootHasPendingCommit) {
      var pendingLanes = root2.pendingLanes;
      if (0 === pendingLanes) return 0;
      var nextLanes = 0, suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes;
      root2 = root2.warmLanes;
      var nonIdlePendingLanes = pendingLanes & 134217727;
      0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
      return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root2, renderLanes2) {
      return 0 === (root2.pendingLanes & ~(root2.suspendedLanes & ~root2.pingedLanes) & renderLanes2);
    }
    function computeExpirationTime(lane, currentTime) {
      switch (lane) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function claimNextTransitionLane() {
      var lane = nextTransitionLane;
      nextTransitionLane <<= 1;
      0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
      return lane;
    }
    function claimNextRetryLane() {
      var lane = nextRetryLane;
      nextRetryLane <<= 1;
      0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
      return lane;
    }
    function createLaneMap(initial2) {
      for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial2);
      return laneMap;
    }
    function markRootUpdated$1(root2, updateLane) {
      root2.pendingLanes |= updateLane;
      268435456 !== updateLane && (root2.suspendedLanes = 0, root2.pingedLanes = 0, root2.warmLanes = 0);
    }
    function markRootFinished(root2, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
      var previouslyPendingLanes = root2.pendingLanes;
      root2.pendingLanes = remainingLanes;
      root2.suspendedLanes = 0;
      root2.pingedLanes = 0;
      root2.warmLanes = 0;
      root2.expiredLanes &= remainingLanes;
      root2.entangledLanes &= remainingLanes;
      root2.errorRecoveryDisabledLanes &= remainingLanes;
      root2.shellSuspendCounter = 0;
      var entanglements = root2.entanglements, expirationTimes = root2.expirationTimes, hiddenUpdates = root2.hiddenUpdates;
      for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
        var index2 = 31 - clz32(remainingLanes), lane = 1 << index2;
        entanglements[index2] = 0;
        expirationTimes[index2] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index2];
        if (null !== hiddenUpdatesForLane)
          for (hiddenUpdates[index2] = null, index2 = 0; index2 < hiddenUpdatesForLane.length; index2++) {
            var update2 = hiddenUpdatesForLane[index2];
            null !== update2 && (update2.lane &= -536870913);
          }
        remainingLanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, 0);
      0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root2.tag && (root2.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root2, spawnedLane, entangledLanes) {
      root2.pendingLanes |= spawnedLane;
      root2.suspendedLanes &= ~spawnedLane;
      var spawnedLaneIndex = 31 - clz32(spawnedLane);
      root2.entangledLanes |= spawnedLane;
      root2.entanglements[spawnedLaneIndex] = root2.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
    }
    function markRootEntangled(root2, entangledLanes) {
      var rootEntangledLanes = root2.entangledLanes |= entangledLanes;
      for (root2 = root2.entanglements; rootEntangledLanes; ) {
        var index2 = 31 - clz32(rootEntangledLanes), lane = 1 << index2;
        lane & entangledLanes | root2[index2] & entangledLanes && (root2[index2] |= entangledLanes);
        rootEntangledLanes &= ~lane;
      }
    }
    function getBumpedLaneForHydrationByLane(lane) {
      switch (lane) {
        case 2:
          lane = 1;
          break;
        case 8:
          lane = 4;
          break;
        case 32:
          lane = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          lane = 128;
          break;
        case 268435456:
          lane = 134217728;
          break;
        default:
          lane = 0;
      }
      return lane;
    }
    function addFiberToLanesMap(root2, fiber, lanes) {
      if (isDevToolsPresent)
        for (root2 = root2.pendingUpdatersLaneMap; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes), lane = 1 << index2;
          root2[index2].add(fiber);
          lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root2, lanes) {
      if (isDevToolsPresent)
        for (var pendingUpdatersLaneMap = root2.pendingUpdatersLaneMap, memoizedUpdaters = root2.memoizedUpdaters; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes);
          root2 = 1 << index2;
          index2 = pendingUpdatersLaneMap[index2];
          0 < index2.size && (index2.forEach(function(fiber) {
            var alternate = fiber.alternate;
            null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
          }), index2.clear());
          lanes &= ~root2;
        }
    }
    function lanesToEventPriority(lanes) {
      lanes &= -lanes;
      return DiscreteEventPriority < lanes ? ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
      var updatePriority = ReactDOMSharedInternals.p;
      if (0 !== updatePriority) return updatePriority;
      updatePriority = window.event;
      return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        return ReactDOMSharedInternals.p = priority, fn();
      } finally {
        ReactDOMSharedInternals.p = previousPriority;
      }
    }
    function detachDeletedInstance(node2) {
      delete node2[internalInstanceKey];
      delete node2[internalPropsKey];
      delete node2[internalEventHandlersKey];
      delete node2[internalEventHandlerListenersKey];
      delete node2[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
      var targetInst = targetNode[internalInstanceKey];
      if (targetInst) return targetInst;
      for (var parentNode = targetNode.parentNode; parentNode; ) {
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
          parentNode = targetInst.alternate;
          if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
            for (targetNode = getParentSuspenseInstance(targetNode); null !== targetNode; ) {
              if (parentNode = targetNode[internalInstanceKey])
                return parentNode;
              targetNode = getParentSuspenseInstance(targetNode);
            }
          return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
      }
      return null;
    }
    function getInstanceFromNode(node2) {
      if (node2 = node2[internalInstanceKey] || node2[internalContainerInstanceKey]) {
        var tag = node2.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag)
          return node2;
      }
      return null;
    }
    function getNodeFromInstance(inst) {
      var tag = inst.tag;
      if (5 === tag || 26 === tag || 27 === tag || 6 === tag)
        return inst.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root2) {
      var resources = root2[internalRootNodeResourcesKey];
      resources || (resources = root2[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
      return resources;
    }
    function markNodeAsHoistable(node2) {
      node2[internalHoistableMarker] = true;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
      registerDirectEvent(registrationName, dependencies);
      registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
      registrationNameDependencies[registrationName] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        registrationName
      );
      registrationNameDependencies[registrationName] = dependencies;
      var lowerCasedName = registrationName.toLowerCase();
      possibleRegistrationNames[lowerCasedName] = registrationName;
      "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
      for (registrationName = 0; registrationName < dependencies.length; registrationName++)
        allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
      hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`."
      ) : console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ));
      props.onChange || props.readOnly || props.disabled || null == props.checked || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function isAttributeNameSafe(attributeName) {
      if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
        return true;
      if (hasOwnProperty.call(illegalAttributeNameCache, attributeName))
        return false;
      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
        return validatedAttributeNameCache[attributeName] = true;
      illegalAttributeNameCache[attributeName] = true;
      console.error("Invalid attribute name: `%s`", attributeName);
      return false;
    }
    function getValueForAttributeOnCustomComponent(node2, name, expected) {
      if (isAttributeNameSafe(name)) {
        if (!node2.hasAttribute(name)) {
          switch (typeof expected) {
            case "symbol":
            case "object":
              return expected;
            case "function":
              return expected;
            case "boolean":
              if (false === expected) return expected;
          }
          return void 0 === expected ? void 0 : null;
        }
        node2 = node2.getAttribute(name);
        if ("" === node2 && true === expected) return true;
        checkAttributeStringCoercion(expected, name);
        return node2 === "" + expected ? expected : node2;
      }
    }
    function setValueForAttribute(node2, name, value) {
      if (isAttributeNameSafe(name))
        if (null === value) node2.removeAttribute(name);
        else {
          switch (typeof value) {
            case "undefined":
            case "function":
            case "symbol":
              node2.removeAttribute(name);
              return;
            case "boolean":
              var prefix3 = name.toLowerCase().slice(0, 5);
              if ("data-" !== prefix3 && "aria-" !== prefix3) {
                node2.removeAttribute(name);
                return;
              }
          }
          checkAttributeStringCoercion(value, name);
          node2.setAttribute(name, "" + value);
        }
    }
    function setValueForKnownAttribute(node2, name, value) {
      if (null === value) node2.removeAttribute(name);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node2.removeAttribute(name);
            return;
        }
        checkAttributeStringCoercion(value, name);
        node2.setAttribute(name, "" + value);
      }
    }
    function setValueForNamespacedAttribute(node2, namespace, name, value) {
      if (null === value) node2.removeAttribute(name);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node2.removeAttribute(name);
            return;
        }
        checkAttributeStringCoercion(value, name);
        node2.setAttributeNS(namespace, name, "" + value);
      }
    }
    function disabledLog() {
    }
    function disableLogs() {
      if (0 === disabledDepth) {
        prevLog = console.log;
        prevInfo = console.info;
        prevWarn = console.warn;
        prevError = console.error;
        prevGroup = console.group;
        prevGroupCollapsed = console.groupCollapsed;
        prevGroupEnd = console.groupEnd;
        var props = {
          configurable: true,
          enumerable: true,
          value: disabledLog,
          writable: true
        };
        Object.defineProperties(console, {
          info: props,
          log: props,
          warn: props,
          error: props,
          group: props,
          groupCollapsed: props,
          groupEnd: props
        });
      }
      disabledDepth++;
    }
    function reenableLogs() {
      disabledDepth--;
      if (0 === disabledDepth) {
        var props = { configurable: true, enumerable: true, writable: true };
        Object.defineProperties(console, {
          log: assign2({}, props, { value: prevLog }),
          info: assign2({}, props, { value: prevInfo }),
          warn: assign2({}, props, { value: prevWarn }),
          error: assign2({}, props, { value: prevError }),
          group: assign2({}, props, { value: prevGroup }),
          groupCollapsed: assign2({}, props, { value: prevGroupCollapsed }),
          groupEnd: assign2({}, props, { value: prevGroupEnd })
        });
      }
      0 > disabledDepth && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function describeBuiltInComponentFrame(name) {
      if (void 0 === prefix2)
        try {
          throw Error();
        } catch (x) {
          var match2 = x.stack.trim().match(/\n( *(at )?)/);
          prefix2 = match2 && match2[1] || "";
          suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return "\n" + prefix2 + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct2) {
      if (!fn || reentry) return "";
      var frame = componentFrameCache.get(fn);
      if (void 0 !== frame) return frame;
      reentry = true;
      frame = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var previousDispatcher2 = null;
      previousDispatcher2 = ReactSharedInternals.H;
      ReactSharedInternals.H = null;
      disableLogs();
      try {
        var RunInRootFrame = {
          DetermineComponentFrameRoot: function() {
            try {
              if (construct2) {
                var Fake = function() {
                  throw Error();
                };
                Object.defineProperty(Fake.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                });
                if ("object" === typeof Reflect && Reflect.construct) {
                  try {
                    Reflect.construct(Fake, []);
                  } catch (x) {
                    var control = x;
                  }
                  Reflect.construct(fn, [], Fake);
                } else {
                  try {
                    Fake.call();
                  } catch (x$0) {
                    control = x$0;
                  }
                  fn.call(Fake.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (x$1) {
                  control = x$1;
                }
                (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
                });
              }
            } catch (sample) {
              if (sample && control && "string" === typeof sample.stack)
                return [sample.stack, control.stack];
            }
            return [null, null];
          }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name"
        );
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
          var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
          for (_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes(
            "DetermineComponentFrameRoot"
          ); )
            namePropDescriptor++;
          for (; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes(
            "DetermineComponentFrameRoot"
          ); )
            _RunInRootFrame$Deter++;
          if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length)
            for (namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]; )
              _RunInRootFrame$Deter--;
          for (; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)
            if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
              if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                do
                  if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    var _frame = "\n" + sampleLines[namePropDescriptor].replace(
                      " at new ",
                      " at "
                    );
                    fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                    "function" === typeof fn && componentFrameCache.set(fn, _frame);
                    return _frame;
                  }
                while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
              }
              break;
            }
        }
      } finally {
        reentry = false, ReactSharedInternals.H = previousDispatcher2, reenableLogs(), Error.prepareStackTrace = frame;
      }
      sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
      "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
      return sampleLines;
    }
    function formatOwnerStack(error2) {
      var prevPrepareStackTrace = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      error2 = error2.stack;
      Error.prepareStackTrace = prevPrepareStackTrace;
      error2.startsWith("Error: react-stack-top-frame\n") && (error2 = error2.slice(29));
      prevPrepareStackTrace = error2.indexOf("\n");
      -1 !== prevPrepareStackTrace && (error2 = error2.slice(prevPrepareStackTrace + 1));
      prevPrepareStackTrace = error2.indexOf("react-stack-bottom-frame");
      -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error2.lastIndexOf(
        "\n",
        prevPrepareStackTrace
      ));
      if (-1 !== prevPrepareStackTrace)
        error2 = error2.slice(0, prevPrepareStackTrace);
      else return "";
      return error2;
    }
    function describeFiber(fiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return describeBuiltInComponentFrame(fiber.type);
        case 16:
          return describeBuiltInComponentFrame("Lazy");
        case 13:
          return describeBuiltInComponentFrame("Suspense");
        case 19:
          return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
          return describeNativeComponentFrame(fiber.type, false);
        case 11:
          return describeNativeComponentFrame(fiber.type.render, false);
        case 1:
          return describeNativeComponentFrame(fiber.type, true);
        case 31:
          return describeBuiltInComponentFrame("Activity");
        default:
          return "";
      }
    }
    function getStackByFiberInDevAndProd(workInProgress2) {
      try {
        var info = "";
        do {
          info += describeFiber(workInProgress2);
          var debugInfo = workInProgress2._debugInfo;
          if (debugInfo)
            for (var i = debugInfo.length - 1; 0 <= i; i--) {
              var entry = debugInfo[i];
              if ("string" === typeof entry.name) {
                var JSCompiler_temp_const = info, env2 = entry.env;
                var JSCompiler_inline_result = describeBuiltInComponentFrame(
                  entry.name + (env2 ? " [" + env2 + "]" : "")
                );
                info = JSCompiler_temp_const + JSCompiler_inline_result;
              }
            }
          workInProgress2 = workInProgress2.return;
        } while (workInProgress2);
        return info;
      } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
      }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
      return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
      if (null === current) return null;
      var owner = current._debugOwner;
      return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
      if (null === current) return "";
      var workInProgress2 = current;
      try {
        var info = "";
        6 === workInProgress2.tag && (workInProgress2 = workInProgress2.return);
        switch (workInProgress2.tag) {
          case 26:
          case 27:
          case 5:
            info += describeBuiltInComponentFrame(workInProgress2.type);
            break;
          case 13:
            info += describeBuiltInComponentFrame("Suspense");
            break;
          case 19:
            info += describeBuiltInComponentFrame("SuspenseList");
            break;
          case 31:
            info += describeBuiltInComponentFrame("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type
            ));
            break;
          case 11:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type.render
            ));
        }
        for (; workInProgress2; )
          if ("number" === typeof workInProgress2.tag) {
            var fiber = workInProgress2;
            workInProgress2 = fiber._debugOwner;
            var debugStack = fiber._debugStack;
            workInProgress2 && debugStack && ("string" !== typeof debugStack && (fiber._debugStack = debugStack = formatOwnerStack(debugStack)), "" !== debugStack && (info += "\n" + debugStack));
          } else if (null != workInProgress2.debugStack) {
            var ownerStack = workInProgress2.debugStack;
            (workInProgress2 = workInProgress2.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
          } else break;
        var JSCompiler_inline_result = info;
      } catch (x) {
        JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
      }
      return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
      var previousFiber = current;
      setCurrentFiber(fiber);
      try {
        return null !== fiber && fiber._debugTask ? fiber._debugTask.run(
          callback.bind(null, arg0, arg1, arg2, arg3, arg4)
        ) : callback(arg0, arg1, arg2, arg3, arg4);
      } finally {
        setCurrentFiber(previousFiber);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function setCurrentFiber(fiber) {
      ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
      isRendering = false;
      current = fiber;
    }
    function getToStringValue(value) {
      switch (typeof value) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return value;
        case "object":
          return checkFormFieldValueStringCoercion(value), value;
        default:
          return "";
      }
    }
    function isCheckable(elem) {
      var type4 = elem.type;
      return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type4 || "radio" === type4);
    }
    function trackValueOnNode(node2) {
      var valueField = isCheckable(node2) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(
        node2.constructor.prototype,
        valueField
      );
      checkFormFieldValueStringCoercion(node2[valueField]);
      var currentValue = "" + node2[valueField];
      if (!node2.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get4 = descriptor.get, set2 = descriptor.set;
        Object.defineProperty(node2, valueField, {
          configurable: true,
          get: function() {
            return get4.call(this);
          },
          set: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
            set2.call(this, value);
          }
        });
        Object.defineProperty(node2, valueField, {
          enumerable: descriptor.enumerable
        });
        return {
          getValue: function() {
            return currentValue;
          },
          setValue: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
          },
          stopTracking: function() {
            node2._valueTracker = null;
            delete node2[valueField];
          }
        };
      }
    }
    function track(node2) {
      node2._valueTracker || (node2._valueTracker = trackValueOnNode(node2));
    }
    function updateValueIfChanged(node2) {
      if (!node2) return false;
      var tracker = node2._valueTracker;
      if (!tracker) return true;
      var lastValue = tracker.getValue();
      var value = "";
      node2 && (value = isCheckable(node2) ? node2.checked ? "true" : "false" : node2.value);
      node2 = value;
      return node2 !== lastValue ? (tracker.setValue(node2), true) : false;
    }
    function getActiveElement(doc) {
      doc = doc || ("undefined" !== typeof document ? document : void 0);
      if ("undefined" === typeof doc) return null;
      try {
        return doc.activeElement || doc.body;
      } catch (e) {
        return doc.body;
      }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
      return value.replace(
        escapeSelectorAttributeValueInsideDoubleQuotesRegex,
        function(ch) {
          return "\\" + ch.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function validateInputProps(element, props) {
      void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props.type
      ), didWarnCheckedDefaultChecked = true);
      void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props.type
      ), didWarnValueDefaultValue$1 = true);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type4, name) {
      element.name = "";
      null != type4 && "function" !== typeof type4 && "symbol" !== typeof type4 && "boolean" !== typeof type4 ? (checkAttributeStringCoercion(type4, "type"), element.type = type4) : element.removeAttribute("type");
      if (null != value)
        if ("number" === type4) {
          if (0 === value && "" === element.value || element.value != value)
            element.value = "" + getToStringValue(value);
        } else
          element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
      else
        "submit" !== type4 && "reset" !== type4 || element.removeAttribute("value");
      null != value ? setDefaultValue(element, type4, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type4, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
      null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
      null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
      null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type4, name, isHydrating2) {
      null != type4 && "function" !== typeof type4 && "symbol" !== typeof type4 && "boolean" !== typeof type4 && (checkAttributeStringCoercion(type4, "type"), element.type = type4);
      if (null != value || null != defaultValue) {
        if (!("submit" !== type4 && "reset" !== type4 || void 0 !== value && null !== value))
          return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating2 || value === element.value || (element.value = value);
        element.defaultValue = value;
      }
      checked = null != checked ? checked : defaultChecked;
      checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
      element.checked = isHydrating2 ? element.checked : !!checked;
      element.defaultChecked = !!checked;
      null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
    }
    function setDefaultValue(node2, type4, value) {
      "number" === type4 && getActiveElement(node2.ownerDocument) === node2 || node2.defaultValue === "" + value || (node2.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
      null == props.value && ("object" === typeof props.children && null !== props.children ? React2.Children.forEach(props.children, function(child) {
        null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = true, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = true, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      )));
      null == props.selected || didWarnSelectedSetOnOption || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), didWarnSelectedSetOnOption = true);
    }
    function getDeclarationErrorAddendum() {
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();
      return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node2, multiple, propValue, setDefaultSelected) {
      node2 = node2.options;
      if (multiple) {
        multiple = {};
        for (var i = 0; i < propValue.length; i++)
          multiple["$" + propValue[i]] = true;
        for (propValue = 0; propValue < node2.length; propValue++)
          i = multiple.hasOwnProperty("$" + node2[propValue].value), node2[propValue].selected !== i && (node2[propValue].selected = i), i && setDefaultSelected && (node2[propValue].defaultSelected = true);
      } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for (i = 0; i < node2.length; i++) {
          if (node2[i].value === propValue) {
            node2[i].selected = true;
            setDefaultSelected && (node2[i].defaultSelected = true);
            return;
          }
          null !== multiple || node2[i].disabled || (multiple = node2[i]);
        }
        null !== multiple && (multiple.selected = true);
      }
    }
    function validateSelectProps(element, props) {
      for (element = 0; element < valuePropNames.length; element++) {
        var propName = valuePropNames[element];
        if (null != props[propName]) {
          var propNameIsArray = isArrayImpl(props[propName]);
          props.multiple && !propNameIsArray ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            propName,
            getDeclarationErrorAddendum()
          ) : !props.multiple && propNameIsArray && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            propName,
            getDeclarationErrorAddendum()
          );
        }
      }
      void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), didWarnValueDefaultValue = true);
    }
    function validateTextareaProps(element, props) {
      void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component"
      ), didWarnValDefaultVal = true);
      null != props.children && null == props.value && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function updateTextarea(element, value, defaultValue) {
      if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
      }
      element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children2) {
      if (null == value) {
        if (null != children2) {
          if (null != defaultValue)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (isArrayImpl(children2)) {
            if (1 < children2.length)
              throw Error("<textarea> can only have at most one child.");
            children2 = children2[0];
          }
          defaultValue = children2;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
      }
      defaultValue = getToStringValue(value);
      element.defaultValue = defaultValue;
      children2 = element.textContent;
      children2 === defaultValue && "" !== children2 && null !== children2 && (element.value = children2);
    }
    function findNotableNode(node2, indent) {
      return void 0 === node2.serverProps && 0 === node2.serverTail.length && 1 === node2.children.length && 3 < node2.distanceFromLeaf && node2.distanceFromLeaf > 15 - indent ? findNotableNode(node2.children[0], indent) : node2;
    }
    function indentation(indent) {
      return "  " + "  ".repeat(indent);
    }
    function added(indent) {
      return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
      return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return fiber.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        case 11:
          return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
        case 1:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        default:
          return null;
      }
    }
    function describeTextNode(content2, maxLength) {
      return needsEscaping.test(content2) ? (content2 = JSON.stringify(content2), content2.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content2.slice(0, maxLength - 7) + '..."}' : "{" + content2 + "}") : content2.length > maxLength ? 5 > maxLength ? '{"..."}' : content2.slice(0, maxLength - 3) + "..." : content2;
    }
    function describeTextDiff(clientText, serverProps, indent) {
      var maxLength = 120 - 2 * indent;
      if (null === serverProps)
        return added(indent) + describeTextNode(clientText, maxLength) + "\n";
      if ("string" === typeof serverProps) {
        for (var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++) ;
        firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
        return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
      }
      return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object4) {
      return Object.prototype.toString.call(object4).replace(/^\[object (.*)\]$/, function(m, p0) {
        return p0;
      });
    }
    function describeValue(value, maxLength) {
      switch (typeof value) {
        case "string":
          return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
        case "object":
          if (null === value) return "null";
          if (isArrayImpl(value)) return "[...]";
          if (value.$$typeof === REACT_ELEMENT_TYPE)
            return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
          var name = objectName(value);
          if ("Object" === name) {
            name = "";
            maxLength -= 2;
            for (var propName in value)
              if (value.hasOwnProperty(propName)) {
                var jsonPropName = JSON.stringify(propName);
                jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                maxLength -= propName.length - 2;
                jsonPropName = describeValue(
                  value[propName],
                  15 > maxLength ? maxLength : 15
                );
                maxLength -= jsonPropName.length;
                if (0 > maxLength) {
                  name += "" === name ? "..." : ", ...";
                  break;
                }
                name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
              }
            return "{" + name + "}";
          }
          return name;
        case "function":
          return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
        default:
          return String(value);
      }
    }
    function describePropValue(value, maxLength) {
      return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type4, props, rowPrefix) {
      var remainingRowLength = 120 - rowPrefix.length - type4.length, properties = [], propName;
      for (propName in props)
        if (props.hasOwnProperty(propName) && "children" !== propName) {
          var propValue = describePropValue(
            props[propName],
            120 - rowPrefix.length - propName.length - 1
          );
          remainingRowLength -= propName.length + propValue.length + 2;
          properties.push(propName + "=" + propValue);
        }
      return 0 === properties.length ? rowPrefix + "<" + type4 + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type4 + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type4 + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
      var properties = "", remainingServerProperties = assign2({}, serverObject), propName;
      for (propName in clientObject)
        if (clientObject.hasOwnProperty(propName)) {
          delete remainingServerProperties[propName];
          var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
          serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
      for (var _propName in remainingServerProperties)
        remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(
          remainingServerProperties[_propName],
          120 - 2 * indent - _propName.length - 2
        ), properties += removed(indent) + _propName + ": " + clientObject + "\n");
      return properties;
    }
    function describeElementDiff(type4, clientProps, serverProps, indent) {
      var content2 = "", serverPropNames = /* @__PURE__ */ new Map();
      for (propName$jscomp$0 in serverProps)
        serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(
          propName$jscomp$0.toLowerCase(),
          propName$jscomp$0
        );
      if (1 === serverPropNames.size && serverPropNames.has("children"))
        content2 += describeExpandedElement(
          type4,
          clientProps,
          indentation(indent)
        );
      else {
        for (var _propName2 in clientProps)
          if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
            var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
            if (void 0 !== serverPropName) {
              serverPropNames.delete(_propName2.toLowerCase());
              var propName$jscomp$0 = clientProps[_propName2];
              serverPropName = serverProps[serverPropName];
              var clientPropValue = describePropValue(
                propName$jscomp$0,
                maxLength$jscomp$0
              );
              maxLength$jscomp$0 = describePropValue(
                serverPropName,
                maxLength$jscomp$0
              );
              "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content2 += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(
                propName$jscomp$0,
                serverPropName,
                indent + 2
              ) + indentation(indent + 1) + "}}\n" : (content2 += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content2 += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
            } else
              content2 += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
          }
        serverPropNames.forEach(function(propName) {
          if ("children" !== propName) {
            var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
            content2 += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
          }
        });
        content2 = "" === content2 ? indentation(indent) + "<" + type4 + ">\n" : indentation(indent) + "<" + type4 + "\n" + content2 + indentation(indent) + ">\n";
      }
      type4 = serverProps.children;
      clientProps = clientProps.children;
      if ("string" === typeof type4 || "number" === typeof type4 || "bigint" === typeof type4) {
        serverPropNames = "";
        if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
          serverPropNames = "" + clientProps;
        content2 += describeTextDiff(serverPropNames, "" + type4, indent + 1);
      } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
        content2 = null == type4 ? content2 + describeTextDiff("" + clientProps, null, indent + 1) : content2 + describeTextDiff("" + clientProps, void 0, indent + 1);
      return content2;
    }
    function describeSiblingFiber(fiber, indent) {
      var type4 = describeFiberType(fiber);
      if (null === type4) {
        type4 = "";
        for (fiber = fiber.child; fiber; )
          type4 += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
        return type4;
      }
      return indentation(indent) + "<" + type4 + ">\n";
    }
    function describeNode(node2, indent) {
      var skipToNode = findNotableNode(node2, indent);
      if (skipToNode !== node2 && (1 !== node2.children.length || node2.children[0] !== skipToNode))
        return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
      skipToNode = "";
      var debugInfo = node2.fiber._debugInfo;
      if (debugInfo)
        for (var i = 0; i < debugInfo.length; i++) {
          var serverComponentName = debugInfo[i].name;
          "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
      debugInfo = "";
      i = node2.fiber.pendingProps;
      if (6 === node2.fiber.tag)
        debugInfo = describeTextDiff(i, node2.serverProps, indent), indent++;
      else if (serverComponentName = describeFiberType(node2.fiber), null !== serverComponentName)
        if (void 0 === node2.serverProps) {
          debugInfo = indent;
          var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content2 = "";
          for (propName in i)
            if (i.hasOwnProperty(propName) && "children" !== propName) {
              var propValue = describePropValue(i[propName], 15);
              maxLength -= propName.length + propValue.length + 2;
              if (0 > maxLength) {
                content2 += " ...";
                break;
              }
              content2 += " " + propName + "=" + propValue;
            }
          debugInfo = indentation(debugInfo) + "<" + serverComponentName + content2 + ">\n";
          indent++;
        } else
          null === node2.serverProps ? (debugInfo = describeExpandedElement(
            serverComponentName,
            i,
            added(indent)
          ), indent++) : "string" === typeof node2.serverProps ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (debugInfo = describeElementDiff(
            serverComponentName,
            i,
            node2.serverProps,
            indent
          ), indent++);
      var propName = "";
      i = node2.fiber.child;
      for (serverComponentName = 0; i && serverComponentName < node2.children.length; )
        maxLength = node2.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
      i && 0 < node2.children.length && (propName += indentation(indent) + "...\n");
      i = node2.serverTail;
      null === node2.serverProps && indent--;
      for (node2 = 0; node2 < i.length; node2++)
        serverComponentName = i[node2], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(
          serverComponentName.type,
          serverComponentName.props,
          removed(indent)
        );
      return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
      try {
        return "\n\n" + describeNode(rootNode, 0);
      } catch (x) {
        return "";
      }
    }
    function describeAncestors(ancestor, child, props) {
      for (var fiber = child, node2 = null, distanceFromLeaf = 0; fiber; )
        fiber === ancestor && (distanceFromLeaf = 0), node2 = {
          fiber,
          children: null !== node2 ? [node2] : [],
          serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
          serverTail: [],
          distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
      return null !== node2 ? describeDiff(node2).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
      var ancestorInfo = assign2({}, oldInfo || emptyAncestorInfoDev), info = { tag };
      -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
      -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
      -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
      ancestorInfo.current = info;
      "form" === tag && (ancestorInfo.formTag = info);
      "a" === tag && (ancestorInfo.aTagInScope = info);
      "button" === tag && (ancestorInfo.buttonTagInScope = info);
      "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
      "p" === tag && (ancestorInfo.pTagInButtonScope = info);
      "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
      if ("dd" === tag || "dt" === tag)
        ancestorInfo.dlItemTagAutoclosing = info;
      "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
      null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? true === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = false) : ancestorInfo.implicitRootScope = true;
      return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
      switch (parentTag) {
        case "select":
          return "hr" === tag || "option" === tag || "optgroup" === tag || "script" === tag || "template" === tag || "#text" === tag;
        case "optgroup":
          return "option" === tag || "#text" === tag;
        case "option":
          return "#text" === tag;
        case "tr":
          return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
        case "tbody":
        case "thead":
        case "tfoot":
          return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
        case "colgroup":
          return "col" === tag || "template" === tag;
        case "table":
          return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
        case "head":
          return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
        case "html":
          if (implicitRootScope) break;
          return "head" === tag || "body" === tag || "frameset" === tag;
        case "frameset":
          return "frame" === tag;
        case "#document":
          if (!implicitRootScope) return "html" === tag;
      }
      switch (tag) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
        case "rp":
        case "rt":
          return -1 === impliedEndTags.indexOf(parentTag);
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return null == parentTag;
        case "head":
          return implicitRootScope || null === parentTag;
        case "html":
          return implicitRootScope && "#document" === parentTag || null === parentTag;
        case "body":
          return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
      }
      return true;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
      switch (tag) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return ancestorInfo.pTagInButtonScope;
        case "form":
          return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
        case "li":
          return ancestorInfo.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return ancestorInfo.dlItemTagAutoclosing;
        case "button":
          return ancestorInfo.buttonTagInScope;
        case "a":
          return ancestorInfo.aTagInScope;
        case "nobr":
          return ancestorInfo.nobrTagInScope;
      }
      return null;
    }
    function findAncestor(parent, tagName) {
      for (; parent; ) {
        switch (parent.tag) {
          case 5:
          case 26:
          case 27:
            if (parent.type === tagName) return parent;
        }
        parent = parent.return;
      }
      return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
      ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
      var parentInfo = ancestorInfo.current;
      ancestorInfo = (parentInfo = isTagValidWithParent(
        childTag,
        parentInfo && parentInfo.tag,
        ancestorInfo.implicitRootScope
      ) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
      ancestorInfo = parentInfo || ancestorInfo;
      if (!ancestorInfo) return true;
      var ancestorTag = ancestorInfo.tag;
      ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
      if (didWarn[ancestorInfo]) return false;
      didWarn[ancestorInfo] = true;
      var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
      parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        "In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        parentInfo,
        ancestorDescription
      )) : console.error(
        "In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        ancestorDescription
      );
      ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
        console.error(
          "<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.",
          ancestorTag,
          tagDisplayName
        );
      }));
      return false;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
      if (implicitRootScope || isTagValidWithParent("#text", parentTag, false))
        return true;
      implicitRootScope = "#text|" + parentTag;
      if (didWarn[implicitRootScope]) return false;
      didWarn[implicitRootScope] = true;
      var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
      implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(
        ancestor,
        implicitRootScope,
        6 !== implicitRootScope.tag ? { children: null } : null
      ) : "";
      /\S/.test(childText) ? console.error(
        "In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      ) : console.error(
        "In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      );
      return false;
    }
    function setTextContent(node2, text2) {
      if (text2) {
        var firstChild = node2.firstChild;
        if (firstChild && firstChild === node2.lastChild && 3 === firstChild.nodeType) {
          firstChild.nodeValue = text2;
          return;
        }
      }
      node2.textContent = text2;
    }
    function camelize(string3) {
      return string3.replace(hyphenPattern, function(_2, character2) {
        return character2.toUpperCase();
      });
    }
    function setValueForStyle(style3, styleName, value) {
      var isCustomProperty3 = 0 === styleName.indexOf("--");
      isCustomProperty3 || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported style property %s. Did you mean %s?",
        styleName,
        camelize(styleName.replace(msPattern, "ms-"))
      )) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        styleName,
        styleName.charAt(0).toUpperCase() + styleName.slice(1)
      )) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = true, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        styleName,
        value.replace(badStyleValueWithSemicolonPattern, "")
      )), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = true, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        styleName
      )) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = true, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        styleName
      ))));
      null == value || "boolean" === typeof value || "" === value ? isCustomProperty3 ? style3.setProperty(styleName, "") : "float" === styleName ? style3.cssFloat = "" : style3[styleName] = "" : isCustomProperty3 ? style3.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style3.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style3[styleName] = ("" + value).trim()) : style3[styleName] = value + "px";
    }
    function setValueForStyles(node2, styles2, prevStyles) {
      if (null != styles2 && "object" !== typeof styles2)
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      styles2 && Object.freeze(styles2);
      node2 = node2.style;
      if (null != prevStyles) {
        if (styles2) {
          var expandedUpdates = {};
          if (prevStyles) {
            for (var key in prevStyles)
              if (prevStyles.hasOwnProperty(key) && !styles2.hasOwnProperty(key))
                for (var longhands = shorthandToLonghand[key] || [key], i = 0; i < longhands.length; i++)
                  expandedUpdates[longhands[i]] = key;
          }
          for (var _key in styles2)
            if (styles2.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles2[_key]))
              for (key = shorthandToLonghand[_key] || [_key], longhands = 0; longhands < key.length; longhands++)
                expandedUpdates[key[longhands]] = _key;
          _key = {};
          for (var key$jscomp$0 in styles2)
            for (key = shorthandToLonghand[key$jscomp$0] || [key$jscomp$0], longhands = 0; longhands < key.length; longhands++)
              _key[key[longhands]] = key$jscomp$0;
          key$jscomp$0 = {};
          for (var _key2 in expandedUpdates)
            if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
              key$jscomp$0[i] = true;
              i = console;
              var value = styles2[key];
              i.error.call(
                i,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating",
                key,
                longhands
              );
            }
        }
        for (var styleName in prevStyles)
          !prevStyles.hasOwnProperty(styleName) || null != styles2 && styles2.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node2.setProperty(styleName, "") : "float" === styleName ? node2.cssFloat = "" : node2[styleName] = "");
        for (var _styleName in styles2)
          _key2 = styles2[_styleName], styles2.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node2, _styleName, _key2);
      } else
        for (expandedUpdates in styles2)
          styles2.hasOwnProperty(expandedUpdates) && setValueForStyle(node2, expandedUpdates, styles2[expandedUpdates]);
    }
    function isCustomElement(tagName) {
      if (-1 === tagName.indexOf("-")) return false;
      switch (tagName) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return false;
        default:
          return true;
      }
    }
    function getAttributeAlias(name) {
      return aliases2.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
      if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name])
        return true;
      if (rARIACamel$1.test(name)) {
        tagName = "aria-" + name.slice(4).toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            name
          ), warnedProperties$1[name] = true;
        if (name !== tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            name,
            tagName
          ), warnedProperties$1[name] = true;
      }
      if (rARIA$1.test(name)) {
        tagName = name.toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName) return warnedProperties$1[name] = true, false;
        name !== tagName && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          name,
          tagName
        ), warnedProperties$1[name] = true);
      }
      return true;
    }
    function validateProperties$2(type4, props) {
      var invalidProps = [], key;
      for (key in props)
        validateProperty$1(type4, key) || invalidProps.push(key);
      props = invalidProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === invalidProps.length ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props,
        type4
      ) : 1 < invalidProps.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props,
        type4
      );
    }
    function validateProperty(tagName, name, value, eventRegistry) {
      if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name])
        return true;
      var lowerCasedName = name.toLowerCase();
      if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName)
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), warnedProperties[name] = true;
      if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name))
        return true;
      if (null != eventRegistry) {
        tagName = eventRegistry.possibleRegistrationNames;
        if (eventRegistry.registrationNameDependencies.hasOwnProperty(name))
          return true;
        eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
        if (null != eventRegistry)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            name,
            eventRegistry
          ), warnedProperties[name] = true;
        if (EVENT_NAME_REGEX.test(name))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            name
          ), warnedProperties[name] = true;
      } else if (EVENT_NAME_REGEX.test(name))
        return INVALID_EVENT_NAME_REGEX.test(name) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          name
        ), warnedProperties[name] = true;
      if (rARIA.test(name) || rARIACamel.test(name)) return true;
      if ("innerhtml" === lowerCasedName)
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), warnedProperties[name] = true;
      if ("aria" === lowerCasedName)
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), warnedProperties[name] = true;
      if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value)
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof value
        ), warnedProperties[name] = true;
      if ("number" === typeof value && isNaN(value))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          name
        ), warnedProperties[name] = true;
      if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
        if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            name,
            lowerCasedName
          ), warnedProperties[name] = true;
      } else if (name !== lowerCasedName)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          name,
          lowerCasedName
        ), warnedProperties[name] = true;
      switch (name) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return true;
        case "innerText":
        case "textContent":
          return true;
      }
      switch (typeof value) {
        case "boolean":
          switch (name) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return true;
            default:
              lowerCasedName = name.toLowerCase().slice(0, 5);
              if ("data-" === lowerCasedName || "aria-" === lowerCasedName)
                return true;
              value ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                value,
                name,
                name,
                value,
                name
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                value,
                name,
                name,
                value,
                name,
                name,
                name
              );
              return warnedProperties[name] = true;
          }
        case "function":
        case "symbol":
          return warnedProperties[name] = true, false;
        case "string":
          if ("false" === value || "true" === value) {
            switch (name) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return true;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              value,
              name,
              "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              name,
              value
            );
            warnedProperties[name] = true;
          }
      }
      return true;
    }
    function warnUnknownProperties(type4, props, eventRegistry) {
      var unknownProps = [], key;
      for (key in props)
        validateProperty(type4, key, props[key], eventRegistry) || unknownProps.push(key);
      props = unknownProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === unknownProps.length ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props,
        type4
      ) : 1 < unknownProps.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props,
        type4
      );
    }
    function sanitizeURL(url2) {
      return isJavaScriptProtocol.test("" + url2) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url2;
    }
    function getEventTarget(nativeEvent) {
      nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
      nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
      return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
      var internalInstance = getInstanceFromNode(target);
      if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch (target = internalInstance.stateNode, internalInstance.type) {
          case "input":
            updateInput(
              target,
              props.value,
              props.defaultValue,
              props.defaultValue,
              props.checked,
              props.defaultChecked,
              props.type,
              props.name
            );
            internalInstance = props.name;
            if ("radio" === props.type && null != internalInstance) {
              for (props = target; props.parentNode; ) props = props.parentNode;
              checkAttributeStringCoercion(internalInstance, "name");
              props = props.querySelectorAll(
                'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                  "" + internalInstance
                ) + '"][type="radio"]'
              );
              for (internalInstance = 0; internalInstance < props.length; internalInstance++) {
                var otherNode = props[internalInstance];
                if (otherNode !== target && otherNode.form === target.form) {
                  var otherProps = otherNode[internalPropsKey] || null;
                  if (!otherProps)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  updateInput(
                    otherNode,
                    otherProps.value,
                    otherProps.defaultValue,
                    otherProps.defaultValue,
                    otherProps.checked,
                    otherProps.defaultChecked,
                    otherProps.type,
                    otherProps.name
                  );
                }
              }
              for (internalInstance = 0; internalInstance < props.length; internalInstance++)
                otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
            }
            break a;
          case "textarea":
            updateTextarea(target, props.value, props.defaultValue);
            break a;
          case "select":
            internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, false);
        }
      }
    }
    function batchedUpdates$1(fn, a, b) {
      if (isInsideEventHandler) return fn(a, b);
      isInsideEventHandler = true;
      try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
      } finally {
        if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
          if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn))
            for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
        }
      }
    }
    function getListener(inst, registrationName) {
      var stateNode = inst.stateNode;
      if (null === stateNode) return null;
      var props = stateNode[internalPropsKey] || null;
      if (null === props) return null;
      stateNode = props[registrationName];
      a: switch (registrationName) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
          inst = !props;
          break a;
        default:
          inst = false;
      }
      if (inst) return null;
      if (stateNode && "function" !== typeof stateNode)
        throw Error(
          "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type."
        );
      return stateNode;
    }
    function getData2() {
      if (fallbackText) return fallbackText;
      var start2, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
      for (start2 = 0; start2 < startLength && startValue[start2] === endValue[start2]; start2++) ;
      var minEnd = startLength - start2;
      for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
      return fallbackText = endValue.slice(start2, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
      var keyCode = nativeEvent.keyCode;
      "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
      10 === nativeEvent && (nativeEvent = 13);
      return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
      return true;
    }
    function functionThatReturnsFalse() {
      return false;
    }
    function createSyntheticEvent(Interface) {
      function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for (var propName in Interface)
          Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
      }
      assign2(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
          this.defaultPrevented = true;
          var event = this.nativeEvent;
          event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
          var event = this.nativeEvent;
          event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {
        },
        isPersistent: functionThatReturnsTrue
      });
      return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
      var nativeEvent = this.nativeEvent;
      return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
    }
    function getEventModifierState() {
      return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
      switch (domEventName) {
        case "keyup":
          return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
          return nativeEvent.keyCode !== START_KEYCODE;
        case "keypress":
        case "mousedown":
        case "focusout":
          return true;
        default:
          return false;
      }
    }
    function getDataFromCustomEvent(nativeEvent) {
      nativeEvent = nativeEvent.detail;
      return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
      switch (domEventName) {
        case "compositionend":
          return getDataFromCustomEvent(nativeEvent);
        case "keypress":
          if (nativeEvent.which !== SPACEBAR_CODE) return null;
          hasSpaceKeypress = true;
          return SPACEBAR_CHAR;
        case "textInput":
          return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
          return null;
      }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
      if (isComposing)
        return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData2(), fallbackText = startText = root = null, isComposing = false, domEventName) : null;
      switch (domEventName) {
        case "paste":
          return null;
        case "keypress":
          if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
            if (nativeEvent.char && 1 < nativeEvent.char.length)
              return nativeEvent.char;
            if (nativeEvent.which)
              return String.fromCharCode(nativeEvent.which);
          }
          return null;
        case "compositionend":
          return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
          return null;
      }
    }
    function isTextInputElement(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
    }
    function isEventSupported(eventNameSuffix) {
      if (!canUseDOM2) return false;
      eventNameSuffix = "on" + eventNameSuffix;
      var isSupported = eventNameSuffix in document;
      isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
      return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
      restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
      inst = accumulateTwoPhaseListeners(inst, "onChange");
      0 < inst.length && (nativeEvent = new SyntheticEvent(
        "onChange",
        "change",
        null,
        nativeEvent,
        target
      ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
    }
    function runEventInBatch(dispatchQueue) {
      processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
      var targetNode = getNodeFromInstance(targetInst);
      if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
      if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
      activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
      if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(
          dispatchQueue,
          activeElementInst$1,
          nativeEvent,
          getEventTarget(nativeEvent)
        );
        batchedUpdates$1(runEventInBatch, dispatchQueue);
      }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
      "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
      if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
        return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
      if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
      if ("input" === domEventName || "change" === domEventName)
        return getInstIfValueChanged(targetInst);
    }
    function is2(x, y) {
      return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual2(objA, objB) {
      if (objectIs(objA, objB)) return true;
      if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
        return false;
      var keysA = Object.keys(objA), keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) return false;
      for (keysB = 0; keysB < keysA.length; keysB++) {
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
          return false;
      }
      return true;
    }
    function getLeafNode(node2) {
      for (; node2 && node2.firstChild; ) node2 = node2.firstChild;
      return node2;
    }
    function getNodeForCharacterOffset(root2, offset) {
      var node2 = getLeafNode(root2);
      root2 = 0;
      for (var nodeEnd; node2; ) {
        if (3 === node2.nodeType) {
          nodeEnd = root2 + node2.textContent.length;
          if (root2 <= offset && nodeEnd >= offset)
            return { node: node2, offset: offset - root2 };
          root2 = nodeEnd;
        }
        a: {
          for (; node2; ) {
            if (node2.nextSibling) {
              node2 = node2.nextSibling;
              break a;
            }
            node2 = node2.parentNode;
          }
          node2 = void 0;
        }
        node2 = getLeafNode(node2);
      }
    }
    function containsNode(outerNode, innerNode) {
      return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
    }
    function getActiveElementDeep(containerInfo) {
      containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
      for (var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement; ) {
        try {
          var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
          JSCompiler_inline_result = false;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
      }
      return element;
    }
    function hasSelectionCapabilities(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
      var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
      mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = { start: doc.selectionStart, end: doc.selectionEnd } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
      }), lastSelection && shallowEqual2(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent(
        "onSelect",
        "select",
        null,
        nativeEvent,
        nativeEventTarget
      ), dispatchQueue.push({ event: nativeEvent, listeners: doc }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap2(styleProp, eventName) {
      var prefixes = {};
      prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
      prefixes["Webkit" + styleProp] = "webkit" + eventName;
      prefixes["Moz" + styleProp] = "moz" + eventName;
      return prefixes;
    }
    function getVendorPrefixedEventName2(eventName) {
      if (prefixedEventNames2[eventName]) return prefixedEventNames2[eventName];
      if (!vendorPrefixes2[eventName]) return eventName;
      var prefixMap = vendorPrefixes2[eventName], styleProp;
      for (styleProp in prefixMap)
        if (prefixMap.hasOwnProperty(styleProp) && styleProp in style2)
          return prefixedEventNames2[eventName] = prefixMap[styleProp];
      return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
      topLevelEventsToReactNames.set(domEventName, reactName);
      registerTwoPhaseEvent(reactName, [domEventName]);
    }
    function createCapturedValueAtFiber(value, source) {
      if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
          value,
          source,
          stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
      }
      return {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
    }
    function finishQueueingConcurrentUpdates() {
      for (var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex; ) {
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update2 = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update2) {
          var pending = queue.pending;
          null === pending ? update2.next = update2 : (update2.next = pending.next, pending.next = update2);
          queue.pending = update2;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update2, lane);
      }
    }
    function enqueueUpdate$1(fiber, queue, update2, lane) {
      concurrentQueues[concurrentQueuesIndex++] = fiber;
      concurrentQueues[concurrentQueuesIndex++] = queue;
      concurrentQueues[concurrentQueuesIndex++] = update2;
      concurrentQueues[concurrentQueuesIndex++] = lane;
      concurrentlyUpdatedLanes |= lane;
      fiber.lanes |= lane;
      fiber = fiber.alternate;
      null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update2, lane) {
      enqueueUpdate$1(fiber, queue, update2, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
      enqueueUpdate$1(fiber, null, null, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update2, lane) {
      sourceFiber.lanes |= lane;
      var alternate = sourceFiber.alternate;
      null !== alternate && (alternate.lanes |= lane);
      for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
        parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = true)), sourceFiber = parent, parent = parent.return;
      return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update2 && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [update2] : alternate.push(update2), update2.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
      if (nestedUpdateCount > NESTED_UPDATE_LIMIT)
        throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      ));
      null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
      for (var node2 = sourceFiber, parent = node2.return; null !== parent; )
        null === node2.alternate && 0 !== (node2.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node2 = parent, parent = node2.return;
      return 3 === node2.tag ? node2.stateNode : null;
    }
    function resolveFunctionForHotReloading(type4) {
      if (null === resolveFamily) return type4;
      var family = resolveFamily(type4);
      return void 0 === family ? type4 : family.current;
    }
    function resolveForwardRefForHotReloading(type4) {
      if (null === resolveFamily) return type4;
      var family = resolveFamily(type4);
      return void 0 === family ? null !== type4 && void 0 !== type4 && "function" === typeof type4.render && (family = resolveFunctionForHotReloading(type4.render), type4.render !== family) ? (family = { $$typeof: REACT_FORWARD_REF_TYPE, render: family }, void 0 !== type4.displayName && (family.displayName = type4.displayName), family) : type4 : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
      if (null === resolveFamily) return false;
      var prevType = fiber.elementType;
      element = element.type;
      var needsCompareFamilies = false, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
      switch (fiber.tag) {
        case 1:
          "function" === typeof element && (needsCompareFamilies = true);
          break;
        case 0:
          "function" === typeof element ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 11:
          $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 14:
        case 15:
          $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        default:
          return false;
      }
      return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element)) ? true : false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
      null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = /* @__PURE__ */ new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
      var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type4 = fiber.type, candidateType = null;
      switch (tag) {
        case 0:
        case 15:
        case 1:
          candidateType = type4;
          break;
        case 11:
          candidateType = type4.render;
      }
      if (null === resolveFamily)
        throw Error("Expected resolveFamily to be set during hot reload.");
      var needsRender = false;
      type4 = false;
      null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? type4 = true : updatedFamilies.has(candidateType) && (1 === tag ? type4 = true : needsRender = true)));
      null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (type4 = true);
      type4 && (fiber._debugNeedsRemount = true);
      if (type4 || needsRender)
        alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
      null === child || type4 || scheduleFibersWithFamiliesRecursively(
        child,
        updatedFamilies,
        staleFamilies
      );
      null !== sibling && scheduleFibersWithFamiliesRecursively(
        sibling,
        updatedFamilies,
        staleFamilies
      );
    }
    function FiberNode(tag, pendingProps, key, mode) {
      this.tag = tag;
      this.key = key;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.refCleanup = this.ref = null;
      this.pendingProps = pendingProps;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = mode;
      this.subtreeFlags = this.flags = 0;
      this.deletions = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
      this.actualDuration = -0;
      this.actualStartTime = -1.1;
      this.treeBaseDuration = this.selfBaseDuration = -0;
      this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
      this._debugNeedsRemount = false;
      this._debugHookTypes = null;
      hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component2) {
      Component2 = Component2.prototype;
      return !(!Component2 || !Component2.isReactComponent);
    }
    function createWorkInProgress(current2, pendingProps) {
      var workInProgress2 = current2.alternate;
      null === workInProgress2 ? (workInProgress2 = createFiber(
        current2.tag,
        pendingProps,
        current2.key,
        current2.mode
      ), workInProgress2.elementType = current2.elementType, workInProgress2.type = current2.type, workInProgress2.stateNode = current2.stateNode, workInProgress2._debugOwner = current2._debugOwner, workInProgress2._debugStack = current2._debugStack, workInProgress2._debugTask = current2._debugTask, workInProgress2._debugHookTypes = current2._debugHookTypes, workInProgress2.alternate = current2, current2.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current2.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.actualDuration = -0, workInProgress2.actualStartTime = -1.1);
      workInProgress2.flags = current2.flags & 65011712;
      workInProgress2.childLanes = current2.childLanes;
      workInProgress2.lanes = current2.lanes;
      workInProgress2.child = current2.child;
      workInProgress2.memoizedProps = current2.memoizedProps;
      workInProgress2.memoizedState = current2.memoizedState;
      workInProgress2.updateQueue = current2.updateQueue;
      pendingProps = current2.dependencies;
      workInProgress2.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext,
        _debugThenableState: pendingProps._debugThenableState
      };
      workInProgress2.sibling = current2.sibling;
      workInProgress2.index = current2.index;
      workInProgress2.ref = current2.ref;
      workInProgress2.refCleanup = current2.refCleanup;
      workInProgress2.selfBaseDuration = current2.selfBaseDuration;
      workInProgress2.treeBaseDuration = current2.treeBaseDuration;
      workInProgress2._debugInfo = current2._debugInfo;
      workInProgress2._debugNeedsRemount = current2._debugNeedsRemount;
      switch (workInProgress2.tag) {
        case 0:
        case 15:
          workInProgress2.type = resolveFunctionForHotReloading(current2.type);
          break;
        case 1:
          workInProgress2.type = resolveFunctionForHotReloading(current2.type);
          break;
        case 11:
          workInProgress2.type = resolveForwardRefForHotReloading(current2.type);
      }
      return workInProgress2;
    }
    function resetWorkInProgress(workInProgress2, renderLanes2) {
      workInProgress2.flags &= 65011714;
      var current2 = workInProgress2.alternate;
      null === current2 ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null, workInProgress2.selfBaseDuration = 0, workInProgress2.treeBaseDuration = 0) : (workInProgress2.childLanes = current2.childLanes, workInProgress2.lanes = current2.lanes, workInProgress2.child = current2.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current2.memoizedProps, workInProgress2.memoizedState = current2.memoizedState, workInProgress2.updateQueue = current2.updateQueue, workInProgress2.type = current2.type, renderLanes2 = current2.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
        lanes: renderLanes2.lanes,
        firstContext: renderLanes2.firstContext,
        _debugThenableState: renderLanes2._debugThenableState
      }, workInProgress2.selfBaseDuration = current2.selfBaseDuration, workInProgress2.treeBaseDuration = current2.treeBaseDuration);
      return workInProgress2;
    }
    function createFiberFromTypeAndProps(type4, key, pendingProps, owner, mode, lanes) {
      var fiberTag = 0, resolvedType = type4;
      if ("function" === typeof type4)
        shouldConstruct(type4) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
      else if ("string" === typeof type4)
        fiberTag = getHostContext(), fiberTag = isHostHoistableType(type4, pendingProps, fiberTag) ? 26 : "html" === type4 || "head" === type4 || "body" === type4 ? 27 : 5;
      else
        a: switch (type4) {
          case REACT_ACTIVITY_TYPE:
            return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
          case REACT_FRAGMENT_TYPE2:
            return createFiberFromFragment(
              pendingProps.children,
              mode,
              lanes,
              key
            );
          case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= StrictLegacyMode;
            mode |= StrictEffectsMode;
            break;
          case REACT_PROFILER_TYPE:
            return type4 = pendingProps, owner = mode, "string" !== typeof type4.id && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof type4.id
            ), key = createFiber(12, type4, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, key;
          case REACT_SUSPENSE_TYPE:
            return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
          case REACT_SUSPENSE_LIST_TYPE:
            return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
          default:
            if ("object" === typeof type4 && null !== type4)
              switch (type4.$$typeof) {
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                  fiberTag = 10;
                  break a;
                case REACT_CONSUMER_TYPE:
                  fiberTag = 9;
                  break a;
                case REACT_FORWARD_REF_TYPE:
                  fiberTag = 11;
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                  break a;
                case REACT_MEMO_TYPE:
                  fiberTag = 14;
                  break a;
                case REACT_LAZY_TYPE:
                  fiberTag = 16;
                  resolvedType = null;
                  break a;
              }
            resolvedType = "";
            if (void 0 === type4 || "object" === typeof type4 && null !== type4 && 0 === Object.keys(type4).length)
              resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            null === type4 ? pendingProps = "null" : isArrayImpl(type4) ? pendingProps = "array" : void 0 !== type4 && type4.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type4.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type4;
            (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
            fiberTag = 29;
            pendingProps = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType)
            );
            resolvedType = null;
        }
      key = createFiber(fiberTag, pendingProps, key, mode);
      key.elementType = type4;
      key.type = resolvedType;
      key.lanes = lanes;
      key._debugOwner = owner;
      return key;
    }
    function createFiberFromElement(element, mode, lanes) {
      mode = createFiberFromTypeAndProps(
        element.type,
        element.key,
        element.props,
        element._owner,
        mode,
        lanes
      );
      mode._debugOwner = element._owner;
      mode._debugStack = element._debugStack;
      mode._debugTask = element._debugTask;
      return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
      elements = createFiber(7, elements, key, mode);
      elements.lanes = lanes;
      return elements;
    }
    function createFiberFromText(content2, mode, lanes) {
      content2 = createFiber(6, content2, null, mode);
      content2.lanes = lanes;
      return content2;
    }
    function createFiberFromPortal(portal, mode, lanes) {
      mode = createFiber(
        4,
        null !== portal.children ? portal.children : [],
        portal.key,
        mode
      );
      mode.lanes = lanes;
      mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
      };
      return mode;
    }
    function pushTreeFork(workInProgress2, totalChildren) {
      warnIfNotHydrating();
      forkStack[forkStackIndex++] = treeForkCount;
      forkStack[forkStackIndex++] = treeForkProvider;
      treeForkProvider = workInProgress2;
      treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress2, totalChildren, index2) {
      warnIfNotHydrating();
      idStack[idStackIndex++] = treeContextId;
      idStack[idStackIndex++] = treeContextOverflow;
      idStack[idStackIndex++] = treeContextProvider;
      treeContextProvider = workInProgress2;
      var baseIdWithLeadingBit = treeContextId;
      workInProgress2 = treeContextOverflow;
      var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
      baseIdWithLeadingBit &= ~(1 << baseLength);
      index2 += 1;
      var length2 = 32 - clz32(totalChildren) + baseLength;
      if (30 < length2) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length2 = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index2 << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length2 + workInProgress2;
      } else
        treeContextId = 1 << length2 | index2 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
    }
    function pushMaterializedTreeId(workInProgress2) {
      warnIfNotHydrating();
      null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
    }
    function popTreeContext(workInProgress2) {
      for (; workInProgress2 === treeForkProvider; )
        treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
      for (; workInProgress2 === treeContextProvider; )
        treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function warnIfNotHydrating() {
      isHydrating || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
      if (null === fiber.return) {
        if (null === hydrationDiffRootDEV)
          hydrationDiffRootDEV = {
            fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf
          };
        else {
          if (hydrationDiffRootDEV.fiber !== fiber)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
        }
        return hydrationDiffRootDEV;
      }
      var siblings = buildHydrationDiffNode(
        fiber.return,
        distanceFromLeaf + 1
      ).children;
      if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber)
        return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
      distanceFromLeaf = {
        fiber,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf
      };
      siblings.push(distanceFromLeaf);
      return distanceFromLeaf;
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
      didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
      var diff = "", diffRoot = hydrationDiffRootDEV;
      null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
      queueHydrationError(
        createCapturedValueAtFiber(
          Error(
            "Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff
          ),
          fiber
        )
      );
      throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
      var didHydrate = fiber.stateNode;
      var type4 = fiber.type, props = fiber.memoizedProps;
      didHydrate[internalInstanceKey] = fiber;
      didHydrate[internalPropsKey] = props;
      validatePropertiesInDevelopment(type4, props);
      switch (type4) {
        case "dialog":
          listenToNonDelegatedEvent("cancel", didHydrate);
          listenToNonDelegatedEvent("close", didHydrate);
          break;
        case "iframe":
        case "object":
        case "embed":
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "video":
        case "audio":
          for (type4 = 0; type4 < mediaEventTypes.length; type4++)
            listenToNonDelegatedEvent(mediaEventTypes[type4], didHydrate);
          break;
        case "source":
          listenToNonDelegatedEvent("error", didHydrate);
          break;
        case "img":
        case "image":
        case "link":
          listenToNonDelegatedEvent("error", didHydrate);
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", didHydrate);
          break;
        case "input":
          checkControlledValueProps("input", props);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateInputProps(didHydrate, props);
          initInput(
            didHydrate,
            props.value,
            props.defaultValue,
            props.checked,
            props.defaultChecked,
            props.type,
            props.name,
            true
          );
          track(didHydrate);
          break;
        case "option":
          validateOptionProps(didHydrate, props);
          break;
        case "select":
          checkControlledValueProps("select", props);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateSelectProps(didHydrate, props);
          break;
        case "textarea":
          checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(
            didHydrate,
            props.value,
            props.defaultValue,
            props.children
          ), track(didHydrate);
      }
      type4 = props.children;
      "string" !== typeof type4 && "number" !== typeof type4 && "bigint" !== typeof type4 || didHydrate.textContent === "" + type4 || true === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type4) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$12), didHydrate = true) : didHydrate = false;
      didHydrate || throwOnHydrationMismatch(fiber);
    }
    function popToNextHostParent(fiber) {
      for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
        switch (hydrationParentFiber.tag) {
          case 5:
          case 13:
            rootOrSingletonContext = false;
            return;
          case 27:
          case 3:
            rootOrSingletonContext = true;
            return;
          default:
            hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
      if (fiber !== hydrationParentFiber) return false;
      if (!isHydrating)
        return popToNextHostParent(fiber), isHydrating = true, false;
      var tag = fiber.tag, JSCompiler_temp;
      if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag)
          JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
      }
      if (JSCompiler_temp && nextHydratableInstance) {
        for (JSCompiler_temp = nextHydratableInstance; JSCompiler_temp; ) {
          var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
          diffNode.serverTail.push(description);
          JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterSuspenseInstance(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
        }
        throwOnHydrationMismatch(fiber);
      }
      popToNextHostParent(fiber);
      if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        nextHydratableInstance = getNextHydratableInstanceAfterSuspenseInstance(fiber);
      } else
        27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
      return true;
    }
    function resetHydrationState() {
      nextHydratableInstance = hydrationParentFiber = null;
      didSuspendOrErrorDEV = isHydrating = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
      var queuedErrors = hydrationErrors;
      null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
        workInProgressRootRecoverableErrors,
        queuedErrors
      ), hydrationErrors = null);
      return queuedErrors;
    }
    function queueHydrationError(error2) {
      null === hydrationErrors ? hydrationErrors = [error2] : hydrationErrors.push(error2);
    }
    function emitPendingHydrationWarnings() {
      var diffRoot = hydrationDiffRootDEV;
      if (null !== diffRoot) {
        hydrationDiffRootDEV = null;
        for (var diff = describeDiff(diffRoot); 0 < diffRoot.children.length; )
          diffRoot = diffRoot.children[0];
        runWithFiberInDEV(diffRoot.fiber, function() {
          console.error(
            "A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s",
            "https://react.dev/link/hydration-mismatch",
            diff
          );
        });
      }
    }
    function resetContextDependencies() {
      lastContextDependency = currentlyRenderingFiber$1 = null;
      isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context2, nextValue) {
      push(valueCursor, context2._currentValue, providerFiber);
      context2._currentValue = nextValue;
      push(rendererCursorDEV, context2._currentRenderer, providerFiber);
      void 0 !== context2._currentRenderer && null !== context2._currentRenderer && context2._currentRenderer !== rendererSigil && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      );
      context2._currentRenderer = rendererSigil;
    }
    function popProvider(context2, providerFiber) {
      context2._currentValue = valueCursor.current;
      var currentRenderer = rendererCursorDEV.current;
      pop(rendererCursorDEV, providerFiber);
      context2._currentRenderer = currentRenderer;
      pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
      for (; null !== parent; ) {
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
        if (parent === propagationRoot) break;
        parent = parent.return;
      }
      parent !== propagationRoot && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
      var fiber = workInProgress2.child;
      null !== fiber && (fiber.return = workInProgress2);
      for (; null !== fiber; ) {
        var list = fiber.dependencies;
        if (null !== list) {
          var nextFiber = fiber.child;
          list = list.firstContext;
          a: for (; null !== list; ) {
            var dependency = list;
            list = fiber;
            for (var i = 0; i < contexts.length; i++)
              if (dependency.context === contexts[i]) {
                list.lanes |= renderLanes2;
                dependency = list.alternate;
                null !== dependency && (dependency.lanes |= renderLanes2);
                scheduleContextWorkOnParentPath(
                  list.return,
                  renderLanes2,
                  workInProgress2
                );
                forcePropagateEntireTree || (nextFiber = null);
                break a;
              }
            list = dependency.next;
          }
        } else if (18 === fiber.tag) {
          nextFiber = fiber.return;
          if (null === nextFiber)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          nextFiber.lanes |= renderLanes2;
          list = nextFiber.alternate;
          null !== list && (list.lanes |= renderLanes2);
          scheduleContextWorkOnParentPath(
            nextFiber,
            renderLanes2,
            workInProgress2
          );
          nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else
          for (nextFiber = fiber; null !== nextFiber; ) {
            if (nextFiber === workInProgress2) {
              nextFiber = null;
              break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
              fiber.return = nextFiber.return;
              nextFiber = fiber;
              break;
            }
            nextFiber = nextFiber.return;
          }
        fiber = nextFiber;
      }
    }
    function propagateParentContextChanges(current2, workInProgress2, renderLanes2, forcePropagateEntireTree) {
      current2 = null;
      for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
        if (!isInsidePropagationBailout) {
          if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
          else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
          var currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent = currentParent.memoizedProps;
          if (null !== currentParent) {
            var context2 = parent.type;
            objectIs(parent.pendingProps.value, currentParent.value) || (null !== current2 ? current2.push(context2) : current2 = [context2]);
          }
        } else if (parent === hostTransitionProviderCursor.current) {
          currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current2 ? current2.push(HostTransitionContext) : current2 = [HostTransitionContext]);
        }
        parent = parent.return;
      }
      null !== current2 && propagateContextChanges(
        workInProgress2,
        current2,
        renderLanes2,
        forcePropagateEntireTree
      );
      workInProgress2.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
      for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
        if (!objectIs(
          currentDependencies.context._currentValue,
          currentDependencies.memoizedValue
        ))
          return true;
        currentDependencies = currentDependencies.next;
      }
      return false;
    }
    function prepareToReadContext(workInProgress2) {
      currentlyRenderingFiber$1 = workInProgress2;
      lastContextDependency = null;
      workInProgress2 = workInProgress2.dependencies;
      null !== workInProgress2 && (workInProgress2.firstContext = null);
    }
    function readContext(context2) {
      isDisallowedContextReadInDEV && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
      return readContextForConsumer(currentlyRenderingFiber$1, context2);
    }
    function readContextDuringReconciliation(consumer, context2) {
      null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
      return readContextForConsumer(consumer, context2);
    }
    function readContextForConsumer(consumer, context2) {
      var value = context2._currentValue;
      context2 = { context: context2, memoizedValue: value, next: null };
      if (null === lastContextDependency) {
        if (null === consumer)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        lastContextDependency = context2;
        consumer.dependencies = {
          lanes: 0,
          firstContext: context2,
          _debugThenableState: null
        };
        consumer.flags |= 524288;
      } else lastContextDependency = lastContextDependency.next = context2;
      return value;
    }
    function createCache3() {
      return {
        controller: new AbortControllerLocal(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function retainCache(cache2) {
      cache2.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      );
      cache2.refCount++;
    }
    function releaseCache(cache2) {
      cache2.refCount--;
      0 > cache2.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      );
      0 === cache2.refCount && scheduleCallback$2(NormalPriority, function() {
        cache2.controller.abort();
      });
    }
    function pushNestedEffectDurations() {
      var prevEffectDuration = profilerEffectDuration;
      profilerEffectDuration = 0;
      return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration = prevEffectDuration;
      return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration += prevEffectDuration;
      return elapsedTime;
    }
    function startProfilerTimer(fiber) {
      profilerStartTime = now();
      0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        fiber.selfBaseDuration = elapsedTime;
        profilerStartTime = -1;
      }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        profilerStartTime = -1;
      }
    }
    function recordEffectDuration() {
      if (0 <= profilerStartTime) {
        var elapsedTime = now() - profilerStartTime;
        profilerStartTime = -1;
        profilerEffectDuration += elapsedTime;
      }
    }
    function startEffectTimer() {
      profilerStartTime = now();
    }
    function transferActualDuration(fiber) {
      for (var child = fiber.child; child; )
        fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
      if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
          status: "pending",
          value: void 0,
          then: function(resolve) {
            entangledListeners.push(resolve);
          }
        };
      }
      currentEntangledPendingCount++;
      thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
      return thenable;
    }
    function pingEngtangledActionScope() {
      if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
      }
    }
    function chainThenableValue(thenable, result) {
      var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
          listeners.push(resolve);
        }
      };
      thenable.then(
        function() {
          thenableWithOverride.status = "fulfilled";
          thenableWithOverride.value = result;
          for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
        },
        function(error2) {
          thenableWithOverride.status = "rejected";
          thenableWithOverride.reason = error2;
          for (error2 = 0; error2 < listeners.length; error2++)
            (0, listeners[error2])(void 0);
        }
      );
      return thenableWithOverride;
    }
    function peekCacheFromPool() {
      var cacheResumedFromPreviousRender = resumedCache.current;
      return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
      null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
      var cacheFromPool = peekCacheFromPool();
      return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
    }
    function createThenableState() {
      return { didWarnAboutUncachedPromise: false, thenables: [] };
    }
    function isThenableResolved(thenable) {
      thenable = thenable.status;
      return "fulfilled" === thenable || "rejected" === thenable;
    }
    function noop$32() {
    }
    function trackUsedThenable(thenableState2, thenable, index2) {
      null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = true);
      var trackedThenables = thenableState2.thenables;
      index2 = trackedThenables[index2];
      void 0 === index2 ? trackedThenables.push(thenable) : index2 !== thenable && (thenableState2.didWarnAboutUncachedPromise || (thenableState2.didWarnAboutUncachedPromise = true, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), thenable.then(noop$32, noop$32), thenable = index2);
      switch (thenable.status) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        default:
          if ("string" === typeof thenable.status)
            thenable.then(noop$32, noop$32);
          else {
            thenableState2 = workInProgressRoot;
            if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            thenableState2 = thenable;
            thenableState2.status = "pending";
            thenableState2.then(
              function(fulfilledValue) {
                if ("pending" === thenable.status) {
                  var fulfilledThenable = thenable;
                  fulfilledThenable.status = "fulfilled";
                  fulfilledThenable.value = fulfilledValue;
                }
              },
              function(error2) {
                if ("pending" === thenable.status) {
                  var rejectedThenable = thenable;
                  rejectedThenable.status = "rejected";
                  rejectedThenable.reason = error2;
                }
              }
            );
          }
          switch (thenable.status) {
            case "fulfilled":
              return thenable.value;
            case "rejected":
              throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
          }
          suspendedThenable = thenable;
          needsToResetSuspendedThenableDEV = true;
          throw SuspenseException;
      }
    }
    function getSuspendedThenable() {
      if (null === suspendedThenable)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var thenable = suspendedThenable;
      suspendedThenable = null;
      needsToResetSuspendedThenableDEV = false;
      return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
      if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function initializeUpdateQueue(fiber) {
      fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function cloneUpdateQueue(current2, workInProgress2) {
      current2 = current2.updateQueue;
      workInProgress2.updateQueue === current2 && (workInProgress2.updateQueue = {
        baseState: current2.baseState,
        firstBaseUpdate: current2.firstBaseUpdate,
        lastBaseUpdate: current2.lastBaseUpdate,
        shared: current2.shared,
        callbacks: null
      });
    }
    function createUpdate(lane) {
      return {
        lane,
        tag: UpdateState,
        payload: null,
        callback: null,
        next: null
      };
    }
    function enqueueUpdate(fiber, update2, lane) {
      var updateQueue = fiber.updateQueue;
      if (null === updateQueue) return null;
      updateQueue = updateQueue.shared;
      if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
        var componentName2 = getComponentNameFromFiber(fiber);
        console.error(
          "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s",
          componentName2
        );
        didWarnUpdateInsideUpdate = true;
      }
      if ((executionContext & RenderContext) !== NoContext)
        return componentName2 = updateQueue.pending, null === componentName2 ? update2.next = update2 : (update2.next = componentName2.next, componentName2.next = update2), updateQueue.pending = update2, update2 = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update2;
      enqueueUpdate$1(fiber, updateQueue, update2, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root2, fiber, lane) {
      fiber = fiber.updateQueue;
      if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root2.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root2, lane);
      }
    }
    function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
      var queue = workInProgress2.updateQueue, current2 = workInProgress2.alternate;
      if (null !== current2 && (current2 = current2.updateQueue, queue === current2)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
          do {
            var clone = {
              lane: queue.lane,
              tag: queue.tag,
              payload: queue.payload,
              callback: null,
              next: null
            };
            null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
            queue = queue.next;
          } while (null !== queue);
          null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
          baseState: current2.baseState,
          firstBaseUpdate: newFirst,
          lastBaseUpdate: newLast,
          shared: current2.shared,
          callbacks: current2.callbacks
        };
        workInProgress2.updateQueue = queue;
        return;
      }
      workInProgress2 = queue.lastBaseUpdate;
      null === workInProgress2 ? queue.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
      queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
      if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
      }
    }
    function processUpdateQueue(workInProgress2, props, instance$jscomp$0, renderLanes2) {
      didReadFromEntangledAsyncAction = false;
      var queue = workInProgress2.updateQueue;
      hasForceUpdate = false;
      currentlyProcessingQueue = queue.shared;
      var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
      if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current2 = workInProgress2.alternate;
        null !== current2 && (current2 = current2.updateQueue, pendingQueue = current2.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current2.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current2.lastBaseUpdate = lastPendingUpdate));
      }
      if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current2 = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
          var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
          if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
            0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
            null !== current2 && (current2 = current2.next = {
              lane: 0,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: null,
              next: null
            });
            a: {
              updateLane = workInProgress2;
              var partialState = pendingQueue;
              var nextProps = props, instance = instance$jscomp$0;
              switch (partialState.tag) {
                case ReplaceState:
                  partialState = partialState.payload;
                  if ("function" === typeof partialState) {
                    isDisallowedContextReadInDEV = true;
                    var nextState = partialState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        partialState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                    newState = nextState;
                    break a;
                  }
                  newState = partialState;
                  break a;
                case CaptureUpdate:
                  updateLane.flags = updateLane.flags & -65537 | 128;
                case UpdateState:
                  nextState = partialState.payload;
                  if ("function" === typeof nextState) {
                    isDisallowedContextReadInDEV = true;
                    partialState = nextState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        nextState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                  } else partialState = nextState;
                  if (null === partialState || void 0 === partialState) break a;
                  newState = assign2({}, newState, partialState);
                  break a;
                case ForceUpdate:
                  hasForceUpdate = true;
              }
            }
            updateLane = pendingQueue.callback;
            null !== updateLane && (workInProgress2.flags |= 64, isHiddenUpdate && (workInProgress2.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
          } else
            isHiddenUpdate = {
              lane: updateLane,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: pendingQueue.callback,
              next: null
            }, null === current2 ? (firstPendingUpdate = current2 = isHiddenUpdate, lastPendingUpdate = newState) : current2 = current2.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
          pendingQueue = pendingQueue.next;
          if (null === pendingQueue)
            if (pendingQueue = queue.shared.pending, null === pendingQueue)
              break;
            else
              isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
        } while (1);
        null === current2 && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current2;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress2.lanes = lastBaseUpdate;
        workInProgress2.memoizedState = newState;
      }
      currentlyProcessingQueue = null;
    }
    function callCallback(callback, context2) {
      if ("function" !== typeof callback)
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + callback
        );
      callback.call(context2);
    }
    function commitHiddenCallbacks(updateQueue, context2) {
      var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
      if (null !== hiddenCallbacks)
        for (updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)
          callCallback(hiddenCallbacks[updateQueue], context2);
    }
    function commitCallbacks(updateQueue, context2) {
      var callbacks = updateQueue.callbacks;
      if (null !== callbacks)
        for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
          callCallback(callbacks[updateQueue], context2);
    }
    function pushHiddenContext(fiber, context2) {
      var prevEntangledRenderLanes = entangledRenderLanes;
      push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
      push(currentTreeHiddenStackCursor, context2, fiber);
      entangledRenderLanes = prevEntangledRenderLanes | context2.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
      push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
      push(
        currentTreeHiddenStackCursor,
        currentTreeHiddenStackCursor.current,
        fiber
      );
    }
    function popHiddenContext(fiber) {
      entangledRenderLanes = prevEntangledRenderLanesCursor.current;
      pop(currentTreeHiddenStackCursor, fiber);
      pop(prevEntangledRenderLanesCursor, fiber);
    }
    function mountHookTypesDev() {
      var hookName = currentHookNameInDev;
      null === hookTypesDev ? hookTypesDev = [hookName] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
      var hookName = currentHookNameInDev;
      if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
        var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName2) && (didWarnAboutMismatchedHooksForComponent.add(componentName2), null !== hookTypesDev)) {
          for (var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++) {
            var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
            for (oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length; )
              oldHookName += " ";
            oldHookName += newHookName + "\n";
            table += oldHookName;
          }
          console.error(
            "React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n",
            componentName2,
            table
          );
        }
      }
    }
    function checkDepsAreArrayDev(deps) {
      void 0 === deps || null === deps || isArrayImpl(deps) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        currentHookNameInDev,
        typeof deps
      );
    }
    function warnOnUseFormStateInDev() {
      var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
      didWarnAboutUseFormState.has(componentName2) || (didWarnAboutUseFormState.add(componentName2), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        componentName2
      ));
    }
    function throwInvalidHookError() {
      throw Error(
        "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
      );
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
      if (ignorePreviousDependencies) return false;
      if (null === prevDeps)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          currentHookNameInDev
        ), false;
      nextDeps.length !== prevDeps.length && console.error(
        "The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s",
        currentHookNameInDev,
        "[" + prevDeps.join(", ") + "]",
        "[" + nextDeps.join(", ") + "]"
      );
      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
        if (!objectIs(nextDeps[i], prevDeps[i])) return false;
      return true;
    }
    function renderWithHooks(current2, workInProgress2, Component2, props, secondArg, nextRenderLanes) {
      renderLanes = nextRenderLanes;
      currentlyRenderingFiber = workInProgress2;
      hookTypesDev = null !== current2 ? current2._debugHookTypes : null;
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current2 && current2.type !== workInProgress2.type;
      if ("[object AsyncFunction]" === Object.prototype.toString.call(Component2) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component2))
        nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error(
          "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
          null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"
        ));
      workInProgress2.memoizedState = null;
      workInProgress2.updateQueue = null;
      workInProgress2.lanes = 0;
      ReactSharedInternals.H = null !== current2 && null !== current2.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
      shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress2.mode & StrictLegacyMode) !== NoMode;
      var children2 = callComponentInDEV(Component2, props, secondArg);
      shouldDoubleInvokeUserFnsInHooksDEV = false;
      didScheduleRenderPhaseUpdateDuringThisPass && (children2 = renderWithHooksAgain(
        workInProgress2,
        Component2,
        props,
        secondArg
      ));
      if (nextRenderLanes) {
        setIsStrictModeForDevtools(true);
        try {
          children2 = renderWithHooksAgain(
            workInProgress2,
            Component2,
            props,
            secondArg
          );
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      finishRenderingHooks(current2, workInProgress2);
      return children2;
    }
    function finishRenderingHooks(current2, workInProgress2) {
      workInProgress2._debugHookTypes = hookTypesDev;
      null === workInProgress2.dependencies ? null !== thenableState$1 && (workInProgress2.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: thenableState$1
      }) : workInProgress2.dependencies._debugThenableState = thenableState$1;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
      renderLanes = 0;
      hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      null !== current2 && (current2.flags & 65011712) !== (workInProgress2.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      );
      didScheduleRenderPhaseUpdate = false;
      thenableIndexCounter$1 = 0;
      thenableState$1 = null;
      if (didRenderTooFewHooks)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      null === current2 || didReceiveUpdate || (current2 = current2.dependencies, null !== current2 && checkIfContextChanged(current2) && (didReceiveUpdate = true));
      needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = false, current2 = true) : current2 = false;
      current2 && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress2) || didWarnAboutAsyncClientComponent.has(workInProgress2) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress2), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function renderWithHooksAgain(workInProgress2, Component2, props, secondArg) {
      currentlyRenderingFiber = workInProgress2;
      var numberOfReRenders = 0;
      do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
        thenableIndexCounter$1 = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        if (numberOfReRenders >= RE_RENDER_LIMIT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        numberOfReRenders += 1;
        ignorePreviousDependencies = false;
        workInProgressHook = currentHook = null;
        if (null != workInProgress2.updateQueue) {
          var children2 = workInProgress2.updateQueue;
          children2.lastEffect = null;
          children2.events = null;
          children2.stores = null;
          null != children2.memoCache && (children2.memoCache.index = 0);
        }
        hookTypesUpdateIndexDev = -1;
        ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
        children2 = callComponentInDEV(Component2, props, secondArg);
      } while (didScheduleRenderPhaseUpdateDuringThisPass);
      return children2;
    }
    function TransitionAwareHostComponent() {
      var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
      maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
      dispatcher = dispatcher.useState()[0];
      (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
      return maybeThenable;
    }
    function checkDidRenderIdHook() {
      var didRenderIdHook = 0 !== localIdCounter;
      localIdCounter = 0;
      return didRenderIdHook;
    }
    function bailoutHooks(current2, workInProgress2, lanes) {
      workInProgress2.updateQueue = current2.updateQueue;
      workInProgress2.flags = (workInProgress2.mode & StrictEffectsMode) !== NoMode ? workInProgress2.flags & -402655237 : workInProgress2.flags & -2053;
      current2.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress2) {
      if (didScheduleRenderPhaseUpdate) {
        for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
          var queue = workInProgress2.queue;
          null !== queue && (queue.pending = null);
          workInProgress2 = workInProgress2.next;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      renderLanes = 0;
      hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      currentHookNameInDev = null;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      thenableIndexCounter$1 = localIdCounter = 0;
      thenableState$1 = null;
    }
    function mountWorkInProgressHook() {
      var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
      return workInProgressHook;
    }
    function updateWorkInProgressHook() {
      if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
      } else nextCurrentHook = currentHook.next;
      var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
      if (null !== nextWorkInProgressHook)
        workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
      else {
        if (null === nextCurrentHook) {
          if (null === currentlyRenderingFiber.alternate)
            throw Error(
              "Update hook called on initial render. This is likely a bug in React. Please file an issue."
            );
          throw Error("Rendered more hooks than during the previous render.");
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
          memoizedState: currentHook.memoizedState,
          baseState: currentHook.baseState,
          baseQueue: currentHook.baseQueue,
          queue: currentHook.queue,
          next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
      }
      return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function useThenable(thenable) {
      var index2 = thenableIndexCounter$1;
      thenableIndexCounter$1 += 1;
      null === thenableState$1 && (thenableState$1 = createThenableState());
      thenable = trackUsedThenable(thenableState$1, thenable, index2);
      index2 = currentlyRenderingFiber;
      null === (null === workInProgressHook ? index2.memoizedState : workInProgressHook.next) && (index2 = index2.alternate, ReactSharedInternals.H = null !== index2 && null !== index2.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
      return thenable;
    }
    function use(usable) {
      if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
      }
      throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size2) {
      var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
      null !== updateQueue && (memoCache = updateQueue.memoCache);
      if (null == memoCache) {
        var current2 = currentlyRenderingFiber.alternate;
        null !== current2 && (current2 = current2.updateQueue, null !== current2 && (current2 = current2.memoCache, null != current2 && (memoCache = {
          data: current2.data.map(function(array4) {
            return array4.slice();
          }),
          index: 0
        })));
      }
      null == memoCache && (memoCache = { data: [], index: 0 });
      null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
      updateQueue.memoCache = memoCache;
      updateQueue = memoCache.data[memoCache.index];
      if (void 0 === updateQueue || ignorePreviousDependencies)
        for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current2 = 0; current2 < size2; current2++)
          updateQueue[current2] = REACT_MEMO_CACHE_SENTINEL;
      else
        updateQueue.length !== size2 && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          updateQueue.length,
          size2
        );
      memoCache.index++;
      return updateQueue;
    }
    function basicStateReducer(state, action3) {
      return "function" === typeof action3 ? action3(state) : action3;
    }
    function mountReducer(reducer2, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer2 = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer2,
        lastRenderedState: initialState2
      };
      hook.queue = reducer2;
      reducer2 = reducer2.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer2
      );
      return [hook.memoizedState, reducer2];
    }
    function updateReducer(reducer2) {
      var hook = updateWorkInProgressHook();
      return updateReducerImpl(hook, currentHook, reducer2);
    }
    function updateReducerImpl(hook, current2, reducer2) {
      var queue = hook.queue;
      if (null === queue)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue.lastRenderedReducer = reducer2;
      var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
      if (null !== pendingQueue) {
        if (null !== baseQueue) {
          var baseFirst = baseQueue.next;
          baseQueue.next = pendingQueue.next;
          pendingQueue.next = baseFirst;
        }
        current2.baseQueue !== baseQueue && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        );
        current2.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
      }
      pendingQueue = hook.baseState;
      if (null === baseQueue) hook.memoizedState = pendingQueue;
      else {
        current2 = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update2 = current2, didReadFromEntangledAsyncAction2 = false;
        do {
          var updateLane = update2.lane & -536870913;
          if (updateLane !== update2.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
            var revertLane = update2.revertLane;
            if (0 === revertLane)
              null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                lane: 0,
                revertLane: 0,
                action: update2.action,
                hasEagerState: update2.hasEagerState,
                eagerState: update2.eagerState,
                next: null
              }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
            else if ((renderLanes & revertLane) === revertLane) {
              update2 = update2.next;
              revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
              continue;
            } else
              updateLane = {
                lane: 0,
                revertLane: update2.revertLane,
                action: update2.action,
                hasEagerState: update2.hasEagerState,
                eagerState: update2.eagerState,
                next: null
              }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
            updateLane = update2.action;
            shouldDoubleInvokeUserFnsInHooksDEV && reducer2(pendingQueue, updateLane);
            pendingQueue = update2.hasEagerState ? update2.eagerState : reducer2(pendingQueue, updateLane);
          } else
            revertLane = {
              lane: updateLane,
              revertLane: update2.revertLane,
              action: update2.action,
              hasEagerState: update2.hasEagerState,
              eagerState: update2.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
          update2 = update2.next;
        } while (null !== update2 && update2 !== current2);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction2 && (reducer2 = currentEntangledActionThenable, null !== reducer2)))
          throw reducer2;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
      }
      null === baseQueue && (queue.lanes = 0);
      return [hook.memoizedState, queue.dispatch];
    }
    function rerenderReducer(reducer2) {
      var hook = updateWorkInProgressHook(), queue = hook.queue;
      if (null === queue)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue.lastRenderedReducer = reducer2;
      var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
      if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update2 = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do
          newState = reducer2(newState, update2.action), update2 = update2.next;
        while (update2 !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
      }
      return [newState, dispatch];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var nextSnapshot = getServerSnapshot();
        didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      } else {
        nextSnapshot = getSnapshot();
        didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true));
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
      }
      hook.memoizedState = nextSnapshot;
      getServerSnapshot = { value: nextSnapshot, getSnapshot };
      hook.queue = getServerSnapshot;
      mountEffect(
        subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe),
        [subscribe]
      );
      fiber.flags |= 2048;
      pushSimpleEffect(
        HasEffect | Passive,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          getServerSnapshot,
          nextSnapshot,
          getSnapshot
        ),
        null
      );
      return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
      if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        getServerSnapshot = getServerSnapshot();
      } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
        var cachedSnapshot = getSnapshot();
        objectIs(getServerSnapshot, cachedSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      if (cachedSnapshot = !objectIs(
        (currentHook || hook).memoizedState,
        getServerSnapshot
      ))
        hook.memoizedState = getServerSnapshot, didReceiveUpdate = true;
      hook = hook.queue;
      var create = subscribeToStore.bind(null, fiber, hook, subscribe);
      updateEffectImpl(2048, Passive, create, [subscribe]);
      if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
        fiber.flags |= 2048;
        pushSimpleEffect(
          HasEffect | Passive,
          createEffectInstance(),
          updateStoreInstance.bind(
            null,
            fiber,
            hook,
            getServerSnapshot,
            getSnapshot
          ),
          null
        );
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
      fiber.flags |= 16384;
      fiber = { getSnapshot, value: renderedSnapshot };
      getSnapshot = currentlyRenderingFiber.updateQueue;
      null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
      inst.value = nextSnapshot;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
      return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
      });
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error2) {
        return true;
      }
    }
    function forceStoreRerender(fiber) {
      var root2 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2);
    }
    function mountStateImpl(initialState2) {
      var hook = mountWorkInProgressHook();
      if ("function" === typeof initialState2) {
        var initialStateInitializer = initialState2;
        initialState2 = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            initialStateInitializer();
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      }
      hook.memoizedState = hook.baseState = initialState2;
      hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState2
      };
      return hook;
    }
    function mountState(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    }
    function mountOptimistic(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    }
    function updateOptimistic(passthrough, reducer2) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer2);
    }
    function updateOptimisticImpl(hook, current2, passthrough, reducer2) {
      hook.baseState = passthrough;
      return updateReducerImpl(
        hook,
        currentHook,
        "function" === typeof reducer2 ? reducer2 : basicStateReducer
      );
    }
    function rerenderOptimistic(passthrough, reducer2) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer2);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
      if (isRenderPhaseUpdate(fiber))
        throw Error("Cannot update form state while rendering.");
      fiber = actionQueue.action;
      if (null !== fiber) {
        var actionNode = {
          payload,
          action: fiber,
          next: null,
          isTransition: true,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(listener) {
            actionNode.listeners.push(listener);
          }
        };
        null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
      }
    }
    function runActionStateAction(actionQueue, node2) {
      var action3 = node2.action, payload = node2.payload, prevState = actionQueue.state;
      if (node2.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        ReactSharedInternals.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var returnValue = action3(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
          null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
          handleActionReturnValue(actionQueue, node2, returnValue);
        } catch (error2) {
          onActionError(actionQueue, node2, error2);
        } finally {
          ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          currentTransition = action3(prevState, payload), handleActionReturnValue(actionQueue, node2, currentTransition);
        } catch (error$4) {
          onActionError(actionQueue, node2, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node2, returnValue) {
      null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (returnValue.then(
        function(nextState) {
          onActionSuccess(actionQueue, node2, nextState);
        },
        function(error2) {
          return onActionError(actionQueue, node2, error2);
        }
      ), node2.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : onActionSuccess(actionQueue, node2, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
      actionNode.status = "fulfilled";
      actionNode.value = nextState;
      notifyActionListeners(actionNode);
      actionQueue.state = nextState;
      actionNode = actionQueue.pending;
      null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error2) {
      var last = actionQueue.pending;
      actionQueue.pending = null;
      if (null !== last) {
        last = last.next;
        do
          actionNode.status = "rejected", actionNode.reason = error2, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
      }
      actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
      actionNode = actionNode.listeners;
      for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
      return newState;
    }
    function mountActionState(action3, initialStateProp) {
      if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
          a: {
            var isMatching = currentlyRenderingFiber;
            if (isHydrating) {
              if (nextHydratableInstance) {
                b: {
                  var markerInstance = nextHydratableInstance;
                  for (var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType; ) {
                    if (!inRootOrSingleton) {
                      markerInstance = null;
                      break b;
                    }
                    markerInstance = getNextHydratable(
                      markerInstance.nextSibling
                    );
                    if (null === markerInstance) {
                      markerInstance = null;
                      break b;
                    }
                  }
                  inRootOrSingleton = markerInstance.data;
                  markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                }
                if (markerInstance) {
                  nextHydratableInstance = getNextHydratable(
                    markerInstance.nextSibling
                  );
                  isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                  break a;
                }
              }
              throwOnHydrationMismatch(isMatching);
            }
            isMatching = false;
          }
          isMatching && (initialStateProp = ssrFormState[0]);
        }
      }
      ssrFormState = mountWorkInProgressHook();
      ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
      isMatching = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
      };
      ssrFormState.queue = isMatching;
      ssrFormState = dispatchSetState.bind(
        null,
        currentlyRenderingFiber,
        isMatching
      );
      isMatching.dispatch = ssrFormState;
      isMatching = mountStateImpl(false);
      inRootOrSingleton = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        false,
        isMatching.queue
      );
      isMatching = mountWorkInProgressHook();
      markerInstance = {
        state: initialStateProp,
        dispatch: null,
        action: action3,
        pending: null
      };
      isMatching.queue = markerInstance;
      ssrFormState = dispatchActionState.bind(
        null,
        currentlyRenderingFiber,
        markerInstance,
        inRootOrSingleton,
        ssrFormState
      );
      markerInstance.dispatch = ssrFormState;
      isMatching.memoizedState = action3;
      return [initialStateProp, ssrFormState, false];
    }
    function updateActionState(action3) {
      var stateHook = updateWorkInProgressHook();
      return updateActionStateImpl(stateHook, currentHook, action3);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action3) {
      currentStateHook = updateReducerImpl(
        stateHook,
        currentStateHook,
        actionStateReducer
      )[0];
      stateHook = updateReducer(basicStateReducer)[0];
      if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
        try {
          var state = useThenable(currentStateHook);
        } catch (x) {
          if (x === SuspenseException) throw SuspenseActionException;
          throw x;
        }
      else state = currentStateHook;
      currentStateHook = updateWorkInProgressHook();
      var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
      action3 !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
        HasEffect | Passive,
        createEffectInstance(),
        actionStateActionEffect.bind(null, actionQueue, action3),
        null
      ));
      return [state, dispatch, stateHook];
    }
    function actionStateActionEffect(actionQueue, action3) {
      actionQueue.action = action3;
    }
    function rerenderActionState(action3) {
      var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
      if (null !== currentStateHook)
        return updateActionStateImpl(stateHook, currentStateHook, action3);
      updateWorkInProgressHook();
      stateHook = stateHook.memoizedState;
      currentStateHook = updateWorkInProgressHook();
      var dispatch = currentStateHook.queue.dispatch;
      currentStateHook.memoizedState = action3;
      return [stateHook, dispatch, false];
    }
    function pushSimpleEffect(tag, inst, create, createDeps) {
      tag = {
        tag,
        create,
        deps: createDeps,
        inst,
        next: null
      };
      inst = currentlyRenderingFiber.updateQueue;
      null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
      create = inst.lastEffect;
      null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
      return tag;
    }
    function createEffectInstance() {
      return { destroy: void 0, resource: void 0 };
    }
    function mountRef(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
      var hook = mountWorkInProgressHook();
      createDeps = void 0 === createDeps ? null : createDeps;
      currentlyRenderingFiber.flags |= fiberFlags;
      hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        createEffectInstance(),
        create,
        createDeps
      );
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var inst = hook.memoizedState.inst;
      null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        inst,
        create,
        deps
      ));
    }
    function mountEffect(create, createDeps) {
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (currentlyRenderingFiber.mode & NoStrictPassiveEffectsMode) === NoMode ? mountEffectImpl(276826112, Passive, create, createDeps) : mountEffectImpl(8390656, Passive, create, createDeps);
    }
    function mountLayoutEffect(create, deps) {
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref2) {
      if ("function" === typeof ref2) {
        create = create();
        var refCleanup = ref2(create);
        return function() {
          "function" === typeof refCleanup ? refCleanup() : ref2(null);
        };
      }
      if (null !== ref2 && void 0 !== ref2)
        return ref2.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(ref2).join(", ") + "}"
        ), create = create(), ref2.current = create, function() {
          ref2.current = null;
        };
    }
    function mountImperativeHandle(ref2, create, deps) {
      "function" !== typeof create && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create ? typeof create : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref2]) : null;
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      mountEffectImpl(
        fiberFlags,
        Layout,
        imperativeHandleEffect.bind(null, create, ref2),
        deps
      );
    }
    function updateImperativeHandle(ref2, create, deps) {
      "function" !== typeof create && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create ? typeof create : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref2]) : null;
      updateEffectImpl(
        4,
        Layout,
        imperativeHandleEffect.bind(null, create, ref2),
        deps
      );
    }
    function mountCallback(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    }
    function updateCallback(callback, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      hook.memoizedState = [callback, deps];
      return callback;
    }
    function mountMemo(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    }
    function updateMemo(nextCreate, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      prevState = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [prevState, deps];
      return prevState;
    }
    function mountDeferredValue(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function rerenderDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
      if (void 0 === initialValue || 0 !== (renderLanes & 1073741824))
        return hook.memoizedState = value;
      hook.memoizedState = initialValue;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
      if (objectIs(value, prevValue)) return value;
      if (null !== currentTreeHiddenStackCursor.current)
        return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
      if (0 === (renderLanes & 42))
        return didReceiveUpdate = true, hook.memoizedState = value;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return prevValue;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
      var previousPriority = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      dispatchOptimisticSetState(fiber, false, queue, pendingState);
      currentTransition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
          var thenableForFinishedState = chainThenableValue(
            returnValue,
            finishedState
          );
          dispatchSetStateInternal(
            fiber,
            queue,
            thenableForFinishedState,
            requestUpdateLane(fiber)
          );
        } else
          dispatchSetStateInternal(
            fiber,
            queue,
            finishedState,
            requestUpdateLane(fiber)
          );
      } catch (error2) {
        dispatchSetStateInternal(
          fiber,
          queue,
          { then: function() {
          }, status: "rejected", reason: error2 },
          requestUpdateLane(fiber)
        );
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function startHostTransition(formFiber, pendingState, action3, formData) {
      if (5 !== formFiber.tag)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var queue = ensureFormComponentIsStateful(formFiber).queue;
      startTransition(
        formFiber,
        queue,
        pendingState,
        NotPendingTransition,
        null === action3 ? noop$22 : function() {
          requestFormReset$1(formFiber);
          return action3(formData);
        }
      );
    }
    function ensureFormComponentIsStateful(formFiber) {
      var existingStateHook = formFiber.memoizedState;
      if (null !== existingStateHook) return existingStateHook;
      existingStateHook = {
        memoizedState: NotPendingTransition,
        baseState: NotPendingTransition,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: NotPendingTransition
        },
        next: null
      };
      var initialResetState = {};
      existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialResetState
        },
        next: null
      };
      formFiber.memoizedState = existingStateHook;
      formFiber = formFiber.alternate;
      null !== formFiber && (formFiber.memoizedState = existingStateHook);
      return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
      null === ReactSharedInternals.T && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
      dispatchSetStateInternal(
        formFiber,
        resetStateQueue,
        {},
        requestUpdateLane(formFiber)
      );
    }
    function mountTransition() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    }
    function updateTransition() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start2 = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start2
      ];
    }
    function rerenderTransition() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start2 = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start2
      ];
    }
    function useHostTransitionStatus() {
      return readContext(HostTransitionContext);
    }
    function mountId() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var treeId = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
        identifierPrefix = "«" + identifierPrefix + "R" + treeId;
        treeId = localIdCounter++;
        0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
        identifierPrefix += "»";
      } else
        treeId = globalClientIdCounter++, identifierPrefix = "«" + identifierPrefix + "r" + treeId.toString(32) + "»";
      return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    }
    function refreshCache(fiber, seedKey) {
      for (var provider = fiber.return; null !== provider; ) {
        switch (provider.tag) {
          case 24:
          case 3:
            var lane = requestUpdateLane(provider);
            fiber = createUpdate(lane);
            var root2 = enqueueUpdate(provider, fiber, lane);
            null !== root2 && (scheduleUpdateOnFiber(root2, provider, lane), entangleTransitions(root2, provider, lane));
            provider = createCache3();
            null !== seedKey && void 0 !== seedKey && null !== root2 && console.error(
              "The seed argument is not enabled outside experimental channels."
            );
            fiber.payload = { cache: provider };
            return;
        }
        provider = provider.return;
      }
    }
    function dispatchReducerAction(fiber, queue, action3) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      var update2 = {
        lane: args,
        revertLane: 0,
        action: action3,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update2) : (update2 = enqueueConcurrentHookUpdate(fiber, queue, update2, args), null !== update2 && (scheduleUpdateOnFiber(update2, fiber, args), entangleTransitionUpdate(update2, queue, args)));
      markStateUpdateScheduled(fiber, args);
    }
    function dispatchSetState(fiber, queue, action3) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      dispatchSetStateInternal(fiber, queue, action3, args);
      markStateUpdateScheduled(fiber, args);
    }
    function dispatchSetStateInternal(fiber, queue, action3, lane) {
      var update2 = {
        lane,
        revertLane: 0,
        action: action3,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update2);
      else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
          var prevDispatcher = ReactSharedInternals.H;
          ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
          try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action3);
            update2.hasEagerState = true;
            update2.eagerState = eagerState;
            if (objectIs(eagerState, currentState))
              return enqueueUpdate$1(fiber, queue, update2, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
          } catch (error2) {
          } finally {
            ReactSharedInternals.H = prevDispatcher;
          }
        }
        action3 = enqueueConcurrentHookUpdate(fiber, queue, update2, lane);
        if (null !== action3)
          return scheduleUpdateOnFiber(action3, fiber, lane), entangleTransitionUpdate(action3, queue, lane), true;
      }
      return false;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action3) {
      null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      );
      action3 = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action3,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        throwIfDuringRender = enqueueConcurrentHookUpdate(
          fiber,
          queue,
          action3,
          2
        ), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
      markStateUpdateScheduled(fiber, 2);
    }
    function isRenderPhaseUpdate(fiber) {
      var alternate = fiber.alternate;
      return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update2) {
      didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
      var pending = queue.pending;
      null === pending ? update2.next = update2 : (update2.next = pending.next, pending.next = update2);
      queue.pending = update2;
    }
    function entangleTransitionUpdate(root2, queue, lane) {
      if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root2.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root2, lane);
      }
    }
    function pushDebugInfo(debugInfo) {
      var previousDebugInfo = currentDebugInfo;
      null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
      return previousDebugInfo;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
      for (var keys2 = Object.keys(element.props), i = 0; i < keys2.length; i++) {
        var key = keys2[i];
        if ("children" !== key && "key" !== key) {
          null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
          runWithFiberInDEV(
            fiber,
            function(erroredKey) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                erroredKey
              );
            },
            key
          );
          break;
        }
      }
    }
    function unwrapThenable(thenable) {
      var index2 = thenableIndexCounter;
      thenableIndexCounter += 1;
      null === thenableState && (thenableState = createThenableState());
      return trackUsedThenable(thenableState, thenable, index2);
    }
    function coerceRef(workInProgress2, element) {
      element = element.props.ref;
      workInProgress2.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
      if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
        throw Error(
          'A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.'
        );
      returnFiber = Object.prototype.toString.call(newChild);
      throw Error(
        "Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = true, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)",
        invalidChild,
        invalidChild,
        invalidChild
      ) : console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>",
        invalidChild,
        invalidChild,
        parentName,
        invalidChild,
        parentName
      ));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = true, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error(
        "Symbols are not valid as a React child.\n  root.render(%s)",
        invalidChild
      ) : console.error(
        "Symbols are not valid as a React child.\n  <%s>%s</%s>",
        parentName,
        invalidChild,
        parentName
      ));
    }
    function createChildReconciler(shouldTrackSideEffects) {
      function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
          var deletions = returnFiber.deletions;
          null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
      }
      function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for (; null !== currentFirstChild; )
          deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
      }
      function mapRemainingChildren(currentFirstChild) {
        for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
          null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
      }
      function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
      }
      function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects)
          return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex)
          return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
      }
      function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
      }
      function updateTextNode(returnFiber, current2, textContent, lanes) {
        if (null === current2 || 6 !== current2.tag)
          return current2 = createFiberFromText(
            textContent,
            returnFiber.mode,
            lanes
          ), current2.return = returnFiber, current2._debugOwner = returnFiber, current2._debugTask = returnFiber._debugTask, current2._debugInfo = currentDebugInfo, current2;
        current2 = useFiber(current2, textContent);
        current2.return = returnFiber;
        current2._debugInfo = currentDebugInfo;
        return current2;
      }
      function updateElement(returnFiber, current2, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE2)
          return current2 = updateFragment(
            returnFiber,
            current2,
            element.props.children,
            lanes,
            element.key
          ), validateFragmentProps(element, current2, returnFiber), current2;
        if (null !== current2 && (current2.elementType === elementType || isCompatibleFamilyForHotReloading(current2, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && callLazyInitInDEV(elementType) === current2.type))
          return current2 = useFiber(current2, element.props), coerceRef(current2, element), current2.return = returnFiber, current2._debugOwner = element._owner, current2._debugInfo = currentDebugInfo, current2;
        current2 = createFiberFromElement(element, returnFiber.mode, lanes);
        coerceRef(current2, element);
        current2.return = returnFiber;
        current2._debugInfo = currentDebugInfo;
        return current2;
      }
      function updatePortal(returnFiber, current2, portal, lanes) {
        if (null === current2 || 4 !== current2.tag || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation)
          return current2 = createFiberFromPortal(portal, returnFiber.mode, lanes), current2.return = returnFiber, current2._debugInfo = currentDebugInfo, current2;
        current2 = useFiber(current2, portal.children || []);
        current2.return = returnFiber;
        current2._debugInfo = currentDebugInfo;
        return current2;
      }
      function updateFragment(returnFiber, current2, fragment, lanes, key) {
        if (null === current2 || 7 !== current2.tag)
          return current2 = createFiberFromFragment(
            fragment,
            returnFiber.mode,
            lanes,
            key
          ), current2.return = returnFiber, current2._debugOwner = returnFiber, current2._debugTask = returnFiber._debugTask, current2._debugInfo = currentDebugInfo, current2;
        current2 = useFiber(current2, fragment);
        current2.return = returnFiber;
        current2._debugInfo = currentDebugInfo;
        return current2;
      }
      function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return newChild = createFiberFromText(
            "" + newChild,
            returnFiber.mode,
            lanes
          ), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return lanes = createFiberFromElement(
                newChild,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
            case REACT_PORTAL_TYPE:
              return newChild = createFiberFromPortal(
                newChild,
                returnFiber.mode,
                lanes
              ), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
            case REACT_LAZY_TYPE:
              var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              newChild = callLazyInitInDEV(newChild);
              returnFiber = createChild(returnFiber, newChild, lanes);
              currentDebugInfo = _prevDebugInfo;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return lanes = createFiberFromFragment(
              newChild,
              returnFiber.mode,
              lanes,
              null
            ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(
              returnFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return createChild(
              returnFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber) : null;
            case REACT_PORTAL_TYPE:
              return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
            case REACT_LAZY_TYPE:
              return key = pushDebugInfo(newChild._debugInfo), newChild = callLazyInitInDEV(newChild), returnFiber = updateSlot(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
            if (null !== key) return null;
            key = pushDebugInfo(newChild._debugInfo);
            returnFiber = updateFragment(
              returnFiber,
              oldFiber,
              newChild,
              lanes,
              null
            );
            currentDebugInfo = key;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(
              returnFiber,
              oldFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = key, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateSlot(
              returnFiber,
              oldFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newIdx = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                newIdx,
                newChild,
                lanes
              ), currentDebugInfo = existingChildren, returnFiber;
            case REACT_PORTAL_TYPE:
              return existingChildren = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
            case REACT_LAZY_TYPE:
              var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
              newChild = callLazyInitInDEV(newChild);
              returnFiber = updateFromMap(
                existingChildren,
                returnFiber,
                newIdx,
                newChild,
                lanes
              );
              currentDebugInfo = _prevDebugInfo7;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(
              returnFiber,
              newIdx,
              newChild,
              lanes,
              null
            ), currentDebugInfo = existingChildren, returnFiber;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo7, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys) {
        if ("object" !== typeof child || null === child) return knownKeys;
        switch (child.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            warnForMissingKey(returnFiber, workInProgress2, child);
            var key = child.key;
            if ("string" !== typeof key) break;
            if (null === knownKeys) {
              knownKeys = /* @__PURE__ */ new Set();
              knownKeys.add(key);
              break;
            }
            if (!knownKeys.has(key)) {
              knownKeys.add(key);
              break;
            }
            runWithFiberInDEV(workInProgress2, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                key
              );
            });
            break;
          case REACT_LAZY_TYPE:
            child = callLazyInitInDEV(child), warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys);
        }
        return knownKeys;
      }
      function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for (var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(
            returnFiber,
            oldFiber,
            newChildren[newIdx],
            lanes
          );
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            newChildren[newIdx],
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; newIdx < newChildren.length; newIdx++)
            oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              newChildren[newIdx],
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            newChildren[newIdx],
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            newChildren[newIdx],
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren)
          throw Error("An iterable object provided no iterator.");
        for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            step.value,
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (step.done)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; !step.done; newIdx++, step = newChildren.next())
            oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              step.value,
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            step.value,
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            step.value,
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE2 && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              a: {
                for (var key = newChild.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === key) {
                    key = newChild.type;
                    if (key === REACT_FRAGMENT_TYPE2) {
                      if (7 === currentFirstChild.tag) {
                        deleteRemainingChildren(
                          returnFiber,
                          currentFirstChild.sibling
                        );
                        lanes = useFiber(
                          currentFirstChild,
                          newChild.props.children
                        );
                        lanes.return = returnFiber;
                        lanes._debugOwner = newChild._owner;
                        lanes._debugInfo = currentDebugInfo;
                        validateFragmentProps(newChild, lanes, returnFiber);
                        returnFiber = lanes;
                        break a;
                      }
                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(
                      currentFirstChild,
                      newChild
                    ) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && callLazyInitInDEV(key) === currentFirstChild.type) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(currentFirstChild, newChild.props);
                      coerceRef(lanes, newChild);
                      lanes.return = returnFiber;
                      lanes._debugOwner = newChild._owner;
                      lanes._debugInfo = currentDebugInfo;
                      returnFiber = lanes;
                      break a;
                    }
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  } else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                newChild.type === REACT_FRAGMENT_TYPE2 ? (lanes = createFiberFromFragment(
                  newChild.props.children,
                  returnFiber.mode,
                  lanes,
                  newChild.key
                ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(
                  newChild,
                  returnFiber.mode,
                  lanes
                ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
              }
              returnFiber = placeSingleChild(returnFiber);
              currentDebugInfo = prevDebugInfo;
              return returnFiber;
            case REACT_PORTAL_TYPE:
              a: {
                prevDebugInfo = newChild;
                for (newChild = prevDebugInfo.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === newChild)
                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        prevDebugInfo.children || []
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    } else {
                      deleteRemainingChildren(returnFiber, currentFirstChild);
                      break;
                    }
                  else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                lanes = createFiberFromPortal(
                  prevDebugInfo,
                  returnFiber.mode,
                  lanes
                );
                lanes.return = returnFiber;
                returnFiber = lanes;
              }
              return placeSingleChild(returnFiber);
            case REACT_LAZY_TYPE:
              return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = callLazyInitInDEV(newChild), returnFiber = reconcileChildFibersImpl(
                returnFiber,
                currentFirstChild,
                newChild,
                lanes
              ), currentDebugInfo = prevDebugInfo, returnFiber;
          }
          if (isArrayImpl(newChild))
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (getIteratorFn(newChild)) {
            prevDebugInfo = pushDebugInfo(newChild._debugInfo);
            key = getIteratorFn(newChild);
            if ("function" !== typeof key)
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var newChildren = key.call(newChild);
            if (newChildren === newChild) {
              if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren))
                didWarnAboutGenerators || console.error(
                  "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
                ), didWarnAboutGenerators = true;
            } else
              newChild.entries !== key || didWarnAboutMaps || (console.error(
                "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
              ), didWarnAboutMaps = true);
            returnFiber = reconcileChildrenIterator(
              returnFiber,
              currentFirstChild,
              newChildren,
              lanes
            );
            currentDebugInfo = prevDebugInfo;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(
            returnFiber,
            currentFirstChild.sibling
          ), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(
            prevDebugInfo,
            returnFiber.mode,
            lanes
          ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return deleteRemainingChildren(returnFiber, currentFirstChild);
      }
      return function(returnFiber, currentFirstChild, newChild, lanes) {
        var prevDebugInfo = currentDebugInfo;
        currentDebugInfo = null;
        try {
          thenableIndexCounter = 0;
          var firstChildFiber = reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
          thenableState = null;
          return firstChildFiber;
        } catch (x) {
          if (x === SuspenseException || x === SuspenseActionException) throw x;
          var fiber = createFiber(29, x, null, returnFiber.mode);
          fiber.lanes = lanes;
          fiber.return = returnFiber;
          var debugInfo = fiber._debugInfo = currentDebugInfo;
          fiber._debugOwner = returnFiber._debugOwner;
          fiber._debugTask = returnFiber._debugTask;
          if (null != debugInfo) {
            for (var i = debugInfo.length - 1; 0 <= i; i--)
              if ("string" === typeof debugInfo[i].stack) {
                fiber._debugOwner = debugInfo[i];
                fiber._debugTask = debugInfo[i].debugTask;
                break;
              }
          }
          return fiber;
        } finally {
          currentDebugInfo = prevDebugInfo;
        }
      };
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
      var current2 = handler.alternate;
      push(
        suspenseStackCursor,
        suspenseStackCursor.current & SubtreeSuspenseContextMask,
        handler
      );
      push(suspenseHandlerStackCursor, handler, handler);
      null === shellBoundary && (null === current2 || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current2.memoizedState && (shellBoundary = handler));
    }
    function pushOffscreenSuspenseHandler(fiber) {
      if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary) {
          var current2 = fiber.alternate;
          null !== current2 && null !== current2.memoizedState && (shellBoundary = fiber);
        }
      } else reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
      push(suspenseStackCursor, suspenseStackCursor.current, fiber);
      push(
        suspenseHandlerStackCursor,
        suspenseHandlerStackCursor.current,
        fiber
      );
    }
    function popSuspenseHandler(fiber) {
      pop(suspenseHandlerStackCursor, fiber);
      shellBoundary === fiber && (shellBoundary = null);
      pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
      for (var node2 = row; null !== node2; ) {
        if (13 === node2.tag) {
          var state = node2.memoizedState;
          if (null !== state && (state = state.dehydrated, null === state || state.data === SUSPENSE_PENDING_START_DATA || isSuspenseInstanceFallback(state)))
            return node2;
        } else if (19 === node2.tag && void 0 !== node2.memoizedProps.revealOrder) {
          if (0 !== (node2.flags & 128)) return node2;
        } else if (null !== node2.child) {
          node2.child.return = node2;
          node2 = node2.child;
          continue;
        }
        if (node2 === row) break;
        for (; null === node2.sibling; ) {
          if (null === node2.return || node2.return === row) return null;
          node2 = node2.return;
        }
        node2.sibling.return = node2.return;
        node2 = node2.sibling;
      }
      return null;
    }
    function warnOnInvalidCallback(callback) {
      if (null !== callback && "function" !== typeof callback) {
        var key = String(callback);
        didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          callback
        ));
      }
    }
    function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
      var prevState = workInProgress2.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
      if (workInProgress2.mode & StrictLegacyMode) {
        setIsStrictModeForDevtools(true);
        try {
          partialState = getDerivedStateFromProps(nextProps, prevState);
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        ctor
      )));
      prevState = null === partialState || void 0 === partialState ? prevState : assign2({}, prevState, partialState);
      workInProgress2.memoizedState = prevState;
      0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
      var instance = workInProgress2.stateNode;
      if ("function" === typeof instance.shouldComponentUpdate) {
        oldProps = instance.shouldComponentUpdate(
          newProps,
          newState,
          nextContext
        );
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            oldProps = instance.shouldComponentUpdate(
              newProps,
              newState,
              nextContext
            );
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        void 0 === oldProps && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          getComponentNameFromType(ctor) || "Component"
        );
        return oldProps;
      }
      return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual2(oldProps, newProps) || !shallowEqual2(oldState, newState) : true;
    }
    function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
      var oldState = instance.state;
      "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
      "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
      instance.state !== oldState && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress2) || (didWarnAboutStateAssignmentForComponent.add(workInProgress2), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        workInProgress2
      )), classComponentUpdater.enqueueReplaceState(
        instance,
        instance.state,
        null
      ));
    }
    function resolveClassComponentProps(Component2, baseProps) {
      var newProps = baseProps;
      if ("ref" in baseProps) {
        newProps = {};
        for (var propName in baseProps)
          "ref" !== propName && (newProps[propName] = baseProps[propName]);
      }
      if (Component2 = Component2.defaultProps) {
        newProps === baseProps && (newProps = assign2({}, newProps));
        for (var _propName in Component2)
          void 0 === newProps[_propName] && (newProps[_propName] = Component2[_propName]);
      }
      return newProps;
    }
    function defaultOnUncaughtError(error2) {
      reportGlobalError(error2);
      console.warn(
        "%s\n\n%s\n",
        componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.",
        "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries."
      );
    }
    function defaultOnCaughtError(error2) {
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
      if ("object" === typeof error2 && null !== error2 && "string" === typeof error2.environmentName) {
        var JSCompiler_inline_result = error2.environmentName;
        error2 = [
          "%o\n\n%s\n\n%s\n",
          error2,
          componentNameMessage,
          recreateMessage
        ].slice(0);
        "string" === typeof error2[0] ? error2.splice(
          0,
          1,
          badgeFormat + error2[0],
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        ) : error2.splice(
          0,
          0,
          badgeFormat,
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        );
        error2.unshift(console);
        JSCompiler_inline_result = bind2.apply(console.error, error2);
        JSCompiler_inline_result();
      } else
        console.error(
          "%o\n\n%s\n\n%s\n",
          error2,
          componentNameMessage,
          recreateMessage
        );
    }
    function defaultOnRecoverableError(error2) {
      reportGlobalError(error2);
    }
    function logUncaughtError(root2, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = null;
        var error2 = errorInfo.value;
        if (null !== ReactSharedInternals.actQueue)
          ReactSharedInternals.thrownErrors.push(error2);
        else {
          var onUncaughtError = root2.onUncaughtError;
          onUncaughtError(error2, { componentStack: errorInfo.stack });
        }
      } catch (e$5) {
        setTimeout(function() {
          throw e$5;
        });
      }
    }
    function logCaughtError(root2, boundary, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = getComponentNameFromFiber(boundary);
        var onCaughtError = root2.onCaughtError;
        onCaughtError(errorInfo.value, {
          componentStack: errorInfo.stack,
          errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
      } catch (e$6) {
        setTimeout(function() {
          throw e$6;
        });
      }
    }
    function createRootErrorUpdate(root2, errorInfo, lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      lane.payload = { element: null };
      lane.callback = function() {
        runWithFiberInDEV(errorInfo.source, logUncaughtError, root2, errorInfo);
      };
      return lane;
    }
    function createClassErrorUpdate(lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      return lane;
    }
    function initializeClassErrorUpdate(update2, root2, fiber, errorInfo) {
      var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
      if ("function" === typeof getDerivedStateFromError) {
        var error2 = errorInfo.value;
        update2.payload = function() {
          return getDerivedStateFromError(error2);
        };
        update2.callback = function() {
          markFailedErrorBoundaryForHotReloading(fiber);
          runWithFiberInDEV(
            errorInfo.source,
            logCaughtError,
            root2,
            fiber,
            errorInfo
          );
        };
      }
      var inst = fiber.stateNode;
      null !== inst && "function" === typeof inst.componentDidCatch && (update2.callback = function() {
        markFailedErrorBoundaryForHotReloading(fiber);
        runWithFiberInDEV(
          errorInfo.source,
          logCaughtError,
          root2,
          fiber,
          errorInfo
        );
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        callComponentDidCatchInDEV(this, errorInfo);
        "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          getComponentNameFromFiber(fiber) || "Unknown"
        );
      });
    }
    function throwException(root2, returnFiber, sourceFiber, value, rootRenderLanes) {
      sourceFiber.flags |= 32768;
      isDevToolsPresent && restorePendingUpdaters(root2, rootRenderLanes);
      if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(
          returnFiber,
          sourceFiber,
          rootRenderLanes,
          true
        );
        isHydrating && (didSuspendOrErrorDEV = true);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
          switch (sourceFiber.tag) {
            case 13:
              return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root2, value, rootRenderLanes)), false;
            case 22:
              return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([value])
              }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root2, value, rootRenderLanes)), false;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React."
          );
        }
        attachPingListener(root2, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return false;
      }
      if (isHydrating)
        return didSuspendOrErrorDEV = true, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: value }
            ),
            sourceFiber
          )
        )) : (value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: value }
            ),
            sourceFiber
          )
        ), root2 = root2.current.alternate, root2.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root2.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
          root2.stateNode,
          value,
          rootRenderLanes
        ), enqueueCapturedUpdate(root2, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), false;
      var error2 = createCapturedValueAtFiber(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: value }
        ),
        sourceFiber
      );
      null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [error2] : workInProgressRootConcurrentErrors.push(error2);
      workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
      if (null === returnFiber) return true;
      value = createCapturedValueAtFiber(value, sourceFiber);
      sourceFiber = returnFiber;
      do {
        switch (sourceFiber.tag) {
          case 3:
            return sourceFiber.flags |= 65536, root2 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root2, root2 = createRootErrorUpdate(
              sourceFiber.stateNode,
              value,
              root2
            ), enqueueCapturedUpdate(sourceFiber, root2), false;
          case 1:
            if (returnFiber = sourceFiber.type, error2 = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error2 && "function" === typeof error2.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error2))))
              return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
                rootRenderLanes,
                root2,
                sourceFiber,
                value
              ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
        }
        sourceFiber = sourceFiber.return;
      } while (null !== sourceFiber);
      return false;
    }
    function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
      workInProgress2.child = null === current2 ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
        workInProgress2,
        current2.child,
        nextChildren,
        renderLanes2
      );
    }
    function updateForwardRef(current2, workInProgress2, Component2, nextProps, renderLanes2) {
      Component2 = Component2.render;
      var ref2 = workInProgress2.ref;
      if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for (var key in nextProps)
          "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
      } else propsWithoutRef = nextProps;
      prepareToReadContext(workInProgress2);
      markComponentRenderStarted(workInProgress2);
      nextProps = renderWithHooks(
        current2,
        workInProgress2,
        Component2,
        propsWithoutRef,
        ref2,
        renderLanes2
      );
      key = checkDidRenderIdHook();
      markComponentRenderStopped();
      if (null !== current2 && !didReceiveUpdate)
        return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
      isHydrating && key && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateMemoComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
      if (null === current2) {
        var type4 = Component2.type;
        if ("function" === typeof type4 && !shouldConstruct(type4) && void 0 === type4.defaultProps && null === Component2.compare)
          return Component2 = resolveFunctionForHotReloading(type4), workInProgress2.tag = 15, workInProgress2.type = Component2, validateFunctionComponentInDev(workInProgress2, type4), updateSimpleMemoComponent(
            current2,
            workInProgress2,
            Component2,
            nextProps,
            renderLanes2
          );
        current2 = createFiberFromTypeAndProps(
          Component2.type,
          null,
          nextProps,
          workInProgress2,
          workInProgress2.mode,
          renderLanes2
        );
        current2.ref = workInProgress2.ref;
        current2.return = workInProgress2;
        return workInProgress2.child = current2;
      }
      type4 = current2.child;
      if (!checkScheduledUpdateOrContext(current2, renderLanes2)) {
        var prevProps = type4.memoizedProps;
        Component2 = Component2.compare;
        Component2 = null !== Component2 ? Component2 : shallowEqual2;
        if (Component2(prevProps, nextProps) && current2.ref === workInProgress2.ref)
          return bailoutOnAlreadyFinishedWork(
            current2,
            workInProgress2,
            renderLanes2
          );
      }
      workInProgress2.flags |= 1;
      current2 = createWorkInProgress(type4, nextProps);
      current2.ref = workInProgress2.ref;
      current2.return = workInProgress2;
      return workInProgress2.child = current2;
    }
    function updateSimpleMemoComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
      if (null !== current2) {
        var prevProps = current2.memoizedProps;
        if (shallowEqual2(prevProps, nextProps) && current2.ref === workInProgress2.ref && workInProgress2.type === current2.type)
          if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current2, renderLanes2))
            0 !== (current2.flags & 131072) && (didReceiveUpdate = true);
          else
            return workInProgress2.lanes = current2.lanes, bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
      }
      return updateFunctionComponent(
        current2,
        workInProgress2,
        Component2,
        nextProps,
        renderLanes2
      );
    }
    function updateOffscreenComponent(current2, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, nextChildren = nextProps.children, prevState = null !== current2 ? current2.memoizedState : null;
      if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress2.flags & 128)) {
          nextProps = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
          if (null !== current2) {
            nextChildren = workInProgress2.child = current2.child;
            for (prevState = 0; null !== nextChildren; )
              prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
            workInProgress2.childLanes = prevState & ~nextProps;
          } else workInProgress2.childLanes = 0, workInProgress2.child = null;
          return deferHiddenOffscreenComponent(
            current2,
            workInProgress2,
            nextProps,
            renderLanes2
          );
        }
        if (0 !== (renderLanes2 & 536870912))
          workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current2 && pushTransition(
            workInProgress2,
            null !== prevState ? prevState.cachePool : null
          ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(workInProgress2), pushOffscreenSuspenseHandler(workInProgress2);
        else
          return workInProgress2.lanes = workInProgress2.childLanes = 536870912, deferHiddenOffscreenComponent(
            current2,
            workInProgress2,
            null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
            renderLanes2
          );
      } else
        null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.memoizedState = null) : (null !== current2 && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(workInProgress2), reuseSuspenseHandlerOnStack(workInProgress2));
      reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function deferHiddenOffscreenComponent(current2, workInProgress2, nextBaseLanes, renderLanes2) {
      var JSCompiler_inline_result = peekCacheFromPool();
      JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
      };
      workInProgress2.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
      };
      null !== current2 && pushTransition(workInProgress2, null);
      reuseHiddenContextOnStack(workInProgress2);
      pushOffscreenSuspenseHandler(workInProgress2);
      null !== current2 && propagateParentContextChanges(current2, workInProgress2, renderLanes2, true);
      return null;
    }
    function markRef(current2, workInProgress2) {
      var ref2 = workInProgress2.ref;
      if (null === ref2)
        null !== current2 && null !== current2.ref && (workInProgress2.flags |= 4194816);
      else {
        if ("function" !== typeof ref2 && "object" !== typeof ref2)
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        if (null === current2 || current2.ref !== ref2)
          workInProgress2.flags |= 4194816;
      }
    }
    function updateFunctionComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
      if (Component2.prototype && "function" === typeof Component2.prototype.render) {
        var componentName2 = getComponentNameFromType(Component2) || "Unknown";
        didWarnAboutBadClass[componentName2] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          componentName2,
          componentName2
        ), didWarnAboutBadClass[componentName2] = true);
      }
      workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
        workInProgress2,
        null
      );
      null === current2 && (validateFunctionComponentInDev(workInProgress2, workInProgress2.type), Component2.contextTypes && (componentName2 = getComponentNameFromType(Component2) || "Unknown", didWarnAboutContextTypes[componentName2] || (didWarnAboutContextTypes[componentName2] = true, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        componentName2
      ))));
      prepareToReadContext(workInProgress2);
      markComponentRenderStarted(workInProgress2);
      Component2 = renderWithHooks(
        current2,
        workInProgress2,
        Component2,
        nextProps,
        void 0,
        renderLanes2
      );
      nextProps = checkDidRenderIdHook();
      markComponentRenderStopped();
      if (null !== current2 && !didReceiveUpdate)
        return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
      isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current2, workInProgress2, Component2, renderLanes2);
      return workInProgress2.child;
    }
    function replayFunctionComponent(current2, workInProgress2, nextProps, Component2, secondArg, renderLanes2) {
      prepareToReadContext(workInProgress2);
      markComponentRenderStarted(workInProgress2);
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current2 && current2.type !== workInProgress2.type;
      workInProgress2.updateQueue = null;
      nextProps = renderWithHooksAgain(
        workInProgress2,
        Component2,
        nextProps,
        secondArg
      );
      finishRenderingHooks(current2, workInProgress2);
      Component2 = checkDidRenderIdHook();
      markComponentRenderStopped();
      if (null !== current2 && !didReceiveUpdate)
        return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
      isHydrating && Component2 && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateClassComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
      switch (shouldErrorImpl(workInProgress2)) {
        case false:
          var _instance = workInProgress2.stateNode, state = new workInProgress2.type(
            workInProgress2.memoizedProps,
            _instance.context
          ).state;
          _instance.updater.enqueueSetState(_instance, state, null);
          break;
        case true:
          workInProgress2.flags |= 128;
          workInProgress2.flags |= 65536;
          _instance = Error("Simulated error coming from DevTools");
          var lane = renderLanes2 & -renderLanes2;
          workInProgress2.lanes |= lane;
          state = workInProgressRoot;
          if (null === state)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          lane = createClassErrorUpdate(lane);
          initializeClassErrorUpdate(
            lane,
            state,
            workInProgress2,
            createCapturedValueAtFiber(_instance, workInProgress2)
          );
          enqueueCapturedUpdate(workInProgress2, lane);
      }
      prepareToReadContext(workInProgress2);
      if (null === workInProgress2.stateNode) {
        state = emptyContextObject;
        _instance = Component2.contextType;
        "contextType" in Component2 && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component2) && (didWarnAboutInvalidateContextType.add(Component2), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          getComponentNameFromType(Component2) || "Component",
          lane
        ));
        "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
        _instance = new Component2(nextProps, state);
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            _instance = new Component2(nextProps, state);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        state = workInProgress2.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
        _instance.updater = classComponentUpdater;
        workInProgress2.stateNode = _instance;
        _instance._reactInternals = workInProgress2;
        _instance._reactInternalInstance = fakeInternalInstance;
        "function" === typeof Component2.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component2) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          state,
          null === _instance.state ? "null" : "undefined",
          state
        )));
        if ("function" === typeof Component2.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
          var foundWillUpdateName = lane = state = null;
          "function" === typeof _instance.componentWillMount && true !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
          "function" === typeof _instance.componentWillReceiveProps && true !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
          "function" === typeof _instance.componentWillUpdate && true !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
          if (null !== state || null !== lane || null !== foundWillUpdateName) {
            _instance = getComponentNameFromType(Component2) || "Component";
            var newApiName = "function" === typeof Component2.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error(
              "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles",
              _instance,
              newApiName,
              null !== state ? "\n  " + state : "",
              null !== lane ? "\n  " + lane : "",
              null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""
            ));
          }
        }
        _instance = workInProgress2.stateNode;
        state = getComponentNameFromType(Component2) || "Component";
        _instance.render || (Component2.prototype && "function" === typeof Component2.prototype.render ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          state
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          state
        ));
        !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          state
        );
        _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          state
        );
        _instance.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          state
        );
        Component2.childContextTypes && !didWarnAboutChildContextTypes.has(Component2) && (didWarnAboutChildContextTypes.add(Component2), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          state
        ));
        Component2.contextTypes && !didWarnAboutContextTypes$1.has(Component2) && (didWarnAboutContextTypes$1.add(Component2), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          state
        ));
        "function" === typeof _instance.componentShouldUpdate && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          state
        );
        Component2.prototype && Component2.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          getComponentNameFromType(Component2) || "A pure component"
        );
        "function" === typeof _instance.componentDidUnmount && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          state
        );
        "function" === typeof _instance.componentDidReceiveProps && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          state
        );
        "function" === typeof _instance.componentWillRecieveProps && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          state
        );
        "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          state
        );
        lane = _instance.props !== nextProps;
        void 0 !== _instance.props && lane && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          state
        );
        _instance.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          state,
          state
        );
        "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component2) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component2), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          getComponentNameFromType(Component2)
        ));
        "function" === typeof _instance.getDerivedStateFromProps && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof _instance.getDerivedStateFromError && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof Component2.getSnapshotBeforeUpdate && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          state
        );
        (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
        "function" === typeof _instance.getChildContext && "object" !== typeof Component2.childContextTypes && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          state
        );
        _instance = workInProgress2.stateNode;
        _instance.props = nextProps;
        _instance.state = workInProgress2.memoizedState;
        _instance.refs = {};
        initializeUpdateQueue(workInProgress2);
        state = Component2.contextType;
        _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
        _instance.state === nextProps && (state = getComponentNameFromType(Component2) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          state
        )));
        workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
          workInProgress2,
          _instance
        );
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(
          workInProgress2,
          _instance
        );
        _instance.state = workInProgress2.memoizedState;
        state = Component2.getDerivedStateFromProps;
        "function" === typeof state && (applyDerivedStateFromProps(
          workInProgress2,
          Component2,
          state,
          nextProps
        ), _instance.state = workInProgress2.memoizedState);
        "function" === typeof Component2.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          getComponentNameFromFiber(workInProgress2) || "Component"
        ), classComponentUpdater.enqueueReplaceState(
          _instance,
          _instance.state,
          null
        )), processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress2.memoizedState);
        "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308);
        (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728);
        _instance = true;
      } else if (null === current2) {
        _instance = workInProgress2.stateNode;
        var unresolvedOldProps = workInProgress2.memoizedProps;
        lane = resolveClassComponentProps(Component2, unresolvedOldProps);
        _instance.props = lane;
        var oldContext = _instance.context;
        foundWillUpdateName = Component2.contextType;
        state = emptyContextObject;
        "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
        newApiName = Component2.getDerivedStateFromProps;
        foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
        foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          state
        );
        hasForceUpdate = false;
        var oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress2.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(
          workInProgress2,
          Component2,
          newApiName,
          nextProps
        ), oldContext = workInProgress2.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component2,
          lane,
          nextProps,
          oldState,
          oldContext,
          state
        )) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), _instance = false);
      } else {
        _instance = workInProgress2.stateNode;
        cloneUpdateQueue(current2, workInProgress2);
        state = workInProgress2.memoizedProps;
        foundWillUpdateName = resolveClassComponentProps(Component2, state);
        _instance.props = foundWillUpdateName;
        newApiName = workInProgress2.pendingProps;
        oldState = _instance.context;
        oldContext = Component2.contextType;
        lane = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
        unresolvedOldProps = Component2.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          lane
        );
        hasForceUpdate = false;
        oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress2.memoizedState;
        state !== newApiName || oldState !== newState || hasForceUpdate || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
          workInProgress2,
          Component2,
          unresolvedOldProps,
          nextProps
        ), newState = workInProgress2.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component2,
          foundWillUpdateName,
          nextProps,
          oldState,
          newState,
          lane
        ) || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(
          nextProps,
          newState,
          lane
        )), "function" === typeof _instance.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), _instance = false);
      }
      lane = _instance;
      markRef(current2, workInProgress2);
      state = 0 !== (workInProgress2.flags & 128);
      if (lane || state) {
        lane = workInProgress2.stateNode;
        setCurrentFiber(workInProgress2);
        if (state && "function" !== typeof Component2.getDerivedStateFromError)
          Component2 = null, profilerStartTime = -1;
        else {
          markComponentRenderStarted(workInProgress2);
          Component2 = callRenderInDEV(lane);
          if (workInProgress2.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
              callRenderInDEV(lane);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
          markComponentRenderStopped();
        }
        workInProgress2.flags |= 1;
        null !== current2 && state ? (workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          current2.child,
          null,
          renderLanes2
        ), workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          Component2,
          renderLanes2
        )) : reconcileChildren(current2, workInProgress2, Component2, renderLanes2);
        workInProgress2.memoizedState = lane.state;
        current2 = workInProgress2.child;
      } else
        current2 = bailoutOnAlreadyFinishedWork(
          current2,
          workInProgress2,
          renderLanes2
        );
      renderLanes2 = workInProgress2.stateNode;
      _instance && renderLanes2.props !== nextProps && (didWarnAboutReassigningProps || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        getComponentNameFromFiber(workInProgress2) || "a component"
      ), didWarnAboutReassigningProps = true);
      return current2;
    }
    function mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2) {
      resetHydrationState();
      workInProgress2.flags |= 256;
      reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function validateFunctionComponentInDev(workInProgress2, Component2) {
      Component2 && Component2.childContextTypes && console.error(
        "childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...",
        Component2.displayName || Component2.name || "Component"
      );
      "function" === typeof Component2.getDerivedStateFromProps && (workInProgress2 = getComponentNameFromType(Component2) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        workInProgress2
      ), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] = true));
      "object" === typeof Component2.contextType && null !== Component2.contextType && (Component2 = getComponentNameFromType(Component2) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component2] || (console.error(
        "%s: Function components do not support contextType.",
        Component2
      ), didWarnAboutContextTypeOnFunctionComponent[Component2] = true));
    }
    function mountSuspenseOffscreenState(renderLanes2) {
      return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
    }
    function getRemainingWorkInPrimaryTree(current2, primaryTreeDidDefer, renderLanes2) {
      current2 = null !== current2 ? current2.childLanes & ~renderLanes2 : 0;
      primaryTreeDidDefer && (current2 |= workInProgressDeferredLane);
      return current2;
    }
    function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
      var JSCompiler_object_inline_digest_2451;
      var JSCompiler_object_inline_stack_2452 = workInProgress2.pendingProps;
      shouldSuspendImpl(workInProgress2) && (workInProgress2.flags |= 128);
      var JSCompiler_object_inline_componentStack_2453 = false;
      var didSuspend = 0 !== (workInProgress2.flags & 128);
      (JSCompiler_object_inline_digest_2451 = didSuspend) || (JSCompiler_object_inline_digest_2451 = null !== current2 && null === current2.memoizedState ? false : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
      JSCompiler_object_inline_digest_2451 && (JSCompiler_object_inline_componentStack_2453 = true, workInProgress2.flags &= -129);
      JSCompiler_object_inline_digest_2451 = 0 !== (workInProgress2.flags & 32);
      workInProgress2.flags &= -33;
      if (null === current2) {
        if (isHydrating) {
          JSCompiler_object_inline_componentStack_2453 ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack(workInProgress2);
          if (isHydrating) {
            var JSCompiler_object_inline_message_2450 = nextHydratableInstance;
            var JSCompiler_temp;
            if (!(JSCompiler_temp = !JSCompiler_object_inline_message_2450)) {
              c: {
                var instance = JSCompiler_object_inline_message_2450;
                for (JSCompiler_temp = rootOrSingletonContext; 8 !== instance.nodeType; ) {
                  if (!JSCompiler_temp) {
                    JSCompiler_temp = null;
                    break c;
                  }
                  instance = getNextHydratable(instance.nextSibling);
                  if (null === instance) {
                    JSCompiler_temp = null;
                    break c;
                  }
                }
                JSCompiler_temp = instance;
              }
              null !== JSCompiler_temp ? (warnIfNotHydrating(), workInProgress2.memoizedState = {
                dehydrated: JSCompiler_temp,
                treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
                retryLane: 536870912,
                hydrationErrors: null
              }, instance = createFiber(18, null, null, NoMode), instance.stateNode = JSCompiler_temp, instance.return = workInProgress2, workInProgress2.child = instance, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, JSCompiler_temp = true) : JSCompiler_temp = false;
              JSCompiler_temp = !JSCompiler_temp;
            }
            JSCompiler_temp && (warnNonHydratedInstance(
              workInProgress2,
              JSCompiler_object_inline_message_2450
            ), throwOnHydrationMismatch(workInProgress2));
          }
          JSCompiler_object_inline_message_2450 = workInProgress2.memoizedState;
          if (null !== JSCompiler_object_inline_message_2450 && (JSCompiler_object_inline_message_2450 = JSCompiler_object_inline_message_2450.dehydrated, null !== JSCompiler_object_inline_message_2450))
            return isSuspenseInstanceFallback(JSCompiler_object_inline_message_2450) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912, null;
          popSuspenseHandler(workInProgress2);
        }
        JSCompiler_object_inline_message_2450 = JSCompiler_object_inline_stack_2452.children;
        JSCompiler_object_inline_stack_2452 = JSCompiler_object_inline_stack_2452.fallback;
        if (JSCompiler_object_inline_componentStack_2453)
          return reuseSuspenseHandlerOnStack(workInProgress2), JSCompiler_object_inline_componentStack_2453 = workInProgress2.mode, JSCompiler_object_inline_message_2450 = mountWorkInProgressOffscreenFiber(
            {
              mode: "hidden",
              children: JSCompiler_object_inline_message_2450
            },
            JSCompiler_object_inline_componentStack_2453
          ), JSCompiler_object_inline_stack_2452 = createFiberFromFragment(
            JSCompiler_object_inline_stack_2452,
            JSCompiler_object_inline_componentStack_2453,
            renderLanes2,
            null
          ), JSCompiler_object_inline_message_2450.return = workInProgress2, JSCompiler_object_inline_stack_2452.return = workInProgress2, JSCompiler_object_inline_message_2450.sibling = JSCompiler_object_inline_stack_2452, workInProgress2.child = JSCompiler_object_inline_message_2450, JSCompiler_object_inline_componentStack_2453 = workInProgress2.child, JSCompiler_object_inline_componentStack_2453.memoizedState = mountSuspenseOffscreenState(renderLanes2), JSCompiler_object_inline_componentStack_2453.childLanes = getRemainingWorkInPrimaryTree(
            current2,
            JSCompiler_object_inline_digest_2451,
            renderLanes2
          ), workInProgress2.memoizedState = SUSPENDED_MARKER, JSCompiler_object_inline_stack_2452;
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        return mountSuspensePrimaryChildren(
          workInProgress2,
          JSCompiler_object_inline_message_2450
        );
      }
      var prevState = current2.memoizedState;
      if (null !== prevState && (JSCompiler_object_inline_message_2450 = prevState.dehydrated, null !== JSCompiler_object_inline_message_2450)) {
        if (didSuspend)
          workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2
          )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.child = current2.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(workInProgress2), JSCompiler_object_inline_componentStack_2453 = JSCompiler_object_inline_stack_2452.fallback, JSCompiler_object_inline_message_2450 = workInProgress2.mode, JSCompiler_object_inline_stack_2452 = mountWorkInProgressOffscreenFiber(
            {
              mode: "visible",
              children: JSCompiler_object_inline_stack_2452.children
            },
            JSCompiler_object_inline_message_2450
          ), JSCompiler_object_inline_componentStack_2453 = createFiberFromFragment(
            JSCompiler_object_inline_componentStack_2453,
            JSCompiler_object_inline_message_2450,
            renderLanes2,
            null
          ), JSCompiler_object_inline_componentStack_2453.flags |= 2, JSCompiler_object_inline_stack_2452.return = workInProgress2, JSCompiler_object_inline_componentStack_2453.return = workInProgress2, JSCompiler_object_inline_stack_2452.sibling = JSCompiler_object_inline_componentStack_2453, workInProgress2.child = JSCompiler_object_inline_stack_2452, reconcileChildFibers(
            workInProgress2,
            current2.child,
            null,
            renderLanes2
          ), JSCompiler_object_inline_stack_2452 = workInProgress2.child, JSCompiler_object_inline_stack_2452.memoizedState = mountSuspenseOffscreenState(renderLanes2), JSCompiler_object_inline_stack_2452.childLanes = getRemainingWorkInPrimaryTree(
            current2,
            JSCompiler_object_inline_digest_2451,
            renderLanes2
          ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = JSCompiler_object_inline_componentStack_2453);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress2), isHydrating && console.error(
          "We should not be hydrating here. This is a bug in React. Please file a bug."
        ), isSuspenseInstanceFallback(JSCompiler_object_inline_message_2450)) {
          JSCompiler_object_inline_digest_2451 = JSCompiler_object_inline_message_2450.nextSibling && JSCompiler_object_inline_message_2450.nextSibling.dataset;
          if (JSCompiler_object_inline_digest_2451) {
            JSCompiler_temp = JSCompiler_object_inline_digest_2451.dgst;
            var message2 = JSCompiler_object_inline_digest_2451.msg;
            instance = JSCompiler_object_inline_digest_2451.stck;
            var componentStack = JSCompiler_object_inline_digest_2451.cstck;
          }
          JSCompiler_object_inline_message_2450 = message2;
          JSCompiler_object_inline_digest_2451 = JSCompiler_temp;
          JSCompiler_object_inline_stack_2452 = instance;
          JSCompiler_temp = JSCompiler_object_inline_componentStack_2453 = componentStack;
          JSCompiler_object_inline_componentStack_2453 = JSCompiler_object_inline_message_2450 ? Error(JSCompiler_object_inline_message_2450) : Error(
            "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."
          );
          JSCompiler_object_inline_componentStack_2453.stack = JSCompiler_object_inline_stack_2452 || "";
          JSCompiler_object_inline_componentStack_2453.digest = JSCompiler_object_inline_digest_2451;
          JSCompiler_object_inline_digest_2451 = void 0 === JSCompiler_temp ? null : JSCompiler_temp;
          JSCompiler_object_inline_stack_2452 = {
            value: JSCompiler_object_inline_componentStack_2453,
            source: null,
            stack: JSCompiler_object_inline_digest_2451
          };
          "string" === typeof JSCompiler_object_inline_digest_2451 && CapturedStacks.set(
            JSCompiler_object_inline_componentStack_2453,
            JSCompiler_object_inline_stack_2452
          );
          queueHydrationError(JSCompiler_object_inline_stack_2452);
          workInProgress2 = retrySuspenseComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2
          );
        } else if (didReceiveUpdate || propagateParentContextChanges(
          current2,
          workInProgress2,
          renderLanes2,
          false
        ), JSCompiler_object_inline_digest_2451 = 0 !== (renderLanes2 & current2.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2451) {
          JSCompiler_object_inline_digest_2451 = workInProgressRoot;
          if (null !== JSCompiler_object_inline_digest_2451 && (JSCompiler_object_inline_stack_2452 = renderLanes2 & -renderLanes2, JSCompiler_object_inline_stack_2452 = 0 !== (JSCompiler_object_inline_stack_2452 & 42) ? 1 : getBumpedLaneForHydrationByLane(
            JSCompiler_object_inline_stack_2452
          ), JSCompiler_object_inline_stack_2452 = 0 !== (JSCompiler_object_inline_stack_2452 & (JSCompiler_object_inline_digest_2451.suspendedLanes | renderLanes2)) ? 0 : JSCompiler_object_inline_stack_2452, 0 !== JSCompiler_object_inline_stack_2452 && JSCompiler_object_inline_stack_2452 !== prevState.retryLane))
            throw prevState.retryLane = JSCompiler_object_inline_stack_2452, enqueueConcurrentRenderForLane(
              current2,
              JSCompiler_object_inline_stack_2452
            ), scheduleUpdateOnFiber(
              JSCompiler_object_inline_digest_2451,
              current2,
              JSCompiler_object_inline_stack_2452
            ), SelectiveHydrationException;
          JSCompiler_object_inline_message_2450.data === SUSPENSE_PENDING_START_DATA || renderDidSuspendDelayIfPossible();
          workInProgress2 = retrySuspenseComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2
          );
        } else
          JSCompiler_object_inline_message_2450.data === SUSPENSE_PENDING_START_DATA ? (workInProgress2.flags |= 192, workInProgress2.child = current2.child, workInProgress2 = null) : (current2 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
            JSCompiler_object_inline_message_2450.nextSibling
          ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, rootOrSingletonContext = false, null !== current2 && (warnIfNotHydrating(), idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current2.id, treeContextOverflow = current2.overflow, treeContextProvider = workInProgress2), workInProgress2 = mountSuspensePrimaryChildren(
            workInProgress2,
            JSCompiler_object_inline_stack_2452.children
          ), workInProgress2.flags |= 4096);
        return workInProgress2;
      }
      if (JSCompiler_object_inline_componentStack_2453)
        return reuseSuspenseHandlerOnStack(workInProgress2), JSCompiler_object_inline_componentStack_2453 = JSCompiler_object_inline_stack_2452.fallback, JSCompiler_object_inline_message_2450 = workInProgress2.mode, JSCompiler_temp = current2.child, instance = JSCompiler_temp.sibling, JSCompiler_object_inline_stack_2452 = createWorkInProgress(
          JSCompiler_temp,
          {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2452.children
          }
        ), JSCompiler_object_inline_stack_2452.subtreeFlags = JSCompiler_temp.subtreeFlags & 65011712, null !== instance ? JSCompiler_object_inline_componentStack_2453 = createWorkInProgress(
          instance,
          JSCompiler_object_inline_componentStack_2453
        ) : (JSCompiler_object_inline_componentStack_2453 = createFiberFromFragment(
          JSCompiler_object_inline_componentStack_2453,
          JSCompiler_object_inline_message_2450,
          renderLanes2,
          null
        ), JSCompiler_object_inline_componentStack_2453.flags |= 2), JSCompiler_object_inline_componentStack_2453.return = workInProgress2, JSCompiler_object_inline_stack_2452.return = workInProgress2, JSCompiler_object_inline_stack_2452.sibling = JSCompiler_object_inline_componentStack_2453, workInProgress2.child = JSCompiler_object_inline_stack_2452, JSCompiler_object_inline_stack_2452 = JSCompiler_object_inline_componentStack_2453, JSCompiler_object_inline_componentStack_2453 = workInProgress2.child, JSCompiler_object_inline_message_2450 = current2.child.memoizedState, null === JSCompiler_object_inline_message_2450 ? JSCompiler_object_inline_message_2450 = mountSuspenseOffscreenState(renderLanes2) : (JSCompiler_temp = JSCompiler_object_inline_message_2450.cachePool, null !== JSCompiler_temp ? (instance = CacheContext._currentValue, JSCompiler_temp = JSCompiler_temp.parent !== instance ? { parent: instance, pool: instance } : JSCompiler_temp) : JSCompiler_temp = getSuspendedCache(), JSCompiler_object_inline_message_2450 = {
          baseLanes: JSCompiler_object_inline_message_2450.baseLanes | renderLanes2,
          cachePool: JSCompiler_temp
        }), JSCompiler_object_inline_componentStack_2453.memoizedState = JSCompiler_object_inline_message_2450, JSCompiler_object_inline_componentStack_2453.childLanes = getRemainingWorkInPrimaryTree(
          current2,
          JSCompiler_object_inline_digest_2451,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, JSCompiler_object_inline_stack_2452;
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      renderLanes2 = current2.child;
      current2 = renderLanes2.sibling;
      renderLanes2 = createWorkInProgress(renderLanes2, {
        mode: "visible",
        children: JSCompiler_object_inline_stack_2452.children
      });
      renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
      null !== current2 && (JSCompiler_object_inline_digest_2451 = workInProgress2.deletions, null === JSCompiler_object_inline_digest_2451 ? (workInProgress2.deletions = [current2], workInProgress2.flags |= 16) : JSCompiler_object_inline_digest_2451.push(current2));
      workInProgress2.child = renderLanes2;
      workInProgress2.memoizedState = null;
      return renderLanes2;
    }
    function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
      primaryChildren = mountWorkInProgressOffscreenFiber(
        { mode: "visible", children: primaryChildren },
        workInProgress2.mode
      );
      primaryChildren.return = workInProgress2;
      return workInProgress2.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
      offscreenProps = createFiber(22, offscreenProps, null, mode);
      offscreenProps.lanes = 0;
      offscreenProps.stateNode = {
        _visibility: OffscreenVisible,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      };
      return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2) {
      reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
      current2 = mountSuspensePrimaryChildren(
        workInProgress2,
        workInProgress2.pendingProps.children
      );
      current2.flags |= 2;
      workInProgress2.memoizedState = null;
      return current2;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
      fiber.lanes |= renderLanes2;
      var alternate = fiber.alternate;
      null !== alternate && (alternate.lanes |= renderLanes2);
      scheduleContextWorkOnParentPath(
        fiber.return,
        renderLanes2,
        propagationRoot
      );
    }
    function validateSuspenseListNestedChild(childSlot, index2) {
      var isAnArray = isArrayImpl(childSlot);
      childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
      return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        isAnArray,
        index2,
        isAnArray
      ), false) : true;
    }
    function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode) {
      var renderState = workInProgress2.memoizedState;
      null === renderState ? workInProgress2.memoizedState = {
        isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail,
        tailMode
      } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
    }
    function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
      nextProps = nextProps.children;
      if (void 0 !== revealOrder && "forwards" !== revealOrder && "backwards" !== revealOrder && "together" !== revealOrder && !didWarnAboutRevealOrder[revealOrder])
        if (didWarnAboutRevealOrder[revealOrder] = true, "string" === typeof revealOrder)
          switch (revealOrder.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                revealOrder
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
            revealOrder
          );
      void 0 === tailMode || didWarnAboutTailOptions[tailMode] || ("collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[tailMode] = true, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
        tailMode
      )) : "forwards" !== revealOrder && "backwards" !== revealOrder && (didWarnAboutTailOptions[tailMode] = true, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        tailMode
      )));
      a: if (("forwards" === revealOrder || "backwards" === revealOrder) && void 0 !== nextProps && null !== nextProps && false !== nextProps)
        if (isArrayImpl(nextProps))
          for (var i = 0; i < nextProps.length; i++) {
            if (!validateSuspenseListNestedChild(nextProps[i], i)) break a;
          }
        else if (i = getIteratorFn(nextProps), "function" === typeof i) {
          if (i = i.call(nextProps))
            for (var step = i.next(), _i = 0; !step.done; step = i.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i)) break a;
              _i++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            revealOrder
          );
      reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
      nextProps = suspenseStackCursor.current;
      if (0 !== (nextProps & ForceSuspenseFallback))
        nextProps = nextProps & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress2.flags |= 128;
      else {
        if (null !== current2 && 0 !== (current2.flags & 128))
          a: for (current2 = workInProgress2.child; null !== current2; ) {
            if (13 === current2.tag)
              null !== current2.memoizedState && scheduleSuspenseWorkOnFiber(
                current2,
                renderLanes2,
                workInProgress2
              );
            else if (19 === current2.tag)
              scheduleSuspenseWorkOnFiber(current2, renderLanes2, workInProgress2);
            else if (null !== current2.child) {
              current2.child.return = current2;
              current2 = current2.child;
              continue;
            }
            if (current2 === workInProgress2) break a;
            for (; null === current2.sibling; ) {
              if (null === current2.return || current2.return === workInProgress2)
                break a;
              current2 = current2.return;
            }
            current2.sibling.return = current2.return;
            current2 = current2.sibling;
          }
        nextProps &= SubtreeSuspenseContextMask;
      }
      push(suspenseStackCursor, nextProps, workInProgress2);
      switch (revealOrder) {
        case "forwards":
          renderLanes2 = workInProgress2.child;
          for (revealOrder = null; null !== renderLanes2; )
            current2 = renderLanes2.alternate, null !== current2 && null === findFirstSuspended(current2) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
          renderLanes2 = revealOrder;
          null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
          initSuspenseListRenderState(
            workInProgress2,
            false,
            revealOrder,
            renderLanes2,
            tailMode
          );
          break;
        case "backwards":
          renderLanes2 = null;
          revealOrder = workInProgress2.child;
          for (workInProgress2.child = null; null !== revealOrder; ) {
            current2 = revealOrder.alternate;
            if (null !== current2 && null === findFirstSuspended(current2)) {
              workInProgress2.child = revealOrder;
              break;
            }
            current2 = revealOrder.sibling;
            revealOrder.sibling = renderLanes2;
            renderLanes2 = revealOrder;
            revealOrder = current2;
          }
          initSuspenseListRenderState(
            workInProgress2,
            true,
            renderLanes2,
            null,
            tailMode
          );
          break;
        case "together":
          initSuspenseListRenderState(workInProgress2, false, null, null, void 0);
          break;
        default:
          workInProgress2.memoizedState = null;
      }
      return workInProgress2.child;
    }
    function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
      null !== current2 && (workInProgress2.dependencies = current2.dependencies);
      profilerStartTime = -1;
      workInProgressRootSkippedLanes |= workInProgress2.lanes;
      if (0 === (renderLanes2 & workInProgress2.childLanes))
        if (null !== current2) {
          if (propagateParentContextChanges(
            current2,
            workInProgress2,
            renderLanes2,
            false
          ), 0 === (renderLanes2 & workInProgress2.childLanes))
            return null;
        } else return null;
      if (null !== current2 && workInProgress2.child !== current2.child)
        throw Error("Resuming work not yet implemented.");
      if (null !== workInProgress2.child) {
        current2 = workInProgress2.child;
        renderLanes2 = createWorkInProgress(current2, current2.pendingProps);
        workInProgress2.child = renderLanes2;
        for (renderLanes2.return = workInProgress2; null !== current2.sibling; )
          current2 = current2.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current2, current2.pendingProps), renderLanes2.return = workInProgress2;
        renderLanes2.sibling = null;
      }
      return workInProgress2.child;
    }
    function checkScheduledUpdateOrContext(current2, renderLanes2) {
      if (0 !== (current2.lanes & renderLanes2)) return true;
      current2 = current2.dependencies;
      return null !== current2 && checkIfContextChanged(current2) ? true : false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current2, workInProgress2, renderLanes2) {
      switch (workInProgress2.tag) {
        case 3:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          pushProvider(
            workInProgress2,
            CacheContext,
            current2.memoizedState.cache
          );
          resetHydrationState();
          break;
        case 27:
        case 5:
          pushHostContext(workInProgress2);
          break;
        case 4:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          break;
        case 10:
          pushProvider(
            workInProgress2,
            workInProgress2.type,
            workInProgress2.memoizedProps.value
          );
          break;
        case 12:
          0 !== (renderLanes2 & workInProgress2.childLanes) && (workInProgress2.flags |= 4);
          workInProgress2.flags |= 2048;
          var stateNode = workInProgress2.stateNode;
          stateNode.effectDuration = -0;
          stateNode.passiveEffectDuration = -0;
          break;
        case 13:
          stateNode = workInProgress2.memoizedState;
          if (null !== stateNode) {
            if (null !== stateNode.dehydrated)
              return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
            if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
              return updateSuspenseComponent(
                current2,
                workInProgress2,
                renderLanes2
              );
            pushPrimaryTreeSuspenseHandler(workInProgress2);
            current2 = bailoutOnAlreadyFinishedWork(
              current2,
              workInProgress2,
              renderLanes2
            );
            return null !== current2 ? current2.sibling : null;
          }
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          break;
        case 19:
          var didSuspendBefore = 0 !== (current2.flags & 128);
          stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes);
          stateNode || (propagateParentContextChanges(
            current2,
            workInProgress2,
            renderLanes2,
            false
          ), stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes));
          if (didSuspendBefore) {
            if (stateNode)
              return updateSuspenseListComponent(
                current2,
                workInProgress2,
                renderLanes2
              );
            workInProgress2.flags |= 128;
          }
          didSuspendBefore = workInProgress2.memoizedState;
          null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
          push(
            suspenseStackCursor,
            suspenseStackCursor.current,
            workInProgress2
          );
          if (stateNode) break;
          else return null;
        case 22:
        case 23:
          return workInProgress2.lanes = 0, updateOffscreenComponent(current2, workInProgress2, renderLanes2);
        case 24:
          pushProvider(
            workInProgress2,
            CacheContext,
            current2.memoizedState.cache
          );
      }
      return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    }
    function beginWork(current2, workInProgress2, renderLanes2) {
      if (workInProgress2._debugNeedsRemount && null !== current2) {
        renderLanes2 = createFiberFromTypeAndProps(
          workInProgress2.type,
          workInProgress2.key,
          workInProgress2.pendingProps,
          workInProgress2._debugOwner || null,
          workInProgress2.mode,
          workInProgress2.lanes
        );
        renderLanes2._debugStack = workInProgress2._debugStack;
        renderLanes2._debugTask = workInProgress2._debugTask;
        var returnFiber = workInProgress2.return;
        if (null === returnFiber) throw Error("Cannot swap the root fiber.");
        current2.alternate = null;
        workInProgress2.alternate = null;
        renderLanes2.index = workInProgress2.index;
        renderLanes2.sibling = workInProgress2.sibling;
        renderLanes2.return = workInProgress2.return;
        renderLanes2.ref = workInProgress2.ref;
        renderLanes2._debugInfo = workInProgress2._debugInfo;
        if (workInProgress2 === returnFiber.child)
          returnFiber.child = renderLanes2;
        else {
          var prevSibling = returnFiber.child;
          if (null === prevSibling)
            throw Error("Expected parent to have a child.");
          for (; prevSibling.sibling !== workInProgress2; )
            if (prevSibling = prevSibling.sibling, null === prevSibling)
              throw Error("Expected to find the previous sibling.");
          prevSibling.sibling = renderLanes2;
        }
        workInProgress2 = returnFiber.deletions;
        null === workInProgress2 ? (returnFiber.deletions = [current2], returnFiber.flags |= 16) : workInProgress2.push(current2);
        renderLanes2.flags |= 2;
        return renderLanes2;
      }
      if (null !== current2)
        if (current2.memoizedProps !== workInProgress2.pendingProps || workInProgress2.type !== current2.type)
          didReceiveUpdate = true;
        else {
          if (!checkScheduledUpdateOrContext(current2, renderLanes2) && 0 === (workInProgress2.flags & 128))
            return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
              current2,
              workInProgress2,
              renderLanes2
            );
          didReceiveUpdate = 0 !== (current2.flags & 131072) ? true : false;
        }
      else {
        didReceiveUpdate = false;
        if (returnFiber = isHydrating)
          warnIfNotHydrating(), returnFiber = 0 !== (workInProgress2.flags & 1048576);
        returnFiber && (returnFiber = workInProgress2.index, warnIfNotHydrating(), pushTreeId(workInProgress2, treeForkCount, returnFiber));
      }
      workInProgress2.lanes = 0;
      switch (workInProgress2.tag) {
        case 16:
          a: if (returnFiber = workInProgress2.pendingProps, current2 = callLazyInitInDEV(workInProgress2.elementType), workInProgress2.type = current2, "function" === typeof current2)
            shouldConstruct(current2) ? (returnFiber = resolveClassComponentProps(
              current2,
              returnFiber
            ), workInProgress2.tag = 1, workInProgress2.type = current2 = resolveFunctionForHotReloading(current2), workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              current2,
              returnFiber,
              renderLanes2
            )) : (workInProgress2.tag = 0, validateFunctionComponentInDev(workInProgress2, current2), workInProgress2.type = current2 = resolveFunctionForHotReloading(current2), workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              current2,
              returnFiber,
              renderLanes2
            ));
          else {
            if (void 0 !== current2 && null !== current2) {
              if (prevSibling = current2.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2.type = current2 = resolveForwardRefForHotReloading(current2);
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  current2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (prevSibling === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  current2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = "";
            null !== current2 && "object" === typeof current2 && current2.$$typeof === REACT_LAZY_TYPE && (workInProgress2 = " Did you wrap a component in React.lazy() more than once?");
            current2 = getComponentNameFromType(current2) || current2;
            throw Error(
              "Element type is invalid. Received a promise that resolves to: " + current2 + ". Lazy element type must resolve to a class or function." + workInProgress2
            );
          }
          return workInProgress2;
        case 0:
          return updateFunctionComponent(
            current2,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 1:
          return returnFiber = workInProgress2.type, prevSibling = resolveClassComponentProps(
            returnFiber,
            workInProgress2.pendingProps
          ), updateClassComponent(
            current2,
            workInProgress2,
            returnFiber,
            prevSibling,
            renderLanes2
          );
        case 3:
          a: {
            pushHostContainer(
              workInProgress2,
              workInProgress2.stateNode.containerInfo
            );
            if (null === current2)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            returnFiber = workInProgress2.pendingProps;
            var prevState = workInProgress2.memoizedState;
            prevSibling = prevState.element;
            cloneUpdateQueue(current2, workInProgress2);
            processUpdateQueue(workInProgress2, returnFiber, null, renderLanes2);
            var nextState = workInProgress2.memoizedState;
            returnFiber = nextState.cache;
            pushProvider(workInProgress2, CacheContext, returnFiber);
            returnFiber !== prevState.cache && propagateContextChanges(
              workInProgress2,
              [CacheContext],
              renderLanes2,
              true
            );
            suspendIfUpdateReadFromEntangledAsyncAction();
            returnFiber = nextState.element;
            if (prevState.isDehydrated)
              if (prevState = {
                element: returnFiber,
                isDehydrated: false,
                cache: nextState.cache
              }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
                workInProgress2 = mountHostRootWithoutHydrating(
                  current2,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (returnFiber !== prevSibling) {
                prevSibling = createCapturedValueAtFiber(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  workInProgress2
                );
                queueHydrationError(prevSibling);
                workInProgress2 = mountHostRootWithoutHydrating(
                  current2,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else {
                current2 = workInProgress2.stateNode.containerInfo;
                switch (current2.nodeType) {
                  case 9:
                    current2 = current2.body;
                    break;
                  default:
                    current2 = "HTML" === current2.nodeName ? current2.ownerDocument.body : current2;
                }
                nextHydratableInstance = getNextHydratable(current2.firstChild);
                hydrationParentFiber = workInProgress2;
                isHydrating = true;
                hydrationErrors = null;
                didSuspendOrErrorDEV = false;
                hydrationDiffRootDEV = null;
                rootOrSingletonContext = true;
                current2 = mountChildFibers(
                  workInProgress2,
                  null,
                  returnFiber,
                  renderLanes2
                );
                for (workInProgress2.child = current2; current2; )
                  current2.flags = current2.flags & -3 | 4096, current2 = current2.sibling;
              }
            else {
              resetHydrationState();
              if (returnFiber === prevSibling) {
                workInProgress2 = bailoutOnAlreadyFinishedWork(
                  current2,
                  workInProgress2,
                  renderLanes2
                );
                break a;
              }
              reconcileChildren(
                current2,
                workInProgress2,
                returnFiber,
                renderLanes2
              );
            }
            workInProgress2 = workInProgress2.child;
          }
          return workInProgress2;
        case 26:
          return markRef(current2, workInProgress2), null === current2 ? (current2 = getResource(
            workInProgress2.type,
            null,
            workInProgress2.pendingProps,
            null
          )) ? workInProgress2.memoizedState = current2 : isHydrating || (current2 = workInProgress2.type, renderLanes2 = workInProgress2.pendingProps, returnFiber = requiredContext(
            rootInstanceStackCursor.current
          ), returnFiber = getOwnerDocumentFromRootContainer(
            returnFiber
          ).createElement(current2), returnFiber[internalInstanceKey] = workInProgress2, returnFiber[internalPropsKey] = renderLanes2, setInitialProperties(returnFiber, current2, renderLanes2), markNodeAsHoistable(returnFiber), workInProgress2.stateNode = returnFiber) : workInProgress2.memoizedState = getResource(
            workInProgress2.type,
            current2.memoizedProps,
            workInProgress2.pendingProps,
            current2.memoizedState
          ), null;
        case 27:
          return pushHostContext(workInProgress2), null === current2 && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress2.stateNode = resolveSingletonInstance(
            workInProgress2.type,
            workInProgress2.pendingProps,
            returnFiber,
            prevSibling,
            false
          ), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(
            returnFiber,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevSibling
          ), null !== prevSibling && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(
            returnFiber.firstChild
          )) : nextHydratableInstance = prevSibling), reconcileChildren(
            current2,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), markRef(current2, workInProgress2), null === current2 && (workInProgress2.flags |= 4194304), workInProgress2.child;
        case 5:
          return null === current2 && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(
            workInProgress2.type,
            prevState.ancestorInfo
          ), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(
            prevSibling,
            workInProgress2.type,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== nextState ? (workInProgress2.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(
            nextState,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevState
          ), null !== prevState && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevState)), hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(
            nextState.firstChild
          ), rootOrSingletonContext = false, prevState = true) : prevState = false, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress2, prevSibling), throwOnHydrationMismatch(workInProgress2))), pushHostContext(workInProgress2), prevSibling = workInProgress2.type, prevState = workInProgress2.pendingProps, nextState = null !== current2 ? current2.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress2.flags |= 32), null !== workInProgress2.memoizedState && (prevSibling = renderWithHooks(
            current2,
            workInProgress2,
            TransitionAwareHostComponent,
            null,
            null,
            renderLanes2
          ), HostTransitionContext._currentValue = prevSibling), markRef(current2, workInProgress2), reconcileChildren(
            current2,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 6:
          return null === current2 && isHydrating && (current2 = workInProgress2.pendingProps, renderLanes2 = getHostContext(), returnFiber = renderLanes2.ancestorInfo.current, current2 = null != returnFiber ? validateTextNesting(
            current2,
            returnFiber.tag,
            renderLanes2.ancestorInfo.implicitRootScope
          ) : true, renderLanes2 = nextHydratableInstance, (returnFiber = !renderLanes2) || (returnFiber = canHydrateTextInstance(
            renderLanes2,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== returnFiber ? (workInProgress2.stateNode = returnFiber, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, returnFiber = true) : returnFiber = false, returnFiber = !returnFiber), returnFiber && (current2 && warnNonHydratedInstance(workInProgress2, renderLanes2), throwOnHydrationMismatch(workInProgress2))), null;
        case 13:
          return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
        case 4:
          return pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          ), returnFiber = workInProgress2.pendingProps, null === current2 ? workInProgress2.child = reconcileChildFibers(
            workInProgress2,
            null,
            returnFiber,
            renderLanes2
          ) : reconcileChildren(
            current2,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 11:
          return updateForwardRef(
            current2,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 7:
          return reconcileChildren(
            current2,
            workInProgress2,
            workInProgress2.pendingProps,
            renderLanes2
          ), workInProgress2.child;
        case 8:
          return reconcileChildren(
            current2,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 12:
          return workInProgress2.flags |= 4, workInProgress2.flags |= 2048, returnFiber = workInProgress2.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(
            current2,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 10:
          return returnFiber = workInProgress2.type, prevSibling = workInProgress2.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = true, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), pushProvider(workInProgress2, returnFiber, prevState), reconcileChildren(
            current2,
            workInProgress2,
            prevSibling.children,
            renderLanes2
          ), workInProgress2.child;
        case 9:
          return prevSibling = workInProgress2.type._context, returnFiber = workInProgress2.pendingProps.children, "function" !== typeof returnFiber && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), prepareToReadContext(workInProgress2), prevSibling = readContext(prevSibling), markComponentRenderStarted(workInProgress2), returnFiber = callComponentInDEV(
            returnFiber,
            prevSibling,
            void 0
          ), markComponentRenderStopped(), workInProgress2.flags |= 1, reconcileChildren(
            current2,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 14:
          return updateMemoComponent(
            current2,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 15:
          return updateSimpleMemoComponent(
            current2,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 19:
          return updateSuspenseListComponent(
            current2,
            workInProgress2,
            renderLanes2
          );
        case 31:
          return returnFiber = workInProgress2.pendingProps, renderLanes2 = workInProgress2.mode, returnFiber = {
            mode: returnFiber.mode,
            children: returnFiber.children
          }, null === current2 ? (current2 = mountWorkInProgressOffscreenFiber(
            returnFiber,
            renderLanes2
          ), current2.ref = workInProgress2.ref, workInProgress2.child = current2, current2.return = workInProgress2, workInProgress2 = current2) : (current2 = createWorkInProgress(current2.child, returnFiber), current2.ref = workInProgress2.ref, workInProgress2.child = current2, current2.return = workInProgress2, workInProgress2 = current2), workInProgress2;
        case 22:
          return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
        case 24:
          return prepareToReadContext(workInProgress2), returnFiber = readContext(CacheContext), null === current2 ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache3(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes2), prevSibling = prevState), workInProgress2.memoizedState = {
            parent: returnFiber,
            cache: prevSibling
          }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, prevSibling)) : (0 !== (current2.lanes & renderLanes2) && (cloneUpdateQueue(current2, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current2.memoizedState, prevState = workInProgress2.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
            parent: returnFiber,
            cache: returnFiber
          }, workInProgress2.memoizedState = prevSibling, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = prevSibling), pushProvider(workInProgress2, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress2, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          ))), reconcileChildren(
            current2,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 29:
          throw workInProgress2.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function markUpdate(workInProgress2) {
      workInProgress2.flags |= 4;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
      if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded)
        workInProgress2.flags &= -16777217;
      else if (workInProgress2.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary))
          throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress2.flags |= 8192;
      }
    }
    function scheduleRetryEffect(workInProgress2, retryQueue) {
      null !== retryQueue && (workInProgress2.flags |= 4);
      workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
      if (!isHydrating)
        switch (renderState.tailMode) {
          case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for (var lastTailNode = null; null !== hasRenderedATailFallback; )
              null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
          case "collapsed":
            lastTailNode = renderState.tail;
            for (var _lastTailNode = null; null !== lastTailNode; )
              null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
      var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
      if (didBailout)
        if ((completedWork.mode & ProfileMode) !== NoMode) {
          for (var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2; )
            newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
          completedWork.treeBaseDuration = _treeBaseDuration;
        } else
          for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
            newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      else if ((completedWork.mode & ProfileMode) !== NoMode) {
        _treeBaseDuration = completedWork.actualDuration;
        _child2 = completedWork.selfBaseDuration;
        for (var child = completedWork.child; null !== child; )
          newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
        completedWork.actualDuration = _treeBaseDuration;
        completedWork.treeBaseDuration = _child2;
      } else
        for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
          newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      completedWork.subtreeFlags |= subtreeFlags;
      completedWork.childLanes = newChildLanes;
      return didBailout;
    }
    function completeWork(current2, workInProgress2, renderLanes2) {
      var newProps = workInProgress2.pendingProps;
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return bubbleProperties(workInProgress2), null;
        case 1:
          return bubbleProperties(workInProgress2), null;
        case 3:
          renderLanes2 = workInProgress2.stateNode;
          newProps = null;
          null !== current2 && (newProps = current2.memoizedState.cache);
          workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
          popProvider(CacheContext, workInProgress2);
          popHostContainer(workInProgress2);
          renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
          if (null === current2 || null === current2.child)
            popHydrationState(workInProgress2) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress2)) : null === current2 || current2.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
          bubbleProperties(workInProgress2);
          return null;
        case 26:
          return renderLanes2 = workInProgress2.memoizedState, null === current2 ? (markUpdate(workInProgress2), null !== renderLanes2 ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            renderLanes2
          )) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217)) : renderLanes2 ? renderLanes2 !== current2.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            renderLanes2
          )) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current2.memoizedProps !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217), null;
        case 27:
          popHostContext(workInProgress2);
          renderLanes2 = requiredContext(rootInstanceStackCursor.current);
          var _type = workInProgress2.type;
          if (null !== current2 && null != workInProgress2.stateNode)
            current2.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            current2 = getHostContext();
            popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current2 = resolveSingletonInstance(
              _type,
              newProps,
              renderLanes2,
              current2,
              true
            ), workInProgress2.stateNode = current2, markUpdate(workInProgress2));
          }
          bubbleProperties(workInProgress2);
          return null;
        case 5:
          popHostContext(workInProgress2);
          renderLanes2 = workInProgress2.type;
          if (null !== current2 && null != workInProgress2.stateNode)
            current2.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            _type = getHostContext();
            if (popHydrationState(workInProgress2))
              prepareToHydrateHostInstance(workInProgress2);
            else {
              current2 = requiredContext(rootInstanceStackCursor.current);
              validateDOMNesting(renderLanes2, _type.ancestorInfo);
              _type = _type.context;
              current2 = getOwnerDocumentFromRootContainer(current2);
              switch (_type) {
                case HostContextNamespaceSvg:
                  current2 = current2.createElementNS(SVG_NAMESPACE, renderLanes2);
                  break;
                case HostContextNamespaceMath:
                  current2 = current2.createElementNS(
                    MATH_NAMESPACE,
                    renderLanes2
                  );
                  break;
                default:
                  switch (renderLanes2) {
                    case "svg":
                      current2 = current2.createElementNS(
                        SVG_NAMESPACE,
                        renderLanes2
                      );
                      break;
                    case "math":
                      current2 = current2.createElementNS(
                        MATH_NAMESPACE,
                        renderLanes2
                      );
                      break;
                    case "script":
                      current2 = current2.createElement("div");
                      current2.innerHTML = "<script><\/script>";
                      current2 = current2.removeChild(current2.firstChild);
                      break;
                    case "select":
                      current2 = "string" === typeof newProps.is ? current2.createElement("select", { is: newProps.is }) : current2.createElement("select");
                      newProps.multiple ? current2.multiple = true : newProps.size && (current2.size = newProps.size);
                      break;
                    default:
                      current2 = "string" === typeof newProps.is ? current2.createElement(renderLanes2, {
                        is: newProps.is
                      }) : current2.createElement(renderLanes2), -1 === renderLanes2.indexOf("-") && (renderLanes2 !== renderLanes2.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        renderLanes2
                      ), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(current2) || hasOwnProperty.call(
                        warnedUnknownTags,
                        renderLanes2
                      ) || (warnedUnknownTags[renderLanes2] = true, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        renderLanes2
                      )));
                  }
              }
              current2[internalInstanceKey] = workInProgress2;
              current2[internalPropsKey] = newProps;
              a: for (_type = workInProgress2.child; null !== _type; ) {
                if (5 === _type.tag || 6 === _type.tag)
                  current2.appendChild(_type.stateNode);
                else if (4 !== _type.tag && 27 !== _type.tag && null !== _type.child) {
                  _type.child.return = _type;
                  _type = _type.child;
                  continue;
                }
                if (_type === workInProgress2) break a;
                for (; null === _type.sibling; ) {
                  if (null === _type.return || _type.return === workInProgress2)
                    break a;
                  _type = _type.return;
                }
                _type.sibling.return = _type.return;
                _type = _type.sibling;
              }
              workInProgress2.stateNode = current2;
              a: switch (setInitialProperties(current2, renderLanes2, newProps), renderLanes2) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  current2 = !!newProps.autoFocus;
                  break a;
                case "img":
                  current2 = true;
                  break a;
                default:
                  current2 = false;
              }
              current2 && markUpdate(workInProgress2);
            }
          }
          bubbleProperties(workInProgress2);
          workInProgress2.flags &= -16777217;
          return null;
        case 6:
          if (current2 && null != workInProgress2.stateNode)
            current2.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if ("string" !== typeof newProps && null === workInProgress2.stateNode)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            current2 = requiredContext(rootInstanceStackCursor.current);
            renderLanes2 = getHostContext();
            if (popHydrationState(workInProgress2)) {
              current2 = workInProgress2.stateNode;
              renderLanes2 = workInProgress2.memoizedProps;
              _type = !didSuspendOrErrorDEV;
              newProps = null;
              var returnFiber = hydrationParentFiber;
              if (null !== returnFiber)
                switch (returnFiber.tag) {
                  case 3:
                    _type && (_type = diffHydratedTextForDevWarnings(
                      current2,
                      renderLanes2,
                      newProps
                    ), null !== _type && (buildHydrationDiffNode(workInProgress2, 0).serverProps = _type));
                    break;
                  case 27:
                  case 5:
                    newProps = returnFiber.memoizedProps, _type && (_type = diffHydratedTextForDevWarnings(
                      current2,
                      renderLanes2,
                      newProps
                    ), null !== _type && (buildHydrationDiffNode(
                      workInProgress2,
                      0
                    ).serverProps = _type));
                }
              current2[internalInstanceKey] = workInProgress2;
              current2 = current2.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current2.nodeValue, renderLanes2) ? true : false;
              current2 || throwOnHydrationMismatch(workInProgress2);
            } else
              _type = renderLanes2.ancestorInfo.current, null != _type && validateTextNesting(
                newProps,
                _type.tag,
                renderLanes2.ancestorInfo.implicitRootScope
              ), current2 = getOwnerDocumentFromRootContainer(current2).createTextNode(
                newProps
              ), current2[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current2;
          }
          bubbleProperties(workInProgress2);
          return null;
        case 13:
          newProps = workInProgress2.memoizedState;
          if (null === current2 || null !== current2.memoizedState && null !== current2.memoizedState.dehydrated) {
            _type = popHydrationState(workInProgress2);
            if (null !== newProps && null !== newProps.dehydrated) {
              if (null === current2) {
                if (!_type)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                _type = workInProgress2.memoizedState;
                _type = null !== _type ? _type.dehydrated : null;
                if (!_type)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                _type[internalInstanceKey] = workInProgress2;
                bubbleProperties(workInProgress2);
                (workInProgress2.mode & ProfileMode) !== NoMode && null !== newProps && (_type = workInProgress2.child, null !== _type && (workInProgress2.treeBaseDuration -= _type.treeBaseDuration));
              } else
                emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4, bubbleProperties(workInProgress2), (workInProgress2.mode & ProfileMode) !== NoMode && null !== newProps && (_type = workInProgress2.child, null !== _type && (workInProgress2.treeBaseDuration -= _type.treeBaseDuration));
              _type = false;
            } else
              _type = upgradeHydrationErrorsToRecoverable(), null !== current2 && null !== current2.memoizedState && (current2.memoizedState.hydrationErrors = _type), _type = true;
            if (!_type) {
              if (workInProgress2.flags & 256)
                return popSuspenseHandler(workInProgress2), workInProgress2;
              popSuspenseHandler(workInProgress2);
              return null;
            }
          }
          popSuspenseHandler(workInProgress2);
          if (0 !== (workInProgress2.flags & 128))
            return workInProgress2.lanes = renderLanes2, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2;
          renderLanes2 = null !== newProps;
          current2 = null !== current2 && null !== current2.memoizedState;
          renderLanes2 && (newProps = workInProgress2.child, _type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (_type = newProps.alternate.memoizedState.cachePool.pool), returnFiber = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (returnFiber = newProps.memoizedState.cachePool.pool), returnFiber !== _type && (newProps.flags |= 2048));
          renderLanes2 !== current2 && renderLanes2 && (workInProgress2.child.flags |= 8192);
          scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
          bubbleProperties(workInProgress2);
          (workInProgress2.mode & ProfileMode) !== NoMode && renderLanes2 && (current2 = workInProgress2.child, null !== current2 && (workInProgress2.treeBaseDuration -= current2.treeBaseDuration));
          return null;
        case 4:
          return popHostContainer(workInProgress2), null === current2 && listenToAllSupportedEvents(
            workInProgress2.stateNode.containerInfo
          ), bubbleProperties(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), bubbleProperties(workInProgress2), null;
        case 19:
          pop(suspenseStackCursor, workInProgress2);
          _type = workInProgress2.memoizedState;
          if (null === _type) return bubbleProperties(workInProgress2), null;
          newProps = 0 !== (workInProgress2.flags & 128);
          returnFiber = _type.rendering;
          if (null === returnFiber)
            if (newProps) cutOffTailIfNeeded(_type, false);
            else {
              if (workInProgressRootExitStatus !== RootInProgress || null !== current2 && 0 !== (current2.flags & 128))
                for (current2 = workInProgress2.child; null !== current2; ) {
                  returnFiber = findFirstSuspended(current2);
                  if (null !== returnFiber) {
                    workInProgress2.flags |= 128;
                    cutOffTailIfNeeded(_type, false);
                    current2 = returnFiber.updateQueue;
                    workInProgress2.updateQueue = current2;
                    scheduleRetryEffect(workInProgress2, current2);
                    workInProgress2.subtreeFlags = 0;
                    current2 = renderLanes2;
                    for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                      resetWorkInProgress(renderLanes2, current2), renderLanes2 = renderLanes2.sibling;
                    push(
                      suspenseStackCursor,
                      suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback,
                      workInProgress2
                    );
                    return workInProgress2.child;
                  }
                  current2 = current2.sibling;
                }
              null !== _type.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(_type, false), workInProgress2.lanes = 4194304);
            }
          else {
            if (!newProps)
              if (current2 = findFirstSuspended(returnFiber), null !== current2) {
                if (workInProgress2.flags |= 128, newProps = true, current2 = current2.updateQueue, workInProgress2.updateQueue = current2, scheduleRetryEffect(workInProgress2, current2), cutOffTailIfNeeded(_type, true), null === _type.tail && "hidden" === _type.tailMode && !returnFiber.alternate && !isHydrating)
                  return bubbleProperties(workInProgress2), null;
              } else
                2 * now$1() - _type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(_type, false), workInProgress2.lanes = 4194304);
            _type.isBackwards ? (returnFiber.sibling = workInProgress2.child, workInProgress2.child = returnFiber) : (current2 = _type.last, null !== current2 ? current2.sibling = returnFiber : workInProgress2.child = returnFiber, _type.last = returnFiber);
          }
          if (null !== _type.tail)
            return current2 = _type.tail, _type.rendering = current2, _type.tail = current2.sibling, _type.renderingStartTime = now$1(), current2.sibling = null, renderLanes2 = suspenseStackCursor.current, renderLanes2 = newProps ? renderLanes2 & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes2 & SubtreeSuspenseContextMask, push(suspenseStackCursor, renderLanes2, workInProgress2), current2;
          bubbleProperties(workInProgress2);
          return null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), newProps = null !== workInProgress2.memoizedState, null !== current2 ? null !== current2.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (renderLanes2 = current2.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current2 && pop(resumedCache, workInProgress2), null;
        case 24:
          return renderLanes2 = null, null !== current2 && (renderLanes2 = current2.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext, workInProgress2), bubbleProperties(workInProgress2), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function unwindWork(current2, workInProgress2) {
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 1:
          return current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 3:
          return popProvider(CacheContext, workInProgress2), popHostContainer(workInProgress2), current2 = workInProgress2.flags, 0 !== (current2 & 65536) && 0 === (current2 & 128) ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
        case 26:
        case 27:
        case 5:
          return popHostContext(workInProgress2), null;
        case 13:
          popSuspenseHandler(workInProgress2);
          current2 = workInProgress2.memoizedState;
          if (null !== current2 && null !== current2.dehydrated) {
            if (null === workInProgress2.alternate)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            resetHydrationState();
          }
          current2 = workInProgress2.flags;
          return current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 19:
          return pop(suspenseStackCursor, workInProgress2), null;
        case 4:
          return popHostContainer(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), null !== current2 && pop(resumedCache, workInProgress2), current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 24:
          return popProvider(CacheContext, workInProgress2), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function unwindInterruptedWork(current2, interruptedWork) {
      popTreeContext(interruptedWork);
      switch (interruptedWork.tag) {
        case 3:
          popProvider(CacheContext, interruptedWork);
          popHostContainer(interruptedWork);
          break;
        case 26:
        case 27:
        case 5:
          popHostContext(interruptedWork);
          break;
        case 4:
          popHostContainer(interruptedWork);
          break;
        case 13:
          popSuspenseHandler(interruptedWork);
          break;
        case 19:
          pop(suspenseStackCursor, interruptedWork);
          break;
        case 10:
          popProvider(interruptedWork.type, interruptedWork);
          break;
        case 22:
        case 23:
          popSuspenseHandler(interruptedWork);
          popHiddenContext(interruptedWork);
          null !== current2 && pop(resumedCache, interruptedWork);
          break;
        case 24:
          popProvider(CacheContext, interruptedWork);
      }
    }
    function shouldProfile(current2) {
      return (current2.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitHookEffectListMount(flags2, finishedWork) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags2) === flags2 && ((flags2 & Passive) !== NoFlags ? null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted && injectedProfilingHooks.markComponentPassiveEffectMountStarted(
              finishedWork
            ) : (flags2 & Layout) !== NoFlags && null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted && injectedProfilingHooks.markComponentLayoutEffectMountStarted(
              finishedWork
            ), lastEffect = void 0, (flags2 & Insertion3) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = runWithFiberInDEV(
              finishedWork,
              callCreateInDEV,
              updateQueue
            ), (flags2 & Insertion3) !== NoFlags && (isRunningInsertionEffect = false), (flags2 & Passive) !== NoFlags ? null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped && injectedProfilingHooks.markComponentPassiveEffectMountStopped() : (flags2 & Layout) !== NoFlags && null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped && injectedProfilingHooks.markComponentLayoutEffectMountStopped(), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
              var hookName = void 0;
              hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion3) ? "useInsertionEffect" : "useEffect";
              var addendum = void 0;
              addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
              runWithFiberInDEV(
                finishedWork,
                function(n, a) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    n,
                    a
                  );
                },
                hookName,
                addendum
              );
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function commitHookEffectListUnmount(flags2, finishedWork, nearestMountedAncestor) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags2) === flags2) {
              var inst = updateQueue.inst, destroy = inst.destroy;
              void 0 !== destroy && (inst.destroy = void 0, (flags2 & Passive) !== NoFlags ? null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted && injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(
                finishedWork
              ) : (flags2 & Layout) !== NoFlags && null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted && injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(
                finishedWork
              ), (flags2 & Insertion3) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = finishedWork, runWithFiberInDEV(
                lastEffect,
                callDestroyInDEV,
                lastEffect,
                nearestMountedAncestor,
                destroy
              ), (flags2 & Insertion3) !== NoFlags && (isRunningInsertionEffect = false), (flags2 & Passive) !== NoFlags ? null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped && injectedProfilingHooks.markComponentPassiveEffectUnmountStopped() : (flags2 & Layout) !== NoFlags && null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped && injectedProfilingHooks.markComponentLayoutEffectUnmountStopped());
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitClassCallbacks(finishedWork) {
      var updateQueue = finishedWork.updateQueue;
      if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ), instance.state !== finishedWork.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ));
        try {
          runWithFiberInDEV(
            finishedWork,
            commitCallbacks,
            updateQueue,
            instance
          );
        } catch (error2) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error2);
        }
      }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
      return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current2) {
      var prevProps = current2.memoizedProps, prevState = current2.memoizedState;
      current2 = finishedWork.stateNode;
      finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current2.props !== finishedWork.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ), current2.state !== finishedWork.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ));
      try {
        var resolvedPrevProps = resolveClassComponentProps(
          finishedWork.type,
          prevProps,
          finishedWork.elementType === finishedWork.type
        );
        var snapshot = runWithFiberInDEV(
          finishedWork,
          callGetSnapshotBeforeUpdates,
          current2,
          resolvedPrevProps,
          prevState
        );
        prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
        void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            getComponentNameFromFiber(finishedWork)
          );
        }));
        current2.__reactInternalSnapshotBeforeUpdate = snapshot;
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function safelyCallComponentWillUnmount(current2, nearestMountedAncestor, instance) {
      instance.props = resolveClassComponentProps(
        current2.type,
        current2.memoizedProps
      );
      instance.state = current2.memoizedState;
      shouldProfile(current2) ? (startEffectTimer(), runWithFiberInDEV(
        current2,
        callComponentWillUnmountInDEV,
        current2,
        nearestMountedAncestor,
        instance
      ), recordEffectDuration()) : runWithFiberInDEV(
        current2,
        callComponentWillUnmountInDEV,
        current2,
        nearestMountedAncestor,
        instance
      );
    }
    function commitAttachRef(finishedWork) {
      var ref2 = finishedWork.ref;
      if (null !== ref2) {
        switch (finishedWork.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = finishedWork.stateNode;
            break;
          case 30:
            instanceToUse = finishedWork.stateNode;
            break;
          default:
            instanceToUse = finishedWork.stateNode;
        }
        if ("function" === typeof ref2)
          if (shouldProfile(finishedWork))
            try {
              startEffectTimer(), finishedWork.refCleanup = ref2(instanceToUse);
            } finally {
              recordEffectDuration();
            }
          else finishedWork.refCleanup = ref2(instanceToUse);
        else
          "string" === typeof ref2 ? console.error("String refs are no longer supported.") : ref2.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            getComponentNameFromFiber(finishedWork)
          ), ref2.current = instanceToUse;
      }
    }
    function safelyAttachRef(current2, nearestMountedAncestor) {
      try {
        runWithFiberInDEV(current2, commitAttachRef, current2);
      } catch (error2) {
        captureCommitPhaseError(current2, nearestMountedAncestor, error2);
      }
    }
    function safelyDetachRef(current2, nearestMountedAncestor) {
      var ref2 = current2.ref, refCleanup = current2.refCleanup;
      if (null !== ref2)
        if ("function" === typeof refCleanup)
          try {
            if (shouldProfile(current2))
              try {
                startEffectTimer(), runWithFiberInDEV(current2, refCleanup);
              } finally {
                recordEffectDuration(current2);
              }
            else runWithFiberInDEV(current2, refCleanup);
          } catch (error2) {
            captureCommitPhaseError(current2, nearestMountedAncestor, error2);
          } finally {
            current2.refCleanup = null, current2 = current2.alternate, null != current2 && (current2.refCleanup = null);
          }
        else if ("function" === typeof ref2)
          try {
            if (shouldProfile(current2))
              try {
                startEffectTimer(), runWithFiberInDEV(current2, ref2, null);
              } finally {
                recordEffectDuration(current2);
              }
            else runWithFiberInDEV(current2, ref2, null);
          } catch (error$7) {
            captureCommitPhaseError(current2, nearestMountedAncestor, error$7);
          }
        else ref2.current = null;
    }
    function commitProfiler(finishedWork, current2, commitStartTime2, effectDuration) {
      var _finishedWork$memoize = finishedWork.memoizedProps, id2 = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
      _finishedWork$memoize = _finishedWork$memoize.onRender;
      current2 = null === current2 ? "mount" : "update";
      currentUpdateIsNested && (current2 = "nested-update");
      "function" === typeof _finishedWork$memoize && _finishedWork$memoize(
        id2,
        current2,
        finishedWork.actualDuration,
        finishedWork.treeBaseDuration,
        finishedWork.actualStartTime,
        commitStartTime2
      );
      "function" === typeof onCommit && onCommit(
        finishedWork.memoizedProps.id,
        current2,
        effectDuration,
        commitStartTime2
      );
    }
    function commitProfilerPostCommitImpl(finishedWork, current2, commitStartTime2, passiveEffectDuration) {
      var _finishedWork$memoize2 = finishedWork.memoizedProps;
      finishedWork = _finishedWork$memoize2.id;
      _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
      current2 = null === current2 ? "mount" : "update";
      currentUpdateIsNested && (current2 = "nested-update");
      "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(
        finishedWork,
        current2,
        passiveEffectDuration,
        commitStartTime2
      );
    }
    function commitHostMount(finishedWork) {
      var type4 = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
      try {
        runWithFiberInDEV(
          finishedWork,
          commitMount,
          instance,
          type4,
          props,
          finishedWork
        );
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
      try {
        runWithFiberInDEV(
          finishedWork,
          commitUpdate,
          finishedWork.stateNode,
          finishedWork.type,
          oldProps,
          newProps,
          finishedWork
        );
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function isHostParent(fiber) {
      return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
      a: for (; ; ) {
        for (; null === fiber.sibling; ) {
          if (null === fiber.return || isHostParent(fiber.return)) return null;
          fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
          if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
          if (fiber.flags & 2) continue a;
          if (null === fiber.child || 4 === fiber.tag) continue a;
          else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
      }
    }
    function insertOrAppendPlacementNodeIntoContainer(node2, before, parent) {
      var tag = node2.tag;
      if (5 === tag || 6 === tag)
        node2 = node2.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node2, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node2), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$12));
      else if (4 !== tag && (27 === tag && isSingletonScope(node2.type) && (parent = node2.stateNode, before = null), node2 = node2.child, null !== node2))
        for (insertOrAppendPlacementNodeIntoContainer(node2, before, parent), node2 = node2.sibling; null !== node2; )
          insertOrAppendPlacementNodeIntoContainer(node2, before, parent), node2 = node2.sibling;
    }
    function insertOrAppendPlacementNode(node2, before, parent) {
      var tag = node2.tag;
      if (5 === tag || 6 === tag)
        node2 = node2.stateNode, before ? parent.insertBefore(node2, before) : parent.appendChild(node2);
      else if (4 !== tag && (27 === tag && isSingletonScope(node2.type) && (parent = node2.stateNode), node2 = node2.child, null !== node2))
        for (insertOrAppendPlacementNode(node2, before, parent), node2 = node2.sibling; null !== node2; )
          insertOrAppendPlacementNode(node2, before, parent), node2 = node2.sibling;
    }
    function commitPlacement(finishedWork) {
      for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
        if (isHostParent(parentFiber)) {
          hostParentFiber = parentFiber;
          break;
        }
        parentFiber = parentFiber.return;
      }
      if (null == hostParentFiber)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (hostParentFiber.tag) {
        case 27:
          hostParentFiber = hostParentFiber.stateNode;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        case 5:
          parentFiber = hostParentFiber.stateNode;
          hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
          hostParentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            hostParentFiber,
            parentFiber
          );
          break;
        case 3:
        case 4:
          hostParentFiber = hostParentFiber.stateNode.containerInfo;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNodeIntoContainer(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function commitHostSingletonAcquisition(finishedWork) {
      var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
      try {
        runWithFiberInDEV(
          finishedWork,
          acquireSingletonInstance,
          finishedWork.type,
          props,
          singleton,
          finishedWork
        );
      } catch (error2) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error2);
      }
    }
    function commitBeforeMutationEffects(root2, firstChild) {
      root2 = root2.containerInfo;
      eventsEnabled = _enabled;
      root2 = getActiveElementDeep(root2);
      if (hasSelectionCapabilities(root2)) {
        if ("selectionStart" in root2)
          var JSCompiler_temp = {
            start: root2.selectionStart,
            end: root2.selectionEnd
          };
        else
          a: {
            JSCompiler_temp = (JSCompiler_temp = root2.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
              JSCompiler_temp = selection.anchorNode;
              var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
              selection = selection.focusOffset;
              try {
                JSCompiler_temp.nodeType, focusNode.nodeType;
              } catch (e$2) {
                JSCompiler_temp = null;
                break a;
              }
              var length2 = 0, start2 = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node2 = root2, parentNode = null;
              b: for (; ; ) {
                for (var next4; ; ) {
                  node2 !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node2.nodeType || (start2 = length2 + anchorOffset);
                  node2 !== focusNode || 0 !== selection && 3 !== node2.nodeType || (end = length2 + selection);
                  3 === node2.nodeType && (length2 += node2.nodeValue.length);
                  if (null === (next4 = node2.firstChild)) break;
                  parentNode = node2;
                  node2 = next4;
                }
                for (; ; ) {
                  if (node2 === root2) break b;
                  parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start2 = length2);
                  parentNode === focusNode && ++indexWithinFocus === selection && (end = length2);
                  if (null !== (next4 = node2.nextSibling)) break;
                  node2 = parentNode;
                  parentNode = node2.parentNode;
                }
                node2 = next4;
              }
              JSCompiler_temp = -1 === start2 || -1 === end ? null : { start: start2, end };
            } else JSCompiler_temp = null;
          }
        JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
      } else JSCompiler_temp = null;
      selectionInformation = {
        focusedElem: root2,
        selectionRange: JSCompiler_temp
      };
      _enabled = false;
      for (nextEffect = firstChild; null !== nextEffect; )
        if (firstChild = nextEffect, root2 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root2)
          root2.return = firstChild, nextEffect = root2;
        else
          for (; null !== nextEffect; ) {
            root2 = firstChild = nextEffect;
            JSCompiler_temp = root2.alternate;
            anchorOffset = root2.flags;
            switch (root2.tag) {
              case 0:
                break;
              case 11:
              case 15:
                break;
              case 1:
                0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root2, JSCompiler_temp);
                break;
              case 3:
                if (0 !== (anchorOffset & 1024)) {
                  if (root2 = root2.stateNode.containerInfo, JSCompiler_temp = root2.nodeType, 9 === JSCompiler_temp)
                    clearContainerSparingly(root2);
                  else if (1 === JSCompiler_temp)
                    switch (root2.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        clearContainerSparingly(root2);
                        break;
                      default:
                        root2.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if (0 !== (anchorOffset & 1024))
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            root2 = firstChild.sibling;
            if (null !== root2) {
              root2.return = firstChild.return;
              nextEffect = root2;
              break;
            }
            nextEffect = firstChild.return;
          }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current2, finishedWork) {
      var flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags2 & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
          break;
        case 1:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags2 & 4)
            if (finishedRoot = finishedWork.stateNode, null === current2)
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              )), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              );
            else {
              var prevProps = resolveClassComponentProps(
                finishedWork.type,
                current2.memoizedProps
              );
              current2 = current2.memoizedState;
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ));
              shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current2,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current2,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            }
          flags2 & 64 && commitClassCallbacks(finishedWork);
          flags2 & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 3:
          current2 = pushNestedEffectDurations();
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags2 & 64 && (flags2 = finishedWork.updateQueue, null !== flags2)) {
            prevProps = null;
            if (null !== finishedWork.child)
              switch (finishedWork.child.tag) {
                case 27:
                case 5:
                  prevProps = finishedWork.child.stateNode;
                  break;
                case 1:
                  prevProps = finishedWork.child.stateNode;
              }
            try {
              runWithFiberInDEV(
                finishedWork,
                commitCallbacks,
                flags2,
                prevProps
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          }
          finishedRoot.effectDuration += popNestedEffectDurations(current2);
          break;
        case 27:
          null === current2 && flags2 & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          null === current2 && flags2 & 4 && commitHostMount(finishedWork);
          flags2 & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (flags2 & 4) {
            flags2 = pushNestedEffectDurations();
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            finishedRoot = finishedWork.stateNode;
            finishedRoot.effectDuration += bubbleNestedEffectDurations(flags2);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current2,
                commitStartTime,
                finishedRoot.effectDuration
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags2 & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          flags2 & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(
            null,
            finishedWork
          ), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
          break;
        case 22:
          flags2 = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
          if (!flags2) {
            current2 = null !== current2 && null !== current2.memoizedState || offscreenSubtreeWasHidden;
            prevProps = offscreenSubtreeIsHidden;
            var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = flags2;
            (offscreenSubtreeWasHidden = current2) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              0 !== (finishedWork.subtreeFlags & 8772)
            ) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            offscreenSubtreeIsHidden = prevProps;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          }
          break;
        case 30:
          break;
        default:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      }
    }
    function detachFiberAfterEffects(fiber) {
      var alternate = fiber.alternate;
      null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
      fiber.child = null;
      fiber.deletions = null;
      fiber.sibling = null;
      5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
      fiber.stateNode = null;
      fiber._debugOwner = null;
      fiber.return = null;
      fiber.dependencies = null;
      fiber.memoizedProps = null;
      fiber.memoizedState = null;
      fiber.pendingProps = null;
      fiber.stateNode = null;
      fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
      for (parent = parent.child; null !== parent; )
        commitDeletionEffectsOnFiber(
          finishedRoot,
          nearestMountedAncestor,
          parent
        ), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
        try {
          injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %s",
            err
          ));
        }
      switch (deletedFiber.tag) {
        case 26:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
          break;
        case 27:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
          isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          runWithFiberInDEV(
            deletedFiber,
            releaseSingletonInstance,
            deletedFiber.stateNode
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 5:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = null;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          if (null !== hostParent)
            if (hostParentIsContainer)
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChildFromContainer,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error2) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error2
                );
              }
            else
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChild,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error2) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error2
                );
              }
          break;
        case 18:
          null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(
            9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
            deletedFiber.stateNode
          ), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
          break;
        case 4:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = deletedFiber.stateNode.containerInfo;
          hostParentIsContainer = true;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          offscreenSubtreeWasHidden || commitHookEffectListUnmount(
            Insertion3,
            deletedFiber,
            nearestMountedAncestor
          );
          offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(
            deletedFiber,
            nearestMountedAncestor,
            Layout
          );
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 1:
          offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
            deletedFiber,
            nearestMountedAncestor,
            prevHostParent
          ));
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 21:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 22:
          offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          offscreenSubtreeWasHidden = prevHostParent;
          break;
        default:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
      }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
      if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
        try {
          runWithFiberInDEV(
            finishedWork,
            commitHydratedSuspenseInstance,
            finishedRoot
          );
        } catch (error2) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error2);
        }
    }
    function getRetryCache(finishedWork) {
      switch (finishedWork.tag) {
        case 13:
        case 19:
          var retryCache = finishedWork.stateNode;
          null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
          return retryCache;
        case 22:
          return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React."
          );
      }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
      var retryCache = getRetryCache(finishedWork);
      wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        if (!retryCache.has(wakeable)) {
          retryCache.add(wakeable);
          if (isDevToolsPresent)
            if (null !== inProgressLanes && null !== inProgressRoot)
              restorePendingUpdaters(inProgressRoot, inProgressLanes);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          wakeable.then(retry, retry);
        }
      });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
      var deletions = parentFiber.deletions;
      if (null !== deletions)
        for (var i = 0; i < deletions.length; i++) {
          var root2 = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], parent = returnFiber;
          a: for (; null !== parent; ) {
            switch (parent.tag) {
              case 27:
                if (isSingletonScope(parent.type)) {
                  hostParent = parent.stateNode;
                  hostParentIsContainer = false;
                  break a;
                }
                break;
              case 5:
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              case 3:
              case 4:
                hostParent = parent.stateNode.containerInfo;
                hostParentIsContainer = true;
                break a;
            }
            parent = parent.return;
          }
          if (null === hostParent)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          commitDeletionEffectsOnFiber(root2, returnFiber, deletedFiber);
          hostParent = null;
          hostParentIsContainer = false;
          root2 = deletedFiber;
          returnFiber = root2.alternate;
          null !== returnFiber && (returnFiber.return = null);
          root2.return = null;
        }
      if (parentFiber.subtreeFlags & 13878)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root2) {
      var current2 = finishedWork.alternate, flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 4 && (commitHookEffectListUnmount(
            Insertion3 | HasEffect,
            finishedWork,
            finishedWork.return
          ), commitHookEffectListMount(Insertion3 | HasEffect, finishedWork), commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout | HasEffect
          ));
          break;
        case 1:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
          flags2 & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags2 = finishedWork.callbacks, null !== flags2 && (current2 = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current2 ? flags2 : current2.concat(flags2))));
          break;
        case 26:
          var hoistableRoot = currentHoistableRoot;
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
          if (flags2 & 4)
            if (root2 = null !== current2 ? current2.memoizedState : null, flags2 = finishedWork.memoizedState, null === current2)
              if (null === flags2)
                if (null === finishedWork.stateNode) {
                  a: {
                    flags2 = finishedWork.type;
                    current2 = finishedWork.memoizedProps;
                    root2 = hoistableRoot.ownerDocument || hoistableRoot;
                    b: switch (flags2) {
                      case "title":
                        hoistableRoot = root2.getElementsByTagName("title")[0];
                        if (!hoistableRoot || hoistableRoot[internalHoistableMarker] || hoistableRoot[internalInstanceKey] || hoistableRoot.namespaceURI === SVG_NAMESPACE || hoistableRoot.hasAttribute("itemprop"))
                          hoistableRoot = root2.createElement(flags2), root2.head.insertBefore(
                            hoistableRoot,
                            root2.querySelector("head > title")
                          );
                        setInitialProperties(hoistableRoot, flags2, current2);
                        hoistableRoot[internalInstanceKey] = finishedWork;
                        markNodeAsHoistable(hoistableRoot);
                        flags2 = hoistableRoot;
                        break a;
                      case "link":
                        var maybeNodes = getHydratableHoistableCache(
                          "link",
                          "href",
                          root2
                        ).get(flags2 + (current2.href || ""));
                        if (maybeNodes) {
                          for (var i = 0; i < maybeNodes.length; i++)
                            if (hoistableRoot = maybeNodes[i], hoistableRoot.getAttribute("href") === (null == current2.href || "" === current2.href ? null : current2.href) && hoistableRoot.getAttribute("rel") === (null == current2.rel ? null : current2.rel) && hoistableRoot.getAttribute("title") === (null == current2.title ? null : current2.title) && hoistableRoot.getAttribute("crossorigin") === (null == current2.crossOrigin ? null : current2.crossOrigin)) {
                              maybeNodes.splice(i, 1);
                              break b;
                            }
                        }
                        hoistableRoot = root2.createElement(flags2);
                        setInitialProperties(hoistableRoot, flags2, current2);
                        root2.head.appendChild(hoistableRoot);
                        break;
                      case "meta":
                        if (maybeNodes = getHydratableHoistableCache(
                          "meta",
                          "content",
                          root2
                        ).get(flags2 + (current2.content || ""))) {
                          for (i = 0; i < maybeNodes.length; i++)
                            if (hoistableRoot = maybeNodes[i], checkAttributeStringCoercion(
                              current2.content,
                              "content"
                            ), hoistableRoot.getAttribute("content") === (null == current2.content ? null : "" + current2.content) && hoistableRoot.getAttribute("name") === (null == current2.name ? null : current2.name) && hoistableRoot.getAttribute("property") === (null == current2.property ? null : current2.property) && hoistableRoot.getAttribute("http-equiv") === (null == current2.httpEquiv ? null : current2.httpEquiv) && hoistableRoot.getAttribute("charset") === (null == current2.charSet ? null : current2.charSet)) {
                              maybeNodes.splice(i, 1);
                              break b;
                            }
                        }
                        hoistableRoot = root2.createElement(flags2);
                        setInitialProperties(hoistableRoot, flags2, current2);
                        root2.head.appendChild(hoistableRoot);
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + flags2 + '". This is a bug in React.'
                        );
                    }
                    hoistableRoot[internalInstanceKey] = finishedWork;
                    markNodeAsHoistable(hoistableRoot);
                    flags2 = hoistableRoot;
                  }
                  finishedWork.stateNode = flags2;
                } else
                  mountHoistable(
                    hoistableRoot,
                    finishedWork.type,
                    finishedWork.stateNode
                  );
              else
                finishedWork.stateNode = acquireResource(
                  hoistableRoot,
                  flags2,
                  finishedWork.memoizedProps
                );
            else
              root2 !== flags2 ? (null === root2 ? null !== current2.stateNode && (current2 = current2.stateNode, current2.parentNode.removeChild(current2)) : root2.count--, null === flags2 ? mountHoistable(
                hoistableRoot,
                finishedWork.type,
                finishedWork.stateNode
              ) : acquireResource(
                hoistableRoot,
                flags2,
                finishedWork.memoizedProps
              )) : null === flags2 && null !== finishedWork.stateNode && commitHostUpdate(
                finishedWork,
                finishedWork.memoizedProps,
                current2.memoizedProps
              );
          break;
        case 27:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
          null !== current2 && flags2 & 4 && commitHostUpdate(
            finishedWork,
            finishedWork.memoizedProps,
            current2.memoizedProps
          );
          break;
        case 5:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
          if (finishedWork.flags & 32) {
            root2 = finishedWork.stateNode;
            try {
              runWithFiberInDEV(finishedWork, resetTextContent, root2);
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          }
          flags2 & 4 && null != finishedWork.stateNode && (root2 = finishedWork.memoizedProps, commitHostUpdate(
            finishedWork,
            root2,
            null !== current2 ? current2.memoizedProps : root2
          ));
          flags2 & 1024 && (needsFormReset = true, "form" !== finishedWork.type && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          if (flags2 & 4) {
            if (null === finishedWork.stateNode)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            flags2 = finishedWork.memoizedProps;
            current2 = null !== current2 ? current2.memoizedProps : flags2;
            root2 = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitTextUpdate,
                root2,
                current2,
                flags2
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          }
          break;
        case 3:
          hoistableRoot = pushNestedEffectDurations();
          tagCaches = null;
          maybeNodes = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(root2.containerInfo);
          recursivelyTraverseMutationEffects(root2, finishedWork);
          currentHoistableRoot = maybeNodes;
          commitReconciliationEffects(finishedWork);
          if (flags2 & 4 && null !== current2 && current2.memoizedState.isDehydrated)
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHydratedContainer,
                root2.containerInfo
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
          root2.effectDuration += popNestedEffectDurations(hoistableRoot);
          break;
        case 4:
          flags2 = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            finishedWork.stateNode.containerInfo
          );
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          currentHoistableRoot = flags2;
          break;
        case 12:
          flags2 = pushNestedEffectDurations();
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags2);
          break;
        case 13:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current2 && null !== current2.memoizedState) && (globalMostRecentFallbackTime = now$1());
          flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags2)));
          break;
        case 22:
          hoistableRoot = null !== finishedWork.memoizedState;
          var wasHidden = null !== current2 && null !== current2.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
          recursivelyTraverseMutationEffects(root2, finishedWork);
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
          commitReconciliationEffects(finishedWork);
          if (flags2 & 8192)
            a: for (root2 = finishedWork.stateNode, root2._visibility = hoistableRoot ? root2._visibility & ~OffscreenVisible : root2._visibility | OffscreenVisible, hoistableRoot && (null === current2 || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current2 = null, root2 = finishedWork; ; ) {
              if (5 === root2.tag || 26 === root2.tag) {
                if (null === current2) {
                  wasHidden = current2 = root2;
                  try {
                    maybeNodes = wasHidden.stateNode, hoistableRoot ? runWithFiberInDEV(wasHidden, hideInstance, maybeNodes) : runWithFiberInDEV(
                      wasHidden,
                      unhideInstance,
                      wasHidden.stateNode,
                      wasHidden.memoizedProps
                    );
                  } catch (error2) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error2);
                  }
                }
              } else if (6 === root2.tag) {
                if (null === current2) {
                  wasHidden = root2;
                  try {
                    i = wasHidden.stateNode, hoistableRoot ? runWithFiberInDEV(wasHidden, hideTextInstance, i) : runWithFiberInDEV(
                      wasHidden,
                      unhideTextInstance,
                      i,
                      wasHidden.memoizedProps
                    );
                  } catch (error2) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error2);
                  }
                }
              } else if ((22 !== root2.tag && 23 !== root2.tag || null === root2.memoizedState || root2 === finishedWork) && null !== root2.child) {
                root2.child.return = root2;
                root2 = root2.child;
                continue;
              }
              if (root2 === finishedWork) break a;
              for (; null === root2.sibling; ) {
                if (null === root2.return || root2.return === finishedWork)
                  break a;
                current2 === root2 && (current2 = null);
                root2 = root2.return;
              }
              current2 === root2 && (current2 = null);
              root2.sibling.return = root2.return;
              root2 = root2.sibling;
            }
          flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (current2 = flags2.retryQueue, null !== current2 && (flags2.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current2))));
          break;
        case 19:
          recursivelyTraverseMutationEffects(root2, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags2 & 4 && (flags2 = finishedWork.updateQueue, null !== flags2 && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags2)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          recursivelyTraverseMutationEffects(root2, finishedWork), commitReconciliationEffects(finishedWork);
      }
    }
    function commitReconciliationEffects(finishedWork) {
      var flags2 = finishedWork.flags;
      if (flags2 & 2) {
        try {
          runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
        } catch (error2) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error2);
        }
        finishedWork.flags &= -3;
      }
      flags2 & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
      if (parentFiber.subtreeFlags & 1024)
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var fiber = parentFiber;
          recursivelyResetForms(fiber);
          5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
          parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root2, parentFiber) {
      if (parentFiber.subtreeFlags & 8772)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitLayoutEffectOnFiber(root2, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          runWithFiberInDEV(
            finishedWork,
            releaseSingletonInstance,
            finishedWork.stateNode
          );
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current2, finishedWork, includeWorkInProgressEffects) {
      var flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookLayoutEffects(finishedWork, Layout);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current2 = finishedWork.stateNode;
          "function" === typeof current2.componentDidMount && runWithFiberInDEV(
            finishedWork,
            callComponentDidMountInDEV,
            finishedWork,
            current2
          );
          current2 = finishedWork.updateQueue;
          if (null !== current2) {
            finishedRoot = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHiddenCallbacks,
                current2,
                finishedRoot
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          }
          includeWorkInProgressEffects && flags2 & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current2 && flags2 & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (includeWorkInProgressEffects && flags2 & 4) {
            flags2 = pushNestedEffectDurations();
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
            includeWorkInProgressEffects = finishedWork.stateNode;
            includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags2);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current2,
                commitStartTime,
                includeWorkInProgressEffects.effectDuration
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          } else
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags2 & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        reappearLayoutEffects(
          finishedRoot,
          parentFiber.alternate,
          parentFiber,
          includeWorkInProgressEffects
        ), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current2, finishedWork) {
      var previousCache = null;
      null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (previousCache = current2.memoizedState.cachePool.pool);
      current2 = null;
      null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current2 = finishedWork.memoizedState.cachePool.pool);
      current2 !== previousCache && (null != current2 && retainCache(current2), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current2, finishedWork) {
      current2 = null;
      null !== finishedWork.alternate && (current2 = finishedWork.alternate.memoizedState.cache);
      finishedWork = finishedWork.memoizedState.cache;
      finishedWork !== current2 && (retainCache(finishedWork), null != current2 && releaseCache(current2));
    }
    function recursivelyTraversePassiveMountEffects(root2, parentFiber, committedLanes, committedTransitions) {
      if (parentFiber.subtreeFlags & 10256)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitPassiveMountOnFiber(
            root2,
            parentFiber,
            committedLanes,
            committedTransitions
          ), parentFiber = parentFiber.sibling;
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
      var flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          flags2 & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
          break;
        case 1:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          break;
        case 3:
          var prevEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          flags2 & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== committedLanes && (retainCache(finishedWork), null != committedLanes && releaseCache(committedLanes)));
          finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevEffectDuration);
          break;
        case 12:
          if (flags2 & 2048) {
            flags2 = pushNestedEffectDurations();
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions
            );
            finishedRoot = finishedWork.stateNode;
            finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags2);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfilerPostCommitImpl,
                finishedWork,
                finishedWork.alternate,
                commitStartTime,
                finishedRoot.passiveEffectDuration
              );
            } catch (error2) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error2);
            }
          } else
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions
            );
          break;
        case 13:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          break;
        case 23:
          break;
        case 22:
          prevEffectDuration = finishedWork.stateNode;
          var _current = finishedWork.alternate;
          null !== finishedWork.memoizedState ? prevEffectDuration._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : prevEffectDuration._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          ) : (prevEffectDuration._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            0 !== (finishedWork.subtreeFlags & 10256)
          ));
          flags2 & 2048 && commitOffscreenPassiveMountEffects(_current, finishedWork);
          break;
        case 24:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          flags2 & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
      }
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        reconnectPassiveEffects(
          finishedRoot,
          parentFiber,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects
        ), parentFiber = parentFiber.sibling;
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) {
      var flags2 = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          commitHookPassiveMountEffects(finishedWork, Passive);
          break;
        case 23:
          break;
        case 22:
          var _instance2 = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ));
          includeWorkInProgressEffects && flags2 & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags2 & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
      }
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
      if (parentFiber.subtreeFlags & 10256)
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags2 = finishedWork.flags;
          switch (finishedWork.tag) {
            case 22:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                finishedWork
              );
              flags2 & 2048 && commitOffscreenPassiveMountEffects(
                finishedWork.alternate,
                finishedWork
              );
              break;
            case 24:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                finishedWork
              );
              flags2 & 2048 && commitCachePassiveMountEffect(
                finishedWork.alternate,
                finishedWork
              );
              break;
            default:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                finishedWork
              );
          }
          parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber) {
      if (parentFiber.subtreeFlags & suspenseyCommitFlag)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber) {
      switch (fiber.tag) {
        case 26:
          recursivelyAccumulateSuspenseyCommit(fiber);
          fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
            currentHoistableRoot,
            fiber.memoizedState,
            fiber.memoizedProps
          );
          break;
        case 5:
          recursivelyAccumulateSuspenseyCommit(fiber);
          break;
        case 3:
        case 4:
          var previousHoistableRoot = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            fiber.stateNode.containerInfo
          );
          recursivelyAccumulateSuspenseyCommit(fiber);
          currentHoistableRoot = previousHoistableRoot;
          break;
        case 22:
          null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
          break;
        default:
          recursivelyAccumulateSuspenseyCommit(fiber);
      }
    }
    function detachAlternateSiblings(parentFiber) {
      var previousFiber = parentFiber.alternate;
      if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do
          previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
      }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i = 0; i < deletions.length; i++) {
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
          }
        detachAlternateSiblings(parentFiber);
      }
      if (parentFiber.subtreeFlags & 10256)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive | HasEffect
          );
          break;
        case 3:
          var prevEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevEffectDuration);
          break;
        case 12:
          prevEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevEffectDuration);
          break;
        case 22:
          prevEffectDuration = finishedWork.stateNode;
          null !== finishedWork.memoizedState && prevEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
          break;
        default:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
      }
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i = 0; i < deletions.length; i++) {
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
          }
        detachAlternateSiblings(parentFiber);
      }
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive
          );
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
          break;
        case 22:
          var instance = finishedWork.stateNode;
          instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
      }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
      for (; null !== nextEffect; ) {
        var fiber = nextEffect, current2 = fiber;
        switch (current2.tag) {
          case 0:
          case 11:
          case 15:
            commitHookPassiveUnmountEffects(
              current2,
              nearestMountedAncestor,
              Passive
            );
            break;
          case 23:
          case 22:
            null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (current2 = current2.memoizedState.cachePool.pool, null != current2 && retainCache(current2));
            break;
          case 24:
            releaseCache(current2.memoizedState.cache);
        }
        current2 = fiber.child;
        if (null !== current2) current2.return = fiber, nextEffect = current2;
        else
          a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
            current2 = nextEffect;
            var sibling = current2.sibling, returnFiber = current2.return;
            detachFiberAfterEffects(current2);
            if (current2 === fiber) {
              nextEffect = null;
              break a;
            }
            if (null !== sibling) {
              sibling.return = returnFiber;
              nextEffect = sibling;
              break a;
            }
            nextEffect = returnFiber;
          }
      }
    }
    function onCommitRoot() {
      commitHooks.forEach(function(commitHook) {
        return commitHook();
      });
    }
    function isConcurrentActEnvironment() {
      var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
      isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error(
        "The current testing environment is not configured to support act(...)"
      );
      return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
      if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes)
        return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
      var transition = ReactSharedInternals.T;
      return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = /* @__PURE__ */ new Set()), transition._updatedFibers.add(fiber), fiber = currentEntangledLane, 0 !== fiber ? fiber : requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
      0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
      var suspenseHandler = suspenseHandlerStackCursor.current;
      null !== suspenseHandler && (suspenseHandler.flags |= 32);
      return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root2, fiber, lane) {
      isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
      isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = true);
      if (root2 === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root2.cancelPendingCommit)
        prepareFreshStack(root2, 0), markRootSuspended(
          root2,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        );
      markRootUpdated$1(root2, lane);
      if (0 !== (executionContext & RenderContext) && root2 === workInProgressRoot) {
        if (isRendering)
          switch (fiber.tag) {
            case 0:
            case 11:
            case 15:
              root2 = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
              didWarnAboutUpdateInRenderForAnotherComponent.has(root2) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root2), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                fiber,
                root2,
                root2
              ));
              break;
            case 1:
              didWarnAboutUpdateInRender || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), didWarnAboutUpdateInRender = true);
          }
      } else
        isDevToolsPresent && addFiberToLanesMap(root2, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root2 === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(
          root2,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        )), ensureRootIsScheduled(root2);
    }
    function performWorkOnRoot(root2, lanes, forceSync) {
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root2.expiredLanes) || checkIfRootIsPrerendering(root2, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root2, lanes) : renderRootSync(root2, lanes, true), renderWasConcurrent = shouldTimeSlice;
      do {
        if (exitStatus === RootInProgress) {
          workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root2, lanes, 0, false);
          break;
        } else {
          forceSync = root2.current.alternate;
          if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
            exitStatus = renderRootSync(root2, lanes, false);
            renderWasConcurrent = false;
            continue;
          }
          if (exitStatus === RootErrored) {
            renderWasConcurrent = lanes;
            if (root2.errorRecoveryDisabledLanes & renderWasConcurrent)
              var errorRetryLanes = 0;
            else
              errorRetryLanes = root2.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
            if (0 !== errorRetryLanes) {
              lanes = errorRetryLanes;
              a: {
                exitStatus = root2;
                var errorRetryLanes$jscomp$0 = errorRetryLanes;
                errorRetryLanes = workInProgressRootConcurrentErrors;
                var wasRootDehydrated = exitStatus.current.memoizedState.isDehydrated;
                wasRootDehydrated && (prepareFreshStack(
                  exitStatus,
                  errorRetryLanes$jscomp$0
                ).flags |= 256);
                errorRetryLanes$jscomp$0 = renderRootSync(
                  exitStatus,
                  errorRetryLanes$jscomp$0,
                  false
                );
                if (errorRetryLanes$jscomp$0 !== RootErrored) {
                  if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                    exitStatus.errorRecoveryDisabledLanes |= renderWasConcurrent;
                    workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                    exitStatus = RootSuspendedWithDelay;
                    break a;
                  }
                  exitStatus = workInProgressRootRecoverableErrors;
                  workInProgressRootRecoverableErrors = errorRetryLanes;
                  null !== exitStatus && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = exitStatus : workInProgressRootRecoverableErrors.push.apply(
                    workInProgressRootRecoverableErrors,
                    exitStatus
                  ));
                }
                exitStatus = errorRetryLanes$jscomp$0;
              }
              renderWasConcurrent = false;
              if (exitStatus !== RootErrored) continue;
            }
          }
          if (exitStatus === RootFatalErrored) {
            prepareFreshStack(root2, 0);
            markRootSuspended(root2, lanes, 0, true);
            break;
          }
          a: {
            shouldTimeSlice = root2;
            switch (exitStatus) {
              case RootInProgress:
              case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
              case RootSuspendedWithDelay:
                if ((lanes & 4194048) !== lanes) break;
              case RootSuspendedAtTheShell:
                markRootSuspended(
                  shouldTimeSlice,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                break a;
              case RootErrored:
                workInProgressRootRecoverableErrors = null;
                break;
              case RootSuspended:
              case RootCompleted:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (null !== ReactSharedInternals.actQueue)
              commitRoot(
                shouldTimeSlice,
                forceSync,
                lanes,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes
              );
            else {
              if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                markRootSuspended(
                  shouldTimeSlice,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
                shouldTimeSlice.timeoutHandle = scheduleTimeout(
                  commitRootWhenReady.bind(
                    null,
                    shouldTimeSlice,
                    forceSync,
                    workInProgressRootRecoverableErrors,
                    workInProgressTransitions,
                    workInProgressRootDidIncludeRecursiveRenderUpdate,
                    lanes,
                    workInProgressDeferredLane,
                    workInProgressRootInterleavedUpdatedLanes,
                    workInProgressSuspendedRetryLanes,
                    workInProgressRootDidSkipSuspendedSiblings,
                    exitStatus,
                    THROTTLED_COMMIT,
                    renderStartTime,
                    0
                  ),
                  renderWasConcurrent
                );
                break a;
              }
              commitRootWhenReady(
                shouldTimeSlice,
                forceSync,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                exitStatus,
                IMMEDIATE_COMMIT,
                renderStartTime,
                0
              );
            }
          }
        }
        break;
      } while (1);
      ensureRootIsScheduled(root2);
    }
    function commitRootWhenReady(root2, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
      root2.timeoutHandle = noTimeout;
      suspendedCommitReason = finishedWork.subtreeFlags;
      if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if (suspendedState = { stylesheets: null, count: 0, unsuspend: noop4 }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
          root2.cancelPendingCommit = suspendedCommitReason(
            commitRoot.bind(
              null,
              root2,
              finishedWork,
              lanes,
              recoverableErrors,
              transitions,
              didIncludeRenderPhaseUpdate,
              spawnedLane,
              updatedLanes,
              suspendedRetryLanes,
              exitStatus,
              SUSPENDED_COMMIT,
              completedRenderStartTime,
              completedRenderEndTime
            )
          );
          markRootSuspended(
            root2,
            lanes,
            spawnedLane,
            !didSkipSuspendedSiblings
          );
          return;
        }
      }
      commitRoot(
        root2,
        finishedWork,
        lanes,
        recoverableErrors,
        transitions,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes
      );
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
      for (var node2 = finishedWork; ; ) {
        var tag = node2.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node2.flags & 16384 && (tag = node2.updateQueue, null !== tag && (tag = tag.stores, null !== tag)))
          for (var i = 0; i < tag.length; i++) {
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
              if (!objectIs(getSnapshot(), check)) return false;
            } catch (error2) {
              return false;
            }
          }
        tag = node2.child;
        if (node2.subtreeFlags & 16384 && null !== tag)
          tag.return = node2, node2 = tag;
        else {
          if (node2 === finishedWork) break;
          for (; null === node2.sibling; ) {
            if (null === node2.return || node2.return === finishedWork) return true;
            node2 = node2.return;
          }
          node2.sibling.return = node2.return;
          node2 = node2.sibling;
        }
      }
      return true;
    }
    function markRootSuspended(root2, suspendedLanes, spawnedLane, didAttemptEntireTree) {
      suspendedLanes &= ~workInProgressRootPingedLanes;
      suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
      root2.suspendedLanes |= suspendedLanes;
      root2.pingedLanes &= ~suspendedLanes;
      didAttemptEntireTree && (root2.warmLanes |= suspendedLanes);
      didAttemptEntireTree = root2.expirationTimes;
      for (var lanes = suspendedLanes; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2;
        didAttemptEntireTree[index2] = -1;
        lanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
      return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
    }
    function resetWorkInProgressStack() {
      if (null !== workInProgress) {
        if (workInProgressSuspendedReason === NotSuspended)
          var interruptedWork = workInProgress.return;
        else
          interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
        for (; null !== interruptedWork; )
          unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
      }
    }
    function prepareFreshStack(root2, lanes) {
      var timeoutHandle = root2.timeoutHandle;
      timeoutHandle !== noTimeout && (root2.timeoutHandle = noTimeout, cancelTimeout(timeoutHandle));
      timeoutHandle = root2.cancelPendingCommit;
      null !== timeoutHandle && (root2.cancelPendingCommit = null, timeoutHandle());
      resetWorkInProgressStack();
      workInProgressRoot = root2;
      workInProgress = timeoutHandle = createWorkInProgress(root2.current, null);
      workInProgressRootRenderLanes = lanes;
      workInProgressSuspendedReason = NotSuspended;
      workInProgressThrownValue = null;
      workInProgressRootDidSkipSuspendedSiblings = false;
      workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root2, lanes);
      workInProgressRootDidAttachPingListener = false;
      workInProgressRootExitStatus = RootInProgress;
      workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
      workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
      workInProgressRootDidIncludeRecursiveRenderUpdate = false;
      0 !== (lanes & 8) && (lanes |= lanes & 32);
      var allEntangledLanes = root2.entangledLanes;
      if (0 !== allEntangledLanes)
        for (root2 = root2.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes; ) {
          var index2 = 31 - clz32(allEntangledLanes), lane = 1 << index2;
          lanes |= root2[index2];
          allEntangledLanes &= ~lane;
        }
      entangledRenderLanes = lanes;
      finishQueueingConcurrentUpdates();
      lanes = getCurrentTime();
      1e3 < lanes - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = lanes);
      ReactStrictModeWarnings.discardPendingWarnings();
      return timeoutHandle;
    }
    function handleThrow(root2, thrownValue) {
      currentlyRenderingFiber = null;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      ReactSharedInternals.getCurrentStack = null;
      isRendering = false;
      current = null;
      thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
      workInProgressThrownValue = thrownValue;
      var erroredWork = workInProgress;
      if (null === erroredWork)
        workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(
          root2,
          createCapturedValueAtFiber(thrownValue, root2.current)
        );
      else
        switch (erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork), markComponentRenderStopped(), workInProgressSuspendedReason) {
          case SuspendedOnError:
            null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentErrored && injectedProfilingHooks.markComponentErrored(
              erroredWork,
              thrownValue,
              workInProgressRootRenderLanes
            );
            break;
          case SuspendedOnData:
          case SuspendedOnAction:
          case SuspendedOnImmediate:
          case SuspendedOnDeprecatedThrowPromise:
          case SuspendedAndReadyToContinue:
            null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markComponentSuspended && injectedProfilingHooks.markComponentSuspended(
              erroredWork,
              thrownValue,
              workInProgressRootRenderLanes
            );
        }
    }
    function pushDispatcher() {
      var prevDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
      var prevAsyncDispatcher = ReactSharedInternals.A;
      ReactSharedInternals.A = DefaultAsyncDispatcher;
      return prevAsyncDispatcher;
    }
    function renderDidSuspendDelayIfPossible() {
      workInProgressRootExitStatus = RootSuspendedWithDelay;
      workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
      0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
        workInProgressRoot,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    }
    function renderRootSync(root2, lanes, shouldYieldForPrerendering) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root2.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root2, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root2, lanes);
        }
        workInProgressTransitions = null;
        prepareFreshStack(root2, lanes);
      }
      markRenderStarted(lanes);
      lanes = false;
      memoizedUpdaters = workInProgressRootExitStatus;
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch (workInProgressSuspendedReason) {
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                memoizedUpdaters = RootSuspendedAtTheShell;
                break a;
              case SuspendedOnImmediate:
              case SuspendedOnData:
              case SuspendedOnAction:
              case SuspendedOnDeprecatedThrowPromise:
                null === suspenseHandlerStackCursor.current && (lanes = true);
                var reason = workInProgressSuspendedReason;
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
                if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                  memoizedUpdaters = RootInProgress;
                  break a;
                }
                break;
              default:
                reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
            }
          }
          workLoopSync();
          memoizedUpdaters = workInProgressRootExitStatus;
          break;
        } catch (thrownValue$8) {
          handleThrow(root2, thrownValue$8);
        }
      while (1);
      lanes && root2.shellSuspendCounter++;
      resetContextDependencies();
      executionContext = prevExecutionContext;
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      markRenderStopped();
      null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
      return memoizedUpdaters;
    }
    function workLoopSync() {
      for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root2, lanes) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root2.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root2, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root2, lanes);
        }
        workInProgressTransitions = null;
        workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
        prepareFreshStack(root2, lanes);
      } else
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
          root2,
          lanes
        );
      markRenderStarted(lanes);
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress)
            b: switch (lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason) {
              case SuspendedOnError:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root2,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnError
                );
                break;
              case SuspendedOnData:
              case SuspendedOnAction:
                if (isThenableResolved(memoizedUpdaters)) {
                  workInProgressSuspendedReason = NotSuspended;
                  workInProgressThrownValue = null;
                  replaySuspendedUnitOfWork(lanes);
                  break;
                }
                lanes = function() {
                  workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root2 || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                  ensureRootIsScheduled(root2);
                };
                memoizedUpdaters.then(lanes, lanes);
                break a;
              case SuspendedOnImmediate:
                workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                break a;
              case SuspendedOnInstance:
                workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                break a;
              case SuspendedAndReadyToContinue:
                isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(
                  root2,
                  lanes,
                  memoizedUpdaters,
                  SuspendedAndReadyToContinue
                ));
                break;
              case SuspendedOnInstanceAndReadyToContinue:
                var resource = null;
                switch (workInProgress.tag) {
                  case 26:
                    resource = workInProgress.memoizedState;
                  case 5:
                  case 27:
                    var hostFiber = workInProgress;
                    if (resource ? preloadResource(resource) : 1) {
                      workInProgressSuspendedReason = NotSuspended;
                      workInProgressThrownValue = null;
                      var sibling = hostFiber.sibling;
                      if (null !== sibling) workInProgress = sibling;
                      else {
                        var returnFiber = hostFiber.return;
                        null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                      }
                      break b;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root2,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnInstanceAndReadyToContinue
                );
                break;
              case SuspendedOnDeprecatedThrowPromise:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root2,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnDeprecatedThrowPromise
                );
                break;
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                workInProgressRootExitStatus = RootSuspendedAtTheShell;
                break a;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
          break;
        } catch (thrownValue$9) {
          handleThrow(root2, thrownValue$9);
        }
      while (1);
      resetContextDependencies();
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      executionContext = prevExecutionContext;
      if (null !== workInProgress)
        return null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markRenderYielded && injectedProfilingHooks.markRenderYielded(), RootInProgress;
      markRenderStopped();
      workInProgressRoot = null;
      workInProgressRootRenderLanes = 0;
      finishQueueingConcurrentUpdates();
      return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
      for (; null !== workInProgress && !shouldYield(); )
        performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
      var current2 = unitOfWork.alternate;
      (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current2 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current2,
        unitOfWork,
        entangledRenderLanes
      ), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current2 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current2,
        unitOfWork,
        entangledRenderLanes
      );
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === current2 ? completeUnitOfWork(unitOfWork) : workInProgress = current2;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
      var next4 = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === next4 ? completeUnitOfWork(unitOfWork) : workInProgress = next4;
    }
    function replayBeginWork(unitOfWork) {
      var current2 = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
      isProfilingMode && startProfilerTimer(unitOfWork);
      switch (unitOfWork.tag) {
        case 15:
        case 0:
          current2 = replayFunctionComponent(
            current2,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type,
            void 0,
            workInProgressRootRenderLanes
          );
          break;
        case 11:
          current2 = replayFunctionComponent(
            current2,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type.render,
            unitOfWork.ref,
            workInProgressRootRenderLanes
          );
          break;
        case 5:
          resetHooksOnUnwind(unitOfWork);
        default:
          unwindInterruptedWork(current2, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current2 = beginWork(current2, unitOfWork, entangledRenderLanes);
      }
      isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
      return current2;
    }
    function throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, suspendedReason) {
      resetContextDependencies();
      resetHooksOnUnwind(unitOfWork);
      thenableState = null;
      thenableIndexCounter = 0;
      var returnFiber = unitOfWork.return;
      try {
        if (throwException(
          root2,
          returnFiber,
          unitOfWork,
          thrownValue,
          workInProgressRootRenderLanes
        )) {
          workInProgressRootExitStatus = RootFatalErrored;
          logUncaughtError(
            root2,
            createCapturedValueAtFiber(thrownValue, root2.current)
          );
          workInProgress = null;
          return;
        }
      } catch (error2) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error2;
        workInProgressRootExitStatus = RootFatalErrored;
        logUncaughtError(
          root2,
          createCapturedValueAtFiber(thrownValue, root2.current)
        );
        workInProgress = null;
        return;
      }
      if (unitOfWork.flags & 32768) {
        if (isHydrating || suspendedReason === SuspendedOnError) root2 = true;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
          root2 = false;
        else if (workInProgressRootDidSkipSuspendedSiblings = root2 = true, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise)
          suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root2);
      } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
      var completedWork = unitOfWork;
      do {
        if (0 !== (completedWork.flags & 32768)) {
          unwindUnitOfWork(
            completedWork,
            workInProgressRootDidSkipSuspendedSiblings
          );
          return;
        }
        var current2 = completedWork.alternate;
        unitOfWork = completedWork.return;
        startProfilerTimer(completedWork);
        current2 = runWithFiberInDEV(
          completedWork,
          completeWork,
          current2,
          completedWork,
          entangledRenderLanes
        );
        (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
        if (null !== current2) {
          workInProgress = current2;
          return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
          workInProgress = completedWork;
          return;
        }
        workInProgress = completedWork = unitOfWork;
      } while (null !== completedWork);
      workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
      do {
        var next4 = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next4) {
          next4.flags &= 32767;
          workInProgress = next4;
          return;
        }
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
          next4 = unitOfWork.actualDuration;
          for (var child = unitOfWork.child; null !== child; )
            next4 += child.actualDuration, child = child.sibling;
          unitOfWork.actualDuration = next4;
        }
        next4 = unitOfWork.return;
        null !== next4 && (next4.flags |= 32768, next4.subtreeFlags = 0, next4.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
          workInProgress = unitOfWork;
          return;
        }
        workInProgress = unitOfWork = next4;
      } while (null !== unitOfWork);
      workInProgressRootExitStatus = RootSuspendedAtTheShell;
      workInProgress = null;
    }
    function commitRoot(root2, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
      root2.cancelPendingCommit = null;
      do
        flushPendingEffects();
      while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
      ReactStrictModeWarnings.flushLegacyContextWarning();
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markCommitStarted && injectedProfilingHooks.markCommitStarted(lanes);
      if (null === finishedWork) markCommitStopped();
      else {
        0 === lanes && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        );
        if (finishedWork === root2.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(
          root2,
          lanes,
          didIncludeRenderPhaseUpdate,
          spawnedLane,
          updatedLanes,
          suspendedRetryLanes
        );
        root2 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root2;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root2.callbackNode = null, root2.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
          flushPassiveEffects();
          return null;
        })) : (root2.callbackNode = null, root2.callbackPriority = 0);
        commitStartTime = now();
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
          recoverableErrors = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          transitions = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          spawnedLane = executionContext;
          executionContext |= CommitContext;
          try {
            commitBeforeMutationEffects(root2, finishedWork, lanes);
          } finally {
            executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
          }
        }
        pendingEffectsStatus = PENDING_MUTATION_PHASE;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
      }
    }
    function flushMutationEffects() {
      if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
          rootMutationHasEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            inProgressLanes = lanes;
            inProgressRoot = root2;
            commitMutationEffectsOnFiber(finishedWork, root2);
            inProgressRoot = inProgressLanes = null;
            lanes = selectionInformation;
            var curFocusedElem = getActiveElementDeep(root2.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
            if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
              priorFocusedElem.ownerDocument.documentElement,
              priorFocusedElem
            )) {
              if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                var start2 = priorSelectionRange.start, end = priorSelectionRange.end;
                void 0 === end && (end = start2);
                if ("selectionStart" in priorFocusedElem)
                  priorFocusedElem.selectionStart = start2, priorFocusedElem.selectionEnd = Math.min(
                    end,
                    priorFocusedElem.value.length
                  );
                else {
                  var doc = priorFocusedElem.ownerDocument || document, win2 = doc && doc.defaultView || window;
                  if (win2.getSelection) {
                    var selection = win2.getSelection(), length2 = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(
                      priorSelectionRange.start,
                      length2
                    ), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length2);
                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                    var startMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      start$jscomp$0
                    ), endMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      end$jscomp$0
                    );
                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                      var range3 = doc.createRange();
                      range3.setStart(startMarker.node, startMarker.offset);
                      selection.removeAllRanges();
                      start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range3), selection.extend(endMarker.node, endMarker.offset)) : (range3.setEnd(endMarker.node, endMarker.offset), selection.addRange(range3));
                    }
                  }
                }
              }
              doc = [];
              for (selection = priorFocusedElem; selection = selection.parentNode; )
                1 === selection.nodeType && doc.push({
                  element: selection,
                  left: selection.scrollLeft,
                  top: selection.scrollTop
                });
              "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
              for (priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++) {
                var info = doc[priorFocusedElem];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
              }
            }
            _enabled = !!eventsEnabled;
            selectionInformation = eventsEnabled = null;
          } finally {
            executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
          }
        }
        root2.current = finishedWork;
        pendingEffectsStatus = PENDING_LAYOUT_PHASE;
      }
    }
    function flushLayoutEffects() {
      if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
          rootHasLayoutEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markLayoutEffectsStarted && injectedProfilingHooks.markLayoutEffectsStarted(lanes), inProgressLanes = lanes, inProgressRoot = root2, commitLayoutEffectOnFiber(
              root2,
              finishedWork.alternate,
              finishedWork
            ), inProgressRoot = inProgressLanes = null, null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markLayoutEffectsStopped && injectedProfilingHooks.markLayoutEffectsStopped();
          } finally {
            executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
          }
        }
        pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
      }
    }
    function flushSpawnedWork() {
      if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        requestPaint();
        var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors, rootDidHavePassiveEffects = 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
        rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root2, root2.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
        var remainingLanes = root2.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(root2);
        rootDidHavePassiveEffects = lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
          try {
            var didError = 128 === (finishedWork.current.flags & 128);
            switch (rootDidHavePassiveEffects) {
              case DiscreteEventPriority:
                var schedulerPriority = ImmediatePriority;
                break;
              case ContinuousEventPriority:
                schedulerPriority = UserBlockingPriority;
                break;
              case DefaultEventPriority:
                schedulerPriority = NormalPriority$1;
                break;
              case IdleEventPriority:
                schedulerPriority = IdlePriority;
                break;
              default:
                schedulerPriority = NormalPriority$1;
            }
            injectedHook.onCommitFiberRoot(
              rendererID,
              finishedWork,
              schedulerPriority,
              didError
            );
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %s",
              err
            ));
          }
        isDevToolsPresent && root2.memoizedUpdaters.clear();
        onCommitRoot();
        if (null !== recoverableErrors) {
          didError = ReactSharedInternals.T;
          schedulerPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          ReactSharedInternals.T = null;
          try {
            var onRecoverableError = root2.onRecoverableError;
            for (finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++) {
              var recoverableError = recoverableErrors[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
              runWithFiberInDEV(
                recoverableError.source,
                onRecoverableError,
                recoverableError.value,
                errorInfo
              );
            }
          } finally {
            ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
          }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root2);
        remainingLanes = root2.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = true, root2 === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root2)) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0);
        markCommitStopped();
      }
    }
    function makeErrorInfo(componentStack) {
      componentStack = { componentStack };
      Object.defineProperty(componentStack, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      });
      return componentStack;
    }
    function releaseRootPooledCache(root2, remainingLanes) {
      0 === (root2.pooledCacheLanes &= remainingLanes) && (remainingLanes = root2.pooledCache, null != remainingLanes && (root2.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects(wasDelayedCommit) {
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
      return flushPassiveEffects();
    }
    function flushPassiveEffects() {
      if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return false;
      var root2 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
      pendingEffectsRemainingLanes = 0;
      var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
      renderPriority = ReactSharedInternals.T;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = priority;
        ReactSharedInternals.T = null;
        priority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
          throw Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markPassiveEffectsStarted && injectedProfilingHooks.markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(
          root$jscomp$0,
          root$jscomp$0.current,
          lanes,
          priority
        );
        null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markPassiveEffectsStopped && injectedProfilingHooks.markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root$jscomp$0);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, false);
        didScheduleUpdateDuringPassiveEffects ? root$jscomp$0 === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = root$jscomp$0) : nestedPassiveUpdateCount = 0;
        didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = false;
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %s",
              err
            ));
          }
        var stateNode = root$jscomp$0.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root2, remainingLanes);
      }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error2) {
      sourceFiber = createCapturedValueAtFiber(error2, sourceFiber);
      sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
      rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
      null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error2) {
      isRunningInsertionEffect = false;
      if (3 === sourceFiber.tag)
        captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error2);
      else {
        for (; null !== nearestMountedAncestor; ) {
          if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(
              nearestMountedAncestor,
              sourceFiber,
              error2
            );
            return;
          }
          if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
              sourceFiber = createCapturedValueAtFiber(error2, sourceFiber);
              error2 = createClassErrorUpdate(2);
              instance = enqueueUpdate(nearestMountedAncestor, error2, 2);
              null !== instance && (initializeClassErrorUpdate(
                error2,
                instance,
                nearestMountedAncestor,
                sourceFiber
              ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
              return;
            }
          }
          nearestMountedAncestor = nearestMountedAncestor.return;
        }
        console.error(
          "Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s",
          error2
        );
      }
    }
    function attachPingListener(root2, wakeable, lanes) {
      var pingCache = root2.pingCache;
      if (null === pingCache) {
        pingCache = root2.pingCache = new PossiblyWeakMap();
        var threadIDs = /* @__PURE__ */ new Set();
        pingCache.set(wakeable, threadIDs);
      } else
        threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
      threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root2, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root2, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root2, wakeable, pingedLanes) {
      var pingCache = root2.pingCache;
      null !== pingCache && pingCache.delete(wakeable);
      root2.pingedLanes |= root2.suspendedLanes & pingedLanes;
      root2.warmLanes &= ~pingedLanes;
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error(
        "A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act"
      );
      workInProgressRoot === root2 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root2, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
      ensureRootIsScheduled(root2);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
      0 === retryLane && (retryLane = claimNextRetryLane());
      boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
      null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
      var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
      null !== suspenseState && (retryLane = suspenseState.retryLane);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
      var retryLane = 0;
      switch (boundaryFiber.tag) {
        case 13:
          var retryCache = boundaryFiber.stateNode;
          var suspenseState = boundaryFiber.memoizedState;
          null !== suspenseState && (retryLane = suspenseState.retryLane);
          break;
        case 19:
          retryCache = boundaryFiber.stateNode;
          break;
        case 22:
          retryCache = boundaryFiber.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      null !== retryCache && retryCache.delete(wakeable);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
      if (0 !== (parentFiber.subtreeFlags & 67117056))
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var root2 = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
          isStrictModeFiber = isInStrictMode || isStrictModeFiber;
          22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root2,
            fiber,
            (fiber.mode & NoStrictPassiveEffectsMode) === NoMode
          ) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(
            root2,
            fiber,
            isStrictModeFiber
          ) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root2,
            fiber
          ) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(
            fiber,
            recursivelyTraverseAndDoubleInvokeEffectsInDEV,
            root2,
            fiber,
            isStrictModeFiber
          ));
          parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root2, fiber) {
      var shouldDoubleInvokePassiveEffects = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : true;
      setIsStrictModeForDevtools(true);
      try {
        disappearLayoutEffects(fiber), shouldDoubleInvokePassiveEffects && disconnectPassiveEffect(fiber), reappearLayoutEffects(root2, fiber.alternate, fiber, false), shouldDoubleInvokePassiveEffects && reconnectPassiveEffects(root2, fiber, 0, null, false, 0);
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    function commitDoubleInvokeEffectsInDEV(root2) {
      var doubleInvokeEffects = true;
      root2.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = false);
      recursivelyTraverseAndDoubleInvokeEffectsInDEV(
        root2,
        root2.current,
        doubleInvokeEffects
      );
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
      if ((executionContext & RenderContext) === NoContext) {
        var tag = fiber.tag;
        if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
          tag = getComponentNameFromFiber(fiber) || "ReactComponent";
          if (null !== didWarnStateUpdateForNotYetMountedComponent) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(tag);
          } else didWarnStateUpdateForNotYetMountedComponent = /* @__PURE__ */ new Set([tag]);
          runWithFiberInDEV(fiber, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function restorePendingUpdaters(root2, lanes) {
      isDevToolsPresent && root2.memoizedUpdaters.forEach(function(schedulingFiber) {
        addFiberToLanesMap(root2, schedulingFiber, lanes);
      });
    }
    function scheduleCallback$1(priorityLevel, callback) {
      var actQueue = ReactSharedInternals.actQueue;
      return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
        console.error(
          "An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act",
          getComponentNameFromFiber(fiber)
        );
      });
    }
    function ensureRootIsScheduled(root2) {
      root2 !== lastScheduledRoot && null === root2.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root2 : lastScheduledRoot = lastScheduledRoot.next = root2);
      mightHavePendingSyncWork = true;
      null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = true, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
      if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = true;
        do {
          var didPerformSomeWork = false;
          for (var root2 = firstScheduledRoot; null !== root2; ) {
            if (0 !== syncTransitionLanes) {
              var pendingLanes = root2.pendingLanes;
              if (0 === pendingLanes) var nextLanes = 0;
              else {
                var suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes;
                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
              }
              0 !== nextLanes && (didPerformSomeWork = true, performSyncWorkOnRoot(root2, nextLanes));
            } else
              nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(
                root2,
                root2 === workInProgressRoot ? nextLanes : 0,
                null !== root2.cancelPendingCommit || root2.timeoutHandle !== noTimeout
              ), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root2, nextLanes) || (didPerformSomeWork = true, performSyncWorkOnRoot(root2, nextLanes));
            root2 = root2.next;
          }
        } while (didPerformSomeWork);
        isFlushingWork = false;
      }
    }
    function processRootScheduleInImmediateTask() {
      processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
      mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = false;
      var syncTransitionLanes = 0;
      0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
      for (var currentTime = now$1(), prev4 = null, root2 = firstScheduledRoot; null !== root2; ) {
        var next4 = root2.next, nextLanes = scheduleTaskForRootDuringMicrotask(root2, currentTime);
        if (0 === nextLanes)
          root2.next = null, null === prev4 ? firstScheduledRoot = next4 : prev4.next = next4, null === next4 && (lastScheduledRoot = prev4);
        else if (prev4 = root2, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
          mightHavePendingSyncWork = true;
        root2 = next4;
      }
      flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
    }
    function scheduleTaskForRootDuringMicrotask(root2, currentTime) {
      for (var suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes, expirationTimes = root2.expirationTimes, lanes = root2.pendingLanes & -62914561; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2, expirationTime = expirationTimes[index2];
        if (-1 === expirationTime) {
          if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
            expirationTimes[index2] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root2.expiredLanes |= lane);
        lanes &= ~lane;
      }
      currentTime = workInProgressRoot;
      suspendedLanes = workInProgressRootRenderLanes;
      suspendedLanes = getNextLanes(
        root2,
        root2 === currentTime ? suspendedLanes : 0,
        null !== root2.cancelPendingCommit || root2.timeoutHandle !== noTimeout
      );
      pingedLanes = root2.callbackNode;
      if (0 === suspendedLanes || root2 === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root2.cancelPendingCommit)
        return null !== pingedLanes && cancelCallback(pingedLanes), root2.callbackNode = null, root2.callbackPriority = 0;
      if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root2, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime !== root2.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode)
          cancelCallback(pingedLanes);
        else return currentTime;
        switch (lanesToEventPriority(suspendedLanes)) {
          case DiscreteEventPriority:
          case ContinuousEventPriority:
            suspendedLanes = UserBlockingPriority;
            break;
          case DefaultEventPriority:
            suspendedLanes = NormalPriority$1;
            break;
          case IdleEventPriority:
            suspendedLanes = IdlePriority;
            break;
          default:
            suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root2);
        null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root2.callbackPriority = currentTime;
        root2.callbackNode = suspendedLanes;
        return currentTime;
      }
      null !== pingedLanes && cancelCallback(pingedLanes);
      root2.callbackPriority = 2;
      root2.callbackNode = null;
      return 2;
    }
    function performWorkOnRootViaSchedulerTask(root2, didTimeout) {
      nestedUpdateScheduled = currentUpdateIsNested = false;
      if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE)
        return root2.callbackNode = null, root2.callbackPriority = 0, null;
      var originalCallbackNode = root2.callbackNode;
      if (flushPendingEffects() && root2.callbackNode !== originalCallbackNode)
        return null;
      var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
      workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
        root2,
        root2 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
        null !== root2.cancelPendingCommit || root2.timeoutHandle !== noTimeout
      );
      if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
      performWorkOnRoot(
        root2,
        workInProgressRootRenderLanes$jscomp$0,
        didTimeout
      );
      scheduleTaskForRootDuringMicrotask(root2, now$1());
      return null != root2.callbackNode && root2.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root2) : null;
    }
    function performSyncWorkOnRoot(root2, lanes) {
      if (flushPendingEffects()) return null;
      currentUpdateIsNested = nestedUpdateScheduled;
      nestedUpdateScheduled = false;
      performWorkOnRoot(root2, lanes, true);
    }
    function cancelCallback(callbackNode) {
      callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
      null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
        processRootScheduleInMicrotask();
        return null;
      });
      scheduleMicrotask(function() {
        (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(
          ImmediatePriority,
          processRootScheduleInImmediateTask
        ) : processRootScheduleInMicrotask();
      });
    }
    function requestTransitionLane() {
      0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
      return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
      if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp)
        return null;
      if ("function" === typeof actionProp) return actionProp;
      checkAttributeStringCoercion(actionProp, "action");
      return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
      var temp = submitter.ownerDocument.createElement("input");
      temp.name = submitter.name;
      temp.value = submitter.value;
      form.id && temp.setAttribute("form", form.id);
      submitter.parentNode.insertBefore(temp, submitter);
      form = new FormData(form);
      temp.parentNode.removeChild(temp);
      return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
      if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action3 = coerceFormActionProp(
          (nativeEventTarget[internalPropsKey] || null).action
        ), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action3 = domEventName, submitter = null));
        var event = new SyntheticEvent(
          "action",
          "action",
          null,
          nativeEvent,
          nativeEventTarget
        );
        dispatchQueue.push({
          event,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (nativeEvent.defaultPrevented) {
                  if (0 !== currentEventTransitionLane) {
                    var formData = submitter ? createFormDataWithSubmitter(
                      nativeEventTarget,
                      submitter
                    ) : new FormData(nativeEventTarget), pendingState = {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action: action3
                    };
                    Object.freeze(pendingState);
                    startHostTransition(
                      maybeTargetInst,
                      pendingState,
                      null,
                      formData
                    );
                  }
                } else
                  "function" === typeof action3 && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(
                    nativeEventTarget,
                    submitter
                  ) : new FormData(nativeEventTarget), pendingState = {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action: action3
                  }, Object.freeze(pendingState), startHostTransition(
                    maybeTargetInst,
                    pendingState,
                    action3,
                    formData
                  ));
              },
              currentTarget: nativeEventTarget
            }
          ]
        });
      }
    }
    function executeDispatch(event, listener, currentTarget) {
      event.currentTarget = currentTarget;
      try {
        listener(event);
      } catch (error2) {
        reportGlobalError(error2);
      }
      event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
      eventSystemFlags = 0 !== (eventSystemFlags & 4);
      for (var i = 0; i < dispatchQueue.length; i++) {
        var _dispatchQueue$i = dispatchQueue[i];
        a: {
          var previousInstance = void 0, event = _dispatchQueue$i.event;
          _dispatchQueue$i = _dispatchQueue$i.listeners;
          if (eventSystemFlags)
            for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
              var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
          else
            for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
              _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
              instance = _dispatchListeners$i.instance;
              currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
        }
      }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
      nonDelegatedEvents.has(domEventName) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        domEventName
      );
      var listenerSet = targetElement[internalEventHandlersKey];
      void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
      var listenerSetKey = domEventName + "__bubble";
      listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
      nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        domEventName
      );
      var eventSystemFlags = 0;
      isCapturePhaseListener && (eventSystemFlags |= 4);
      addTrappedEventListener(
        target,
        domEventName,
        eventSystemFlags,
        isCapturePhaseListener
      );
    }
    function listenToAllSupportedEvents(rootContainerElement) {
      if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
          "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
      }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
      switch (getEventPriority(domEventName)) {
        case DiscreteEventPriority:
          var listenerWrapper = dispatchDiscreteEvent;
          break;
        case ContinuousEventPriority:
          listenerWrapper = dispatchContinuousEvent;
          break;
        default:
          listenerWrapper = dispatchEvent;
      }
      eventSystemFlags = listenerWrapper.bind(
        null,
        domEventName,
        eventSystemFlags,
        targetContainer
      );
      listenerWrapper = void 0;
      !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
      isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: true,
        passive: listenerWrapper
      }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
      }) : targetContainer.addEventListener(
        domEventName,
        eventSystemFlags,
        false
      );
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
      var ancestorInst = targetInst$jscomp$0;
      if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
        a: for (; ; ) {
          if (null === targetInst$jscomp$0) return;
          var nodeTag = targetInst$jscomp$0.tag;
          if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag)
              for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                  return;
                nodeTag = nodeTag.return;
              }
            for (; null !== container; ) {
              nodeTag = getClosestInstanceFromNode(container);
              if (null === nodeTag) return;
              grandTag = nodeTag.tag;
              if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                targetInst$jscomp$0 = ancestorInst = nodeTag;
                continue a;
              }
              container = container.parentNode;
            }
          }
          targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
      batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
          var reactName = topLevelEventsToReactNames.get(domEventName);
          if (void 0 !== reactName) {
            var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
            switch (domEventName) {
              case "keypress":
                if (0 === getEventCharCode(nativeEvent)) break a;
              case "keydown":
              case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
              case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "beforeblur":
              case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "click":
                if (2 === nativeEvent.button) break a;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
              case ANIMATION_END:
              case ANIMATION_ITERATION:
              case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
              case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
              case "scroll":
              case "scrollend":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
              case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
              case "copy":
              case "cut":
              case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
              case "toggle":
              case "beforetoggle":
                SyntheticEventCtor = SyntheticToggleEvent;
            }
            var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
            inCapturePhase = [];
            for (var instance = targetInst, lastHostComponent; null !== instance; ) {
              var _instance2 = instance;
              lastHostComponent = _instance2.stateNode;
              _instance2 = _instance2.tag;
              5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(
                createDispatchListener(
                  instance,
                  _instance2,
                  lastHostComponent
                )
              ));
              if (accumulateTargetOnly) break;
              instance = instance.return;
            }
            0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
              reactName,
              reactEventType,
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: reactName,
              listeners: inCapturePhase
            }));
          }
        }
        if (0 === (eventSystemFlags & 7)) {
          a: {
            reactName = "mouseover" === domEventName || "pointerover" === domEventName;
            SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
            if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
              break a;
            if (SyntheticEventCtor || reactName) {
              reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
              if (SyntheticEventCtor) {
                if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                  reactEventType = null;
              } else SyntheticEventCtor = null, reactEventType = targetInst;
              if (SyntheticEventCtor !== reactEventType) {
                inCapturePhase = SyntheticMouseEvent;
                _instance2 = "onMouseLeave";
                reactEventName = "onMouseEnter";
                instance = "mouse";
                if ("pointerout" === domEventName || "pointerover" === domEventName)
                  inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                reactName = new inCapturePhase(
                  _instance2,
                  instance + "leave",
                  SyntheticEventCtor,
                  nativeEvent,
                  nativeEventTarget
                );
                reactName.target = accumulateTargetOnly;
                reactName.relatedTarget = lastHostComponent;
                _instance2 = null;
                getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                  reactEventName,
                  instance + "enter",
                  reactEventType,
                  nativeEvent,
                  nativeEventTarget
                ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                accumulateTargetOnly = _instance2;
                if (SyntheticEventCtor && reactEventType)
                  b: {
                    inCapturePhase = SyntheticEventCtor;
                    reactEventName = reactEventType;
                    instance = 0;
                    for (lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))
                      instance++;
                    lastHostComponent = 0;
                    for (_instance2 = reactEventName; _instance2; _instance2 = getParent(_instance2))
                      lastHostComponent++;
                    for (; 0 < instance - lastHostComponent; )
                      inCapturePhase = getParent(inCapturePhase), instance--;
                    for (; 0 < lastHostComponent - instance; )
                      reactEventName = getParent(reactEventName), lastHostComponent--;
                    for (; instance--; ) {
                      if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate)
                        break b;
                      inCapturePhase = getParent(inCapturePhase);
                      reactEventName = getParent(reactEventName);
                    }
                    inCapturePhase = null;
                  }
                else inCapturePhase = null;
                null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  reactName,
                  SyntheticEventCtor,
                  inCapturePhase,
                  false
                );
                null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  accumulateTargetOnly,
                  reactEventType,
                  inCapturePhase,
                  true
                );
              }
            }
          }
          a: {
            reactName = targetInst ? getNodeFromInstance(targetInst) : window;
            SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
            if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
              var getTargetInstFunc = getTargetInstForChangeEvent;
            else if (isTextInputElement(reactName))
              if (isInputEventSupported)
                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
              else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                var handleEventFunc = handleEventsForInputEventPolyfill;
              }
            else
              SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
            if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
              createAndAccumulateChangeEvent(
                dispatchQueue,
                getTargetInstFunc,
                nativeEvent,
                nativeEventTarget
              );
              break a;
            }
            handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
          }
          handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
          switch (domEventName) {
            case "focusin":
              if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
                activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
              break;
            case "focusout":
              lastSelection = activeElementInst = activeElement = null;
              break;
            case "mousedown":
              mouseDown = true;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              mouseDown = false;
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
              break;
            case "selectionchange":
              if (skipSelectionChangeEvent) break;
            case "keydown":
            case "keyup":
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
          }
          var fallbackData;
          if (canUseCompositionEvent)
            b: {
              switch (domEventName) {
                case "compositionstart":
                  var eventType = "onCompositionStart";
                  break b;
                case "compositionend":
                  eventType = "onCompositionEnd";
                  break b;
                case "compositionupdate":
                  eventType = "onCompositionUpdate";
                  break b;
              }
              eventType = void 0;
            }
          else
            isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
          eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData2()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(
            targetInst,
            eventType
          ), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
            eventType,
            domEventName,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: eventType,
            listeners: handleEventFunc
          }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
          if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
            eventType = accumulateTwoPhaseListeners(
              targetInst,
              "onBeforeInput"
            ), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent(
              "onBeforeInput",
              "beforeinput",
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: handleEventFunc,
              listeners: eventType
            }), handleEventFunc.data = fallbackData);
          extractEvents$1(
            dispatchQueue,
            domEventName,
            targetInst,
            nativeEvent,
            nativeEventTarget
          );
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
      });
    }
    function createDispatchListener(instance, listener, currentTarget) {
      return {
        instance,
        listener,
        currentTarget
      };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
      for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
        var _instance3 = targetFiber, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
      }
      return [];
    }
    function getParent(inst) {
      if (null === inst) return null;
      do
        inst = inst.return;
      while (inst && 5 !== inst.tag && 27 !== inst.tag);
      return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common2, inCapturePhase) {
      for (var registrationName = event._reactName, listeners = []; null !== target && target !== common2; ) {
        var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
        _instance4 = _instance4.tag;
        if (null !== alternate && alternate === common2) break;
        5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
          createDispatchListener(target, stateNode, alternate)
        )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
          createDispatchListener(target, stateNode, alternate)
        )));
        target = target.return;
      }
      0 !== listeners.length && dispatchQueue.push({ event, listeners });
    }
    function validatePropertiesInDevelopment(type4, props) {
      validateProperties$2(type4, props);
      "input" !== type4 && "textarea" !== type4 && "select" !== type4 || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = true, "select" === type4 && props.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        type4
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        type4
      ));
      var eventRegistry = {
        registrationNameDependencies,
        possibleRegistrationNames
      };
      isCustomElement(type4) || "string" === typeof props.is || warnUnknownProperties(type4, props, eventRegistry);
      props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
      serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
      attributeNames.forEach(function(attributeName) {
        serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
      });
    }
    function warnForInvalidEventListener(registrationName, listener) {
      false === listener ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        registrationName,
        registrationName,
        registrationName
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        registrationName,
        typeof listener
      );
    }
    function normalizeHTML(parent, html) {
      parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(
        parent.namespaceURI,
        parent.tagName
      ) : parent.ownerDocument.createElement(parent.tagName);
      parent.innerHTML = html;
      return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
      willCoercionThrow(markup) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        typeName(markup)
      ), testStringCoercion(markup));
      return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
      clientText = normalizeMarkupForTextOrAttribute(clientText);
      return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
    }
    function noop$12() {
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
      switch (key) {
        case "children":
          if ("string" === typeof value)
            validateTextNesting(value, tag, false), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
          else if ("number" === typeof value || "bigint" === typeof value)
            validateTextNesting("" + value, tag, false), "body" !== tag && setTextContent(domElement, "" + value);
          break;
        case "className":
          setValueForKnownAttribute(domElement, "class", value);
          break;
        case "tabIndex":
          setValueForKnownAttribute(domElement, "tabindex", value);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          setValueForKnownAttribute(domElement, key, value);
          break;
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "data":
          if ("object" !== tag) {
            setValueForKnownAttribute(domElement, "data", value);
            break;
          }
        case "src":
        case "href":
          if ("" === value && ("a" !== tag || "href" !== key)) {
            "src" === key ? console.error(
              'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            ) : console.error(
              'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            );
            domElement.removeAttribute(key);
            break;
          }
          if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "action":
        case "formAction":
          null != value && ("form" === tag ? "formAction" === key ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : "input" === tag || "button" === tag ? "action" === key ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = true, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (didWarnFormActionType = true, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (didWarnFormActionType = true, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : "action" === key ? console.error(
            "You can only pass the action prop to <form>."
          ) : console.error(
            "You can only pass the formAction prop to <input> or <button>."
          ));
          if ("function" === typeof value) {
            domElement.setAttribute(
              key,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(
              domElement,
              tag,
              "formEncType",
              props.formEncType,
              props,
              null
            ), setProp(
              domElement,
              tag,
              "formMethod",
              props.formMethod,
              props,
              null
            ), setProp(
              domElement,
              tag,
              "formTarget",
              props.formTarget,
              props,
              null
            )) : (setProp(
              domElement,
              tag,
              "encType",
              props.encType,
              props,
              null
            ), setProp(domElement, tag, "method", props.method, props, null), setProp(
              domElement,
              tag,
              "target",
              props.target,
              props,
              null
            )));
          if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "multiple":
          domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "muted":
          domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
            domElement.removeAttribute("xlink:href");
            break;
          }
          checkAttributeStringCoercion(value, key);
          key = sanitizeURL("" + value);
          domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
          break;
        case "inert":
          "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = true, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            key
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
          break;
        case "capture":
        case "download":
          true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "rowSpan":
        case "start":
          null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
          break;
        case "popover":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          setValueForAttribute(domElement, "popover", value);
          break;
        case "xlinkActuate":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:actuate",
            value
          );
          break;
        case "xlinkArcrole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:arcrole",
            value
          );
          break;
        case "xlinkRole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:role",
            value
          );
          break;
        case "xlinkShow":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:show",
            value
          );
          break;
        case "xlinkTitle":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:title",
            value
          );
          break;
        case "xlinkType":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:type",
            value
          );
          break;
        case "xmlBase":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:base",
            value
          );
          break;
        case "xmlLang":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:lang",
            value
          );
          break;
        case "xmlSpace":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:space",
            value
          );
          break;
        case "is":
          null != prevValue && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          );
          setValueForAttribute(domElement, "is", value);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = true, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            value
          ));
        default:
          !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
      }
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
      switch (key) {
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "children":
          "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (registrationNameDependencies.hasOwnProperty(key))
            null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
          else
            a: {
              if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                domElement.addEventListener(tag, value, props);
                break a;
              }
              key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
      }
    }
    function setInitialProperties(domElement, tag, props) {
      validatePropertiesInDevelopment(tag, props);
      switch (tag) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          var hasSrc = false, hasSrcSet = false, propKey;
          for (propKey in props)
            if (props.hasOwnProperty(propKey)) {
              var propValue = props[propKey];
              if (null != propValue)
                switch (propKey) {
                  case "src":
                    hasSrc = true;
                    break;
                  case "srcSet":
                    hasSrcSet = true;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
          hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
          hasSrc && setProp(domElement, tag, "src", props.src, props, null);
          return;
        case "input":
          checkControlledValueProps("input", props);
          listenToNonDelegatedEvent("invalid", domElement);
          var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
          for (hasSrc in props)
            if (props.hasOwnProperty(hasSrc)) {
              var _propValue = props[hasSrc];
              if (null != _propValue)
                switch (hasSrc) {
                  case "name":
                    hasSrcSet = _propValue;
                    break;
                  case "type":
                    propValue = _propValue;
                    break;
                  case "checked":
                    checked = _propValue;
                    break;
                  case "defaultChecked":
                    defaultChecked = _propValue;
                    break;
                  case "value":
                    propKey = _propValue;
                    break;
                  case "defaultValue":
                    defaultValue = _propValue;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (null != _propValue)
                      throw Error(
                        tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    setProp(domElement, tag, hasSrc, _propValue, props, null);
                }
            }
          validateInputProps(domElement, props);
          initInput(
            domElement,
            propKey,
            defaultValue,
            checked,
            defaultChecked,
            propValue,
            hasSrcSet,
            false
          );
          track(domElement);
          return;
        case "select":
          checkControlledValueProps("select", props);
          listenToNonDelegatedEvent("invalid", domElement);
          hasSrc = propValue = propKey = null;
          for (hasSrcSet in props)
            if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue))
              switch (hasSrcSet) {
                case "value":
                  propKey = defaultValue;
                  break;
                case "defaultValue":
                  propValue = defaultValue;
                  break;
                case "multiple":
                  hasSrc = defaultValue;
                default:
                  setProp(
                    domElement,
                    tag,
                    hasSrcSet,
                    defaultValue,
                    props,
                    null
                  );
              }
          validateSelectProps(domElement, props);
          tag = propKey;
          props = propValue;
          domElement.multiple = !!hasSrc;
          null != tag ? updateOptions(domElement, !!hasSrc, tag, false) : null != props && updateOptions(domElement, !!hasSrc, props, true);
          return;
        case "textarea":
          checkControlledValueProps("textarea", props);
          listenToNonDelegatedEvent("invalid", domElement);
          propKey = hasSrcSet = hasSrc = null;
          for (propValue in props)
            if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue))
              switch (propValue) {
                case "value":
                  hasSrc = defaultValue;
                  break;
                case "defaultValue":
                  hasSrcSet = defaultValue;
                  break;
                case "children":
                  propKey = defaultValue;
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != defaultValue)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag,
                    propValue,
                    defaultValue,
                    props,
                    null
                  );
              }
          validateTextareaProps(domElement, props);
          initTextarea(domElement, hasSrc, hasSrcSet, propKey);
          track(domElement);
          return;
        case "option":
          validateOptionProps(domElement, props);
          for (checked in props)
            if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc))
              switch (checked) {
                case "selected":
                  domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                  break;
                default:
                  setProp(domElement, tag, checked, hasSrc, props, null);
              }
          return;
        case "dialog":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          listenToNonDelegatedEvent("cancel", domElement);
          listenToNonDelegatedEvent("close", domElement);
          break;
        case "iframe":
        case "object":
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "video":
        case "audio":
          for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
            listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
          break;
        case "image":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", domElement);
          break;
        case "embed":
        case "source":
        case "link":
          listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (defaultChecked in props)
            if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc))
              switch (defaultChecked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  setProp(domElement, tag, defaultChecked, hasSrc, props, null);
              }
          return;
        default:
          if (isCustomElement(tag)) {
            for (_propValue in props)
              props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(
                domElement,
                tag,
                _propValue,
                hasSrc,
                props,
                void 0
              ));
            return;
          }
      }
      for (defaultValue in props)
        props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
      validatePropertiesInDevelopment(tag, nextProps);
      switch (tag) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var name = null, type4 = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
          for (propKey in lastProps) {
            var lastProp = lastProps[propKey];
            if (lastProps.hasOwnProperty(propKey) && null != lastProp)
              switch (propKey) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  lastDefaultValue = lastProp;
                default:
                  nextProps.hasOwnProperty(propKey) || setProp(
                    domElement,
                    tag,
                    propKey,
                    null,
                    nextProps,
                    lastProp
                  );
              }
          }
          for (var _propKey8 in nextProps) {
            var propKey = nextProps[_propKey8];
            lastProp = lastProps[_propKey8];
            if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp))
              switch (_propKey8) {
                case "type":
                  type4 = propKey;
                  break;
                case "name":
                  name = propKey;
                  break;
                case "checked":
                  checked = propKey;
                  break;
                case "defaultChecked":
                  defaultChecked = propKey;
                  break;
                case "value":
                  value = propKey;
                  break;
                case "defaultValue":
                  defaultValue = propKey;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propKey)
                    throw Error(
                      tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  propKey !== lastProp && setProp(
                    domElement,
                    tag,
                    _propKey8,
                    propKey,
                    nextProps,
                    lastProp
                  );
              }
          }
          tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
          nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
          tag || !nextProps || didWarnUncontrolledToControlled || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnUncontrolledToControlled = true);
          !tag || nextProps || didWarnControlledToUncontrolled || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnControlledToUncontrolled = true);
          updateInput(
            domElement,
            value,
            defaultValue,
            lastDefaultValue,
            checked,
            defaultChecked,
            type4,
            name
          );
          return;
        case "select":
          propKey = value = defaultValue = _propKey8 = null;
          for (type4 in lastProps)
            if (lastDefaultValue = lastProps[type4], lastProps.hasOwnProperty(type4) && null != lastDefaultValue)
              switch (type4) {
                case "value":
                  break;
                case "multiple":
                  propKey = lastDefaultValue;
                default:
                  nextProps.hasOwnProperty(type4) || setProp(
                    domElement,
                    tag,
                    type4,
                    null,
                    nextProps,
                    lastDefaultValue
                  );
              }
          for (name in nextProps)
            if (type4 = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type4 || null != lastDefaultValue))
              switch (name) {
                case "value":
                  _propKey8 = type4;
                  break;
                case "defaultValue":
                  defaultValue = type4;
                  break;
                case "multiple":
                  value = type4;
                default:
                  type4 !== lastDefaultValue && setProp(
                    domElement,
                    tag,
                    name,
                    type4,
                    nextProps,
                    lastDefaultValue
                  );
              }
          nextProps = defaultValue;
          tag = value;
          lastProps = propKey;
          null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, false) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, true) : updateOptions(domElement, !!tag, tag ? [] : "", false));
          return;
        case "textarea":
          propKey = _propKey8 = null;
          for (defaultValue in lastProps)
            if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue))
              switch (defaultValue) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  setProp(domElement, tag, defaultValue, null, nextProps, name);
              }
          for (value in nextProps)
            if (name = nextProps[value], type4 = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type4))
              switch (value) {
                case "value":
                  _propKey8 = name;
                  break;
                case "defaultValue":
                  propKey = name;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != name)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  name !== type4 && setProp(domElement, tag, value, name, nextProps, type4);
              }
          updateTextarea(domElement, _propKey8, propKey);
          return;
        case "option":
          for (var _propKey13 in lastProps)
            if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13))
              switch (_propKey13) {
                case "selected":
                  domElement.selected = false;
                  break;
                default:
                  setProp(
                    domElement,
                    tag,
                    _propKey13,
                    null,
                    nextProps,
                    _propKey8
                  );
              }
          for (lastDefaultValue in nextProps)
            if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (lastDefaultValue) {
                case "selected":
                  domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                  break;
                default:
                  setProp(
                    domElement,
                    tag,
                    lastDefaultValue,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var _propKey15 in lastProps)
            _propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(
              domElement,
              tag,
              _propKey15,
              null,
              nextProps,
              _propKey8
            );
          for (checked in nextProps)
            if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (checked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != _propKey8)
                    throw Error(
                      tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag,
                    checked,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        default:
          if (isCustomElement(tag)) {
            for (var _propKey17 in lastProps)
              _propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(
                domElement,
                tag,
                _propKey17,
                void 0,
                nextProps,
                _propKey8
              );
            for (defaultChecked in nextProps)
              _propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(
                domElement,
                tag,
                defaultChecked,
                _propKey8,
                nextProps,
                propKey
              );
            return;
          }
      }
      for (var _propKey19 in lastProps)
        _propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
      for (lastProp in nextProps)
        _propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
      switch (attrName) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return attrName;
      }
    }
    function getStylesObjectFromElement(domElement) {
      var serverValueInObjectForm = {};
      domElement = domElement.style;
      for (var i = 0; i < domElement.length; i++) {
        var styleName = domElement[i];
        serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
      }
      return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
      if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0)
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var clientValue;
        var delimiter2 = clientValue = "", styleName;
        for (styleName in value$jscomp$0)
          if (value$jscomp$0.hasOwnProperty(styleName)) {
            var value = value$jscomp$0[styleName];
            null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter2 + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter2 + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter2 + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter2 = ";");
          }
        clientValue = clientValue || null;
        value$jscomp$0 = domElement.getAttribute("style");
        value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
      }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement) {
        switch (typeof value) {
          case "function":
          case "symbol":
            return;
        }
        if (!value) return;
      } else
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (value) return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(value)) return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value))
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
      for (var serverDifferences = {}, extraAttributes = /* @__PURE__ */ new Set(), attributes2 = domElement.attributes, i = 0; i < attributes2.length; i++)
        switch (attributes2[i].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            extraAttributes.add(attributes2[i].name);
        }
      if (isCustomElement(tag))
        for (var propKey in props) {
          if (props.hasOwnProperty(propKey)) {
            var value = props[propKey];
            if (null != value) {
              if (registrationNameDependencies.hasOwnProperty(propKey))
                "function" !== typeof value && warnForInvalidEventListener(propKey, value);
              else if (true !== props.suppressHydrationWarning)
                switch (propKey) {
                  case "children":
                    "string" !== typeof value && "number" !== typeof value || warnForPropDifference(
                      "children",
                      domElement.textContent,
                      value,
                      serverDifferences
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    attributes2 = domElement.innerHTML;
                    value = value ? value.__html : void 0;
                    null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(
                      propKey,
                      attributes2,
                      value,
                      serverDifferences
                    ));
                    continue;
                  case "style":
                    extraAttributes.delete(propKey);
                    diffHydratedStyles(domElement, value, serverDifferences);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    extraAttributes.delete(propKey.toLowerCase());
                    console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      propKey
                    );
                    continue;
                  case "className":
                    extraAttributes.delete("class");
                    attributes2 = getValueForAttributeOnCustomComponent(
                      domElement,
                      "class",
                      value
                    );
                    warnForPropDifference(
                      "className",
                      attributes2,
                      value,
                      serverDifferences
                    );
                    continue;
                  default:
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes2 = getValueForAttributeOnCustomComponent(
                      domElement,
                      propKey,
                      value
                    ), warnForPropDifference(
                      propKey,
                      attributes2,
                      value,
                      serverDifferences
                    );
                }
            }
          }
        }
      else
        for (value in props)
          if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value))
              "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (true !== props.suppressHydrationWarning)
              switch (value) {
                case "children":
                  "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference(
                    "children",
                    domElement.textContent,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  attributes2 = domElement.innerHTML;
                  propKey = propKey ? propKey.__html : void 0;
                  null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes2 !== propKey && (serverDifferences[value] = { __html: attributes2 }));
                  continue;
                case "className":
                  hydrateAttribute(
                    domElement,
                    value,
                    "class",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "tabIndex":
                  hydrateAttribute(
                    domElement,
                    value,
                    "tabindex",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "style":
                  extraAttributes.delete(value);
                  diffHydratedStyles(domElement, propKey, serverDifferences);
                  continue;
                case "multiple":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.multiple,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "muted":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.muted,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "autoFocus":
                  extraAttributes.delete("autofocus");
                  warnForPropDifference(
                    value,
                    domElement.autofocus,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "data":
                  if ("object" !== tag) {
                    extraAttributes.delete(value);
                    attributes2 = domElement.getAttribute("data");
                    warnForPropDifference(
                      value,
                      attributes2,
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                    "src" === value ? console.error(
                      'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    ) : console.error(
                      'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "action":
                case "formAction":
                  attributes2 = domElement.getAttribute(value);
                  if ("function" === typeof propKey) {
                    extraAttributes.delete(value.toLowerCase());
                    "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                    continue;
                  } else if (attributes2 === EXPECTED_FORM_ACTION_URL) {
                    extraAttributes.delete(value.toLowerCase());
                    warnForPropDifference(
                      value,
                      "function",
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkHref":
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    "xlink:href",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "contentEditable":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "contenteditable",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "spellCheck":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "spellcheck",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "capture":
                case "download":
                  a: {
                    i = domElement;
                    var attributeName = attributes2 = value, serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i = i.getAttribute(attributeName);
                    if (null === i)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break a;
                        default:
                          if (false === propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (true === propKey && "" === i) break a;
                          break;
                        default:
                          if (checkAttributeStringCoercion(propKey, attributes2), i === "" + propKey)
                            break a;
                      }
                    warnForPropDifference(
                      attributes2,
                      i,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  a: {
                    i = domElement;
                    attributeName = attributes2 = value;
                    serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i = i.getAttribute(attributeName);
                    if (null === i)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break a;
                        default:
                          if (isNaN(propKey) || 1 > propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes2), i === "" + propKey))
                            break a;
                      }
                    warnForPropDifference(
                      attributes2,
                      i,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "rowSpan":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    "rowspan",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "start":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xHeight":
                  hydrateAttribute(
                    domElement,
                    value,
                    "x-height",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkActuate":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:actuate",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkArcrole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:arcrole",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkRole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:role",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkShow":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:show",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkTitle":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:title",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkType":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:type",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlBase":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:base",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlLang":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:lang",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlSpace":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:space",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "inert":
                  "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = true, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    value
                  ));
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                default:
                  if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                    i = getAttributeAlias(value);
                    attributes2 = false;
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(
                      attributeName
                    ) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes2 = true, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                    a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0))
                      if (attributeName.hasAttribute(serverDifferences$jscomp$0))
                        attributeName = attributeName.getAttribute(
                          serverDifferences$jscomp$0
                        ), checkAttributeStringCoercion(
                          i,
                          serverDifferences$jscomp$0
                        ), i = attributeName === "" + i ? i : attributeName;
                      else {
                        switch (typeof i) {
                          case "function":
                          case "symbol":
                            break a;
                          case "boolean":
                            if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName)
                              break a;
                        }
                        i = void 0 === i ? void 0 : null;
                      }
                    else i = void 0;
                    attributes2 || warnForPropDifference(
                      value,
                      i,
                      propKey,
                      serverDifferences
                    );
                  }
              }
          }
      0 < extraAttributes.size && true !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
      return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
      switch (list.length) {
        case 0:
          return "";
        case 1:
          return list[0];
        case 2:
          return list[0] + " " + combinator + " " + list[1];
        default:
          return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
      }
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
      return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
      switch (namespaceURI) {
        case SVG_NAMESPACE:
          return HostContextNamespaceSvg;
        case MATH_NAMESPACE:
          return HostContextNamespaceMath;
        default:
          return HostContextNamespaceNone;
      }
    }
    function getChildHostContextProd(parentNamespace, type4) {
      if (parentNamespace === HostContextNamespaceNone)
        switch (type4) {
          case "svg":
            return HostContextNamespaceSvg;
          case "math":
            return HostContextNamespaceMath;
          default:
            return HostContextNamespaceNone;
        }
      return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type4 ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type4, props) {
      return "textarea" === type4 || "noscript" === type4 || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
      var event = window.event;
      if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return false;
        currentPopstateTransitionEvent = event;
        return true;
      }
      currentPopstateTransitionEvent = null;
      return false;
    }
    function handleErrorInNextTick(error2) {
      setTimeout(function() {
        throw error2;
      });
    }
    function commitMount(domElement, type4, newProps) {
      switch (type4) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          newProps.autoFocus && domElement.focus();
          break;
        case "img":
          newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
      }
    }
    function commitUpdate(domElement, type4, oldProps, newProps) {
      updateProperties(domElement, type4, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
      setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
      textInstance.nodeValue = newText;
    }
    function isSingletonScope(type4) {
      return "head" === type4;
    }
    function removeChild(parentInstance, child) {
      parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
      (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
      var node2 = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
      do {
        var nextNode = node2.nextSibling;
        parentInstance.removeChild(node2);
        if (nextNode && 8 === nextNode.nodeType)
          if (node2 = nextNode.data, node2 === SUSPENSE_END_DATA) {
            if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
              node2 = possiblePreambleContribution;
              var ownerDocument = parentInstance.ownerDocument;
              node2 & PREAMBLE_CONTRIBUTION_HTML && releaseSingletonInstance(ownerDocument.documentElement);
              node2 & PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(ownerDocument.body);
              if (node2 & PREAMBLE_CONTRIBUTION_HEAD)
                for (node2 = ownerDocument.head, releaseSingletonInstance(node2), ownerDocument = node2.firstChild; ownerDocument; ) {
                  var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                  ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node2.removeChild(ownerDocument);
                  ownerDocument = nextNode$jscomp$0;
                }
            }
            if (0 === depth) {
              parentInstance.removeChild(nextNode);
              retryIfBlockedOn(suspenseInstance);
              return;
            }
            depth--;
          } else
            node2 === SUSPENSE_START_DATA || node2 === SUSPENSE_PENDING_START_DATA || node2 === SUSPENSE_FALLBACK_START_DATA ? depth++ : possiblePreambleContribution = node2.charCodeAt(0) - 48;
        else possiblePreambleContribution = 0;
        node2 = nextNode;
      } while (node2);
      retryIfBlockedOn(suspenseInstance);
    }
    function hideInstance(instance) {
      instance = instance.style;
      "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
      textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
      props = props[STYLE];
      props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
      instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text2) {
      textInstance.nodeValue = text2;
    }
    function clearContainerSparingly(container) {
      var nextNode = container.firstChild;
      nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
      for (; nextNode; ) {
        var node2 = nextNode;
        nextNode = nextNode.nextSibling;
        switch (node2.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            clearContainerSparingly(node2);
            detachDeletedInstance(node2);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if ("stylesheet" === node2.rel.toLowerCase()) continue;
        }
        container.removeChild(node2);
      }
    }
    function canHydrateInstance(instance, type4, props, inRootOrSingleton) {
      for (; 1 === instance.nodeType; ) {
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type4.toLowerCase()) {
          if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
            break;
        } else if (!inRootOrSingleton)
          if ("input" === type4 && "hidden" === instance.type) {
            checkAttributeStringCoercion(anyProps.name, "name");
            var name = null == anyProps.name ? null : "" + anyProps.name;
            if ("hidden" === anyProps.type && instance.getAttribute("name") === name)
              return instance;
          } else return instance;
        else if (!instance[internalHoistableMarker])
          switch (type4) {
            case "meta":
              if (!instance.hasAttribute("itemprop")) break;
              return instance;
            case "link":
              name = instance.getAttribute("rel");
              if ("stylesheet" === name && instance.hasAttribute("data-precedence"))
                break;
              else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
                break;
              return instance;
            case "style":
              if (instance.hasAttribute("data-precedence")) break;
              return instance;
            case "script":
              name = instance.getAttribute("src");
              if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
                break;
              return instance;
            default:
              return instance;
          }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
      }
      return null;
    }
    function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
      if ("" === text2) return null;
      for (; 3 !== instance.nodeType; ) {
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
          return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
      }
      return instance;
    }
    function isSuspenseInstanceFallback(instance) {
      return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState === DOCUMENT_READY_STATE_COMPLETE;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
      var ownerDocument = instance.ownerDocument;
      if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState === DOCUMENT_READY_STATE_COMPLETE)
        callback();
      else {
        var listener = function() {
          callback();
          ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
      }
    }
    function getNextHydratable(node2) {
      for (; null != node2; node2 = node2.nextSibling) {
        var nodeType = node2.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
          nodeType = node2.data;
          if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING)
            break;
          if (nodeType === SUSPENSE_END_DATA) return null;
        }
      }
      return node2;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
      if (1 === instance.nodeType) {
        for (var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes2 = instance.attributes, i = 0; i < attributes2.length; i++) {
          var attr = attributes2[i];
          serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
        }
        return { type: JSCompiler_temp_const, props: serverDifferences };
      }
      return 8 === instance.nodeType ? { type: "Suspense", props: {} } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text2, parentProps) {
      return null === parentProps || true !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text2 ? textInstance = null : (text2 = normalizeMarkupForTextOrAttribute(text2), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text2 ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
      suspenseInstance = suspenseInstance.nextSibling;
      for (var depth = 0; suspenseInstance; ) {
        if (8 === suspenseInstance.nodeType) {
          var data2 = suspenseInstance.data;
          if (data2 === SUSPENSE_END_DATA) {
            if (0 === depth)
              return getNextHydratable(suspenseInstance.nextSibling);
            depth--;
          } else
            data2 !== SUSPENSE_START_DATA && data2 !== SUSPENSE_FALLBACK_START_DATA && data2 !== SUSPENSE_PENDING_START_DATA || depth++;
        }
        suspenseInstance = suspenseInstance.nextSibling;
      }
      return null;
    }
    function getParentSuspenseInstance(targetInstance) {
      targetInstance = targetInstance.previousSibling;
      for (var depth = 0; targetInstance; ) {
        if (8 === targetInstance.nodeType) {
          var data2 = targetInstance.data;
          if (data2 === SUSPENSE_START_DATA || data2 === SUSPENSE_FALLBACK_START_DATA || data2 === SUSPENSE_PENDING_START_DATA) {
            if (0 === depth) return targetInstance;
            depth--;
          } else data2 === SUSPENSE_END_DATA && depth++;
        }
        targetInstance = targetInstance.previousSibling;
      }
      return null;
    }
    function commitHydratedContainer(container) {
      retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
      retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type4, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
      validateDOMNestingDev && validateDOMNesting(type4, hostContext.ancestorInfo);
      props = getOwnerDocumentFromRootContainer(rootContainerInstance);
      switch (type4) {
        case "html":
          type4 = props.documentElement;
          if (!type4)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type4;
        case "head":
          type4 = props.head;
          if (!type4)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type4;
        case "body":
          type4 = props.body;
          if (!type4)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type4;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function acquireSingletonInstance(type4, props, instance, internalInstanceHandle) {
      if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
        var tagName = instance.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          tagName,
          tagName,
          tagName
        );
      }
      switch (type4) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (tagName = instance.attributes; tagName.length; )
        instance.removeAttributeNode(tagName[0]);
      setInitialProperties(instance, type4, props);
      instance[internalInstanceKey] = internalInstanceHandle;
      instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance) {
      for (var attributes2 = instance.attributes; attributes2.length; )
        instance.removeAttributeNode(attributes2[0]);
      detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
      return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
      var ownerDocument = globalDocument;
      if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
      }
    }
    function getResource(type4, currentProps, pendingProps, currentResource) {
      var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
      if (!resourceRoot)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (type4) {
        case "meta":
        case "title":
          return null;
        case "style":
          return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
            type4 = getStyleKey(pendingProps.href);
            var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type4);
            if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: NotLoaded, preload: null }
            }, _styles.set(type4, _resource), (_styles = resourceRoot.querySelector(
              getStylesheetSelectorFromKey(type4)
            )) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type4))) {
              var preloadProps = {
                rel: "preload",
                as: "style",
                href: pendingProps.href,
                crossOrigin: pendingProps.crossOrigin,
                integrity: pendingProps.integrity,
                media: pendingProps.media,
                hrefLang: pendingProps.hrefLang,
                referrerPolicy: pendingProps.referrerPolicy
              };
              preloadPropsMap.set(type4, preloadProps);
              _styles || preloadStylesheet(
                resourceRoot,
                type4,
                preloadProps,
                _resource.state
              );
            }
            if (currentProps && null === currentResource)
              throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
              );
            return _resource;
          }
          if (currentProps && null !== currentResource)
            throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
            );
          return null;
        case "script":
          return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + type4 + '". this is a bug in React.'
          );
      }
    }
    function describeLinkForResourceErrorDEV(props) {
      var describedProps = 0, description = "<link";
      "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
      "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
      "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
      Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
      return description + " />";
    }
    function getStyleKey(href) {
      return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
      return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
      return assign2({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
      });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
      ownerDocument.querySelector(
        'link[rel="preload"][as="style"][' + key + "]"
      ) ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= Loaded;
      }), key.addEventListener("error", function() {
        return state.loading |= Errored;
      }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
      return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
      return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
      resource.count++;
      if (null === resource.instance)
        switch (resource.type) {
          case "style":
            var instance = hoistableRoot.querySelector(
              'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]'
            );
            if (instance)
              return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign2({}, props, {
              "data-href": props.href,
              "data-precedence": props.precedence,
              href: null,
              precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
          case "stylesheet":
            styleProps = getStyleKey(props.href);
            var _instance = hoistableRoot.querySelector(
              getStylesheetSelectorFromKey(styleProps)
            );
            if (_instance)
              return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(_instance);
            var linkInstance = _instance;
            linkInstance._p = new Promise(function(resolve, reject) {
              linkInstance.onload = resolve;
              linkInstance.onerror = reject;
            });
            setInitialProperties(_instance, "link", instance);
            resource.state.loading |= Inserted;
            insertStylesheet(_instance, props.precedence, hoistableRoot);
            return resource.instance = _instance;
          case "script":
            _instance = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(
              getScriptSelectorFromKey(_instance)
            ))
              return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(_instance))
              instance = assign2({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.'
            );
        }
      else
        "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
      return resource.instance;
    }
    function insertStylesheet(instance, precedence, root2) {
      for (var nodes = root2.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++) {
        var node2 = nodes[i];
        if (node2.dataset.precedence === precedence) prior = node2;
        else if (prior !== last) break;
      }
      prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root2.nodeType ? root2.head : root2, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
      null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
      null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
      null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
      null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
      null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
      null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type4, keyAttribute, ownerDocument) {
      if (null === tagCaches) {
        var cache2 = /* @__PURE__ */ new Map();
        var caches = tagCaches = /* @__PURE__ */ new Map();
        caches.set(ownerDocument, cache2);
      } else
        caches = tagCaches, cache2 = caches.get(ownerDocument), cache2 || (cache2 = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache2));
      if (cache2.has(type4)) return cache2;
      cache2.set(type4, null);
      ownerDocument = ownerDocument.getElementsByTagName(type4);
      for (caches = 0; caches < ownerDocument.length; caches++) {
        var node2 = ownerDocument[caches];
        if (!(node2[internalHoistableMarker] || node2[internalInstanceKey] || "link" === type4 && "stylesheet" === node2.getAttribute("rel")) && node2.namespaceURI !== SVG_NAMESPACE) {
          var nodeKey = node2.getAttribute(keyAttribute) || "";
          nodeKey = type4 + nodeKey;
          var existing = cache2.get(nodeKey);
          existing ? existing.push(node2) : cache2.set(nodeKey, [node2]);
        }
      }
      return cache2;
    }
    function mountHoistable(hoistableRoot, type4, instance) {
      hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
      hoistableRoot.head.insertBefore(
        instance,
        "title" === type4 ? hoistableRoot.querySelector("head > title") : null
      );
    }
    function isHostHoistableType(type4, props, hostContext) {
      var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
      if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp)
        return !outsideHostContainerContext || null == props.itemProp || "meta" !== type4 && "title" !== type4 && "style" !== type4 && "link" !== type4 && "script" !== type4 || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          type4,
          type4
        ), false;
      switch (type4) {
        case "meta":
        case "title":
          return true;
        case "style":
          if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
            outsideHostContainerContext && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return true;
        case "link":
          if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
            if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
              type4 = props.href;
              var onError = props.onError, disabled = props.disabled;
              hostContext = [];
              props.onLoad && hostContext.push("`onLoad`");
              onError && hostContext.push("`onError`");
              null != disabled && hostContext.push("`disabled`");
              onError = propNamesListJoin(hostContext, "and");
              onError += 1 === hostContext.length ? " prop" : " props";
              disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
              hostContext.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                type4,
                disabled,
                onError
              );
            }
            outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (props.onError || props.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (props.rel) {
            case "stylesheet":
              return type4 = props.precedence, props = props.disabled, "string" !== typeof type4 && outsideHostContainerContext && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), "string" === typeof type4 && null == props;
            default:
              return true;
          }
        case "script":
          type4 = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
          if (!type4 || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
            outsideHostContainerContext && (type4 ? props.onLoad || props.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return true;
        case "noscript":
        case "template":
          outsideHostContainerContext && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            type4
          );
      }
      return false;
    }
    function preloadResource(resource) {
      return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? false : true;
    }
    function noop4() {
    }
    function suspendResource(hoistableRoot, resource, props) {
      if (null === suspendedState)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var state = suspendedState;
      if ("stylesheet" === resource.type && ("string" !== typeof props.media || false !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
        if (null === resource.instance) {
          var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(key)
          );
          if (instance) {
            hoistableRoot = instance._p;
            null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
            resource.state.loading |= Inserted;
            resource.instance = instance;
            markNodeAsHoistable(instance);
            return;
          }
          instance = hoistableRoot.ownerDocument || hoistableRoot;
          props = stylesheetPropsFromRawProps(props);
          (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
          instance = instance.createElement("link");
          markNodeAsHoistable(instance);
          var linkInstance = instance;
          linkInstance._p = new Promise(function(resolve, reject) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject;
          });
          setInitialProperties(instance, "link", props);
          resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
      }
    }
    function waitForCommitToBeReady() {
      if (null === suspendedState)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var state = suspendedState;
      state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
      return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
          state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
          if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
          state.unsuspend = null;
          clearTimeout(stylesheetTimer);
        };
      } : null;
    }
    function onUnsuspend() {
      this.count--;
      if (0 === this.count) {
        if (this.stylesheets)
          insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
          var unsuspend = this.unsuspend;
          this.unsuspend = null;
          unsuspend();
        }
      }
    }
    function insertSuspendedStylesheets(state, resources) {
      state.stylesheets = null;
      null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root2, resource) {
      if (!(resource.state.loading & Inserted)) {
        var precedences = precedencesByRoot.get(root2);
        if (precedences) var last = precedences.get(LAST_PRECEDENCE);
        else {
          precedences = /* @__PURE__ */ new Map();
          precedencesByRoot.set(root2, precedences);
          for (var nodes = root2.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), i = 0; i < nodes.length; i++) {
            var node2 = nodes[i];
            if ("LINK" === node2.nodeName || "not all" !== node2.getAttribute("media"))
              precedences.set(node2.dataset.precedence, node2), last = node2;
          }
          last && precedences.set(LAST_PRECEDENCE, last);
        }
        nodes = resource.instance;
        node2 = nodes.getAttribute("data-precedence");
        i = precedences.get(node2) || last;
        i === last && precedences.set(LAST_PRECEDENCE, nodes);
        precedences.set(node2, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root2 = 9 === root2.nodeType ? root2.head : root2, root2.insertBefore(nodes, root2.firstChild));
        resource.state.loading |= Inserted;
      }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
      this.tag = 1;
      this.containerInfo = containerInfo;
      this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = noTimeout;
      this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
      this.callbackPriority = 0;
      this.expirationTimes = createLaneMap(-1);
      this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = createLaneMap(0);
      this.hiddenUpdates = createLaneMap(null);
      this.identifierPrefix = identifierPrefix;
      this.onUncaughtError = onUncaughtError;
      this.onCaughtError = onCaughtError;
      this.onRecoverableError = onRecoverableError;
      this.pooledCache = null;
      this.pooledCacheLanes = 0;
      this.formState = formState;
      this.incompleteTransitions = /* @__PURE__ */ new Map();
      this.passiveEffectDuration = this.effectDuration = -0;
      this.memoizedUpdaters = /* @__PURE__ */ new Set();
      containerInfo = this.pendingUpdatersLaneMap = [];
      for (tag = 0; 31 > tag; tag++) containerInfo.push(/* @__PURE__ */ new Set());
      this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
      containerInfo = new FiberRootNode(
        containerInfo,
        tag,
        hydrate,
        identifierPrefix,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        formState
      );
      tag = ConcurrentMode;
      true === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
      isDevToolsPresent && (tag |= ProfileMode);
      isStrictMode = createFiber(3, null, null, tag);
      containerInfo.current = isStrictMode;
      isStrictMode.stateNode = containerInfo;
      tag = createCache3();
      retainCache(tag);
      containerInfo.pooledCache = tag;
      retainCache(tag);
      isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
      };
      initializeUpdateQueue(isStrictMode);
      return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
      if (!parentComponent) return emptyContextObject;
      parentComponent = emptyContextObject;
      return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
      if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot)
        try {
          injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %s",
            err
          ));
        }
      null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markRenderScheduled && injectedProfilingHooks.markRenderScheduled(lane);
      parentComponent = getContextForSubtree(parentComponent);
      null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
      isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = true, console.error(
        "Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.",
        getComponentNameFromFiber(current) || "Unknown"
      ));
      container = createUpdate(lane);
      container.payload = { element };
      callback = void 0 === callback ? null : callback;
      null !== callback && ("function" !== typeof callback && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        callback
      ), container.callback = callback);
      element = enqueueUpdate(rootFiber, container, lane);
      null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
      fiber = fiber.memoizedState;
      if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
      }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
      markRetryLaneImpl(fiber, retryLane);
      (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
      if (13 === fiber.tag) {
        var root2 = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root2 && scheduleUpdateOnFiber(root2, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
      }
    }
    function getCurrentFiberForDevTools() {
      return current;
    }
    function getLaneLabelMap() {
      for (var map = /* @__PURE__ */ new Map(), lane = 1, index2 = 0; 31 > index2; index2++) {
        var label = getLabelForLane(lane);
        map.set(lane, label);
        lane *= 2;
      }
      return map;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn)
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          ), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ))
          nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
          for (; null !== blockedOn; ) {
            var fiber = getInstanceFromNode(blockedOn);
            if (null !== fiber)
              switch (fiber.tag) {
                case 3:
                  fiber = fiber.stateNode;
                  if (fiber.current.memoizedState.isDehydrated) {
                    var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                    if (0 !== lanes) {
                      var root2 = fiber;
                      root2.pendingLanes |= 2;
                      for (root2.entangledLanes |= 2; lanes; ) {
                        var lane = 1 << 31 - clz32(lanes);
                        root2.entanglements[1] |= lane;
                        lanes &= ~lane;
                      }
                      ensureRootIsScheduled(fiber);
                      (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0));
                    }
                  }
                  break;
                case 13:
                  root2 = enqueueConcurrentRenderForLane(fiber, 2), null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
              }
            fiber = findInstanceBlockingEvent(nativeEvent);
            null === fiber && dispatchEventForPluginEventSystem(
              domEventName,
              eventSystemFlags,
              nativeEvent,
              return_targetInst,
              targetContainer
            );
            if (fiber === blockedOn) break;
            blockedOn = fiber;
          }
          null !== blockedOn && nativeEvent.stopPropagation();
        } else
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            null,
            targetContainer
          );
      }
    }
    function findInstanceBlockingEvent(nativeEvent) {
      nativeEvent = getEventTarget(nativeEvent);
      return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
      return_targetInst = null;
      targetNode = getClosestInstanceFromNode(targetNode);
      if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
          var tag = nearestMounted.tag;
          if (13 === tag) {
            targetNode = getSuspenseInstanceFromFiber(nearestMounted);
            if (null !== targetNode) return targetNode;
            targetNode = null;
          } else if (3 === tag) {
            if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
              return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            targetNode = null;
          } else nearestMounted !== targetNode && (targetNode = null);
        }
      }
      return_targetInst = targetNode;
      return null;
    }
    function getEventPriority(domEventName) {
      switch (domEventName) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return DiscreteEventPriority;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ContinuousEventPriority;
        case "message":
          switch (getCurrentPriorityLevel()) {
            case ImmediatePriority:
              return DiscreteEventPriority;
            case UserBlockingPriority:
              return ContinuousEventPriority;
            case NormalPriority$1:
            case LowPriority:
              return DefaultEventPriority;
            case IdlePriority:
              return IdleEventPriority;
            default:
              return DefaultEventPriority;
          }
        default:
          return DefaultEventPriority;
      }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
      switch (domEventName) {
        case "focusin":
        case "focusout":
          queuedFocus = null;
          break;
        case "dragenter":
        case "dragleave":
          queuedDrag = null;
          break;
        case "mouseover":
        case "mouseout":
          queuedMouse = null;
          break;
        case "pointerover":
        case "pointerout":
          queuedPointers.delete(nativeEvent.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          queuedPointerCaptures.delete(nativeEvent.pointerId);
      }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
        return existingQueuedEvent = {
          blockedOn,
          domEventName,
          eventSystemFlags,
          nativeEvent,
          targetContainers: [targetContainer]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
      existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
      blockedOn = existingQueuedEvent.targetContainers;
      null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
      return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      switch (domEventName) {
        case "focusin":
          return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedFocus,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "dragenter":
          return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedDrag,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "mouseover":
          return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedMouse,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "pointerover":
          var pointerId = nativeEvent.pointerId;
          queuedPointers.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointers.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          );
          return true;
        case "gotpointercapture":
          return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointerCaptures.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          ), true;
      }
      return false;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
      var targetInst = getClosestInstanceFromNode(queuedTarget.target);
      if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
          if (targetInst = nearestMounted.tag, 13 === targetInst) {
            if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
              queuedTarget.blockedOn = targetInst;
              runWithPriority(queuedTarget.priority, function() {
                if (13 === nearestMounted.tag) {
                  var lane = requestUpdateLane(nearestMounted);
                  lane = getBumpedLaneForHydrationByLane(lane);
                  var root2 = enqueueConcurrentRenderForLane(
                    nearestMounted,
                    lane
                  );
                  null !== root2 && scheduleUpdateOnFiber(root2, nearestMounted, lane);
                  markRetryLaneIfNotHydrated(nearestMounted, lane);
                }
              });
              return;
            }
          } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
            queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            return;
          }
        }
      }
      queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
      if (null !== queuedEvent.blockedOn) return false;
      for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
          nextBlockedOn = queuedEvent.nativeEvent;
          var nativeEventClone = new nextBlockedOn.constructor(
            nextBlockedOn.type,
            nextBlockedOn
          ), event = nativeEventClone;
          null !== currentReplayingEvent && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = event;
          nextBlockedOn.target.dispatchEvent(nativeEventClone);
          null === currentReplayingEvent && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = null;
        } else
          return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
        targetContainers.shift();
      }
      return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
      attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
      hasScheduledReplayAttempt = false;
      null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
      null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
      null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
      queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
      queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
      queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler.unstable_scheduleCallback(
        Scheduler.unstable_NormalPriority,
        replayUnblockedEvents
      )));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
      lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(
        Scheduler.unstable_NormalPriority,
        function() {
          lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
          for (var i = 0; i < formReplayingQueue.length; i += 3) {
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction)
              if (null === findInstanceBlockingTarget(submitterOrAction || form))
                continue;
              else break;
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            }, Object.freeze(form), startHostTransition(
              formInst,
              form,
              submitterOrAction,
              formData
            ));
          }
        }
      ));
    }
    function retryIfBlockedOn(unblocked) {
      function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
      }
      null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
      null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
      null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
      queuedPointers.forEach(unblock);
      queuedPointerCaptures.forEach(unblock);
      for (var i = 0; i < queuedExplicitHydrationTargets.length; i++) {
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
      }
      for (; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn); )
        attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
      i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
      if (null != i)
        for (queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3) {
          var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
          if ("function" === typeof submitterOrAction)
            formProps || scheduleReplayQueueIfNeeded(i);
          else if (formProps) {
            var action3 = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
              if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
                action3 = formProps.formAction;
              else {
                if (null !== findInstanceBlockingTarget(form)) continue;
              }
            else action3 = formProps.action;
            "function" === typeof action3 ? i[queuedTarget + 1] = action3 : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
          }
        }
    }
    function ReactDOMRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
      container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = requireScheduler(), React2 = React__default, ReactDOM$1 = ReactDOM, assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE2 = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM$1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
      pending: false,
      data: null,
      method: null,
      action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, injectedProfilingHooks = null, hasLoggedError = false, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log2 = Math.log, LN2 = Math.LN2, nextTransitionLane = 256, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
      button: true,
      checkbox: true,
      image: true,
      hidden: true,
      radio: true,
      reset: true,
      submit: true
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = true;
    var prefix2, suffix, reentry = false;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = false, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = false, didWarnCheckedDefaultChecked = false, didWarnSelectedSetOnOption = false, didWarnInvalidChild = false, didWarnInvalidInnerHTML = false;
    var didWarnValueDefaultValue = false;
    var valuePropNames = ["value", "defaultValue"], didWarnValDefaultVal = false, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), buttonScopeTags = inScopeTags.concat(["button"]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: false
    }, didWarn = {}, shorthandToLonghand = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = false, warnedForInfinityValue = false, unitlessNumbers = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases2 = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), possibleStandardNames = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ariaProperties = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel$1 = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), didWarnValueNull = false, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = false, canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
    if (canUseDOM2)
      try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
          get: function() {
            passiveBrowserEventsSupported = true;
          }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
      } catch (e) {
        passiveBrowserEventsSupported = false;
      }
    var root = null, startText = null, fallbackText = null, EventInterface = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(event) {
        return event.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: getEventModifierState,
      button: 0,
      buttons: 0,
      relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
      },
      movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
      },
      movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
      }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
      clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
      }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(
      CompositionEventInterface
    ), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, translateToKey = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, modifierKeyToProp = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, KeyboardEventInterface = assign2({}, UIEventInterface, {
      key: function(nativeEvent) {
        if (nativeEvent.key) {
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: getEventModifierState,
      charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
      },
      keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      },
      which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
      deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
      },
      deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
      newState: 0,
      oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
    canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = false, isComposing = false, supportedInputTypes = {
      color: true,
      date: true,
      datetime: true,
      "datetime-local": true,
      email: true,
      month: true,
      number: true,
      password: true,
      range: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = false;
    canUseDOM2 && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is2, skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false, vendorPrefixes2 = {
      animationend: makePrefixMap2("Animation", "AnimationEnd"),
      animationiteration: makePrefixMap2("Animation", "AnimationIteration"),
      animationstart: makePrefixMap2("Animation", "AnimationStart"),
      transitionrun: makePrefixMap2("Transition", "TransitionRun"),
      transitionstart: makePrefixMap2("Transition", "TransitionStart"),
      transitioncancel: makePrefixMap2("Transition", "TransitionCancel"),
      transitionend: makePrefixMap2("Transition", "TransitionEnd")
    }, prefixedEventNames2 = {}, style2 = {};
    canUseDOM2 && (style2 = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes2.animationend.animation, delete vendorPrefixes2.animationiteration.animation, delete vendorPrefixes2.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes2.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName2("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName2("animationiteration"), ANIMATION_START = getVendorPrefixedEventName2("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName2("transitionrun"), TRANSITION_START = getVendorPrefixedEventName2("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName2("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName2("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    simpleEventPluginEvents.push("scrollEnd");
    var CapturedStacks = /* @__PURE__ */ new WeakMap(), OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, NoStrictPassiveEffectsMode = 64;
    var hasBadMapPolyfill = false;
    try {
      var nonExtensibleObject = Object.preventExtensions({});
      /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
      /* @__PURE__ */ new Set([nonExtensibleObject]);
    } catch (e$3) {
      hasBadMapPolyfill = true;
    }
    var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      var getCurrentTime = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date;
      getCurrentTime = function() {
        return localDate.now();
      };
    }
    var valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = false, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
      var listeners = [], signal = this.signal = {
        aborted: false,
        addEventListener: function(type4, listener) {
          listeners.push(listener);
        }
      };
      this.abort = function() {
        signal.aborted = true;
        listeners.forEach(function(listener) {
          return listener();
        });
      };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, now = Scheduler.unstable_now, renderStartTime = -0, commitStartTime = -0, profilerStartTime = -1.1, profilerEffectDuration = -0, currentUpdateIsNested = false, nestedUpdateScheduled = false, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
      "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
      null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
      didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && true !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && true !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && true !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
      var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
        componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillMountWarnings = []);
      var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
        UNSAFE_componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillMountWarnings = []);
      var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
        componentWillReceivePropsUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillReceivePropsWarnings = []);
      var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(
        function(fiber) {
          UNSAFE_componentWillReceivePropsUniqueNames.add(
            getComponentNameFromFiber(fiber) || "Component"
          );
          didWarnAboutUnsafeLifecycles.add(fiber.type);
        }
      ), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
      var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
        componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillUpdateWarnings = []);
      var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
      if (0 < UNSAFE_componentWillMountUniqueNames.size) {
        var sortedNames = setToSortedString(
          UNSAFE_componentWillMountUniqueNames
        );
        console.error(
          "Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s",
          sortedNames
        );
      }
      0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillReceivePropsUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillUpdateUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn(
        "componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        componentWillReceivePropsUniqueNames
      ), console.warn(
        "componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn(
        "componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
    };
    var pendingLegacyContextWarning = /* @__PURE__ */ new Map(), didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
      var strictRoot = null;
      for (var node2 = fiber; null !== node2; )
        node2.mode & StrictLegacyMode && (strictRoot = node2), node2 = node2.return;
      null === strictRoot ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !didWarnAboutLegacyContext.has(fiber.type) && (node2 = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node2 && (node2 = [], pendingLegacyContextWarning.set(strictRoot, node2)), node2.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
      pendingLegacyContextWarning.forEach(function(fiberArray) {
        if (0 !== fiberArray.length) {
          var firstFiber = fiberArray[0], uniqueNames = /* @__PURE__ */ new Set();
          fiberArray.forEach(function(fiber) {
            uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutLegacyContext.add(fiber.type);
          });
          var sortedNames = setToSortedString(uniqueNames);
          runWithFiberInDEV(firstFiber, function() {
            console.error(
              "Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context",
              sortedNames
            );
          });
        }
      });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
      pendingComponentWillMountWarnings = [];
      pendingUNSAFE_ComponentWillMountWarnings = [];
      pendingComponentWillReceivePropsWarnings = [];
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
      pendingComponentWillUpdateWarnings = [];
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
      pendingLegacyContextWarning = /* @__PURE__ */ new Map();
    };
    var SuspenseException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), SuspenseyCommitException = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), SuspenseActionException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), noopSuspenseyCommitThenable = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = false, NoFlags = 0, HasEffect = 1, Insertion3 = 2, Layout = 4, Passive = 8, UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = false;
    var didWarnUpdateInsideUpdate = false;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = false, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseWrappedInTryCatch = /* @__PURE__ */ new Set();
    var didWarnAboutAsyncClientComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseFormState = /* @__PURE__ */ new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = false, ContextOnlyDispatcher = {
      readContext,
      use,
      useCallback: throwInvalidHookError,
      useContext: throwInvalidHookError,
      useEffect: throwInvalidHookError,
      useImperativeHandle: throwInvalidHookError,
      useLayoutEffect: throwInvalidHookError,
      useInsertionEffect: throwInvalidHookError,
      useMemo: throwInvalidHookError,
      useReducer: throwInvalidHookError,
      useRef: throwInvalidHookError,
      useState: throwInvalidHookError,
      useDebugValue: throwInvalidHookError,
      useDeferredValue: throwInvalidHookError,
      useTransition: throwInvalidHookError,
      useSyncExternalStore: throwInvalidHookError,
      useId: throwInvalidHookError,
      useHostTransitionStatus: throwInvalidHookError,
      useFormState: throwInvalidHookError,
      useActionState: throwInvalidHookError,
      useOptimistic: throwInvalidHookError,
      useMemoCache: throwInvalidHookError,
      useCacheRefresh: throwInvalidHookError
    }, HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
      readContext: function(context2) {
        return readContext(context2);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        mountHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(createDeps);
        return mountEffect(create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        mountEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountLayoutEffect(create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action3, initialState2) {
        currentHookNameInDev = "useFormState";
        mountHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action3, initialState2);
      },
      useActionState: function(action3, initialState2) {
        currentHookNameInDev = "useActionState";
        mountHookTypesDev();
        return mountActionState(action3, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
      readContext: function(context2) {
        return readContext(context2);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        return mountEffect(create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return mountImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        mountEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return mountLayoutEffect(create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return mountSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return mountId();
      },
      useActionState: function(action3, initialState2) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return mountActionState(action3, initialState2);
      },
      useFormState: function(action3, initialState2) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action3, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return mountRefresh();
      }
    };
    HooksDispatcherOnUpdateInDEV = {
      readContext: function(context2) {
        return readContext(context2);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action3) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return updateActionState(action3);
      },
      useActionState: function(action3) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return updateActionState(action3);
      },
      useOptimistic: function(passthrough, reducer2) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer2);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      }
    };
    HooksDispatcherOnRerenderInDEV = {
      readContext: function(context2) {
        return readContext(context2);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return updateMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action3) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return rerenderActionState(action3);
      },
      useActionState: function(action3) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return rerenderActionState(action3);
      },
      useOptimistic: function(passthrough, reducer2) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer2);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
      readContext: function(context2) {
        warnInvalidContextAccess();
        return readContext(context2);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountEffect(create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        mountEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountLayoutEffect(create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action3, initialState2) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action3, initialState2);
      },
      useActionState: function(action3, initialState2) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action3, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
      readContext: function(context2) {
        warnInvalidContextAccess();
        return readContext(context2);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action3) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action3);
      },
      useActionState: function(action3) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action3);
      },
      useOptimistic: function(passthrough, reducer2) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer2);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
      readContext: function(context2) {
        warnInvalidContextAccess();
        return readContext(context2);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context2) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context2);
      },
      useEffect: function(create, createDeps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create, createDeps);
      },
      useImperativeHandle: function(ref2, create, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref2, create, deps);
      },
      useInsertionEffect: function(create, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion3, create, deps);
      },
      useLayoutEffect: function(create, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create, deps);
      },
      useMemo: function(create, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer2, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(reducer2, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action3) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action3);
      },
      useActionState: function(action3) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action3);
      },
      useOptimistic: function(passthrough, reducer2) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer2);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      }
    };
    var callComponent = {
      "react-stack-bottom-frame": function(Component2, props, secondArg) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return Component2(props, secondArg);
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callComponentInDEV = callComponent["react-stack-bottom-frame"].bind(callComponent), callRender = {
      "react-stack-bottom-frame": function(instance) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return instance.render();
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callRenderInDEV = callRender["react-stack-bottom-frame"].bind(callRender), callComponentDidMount = {
      "react-stack-bottom-frame": function(finishedWork, instance) {
        try {
          instance.componentDidMount();
        } catch (error2) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error2);
        }
      }
    }, callComponentDidMountInDEV = callComponentDidMount["react-stack-bottom-frame"].bind(callComponentDidMount), callComponentDidUpdate = {
      "react-stack-bottom-frame": function(finishedWork, instance, prevProps, prevState, snapshot) {
        try {
          instance.componentDidUpdate(prevProps, prevState, snapshot);
        } catch (error2) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error2);
        }
      }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate["react-stack-bottom-frame"].bind(callComponentDidUpdate), callComponentDidCatch = {
      "react-stack-bottom-frame": function(instance, errorInfo) {
        var stack = errorInfo.stack;
        instance.componentDidCatch(errorInfo.value, {
          componentStack: null !== stack ? stack : ""
        });
      }
    }, callComponentDidCatchInDEV = callComponentDidCatch["react-stack-bottom-frame"].bind(callComponentDidCatch), callComponentWillUnmount = {
      "react-stack-bottom-frame": function(current2, nearestMountedAncestor, instance) {
        try {
          instance.componentWillUnmount();
        } catch (error2) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error2);
        }
      }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount["react-stack-bottom-frame"].bind(callComponentWillUnmount), callCreate = {
      "react-stack-bottom-frame": function(effect) {
        null != effect.resourceKind && console.error(
          "Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s",
          effect.resourceKind
        );
        var create = effect.create;
        effect = effect.inst;
        create = create();
        return effect.destroy = create;
      }
    }, callCreateInDEV = callCreate["react-stack-bottom-frame"].bind(callCreate), callDestroy = {
      "react-stack-bottom-frame": function(current2, nearestMountedAncestor, destroy) {
        try {
          destroy();
        } catch (error2) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error2);
        }
      }
    }, callDestroyInDEV = callDestroy["react-stack-bottom-frame"].bind(callDestroy), callLazyInit = {
      "react-stack-bottom-frame": function(lazy) {
        var init2 = lazy._init;
        return init2(lazy._payload);
      }
    }, callLazyInitInDEV = callLazyInit["react-stack-bottom-frame"].bind(callLazyInit), thenableState = null, thenableIndexCounter = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = false;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress2, child) {
      if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
        if ("object" !== typeof child._store)
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        child._store.validated = 1;
        var componentName2 = getComponentNameFromFiber(returnFiber), componentKey = componentName2 || "null";
        if (!ownerHasKeyUseWarning[componentKey]) {
          ownerHasKeyUseWarning[componentKey] = true;
          child = child._owner;
          returnFiber = returnFiber._debugOwner;
          var currentComponentErrorInfo = "";
          returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
          currentComponentErrorInfo || componentName2 && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName2 + ">.");
          var childOwnerAppendix = "";
          null != child && returnFiber !== child && (componentName2 = null, "number" === typeof child.tag ? componentName2 = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName2 = child.name), componentName2 && (childOwnerAppendix = " It was passed a child from " + componentName2 + "."));
          runWithFiberInDEV(workInProgress2, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              currentComponentErrorInfo,
              childOwnerAppendix
            );
          });
        }
      }
    };
    var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
    var didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutContextTypes$1 = /* @__PURE__ */ new Set();
    var didWarnAboutChildContextTypes = /* @__PURE__ */ new Set();
    var didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
    var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
      enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update2 = createUpdate(lane);
        update2.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update2.callback = callback);
        payload = enqueueUpdate(inst, update2, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        markStateUpdateScheduled(inst, lane);
      },
      enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update2 = createUpdate(lane);
        update2.tag = ReplaceState;
        update2.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update2.callback = callback);
        payload = enqueueUpdate(inst, update2, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        markStateUpdateScheduled(inst, lane);
      },
      enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update2 = createUpdate(lane);
        update2.tag = ForceUpdate;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update2.callback = callback);
        callback = enqueueUpdate(inst, update2, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        null !== injectedProfilingHooks && "function" === typeof injectedProfilingHooks.markForceUpdateScheduled && injectedProfilingHooks.markForceUpdateScheduled(inst, lane);
      }
    }, reportGlobalError = "function" === typeof reportError ? reportError : function(error2) {
      if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
          bubbles: true,
          cancelable: true,
          message: "object" === typeof error2 && null !== error2 && "string" === typeof error2.message ? String(error2.message) : String(error2),
          error: error2
        });
        if (!window.dispatchEvent(event)) return;
      } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error2);
        return;
      }
      console.error(error2);
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), didReceiveUpdate = false;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = false;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = false, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
    var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = false, currentHoistableRoot = null, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
      getCacheForType: function(resourceType) {
        var cache2 = readContext(CacheContext), cacheForType = cache2.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache2.data.set(resourceType, cacheForType));
        return cacheForType;
      },
      getOwner: function() {
        return current;
      }
    };
    if ("function" === typeof Symbol && Symbol.for) {
      var symbolFor = Symbol.for;
      symbolFor("selector.component");
      symbolFor("selector.has_pseudo_class");
      symbolFor("selector.role");
      symbolFor("selector.test_id");
      symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, SUSPENDED_COMMIT = 1, THROTTLED_COMMIT = 2, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = false, didScheduleUpdateDuringPassiveEffects = false, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = false, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, didScheduleMicrotask_act = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
      for (var i = 0; i < simpleEventPluginEvents.length; i++) {
        var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
        eventName = eventName[0].toUpperCase() + eventName.slice(1);
        registerSimpleEvent(domEventName, "on" + eventName);
      }
      registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
      registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
      registerSimpleEvent(ANIMATION_START, "onAnimationStart");
      registerSimpleEvent("dblclick", "onDoubleClick");
      registerSimpleEvent("focusin", "onFocus");
      registerSimpleEvent("focusout", "onBlur");
      registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
      registerSimpleEvent(TRANSITION_START, "onTransitionStart");
      registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
      registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
    registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
    registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
    registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
    registerTwoPhaseEvent(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]);
    registerTwoPhaseEvent(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), nonDelegatedEvents = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
    ), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = false, didWarnUncontrolledToControlled = false, didWarnFormActionType = false, didWarnFormActionName = false, didWarnFormActionTarget = false, didWarnFormActionMethod = false, didWarnPopoverTargetObject = false;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = 1, PREAMBLE_CONTRIBUTION_BODY = 2, PREAMBLE_CONTRIBUTION_HEAD = 4, FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_COMPLETE = "complete", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = { dialog: true, webview: true }, currentPopstateTransitionEvent = null, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
      return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
      f: function() {
        var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
        return previousWasRendering || wasRendering;
      },
      r: function(form) {
        var formInst = getInstanceFromNode(form);
        null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
      },
      D: function(href) {
        previousDispatcher.D(href);
        preconnectAs("dns-prefetch", href, null);
      },
      C: function(href, crossOrigin) {
        previousDispatcher.C(href, crossOrigin);
        preconnectAs("preconnect", href, crossOrigin);
      },
      L: function(href, as, options) {
        previousDispatcher.L(href, as, options);
        var ownerDocument = globalDocument;
        if (ownerDocument && href && as) {
          var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
          "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options.imageSrcSet
          ) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options.imageSizes
          ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
          var key = preloadSelector;
          switch (as) {
            case "style":
              key = getStyleKey(href);
              break;
            case "script":
              key = getScriptKey(href);
          }
          preloadPropsMap.has(key) || (href = assign2(
            {
              rel: "preload",
              href: "image" === as && options && options.imageSrcSet ? void 0 : href,
              as
            },
            options
          ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(
            getStylesheetSelectorFromKey(key)
          ) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
        }
      },
      m: function(href, options) {
        previousDispatcher.m(href, options);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
          switch (as) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              key = getScriptKey(href);
          }
          if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch (as) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
                  return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
          }
        }
      },
      X: function(src, options) {
        previousDispatcher.X(src, options);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      },
      S: function(href, precedence, options) {
        previousDispatcher.S(href, precedence, options);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var styles2 = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
          precedence = precedence || "default";
          var resource = styles2.get(key);
          if (!resource) {
            var state = { loading: NotLoaded, preload: null };
            if (resource = ownerDocument.querySelector(
              getStylesheetSelectorFromKey(key)
            ))
              state.loading = Loaded | Inserted;
            else {
              href = assign2(
                {
                  rel: "stylesheet",
                  href,
                  "data-precedence": precedence
                },
                options
              );
              (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
              var link = resource = ownerDocument.createElement("link");
              markNodeAsHoistable(link);
              setInitialProperties(link, "link", href);
              link._p = new Promise(function(resolve, reject) {
                link.onload = resolve;
                link.onerror = reject;
              });
              link.addEventListener("load", function() {
                state.loading |= Loaded;
              });
              link.addEventListener("error", function() {
                state.loading |= Errored;
              });
              state.loading |= Inserted;
              insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
              type: "stylesheet",
              instance: resource,
              count: 1,
              state
            };
            styles2.set(key, resource);
          }
        }
      },
      M: function(src, options) {
        previousDispatcher.M(src, options);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true, type: "module" }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, suspendedState = null, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Provider: null,
      Consumer: null,
      _currentValue: NotPendingTransition,
      _currentValue2: NotPendingTransition,
      _threadCount: 0
    }, badgeFormat = "%c%s%c ", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind2 = Function.prototype.bind;
    var didWarnAboutNestedUpdates = false;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id2, path2, value) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path2 = copyWithSetImpl(id2.memoizedState, path2, 0, value), id2.memoizedState = path2, id2.baseState = path2, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path2 = enqueueConcurrentRenderForLane(fiber, 2), null !== path2 && scheduleUpdateOnFiber(path2, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id2, path2) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path2 = copyWithDeleteImpl(id2.memoizedState, path2, 0), id2.memoizedState = path2, id2.baseState = path2, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path2 = enqueueConcurrentRenderForLane(fiber, 2), null !== path2 && scheduleUpdateOnFiber(path2, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id2, oldPath, newPath) {
      id2 = findHook(fiber, id2);
      null !== id2 && (oldPath = copyWithRename(id2.memoizedState, oldPath, newPath), id2.memoizedState = oldPath, id2.baseState = oldPath, fiber.memoizedProps = assign2({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path2, value) {
      fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path2, 0, value);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path2 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path2 && scheduleUpdateOnFiber(path2, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path2) {
      fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path2, 0);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path2 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path2 && scheduleUpdateOnFiber(path2, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
      fiber.pendingProps = copyWithRename(
        fiber.memoizedProps,
        oldPath,
        newPath
      );
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      oldPath = enqueueConcurrentRenderForLane(fiber, 2);
      null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
      var root2 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2);
    };
    setErrorHandler = function(newShouldErrorImpl) {
      shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
      shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = true, return_targetInst = null, hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children2) {
      var root2 = this._internalRoot;
      if (null === root2) throw Error("Cannot update an unmounted root.");
      var args = arguments;
      "function" === typeof args[1] ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : isValidContainer(args[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : "undefined" !== typeof args[1] && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      );
      args = children2;
      var current2 = root2.current, lane = requestUpdateLane(current2);
      updateContainerImpl(current2, lane, args, root2, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
      var args = arguments;
      "function" === typeof args[0] && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      );
      args = this._internalRoot;
      if (null !== args) {
        this._internalRoot = null;
        var container = args.containerInfo;
        (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        );
        updateContainerImpl(args.current, 2, null, args, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
      }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
      if (target) {
        var updatePriority = resolveUpdatePriority();
        target = { blockedOn: null, target, priority: updatePriority };
        for (var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++) ;
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
      }
    };
    (function() {
      var isomorphicReactPackageVersion = React2.version;
      if ("19.1.0" !== isomorphicReactPackageVersion)
        throw Error(
          'Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.1.0\nLearn more: https://react.dev/warnings/version-mismatch")
        );
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    );
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
      var fiber = componentOrElement._reactInternals;
      if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render)
          throw Error("Unable to find node on an unmounted component.");
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(
          "Argument appears to not be a ReactComponent. Keys: " + componentOrElement
        );
      }
      componentOrElement = findCurrentFiberUsingSlowPath(fiber);
      componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
      componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
      return componentOrElement;
    };
    if (!(function() {
      var internals = {
        bundleType: 1,
        version: "19.1.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: ReactSharedInternals,
        reconcilerVersion: "19.1.0"
      };
      internals.overrideHookState = overrideHookState;
      internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
      internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
      internals.overrideProps = overrideProps;
      internals.overridePropsDeletePath = overridePropsDeletePath;
      internals.overridePropsRenamePath = overridePropsRenamePath;
      internals.scheduleUpdate = scheduleUpdate;
      internals.setErrorHandler = setErrorHandler;
      internals.setSuspenseHandler = setSuspenseHandler;
      internals.scheduleRefresh = scheduleRefresh;
      internals.scheduleRoot = scheduleRoot;
      internals.setRefreshHandler = setRefreshHandler;
      internals.getCurrentFiber = getCurrentFiberForDevTools;
      internals.getLaneLabelMap = getLaneLabelMap;
      internals.injectProfilingHooks = injectProfilingHooks;
      return injectInternals(internals);
    })() && canUseDOM2 && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var protocol2 = window.location.protocol;
      /^(https?|file):$/.test(protocol2) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol2 ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""),
        "font-weight:bold"
      );
    }
    reactDomClient_development.createRoot = function(container, options) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
      null !== options && void 0 !== options && (options.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error(
        "You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"
      ), true === options.unstable_strictMode && (isStrictMode = true), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
      options = createFiberRoot(
        container,
        1,
        false,
        null,
        null,
        isStrictMode,
        identifierPrefix,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        transitionCallbacks,
        null
      );
      container[internalContainerInstanceKey] = options.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMRoot(options);
    };
    reactDomClient_development.hydrateRoot = function(container, initialChildren, options) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      void 0 === initialChildren && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
      null !== options && void 0 !== options && (true === options.unstable_strictMode && (isStrictMode = true), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
      initialChildren = createFiberRoot(
        container,
        1,
        true,
        initialChildren,
        null != options ? options : null,
        isStrictMode,
        identifierPrefix,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        transitionCallbacks,
        formState
      );
      initialChildren.context = getContextForSubtree(null);
      options = initialChildren.current;
      isStrictMode = requestUpdateLane(options);
      isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
      identifierPrefix = createUpdate(isStrictMode);
      identifierPrefix.callback = null;
      enqueueUpdate(options, identifierPrefix, isStrictMode);
      options = isStrictMode;
      initialChildren.current.lanes = options;
      markRootUpdated$1(initialChildren, options);
      ensureRootIsScheduled(initialChildren);
      container[internalContainerInstanceKey] = initialChildren.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMHydrationRoot(initialChildren);
    };
    reactDomClient_development.version = "19.1.0";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return reactDomClient_development;
}
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client.exports;
  hasRequiredClient = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      throw new Error("^_^");
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  if (process.env.NODE_ENV === "production") {
    checkDCE();
    client.exports = requireReactDomClient_production();
  } else {
    client.exports = requireReactDomClient_development();
  }
  return client.exports;
}
var clientExports = requireClient();
unstableSetRender(function(node2, container) {
  container._reactRoot || (container._reactRoot = clientExports.createRoot(container));
  var root = container._reactRoot;
  root.render(node2);
  return function() {
    return new Promise(function(resolve) {
      setTimeout(function() {
        root.unmount();
        resolve();
      }, 0);
    });
  };
});
configure({ enforceActions: "observed", isolateGlobalState: true });
export {
  Chat_default as EZChat,
  ChatController as EZChatControllerNew,
  ChatProvider_default as EZChatProvider
};
//# sourceMappingURL=index.js.map
